
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("1b2ls", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $0db8a335f84591c1$export$ffb0004e005737fa, (v) => $0db8a335f84591c1$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $0db8a335f84591c1$export$34b9dba7ce09269b, (v) => $0db8a335f84591c1$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $0db8a335f84591c1$export$25062201e9e25d76, (v) => $0db8a335f84591c1$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $0db8a335f84591c1$export$ffb0004e005737fa;
var $0db8a335f84591c1$export$34b9dba7ce09269b;
var $0db8a335f84591c1$export$25062201e9e25d76;
'use strict';

var $acw62 = parcelRequire("acw62");
var $0db8a335f84591c1$var$k = Symbol.for("react.element"), $0db8a335f84591c1$var$l = Symbol.for("react.fragment"), $0db8a335f84591c1$var$m = Object.prototype.hasOwnProperty, $0db8a335f84591c1$var$n = $acw62.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $0db8a335f84591c1$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $0db8a335f84591c1$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$0db8a335f84591c1$var$m.call(a, b) && !$0db8a335f84591c1$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $0db8a335f84591c1$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $0db8a335f84591c1$var$n.current
    };
}
$0db8a335f84591c1$export$ffb0004e005737fa = $0db8a335f84591c1$var$l;
$0db8a335f84591c1$export$34b9dba7ce09269b = $0db8a335f84591c1$var$q;
$0db8a335f84591c1$export$25062201e9e25d76 = $0db8a335f84591c1$var$q;

});
parcelRegister("acw62", function(module, exports) {
'use strict';

module.exports = (parcelRequire("2pUnB"));

});
parcelRegister("2pUnB", function(module, exports) {

$parcel$export(module.exports, "Children", () => $1c29a66706a62afd$export$dca3b0875bd9a954, (v) => $1c29a66706a62afd$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $1c29a66706a62afd$export$16fa2f45be04daa8, (v) => $1c29a66706a62afd$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $1c29a66706a62afd$export$ffb0004e005737fa, (v) => $1c29a66706a62afd$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $1c29a66706a62afd$export$e2c29f18771995cb, (v) => $1c29a66706a62afd$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $1c29a66706a62afd$export$221d75b3f55bb0bd, (v) => $1c29a66706a62afd$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $1c29a66706a62afd$export$5f8d39834fd61797, (v) => $1c29a66706a62afd$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $1c29a66706a62afd$export$74bf444e3cd11ea5, (v) => $1c29a66706a62afd$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $1c29a66706a62afd$export$ae55be85d98224ed, (v) => $1c29a66706a62afd$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "act", () => $1c29a66706a62afd$export$3ba232387fd5d6dd, (v) => $1c29a66706a62afd$export$3ba232387fd5d6dd = v);
$parcel$export(module.exports, "cloneElement", () => $1c29a66706a62afd$export$e530037191fcd5d7, (v) => $1c29a66706a62afd$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $1c29a66706a62afd$export$fd42f52fd3ae1109, (v) => $1c29a66706a62afd$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $1c29a66706a62afd$export$c8a8987d4410bf2d, (v) => $1c29a66706a62afd$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createFactory", () => $1c29a66706a62afd$export$d38cd72104c1f0e9, (v) => $1c29a66706a62afd$export$d38cd72104c1f0e9 = v);
$parcel$export(module.exports, "createRef", () => $1c29a66706a62afd$export$7d1e3a5e95ceca43, (v) => $1c29a66706a62afd$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $1c29a66706a62afd$export$257a8862b851cb5b, (v) => $1c29a66706a62afd$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $1c29a66706a62afd$export$a8257692ac88316c, (v) => $1c29a66706a62afd$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $1c29a66706a62afd$export$488013bae63b21da, (v) => $1c29a66706a62afd$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $1c29a66706a62afd$export$7c73462e0d25e514, (v) => $1c29a66706a62afd$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $1c29a66706a62afd$export$7568632d0d33d16d, (v) => $1c29a66706a62afd$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_act", () => $1c29a66706a62afd$export$88948ce120ea2619, (v) => $1c29a66706a62afd$export$88948ce120ea2619 = v);
$parcel$export(module.exports, "useCallback", () => $1c29a66706a62afd$export$35808ee640e87ca7, (v) => $1c29a66706a62afd$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $1c29a66706a62afd$export$fae74005e78b1a27, (v) => $1c29a66706a62afd$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $1c29a66706a62afd$export$dc8fbce3eb94dc1e, (v) => $1c29a66706a62afd$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $1c29a66706a62afd$export$6a7bc4e911dc01cf, (v) => $1c29a66706a62afd$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $1c29a66706a62afd$export$6d9c69b0de29b591, (v) => $1c29a66706a62afd$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useId", () => $1c29a66706a62afd$export$f680877a34711e37, (v) => $1c29a66706a62afd$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $1c29a66706a62afd$export$d5a552a76deda3c2, (v) => $1c29a66706a62afd$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $1c29a66706a62afd$export$aaabe4eda9ed9969, (v) => $1c29a66706a62afd$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $1c29a66706a62afd$export$e5c5a5f917a5871c, (v) => $1c29a66706a62afd$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $1c29a66706a62afd$export$1538c33de8887b59, (v) => $1c29a66706a62afd$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useReducer", () => $1c29a66706a62afd$export$13e3392192263954, (v) => $1c29a66706a62afd$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $1c29a66706a62afd$export$b8f5890fc79d6aca, (v) => $1c29a66706a62afd$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $1c29a66706a62afd$export$60241385465d0a34, (v) => $1c29a66706a62afd$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $1c29a66706a62afd$export$306c0aa65ff9ec16, (v) => $1c29a66706a62afd$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $1c29a66706a62afd$export$7b286972b8d8ccbf, (v) => $1c29a66706a62afd$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $1c29a66706a62afd$export$83d89fbfd8236492, (v) => $1c29a66706a62afd$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1c29a66706a62afd$export$dca3b0875bd9a954;
var $1c29a66706a62afd$export$16fa2f45be04daa8;
var $1c29a66706a62afd$export$ffb0004e005737fa;
var $1c29a66706a62afd$export$e2c29f18771995cb;
var $1c29a66706a62afd$export$221d75b3f55bb0bd;
var $1c29a66706a62afd$export$5f8d39834fd61797;
var $1c29a66706a62afd$export$74bf444e3cd11ea5;
var $1c29a66706a62afd$export$ae55be85d98224ed;
var $1c29a66706a62afd$export$3ba232387fd5d6dd;
var $1c29a66706a62afd$export$e530037191fcd5d7;
var $1c29a66706a62afd$export$fd42f52fd3ae1109;
var $1c29a66706a62afd$export$c8a8987d4410bf2d;
var $1c29a66706a62afd$export$d38cd72104c1f0e9;
var $1c29a66706a62afd$export$7d1e3a5e95ceca43;
var $1c29a66706a62afd$export$257a8862b851cb5b;
var $1c29a66706a62afd$export$a8257692ac88316c;
var $1c29a66706a62afd$export$488013bae63b21da;
var $1c29a66706a62afd$export$7c73462e0d25e514;
var $1c29a66706a62afd$export$7568632d0d33d16d;
var $1c29a66706a62afd$export$88948ce120ea2619;
var $1c29a66706a62afd$export$35808ee640e87ca7;
var $1c29a66706a62afd$export$fae74005e78b1a27;
var $1c29a66706a62afd$export$dc8fbce3eb94dc1e;
var $1c29a66706a62afd$export$6a7bc4e911dc01cf;
var $1c29a66706a62afd$export$6d9c69b0de29b591;
var $1c29a66706a62afd$export$f680877a34711e37;
var $1c29a66706a62afd$export$d5a552a76deda3c2;
var $1c29a66706a62afd$export$aaabe4eda9ed9969;
var $1c29a66706a62afd$export$e5c5a5f917a5871c;
var $1c29a66706a62afd$export$1538c33de8887b59;
var $1c29a66706a62afd$export$13e3392192263954;
var $1c29a66706a62afd$export$b8f5890fc79d6aca;
var $1c29a66706a62afd$export$60241385465d0a34;
var $1c29a66706a62afd$export$306c0aa65ff9ec16;
var $1c29a66706a62afd$export$7b286972b8d8ccbf;
var $1c29a66706a62afd$export$83d89fbfd8236492;
'use strict';
var $1c29a66706a62afd$var$l = Symbol.for("react.element"), $1c29a66706a62afd$var$n = Symbol.for("react.portal"), $1c29a66706a62afd$var$p = Symbol.for("react.fragment"), $1c29a66706a62afd$var$q = Symbol.for("react.strict_mode"), $1c29a66706a62afd$var$r = Symbol.for("react.profiler"), $1c29a66706a62afd$var$t = Symbol.for("react.provider"), $1c29a66706a62afd$var$u = Symbol.for("react.context"), $1c29a66706a62afd$var$v = Symbol.for("react.forward_ref"), $1c29a66706a62afd$var$w = Symbol.for("react.suspense"), $1c29a66706a62afd$var$x = Symbol.for("react.memo"), $1c29a66706a62afd$var$y = Symbol.for("react.lazy"), $1c29a66706a62afd$var$z = Symbol.iterator;
function $1c29a66706a62afd$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $1c29a66706a62afd$var$z && a[$1c29a66706a62afd$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $1c29a66706a62afd$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $1c29a66706a62afd$var$C = Object.assign, $1c29a66706a62afd$var$D = {};
function $1c29a66706a62afd$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $1c29a66706a62afd$var$D;
    this.updater = e || $1c29a66706a62afd$var$B;
}
$1c29a66706a62afd$var$E.prototype.isReactComponent = {};
$1c29a66706a62afd$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$1c29a66706a62afd$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $1c29a66706a62afd$var$F() {}
$1c29a66706a62afd$var$F.prototype = $1c29a66706a62afd$var$E.prototype;
function $1c29a66706a62afd$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $1c29a66706a62afd$var$D;
    this.updater = e || $1c29a66706a62afd$var$B;
}
var $1c29a66706a62afd$var$H = $1c29a66706a62afd$var$G.prototype = new $1c29a66706a62afd$var$F;
$1c29a66706a62afd$var$H.constructor = $1c29a66706a62afd$var$G;
$1c29a66706a62afd$var$C($1c29a66706a62afd$var$H, $1c29a66706a62afd$var$E.prototype);
$1c29a66706a62afd$var$H.isPureReactComponent = !0;
var $1c29a66706a62afd$var$I = Array.isArray, $1c29a66706a62afd$var$J = Object.prototype.hasOwnProperty, $1c29a66706a62afd$var$K = {
    current: null
}, $1c29a66706a62afd$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $1c29a66706a62afd$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$1c29a66706a62afd$var$J.call(b, d) && !$1c29a66706a62afd$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $1c29a66706a62afd$var$K.current
    };
}
function $1c29a66706a62afd$var$N(a, b) {
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $1c29a66706a62afd$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $1c29a66706a62afd$var$l;
}
function $1c29a66706a62afd$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $1c29a66706a62afd$var$P = /\/+/g;
function $1c29a66706a62afd$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $1c29a66706a62afd$var$escape("" + a.key) : b.toString(36);
}
function $1c29a66706a62afd$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $1c29a66706a62afd$var$l:
                case $1c29a66706a62afd$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $1c29a66706a62afd$var$Q(h, 0) : d, $1c29a66706a62afd$var$I(c) ? (e = "", null != a && (e = a.replace($1c29a66706a62afd$var$P, "$&/") + "/"), $1c29a66706a62afd$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($1c29a66706a62afd$var$O(c) && (c = $1c29a66706a62afd$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($1c29a66706a62afd$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($1c29a66706a62afd$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $1c29a66706a62afd$var$Q(k, g);
        h += $1c29a66706a62afd$var$R(k, b, e, f, c);
    }
    else if (f = $1c29a66706a62afd$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $1c29a66706a62afd$var$Q(k, g++), h += $1c29a66706a62afd$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $1c29a66706a62afd$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $1c29a66706a62afd$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $1c29a66706a62afd$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $1c29a66706a62afd$var$U = {
    current: null
}, $1c29a66706a62afd$var$V = {
    transition: null
}, $1c29a66706a62afd$var$W = {
    ReactCurrentDispatcher: $1c29a66706a62afd$var$U,
    ReactCurrentBatchConfig: $1c29a66706a62afd$var$V,
    ReactCurrentOwner: $1c29a66706a62afd$var$K
};
function $1c29a66706a62afd$var$X() {
    throw Error("act(...) is not supported in production builds of React.");
}
$1c29a66706a62afd$export$dca3b0875bd9a954 = {
    map: $1c29a66706a62afd$var$S,
    forEach: function(a, b, e) {
        $1c29a66706a62afd$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $1c29a66706a62afd$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $1c29a66706a62afd$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$1c29a66706a62afd$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$1c29a66706a62afd$export$16fa2f45be04daa8 = $1c29a66706a62afd$var$E;
$1c29a66706a62afd$export$ffb0004e005737fa = $1c29a66706a62afd$var$p;
$1c29a66706a62afd$export$e2c29f18771995cb = $1c29a66706a62afd$var$r;
$1c29a66706a62afd$export$221d75b3f55bb0bd = $1c29a66706a62afd$var$G;
$1c29a66706a62afd$export$5f8d39834fd61797 = $1c29a66706a62afd$var$q;
$1c29a66706a62afd$export$74bf444e3cd11ea5 = $1c29a66706a62afd$var$w;
$1c29a66706a62afd$export$ae55be85d98224ed = $1c29a66706a62afd$var$W;
$1c29a66706a62afd$export$3ba232387fd5d6dd = $1c29a66706a62afd$var$X;
$1c29a66706a62afd$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $1c29a66706a62afd$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $1c29a66706a62afd$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$1c29a66706a62afd$var$J.call(b, f) && !$1c29a66706a62afd$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$1c29a66706a62afd$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $1c29a66706a62afd$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $1c29a66706a62afd$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$1c29a66706a62afd$export$c8a8987d4410bf2d = $1c29a66706a62afd$var$M;
$1c29a66706a62afd$export$d38cd72104c1f0e9 = function(a) {
    var b = $1c29a66706a62afd$var$M.bind(null, a);
    b.type = a;
    return b;
};
$1c29a66706a62afd$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$1c29a66706a62afd$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $1c29a66706a62afd$var$v,
        render: a
    };
};
$1c29a66706a62afd$export$a8257692ac88316c = $1c29a66706a62afd$var$O;
$1c29a66706a62afd$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $1c29a66706a62afd$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $1c29a66706a62afd$var$T
    };
};
$1c29a66706a62afd$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $1c29a66706a62afd$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$1c29a66706a62afd$export$7568632d0d33d16d = function(a) {
    var b = $1c29a66706a62afd$var$V.transition;
    $1c29a66706a62afd$var$V.transition = {};
    try {
        a();
    } finally{
        $1c29a66706a62afd$var$V.transition = b;
    }
};
$1c29a66706a62afd$export$88948ce120ea2619 = $1c29a66706a62afd$var$X;
$1c29a66706a62afd$export$35808ee640e87ca7 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useCallback(a, b);
};
$1c29a66706a62afd$export$fae74005e78b1a27 = function(a) {
    return $1c29a66706a62afd$var$U.current.useContext(a);
};
$1c29a66706a62afd$export$dc8fbce3eb94dc1e = function() {};
$1c29a66706a62afd$export$6a7bc4e911dc01cf = function(a) {
    return $1c29a66706a62afd$var$U.current.useDeferredValue(a);
};
$1c29a66706a62afd$export$6d9c69b0de29b591 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useEffect(a, b);
};
$1c29a66706a62afd$export$f680877a34711e37 = function() {
    return $1c29a66706a62afd$var$U.current.useId();
};
$1c29a66706a62afd$export$d5a552a76deda3c2 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useImperativeHandle(a, b, e);
};
$1c29a66706a62afd$export$aaabe4eda9ed9969 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useInsertionEffect(a, b);
};
$1c29a66706a62afd$export$e5c5a5f917a5871c = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useLayoutEffect(a, b);
};
$1c29a66706a62afd$export$1538c33de8887b59 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useMemo(a, b);
};
$1c29a66706a62afd$export$13e3392192263954 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useReducer(a, b, e);
};
$1c29a66706a62afd$export$b8f5890fc79d6aca = function(a) {
    return $1c29a66706a62afd$var$U.current.useRef(a);
};
$1c29a66706a62afd$export$60241385465d0a34 = function(a) {
    return $1c29a66706a62afd$var$U.current.useState(a);
};
$1c29a66706a62afd$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useSyncExternalStore(a, b, e);
};
$1c29a66706a62afd$export$7b286972b8d8ccbf = function() {
    return $1c29a66706a62afd$var$U.current.useTransition();
};
$1c29a66706a62afd$export$83d89fbfd8236492 = "18.3.1";

});



parcelRegister("Xw6Mv", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $0b2e6adb871a3b94$export$ae55be85d98224ed, (v) => $0b2e6adb871a3b94$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "createPortal", () => $0b2e6adb871a3b94$export$d39a5bbd09211389, (v) => $0b2e6adb871a3b94$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "createRoot", () => $0b2e6adb871a3b94$export$882461b6382ed46c, (v) => $0b2e6adb871a3b94$export$882461b6382ed46c = v);
$parcel$export(module.exports, "findDOMNode", () => $0b2e6adb871a3b94$export$466bfc07425424d5, (v) => $0b2e6adb871a3b94$export$466bfc07425424d5 = v);
$parcel$export(module.exports, "flushSync", () => $0b2e6adb871a3b94$export$cd75ccfd720a3cd4, (v) => $0b2e6adb871a3b94$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "hydrate", () => $0b2e6adb871a3b94$export$fa8d919ba61d84db, (v) => $0b2e6adb871a3b94$export$fa8d919ba61d84db = v);
$parcel$export(module.exports, "hydrateRoot", () => $0b2e6adb871a3b94$export$757ceba2d55c277e, (v) => $0b2e6adb871a3b94$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "render", () => $0b2e6adb871a3b94$export$b3890eb0ae9dca99, (v) => $0b2e6adb871a3b94$export$b3890eb0ae9dca99 = v);
$parcel$export(module.exports, "unmountComponentAtNode", () => $0b2e6adb871a3b94$export$502457920280e6be, (v) => $0b2e6adb871a3b94$export$502457920280e6be = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $0b2e6adb871a3b94$export$c78a37762a8d58e1, (v) => $0b2e6adb871a3b94$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", () => $0b2e6adb871a3b94$export$dc54d992c10e8a18, (v) => $0b2e6adb871a3b94$export$dc54d992c10e8a18 = v);
$parcel$export(module.exports, "version", () => $0b2e6adb871a3b94$export$83d89fbfd8236492, (v) => $0b2e6adb871a3b94$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $0b2e6adb871a3b94$export$ae55be85d98224ed;
var $0b2e6adb871a3b94$export$d39a5bbd09211389;
var $0b2e6adb871a3b94$export$882461b6382ed46c;
var $0b2e6adb871a3b94$export$466bfc07425424d5;
var $0b2e6adb871a3b94$export$cd75ccfd720a3cd4;
var $0b2e6adb871a3b94$export$fa8d919ba61d84db;
var $0b2e6adb871a3b94$export$757ceba2d55c277e;
var $0b2e6adb871a3b94$export$b3890eb0ae9dca99;
var $0b2e6adb871a3b94$export$502457920280e6be;
var $0b2e6adb871a3b94$export$c78a37762a8d58e1;
var $0b2e6adb871a3b94$export$dc54d992c10e8a18;
var $0b2e6adb871a3b94$export$83d89fbfd8236492;
'use strict';

var $acw62 = parcelRequire("acw62");

var $fO90s = parcelRequire("fO90s");
function $0b2e6adb871a3b94$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $0b2e6adb871a3b94$var$da = new Set, $0b2e6adb871a3b94$var$ea = {};
function $0b2e6adb871a3b94$var$fa(a, b) {
    $0b2e6adb871a3b94$var$ha(a, b);
    $0b2e6adb871a3b94$var$ha(a + "Capture", b);
}
function $0b2e6adb871a3b94$var$ha(a, b) {
    $0b2e6adb871a3b94$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$0b2e6adb871a3b94$var$da.add(b[a]);
}
var $0b2e6adb871a3b94$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $0b2e6adb871a3b94$var$ja = Object.prototype.hasOwnProperty, $0b2e6adb871a3b94$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $0b2e6adb871a3b94$var$la = {}, $0b2e6adb871a3b94$var$ma = {};
function $0b2e6adb871a3b94$var$oa(a) {
    if ($0b2e6adb871a3b94$var$ja.call($0b2e6adb871a3b94$var$ma, a)) return !0;
    if ($0b2e6adb871a3b94$var$ja.call($0b2e6adb871a3b94$var$la, a)) return !1;
    if ($0b2e6adb871a3b94$var$ka.test(a)) return $0b2e6adb871a3b94$var$ma[a] = !0;
    $0b2e6adb871a3b94$var$la[a] = !0;
    return !1;
}
function $0b2e6adb871a3b94$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $0b2e6adb871a3b94$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $0b2e6adb871a3b94$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $0b2e6adb871a3b94$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $0b2e6adb871a3b94$var$ra = /[\-:]([a-z])/g;
function $0b2e6adb871a3b94$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$0b2e6adb871a3b94$var$z.xlinkHref = new $0b2e6adb871a3b94$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $0b2e6adb871a3b94$var$ta(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$z.hasOwnProperty(b) ? $0b2e6adb871a3b94$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $0b2e6adb871a3b94$var$qa(b, c, e, d) && (c = null), d || null === e ? $0b2e6adb871a3b94$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $0b2e6adb871a3b94$var$ua = $acw62.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $0b2e6adb871a3b94$var$va = Symbol.for("react.element"), $0b2e6adb871a3b94$var$wa = Symbol.for("react.portal"), $0b2e6adb871a3b94$var$ya = Symbol.for("react.fragment"), $0b2e6adb871a3b94$var$za = Symbol.for("react.strict_mode"), $0b2e6adb871a3b94$var$Aa = Symbol.for("react.profiler"), $0b2e6adb871a3b94$var$Ba = Symbol.for("react.provider"), $0b2e6adb871a3b94$var$Ca = Symbol.for("react.context"), $0b2e6adb871a3b94$var$Da = Symbol.for("react.forward_ref"), $0b2e6adb871a3b94$var$Ea = Symbol.for("react.suspense"), $0b2e6adb871a3b94$var$Fa = Symbol.for("react.suspense_list"), $0b2e6adb871a3b94$var$Ga = Symbol.for("react.memo"), $0b2e6adb871a3b94$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $0b2e6adb871a3b94$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $0b2e6adb871a3b94$var$Ja = Symbol.iterator;
function $0b2e6adb871a3b94$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $0b2e6adb871a3b94$var$Ja && a[$0b2e6adb871a3b94$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $0b2e6adb871a3b94$var$A = Object.assign, $0b2e6adb871a3b94$var$La;
function $0b2e6adb871a3b94$var$Ma(a) {
    if (void 0 === $0b2e6adb871a3b94$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $0b2e6adb871a3b94$var$La = b && b[1] || "";
    }
    return "\n" + $0b2e6adb871a3b94$var$La + a;
}
var $0b2e6adb871a3b94$var$Na = !1;
function $0b2e6adb871a3b94$var$Oa(a, b) {
    if (!a || $0b2e6adb871a3b94$var$Na) return "";
    $0b2e6adb871a3b94$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $0b2e6adb871a3b94$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $0b2e6adb871a3b94$var$Ma(a) : "";
}
function $0b2e6adb871a3b94$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $0b2e6adb871a3b94$var$Ma(a.type);
        case 16:
            return $0b2e6adb871a3b94$var$Ma("Lazy");
        case 13:
            return $0b2e6adb871a3b94$var$Ma("Suspense");
        case 19:
            return $0b2e6adb871a3b94$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $0b2e6adb871a3b94$var$Oa(a.type, !1), a;
        case 11:
            return a = $0b2e6adb871a3b94$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $0b2e6adb871a3b94$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $0b2e6adb871a3b94$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $0b2e6adb871a3b94$var$ya:
            return "Fragment";
        case $0b2e6adb871a3b94$var$wa:
            return "Portal";
        case $0b2e6adb871a3b94$var$Aa:
            return "Profiler";
        case $0b2e6adb871a3b94$var$za:
            return "StrictMode";
        case $0b2e6adb871a3b94$var$Ea:
            return "Suspense";
        case $0b2e6adb871a3b94$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $0b2e6adb871a3b94$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $0b2e6adb871a3b94$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $0b2e6adb871a3b94$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $0b2e6adb871a3b94$var$Ga:
            return b = a.displayName || null, null !== b ? b : $0b2e6adb871a3b94$var$Qa(a.type) || "Memo";
        case $0b2e6adb871a3b94$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $0b2e6adb871a3b94$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $0b2e6adb871a3b94$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $0b2e6adb871a3b94$var$Qa(b);
        case 8:
            return b === $0b2e6adb871a3b94$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $0b2e6adb871a3b94$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $0b2e6adb871a3b94$var$Ua(a) {
    var b = $0b2e6adb871a3b94$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $0b2e6adb871a3b94$var$Va(a) {
    a._valueTracker || (a._valueTracker = $0b2e6adb871a3b94$var$Ua(a));
}
function $0b2e6adb871a3b94$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $0b2e6adb871a3b94$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $0b2e6adb871a3b94$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $0b2e6adb871a3b94$var$Ya(a, b) {
    var c = b.checked;
    return $0b2e6adb871a3b94$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $0b2e6adb871a3b94$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $0b2e6adb871a3b94$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $0b2e6adb871a3b94$var$ab(a, b) {
    b = b.checked;
    null != b && $0b2e6adb871a3b94$var$ta(a, "checked", b, !1);
}
function $0b2e6adb871a3b94$var$bb(a, b) {
    $0b2e6adb871a3b94$var$ab(a, b);
    var c = $0b2e6adb871a3b94$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $0b2e6adb871a3b94$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $0b2e6adb871a3b94$var$cb(a, b.type, $0b2e6adb871a3b94$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $0b2e6adb871a3b94$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $0b2e6adb871a3b94$var$cb(a, b, c) {
    if ("number" !== b || $0b2e6adb871a3b94$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $0b2e6adb871a3b94$var$eb = Array.isArray;
function $0b2e6adb871a3b94$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $0b2e6adb871a3b94$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $0b2e6adb871a3b94$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($0b2e6adb871a3b94$var$p(91));
    return $0b2e6adb871a3b94$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $0b2e6adb871a3b94$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($0b2e6adb871a3b94$var$p(92));
            if ($0b2e6adb871a3b94$var$eb(c)) {
                if (1 < c.length) throw Error($0b2e6adb871a3b94$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $0b2e6adb871a3b94$var$Sa(c)
    };
}
function $0b2e6adb871a3b94$var$ib(a, b) {
    var c = $0b2e6adb871a3b94$var$Sa(b.value), d = $0b2e6adb871a3b94$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $0b2e6adb871a3b94$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $0b2e6adb871a3b94$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $0b2e6adb871a3b94$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $0b2e6adb871a3b94$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $0b2e6adb871a3b94$var$mb, $0b2e6adb871a3b94$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $0b2e6adb871a3b94$var$mb = $0b2e6adb871a3b94$var$mb || document.createElement("div");
        $0b2e6adb871a3b94$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $0b2e6adb871a3b94$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $0b2e6adb871a3b94$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $0b2e6adb871a3b94$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $0b2e6adb871a3b94$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($0b2e6adb871a3b94$var$pb).forEach(function(a) {
    $0b2e6adb871a3b94$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $0b2e6adb871a3b94$var$pb[b] = $0b2e6adb871a3b94$var$pb[a];
    });
});
function $0b2e6adb871a3b94$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $0b2e6adb871a3b94$var$pb.hasOwnProperty(a) && $0b2e6adb871a3b94$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $0b2e6adb871a3b94$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $0b2e6adb871a3b94$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $0b2e6adb871a3b94$var$tb = $0b2e6adb871a3b94$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $0b2e6adb871a3b94$var$ub(a, b) {
    if (b) {
        if ($0b2e6adb871a3b94$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($0b2e6adb871a3b94$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($0b2e6adb871a3b94$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($0b2e6adb871a3b94$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($0b2e6adb871a3b94$var$p(62));
    }
}
function $0b2e6adb871a3b94$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $0b2e6adb871a3b94$var$wb = null;
function $0b2e6adb871a3b94$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $0b2e6adb871a3b94$var$yb = null, $0b2e6adb871a3b94$var$zb = null, $0b2e6adb871a3b94$var$Ab = null;
function $0b2e6adb871a3b94$var$Bb(a) {
    if (a = $0b2e6adb871a3b94$var$Cb(a)) {
        if ("function" !== typeof $0b2e6adb871a3b94$var$yb) throw Error($0b2e6adb871a3b94$var$p(280));
        var b = a.stateNode;
        b && (b = $0b2e6adb871a3b94$var$Db(b), $0b2e6adb871a3b94$var$yb(a.stateNode, a.type, b));
    }
}
function $0b2e6adb871a3b94$var$Eb(a) {
    $0b2e6adb871a3b94$var$zb ? $0b2e6adb871a3b94$var$Ab ? $0b2e6adb871a3b94$var$Ab.push(a) : $0b2e6adb871a3b94$var$Ab = [
        a
    ] : $0b2e6adb871a3b94$var$zb = a;
}
function $0b2e6adb871a3b94$var$Fb() {
    if ($0b2e6adb871a3b94$var$zb) {
        var a = $0b2e6adb871a3b94$var$zb, b = $0b2e6adb871a3b94$var$Ab;
        $0b2e6adb871a3b94$var$Ab = $0b2e6adb871a3b94$var$zb = null;
        $0b2e6adb871a3b94$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$0b2e6adb871a3b94$var$Bb(b[a]);
    }
}
function $0b2e6adb871a3b94$var$Gb(a, b) {
    return a(b);
}
function $0b2e6adb871a3b94$var$Hb() {}
var $0b2e6adb871a3b94$var$Ib = !1;
function $0b2e6adb871a3b94$var$Jb(a, b, c) {
    if ($0b2e6adb871a3b94$var$Ib) return a(b, c);
    $0b2e6adb871a3b94$var$Ib = !0;
    try {
        return $0b2e6adb871a3b94$var$Gb(a, b, c);
    } finally{
        if ($0b2e6adb871a3b94$var$Ib = !1, null !== $0b2e6adb871a3b94$var$zb || null !== $0b2e6adb871a3b94$var$Ab) $0b2e6adb871a3b94$var$Hb(), $0b2e6adb871a3b94$var$Fb();
    }
}
function $0b2e6adb871a3b94$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $0b2e6adb871a3b94$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($0b2e6adb871a3b94$var$p(231, b, typeof c));
    return c;
}
var $0b2e6adb871a3b94$var$Lb = !1;
if ($0b2e6adb871a3b94$var$ia) try {
    var $0b2e6adb871a3b94$var$Mb = {};
    Object.defineProperty($0b2e6adb871a3b94$var$Mb, "passive", {
        get: function() {
            $0b2e6adb871a3b94$var$Lb = !0;
        }
    });
    window.addEventListener("test", $0b2e6adb871a3b94$var$Mb, $0b2e6adb871a3b94$var$Mb);
    window.removeEventListener("test", $0b2e6adb871a3b94$var$Mb, $0b2e6adb871a3b94$var$Mb);
} catch (a) {
    $0b2e6adb871a3b94$var$Lb = !1;
}
function $0b2e6adb871a3b94$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $0b2e6adb871a3b94$var$Ob = !1, $0b2e6adb871a3b94$var$Pb = null, $0b2e6adb871a3b94$var$Qb = !1, $0b2e6adb871a3b94$var$Rb = null, $0b2e6adb871a3b94$var$Sb = {
    onError: function(a) {
        $0b2e6adb871a3b94$var$Ob = !0;
        $0b2e6adb871a3b94$var$Pb = a;
    }
};
function $0b2e6adb871a3b94$var$Tb(a, b, c, d, e, f, g, h, k) {
    $0b2e6adb871a3b94$var$Ob = !1;
    $0b2e6adb871a3b94$var$Pb = null;
    $0b2e6adb871a3b94$var$Nb.apply($0b2e6adb871a3b94$var$Sb, arguments);
}
function $0b2e6adb871a3b94$var$Ub(a, b, c, d, e, f, g, h, k) {
    $0b2e6adb871a3b94$var$Tb.apply(this, arguments);
    if ($0b2e6adb871a3b94$var$Ob) {
        if ($0b2e6adb871a3b94$var$Ob) {
            var l = $0b2e6adb871a3b94$var$Pb;
            $0b2e6adb871a3b94$var$Ob = !1;
            $0b2e6adb871a3b94$var$Pb = null;
        } else throw Error($0b2e6adb871a3b94$var$p(198));
        $0b2e6adb871a3b94$var$Qb || ($0b2e6adb871a3b94$var$Qb = !0, $0b2e6adb871a3b94$var$Rb = l);
    }
}
function $0b2e6adb871a3b94$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $0b2e6adb871a3b94$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Xb(a) {
    if ($0b2e6adb871a3b94$var$Vb(a) !== a) throw Error($0b2e6adb871a3b94$var$p(188));
}
function $0b2e6adb871a3b94$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $0b2e6adb871a3b94$var$Vb(a);
        if (null === b) throw Error($0b2e6adb871a3b94$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $0b2e6adb871a3b94$var$Xb(e), a;
                if (f === d) return $0b2e6adb871a3b94$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($0b2e6adb871a3b94$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($0b2e6adb871a3b94$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($0b2e6adb871a3b94$var$p(190));
    }
    if (3 !== c.tag) throw Error($0b2e6adb871a3b94$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $0b2e6adb871a3b94$var$Zb(a) {
    a = $0b2e6adb871a3b94$var$Yb(a);
    return null !== a ? $0b2e6adb871a3b94$var$$b(a) : null;
}
function $0b2e6adb871a3b94$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $0b2e6adb871a3b94$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$ac = $fO90s.unstable_scheduleCallback, $0b2e6adb871a3b94$var$bc = $fO90s.unstable_cancelCallback, $0b2e6adb871a3b94$var$cc = $fO90s.unstable_shouldYield, $0b2e6adb871a3b94$var$dc = $fO90s.unstable_requestPaint, $0b2e6adb871a3b94$var$B = $fO90s.unstable_now, $0b2e6adb871a3b94$var$ec = $fO90s.unstable_getCurrentPriorityLevel, $0b2e6adb871a3b94$var$fc = $fO90s.unstable_ImmediatePriority, $0b2e6adb871a3b94$var$gc = $fO90s.unstable_UserBlockingPriority, $0b2e6adb871a3b94$var$hc = $fO90s.unstable_NormalPriority, $0b2e6adb871a3b94$var$ic = $fO90s.unstable_LowPriority, $0b2e6adb871a3b94$var$jc = $fO90s.unstable_IdlePriority, $0b2e6adb871a3b94$var$kc = null, $0b2e6adb871a3b94$var$lc = null;
function $0b2e6adb871a3b94$var$mc(a) {
    if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onCommitFiberRoot) try {
        $0b2e6adb871a3b94$var$lc.onCommitFiberRoot($0b2e6adb871a3b94$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $0b2e6adb871a3b94$var$oc = Math.clz32 ? Math.clz32 : $0b2e6adb871a3b94$var$nc, $0b2e6adb871a3b94$var$pc = Math.log, $0b2e6adb871a3b94$var$qc = Math.LN2;
function $0b2e6adb871a3b94$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($0b2e6adb871a3b94$var$pc(a) / $0b2e6adb871a3b94$var$qc | 0) | 0;
}
var $0b2e6adb871a3b94$var$rc = 64, $0b2e6adb871a3b94$var$sc = 4194304;
function $0b2e6adb871a3b94$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $0b2e6adb871a3b94$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $0b2e6adb871a3b94$var$tc(h) : (f &= g, 0 !== f && (d = $0b2e6adb871a3b94$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $0b2e6adb871a3b94$var$tc(g) : 0 !== f && (d = $0b2e6adb871a3b94$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $0b2e6adb871a3b94$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $0b2e6adb871a3b94$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $0b2e6adb871a3b94$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $0b2e6adb871a3b94$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $0b2e6adb871a3b94$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $0b2e6adb871a3b94$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $0b2e6adb871a3b94$var$yc() {
    var a = $0b2e6adb871a3b94$var$rc;
    $0b2e6adb871a3b94$var$rc <<= 1;
    0 === ($0b2e6adb871a3b94$var$rc & 4194240) && ($0b2e6adb871a3b94$var$rc = 64);
    return a;
}
function $0b2e6adb871a3b94$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $0b2e6adb871a3b94$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $0b2e6adb871a3b94$var$oc(b);
    a[b] = c;
}
function $0b2e6adb871a3b94$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $0b2e6adb871a3b94$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $0b2e6adb871a3b94$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $0b2e6adb871a3b94$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $0b2e6adb871a3b94$var$C = 0;
function $0b2e6adb871a3b94$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $0b2e6adb871a3b94$var$Ec, $0b2e6adb871a3b94$var$Fc, $0b2e6adb871a3b94$var$Gc, $0b2e6adb871a3b94$var$Hc, $0b2e6adb871a3b94$var$Ic, $0b2e6adb871a3b94$var$Jc = !1, $0b2e6adb871a3b94$var$Kc = [], $0b2e6adb871a3b94$var$Lc = null, $0b2e6adb871a3b94$var$Mc = null, $0b2e6adb871a3b94$var$Nc = null, $0b2e6adb871a3b94$var$Oc = new Map, $0b2e6adb871a3b94$var$Pc = new Map, $0b2e6adb871a3b94$var$Qc = [], $0b2e6adb871a3b94$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $0b2e6adb871a3b94$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $0b2e6adb871a3b94$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $0b2e6adb871a3b94$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $0b2e6adb871a3b94$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $0b2e6adb871a3b94$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $0b2e6adb871a3b94$var$Pc.delete(b.pointerId);
    }
}
function $0b2e6adb871a3b94$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $0b2e6adb871a3b94$var$Cb(b), null !== b && $0b2e6adb871a3b94$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $0b2e6adb871a3b94$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $0b2e6adb871a3b94$var$Lc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $0b2e6adb871a3b94$var$Mc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $0b2e6adb871a3b94$var$Nc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $0b2e6adb871a3b94$var$Oc.set(f, $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $0b2e6adb871a3b94$var$Pc.set(f, $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $0b2e6adb871a3b94$var$Vc(a) {
    var b = $0b2e6adb871a3b94$var$Wc(a.target);
    if (null !== b) {
        var c = $0b2e6adb871a3b94$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $0b2e6adb871a3b94$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $0b2e6adb871a3b94$var$Ic(a.priority, function() {
                        $0b2e6adb871a3b94$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $0b2e6adb871a3b94$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $0b2e6adb871a3b94$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $0b2e6adb871a3b94$var$wb = d;
            c.target.dispatchEvent(d);
            $0b2e6adb871a3b94$var$wb = null;
        } else return b = $0b2e6adb871a3b94$var$Cb(c), null !== b && $0b2e6adb871a3b94$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Zc(a, b, c) {
    $0b2e6adb871a3b94$var$Xc(a) && c.delete(b);
}
function $0b2e6adb871a3b94$var$$c() {
    $0b2e6adb871a3b94$var$Jc = !1;
    null !== $0b2e6adb871a3b94$var$Lc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Lc) && ($0b2e6adb871a3b94$var$Lc = null);
    null !== $0b2e6adb871a3b94$var$Mc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Mc) && ($0b2e6adb871a3b94$var$Mc = null);
    null !== $0b2e6adb871a3b94$var$Nc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Nc) && ($0b2e6adb871a3b94$var$Nc = null);
    $0b2e6adb871a3b94$var$Oc.forEach($0b2e6adb871a3b94$var$Zc);
    $0b2e6adb871a3b94$var$Pc.forEach($0b2e6adb871a3b94$var$Zc);
}
function $0b2e6adb871a3b94$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $0b2e6adb871a3b94$var$Jc || ($0b2e6adb871a3b94$var$Jc = !0, $fO90s.unstable_scheduleCallback($fO90s.unstable_NormalPriority, $0b2e6adb871a3b94$var$$c)));
}
function $0b2e6adb871a3b94$var$bd(a) {
    function b(b) {
        return $0b2e6adb871a3b94$var$ad(b, a);
    }
    if (0 < $0b2e6adb871a3b94$var$Kc.length) {
        $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Kc[0], a);
        for(var c = 1; c < $0b2e6adb871a3b94$var$Kc.length; c++){
            var d = $0b2e6adb871a3b94$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $0b2e6adb871a3b94$var$Lc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Lc, a);
    null !== $0b2e6adb871a3b94$var$Mc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Mc, a);
    null !== $0b2e6adb871a3b94$var$Nc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Nc, a);
    $0b2e6adb871a3b94$var$Oc.forEach(b);
    $0b2e6adb871a3b94$var$Pc.forEach(b);
    for(c = 0; c < $0b2e6adb871a3b94$var$Qc.length; c++)d = $0b2e6adb871a3b94$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $0b2e6adb871a3b94$var$Qc.length && (c = $0b2e6adb871a3b94$var$Qc[0], null === c.blockedOn);)$0b2e6adb871a3b94$var$Vc(c), null === c.blockedOn && $0b2e6adb871a3b94$var$Qc.shift();
}
var $0b2e6adb871a3b94$var$cd = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$dd = !0;
function $0b2e6adb871a3b94$var$ed(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$C, f = $0b2e6adb871a3b94$var$cd.transition;
    $0b2e6adb871a3b94$var$cd.transition = null;
    try {
        $0b2e6adb871a3b94$var$C = 1, $0b2e6adb871a3b94$var$fd(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$C = e, $0b2e6adb871a3b94$var$cd.transition = f;
    }
}
function $0b2e6adb871a3b94$var$gd(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$C, f = $0b2e6adb871a3b94$var$cd.transition;
    $0b2e6adb871a3b94$var$cd.transition = null;
    try {
        $0b2e6adb871a3b94$var$C = 4, $0b2e6adb871a3b94$var$fd(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$C = e, $0b2e6adb871a3b94$var$cd.transition = f;
    }
}
function $0b2e6adb871a3b94$var$fd(a, b, c, d) {
    if ($0b2e6adb871a3b94$var$dd) {
        var e = $0b2e6adb871a3b94$var$Yc(a, b, c, d);
        if (null === e) $0b2e6adb871a3b94$var$hd(a, b, d, $0b2e6adb871a3b94$var$id, c), $0b2e6adb871a3b94$var$Sc(a, d);
        else if ($0b2e6adb871a3b94$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($0b2e6adb871a3b94$var$Sc(a, d), b & 4 && -1 < $0b2e6adb871a3b94$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $0b2e6adb871a3b94$var$Cb(e);
                null !== f && $0b2e6adb871a3b94$var$Ec(f);
                f = $0b2e6adb871a3b94$var$Yc(a, b, c, d);
                null === f && $0b2e6adb871a3b94$var$hd(a, b, d, $0b2e6adb871a3b94$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $0b2e6adb871a3b94$var$hd(a, b, d, null, c);
    }
}
var $0b2e6adb871a3b94$var$id = null;
function $0b2e6adb871a3b94$var$Yc(a, b, c, d) {
    $0b2e6adb871a3b94$var$id = null;
    a = $0b2e6adb871a3b94$var$xb(d);
    a = $0b2e6adb871a3b94$var$Wc(a);
    if (null !== a) {
        if (b = $0b2e6adb871a3b94$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $0b2e6adb871a3b94$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $0b2e6adb871a3b94$var$id = a;
    return null;
}
function $0b2e6adb871a3b94$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($0b2e6adb871a3b94$var$ec()){
                case $0b2e6adb871a3b94$var$fc:
                    return 1;
                case $0b2e6adb871a3b94$var$gc:
                    return 4;
                case $0b2e6adb871a3b94$var$hc:
                case $0b2e6adb871a3b94$var$ic:
                    return 16;
                case $0b2e6adb871a3b94$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $0b2e6adb871a3b94$var$kd = null, $0b2e6adb871a3b94$var$ld = null, $0b2e6adb871a3b94$var$md = null;
function $0b2e6adb871a3b94$var$nd() {
    if ($0b2e6adb871a3b94$var$md) return $0b2e6adb871a3b94$var$md;
    var a, b = $0b2e6adb871a3b94$var$ld, c = b.length, d, e = "value" in $0b2e6adb871a3b94$var$kd ? $0b2e6adb871a3b94$var$kd.value : $0b2e6adb871a3b94$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $0b2e6adb871a3b94$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $0b2e6adb871a3b94$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $0b2e6adb871a3b94$var$pd() {
    return !0;
}
function $0b2e6adb871a3b94$var$qd() {
    return !1;
}
function $0b2e6adb871a3b94$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $0b2e6adb871a3b94$var$pd : $0b2e6adb871a3b94$var$qd;
        this.isPropagationStopped = $0b2e6adb871a3b94$var$qd;
        return this;
    }
    $0b2e6adb871a3b94$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $0b2e6adb871a3b94$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $0b2e6adb871a3b94$var$pd);
        },
        persist: function() {},
        isPersistent: $0b2e6adb871a3b94$var$pd
    });
    return b;
}
var $0b2e6adb871a3b94$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $0b2e6adb871a3b94$var$td = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$sd), $0b2e6adb871a3b94$var$ud = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    view: 0,
    detail: 0
}), $0b2e6adb871a3b94$var$vd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$ud), $0b2e6adb871a3b94$var$wd, $0b2e6adb871a3b94$var$xd, $0b2e6adb871a3b94$var$yd, $0b2e6adb871a3b94$var$Ad = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $0b2e6adb871a3b94$var$yd && ($0b2e6adb871a3b94$var$yd && "mousemove" === a.type ? ($0b2e6adb871a3b94$var$wd = a.screenX - $0b2e6adb871a3b94$var$yd.screenX, $0b2e6adb871a3b94$var$xd = a.screenY - $0b2e6adb871a3b94$var$yd.screenY) : $0b2e6adb871a3b94$var$xd = $0b2e6adb871a3b94$var$wd = 0, $0b2e6adb871a3b94$var$yd = a);
        return $0b2e6adb871a3b94$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $0b2e6adb871a3b94$var$xd;
    }
}), $0b2e6adb871a3b94$var$Bd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ad), $0b2e6adb871a3b94$var$Cd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    dataTransfer: 0
}), $0b2e6adb871a3b94$var$Dd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Cd), $0b2e6adb871a3b94$var$Ed = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    relatedTarget: 0
}), $0b2e6adb871a3b94$var$Fd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ed), $0b2e6adb871a3b94$var$Gd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $0b2e6adb871a3b94$var$Hd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Gd), $0b2e6adb871a3b94$var$Id = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $0b2e6adb871a3b94$var$Jd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Id), $0b2e6adb871a3b94$var$Kd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    data: 0
}), $0b2e6adb871a3b94$var$Ld = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Kd), $0b2e6adb871a3b94$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $0b2e6adb871a3b94$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $0b2e6adb871a3b94$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $0b2e6adb871a3b94$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $0b2e6adb871a3b94$var$Od[a]) ? !!b[a] : !1;
}
function $0b2e6adb871a3b94$var$zd() {
    return $0b2e6adb871a3b94$var$Pd;
}
var $0b2e6adb871a3b94$var$Qd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $0b2e6adb871a3b94$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $0b2e6adb871a3b94$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $0b2e6adb871a3b94$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $0b2e6adb871a3b94$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $0b2e6adb871a3b94$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $0b2e6adb871a3b94$var$Rd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Qd), $0b2e6adb871a3b94$var$Sd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $0b2e6adb871a3b94$var$Td = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Sd), $0b2e6adb871a3b94$var$Ud = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd
}), $0b2e6adb871a3b94$var$Vd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ud), $0b2e6adb871a3b94$var$Wd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $0b2e6adb871a3b94$var$Xd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Wd), $0b2e6adb871a3b94$var$Yd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $0b2e6adb871a3b94$var$Zd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Yd), $0b2e6adb871a3b94$var$$d = [
    9,
    13,
    27,
    32
], $0b2e6adb871a3b94$var$ae = $0b2e6adb871a3b94$var$ia && "CompositionEvent" in window, $0b2e6adb871a3b94$var$be = null;
$0b2e6adb871a3b94$var$ia && "documentMode" in document && ($0b2e6adb871a3b94$var$be = document.documentMode);
var $0b2e6adb871a3b94$var$ce = $0b2e6adb871a3b94$var$ia && "TextEvent" in window && !$0b2e6adb871a3b94$var$be, $0b2e6adb871a3b94$var$de = $0b2e6adb871a3b94$var$ia && (!$0b2e6adb871a3b94$var$ae || $0b2e6adb871a3b94$var$be && 8 < $0b2e6adb871a3b94$var$be && 11 >= $0b2e6adb871a3b94$var$be), $0b2e6adb871a3b94$var$ee = String.fromCharCode(32), $0b2e6adb871a3b94$var$fe = !1;
function $0b2e6adb871a3b94$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $0b2e6adb871a3b94$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $0b2e6adb871a3b94$var$ie = !1;
function $0b2e6adb871a3b94$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $0b2e6adb871a3b94$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $0b2e6adb871a3b94$var$fe = !0;
            return $0b2e6adb871a3b94$var$ee;
        case "textInput":
            return a = b.data, a === $0b2e6adb871a3b94$var$ee && $0b2e6adb871a3b94$var$fe ? null : a;
        default:
            return null;
    }
}
function $0b2e6adb871a3b94$var$ke(a, b) {
    if ($0b2e6adb871a3b94$var$ie) return "compositionend" === a || !$0b2e6adb871a3b94$var$ae && $0b2e6adb871a3b94$var$ge(a, b) ? (a = $0b2e6adb871a3b94$var$nd(), $0b2e6adb871a3b94$var$md = $0b2e6adb871a3b94$var$ld = $0b2e6adb871a3b94$var$kd = null, $0b2e6adb871a3b94$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $0b2e6adb871a3b94$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $0b2e6adb871a3b94$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $0b2e6adb871a3b94$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$0b2e6adb871a3b94$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $0b2e6adb871a3b94$var$ne(a, b, c, d) {
    $0b2e6adb871a3b94$var$Eb(d);
    b = $0b2e6adb871a3b94$var$oe(b, "onChange");
    0 < b.length && (c = new $0b2e6adb871a3b94$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $0b2e6adb871a3b94$var$pe = null, $0b2e6adb871a3b94$var$qe = null;
function $0b2e6adb871a3b94$var$re(a) {
    $0b2e6adb871a3b94$var$se(a, 0);
}
function $0b2e6adb871a3b94$var$te(a) {
    var b = $0b2e6adb871a3b94$var$ue(a);
    if ($0b2e6adb871a3b94$var$Wa(b)) return a;
}
function $0b2e6adb871a3b94$var$ve(a, b) {
    if ("change" === a) return b;
}
var $0b2e6adb871a3b94$var$we = !1;
if ($0b2e6adb871a3b94$var$ia) {
    var $0b2e6adb871a3b94$var$xe;
    if ($0b2e6adb871a3b94$var$ia) {
        var $0b2e6adb871a3b94$var$ye = "oninput" in document;
        if (!$0b2e6adb871a3b94$var$ye) {
            var $0b2e6adb871a3b94$var$ze = document.createElement("div");
            $0b2e6adb871a3b94$var$ze.setAttribute("oninput", "return;");
            $0b2e6adb871a3b94$var$ye = "function" === typeof $0b2e6adb871a3b94$var$ze.oninput;
        }
        $0b2e6adb871a3b94$var$xe = $0b2e6adb871a3b94$var$ye;
    } else $0b2e6adb871a3b94$var$xe = !1;
    $0b2e6adb871a3b94$var$we = $0b2e6adb871a3b94$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $0b2e6adb871a3b94$var$Ae() {
    $0b2e6adb871a3b94$var$pe && ($0b2e6adb871a3b94$var$pe.detachEvent("onpropertychange", $0b2e6adb871a3b94$var$Be), $0b2e6adb871a3b94$var$qe = $0b2e6adb871a3b94$var$pe = null);
}
function $0b2e6adb871a3b94$var$Be(a) {
    if ("value" === a.propertyName && $0b2e6adb871a3b94$var$te($0b2e6adb871a3b94$var$qe)) {
        var b = [];
        $0b2e6adb871a3b94$var$ne(b, $0b2e6adb871a3b94$var$qe, a, $0b2e6adb871a3b94$var$xb(a));
        $0b2e6adb871a3b94$var$Jb($0b2e6adb871a3b94$var$re, b);
    }
}
function $0b2e6adb871a3b94$var$Ce(a, b, c) {
    "focusin" === a ? ($0b2e6adb871a3b94$var$Ae(), $0b2e6adb871a3b94$var$pe = b, $0b2e6adb871a3b94$var$qe = c, $0b2e6adb871a3b94$var$pe.attachEvent("onpropertychange", $0b2e6adb871a3b94$var$Be)) : "focusout" === a && $0b2e6adb871a3b94$var$Ae();
}
function $0b2e6adb871a3b94$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $0b2e6adb871a3b94$var$te($0b2e6adb871a3b94$var$qe);
}
function $0b2e6adb871a3b94$var$Ee(a, b) {
    if ("click" === a) return $0b2e6adb871a3b94$var$te(b);
}
function $0b2e6adb871a3b94$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $0b2e6adb871a3b94$var$te(b);
}
function $0b2e6adb871a3b94$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $0b2e6adb871a3b94$var$He = "function" === typeof Object.is ? Object.is : $0b2e6adb871a3b94$var$Ge;
function $0b2e6adb871a3b94$var$Ie(a, b) {
    if ($0b2e6adb871a3b94$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$0b2e6adb871a3b94$var$ja.call(b, e) || !$0b2e6adb871a3b94$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $0b2e6adb871a3b94$var$Ke(a, b) {
    var c = $0b2e6adb871a3b94$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $0b2e6adb871a3b94$var$Je(c);
    }
}
function $0b2e6adb871a3b94$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $0b2e6adb871a3b94$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $0b2e6adb871a3b94$var$Me() {
    for(var a = window, b = $0b2e6adb871a3b94$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $0b2e6adb871a3b94$var$Xa(a.document);
    }
    return b;
}
function $0b2e6adb871a3b94$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $0b2e6adb871a3b94$var$Oe(a) {
    var b = $0b2e6adb871a3b94$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $0b2e6adb871a3b94$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $0b2e6adb871a3b94$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $0b2e6adb871a3b94$var$Ke(c, f);
                var g = $0b2e6adb871a3b94$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $0b2e6adb871a3b94$var$Pe = $0b2e6adb871a3b94$var$ia && "documentMode" in document && 11 >= document.documentMode, $0b2e6adb871a3b94$var$Qe = null, $0b2e6adb871a3b94$var$Re = null, $0b2e6adb871a3b94$var$Se = null, $0b2e6adb871a3b94$var$Te = !1;
function $0b2e6adb871a3b94$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $0b2e6adb871a3b94$var$Te || null == $0b2e6adb871a3b94$var$Qe || $0b2e6adb871a3b94$var$Qe !== $0b2e6adb871a3b94$var$Xa(d) || (d = $0b2e6adb871a3b94$var$Qe, "selectionStart" in d && $0b2e6adb871a3b94$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $0b2e6adb871a3b94$var$Se && $0b2e6adb871a3b94$var$Ie($0b2e6adb871a3b94$var$Se, d) || ($0b2e6adb871a3b94$var$Se = d, d = $0b2e6adb871a3b94$var$oe($0b2e6adb871a3b94$var$Re, "onSelect"), 0 < d.length && (b = new $0b2e6adb871a3b94$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $0b2e6adb871a3b94$var$Qe)));
}
function $0b2e6adb871a3b94$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $0b2e6adb871a3b94$var$We = {
    animationend: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationIteration"),
    animationstart: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationStart"),
    transitionend: $0b2e6adb871a3b94$var$Ve("Transition", "TransitionEnd")
}, $0b2e6adb871a3b94$var$Xe = {}, $0b2e6adb871a3b94$var$Ye = {};
$0b2e6adb871a3b94$var$ia && ($0b2e6adb871a3b94$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $0b2e6adb871a3b94$var$We.animationend.animation, delete $0b2e6adb871a3b94$var$We.animationiteration.animation, delete $0b2e6adb871a3b94$var$We.animationstart.animation), "TransitionEvent" in window || delete $0b2e6adb871a3b94$var$We.transitionend.transition);
function $0b2e6adb871a3b94$var$Ze(a) {
    if ($0b2e6adb871a3b94$var$Xe[a]) return $0b2e6adb871a3b94$var$Xe[a];
    if (!$0b2e6adb871a3b94$var$We[a]) return a;
    var b = $0b2e6adb871a3b94$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $0b2e6adb871a3b94$var$Ye) return $0b2e6adb871a3b94$var$Xe[a] = b[c];
    return a;
}
var $0b2e6adb871a3b94$var$$e = $0b2e6adb871a3b94$var$Ze("animationend"), $0b2e6adb871a3b94$var$af = $0b2e6adb871a3b94$var$Ze("animationiteration"), $0b2e6adb871a3b94$var$bf = $0b2e6adb871a3b94$var$Ze("animationstart"), $0b2e6adb871a3b94$var$cf = $0b2e6adb871a3b94$var$Ze("transitionend"), $0b2e6adb871a3b94$var$df = new Map, $0b2e6adb871a3b94$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $0b2e6adb871a3b94$var$ff(a, b) {
    $0b2e6adb871a3b94$var$df.set(a, b);
    $0b2e6adb871a3b94$var$fa(b, [
        a
    ]);
}
for(var $0b2e6adb871a3b94$var$gf = 0; $0b2e6adb871a3b94$var$gf < $0b2e6adb871a3b94$var$ef.length; $0b2e6adb871a3b94$var$gf++){
    var $0b2e6adb871a3b94$var$hf = $0b2e6adb871a3b94$var$ef[$0b2e6adb871a3b94$var$gf], $0b2e6adb871a3b94$var$jf = $0b2e6adb871a3b94$var$hf.toLowerCase(), $0b2e6adb871a3b94$var$kf = $0b2e6adb871a3b94$var$hf[0].toUpperCase() + $0b2e6adb871a3b94$var$hf.slice(1);
    $0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$jf, "on" + $0b2e6adb871a3b94$var$kf);
}
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$$e, "onAnimationEnd");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$af, "onAnimationIteration");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$bf, "onAnimationStart");
$0b2e6adb871a3b94$var$ff("dblclick", "onDoubleClick");
$0b2e6adb871a3b94$var$ff("focusin", "onFocus");
$0b2e6adb871a3b94$var$ff("focusout", "onBlur");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$cf, "onTransitionEnd");
$0b2e6adb871a3b94$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$0b2e6adb871a3b94$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$0b2e6adb871a3b94$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$0b2e6adb871a3b94$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$0b2e6adb871a3b94$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$0b2e6adb871a3b94$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$0b2e6adb871a3b94$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$0b2e6adb871a3b94$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$0b2e6adb871a3b94$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$0b2e6adb871a3b94$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $0b2e6adb871a3b94$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $0b2e6adb871a3b94$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($0b2e6adb871a3b94$var$lf));
function $0b2e6adb871a3b94$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $0b2e6adb871a3b94$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $0b2e6adb871a3b94$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $0b2e6adb871a3b94$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $0b2e6adb871a3b94$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($0b2e6adb871a3b94$var$Qb) throw a = $0b2e6adb871a3b94$var$Rb, $0b2e6adb871a3b94$var$Qb = !1, $0b2e6adb871a3b94$var$Rb = null, a;
}
function $0b2e6adb871a3b94$var$D(a, b) {
    var c = b[$0b2e6adb871a3b94$var$of];
    void 0 === c && (c = b[$0b2e6adb871a3b94$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($0b2e6adb871a3b94$var$pf(b, a, 2, !1), c.add(d));
}
function $0b2e6adb871a3b94$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $0b2e6adb871a3b94$var$pf(c, a, d, b);
}
var $0b2e6adb871a3b94$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $0b2e6adb871a3b94$var$sf(a) {
    if (!a[$0b2e6adb871a3b94$var$rf]) {
        a[$0b2e6adb871a3b94$var$rf] = !0;
        $0b2e6adb871a3b94$var$da.forEach(function(b) {
            "selectionchange" !== b && ($0b2e6adb871a3b94$var$mf.has(b) || $0b2e6adb871a3b94$var$qf(b, !1, a), $0b2e6adb871a3b94$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$0b2e6adb871a3b94$var$rf] || (b[$0b2e6adb871a3b94$var$rf] = !0, $0b2e6adb871a3b94$var$qf("selectionchange", !1, b));
    }
}
function $0b2e6adb871a3b94$var$pf(a, b, c, d) {
    switch($0b2e6adb871a3b94$var$jd(b)){
        case 1:
            var e = $0b2e6adb871a3b94$var$ed;
            break;
        case 4:
            e = $0b2e6adb871a3b94$var$gd;
            break;
        default:
            e = $0b2e6adb871a3b94$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$0b2e6adb871a3b94$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $0b2e6adb871a3b94$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $0b2e6adb871a3b94$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $0b2e6adb871a3b94$var$Jb(function() {
        var d = f, e = $0b2e6adb871a3b94$var$xb(c), g = [];
        a: {
            var h = $0b2e6adb871a3b94$var$df.get(a);
            if (void 0 !== h) {
                var k = $0b2e6adb871a3b94$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $0b2e6adb871a3b94$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $0b2e6adb871a3b94$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $0b2e6adb871a3b94$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $0b2e6adb871a3b94$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $0b2e6adb871a3b94$var$Vd;
                        break;
                    case $0b2e6adb871a3b94$var$$e:
                    case $0b2e6adb871a3b94$var$af:
                    case $0b2e6adb871a3b94$var$bf:
                        k = $0b2e6adb871a3b94$var$Hd;
                        break;
                    case $0b2e6adb871a3b94$var$cf:
                        k = $0b2e6adb871a3b94$var$Xd;
                        break;
                    case "scroll":
                        k = $0b2e6adb871a3b94$var$vd;
                        break;
                    case "wheel":
                        k = $0b2e6adb871a3b94$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $0b2e6adb871a3b94$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $0b2e6adb871a3b94$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $0b2e6adb871a3b94$var$Kb(w, x), null != F && t.push($0b2e6adb871a3b94$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $0b2e6adb871a3b94$var$wb && (n = c.relatedTarget || c.fromElement) && ($0b2e6adb871a3b94$var$Wc(n) || n[$0b2e6adb871a3b94$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $0b2e6adb871a3b94$var$Wc(n) : null, null !== n && (J = $0b2e6adb871a3b94$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $0b2e6adb871a3b94$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $0b2e6adb871a3b94$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $0b2e6adb871a3b94$var$ue(k);
                        u = null == n ? h : $0b2e6adb871a3b94$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $0b2e6adb871a3b94$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $0b2e6adb871a3b94$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $0b2e6adb871a3b94$var$vf(F))u++;
                            for(; 0 < w - u;)t = $0b2e6adb871a3b94$var$vf(t), w--;
                            for(; 0 < u - w;)x = $0b2e6adb871a3b94$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $0b2e6adb871a3b94$var$vf(t);
                                x = $0b2e6adb871a3b94$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $0b2e6adb871a3b94$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $0b2e6adb871a3b94$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $0b2e6adb871a3b94$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $0b2e6adb871a3b94$var$ve;
                else if ($0b2e6adb871a3b94$var$me(h)) {
                    if ($0b2e6adb871a3b94$var$we) na = $0b2e6adb871a3b94$var$Fe;
                    else {
                        na = $0b2e6adb871a3b94$var$De;
                        var xa = $0b2e6adb871a3b94$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $0b2e6adb871a3b94$var$Ee);
                if (na && (na = na(a, d))) {
                    $0b2e6adb871a3b94$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $0b2e6adb871a3b94$var$cb(h, "number", h.value);
            }
            xa = d ? $0b2e6adb871a3b94$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($0b2e6adb871a3b94$var$me(xa) || "true" === xa.contentEditable) $0b2e6adb871a3b94$var$Qe = xa, $0b2e6adb871a3b94$var$Re = d, $0b2e6adb871a3b94$var$Se = null;
                    break;
                case "focusout":
                    $0b2e6adb871a3b94$var$Se = $0b2e6adb871a3b94$var$Re = $0b2e6adb871a3b94$var$Qe = null;
                    break;
                case "mousedown":
                    $0b2e6adb871a3b94$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $0b2e6adb871a3b94$var$Te = !1;
                    $0b2e6adb871a3b94$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($0b2e6adb871a3b94$var$Pe) break;
                case "keydown":
                case "keyup":
                    $0b2e6adb871a3b94$var$Ue(g, c, e);
            }
            var $a;
            if ($0b2e6adb871a3b94$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $0b2e6adb871a3b94$var$ie ? $0b2e6adb871a3b94$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($0b2e6adb871a3b94$var$de && "ko" !== c.locale && ($0b2e6adb871a3b94$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $0b2e6adb871a3b94$var$ie && ($a = $0b2e6adb871a3b94$var$nd()) : ($0b2e6adb871a3b94$var$kd = e, $0b2e6adb871a3b94$var$ld = "value" in $0b2e6adb871a3b94$var$kd ? $0b2e6adb871a3b94$var$kd.value : $0b2e6adb871a3b94$var$kd.textContent, $0b2e6adb871a3b94$var$ie = !0)), xa = $0b2e6adb871a3b94$var$oe(d, ba), 0 < xa.length && (ba = new $0b2e6adb871a3b94$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $0b2e6adb871a3b94$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $0b2e6adb871a3b94$var$ce ? $0b2e6adb871a3b94$var$je(a, c) : $0b2e6adb871a3b94$var$ke(a, c)) d = $0b2e6adb871a3b94$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $0b2e6adb871a3b94$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $0b2e6adb871a3b94$var$se(g, b);
    });
}
function $0b2e6adb871a3b94$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $0b2e6adb871a3b94$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $0b2e6adb871a3b94$var$Kb(a, c), null != f && d.unshift($0b2e6adb871a3b94$var$tf(a, f, e)), f = $0b2e6adb871a3b94$var$Kb(a, b), null != f && d.push($0b2e6adb871a3b94$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $0b2e6adb871a3b94$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $0b2e6adb871a3b94$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $0b2e6adb871a3b94$var$Kb(c, f), null != k && g.unshift($0b2e6adb871a3b94$var$tf(c, k, h))) : e || (k = $0b2e6adb871a3b94$var$Kb(c, f), null != k && g.push($0b2e6adb871a3b94$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $0b2e6adb871a3b94$var$xf = /\r\n?/g, $0b2e6adb871a3b94$var$yf = /\u0000|\uFFFD/g;
function $0b2e6adb871a3b94$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($0b2e6adb871a3b94$var$xf, "\n").replace($0b2e6adb871a3b94$var$yf, "");
}
function $0b2e6adb871a3b94$var$Af(a, b, c) {
    b = $0b2e6adb871a3b94$var$zf(b);
    if ($0b2e6adb871a3b94$var$zf(a) !== b && c) throw Error($0b2e6adb871a3b94$var$p(425));
}
function $0b2e6adb871a3b94$var$Bf() {}
var $0b2e6adb871a3b94$var$Cf = null, $0b2e6adb871a3b94$var$Df = null;
function $0b2e6adb871a3b94$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $0b2e6adb871a3b94$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $0b2e6adb871a3b94$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $0b2e6adb871a3b94$var$Hf = "function" === typeof Promise ? Promise : void 0, $0b2e6adb871a3b94$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $0b2e6adb871a3b94$var$Hf ? function(a) {
    return $0b2e6adb871a3b94$var$Hf.resolve(null).then(a).catch($0b2e6adb871a3b94$var$If);
} : $0b2e6adb871a3b94$var$Ff;
function $0b2e6adb871a3b94$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $0b2e6adb871a3b94$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $0b2e6adb871a3b94$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $0b2e6adb871a3b94$var$bd(b);
}
function $0b2e6adb871a3b94$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $0b2e6adb871a3b94$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$Nf = Math.random().toString(36).slice(2), $0b2e6adb871a3b94$var$Of = "__reactFiber$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Pf = "__reactProps$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$uf = "__reactContainer$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$of = "__reactEvents$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Qf = "__reactListeners$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Rf = "__reactHandles$" + $0b2e6adb871a3b94$var$Nf;
function $0b2e6adb871a3b94$var$Wc(a) {
    var b = a[$0b2e6adb871a3b94$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$0b2e6adb871a3b94$var$uf] || c[$0b2e6adb871a3b94$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $0b2e6adb871a3b94$var$Mf(a); null !== a;){
                if (c = a[$0b2e6adb871a3b94$var$Of]) return c;
                a = $0b2e6adb871a3b94$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Cb(a) {
    a = a[$0b2e6adb871a3b94$var$Of] || a[$0b2e6adb871a3b94$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $0b2e6adb871a3b94$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($0b2e6adb871a3b94$var$p(33));
}
function $0b2e6adb871a3b94$var$Db(a) {
    return a[$0b2e6adb871a3b94$var$Pf] || null;
}
var $0b2e6adb871a3b94$var$Sf = [], $0b2e6adb871a3b94$var$Tf = -1;
function $0b2e6adb871a3b94$var$Uf(a) {
    return {
        current: a
    };
}
function $0b2e6adb871a3b94$var$E(a) {
    0 > $0b2e6adb871a3b94$var$Tf || (a.current = $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf], $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf] = null, $0b2e6adb871a3b94$var$Tf--);
}
function $0b2e6adb871a3b94$var$G(a, b) {
    $0b2e6adb871a3b94$var$Tf++;
    $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf] = a.current;
    a.current = b;
}
var $0b2e6adb871a3b94$var$Vf = {}, $0b2e6adb871a3b94$var$H = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$Vf), $0b2e6adb871a3b94$var$Wf = $0b2e6adb871a3b94$var$Uf(!1), $0b2e6adb871a3b94$var$Xf = $0b2e6adb871a3b94$var$Vf;
function $0b2e6adb871a3b94$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $0b2e6adb871a3b94$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $0b2e6adb871a3b94$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $0b2e6adb871a3b94$var$$f() {
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
}
function $0b2e6adb871a3b94$var$ag(a, b, c) {
    if ($0b2e6adb871a3b94$var$H.current !== $0b2e6adb871a3b94$var$Vf) throw Error($0b2e6adb871a3b94$var$p(168));
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, b);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, c);
}
function $0b2e6adb871a3b94$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($0b2e6adb871a3b94$var$p(108, $0b2e6adb871a3b94$var$Ra(a) || "Unknown", e));
    return $0b2e6adb871a3b94$var$A({}, c, d);
}
function $0b2e6adb871a3b94$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $0b2e6adb871a3b94$var$Vf;
    $0b2e6adb871a3b94$var$Xf = $0b2e6adb871a3b94$var$H.current;
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, a);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, $0b2e6adb871a3b94$var$Wf.current);
    return !0;
}
function $0b2e6adb871a3b94$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($0b2e6adb871a3b94$var$p(169));
    c ? (a = $0b2e6adb871a3b94$var$bg(a, b, $0b2e6adb871a3b94$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H), $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, a)) : $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, c);
}
var $0b2e6adb871a3b94$var$eg = null, $0b2e6adb871a3b94$var$fg = !1, $0b2e6adb871a3b94$var$gg = !1;
function $0b2e6adb871a3b94$var$hg(a) {
    null === $0b2e6adb871a3b94$var$eg ? $0b2e6adb871a3b94$var$eg = [
        a
    ] : $0b2e6adb871a3b94$var$eg.push(a);
}
function $0b2e6adb871a3b94$var$ig(a) {
    $0b2e6adb871a3b94$var$fg = !0;
    $0b2e6adb871a3b94$var$hg(a);
}
function $0b2e6adb871a3b94$var$jg() {
    if (!$0b2e6adb871a3b94$var$gg && null !== $0b2e6adb871a3b94$var$eg) {
        $0b2e6adb871a3b94$var$gg = !0;
        var a = 0, b = $0b2e6adb871a3b94$var$C;
        try {
            var c = $0b2e6adb871a3b94$var$eg;
            for($0b2e6adb871a3b94$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $0b2e6adb871a3b94$var$eg = null;
            $0b2e6adb871a3b94$var$fg = !1;
        } catch (e) {
            throw null !== $0b2e6adb871a3b94$var$eg && ($0b2e6adb871a3b94$var$eg = $0b2e6adb871a3b94$var$eg.slice(a + 1)), $0b2e6adb871a3b94$var$ac($0b2e6adb871a3b94$var$fc, $0b2e6adb871a3b94$var$jg), e;
        } finally{
            $0b2e6adb871a3b94$var$C = b, $0b2e6adb871a3b94$var$gg = !1;
        }
    }
    return null;
}
var $0b2e6adb871a3b94$var$kg = [], $0b2e6adb871a3b94$var$lg = 0, $0b2e6adb871a3b94$var$mg = null, $0b2e6adb871a3b94$var$ng = 0, $0b2e6adb871a3b94$var$og = [], $0b2e6adb871a3b94$var$pg = 0, $0b2e6adb871a3b94$var$qg = null, $0b2e6adb871a3b94$var$rg = 1, $0b2e6adb871a3b94$var$sg = "";
function $0b2e6adb871a3b94$var$tg(a, b) {
    $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg++] = $0b2e6adb871a3b94$var$ng;
    $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg++] = $0b2e6adb871a3b94$var$mg;
    $0b2e6adb871a3b94$var$mg = a;
    $0b2e6adb871a3b94$var$ng = b;
}
function $0b2e6adb871a3b94$var$ug(a, b, c) {
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$rg;
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$sg;
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$qg;
    $0b2e6adb871a3b94$var$qg = a;
    var d = $0b2e6adb871a3b94$var$rg;
    a = $0b2e6adb871a3b94$var$sg;
    var e = 32 - $0b2e6adb871a3b94$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $0b2e6adb871a3b94$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $0b2e6adb871a3b94$var$rg = 1 << 32 - $0b2e6adb871a3b94$var$oc(b) + e | c << e | d;
        $0b2e6adb871a3b94$var$sg = f + a;
    } else $0b2e6adb871a3b94$var$rg = 1 << f | c << e | d, $0b2e6adb871a3b94$var$sg = a;
}
function $0b2e6adb871a3b94$var$vg(a) {
    null !== a.return && ($0b2e6adb871a3b94$var$tg(a, 1), $0b2e6adb871a3b94$var$ug(a, 1, 0));
}
function $0b2e6adb871a3b94$var$wg(a) {
    for(; a === $0b2e6adb871a3b94$var$mg;)$0b2e6adb871a3b94$var$mg = $0b2e6adb871a3b94$var$kg[--$0b2e6adb871a3b94$var$lg], $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg] = null, $0b2e6adb871a3b94$var$ng = $0b2e6adb871a3b94$var$kg[--$0b2e6adb871a3b94$var$lg], $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg] = null;
    for(; a === $0b2e6adb871a3b94$var$qg;)$0b2e6adb871a3b94$var$qg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null, $0b2e6adb871a3b94$var$sg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null, $0b2e6adb871a3b94$var$rg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null;
}
var $0b2e6adb871a3b94$var$xg = null, $0b2e6adb871a3b94$var$yg = null, $0b2e6adb871a3b94$var$I = !1, $0b2e6adb871a3b94$var$zg = null;
function $0b2e6adb871a3b94$var$Ag(a, b) {
    var c = $0b2e6adb871a3b94$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $0b2e6adb871a3b94$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $0b2e6adb871a3b94$var$qg ? {
                id: $0b2e6adb871a3b94$var$rg,
                overflow: $0b2e6adb871a3b94$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $0b2e6adb871a3b94$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $0b2e6adb871a3b94$var$Eg(a) {
    if ($0b2e6adb871a3b94$var$I) {
        var b = $0b2e6adb871a3b94$var$yg;
        if (b) {
            var c = b;
            if (!$0b2e6adb871a3b94$var$Cg(a, b)) {
                if ($0b2e6adb871a3b94$var$Dg(a)) throw Error($0b2e6adb871a3b94$var$p(418));
                b = $0b2e6adb871a3b94$var$Lf(c.nextSibling);
                var d = $0b2e6adb871a3b94$var$xg;
                b && $0b2e6adb871a3b94$var$Cg(a, b) ? $0b2e6adb871a3b94$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $0b2e6adb871a3b94$var$I = !1, $0b2e6adb871a3b94$var$xg = a);
            }
        } else {
            if ($0b2e6adb871a3b94$var$Dg(a)) throw Error($0b2e6adb871a3b94$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $0b2e6adb871a3b94$var$I = !1;
            $0b2e6adb871a3b94$var$xg = a;
        }
    }
}
function $0b2e6adb871a3b94$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $0b2e6adb871a3b94$var$xg = a;
}
function $0b2e6adb871a3b94$var$Gg(a) {
    if (a !== $0b2e6adb871a3b94$var$xg) return !1;
    if (!$0b2e6adb871a3b94$var$I) return $0b2e6adb871a3b94$var$Fg(a), $0b2e6adb871a3b94$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$0b2e6adb871a3b94$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $0b2e6adb871a3b94$var$yg)) {
        if ($0b2e6adb871a3b94$var$Dg(a)) throw $0b2e6adb871a3b94$var$Hg(), Error($0b2e6adb871a3b94$var$p(418));
        for(; b;)$0b2e6adb871a3b94$var$Ag(a, b), b = $0b2e6adb871a3b94$var$Lf(b.nextSibling);
    }
    $0b2e6adb871a3b94$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($0b2e6adb871a3b94$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $0b2e6adb871a3b94$var$yg = null;
        }
    } else $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$xg ? $0b2e6adb871a3b94$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $0b2e6adb871a3b94$var$Hg() {
    for(var a = $0b2e6adb871a3b94$var$yg; a;)a = $0b2e6adb871a3b94$var$Lf(a.nextSibling);
}
function $0b2e6adb871a3b94$var$Ig() {
    $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$xg = null;
    $0b2e6adb871a3b94$var$I = !1;
}
function $0b2e6adb871a3b94$var$Jg(a) {
    null === $0b2e6adb871a3b94$var$zg ? $0b2e6adb871a3b94$var$zg = [
        a
    ] : $0b2e6adb871a3b94$var$zg.push(a);
}
var $0b2e6adb871a3b94$var$Kg = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig;
function $0b2e6adb871a3b94$var$Lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($0b2e6adb871a3b94$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($0b2e6adb871a3b94$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($0b2e6adb871a3b94$var$p(284));
        if (!c._owner) throw Error($0b2e6adb871a3b94$var$p(290, a));
    }
    return a;
}
function $0b2e6adb871a3b94$var$Mg(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($0b2e6adb871a3b94$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $0b2e6adb871a3b94$var$Ng(a) {
    var b = a._init;
    return b(a._payload);
}
function $0b2e6adb871a3b94$var$Og(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $0b2e6adb871a3b94$var$Pg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $0b2e6adb871a3b94$var$Qg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $0b2e6adb871a3b94$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $0b2e6adb871a3b94$var$Ha && $0b2e6adb871a3b94$var$Ng(f) === b.type)) return d = e(b, c.props), d.ref = $0b2e6adb871a3b94$var$Lg(a, b, c), d.return = a, d;
        d = $0b2e6adb871a3b94$var$Rg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $0b2e6adb871a3b94$var$Lg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $0b2e6adb871a3b94$var$Sg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $0b2e6adb871a3b94$var$Tg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $0b2e6adb871a3b94$var$Qg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return c = $0b2e6adb871a3b94$var$Rg(b.type, b.key, b.props, null, a.mode, c), c.ref = $0b2e6adb871a3b94$var$Lg(a, null, b), c.return = a, c;
                case $0b2e6adb871a3b94$var$wa:
                    return b = $0b2e6adb871a3b94$var$Sg(b, a.mode, c), b.return = a, b;
                case $0b2e6adb871a3b94$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($0b2e6adb871a3b94$var$eb(b) || $0b2e6adb871a3b94$var$Ka(b)) return b = $0b2e6adb871a3b94$var$Tg(b, a.mode, c, null), b.return = a, b;
            $0b2e6adb871a3b94$var$Mg(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $0b2e6adb871a3b94$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $0b2e6adb871a3b94$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($0b2e6adb871a3b94$var$eb(c) || $0b2e6adb871a3b94$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $0b2e6adb871a3b94$var$Mg(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $0b2e6adb871a3b94$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $0b2e6adb871a3b94$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($0b2e6adb871a3b94$var$eb(d) || $0b2e6adb871a3b94$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $0b2e6adb871a3b94$var$Mg(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $0b2e6adb871a3b94$var$Ka(h);
        if ("function" !== typeof l) throw Error($0b2e6adb871a3b94$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($0b2e6adb871a3b94$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $0b2e6adb871a3b94$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $0b2e6adb871a3b94$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $0b2e6adb871a3b94$var$Ha && $0b2e6adb871a3b94$var$Ng(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $0b2e6adb871a3b94$var$Lg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $0b2e6adb871a3b94$var$ya ? (d = $0b2e6adb871a3b94$var$Tg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $0b2e6adb871a3b94$var$Rg(f.type, f.key, f.props, null, a.mode, h), h.ref = $0b2e6adb871a3b94$var$Lg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $0b2e6adb871a3b94$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $0b2e6adb871a3b94$var$Sg(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $0b2e6adb871a3b94$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($0b2e6adb871a3b94$var$eb(f)) return n(a, d, f, h);
            if ($0b2e6adb871a3b94$var$Ka(f)) return t(a, d, f, h);
            $0b2e6adb871a3b94$var$Mg(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $0b2e6adb871a3b94$var$Qg(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $0b2e6adb871a3b94$var$Ug = $0b2e6adb871a3b94$var$Og(!0), $0b2e6adb871a3b94$var$Vg = $0b2e6adb871a3b94$var$Og(!1), $0b2e6adb871a3b94$var$Wg = $0b2e6adb871a3b94$var$Uf(null), $0b2e6adb871a3b94$var$Xg = null, $0b2e6adb871a3b94$var$Yg = null, $0b2e6adb871a3b94$var$Zg = null;
function $0b2e6adb871a3b94$var$$g() {
    $0b2e6adb871a3b94$var$Zg = $0b2e6adb871a3b94$var$Yg = $0b2e6adb871a3b94$var$Xg = null;
}
function $0b2e6adb871a3b94$var$ah(a) {
    var b = $0b2e6adb871a3b94$var$Wg.current;
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wg);
    a._currentValue = b;
}
function $0b2e6adb871a3b94$var$bh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $0b2e6adb871a3b94$var$ch(a, b) {
    $0b2e6adb871a3b94$var$Xg = a;
    $0b2e6adb871a3b94$var$Zg = $0b2e6adb871a3b94$var$Yg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($0b2e6adb871a3b94$var$dh = !0), a.firstContext = null);
}
function $0b2e6adb871a3b94$var$eh(a) {
    var b = a._currentValue;
    if ($0b2e6adb871a3b94$var$Zg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $0b2e6adb871a3b94$var$Yg) {
            if (null === $0b2e6adb871a3b94$var$Xg) throw Error($0b2e6adb871a3b94$var$p(308));
            $0b2e6adb871a3b94$var$Yg = a;
            $0b2e6adb871a3b94$var$Xg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $0b2e6adb871a3b94$var$Yg = $0b2e6adb871a3b94$var$Yg.next = a;
    }
    return b;
}
var $0b2e6adb871a3b94$var$fh = null;
function $0b2e6adb871a3b94$var$gh(a) {
    null === $0b2e6adb871a3b94$var$fh ? $0b2e6adb871a3b94$var$fh = [
        a
    ] : $0b2e6adb871a3b94$var$fh.push(a);
}
function $0b2e6adb871a3b94$var$hh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $0b2e6adb871a3b94$var$gh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $0b2e6adb871a3b94$var$ih(a, d);
}
function $0b2e6adb871a3b94$var$ih(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $0b2e6adb871a3b94$var$jh = !1;
function $0b2e6adb871a3b94$var$kh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $0b2e6adb871a3b94$var$lh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $0b2e6adb871a3b94$var$mh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $0b2e6adb871a3b94$var$nh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($0b2e6adb871a3b94$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $0b2e6adb871a3b94$var$ih(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $0b2e6adb871a3b94$var$gh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $0b2e6adb871a3b94$var$ih(a, c);
}
function $0b2e6adb871a3b94$var$oh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $0b2e6adb871a3b94$var$Cc(a, c);
    }
}
function $0b2e6adb871a3b94$var$ph(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $0b2e6adb871a3b94$var$qh(a, b, c, d) {
    var e = a.updateQueue;
    $0b2e6adb871a3b94$var$jh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $0b2e6adb871a3b94$var$A({}, q, r);
                            break a;
                        case 2:
                            $0b2e6adb871a3b94$var$jh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $0b2e6adb871a3b94$var$rh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $0b2e6adb871a3b94$var$sh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($0b2e6adb871a3b94$var$p(191, e));
            e.call(d);
        }
    }
}
var $0b2e6adb871a3b94$var$th = {}, $0b2e6adb871a3b94$var$uh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$th), $0b2e6adb871a3b94$var$vh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$th), $0b2e6adb871a3b94$var$wh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$th);
function $0b2e6adb871a3b94$var$xh(a) {
    if (a === $0b2e6adb871a3b94$var$th) throw Error($0b2e6adb871a3b94$var$p(174));
    return a;
}
function $0b2e6adb871a3b94$var$yh(a, b) {
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$wh, b);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$vh, a);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$uh, $0b2e6adb871a3b94$var$th);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $0b2e6adb871a3b94$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $0b2e6adb871a3b94$var$lb(b, a);
    }
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$uh);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$uh, b);
}
function $0b2e6adb871a3b94$var$zh() {
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$uh);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$vh);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$wh);
}
function $0b2e6adb871a3b94$var$Ah(a) {
    $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$wh.current);
    var b = $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$uh.current);
    var c = $0b2e6adb871a3b94$var$lb(b, a.type);
    b !== c && ($0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$vh, a), $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$uh, c));
}
function $0b2e6adb871a3b94$var$Bh(a) {
    $0b2e6adb871a3b94$var$vh.current === a && ($0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$uh), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$vh));
}
var $0b2e6adb871a3b94$var$L = $0b2e6adb871a3b94$var$Uf(0);
function $0b2e6adb871a3b94$var$Ch(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$Dh = [];
function $0b2e6adb871a3b94$var$Eh() {
    for(var a = 0; a < $0b2e6adb871a3b94$var$Dh.length; a++)$0b2e6adb871a3b94$var$Dh[a]._workInProgressVersionPrimary = null;
    $0b2e6adb871a3b94$var$Dh.length = 0;
}
var $0b2e6adb871a3b94$var$Fh = $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher, $0b2e6adb871a3b94$var$Gh = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$Hh = 0, $0b2e6adb871a3b94$var$M = null, $0b2e6adb871a3b94$var$N = null, $0b2e6adb871a3b94$var$O = null, $0b2e6adb871a3b94$var$Ih = !1, $0b2e6adb871a3b94$var$Jh = !1, $0b2e6adb871a3b94$var$Kh = 0, $0b2e6adb871a3b94$var$Lh = 0;
function $0b2e6adb871a3b94$var$P() {
    throw Error($0b2e6adb871a3b94$var$p(321));
}
function $0b2e6adb871a3b94$var$Mh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$0b2e6adb871a3b94$var$He(a[c], b[c])) return !1;
    return !0;
}
function $0b2e6adb871a3b94$var$Nh(a, b, c, d, e, f) {
    $0b2e6adb871a3b94$var$Hh = f;
    $0b2e6adb871a3b94$var$M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $0b2e6adb871a3b94$var$Fh.current = null === a || null === a.memoizedState ? $0b2e6adb871a3b94$var$Oh : $0b2e6adb871a3b94$var$Ph;
    a = c(d, e);
    if ($0b2e6adb871a3b94$var$Jh) {
        f = 0;
        do {
            $0b2e6adb871a3b94$var$Jh = !1;
            $0b2e6adb871a3b94$var$Kh = 0;
            if (25 <= f) throw Error($0b2e6adb871a3b94$var$p(301));
            f += 1;
            $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$N = null;
            b.updateQueue = null;
            $0b2e6adb871a3b94$var$Fh.current = $0b2e6adb871a3b94$var$Qh;
            a = c(d, e);
        }while ($0b2e6adb871a3b94$var$Jh);
    }
    $0b2e6adb871a3b94$var$Fh.current = $0b2e6adb871a3b94$var$Rh;
    b = null !== $0b2e6adb871a3b94$var$N && null !== $0b2e6adb871a3b94$var$N.next;
    $0b2e6adb871a3b94$var$Hh = 0;
    $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$N = $0b2e6adb871a3b94$var$M = null;
    $0b2e6adb871a3b94$var$Ih = !1;
    if (b) throw Error($0b2e6adb871a3b94$var$p(300));
    return a;
}
function $0b2e6adb871a3b94$var$Sh() {
    var a = 0 !== $0b2e6adb871a3b94$var$Kh;
    $0b2e6adb871a3b94$var$Kh = 0;
    return a;
}
function $0b2e6adb871a3b94$var$Th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $0b2e6adb871a3b94$var$O ? $0b2e6adb871a3b94$var$M.memoizedState = $0b2e6adb871a3b94$var$O = a : $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$O.next = a;
    return $0b2e6adb871a3b94$var$O;
}
function $0b2e6adb871a3b94$var$Uh() {
    if (null === $0b2e6adb871a3b94$var$N) {
        var a = $0b2e6adb871a3b94$var$M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $0b2e6adb871a3b94$var$N.next;
    var b = null === $0b2e6adb871a3b94$var$O ? $0b2e6adb871a3b94$var$M.memoizedState : $0b2e6adb871a3b94$var$O.next;
    if (null !== b) $0b2e6adb871a3b94$var$O = b, $0b2e6adb871a3b94$var$N = a;
    else {
        if (null === a) throw Error($0b2e6adb871a3b94$var$p(310));
        $0b2e6adb871a3b94$var$N = a;
        a = {
            memoizedState: $0b2e6adb871a3b94$var$N.memoizedState,
            baseState: $0b2e6adb871a3b94$var$N.baseState,
            baseQueue: $0b2e6adb871a3b94$var$N.baseQueue,
            queue: $0b2e6adb871a3b94$var$N.queue,
            next: null
        };
        null === $0b2e6adb871a3b94$var$O ? $0b2e6adb871a3b94$var$M.memoizedState = $0b2e6adb871a3b94$var$O = a : $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$O.next = a;
    }
    return $0b2e6adb871a3b94$var$O;
}
function $0b2e6adb871a3b94$var$Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $0b2e6adb871a3b94$var$Wh(a) {
    var b = $0b2e6adb871a3b94$var$Uh(), c = b.queue;
    if (null === c) throw Error($0b2e6adb871a3b94$var$p(311));
    c.lastRenderedReducer = a;
    var d = $0b2e6adb871a3b94$var$N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($0b2e6adb871a3b94$var$Hh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $0b2e6adb871a3b94$var$M.lanes |= m;
                $0b2e6adb871a3b94$var$rh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $0b2e6adb871a3b94$var$He(d, b.memoizedState) || ($0b2e6adb871a3b94$var$dh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $0b2e6adb871a3b94$var$M.lanes |= f, $0b2e6adb871a3b94$var$rh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $0b2e6adb871a3b94$var$Xh(a) {
    var b = $0b2e6adb871a3b94$var$Uh(), c = b.queue;
    if (null === c) throw Error($0b2e6adb871a3b94$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $0b2e6adb871a3b94$var$He(f, b.memoizedState) || ($0b2e6adb871a3b94$var$dh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $0b2e6adb871a3b94$var$Yh() {}
function $0b2e6adb871a3b94$var$Zh(a, b) {
    var c = $0b2e6adb871a3b94$var$M, d = $0b2e6adb871a3b94$var$Uh(), e = b(), f = !$0b2e6adb871a3b94$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $0b2e6adb871a3b94$var$dh = !0);
    d = d.queue;
    $0b2e6adb871a3b94$var$$h($0b2e6adb871a3b94$var$ai.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $0b2e6adb871a3b94$var$O && $0b2e6adb871a3b94$var$O.memoizedState.tag & 1) {
        c.flags |= 2048;
        $0b2e6adb871a3b94$var$bi(9, $0b2e6adb871a3b94$var$ci.bind(null, c, d, e, b), void 0, null);
        if (null === $0b2e6adb871a3b94$var$Q) throw Error($0b2e6adb871a3b94$var$p(349));
        0 !== ($0b2e6adb871a3b94$var$Hh & 30) || $0b2e6adb871a3b94$var$di(c, b, e);
    }
    return e;
}
function $0b2e6adb871a3b94$var$di(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $0b2e6adb871a3b94$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $0b2e6adb871a3b94$var$M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $0b2e6adb871a3b94$var$ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $0b2e6adb871a3b94$var$ei(b) && $0b2e6adb871a3b94$var$fi(a);
}
function $0b2e6adb871a3b94$var$ai(a, b, c) {
    return c(function() {
        $0b2e6adb871a3b94$var$ei(b) && $0b2e6adb871a3b94$var$fi(a);
    });
}
function $0b2e6adb871a3b94$var$ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$0b2e6adb871a3b94$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $0b2e6adb871a3b94$var$fi(a) {
    var b = $0b2e6adb871a3b94$var$ih(a, 1);
    null !== b && $0b2e6adb871a3b94$var$gi(b, a, 1, -1);
}
function $0b2e6adb871a3b94$var$hi(a) {
    var b = $0b2e6adb871a3b94$var$Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $0b2e6adb871a3b94$var$Vh,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $0b2e6adb871a3b94$var$ii.bind(null, $0b2e6adb871a3b94$var$M, a);
    return [
        b.memoizedState,
        a
    ];
}
function $0b2e6adb871a3b94$var$bi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $0b2e6adb871a3b94$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $0b2e6adb871a3b94$var$M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $0b2e6adb871a3b94$var$ji() {
    return $0b2e6adb871a3b94$var$Uh().memoizedState;
}
function $0b2e6adb871a3b94$var$ki(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$Th();
    $0b2e6adb871a3b94$var$M.flags |= a;
    e.memoizedState = $0b2e6adb871a3b94$var$bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function $0b2e6adb871a3b94$var$li(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$Uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $0b2e6adb871a3b94$var$N) {
        var g = $0b2e6adb871a3b94$var$N.memoizedState;
        f = g.destroy;
        if (null !== d && $0b2e6adb871a3b94$var$Mh(d, g.deps)) {
            e.memoizedState = $0b2e6adb871a3b94$var$bi(b, c, f, d);
            return;
        }
    }
    $0b2e6adb871a3b94$var$M.flags |= a;
    e.memoizedState = $0b2e6adb871a3b94$var$bi(1 | b, c, f, d);
}
function $0b2e6adb871a3b94$var$mi(a, b) {
    return $0b2e6adb871a3b94$var$ki(8390656, 8, a, b);
}
function $0b2e6adb871a3b94$var$$h(a, b) {
    return $0b2e6adb871a3b94$var$li(2048, 8, a, b);
}
function $0b2e6adb871a3b94$var$ni(a, b) {
    return $0b2e6adb871a3b94$var$li(4, 2, a, b);
}
function $0b2e6adb871a3b94$var$oi(a, b) {
    return $0b2e6adb871a3b94$var$li(4, 4, a, b);
}
function $0b2e6adb871a3b94$var$pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $0b2e6adb871a3b94$var$qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $0b2e6adb871a3b94$var$li(4, 4, $0b2e6adb871a3b94$var$pi.bind(null, b, a), c);
}
function $0b2e6adb871a3b94$var$ri() {}
function $0b2e6adb871a3b94$var$si(a, b) {
    var c = $0b2e6adb871a3b94$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $0b2e6adb871a3b94$var$Mh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $0b2e6adb871a3b94$var$ti(a, b) {
    var c = $0b2e6adb871a3b94$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $0b2e6adb871a3b94$var$Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $0b2e6adb871a3b94$var$ui(a, b, c) {
    if (0 === ($0b2e6adb871a3b94$var$Hh & 21)) return a.baseState && (a.baseState = !1, $0b2e6adb871a3b94$var$dh = !0), a.memoizedState = c;
    $0b2e6adb871a3b94$var$He(c, b) || (c = $0b2e6adb871a3b94$var$yc(), $0b2e6adb871a3b94$var$M.lanes |= c, $0b2e6adb871a3b94$var$rh |= c, a.baseState = !0);
    return b;
}
function $0b2e6adb871a3b94$var$vi(a, b) {
    var c = $0b2e6adb871a3b94$var$C;
    $0b2e6adb871a3b94$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $0b2e6adb871a3b94$var$Gh.transition;
    $0b2e6adb871a3b94$var$Gh.transition = {};
    try {
        a(!1), b();
    } finally{
        $0b2e6adb871a3b94$var$C = c, $0b2e6adb871a3b94$var$Gh.transition = d;
    }
}
function $0b2e6adb871a3b94$var$wi() {
    return $0b2e6adb871a3b94$var$Uh().memoizedState;
}
function $0b2e6adb871a3b94$var$xi(a, b, c) {
    var d = $0b2e6adb871a3b94$var$yi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($0b2e6adb871a3b94$var$zi(a)) $0b2e6adb871a3b94$var$Ai(b, c);
    else if (c = $0b2e6adb871a3b94$var$hh(a, b, c, d), null !== c) {
        var e = $0b2e6adb871a3b94$var$R();
        $0b2e6adb871a3b94$var$gi(c, a, d, e);
        $0b2e6adb871a3b94$var$Bi(c, b, d);
    }
}
function $0b2e6adb871a3b94$var$ii(a, b, c) {
    var d = $0b2e6adb871a3b94$var$yi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($0b2e6adb871a3b94$var$zi(a)) $0b2e6adb871a3b94$var$Ai(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($0b2e6adb871a3b94$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $0b2e6adb871a3b94$var$gh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $0b2e6adb871a3b94$var$hh(a, b, e, d);
        null !== c && (e = $0b2e6adb871a3b94$var$R(), $0b2e6adb871a3b94$var$gi(c, a, d, e), $0b2e6adb871a3b94$var$Bi(c, b, d));
    }
}
function $0b2e6adb871a3b94$var$zi(a) {
    var b = a.alternate;
    return a === $0b2e6adb871a3b94$var$M || null !== b && b === $0b2e6adb871a3b94$var$M;
}
function $0b2e6adb871a3b94$var$Ai(a, b) {
    $0b2e6adb871a3b94$var$Jh = $0b2e6adb871a3b94$var$Ih = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $0b2e6adb871a3b94$var$Bi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $0b2e6adb871a3b94$var$Cc(a, c);
    }
}
var $0b2e6adb871a3b94$var$Rh = {
    readContext: $0b2e6adb871a3b94$var$eh,
    useCallback: $0b2e6adb871a3b94$var$P,
    useContext: $0b2e6adb871a3b94$var$P,
    useEffect: $0b2e6adb871a3b94$var$P,
    useImperativeHandle: $0b2e6adb871a3b94$var$P,
    useInsertionEffect: $0b2e6adb871a3b94$var$P,
    useLayoutEffect: $0b2e6adb871a3b94$var$P,
    useMemo: $0b2e6adb871a3b94$var$P,
    useReducer: $0b2e6adb871a3b94$var$P,
    useRef: $0b2e6adb871a3b94$var$P,
    useState: $0b2e6adb871a3b94$var$P,
    useDebugValue: $0b2e6adb871a3b94$var$P,
    useDeferredValue: $0b2e6adb871a3b94$var$P,
    useTransition: $0b2e6adb871a3b94$var$P,
    useMutableSource: $0b2e6adb871a3b94$var$P,
    useSyncExternalStore: $0b2e6adb871a3b94$var$P,
    useId: $0b2e6adb871a3b94$var$P,
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$Oh = {
    readContext: $0b2e6adb871a3b94$var$eh,
    useCallback: function(a, b) {
        $0b2e6adb871a3b94$var$Th().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $0b2e6adb871a3b94$var$eh,
    useEffect: $0b2e6adb871a3b94$var$mi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $0b2e6adb871a3b94$var$ki(4194308, 4, $0b2e6adb871a3b94$var$pi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $0b2e6adb871a3b94$var$ki(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $0b2e6adb871a3b94$var$ki(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $0b2e6adb871a3b94$var$Th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $0b2e6adb871a3b94$var$Th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $0b2e6adb871a3b94$var$xi.bind(null, $0b2e6adb871a3b94$var$M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $0b2e6adb871a3b94$var$Th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $0b2e6adb871a3b94$var$hi,
    useDebugValue: $0b2e6adb871a3b94$var$ri,
    useDeferredValue: function(a) {
        return $0b2e6adb871a3b94$var$Th().memoizedState = a;
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$hi(!1), b = a[0];
        a = $0b2e6adb871a3b94$var$vi.bind(null, a[1]);
        $0b2e6adb871a3b94$var$Th().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $0b2e6adb871a3b94$var$M, e = $0b2e6adb871a3b94$var$Th();
        if ($0b2e6adb871a3b94$var$I) {
            if (void 0 === c) throw Error($0b2e6adb871a3b94$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $0b2e6adb871a3b94$var$Q) throw Error($0b2e6adb871a3b94$var$p(349));
            0 !== ($0b2e6adb871a3b94$var$Hh & 30) || $0b2e6adb871a3b94$var$di(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $0b2e6adb871a3b94$var$mi($0b2e6adb871a3b94$var$ai.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $0b2e6adb871a3b94$var$bi(9, $0b2e6adb871a3b94$var$ci.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $0b2e6adb871a3b94$var$Th(), b = $0b2e6adb871a3b94$var$Q.identifierPrefix;
        if ($0b2e6adb871a3b94$var$I) {
            var c = $0b2e6adb871a3b94$var$sg;
            var d = $0b2e6adb871a3b94$var$rg;
            c = (d & ~(1 << 32 - $0b2e6adb871a3b94$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $0b2e6adb871a3b94$var$Kh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $0b2e6adb871a3b94$var$Lh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$Ph = {
    readContext: $0b2e6adb871a3b94$var$eh,
    useCallback: $0b2e6adb871a3b94$var$si,
    useContext: $0b2e6adb871a3b94$var$eh,
    useEffect: $0b2e6adb871a3b94$var$$h,
    useImperativeHandle: $0b2e6adb871a3b94$var$qi,
    useInsertionEffect: $0b2e6adb871a3b94$var$ni,
    useLayoutEffect: $0b2e6adb871a3b94$var$oi,
    useMemo: $0b2e6adb871a3b94$var$ti,
    useReducer: $0b2e6adb871a3b94$var$Wh,
    useRef: $0b2e6adb871a3b94$var$ji,
    useState: function() {
        return $0b2e6adb871a3b94$var$Wh($0b2e6adb871a3b94$var$Vh);
    },
    useDebugValue: $0b2e6adb871a3b94$var$ri,
    useDeferredValue: function(a) {
        var b = $0b2e6adb871a3b94$var$Uh();
        return $0b2e6adb871a3b94$var$ui(b, $0b2e6adb871a3b94$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$Wh($0b2e6adb871a3b94$var$Vh)[0], b = $0b2e6adb871a3b94$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $0b2e6adb871a3b94$var$Yh,
    useSyncExternalStore: $0b2e6adb871a3b94$var$Zh,
    useId: $0b2e6adb871a3b94$var$wi,
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$Qh = {
    readContext: $0b2e6adb871a3b94$var$eh,
    useCallback: $0b2e6adb871a3b94$var$si,
    useContext: $0b2e6adb871a3b94$var$eh,
    useEffect: $0b2e6adb871a3b94$var$$h,
    useImperativeHandle: $0b2e6adb871a3b94$var$qi,
    useInsertionEffect: $0b2e6adb871a3b94$var$ni,
    useLayoutEffect: $0b2e6adb871a3b94$var$oi,
    useMemo: $0b2e6adb871a3b94$var$ti,
    useReducer: $0b2e6adb871a3b94$var$Xh,
    useRef: $0b2e6adb871a3b94$var$ji,
    useState: function() {
        return $0b2e6adb871a3b94$var$Xh($0b2e6adb871a3b94$var$Vh);
    },
    useDebugValue: $0b2e6adb871a3b94$var$ri,
    useDeferredValue: function(a) {
        var b = $0b2e6adb871a3b94$var$Uh();
        return null === $0b2e6adb871a3b94$var$N ? b.memoizedState = a : $0b2e6adb871a3b94$var$ui(b, $0b2e6adb871a3b94$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$Xh($0b2e6adb871a3b94$var$Vh)[0], b = $0b2e6adb871a3b94$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $0b2e6adb871a3b94$var$Yh,
    useSyncExternalStore: $0b2e6adb871a3b94$var$Zh,
    useId: $0b2e6adb871a3b94$var$wi,
    unstable_isNewReconciler: !1
};
function $0b2e6adb871a3b94$var$Ci(a, b) {
    if (a && a.defaultProps) {
        b = $0b2e6adb871a3b94$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $0b2e6adb871a3b94$var$Di(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $0b2e6adb871a3b94$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $0b2e6adb871a3b94$var$Ei = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $0b2e6adb871a3b94$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $0b2e6adb871a3b94$var$R(), e = $0b2e6adb871a3b94$var$yi(a), f = $0b2e6adb871a3b94$var$mh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $0b2e6adb871a3b94$var$nh(a, f, e);
        null !== b && ($0b2e6adb871a3b94$var$gi(b, a, e, d), $0b2e6adb871a3b94$var$oh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $0b2e6adb871a3b94$var$R(), e = $0b2e6adb871a3b94$var$yi(a), f = $0b2e6adb871a3b94$var$mh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $0b2e6adb871a3b94$var$nh(a, f, e);
        null !== b && ($0b2e6adb871a3b94$var$gi(b, a, e, d), $0b2e6adb871a3b94$var$oh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $0b2e6adb871a3b94$var$R(), d = $0b2e6adb871a3b94$var$yi(a), e = $0b2e6adb871a3b94$var$mh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $0b2e6adb871a3b94$var$nh(a, e, d);
        null !== b && ($0b2e6adb871a3b94$var$gi(b, a, d, c), $0b2e6adb871a3b94$var$oh(b, a, d));
    }
};
function $0b2e6adb871a3b94$var$Fi(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$0b2e6adb871a3b94$var$Ie(c, d) || !$0b2e6adb871a3b94$var$Ie(e, f) : !0;
}
function $0b2e6adb871a3b94$var$Gi(a, b, c) {
    var d = !1, e = $0b2e6adb871a3b94$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $0b2e6adb871a3b94$var$eh(f) : (e = $0b2e6adb871a3b94$var$Zf(b) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $0b2e6adb871a3b94$var$Yf(a, e) : $0b2e6adb871a3b94$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $0b2e6adb871a3b94$var$Ei;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $0b2e6adb871a3b94$var$Hi(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $0b2e6adb871a3b94$var$Ei.enqueueReplaceState(b, b.state, null);
}
function $0b2e6adb871a3b94$var$Ii(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    $0b2e6adb871a3b94$var$kh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $0b2e6adb871a3b94$var$eh(f) : (f = $0b2e6adb871a3b94$var$Zf(b) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, e.context = $0b2e6adb871a3b94$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($0b2e6adb871a3b94$var$Di(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $0b2e6adb871a3b94$var$Ei.enqueueReplaceState(e, e.state, null), $0b2e6adb871a3b94$var$qh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $0b2e6adb871a3b94$var$Ji(a, b) {
    try {
        var c = "", d = b;
        do c += $0b2e6adb871a3b94$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $0b2e6adb871a3b94$var$Ki(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $0b2e6adb871a3b94$var$Li(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $0b2e6adb871a3b94$var$Mi = "function" === typeof WeakMap ? WeakMap : Map;
function $0b2e6adb871a3b94$var$Ni(a, b, c) {
    c = $0b2e6adb871a3b94$var$mh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $0b2e6adb871a3b94$var$Oi || ($0b2e6adb871a3b94$var$Oi = !0, $0b2e6adb871a3b94$var$Pi = d);
        $0b2e6adb871a3b94$var$Li(a, b);
    };
    return c;
}
function $0b2e6adb871a3b94$var$Qi(a, b, c) {
    c = $0b2e6adb871a3b94$var$mh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $0b2e6adb871a3b94$var$Li(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $0b2e6adb871a3b94$var$Li(a, b);
        "function" !== typeof d && (null === $0b2e6adb871a3b94$var$Ri ? $0b2e6adb871a3b94$var$Ri = new Set([
            this
        ]) : $0b2e6adb871a3b94$var$Ri.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $0b2e6adb871a3b94$var$Si(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $0b2e6adb871a3b94$var$Mi;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $0b2e6adb871a3b94$var$Ti.bind(null, a, b, c), b.then(a, a));
}
function $0b2e6adb871a3b94$var$Ui(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $0b2e6adb871a3b94$var$Vi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $0b2e6adb871a3b94$var$mh(-1, 1), b.tag = 2, $0b2e6adb871a3b94$var$nh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $0b2e6adb871a3b94$var$Wi = $0b2e6adb871a3b94$var$ua.ReactCurrentOwner, $0b2e6adb871a3b94$var$dh = !1;
function $0b2e6adb871a3b94$var$Xi(a, b, c, d) {
    b.child = null === a ? $0b2e6adb871a3b94$var$Vg(b, null, c, d) : $0b2e6adb871a3b94$var$Ug(b, a.child, c, d);
}
function $0b2e6adb871a3b94$var$Yi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $0b2e6adb871a3b94$var$ch(b, e);
    d = $0b2e6adb871a3b94$var$Nh(a, b, c, d, f, e);
    c = $0b2e6adb871a3b94$var$Sh();
    if (null !== a && !$0b2e6adb871a3b94$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $0b2e6adb871a3b94$var$Zi(a, b, e);
    $0b2e6adb871a3b94$var$I && c && $0b2e6adb871a3b94$var$vg(b);
    b.flags |= 1;
    $0b2e6adb871a3b94$var$Xi(a, b, d, e);
    return b.child;
}
function $0b2e6adb871a3b94$var$$i(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$0b2e6adb871a3b94$var$aj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $0b2e6adb871a3b94$var$bj(a, b, f, d, e);
        a = $0b2e6adb871a3b94$var$Rg(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $0b2e6adb871a3b94$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $0b2e6adb871a3b94$var$Zi(a, b, e);
    }
    b.flags |= 1;
    a = $0b2e6adb871a3b94$var$Pg(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $0b2e6adb871a3b94$var$bj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($0b2e6adb871a3b94$var$Ie(f, d) && a.ref === b.ref) {
            if ($0b2e6adb871a3b94$var$dh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($0b2e6adb871a3b94$var$dh = !0);
            else return b.lanes = a.lanes, $0b2e6adb871a3b94$var$Zi(a, b, e);
        }
    }
    return $0b2e6adb871a3b94$var$cj(a, b, c, d, e);
}
function $0b2e6adb871a3b94$var$dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$ej, $0b2e6adb871a3b94$var$fj), $0b2e6adb871a3b94$var$fj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$ej, $0b2e6adb871a3b94$var$fj), $0b2e6adb871a3b94$var$fj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$ej, $0b2e6adb871a3b94$var$fj);
            $0b2e6adb871a3b94$var$fj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$ej, $0b2e6adb871a3b94$var$fj), $0b2e6adb871a3b94$var$fj |= d;
    $0b2e6adb871a3b94$var$Xi(a, b, e, c);
    return b.child;
}
function $0b2e6adb871a3b94$var$gj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $0b2e6adb871a3b94$var$cj(a, b, c, d, e) {
    var f = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current;
    f = $0b2e6adb871a3b94$var$Yf(b, f);
    $0b2e6adb871a3b94$var$ch(b, e);
    c = $0b2e6adb871a3b94$var$Nh(a, b, c, d, f, e);
    d = $0b2e6adb871a3b94$var$Sh();
    if (null !== a && !$0b2e6adb871a3b94$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $0b2e6adb871a3b94$var$Zi(a, b, e);
    $0b2e6adb871a3b94$var$I && d && $0b2e6adb871a3b94$var$vg(b);
    b.flags |= 1;
    $0b2e6adb871a3b94$var$Xi(a, b, c, e);
    return b.child;
}
function $0b2e6adb871a3b94$var$hj(a, b, c, d, e) {
    if ($0b2e6adb871a3b94$var$Zf(c)) {
        var f = !0;
        $0b2e6adb871a3b94$var$cg(b);
    } else f = !1;
    $0b2e6adb871a3b94$var$ch(b, e);
    if (null === b.stateNode) $0b2e6adb871a3b94$var$ij(a, b), $0b2e6adb871a3b94$var$Gi(b, c, d), $0b2e6adb871a3b94$var$Ii(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $0b2e6adb871a3b94$var$eh(l) : (l = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, l = $0b2e6adb871a3b94$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $0b2e6adb871a3b94$var$Hi(b, g, d, l);
        $0b2e6adb871a3b94$var$jh = !1;
        var r = b.memoizedState;
        g.state = r;
        $0b2e6adb871a3b94$var$qh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $0b2e6adb871a3b94$var$Wf.current || $0b2e6adb871a3b94$var$jh ? ("function" === typeof m && ($0b2e6adb871a3b94$var$Di(b, c, m, d), k = b.memoizedState), (h = $0b2e6adb871a3b94$var$jh || $0b2e6adb871a3b94$var$Fi(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $0b2e6adb871a3b94$var$lh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $0b2e6adb871a3b94$var$Ci(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $0b2e6adb871a3b94$var$eh(k) : (k = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, k = $0b2e6adb871a3b94$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $0b2e6adb871a3b94$var$Hi(b, g, d, k);
        $0b2e6adb871a3b94$var$jh = !1;
        r = b.memoizedState;
        g.state = r;
        $0b2e6adb871a3b94$var$qh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $0b2e6adb871a3b94$var$Wf.current || $0b2e6adb871a3b94$var$jh ? ("function" === typeof y && ($0b2e6adb871a3b94$var$Di(b, c, y, d), n = b.memoizedState), (l = $0b2e6adb871a3b94$var$jh || $0b2e6adb871a3b94$var$Fi(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $0b2e6adb871a3b94$var$jj(a, b, c, d, f, e);
}
function $0b2e6adb871a3b94$var$jj(a, b, c, d, e, f) {
    $0b2e6adb871a3b94$var$gj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $0b2e6adb871a3b94$var$dg(b, c, !1), $0b2e6adb871a3b94$var$Zi(a, b, f);
    d = b.stateNode;
    $0b2e6adb871a3b94$var$Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $0b2e6adb871a3b94$var$Ug(b, a.child, null, f), b.child = $0b2e6adb871a3b94$var$Ug(b, null, h, f)) : $0b2e6adb871a3b94$var$Xi(a, b, h, f);
    b.memoizedState = d.state;
    e && $0b2e6adb871a3b94$var$dg(b, c, !0);
    return b.child;
}
function $0b2e6adb871a3b94$var$kj(a) {
    var b = a.stateNode;
    b.pendingContext ? $0b2e6adb871a3b94$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $0b2e6adb871a3b94$var$ag(a, b.context, !1);
    $0b2e6adb871a3b94$var$yh(a, b.containerInfo);
}
function $0b2e6adb871a3b94$var$lj(a, b, c, d, e) {
    $0b2e6adb871a3b94$var$Ig();
    $0b2e6adb871a3b94$var$Jg(e);
    b.flags |= 256;
    $0b2e6adb871a3b94$var$Xi(a, b, c, d);
    return b.child;
}
var $0b2e6adb871a3b94$var$mj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $0b2e6adb871a3b94$var$nj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $0b2e6adb871a3b94$var$oj(a, b, c) {
    var d = b.pendingProps, e = $0b2e6adb871a3b94$var$L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, e & 1);
    if (null === a) {
        $0b2e6adb871a3b94$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $0b2e6adb871a3b94$var$pj(g, d, 0, null), a = $0b2e6adb871a3b94$var$Tg(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $0b2e6adb871a3b94$var$nj(c), b.memoizedState = $0b2e6adb871a3b94$var$mj, a) : $0b2e6adb871a3b94$var$qj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $0b2e6adb871a3b94$var$rj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $0b2e6adb871a3b94$var$Pg(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $0b2e6adb871a3b94$var$Pg(h, f) : (f = $0b2e6adb871a3b94$var$Tg(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $0b2e6adb871a3b94$var$nj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $0b2e6adb871a3b94$var$mj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $0b2e6adb871a3b94$var$Pg(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $0b2e6adb871a3b94$var$qj(a, b) {
    b = $0b2e6adb871a3b94$var$pj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $0b2e6adb871a3b94$var$sj(a, b, c, d) {
    null !== d && $0b2e6adb871a3b94$var$Jg(d);
    $0b2e6adb871a3b94$var$Ug(b, a.child, null, c);
    a = $0b2e6adb871a3b94$var$qj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $0b2e6adb871a3b94$var$rj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $0b2e6adb871a3b94$var$Ki(Error($0b2e6adb871a3b94$var$p(422))), $0b2e6adb871a3b94$var$sj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $0b2e6adb871a3b94$var$pj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $0b2e6adb871a3b94$var$Tg(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $0b2e6adb871a3b94$var$Ug(b, a.child, null, g);
        b.child.memoizedState = $0b2e6adb871a3b94$var$nj(g);
        b.memoizedState = $0b2e6adb871a3b94$var$mj;
        return f;
    }
    if (0 === (b.mode & 1)) return $0b2e6adb871a3b94$var$sj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($0b2e6adb871a3b94$var$p(419));
        d = $0b2e6adb871a3b94$var$Ki(f, d, void 0);
        return $0b2e6adb871a3b94$var$sj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($0b2e6adb871a3b94$var$dh || h) {
        d = $0b2e6adb871a3b94$var$Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $0b2e6adb871a3b94$var$ih(a, e), $0b2e6adb871a3b94$var$gi(d, a, e, -1));
        }
        $0b2e6adb871a3b94$var$tj();
        d = $0b2e6adb871a3b94$var$Ki(Error($0b2e6adb871a3b94$var$p(421)));
        return $0b2e6adb871a3b94$var$sj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $0b2e6adb871a3b94$var$uj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(e.nextSibling);
    $0b2e6adb871a3b94$var$xg = b;
    $0b2e6adb871a3b94$var$I = !0;
    $0b2e6adb871a3b94$var$zg = null;
    null !== a && ($0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$rg, $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$sg, $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$qg, $0b2e6adb871a3b94$var$rg = a.id, $0b2e6adb871a3b94$var$sg = a.overflow, $0b2e6adb871a3b94$var$qg = b);
    b = $0b2e6adb871a3b94$var$qj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $0b2e6adb871a3b94$var$vj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $0b2e6adb871a3b94$var$bh(a.return, b, c);
}
function $0b2e6adb871a3b94$var$wj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $0b2e6adb871a3b94$var$xj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $0b2e6adb871a3b94$var$Xi(a, b, d.children, c);
    d = $0b2e6adb871a3b94$var$L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $0b2e6adb871a3b94$var$vj(a, c, b);
            else if (19 === a.tag) $0b2e6adb871a3b94$var$vj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $0b2e6adb871a3b94$var$Ch(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $0b2e6adb871a3b94$var$wj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $0b2e6adb871a3b94$var$Ch(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $0b2e6adb871a3b94$var$wj(b, !0, c, null, f);
            break;
        case "together":
            $0b2e6adb871a3b94$var$wj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $0b2e6adb871a3b94$var$ij(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $0b2e6adb871a3b94$var$Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $0b2e6adb871a3b94$var$rh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($0b2e6adb871a3b94$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $0b2e6adb871a3b94$var$Pg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $0b2e6adb871a3b94$var$Pg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $0b2e6adb871a3b94$var$yj(a, b, c) {
    switch(b.tag){
        case 3:
            $0b2e6adb871a3b94$var$kj(b);
            $0b2e6adb871a3b94$var$Ig();
            break;
        case 5:
            $0b2e6adb871a3b94$var$Ah(b);
            break;
        case 1:
            $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$cg(b);
            break;
        case 4:
            $0b2e6adb871a3b94$var$yh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $0b2e6adb871a3b94$var$oj(a, b, c);
                $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current & 1);
                a = $0b2e6adb871a3b94$var$Zi(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $0b2e6adb871a3b94$var$xj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $0b2e6adb871a3b94$var$dj(a, b, c);
    }
    return $0b2e6adb871a3b94$var$Zi(a, b, c);
}
var $0b2e6adb871a3b94$var$zj, $0b2e6adb871a3b94$var$Aj, $0b2e6adb871a3b94$var$Bj, $0b2e6adb871a3b94$var$Cj;
$0b2e6adb871a3b94$var$zj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$0b2e6adb871a3b94$var$Aj = function() {};
$0b2e6adb871a3b94$var$Bj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$uh.current);
        var f = null;
        switch(c){
            case "input":
                e = $0b2e6adb871a3b94$var$Ya(a, e);
                d = $0b2e6adb871a3b94$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $0b2e6adb871a3b94$var$A({}, e, {
                    value: void 0
                });
                d = $0b2e6adb871a3b94$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $0b2e6adb871a3b94$var$gb(a, e);
                d = $0b2e6adb871a3b94$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $0b2e6adb871a3b94$var$Bf);
        }
        $0b2e6adb871a3b94$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $0b2e6adb871a3b94$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$0b2e6adb871a3b94$var$Cj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $0b2e6adb871a3b94$var$Dj(a, b) {
    if (!$0b2e6adb871a3b94$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $0b2e6adb871a3b94$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $0b2e6adb871a3b94$var$Ej(a, b, c) {
    var d = b.pendingProps;
    $0b2e6adb871a3b94$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $0b2e6adb871a3b94$var$S(b), null;
        case 1:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), $0b2e6adb871a3b94$var$S(b), null;
        case 3:
            d = b.stateNode;
            $0b2e6adb871a3b94$var$zh();
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
            $0b2e6adb871a3b94$var$Eh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $0b2e6adb871a3b94$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $0b2e6adb871a3b94$var$zg && ($0b2e6adb871a3b94$var$Fj($0b2e6adb871a3b94$var$zg), $0b2e6adb871a3b94$var$zg = null));
            $0b2e6adb871a3b94$var$Aj(a, b);
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 5:
            $0b2e6adb871a3b94$var$Bh(b);
            var e = $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$wh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $0b2e6adb871a3b94$var$Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($0b2e6adb871a3b94$var$p(166));
                    $0b2e6adb871a3b94$var$S(b);
                    return null;
                }
                a = $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$uh.current);
                if ($0b2e6adb871a3b94$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$0b2e6adb871a3b94$var$Of] = b;
                    d[$0b2e6adb871a3b94$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $0b2e6adb871a3b94$var$D("cancel", d);
                            $0b2e6adb871a3b94$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $0b2e6adb871a3b94$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $0b2e6adb871a3b94$var$lf.length; e++)$0b2e6adb871a3b94$var$D($0b2e6adb871a3b94$var$lf[e], d);
                            break;
                        case "source":
                            $0b2e6adb871a3b94$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $0b2e6adb871a3b94$var$D("error", d);
                            $0b2e6adb871a3b94$var$D("load", d);
                            break;
                        case "details":
                            $0b2e6adb871a3b94$var$D("toggle", d);
                            break;
                        case "input":
                            $0b2e6adb871a3b94$var$Za(d, f);
                            $0b2e6adb871a3b94$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $0b2e6adb871a3b94$var$D("invalid", d);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$hb(d, f), $0b2e6adb871a3b94$var$D("invalid", d);
                    }
                    $0b2e6adb871a3b94$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $0b2e6adb871a3b94$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $0b2e6adb871a3b94$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $0b2e6adb871a3b94$var$Va(d);
                            $0b2e6adb871a3b94$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$Va(d);
                            $0b2e6adb871a3b94$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $0b2e6adb871a3b94$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $0b2e6adb871a3b94$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$0b2e6adb871a3b94$var$Of] = b;
                    a[$0b2e6adb871a3b94$var$Pf] = d;
                    $0b2e6adb871a3b94$var$zj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $0b2e6adb871a3b94$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $0b2e6adb871a3b94$var$D("cancel", a);
                                $0b2e6adb871a3b94$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $0b2e6adb871a3b94$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $0b2e6adb871a3b94$var$lf.length; e++)$0b2e6adb871a3b94$var$D($0b2e6adb871a3b94$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $0b2e6adb871a3b94$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $0b2e6adb871a3b94$var$D("error", a);
                                $0b2e6adb871a3b94$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $0b2e6adb871a3b94$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $0b2e6adb871a3b94$var$Za(a, d);
                                e = $0b2e6adb871a3b94$var$Ya(a, d);
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $0b2e6adb871a3b94$var$A({}, d, {
                                    value: void 0
                                });
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            case "textarea":
                                $0b2e6adb871a3b94$var$hb(a, d);
                                e = $0b2e6adb871a3b94$var$gb(a, d);
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $0b2e6adb871a3b94$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $0b2e6adb871a3b94$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $0b2e6adb871a3b94$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $0b2e6adb871a3b94$var$ob(a, k) : "number" === typeof k && $0b2e6adb871a3b94$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $0b2e6adb871a3b94$var$D("scroll", a) : null != k && $0b2e6adb871a3b94$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $0b2e6adb871a3b94$var$Va(a);
                                $0b2e6adb871a3b94$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $0b2e6adb871a3b94$var$Va(a);
                                $0b2e6adb871a3b94$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $0b2e6adb871a3b94$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $0b2e6adb871a3b94$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $0b2e6adb871a3b94$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $0b2e6adb871a3b94$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $0b2e6adb871a3b94$var$Cj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($0b2e6adb871a3b94$var$p(166));
                c = $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$wh.current);
                $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$uh.current);
                if ($0b2e6adb871a3b94$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$0b2e6adb871a3b94$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $0b2e6adb871a3b94$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $0b2e6adb871a3b94$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$0b2e6adb871a3b94$var$Of] = b, b.stateNode = d;
            }
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 13:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($0b2e6adb871a3b94$var$I && null !== $0b2e6adb871a3b94$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $0b2e6adb871a3b94$var$Hg(), $0b2e6adb871a3b94$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $0b2e6adb871a3b94$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($0b2e6adb871a3b94$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($0b2e6adb871a3b94$var$p(317));
                        f[$0b2e6adb871a3b94$var$Of] = b;
                    } else $0b2e6adb871a3b94$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $0b2e6adb871a3b94$var$S(b);
                    f = !1;
                } else null !== $0b2e6adb871a3b94$var$zg && ($0b2e6adb871a3b94$var$Fj($0b2e6adb871a3b94$var$zg), $0b2e6adb871a3b94$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($0b2e6adb871a3b94$var$L.current & 1) ? 0 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 3) : $0b2e6adb871a3b94$var$tj()));
            null !== b.updateQueue && (b.flags |= 4);
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 4:
            return $0b2e6adb871a3b94$var$zh(), $0b2e6adb871a3b94$var$Aj(a, b), null === a && $0b2e6adb871a3b94$var$sf(b.stateNode.containerInfo), $0b2e6adb871a3b94$var$S(b), null;
        case 10:
            return $0b2e6adb871a3b94$var$ah(b.type._context), $0b2e6adb871a3b94$var$S(b), null;
        case 17:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), $0b2e6adb871a3b94$var$S(b), null;
        case 19:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
            f = b.memoizedState;
            if (null === f) return $0b2e6adb871a3b94$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $0b2e6adb871a3b94$var$Dj(f, !1);
                else {
                    if (0 !== $0b2e6adb871a3b94$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $0b2e6adb871a3b94$var$Ch(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $0b2e6adb871a3b94$var$Dj(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $0b2e6adb871a3b94$var$B() > $0b2e6adb871a3b94$var$Gj && (b.flags |= 128, d = !0, $0b2e6adb871a3b94$var$Dj(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $0b2e6adb871a3b94$var$Ch(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $0b2e6adb871a3b94$var$Dj(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$0b2e6adb871a3b94$var$I) return $0b2e6adb871a3b94$var$S(b), null;
                    } else 2 * $0b2e6adb871a3b94$var$B() - f.renderingStartTime > $0b2e6adb871a3b94$var$Gj && 1073741824 !== c && (b.flags |= 128, d = !0, $0b2e6adb871a3b94$var$Dj(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $0b2e6adb871a3b94$var$B(), b.sibling = null, c = $0b2e6adb871a3b94$var$L.current, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, d ? c & 1 | 2 : c & 1), b;
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 22:
        case 23:
            return $0b2e6adb871a3b94$var$Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($0b2e6adb871a3b94$var$fj & 1073741824) && ($0b2e6adb871a3b94$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $0b2e6adb871a3b94$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($0b2e6adb871a3b94$var$p(156, b.tag));
}
function $0b2e6adb871a3b94$var$Ij(a, b) {
    $0b2e6adb871a3b94$var$wg(b);
    switch(b.tag){
        case 1:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $0b2e6adb871a3b94$var$zh(), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H), $0b2e6adb871a3b94$var$Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $0b2e6adb871a3b94$var$Bh(b), null;
        case 13:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($0b2e6adb871a3b94$var$p(340));
                $0b2e6adb871a3b94$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L), null;
        case 4:
            return $0b2e6adb871a3b94$var$zh(), null;
        case 10:
            return $0b2e6adb871a3b94$var$ah(b.type._context), null;
        case 22:
        case 23:
            return $0b2e6adb871a3b94$var$Hj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $0b2e6adb871a3b94$var$Jj = !1, $0b2e6adb871a3b94$var$U = !1, $0b2e6adb871a3b94$var$Kj = "function" === typeof WeakSet ? WeakSet : Set, $0b2e6adb871a3b94$var$V = null;
function $0b2e6adb871a3b94$var$Lj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $0b2e6adb871a3b94$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $0b2e6adb871a3b94$var$Mj(a, b, c) {
    try {
        c();
    } catch (d) {
        $0b2e6adb871a3b94$var$W(a, b, d);
    }
}
var $0b2e6adb871a3b94$var$Nj = !1;
function $0b2e6adb871a3b94$var$Oj(a, b) {
    $0b2e6adb871a3b94$var$Cf = $0b2e6adb871a3b94$var$dd;
    a = $0b2e6adb871a3b94$var$Me();
    if ($0b2e6adb871a3b94$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $0b2e6adb871a3b94$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $0b2e6adb871a3b94$var$dd = !1;
    for($0b2e6adb871a3b94$var$V = b; null !== $0b2e6adb871a3b94$var$V;)if (b = $0b2e6adb871a3b94$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $0b2e6adb871a3b94$var$V = a;
    else for(; null !== $0b2e6adb871a3b94$var$V;){
        b = $0b2e6adb871a3b94$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $0b2e6adb871a3b94$var$Ci(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(163));
            }
        } catch (F) {
            $0b2e6adb871a3b94$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $0b2e6adb871a3b94$var$V = a;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
    n = $0b2e6adb871a3b94$var$Nj;
    $0b2e6adb871a3b94$var$Nj = !1;
    return n;
}
function $0b2e6adb871a3b94$var$Pj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $0b2e6adb871a3b94$var$Mj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $0b2e6adb871a3b94$var$Qj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $0b2e6adb871a3b94$var$Rj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $0b2e6adb871a3b94$var$Sj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $0b2e6adb871a3b94$var$Sj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$0b2e6adb871a3b94$var$Of], delete b[$0b2e6adb871a3b94$var$Pf], delete b[$0b2e6adb871a3b94$var$of], delete b[$0b2e6adb871a3b94$var$Qf], delete b[$0b2e6adb871a3b94$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $0b2e6adb871a3b94$var$Tj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $0b2e6adb871a3b94$var$Uj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $0b2e6adb871a3b94$var$Tj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $0b2e6adb871a3b94$var$Vj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $0b2e6adb871a3b94$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($0b2e6adb871a3b94$var$Vj(a, b, c), a = a.sibling; null !== a;)$0b2e6adb871a3b94$var$Vj(a, b, c), a = a.sibling;
}
function $0b2e6adb871a3b94$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($0b2e6adb871a3b94$var$Wj(a, b, c), a = a.sibling; null !== a;)$0b2e6adb871a3b94$var$Wj(a, b, c), a = a.sibling;
}
var $0b2e6adb871a3b94$var$X = null, $0b2e6adb871a3b94$var$Xj = !1;
function $0b2e6adb871a3b94$var$Yj(a, b, c) {
    for(c = c.child; null !== c;)$0b2e6adb871a3b94$var$Zj(a, b, c), c = c.sibling;
}
function $0b2e6adb871a3b94$var$Zj(a, b, c) {
    if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onCommitFiberUnmount) try {
        $0b2e6adb871a3b94$var$lc.onCommitFiberUnmount($0b2e6adb871a3b94$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $0b2e6adb871a3b94$var$U || $0b2e6adb871a3b94$var$Lj(c, b);
        case 6:
            var d = $0b2e6adb871a3b94$var$X, e = $0b2e6adb871a3b94$var$Xj;
            $0b2e6adb871a3b94$var$X = null;
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            $0b2e6adb871a3b94$var$X = d;
            $0b2e6adb871a3b94$var$Xj = e;
            null !== $0b2e6adb871a3b94$var$X && ($0b2e6adb871a3b94$var$Xj ? (a = $0b2e6adb871a3b94$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $0b2e6adb871a3b94$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $0b2e6adb871a3b94$var$X && ($0b2e6adb871a3b94$var$Xj ? (a = $0b2e6adb871a3b94$var$X, c = c.stateNode, 8 === a.nodeType ? $0b2e6adb871a3b94$var$Kf(a.parentNode, c) : 1 === a.nodeType && $0b2e6adb871a3b94$var$Kf(a, c), $0b2e6adb871a3b94$var$bd(a)) : $0b2e6adb871a3b94$var$Kf($0b2e6adb871a3b94$var$X, c.stateNode));
            break;
        case 4:
            d = $0b2e6adb871a3b94$var$X;
            e = $0b2e6adb871a3b94$var$Xj;
            $0b2e6adb871a3b94$var$X = c.stateNode.containerInfo;
            $0b2e6adb871a3b94$var$Xj = !0;
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            $0b2e6adb871a3b94$var$X = d;
            $0b2e6adb871a3b94$var$Xj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$0b2e6adb871a3b94$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $0b2e6adb871a3b94$var$Mj(c, b, g) : 0 !== (f & 4) && $0b2e6adb871a3b94$var$Mj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            break;
        case 1:
            if (!$0b2e6adb871a3b94$var$U && ($0b2e6adb871a3b94$var$Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $0b2e6adb871a3b94$var$W(c, b, h);
            }
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            break;
        case 21:
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($0b2e6adb871a3b94$var$U = (d = $0b2e6adb871a3b94$var$U) || null !== c.memoizedState, $0b2e6adb871a3b94$var$Yj(a, b, c), $0b2e6adb871a3b94$var$U = d) : $0b2e6adb871a3b94$var$Yj(a, b, c);
            break;
        default:
            $0b2e6adb871a3b94$var$Yj(a, b, c);
    }
}
function $0b2e6adb871a3b94$var$ak(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $0b2e6adb871a3b94$var$Kj);
        b.forEach(function(b) {
            var d = $0b2e6adb871a3b94$var$bk.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $0b2e6adb871a3b94$var$ck(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $0b2e6adb871a3b94$var$X = h.stateNode;
                        $0b2e6adb871a3b94$var$Xj = !1;
                        break a;
                    case 3:
                        $0b2e6adb871a3b94$var$X = h.stateNode.containerInfo;
                        $0b2e6adb871a3b94$var$Xj = !0;
                        break a;
                    case 4:
                        $0b2e6adb871a3b94$var$X = h.stateNode.containerInfo;
                        $0b2e6adb871a3b94$var$Xj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $0b2e6adb871a3b94$var$X) throw Error($0b2e6adb871a3b94$var$p(160));
            $0b2e6adb871a3b94$var$Zj(f, g, e);
            $0b2e6adb871a3b94$var$X = null;
            $0b2e6adb871a3b94$var$Xj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $0b2e6adb871a3b94$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$0b2e6adb871a3b94$var$dk(b, a), b = b.sibling;
}
function $0b2e6adb871a3b94$var$dk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            if (d & 4) {
                try {
                    $0b2e6adb871a3b94$var$Pj(3, a, a.return), $0b2e6adb871a3b94$var$Qj(3, a);
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
                try {
                    $0b2e6adb871a3b94$var$Pj(5, a, a.return);
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            d & 512 && null !== c && $0b2e6adb871a3b94$var$Lj(c, c.return);
            break;
        case 5:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            d & 512 && null !== c && $0b2e6adb871a3b94$var$Lj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $0b2e6adb871a3b94$var$ob(e, "");
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $0b2e6adb871a3b94$var$ab(e, f);
                    $0b2e6adb871a3b94$var$vb(h, g);
                    var l = $0b2e6adb871a3b94$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $0b2e6adb871a3b94$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $0b2e6adb871a3b94$var$nb(e, q) : "children" === m ? $0b2e6adb871a3b94$var$ob(e, q) : $0b2e6adb871a3b94$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $0b2e6adb871a3b94$var$bb(e, f);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $0b2e6adb871a3b94$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $0b2e6adb871a3b94$var$fb(e, !!f.multiple, f.defaultValue, !0) : $0b2e6adb871a3b94$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$0b2e6adb871a3b94$var$Pf] = f;
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($0b2e6adb871a3b94$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $0b2e6adb871a3b94$var$bd(b.containerInfo);
            } catch (t) {
                $0b2e6adb871a3b94$var$W(a, a.return, t);
            }
            break;
        case 4:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            break;
        case 13:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($0b2e6adb871a3b94$var$fk = $0b2e6adb871a3b94$var$B()));
            d & 4 && $0b2e6adb871a3b94$var$ak(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($0b2e6adb871a3b94$var$U = (l = $0b2e6adb871a3b94$var$U) || m, $0b2e6adb871a3b94$var$ck(b, a), $0b2e6adb871a3b94$var$U = l) : $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($0b2e6adb871a3b94$var$V = a, m = a.child; null !== m;){
                    for(q = $0b2e6adb871a3b94$var$V = m; null !== $0b2e6adb871a3b94$var$V;){
                        r = $0b2e6adb871a3b94$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $0b2e6adb871a3b94$var$Pj(4, r, r.return);
                                break;
                            case 1:
                                $0b2e6adb871a3b94$var$Lj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $0b2e6adb871a3b94$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $0b2e6adb871a3b94$var$Lj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $0b2e6adb871a3b94$var$gk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $0b2e6adb871a3b94$var$V = y) : $0b2e6adb871a3b94$var$gk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $0b2e6adb871a3b94$var$rb("display", g));
                            } catch (t) {
                                $0b2e6adb871a3b94$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $0b2e6adb871a3b94$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            d & 4 && $0b2e6adb871a3b94$var$ak(a);
            break;
        case 21:
            break;
        default:
            $0b2e6adb871a3b94$var$ck(b, a), $0b2e6adb871a3b94$var$ek(a);
    }
}
function $0b2e6adb871a3b94$var$ek(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($0b2e6adb871a3b94$var$Tj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($0b2e6adb871a3b94$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($0b2e6adb871a3b94$var$ob(e, ""), d.flags &= -33);
                    var f = $0b2e6adb871a3b94$var$Uj(a);
                    $0b2e6adb871a3b94$var$Wj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $0b2e6adb871a3b94$var$Uj(a);
                    $0b2e6adb871a3b94$var$Vj(a, h, g);
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(161));
            }
        } catch (k) {
            $0b2e6adb871a3b94$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $0b2e6adb871a3b94$var$hk(a, b, c) {
    $0b2e6adb871a3b94$var$V = a;
    $0b2e6adb871a3b94$var$ik(a, b, c);
}
function $0b2e6adb871a3b94$var$ik(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $0b2e6adb871a3b94$var$V;){
        var e = $0b2e6adb871a3b94$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $0b2e6adb871a3b94$var$Jj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $0b2e6adb871a3b94$var$U;
                h = $0b2e6adb871a3b94$var$Jj;
                var l = $0b2e6adb871a3b94$var$U;
                $0b2e6adb871a3b94$var$Jj = g;
                if (($0b2e6adb871a3b94$var$U = k) && !l) for($0b2e6adb871a3b94$var$V = e; null !== $0b2e6adb871a3b94$var$V;)g = $0b2e6adb871a3b94$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $0b2e6adb871a3b94$var$jk(e) : null !== k ? (k.return = g, $0b2e6adb871a3b94$var$V = k) : $0b2e6adb871a3b94$var$jk(e);
                for(; null !== f;)$0b2e6adb871a3b94$var$V = f, $0b2e6adb871a3b94$var$ik(f, b, c), f = f.sibling;
                $0b2e6adb871a3b94$var$V = e;
                $0b2e6adb871a3b94$var$Jj = h;
                $0b2e6adb871a3b94$var$U = l;
            }
            $0b2e6adb871a3b94$var$kk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $0b2e6adb871a3b94$var$V = f) : $0b2e6adb871a3b94$var$kk(a, b, c);
    }
}
function $0b2e6adb871a3b94$var$kk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $0b2e6adb871a3b94$var$U || $0b2e6adb871a3b94$var$Qj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$0b2e6adb871a3b94$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $0b2e6adb871a3b94$var$Ci(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $0b2e6adb871a3b94$var$sh(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $0b2e6adb871a3b94$var$sh(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $0b2e6adb871a3b94$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($0b2e6adb871a3b94$var$p(163));
                }
                $0b2e6adb871a3b94$var$U || b.flags & 512 && $0b2e6adb871a3b94$var$Rj(b);
            } catch (r) {
                $0b2e6adb871a3b94$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $0b2e6adb871a3b94$var$V = c;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
function $0b2e6adb871a3b94$var$gk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $0b2e6adb871a3b94$var$V = c;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
function $0b2e6adb871a3b94$var$jk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Qj(4, b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $0b2e6adb871a3b94$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Rj(b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Rj(b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $0b2e6adb871a3b94$var$W(b, b.return, k);
        }
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $0b2e6adb871a3b94$var$V = h;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
var $0b2e6adb871a3b94$var$lk = Math.ceil, $0b2e6adb871a3b94$var$mk = $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher, $0b2e6adb871a3b94$var$nk = $0b2e6adb871a3b94$var$ua.ReactCurrentOwner, $0b2e6adb871a3b94$var$ok = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$K = 0, $0b2e6adb871a3b94$var$Q = null, $0b2e6adb871a3b94$var$Y = null, $0b2e6adb871a3b94$var$Z = 0, $0b2e6adb871a3b94$var$fj = 0, $0b2e6adb871a3b94$var$ej = $0b2e6adb871a3b94$var$Uf(0), $0b2e6adb871a3b94$var$T = 0, $0b2e6adb871a3b94$var$pk = null, $0b2e6adb871a3b94$var$rh = 0, $0b2e6adb871a3b94$var$qk = 0, $0b2e6adb871a3b94$var$rk = 0, $0b2e6adb871a3b94$var$sk = null, $0b2e6adb871a3b94$var$tk = null, $0b2e6adb871a3b94$var$fk = 0, $0b2e6adb871a3b94$var$Gj = Infinity, $0b2e6adb871a3b94$var$uk = null, $0b2e6adb871a3b94$var$Oi = !1, $0b2e6adb871a3b94$var$Pi = null, $0b2e6adb871a3b94$var$Ri = null, $0b2e6adb871a3b94$var$vk = !1, $0b2e6adb871a3b94$var$wk = null, $0b2e6adb871a3b94$var$xk = 0, $0b2e6adb871a3b94$var$yk = 0, $0b2e6adb871a3b94$var$zk = null, $0b2e6adb871a3b94$var$Ak = -1, $0b2e6adb871a3b94$var$Bk = 0;
function $0b2e6adb871a3b94$var$R() {
    return 0 !== ($0b2e6adb871a3b94$var$K & 6) ? $0b2e6adb871a3b94$var$B() : -1 !== $0b2e6adb871a3b94$var$Ak ? $0b2e6adb871a3b94$var$Ak : $0b2e6adb871a3b94$var$Ak = $0b2e6adb871a3b94$var$B();
}
function $0b2e6adb871a3b94$var$yi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($0b2e6adb871a3b94$var$K & 2) && 0 !== $0b2e6adb871a3b94$var$Z) return $0b2e6adb871a3b94$var$Z & -$0b2e6adb871a3b94$var$Z;
    if (null !== $0b2e6adb871a3b94$var$Kg.transition) return 0 === $0b2e6adb871a3b94$var$Bk && ($0b2e6adb871a3b94$var$Bk = $0b2e6adb871a3b94$var$yc()), $0b2e6adb871a3b94$var$Bk;
    a = $0b2e6adb871a3b94$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $0b2e6adb871a3b94$var$jd(a.type);
    return a;
}
function $0b2e6adb871a3b94$var$gi(a, b, c, d) {
    if (50 < $0b2e6adb871a3b94$var$yk) throw $0b2e6adb871a3b94$var$yk = 0, $0b2e6adb871a3b94$var$zk = null, Error($0b2e6adb871a3b94$var$p(185));
    $0b2e6adb871a3b94$var$Ac(a, c, d);
    if (0 === ($0b2e6adb871a3b94$var$K & 2) || a !== $0b2e6adb871a3b94$var$Q) a === $0b2e6adb871a3b94$var$Q && (0 === ($0b2e6adb871a3b94$var$K & 2) && ($0b2e6adb871a3b94$var$qk |= c), 4 === $0b2e6adb871a3b94$var$T && $0b2e6adb871a3b94$var$Ck(a, $0b2e6adb871a3b94$var$Z)), $0b2e6adb871a3b94$var$Dk(a, d), 1 === c && 0 === $0b2e6adb871a3b94$var$K && 0 === (b.mode & 1) && ($0b2e6adb871a3b94$var$Gj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$fg && $0b2e6adb871a3b94$var$jg());
}
function $0b2e6adb871a3b94$var$Dk(a, b) {
    var c = a.callbackNode;
    $0b2e6adb871a3b94$var$wc(a, b);
    var d = $0b2e6adb871a3b94$var$uc(a, a === $0b2e6adb871a3b94$var$Q ? $0b2e6adb871a3b94$var$Z : 0);
    if (0 === d) null !== c && $0b2e6adb871a3b94$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $0b2e6adb871a3b94$var$bc(c);
        if (1 === b) 0 === a.tag ? $0b2e6adb871a3b94$var$ig($0b2e6adb871a3b94$var$Ek.bind(null, a)) : $0b2e6adb871a3b94$var$hg($0b2e6adb871a3b94$var$Ek.bind(null, a)), $0b2e6adb871a3b94$var$Jf(function() {
            0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$jg();
        }), c = null;
        else {
            switch($0b2e6adb871a3b94$var$Dc(d)){
                case 1:
                    c = $0b2e6adb871a3b94$var$fc;
                    break;
                case 4:
                    c = $0b2e6adb871a3b94$var$gc;
                    break;
                case 16:
                    c = $0b2e6adb871a3b94$var$hc;
                    break;
                case 536870912:
                    c = $0b2e6adb871a3b94$var$jc;
                    break;
                default:
                    c = $0b2e6adb871a3b94$var$hc;
            }
            c = $0b2e6adb871a3b94$var$Fk(c, $0b2e6adb871a3b94$var$Gk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $0b2e6adb871a3b94$var$Gk(a, b) {
    $0b2e6adb871a3b94$var$Ak = -1;
    $0b2e6adb871a3b94$var$Bk = 0;
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    var c = a.callbackNode;
    if ($0b2e6adb871a3b94$var$Hk() && a.callbackNode !== c) return null;
    var d = $0b2e6adb871a3b94$var$uc(a, a === $0b2e6adb871a3b94$var$Q ? $0b2e6adb871a3b94$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $0b2e6adb871a3b94$var$Ik(a, d);
    else {
        b = d;
        var e = $0b2e6adb871a3b94$var$K;
        $0b2e6adb871a3b94$var$K |= 2;
        var f = $0b2e6adb871a3b94$var$Jk();
        if ($0b2e6adb871a3b94$var$Q !== a || $0b2e6adb871a3b94$var$Z !== b) $0b2e6adb871a3b94$var$uk = null, $0b2e6adb871a3b94$var$Gj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$Kk(a, b);
        for(;;)try {
            $0b2e6adb871a3b94$var$Lk();
            break;
        } catch (h) {
            $0b2e6adb871a3b94$var$Mk(a, h);
        }
        $0b2e6adb871a3b94$var$$g();
        $0b2e6adb871a3b94$var$mk.current = f;
        $0b2e6adb871a3b94$var$K = e;
        null !== $0b2e6adb871a3b94$var$Y ? b = 0 : ($0b2e6adb871a3b94$var$Q = null, $0b2e6adb871a3b94$var$Z = 0, b = $0b2e6adb871a3b94$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $0b2e6adb871a3b94$var$xc(a), 0 !== e && (d = e, b = $0b2e6adb871a3b94$var$Nk(a, e)));
        if (1 === b) throw c = $0b2e6adb871a3b94$var$pk, $0b2e6adb871a3b94$var$Kk(a, 0), $0b2e6adb871a3b94$var$Ck(a, d), $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B()), c;
        if (6 === b) $0b2e6adb871a3b94$var$Ck(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$0b2e6adb871a3b94$var$Ok(e) && (b = $0b2e6adb871a3b94$var$Ik(a, d), 2 === b && (f = $0b2e6adb871a3b94$var$xc(a), 0 !== f && (d = f, b = $0b2e6adb871a3b94$var$Nk(a, f))), 1 === b)) throw c = $0b2e6adb871a3b94$var$pk, $0b2e6adb871a3b94$var$Kk(a, 0), $0b2e6adb871a3b94$var$Ck(a, d), $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($0b2e6adb871a3b94$var$p(345));
                case 2:
                    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
                    break;
                case 3:
                    $0b2e6adb871a3b94$var$Ck(a, d);
                    if ((d & 130023424) === d && (b = $0b2e6adb871a3b94$var$fk + 500 - $0b2e6adb871a3b94$var$B(), 10 < b)) {
                        if (0 !== $0b2e6adb871a3b94$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $0b2e6adb871a3b94$var$R();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $0b2e6adb871a3b94$var$Ff($0b2e6adb871a3b94$var$Pk.bind(null, a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk), b);
                        break;
                    }
                    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
                    break;
                case 4:
                    $0b2e6adb871a3b94$var$Ck(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $0b2e6adb871a3b94$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $0b2e6adb871a3b94$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $0b2e6adb871a3b94$var$lk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $0b2e6adb871a3b94$var$Ff($0b2e6adb871a3b94$var$Pk.bind(null, a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk), d);
                        break;
                    }
                    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
                    break;
                case 5:
                    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(329));
            }
        }
    }
    $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B());
    return a.callbackNode === c ? $0b2e6adb871a3b94$var$Gk.bind(null, a) : null;
}
function $0b2e6adb871a3b94$var$Nk(a, b) {
    var c = $0b2e6adb871a3b94$var$sk;
    a.current.memoizedState.isDehydrated && ($0b2e6adb871a3b94$var$Kk(a, b).flags |= 256);
    a = $0b2e6adb871a3b94$var$Ik(a, b);
    2 !== a && (b = $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$tk = c, null !== b && $0b2e6adb871a3b94$var$Fj(b));
    return a;
}
function $0b2e6adb871a3b94$var$Fj(a) {
    null === $0b2e6adb871a3b94$var$tk ? $0b2e6adb871a3b94$var$tk = a : $0b2e6adb871a3b94$var$tk.push.apply($0b2e6adb871a3b94$var$tk, a);
}
function $0b2e6adb871a3b94$var$Ok(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$0b2e6adb871a3b94$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Ck(a, b) {
    b &= ~$0b2e6adb871a3b94$var$rk;
    b &= ~$0b2e6adb871a3b94$var$qk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $0b2e6adb871a3b94$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $0b2e6adb871a3b94$var$Ek(a) {
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    $0b2e6adb871a3b94$var$Hk();
    var b = $0b2e6adb871a3b94$var$uc(a, 0);
    if (0 === (b & 1)) return $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B()), null;
    var c = $0b2e6adb871a3b94$var$Ik(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $0b2e6adb871a3b94$var$xc(a);
        0 !== d && (b = d, c = $0b2e6adb871a3b94$var$Nk(a, d));
    }
    if (1 === c) throw c = $0b2e6adb871a3b94$var$pk, $0b2e6adb871a3b94$var$Kk(a, 0), $0b2e6adb871a3b94$var$Ck(a, b), $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B()), c;
    if (6 === c) throw Error($0b2e6adb871a3b94$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
    $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B());
    return null;
}
function $0b2e6adb871a3b94$var$Qk(a, b) {
    var c = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 1;
    try {
        return a(b);
    } finally{
        $0b2e6adb871a3b94$var$K = c, 0 === $0b2e6adb871a3b94$var$K && ($0b2e6adb871a3b94$var$Gj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$fg && $0b2e6adb871a3b94$var$jg());
    }
}
function $0b2e6adb871a3b94$var$Rk(a) {
    null !== $0b2e6adb871a3b94$var$wk && 0 === $0b2e6adb871a3b94$var$wk.tag && 0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$Hk();
    var b = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 1;
    var c = $0b2e6adb871a3b94$var$ok.transition, d = $0b2e6adb871a3b94$var$C;
    try {
        if ($0b2e6adb871a3b94$var$ok.transition = null, $0b2e6adb871a3b94$var$C = 1, a) return a();
    } finally{
        $0b2e6adb871a3b94$var$C = d, $0b2e6adb871a3b94$var$ok.transition = c, $0b2e6adb871a3b94$var$K = b, 0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$jg();
    }
}
function $0b2e6adb871a3b94$var$Hj() {
    $0b2e6adb871a3b94$var$fj = $0b2e6adb871a3b94$var$ej.current;
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$ej);
}
function $0b2e6adb871a3b94$var$Kk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $0b2e6adb871a3b94$var$Gf(c));
    if (null !== $0b2e6adb871a3b94$var$Y) for(c = $0b2e6adb871a3b94$var$Y.return; null !== c;){
        var d = c;
        $0b2e6adb871a3b94$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $0b2e6adb871a3b94$var$$f();
                break;
            case 3:
                $0b2e6adb871a3b94$var$zh();
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
                $0b2e6adb871a3b94$var$Eh();
                break;
            case 5:
                $0b2e6adb871a3b94$var$Bh(d);
                break;
            case 4:
                $0b2e6adb871a3b94$var$zh();
                break;
            case 13:
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
                break;
            case 19:
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
                break;
            case 10:
                $0b2e6adb871a3b94$var$ah(d.type._context);
                break;
            case 22:
            case 23:
                $0b2e6adb871a3b94$var$Hj();
        }
        c = c.return;
    }
    $0b2e6adb871a3b94$var$Q = a;
    $0b2e6adb871a3b94$var$Y = a = $0b2e6adb871a3b94$var$Pg(a.current, null);
    $0b2e6adb871a3b94$var$Z = $0b2e6adb871a3b94$var$fj = b;
    $0b2e6adb871a3b94$var$T = 0;
    $0b2e6adb871a3b94$var$pk = null;
    $0b2e6adb871a3b94$var$rk = $0b2e6adb871a3b94$var$qk = $0b2e6adb871a3b94$var$rh = 0;
    $0b2e6adb871a3b94$var$tk = $0b2e6adb871a3b94$var$sk = null;
    if (null !== $0b2e6adb871a3b94$var$fh) {
        for(b = 0; b < $0b2e6adb871a3b94$var$fh.length; b++)if (c = $0b2e6adb871a3b94$var$fh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $0b2e6adb871a3b94$var$fh = null;
    }
    return a;
}
function $0b2e6adb871a3b94$var$Mk(a, b) {
    do {
        var c = $0b2e6adb871a3b94$var$Y;
        try {
            $0b2e6adb871a3b94$var$$g();
            $0b2e6adb871a3b94$var$Fh.current = $0b2e6adb871a3b94$var$Rh;
            if ($0b2e6adb871a3b94$var$Ih) {
                for(var d = $0b2e6adb871a3b94$var$M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $0b2e6adb871a3b94$var$Ih = !1;
            }
            $0b2e6adb871a3b94$var$Hh = 0;
            $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$N = $0b2e6adb871a3b94$var$M = null;
            $0b2e6adb871a3b94$var$Jh = !1;
            $0b2e6adb871a3b94$var$Kh = 0;
            $0b2e6adb871a3b94$var$nk.current = null;
            if (null === c || null === c.return) {
                $0b2e6adb871a3b94$var$T = 1;
                $0b2e6adb871a3b94$var$pk = b;
                $0b2e6adb871a3b94$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $0b2e6adb871a3b94$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $0b2e6adb871a3b94$var$Ui(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $0b2e6adb871a3b94$var$Vi(y, g, h, f, b);
                        y.mode & 1 && $0b2e6adb871a3b94$var$Si(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $0b2e6adb871a3b94$var$Si(f, l, b);
                            $0b2e6adb871a3b94$var$tj();
                            break a;
                        }
                        k = Error($0b2e6adb871a3b94$var$p(426));
                    }
                } else if ($0b2e6adb871a3b94$var$I && h.mode & 1) {
                    var J = $0b2e6adb871a3b94$var$Ui(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $0b2e6adb871a3b94$var$Vi(J, g, h, f, b);
                        $0b2e6adb871a3b94$var$Jg($0b2e6adb871a3b94$var$Ji(k, h));
                        break a;
                    }
                }
                f = k = $0b2e6adb871a3b94$var$Ji(k, h);
                4 !== $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 2);
                null === $0b2e6adb871a3b94$var$sk ? $0b2e6adb871a3b94$var$sk = [
                    f
                ] : $0b2e6adb871a3b94$var$sk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $0b2e6adb871a3b94$var$Ni(f, k, b);
                            $0b2e6adb871a3b94$var$ph(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $0b2e6adb871a3b94$var$Ri || !$0b2e6adb871a3b94$var$Ri.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $0b2e6adb871a3b94$var$Qi(f, h, b);
                                $0b2e6adb871a3b94$var$ph(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $0b2e6adb871a3b94$var$Sk(c);
        } catch (na) {
            b = na;
            $0b2e6adb871a3b94$var$Y === c && null !== c && ($0b2e6adb871a3b94$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $0b2e6adb871a3b94$var$Jk() {
    var a = $0b2e6adb871a3b94$var$mk.current;
    $0b2e6adb871a3b94$var$mk.current = $0b2e6adb871a3b94$var$Rh;
    return null === a ? $0b2e6adb871a3b94$var$Rh : a;
}
function $0b2e6adb871a3b94$var$tj() {
    if (0 === $0b2e6adb871a3b94$var$T || 3 === $0b2e6adb871a3b94$var$T || 2 === $0b2e6adb871a3b94$var$T) $0b2e6adb871a3b94$var$T = 4;
    null === $0b2e6adb871a3b94$var$Q || 0 === ($0b2e6adb871a3b94$var$rh & 268435455) && 0 === ($0b2e6adb871a3b94$var$qk & 268435455) || $0b2e6adb871a3b94$var$Ck($0b2e6adb871a3b94$var$Q, $0b2e6adb871a3b94$var$Z);
}
function $0b2e6adb871a3b94$var$Ik(a, b) {
    var c = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 2;
    var d = $0b2e6adb871a3b94$var$Jk();
    if ($0b2e6adb871a3b94$var$Q !== a || $0b2e6adb871a3b94$var$Z !== b) $0b2e6adb871a3b94$var$uk = null, $0b2e6adb871a3b94$var$Kk(a, b);
    for(;;)try {
        $0b2e6adb871a3b94$var$Tk();
        break;
    } catch (e) {
        $0b2e6adb871a3b94$var$Mk(a, e);
    }
    $0b2e6adb871a3b94$var$$g();
    $0b2e6adb871a3b94$var$K = c;
    $0b2e6adb871a3b94$var$mk.current = d;
    if (null !== $0b2e6adb871a3b94$var$Y) throw Error($0b2e6adb871a3b94$var$p(261));
    $0b2e6adb871a3b94$var$Q = null;
    $0b2e6adb871a3b94$var$Z = 0;
    return $0b2e6adb871a3b94$var$T;
}
function $0b2e6adb871a3b94$var$Tk() {
    for(; null !== $0b2e6adb871a3b94$var$Y;)$0b2e6adb871a3b94$var$Uk($0b2e6adb871a3b94$var$Y);
}
function $0b2e6adb871a3b94$var$Lk() {
    for(; null !== $0b2e6adb871a3b94$var$Y && !$0b2e6adb871a3b94$var$cc();)$0b2e6adb871a3b94$var$Uk($0b2e6adb871a3b94$var$Y);
}
function $0b2e6adb871a3b94$var$Uk(a) {
    var b = $0b2e6adb871a3b94$var$Vk(a.alternate, a, $0b2e6adb871a3b94$var$fj);
    a.memoizedProps = a.pendingProps;
    null === b ? $0b2e6adb871a3b94$var$Sk(a) : $0b2e6adb871a3b94$var$Y = b;
    $0b2e6adb871a3b94$var$nk.current = null;
}
function $0b2e6adb871a3b94$var$Sk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $0b2e6adb871a3b94$var$Ej(c, b, $0b2e6adb871a3b94$var$fj), null !== c) {
                $0b2e6adb871a3b94$var$Y = c;
                return;
            }
        } else {
            c = $0b2e6adb871a3b94$var$Ij(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $0b2e6adb871a3b94$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $0b2e6adb871a3b94$var$T = 6;
                $0b2e6adb871a3b94$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $0b2e6adb871a3b94$var$Y = b;
            return;
        }
        $0b2e6adb871a3b94$var$Y = b = a;
    }while (null !== b);
    0 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 5);
}
function $0b2e6adb871a3b94$var$Pk(a, b, c) {
    var d = $0b2e6adb871a3b94$var$C, e = $0b2e6adb871a3b94$var$ok.transition;
    try {
        $0b2e6adb871a3b94$var$ok.transition = null, $0b2e6adb871a3b94$var$C = 1, $0b2e6adb871a3b94$var$Wk(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$ok.transition = e, $0b2e6adb871a3b94$var$C = d;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Wk(a, b, c, d) {
    do $0b2e6adb871a3b94$var$Hk();
    while (null !== $0b2e6adb871a3b94$var$wk);
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($0b2e6adb871a3b94$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $0b2e6adb871a3b94$var$Bc(a, f);
    a === $0b2e6adb871a3b94$var$Q && ($0b2e6adb871a3b94$var$Y = $0b2e6adb871a3b94$var$Q = null, $0b2e6adb871a3b94$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $0b2e6adb871a3b94$var$vk || ($0b2e6adb871a3b94$var$vk = !0, $0b2e6adb871a3b94$var$Fk($0b2e6adb871a3b94$var$hc, function() {
        $0b2e6adb871a3b94$var$Hk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $0b2e6adb871a3b94$var$ok.transition;
        $0b2e6adb871a3b94$var$ok.transition = null;
        var g = $0b2e6adb871a3b94$var$C;
        $0b2e6adb871a3b94$var$C = 1;
        var h = $0b2e6adb871a3b94$var$K;
        $0b2e6adb871a3b94$var$K |= 4;
        $0b2e6adb871a3b94$var$nk.current = null;
        $0b2e6adb871a3b94$var$Oj(a, c);
        $0b2e6adb871a3b94$var$dk(c, a);
        $0b2e6adb871a3b94$var$Oe($0b2e6adb871a3b94$var$Df);
        $0b2e6adb871a3b94$var$dd = !!$0b2e6adb871a3b94$var$Cf;
        $0b2e6adb871a3b94$var$Df = $0b2e6adb871a3b94$var$Cf = null;
        a.current = c;
        $0b2e6adb871a3b94$var$hk(c, a, e);
        $0b2e6adb871a3b94$var$dc();
        $0b2e6adb871a3b94$var$K = h;
        $0b2e6adb871a3b94$var$C = g;
        $0b2e6adb871a3b94$var$ok.transition = f;
    } else a.current = c;
    $0b2e6adb871a3b94$var$vk && ($0b2e6adb871a3b94$var$vk = !1, $0b2e6adb871a3b94$var$wk = a, $0b2e6adb871a3b94$var$xk = e);
    f = a.pendingLanes;
    0 === f && ($0b2e6adb871a3b94$var$Ri = null);
    $0b2e6adb871a3b94$var$mc(c.stateNode, d);
    $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($0b2e6adb871a3b94$var$Oi) throw $0b2e6adb871a3b94$var$Oi = !1, a = $0b2e6adb871a3b94$var$Pi, $0b2e6adb871a3b94$var$Pi = null, a;
    0 !== ($0b2e6adb871a3b94$var$xk & 1) && 0 !== a.tag && $0b2e6adb871a3b94$var$Hk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $0b2e6adb871a3b94$var$zk ? $0b2e6adb871a3b94$var$yk++ : ($0b2e6adb871a3b94$var$yk = 0, $0b2e6adb871a3b94$var$zk = a) : $0b2e6adb871a3b94$var$yk = 0;
    $0b2e6adb871a3b94$var$jg();
    return null;
}
function $0b2e6adb871a3b94$var$Hk() {
    if (null !== $0b2e6adb871a3b94$var$wk) {
        var a = $0b2e6adb871a3b94$var$Dc($0b2e6adb871a3b94$var$xk), b = $0b2e6adb871a3b94$var$ok.transition, c = $0b2e6adb871a3b94$var$C;
        try {
            $0b2e6adb871a3b94$var$ok.transition = null;
            $0b2e6adb871a3b94$var$C = 16 > a ? 16 : a;
            if (null === $0b2e6adb871a3b94$var$wk) var d = !1;
            else {
                a = $0b2e6adb871a3b94$var$wk;
                $0b2e6adb871a3b94$var$wk = null;
                $0b2e6adb871a3b94$var$xk = 0;
                if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(331));
                var e = $0b2e6adb871a3b94$var$K;
                $0b2e6adb871a3b94$var$K |= 4;
                for($0b2e6adb871a3b94$var$V = a.current; null !== $0b2e6adb871a3b94$var$V;){
                    var f = $0b2e6adb871a3b94$var$V, g = f.child;
                    if (0 !== ($0b2e6adb871a3b94$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($0b2e6adb871a3b94$var$V = l; null !== $0b2e6adb871a3b94$var$V;){
                                    var m = $0b2e6adb871a3b94$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $0b2e6adb871a3b94$var$Pj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $0b2e6adb871a3b94$var$V = q;
                                    else for(; null !== $0b2e6adb871a3b94$var$V;){
                                        m = $0b2e6adb871a3b94$var$V;
                                        var r = m.sibling, y = m.return;
                                        $0b2e6adb871a3b94$var$Sj(m);
                                        if (m === l) {
                                            $0b2e6adb871a3b94$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $0b2e6adb871a3b94$var$V = r;
                                            break;
                                        }
                                        $0b2e6adb871a3b94$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $0b2e6adb871a3b94$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $0b2e6adb871a3b94$var$V = g;
                    else b: for(; null !== $0b2e6adb871a3b94$var$V;){
                        f = $0b2e6adb871a3b94$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $0b2e6adb871a3b94$var$Pj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $0b2e6adb871a3b94$var$V = x;
                            break b;
                        }
                        $0b2e6adb871a3b94$var$V = f.return;
                    }
                }
                var w = a.current;
                for($0b2e6adb871a3b94$var$V = w; null !== $0b2e6adb871a3b94$var$V;){
                    g = $0b2e6adb871a3b94$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $0b2e6adb871a3b94$var$V = u;
                    else b: for(g = w; null !== $0b2e6adb871a3b94$var$V;){
                        h = $0b2e6adb871a3b94$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $0b2e6adb871a3b94$var$Qj(9, h);
                            }
                        } catch (na) {
                            $0b2e6adb871a3b94$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $0b2e6adb871a3b94$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $0b2e6adb871a3b94$var$V = F;
                            break b;
                        }
                        $0b2e6adb871a3b94$var$V = h.return;
                    }
                }
                $0b2e6adb871a3b94$var$K = e;
                $0b2e6adb871a3b94$var$jg();
                if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onPostCommitFiberRoot) try {
                    $0b2e6adb871a3b94$var$lc.onPostCommitFiberRoot($0b2e6adb871a3b94$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $0b2e6adb871a3b94$var$C = c, $0b2e6adb871a3b94$var$ok.transition = b;
        }
    }
    return !1;
}
function $0b2e6adb871a3b94$var$Xk(a, b, c) {
    b = $0b2e6adb871a3b94$var$Ji(c, b);
    b = $0b2e6adb871a3b94$var$Ni(a, b, 1);
    a = $0b2e6adb871a3b94$var$nh(a, b, 1);
    b = $0b2e6adb871a3b94$var$R();
    null !== a && ($0b2e6adb871a3b94$var$Ac(a, 1, b), $0b2e6adb871a3b94$var$Dk(a, b));
}
function $0b2e6adb871a3b94$var$W(a, b, c) {
    if (3 === a.tag) $0b2e6adb871a3b94$var$Xk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $0b2e6adb871a3b94$var$Xk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $0b2e6adb871a3b94$var$Ri || !$0b2e6adb871a3b94$var$Ri.has(d))) {
                a = $0b2e6adb871a3b94$var$Ji(c, a);
                a = $0b2e6adb871a3b94$var$Qi(b, a, 1);
                b = $0b2e6adb871a3b94$var$nh(b, a, 1);
                a = $0b2e6adb871a3b94$var$R();
                null !== b && ($0b2e6adb871a3b94$var$Ac(b, 1, a), $0b2e6adb871a3b94$var$Dk(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $0b2e6adb871a3b94$var$Ti(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $0b2e6adb871a3b94$var$R();
    a.pingedLanes |= a.suspendedLanes & c;
    $0b2e6adb871a3b94$var$Q === a && ($0b2e6adb871a3b94$var$Z & c) === c && (4 === $0b2e6adb871a3b94$var$T || 3 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$Z & 130023424) === $0b2e6adb871a3b94$var$Z && 500 > $0b2e6adb871a3b94$var$B() - $0b2e6adb871a3b94$var$fk ? $0b2e6adb871a3b94$var$Kk(a, 0) : $0b2e6adb871a3b94$var$rk |= c);
    $0b2e6adb871a3b94$var$Dk(a, b);
}
function $0b2e6adb871a3b94$var$Yk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $0b2e6adb871a3b94$var$sc, $0b2e6adb871a3b94$var$sc <<= 1, 0 === ($0b2e6adb871a3b94$var$sc & 130023424) && ($0b2e6adb871a3b94$var$sc = 4194304)));
    var c = $0b2e6adb871a3b94$var$R();
    a = $0b2e6adb871a3b94$var$ih(a, b);
    null !== a && ($0b2e6adb871a3b94$var$Ac(a, b, c), $0b2e6adb871a3b94$var$Dk(a, c));
}
function $0b2e6adb871a3b94$var$uj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $0b2e6adb871a3b94$var$Yk(a, c);
}
function $0b2e6adb871a3b94$var$bk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($0b2e6adb871a3b94$var$p(314));
    }
    null !== d && d.delete(b);
    $0b2e6adb871a3b94$var$Yk(a, c);
}
var $0b2e6adb871a3b94$var$Vk;
$0b2e6adb871a3b94$var$Vk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $0b2e6adb871a3b94$var$Wf.current) $0b2e6adb871a3b94$var$dh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $0b2e6adb871a3b94$var$dh = !1, $0b2e6adb871a3b94$var$yj(a, b, c);
            $0b2e6adb871a3b94$var$dh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $0b2e6adb871a3b94$var$dh = !1, $0b2e6adb871a3b94$var$I && 0 !== (b.flags & 1048576) && $0b2e6adb871a3b94$var$ug(b, $0b2e6adb871a3b94$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $0b2e6adb871a3b94$var$ij(a, b);
            a = b.pendingProps;
            var e = $0b2e6adb871a3b94$var$Yf(b, $0b2e6adb871a3b94$var$H.current);
            $0b2e6adb871a3b94$var$ch(b, c);
            e = $0b2e6adb871a3b94$var$Nh(null, b, d, a, e, c);
            var f = $0b2e6adb871a3b94$var$Sh();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $0b2e6adb871a3b94$var$Zf(d) ? (f = !0, $0b2e6adb871a3b94$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $0b2e6adb871a3b94$var$kh(b), e.updater = $0b2e6adb871a3b94$var$Ei, b.stateNode = e, e._reactInternals = b, $0b2e6adb871a3b94$var$Ii(b, d, a, c), b = $0b2e6adb871a3b94$var$jj(null, b, d, !0, f, c)) : (b.tag = 0, $0b2e6adb871a3b94$var$I && f && $0b2e6adb871a3b94$var$vg(b), $0b2e6adb871a3b94$var$Xi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $0b2e6adb871a3b94$var$ij(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $0b2e6adb871a3b94$var$Zk(d);
                a = $0b2e6adb871a3b94$var$Ci(d, a);
                switch(e){
                    case 0:
                        b = $0b2e6adb871a3b94$var$cj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $0b2e6adb871a3b94$var$hj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $0b2e6adb871a3b94$var$Yi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $0b2e6adb871a3b94$var$$i(null, b, d, $0b2e6adb871a3b94$var$Ci(d.type, a), c);
                        break a;
                }
                throw Error($0b2e6adb871a3b94$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Ci(d, e), $0b2e6adb871a3b94$var$cj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Ci(d, e), $0b2e6adb871a3b94$var$hj(a, b, d, e, c);
        case 3:
            a: {
                $0b2e6adb871a3b94$var$kj(b);
                if (null === a) throw Error($0b2e6adb871a3b94$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $0b2e6adb871a3b94$var$lh(a, b);
                $0b2e6adb871a3b94$var$qh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $0b2e6adb871a3b94$var$Ji(Error($0b2e6adb871a3b94$var$p(423)), b);
                        b = $0b2e6adb871a3b94$var$lj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $0b2e6adb871a3b94$var$Ji(Error($0b2e6adb871a3b94$var$p(424)), b);
                        b = $0b2e6adb871a3b94$var$lj(a, b, d, c, e);
                        break a;
                    } else for($0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(b.stateNode.containerInfo.firstChild), $0b2e6adb871a3b94$var$xg = b, $0b2e6adb871a3b94$var$I = !0, $0b2e6adb871a3b94$var$zg = null, c = $0b2e6adb871a3b94$var$Vg(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $0b2e6adb871a3b94$var$Ig();
                    if (d === e) {
                        b = $0b2e6adb871a3b94$var$Zi(a, b, c);
                        break a;
                    }
                    $0b2e6adb871a3b94$var$Xi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $0b2e6adb871a3b94$var$Ah(b), null === a && $0b2e6adb871a3b94$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $0b2e6adb871a3b94$var$Ef(d, e) ? g = null : null !== f && $0b2e6adb871a3b94$var$Ef(d, f) && (b.flags |= 32), $0b2e6adb871a3b94$var$gj(a, b), $0b2e6adb871a3b94$var$Xi(a, b, g, c), b.child;
        case 6:
            return null === a && $0b2e6adb871a3b94$var$Eg(b), null;
        case 13:
            return $0b2e6adb871a3b94$var$oj(a, b, c);
        case 4:
            return $0b2e6adb871a3b94$var$yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $0b2e6adb871a3b94$var$Ug(b, null, d, c) : $0b2e6adb871a3b94$var$Xi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Ci(d, e), $0b2e6adb871a3b94$var$Yi(a, b, d, e, c);
        case 7:
            return $0b2e6adb871a3b94$var$Xi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $0b2e6adb871a3b94$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $0b2e6adb871a3b94$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($0b2e6adb871a3b94$var$He(f.value, g)) {
                        if (f.children === e.children && !$0b2e6adb871a3b94$var$Wf.current) {
                            b = $0b2e6adb871a3b94$var$Zi(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $0b2e6adb871a3b94$var$mh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $0b2e6adb871a3b94$var$bh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($0b2e6adb871a3b94$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $0b2e6adb871a3b94$var$bh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $0b2e6adb871a3b94$var$Xi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $0b2e6adb871a3b94$var$ch(b, c), e = $0b2e6adb871a3b94$var$eh(e), d = d(e), b.flags |= 1, $0b2e6adb871a3b94$var$Xi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $0b2e6adb871a3b94$var$Ci(d, b.pendingProps), e = $0b2e6adb871a3b94$var$Ci(d.type, e), $0b2e6adb871a3b94$var$$i(a, b, d, e, c);
        case 15:
            return $0b2e6adb871a3b94$var$bj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Ci(d, e), $0b2e6adb871a3b94$var$ij(a, b), b.tag = 1, $0b2e6adb871a3b94$var$Zf(d) ? (a = !0, $0b2e6adb871a3b94$var$cg(b)) : a = !1, $0b2e6adb871a3b94$var$ch(b, c), $0b2e6adb871a3b94$var$Gi(b, d, e), $0b2e6adb871a3b94$var$Ii(b, d, e, c), $0b2e6adb871a3b94$var$jj(null, b, d, !0, a, c);
        case 19:
            return $0b2e6adb871a3b94$var$xj(a, b, c);
        case 22:
            return $0b2e6adb871a3b94$var$dj(a, b, c);
    }
    throw Error($0b2e6adb871a3b94$var$p(156, b.tag));
};
function $0b2e6adb871a3b94$var$Fk(a, b) {
    return $0b2e6adb871a3b94$var$ac(a, b);
}
function $0b2e6adb871a3b94$var$$k(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $0b2e6adb871a3b94$var$Bg(a, b, c, d) {
    return new $0b2e6adb871a3b94$var$$k(a, b, c, d);
}
function $0b2e6adb871a3b94$var$aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $0b2e6adb871a3b94$var$Zk(a) {
    if ("function" === typeof a) return $0b2e6adb871a3b94$var$aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $0b2e6adb871a3b94$var$Da) return 11;
        if (a === $0b2e6adb871a3b94$var$Ga) return 14;
    }
    return 2;
}
function $0b2e6adb871a3b94$var$Pg(a, b) {
    var c = a.alternate;
    null === c ? (c = $0b2e6adb871a3b94$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $0b2e6adb871a3b94$var$Rg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $0b2e6adb871a3b94$var$aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $0b2e6adb871a3b94$var$ya:
            return $0b2e6adb871a3b94$var$Tg(c.children, e, f, b);
        case $0b2e6adb871a3b94$var$za:
            g = 8;
            e |= 8;
            break;
        case $0b2e6adb871a3b94$var$Aa:
            return a = $0b2e6adb871a3b94$var$Bg(12, c, b, e | 2), a.elementType = $0b2e6adb871a3b94$var$Aa, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Ea:
            return a = $0b2e6adb871a3b94$var$Bg(13, c, b, e), a.elementType = $0b2e6adb871a3b94$var$Ea, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Fa:
            return a = $0b2e6adb871a3b94$var$Bg(19, c, b, e), a.elementType = $0b2e6adb871a3b94$var$Fa, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Ia:
            return $0b2e6adb871a3b94$var$pj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $0b2e6adb871a3b94$var$Ba:
                    g = 10;
                    break a;
                case $0b2e6adb871a3b94$var$Ca:
                    g = 9;
                    break a;
                case $0b2e6adb871a3b94$var$Da:
                    g = 11;
                    break a;
                case $0b2e6adb871a3b94$var$Ga:
                    g = 14;
                    break a;
                case $0b2e6adb871a3b94$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($0b2e6adb871a3b94$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $0b2e6adb871a3b94$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $0b2e6adb871a3b94$var$Tg(a, b, c, d) {
    a = $0b2e6adb871a3b94$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $0b2e6adb871a3b94$var$pj(a, b, c, d) {
    a = $0b2e6adb871a3b94$var$Bg(22, a, d, b);
    a.elementType = $0b2e6adb871a3b94$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $0b2e6adb871a3b94$var$Qg(a, b, c) {
    a = $0b2e6adb871a3b94$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $0b2e6adb871a3b94$var$Sg(a, b, c) {
    b = $0b2e6adb871a3b94$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $0b2e6adb871a3b94$var$al(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $0b2e6adb871a3b94$var$zc(0);
    this.expirationTimes = $0b2e6adb871a3b94$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $0b2e6adb871a3b94$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $0b2e6adb871a3b94$var$bl(a, b, c, d, e, f, g, h, k) {
    a = new $0b2e6adb871a3b94$var$al(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $0b2e6adb871a3b94$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $0b2e6adb871a3b94$var$kh(f);
    return a;
}
function $0b2e6adb871a3b94$var$cl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $0b2e6adb871a3b94$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $0b2e6adb871a3b94$var$dl(a) {
    if (!a) return $0b2e6adb871a3b94$var$Vf;
    a = a._reactInternals;
    a: {
        if ($0b2e6adb871a3b94$var$Vb(a) !== a || 1 !== a.tag) throw Error($0b2e6adb871a3b94$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($0b2e6adb871a3b94$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($0b2e6adb871a3b94$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($0b2e6adb871a3b94$var$Zf(c)) return $0b2e6adb871a3b94$var$bg(a, c, b);
    }
    return b;
}
function $0b2e6adb871a3b94$var$el(a, b, c, d, e, f, g, h, k) {
    a = $0b2e6adb871a3b94$var$bl(c, d, !0, a, e, f, g, h, k);
    a.context = $0b2e6adb871a3b94$var$dl(null);
    c = a.current;
    d = $0b2e6adb871a3b94$var$R();
    e = $0b2e6adb871a3b94$var$yi(c);
    f = $0b2e6adb871a3b94$var$mh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $0b2e6adb871a3b94$var$nh(c, f, e);
    a.current.lanes = e;
    $0b2e6adb871a3b94$var$Ac(a, e, d);
    $0b2e6adb871a3b94$var$Dk(a, d);
    return a;
}
function $0b2e6adb871a3b94$var$fl(a, b, c, d) {
    var e = b.current, f = $0b2e6adb871a3b94$var$R(), g = $0b2e6adb871a3b94$var$yi(e);
    c = $0b2e6adb871a3b94$var$dl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $0b2e6adb871a3b94$var$mh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $0b2e6adb871a3b94$var$nh(e, b, g);
    null !== a && ($0b2e6adb871a3b94$var$gi(a, e, g, f), $0b2e6adb871a3b94$var$oh(a, e, g));
    return g;
}
function $0b2e6adb871a3b94$var$gl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $0b2e6adb871a3b94$var$hl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $0b2e6adb871a3b94$var$il(a, b) {
    $0b2e6adb871a3b94$var$hl(a, b);
    (a = a.alternate) && $0b2e6adb871a3b94$var$hl(a, b);
}
function $0b2e6adb871a3b94$var$jl() {
    return null;
}
var $0b2e6adb871a3b94$var$kl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $0b2e6adb871a3b94$var$ll(a) {
    this._internalRoot = a;
}
$0b2e6adb871a3b94$var$ml.prototype.render = $0b2e6adb871a3b94$var$ll.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($0b2e6adb871a3b94$var$p(409));
    $0b2e6adb871a3b94$var$fl(a, b, null, null);
};
$0b2e6adb871a3b94$var$ml.prototype.unmount = $0b2e6adb871a3b94$var$ll.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $0b2e6adb871a3b94$var$Rk(function() {
            $0b2e6adb871a3b94$var$fl(null, a, null, null);
        });
        b[$0b2e6adb871a3b94$var$uf] = null;
    }
};
function $0b2e6adb871a3b94$var$ml(a) {
    this._internalRoot = a;
}
$0b2e6adb871a3b94$var$ml.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $0b2e6adb871a3b94$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $0b2e6adb871a3b94$var$Qc.length && 0 !== b && b < $0b2e6adb871a3b94$var$Qc[c].priority; c++);
        $0b2e6adb871a3b94$var$Qc.splice(c, 0, a);
        0 === c && $0b2e6adb871a3b94$var$Vc(a);
    }
};
function $0b2e6adb871a3b94$var$nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $0b2e6adb871a3b94$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $0b2e6adb871a3b94$var$pl() {}
function $0b2e6adb871a3b94$var$ql(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $0b2e6adb871a3b94$var$gl(g);
                f.call(a);
            };
        }
        var g = $0b2e6adb871a3b94$var$el(b, d, a, 0, null, !1, !1, "", $0b2e6adb871a3b94$var$pl);
        a._reactRootContainer = g;
        a[$0b2e6adb871a3b94$var$uf] = g.current;
        $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
        $0b2e6adb871a3b94$var$Rk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $0b2e6adb871a3b94$var$gl(k);
            h.call(a);
        };
    }
    var k = $0b2e6adb871a3b94$var$bl(a, 0, !1, null, null, !1, !1, "", $0b2e6adb871a3b94$var$pl);
    a._reactRootContainer = k;
    a[$0b2e6adb871a3b94$var$uf] = k.current;
    $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
    $0b2e6adb871a3b94$var$Rk(function() {
        $0b2e6adb871a3b94$var$fl(b, k, c, d);
    });
    return k;
}
function $0b2e6adb871a3b94$var$rl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $0b2e6adb871a3b94$var$gl(g);
                h.call(a);
            };
        }
        $0b2e6adb871a3b94$var$fl(b, g, a, e);
    } else g = $0b2e6adb871a3b94$var$ql(c, b, a, e, d);
    return $0b2e6adb871a3b94$var$gl(g);
}
$0b2e6adb871a3b94$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $0b2e6adb871a3b94$var$tc(b.pendingLanes);
                0 !== c && ($0b2e6adb871a3b94$var$Cc(b, c | 1), $0b2e6adb871a3b94$var$Dk(b, $0b2e6adb871a3b94$var$B()), 0 === ($0b2e6adb871a3b94$var$K & 6) && ($0b2e6adb871a3b94$var$Gj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$jg()));
            }
            break;
        case 13:
            $0b2e6adb871a3b94$var$Rk(function() {
                var b = $0b2e6adb871a3b94$var$ih(a, 1);
                if (null !== b) {
                    var c = $0b2e6adb871a3b94$var$R();
                    $0b2e6adb871a3b94$var$gi(b, a, 1, c);
                }
            }), $0b2e6adb871a3b94$var$il(a, 1);
    }
};
$0b2e6adb871a3b94$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $0b2e6adb871a3b94$var$ih(a, 134217728);
        if (null !== b) {
            var c = $0b2e6adb871a3b94$var$R();
            $0b2e6adb871a3b94$var$gi(b, a, 134217728, c);
        }
        $0b2e6adb871a3b94$var$il(a, 134217728);
    }
};
$0b2e6adb871a3b94$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $0b2e6adb871a3b94$var$yi(a), c = $0b2e6adb871a3b94$var$ih(a, b);
        if (null !== c) {
            var d = $0b2e6adb871a3b94$var$R();
            $0b2e6adb871a3b94$var$gi(c, a, b, d);
        }
        $0b2e6adb871a3b94$var$il(a, b);
    }
};
$0b2e6adb871a3b94$var$Hc = function() {
    return $0b2e6adb871a3b94$var$C;
};
$0b2e6adb871a3b94$var$Ic = function(a, b) {
    var c = $0b2e6adb871a3b94$var$C;
    try {
        return $0b2e6adb871a3b94$var$C = a, b();
    } finally{
        $0b2e6adb871a3b94$var$C = c;
    }
};
$0b2e6adb871a3b94$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $0b2e6adb871a3b94$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $0b2e6adb871a3b94$var$Db(d);
                        if (!e) throw Error($0b2e6adb871a3b94$var$p(90));
                        $0b2e6adb871a3b94$var$Wa(d);
                        $0b2e6adb871a3b94$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $0b2e6adb871a3b94$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $0b2e6adb871a3b94$var$fb(a, !!c.multiple, b, !1);
    }
};
$0b2e6adb871a3b94$var$Gb = $0b2e6adb871a3b94$var$Qk;
$0b2e6adb871a3b94$var$Hb = $0b2e6adb871a3b94$var$Rk;
var $0b2e6adb871a3b94$var$sl = {
    usingClientEntryPoint: !1,
    Events: [
        $0b2e6adb871a3b94$var$Cb,
        $0b2e6adb871a3b94$var$ue,
        $0b2e6adb871a3b94$var$Db,
        $0b2e6adb871a3b94$var$Eb,
        $0b2e6adb871a3b94$var$Fb,
        $0b2e6adb871a3b94$var$Qk
    ]
}, $0b2e6adb871a3b94$var$tl = {
    findFiberByHostInstance: $0b2e6adb871a3b94$var$Wc,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
var $0b2e6adb871a3b94$var$ul = {
    bundleType: $0b2e6adb871a3b94$var$tl.bundleType,
    version: $0b2e6adb871a3b94$var$tl.version,
    rendererPackageName: $0b2e6adb871a3b94$var$tl.rendererPackageName,
    rendererConfig: $0b2e6adb871a3b94$var$tl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $0b2e6adb871a3b94$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $0b2e6adb871a3b94$var$tl.findFiberByHostInstance || $0b2e6adb871a3b94$var$jl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $0b2e6adb871a3b94$var$vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$0b2e6adb871a3b94$var$vl.isDisabled && $0b2e6adb871a3b94$var$vl.supportsFiber) try {
        $0b2e6adb871a3b94$var$kc = $0b2e6adb871a3b94$var$vl.inject($0b2e6adb871a3b94$var$ul), $0b2e6adb871a3b94$var$lc = $0b2e6adb871a3b94$var$vl;
    } catch (a) {}
}
$0b2e6adb871a3b94$export$ae55be85d98224ed = $0b2e6adb871a3b94$var$sl;
$0b2e6adb871a3b94$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$0b2e6adb871a3b94$var$nl(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$cl(a, b, null, c);
};
$0b2e6adb871a3b94$export$882461b6382ed46c = function(a, b) {
    if (!$0b2e6adb871a3b94$var$nl(a)) throw Error($0b2e6adb871a3b94$var$p(299));
    var c = !1, d = "", e = $0b2e6adb871a3b94$var$kl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $0b2e6adb871a3b94$var$bl(a, 1, !1, null, null, c, !1, d, e);
    a[$0b2e6adb871a3b94$var$uf] = b.current;
    $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $0b2e6adb871a3b94$var$ll(b);
};
$0b2e6adb871a3b94$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($0b2e6adb871a3b94$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($0b2e6adb871a3b94$var$p(268, a));
    }
    a = $0b2e6adb871a3b94$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$0b2e6adb871a3b94$export$cd75ccfd720a3cd4 = function(a) {
    return $0b2e6adb871a3b94$var$Rk(a);
};
$0b2e6adb871a3b94$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$ol(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$rl(null, a, b, !0, c);
};
$0b2e6adb871a3b94$export$757ceba2d55c277e = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$nl(a)) throw Error($0b2e6adb871a3b94$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $0b2e6adb871a3b94$var$kl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $0b2e6adb871a3b94$var$el(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$0b2e6adb871a3b94$var$uf] = b.current;
    $0b2e6adb871a3b94$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $0b2e6adb871a3b94$var$ml(b);
};
$0b2e6adb871a3b94$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$ol(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$rl(null, a, b, !1, c);
};
$0b2e6adb871a3b94$export$502457920280e6be = function(a) {
    if (!$0b2e6adb871a3b94$var$ol(a)) throw Error($0b2e6adb871a3b94$var$p(40));
    return a._reactRootContainer ? ($0b2e6adb871a3b94$var$Rk(function() {
        $0b2e6adb871a3b94$var$rl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$0b2e6adb871a3b94$var$uf] = null;
        });
    }), !0) : !1;
};
$0b2e6adb871a3b94$export$c78a37762a8d58e1 = $0b2e6adb871a3b94$var$Qk;
$0b2e6adb871a3b94$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$0b2e6adb871a3b94$var$ol(c)) throw Error($0b2e6adb871a3b94$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($0b2e6adb871a3b94$var$p(38));
    return $0b2e6adb871a3b94$var$rl(a, b, c, !1, d);
};
$0b2e6adb871a3b94$export$83d89fbfd8236492 = "18.3.1-next-f1338f8080-20240426";

});
parcelRegister("fO90s", function(module, exports) {
'use strict';

module.exports = (parcelRequire("gcnCG"));

});
parcelRegister("gcnCG", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $bcb017604639e9d7$export$c4744153514ff05d, (v) => $bcb017604639e9d7$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $bcb017604639e9d7$export$3e506c1ccc9cc1a7, (v) => $bcb017604639e9d7$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $bcb017604639e9d7$export$e26fe2ed2fa76875, (v) => $bcb017604639e9d7$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $bcb017604639e9d7$export$502329bbf4b505b1, (v) => $bcb017604639e9d7$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $bcb017604639e9d7$export$6e3807111c4874c4, (v) => $bcb017604639e9d7$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $bcb017604639e9d7$export$c27134553091fb3a, (v) => $bcb017604639e9d7$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $bcb017604639e9d7$export$33ee1acdc04fd2a2, (v) => $bcb017604639e9d7$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $bcb017604639e9d7$export$b00a404bbd5edef2, (v) => $bcb017604639e9d7$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $bcb017604639e9d7$export$8352ce38b91d0c62, (v) => $bcb017604639e9d7$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $bcb017604639e9d7$export$d66a1c1c77bd778b, (v) => $bcb017604639e9d7$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $bcb017604639e9d7$export$d3dfb8e4810cb555, (v) => $bcb017604639e9d7$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $bcb017604639e9d7$export$839f9183b0465a69, (v) => $bcb017604639e9d7$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $bcb017604639e9d7$export$72fdf0e06517287b, (v) => $bcb017604639e9d7$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $bcb017604639e9d7$export$4b844e58a3e414b4, (v) => $bcb017604639e9d7$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $bcb017604639e9d7$export$816d2913ae6b83b1, (v) => $bcb017604639e9d7$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $bcb017604639e9d7$export$61bcfe829111a1d0, (v) => $bcb017604639e9d7$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $bcb017604639e9d7$export$7ee8c9beb337bc3f, (v) => $bcb017604639e9d7$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $bcb017604639e9d7$export$b5836b71941fa3ed, (v) => $bcb017604639e9d7$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $bcb017604639e9d7$export$cf845f2c119da08a, (v) => $bcb017604639e9d7$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $bcb017604639e9d7$export$c4744153514ff05d;
var $bcb017604639e9d7$export$3e506c1ccc9cc1a7;
var $bcb017604639e9d7$export$e26fe2ed2fa76875;
var $bcb017604639e9d7$export$502329bbf4b505b1;
var $bcb017604639e9d7$export$6e3807111c4874c4;
var $bcb017604639e9d7$export$c27134553091fb3a;
var $bcb017604639e9d7$export$33ee1acdc04fd2a2;
var $bcb017604639e9d7$export$b00a404bbd5edef2;
var $bcb017604639e9d7$export$8352ce38b91d0c62;
var $bcb017604639e9d7$export$d66a1c1c77bd778b;
var $bcb017604639e9d7$export$d3dfb8e4810cb555;
var $bcb017604639e9d7$export$839f9183b0465a69;
var $bcb017604639e9d7$export$72fdf0e06517287b;
var $bcb017604639e9d7$export$4b844e58a3e414b4;
var $bcb017604639e9d7$export$816d2913ae6b83b1;
var $bcb017604639e9d7$export$61bcfe829111a1d0;
var $bcb017604639e9d7$export$7ee8c9beb337bc3f;
var $bcb017604639e9d7$export$b5836b71941fa3ed;
var $bcb017604639e9d7$export$cf845f2c119da08a;
'use strict';
function $bcb017604639e9d7$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $bcb017604639e9d7$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $bcb017604639e9d7$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $bcb017604639e9d7$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $bcb017604639e9d7$var$g(C, c)) n < e && 0 > $bcb017604639e9d7$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $bcb017604639e9d7$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $bcb017604639e9d7$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $bcb017604639e9d7$var$l = performance;
    $bcb017604639e9d7$export$c4744153514ff05d = function() {
        return $bcb017604639e9d7$var$l.now();
    };
} else {
    var $bcb017604639e9d7$var$p = Date, $bcb017604639e9d7$var$q = $bcb017604639e9d7$var$p.now();
    $bcb017604639e9d7$export$c4744153514ff05d = function() {
        return $bcb017604639e9d7$var$p.now() - $bcb017604639e9d7$var$q;
    };
}
var $bcb017604639e9d7$var$r = [], $bcb017604639e9d7$var$t = [], $bcb017604639e9d7$var$u = 1, $bcb017604639e9d7$var$v = null, $bcb017604639e9d7$var$y = 3, $bcb017604639e9d7$var$z = !1, $bcb017604639e9d7$var$A = !1, $bcb017604639e9d7$var$B = !1, $bcb017604639e9d7$var$D = "function" === typeof setTimeout ? setTimeout : null, $bcb017604639e9d7$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $bcb017604639e9d7$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $bcb017604639e9d7$var$G(a) {
    for(var b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t); null !== b;){
        if (null === b.callback) $bcb017604639e9d7$var$k($bcb017604639e9d7$var$t);
        else if (b.startTime <= a) $bcb017604639e9d7$var$k($bcb017604639e9d7$var$t), b.sortIndex = b.expirationTime, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$r, b);
        else break;
        b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
    }
}
function $bcb017604639e9d7$var$H(a) {
    $bcb017604639e9d7$var$B = !1;
    $bcb017604639e9d7$var$G(a);
    if (!$bcb017604639e9d7$var$A) {
        if (null !== $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r)) $bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J);
        else {
            var b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
            null !== b && $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, b.startTime - a);
        }
    }
}
function $bcb017604639e9d7$var$J(a, b) {
    $bcb017604639e9d7$var$A = !1;
    $bcb017604639e9d7$var$B && ($bcb017604639e9d7$var$B = !1, $bcb017604639e9d7$var$E($bcb017604639e9d7$var$L), $bcb017604639e9d7$var$L = -1);
    $bcb017604639e9d7$var$z = !0;
    var c = $bcb017604639e9d7$var$y;
    try {
        $bcb017604639e9d7$var$G(b);
        for($bcb017604639e9d7$var$v = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r); null !== $bcb017604639e9d7$var$v && (!($bcb017604639e9d7$var$v.expirationTime > b) || a && !$bcb017604639e9d7$var$M());){
            var d = $bcb017604639e9d7$var$v.callback;
            if ("function" === typeof d) {
                $bcb017604639e9d7$var$v.callback = null;
                $bcb017604639e9d7$var$y = $bcb017604639e9d7$var$v.priorityLevel;
                var e = d($bcb017604639e9d7$var$v.expirationTime <= b);
                b = $bcb017604639e9d7$export$c4744153514ff05d();
                "function" === typeof e ? $bcb017604639e9d7$var$v.callback = e : $bcb017604639e9d7$var$v === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r) && $bcb017604639e9d7$var$k($bcb017604639e9d7$var$r);
                $bcb017604639e9d7$var$G(b);
            } else $bcb017604639e9d7$var$k($bcb017604639e9d7$var$r);
            $bcb017604639e9d7$var$v = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r);
        }
        if (null !== $bcb017604639e9d7$var$v) var w = !0;
        else {
            var m = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
            null !== m && $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $bcb017604639e9d7$var$v = null, $bcb017604639e9d7$var$y = c, $bcb017604639e9d7$var$z = !1;
    }
}
var $bcb017604639e9d7$var$N = !1, $bcb017604639e9d7$var$O = null, $bcb017604639e9d7$var$L = -1, $bcb017604639e9d7$var$P = 5, $bcb017604639e9d7$var$Q = -1;
function $bcb017604639e9d7$var$M() {
    return $bcb017604639e9d7$export$c4744153514ff05d() - $bcb017604639e9d7$var$Q < $bcb017604639e9d7$var$P ? !1 : !0;
}
function $bcb017604639e9d7$var$R() {
    if (null !== $bcb017604639e9d7$var$O) {
        var a = $bcb017604639e9d7$export$c4744153514ff05d();
        $bcb017604639e9d7$var$Q = a;
        var b = !0;
        try {
            b = $bcb017604639e9d7$var$O(!0, a);
        } finally{
            b ? $bcb017604639e9d7$var$S() : ($bcb017604639e9d7$var$N = !1, $bcb017604639e9d7$var$O = null);
        }
    } else $bcb017604639e9d7$var$N = !1;
}
var $bcb017604639e9d7$var$S;
if ("function" === typeof $bcb017604639e9d7$var$F) $bcb017604639e9d7$var$S = function() {
    $bcb017604639e9d7$var$F($bcb017604639e9d7$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $bcb017604639e9d7$var$T = new MessageChannel, $bcb017604639e9d7$var$U = $bcb017604639e9d7$var$T.port2;
    $bcb017604639e9d7$var$T.port1.onmessage = $bcb017604639e9d7$var$R;
    $bcb017604639e9d7$var$S = function() {
        $bcb017604639e9d7$var$U.postMessage(null);
    };
} else $bcb017604639e9d7$var$S = function() {
    $bcb017604639e9d7$var$D($bcb017604639e9d7$var$R, 0);
};
function $bcb017604639e9d7$var$I(a) {
    $bcb017604639e9d7$var$O = a;
    $bcb017604639e9d7$var$N || ($bcb017604639e9d7$var$N = !0, $bcb017604639e9d7$var$S());
}
function $bcb017604639e9d7$var$K(a, b) {
    $bcb017604639e9d7$var$L = $bcb017604639e9d7$var$D(function() {
        a($bcb017604639e9d7$export$c4744153514ff05d());
    }, b);
}
$bcb017604639e9d7$export$3e506c1ccc9cc1a7 = 5;
$bcb017604639e9d7$export$e26fe2ed2fa76875 = 1;
$bcb017604639e9d7$export$502329bbf4b505b1 = 4;
$bcb017604639e9d7$export$6e3807111c4874c4 = 3;
$bcb017604639e9d7$export$c27134553091fb3a = null;
$bcb017604639e9d7$export$33ee1acdc04fd2a2 = 2;
$bcb017604639e9d7$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$bcb017604639e9d7$export$8352ce38b91d0c62 = function() {
    $bcb017604639e9d7$var$A || $bcb017604639e9d7$var$z || ($bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J));
};
$bcb017604639e9d7$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $bcb017604639e9d7$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$bcb017604639e9d7$export$d3dfb8e4810cb555 = function() {
    return $bcb017604639e9d7$var$y;
};
$bcb017604639e9d7$export$839f9183b0465a69 = function() {
    return $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r);
};
$bcb017604639e9d7$export$72fdf0e06517287b = function(a) {
    switch($bcb017604639e9d7$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $bcb017604639e9d7$var$y;
    }
    var c = $bcb017604639e9d7$var$y;
    $bcb017604639e9d7$var$y = b;
    try {
        return a();
    } finally{
        $bcb017604639e9d7$var$y = c;
    }
};
$bcb017604639e9d7$export$4b844e58a3e414b4 = function() {};
$bcb017604639e9d7$export$816d2913ae6b83b1 = function() {};
$bcb017604639e9d7$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $bcb017604639e9d7$var$y;
    $bcb017604639e9d7$var$y = a;
    try {
        return b();
    } finally{
        $bcb017604639e9d7$var$y = c;
    }
};
$bcb017604639e9d7$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $bcb017604639e9d7$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $bcb017604639e9d7$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$t, a), null === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r) && a === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t) && ($bcb017604639e9d7$var$B ? ($bcb017604639e9d7$var$E($bcb017604639e9d7$var$L), $bcb017604639e9d7$var$L = -1) : $bcb017604639e9d7$var$B = !0, $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, c - d))) : (a.sortIndex = e, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$r, a), $bcb017604639e9d7$var$A || $bcb017604639e9d7$var$z || ($bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J)));
    return a;
};
$bcb017604639e9d7$export$b5836b71941fa3ed = $bcb017604639e9d7$var$M;
$bcb017604639e9d7$export$cf845f2c119da08a = function(a) {
    var b = $bcb017604639e9d7$var$y;
    return function() {
        var c = $bcb017604639e9d7$var$y;
        $bcb017604639e9d7$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $bcb017604639e9d7$var$y = c;
        }
    };
};

});



parcelRegister("5svTu", function(module, exports) {
module.exports = function eventify(subject) {
    $3f984ebf2aba86a9$var$validateSubject(subject);
    var eventsStorage = $3f984ebf2aba86a9$var$createEventsStorage(subject);
    subject.on = eventsStorage.on;
    subject.off = eventsStorage.off;
    subject.fire = eventsStorage.fire;
    return subject;
};
function $3f984ebf2aba86a9$var$createEventsStorage(subject) {
    // Store all event listeners to this hash. Key is event name, value is array
    // of callback records.
    //
    // A callback record consists of callback function and its optional context:
    // { 'eventName' => [{callback: function, ctx: object}] }
    var registeredEvents = Object.create(null);
    return {
        on: function(eventName, callback, ctx) {
            if (typeof callback !== 'function') throw new Error('callback is expected to be a function');
            var handlers = registeredEvents[eventName];
            if (!handlers) handlers = registeredEvents[eventName] = [];
            handlers.push({
                callback: callback,
                ctx: ctx
            });
            return subject;
        },
        off: function(eventName, callback) {
            var wantToRemoveAll = typeof eventName === 'undefined';
            if (wantToRemoveAll) {
                // Killing old events storage should be enough in this case:
                registeredEvents = Object.create(null);
                return subject;
            }
            if (registeredEvents[eventName]) {
                var deleteAllCallbacksForEvent = typeof callback !== 'function';
                if (deleteAllCallbacksForEvent) delete registeredEvents[eventName];
                else {
                    var callbacks = registeredEvents[eventName];
                    for(var i = 0; i < callbacks.length; ++i)if (callbacks[i].callback === callback) callbacks.splice(i, 1);
                }
            }
            return subject;
        },
        fire: function(eventName) {
            var callbacks = registeredEvents[eventName];
            if (!callbacks) return subject;
            var fireArguments;
            if (arguments.length > 1) fireArguments = Array.prototype.splice.call(arguments, 1);
            for(var i = 0; i < callbacks.length; ++i){
                var callbackInfo = callbacks[i];
                callbackInfo.callback.apply(callbackInfo.ctx, fireArguments);
            }
            return subject;
        }
    };
}
function $3f984ebf2aba86a9$var$validateSubject(subject) {
    if (!subject) throw new Error('Eventify cannot use falsy object as events subject');
    var reservedWords = [
        'on',
        'fire',
        'off'
    ];
    for(var i = 0; i < reservedWords.length; ++i){
        if (subject.hasOwnProperty(reservedWords[i])) throw new Error("Subject cannot be eventified, since it already has property '" + reservedWords[i] + "'");
    }
}

});

parcelRegister("6y6y7", function(module, exports) {
/**
 * Manages a simulation of physical forces acting on bodies and springs.
 */ module.exports = $4c4aff9898cca392$var$createPhysicsSimulator;

var $3Y3RK = parcelRequire("3Y3RK");

var $kF3pF = parcelRequire("kF3pF");

var $cCWWN = parcelRequire("cCWWN");

var $kpttX = parcelRequire("kpttX");

var $gIVX5 = parcelRequire("gIVX5");

var $fmqpS = parcelRequire("fmqpS");
var $4c4aff9898cca392$var$dimensionalCache = {};




function $4c4aff9898cca392$var$createPhysicsSimulator(settings) {
    var Spring = (parcelRequire("48be4"));
    var merge = (parcelRequire("eRWCk"));
    var eventify = (parcelRequire("5svTu"));
    if (settings) {
        // Check for names from older versions of the layout
        if (settings.springCoeff !== undefined) throw new Error('springCoeff was renamed to springCoefficient');
        if (settings.dragCoeff !== undefined) throw new Error('dragCoeff was renamed to dragCoefficient');
    }
    settings = merge(settings, {
        /**
       * Ideal length for links (springs in physical model).
       */ springLength: 10,
        /**
       * Hook's law coefficient. 1 - solid spring.
       */ springCoefficient: 0.8,
        /**
       * Coulomb's law coefficient. It's used to repel nodes thus should be negative
       * if you make it positive nodes start attract each other :).
       */ gravity: -12,
        /**
       * Theta coefficient from Barnes Hut simulation. Ranged between (0, 1).
       * The closer it's to 1 the more nodes algorithm will have to go through.
       * Setting it to one makes Barnes Hut simulation no different from
       * brute-force forces calculation (each node is considered).
       */ theta: 0.8,
        /**
       * Drag force coefficient. Used to slow down system, thus should be less than 1.
       * The closer it is to 0 the less tight system will be.
       */ dragCoefficient: 0.9,
        /**
       * Default time step (dt) for forces integration
       */ timeStep: 0.5,
        /**
       * Adaptive time step uses average spring length to compute actual time step:
       * See: https://twitter.com/anvaka/status/1293067160755957760
       */ adaptiveTimeStepWeight: 0,
        /**
       * This parameter defines number of dimensions of the space where simulation
       * is performed. 
       */ dimensions: 2,
        /**
       * In debug mode more checks are performed, this will help you catch errors
       * quickly, however for production build it is recommended to turn off this flag
       * to speed up computation.
       */ debug: false
    });
    var factory = $4c4aff9898cca392$var$dimensionalCache[settings.dimensions];
    if (!factory) {
        var dimensions = settings.dimensions;
        factory = {
            Body: $3Y3RK(dimensions, settings.debug),
            createQuadTree: $kF3pF(dimensions),
            createBounds: $cCWWN(dimensions),
            createDragForce: $kpttX(dimensions),
            createSpringForce: $gIVX5(dimensions),
            integrate: $fmqpS(dimensions)
        };
        $4c4aff9898cca392$var$dimensionalCache[dimensions] = factory;
    }
    var Body = factory.Body;
    var createQuadTree = factory.createQuadTree;
    var createBounds = factory.createBounds;
    var createDragForce = factory.createDragForce;
    var createSpringForce = factory.createSpringForce;
    var integrate = factory.integrate;
    var createBody = (pos)=>new Body(pos);
    var random = (parcelRequire("8tnak")).random(42);
    var bodies = []; // Bodies in this simulation.
    var springs = []; // Springs in this simulation.
    var quadTree = createQuadTree(settings, random);
    var bounds = createBounds(bodies, settings, random);
    var springForce = createSpringForce(settings, random);
    var dragForce = createDragForce(settings);
    var totalMovement = 0; // how much movement we made on last step
    var forces = [];
    var forceMap = new Map();
    var iterationNumber = 0;
    addForce('nbody', nbodyForce);
    addForce('spring', updateSpringForce);
    var publicApi = {
        /**
     * Array of bodies, registered with current simulator
     *
     * Note: To add new body, use addBody() method. This property is only
     * exposed for testing/performance purposes.
     */ bodies: bodies,
        quadTree: quadTree,
        /**
     * Array of springs, registered with current simulator
     *
     * Note: To add new spring, use addSpring() method. This property is only
     * exposed for testing/performance purposes.
     */ springs: springs,
        /**
     * Returns settings with which current simulator was initialized
     */ settings: settings,
        /**
     * Adds a new force to simulation
     */ addForce: addForce,
        /**
     * Removes a force from the simulation.
     */ removeForce: removeForce,
        /**
     * Returns a map of all registered forces.
     */ getForces: getForces,
        /**
     * Performs one step of force simulation.
     *
     * @returns {boolean} true if system is considered stable; False otherwise.
     */ step: function() {
            for(var i = 0; i < forces.length; ++i)forces[i](iterationNumber);
            var movement = integrate(bodies, settings.timeStep, settings.adaptiveTimeStepWeight);
            iterationNumber += 1;
            return movement;
        },
        /**
     * Adds body to the system
     *
     * @param {ngraph.physics.primitives.Body} body physical body
     *
     * @returns {ngraph.physics.primitives.Body} added body
     */ addBody: function(body) {
            if (!body) throw new Error('Body is required');
            bodies.push(body);
            return body;
        },
        /**
     * Adds body to the system at given position
     *
     * @param {Object} pos position of a body
     *
     * @returns {ngraph.physics.primitives.Body} added body
     */ addBodyAt: function(pos) {
            if (!pos) throw new Error('Body position is required');
            var body = createBody(pos);
            bodies.push(body);
            return body;
        },
        /**
     * Removes body from the system
     *
     * @param {ngraph.physics.primitives.Body} body to remove
     *
     * @returns {Boolean} true if body found and removed. falsy otherwise;
     */ removeBody: function(body) {
            if (!body) return;
            var idx = bodies.indexOf(body);
            if (idx < 0) return;
            bodies.splice(idx, 1);
            if (bodies.length === 0) bounds.reset();
            return true;
        },
        /**
     * Adds a spring to this simulation.
     *
     * @returns {Object} - a handle for a spring. If you want to later remove
     * spring pass it to removeSpring() method.
     */ addSpring: function(body1, body2, springLength, springCoefficient) {
            if (!body1 || !body2) throw new Error('Cannot add null spring to force simulator');
            if (typeof springLength !== 'number') springLength = -1; // assume global configuration
            var spring = new Spring(body1, body2, springLength, springCoefficient >= 0 ? springCoefficient : -1);
            springs.push(spring);
            // TODO: could mark simulator as dirty.
            return spring;
        },
        /**
     * Returns amount of movement performed on last step() call
     */ getTotalMovement: function() {
            return totalMovement;
        },
        /**
     * Removes spring from the system
     *
     * @param {Object} spring to remove. Spring is an object returned by addSpring
     *
     * @returns {Boolean} true if spring found and removed. falsy otherwise;
     */ removeSpring: function(spring) {
            if (!spring) return;
            var idx = springs.indexOf(spring);
            if (idx > -1) {
                springs.splice(idx, 1);
                return true;
            }
        },
        getBestNewBodyPosition: function(neighbors) {
            return bounds.getBestNewPosition(neighbors);
        },
        /**
     * Returns bounding box which covers all bodies
     */ getBBox: getBoundingBox,
        getBoundingBox: getBoundingBox,
        invalidateBBox: function() {
            console.warn('invalidateBBox() is deprecated, bounds always recomputed on `getBBox()` call');
        },
        // TODO: Move the force specific stuff to force
        gravity: function(value) {
            if (value !== undefined) {
                settings.gravity = value;
                quadTree.options({
                    gravity: value
                });
                return this;
            } else return settings.gravity;
        },
        theta: function(value) {
            if (value !== undefined) {
                settings.theta = value;
                quadTree.options({
                    theta: value
                });
                return this;
            } else return settings.theta;
        },
        /**
     * Returns pseudo-random number generator instance.
     */ random: random
    };
    // allow settings modification via public API:
    $4c4aff9898cca392$var$expose(settings, publicApi);
    eventify(publicApi);
    return publicApi;
    function getBoundingBox() {
        bounds.update();
        return bounds.box;
    }
    function addForce(forceName, forceFunction) {
        if (forceMap.has(forceName)) throw new Error('Force ' + forceName + ' is already added');
        forceMap.set(forceName, forceFunction);
        forces.push(forceFunction);
    }
    function removeForce(forceName) {
        var forceIndex = forces.indexOf(forceMap.get(forceName));
        if (forceIndex < 0) return;
        forces.splice(forceIndex, 1);
        forceMap.delete(forceName);
    }
    function getForces() {
        // TODO: Should I trust them or clone the forces?
        return forceMap;
    }
    function nbodyForce() {
        if (bodies.length === 0) return;
        quadTree.insertBodies(bodies);
        var i = bodies.length;
        while(i--){
            var body = bodies[i];
            if (!body.isPinned) {
                body.reset();
                quadTree.updateBodyForce(body);
                dragForce.update(body);
            }
        }
    }
    function updateSpringForce() {
        var i = springs.length;
        while(i--)springForce.update(springs[i]);
    }
}
function $4c4aff9898cca392$var$expose(settings, target) {
    for(var key in settings)$4c4aff9898cca392$var$augment(settings, target, key);
}
function $4c4aff9898cca392$var$augment(source, target, key) {
    if (!source.hasOwnProperty(key)) return;
    if (typeof target[key] === 'function') // this accessor is already defined. Ignore it
    return;
    var sourceIsNumber = Number.isFinite(source[key]);
    if (sourceIsNumber) target[key] = function(value) {
        if (value !== undefined) {
            if (!Number.isFinite(value)) throw new Error('Value of ' + key + ' should be a valid number.');
            source[key] = value;
            return target;
        }
        return source[key];
    };
    else target[key] = function(value) {
        if (value !== undefined) {
            source[key] = value;
            return target;
        }
        return source[key];
    };
}

});
parcelRegister("3Y3RK", function(module, exports) {

var $ehEoR = parcelRequire("ehEoR");
module.exports = $2e39f95f381af0d6$var$generateCreateBodyFunction;
module.exports.generateCreateBodyFunctionBody = $2e39f95f381af0d6$var$generateCreateBodyFunctionBody;
// InlineTransform: getVectorCode
module.exports.getVectorCode = $2e39f95f381af0d6$var$getVectorCode;
// InlineTransform: getBodyCode
module.exports.getBodyCode = $2e39f95f381af0d6$var$getBodyCode;
// InlineTransformExport: module.exports = function() { return Body; }
function $2e39f95f381af0d6$var$generateCreateBodyFunction(dimension, debugSetters) {
    let code = $2e39f95f381af0d6$var$generateCreateBodyFunctionBody(dimension, debugSetters);
    let { Body: Body } = new Function(code)();
    return Body;
}
function $2e39f95f381af0d6$var$generateCreateBodyFunctionBody(dimension, debugSetters) {
    let code = `
${$2e39f95f381af0d6$var$getVectorCode(dimension, debugSetters)}
${$2e39f95f381af0d6$var$getBodyCode(dimension, debugSetters)}
return {Body: Body, Vector: Vector};
`;
    return code;
}
function $2e39f95f381af0d6$var$getBodyCode(dimension) {
    let pattern = $ehEoR(dimension);
    let variableList = pattern('{var}', {
        join: ', '
    });
    return `
function Body(${variableList}) {
  this.isPinned = false;
  this.pos = new Vector(${variableList});
  this.force = new Vector();
  this.velocity = new Vector();
  this.mass = 1;

  this.springCount = 0;
  this.springLength = 0;
}

Body.prototype.reset = function() {
  this.force.reset();
  this.springCount = 0;
  this.springLength = 0;
}

Body.prototype.setPosition = function (${variableList}) {
  ${pattern('this.pos.{var} = {var} || 0;', {
        indent: 2
    })}
};`;
}
function $2e39f95f381af0d6$var$getVectorCode(dimension, debugSetters) {
    let pattern = $ehEoR(dimension);
    let setters = '';
    if (debugSetters) setters = `${pattern("\n\
   var v{var};\n\
Object.defineProperty(this, '{var}', {\n\
  set: function(v) { \n\
    if (!Number.isFinite(v)) throw new Error('Cannot set non-numbers to {var}');\n\
    v{var} = v; \n\
  },\n\
  get: function() { return v{var}; }\n\
});")}`;
    let variableList = pattern('{var}', {
        join: ', '
    });
    return `function Vector(${variableList}) {
  ${setters}
    if (typeof arguments[0] === 'object') {
      // could be another vector
      let v = arguments[0];
      ${pattern('if (!Number.isFinite(v.{var})) throw new Error("Expected value is not a finite number at Vector constructor ({var})");', {
        indent: 4
    })}
      ${pattern('this.{var} = v.{var};', {
        indent: 4
    })}
    } else {
      ${pattern('this.{var} = typeof {var} === "number" ? {var} : 0;', {
        indent: 4
    })}
    }
  }
  
  Vector.prototype.reset = function () {
    ${pattern('this.{var} = ', {
        join: ''
    })}0;
  };`;
}

});
parcelRegister("ehEoR", function(module, exports) {

var $hnBDe = parcelRequire("hnBDe");
module.exports = function createPatternBuilder(dimension) {
    return pattern;
    function pattern(template, config) {
        let indent = config && config.indent || 0;
        let join = config && config.join !== undefined ? config.join : '\n';
        let indentString = Array(indent + 1).join(' ');
        let buffer = [];
        for(let i = 0; i < dimension; ++i){
            let variableName = $hnBDe(i);
            let prefix = i === 0 ? '' : indentString;
            buffer.push(prefix + template.replace(/{var}/g, variableName));
        }
        return buffer.join(join);
    }
};

});
parcelRegister("hnBDe", function(module, exports) {
module.exports = function getVariableName(index) {
    if (index === 0) return 'x';
    if (index === 1) return 'y';
    if (index === 2) return 'z';
    return 'c' + (index + 1);
};

});



parcelRegister("kF3pF", function(module, exports) {

var $ehEoR = parcelRequire("ehEoR");

var $hnBDe = parcelRequire("hnBDe");
module.exports = $f0aa48bc1bb29501$var$generateQuadTreeFunction;
module.exports.generateQuadTreeFunctionBody = $f0aa48bc1bb29501$var$generateQuadTreeFunctionBody;
// These exports are for InlineTransform tool.
// InlineTransform: getInsertStackCode
module.exports.getInsertStackCode = $f0aa48bc1bb29501$var$getInsertStackCode;
// InlineTransform: getQuadNodeCode
module.exports.getQuadNodeCode = $f0aa48bc1bb29501$var$getQuadNodeCode;
// InlineTransform: isSamePosition
module.exports.isSamePosition = $f0aa48bc1bb29501$var$isSamePosition;
// InlineTransform: getChildBodyCode
module.exports.getChildBodyCode = $f0aa48bc1bb29501$var$getChildBodyCode;
// InlineTransform: setChildBodyCode
module.exports.setChildBodyCode = $f0aa48bc1bb29501$var$setChildBodyCode;
function $f0aa48bc1bb29501$var$generateQuadTreeFunction(dimension) {
    let code = $f0aa48bc1bb29501$var$generateQuadTreeFunctionBody(dimension);
    return new Function(code)();
}
function $f0aa48bc1bb29501$var$generateQuadTreeFunctionBody(dimension) {
    let pattern = $ehEoR(dimension);
    let quadCount = Math.pow(2, dimension);
    let code = `
${$f0aa48bc1bb29501$var$getInsertStackCode()}
${$f0aa48bc1bb29501$var$getQuadNodeCode(dimension)}
${$f0aa48bc1bb29501$var$isSamePosition(dimension)}
${$f0aa48bc1bb29501$var$getChildBodyCode(dimension)}
${$f0aa48bc1bb29501$var$setChildBodyCode(dimension)}

function createQuadTree(options, random) {
  options = options || {};
  options.gravity = typeof options.gravity === 'number' ? options.gravity : -1;
  options.theta = typeof options.theta === 'number' ? options.theta : 0.8;

  var gravity = options.gravity;
  var updateQueue = [];
  var insertStack = new InsertStack();
  var theta = options.theta;

  var nodesCache = [];
  var currentInCache = 0;
  var root = newNode();

  return {
    insertBodies: insertBodies,

    /**
     * Gets root node if it is present
     */
    getRoot: function() {
      return root;
    },

    updateBodyForce: update,

    options: function(newOptions) {
      if (newOptions) {
        if (typeof newOptions.gravity === 'number') {
          gravity = newOptions.gravity;
        }
        if (typeof newOptions.theta === 'number') {
          theta = newOptions.theta;
        }

        return this;
      }

      return {
        gravity: gravity,
        theta: theta
      };
    }
  };

  function newNode() {
    // To avoid pressure on GC we reuse nodes.
    var node = nodesCache[currentInCache];
    if (node) {
${assignQuads('      node.')}
      node.body = null;
      node.mass = ${pattern('node.mass_{var} = ', {
        join: ''
    })}0;
      ${pattern('node.min_{var} = node.max_{var} = ', {
        join: ''
    })}0;
    } else {
      node = new QuadNode();
      nodesCache[currentInCache] = node;
    }

    ++currentInCache;
    return node;
  }

  function update(sourceBody) {
    var queue = updateQueue;
    var v;
    ${pattern('var d{var};', {
        indent: 4
    })}
    var r; 
    ${pattern('var f{var} = 0;', {
        indent: 4
    })}
    var queueLength = 1;
    var shiftIdx = 0;
    var pushIdx = 1;

    queue[0] = root;

    while (queueLength) {
      var node = queue[shiftIdx];
      var body = node.body;

      queueLength -= 1;
      shiftIdx += 1;
      var differentBody = (body !== sourceBody);
      if (body && differentBody) {
        // If the current node is a leaf node (and it is not source body),
        // calculate the force exerted by the current node on body, and add this
        // amount to body's net force.
        ${pattern('d{var} = body.pos.{var} - sourceBody.pos.{var};', {
        indent: 8
    })}
        r = Math.sqrt(${pattern('d{var} * d{var}', {
        join: ' + '
    })});

        if (r === 0) {
          // Poor man's protection against zero distance.
          ${pattern('d{var} = (random.nextDouble() - 0.5) / 50;', {
        indent: 10
    })}
          r = Math.sqrt(${pattern('d{var} * d{var}', {
        join: ' + '
    })});
        }

        // This is standard gravitation force calculation but we divide
        // by r^3 to save two operations when normalizing force vector.
        v = gravity * body.mass * sourceBody.mass / (r * r * r);
        ${pattern('f{var} += v * d{var};', {
        indent: 8
    })}
      } else if (differentBody) {
        // Otherwise, calculate the ratio s / r,  where s is the width of the region
        // represented by the internal node, and r is the distance between the body
        // and the node's center-of-mass
        ${pattern('d{var} = node.mass_{var} / node.mass - sourceBody.pos.{var};', {
        indent: 8
    })}
        r = Math.sqrt(${pattern('d{var} * d{var}', {
        join: ' + '
    })});

        if (r === 0) {
          // Sorry about code duplication. I don't want to create many functions
          // right away. Just want to see performance first.
          ${pattern('d{var} = (random.nextDouble() - 0.5) / 50;', {
        indent: 10
    })}
          r = Math.sqrt(${pattern('d{var} * d{var}', {
        join: ' + '
    })});
        }
        // If s / r < \u{3B8}, treat this internal node as a single body, and calculate the
        // force it exerts on sourceBody, and add this amount to sourceBody's net force.
        if ((node.max_${$hnBDe(0)} - node.min_${$hnBDe(0)}) / r < theta) {
          // in the if statement above we consider node's width only
          // because the region was made into square during tree creation.
          // Thus there is no difference between using width or height.
          v = gravity * node.mass * sourceBody.mass / (r * r * r);
          ${pattern('f{var} += v * d{var};', {
        indent: 10
    })}
        } else {
          // Otherwise, run the procedure recursively on each of the current node's children.

          // I intentionally unfolded this loop, to save several CPU cycles.
${runRecursiveOnChildren()}
        }
      }
    }

    ${pattern('sourceBody.force.{var} += f{var};', {
        indent: 4
    })}
  }

  function insertBodies(bodies) {
    ${pattern('var {var}min = Number.MAX_VALUE;', {
        indent: 4
    })}
    ${pattern('var {var}max = Number.MIN_VALUE;', {
        indent: 4
    })}
    var i = bodies.length;

    // To reduce quad tree depth we are looking for exact bounding box of all particles.
    while (i--) {
      var pos = bodies[i].pos;
      ${pattern('if (pos.{var} < {var}min) {var}min = pos.{var};', {
        indent: 6
    })}
      ${pattern('if (pos.{var} > {var}max) {var}max = pos.{var};', {
        indent: 6
    })}
    }

    // Makes the bounds square.
    var maxSideLength = -Infinity;
    ${pattern('if ({var}max - {var}min > maxSideLength) maxSideLength = {var}max - {var}min ;', {
        indent: 4
    })}

    currentInCache = 0;
    root = newNode();
    ${pattern('root.min_{var} = {var}min;', {
        indent: 4
    })}
    ${pattern('root.max_{var} = {var}min + maxSideLength;', {
        indent: 4
    })}

    i = bodies.length - 1;
    if (i >= 0) {
      root.body = bodies[i];
    }
    while (i--) {
      insert(bodies[i], root);
    }
  }

  function insert(newBody) {
    insertStack.reset();
    insertStack.push(root, newBody);

    while (!insertStack.isEmpty()) {
      var stackItem = insertStack.pop();
      var node = stackItem.node;
      var body = stackItem.body;

      if (!node.body) {
        // This is internal node. Update the total mass of the node and center-of-mass.
        ${pattern('var {var} = body.pos.{var};', {
        indent: 8
    })}
        node.mass += body.mass;
        ${pattern('node.mass_{var} += body.mass * {var};', {
        indent: 8
    })}

        // Recursively insert the body in the appropriate quadrant.
        // But first find the appropriate quadrant.
        var quadIdx = 0; // Assume we are in the 0's quad.
        ${pattern('var min_{var} = node.min_{var};', {
        indent: 8
    })}
        ${pattern('var max_{var} = (min_{var} + node.max_{var}) / 2;', {
        indent: 8
    })}

${assignInsertionQuadIndex(8)}

        var child = getChild(node, quadIdx);

        if (!child) {
          // The node is internal but this quadrant is not taken. Add
          // subnode to it.
          child = newNode();
          ${pattern('child.min_{var} = min_{var};', {
        indent: 10
    })}
          ${pattern('child.max_{var} = max_{var};', {
        indent: 10
    })}
          child.body = body;

          setChild(node, quadIdx, child);
        } else {
          // continue searching in this quadrant.
          insertStack.push(child, body);
        }
      } else {
        // We are trying to add to the leaf node.
        // We have to convert current leaf into internal node
        // and continue adding two nodes.
        var oldBody = node.body;
        node.body = null; // internal nodes do not cary bodies

        if (isSamePosition(oldBody.pos, body.pos)) {
          // Prevent infinite subdivision by bumping one node
          // anywhere in this quadrant
          var retriesCount = 3;
          do {
            var offset = random.nextDouble();
            ${pattern('var d{var} = (node.max_{var} - node.min_{var}) * offset;', {
        indent: 12
    })}

            ${pattern('oldBody.pos.{var} = node.min_{var} + d{var};', {
        indent: 12
    })}
            retriesCount -= 1;
            // Make sure we don't bump it out of the box. If we do, next iteration should fix it
          } while (retriesCount > 0 && isSamePosition(oldBody.pos, body.pos));

          if (retriesCount === 0 && isSamePosition(oldBody.pos, body.pos)) {
            // This is very bad, we ran out of precision.
            // if we do not return from the method we'll get into
            // infinite loop here. So we sacrifice correctness of layout, and keep the app running
            // Next layout iteration should get larger bounding box in the first step and fix this
            return;
          }
        }
        // Next iteration should subdivide node further.
        insertStack.push(node, oldBody);
        insertStack.push(node, body);
      }
    }
  }
}
return createQuadTree;

`;
    return code;
    function assignInsertionQuadIndex(indentCount) {
        let insertionCode = [];
        let indent = Array(indentCount + 1).join(' ');
        for(let i = 0; i < dimension; ++i){
            insertionCode.push(indent + `if (${$hnBDe(i)} > max_${$hnBDe(i)}) {`);
            insertionCode.push(indent + `  quadIdx = quadIdx + ${Math.pow(2, i)};`);
            insertionCode.push(indent + `  min_${$hnBDe(i)} = max_${$hnBDe(i)};`);
            insertionCode.push(indent + `  max_${$hnBDe(i)} = node.max_${$hnBDe(i)};`);
            insertionCode.push(indent + `}`);
        }
        return insertionCode.join('\n');
    // if (x > max_x) { // somewhere in the eastern part.
    //   quadIdx = quadIdx + 1;
    //   left = right;
    //   right = node.right;
    // }
    }
    function runRecursiveOnChildren() {
        let indent = Array(11).join(' ');
        let recursiveCode = [];
        for(let i = 0; i < quadCount; ++i){
            recursiveCode.push(indent + `if (node.quad${i}) {`);
            recursiveCode.push(indent + `  queue[pushIdx] = node.quad${i};`);
            recursiveCode.push(indent + `  queueLength += 1;`);
            recursiveCode.push(indent + `  pushIdx += 1;`);
            recursiveCode.push(indent + `}`);
        }
        return recursiveCode.join('\n');
    // if (node.quad0) {
    //   queue[pushIdx] = node.quad0;
    //   queueLength += 1;
    //   pushIdx += 1;
    // }
    }
    function assignQuads(indent) {
        // this.quad0 = null;
        // this.quad1 = null;
        // this.quad2 = null;
        // this.quad3 = null;
        let quads = [];
        for(let i = 0; i < quadCount; ++i)quads.push(`${indent}quad${i} = null;`);
        return quads.join('\n');
    }
}
function $f0aa48bc1bb29501$var$isSamePosition(dimension) {
    let pattern = $ehEoR(dimension);
    return `
  function isSamePosition(point1, point2) {
    ${pattern('var d{var} = Math.abs(point1.{var} - point2.{var});', {
        indent: 2
    })}
  
    return ${pattern('d{var} < 1e-8', {
        join: ' && '
    })};
  }  
`;
}
function $f0aa48bc1bb29501$var$setChildBodyCode(dimension) {
    var quadCount = Math.pow(2, dimension);
    return `
function setChild(node, idx, child) {
  ${setChildBody()}
}`;
    function setChildBody() {
        let childBody = [];
        for(let i = 0; i < quadCount; ++i){
            let prefix = i === 0 ? '  ' : '  else ';
            childBody.push(`${prefix}if (idx === ${i}) node.quad${i} = child;`);
        }
        return childBody.join('\n');
    // if (idx === 0) node.quad0 = child;
    // else if (idx === 1) node.quad1 = child;
    // else if (idx === 2) node.quad2 = child;
    // else if (idx === 3) node.quad3 = child;
    }
}
function $f0aa48bc1bb29501$var$getChildBodyCode(dimension) {
    return `function getChild(node, idx) {
${getChildBody()}
  return null;
}`;
    function getChildBody() {
        let childBody = [];
        let quadCount = Math.pow(2, dimension);
        for(let i = 0; i < quadCount; ++i)childBody.push(`  if (idx === ${i}) return node.quad${i};`);
        return childBody.join('\n');
    // if (idx === 0) return node.quad0;
    // if (idx === 1) return node.quad1;
    // if (idx === 2) return node.quad2;
    // if (idx === 3) return node.quad3;
    }
}
function $f0aa48bc1bb29501$var$getQuadNodeCode(dimension) {
    let pattern = $ehEoR(dimension);
    let quadCount = Math.pow(2, dimension);
    var quadNodeCode = `
function QuadNode() {
  // body stored inside this node. In quad tree only leaf nodes (by construction)
  // contain bodies:
  this.body = null;

  // Child nodes are stored in quads. Each quad is presented by number:
  // 0 | 1
  // -----
  // 2 | 3
${assignQuads('  this.')}

  // Total mass of current node
  this.mass = 0;

  // Center of mass coordinates
  ${pattern('this.mass_{var} = 0;', {
        indent: 2
    })}

  // bounding box coordinates
  ${pattern('this.min_{var} = 0;', {
        indent: 2
    })}
  ${pattern('this.max_{var} = 0;', {
        indent: 2
    })}
}
`;
    return quadNodeCode;
    function assignQuads(indent) {
        // this.quad0 = null;
        // this.quad1 = null;
        // this.quad2 = null;
        // this.quad3 = null;
        let quads = [];
        for(let i = 0; i < quadCount; ++i)quads.push(`${indent}quad${i} = null;`);
        return quads.join('\n');
    }
}
function $f0aa48bc1bb29501$var$getInsertStackCode() {
    return `
/**
 * Our implementation of QuadTree is non-recursive to avoid GC hit
 * This data structure represent stack of elements
 * which we are trying to insert into quad tree.
 */
function InsertStack () {
    this.stack = [];
    this.popIdx = 0;
}

InsertStack.prototype = {
    isEmpty: function() {
        return this.popIdx === 0;
    },
    push: function (node, body) {
        var item = this.stack[this.popIdx];
        if (!item) {
            // we are trying to avoid memory pressure: create new element
            // only when absolutely necessary
            this.stack[this.popIdx] = new InsertStackElement(node, body);
        } else {
            item.node = node;
            item.body = body;
        }
        ++this.popIdx;
    },
    pop: function () {
        if (this.popIdx > 0) {
            return this.stack[--this.popIdx];
        }
    },
    reset: function () {
        this.popIdx = 0;
    }
};

function InsertStackElement(node, body) {
    this.node = node; // QuadTree node
    this.body = body; // physical body which needs to be inserted to node
}
`;
}

});

parcelRegister("cCWWN", function(module, exports) {
module.exports = $9316c255f6c80a29$var$generateBoundsFunction;
module.exports.generateFunctionBody = $9316c255f6c80a29$var$generateBoundsFunctionBody;

var $ehEoR = parcelRequire("ehEoR");
function $9316c255f6c80a29$var$generateBoundsFunction(dimension) {
    let code = $9316c255f6c80a29$var$generateBoundsFunctionBody(dimension);
    return new Function('bodies', 'settings', 'random', code);
}
function $9316c255f6c80a29$var$generateBoundsFunctionBody(dimension) {
    let pattern = $ehEoR(dimension);
    let code = `
  var boundingBox = {
    ${pattern('min_{var}: 0, max_{var}: 0,', {
        indent: 4
    })}
  };

  return {
    box: boundingBox,

    update: updateBoundingBox,

    reset: resetBoundingBox,

    getBestNewPosition: function (neighbors) {
      var ${pattern('base_{var} = 0', {
        join: ', '
    })};

      if (neighbors.length) {
        for (var i = 0; i < neighbors.length; ++i) {
          let neighborPos = neighbors[i].pos;
          ${pattern('base_{var} += neighborPos.{var};', {
        indent: 10
    })}
        }

        ${pattern('base_{var} /= neighbors.length;', {
        indent: 8
    })}
      } else {
        ${pattern('base_{var} = (boundingBox.min_{var} + boundingBox.max_{var}) / 2;', {
        indent: 8
    })}
      }

      var springLength = settings.springLength;
      return {
        ${pattern('{var}: base_{var} + (random.nextDouble() - 0.5) * springLength,', {
        indent: 8
    })}
      };
    }
  };

  function updateBoundingBox() {
    var i = bodies.length;
    if (i === 0) return; // No bodies - no borders.

    ${pattern('var max_{var} = -Infinity;', {
        indent: 4
    })}
    ${pattern('var min_{var} = Infinity;', {
        indent: 4
    })}

    while(i--) {
      // this is O(n), it could be done faster with quadtree, if we check the root node bounds
      var bodyPos = bodies[i].pos;
      ${pattern('if (bodyPos.{var} < min_{var}) min_{var} = bodyPos.{var};', {
        indent: 6
    })}
      ${pattern('if (bodyPos.{var} > max_{var}) max_{var} = bodyPos.{var};', {
        indent: 6
    })}
    }

    ${pattern('boundingBox.min_{var} = min_{var};', {
        indent: 4
    })}
    ${pattern('boundingBox.max_{var} = max_{var};', {
        indent: 4
    })}
  }

  function resetBoundingBox() {
    ${pattern('boundingBox.min_{var} = boundingBox.max_{var} = 0;', {
        indent: 4
    })}
  }
`;
    return code;
}

});

parcelRegister("kpttX", function(module, exports) {

var $ehEoR = parcelRequire("ehEoR");
module.exports = $edbd02fa2f505dcd$var$generateCreateDragForceFunction;
module.exports.generateCreateDragForceFunctionBody = $edbd02fa2f505dcd$var$generateCreateDragForceFunctionBody;
function $edbd02fa2f505dcd$var$generateCreateDragForceFunction(dimension) {
    let code = $edbd02fa2f505dcd$var$generateCreateDragForceFunctionBody(dimension);
    return new Function('options', code);
}
function $edbd02fa2f505dcd$var$generateCreateDragForceFunctionBody(dimension) {
    let pattern = $ehEoR(dimension);
    let code = `
  if (!Number.isFinite(options.dragCoefficient)) throw new Error('dragCoefficient is not a finite number');

  return {
    update: function(body) {
      ${pattern('body.force.{var} -= options.dragCoefficient * body.velocity.{var};', {
        indent: 6
    })}
    }
  };
`;
    return code;
}

});

parcelRegister("gIVX5", function(module, exports) {

var $ehEoR = parcelRequire("ehEoR");
module.exports = $c2cdb571d6533273$var$generateCreateSpringForceFunction;
module.exports.generateCreateSpringForceFunctionBody = $c2cdb571d6533273$var$generateCreateSpringForceFunctionBody;
function $c2cdb571d6533273$var$generateCreateSpringForceFunction(dimension) {
    let code = $c2cdb571d6533273$var$generateCreateSpringForceFunctionBody(dimension);
    return new Function('options', 'random', code);
}
function $c2cdb571d6533273$var$generateCreateSpringForceFunctionBody(dimension) {
    let pattern = $ehEoR(dimension);
    let code = `
  if (!Number.isFinite(options.springCoefficient)) throw new Error('Spring coefficient is not a number');
  if (!Number.isFinite(options.springLength)) throw new Error('Spring length is not a number');

  return {
    /**
     * Updates forces acting on a spring
     */
    update: function (spring) {
      var body1 = spring.from;
      var body2 = spring.to;
      var length = spring.length < 0 ? options.springLength : spring.length;
      ${pattern('var d{var} = body2.pos.{var} - body1.pos.{var};', {
        indent: 6
    })}
      var r = Math.sqrt(${pattern('d{var} * d{var}', {
        join: ' + '
    })});

      if (r === 0) {
        ${pattern('d{var} = (random.nextDouble() - 0.5) / 50;', {
        indent: 8
    })}
        r = Math.sqrt(${pattern('d{var} * d{var}', {
        join: ' + '
    })});
      }

      var d = r - length;
      var coefficient = ((spring.coefficient > 0) ? spring.coefficient : options.springCoefficient) * d / r;

      ${pattern('body1.force.{var} += coefficient * d{var}', {
        indent: 6
    })};
      body1.springCount += 1;
      body1.springLength += r;

      ${pattern('body2.force.{var} -= coefficient * d{var}', {
        indent: 6
    })};
      body2.springCount += 1;
      body2.springLength += r;
    }
  };
`;
    return code;
}

});

parcelRegister("fmqpS", function(module, exports) {

var $ehEoR = parcelRequire("ehEoR");
module.exports = $b2ed66d4fee16ab8$var$generateIntegratorFunction;
module.exports.generateIntegratorFunctionBody = $b2ed66d4fee16ab8$var$generateIntegratorFunctionBody;
function $b2ed66d4fee16ab8$var$generateIntegratorFunction(dimension) {
    let code = $b2ed66d4fee16ab8$var$generateIntegratorFunctionBody(dimension);
    return new Function('bodies', 'timeStep', 'adaptiveTimeStepWeight', code);
}
function $b2ed66d4fee16ab8$var$generateIntegratorFunctionBody(dimension) {
    let pattern = $ehEoR(dimension);
    let code = `
  var length = bodies.length;
  if (length === 0) return 0;

  ${pattern('var d{var} = 0, t{var} = 0;', {
        indent: 2
    })}

  for (var i = 0; i < length; ++i) {
    var body = bodies[i];
    if (body.isPinned) continue;

    if (adaptiveTimeStepWeight && body.springCount) {
      timeStep = (adaptiveTimeStepWeight * body.springLength/body.springCount);
    }

    var coeff = timeStep / body.mass;

    ${pattern('body.velocity.{var} += coeff * body.force.{var};', {
        indent: 4
    })}
    ${pattern('var v{var} = body.velocity.{var};', {
        indent: 4
    })}
    var v = Math.sqrt(${pattern('v{var} * v{var}', {
        join: ' + '
    })});

    if (v > 1) {
      // We normalize it so that we move within timeStep range. 
      // for the case when v <= 1 - we let velocity to fade out.
      ${pattern('body.velocity.{var} = v{var} / v;', {
        indent: 6
    })}
    }

    ${pattern('d{var} = timeStep * body.velocity.{var};', {
        indent: 4
    })}

    ${pattern('body.pos.{var} += d{var};', {
        indent: 4
    })}

    ${pattern('t{var} += Math.abs(d{var});', {
        indent: 4
    })}
  }

  return (${pattern('t{var} * t{var}', {
        join: ' + '
    })})/length;
`;
    return code;
}

});

parcelRegister("48be4", function(module, exports) {
module.exports = $30209e04a9e93e1d$var$Spring;
/**
 * Represents a physical spring. Spring connects two bodies, has rest length
 * stiffness coefficient and optional weight
 */ function $30209e04a9e93e1d$var$Spring(fromBody, toBody, length, springCoefficient) {
    this.from = fromBody;
    this.to = toBody;
    this.length = length;
    this.coefficient = springCoefficient;
}

});

parcelRegister("eRWCk", function(module, exports) {
module.exports = $ad337c0e9bb0f607$var$merge;
/**
 * Augments `target` with properties in `options`. Does not override
 * target's properties if they are defined and matches expected type in 
 * options
 *
 * @returns {Object} merged object
 */ function $ad337c0e9bb0f607$var$merge(target, options) {
    var key;
    if (!target) target = {};
    if (options) {
        for(key in options)if (options.hasOwnProperty(key)) {
            var targetHasIt = target.hasOwnProperty(key), optionsValueType = typeof options[key], shouldReplace = !targetHasIt || typeof target[key] !== optionsValueType;
            if (shouldReplace) target[key] = options[key];
            else if (optionsValueType === 'object') // go deep, don't care about loops here, we are simple API!:
            target[key] = $ad337c0e9bb0f607$var$merge(target[key], options[key]);
        }
    }
    return target;
}

});

parcelRegister("8tnak", function(module, exports) {
module.exports = $62b3005a13df0526$var$random;
// TODO: Deprecate?
module.exports.random = $62b3005a13df0526$var$random, module.exports.randomIterator = $62b3005a13df0526$var$randomIterator;
/**
 * Creates seeded PRNG with two methods:
 *   next() and nextDouble()
 */ function $62b3005a13df0526$var$random(inputSeed) {
    var seed = typeof inputSeed === 'number' ? inputSeed : +new Date();
    return new $62b3005a13df0526$var$Generator(seed);
}
function $62b3005a13df0526$var$Generator(seed) {
    this.seed = seed;
}
/**
  * Generates random integer number in the range from 0 (inclusive) to maxValue (exclusive)
  *
  * @param maxValue Number REQUIRED. Omitting this number will result in NaN values from PRNG.
  */ $62b3005a13df0526$var$Generator.prototype.next = $62b3005a13df0526$var$next;
/**
  * Generates random double number in the range from 0 (inclusive) to 1 (exclusive)
  * This function is the same as Math.random() (except that it could be seeded)
  */ $62b3005a13df0526$var$Generator.prototype.nextDouble = $62b3005a13df0526$var$nextDouble;
/**
 * Returns a random real number from uniform distribution in [0, 1)
 */ $62b3005a13df0526$var$Generator.prototype.uniform = $62b3005a13df0526$var$nextDouble;
/**
 * Returns a random real number from a Gaussian distribution
 * with 0 as a mean, and 1 as standard deviation u ~ N(0,1)
 */ $62b3005a13df0526$var$Generator.prototype.gaussian = $62b3005a13df0526$var$gaussian;
function $62b3005a13df0526$var$gaussian() {
    // use the polar form of the Box-Muller transform
    // based on https://introcs.cs.princeton.edu/java/23recursion/StdRandom.java
    var r, x, y;
    do {
        x = this.nextDouble() * 2 - 1;
        y = this.nextDouble() * 2 - 1;
        r = x * x + y * y;
    }while (r >= 1 || r === 0);
    return x * Math.sqrt(-2 * Math.log(r) / r);
}
/**
 * See https://twitter.com/anvaka/status/1296182534150135808
 */ $62b3005a13df0526$var$Generator.prototype.levy = $62b3005a13df0526$var$levy;
function $62b3005a13df0526$var$levy() {
    var beta = 1.5;
    var sigma = Math.pow($62b3005a13df0526$var$gamma(1 + beta) * Math.sin(Math.PI * beta / 2) / ($62b3005a13df0526$var$gamma((1 + beta) / 2) * beta * Math.pow(2, (beta - 1) / 2)), 1 / beta);
    return this.gaussian() * sigma / Math.pow(Math.abs(this.gaussian()), 1 / beta);
}
// gamma function approximation
function $62b3005a13df0526$var$gamma(z) {
    return Math.sqrt(2 * Math.PI / z) * Math.pow(1 / Math.E * (z + 1 / (12 * z - 1 / (10 * z))), z);
}
function $62b3005a13df0526$var$nextDouble() {
    var seed = this.seed;
    // Robert Jenkins' 32 bit integer hash function.
    seed = seed + 0x7ed55d16 + (seed << 12) & 0xffffffff;
    seed = (seed ^ 0xc761c23c ^ seed >>> 19) & 0xffffffff;
    seed = seed + 0x165667b1 + (seed << 5) & 0xffffffff;
    seed = (seed + 0xd3a2646c ^ seed << 9) & 0xffffffff;
    seed = seed + 0xfd7046c5 + (seed << 3) & 0xffffffff;
    seed = (seed ^ 0xb55a4f09 ^ seed >>> 16) & 0xffffffff;
    this.seed = seed;
    return (seed & 0xfffffff) / 0x10000000;
}
function $62b3005a13df0526$var$next(maxValue) {
    return Math.floor(this.nextDouble() * maxValue);
}
/*
 * Creates iterator over array, which returns items of array in random order
 * Time complexity is guaranteed to be O(n);
 */ function $62b3005a13df0526$var$randomIterator(array, customRandom) {
    var localRandom = customRandom || $62b3005a13df0526$var$random();
    if (typeof localRandom.next !== 'function') throw new Error('customRandom does not match expected API: next() function is missing');
    return {
        forEach: forEach,
        /**
     * Shuffles array randomly, in place.
     */ shuffle: shuffle
    };
    function shuffle() {
        var i, j, t;
        for(i = array.length - 1; i > 0; --i){
            j = localRandom.next(i + 1); // i inclusive
            t = array[j];
            array[j] = array[i];
            array[i] = t;
        }
        return array;
    }
    function forEach(callback) {
        var i, j, t;
        for(i = array.length - 1; i > 0; --i){
            j = localRandom.next(i + 1); // i inclusive
            t = array[j];
            array[j] = array[i];
            array[i] = t;
            callback(t);
        }
        if (array.length) callback(array[0]);
    }
}

});


parcelRegister("8PNKb", function(module, exports) {

$parcel$export(module.exports, "Easing", () => Easing);
$parcel$export(module.exports, "Group", () => Group);
$parcel$export(module.exports, "Tween", () => Tween);
/**
 * The Ease class provides a collection of easing functions for use with tween.js.
 */ var Easing = Object.freeze({
    Linear: Object.freeze({
        None: function(amount) {
            return amount;
        },
        In: function(amount) {
            return amount;
        },
        Out: function(amount) {
            return amount;
        },
        InOut: function(amount) {
            return amount;
        }
    }),
    Quadratic: Object.freeze({
        In: function(amount) {
            return amount * amount;
        },
        Out: function(amount) {
            return amount * (2 - amount);
        },
        InOut: function(amount) {
            if ((amount *= 2) < 1) return 0.5 * amount * amount;
            return -0.5 * (--amount * (amount - 2) - 1);
        }
    }),
    Cubic: Object.freeze({
        In: function(amount) {
            return amount * amount * amount;
        },
        Out: function(amount) {
            return --amount * amount * amount + 1;
        },
        InOut: function(amount) {
            if ((amount *= 2) < 1) return 0.5 * amount * amount * amount;
            return 0.5 * ((amount -= 2) * amount * amount + 2);
        }
    }),
    Quartic: Object.freeze({
        In: function(amount) {
            return amount * amount * amount * amount;
        },
        Out: function(amount) {
            return 1 - --amount * amount * amount * amount;
        },
        InOut: function(amount) {
            if ((amount *= 2) < 1) return 0.5 * amount * amount * amount * amount;
            return -0.5 * ((amount -= 2) * amount * amount * amount - 2);
        }
    }),
    Quintic: Object.freeze({
        In: function(amount) {
            return amount * amount * amount * amount * amount;
        },
        Out: function(amount) {
            return --amount * amount * amount * amount * amount + 1;
        },
        InOut: function(amount) {
            if ((amount *= 2) < 1) return 0.5 * amount * amount * amount * amount * amount;
            return 0.5 * ((amount -= 2) * amount * amount * amount * amount + 2);
        }
    }),
    Sinusoidal: Object.freeze({
        In: function(amount) {
            return 1 - Math.sin((1.0 - amount) * Math.PI / 2);
        },
        Out: function(amount) {
            return Math.sin(amount * Math.PI / 2);
        },
        InOut: function(amount) {
            return 0.5 * (1 - Math.sin(Math.PI * (0.5 - amount)));
        }
    }),
    Exponential: Object.freeze({
        In: function(amount) {
            return amount === 0 ? 0 : Math.pow(1024, amount - 1);
        },
        Out: function(amount) {
            return amount === 1 ? 1 : 1 - Math.pow(2, -10 * amount);
        },
        InOut: function(amount) {
            if (amount === 0) return 0;
            if (amount === 1) return 1;
            if ((amount *= 2) < 1) return 0.5 * Math.pow(1024, amount - 1);
            return 0.5 * (-Math.pow(2, -10 * (amount - 1)) + 2);
        }
    }),
    Circular: Object.freeze({
        In: function(amount) {
            return 1 - Math.sqrt(1 - amount * amount);
        },
        Out: function(amount) {
            return Math.sqrt(1 - --amount * amount);
        },
        InOut: function(amount) {
            if ((amount *= 2) < 1) return -0.5 * (Math.sqrt(1 - amount * amount) - 1);
            return 0.5 * (Math.sqrt(1 - (amount -= 2) * amount) + 1);
        }
    }),
    Elastic: Object.freeze({
        In: function(amount) {
            if (amount === 0) return 0;
            if (amount === 1) return 1;
            return -Math.pow(2, 10 * (amount - 1)) * Math.sin((amount - 1.1) * 5 * Math.PI);
        },
        Out: function(amount) {
            if (amount === 0) return 0;
            if (amount === 1) return 1;
            return Math.pow(2, -10 * amount) * Math.sin((amount - 0.1) * 5 * Math.PI) + 1;
        },
        InOut: function(amount) {
            if (amount === 0) return 0;
            if (amount === 1) return 1;
            amount *= 2;
            if (amount < 1) return -0.5 * Math.pow(2, 10 * (amount - 1)) * Math.sin((amount - 1.1) * 5 * Math.PI);
            return 0.5 * Math.pow(2, -10 * (amount - 1)) * Math.sin((amount - 1.1) * 5 * Math.PI) + 1;
        }
    }),
    Back: Object.freeze({
        In: function(amount) {
            var s = 1.70158;
            return amount === 1 ? 1 : amount * amount * ((s + 1) * amount - s);
        },
        Out: function(amount) {
            var s = 1.70158;
            return amount === 0 ? 0 : --amount * amount * ((s + 1) * amount + s) + 1;
        },
        InOut: function(amount) {
            var s = 2.5949095;
            if ((amount *= 2) < 1) return 0.5 * (amount * amount * ((s + 1) * amount - s));
            return 0.5 * ((amount -= 2) * amount * ((s + 1) * amount + s) + 2);
        }
    }),
    Bounce: Object.freeze({
        In: function(amount) {
            return 1 - Easing.Bounce.Out(1 - amount);
        },
        Out: function(amount) {
            if (amount < 1 / 2.75) return 7.5625 * amount * amount;
            else if (amount < 2 / 2.75) return 7.5625 * (amount -= 1.5 / 2.75) * amount + 0.75;
            else if (amount < 2.5 / 2.75) return 7.5625 * (amount -= 2.25 / 2.75) * amount + 0.9375;
            else return 7.5625 * (amount -= 2.625 / 2.75) * amount + 0.984375;
        },
        InOut: function(amount) {
            if (amount < 0.5) return Easing.Bounce.In(amount * 2) * 0.5;
            return Easing.Bounce.Out(amount * 2 - 1) * 0.5 + 0.5;
        }
    }),
    generatePow: function(power) {
        if (power === void 0) power = 4;
        power = power < Number.EPSILON ? Number.EPSILON : power;
        power = power > 10000 ? 10000 : power;
        return {
            In: function(amount) {
                return Math.pow(amount, power);
            },
            Out: function(amount) {
                return 1 - Math.pow(1 - amount, power);
            },
            InOut: function(amount) {
                if (amount < 0.5) return Math.pow(amount * 2, power) / 2;
                return (1 - Math.pow(2 - amount * 2, power)) / 2 + 0.5;
            }
        };
    }
});
var now = function() {
    return performance.now();
};
/**
 * Controlling groups of tweens
 *
 * Using the TWEEN singleton to manage your tweens can cause issues in large apps with many components.
 * In these cases, you may want to create your own smaller groups of tween
 */ var Group = /** @class */ function() {
    function Group() {
        var tweens = [];
        for(var _i = 0; _i < arguments.length; _i++)tweens[_i] = arguments[_i];
        this._tweens = {};
        this._tweensAddedDuringUpdate = {};
        this.add.apply(this, tweens);
    }
    Group.prototype.getAll = function() {
        var _this = this;
        return Object.keys(this._tweens).map(function(tweenId) {
            return _this._tweens[tweenId];
        });
    };
    Group.prototype.removeAll = function() {
        this._tweens = {};
    };
    Group.prototype.add = function() {
        var _a;
        var tweens = [];
        for(var _i = 0; _i < arguments.length; _i++)tweens[_i] = arguments[_i];
        for(var _b = 0, tweens_1 = tweens; _b < tweens_1.length; _b++){
            var tween = tweens_1[_b];
            // Remove from any other group first, a tween can only be in one group at a time.
            // @ts-expect-error library internal access
            (_a = tween._group) === null || _a === void 0 || _a.remove(tween);
            // @ts-expect-error library internal access
            tween._group = this;
            this._tweens[tween.getId()] = tween;
            this._tweensAddedDuringUpdate[tween.getId()] = tween;
        }
    };
    Group.prototype.remove = function() {
        var tweens = [];
        for(var _i = 0; _i < arguments.length; _i++)tweens[_i] = arguments[_i];
        for(var _a = 0, tweens_2 = tweens; _a < tweens_2.length; _a++){
            var tween = tweens_2[_a];
            // @ts-expect-error library internal access
            tween._group = undefined;
            delete this._tweens[tween.getId()];
            delete this._tweensAddedDuringUpdate[tween.getId()];
        }
    };
    /** Return true if all tweens in the group are not paused or playing. */ Group.prototype.allStopped = function() {
        return this.getAll().every(function(tween) {
            return !tween.isPlaying();
        });
    };
    Group.prototype.update = function(time, preserve) {
        if (time === void 0) time = now();
        if (preserve === void 0) preserve = true;
        var tweenIds = Object.keys(this._tweens);
        if (tweenIds.length === 0) return;
        // Tweens are updated in "batches". If you add a new tween during an
        // update, then the new tween will be updated in the next batch.
        // If you remove a tween during an update, it may or may not be updated.
        // However, if the removed tween was added during the current batch,
        // then it will not be updated.
        while(tweenIds.length > 0){
            this._tweensAddedDuringUpdate = {};
            for(var i = 0; i < tweenIds.length; i++){
                var tween = this._tweens[tweenIds[i]];
                var autoStart = !preserve;
                if (tween && tween.update(time, autoStart) === false && !preserve) this.remove(tween);
            }
            tweenIds = Object.keys(this._tweensAddedDuringUpdate);
        }
    };
    return Group;
}();
/**
 *
 */ var Interpolation = {
    Linear: function(v, k) {
        var m = v.length - 1;
        var f = m * k;
        var i = Math.floor(f);
        var fn = Interpolation.Utils.Linear;
        if (k < 0) return fn(v[0], v[1], f);
        if (k > 1) return fn(v[m], v[m - 1], m - f);
        return fn(v[i], v[i + 1 > m ? m : i + 1], f - i);
    },
    Bezier: function(v, k) {
        var b = 0;
        var n = v.length - 1;
        var pw = Math.pow;
        var bn = Interpolation.Utils.Bernstein;
        for(var i = 0; i <= n; i++)b += pw(1 - k, n - i) * pw(k, i) * v[i] * bn(n, i);
        return b;
    },
    CatmullRom: function(v, k) {
        var m = v.length - 1;
        var f = m * k;
        var i = Math.floor(f);
        var fn = Interpolation.Utils.CatmullRom;
        if (v[0] === v[m]) {
            if (k < 0) i = Math.floor(f = m * (1 + k));
            return fn(v[(i - 1 + m) % m], v[i], v[(i + 1) % m], v[(i + 2) % m], f - i);
        } else {
            if (k < 0) return v[0] - (fn(v[0], v[0], v[1], v[1], -f) - v[0]);
            if (k > 1) return v[m] - (fn(v[m], v[m], v[m - 1], v[m - 1], f - m) - v[m]);
            return fn(v[i ? i - 1 : 0], v[i], v[m < i + 1 ? m : i + 1], v[m < i + 2 ? m : i + 2], f - i);
        }
    },
    Utils: {
        Linear: function(p0, p1, t) {
            return (p1 - p0) * t + p0;
        },
        Bernstein: function(n, i) {
            var fc = Interpolation.Utils.Factorial;
            return fc(n) / fc(i) / fc(n - i);
        },
        Factorial: function() {
            var a = [
                1
            ];
            return function(n) {
                var s = 1;
                if (a[n]) return a[n];
                for(var i = n; i > 1; i--)s *= i;
                a[n] = s;
                return s;
            };
        }(),
        CatmullRom: function(p0, p1, p2, p3, t) {
            var v0 = (p2 - p0) * 0.5;
            var v1 = (p3 - p1) * 0.5;
            var t2 = t * t;
            var t3 = t * t2;
            return (2 * p1 - 2 * p2 + v0 + v1) * t3 + (-3 * p1 + 3 * p2 - 2 * v0 - v1) * t2 + v0 * t + p1;
        }
    }
};
/**
 * Utils
 */ var Sequence = /** @class */ function() {
    function Sequence() {}
    Sequence.nextId = function() {
        return Sequence._nextId++;
    };
    Sequence._nextId = 0;
    return Sequence;
}();
var mainGroup = new Group();
/**
 * Tween.js - Licensed under the MIT license
 * https://github.com/tweenjs/tween.js
 * ----------------------------------------------
 *
 * See https://github.com/tweenjs/tween.js/graphs/contributors for the full list of contributors.
 * Thank you all, you're awesome!
 */ var Tween = /** @class */ function() {
    function Tween(object, group) {
        this._isPaused = false;
        this._pauseStart = 0;
        this._valuesStart = {};
        this._valuesEnd = {};
        this._valuesStartRepeat = {};
        this._duration = 1000;
        this._isDynamic = false;
        this._initialRepeat = 0;
        this._repeat = 0;
        this._yoyo = false;
        this._isPlaying = false;
        this._reversed = false;
        this._delayTime = 0;
        this._startTime = 0;
        this._easingFunction = Easing.Linear.None;
        this._interpolationFunction = Interpolation.Linear;
        // eslint-disable-next-line
        this._chainedTweens = [];
        this._onStartCallbackFired = false;
        this._onEveryStartCallbackFired = false;
        this._id = Sequence.nextId();
        this._isChainStopped = false;
        this._propertiesAreSetUp = false;
        this._goToEnd = false;
        this._object = object;
        if (typeof group === 'object') {
            this._group = group;
            group.add(this);
        } else if (group === true) {
            this._group = mainGroup;
            mainGroup.add(this);
        }
    }
    Tween.prototype.getId = function() {
        return this._id;
    };
    Tween.prototype.isPlaying = function() {
        return this._isPlaying;
    };
    Tween.prototype.isPaused = function() {
        return this._isPaused;
    };
    Tween.prototype.getDuration = function() {
        return this._duration;
    };
    Tween.prototype.to = function(target, duration) {
        if (duration === void 0) duration = 1000;
        if (this._isPlaying) throw new Error('Can not call Tween.to() while Tween is already started or paused. Stop the Tween first.');
        this._valuesEnd = target;
        this._propertiesAreSetUp = false;
        this._duration = duration < 0 ? 0 : duration;
        return this;
    };
    Tween.prototype.duration = function(duration) {
        if (duration === void 0) duration = 1000;
        this._duration = duration < 0 ? 0 : duration;
        return this;
    };
    Tween.prototype.dynamic = function(dynamic) {
        if (dynamic === void 0) dynamic = false;
        this._isDynamic = dynamic;
        return this;
    };
    Tween.prototype.start = function(time, overrideStartingValues) {
        if (time === void 0) time = now();
        if (overrideStartingValues === void 0) overrideStartingValues = false;
        if (this._isPlaying) return this;
        this._repeat = this._initialRepeat;
        if (this._reversed) {
            // If we were reversed (f.e. using the yoyo feature) then we need to
            // flip the tween direction back to forward.
            this._reversed = false;
            for(var property in this._valuesStartRepeat){
                this._swapEndStartRepeatValues(property);
                this._valuesStart[property] = this._valuesStartRepeat[property];
            }
        }
        this._isPlaying = true;
        this._isPaused = false;
        this._onStartCallbackFired = false;
        this._onEveryStartCallbackFired = false;
        this._isChainStopped = false;
        this._startTime = time;
        this._startTime += this._delayTime;
        if (!this._propertiesAreSetUp || overrideStartingValues) {
            this._propertiesAreSetUp = true;
            // If dynamic is not enabled, clone the end values instead of using the passed-in end values.
            if (!this._isDynamic) {
                var tmp = {};
                for(var prop in this._valuesEnd)tmp[prop] = this._valuesEnd[prop];
                this._valuesEnd = tmp;
            }
            this._setupProperties(this._object, this._valuesStart, this._valuesEnd, this._valuesStartRepeat, overrideStartingValues);
        }
        return this;
    };
    Tween.prototype.startFromCurrentValues = function(time) {
        return this.start(time, true);
    };
    Tween.prototype._setupProperties = function(_object, _valuesStart, _valuesEnd, _valuesStartRepeat, overrideStartingValues) {
        for(var property in _valuesEnd){
            var startValue = _object[property];
            var startValueIsArray = Array.isArray(startValue);
            var propType = startValueIsArray ? 'array' : typeof startValue;
            var isInterpolationList = !startValueIsArray && Array.isArray(_valuesEnd[property]);
            // If `to()` specifies a property that doesn't exist in the source object,
            // we should not set that property in the object
            if (propType === 'undefined' || propType === 'function') continue;
            // Check if an Array was provided as property value
            if (isInterpolationList) {
                var endValues = _valuesEnd[property];
                if (endValues.length === 0) continue;
                // Handle an array of relative values.
                // Creates a local copy of the Array with the start value at the front
                var temp = [
                    startValue
                ];
                for(var i = 0, l = endValues.length; i < l; i += 1){
                    var value = this._handleRelativeValue(startValue, endValues[i]);
                    if (isNaN(value)) {
                        isInterpolationList = false;
                        console.warn('Found invalid interpolation list. Skipping.');
                        break;
                    }
                    temp.push(value);
                }
                if (isInterpolationList) // if (_valuesStart[property] === undefined) { // handle end values only the first time. NOT NEEDED? setupProperties is now guarded by _propertiesAreSetUp.
                _valuesEnd[property] = temp;
            }
            // handle the deepness of the values
            if ((propType === 'object' || startValueIsArray) && startValue && !isInterpolationList) {
                _valuesStart[property] = startValueIsArray ? [] : {};
                var nestedObject = startValue;
                for(var prop in nestedObject)_valuesStart[property][prop] = nestedObject[prop];
                // TODO? repeat nested values? And yoyo? And array values?
                _valuesStartRepeat[property] = startValueIsArray ? [] : {};
                var endValues = _valuesEnd[property];
                // If dynamic is not enabled, clone the end values instead of using the passed-in end values.
                if (!this._isDynamic) {
                    var tmp = {};
                    for(var prop in endValues)tmp[prop] = endValues[prop];
                    _valuesEnd[property] = endValues = tmp;
                }
                this._setupProperties(nestedObject, _valuesStart[property], endValues, _valuesStartRepeat[property], overrideStartingValues);
            } else {
                // Save the starting value, but only once unless override is requested.
                if (typeof _valuesStart[property] === 'undefined' || overrideStartingValues) _valuesStart[property] = startValue;
                if (!startValueIsArray) // eslint-disable-next-line
                // @ts-ignore FIXME?
                _valuesStart[property] *= 1.0; // Ensures we're using numbers, not strings
                if (isInterpolationList) // eslint-disable-next-line
                // @ts-ignore FIXME?
                _valuesStartRepeat[property] = _valuesEnd[property].slice().reverse();
                else _valuesStartRepeat[property] = _valuesStart[property] || 0;
            }
        }
    };
    Tween.prototype.stop = function() {
        if (!this._isChainStopped) {
            this._isChainStopped = true;
            this.stopChainedTweens();
        }
        if (!this._isPlaying) return this;
        this._isPlaying = false;
        this._isPaused = false;
        if (this._onStopCallback) this._onStopCallback(this._object);
        return this;
    };
    Tween.prototype.end = function() {
        this._goToEnd = true;
        this.update(this._startTime + this._duration);
        return this;
    };
    Tween.prototype.pause = function(time) {
        if (time === void 0) time = now();
        if (this._isPaused || !this._isPlaying) return this;
        this._isPaused = true;
        this._pauseStart = time;
        return this;
    };
    Tween.prototype.resume = function(time) {
        if (time === void 0) time = now();
        if (!this._isPaused || !this._isPlaying) return this;
        this._isPaused = false;
        this._startTime += time - this._pauseStart;
        this._pauseStart = 0;
        return this;
    };
    Tween.prototype.stopChainedTweens = function() {
        for(var i = 0, numChainedTweens = this._chainedTweens.length; i < numChainedTweens; i++)this._chainedTweens[i].stop();
        return this;
    };
    Tween.prototype.group = function(group) {
        if (!group) {
            console.warn('tween.group() without args has been removed, use group.add(tween) instead.');
            return this;
        }
        group.add(this);
        return this;
    };
    /**
     * Removes the tween from whichever group it is in.
     */ Tween.prototype.remove = function() {
        var _a;
        (_a = this._group) === null || _a === void 0 || _a.remove(this);
        return this;
    };
    Tween.prototype.delay = function(amount) {
        if (amount === void 0) amount = 0;
        this._delayTime = amount;
        return this;
    };
    Tween.prototype.repeat = function(times) {
        if (times === void 0) times = 0;
        this._initialRepeat = times;
        this._repeat = times;
        return this;
    };
    Tween.prototype.repeatDelay = function(amount) {
        this._repeatDelayTime = amount;
        return this;
    };
    Tween.prototype.yoyo = function(yoyo) {
        if (yoyo === void 0) yoyo = false;
        this._yoyo = yoyo;
        return this;
    };
    Tween.prototype.easing = function(easingFunction) {
        if (easingFunction === void 0) easingFunction = Easing.Linear.None;
        this._easingFunction = easingFunction;
        return this;
    };
    Tween.prototype.interpolation = function(interpolationFunction) {
        if (interpolationFunction === void 0) interpolationFunction = Interpolation.Linear;
        this._interpolationFunction = interpolationFunction;
        return this;
    };
    // eslint-disable-next-line
    Tween.prototype.chain = function() {
        var tweens = [];
        for(var _i = 0; _i < arguments.length; _i++)tweens[_i] = arguments[_i];
        this._chainedTweens = tweens;
        return this;
    };
    Tween.prototype.onStart = function(callback) {
        this._onStartCallback = callback;
        return this;
    };
    Tween.prototype.onEveryStart = function(callback) {
        this._onEveryStartCallback = callback;
        return this;
    };
    Tween.prototype.onUpdate = function(callback) {
        this._onUpdateCallback = callback;
        return this;
    };
    Tween.prototype.onRepeat = function(callback) {
        this._onRepeatCallback = callback;
        return this;
    };
    Tween.prototype.onComplete = function(callback) {
        this._onCompleteCallback = callback;
        return this;
    };
    Tween.prototype.onStop = function(callback) {
        this._onStopCallback = callback;
        return this;
    };
    /**
     * @returns true if the tween is still playing after the update, false
     * otherwise (calling update on a paused tween still returns true because
     * it is still playing, just paused).
     *
     * @param autoStart - When true, calling update will implicitly call start()
     * as well. Note, if you stop() or end() the tween, but are still calling
     * update(), it will start again!
     */ Tween.prototype.update = function(time, autoStart) {
        var _this = this;
        var _a;
        if (time === void 0) time = now();
        if (autoStart === void 0) autoStart = Tween.autoStartOnUpdate;
        if (this._isPaused) return true;
        var property;
        if (!this._goToEnd && !this._isPlaying) {
            if (autoStart) this.start(time, true);
            else return false;
        }
        this._goToEnd = false;
        if (time < this._startTime) return true;
        if (this._onStartCallbackFired === false) {
            if (this._onStartCallback) this._onStartCallback(this._object);
            this._onStartCallbackFired = true;
        }
        if (this._onEveryStartCallbackFired === false) {
            if (this._onEveryStartCallback) this._onEveryStartCallback(this._object);
            this._onEveryStartCallbackFired = true;
        }
        var elapsedTime = time - this._startTime;
        var durationAndDelay = this._duration + ((_a = this._repeatDelayTime) !== null && _a !== void 0 ? _a : this._delayTime);
        var totalTime = this._duration + this._repeat * durationAndDelay;
        var calculateElapsedPortion = function() {
            if (_this._duration === 0) return 1;
            if (elapsedTime > totalTime) return 1;
            var timesRepeated = Math.trunc(elapsedTime / durationAndDelay);
            var timeIntoCurrentRepeat = elapsedTime - timesRepeated * durationAndDelay;
            // TODO use %?
            // const timeIntoCurrentRepeat = elapsedTime % durationAndDelay
            var portion = Math.min(timeIntoCurrentRepeat / _this._duration, 1);
            if (portion === 0 && elapsedTime === _this._duration) return 1;
            return portion;
        };
        var elapsed = calculateElapsedPortion();
        var value = this._easingFunction(elapsed);
        // properties transformations
        this._updateProperties(this._object, this._valuesStart, this._valuesEnd, value);
        if (this._onUpdateCallback) this._onUpdateCallback(this._object, elapsed);
        if (this._duration === 0 || elapsedTime >= this._duration) {
            if (this._repeat > 0) {
                var completeCount = Math.min(Math.trunc((elapsedTime - this._duration) / durationAndDelay) + 1, this._repeat);
                if (isFinite(this._repeat)) this._repeat -= completeCount;
                // Reassign starting values, restart by making startTime = now
                for(property in this._valuesStartRepeat){
                    if (!this._yoyo && typeof this._valuesEnd[property] === 'string') this._valuesStartRepeat[property] = // eslint-disable-next-line
                    // @ts-ignore FIXME?
                    this._valuesStartRepeat[property] + parseFloat(this._valuesEnd[property]);
                    if (this._yoyo) this._swapEndStartRepeatValues(property);
                    this._valuesStart[property] = this._valuesStartRepeat[property];
                }
                if (this._yoyo) this._reversed = !this._reversed;
                this._startTime += durationAndDelay * completeCount;
                if (this._onRepeatCallback) this._onRepeatCallback(this._object);
                this._onEveryStartCallbackFired = false;
                return true;
            } else {
                if (this._onCompleteCallback) this._onCompleteCallback(this._object);
                for(var i = 0, numChainedTweens = this._chainedTweens.length; i < numChainedTweens; i++)// Make the chained tweens start exactly at the time they should,
                // even if the `update()` method was called way past the duration of the tween
                this._chainedTweens[i].start(this._startTime + this._duration, false);
                this._isPlaying = false;
                return false;
            }
        }
        return true;
    };
    Tween.prototype._updateProperties = function(_object, _valuesStart, _valuesEnd, value) {
        for(var property in _valuesEnd){
            // Don't update properties that do not exist in the source object
            if (_valuesStart[property] === undefined) continue;
            var start = _valuesStart[property] || 0;
            var end = _valuesEnd[property];
            var startIsArray = Array.isArray(_object[property]);
            var endIsArray = Array.isArray(end);
            var isInterpolationList = !startIsArray && endIsArray;
            if (isInterpolationList) _object[property] = this._interpolationFunction(end, value);
            else if (typeof end === 'object' && end) // eslint-disable-next-line
            // @ts-ignore FIXME?
            this._updateProperties(_object[property], start, end, value);
            else {
                // Parses relative end values with start as base (e.g.: +10, -3)
                end = this._handleRelativeValue(start, end);
                // Protect against non numeric properties.
                if (typeof end === 'number') // eslint-disable-next-line
                // @ts-ignore FIXME?
                _object[property] = start + (end - start) * value;
            }
        }
    };
    Tween.prototype._handleRelativeValue = function(start, end) {
        if (typeof end !== 'string') return end;
        if (end.charAt(0) === '+' || end.charAt(0) === '-') return start + parseFloat(end);
        return parseFloat(end);
    };
    Tween.prototype._swapEndStartRepeatValues = function(property) {
        var tmp = this._valuesStartRepeat[property];
        var endValue = this._valuesEnd[property];
        if (typeof endValue === 'string') this._valuesStartRepeat[property] = this._valuesStartRepeat[property] + parseFloat(endValue);
        else this._valuesStartRepeat[property] = this._valuesEnd[property];
        this._valuesEnd[property] = tmp;
    };
    Tween.autoStartOnUpdate = false;
    return Tween;
}();
var VERSION = '25.0.0';
/**
 * Tween.js - Licensed under the MIT license
 * https://github.com/tweenjs/tween.js
 * ----------------------------------------------
 *
 * See https://github.com/tweenjs/tween.js/graphs/contributors for the full list of contributors.
 * Thank you all, you're awesome!
 */ var nextId = Sequence.nextId;
/**
 * Controlling groups of tweens
 *
 * Using the TWEEN singleton to manage your tweens can cause issues in large apps with many components.
 * In these cases, you may want to create your own smaller groups of tweens.
 */ var TWEEN = mainGroup;
// This is the best way to export things in a way that's compatible with both ES
// Modules and CommonJS, without build hacks, and so as not to break the
// existing API.
// https://github.com/rollup/rollup/issues/1961#issuecomment-423037881
/**
 * @deprecated The global TWEEN Group will be removed in a following major
 * release. To migrate, create a `new Group()` instead of using `TWEEN` as a
 * group.
 *
 * Old code:
 *
 * ```js
 * import * as TWEEN from '@tweenjs/tween.js'
 *
 * //...
 *
 * const tween = new TWEEN.Tween(obj)
 * const tween2 = new TWEEN.Tween(obj2)
 *
 * //...
 *
 * requestAnimationFrame(function loop(time) {
 *   TWEEN.update(time)
 *   requestAnimationFrame(loop)
 * })
 * ```
 *
 * New code:
 *
 * ```js
 * import {Tween, Group} from '@tweenjs/tween.js'
 *
 * //...
 *
 * const tween = new Tween(obj)
 * const tween2 = new TWEEN.Tween(obj2)
 *
 * //...
 *
 * const group = new Group()
 * group.add(tween)
 * group.add(tween2)
 *
 * //...
 *
 * requestAnimationFrame(function loop(time) {
 *   group.update(time)
 *   requestAnimationFrame(loop)
 * })
 * ```
 */ var getAll = TWEEN.getAll.bind(TWEEN);
/**
 * @deprecated The global TWEEN Group will be removed in a following major
 * release. To migrate, create a `new Group()` instead of using `TWEEN` as a
 * group.
 *
 * Old code:
 *
 * ```js
 * import * as TWEEN from '@tweenjs/tween.js'
 *
 * //...
 *
 * const tween = new TWEEN.Tween(obj)
 * const tween2 = new TWEEN.Tween(obj2)
 *
 * //...
 *
 * requestAnimationFrame(function loop(time) {
 *   TWEEN.update(time)
 *   requestAnimationFrame(loop)
 * })
 * ```
 *
 * New code:
 *
 * ```js
 * import {Tween, Group} from '@tweenjs/tween.js'
 *
 * //...
 *
 * const tween = new Tween(obj)
 * const tween2 = new TWEEN.Tween(obj2)
 *
 * //...
 *
 * const group = new Group()
 * group.add(tween)
 * group.add(tween2)
 *
 * //...
 *
 * requestAnimationFrame(function loop(time) {
 *   group.update(time)
 *   requestAnimationFrame(loop)
 * })
 * ```
 */ var removeAll = TWEEN.removeAll.bind(TWEEN);
/**
 * @deprecated The global TWEEN Group will be removed in a following major
 * release. To migrate, create a `new Group()` instead of using `TWEEN` as a
 * group.
 *
 * Old code:
 *
 * ```js
 * import * as TWEEN from '@tweenjs/tween.js'
 *
 * //...
 *
 * const tween = new TWEEN.Tween(obj)
 * const tween2 = new TWEEN.Tween(obj2)
 *
 * //...
 *
 * requestAnimationFrame(function loop(time) {
 *   TWEEN.update(time)
 *   requestAnimationFrame(loop)
 * })
 * ```
 *
 * New code:
 *
 * ```js
 * import {Tween, Group} from '@tweenjs/tween.js'
 *
 * //...
 *
 * const tween = new Tween(obj)
 * const tween2 = new TWEEN.Tween(obj2)
 *
 * //...
 *
 * const group = new Group()
 * group.add(tween)
 * group.add(tween2)
 *
 * //...
 *
 * requestAnimationFrame(function loop(time) {
 *   group.update(time)
 *   requestAnimationFrame(loop)
 * })
 * ```
 */ var add = TWEEN.add.bind(TWEEN);
/**
 * @deprecated The global TWEEN Group will be removed in a following major
 * release. To migrate, create a `new Group()` instead of using `TWEEN` as a
 * group.
 *
 * Old code:
 *
 * ```js
 * import * as TWEEN from '@tweenjs/tween.js'
 *
 * //...
 *
 * const tween = new TWEEN.Tween(obj)
 * const tween2 = new TWEEN.Tween(obj2)
 *
 * //...
 *
 * requestAnimationFrame(function loop(time) {
 *   TWEEN.update(time)
 *   requestAnimationFrame(loop)
 * })
 * ```
 *
 * New code:
 *
 * ```js
 * import {Tween, Group} from '@tweenjs/tween.js'
 *
 * //...
 *
 * const tween = new Tween(obj)
 * const tween2 = new TWEEN.Tween(obj2)
 *
 * //...
 *
 * const group = new Group()
 * group.add(tween)
 * group.add(tween2)
 *
 * //...
 *
 * requestAnimationFrame(function loop(time) {
 *   group.update(time)
 *   requestAnimationFrame(loop)
 * })
 * ```
 */ var remove = TWEEN.remove.bind(TWEEN);
/**
 * @deprecated The global TWEEN Group will be removed in a following major
 * release. To migrate, create a `new Group()` instead of using `TWEEN` as a
 * group.
 *
 * Old code:
 *
 * ```js
 * import * as TWEEN from '@tweenjs/tween.js'
 *
 * //...
 *
 * const tween = new TWEEN.Tween(obj)
 * const tween2 = new TWEEN.Tween(obj2)
 *
 * //...
 *
 * requestAnimationFrame(function loop(time) {
 *   TWEEN.update(time)
 *   requestAnimationFrame(loop)
 * })
 * ```
 *
 * New code:
 *
 * ```js
 * import {Tween, Group} from '@tweenjs/tween.js'
 *
 * //...
 *
 * const tween = new Tween(obj)
 * const tween2 = new TWEEN.Tween(obj2)
 *
 * //...
 *
 * const group = new Group()
 * group.add(tween)
 * group.add(tween2)
 *
 * //...
 *
 * requestAnimationFrame(function loop(time) {
 *   group.update(time)
 *   requestAnimationFrame(loop)
 * })
 * ```
 */ var update = TWEEN.update.bind(TWEEN);
var exports = {
    Easing: Easing,
    Group: Group,
    Interpolation: Interpolation,
    now: now,
    Sequence: Sequence,
    nextId: nextId,
    Tween: Tween,
    VERSION: VERSION,
    /**
     * @deprecated The global TWEEN Group will be removed in a following major
     * release. To migrate, create a `new Group()` instead of using `TWEEN` as a
     * group.
     *
     * Old code:
     *
     * ```js
     * import * as TWEEN from '@tweenjs/tween.js'
     *
     * //...
     *
     * const tween = new TWEEN.Tween(obj)
     * const tween2 = new TWEEN.Tween(obj2)
     *
     * //...
     *
     * requestAnimationFrame(function loop(time) {
     *   TWEEN.update(time)
     *   requestAnimationFrame(loop)
     * })
     * ```
     *
     * New code:
     *
     * ```js
     * import {Tween, Group} from '@tweenjs/tween.js'
     *
     * //...
     *
     * const tween = new Tween(obj)
     * const tween2 = new TWEEN.Tween(obj2)
     *
     * //...
     *
     * const group = new Group()
     * group.add(tween)
     * group.add(tween2)
     *
     * //...
     *
     * requestAnimationFrame(function loop(time) {
     *   group.update(time)
     *   requestAnimationFrame(loop)
     * })
     * ```
     */ getAll: getAll,
    /**
     * @deprecated The global TWEEN Group will be removed in a following major
     * release. To migrate, create a `new Group()` instead of using `TWEEN` as a
     * group.
     *
     * Old code:
     *
     * ```js
     * import * as TWEEN from '@tweenjs/tween.js'
     *
     * //...
     *
     * const tween = new TWEEN.Tween(obj)
     * const tween2 = new TWEEN.Tween(obj2)
     *
     * //...
     *
     * requestAnimationFrame(function loop(time) {
     *   TWEEN.update(time)
     *   requestAnimationFrame(loop)
     * })
     * ```
     *
     * New code:
     *
     * ```js
     * import {Tween, Group} from '@tweenjs/tween.js'
     *
     * //...
     *
     * const tween = new Tween(obj)
     * const tween2 = new TWEEN.Tween(obj2)
     *
     * //...
     *
     * const group = new Group()
     * group.add(tween)
     * group.add(tween2)
     *
     * //...
     *
     * requestAnimationFrame(function loop(time) {
     *   group.update(time)
     *   requestAnimationFrame(loop)
     * })
     * ```
     */ removeAll: removeAll,
    /**
     * @deprecated The global TWEEN Group will be removed in a following major
     * release. To migrate, create a `new Group()` instead of using `TWEEN` as a
     * group.
     *
     * Old code:
     *
     * ```js
     * import * as TWEEN from '@tweenjs/tween.js'
     *
     * //...
     *
     * const tween = new TWEEN.Tween(obj)
     * const tween2 = new TWEEN.Tween(obj2)
     *
     * //...
     *
     * requestAnimationFrame(function loop(time) {
     *   TWEEN.update(time)
     *   requestAnimationFrame(loop)
     * })
     * ```
     *
     * New code:
     *
     * ```js
     * import {Tween, Group} from '@tweenjs/tween.js'
     *
     * //...
     *
     * const tween = new Tween(obj)
     * const tween2 = new TWEEN.Tween(obj2)
     *
     * //...
     *
     * const group = new Group()
     * group.add(tween)
     * group.add(tween2)
     *
     * //...
     *
     * requestAnimationFrame(function loop(time) {
     *   group.update(time)
     *   requestAnimationFrame(loop)
     * })
     * ```
     */ add: add,
    /**
     * @deprecated The global TWEEN Group will be removed in a following major
     * release. To migrate, create a `new Group()` instead of using `TWEEN` as a
     * group.
     *
     * Old code:
     *
     * ```js
     * import * as TWEEN from '@tweenjs/tween.js'
     *
     * //...
     *
     * const tween = new TWEEN.Tween(obj)
     * const tween2 = new TWEEN.Tween(obj2)
     *
     * //...
     *
     * requestAnimationFrame(function loop(time) {
     *   TWEEN.update(time)
     *   requestAnimationFrame(loop)
     * })
     * ```
     *
     * New code:
     *
     * ```js
     * import {Tween, Group} from '@tweenjs/tween.js'
     *
     * //...
     *
     * const tween = new Tween(obj)
     * const tween2 = new TWEEN.Tween(obj2)
     *
     * //...
     *
     * const group = new Group()
     * group.add(tween)
     * group.add(tween2)
     *
     * //...
     *
     * requestAnimationFrame(function loop(time) {
     *   group.update(time)
     *   requestAnimationFrame(loop)
     * })
     * ```
     */ remove: remove,
    /**
     * @deprecated The global TWEEN Group will be removed in a following major
     * release. To migrate, create a `new Group()` instead of using `TWEEN` as a
     * group.
     *
     * Old code:
     *
     * ```js
     * import * as TWEEN from '@tweenjs/tween.js'
     *
     * //...
     *
     * const tween = new TWEEN.Tween(obj)
     * const tween2 = new TWEEN.Tween(obj2)
     *
     * //...
     *
     * requestAnimationFrame(function loop(time) {
     *   TWEEN.update(time)
     *   requestAnimationFrame(loop)
     * })
     * ```
     *
     * New code:
     *
     * ```js
     * import {Tween, Group} from '@tweenjs/tween.js'
     *
     * //...
     *
     * const tween = new Tween(obj)
     * const tween2 = new TWEEN.Tween(obj2)
     *
     * //...
     *
     * const group = new Group()
     * group.add(tween)
     * group.add(tween2)
     *
     * //...
     *
     * requestAnimationFrame(function loop(time) {
     *   group.update(time)
     *   requestAnimationFrame(loop)
     * })
     * ```
     */ update: update
};

});

parcelRegister("hOzOt", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';

var $kZO5c = parcelRequire("kZO5c");
function $cf82e2ef667d5788$var$emptyFunction() {}
function $cf82e2ef667d5788$var$emptyFunctionWithReset() {}
$cf82e2ef667d5788$var$emptyFunctionWithReset.resetWarningCache = $cf82e2ef667d5788$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $kZO5c) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $cf82e2ef667d5788$var$emptyFunctionWithReset,
        resetWarningCache: $cf82e2ef667d5788$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("kZO5c", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var $f4905a8b274aa381$var$ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = $f4905a8b274aa381$var$ReactPropTypesSecret;

});


parcelRegister("6Z7su", function(module, exports) {
/* global window */ 
var $1qzDT = parcelRequire("1qzDT");
var root;
if (typeof self !== 'undefined') root = self;
else if (typeof window !== 'undefined') root = window;
else if (typeof $parcel$global !== 'undefined') root = $parcel$global;
else root = module;
var result = (0, $1qzDT.default)(root);
var $515e39ad6749f3aa$export$2e2bcd8739ae039 = result;

});
parcelRegister("1qzDT", function(module, exports) {

$parcel$export(module.exports, "default", () => $10a3ddfbb4e508ab$export$2e2bcd8739ae039);
function $10a3ddfbb4e508ab$export$2e2bcd8739ae039(root) {
    var result;
    var Symbol = root.Symbol;
    if (typeof Symbol === 'function') {
        if (Symbol.observable) result = Symbol.observable;
        else {
            if (typeof Symbol.for === 'function') // This just needs to be something that won't trample other user's Symbol.for use
            // It also will guide people to the source of their issues, if this is problematic.
            // META: It's a resource locator!
            result = Symbol.for('https://github.com/benlesh/symbol-observable');
            else // Symbol.for didn't exist! The best we can do at this point is a totally 
            // unique symbol. Note that the string argument here is a descriptor, not
            // an identifier. This symbol is unique.
            result = Symbol('https://github.com/benlesh/symbol-observable');
            try {
                Symbol.observable = result;
            } catch (err) {
            // Do nothing. In some environments, users have frozen `Symbol` for security reasons,
            // if it is frozen assigning to it will throw. In this case, we don't care, because
            // they will need to use the returned value from the ponyfill.
            }
        }
    } else result = '@@observable';
    return result;
}

});


var $7b02d682eb115277$exports = {};
'use strict';

$7b02d682eb115277$exports = (parcelRequire("1b2ls"));


parcelRequire("acw62");
var $7e96a608cb33bf79$export$882461b6382ed46c;
var $7e96a608cb33bf79$export$757ceba2d55c277e;
'use strict';
var $11492dca620dcaa5$exports = {};
'use strict';
function $11492dca620dcaa5$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($11492dca620dcaa5$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$11492dca620dcaa5$var$checkDCE();

$11492dca620dcaa5$exports = (parcelRequire("Xw6Mv"));


var $7e96a608cb33bf79$var$i;
$7e96a608cb33bf79$export$882461b6382ed46c = $11492dca620dcaa5$exports.createRoot;
$7e96a608cb33bf79$export$757ceba2d55c277e = $11492dca620dcaa5$exports.hydrateRoot;




var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
function $efa8fc7554d57bc9$var$_iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
        var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
        try {
            if (_x = (_i = _i.call(arr)).next, 0 === i) {
                if (Object(_i) !== _i) return;
                _n = !1;
            } else for(; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
        } catch (err) {
            _d = !0, _e = err;
        } finally{
            try {
                if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
}
function $efa8fc7554d57bc9$var$_defineProperty(obj, key, value) {
    key = $efa8fc7554d57bc9$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $efa8fc7554d57bc9$var$_slicedToArray(arr, i) {
    return $efa8fc7554d57bc9$var$_arrayWithHoles(arr) || $efa8fc7554d57bc9$var$_iterableToArrayLimit(arr, i) || $efa8fc7554d57bc9$var$_unsupportedIterableToArray(arr, i) || $efa8fc7554d57bc9$var$_nonIterableRest();
}
function $efa8fc7554d57bc9$var$_toConsumableArray(arr) {
    return $efa8fc7554d57bc9$var$_arrayWithoutHoles(arr) || $efa8fc7554d57bc9$var$_iterableToArray(arr) || $efa8fc7554d57bc9$var$_unsupportedIterableToArray(arr) || $efa8fc7554d57bc9$var$_nonIterableSpread();
}
function $efa8fc7554d57bc9$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $efa8fc7554d57bc9$var$_arrayLikeToArray(arr);
}
function $efa8fc7554d57bc9$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $efa8fc7554d57bc9$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $efa8fc7554d57bc9$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $efa8fc7554d57bc9$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $efa8fc7554d57bc9$var$_arrayLikeToArray(o, minLen);
}
function $efa8fc7554d57bc9$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $efa8fc7554d57bc9$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $efa8fc7554d57bc9$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $efa8fc7554d57bc9$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $efa8fc7554d57bc9$var$_toPropertyKey(arg) {
    var key = $efa8fc7554d57bc9$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
var $efa8fc7554d57bc9$export$c44985b87d605eff = function pluck(obj, keys) {
    return Object.assign.apply(Object, [
        {}
    ].concat($efa8fc7554d57bc9$var$_toConsumableArray(keys.map(function(key) {
        return $efa8fc7554d57bc9$var$_defineProperty({}, key, obj[key]);
    }))));
};
var $efa8fc7554d57bc9$export$30a06c8d3562193f = function omit(obj, keys) {
    var keySet = new Set(keys);
    return Object.assign.apply(Object, [
        {}
    ].concat($efa8fc7554d57bc9$var$_toConsumableArray(Object.entries(obj).filter(function(_ref2) {
        var _ref3 = $efa8fc7554d57bc9$var$_slicedToArray(_ref2, 1), key = _ref3[0];
        return !keySet.has(key);
    }).map(function(_ref4) {
        var _ref5 = $efa8fc7554d57bc9$var$_slicedToArray(_ref4, 2), key = _ref5[0], val = _ref5[1];
        return $efa8fc7554d57bc9$var$_defineProperty({}, key, val);
    }))));
};


var $a3c7ec7e312bfc09$exports = {};
/*! fromentries. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */ $a3c7ec7e312bfc09$exports = function fromEntries(iterable) {
    return [
        ...iterable
    ].reduce((obj, [key, val])=>{
        obj[key] = val;
        return obj;
    }, {});
};


function $5d3aea6df4994d8c$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $5d3aea6df4994d8c$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
function $5d3aea6df4994d8c$var$_arrayWithoutHoles(r) {
    if (Array.isArray(r)) return $5d3aea6df4994d8c$var$_arrayLikeToArray(r);
}
function $5d3aea6df4994d8c$var$_iterableToArray(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function $5d3aea6df4994d8c$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) ;
            else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $5d3aea6df4994d8c$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $5d3aea6df4994d8c$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $5d3aea6df4994d8c$var$_slicedToArray(r, e) {
    return $5d3aea6df4994d8c$var$_arrayWithHoles(r) || $5d3aea6df4994d8c$var$_iterableToArrayLimit(r, e) || $5d3aea6df4994d8c$var$_unsupportedIterableToArray(r, e) || $5d3aea6df4994d8c$var$_nonIterableRest();
}
function $5d3aea6df4994d8c$var$_toConsumableArray(r) {
    return $5d3aea6df4994d8c$var$_arrayWithoutHoles(r) || $5d3aea6df4994d8c$var$_iterableToArray(r) || $5d3aea6df4994d8c$var$_unsupportedIterableToArray(r) || $5d3aea6df4994d8c$var$_nonIterableSpread();
}
function $5d3aea6df4994d8c$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $5d3aea6df4994d8c$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $5d3aea6df4994d8c$var$_typeof(o);
}
function $5d3aea6df4994d8c$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $5d3aea6df4994d8c$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $5d3aea6df4994d8c$var$_arrayLikeToArray(r, a) : void 0;
    }
}
var $5d3aea6df4994d8c$var$shallowEq = function shallowEq(o1, o2) {
    return Object.keys(o1).length === Object.keys(o2).length && Object.keys(o1).every(function(k) {
        return o1[k] === o2[k];
    });
};
function $5d3aea6df4994d8c$export$2e2bcd8739ae039(kapsuleComponent, comboParam) {
    var _ref = $5d3aea6df4994d8c$var$_typeof(comboParam) === 'object' ? comboParam : {
        // support old schema for backwards compatibility
        wrapperElementType: comboParam,
        methodNames: (arguments.length <= 2 ? undefined : arguments[2]) || undefined,
        initPropNames: (arguments.length <= 3 ? undefined : arguments[3]) || undefined
    }, _ref$wrapperElementTy = _ref.wrapperElementType, wrapperElementType = _ref$wrapperElementTy === void 0 ? 'div' : _ref$wrapperElementTy, _ref$nodeMapper = _ref.nodeMapper, nodeMapper = _ref$nodeMapper === void 0 ? function(node) {
        return node;
    } : _ref$nodeMapper, _ref$methodNames = _ref.methodNames, methodNames = _ref$methodNames === void 0 ? [] : _ref$methodNames, _ref$initPropNames = _ref.initPropNames, initPropNames = _ref$initPropNames === void 0 ? [] : _ref$initPropNames;
    return /*#__PURE__*/ (0, $acw62.forwardRef)(function(props, ref) {
        var domEl = (0, $acw62.useRef)();
        var _useState = (0, $acw62.useState)({}), _useState2 = $5d3aea6df4994d8c$var$_slicedToArray(_useState, 2), prevProps = _useState2[0], setPrevProps = _useState2[1];
        (0, $acw62.useEffect)(function() {
            !$5d3aea6df4994d8c$var$shallowEq(props, prevProps) && setPrevProps(props);
        }); // remember previous props
        // instantiate the inner kapsule component with the defined initPropNames
        var comp = (0, $acw62.useMemo)(function() {
            var configOptions = (0, (/*@__PURE__*/$parcel$interopDefault($a3c7ec7e312bfc09$exports)))(initPropNames.filter(function(p) {
                return props.hasOwnProperty(p);
            }).map(function(prop) {
                return [
                    prop,
                    props[prop]
                ];
            }));
            return kapsuleComponent(configOptions);
        }, []);
        $5d3aea6df4994d8c$var$useEffectOnce(function() {
            comp(nodeMapper(domEl.current)); // mount kapsule synchronously on this element ref, optionally mapped into an object that the kapsule understands
        }, (0, $acw62.useLayoutEffect));
        $5d3aea6df4994d8c$var$useEffectOnce(function() {
            // invoke destructor on unmount, if it exists
            return comp._destructor instanceof Function ? comp._destructor : undefined;
        });
        // Call a component method
        var _call = (0, $acw62.useCallback)(function(method) {
            for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
            return comp[method] instanceof Function ? comp[method].apply(comp, args) : undefined;
        } // method not found
        , [
            comp
        ]);
        // propagate component props that have changed
        var dynamicProps = (0, $efa8fc7554d57bc9$export$30a06c8d3562193f)(props, [].concat($5d3aea6df4994d8c$var$_toConsumableArray(methodNames), $5d3aea6df4994d8c$var$_toConsumableArray(initPropNames))); // initPropNames or methodNames should not be called
        Object.keys(dynamicProps).filter(function(p) {
            return prevProps[p] !== props[p];
        }).forEach(function(p) {
            return _call(p, props[p]);
        });
        // bind external methods to parent ref
        (0, $acw62.useImperativeHandle)(ref, function() {
            return (0, (/*@__PURE__*/$parcel$interopDefault($a3c7ec7e312bfc09$exports)))(methodNames.map(function(method) {
                return [
                    method,
                    function() {
                        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
                        return _call.apply(void 0, [
                            method
                        ].concat(args));
                    }
                ];
            }));
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(wrapperElementType, {
            ref: domEl
        });
    });
}
//
// Handle R18 strict mode double mount at init
function $5d3aea6df4994d8c$var$useEffectOnce(effect) {
    var useEffectFn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $acw62.useEffect);
    var destroyFunc = (0, $acw62.useRef)();
    var effectCalled = (0, $acw62.useRef)(false);
    var renderAfterCalled = (0, $acw62.useRef)(false);
    var _useState3 = (0, $acw62.useState)(0), _useState4 = $5d3aea6df4994d8c$var$_slicedToArray(_useState3, 2);
    _useState4[0];
    var setVal = _useState4[1];
    if (effectCalled.current) renderAfterCalled.current = true;
    useEffectFn(function() {
        // only execute the effect first time around
        if (!effectCalled.current) {
            destroyFunc.current = effect();
            effectCalled.current = true;
        }
        // this forces one render after the effect is run
        setVal(function(val) {
            return val + 1;
        });
        return function() {
            // if the comp didn't render since the useEffect was called,
            // we know it's the dummy React cycle
            if (!renderAfterCalled.current) return;
            if (destroyFunc.current) destroyFunc.current();
        };
    }, []);
}


/**
 * @license
 * Copyright 2010-2024 Three.js Authors
 * SPDX-License-Identifier: MIT
 */ const $d5b33d7c30034067$export$3545e07a80636437 = '170';
const $d5b33d7c30034067$export$7177b3e430c2d7ca = {
    LEFT: 0,
    MIDDLE: 1,
    RIGHT: 2,
    ROTATE: 0,
    DOLLY: 1,
    PAN: 2
};
const $d5b33d7c30034067$export$d46bd3ead7cc759b = {
    ROTATE: 0,
    PAN: 1,
    DOLLY_PAN: 2,
    DOLLY_ROTATE: 3
};
const $d5b33d7c30034067$export$3237e1f2c1ea1f44 = 0;
const $d5b33d7c30034067$export$b9a7b4fc5cb15f9b = 1;
const $d5b33d7c30034067$export$b8058bcc7037d3f3 = 2;
const $d5b33d7c30034067$export$f24be24dcddeac0d = 3;
const $d5b33d7c30034067$export$346307dbae2b7447 = 0;
const $d5b33d7c30034067$export$5813f879eee7cd88 = 1;
const $d5b33d7c30034067$export$a47c4b43a1be34f0 = 2;
const $d5b33d7c30034067$export$896ae1ade6c829c4 = 3;
const $d5b33d7c30034067$export$2ede184fc2998901 = 0;
const $d5b33d7c30034067$export$d9f0486e75b5ace = 1;
const $d5b33d7c30034067$export$3b296b6f144d5b03 = 2;
const $d5b33d7c30034067$export$63b8d6b580fc65ba = 0;
const $d5b33d7c30034067$export$5b29a26d96ee6af0 = 1;
const $d5b33d7c30034067$export$777d8f9551c2216b = 2;
const $d5b33d7c30034067$export$cdfa06f868e2e467 = 3;
const $d5b33d7c30034067$export$4138e1c684b46a20 = 4;
const $d5b33d7c30034067$export$eda4864c68df1fa2 = 5;
const $d5b33d7c30034067$export$20183a0484ce21a0 = 100;
const $d5b33d7c30034067$export$73e0df5177988548 = 101;
const $d5b33d7c30034067$export$28e582859cbec660 = 102;
const $d5b33d7c30034067$export$c8c1508da8d0600c = 103;
const $d5b33d7c30034067$export$99948c02fb51055f = 104;
const $d5b33d7c30034067$export$2110f05edf778d3d = 200;
const $d5b33d7c30034067$export$8805bad65e24940e = 201;
const $d5b33d7c30034067$export$7fbe15b28d28cf52 = 202;
const $d5b33d7c30034067$export$947829af9f2c17f6 = 203;
const $d5b33d7c30034067$export$d5773124e86cf28c = 204;
const $d5b33d7c30034067$export$11d468cc7f19e971 = 205;
const $d5b33d7c30034067$export$a78aed1ca2a87192 = 206;
const $d5b33d7c30034067$export$5d0fe17fd8773bac = 207;
const $d5b33d7c30034067$export$ef5f2dd8ffac5574 = 208;
const $d5b33d7c30034067$export$56b85b2686ab16 = 209;
const $d5b33d7c30034067$export$c05e2a1fc8609506 = 210;
const $d5b33d7c30034067$export$7dd8f434fd59075 = 211;
const $d5b33d7c30034067$export$99c8d898a9afbcee = 212;
const $d5b33d7c30034067$export$310cd2be38d13b56 = 213;
const $d5b33d7c30034067$export$db77b8fbcf45dbf4 = 214;
const $d5b33d7c30034067$export$69025ce147cee220 = 0;
const $d5b33d7c30034067$export$7182eb52ea3b3f04 = 1;
const $d5b33d7c30034067$export$eedccec66ab7ebe = 2;
const $d5b33d7c30034067$export$296f78a0b892f81a = 3;
const $d5b33d7c30034067$export$a60d398fc7b7590e = 4;
const $d5b33d7c30034067$export$7d7234c1240a1fc4 = 5;
const $d5b33d7c30034067$export$c5e2c52991f30937 = 6;
const $d5b33d7c30034067$export$2f843afa843d8916 = 7;
const $d5b33d7c30034067$export$e50ac29801f1774d = 0;
const $d5b33d7c30034067$export$9f9d94f963c85479 = 1;
const $d5b33d7c30034067$export$e641dc52bc3494aa = 2;
const $d5b33d7c30034067$export$9fcb6b4294603b2 = 0;
const $d5b33d7c30034067$export$98f52c2a46c598ca = 1;
const $d5b33d7c30034067$export$74b25e54b3bcd548 = 2;
const $d5b33d7c30034067$export$932b3dd283d4a366 = 3;
const $d5b33d7c30034067$export$a0d98fe6d7e4af64 = 4;
const $d5b33d7c30034067$export$2c7b09c1e9abfb5e = 5;
const $d5b33d7c30034067$export$212d53a513a325b2 = 6;
const $d5b33d7c30034067$export$f2863e1668a8e317 = 7;
const $d5b33d7c30034067$export$2595a3798997538 = 'attached';
const $d5b33d7c30034067$export$d7e7dc2e114517a0 = 'detached';
const $d5b33d7c30034067$export$1beec6768cbb3d2d = 300;
const $d5b33d7c30034067$export$8759762a6477f2c4 = 301;
const $d5b33d7c30034067$export$dc59f8aed047f61d = 302;
const $d5b33d7c30034067$export$d64030b316d3b087 = 303;
const $d5b33d7c30034067$export$ee99d97d46898098 = 304;
const $d5b33d7c30034067$export$dbf3e70ff37af79 = 306;
const $d5b33d7c30034067$export$533346c8e8dac0f5 = 1000;
const $d5b33d7c30034067$export$9d9334239a5a5e06 = 1001;
const $d5b33d7c30034067$export$c7e7c00b14f51a4f = 1002;
const $d5b33d7c30034067$export$727aa5ec3fe39bf0 = 1003;
const $d5b33d7c30034067$export$d129e38cf6feaa8c = 1004;
const $d5b33d7c30034067$export$14a4936464a36496 = 1004;
const $d5b33d7c30034067$export$d2327c1afe5bfdf2 = 1005;
const $d5b33d7c30034067$export$cbc5b7f5647595d8 = 1005;
const $d5b33d7c30034067$export$8a72f490b25c56c8 = 1006;
const $d5b33d7c30034067$export$19a719f377145a13 = 1007;
const $d5b33d7c30034067$export$dbe96bee3fe9dbf0 = 1007;
const $d5b33d7c30034067$export$5d8599b6a933fb1b = 1008;
const $d5b33d7c30034067$export$90d80f1e3506775f = 1008;
const $d5b33d7c30034067$export$2e8ce08d3f6f5e10 = 1009;
const $d5b33d7c30034067$export$545fce0311a9796a = 1010;
const $d5b33d7c30034067$export$88572337f312435f = 1011;
const $d5b33d7c30034067$export$c63dc51868b06a9d = 1012;
const $d5b33d7c30034067$export$5c612977753abe2 = 1013;
const $d5b33d7c30034067$export$c3c7fc4518ebba96 = 1014;
const $d5b33d7c30034067$export$f6d331659b644596 = 1015;
const $d5b33d7c30034067$export$2697304443f382bc = 1016;
const $d5b33d7c30034067$export$b3969b01faf587f2 = 1017;
const $d5b33d7c30034067$export$18886f8ae33e90de = 1018;
const $d5b33d7c30034067$export$6c8ea339bfab1301 = 1020;
const $d5b33d7c30034067$export$5a4c329b7e2092d3 = 35902;
const $d5b33d7c30034067$export$988473390501ed4b = 1021;
const $d5b33d7c30034067$export$7c67423a5ee6f5eb = 1022;
const $d5b33d7c30034067$export$3f8bb04b555a363c = 1023;
const $d5b33d7c30034067$export$cc09ccbf6d1ed449 = 1024;
const $d5b33d7c30034067$export$9053a81c4a69c289 = 1025;
const $d5b33d7c30034067$export$c1b6b5136be58045 = 1026;
const $d5b33d7c30034067$export$1e113ac2d0905829 = 1027;
const $d5b33d7c30034067$export$4e041a7967d15c4b = 1028;
const $d5b33d7c30034067$export$aa92e870a709d190 = 1029;
const $d5b33d7c30034067$export$6cdf0b461c7ce8a0 = 1030;
const $d5b33d7c30034067$export$1ba1c45f9f77d4d7 = 1031;
const $d5b33d7c30034067$export$d1fd40c11bfa798e = 1032;
const $d5b33d7c30034067$export$c200e7d26f592f21 = 1033;
const $d5b33d7c30034067$export$21d1799c6d552fc0 = 33776;
const $d5b33d7c30034067$export$afa304c3e981b668 = 33777;
const $d5b33d7c30034067$export$d2a1a68024a3e56c = 33778;
const $d5b33d7c30034067$export$9a79c424327dacf9 = 33779;
const $d5b33d7c30034067$export$19ada9bbb1af3573 = 35840;
const $d5b33d7c30034067$export$d0f0355bb3d948e4 = 35841;
const $d5b33d7c30034067$export$b82296714358084c = 35842;
const $d5b33d7c30034067$export$b71692456c47b6c3 = 35843;
const $d5b33d7c30034067$export$6ab91af2d757aee7 = 36196;
const $d5b33d7c30034067$export$7800993ef8106a6a = 37492;
const $d5b33d7c30034067$export$23ed8300a860e7d8 = 37496;
const $d5b33d7c30034067$export$dc5570b4a2b92d48 = 37808;
const $d5b33d7c30034067$export$68880cd325f8b2fb = 37809;
const $d5b33d7c30034067$export$7d2c0be323373d95 = 37810;
const $d5b33d7c30034067$export$22b52da301fc3a3e = 37811;
const $d5b33d7c30034067$export$c009e2cb4a66485e = 37812;
const $d5b33d7c30034067$export$118fff5afa255b63 = 37813;
const $d5b33d7c30034067$export$120713c829ae0667 = 37814;
const $d5b33d7c30034067$export$c79eeabbf53313e9 = 37815;
const $d5b33d7c30034067$export$443cf6567cdd6424 = 37816;
const $d5b33d7c30034067$export$6573984fc9840780 = 37817;
const $d5b33d7c30034067$export$e7aee563f30091de = 37818;
const $d5b33d7c30034067$export$2eb8634622ddeab7 = 37819;
const $d5b33d7c30034067$export$202b1ce7b5d25742 = 37820;
const $d5b33d7c30034067$export$18ab77abd087e467 = 37821;
const $d5b33d7c30034067$export$ce40b115e188bc81 = 36492;
const $d5b33d7c30034067$export$d279c5c4bac5121e = 36494;
const $d5b33d7c30034067$export$cde52d17225fdbd3 = 36495;
const $d5b33d7c30034067$export$b1688df4c4c21670 = 36283;
const $d5b33d7c30034067$export$fc15e5d8261eed58 = 36284;
const $d5b33d7c30034067$export$d220f6ade8463a0f = 36285;
const $d5b33d7c30034067$export$768646d09dc1b6ef = 36286;
const $d5b33d7c30034067$export$d62fdc9d1b1cccad = 2200;
const $d5b33d7c30034067$export$dfaf4422ce096e29 = 2201;
const $d5b33d7c30034067$export$f8f6f2041b78e210 = 2202;
const $d5b33d7c30034067$export$995b32462a65e855 = 2300;
const $d5b33d7c30034067$export$30fac1aace31cf4d = 2301;
const $d5b33d7c30034067$export$198b11ff4c72bb30 = 2302;
const $d5b33d7c30034067$export$7f795934b84ab523 = 2400;
const $d5b33d7c30034067$export$24a4ccb5099273b5 = 2401;
const $d5b33d7c30034067$export$8e8c3ecdcd8e1fee = 2402;
const $d5b33d7c30034067$export$bcfbbdcf8de7f8cd = 2500;
const $d5b33d7c30034067$export$d875e029ef558d3 = 2501;
const $d5b33d7c30034067$export$4c28c87c2dc84758 = 0;
const $d5b33d7c30034067$export$b23a071aa286eb29 = 1;
const $d5b33d7c30034067$export$f0d8293634f88842 = 2;
const $d5b33d7c30034067$export$deeb383078690b50 = 3200;
const $d5b33d7c30034067$export$8f910f4c4f73df11 = 3201;
const $d5b33d7c30034067$export$be2e2ddbc3983173 = 3202;
const $d5b33d7c30034067$export$1a54198784742f80 = 3203;
const $d5b33d7c30034067$export$2852a58ebdac27b8 = 0;
const $d5b33d7c30034067$export$9990ad26f9db5b2c = 1;
// Color space string identifiers, matching CSS Color Module Level 4 and WebGPU names where available.
const $d5b33d7c30034067$export$bfcb490c2dd3db51 = '';
const $d5b33d7c30034067$export$561f394b24edfcaa = 'srgb';
const $d5b33d7c30034067$export$42429b3acfb233a4 = 'srgb-linear';
const $d5b33d7c30034067$export$f197347d588c1b4a = 'linear';
const $d5b33d7c30034067$export$8d0a61916cc26abb = 'srgb';
const $d5b33d7c30034067$export$69433f11f42d5527 = 0;
const $d5b33d7c30034067$export$9f542ae4b5baca34 = 7680;
const $d5b33d7c30034067$export$8a4f28336ef203d3 = 7681;
const $d5b33d7c30034067$export$2928c0231297c036 = 7682;
const $d5b33d7c30034067$export$c0e9611c8a15f9a8 = 7683;
const $d5b33d7c30034067$export$9c2c08927385dcc4 = 34055;
const $d5b33d7c30034067$export$7c74ea00fa1315e6 = 34056;
const $d5b33d7c30034067$export$22e2e5726612443 = 5386;
const $d5b33d7c30034067$export$1343870698229224 = 512;
const $d5b33d7c30034067$export$8e1d8ed281997fa6 = 513;
const $d5b33d7c30034067$export$55648a1cde8329a7 = 514;
const $d5b33d7c30034067$export$2dff107857e6aca2 = 515;
const $d5b33d7c30034067$export$6f93765ab2f451a2 = 516;
const $d5b33d7c30034067$export$6f3fb2d2440f2b76 = 517;
const $d5b33d7c30034067$export$4119cf7b4c98fd5a = 518;
const $d5b33d7c30034067$export$14cf96713ddd97a8 = 519;
const $d5b33d7c30034067$export$d9e2d19a747baaab = 512;
const $d5b33d7c30034067$export$36bcf49c713b3eb7 = 513;
const $d5b33d7c30034067$export$66f28d946fc6a0d5 = 514;
const $d5b33d7c30034067$export$64eea11eb407ddf1 = 515;
const $d5b33d7c30034067$export$155af022118f3a38 = 516;
const $d5b33d7c30034067$export$67ab95dde6bed156 = 517;
const $d5b33d7c30034067$export$1cdcb70d53d65f61 = 518;
const $d5b33d7c30034067$export$187b73a3e352c145 = 519;
const $d5b33d7c30034067$export$763e8360f4d7f77d = 35044;
const $d5b33d7c30034067$export$8505d14ac8546ca = 35048;
const $d5b33d7c30034067$export$721e63549e51d81e = 35040;
const $d5b33d7c30034067$export$415731dc4f48e299 = 35045;
const $d5b33d7c30034067$export$9e809946455f13bc = 35049;
const $d5b33d7c30034067$export$2ed9499a35b5f832 = 35041;
const $d5b33d7c30034067$export$32ab2503ea19469a = 35046;
const $d5b33d7c30034067$export$ab4022c2c3f86315 = 35050;
const $d5b33d7c30034067$export$ba7f1db36a76a970 = 35042;
const $d5b33d7c30034067$export$43600cc67fabd9f = '100';
const $d5b33d7c30034067$export$f63012db5506e7dd = '300 es';
const $d5b33d7c30034067$export$5a0e9190d10875d3 = 2000;
const $d5b33d7c30034067$export$cc83beedcb9be9ac = 2001;
/**
 * https://github.com/mrdoob/eventdispatcher.js/
 */ class $d5b33d7c30034067$export$ec8b666c5fe2c75a {
    addEventListener(type, listener) {
        if (this._listeners === undefined) this._listeners = {};
        const listeners = this._listeners;
        if (listeners[type] === undefined) listeners[type] = [];
        if (listeners[type].indexOf(listener) === -1) listeners[type].push(listener);
    }
    hasEventListener(type, listener) {
        if (this._listeners === undefined) return false;
        const listeners = this._listeners;
        return listeners[type] !== undefined && listeners[type].indexOf(listener) !== -1;
    }
    removeEventListener(type, listener) {
        if (this._listeners === undefined) return;
        const listeners = this._listeners;
        const listenerArray = listeners[type];
        if (listenerArray !== undefined) {
            const index = listenerArray.indexOf(listener);
            if (index !== -1) listenerArray.splice(index, 1);
        }
    }
    dispatchEvent(event) {
        if (this._listeners === undefined) return;
        const listeners = this._listeners;
        const listenerArray = listeners[event.type];
        if (listenerArray !== undefined) {
            event.target = this;
            // Make a copy, in case listeners are removed while iterating.
            const array = listenerArray.slice(0);
            for(let i = 0, l = array.length; i < l; i++)array[i].call(this, event);
            event.target = null;
        }
    }
}
const $d5b33d7c30034067$var$_lut = [
    '00',
    '01',
    '02',
    '03',
    '04',
    '05',
    '06',
    '07',
    '08',
    '09',
    '0a',
    '0b',
    '0c',
    '0d',
    '0e',
    '0f',
    '10',
    '11',
    '12',
    '13',
    '14',
    '15',
    '16',
    '17',
    '18',
    '19',
    '1a',
    '1b',
    '1c',
    '1d',
    '1e',
    '1f',
    '20',
    '21',
    '22',
    '23',
    '24',
    '25',
    '26',
    '27',
    '28',
    '29',
    '2a',
    '2b',
    '2c',
    '2d',
    '2e',
    '2f',
    '30',
    '31',
    '32',
    '33',
    '34',
    '35',
    '36',
    '37',
    '38',
    '39',
    '3a',
    '3b',
    '3c',
    '3d',
    '3e',
    '3f',
    '40',
    '41',
    '42',
    '43',
    '44',
    '45',
    '46',
    '47',
    '48',
    '49',
    '4a',
    '4b',
    '4c',
    '4d',
    '4e',
    '4f',
    '50',
    '51',
    '52',
    '53',
    '54',
    '55',
    '56',
    '57',
    '58',
    '59',
    '5a',
    '5b',
    '5c',
    '5d',
    '5e',
    '5f',
    '60',
    '61',
    '62',
    '63',
    '64',
    '65',
    '66',
    '67',
    '68',
    '69',
    '6a',
    '6b',
    '6c',
    '6d',
    '6e',
    '6f',
    '70',
    '71',
    '72',
    '73',
    '74',
    '75',
    '76',
    '77',
    '78',
    '79',
    '7a',
    '7b',
    '7c',
    '7d',
    '7e',
    '7f',
    '80',
    '81',
    '82',
    '83',
    '84',
    '85',
    '86',
    '87',
    '88',
    '89',
    '8a',
    '8b',
    '8c',
    '8d',
    '8e',
    '8f',
    '90',
    '91',
    '92',
    '93',
    '94',
    '95',
    '96',
    '97',
    '98',
    '99',
    '9a',
    '9b',
    '9c',
    '9d',
    '9e',
    '9f',
    'a0',
    'a1',
    'a2',
    'a3',
    'a4',
    'a5',
    'a6',
    'a7',
    'a8',
    'a9',
    'aa',
    'ab',
    'ac',
    'ad',
    'ae',
    'af',
    'b0',
    'b1',
    'b2',
    'b3',
    'b4',
    'b5',
    'b6',
    'b7',
    'b8',
    'b9',
    'ba',
    'bb',
    'bc',
    'bd',
    'be',
    'bf',
    'c0',
    'c1',
    'c2',
    'c3',
    'c4',
    'c5',
    'c6',
    'c7',
    'c8',
    'c9',
    'ca',
    'cb',
    'cc',
    'cd',
    'ce',
    'cf',
    'd0',
    'd1',
    'd2',
    'd3',
    'd4',
    'd5',
    'd6',
    'd7',
    'd8',
    'd9',
    'da',
    'db',
    'dc',
    'dd',
    'de',
    'df',
    'e0',
    'e1',
    'e2',
    'e3',
    'e4',
    'e5',
    'e6',
    'e7',
    'e8',
    'e9',
    'ea',
    'eb',
    'ec',
    'ed',
    'ee',
    'ef',
    'f0',
    'f1',
    'f2',
    'f3',
    'f4',
    'f5',
    'f6',
    'f7',
    'f8',
    'f9',
    'fa',
    'fb',
    'fc',
    'fd',
    'fe',
    'ff'
];
let $d5b33d7c30034067$var$_seed = 1234567;
const $d5b33d7c30034067$var$DEG2RAD = Math.PI / 180;
const $d5b33d7c30034067$var$RAD2DEG = 180 / Math.PI;
// http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/21963136#21963136
function $d5b33d7c30034067$var$generateUUID() {
    const d0 = Math.random() * 0xffffffff | 0;
    const d1 = Math.random() * 0xffffffff | 0;
    const d2 = Math.random() * 0xffffffff | 0;
    const d3 = Math.random() * 0xffffffff | 0;
    const uuid = $d5b33d7c30034067$var$_lut[d0 & 0xff] + $d5b33d7c30034067$var$_lut[d0 >> 8 & 0xff] + $d5b33d7c30034067$var$_lut[d0 >> 16 & 0xff] + $d5b33d7c30034067$var$_lut[d0 >> 24 & 0xff] + '-' + $d5b33d7c30034067$var$_lut[d1 & 0xff] + $d5b33d7c30034067$var$_lut[d1 >> 8 & 0xff] + '-' + $d5b33d7c30034067$var$_lut[d1 >> 16 & 0x0f | 0x40] + $d5b33d7c30034067$var$_lut[d1 >> 24 & 0xff] + '-' + $d5b33d7c30034067$var$_lut[d2 & 0x3f | 0x80] + $d5b33d7c30034067$var$_lut[d2 >> 8 & 0xff] + '-' + $d5b33d7c30034067$var$_lut[d2 >> 16 & 0xff] + $d5b33d7c30034067$var$_lut[d2 >> 24 & 0xff] + $d5b33d7c30034067$var$_lut[d3 & 0xff] + $d5b33d7c30034067$var$_lut[d3 >> 8 & 0xff] + $d5b33d7c30034067$var$_lut[d3 >> 16 & 0xff] + $d5b33d7c30034067$var$_lut[d3 >> 24 & 0xff];
    // .toLowerCase() here flattens concatenated strings to save heap memory space.
    return uuid.toLowerCase();
}
function $d5b33d7c30034067$var$clamp(value, min, max) {
    return Math.max(min, Math.min(max, value));
}
// compute euclidean modulo of m % n
// https://en.wikipedia.org/wiki/Modulo_operation
function $d5b33d7c30034067$var$euclideanModulo(n, m) {
    return (n % m + m) % m;
}
// Linear mapping from range <a1, a2> to range <b1, b2>
function $d5b33d7c30034067$var$mapLinear(x, a1, a2, b1, b2) {
    return b1 + (x - a1) * (b2 - b1) / (a2 - a1);
}
// https://www.gamedev.net/tutorials/programming/general-and-gameplay-programming/inverse-lerp-a-super-useful-yet-often-overlooked-function-r5230/
function $d5b33d7c30034067$var$inverseLerp(x, y, value) {
    if (x !== y) return (value - x) / (y - x);
    else return 0;
}
// https://en.wikipedia.org/wiki/Linear_interpolation
function $d5b33d7c30034067$var$lerp(x, y, t) {
    return (1 - t) * x + t * y;
}
// http://www.rorydriscoll.com/2016/03/07/frame-rate-independent-damping-using-lerp/
function $d5b33d7c30034067$var$damp(x, y, lambda, dt) {
    return $d5b33d7c30034067$var$lerp(x, y, 1 - Math.exp(-lambda * dt));
}
// https://www.desmos.com/calculator/vcsjnyz7x4
function $d5b33d7c30034067$var$pingpong(x, length = 1) {
    return length - Math.abs($d5b33d7c30034067$var$euclideanModulo(x, length * 2) - length);
}
// http://en.wikipedia.org/wiki/Smoothstep
function $d5b33d7c30034067$var$smoothstep(x, min, max) {
    if (x <= min) return 0;
    if (x >= max) return 1;
    x = (x - min) / (max - min);
    return x * x * (3 - 2 * x);
}
function $d5b33d7c30034067$var$smootherstep(x, min, max) {
    if (x <= min) return 0;
    if (x >= max) return 1;
    x = (x - min) / (max - min);
    return x * x * x * (x * (x * 6 - 15) + 10);
}
// Random integer from <low, high> interval
function $d5b33d7c30034067$var$randInt(low, high) {
    return low + Math.floor(Math.random() * (high - low + 1));
}
// Random float from <low, high> interval
function $d5b33d7c30034067$var$randFloat(low, high) {
    return low + Math.random() * (high - low);
}
// Random float from <-range/2, range/2> interval
function $d5b33d7c30034067$var$randFloatSpread(range) {
    return range * (0.5 - Math.random());
}
// Deterministic pseudo-random float in the interval [ 0, 1 ]
function $d5b33d7c30034067$var$seededRandom(s) {
    if (s !== undefined) $d5b33d7c30034067$var$_seed = s;
    // Mulberry32 generator
    let t = $d5b33d7c30034067$var$_seed += 0x6D2B79F5;
    t = Math.imul(t ^ t >>> 15, t | 1);
    t ^= t + Math.imul(t ^ t >>> 7, t | 61);
    return ((t ^ t >>> 14) >>> 0) / 4294967296;
}
function $d5b33d7c30034067$var$degToRad(degrees) {
    return degrees * $d5b33d7c30034067$var$DEG2RAD;
}
function $d5b33d7c30034067$var$radToDeg(radians) {
    return radians * $d5b33d7c30034067$var$RAD2DEG;
}
function $d5b33d7c30034067$var$isPowerOfTwo(value) {
    return (value & value - 1) === 0 && value !== 0;
}
function $d5b33d7c30034067$var$ceilPowerOfTwo(value) {
    return Math.pow(2, Math.ceil(Math.log(value) / Math.LN2));
}
function $d5b33d7c30034067$var$floorPowerOfTwo(value) {
    return Math.pow(2, Math.floor(Math.log(value) / Math.LN2));
}
function $d5b33d7c30034067$var$setQuaternionFromProperEuler(q, a, b, c, order) {
    // Intrinsic Proper Euler Angles - see https://en.wikipedia.org/wiki/Euler_angles
    // rotations are applied to the axes in the order specified by 'order'
    // rotation by angle 'a' is applied first, then by angle 'b', then by angle 'c'
    // angles are in radians
    const cos = Math.cos;
    const sin = Math.sin;
    const c2 = cos(b / 2);
    const s2 = sin(b / 2);
    const c13 = cos((a + c) / 2);
    const s13 = sin((a + c) / 2);
    const c1_3 = cos((a - c) / 2);
    const s1_3 = sin((a - c) / 2);
    const c3_1 = cos((c - a) / 2);
    const s3_1 = sin((c - a) / 2);
    switch(order){
        case 'XYX':
            q.set(c2 * s13, s2 * c1_3, s2 * s1_3, c2 * c13);
            break;
        case 'YZY':
            q.set(s2 * s1_3, c2 * s13, s2 * c1_3, c2 * c13);
            break;
        case 'ZXZ':
            q.set(s2 * c1_3, s2 * s1_3, c2 * s13, c2 * c13);
            break;
        case 'XZX':
            q.set(c2 * s13, s2 * s3_1, s2 * c3_1, c2 * c13);
            break;
        case 'YXY':
            q.set(s2 * c3_1, c2 * s13, s2 * s3_1, c2 * c13);
            break;
        case 'ZYZ':
            q.set(s2 * s3_1, s2 * c3_1, c2 * s13, c2 * c13);
            break;
        default:
            console.warn('THREE.MathUtils: .setQuaternionFromProperEuler() encountered an unknown order: ' + order);
    }
}
function $d5b33d7c30034067$var$denormalize(value, array) {
    switch(array.constructor){
        case Float32Array:
            return value;
        case Uint32Array:
            return value / 4294967295.0;
        case Uint16Array:
            return value / 65535.0;
        case Uint8Array:
            return value / 255.0;
        case Int32Array:
            return Math.max(value / 2147483647.0, -1);
        case Int16Array:
            return Math.max(value / 32767.0, -1);
        case Int8Array:
            return Math.max(value / 127.0, -1);
        default:
            throw new Error('Invalid component type.');
    }
}
function $d5b33d7c30034067$var$normalize(value, array) {
    switch(array.constructor){
        case Float32Array:
            return value;
        case Uint32Array:
            return Math.round(value * 4294967295.0);
        case Uint16Array:
            return Math.round(value * 65535.0);
        case Uint8Array:
            return Math.round(value * 255.0);
        case Int32Array:
            return Math.round(value * 2147483647.0);
        case Int16Array:
            return Math.round(value * 32767.0);
        case Int8Array:
            return Math.round(value * 127.0);
        default:
            throw new Error('Invalid component type.');
    }
}
const $d5b33d7c30034067$export$6a7ef315a0d1ef07 = {
    DEG2RAD: $d5b33d7c30034067$var$DEG2RAD,
    RAD2DEG: $d5b33d7c30034067$var$RAD2DEG,
    generateUUID: $d5b33d7c30034067$var$generateUUID,
    clamp: $d5b33d7c30034067$var$clamp,
    euclideanModulo: $d5b33d7c30034067$var$euclideanModulo,
    mapLinear: $d5b33d7c30034067$var$mapLinear,
    inverseLerp: $d5b33d7c30034067$var$inverseLerp,
    lerp: $d5b33d7c30034067$var$lerp,
    damp: $d5b33d7c30034067$var$damp,
    pingpong: $d5b33d7c30034067$var$pingpong,
    smoothstep: $d5b33d7c30034067$var$smoothstep,
    smootherstep: $d5b33d7c30034067$var$smootherstep,
    randInt: $d5b33d7c30034067$var$randInt,
    randFloat: $d5b33d7c30034067$var$randFloat,
    randFloatSpread: $d5b33d7c30034067$var$randFloatSpread,
    seededRandom: $d5b33d7c30034067$var$seededRandom,
    degToRad: $d5b33d7c30034067$var$degToRad,
    radToDeg: $d5b33d7c30034067$var$radToDeg,
    isPowerOfTwo: $d5b33d7c30034067$var$isPowerOfTwo,
    ceilPowerOfTwo: $d5b33d7c30034067$var$ceilPowerOfTwo,
    floorPowerOfTwo: $d5b33d7c30034067$var$floorPowerOfTwo,
    setQuaternionFromProperEuler: $d5b33d7c30034067$var$setQuaternionFromProperEuler,
    normalize: $d5b33d7c30034067$var$normalize,
    denormalize: $d5b33d7c30034067$var$denormalize
};
class $d5b33d7c30034067$export$c977b3e384af9ae1 {
    constructor(x = 0, y = 0){
        $d5b33d7c30034067$export$c977b3e384af9ae1.prototype.isVector2 = true;
        this.x = x;
        this.y = y;
    }
    get width() {
        return this.x;
    }
    set width(value) {
        this.x = value;
    }
    get height() {
        return this.y;
    }
    set height(value) {
        this.y = value;
    }
    set(x, y) {
        this.x = x;
        this.y = y;
        return this;
    }
    setScalar(scalar) {
        this.x = scalar;
        this.y = scalar;
        return this;
    }
    setX(x) {
        this.x = x;
        return this;
    }
    setY(y) {
        this.y = y;
        return this;
    }
    setComponent(index, value) {
        switch(index){
            case 0:
                this.x = value;
                break;
            case 1:
                this.y = value;
                break;
            default:
                throw new Error('index is out of range: ' + index);
        }
        return this;
    }
    getComponent(index) {
        switch(index){
            case 0:
                return this.x;
            case 1:
                return this.y;
            default:
                throw new Error('index is out of range: ' + index);
        }
    }
    clone() {
        return new this.constructor(this.x, this.y);
    }
    copy(v) {
        this.x = v.x;
        this.y = v.y;
        return this;
    }
    add(v) {
        this.x += v.x;
        this.y += v.y;
        return this;
    }
    addScalar(s) {
        this.x += s;
        this.y += s;
        return this;
    }
    addVectors(a, b) {
        this.x = a.x + b.x;
        this.y = a.y + b.y;
        return this;
    }
    addScaledVector(v, s) {
        this.x += v.x * s;
        this.y += v.y * s;
        return this;
    }
    sub(v) {
        this.x -= v.x;
        this.y -= v.y;
        return this;
    }
    subScalar(s) {
        this.x -= s;
        this.y -= s;
        return this;
    }
    subVectors(a, b) {
        this.x = a.x - b.x;
        this.y = a.y - b.y;
        return this;
    }
    multiply(v) {
        this.x *= v.x;
        this.y *= v.y;
        return this;
    }
    multiplyScalar(scalar) {
        this.x *= scalar;
        this.y *= scalar;
        return this;
    }
    divide(v) {
        this.x /= v.x;
        this.y /= v.y;
        return this;
    }
    divideScalar(scalar) {
        return this.multiplyScalar(1 / scalar);
    }
    applyMatrix3(m) {
        const x = this.x, y = this.y;
        const e = m.elements;
        this.x = e[0] * x + e[3] * y + e[6];
        this.y = e[1] * x + e[4] * y + e[7];
        return this;
    }
    min(v) {
        this.x = Math.min(this.x, v.x);
        this.y = Math.min(this.y, v.y);
        return this;
    }
    max(v) {
        this.x = Math.max(this.x, v.x);
        this.y = Math.max(this.y, v.y);
        return this;
    }
    clamp(min, max) {
        // assumes min < max, componentwise
        this.x = Math.max(min.x, Math.min(max.x, this.x));
        this.y = Math.max(min.y, Math.min(max.y, this.y));
        return this;
    }
    clampScalar(minVal, maxVal) {
        this.x = Math.max(minVal, Math.min(maxVal, this.x));
        this.y = Math.max(minVal, Math.min(maxVal, this.y));
        return this;
    }
    clampLength(min, max) {
        const length = this.length();
        return this.divideScalar(length || 1).multiplyScalar(Math.max(min, Math.min(max, length)));
    }
    floor() {
        this.x = Math.floor(this.x);
        this.y = Math.floor(this.y);
        return this;
    }
    ceil() {
        this.x = Math.ceil(this.x);
        this.y = Math.ceil(this.y);
        return this;
    }
    round() {
        this.x = Math.round(this.x);
        this.y = Math.round(this.y);
        return this;
    }
    roundToZero() {
        this.x = Math.trunc(this.x);
        this.y = Math.trunc(this.y);
        return this;
    }
    negate() {
        this.x = -this.x;
        this.y = -this.y;
        return this;
    }
    dot(v) {
        return this.x * v.x + this.y * v.y;
    }
    cross(v) {
        return this.x * v.y - this.y * v.x;
    }
    lengthSq() {
        return this.x * this.x + this.y * this.y;
    }
    length() {
        return Math.sqrt(this.x * this.x + this.y * this.y);
    }
    manhattanLength() {
        return Math.abs(this.x) + Math.abs(this.y);
    }
    normalize() {
        return this.divideScalar(this.length() || 1);
    }
    angle() {
        // computes the angle in radians with respect to the positive x-axis
        const angle = Math.atan2(-this.y, -this.x) + Math.PI;
        return angle;
    }
    angleTo(v) {
        const denominator = Math.sqrt(this.lengthSq() * v.lengthSq());
        if (denominator === 0) return Math.PI / 2;
        const theta = this.dot(v) / denominator;
        // clamp, to handle numerical problems
        return Math.acos($d5b33d7c30034067$var$clamp(theta, -1, 1));
    }
    distanceTo(v) {
        return Math.sqrt(this.distanceToSquared(v));
    }
    distanceToSquared(v) {
        const dx = this.x - v.x, dy = this.y - v.y;
        return dx * dx + dy * dy;
    }
    manhattanDistanceTo(v) {
        return Math.abs(this.x - v.x) + Math.abs(this.y - v.y);
    }
    setLength(length) {
        return this.normalize().multiplyScalar(length);
    }
    lerp(v, alpha) {
        this.x += (v.x - this.x) * alpha;
        this.y += (v.y - this.y) * alpha;
        return this;
    }
    lerpVectors(v1, v2, alpha) {
        this.x = v1.x + (v2.x - v1.x) * alpha;
        this.y = v1.y + (v2.y - v1.y) * alpha;
        return this;
    }
    equals(v) {
        return v.x === this.x && v.y === this.y;
    }
    fromArray(array, offset = 0) {
        this.x = array[offset];
        this.y = array[offset + 1];
        return this;
    }
    toArray(array = [], offset = 0) {
        array[offset] = this.x;
        array[offset + 1] = this.y;
        return array;
    }
    fromBufferAttribute(attribute, index) {
        this.x = attribute.getX(index);
        this.y = attribute.getY(index);
        return this;
    }
    rotateAround(center, angle) {
        const c = Math.cos(angle), s = Math.sin(angle);
        const x = this.x - center.x;
        const y = this.y - center.y;
        this.x = x * c - y * s + center.x;
        this.y = x * s + y * c + center.y;
        return this;
    }
    random() {
        this.x = Math.random();
        this.y = Math.random();
        return this;
    }
    *[Symbol.iterator]() {
        yield this.x;
        yield this.y;
    }
}
class $d5b33d7c30034067$export$8ff26dafa08918 {
    constructor(n11, n12, n13, n21, n22, n23, n31, n32, n33){
        $d5b33d7c30034067$export$8ff26dafa08918.prototype.isMatrix3 = true;
        this.elements = [
            1,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            1
        ];
        if (n11 !== undefined) this.set(n11, n12, n13, n21, n22, n23, n31, n32, n33);
    }
    set(n11, n12, n13, n21, n22, n23, n31, n32, n33) {
        const te = this.elements;
        te[0] = n11;
        te[1] = n21;
        te[2] = n31;
        te[3] = n12;
        te[4] = n22;
        te[5] = n32;
        te[6] = n13;
        te[7] = n23;
        te[8] = n33;
        return this;
    }
    identity() {
        this.set(1, 0, 0, 0, 1, 0, 0, 0, 1);
        return this;
    }
    copy(m) {
        const te = this.elements;
        const me = m.elements;
        te[0] = me[0];
        te[1] = me[1];
        te[2] = me[2];
        te[3] = me[3];
        te[4] = me[4];
        te[5] = me[5];
        te[6] = me[6];
        te[7] = me[7];
        te[8] = me[8];
        return this;
    }
    extractBasis(xAxis, yAxis, zAxis) {
        xAxis.setFromMatrix3Column(this, 0);
        yAxis.setFromMatrix3Column(this, 1);
        zAxis.setFromMatrix3Column(this, 2);
        return this;
    }
    setFromMatrix4(m) {
        const me = m.elements;
        this.set(me[0], me[4], me[8], me[1], me[5], me[9], me[2], me[6], me[10]);
        return this;
    }
    multiply(m) {
        return this.multiplyMatrices(this, m);
    }
    premultiply(m) {
        return this.multiplyMatrices(m, this);
    }
    multiplyMatrices(a, b) {
        const ae = a.elements;
        const be = b.elements;
        const te = this.elements;
        const a11 = ae[0], a12 = ae[3], a13 = ae[6];
        const a21 = ae[1], a22 = ae[4], a23 = ae[7];
        const a31 = ae[2], a32 = ae[5], a33 = ae[8];
        const b11 = be[0], b12 = be[3], b13 = be[6];
        const b21 = be[1], b22 = be[4], b23 = be[7];
        const b31 = be[2], b32 = be[5], b33 = be[8];
        te[0] = a11 * b11 + a12 * b21 + a13 * b31;
        te[3] = a11 * b12 + a12 * b22 + a13 * b32;
        te[6] = a11 * b13 + a12 * b23 + a13 * b33;
        te[1] = a21 * b11 + a22 * b21 + a23 * b31;
        te[4] = a21 * b12 + a22 * b22 + a23 * b32;
        te[7] = a21 * b13 + a22 * b23 + a23 * b33;
        te[2] = a31 * b11 + a32 * b21 + a33 * b31;
        te[5] = a31 * b12 + a32 * b22 + a33 * b32;
        te[8] = a31 * b13 + a32 * b23 + a33 * b33;
        return this;
    }
    multiplyScalar(s) {
        const te = this.elements;
        te[0] *= s;
        te[3] *= s;
        te[6] *= s;
        te[1] *= s;
        te[4] *= s;
        te[7] *= s;
        te[2] *= s;
        te[5] *= s;
        te[8] *= s;
        return this;
    }
    determinant() {
        const te = this.elements;
        const a = te[0], b = te[1], c = te[2], d = te[3], e = te[4], f = te[5], g = te[6], h = te[7], i = te[8];
        return a * e * i - a * f * h - b * d * i + b * f * g + c * d * h - c * e * g;
    }
    invert() {
        const te = this.elements, n11 = te[0], n21 = te[1], n31 = te[2], n12 = te[3], n22 = te[4], n32 = te[5], n13 = te[6], n23 = te[7], n33 = te[8], t11 = n33 * n22 - n32 * n23, t12 = n32 * n13 - n33 * n12, t13 = n23 * n12 - n22 * n13, det = n11 * t11 + n21 * t12 + n31 * t13;
        if (det === 0) return this.set(0, 0, 0, 0, 0, 0, 0, 0, 0);
        const detInv = 1 / det;
        te[0] = t11 * detInv;
        te[1] = (n31 * n23 - n33 * n21) * detInv;
        te[2] = (n32 * n21 - n31 * n22) * detInv;
        te[3] = t12 * detInv;
        te[4] = (n33 * n11 - n31 * n13) * detInv;
        te[5] = (n31 * n12 - n32 * n11) * detInv;
        te[6] = t13 * detInv;
        te[7] = (n21 * n13 - n23 * n11) * detInv;
        te[8] = (n22 * n11 - n21 * n12) * detInv;
        return this;
    }
    transpose() {
        let tmp;
        const m = this.elements;
        tmp = m[1];
        m[1] = m[3];
        m[3] = tmp;
        tmp = m[2];
        m[2] = m[6];
        m[6] = tmp;
        tmp = m[5];
        m[5] = m[7];
        m[7] = tmp;
        return this;
    }
    getNormalMatrix(matrix4) {
        return this.setFromMatrix4(matrix4).invert().transpose();
    }
    transposeIntoArray(r) {
        const m = this.elements;
        r[0] = m[0];
        r[1] = m[3];
        r[2] = m[6];
        r[3] = m[1];
        r[4] = m[4];
        r[5] = m[7];
        r[6] = m[2];
        r[7] = m[5];
        r[8] = m[8];
        return this;
    }
    setUvTransform(tx, ty, sx, sy, rotation, cx, cy) {
        const c = Math.cos(rotation);
        const s = Math.sin(rotation);
        this.set(sx * c, sx * s, -sx * (c * cx + s * cy) + cx + tx, -sy * s, sy * c, -sy * (-s * cx + c * cy) + cy + ty, 0, 0, 1);
        return this;
    }
    //
    scale(sx, sy) {
        this.premultiply($d5b33d7c30034067$var$_m3.makeScale(sx, sy));
        return this;
    }
    rotate(theta) {
        this.premultiply($d5b33d7c30034067$var$_m3.makeRotation(-theta));
        return this;
    }
    translate(tx, ty) {
        this.premultiply($d5b33d7c30034067$var$_m3.makeTranslation(tx, ty));
        return this;
    }
    // for 2D Transforms
    makeTranslation(x, y) {
        if (x.isVector2) this.set(1, 0, x.x, 0, 1, x.y, 0, 0, 1);
        else this.set(1, 0, x, 0, 1, y, 0, 0, 1);
        return this;
    }
    makeRotation(theta) {
        // counterclockwise
        const c = Math.cos(theta);
        const s = Math.sin(theta);
        this.set(c, -s, 0, s, c, 0, 0, 0, 1);
        return this;
    }
    makeScale(x, y) {
        this.set(x, 0, 0, 0, y, 0, 0, 0, 1);
        return this;
    }
    //
    equals(matrix) {
        const te = this.elements;
        const me = matrix.elements;
        for(let i = 0; i < 9; i++){
            if (te[i] !== me[i]) return false;
        }
        return true;
    }
    fromArray(array, offset = 0) {
        for(let i = 0; i < 9; i++)this.elements[i] = array[i + offset];
        return this;
    }
    toArray(array = [], offset = 0) {
        const te = this.elements;
        array[offset] = te[0];
        array[offset + 1] = te[1];
        array[offset + 2] = te[2];
        array[offset + 3] = te[3];
        array[offset + 4] = te[4];
        array[offset + 5] = te[5];
        array[offset + 6] = te[6];
        array[offset + 7] = te[7];
        array[offset + 8] = te[8];
        return array;
    }
    clone() {
        return new this.constructor().fromArray(this.elements);
    }
}
const $d5b33d7c30034067$var$_m3 = /*@__PURE__*/ new $d5b33d7c30034067$export$8ff26dafa08918();
function $d5b33d7c30034067$var$arrayNeedsUint32(array) {
    // assumes larger values usually on last
    for(let i = array.length - 1; i >= 0; --i){
        if (array[i] >= 65535) return true; // account for PRIMITIVE_RESTART_FIXED_INDEX, #24565
    }
    return false;
}
const $d5b33d7c30034067$var$TYPED_ARRAYS = {
    Int8Array: Int8Array,
    Uint8Array: Uint8Array,
    Uint8ClampedArray: Uint8ClampedArray,
    Int16Array: Int16Array,
    Uint16Array: Uint16Array,
    Int32Array: Int32Array,
    Uint32Array: Uint32Array,
    Float32Array: Float32Array,
    Float64Array: Float64Array
};
function $d5b33d7c30034067$var$getTypedArray(type, buffer) {
    return new $d5b33d7c30034067$var$TYPED_ARRAYS[type](buffer);
}
function $d5b33d7c30034067$var$createElementNS(name) {
    return document.createElementNS('http://www.w3.org/1999/xhtml', name);
}
function $d5b33d7c30034067$export$1033a2df66368859() {
    const canvas = $d5b33d7c30034067$var$createElementNS('canvas');
    canvas.style.display = 'block';
    return canvas;
}
const $d5b33d7c30034067$var$_cache = {};
function $d5b33d7c30034067$var$warnOnce(message) {
    if (message in $d5b33d7c30034067$var$_cache) return;
    $d5b33d7c30034067$var$_cache[message] = true;
    console.warn(message);
}
function $d5b33d7c30034067$var$probeAsync(gl, sync, interval) {
    return new Promise(function(resolve, reject) {
        function probe() {
            switch(gl.clientWaitSync(sync, gl.SYNC_FLUSH_COMMANDS_BIT, 0)){
                case gl.WAIT_FAILED:
                    reject();
                    break;
                case gl.TIMEOUT_EXPIRED:
                    setTimeout(probe, interval);
                    break;
                default:
                    resolve();
            }
        }
        setTimeout(probe, interval);
    });
}
function $d5b33d7c30034067$var$toNormalizedProjectionMatrix(projectionMatrix) {
    const m = projectionMatrix.elements;
    // Convert [-1, 1] to [0, 1] projection matrix
    m[2] = 0.5 * m[2] + 0.5 * m[3];
    m[6] = 0.5 * m[6] + 0.5 * m[7];
    m[10] = 0.5 * m[10] + 0.5 * m[11];
    m[14] = 0.5 * m[14] + 0.5 * m[15];
}
function $d5b33d7c30034067$var$toReversedProjectionMatrix(projectionMatrix) {
    const m = projectionMatrix.elements;
    const isPerspectiveMatrix = m[11] === -1;
    // Reverse [0, 1] projection matrix
    if (isPerspectiveMatrix) {
        m[10] = -m[10] - 1;
        m[14] = -m[14];
    } else {
        m[10] = -m[10];
        m[14] = -m[14] + 1;
    }
}
const $d5b33d7c30034067$export$5e6fd513f44698c = {
    enabled: true,
    workingColorSpace: $d5b33d7c30034067$export$42429b3acfb233a4,
    /**
	 * Implementations of supported color spaces.
	 *
	 * Required:
	 *	- primaries: chromaticity coordinates [ rx ry gx gy bx by ]
	 *	- whitePoint: reference white [ x y ]
	 *	- transfer: transfer function (pre-defined)
	 *	- toXYZ: Matrix3 RGB to XYZ transform
	 *	- fromXYZ: Matrix3 XYZ to RGB transform
	 *	- luminanceCoefficients: RGB luminance coefficients
	 *
	 * Optional:
	 *  - outputColorSpaceConfig: { drawingBufferColorSpace: ColorSpace }
	 *  - workingColorSpaceConfig: { unpackColorSpace: ColorSpace }
	 *
	 * Reference:
	 * - https://www.russellcottrell.com/photo/matrixCalculator.htm
	 */ spaces: {},
    convert: function(color, sourceColorSpace, targetColorSpace) {
        if (this.enabled === false || sourceColorSpace === targetColorSpace || !sourceColorSpace || !targetColorSpace) return color;
        if (this.spaces[sourceColorSpace].transfer === $d5b33d7c30034067$export$8d0a61916cc26abb) {
            color.r = $d5b33d7c30034067$var$SRGBToLinear(color.r);
            color.g = $d5b33d7c30034067$var$SRGBToLinear(color.g);
            color.b = $d5b33d7c30034067$var$SRGBToLinear(color.b);
        }
        if (this.spaces[sourceColorSpace].primaries !== this.spaces[targetColorSpace].primaries) {
            color.applyMatrix3(this.spaces[sourceColorSpace].toXYZ);
            color.applyMatrix3(this.spaces[targetColorSpace].fromXYZ);
        }
        if (this.spaces[targetColorSpace].transfer === $d5b33d7c30034067$export$8d0a61916cc26abb) {
            color.r = $d5b33d7c30034067$var$LinearToSRGB(color.r);
            color.g = $d5b33d7c30034067$var$LinearToSRGB(color.g);
            color.b = $d5b33d7c30034067$var$LinearToSRGB(color.b);
        }
        return color;
    },
    fromWorkingColorSpace: function(color, targetColorSpace) {
        return this.convert(color, this.workingColorSpace, targetColorSpace);
    },
    toWorkingColorSpace: function(color, sourceColorSpace) {
        return this.convert(color, sourceColorSpace, this.workingColorSpace);
    },
    getPrimaries: function(colorSpace) {
        return this.spaces[colorSpace].primaries;
    },
    getTransfer: function(colorSpace) {
        if (colorSpace === $d5b33d7c30034067$export$bfcb490c2dd3db51) return $d5b33d7c30034067$export$f197347d588c1b4a;
        return this.spaces[colorSpace].transfer;
    },
    getLuminanceCoefficients: function(target, colorSpace = this.workingColorSpace) {
        return target.fromArray(this.spaces[colorSpace].luminanceCoefficients);
    },
    define: function(colorSpaces) {
        Object.assign(this.spaces, colorSpaces);
    },
    // Internal APIs
    _getMatrix: function(targetMatrix, sourceColorSpace, targetColorSpace) {
        return targetMatrix.copy(this.spaces[sourceColorSpace].toXYZ).multiply(this.spaces[targetColorSpace].fromXYZ);
    },
    _getDrawingBufferColorSpace: function(colorSpace) {
        return this.spaces[colorSpace].outputColorSpaceConfig.drawingBufferColorSpace;
    },
    _getUnpackColorSpace: function(colorSpace = this.workingColorSpace) {
        return this.spaces[colorSpace].workingColorSpaceConfig.unpackColorSpace;
    }
};
function $d5b33d7c30034067$var$SRGBToLinear(c) {
    return c < 0.04045 ? c * 0.0773993808 : Math.pow(c * 0.9478672986 + 0.0521327014, 2.4);
}
function $d5b33d7c30034067$var$LinearToSRGB(c) {
    return c < 0.0031308 ? c * 12.92 : 1.055 * Math.pow(c, 0.41666) - 0.055;
}
/******************************************************************************
 * sRGB definitions
 */ const $d5b33d7c30034067$var$REC709_PRIMARIES = [
    0.640,
    0.330,
    0.300,
    0.600,
    0.150,
    0.060
];
const $d5b33d7c30034067$var$REC709_LUMINANCE_COEFFICIENTS = [
    0.2126,
    0.7152,
    0.0722
];
const $d5b33d7c30034067$var$D65 = [
    0.3127,
    0.3290
];
const $d5b33d7c30034067$var$LINEAR_REC709_TO_XYZ = /*@__PURE__*/ new $d5b33d7c30034067$export$8ff26dafa08918().set(0.4123908, 0.3575843, 0.1804808, 0.2126390, 0.7151687, 0.0721923, 0.0193308, 0.1191948, 0.9505322);
const $d5b33d7c30034067$var$XYZ_TO_LINEAR_REC709 = /*@__PURE__*/ new $d5b33d7c30034067$export$8ff26dafa08918().set(3.2409699, -1.5373832, -0.4986108, -0.9692436, 1.8759675, 0.0415551, 0.0556301, -0.203977, 1.0569715);
$d5b33d7c30034067$export$5e6fd513f44698c.define({
    [$d5b33d7c30034067$export$42429b3acfb233a4]: {
        primaries: $d5b33d7c30034067$var$REC709_PRIMARIES,
        whitePoint: $d5b33d7c30034067$var$D65,
        transfer: $d5b33d7c30034067$export$f197347d588c1b4a,
        toXYZ: $d5b33d7c30034067$var$LINEAR_REC709_TO_XYZ,
        fromXYZ: $d5b33d7c30034067$var$XYZ_TO_LINEAR_REC709,
        luminanceCoefficients: $d5b33d7c30034067$var$REC709_LUMINANCE_COEFFICIENTS,
        workingColorSpaceConfig: {
            unpackColorSpace: $d5b33d7c30034067$export$561f394b24edfcaa
        },
        outputColorSpaceConfig: {
            drawingBufferColorSpace: $d5b33d7c30034067$export$561f394b24edfcaa
        }
    },
    [$d5b33d7c30034067$export$561f394b24edfcaa]: {
        primaries: $d5b33d7c30034067$var$REC709_PRIMARIES,
        whitePoint: $d5b33d7c30034067$var$D65,
        transfer: $d5b33d7c30034067$export$8d0a61916cc26abb,
        toXYZ: $d5b33d7c30034067$var$LINEAR_REC709_TO_XYZ,
        fromXYZ: $d5b33d7c30034067$var$XYZ_TO_LINEAR_REC709,
        luminanceCoefficients: $d5b33d7c30034067$var$REC709_LUMINANCE_COEFFICIENTS,
        outputColorSpaceConfig: {
            drawingBufferColorSpace: $d5b33d7c30034067$export$561f394b24edfcaa
        }
    }
});
let $d5b33d7c30034067$var$_canvas;
class $d5b33d7c30034067$export$698882cf06df44aa {
    static getDataURL(image) {
        if (/^data:/i.test(image.src)) return image.src;
        if (typeof HTMLCanvasElement === 'undefined') return image.src;
        let canvas;
        if (image instanceof HTMLCanvasElement) canvas = image;
        else {
            if ($d5b33d7c30034067$var$_canvas === undefined) $d5b33d7c30034067$var$_canvas = $d5b33d7c30034067$var$createElementNS('canvas');
            $d5b33d7c30034067$var$_canvas.width = image.width;
            $d5b33d7c30034067$var$_canvas.height = image.height;
            const context = $d5b33d7c30034067$var$_canvas.getContext('2d');
            if (image instanceof ImageData) context.putImageData(image, 0, 0);
            else context.drawImage(image, 0, 0, image.width, image.height);
            canvas = $d5b33d7c30034067$var$_canvas;
        }
        if (canvas.width > 2048 || canvas.height > 2048) {
            console.warn('THREE.ImageUtils.getDataURL: Image converted to jpg for performance reasons', image);
            return canvas.toDataURL('image/jpeg', 0.6);
        } else return canvas.toDataURL('image/png');
    }
    static sRGBToLinear(image) {
        if (typeof HTMLImageElement !== 'undefined' && image instanceof HTMLImageElement || typeof HTMLCanvasElement !== 'undefined' && image instanceof HTMLCanvasElement || typeof ImageBitmap !== 'undefined' && image instanceof ImageBitmap) {
            const canvas = $d5b33d7c30034067$var$createElementNS('canvas');
            canvas.width = image.width;
            canvas.height = image.height;
            const context = canvas.getContext('2d');
            context.drawImage(image, 0, 0, image.width, image.height);
            const imageData = context.getImageData(0, 0, image.width, image.height);
            const data = imageData.data;
            for(let i = 0; i < data.length; i++)data[i] = $d5b33d7c30034067$var$SRGBToLinear(data[i] / 255) * 255;
            context.putImageData(imageData, 0, 0);
            return canvas;
        } else if (image.data) {
            const data = image.data.slice(0);
            for(let i = 0; i < data.length; i++)if (data instanceof Uint8Array || data instanceof Uint8ClampedArray) data[i] = Math.floor($d5b33d7c30034067$var$SRGBToLinear(data[i] / 255) * 255);
            else // assuming float
            data[i] = $d5b33d7c30034067$var$SRGBToLinear(data[i]);
            return {
                data: data,
                width: image.width,
                height: image.height
            };
        } else {
            console.warn('THREE.ImageUtils.sRGBToLinear(): Unsupported image type. No color space conversion applied.');
            return image;
        }
    }
}
let $d5b33d7c30034067$var$_sourceId = 0;
class $d5b33d7c30034067$export$1d2df86270c81ecb {
    constructor(data = null){
        this.isSource = true;
        Object.defineProperty(this, 'id', {
            value: $d5b33d7c30034067$var$_sourceId++
        });
        this.uuid = $d5b33d7c30034067$var$generateUUID();
        this.data = data;
        this.dataReady = true;
        this.version = 0;
    }
    set needsUpdate(value) {
        if (value === true) this.version++;
    }
    toJSON(meta) {
        const isRootObject = meta === undefined || typeof meta === 'string';
        if (!isRootObject && meta.images[this.uuid] !== undefined) return meta.images[this.uuid];
        const output = {
            uuid: this.uuid,
            url: ''
        };
        const data = this.data;
        if (data !== null) {
            let url;
            if (Array.isArray(data)) {
                // cube texture
                url = [];
                for(let i = 0, l = data.length; i < l; i++)if (data[i].isDataTexture) url.push($d5b33d7c30034067$var$serializeImage(data[i].image));
                else url.push($d5b33d7c30034067$var$serializeImage(data[i]));
            } else // texture
            url = $d5b33d7c30034067$var$serializeImage(data);
            output.url = url;
        }
        if (!isRootObject) meta.images[this.uuid] = output;
        return output;
    }
}
function $d5b33d7c30034067$var$serializeImage(image) {
    if (typeof HTMLImageElement !== 'undefined' && image instanceof HTMLImageElement || typeof HTMLCanvasElement !== 'undefined' && image instanceof HTMLCanvasElement || typeof ImageBitmap !== 'undefined' && image instanceof ImageBitmap) // default images
    return $d5b33d7c30034067$export$698882cf06df44aa.getDataURL(image);
    else {
        if (image.data) // images of DataTexture
        return {
            data: Array.from(image.data),
            width: image.width,
            height: image.height,
            type: image.data.constructor.name
        };
        else {
            console.warn('THREE.Texture: Unable to serialize Texture.');
            return {};
        }
    }
}
let $d5b33d7c30034067$var$_textureId = 0;
class $d5b33d7c30034067$export$5431306cf43de24a extends $d5b33d7c30034067$export$ec8b666c5fe2c75a {
    constructor(image = $d5b33d7c30034067$export$5431306cf43de24a.DEFAULT_IMAGE, mapping = $d5b33d7c30034067$export$5431306cf43de24a.DEFAULT_MAPPING, wrapS = $d5b33d7c30034067$export$9d9334239a5a5e06, wrapT = $d5b33d7c30034067$export$9d9334239a5a5e06, magFilter = $d5b33d7c30034067$export$8a72f490b25c56c8, minFilter = $d5b33d7c30034067$export$5d8599b6a933fb1b, format = $d5b33d7c30034067$export$3f8bb04b555a363c, type = $d5b33d7c30034067$export$2e8ce08d3f6f5e10, anisotropy = $d5b33d7c30034067$export$5431306cf43de24a.DEFAULT_ANISOTROPY, colorSpace = $d5b33d7c30034067$export$bfcb490c2dd3db51){
        super();
        this.isTexture = true;
        Object.defineProperty(this, 'id', {
            value: $d5b33d7c30034067$var$_textureId++
        });
        this.uuid = $d5b33d7c30034067$var$generateUUID();
        this.name = '';
        this.source = new $d5b33d7c30034067$export$1d2df86270c81ecb(image);
        this.mipmaps = [];
        this.mapping = mapping;
        this.channel = 0;
        this.wrapS = wrapS;
        this.wrapT = wrapT;
        this.magFilter = magFilter;
        this.minFilter = minFilter;
        this.anisotropy = anisotropy;
        this.format = format;
        this.internalFormat = null;
        this.type = type;
        this.offset = new $d5b33d7c30034067$export$c977b3e384af9ae1(0, 0);
        this.repeat = new $d5b33d7c30034067$export$c977b3e384af9ae1(1, 1);
        this.center = new $d5b33d7c30034067$export$c977b3e384af9ae1(0, 0);
        this.rotation = 0;
        this.matrixAutoUpdate = true;
        this.matrix = new $d5b33d7c30034067$export$8ff26dafa08918();
        this.generateMipmaps = true;
        this.premultiplyAlpha = false;
        this.flipY = true;
        this.unpackAlignment = 4; // valid values: 1, 2, 4, 8 (see http://www.khronos.org/opengles/sdk/docs/man/xhtml/glPixelStorei.xml)
        this.colorSpace = colorSpace;
        this.userData = {};
        this.version = 0;
        this.onUpdate = null;
        this.isRenderTargetTexture = false; // indicates whether a texture belongs to a render target or not
        this.pmremVersion = 0; // indicates whether this texture should be processed by PMREMGenerator or not (only relevant for render target textures)
    }
    get image() {
        return this.source.data;
    }
    set image(value = null) {
        this.source.data = value;
    }
    updateMatrix() {
        this.matrix.setUvTransform(this.offset.x, this.offset.y, this.repeat.x, this.repeat.y, this.rotation, this.center.x, this.center.y);
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(source) {
        this.name = source.name;
        this.source = source.source;
        this.mipmaps = source.mipmaps.slice(0);
        this.mapping = source.mapping;
        this.channel = source.channel;
        this.wrapS = source.wrapS;
        this.wrapT = source.wrapT;
        this.magFilter = source.magFilter;
        this.minFilter = source.minFilter;
        this.anisotropy = source.anisotropy;
        this.format = source.format;
        this.internalFormat = source.internalFormat;
        this.type = source.type;
        this.offset.copy(source.offset);
        this.repeat.copy(source.repeat);
        this.center.copy(source.center);
        this.rotation = source.rotation;
        this.matrixAutoUpdate = source.matrixAutoUpdate;
        this.matrix.copy(source.matrix);
        this.generateMipmaps = source.generateMipmaps;
        this.premultiplyAlpha = source.premultiplyAlpha;
        this.flipY = source.flipY;
        this.unpackAlignment = source.unpackAlignment;
        this.colorSpace = source.colorSpace;
        this.userData = JSON.parse(JSON.stringify(source.userData));
        this.needsUpdate = true;
        return this;
    }
    toJSON(meta) {
        const isRootObject = meta === undefined || typeof meta === 'string';
        if (!isRootObject && meta.textures[this.uuid] !== undefined) return meta.textures[this.uuid];
        const output = {
            metadata: {
                version: 4.6,
                type: 'Texture',
                generator: 'Texture.toJSON'
            },
            uuid: this.uuid,
            name: this.name,
            image: this.source.toJSON(meta).uuid,
            mapping: this.mapping,
            channel: this.channel,
            repeat: [
                this.repeat.x,
                this.repeat.y
            ],
            offset: [
                this.offset.x,
                this.offset.y
            ],
            center: [
                this.center.x,
                this.center.y
            ],
            rotation: this.rotation,
            wrap: [
                this.wrapS,
                this.wrapT
            ],
            format: this.format,
            internalFormat: this.internalFormat,
            type: this.type,
            colorSpace: this.colorSpace,
            minFilter: this.minFilter,
            magFilter: this.magFilter,
            anisotropy: this.anisotropy,
            flipY: this.flipY,
            generateMipmaps: this.generateMipmaps,
            premultiplyAlpha: this.premultiplyAlpha,
            unpackAlignment: this.unpackAlignment
        };
        if (Object.keys(this.userData).length > 0) output.userData = this.userData;
        if (!isRootObject) meta.textures[this.uuid] = output;
        return output;
    }
    dispose() {
        this.dispatchEvent({
            type: 'dispose'
        });
    }
    transformUv(uv) {
        if (this.mapping !== $d5b33d7c30034067$export$1beec6768cbb3d2d) return uv;
        uv.applyMatrix3(this.matrix);
        if (uv.x < 0 || uv.x > 1) switch(this.wrapS){
            case $d5b33d7c30034067$export$533346c8e8dac0f5:
                uv.x = uv.x - Math.floor(uv.x);
                break;
            case $d5b33d7c30034067$export$9d9334239a5a5e06:
                uv.x = uv.x < 0 ? 0 : 1;
                break;
            case $d5b33d7c30034067$export$c7e7c00b14f51a4f:
                if (Math.abs(Math.floor(uv.x) % 2) === 1) uv.x = Math.ceil(uv.x) - uv.x;
                else uv.x = uv.x - Math.floor(uv.x);
                break;
        }
        if (uv.y < 0 || uv.y > 1) switch(this.wrapT){
            case $d5b33d7c30034067$export$533346c8e8dac0f5:
                uv.y = uv.y - Math.floor(uv.y);
                break;
            case $d5b33d7c30034067$export$9d9334239a5a5e06:
                uv.y = uv.y < 0 ? 0 : 1;
                break;
            case $d5b33d7c30034067$export$c7e7c00b14f51a4f:
                if (Math.abs(Math.floor(uv.y) % 2) === 1) uv.y = Math.ceil(uv.y) - uv.y;
                else uv.y = uv.y - Math.floor(uv.y);
                break;
        }
        if (this.flipY) uv.y = 1 - uv.y;
        return uv;
    }
    set needsUpdate(value) {
        if (value === true) {
            this.version++;
            this.source.needsUpdate = true;
        }
    }
    set needsPMREMUpdate(value) {
        if (value === true) this.pmremVersion++;
    }
}
$d5b33d7c30034067$export$5431306cf43de24a.DEFAULT_IMAGE = null;
$d5b33d7c30034067$export$5431306cf43de24a.DEFAULT_MAPPING = $d5b33d7c30034067$export$1beec6768cbb3d2d;
$d5b33d7c30034067$export$5431306cf43de24a.DEFAULT_ANISOTROPY = 1;
class $d5b33d7c30034067$export$fa7daccca11cdbe3 {
    constructor(x = 0, y = 0, z = 0, w = 1){
        $d5b33d7c30034067$export$fa7daccca11cdbe3.prototype.isVector4 = true;
        this.x = x;
        this.y = y;
        this.z = z;
        this.w = w;
    }
    get width() {
        return this.z;
    }
    set width(value) {
        this.z = value;
    }
    get height() {
        return this.w;
    }
    set height(value) {
        this.w = value;
    }
    set(x, y, z, w) {
        this.x = x;
        this.y = y;
        this.z = z;
        this.w = w;
        return this;
    }
    setScalar(scalar) {
        this.x = scalar;
        this.y = scalar;
        this.z = scalar;
        this.w = scalar;
        return this;
    }
    setX(x) {
        this.x = x;
        return this;
    }
    setY(y) {
        this.y = y;
        return this;
    }
    setZ(z) {
        this.z = z;
        return this;
    }
    setW(w) {
        this.w = w;
        return this;
    }
    setComponent(index, value) {
        switch(index){
            case 0:
                this.x = value;
                break;
            case 1:
                this.y = value;
                break;
            case 2:
                this.z = value;
                break;
            case 3:
                this.w = value;
                break;
            default:
                throw new Error('index is out of range: ' + index);
        }
        return this;
    }
    getComponent(index) {
        switch(index){
            case 0:
                return this.x;
            case 1:
                return this.y;
            case 2:
                return this.z;
            case 3:
                return this.w;
            default:
                throw new Error('index is out of range: ' + index);
        }
    }
    clone() {
        return new this.constructor(this.x, this.y, this.z, this.w);
    }
    copy(v) {
        this.x = v.x;
        this.y = v.y;
        this.z = v.z;
        this.w = v.w !== undefined ? v.w : 1;
        return this;
    }
    add(v) {
        this.x += v.x;
        this.y += v.y;
        this.z += v.z;
        this.w += v.w;
        return this;
    }
    addScalar(s) {
        this.x += s;
        this.y += s;
        this.z += s;
        this.w += s;
        return this;
    }
    addVectors(a, b) {
        this.x = a.x + b.x;
        this.y = a.y + b.y;
        this.z = a.z + b.z;
        this.w = a.w + b.w;
        return this;
    }
    addScaledVector(v, s) {
        this.x += v.x * s;
        this.y += v.y * s;
        this.z += v.z * s;
        this.w += v.w * s;
        return this;
    }
    sub(v) {
        this.x -= v.x;
        this.y -= v.y;
        this.z -= v.z;
        this.w -= v.w;
        return this;
    }
    subScalar(s) {
        this.x -= s;
        this.y -= s;
        this.z -= s;
        this.w -= s;
        return this;
    }
    subVectors(a, b) {
        this.x = a.x - b.x;
        this.y = a.y - b.y;
        this.z = a.z - b.z;
        this.w = a.w - b.w;
        return this;
    }
    multiply(v) {
        this.x *= v.x;
        this.y *= v.y;
        this.z *= v.z;
        this.w *= v.w;
        return this;
    }
    multiplyScalar(scalar) {
        this.x *= scalar;
        this.y *= scalar;
        this.z *= scalar;
        this.w *= scalar;
        return this;
    }
    applyMatrix4(m) {
        const x = this.x, y = this.y, z = this.z, w = this.w;
        const e = m.elements;
        this.x = e[0] * x + e[4] * y + e[8] * z + e[12] * w;
        this.y = e[1] * x + e[5] * y + e[9] * z + e[13] * w;
        this.z = e[2] * x + e[6] * y + e[10] * z + e[14] * w;
        this.w = e[3] * x + e[7] * y + e[11] * z + e[15] * w;
        return this;
    }
    divide(v) {
        this.x /= v.x;
        this.y /= v.y;
        this.z /= v.z;
        this.w /= v.w;
        return this;
    }
    divideScalar(scalar) {
        return this.multiplyScalar(1 / scalar);
    }
    setAxisAngleFromQuaternion(q) {
        // http://www.euclideanspace.com/maths/geometry/rotations/conversions/quaternionToAngle/index.htm
        // q is assumed to be normalized
        this.w = 2 * Math.acos(q.w);
        const s = Math.sqrt(1 - q.w * q.w);
        if (s < 0.0001) {
            this.x = 1;
            this.y = 0;
            this.z = 0;
        } else {
            this.x = q.x / s;
            this.y = q.y / s;
            this.z = q.z / s;
        }
        return this;
    }
    setAxisAngleFromRotationMatrix(m) {
        // http://www.euclideanspace.com/maths/geometry/rotations/conversions/matrixToAngle/index.htm
        // assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)
        let angle, x, y, z; // variables for result
        const epsilon = 0.01, epsilon2 = 0.1, te = m.elements, m11 = te[0], m12 = te[4], m13 = te[8], m21 = te[1], m22 = te[5], m23 = te[9], m31 = te[2], m32 = te[6], m33 = te[10];
        if (Math.abs(m12 - m21) < epsilon && Math.abs(m13 - m31) < epsilon && Math.abs(m23 - m32) < epsilon) {
            // singularity found
            // first check for identity matrix which must have +1 for all terms
            // in leading diagonal and zero in other terms
            if (Math.abs(m12 + m21) < epsilon2 && Math.abs(m13 + m31) < epsilon2 && Math.abs(m23 + m32) < epsilon2 && Math.abs(m11 + m22 + m33 - 3) < epsilon2) {
                // this singularity is identity matrix so angle = 0
                this.set(1, 0, 0, 0);
                return this; // zero angle, arbitrary axis
            }
            // otherwise this singularity is angle = 180
            angle = Math.PI;
            const xx = (m11 + 1) / 2;
            const yy = (m22 + 1) / 2;
            const zz = (m33 + 1) / 2;
            const xy = (m12 + m21) / 4;
            const xz = (m13 + m31) / 4;
            const yz = (m23 + m32) / 4;
            if (xx > yy && xx > zz) {
                // m11 is the largest diagonal term
                if (xx < epsilon) {
                    x = 0;
                    y = 0.707106781;
                    z = 0.707106781;
                } else {
                    x = Math.sqrt(xx);
                    y = xy / x;
                    z = xz / x;
                }
            } else if (yy > zz) {
                // m22 is the largest diagonal term
                if (yy < epsilon) {
                    x = 0.707106781;
                    y = 0;
                    z = 0.707106781;
                } else {
                    y = Math.sqrt(yy);
                    x = xy / y;
                    z = yz / y;
                }
            } else // m33 is the largest diagonal term so base result on this
            if (zz < epsilon) {
                x = 0.707106781;
                y = 0.707106781;
                z = 0;
            } else {
                z = Math.sqrt(zz);
                x = xz / z;
                y = yz / z;
            }
            this.set(x, y, z, angle);
            return this; // return 180 deg rotation
        }
        // as we have reached here there are no singularities so we can handle normally
        let s = Math.sqrt((m32 - m23) * (m32 - m23) + (m13 - m31) * (m13 - m31) + (m21 - m12) * (m21 - m12)); // used to normalize
        if (Math.abs(s) < 0.001) s = 1;
        // prevent divide by zero, should not happen if matrix is orthogonal and should be
        // caught by singularity test above, but I've left it in just in case
        this.x = (m32 - m23) / s;
        this.y = (m13 - m31) / s;
        this.z = (m21 - m12) / s;
        this.w = Math.acos((m11 + m22 + m33 - 1) / 2);
        return this;
    }
    setFromMatrixPosition(m) {
        const e = m.elements;
        this.x = e[12];
        this.y = e[13];
        this.z = e[14];
        this.w = e[15];
        return this;
    }
    min(v) {
        this.x = Math.min(this.x, v.x);
        this.y = Math.min(this.y, v.y);
        this.z = Math.min(this.z, v.z);
        this.w = Math.min(this.w, v.w);
        return this;
    }
    max(v) {
        this.x = Math.max(this.x, v.x);
        this.y = Math.max(this.y, v.y);
        this.z = Math.max(this.z, v.z);
        this.w = Math.max(this.w, v.w);
        return this;
    }
    clamp(min, max) {
        // assumes min < max, componentwise
        this.x = Math.max(min.x, Math.min(max.x, this.x));
        this.y = Math.max(min.y, Math.min(max.y, this.y));
        this.z = Math.max(min.z, Math.min(max.z, this.z));
        this.w = Math.max(min.w, Math.min(max.w, this.w));
        return this;
    }
    clampScalar(minVal, maxVal) {
        this.x = Math.max(minVal, Math.min(maxVal, this.x));
        this.y = Math.max(minVal, Math.min(maxVal, this.y));
        this.z = Math.max(minVal, Math.min(maxVal, this.z));
        this.w = Math.max(minVal, Math.min(maxVal, this.w));
        return this;
    }
    clampLength(min, max) {
        const length = this.length();
        return this.divideScalar(length || 1).multiplyScalar(Math.max(min, Math.min(max, length)));
    }
    floor() {
        this.x = Math.floor(this.x);
        this.y = Math.floor(this.y);
        this.z = Math.floor(this.z);
        this.w = Math.floor(this.w);
        return this;
    }
    ceil() {
        this.x = Math.ceil(this.x);
        this.y = Math.ceil(this.y);
        this.z = Math.ceil(this.z);
        this.w = Math.ceil(this.w);
        return this;
    }
    round() {
        this.x = Math.round(this.x);
        this.y = Math.round(this.y);
        this.z = Math.round(this.z);
        this.w = Math.round(this.w);
        return this;
    }
    roundToZero() {
        this.x = Math.trunc(this.x);
        this.y = Math.trunc(this.y);
        this.z = Math.trunc(this.z);
        this.w = Math.trunc(this.w);
        return this;
    }
    negate() {
        this.x = -this.x;
        this.y = -this.y;
        this.z = -this.z;
        this.w = -this.w;
        return this;
    }
    dot(v) {
        return this.x * v.x + this.y * v.y + this.z * v.z + this.w * v.w;
    }
    lengthSq() {
        return this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w;
    }
    length() {
        return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w);
    }
    manhattanLength() {
        return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z) + Math.abs(this.w);
    }
    normalize() {
        return this.divideScalar(this.length() || 1);
    }
    setLength(length) {
        return this.normalize().multiplyScalar(length);
    }
    lerp(v, alpha) {
        this.x += (v.x - this.x) * alpha;
        this.y += (v.y - this.y) * alpha;
        this.z += (v.z - this.z) * alpha;
        this.w += (v.w - this.w) * alpha;
        return this;
    }
    lerpVectors(v1, v2, alpha) {
        this.x = v1.x + (v2.x - v1.x) * alpha;
        this.y = v1.y + (v2.y - v1.y) * alpha;
        this.z = v1.z + (v2.z - v1.z) * alpha;
        this.w = v1.w + (v2.w - v1.w) * alpha;
        return this;
    }
    equals(v) {
        return v.x === this.x && v.y === this.y && v.z === this.z && v.w === this.w;
    }
    fromArray(array, offset = 0) {
        this.x = array[offset];
        this.y = array[offset + 1];
        this.z = array[offset + 2];
        this.w = array[offset + 3];
        return this;
    }
    toArray(array = [], offset = 0) {
        array[offset] = this.x;
        array[offset + 1] = this.y;
        array[offset + 2] = this.z;
        array[offset + 3] = this.w;
        return array;
    }
    fromBufferAttribute(attribute, index) {
        this.x = attribute.getX(index);
        this.y = attribute.getY(index);
        this.z = attribute.getZ(index);
        this.w = attribute.getW(index);
        return this;
    }
    random() {
        this.x = Math.random();
        this.y = Math.random();
        this.z = Math.random();
        this.w = Math.random();
        return this;
    }
    *[Symbol.iterator]() {
        yield this.x;
        yield this.y;
        yield this.z;
        yield this.w;
    }
}
/*
 In options, we can specify:
 * Texture parameters for an auto-generated target texture
 * depthBuffer/stencilBuffer: Booleans to indicate if we should generate these buffers
*/ class $d5b33d7c30034067$export$efcb1f8bf367cbfb extends $d5b33d7c30034067$export$ec8b666c5fe2c75a {
    constructor(width = 1, height = 1, options = {}){
        super();
        this.isRenderTarget = true;
        this.width = width;
        this.height = height;
        this.depth = 1;
        this.scissor = new $d5b33d7c30034067$export$fa7daccca11cdbe3(0, 0, width, height);
        this.scissorTest = false;
        this.viewport = new $d5b33d7c30034067$export$fa7daccca11cdbe3(0, 0, width, height);
        const image = {
            width: width,
            height: height,
            depth: 1
        };
        options = Object.assign({
            generateMipmaps: false,
            internalFormat: null,
            minFilter: $d5b33d7c30034067$export$8a72f490b25c56c8,
            depthBuffer: true,
            stencilBuffer: false,
            resolveDepthBuffer: true,
            resolveStencilBuffer: true,
            depthTexture: null,
            samples: 0,
            count: 1
        }, options);
        const texture = new $d5b33d7c30034067$export$5431306cf43de24a(image, options.mapping, options.wrapS, options.wrapT, options.magFilter, options.minFilter, options.format, options.type, options.anisotropy, options.colorSpace);
        texture.flipY = false;
        texture.generateMipmaps = options.generateMipmaps;
        texture.internalFormat = options.internalFormat;
        this.textures = [];
        const count = options.count;
        for(let i = 0; i < count; i++){
            this.textures[i] = texture.clone();
            this.textures[i].isRenderTargetTexture = true;
        }
        this.depthBuffer = options.depthBuffer;
        this.stencilBuffer = options.stencilBuffer;
        this.resolveDepthBuffer = options.resolveDepthBuffer;
        this.resolveStencilBuffer = options.resolveStencilBuffer;
        this.depthTexture = options.depthTexture;
        this.samples = options.samples;
    }
    get texture() {
        return this.textures[0];
    }
    set texture(value) {
        this.textures[0] = value;
    }
    setSize(width, height, depth = 1) {
        if (this.width !== width || this.height !== height || this.depth !== depth) {
            this.width = width;
            this.height = height;
            this.depth = depth;
            for(let i = 0, il = this.textures.length; i < il; i++){
                this.textures[i].image.width = width;
                this.textures[i].image.height = height;
                this.textures[i].image.depth = depth;
            }
            this.dispose();
        }
        this.viewport.set(0, 0, width, height);
        this.scissor.set(0, 0, width, height);
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(source) {
        this.width = source.width;
        this.height = source.height;
        this.depth = source.depth;
        this.scissor.copy(source.scissor);
        this.scissorTest = source.scissorTest;
        this.viewport.copy(source.viewport);
        this.textures.length = 0;
        for(let i = 0, il = source.textures.length; i < il; i++){
            this.textures[i] = source.textures[i].clone();
            this.textures[i].isRenderTargetTexture = true;
        }
        // ensure image object is not shared, see #20328
        const image = Object.assign({}, source.texture.image);
        this.texture.source = new $d5b33d7c30034067$export$1d2df86270c81ecb(image);
        this.depthBuffer = source.depthBuffer;
        this.stencilBuffer = source.stencilBuffer;
        this.resolveDepthBuffer = source.resolveDepthBuffer;
        this.resolveStencilBuffer = source.resolveStencilBuffer;
        if (source.depthTexture !== null) this.depthTexture = source.depthTexture.clone();
        this.samples = source.samples;
        return this;
    }
    dispose() {
        this.dispatchEvent({
            type: 'dispose'
        });
    }
}
class $d5b33d7c30034067$export$3c052beb2e51e23f extends $d5b33d7c30034067$export$efcb1f8bf367cbfb {
    constructor(width = 1, height = 1, options = {}){
        super(width, height, options);
        this.isWebGLRenderTarget = true;
    }
}
class $d5b33d7c30034067$export$dfac6c8e811406a3 extends $d5b33d7c30034067$export$5431306cf43de24a {
    constructor(data = null, width = 1, height = 1, depth = 1){
        super(null);
        this.isDataArrayTexture = true;
        this.image = {
            data: data,
            width: width,
            height: height,
            depth: depth
        };
        this.magFilter = $d5b33d7c30034067$export$727aa5ec3fe39bf0;
        this.minFilter = $d5b33d7c30034067$export$727aa5ec3fe39bf0;
        this.wrapR = $d5b33d7c30034067$export$9d9334239a5a5e06;
        this.generateMipmaps = false;
        this.flipY = false;
        this.unpackAlignment = 1;
        this.layerUpdates = new Set();
    }
    addLayerUpdate(layerIndex) {
        this.layerUpdates.add(layerIndex);
    }
    clearLayerUpdates() {
        this.layerUpdates.clear();
    }
}
class $d5b33d7c30034067$export$c77a02c11ed180c7 extends $d5b33d7c30034067$export$3c052beb2e51e23f {
    constructor(width = 1, height = 1, depth = 1, options = {}){
        super(width, height, options);
        this.isWebGLArrayRenderTarget = true;
        this.depth = depth;
        this.texture = new $d5b33d7c30034067$export$dfac6c8e811406a3(null, width, height, depth);
        this.texture.isRenderTargetTexture = true;
    }
}
class $d5b33d7c30034067$export$d7a3086320f856db extends $d5b33d7c30034067$export$5431306cf43de24a {
    constructor(data = null, width = 1, height = 1, depth = 1){
        // We're going to add .setXXX() methods for setting properties later.
        // Users can still set in DataTexture3D directly.
        //
        //	const texture = new THREE.DataTexture3D( data, width, height, depth );
        // 	texture.anisotropy = 16;
        //
        // See #14839
        super(null);
        this.isData3DTexture = true;
        this.image = {
            data: data,
            width: width,
            height: height,
            depth: depth
        };
        this.magFilter = $d5b33d7c30034067$export$727aa5ec3fe39bf0;
        this.minFilter = $d5b33d7c30034067$export$727aa5ec3fe39bf0;
        this.wrapR = $d5b33d7c30034067$export$9d9334239a5a5e06;
        this.generateMipmaps = false;
        this.flipY = false;
        this.unpackAlignment = 1;
    }
}
class $d5b33d7c30034067$export$7ee06591009639df extends $d5b33d7c30034067$export$3c052beb2e51e23f {
    constructor(width = 1, height = 1, depth = 1, options = {}){
        super(width, height, options);
        this.isWebGL3DRenderTarget = true;
        this.depth = depth;
        this.texture = new $d5b33d7c30034067$export$d7a3086320f856db(null, width, height, depth);
        this.texture.isRenderTargetTexture = true;
    }
}
class $d5b33d7c30034067$export$23d6a54f0bbc85a3 {
    constructor(x = 0, y = 0, z = 0, w = 1){
        this.isQuaternion = true;
        this._x = x;
        this._y = y;
        this._z = z;
        this._w = w;
    }
    static slerpFlat(dst, dstOffset, src0, srcOffset0, src1, srcOffset1, t) {
        // fuzz-free, array-based Quaternion SLERP operation
        let x0 = src0[srcOffset0 + 0], y0 = src0[srcOffset0 + 1], z0 = src0[srcOffset0 + 2], w0 = src0[srcOffset0 + 3];
        const x1 = src1[srcOffset1 + 0], y1 = src1[srcOffset1 + 1], z1 = src1[srcOffset1 + 2], w1 = src1[srcOffset1 + 3];
        if (t === 0) {
            dst[dstOffset + 0] = x0;
            dst[dstOffset + 1] = y0;
            dst[dstOffset + 2] = z0;
            dst[dstOffset + 3] = w0;
            return;
        }
        if (t === 1) {
            dst[dstOffset + 0] = x1;
            dst[dstOffset + 1] = y1;
            dst[dstOffset + 2] = z1;
            dst[dstOffset + 3] = w1;
            return;
        }
        if (w0 !== w1 || x0 !== x1 || y0 !== y1 || z0 !== z1) {
            let s = 1 - t;
            const cos = x0 * x1 + y0 * y1 + z0 * z1 + w0 * w1, dir = cos >= 0 ? 1 : -1, sqrSin = 1 - cos * cos;
            // Skip the Slerp for tiny steps to avoid numeric problems:
            if (sqrSin > Number.EPSILON) {
                const sin = Math.sqrt(sqrSin), len = Math.atan2(sin, cos * dir);
                s = Math.sin(s * len) / sin;
                t = Math.sin(t * len) / sin;
            }
            const tDir = t * dir;
            x0 = x0 * s + x1 * tDir;
            y0 = y0 * s + y1 * tDir;
            z0 = z0 * s + z1 * tDir;
            w0 = w0 * s + w1 * tDir;
            // Normalize in case we just did a lerp:
            if (s === 1 - t) {
                const f = 1 / Math.sqrt(x0 * x0 + y0 * y0 + z0 * z0 + w0 * w0);
                x0 *= f;
                y0 *= f;
                z0 *= f;
                w0 *= f;
            }
        }
        dst[dstOffset] = x0;
        dst[dstOffset + 1] = y0;
        dst[dstOffset + 2] = z0;
        dst[dstOffset + 3] = w0;
    }
    static multiplyQuaternionsFlat(dst, dstOffset, src0, srcOffset0, src1, srcOffset1) {
        const x0 = src0[srcOffset0];
        const y0 = src0[srcOffset0 + 1];
        const z0 = src0[srcOffset0 + 2];
        const w0 = src0[srcOffset0 + 3];
        const x1 = src1[srcOffset1];
        const y1 = src1[srcOffset1 + 1];
        const z1 = src1[srcOffset1 + 2];
        const w1 = src1[srcOffset1 + 3];
        dst[dstOffset] = x0 * w1 + w0 * x1 + y0 * z1 - z0 * y1;
        dst[dstOffset + 1] = y0 * w1 + w0 * y1 + z0 * x1 - x0 * z1;
        dst[dstOffset + 2] = z0 * w1 + w0 * z1 + x0 * y1 - y0 * x1;
        dst[dstOffset + 3] = w0 * w1 - x0 * x1 - y0 * y1 - z0 * z1;
        return dst;
    }
    get x() {
        return this._x;
    }
    set x(value) {
        this._x = value;
        this._onChangeCallback();
    }
    get y() {
        return this._y;
    }
    set y(value) {
        this._y = value;
        this._onChangeCallback();
    }
    get z() {
        return this._z;
    }
    set z(value) {
        this._z = value;
        this._onChangeCallback();
    }
    get w() {
        return this._w;
    }
    set w(value) {
        this._w = value;
        this._onChangeCallback();
    }
    set(x, y, z, w) {
        this._x = x;
        this._y = y;
        this._z = z;
        this._w = w;
        this._onChangeCallback();
        return this;
    }
    clone() {
        return new this.constructor(this._x, this._y, this._z, this._w);
    }
    copy(quaternion) {
        this._x = quaternion.x;
        this._y = quaternion.y;
        this._z = quaternion.z;
        this._w = quaternion.w;
        this._onChangeCallback();
        return this;
    }
    setFromEuler(euler, update = true) {
        const x = euler._x, y = euler._y, z = euler._z, order = euler._order;
        // http://www.mathworks.com/matlabcentral/fileexchange/
        // 	20696-function-to-convert-between-dcm-euler-angles-quaternions-and-euler-vectors/
        //	content/SpinCalc.m
        const cos = Math.cos;
        const sin = Math.sin;
        const c1 = cos(x / 2);
        const c2 = cos(y / 2);
        const c3 = cos(z / 2);
        const s1 = sin(x / 2);
        const s2 = sin(y / 2);
        const s3 = sin(z / 2);
        switch(order){
            case 'XYZ':
                this._x = s1 * c2 * c3 + c1 * s2 * s3;
                this._y = c1 * s2 * c3 - s1 * c2 * s3;
                this._z = c1 * c2 * s3 + s1 * s2 * c3;
                this._w = c1 * c2 * c3 - s1 * s2 * s3;
                break;
            case 'YXZ':
                this._x = s1 * c2 * c3 + c1 * s2 * s3;
                this._y = c1 * s2 * c3 - s1 * c2 * s3;
                this._z = c1 * c2 * s3 - s1 * s2 * c3;
                this._w = c1 * c2 * c3 + s1 * s2 * s3;
                break;
            case 'ZXY':
                this._x = s1 * c2 * c3 - c1 * s2 * s3;
                this._y = c1 * s2 * c3 + s1 * c2 * s3;
                this._z = c1 * c2 * s3 + s1 * s2 * c3;
                this._w = c1 * c2 * c3 - s1 * s2 * s3;
                break;
            case 'ZYX':
                this._x = s1 * c2 * c3 - c1 * s2 * s3;
                this._y = c1 * s2 * c3 + s1 * c2 * s3;
                this._z = c1 * c2 * s3 - s1 * s2 * c3;
                this._w = c1 * c2 * c3 + s1 * s2 * s3;
                break;
            case 'YZX':
                this._x = s1 * c2 * c3 + c1 * s2 * s3;
                this._y = c1 * s2 * c3 + s1 * c2 * s3;
                this._z = c1 * c2 * s3 - s1 * s2 * c3;
                this._w = c1 * c2 * c3 - s1 * s2 * s3;
                break;
            case 'XZY':
                this._x = s1 * c2 * c3 - c1 * s2 * s3;
                this._y = c1 * s2 * c3 - s1 * c2 * s3;
                this._z = c1 * c2 * s3 + s1 * s2 * c3;
                this._w = c1 * c2 * c3 + s1 * s2 * s3;
                break;
            default:
                console.warn('THREE.Quaternion: .setFromEuler() encountered an unknown order: ' + order);
        }
        if (update === true) this._onChangeCallback();
        return this;
    }
    setFromAxisAngle(axis, angle) {
        // http://www.euclideanspace.com/maths/geometry/rotations/conversions/angleToQuaternion/index.htm
        // assumes axis is normalized
        const halfAngle = angle / 2, s = Math.sin(halfAngle);
        this._x = axis.x * s;
        this._y = axis.y * s;
        this._z = axis.z * s;
        this._w = Math.cos(halfAngle);
        this._onChangeCallback();
        return this;
    }
    setFromRotationMatrix(m) {
        // http://www.euclideanspace.com/maths/geometry/rotations/conversions/matrixToQuaternion/index.htm
        // assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)
        const te = m.elements, m11 = te[0], m12 = te[4], m13 = te[8], m21 = te[1], m22 = te[5], m23 = te[9], m31 = te[2], m32 = te[6], m33 = te[10], trace = m11 + m22 + m33;
        if (trace > 0) {
            const s = 0.5 / Math.sqrt(trace + 1.0);
            this._w = 0.25 / s;
            this._x = (m32 - m23) * s;
            this._y = (m13 - m31) * s;
            this._z = (m21 - m12) * s;
        } else if (m11 > m22 && m11 > m33) {
            const s = 2.0 * Math.sqrt(1.0 + m11 - m22 - m33);
            this._w = (m32 - m23) / s;
            this._x = 0.25 * s;
            this._y = (m12 + m21) / s;
            this._z = (m13 + m31) / s;
        } else if (m22 > m33) {
            const s = 2.0 * Math.sqrt(1.0 + m22 - m11 - m33);
            this._w = (m13 - m31) / s;
            this._x = (m12 + m21) / s;
            this._y = 0.25 * s;
            this._z = (m23 + m32) / s;
        } else {
            const s = 2.0 * Math.sqrt(1.0 + m33 - m11 - m22);
            this._w = (m21 - m12) / s;
            this._x = (m13 + m31) / s;
            this._y = (m23 + m32) / s;
            this._z = 0.25 * s;
        }
        this._onChangeCallback();
        return this;
    }
    setFromUnitVectors(vFrom, vTo) {
        // assumes direction vectors vFrom and vTo are normalized
        let r = vFrom.dot(vTo) + 1;
        if (r < Number.EPSILON) {
            // vFrom and vTo point in opposite directions
            r = 0;
            if (Math.abs(vFrom.x) > Math.abs(vFrom.z)) {
                this._x = -vFrom.y;
                this._y = vFrom.x;
                this._z = 0;
                this._w = r;
            } else {
                this._x = 0;
                this._y = -vFrom.z;
                this._z = vFrom.y;
                this._w = r;
            }
        } else {
            // crossVectors( vFrom, vTo ); // inlined to avoid cyclic dependency on Vector3
            this._x = vFrom.y * vTo.z - vFrom.z * vTo.y;
            this._y = vFrom.z * vTo.x - vFrom.x * vTo.z;
            this._z = vFrom.x * vTo.y - vFrom.y * vTo.x;
            this._w = r;
        }
        return this.normalize();
    }
    angleTo(q) {
        return 2 * Math.acos(Math.abs($d5b33d7c30034067$var$clamp(this.dot(q), -1, 1)));
    }
    rotateTowards(q, step) {
        const angle = this.angleTo(q);
        if (angle === 0) return this;
        const t = Math.min(1, step / angle);
        this.slerp(q, t);
        return this;
    }
    identity() {
        return this.set(0, 0, 0, 1);
    }
    invert() {
        // quaternion is assumed to have unit length
        return this.conjugate();
    }
    conjugate() {
        this._x *= -1;
        this._y *= -1;
        this._z *= -1;
        this._onChangeCallback();
        return this;
    }
    dot(v) {
        return this._x * v._x + this._y * v._y + this._z * v._z + this._w * v._w;
    }
    lengthSq() {
        return this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w;
    }
    length() {
        return Math.sqrt(this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w);
    }
    normalize() {
        let l = this.length();
        if (l === 0) {
            this._x = 0;
            this._y = 0;
            this._z = 0;
            this._w = 1;
        } else {
            l = 1 / l;
            this._x = this._x * l;
            this._y = this._y * l;
            this._z = this._z * l;
            this._w = this._w * l;
        }
        this._onChangeCallback();
        return this;
    }
    multiply(q) {
        return this.multiplyQuaternions(this, q);
    }
    premultiply(q) {
        return this.multiplyQuaternions(q, this);
    }
    multiplyQuaternions(a, b) {
        // from http://www.euclideanspace.com/maths/algebra/realNormedAlgebra/quaternions/code/index.htm
        const qax = a._x, qay = a._y, qaz = a._z, qaw = a._w;
        const qbx = b._x, qby = b._y, qbz = b._z, qbw = b._w;
        this._x = qax * qbw + qaw * qbx + qay * qbz - qaz * qby;
        this._y = qay * qbw + qaw * qby + qaz * qbx - qax * qbz;
        this._z = qaz * qbw + qaw * qbz + qax * qby - qay * qbx;
        this._w = qaw * qbw - qax * qbx - qay * qby - qaz * qbz;
        this._onChangeCallback();
        return this;
    }
    slerp(qb, t) {
        if (t === 0) return this;
        if (t === 1) return this.copy(qb);
        const x = this._x, y = this._y, z = this._z, w = this._w;
        // http://www.euclideanspace.com/maths/algebra/realNormedAlgebra/quaternions/slerp/
        let cosHalfTheta = w * qb._w + x * qb._x + y * qb._y + z * qb._z;
        if (cosHalfTheta < 0) {
            this._w = -qb._w;
            this._x = -qb._x;
            this._y = -qb._y;
            this._z = -qb._z;
            cosHalfTheta = -cosHalfTheta;
        } else this.copy(qb);
        if (cosHalfTheta >= 1.0) {
            this._w = w;
            this._x = x;
            this._y = y;
            this._z = z;
            return this;
        }
        const sqrSinHalfTheta = 1.0 - cosHalfTheta * cosHalfTheta;
        if (sqrSinHalfTheta <= Number.EPSILON) {
            const s = 1 - t;
            this._w = s * w + t * this._w;
            this._x = s * x + t * this._x;
            this._y = s * y + t * this._y;
            this._z = s * z + t * this._z;
            this.normalize(); // normalize calls _onChangeCallback()
            return this;
        }
        const sinHalfTheta = Math.sqrt(sqrSinHalfTheta);
        const halfTheta = Math.atan2(sinHalfTheta, cosHalfTheta);
        const ratioA = Math.sin((1 - t) * halfTheta) / sinHalfTheta, ratioB = Math.sin(t * halfTheta) / sinHalfTheta;
        this._w = w * ratioA + this._w * ratioB;
        this._x = x * ratioA + this._x * ratioB;
        this._y = y * ratioA + this._y * ratioB;
        this._z = z * ratioA + this._z * ratioB;
        this._onChangeCallback();
        return this;
    }
    slerpQuaternions(qa, qb, t) {
        return this.copy(qa).slerp(qb, t);
    }
    random() {
        // sets this quaternion to a uniform random unit quaternnion
        // Ken Shoemake
        // Uniform random rotations
        // D. Kirk, editor, Graphics Gems III, pages 124-132. Academic Press, New York, 1992.
        const theta1 = 2 * Math.PI * Math.random();
        const theta2 = 2 * Math.PI * Math.random();
        const x0 = Math.random();
        const r1 = Math.sqrt(1 - x0);
        const r2 = Math.sqrt(x0);
        return this.set(r1 * Math.sin(theta1), r1 * Math.cos(theta1), r2 * Math.sin(theta2), r2 * Math.cos(theta2));
    }
    equals(quaternion) {
        return quaternion._x === this._x && quaternion._y === this._y && quaternion._z === this._z && quaternion._w === this._w;
    }
    fromArray(array, offset = 0) {
        this._x = array[offset];
        this._y = array[offset + 1];
        this._z = array[offset + 2];
        this._w = array[offset + 3];
        this._onChangeCallback();
        return this;
    }
    toArray(array = [], offset = 0) {
        array[offset] = this._x;
        array[offset + 1] = this._y;
        array[offset + 2] = this._z;
        array[offset + 3] = this._w;
        return array;
    }
    fromBufferAttribute(attribute, index) {
        this._x = attribute.getX(index);
        this._y = attribute.getY(index);
        this._z = attribute.getZ(index);
        this._w = attribute.getW(index);
        this._onChangeCallback();
        return this;
    }
    toJSON() {
        return this.toArray();
    }
    _onChange(callback) {
        this._onChangeCallback = callback;
        return this;
    }
    _onChangeCallback() {}
    *[Symbol.iterator]() {
        yield this._x;
        yield this._y;
        yield this._z;
        yield this._w;
    }
}
class $d5b33d7c30034067$export$64b5c384219d3699 {
    constructor(x = 0, y = 0, z = 0){
        $d5b33d7c30034067$export$64b5c384219d3699.prototype.isVector3 = true;
        this.x = x;
        this.y = y;
        this.z = z;
    }
    set(x, y, z) {
        if (z === undefined) z = this.z; // sprite.scale.set(x,y)
        this.x = x;
        this.y = y;
        this.z = z;
        return this;
    }
    setScalar(scalar) {
        this.x = scalar;
        this.y = scalar;
        this.z = scalar;
        return this;
    }
    setX(x) {
        this.x = x;
        return this;
    }
    setY(y) {
        this.y = y;
        return this;
    }
    setZ(z) {
        this.z = z;
        return this;
    }
    setComponent(index, value) {
        switch(index){
            case 0:
                this.x = value;
                break;
            case 1:
                this.y = value;
                break;
            case 2:
                this.z = value;
                break;
            default:
                throw new Error('index is out of range: ' + index);
        }
        return this;
    }
    getComponent(index) {
        switch(index){
            case 0:
                return this.x;
            case 1:
                return this.y;
            case 2:
                return this.z;
            default:
                throw new Error('index is out of range: ' + index);
        }
    }
    clone() {
        return new this.constructor(this.x, this.y, this.z);
    }
    copy(v) {
        this.x = v.x;
        this.y = v.y;
        this.z = v.z;
        return this;
    }
    add(v) {
        this.x += v.x;
        this.y += v.y;
        this.z += v.z;
        return this;
    }
    addScalar(s) {
        this.x += s;
        this.y += s;
        this.z += s;
        return this;
    }
    addVectors(a, b) {
        this.x = a.x + b.x;
        this.y = a.y + b.y;
        this.z = a.z + b.z;
        return this;
    }
    addScaledVector(v, s) {
        this.x += v.x * s;
        this.y += v.y * s;
        this.z += v.z * s;
        return this;
    }
    sub(v) {
        this.x -= v.x;
        this.y -= v.y;
        this.z -= v.z;
        return this;
    }
    subScalar(s) {
        this.x -= s;
        this.y -= s;
        this.z -= s;
        return this;
    }
    subVectors(a, b) {
        this.x = a.x - b.x;
        this.y = a.y - b.y;
        this.z = a.z - b.z;
        return this;
    }
    multiply(v) {
        this.x *= v.x;
        this.y *= v.y;
        this.z *= v.z;
        return this;
    }
    multiplyScalar(scalar) {
        this.x *= scalar;
        this.y *= scalar;
        this.z *= scalar;
        return this;
    }
    multiplyVectors(a, b) {
        this.x = a.x * b.x;
        this.y = a.y * b.y;
        this.z = a.z * b.z;
        return this;
    }
    applyEuler(euler) {
        return this.applyQuaternion($d5b33d7c30034067$var$_quaternion$4.setFromEuler(euler));
    }
    applyAxisAngle(axis, angle) {
        return this.applyQuaternion($d5b33d7c30034067$var$_quaternion$4.setFromAxisAngle(axis, angle));
    }
    applyMatrix3(m) {
        const x = this.x, y = this.y, z = this.z;
        const e = m.elements;
        this.x = e[0] * x + e[3] * y + e[6] * z;
        this.y = e[1] * x + e[4] * y + e[7] * z;
        this.z = e[2] * x + e[5] * y + e[8] * z;
        return this;
    }
    applyNormalMatrix(m) {
        return this.applyMatrix3(m).normalize();
    }
    applyMatrix4(m) {
        const x = this.x, y = this.y, z = this.z;
        const e = m.elements;
        const w = 1 / (e[3] * x + e[7] * y + e[11] * z + e[15]);
        this.x = (e[0] * x + e[4] * y + e[8] * z + e[12]) * w;
        this.y = (e[1] * x + e[5] * y + e[9] * z + e[13]) * w;
        this.z = (e[2] * x + e[6] * y + e[10] * z + e[14]) * w;
        return this;
    }
    applyQuaternion(q) {
        // quaternion q is assumed to have unit length
        const vx = this.x, vy = this.y, vz = this.z;
        const qx = q.x, qy = q.y, qz = q.z, qw = q.w;
        // t = 2 * cross( q.xyz, v );
        const tx = 2 * (qy * vz - qz * vy);
        const ty = 2 * (qz * vx - qx * vz);
        const tz = 2 * (qx * vy - qy * vx);
        // v + q.w * t + cross( q.xyz, t );
        this.x = vx + qw * tx + qy * tz - qz * ty;
        this.y = vy + qw * ty + qz * tx - qx * tz;
        this.z = vz + qw * tz + qx * ty - qy * tx;
        return this;
    }
    project(camera) {
        return this.applyMatrix4(camera.matrixWorldInverse).applyMatrix4(camera.projectionMatrix);
    }
    unproject(camera) {
        return this.applyMatrix4(camera.projectionMatrixInverse).applyMatrix4(camera.matrixWorld);
    }
    transformDirection(m) {
        // input: THREE.Matrix4 affine matrix
        // vector interpreted as a direction
        const x = this.x, y = this.y, z = this.z;
        const e = m.elements;
        this.x = e[0] * x + e[4] * y + e[8] * z;
        this.y = e[1] * x + e[5] * y + e[9] * z;
        this.z = e[2] * x + e[6] * y + e[10] * z;
        return this.normalize();
    }
    divide(v) {
        this.x /= v.x;
        this.y /= v.y;
        this.z /= v.z;
        return this;
    }
    divideScalar(scalar) {
        return this.multiplyScalar(1 / scalar);
    }
    min(v) {
        this.x = Math.min(this.x, v.x);
        this.y = Math.min(this.y, v.y);
        this.z = Math.min(this.z, v.z);
        return this;
    }
    max(v) {
        this.x = Math.max(this.x, v.x);
        this.y = Math.max(this.y, v.y);
        this.z = Math.max(this.z, v.z);
        return this;
    }
    clamp(min, max) {
        // assumes min < max, componentwise
        this.x = Math.max(min.x, Math.min(max.x, this.x));
        this.y = Math.max(min.y, Math.min(max.y, this.y));
        this.z = Math.max(min.z, Math.min(max.z, this.z));
        return this;
    }
    clampScalar(minVal, maxVal) {
        this.x = Math.max(minVal, Math.min(maxVal, this.x));
        this.y = Math.max(minVal, Math.min(maxVal, this.y));
        this.z = Math.max(minVal, Math.min(maxVal, this.z));
        return this;
    }
    clampLength(min, max) {
        const length = this.length();
        return this.divideScalar(length || 1).multiplyScalar(Math.max(min, Math.min(max, length)));
    }
    floor() {
        this.x = Math.floor(this.x);
        this.y = Math.floor(this.y);
        this.z = Math.floor(this.z);
        return this;
    }
    ceil() {
        this.x = Math.ceil(this.x);
        this.y = Math.ceil(this.y);
        this.z = Math.ceil(this.z);
        return this;
    }
    round() {
        this.x = Math.round(this.x);
        this.y = Math.round(this.y);
        this.z = Math.round(this.z);
        return this;
    }
    roundToZero() {
        this.x = Math.trunc(this.x);
        this.y = Math.trunc(this.y);
        this.z = Math.trunc(this.z);
        return this;
    }
    negate() {
        this.x = -this.x;
        this.y = -this.y;
        this.z = -this.z;
        return this;
    }
    dot(v) {
        return this.x * v.x + this.y * v.y + this.z * v.z;
    }
    // TODO lengthSquared?
    lengthSq() {
        return this.x * this.x + this.y * this.y + this.z * this.z;
    }
    length() {
        return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z);
    }
    manhattanLength() {
        return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z);
    }
    normalize() {
        return this.divideScalar(this.length() || 1);
    }
    setLength(length) {
        return this.normalize().multiplyScalar(length);
    }
    lerp(v, alpha) {
        this.x += (v.x - this.x) * alpha;
        this.y += (v.y - this.y) * alpha;
        this.z += (v.z - this.z) * alpha;
        return this;
    }
    lerpVectors(v1, v2, alpha) {
        this.x = v1.x + (v2.x - v1.x) * alpha;
        this.y = v1.y + (v2.y - v1.y) * alpha;
        this.z = v1.z + (v2.z - v1.z) * alpha;
        return this;
    }
    cross(v) {
        return this.crossVectors(this, v);
    }
    crossVectors(a, b) {
        const ax = a.x, ay = a.y, az = a.z;
        const bx = b.x, by = b.y, bz = b.z;
        this.x = ay * bz - az * by;
        this.y = az * bx - ax * bz;
        this.z = ax * by - ay * bx;
        return this;
    }
    projectOnVector(v) {
        const denominator = v.lengthSq();
        if (denominator === 0) return this.set(0, 0, 0);
        const scalar = v.dot(this) / denominator;
        return this.copy(v).multiplyScalar(scalar);
    }
    projectOnPlane(planeNormal) {
        $d5b33d7c30034067$var$_vector$c.copy(this).projectOnVector(planeNormal);
        return this.sub($d5b33d7c30034067$var$_vector$c);
    }
    reflect(normal) {
        // reflect incident vector off plane orthogonal to normal
        // normal is assumed to have unit length
        return this.sub($d5b33d7c30034067$var$_vector$c.copy(normal).multiplyScalar(2 * this.dot(normal)));
    }
    angleTo(v) {
        const denominator = Math.sqrt(this.lengthSq() * v.lengthSq());
        if (denominator === 0) return Math.PI / 2;
        const theta = this.dot(v) / denominator;
        // clamp, to handle numerical problems
        return Math.acos($d5b33d7c30034067$var$clamp(theta, -1, 1));
    }
    distanceTo(v) {
        return Math.sqrt(this.distanceToSquared(v));
    }
    distanceToSquared(v) {
        const dx = this.x - v.x, dy = this.y - v.y, dz = this.z - v.z;
        return dx * dx + dy * dy + dz * dz;
    }
    manhattanDistanceTo(v) {
        return Math.abs(this.x - v.x) + Math.abs(this.y - v.y) + Math.abs(this.z - v.z);
    }
    setFromSpherical(s) {
        return this.setFromSphericalCoords(s.radius, s.phi, s.theta);
    }
    setFromSphericalCoords(radius, phi, theta) {
        const sinPhiRadius = Math.sin(phi) * radius;
        this.x = sinPhiRadius * Math.sin(theta);
        this.y = Math.cos(phi) * radius;
        this.z = sinPhiRadius * Math.cos(theta);
        return this;
    }
    setFromCylindrical(c) {
        return this.setFromCylindricalCoords(c.radius, c.theta, c.y);
    }
    setFromCylindricalCoords(radius, theta, y) {
        this.x = radius * Math.sin(theta);
        this.y = y;
        this.z = radius * Math.cos(theta);
        return this;
    }
    setFromMatrixPosition(m) {
        const e = m.elements;
        this.x = e[12];
        this.y = e[13];
        this.z = e[14];
        return this;
    }
    setFromMatrixScale(m) {
        const sx = this.setFromMatrixColumn(m, 0).length();
        const sy = this.setFromMatrixColumn(m, 1).length();
        const sz = this.setFromMatrixColumn(m, 2).length();
        this.x = sx;
        this.y = sy;
        this.z = sz;
        return this;
    }
    setFromMatrixColumn(m, index) {
        return this.fromArray(m.elements, index * 4);
    }
    setFromMatrix3Column(m, index) {
        return this.fromArray(m.elements, index * 3);
    }
    setFromEuler(e) {
        this.x = e._x;
        this.y = e._y;
        this.z = e._z;
        return this;
    }
    setFromColor(c) {
        this.x = c.r;
        this.y = c.g;
        this.z = c.b;
        return this;
    }
    equals(v) {
        return v.x === this.x && v.y === this.y && v.z === this.z;
    }
    fromArray(array, offset = 0) {
        this.x = array[offset];
        this.y = array[offset + 1];
        this.z = array[offset + 2];
        return this;
    }
    toArray(array = [], offset = 0) {
        array[offset] = this.x;
        array[offset + 1] = this.y;
        array[offset + 2] = this.z;
        return array;
    }
    fromBufferAttribute(attribute, index) {
        this.x = attribute.getX(index);
        this.y = attribute.getY(index);
        this.z = attribute.getZ(index);
        return this;
    }
    random() {
        this.x = Math.random();
        this.y = Math.random();
        this.z = Math.random();
        return this;
    }
    randomDirection() {
        // https://mathworld.wolfram.com/SpherePointPicking.html
        const theta = Math.random() * Math.PI * 2;
        const u = Math.random() * 2 - 1;
        const c = Math.sqrt(1 - u * u);
        this.x = c * Math.cos(theta);
        this.y = u;
        this.z = c * Math.sin(theta);
        return this;
    }
    *[Symbol.iterator]() {
        yield this.x;
        yield this.y;
        yield this.z;
    }
}
const $d5b33d7c30034067$var$_vector$c = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_quaternion$4 = /*@__PURE__*/ new $d5b33d7c30034067$export$23d6a54f0bbc85a3();
class $d5b33d7c30034067$export$6f7d5a9418ab2aa3 {
    constructor(min = new $d5b33d7c30034067$export$64b5c384219d3699(Infinity, Infinity, Infinity), max = new $d5b33d7c30034067$export$64b5c384219d3699(-Infinity, -Infinity, -Infinity)){
        this.isBox3 = true;
        this.min = min;
        this.max = max;
    }
    set(min, max) {
        this.min.copy(min);
        this.max.copy(max);
        return this;
    }
    setFromArray(array) {
        this.makeEmpty();
        for(let i = 0, il = array.length; i < il; i += 3)this.expandByPoint($d5b33d7c30034067$var$_vector$b.fromArray(array, i));
        return this;
    }
    setFromBufferAttribute(attribute) {
        this.makeEmpty();
        for(let i = 0, il = attribute.count; i < il; i++)this.expandByPoint($d5b33d7c30034067$var$_vector$b.fromBufferAttribute(attribute, i));
        return this;
    }
    setFromPoints(points) {
        this.makeEmpty();
        for(let i = 0, il = points.length; i < il; i++)this.expandByPoint(points[i]);
        return this;
    }
    setFromCenterAndSize(center, size) {
        const halfSize = $d5b33d7c30034067$var$_vector$b.copy(size).multiplyScalar(0.5);
        this.min.copy(center).sub(halfSize);
        this.max.copy(center).add(halfSize);
        return this;
    }
    setFromObject(object, precise = false) {
        this.makeEmpty();
        return this.expandByObject(object, precise);
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(box) {
        this.min.copy(box.min);
        this.max.copy(box.max);
        return this;
    }
    makeEmpty() {
        this.min.x = this.min.y = this.min.z = Infinity;
        this.max.x = this.max.y = this.max.z = -Infinity;
        return this;
    }
    isEmpty() {
        // this is a more robust check for empty than ( volume <= 0 ) because volume can get positive with two negative axes
        return this.max.x < this.min.x || this.max.y < this.min.y || this.max.z < this.min.z;
    }
    getCenter(target) {
        return this.isEmpty() ? target.set(0, 0, 0) : target.addVectors(this.min, this.max).multiplyScalar(0.5);
    }
    getSize(target) {
        return this.isEmpty() ? target.set(0, 0, 0) : target.subVectors(this.max, this.min);
    }
    expandByPoint(point) {
        this.min.min(point);
        this.max.max(point);
        return this;
    }
    expandByVector(vector) {
        this.min.sub(vector);
        this.max.add(vector);
        return this;
    }
    expandByScalar(scalar) {
        this.min.addScalar(-scalar);
        this.max.addScalar(scalar);
        return this;
    }
    expandByObject(object, precise = false) {
        // Computes the world-axis-aligned bounding box of an object (including its children),
        // accounting for both the object's, and children's, world transforms
        object.updateWorldMatrix(false, false);
        const geometry = object.geometry;
        if (geometry !== undefined) {
            const positionAttribute = geometry.getAttribute('position');
            // precise AABB computation based on vertex data requires at least a position attribute.
            // instancing isn't supported so far and uses the normal (conservative) code path.
            if (precise === true && positionAttribute !== undefined && object.isInstancedMesh !== true) for(let i = 0, l = positionAttribute.count; i < l; i++){
                if (object.isMesh === true) object.getVertexPosition(i, $d5b33d7c30034067$var$_vector$b);
                else $d5b33d7c30034067$var$_vector$b.fromBufferAttribute(positionAttribute, i);
                $d5b33d7c30034067$var$_vector$b.applyMatrix4(object.matrixWorld);
                this.expandByPoint($d5b33d7c30034067$var$_vector$b);
            }
            else {
                if (object.boundingBox !== undefined) {
                    // object-level bounding box
                    if (object.boundingBox === null) object.computeBoundingBox();
                    $d5b33d7c30034067$var$_box$4.copy(object.boundingBox);
                } else {
                    // geometry-level bounding box
                    if (geometry.boundingBox === null) geometry.computeBoundingBox();
                    $d5b33d7c30034067$var$_box$4.copy(geometry.boundingBox);
                }
                $d5b33d7c30034067$var$_box$4.applyMatrix4(object.matrixWorld);
                this.union($d5b33d7c30034067$var$_box$4);
            }
        }
        const children = object.children;
        for(let i = 0, l = children.length; i < l; i++)this.expandByObject(children[i], precise);
        return this;
    }
    containsPoint(point) {
        return point.x >= this.min.x && point.x <= this.max.x && point.y >= this.min.y && point.y <= this.max.y && point.z >= this.min.z && point.z <= this.max.z;
    }
    containsBox(box) {
        return this.min.x <= box.min.x && box.max.x <= this.max.x && this.min.y <= box.min.y && box.max.y <= this.max.y && this.min.z <= box.min.z && box.max.z <= this.max.z;
    }
    getParameter(point, target) {
        // This can potentially have a divide by zero if the box
        // has a size dimension of 0.
        return target.set((point.x - this.min.x) / (this.max.x - this.min.x), (point.y - this.min.y) / (this.max.y - this.min.y), (point.z - this.min.z) / (this.max.z - this.min.z));
    }
    intersectsBox(box) {
        // using 6 splitting planes to rule out intersections.
        return box.max.x >= this.min.x && box.min.x <= this.max.x && box.max.y >= this.min.y && box.min.y <= this.max.y && box.max.z >= this.min.z && box.min.z <= this.max.z;
    }
    intersectsSphere(sphere) {
        // Find the point on the AABB closest to the sphere center.
        this.clampPoint(sphere.center, $d5b33d7c30034067$var$_vector$b);
        // If that point is inside the sphere, the AABB and sphere intersect.
        return $d5b33d7c30034067$var$_vector$b.distanceToSquared(sphere.center) <= sphere.radius * sphere.radius;
    }
    intersectsPlane(plane) {
        // We compute the minimum and maximum dot product values. If those values
        // are on the same side (back or front) of the plane, then there is no intersection.
        let min, max;
        if (plane.normal.x > 0) {
            min = plane.normal.x * this.min.x;
            max = plane.normal.x * this.max.x;
        } else {
            min = plane.normal.x * this.max.x;
            max = plane.normal.x * this.min.x;
        }
        if (plane.normal.y > 0) {
            min += plane.normal.y * this.min.y;
            max += plane.normal.y * this.max.y;
        } else {
            min += plane.normal.y * this.max.y;
            max += plane.normal.y * this.min.y;
        }
        if (plane.normal.z > 0) {
            min += plane.normal.z * this.min.z;
            max += plane.normal.z * this.max.z;
        } else {
            min += plane.normal.z * this.max.z;
            max += plane.normal.z * this.min.z;
        }
        return min <= -plane.constant && max >= -plane.constant;
    }
    intersectsTriangle(triangle) {
        if (this.isEmpty()) return false;
        // compute box center and extents
        this.getCenter($d5b33d7c30034067$var$_center);
        $d5b33d7c30034067$var$_extents.subVectors(this.max, $d5b33d7c30034067$var$_center);
        // translate triangle to aabb origin
        $d5b33d7c30034067$var$_v0$3.subVectors(triangle.a, $d5b33d7c30034067$var$_center);
        $d5b33d7c30034067$var$_v1$7.subVectors(triangle.b, $d5b33d7c30034067$var$_center);
        $d5b33d7c30034067$var$_v2$4.subVectors(triangle.c, $d5b33d7c30034067$var$_center);
        // compute edge vectors for triangle
        $d5b33d7c30034067$var$_f0.subVectors($d5b33d7c30034067$var$_v1$7, $d5b33d7c30034067$var$_v0$3);
        $d5b33d7c30034067$var$_f1.subVectors($d5b33d7c30034067$var$_v2$4, $d5b33d7c30034067$var$_v1$7);
        $d5b33d7c30034067$var$_f2.subVectors($d5b33d7c30034067$var$_v0$3, $d5b33d7c30034067$var$_v2$4);
        // test against axes that are given by cross product combinations of the edges of the triangle and the edges of the aabb
        // make an axis testing of each of the 3 sides of the aabb against each of the 3 sides of the triangle = 9 axis of separation
        // axis_ij = u_i x f_j (u0, u1, u2 = face normals of aabb = x,y,z axes vectors since aabb is axis aligned)
        let axes = [
            0,
            -$d5b33d7c30034067$var$_f0.z,
            $d5b33d7c30034067$var$_f0.y,
            0,
            -$d5b33d7c30034067$var$_f1.z,
            $d5b33d7c30034067$var$_f1.y,
            0,
            -$d5b33d7c30034067$var$_f2.z,
            $d5b33d7c30034067$var$_f2.y,
            $d5b33d7c30034067$var$_f0.z,
            0,
            -$d5b33d7c30034067$var$_f0.x,
            $d5b33d7c30034067$var$_f1.z,
            0,
            -$d5b33d7c30034067$var$_f1.x,
            $d5b33d7c30034067$var$_f2.z,
            0,
            -$d5b33d7c30034067$var$_f2.x,
            -$d5b33d7c30034067$var$_f0.y,
            $d5b33d7c30034067$var$_f0.x,
            0,
            -$d5b33d7c30034067$var$_f1.y,
            $d5b33d7c30034067$var$_f1.x,
            0,
            -$d5b33d7c30034067$var$_f2.y,
            $d5b33d7c30034067$var$_f2.x,
            0
        ];
        if (!$d5b33d7c30034067$var$satForAxes(axes, $d5b33d7c30034067$var$_v0$3, $d5b33d7c30034067$var$_v1$7, $d5b33d7c30034067$var$_v2$4, $d5b33d7c30034067$var$_extents)) return false;
        // test 3 face normals from the aabb
        axes = [
            1,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            1
        ];
        if (!$d5b33d7c30034067$var$satForAxes(axes, $d5b33d7c30034067$var$_v0$3, $d5b33d7c30034067$var$_v1$7, $d5b33d7c30034067$var$_v2$4, $d5b33d7c30034067$var$_extents)) return false;
        // finally testing the face normal of the triangle
        // use already existing triangle edge vectors here
        $d5b33d7c30034067$var$_triangleNormal.crossVectors($d5b33d7c30034067$var$_f0, $d5b33d7c30034067$var$_f1);
        axes = [
            $d5b33d7c30034067$var$_triangleNormal.x,
            $d5b33d7c30034067$var$_triangleNormal.y,
            $d5b33d7c30034067$var$_triangleNormal.z
        ];
        return $d5b33d7c30034067$var$satForAxes(axes, $d5b33d7c30034067$var$_v0$3, $d5b33d7c30034067$var$_v1$7, $d5b33d7c30034067$var$_v2$4, $d5b33d7c30034067$var$_extents);
    }
    clampPoint(point, target) {
        return target.copy(point).clamp(this.min, this.max);
    }
    distanceToPoint(point) {
        return this.clampPoint(point, $d5b33d7c30034067$var$_vector$b).distanceTo(point);
    }
    getBoundingSphere(target) {
        if (this.isEmpty()) target.makeEmpty();
        else {
            this.getCenter(target.center);
            target.radius = this.getSize($d5b33d7c30034067$var$_vector$b).length() * 0.5;
        }
        return target;
    }
    intersect(box) {
        this.min.max(box.min);
        this.max.min(box.max);
        // ensure that if there is no overlap, the result is fully empty, not slightly empty with non-inf/+inf values that will cause subsequence intersects to erroneously return valid values.
        if (this.isEmpty()) this.makeEmpty();
        return this;
    }
    union(box) {
        this.min.min(box.min);
        this.max.max(box.max);
        return this;
    }
    applyMatrix4(matrix) {
        // transform of empty box is an empty box.
        if (this.isEmpty()) return this;
        // NOTE: I am using a binary pattern to specify all 2^3 combinations below
        $d5b33d7c30034067$var$_points[0].set(this.min.x, this.min.y, this.min.z).applyMatrix4(matrix); // 000
        $d5b33d7c30034067$var$_points[1].set(this.min.x, this.min.y, this.max.z).applyMatrix4(matrix); // 001
        $d5b33d7c30034067$var$_points[2].set(this.min.x, this.max.y, this.min.z).applyMatrix4(matrix); // 010
        $d5b33d7c30034067$var$_points[3].set(this.min.x, this.max.y, this.max.z).applyMatrix4(matrix); // 011
        $d5b33d7c30034067$var$_points[4].set(this.max.x, this.min.y, this.min.z).applyMatrix4(matrix); // 100
        $d5b33d7c30034067$var$_points[5].set(this.max.x, this.min.y, this.max.z).applyMatrix4(matrix); // 101
        $d5b33d7c30034067$var$_points[6].set(this.max.x, this.max.y, this.min.z).applyMatrix4(matrix); // 110
        $d5b33d7c30034067$var$_points[7].set(this.max.x, this.max.y, this.max.z).applyMatrix4(matrix); // 111
        this.setFromPoints($d5b33d7c30034067$var$_points);
        return this;
    }
    translate(offset) {
        this.min.add(offset);
        this.max.add(offset);
        return this;
    }
    equals(box) {
        return box.min.equals(this.min) && box.max.equals(this.max);
    }
}
const $d5b33d7c30034067$var$_points = [
    /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699(),
    /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699(),
    /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699(),
    /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699(),
    /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699(),
    /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699(),
    /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699(),
    /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699()
];
const $d5b33d7c30034067$var$_vector$b = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_box$4 = /*@__PURE__*/ new $d5b33d7c30034067$export$6f7d5a9418ab2aa3();
// triangle centered vertices
const $d5b33d7c30034067$var$_v0$3 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_v1$7 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_v2$4 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
// triangle edge vectors
const $d5b33d7c30034067$var$_f0 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_f1 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_f2 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_center = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_extents = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_triangleNormal = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_testAxis = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
function $d5b33d7c30034067$var$satForAxes(axes, v0, v1, v2, extents) {
    for(let i = 0, j = axes.length - 3; i <= j; i += 3){
        $d5b33d7c30034067$var$_testAxis.fromArray(axes, i);
        // project the aabb onto the separating axis
        const r = extents.x * Math.abs($d5b33d7c30034067$var$_testAxis.x) + extents.y * Math.abs($d5b33d7c30034067$var$_testAxis.y) + extents.z * Math.abs($d5b33d7c30034067$var$_testAxis.z);
        // project all 3 vertices of the triangle onto the separating axis
        const p0 = v0.dot($d5b33d7c30034067$var$_testAxis);
        const p1 = v1.dot($d5b33d7c30034067$var$_testAxis);
        const p2 = v2.dot($d5b33d7c30034067$var$_testAxis);
        // actual test, basically see if either of the most extreme of the triangle points intersects r
        if (Math.max(-Math.max(p0, p1, p2), Math.min(p0, p1, p2)) > r) // points of the projected triangle are outside the projected half-length of the aabb
        // the axis is separating and we can exit
        return false;
    }
    return true;
}
const $d5b33d7c30034067$var$_box$3 = /*@__PURE__*/ new $d5b33d7c30034067$export$6f7d5a9418ab2aa3();
const $d5b33d7c30034067$var$_v1$6 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_v2$3 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
class $d5b33d7c30034067$export$805e8b72413ccaba {
    constructor(center = new $d5b33d7c30034067$export$64b5c384219d3699(), radius = -1){
        this.isSphere = true;
        this.center = center;
        this.radius = radius;
    }
    set(center, radius) {
        this.center.copy(center);
        this.radius = radius;
        return this;
    }
    setFromPoints(points, optionalCenter) {
        const center = this.center;
        if (optionalCenter !== undefined) center.copy(optionalCenter);
        else $d5b33d7c30034067$var$_box$3.setFromPoints(points).getCenter(center);
        let maxRadiusSq = 0;
        for(let i = 0, il = points.length; i < il; i++)maxRadiusSq = Math.max(maxRadiusSq, center.distanceToSquared(points[i]));
        this.radius = Math.sqrt(maxRadiusSq);
        return this;
    }
    copy(sphere) {
        this.center.copy(sphere.center);
        this.radius = sphere.radius;
        return this;
    }
    isEmpty() {
        return this.radius < 0;
    }
    makeEmpty() {
        this.center.set(0, 0, 0);
        this.radius = -1;
        return this;
    }
    containsPoint(point) {
        return point.distanceToSquared(this.center) <= this.radius * this.radius;
    }
    distanceToPoint(point) {
        return point.distanceTo(this.center) - this.radius;
    }
    intersectsSphere(sphere) {
        const radiusSum = this.radius + sphere.radius;
        return sphere.center.distanceToSquared(this.center) <= radiusSum * radiusSum;
    }
    intersectsBox(box) {
        return box.intersectsSphere(this);
    }
    intersectsPlane(plane) {
        return Math.abs(plane.distanceToPoint(this.center)) <= this.radius;
    }
    clampPoint(point, target) {
        const deltaLengthSq = this.center.distanceToSquared(point);
        target.copy(point);
        if (deltaLengthSq > this.radius * this.radius) {
            target.sub(this.center).normalize();
            target.multiplyScalar(this.radius).add(this.center);
        }
        return target;
    }
    getBoundingBox(target) {
        if (this.isEmpty()) {
            // Empty sphere produces empty bounding box
            target.makeEmpty();
            return target;
        }
        target.set(this.center, this.center);
        target.expandByScalar(this.radius);
        return target;
    }
    applyMatrix4(matrix) {
        this.center.applyMatrix4(matrix);
        this.radius = this.radius * matrix.getMaxScaleOnAxis();
        return this;
    }
    translate(offset) {
        this.center.add(offset);
        return this;
    }
    expandByPoint(point) {
        if (this.isEmpty()) {
            this.center.copy(point);
            this.radius = 0;
            return this;
        }
        $d5b33d7c30034067$var$_v1$6.subVectors(point, this.center);
        const lengthSq = $d5b33d7c30034067$var$_v1$6.lengthSq();
        if (lengthSq > this.radius * this.radius) {
            // calculate the minimal sphere
            const length = Math.sqrt(lengthSq);
            const delta = (length - this.radius) * 0.5;
            this.center.addScaledVector($d5b33d7c30034067$var$_v1$6, delta / length);
            this.radius += delta;
        }
        return this;
    }
    union(sphere) {
        if (sphere.isEmpty()) return this;
        if (this.isEmpty()) {
            this.copy(sphere);
            return this;
        }
        if (this.center.equals(sphere.center) === true) this.radius = Math.max(this.radius, sphere.radius);
        else {
            $d5b33d7c30034067$var$_v2$3.subVectors(sphere.center, this.center).setLength(sphere.radius);
            this.expandByPoint($d5b33d7c30034067$var$_v1$6.copy(sphere.center).add($d5b33d7c30034067$var$_v2$3));
            this.expandByPoint($d5b33d7c30034067$var$_v1$6.copy(sphere.center).sub($d5b33d7c30034067$var$_v2$3));
        }
        return this;
    }
    equals(sphere) {
        return sphere.center.equals(this.center) && sphere.radius === this.radius;
    }
    clone() {
        return new this.constructor().copy(this);
    }
}
const $d5b33d7c30034067$var$_vector$a = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_segCenter = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_segDir = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_diff = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_edge1 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_edge2 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_normal$1 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
class $d5b33d7c30034067$export$a186db52eed6d40e {
    constructor(origin = new $d5b33d7c30034067$export$64b5c384219d3699(), direction = new $d5b33d7c30034067$export$64b5c384219d3699(0, 0, -1)){
        this.origin = origin;
        this.direction = direction;
    }
    set(origin, direction) {
        this.origin.copy(origin);
        this.direction.copy(direction);
        return this;
    }
    copy(ray) {
        this.origin.copy(ray.origin);
        this.direction.copy(ray.direction);
        return this;
    }
    at(t, target) {
        return target.copy(this.origin).addScaledVector(this.direction, t);
    }
    lookAt(v) {
        this.direction.copy(v).sub(this.origin).normalize();
        return this;
    }
    recast(t) {
        this.origin.copy(this.at(t, $d5b33d7c30034067$var$_vector$a));
        return this;
    }
    closestPointToPoint(point, target) {
        target.subVectors(point, this.origin);
        const directionDistance = target.dot(this.direction);
        if (directionDistance < 0) return target.copy(this.origin);
        return target.copy(this.origin).addScaledVector(this.direction, directionDistance);
    }
    distanceToPoint(point) {
        return Math.sqrt(this.distanceSqToPoint(point));
    }
    distanceSqToPoint(point) {
        const directionDistance = $d5b33d7c30034067$var$_vector$a.subVectors(point, this.origin).dot(this.direction);
        // point behind the ray
        if (directionDistance < 0) return this.origin.distanceToSquared(point);
        $d5b33d7c30034067$var$_vector$a.copy(this.origin).addScaledVector(this.direction, directionDistance);
        return $d5b33d7c30034067$var$_vector$a.distanceToSquared(point);
    }
    distanceSqToSegment(v0, v1, optionalPointOnRay, optionalPointOnSegment) {
        // from https://github.com/pmjoniak/GeometricTools/blob/master/GTEngine/Include/Mathematics/GteDistRaySegment.h
        // It returns the min distance between the ray and the segment
        // defined by v0 and v1
        // It can also set two optional targets :
        // - The closest point on the ray
        // - The closest point on the segment
        $d5b33d7c30034067$var$_segCenter.copy(v0).add(v1).multiplyScalar(0.5);
        $d5b33d7c30034067$var$_segDir.copy(v1).sub(v0).normalize();
        $d5b33d7c30034067$var$_diff.copy(this.origin).sub($d5b33d7c30034067$var$_segCenter);
        const segExtent = v0.distanceTo(v1) * 0.5;
        const a01 = -this.direction.dot($d5b33d7c30034067$var$_segDir);
        const b0 = $d5b33d7c30034067$var$_diff.dot(this.direction);
        const b1 = -$d5b33d7c30034067$var$_diff.dot($d5b33d7c30034067$var$_segDir);
        const c = $d5b33d7c30034067$var$_diff.lengthSq();
        const det = Math.abs(1 - a01 * a01);
        let s0, s1, sqrDist, extDet;
        if (det > 0) {
            // The ray and segment are not parallel.
            s0 = a01 * b1 - b0;
            s1 = a01 * b0 - b1;
            extDet = segExtent * det;
            if (s0 >= 0) {
                if (s1 >= -extDet) {
                    if (s1 <= extDet) {
                        // region 0
                        // Minimum at interior points of ray and segment.
                        const invDet = 1 / det;
                        s0 *= invDet;
                        s1 *= invDet;
                        sqrDist = s0 * (s0 + a01 * s1 + 2 * b0) + s1 * (a01 * s0 + s1 + 2 * b1) + c;
                    } else {
                        // region 1
                        s1 = segExtent;
                        s0 = Math.max(0, -(a01 * s1 + b0));
                        sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
                    }
                } else {
                    // region 5
                    s1 = -segExtent;
                    s0 = Math.max(0, -(a01 * s1 + b0));
                    sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
                }
            } else {
                if (s1 <= -extDet) {
                    // region 4
                    s0 = Math.max(0, -(-a01 * segExtent + b0));
                    s1 = s0 > 0 ? -segExtent : Math.min(Math.max(-segExtent, -b1), segExtent);
                    sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
                } else if (s1 <= extDet) {
                    // region 3
                    s0 = 0;
                    s1 = Math.min(Math.max(-segExtent, -b1), segExtent);
                    sqrDist = s1 * (s1 + 2 * b1) + c;
                } else {
                    // region 2
                    s0 = Math.max(0, -(a01 * segExtent + b0));
                    s1 = s0 > 0 ? segExtent : Math.min(Math.max(-segExtent, -b1), segExtent);
                    sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
                }
            }
        } else {
            // Ray and segment are parallel.
            s1 = a01 > 0 ? -segExtent : segExtent;
            s0 = Math.max(0, -(a01 * s1 + b0));
            sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
        }
        if (optionalPointOnRay) optionalPointOnRay.copy(this.origin).addScaledVector(this.direction, s0);
        if (optionalPointOnSegment) optionalPointOnSegment.copy($d5b33d7c30034067$var$_segCenter).addScaledVector($d5b33d7c30034067$var$_segDir, s1);
        return sqrDist;
    }
    intersectSphere(sphere, target) {
        $d5b33d7c30034067$var$_vector$a.subVectors(sphere.center, this.origin);
        const tca = $d5b33d7c30034067$var$_vector$a.dot(this.direction);
        const d2 = $d5b33d7c30034067$var$_vector$a.dot($d5b33d7c30034067$var$_vector$a) - tca * tca;
        const radius2 = sphere.radius * sphere.radius;
        if (d2 > radius2) return null;
        const thc = Math.sqrt(radius2 - d2);
        // t0 = first intersect point - entrance on front of sphere
        const t0 = tca - thc;
        // t1 = second intersect point - exit point on back of sphere
        const t1 = tca + thc;
        // test to see if t1 is behind the ray - if so, return null
        if (t1 < 0) return null;
        // test to see if t0 is behind the ray:
        // if it is, the ray is inside the sphere, so return the second exit point scaled by t1,
        // in order to always return an intersect point that is in front of the ray.
        if (t0 < 0) return this.at(t1, target);
        // else t0 is in front of the ray, so return the first collision point scaled by t0
        return this.at(t0, target);
    }
    intersectsSphere(sphere) {
        return this.distanceSqToPoint(sphere.center) <= sphere.radius * sphere.radius;
    }
    distanceToPlane(plane) {
        const denominator = plane.normal.dot(this.direction);
        if (denominator === 0) {
            // line is coplanar, return origin
            if (plane.distanceToPoint(this.origin) === 0) return 0;
            // Null is preferable to undefined since undefined means.... it is undefined
            return null;
        }
        const t = -(this.origin.dot(plane.normal) + plane.constant) / denominator;
        // Return if the ray never intersects the plane
        return t >= 0 ? t : null;
    }
    intersectPlane(plane, target) {
        const t = this.distanceToPlane(plane);
        if (t === null) return null;
        return this.at(t, target);
    }
    intersectsPlane(plane) {
        // check if the ray lies on the plane first
        const distToPoint = plane.distanceToPoint(this.origin);
        if (distToPoint === 0) return true;
        const denominator = plane.normal.dot(this.direction);
        if (denominator * distToPoint < 0) return true;
        // ray origin is behind the plane (and is pointing behind it)
        return false;
    }
    intersectBox(box, target) {
        let tmin, tmax, tymin, tymax, tzmin, tzmax;
        const invdirx = 1 / this.direction.x, invdiry = 1 / this.direction.y, invdirz = 1 / this.direction.z;
        const origin = this.origin;
        if (invdirx >= 0) {
            tmin = (box.min.x - origin.x) * invdirx;
            tmax = (box.max.x - origin.x) * invdirx;
        } else {
            tmin = (box.max.x - origin.x) * invdirx;
            tmax = (box.min.x - origin.x) * invdirx;
        }
        if (invdiry >= 0) {
            tymin = (box.min.y - origin.y) * invdiry;
            tymax = (box.max.y - origin.y) * invdiry;
        } else {
            tymin = (box.max.y - origin.y) * invdiry;
            tymax = (box.min.y - origin.y) * invdiry;
        }
        if (tmin > tymax || tymin > tmax) return null;
        if (tymin > tmin || isNaN(tmin)) tmin = tymin;
        if (tymax < tmax || isNaN(tmax)) tmax = tymax;
        if (invdirz >= 0) {
            tzmin = (box.min.z - origin.z) * invdirz;
            tzmax = (box.max.z - origin.z) * invdirz;
        } else {
            tzmin = (box.max.z - origin.z) * invdirz;
            tzmax = (box.min.z - origin.z) * invdirz;
        }
        if (tmin > tzmax || tzmin > tmax) return null;
        if (tzmin > tmin || tmin !== tmin) tmin = tzmin;
        if (tzmax < tmax || tmax !== tmax) tmax = tzmax;
        //return point closest to the ray (positive side)
        if (tmax < 0) return null;
        return this.at(tmin >= 0 ? tmin : tmax, target);
    }
    intersectsBox(box) {
        return this.intersectBox(box, $d5b33d7c30034067$var$_vector$a) !== null;
    }
    intersectTriangle(a, b, c, backfaceCulling, target) {
        // Compute the offset origin, edges, and normal.
        // from https://github.com/pmjoniak/GeometricTools/blob/master/GTEngine/Include/Mathematics/GteIntrRay3Triangle3.h
        $d5b33d7c30034067$var$_edge1.subVectors(b, a);
        $d5b33d7c30034067$var$_edge2.subVectors(c, a);
        $d5b33d7c30034067$var$_normal$1.crossVectors($d5b33d7c30034067$var$_edge1, $d5b33d7c30034067$var$_edge2);
        // Solve Q + t*D = b1*E1 + b2*E2 (Q = kDiff, D = ray direction,
        // E1 = kEdge1, E2 = kEdge2, N = Cross(E1,E2)) by
        //   |Dot(D,N)|*b1 = sign(Dot(D,N))*Dot(D,Cross(Q,E2))
        //   |Dot(D,N)|*b2 = sign(Dot(D,N))*Dot(D,Cross(E1,Q))
        //   |Dot(D,N)|*t = -sign(Dot(D,N))*Dot(Q,N)
        let DdN = this.direction.dot($d5b33d7c30034067$var$_normal$1);
        let sign;
        if (DdN > 0) {
            if (backfaceCulling) return null;
            sign = 1;
        } else if (DdN < 0) {
            sign = -1;
            DdN = -DdN;
        } else return null;
        $d5b33d7c30034067$var$_diff.subVectors(this.origin, a);
        const DdQxE2 = sign * this.direction.dot($d5b33d7c30034067$var$_edge2.crossVectors($d5b33d7c30034067$var$_diff, $d5b33d7c30034067$var$_edge2));
        // b1 < 0, no intersection
        if (DdQxE2 < 0) return null;
        const DdE1xQ = sign * this.direction.dot($d5b33d7c30034067$var$_edge1.cross($d5b33d7c30034067$var$_diff));
        // b2 < 0, no intersection
        if (DdE1xQ < 0) return null;
        // b1+b2 > 1, no intersection
        if (DdQxE2 + DdE1xQ > DdN) return null;
        // Line intersects triangle, check if ray does.
        const QdN = -sign * $d5b33d7c30034067$var$_diff.dot($d5b33d7c30034067$var$_normal$1);
        // t < 0, no intersection
        if (QdN < 0) return null;
        // Ray intersects triangle.
        return this.at(QdN / DdN, target);
    }
    applyMatrix4(matrix4) {
        this.origin.applyMatrix4(matrix4);
        this.direction.transformDirection(matrix4);
        return this;
    }
    equals(ray) {
        return ray.origin.equals(this.origin) && ray.direction.equals(this.direction);
    }
    clone() {
        return new this.constructor().copy(this);
    }
}
class $d5b33d7c30034067$export$2ae72fc923e5eb5 {
    constructor(n11, n12, n13, n14, n21, n22, n23, n24, n31, n32, n33, n34, n41, n42, n43, n44){
        $d5b33d7c30034067$export$2ae72fc923e5eb5.prototype.isMatrix4 = true;
        this.elements = [
            1,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            0,
            1
        ];
        if (n11 !== undefined) this.set(n11, n12, n13, n14, n21, n22, n23, n24, n31, n32, n33, n34, n41, n42, n43, n44);
    }
    set(n11, n12, n13, n14, n21, n22, n23, n24, n31, n32, n33, n34, n41, n42, n43, n44) {
        const te = this.elements;
        te[0] = n11;
        te[4] = n12;
        te[8] = n13;
        te[12] = n14;
        te[1] = n21;
        te[5] = n22;
        te[9] = n23;
        te[13] = n24;
        te[2] = n31;
        te[6] = n32;
        te[10] = n33;
        te[14] = n34;
        te[3] = n41;
        te[7] = n42;
        te[11] = n43;
        te[15] = n44;
        return this;
    }
    identity() {
        this.set(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
        return this;
    }
    clone() {
        return new $d5b33d7c30034067$export$2ae72fc923e5eb5().fromArray(this.elements);
    }
    copy(m) {
        const te = this.elements;
        const me = m.elements;
        te[0] = me[0];
        te[1] = me[1];
        te[2] = me[2];
        te[3] = me[3];
        te[4] = me[4];
        te[5] = me[5];
        te[6] = me[6];
        te[7] = me[7];
        te[8] = me[8];
        te[9] = me[9];
        te[10] = me[10];
        te[11] = me[11];
        te[12] = me[12];
        te[13] = me[13];
        te[14] = me[14];
        te[15] = me[15];
        return this;
    }
    copyPosition(m) {
        const te = this.elements, me = m.elements;
        te[12] = me[12];
        te[13] = me[13];
        te[14] = me[14];
        return this;
    }
    setFromMatrix3(m) {
        const me = m.elements;
        this.set(me[0], me[3], me[6], 0, me[1], me[4], me[7], 0, me[2], me[5], me[8], 0, 0, 0, 0, 1);
        return this;
    }
    extractBasis(xAxis, yAxis, zAxis) {
        xAxis.setFromMatrixColumn(this, 0);
        yAxis.setFromMatrixColumn(this, 1);
        zAxis.setFromMatrixColumn(this, 2);
        return this;
    }
    makeBasis(xAxis, yAxis, zAxis) {
        this.set(xAxis.x, yAxis.x, zAxis.x, 0, xAxis.y, yAxis.y, zAxis.y, 0, xAxis.z, yAxis.z, zAxis.z, 0, 0, 0, 0, 1);
        return this;
    }
    extractRotation(m) {
        // this method does not support reflection matrices
        const te = this.elements;
        const me = m.elements;
        const scaleX = 1 / $d5b33d7c30034067$var$_v1$5.setFromMatrixColumn(m, 0).length();
        const scaleY = 1 / $d5b33d7c30034067$var$_v1$5.setFromMatrixColumn(m, 1).length();
        const scaleZ = 1 / $d5b33d7c30034067$var$_v1$5.setFromMatrixColumn(m, 2).length();
        te[0] = me[0] * scaleX;
        te[1] = me[1] * scaleX;
        te[2] = me[2] * scaleX;
        te[3] = 0;
        te[4] = me[4] * scaleY;
        te[5] = me[5] * scaleY;
        te[6] = me[6] * scaleY;
        te[7] = 0;
        te[8] = me[8] * scaleZ;
        te[9] = me[9] * scaleZ;
        te[10] = me[10] * scaleZ;
        te[11] = 0;
        te[12] = 0;
        te[13] = 0;
        te[14] = 0;
        te[15] = 1;
        return this;
    }
    makeRotationFromEuler(euler) {
        const te = this.elements;
        const x = euler.x, y = euler.y, z = euler.z;
        const a = Math.cos(x), b = Math.sin(x);
        const c = Math.cos(y), d = Math.sin(y);
        const e = Math.cos(z), f = Math.sin(z);
        if (euler.order === 'XYZ') {
            const ae = a * e, af = a * f, be = b * e, bf = b * f;
            te[0] = c * e;
            te[4] = -c * f;
            te[8] = d;
            te[1] = af + be * d;
            te[5] = ae - bf * d;
            te[9] = -b * c;
            te[2] = bf - ae * d;
            te[6] = be + af * d;
            te[10] = a * c;
        } else if (euler.order === 'YXZ') {
            const ce = c * e, cf = c * f, de = d * e, df = d * f;
            te[0] = ce + df * b;
            te[4] = de * b - cf;
            te[8] = a * d;
            te[1] = a * f;
            te[5] = a * e;
            te[9] = -b;
            te[2] = cf * b - de;
            te[6] = df + ce * b;
            te[10] = a * c;
        } else if (euler.order === 'ZXY') {
            const ce = c * e, cf = c * f, de = d * e, df = d * f;
            te[0] = ce - df * b;
            te[4] = -a * f;
            te[8] = de + cf * b;
            te[1] = cf + de * b;
            te[5] = a * e;
            te[9] = df - ce * b;
            te[2] = -a * d;
            te[6] = b;
            te[10] = a * c;
        } else if (euler.order === 'ZYX') {
            const ae = a * e, af = a * f, be = b * e, bf = b * f;
            te[0] = c * e;
            te[4] = be * d - af;
            te[8] = ae * d + bf;
            te[1] = c * f;
            te[5] = bf * d + ae;
            te[9] = af * d - be;
            te[2] = -d;
            te[6] = b * c;
            te[10] = a * c;
        } else if (euler.order === 'YZX') {
            const ac = a * c, ad = a * d, bc = b * c, bd = b * d;
            te[0] = c * e;
            te[4] = bd - ac * f;
            te[8] = bc * f + ad;
            te[1] = f;
            te[5] = a * e;
            te[9] = -b * e;
            te[2] = -d * e;
            te[6] = ad * f + bc;
            te[10] = ac - bd * f;
        } else if (euler.order === 'XZY') {
            const ac = a * c, ad = a * d, bc = b * c, bd = b * d;
            te[0] = c * e;
            te[4] = -f;
            te[8] = d * e;
            te[1] = ac * f + bd;
            te[5] = a * e;
            te[9] = ad * f - bc;
            te[2] = bc * f - ad;
            te[6] = b * e;
            te[10] = bd * f + ac;
        }
        // bottom row
        te[3] = 0;
        te[7] = 0;
        te[11] = 0;
        // last column
        te[12] = 0;
        te[13] = 0;
        te[14] = 0;
        te[15] = 1;
        return this;
    }
    makeRotationFromQuaternion(q) {
        return this.compose($d5b33d7c30034067$var$_zero, q, $d5b33d7c30034067$var$_one);
    }
    lookAt(eye, target, up) {
        const te = this.elements;
        $d5b33d7c30034067$var$_z.subVectors(eye, target);
        if ($d5b33d7c30034067$var$_z.lengthSq() === 0) // eye and target are in the same position
        $d5b33d7c30034067$var$_z.z = 1;
        $d5b33d7c30034067$var$_z.normalize();
        $d5b33d7c30034067$var$_x.crossVectors(up, $d5b33d7c30034067$var$_z);
        if ($d5b33d7c30034067$var$_x.lengthSq() === 0) {
            // up and z are parallel
            if (Math.abs(up.z) === 1) $d5b33d7c30034067$var$_z.x += 0.0001;
            else $d5b33d7c30034067$var$_z.z += 0.0001;
            $d5b33d7c30034067$var$_z.normalize();
            $d5b33d7c30034067$var$_x.crossVectors(up, $d5b33d7c30034067$var$_z);
        }
        $d5b33d7c30034067$var$_x.normalize();
        $d5b33d7c30034067$var$_y.crossVectors($d5b33d7c30034067$var$_z, $d5b33d7c30034067$var$_x);
        te[0] = $d5b33d7c30034067$var$_x.x;
        te[4] = $d5b33d7c30034067$var$_y.x;
        te[8] = $d5b33d7c30034067$var$_z.x;
        te[1] = $d5b33d7c30034067$var$_x.y;
        te[5] = $d5b33d7c30034067$var$_y.y;
        te[9] = $d5b33d7c30034067$var$_z.y;
        te[2] = $d5b33d7c30034067$var$_x.z;
        te[6] = $d5b33d7c30034067$var$_y.z;
        te[10] = $d5b33d7c30034067$var$_z.z;
        return this;
    }
    multiply(m) {
        return this.multiplyMatrices(this, m);
    }
    premultiply(m) {
        return this.multiplyMatrices(m, this);
    }
    multiplyMatrices(a, b) {
        const ae = a.elements;
        const be = b.elements;
        const te = this.elements;
        const a11 = ae[0], a12 = ae[4], a13 = ae[8], a14 = ae[12];
        const a21 = ae[1], a22 = ae[5], a23 = ae[9], a24 = ae[13];
        const a31 = ae[2], a32 = ae[6], a33 = ae[10], a34 = ae[14];
        const a41 = ae[3], a42 = ae[7], a43 = ae[11], a44 = ae[15];
        const b11 = be[0], b12 = be[4], b13 = be[8], b14 = be[12];
        const b21 = be[1], b22 = be[5], b23 = be[9], b24 = be[13];
        const b31 = be[2], b32 = be[6], b33 = be[10], b34 = be[14];
        const b41 = be[3], b42 = be[7], b43 = be[11], b44 = be[15];
        te[0] = a11 * b11 + a12 * b21 + a13 * b31 + a14 * b41;
        te[4] = a11 * b12 + a12 * b22 + a13 * b32 + a14 * b42;
        te[8] = a11 * b13 + a12 * b23 + a13 * b33 + a14 * b43;
        te[12] = a11 * b14 + a12 * b24 + a13 * b34 + a14 * b44;
        te[1] = a21 * b11 + a22 * b21 + a23 * b31 + a24 * b41;
        te[5] = a21 * b12 + a22 * b22 + a23 * b32 + a24 * b42;
        te[9] = a21 * b13 + a22 * b23 + a23 * b33 + a24 * b43;
        te[13] = a21 * b14 + a22 * b24 + a23 * b34 + a24 * b44;
        te[2] = a31 * b11 + a32 * b21 + a33 * b31 + a34 * b41;
        te[6] = a31 * b12 + a32 * b22 + a33 * b32 + a34 * b42;
        te[10] = a31 * b13 + a32 * b23 + a33 * b33 + a34 * b43;
        te[14] = a31 * b14 + a32 * b24 + a33 * b34 + a34 * b44;
        te[3] = a41 * b11 + a42 * b21 + a43 * b31 + a44 * b41;
        te[7] = a41 * b12 + a42 * b22 + a43 * b32 + a44 * b42;
        te[11] = a41 * b13 + a42 * b23 + a43 * b33 + a44 * b43;
        te[15] = a41 * b14 + a42 * b24 + a43 * b34 + a44 * b44;
        return this;
    }
    multiplyScalar(s) {
        const te = this.elements;
        te[0] *= s;
        te[4] *= s;
        te[8] *= s;
        te[12] *= s;
        te[1] *= s;
        te[5] *= s;
        te[9] *= s;
        te[13] *= s;
        te[2] *= s;
        te[6] *= s;
        te[10] *= s;
        te[14] *= s;
        te[3] *= s;
        te[7] *= s;
        te[11] *= s;
        te[15] *= s;
        return this;
    }
    determinant() {
        const te = this.elements;
        const n11 = te[0], n12 = te[4], n13 = te[8], n14 = te[12];
        const n21 = te[1], n22 = te[5], n23 = te[9], n24 = te[13];
        const n31 = te[2], n32 = te[6], n33 = te[10], n34 = te[14];
        const n41 = te[3], n42 = te[7], n43 = te[11], n44 = te[15];
        //TODO: make this more efficient
        //( based on http://www.euclideanspace.com/maths/algebra/matrix/functions/inverse/fourD/index.htm )
        return n41 * (+n14 * n23 * n32 - n13 * n24 * n32 - n14 * n22 * n33 + n12 * n24 * n33 + n13 * n22 * n34 - n12 * n23 * n34) + n42 * (+n11 * n23 * n34 - n11 * n24 * n33 + n14 * n21 * n33 - n13 * n21 * n34 + n13 * n24 * n31 - n14 * n23 * n31) + n43 * (+n11 * n24 * n32 - n11 * n22 * n34 - n14 * n21 * n32 + n12 * n21 * n34 + n14 * n22 * n31 - n12 * n24 * n31) + n44 * (-n13 * n22 * n31 - n11 * n23 * n32 + n11 * n22 * n33 + n13 * n21 * n32 - n12 * n21 * n33 + n12 * n23 * n31);
    }
    transpose() {
        const te = this.elements;
        let tmp;
        tmp = te[1];
        te[1] = te[4];
        te[4] = tmp;
        tmp = te[2];
        te[2] = te[8];
        te[8] = tmp;
        tmp = te[6];
        te[6] = te[9];
        te[9] = tmp;
        tmp = te[3];
        te[3] = te[12];
        te[12] = tmp;
        tmp = te[7];
        te[7] = te[13];
        te[13] = tmp;
        tmp = te[11];
        te[11] = te[14];
        te[14] = tmp;
        return this;
    }
    setPosition(x, y, z) {
        const te = this.elements;
        if (x.isVector3) {
            te[12] = x.x;
            te[13] = x.y;
            te[14] = x.z;
        } else {
            te[12] = x;
            te[13] = y;
            te[14] = z;
        }
        return this;
    }
    invert() {
        // based on http://www.euclideanspace.com/maths/algebra/matrix/functions/inverse/fourD/index.htm
        const te = this.elements, n11 = te[0], n21 = te[1], n31 = te[2], n41 = te[3], n12 = te[4], n22 = te[5], n32 = te[6], n42 = te[7], n13 = te[8], n23 = te[9], n33 = te[10], n43 = te[11], n14 = te[12], n24 = te[13], n34 = te[14], n44 = te[15], t11 = n23 * n34 * n42 - n24 * n33 * n42 + n24 * n32 * n43 - n22 * n34 * n43 - n23 * n32 * n44 + n22 * n33 * n44, t12 = n14 * n33 * n42 - n13 * n34 * n42 - n14 * n32 * n43 + n12 * n34 * n43 + n13 * n32 * n44 - n12 * n33 * n44, t13 = n13 * n24 * n42 - n14 * n23 * n42 + n14 * n22 * n43 - n12 * n24 * n43 - n13 * n22 * n44 + n12 * n23 * n44, t14 = n14 * n23 * n32 - n13 * n24 * n32 - n14 * n22 * n33 + n12 * n24 * n33 + n13 * n22 * n34 - n12 * n23 * n34;
        const det = n11 * t11 + n21 * t12 + n31 * t13 + n41 * t14;
        if (det === 0) return this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
        const detInv = 1 / det;
        te[0] = t11 * detInv;
        te[1] = (n24 * n33 * n41 - n23 * n34 * n41 - n24 * n31 * n43 + n21 * n34 * n43 + n23 * n31 * n44 - n21 * n33 * n44) * detInv;
        te[2] = (n22 * n34 * n41 - n24 * n32 * n41 + n24 * n31 * n42 - n21 * n34 * n42 - n22 * n31 * n44 + n21 * n32 * n44) * detInv;
        te[3] = (n23 * n32 * n41 - n22 * n33 * n41 - n23 * n31 * n42 + n21 * n33 * n42 + n22 * n31 * n43 - n21 * n32 * n43) * detInv;
        te[4] = t12 * detInv;
        te[5] = (n13 * n34 * n41 - n14 * n33 * n41 + n14 * n31 * n43 - n11 * n34 * n43 - n13 * n31 * n44 + n11 * n33 * n44) * detInv;
        te[6] = (n14 * n32 * n41 - n12 * n34 * n41 - n14 * n31 * n42 + n11 * n34 * n42 + n12 * n31 * n44 - n11 * n32 * n44) * detInv;
        te[7] = (n12 * n33 * n41 - n13 * n32 * n41 + n13 * n31 * n42 - n11 * n33 * n42 - n12 * n31 * n43 + n11 * n32 * n43) * detInv;
        te[8] = t13 * detInv;
        te[9] = (n14 * n23 * n41 - n13 * n24 * n41 - n14 * n21 * n43 + n11 * n24 * n43 + n13 * n21 * n44 - n11 * n23 * n44) * detInv;
        te[10] = (n12 * n24 * n41 - n14 * n22 * n41 + n14 * n21 * n42 - n11 * n24 * n42 - n12 * n21 * n44 + n11 * n22 * n44) * detInv;
        te[11] = (n13 * n22 * n41 - n12 * n23 * n41 - n13 * n21 * n42 + n11 * n23 * n42 + n12 * n21 * n43 - n11 * n22 * n43) * detInv;
        te[12] = t14 * detInv;
        te[13] = (n13 * n24 * n31 - n14 * n23 * n31 + n14 * n21 * n33 - n11 * n24 * n33 - n13 * n21 * n34 + n11 * n23 * n34) * detInv;
        te[14] = (n14 * n22 * n31 - n12 * n24 * n31 - n14 * n21 * n32 + n11 * n24 * n32 + n12 * n21 * n34 - n11 * n22 * n34) * detInv;
        te[15] = (n12 * n23 * n31 - n13 * n22 * n31 + n13 * n21 * n32 - n11 * n23 * n32 - n12 * n21 * n33 + n11 * n22 * n33) * detInv;
        return this;
    }
    scale(v) {
        const te = this.elements;
        const x = v.x, y = v.y, z = v.z;
        te[0] *= x;
        te[4] *= y;
        te[8] *= z;
        te[1] *= x;
        te[5] *= y;
        te[9] *= z;
        te[2] *= x;
        te[6] *= y;
        te[10] *= z;
        te[3] *= x;
        te[7] *= y;
        te[11] *= z;
        return this;
    }
    getMaxScaleOnAxis() {
        const te = this.elements;
        const scaleXSq = te[0] * te[0] + te[1] * te[1] + te[2] * te[2];
        const scaleYSq = te[4] * te[4] + te[5] * te[5] + te[6] * te[6];
        const scaleZSq = te[8] * te[8] + te[9] * te[9] + te[10] * te[10];
        return Math.sqrt(Math.max(scaleXSq, scaleYSq, scaleZSq));
    }
    makeTranslation(x, y, z) {
        if (x.isVector3) this.set(1, 0, 0, x.x, 0, 1, 0, x.y, 0, 0, 1, x.z, 0, 0, 0, 1);
        else this.set(1, 0, 0, x, 0, 1, 0, y, 0, 0, 1, z, 0, 0, 0, 1);
        return this;
    }
    makeRotationX(theta) {
        const c = Math.cos(theta), s = Math.sin(theta);
        this.set(1, 0, 0, 0, 0, c, -s, 0, 0, s, c, 0, 0, 0, 0, 1);
        return this;
    }
    makeRotationY(theta) {
        const c = Math.cos(theta), s = Math.sin(theta);
        this.set(c, 0, s, 0, 0, 1, 0, 0, -s, 0, c, 0, 0, 0, 0, 1);
        return this;
    }
    makeRotationZ(theta) {
        const c = Math.cos(theta), s = Math.sin(theta);
        this.set(c, -s, 0, 0, s, c, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
        return this;
    }
    makeRotationAxis(axis, angle) {
        // Based on http://www.gamedev.net/reference/articles/article1199.asp
        const c = Math.cos(angle);
        const s = Math.sin(angle);
        const t = 1 - c;
        const x = axis.x, y = axis.y, z = axis.z;
        const tx = t * x, ty = t * y;
        this.set(tx * x + c, tx * y - s * z, tx * z + s * y, 0, tx * y + s * z, ty * y + c, ty * z - s * x, 0, tx * z - s * y, ty * z + s * x, t * z * z + c, 0, 0, 0, 0, 1);
        return this;
    }
    makeScale(x, y, z) {
        this.set(x, 0, 0, 0, 0, y, 0, 0, 0, 0, z, 0, 0, 0, 0, 1);
        return this;
    }
    makeShear(xy, xz, yx, yz, zx, zy) {
        this.set(1, yx, zx, 0, xy, 1, zy, 0, xz, yz, 1, 0, 0, 0, 0, 1);
        return this;
    }
    compose(position, quaternion, scale) {
        const te = this.elements;
        const x = quaternion._x, y = quaternion._y, z = quaternion._z, w = quaternion._w;
        const x2 = x + x, y2 = y + y, z2 = z + z;
        const xx = x * x2, xy = x * y2, xz = x * z2;
        const yy = y * y2, yz = y * z2, zz = z * z2;
        const wx = w * x2, wy = w * y2, wz = w * z2;
        const sx = scale.x, sy = scale.y, sz = scale.z;
        te[0] = (1 - (yy + zz)) * sx;
        te[1] = (xy + wz) * sx;
        te[2] = (xz - wy) * sx;
        te[3] = 0;
        te[4] = (xy - wz) * sy;
        te[5] = (1 - (xx + zz)) * sy;
        te[6] = (yz + wx) * sy;
        te[7] = 0;
        te[8] = (xz + wy) * sz;
        te[9] = (yz - wx) * sz;
        te[10] = (1 - (xx + yy)) * sz;
        te[11] = 0;
        te[12] = position.x;
        te[13] = position.y;
        te[14] = position.z;
        te[15] = 1;
        return this;
    }
    decompose(position, quaternion, scale) {
        const te = this.elements;
        let sx = $d5b33d7c30034067$var$_v1$5.set(te[0], te[1], te[2]).length();
        const sy = $d5b33d7c30034067$var$_v1$5.set(te[4], te[5], te[6]).length();
        const sz = $d5b33d7c30034067$var$_v1$5.set(te[8], te[9], te[10]).length();
        // if determine is negative, we need to invert one scale
        const det = this.determinant();
        if (det < 0) sx = -sx;
        position.x = te[12];
        position.y = te[13];
        position.z = te[14];
        // scale the rotation part
        $d5b33d7c30034067$var$_m1$4.copy(this);
        const invSX = 1 / sx;
        const invSY = 1 / sy;
        const invSZ = 1 / sz;
        $d5b33d7c30034067$var$_m1$4.elements[0] *= invSX;
        $d5b33d7c30034067$var$_m1$4.elements[1] *= invSX;
        $d5b33d7c30034067$var$_m1$4.elements[2] *= invSX;
        $d5b33d7c30034067$var$_m1$4.elements[4] *= invSY;
        $d5b33d7c30034067$var$_m1$4.elements[5] *= invSY;
        $d5b33d7c30034067$var$_m1$4.elements[6] *= invSY;
        $d5b33d7c30034067$var$_m1$4.elements[8] *= invSZ;
        $d5b33d7c30034067$var$_m1$4.elements[9] *= invSZ;
        $d5b33d7c30034067$var$_m1$4.elements[10] *= invSZ;
        quaternion.setFromRotationMatrix($d5b33d7c30034067$var$_m1$4);
        scale.x = sx;
        scale.y = sy;
        scale.z = sz;
        return this;
    }
    makePerspective(left, right, top, bottom, near, far, coordinateSystem = $d5b33d7c30034067$export$5a0e9190d10875d3) {
        const te = this.elements;
        const x = 2 * near / (right - left);
        const y = 2 * near / (top - bottom);
        const a = (right + left) / (right - left);
        const b = (top + bottom) / (top - bottom);
        let c, d;
        if (coordinateSystem === $d5b33d7c30034067$export$5a0e9190d10875d3) {
            c = -(far + near) / (far - near);
            d = -2 * far * near / (far - near);
        } else if (coordinateSystem === $d5b33d7c30034067$export$cc83beedcb9be9ac) {
            c = -far / (far - near);
            d = -far * near / (far - near);
        } else throw new Error('THREE.Matrix4.makePerspective(): Invalid coordinate system: ' + coordinateSystem);
        te[0] = x;
        te[4] = 0;
        te[8] = a;
        te[12] = 0;
        te[1] = 0;
        te[5] = y;
        te[9] = b;
        te[13] = 0;
        te[2] = 0;
        te[6] = 0;
        te[10] = c;
        te[14] = d;
        te[3] = 0;
        te[7] = 0;
        te[11] = -1;
        te[15] = 0;
        return this;
    }
    makeOrthographic(left, right, top, bottom, near, far, coordinateSystem = $d5b33d7c30034067$export$5a0e9190d10875d3) {
        const te = this.elements;
        const w = 1.0 / (right - left);
        const h = 1.0 / (top - bottom);
        const p = 1.0 / (far - near);
        const x = (right + left) * w;
        const y = (top + bottom) * h;
        let z, zInv;
        if (coordinateSystem === $d5b33d7c30034067$export$5a0e9190d10875d3) {
            z = (far + near) * p;
            zInv = -2 * p;
        } else if (coordinateSystem === $d5b33d7c30034067$export$cc83beedcb9be9ac) {
            z = near * p;
            zInv = -1 * p;
        } else throw new Error('THREE.Matrix4.makeOrthographic(): Invalid coordinate system: ' + coordinateSystem);
        te[0] = 2 * w;
        te[4] = 0;
        te[8] = 0;
        te[12] = -x;
        te[1] = 0;
        te[5] = 2 * h;
        te[9] = 0;
        te[13] = -y;
        te[2] = 0;
        te[6] = 0;
        te[10] = zInv;
        te[14] = -z;
        te[3] = 0;
        te[7] = 0;
        te[11] = 0;
        te[15] = 1;
        return this;
    }
    equals(matrix) {
        const te = this.elements;
        const me = matrix.elements;
        for(let i = 0; i < 16; i++){
            if (te[i] !== me[i]) return false;
        }
        return true;
    }
    fromArray(array, offset = 0) {
        for(let i = 0; i < 16; i++)this.elements[i] = array[i + offset];
        return this;
    }
    toArray(array = [], offset = 0) {
        const te = this.elements;
        array[offset] = te[0];
        array[offset + 1] = te[1];
        array[offset + 2] = te[2];
        array[offset + 3] = te[3];
        array[offset + 4] = te[4];
        array[offset + 5] = te[5];
        array[offset + 6] = te[6];
        array[offset + 7] = te[7];
        array[offset + 8] = te[8];
        array[offset + 9] = te[9];
        array[offset + 10] = te[10];
        array[offset + 11] = te[11];
        array[offset + 12] = te[12];
        array[offset + 13] = te[13];
        array[offset + 14] = te[14];
        array[offset + 15] = te[15];
        return array;
    }
}
const $d5b33d7c30034067$var$_v1$5 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_m1$4 = /*@__PURE__*/ new $d5b33d7c30034067$export$2ae72fc923e5eb5();
const $d5b33d7c30034067$var$_zero = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699(0, 0, 0);
const $d5b33d7c30034067$var$_one = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699(1, 1, 1);
const $d5b33d7c30034067$var$_x = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_y = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_z = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_matrix$2 = /*@__PURE__*/ new $d5b33d7c30034067$export$2ae72fc923e5eb5();
const $d5b33d7c30034067$var$_quaternion$3 = /*@__PURE__*/ new $d5b33d7c30034067$export$23d6a54f0bbc85a3();
class $d5b33d7c30034067$export$d93cc409a0768c5f {
    constructor(x = 0, y = 0, z = 0, order = $d5b33d7c30034067$export$d93cc409a0768c5f.DEFAULT_ORDER){
        this.isEuler = true;
        this._x = x;
        this._y = y;
        this._z = z;
        this._order = order;
    }
    get x() {
        return this._x;
    }
    set x(value) {
        this._x = value;
        this._onChangeCallback();
    }
    get y() {
        return this._y;
    }
    set y(value) {
        this._y = value;
        this._onChangeCallback();
    }
    get z() {
        return this._z;
    }
    set z(value) {
        this._z = value;
        this._onChangeCallback();
    }
    get order() {
        return this._order;
    }
    set order(value) {
        this._order = value;
        this._onChangeCallback();
    }
    set(x, y, z, order = this._order) {
        this._x = x;
        this._y = y;
        this._z = z;
        this._order = order;
        this._onChangeCallback();
        return this;
    }
    clone() {
        return new this.constructor(this._x, this._y, this._z, this._order);
    }
    copy(euler) {
        this._x = euler._x;
        this._y = euler._y;
        this._z = euler._z;
        this._order = euler._order;
        this._onChangeCallback();
        return this;
    }
    setFromRotationMatrix(m, order = this._order, update = true) {
        // assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)
        const te = m.elements;
        const m11 = te[0], m12 = te[4], m13 = te[8];
        const m21 = te[1], m22 = te[5], m23 = te[9];
        const m31 = te[2], m32 = te[6], m33 = te[10];
        switch(order){
            case 'XYZ':
                this._y = Math.asin($d5b33d7c30034067$var$clamp(m13, -1, 1));
                if (Math.abs(m13) < 0.9999999) {
                    this._x = Math.atan2(-m23, m33);
                    this._z = Math.atan2(-m12, m11);
                } else {
                    this._x = Math.atan2(m32, m22);
                    this._z = 0;
                }
                break;
            case 'YXZ':
                this._x = Math.asin(-$d5b33d7c30034067$var$clamp(m23, -1, 1));
                if (Math.abs(m23) < 0.9999999) {
                    this._y = Math.atan2(m13, m33);
                    this._z = Math.atan2(m21, m22);
                } else {
                    this._y = Math.atan2(-m31, m11);
                    this._z = 0;
                }
                break;
            case 'ZXY':
                this._x = Math.asin($d5b33d7c30034067$var$clamp(m32, -1, 1));
                if (Math.abs(m32) < 0.9999999) {
                    this._y = Math.atan2(-m31, m33);
                    this._z = Math.atan2(-m12, m22);
                } else {
                    this._y = 0;
                    this._z = Math.atan2(m21, m11);
                }
                break;
            case 'ZYX':
                this._y = Math.asin(-$d5b33d7c30034067$var$clamp(m31, -1, 1));
                if (Math.abs(m31) < 0.9999999) {
                    this._x = Math.atan2(m32, m33);
                    this._z = Math.atan2(m21, m11);
                } else {
                    this._x = 0;
                    this._z = Math.atan2(-m12, m22);
                }
                break;
            case 'YZX':
                this._z = Math.asin($d5b33d7c30034067$var$clamp(m21, -1, 1));
                if (Math.abs(m21) < 0.9999999) {
                    this._x = Math.atan2(-m23, m22);
                    this._y = Math.atan2(-m31, m11);
                } else {
                    this._x = 0;
                    this._y = Math.atan2(m13, m33);
                }
                break;
            case 'XZY':
                this._z = Math.asin(-$d5b33d7c30034067$var$clamp(m12, -1, 1));
                if (Math.abs(m12) < 0.9999999) {
                    this._x = Math.atan2(m32, m22);
                    this._y = Math.atan2(m13, m11);
                } else {
                    this._x = Math.atan2(-m23, m33);
                    this._y = 0;
                }
                break;
            default:
                console.warn('THREE.Euler: .setFromRotationMatrix() encountered an unknown order: ' + order);
        }
        this._order = order;
        if (update === true) this._onChangeCallback();
        return this;
    }
    setFromQuaternion(q, order, update) {
        $d5b33d7c30034067$var$_matrix$2.makeRotationFromQuaternion(q);
        return this.setFromRotationMatrix($d5b33d7c30034067$var$_matrix$2, order, update);
    }
    setFromVector3(v, order = this._order) {
        return this.set(v.x, v.y, v.z, order);
    }
    reorder(newOrder) {
        // WARNING: this discards revolution information -bhouston
        $d5b33d7c30034067$var$_quaternion$3.setFromEuler(this);
        return this.setFromQuaternion($d5b33d7c30034067$var$_quaternion$3, newOrder);
    }
    equals(euler) {
        return euler._x === this._x && euler._y === this._y && euler._z === this._z && euler._order === this._order;
    }
    fromArray(array) {
        this._x = array[0];
        this._y = array[1];
        this._z = array[2];
        if (array[3] !== undefined) this._order = array[3];
        this._onChangeCallback();
        return this;
    }
    toArray(array = [], offset = 0) {
        array[offset] = this._x;
        array[offset + 1] = this._y;
        array[offset + 2] = this._z;
        array[offset + 3] = this._order;
        return array;
    }
    _onChange(callback) {
        this._onChangeCallback = callback;
        return this;
    }
    _onChangeCallback() {}
    *[Symbol.iterator]() {
        yield this._x;
        yield this._y;
        yield this._z;
        yield this._order;
    }
}
$d5b33d7c30034067$export$d93cc409a0768c5f.DEFAULT_ORDER = 'XYZ';
class $d5b33d7c30034067$export$89312ce47c0ca777 {
    constructor(){
        this.mask = 1;
    }
    set(channel) {
        this.mask = (1 << channel | 0) >>> 0;
    }
    enable(channel) {
        this.mask |= 1 << channel | 0;
    }
    enableAll() {
        this.mask = -1;
    }
    toggle(channel) {
        this.mask ^= 1 << channel | 0;
    }
    disable(channel) {
        this.mask &= ~(1 << channel | 0);
    }
    disableAll() {
        this.mask = 0;
    }
    test(layers) {
        return (this.mask & layers.mask) !== 0;
    }
    isEnabled(channel) {
        return (this.mask & (1 << channel | 0)) !== 0;
    }
}
let $d5b33d7c30034067$var$_object3DId = 0;
const $d5b33d7c30034067$var$_v1$4 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_q1 = /*@__PURE__*/ new $d5b33d7c30034067$export$23d6a54f0bbc85a3();
const $d5b33d7c30034067$var$_m1$3 = /*@__PURE__*/ new $d5b33d7c30034067$export$2ae72fc923e5eb5();
const $d5b33d7c30034067$var$_target = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_position$3 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_scale$2 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_quaternion$2 = /*@__PURE__*/ new $d5b33d7c30034067$export$23d6a54f0bbc85a3();
const $d5b33d7c30034067$var$_xAxis = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699(1, 0, 0);
const $d5b33d7c30034067$var$_yAxis = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699(0, 1, 0);
const $d5b33d7c30034067$var$_zAxis = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699(0, 0, 1);
const $d5b33d7c30034067$var$_addedEvent = {
    type: 'added'
};
const $d5b33d7c30034067$var$_removedEvent = {
    type: 'removed'
};
const $d5b33d7c30034067$var$_childaddedEvent = {
    type: 'childadded',
    child: null
};
const $d5b33d7c30034067$var$_childremovedEvent = {
    type: 'childremoved',
    child: null
};
class $d5b33d7c30034067$export$e4dd07dff30cc924 extends $d5b33d7c30034067$export$ec8b666c5fe2c75a {
    constructor(){
        super();
        this.isObject3D = true;
        Object.defineProperty(this, 'id', {
            value: $d5b33d7c30034067$var$_object3DId++
        });
        this.uuid = $d5b33d7c30034067$var$generateUUID();
        this.name = '';
        this.type = 'Object3D';
        this.parent = null;
        this.children = [];
        this.up = $d5b33d7c30034067$export$e4dd07dff30cc924.DEFAULT_UP.clone();
        const position = new $d5b33d7c30034067$export$64b5c384219d3699();
        const rotation = new $d5b33d7c30034067$export$d93cc409a0768c5f();
        const quaternion = new $d5b33d7c30034067$export$23d6a54f0bbc85a3();
        const scale = new $d5b33d7c30034067$export$64b5c384219d3699(1, 1, 1);
        function onRotationChange() {
            quaternion.setFromEuler(rotation, false);
        }
        function onQuaternionChange() {
            rotation.setFromQuaternion(quaternion, undefined, false);
        }
        rotation._onChange(onRotationChange);
        quaternion._onChange(onQuaternionChange);
        Object.defineProperties(this, {
            position: {
                configurable: true,
                enumerable: true,
                value: position
            },
            rotation: {
                configurable: true,
                enumerable: true,
                value: rotation
            },
            quaternion: {
                configurable: true,
                enumerable: true,
                value: quaternion
            },
            scale: {
                configurable: true,
                enumerable: true,
                value: scale
            },
            modelViewMatrix: {
                value: new $d5b33d7c30034067$export$2ae72fc923e5eb5()
            },
            normalMatrix: {
                value: new $d5b33d7c30034067$export$8ff26dafa08918()
            }
        });
        this.matrix = new $d5b33d7c30034067$export$2ae72fc923e5eb5();
        this.matrixWorld = new $d5b33d7c30034067$export$2ae72fc923e5eb5();
        this.matrixAutoUpdate = $d5b33d7c30034067$export$e4dd07dff30cc924.DEFAULT_MATRIX_AUTO_UPDATE;
        this.matrixWorldAutoUpdate = $d5b33d7c30034067$export$e4dd07dff30cc924.DEFAULT_MATRIX_WORLD_AUTO_UPDATE; // checked by the renderer
        this.matrixWorldNeedsUpdate = false;
        this.layers = new $d5b33d7c30034067$export$89312ce47c0ca777();
        this.visible = true;
        this.castShadow = false;
        this.receiveShadow = false;
        this.frustumCulled = true;
        this.renderOrder = 0;
        this.animations = [];
        this.userData = {};
    }
    onBeforeShadow() {}
    onAfterShadow() {}
    onBeforeRender() {}
    onAfterRender() {}
    applyMatrix4(matrix) {
        if (this.matrixAutoUpdate) this.updateMatrix();
        this.matrix.premultiply(matrix);
        this.matrix.decompose(this.position, this.quaternion, this.scale);
    }
    applyQuaternion(q) {
        this.quaternion.premultiply(q);
        return this;
    }
    setRotationFromAxisAngle(axis, angle) {
        // assumes axis is normalized
        this.quaternion.setFromAxisAngle(axis, angle);
    }
    setRotationFromEuler(euler) {
        this.quaternion.setFromEuler(euler, true);
    }
    setRotationFromMatrix(m) {
        // assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)
        this.quaternion.setFromRotationMatrix(m);
    }
    setRotationFromQuaternion(q) {
        // assumes q is normalized
        this.quaternion.copy(q);
    }
    rotateOnAxis(axis, angle) {
        // rotate object on axis in object space
        // axis is assumed to be normalized
        $d5b33d7c30034067$var$_q1.setFromAxisAngle(axis, angle);
        this.quaternion.multiply($d5b33d7c30034067$var$_q1);
        return this;
    }
    rotateOnWorldAxis(axis, angle) {
        // rotate object on axis in world space
        // axis is assumed to be normalized
        // method assumes no rotated parent
        $d5b33d7c30034067$var$_q1.setFromAxisAngle(axis, angle);
        this.quaternion.premultiply($d5b33d7c30034067$var$_q1);
        return this;
    }
    rotateX(angle) {
        return this.rotateOnAxis($d5b33d7c30034067$var$_xAxis, angle);
    }
    rotateY(angle) {
        return this.rotateOnAxis($d5b33d7c30034067$var$_yAxis, angle);
    }
    rotateZ(angle) {
        return this.rotateOnAxis($d5b33d7c30034067$var$_zAxis, angle);
    }
    translateOnAxis(axis, distance) {
        // translate object by distance along axis in object space
        // axis is assumed to be normalized
        $d5b33d7c30034067$var$_v1$4.copy(axis).applyQuaternion(this.quaternion);
        this.position.add($d5b33d7c30034067$var$_v1$4.multiplyScalar(distance));
        return this;
    }
    translateX(distance) {
        return this.translateOnAxis($d5b33d7c30034067$var$_xAxis, distance);
    }
    translateY(distance) {
        return this.translateOnAxis($d5b33d7c30034067$var$_yAxis, distance);
    }
    translateZ(distance) {
        return this.translateOnAxis($d5b33d7c30034067$var$_zAxis, distance);
    }
    localToWorld(vector) {
        this.updateWorldMatrix(true, false);
        return vector.applyMatrix4(this.matrixWorld);
    }
    worldToLocal(vector) {
        this.updateWorldMatrix(true, false);
        return vector.applyMatrix4($d5b33d7c30034067$var$_m1$3.copy(this.matrixWorld).invert());
    }
    lookAt(x, y, z) {
        // This method does not support objects having non-uniformly-scaled parent(s)
        if (x.isVector3) $d5b33d7c30034067$var$_target.copy(x);
        else $d5b33d7c30034067$var$_target.set(x, y, z);
        const parent = this.parent;
        this.updateWorldMatrix(true, false);
        $d5b33d7c30034067$var$_position$3.setFromMatrixPosition(this.matrixWorld);
        if (this.isCamera || this.isLight) $d5b33d7c30034067$var$_m1$3.lookAt($d5b33d7c30034067$var$_position$3, $d5b33d7c30034067$var$_target, this.up);
        else $d5b33d7c30034067$var$_m1$3.lookAt($d5b33d7c30034067$var$_target, $d5b33d7c30034067$var$_position$3, this.up);
        this.quaternion.setFromRotationMatrix($d5b33d7c30034067$var$_m1$3);
        if (parent) {
            $d5b33d7c30034067$var$_m1$3.extractRotation(parent.matrixWorld);
            $d5b33d7c30034067$var$_q1.setFromRotationMatrix($d5b33d7c30034067$var$_m1$3);
            this.quaternion.premultiply($d5b33d7c30034067$var$_q1.invert());
        }
    }
    add(object) {
        if (arguments.length > 1) {
            for(let i = 0; i < arguments.length; i++)this.add(arguments[i]);
            return this;
        }
        if (object === this) {
            console.error('THREE.Object3D.add: object can\'t be added as a child of itself.', object);
            return this;
        }
        if (object && object.isObject3D) {
            object.removeFromParent();
            object.parent = this;
            this.children.push(object);
            object.dispatchEvent($d5b33d7c30034067$var$_addedEvent);
            $d5b33d7c30034067$var$_childaddedEvent.child = object;
            this.dispatchEvent($d5b33d7c30034067$var$_childaddedEvent);
            $d5b33d7c30034067$var$_childaddedEvent.child = null;
        } else console.error('THREE.Object3D.add: object not an instance of THREE.Object3D.', object);
        return this;
    }
    remove(object) {
        if (arguments.length > 1) {
            for(let i = 0; i < arguments.length; i++)this.remove(arguments[i]);
            return this;
        }
        const index = this.children.indexOf(object);
        if (index !== -1) {
            object.parent = null;
            this.children.splice(index, 1);
            object.dispatchEvent($d5b33d7c30034067$var$_removedEvent);
            $d5b33d7c30034067$var$_childremovedEvent.child = object;
            this.dispatchEvent($d5b33d7c30034067$var$_childremovedEvent);
            $d5b33d7c30034067$var$_childremovedEvent.child = null;
        }
        return this;
    }
    removeFromParent() {
        const parent = this.parent;
        if (parent !== null) parent.remove(this);
        return this;
    }
    clear() {
        return this.remove(...this.children);
    }
    attach(object) {
        // adds object as a child of this, while maintaining the object's world transform
        // Note: This method does not support scene graphs having non-uniformly-scaled nodes(s)
        this.updateWorldMatrix(true, false);
        $d5b33d7c30034067$var$_m1$3.copy(this.matrixWorld).invert();
        if (object.parent !== null) {
            object.parent.updateWorldMatrix(true, false);
            $d5b33d7c30034067$var$_m1$3.multiply(object.parent.matrixWorld);
        }
        object.applyMatrix4($d5b33d7c30034067$var$_m1$3);
        object.removeFromParent();
        object.parent = this;
        this.children.push(object);
        object.updateWorldMatrix(false, true);
        object.dispatchEvent($d5b33d7c30034067$var$_addedEvent);
        $d5b33d7c30034067$var$_childaddedEvent.child = object;
        this.dispatchEvent($d5b33d7c30034067$var$_childaddedEvent);
        $d5b33d7c30034067$var$_childaddedEvent.child = null;
        return this;
    }
    getObjectById(id) {
        return this.getObjectByProperty('id', id);
    }
    getObjectByName(name) {
        return this.getObjectByProperty('name', name);
    }
    getObjectByProperty(name, value) {
        if (this[name] === value) return this;
        for(let i = 0, l = this.children.length; i < l; i++){
            const child = this.children[i];
            const object = child.getObjectByProperty(name, value);
            if (object !== undefined) return object;
        }
        return undefined;
    }
    getObjectsByProperty(name, value, result = []) {
        if (this[name] === value) result.push(this);
        const children = this.children;
        for(let i = 0, l = children.length; i < l; i++)children[i].getObjectsByProperty(name, value, result);
        return result;
    }
    getWorldPosition(target) {
        this.updateWorldMatrix(true, false);
        return target.setFromMatrixPosition(this.matrixWorld);
    }
    getWorldQuaternion(target) {
        this.updateWorldMatrix(true, false);
        this.matrixWorld.decompose($d5b33d7c30034067$var$_position$3, target, $d5b33d7c30034067$var$_scale$2);
        return target;
    }
    getWorldScale(target) {
        this.updateWorldMatrix(true, false);
        this.matrixWorld.decompose($d5b33d7c30034067$var$_position$3, $d5b33d7c30034067$var$_quaternion$2, target);
        return target;
    }
    getWorldDirection(target) {
        this.updateWorldMatrix(true, false);
        const e = this.matrixWorld.elements;
        return target.set(e[8], e[9], e[10]).normalize();
    }
    raycast() {}
    traverse(callback) {
        callback(this);
        const children = this.children;
        for(let i = 0, l = children.length; i < l; i++)children[i].traverse(callback);
    }
    traverseVisible(callback) {
        if (this.visible === false) return;
        callback(this);
        const children = this.children;
        for(let i = 0, l = children.length; i < l; i++)children[i].traverseVisible(callback);
    }
    traverseAncestors(callback) {
        const parent = this.parent;
        if (parent !== null) {
            callback(parent);
            parent.traverseAncestors(callback);
        }
    }
    updateMatrix() {
        this.matrix.compose(this.position, this.quaternion, this.scale);
        this.matrixWorldNeedsUpdate = true;
    }
    updateMatrixWorld(force) {
        if (this.matrixAutoUpdate) this.updateMatrix();
        if (this.matrixWorldNeedsUpdate || force) {
            if (this.matrixWorldAutoUpdate === true) {
                if (this.parent === null) this.matrixWorld.copy(this.matrix);
                else this.matrixWorld.multiplyMatrices(this.parent.matrixWorld, this.matrix);
            }
            this.matrixWorldNeedsUpdate = false;
            force = true;
        }
        // make sure descendants are updated if required
        const children = this.children;
        for(let i = 0, l = children.length; i < l; i++){
            const child = children[i];
            child.updateMatrixWorld(force);
        }
    }
    updateWorldMatrix(updateParents, updateChildren) {
        const parent = this.parent;
        if (updateParents === true && parent !== null) parent.updateWorldMatrix(true, false);
        if (this.matrixAutoUpdate) this.updateMatrix();
        if (this.matrixWorldAutoUpdate === true) {
            if (this.parent === null) this.matrixWorld.copy(this.matrix);
            else this.matrixWorld.multiplyMatrices(this.parent.matrixWorld, this.matrix);
        }
        // make sure descendants are updated
        if (updateChildren === true) {
            const children = this.children;
            for(let i = 0, l = children.length; i < l; i++){
                const child = children[i];
                child.updateWorldMatrix(false, true);
            }
        }
    }
    toJSON(meta) {
        // meta is a string when called from JSON.stringify
        const isRootObject = meta === undefined || typeof meta === 'string';
        const output = {};
        // meta is a hash used to collect geometries, materials.
        // not providing it implies that this is the root object
        // being serialized.
        if (isRootObject) {
            // initialize meta obj
            meta = {
                geometries: {},
                materials: {},
                textures: {},
                images: {},
                shapes: {},
                skeletons: {},
                animations: {},
                nodes: {}
            };
            output.metadata = {
                version: 4.6,
                type: 'Object',
                generator: 'Object3D.toJSON'
            };
        }
        // standard Object3D serialization
        const object = {};
        object.uuid = this.uuid;
        object.type = this.type;
        if (this.name !== '') object.name = this.name;
        if (this.castShadow === true) object.castShadow = true;
        if (this.receiveShadow === true) object.receiveShadow = true;
        if (this.visible === false) object.visible = false;
        if (this.frustumCulled === false) object.frustumCulled = false;
        if (this.renderOrder !== 0) object.renderOrder = this.renderOrder;
        if (Object.keys(this.userData).length > 0) object.userData = this.userData;
        object.layers = this.layers.mask;
        object.matrix = this.matrix.toArray();
        object.up = this.up.toArray();
        if (this.matrixAutoUpdate === false) object.matrixAutoUpdate = false;
        // object specific properties
        if (this.isInstancedMesh) {
            object.type = 'InstancedMesh';
            object.count = this.count;
            object.instanceMatrix = this.instanceMatrix.toJSON();
            if (this.instanceColor !== null) object.instanceColor = this.instanceColor.toJSON();
        }
        if (this.isBatchedMesh) {
            object.type = 'BatchedMesh';
            object.perObjectFrustumCulled = this.perObjectFrustumCulled;
            object.sortObjects = this.sortObjects;
            object.drawRanges = this._drawRanges;
            object.reservedRanges = this._reservedRanges;
            object.visibility = this._visibility;
            object.active = this._active;
            object.bounds = this._bounds.map((bound)=>({
                    boxInitialized: bound.boxInitialized,
                    boxMin: bound.box.min.toArray(),
                    boxMax: bound.box.max.toArray(),
                    sphereInitialized: bound.sphereInitialized,
                    sphereRadius: bound.sphere.radius,
                    sphereCenter: bound.sphere.center.toArray()
                }));
            object.maxInstanceCount = this._maxInstanceCount;
            object.maxVertexCount = this._maxVertexCount;
            object.maxIndexCount = this._maxIndexCount;
            object.geometryInitialized = this._geometryInitialized;
            object.geometryCount = this._geometryCount;
            object.matricesTexture = this._matricesTexture.toJSON(meta);
            if (this._colorsTexture !== null) object.colorsTexture = this._colorsTexture.toJSON(meta);
            if (this.boundingSphere !== null) object.boundingSphere = {
                center: object.boundingSphere.center.toArray(),
                radius: object.boundingSphere.radius
            };
            if (this.boundingBox !== null) object.boundingBox = {
                min: object.boundingBox.min.toArray(),
                max: object.boundingBox.max.toArray()
            };
        }
        //
        function serialize(library, element) {
            if (library[element.uuid] === undefined) library[element.uuid] = element.toJSON(meta);
            return element.uuid;
        }
        if (this.isScene) {
            if (this.background) {
                if (this.background.isColor) object.background = this.background.toJSON();
                else if (this.background.isTexture) object.background = this.background.toJSON(meta).uuid;
            }
            if (this.environment && this.environment.isTexture && this.environment.isRenderTargetTexture !== true) object.environment = this.environment.toJSON(meta).uuid;
        } else if (this.isMesh || this.isLine || this.isPoints) {
            object.geometry = serialize(meta.geometries, this.geometry);
            const parameters = this.geometry.parameters;
            if (parameters !== undefined && parameters.shapes !== undefined) {
                const shapes = parameters.shapes;
                if (Array.isArray(shapes)) for(let i = 0, l = shapes.length; i < l; i++){
                    const shape = shapes[i];
                    serialize(meta.shapes, shape);
                }
                else serialize(meta.shapes, shapes);
            }
        }
        if (this.isSkinnedMesh) {
            object.bindMode = this.bindMode;
            object.bindMatrix = this.bindMatrix.toArray();
            if (this.skeleton !== undefined) {
                serialize(meta.skeletons, this.skeleton);
                object.skeleton = this.skeleton.uuid;
            }
        }
        if (this.material !== undefined) {
            if (Array.isArray(this.material)) {
                const uuids = [];
                for(let i = 0, l = this.material.length; i < l; i++)uuids.push(serialize(meta.materials, this.material[i]));
                object.material = uuids;
            } else object.material = serialize(meta.materials, this.material);
        }
        //
        if (this.children.length > 0) {
            object.children = [];
            for(let i = 0; i < this.children.length; i++)object.children.push(this.children[i].toJSON(meta).object);
        }
        //
        if (this.animations.length > 0) {
            object.animations = [];
            for(let i = 0; i < this.animations.length; i++){
                const animation = this.animations[i];
                object.animations.push(serialize(meta.animations, animation));
            }
        }
        if (isRootObject) {
            const geometries = extractFromCache(meta.geometries);
            const materials = extractFromCache(meta.materials);
            const textures = extractFromCache(meta.textures);
            const images = extractFromCache(meta.images);
            const shapes = extractFromCache(meta.shapes);
            const skeletons = extractFromCache(meta.skeletons);
            const animations = extractFromCache(meta.animations);
            const nodes = extractFromCache(meta.nodes);
            if (geometries.length > 0) output.geometries = geometries;
            if (materials.length > 0) output.materials = materials;
            if (textures.length > 0) output.textures = textures;
            if (images.length > 0) output.images = images;
            if (shapes.length > 0) output.shapes = shapes;
            if (skeletons.length > 0) output.skeletons = skeletons;
            if (animations.length > 0) output.animations = animations;
            if (nodes.length > 0) output.nodes = nodes;
        }
        output.object = object;
        return output;
        // extract data from the cache hash
        // remove metadata on each item
        // and return as array
        function extractFromCache(cache) {
            const values = [];
            for(const key in cache){
                const data = cache[key];
                delete data.metadata;
                values.push(data);
            }
            return values;
        }
    }
    clone(recursive) {
        return new this.constructor().copy(this, recursive);
    }
    copy(source, recursive = true) {
        this.name = source.name;
        this.up.copy(source.up);
        this.position.copy(source.position);
        this.rotation.order = source.rotation.order;
        this.quaternion.copy(source.quaternion);
        this.scale.copy(source.scale);
        this.matrix.copy(source.matrix);
        this.matrixWorld.copy(source.matrixWorld);
        this.matrixAutoUpdate = source.matrixAutoUpdate;
        this.matrixWorldAutoUpdate = source.matrixWorldAutoUpdate;
        this.matrixWorldNeedsUpdate = source.matrixWorldNeedsUpdate;
        this.layers.mask = source.layers.mask;
        this.visible = source.visible;
        this.castShadow = source.castShadow;
        this.receiveShadow = source.receiveShadow;
        this.frustumCulled = source.frustumCulled;
        this.renderOrder = source.renderOrder;
        this.animations = source.animations.slice();
        this.userData = JSON.parse(JSON.stringify(source.userData));
        if (recursive === true) for(let i = 0; i < source.children.length; i++){
            const child = source.children[i];
            this.add(child.clone());
        }
        return this;
    }
}
$d5b33d7c30034067$export$e4dd07dff30cc924.DEFAULT_UP = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699(0, 1, 0);
$d5b33d7c30034067$export$e4dd07dff30cc924.DEFAULT_MATRIX_AUTO_UPDATE = true;
$d5b33d7c30034067$export$e4dd07dff30cc924.DEFAULT_MATRIX_WORLD_AUTO_UPDATE = true;
const $d5b33d7c30034067$var$_v0$2 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_v1$3 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_v2$2 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_v3$2 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_vab = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_vac = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_vbc = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_vap = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_vbp = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_vcp = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_v40 = /*@__PURE__*/ new $d5b33d7c30034067$export$fa7daccca11cdbe3();
const $d5b33d7c30034067$var$_v41 = /*@__PURE__*/ new $d5b33d7c30034067$export$fa7daccca11cdbe3();
const $d5b33d7c30034067$var$_v42 = /*@__PURE__*/ new $d5b33d7c30034067$export$fa7daccca11cdbe3();
class $d5b33d7c30034067$export$5a465592bfe74b48 {
    constructor(a = new $d5b33d7c30034067$export$64b5c384219d3699(), b = new $d5b33d7c30034067$export$64b5c384219d3699(), c = new $d5b33d7c30034067$export$64b5c384219d3699()){
        this.a = a;
        this.b = b;
        this.c = c;
    }
    static getNormal(a, b, c, target) {
        target.subVectors(c, b);
        $d5b33d7c30034067$var$_v0$2.subVectors(a, b);
        target.cross($d5b33d7c30034067$var$_v0$2);
        const targetLengthSq = target.lengthSq();
        if (targetLengthSq > 0) return target.multiplyScalar(1 / Math.sqrt(targetLengthSq));
        return target.set(0, 0, 0);
    }
    // static/instance method to calculate barycentric coordinates
    // based on: http://www.blackpawn.com/texts/pointinpoly/default.html
    static getBarycoord(point, a, b, c, target) {
        $d5b33d7c30034067$var$_v0$2.subVectors(c, a);
        $d5b33d7c30034067$var$_v1$3.subVectors(b, a);
        $d5b33d7c30034067$var$_v2$2.subVectors(point, a);
        const dot00 = $d5b33d7c30034067$var$_v0$2.dot($d5b33d7c30034067$var$_v0$2);
        const dot01 = $d5b33d7c30034067$var$_v0$2.dot($d5b33d7c30034067$var$_v1$3);
        const dot02 = $d5b33d7c30034067$var$_v0$2.dot($d5b33d7c30034067$var$_v2$2);
        const dot11 = $d5b33d7c30034067$var$_v1$3.dot($d5b33d7c30034067$var$_v1$3);
        const dot12 = $d5b33d7c30034067$var$_v1$3.dot($d5b33d7c30034067$var$_v2$2);
        const denom = dot00 * dot11 - dot01 * dot01;
        // collinear or singular triangle
        if (denom === 0) {
            target.set(0, 0, 0);
            return null;
        }
        const invDenom = 1 / denom;
        const u = (dot11 * dot02 - dot01 * dot12) * invDenom;
        const v = (dot00 * dot12 - dot01 * dot02) * invDenom;
        // barycentric coordinates must always sum to 1
        return target.set(1 - u - v, v, u);
    }
    static containsPoint(point, a, b, c) {
        // if the triangle is degenerate then we can't contain a point
        if (this.getBarycoord(point, a, b, c, $d5b33d7c30034067$var$_v3$2) === null) return false;
        return $d5b33d7c30034067$var$_v3$2.x >= 0 && $d5b33d7c30034067$var$_v3$2.y >= 0 && $d5b33d7c30034067$var$_v3$2.x + $d5b33d7c30034067$var$_v3$2.y <= 1;
    }
    static getInterpolation(point, p1, p2, p3, v1, v2, v3, target) {
        if (this.getBarycoord(point, p1, p2, p3, $d5b33d7c30034067$var$_v3$2) === null) {
            target.x = 0;
            target.y = 0;
            if ('z' in target) target.z = 0;
            if ('w' in target) target.w = 0;
            return null;
        }
        target.setScalar(0);
        target.addScaledVector(v1, $d5b33d7c30034067$var$_v3$2.x);
        target.addScaledVector(v2, $d5b33d7c30034067$var$_v3$2.y);
        target.addScaledVector(v3, $d5b33d7c30034067$var$_v3$2.z);
        return target;
    }
    static getInterpolatedAttribute(attr, i1, i2, i3, barycoord, target) {
        $d5b33d7c30034067$var$_v40.setScalar(0);
        $d5b33d7c30034067$var$_v41.setScalar(0);
        $d5b33d7c30034067$var$_v42.setScalar(0);
        $d5b33d7c30034067$var$_v40.fromBufferAttribute(attr, i1);
        $d5b33d7c30034067$var$_v41.fromBufferAttribute(attr, i2);
        $d5b33d7c30034067$var$_v42.fromBufferAttribute(attr, i3);
        target.setScalar(0);
        target.addScaledVector($d5b33d7c30034067$var$_v40, barycoord.x);
        target.addScaledVector($d5b33d7c30034067$var$_v41, barycoord.y);
        target.addScaledVector($d5b33d7c30034067$var$_v42, barycoord.z);
        return target;
    }
    static isFrontFacing(a, b, c, direction) {
        $d5b33d7c30034067$var$_v0$2.subVectors(c, b);
        $d5b33d7c30034067$var$_v1$3.subVectors(a, b);
        // strictly front facing
        return $d5b33d7c30034067$var$_v0$2.cross($d5b33d7c30034067$var$_v1$3).dot(direction) < 0 ? true : false;
    }
    set(a, b, c) {
        this.a.copy(a);
        this.b.copy(b);
        this.c.copy(c);
        return this;
    }
    setFromPointsAndIndices(points, i0, i1, i2) {
        this.a.copy(points[i0]);
        this.b.copy(points[i1]);
        this.c.copy(points[i2]);
        return this;
    }
    setFromAttributeAndIndices(attribute, i0, i1, i2) {
        this.a.fromBufferAttribute(attribute, i0);
        this.b.fromBufferAttribute(attribute, i1);
        this.c.fromBufferAttribute(attribute, i2);
        return this;
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(triangle) {
        this.a.copy(triangle.a);
        this.b.copy(triangle.b);
        this.c.copy(triangle.c);
        return this;
    }
    getArea() {
        $d5b33d7c30034067$var$_v0$2.subVectors(this.c, this.b);
        $d5b33d7c30034067$var$_v1$3.subVectors(this.a, this.b);
        return $d5b33d7c30034067$var$_v0$2.cross($d5b33d7c30034067$var$_v1$3).length() * 0.5;
    }
    getMidpoint(target) {
        return target.addVectors(this.a, this.b).add(this.c).multiplyScalar(1 / 3);
    }
    getNormal(target) {
        return $d5b33d7c30034067$export$5a465592bfe74b48.getNormal(this.a, this.b, this.c, target);
    }
    getPlane(target) {
        return target.setFromCoplanarPoints(this.a, this.b, this.c);
    }
    getBarycoord(point, target) {
        return $d5b33d7c30034067$export$5a465592bfe74b48.getBarycoord(point, this.a, this.b, this.c, target);
    }
    getInterpolation(point, v1, v2, v3, target) {
        return $d5b33d7c30034067$export$5a465592bfe74b48.getInterpolation(point, this.a, this.b, this.c, v1, v2, v3, target);
    }
    containsPoint(point) {
        return $d5b33d7c30034067$export$5a465592bfe74b48.containsPoint(point, this.a, this.b, this.c);
    }
    isFrontFacing(direction) {
        return $d5b33d7c30034067$export$5a465592bfe74b48.isFrontFacing(this.a, this.b, this.c, direction);
    }
    intersectsBox(box) {
        return box.intersectsTriangle(this);
    }
    closestPointToPoint(p, target) {
        const a = this.a, b = this.b, c = this.c;
        let v, w;
        // algorithm thanks to Real-Time Collision Detection by Christer Ericson,
        // published by Morgan Kaufmann Publishers, (c) 2005 Elsevier Inc.,
        // under the accompanying license; see chapter 5.1.5 for detailed explanation.
        // basically, we're distinguishing which of the voronoi regions of the triangle
        // the point lies in with the minimum amount of redundant computation.
        $d5b33d7c30034067$var$_vab.subVectors(b, a);
        $d5b33d7c30034067$var$_vac.subVectors(c, a);
        $d5b33d7c30034067$var$_vap.subVectors(p, a);
        const d1 = $d5b33d7c30034067$var$_vab.dot($d5b33d7c30034067$var$_vap);
        const d2 = $d5b33d7c30034067$var$_vac.dot($d5b33d7c30034067$var$_vap);
        if (d1 <= 0 && d2 <= 0) // vertex region of A; barycentric coords (1, 0, 0)
        return target.copy(a);
        $d5b33d7c30034067$var$_vbp.subVectors(p, b);
        const d3 = $d5b33d7c30034067$var$_vab.dot($d5b33d7c30034067$var$_vbp);
        const d4 = $d5b33d7c30034067$var$_vac.dot($d5b33d7c30034067$var$_vbp);
        if (d3 >= 0 && d4 <= d3) // vertex region of B; barycentric coords (0, 1, 0)
        return target.copy(b);
        const vc = d1 * d4 - d3 * d2;
        if (vc <= 0 && d1 >= 0 && d3 <= 0) {
            v = d1 / (d1 - d3);
            // edge region of AB; barycentric coords (1-v, v, 0)
            return target.copy(a).addScaledVector($d5b33d7c30034067$var$_vab, v);
        }
        $d5b33d7c30034067$var$_vcp.subVectors(p, c);
        const d5 = $d5b33d7c30034067$var$_vab.dot($d5b33d7c30034067$var$_vcp);
        const d6 = $d5b33d7c30034067$var$_vac.dot($d5b33d7c30034067$var$_vcp);
        if (d6 >= 0 && d5 <= d6) // vertex region of C; barycentric coords (0, 0, 1)
        return target.copy(c);
        const vb = d5 * d2 - d1 * d6;
        if (vb <= 0 && d2 >= 0 && d6 <= 0) {
            w = d2 / (d2 - d6);
            // edge region of AC; barycentric coords (1-w, 0, w)
            return target.copy(a).addScaledVector($d5b33d7c30034067$var$_vac, w);
        }
        const va = d3 * d6 - d5 * d4;
        if (va <= 0 && d4 - d3 >= 0 && d5 - d6 >= 0) {
            $d5b33d7c30034067$var$_vbc.subVectors(c, b);
            w = (d4 - d3) / (d4 - d3 + (d5 - d6));
            // edge region of BC; barycentric coords (0, 1-w, w)
            return target.copy(b).addScaledVector($d5b33d7c30034067$var$_vbc, w); // edge region of BC
        }
        // face region
        const denom = 1 / (va + vb + vc);
        // u = va * denom
        v = vb * denom;
        w = vc * denom;
        return target.copy(a).addScaledVector($d5b33d7c30034067$var$_vab, v).addScaledVector($d5b33d7c30034067$var$_vac, w);
    }
    equals(triangle) {
        return triangle.a.equals(this.a) && triangle.b.equals(this.b) && triangle.c.equals(this.c);
    }
}
const $d5b33d7c30034067$var$_colorKeywords = {
    'aliceblue': 0xF0F8FF,
    'antiquewhite': 0xFAEBD7,
    'aqua': 0x00FFFF,
    'aquamarine': 0x7FFFD4,
    'azure': 0xF0FFFF,
    'beige': 0xF5F5DC,
    'bisque': 0xFFE4C4,
    'black': 0x000000,
    'blanchedalmond': 0xFFEBCD,
    'blue': 0x0000FF,
    'blueviolet': 0x8A2BE2,
    'brown': 0xA52A2A,
    'burlywood': 0xDEB887,
    'cadetblue': 0x5F9EA0,
    'chartreuse': 0x7FFF00,
    'chocolate': 0xD2691E,
    'coral': 0xFF7F50,
    'cornflowerblue': 0x6495ED,
    'cornsilk': 0xFFF8DC,
    'crimson': 0xDC143C,
    'cyan': 0x00FFFF,
    'darkblue': 0x00008B,
    'darkcyan': 0x008B8B,
    'darkgoldenrod': 0xB8860B,
    'darkgray': 0xA9A9A9,
    'darkgreen': 0x006400,
    'darkgrey': 0xA9A9A9,
    'darkkhaki': 0xBDB76B,
    'darkmagenta': 0x8B008B,
    'darkolivegreen': 0x556B2F,
    'darkorange': 0xFF8C00,
    'darkorchid': 0x9932CC,
    'darkred': 0x8B0000,
    'darksalmon': 0xE9967A,
    'darkseagreen': 0x8FBC8F,
    'darkslateblue': 0x483D8B,
    'darkslategray': 0x2F4F4F,
    'darkslategrey': 0x2F4F4F,
    'darkturquoise': 0x00CED1,
    'darkviolet': 0x9400D3,
    'deeppink': 0xFF1493,
    'deepskyblue': 0x00BFFF,
    'dimgray': 0x696969,
    'dimgrey': 0x696969,
    'dodgerblue': 0x1E90FF,
    'firebrick': 0xB22222,
    'floralwhite': 0xFFFAF0,
    'forestgreen': 0x228B22,
    'fuchsia': 0xFF00FF,
    'gainsboro': 0xDCDCDC,
    'ghostwhite': 0xF8F8FF,
    'gold': 0xFFD700,
    'goldenrod': 0xDAA520,
    'gray': 0x808080,
    'green': 0x008000,
    'greenyellow': 0xADFF2F,
    'grey': 0x808080,
    'honeydew': 0xF0FFF0,
    'hotpink': 0xFF69B4,
    'indianred': 0xCD5C5C,
    'indigo': 0x4B0082,
    'ivory': 0xFFFFF0,
    'khaki': 0xF0E68C,
    'lavender': 0xE6E6FA,
    'lavenderblush': 0xFFF0F5,
    'lawngreen': 0x7CFC00,
    'lemonchiffon': 0xFFFACD,
    'lightblue': 0xADD8E6,
    'lightcoral': 0xF08080,
    'lightcyan': 0xE0FFFF,
    'lightgoldenrodyellow': 0xFAFAD2,
    'lightgray': 0xD3D3D3,
    'lightgreen': 0x90EE90,
    'lightgrey': 0xD3D3D3,
    'lightpink': 0xFFB6C1,
    'lightsalmon': 0xFFA07A,
    'lightseagreen': 0x20B2AA,
    'lightskyblue': 0x87CEFA,
    'lightslategray': 0x778899,
    'lightslategrey': 0x778899,
    'lightsteelblue': 0xB0C4DE,
    'lightyellow': 0xFFFFE0,
    'lime': 0x00FF00,
    'limegreen': 0x32CD32,
    'linen': 0xFAF0E6,
    'magenta': 0xFF00FF,
    'maroon': 0x800000,
    'mediumaquamarine': 0x66CDAA,
    'mediumblue': 0x0000CD,
    'mediumorchid': 0xBA55D3,
    'mediumpurple': 0x9370DB,
    'mediumseagreen': 0x3CB371,
    'mediumslateblue': 0x7B68EE,
    'mediumspringgreen': 0x00FA9A,
    'mediumturquoise': 0x48D1CC,
    'mediumvioletred': 0xC71585,
    'midnightblue': 0x191970,
    'mintcream': 0xF5FFFA,
    'mistyrose': 0xFFE4E1,
    'moccasin': 0xFFE4B5,
    'navajowhite': 0xFFDEAD,
    'navy': 0x000080,
    'oldlace': 0xFDF5E6,
    'olive': 0x808000,
    'olivedrab': 0x6B8E23,
    'orange': 0xFFA500,
    'orangered': 0xFF4500,
    'orchid': 0xDA70D6,
    'palegoldenrod': 0xEEE8AA,
    'palegreen': 0x98FB98,
    'paleturquoise': 0xAFEEEE,
    'palevioletred': 0xDB7093,
    'papayawhip': 0xFFEFD5,
    'peachpuff': 0xFFDAB9,
    'peru': 0xCD853F,
    'pink': 0xFFC0CB,
    'plum': 0xDDA0DD,
    'powderblue': 0xB0E0E6,
    'purple': 0x800080,
    'rebeccapurple': 0x663399,
    'red': 0xFF0000,
    'rosybrown': 0xBC8F8F,
    'royalblue': 0x4169E1,
    'saddlebrown': 0x8B4513,
    'salmon': 0xFA8072,
    'sandybrown': 0xF4A460,
    'seagreen': 0x2E8B57,
    'seashell': 0xFFF5EE,
    'sienna': 0xA0522D,
    'silver': 0xC0C0C0,
    'skyblue': 0x87CEEB,
    'slateblue': 0x6A5ACD,
    'slategray': 0x708090,
    'slategrey': 0x708090,
    'snow': 0xFFFAFA,
    'springgreen': 0x00FF7F,
    'steelblue': 0x4682B4,
    'tan': 0xD2B48C,
    'teal': 0x008080,
    'thistle': 0xD8BFD8,
    'tomato': 0xFF6347,
    'turquoise': 0x40E0D0,
    'violet': 0xEE82EE,
    'wheat': 0xF5DEB3,
    'white': 0xFFFFFF,
    'whitesmoke': 0xF5F5F5,
    'yellow': 0xFFFF00,
    'yellowgreen': 0x9ACD32
};
const $d5b33d7c30034067$var$_hslA = {
    h: 0,
    s: 0,
    l: 0
};
const $d5b33d7c30034067$var$_hslB = {
    h: 0,
    s: 0,
    l: 0
};
function $d5b33d7c30034067$var$hue2rgb(p, q, t) {
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1 / 6) return p + (q - p) * 6 * t;
    if (t < 0.5) return q;
    if (t < 2 / 3) return p + (q - p) * 6 * (2 / 3 - t);
    return p;
}
class $d5b33d7c30034067$export$892596cec99bc70e {
    constructor(r, g, b){
        this.isColor = true;
        this.r = 1;
        this.g = 1;
        this.b = 1;
        return this.set(r, g, b);
    }
    set(r, g, b) {
        if (g === undefined && b === undefined) {
            // r is THREE.Color, hex or string
            const value = r;
            if (value && value.isColor) this.copy(value);
            else if (typeof value === 'number') this.setHex(value);
            else if (typeof value === 'string') this.setStyle(value);
        } else this.setRGB(r, g, b);
        return this;
    }
    setScalar(scalar) {
        this.r = scalar;
        this.g = scalar;
        this.b = scalar;
        return this;
    }
    setHex(hex, colorSpace = $d5b33d7c30034067$export$561f394b24edfcaa) {
        hex = Math.floor(hex);
        this.r = (hex >> 16 & 255) / 255;
        this.g = (hex >> 8 & 255) / 255;
        this.b = (hex & 255) / 255;
        $d5b33d7c30034067$export$5e6fd513f44698c.toWorkingColorSpace(this, colorSpace);
        return this;
    }
    setRGB(r, g, b, colorSpace = $d5b33d7c30034067$export$5e6fd513f44698c.workingColorSpace) {
        this.r = r;
        this.g = g;
        this.b = b;
        $d5b33d7c30034067$export$5e6fd513f44698c.toWorkingColorSpace(this, colorSpace);
        return this;
    }
    setHSL(h, s, l, colorSpace = $d5b33d7c30034067$export$5e6fd513f44698c.workingColorSpace) {
        // h,s,l ranges are in 0.0 - 1.0
        h = $d5b33d7c30034067$var$euclideanModulo(h, 1);
        s = $d5b33d7c30034067$var$clamp(s, 0, 1);
        l = $d5b33d7c30034067$var$clamp(l, 0, 1);
        if (s === 0) this.r = this.g = this.b = l;
        else {
            const p = l <= 0.5 ? l * (1 + s) : l + s - l * s;
            const q = 2 * l - p;
            this.r = $d5b33d7c30034067$var$hue2rgb(q, p, h + 1 / 3);
            this.g = $d5b33d7c30034067$var$hue2rgb(q, p, h);
            this.b = $d5b33d7c30034067$var$hue2rgb(q, p, h - 1 / 3);
        }
        $d5b33d7c30034067$export$5e6fd513f44698c.toWorkingColorSpace(this, colorSpace);
        return this;
    }
    setStyle(style, colorSpace = $d5b33d7c30034067$export$561f394b24edfcaa) {
        function handleAlpha(string) {
            if (string === undefined) return;
            if (parseFloat(string) < 1) console.warn('THREE.Color: Alpha component of ' + style + ' will be ignored.');
        }
        let m;
        if (m = /^(\w+)\(([^\)]*)\)/.exec(style)) {
            // rgb / hsl
            let color;
            const name = m[1];
            const components = m[2];
            switch(name){
                case 'rgb':
                case 'rgba':
                    if (color = /^\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(components)) {
                        // rgb(255,0,0) rgba(255,0,0,0.5)
                        handleAlpha(color[4]);
                        return this.setRGB(Math.min(255, parseInt(color[1], 10)) / 255, Math.min(255, parseInt(color[2], 10)) / 255, Math.min(255, parseInt(color[3], 10)) / 255, colorSpace);
                    }
                    if (color = /^\s*(\d+)\%\s*,\s*(\d+)\%\s*,\s*(\d+)\%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(components)) {
                        // rgb(100%,0%,0%) rgba(100%,0%,0%,0.5)
                        handleAlpha(color[4]);
                        return this.setRGB(Math.min(100, parseInt(color[1], 10)) / 100, Math.min(100, parseInt(color[2], 10)) / 100, Math.min(100, parseInt(color[3], 10)) / 100, colorSpace);
                    }
                    break;
                case 'hsl':
                case 'hsla':
                    if (color = /^\s*(\d*\.?\d+)\s*,\s*(\d*\.?\d+)\%\s*,\s*(\d*\.?\d+)\%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(components)) {
                        // hsl(120,50%,50%) hsla(120,50%,50%,0.5)
                        handleAlpha(color[4]);
                        return this.setHSL(parseFloat(color[1]) / 360, parseFloat(color[2]) / 100, parseFloat(color[3]) / 100, colorSpace);
                    }
                    break;
                default:
                    console.warn('THREE.Color: Unknown color model ' + style);
            }
        } else if (m = /^\#([A-Fa-f\d]+)$/.exec(style)) {
            // hex color
            const hex = m[1];
            const size = hex.length;
            if (size === 3) // #ff0
            return this.setRGB(parseInt(hex.charAt(0), 16) / 15, parseInt(hex.charAt(1), 16) / 15, parseInt(hex.charAt(2), 16) / 15, colorSpace);
            else if (size === 6) // #ff0000
            return this.setHex(parseInt(hex, 16), colorSpace);
            else console.warn('THREE.Color: Invalid hex color ' + style);
        } else if (style && style.length > 0) return this.setColorName(style, colorSpace);
        return this;
    }
    setColorName(style, colorSpace = $d5b33d7c30034067$export$561f394b24edfcaa) {
        // color keywords
        const hex = $d5b33d7c30034067$var$_colorKeywords[style.toLowerCase()];
        if (hex !== undefined) // red
        this.setHex(hex, colorSpace);
        else // unknown color
        console.warn('THREE.Color: Unknown color ' + style);
        return this;
    }
    clone() {
        return new this.constructor(this.r, this.g, this.b);
    }
    copy(color) {
        this.r = color.r;
        this.g = color.g;
        this.b = color.b;
        return this;
    }
    copySRGBToLinear(color) {
        this.r = $d5b33d7c30034067$var$SRGBToLinear(color.r);
        this.g = $d5b33d7c30034067$var$SRGBToLinear(color.g);
        this.b = $d5b33d7c30034067$var$SRGBToLinear(color.b);
        return this;
    }
    copyLinearToSRGB(color) {
        this.r = $d5b33d7c30034067$var$LinearToSRGB(color.r);
        this.g = $d5b33d7c30034067$var$LinearToSRGB(color.g);
        this.b = $d5b33d7c30034067$var$LinearToSRGB(color.b);
        return this;
    }
    convertSRGBToLinear() {
        this.copySRGBToLinear(this);
        return this;
    }
    convertLinearToSRGB() {
        this.copyLinearToSRGB(this);
        return this;
    }
    getHex(colorSpace = $d5b33d7c30034067$export$561f394b24edfcaa) {
        $d5b33d7c30034067$export$5e6fd513f44698c.fromWorkingColorSpace($d5b33d7c30034067$var$_color.copy(this), colorSpace);
        return Math.round($d5b33d7c30034067$var$clamp($d5b33d7c30034067$var$_color.r * 255, 0, 255)) * 65536 + Math.round($d5b33d7c30034067$var$clamp($d5b33d7c30034067$var$_color.g * 255, 0, 255)) * 256 + Math.round($d5b33d7c30034067$var$clamp($d5b33d7c30034067$var$_color.b * 255, 0, 255));
    }
    getHexString(colorSpace = $d5b33d7c30034067$export$561f394b24edfcaa) {
        return ('000000' + this.getHex(colorSpace).toString(16)).slice(-6);
    }
    getHSL(target, colorSpace = $d5b33d7c30034067$export$5e6fd513f44698c.workingColorSpace) {
        // h,s,l ranges are in 0.0 - 1.0
        $d5b33d7c30034067$export$5e6fd513f44698c.fromWorkingColorSpace($d5b33d7c30034067$var$_color.copy(this), colorSpace);
        const r = $d5b33d7c30034067$var$_color.r, g = $d5b33d7c30034067$var$_color.g, b = $d5b33d7c30034067$var$_color.b;
        const max = Math.max(r, g, b);
        const min = Math.min(r, g, b);
        let hue, saturation;
        const lightness = (min + max) / 2.0;
        if (min === max) {
            hue = 0;
            saturation = 0;
        } else {
            const delta = max - min;
            saturation = lightness <= 0.5 ? delta / (max + min) : delta / (2 - max - min);
            switch(max){
                case r:
                    hue = (g - b) / delta + (g < b ? 6 : 0);
                    break;
                case g:
                    hue = (b - r) / delta + 2;
                    break;
                case b:
                    hue = (r - g) / delta + 4;
                    break;
            }
            hue /= 6;
        }
        target.h = hue;
        target.s = saturation;
        target.l = lightness;
        return target;
    }
    getRGB(target, colorSpace = $d5b33d7c30034067$export$5e6fd513f44698c.workingColorSpace) {
        $d5b33d7c30034067$export$5e6fd513f44698c.fromWorkingColorSpace($d5b33d7c30034067$var$_color.copy(this), colorSpace);
        target.r = $d5b33d7c30034067$var$_color.r;
        target.g = $d5b33d7c30034067$var$_color.g;
        target.b = $d5b33d7c30034067$var$_color.b;
        return target;
    }
    getStyle(colorSpace = $d5b33d7c30034067$export$561f394b24edfcaa) {
        $d5b33d7c30034067$export$5e6fd513f44698c.fromWorkingColorSpace($d5b33d7c30034067$var$_color.copy(this), colorSpace);
        const r = $d5b33d7c30034067$var$_color.r, g = $d5b33d7c30034067$var$_color.g, b = $d5b33d7c30034067$var$_color.b;
        if (colorSpace !== $d5b33d7c30034067$export$561f394b24edfcaa) // Requires CSS Color Module Level 4 (https://www.w3.org/TR/css-color-4/).
        return `color(${colorSpace} ${r.toFixed(3)} ${g.toFixed(3)} ${b.toFixed(3)})`;
        return `rgb(${Math.round(r * 255)},${Math.round(g * 255)},${Math.round(b * 255)})`;
    }
    offsetHSL(h, s, l) {
        this.getHSL($d5b33d7c30034067$var$_hslA);
        return this.setHSL($d5b33d7c30034067$var$_hslA.h + h, $d5b33d7c30034067$var$_hslA.s + s, $d5b33d7c30034067$var$_hslA.l + l);
    }
    add(color) {
        this.r += color.r;
        this.g += color.g;
        this.b += color.b;
        return this;
    }
    addColors(color1, color2) {
        this.r = color1.r + color2.r;
        this.g = color1.g + color2.g;
        this.b = color1.b + color2.b;
        return this;
    }
    addScalar(s) {
        this.r += s;
        this.g += s;
        this.b += s;
        return this;
    }
    sub(color) {
        this.r = Math.max(0, this.r - color.r);
        this.g = Math.max(0, this.g - color.g);
        this.b = Math.max(0, this.b - color.b);
        return this;
    }
    multiply(color) {
        this.r *= color.r;
        this.g *= color.g;
        this.b *= color.b;
        return this;
    }
    multiplyScalar(s) {
        this.r *= s;
        this.g *= s;
        this.b *= s;
        return this;
    }
    lerp(color, alpha) {
        this.r += (color.r - this.r) * alpha;
        this.g += (color.g - this.g) * alpha;
        this.b += (color.b - this.b) * alpha;
        return this;
    }
    lerpColors(color1, color2, alpha) {
        this.r = color1.r + (color2.r - color1.r) * alpha;
        this.g = color1.g + (color2.g - color1.g) * alpha;
        this.b = color1.b + (color2.b - color1.b) * alpha;
        return this;
    }
    lerpHSL(color, alpha) {
        this.getHSL($d5b33d7c30034067$var$_hslA);
        color.getHSL($d5b33d7c30034067$var$_hslB);
        const h = $d5b33d7c30034067$var$lerp($d5b33d7c30034067$var$_hslA.h, $d5b33d7c30034067$var$_hslB.h, alpha);
        const s = $d5b33d7c30034067$var$lerp($d5b33d7c30034067$var$_hslA.s, $d5b33d7c30034067$var$_hslB.s, alpha);
        const l = $d5b33d7c30034067$var$lerp($d5b33d7c30034067$var$_hslA.l, $d5b33d7c30034067$var$_hslB.l, alpha);
        this.setHSL(h, s, l);
        return this;
    }
    setFromVector3(v) {
        this.r = v.x;
        this.g = v.y;
        this.b = v.z;
        return this;
    }
    applyMatrix3(m) {
        const r = this.r, g = this.g, b = this.b;
        const e = m.elements;
        this.r = e[0] * r + e[3] * g + e[6] * b;
        this.g = e[1] * r + e[4] * g + e[7] * b;
        this.b = e[2] * r + e[5] * g + e[8] * b;
        return this;
    }
    equals(c) {
        return c.r === this.r && c.g === this.g && c.b === this.b;
    }
    fromArray(array, offset = 0) {
        this.r = array[offset];
        this.g = array[offset + 1];
        this.b = array[offset + 2];
        return this;
    }
    toArray(array = [], offset = 0) {
        array[offset] = this.r;
        array[offset + 1] = this.g;
        array[offset + 2] = this.b;
        return array;
    }
    fromBufferAttribute(attribute, index) {
        this.r = attribute.getX(index);
        this.g = attribute.getY(index);
        this.b = attribute.getZ(index);
        return this;
    }
    toJSON() {
        return this.getHex();
    }
    *[Symbol.iterator]() {
        yield this.r;
        yield this.g;
        yield this.b;
    }
}
const $d5b33d7c30034067$var$_color = /*@__PURE__*/ new $d5b33d7c30034067$export$892596cec99bc70e();
$d5b33d7c30034067$export$892596cec99bc70e.NAMES = $d5b33d7c30034067$var$_colorKeywords;
let $d5b33d7c30034067$var$_materialId = 0;
class $d5b33d7c30034067$export$a2d8b23205c25948 extends $d5b33d7c30034067$export$ec8b666c5fe2c75a {
    static get type() {
        return 'Material';
    }
    get type() {
        return this.constructor.type;
    }
    set type(_value) {}
    constructor(){
        super();
        this.isMaterial = true;
        Object.defineProperty(this, 'id', {
            value: $d5b33d7c30034067$var$_materialId++
        });
        this.uuid = $d5b33d7c30034067$var$generateUUID();
        this.name = '';
        this.blending = $d5b33d7c30034067$export$5b29a26d96ee6af0;
        this.side = $d5b33d7c30034067$export$2ede184fc2998901;
        this.vertexColors = false;
        this.opacity = 1;
        this.transparent = false;
        this.alphaHash = false;
        this.blendSrc = $d5b33d7c30034067$export$d5773124e86cf28c;
        this.blendDst = $d5b33d7c30034067$export$11d468cc7f19e971;
        this.blendEquation = $d5b33d7c30034067$export$20183a0484ce21a0;
        this.blendSrcAlpha = null;
        this.blendDstAlpha = null;
        this.blendEquationAlpha = null;
        this.blendColor = new $d5b33d7c30034067$export$892596cec99bc70e(0, 0, 0);
        this.blendAlpha = 0;
        this.depthFunc = $d5b33d7c30034067$export$296f78a0b892f81a;
        this.depthTest = true;
        this.depthWrite = true;
        this.stencilWriteMask = 0xff;
        this.stencilFunc = $d5b33d7c30034067$export$14cf96713ddd97a8;
        this.stencilRef = 0;
        this.stencilFuncMask = 0xff;
        this.stencilFail = $d5b33d7c30034067$export$9f542ae4b5baca34;
        this.stencilZFail = $d5b33d7c30034067$export$9f542ae4b5baca34;
        this.stencilZPass = $d5b33d7c30034067$export$9f542ae4b5baca34;
        this.stencilWrite = false;
        this.clippingPlanes = null;
        this.clipIntersection = false;
        this.clipShadows = false;
        this.shadowSide = null;
        this.colorWrite = true;
        this.precision = null; // override the renderer's default precision for this material
        this.polygonOffset = false;
        this.polygonOffsetFactor = 0;
        this.polygonOffsetUnits = 0;
        this.dithering = false;
        this.alphaToCoverage = false;
        this.premultipliedAlpha = false;
        this.forceSinglePass = false;
        this.visible = true;
        this.toneMapped = true;
        this.userData = {};
        this.version = 0;
        this._alphaTest = 0;
    }
    get alphaTest() {
        return this._alphaTest;
    }
    set alphaTest(value) {
        if (this._alphaTest > 0 !== value > 0) this.version++;
        this._alphaTest = value;
    }
    // onBeforeRender and onBeforeCompile only supported in WebGLRenderer
    onBeforeRender() {}
    onBeforeCompile() {}
    customProgramCacheKey() {
        return this.onBeforeCompile.toString();
    }
    setValues(values) {
        if (values === undefined) return;
        for(const key in values){
            const newValue = values[key];
            if (newValue === undefined) {
                console.warn(`THREE.Material: parameter '${key}' has value of undefined.`);
                continue;
            }
            const currentValue = this[key];
            if (currentValue === undefined) {
                console.warn(`THREE.Material: '${key}' is not a property of THREE.${this.type}.`);
                continue;
            }
            if (currentValue && currentValue.isColor) currentValue.set(newValue);
            else if (currentValue && currentValue.isVector3 && newValue && newValue.isVector3) currentValue.copy(newValue);
            else this[key] = newValue;
        }
    }
    toJSON(meta) {
        const isRootObject = meta === undefined || typeof meta === 'string';
        if (isRootObject) meta = {
            textures: {},
            images: {}
        };
        const data = {
            metadata: {
                version: 4.6,
                type: 'Material',
                generator: 'Material.toJSON'
            }
        };
        // standard Material serialization
        data.uuid = this.uuid;
        data.type = this.type;
        if (this.name !== '') data.name = this.name;
        if (this.color && this.color.isColor) data.color = this.color.getHex();
        if (this.roughness !== undefined) data.roughness = this.roughness;
        if (this.metalness !== undefined) data.metalness = this.metalness;
        if (this.sheen !== undefined) data.sheen = this.sheen;
        if (this.sheenColor && this.sheenColor.isColor) data.sheenColor = this.sheenColor.getHex();
        if (this.sheenRoughness !== undefined) data.sheenRoughness = this.sheenRoughness;
        if (this.emissive && this.emissive.isColor) data.emissive = this.emissive.getHex();
        if (this.emissiveIntensity !== undefined && this.emissiveIntensity !== 1) data.emissiveIntensity = this.emissiveIntensity;
        if (this.specular && this.specular.isColor) data.specular = this.specular.getHex();
        if (this.specularIntensity !== undefined) data.specularIntensity = this.specularIntensity;
        if (this.specularColor && this.specularColor.isColor) data.specularColor = this.specularColor.getHex();
        if (this.shininess !== undefined) data.shininess = this.shininess;
        if (this.clearcoat !== undefined) data.clearcoat = this.clearcoat;
        if (this.clearcoatRoughness !== undefined) data.clearcoatRoughness = this.clearcoatRoughness;
        if (this.clearcoatMap && this.clearcoatMap.isTexture) data.clearcoatMap = this.clearcoatMap.toJSON(meta).uuid;
        if (this.clearcoatRoughnessMap && this.clearcoatRoughnessMap.isTexture) data.clearcoatRoughnessMap = this.clearcoatRoughnessMap.toJSON(meta).uuid;
        if (this.clearcoatNormalMap && this.clearcoatNormalMap.isTexture) {
            data.clearcoatNormalMap = this.clearcoatNormalMap.toJSON(meta).uuid;
            data.clearcoatNormalScale = this.clearcoatNormalScale.toArray();
        }
        if (this.dispersion !== undefined) data.dispersion = this.dispersion;
        if (this.iridescence !== undefined) data.iridescence = this.iridescence;
        if (this.iridescenceIOR !== undefined) data.iridescenceIOR = this.iridescenceIOR;
        if (this.iridescenceThicknessRange !== undefined) data.iridescenceThicknessRange = this.iridescenceThicknessRange;
        if (this.iridescenceMap && this.iridescenceMap.isTexture) data.iridescenceMap = this.iridescenceMap.toJSON(meta).uuid;
        if (this.iridescenceThicknessMap && this.iridescenceThicknessMap.isTexture) data.iridescenceThicknessMap = this.iridescenceThicknessMap.toJSON(meta).uuid;
        if (this.anisotropy !== undefined) data.anisotropy = this.anisotropy;
        if (this.anisotropyRotation !== undefined) data.anisotropyRotation = this.anisotropyRotation;
        if (this.anisotropyMap && this.anisotropyMap.isTexture) data.anisotropyMap = this.anisotropyMap.toJSON(meta).uuid;
        if (this.map && this.map.isTexture) data.map = this.map.toJSON(meta).uuid;
        if (this.matcap && this.matcap.isTexture) data.matcap = this.matcap.toJSON(meta).uuid;
        if (this.alphaMap && this.alphaMap.isTexture) data.alphaMap = this.alphaMap.toJSON(meta).uuid;
        if (this.lightMap && this.lightMap.isTexture) {
            data.lightMap = this.lightMap.toJSON(meta).uuid;
            data.lightMapIntensity = this.lightMapIntensity;
        }
        if (this.aoMap && this.aoMap.isTexture) {
            data.aoMap = this.aoMap.toJSON(meta).uuid;
            data.aoMapIntensity = this.aoMapIntensity;
        }
        if (this.bumpMap && this.bumpMap.isTexture) {
            data.bumpMap = this.bumpMap.toJSON(meta).uuid;
            data.bumpScale = this.bumpScale;
        }
        if (this.normalMap && this.normalMap.isTexture) {
            data.normalMap = this.normalMap.toJSON(meta).uuid;
            data.normalMapType = this.normalMapType;
            data.normalScale = this.normalScale.toArray();
        }
        if (this.displacementMap && this.displacementMap.isTexture) {
            data.displacementMap = this.displacementMap.toJSON(meta).uuid;
            data.displacementScale = this.displacementScale;
            data.displacementBias = this.displacementBias;
        }
        if (this.roughnessMap && this.roughnessMap.isTexture) data.roughnessMap = this.roughnessMap.toJSON(meta).uuid;
        if (this.metalnessMap && this.metalnessMap.isTexture) data.metalnessMap = this.metalnessMap.toJSON(meta).uuid;
        if (this.emissiveMap && this.emissiveMap.isTexture) data.emissiveMap = this.emissiveMap.toJSON(meta).uuid;
        if (this.specularMap && this.specularMap.isTexture) data.specularMap = this.specularMap.toJSON(meta).uuid;
        if (this.specularIntensityMap && this.specularIntensityMap.isTexture) data.specularIntensityMap = this.specularIntensityMap.toJSON(meta).uuid;
        if (this.specularColorMap && this.specularColorMap.isTexture) data.specularColorMap = this.specularColorMap.toJSON(meta).uuid;
        if (this.envMap && this.envMap.isTexture) {
            data.envMap = this.envMap.toJSON(meta).uuid;
            if (this.combine !== undefined) data.combine = this.combine;
        }
        if (this.envMapRotation !== undefined) data.envMapRotation = this.envMapRotation.toArray();
        if (this.envMapIntensity !== undefined) data.envMapIntensity = this.envMapIntensity;
        if (this.reflectivity !== undefined) data.reflectivity = this.reflectivity;
        if (this.refractionRatio !== undefined) data.refractionRatio = this.refractionRatio;
        if (this.gradientMap && this.gradientMap.isTexture) data.gradientMap = this.gradientMap.toJSON(meta).uuid;
        if (this.transmission !== undefined) data.transmission = this.transmission;
        if (this.transmissionMap && this.transmissionMap.isTexture) data.transmissionMap = this.transmissionMap.toJSON(meta).uuid;
        if (this.thickness !== undefined) data.thickness = this.thickness;
        if (this.thicknessMap && this.thicknessMap.isTexture) data.thicknessMap = this.thicknessMap.toJSON(meta).uuid;
        if (this.attenuationDistance !== undefined && this.attenuationDistance !== Infinity) data.attenuationDistance = this.attenuationDistance;
        if (this.attenuationColor !== undefined) data.attenuationColor = this.attenuationColor.getHex();
        if (this.size !== undefined) data.size = this.size;
        if (this.shadowSide !== null) data.shadowSide = this.shadowSide;
        if (this.sizeAttenuation !== undefined) data.sizeAttenuation = this.sizeAttenuation;
        if (this.blending !== $d5b33d7c30034067$export$5b29a26d96ee6af0) data.blending = this.blending;
        if (this.side !== $d5b33d7c30034067$export$2ede184fc2998901) data.side = this.side;
        if (this.vertexColors === true) data.vertexColors = true;
        if (this.opacity < 1) data.opacity = this.opacity;
        if (this.transparent === true) data.transparent = true;
        if (this.blendSrc !== $d5b33d7c30034067$export$d5773124e86cf28c) data.blendSrc = this.blendSrc;
        if (this.blendDst !== $d5b33d7c30034067$export$11d468cc7f19e971) data.blendDst = this.blendDst;
        if (this.blendEquation !== $d5b33d7c30034067$export$20183a0484ce21a0) data.blendEquation = this.blendEquation;
        if (this.blendSrcAlpha !== null) data.blendSrcAlpha = this.blendSrcAlpha;
        if (this.blendDstAlpha !== null) data.blendDstAlpha = this.blendDstAlpha;
        if (this.blendEquationAlpha !== null) data.blendEquationAlpha = this.blendEquationAlpha;
        if (this.blendColor && this.blendColor.isColor) data.blendColor = this.blendColor.getHex();
        if (this.blendAlpha !== 0) data.blendAlpha = this.blendAlpha;
        if (this.depthFunc !== $d5b33d7c30034067$export$296f78a0b892f81a) data.depthFunc = this.depthFunc;
        if (this.depthTest === false) data.depthTest = this.depthTest;
        if (this.depthWrite === false) data.depthWrite = this.depthWrite;
        if (this.colorWrite === false) data.colorWrite = this.colorWrite;
        if (this.stencilWriteMask !== 0xff) data.stencilWriteMask = this.stencilWriteMask;
        if (this.stencilFunc !== $d5b33d7c30034067$export$14cf96713ddd97a8) data.stencilFunc = this.stencilFunc;
        if (this.stencilRef !== 0) data.stencilRef = this.stencilRef;
        if (this.stencilFuncMask !== 0xff) data.stencilFuncMask = this.stencilFuncMask;
        if (this.stencilFail !== $d5b33d7c30034067$export$9f542ae4b5baca34) data.stencilFail = this.stencilFail;
        if (this.stencilZFail !== $d5b33d7c30034067$export$9f542ae4b5baca34) data.stencilZFail = this.stencilZFail;
        if (this.stencilZPass !== $d5b33d7c30034067$export$9f542ae4b5baca34) data.stencilZPass = this.stencilZPass;
        if (this.stencilWrite === true) data.stencilWrite = this.stencilWrite;
        // rotation (SpriteMaterial)
        if (this.rotation !== undefined && this.rotation !== 0) data.rotation = this.rotation;
        if (this.polygonOffset === true) data.polygonOffset = true;
        if (this.polygonOffsetFactor !== 0) data.polygonOffsetFactor = this.polygonOffsetFactor;
        if (this.polygonOffsetUnits !== 0) data.polygonOffsetUnits = this.polygonOffsetUnits;
        if (this.linewidth !== undefined && this.linewidth !== 1) data.linewidth = this.linewidth;
        if (this.dashSize !== undefined) data.dashSize = this.dashSize;
        if (this.gapSize !== undefined) data.gapSize = this.gapSize;
        if (this.scale !== undefined) data.scale = this.scale;
        if (this.dithering === true) data.dithering = true;
        if (this.alphaTest > 0) data.alphaTest = this.alphaTest;
        if (this.alphaHash === true) data.alphaHash = true;
        if (this.alphaToCoverage === true) data.alphaToCoverage = true;
        if (this.premultipliedAlpha === true) data.premultipliedAlpha = true;
        if (this.forceSinglePass === true) data.forceSinglePass = true;
        if (this.wireframe === true) data.wireframe = true;
        if (this.wireframeLinewidth > 1) data.wireframeLinewidth = this.wireframeLinewidth;
        if (this.wireframeLinecap !== 'round') data.wireframeLinecap = this.wireframeLinecap;
        if (this.wireframeLinejoin !== 'round') data.wireframeLinejoin = this.wireframeLinejoin;
        if (this.flatShading === true) data.flatShading = true;
        if (this.visible === false) data.visible = false;
        if (this.toneMapped === false) data.toneMapped = false;
        if (this.fog === false) data.fog = false;
        if (Object.keys(this.userData).length > 0) data.userData = this.userData;
        // TODO: Copied from Object3D.toJSON
        function extractFromCache(cache) {
            const values = [];
            for(const key in cache){
                const data = cache[key];
                delete data.metadata;
                values.push(data);
            }
            return values;
        }
        if (isRootObject) {
            const textures = extractFromCache(meta.textures);
            const images = extractFromCache(meta.images);
            if (textures.length > 0) data.textures = textures;
            if (images.length > 0) data.images = images;
        }
        return data;
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(source) {
        this.name = source.name;
        this.blending = source.blending;
        this.side = source.side;
        this.vertexColors = source.vertexColors;
        this.opacity = source.opacity;
        this.transparent = source.transparent;
        this.blendSrc = source.blendSrc;
        this.blendDst = source.blendDst;
        this.blendEquation = source.blendEquation;
        this.blendSrcAlpha = source.blendSrcAlpha;
        this.blendDstAlpha = source.blendDstAlpha;
        this.blendEquationAlpha = source.blendEquationAlpha;
        this.blendColor.copy(source.blendColor);
        this.blendAlpha = source.blendAlpha;
        this.depthFunc = source.depthFunc;
        this.depthTest = source.depthTest;
        this.depthWrite = source.depthWrite;
        this.stencilWriteMask = source.stencilWriteMask;
        this.stencilFunc = source.stencilFunc;
        this.stencilRef = source.stencilRef;
        this.stencilFuncMask = source.stencilFuncMask;
        this.stencilFail = source.stencilFail;
        this.stencilZFail = source.stencilZFail;
        this.stencilZPass = source.stencilZPass;
        this.stencilWrite = source.stencilWrite;
        const srcPlanes = source.clippingPlanes;
        let dstPlanes = null;
        if (srcPlanes !== null) {
            const n = srcPlanes.length;
            dstPlanes = new Array(n);
            for(let i = 0; i !== n; ++i)dstPlanes[i] = srcPlanes[i].clone();
        }
        this.clippingPlanes = dstPlanes;
        this.clipIntersection = source.clipIntersection;
        this.clipShadows = source.clipShadows;
        this.shadowSide = source.shadowSide;
        this.colorWrite = source.colorWrite;
        this.precision = source.precision;
        this.polygonOffset = source.polygonOffset;
        this.polygonOffsetFactor = source.polygonOffsetFactor;
        this.polygonOffsetUnits = source.polygonOffsetUnits;
        this.dithering = source.dithering;
        this.alphaTest = source.alphaTest;
        this.alphaHash = source.alphaHash;
        this.alphaToCoverage = source.alphaToCoverage;
        this.premultipliedAlpha = source.premultipliedAlpha;
        this.forceSinglePass = source.forceSinglePass;
        this.visible = source.visible;
        this.toneMapped = source.toneMapped;
        this.userData = JSON.parse(JSON.stringify(source.userData));
        return this;
    }
    dispose() {
        this.dispatchEvent({
            type: 'dispose'
        });
    }
    set needsUpdate(value) {
        if (value === true) this.version++;
    }
    onBuild() {
        console.warn('Material: onBuild() has been removed.'); // @deprecated, r166
    }
}
class $d5b33d7c30034067$export$55cbcc9b622fe1f5 extends $d5b33d7c30034067$export$a2d8b23205c25948 {
    static get type() {
        return 'MeshBasicMaterial';
    }
    constructor(parameters){
        super();
        this.isMeshBasicMaterial = true;
        this.color = new $d5b33d7c30034067$export$892596cec99bc70e(0xffffff); // emissive
        this.map = null;
        this.lightMap = null;
        this.lightMapIntensity = 1.0;
        this.aoMap = null;
        this.aoMapIntensity = 1.0;
        this.specularMap = null;
        this.alphaMap = null;
        this.envMap = null;
        this.envMapRotation = new $d5b33d7c30034067$export$d93cc409a0768c5f();
        this.combine = $d5b33d7c30034067$export$e50ac29801f1774d;
        this.reflectivity = 1;
        this.refractionRatio = 0.98;
        this.wireframe = false;
        this.wireframeLinewidth = 1;
        this.wireframeLinecap = 'round';
        this.wireframeLinejoin = 'round';
        this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.map = source.map;
        this.lightMap = source.lightMap;
        this.lightMapIntensity = source.lightMapIntensity;
        this.aoMap = source.aoMap;
        this.aoMapIntensity = source.aoMapIntensity;
        this.specularMap = source.specularMap;
        this.alphaMap = source.alphaMap;
        this.envMap = source.envMap;
        this.envMapRotation.copy(source.envMapRotation);
        this.combine = source.combine;
        this.reflectivity = source.reflectivity;
        this.refractionRatio = source.refractionRatio;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.wireframeLinecap = source.wireframeLinecap;
        this.wireframeLinejoin = source.wireframeLinejoin;
        this.fog = source.fog;
        return this;
    }
}
// Fast Half Float Conversions, http://www.fox-toolkit.org/ftp/fasthalffloatconversion.pdf
const $d5b33d7c30034067$var$_tables = /*@__PURE__*/ $d5b33d7c30034067$var$_generateTables();
function $d5b33d7c30034067$var$_generateTables() {
    // float32 to float16 helpers
    const buffer = new ArrayBuffer(4);
    const floatView = new Float32Array(buffer);
    const uint32View = new Uint32Array(buffer);
    const baseTable = new Uint32Array(512);
    const shiftTable = new Uint32Array(512);
    for(let i = 0; i < 256; ++i){
        const e = i - 127;
        // very small number (0, -0)
        if (e < -27) {
            baseTable[i] = 0x0000;
            baseTable[i | 0x100] = 0x8000;
            shiftTable[i] = 24;
            shiftTable[i | 0x100] = 24;
        // small number (denorm)
        } else if (e < -14) {
            baseTable[i] = 0x0400 >> -e - 14;
            baseTable[i | 0x100] = 0x0400 >> -e - 14 | 0x8000;
            shiftTable[i] = -e - 1;
            shiftTable[i | 0x100] = -e - 1;
        // normal number
        } else if (e <= 15) {
            baseTable[i] = e + 15 << 10;
            baseTable[i | 0x100] = e + 15 << 10 | 0x8000;
            shiftTable[i] = 13;
            shiftTable[i | 0x100] = 13;
        // large number (Infinity, -Infinity)
        } else if (e < 128) {
            baseTable[i] = 0x7c00;
            baseTable[i | 0x100] = 0xfc00;
            shiftTable[i] = 24;
            shiftTable[i | 0x100] = 24;
        // stay (NaN, Infinity, -Infinity)
        } else {
            baseTable[i] = 0x7c00;
            baseTable[i | 0x100] = 0xfc00;
            shiftTable[i] = 13;
            shiftTable[i | 0x100] = 13;
        }
    }
    // float16 to float32 helpers
    const mantissaTable = new Uint32Array(2048);
    const exponentTable = new Uint32Array(64);
    const offsetTable = new Uint32Array(64);
    for(let i = 1; i < 1024; ++i){
        let m = i << 13; // zero pad mantissa bits
        let e = 0; // zero exponent
        // normalized
        while((m & 0x00800000) === 0){
            m <<= 1;
            e -= 0x00800000; // decrement exponent
        }
        m &= -8388609; // clear leading 1 bit
        e += 0x38800000; // adjust bias
        mantissaTable[i] = m | e;
    }
    for(let i = 1024; i < 2048; ++i)mantissaTable[i] = 0x38000000 + (i - 1024 << 13);
    for(let i = 1; i < 31; ++i)exponentTable[i] = i << 23;
    exponentTable[31] = 0x47800000;
    exponentTable[32] = 0x80000000;
    for(let i = 33; i < 63; ++i)exponentTable[i] = 0x80000000 + (i - 32 << 23);
    exponentTable[63] = 0xc7800000;
    for(let i = 1; i < 64; ++i)if (i !== 32) offsetTable[i] = 1024;
    return {
        floatView: floatView,
        uint32View: uint32View,
        baseTable: baseTable,
        shiftTable: shiftTable,
        mantissaTable: mantissaTable,
        exponentTable: exponentTable,
        offsetTable: offsetTable
    };
}
// float32 to float16
function $d5b33d7c30034067$var$toHalfFloat(val) {
    if (Math.abs(val) > 65504) console.warn('THREE.DataUtils.toHalfFloat(): Value out of range.');
    val = $d5b33d7c30034067$var$clamp(val, -65504, 65504);
    $d5b33d7c30034067$var$_tables.floatView[0] = val;
    const f = $d5b33d7c30034067$var$_tables.uint32View[0];
    const e = f >> 23 & 0x1ff;
    return $d5b33d7c30034067$var$_tables.baseTable[e] + ((f & 0x007fffff) >> $d5b33d7c30034067$var$_tables.shiftTable[e]);
}
// float16 to float32
function $d5b33d7c30034067$var$fromHalfFloat(val) {
    const m = val >> 10;
    $d5b33d7c30034067$var$_tables.uint32View[0] = $d5b33d7c30034067$var$_tables.mantissaTable[$d5b33d7c30034067$var$_tables.offsetTable[m] + (val & 0x3ff)] + $d5b33d7c30034067$var$_tables.exponentTable[m];
    return $d5b33d7c30034067$var$_tables.floatView[0];
}
const $d5b33d7c30034067$export$11ce8b759162cc80 = {
    toHalfFloat: $d5b33d7c30034067$var$toHalfFloat,
    fromHalfFloat: $d5b33d7c30034067$var$fromHalfFloat
};
const $d5b33d7c30034067$var$_vector$9 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_vector2$1 = /*@__PURE__*/ new $d5b33d7c30034067$export$c977b3e384af9ae1();
class $d5b33d7c30034067$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized = false){
        if (Array.isArray(array)) throw new TypeError('THREE.BufferAttribute: array should be a Typed Array.');
        this.isBufferAttribute = true;
        this.name = '';
        this.array = array;
        this.itemSize = itemSize;
        this.count = array !== undefined ? array.length / itemSize : 0;
        this.normalized = normalized;
        this.usage = $d5b33d7c30034067$export$763e8360f4d7f77d;
        this.updateRanges = [];
        this.gpuType = $d5b33d7c30034067$export$f6d331659b644596;
        this.version = 0;
    }
    onUploadCallback() {}
    set needsUpdate(value) {
        if (value === true) this.version++;
    }
    setUsage(value) {
        this.usage = value;
        return this;
    }
    addUpdateRange(start, count) {
        this.updateRanges.push({
            start: start,
            count: count
        });
    }
    clearUpdateRanges() {
        this.updateRanges.length = 0;
    }
    copy(source) {
        this.name = source.name;
        this.array = new source.array.constructor(source.array);
        this.itemSize = source.itemSize;
        this.count = source.count;
        this.normalized = source.normalized;
        this.usage = source.usage;
        this.gpuType = source.gpuType;
        return this;
    }
    copyAt(index1, attribute, index2) {
        index1 *= this.itemSize;
        index2 *= attribute.itemSize;
        for(let i = 0, l = this.itemSize; i < l; i++)this.array[index1 + i] = attribute.array[index2 + i];
        return this;
    }
    copyArray(array) {
        this.array.set(array);
        return this;
    }
    applyMatrix3(m) {
        if (this.itemSize === 2) for(let i = 0, l = this.count; i < l; i++){
            $d5b33d7c30034067$var$_vector2$1.fromBufferAttribute(this, i);
            $d5b33d7c30034067$var$_vector2$1.applyMatrix3(m);
            this.setXY(i, $d5b33d7c30034067$var$_vector2$1.x, $d5b33d7c30034067$var$_vector2$1.y);
        }
        else if (this.itemSize === 3) for(let i = 0, l = this.count; i < l; i++){
            $d5b33d7c30034067$var$_vector$9.fromBufferAttribute(this, i);
            $d5b33d7c30034067$var$_vector$9.applyMatrix3(m);
            this.setXYZ(i, $d5b33d7c30034067$var$_vector$9.x, $d5b33d7c30034067$var$_vector$9.y, $d5b33d7c30034067$var$_vector$9.z);
        }
        return this;
    }
    applyMatrix4(m) {
        for(let i = 0, l = this.count; i < l; i++){
            $d5b33d7c30034067$var$_vector$9.fromBufferAttribute(this, i);
            $d5b33d7c30034067$var$_vector$9.applyMatrix4(m);
            this.setXYZ(i, $d5b33d7c30034067$var$_vector$9.x, $d5b33d7c30034067$var$_vector$9.y, $d5b33d7c30034067$var$_vector$9.z);
        }
        return this;
    }
    applyNormalMatrix(m) {
        for(let i = 0, l = this.count; i < l; i++){
            $d5b33d7c30034067$var$_vector$9.fromBufferAttribute(this, i);
            $d5b33d7c30034067$var$_vector$9.applyNormalMatrix(m);
            this.setXYZ(i, $d5b33d7c30034067$var$_vector$9.x, $d5b33d7c30034067$var$_vector$9.y, $d5b33d7c30034067$var$_vector$9.z);
        }
        return this;
    }
    transformDirection(m) {
        for(let i = 0, l = this.count; i < l; i++){
            $d5b33d7c30034067$var$_vector$9.fromBufferAttribute(this, i);
            $d5b33d7c30034067$var$_vector$9.transformDirection(m);
            this.setXYZ(i, $d5b33d7c30034067$var$_vector$9.x, $d5b33d7c30034067$var$_vector$9.y, $d5b33d7c30034067$var$_vector$9.z);
        }
        return this;
    }
    set(value, offset = 0) {
        // Matching BufferAttribute constructor, do not normalize the array.
        this.array.set(value, offset);
        return this;
    }
    getComponent(index, component) {
        let value = this.array[index * this.itemSize + component];
        if (this.normalized) value = $d5b33d7c30034067$var$denormalize(value, this.array);
        return value;
    }
    setComponent(index, component, value) {
        if (this.normalized) value = $d5b33d7c30034067$var$normalize(value, this.array);
        this.array[index * this.itemSize + component] = value;
        return this;
    }
    getX(index) {
        let x = this.array[index * this.itemSize];
        if (this.normalized) x = $d5b33d7c30034067$var$denormalize(x, this.array);
        return x;
    }
    setX(index, x) {
        if (this.normalized) x = $d5b33d7c30034067$var$normalize(x, this.array);
        this.array[index * this.itemSize] = x;
        return this;
    }
    getY(index) {
        let y = this.array[index * this.itemSize + 1];
        if (this.normalized) y = $d5b33d7c30034067$var$denormalize(y, this.array);
        return y;
    }
    setY(index, y) {
        if (this.normalized) y = $d5b33d7c30034067$var$normalize(y, this.array);
        this.array[index * this.itemSize + 1] = y;
        return this;
    }
    getZ(index) {
        let z = this.array[index * this.itemSize + 2];
        if (this.normalized) z = $d5b33d7c30034067$var$denormalize(z, this.array);
        return z;
    }
    setZ(index, z) {
        if (this.normalized) z = $d5b33d7c30034067$var$normalize(z, this.array);
        this.array[index * this.itemSize + 2] = z;
        return this;
    }
    getW(index) {
        let w = this.array[index * this.itemSize + 3];
        if (this.normalized) w = $d5b33d7c30034067$var$denormalize(w, this.array);
        return w;
    }
    setW(index, w) {
        if (this.normalized) w = $d5b33d7c30034067$var$normalize(w, this.array);
        this.array[index * this.itemSize + 3] = w;
        return this;
    }
    setXY(index, x, y) {
        index *= this.itemSize;
        if (this.normalized) {
            x = $d5b33d7c30034067$var$normalize(x, this.array);
            y = $d5b33d7c30034067$var$normalize(y, this.array);
        }
        this.array[index + 0] = x;
        this.array[index + 1] = y;
        return this;
    }
    setXYZ(index, x, y, z) {
        index *= this.itemSize;
        if (this.normalized) {
            x = $d5b33d7c30034067$var$normalize(x, this.array);
            y = $d5b33d7c30034067$var$normalize(y, this.array);
            z = $d5b33d7c30034067$var$normalize(z, this.array);
        }
        this.array[index + 0] = x;
        this.array[index + 1] = y;
        this.array[index + 2] = z;
        return this;
    }
    setXYZW(index, x, y, z, w) {
        index *= this.itemSize;
        if (this.normalized) {
            x = $d5b33d7c30034067$var$normalize(x, this.array);
            y = $d5b33d7c30034067$var$normalize(y, this.array);
            z = $d5b33d7c30034067$var$normalize(z, this.array);
            w = $d5b33d7c30034067$var$normalize(w, this.array);
        }
        this.array[index + 0] = x;
        this.array[index + 1] = y;
        this.array[index + 2] = z;
        this.array[index + 3] = w;
        return this;
    }
    onUpload(callback) {
        this.onUploadCallback = callback;
        return this;
    }
    clone() {
        return new this.constructor(this.array, this.itemSize).copy(this);
    }
    toJSON() {
        const data = {
            itemSize: this.itemSize,
            type: this.array.constructor.name,
            array: Array.from(this.array),
            normalized: this.normalized
        };
        if (this.name !== '') data.name = this.name;
        if (this.usage !== $d5b33d7c30034067$export$763e8360f4d7f77d) data.usage = this.usage;
        return data;
    }
}
//
class $d5b33d7c30034067$export$f9ff2d6a20248cbf extends $d5b33d7c30034067$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Int8Array(array), itemSize, normalized);
    }
}
class $d5b33d7c30034067$export$cacc90cf35d11cdd extends $d5b33d7c30034067$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Uint8Array(array), itemSize, normalized);
    }
}
class $d5b33d7c30034067$export$baaa85a1a812c157 extends $d5b33d7c30034067$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Uint8ClampedArray(array), itemSize, normalized);
    }
}
class $d5b33d7c30034067$export$2b755a102ccdcefe extends $d5b33d7c30034067$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Int16Array(array), itemSize, normalized);
    }
}
class $d5b33d7c30034067$export$640a853f68025f2e extends $d5b33d7c30034067$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Uint16Array(array), itemSize, normalized);
    }
}
class $d5b33d7c30034067$export$46b369aed2968a0a extends $d5b33d7c30034067$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Int32Array(array), itemSize, normalized);
    }
}
class $d5b33d7c30034067$export$7eb8c9fa25cd5bd6 extends $d5b33d7c30034067$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Uint32Array(array), itemSize, normalized);
    }
}
class $d5b33d7c30034067$export$dbd3698c64958d69 extends $d5b33d7c30034067$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Uint16Array(array), itemSize, normalized);
        this.isFloat16BufferAttribute = true;
    }
    getX(index) {
        let x = $d5b33d7c30034067$var$fromHalfFloat(this.array[index * this.itemSize]);
        if (this.normalized) x = $d5b33d7c30034067$var$denormalize(x, this.array);
        return x;
    }
    setX(index, x) {
        if (this.normalized) x = $d5b33d7c30034067$var$normalize(x, this.array);
        this.array[index * this.itemSize] = $d5b33d7c30034067$var$toHalfFloat(x);
        return this;
    }
    getY(index) {
        let y = $d5b33d7c30034067$var$fromHalfFloat(this.array[index * this.itemSize + 1]);
        if (this.normalized) y = $d5b33d7c30034067$var$denormalize(y, this.array);
        return y;
    }
    setY(index, y) {
        if (this.normalized) y = $d5b33d7c30034067$var$normalize(y, this.array);
        this.array[index * this.itemSize + 1] = $d5b33d7c30034067$var$toHalfFloat(y);
        return this;
    }
    getZ(index) {
        let z = $d5b33d7c30034067$var$fromHalfFloat(this.array[index * this.itemSize + 2]);
        if (this.normalized) z = $d5b33d7c30034067$var$denormalize(z, this.array);
        return z;
    }
    setZ(index, z) {
        if (this.normalized) z = $d5b33d7c30034067$var$normalize(z, this.array);
        this.array[index * this.itemSize + 2] = $d5b33d7c30034067$var$toHalfFloat(z);
        return this;
    }
    getW(index) {
        let w = $d5b33d7c30034067$var$fromHalfFloat(this.array[index * this.itemSize + 3]);
        if (this.normalized) w = $d5b33d7c30034067$var$denormalize(w, this.array);
        return w;
    }
    setW(index, w) {
        if (this.normalized) w = $d5b33d7c30034067$var$normalize(w, this.array);
        this.array[index * this.itemSize + 3] = $d5b33d7c30034067$var$toHalfFloat(w);
        return this;
    }
    setXY(index, x, y) {
        index *= this.itemSize;
        if (this.normalized) {
            x = $d5b33d7c30034067$var$normalize(x, this.array);
            y = $d5b33d7c30034067$var$normalize(y, this.array);
        }
        this.array[index + 0] = $d5b33d7c30034067$var$toHalfFloat(x);
        this.array[index + 1] = $d5b33d7c30034067$var$toHalfFloat(y);
        return this;
    }
    setXYZ(index, x, y, z) {
        index *= this.itemSize;
        if (this.normalized) {
            x = $d5b33d7c30034067$var$normalize(x, this.array);
            y = $d5b33d7c30034067$var$normalize(y, this.array);
            z = $d5b33d7c30034067$var$normalize(z, this.array);
        }
        this.array[index + 0] = $d5b33d7c30034067$var$toHalfFloat(x);
        this.array[index + 1] = $d5b33d7c30034067$var$toHalfFloat(y);
        this.array[index + 2] = $d5b33d7c30034067$var$toHalfFloat(z);
        return this;
    }
    setXYZW(index, x, y, z, w) {
        index *= this.itemSize;
        if (this.normalized) {
            x = $d5b33d7c30034067$var$normalize(x, this.array);
            y = $d5b33d7c30034067$var$normalize(y, this.array);
            z = $d5b33d7c30034067$var$normalize(z, this.array);
            w = $d5b33d7c30034067$var$normalize(w, this.array);
        }
        this.array[index + 0] = $d5b33d7c30034067$var$toHalfFloat(x);
        this.array[index + 1] = $d5b33d7c30034067$var$toHalfFloat(y);
        this.array[index + 2] = $d5b33d7c30034067$var$toHalfFloat(z);
        this.array[index + 3] = $d5b33d7c30034067$var$toHalfFloat(w);
        return this;
    }
}
class $d5b33d7c30034067$export$cbe7a62641830ebd extends $d5b33d7c30034067$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Float32Array(array), itemSize, normalized);
    }
}
let $d5b33d7c30034067$var$_id$2 = 0;
const $d5b33d7c30034067$var$_m1$2 = /*@__PURE__*/ new $d5b33d7c30034067$export$2ae72fc923e5eb5();
const $d5b33d7c30034067$var$_obj = /*@__PURE__*/ new $d5b33d7c30034067$export$e4dd07dff30cc924();
const $d5b33d7c30034067$var$_offset = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_box$2 = /*@__PURE__*/ new $d5b33d7c30034067$export$6f7d5a9418ab2aa3();
const $d5b33d7c30034067$var$_boxMorphTargets = /*@__PURE__*/ new $d5b33d7c30034067$export$6f7d5a9418ab2aa3();
const $d5b33d7c30034067$var$_vector$8 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
class $d5b33d7c30034067$export$b7be63a67df8959 extends $d5b33d7c30034067$export$ec8b666c5fe2c75a {
    constructor(){
        super();
        this.isBufferGeometry = true;
        Object.defineProperty(this, 'id', {
            value: $d5b33d7c30034067$var$_id$2++
        });
        this.uuid = $d5b33d7c30034067$var$generateUUID();
        this.name = '';
        this.type = 'BufferGeometry';
        this.index = null;
        this.indirect = null;
        this.attributes = {};
        this.morphAttributes = {};
        this.morphTargetsRelative = false;
        this.groups = [];
        this.boundingBox = null;
        this.boundingSphere = null;
        this.drawRange = {
            start: 0,
            count: Infinity
        };
        this.userData = {};
    }
    getIndex() {
        return this.index;
    }
    setIndex(index) {
        if (Array.isArray(index)) this.index = new ($d5b33d7c30034067$var$arrayNeedsUint32(index) ? $d5b33d7c30034067$export$7eb8c9fa25cd5bd6 : $d5b33d7c30034067$export$640a853f68025f2e)(index, 1);
        else this.index = index;
        return this;
    }
    setIndirect(indirect) {
        this.indirect = indirect;
        return this;
    }
    getIndirect() {
        return this.indirect;
    }
    getAttribute(name) {
        return this.attributes[name];
    }
    setAttribute(name, attribute) {
        this.attributes[name] = attribute;
        return this;
    }
    deleteAttribute(name) {
        delete this.attributes[name];
        return this;
    }
    hasAttribute(name) {
        return this.attributes[name] !== undefined;
    }
    addGroup(start, count, materialIndex = 0) {
        this.groups.push({
            start: start,
            count: count,
            materialIndex: materialIndex
        });
    }
    clearGroups() {
        this.groups = [];
    }
    setDrawRange(start, count) {
        this.drawRange.start = start;
        this.drawRange.count = count;
    }
    applyMatrix4(matrix) {
        const position = this.attributes.position;
        if (position !== undefined) {
            position.applyMatrix4(matrix);
            position.needsUpdate = true;
        }
        const normal = this.attributes.normal;
        if (normal !== undefined) {
            const normalMatrix = new $d5b33d7c30034067$export$8ff26dafa08918().getNormalMatrix(matrix);
            normal.applyNormalMatrix(normalMatrix);
            normal.needsUpdate = true;
        }
        const tangent = this.attributes.tangent;
        if (tangent !== undefined) {
            tangent.transformDirection(matrix);
            tangent.needsUpdate = true;
        }
        if (this.boundingBox !== null) this.computeBoundingBox();
        if (this.boundingSphere !== null) this.computeBoundingSphere();
        return this;
    }
    applyQuaternion(q) {
        $d5b33d7c30034067$var$_m1$2.makeRotationFromQuaternion(q);
        this.applyMatrix4($d5b33d7c30034067$var$_m1$2);
        return this;
    }
    rotateX(angle) {
        // rotate geometry around world x-axis
        $d5b33d7c30034067$var$_m1$2.makeRotationX(angle);
        this.applyMatrix4($d5b33d7c30034067$var$_m1$2);
        return this;
    }
    rotateY(angle) {
        // rotate geometry around world y-axis
        $d5b33d7c30034067$var$_m1$2.makeRotationY(angle);
        this.applyMatrix4($d5b33d7c30034067$var$_m1$2);
        return this;
    }
    rotateZ(angle) {
        // rotate geometry around world z-axis
        $d5b33d7c30034067$var$_m1$2.makeRotationZ(angle);
        this.applyMatrix4($d5b33d7c30034067$var$_m1$2);
        return this;
    }
    translate(x, y, z) {
        // translate geometry
        $d5b33d7c30034067$var$_m1$2.makeTranslation(x, y, z);
        this.applyMatrix4($d5b33d7c30034067$var$_m1$2);
        return this;
    }
    scale(x, y, z) {
        // scale geometry
        $d5b33d7c30034067$var$_m1$2.makeScale(x, y, z);
        this.applyMatrix4($d5b33d7c30034067$var$_m1$2);
        return this;
    }
    lookAt(vector) {
        $d5b33d7c30034067$var$_obj.lookAt(vector);
        $d5b33d7c30034067$var$_obj.updateMatrix();
        this.applyMatrix4($d5b33d7c30034067$var$_obj.matrix);
        return this;
    }
    center() {
        this.computeBoundingBox();
        this.boundingBox.getCenter($d5b33d7c30034067$var$_offset).negate();
        this.translate($d5b33d7c30034067$var$_offset.x, $d5b33d7c30034067$var$_offset.y, $d5b33d7c30034067$var$_offset.z);
        return this;
    }
    setFromPoints(points) {
        const positionAttribute = this.getAttribute('position');
        if (positionAttribute === undefined) {
            const position = [];
            for(let i = 0, l = points.length; i < l; i++){
                const point = points[i];
                position.push(point.x, point.y, point.z || 0);
            }
            this.setAttribute('position', new $d5b33d7c30034067$export$cbe7a62641830ebd(position, 3));
        } else {
            for(let i = 0, l = positionAttribute.count; i < l; i++){
                const point = points[i];
                positionAttribute.setXYZ(i, point.x, point.y, point.z || 0);
            }
            if (points.length > positionAttribute.count) console.warn('THREE.BufferGeometry: Buffer size too small for points data. Use .dispose() and create a new geometry.');
            positionAttribute.needsUpdate = true;
        }
        return this;
    }
    computeBoundingBox() {
        if (this.boundingBox === null) this.boundingBox = new $d5b33d7c30034067$export$6f7d5a9418ab2aa3();
        const position = this.attributes.position;
        const morphAttributesPosition = this.morphAttributes.position;
        if (position && position.isGLBufferAttribute) {
            console.error('THREE.BufferGeometry.computeBoundingBox(): GLBufferAttribute requires a manual bounding box.', this);
            this.boundingBox.set(new $d5b33d7c30034067$export$64b5c384219d3699(-Infinity, -Infinity, -Infinity), new $d5b33d7c30034067$export$64b5c384219d3699(Infinity, Infinity, Infinity));
            return;
        }
        if (position !== undefined) {
            this.boundingBox.setFromBufferAttribute(position);
            // process morph attributes if present
            if (morphAttributesPosition) for(let i = 0, il = morphAttributesPosition.length; i < il; i++){
                const morphAttribute = morphAttributesPosition[i];
                $d5b33d7c30034067$var$_box$2.setFromBufferAttribute(morphAttribute);
                if (this.morphTargetsRelative) {
                    $d5b33d7c30034067$var$_vector$8.addVectors(this.boundingBox.min, $d5b33d7c30034067$var$_box$2.min);
                    this.boundingBox.expandByPoint($d5b33d7c30034067$var$_vector$8);
                    $d5b33d7c30034067$var$_vector$8.addVectors(this.boundingBox.max, $d5b33d7c30034067$var$_box$2.max);
                    this.boundingBox.expandByPoint($d5b33d7c30034067$var$_vector$8);
                } else {
                    this.boundingBox.expandByPoint($d5b33d7c30034067$var$_box$2.min);
                    this.boundingBox.expandByPoint($d5b33d7c30034067$var$_box$2.max);
                }
            }
        } else this.boundingBox.makeEmpty();
        if (isNaN(this.boundingBox.min.x) || isNaN(this.boundingBox.min.y) || isNaN(this.boundingBox.min.z)) console.error('THREE.BufferGeometry.computeBoundingBox(): Computed min/max have NaN values. The "position" attribute is likely to have NaN values.', this);
    }
    computeBoundingSphere() {
        if (this.boundingSphere === null) this.boundingSphere = new $d5b33d7c30034067$export$805e8b72413ccaba();
        const position = this.attributes.position;
        const morphAttributesPosition = this.morphAttributes.position;
        if (position && position.isGLBufferAttribute) {
            console.error('THREE.BufferGeometry.computeBoundingSphere(): GLBufferAttribute requires a manual bounding sphere.', this);
            this.boundingSphere.set(new $d5b33d7c30034067$export$64b5c384219d3699(), Infinity);
            return;
        }
        if (position) {
            // first, find the center of the bounding sphere
            const center = this.boundingSphere.center;
            $d5b33d7c30034067$var$_box$2.setFromBufferAttribute(position);
            // process morph attributes if present
            if (morphAttributesPosition) for(let i = 0, il = morphAttributesPosition.length; i < il; i++){
                const morphAttribute = morphAttributesPosition[i];
                $d5b33d7c30034067$var$_boxMorphTargets.setFromBufferAttribute(morphAttribute);
                if (this.morphTargetsRelative) {
                    $d5b33d7c30034067$var$_vector$8.addVectors($d5b33d7c30034067$var$_box$2.min, $d5b33d7c30034067$var$_boxMorphTargets.min);
                    $d5b33d7c30034067$var$_box$2.expandByPoint($d5b33d7c30034067$var$_vector$8);
                    $d5b33d7c30034067$var$_vector$8.addVectors($d5b33d7c30034067$var$_box$2.max, $d5b33d7c30034067$var$_boxMorphTargets.max);
                    $d5b33d7c30034067$var$_box$2.expandByPoint($d5b33d7c30034067$var$_vector$8);
                } else {
                    $d5b33d7c30034067$var$_box$2.expandByPoint($d5b33d7c30034067$var$_boxMorphTargets.min);
                    $d5b33d7c30034067$var$_box$2.expandByPoint($d5b33d7c30034067$var$_boxMorphTargets.max);
                }
            }
            $d5b33d7c30034067$var$_box$2.getCenter(center);
            // second, try to find a boundingSphere with a radius smaller than the
            // boundingSphere of the boundingBox: sqrt(3) smaller in the best case
            let maxRadiusSq = 0;
            for(let i = 0, il = position.count; i < il; i++){
                $d5b33d7c30034067$var$_vector$8.fromBufferAttribute(position, i);
                maxRadiusSq = Math.max(maxRadiusSq, center.distanceToSquared($d5b33d7c30034067$var$_vector$8));
            }
            // process morph attributes if present
            if (morphAttributesPosition) for(let i = 0, il = morphAttributesPosition.length; i < il; i++){
                const morphAttribute = morphAttributesPosition[i];
                const morphTargetsRelative = this.morphTargetsRelative;
                for(let j = 0, jl = morphAttribute.count; j < jl; j++){
                    $d5b33d7c30034067$var$_vector$8.fromBufferAttribute(morphAttribute, j);
                    if (morphTargetsRelative) {
                        $d5b33d7c30034067$var$_offset.fromBufferAttribute(position, j);
                        $d5b33d7c30034067$var$_vector$8.add($d5b33d7c30034067$var$_offset);
                    }
                    maxRadiusSq = Math.max(maxRadiusSq, center.distanceToSquared($d5b33d7c30034067$var$_vector$8));
                }
            }
            this.boundingSphere.radius = Math.sqrt(maxRadiusSq);
            if (isNaN(this.boundingSphere.radius)) console.error('THREE.BufferGeometry.computeBoundingSphere(): Computed radius is NaN. The "position" attribute is likely to have NaN values.', this);
        }
    }
    computeTangents() {
        const index = this.index;
        const attributes = this.attributes;
        // based on http://www.terathon.com/code/tangent.html
        // (per vertex tangents)
        if (index === null || attributes.position === undefined || attributes.normal === undefined || attributes.uv === undefined) {
            console.error('THREE.BufferGeometry: .computeTangents() failed. Missing required attributes (index, position, normal or uv)');
            return;
        }
        const positionAttribute = attributes.position;
        const normalAttribute = attributes.normal;
        const uvAttribute = attributes.uv;
        if (this.hasAttribute('tangent') === false) this.setAttribute('tangent', new $d5b33d7c30034067$export$8dea267bd6bde117(new Float32Array(4 * positionAttribute.count), 4));
        const tangentAttribute = this.getAttribute('tangent');
        const tan1 = [], tan2 = [];
        for(let i = 0; i < positionAttribute.count; i++){
            tan1[i] = new $d5b33d7c30034067$export$64b5c384219d3699();
            tan2[i] = new $d5b33d7c30034067$export$64b5c384219d3699();
        }
        const vA = new $d5b33d7c30034067$export$64b5c384219d3699(), vB = new $d5b33d7c30034067$export$64b5c384219d3699(), vC = new $d5b33d7c30034067$export$64b5c384219d3699(), uvA = new $d5b33d7c30034067$export$c977b3e384af9ae1(), uvB = new $d5b33d7c30034067$export$c977b3e384af9ae1(), uvC = new $d5b33d7c30034067$export$c977b3e384af9ae1(), sdir = new $d5b33d7c30034067$export$64b5c384219d3699(), tdir = new $d5b33d7c30034067$export$64b5c384219d3699();
        function handleTriangle(a, b, c) {
            vA.fromBufferAttribute(positionAttribute, a);
            vB.fromBufferAttribute(positionAttribute, b);
            vC.fromBufferAttribute(positionAttribute, c);
            uvA.fromBufferAttribute(uvAttribute, a);
            uvB.fromBufferAttribute(uvAttribute, b);
            uvC.fromBufferAttribute(uvAttribute, c);
            vB.sub(vA);
            vC.sub(vA);
            uvB.sub(uvA);
            uvC.sub(uvA);
            const r = 1.0 / (uvB.x * uvC.y - uvC.x * uvB.y);
            // silently ignore degenerate uv triangles having coincident or colinear vertices
            if (!isFinite(r)) return;
            sdir.copy(vB).multiplyScalar(uvC.y).addScaledVector(vC, -uvB.y).multiplyScalar(r);
            tdir.copy(vC).multiplyScalar(uvB.x).addScaledVector(vB, -uvC.x).multiplyScalar(r);
            tan1[a].add(sdir);
            tan1[b].add(sdir);
            tan1[c].add(sdir);
            tan2[a].add(tdir);
            tan2[b].add(tdir);
            tan2[c].add(tdir);
        }
        let groups = this.groups;
        if (groups.length === 0) groups = [
            {
                start: 0,
                count: index.count
            }
        ];
        for(let i = 0, il = groups.length; i < il; ++i){
            const group = groups[i];
            const start = group.start;
            const count = group.count;
            for(let j = start, jl = start + count; j < jl; j += 3)handleTriangle(index.getX(j + 0), index.getX(j + 1), index.getX(j + 2));
        }
        const tmp = new $d5b33d7c30034067$export$64b5c384219d3699(), tmp2 = new $d5b33d7c30034067$export$64b5c384219d3699();
        const n = new $d5b33d7c30034067$export$64b5c384219d3699(), n2 = new $d5b33d7c30034067$export$64b5c384219d3699();
        function handleVertex(v) {
            n.fromBufferAttribute(normalAttribute, v);
            n2.copy(n);
            const t = tan1[v];
            // Gram-Schmidt orthogonalize
            tmp.copy(t);
            tmp.sub(n.multiplyScalar(n.dot(t))).normalize();
            // Calculate handedness
            tmp2.crossVectors(n2, t);
            const test = tmp2.dot(tan2[v]);
            const w = test < 0.0 ? -1 : 1.0;
            tangentAttribute.setXYZW(v, tmp.x, tmp.y, tmp.z, w);
        }
        for(let i = 0, il = groups.length; i < il; ++i){
            const group = groups[i];
            const start = group.start;
            const count = group.count;
            for(let j = start, jl = start + count; j < jl; j += 3){
                handleVertex(index.getX(j + 0));
                handleVertex(index.getX(j + 1));
                handleVertex(index.getX(j + 2));
            }
        }
    }
    computeVertexNormals() {
        const index = this.index;
        const positionAttribute = this.getAttribute('position');
        if (positionAttribute !== undefined) {
            let normalAttribute = this.getAttribute('normal');
            if (normalAttribute === undefined) {
                normalAttribute = new $d5b33d7c30034067$export$8dea267bd6bde117(new Float32Array(positionAttribute.count * 3), 3);
                this.setAttribute('normal', normalAttribute);
            } else // reset existing normals to zero
            for(let i = 0, il = normalAttribute.count; i < il; i++)normalAttribute.setXYZ(i, 0, 0, 0);
            const pA = new $d5b33d7c30034067$export$64b5c384219d3699(), pB = new $d5b33d7c30034067$export$64b5c384219d3699(), pC = new $d5b33d7c30034067$export$64b5c384219d3699();
            const nA = new $d5b33d7c30034067$export$64b5c384219d3699(), nB = new $d5b33d7c30034067$export$64b5c384219d3699(), nC = new $d5b33d7c30034067$export$64b5c384219d3699();
            const cb = new $d5b33d7c30034067$export$64b5c384219d3699(), ab = new $d5b33d7c30034067$export$64b5c384219d3699();
            // indexed elements
            if (index) for(let i = 0, il = index.count; i < il; i += 3){
                const vA = index.getX(i + 0);
                const vB = index.getX(i + 1);
                const vC = index.getX(i + 2);
                pA.fromBufferAttribute(positionAttribute, vA);
                pB.fromBufferAttribute(positionAttribute, vB);
                pC.fromBufferAttribute(positionAttribute, vC);
                cb.subVectors(pC, pB);
                ab.subVectors(pA, pB);
                cb.cross(ab);
                nA.fromBufferAttribute(normalAttribute, vA);
                nB.fromBufferAttribute(normalAttribute, vB);
                nC.fromBufferAttribute(normalAttribute, vC);
                nA.add(cb);
                nB.add(cb);
                nC.add(cb);
                normalAttribute.setXYZ(vA, nA.x, nA.y, nA.z);
                normalAttribute.setXYZ(vB, nB.x, nB.y, nB.z);
                normalAttribute.setXYZ(vC, nC.x, nC.y, nC.z);
            }
            else // non-indexed elements (unconnected triangle soup)
            for(let i = 0, il = positionAttribute.count; i < il; i += 3){
                pA.fromBufferAttribute(positionAttribute, i + 0);
                pB.fromBufferAttribute(positionAttribute, i + 1);
                pC.fromBufferAttribute(positionAttribute, i + 2);
                cb.subVectors(pC, pB);
                ab.subVectors(pA, pB);
                cb.cross(ab);
                normalAttribute.setXYZ(i + 0, cb.x, cb.y, cb.z);
                normalAttribute.setXYZ(i + 1, cb.x, cb.y, cb.z);
                normalAttribute.setXYZ(i + 2, cb.x, cb.y, cb.z);
            }
            this.normalizeNormals();
            normalAttribute.needsUpdate = true;
        }
    }
    normalizeNormals() {
        const normals = this.attributes.normal;
        for(let i = 0, il = normals.count; i < il; i++){
            $d5b33d7c30034067$var$_vector$8.fromBufferAttribute(normals, i);
            $d5b33d7c30034067$var$_vector$8.normalize();
            normals.setXYZ(i, $d5b33d7c30034067$var$_vector$8.x, $d5b33d7c30034067$var$_vector$8.y, $d5b33d7c30034067$var$_vector$8.z);
        }
    }
    toNonIndexed() {
        function convertBufferAttribute(attribute, indices) {
            const array = attribute.array;
            const itemSize = attribute.itemSize;
            const normalized = attribute.normalized;
            const array2 = new array.constructor(indices.length * itemSize);
            let index = 0, index2 = 0;
            for(let i = 0, l = indices.length; i < l; i++){
                if (attribute.isInterleavedBufferAttribute) index = indices[i] * attribute.data.stride + attribute.offset;
                else index = indices[i] * itemSize;
                for(let j = 0; j < itemSize; j++)array2[index2++] = array[index++];
            }
            return new $d5b33d7c30034067$export$8dea267bd6bde117(array2, itemSize, normalized);
        }
        //
        if (this.index === null) {
            console.warn('THREE.BufferGeometry.toNonIndexed(): BufferGeometry is already non-indexed.');
            return this;
        }
        const geometry2 = new $d5b33d7c30034067$export$b7be63a67df8959();
        const indices = this.index.array;
        const attributes = this.attributes;
        // attributes
        for(const name in attributes){
            const attribute = attributes[name];
            const newAttribute = convertBufferAttribute(attribute, indices);
            geometry2.setAttribute(name, newAttribute);
        }
        // morph attributes
        const morphAttributes = this.morphAttributes;
        for(const name in morphAttributes){
            const morphArray = [];
            const morphAttribute = morphAttributes[name]; // morphAttribute: array of Float32BufferAttributes
            for(let i = 0, il = morphAttribute.length; i < il; i++){
                const attribute = morphAttribute[i];
                const newAttribute = convertBufferAttribute(attribute, indices);
                morphArray.push(newAttribute);
            }
            geometry2.morphAttributes[name] = morphArray;
        }
        geometry2.morphTargetsRelative = this.morphTargetsRelative;
        // groups
        const groups = this.groups;
        for(let i = 0, l = groups.length; i < l; i++){
            const group = groups[i];
            geometry2.addGroup(group.start, group.count, group.materialIndex);
        }
        return geometry2;
    }
    toJSON() {
        const data = {
            metadata: {
                version: 4.6,
                type: 'BufferGeometry',
                generator: 'BufferGeometry.toJSON'
            }
        };
        // standard BufferGeometry serialization
        data.uuid = this.uuid;
        data.type = this.type;
        if (this.name !== '') data.name = this.name;
        if (Object.keys(this.userData).length > 0) data.userData = this.userData;
        if (this.parameters !== undefined) {
            const parameters = this.parameters;
            for(const key in parameters)if (parameters[key] !== undefined) data[key] = parameters[key];
            return data;
        }
        // for simplicity the code assumes attributes are not shared across geometries, see #15811
        data.data = {
            attributes: {}
        };
        const index = this.index;
        if (index !== null) data.data.index = {
            type: index.array.constructor.name,
            array: Array.prototype.slice.call(index.array)
        };
        const attributes = this.attributes;
        for(const key in attributes){
            const attribute = attributes[key];
            data.data.attributes[key] = attribute.toJSON(data.data);
        }
        const morphAttributes = {};
        let hasMorphAttributes = false;
        for(const key in this.morphAttributes){
            const attributeArray = this.morphAttributes[key];
            const array = [];
            for(let i = 0, il = attributeArray.length; i < il; i++){
                const attribute = attributeArray[i];
                array.push(attribute.toJSON(data.data));
            }
            if (array.length > 0) {
                morphAttributes[key] = array;
                hasMorphAttributes = true;
            }
        }
        if (hasMorphAttributes) {
            data.data.morphAttributes = morphAttributes;
            data.data.morphTargetsRelative = this.morphTargetsRelative;
        }
        const groups = this.groups;
        if (groups.length > 0) data.data.groups = JSON.parse(JSON.stringify(groups));
        const boundingSphere = this.boundingSphere;
        if (boundingSphere !== null) data.data.boundingSphere = {
            center: boundingSphere.center.toArray(),
            radius: boundingSphere.radius
        };
        return data;
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(source) {
        // reset
        this.index = null;
        this.attributes = {};
        this.morphAttributes = {};
        this.groups = [];
        this.boundingBox = null;
        this.boundingSphere = null;
        // used for storing cloned, shared data
        const data = {};
        // name
        this.name = source.name;
        // index
        const index = source.index;
        if (index !== null) this.setIndex(index.clone(data));
        // attributes
        const attributes = source.attributes;
        for(const name in attributes){
            const attribute = attributes[name];
            this.setAttribute(name, attribute.clone(data));
        }
        // morph attributes
        const morphAttributes = source.morphAttributes;
        for(const name in morphAttributes){
            const array = [];
            const morphAttribute = morphAttributes[name]; // morphAttribute: array of Float32BufferAttributes
            for(let i = 0, l = morphAttribute.length; i < l; i++)array.push(morphAttribute[i].clone(data));
            this.morphAttributes[name] = array;
        }
        this.morphTargetsRelative = source.morphTargetsRelative;
        // groups
        const groups = source.groups;
        for(let i = 0, l = groups.length; i < l; i++){
            const group = groups[i];
            this.addGroup(group.start, group.count, group.materialIndex);
        }
        // bounding box
        const boundingBox = source.boundingBox;
        if (boundingBox !== null) this.boundingBox = boundingBox.clone();
        // bounding sphere
        const boundingSphere = source.boundingSphere;
        if (boundingSphere !== null) this.boundingSphere = boundingSphere.clone();
        // draw range
        this.drawRange.start = source.drawRange.start;
        this.drawRange.count = source.drawRange.count;
        // user data
        this.userData = source.userData;
        return this;
    }
    dispose() {
        this.dispatchEvent({
            type: 'dispose'
        });
    }
}
const $d5b33d7c30034067$var$_inverseMatrix$3 = /*@__PURE__*/ new $d5b33d7c30034067$export$2ae72fc923e5eb5();
const $d5b33d7c30034067$var$_ray$3 = /*@__PURE__*/ new $d5b33d7c30034067$export$a186db52eed6d40e();
const $d5b33d7c30034067$var$_sphere$6 = /*@__PURE__*/ new $d5b33d7c30034067$export$805e8b72413ccaba();
const $d5b33d7c30034067$var$_sphereHitAt = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_vA$1 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_vB$1 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_vC$1 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_tempA = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_morphA = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_intersectionPoint = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_intersectionPointWorld = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
class $d5b33d7c30034067$export$e176487c05830cc5 extends $d5b33d7c30034067$export$e4dd07dff30cc924 {
    constructor(geometry = new $d5b33d7c30034067$export$b7be63a67df8959(), material = new $d5b33d7c30034067$export$55cbcc9b622fe1f5()){
        super();
        this.isMesh = true;
        this.type = 'Mesh';
        this.geometry = geometry;
        this.material = material;
        this.updateMorphTargets();
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        if (source.morphTargetInfluences !== undefined) this.morphTargetInfluences = source.morphTargetInfluences.slice();
        if (source.morphTargetDictionary !== undefined) this.morphTargetDictionary = Object.assign({}, source.morphTargetDictionary);
        this.material = Array.isArray(source.material) ? source.material.slice() : source.material;
        this.geometry = source.geometry;
        return this;
    }
    updateMorphTargets() {
        const geometry = this.geometry;
        const morphAttributes = geometry.morphAttributes;
        const keys = Object.keys(morphAttributes);
        if (keys.length > 0) {
            const morphAttribute = morphAttributes[keys[0]];
            if (morphAttribute !== undefined) {
                this.morphTargetInfluences = [];
                this.morphTargetDictionary = {};
                for(let m = 0, ml = morphAttribute.length; m < ml; m++){
                    const name = morphAttribute[m].name || String(m);
                    this.morphTargetInfluences.push(0);
                    this.morphTargetDictionary[name] = m;
                }
            }
        }
    }
    getVertexPosition(index, target) {
        const geometry = this.geometry;
        const position = geometry.attributes.position;
        const morphPosition = geometry.morphAttributes.position;
        const morphTargetsRelative = geometry.morphTargetsRelative;
        target.fromBufferAttribute(position, index);
        const morphInfluences = this.morphTargetInfluences;
        if (morphPosition && morphInfluences) {
            $d5b33d7c30034067$var$_morphA.set(0, 0, 0);
            for(let i = 0, il = morphPosition.length; i < il; i++){
                const influence = morphInfluences[i];
                const morphAttribute = morphPosition[i];
                if (influence === 0) continue;
                $d5b33d7c30034067$var$_tempA.fromBufferAttribute(morphAttribute, index);
                if (morphTargetsRelative) $d5b33d7c30034067$var$_morphA.addScaledVector($d5b33d7c30034067$var$_tempA, influence);
                else $d5b33d7c30034067$var$_morphA.addScaledVector($d5b33d7c30034067$var$_tempA.sub(target), influence);
            }
            target.add($d5b33d7c30034067$var$_morphA);
        }
        return target;
    }
    raycast(raycaster, intersects) {
        const geometry = this.geometry;
        const material = this.material;
        const matrixWorld = this.matrixWorld;
        if (material === undefined) return;
        // test with bounding sphere in world space
        if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
        $d5b33d7c30034067$var$_sphere$6.copy(geometry.boundingSphere);
        $d5b33d7c30034067$var$_sphere$6.applyMatrix4(matrixWorld);
        // check distance from ray origin to bounding sphere
        $d5b33d7c30034067$var$_ray$3.copy(raycaster.ray).recast(raycaster.near);
        if ($d5b33d7c30034067$var$_sphere$6.containsPoint($d5b33d7c30034067$var$_ray$3.origin) === false) {
            if ($d5b33d7c30034067$var$_ray$3.intersectSphere($d5b33d7c30034067$var$_sphere$6, $d5b33d7c30034067$var$_sphereHitAt) === null) return;
            if ($d5b33d7c30034067$var$_ray$3.origin.distanceToSquared($d5b33d7c30034067$var$_sphereHitAt) > (raycaster.far - raycaster.near) ** 2) return;
        }
        // convert ray to local space of mesh
        $d5b33d7c30034067$var$_inverseMatrix$3.copy(matrixWorld).invert();
        $d5b33d7c30034067$var$_ray$3.copy(raycaster.ray).applyMatrix4($d5b33d7c30034067$var$_inverseMatrix$3);
        // test with bounding box in local space
        if (geometry.boundingBox !== null) {
            if ($d5b33d7c30034067$var$_ray$3.intersectsBox(geometry.boundingBox) === false) return;
        }
        // test for intersections with geometry
        this._computeIntersections(raycaster, intersects, $d5b33d7c30034067$var$_ray$3);
    }
    _computeIntersections(raycaster, intersects, rayLocalSpace) {
        let intersection;
        const geometry = this.geometry;
        const material = this.material;
        const index = geometry.index;
        const position = geometry.attributes.position;
        const uv = geometry.attributes.uv;
        const uv1 = geometry.attributes.uv1;
        const normal = geometry.attributes.normal;
        const groups = geometry.groups;
        const drawRange = geometry.drawRange;
        if (index !== null) {
            // indexed buffer geometry
            if (Array.isArray(material)) for(let i = 0, il = groups.length; i < il; i++){
                const group = groups[i];
                const groupMaterial = material[group.materialIndex];
                const start = Math.max(group.start, drawRange.start);
                const end = Math.min(index.count, Math.min(group.start + group.count, drawRange.start + drawRange.count));
                for(let j = start, jl = end; j < jl; j += 3){
                    const a = index.getX(j);
                    const b = index.getX(j + 1);
                    const c = index.getX(j + 2);
                    intersection = $d5b33d7c30034067$var$checkGeometryIntersection(this, groupMaterial, raycaster, rayLocalSpace, uv, uv1, normal, a, b, c);
                    if (intersection) {
                        intersection.faceIndex = Math.floor(j / 3); // triangle number in indexed buffer semantics
                        intersection.face.materialIndex = group.materialIndex;
                        intersects.push(intersection);
                    }
                }
            }
            else {
                const start = Math.max(0, drawRange.start);
                const end = Math.min(index.count, drawRange.start + drawRange.count);
                for(let i = start, il = end; i < il; i += 3){
                    const a = index.getX(i);
                    const b = index.getX(i + 1);
                    const c = index.getX(i + 2);
                    intersection = $d5b33d7c30034067$var$checkGeometryIntersection(this, material, raycaster, rayLocalSpace, uv, uv1, normal, a, b, c);
                    if (intersection) {
                        intersection.faceIndex = Math.floor(i / 3); // triangle number in indexed buffer semantics
                        intersects.push(intersection);
                    }
                }
            }
        } else if (position !== undefined) {
            // non-indexed buffer geometry
            if (Array.isArray(material)) for(let i = 0, il = groups.length; i < il; i++){
                const group = groups[i];
                const groupMaterial = material[group.materialIndex];
                const start = Math.max(group.start, drawRange.start);
                const end = Math.min(position.count, Math.min(group.start + group.count, drawRange.start + drawRange.count));
                for(let j = start, jl = end; j < jl; j += 3){
                    const a = j;
                    const b = j + 1;
                    const c = j + 2;
                    intersection = $d5b33d7c30034067$var$checkGeometryIntersection(this, groupMaterial, raycaster, rayLocalSpace, uv, uv1, normal, a, b, c);
                    if (intersection) {
                        intersection.faceIndex = Math.floor(j / 3); // triangle number in non-indexed buffer semantics
                        intersection.face.materialIndex = group.materialIndex;
                        intersects.push(intersection);
                    }
                }
            }
            else {
                const start = Math.max(0, drawRange.start);
                const end = Math.min(position.count, drawRange.start + drawRange.count);
                for(let i = start, il = end; i < il; i += 3){
                    const a = i;
                    const b = i + 1;
                    const c = i + 2;
                    intersection = $d5b33d7c30034067$var$checkGeometryIntersection(this, material, raycaster, rayLocalSpace, uv, uv1, normal, a, b, c);
                    if (intersection) {
                        intersection.faceIndex = Math.floor(i / 3); // triangle number in non-indexed buffer semantics
                        intersects.push(intersection);
                    }
                }
            }
        }
    }
}
function $d5b33d7c30034067$var$checkIntersection$1(object, material, raycaster, ray, pA, pB, pC, point) {
    let intersect;
    if (material.side === $d5b33d7c30034067$export$d9f0486e75b5ace) intersect = ray.intersectTriangle(pC, pB, pA, true, point);
    else intersect = ray.intersectTriangle(pA, pB, pC, material.side === $d5b33d7c30034067$export$2ede184fc2998901, point);
    if (intersect === null) return null;
    $d5b33d7c30034067$var$_intersectionPointWorld.copy(point);
    $d5b33d7c30034067$var$_intersectionPointWorld.applyMatrix4(object.matrixWorld);
    const distance = raycaster.ray.origin.distanceTo($d5b33d7c30034067$var$_intersectionPointWorld);
    if (distance < raycaster.near || distance > raycaster.far) return null;
    return {
        distance: distance,
        point: $d5b33d7c30034067$var$_intersectionPointWorld.clone(),
        object: object
    };
}
function $d5b33d7c30034067$var$checkGeometryIntersection(object, material, raycaster, ray, uv, uv1, normal, a, b, c) {
    object.getVertexPosition(a, $d5b33d7c30034067$var$_vA$1);
    object.getVertexPosition(b, $d5b33d7c30034067$var$_vB$1);
    object.getVertexPosition(c, $d5b33d7c30034067$var$_vC$1);
    const intersection = $d5b33d7c30034067$var$checkIntersection$1(object, material, raycaster, ray, $d5b33d7c30034067$var$_vA$1, $d5b33d7c30034067$var$_vB$1, $d5b33d7c30034067$var$_vC$1, $d5b33d7c30034067$var$_intersectionPoint);
    if (intersection) {
        const barycoord = new $d5b33d7c30034067$export$64b5c384219d3699();
        $d5b33d7c30034067$export$5a465592bfe74b48.getBarycoord($d5b33d7c30034067$var$_intersectionPoint, $d5b33d7c30034067$var$_vA$1, $d5b33d7c30034067$var$_vB$1, $d5b33d7c30034067$var$_vC$1, barycoord);
        if (uv) intersection.uv = $d5b33d7c30034067$export$5a465592bfe74b48.getInterpolatedAttribute(uv, a, b, c, barycoord, new $d5b33d7c30034067$export$c977b3e384af9ae1());
        if (uv1) intersection.uv1 = $d5b33d7c30034067$export$5a465592bfe74b48.getInterpolatedAttribute(uv1, a, b, c, barycoord, new $d5b33d7c30034067$export$c977b3e384af9ae1());
        if (normal) {
            intersection.normal = $d5b33d7c30034067$export$5a465592bfe74b48.getInterpolatedAttribute(normal, a, b, c, barycoord, new $d5b33d7c30034067$export$64b5c384219d3699());
            if (intersection.normal.dot(ray.direction) > 0) intersection.normal.multiplyScalar(-1);
        }
        const face = {
            a: a,
            b: b,
            c: c,
            normal: new $d5b33d7c30034067$export$64b5c384219d3699(),
            materialIndex: 0
        };
        $d5b33d7c30034067$export$5a465592bfe74b48.getNormal($d5b33d7c30034067$var$_vA$1, $d5b33d7c30034067$var$_vB$1, $d5b33d7c30034067$var$_vC$1, face.normal);
        intersection.face = face;
        intersection.barycoord = barycoord;
    }
    return intersection;
}
class $d5b33d7c30034067$export$33e43285f7406bd5 extends $d5b33d7c30034067$export$b7be63a67df8959 {
    constructor(width = 1, height = 1, depth = 1, widthSegments = 1, heightSegments = 1, depthSegments = 1){
        super();
        this.type = 'BoxGeometry';
        this.parameters = {
            width: width,
            height: height,
            depth: depth,
            widthSegments: widthSegments,
            heightSegments: heightSegments,
            depthSegments: depthSegments
        };
        const scope = this;
        // segments
        widthSegments = Math.floor(widthSegments);
        heightSegments = Math.floor(heightSegments);
        depthSegments = Math.floor(depthSegments);
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // helper variables
        let numberOfVertices = 0;
        let groupStart = 0;
        // build each side of the box geometry
        buildPlane('z', 'y', 'x', -1, -1, depth, height, width, depthSegments, heightSegments, 0); // px
        buildPlane('z', 'y', 'x', 1, -1, depth, height, -width, depthSegments, heightSegments, 1); // nx
        buildPlane('x', 'z', 'y', 1, 1, width, depth, height, widthSegments, depthSegments, 2); // py
        buildPlane('x', 'z', 'y', 1, -1, width, depth, -height, widthSegments, depthSegments, 3); // ny
        buildPlane('x', 'y', 'z', 1, -1, width, height, depth, widthSegments, heightSegments, 4); // pz
        buildPlane('x', 'y', 'z', -1, -1, width, height, -depth, widthSegments, heightSegments, 5); // nz
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new $d5b33d7c30034067$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute('normal', new $d5b33d7c30034067$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute('uv', new $d5b33d7c30034067$export$cbe7a62641830ebd(uvs, 2));
        function buildPlane(u, v, w, udir, vdir, width, height, depth, gridX, gridY, materialIndex) {
            const segmentWidth = width / gridX;
            const segmentHeight = height / gridY;
            const widthHalf = width / 2;
            const heightHalf = height / 2;
            const depthHalf = depth / 2;
            const gridX1 = gridX + 1;
            const gridY1 = gridY + 1;
            let vertexCounter = 0;
            let groupCount = 0;
            const vector = new $d5b33d7c30034067$export$64b5c384219d3699();
            // generate vertices, normals and uvs
            for(let iy = 0; iy < gridY1; iy++){
                const y = iy * segmentHeight - heightHalf;
                for(let ix = 0; ix < gridX1; ix++){
                    const x = ix * segmentWidth - widthHalf;
                    // set values to correct vector component
                    vector[u] = x * udir;
                    vector[v] = y * vdir;
                    vector[w] = depthHalf;
                    // now apply vector to vertex buffer
                    vertices.push(vector.x, vector.y, vector.z);
                    // set values to correct vector component
                    vector[u] = 0;
                    vector[v] = 0;
                    vector[w] = depth > 0 ? 1 : -1;
                    // now apply vector to normal buffer
                    normals.push(vector.x, vector.y, vector.z);
                    // uvs
                    uvs.push(ix / gridX);
                    uvs.push(1 - iy / gridY);
                    // counters
                    vertexCounter += 1;
                }
            }
            // indices
            // 1. you need three indices to draw a single face
            // 2. a single segment consists of two faces
            // 3. so we need to generate six (2*3) indices per segment
            for(let iy = 0; iy < gridY; iy++)for(let ix = 0; ix < gridX; ix++){
                const a = numberOfVertices + ix + gridX1 * iy;
                const b = numberOfVertices + ix + gridX1 * (iy + 1);
                const c = numberOfVertices + (ix + 1) + gridX1 * (iy + 1);
                const d = numberOfVertices + (ix + 1) + gridX1 * iy;
                // faces
                indices.push(a, b, d);
                indices.push(b, c, d);
                // increase counter
                groupCount += 6;
            }
            // add a group to the geometry. this will ensure multi material support
            scope.addGroup(groupStart, groupCount, materialIndex);
            // calculate new start value for groups
            groupStart += groupCount;
            // update total number of vertices
            numberOfVertices += vertexCounter;
        }
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    static fromJSON(data) {
        return new $d5b33d7c30034067$export$33e43285f7406bd5(data.width, data.height, data.depth, data.widthSegments, data.heightSegments, data.depthSegments);
    }
}
/**
 * Uniform Utilities
 */ function $d5b33d7c30034067$var$cloneUniforms(src) {
    const dst = {};
    for(const u in src){
        dst[u] = {};
        for(const p in src[u]){
            const property = src[u][p];
            if (property && (property.isColor || property.isMatrix3 || property.isMatrix4 || property.isVector2 || property.isVector3 || property.isVector4 || property.isTexture || property.isQuaternion)) {
                if (property.isRenderTargetTexture) {
                    console.warn('UniformsUtils: Textures of render targets cannot be cloned via cloneUniforms() or mergeUniforms().');
                    dst[u][p] = null;
                } else dst[u][p] = property.clone();
            } else if (Array.isArray(property)) dst[u][p] = property.slice();
            else dst[u][p] = property;
        }
    }
    return dst;
}
function $d5b33d7c30034067$var$mergeUniforms(uniforms) {
    const merged = {};
    for(let u = 0; u < uniforms.length; u++){
        const tmp = $d5b33d7c30034067$var$cloneUniforms(uniforms[u]);
        for(const p in tmp)merged[p] = tmp[p];
    }
    return merged;
}
function $d5b33d7c30034067$var$cloneUniformsGroups(src) {
    const dst = [];
    for(let u = 0; u < src.length; u++)dst.push(src[u].clone());
    return dst;
}
function $d5b33d7c30034067$var$getUnlitUniformColorSpace(renderer) {
    const currentRenderTarget = renderer.getRenderTarget();
    if (currentRenderTarget === null) // https://github.com/mrdoob/three.js/pull/23937#issuecomment-1111067398
    return renderer.outputColorSpace;
    // https://github.com/mrdoob/three.js/issues/27868
    if (currentRenderTarget.isXRRenderTarget === true) return currentRenderTarget.texture.colorSpace;
    return $d5b33d7c30034067$export$5e6fd513f44698c.workingColorSpace;
}
// Legacy
const $d5b33d7c30034067$export$d8ecdf8615bfea69 = {
    clone: $d5b33d7c30034067$var$cloneUniforms,
    merge: $d5b33d7c30034067$var$mergeUniforms
};
var $d5b33d7c30034067$var$default_vertex = "void main() {\n\tgl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );\n}";
var $d5b33d7c30034067$var$default_fragment = "void main() {\n\tgl_FragColor = vec4( 1.0, 0.0, 0.0, 1.0 );\n}";
class $d5b33d7c30034067$export$83c7d75d550a8b0d extends $d5b33d7c30034067$export$a2d8b23205c25948 {
    static get type() {
        return 'ShaderMaterial';
    }
    constructor(parameters){
        super();
        this.isShaderMaterial = true;
        this.defines = {};
        this.uniforms = {};
        this.uniformsGroups = [];
        this.vertexShader = $d5b33d7c30034067$var$default_vertex;
        this.fragmentShader = $d5b33d7c30034067$var$default_fragment;
        this.linewidth = 1;
        this.wireframe = false;
        this.wireframeLinewidth = 1;
        this.fog = false; // set to use scene fog
        this.lights = false; // set to use scene lights
        this.clipping = false; // set to use user-defined clipping planes
        this.forceSinglePass = true;
        this.extensions = {
            clipCullDistance: false,
            multiDraw: false // set to use vertex shader multi_draw / enable gl_DrawID
        };
        // When rendered geometry doesn't include these attributes but the material does,
        // use these default values in WebGL. This avoids errors when buffer data is missing.
        this.defaultAttributeValues = {
            'color': [
                1,
                1,
                1
            ],
            'uv': [
                0,
                0
            ],
            'uv1': [
                0,
                0
            ]
        };
        this.index0AttributeName = undefined;
        this.uniformsNeedUpdate = false;
        this.glslVersion = null;
        if (parameters !== undefined) this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.fragmentShader = source.fragmentShader;
        this.vertexShader = source.vertexShader;
        this.uniforms = $d5b33d7c30034067$var$cloneUniforms(source.uniforms);
        this.uniformsGroups = $d5b33d7c30034067$var$cloneUniformsGroups(source.uniformsGroups);
        this.defines = Object.assign({}, source.defines);
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.fog = source.fog;
        this.lights = source.lights;
        this.clipping = source.clipping;
        this.extensions = Object.assign({}, source.extensions);
        this.glslVersion = source.glslVersion;
        return this;
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.glslVersion = this.glslVersion;
        data.uniforms = {};
        for(const name in this.uniforms){
            const uniform = this.uniforms[name];
            const value = uniform.value;
            if (value && value.isTexture) data.uniforms[name] = {
                type: 't',
                value: value.toJSON(meta).uuid
            };
            else if (value && value.isColor) data.uniforms[name] = {
                type: 'c',
                value: value.getHex()
            };
            else if (value && value.isVector2) data.uniforms[name] = {
                type: 'v2',
                value: value.toArray()
            };
            else if (value && value.isVector3) data.uniforms[name] = {
                type: 'v3',
                value: value.toArray()
            };
            else if (value && value.isVector4) data.uniforms[name] = {
                type: 'v4',
                value: value.toArray()
            };
            else if (value && value.isMatrix3) data.uniforms[name] = {
                type: 'm3',
                value: value.toArray()
            };
            else if (value && value.isMatrix4) data.uniforms[name] = {
                type: 'm4',
                value: value.toArray()
            };
            else data.uniforms[name] = {
                value: value
            };
        }
        if (Object.keys(this.defines).length > 0) data.defines = this.defines;
        data.vertexShader = this.vertexShader;
        data.fragmentShader = this.fragmentShader;
        data.lights = this.lights;
        data.clipping = this.clipping;
        const extensions = {};
        for(const key in this.extensions)if (this.extensions[key] === true) extensions[key] = true;
        if (Object.keys(extensions).length > 0) data.extensions = extensions;
        return data;
    }
}
class $d5b33d7c30034067$export$79f141de891a5fed extends $d5b33d7c30034067$export$e4dd07dff30cc924 {
    constructor(){
        super();
        this.isCamera = true;
        this.type = 'Camera';
        this.matrixWorldInverse = new $d5b33d7c30034067$export$2ae72fc923e5eb5();
        this.projectionMatrix = new $d5b33d7c30034067$export$2ae72fc923e5eb5();
        this.projectionMatrixInverse = new $d5b33d7c30034067$export$2ae72fc923e5eb5();
        this.coordinateSystem = $d5b33d7c30034067$export$5a0e9190d10875d3;
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.matrixWorldInverse.copy(source.matrixWorldInverse);
        this.projectionMatrix.copy(source.projectionMatrix);
        this.projectionMatrixInverse.copy(source.projectionMatrixInverse);
        this.coordinateSystem = source.coordinateSystem;
        return this;
    }
    getWorldDirection(target) {
        return super.getWorldDirection(target).negate();
    }
    updateMatrixWorld(force) {
        super.updateMatrixWorld(force);
        this.matrixWorldInverse.copy(this.matrixWorld).invert();
    }
    updateWorldMatrix(updateParents, updateChildren) {
        super.updateWorldMatrix(updateParents, updateChildren);
        this.matrixWorldInverse.copy(this.matrixWorld).invert();
    }
    clone() {
        return new this.constructor().copy(this);
    }
}
const $d5b33d7c30034067$var$_v3$1 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_minTarget = /*@__PURE__*/ new $d5b33d7c30034067$export$c977b3e384af9ae1();
const $d5b33d7c30034067$var$_maxTarget = /*@__PURE__*/ new $d5b33d7c30034067$export$c977b3e384af9ae1();
class $d5b33d7c30034067$export$74e4ae24825f68d7 extends $d5b33d7c30034067$export$79f141de891a5fed {
    constructor(fov = 50, aspect = 1, near = 0.1, far = 2000){
        super();
        this.isPerspectiveCamera = true;
        this.type = 'PerspectiveCamera';
        this.fov = fov;
        this.zoom = 1;
        this.near = near;
        this.far = far;
        this.focus = 10;
        this.aspect = aspect;
        this.view = null;
        this.filmGauge = 35; // width of the film (default in millimeters)
        this.filmOffset = 0; // horizontal film offset (same unit as gauge)
        this.updateProjectionMatrix();
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.fov = source.fov;
        this.zoom = source.zoom;
        this.near = source.near;
        this.far = source.far;
        this.focus = source.focus;
        this.aspect = source.aspect;
        this.view = source.view === null ? null : Object.assign({}, source.view);
        this.filmGauge = source.filmGauge;
        this.filmOffset = source.filmOffset;
        return this;
    }
    /**
	 * Sets the FOV by focal length in respect to the current .filmGauge.
	 *
	 * The default film gauge is 35, so that the focal length can be specified for
	 * a 35mm (full frame) camera.
	 *
	 * Values for focal length and film gauge must have the same unit.
	 */ setFocalLength(focalLength) {
        /** see {@link http://www.bobatkins.com/photography/technical/field_of_view.html} */ const vExtentSlope = 0.5 * this.getFilmHeight() / focalLength;
        this.fov = $d5b33d7c30034067$var$RAD2DEG * 2 * Math.atan(vExtentSlope);
        this.updateProjectionMatrix();
    }
    /**
	 * Calculates the focal length from the current .fov and .filmGauge.
	 */ getFocalLength() {
        const vExtentSlope = Math.tan($d5b33d7c30034067$var$DEG2RAD * 0.5 * this.fov);
        return 0.5 * this.getFilmHeight() / vExtentSlope;
    }
    getEffectiveFOV() {
        return $d5b33d7c30034067$var$RAD2DEG * 2 * Math.atan(Math.tan($d5b33d7c30034067$var$DEG2RAD * 0.5 * this.fov) / this.zoom);
    }
    getFilmWidth() {
        // film not completely covered in portrait format (aspect < 1)
        return this.filmGauge * Math.min(this.aspect, 1);
    }
    getFilmHeight() {
        // film not completely covered in landscape format (aspect > 1)
        return this.filmGauge / Math.max(this.aspect, 1);
    }
    /**
	 * Computes the 2D bounds of the camera's viewable rectangle at a given distance along the viewing direction.
	 * Sets minTarget and maxTarget to the coordinates of the lower-left and upper-right corners of the view rectangle.
	 */ getViewBounds(distance, minTarget, maxTarget) {
        $d5b33d7c30034067$var$_v3$1.set(-1, -1, 0.5).applyMatrix4(this.projectionMatrixInverse);
        minTarget.set($d5b33d7c30034067$var$_v3$1.x, $d5b33d7c30034067$var$_v3$1.y).multiplyScalar(-distance / $d5b33d7c30034067$var$_v3$1.z);
        $d5b33d7c30034067$var$_v3$1.set(1, 1, 0.5).applyMatrix4(this.projectionMatrixInverse);
        maxTarget.set($d5b33d7c30034067$var$_v3$1.x, $d5b33d7c30034067$var$_v3$1.y).multiplyScalar(-distance / $d5b33d7c30034067$var$_v3$1.z);
    }
    /**
	 * Computes the width and height of the camera's viewable rectangle at a given distance along the viewing direction.
	 * Copies the result into the target Vector2, where x is width and y is height.
	 */ getViewSize(distance, target) {
        this.getViewBounds(distance, $d5b33d7c30034067$var$_minTarget, $d5b33d7c30034067$var$_maxTarget);
        return target.subVectors($d5b33d7c30034067$var$_maxTarget, $d5b33d7c30034067$var$_minTarget);
    }
    /**
	 * Sets an offset in a larger frustum. This is useful for multi-window or
	 * multi-monitor/multi-machine setups.
	 *
	 * For example, if you have 3x2 monitors and each monitor is 1920x1080 and
	 * the monitors are in grid like this
	 *
	 *   +---+---+---+
	 *   | A | B | C |
	 *   +---+---+---+
	 *   | D | E | F |
	 *   +---+---+---+
	 *
	 * then for each monitor you would call it like this
	 *
	 *   const w = 1920;
	 *   const h = 1080;
	 *   const fullWidth = w * 3;
	 *   const fullHeight = h * 2;
	 *
	 *   --A--
	 *   camera.setViewOffset( fullWidth, fullHeight, w * 0, h * 0, w, h );
	 *   --B--
	 *   camera.setViewOffset( fullWidth, fullHeight, w * 1, h * 0, w, h );
	 *   --C--
	 *   camera.setViewOffset( fullWidth, fullHeight, w * 2, h * 0, w, h );
	 *   --D--
	 *   camera.setViewOffset( fullWidth, fullHeight, w * 0, h * 1, w, h );
	 *   --E--
	 *   camera.setViewOffset( fullWidth, fullHeight, w * 1, h * 1, w, h );
	 *   --F--
	 *   camera.setViewOffset( fullWidth, fullHeight, w * 2, h * 1, w, h );
	 *
	 *   Note there is no reason monitors have to be the same size or in a grid.
	 */ setViewOffset(fullWidth, fullHeight, x, y, width, height) {
        this.aspect = fullWidth / fullHeight;
        if (this.view === null) this.view = {
            enabled: true,
            fullWidth: 1,
            fullHeight: 1,
            offsetX: 0,
            offsetY: 0,
            width: 1,
            height: 1
        };
        this.view.enabled = true;
        this.view.fullWidth = fullWidth;
        this.view.fullHeight = fullHeight;
        this.view.offsetX = x;
        this.view.offsetY = y;
        this.view.width = width;
        this.view.height = height;
        this.updateProjectionMatrix();
    }
    clearViewOffset() {
        if (this.view !== null) this.view.enabled = false;
        this.updateProjectionMatrix();
    }
    updateProjectionMatrix() {
        const near = this.near;
        let top = near * Math.tan($d5b33d7c30034067$var$DEG2RAD * 0.5 * this.fov) / this.zoom;
        let height = 2 * top;
        let width = this.aspect * height;
        let left = -0.5 * width;
        const view = this.view;
        if (this.view !== null && this.view.enabled) {
            const fullWidth = view.fullWidth, fullHeight = view.fullHeight;
            left += view.offsetX * width / fullWidth;
            top -= view.offsetY * height / fullHeight;
            width *= view.width / fullWidth;
            height *= view.height / fullHeight;
        }
        const skew = this.filmOffset;
        if (skew !== 0) left += near * skew / this.getFilmWidth();
        this.projectionMatrix.makePerspective(left, left + width, top, top - height, near, this.far, this.coordinateSystem);
        this.projectionMatrixInverse.copy(this.projectionMatrix).invert();
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.object.fov = this.fov;
        data.object.zoom = this.zoom;
        data.object.near = this.near;
        data.object.far = this.far;
        data.object.focus = this.focus;
        data.object.aspect = this.aspect;
        if (this.view !== null) data.object.view = Object.assign({}, this.view);
        data.object.filmGauge = this.filmGauge;
        data.object.filmOffset = this.filmOffset;
        return data;
    }
}
const $d5b33d7c30034067$var$fov = -90; // negative fov is not an error
const $d5b33d7c30034067$var$aspect = 1;
class $d5b33d7c30034067$export$d0cdd0bd804995de extends $d5b33d7c30034067$export$e4dd07dff30cc924 {
    constructor(near, far, renderTarget){
        super();
        this.type = 'CubeCamera';
        this.renderTarget = renderTarget;
        this.coordinateSystem = null;
        this.activeMipmapLevel = 0;
        const cameraPX = new $d5b33d7c30034067$export$74e4ae24825f68d7($d5b33d7c30034067$var$fov, $d5b33d7c30034067$var$aspect, near, far);
        cameraPX.layers = this.layers;
        this.add(cameraPX);
        const cameraNX = new $d5b33d7c30034067$export$74e4ae24825f68d7($d5b33d7c30034067$var$fov, $d5b33d7c30034067$var$aspect, near, far);
        cameraNX.layers = this.layers;
        this.add(cameraNX);
        const cameraPY = new $d5b33d7c30034067$export$74e4ae24825f68d7($d5b33d7c30034067$var$fov, $d5b33d7c30034067$var$aspect, near, far);
        cameraPY.layers = this.layers;
        this.add(cameraPY);
        const cameraNY = new $d5b33d7c30034067$export$74e4ae24825f68d7($d5b33d7c30034067$var$fov, $d5b33d7c30034067$var$aspect, near, far);
        cameraNY.layers = this.layers;
        this.add(cameraNY);
        const cameraPZ = new $d5b33d7c30034067$export$74e4ae24825f68d7($d5b33d7c30034067$var$fov, $d5b33d7c30034067$var$aspect, near, far);
        cameraPZ.layers = this.layers;
        this.add(cameraPZ);
        const cameraNZ = new $d5b33d7c30034067$export$74e4ae24825f68d7($d5b33d7c30034067$var$fov, $d5b33d7c30034067$var$aspect, near, far);
        cameraNZ.layers = this.layers;
        this.add(cameraNZ);
    }
    updateCoordinateSystem() {
        const coordinateSystem = this.coordinateSystem;
        const cameras = this.children.concat();
        const [cameraPX, cameraNX, cameraPY, cameraNY, cameraPZ, cameraNZ] = cameras;
        for (const camera of cameras)this.remove(camera);
        if (coordinateSystem === $d5b33d7c30034067$export$5a0e9190d10875d3) {
            cameraPX.up.set(0, 1, 0);
            cameraPX.lookAt(1, 0, 0);
            cameraNX.up.set(0, 1, 0);
            cameraNX.lookAt(-1, 0, 0);
            cameraPY.up.set(0, 0, -1);
            cameraPY.lookAt(0, 1, 0);
            cameraNY.up.set(0, 0, 1);
            cameraNY.lookAt(0, -1, 0);
            cameraPZ.up.set(0, 1, 0);
            cameraPZ.lookAt(0, 0, 1);
            cameraNZ.up.set(0, 1, 0);
            cameraNZ.lookAt(0, 0, -1);
        } else if (coordinateSystem === $d5b33d7c30034067$export$cc83beedcb9be9ac) {
            cameraPX.up.set(0, -1, 0);
            cameraPX.lookAt(-1, 0, 0);
            cameraNX.up.set(0, -1, 0);
            cameraNX.lookAt(1, 0, 0);
            cameraPY.up.set(0, 0, 1);
            cameraPY.lookAt(0, 1, 0);
            cameraNY.up.set(0, 0, -1);
            cameraNY.lookAt(0, -1, 0);
            cameraPZ.up.set(0, -1, 0);
            cameraPZ.lookAt(0, 0, 1);
            cameraNZ.up.set(0, -1, 0);
            cameraNZ.lookAt(0, 0, -1);
        } else throw new Error('THREE.CubeCamera.updateCoordinateSystem(): Invalid coordinate system: ' + coordinateSystem);
        for (const camera of cameras){
            this.add(camera);
            camera.updateMatrixWorld();
        }
    }
    update(renderer, scene) {
        if (this.parent === null) this.updateMatrixWorld();
        const { renderTarget: renderTarget, activeMipmapLevel: activeMipmapLevel } = this;
        if (this.coordinateSystem !== renderer.coordinateSystem) {
            this.coordinateSystem = renderer.coordinateSystem;
            this.updateCoordinateSystem();
        }
        const [cameraPX, cameraNX, cameraPY, cameraNY, cameraPZ, cameraNZ] = this.children;
        const currentRenderTarget = renderer.getRenderTarget();
        const currentActiveCubeFace = renderer.getActiveCubeFace();
        const currentActiveMipmapLevel = renderer.getActiveMipmapLevel();
        const currentXrEnabled = renderer.xr.enabled;
        renderer.xr.enabled = false;
        const generateMipmaps = renderTarget.texture.generateMipmaps;
        renderTarget.texture.generateMipmaps = false;
        renderer.setRenderTarget(renderTarget, 0, activeMipmapLevel);
        renderer.render(scene, cameraPX);
        renderer.setRenderTarget(renderTarget, 1, activeMipmapLevel);
        renderer.render(scene, cameraNX);
        renderer.setRenderTarget(renderTarget, 2, activeMipmapLevel);
        renderer.render(scene, cameraPY);
        renderer.setRenderTarget(renderTarget, 3, activeMipmapLevel);
        renderer.render(scene, cameraNY);
        renderer.setRenderTarget(renderTarget, 4, activeMipmapLevel);
        renderer.render(scene, cameraPZ);
        // mipmaps are generated during the last call of render()
        // at this point, all sides of the cube render target are defined
        renderTarget.texture.generateMipmaps = generateMipmaps;
        renderer.setRenderTarget(renderTarget, 5, activeMipmapLevel);
        renderer.render(scene, cameraNZ);
        renderer.setRenderTarget(currentRenderTarget, currentActiveCubeFace, currentActiveMipmapLevel);
        renderer.xr.enabled = currentXrEnabled;
        renderTarget.texture.needsPMREMUpdate = true;
    }
}
class $d5b33d7c30034067$export$ee2e5a18258a4049 extends $d5b33d7c30034067$export$5431306cf43de24a {
    constructor(images, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, colorSpace){
        images = images !== undefined ? images : [];
        mapping = mapping !== undefined ? mapping : $d5b33d7c30034067$export$8759762a6477f2c4;
        super(images, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, colorSpace);
        this.isCubeTexture = true;
        this.flipY = false;
    }
    get images() {
        return this.image;
    }
    set images(value) {
        this.image = value;
    }
}
class $d5b33d7c30034067$export$ac386671d651941e extends $d5b33d7c30034067$export$3c052beb2e51e23f {
    constructor(size = 1, options = {}){
        super(size, size, options);
        this.isWebGLCubeRenderTarget = true;
        const image = {
            width: size,
            height: size,
            depth: 1
        };
        const images = [
            image,
            image,
            image,
            image,
            image,
            image
        ];
        this.texture = new $d5b33d7c30034067$export$ee2e5a18258a4049(images, options.mapping, options.wrapS, options.wrapT, options.magFilter, options.minFilter, options.format, options.type, options.anisotropy, options.colorSpace);
        // By convention -- likely based on the RenderMan spec from the 1990's -- cube maps are specified by WebGL (and three.js)
        // in a coordinate system in which positive-x is to the right when looking up the positive-z axis -- in other words,
        // in a left-handed coordinate system. By continuing this convention, preexisting cube maps continued to render correctly.
        // three.js uses a right-handed coordinate system. So environment maps used in three.js appear to have px and nx swapped
        // and the flag isRenderTargetTexture controls this conversion. The flip is not required when using WebGLCubeRenderTarget.texture
        // as a cube texture (this is detected when isRenderTargetTexture is set to true for cube textures).
        this.texture.isRenderTargetTexture = true;
        this.texture.generateMipmaps = options.generateMipmaps !== undefined ? options.generateMipmaps : false;
        this.texture.minFilter = options.minFilter !== undefined ? options.minFilter : $d5b33d7c30034067$export$8a72f490b25c56c8;
    }
    fromEquirectangularTexture(renderer, texture) {
        this.texture.type = texture.type;
        this.texture.colorSpace = texture.colorSpace;
        this.texture.generateMipmaps = texture.generateMipmaps;
        this.texture.minFilter = texture.minFilter;
        this.texture.magFilter = texture.magFilter;
        const shader = {
            uniforms: {
                tEquirect: {
                    value: null
                }
            },
            vertexShader: /* glsl */ `

				varying vec3 vWorldDirection;

				vec3 transformDirection( in vec3 dir, in mat4 matrix ) {

					return normalize( ( matrix * vec4( dir, 0.0 ) ).xyz );

				}

				void main() {

					vWorldDirection = transformDirection( position, modelMatrix );

					#include <begin_vertex>
					#include <project_vertex>

				}
			`,
            fragmentShader: /* glsl */ `

				uniform sampler2D tEquirect;

				varying vec3 vWorldDirection;

				#include <common>

				void main() {

					vec3 direction = normalize( vWorldDirection );

					vec2 sampleUV = equirectUv( direction );

					gl_FragColor = texture2D( tEquirect, sampleUV );

				}
			`
        };
        const geometry = new $d5b33d7c30034067$export$33e43285f7406bd5(5, 5, 5);
        const material = new $d5b33d7c30034067$export$83c7d75d550a8b0d({
            name: 'CubemapFromEquirect',
            uniforms: $d5b33d7c30034067$var$cloneUniforms(shader.uniforms),
            vertexShader: shader.vertexShader,
            fragmentShader: shader.fragmentShader,
            side: $d5b33d7c30034067$export$d9f0486e75b5ace,
            blending: $d5b33d7c30034067$export$63b8d6b580fc65ba
        });
        material.uniforms.tEquirect.value = texture;
        const mesh = new $d5b33d7c30034067$export$e176487c05830cc5(geometry, material);
        const currentMinFilter = texture.minFilter;
        // Avoid blurred poles
        if (texture.minFilter === $d5b33d7c30034067$export$5d8599b6a933fb1b) texture.minFilter = $d5b33d7c30034067$export$8a72f490b25c56c8;
        const camera = new $d5b33d7c30034067$export$d0cdd0bd804995de(1, 10, this);
        camera.update(renderer, mesh);
        texture.minFilter = currentMinFilter;
        mesh.geometry.dispose();
        mesh.material.dispose();
        return this;
    }
    clear(renderer, color, depth, stencil) {
        const currentRenderTarget = renderer.getRenderTarget();
        for(let i = 0; i < 6; i++){
            renderer.setRenderTarget(this, i);
            renderer.clear(color, depth, stencil);
        }
        renderer.setRenderTarget(currentRenderTarget);
    }
}
const $d5b33d7c30034067$var$_vector1 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_vector2 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_normalMatrix = /*@__PURE__*/ new $d5b33d7c30034067$export$8ff26dafa08918();
class $d5b33d7c30034067$export$7ff5ac152ef991b0 {
    constructor(normal = new $d5b33d7c30034067$export$64b5c384219d3699(1, 0, 0), constant = 0){
        this.isPlane = true;
        // normal is assumed to be normalized
        this.normal = normal;
        this.constant = constant;
    }
    set(normal, constant) {
        this.normal.copy(normal);
        this.constant = constant;
        return this;
    }
    setComponents(x, y, z, w) {
        this.normal.set(x, y, z);
        this.constant = w;
        return this;
    }
    setFromNormalAndCoplanarPoint(normal, point) {
        this.normal.copy(normal);
        this.constant = -point.dot(this.normal);
        return this;
    }
    setFromCoplanarPoints(a, b, c) {
        const normal = $d5b33d7c30034067$var$_vector1.subVectors(c, b).cross($d5b33d7c30034067$var$_vector2.subVectors(a, b)).normalize();
        // Q: should an error be thrown if normal is zero (e.g. degenerate plane)?
        this.setFromNormalAndCoplanarPoint(normal, a);
        return this;
    }
    copy(plane) {
        this.normal.copy(plane.normal);
        this.constant = plane.constant;
        return this;
    }
    normalize() {
        // Note: will lead to a divide by zero if the plane is invalid.
        const inverseNormalLength = 1.0 / this.normal.length();
        this.normal.multiplyScalar(inverseNormalLength);
        this.constant *= inverseNormalLength;
        return this;
    }
    negate() {
        this.constant *= -1;
        this.normal.negate();
        return this;
    }
    distanceToPoint(point) {
        return this.normal.dot(point) + this.constant;
    }
    distanceToSphere(sphere) {
        return this.distanceToPoint(sphere.center) - sphere.radius;
    }
    projectPoint(point, target) {
        return target.copy(point).addScaledVector(this.normal, -this.distanceToPoint(point));
    }
    intersectLine(line, target) {
        const direction = line.delta($d5b33d7c30034067$var$_vector1);
        const denominator = this.normal.dot(direction);
        if (denominator === 0) {
            // line is coplanar, return origin
            if (this.distanceToPoint(line.start) === 0) return target.copy(line.start);
            // Unsure if this is the correct method to handle this case.
            return null;
        }
        const t = -(line.start.dot(this.normal) + this.constant) / denominator;
        if (t < 0 || t > 1) return null;
        return target.copy(line.start).addScaledVector(direction, t);
    }
    intersectsLine(line) {
        // Note: this tests if a line intersects the plane, not whether it (or its end-points) are coplanar with it.
        const startSign = this.distanceToPoint(line.start);
        const endSign = this.distanceToPoint(line.end);
        return startSign < 0 && endSign > 0 || endSign < 0 && startSign > 0;
    }
    intersectsBox(box) {
        return box.intersectsPlane(this);
    }
    intersectsSphere(sphere) {
        return sphere.intersectsPlane(this);
    }
    coplanarPoint(target) {
        return target.copy(this.normal).multiplyScalar(-this.constant);
    }
    applyMatrix4(matrix, optionalNormalMatrix) {
        const normalMatrix = optionalNormalMatrix || $d5b33d7c30034067$var$_normalMatrix.getNormalMatrix(matrix);
        const referencePoint = this.coplanarPoint($d5b33d7c30034067$var$_vector1).applyMatrix4(matrix);
        const normal = this.normal.applyMatrix3(normalMatrix).normalize();
        this.constant = -referencePoint.dot(normal);
        return this;
    }
    translate(offset) {
        this.constant -= offset.dot(this.normal);
        return this;
    }
    equals(plane) {
        return plane.normal.equals(this.normal) && plane.constant === this.constant;
    }
    clone() {
        return new this.constructor().copy(this);
    }
}
const $d5b33d7c30034067$var$_sphere$5 = /*@__PURE__*/ new $d5b33d7c30034067$export$805e8b72413ccaba();
const $d5b33d7c30034067$var$_vector$7 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
class $d5b33d7c30034067$export$35efe6f4c85463d2 {
    constructor(p0 = new $d5b33d7c30034067$export$7ff5ac152ef991b0(), p1 = new $d5b33d7c30034067$export$7ff5ac152ef991b0(), p2 = new $d5b33d7c30034067$export$7ff5ac152ef991b0(), p3 = new $d5b33d7c30034067$export$7ff5ac152ef991b0(), p4 = new $d5b33d7c30034067$export$7ff5ac152ef991b0(), p5 = new $d5b33d7c30034067$export$7ff5ac152ef991b0()){
        this.planes = [
            p0,
            p1,
            p2,
            p3,
            p4,
            p5
        ];
    }
    set(p0, p1, p2, p3, p4, p5) {
        const planes = this.planes;
        planes[0].copy(p0);
        planes[1].copy(p1);
        planes[2].copy(p2);
        planes[3].copy(p3);
        planes[4].copy(p4);
        planes[5].copy(p5);
        return this;
    }
    copy(frustum) {
        const planes = this.planes;
        for(let i = 0; i < 6; i++)planes[i].copy(frustum.planes[i]);
        return this;
    }
    setFromProjectionMatrix(m, coordinateSystem = $d5b33d7c30034067$export$5a0e9190d10875d3) {
        const planes = this.planes;
        const me = m.elements;
        const me0 = me[0], me1 = me[1], me2 = me[2], me3 = me[3];
        const me4 = me[4], me5 = me[5], me6 = me[6], me7 = me[7];
        const me8 = me[8], me9 = me[9], me10 = me[10], me11 = me[11];
        const me12 = me[12], me13 = me[13], me14 = me[14], me15 = me[15];
        planes[0].setComponents(me3 - me0, me7 - me4, me11 - me8, me15 - me12).normalize();
        planes[1].setComponents(me3 + me0, me7 + me4, me11 + me8, me15 + me12).normalize();
        planes[2].setComponents(me3 + me1, me7 + me5, me11 + me9, me15 + me13).normalize();
        planes[3].setComponents(me3 - me1, me7 - me5, me11 - me9, me15 - me13).normalize();
        planes[4].setComponents(me3 - me2, me7 - me6, me11 - me10, me15 - me14).normalize();
        if (coordinateSystem === $d5b33d7c30034067$export$5a0e9190d10875d3) planes[5].setComponents(me3 + me2, me7 + me6, me11 + me10, me15 + me14).normalize();
        else if (coordinateSystem === $d5b33d7c30034067$export$cc83beedcb9be9ac) planes[5].setComponents(me2, me6, me10, me14).normalize();
        else throw new Error('THREE.Frustum.setFromProjectionMatrix(): Invalid coordinate system: ' + coordinateSystem);
        return this;
    }
    intersectsObject(object) {
        if (object.boundingSphere !== undefined) {
            if (object.boundingSphere === null) object.computeBoundingSphere();
            $d5b33d7c30034067$var$_sphere$5.copy(object.boundingSphere).applyMatrix4(object.matrixWorld);
        } else {
            const geometry = object.geometry;
            if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
            $d5b33d7c30034067$var$_sphere$5.copy(geometry.boundingSphere).applyMatrix4(object.matrixWorld);
        }
        return this.intersectsSphere($d5b33d7c30034067$var$_sphere$5);
    }
    intersectsSprite(sprite) {
        $d5b33d7c30034067$var$_sphere$5.center.set(0, 0, 0);
        $d5b33d7c30034067$var$_sphere$5.radius = 0.7071067811865476;
        $d5b33d7c30034067$var$_sphere$5.applyMatrix4(sprite.matrixWorld);
        return this.intersectsSphere($d5b33d7c30034067$var$_sphere$5);
    }
    intersectsSphere(sphere) {
        const planes = this.planes;
        const center = sphere.center;
        const negRadius = -sphere.radius;
        for(let i = 0; i < 6; i++){
            const distance = planes[i].distanceToPoint(center);
            if (distance < negRadius) return false;
        }
        return true;
    }
    intersectsBox(box) {
        const planes = this.planes;
        for(let i = 0; i < 6; i++){
            const plane = planes[i];
            // corner at max distance
            $d5b33d7c30034067$var$_vector$7.x = plane.normal.x > 0 ? box.max.x : box.min.x;
            $d5b33d7c30034067$var$_vector$7.y = plane.normal.y > 0 ? box.max.y : box.min.y;
            $d5b33d7c30034067$var$_vector$7.z = plane.normal.z > 0 ? box.max.z : box.min.z;
            if (plane.distanceToPoint($d5b33d7c30034067$var$_vector$7) < 0) return false;
        }
        return true;
    }
    containsPoint(point) {
        const planes = this.planes;
        for(let i = 0; i < 6; i++){
            if (planes[i].distanceToPoint(point) < 0) return false;
        }
        return true;
    }
    clone() {
        return new this.constructor().copy(this);
    }
}
function $d5b33d7c30034067$var$WebGLAnimation() {
    let context = null;
    let isAnimating = false;
    let animationLoop = null;
    let requestId = null;
    function onAnimationFrame(time, frame) {
        animationLoop(time, frame);
        requestId = context.requestAnimationFrame(onAnimationFrame);
    }
    return {
        start: function() {
            if (isAnimating === true) return;
            if (animationLoop === null) return;
            requestId = context.requestAnimationFrame(onAnimationFrame);
            isAnimating = true;
        },
        stop: function() {
            context.cancelAnimationFrame(requestId);
            isAnimating = false;
        },
        setAnimationLoop: function(callback) {
            animationLoop = callback;
        },
        setContext: function(value) {
            context = value;
        }
    };
}
function $d5b33d7c30034067$var$WebGLAttributes(gl) {
    const buffers = new WeakMap();
    function createBuffer(attribute, bufferType) {
        const array = attribute.array;
        const usage = attribute.usage;
        const size = array.byteLength;
        const buffer = gl.createBuffer();
        gl.bindBuffer(bufferType, buffer);
        gl.bufferData(bufferType, array, usage);
        attribute.onUploadCallback();
        let type;
        if (array instanceof Float32Array) type = gl.FLOAT;
        else if (array instanceof Uint16Array) {
            if (attribute.isFloat16BufferAttribute) type = gl.HALF_FLOAT;
            else type = gl.UNSIGNED_SHORT;
        } else if (array instanceof Int16Array) type = gl.SHORT;
        else if (array instanceof Uint32Array) type = gl.UNSIGNED_INT;
        else if (array instanceof Int32Array) type = gl.INT;
        else if (array instanceof Int8Array) type = gl.BYTE;
        else if (array instanceof Uint8Array) type = gl.UNSIGNED_BYTE;
        else if (array instanceof Uint8ClampedArray) type = gl.UNSIGNED_BYTE;
        else throw new Error('THREE.WebGLAttributes: Unsupported buffer data format: ' + array);
        return {
            buffer: buffer,
            type: type,
            bytesPerElement: array.BYTES_PER_ELEMENT,
            version: attribute.version,
            size: size
        };
    }
    function updateBuffer(buffer, attribute, bufferType) {
        const array = attribute.array;
        const updateRanges = attribute.updateRanges;
        gl.bindBuffer(bufferType, buffer);
        if (updateRanges.length === 0) // Not using update ranges
        gl.bufferSubData(bufferType, 0, array);
        else {
            // Before applying update ranges, we merge any adjacent / overlapping
            // ranges to reduce load on `gl.bufferSubData`. Empirically, this has led
            // to performance improvements for applications which make heavy use of
            // update ranges. Likely due to GPU command overhead.
            //
            // Note that to reduce garbage collection between frames, we merge the
            // update ranges in-place. This is safe because this method will clear the
            // update ranges once updated.
            updateRanges.sort((a, b)=>a.start - b.start);
            // To merge the update ranges in-place, we work from left to right in the
            // existing updateRanges array, merging ranges. This may result in a final
            // array which is smaller than the original. This index tracks the last
            // index representing a merged range, any data after this index can be
            // trimmed once the merge algorithm is completed.
            let mergeIndex = 0;
            for(let i = 1; i < updateRanges.length; i++){
                const previousRange = updateRanges[mergeIndex];
                const range = updateRanges[i];
                // We add one here to merge adjacent ranges. This is safe because ranges
                // operate over positive integers.
                if (range.start <= previousRange.start + previousRange.count + 1) previousRange.count = Math.max(previousRange.count, range.start + range.count - previousRange.start);
                else {
                    ++mergeIndex;
                    updateRanges[mergeIndex] = range;
                }
            }
            // Trim the array to only contain the merged ranges.
            updateRanges.length = mergeIndex + 1;
            for(let i = 0, l = updateRanges.length; i < l; i++){
                const range = updateRanges[i];
                gl.bufferSubData(bufferType, range.start * array.BYTES_PER_ELEMENT, array, range.start, range.count);
            }
            attribute.clearUpdateRanges();
        }
        attribute.onUploadCallback();
    }
    //
    function get(attribute) {
        if (attribute.isInterleavedBufferAttribute) attribute = attribute.data;
        return buffers.get(attribute);
    }
    function remove(attribute) {
        if (attribute.isInterleavedBufferAttribute) attribute = attribute.data;
        const data = buffers.get(attribute);
        if (data) {
            gl.deleteBuffer(data.buffer);
            buffers.delete(attribute);
        }
    }
    function update(attribute, bufferType) {
        if (attribute.isInterleavedBufferAttribute) attribute = attribute.data;
        if (attribute.isGLBufferAttribute) {
            const cached = buffers.get(attribute);
            if (!cached || cached.version < attribute.version) buffers.set(attribute, {
                buffer: attribute.buffer,
                type: attribute.type,
                bytesPerElement: attribute.elementSize,
                version: attribute.version
            });
            return;
        }
        const data = buffers.get(attribute);
        if (data === undefined) buffers.set(attribute, createBuffer(attribute, bufferType));
        else if (data.version < attribute.version) {
            if (data.size !== attribute.array.byteLength) throw new Error('THREE.WebGLAttributes: The size of the buffer attribute\'s array buffer does not match the original size. Resizing buffer attributes is not supported.');
            updateBuffer(data.buffer, attribute, bufferType);
            data.version = attribute.version;
        }
    }
    return {
        get: get,
        remove: remove,
        update: update
    };
}
class $d5b33d7c30034067$export$967d831af31f69ce extends $d5b33d7c30034067$export$b7be63a67df8959 {
    constructor(width = 1, height = 1, widthSegments = 1, heightSegments = 1){
        super();
        this.type = 'PlaneGeometry';
        this.parameters = {
            width: width,
            height: height,
            widthSegments: widthSegments,
            heightSegments: heightSegments
        };
        const width_half = width / 2;
        const height_half = height / 2;
        const gridX = Math.floor(widthSegments);
        const gridY = Math.floor(heightSegments);
        const gridX1 = gridX + 1;
        const gridY1 = gridY + 1;
        const segment_width = width / gridX;
        const segment_height = height / gridY;
        //
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        for(let iy = 0; iy < gridY1; iy++){
            const y = iy * segment_height - height_half;
            for(let ix = 0; ix < gridX1; ix++){
                const x = ix * segment_width - width_half;
                vertices.push(x, -y, 0);
                normals.push(0, 0, 1);
                uvs.push(ix / gridX);
                uvs.push(1 - iy / gridY);
            }
        }
        for(let iy = 0; iy < gridY; iy++)for(let ix = 0; ix < gridX; ix++){
            const a = ix + gridX1 * iy;
            const b = ix + gridX1 * (iy + 1);
            const c = ix + 1 + gridX1 * (iy + 1);
            const d = ix + 1 + gridX1 * iy;
            indices.push(a, b, d);
            indices.push(b, c, d);
        }
        this.setIndex(indices);
        this.setAttribute('position', new $d5b33d7c30034067$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute('normal', new $d5b33d7c30034067$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute('uv', new $d5b33d7c30034067$export$cbe7a62641830ebd(uvs, 2));
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    static fromJSON(data) {
        return new $d5b33d7c30034067$export$967d831af31f69ce(data.width, data.height, data.widthSegments, data.heightSegments);
    }
}
var $d5b33d7c30034067$var$alphahash_fragment = "#ifdef USE_ALPHAHASH\n\tif ( diffuseColor.a < getAlphaHashThreshold( vPosition ) ) discard;\n#endif";
var $d5b33d7c30034067$var$alphahash_pars_fragment = "#ifdef USE_ALPHAHASH\n\tconst float ALPHA_HASH_SCALE = 0.05;\n\tfloat hash2D( vec2 value ) {\n\t\treturn fract( 1.0e4 * sin( 17.0 * value.x + 0.1 * value.y ) * ( 0.1 + abs( sin( 13.0 * value.y + value.x ) ) ) );\n\t}\n\tfloat hash3D( vec3 value ) {\n\t\treturn hash2D( vec2( hash2D( value.xy ), value.z ) );\n\t}\n\tfloat getAlphaHashThreshold( vec3 position ) {\n\t\tfloat maxDeriv = max(\n\t\t\tlength( dFdx( position.xyz ) ),\n\t\t\tlength( dFdy( position.xyz ) )\n\t\t);\n\t\tfloat pixScale = 1.0 / ( ALPHA_HASH_SCALE * maxDeriv );\n\t\tvec2 pixScales = vec2(\n\t\t\texp2( floor( log2( pixScale ) ) ),\n\t\t\texp2( ceil( log2( pixScale ) ) )\n\t\t);\n\t\tvec2 alpha = vec2(\n\t\t\thash3D( floor( pixScales.x * position.xyz ) ),\n\t\t\thash3D( floor( pixScales.y * position.xyz ) )\n\t\t);\n\t\tfloat lerpFactor = fract( log2( pixScale ) );\n\t\tfloat x = ( 1.0 - lerpFactor ) * alpha.x + lerpFactor * alpha.y;\n\t\tfloat a = min( lerpFactor, 1.0 - lerpFactor );\n\t\tvec3 cases = vec3(\n\t\t\tx * x / ( 2.0 * a * ( 1.0 - a ) ),\n\t\t\t( x - 0.5 * a ) / ( 1.0 - a ),\n\t\t\t1.0 - ( ( 1.0 - x ) * ( 1.0 - x ) / ( 2.0 * a * ( 1.0 - a ) ) )\n\t\t);\n\t\tfloat threshold = ( x < ( 1.0 - a ) )\n\t\t\t? ( ( x < a ) ? cases.x : cases.y )\n\t\t\t: cases.z;\n\t\treturn clamp( threshold , 1.0e-6, 1.0 );\n\t}\n#endif";
var $d5b33d7c30034067$var$alphamap_fragment = "#ifdef USE_ALPHAMAP\n\tdiffuseColor.a *= texture2D( alphaMap, vAlphaMapUv ).g;\n#endif";
var $d5b33d7c30034067$var$alphamap_pars_fragment = "#ifdef USE_ALPHAMAP\n\tuniform sampler2D alphaMap;\n#endif";
var $d5b33d7c30034067$var$alphatest_fragment = "#ifdef USE_ALPHATEST\n\t#ifdef ALPHA_TO_COVERAGE\n\tdiffuseColor.a = smoothstep( alphaTest, alphaTest + fwidth( diffuseColor.a ), diffuseColor.a );\n\tif ( diffuseColor.a == 0.0 ) discard;\n\t#else\n\tif ( diffuseColor.a < alphaTest ) discard;\n\t#endif\n#endif";
var $d5b33d7c30034067$var$alphatest_pars_fragment = "#ifdef USE_ALPHATEST\n\tuniform float alphaTest;\n#endif";
var $d5b33d7c30034067$var$aomap_fragment = "#ifdef USE_AOMAP\n\tfloat ambientOcclusion = ( texture2D( aoMap, vAoMapUv ).r - 1.0 ) * aoMapIntensity + 1.0;\n\treflectedLight.indirectDiffuse *= ambientOcclusion;\n\t#if defined( USE_CLEARCOAT ) \n\t\tclearcoatSpecularIndirect *= ambientOcclusion;\n\t#endif\n\t#if defined( USE_SHEEN ) \n\t\tsheenSpecularIndirect *= ambientOcclusion;\n\t#endif\n\t#if defined( USE_ENVMAP ) && defined( STANDARD )\n\t\tfloat dotNV = saturate( dot( geometryNormal, geometryViewDir ) );\n\t\treflectedLight.indirectSpecular *= computeSpecularOcclusion( dotNV, ambientOcclusion, material.roughness );\n\t#endif\n#endif";
var $d5b33d7c30034067$var$aomap_pars_fragment = "#ifdef USE_AOMAP\n\tuniform sampler2D aoMap;\n\tuniform float aoMapIntensity;\n#endif";
var $d5b33d7c30034067$var$batching_pars_vertex = "#ifdef USE_BATCHING\n\t#if ! defined( GL_ANGLE_multi_draw )\n\t#define gl_DrawID _gl_DrawID\n\tuniform int _gl_DrawID;\n\t#endif\n\tuniform highp sampler2D batchingTexture;\n\tuniform highp usampler2D batchingIdTexture;\n\tmat4 getBatchingMatrix( const in float i ) {\n\t\tint size = textureSize( batchingTexture, 0 ).x;\n\t\tint j = int( i ) * 4;\n\t\tint x = j % size;\n\t\tint y = j / size;\n\t\tvec4 v1 = texelFetch( batchingTexture, ivec2( x, y ), 0 );\n\t\tvec4 v2 = texelFetch( batchingTexture, ivec2( x + 1, y ), 0 );\n\t\tvec4 v3 = texelFetch( batchingTexture, ivec2( x + 2, y ), 0 );\n\t\tvec4 v4 = texelFetch( batchingTexture, ivec2( x + 3, y ), 0 );\n\t\treturn mat4( v1, v2, v3, v4 );\n\t}\n\tfloat getIndirectIndex( const in int i ) {\n\t\tint size = textureSize( batchingIdTexture, 0 ).x;\n\t\tint x = i % size;\n\t\tint y = i / size;\n\t\treturn float( texelFetch( batchingIdTexture, ivec2( x, y ), 0 ).r );\n\t}\n#endif\n#ifdef USE_BATCHING_COLOR\n\tuniform sampler2D batchingColorTexture;\n\tvec3 getBatchingColor( const in float i ) {\n\t\tint size = textureSize( batchingColorTexture, 0 ).x;\n\t\tint j = int( i );\n\t\tint x = j % size;\n\t\tint y = j / size;\n\t\treturn texelFetch( batchingColorTexture, ivec2( x, y ), 0 ).rgb;\n\t}\n#endif";
var $d5b33d7c30034067$var$batching_vertex = "#ifdef USE_BATCHING\n\tmat4 batchingMatrix = getBatchingMatrix( getIndirectIndex( gl_DrawID ) );\n#endif";
var $d5b33d7c30034067$var$begin_vertex = "vec3 transformed = vec3( position );\n#ifdef USE_ALPHAHASH\n\tvPosition = vec3( position );\n#endif";
var $d5b33d7c30034067$var$beginnormal_vertex = "vec3 objectNormal = vec3( normal );\n#ifdef USE_TANGENT\n\tvec3 objectTangent = vec3( tangent.xyz );\n#endif";
var $d5b33d7c30034067$var$bsdfs = "float G_BlinnPhong_Implicit( ) {\n\treturn 0.25;\n}\nfloat D_BlinnPhong( const in float shininess, const in float dotNH ) {\n\treturn RECIPROCAL_PI * ( shininess * 0.5 + 1.0 ) * pow( dotNH, shininess );\n}\nvec3 BRDF_BlinnPhong( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in vec3 specularColor, const in float shininess ) {\n\tvec3 halfDir = normalize( lightDir + viewDir );\n\tfloat dotNH = saturate( dot( normal, halfDir ) );\n\tfloat dotVH = saturate( dot( viewDir, halfDir ) );\n\tvec3 F = F_Schlick( specularColor, 1.0, dotVH );\n\tfloat G = G_BlinnPhong_Implicit( );\n\tfloat D = D_BlinnPhong( shininess, dotNH );\n\treturn F * ( G * D );\n} // validated";
var $d5b33d7c30034067$var$iridescence_fragment = "#ifdef USE_IRIDESCENCE\n\tconst mat3 XYZ_TO_REC709 = mat3(\n\t\t 3.2404542, -0.9692660,  0.0556434,\n\t\t-1.5371385,  1.8760108, -0.2040259,\n\t\t-0.4985314,  0.0415560,  1.0572252\n\t);\n\tvec3 Fresnel0ToIor( vec3 fresnel0 ) {\n\t\tvec3 sqrtF0 = sqrt( fresnel0 );\n\t\treturn ( vec3( 1.0 ) + sqrtF0 ) / ( vec3( 1.0 ) - sqrtF0 );\n\t}\n\tvec3 IorToFresnel0( vec3 transmittedIor, float incidentIor ) {\n\t\treturn pow2( ( transmittedIor - vec3( incidentIor ) ) / ( transmittedIor + vec3( incidentIor ) ) );\n\t}\n\tfloat IorToFresnel0( float transmittedIor, float incidentIor ) {\n\t\treturn pow2( ( transmittedIor - incidentIor ) / ( transmittedIor + incidentIor ));\n\t}\n\tvec3 evalSensitivity( float OPD, vec3 shift ) {\n\t\tfloat phase = 2.0 * PI * OPD * 1.0e-9;\n\t\tvec3 val = vec3( 5.4856e-13, 4.4201e-13, 5.2481e-13 );\n\t\tvec3 pos = vec3( 1.6810e+06, 1.7953e+06, 2.2084e+06 );\n\t\tvec3 var = vec3( 4.3278e+09, 9.3046e+09, 6.6121e+09 );\n\t\tvec3 xyz = val * sqrt( 2.0 * PI * var ) * cos( pos * phase + shift ) * exp( - pow2( phase ) * var );\n\t\txyz.x += 9.7470e-14 * sqrt( 2.0 * PI * 4.5282e+09 ) * cos( 2.2399e+06 * phase + shift[ 0 ] ) * exp( - 4.5282e+09 * pow2( phase ) );\n\t\txyz /= 1.0685e-7;\n\t\tvec3 rgb = XYZ_TO_REC709 * xyz;\n\t\treturn rgb;\n\t}\n\tvec3 evalIridescence( float outsideIOR, float eta2, float cosTheta1, float thinFilmThickness, vec3 baseF0 ) {\n\t\tvec3 I;\n\t\tfloat iridescenceIOR = mix( outsideIOR, eta2, smoothstep( 0.0, 0.03, thinFilmThickness ) );\n\t\tfloat sinTheta2Sq = pow2( outsideIOR / iridescenceIOR ) * ( 1.0 - pow2( cosTheta1 ) );\n\t\tfloat cosTheta2Sq = 1.0 - sinTheta2Sq;\n\t\tif ( cosTheta2Sq < 0.0 ) {\n\t\t\treturn vec3( 1.0 );\n\t\t}\n\t\tfloat cosTheta2 = sqrt( cosTheta2Sq );\n\t\tfloat R0 = IorToFresnel0( iridescenceIOR, outsideIOR );\n\t\tfloat R12 = F_Schlick( R0, 1.0, cosTheta1 );\n\t\tfloat T121 = 1.0 - R12;\n\t\tfloat phi12 = 0.0;\n\t\tif ( iridescenceIOR < outsideIOR ) phi12 = PI;\n\t\tfloat phi21 = PI - phi12;\n\t\tvec3 baseIOR = Fresnel0ToIor( clamp( baseF0, 0.0, 0.9999 ) );\t\tvec3 R1 = IorToFresnel0( baseIOR, iridescenceIOR );\n\t\tvec3 R23 = F_Schlick( R1, 1.0, cosTheta2 );\n\t\tvec3 phi23 = vec3( 0.0 );\n\t\tif ( baseIOR[ 0 ] < iridescenceIOR ) phi23[ 0 ] = PI;\n\t\tif ( baseIOR[ 1 ] < iridescenceIOR ) phi23[ 1 ] = PI;\n\t\tif ( baseIOR[ 2 ] < iridescenceIOR ) phi23[ 2 ] = PI;\n\t\tfloat OPD = 2.0 * iridescenceIOR * thinFilmThickness * cosTheta2;\n\t\tvec3 phi = vec3( phi21 ) + phi23;\n\t\tvec3 R123 = clamp( R12 * R23, 1e-5, 0.9999 );\n\t\tvec3 r123 = sqrt( R123 );\n\t\tvec3 Rs = pow2( T121 ) * R23 / ( vec3( 1.0 ) - R123 );\n\t\tvec3 C0 = R12 + Rs;\n\t\tI = C0;\n\t\tvec3 Cm = Rs - T121;\n\t\tfor ( int m = 1; m <= 2; ++ m ) {\n\t\t\tCm *= r123;\n\t\t\tvec3 Sm = 2.0 * evalSensitivity( float( m ) * OPD, float( m ) * phi );\n\t\t\tI += Cm * Sm;\n\t\t}\n\t\treturn max( I, vec3( 0.0 ) );\n\t}\n#endif";
var $d5b33d7c30034067$var$bumpmap_pars_fragment = "#ifdef USE_BUMPMAP\n\tuniform sampler2D bumpMap;\n\tuniform float bumpScale;\n\tvec2 dHdxy_fwd() {\n\t\tvec2 dSTdx = dFdx( vBumpMapUv );\n\t\tvec2 dSTdy = dFdy( vBumpMapUv );\n\t\tfloat Hll = bumpScale * texture2D( bumpMap, vBumpMapUv ).x;\n\t\tfloat dBx = bumpScale * texture2D( bumpMap, vBumpMapUv + dSTdx ).x - Hll;\n\t\tfloat dBy = bumpScale * texture2D( bumpMap, vBumpMapUv + dSTdy ).x - Hll;\n\t\treturn vec2( dBx, dBy );\n\t}\n\tvec3 perturbNormalArb( vec3 surf_pos, vec3 surf_norm, vec2 dHdxy, float faceDirection ) {\n\t\tvec3 vSigmaX = normalize( dFdx( surf_pos.xyz ) );\n\t\tvec3 vSigmaY = normalize( dFdy( surf_pos.xyz ) );\n\t\tvec3 vN = surf_norm;\n\t\tvec3 R1 = cross( vSigmaY, vN );\n\t\tvec3 R2 = cross( vN, vSigmaX );\n\t\tfloat fDet = dot( vSigmaX, R1 ) * faceDirection;\n\t\tvec3 vGrad = sign( fDet ) * ( dHdxy.x * R1 + dHdxy.y * R2 );\n\t\treturn normalize( abs( fDet ) * surf_norm - vGrad );\n\t}\n#endif";
var $d5b33d7c30034067$var$clipping_planes_fragment = "#if NUM_CLIPPING_PLANES > 0\n\tvec4 plane;\n\t#ifdef ALPHA_TO_COVERAGE\n\t\tfloat distanceToPlane, distanceGradient;\n\t\tfloat clipOpacity = 1.0;\n\t\t#pragma unroll_loop_start\n\t\tfor ( int i = 0; i < UNION_CLIPPING_PLANES; i ++ ) {\n\t\t\tplane = clippingPlanes[ i ];\n\t\t\tdistanceToPlane = - dot( vClipPosition, plane.xyz ) + plane.w;\n\t\t\tdistanceGradient = fwidth( distanceToPlane ) / 2.0;\n\t\t\tclipOpacity *= smoothstep( - distanceGradient, distanceGradient, distanceToPlane );\n\t\t\tif ( clipOpacity == 0.0 ) discard;\n\t\t}\n\t\t#pragma unroll_loop_end\n\t\t#if UNION_CLIPPING_PLANES < NUM_CLIPPING_PLANES\n\t\t\tfloat unionClipOpacity = 1.0;\n\t\t\t#pragma unroll_loop_start\n\t\t\tfor ( int i = UNION_CLIPPING_PLANES; i < NUM_CLIPPING_PLANES; i ++ ) {\n\t\t\t\tplane = clippingPlanes[ i ];\n\t\t\t\tdistanceToPlane = - dot( vClipPosition, plane.xyz ) + plane.w;\n\t\t\t\tdistanceGradient = fwidth( distanceToPlane ) / 2.0;\n\t\t\t\tunionClipOpacity *= 1.0 - smoothstep( - distanceGradient, distanceGradient, distanceToPlane );\n\t\t\t}\n\t\t\t#pragma unroll_loop_end\n\t\t\tclipOpacity *= 1.0 - unionClipOpacity;\n\t\t#endif\n\t\tdiffuseColor.a *= clipOpacity;\n\t\tif ( diffuseColor.a == 0.0 ) discard;\n\t#else\n\t\t#pragma unroll_loop_start\n\t\tfor ( int i = 0; i < UNION_CLIPPING_PLANES; i ++ ) {\n\t\t\tplane = clippingPlanes[ i ];\n\t\t\tif ( dot( vClipPosition, plane.xyz ) > plane.w ) discard;\n\t\t}\n\t\t#pragma unroll_loop_end\n\t\t#if UNION_CLIPPING_PLANES < NUM_CLIPPING_PLANES\n\t\t\tbool clipped = true;\n\t\t\t#pragma unroll_loop_start\n\t\t\tfor ( int i = UNION_CLIPPING_PLANES; i < NUM_CLIPPING_PLANES; i ++ ) {\n\t\t\t\tplane = clippingPlanes[ i ];\n\t\t\t\tclipped = ( dot( vClipPosition, plane.xyz ) > plane.w ) && clipped;\n\t\t\t}\n\t\t\t#pragma unroll_loop_end\n\t\t\tif ( clipped ) discard;\n\t\t#endif\n\t#endif\n#endif";
var $d5b33d7c30034067$var$clipping_planes_pars_fragment = "#if NUM_CLIPPING_PLANES > 0\n\tvarying vec3 vClipPosition;\n\tuniform vec4 clippingPlanes[ NUM_CLIPPING_PLANES ];\n#endif";
var $d5b33d7c30034067$var$clipping_planes_pars_vertex = "#if NUM_CLIPPING_PLANES > 0\n\tvarying vec3 vClipPosition;\n#endif";
var $d5b33d7c30034067$var$clipping_planes_vertex = "#if NUM_CLIPPING_PLANES > 0\n\tvClipPosition = - mvPosition.xyz;\n#endif";
var $d5b33d7c30034067$var$color_fragment = "#if defined( USE_COLOR_ALPHA )\n\tdiffuseColor *= vColor;\n#elif defined( USE_COLOR )\n\tdiffuseColor.rgb *= vColor;\n#endif";
var $d5b33d7c30034067$var$color_pars_fragment = "#if defined( USE_COLOR_ALPHA )\n\tvarying vec4 vColor;\n#elif defined( USE_COLOR )\n\tvarying vec3 vColor;\n#endif";
var $d5b33d7c30034067$var$color_pars_vertex = "#if defined( USE_COLOR_ALPHA )\n\tvarying vec4 vColor;\n#elif defined( USE_COLOR ) || defined( USE_INSTANCING_COLOR ) || defined( USE_BATCHING_COLOR )\n\tvarying vec3 vColor;\n#endif";
var $d5b33d7c30034067$var$color_vertex = "#if defined( USE_COLOR_ALPHA )\n\tvColor = vec4( 1.0 );\n#elif defined( USE_COLOR ) || defined( USE_INSTANCING_COLOR ) || defined( USE_BATCHING_COLOR )\n\tvColor = vec3( 1.0 );\n#endif\n#ifdef USE_COLOR\n\tvColor *= color;\n#endif\n#ifdef USE_INSTANCING_COLOR\n\tvColor.xyz *= instanceColor.xyz;\n#endif\n#ifdef USE_BATCHING_COLOR\n\tvec3 batchingColor = getBatchingColor( getIndirectIndex( gl_DrawID ) );\n\tvColor.xyz *= batchingColor.xyz;\n#endif";
var $d5b33d7c30034067$var$common = "#define PI 3.141592653589793\n#define PI2 6.283185307179586\n#define PI_HALF 1.5707963267948966\n#define RECIPROCAL_PI 0.3183098861837907\n#define RECIPROCAL_PI2 0.15915494309189535\n#define EPSILON 1e-6\n#ifndef saturate\n#define saturate( a ) clamp( a, 0.0, 1.0 )\n#endif\n#define whiteComplement( a ) ( 1.0 - saturate( a ) )\nfloat pow2( const in float x ) { return x*x; }\nvec3 pow2( const in vec3 x ) { return x*x; }\nfloat pow3( const in float x ) { return x*x*x; }\nfloat pow4( const in float x ) { float x2 = x*x; return x2*x2; }\nfloat max3( const in vec3 v ) { return max( max( v.x, v.y ), v.z ); }\nfloat average( const in vec3 v ) { return dot( v, vec3( 0.3333333 ) ); }\nhighp float rand( const in vec2 uv ) {\n\tconst highp float a = 12.9898, b = 78.233, c = 43758.5453;\n\thighp float dt = dot( uv.xy, vec2( a,b ) ), sn = mod( dt, PI );\n\treturn fract( sin( sn ) * c );\n}\n#ifdef HIGH_PRECISION\n\tfloat precisionSafeLength( vec3 v ) { return length( v ); }\n#else\n\tfloat precisionSafeLength( vec3 v ) {\n\t\tfloat maxComponent = max3( abs( v ) );\n\t\treturn length( v / maxComponent ) * maxComponent;\n\t}\n#endif\nstruct IncidentLight {\n\tvec3 color;\n\tvec3 direction;\n\tbool visible;\n};\nstruct ReflectedLight {\n\tvec3 directDiffuse;\n\tvec3 directSpecular;\n\tvec3 indirectDiffuse;\n\tvec3 indirectSpecular;\n};\n#ifdef USE_ALPHAHASH\n\tvarying vec3 vPosition;\n#endif\nvec3 transformDirection( in vec3 dir, in mat4 matrix ) {\n\treturn normalize( ( matrix * vec4( dir, 0.0 ) ).xyz );\n}\nvec3 inverseTransformDirection( in vec3 dir, in mat4 matrix ) {\n\treturn normalize( ( vec4( dir, 0.0 ) * matrix ).xyz );\n}\nmat3 transposeMat3( const in mat3 m ) {\n\tmat3 tmp;\n\ttmp[ 0 ] = vec3( m[ 0 ].x, m[ 1 ].x, m[ 2 ].x );\n\ttmp[ 1 ] = vec3( m[ 0 ].y, m[ 1 ].y, m[ 2 ].y );\n\ttmp[ 2 ] = vec3( m[ 0 ].z, m[ 1 ].z, m[ 2 ].z );\n\treturn tmp;\n}\nbool isPerspectiveMatrix( mat4 m ) {\n\treturn m[ 2 ][ 3 ] == - 1.0;\n}\nvec2 equirectUv( in vec3 dir ) {\n\tfloat u = atan( dir.z, dir.x ) * RECIPROCAL_PI2 + 0.5;\n\tfloat v = asin( clamp( dir.y, - 1.0, 1.0 ) ) * RECIPROCAL_PI + 0.5;\n\treturn vec2( u, v );\n}\nvec3 BRDF_Lambert( const in vec3 diffuseColor ) {\n\treturn RECIPROCAL_PI * diffuseColor;\n}\nvec3 F_Schlick( const in vec3 f0, const in float f90, const in float dotVH ) {\n\tfloat fresnel = exp2( ( - 5.55473 * dotVH - 6.98316 ) * dotVH );\n\treturn f0 * ( 1.0 - fresnel ) + ( f90 * fresnel );\n}\nfloat F_Schlick( const in float f0, const in float f90, const in float dotVH ) {\n\tfloat fresnel = exp2( ( - 5.55473 * dotVH - 6.98316 ) * dotVH );\n\treturn f0 * ( 1.0 - fresnel ) + ( f90 * fresnel );\n} // validated";
var $d5b33d7c30034067$var$cube_uv_reflection_fragment = "#ifdef ENVMAP_TYPE_CUBE_UV\n\t#define cubeUV_minMipLevel 4.0\n\t#define cubeUV_minTileSize 16.0\n\tfloat getFace( vec3 direction ) {\n\t\tvec3 absDirection = abs( direction );\n\t\tfloat face = - 1.0;\n\t\tif ( absDirection.x > absDirection.z ) {\n\t\t\tif ( absDirection.x > absDirection.y )\n\t\t\t\tface = direction.x > 0.0 ? 0.0 : 3.0;\n\t\t\telse\n\t\t\t\tface = direction.y > 0.0 ? 1.0 : 4.0;\n\t\t} else {\n\t\t\tif ( absDirection.z > absDirection.y )\n\t\t\t\tface = direction.z > 0.0 ? 2.0 : 5.0;\n\t\t\telse\n\t\t\t\tface = direction.y > 0.0 ? 1.0 : 4.0;\n\t\t}\n\t\treturn face;\n\t}\n\tvec2 getUV( vec3 direction, float face ) {\n\t\tvec2 uv;\n\t\tif ( face == 0.0 ) {\n\t\t\tuv = vec2( direction.z, direction.y ) / abs( direction.x );\n\t\t} else if ( face == 1.0 ) {\n\t\t\tuv = vec2( - direction.x, - direction.z ) / abs( direction.y );\n\t\t} else if ( face == 2.0 ) {\n\t\t\tuv = vec2( - direction.x, direction.y ) / abs( direction.z );\n\t\t} else if ( face == 3.0 ) {\n\t\t\tuv = vec2( - direction.z, direction.y ) / abs( direction.x );\n\t\t} else if ( face == 4.0 ) {\n\t\t\tuv = vec2( - direction.x, direction.z ) / abs( direction.y );\n\t\t} else {\n\t\t\tuv = vec2( direction.x, direction.y ) / abs( direction.z );\n\t\t}\n\t\treturn 0.5 * ( uv + 1.0 );\n\t}\n\tvec3 bilinearCubeUV( sampler2D envMap, vec3 direction, float mipInt ) {\n\t\tfloat face = getFace( direction );\n\t\tfloat filterInt = max( cubeUV_minMipLevel - mipInt, 0.0 );\n\t\tmipInt = max( mipInt, cubeUV_minMipLevel );\n\t\tfloat faceSize = exp2( mipInt );\n\t\thighp vec2 uv = getUV( direction, face ) * ( faceSize - 2.0 ) + 1.0;\n\t\tif ( face > 2.0 ) {\n\t\t\tuv.y += faceSize;\n\t\t\tface -= 3.0;\n\t\t}\n\t\tuv.x += face * faceSize;\n\t\tuv.x += filterInt * 3.0 * cubeUV_minTileSize;\n\t\tuv.y += 4.0 * ( exp2( CUBEUV_MAX_MIP ) - faceSize );\n\t\tuv.x *= CUBEUV_TEXEL_WIDTH;\n\t\tuv.y *= CUBEUV_TEXEL_HEIGHT;\n\t\t#ifdef texture2DGradEXT\n\t\t\treturn texture2DGradEXT( envMap, uv, vec2( 0.0 ), vec2( 0.0 ) ).rgb;\n\t\t#else\n\t\t\treturn texture2D( envMap, uv ).rgb;\n\t\t#endif\n\t}\n\t#define cubeUV_r0 1.0\n\t#define cubeUV_m0 - 2.0\n\t#define cubeUV_r1 0.8\n\t#define cubeUV_m1 - 1.0\n\t#define cubeUV_r4 0.4\n\t#define cubeUV_m4 2.0\n\t#define cubeUV_r5 0.305\n\t#define cubeUV_m5 3.0\n\t#define cubeUV_r6 0.21\n\t#define cubeUV_m6 4.0\n\tfloat roughnessToMip( float roughness ) {\n\t\tfloat mip = 0.0;\n\t\tif ( roughness >= cubeUV_r1 ) {\n\t\t\tmip = ( cubeUV_r0 - roughness ) * ( cubeUV_m1 - cubeUV_m0 ) / ( cubeUV_r0 - cubeUV_r1 ) + cubeUV_m0;\n\t\t} else if ( roughness >= cubeUV_r4 ) {\n\t\t\tmip = ( cubeUV_r1 - roughness ) * ( cubeUV_m4 - cubeUV_m1 ) / ( cubeUV_r1 - cubeUV_r4 ) + cubeUV_m1;\n\t\t} else if ( roughness >= cubeUV_r5 ) {\n\t\t\tmip = ( cubeUV_r4 - roughness ) * ( cubeUV_m5 - cubeUV_m4 ) / ( cubeUV_r4 - cubeUV_r5 ) + cubeUV_m4;\n\t\t} else if ( roughness >= cubeUV_r6 ) {\n\t\t\tmip = ( cubeUV_r5 - roughness ) * ( cubeUV_m6 - cubeUV_m5 ) / ( cubeUV_r5 - cubeUV_r6 ) + cubeUV_m5;\n\t\t} else {\n\t\t\tmip = - 2.0 * log2( 1.16 * roughness );\t\t}\n\t\treturn mip;\n\t}\n\tvec4 textureCubeUV( sampler2D envMap, vec3 sampleDir, float roughness ) {\n\t\tfloat mip = clamp( roughnessToMip( roughness ), cubeUV_m0, CUBEUV_MAX_MIP );\n\t\tfloat mipF = fract( mip );\n\t\tfloat mipInt = floor( mip );\n\t\tvec3 color0 = bilinearCubeUV( envMap, sampleDir, mipInt );\n\t\tif ( mipF == 0.0 ) {\n\t\t\treturn vec4( color0, 1.0 );\n\t\t} else {\n\t\t\tvec3 color1 = bilinearCubeUV( envMap, sampleDir, mipInt + 1.0 );\n\t\t\treturn vec4( mix( color0, color1, mipF ), 1.0 );\n\t\t}\n\t}\n#endif";
var $d5b33d7c30034067$var$defaultnormal_vertex = "vec3 transformedNormal = objectNormal;\n#ifdef USE_TANGENT\n\tvec3 transformedTangent = objectTangent;\n#endif\n#ifdef USE_BATCHING\n\tmat3 bm = mat3( batchingMatrix );\n\ttransformedNormal /= vec3( dot( bm[ 0 ], bm[ 0 ] ), dot( bm[ 1 ], bm[ 1 ] ), dot( bm[ 2 ], bm[ 2 ] ) );\n\ttransformedNormal = bm * transformedNormal;\n\t#ifdef USE_TANGENT\n\t\ttransformedTangent = bm * transformedTangent;\n\t#endif\n#endif\n#ifdef USE_INSTANCING\n\tmat3 im = mat3( instanceMatrix );\n\ttransformedNormal /= vec3( dot( im[ 0 ], im[ 0 ] ), dot( im[ 1 ], im[ 1 ] ), dot( im[ 2 ], im[ 2 ] ) );\n\ttransformedNormal = im * transformedNormal;\n\t#ifdef USE_TANGENT\n\t\ttransformedTangent = im * transformedTangent;\n\t#endif\n#endif\ntransformedNormal = normalMatrix * transformedNormal;\n#ifdef FLIP_SIDED\n\ttransformedNormal = - transformedNormal;\n#endif\n#ifdef USE_TANGENT\n\ttransformedTangent = ( modelViewMatrix * vec4( transformedTangent, 0.0 ) ).xyz;\n\t#ifdef FLIP_SIDED\n\t\ttransformedTangent = - transformedTangent;\n\t#endif\n#endif";
var $d5b33d7c30034067$var$displacementmap_pars_vertex = "#ifdef USE_DISPLACEMENTMAP\n\tuniform sampler2D displacementMap;\n\tuniform float displacementScale;\n\tuniform float displacementBias;\n#endif";
var $d5b33d7c30034067$var$displacementmap_vertex = "#ifdef USE_DISPLACEMENTMAP\n\ttransformed += normalize( objectNormal ) * ( texture2D( displacementMap, vDisplacementMapUv ).x * displacementScale + displacementBias );\n#endif";
var $d5b33d7c30034067$var$emissivemap_fragment = "#ifdef USE_EMISSIVEMAP\n\tvec4 emissiveColor = texture2D( emissiveMap, vEmissiveMapUv );\n\t#ifdef DECODE_VIDEO_TEXTURE_EMISSIVE\n\t\temissiveColor = sRGBTransferEOTF( emissiveColor );\n\t#endif\n\ttotalEmissiveRadiance *= emissiveColor.rgb;\n#endif";
var $d5b33d7c30034067$var$emissivemap_pars_fragment = "#ifdef USE_EMISSIVEMAP\n\tuniform sampler2D emissiveMap;\n#endif";
var $d5b33d7c30034067$var$colorspace_fragment = "gl_FragColor = linearToOutputTexel( gl_FragColor );";
var $d5b33d7c30034067$var$colorspace_pars_fragment = "vec4 LinearTransferOETF( in vec4 value ) {\n\treturn value;\n}\nvec4 sRGBTransferEOTF( in vec4 value ) {\n\treturn vec4( mix( pow( value.rgb * 0.9478672986 + vec3( 0.0521327014 ), vec3( 2.4 ) ), value.rgb * 0.0773993808, vec3( lessThanEqual( value.rgb, vec3( 0.04045 ) ) ) ), value.a );\n}\nvec4 sRGBTransferOETF( in vec4 value ) {\n\treturn vec4( mix( pow( value.rgb, vec3( 0.41666 ) ) * 1.055 - vec3( 0.055 ), value.rgb * 12.92, vec3( lessThanEqual( value.rgb, vec3( 0.0031308 ) ) ) ), value.a );\n}";
var $d5b33d7c30034067$var$envmap_fragment = "#ifdef USE_ENVMAP\n\t#ifdef ENV_WORLDPOS\n\t\tvec3 cameraToFrag;\n\t\tif ( isOrthographic ) {\n\t\t\tcameraToFrag = normalize( vec3( - viewMatrix[ 0 ][ 2 ], - viewMatrix[ 1 ][ 2 ], - viewMatrix[ 2 ][ 2 ] ) );\n\t\t} else {\n\t\t\tcameraToFrag = normalize( vWorldPosition - cameraPosition );\n\t\t}\n\t\tvec3 worldNormal = inverseTransformDirection( normal, viewMatrix );\n\t\t#ifdef ENVMAP_MODE_REFLECTION\n\t\t\tvec3 reflectVec = reflect( cameraToFrag, worldNormal );\n\t\t#else\n\t\t\tvec3 reflectVec = refract( cameraToFrag, worldNormal, refractionRatio );\n\t\t#endif\n\t#else\n\t\tvec3 reflectVec = vReflect;\n\t#endif\n\t#ifdef ENVMAP_TYPE_CUBE\n\t\tvec4 envColor = textureCube( envMap, envMapRotation * vec3( flipEnvMap * reflectVec.x, reflectVec.yz ) );\n\t#else\n\t\tvec4 envColor = vec4( 0.0 );\n\t#endif\n\t#ifdef ENVMAP_BLENDING_MULTIPLY\n\t\toutgoingLight = mix( outgoingLight, outgoingLight * envColor.xyz, specularStrength * reflectivity );\n\t#elif defined( ENVMAP_BLENDING_MIX )\n\t\toutgoingLight = mix( outgoingLight, envColor.xyz, specularStrength * reflectivity );\n\t#elif defined( ENVMAP_BLENDING_ADD )\n\t\toutgoingLight += envColor.xyz * specularStrength * reflectivity;\n\t#endif\n#endif";
var $d5b33d7c30034067$var$envmap_common_pars_fragment = "#ifdef USE_ENVMAP\n\tuniform float envMapIntensity;\n\tuniform float flipEnvMap;\n\tuniform mat3 envMapRotation;\n\t#ifdef ENVMAP_TYPE_CUBE\n\t\tuniform samplerCube envMap;\n\t#else\n\t\tuniform sampler2D envMap;\n\t#endif\n\t\n#endif";
var $d5b33d7c30034067$var$envmap_pars_fragment = "#ifdef USE_ENVMAP\n\tuniform float reflectivity;\n\t#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG ) || defined( LAMBERT )\n\t\t#define ENV_WORLDPOS\n\t#endif\n\t#ifdef ENV_WORLDPOS\n\t\tvarying vec3 vWorldPosition;\n\t\tuniform float refractionRatio;\n\t#else\n\t\tvarying vec3 vReflect;\n\t#endif\n#endif";
var $d5b33d7c30034067$var$envmap_pars_vertex = "#ifdef USE_ENVMAP\n\t#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG ) || defined( LAMBERT )\n\t\t#define ENV_WORLDPOS\n\t#endif\n\t#ifdef ENV_WORLDPOS\n\t\t\n\t\tvarying vec3 vWorldPosition;\n\t#else\n\t\tvarying vec3 vReflect;\n\t\tuniform float refractionRatio;\n\t#endif\n#endif";
var $d5b33d7c30034067$var$envmap_vertex = "#ifdef USE_ENVMAP\n\t#ifdef ENV_WORLDPOS\n\t\tvWorldPosition = worldPosition.xyz;\n\t#else\n\t\tvec3 cameraToVertex;\n\t\tif ( isOrthographic ) {\n\t\t\tcameraToVertex = normalize( vec3( - viewMatrix[ 0 ][ 2 ], - viewMatrix[ 1 ][ 2 ], - viewMatrix[ 2 ][ 2 ] ) );\n\t\t} else {\n\t\t\tcameraToVertex = normalize( worldPosition.xyz - cameraPosition );\n\t\t}\n\t\tvec3 worldNormal = inverseTransformDirection( transformedNormal, viewMatrix );\n\t\t#ifdef ENVMAP_MODE_REFLECTION\n\t\t\tvReflect = reflect( cameraToVertex, worldNormal );\n\t\t#else\n\t\t\tvReflect = refract( cameraToVertex, worldNormal, refractionRatio );\n\t\t#endif\n\t#endif\n#endif";
var $d5b33d7c30034067$var$fog_vertex = "#ifdef USE_FOG\n\tvFogDepth = - mvPosition.z;\n#endif";
var $d5b33d7c30034067$var$fog_pars_vertex = "#ifdef USE_FOG\n\tvarying float vFogDepth;\n#endif";
var $d5b33d7c30034067$var$fog_fragment = "#ifdef USE_FOG\n\t#ifdef FOG_EXP2\n\t\tfloat fogFactor = 1.0 - exp( - fogDensity * fogDensity * vFogDepth * vFogDepth );\n\t#else\n\t\tfloat fogFactor = smoothstep( fogNear, fogFar, vFogDepth );\n\t#endif\n\tgl_FragColor.rgb = mix( gl_FragColor.rgb, fogColor, fogFactor );\n#endif";
var $d5b33d7c30034067$var$fog_pars_fragment = "#ifdef USE_FOG\n\tuniform vec3 fogColor;\n\tvarying float vFogDepth;\n\t#ifdef FOG_EXP2\n\t\tuniform float fogDensity;\n\t#else\n\t\tuniform float fogNear;\n\t\tuniform float fogFar;\n\t#endif\n#endif";
var $d5b33d7c30034067$var$gradientmap_pars_fragment = "#ifdef USE_GRADIENTMAP\n\tuniform sampler2D gradientMap;\n#endif\nvec3 getGradientIrradiance( vec3 normal, vec3 lightDirection ) {\n\tfloat dotNL = dot( normal, lightDirection );\n\tvec2 coord = vec2( dotNL * 0.5 + 0.5, 0.0 );\n\t#ifdef USE_GRADIENTMAP\n\t\treturn vec3( texture2D( gradientMap, coord ).r );\n\t#else\n\t\tvec2 fw = fwidth( coord ) * 0.5;\n\t\treturn mix( vec3( 0.7 ), vec3( 1.0 ), smoothstep( 0.7 - fw.x, 0.7 + fw.x, coord.x ) );\n\t#endif\n}";
var $d5b33d7c30034067$var$lightmap_pars_fragment = "#ifdef USE_LIGHTMAP\n\tuniform sampler2D lightMap;\n\tuniform float lightMapIntensity;\n#endif";
var $d5b33d7c30034067$var$lights_lambert_fragment = "LambertMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;\nmaterial.specularStrength = specularStrength;";
var $d5b33d7c30034067$var$lights_lambert_pars_fragment = "varying vec3 vViewPosition;\nstruct LambertMaterial {\n\tvec3 diffuseColor;\n\tfloat specularStrength;\n};\nvoid RE_Direct_Lambert( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in LambertMaterial material, inout ReflectedLight reflectedLight ) {\n\tfloat dotNL = saturate( dot( geometryNormal, directLight.direction ) );\n\tvec3 irradiance = dotNL * directLight.color;\n\treflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectDiffuse_Lambert( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in LambertMaterial material, inout ReflectedLight reflectedLight ) {\n\treflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\n#define RE_Direct\t\t\t\tRE_Direct_Lambert\n#define RE_IndirectDiffuse\t\tRE_IndirectDiffuse_Lambert";
var $d5b33d7c30034067$var$lights_pars_begin = "uniform bool receiveShadow;\nuniform vec3 ambientLightColor;\n#if defined( USE_LIGHT_PROBES )\n\tuniform vec3 lightProbe[ 9 ];\n#endif\nvec3 shGetIrradianceAt( in vec3 normal, in vec3 shCoefficients[ 9 ] ) {\n\tfloat x = normal.x, y = normal.y, z = normal.z;\n\tvec3 result = shCoefficients[ 0 ] * 0.886227;\n\tresult += shCoefficients[ 1 ] * 2.0 * 0.511664 * y;\n\tresult += shCoefficients[ 2 ] * 2.0 * 0.511664 * z;\n\tresult += shCoefficients[ 3 ] * 2.0 * 0.511664 * x;\n\tresult += shCoefficients[ 4 ] * 2.0 * 0.429043 * x * y;\n\tresult += shCoefficients[ 5 ] * 2.0 * 0.429043 * y * z;\n\tresult += shCoefficients[ 6 ] * ( 0.743125 * z * z - 0.247708 );\n\tresult += shCoefficients[ 7 ] * 2.0 * 0.429043 * x * z;\n\tresult += shCoefficients[ 8 ] * 0.429043 * ( x * x - y * y );\n\treturn result;\n}\nvec3 getLightProbeIrradiance( const in vec3 lightProbe[ 9 ], const in vec3 normal ) {\n\tvec3 worldNormal = inverseTransformDirection( normal, viewMatrix );\n\tvec3 irradiance = shGetIrradianceAt( worldNormal, lightProbe );\n\treturn irradiance;\n}\nvec3 getAmbientLightIrradiance( const in vec3 ambientLightColor ) {\n\tvec3 irradiance = ambientLightColor;\n\treturn irradiance;\n}\nfloat getDistanceAttenuation( const in float lightDistance, const in float cutoffDistance, const in float decayExponent ) {\n\tfloat distanceFalloff = 1.0 / max( pow( lightDistance, decayExponent ), 0.01 );\n\tif ( cutoffDistance > 0.0 ) {\n\t\tdistanceFalloff *= pow2( saturate( 1.0 - pow4( lightDistance / cutoffDistance ) ) );\n\t}\n\treturn distanceFalloff;\n}\nfloat getSpotAttenuation( const in float coneCosine, const in float penumbraCosine, const in float angleCosine ) {\n\treturn smoothstep( coneCosine, penumbraCosine, angleCosine );\n}\n#if NUM_DIR_LIGHTS > 0\n\tstruct DirectionalLight {\n\t\tvec3 direction;\n\t\tvec3 color;\n\t};\n\tuniform DirectionalLight directionalLights[ NUM_DIR_LIGHTS ];\n\tvoid getDirectionalLightInfo( const in DirectionalLight directionalLight, out IncidentLight light ) {\n\t\tlight.color = directionalLight.color;\n\t\tlight.direction = directionalLight.direction;\n\t\tlight.visible = true;\n\t}\n#endif\n#if NUM_POINT_LIGHTS > 0\n\tstruct PointLight {\n\t\tvec3 position;\n\t\tvec3 color;\n\t\tfloat distance;\n\t\tfloat decay;\n\t};\n\tuniform PointLight pointLights[ NUM_POINT_LIGHTS ];\n\tvoid getPointLightInfo( const in PointLight pointLight, const in vec3 geometryPosition, out IncidentLight light ) {\n\t\tvec3 lVector = pointLight.position - geometryPosition;\n\t\tlight.direction = normalize( lVector );\n\t\tfloat lightDistance = length( lVector );\n\t\tlight.color = pointLight.color;\n\t\tlight.color *= getDistanceAttenuation( lightDistance, pointLight.distance, pointLight.decay );\n\t\tlight.visible = ( light.color != vec3( 0.0 ) );\n\t}\n#endif\n#if NUM_SPOT_LIGHTS > 0\n\tstruct SpotLight {\n\t\tvec3 position;\n\t\tvec3 direction;\n\t\tvec3 color;\n\t\tfloat distance;\n\t\tfloat decay;\n\t\tfloat coneCos;\n\t\tfloat penumbraCos;\n\t};\n\tuniform SpotLight spotLights[ NUM_SPOT_LIGHTS ];\n\tvoid getSpotLightInfo( const in SpotLight spotLight, const in vec3 geometryPosition, out IncidentLight light ) {\n\t\tvec3 lVector = spotLight.position - geometryPosition;\n\t\tlight.direction = normalize( lVector );\n\t\tfloat angleCos = dot( light.direction, spotLight.direction );\n\t\tfloat spotAttenuation = getSpotAttenuation( spotLight.coneCos, spotLight.penumbraCos, angleCos );\n\t\tif ( spotAttenuation > 0.0 ) {\n\t\t\tfloat lightDistance = length( lVector );\n\t\t\tlight.color = spotLight.color * spotAttenuation;\n\t\t\tlight.color *= getDistanceAttenuation( lightDistance, spotLight.distance, spotLight.decay );\n\t\t\tlight.visible = ( light.color != vec3( 0.0 ) );\n\t\t} else {\n\t\t\tlight.color = vec3( 0.0 );\n\t\t\tlight.visible = false;\n\t\t}\n\t}\n#endif\n#if NUM_RECT_AREA_LIGHTS > 0\n\tstruct RectAreaLight {\n\t\tvec3 color;\n\t\tvec3 position;\n\t\tvec3 halfWidth;\n\t\tvec3 halfHeight;\n\t};\n\tuniform sampler2D ltc_1;\tuniform sampler2D ltc_2;\n\tuniform RectAreaLight rectAreaLights[ NUM_RECT_AREA_LIGHTS ];\n#endif\n#if NUM_HEMI_LIGHTS > 0\n\tstruct HemisphereLight {\n\t\tvec3 direction;\n\t\tvec3 skyColor;\n\t\tvec3 groundColor;\n\t};\n\tuniform HemisphereLight hemisphereLights[ NUM_HEMI_LIGHTS ];\n\tvec3 getHemisphereLightIrradiance( const in HemisphereLight hemiLight, const in vec3 normal ) {\n\t\tfloat dotNL = dot( normal, hemiLight.direction );\n\t\tfloat hemiDiffuseWeight = 0.5 * dotNL + 0.5;\n\t\tvec3 irradiance = mix( hemiLight.groundColor, hemiLight.skyColor, hemiDiffuseWeight );\n\t\treturn irradiance;\n\t}\n#endif";
var $d5b33d7c30034067$var$envmap_physical_pars_fragment = "#ifdef USE_ENVMAP\n\tvec3 getIBLIrradiance( const in vec3 normal ) {\n\t\t#ifdef ENVMAP_TYPE_CUBE_UV\n\t\t\tvec3 worldNormal = inverseTransformDirection( normal, viewMatrix );\n\t\t\tvec4 envMapColor = textureCubeUV( envMap, envMapRotation * worldNormal, 1.0 );\n\t\t\treturn PI * envMapColor.rgb * envMapIntensity;\n\t\t#else\n\t\t\treturn vec3( 0.0 );\n\t\t#endif\n\t}\n\tvec3 getIBLRadiance( const in vec3 viewDir, const in vec3 normal, const in float roughness ) {\n\t\t#ifdef ENVMAP_TYPE_CUBE_UV\n\t\t\tvec3 reflectVec = reflect( - viewDir, normal );\n\t\t\treflectVec = normalize( mix( reflectVec, normal, roughness * roughness) );\n\t\t\treflectVec = inverseTransformDirection( reflectVec, viewMatrix );\n\t\t\tvec4 envMapColor = textureCubeUV( envMap, envMapRotation * reflectVec, roughness );\n\t\t\treturn envMapColor.rgb * envMapIntensity;\n\t\t#else\n\t\t\treturn vec3( 0.0 );\n\t\t#endif\n\t}\n\t#ifdef USE_ANISOTROPY\n\t\tvec3 getIBLAnisotropyRadiance( const in vec3 viewDir, const in vec3 normal, const in float roughness, const in vec3 bitangent, const in float anisotropy ) {\n\t\t\t#ifdef ENVMAP_TYPE_CUBE_UV\n\t\t\t\tvec3 bentNormal = cross( bitangent, viewDir );\n\t\t\t\tbentNormal = normalize( cross( bentNormal, bitangent ) );\n\t\t\t\tbentNormal = normalize( mix( bentNormal, normal, pow2( pow2( 1.0 - anisotropy * ( 1.0 - roughness ) ) ) ) );\n\t\t\t\treturn getIBLRadiance( viewDir, bentNormal, roughness );\n\t\t\t#else\n\t\t\t\treturn vec3( 0.0 );\n\t\t\t#endif\n\t\t}\n\t#endif\n#endif";
var $d5b33d7c30034067$var$lights_toon_fragment = "ToonMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;";
var $d5b33d7c30034067$var$lights_toon_pars_fragment = "varying vec3 vViewPosition;\nstruct ToonMaterial {\n\tvec3 diffuseColor;\n};\nvoid RE_Direct_Toon( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in ToonMaterial material, inout ReflectedLight reflectedLight ) {\n\tvec3 irradiance = getGradientIrradiance( geometryNormal, directLight.direction ) * directLight.color;\n\treflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectDiffuse_Toon( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in ToonMaterial material, inout ReflectedLight reflectedLight ) {\n\treflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\n#define RE_Direct\t\t\t\tRE_Direct_Toon\n#define RE_IndirectDiffuse\t\tRE_IndirectDiffuse_Toon";
var $d5b33d7c30034067$var$lights_phong_fragment = "BlinnPhongMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;\nmaterial.specularColor = specular;\nmaterial.specularShininess = shininess;\nmaterial.specularStrength = specularStrength;";
var $d5b33d7c30034067$var$lights_phong_pars_fragment = "varying vec3 vViewPosition;\nstruct BlinnPhongMaterial {\n\tvec3 diffuseColor;\n\tvec3 specularColor;\n\tfloat specularShininess;\n\tfloat specularStrength;\n};\nvoid RE_Direct_BlinnPhong( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {\n\tfloat dotNL = saturate( dot( geometryNormal, directLight.direction ) );\n\tvec3 irradiance = dotNL * directLight.color;\n\treflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n\treflectedLight.directSpecular += irradiance * BRDF_BlinnPhong( directLight.direction, geometryViewDir, geometryNormal, material.specularColor, material.specularShininess ) * material.specularStrength;\n}\nvoid RE_IndirectDiffuse_BlinnPhong( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {\n\treflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\n#define RE_Direct\t\t\t\tRE_Direct_BlinnPhong\n#define RE_IndirectDiffuse\t\tRE_IndirectDiffuse_BlinnPhong";
var $d5b33d7c30034067$var$lights_physical_fragment = "PhysicalMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb * ( 1.0 - metalnessFactor );\nvec3 dxy = max( abs( dFdx( nonPerturbedNormal ) ), abs( dFdy( nonPerturbedNormal ) ) );\nfloat geometryRoughness = max( max( dxy.x, dxy.y ), dxy.z );\nmaterial.roughness = max( roughnessFactor, 0.0525 );material.roughness += geometryRoughness;\nmaterial.roughness = min( material.roughness, 1.0 );\n#ifdef IOR\n\tmaterial.ior = ior;\n\t#ifdef USE_SPECULAR\n\t\tfloat specularIntensityFactor = specularIntensity;\n\t\tvec3 specularColorFactor = specularColor;\n\t\t#ifdef USE_SPECULAR_COLORMAP\n\t\t\tspecularColorFactor *= texture2D( specularColorMap, vSpecularColorMapUv ).rgb;\n\t\t#endif\n\t\t#ifdef USE_SPECULAR_INTENSITYMAP\n\t\t\tspecularIntensityFactor *= texture2D( specularIntensityMap, vSpecularIntensityMapUv ).a;\n\t\t#endif\n\t\tmaterial.specularF90 = mix( specularIntensityFactor, 1.0, metalnessFactor );\n\t#else\n\t\tfloat specularIntensityFactor = 1.0;\n\t\tvec3 specularColorFactor = vec3( 1.0 );\n\t\tmaterial.specularF90 = 1.0;\n\t#endif\n\tmaterial.specularColor = mix( min( pow2( ( material.ior - 1.0 ) / ( material.ior + 1.0 ) ) * specularColorFactor, vec3( 1.0 ) ) * specularIntensityFactor, diffuseColor.rgb, metalnessFactor );\n#else\n\tmaterial.specularColor = mix( vec3( 0.04 ), diffuseColor.rgb, metalnessFactor );\n\tmaterial.specularF90 = 1.0;\n#endif\n#ifdef USE_CLEARCOAT\n\tmaterial.clearcoat = clearcoat;\n\tmaterial.clearcoatRoughness = clearcoatRoughness;\n\tmaterial.clearcoatF0 = vec3( 0.04 );\n\tmaterial.clearcoatF90 = 1.0;\n\t#ifdef USE_CLEARCOATMAP\n\t\tmaterial.clearcoat *= texture2D( clearcoatMap, vClearcoatMapUv ).x;\n\t#endif\n\t#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n\t\tmaterial.clearcoatRoughness *= texture2D( clearcoatRoughnessMap, vClearcoatRoughnessMapUv ).y;\n\t#endif\n\tmaterial.clearcoat = saturate( material.clearcoat );\tmaterial.clearcoatRoughness = max( material.clearcoatRoughness, 0.0525 );\n\tmaterial.clearcoatRoughness += geometryRoughness;\n\tmaterial.clearcoatRoughness = min( material.clearcoatRoughness, 1.0 );\n#endif\n#ifdef USE_DISPERSION\n\tmaterial.dispersion = dispersion;\n#endif\n#ifdef USE_IRIDESCENCE\n\tmaterial.iridescence = iridescence;\n\tmaterial.iridescenceIOR = iridescenceIOR;\n\t#ifdef USE_IRIDESCENCEMAP\n\t\tmaterial.iridescence *= texture2D( iridescenceMap, vIridescenceMapUv ).r;\n\t#endif\n\t#ifdef USE_IRIDESCENCE_THICKNESSMAP\n\t\tmaterial.iridescenceThickness = (iridescenceThicknessMaximum - iridescenceThicknessMinimum) * texture2D( iridescenceThicknessMap, vIridescenceThicknessMapUv ).g + iridescenceThicknessMinimum;\n\t#else\n\t\tmaterial.iridescenceThickness = iridescenceThicknessMaximum;\n\t#endif\n#endif\n#ifdef USE_SHEEN\n\tmaterial.sheenColor = sheenColor;\n\t#ifdef USE_SHEEN_COLORMAP\n\t\tmaterial.sheenColor *= texture2D( sheenColorMap, vSheenColorMapUv ).rgb;\n\t#endif\n\tmaterial.sheenRoughness = clamp( sheenRoughness, 0.07, 1.0 );\n\t#ifdef USE_SHEEN_ROUGHNESSMAP\n\t\tmaterial.sheenRoughness *= texture2D( sheenRoughnessMap, vSheenRoughnessMapUv ).a;\n\t#endif\n#endif\n#ifdef USE_ANISOTROPY\n\t#ifdef USE_ANISOTROPYMAP\n\t\tmat2 anisotropyMat = mat2( anisotropyVector.x, anisotropyVector.y, - anisotropyVector.y, anisotropyVector.x );\n\t\tvec3 anisotropyPolar = texture2D( anisotropyMap, vAnisotropyMapUv ).rgb;\n\t\tvec2 anisotropyV = anisotropyMat * normalize( 2.0 * anisotropyPolar.rg - vec2( 1.0 ) ) * anisotropyPolar.b;\n\t#else\n\t\tvec2 anisotropyV = anisotropyVector;\n\t#endif\n\tmaterial.anisotropy = length( anisotropyV );\n\tif( material.anisotropy == 0.0 ) {\n\t\tanisotropyV = vec2( 1.0, 0.0 );\n\t} else {\n\t\tanisotropyV /= material.anisotropy;\n\t\tmaterial.anisotropy = saturate( material.anisotropy );\n\t}\n\tmaterial.alphaT = mix( pow2( material.roughness ), 1.0, pow2( material.anisotropy ) );\n\tmaterial.anisotropyT = tbn[ 0 ] * anisotropyV.x + tbn[ 1 ] * anisotropyV.y;\n\tmaterial.anisotropyB = tbn[ 1 ] * anisotropyV.x - tbn[ 0 ] * anisotropyV.y;\n#endif";
var $d5b33d7c30034067$var$lights_physical_pars_fragment = "struct PhysicalMaterial {\n\tvec3 diffuseColor;\n\tfloat roughness;\n\tvec3 specularColor;\n\tfloat specularF90;\n\tfloat dispersion;\n\t#ifdef USE_CLEARCOAT\n\t\tfloat clearcoat;\n\t\tfloat clearcoatRoughness;\n\t\tvec3 clearcoatF0;\n\t\tfloat clearcoatF90;\n\t#endif\n\t#ifdef USE_IRIDESCENCE\n\t\tfloat iridescence;\n\t\tfloat iridescenceIOR;\n\t\tfloat iridescenceThickness;\n\t\tvec3 iridescenceFresnel;\n\t\tvec3 iridescenceF0;\n\t#endif\n\t#ifdef USE_SHEEN\n\t\tvec3 sheenColor;\n\t\tfloat sheenRoughness;\n\t#endif\n\t#ifdef IOR\n\t\tfloat ior;\n\t#endif\n\t#ifdef USE_TRANSMISSION\n\t\tfloat transmission;\n\t\tfloat transmissionAlpha;\n\t\tfloat thickness;\n\t\tfloat attenuationDistance;\n\t\tvec3 attenuationColor;\n\t#endif\n\t#ifdef USE_ANISOTROPY\n\t\tfloat anisotropy;\n\t\tfloat alphaT;\n\t\tvec3 anisotropyT;\n\t\tvec3 anisotropyB;\n\t#endif\n};\nvec3 clearcoatSpecularDirect = vec3( 0.0 );\nvec3 clearcoatSpecularIndirect = vec3( 0.0 );\nvec3 sheenSpecularDirect = vec3( 0.0 );\nvec3 sheenSpecularIndirect = vec3(0.0 );\nvec3 Schlick_to_F0( const in vec3 f, const in float f90, const in float dotVH ) {\n    float x = clamp( 1.0 - dotVH, 0.0, 1.0 );\n    float x2 = x * x;\n    float x5 = clamp( x * x2 * x2, 0.0, 0.9999 );\n    return ( f - vec3( f90 ) * x5 ) / ( 1.0 - x5 );\n}\nfloat V_GGX_SmithCorrelated( const in float alpha, const in float dotNL, const in float dotNV ) {\n\tfloat a2 = pow2( alpha );\n\tfloat gv = dotNL * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNV ) );\n\tfloat gl = dotNV * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNL ) );\n\treturn 0.5 / max( gv + gl, EPSILON );\n}\nfloat D_GGX( const in float alpha, const in float dotNH ) {\n\tfloat a2 = pow2( alpha );\n\tfloat denom = pow2( dotNH ) * ( a2 - 1.0 ) + 1.0;\n\treturn RECIPROCAL_PI * a2 / pow2( denom );\n}\n#ifdef USE_ANISOTROPY\n\tfloat V_GGX_SmithCorrelated_Anisotropic( const in float alphaT, const in float alphaB, const in float dotTV, const in float dotBV, const in float dotTL, const in float dotBL, const in float dotNV, const in float dotNL ) {\n\t\tfloat gv = dotNL * length( vec3( alphaT * dotTV, alphaB * dotBV, dotNV ) );\n\t\tfloat gl = dotNV * length( vec3( alphaT * dotTL, alphaB * dotBL, dotNL ) );\n\t\tfloat v = 0.5 / ( gv + gl );\n\t\treturn saturate(v);\n\t}\n\tfloat D_GGX_Anisotropic( const in float alphaT, const in float alphaB, const in float dotNH, const in float dotTH, const in float dotBH ) {\n\t\tfloat a2 = alphaT * alphaB;\n\t\thighp vec3 v = vec3( alphaB * dotTH, alphaT * dotBH, a2 * dotNH );\n\t\thighp float v2 = dot( v, v );\n\t\tfloat w2 = a2 / v2;\n\t\treturn RECIPROCAL_PI * a2 * pow2 ( w2 );\n\t}\n#endif\n#ifdef USE_CLEARCOAT\n\tvec3 BRDF_GGX_Clearcoat( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in PhysicalMaterial material) {\n\t\tvec3 f0 = material.clearcoatF0;\n\t\tfloat f90 = material.clearcoatF90;\n\t\tfloat roughness = material.clearcoatRoughness;\n\t\tfloat alpha = pow2( roughness );\n\t\tvec3 halfDir = normalize( lightDir + viewDir );\n\t\tfloat dotNL = saturate( dot( normal, lightDir ) );\n\t\tfloat dotNV = saturate( dot( normal, viewDir ) );\n\t\tfloat dotNH = saturate( dot( normal, halfDir ) );\n\t\tfloat dotVH = saturate( dot( viewDir, halfDir ) );\n\t\tvec3 F = F_Schlick( f0, f90, dotVH );\n\t\tfloat V = V_GGX_SmithCorrelated( alpha, dotNL, dotNV );\n\t\tfloat D = D_GGX( alpha, dotNH );\n\t\treturn F * ( V * D );\n\t}\n#endif\nvec3 BRDF_GGX( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in PhysicalMaterial material ) {\n\tvec3 f0 = material.specularColor;\n\tfloat f90 = material.specularF90;\n\tfloat roughness = material.roughness;\n\tfloat alpha = pow2( roughness );\n\tvec3 halfDir = normalize( lightDir + viewDir );\n\tfloat dotNL = saturate( dot( normal, lightDir ) );\n\tfloat dotNV = saturate( dot( normal, viewDir ) );\n\tfloat dotNH = saturate( dot( normal, halfDir ) );\n\tfloat dotVH = saturate( dot( viewDir, halfDir ) );\n\tvec3 F = F_Schlick( f0, f90, dotVH );\n\t#ifdef USE_IRIDESCENCE\n\t\tF = mix( F, material.iridescenceFresnel, material.iridescence );\n\t#endif\n\t#ifdef USE_ANISOTROPY\n\t\tfloat dotTL = dot( material.anisotropyT, lightDir );\n\t\tfloat dotTV = dot( material.anisotropyT, viewDir );\n\t\tfloat dotTH = dot( material.anisotropyT, halfDir );\n\t\tfloat dotBL = dot( material.anisotropyB, lightDir );\n\t\tfloat dotBV = dot( material.anisotropyB, viewDir );\n\t\tfloat dotBH = dot( material.anisotropyB, halfDir );\n\t\tfloat V = V_GGX_SmithCorrelated_Anisotropic( material.alphaT, alpha, dotTV, dotBV, dotTL, dotBL, dotNV, dotNL );\n\t\tfloat D = D_GGX_Anisotropic( material.alphaT, alpha, dotNH, dotTH, dotBH );\n\t#else\n\t\tfloat V = V_GGX_SmithCorrelated( alpha, dotNL, dotNV );\n\t\tfloat D = D_GGX( alpha, dotNH );\n\t#endif\n\treturn F * ( V * D );\n}\nvec2 LTC_Uv( const in vec3 N, const in vec3 V, const in float roughness ) {\n\tconst float LUT_SIZE = 64.0;\n\tconst float LUT_SCALE = ( LUT_SIZE - 1.0 ) / LUT_SIZE;\n\tconst float LUT_BIAS = 0.5 / LUT_SIZE;\n\tfloat dotNV = saturate( dot( N, V ) );\n\tvec2 uv = vec2( roughness, sqrt( 1.0 - dotNV ) );\n\tuv = uv * LUT_SCALE + LUT_BIAS;\n\treturn uv;\n}\nfloat LTC_ClippedSphereFormFactor( const in vec3 f ) {\n\tfloat l = length( f );\n\treturn max( ( l * l + f.z ) / ( l + 1.0 ), 0.0 );\n}\nvec3 LTC_EdgeVectorFormFactor( const in vec3 v1, const in vec3 v2 ) {\n\tfloat x = dot( v1, v2 );\n\tfloat y = abs( x );\n\tfloat a = 0.8543985 + ( 0.4965155 + 0.0145206 * y ) * y;\n\tfloat b = 3.4175940 + ( 4.1616724 + y ) * y;\n\tfloat v = a / b;\n\tfloat theta_sintheta = ( x > 0.0 ) ? v : 0.5 * inversesqrt( max( 1.0 - x * x, 1e-7 ) ) - v;\n\treturn cross( v1, v2 ) * theta_sintheta;\n}\nvec3 LTC_Evaluate( const in vec3 N, const in vec3 V, const in vec3 P, const in mat3 mInv, const in vec3 rectCoords[ 4 ] ) {\n\tvec3 v1 = rectCoords[ 1 ] - rectCoords[ 0 ];\n\tvec3 v2 = rectCoords[ 3 ] - rectCoords[ 0 ];\n\tvec3 lightNormal = cross( v1, v2 );\n\tif( dot( lightNormal, P - rectCoords[ 0 ] ) < 0.0 ) return vec3( 0.0 );\n\tvec3 T1, T2;\n\tT1 = normalize( V - N * dot( V, N ) );\n\tT2 = - cross( N, T1 );\n\tmat3 mat = mInv * transposeMat3( mat3( T1, T2, N ) );\n\tvec3 coords[ 4 ];\n\tcoords[ 0 ] = mat * ( rectCoords[ 0 ] - P );\n\tcoords[ 1 ] = mat * ( rectCoords[ 1 ] - P );\n\tcoords[ 2 ] = mat * ( rectCoords[ 2 ] - P );\n\tcoords[ 3 ] = mat * ( rectCoords[ 3 ] - P );\n\tcoords[ 0 ] = normalize( coords[ 0 ] );\n\tcoords[ 1 ] = normalize( coords[ 1 ] );\n\tcoords[ 2 ] = normalize( coords[ 2 ] );\n\tcoords[ 3 ] = normalize( coords[ 3 ] );\n\tvec3 vectorFormFactor = vec3( 0.0 );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 0 ], coords[ 1 ] );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 1 ], coords[ 2 ] );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 2 ], coords[ 3 ] );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 3 ], coords[ 0 ] );\n\tfloat result = LTC_ClippedSphereFormFactor( vectorFormFactor );\n\treturn vec3( result );\n}\n#if defined( USE_SHEEN )\nfloat D_Charlie( float roughness, float dotNH ) {\n\tfloat alpha = pow2( roughness );\n\tfloat invAlpha = 1.0 / alpha;\n\tfloat cos2h = dotNH * dotNH;\n\tfloat sin2h = max( 1.0 - cos2h, 0.0078125 );\n\treturn ( 2.0 + invAlpha ) * pow( sin2h, invAlpha * 0.5 ) / ( 2.0 * PI );\n}\nfloat V_Neubelt( float dotNV, float dotNL ) {\n\treturn saturate( 1.0 / ( 4.0 * ( dotNL + dotNV - dotNL * dotNV ) ) );\n}\nvec3 BRDF_Sheen( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, vec3 sheenColor, const in float sheenRoughness ) {\n\tvec3 halfDir = normalize( lightDir + viewDir );\n\tfloat dotNL = saturate( dot( normal, lightDir ) );\n\tfloat dotNV = saturate( dot( normal, viewDir ) );\n\tfloat dotNH = saturate( dot( normal, halfDir ) );\n\tfloat D = D_Charlie( sheenRoughness, dotNH );\n\tfloat V = V_Neubelt( dotNV, dotNL );\n\treturn sheenColor * ( D * V );\n}\n#endif\nfloat IBLSheenBRDF( const in vec3 normal, const in vec3 viewDir, const in float roughness ) {\n\tfloat dotNV = saturate( dot( normal, viewDir ) );\n\tfloat r2 = roughness * roughness;\n\tfloat a = roughness < 0.25 ? -339.2 * r2 + 161.4 * roughness - 25.9 : -8.48 * r2 + 14.3 * roughness - 9.95;\n\tfloat b = roughness < 0.25 ? 44.0 * r2 - 23.7 * roughness + 3.26 : 1.97 * r2 - 3.27 * roughness + 0.72;\n\tfloat DG = exp( a * dotNV + b ) + ( roughness < 0.25 ? 0.0 : 0.1 * ( roughness - 0.25 ) );\n\treturn saturate( DG * RECIPROCAL_PI );\n}\nvec2 DFGApprox( const in vec3 normal, const in vec3 viewDir, const in float roughness ) {\n\tfloat dotNV = saturate( dot( normal, viewDir ) );\n\tconst vec4 c0 = vec4( - 1, - 0.0275, - 0.572, 0.022 );\n\tconst vec4 c1 = vec4( 1, 0.0425, 1.04, - 0.04 );\n\tvec4 r = roughness * c0 + c1;\n\tfloat a004 = min( r.x * r.x, exp2( - 9.28 * dotNV ) ) * r.x + r.y;\n\tvec2 fab = vec2( - 1.04, 1.04 ) * a004 + r.zw;\n\treturn fab;\n}\nvec3 EnvironmentBRDF( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float roughness ) {\n\tvec2 fab = DFGApprox( normal, viewDir, roughness );\n\treturn specularColor * fab.x + specularF90 * fab.y;\n}\n#ifdef USE_IRIDESCENCE\nvoid computeMultiscatteringIridescence( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float iridescence, const in vec3 iridescenceF0, const in float roughness, inout vec3 singleScatter, inout vec3 multiScatter ) {\n#else\nvoid computeMultiscattering( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float roughness, inout vec3 singleScatter, inout vec3 multiScatter ) {\n#endif\n\tvec2 fab = DFGApprox( normal, viewDir, roughness );\n\t#ifdef USE_IRIDESCENCE\n\t\tvec3 Fr = mix( specularColor, iridescenceF0, iridescence );\n\t#else\n\t\tvec3 Fr = specularColor;\n\t#endif\n\tvec3 FssEss = Fr * fab.x + specularF90 * fab.y;\n\tfloat Ess = fab.x + fab.y;\n\tfloat Ems = 1.0 - Ess;\n\tvec3 Favg = Fr + ( 1.0 - Fr ) * 0.047619;\tvec3 Fms = FssEss * Favg / ( 1.0 - Ems * Favg );\n\tsingleScatter += FssEss;\n\tmultiScatter += Fms * Ems;\n}\n#if NUM_RECT_AREA_LIGHTS > 0\n\tvoid RE_Direct_RectArea_Physical( const in RectAreaLight rectAreaLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n\t\tvec3 normal = geometryNormal;\n\t\tvec3 viewDir = geometryViewDir;\n\t\tvec3 position = geometryPosition;\n\t\tvec3 lightPos = rectAreaLight.position;\n\t\tvec3 halfWidth = rectAreaLight.halfWidth;\n\t\tvec3 halfHeight = rectAreaLight.halfHeight;\n\t\tvec3 lightColor = rectAreaLight.color;\n\t\tfloat roughness = material.roughness;\n\t\tvec3 rectCoords[ 4 ];\n\t\trectCoords[ 0 ] = lightPos + halfWidth - halfHeight;\t\trectCoords[ 1 ] = lightPos - halfWidth - halfHeight;\n\t\trectCoords[ 2 ] = lightPos - halfWidth + halfHeight;\n\t\trectCoords[ 3 ] = lightPos + halfWidth + halfHeight;\n\t\tvec2 uv = LTC_Uv( normal, viewDir, roughness );\n\t\tvec4 t1 = texture2D( ltc_1, uv );\n\t\tvec4 t2 = texture2D( ltc_2, uv );\n\t\tmat3 mInv = mat3(\n\t\t\tvec3( t1.x, 0, t1.y ),\n\t\t\tvec3(    0, 1,    0 ),\n\t\t\tvec3( t1.z, 0, t1.w )\n\t\t);\n\t\tvec3 fresnel = ( material.specularColor * t2.x + ( vec3( 1.0 ) - material.specularColor ) * t2.y );\n\t\treflectedLight.directSpecular += lightColor * fresnel * LTC_Evaluate( normal, viewDir, position, mInv, rectCoords );\n\t\treflectedLight.directDiffuse += lightColor * material.diffuseColor * LTC_Evaluate( normal, viewDir, position, mat3( 1.0 ), rectCoords );\n\t}\n#endif\nvoid RE_Direct_Physical( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n\tfloat dotNL = saturate( dot( geometryNormal, directLight.direction ) );\n\tvec3 irradiance = dotNL * directLight.color;\n\t#ifdef USE_CLEARCOAT\n\t\tfloat dotNLcc = saturate( dot( geometryClearcoatNormal, directLight.direction ) );\n\t\tvec3 ccIrradiance = dotNLcc * directLight.color;\n\t\tclearcoatSpecularDirect += ccIrradiance * BRDF_GGX_Clearcoat( directLight.direction, geometryViewDir, geometryClearcoatNormal, material );\n\t#endif\n\t#ifdef USE_SHEEN\n\t\tsheenSpecularDirect += irradiance * BRDF_Sheen( directLight.direction, geometryViewDir, geometryNormal, material.sheenColor, material.sheenRoughness );\n\t#endif\n\treflectedLight.directSpecular += irradiance * BRDF_GGX( directLight.direction, geometryViewDir, geometryNormal, material );\n\treflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectDiffuse_Physical( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n\treflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectSpecular_Physical( const in vec3 radiance, const in vec3 irradiance, const in vec3 clearcoatRadiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight) {\n\t#ifdef USE_CLEARCOAT\n\t\tclearcoatSpecularIndirect += clearcoatRadiance * EnvironmentBRDF( geometryClearcoatNormal, geometryViewDir, material.clearcoatF0, material.clearcoatF90, material.clearcoatRoughness );\n\t#endif\n\t#ifdef USE_SHEEN\n\t\tsheenSpecularIndirect += irradiance * material.sheenColor * IBLSheenBRDF( geometryNormal, geometryViewDir, material.sheenRoughness );\n\t#endif\n\tvec3 singleScattering = vec3( 0.0 );\n\tvec3 multiScattering = vec3( 0.0 );\n\tvec3 cosineWeightedIrradiance = irradiance * RECIPROCAL_PI;\n\t#ifdef USE_IRIDESCENCE\n\t\tcomputeMultiscatteringIridescence( geometryNormal, geometryViewDir, material.specularColor, material.specularF90, material.iridescence, material.iridescenceFresnel, material.roughness, singleScattering, multiScattering );\n\t#else\n\t\tcomputeMultiscattering( geometryNormal, geometryViewDir, material.specularColor, material.specularF90, material.roughness, singleScattering, multiScattering );\n\t#endif\n\tvec3 totalScattering = singleScattering + multiScattering;\n\tvec3 diffuse = material.diffuseColor * ( 1.0 - max( max( totalScattering.r, totalScattering.g ), totalScattering.b ) );\n\treflectedLight.indirectSpecular += radiance * singleScattering;\n\treflectedLight.indirectSpecular += multiScattering * cosineWeightedIrradiance;\n\treflectedLight.indirectDiffuse += diffuse * cosineWeightedIrradiance;\n}\n#define RE_Direct\t\t\t\tRE_Direct_Physical\n#define RE_Direct_RectArea\t\tRE_Direct_RectArea_Physical\n#define RE_IndirectDiffuse\t\tRE_IndirectDiffuse_Physical\n#define RE_IndirectSpecular\t\tRE_IndirectSpecular_Physical\nfloat computeSpecularOcclusion( const in float dotNV, const in float ambientOcclusion, const in float roughness ) {\n\treturn saturate( pow( dotNV + ambientOcclusion, exp2( - 16.0 * roughness - 1.0 ) ) - 1.0 + ambientOcclusion );\n}";
var $d5b33d7c30034067$var$lights_fragment_begin = "\nvec3 geometryPosition = - vViewPosition;\nvec3 geometryNormal = normal;\nvec3 geometryViewDir = ( isOrthographic ) ? vec3( 0, 0, 1 ) : normalize( vViewPosition );\nvec3 geometryClearcoatNormal = vec3( 0.0 );\n#ifdef USE_CLEARCOAT\n\tgeometryClearcoatNormal = clearcoatNormal;\n#endif\n#ifdef USE_IRIDESCENCE\n\tfloat dotNVi = saturate( dot( normal, geometryViewDir ) );\n\tif ( material.iridescenceThickness == 0.0 ) {\n\t\tmaterial.iridescence = 0.0;\n\t} else {\n\t\tmaterial.iridescence = saturate( material.iridescence );\n\t}\n\tif ( material.iridescence > 0.0 ) {\n\t\tmaterial.iridescenceFresnel = evalIridescence( 1.0, material.iridescenceIOR, dotNVi, material.iridescenceThickness, material.specularColor );\n\t\tmaterial.iridescenceF0 = Schlick_to_F0( material.iridescenceFresnel, 1.0, dotNVi );\n\t}\n#endif\nIncidentLight directLight;\n#if ( NUM_POINT_LIGHTS > 0 ) && defined( RE_Direct )\n\tPointLight pointLight;\n\t#if defined( USE_SHADOWMAP ) && NUM_POINT_LIGHT_SHADOWS > 0\n\tPointLightShadow pointLightShadow;\n\t#endif\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_POINT_LIGHTS; i ++ ) {\n\t\tpointLight = pointLights[ i ];\n\t\tgetPointLightInfo( pointLight, geometryPosition, directLight );\n\t\t#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_POINT_LIGHT_SHADOWS )\n\t\tpointLightShadow = pointLightShadows[ i ];\n\t\tdirectLight.color *= ( directLight.visible && receiveShadow ) ? getPointShadow( pointShadowMap[ i ], pointLightShadow.shadowMapSize, pointLightShadow.shadowIntensity, pointLightShadow.shadowBias, pointLightShadow.shadowRadius, vPointShadowCoord[ i ], pointLightShadow.shadowCameraNear, pointLightShadow.shadowCameraFar ) : 1.0;\n\t\t#endif\n\t\tRE_Direct( directLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if ( NUM_SPOT_LIGHTS > 0 ) && defined( RE_Direct )\n\tSpotLight spotLight;\n\tvec4 spotColor;\n\tvec3 spotLightCoord;\n\tbool inSpotLightMap;\n\t#if defined( USE_SHADOWMAP ) && NUM_SPOT_LIGHT_SHADOWS > 0\n\tSpotLightShadow spotLightShadow;\n\t#endif\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_SPOT_LIGHTS; i ++ ) {\n\t\tspotLight = spotLights[ i ];\n\t\tgetSpotLightInfo( spotLight, geometryPosition, directLight );\n\t\t#if ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS )\n\t\t#define SPOT_LIGHT_MAP_INDEX UNROLLED_LOOP_INDEX\n\t\t#elif ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )\n\t\t#define SPOT_LIGHT_MAP_INDEX NUM_SPOT_LIGHT_MAPS\n\t\t#else\n\t\t#define SPOT_LIGHT_MAP_INDEX ( UNROLLED_LOOP_INDEX - NUM_SPOT_LIGHT_SHADOWS + NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS )\n\t\t#endif\n\t\t#if ( SPOT_LIGHT_MAP_INDEX < NUM_SPOT_LIGHT_MAPS )\n\t\t\tspotLightCoord = vSpotLightCoord[ i ].xyz / vSpotLightCoord[ i ].w;\n\t\t\tinSpotLightMap = all( lessThan( abs( spotLightCoord * 2. - 1. ), vec3( 1.0 ) ) );\n\t\t\tspotColor = texture2D( spotLightMap[ SPOT_LIGHT_MAP_INDEX ], spotLightCoord.xy );\n\t\t\tdirectLight.color = inSpotLightMap ? directLight.color * spotColor.rgb : directLight.color;\n\t\t#endif\n\t\t#undef SPOT_LIGHT_MAP_INDEX\n\t\t#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )\n\t\tspotLightShadow = spotLightShadows[ i ];\n\t\tdirectLight.color *= ( directLight.visible && receiveShadow ) ? getShadow( spotShadowMap[ i ], spotLightShadow.shadowMapSize, spotLightShadow.shadowIntensity, spotLightShadow.shadowBias, spotLightShadow.shadowRadius, vSpotLightCoord[ i ] ) : 1.0;\n\t\t#endif\n\t\tRE_Direct( directLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if ( NUM_DIR_LIGHTS > 0 ) && defined( RE_Direct )\n\tDirectionalLight directionalLight;\n\t#if defined( USE_SHADOWMAP ) && NUM_DIR_LIGHT_SHADOWS > 0\n\tDirectionalLightShadow directionalLightShadow;\n\t#endif\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_DIR_LIGHTS; i ++ ) {\n\t\tdirectionalLight = directionalLights[ i ];\n\t\tgetDirectionalLightInfo( directionalLight, directLight );\n\t\t#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_DIR_LIGHT_SHADOWS )\n\t\tdirectionalLightShadow = directionalLightShadows[ i ];\n\t\tdirectLight.color *= ( directLight.visible && receiveShadow ) ? getShadow( directionalShadowMap[ i ], directionalLightShadow.shadowMapSize, directionalLightShadow.shadowIntensity, directionalLightShadow.shadowBias, directionalLightShadow.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;\n\t\t#endif\n\t\tRE_Direct( directLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if ( NUM_RECT_AREA_LIGHTS > 0 ) && defined( RE_Direct_RectArea )\n\tRectAreaLight rectAreaLight;\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_RECT_AREA_LIGHTS; i ++ ) {\n\t\trectAreaLight = rectAreaLights[ i ];\n\t\tRE_Direct_RectArea( rectAreaLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if defined( RE_IndirectDiffuse )\n\tvec3 iblIrradiance = vec3( 0.0 );\n\tvec3 irradiance = getAmbientLightIrradiance( ambientLightColor );\n\t#if defined( USE_LIGHT_PROBES )\n\t\tirradiance += getLightProbeIrradiance( lightProbe, geometryNormal );\n\t#endif\n\t#if ( NUM_HEMI_LIGHTS > 0 )\n\t\t#pragma unroll_loop_start\n\t\tfor ( int i = 0; i < NUM_HEMI_LIGHTS; i ++ ) {\n\t\t\tirradiance += getHemisphereLightIrradiance( hemisphereLights[ i ], geometryNormal );\n\t\t}\n\t\t#pragma unroll_loop_end\n\t#endif\n#endif\n#if defined( RE_IndirectSpecular )\n\tvec3 radiance = vec3( 0.0 );\n\tvec3 clearcoatRadiance = vec3( 0.0 );\n#endif";
var $d5b33d7c30034067$var$lights_fragment_maps = "#if defined( RE_IndirectDiffuse )\n\t#ifdef USE_LIGHTMAP\n\t\tvec4 lightMapTexel = texture2D( lightMap, vLightMapUv );\n\t\tvec3 lightMapIrradiance = lightMapTexel.rgb * lightMapIntensity;\n\t\tirradiance += lightMapIrradiance;\n\t#endif\n\t#if defined( USE_ENVMAP ) && defined( STANDARD ) && defined( ENVMAP_TYPE_CUBE_UV )\n\t\tiblIrradiance += getIBLIrradiance( geometryNormal );\n\t#endif\n#endif\n#if defined( USE_ENVMAP ) && defined( RE_IndirectSpecular )\n\t#ifdef USE_ANISOTROPY\n\t\tradiance += getIBLAnisotropyRadiance( geometryViewDir, geometryNormal, material.roughness, material.anisotropyB, material.anisotropy );\n\t#else\n\t\tradiance += getIBLRadiance( geometryViewDir, geometryNormal, material.roughness );\n\t#endif\n\t#ifdef USE_CLEARCOAT\n\t\tclearcoatRadiance += getIBLRadiance( geometryViewDir, geometryClearcoatNormal, material.clearcoatRoughness );\n\t#endif\n#endif";
var $d5b33d7c30034067$var$lights_fragment_end = "#if defined( RE_IndirectDiffuse )\n\tRE_IndirectDiffuse( irradiance, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n#endif\n#if defined( RE_IndirectSpecular )\n\tRE_IndirectSpecular( radiance, iblIrradiance, clearcoatRadiance, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n#endif";
var $d5b33d7c30034067$var$logdepthbuf_fragment = "#if defined( USE_LOGDEPTHBUF )\n\tgl_FragDepth = vIsPerspective == 0.0 ? gl_FragCoord.z : log2( vFragDepth ) * logDepthBufFC * 0.5;\n#endif";
var $d5b33d7c30034067$var$logdepthbuf_pars_fragment = "#if defined( USE_LOGDEPTHBUF )\n\tuniform float logDepthBufFC;\n\tvarying float vFragDepth;\n\tvarying float vIsPerspective;\n#endif";
var $d5b33d7c30034067$var$logdepthbuf_pars_vertex = "#ifdef USE_LOGDEPTHBUF\n\tvarying float vFragDepth;\n\tvarying float vIsPerspective;\n#endif";
var $d5b33d7c30034067$var$logdepthbuf_vertex = "#ifdef USE_LOGDEPTHBUF\n\tvFragDepth = 1.0 + gl_Position.w;\n\tvIsPerspective = float( isPerspectiveMatrix( projectionMatrix ) );\n#endif";
var $d5b33d7c30034067$var$map_fragment = "#ifdef USE_MAP\n\tvec4 sampledDiffuseColor = texture2D( map, vMapUv );\n\t#ifdef DECODE_VIDEO_TEXTURE\n\t\tsampledDiffuseColor = sRGBTransferEOTF( sampledDiffuseColor );\n\t#endif\n\tdiffuseColor *= sampledDiffuseColor;\n#endif";
var $d5b33d7c30034067$var$map_pars_fragment = "#ifdef USE_MAP\n\tuniform sampler2D map;\n#endif";
var $d5b33d7c30034067$var$map_particle_fragment = "#if defined( USE_MAP ) || defined( USE_ALPHAMAP )\n\t#if defined( USE_POINTS_UV )\n\t\tvec2 uv = vUv;\n\t#else\n\t\tvec2 uv = ( uvTransform * vec3( gl_PointCoord.x, 1.0 - gl_PointCoord.y, 1 ) ).xy;\n\t#endif\n#endif\n#ifdef USE_MAP\n\tdiffuseColor *= texture2D( map, uv );\n#endif\n#ifdef USE_ALPHAMAP\n\tdiffuseColor.a *= texture2D( alphaMap, uv ).g;\n#endif";
var $d5b33d7c30034067$var$map_particle_pars_fragment = "#if defined( USE_POINTS_UV )\n\tvarying vec2 vUv;\n#else\n\t#if defined( USE_MAP ) || defined( USE_ALPHAMAP )\n\t\tuniform mat3 uvTransform;\n\t#endif\n#endif\n#ifdef USE_MAP\n\tuniform sampler2D map;\n#endif\n#ifdef USE_ALPHAMAP\n\tuniform sampler2D alphaMap;\n#endif";
var $d5b33d7c30034067$var$metalnessmap_fragment = "float metalnessFactor = metalness;\n#ifdef USE_METALNESSMAP\n\tvec4 texelMetalness = texture2D( metalnessMap, vMetalnessMapUv );\n\tmetalnessFactor *= texelMetalness.b;\n#endif";
var $d5b33d7c30034067$var$metalnessmap_pars_fragment = "#ifdef USE_METALNESSMAP\n\tuniform sampler2D metalnessMap;\n#endif";
var $d5b33d7c30034067$var$morphinstance_vertex = "#ifdef USE_INSTANCING_MORPH\n\tfloat morphTargetInfluences[ MORPHTARGETS_COUNT ];\n\tfloat morphTargetBaseInfluence = texelFetch( morphTexture, ivec2( 0, gl_InstanceID ), 0 ).r;\n\tfor ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n\t\tmorphTargetInfluences[i] =  texelFetch( morphTexture, ivec2( i + 1, gl_InstanceID ), 0 ).r;\n\t}\n#endif";
var $d5b33d7c30034067$var$morphcolor_vertex = "#if defined( USE_MORPHCOLORS )\n\tvColor *= morphTargetBaseInfluence;\n\tfor ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n\t\t#if defined( USE_COLOR_ALPHA )\n\t\t\tif ( morphTargetInfluences[ i ] != 0.0 ) vColor += getMorph( gl_VertexID, i, 2 ) * morphTargetInfluences[ i ];\n\t\t#elif defined( USE_COLOR )\n\t\t\tif ( morphTargetInfluences[ i ] != 0.0 ) vColor += getMorph( gl_VertexID, i, 2 ).rgb * morphTargetInfluences[ i ];\n\t\t#endif\n\t}\n#endif";
var $d5b33d7c30034067$var$morphnormal_vertex = "#ifdef USE_MORPHNORMALS\n\tobjectNormal *= morphTargetBaseInfluence;\n\tfor ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n\t\tif ( morphTargetInfluences[ i ] != 0.0 ) objectNormal += getMorph( gl_VertexID, i, 1 ).xyz * morphTargetInfluences[ i ];\n\t}\n#endif";
var $d5b33d7c30034067$var$morphtarget_pars_vertex = "#ifdef USE_MORPHTARGETS\n\t#ifndef USE_INSTANCING_MORPH\n\t\tuniform float morphTargetBaseInfluence;\n\t\tuniform float morphTargetInfluences[ MORPHTARGETS_COUNT ];\n\t#endif\n\tuniform sampler2DArray morphTargetsTexture;\n\tuniform ivec2 morphTargetsTextureSize;\n\tvec4 getMorph( const in int vertexIndex, const in int morphTargetIndex, const in int offset ) {\n\t\tint texelIndex = vertexIndex * MORPHTARGETS_TEXTURE_STRIDE + offset;\n\t\tint y = texelIndex / morphTargetsTextureSize.x;\n\t\tint x = texelIndex - y * morphTargetsTextureSize.x;\n\t\tivec3 morphUV = ivec3( x, y, morphTargetIndex );\n\t\treturn texelFetch( morphTargetsTexture, morphUV, 0 );\n\t}\n#endif";
var $d5b33d7c30034067$var$morphtarget_vertex = "#ifdef USE_MORPHTARGETS\n\ttransformed *= morphTargetBaseInfluence;\n\tfor ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n\t\tif ( morphTargetInfluences[ i ] != 0.0 ) transformed += getMorph( gl_VertexID, i, 0 ).xyz * morphTargetInfluences[ i ];\n\t}\n#endif";
var $d5b33d7c30034067$var$normal_fragment_begin = "float faceDirection = gl_FrontFacing ? 1.0 : - 1.0;\n#ifdef FLAT_SHADED\n\tvec3 fdx = dFdx( vViewPosition );\n\tvec3 fdy = dFdy( vViewPosition );\n\tvec3 normal = normalize( cross( fdx, fdy ) );\n#else\n\tvec3 normal = normalize( vNormal );\n\t#ifdef DOUBLE_SIDED\n\t\tnormal *= faceDirection;\n\t#endif\n#endif\n#if defined( USE_NORMALMAP_TANGENTSPACE ) || defined( USE_CLEARCOAT_NORMALMAP ) || defined( USE_ANISOTROPY )\n\t#ifdef USE_TANGENT\n\t\tmat3 tbn = mat3( normalize( vTangent ), normalize( vBitangent ), normal );\n\t#else\n\t\tmat3 tbn = getTangentFrame( - vViewPosition, normal,\n\t\t#if defined( USE_NORMALMAP )\n\t\t\tvNormalMapUv\n\t\t#elif defined( USE_CLEARCOAT_NORMALMAP )\n\t\t\tvClearcoatNormalMapUv\n\t\t#else\n\t\t\tvUv\n\t\t#endif\n\t\t);\n\t#endif\n\t#if defined( DOUBLE_SIDED ) && ! defined( FLAT_SHADED )\n\t\ttbn[0] *= faceDirection;\n\t\ttbn[1] *= faceDirection;\n\t#endif\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n\t#ifdef USE_TANGENT\n\t\tmat3 tbn2 = mat3( normalize( vTangent ), normalize( vBitangent ), normal );\n\t#else\n\t\tmat3 tbn2 = getTangentFrame( - vViewPosition, normal, vClearcoatNormalMapUv );\n\t#endif\n\t#if defined( DOUBLE_SIDED ) && ! defined( FLAT_SHADED )\n\t\ttbn2[0] *= faceDirection;\n\t\ttbn2[1] *= faceDirection;\n\t#endif\n#endif\nvec3 nonPerturbedNormal = normal;";
var $d5b33d7c30034067$var$normal_fragment_maps = "#ifdef USE_NORMALMAP_OBJECTSPACE\n\tnormal = texture2D( normalMap, vNormalMapUv ).xyz * 2.0 - 1.0;\n\t#ifdef FLIP_SIDED\n\t\tnormal = - normal;\n\t#endif\n\t#ifdef DOUBLE_SIDED\n\t\tnormal = normal * faceDirection;\n\t#endif\n\tnormal = normalize( normalMatrix * normal );\n#elif defined( USE_NORMALMAP_TANGENTSPACE )\n\tvec3 mapN = texture2D( normalMap, vNormalMapUv ).xyz * 2.0 - 1.0;\n\tmapN.xy *= normalScale;\n\tnormal = normalize( tbn * mapN );\n#elif defined( USE_BUMPMAP )\n\tnormal = perturbNormalArb( - vViewPosition, normal, dHdxy_fwd(), faceDirection );\n#endif";
var $d5b33d7c30034067$var$normal_pars_fragment = "#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n\t#ifdef USE_TANGENT\n\t\tvarying vec3 vTangent;\n\t\tvarying vec3 vBitangent;\n\t#endif\n#endif";
var $d5b33d7c30034067$var$normal_pars_vertex = "#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n\t#ifdef USE_TANGENT\n\t\tvarying vec3 vTangent;\n\t\tvarying vec3 vBitangent;\n\t#endif\n#endif";
var $d5b33d7c30034067$var$normal_vertex = "#ifndef FLAT_SHADED\n\tvNormal = normalize( transformedNormal );\n\t#ifdef USE_TANGENT\n\t\tvTangent = normalize( transformedTangent );\n\t\tvBitangent = normalize( cross( vNormal, vTangent ) * tangent.w );\n\t#endif\n#endif";
var $d5b33d7c30034067$var$normalmap_pars_fragment = "#ifdef USE_NORMALMAP\n\tuniform sampler2D normalMap;\n\tuniform vec2 normalScale;\n#endif\n#ifdef USE_NORMALMAP_OBJECTSPACE\n\tuniform mat3 normalMatrix;\n#endif\n#if ! defined ( USE_TANGENT ) && ( defined ( USE_NORMALMAP_TANGENTSPACE ) || defined ( USE_CLEARCOAT_NORMALMAP ) || defined( USE_ANISOTROPY ) )\n\tmat3 getTangentFrame( vec3 eye_pos, vec3 surf_norm, vec2 uv ) {\n\t\tvec3 q0 = dFdx( eye_pos.xyz );\n\t\tvec3 q1 = dFdy( eye_pos.xyz );\n\t\tvec2 st0 = dFdx( uv.st );\n\t\tvec2 st1 = dFdy( uv.st );\n\t\tvec3 N = surf_norm;\n\t\tvec3 q1perp = cross( q1, N );\n\t\tvec3 q0perp = cross( N, q0 );\n\t\tvec3 T = q1perp * st0.x + q0perp * st1.x;\n\t\tvec3 B = q1perp * st0.y + q0perp * st1.y;\n\t\tfloat det = max( dot( T, T ), dot( B, B ) );\n\t\tfloat scale = ( det == 0.0 ) ? 0.0 : inversesqrt( det );\n\t\treturn mat3( T * scale, B * scale, N );\n\t}\n#endif";
var $d5b33d7c30034067$var$clearcoat_normal_fragment_begin = "#ifdef USE_CLEARCOAT\n\tvec3 clearcoatNormal = nonPerturbedNormal;\n#endif";
var $d5b33d7c30034067$var$clearcoat_normal_fragment_maps = "#ifdef USE_CLEARCOAT_NORMALMAP\n\tvec3 clearcoatMapN = texture2D( clearcoatNormalMap, vClearcoatNormalMapUv ).xyz * 2.0 - 1.0;\n\tclearcoatMapN.xy *= clearcoatNormalScale;\n\tclearcoatNormal = normalize( tbn2 * clearcoatMapN );\n#endif";
var $d5b33d7c30034067$var$clearcoat_pars_fragment = "#ifdef USE_CLEARCOATMAP\n\tuniform sampler2D clearcoatMap;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n\tuniform sampler2D clearcoatNormalMap;\n\tuniform vec2 clearcoatNormalScale;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n\tuniform sampler2D clearcoatRoughnessMap;\n#endif";
var $d5b33d7c30034067$var$iridescence_pars_fragment = "#ifdef USE_IRIDESCENCEMAP\n\tuniform sampler2D iridescenceMap;\n#endif\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\n\tuniform sampler2D iridescenceThicknessMap;\n#endif";
var $d5b33d7c30034067$var$opaque_fragment = "#ifdef OPAQUE\ndiffuseColor.a = 1.0;\n#endif\n#ifdef USE_TRANSMISSION\ndiffuseColor.a *= material.transmissionAlpha;\n#endif\ngl_FragColor = vec4( outgoingLight, diffuseColor.a );";
var $d5b33d7c30034067$var$packing = "vec3 packNormalToRGB( const in vec3 normal ) {\n\treturn normalize( normal ) * 0.5 + 0.5;\n}\nvec3 unpackRGBToNormal( const in vec3 rgb ) {\n\treturn 2.0 * rgb.xyz - 1.0;\n}\nconst float PackUpscale = 256. / 255.;const float UnpackDownscale = 255. / 256.;const float ShiftRight8 = 1. / 256.;\nconst float Inv255 = 1. / 255.;\nconst vec4 PackFactors = vec4( 1.0, 256.0, 256.0 * 256.0, 256.0 * 256.0 * 256.0 );\nconst vec2 UnpackFactors2 = vec2( UnpackDownscale, 1.0 / PackFactors.g );\nconst vec3 UnpackFactors3 = vec3( UnpackDownscale / PackFactors.rg, 1.0 / PackFactors.b );\nconst vec4 UnpackFactors4 = vec4( UnpackDownscale / PackFactors.rgb, 1.0 / PackFactors.a );\nvec4 packDepthToRGBA( const in float v ) {\n\tif( v <= 0.0 )\n\t\treturn vec4( 0., 0., 0., 0. );\n\tif( v >= 1.0 )\n\t\treturn vec4( 1., 1., 1., 1. );\n\tfloat vuf;\n\tfloat af = modf( v * PackFactors.a, vuf );\n\tfloat bf = modf( vuf * ShiftRight8, vuf );\n\tfloat gf = modf( vuf * ShiftRight8, vuf );\n\treturn vec4( vuf * Inv255, gf * PackUpscale, bf * PackUpscale, af );\n}\nvec3 packDepthToRGB( const in float v ) {\n\tif( v <= 0.0 )\n\t\treturn vec3( 0., 0., 0. );\n\tif( v >= 1.0 )\n\t\treturn vec3( 1., 1., 1. );\n\tfloat vuf;\n\tfloat bf = modf( v * PackFactors.b, vuf );\n\tfloat gf = modf( vuf * ShiftRight8, vuf );\n\treturn vec3( vuf * Inv255, gf * PackUpscale, bf );\n}\nvec2 packDepthToRG( const in float v ) {\n\tif( v <= 0.0 )\n\t\treturn vec2( 0., 0. );\n\tif( v >= 1.0 )\n\t\treturn vec2( 1., 1. );\n\tfloat vuf;\n\tfloat gf = modf( v * 256., vuf );\n\treturn vec2( vuf * Inv255, gf );\n}\nfloat unpackRGBAToDepth( const in vec4 v ) {\n\treturn dot( v, UnpackFactors4 );\n}\nfloat unpackRGBToDepth( const in vec3 v ) {\n\treturn dot( v, UnpackFactors3 );\n}\nfloat unpackRGToDepth( const in vec2 v ) {\n\treturn v.r * UnpackFactors2.r + v.g * UnpackFactors2.g;\n}\nvec4 pack2HalfToRGBA( const in vec2 v ) {\n\tvec4 r = vec4( v.x, fract( v.x * 255.0 ), v.y, fract( v.y * 255.0 ) );\n\treturn vec4( r.x - r.y / 255.0, r.y, r.z - r.w / 255.0, r.w );\n}\nvec2 unpackRGBATo2Half( const in vec4 v ) {\n\treturn vec2( v.x + ( v.y / 255.0 ), v.z + ( v.w / 255.0 ) );\n}\nfloat viewZToOrthographicDepth( const in float viewZ, const in float near, const in float far ) {\n\treturn ( viewZ + near ) / ( near - far );\n}\nfloat orthographicDepthToViewZ( const in float depth, const in float near, const in float far ) {\n\treturn depth * ( near - far ) - near;\n}\nfloat viewZToPerspectiveDepth( const in float viewZ, const in float near, const in float far ) {\n\treturn ( ( near + viewZ ) * far ) / ( ( far - near ) * viewZ );\n}\nfloat perspectiveDepthToViewZ( const in float depth, const in float near, const in float far ) {\n\treturn ( near * far ) / ( ( far - near ) * depth - far );\n}";
var $d5b33d7c30034067$var$premultiplied_alpha_fragment = "#ifdef PREMULTIPLIED_ALPHA\n\tgl_FragColor.rgb *= gl_FragColor.a;\n#endif";
var $d5b33d7c30034067$var$project_vertex = "vec4 mvPosition = vec4( transformed, 1.0 );\n#ifdef USE_BATCHING\n\tmvPosition = batchingMatrix * mvPosition;\n#endif\n#ifdef USE_INSTANCING\n\tmvPosition = instanceMatrix * mvPosition;\n#endif\nmvPosition = modelViewMatrix * mvPosition;\ngl_Position = projectionMatrix * mvPosition;";
var $d5b33d7c30034067$var$dithering_fragment = "#ifdef DITHERING\n\tgl_FragColor.rgb = dithering( gl_FragColor.rgb );\n#endif";
var $d5b33d7c30034067$var$dithering_pars_fragment = "#ifdef DITHERING\n\tvec3 dithering( vec3 color ) {\n\t\tfloat grid_position = rand( gl_FragCoord.xy );\n\t\tvec3 dither_shift_RGB = vec3( 0.25 / 255.0, -0.25 / 255.0, 0.25 / 255.0 );\n\t\tdither_shift_RGB = mix( 2.0 * dither_shift_RGB, -2.0 * dither_shift_RGB, grid_position );\n\t\treturn color + dither_shift_RGB;\n\t}\n#endif";
var $d5b33d7c30034067$var$roughnessmap_fragment = "float roughnessFactor = roughness;\n#ifdef USE_ROUGHNESSMAP\n\tvec4 texelRoughness = texture2D( roughnessMap, vRoughnessMapUv );\n\troughnessFactor *= texelRoughness.g;\n#endif";
var $d5b33d7c30034067$var$roughnessmap_pars_fragment = "#ifdef USE_ROUGHNESSMAP\n\tuniform sampler2D roughnessMap;\n#endif";
var $d5b33d7c30034067$var$shadowmap_pars_fragment = "#if NUM_SPOT_LIGHT_COORDS > 0\n\tvarying vec4 vSpotLightCoord[ NUM_SPOT_LIGHT_COORDS ];\n#endif\n#if NUM_SPOT_LIGHT_MAPS > 0\n\tuniform sampler2D spotLightMap[ NUM_SPOT_LIGHT_MAPS ];\n#endif\n#ifdef USE_SHADOWMAP\n\t#if NUM_DIR_LIGHT_SHADOWS > 0\n\t\tuniform sampler2D directionalShadowMap[ NUM_DIR_LIGHT_SHADOWS ];\n\t\tvarying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHT_SHADOWS ];\n\t\tstruct DirectionalLightShadow {\n\t\t\tfloat shadowIntensity;\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t};\n\t\tuniform DirectionalLightShadow directionalLightShadows[ NUM_DIR_LIGHT_SHADOWS ];\n\t#endif\n\t#if NUM_SPOT_LIGHT_SHADOWS > 0\n\t\tuniform sampler2D spotShadowMap[ NUM_SPOT_LIGHT_SHADOWS ];\n\t\tstruct SpotLightShadow {\n\t\t\tfloat shadowIntensity;\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t};\n\t\tuniform SpotLightShadow spotLightShadows[ NUM_SPOT_LIGHT_SHADOWS ];\n\t#endif\n\t#if NUM_POINT_LIGHT_SHADOWS > 0\n\t\tuniform sampler2D pointShadowMap[ NUM_POINT_LIGHT_SHADOWS ];\n\t\tvarying vec4 vPointShadowCoord[ NUM_POINT_LIGHT_SHADOWS ];\n\t\tstruct PointLightShadow {\n\t\t\tfloat shadowIntensity;\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t\tfloat shadowCameraNear;\n\t\t\tfloat shadowCameraFar;\n\t\t};\n\t\tuniform PointLightShadow pointLightShadows[ NUM_POINT_LIGHT_SHADOWS ];\n\t#endif\n\tfloat texture2DCompare( sampler2D depths, vec2 uv, float compare ) {\n\t\treturn step( compare, unpackRGBAToDepth( texture2D( depths, uv ) ) );\n\t}\n\tvec2 texture2DDistribution( sampler2D shadow, vec2 uv ) {\n\t\treturn unpackRGBATo2Half( texture2D( shadow, uv ) );\n\t}\n\tfloat VSMShadow (sampler2D shadow, vec2 uv, float compare ){\n\t\tfloat occlusion = 1.0;\n\t\tvec2 distribution = texture2DDistribution( shadow, uv );\n\t\tfloat hard_shadow = step( compare , distribution.x );\n\t\tif (hard_shadow != 1.0 ) {\n\t\t\tfloat distance = compare - distribution.x ;\n\t\t\tfloat variance = max( 0.00000, distribution.y * distribution.y );\n\t\t\tfloat softness_probability = variance / (variance + distance * distance );\t\t\tsoftness_probability = clamp( ( softness_probability - 0.3 ) / ( 0.95 - 0.3 ), 0.0, 1.0 );\t\t\tocclusion = clamp( max( hard_shadow, softness_probability ), 0.0, 1.0 );\n\t\t}\n\t\treturn occlusion;\n\t}\n\tfloat getShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowIntensity, float shadowBias, float shadowRadius, vec4 shadowCoord ) {\n\t\tfloat shadow = 1.0;\n\t\tshadowCoord.xyz /= shadowCoord.w;\n\t\tshadowCoord.z += shadowBias;\n\t\tbool inFrustum = shadowCoord.x >= 0.0 && shadowCoord.x <= 1.0 && shadowCoord.y >= 0.0 && shadowCoord.y <= 1.0;\n\t\tbool frustumTest = inFrustum && shadowCoord.z <= 1.0;\n\t\tif ( frustumTest ) {\n\t\t#if defined( SHADOWMAP_TYPE_PCF )\n\t\t\tvec2 texelSize = vec2( 1.0 ) / shadowMapSize;\n\t\t\tfloat dx0 = - texelSize.x * shadowRadius;\n\t\t\tfloat dy0 = - texelSize.y * shadowRadius;\n\t\t\tfloat dx1 = + texelSize.x * shadowRadius;\n\t\t\tfloat dy1 = + texelSize.y * shadowRadius;\n\t\t\tfloat dx2 = dx0 / 2.0;\n\t\t\tfloat dy2 = dy0 / 2.0;\n\t\t\tfloat dx3 = dx1 / 2.0;\n\t\t\tfloat dy3 = dy1 / 2.0;\n\t\t\tshadow = (\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, dy0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, dy0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, dy2 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy2 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, dy2 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy, shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, dy3 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy3 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, dy3 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, dy1 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy1 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, dy1 ), shadowCoord.z )\n\t\t\t) * ( 1.0 / 17.0 );\n\t\t#elif defined( SHADOWMAP_TYPE_PCF_SOFT )\n\t\t\tvec2 texelSize = vec2( 1.0 ) / shadowMapSize;\n\t\t\tfloat dx = texelSize.x;\n\t\t\tfloat dy = texelSize.y;\n\t\t\tvec2 uv = shadowCoord.xy;\n\t\t\tvec2 f = fract( uv * shadowMapSize + 0.5 );\n\t\t\tuv -= f * texelSize;\n\t\t\tshadow = (\n\t\t\t\ttexture2DCompare( shadowMap, uv, shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, uv + vec2( dx, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, uv + vec2( 0.0, dy ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, uv + texelSize, shadowCoord.z ) +\n\t\t\t\tmix( texture2DCompare( shadowMap, uv + vec2( -dx, 0.0 ), shadowCoord.z ),\n\t\t\t\t\t texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, 0.0 ), shadowCoord.z ),\n\t\t\t\t\t f.x ) +\n\t\t\t\tmix( texture2DCompare( shadowMap, uv + vec2( -dx, dy ), shadowCoord.z ),\n\t\t\t\t\t texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, dy ), shadowCoord.z ),\n\t\t\t\t\t f.x ) +\n\t\t\t\tmix( texture2DCompare( shadowMap, uv + vec2( 0.0, -dy ), shadowCoord.z ),\n\t\t\t\t\t texture2DCompare( shadowMap, uv + vec2( 0.0, 2.0 * dy ), shadowCoord.z ),\n\t\t\t\t\t f.y ) +\n\t\t\t\tmix( texture2DCompare( shadowMap, uv + vec2( dx, -dy ), shadowCoord.z ),\n\t\t\t\t\t texture2DCompare( shadowMap, uv + vec2( dx, 2.0 * dy ), shadowCoord.z ),\n\t\t\t\t\t f.y ) +\n\t\t\t\tmix( mix( texture2DCompare( shadowMap, uv + vec2( -dx, -dy ), shadowCoord.z ),\n\t\t\t\t\t\t  texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, -dy ), shadowCoord.z ),\n\t\t\t\t\t\t  f.x ),\n\t\t\t\t\t mix( texture2DCompare( shadowMap, uv + vec2( -dx, 2.0 * dy ), shadowCoord.z ),\n\t\t\t\t\t\t  texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, 2.0 * dy ), shadowCoord.z ),\n\t\t\t\t\t\t  f.x ),\n\t\t\t\t\t f.y )\n\t\t\t) * ( 1.0 / 9.0 );\n\t\t#elif defined( SHADOWMAP_TYPE_VSM )\n\t\t\tshadow = VSMShadow( shadowMap, shadowCoord.xy, shadowCoord.z );\n\t\t#else\n\t\t\tshadow = texture2DCompare( shadowMap, shadowCoord.xy, shadowCoord.z );\n\t\t#endif\n\t\t}\n\t\treturn mix( 1.0, shadow, shadowIntensity );\n\t}\n\tvec2 cubeToUV( vec3 v, float texelSizeY ) {\n\t\tvec3 absV = abs( v );\n\t\tfloat scaleToCube = 1.0 / max( absV.x, max( absV.y, absV.z ) );\n\t\tabsV *= scaleToCube;\n\t\tv *= scaleToCube * ( 1.0 - 2.0 * texelSizeY );\n\t\tvec2 planar = v.xy;\n\t\tfloat almostATexel = 1.5 * texelSizeY;\n\t\tfloat almostOne = 1.0 - almostATexel;\n\t\tif ( absV.z >= almostOne ) {\n\t\t\tif ( v.z > 0.0 )\n\t\t\t\tplanar.x = 4.0 - v.x;\n\t\t} else if ( absV.x >= almostOne ) {\n\t\t\tfloat signX = sign( v.x );\n\t\t\tplanar.x = v.z * signX + 2.0 * signX;\n\t\t} else if ( absV.y >= almostOne ) {\n\t\t\tfloat signY = sign( v.y );\n\t\t\tplanar.x = v.x + 2.0 * signY + 2.0;\n\t\t\tplanar.y = v.z * signY - 2.0;\n\t\t}\n\t\treturn vec2( 0.125, 0.25 ) * planar + vec2( 0.375, 0.75 );\n\t}\n\tfloat getPointShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowIntensity, float shadowBias, float shadowRadius, vec4 shadowCoord, float shadowCameraNear, float shadowCameraFar ) {\n\t\tfloat shadow = 1.0;\n\t\tvec3 lightToPosition = shadowCoord.xyz;\n\t\t\n\t\tfloat lightToPositionLength = length( lightToPosition );\n\t\tif ( lightToPositionLength - shadowCameraFar <= 0.0 && lightToPositionLength - shadowCameraNear >= 0.0 ) {\n\t\t\tfloat dp = ( lightToPositionLength - shadowCameraNear ) / ( shadowCameraFar - shadowCameraNear );\t\t\tdp += shadowBias;\n\t\t\tvec3 bd3D = normalize( lightToPosition );\n\t\t\tvec2 texelSize = vec2( 1.0 ) / ( shadowMapSize * vec2( 4.0, 2.0 ) );\n\t\t\t#if defined( SHADOWMAP_TYPE_PCF ) || defined( SHADOWMAP_TYPE_PCF_SOFT ) || defined( SHADOWMAP_TYPE_VSM )\n\t\t\t\tvec2 offset = vec2( - 1, 1 ) * shadowRadius * texelSize.y;\n\t\t\t\tshadow = (\n\t\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.xyy, texelSize.y ), dp ) +\n\t\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.yyy, texelSize.y ), dp ) +\n\t\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.xyx, texelSize.y ), dp ) +\n\t\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.yyx, texelSize.y ), dp ) +\n\t\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D, texelSize.y ), dp ) +\n\t\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.xxy, texelSize.y ), dp ) +\n\t\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.yxy, texelSize.y ), dp ) +\n\t\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.xxx, texelSize.y ), dp ) +\n\t\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.yxx, texelSize.y ), dp )\n\t\t\t\t) * ( 1.0 / 9.0 );\n\t\t\t#else\n\t\t\t\tshadow = texture2DCompare( shadowMap, cubeToUV( bd3D, texelSize.y ), dp );\n\t\t\t#endif\n\t\t}\n\t\treturn mix( 1.0, shadow, shadowIntensity );\n\t}\n#endif";
var $d5b33d7c30034067$var$shadowmap_pars_vertex = "#if NUM_SPOT_LIGHT_COORDS > 0\n\tuniform mat4 spotLightMatrix[ NUM_SPOT_LIGHT_COORDS ];\n\tvarying vec4 vSpotLightCoord[ NUM_SPOT_LIGHT_COORDS ];\n#endif\n#ifdef USE_SHADOWMAP\n\t#if NUM_DIR_LIGHT_SHADOWS > 0\n\t\tuniform mat4 directionalShadowMatrix[ NUM_DIR_LIGHT_SHADOWS ];\n\t\tvarying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHT_SHADOWS ];\n\t\tstruct DirectionalLightShadow {\n\t\t\tfloat shadowIntensity;\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t};\n\t\tuniform DirectionalLightShadow directionalLightShadows[ NUM_DIR_LIGHT_SHADOWS ];\n\t#endif\n\t#if NUM_SPOT_LIGHT_SHADOWS > 0\n\t\tstruct SpotLightShadow {\n\t\t\tfloat shadowIntensity;\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t};\n\t\tuniform SpotLightShadow spotLightShadows[ NUM_SPOT_LIGHT_SHADOWS ];\n\t#endif\n\t#if NUM_POINT_LIGHT_SHADOWS > 0\n\t\tuniform mat4 pointShadowMatrix[ NUM_POINT_LIGHT_SHADOWS ];\n\t\tvarying vec4 vPointShadowCoord[ NUM_POINT_LIGHT_SHADOWS ];\n\t\tstruct PointLightShadow {\n\t\t\tfloat shadowIntensity;\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t\tfloat shadowCameraNear;\n\t\t\tfloat shadowCameraFar;\n\t\t};\n\t\tuniform PointLightShadow pointLightShadows[ NUM_POINT_LIGHT_SHADOWS ];\n\t#endif\n#endif";
var $d5b33d7c30034067$var$shadowmap_vertex = "#if ( defined( USE_SHADOWMAP ) && ( NUM_DIR_LIGHT_SHADOWS > 0 || NUM_POINT_LIGHT_SHADOWS > 0 ) ) || ( NUM_SPOT_LIGHT_COORDS > 0 )\n\tvec3 shadowWorldNormal = inverseTransformDirection( transformedNormal, viewMatrix );\n\tvec4 shadowWorldPosition;\n#endif\n#if defined( USE_SHADOWMAP )\n\t#if NUM_DIR_LIGHT_SHADOWS > 0\n\t\t#pragma unroll_loop_start\n\t\tfor ( int i = 0; i < NUM_DIR_LIGHT_SHADOWS; i ++ ) {\n\t\t\tshadowWorldPosition = worldPosition + vec4( shadowWorldNormal * directionalLightShadows[ i ].shadowNormalBias, 0 );\n\t\t\tvDirectionalShadowCoord[ i ] = directionalShadowMatrix[ i ] * shadowWorldPosition;\n\t\t}\n\t\t#pragma unroll_loop_end\n\t#endif\n\t#if NUM_POINT_LIGHT_SHADOWS > 0\n\t\t#pragma unroll_loop_start\n\t\tfor ( int i = 0; i < NUM_POINT_LIGHT_SHADOWS; i ++ ) {\n\t\t\tshadowWorldPosition = worldPosition + vec4( shadowWorldNormal * pointLightShadows[ i ].shadowNormalBias, 0 );\n\t\t\tvPointShadowCoord[ i ] = pointShadowMatrix[ i ] * shadowWorldPosition;\n\t\t}\n\t\t#pragma unroll_loop_end\n\t#endif\n#endif\n#if NUM_SPOT_LIGHT_COORDS > 0\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_SPOT_LIGHT_COORDS; i ++ ) {\n\t\tshadowWorldPosition = worldPosition;\n\t\t#if ( defined( USE_SHADOWMAP ) && UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )\n\t\t\tshadowWorldPosition.xyz += shadowWorldNormal * spotLightShadows[ i ].shadowNormalBias;\n\t\t#endif\n\t\tvSpotLightCoord[ i ] = spotLightMatrix[ i ] * shadowWorldPosition;\n\t}\n\t#pragma unroll_loop_end\n#endif";
var $d5b33d7c30034067$var$shadowmask_pars_fragment = "float getShadowMask() {\n\tfloat shadow = 1.0;\n\t#ifdef USE_SHADOWMAP\n\t#if NUM_DIR_LIGHT_SHADOWS > 0\n\tDirectionalLightShadow directionalLight;\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_DIR_LIGHT_SHADOWS; i ++ ) {\n\t\tdirectionalLight = directionalLightShadows[ i ];\n\t\tshadow *= receiveShadow ? getShadow( directionalShadowMap[ i ], directionalLight.shadowMapSize, directionalLight.shadowIntensity, directionalLight.shadowBias, directionalLight.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;\n\t}\n\t#pragma unroll_loop_end\n\t#endif\n\t#if NUM_SPOT_LIGHT_SHADOWS > 0\n\tSpotLightShadow spotLight;\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_SPOT_LIGHT_SHADOWS; i ++ ) {\n\t\tspotLight = spotLightShadows[ i ];\n\t\tshadow *= receiveShadow ? getShadow( spotShadowMap[ i ], spotLight.shadowMapSize, spotLight.shadowIntensity, spotLight.shadowBias, spotLight.shadowRadius, vSpotLightCoord[ i ] ) : 1.0;\n\t}\n\t#pragma unroll_loop_end\n\t#endif\n\t#if NUM_POINT_LIGHT_SHADOWS > 0\n\tPointLightShadow pointLight;\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_POINT_LIGHT_SHADOWS; i ++ ) {\n\t\tpointLight = pointLightShadows[ i ];\n\t\tshadow *= receiveShadow ? getPointShadow( pointShadowMap[ i ], pointLight.shadowMapSize, pointLight.shadowIntensity, pointLight.shadowBias, pointLight.shadowRadius, vPointShadowCoord[ i ], pointLight.shadowCameraNear, pointLight.shadowCameraFar ) : 1.0;\n\t}\n\t#pragma unroll_loop_end\n\t#endif\n\t#endif\n\treturn shadow;\n}";
var $d5b33d7c30034067$var$skinbase_vertex = "#ifdef USE_SKINNING\n\tmat4 boneMatX = getBoneMatrix( skinIndex.x );\n\tmat4 boneMatY = getBoneMatrix( skinIndex.y );\n\tmat4 boneMatZ = getBoneMatrix( skinIndex.z );\n\tmat4 boneMatW = getBoneMatrix( skinIndex.w );\n#endif";
var $d5b33d7c30034067$var$skinning_pars_vertex = "#ifdef USE_SKINNING\n\tuniform mat4 bindMatrix;\n\tuniform mat4 bindMatrixInverse;\n\tuniform highp sampler2D boneTexture;\n\tmat4 getBoneMatrix( const in float i ) {\n\t\tint size = textureSize( boneTexture, 0 ).x;\n\t\tint j = int( i ) * 4;\n\t\tint x = j % size;\n\t\tint y = j / size;\n\t\tvec4 v1 = texelFetch( boneTexture, ivec2( x, y ), 0 );\n\t\tvec4 v2 = texelFetch( boneTexture, ivec2( x + 1, y ), 0 );\n\t\tvec4 v3 = texelFetch( boneTexture, ivec2( x + 2, y ), 0 );\n\t\tvec4 v4 = texelFetch( boneTexture, ivec2( x + 3, y ), 0 );\n\t\treturn mat4( v1, v2, v3, v4 );\n\t}\n#endif";
var $d5b33d7c30034067$var$skinning_vertex = "#ifdef USE_SKINNING\n\tvec4 skinVertex = bindMatrix * vec4( transformed, 1.0 );\n\tvec4 skinned = vec4( 0.0 );\n\tskinned += boneMatX * skinVertex * skinWeight.x;\n\tskinned += boneMatY * skinVertex * skinWeight.y;\n\tskinned += boneMatZ * skinVertex * skinWeight.z;\n\tskinned += boneMatW * skinVertex * skinWeight.w;\n\ttransformed = ( bindMatrixInverse * skinned ).xyz;\n#endif";
var $d5b33d7c30034067$var$skinnormal_vertex = "#ifdef USE_SKINNING\n\tmat4 skinMatrix = mat4( 0.0 );\n\tskinMatrix += skinWeight.x * boneMatX;\n\tskinMatrix += skinWeight.y * boneMatY;\n\tskinMatrix += skinWeight.z * boneMatZ;\n\tskinMatrix += skinWeight.w * boneMatW;\n\tskinMatrix = bindMatrixInverse * skinMatrix * bindMatrix;\n\tobjectNormal = vec4( skinMatrix * vec4( objectNormal, 0.0 ) ).xyz;\n\t#ifdef USE_TANGENT\n\t\tobjectTangent = vec4( skinMatrix * vec4( objectTangent, 0.0 ) ).xyz;\n\t#endif\n#endif";
var $d5b33d7c30034067$var$specularmap_fragment = "float specularStrength;\n#ifdef USE_SPECULARMAP\n\tvec4 texelSpecular = texture2D( specularMap, vSpecularMapUv );\n\tspecularStrength = texelSpecular.r;\n#else\n\tspecularStrength = 1.0;\n#endif";
var $d5b33d7c30034067$var$specularmap_pars_fragment = "#ifdef USE_SPECULARMAP\n\tuniform sampler2D specularMap;\n#endif";
var $d5b33d7c30034067$var$tonemapping_fragment = "#if defined( TONE_MAPPING )\n\tgl_FragColor.rgb = toneMapping( gl_FragColor.rgb );\n#endif";
var $d5b33d7c30034067$var$tonemapping_pars_fragment = "#ifndef saturate\n#define saturate( a ) clamp( a, 0.0, 1.0 )\n#endif\nuniform float toneMappingExposure;\nvec3 LinearToneMapping( vec3 color ) {\n\treturn saturate( toneMappingExposure * color );\n}\nvec3 ReinhardToneMapping( vec3 color ) {\n\tcolor *= toneMappingExposure;\n\treturn saturate( color / ( vec3( 1.0 ) + color ) );\n}\nvec3 CineonToneMapping( vec3 color ) {\n\tcolor *= toneMappingExposure;\n\tcolor = max( vec3( 0.0 ), color - 0.004 );\n\treturn pow( ( color * ( 6.2 * color + 0.5 ) ) / ( color * ( 6.2 * color + 1.7 ) + 0.06 ), vec3( 2.2 ) );\n}\nvec3 RRTAndODTFit( vec3 v ) {\n\tvec3 a = v * ( v + 0.0245786 ) - 0.000090537;\n\tvec3 b = v * ( 0.983729 * v + 0.4329510 ) + 0.238081;\n\treturn a / b;\n}\nvec3 ACESFilmicToneMapping( vec3 color ) {\n\tconst mat3 ACESInputMat = mat3(\n\t\tvec3( 0.59719, 0.07600, 0.02840 ),\t\tvec3( 0.35458, 0.90834, 0.13383 ),\n\t\tvec3( 0.04823, 0.01566, 0.83777 )\n\t);\n\tconst mat3 ACESOutputMat = mat3(\n\t\tvec3(  1.60475, -0.10208, -0.00327 ),\t\tvec3( -0.53108,  1.10813, -0.07276 ),\n\t\tvec3( -0.07367, -0.00605,  1.07602 )\n\t);\n\tcolor *= toneMappingExposure / 0.6;\n\tcolor = ACESInputMat * color;\n\tcolor = RRTAndODTFit( color );\n\tcolor = ACESOutputMat * color;\n\treturn saturate( color );\n}\nconst mat3 LINEAR_REC2020_TO_LINEAR_SRGB = mat3(\n\tvec3( 1.6605, - 0.1246, - 0.0182 ),\n\tvec3( - 0.5876, 1.1329, - 0.1006 ),\n\tvec3( - 0.0728, - 0.0083, 1.1187 )\n);\nconst mat3 LINEAR_SRGB_TO_LINEAR_REC2020 = mat3(\n\tvec3( 0.6274, 0.0691, 0.0164 ),\n\tvec3( 0.3293, 0.9195, 0.0880 ),\n\tvec3( 0.0433, 0.0113, 0.8956 )\n);\nvec3 agxDefaultContrastApprox( vec3 x ) {\n\tvec3 x2 = x * x;\n\tvec3 x4 = x2 * x2;\n\treturn + 15.5 * x4 * x2\n\t\t- 40.14 * x4 * x\n\t\t+ 31.96 * x4\n\t\t- 6.868 * x2 * x\n\t\t+ 0.4298 * x2\n\t\t+ 0.1191 * x\n\t\t- 0.00232;\n}\nvec3 AgXToneMapping( vec3 color ) {\n\tconst mat3 AgXInsetMatrix = mat3(\n\t\tvec3( 0.856627153315983, 0.137318972929847, 0.11189821299995 ),\n\t\tvec3( 0.0951212405381588, 0.761241990602591, 0.0767994186031903 ),\n\t\tvec3( 0.0482516061458583, 0.101439036467562, 0.811302368396859 )\n\t);\n\tconst mat3 AgXOutsetMatrix = mat3(\n\t\tvec3( 1.1271005818144368, - 0.1413297634984383, - 0.14132976349843826 ),\n\t\tvec3( - 0.11060664309660323, 1.157823702216272, - 0.11060664309660294 ),\n\t\tvec3( - 0.016493938717834573, - 0.016493938717834257, 1.2519364065950405 )\n\t);\n\tconst float AgxMinEv = - 12.47393;\tconst float AgxMaxEv = 4.026069;\n\tcolor *= toneMappingExposure;\n\tcolor = LINEAR_SRGB_TO_LINEAR_REC2020 * color;\n\tcolor = AgXInsetMatrix * color;\n\tcolor = max( color, 1e-10 );\tcolor = log2( color );\n\tcolor = ( color - AgxMinEv ) / ( AgxMaxEv - AgxMinEv );\n\tcolor = clamp( color, 0.0, 1.0 );\n\tcolor = agxDefaultContrastApprox( color );\n\tcolor = AgXOutsetMatrix * color;\n\tcolor = pow( max( vec3( 0.0 ), color ), vec3( 2.2 ) );\n\tcolor = LINEAR_REC2020_TO_LINEAR_SRGB * color;\n\tcolor = clamp( color, 0.0, 1.0 );\n\treturn color;\n}\nvec3 NeutralToneMapping( vec3 color ) {\n\tconst float StartCompression = 0.8 - 0.04;\n\tconst float Desaturation = 0.15;\n\tcolor *= toneMappingExposure;\n\tfloat x = min( color.r, min( color.g, color.b ) );\n\tfloat offset = x < 0.08 ? x - 6.25 * x * x : 0.04;\n\tcolor -= offset;\n\tfloat peak = max( color.r, max( color.g, color.b ) );\n\tif ( peak < StartCompression ) return color;\n\tfloat d = 1. - StartCompression;\n\tfloat newPeak = 1. - d * d / ( peak + d - StartCompression );\n\tcolor *= newPeak / peak;\n\tfloat g = 1. - 1. / ( Desaturation * ( peak - newPeak ) + 1. );\n\treturn mix( color, vec3( newPeak ), g );\n}\nvec3 CustomToneMapping( vec3 color ) { return color; }";
var $d5b33d7c30034067$var$transmission_fragment = "#ifdef USE_TRANSMISSION\n\tmaterial.transmission = transmission;\n\tmaterial.transmissionAlpha = 1.0;\n\tmaterial.thickness = thickness;\n\tmaterial.attenuationDistance = attenuationDistance;\n\tmaterial.attenuationColor = attenuationColor;\n\t#ifdef USE_TRANSMISSIONMAP\n\t\tmaterial.transmission *= texture2D( transmissionMap, vTransmissionMapUv ).r;\n\t#endif\n\t#ifdef USE_THICKNESSMAP\n\t\tmaterial.thickness *= texture2D( thicknessMap, vThicknessMapUv ).g;\n\t#endif\n\tvec3 pos = vWorldPosition;\n\tvec3 v = normalize( cameraPosition - pos );\n\tvec3 n = inverseTransformDirection( normal, viewMatrix );\n\tvec4 transmitted = getIBLVolumeRefraction(\n\t\tn, v, material.roughness, material.diffuseColor, material.specularColor, material.specularF90,\n\t\tpos, modelMatrix, viewMatrix, projectionMatrix, material.dispersion, material.ior, material.thickness,\n\t\tmaterial.attenuationColor, material.attenuationDistance );\n\tmaterial.transmissionAlpha = mix( material.transmissionAlpha, transmitted.a, material.transmission );\n\ttotalDiffuse = mix( totalDiffuse, transmitted.rgb, material.transmission );\n#endif";
var $d5b33d7c30034067$var$transmission_pars_fragment = "#ifdef USE_TRANSMISSION\n\tuniform float transmission;\n\tuniform float thickness;\n\tuniform float attenuationDistance;\n\tuniform vec3 attenuationColor;\n\t#ifdef USE_TRANSMISSIONMAP\n\t\tuniform sampler2D transmissionMap;\n\t#endif\n\t#ifdef USE_THICKNESSMAP\n\t\tuniform sampler2D thicknessMap;\n\t#endif\n\tuniform vec2 transmissionSamplerSize;\n\tuniform sampler2D transmissionSamplerMap;\n\tuniform mat4 modelMatrix;\n\tuniform mat4 projectionMatrix;\n\tvarying vec3 vWorldPosition;\n\tfloat w0( float a ) {\n\t\treturn ( 1.0 / 6.0 ) * ( a * ( a * ( - a + 3.0 ) - 3.0 ) + 1.0 );\n\t}\n\tfloat w1( float a ) {\n\t\treturn ( 1.0 / 6.0 ) * ( a *  a * ( 3.0 * a - 6.0 ) + 4.0 );\n\t}\n\tfloat w2( float a ){\n\t\treturn ( 1.0 / 6.0 ) * ( a * ( a * ( - 3.0 * a + 3.0 ) + 3.0 ) + 1.0 );\n\t}\n\tfloat w3( float a ) {\n\t\treturn ( 1.0 / 6.0 ) * ( a * a * a );\n\t}\n\tfloat g0( float a ) {\n\t\treturn w0( a ) + w1( a );\n\t}\n\tfloat g1( float a ) {\n\t\treturn w2( a ) + w3( a );\n\t}\n\tfloat h0( float a ) {\n\t\treturn - 1.0 + w1( a ) / ( w0( a ) + w1( a ) );\n\t}\n\tfloat h1( float a ) {\n\t\treturn 1.0 + w3( a ) / ( w2( a ) + w3( a ) );\n\t}\n\tvec4 bicubic( sampler2D tex, vec2 uv, vec4 texelSize, float lod ) {\n\t\tuv = uv * texelSize.zw + 0.5;\n\t\tvec2 iuv = floor( uv );\n\t\tvec2 fuv = fract( uv );\n\t\tfloat g0x = g0( fuv.x );\n\t\tfloat g1x = g1( fuv.x );\n\t\tfloat h0x = h0( fuv.x );\n\t\tfloat h1x = h1( fuv.x );\n\t\tfloat h0y = h0( fuv.y );\n\t\tfloat h1y = h1( fuv.y );\n\t\tvec2 p0 = ( vec2( iuv.x + h0x, iuv.y + h0y ) - 0.5 ) * texelSize.xy;\n\t\tvec2 p1 = ( vec2( iuv.x + h1x, iuv.y + h0y ) - 0.5 ) * texelSize.xy;\n\t\tvec2 p2 = ( vec2( iuv.x + h0x, iuv.y + h1y ) - 0.5 ) * texelSize.xy;\n\t\tvec2 p3 = ( vec2( iuv.x + h1x, iuv.y + h1y ) - 0.5 ) * texelSize.xy;\n\t\treturn g0( fuv.y ) * ( g0x * textureLod( tex, p0, lod ) + g1x * textureLod( tex, p1, lod ) ) +\n\t\t\tg1( fuv.y ) * ( g0x * textureLod( tex, p2, lod ) + g1x * textureLod( tex, p3, lod ) );\n\t}\n\tvec4 textureBicubic( sampler2D sampler, vec2 uv, float lod ) {\n\t\tvec2 fLodSize = vec2( textureSize( sampler, int( lod ) ) );\n\t\tvec2 cLodSize = vec2( textureSize( sampler, int( lod + 1.0 ) ) );\n\t\tvec2 fLodSizeInv = 1.0 / fLodSize;\n\t\tvec2 cLodSizeInv = 1.0 / cLodSize;\n\t\tvec4 fSample = bicubic( sampler, uv, vec4( fLodSizeInv, fLodSize ), floor( lod ) );\n\t\tvec4 cSample = bicubic( sampler, uv, vec4( cLodSizeInv, cLodSize ), ceil( lod ) );\n\t\treturn mix( fSample, cSample, fract( lod ) );\n\t}\n\tvec3 getVolumeTransmissionRay( const in vec3 n, const in vec3 v, const in float thickness, const in float ior, const in mat4 modelMatrix ) {\n\t\tvec3 refractionVector = refract( - v, normalize( n ), 1.0 / ior );\n\t\tvec3 modelScale;\n\t\tmodelScale.x = length( vec3( modelMatrix[ 0 ].xyz ) );\n\t\tmodelScale.y = length( vec3( modelMatrix[ 1 ].xyz ) );\n\t\tmodelScale.z = length( vec3( modelMatrix[ 2 ].xyz ) );\n\t\treturn normalize( refractionVector ) * thickness * modelScale;\n\t}\n\tfloat applyIorToRoughness( const in float roughness, const in float ior ) {\n\t\treturn roughness * clamp( ior * 2.0 - 2.0, 0.0, 1.0 );\n\t}\n\tvec4 getTransmissionSample( const in vec2 fragCoord, const in float roughness, const in float ior ) {\n\t\tfloat lod = log2( transmissionSamplerSize.x ) * applyIorToRoughness( roughness, ior );\n\t\treturn textureBicubic( transmissionSamplerMap, fragCoord.xy, lod );\n\t}\n\tvec3 volumeAttenuation( const in float transmissionDistance, const in vec3 attenuationColor, const in float attenuationDistance ) {\n\t\tif ( isinf( attenuationDistance ) ) {\n\t\t\treturn vec3( 1.0 );\n\t\t} else {\n\t\t\tvec3 attenuationCoefficient = -log( attenuationColor ) / attenuationDistance;\n\t\t\tvec3 transmittance = exp( - attenuationCoefficient * transmissionDistance );\t\t\treturn transmittance;\n\t\t}\n\t}\n\tvec4 getIBLVolumeRefraction( const in vec3 n, const in vec3 v, const in float roughness, const in vec3 diffuseColor,\n\t\tconst in vec3 specularColor, const in float specularF90, const in vec3 position, const in mat4 modelMatrix,\n\t\tconst in mat4 viewMatrix, const in mat4 projMatrix, const in float dispersion, const in float ior, const in float thickness,\n\t\tconst in vec3 attenuationColor, const in float attenuationDistance ) {\n\t\tvec4 transmittedLight;\n\t\tvec3 transmittance;\n\t\t#ifdef USE_DISPERSION\n\t\t\tfloat halfSpread = ( ior - 1.0 ) * 0.025 * dispersion;\n\t\t\tvec3 iors = vec3( ior - halfSpread, ior, ior + halfSpread );\n\t\t\tfor ( int i = 0; i < 3; i ++ ) {\n\t\t\t\tvec3 transmissionRay = getVolumeTransmissionRay( n, v, thickness, iors[ i ], modelMatrix );\n\t\t\t\tvec3 refractedRayExit = position + transmissionRay;\n\t\t\n\t\t\t\tvec4 ndcPos = projMatrix * viewMatrix * vec4( refractedRayExit, 1.0 );\n\t\t\t\tvec2 refractionCoords = ndcPos.xy / ndcPos.w;\n\t\t\t\trefractionCoords += 1.0;\n\t\t\t\trefractionCoords /= 2.0;\n\t\t\n\t\t\t\tvec4 transmissionSample = getTransmissionSample( refractionCoords, roughness, iors[ i ] );\n\t\t\t\ttransmittedLight[ i ] = transmissionSample[ i ];\n\t\t\t\ttransmittedLight.a += transmissionSample.a;\n\t\t\t\ttransmittance[ i ] = diffuseColor[ i ] * volumeAttenuation( length( transmissionRay ), attenuationColor, attenuationDistance )[ i ];\n\t\t\t}\n\t\t\ttransmittedLight.a /= 3.0;\n\t\t\n\t\t#else\n\t\t\n\t\t\tvec3 transmissionRay = getVolumeTransmissionRay( n, v, thickness, ior, modelMatrix );\n\t\t\tvec3 refractedRayExit = position + transmissionRay;\n\t\t\tvec4 ndcPos = projMatrix * viewMatrix * vec4( refractedRayExit, 1.0 );\n\t\t\tvec2 refractionCoords = ndcPos.xy / ndcPos.w;\n\t\t\trefractionCoords += 1.0;\n\t\t\trefractionCoords /= 2.0;\n\t\t\ttransmittedLight = getTransmissionSample( refractionCoords, roughness, ior );\n\t\t\ttransmittance = diffuseColor * volumeAttenuation( length( transmissionRay ), attenuationColor, attenuationDistance );\n\t\t\n\t\t#endif\n\t\tvec3 attenuatedColor = transmittance * transmittedLight.rgb;\n\t\tvec3 F = EnvironmentBRDF( n, v, specularColor, specularF90, roughness );\n\t\tfloat transmittanceFactor = ( transmittance.r + transmittance.g + transmittance.b ) / 3.0;\n\t\treturn vec4( ( 1.0 - F ) * attenuatedColor, 1.0 - ( 1.0 - transmittedLight.a ) * transmittanceFactor );\n\t}\n#endif";
var $d5b33d7c30034067$var$uv_pars_fragment = "#if defined( USE_UV ) || defined( USE_ANISOTROPY )\n\tvarying vec2 vUv;\n#endif\n#ifdef USE_MAP\n\tvarying vec2 vMapUv;\n#endif\n#ifdef USE_ALPHAMAP\n\tvarying vec2 vAlphaMapUv;\n#endif\n#ifdef USE_LIGHTMAP\n\tvarying vec2 vLightMapUv;\n#endif\n#ifdef USE_AOMAP\n\tvarying vec2 vAoMapUv;\n#endif\n#ifdef USE_BUMPMAP\n\tvarying vec2 vBumpMapUv;\n#endif\n#ifdef USE_NORMALMAP\n\tvarying vec2 vNormalMapUv;\n#endif\n#ifdef USE_EMISSIVEMAP\n\tvarying vec2 vEmissiveMapUv;\n#endif\n#ifdef USE_METALNESSMAP\n\tvarying vec2 vMetalnessMapUv;\n#endif\n#ifdef USE_ROUGHNESSMAP\n\tvarying vec2 vRoughnessMapUv;\n#endif\n#ifdef USE_ANISOTROPYMAP\n\tvarying vec2 vAnisotropyMapUv;\n#endif\n#ifdef USE_CLEARCOATMAP\n\tvarying vec2 vClearcoatMapUv;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n\tvarying vec2 vClearcoatNormalMapUv;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n\tvarying vec2 vClearcoatRoughnessMapUv;\n#endif\n#ifdef USE_IRIDESCENCEMAP\n\tvarying vec2 vIridescenceMapUv;\n#endif\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\n\tvarying vec2 vIridescenceThicknessMapUv;\n#endif\n#ifdef USE_SHEEN_COLORMAP\n\tvarying vec2 vSheenColorMapUv;\n#endif\n#ifdef USE_SHEEN_ROUGHNESSMAP\n\tvarying vec2 vSheenRoughnessMapUv;\n#endif\n#ifdef USE_SPECULARMAP\n\tvarying vec2 vSpecularMapUv;\n#endif\n#ifdef USE_SPECULAR_COLORMAP\n\tvarying vec2 vSpecularColorMapUv;\n#endif\n#ifdef USE_SPECULAR_INTENSITYMAP\n\tvarying vec2 vSpecularIntensityMapUv;\n#endif\n#ifdef USE_TRANSMISSIONMAP\n\tuniform mat3 transmissionMapTransform;\n\tvarying vec2 vTransmissionMapUv;\n#endif\n#ifdef USE_THICKNESSMAP\n\tuniform mat3 thicknessMapTransform;\n\tvarying vec2 vThicknessMapUv;\n#endif";
var $d5b33d7c30034067$var$uv_pars_vertex = "#if defined( USE_UV ) || defined( USE_ANISOTROPY )\n\tvarying vec2 vUv;\n#endif\n#ifdef USE_MAP\n\tuniform mat3 mapTransform;\n\tvarying vec2 vMapUv;\n#endif\n#ifdef USE_ALPHAMAP\n\tuniform mat3 alphaMapTransform;\n\tvarying vec2 vAlphaMapUv;\n#endif\n#ifdef USE_LIGHTMAP\n\tuniform mat3 lightMapTransform;\n\tvarying vec2 vLightMapUv;\n#endif\n#ifdef USE_AOMAP\n\tuniform mat3 aoMapTransform;\n\tvarying vec2 vAoMapUv;\n#endif\n#ifdef USE_BUMPMAP\n\tuniform mat3 bumpMapTransform;\n\tvarying vec2 vBumpMapUv;\n#endif\n#ifdef USE_NORMALMAP\n\tuniform mat3 normalMapTransform;\n\tvarying vec2 vNormalMapUv;\n#endif\n#ifdef USE_DISPLACEMENTMAP\n\tuniform mat3 displacementMapTransform;\n\tvarying vec2 vDisplacementMapUv;\n#endif\n#ifdef USE_EMISSIVEMAP\n\tuniform mat3 emissiveMapTransform;\n\tvarying vec2 vEmissiveMapUv;\n#endif\n#ifdef USE_METALNESSMAP\n\tuniform mat3 metalnessMapTransform;\n\tvarying vec2 vMetalnessMapUv;\n#endif\n#ifdef USE_ROUGHNESSMAP\n\tuniform mat3 roughnessMapTransform;\n\tvarying vec2 vRoughnessMapUv;\n#endif\n#ifdef USE_ANISOTROPYMAP\n\tuniform mat3 anisotropyMapTransform;\n\tvarying vec2 vAnisotropyMapUv;\n#endif\n#ifdef USE_CLEARCOATMAP\n\tuniform mat3 clearcoatMapTransform;\n\tvarying vec2 vClearcoatMapUv;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n\tuniform mat3 clearcoatNormalMapTransform;\n\tvarying vec2 vClearcoatNormalMapUv;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n\tuniform mat3 clearcoatRoughnessMapTransform;\n\tvarying vec2 vClearcoatRoughnessMapUv;\n#endif\n#ifdef USE_SHEEN_COLORMAP\n\tuniform mat3 sheenColorMapTransform;\n\tvarying vec2 vSheenColorMapUv;\n#endif\n#ifdef USE_SHEEN_ROUGHNESSMAP\n\tuniform mat3 sheenRoughnessMapTransform;\n\tvarying vec2 vSheenRoughnessMapUv;\n#endif\n#ifdef USE_IRIDESCENCEMAP\n\tuniform mat3 iridescenceMapTransform;\n\tvarying vec2 vIridescenceMapUv;\n#endif\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\n\tuniform mat3 iridescenceThicknessMapTransform;\n\tvarying vec2 vIridescenceThicknessMapUv;\n#endif\n#ifdef USE_SPECULARMAP\n\tuniform mat3 specularMapTransform;\n\tvarying vec2 vSpecularMapUv;\n#endif\n#ifdef USE_SPECULAR_COLORMAP\n\tuniform mat3 specularColorMapTransform;\n\tvarying vec2 vSpecularColorMapUv;\n#endif\n#ifdef USE_SPECULAR_INTENSITYMAP\n\tuniform mat3 specularIntensityMapTransform;\n\tvarying vec2 vSpecularIntensityMapUv;\n#endif\n#ifdef USE_TRANSMISSIONMAP\n\tuniform mat3 transmissionMapTransform;\n\tvarying vec2 vTransmissionMapUv;\n#endif\n#ifdef USE_THICKNESSMAP\n\tuniform mat3 thicknessMapTransform;\n\tvarying vec2 vThicknessMapUv;\n#endif";
var $d5b33d7c30034067$var$uv_vertex = "#if defined( USE_UV ) || defined( USE_ANISOTROPY )\n\tvUv = vec3( uv, 1 ).xy;\n#endif\n#ifdef USE_MAP\n\tvMapUv = ( mapTransform * vec3( MAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_ALPHAMAP\n\tvAlphaMapUv = ( alphaMapTransform * vec3( ALPHAMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_LIGHTMAP\n\tvLightMapUv = ( lightMapTransform * vec3( LIGHTMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_AOMAP\n\tvAoMapUv = ( aoMapTransform * vec3( AOMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_BUMPMAP\n\tvBumpMapUv = ( bumpMapTransform * vec3( BUMPMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_NORMALMAP\n\tvNormalMapUv = ( normalMapTransform * vec3( NORMALMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_DISPLACEMENTMAP\n\tvDisplacementMapUv = ( displacementMapTransform * vec3( DISPLACEMENTMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_EMISSIVEMAP\n\tvEmissiveMapUv = ( emissiveMapTransform * vec3( EMISSIVEMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_METALNESSMAP\n\tvMetalnessMapUv = ( metalnessMapTransform * vec3( METALNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_ROUGHNESSMAP\n\tvRoughnessMapUv = ( roughnessMapTransform * vec3( ROUGHNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_ANISOTROPYMAP\n\tvAnisotropyMapUv = ( anisotropyMapTransform * vec3( ANISOTROPYMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_CLEARCOATMAP\n\tvClearcoatMapUv = ( clearcoatMapTransform * vec3( CLEARCOATMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n\tvClearcoatNormalMapUv = ( clearcoatNormalMapTransform * vec3( CLEARCOAT_NORMALMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n\tvClearcoatRoughnessMapUv = ( clearcoatRoughnessMapTransform * vec3( CLEARCOAT_ROUGHNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_IRIDESCENCEMAP\n\tvIridescenceMapUv = ( iridescenceMapTransform * vec3( IRIDESCENCEMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\n\tvIridescenceThicknessMapUv = ( iridescenceThicknessMapTransform * vec3( IRIDESCENCE_THICKNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SHEEN_COLORMAP\n\tvSheenColorMapUv = ( sheenColorMapTransform * vec3( SHEEN_COLORMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SHEEN_ROUGHNESSMAP\n\tvSheenRoughnessMapUv = ( sheenRoughnessMapTransform * vec3( SHEEN_ROUGHNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SPECULARMAP\n\tvSpecularMapUv = ( specularMapTransform * vec3( SPECULARMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SPECULAR_COLORMAP\n\tvSpecularColorMapUv = ( specularColorMapTransform * vec3( SPECULAR_COLORMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SPECULAR_INTENSITYMAP\n\tvSpecularIntensityMapUv = ( specularIntensityMapTransform * vec3( SPECULAR_INTENSITYMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_TRANSMISSIONMAP\n\tvTransmissionMapUv = ( transmissionMapTransform * vec3( TRANSMISSIONMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_THICKNESSMAP\n\tvThicknessMapUv = ( thicknessMapTransform * vec3( THICKNESSMAP_UV, 1 ) ).xy;\n#endif";
var $d5b33d7c30034067$var$worldpos_vertex = "#if defined( USE_ENVMAP ) || defined( DISTANCE ) || defined ( USE_SHADOWMAP ) || defined ( USE_TRANSMISSION ) || NUM_SPOT_LIGHT_COORDS > 0\n\tvec4 worldPosition = vec4( transformed, 1.0 );\n\t#ifdef USE_BATCHING\n\t\tworldPosition = batchingMatrix * worldPosition;\n\t#endif\n\t#ifdef USE_INSTANCING\n\t\tworldPosition = instanceMatrix * worldPosition;\n\t#endif\n\tworldPosition = modelMatrix * worldPosition;\n#endif";
const $d5b33d7c30034067$var$vertex$h = "varying vec2 vUv;\nuniform mat3 uvTransform;\nvoid main() {\n\tvUv = ( uvTransform * vec3( uv, 1 ) ).xy;\n\tgl_Position = vec4( position.xy, 1.0, 1.0 );\n}";
const $d5b33d7c30034067$var$fragment$h = "uniform sampler2D t2D;\nuniform float backgroundIntensity;\nvarying vec2 vUv;\nvoid main() {\n\tvec4 texColor = texture2D( t2D, vUv );\n\t#ifdef DECODE_VIDEO_TEXTURE\n\t\ttexColor = vec4( mix( pow( texColor.rgb * 0.9478672986 + vec3( 0.0521327014 ), vec3( 2.4 ) ), texColor.rgb * 0.0773993808, vec3( lessThanEqual( texColor.rgb, vec3( 0.04045 ) ) ) ), texColor.w );\n\t#endif\n\ttexColor.rgb *= backgroundIntensity;\n\tgl_FragColor = texColor;\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n}";
const $d5b33d7c30034067$var$vertex$g = "varying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n\tvWorldDirection = transformDirection( position, modelMatrix );\n\t#include <begin_vertex>\n\t#include <project_vertex>\n\tgl_Position.z = gl_Position.w;\n}";
const $d5b33d7c30034067$var$fragment$g = "#ifdef ENVMAP_TYPE_CUBE\n\tuniform samplerCube envMap;\n#elif defined( ENVMAP_TYPE_CUBE_UV )\n\tuniform sampler2D envMap;\n#endif\nuniform float flipEnvMap;\nuniform float backgroundBlurriness;\nuniform float backgroundIntensity;\nuniform mat3 backgroundRotation;\nvarying vec3 vWorldDirection;\n#include <cube_uv_reflection_fragment>\nvoid main() {\n\t#ifdef ENVMAP_TYPE_CUBE\n\t\tvec4 texColor = textureCube( envMap, backgroundRotation * vec3( flipEnvMap * vWorldDirection.x, vWorldDirection.yz ) );\n\t#elif defined( ENVMAP_TYPE_CUBE_UV )\n\t\tvec4 texColor = textureCubeUV( envMap, backgroundRotation * vWorldDirection, backgroundBlurriness );\n\t#else\n\t\tvec4 texColor = vec4( 0.0, 0.0, 0.0, 1.0 );\n\t#endif\n\ttexColor.rgb *= backgroundIntensity;\n\tgl_FragColor = texColor;\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n}";
const $d5b33d7c30034067$var$vertex$f = "varying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n\tvWorldDirection = transformDirection( position, modelMatrix );\n\t#include <begin_vertex>\n\t#include <project_vertex>\n\tgl_Position.z = gl_Position.w;\n}";
const $d5b33d7c30034067$var$fragment$f = "uniform samplerCube tCube;\nuniform float tFlip;\nuniform float opacity;\nvarying vec3 vWorldDirection;\nvoid main() {\n\tvec4 texColor = textureCube( tCube, vec3( tFlip * vWorldDirection.x, vWorldDirection.yz ) );\n\tgl_FragColor = texColor;\n\tgl_FragColor.a *= opacity;\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n}";
const $d5b33d7c30034067$var$vertex$e = "#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvarying vec2 vHighPrecisionZW;\nvoid main() {\n\t#include <uv_vertex>\n\t#include <batching_vertex>\n\t#include <skinbase_vertex>\n\t#include <morphinstance_vertex>\n\t#ifdef USE_DISPLACEMENTMAP\n\t\t#include <beginnormal_vertex>\n\t\t#include <morphnormal_vertex>\n\t\t#include <skinnormal_vertex>\n\t#endif\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvHighPrecisionZW = gl_Position.zw;\n}";
const $d5b33d7c30034067$var$fragment$e = "#if DEPTH_PACKING == 3200\n\tuniform float opacity;\n#endif\n#include <common>\n#include <packing>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvarying vec2 vHighPrecisionZW;\nvoid main() {\n\tvec4 diffuseColor = vec4( 1.0 );\n\t#include <clipping_planes_fragment>\n\t#if DEPTH_PACKING == 3200\n\t\tdiffuseColor.a = opacity;\n\t#endif\n\t#include <map_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\t#include <logdepthbuf_fragment>\n\tfloat fragCoordZ = 0.5 * vHighPrecisionZW[0] / vHighPrecisionZW[1] + 0.5;\n\t#if DEPTH_PACKING == 3200\n\t\tgl_FragColor = vec4( vec3( 1.0 - fragCoordZ ), opacity );\n\t#elif DEPTH_PACKING == 3201\n\t\tgl_FragColor = packDepthToRGBA( fragCoordZ );\n\t#elif DEPTH_PACKING == 3202\n\t\tgl_FragColor = vec4( packDepthToRGB( fragCoordZ ), 1.0 );\n\t#elif DEPTH_PACKING == 3203\n\t\tgl_FragColor = vec4( packDepthToRG( fragCoordZ ), 0.0, 1.0 );\n\t#endif\n}";
const $d5b33d7c30034067$var$vertex$d = "#define DISTANCE\nvarying vec3 vWorldPosition;\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <batching_vertex>\n\t#include <skinbase_vertex>\n\t#include <morphinstance_vertex>\n\t#ifdef USE_DISPLACEMENTMAP\n\t\t#include <beginnormal_vertex>\n\t\t#include <morphnormal_vertex>\n\t\t#include <skinnormal_vertex>\n\t#endif\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <worldpos_vertex>\n\t#include <clipping_planes_vertex>\n\tvWorldPosition = worldPosition.xyz;\n}";
const $d5b33d7c30034067$var$fragment$d = "#define DISTANCE\nuniform vec3 referencePosition;\nuniform float nearDistance;\nuniform float farDistance;\nvarying vec3 vWorldPosition;\n#include <common>\n#include <packing>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main () {\n\tvec4 diffuseColor = vec4( 1.0 );\n\t#include <clipping_planes_fragment>\n\t#include <map_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\tfloat dist = length( vWorldPosition - referencePosition );\n\tdist = ( dist - nearDistance ) / ( farDistance - nearDistance );\n\tdist = saturate( dist );\n\tgl_FragColor = packDepthToRGBA( dist );\n}";
const $d5b33d7c30034067$var$vertex$c = "varying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n\tvWorldDirection = transformDirection( position, modelMatrix );\n\t#include <begin_vertex>\n\t#include <project_vertex>\n}";
const $d5b33d7c30034067$var$fragment$c = "uniform sampler2D tEquirect;\nvarying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n\tvec3 direction = normalize( vWorldDirection );\n\tvec2 sampleUV = equirectUv( direction );\n\tgl_FragColor = texture2D( tEquirect, sampleUV );\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n}";
const $d5b33d7c30034067$var$vertex$b = "uniform float scale;\nattribute float lineDistance;\nvarying float vLineDistance;\n#include <common>\n#include <uv_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\tvLineDistance = scale * lineDistance;\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphcolor_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <fog_vertex>\n}";
const $d5b33d7c30034067$var$fragment$b = "uniform vec3 diffuse;\nuniform float opacity;\nuniform float dashSize;\nuniform float totalSize;\nvarying float vLineDistance;\n#include <common>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <clipping_planes_fragment>\n\tif ( mod( vLineDistance, totalSize ) > dashSize ) {\n\t\tdiscard;\n\t}\n\tvec3 outgoingLight = vec3( 0.0 );\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\toutgoingLight = diffuseColor.rgb;\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n}";
const $d5b33d7c30034067$var$vertex$a = "#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphcolor_vertex>\n\t#include <batching_vertex>\n\t#if defined ( USE_ENVMAP ) || defined ( USE_SKINNING )\n\t\t#include <beginnormal_vertex>\n\t\t#include <morphnormal_vertex>\n\t\t#include <skinbase_vertex>\n\t\t#include <skinnormal_vertex>\n\t\t#include <defaultnormal_vertex>\n\t#endif\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <worldpos_vertex>\n\t#include <envmap_vertex>\n\t#include <fog_vertex>\n}";
const $d5b33d7c30034067$var$fragment$a = "uniform vec3 diffuse;\nuniform float opacity;\n#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n#endif\n#include <common>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <clipping_planes_fragment>\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\t#include <specularmap_fragment>\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\t#ifdef USE_LIGHTMAP\n\t\tvec4 lightMapTexel = texture2D( lightMap, vLightMapUv );\n\t\treflectedLight.indirectDiffuse += lightMapTexel.rgb * lightMapIntensity * RECIPROCAL_PI;\n\t#else\n\t\treflectedLight.indirectDiffuse += vec3( 1.0 );\n\t#endif\n\t#include <aomap_fragment>\n\treflectedLight.indirectDiffuse *= diffuseColor.rgb;\n\tvec3 outgoingLight = reflectedLight.indirectDiffuse;\n\t#include <envmap_fragment>\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}";
const $d5b33d7c30034067$var$vertex$9 = "#define LAMBERT\nvarying vec3 vViewPosition;\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphcolor_vertex>\n\t#include <batching_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvViewPosition = - mvPosition.xyz;\n\t#include <worldpos_vertex>\n\t#include <envmap_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}";
const $d5b33d7c30034067$var$fragment$9 = "#define LAMBERT\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_lambert_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <clipping_planes_fragment>\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\t#include <specularmap_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\t#include <emissivemap_fragment>\n\t#include <lights_lambert_fragment>\n\t#include <lights_fragment_begin>\n\t#include <lights_fragment_maps>\n\t#include <lights_fragment_end>\n\t#include <aomap_fragment>\n\tvec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;\n\t#include <envmap_fragment>\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}";
const $d5b33d7c30034067$var$vertex$8 = "#define MATCAP\nvarying vec3 vViewPosition;\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <color_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphcolor_vertex>\n\t#include <batching_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <fog_vertex>\n\tvViewPosition = - mvPosition.xyz;\n}";
const $d5b33d7c30034067$var$fragment$8 = "#define MATCAP\nuniform vec3 diffuse;\nuniform float opacity;\nuniform sampler2D matcap;\nvarying vec3 vViewPosition;\n#include <common>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <fog_pars_fragment>\n#include <normal_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <clipping_planes_fragment>\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\tvec3 viewDir = normalize( vViewPosition );\n\tvec3 x = normalize( vec3( viewDir.z, 0.0, - viewDir.x ) );\n\tvec3 y = cross( viewDir, x );\n\tvec2 uv = vec2( dot( x, normal ), dot( y, normal ) ) * 0.495 + 0.5;\n\t#ifdef USE_MATCAP\n\t\tvec4 matcapColor = texture2D( matcap, uv );\n\t#else\n\t\tvec4 matcapColor = vec4( vec3( mix( 0.2, 0.8, uv.y ) ), 1.0 );\n\t#endif\n\tvec3 outgoingLight = diffuseColor.rgb * matcapColor.rgb;\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}";
const $d5b33d7c30034067$var$vertex$7 = "#define NORMAL\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP_TANGENTSPACE )\n\tvarying vec3 vViewPosition;\n#endif\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <batching_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP_TANGENTSPACE )\n\tvViewPosition = - mvPosition.xyz;\n#endif\n}";
const $d5b33d7c30034067$var$fragment$7 = "#define NORMAL\nuniform float opacity;\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP_TANGENTSPACE )\n\tvarying vec3 vViewPosition;\n#endif\n#include <packing>\n#include <uv_pars_fragment>\n#include <normal_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( 0.0, 0.0, 0.0, opacity );\n\t#include <clipping_planes_fragment>\n\t#include <logdepthbuf_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\tgl_FragColor = vec4( packNormalToRGB( normal ), diffuseColor.a );\n\t#ifdef OPAQUE\n\t\tgl_FragColor.a = 1.0;\n\t#endif\n}";
const $d5b33d7c30034067$var$vertex$6 = "#define PHONG\nvarying vec3 vViewPosition;\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphcolor_vertex>\n\t#include <batching_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvViewPosition = - mvPosition.xyz;\n\t#include <worldpos_vertex>\n\t#include <envmap_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}";
const $d5b33d7c30034067$var$fragment$6 = "#define PHONG\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform vec3 specular;\nuniform float shininess;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_phong_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <clipping_planes_fragment>\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\t#include <specularmap_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\t#include <emissivemap_fragment>\n\t#include <lights_phong_fragment>\n\t#include <lights_fragment_begin>\n\t#include <lights_fragment_maps>\n\t#include <lights_fragment_end>\n\t#include <aomap_fragment>\n\tvec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + reflectedLight.directSpecular + reflectedLight.indirectSpecular + totalEmissiveRadiance;\n\t#include <envmap_fragment>\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}";
const $d5b33d7c30034067$var$vertex$5 = "#define STANDARD\nvarying vec3 vViewPosition;\n#ifdef USE_TRANSMISSION\n\tvarying vec3 vWorldPosition;\n#endif\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphcolor_vertex>\n\t#include <batching_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvViewPosition = - mvPosition.xyz;\n\t#include <worldpos_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n#ifdef USE_TRANSMISSION\n\tvWorldPosition = worldPosition.xyz;\n#endif\n}";
const $d5b33d7c30034067$var$fragment$5 = "#define STANDARD\n#ifdef PHYSICAL\n\t#define IOR\n\t#define USE_SPECULAR\n#endif\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float roughness;\nuniform float metalness;\nuniform float opacity;\n#ifdef IOR\n\tuniform float ior;\n#endif\n#ifdef USE_SPECULAR\n\tuniform float specularIntensity;\n\tuniform vec3 specularColor;\n\t#ifdef USE_SPECULAR_COLORMAP\n\t\tuniform sampler2D specularColorMap;\n\t#endif\n\t#ifdef USE_SPECULAR_INTENSITYMAP\n\t\tuniform sampler2D specularIntensityMap;\n\t#endif\n#endif\n#ifdef USE_CLEARCOAT\n\tuniform float clearcoat;\n\tuniform float clearcoatRoughness;\n#endif\n#ifdef USE_DISPERSION\n\tuniform float dispersion;\n#endif\n#ifdef USE_IRIDESCENCE\n\tuniform float iridescence;\n\tuniform float iridescenceIOR;\n\tuniform float iridescenceThicknessMinimum;\n\tuniform float iridescenceThicknessMaximum;\n#endif\n#ifdef USE_SHEEN\n\tuniform vec3 sheenColor;\n\tuniform float sheenRoughness;\n\t#ifdef USE_SHEEN_COLORMAP\n\t\tuniform sampler2D sheenColorMap;\n\t#endif\n\t#ifdef USE_SHEEN_ROUGHNESSMAP\n\t\tuniform sampler2D sheenRoughnessMap;\n\t#endif\n#endif\n#ifdef USE_ANISOTROPY\n\tuniform vec2 anisotropyVector;\n\t#ifdef USE_ANISOTROPYMAP\n\t\tuniform sampler2D anisotropyMap;\n\t#endif\n#endif\nvarying vec3 vViewPosition;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <iridescence_fragment>\n#include <cube_uv_reflection_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_physical_pars_fragment>\n#include <fog_pars_fragment>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_physical_pars_fragment>\n#include <transmission_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <clearcoat_pars_fragment>\n#include <iridescence_pars_fragment>\n#include <roughnessmap_pars_fragment>\n#include <metalnessmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <clipping_planes_fragment>\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\t#include <roughnessmap_fragment>\n\t#include <metalnessmap_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\t#include <clearcoat_normal_fragment_begin>\n\t#include <clearcoat_normal_fragment_maps>\n\t#include <emissivemap_fragment>\n\t#include <lights_physical_fragment>\n\t#include <lights_fragment_begin>\n\t#include <lights_fragment_maps>\n\t#include <lights_fragment_end>\n\t#include <aomap_fragment>\n\tvec3 totalDiffuse = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse;\n\tvec3 totalSpecular = reflectedLight.directSpecular + reflectedLight.indirectSpecular;\n\t#include <transmission_fragment>\n\tvec3 outgoingLight = totalDiffuse + totalSpecular + totalEmissiveRadiance;\n\t#ifdef USE_SHEEN\n\t\tfloat sheenEnergyComp = 1.0 - 0.157 * max3( material.sheenColor );\n\t\toutgoingLight = outgoingLight * sheenEnergyComp + sheenSpecularDirect + sheenSpecularIndirect;\n\t#endif\n\t#ifdef USE_CLEARCOAT\n\t\tfloat dotNVcc = saturate( dot( geometryClearcoatNormal, geometryViewDir ) );\n\t\tvec3 Fcc = F_Schlick( material.clearcoatF0, material.clearcoatF90, dotNVcc );\n\t\toutgoingLight = outgoingLight * ( 1.0 - material.clearcoat * Fcc ) + ( clearcoatSpecularDirect + clearcoatSpecularIndirect ) * material.clearcoat;\n\t#endif\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}";
const $d5b33d7c30034067$var$vertex$4 = "#define TOON\nvarying vec3 vViewPosition;\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphcolor_vertex>\n\t#include <batching_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvViewPosition = - mvPosition.xyz;\n\t#include <worldpos_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}";
const $d5b33d7c30034067$var$fragment$4 = "#define TOON\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <gradientmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_toon_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <clipping_planes_fragment>\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\t#include <emissivemap_fragment>\n\t#include <lights_toon_fragment>\n\t#include <lights_fragment_begin>\n\t#include <lights_fragment_maps>\n\t#include <lights_fragment_end>\n\t#include <aomap_fragment>\n\tvec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}";
const $d5b33d7c30034067$var$vertex$3 = "uniform float size;\nuniform float scale;\n#include <common>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\n#ifdef USE_POINTS_UV\n\tvarying vec2 vUv;\n\tuniform mat3 uvTransform;\n#endif\nvoid main() {\n\t#ifdef USE_POINTS_UV\n\t\tvUv = ( uvTransform * vec3( uv, 1 ) ).xy;\n\t#endif\n\t#include <color_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphcolor_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <project_vertex>\n\tgl_PointSize = size;\n\t#ifdef USE_SIZEATTENUATION\n\t\tbool isPerspective = isPerspectiveMatrix( projectionMatrix );\n\t\tif ( isPerspective ) gl_PointSize *= ( scale / - mvPosition.z );\n\t#endif\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <worldpos_vertex>\n\t#include <fog_vertex>\n}";
const $d5b33d7c30034067$var$fragment$3 = "uniform vec3 diffuse;\nuniform float opacity;\n#include <common>\n#include <color_pars_fragment>\n#include <map_particle_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <clipping_planes_fragment>\n\tvec3 outgoingLight = vec3( 0.0 );\n\t#include <logdepthbuf_fragment>\n\t#include <map_particle_fragment>\n\t#include <color_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\toutgoingLight = diffuseColor.rgb;\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n}";
const $d5b33d7c30034067$var$vertex$2 = "#include <common>\n#include <batching_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <shadowmap_pars_vertex>\nvoid main() {\n\t#include <batching_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <worldpos_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}";
const $d5b33d7c30034067$var$fragment$2 = "uniform vec3 color;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <logdepthbuf_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <shadowmask_pars_fragment>\nvoid main() {\n\t#include <logdepthbuf_fragment>\n\tgl_FragColor = vec4( color, opacity * ( 1.0 - getShadowMask() ) );\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n}";
const $d5b33d7c30034067$var$vertex$1 = "uniform float rotation;\nuniform vec2 center;\n#include <common>\n#include <uv_pars_vertex>\n#include <fog_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\tvec4 mvPosition = modelViewMatrix[ 3 ];\n\tvec2 scale = vec2( length( modelMatrix[ 0 ].xyz ), length( modelMatrix[ 1 ].xyz ) );\n\t#ifndef USE_SIZEATTENUATION\n\t\tbool isPerspective = isPerspectiveMatrix( projectionMatrix );\n\t\tif ( isPerspective ) scale *= - mvPosition.z;\n\t#endif\n\tvec2 alignedPosition = ( position.xy - ( center - vec2( 0.5 ) ) ) * scale;\n\tvec2 rotatedPosition;\n\trotatedPosition.x = cos( rotation ) * alignedPosition.x - sin( rotation ) * alignedPosition.y;\n\trotatedPosition.y = sin( rotation ) * alignedPosition.x + cos( rotation ) * alignedPosition.y;\n\tmvPosition.xy += rotatedPosition;\n\tgl_Position = projectionMatrix * mvPosition;\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <fog_vertex>\n}";
const $d5b33d7c30034067$var$fragment$1 = "uniform vec3 diffuse;\nuniform float opacity;\n#include <common>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <clipping_planes_fragment>\n\tvec3 outgoingLight = vec3( 0.0 );\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\toutgoingLight = diffuseColor.rgb;\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n}";
const $d5b33d7c30034067$export$955f9f2e84c43c8b = {
    alphahash_fragment: $d5b33d7c30034067$var$alphahash_fragment,
    alphahash_pars_fragment: $d5b33d7c30034067$var$alphahash_pars_fragment,
    alphamap_fragment: $d5b33d7c30034067$var$alphamap_fragment,
    alphamap_pars_fragment: $d5b33d7c30034067$var$alphamap_pars_fragment,
    alphatest_fragment: $d5b33d7c30034067$var$alphatest_fragment,
    alphatest_pars_fragment: $d5b33d7c30034067$var$alphatest_pars_fragment,
    aomap_fragment: $d5b33d7c30034067$var$aomap_fragment,
    aomap_pars_fragment: $d5b33d7c30034067$var$aomap_pars_fragment,
    batching_pars_vertex: $d5b33d7c30034067$var$batching_pars_vertex,
    batching_vertex: $d5b33d7c30034067$var$batching_vertex,
    begin_vertex: $d5b33d7c30034067$var$begin_vertex,
    beginnormal_vertex: $d5b33d7c30034067$var$beginnormal_vertex,
    bsdfs: $d5b33d7c30034067$var$bsdfs,
    iridescence_fragment: $d5b33d7c30034067$var$iridescence_fragment,
    bumpmap_pars_fragment: $d5b33d7c30034067$var$bumpmap_pars_fragment,
    clipping_planes_fragment: $d5b33d7c30034067$var$clipping_planes_fragment,
    clipping_planes_pars_fragment: $d5b33d7c30034067$var$clipping_planes_pars_fragment,
    clipping_planes_pars_vertex: $d5b33d7c30034067$var$clipping_planes_pars_vertex,
    clipping_planes_vertex: $d5b33d7c30034067$var$clipping_planes_vertex,
    color_fragment: $d5b33d7c30034067$var$color_fragment,
    color_pars_fragment: $d5b33d7c30034067$var$color_pars_fragment,
    color_pars_vertex: $d5b33d7c30034067$var$color_pars_vertex,
    color_vertex: $d5b33d7c30034067$var$color_vertex,
    common: $d5b33d7c30034067$var$common,
    cube_uv_reflection_fragment: $d5b33d7c30034067$var$cube_uv_reflection_fragment,
    defaultnormal_vertex: $d5b33d7c30034067$var$defaultnormal_vertex,
    displacementmap_pars_vertex: $d5b33d7c30034067$var$displacementmap_pars_vertex,
    displacementmap_vertex: $d5b33d7c30034067$var$displacementmap_vertex,
    emissivemap_fragment: $d5b33d7c30034067$var$emissivemap_fragment,
    emissivemap_pars_fragment: $d5b33d7c30034067$var$emissivemap_pars_fragment,
    colorspace_fragment: $d5b33d7c30034067$var$colorspace_fragment,
    colorspace_pars_fragment: $d5b33d7c30034067$var$colorspace_pars_fragment,
    envmap_fragment: $d5b33d7c30034067$var$envmap_fragment,
    envmap_common_pars_fragment: $d5b33d7c30034067$var$envmap_common_pars_fragment,
    envmap_pars_fragment: $d5b33d7c30034067$var$envmap_pars_fragment,
    envmap_pars_vertex: $d5b33d7c30034067$var$envmap_pars_vertex,
    envmap_physical_pars_fragment: $d5b33d7c30034067$var$envmap_physical_pars_fragment,
    envmap_vertex: $d5b33d7c30034067$var$envmap_vertex,
    fog_vertex: $d5b33d7c30034067$var$fog_vertex,
    fog_pars_vertex: $d5b33d7c30034067$var$fog_pars_vertex,
    fog_fragment: $d5b33d7c30034067$var$fog_fragment,
    fog_pars_fragment: $d5b33d7c30034067$var$fog_pars_fragment,
    gradientmap_pars_fragment: $d5b33d7c30034067$var$gradientmap_pars_fragment,
    lightmap_pars_fragment: $d5b33d7c30034067$var$lightmap_pars_fragment,
    lights_lambert_fragment: $d5b33d7c30034067$var$lights_lambert_fragment,
    lights_lambert_pars_fragment: $d5b33d7c30034067$var$lights_lambert_pars_fragment,
    lights_pars_begin: $d5b33d7c30034067$var$lights_pars_begin,
    lights_toon_fragment: $d5b33d7c30034067$var$lights_toon_fragment,
    lights_toon_pars_fragment: $d5b33d7c30034067$var$lights_toon_pars_fragment,
    lights_phong_fragment: $d5b33d7c30034067$var$lights_phong_fragment,
    lights_phong_pars_fragment: $d5b33d7c30034067$var$lights_phong_pars_fragment,
    lights_physical_fragment: $d5b33d7c30034067$var$lights_physical_fragment,
    lights_physical_pars_fragment: $d5b33d7c30034067$var$lights_physical_pars_fragment,
    lights_fragment_begin: $d5b33d7c30034067$var$lights_fragment_begin,
    lights_fragment_maps: $d5b33d7c30034067$var$lights_fragment_maps,
    lights_fragment_end: $d5b33d7c30034067$var$lights_fragment_end,
    logdepthbuf_fragment: $d5b33d7c30034067$var$logdepthbuf_fragment,
    logdepthbuf_pars_fragment: $d5b33d7c30034067$var$logdepthbuf_pars_fragment,
    logdepthbuf_pars_vertex: $d5b33d7c30034067$var$logdepthbuf_pars_vertex,
    logdepthbuf_vertex: $d5b33d7c30034067$var$logdepthbuf_vertex,
    map_fragment: $d5b33d7c30034067$var$map_fragment,
    map_pars_fragment: $d5b33d7c30034067$var$map_pars_fragment,
    map_particle_fragment: $d5b33d7c30034067$var$map_particle_fragment,
    map_particle_pars_fragment: $d5b33d7c30034067$var$map_particle_pars_fragment,
    metalnessmap_fragment: $d5b33d7c30034067$var$metalnessmap_fragment,
    metalnessmap_pars_fragment: $d5b33d7c30034067$var$metalnessmap_pars_fragment,
    morphinstance_vertex: $d5b33d7c30034067$var$morphinstance_vertex,
    morphcolor_vertex: $d5b33d7c30034067$var$morphcolor_vertex,
    morphnormal_vertex: $d5b33d7c30034067$var$morphnormal_vertex,
    morphtarget_pars_vertex: $d5b33d7c30034067$var$morphtarget_pars_vertex,
    morphtarget_vertex: $d5b33d7c30034067$var$morphtarget_vertex,
    normal_fragment_begin: $d5b33d7c30034067$var$normal_fragment_begin,
    normal_fragment_maps: $d5b33d7c30034067$var$normal_fragment_maps,
    normal_pars_fragment: $d5b33d7c30034067$var$normal_pars_fragment,
    normal_pars_vertex: $d5b33d7c30034067$var$normal_pars_vertex,
    normal_vertex: $d5b33d7c30034067$var$normal_vertex,
    normalmap_pars_fragment: $d5b33d7c30034067$var$normalmap_pars_fragment,
    clearcoat_normal_fragment_begin: $d5b33d7c30034067$var$clearcoat_normal_fragment_begin,
    clearcoat_normal_fragment_maps: $d5b33d7c30034067$var$clearcoat_normal_fragment_maps,
    clearcoat_pars_fragment: $d5b33d7c30034067$var$clearcoat_pars_fragment,
    iridescence_pars_fragment: $d5b33d7c30034067$var$iridescence_pars_fragment,
    opaque_fragment: $d5b33d7c30034067$var$opaque_fragment,
    packing: $d5b33d7c30034067$var$packing,
    premultiplied_alpha_fragment: $d5b33d7c30034067$var$premultiplied_alpha_fragment,
    project_vertex: $d5b33d7c30034067$var$project_vertex,
    dithering_fragment: $d5b33d7c30034067$var$dithering_fragment,
    dithering_pars_fragment: $d5b33d7c30034067$var$dithering_pars_fragment,
    roughnessmap_fragment: $d5b33d7c30034067$var$roughnessmap_fragment,
    roughnessmap_pars_fragment: $d5b33d7c30034067$var$roughnessmap_pars_fragment,
    shadowmap_pars_fragment: $d5b33d7c30034067$var$shadowmap_pars_fragment,
    shadowmap_pars_vertex: $d5b33d7c30034067$var$shadowmap_pars_vertex,
    shadowmap_vertex: $d5b33d7c30034067$var$shadowmap_vertex,
    shadowmask_pars_fragment: $d5b33d7c30034067$var$shadowmask_pars_fragment,
    skinbase_vertex: $d5b33d7c30034067$var$skinbase_vertex,
    skinning_pars_vertex: $d5b33d7c30034067$var$skinning_pars_vertex,
    skinning_vertex: $d5b33d7c30034067$var$skinning_vertex,
    skinnormal_vertex: $d5b33d7c30034067$var$skinnormal_vertex,
    specularmap_fragment: $d5b33d7c30034067$var$specularmap_fragment,
    specularmap_pars_fragment: $d5b33d7c30034067$var$specularmap_pars_fragment,
    tonemapping_fragment: $d5b33d7c30034067$var$tonemapping_fragment,
    tonemapping_pars_fragment: $d5b33d7c30034067$var$tonemapping_pars_fragment,
    transmission_fragment: $d5b33d7c30034067$var$transmission_fragment,
    transmission_pars_fragment: $d5b33d7c30034067$var$transmission_pars_fragment,
    uv_pars_fragment: $d5b33d7c30034067$var$uv_pars_fragment,
    uv_pars_vertex: $d5b33d7c30034067$var$uv_pars_vertex,
    uv_vertex: $d5b33d7c30034067$var$uv_vertex,
    worldpos_vertex: $d5b33d7c30034067$var$worldpos_vertex,
    background_vert: $d5b33d7c30034067$var$vertex$h,
    background_frag: $d5b33d7c30034067$var$fragment$h,
    backgroundCube_vert: $d5b33d7c30034067$var$vertex$g,
    backgroundCube_frag: $d5b33d7c30034067$var$fragment$g,
    cube_vert: $d5b33d7c30034067$var$vertex$f,
    cube_frag: $d5b33d7c30034067$var$fragment$f,
    depth_vert: $d5b33d7c30034067$var$vertex$e,
    depth_frag: $d5b33d7c30034067$var$fragment$e,
    distanceRGBA_vert: $d5b33d7c30034067$var$vertex$d,
    distanceRGBA_frag: $d5b33d7c30034067$var$fragment$d,
    equirect_vert: $d5b33d7c30034067$var$vertex$c,
    equirect_frag: $d5b33d7c30034067$var$fragment$c,
    linedashed_vert: $d5b33d7c30034067$var$vertex$b,
    linedashed_frag: $d5b33d7c30034067$var$fragment$b,
    meshbasic_vert: $d5b33d7c30034067$var$vertex$a,
    meshbasic_frag: $d5b33d7c30034067$var$fragment$a,
    meshlambert_vert: $d5b33d7c30034067$var$vertex$9,
    meshlambert_frag: $d5b33d7c30034067$var$fragment$9,
    meshmatcap_vert: $d5b33d7c30034067$var$vertex$8,
    meshmatcap_frag: $d5b33d7c30034067$var$fragment$8,
    meshnormal_vert: $d5b33d7c30034067$var$vertex$7,
    meshnormal_frag: $d5b33d7c30034067$var$fragment$7,
    meshphong_vert: $d5b33d7c30034067$var$vertex$6,
    meshphong_frag: $d5b33d7c30034067$var$fragment$6,
    meshphysical_vert: $d5b33d7c30034067$var$vertex$5,
    meshphysical_frag: $d5b33d7c30034067$var$fragment$5,
    meshtoon_vert: $d5b33d7c30034067$var$vertex$4,
    meshtoon_frag: $d5b33d7c30034067$var$fragment$4,
    points_vert: $d5b33d7c30034067$var$vertex$3,
    points_frag: $d5b33d7c30034067$var$fragment$3,
    shadow_vert: $d5b33d7c30034067$var$vertex$2,
    shadow_frag: $d5b33d7c30034067$var$fragment$2,
    sprite_vert: $d5b33d7c30034067$var$vertex$1,
    sprite_frag: $d5b33d7c30034067$var$fragment$1
};
/**
 * Uniforms library for shared webgl shaders
 */ const $d5b33d7c30034067$export$6643083551874bf5 = {
    common: {
        diffuse: {
            value: /*@__PURE__*/ new $d5b33d7c30034067$export$892596cec99bc70e(0xffffff)
        },
        opacity: {
            value: 1.0
        },
        map: {
            value: null
        },
        mapTransform: {
            value: /*@__PURE__*/ new $d5b33d7c30034067$export$8ff26dafa08918()
        },
        alphaMap: {
            value: null
        },
        alphaMapTransform: {
            value: /*@__PURE__*/ new $d5b33d7c30034067$export$8ff26dafa08918()
        },
        alphaTest: {
            value: 0
        }
    },
    specularmap: {
        specularMap: {
            value: null
        },
        specularMapTransform: {
            value: /*@__PURE__*/ new $d5b33d7c30034067$export$8ff26dafa08918()
        }
    },
    envmap: {
        envMap: {
            value: null
        },
        envMapRotation: {
            value: /*@__PURE__*/ new $d5b33d7c30034067$export$8ff26dafa08918()
        },
        flipEnvMap: {
            value: -1
        },
        reflectivity: {
            value: 1.0
        },
        ior: {
            value: 1.5
        },
        refractionRatio: {
            value: 0.98
        }
    },
    aomap: {
        aoMap: {
            value: null
        },
        aoMapIntensity: {
            value: 1
        },
        aoMapTransform: {
            value: /*@__PURE__*/ new $d5b33d7c30034067$export$8ff26dafa08918()
        }
    },
    lightmap: {
        lightMap: {
            value: null
        },
        lightMapIntensity: {
            value: 1
        },
        lightMapTransform: {
            value: /*@__PURE__*/ new $d5b33d7c30034067$export$8ff26dafa08918()
        }
    },
    bumpmap: {
        bumpMap: {
            value: null
        },
        bumpMapTransform: {
            value: /*@__PURE__*/ new $d5b33d7c30034067$export$8ff26dafa08918()
        },
        bumpScale: {
            value: 1
        }
    },
    normalmap: {
        normalMap: {
            value: null
        },
        normalMapTransform: {
            value: /*@__PURE__*/ new $d5b33d7c30034067$export$8ff26dafa08918()
        },
        normalScale: {
            value: /*@__PURE__*/ new $d5b33d7c30034067$export$c977b3e384af9ae1(1, 1)
        }
    },
    displacementmap: {
        displacementMap: {
            value: null
        },
        displacementMapTransform: {
            value: /*@__PURE__*/ new $d5b33d7c30034067$export$8ff26dafa08918()
        },
        displacementScale: {
            value: 1
        },
        displacementBias: {
            value: 0
        }
    },
    emissivemap: {
        emissiveMap: {
            value: null
        },
        emissiveMapTransform: {
            value: /*@__PURE__*/ new $d5b33d7c30034067$export$8ff26dafa08918()
        }
    },
    metalnessmap: {
        metalnessMap: {
            value: null
        },
        metalnessMapTransform: {
            value: /*@__PURE__*/ new $d5b33d7c30034067$export$8ff26dafa08918()
        }
    },
    roughnessmap: {
        roughnessMap: {
            value: null
        },
        roughnessMapTransform: {
            value: /*@__PURE__*/ new $d5b33d7c30034067$export$8ff26dafa08918()
        }
    },
    gradientmap: {
        gradientMap: {
            value: null
        }
    },
    fog: {
        fogDensity: {
            value: 0.00025
        },
        fogNear: {
            value: 1
        },
        fogFar: {
            value: 2000
        },
        fogColor: {
            value: /*@__PURE__*/ new $d5b33d7c30034067$export$892596cec99bc70e(0xffffff)
        }
    },
    lights: {
        ambientLightColor: {
            value: []
        },
        lightProbe: {
            value: []
        },
        directionalLights: {
            value: [],
            properties: {
                direction: {},
                color: {}
            }
        },
        directionalLightShadows: {
            value: [],
            properties: {
                shadowIntensity: 1,
                shadowBias: {},
                shadowNormalBias: {},
                shadowRadius: {},
                shadowMapSize: {}
            }
        },
        directionalShadowMap: {
            value: []
        },
        directionalShadowMatrix: {
            value: []
        },
        spotLights: {
            value: [],
            properties: {
                color: {},
                position: {},
                direction: {},
                distance: {},
                coneCos: {},
                penumbraCos: {},
                decay: {}
            }
        },
        spotLightShadows: {
            value: [],
            properties: {
                shadowIntensity: 1,
                shadowBias: {},
                shadowNormalBias: {},
                shadowRadius: {},
                shadowMapSize: {}
            }
        },
        spotLightMap: {
            value: []
        },
        spotShadowMap: {
            value: []
        },
        spotLightMatrix: {
            value: []
        },
        pointLights: {
            value: [],
            properties: {
                color: {},
                position: {},
                decay: {},
                distance: {}
            }
        },
        pointLightShadows: {
            value: [],
            properties: {
                shadowIntensity: 1,
                shadowBias: {},
                shadowNormalBias: {},
                shadowRadius: {},
                shadowMapSize: {},
                shadowCameraNear: {},
                shadowCameraFar: {}
            }
        },
        pointShadowMap: {
            value: []
        },
        pointShadowMatrix: {
            value: []
        },
        hemisphereLights: {
            value: [],
            properties: {
                direction: {},
                skyColor: {},
                groundColor: {}
            }
        },
        // TODO (abelnation): RectAreaLight BRDF data needs to be moved from example to main src
        rectAreaLights: {
            value: [],
            properties: {
                color: {},
                position: {},
                width: {},
                height: {}
            }
        },
        ltc_1: {
            value: null
        },
        ltc_2: {
            value: null
        }
    },
    points: {
        diffuse: {
            value: /*@__PURE__*/ new $d5b33d7c30034067$export$892596cec99bc70e(0xffffff)
        },
        opacity: {
            value: 1.0
        },
        size: {
            value: 1.0
        },
        scale: {
            value: 1.0
        },
        map: {
            value: null
        },
        alphaMap: {
            value: null
        },
        alphaMapTransform: {
            value: /*@__PURE__*/ new $d5b33d7c30034067$export$8ff26dafa08918()
        },
        alphaTest: {
            value: 0
        },
        uvTransform: {
            value: /*@__PURE__*/ new $d5b33d7c30034067$export$8ff26dafa08918()
        }
    },
    sprite: {
        diffuse: {
            value: /*@__PURE__*/ new $d5b33d7c30034067$export$892596cec99bc70e(0xffffff)
        },
        opacity: {
            value: 1.0
        },
        center: {
            value: /*@__PURE__*/ new $d5b33d7c30034067$export$c977b3e384af9ae1(0.5, 0.5)
        },
        rotation: {
            value: 0.0
        },
        map: {
            value: null
        },
        mapTransform: {
            value: /*@__PURE__*/ new $d5b33d7c30034067$export$8ff26dafa08918()
        },
        alphaMap: {
            value: null
        },
        alphaMapTransform: {
            value: /*@__PURE__*/ new $d5b33d7c30034067$export$8ff26dafa08918()
        },
        alphaTest: {
            value: 0
        }
    }
};
const $d5b33d7c30034067$export$bee4a7d47f8f5014 = {
    basic: {
        uniforms: /*@__PURE__*/ $d5b33d7c30034067$var$mergeUniforms([
            $d5b33d7c30034067$export$6643083551874bf5.common,
            $d5b33d7c30034067$export$6643083551874bf5.specularmap,
            $d5b33d7c30034067$export$6643083551874bf5.envmap,
            $d5b33d7c30034067$export$6643083551874bf5.aomap,
            $d5b33d7c30034067$export$6643083551874bf5.lightmap,
            $d5b33d7c30034067$export$6643083551874bf5.fog
        ]),
        vertexShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.meshbasic_vert,
        fragmentShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.meshbasic_frag
    },
    lambert: {
        uniforms: /*@__PURE__*/ $d5b33d7c30034067$var$mergeUniforms([
            $d5b33d7c30034067$export$6643083551874bf5.common,
            $d5b33d7c30034067$export$6643083551874bf5.specularmap,
            $d5b33d7c30034067$export$6643083551874bf5.envmap,
            $d5b33d7c30034067$export$6643083551874bf5.aomap,
            $d5b33d7c30034067$export$6643083551874bf5.lightmap,
            $d5b33d7c30034067$export$6643083551874bf5.emissivemap,
            $d5b33d7c30034067$export$6643083551874bf5.bumpmap,
            $d5b33d7c30034067$export$6643083551874bf5.normalmap,
            $d5b33d7c30034067$export$6643083551874bf5.displacementmap,
            $d5b33d7c30034067$export$6643083551874bf5.fog,
            $d5b33d7c30034067$export$6643083551874bf5.lights,
            {
                emissive: {
                    value: /*@__PURE__*/ new $d5b33d7c30034067$export$892596cec99bc70e(0x000000)
                }
            }
        ]),
        vertexShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.meshlambert_vert,
        fragmentShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.meshlambert_frag
    },
    phong: {
        uniforms: /*@__PURE__*/ $d5b33d7c30034067$var$mergeUniforms([
            $d5b33d7c30034067$export$6643083551874bf5.common,
            $d5b33d7c30034067$export$6643083551874bf5.specularmap,
            $d5b33d7c30034067$export$6643083551874bf5.envmap,
            $d5b33d7c30034067$export$6643083551874bf5.aomap,
            $d5b33d7c30034067$export$6643083551874bf5.lightmap,
            $d5b33d7c30034067$export$6643083551874bf5.emissivemap,
            $d5b33d7c30034067$export$6643083551874bf5.bumpmap,
            $d5b33d7c30034067$export$6643083551874bf5.normalmap,
            $d5b33d7c30034067$export$6643083551874bf5.displacementmap,
            $d5b33d7c30034067$export$6643083551874bf5.fog,
            $d5b33d7c30034067$export$6643083551874bf5.lights,
            {
                emissive: {
                    value: /*@__PURE__*/ new $d5b33d7c30034067$export$892596cec99bc70e(0x000000)
                },
                specular: {
                    value: /*@__PURE__*/ new $d5b33d7c30034067$export$892596cec99bc70e(0x111111)
                },
                shininess: {
                    value: 30
                }
            }
        ]),
        vertexShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.meshphong_vert,
        fragmentShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.meshphong_frag
    },
    standard: {
        uniforms: /*@__PURE__*/ $d5b33d7c30034067$var$mergeUniforms([
            $d5b33d7c30034067$export$6643083551874bf5.common,
            $d5b33d7c30034067$export$6643083551874bf5.envmap,
            $d5b33d7c30034067$export$6643083551874bf5.aomap,
            $d5b33d7c30034067$export$6643083551874bf5.lightmap,
            $d5b33d7c30034067$export$6643083551874bf5.emissivemap,
            $d5b33d7c30034067$export$6643083551874bf5.bumpmap,
            $d5b33d7c30034067$export$6643083551874bf5.normalmap,
            $d5b33d7c30034067$export$6643083551874bf5.displacementmap,
            $d5b33d7c30034067$export$6643083551874bf5.roughnessmap,
            $d5b33d7c30034067$export$6643083551874bf5.metalnessmap,
            $d5b33d7c30034067$export$6643083551874bf5.fog,
            $d5b33d7c30034067$export$6643083551874bf5.lights,
            {
                emissive: {
                    value: /*@__PURE__*/ new $d5b33d7c30034067$export$892596cec99bc70e(0x000000)
                },
                roughness: {
                    value: 1.0
                },
                metalness: {
                    value: 0.0
                },
                envMapIntensity: {
                    value: 1
                }
            }
        ]),
        vertexShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.meshphysical_vert,
        fragmentShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.meshphysical_frag
    },
    toon: {
        uniforms: /*@__PURE__*/ $d5b33d7c30034067$var$mergeUniforms([
            $d5b33d7c30034067$export$6643083551874bf5.common,
            $d5b33d7c30034067$export$6643083551874bf5.aomap,
            $d5b33d7c30034067$export$6643083551874bf5.lightmap,
            $d5b33d7c30034067$export$6643083551874bf5.emissivemap,
            $d5b33d7c30034067$export$6643083551874bf5.bumpmap,
            $d5b33d7c30034067$export$6643083551874bf5.normalmap,
            $d5b33d7c30034067$export$6643083551874bf5.displacementmap,
            $d5b33d7c30034067$export$6643083551874bf5.gradientmap,
            $d5b33d7c30034067$export$6643083551874bf5.fog,
            $d5b33d7c30034067$export$6643083551874bf5.lights,
            {
                emissive: {
                    value: /*@__PURE__*/ new $d5b33d7c30034067$export$892596cec99bc70e(0x000000)
                }
            }
        ]),
        vertexShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.meshtoon_vert,
        fragmentShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.meshtoon_frag
    },
    matcap: {
        uniforms: /*@__PURE__*/ $d5b33d7c30034067$var$mergeUniforms([
            $d5b33d7c30034067$export$6643083551874bf5.common,
            $d5b33d7c30034067$export$6643083551874bf5.bumpmap,
            $d5b33d7c30034067$export$6643083551874bf5.normalmap,
            $d5b33d7c30034067$export$6643083551874bf5.displacementmap,
            $d5b33d7c30034067$export$6643083551874bf5.fog,
            {
                matcap: {
                    value: null
                }
            }
        ]),
        vertexShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.meshmatcap_vert,
        fragmentShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.meshmatcap_frag
    },
    points: {
        uniforms: /*@__PURE__*/ $d5b33d7c30034067$var$mergeUniforms([
            $d5b33d7c30034067$export$6643083551874bf5.points,
            $d5b33d7c30034067$export$6643083551874bf5.fog
        ]),
        vertexShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.points_vert,
        fragmentShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.points_frag
    },
    dashed: {
        uniforms: /*@__PURE__*/ $d5b33d7c30034067$var$mergeUniforms([
            $d5b33d7c30034067$export$6643083551874bf5.common,
            $d5b33d7c30034067$export$6643083551874bf5.fog,
            {
                scale: {
                    value: 1
                },
                dashSize: {
                    value: 1
                },
                totalSize: {
                    value: 2
                }
            }
        ]),
        vertexShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.linedashed_vert,
        fragmentShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.linedashed_frag
    },
    depth: {
        uniforms: /*@__PURE__*/ $d5b33d7c30034067$var$mergeUniforms([
            $d5b33d7c30034067$export$6643083551874bf5.common,
            $d5b33d7c30034067$export$6643083551874bf5.displacementmap
        ]),
        vertexShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.depth_vert,
        fragmentShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.depth_frag
    },
    normal: {
        uniforms: /*@__PURE__*/ $d5b33d7c30034067$var$mergeUniforms([
            $d5b33d7c30034067$export$6643083551874bf5.common,
            $d5b33d7c30034067$export$6643083551874bf5.bumpmap,
            $d5b33d7c30034067$export$6643083551874bf5.normalmap,
            $d5b33d7c30034067$export$6643083551874bf5.displacementmap,
            {
                opacity: {
                    value: 1.0
                }
            }
        ]),
        vertexShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.meshnormal_vert,
        fragmentShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.meshnormal_frag
    },
    sprite: {
        uniforms: /*@__PURE__*/ $d5b33d7c30034067$var$mergeUniforms([
            $d5b33d7c30034067$export$6643083551874bf5.sprite,
            $d5b33d7c30034067$export$6643083551874bf5.fog
        ]),
        vertexShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.sprite_vert,
        fragmentShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.sprite_frag
    },
    background: {
        uniforms: {
            uvTransform: {
                value: /*@__PURE__*/ new $d5b33d7c30034067$export$8ff26dafa08918()
            },
            t2D: {
                value: null
            },
            backgroundIntensity: {
                value: 1
            }
        },
        vertexShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.background_vert,
        fragmentShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.background_frag
    },
    backgroundCube: {
        uniforms: {
            envMap: {
                value: null
            },
            flipEnvMap: {
                value: -1
            },
            backgroundBlurriness: {
                value: 0
            },
            backgroundIntensity: {
                value: 1
            },
            backgroundRotation: {
                value: /*@__PURE__*/ new $d5b33d7c30034067$export$8ff26dafa08918()
            }
        },
        vertexShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.backgroundCube_vert,
        fragmentShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.backgroundCube_frag
    },
    cube: {
        uniforms: {
            tCube: {
                value: null
            },
            tFlip: {
                value: -1
            },
            opacity: {
                value: 1.0
            }
        },
        vertexShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.cube_vert,
        fragmentShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.cube_frag
    },
    equirect: {
        uniforms: {
            tEquirect: {
                value: null
            }
        },
        vertexShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.equirect_vert,
        fragmentShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.equirect_frag
    },
    distanceRGBA: {
        uniforms: /*@__PURE__*/ $d5b33d7c30034067$var$mergeUniforms([
            $d5b33d7c30034067$export$6643083551874bf5.common,
            $d5b33d7c30034067$export$6643083551874bf5.displacementmap,
            {
                referencePosition: {
                    value: /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699()
                },
                nearDistance: {
                    value: 1
                },
                farDistance: {
                    value: 1000
                }
            }
        ]),
        vertexShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.distanceRGBA_vert,
        fragmentShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.distanceRGBA_frag
    },
    shadow: {
        uniforms: /*@__PURE__*/ $d5b33d7c30034067$var$mergeUniforms([
            $d5b33d7c30034067$export$6643083551874bf5.lights,
            $d5b33d7c30034067$export$6643083551874bf5.fog,
            {
                color: {
                    value: /*@__PURE__*/ new $d5b33d7c30034067$export$892596cec99bc70e(0x00000)
                },
                opacity: {
                    value: 1.0
                }
            }
        ]),
        vertexShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.shadow_vert,
        fragmentShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.shadow_frag
    }
};
$d5b33d7c30034067$export$bee4a7d47f8f5014.physical = {
    uniforms: /*@__PURE__*/ $d5b33d7c30034067$var$mergeUniforms([
        $d5b33d7c30034067$export$bee4a7d47f8f5014.standard.uniforms,
        {
            clearcoat: {
                value: 0
            },
            clearcoatMap: {
                value: null
            },
            clearcoatMapTransform: {
                value: /*@__PURE__*/ new $d5b33d7c30034067$export$8ff26dafa08918()
            },
            clearcoatNormalMap: {
                value: null
            },
            clearcoatNormalMapTransform: {
                value: /*@__PURE__*/ new $d5b33d7c30034067$export$8ff26dafa08918()
            },
            clearcoatNormalScale: {
                value: /*@__PURE__*/ new $d5b33d7c30034067$export$c977b3e384af9ae1(1, 1)
            },
            clearcoatRoughness: {
                value: 0
            },
            clearcoatRoughnessMap: {
                value: null
            },
            clearcoatRoughnessMapTransform: {
                value: /*@__PURE__*/ new $d5b33d7c30034067$export$8ff26dafa08918()
            },
            dispersion: {
                value: 0
            },
            iridescence: {
                value: 0
            },
            iridescenceMap: {
                value: null
            },
            iridescenceMapTransform: {
                value: /*@__PURE__*/ new $d5b33d7c30034067$export$8ff26dafa08918()
            },
            iridescenceIOR: {
                value: 1.3
            },
            iridescenceThicknessMinimum: {
                value: 100
            },
            iridescenceThicknessMaximum: {
                value: 400
            },
            iridescenceThicknessMap: {
                value: null
            },
            iridescenceThicknessMapTransform: {
                value: /*@__PURE__*/ new $d5b33d7c30034067$export$8ff26dafa08918()
            },
            sheen: {
                value: 0
            },
            sheenColor: {
                value: /*@__PURE__*/ new $d5b33d7c30034067$export$892596cec99bc70e(0x000000)
            },
            sheenColorMap: {
                value: null
            },
            sheenColorMapTransform: {
                value: /*@__PURE__*/ new $d5b33d7c30034067$export$8ff26dafa08918()
            },
            sheenRoughness: {
                value: 1
            },
            sheenRoughnessMap: {
                value: null
            },
            sheenRoughnessMapTransform: {
                value: /*@__PURE__*/ new $d5b33d7c30034067$export$8ff26dafa08918()
            },
            transmission: {
                value: 0
            },
            transmissionMap: {
                value: null
            },
            transmissionMapTransform: {
                value: /*@__PURE__*/ new $d5b33d7c30034067$export$8ff26dafa08918()
            },
            transmissionSamplerSize: {
                value: /*@__PURE__*/ new $d5b33d7c30034067$export$c977b3e384af9ae1()
            },
            transmissionSamplerMap: {
                value: null
            },
            thickness: {
                value: 0
            },
            thicknessMap: {
                value: null
            },
            thicknessMapTransform: {
                value: /*@__PURE__*/ new $d5b33d7c30034067$export$8ff26dafa08918()
            },
            attenuationDistance: {
                value: 0
            },
            attenuationColor: {
                value: /*@__PURE__*/ new $d5b33d7c30034067$export$892596cec99bc70e(0x000000)
            },
            specularColor: {
                value: /*@__PURE__*/ new $d5b33d7c30034067$export$892596cec99bc70e(1, 1, 1)
            },
            specularColorMap: {
                value: null
            },
            specularColorMapTransform: {
                value: /*@__PURE__*/ new $d5b33d7c30034067$export$8ff26dafa08918()
            },
            specularIntensity: {
                value: 1
            },
            specularIntensityMap: {
                value: null
            },
            specularIntensityMapTransform: {
                value: /*@__PURE__*/ new $d5b33d7c30034067$export$8ff26dafa08918()
            },
            anisotropyVector: {
                value: /*@__PURE__*/ new $d5b33d7c30034067$export$c977b3e384af9ae1()
            },
            anisotropyMap: {
                value: null
            },
            anisotropyMapTransform: {
                value: /*@__PURE__*/ new $d5b33d7c30034067$export$8ff26dafa08918()
            }
        }
    ]),
    vertexShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.meshphysical_vert,
    fragmentShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.meshphysical_frag
};
const $d5b33d7c30034067$var$_rgb = {
    r: 0,
    b: 0,
    g: 0
};
const $d5b33d7c30034067$var$_e1$1 = /*@__PURE__*/ new $d5b33d7c30034067$export$d93cc409a0768c5f();
const $d5b33d7c30034067$var$_m1$1 = /*@__PURE__*/ new $d5b33d7c30034067$export$2ae72fc923e5eb5();
function $d5b33d7c30034067$var$WebGLBackground(renderer, cubemaps, cubeuvmaps, state, objects, alpha, premultipliedAlpha) {
    const clearColor = new $d5b33d7c30034067$export$892596cec99bc70e(0x000000);
    let clearAlpha = alpha === true ? 0 : 1;
    let planeMesh;
    let boxMesh;
    let currentBackground = null;
    let currentBackgroundVersion = 0;
    let currentTonemapping = null;
    function getBackground(scene) {
        let background = scene.isScene === true ? scene.background : null;
        if (background && background.isTexture) {
            const usePMREM = scene.backgroundBlurriness > 0; // use PMREM if the user wants to blur the background
            background = (usePMREM ? cubeuvmaps : cubemaps).get(background);
        }
        return background;
    }
    function render(scene) {
        let forceClear = false;
        const background = getBackground(scene);
        if (background === null) setClear(clearColor, clearAlpha);
        else if (background && background.isColor) {
            setClear(background, 1);
            forceClear = true;
        }
        const environmentBlendMode = renderer.xr.getEnvironmentBlendMode();
        if (environmentBlendMode === 'additive') state.buffers.color.setClear(0, 0, 0, 1, premultipliedAlpha);
        else if (environmentBlendMode === 'alpha-blend') state.buffers.color.setClear(0, 0, 0, 0, premultipliedAlpha);
        if (renderer.autoClear || forceClear) {
            // buffers might not be writable which is required to ensure a correct clear
            state.buffers.depth.setTest(true);
            state.buffers.depth.setMask(true);
            state.buffers.color.setMask(true);
            renderer.clear(renderer.autoClearColor, renderer.autoClearDepth, renderer.autoClearStencil);
        }
    }
    function addToRenderList(renderList, scene) {
        const background = getBackground(scene);
        if (background && (background.isCubeTexture || background.mapping === $d5b33d7c30034067$export$dbf3e70ff37af79)) {
            if (boxMesh === undefined) {
                boxMesh = new $d5b33d7c30034067$export$e176487c05830cc5(new $d5b33d7c30034067$export$33e43285f7406bd5(1, 1, 1), new $d5b33d7c30034067$export$83c7d75d550a8b0d({
                    name: 'BackgroundCubeMaterial',
                    uniforms: $d5b33d7c30034067$var$cloneUniforms($d5b33d7c30034067$export$bee4a7d47f8f5014.backgroundCube.uniforms),
                    vertexShader: $d5b33d7c30034067$export$bee4a7d47f8f5014.backgroundCube.vertexShader,
                    fragmentShader: $d5b33d7c30034067$export$bee4a7d47f8f5014.backgroundCube.fragmentShader,
                    side: $d5b33d7c30034067$export$d9f0486e75b5ace,
                    depthTest: false,
                    depthWrite: false,
                    fog: false
                }));
                boxMesh.geometry.deleteAttribute('normal');
                boxMesh.geometry.deleteAttribute('uv');
                boxMesh.onBeforeRender = function(renderer, scene, camera) {
                    this.matrixWorld.copyPosition(camera.matrixWorld);
                };
                // add "envMap" material property so the renderer can evaluate it like for built-in materials
                Object.defineProperty(boxMesh.material, 'envMap', {
                    get: function() {
                        return this.uniforms.envMap.value;
                    }
                });
                objects.update(boxMesh);
            }
            $d5b33d7c30034067$var$_e1$1.copy(scene.backgroundRotation);
            // accommodate left-handed frame
            $d5b33d7c30034067$var$_e1$1.x *= -1;
            $d5b33d7c30034067$var$_e1$1.y *= -1;
            $d5b33d7c30034067$var$_e1$1.z *= -1;
            if (background.isCubeTexture && background.isRenderTargetTexture === false) {
                // environment maps which are not cube render targets or PMREMs follow a different convention
                $d5b33d7c30034067$var$_e1$1.y *= -1;
                $d5b33d7c30034067$var$_e1$1.z *= -1;
            }
            boxMesh.material.uniforms.envMap.value = background;
            boxMesh.material.uniforms.flipEnvMap.value = background.isCubeTexture && background.isRenderTargetTexture === false ? -1 : 1;
            boxMesh.material.uniforms.backgroundBlurriness.value = scene.backgroundBlurriness;
            boxMesh.material.uniforms.backgroundIntensity.value = scene.backgroundIntensity;
            boxMesh.material.uniforms.backgroundRotation.value.setFromMatrix4($d5b33d7c30034067$var$_m1$1.makeRotationFromEuler($d5b33d7c30034067$var$_e1$1));
            boxMesh.material.toneMapped = $d5b33d7c30034067$export$5e6fd513f44698c.getTransfer(background.colorSpace) !== $d5b33d7c30034067$export$8d0a61916cc26abb;
            if (currentBackground !== background || currentBackgroundVersion !== background.version || currentTonemapping !== renderer.toneMapping) {
                boxMesh.material.needsUpdate = true;
                currentBackground = background;
                currentBackgroundVersion = background.version;
                currentTonemapping = renderer.toneMapping;
            }
            boxMesh.layers.enableAll();
            // push to the pre-sorted opaque render list
            renderList.unshift(boxMesh, boxMesh.geometry, boxMesh.material, 0, 0, null);
        } else if (background && background.isTexture) {
            if (planeMesh === undefined) {
                planeMesh = new $d5b33d7c30034067$export$e176487c05830cc5(new $d5b33d7c30034067$export$967d831af31f69ce(2, 2), new $d5b33d7c30034067$export$83c7d75d550a8b0d({
                    name: 'BackgroundMaterial',
                    uniforms: $d5b33d7c30034067$var$cloneUniforms($d5b33d7c30034067$export$bee4a7d47f8f5014.background.uniforms),
                    vertexShader: $d5b33d7c30034067$export$bee4a7d47f8f5014.background.vertexShader,
                    fragmentShader: $d5b33d7c30034067$export$bee4a7d47f8f5014.background.fragmentShader,
                    side: $d5b33d7c30034067$export$2ede184fc2998901,
                    depthTest: false,
                    depthWrite: false,
                    fog: false
                }));
                planeMesh.geometry.deleteAttribute('normal');
                // add "map" material property so the renderer can evaluate it like for built-in materials
                Object.defineProperty(planeMesh.material, 'map', {
                    get: function() {
                        return this.uniforms.t2D.value;
                    }
                });
                objects.update(planeMesh);
            }
            planeMesh.material.uniforms.t2D.value = background;
            planeMesh.material.uniforms.backgroundIntensity.value = scene.backgroundIntensity;
            planeMesh.material.toneMapped = $d5b33d7c30034067$export$5e6fd513f44698c.getTransfer(background.colorSpace) !== $d5b33d7c30034067$export$8d0a61916cc26abb;
            if (background.matrixAutoUpdate === true) background.updateMatrix();
            planeMesh.material.uniforms.uvTransform.value.copy(background.matrix);
            if (currentBackground !== background || currentBackgroundVersion !== background.version || currentTonemapping !== renderer.toneMapping) {
                planeMesh.material.needsUpdate = true;
                currentBackground = background;
                currentBackgroundVersion = background.version;
                currentTonemapping = renderer.toneMapping;
            }
            planeMesh.layers.enableAll();
            // push to the pre-sorted opaque render list
            renderList.unshift(planeMesh, planeMesh.geometry, planeMesh.material, 0, 0, null);
        }
    }
    function setClear(color, alpha) {
        color.getRGB($d5b33d7c30034067$var$_rgb, $d5b33d7c30034067$var$getUnlitUniformColorSpace(renderer));
        state.buffers.color.setClear($d5b33d7c30034067$var$_rgb.r, $d5b33d7c30034067$var$_rgb.g, $d5b33d7c30034067$var$_rgb.b, alpha, premultipliedAlpha);
    }
    return {
        getClearColor: function() {
            return clearColor;
        },
        setClearColor: function(color, alpha = 1) {
            clearColor.set(color);
            clearAlpha = alpha;
            setClear(clearColor, clearAlpha);
        },
        getClearAlpha: function() {
            return clearAlpha;
        },
        setClearAlpha: function(alpha) {
            clearAlpha = alpha;
            setClear(clearColor, clearAlpha);
        },
        render: render,
        addToRenderList: addToRenderList
    };
}
function $d5b33d7c30034067$var$WebGLBindingStates(gl, attributes) {
    const maxVertexAttributes = gl.getParameter(gl.MAX_VERTEX_ATTRIBS);
    const bindingStates = {};
    const defaultState = createBindingState(null);
    let currentState = defaultState;
    let forceUpdate = false;
    function setup(object, material, program, geometry, index) {
        let updateBuffers = false;
        const state = getBindingState(geometry, program, material);
        if (currentState !== state) {
            currentState = state;
            bindVertexArrayObject(currentState.object);
        }
        updateBuffers = needsUpdate(object, geometry, program, index);
        if (updateBuffers) saveCache(object, geometry, program, index);
        if (index !== null) attributes.update(index, gl.ELEMENT_ARRAY_BUFFER);
        if (updateBuffers || forceUpdate) {
            forceUpdate = false;
            setupVertexAttributes(object, material, program, geometry);
            if (index !== null) gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, attributes.get(index).buffer);
        }
    }
    function createVertexArrayObject() {
        return gl.createVertexArray();
    }
    function bindVertexArrayObject(vao) {
        return gl.bindVertexArray(vao);
    }
    function deleteVertexArrayObject(vao) {
        return gl.deleteVertexArray(vao);
    }
    function getBindingState(geometry, program, material) {
        const wireframe = material.wireframe === true;
        let programMap = bindingStates[geometry.id];
        if (programMap === undefined) {
            programMap = {};
            bindingStates[geometry.id] = programMap;
        }
        let stateMap = programMap[program.id];
        if (stateMap === undefined) {
            stateMap = {};
            programMap[program.id] = stateMap;
        }
        let state = stateMap[wireframe];
        if (state === undefined) {
            state = createBindingState(createVertexArrayObject());
            stateMap[wireframe] = state;
        }
        return state;
    }
    function createBindingState(vao) {
        const newAttributes = [];
        const enabledAttributes = [];
        const attributeDivisors = [];
        for(let i = 0; i < maxVertexAttributes; i++){
            newAttributes[i] = 0;
            enabledAttributes[i] = 0;
            attributeDivisors[i] = 0;
        }
        return {
            // for backward compatibility on non-VAO support browser
            geometry: null,
            program: null,
            wireframe: false,
            newAttributes: newAttributes,
            enabledAttributes: enabledAttributes,
            attributeDivisors: attributeDivisors,
            object: vao,
            attributes: {},
            index: null
        };
    }
    function needsUpdate(object, geometry, program, index) {
        const cachedAttributes = currentState.attributes;
        const geometryAttributes = geometry.attributes;
        let attributesNum = 0;
        const programAttributes = program.getAttributes();
        for(const name in programAttributes){
            const programAttribute = programAttributes[name];
            if (programAttribute.location >= 0) {
                const cachedAttribute = cachedAttributes[name];
                let geometryAttribute = geometryAttributes[name];
                if (geometryAttribute === undefined) {
                    if (name === 'instanceMatrix' && object.instanceMatrix) geometryAttribute = object.instanceMatrix;
                    if (name === 'instanceColor' && object.instanceColor) geometryAttribute = object.instanceColor;
                }
                if (cachedAttribute === undefined) return true;
                if (cachedAttribute.attribute !== geometryAttribute) return true;
                if (geometryAttribute && cachedAttribute.data !== geometryAttribute.data) return true;
                attributesNum++;
            }
        }
        if (currentState.attributesNum !== attributesNum) return true;
        if (currentState.index !== index) return true;
        return false;
    }
    function saveCache(object, geometry, program, index) {
        const cache = {};
        const attributes = geometry.attributes;
        let attributesNum = 0;
        const programAttributes = program.getAttributes();
        for(const name in programAttributes){
            const programAttribute = programAttributes[name];
            if (programAttribute.location >= 0) {
                let attribute = attributes[name];
                if (attribute === undefined) {
                    if (name === 'instanceMatrix' && object.instanceMatrix) attribute = object.instanceMatrix;
                    if (name === 'instanceColor' && object.instanceColor) attribute = object.instanceColor;
                }
                const data = {};
                data.attribute = attribute;
                if (attribute && attribute.data) data.data = attribute.data;
                cache[name] = data;
                attributesNum++;
            }
        }
        currentState.attributes = cache;
        currentState.attributesNum = attributesNum;
        currentState.index = index;
    }
    function initAttributes() {
        const newAttributes = currentState.newAttributes;
        for(let i = 0, il = newAttributes.length; i < il; i++)newAttributes[i] = 0;
    }
    function enableAttribute(attribute) {
        enableAttributeAndDivisor(attribute, 0);
    }
    function enableAttributeAndDivisor(attribute, meshPerAttribute) {
        const newAttributes = currentState.newAttributes;
        const enabledAttributes = currentState.enabledAttributes;
        const attributeDivisors = currentState.attributeDivisors;
        newAttributes[attribute] = 1;
        if (enabledAttributes[attribute] === 0) {
            gl.enableVertexAttribArray(attribute);
            enabledAttributes[attribute] = 1;
        }
        if (attributeDivisors[attribute] !== meshPerAttribute) {
            gl.vertexAttribDivisor(attribute, meshPerAttribute);
            attributeDivisors[attribute] = meshPerAttribute;
        }
    }
    function disableUnusedAttributes() {
        const newAttributes = currentState.newAttributes;
        const enabledAttributes = currentState.enabledAttributes;
        for(let i = 0, il = enabledAttributes.length; i < il; i++)if (enabledAttributes[i] !== newAttributes[i]) {
            gl.disableVertexAttribArray(i);
            enabledAttributes[i] = 0;
        }
    }
    function vertexAttribPointer(index, size, type, normalized, stride, offset, integer) {
        if (integer === true) gl.vertexAttribIPointer(index, size, type, stride, offset);
        else gl.vertexAttribPointer(index, size, type, normalized, stride, offset);
    }
    function setupVertexAttributes(object, material, program, geometry) {
        initAttributes();
        const geometryAttributes = geometry.attributes;
        const programAttributes = program.getAttributes();
        const materialDefaultAttributeValues = material.defaultAttributeValues;
        for(const name in programAttributes){
            const programAttribute = programAttributes[name];
            if (programAttribute.location >= 0) {
                let geometryAttribute = geometryAttributes[name];
                if (geometryAttribute === undefined) {
                    if (name === 'instanceMatrix' && object.instanceMatrix) geometryAttribute = object.instanceMatrix;
                    if (name === 'instanceColor' && object.instanceColor) geometryAttribute = object.instanceColor;
                }
                if (geometryAttribute !== undefined) {
                    const normalized = geometryAttribute.normalized;
                    const size = geometryAttribute.itemSize;
                    const attribute = attributes.get(geometryAttribute);
                    // TODO Attribute may not be available on context restore
                    if (attribute === undefined) continue;
                    const buffer = attribute.buffer;
                    const type = attribute.type;
                    const bytesPerElement = attribute.bytesPerElement;
                    // check for integer attributes
                    const integer = type === gl.INT || type === gl.UNSIGNED_INT || geometryAttribute.gpuType === $d5b33d7c30034067$export$5c612977753abe2;
                    if (geometryAttribute.isInterleavedBufferAttribute) {
                        const data = geometryAttribute.data;
                        const stride = data.stride;
                        const offset = geometryAttribute.offset;
                        if (data.isInstancedInterleavedBuffer) {
                            for(let i = 0; i < programAttribute.locationSize; i++)enableAttributeAndDivisor(programAttribute.location + i, data.meshPerAttribute);
                            if (object.isInstancedMesh !== true && geometry._maxInstanceCount === undefined) geometry._maxInstanceCount = data.meshPerAttribute * data.count;
                        } else for(let i = 0; i < programAttribute.locationSize; i++)enableAttribute(programAttribute.location + i);
                        gl.bindBuffer(gl.ARRAY_BUFFER, buffer);
                        for(let i = 0; i < programAttribute.locationSize; i++)vertexAttribPointer(programAttribute.location + i, size / programAttribute.locationSize, type, normalized, stride * bytesPerElement, (offset + size / programAttribute.locationSize * i) * bytesPerElement, integer);
                    } else {
                        if (geometryAttribute.isInstancedBufferAttribute) {
                            for(let i = 0; i < programAttribute.locationSize; i++)enableAttributeAndDivisor(programAttribute.location + i, geometryAttribute.meshPerAttribute);
                            if (object.isInstancedMesh !== true && geometry._maxInstanceCount === undefined) geometry._maxInstanceCount = geometryAttribute.meshPerAttribute * geometryAttribute.count;
                        } else for(let i = 0; i < programAttribute.locationSize; i++)enableAttribute(programAttribute.location + i);
                        gl.bindBuffer(gl.ARRAY_BUFFER, buffer);
                        for(let i = 0; i < programAttribute.locationSize; i++)vertexAttribPointer(programAttribute.location + i, size / programAttribute.locationSize, type, normalized, size * bytesPerElement, size / programAttribute.locationSize * i * bytesPerElement, integer);
                    }
                } else if (materialDefaultAttributeValues !== undefined) {
                    const value = materialDefaultAttributeValues[name];
                    if (value !== undefined) switch(value.length){
                        case 2:
                            gl.vertexAttrib2fv(programAttribute.location, value);
                            break;
                        case 3:
                            gl.vertexAttrib3fv(programAttribute.location, value);
                            break;
                        case 4:
                            gl.vertexAttrib4fv(programAttribute.location, value);
                            break;
                        default:
                            gl.vertexAttrib1fv(programAttribute.location, value);
                    }
                }
            }
        }
        disableUnusedAttributes();
    }
    function dispose() {
        reset();
        for(const geometryId in bindingStates){
            const programMap = bindingStates[geometryId];
            for(const programId in programMap){
                const stateMap = programMap[programId];
                for(const wireframe in stateMap){
                    deleteVertexArrayObject(stateMap[wireframe].object);
                    delete stateMap[wireframe];
                }
                delete programMap[programId];
            }
            delete bindingStates[geometryId];
        }
    }
    function releaseStatesOfGeometry(geometry) {
        if (bindingStates[geometry.id] === undefined) return;
        const programMap = bindingStates[geometry.id];
        for(const programId in programMap){
            const stateMap = programMap[programId];
            for(const wireframe in stateMap){
                deleteVertexArrayObject(stateMap[wireframe].object);
                delete stateMap[wireframe];
            }
            delete programMap[programId];
        }
        delete bindingStates[geometry.id];
    }
    function releaseStatesOfProgram(program) {
        for(const geometryId in bindingStates){
            const programMap = bindingStates[geometryId];
            if (programMap[program.id] === undefined) continue;
            const stateMap = programMap[program.id];
            for(const wireframe in stateMap){
                deleteVertexArrayObject(stateMap[wireframe].object);
                delete stateMap[wireframe];
            }
            delete programMap[program.id];
        }
    }
    function reset() {
        resetDefaultState();
        forceUpdate = true;
        if (currentState === defaultState) return;
        currentState = defaultState;
        bindVertexArrayObject(currentState.object);
    }
    // for backward-compatibility
    function resetDefaultState() {
        defaultState.geometry = null;
        defaultState.program = null;
        defaultState.wireframe = false;
    }
    return {
        setup: setup,
        reset: reset,
        resetDefaultState: resetDefaultState,
        dispose: dispose,
        releaseStatesOfGeometry: releaseStatesOfGeometry,
        releaseStatesOfProgram: releaseStatesOfProgram,
        initAttributes: initAttributes,
        enableAttribute: enableAttribute,
        disableUnusedAttributes: disableUnusedAttributes
    };
}
function $d5b33d7c30034067$var$WebGLBufferRenderer(gl, extensions, info) {
    let mode;
    function setMode(value) {
        mode = value;
    }
    function render(start, count) {
        gl.drawArrays(mode, start, count);
        info.update(count, mode, 1);
    }
    function renderInstances(start, count, primcount) {
        if (primcount === 0) return;
        gl.drawArraysInstanced(mode, start, count, primcount);
        info.update(count, mode, primcount);
    }
    function renderMultiDraw(starts, counts, drawCount) {
        if (drawCount === 0) return;
        const extension = extensions.get('WEBGL_multi_draw');
        extension.multiDrawArraysWEBGL(mode, starts, 0, counts, 0, drawCount);
        let elementCount = 0;
        for(let i = 0; i < drawCount; i++)elementCount += counts[i];
        info.update(elementCount, mode, 1);
    }
    function renderMultiDrawInstances(starts, counts, drawCount, primcount) {
        if (drawCount === 0) return;
        const extension = extensions.get('WEBGL_multi_draw');
        if (extension === null) for(let i = 0; i < starts.length; i++)renderInstances(starts[i], counts[i], primcount[i]);
        else {
            extension.multiDrawArraysInstancedWEBGL(mode, starts, 0, counts, 0, primcount, 0, drawCount);
            let elementCount = 0;
            for(let i = 0; i < drawCount; i++)elementCount += counts[i] * primcount[i];
            info.update(elementCount, mode, 1);
        }
    }
    //
    this.setMode = setMode;
    this.render = render;
    this.renderInstances = renderInstances;
    this.renderMultiDraw = renderMultiDraw;
    this.renderMultiDrawInstances = renderMultiDrawInstances;
}
function $d5b33d7c30034067$var$WebGLCapabilities(gl, extensions, parameters, utils) {
    let maxAnisotropy;
    function getMaxAnisotropy() {
        if (maxAnisotropy !== undefined) return maxAnisotropy;
        if (extensions.has('EXT_texture_filter_anisotropic') === true) {
            const extension = extensions.get('EXT_texture_filter_anisotropic');
            maxAnisotropy = gl.getParameter(extension.MAX_TEXTURE_MAX_ANISOTROPY_EXT);
        } else maxAnisotropy = 0;
        return maxAnisotropy;
    }
    function textureFormatReadable(textureFormat) {
        if (textureFormat !== $d5b33d7c30034067$export$3f8bb04b555a363c && utils.convert(textureFormat) !== gl.getParameter(gl.IMPLEMENTATION_COLOR_READ_FORMAT)) return false;
        return true;
    }
    function textureTypeReadable(textureType) {
        const halfFloatSupportedByExt = textureType === $d5b33d7c30034067$export$2697304443f382bc && (extensions.has('EXT_color_buffer_half_float') || extensions.has('EXT_color_buffer_float'));
        if (textureType !== $d5b33d7c30034067$export$2e8ce08d3f6f5e10 && utils.convert(textureType) !== gl.getParameter(gl.IMPLEMENTATION_COLOR_READ_TYPE) && // Edge and Chrome Mac < 52 (#9513)
        textureType !== $d5b33d7c30034067$export$f6d331659b644596 && !halfFloatSupportedByExt) return false;
        return true;
    }
    function getMaxPrecision(precision) {
        if (precision === 'highp') {
            if (gl.getShaderPrecisionFormat(gl.VERTEX_SHADER, gl.HIGH_FLOAT).precision > 0 && gl.getShaderPrecisionFormat(gl.FRAGMENT_SHADER, gl.HIGH_FLOAT).precision > 0) return 'highp';
            precision = 'mediump';
        }
        if (precision === 'mediump') {
            if (gl.getShaderPrecisionFormat(gl.VERTEX_SHADER, gl.MEDIUM_FLOAT).precision > 0 && gl.getShaderPrecisionFormat(gl.FRAGMENT_SHADER, gl.MEDIUM_FLOAT).precision > 0) return 'mediump';
        }
        return 'lowp';
    }
    let precision = parameters.precision !== undefined ? parameters.precision : 'highp';
    const maxPrecision = getMaxPrecision(precision);
    if (maxPrecision !== precision) {
        console.warn('THREE.WebGLRenderer:', precision, 'not supported, using', maxPrecision, 'instead.');
        precision = maxPrecision;
    }
    const logarithmicDepthBuffer = parameters.logarithmicDepthBuffer === true;
    const reverseDepthBuffer = parameters.reverseDepthBuffer === true && extensions.has('EXT_clip_control');
    const maxTextures = gl.getParameter(gl.MAX_TEXTURE_IMAGE_UNITS);
    const maxVertexTextures = gl.getParameter(gl.MAX_VERTEX_TEXTURE_IMAGE_UNITS);
    const maxTextureSize = gl.getParameter(gl.MAX_TEXTURE_SIZE);
    const maxCubemapSize = gl.getParameter(gl.MAX_CUBE_MAP_TEXTURE_SIZE);
    const maxAttributes = gl.getParameter(gl.MAX_VERTEX_ATTRIBS);
    const maxVertexUniforms = gl.getParameter(gl.MAX_VERTEX_UNIFORM_VECTORS);
    const maxVaryings = gl.getParameter(gl.MAX_VARYING_VECTORS);
    const maxFragmentUniforms = gl.getParameter(gl.MAX_FRAGMENT_UNIFORM_VECTORS);
    const vertexTextures = maxVertexTextures > 0;
    const maxSamples = gl.getParameter(gl.MAX_SAMPLES);
    return {
        isWebGL2: true,
        getMaxAnisotropy: getMaxAnisotropy,
        getMaxPrecision: getMaxPrecision,
        textureFormatReadable: textureFormatReadable,
        textureTypeReadable: textureTypeReadable,
        precision: precision,
        logarithmicDepthBuffer: logarithmicDepthBuffer,
        reverseDepthBuffer: reverseDepthBuffer,
        maxTextures: maxTextures,
        maxVertexTextures: maxVertexTextures,
        maxTextureSize: maxTextureSize,
        maxCubemapSize: maxCubemapSize,
        maxAttributes: maxAttributes,
        maxVertexUniforms: maxVertexUniforms,
        maxVaryings: maxVaryings,
        maxFragmentUniforms: maxFragmentUniforms,
        vertexTextures: vertexTextures,
        maxSamples: maxSamples
    };
}
function $d5b33d7c30034067$var$WebGLClipping(properties) {
    const scope = this;
    let globalState = null, numGlobalPlanes = 0, localClippingEnabled = false, renderingShadows = false;
    const plane = new $d5b33d7c30034067$export$7ff5ac152ef991b0(), viewNormalMatrix = new $d5b33d7c30034067$export$8ff26dafa08918(), uniform = {
        value: null,
        needsUpdate: false
    };
    this.uniform = uniform;
    this.numPlanes = 0;
    this.numIntersection = 0;
    this.init = function(planes, enableLocalClipping) {
        const enabled = planes.length !== 0 || enableLocalClipping || // enable state of previous frame - the clipping code has to
        // run another frame in order to reset the state:
        numGlobalPlanes !== 0 || localClippingEnabled;
        localClippingEnabled = enableLocalClipping;
        numGlobalPlanes = planes.length;
        return enabled;
    };
    this.beginShadows = function() {
        renderingShadows = true;
        projectPlanes(null);
    };
    this.endShadows = function() {
        renderingShadows = false;
    };
    this.setGlobalState = function(planes, camera) {
        globalState = projectPlanes(planes, camera, 0);
    };
    this.setState = function(material, camera, useCache) {
        const planes = material.clippingPlanes, clipIntersection = material.clipIntersection, clipShadows = material.clipShadows;
        const materialProperties = properties.get(material);
        if (!localClippingEnabled || planes === null || planes.length === 0 || renderingShadows && !clipShadows) {
            // there's no local clipping
            if (renderingShadows) // there's no global clipping
            projectPlanes(null);
            else resetGlobalState();
        } else {
            const nGlobal = renderingShadows ? 0 : numGlobalPlanes, lGlobal = nGlobal * 4;
            let dstArray = materialProperties.clippingState || null;
            uniform.value = dstArray; // ensure unique state
            dstArray = projectPlanes(planes, camera, lGlobal, useCache);
            for(let i = 0; i !== lGlobal; ++i)dstArray[i] = globalState[i];
            materialProperties.clippingState = dstArray;
            this.numIntersection = clipIntersection ? this.numPlanes : 0;
            this.numPlanes += nGlobal;
        }
    };
    function resetGlobalState() {
        if (uniform.value !== globalState) {
            uniform.value = globalState;
            uniform.needsUpdate = numGlobalPlanes > 0;
        }
        scope.numPlanes = numGlobalPlanes;
        scope.numIntersection = 0;
    }
    function projectPlanes(planes, camera, dstOffset, skipTransform) {
        const nPlanes = planes !== null ? planes.length : 0;
        let dstArray = null;
        if (nPlanes !== 0) {
            dstArray = uniform.value;
            if (skipTransform !== true || dstArray === null) {
                const flatSize = dstOffset + nPlanes * 4, viewMatrix = camera.matrixWorldInverse;
                viewNormalMatrix.getNormalMatrix(viewMatrix);
                if (dstArray === null || dstArray.length < flatSize) dstArray = new Float32Array(flatSize);
                for(let i = 0, i4 = dstOffset; i !== nPlanes; ++i, i4 += 4){
                    plane.copy(planes[i]).applyMatrix4(viewMatrix, viewNormalMatrix);
                    plane.normal.toArray(dstArray, i4);
                    dstArray[i4 + 3] = plane.constant;
                }
            }
            uniform.value = dstArray;
            uniform.needsUpdate = true;
        }
        scope.numPlanes = nPlanes;
        scope.numIntersection = 0;
        return dstArray;
    }
}
function $d5b33d7c30034067$var$WebGLCubeMaps(renderer) {
    let cubemaps = new WeakMap();
    function mapTextureMapping(texture, mapping) {
        if (mapping === $d5b33d7c30034067$export$d64030b316d3b087) texture.mapping = $d5b33d7c30034067$export$8759762a6477f2c4;
        else if (mapping === $d5b33d7c30034067$export$ee99d97d46898098) texture.mapping = $d5b33d7c30034067$export$dc59f8aed047f61d;
        return texture;
    }
    function get(texture) {
        if (texture && texture.isTexture) {
            const mapping = texture.mapping;
            if (mapping === $d5b33d7c30034067$export$d64030b316d3b087 || mapping === $d5b33d7c30034067$export$ee99d97d46898098) {
                if (cubemaps.has(texture)) {
                    const cubemap = cubemaps.get(texture).texture;
                    return mapTextureMapping(cubemap, texture.mapping);
                } else {
                    const image = texture.image;
                    if (image && image.height > 0) {
                        const renderTarget = new $d5b33d7c30034067$export$ac386671d651941e(image.height);
                        renderTarget.fromEquirectangularTexture(renderer, texture);
                        cubemaps.set(texture, renderTarget);
                        texture.addEventListener('dispose', onTextureDispose);
                        return mapTextureMapping(renderTarget.texture, texture.mapping);
                    } else // image not yet ready. try the conversion next frame
                    return null;
                }
            }
        }
        return texture;
    }
    function onTextureDispose(event) {
        const texture = event.target;
        texture.removeEventListener('dispose', onTextureDispose);
        const cubemap = cubemaps.get(texture);
        if (cubemap !== undefined) {
            cubemaps.delete(texture);
            cubemap.dispose();
        }
    }
    function dispose() {
        cubemaps = new WeakMap();
    }
    return {
        get: get,
        dispose: dispose
    };
}
class $d5b33d7c30034067$export$9ebf355ee4ed261b extends $d5b33d7c30034067$export$79f141de891a5fed {
    constructor(left = -1, right = 1, top = 1, bottom = -1, near = 0.1, far = 2000){
        super();
        this.isOrthographicCamera = true;
        this.type = 'OrthographicCamera';
        this.zoom = 1;
        this.view = null;
        this.left = left;
        this.right = right;
        this.top = top;
        this.bottom = bottom;
        this.near = near;
        this.far = far;
        this.updateProjectionMatrix();
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.left = source.left;
        this.right = source.right;
        this.top = source.top;
        this.bottom = source.bottom;
        this.near = source.near;
        this.far = source.far;
        this.zoom = source.zoom;
        this.view = source.view === null ? null : Object.assign({}, source.view);
        return this;
    }
    setViewOffset(fullWidth, fullHeight, x, y, width, height) {
        if (this.view === null) this.view = {
            enabled: true,
            fullWidth: 1,
            fullHeight: 1,
            offsetX: 0,
            offsetY: 0,
            width: 1,
            height: 1
        };
        this.view.enabled = true;
        this.view.fullWidth = fullWidth;
        this.view.fullHeight = fullHeight;
        this.view.offsetX = x;
        this.view.offsetY = y;
        this.view.width = width;
        this.view.height = height;
        this.updateProjectionMatrix();
    }
    clearViewOffset() {
        if (this.view !== null) this.view.enabled = false;
        this.updateProjectionMatrix();
    }
    updateProjectionMatrix() {
        const dx = (this.right - this.left) / (2 * this.zoom);
        const dy = (this.top - this.bottom) / (2 * this.zoom);
        const cx = (this.right + this.left) / 2;
        const cy = (this.top + this.bottom) / 2;
        let left = cx - dx;
        let right = cx + dx;
        let top = cy + dy;
        let bottom = cy - dy;
        if (this.view !== null && this.view.enabled) {
            const scaleW = (this.right - this.left) / this.view.fullWidth / this.zoom;
            const scaleH = (this.top - this.bottom) / this.view.fullHeight / this.zoom;
            left += scaleW * this.view.offsetX;
            right = left + scaleW * this.view.width;
            top -= scaleH * this.view.offsetY;
            bottom = top - scaleH * this.view.height;
        }
        this.projectionMatrix.makeOrthographic(left, right, top, bottom, this.near, this.far, this.coordinateSystem);
        this.projectionMatrixInverse.copy(this.projectionMatrix).invert();
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.object.zoom = this.zoom;
        data.object.left = this.left;
        data.object.right = this.right;
        data.object.top = this.top;
        data.object.bottom = this.bottom;
        data.object.near = this.near;
        data.object.far = this.far;
        if (this.view !== null) data.object.view = Object.assign({}, this.view);
        return data;
    }
}
const $d5b33d7c30034067$var$LOD_MIN = 4;
// The standard deviations (radians) associated with the extra mips. These are
// chosen to approximate a Trowbridge-Reitz distribution function times the
// geometric shadowing function. These sigma values squared must match the
// variance #defines in cube_uv_reflection_fragment.glsl.js.
const $d5b33d7c30034067$var$EXTRA_LOD_SIGMA = [
    0.125,
    0.215,
    0.35,
    0.446,
    0.526,
    0.582
];
// The maximum length of the blur for loop. Smaller sigmas will use fewer
// samples and exit early, but not recompile the shader.
const $d5b33d7c30034067$var$MAX_SAMPLES = 20;
const $d5b33d7c30034067$var$_flatCamera = /*@__PURE__*/ new $d5b33d7c30034067$export$9ebf355ee4ed261b();
const $d5b33d7c30034067$var$_clearColor = /*@__PURE__*/ new $d5b33d7c30034067$export$892596cec99bc70e();
let $d5b33d7c30034067$var$_oldTarget = null;
let $d5b33d7c30034067$var$_oldActiveCubeFace = 0;
let $d5b33d7c30034067$var$_oldActiveMipmapLevel = 0;
let $d5b33d7c30034067$var$_oldXrEnabled = false;
// Golden Ratio
const $d5b33d7c30034067$var$PHI = (1 + Math.sqrt(5)) / 2;
const $d5b33d7c30034067$var$INV_PHI = 1 / $d5b33d7c30034067$var$PHI;
// Vertices of a dodecahedron (except the opposites, which represent the
// same axis), used as axis directions evenly spread on a sphere.
const $d5b33d7c30034067$var$_axisDirections = [
    /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699(-$d5b33d7c30034067$var$PHI, $d5b33d7c30034067$var$INV_PHI, 0),
    /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699($d5b33d7c30034067$var$PHI, $d5b33d7c30034067$var$INV_PHI, 0),
    /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699(-$d5b33d7c30034067$var$INV_PHI, 0, $d5b33d7c30034067$var$PHI),
    /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699($d5b33d7c30034067$var$INV_PHI, 0, $d5b33d7c30034067$var$PHI),
    /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699(0, $d5b33d7c30034067$var$PHI, -$d5b33d7c30034067$var$INV_PHI),
    /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699(0, $d5b33d7c30034067$var$PHI, $d5b33d7c30034067$var$INV_PHI),
    /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699(-1, 1, -1),
    /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699(1, 1, -1),
    /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699(-1, 1, 1),
    /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699(1, 1, 1)
];
/**
 * This class generates a Prefiltered, Mipmapped Radiance Environment Map
 * (PMREM) from a cubeMap environment texture. This allows different levels of
 * blur to be quickly accessed based on material roughness. It is packed into a
 * special CubeUV format that allows us to perform custom interpolation so that
 * we can support nonlinear formats such as RGBE. Unlike a traditional mipmap
 * chain, it only goes down to the LOD_MIN level (above), and then creates extra
 * even more filtered 'mips' at the same LOD_MIN resolution, associated with
 * higher roughness levels. In this way we maintain resolution to smoothly
 * interpolate diffuse lighting while limiting sampling computation.
 *
 * Paper: Fast, Accurate Image-Based Lighting
 * https://drive.google.com/file/d/15y8r_UpKlU9SvV4ILb0C3qCPecS8pvLz/view
*/ class $d5b33d7c30034067$export$6add42717753e221 {
    constructor(renderer){
        this._renderer = renderer;
        this._pingPongRenderTarget = null;
        this._lodMax = 0;
        this._cubeSize = 0;
        this._lodPlanes = [];
        this._sizeLods = [];
        this._sigmas = [];
        this._blurMaterial = null;
        this._cubemapMaterial = null;
        this._equirectMaterial = null;
        this._compileMaterial(this._blurMaterial);
    }
    /**
	 * Generates a PMREM from a supplied Scene, which can be faster than using an
	 * image if networking bandwidth is low. Optional sigma specifies a blur radius
	 * in radians to be applied to the scene before PMREM generation. Optional near
	 * and far planes ensure the scene is rendered in its entirety (the cubeCamera
	 * is placed at the origin).
	 */ fromScene(scene, sigma = 0, near = 0.1, far = 100) {
        $d5b33d7c30034067$var$_oldTarget = this._renderer.getRenderTarget();
        $d5b33d7c30034067$var$_oldActiveCubeFace = this._renderer.getActiveCubeFace();
        $d5b33d7c30034067$var$_oldActiveMipmapLevel = this._renderer.getActiveMipmapLevel();
        $d5b33d7c30034067$var$_oldXrEnabled = this._renderer.xr.enabled;
        this._renderer.xr.enabled = false;
        this._setSize(256);
        const cubeUVRenderTarget = this._allocateTargets();
        cubeUVRenderTarget.depthBuffer = true;
        this._sceneToCubeUV(scene, near, far, cubeUVRenderTarget);
        if (sigma > 0) this._blur(cubeUVRenderTarget, 0, 0, sigma);
        this._applyPMREM(cubeUVRenderTarget);
        this._cleanup(cubeUVRenderTarget);
        return cubeUVRenderTarget;
    }
    /**
	 * Generates a PMREM from an equirectangular texture, which can be either LDR
	 * or HDR. The ideal input image size is 1k (1024 x 512),
	 * as this matches best with the 256 x 256 cubemap output.
	 * The smallest supported equirectangular image size is 64 x 32.
	 */ fromEquirectangular(equirectangular, renderTarget = null) {
        return this._fromTexture(equirectangular, renderTarget);
    }
    /**
	 * Generates a PMREM from an cubemap texture, which can be either LDR
	 * or HDR. The ideal input cube size is 256 x 256,
	 * as this matches best with the 256 x 256 cubemap output.
	 * The smallest supported cube size is 16 x 16.
	 */ fromCubemap(cubemap, renderTarget = null) {
        return this._fromTexture(cubemap, renderTarget);
    }
    /**
	 * Pre-compiles the cubemap shader. You can get faster start-up by invoking this method during
	 * your texture's network fetch for increased concurrency.
	 */ compileCubemapShader() {
        if (this._cubemapMaterial === null) {
            this._cubemapMaterial = $d5b33d7c30034067$var$_getCubemapMaterial();
            this._compileMaterial(this._cubemapMaterial);
        }
    }
    /**
	 * Pre-compiles the equirectangular shader. You can get faster start-up by invoking this method during
	 * your texture's network fetch for increased concurrency.
	 */ compileEquirectangularShader() {
        if (this._equirectMaterial === null) {
            this._equirectMaterial = $d5b33d7c30034067$var$_getEquirectMaterial();
            this._compileMaterial(this._equirectMaterial);
        }
    }
    /**
	 * Disposes of the PMREMGenerator's internal memory. Note that PMREMGenerator is a static class,
	 * so you should not need more than one PMREMGenerator object. If you do, calling dispose() on
	 * one of them will cause any others to also become unusable.
	 */ dispose() {
        this._dispose();
        if (this._cubemapMaterial !== null) this._cubemapMaterial.dispose();
        if (this._equirectMaterial !== null) this._equirectMaterial.dispose();
    }
    // private interface
    _setSize(cubeSize) {
        this._lodMax = Math.floor(Math.log2(cubeSize));
        this._cubeSize = Math.pow(2, this._lodMax);
    }
    _dispose() {
        if (this._blurMaterial !== null) this._blurMaterial.dispose();
        if (this._pingPongRenderTarget !== null) this._pingPongRenderTarget.dispose();
        for(let i = 0; i < this._lodPlanes.length; i++)this._lodPlanes[i].dispose();
    }
    _cleanup(outputTarget) {
        this._renderer.setRenderTarget($d5b33d7c30034067$var$_oldTarget, $d5b33d7c30034067$var$_oldActiveCubeFace, $d5b33d7c30034067$var$_oldActiveMipmapLevel);
        this._renderer.xr.enabled = $d5b33d7c30034067$var$_oldXrEnabled;
        outputTarget.scissorTest = false;
        $d5b33d7c30034067$var$_setViewport(outputTarget, 0, 0, outputTarget.width, outputTarget.height);
    }
    _fromTexture(texture, renderTarget) {
        if (texture.mapping === $d5b33d7c30034067$export$8759762a6477f2c4 || texture.mapping === $d5b33d7c30034067$export$dc59f8aed047f61d) this._setSize(texture.image.length === 0 ? 16 : texture.image[0].width || texture.image[0].image.width);
        else this._setSize(texture.image.width / 4);
        $d5b33d7c30034067$var$_oldTarget = this._renderer.getRenderTarget();
        $d5b33d7c30034067$var$_oldActiveCubeFace = this._renderer.getActiveCubeFace();
        $d5b33d7c30034067$var$_oldActiveMipmapLevel = this._renderer.getActiveMipmapLevel();
        $d5b33d7c30034067$var$_oldXrEnabled = this._renderer.xr.enabled;
        this._renderer.xr.enabled = false;
        const cubeUVRenderTarget = renderTarget || this._allocateTargets();
        this._textureToCubeUV(texture, cubeUVRenderTarget);
        this._applyPMREM(cubeUVRenderTarget);
        this._cleanup(cubeUVRenderTarget);
        return cubeUVRenderTarget;
    }
    _allocateTargets() {
        const width = 3 * Math.max(this._cubeSize, 112);
        const height = 4 * this._cubeSize;
        const params = {
            magFilter: $d5b33d7c30034067$export$8a72f490b25c56c8,
            minFilter: $d5b33d7c30034067$export$8a72f490b25c56c8,
            generateMipmaps: false,
            type: $d5b33d7c30034067$export$2697304443f382bc,
            format: $d5b33d7c30034067$export$3f8bb04b555a363c,
            colorSpace: $d5b33d7c30034067$export$42429b3acfb233a4,
            depthBuffer: false
        };
        const cubeUVRenderTarget = $d5b33d7c30034067$var$_createRenderTarget(width, height, params);
        if (this._pingPongRenderTarget === null || this._pingPongRenderTarget.width !== width || this._pingPongRenderTarget.height !== height) {
            if (this._pingPongRenderTarget !== null) this._dispose();
            this._pingPongRenderTarget = $d5b33d7c30034067$var$_createRenderTarget(width, height, params);
            const { _lodMax: _lodMax } = this;
            ({ sizeLods: this._sizeLods, lodPlanes: this._lodPlanes, sigmas: this._sigmas } = $d5b33d7c30034067$var$_createPlanes(_lodMax));
            this._blurMaterial = $d5b33d7c30034067$var$_getBlurShader(_lodMax, width, height);
        }
        return cubeUVRenderTarget;
    }
    _compileMaterial(material) {
        const tmpMesh = new $d5b33d7c30034067$export$e176487c05830cc5(this._lodPlanes[0], material);
        this._renderer.compile(tmpMesh, $d5b33d7c30034067$var$_flatCamera);
    }
    _sceneToCubeUV(scene, near, far, cubeUVRenderTarget) {
        const fov = 90;
        const aspect = 1;
        const cubeCamera = new $d5b33d7c30034067$export$74e4ae24825f68d7(fov, aspect, near, far);
        const upSign = [
            1,
            -1,
            1,
            1,
            1,
            1
        ];
        const forwardSign = [
            1,
            1,
            1,
            -1,
            -1,
            -1
        ];
        const renderer = this._renderer;
        const originalAutoClear = renderer.autoClear;
        const toneMapping = renderer.toneMapping;
        renderer.getClearColor($d5b33d7c30034067$var$_clearColor);
        renderer.toneMapping = $d5b33d7c30034067$export$9fcb6b4294603b2;
        renderer.autoClear = false;
        const backgroundMaterial = new $d5b33d7c30034067$export$55cbcc9b622fe1f5({
            name: 'PMREM.Background',
            side: $d5b33d7c30034067$export$d9f0486e75b5ace,
            depthWrite: false,
            depthTest: false
        });
        const backgroundBox = new $d5b33d7c30034067$export$e176487c05830cc5(new $d5b33d7c30034067$export$33e43285f7406bd5(), backgroundMaterial);
        let useSolidColor = false;
        const background = scene.background;
        if (background) {
            if (background.isColor) {
                backgroundMaterial.color.copy(background);
                scene.background = null;
                useSolidColor = true;
            }
        } else {
            backgroundMaterial.color.copy($d5b33d7c30034067$var$_clearColor);
            useSolidColor = true;
        }
        for(let i = 0; i < 6; i++){
            const col = i % 3;
            if (col === 0) {
                cubeCamera.up.set(0, upSign[i], 0);
                cubeCamera.lookAt(forwardSign[i], 0, 0);
            } else if (col === 1) {
                cubeCamera.up.set(0, 0, upSign[i]);
                cubeCamera.lookAt(0, forwardSign[i], 0);
            } else {
                cubeCamera.up.set(0, upSign[i], 0);
                cubeCamera.lookAt(0, 0, forwardSign[i]);
            }
            const size = this._cubeSize;
            $d5b33d7c30034067$var$_setViewport(cubeUVRenderTarget, col * size, i > 2 ? size : 0, size, size);
            renderer.setRenderTarget(cubeUVRenderTarget);
            if (useSolidColor) renderer.render(backgroundBox, cubeCamera);
            renderer.render(scene, cubeCamera);
        }
        backgroundBox.geometry.dispose();
        backgroundBox.material.dispose();
        renderer.toneMapping = toneMapping;
        renderer.autoClear = originalAutoClear;
        scene.background = background;
    }
    _textureToCubeUV(texture, cubeUVRenderTarget) {
        const renderer = this._renderer;
        const isCubeTexture = texture.mapping === $d5b33d7c30034067$export$8759762a6477f2c4 || texture.mapping === $d5b33d7c30034067$export$dc59f8aed047f61d;
        if (isCubeTexture) {
            if (this._cubemapMaterial === null) this._cubemapMaterial = $d5b33d7c30034067$var$_getCubemapMaterial();
            this._cubemapMaterial.uniforms.flipEnvMap.value = texture.isRenderTargetTexture === false ? -1 : 1;
        } else if (this._equirectMaterial === null) this._equirectMaterial = $d5b33d7c30034067$var$_getEquirectMaterial();
        const material = isCubeTexture ? this._cubemapMaterial : this._equirectMaterial;
        const mesh = new $d5b33d7c30034067$export$e176487c05830cc5(this._lodPlanes[0], material);
        const uniforms = material.uniforms;
        uniforms['envMap'].value = texture;
        const size = this._cubeSize;
        $d5b33d7c30034067$var$_setViewport(cubeUVRenderTarget, 0, 0, 3 * size, 2 * size);
        renderer.setRenderTarget(cubeUVRenderTarget);
        renderer.render(mesh, $d5b33d7c30034067$var$_flatCamera);
    }
    _applyPMREM(cubeUVRenderTarget) {
        const renderer = this._renderer;
        const autoClear = renderer.autoClear;
        renderer.autoClear = false;
        const n = this._lodPlanes.length;
        for(let i = 1; i < n; i++){
            const sigma = Math.sqrt(this._sigmas[i] * this._sigmas[i] - this._sigmas[i - 1] * this._sigmas[i - 1]);
            const poleAxis = $d5b33d7c30034067$var$_axisDirections[(n - i - 1) % $d5b33d7c30034067$var$_axisDirections.length];
            this._blur(cubeUVRenderTarget, i - 1, i, sigma, poleAxis);
        }
        renderer.autoClear = autoClear;
    }
    /**
	 * This is a two-pass Gaussian blur for a cubemap. Normally this is done
	 * vertically and horizontally, but this breaks down on a cube. Here we apply
	 * the blur latitudinally (around the poles), and then longitudinally (towards
	 * the poles) to approximate the orthogonally-separable blur. It is least
	 * accurate at the poles, but still does a decent job.
	 */ _blur(cubeUVRenderTarget, lodIn, lodOut, sigma, poleAxis) {
        const pingPongRenderTarget = this._pingPongRenderTarget;
        this._halfBlur(cubeUVRenderTarget, pingPongRenderTarget, lodIn, lodOut, sigma, 'latitudinal', poleAxis);
        this._halfBlur(pingPongRenderTarget, cubeUVRenderTarget, lodOut, lodOut, sigma, 'longitudinal', poleAxis);
    }
    _halfBlur(targetIn, targetOut, lodIn, lodOut, sigmaRadians, direction, poleAxis) {
        const renderer = this._renderer;
        const blurMaterial = this._blurMaterial;
        if (direction !== 'latitudinal' && direction !== 'longitudinal') console.error('blur direction must be either latitudinal or longitudinal!');
        // Number of standard deviations at which to cut off the discrete approximation.
        const STANDARD_DEVIATIONS = 3;
        const blurMesh = new $d5b33d7c30034067$export$e176487c05830cc5(this._lodPlanes[lodOut], blurMaterial);
        const blurUniforms = blurMaterial.uniforms;
        const pixels = this._sizeLods[lodIn] - 1;
        const radiansPerPixel = isFinite(sigmaRadians) ? Math.PI / (2 * pixels) : 2 * Math.PI / (2 * $d5b33d7c30034067$var$MAX_SAMPLES - 1);
        const sigmaPixels = sigmaRadians / radiansPerPixel;
        const samples = isFinite(sigmaRadians) ? 1 + Math.floor(STANDARD_DEVIATIONS * sigmaPixels) : $d5b33d7c30034067$var$MAX_SAMPLES;
        if (samples > $d5b33d7c30034067$var$MAX_SAMPLES) console.warn(`sigmaRadians, ${sigmaRadians}, is too large and will clip, as it requested ${samples} samples when the maximum is set to ${$d5b33d7c30034067$var$MAX_SAMPLES}`);
        const weights = [];
        let sum = 0;
        for(let i = 0; i < $d5b33d7c30034067$var$MAX_SAMPLES; ++i){
            const x = i / sigmaPixels;
            const weight = Math.exp(-x * x / 2);
            weights.push(weight);
            if (i === 0) sum += weight;
            else if (i < samples) sum += 2 * weight;
        }
        for(let i = 0; i < weights.length; i++)weights[i] = weights[i] / sum;
        blurUniforms['envMap'].value = targetIn.texture;
        blurUniforms['samples'].value = samples;
        blurUniforms['weights'].value = weights;
        blurUniforms['latitudinal'].value = direction === 'latitudinal';
        if (poleAxis) blurUniforms['poleAxis'].value = poleAxis;
        const { _lodMax: _lodMax } = this;
        blurUniforms['dTheta'].value = radiansPerPixel;
        blurUniforms['mipInt'].value = _lodMax - lodIn;
        const outputSize = this._sizeLods[lodOut];
        const x = 3 * outputSize * (lodOut > _lodMax - $d5b33d7c30034067$var$LOD_MIN ? lodOut - _lodMax + $d5b33d7c30034067$var$LOD_MIN : 0);
        const y = 4 * (this._cubeSize - outputSize);
        $d5b33d7c30034067$var$_setViewport(targetOut, x, y, 3 * outputSize, 2 * outputSize);
        renderer.setRenderTarget(targetOut);
        renderer.render(blurMesh, $d5b33d7c30034067$var$_flatCamera);
    }
}
function $d5b33d7c30034067$var$_createPlanes(lodMax) {
    const lodPlanes = [];
    const sizeLods = [];
    const sigmas = [];
    let lod = lodMax;
    const totalLods = lodMax - $d5b33d7c30034067$var$LOD_MIN + 1 + $d5b33d7c30034067$var$EXTRA_LOD_SIGMA.length;
    for(let i = 0; i < totalLods; i++){
        const sizeLod = Math.pow(2, lod);
        sizeLods.push(sizeLod);
        let sigma = 1.0 / sizeLod;
        if (i > lodMax - $d5b33d7c30034067$var$LOD_MIN) sigma = $d5b33d7c30034067$var$EXTRA_LOD_SIGMA[i - lodMax + $d5b33d7c30034067$var$LOD_MIN - 1];
        else if (i === 0) sigma = 0;
        sigmas.push(sigma);
        const texelSize = 1.0 / (sizeLod - 2);
        const min = -texelSize;
        const max = 1 + texelSize;
        const uv1 = [
            min,
            min,
            max,
            min,
            max,
            max,
            min,
            min,
            max,
            max,
            min,
            max
        ];
        const cubeFaces = 6;
        const vertices = 6;
        const positionSize = 3;
        const uvSize = 2;
        const faceIndexSize = 1;
        const position = new Float32Array(positionSize * vertices * cubeFaces);
        const uv = new Float32Array(uvSize * vertices * cubeFaces);
        const faceIndex = new Float32Array(faceIndexSize * vertices * cubeFaces);
        for(let face = 0; face < cubeFaces; face++){
            const x = face % 3 * 2 / 3 - 1;
            const y = face > 2 ? 0 : -1;
            const coordinates = [
                x,
                y,
                0,
                x + 2 / 3,
                y,
                0,
                x + 2 / 3,
                y + 1,
                0,
                x,
                y,
                0,
                x + 2 / 3,
                y + 1,
                0,
                x,
                y + 1,
                0
            ];
            position.set(coordinates, positionSize * vertices * face);
            uv.set(uv1, uvSize * vertices * face);
            const fill = [
                face,
                face,
                face,
                face,
                face,
                face
            ];
            faceIndex.set(fill, faceIndexSize * vertices * face);
        }
        const planes = new $d5b33d7c30034067$export$b7be63a67df8959();
        planes.setAttribute('position', new $d5b33d7c30034067$export$8dea267bd6bde117(position, positionSize));
        planes.setAttribute('uv', new $d5b33d7c30034067$export$8dea267bd6bde117(uv, uvSize));
        planes.setAttribute('faceIndex', new $d5b33d7c30034067$export$8dea267bd6bde117(faceIndex, faceIndexSize));
        lodPlanes.push(planes);
        if (lod > $d5b33d7c30034067$var$LOD_MIN) lod--;
    }
    return {
        lodPlanes: lodPlanes,
        sizeLods: sizeLods,
        sigmas: sigmas
    };
}
function $d5b33d7c30034067$var$_createRenderTarget(width, height, params) {
    const cubeUVRenderTarget = new $d5b33d7c30034067$export$3c052beb2e51e23f(width, height, params);
    cubeUVRenderTarget.texture.mapping = $d5b33d7c30034067$export$dbf3e70ff37af79;
    cubeUVRenderTarget.texture.name = 'PMREM.cubeUv';
    cubeUVRenderTarget.scissorTest = true;
    return cubeUVRenderTarget;
}
function $d5b33d7c30034067$var$_setViewport(target, x, y, width, height) {
    target.viewport.set(x, y, width, height);
    target.scissor.set(x, y, width, height);
}
function $d5b33d7c30034067$var$_getBlurShader(lodMax, width, height) {
    const weights = new Float32Array($d5b33d7c30034067$var$MAX_SAMPLES);
    const poleAxis = new $d5b33d7c30034067$export$64b5c384219d3699(0, 1, 0);
    const shaderMaterial = new $d5b33d7c30034067$export$83c7d75d550a8b0d({
        name: 'SphericalGaussianBlur',
        defines: {
            'n': $d5b33d7c30034067$var$MAX_SAMPLES,
            'CUBEUV_TEXEL_WIDTH': 1.0 / width,
            'CUBEUV_TEXEL_HEIGHT': 1.0 / height,
            'CUBEUV_MAX_MIP': `${lodMax}.0`
        },
        uniforms: {
            'envMap': {
                value: null
            },
            'samples': {
                value: 1
            },
            'weights': {
                value: weights
            },
            'latitudinal': {
                value: false
            },
            'dTheta': {
                value: 0
            },
            'mipInt': {
                value: 0
            },
            'poleAxis': {
                value: poleAxis
            }
        },
        vertexShader: $d5b33d7c30034067$var$_getCommonVertexShader(),
        fragmentShader: /* glsl */ `

			precision mediump float;
			precision mediump int;

			varying vec3 vOutputDirection;

			uniform sampler2D envMap;
			uniform int samples;
			uniform float weights[ n ];
			uniform bool latitudinal;
			uniform float dTheta;
			uniform float mipInt;
			uniform vec3 poleAxis;

			#define ENVMAP_TYPE_CUBE_UV
			#include <cube_uv_reflection_fragment>

			vec3 getSample( float theta, vec3 axis ) {

				float cosTheta = cos( theta );
				// Rodrigues' axis-angle rotation
				vec3 sampleDirection = vOutputDirection * cosTheta
					+ cross( axis, vOutputDirection ) * sin( theta )
					+ axis * dot( axis, vOutputDirection ) * ( 1.0 - cosTheta );

				return bilinearCubeUV( envMap, sampleDirection, mipInt );

			}

			void main() {

				vec3 axis = latitudinal ? poleAxis : cross( poleAxis, vOutputDirection );

				if ( all( equal( axis, vec3( 0.0 ) ) ) ) {

					axis = vec3( vOutputDirection.z, 0.0, - vOutputDirection.x );

				}

				axis = normalize( axis );

				gl_FragColor = vec4( 0.0, 0.0, 0.0, 1.0 );
				gl_FragColor.rgb += weights[ 0 ] * getSample( 0.0, axis );

				for ( int i = 1; i < n; i++ ) {

					if ( i >= samples ) {

						break;

					}

					float theta = dTheta * float( i );
					gl_FragColor.rgb += weights[ i ] * getSample( -1.0 * theta, axis );
					gl_FragColor.rgb += weights[ i ] * getSample( theta, axis );

				}

			}
		`,
        blending: $d5b33d7c30034067$export$63b8d6b580fc65ba,
        depthTest: false,
        depthWrite: false
    });
    return shaderMaterial;
}
function $d5b33d7c30034067$var$_getEquirectMaterial() {
    return new $d5b33d7c30034067$export$83c7d75d550a8b0d({
        name: 'EquirectangularToCubeUV',
        uniforms: {
            'envMap': {
                value: null
            }
        },
        vertexShader: $d5b33d7c30034067$var$_getCommonVertexShader(),
        fragmentShader: /* glsl */ `

			precision mediump float;
			precision mediump int;

			varying vec3 vOutputDirection;

			uniform sampler2D envMap;

			#include <common>

			void main() {

				vec3 outputDirection = normalize( vOutputDirection );
				vec2 uv = equirectUv( outputDirection );

				gl_FragColor = vec4( texture2D ( envMap, uv ).rgb, 1.0 );

			}
		`,
        blending: $d5b33d7c30034067$export$63b8d6b580fc65ba,
        depthTest: false,
        depthWrite: false
    });
}
function $d5b33d7c30034067$var$_getCubemapMaterial() {
    return new $d5b33d7c30034067$export$83c7d75d550a8b0d({
        name: 'CubemapToCubeUV',
        uniforms: {
            'envMap': {
                value: null
            },
            'flipEnvMap': {
                value: -1
            }
        },
        vertexShader: $d5b33d7c30034067$var$_getCommonVertexShader(),
        fragmentShader: /* glsl */ `

			precision mediump float;
			precision mediump int;

			uniform float flipEnvMap;

			varying vec3 vOutputDirection;

			uniform samplerCube envMap;

			void main() {

				gl_FragColor = textureCube( envMap, vec3( flipEnvMap * vOutputDirection.x, vOutputDirection.yz ) );

			}
		`,
        blending: $d5b33d7c30034067$export$63b8d6b580fc65ba,
        depthTest: false,
        depthWrite: false
    });
}
function $d5b33d7c30034067$var$_getCommonVertexShader() {
    return /* glsl */ `

		precision mediump float;
		precision mediump int;

		attribute float faceIndex;

		varying vec3 vOutputDirection;

		// RH coordinate system; PMREM face-indexing convention
		vec3 getDirection( vec2 uv, float face ) {

			uv = 2.0 * uv - 1.0;

			vec3 direction = vec3( uv, 1.0 );

			if ( face == 0.0 ) {

				direction = direction.zyx; // ( 1, v, u ) pos x

			} else if ( face == 1.0 ) {

				direction = direction.xzy;
				direction.xz *= -1.0; // ( -u, 1, -v ) pos y

			} else if ( face == 2.0 ) {

				direction.x *= -1.0; // ( -u, v, 1 ) pos z

			} else if ( face == 3.0 ) {

				direction = direction.zyx;
				direction.xz *= -1.0; // ( -1, v, -u ) neg x

			} else if ( face == 4.0 ) {

				direction = direction.xzy;
				direction.xy *= -1.0; // ( -u, -1, v ) neg y

			} else if ( face == 5.0 ) {

				direction.z *= -1.0; // ( u, v, -1 ) neg z

			}

			return direction;

		}

		void main() {

			vOutputDirection = getDirection( uv, faceIndex );
			gl_Position = vec4( position, 1.0 );

		}
	`;
}
function $d5b33d7c30034067$var$WebGLCubeUVMaps(renderer) {
    let cubeUVmaps = new WeakMap();
    let pmremGenerator = null;
    function get(texture) {
        if (texture && texture.isTexture) {
            const mapping = texture.mapping;
            const isEquirectMap = mapping === $d5b33d7c30034067$export$d64030b316d3b087 || mapping === $d5b33d7c30034067$export$ee99d97d46898098;
            const isCubeMap = mapping === $d5b33d7c30034067$export$8759762a6477f2c4 || mapping === $d5b33d7c30034067$export$dc59f8aed047f61d;
            // equirect/cube map to cubeUV conversion
            if (isEquirectMap || isCubeMap) {
                let renderTarget = cubeUVmaps.get(texture);
                const currentPMREMVersion = renderTarget !== undefined ? renderTarget.texture.pmremVersion : 0;
                if (texture.isRenderTargetTexture && texture.pmremVersion !== currentPMREMVersion) {
                    if (pmremGenerator === null) pmremGenerator = new $d5b33d7c30034067$export$6add42717753e221(renderer);
                    renderTarget = isEquirectMap ? pmremGenerator.fromEquirectangular(texture, renderTarget) : pmremGenerator.fromCubemap(texture, renderTarget);
                    renderTarget.texture.pmremVersion = texture.pmremVersion;
                    cubeUVmaps.set(texture, renderTarget);
                    return renderTarget.texture;
                } else {
                    if (renderTarget !== undefined) return renderTarget.texture;
                    else {
                        const image = texture.image;
                        if (isEquirectMap && image && image.height > 0 || isCubeMap && image && isCubeTextureComplete(image)) {
                            if (pmremGenerator === null) pmremGenerator = new $d5b33d7c30034067$export$6add42717753e221(renderer);
                            renderTarget = isEquirectMap ? pmremGenerator.fromEquirectangular(texture) : pmremGenerator.fromCubemap(texture);
                            renderTarget.texture.pmremVersion = texture.pmremVersion;
                            cubeUVmaps.set(texture, renderTarget);
                            texture.addEventListener('dispose', onTextureDispose);
                            return renderTarget.texture;
                        } else // image not yet ready. try the conversion next frame
                        return null;
                    }
                }
            }
        }
        return texture;
    }
    function isCubeTextureComplete(image) {
        let count = 0;
        const length = 6;
        for(let i = 0; i < length; i++)if (image[i] !== undefined) count++;
        return count === length;
    }
    function onTextureDispose(event) {
        const texture = event.target;
        texture.removeEventListener('dispose', onTextureDispose);
        const cubemapUV = cubeUVmaps.get(texture);
        if (cubemapUV !== undefined) {
            cubeUVmaps.delete(texture);
            cubemapUV.dispose();
        }
    }
    function dispose() {
        cubeUVmaps = new WeakMap();
        if (pmremGenerator !== null) {
            pmremGenerator.dispose();
            pmremGenerator = null;
        }
    }
    return {
        get: get,
        dispose: dispose
    };
}
function $d5b33d7c30034067$var$WebGLExtensions(gl) {
    const extensions = {};
    function getExtension(name) {
        if (extensions[name] !== undefined) return extensions[name];
        let extension;
        switch(name){
            case 'WEBGL_depth_texture':
                extension = gl.getExtension('WEBGL_depth_texture') || gl.getExtension('MOZ_WEBGL_depth_texture') || gl.getExtension('WEBKIT_WEBGL_depth_texture');
                break;
            case 'EXT_texture_filter_anisotropic':
                extension = gl.getExtension('EXT_texture_filter_anisotropic') || gl.getExtension('MOZ_EXT_texture_filter_anisotropic') || gl.getExtension('WEBKIT_EXT_texture_filter_anisotropic');
                break;
            case 'WEBGL_compressed_texture_s3tc':
                extension = gl.getExtension('WEBGL_compressed_texture_s3tc') || gl.getExtension('MOZ_WEBGL_compressed_texture_s3tc') || gl.getExtension('WEBKIT_WEBGL_compressed_texture_s3tc');
                break;
            case 'WEBGL_compressed_texture_pvrtc':
                extension = gl.getExtension('WEBGL_compressed_texture_pvrtc') || gl.getExtension('WEBKIT_WEBGL_compressed_texture_pvrtc');
                break;
            default:
                extension = gl.getExtension(name);
        }
        extensions[name] = extension;
        return extension;
    }
    return {
        has: function(name) {
            return getExtension(name) !== null;
        },
        init: function() {
            getExtension('EXT_color_buffer_float');
            getExtension('WEBGL_clip_cull_distance');
            getExtension('OES_texture_float_linear');
            getExtension('EXT_color_buffer_half_float');
            getExtension('WEBGL_multisampled_render_to_texture');
            getExtension('WEBGL_render_shared_exponent');
        },
        get: function(name) {
            const extension = getExtension(name);
            if (extension === null) $d5b33d7c30034067$var$warnOnce('THREE.WebGLRenderer: ' + name + ' extension not supported.');
            return extension;
        }
    };
}
function $d5b33d7c30034067$var$WebGLGeometries(gl, attributes, info, bindingStates) {
    const geometries = {};
    const wireframeAttributes = new WeakMap();
    function onGeometryDispose(event) {
        const geometry = event.target;
        if (geometry.index !== null) attributes.remove(geometry.index);
        for(const name in geometry.attributes)attributes.remove(geometry.attributes[name]);
        for(const name in geometry.morphAttributes){
            const array = geometry.morphAttributes[name];
            for(let i = 0, l = array.length; i < l; i++)attributes.remove(array[i]);
        }
        geometry.removeEventListener('dispose', onGeometryDispose);
        delete geometries[geometry.id];
        const attribute = wireframeAttributes.get(geometry);
        if (attribute) {
            attributes.remove(attribute);
            wireframeAttributes.delete(geometry);
        }
        bindingStates.releaseStatesOfGeometry(geometry);
        if (geometry.isInstancedBufferGeometry === true) delete geometry._maxInstanceCount;
        //
        info.memory.geometries--;
    }
    function get(object, geometry) {
        if (geometries[geometry.id] === true) return geometry;
        geometry.addEventListener('dispose', onGeometryDispose);
        geometries[geometry.id] = true;
        info.memory.geometries++;
        return geometry;
    }
    function update(geometry) {
        const geometryAttributes = geometry.attributes;
        // Updating index buffer in VAO now. See WebGLBindingStates.
        for(const name in geometryAttributes)attributes.update(geometryAttributes[name], gl.ARRAY_BUFFER);
        // morph targets
        const morphAttributes = geometry.morphAttributes;
        for(const name in morphAttributes){
            const array = morphAttributes[name];
            for(let i = 0, l = array.length; i < l; i++)attributes.update(array[i], gl.ARRAY_BUFFER);
        }
    }
    function updateWireframeAttribute(geometry) {
        const indices = [];
        const geometryIndex = geometry.index;
        const geometryPosition = geometry.attributes.position;
        let version = 0;
        if (geometryIndex !== null) {
            const array = geometryIndex.array;
            version = geometryIndex.version;
            for(let i = 0, l = array.length; i < l; i += 3){
                const a = array[i + 0];
                const b = array[i + 1];
                const c = array[i + 2];
                indices.push(a, b, b, c, c, a);
            }
        } else if (geometryPosition !== undefined) {
            const array = geometryPosition.array;
            version = geometryPosition.version;
            for(let i = 0, l = array.length / 3 - 1; i < l; i += 3){
                const a = i + 0;
                const b = i + 1;
                const c = i + 2;
                indices.push(a, b, b, c, c, a);
            }
        } else return;
        const attribute = new ($d5b33d7c30034067$var$arrayNeedsUint32(indices) ? $d5b33d7c30034067$export$7eb8c9fa25cd5bd6 : $d5b33d7c30034067$export$640a853f68025f2e)(indices, 1);
        attribute.version = version;
        // Updating index buffer in VAO now. See WebGLBindingStates
        //
        const previousAttribute = wireframeAttributes.get(geometry);
        if (previousAttribute) attributes.remove(previousAttribute);
        //
        wireframeAttributes.set(geometry, attribute);
    }
    function getWireframeAttribute(geometry) {
        const currentAttribute = wireframeAttributes.get(geometry);
        if (currentAttribute) {
            const geometryIndex = geometry.index;
            if (geometryIndex !== null) // if the attribute is obsolete, create a new one
            {
                if (currentAttribute.version < geometryIndex.version) updateWireframeAttribute(geometry);
            }
        } else updateWireframeAttribute(geometry);
        return wireframeAttributes.get(geometry);
    }
    return {
        get: get,
        update: update,
        getWireframeAttribute: getWireframeAttribute
    };
}
function $d5b33d7c30034067$var$WebGLIndexedBufferRenderer(gl, extensions, info) {
    let mode;
    function setMode(value) {
        mode = value;
    }
    let type, bytesPerElement;
    function setIndex(value) {
        type = value.type;
        bytesPerElement = value.bytesPerElement;
    }
    function render(start, count) {
        gl.drawElements(mode, count, type, start * bytesPerElement);
        info.update(count, mode, 1);
    }
    function renderInstances(start, count, primcount) {
        if (primcount === 0) return;
        gl.drawElementsInstanced(mode, count, type, start * bytesPerElement, primcount);
        info.update(count, mode, primcount);
    }
    function renderMultiDraw(starts, counts, drawCount) {
        if (drawCount === 0) return;
        const extension = extensions.get('WEBGL_multi_draw');
        extension.multiDrawElementsWEBGL(mode, counts, 0, type, starts, 0, drawCount);
        let elementCount = 0;
        for(let i = 0; i < drawCount; i++)elementCount += counts[i];
        info.update(elementCount, mode, 1);
    }
    function renderMultiDrawInstances(starts, counts, drawCount, primcount) {
        if (drawCount === 0) return;
        const extension = extensions.get('WEBGL_multi_draw');
        if (extension === null) for(let i = 0; i < starts.length; i++)renderInstances(starts[i] / bytesPerElement, counts[i], primcount[i]);
        else {
            extension.multiDrawElementsInstancedWEBGL(mode, counts, 0, type, starts, 0, primcount, 0, drawCount);
            let elementCount = 0;
            for(let i = 0; i < drawCount; i++)elementCount += counts[i] * primcount[i];
            info.update(elementCount, mode, 1);
        }
    }
    //
    this.setMode = setMode;
    this.setIndex = setIndex;
    this.render = render;
    this.renderInstances = renderInstances;
    this.renderMultiDraw = renderMultiDraw;
    this.renderMultiDrawInstances = renderMultiDrawInstances;
}
function $d5b33d7c30034067$var$WebGLInfo(gl) {
    const memory = {
        geometries: 0,
        textures: 0
    };
    const render = {
        frame: 0,
        calls: 0,
        triangles: 0,
        points: 0,
        lines: 0
    };
    function update(count, mode, instanceCount) {
        render.calls++;
        switch(mode){
            case gl.TRIANGLES:
                render.triangles += instanceCount * (count / 3);
                break;
            case gl.LINES:
                render.lines += instanceCount * (count / 2);
                break;
            case gl.LINE_STRIP:
                render.lines += instanceCount * (count - 1);
                break;
            case gl.LINE_LOOP:
                render.lines += instanceCount * count;
                break;
            case gl.POINTS:
                render.points += instanceCount * count;
                break;
            default:
                console.error('THREE.WebGLInfo: Unknown draw mode:', mode);
                break;
        }
    }
    function reset() {
        render.calls = 0;
        render.triangles = 0;
        render.points = 0;
        render.lines = 0;
    }
    return {
        memory: memory,
        render: render,
        programs: null,
        autoReset: true,
        reset: reset,
        update: update
    };
}
function $d5b33d7c30034067$var$WebGLMorphtargets(gl, capabilities, textures) {
    const morphTextures = new WeakMap();
    const morph = new $d5b33d7c30034067$export$fa7daccca11cdbe3();
    function update(object, geometry, program) {
        const objectInfluences = object.morphTargetInfluences;
        // the following encodes morph targets into an array of data textures. Each layer represents a single morph target.
        const morphAttribute = geometry.morphAttributes.position || geometry.morphAttributes.normal || geometry.morphAttributes.color;
        const morphTargetsCount = morphAttribute !== undefined ? morphAttribute.length : 0;
        let entry = morphTextures.get(geometry);
        if (entry === undefined || entry.count !== morphTargetsCount) {
            if (entry !== undefined) entry.texture.dispose();
            const hasMorphPosition = geometry.morphAttributes.position !== undefined;
            const hasMorphNormals = geometry.morphAttributes.normal !== undefined;
            const hasMorphColors = geometry.morphAttributes.color !== undefined;
            const morphTargets = geometry.morphAttributes.position || [];
            const morphNormals = geometry.morphAttributes.normal || [];
            const morphColors = geometry.morphAttributes.color || [];
            let vertexDataCount = 0;
            if (hasMorphPosition === true) vertexDataCount = 1;
            if (hasMorphNormals === true) vertexDataCount = 2;
            if (hasMorphColors === true) vertexDataCount = 3;
            let width = geometry.attributes.position.count * vertexDataCount;
            let height = 1;
            if (width > capabilities.maxTextureSize) {
                height = Math.ceil(width / capabilities.maxTextureSize);
                width = capabilities.maxTextureSize;
            }
            const buffer = new Float32Array(width * height * 4 * morphTargetsCount);
            const texture = new $d5b33d7c30034067$export$dfac6c8e811406a3(buffer, width, height, morphTargetsCount);
            texture.type = $d5b33d7c30034067$export$f6d331659b644596;
            texture.needsUpdate = true;
            // fill buffer
            const vertexDataStride = vertexDataCount * 4;
            for(let i = 0; i < morphTargetsCount; i++){
                const morphTarget = morphTargets[i];
                const morphNormal = morphNormals[i];
                const morphColor = morphColors[i];
                const offset = width * height * 4 * i;
                for(let j = 0; j < morphTarget.count; j++){
                    const stride = j * vertexDataStride;
                    if (hasMorphPosition === true) {
                        morph.fromBufferAttribute(morphTarget, j);
                        buffer[offset + stride + 0] = morph.x;
                        buffer[offset + stride + 1] = morph.y;
                        buffer[offset + stride + 2] = morph.z;
                        buffer[offset + stride + 3] = 0;
                    }
                    if (hasMorphNormals === true) {
                        morph.fromBufferAttribute(morphNormal, j);
                        buffer[offset + stride + 4] = morph.x;
                        buffer[offset + stride + 5] = morph.y;
                        buffer[offset + stride + 6] = morph.z;
                        buffer[offset + stride + 7] = 0;
                    }
                    if (hasMorphColors === true) {
                        morph.fromBufferAttribute(morphColor, j);
                        buffer[offset + stride + 8] = morph.x;
                        buffer[offset + stride + 9] = morph.y;
                        buffer[offset + stride + 10] = morph.z;
                        buffer[offset + stride + 11] = morphColor.itemSize === 4 ? morph.w : 1;
                    }
                }
            }
            entry = {
                count: morphTargetsCount,
                texture: texture,
                size: new $d5b33d7c30034067$export$c977b3e384af9ae1(width, height)
            };
            morphTextures.set(geometry, entry);
            function disposeTexture() {
                texture.dispose();
                morphTextures.delete(geometry);
                geometry.removeEventListener('dispose', disposeTexture);
            }
            geometry.addEventListener('dispose', disposeTexture);
        }
        //
        if (object.isInstancedMesh === true && object.morphTexture !== null) program.getUniforms().setValue(gl, 'morphTexture', object.morphTexture, textures);
        else {
            let morphInfluencesSum = 0;
            for(let i = 0; i < objectInfluences.length; i++)morphInfluencesSum += objectInfluences[i];
            const morphBaseInfluence = geometry.morphTargetsRelative ? 1 : 1 - morphInfluencesSum;
            program.getUniforms().setValue(gl, 'morphTargetBaseInfluence', morphBaseInfluence);
            program.getUniforms().setValue(gl, 'morphTargetInfluences', objectInfluences);
        }
        program.getUniforms().setValue(gl, 'morphTargetsTexture', entry.texture, textures);
        program.getUniforms().setValue(gl, 'morphTargetsTextureSize', entry.size);
    }
    return {
        update: update
    };
}
function $d5b33d7c30034067$var$WebGLObjects(gl, geometries, attributes, info) {
    let updateMap = new WeakMap();
    function update(object) {
        const frame = info.render.frame;
        const geometry = object.geometry;
        const buffergeometry = geometries.get(object, geometry);
        // Update once per frame
        if (updateMap.get(buffergeometry) !== frame) {
            geometries.update(buffergeometry);
            updateMap.set(buffergeometry, frame);
        }
        if (object.isInstancedMesh) {
            if (object.hasEventListener('dispose', onInstancedMeshDispose) === false) object.addEventListener('dispose', onInstancedMeshDispose);
            if (updateMap.get(object) !== frame) {
                attributes.update(object.instanceMatrix, gl.ARRAY_BUFFER);
                if (object.instanceColor !== null) attributes.update(object.instanceColor, gl.ARRAY_BUFFER);
                updateMap.set(object, frame);
            }
        }
        if (object.isSkinnedMesh) {
            const skeleton = object.skeleton;
            if (updateMap.get(skeleton) !== frame) {
                skeleton.update();
                updateMap.set(skeleton, frame);
            }
        }
        return buffergeometry;
    }
    function dispose() {
        updateMap = new WeakMap();
    }
    function onInstancedMeshDispose(event) {
        const instancedMesh = event.target;
        instancedMesh.removeEventListener('dispose', onInstancedMeshDispose);
        attributes.remove(instancedMesh.instanceMatrix);
        if (instancedMesh.instanceColor !== null) attributes.remove(instancedMesh.instanceColor);
    }
    return {
        update: update,
        dispose: dispose
    };
}
class $d5b33d7c30034067$export$fc830aa069cc8c2f extends $d5b33d7c30034067$export$5431306cf43de24a {
    constructor(width, height, type, mapping, wrapS, wrapT, magFilter, minFilter, anisotropy, format = $d5b33d7c30034067$export$c1b6b5136be58045){
        if (format !== $d5b33d7c30034067$export$c1b6b5136be58045 && format !== $d5b33d7c30034067$export$1e113ac2d0905829) throw new Error('DepthTexture format must be either THREE.DepthFormat or THREE.DepthStencilFormat');
        if (type === undefined && format === $d5b33d7c30034067$export$c1b6b5136be58045) type = $d5b33d7c30034067$export$c3c7fc4518ebba96;
        if (type === undefined && format === $d5b33d7c30034067$export$1e113ac2d0905829) type = $d5b33d7c30034067$export$6c8ea339bfab1301;
        super(null, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy);
        this.isDepthTexture = true;
        this.image = {
            width: width,
            height: height
        };
        this.magFilter = magFilter !== undefined ? magFilter : $d5b33d7c30034067$export$727aa5ec3fe39bf0;
        this.minFilter = minFilter !== undefined ? minFilter : $d5b33d7c30034067$export$727aa5ec3fe39bf0;
        this.flipY = false;
        this.generateMipmaps = false;
        this.compareFunction = null;
    }
    copy(source) {
        super.copy(source);
        this.compareFunction = source.compareFunction;
        return this;
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        if (this.compareFunction !== null) data.compareFunction = this.compareFunction;
        return data;
    }
}
/**
 * Uniforms of a program.
 * Those form a tree structure with a special top-level container for the root,
 * which you get by calling 'new WebGLUniforms( gl, program )'.
 *
 *
 * Properties of inner nodes including the top-level container:
 *
 * .seq - array of nested uniforms
 * .map - nested uniforms by name
 *
 *
 * Methods of all nodes except the top-level container:
 *
 * .setValue( gl, value, [textures] )
 *
 * 		uploads a uniform value(s)
 *  	the 'textures' parameter is needed for sampler uniforms
 *
 *
 * Static methods of the top-level container (textures factorizations):
 *
 * .upload( gl, seq, values, textures )
 *
 * 		sets uniforms in 'seq' to 'values[id].value'
 *
 * .seqWithValue( seq, values ) : filteredSeq
 *
 * 		filters 'seq' entries with corresponding entry in values
 *
 *
 * Methods of the top-level container (textures factorizations):
 *
 * .setValue( gl, name, value, textures )
 *
 * 		sets uniform with  name 'name' to 'value'
 *
 * .setOptional( gl, obj, prop )
 *
 * 		like .set for an optional property of the object
 *
 */ const $d5b33d7c30034067$var$emptyTexture = /*@__PURE__*/ new $d5b33d7c30034067$export$5431306cf43de24a();
const $d5b33d7c30034067$var$emptyShadowTexture = /*@__PURE__*/ new $d5b33d7c30034067$export$fc830aa069cc8c2f(1, 1);
const $d5b33d7c30034067$var$emptyArrayTexture = /*@__PURE__*/ new $d5b33d7c30034067$export$dfac6c8e811406a3();
const $d5b33d7c30034067$var$empty3dTexture = /*@__PURE__*/ new $d5b33d7c30034067$export$d7a3086320f856db();
const $d5b33d7c30034067$var$emptyCubeTexture = /*@__PURE__*/ new $d5b33d7c30034067$export$ee2e5a18258a4049();
// --- Utilities ---
// Array Caches (provide typed arrays for temporary by size)
const $d5b33d7c30034067$var$arrayCacheF32 = [];
const $d5b33d7c30034067$var$arrayCacheI32 = [];
// Float32Array caches used for uploading Matrix uniforms
const $d5b33d7c30034067$var$mat4array = new Float32Array(16);
const $d5b33d7c30034067$var$mat3array = new Float32Array(9);
const $d5b33d7c30034067$var$mat2array = new Float32Array(4);
// Flattening for arrays of vectors and matrices
function $d5b33d7c30034067$var$flatten(array, nBlocks, blockSize) {
    const firstElem = array[0];
    if (firstElem <= 0 || firstElem > 0) return array;
    // unoptimized: ! isNaN( firstElem )
    // see http://jacksondunstan.com/articles/983
    const n = nBlocks * blockSize;
    let r = $d5b33d7c30034067$var$arrayCacheF32[n];
    if (r === undefined) {
        r = new Float32Array(n);
        $d5b33d7c30034067$var$arrayCacheF32[n] = r;
    }
    if (nBlocks !== 0) {
        firstElem.toArray(r, 0);
        for(let i = 1, offset = 0; i !== nBlocks; ++i){
            offset += blockSize;
            array[i].toArray(r, offset);
        }
    }
    return r;
}
function $d5b33d7c30034067$var$arraysEqual(a, b) {
    if (a.length !== b.length) return false;
    for(let i = 0, l = a.length; i < l; i++){
        if (a[i] !== b[i]) return false;
    }
    return true;
}
function $d5b33d7c30034067$var$copyArray(a, b) {
    for(let i = 0, l = b.length; i < l; i++)a[i] = b[i];
}
// Texture unit allocation
function $d5b33d7c30034067$var$allocTexUnits(textures, n) {
    let r = $d5b33d7c30034067$var$arrayCacheI32[n];
    if (r === undefined) {
        r = new Int32Array(n);
        $d5b33d7c30034067$var$arrayCacheI32[n] = r;
    }
    for(let i = 0; i !== n; ++i)r[i] = textures.allocateTextureUnit();
    return r;
}
// --- Setters ---
// Note: Defining these methods externally, because they come in a bunch
// and this way their names minify.
// Single scalar
function $d5b33d7c30034067$var$setValueV1f(gl, v) {
    const cache = this.cache;
    if (cache[0] === v) return;
    gl.uniform1f(this.addr, v);
    cache[0] = v;
}
// Single float vector (from flat array or THREE.VectorN)
function $d5b33d7c30034067$var$setValueV2f(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y) {
            gl.uniform2f(this.addr, v.x, v.y);
            cache[0] = v.x;
            cache[1] = v.y;
        }
    } else {
        if ($d5b33d7c30034067$var$arraysEqual(cache, v)) return;
        gl.uniform2fv(this.addr, v);
        $d5b33d7c30034067$var$copyArray(cache, v);
    }
}
function $d5b33d7c30034067$var$setValueV3f(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y || cache[2] !== v.z) {
            gl.uniform3f(this.addr, v.x, v.y, v.z);
            cache[0] = v.x;
            cache[1] = v.y;
            cache[2] = v.z;
        }
    } else if (v.r !== undefined) {
        if (cache[0] !== v.r || cache[1] !== v.g || cache[2] !== v.b) {
            gl.uniform3f(this.addr, v.r, v.g, v.b);
            cache[0] = v.r;
            cache[1] = v.g;
            cache[2] = v.b;
        }
    } else {
        if ($d5b33d7c30034067$var$arraysEqual(cache, v)) return;
        gl.uniform3fv(this.addr, v);
        $d5b33d7c30034067$var$copyArray(cache, v);
    }
}
function $d5b33d7c30034067$var$setValueV4f(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y || cache[2] !== v.z || cache[3] !== v.w) {
            gl.uniform4f(this.addr, v.x, v.y, v.z, v.w);
            cache[0] = v.x;
            cache[1] = v.y;
            cache[2] = v.z;
            cache[3] = v.w;
        }
    } else {
        if ($d5b33d7c30034067$var$arraysEqual(cache, v)) return;
        gl.uniform4fv(this.addr, v);
        $d5b33d7c30034067$var$copyArray(cache, v);
    }
}
// Single matrix (from flat array or THREE.MatrixN)
function $d5b33d7c30034067$var$setValueM2(gl, v) {
    const cache = this.cache;
    const elements = v.elements;
    if (elements === undefined) {
        if ($d5b33d7c30034067$var$arraysEqual(cache, v)) return;
        gl.uniformMatrix2fv(this.addr, false, v);
        $d5b33d7c30034067$var$copyArray(cache, v);
    } else {
        if ($d5b33d7c30034067$var$arraysEqual(cache, elements)) return;
        $d5b33d7c30034067$var$mat2array.set(elements);
        gl.uniformMatrix2fv(this.addr, false, $d5b33d7c30034067$var$mat2array);
        $d5b33d7c30034067$var$copyArray(cache, elements);
    }
}
function $d5b33d7c30034067$var$setValueM3(gl, v) {
    const cache = this.cache;
    const elements = v.elements;
    if (elements === undefined) {
        if ($d5b33d7c30034067$var$arraysEqual(cache, v)) return;
        gl.uniformMatrix3fv(this.addr, false, v);
        $d5b33d7c30034067$var$copyArray(cache, v);
    } else {
        if ($d5b33d7c30034067$var$arraysEqual(cache, elements)) return;
        $d5b33d7c30034067$var$mat3array.set(elements);
        gl.uniformMatrix3fv(this.addr, false, $d5b33d7c30034067$var$mat3array);
        $d5b33d7c30034067$var$copyArray(cache, elements);
    }
}
function $d5b33d7c30034067$var$setValueM4(gl, v) {
    const cache = this.cache;
    const elements = v.elements;
    if (elements === undefined) {
        if ($d5b33d7c30034067$var$arraysEqual(cache, v)) return;
        gl.uniformMatrix4fv(this.addr, false, v);
        $d5b33d7c30034067$var$copyArray(cache, v);
    } else {
        if ($d5b33d7c30034067$var$arraysEqual(cache, elements)) return;
        $d5b33d7c30034067$var$mat4array.set(elements);
        gl.uniformMatrix4fv(this.addr, false, $d5b33d7c30034067$var$mat4array);
        $d5b33d7c30034067$var$copyArray(cache, elements);
    }
}
// Single integer / boolean
function $d5b33d7c30034067$var$setValueV1i(gl, v) {
    const cache = this.cache;
    if (cache[0] === v) return;
    gl.uniform1i(this.addr, v);
    cache[0] = v;
}
// Single integer / boolean vector (from flat array or THREE.VectorN)
function $d5b33d7c30034067$var$setValueV2i(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y) {
            gl.uniform2i(this.addr, v.x, v.y);
            cache[0] = v.x;
            cache[1] = v.y;
        }
    } else {
        if ($d5b33d7c30034067$var$arraysEqual(cache, v)) return;
        gl.uniform2iv(this.addr, v);
        $d5b33d7c30034067$var$copyArray(cache, v);
    }
}
function $d5b33d7c30034067$var$setValueV3i(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y || cache[2] !== v.z) {
            gl.uniform3i(this.addr, v.x, v.y, v.z);
            cache[0] = v.x;
            cache[1] = v.y;
            cache[2] = v.z;
        }
    } else {
        if ($d5b33d7c30034067$var$arraysEqual(cache, v)) return;
        gl.uniform3iv(this.addr, v);
        $d5b33d7c30034067$var$copyArray(cache, v);
    }
}
function $d5b33d7c30034067$var$setValueV4i(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y || cache[2] !== v.z || cache[3] !== v.w) {
            gl.uniform4i(this.addr, v.x, v.y, v.z, v.w);
            cache[0] = v.x;
            cache[1] = v.y;
            cache[2] = v.z;
            cache[3] = v.w;
        }
    } else {
        if ($d5b33d7c30034067$var$arraysEqual(cache, v)) return;
        gl.uniform4iv(this.addr, v);
        $d5b33d7c30034067$var$copyArray(cache, v);
    }
}
// Single unsigned integer
function $d5b33d7c30034067$var$setValueV1ui(gl, v) {
    const cache = this.cache;
    if (cache[0] === v) return;
    gl.uniform1ui(this.addr, v);
    cache[0] = v;
}
// Single unsigned integer vector (from flat array or THREE.VectorN)
function $d5b33d7c30034067$var$setValueV2ui(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y) {
            gl.uniform2ui(this.addr, v.x, v.y);
            cache[0] = v.x;
            cache[1] = v.y;
        }
    } else {
        if ($d5b33d7c30034067$var$arraysEqual(cache, v)) return;
        gl.uniform2uiv(this.addr, v);
        $d5b33d7c30034067$var$copyArray(cache, v);
    }
}
function $d5b33d7c30034067$var$setValueV3ui(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y || cache[2] !== v.z) {
            gl.uniform3ui(this.addr, v.x, v.y, v.z);
            cache[0] = v.x;
            cache[1] = v.y;
            cache[2] = v.z;
        }
    } else {
        if ($d5b33d7c30034067$var$arraysEqual(cache, v)) return;
        gl.uniform3uiv(this.addr, v);
        $d5b33d7c30034067$var$copyArray(cache, v);
    }
}
function $d5b33d7c30034067$var$setValueV4ui(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y || cache[2] !== v.z || cache[3] !== v.w) {
            gl.uniform4ui(this.addr, v.x, v.y, v.z, v.w);
            cache[0] = v.x;
            cache[1] = v.y;
            cache[2] = v.z;
            cache[3] = v.w;
        }
    } else {
        if ($d5b33d7c30034067$var$arraysEqual(cache, v)) return;
        gl.uniform4uiv(this.addr, v);
        $d5b33d7c30034067$var$copyArray(cache, v);
    }
}
// Single texture (2D / Cube)
function $d5b33d7c30034067$var$setValueT1(gl, v, textures) {
    const cache = this.cache;
    const unit = textures.allocateTextureUnit();
    if (cache[0] !== unit) {
        gl.uniform1i(this.addr, unit);
        cache[0] = unit;
    }
    let emptyTexture2D;
    if (this.type === gl.SAMPLER_2D_SHADOW) {
        $d5b33d7c30034067$var$emptyShadowTexture.compareFunction = $d5b33d7c30034067$export$64eea11eb407ddf1; // #28670
        emptyTexture2D = $d5b33d7c30034067$var$emptyShadowTexture;
    } else emptyTexture2D = $d5b33d7c30034067$var$emptyTexture;
    textures.setTexture2D(v || emptyTexture2D, unit);
}
function $d5b33d7c30034067$var$setValueT3D1(gl, v, textures) {
    const cache = this.cache;
    const unit = textures.allocateTextureUnit();
    if (cache[0] !== unit) {
        gl.uniform1i(this.addr, unit);
        cache[0] = unit;
    }
    textures.setTexture3D(v || $d5b33d7c30034067$var$empty3dTexture, unit);
}
function $d5b33d7c30034067$var$setValueT6(gl, v, textures) {
    const cache = this.cache;
    const unit = textures.allocateTextureUnit();
    if (cache[0] !== unit) {
        gl.uniform1i(this.addr, unit);
        cache[0] = unit;
    }
    textures.setTextureCube(v || $d5b33d7c30034067$var$emptyCubeTexture, unit);
}
function $d5b33d7c30034067$var$setValueT2DArray1(gl, v, textures) {
    const cache = this.cache;
    const unit = textures.allocateTextureUnit();
    if (cache[0] !== unit) {
        gl.uniform1i(this.addr, unit);
        cache[0] = unit;
    }
    textures.setTexture2DArray(v || $d5b33d7c30034067$var$emptyArrayTexture, unit);
}
// Helper to pick the right setter for the singular case
function $d5b33d7c30034067$var$getSingularSetter(type) {
    switch(type){
        case 0x1406:
            return $d5b33d7c30034067$var$setValueV1f; // FLOAT
        case 0x8b50:
            return $d5b33d7c30034067$var$setValueV2f; // _VEC2
        case 0x8b51:
            return $d5b33d7c30034067$var$setValueV3f; // _VEC3
        case 0x8b52:
            return $d5b33d7c30034067$var$setValueV4f; // _VEC4
        case 0x8b5a:
            return $d5b33d7c30034067$var$setValueM2; // _MAT2
        case 0x8b5b:
            return $d5b33d7c30034067$var$setValueM3; // _MAT3
        case 0x8b5c:
            return $d5b33d7c30034067$var$setValueM4; // _MAT4
        case 0x1404:
        case 0x8b56:
            return $d5b33d7c30034067$var$setValueV1i; // INT, BOOL
        case 0x8b53:
        case 0x8b57:
            return $d5b33d7c30034067$var$setValueV2i; // _VEC2
        case 0x8b54:
        case 0x8b58:
            return $d5b33d7c30034067$var$setValueV3i; // _VEC3
        case 0x8b55:
        case 0x8b59:
            return $d5b33d7c30034067$var$setValueV4i; // _VEC4
        case 0x1405:
            return $d5b33d7c30034067$var$setValueV1ui; // UINT
        case 0x8dc6:
            return $d5b33d7c30034067$var$setValueV2ui; // _VEC2
        case 0x8dc7:
            return $d5b33d7c30034067$var$setValueV3ui; // _VEC3
        case 0x8dc8:
            return $d5b33d7c30034067$var$setValueV4ui; // _VEC4
        case 0x8b5e:
        case 0x8d66:
        case 0x8dca:
        case 0x8dd2:
        case 0x8b62:
            return $d5b33d7c30034067$var$setValueT1;
        case 0x8b5f:
        case 0x8dcb:
        case 0x8dd3:
            return $d5b33d7c30034067$var$setValueT3D1;
        case 0x8b60:
        case 0x8dcc:
        case 0x8dd4:
        case 0x8dc5:
            return $d5b33d7c30034067$var$setValueT6;
        case 0x8dc1:
        case 0x8dcf:
        case 0x8dd7:
        case 0x8dc4:
            return $d5b33d7c30034067$var$setValueT2DArray1;
    }
}
// Array of scalars
function $d5b33d7c30034067$var$setValueV1fArray(gl, v) {
    gl.uniform1fv(this.addr, v);
}
// Array of vectors (from flat array or array of THREE.VectorN)
function $d5b33d7c30034067$var$setValueV2fArray(gl, v) {
    const data = $d5b33d7c30034067$var$flatten(v, this.size, 2);
    gl.uniform2fv(this.addr, data);
}
function $d5b33d7c30034067$var$setValueV3fArray(gl, v) {
    const data = $d5b33d7c30034067$var$flatten(v, this.size, 3);
    gl.uniform3fv(this.addr, data);
}
function $d5b33d7c30034067$var$setValueV4fArray(gl, v) {
    const data = $d5b33d7c30034067$var$flatten(v, this.size, 4);
    gl.uniform4fv(this.addr, data);
}
// Array of matrices (from flat array or array of THREE.MatrixN)
function $d5b33d7c30034067$var$setValueM2Array(gl, v) {
    const data = $d5b33d7c30034067$var$flatten(v, this.size, 4);
    gl.uniformMatrix2fv(this.addr, false, data);
}
function $d5b33d7c30034067$var$setValueM3Array(gl, v) {
    const data = $d5b33d7c30034067$var$flatten(v, this.size, 9);
    gl.uniformMatrix3fv(this.addr, false, data);
}
function $d5b33d7c30034067$var$setValueM4Array(gl, v) {
    const data = $d5b33d7c30034067$var$flatten(v, this.size, 16);
    gl.uniformMatrix4fv(this.addr, false, data);
}
// Array of integer / boolean
function $d5b33d7c30034067$var$setValueV1iArray(gl, v) {
    gl.uniform1iv(this.addr, v);
}
// Array of integer / boolean vectors (from flat array)
function $d5b33d7c30034067$var$setValueV2iArray(gl, v) {
    gl.uniform2iv(this.addr, v);
}
function $d5b33d7c30034067$var$setValueV3iArray(gl, v) {
    gl.uniform3iv(this.addr, v);
}
function $d5b33d7c30034067$var$setValueV4iArray(gl, v) {
    gl.uniform4iv(this.addr, v);
}
// Array of unsigned integer
function $d5b33d7c30034067$var$setValueV1uiArray(gl, v) {
    gl.uniform1uiv(this.addr, v);
}
// Array of unsigned integer vectors (from flat array)
function $d5b33d7c30034067$var$setValueV2uiArray(gl, v) {
    gl.uniform2uiv(this.addr, v);
}
function $d5b33d7c30034067$var$setValueV3uiArray(gl, v) {
    gl.uniform3uiv(this.addr, v);
}
function $d5b33d7c30034067$var$setValueV4uiArray(gl, v) {
    gl.uniform4uiv(this.addr, v);
}
// Array of textures (2D / 3D / Cube / 2DArray)
function $d5b33d7c30034067$var$setValueT1Array(gl, v, textures) {
    const cache = this.cache;
    const n = v.length;
    const units = $d5b33d7c30034067$var$allocTexUnits(textures, n);
    if (!$d5b33d7c30034067$var$arraysEqual(cache, units)) {
        gl.uniform1iv(this.addr, units);
        $d5b33d7c30034067$var$copyArray(cache, units);
    }
    for(let i = 0; i !== n; ++i)textures.setTexture2D(v[i] || $d5b33d7c30034067$var$emptyTexture, units[i]);
}
function $d5b33d7c30034067$var$setValueT3DArray(gl, v, textures) {
    const cache = this.cache;
    const n = v.length;
    const units = $d5b33d7c30034067$var$allocTexUnits(textures, n);
    if (!$d5b33d7c30034067$var$arraysEqual(cache, units)) {
        gl.uniform1iv(this.addr, units);
        $d5b33d7c30034067$var$copyArray(cache, units);
    }
    for(let i = 0; i !== n; ++i)textures.setTexture3D(v[i] || $d5b33d7c30034067$var$empty3dTexture, units[i]);
}
function $d5b33d7c30034067$var$setValueT6Array(gl, v, textures) {
    const cache = this.cache;
    const n = v.length;
    const units = $d5b33d7c30034067$var$allocTexUnits(textures, n);
    if (!$d5b33d7c30034067$var$arraysEqual(cache, units)) {
        gl.uniform1iv(this.addr, units);
        $d5b33d7c30034067$var$copyArray(cache, units);
    }
    for(let i = 0; i !== n; ++i)textures.setTextureCube(v[i] || $d5b33d7c30034067$var$emptyCubeTexture, units[i]);
}
function $d5b33d7c30034067$var$setValueT2DArrayArray(gl, v, textures) {
    const cache = this.cache;
    const n = v.length;
    const units = $d5b33d7c30034067$var$allocTexUnits(textures, n);
    if (!$d5b33d7c30034067$var$arraysEqual(cache, units)) {
        gl.uniform1iv(this.addr, units);
        $d5b33d7c30034067$var$copyArray(cache, units);
    }
    for(let i = 0; i !== n; ++i)textures.setTexture2DArray(v[i] || $d5b33d7c30034067$var$emptyArrayTexture, units[i]);
}
// Helper to pick the right setter for a pure (bottom-level) array
function $d5b33d7c30034067$var$getPureArraySetter(type) {
    switch(type){
        case 0x1406:
            return $d5b33d7c30034067$var$setValueV1fArray; // FLOAT
        case 0x8b50:
            return $d5b33d7c30034067$var$setValueV2fArray; // _VEC2
        case 0x8b51:
            return $d5b33d7c30034067$var$setValueV3fArray; // _VEC3
        case 0x8b52:
            return $d5b33d7c30034067$var$setValueV4fArray; // _VEC4
        case 0x8b5a:
            return $d5b33d7c30034067$var$setValueM2Array; // _MAT2
        case 0x8b5b:
            return $d5b33d7c30034067$var$setValueM3Array; // _MAT3
        case 0x8b5c:
            return $d5b33d7c30034067$var$setValueM4Array; // _MAT4
        case 0x1404:
        case 0x8b56:
            return $d5b33d7c30034067$var$setValueV1iArray; // INT, BOOL
        case 0x8b53:
        case 0x8b57:
            return $d5b33d7c30034067$var$setValueV2iArray; // _VEC2
        case 0x8b54:
        case 0x8b58:
            return $d5b33d7c30034067$var$setValueV3iArray; // _VEC3
        case 0x8b55:
        case 0x8b59:
            return $d5b33d7c30034067$var$setValueV4iArray; // _VEC4
        case 0x1405:
            return $d5b33d7c30034067$var$setValueV1uiArray; // UINT
        case 0x8dc6:
            return $d5b33d7c30034067$var$setValueV2uiArray; // _VEC2
        case 0x8dc7:
            return $d5b33d7c30034067$var$setValueV3uiArray; // _VEC3
        case 0x8dc8:
            return $d5b33d7c30034067$var$setValueV4uiArray; // _VEC4
        case 0x8b5e:
        case 0x8d66:
        case 0x8dca:
        case 0x8dd2:
        case 0x8b62:
            return $d5b33d7c30034067$var$setValueT1Array;
        case 0x8b5f:
        case 0x8dcb:
        case 0x8dd3:
            return $d5b33d7c30034067$var$setValueT3DArray;
        case 0x8b60:
        case 0x8dcc:
        case 0x8dd4:
        case 0x8dc5:
            return $d5b33d7c30034067$var$setValueT6Array;
        case 0x8dc1:
        case 0x8dcf:
        case 0x8dd7:
        case 0x8dc4:
            return $d5b33d7c30034067$var$setValueT2DArrayArray;
    }
}
// --- Uniform Classes ---
class $d5b33d7c30034067$var$SingleUniform {
    constructor(id, activeInfo, addr){
        this.id = id;
        this.addr = addr;
        this.cache = [];
        this.type = activeInfo.type;
        this.setValue = $d5b33d7c30034067$var$getSingularSetter(activeInfo.type);
    // this.path = activeInfo.name; // DEBUG
    }
}
class $d5b33d7c30034067$var$PureArrayUniform {
    constructor(id, activeInfo, addr){
        this.id = id;
        this.addr = addr;
        this.cache = [];
        this.type = activeInfo.type;
        this.size = activeInfo.size;
        this.setValue = $d5b33d7c30034067$var$getPureArraySetter(activeInfo.type);
    // this.path = activeInfo.name; // DEBUG
    }
}
class $d5b33d7c30034067$var$StructuredUniform {
    constructor(id){
        this.id = id;
        this.seq = [];
        this.map = {};
    }
    setValue(gl, value, textures) {
        const seq = this.seq;
        for(let i = 0, n = seq.length; i !== n; ++i){
            const u = seq[i];
            u.setValue(gl, value[u.id], textures);
        }
    }
}
// --- Top-level ---
// Parser - builds up the property tree from the path strings
const $d5b33d7c30034067$var$RePathPart = /(\w+)(\])?(\[|\.)?/g;
// extracts
// 	- the identifier (member name or array index)
//  - followed by an optional right bracket (found when array index)
//  - followed by an optional left bracket or dot (type of subscript)
//
// Note: These portions can be read in a non-overlapping fashion and
// allow straightforward parsing of the hierarchy that WebGL encodes
// in the uniform names.
function $d5b33d7c30034067$var$addUniform(container, uniformObject) {
    container.seq.push(uniformObject);
    container.map[uniformObject.id] = uniformObject;
}
function $d5b33d7c30034067$var$parseUniform(activeInfo, addr, container) {
    const path = activeInfo.name, pathLength = path.length;
    // reset RegExp object, because of the early exit of a previous run
    $d5b33d7c30034067$var$RePathPart.lastIndex = 0;
    while(true){
        const match = $d5b33d7c30034067$var$RePathPart.exec(path), matchEnd = $d5b33d7c30034067$var$RePathPart.lastIndex;
        let id = match[1];
        const idIsIndex = match[2] === ']', subscript = match[3];
        if (idIsIndex) id = id | 0; // convert to integer
        if (subscript === undefined || subscript === '[' && matchEnd + 2 === pathLength) {
            // bare name or "pure" bottom-level array "[0]" suffix
            $d5b33d7c30034067$var$addUniform(container, subscript === undefined ? new $d5b33d7c30034067$var$SingleUniform(id, activeInfo, addr) : new $d5b33d7c30034067$var$PureArrayUniform(id, activeInfo, addr));
            break;
        } else {
            // step into inner node / create it in case it doesn't exist
            const map = container.map;
            let next = map[id];
            if (next === undefined) {
                next = new $d5b33d7c30034067$var$StructuredUniform(id);
                $d5b33d7c30034067$var$addUniform(container, next);
            }
            container = next;
        }
    }
}
// Root Container
class $d5b33d7c30034067$var$WebGLUniforms {
    constructor(gl, program){
        this.seq = [];
        this.map = {};
        const n = gl.getProgramParameter(program, gl.ACTIVE_UNIFORMS);
        for(let i = 0; i < n; ++i){
            const info = gl.getActiveUniform(program, i), addr = gl.getUniformLocation(program, info.name);
            $d5b33d7c30034067$var$parseUniform(info, addr, this);
        }
    }
    setValue(gl, name, value, textures) {
        const u = this.map[name];
        if (u !== undefined) u.setValue(gl, value, textures);
    }
    setOptional(gl, object, name) {
        const v = object[name];
        if (v !== undefined) this.setValue(gl, name, v);
    }
    static upload(gl, seq, values, textures) {
        for(let i = 0, n = seq.length; i !== n; ++i){
            const u = seq[i], v = values[u.id];
            if (v.needsUpdate !== false) // note: always updating when .needsUpdate is undefined
            u.setValue(gl, v.value, textures);
        }
    }
    static seqWithValue(seq, values) {
        const r = [];
        for(let i = 0, n = seq.length; i !== n; ++i){
            const u = seq[i];
            if (u.id in values) r.push(u);
        }
        return r;
    }
}
function $d5b33d7c30034067$var$WebGLShader(gl, type, string) {
    const shader = gl.createShader(type);
    gl.shaderSource(shader, string);
    gl.compileShader(shader);
    return shader;
}
// From https://www.khronos.org/registry/webgl/extensions/KHR_parallel_shader_compile/
const $d5b33d7c30034067$var$COMPLETION_STATUS_KHR = 0x91B1;
let $d5b33d7c30034067$var$programIdCount = 0;
function $d5b33d7c30034067$var$handleSource(string, errorLine) {
    const lines = string.split('\n');
    const lines2 = [];
    const from = Math.max(errorLine - 6, 0);
    const to = Math.min(errorLine + 6, lines.length);
    for(let i = from; i < to; i++){
        const line = i + 1;
        lines2.push(`${line === errorLine ? '>' : ' '} ${line}: ${lines[i]}`);
    }
    return lines2.join('\n');
}
const $d5b33d7c30034067$var$_m0 = /*@__PURE__*/ new $d5b33d7c30034067$export$8ff26dafa08918();
function $d5b33d7c30034067$var$getEncodingComponents(colorSpace) {
    $d5b33d7c30034067$export$5e6fd513f44698c._getMatrix($d5b33d7c30034067$var$_m0, $d5b33d7c30034067$export$5e6fd513f44698c.workingColorSpace, colorSpace);
    const encodingMatrix = `mat3( ${$d5b33d7c30034067$var$_m0.elements.map((v)=>v.toFixed(4))} )`;
    switch($d5b33d7c30034067$export$5e6fd513f44698c.getTransfer(colorSpace)){
        case $d5b33d7c30034067$export$f197347d588c1b4a:
            return [
                encodingMatrix,
                'LinearTransferOETF'
            ];
        case $d5b33d7c30034067$export$8d0a61916cc26abb:
            return [
                encodingMatrix,
                'sRGBTransferOETF'
            ];
        default:
            console.warn('THREE.WebGLProgram: Unsupported color space: ', colorSpace);
            return [
                encodingMatrix,
                'LinearTransferOETF'
            ];
    }
}
function $d5b33d7c30034067$var$getShaderErrors(gl, shader, type) {
    const status = gl.getShaderParameter(shader, gl.COMPILE_STATUS);
    const errors = gl.getShaderInfoLog(shader).trim();
    if (status && errors === '') return '';
    const errorMatches = /ERROR: 0:(\d+)/.exec(errors);
    if (errorMatches) {
        // --enable-privileged-webgl-extension
        // console.log( '**' + type + '**', gl.getExtension( 'WEBGL_debug_shaders' ).getTranslatedShaderSource( shader ) );
        const errorLine = parseInt(errorMatches[1]);
        return type.toUpperCase() + '\n\n' + errors + '\n\n' + $d5b33d7c30034067$var$handleSource(gl.getShaderSource(shader), errorLine);
    } else return errors;
}
function $d5b33d7c30034067$var$getTexelEncodingFunction(functionName, colorSpace) {
    const components = $d5b33d7c30034067$var$getEncodingComponents(colorSpace);
    return [
        `vec4 ${functionName}( vec4 value ) {`,
        `	return ${components[1]}( vec4( value.rgb * ${components[0]}, value.a ) );`,
        '}'
    ].join('\n');
}
function $d5b33d7c30034067$var$getToneMappingFunction(functionName, toneMapping) {
    let toneMappingName;
    switch(toneMapping){
        case $d5b33d7c30034067$export$98f52c2a46c598ca:
            toneMappingName = 'Linear';
            break;
        case $d5b33d7c30034067$export$74b25e54b3bcd548:
            toneMappingName = 'Reinhard';
            break;
        case $d5b33d7c30034067$export$932b3dd283d4a366:
            toneMappingName = 'Cineon';
            break;
        case $d5b33d7c30034067$export$a0d98fe6d7e4af64:
            toneMappingName = 'ACESFilmic';
            break;
        case $d5b33d7c30034067$export$212d53a513a325b2:
            toneMappingName = 'AgX';
            break;
        case $d5b33d7c30034067$export$f2863e1668a8e317:
            toneMappingName = 'Neutral';
            break;
        case $d5b33d7c30034067$export$2c7b09c1e9abfb5e:
            toneMappingName = 'Custom';
            break;
        default:
            console.warn('THREE.WebGLProgram: Unsupported toneMapping:', toneMapping);
            toneMappingName = 'Linear';
    }
    return 'vec3 ' + functionName + '( vec3 color ) { return ' + toneMappingName + 'ToneMapping( color ); }';
}
const $d5b33d7c30034067$var$_v0$1 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
function $d5b33d7c30034067$var$getLuminanceFunction() {
    $d5b33d7c30034067$export$5e6fd513f44698c.getLuminanceCoefficients($d5b33d7c30034067$var$_v0$1);
    const r = $d5b33d7c30034067$var$_v0$1.x.toFixed(4);
    const g = $d5b33d7c30034067$var$_v0$1.y.toFixed(4);
    const b = $d5b33d7c30034067$var$_v0$1.z.toFixed(4);
    return [
        'float luminance( const in vec3 rgb ) {',
        `	const vec3 weights = vec3( ${r}, ${g}, ${b} );`,
        '	return dot( weights, rgb );',
        '}'
    ].join('\n');
}
function $d5b33d7c30034067$var$generateVertexExtensions(parameters) {
    const chunks = [
        parameters.extensionClipCullDistance ? '#extension GL_ANGLE_clip_cull_distance : require' : '',
        parameters.extensionMultiDraw ? '#extension GL_ANGLE_multi_draw : require' : ''
    ];
    return chunks.filter($d5b33d7c30034067$var$filterEmptyLine).join('\n');
}
function $d5b33d7c30034067$var$generateDefines(defines) {
    const chunks = [];
    for(const name in defines){
        const value = defines[name];
        if (value === false) continue;
        chunks.push('#define ' + name + ' ' + value);
    }
    return chunks.join('\n');
}
function $d5b33d7c30034067$var$fetchAttributeLocations(gl, program) {
    const attributes = {};
    const n = gl.getProgramParameter(program, gl.ACTIVE_ATTRIBUTES);
    for(let i = 0; i < n; i++){
        const info = gl.getActiveAttrib(program, i);
        const name = info.name;
        let locationSize = 1;
        if (info.type === gl.FLOAT_MAT2) locationSize = 2;
        if (info.type === gl.FLOAT_MAT3) locationSize = 3;
        if (info.type === gl.FLOAT_MAT4) locationSize = 4;
        // console.log( 'THREE.WebGLProgram: ACTIVE VERTEX ATTRIBUTE:', name, i );
        attributes[name] = {
            type: info.type,
            location: gl.getAttribLocation(program, name),
            locationSize: locationSize
        };
    }
    return attributes;
}
function $d5b33d7c30034067$var$filterEmptyLine(string) {
    return string !== '';
}
function $d5b33d7c30034067$var$replaceLightNums(string, parameters) {
    const numSpotLightCoords = parameters.numSpotLightShadows + parameters.numSpotLightMaps - parameters.numSpotLightShadowsWithMaps;
    return string.replace(/NUM_DIR_LIGHTS/g, parameters.numDirLights).replace(/NUM_SPOT_LIGHTS/g, parameters.numSpotLights).replace(/NUM_SPOT_LIGHT_MAPS/g, parameters.numSpotLightMaps).replace(/NUM_SPOT_LIGHT_COORDS/g, numSpotLightCoords).replace(/NUM_RECT_AREA_LIGHTS/g, parameters.numRectAreaLights).replace(/NUM_POINT_LIGHTS/g, parameters.numPointLights).replace(/NUM_HEMI_LIGHTS/g, parameters.numHemiLights).replace(/NUM_DIR_LIGHT_SHADOWS/g, parameters.numDirLightShadows).replace(/NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS/g, parameters.numSpotLightShadowsWithMaps).replace(/NUM_SPOT_LIGHT_SHADOWS/g, parameters.numSpotLightShadows).replace(/NUM_POINT_LIGHT_SHADOWS/g, parameters.numPointLightShadows);
}
function $d5b33d7c30034067$var$replaceClippingPlaneNums(string, parameters) {
    return string.replace(/NUM_CLIPPING_PLANES/g, parameters.numClippingPlanes).replace(/UNION_CLIPPING_PLANES/g, parameters.numClippingPlanes - parameters.numClipIntersection);
}
// Resolve Includes
const $d5b33d7c30034067$var$includePattern = /^[ \t]*#include +<([\w\d./]+)>/gm;
function $d5b33d7c30034067$var$resolveIncludes(string) {
    return string.replace($d5b33d7c30034067$var$includePattern, $d5b33d7c30034067$var$includeReplacer);
}
const $d5b33d7c30034067$var$shaderChunkMap = new Map();
function $d5b33d7c30034067$var$includeReplacer(match, include) {
    let string = $d5b33d7c30034067$export$955f9f2e84c43c8b[include];
    if (string === undefined) {
        const newInclude = $d5b33d7c30034067$var$shaderChunkMap.get(include);
        if (newInclude !== undefined) {
            string = $d5b33d7c30034067$export$955f9f2e84c43c8b[newInclude];
            console.warn('THREE.WebGLRenderer: Shader chunk "%s" has been deprecated. Use "%s" instead.', include, newInclude);
        } else throw new Error('Can not resolve #include <' + include + '>');
    }
    return $d5b33d7c30034067$var$resolveIncludes(string);
}
// Unroll Loops
const $d5b33d7c30034067$var$unrollLoopPattern = /#pragma unroll_loop_start\s+for\s*\(\s*int\s+i\s*=\s*(\d+)\s*;\s*i\s*<\s*(\d+)\s*;\s*i\s*\+\+\s*\)\s*{([\s\S]+?)}\s+#pragma unroll_loop_end/g;
function $d5b33d7c30034067$var$unrollLoops(string) {
    return string.replace($d5b33d7c30034067$var$unrollLoopPattern, $d5b33d7c30034067$var$loopReplacer);
}
function $d5b33d7c30034067$var$loopReplacer(match, start, end, snippet) {
    let string = '';
    for(let i = parseInt(start); i < parseInt(end); i++)string += snippet.replace(/\[\s*i\s*\]/g, '[ ' + i + ' ]').replace(/UNROLLED_LOOP_INDEX/g, i);
    return string;
}
//
function $d5b33d7c30034067$var$generatePrecision(parameters) {
    let precisionstring = `precision ${parameters.precision} float;
	precision ${parameters.precision} int;
	precision ${parameters.precision} sampler2D;
	precision ${parameters.precision} samplerCube;
	precision ${parameters.precision} sampler3D;
	precision ${parameters.precision} sampler2DArray;
	precision ${parameters.precision} sampler2DShadow;
	precision ${parameters.precision} samplerCubeShadow;
	precision ${parameters.precision} sampler2DArrayShadow;
	precision ${parameters.precision} isampler2D;
	precision ${parameters.precision} isampler3D;
	precision ${parameters.precision} isamplerCube;
	precision ${parameters.precision} isampler2DArray;
	precision ${parameters.precision} usampler2D;
	precision ${parameters.precision} usampler3D;
	precision ${parameters.precision} usamplerCube;
	precision ${parameters.precision} usampler2DArray;
	`;
    if (parameters.precision === 'highp') precisionstring += '\n#define HIGH_PRECISION';
    else if (parameters.precision === 'mediump') precisionstring += '\n#define MEDIUM_PRECISION';
    else if (parameters.precision === 'lowp') precisionstring += '\n#define LOW_PRECISION';
    return precisionstring;
}
function $d5b33d7c30034067$var$generateShadowMapTypeDefine(parameters) {
    let shadowMapTypeDefine = 'SHADOWMAP_TYPE_BASIC';
    if (parameters.shadowMapType === $d5b33d7c30034067$export$5813f879eee7cd88) shadowMapTypeDefine = 'SHADOWMAP_TYPE_PCF';
    else if (parameters.shadowMapType === $d5b33d7c30034067$export$a47c4b43a1be34f0) shadowMapTypeDefine = 'SHADOWMAP_TYPE_PCF_SOFT';
    else if (parameters.shadowMapType === $d5b33d7c30034067$export$896ae1ade6c829c4) shadowMapTypeDefine = 'SHADOWMAP_TYPE_VSM';
    return shadowMapTypeDefine;
}
function $d5b33d7c30034067$var$generateEnvMapTypeDefine(parameters) {
    let envMapTypeDefine = 'ENVMAP_TYPE_CUBE';
    if (parameters.envMap) switch(parameters.envMapMode){
        case $d5b33d7c30034067$export$8759762a6477f2c4:
        case $d5b33d7c30034067$export$dc59f8aed047f61d:
            envMapTypeDefine = 'ENVMAP_TYPE_CUBE';
            break;
        case $d5b33d7c30034067$export$dbf3e70ff37af79:
            envMapTypeDefine = 'ENVMAP_TYPE_CUBE_UV';
            break;
    }
    return envMapTypeDefine;
}
function $d5b33d7c30034067$var$generateEnvMapModeDefine(parameters) {
    let envMapModeDefine = 'ENVMAP_MODE_REFLECTION';
    if (parameters.envMap) switch(parameters.envMapMode){
        case $d5b33d7c30034067$export$dc59f8aed047f61d:
            envMapModeDefine = 'ENVMAP_MODE_REFRACTION';
            break;
    }
    return envMapModeDefine;
}
function $d5b33d7c30034067$var$generateEnvMapBlendingDefine(parameters) {
    let envMapBlendingDefine = 'ENVMAP_BLENDING_NONE';
    if (parameters.envMap) switch(parameters.combine){
        case $d5b33d7c30034067$export$e50ac29801f1774d:
            envMapBlendingDefine = 'ENVMAP_BLENDING_MULTIPLY';
            break;
        case $d5b33d7c30034067$export$9f9d94f963c85479:
            envMapBlendingDefine = 'ENVMAP_BLENDING_MIX';
            break;
        case $d5b33d7c30034067$export$e641dc52bc3494aa:
            envMapBlendingDefine = 'ENVMAP_BLENDING_ADD';
            break;
    }
    return envMapBlendingDefine;
}
function $d5b33d7c30034067$var$generateCubeUVSize(parameters) {
    const imageHeight = parameters.envMapCubeUVHeight;
    if (imageHeight === null) return null;
    const maxMip = Math.log2(imageHeight) - 2;
    const texelHeight = 1.0 / imageHeight;
    const texelWidth = 1.0 / (3 * Math.max(Math.pow(2, maxMip), 112));
    return {
        texelWidth: texelWidth,
        texelHeight: texelHeight,
        maxMip: maxMip
    };
}
function $d5b33d7c30034067$var$WebGLProgram(renderer, cacheKey, parameters, bindingStates) {
    // TODO Send this event to Three.js DevTools
    // console.log( 'WebGLProgram', cacheKey );
    const gl = renderer.getContext();
    const defines = parameters.defines;
    let vertexShader = parameters.vertexShader;
    let fragmentShader = parameters.fragmentShader;
    const shadowMapTypeDefine = $d5b33d7c30034067$var$generateShadowMapTypeDefine(parameters);
    const envMapTypeDefine = $d5b33d7c30034067$var$generateEnvMapTypeDefine(parameters);
    const envMapModeDefine = $d5b33d7c30034067$var$generateEnvMapModeDefine(parameters);
    const envMapBlendingDefine = $d5b33d7c30034067$var$generateEnvMapBlendingDefine(parameters);
    const envMapCubeUVSize = $d5b33d7c30034067$var$generateCubeUVSize(parameters);
    const customVertexExtensions = $d5b33d7c30034067$var$generateVertexExtensions(parameters);
    const customDefines = $d5b33d7c30034067$var$generateDefines(defines);
    const program = gl.createProgram();
    let prefixVertex, prefixFragment;
    let versionString = parameters.glslVersion ? '#version ' + parameters.glslVersion + '\n' : '';
    if (parameters.isRawShaderMaterial) {
        prefixVertex = [
            '#define SHADER_TYPE ' + parameters.shaderType,
            '#define SHADER_NAME ' + parameters.shaderName,
            customDefines
        ].filter($d5b33d7c30034067$var$filterEmptyLine).join('\n');
        if (prefixVertex.length > 0) prefixVertex += '\n';
        prefixFragment = [
            '#define SHADER_TYPE ' + parameters.shaderType,
            '#define SHADER_NAME ' + parameters.shaderName,
            customDefines
        ].filter($d5b33d7c30034067$var$filterEmptyLine).join('\n');
        if (prefixFragment.length > 0) prefixFragment += '\n';
    } else {
        prefixVertex = [
            $d5b33d7c30034067$var$generatePrecision(parameters),
            '#define SHADER_TYPE ' + parameters.shaderType,
            '#define SHADER_NAME ' + parameters.shaderName,
            customDefines,
            parameters.extensionClipCullDistance ? '#define USE_CLIP_DISTANCE' : '',
            parameters.batching ? '#define USE_BATCHING' : '',
            parameters.batchingColor ? '#define USE_BATCHING_COLOR' : '',
            parameters.instancing ? '#define USE_INSTANCING' : '',
            parameters.instancingColor ? '#define USE_INSTANCING_COLOR' : '',
            parameters.instancingMorph ? '#define USE_INSTANCING_MORPH' : '',
            parameters.useFog && parameters.fog ? '#define USE_FOG' : '',
            parameters.useFog && parameters.fogExp2 ? '#define FOG_EXP2' : '',
            parameters.map ? '#define USE_MAP' : '',
            parameters.envMap ? '#define USE_ENVMAP' : '',
            parameters.envMap ? '#define ' + envMapModeDefine : '',
            parameters.lightMap ? '#define USE_LIGHTMAP' : '',
            parameters.aoMap ? '#define USE_AOMAP' : '',
            parameters.bumpMap ? '#define USE_BUMPMAP' : '',
            parameters.normalMap ? '#define USE_NORMALMAP' : '',
            parameters.normalMapObjectSpace ? '#define USE_NORMALMAP_OBJECTSPACE' : '',
            parameters.normalMapTangentSpace ? '#define USE_NORMALMAP_TANGENTSPACE' : '',
            parameters.displacementMap ? '#define USE_DISPLACEMENTMAP' : '',
            parameters.emissiveMap ? '#define USE_EMISSIVEMAP' : '',
            parameters.anisotropy ? '#define USE_ANISOTROPY' : '',
            parameters.anisotropyMap ? '#define USE_ANISOTROPYMAP' : '',
            parameters.clearcoatMap ? '#define USE_CLEARCOATMAP' : '',
            parameters.clearcoatRoughnessMap ? '#define USE_CLEARCOAT_ROUGHNESSMAP' : '',
            parameters.clearcoatNormalMap ? '#define USE_CLEARCOAT_NORMALMAP' : '',
            parameters.iridescenceMap ? '#define USE_IRIDESCENCEMAP' : '',
            parameters.iridescenceThicknessMap ? '#define USE_IRIDESCENCE_THICKNESSMAP' : '',
            parameters.specularMap ? '#define USE_SPECULARMAP' : '',
            parameters.specularColorMap ? '#define USE_SPECULAR_COLORMAP' : '',
            parameters.specularIntensityMap ? '#define USE_SPECULAR_INTENSITYMAP' : '',
            parameters.roughnessMap ? '#define USE_ROUGHNESSMAP' : '',
            parameters.metalnessMap ? '#define USE_METALNESSMAP' : '',
            parameters.alphaMap ? '#define USE_ALPHAMAP' : '',
            parameters.alphaHash ? '#define USE_ALPHAHASH' : '',
            parameters.transmission ? '#define USE_TRANSMISSION' : '',
            parameters.transmissionMap ? '#define USE_TRANSMISSIONMAP' : '',
            parameters.thicknessMap ? '#define USE_THICKNESSMAP' : '',
            parameters.sheenColorMap ? '#define USE_SHEEN_COLORMAP' : '',
            parameters.sheenRoughnessMap ? '#define USE_SHEEN_ROUGHNESSMAP' : '',
            //
            parameters.mapUv ? '#define MAP_UV ' + parameters.mapUv : '',
            parameters.alphaMapUv ? '#define ALPHAMAP_UV ' + parameters.alphaMapUv : '',
            parameters.lightMapUv ? '#define LIGHTMAP_UV ' + parameters.lightMapUv : '',
            parameters.aoMapUv ? '#define AOMAP_UV ' + parameters.aoMapUv : '',
            parameters.emissiveMapUv ? '#define EMISSIVEMAP_UV ' + parameters.emissiveMapUv : '',
            parameters.bumpMapUv ? '#define BUMPMAP_UV ' + parameters.bumpMapUv : '',
            parameters.normalMapUv ? '#define NORMALMAP_UV ' + parameters.normalMapUv : '',
            parameters.displacementMapUv ? '#define DISPLACEMENTMAP_UV ' + parameters.displacementMapUv : '',
            parameters.metalnessMapUv ? '#define METALNESSMAP_UV ' + parameters.metalnessMapUv : '',
            parameters.roughnessMapUv ? '#define ROUGHNESSMAP_UV ' + parameters.roughnessMapUv : '',
            parameters.anisotropyMapUv ? '#define ANISOTROPYMAP_UV ' + parameters.anisotropyMapUv : '',
            parameters.clearcoatMapUv ? '#define CLEARCOATMAP_UV ' + parameters.clearcoatMapUv : '',
            parameters.clearcoatNormalMapUv ? '#define CLEARCOAT_NORMALMAP_UV ' + parameters.clearcoatNormalMapUv : '',
            parameters.clearcoatRoughnessMapUv ? '#define CLEARCOAT_ROUGHNESSMAP_UV ' + parameters.clearcoatRoughnessMapUv : '',
            parameters.iridescenceMapUv ? '#define IRIDESCENCEMAP_UV ' + parameters.iridescenceMapUv : '',
            parameters.iridescenceThicknessMapUv ? '#define IRIDESCENCE_THICKNESSMAP_UV ' + parameters.iridescenceThicknessMapUv : '',
            parameters.sheenColorMapUv ? '#define SHEEN_COLORMAP_UV ' + parameters.sheenColorMapUv : '',
            parameters.sheenRoughnessMapUv ? '#define SHEEN_ROUGHNESSMAP_UV ' + parameters.sheenRoughnessMapUv : '',
            parameters.specularMapUv ? '#define SPECULARMAP_UV ' + parameters.specularMapUv : '',
            parameters.specularColorMapUv ? '#define SPECULAR_COLORMAP_UV ' + parameters.specularColorMapUv : '',
            parameters.specularIntensityMapUv ? '#define SPECULAR_INTENSITYMAP_UV ' + parameters.specularIntensityMapUv : '',
            parameters.transmissionMapUv ? '#define TRANSMISSIONMAP_UV ' + parameters.transmissionMapUv : '',
            parameters.thicknessMapUv ? '#define THICKNESSMAP_UV ' + parameters.thicknessMapUv : '',
            //
            parameters.vertexTangents && parameters.flatShading === false ? '#define USE_TANGENT' : '',
            parameters.vertexColors ? '#define USE_COLOR' : '',
            parameters.vertexAlphas ? '#define USE_COLOR_ALPHA' : '',
            parameters.vertexUv1s ? '#define USE_UV1' : '',
            parameters.vertexUv2s ? '#define USE_UV2' : '',
            parameters.vertexUv3s ? '#define USE_UV3' : '',
            parameters.pointsUvs ? '#define USE_POINTS_UV' : '',
            parameters.flatShading ? '#define FLAT_SHADED' : '',
            parameters.skinning ? '#define USE_SKINNING' : '',
            parameters.morphTargets ? '#define USE_MORPHTARGETS' : '',
            parameters.morphNormals && parameters.flatShading === false ? '#define USE_MORPHNORMALS' : '',
            parameters.morphColors ? '#define USE_MORPHCOLORS' : '',
            parameters.morphTargetsCount > 0 ? '#define MORPHTARGETS_TEXTURE_STRIDE ' + parameters.morphTextureStride : '',
            parameters.morphTargetsCount > 0 ? '#define MORPHTARGETS_COUNT ' + parameters.morphTargetsCount : '',
            parameters.doubleSided ? '#define DOUBLE_SIDED' : '',
            parameters.flipSided ? '#define FLIP_SIDED' : '',
            parameters.shadowMapEnabled ? '#define USE_SHADOWMAP' : '',
            parameters.shadowMapEnabled ? '#define ' + shadowMapTypeDefine : '',
            parameters.sizeAttenuation ? '#define USE_SIZEATTENUATION' : '',
            parameters.numLightProbes > 0 ? '#define USE_LIGHT_PROBES' : '',
            parameters.logarithmicDepthBuffer ? '#define USE_LOGDEPTHBUF' : '',
            parameters.reverseDepthBuffer ? '#define USE_REVERSEDEPTHBUF' : '',
            'uniform mat4 modelMatrix;',
            'uniform mat4 modelViewMatrix;',
            'uniform mat4 projectionMatrix;',
            'uniform mat4 viewMatrix;',
            'uniform mat3 normalMatrix;',
            'uniform vec3 cameraPosition;',
            'uniform bool isOrthographic;',
            '#ifdef USE_INSTANCING',
            '	attribute mat4 instanceMatrix;',
            '#endif',
            '#ifdef USE_INSTANCING_COLOR',
            '	attribute vec3 instanceColor;',
            '#endif',
            '#ifdef USE_INSTANCING_MORPH',
            '	uniform sampler2D morphTexture;',
            '#endif',
            'attribute vec3 position;',
            'attribute vec3 normal;',
            'attribute vec2 uv;',
            '#ifdef USE_UV1',
            '	attribute vec2 uv1;',
            '#endif',
            '#ifdef USE_UV2',
            '	attribute vec2 uv2;',
            '#endif',
            '#ifdef USE_UV3',
            '	attribute vec2 uv3;',
            '#endif',
            '#ifdef USE_TANGENT',
            '	attribute vec4 tangent;',
            '#endif',
            '#if defined( USE_COLOR_ALPHA )',
            '	attribute vec4 color;',
            '#elif defined( USE_COLOR )',
            '	attribute vec3 color;',
            '#endif',
            '#ifdef USE_SKINNING',
            '	attribute vec4 skinIndex;',
            '	attribute vec4 skinWeight;',
            '#endif',
            '\n'
        ].filter($d5b33d7c30034067$var$filterEmptyLine).join('\n');
        prefixFragment = [
            $d5b33d7c30034067$var$generatePrecision(parameters),
            '#define SHADER_TYPE ' + parameters.shaderType,
            '#define SHADER_NAME ' + parameters.shaderName,
            customDefines,
            parameters.useFog && parameters.fog ? '#define USE_FOG' : '',
            parameters.useFog && parameters.fogExp2 ? '#define FOG_EXP2' : '',
            parameters.alphaToCoverage ? '#define ALPHA_TO_COVERAGE' : '',
            parameters.map ? '#define USE_MAP' : '',
            parameters.matcap ? '#define USE_MATCAP' : '',
            parameters.envMap ? '#define USE_ENVMAP' : '',
            parameters.envMap ? '#define ' + envMapTypeDefine : '',
            parameters.envMap ? '#define ' + envMapModeDefine : '',
            parameters.envMap ? '#define ' + envMapBlendingDefine : '',
            envMapCubeUVSize ? '#define CUBEUV_TEXEL_WIDTH ' + envMapCubeUVSize.texelWidth : '',
            envMapCubeUVSize ? '#define CUBEUV_TEXEL_HEIGHT ' + envMapCubeUVSize.texelHeight : '',
            envMapCubeUVSize ? '#define CUBEUV_MAX_MIP ' + envMapCubeUVSize.maxMip + '.0' : '',
            parameters.lightMap ? '#define USE_LIGHTMAP' : '',
            parameters.aoMap ? '#define USE_AOMAP' : '',
            parameters.bumpMap ? '#define USE_BUMPMAP' : '',
            parameters.normalMap ? '#define USE_NORMALMAP' : '',
            parameters.normalMapObjectSpace ? '#define USE_NORMALMAP_OBJECTSPACE' : '',
            parameters.normalMapTangentSpace ? '#define USE_NORMALMAP_TANGENTSPACE' : '',
            parameters.emissiveMap ? '#define USE_EMISSIVEMAP' : '',
            parameters.anisotropy ? '#define USE_ANISOTROPY' : '',
            parameters.anisotropyMap ? '#define USE_ANISOTROPYMAP' : '',
            parameters.clearcoat ? '#define USE_CLEARCOAT' : '',
            parameters.clearcoatMap ? '#define USE_CLEARCOATMAP' : '',
            parameters.clearcoatRoughnessMap ? '#define USE_CLEARCOAT_ROUGHNESSMAP' : '',
            parameters.clearcoatNormalMap ? '#define USE_CLEARCOAT_NORMALMAP' : '',
            parameters.dispersion ? '#define USE_DISPERSION' : '',
            parameters.iridescence ? '#define USE_IRIDESCENCE' : '',
            parameters.iridescenceMap ? '#define USE_IRIDESCENCEMAP' : '',
            parameters.iridescenceThicknessMap ? '#define USE_IRIDESCENCE_THICKNESSMAP' : '',
            parameters.specularMap ? '#define USE_SPECULARMAP' : '',
            parameters.specularColorMap ? '#define USE_SPECULAR_COLORMAP' : '',
            parameters.specularIntensityMap ? '#define USE_SPECULAR_INTENSITYMAP' : '',
            parameters.roughnessMap ? '#define USE_ROUGHNESSMAP' : '',
            parameters.metalnessMap ? '#define USE_METALNESSMAP' : '',
            parameters.alphaMap ? '#define USE_ALPHAMAP' : '',
            parameters.alphaTest ? '#define USE_ALPHATEST' : '',
            parameters.alphaHash ? '#define USE_ALPHAHASH' : '',
            parameters.sheen ? '#define USE_SHEEN' : '',
            parameters.sheenColorMap ? '#define USE_SHEEN_COLORMAP' : '',
            parameters.sheenRoughnessMap ? '#define USE_SHEEN_ROUGHNESSMAP' : '',
            parameters.transmission ? '#define USE_TRANSMISSION' : '',
            parameters.transmissionMap ? '#define USE_TRANSMISSIONMAP' : '',
            parameters.thicknessMap ? '#define USE_THICKNESSMAP' : '',
            parameters.vertexTangents && parameters.flatShading === false ? '#define USE_TANGENT' : '',
            parameters.vertexColors || parameters.instancingColor || parameters.batchingColor ? '#define USE_COLOR' : '',
            parameters.vertexAlphas ? '#define USE_COLOR_ALPHA' : '',
            parameters.vertexUv1s ? '#define USE_UV1' : '',
            parameters.vertexUv2s ? '#define USE_UV2' : '',
            parameters.vertexUv3s ? '#define USE_UV3' : '',
            parameters.pointsUvs ? '#define USE_POINTS_UV' : '',
            parameters.gradientMap ? '#define USE_GRADIENTMAP' : '',
            parameters.flatShading ? '#define FLAT_SHADED' : '',
            parameters.doubleSided ? '#define DOUBLE_SIDED' : '',
            parameters.flipSided ? '#define FLIP_SIDED' : '',
            parameters.shadowMapEnabled ? '#define USE_SHADOWMAP' : '',
            parameters.shadowMapEnabled ? '#define ' + shadowMapTypeDefine : '',
            parameters.premultipliedAlpha ? '#define PREMULTIPLIED_ALPHA' : '',
            parameters.numLightProbes > 0 ? '#define USE_LIGHT_PROBES' : '',
            parameters.decodeVideoTexture ? '#define DECODE_VIDEO_TEXTURE' : '',
            parameters.decodeVideoTextureEmissive ? '#define DECODE_VIDEO_TEXTURE_EMISSIVE' : '',
            parameters.logarithmicDepthBuffer ? '#define USE_LOGDEPTHBUF' : '',
            parameters.reverseDepthBuffer ? '#define USE_REVERSEDEPTHBUF' : '',
            'uniform mat4 viewMatrix;',
            'uniform vec3 cameraPosition;',
            'uniform bool isOrthographic;',
            parameters.toneMapping !== $d5b33d7c30034067$export$9fcb6b4294603b2 ? '#define TONE_MAPPING' : '',
            parameters.toneMapping !== $d5b33d7c30034067$export$9fcb6b4294603b2 ? $d5b33d7c30034067$export$955f9f2e84c43c8b['tonemapping_pars_fragment'] : '',
            parameters.toneMapping !== $d5b33d7c30034067$export$9fcb6b4294603b2 ? $d5b33d7c30034067$var$getToneMappingFunction('toneMapping', parameters.toneMapping) : '',
            parameters.dithering ? '#define DITHERING' : '',
            parameters.opaque ? '#define OPAQUE' : '',
            $d5b33d7c30034067$export$955f9f2e84c43c8b['colorspace_pars_fragment'],
            $d5b33d7c30034067$var$getTexelEncodingFunction('linearToOutputTexel', parameters.outputColorSpace),
            $d5b33d7c30034067$var$getLuminanceFunction(),
            parameters.useDepthPacking ? '#define DEPTH_PACKING ' + parameters.depthPacking : '',
            '\n'
        ].filter($d5b33d7c30034067$var$filterEmptyLine).join('\n');
    }
    vertexShader = $d5b33d7c30034067$var$resolveIncludes(vertexShader);
    vertexShader = $d5b33d7c30034067$var$replaceLightNums(vertexShader, parameters);
    vertexShader = $d5b33d7c30034067$var$replaceClippingPlaneNums(vertexShader, parameters);
    fragmentShader = $d5b33d7c30034067$var$resolveIncludes(fragmentShader);
    fragmentShader = $d5b33d7c30034067$var$replaceLightNums(fragmentShader, parameters);
    fragmentShader = $d5b33d7c30034067$var$replaceClippingPlaneNums(fragmentShader, parameters);
    vertexShader = $d5b33d7c30034067$var$unrollLoops(vertexShader);
    fragmentShader = $d5b33d7c30034067$var$unrollLoops(fragmentShader);
    if (parameters.isRawShaderMaterial !== true) {
        // GLSL 3.0 conversion for built-in materials and ShaderMaterial
        versionString = '#version 300 es\n';
        prefixVertex = [
            customVertexExtensions,
            '#define attribute in',
            '#define varying out',
            '#define texture2D texture'
        ].join('\n') + '\n' + prefixVertex;
        prefixFragment = [
            '#define varying in',
            parameters.glslVersion === $d5b33d7c30034067$export$f63012db5506e7dd ? '' : 'layout(location = 0) out highp vec4 pc_fragColor;',
            parameters.glslVersion === $d5b33d7c30034067$export$f63012db5506e7dd ? '' : '#define gl_FragColor pc_fragColor',
            '#define gl_FragDepthEXT gl_FragDepth',
            '#define texture2D texture',
            '#define textureCube texture',
            '#define texture2DProj textureProj',
            '#define texture2DLodEXT textureLod',
            '#define texture2DProjLodEXT textureProjLod',
            '#define textureCubeLodEXT textureLod',
            '#define texture2DGradEXT textureGrad',
            '#define texture2DProjGradEXT textureProjGrad',
            '#define textureCubeGradEXT textureGrad'
        ].join('\n') + '\n' + prefixFragment;
    }
    const vertexGlsl = versionString + prefixVertex + vertexShader;
    const fragmentGlsl = versionString + prefixFragment + fragmentShader;
    // console.log( '*VERTEX*', vertexGlsl );
    // console.log( '*FRAGMENT*', fragmentGlsl );
    const glVertexShader = $d5b33d7c30034067$var$WebGLShader(gl, gl.VERTEX_SHADER, vertexGlsl);
    const glFragmentShader = $d5b33d7c30034067$var$WebGLShader(gl, gl.FRAGMENT_SHADER, fragmentGlsl);
    gl.attachShader(program, glVertexShader);
    gl.attachShader(program, glFragmentShader);
    // Force a particular attribute to index 0.
    if (parameters.index0AttributeName !== undefined) gl.bindAttribLocation(program, 0, parameters.index0AttributeName);
    else if (parameters.morphTargets === true) // programs with morphTargets displace position out of attribute 0
    gl.bindAttribLocation(program, 0, 'position');
    gl.linkProgram(program);
    function onFirstUse(self1) {
        // check for link errors
        if (renderer.debug.checkShaderErrors) {
            const programLog = gl.getProgramInfoLog(program).trim();
            const vertexLog = gl.getShaderInfoLog(glVertexShader).trim();
            const fragmentLog = gl.getShaderInfoLog(glFragmentShader).trim();
            let runnable = true;
            let haveDiagnostics = true;
            if (gl.getProgramParameter(program, gl.LINK_STATUS) === false) {
                runnable = false;
                if (typeof renderer.debug.onShaderError === 'function') renderer.debug.onShaderError(gl, program, glVertexShader, glFragmentShader);
                else {
                    // default error reporting
                    const vertexErrors = $d5b33d7c30034067$var$getShaderErrors(gl, glVertexShader, 'vertex');
                    const fragmentErrors = $d5b33d7c30034067$var$getShaderErrors(gl, glFragmentShader, 'fragment');
                    console.error('THREE.WebGLProgram: Shader Error ' + gl.getError() + ' - ' + 'VALIDATE_STATUS ' + gl.getProgramParameter(program, gl.VALIDATE_STATUS) + '\n\n' + 'Material Name: ' + self1.name + '\n' + 'Material Type: ' + self1.type + '\n\n' + 'Program Info Log: ' + programLog + '\n' + vertexErrors + '\n' + fragmentErrors);
                }
            } else if (programLog !== '') console.warn('THREE.WebGLProgram: Program Info Log:', programLog);
            else if (vertexLog === '' || fragmentLog === '') haveDiagnostics = false;
            if (haveDiagnostics) self1.diagnostics = {
                runnable: runnable,
                programLog: programLog,
                vertexShader: {
                    log: vertexLog,
                    prefix: prefixVertex
                },
                fragmentShader: {
                    log: fragmentLog,
                    prefix: prefixFragment
                }
            };
        }
        // Clean up
        // Crashes in iOS9 and iOS10. #18402
        // gl.detachShader( program, glVertexShader );
        // gl.detachShader( program, glFragmentShader );
        gl.deleteShader(glVertexShader);
        gl.deleteShader(glFragmentShader);
        cachedUniforms = new $d5b33d7c30034067$var$WebGLUniforms(gl, program);
        cachedAttributes = $d5b33d7c30034067$var$fetchAttributeLocations(gl, program);
    }
    // set up caching for uniform locations
    let cachedUniforms;
    this.getUniforms = function() {
        if (cachedUniforms === undefined) // Populates cachedUniforms and cachedAttributes
        onFirstUse(this);
        return cachedUniforms;
    };
    // set up caching for attribute locations
    let cachedAttributes;
    this.getAttributes = function() {
        if (cachedAttributes === undefined) // Populates cachedAttributes and cachedUniforms
        onFirstUse(this);
        return cachedAttributes;
    };
    // indicate when the program is ready to be used. if the KHR_parallel_shader_compile extension isn't supported,
    // flag the program as ready immediately. It may cause a stall when it's first used.
    let programReady = parameters.rendererExtensionParallelShaderCompile === false;
    this.isReady = function() {
        if (programReady === false) programReady = gl.getProgramParameter(program, $d5b33d7c30034067$var$COMPLETION_STATUS_KHR);
        return programReady;
    };
    // free resource
    this.destroy = function() {
        bindingStates.releaseStatesOfProgram(this);
        gl.deleteProgram(program);
        this.program = undefined;
    };
    //
    this.type = parameters.shaderType;
    this.name = parameters.shaderName;
    this.id = $d5b33d7c30034067$var$programIdCount++;
    this.cacheKey = cacheKey;
    this.usedTimes = 1;
    this.program = program;
    this.vertexShader = glVertexShader;
    this.fragmentShader = glFragmentShader;
    return this;
}
let $d5b33d7c30034067$var$_id$1 = 0;
class $d5b33d7c30034067$var$WebGLShaderCache {
    constructor(){
        this.shaderCache = new Map();
        this.materialCache = new Map();
    }
    update(material) {
        const vertexShader = material.vertexShader;
        const fragmentShader = material.fragmentShader;
        const vertexShaderStage = this._getShaderStage(vertexShader);
        const fragmentShaderStage = this._getShaderStage(fragmentShader);
        const materialShaders = this._getShaderCacheForMaterial(material);
        if (materialShaders.has(vertexShaderStage) === false) {
            materialShaders.add(vertexShaderStage);
            vertexShaderStage.usedTimes++;
        }
        if (materialShaders.has(fragmentShaderStage) === false) {
            materialShaders.add(fragmentShaderStage);
            fragmentShaderStage.usedTimes++;
        }
        return this;
    }
    remove(material) {
        const materialShaders = this.materialCache.get(material);
        for (const shaderStage of materialShaders){
            shaderStage.usedTimes--;
            if (shaderStage.usedTimes === 0) this.shaderCache.delete(shaderStage.code);
        }
        this.materialCache.delete(material);
        return this;
    }
    getVertexShaderID(material) {
        return this._getShaderStage(material.vertexShader).id;
    }
    getFragmentShaderID(material) {
        return this._getShaderStage(material.fragmentShader).id;
    }
    dispose() {
        this.shaderCache.clear();
        this.materialCache.clear();
    }
    _getShaderCacheForMaterial(material) {
        const cache = this.materialCache;
        let set = cache.get(material);
        if (set === undefined) {
            set = new Set();
            cache.set(material, set);
        }
        return set;
    }
    _getShaderStage(code) {
        const cache = this.shaderCache;
        let stage = cache.get(code);
        if (stage === undefined) {
            stage = new $d5b33d7c30034067$var$WebGLShaderStage(code);
            cache.set(code, stage);
        }
        return stage;
    }
}
class $d5b33d7c30034067$var$WebGLShaderStage {
    constructor(code){
        this.id = $d5b33d7c30034067$var$_id$1++;
        this.code = code;
        this.usedTimes = 0;
    }
}
function $d5b33d7c30034067$var$WebGLPrograms(renderer, cubemaps, cubeuvmaps, extensions, capabilities, bindingStates, clipping) {
    const _programLayers = new $d5b33d7c30034067$export$89312ce47c0ca777();
    const _customShaders = new $d5b33d7c30034067$var$WebGLShaderCache();
    const _activeChannels = new Set();
    const programs = [];
    const logarithmicDepthBuffer = capabilities.logarithmicDepthBuffer;
    const SUPPORTS_VERTEX_TEXTURES = capabilities.vertexTextures;
    let precision = capabilities.precision;
    const shaderIDs = {
        MeshDepthMaterial: 'depth',
        MeshDistanceMaterial: 'distanceRGBA',
        MeshNormalMaterial: 'normal',
        MeshBasicMaterial: 'basic',
        MeshLambertMaterial: 'lambert',
        MeshPhongMaterial: 'phong',
        MeshToonMaterial: 'toon',
        MeshStandardMaterial: 'physical',
        MeshPhysicalMaterial: 'physical',
        MeshMatcapMaterial: 'matcap',
        LineBasicMaterial: 'basic',
        LineDashedMaterial: 'dashed',
        PointsMaterial: 'points',
        ShadowMaterial: 'shadow',
        SpriteMaterial: 'sprite'
    };
    function getChannel(value) {
        _activeChannels.add(value);
        if (value === 0) return 'uv';
        return `uv${value}`;
    }
    function getParameters(material, lights, shadows, scene, object) {
        const fog = scene.fog;
        const geometry = object.geometry;
        const environment = material.isMeshStandardMaterial ? scene.environment : null;
        const envMap = (material.isMeshStandardMaterial ? cubeuvmaps : cubemaps).get(material.envMap || environment);
        const envMapCubeUVHeight = !!envMap && envMap.mapping === $d5b33d7c30034067$export$dbf3e70ff37af79 ? envMap.image.height : null;
        const shaderID = shaderIDs[material.type];
        // heuristics to create shader parameters according to lights in the scene
        // (not to blow over maxLights budget)
        if (material.precision !== null) {
            precision = capabilities.getMaxPrecision(material.precision);
            if (precision !== material.precision) console.warn('THREE.WebGLProgram.getParameters:', material.precision, 'not supported, using', precision, 'instead.');
        }
        //
        const morphAttribute = geometry.morphAttributes.position || geometry.morphAttributes.normal || geometry.morphAttributes.color;
        const morphTargetsCount = morphAttribute !== undefined ? morphAttribute.length : 0;
        let morphTextureStride = 0;
        if (geometry.morphAttributes.position !== undefined) morphTextureStride = 1;
        if (geometry.morphAttributes.normal !== undefined) morphTextureStride = 2;
        if (geometry.morphAttributes.color !== undefined) morphTextureStride = 3;
        //
        let vertexShader, fragmentShader;
        let customVertexShaderID, customFragmentShaderID;
        if (shaderID) {
            const shader = $d5b33d7c30034067$export$bee4a7d47f8f5014[shaderID];
            vertexShader = shader.vertexShader;
            fragmentShader = shader.fragmentShader;
        } else {
            vertexShader = material.vertexShader;
            fragmentShader = material.fragmentShader;
            _customShaders.update(material);
            customVertexShaderID = _customShaders.getVertexShaderID(material);
            customFragmentShaderID = _customShaders.getFragmentShaderID(material);
        }
        const currentRenderTarget = renderer.getRenderTarget();
        const reverseDepthBuffer = renderer.state.buffers.depth.getReversed();
        const IS_INSTANCEDMESH = object.isInstancedMesh === true;
        const IS_BATCHEDMESH = object.isBatchedMesh === true;
        const HAS_MAP = !!material.map;
        const HAS_MATCAP = !!material.matcap;
        const HAS_ENVMAP = !!envMap;
        const HAS_AOMAP = !!material.aoMap;
        const HAS_LIGHTMAP = !!material.lightMap;
        const HAS_BUMPMAP = !!material.bumpMap;
        const HAS_NORMALMAP = !!material.normalMap;
        const HAS_DISPLACEMENTMAP = !!material.displacementMap;
        const HAS_EMISSIVEMAP = !!material.emissiveMap;
        const HAS_METALNESSMAP = !!material.metalnessMap;
        const HAS_ROUGHNESSMAP = !!material.roughnessMap;
        const HAS_ANISOTROPY = material.anisotropy > 0;
        const HAS_CLEARCOAT = material.clearcoat > 0;
        const HAS_DISPERSION = material.dispersion > 0;
        const HAS_IRIDESCENCE = material.iridescence > 0;
        const HAS_SHEEN = material.sheen > 0;
        const HAS_TRANSMISSION = material.transmission > 0;
        const HAS_ANISOTROPYMAP = HAS_ANISOTROPY && !!material.anisotropyMap;
        const HAS_CLEARCOATMAP = HAS_CLEARCOAT && !!material.clearcoatMap;
        const HAS_CLEARCOAT_NORMALMAP = HAS_CLEARCOAT && !!material.clearcoatNormalMap;
        const HAS_CLEARCOAT_ROUGHNESSMAP = HAS_CLEARCOAT && !!material.clearcoatRoughnessMap;
        const HAS_IRIDESCENCEMAP = HAS_IRIDESCENCE && !!material.iridescenceMap;
        const HAS_IRIDESCENCE_THICKNESSMAP = HAS_IRIDESCENCE && !!material.iridescenceThicknessMap;
        const HAS_SHEEN_COLORMAP = HAS_SHEEN && !!material.sheenColorMap;
        const HAS_SHEEN_ROUGHNESSMAP = HAS_SHEEN && !!material.sheenRoughnessMap;
        const HAS_SPECULARMAP = !!material.specularMap;
        const HAS_SPECULAR_COLORMAP = !!material.specularColorMap;
        const HAS_SPECULAR_INTENSITYMAP = !!material.specularIntensityMap;
        const HAS_TRANSMISSIONMAP = HAS_TRANSMISSION && !!material.transmissionMap;
        const HAS_THICKNESSMAP = HAS_TRANSMISSION && !!material.thicknessMap;
        const HAS_GRADIENTMAP = !!material.gradientMap;
        const HAS_ALPHAMAP = !!material.alphaMap;
        const HAS_ALPHATEST = material.alphaTest > 0;
        const HAS_ALPHAHASH = !!material.alphaHash;
        const HAS_EXTENSIONS = !!material.extensions;
        let toneMapping = $d5b33d7c30034067$export$9fcb6b4294603b2;
        if (material.toneMapped) {
            if (currentRenderTarget === null || currentRenderTarget.isXRRenderTarget === true) toneMapping = renderer.toneMapping;
        }
        const parameters = {
            shaderID: shaderID,
            shaderType: material.type,
            shaderName: material.name,
            vertexShader: vertexShader,
            fragmentShader: fragmentShader,
            defines: material.defines,
            customVertexShaderID: customVertexShaderID,
            customFragmentShaderID: customFragmentShaderID,
            isRawShaderMaterial: material.isRawShaderMaterial === true,
            glslVersion: material.glslVersion,
            precision: precision,
            batching: IS_BATCHEDMESH,
            batchingColor: IS_BATCHEDMESH && object._colorsTexture !== null,
            instancing: IS_INSTANCEDMESH,
            instancingColor: IS_INSTANCEDMESH && object.instanceColor !== null,
            instancingMorph: IS_INSTANCEDMESH && object.morphTexture !== null,
            supportsVertexTextures: SUPPORTS_VERTEX_TEXTURES,
            outputColorSpace: currentRenderTarget === null ? renderer.outputColorSpace : currentRenderTarget.isXRRenderTarget === true ? currentRenderTarget.texture.colorSpace : $d5b33d7c30034067$export$42429b3acfb233a4,
            alphaToCoverage: !!material.alphaToCoverage,
            map: HAS_MAP,
            matcap: HAS_MATCAP,
            envMap: HAS_ENVMAP,
            envMapMode: HAS_ENVMAP && envMap.mapping,
            envMapCubeUVHeight: envMapCubeUVHeight,
            aoMap: HAS_AOMAP,
            lightMap: HAS_LIGHTMAP,
            bumpMap: HAS_BUMPMAP,
            normalMap: HAS_NORMALMAP,
            displacementMap: SUPPORTS_VERTEX_TEXTURES && HAS_DISPLACEMENTMAP,
            emissiveMap: HAS_EMISSIVEMAP,
            normalMapObjectSpace: HAS_NORMALMAP && material.normalMapType === $d5b33d7c30034067$export$9990ad26f9db5b2c,
            normalMapTangentSpace: HAS_NORMALMAP && material.normalMapType === $d5b33d7c30034067$export$2852a58ebdac27b8,
            metalnessMap: HAS_METALNESSMAP,
            roughnessMap: HAS_ROUGHNESSMAP,
            anisotropy: HAS_ANISOTROPY,
            anisotropyMap: HAS_ANISOTROPYMAP,
            clearcoat: HAS_CLEARCOAT,
            clearcoatMap: HAS_CLEARCOATMAP,
            clearcoatNormalMap: HAS_CLEARCOAT_NORMALMAP,
            clearcoatRoughnessMap: HAS_CLEARCOAT_ROUGHNESSMAP,
            dispersion: HAS_DISPERSION,
            iridescence: HAS_IRIDESCENCE,
            iridescenceMap: HAS_IRIDESCENCEMAP,
            iridescenceThicknessMap: HAS_IRIDESCENCE_THICKNESSMAP,
            sheen: HAS_SHEEN,
            sheenColorMap: HAS_SHEEN_COLORMAP,
            sheenRoughnessMap: HAS_SHEEN_ROUGHNESSMAP,
            specularMap: HAS_SPECULARMAP,
            specularColorMap: HAS_SPECULAR_COLORMAP,
            specularIntensityMap: HAS_SPECULAR_INTENSITYMAP,
            transmission: HAS_TRANSMISSION,
            transmissionMap: HAS_TRANSMISSIONMAP,
            thicknessMap: HAS_THICKNESSMAP,
            gradientMap: HAS_GRADIENTMAP,
            opaque: material.transparent === false && material.blending === $d5b33d7c30034067$export$5b29a26d96ee6af0 && material.alphaToCoverage === false,
            alphaMap: HAS_ALPHAMAP,
            alphaTest: HAS_ALPHATEST,
            alphaHash: HAS_ALPHAHASH,
            combine: material.combine,
            //
            mapUv: HAS_MAP && getChannel(material.map.channel),
            aoMapUv: HAS_AOMAP && getChannel(material.aoMap.channel),
            lightMapUv: HAS_LIGHTMAP && getChannel(material.lightMap.channel),
            bumpMapUv: HAS_BUMPMAP && getChannel(material.bumpMap.channel),
            normalMapUv: HAS_NORMALMAP && getChannel(material.normalMap.channel),
            displacementMapUv: HAS_DISPLACEMENTMAP && getChannel(material.displacementMap.channel),
            emissiveMapUv: HAS_EMISSIVEMAP && getChannel(material.emissiveMap.channel),
            metalnessMapUv: HAS_METALNESSMAP && getChannel(material.metalnessMap.channel),
            roughnessMapUv: HAS_ROUGHNESSMAP && getChannel(material.roughnessMap.channel),
            anisotropyMapUv: HAS_ANISOTROPYMAP && getChannel(material.anisotropyMap.channel),
            clearcoatMapUv: HAS_CLEARCOATMAP && getChannel(material.clearcoatMap.channel),
            clearcoatNormalMapUv: HAS_CLEARCOAT_NORMALMAP && getChannel(material.clearcoatNormalMap.channel),
            clearcoatRoughnessMapUv: HAS_CLEARCOAT_ROUGHNESSMAP && getChannel(material.clearcoatRoughnessMap.channel),
            iridescenceMapUv: HAS_IRIDESCENCEMAP && getChannel(material.iridescenceMap.channel),
            iridescenceThicknessMapUv: HAS_IRIDESCENCE_THICKNESSMAP && getChannel(material.iridescenceThicknessMap.channel),
            sheenColorMapUv: HAS_SHEEN_COLORMAP && getChannel(material.sheenColorMap.channel),
            sheenRoughnessMapUv: HAS_SHEEN_ROUGHNESSMAP && getChannel(material.sheenRoughnessMap.channel),
            specularMapUv: HAS_SPECULARMAP && getChannel(material.specularMap.channel),
            specularColorMapUv: HAS_SPECULAR_COLORMAP && getChannel(material.specularColorMap.channel),
            specularIntensityMapUv: HAS_SPECULAR_INTENSITYMAP && getChannel(material.specularIntensityMap.channel),
            transmissionMapUv: HAS_TRANSMISSIONMAP && getChannel(material.transmissionMap.channel),
            thicknessMapUv: HAS_THICKNESSMAP && getChannel(material.thicknessMap.channel),
            alphaMapUv: HAS_ALPHAMAP && getChannel(material.alphaMap.channel),
            //
            vertexTangents: !!geometry.attributes.tangent && (HAS_NORMALMAP || HAS_ANISOTROPY),
            vertexColors: material.vertexColors,
            vertexAlphas: material.vertexColors === true && !!geometry.attributes.color && geometry.attributes.color.itemSize === 4,
            pointsUvs: object.isPoints === true && !!geometry.attributes.uv && (HAS_MAP || HAS_ALPHAMAP),
            fog: !!fog,
            useFog: material.fog === true,
            fogExp2: !!fog && fog.isFogExp2,
            flatShading: material.flatShading === true,
            sizeAttenuation: material.sizeAttenuation === true,
            logarithmicDepthBuffer: logarithmicDepthBuffer,
            reverseDepthBuffer: reverseDepthBuffer,
            skinning: object.isSkinnedMesh === true,
            morphTargets: geometry.morphAttributes.position !== undefined,
            morphNormals: geometry.morphAttributes.normal !== undefined,
            morphColors: geometry.morphAttributes.color !== undefined,
            morphTargetsCount: morphTargetsCount,
            morphTextureStride: morphTextureStride,
            numDirLights: lights.directional.length,
            numPointLights: lights.point.length,
            numSpotLights: lights.spot.length,
            numSpotLightMaps: lights.spotLightMap.length,
            numRectAreaLights: lights.rectArea.length,
            numHemiLights: lights.hemi.length,
            numDirLightShadows: lights.directionalShadowMap.length,
            numPointLightShadows: lights.pointShadowMap.length,
            numSpotLightShadows: lights.spotShadowMap.length,
            numSpotLightShadowsWithMaps: lights.numSpotLightShadowsWithMaps,
            numLightProbes: lights.numLightProbes,
            numClippingPlanes: clipping.numPlanes,
            numClipIntersection: clipping.numIntersection,
            dithering: material.dithering,
            shadowMapEnabled: renderer.shadowMap.enabled && shadows.length > 0,
            shadowMapType: renderer.shadowMap.type,
            toneMapping: toneMapping,
            decodeVideoTexture: HAS_MAP && material.map.isVideoTexture === true && $d5b33d7c30034067$export$5e6fd513f44698c.getTransfer(material.map.colorSpace) === $d5b33d7c30034067$export$8d0a61916cc26abb,
            decodeVideoTextureEmissive: HAS_EMISSIVEMAP && material.emissiveMap.isVideoTexture === true && $d5b33d7c30034067$export$5e6fd513f44698c.getTransfer(material.emissiveMap.colorSpace) === $d5b33d7c30034067$export$8d0a61916cc26abb,
            premultipliedAlpha: material.premultipliedAlpha,
            doubleSided: material.side === $d5b33d7c30034067$export$3b296b6f144d5b03,
            flipSided: material.side === $d5b33d7c30034067$export$d9f0486e75b5ace,
            useDepthPacking: material.depthPacking >= 0,
            depthPacking: material.depthPacking || 0,
            index0AttributeName: material.index0AttributeName,
            extensionClipCullDistance: HAS_EXTENSIONS && material.extensions.clipCullDistance === true && extensions.has('WEBGL_clip_cull_distance'),
            extensionMultiDraw: (HAS_EXTENSIONS && material.extensions.multiDraw === true || IS_BATCHEDMESH) && extensions.has('WEBGL_multi_draw'),
            rendererExtensionParallelShaderCompile: extensions.has('KHR_parallel_shader_compile'),
            customProgramCacheKey: material.customProgramCacheKey()
        };
        // the usage of getChannel() determines the active texture channels for this shader
        parameters.vertexUv1s = _activeChannels.has(1);
        parameters.vertexUv2s = _activeChannels.has(2);
        parameters.vertexUv3s = _activeChannels.has(3);
        _activeChannels.clear();
        return parameters;
    }
    function getProgramCacheKey(parameters) {
        const array = [];
        if (parameters.shaderID) array.push(parameters.shaderID);
        else {
            array.push(parameters.customVertexShaderID);
            array.push(parameters.customFragmentShaderID);
        }
        if (parameters.defines !== undefined) for(const name in parameters.defines){
            array.push(name);
            array.push(parameters.defines[name]);
        }
        if (parameters.isRawShaderMaterial === false) {
            getProgramCacheKeyParameters(array, parameters);
            getProgramCacheKeyBooleans(array, parameters);
            array.push(renderer.outputColorSpace);
        }
        array.push(parameters.customProgramCacheKey);
        return array.join();
    }
    function getProgramCacheKeyParameters(array, parameters) {
        array.push(parameters.precision);
        array.push(parameters.outputColorSpace);
        array.push(parameters.envMapMode);
        array.push(parameters.envMapCubeUVHeight);
        array.push(parameters.mapUv);
        array.push(parameters.alphaMapUv);
        array.push(parameters.lightMapUv);
        array.push(parameters.aoMapUv);
        array.push(parameters.bumpMapUv);
        array.push(parameters.normalMapUv);
        array.push(parameters.displacementMapUv);
        array.push(parameters.emissiveMapUv);
        array.push(parameters.metalnessMapUv);
        array.push(parameters.roughnessMapUv);
        array.push(parameters.anisotropyMapUv);
        array.push(parameters.clearcoatMapUv);
        array.push(parameters.clearcoatNormalMapUv);
        array.push(parameters.clearcoatRoughnessMapUv);
        array.push(parameters.iridescenceMapUv);
        array.push(parameters.iridescenceThicknessMapUv);
        array.push(parameters.sheenColorMapUv);
        array.push(parameters.sheenRoughnessMapUv);
        array.push(parameters.specularMapUv);
        array.push(parameters.specularColorMapUv);
        array.push(parameters.specularIntensityMapUv);
        array.push(parameters.transmissionMapUv);
        array.push(parameters.thicknessMapUv);
        array.push(parameters.combine);
        array.push(parameters.fogExp2);
        array.push(parameters.sizeAttenuation);
        array.push(parameters.morphTargetsCount);
        array.push(parameters.morphAttributeCount);
        array.push(parameters.numDirLights);
        array.push(parameters.numPointLights);
        array.push(parameters.numSpotLights);
        array.push(parameters.numSpotLightMaps);
        array.push(parameters.numHemiLights);
        array.push(parameters.numRectAreaLights);
        array.push(parameters.numDirLightShadows);
        array.push(parameters.numPointLightShadows);
        array.push(parameters.numSpotLightShadows);
        array.push(parameters.numSpotLightShadowsWithMaps);
        array.push(parameters.numLightProbes);
        array.push(parameters.shadowMapType);
        array.push(parameters.toneMapping);
        array.push(parameters.numClippingPlanes);
        array.push(parameters.numClipIntersection);
        array.push(parameters.depthPacking);
    }
    function getProgramCacheKeyBooleans(array, parameters) {
        _programLayers.disableAll();
        if (parameters.supportsVertexTextures) _programLayers.enable(0);
        if (parameters.instancing) _programLayers.enable(1);
        if (parameters.instancingColor) _programLayers.enable(2);
        if (parameters.instancingMorph) _programLayers.enable(3);
        if (parameters.matcap) _programLayers.enable(4);
        if (parameters.envMap) _programLayers.enable(5);
        if (parameters.normalMapObjectSpace) _programLayers.enable(6);
        if (parameters.normalMapTangentSpace) _programLayers.enable(7);
        if (parameters.clearcoat) _programLayers.enable(8);
        if (parameters.iridescence) _programLayers.enable(9);
        if (parameters.alphaTest) _programLayers.enable(10);
        if (parameters.vertexColors) _programLayers.enable(11);
        if (parameters.vertexAlphas) _programLayers.enable(12);
        if (parameters.vertexUv1s) _programLayers.enable(13);
        if (parameters.vertexUv2s) _programLayers.enable(14);
        if (parameters.vertexUv3s) _programLayers.enable(15);
        if (parameters.vertexTangents) _programLayers.enable(16);
        if (parameters.anisotropy) _programLayers.enable(17);
        if (parameters.alphaHash) _programLayers.enable(18);
        if (parameters.batching) _programLayers.enable(19);
        if (parameters.dispersion) _programLayers.enable(20);
        if (parameters.batchingColor) _programLayers.enable(21);
        array.push(_programLayers.mask);
        _programLayers.disableAll();
        if (parameters.fog) _programLayers.enable(0);
        if (parameters.useFog) _programLayers.enable(1);
        if (parameters.flatShading) _programLayers.enable(2);
        if (parameters.logarithmicDepthBuffer) _programLayers.enable(3);
        if (parameters.reverseDepthBuffer) _programLayers.enable(4);
        if (parameters.skinning) _programLayers.enable(5);
        if (parameters.morphTargets) _programLayers.enable(6);
        if (parameters.morphNormals) _programLayers.enable(7);
        if (parameters.morphColors) _programLayers.enable(8);
        if (parameters.premultipliedAlpha) _programLayers.enable(9);
        if (parameters.shadowMapEnabled) _programLayers.enable(10);
        if (parameters.doubleSided) _programLayers.enable(11);
        if (parameters.flipSided) _programLayers.enable(12);
        if (parameters.useDepthPacking) _programLayers.enable(13);
        if (parameters.dithering) _programLayers.enable(14);
        if (parameters.transmission) _programLayers.enable(15);
        if (parameters.sheen) _programLayers.enable(16);
        if (parameters.opaque) _programLayers.enable(17);
        if (parameters.pointsUvs) _programLayers.enable(18);
        if (parameters.decodeVideoTexture) _programLayers.enable(19);
        if (parameters.decodeVideoTextureEmissive) _programLayers.enable(20);
        if (parameters.alphaToCoverage) _programLayers.enable(21);
        array.push(_programLayers.mask);
    }
    function getUniforms(material) {
        const shaderID = shaderIDs[material.type];
        let uniforms;
        if (shaderID) {
            const shader = $d5b33d7c30034067$export$bee4a7d47f8f5014[shaderID];
            uniforms = $d5b33d7c30034067$export$d8ecdf8615bfea69.clone(shader.uniforms);
        } else uniforms = material.uniforms;
        return uniforms;
    }
    function acquireProgram(parameters, cacheKey) {
        let program;
        // Check if code has been already compiled
        for(let p = 0, pl = programs.length; p < pl; p++){
            const preexistingProgram = programs[p];
            if (preexistingProgram.cacheKey === cacheKey) {
                program = preexistingProgram;
                ++program.usedTimes;
                break;
            }
        }
        if (program === undefined) {
            program = new $d5b33d7c30034067$var$WebGLProgram(renderer, cacheKey, parameters, bindingStates);
            programs.push(program);
        }
        return program;
    }
    function releaseProgram(program) {
        if (--program.usedTimes === 0) {
            // Remove from unordered set
            const i = programs.indexOf(program);
            programs[i] = programs[programs.length - 1];
            programs.pop();
            // Free WebGL resources
            program.destroy();
        }
    }
    function releaseShaderCache(material) {
        _customShaders.remove(material);
    }
    function dispose() {
        _customShaders.dispose();
    }
    return {
        getParameters: getParameters,
        getProgramCacheKey: getProgramCacheKey,
        getUniforms: getUniforms,
        acquireProgram: acquireProgram,
        releaseProgram: releaseProgram,
        releaseShaderCache: releaseShaderCache,
        // Exposed for resource monitoring & error feedback via renderer.info:
        programs: programs,
        dispose: dispose
    };
}
function $d5b33d7c30034067$var$WebGLProperties() {
    let properties = new WeakMap();
    function has(object) {
        return properties.has(object);
    }
    function get(object) {
        let map = properties.get(object);
        if (map === undefined) {
            map = {};
            properties.set(object, map);
        }
        return map;
    }
    function remove(object) {
        properties.delete(object);
    }
    function update(object, key, value) {
        properties.get(object)[key] = value;
    }
    function dispose() {
        properties = new WeakMap();
    }
    return {
        has: has,
        get: get,
        remove: remove,
        update: update,
        dispose: dispose
    };
}
function $d5b33d7c30034067$var$painterSortStable(a, b) {
    if (a.groupOrder !== b.groupOrder) return a.groupOrder - b.groupOrder;
    else if (a.renderOrder !== b.renderOrder) return a.renderOrder - b.renderOrder;
    else if (a.material.id !== b.material.id) return a.material.id - b.material.id;
    else if (a.z !== b.z) return a.z - b.z;
    else return a.id - b.id;
}
function $d5b33d7c30034067$var$reversePainterSortStable(a, b) {
    if (a.groupOrder !== b.groupOrder) return a.groupOrder - b.groupOrder;
    else if (a.renderOrder !== b.renderOrder) return a.renderOrder - b.renderOrder;
    else if (a.z !== b.z) return b.z - a.z;
    else return a.id - b.id;
}
function $d5b33d7c30034067$var$WebGLRenderList() {
    const renderItems = [];
    let renderItemsIndex = 0;
    const opaque = [];
    const transmissive = [];
    const transparent = [];
    function init() {
        renderItemsIndex = 0;
        opaque.length = 0;
        transmissive.length = 0;
        transparent.length = 0;
    }
    function getNextRenderItem(object, geometry, material, groupOrder, z, group) {
        let renderItem = renderItems[renderItemsIndex];
        if (renderItem === undefined) {
            renderItem = {
                id: object.id,
                object: object,
                geometry: geometry,
                material: material,
                groupOrder: groupOrder,
                renderOrder: object.renderOrder,
                z: z,
                group: group
            };
            renderItems[renderItemsIndex] = renderItem;
        } else {
            renderItem.id = object.id;
            renderItem.object = object;
            renderItem.geometry = geometry;
            renderItem.material = material;
            renderItem.groupOrder = groupOrder;
            renderItem.renderOrder = object.renderOrder;
            renderItem.z = z;
            renderItem.group = group;
        }
        renderItemsIndex++;
        return renderItem;
    }
    function push(object, geometry, material, groupOrder, z, group) {
        const renderItem = getNextRenderItem(object, geometry, material, groupOrder, z, group);
        if (material.transmission > 0.0) transmissive.push(renderItem);
        else if (material.transparent === true) transparent.push(renderItem);
        else opaque.push(renderItem);
    }
    function unshift(object, geometry, material, groupOrder, z, group) {
        const renderItem = getNextRenderItem(object, geometry, material, groupOrder, z, group);
        if (material.transmission > 0.0) transmissive.unshift(renderItem);
        else if (material.transparent === true) transparent.unshift(renderItem);
        else opaque.unshift(renderItem);
    }
    function sort(customOpaqueSort, customTransparentSort) {
        if (opaque.length > 1) opaque.sort(customOpaqueSort || $d5b33d7c30034067$var$painterSortStable);
        if (transmissive.length > 1) transmissive.sort(customTransparentSort || $d5b33d7c30034067$var$reversePainterSortStable);
        if (transparent.length > 1) transparent.sort(customTransparentSort || $d5b33d7c30034067$var$reversePainterSortStable);
    }
    function finish() {
        // Clear references from inactive renderItems in the list
        for(let i = renderItemsIndex, il = renderItems.length; i < il; i++){
            const renderItem = renderItems[i];
            if (renderItem.id === null) break;
            renderItem.id = null;
            renderItem.object = null;
            renderItem.geometry = null;
            renderItem.material = null;
            renderItem.group = null;
        }
    }
    return {
        opaque: opaque,
        transmissive: transmissive,
        transparent: transparent,
        init: init,
        push: push,
        unshift: unshift,
        finish: finish,
        sort: sort
    };
}
function $d5b33d7c30034067$var$WebGLRenderLists() {
    let lists = new WeakMap();
    function get(scene, renderCallDepth) {
        const listArray = lists.get(scene);
        let list;
        if (listArray === undefined) {
            list = new $d5b33d7c30034067$var$WebGLRenderList();
            lists.set(scene, [
                list
            ]);
        } else if (renderCallDepth >= listArray.length) {
            list = new $d5b33d7c30034067$var$WebGLRenderList();
            listArray.push(list);
        } else list = listArray[renderCallDepth];
        return list;
    }
    function dispose() {
        lists = new WeakMap();
    }
    return {
        get: get,
        dispose: dispose
    };
}
function $d5b33d7c30034067$var$UniformsCache() {
    const lights = {};
    return {
        get: function(light) {
            if (lights[light.id] !== undefined) return lights[light.id];
            let uniforms;
            switch(light.type){
                case 'DirectionalLight':
                    uniforms = {
                        direction: new $d5b33d7c30034067$export$64b5c384219d3699(),
                        color: new $d5b33d7c30034067$export$892596cec99bc70e()
                    };
                    break;
                case 'SpotLight':
                    uniforms = {
                        position: new $d5b33d7c30034067$export$64b5c384219d3699(),
                        direction: new $d5b33d7c30034067$export$64b5c384219d3699(),
                        color: new $d5b33d7c30034067$export$892596cec99bc70e(),
                        distance: 0,
                        coneCos: 0,
                        penumbraCos: 0,
                        decay: 0
                    };
                    break;
                case 'PointLight':
                    uniforms = {
                        position: new $d5b33d7c30034067$export$64b5c384219d3699(),
                        color: new $d5b33d7c30034067$export$892596cec99bc70e(),
                        distance: 0,
                        decay: 0
                    };
                    break;
                case 'HemisphereLight':
                    uniforms = {
                        direction: new $d5b33d7c30034067$export$64b5c384219d3699(),
                        skyColor: new $d5b33d7c30034067$export$892596cec99bc70e(),
                        groundColor: new $d5b33d7c30034067$export$892596cec99bc70e()
                    };
                    break;
                case 'RectAreaLight':
                    uniforms = {
                        color: new $d5b33d7c30034067$export$892596cec99bc70e(),
                        position: new $d5b33d7c30034067$export$64b5c384219d3699(),
                        halfWidth: new $d5b33d7c30034067$export$64b5c384219d3699(),
                        halfHeight: new $d5b33d7c30034067$export$64b5c384219d3699()
                    };
                    break;
            }
            lights[light.id] = uniforms;
            return uniforms;
        }
    };
}
function $d5b33d7c30034067$var$ShadowUniformsCache() {
    const lights = {};
    return {
        get: function(light) {
            if (lights[light.id] !== undefined) return lights[light.id];
            let uniforms;
            switch(light.type){
                case 'DirectionalLight':
                    uniforms = {
                        shadowIntensity: 1,
                        shadowBias: 0,
                        shadowNormalBias: 0,
                        shadowRadius: 1,
                        shadowMapSize: new $d5b33d7c30034067$export$c977b3e384af9ae1()
                    };
                    break;
                case 'SpotLight':
                    uniforms = {
                        shadowIntensity: 1,
                        shadowBias: 0,
                        shadowNormalBias: 0,
                        shadowRadius: 1,
                        shadowMapSize: new $d5b33d7c30034067$export$c977b3e384af9ae1()
                    };
                    break;
                case 'PointLight':
                    uniforms = {
                        shadowIntensity: 1,
                        shadowBias: 0,
                        shadowNormalBias: 0,
                        shadowRadius: 1,
                        shadowMapSize: new $d5b33d7c30034067$export$c977b3e384af9ae1(),
                        shadowCameraNear: 1,
                        shadowCameraFar: 1000
                    };
                    break;
            }
            lights[light.id] = uniforms;
            return uniforms;
        }
    };
}
let $d5b33d7c30034067$var$nextVersion = 0;
function $d5b33d7c30034067$var$shadowCastingAndTexturingLightsFirst(lightA, lightB) {
    return (lightB.castShadow ? 2 : 0) - (lightA.castShadow ? 2 : 0) + (lightB.map ? 1 : 0) - (lightA.map ? 1 : 0);
}
function $d5b33d7c30034067$var$WebGLLights(extensions) {
    const cache = new $d5b33d7c30034067$var$UniformsCache();
    const shadowCache = $d5b33d7c30034067$var$ShadowUniformsCache();
    const state = {
        version: 0,
        hash: {
            directionalLength: -1,
            pointLength: -1,
            spotLength: -1,
            rectAreaLength: -1,
            hemiLength: -1,
            numDirectionalShadows: -1,
            numPointShadows: -1,
            numSpotShadows: -1,
            numSpotMaps: -1,
            numLightProbes: -1
        },
        ambient: [
            0,
            0,
            0
        ],
        probe: [],
        directional: [],
        directionalShadow: [],
        directionalShadowMap: [],
        directionalShadowMatrix: [],
        spot: [],
        spotLightMap: [],
        spotShadow: [],
        spotShadowMap: [],
        spotLightMatrix: [],
        rectArea: [],
        rectAreaLTC1: null,
        rectAreaLTC2: null,
        point: [],
        pointShadow: [],
        pointShadowMap: [],
        pointShadowMatrix: [],
        hemi: [],
        numSpotLightShadowsWithMaps: 0,
        numLightProbes: 0
    };
    for(let i = 0; i < 9; i++)state.probe.push(new $d5b33d7c30034067$export$64b5c384219d3699());
    const vector3 = new $d5b33d7c30034067$export$64b5c384219d3699();
    const matrix4 = new $d5b33d7c30034067$export$2ae72fc923e5eb5();
    const matrix42 = new $d5b33d7c30034067$export$2ae72fc923e5eb5();
    function setup(lights) {
        let r = 0, g = 0, b = 0;
        for(let i = 0; i < 9; i++)state.probe[i].set(0, 0, 0);
        let directionalLength = 0;
        let pointLength = 0;
        let spotLength = 0;
        let rectAreaLength = 0;
        let hemiLength = 0;
        let numDirectionalShadows = 0;
        let numPointShadows = 0;
        let numSpotShadows = 0;
        let numSpotMaps = 0;
        let numSpotShadowsWithMaps = 0;
        let numLightProbes = 0;
        // ordering : [shadow casting + map texturing, map texturing, shadow casting, none ]
        lights.sort($d5b33d7c30034067$var$shadowCastingAndTexturingLightsFirst);
        for(let i = 0, l = lights.length; i < l; i++){
            const light = lights[i];
            const color = light.color;
            const intensity = light.intensity;
            const distance = light.distance;
            const shadowMap = light.shadow && light.shadow.map ? light.shadow.map.texture : null;
            if (light.isAmbientLight) {
                r += color.r * intensity;
                g += color.g * intensity;
                b += color.b * intensity;
            } else if (light.isLightProbe) {
                for(let j = 0; j < 9; j++)state.probe[j].addScaledVector(light.sh.coefficients[j], intensity);
                numLightProbes++;
            } else if (light.isDirectionalLight) {
                const uniforms = cache.get(light);
                uniforms.color.copy(light.color).multiplyScalar(light.intensity);
                if (light.castShadow) {
                    const shadow = light.shadow;
                    const shadowUniforms = shadowCache.get(light);
                    shadowUniforms.shadowIntensity = shadow.intensity;
                    shadowUniforms.shadowBias = shadow.bias;
                    shadowUniforms.shadowNormalBias = shadow.normalBias;
                    shadowUniforms.shadowRadius = shadow.radius;
                    shadowUniforms.shadowMapSize = shadow.mapSize;
                    state.directionalShadow[directionalLength] = shadowUniforms;
                    state.directionalShadowMap[directionalLength] = shadowMap;
                    state.directionalShadowMatrix[directionalLength] = light.shadow.matrix;
                    numDirectionalShadows++;
                }
                state.directional[directionalLength] = uniforms;
                directionalLength++;
            } else if (light.isSpotLight) {
                const uniforms = cache.get(light);
                uniforms.position.setFromMatrixPosition(light.matrixWorld);
                uniforms.color.copy(color).multiplyScalar(intensity);
                uniforms.distance = distance;
                uniforms.coneCos = Math.cos(light.angle);
                uniforms.penumbraCos = Math.cos(light.angle * (1 - light.penumbra));
                uniforms.decay = light.decay;
                state.spot[spotLength] = uniforms;
                const shadow = light.shadow;
                if (light.map) {
                    state.spotLightMap[numSpotMaps] = light.map;
                    numSpotMaps++;
                    // make sure the lightMatrix is up to date
                    // TODO : do it if required only
                    shadow.updateMatrices(light);
                    if (light.castShadow) numSpotShadowsWithMaps++;
                }
                state.spotLightMatrix[spotLength] = shadow.matrix;
                if (light.castShadow) {
                    const shadowUniforms = shadowCache.get(light);
                    shadowUniforms.shadowIntensity = shadow.intensity;
                    shadowUniforms.shadowBias = shadow.bias;
                    shadowUniforms.shadowNormalBias = shadow.normalBias;
                    shadowUniforms.shadowRadius = shadow.radius;
                    shadowUniforms.shadowMapSize = shadow.mapSize;
                    state.spotShadow[spotLength] = shadowUniforms;
                    state.spotShadowMap[spotLength] = shadowMap;
                    numSpotShadows++;
                }
                spotLength++;
            } else if (light.isRectAreaLight) {
                const uniforms = cache.get(light);
                uniforms.color.copy(color).multiplyScalar(intensity);
                uniforms.halfWidth.set(light.width * 0.5, 0.0, 0.0);
                uniforms.halfHeight.set(0.0, light.height * 0.5, 0.0);
                state.rectArea[rectAreaLength] = uniforms;
                rectAreaLength++;
            } else if (light.isPointLight) {
                const uniforms = cache.get(light);
                uniforms.color.copy(light.color).multiplyScalar(light.intensity);
                uniforms.distance = light.distance;
                uniforms.decay = light.decay;
                if (light.castShadow) {
                    const shadow = light.shadow;
                    const shadowUniforms = shadowCache.get(light);
                    shadowUniforms.shadowIntensity = shadow.intensity;
                    shadowUniforms.shadowBias = shadow.bias;
                    shadowUniforms.shadowNormalBias = shadow.normalBias;
                    shadowUniforms.shadowRadius = shadow.radius;
                    shadowUniforms.shadowMapSize = shadow.mapSize;
                    shadowUniforms.shadowCameraNear = shadow.camera.near;
                    shadowUniforms.shadowCameraFar = shadow.camera.far;
                    state.pointShadow[pointLength] = shadowUniforms;
                    state.pointShadowMap[pointLength] = shadowMap;
                    state.pointShadowMatrix[pointLength] = light.shadow.matrix;
                    numPointShadows++;
                }
                state.point[pointLength] = uniforms;
                pointLength++;
            } else if (light.isHemisphereLight) {
                const uniforms = cache.get(light);
                uniforms.skyColor.copy(light.color).multiplyScalar(intensity);
                uniforms.groundColor.copy(light.groundColor).multiplyScalar(intensity);
                state.hemi[hemiLength] = uniforms;
                hemiLength++;
            }
        }
        if (rectAreaLength > 0) {
            if (extensions.has('OES_texture_float_linear') === true) {
                state.rectAreaLTC1 = $d5b33d7c30034067$export$6643083551874bf5.LTC_FLOAT_1;
                state.rectAreaLTC2 = $d5b33d7c30034067$export$6643083551874bf5.LTC_FLOAT_2;
            } else {
                state.rectAreaLTC1 = $d5b33d7c30034067$export$6643083551874bf5.LTC_HALF_1;
                state.rectAreaLTC2 = $d5b33d7c30034067$export$6643083551874bf5.LTC_HALF_2;
            }
        }
        state.ambient[0] = r;
        state.ambient[1] = g;
        state.ambient[2] = b;
        const hash = state.hash;
        if (hash.directionalLength !== directionalLength || hash.pointLength !== pointLength || hash.spotLength !== spotLength || hash.rectAreaLength !== rectAreaLength || hash.hemiLength !== hemiLength || hash.numDirectionalShadows !== numDirectionalShadows || hash.numPointShadows !== numPointShadows || hash.numSpotShadows !== numSpotShadows || hash.numSpotMaps !== numSpotMaps || hash.numLightProbes !== numLightProbes) {
            state.directional.length = directionalLength;
            state.spot.length = spotLength;
            state.rectArea.length = rectAreaLength;
            state.point.length = pointLength;
            state.hemi.length = hemiLength;
            state.directionalShadow.length = numDirectionalShadows;
            state.directionalShadowMap.length = numDirectionalShadows;
            state.pointShadow.length = numPointShadows;
            state.pointShadowMap.length = numPointShadows;
            state.spotShadow.length = numSpotShadows;
            state.spotShadowMap.length = numSpotShadows;
            state.directionalShadowMatrix.length = numDirectionalShadows;
            state.pointShadowMatrix.length = numPointShadows;
            state.spotLightMatrix.length = numSpotShadows + numSpotMaps - numSpotShadowsWithMaps;
            state.spotLightMap.length = numSpotMaps;
            state.numSpotLightShadowsWithMaps = numSpotShadowsWithMaps;
            state.numLightProbes = numLightProbes;
            hash.directionalLength = directionalLength;
            hash.pointLength = pointLength;
            hash.spotLength = spotLength;
            hash.rectAreaLength = rectAreaLength;
            hash.hemiLength = hemiLength;
            hash.numDirectionalShadows = numDirectionalShadows;
            hash.numPointShadows = numPointShadows;
            hash.numSpotShadows = numSpotShadows;
            hash.numSpotMaps = numSpotMaps;
            hash.numLightProbes = numLightProbes;
            state.version = $d5b33d7c30034067$var$nextVersion++;
        }
    }
    function setupView(lights, camera) {
        let directionalLength = 0;
        let pointLength = 0;
        let spotLength = 0;
        let rectAreaLength = 0;
        let hemiLength = 0;
        const viewMatrix = camera.matrixWorldInverse;
        for(let i = 0, l = lights.length; i < l; i++){
            const light = lights[i];
            if (light.isDirectionalLight) {
                const uniforms = state.directional[directionalLength];
                uniforms.direction.setFromMatrixPosition(light.matrixWorld);
                vector3.setFromMatrixPosition(light.target.matrixWorld);
                uniforms.direction.sub(vector3);
                uniforms.direction.transformDirection(viewMatrix);
                directionalLength++;
            } else if (light.isSpotLight) {
                const uniforms = state.spot[spotLength];
                uniforms.position.setFromMatrixPosition(light.matrixWorld);
                uniforms.position.applyMatrix4(viewMatrix);
                uniforms.direction.setFromMatrixPosition(light.matrixWorld);
                vector3.setFromMatrixPosition(light.target.matrixWorld);
                uniforms.direction.sub(vector3);
                uniforms.direction.transformDirection(viewMatrix);
                spotLength++;
            } else if (light.isRectAreaLight) {
                const uniforms = state.rectArea[rectAreaLength];
                uniforms.position.setFromMatrixPosition(light.matrixWorld);
                uniforms.position.applyMatrix4(viewMatrix);
                // extract local rotation of light to derive width/height half vectors
                matrix42.identity();
                matrix4.copy(light.matrixWorld);
                matrix4.premultiply(viewMatrix);
                matrix42.extractRotation(matrix4);
                uniforms.halfWidth.set(light.width * 0.5, 0.0, 0.0);
                uniforms.halfHeight.set(0.0, light.height * 0.5, 0.0);
                uniforms.halfWidth.applyMatrix4(matrix42);
                uniforms.halfHeight.applyMatrix4(matrix42);
                rectAreaLength++;
            } else if (light.isPointLight) {
                const uniforms = state.point[pointLength];
                uniforms.position.setFromMatrixPosition(light.matrixWorld);
                uniforms.position.applyMatrix4(viewMatrix);
                pointLength++;
            } else if (light.isHemisphereLight) {
                const uniforms = state.hemi[hemiLength];
                uniforms.direction.setFromMatrixPosition(light.matrixWorld);
                uniforms.direction.transformDirection(viewMatrix);
                hemiLength++;
            }
        }
    }
    return {
        setup: setup,
        setupView: setupView,
        state: state
    };
}
function $d5b33d7c30034067$var$WebGLRenderState(extensions) {
    const lights = new $d5b33d7c30034067$var$WebGLLights(extensions);
    const lightsArray = [];
    const shadowsArray = [];
    function init(camera) {
        state.camera = camera;
        lightsArray.length = 0;
        shadowsArray.length = 0;
    }
    function pushLight(light) {
        lightsArray.push(light);
    }
    function pushShadow(shadowLight) {
        shadowsArray.push(shadowLight);
    }
    function setupLights() {
        lights.setup(lightsArray);
    }
    function setupLightsView(camera) {
        lights.setupView(lightsArray, camera);
    }
    const state = {
        lightsArray: lightsArray,
        shadowsArray: shadowsArray,
        camera: null,
        lights: lights,
        transmissionRenderTarget: {}
    };
    return {
        init: init,
        state: state,
        setupLights: setupLights,
        setupLightsView: setupLightsView,
        pushLight: pushLight,
        pushShadow: pushShadow
    };
}
function $d5b33d7c30034067$var$WebGLRenderStates(extensions) {
    let renderStates = new WeakMap();
    function get(scene, renderCallDepth = 0) {
        const renderStateArray = renderStates.get(scene);
        let renderState;
        if (renderStateArray === undefined) {
            renderState = new $d5b33d7c30034067$var$WebGLRenderState(extensions);
            renderStates.set(scene, [
                renderState
            ]);
        } else if (renderCallDepth >= renderStateArray.length) {
            renderState = new $d5b33d7c30034067$var$WebGLRenderState(extensions);
            renderStateArray.push(renderState);
        } else renderState = renderStateArray[renderCallDepth];
        return renderState;
    }
    function dispose() {
        renderStates = new WeakMap();
    }
    return {
        get: get,
        dispose: dispose
    };
}
class $d5b33d7c30034067$export$2698c22ec13825db extends $d5b33d7c30034067$export$a2d8b23205c25948 {
    static get type() {
        return 'MeshDepthMaterial';
    }
    constructor(parameters){
        super();
        this.isMeshDepthMaterial = true;
        this.depthPacking = $d5b33d7c30034067$export$deeb383078690b50;
        this.map = null;
        this.alphaMap = null;
        this.displacementMap = null;
        this.displacementScale = 1;
        this.displacementBias = 0;
        this.wireframe = false;
        this.wireframeLinewidth = 1;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.depthPacking = source.depthPacking;
        this.map = source.map;
        this.alphaMap = source.alphaMap;
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        return this;
    }
}
class $d5b33d7c30034067$export$33e187ed002f2a19 extends $d5b33d7c30034067$export$a2d8b23205c25948 {
    static get type() {
        return 'MeshDistanceMaterial';
    }
    constructor(parameters){
        super();
        this.isMeshDistanceMaterial = true;
        this.map = null;
        this.alphaMap = null;
        this.displacementMap = null;
        this.displacementScale = 1;
        this.displacementBias = 0;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.map = source.map;
        this.alphaMap = source.alphaMap;
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        return this;
    }
}
const $d5b33d7c30034067$var$vertex = "void main() {\n\tgl_Position = vec4( position, 1.0 );\n}";
const $d5b33d7c30034067$var$fragment = "uniform sampler2D shadow_pass;\nuniform vec2 resolution;\nuniform float radius;\n#include <packing>\nvoid main() {\n\tconst float samples = float( VSM_SAMPLES );\n\tfloat mean = 0.0;\n\tfloat squared_mean = 0.0;\n\tfloat uvStride = samples <= 1.0 ? 0.0 : 2.0 / ( samples - 1.0 );\n\tfloat uvStart = samples <= 1.0 ? 0.0 : - 1.0;\n\tfor ( float i = 0.0; i < samples; i ++ ) {\n\t\tfloat uvOffset = uvStart + i * uvStride;\n\t\t#ifdef HORIZONTAL_PASS\n\t\t\tvec2 distribution = unpackRGBATo2Half( texture2D( shadow_pass, ( gl_FragCoord.xy + vec2( uvOffset, 0.0 ) * radius ) / resolution ) );\n\t\t\tmean += distribution.x;\n\t\t\tsquared_mean += distribution.y * distribution.y + distribution.x * distribution.x;\n\t\t#else\n\t\t\tfloat depth = unpackRGBAToDepth( texture2D( shadow_pass, ( gl_FragCoord.xy + vec2( 0.0, uvOffset ) * radius ) / resolution ) );\n\t\t\tmean += depth;\n\t\t\tsquared_mean += depth * depth;\n\t\t#endif\n\t}\n\tmean = mean / samples;\n\tsquared_mean = squared_mean / samples;\n\tfloat std_dev = sqrt( squared_mean - mean * mean );\n\tgl_FragColor = pack2HalfToRGBA( vec2( mean, std_dev ) );\n}";
function $d5b33d7c30034067$var$WebGLShadowMap(renderer, objects, capabilities) {
    let _frustum = new $d5b33d7c30034067$export$35efe6f4c85463d2();
    const _shadowMapSize = new $d5b33d7c30034067$export$c977b3e384af9ae1(), _viewportSize = new $d5b33d7c30034067$export$c977b3e384af9ae1(), _viewport = new $d5b33d7c30034067$export$fa7daccca11cdbe3(), _depthMaterial = new $d5b33d7c30034067$export$2698c22ec13825db({
        depthPacking: $d5b33d7c30034067$export$8f910f4c4f73df11
    }), _distanceMaterial = new $d5b33d7c30034067$export$33e187ed002f2a19(), _materialCache = {}, _maxTextureSize = capabilities.maxTextureSize;
    const shadowSide = {
        [$d5b33d7c30034067$export$2ede184fc2998901]: $d5b33d7c30034067$export$d9f0486e75b5ace,
        [$d5b33d7c30034067$export$d9f0486e75b5ace]: $d5b33d7c30034067$export$2ede184fc2998901,
        [$d5b33d7c30034067$export$3b296b6f144d5b03]: $d5b33d7c30034067$export$3b296b6f144d5b03
    };
    const shadowMaterialVertical = new $d5b33d7c30034067$export$83c7d75d550a8b0d({
        defines: {
            VSM_SAMPLES: 8
        },
        uniforms: {
            shadow_pass: {
                value: null
            },
            resolution: {
                value: new $d5b33d7c30034067$export$c977b3e384af9ae1()
            },
            radius: {
                value: 4.0
            }
        },
        vertexShader: $d5b33d7c30034067$var$vertex,
        fragmentShader: $d5b33d7c30034067$var$fragment
    });
    const shadowMaterialHorizontal = shadowMaterialVertical.clone();
    shadowMaterialHorizontal.defines.HORIZONTAL_PASS = 1;
    const fullScreenTri = new $d5b33d7c30034067$export$b7be63a67df8959();
    fullScreenTri.setAttribute('position', new $d5b33d7c30034067$export$8dea267bd6bde117(new Float32Array([
        -1,
        -1,
        0.5,
        3,
        -1,
        0.5,
        -1,
        3,
        0.5
    ]), 3));
    const fullScreenMesh = new $d5b33d7c30034067$export$e176487c05830cc5(fullScreenTri, shadowMaterialVertical);
    const scope = this;
    this.enabled = false;
    this.autoUpdate = true;
    this.needsUpdate = false;
    this.type = $d5b33d7c30034067$export$5813f879eee7cd88;
    let _previousType = this.type;
    this.render = function(lights, scene, camera) {
        if (scope.enabled === false) return;
        if (scope.autoUpdate === false && scope.needsUpdate === false) return;
        if (lights.length === 0) return;
        const currentRenderTarget = renderer.getRenderTarget();
        const activeCubeFace = renderer.getActiveCubeFace();
        const activeMipmapLevel = renderer.getActiveMipmapLevel();
        const _state = renderer.state;
        // Set GL state for depth map.
        _state.setBlending($d5b33d7c30034067$export$63b8d6b580fc65ba);
        _state.buffers.color.setClear(1, 1, 1, 1);
        _state.buffers.depth.setTest(true);
        _state.setScissorTest(false);
        // check for shadow map type changes
        const toVSM = _previousType !== $d5b33d7c30034067$export$896ae1ade6c829c4 && this.type === $d5b33d7c30034067$export$896ae1ade6c829c4;
        const fromVSM = _previousType === $d5b33d7c30034067$export$896ae1ade6c829c4 && this.type !== $d5b33d7c30034067$export$896ae1ade6c829c4;
        // render depth map
        for(let i = 0, il = lights.length; i < il; i++){
            const light = lights[i];
            const shadow = light.shadow;
            if (shadow === undefined) {
                console.warn('THREE.WebGLShadowMap:', light, 'has no shadow.');
                continue;
            }
            if (shadow.autoUpdate === false && shadow.needsUpdate === false) continue;
            _shadowMapSize.copy(shadow.mapSize);
            const shadowFrameExtents = shadow.getFrameExtents();
            _shadowMapSize.multiply(shadowFrameExtents);
            _viewportSize.copy(shadow.mapSize);
            if (_shadowMapSize.x > _maxTextureSize || _shadowMapSize.y > _maxTextureSize) {
                if (_shadowMapSize.x > _maxTextureSize) {
                    _viewportSize.x = Math.floor(_maxTextureSize / shadowFrameExtents.x);
                    _shadowMapSize.x = _viewportSize.x * shadowFrameExtents.x;
                    shadow.mapSize.x = _viewportSize.x;
                }
                if (_shadowMapSize.y > _maxTextureSize) {
                    _viewportSize.y = Math.floor(_maxTextureSize / shadowFrameExtents.y);
                    _shadowMapSize.y = _viewportSize.y * shadowFrameExtents.y;
                    shadow.mapSize.y = _viewportSize.y;
                }
            }
            if (shadow.map === null || toVSM === true || fromVSM === true) {
                const pars = this.type !== $d5b33d7c30034067$export$896ae1ade6c829c4 ? {
                    minFilter: $d5b33d7c30034067$export$727aa5ec3fe39bf0,
                    magFilter: $d5b33d7c30034067$export$727aa5ec3fe39bf0
                } : {};
                if (shadow.map !== null) shadow.map.dispose();
                shadow.map = new $d5b33d7c30034067$export$3c052beb2e51e23f(_shadowMapSize.x, _shadowMapSize.y, pars);
                shadow.map.texture.name = light.name + '.shadowMap';
                shadow.camera.updateProjectionMatrix();
            }
            renderer.setRenderTarget(shadow.map);
            renderer.clear();
            const viewportCount = shadow.getViewportCount();
            for(let vp = 0; vp < viewportCount; vp++){
                const viewport = shadow.getViewport(vp);
                _viewport.set(_viewportSize.x * viewport.x, _viewportSize.y * viewport.y, _viewportSize.x * viewport.z, _viewportSize.y * viewport.w);
                _state.viewport(_viewport);
                shadow.updateMatrices(light, vp);
                _frustum = shadow.getFrustum();
                renderObject(scene, camera, shadow.camera, light, this.type);
            }
            // do blur pass for VSM
            if (shadow.isPointLightShadow !== true && this.type === $d5b33d7c30034067$export$896ae1ade6c829c4) VSMPass(shadow, camera);
            shadow.needsUpdate = false;
        }
        _previousType = this.type;
        scope.needsUpdate = false;
        renderer.setRenderTarget(currentRenderTarget, activeCubeFace, activeMipmapLevel);
    };
    function VSMPass(shadow, camera) {
        const geometry = objects.update(fullScreenMesh);
        if (shadowMaterialVertical.defines.VSM_SAMPLES !== shadow.blurSamples) {
            shadowMaterialVertical.defines.VSM_SAMPLES = shadow.blurSamples;
            shadowMaterialHorizontal.defines.VSM_SAMPLES = shadow.blurSamples;
            shadowMaterialVertical.needsUpdate = true;
            shadowMaterialHorizontal.needsUpdate = true;
        }
        if (shadow.mapPass === null) shadow.mapPass = new $d5b33d7c30034067$export$3c052beb2e51e23f(_shadowMapSize.x, _shadowMapSize.y);
        // vertical pass
        shadowMaterialVertical.uniforms.shadow_pass.value = shadow.map.texture;
        shadowMaterialVertical.uniforms.resolution.value = shadow.mapSize;
        shadowMaterialVertical.uniforms.radius.value = shadow.radius;
        renderer.setRenderTarget(shadow.mapPass);
        renderer.clear();
        renderer.renderBufferDirect(camera, null, geometry, shadowMaterialVertical, fullScreenMesh, null);
        // horizontal pass
        shadowMaterialHorizontal.uniforms.shadow_pass.value = shadow.mapPass.texture;
        shadowMaterialHorizontal.uniforms.resolution.value = shadow.mapSize;
        shadowMaterialHorizontal.uniforms.radius.value = shadow.radius;
        renderer.setRenderTarget(shadow.map);
        renderer.clear();
        renderer.renderBufferDirect(camera, null, geometry, shadowMaterialHorizontal, fullScreenMesh, null);
    }
    function getDepthMaterial(object, material, light, type) {
        let result = null;
        const customMaterial = light.isPointLight === true ? object.customDistanceMaterial : object.customDepthMaterial;
        if (customMaterial !== undefined) result = customMaterial;
        else {
            result = light.isPointLight === true ? _distanceMaterial : _depthMaterial;
            if (renderer.localClippingEnabled && material.clipShadows === true && Array.isArray(material.clippingPlanes) && material.clippingPlanes.length !== 0 || material.displacementMap && material.displacementScale !== 0 || material.alphaMap && material.alphaTest > 0 || material.map && material.alphaTest > 0) {
                // in this case we need a unique material instance reflecting the
                // appropriate state
                const keyA = result.uuid, keyB = material.uuid;
                let materialsForVariant = _materialCache[keyA];
                if (materialsForVariant === undefined) {
                    materialsForVariant = {};
                    _materialCache[keyA] = materialsForVariant;
                }
                let cachedMaterial = materialsForVariant[keyB];
                if (cachedMaterial === undefined) {
                    cachedMaterial = result.clone();
                    materialsForVariant[keyB] = cachedMaterial;
                    material.addEventListener('dispose', onMaterialDispose);
                }
                result = cachedMaterial;
            }
        }
        result.visible = material.visible;
        result.wireframe = material.wireframe;
        if (type === $d5b33d7c30034067$export$896ae1ade6c829c4) result.side = material.shadowSide !== null ? material.shadowSide : material.side;
        else result.side = material.shadowSide !== null ? material.shadowSide : shadowSide[material.side];
        result.alphaMap = material.alphaMap;
        result.alphaTest = material.alphaTest;
        result.map = material.map;
        result.clipShadows = material.clipShadows;
        result.clippingPlanes = material.clippingPlanes;
        result.clipIntersection = material.clipIntersection;
        result.displacementMap = material.displacementMap;
        result.displacementScale = material.displacementScale;
        result.displacementBias = material.displacementBias;
        result.wireframeLinewidth = material.wireframeLinewidth;
        result.linewidth = material.linewidth;
        if (light.isPointLight === true && result.isMeshDistanceMaterial === true) {
            const materialProperties = renderer.properties.get(result);
            materialProperties.light = light;
        }
        return result;
    }
    function renderObject(object, camera, shadowCamera, light, type) {
        if (object.visible === false) return;
        const visible = object.layers.test(camera.layers);
        if (visible && (object.isMesh || object.isLine || object.isPoints)) {
            if ((object.castShadow || object.receiveShadow && type === $d5b33d7c30034067$export$896ae1ade6c829c4) && (!object.frustumCulled || _frustum.intersectsObject(object))) {
                object.modelViewMatrix.multiplyMatrices(shadowCamera.matrixWorldInverse, object.matrixWorld);
                const geometry = objects.update(object);
                const material = object.material;
                if (Array.isArray(material)) {
                    const groups = geometry.groups;
                    for(let k = 0, kl = groups.length; k < kl; k++){
                        const group = groups[k];
                        const groupMaterial = material[group.materialIndex];
                        if (groupMaterial && groupMaterial.visible) {
                            const depthMaterial = getDepthMaterial(object, groupMaterial, light, type);
                            object.onBeforeShadow(renderer, object, camera, shadowCamera, geometry, depthMaterial, group);
                            renderer.renderBufferDirect(shadowCamera, null, geometry, depthMaterial, object, group);
                            object.onAfterShadow(renderer, object, camera, shadowCamera, geometry, depthMaterial, group);
                        }
                    }
                } else if (material.visible) {
                    const depthMaterial = getDepthMaterial(object, material, light, type);
                    object.onBeforeShadow(renderer, object, camera, shadowCamera, geometry, depthMaterial, null);
                    renderer.renderBufferDirect(shadowCamera, null, geometry, depthMaterial, object, null);
                    object.onAfterShadow(renderer, object, camera, shadowCamera, geometry, depthMaterial, null);
                }
            }
        }
        const children = object.children;
        for(let i = 0, l = children.length; i < l; i++)renderObject(children[i], camera, shadowCamera, light, type);
    }
    function onMaterialDispose(event) {
        const material = event.target;
        material.removeEventListener('dispose', onMaterialDispose);
        // make sure to remove the unique distance/depth materials used for shadow map rendering
        for(const id in _materialCache){
            const cache = _materialCache[id];
            const uuid = event.target.uuid;
            if (uuid in cache) {
                const shadowMaterial = cache[uuid];
                shadowMaterial.dispose();
                delete cache[uuid];
            }
        }
    }
}
const $d5b33d7c30034067$var$reversedFuncs = {
    [$d5b33d7c30034067$export$69025ce147cee220]: $d5b33d7c30034067$export$7182eb52ea3b3f04,
    [$d5b33d7c30034067$export$eedccec66ab7ebe]: $d5b33d7c30034067$export$c5e2c52991f30937,
    [$d5b33d7c30034067$export$a60d398fc7b7590e]: $d5b33d7c30034067$export$2f843afa843d8916,
    [$d5b33d7c30034067$export$296f78a0b892f81a]: $d5b33d7c30034067$export$7d7234c1240a1fc4,
    [$d5b33d7c30034067$export$7182eb52ea3b3f04]: $d5b33d7c30034067$export$69025ce147cee220,
    [$d5b33d7c30034067$export$c5e2c52991f30937]: $d5b33d7c30034067$export$eedccec66ab7ebe,
    [$d5b33d7c30034067$export$2f843afa843d8916]: $d5b33d7c30034067$export$a60d398fc7b7590e,
    [$d5b33d7c30034067$export$7d7234c1240a1fc4]: $d5b33d7c30034067$export$296f78a0b892f81a
};
function $d5b33d7c30034067$var$WebGLState(gl, extensions) {
    function ColorBuffer() {
        let locked = false;
        const color = new $d5b33d7c30034067$export$fa7daccca11cdbe3();
        let currentColorMask = null;
        const currentColorClear = new $d5b33d7c30034067$export$fa7daccca11cdbe3(0, 0, 0, 0);
        return {
            setMask: function(colorMask) {
                if (currentColorMask !== colorMask && !locked) {
                    gl.colorMask(colorMask, colorMask, colorMask, colorMask);
                    currentColorMask = colorMask;
                }
            },
            setLocked: function(lock) {
                locked = lock;
            },
            setClear: function(r, g, b, a, premultipliedAlpha) {
                if (premultipliedAlpha === true) {
                    r *= a;
                    g *= a;
                    b *= a;
                }
                color.set(r, g, b, a);
                if (currentColorClear.equals(color) === false) {
                    gl.clearColor(r, g, b, a);
                    currentColorClear.copy(color);
                }
            },
            reset: function() {
                locked = false;
                currentColorMask = null;
                currentColorClear.set(-1, 0, 0, 0); // set to invalid state
            }
        };
    }
    function DepthBuffer() {
        let locked = false;
        let reversed = false;
        let currentDepthMask = null;
        let currentDepthFunc = null;
        let currentDepthClear = null;
        return {
            setReversed: function(value) {
                if (reversed !== value) {
                    const ext = extensions.get('EXT_clip_control');
                    if (reversed) ext.clipControlEXT(ext.LOWER_LEFT_EXT, ext.ZERO_TO_ONE_EXT);
                    else ext.clipControlEXT(ext.LOWER_LEFT_EXT, ext.NEGATIVE_ONE_TO_ONE_EXT);
                    const oldDepth = currentDepthClear;
                    currentDepthClear = null;
                    this.setClear(oldDepth);
                }
                reversed = value;
            },
            getReversed: function() {
                return reversed;
            },
            setTest: function(depthTest) {
                if (depthTest) enable(gl.DEPTH_TEST);
                else disable(gl.DEPTH_TEST);
            },
            setMask: function(depthMask) {
                if (currentDepthMask !== depthMask && !locked) {
                    gl.depthMask(depthMask);
                    currentDepthMask = depthMask;
                }
            },
            setFunc: function(depthFunc) {
                if (reversed) depthFunc = $d5b33d7c30034067$var$reversedFuncs[depthFunc];
                if (currentDepthFunc !== depthFunc) {
                    switch(depthFunc){
                        case $d5b33d7c30034067$export$69025ce147cee220:
                            gl.depthFunc(gl.NEVER);
                            break;
                        case $d5b33d7c30034067$export$7182eb52ea3b3f04:
                            gl.depthFunc(gl.ALWAYS);
                            break;
                        case $d5b33d7c30034067$export$eedccec66ab7ebe:
                            gl.depthFunc(gl.LESS);
                            break;
                        case $d5b33d7c30034067$export$296f78a0b892f81a:
                            gl.depthFunc(gl.LEQUAL);
                            break;
                        case $d5b33d7c30034067$export$a60d398fc7b7590e:
                            gl.depthFunc(gl.EQUAL);
                            break;
                        case $d5b33d7c30034067$export$7d7234c1240a1fc4:
                            gl.depthFunc(gl.GEQUAL);
                            break;
                        case $d5b33d7c30034067$export$c5e2c52991f30937:
                            gl.depthFunc(gl.GREATER);
                            break;
                        case $d5b33d7c30034067$export$2f843afa843d8916:
                            gl.depthFunc(gl.NOTEQUAL);
                            break;
                        default:
                            gl.depthFunc(gl.LEQUAL);
                    }
                    currentDepthFunc = depthFunc;
                }
            },
            setLocked: function(lock) {
                locked = lock;
            },
            setClear: function(depth) {
                if (currentDepthClear !== depth) {
                    if (reversed) depth = 1 - depth;
                    gl.clearDepth(depth);
                    currentDepthClear = depth;
                }
            },
            reset: function() {
                locked = false;
                currentDepthMask = null;
                currentDepthFunc = null;
                currentDepthClear = null;
                reversed = false;
            }
        };
    }
    function StencilBuffer() {
        let locked = false;
        let currentStencilMask = null;
        let currentStencilFunc = null;
        let currentStencilRef = null;
        let currentStencilFuncMask = null;
        let currentStencilFail = null;
        let currentStencilZFail = null;
        let currentStencilZPass = null;
        let currentStencilClear = null;
        return {
            setTest: function(stencilTest) {
                if (!locked) {
                    if (stencilTest) enable(gl.STENCIL_TEST);
                    else disable(gl.STENCIL_TEST);
                }
            },
            setMask: function(stencilMask) {
                if (currentStencilMask !== stencilMask && !locked) {
                    gl.stencilMask(stencilMask);
                    currentStencilMask = stencilMask;
                }
            },
            setFunc: function(stencilFunc, stencilRef, stencilMask) {
                if (currentStencilFunc !== stencilFunc || currentStencilRef !== stencilRef || currentStencilFuncMask !== stencilMask) {
                    gl.stencilFunc(stencilFunc, stencilRef, stencilMask);
                    currentStencilFunc = stencilFunc;
                    currentStencilRef = stencilRef;
                    currentStencilFuncMask = stencilMask;
                }
            },
            setOp: function(stencilFail, stencilZFail, stencilZPass) {
                if (currentStencilFail !== stencilFail || currentStencilZFail !== stencilZFail || currentStencilZPass !== stencilZPass) {
                    gl.stencilOp(stencilFail, stencilZFail, stencilZPass);
                    currentStencilFail = stencilFail;
                    currentStencilZFail = stencilZFail;
                    currentStencilZPass = stencilZPass;
                }
            },
            setLocked: function(lock) {
                locked = lock;
            },
            setClear: function(stencil) {
                if (currentStencilClear !== stencil) {
                    gl.clearStencil(stencil);
                    currentStencilClear = stencil;
                }
            },
            reset: function() {
                locked = false;
                currentStencilMask = null;
                currentStencilFunc = null;
                currentStencilRef = null;
                currentStencilFuncMask = null;
                currentStencilFail = null;
                currentStencilZFail = null;
                currentStencilZPass = null;
                currentStencilClear = null;
            }
        };
    }
    //
    const colorBuffer = new ColorBuffer();
    const depthBuffer = new DepthBuffer();
    const stencilBuffer = new StencilBuffer();
    const uboBindings = new WeakMap();
    const uboProgramMap = new WeakMap();
    let enabledCapabilities = {};
    let currentBoundFramebuffers = {};
    let currentDrawbuffers = new WeakMap();
    let defaultDrawbuffers = [];
    let currentProgram = null;
    let currentBlendingEnabled = false;
    let currentBlending = null;
    let currentBlendEquation = null;
    let currentBlendSrc = null;
    let currentBlendDst = null;
    let currentBlendEquationAlpha = null;
    let currentBlendSrcAlpha = null;
    let currentBlendDstAlpha = null;
    let currentBlendColor = new $d5b33d7c30034067$export$892596cec99bc70e(0, 0, 0);
    let currentBlendAlpha = 0;
    let currentPremultipledAlpha = false;
    let currentFlipSided = null;
    let currentCullFace = null;
    let currentLineWidth = null;
    let currentPolygonOffsetFactor = null;
    let currentPolygonOffsetUnits = null;
    const maxTextures = gl.getParameter(gl.MAX_COMBINED_TEXTURE_IMAGE_UNITS);
    let lineWidthAvailable = false;
    let version = 0;
    const glVersion = gl.getParameter(gl.VERSION);
    if (glVersion.indexOf('WebGL') !== -1) {
        version = parseFloat(/^WebGL (\d)/.exec(glVersion)[1]);
        lineWidthAvailable = version >= 1.0;
    } else if (glVersion.indexOf('OpenGL ES') !== -1) {
        version = parseFloat(/^OpenGL ES (\d)/.exec(glVersion)[1]);
        lineWidthAvailable = version >= 2.0;
    }
    let currentTextureSlot = null;
    let currentBoundTextures = {};
    const scissorParam = gl.getParameter(gl.SCISSOR_BOX);
    const viewportParam = gl.getParameter(gl.VIEWPORT);
    const currentScissor = new $d5b33d7c30034067$export$fa7daccca11cdbe3().fromArray(scissorParam);
    const currentViewport = new $d5b33d7c30034067$export$fa7daccca11cdbe3().fromArray(viewportParam);
    function createTexture(type, target, count, dimensions) {
        const data = new Uint8Array(4); // 4 is required to match default unpack alignment of 4.
        const texture = gl.createTexture();
        gl.bindTexture(type, texture);
        gl.texParameteri(type, gl.TEXTURE_MIN_FILTER, gl.NEAREST);
        gl.texParameteri(type, gl.TEXTURE_MAG_FILTER, gl.NEAREST);
        for(let i = 0; i < count; i++)if (type === gl.TEXTURE_3D || type === gl.TEXTURE_2D_ARRAY) gl.texImage3D(target, 0, gl.RGBA, 1, 1, dimensions, 0, gl.RGBA, gl.UNSIGNED_BYTE, data);
        else gl.texImage2D(target + i, 0, gl.RGBA, 1, 1, 0, gl.RGBA, gl.UNSIGNED_BYTE, data);
        return texture;
    }
    const emptyTextures = {};
    emptyTextures[gl.TEXTURE_2D] = createTexture(gl.TEXTURE_2D, gl.TEXTURE_2D, 1);
    emptyTextures[gl.TEXTURE_CUBE_MAP] = createTexture(gl.TEXTURE_CUBE_MAP, gl.TEXTURE_CUBE_MAP_POSITIVE_X, 6);
    emptyTextures[gl.TEXTURE_2D_ARRAY] = createTexture(gl.TEXTURE_2D_ARRAY, gl.TEXTURE_2D_ARRAY, 1, 1);
    emptyTextures[gl.TEXTURE_3D] = createTexture(gl.TEXTURE_3D, gl.TEXTURE_3D, 1, 1);
    // init
    colorBuffer.setClear(0, 0, 0, 1);
    depthBuffer.setClear(1);
    stencilBuffer.setClear(0);
    enable(gl.DEPTH_TEST);
    depthBuffer.setFunc($d5b33d7c30034067$export$296f78a0b892f81a);
    setFlipSided(false);
    setCullFace($d5b33d7c30034067$export$b9a7b4fc5cb15f9b);
    enable(gl.CULL_FACE);
    setBlending($d5b33d7c30034067$export$63b8d6b580fc65ba);
    //
    function enable(id) {
        if (enabledCapabilities[id] !== true) {
            gl.enable(id);
            enabledCapabilities[id] = true;
        }
    }
    function disable(id) {
        if (enabledCapabilities[id] !== false) {
            gl.disable(id);
            enabledCapabilities[id] = false;
        }
    }
    function bindFramebuffer(target, framebuffer) {
        if (currentBoundFramebuffers[target] !== framebuffer) {
            gl.bindFramebuffer(target, framebuffer);
            currentBoundFramebuffers[target] = framebuffer;
            // gl.DRAW_FRAMEBUFFER is equivalent to gl.FRAMEBUFFER
            if (target === gl.DRAW_FRAMEBUFFER) currentBoundFramebuffers[gl.FRAMEBUFFER] = framebuffer;
            if (target === gl.FRAMEBUFFER) currentBoundFramebuffers[gl.DRAW_FRAMEBUFFER] = framebuffer;
            return true;
        }
        return false;
    }
    function drawBuffers(renderTarget, framebuffer) {
        let drawBuffers = defaultDrawbuffers;
        let needsUpdate = false;
        if (renderTarget) {
            drawBuffers = currentDrawbuffers.get(framebuffer);
            if (drawBuffers === undefined) {
                drawBuffers = [];
                currentDrawbuffers.set(framebuffer, drawBuffers);
            }
            const textures = renderTarget.textures;
            if (drawBuffers.length !== textures.length || drawBuffers[0] !== gl.COLOR_ATTACHMENT0) {
                for(let i = 0, il = textures.length; i < il; i++)drawBuffers[i] = gl.COLOR_ATTACHMENT0 + i;
                drawBuffers.length = textures.length;
                needsUpdate = true;
            }
        } else if (drawBuffers[0] !== gl.BACK) {
            drawBuffers[0] = gl.BACK;
            needsUpdate = true;
        }
        if (needsUpdate) gl.drawBuffers(drawBuffers);
    }
    function useProgram(program) {
        if (currentProgram !== program) {
            gl.useProgram(program);
            currentProgram = program;
            return true;
        }
        return false;
    }
    const equationToGL = {
        [$d5b33d7c30034067$export$20183a0484ce21a0]: gl.FUNC_ADD,
        [$d5b33d7c30034067$export$73e0df5177988548]: gl.FUNC_SUBTRACT,
        [$d5b33d7c30034067$export$28e582859cbec660]: gl.FUNC_REVERSE_SUBTRACT
    };
    equationToGL[$d5b33d7c30034067$export$c8c1508da8d0600c] = gl.MIN;
    equationToGL[$d5b33d7c30034067$export$99948c02fb51055f] = gl.MAX;
    const factorToGL = {
        [$d5b33d7c30034067$export$2110f05edf778d3d]: gl.ZERO,
        [$d5b33d7c30034067$export$8805bad65e24940e]: gl.ONE,
        [$d5b33d7c30034067$export$7fbe15b28d28cf52]: gl.SRC_COLOR,
        [$d5b33d7c30034067$export$d5773124e86cf28c]: gl.SRC_ALPHA,
        [$d5b33d7c30034067$export$c05e2a1fc8609506]: gl.SRC_ALPHA_SATURATE,
        [$d5b33d7c30034067$export$ef5f2dd8ffac5574]: gl.DST_COLOR,
        [$d5b33d7c30034067$export$a78aed1ca2a87192]: gl.DST_ALPHA,
        [$d5b33d7c30034067$export$947829af9f2c17f6]: gl.ONE_MINUS_SRC_COLOR,
        [$d5b33d7c30034067$export$11d468cc7f19e971]: gl.ONE_MINUS_SRC_ALPHA,
        [$d5b33d7c30034067$export$56b85b2686ab16]: gl.ONE_MINUS_DST_COLOR,
        [$d5b33d7c30034067$export$5d0fe17fd8773bac]: gl.ONE_MINUS_DST_ALPHA,
        [$d5b33d7c30034067$export$7dd8f434fd59075]: gl.CONSTANT_COLOR,
        [$d5b33d7c30034067$export$99c8d898a9afbcee]: gl.ONE_MINUS_CONSTANT_COLOR,
        [$d5b33d7c30034067$export$310cd2be38d13b56]: gl.CONSTANT_ALPHA,
        [$d5b33d7c30034067$export$db77b8fbcf45dbf4]: gl.ONE_MINUS_CONSTANT_ALPHA
    };
    function setBlending(blending, blendEquation, blendSrc, blendDst, blendEquationAlpha, blendSrcAlpha, blendDstAlpha, blendColor, blendAlpha, premultipliedAlpha) {
        if (blending === $d5b33d7c30034067$export$63b8d6b580fc65ba) {
            if (currentBlendingEnabled === true) {
                disable(gl.BLEND);
                currentBlendingEnabled = false;
            }
            return;
        }
        if (currentBlendingEnabled === false) {
            enable(gl.BLEND);
            currentBlendingEnabled = true;
        }
        if (blending !== $d5b33d7c30034067$export$eda4864c68df1fa2) {
            if (blending !== currentBlending || premultipliedAlpha !== currentPremultipledAlpha) {
                if (currentBlendEquation !== $d5b33d7c30034067$export$20183a0484ce21a0 || currentBlendEquationAlpha !== $d5b33d7c30034067$export$20183a0484ce21a0) {
                    gl.blendEquation(gl.FUNC_ADD);
                    currentBlendEquation = $d5b33d7c30034067$export$20183a0484ce21a0;
                    currentBlendEquationAlpha = $d5b33d7c30034067$export$20183a0484ce21a0;
                }
                if (premultipliedAlpha) switch(blending){
                    case $d5b33d7c30034067$export$5b29a26d96ee6af0:
                        gl.blendFuncSeparate(gl.ONE, gl.ONE_MINUS_SRC_ALPHA, gl.ONE, gl.ONE_MINUS_SRC_ALPHA);
                        break;
                    case $d5b33d7c30034067$export$777d8f9551c2216b:
                        gl.blendFunc(gl.ONE, gl.ONE);
                        break;
                    case $d5b33d7c30034067$export$cdfa06f868e2e467:
                        gl.blendFuncSeparate(gl.ZERO, gl.ONE_MINUS_SRC_COLOR, gl.ZERO, gl.ONE);
                        break;
                    case $d5b33d7c30034067$export$4138e1c684b46a20:
                        gl.blendFuncSeparate(gl.ZERO, gl.SRC_COLOR, gl.ZERO, gl.SRC_ALPHA);
                        break;
                    default:
                        console.error('THREE.WebGLState: Invalid blending: ', blending);
                        break;
                }
                else switch(blending){
                    case $d5b33d7c30034067$export$5b29a26d96ee6af0:
                        gl.blendFuncSeparate(gl.SRC_ALPHA, gl.ONE_MINUS_SRC_ALPHA, gl.ONE, gl.ONE_MINUS_SRC_ALPHA);
                        break;
                    case $d5b33d7c30034067$export$777d8f9551c2216b:
                        gl.blendFunc(gl.SRC_ALPHA, gl.ONE);
                        break;
                    case $d5b33d7c30034067$export$cdfa06f868e2e467:
                        gl.blendFuncSeparate(gl.ZERO, gl.ONE_MINUS_SRC_COLOR, gl.ZERO, gl.ONE);
                        break;
                    case $d5b33d7c30034067$export$4138e1c684b46a20:
                        gl.blendFunc(gl.ZERO, gl.SRC_COLOR);
                        break;
                    default:
                        console.error('THREE.WebGLState: Invalid blending: ', blending);
                        break;
                }
                currentBlendSrc = null;
                currentBlendDst = null;
                currentBlendSrcAlpha = null;
                currentBlendDstAlpha = null;
                currentBlendColor.set(0, 0, 0);
                currentBlendAlpha = 0;
                currentBlending = blending;
                currentPremultipledAlpha = premultipliedAlpha;
            }
            return;
        }
        // custom blending
        blendEquationAlpha = blendEquationAlpha || blendEquation;
        blendSrcAlpha = blendSrcAlpha || blendSrc;
        blendDstAlpha = blendDstAlpha || blendDst;
        if (blendEquation !== currentBlendEquation || blendEquationAlpha !== currentBlendEquationAlpha) {
            gl.blendEquationSeparate(equationToGL[blendEquation], equationToGL[blendEquationAlpha]);
            currentBlendEquation = blendEquation;
            currentBlendEquationAlpha = blendEquationAlpha;
        }
        if (blendSrc !== currentBlendSrc || blendDst !== currentBlendDst || blendSrcAlpha !== currentBlendSrcAlpha || blendDstAlpha !== currentBlendDstAlpha) {
            gl.blendFuncSeparate(factorToGL[blendSrc], factorToGL[blendDst], factorToGL[blendSrcAlpha], factorToGL[blendDstAlpha]);
            currentBlendSrc = blendSrc;
            currentBlendDst = blendDst;
            currentBlendSrcAlpha = blendSrcAlpha;
            currentBlendDstAlpha = blendDstAlpha;
        }
        if (blendColor.equals(currentBlendColor) === false || blendAlpha !== currentBlendAlpha) {
            gl.blendColor(blendColor.r, blendColor.g, blendColor.b, blendAlpha);
            currentBlendColor.copy(blendColor);
            currentBlendAlpha = blendAlpha;
        }
        currentBlending = blending;
        currentPremultipledAlpha = false;
    }
    function setMaterial(material, frontFaceCW) {
        material.side === $d5b33d7c30034067$export$3b296b6f144d5b03 ? disable(gl.CULL_FACE) : enable(gl.CULL_FACE);
        let flipSided = material.side === $d5b33d7c30034067$export$d9f0486e75b5ace;
        if (frontFaceCW) flipSided = !flipSided;
        setFlipSided(flipSided);
        material.blending === $d5b33d7c30034067$export$5b29a26d96ee6af0 && material.transparent === false ? setBlending($d5b33d7c30034067$export$63b8d6b580fc65ba) : setBlending(material.blending, material.blendEquation, material.blendSrc, material.blendDst, material.blendEquationAlpha, material.blendSrcAlpha, material.blendDstAlpha, material.blendColor, material.blendAlpha, material.premultipliedAlpha);
        depthBuffer.setFunc(material.depthFunc);
        depthBuffer.setTest(material.depthTest);
        depthBuffer.setMask(material.depthWrite);
        colorBuffer.setMask(material.colorWrite);
        const stencilWrite = material.stencilWrite;
        stencilBuffer.setTest(stencilWrite);
        if (stencilWrite) {
            stencilBuffer.setMask(material.stencilWriteMask);
            stencilBuffer.setFunc(material.stencilFunc, material.stencilRef, material.stencilFuncMask);
            stencilBuffer.setOp(material.stencilFail, material.stencilZFail, material.stencilZPass);
        }
        setPolygonOffset(material.polygonOffset, material.polygonOffsetFactor, material.polygonOffsetUnits);
        material.alphaToCoverage === true ? enable(gl.SAMPLE_ALPHA_TO_COVERAGE) : disable(gl.SAMPLE_ALPHA_TO_COVERAGE);
    }
    //
    function setFlipSided(flipSided) {
        if (currentFlipSided !== flipSided) {
            if (flipSided) gl.frontFace(gl.CW);
            else gl.frontFace(gl.CCW);
            currentFlipSided = flipSided;
        }
    }
    function setCullFace(cullFace) {
        if (cullFace !== $d5b33d7c30034067$export$3237e1f2c1ea1f44) {
            enable(gl.CULL_FACE);
            if (cullFace !== currentCullFace) {
                if (cullFace === $d5b33d7c30034067$export$b9a7b4fc5cb15f9b) gl.cullFace(gl.BACK);
                else if (cullFace === $d5b33d7c30034067$export$b8058bcc7037d3f3) gl.cullFace(gl.FRONT);
                else gl.cullFace(gl.FRONT_AND_BACK);
            }
        } else disable(gl.CULL_FACE);
        currentCullFace = cullFace;
    }
    function setLineWidth(width) {
        if (width !== currentLineWidth) {
            if (lineWidthAvailable) gl.lineWidth(width);
            currentLineWidth = width;
        }
    }
    function setPolygonOffset(polygonOffset, factor, units) {
        if (polygonOffset) {
            enable(gl.POLYGON_OFFSET_FILL);
            if (currentPolygonOffsetFactor !== factor || currentPolygonOffsetUnits !== units) {
                gl.polygonOffset(factor, units);
                currentPolygonOffsetFactor = factor;
                currentPolygonOffsetUnits = units;
            }
        } else disable(gl.POLYGON_OFFSET_FILL);
    }
    function setScissorTest(scissorTest) {
        if (scissorTest) enable(gl.SCISSOR_TEST);
        else disable(gl.SCISSOR_TEST);
    }
    // texture
    function activeTexture(webglSlot) {
        if (webglSlot === undefined) webglSlot = gl.TEXTURE0 + maxTextures - 1;
        if (currentTextureSlot !== webglSlot) {
            gl.activeTexture(webglSlot);
            currentTextureSlot = webglSlot;
        }
    }
    function bindTexture(webglType, webglTexture, webglSlot) {
        if (webglSlot === undefined) {
            if (currentTextureSlot === null) webglSlot = gl.TEXTURE0 + maxTextures - 1;
            else webglSlot = currentTextureSlot;
        }
        let boundTexture = currentBoundTextures[webglSlot];
        if (boundTexture === undefined) {
            boundTexture = {
                type: undefined,
                texture: undefined
            };
            currentBoundTextures[webglSlot] = boundTexture;
        }
        if (boundTexture.type !== webglType || boundTexture.texture !== webglTexture) {
            if (currentTextureSlot !== webglSlot) {
                gl.activeTexture(webglSlot);
                currentTextureSlot = webglSlot;
            }
            gl.bindTexture(webglType, webglTexture || emptyTextures[webglType]);
            boundTexture.type = webglType;
            boundTexture.texture = webglTexture;
        }
    }
    function unbindTexture() {
        const boundTexture = currentBoundTextures[currentTextureSlot];
        if (boundTexture !== undefined && boundTexture.type !== undefined) {
            gl.bindTexture(boundTexture.type, null);
            boundTexture.type = undefined;
            boundTexture.texture = undefined;
        }
    }
    function compressedTexImage2D() {
        try {
            gl.compressedTexImage2D.apply(gl, arguments);
        } catch (error) {
            console.error('THREE.WebGLState:', error);
        }
    }
    function compressedTexImage3D() {
        try {
            gl.compressedTexImage3D.apply(gl, arguments);
        } catch (error) {
            console.error('THREE.WebGLState:', error);
        }
    }
    function texSubImage2D() {
        try {
            gl.texSubImage2D.apply(gl, arguments);
        } catch (error) {
            console.error('THREE.WebGLState:', error);
        }
    }
    function texSubImage3D() {
        try {
            gl.texSubImage3D.apply(gl, arguments);
        } catch (error) {
            console.error('THREE.WebGLState:', error);
        }
    }
    function compressedTexSubImage2D() {
        try {
            gl.compressedTexSubImage2D.apply(gl, arguments);
        } catch (error) {
            console.error('THREE.WebGLState:', error);
        }
    }
    function compressedTexSubImage3D() {
        try {
            gl.compressedTexSubImage3D.apply(gl, arguments);
        } catch (error) {
            console.error('THREE.WebGLState:', error);
        }
    }
    function texStorage2D() {
        try {
            gl.texStorage2D.apply(gl, arguments);
        } catch (error) {
            console.error('THREE.WebGLState:', error);
        }
    }
    function texStorage3D() {
        try {
            gl.texStorage3D.apply(gl, arguments);
        } catch (error) {
            console.error('THREE.WebGLState:', error);
        }
    }
    function texImage2D() {
        try {
            gl.texImage2D.apply(gl, arguments);
        } catch (error) {
            console.error('THREE.WebGLState:', error);
        }
    }
    function texImage3D() {
        try {
            gl.texImage3D.apply(gl, arguments);
        } catch (error) {
            console.error('THREE.WebGLState:', error);
        }
    }
    //
    function scissor(scissor) {
        if (currentScissor.equals(scissor) === false) {
            gl.scissor(scissor.x, scissor.y, scissor.z, scissor.w);
            currentScissor.copy(scissor);
        }
    }
    function viewport(viewport) {
        if (currentViewport.equals(viewport) === false) {
            gl.viewport(viewport.x, viewport.y, viewport.z, viewport.w);
            currentViewport.copy(viewport);
        }
    }
    function updateUBOMapping(uniformsGroup, program) {
        let mapping = uboProgramMap.get(program);
        if (mapping === undefined) {
            mapping = new WeakMap();
            uboProgramMap.set(program, mapping);
        }
        let blockIndex = mapping.get(uniformsGroup);
        if (blockIndex === undefined) {
            blockIndex = gl.getUniformBlockIndex(program, uniformsGroup.name);
            mapping.set(uniformsGroup, blockIndex);
        }
    }
    function uniformBlockBinding(uniformsGroup, program) {
        const mapping = uboProgramMap.get(program);
        const blockIndex = mapping.get(uniformsGroup);
        if (uboBindings.get(program) !== blockIndex) {
            // bind shader specific block index to global block point
            gl.uniformBlockBinding(program, blockIndex, uniformsGroup.__bindingPointIndex);
            uboBindings.set(program, blockIndex);
        }
    }
    //
    function reset() {
        // reset state
        gl.disable(gl.BLEND);
        gl.disable(gl.CULL_FACE);
        gl.disable(gl.DEPTH_TEST);
        gl.disable(gl.POLYGON_OFFSET_FILL);
        gl.disable(gl.SCISSOR_TEST);
        gl.disable(gl.STENCIL_TEST);
        gl.disable(gl.SAMPLE_ALPHA_TO_COVERAGE);
        gl.blendEquation(gl.FUNC_ADD);
        gl.blendFunc(gl.ONE, gl.ZERO);
        gl.blendFuncSeparate(gl.ONE, gl.ZERO, gl.ONE, gl.ZERO);
        gl.blendColor(0, 0, 0, 0);
        gl.colorMask(true, true, true, true);
        gl.clearColor(0, 0, 0, 0);
        gl.depthMask(true);
        gl.depthFunc(gl.LESS);
        depthBuffer.setReversed(false);
        gl.clearDepth(1);
        gl.stencilMask(0xffffffff);
        gl.stencilFunc(gl.ALWAYS, 0, 0xffffffff);
        gl.stencilOp(gl.KEEP, gl.KEEP, gl.KEEP);
        gl.clearStencil(0);
        gl.cullFace(gl.BACK);
        gl.frontFace(gl.CCW);
        gl.polygonOffset(0, 0);
        gl.activeTexture(gl.TEXTURE0);
        gl.bindFramebuffer(gl.FRAMEBUFFER, null);
        gl.bindFramebuffer(gl.DRAW_FRAMEBUFFER, null);
        gl.bindFramebuffer(gl.READ_FRAMEBUFFER, null);
        gl.useProgram(null);
        gl.lineWidth(1);
        gl.scissor(0, 0, gl.canvas.width, gl.canvas.height);
        gl.viewport(0, 0, gl.canvas.width, gl.canvas.height);
        // reset internals
        enabledCapabilities = {};
        currentTextureSlot = null;
        currentBoundTextures = {};
        currentBoundFramebuffers = {};
        currentDrawbuffers = new WeakMap();
        defaultDrawbuffers = [];
        currentProgram = null;
        currentBlendingEnabled = false;
        currentBlending = null;
        currentBlendEquation = null;
        currentBlendSrc = null;
        currentBlendDst = null;
        currentBlendEquationAlpha = null;
        currentBlendSrcAlpha = null;
        currentBlendDstAlpha = null;
        currentBlendColor = new $d5b33d7c30034067$export$892596cec99bc70e(0, 0, 0);
        currentBlendAlpha = 0;
        currentPremultipledAlpha = false;
        currentFlipSided = null;
        currentCullFace = null;
        currentLineWidth = null;
        currentPolygonOffsetFactor = null;
        currentPolygonOffsetUnits = null;
        currentScissor.set(0, 0, gl.canvas.width, gl.canvas.height);
        currentViewport.set(0, 0, gl.canvas.width, gl.canvas.height);
        colorBuffer.reset();
        depthBuffer.reset();
        stencilBuffer.reset();
    }
    return {
        buffers: {
            color: colorBuffer,
            depth: depthBuffer,
            stencil: stencilBuffer
        },
        enable: enable,
        disable: disable,
        bindFramebuffer: bindFramebuffer,
        drawBuffers: drawBuffers,
        useProgram: useProgram,
        setBlending: setBlending,
        setMaterial: setMaterial,
        setFlipSided: setFlipSided,
        setCullFace: setCullFace,
        setLineWidth: setLineWidth,
        setPolygonOffset: setPolygonOffset,
        setScissorTest: setScissorTest,
        activeTexture: activeTexture,
        bindTexture: bindTexture,
        unbindTexture: unbindTexture,
        compressedTexImage2D: compressedTexImage2D,
        compressedTexImage3D: compressedTexImage3D,
        texImage2D: texImage2D,
        texImage3D: texImage3D,
        updateUBOMapping: updateUBOMapping,
        uniformBlockBinding: uniformBlockBinding,
        texStorage2D: texStorage2D,
        texStorage3D: texStorage3D,
        texSubImage2D: texSubImage2D,
        texSubImage3D: texSubImage3D,
        compressedTexSubImage2D: compressedTexSubImage2D,
        compressedTexSubImage3D: compressedTexSubImage3D,
        scissor: scissor,
        viewport: viewport,
        reset: reset
    };
}
function $d5b33d7c30034067$var$contain(texture, aspect) {
    const imageAspect = texture.image && texture.image.width ? texture.image.width / texture.image.height : 1;
    if (imageAspect > aspect) {
        texture.repeat.x = 1;
        texture.repeat.y = imageAspect / aspect;
        texture.offset.x = 0;
        texture.offset.y = (1 - texture.repeat.y) / 2;
    } else {
        texture.repeat.x = aspect / imageAspect;
        texture.repeat.y = 1;
        texture.offset.x = (1 - texture.repeat.x) / 2;
        texture.offset.y = 0;
    }
    return texture;
}
function $d5b33d7c30034067$var$cover(texture, aspect) {
    const imageAspect = texture.image && texture.image.width ? texture.image.width / texture.image.height : 1;
    if (imageAspect > aspect) {
        texture.repeat.x = aspect / imageAspect;
        texture.repeat.y = 1;
        texture.offset.x = (1 - texture.repeat.x) / 2;
        texture.offset.y = 0;
    } else {
        texture.repeat.x = 1;
        texture.repeat.y = imageAspect / aspect;
        texture.offset.x = 0;
        texture.offset.y = (1 - texture.repeat.y) / 2;
    }
    return texture;
}
function $d5b33d7c30034067$var$fill(texture) {
    texture.repeat.x = 1;
    texture.repeat.y = 1;
    texture.offset.x = 0;
    texture.offset.y = 0;
    return texture;
}
/**
 * Given the width, height, format, and type of a texture. Determines how many
 * bytes must be used to represent the texture.
 */ function $d5b33d7c30034067$var$getByteLength(width, height, format, type) {
    const typeByteLength = $d5b33d7c30034067$var$getTextureTypeByteLength(type);
    switch(format){
        // https://registry.khronos.org/OpenGL-Refpages/es3.0/html/glTexImage2D.xhtml
        case $d5b33d7c30034067$export$988473390501ed4b:
            return width * height;
        case $d5b33d7c30034067$export$cc09ccbf6d1ed449:
            return width * height;
        case $d5b33d7c30034067$export$9053a81c4a69c289:
            return width * height * 2;
        case $d5b33d7c30034067$export$4e041a7967d15c4b:
            return width * height / typeByteLength.components * typeByteLength.byteLength;
        case $d5b33d7c30034067$export$aa92e870a709d190:
            return width * height / typeByteLength.components * typeByteLength.byteLength;
        case $d5b33d7c30034067$export$6cdf0b461c7ce8a0:
            return width * height * 2 / typeByteLength.components * typeByteLength.byteLength;
        case $d5b33d7c30034067$export$1ba1c45f9f77d4d7:
            return width * height * 2 / typeByteLength.components * typeByteLength.byteLength;
        case $d5b33d7c30034067$export$7c67423a5ee6f5eb:
            return width * height * 3 / typeByteLength.components * typeByteLength.byteLength;
        case $d5b33d7c30034067$export$3f8bb04b555a363c:
            return width * height * 4 / typeByteLength.components * typeByteLength.byteLength;
        case $d5b33d7c30034067$export$c200e7d26f592f21:
            return width * height * 4 / typeByteLength.components * typeByteLength.byteLength;
        // https://registry.khronos.org/webgl/extensions/WEBGL_compressed_texture_s3tc_srgb/
        case $d5b33d7c30034067$export$21d1799c6d552fc0:
        case $d5b33d7c30034067$export$afa304c3e981b668:
            return Math.floor((width + 3) / 4) * Math.floor((height + 3) / 4) * 8;
        case $d5b33d7c30034067$export$d2a1a68024a3e56c:
        case $d5b33d7c30034067$export$9a79c424327dacf9:
            return Math.floor((width + 3) / 4) * Math.floor((height + 3) / 4) * 16;
        // https://registry.khronos.org/webgl/extensions/WEBGL_compressed_texture_pvrtc/
        case $d5b33d7c30034067$export$d0f0355bb3d948e4:
        case $d5b33d7c30034067$export$b71692456c47b6c3:
            return Math.max(width, 16) * Math.max(height, 8) / 4;
        case $d5b33d7c30034067$export$19ada9bbb1af3573:
        case $d5b33d7c30034067$export$b82296714358084c:
            return Math.max(width, 8) * Math.max(height, 8) / 2;
        // https://registry.khronos.org/webgl/extensions/WEBGL_compressed_texture_etc/
        case $d5b33d7c30034067$export$6ab91af2d757aee7:
        case $d5b33d7c30034067$export$7800993ef8106a6a:
            return Math.floor((width + 3) / 4) * Math.floor((height + 3) / 4) * 8;
        case $d5b33d7c30034067$export$23ed8300a860e7d8:
            return Math.floor((width + 3) / 4) * Math.floor((height + 3) / 4) * 16;
        // https://registry.khronos.org/webgl/extensions/WEBGL_compressed_texture_astc/
        case $d5b33d7c30034067$export$dc5570b4a2b92d48:
            return Math.floor((width + 3) / 4) * Math.floor((height + 3) / 4) * 16;
        case $d5b33d7c30034067$export$68880cd325f8b2fb:
            return Math.floor((width + 4) / 5) * Math.floor((height + 3) / 4) * 16;
        case $d5b33d7c30034067$export$7d2c0be323373d95:
            return Math.floor((width + 4) / 5) * Math.floor((height + 4) / 5) * 16;
        case $d5b33d7c30034067$export$22b52da301fc3a3e:
            return Math.floor((width + 5) / 6) * Math.floor((height + 4) / 5) * 16;
        case $d5b33d7c30034067$export$c009e2cb4a66485e:
            return Math.floor((width + 5) / 6) * Math.floor((height + 5) / 6) * 16;
        case $d5b33d7c30034067$export$118fff5afa255b63:
            return Math.floor((width + 7) / 8) * Math.floor((height + 4) / 5) * 16;
        case $d5b33d7c30034067$export$120713c829ae0667:
            return Math.floor((width + 7) / 8) * Math.floor((height + 5) / 6) * 16;
        case $d5b33d7c30034067$export$c79eeabbf53313e9:
            return Math.floor((width + 7) / 8) * Math.floor((height + 7) / 8) * 16;
        case $d5b33d7c30034067$export$443cf6567cdd6424:
            return Math.floor((width + 9) / 10) * Math.floor((height + 4) / 5) * 16;
        case $d5b33d7c30034067$export$6573984fc9840780:
            return Math.floor((width + 9) / 10) * Math.floor((height + 5) / 6) * 16;
        case $d5b33d7c30034067$export$e7aee563f30091de:
            return Math.floor((width + 9) / 10) * Math.floor((height + 7) / 8) * 16;
        case $d5b33d7c30034067$export$2eb8634622ddeab7:
            return Math.floor((width + 9) / 10) * Math.floor((height + 9) / 10) * 16;
        case $d5b33d7c30034067$export$202b1ce7b5d25742:
            return Math.floor((width + 11) / 12) * Math.floor((height + 9) / 10) * 16;
        case $d5b33d7c30034067$export$18ab77abd087e467:
            return Math.floor((width + 11) / 12) * Math.floor((height + 11) / 12) * 16;
        // https://registry.khronos.org/webgl/extensions/EXT_texture_compression_bptc/
        case $d5b33d7c30034067$export$ce40b115e188bc81:
        case $d5b33d7c30034067$export$d279c5c4bac5121e:
        case $d5b33d7c30034067$export$cde52d17225fdbd3:
            return Math.ceil(width / 4) * Math.ceil(height / 4) * 16;
        // https://registry.khronos.org/webgl/extensions/EXT_texture_compression_rgtc/
        case $d5b33d7c30034067$export$b1688df4c4c21670:
        case $d5b33d7c30034067$export$fc15e5d8261eed58:
            return Math.ceil(width / 4) * Math.ceil(height / 4) * 8;
        case $d5b33d7c30034067$export$d220f6ade8463a0f:
        case $d5b33d7c30034067$export$768646d09dc1b6ef:
            return Math.ceil(width / 4) * Math.ceil(height / 4) * 16;
    }
    throw new Error(`Unable to determine texture byte length for ${format} format.`);
}
function $d5b33d7c30034067$var$getTextureTypeByteLength(type) {
    switch(type){
        case $d5b33d7c30034067$export$2e8ce08d3f6f5e10:
        case $d5b33d7c30034067$export$545fce0311a9796a:
            return {
                byteLength: 1,
                components: 1
            };
        case $d5b33d7c30034067$export$c63dc51868b06a9d:
        case $d5b33d7c30034067$export$88572337f312435f:
        case $d5b33d7c30034067$export$2697304443f382bc:
            return {
                byteLength: 2,
                components: 1
            };
        case $d5b33d7c30034067$export$b3969b01faf587f2:
        case $d5b33d7c30034067$export$18886f8ae33e90de:
            return {
                byteLength: 2,
                components: 4
            };
        case $d5b33d7c30034067$export$c3c7fc4518ebba96:
        case $d5b33d7c30034067$export$5c612977753abe2:
        case $d5b33d7c30034067$export$f6d331659b644596:
            return {
                byteLength: 4,
                components: 1
            };
        case $d5b33d7c30034067$export$5a4c329b7e2092d3:
            return {
                byteLength: 4,
                components: 3
            };
    }
    throw new Error(`Unknown texture type ${type}.`);
}
const $d5b33d7c30034067$export$ec276d39f33d4b7 = {
    contain: $d5b33d7c30034067$var$contain,
    cover: $d5b33d7c30034067$var$cover,
    fill: $d5b33d7c30034067$var$fill,
    getByteLength: $d5b33d7c30034067$var$getByteLength
};
function $d5b33d7c30034067$var$WebGLTextures(_gl, extensions, state, properties, capabilities, utils, info) {
    const multisampledRTTExt = extensions.has('WEBGL_multisampled_render_to_texture') ? extensions.get('WEBGL_multisampled_render_to_texture') : null;
    const supportsInvalidateFramebuffer = typeof navigator === 'undefined' ? false : /OculusBrowser/g.test(navigator.userAgent);
    const _imageDimensions = new $d5b33d7c30034067$export$c977b3e384af9ae1();
    const _videoTextures = new WeakMap();
    let _canvas;
    const _sources = new WeakMap(); // maps WebglTexture objects to instances of Source
    // cordova iOS (as of 5.0) still uses UIWebView, which provides OffscreenCanvas,
    // also OffscreenCanvas.getContext("webgl"), but not OffscreenCanvas.getContext("2d")!
    // Some implementations may only implement OffscreenCanvas partially (e.g. lacking 2d).
    let useOffscreenCanvas = false;
    try {
        useOffscreenCanvas = typeof OffscreenCanvas !== 'undefined' && new OffscreenCanvas(1, 1).getContext('2d') !== null;
    } catch (err) {
    // Ignore any errors
    }
    function createCanvas(width, height) {
        // Use OffscreenCanvas when available. Specially needed in web workers
        return useOffscreenCanvas ? // eslint-disable-next-line compat/compat
        new OffscreenCanvas(width, height) : $d5b33d7c30034067$var$createElementNS('canvas');
    }
    function resizeImage(image, needsNewCanvas, maxSize) {
        let scale = 1;
        const dimensions = getDimensions(image);
        // handle case if texture exceeds max size
        if (dimensions.width > maxSize || dimensions.height > maxSize) scale = maxSize / Math.max(dimensions.width, dimensions.height);
        // only perform resize if necessary
        if (scale < 1) {
            // only perform resize for certain image types
            if (typeof HTMLImageElement !== 'undefined' && image instanceof HTMLImageElement || typeof HTMLCanvasElement !== 'undefined' && image instanceof HTMLCanvasElement || typeof ImageBitmap !== 'undefined' && image instanceof ImageBitmap || typeof VideoFrame !== 'undefined' && image instanceof VideoFrame) {
                const width = Math.floor(scale * dimensions.width);
                const height = Math.floor(scale * dimensions.height);
                if (_canvas === undefined) _canvas = createCanvas(width, height);
                // cube textures can't reuse the same canvas
                const canvas = needsNewCanvas ? createCanvas(width, height) : _canvas;
                canvas.width = width;
                canvas.height = height;
                const context = canvas.getContext('2d');
                context.drawImage(image, 0, 0, width, height);
                console.warn('THREE.WebGLRenderer: Texture has been resized from (' + dimensions.width + 'x' + dimensions.height + ') to (' + width + 'x' + height + ').');
                return canvas;
            } else {
                if ('data' in image) console.warn('THREE.WebGLRenderer: Image in DataTexture is too big (' + dimensions.width + 'x' + dimensions.height + ').');
                return image;
            }
        }
        return image;
    }
    function textureNeedsGenerateMipmaps(texture) {
        return texture.generateMipmaps;
    }
    function generateMipmap(target) {
        _gl.generateMipmap(target);
    }
    function getTargetType(texture) {
        if (texture.isWebGLCubeRenderTarget) return _gl.TEXTURE_CUBE_MAP;
        if (texture.isWebGL3DRenderTarget) return _gl.TEXTURE_3D;
        if (texture.isWebGLArrayRenderTarget || texture.isCompressedArrayTexture) return _gl.TEXTURE_2D_ARRAY;
        return _gl.TEXTURE_2D;
    }
    function getInternalFormat(internalFormatName, glFormat, glType, colorSpace, forceLinearTransfer = false) {
        if (internalFormatName !== null) {
            if (_gl[internalFormatName] !== undefined) return _gl[internalFormatName];
            console.warn('THREE.WebGLRenderer: Attempt to use non-existing WebGL internal format \'' + internalFormatName + '\'');
        }
        let internalFormat = glFormat;
        if (glFormat === _gl.RED) {
            if (glType === _gl.FLOAT) internalFormat = _gl.R32F;
            if (glType === _gl.HALF_FLOAT) internalFormat = _gl.R16F;
            if (glType === _gl.UNSIGNED_BYTE) internalFormat = _gl.R8;
        }
        if (glFormat === _gl.RED_INTEGER) {
            if (glType === _gl.UNSIGNED_BYTE) internalFormat = _gl.R8UI;
            if (glType === _gl.UNSIGNED_SHORT) internalFormat = _gl.R16UI;
            if (glType === _gl.UNSIGNED_INT) internalFormat = _gl.R32UI;
            if (glType === _gl.BYTE) internalFormat = _gl.R8I;
            if (glType === _gl.SHORT) internalFormat = _gl.R16I;
            if (glType === _gl.INT) internalFormat = _gl.R32I;
        }
        if (glFormat === _gl.RG) {
            if (glType === _gl.FLOAT) internalFormat = _gl.RG32F;
            if (glType === _gl.HALF_FLOAT) internalFormat = _gl.RG16F;
            if (glType === _gl.UNSIGNED_BYTE) internalFormat = _gl.RG8;
        }
        if (glFormat === _gl.RG_INTEGER) {
            if (glType === _gl.UNSIGNED_BYTE) internalFormat = _gl.RG8UI;
            if (glType === _gl.UNSIGNED_SHORT) internalFormat = _gl.RG16UI;
            if (glType === _gl.UNSIGNED_INT) internalFormat = _gl.RG32UI;
            if (glType === _gl.BYTE) internalFormat = _gl.RG8I;
            if (glType === _gl.SHORT) internalFormat = _gl.RG16I;
            if (glType === _gl.INT) internalFormat = _gl.RG32I;
        }
        if (glFormat === _gl.RGB_INTEGER) {
            if (glType === _gl.UNSIGNED_BYTE) internalFormat = _gl.RGB8UI;
            if (glType === _gl.UNSIGNED_SHORT) internalFormat = _gl.RGB16UI;
            if (glType === _gl.UNSIGNED_INT) internalFormat = _gl.RGB32UI;
            if (glType === _gl.BYTE) internalFormat = _gl.RGB8I;
            if (glType === _gl.SHORT) internalFormat = _gl.RGB16I;
            if (glType === _gl.INT) internalFormat = _gl.RGB32I;
        }
        if (glFormat === _gl.RGBA_INTEGER) {
            if (glType === _gl.UNSIGNED_BYTE) internalFormat = _gl.RGBA8UI;
            if (glType === _gl.UNSIGNED_SHORT) internalFormat = _gl.RGBA16UI;
            if (glType === _gl.UNSIGNED_INT) internalFormat = _gl.RGBA32UI;
            if (glType === _gl.BYTE) internalFormat = _gl.RGBA8I;
            if (glType === _gl.SHORT) internalFormat = _gl.RGBA16I;
            if (glType === _gl.INT) internalFormat = _gl.RGBA32I;
        }
        if (glFormat === _gl.RGB) {
            if (glType === _gl.UNSIGNED_INT_5_9_9_9_REV) internalFormat = _gl.RGB9_E5;
        }
        if (glFormat === _gl.RGBA) {
            const transfer = forceLinearTransfer ? $d5b33d7c30034067$export$f197347d588c1b4a : $d5b33d7c30034067$export$5e6fd513f44698c.getTransfer(colorSpace);
            if (glType === _gl.FLOAT) internalFormat = _gl.RGBA32F;
            if (glType === _gl.HALF_FLOAT) internalFormat = _gl.RGBA16F;
            if (glType === _gl.UNSIGNED_BYTE) internalFormat = transfer === $d5b33d7c30034067$export$8d0a61916cc26abb ? _gl.SRGB8_ALPHA8 : _gl.RGBA8;
            if (glType === _gl.UNSIGNED_SHORT_4_4_4_4) internalFormat = _gl.RGBA4;
            if (glType === _gl.UNSIGNED_SHORT_5_5_5_1) internalFormat = _gl.RGB5_A1;
        }
        if (internalFormat === _gl.R16F || internalFormat === _gl.R32F || internalFormat === _gl.RG16F || internalFormat === _gl.RG32F || internalFormat === _gl.RGBA16F || internalFormat === _gl.RGBA32F) extensions.get('EXT_color_buffer_float');
        return internalFormat;
    }
    function getInternalDepthFormat(useStencil, depthType) {
        let glInternalFormat;
        if (useStencil) {
            if (depthType === null || depthType === $d5b33d7c30034067$export$c3c7fc4518ebba96 || depthType === $d5b33d7c30034067$export$6c8ea339bfab1301) glInternalFormat = _gl.DEPTH24_STENCIL8;
            else if (depthType === $d5b33d7c30034067$export$f6d331659b644596) glInternalFormat = _gl.DEPTH32F_STENCIL8;
            else if (depthType === $d5b33d7c30034067$export$c63dc51868b06a9d) {
                glInternalFormat = _gl.DEPTH24_STENCIL8;
                console.warn('DepthTexture: 16 bit depth attachment is not supported with stencil. Using 24-bit attachment.');
            }
        } else {
            if (depthType === null || depthType === $d5b33d7c30034067$export$c3c7fc4518ebba96 || depthType === $d5b33d7c30034067$export$6c8ea339bfab1301) glInternalFormat = _gl.DEPTH_COMPONENT24;
            else if (depthType === $d5b33d7c30034067$export$f6d331659b644596) glInternalFormat = _gl.DEPTH_COMPONENT32F;
            else if (depthType === $d5b33d7c30034067$export$c63dc51868b06a9d) glInternalFormat = _gl.DEPTH_COMPONENT16;
        }
        return glInternalFormat;
    }
    function getMipLevels(texture, image) {
        if (textureNeedsGenerateMipmaps(texture) === true || texture.isFramebufferTexture && texture.minFilter !== $d5b33d7c30034067$export$727aa5ec3fe39bf0 && texture.minFilter !== $d5b33d7c30034067$export$8a72f490b25c56c8) return Math.log2(Math.max(image.width, image.height)) + 1;
        else if (texture.mipmaps !== undefined && texture.mipmaps.length > 0) // user-defined mipmaps
        return texture.mipmaps.length;
        else if (texture.isCompressedTexture && Array.isArray(texture.image)) return image.mipmaps.length;
        else // texture without mipmaps (only base level)
        return 1;
    }
    //
    function onTextureDispose(event) {
        const texture = event.target;
        texture.removeEventListener('dispose', onTextureDispose);
        deallocateTexture(texture);
        if (texture.isVideoTexture) _videoTextures.delete(texture);
    }
    function onRenderTargetDispose(event) {
        const renderTarget = event.target;
        renderTarget.removeEventListener('dispose', onRenderTargetDispose);
        deallocateRenderTarget(renderTarget);
    }
    //
    function deallocateTexture(texture) {
        const textureProperties = properties.get(texture);
        if (textureProperties.__webglInit === undefined) return;
        // check if it's necessary to remove the WebGLTexture object
        const source = texture.source;
        const webglTextures = _sources.get(source);
        if (webglTextures) {
            const webglTexture = webglTextures[textureProperties.__cacheKey];
            webglTexture.usedTimes--;
            // the WebGLTexture object is not used anymore, remove it
            if (webglTexture.usedTimes === 0) deleteTexture(texture);
            // remove the weak map entry if no WebGLTexture uses the source anymore
            if (Object.keys(webglTextures).length === 0) _sources.delete(source);
        }
        properties.remove(texture);
    }
    function deleteTexture(texture) {
        const textureProperties = properties.get(texture);
        _gl.deleteTexture(textureProperties.__webglTexture);
        const source = texture.source;
        const webglTextures = _sources.get(source);
        delete webglTextures[textureProperties.__cacheKey];
        info.memory.textures--;
    }
    function deallocateRenderTarget(renderTarget) {
        const renderTargetProperties = properties.get(renderTarget);
        if (renderTarget.depthTexture) {
            renderTarget.depthTexture.dispose();
            properties.remove(renderTarget.depthTexture);
        }
        if (renderTarget.isWebGLCubeRenderTarget) for(let i = 0; i < 6; i++){
            if (Array.isArray(renderTargetProperties.__webglFramebuffer[i])) for(let level = 0; level < renderTargetProperties.__webglFramebuffer[i].length; level++)_gl.deleteFramebuffer(renderTargetProperties.__webglFramebuffer[i][level]);
            else _gl.deleteFramebuffer(renderTargetProperties.__webglFramebuffer[i]);
            if (renderTargetProperties.__webglDepthbuffer) _gl.deleteRenderbuffer(renderTargetProperties.__webglDepthbuffer[i]);
        }
        else {
            if (Array.isArray(renderTargetProperties.__webglFramebuffer)) for(let level = 0; level < renderTargetProperties.__webglFramebuffer.length; level++)_gl.deleteFramebuffer(renderTargetProperties.__webglFramebuffer[level]);
            else _gl.deleteFramebuffer(renderTargetProperties.__webglFramebuffer);
            if (renderTargetProperties.__webglDepthbuffer) _gl.deleteRenderbuffer(renderTargetProperties.__webglDepthbuffer);
            if (renderTargetProperties.__webglMultisampledFramebuffer) _gl.deleteFramebuffer(renderTargetProperties.__webglMultisampledFramebuffer);
            if (renderTargetProperties.__webglColorRenderbuffer) {
                for(let i = 0; i < renderTargetProperties.__webglColorRenderbuffer.length; i++)if (renderTargetProperties.__webglColorRenderbuffer[i]) _gl.deleteRenderbuffer(renderTargetProperties.__webglColorRenderbuffer[i]);
            }
            if (renderTargetProperties.__webglDepthRenderbuffer) _gl.deleteRenderbuffer(renderTargetProperties.__webglDepthRenderbuffer);
        }
        const textures = renderTarget.textures;
        for(let i = 0, il = textures.length; i < il; i++){
            const attachmentProperties = properties.get(textures[i]);
            if (attachmentProperties.__webglTexture) {
                _gl.deleteTexture(attachmentProperties.__webglTexture);
                info.memory.textures--;
            }
            properties.remove(textures[i]);
        }
        properties.remove(renderTarget);
    }
    //
    let textureUnits = 0;
    function resetTextureUnits() {
        textureUnits = 0;
    }
    function allocateTextureUnit() {
        const textureUnit = textureUnits;
        if (textureUnit >= capabilities.maxTextures) console.warn('THREE.WebGLTextures: Trying to use ' + textureUnit + ' texture units while this GPU supports only ' + capabilities.maxTextures);
        textureUnits += 1;
        return textureUnit;
    }
    function getTextureCacheKey(texture) {
        const array = [];
        array.push(texture.wrapS);
        array.push(texture.wrapT);
        array.push(texture.wrapR || 0);
        array.push(texture.magFilter);
        array.push(texture.minFilter);
        array.push(texture.anisotropy);
        array.push(texture.internalFormat);
        array.push(texture.format);
        array.push(texture.type);
        array.push(texture.generateMipmaps);
        array.push(texture.premultiplyAlpha);
        array.push(texture.flipY);
        array.push(texture.unpackAlignment);
        array.push(texture.colorSpace);
        return array.join();
    }
    //
    function setTexture2D(texture, slot) {
        const textureProperties = properties.get(texture);
        if (texture.isVideoTexture) updateVideoTexture(texture);
        if (texture.isRenderTargetTexture === false && texture.version > 0 && textureProperties.__version !== texture.version) {
            const image = texture.image;
            if (image === null) console.warn('THREE.WebGLRenderer: Texture marked for update but no image data found.');
            else if (image.complete === false) console.warn('THREE.WebGLRenderer: Texture marked for update but image is incomplete');
            else {
                uploadTexture(textureProperties, texture, slot);
                return;
            }
        }
        state.bindTexture(_gl.TEXTURE_2D, textureProperties.__webglTexture, _gl.TEXTURE0 + slot);
    }
    function setTexture2DArray(texture, slot) {
        const textureProperties = properties.get(texture);
        if (texture.version > 0 && textureProperties.__version !== texture.version) {
            uploadTexture(textureProperties, texture, slot);
            return;
        }
        state.bindTexture(_gl.TEXTURE_2D_ARRAY, textureProperties.__webglTexture, _gl.TEXTURE0 + slot);
    }
    function setTexture3D(texture, slot) {
        const textureProperties = properties.get(texture);
        if (texture.version > 0 && textureProperties.__version !== texture.version) {
            uploadTexture(textureProperties, texture, slot);
            return;
        }
        state.bindTexture(_gl.TEXTURE_3D, textureProperties.__webglTexture, _gl.TEXTURE0 + slot);
    }
    function setTextureCube(texture, slot) {
        const textureProperties = properties.get(texture);
        if (texture.version > 0 && textureProperties.__version !== texture.version) {
            uploadCubeTexture(textureProperties, texture, slot);
            return;
        }
        state.bindTexture(_gl.TEXTURE_CUBE_MAP, textureProperties.__webglTexture, _gl.TEXTURE0 + slot);
    }
    const wrappingToGL = {
        [$d5b33d7c30034067$export$533346c8e8dac0f5]: _gl.REPEAT,
        [$d5b33d7c30034067$export$9d9334239a5a5e06]: _gl.CLAMP_TO_EDGE,
        [$d5b33d7c30034067$export$c7e7c00b14f51a4f]: _gl.MIRRORED_REPEAT
    };
    const filterToGL = {
        [$d5b33d7c30034067$export$727aa5ec3fe39bf0]: _gl.NEAREST,
        [$d5b33d7c30034067$export$d129e38cf6feaa8c]: _gl.NEAREST_MIPMAP_NEAREST,
        [$d5b33d7c30034067$export$d2327c1afe5bfdf2]: _gl.NEAREST_MIPMAP_LINEAR,
        [$d5b33d7c30034067$export$8a72f490b25c56c8]: _gl.LINEAR,
        [$d5b33d7c30034067$export$19a719f377145a13]: _gl.LINEAR_MIPMAP_NEAREST,
        [$d5b33d7c30034067$export$5d8599b6a933fb1b]: _gl.LINEAR_MIPMAP_LINEAR
    };
    const compareToGL = {
        [$d5b33d7c30034067$export$d9e2d19a747baaab]: _gl.NEVER,
        [$d5b33d7c30034067$export$187b73a3e352c145]: _gl.ALWAYS,
        [$d5b33d7c30034067$export$36bcf49c713b3eb7]: _gl.LESS,
        [$d5b33d7c30034067$export$64eea11eb407ddf1]: _gl.LEQUAL,
        [$d5b33d7c30034067$export$66f28d946fc6a0d5]: _gl.EQUAL,
        [$d5b33d7c30034067$export$1cdcb70d53d65f61]: _gl.GEQUAL,
        [$d5b33d7c30034067$export$155af022118f3a38]: _gl.GREATER,
        [$d5b33d7c30034067$export$67ab95dde6bed156]: _gl.NOTEQUAL
    };
    function setTextureParameters(textureType, texture) {
        if (texture.type === $d5b33d7c30034067$export$f6d331659b644596 && extensions.has('OES_texture_float_linear') === false && (texture.magFilter === $d5b33d7c30034067$export$8a72f490b25c56c8 || texture.magFilter === $d5b33d7c30034067$export$19a719f377145a13 || texture.magFilter === $d5b33d7c30034067$export$d2327c1afe5bfdf2 || texture.magFilter === $d5b33d7c30034067$export$5d8599b6a933fb1b || texture.minFilter === $d5b33d7c30034067$export$8a72f490b25c56c8 || texture.minFilter === $d5b33d7c30034067$export$19a719f377145a13 || texture.minFilter === $d5b33d7c30034067$export$d2327c1afe5bfdf2 || texture.minFilter === $d5b33d7c30034067$export$5d8599b6a933fb1b)) console.warn('THREE.WebGLRenderer: Unable to use linear filtering with floating point textures. OES_texture_float_linear not supported on this device.');
        _gl.texParameteri(textureType, _gl.TEXTURE_WRAP_S, wrappingToGL[texture.wrapS]);
        _gl.texParameteri(textureType, _gl.TEXTURE_WRAP_T, wrappingToGL[texture.wrapT]);
        if (textureType === _gl.TEXTURE_3D || textureType === _gl.TEXTURE_2D_ARRAY) _gl.texParameteri(textureType, _gl.TEXTURE_WRAP_R, wrappingToGL[texture.wrapR]);
        _gl.texParameteri(textureType, _gl.TEXTURE_MAG_FILTER, filterToGL[texture.magFilter]);
        _gl.texParameteri(textureType, _gl.TEXTURE_MIN_FILTER, filterToGL[texture.minFilter]);
        if (texture.compareFunction) {
            _gl.texParameteri(textureType, _gl.TEXTURE_COMPARE_MODE, _gl.COMPARE_REF_TO_TEXTURE);
            _gl.texParameteri(textureType, _gl.TEXTURE_COMPARE_FUNC, compareToGL[texture.compareFunction]);
        }
        if (extensions.has('EXT_texture_filter_anisotropic') === true) {
            if (texture.magFilter === $d5b33d7c30034067$export$727aa5ec3fe39bf0) return;
            if (texture.minFilter !== $d5b33d7c30034067$export$d2327c1afe5bfdf2 && texture.minFilter !== $d5b33d7c30034067$export$5d8599b6a933fb1b) return;
            if (texture.type === $d5b33d7c30034067$export$f6d331659b644596 && extensions.has('OES_texture_float_linear') === false) return; // verify extension
            if (texture.anisotropy > 1 || properties.get(texture).__currentAnisotropy) {
                const extension = extensions.get('EXT_texture_filter_anisotropic');
                _gl.texParameterf(textureType, extension.TEXTURE_MAX_ANISOTROPY_EXT, Math.min(texture.anisotropy, capabilities.getMaxAnisotropy()));
                properties.get(texture).__currentAnisotropy = texture.anisotropy;
            }
        }
    }
    function initTexture(textureProperties, texture) {
        let forceUpload = false;
        if (textureProperties.__webglInit === undefined) {
            textureProperties.__webglInit = true;
            texture.addEventListener('dispose', onTextureDispose);
        }
        // create Source <-> WebGLTextures mapping if necessary
        const source = texture.source;
        let webglTextures = _sources.get(source);
        if (webglTextures === undefined) {
            webglTextures = {};
            _sources.set(source, webglTextures);
        }
        // check if there is already a WebGLTexture object for the given texture parameters
        const textureCacheKey = getTextureCacheKey(texture);
        if (textureCacheKey !== textureProperties.__cacheKey) {
            // if not, create a new instance of WebGLTexture
            if (webglTextures[textureCacheKey] === undefined) {
                // create new entry
                webglTextures[textureCacheKey] = {
                    texture: _gl.createTexture(),
                    usedTimes: 0
                };
                info.memory.textures++;
                // when a new instance of WebGLTexture was created, a texture upload is required
                // even if the image contents are identical
                forceUpload = true;
            }
            webglTextures[textureCacheKey].usedTimes++;
            // every time the texture cache key changes, it's necessary to check if an instance of
            // WebGLTexture can be deleted in order to avoid a memory leak.
            const webglTexture = webglTextures[textureProperties.__cacheKey];
            if (webglTexture !== undefined) {
                webglTextures[textureProperties.__cacheKey].usedTimes--;
                if (webglTexture.usedTimes === 0) deleteTexture(texture);
            }
            // store references to cache key and WebGLTexture object
            textureProperties.__cacheKey = textureCacheKey;
            textureProperties.__webglTexture = webglTextures[textureCacheKey].texture;
        }
        return forceUpload;
    }
    function uploadTexture(textureProperties, texture, slot) {
        let textureType = _gl.TEXTURE_2D;
        if (texture.isDataArrayTexture || texture.isCompressedArrayTexture) textureType = _gl.TEXTURE_2D_ARRAY;
        if (texture.isData3DTexture) textureType = _gl.TEXTURE_3D;
        const forceUpload = initTexture(textureProperties, texture);
        const source = texture.source;
        state.bindTexture(textureType, textureProperties.__webglTexture, _gl.TEXTURE0 + slot);
        const sourceProperties = properties.get(source);
        if (source.version !== sourceProperties.__version || forceUpload === true) {
            state.activeTexture(_gl.TEXTURE0 + slot);
            const workingPrimaries = $d5b33d7c30034067$export$5e6fd513f44698c.getPrimaries($d5b33d7c30034067$export$5e6fd513f44698c.workingColorSpace);
            const texturePrimaries = texture.colorSpace === $d5b33d7c30034067$export$bfcb490c2dd3db51 ? null : $d5b33d7c30034067$export$5e6fd513f44698c.getPrimaries(texture.colorSpace);
            const unpackConversion = texture.colorSpace === $d5b33d7c30034067$export$bfcb490c2dd3db51 || workingPrimaries === texturePrimaries ? _gl.NONE : _gl.BROWSER_DEFAULT_WEBGL;
            _gl.pixelStorei(_gl.UNPACK_FLIP_Y_WEBGL, texture.flipY);
            _gl.pixelStorei(_gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, texture.premultiplyAlpha);
            _gl.pixelStorei(_gl.UNPACK_ALIGNMENT, texture.unpackAlignment);
            _gl.pixelStorei(_gl.UNPACK_COLORSPACE_CONVERSION_WEBGL, unpackConversion);
            let image = resizeImage(texture.image, false, capabilities.maxTextureSize);
            image = verifyColorSpace(texture, image);
            const glFormat = utils.convert(texture.format, texture.colorSpace);
            const glType = utils.convert(texture.type);
            let glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType, texture.colorSpace, texture.isVideoTexture);
            setTextureParameters(textureType, texture);
            let mipmap;
            const mipmaps = texture.mipmaps;
            const useTexStorage = texture.isVideoTexture !== true;
            const allocateMemory = sourceProperties.__version === undefined || forceUpload === true;
            const dataReady = source.dataReady;
            const levels = getMipLevels(texture, image);
            if (texture.isDepthTexture) {
                glInternalFormat = getInternalDepthFormat(texture.format === $d5b33d7c30034067$export$1e113ac2d0905829, texture.type);
                //
                if (allocateMemory) {
                    if (useTexStorage) state.texStorage2D(_gl.TEXTURE_2D, 1, glInternalFormat, image.width, image.height);
                    else state.texImage2D(_gl.TEXTURE_2D, 0, glInternalFormat, image.width, image.height, 0, glFormat, glType, null);
                }
            } else if (texture.isDataTexture) {
                // use manually created mipmaps if available
                // if there are no manual mipmaps
                // set 0 level mipmap and then use GL to generate other mipmap levels
                if (mipmaps.length > 0) {
                    if (useTexStorage && allocateMemory) state.texStorage2D(_gl.TEXTURE_2D, levels, glInternalFormat, mipmaps[0].width, mipmaps[0].height);
                    for(let i = 0, il = mipmaps.length; i < il; i++){
                        mipmap = mipmaps[i];
                        if (useTexStorage) {
                            if (dataReady) state.texSubImage2D(_gl.TEXTURE_2D, i, 0, 0, mipmap.width, mipmap.height, glFormat, glType, mipmap.data);
                        } else state.texImage2D(_gl.TEXTURE_2D, i, glInternalFormat, mipmap.width, mipmap.height, 0, glFormat, glType, mipmap.data);
                    }
                    texture.generateMipmaps = false;
                } else if (useTexStorage) {
                    if (allocateMemory) state.texStorage2D(_gl.TEXTURE_2D, levels, glInternalFormat, image.width, image.height);
                    if (dataReady) state.texSubImage2D(_gl.TEXTURE_2D, 0, 0, 0, image.width, image.height, glFormat, glType, image.data);
                } else state.texImage2D(_gl.TEXTURE_2D, 0, glInternalFormat, image.width, image.height, 0, glFormat, glType, image.data);
            } else if (texture.isCompressedTexture) {
                if (texture.isCompressedArrayTexture) {
                    if (useTexStorage && allocateMemory) state.texStorage3D(_gl.TEXTURE_2D_ARRAY, levels, glInternalFormat, mipmaps[0].width, mipmaps[0].height, image.depth);
                    for(let i = 0, il = mipmaps.length; i < il; i++){
                        mipmap = mipmaps[i];
                        if (texture.format !== $d5b33d7c30034067$export$3f8bb04b555a363c) {
                            if (glFormat !== null) {
                                if (useTexStorage) {
                                    if (dataReady) {
                                        if (texture.layerUpdates.size > 0) {
                                            const layerByteLength = $d5b33d7c30034067$var$getByteLength(mipmap.width, mipmap.height, texture.format, texture.type);
                                            for (const layerIndex of texture.layerUpdates){
                                                const layerData = mipmap.data.subarray(layerIndex * layerByteLength / mipmap.data.BYTES_PER_ELEMENT, (layerIndex + 1) * layerByteLength / mipmap.data.BYTES_PER_ELEMENT);
                                                state.compressedTexSubImage3D(_gl.TEXTURE_2D_ARRAY, i, 0, 0, layerIndex, mipmap.width, mipmap.height, 1, glFormat, layerData);
                                            }
                                            texture.clearLayerUpdates();
                                        } else state.compressedTexSubImage3D(_gl.TEXTURE_2D_ARRAY, i, 0, 0, 0, mipmap.width, mipmap.height, image.depth, glFormat, mipmap.data);
                                    }
                                } else state.compressedTexImage3D(_gl.TEXTURE_2D_ARRAY, i, glInternalFormat, mipmap.width, mipmap.height, image.depth, 0, mipmap.data, 0, 0);
                            } else console.warn('THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .uploadTexture()');
                        } else {
                            if (useTexStorage) {
                                if (dataReady) state.texSubImage3D(_gl.TEXTURE_2D_ARRAY, i, 0, 0, 0, mipmap.width, mipmap.height, image.depth, glFormat, glType, mipmap.data);
                            } else state.texImage3D(_gl.TEXTURE_2D_ARRAY, i, glInternalFormat, mipmap.width, mipmap.height, image.depth, 0, glFormat, glType, mipmap.data);
                        }
                    }
                } else {
                    if (useTexStorage && allocateMemory) state.texStorage2D(_gl.TEXTURE_2D, levels, glInternalFormat, mipmaps[0].width, mipmaps[0].height);
                    for(let i = 0, il = mipmaps.length; i < il; i++){
                        mipmap = mipmaps[i];
                        if (texture.format !== $d5b33d7c30034067$export$3f8bb04b555a363c) {
                            if (glFormat !== null) {
                                if (useTexStorage) {
                                    if (dataReady) state.compressedTexSubImage2D(_gl.TEXTURE_2D, i, 0, 0, mipmap.width, mipmap.height, glFormat, mipmap.data);
                                } else state.compressedTexImage2D(_gl.TEXTURE_2D, i, glInternalFormat, mipmap.width, mipmap.height, 0, mipmap.data);
                            } else console.warn('THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .uploadTexture()');
                        } else {
                            if (useTexStorage) {
                                if (dataReady) state.texSubImage2D(_gl.TEXTURE_2D, i, 0, 0, mipmap.width, mipmap.height, glFormat, glType, mipmap.data);
                            } else state.texImage2D(_gl.TEXTURE_2D, i, glInternalFormat, mipmap.width, mipmap.height, 0, glFormat, glType, mipmap.data);
                        }
                    }
                }
            } else if (texture.isDataArrayTexture) {
                if (useTexStorage) {
                    if (allocateMemory) state.texStorage3D(_gl.TEXTURE_2D_ARRAY, levels, glInternalFormat, image.width, image.height, image.depth);
                    if (dataReady) {
                        if (texture.layerUpdates.size > 0) {
                            const layerByteLength = $d5b33d7c30034067$var$getByteLength(image.width, image.height, texture.format, texture.type);
                            for (const layerIndex of texture.layerUpdates){
                                const layerData = image.data.subarray(layerIndex * layerByteLength / image.data.BYTES_PER_ELEMENT, (layerIndex + 1) * layerByteLength / image.data.BYTES_PER_ELEMENT);
                                state.texSubImage3D(_gl.TEXTURE_2D_ARRAY, 0, 0, 0, layerIndex, image.width, image.height, 1, glFormat, glType, layerData);
                            }
                            texture.clearLayerUpdates();
                        } else state.texSubImage3D(_gl.TEXTURE_2D_ARRAY, 0, 0, 0, 0, image.width, image.height, image.depth, glFormat, glType, image.data);
                    }
                } else state.texImage3D(_gl.TEXTURE_2D_ARRAY, 0, glInternalFormat, image.width, image.height, image.depth, 0, glFormat, glType, image.data);
            } else if (texture.isData3DTexture) {
                if (useTexStorage) {
                    if (allocateMemory) state.texStorage3D(_gl.TEXTURE_3D, levels, glInternalFormat, image.width, image.height, image.depth);
                    if (dataReady) state.texSubImage3D(_gl.TEXTURE_3D, 0, 0, 0, 0, image.width, image.height, image.depth, glFormat, glType, image.data);
                } else state.texImage3D(_gl.TEXTURE_3D, 0, glInternalFormat, image.width, image.height, image.depth, 0, glFormat, glType, image.data);
            } else if (texture.isFramebufferTexture) {
                if (allocateMemory) {
                    if (useTexStorage) state.texStorage2D(_gl.TEXTURE_2D, levels, glInternalFormat, image.width, image.height);
                    else {
                        let width = image.width, height = image.height;
                        for(let i = 0; i < levels; i++){
                            state.texImage2D(_gl.TEXTURE_2D, i, glInternalFormat, width, height, 0, glFormat, glType, null);
                            width >>= 1;
                            height >>= 1;
                        }
                    }
                }
            } else {
                // regular Texture (image, video, canvas)
                // use manually created mipmaps if available
                // if there are no manual mipmaps
                // set 0 level mipmap and then use GL to generate other mipmap levels
                if (mipmaps.length > 0) {
                    if (useTexStorage && allocateMemory) {
                        const dimensions = getDimensions(mipmaps[0]);
                        state.texStorage2D(_gl.TEXTURE_2D, levels, glInternalFormat, dimensions.width, dimensions.height);
                    }
                    for(let i = 0, il = mipmaps.length; i < il; i++){
                        mipmap = mipmaps[i];
                        if (useTexStorage) {
                            if (dataReady) state.texSubImage2D(_gl.TEXTURE_2D, i, 0, 0, glFormat, glType, mipmap);
                        } else state.texImage2D(_gl.TEXTURE_2D, i, glInternalFormat, glFormat, glType, mipmap);
                    }
                    texture.generateMipmaps = false;
                } else if (useTexStorage) {
                    if (allocateMemory) {
                        const dimensions = getDimensions(image);
                        state.texStorage2D(_gl.TEXTURE_2D, levels, glInternalFormat, dimensions.width, dimensions.height);
                    }
                    if (dataReady) state.texSubImage2D(_gl.TEXTURE_2D, 0, 0, 0, glFormat, glType, image);
                } else state.texImage2D(_gl.TEXTURE_2D, 0, glInternalFormat, glFormat, glType, image);
            }
            if (textureNeedsGenerateMipmaps(texture)) generateMipmap(textureType);
            sourceProperties.__version = source.version;
            if (texture.onUpdate) texture.onUpdate(texture);
        }
        textureProperties.__version = texture.version;
    }
    function uploadCubeTexture(textureProperties, texture, slot) {
        if (texture.image.length !== 6) return;
        const forceUpload = initTexture(textureProperties, texture);
        const source = texture.source;
        state.bindTexture(_gl.TEXTURE_CUBE_MAP, textureProperties.__webglTexture, _gl.TEXTURE0 + slot);
        const sourceProperties = properties.get(source);
        if (source.version !== sourceProperties.__version || forceUpload === true) {
            state.activeTexture(_gl.TEXTURE0 + slot);
            const workingPrimaries = $d5b33d7c30034067$export$5e6fd513f44698c.getPrimaries($d5b33d7c30034067$export$5e6fd513f44698c.workingColorSpace);
            const texturePrimaries = texture.colorSpace === $d5b33d7c30034067$export$bfcb490c2dd3db51 ? null : $d5b33d7c30034067$export$5e6fd513f44698c.getPrimaries(texture.colorSpace);
            const unpackConversion = texture.colorSpace === $d5b33d7c30034067$export$bfcb490c2dd3db51 || workingPrimaries === texturePrimaries ? _gl.NONE : _gl.BROWSER_DEFAULT_WEBGL;
            _gl.pixelStorei(_gl.UNPACK_FLIP_Y_WEBGL, texture.flipY);
            _gl.pixelStorei(_gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, texture.premultiplyAlpha);
            _gl.pixelStorei(_gl.UNPACK_ALIGNMENT, texture.unpackAlignment);
            _gl.pixelStorei(_gl.UNPACK_COLORSPACE_CONVERSION_WEBGL, unpackConversion);
            const isCompressed = texture.isCompressedTexture || texture.image[0].isCompressedTexture;
            const isDataTexture = texture.image[0] && texture.image[0].isDataTexture;
            const cubeImage = [];
            for(let i = 0; i < 6; i++){
                if (!isCompressed && !isDataTexture) cubeImage[i] = resizeImage(texture.image[i], true, capabilities.maxCubemapSize);
                else cubeImage[i] = isDataTexture ? texture.image[i].image : texture.image[i];
                cubeImage[i] = verifyColorSpace(texture, cubeImage[i]);
            }
            const image = cubeImage[0], glFormat = utils.convert(texture.format, texture.colorSpace), glType = utils.convert(texture.type), glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType, texture.colorSpace);
            const useTexStorage = texture.isVideoTexture !== true;
            const allocateMemory = sourceProperties.__version === undefined || forceUpload === true;
            const dataReady = source.dataReady;
            let levels = getMipLevels(texture, image);
            setTextureParameters(_gl.TEXTURE_CUBE_MAP, texture);
            let mipmaps;
            if (isCompressed) {
                if (useTexStorage && allocateMemory) state.texStorage2D(_gl.TEXTURE_CUBE_MAP, levels, glInternalFormat, image.width, image.height);
                for(let i = 0; i < 6; i++){
                    mipmaps = cubeImage[i].mipmaps;
                    for(let j = 0; j < mipmaps.length; j++){
                        const mipmap = mipmaps[j];
                        if (texture.format !== $d5b33d7c30034067$export$3f8bb04b555a363c) {
                            if (glFormat !== null) {
                                if (useTexStorage) {
                                    if (dataReady) state.compressedTexSubImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j, 0, 0, mipmap.width, mipmap.height, glFormat, mipmap.data);
                                } else state.compressedTexImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j, glInternalFormat, mipmap.width, mipmap.height, 0, mipmap.data);
                            } else console.warn('THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .setTextureCube()');
                        } else {
                            if (useTexStorage) {
                                if (dataReady) state.texSubImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j, 0, 0, mipmap.width, mipmap.height, glFormat, glType, mipmap.data);
                            } else state.texImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j, glInternalFormat, mipmap.width, mipmap.height, 0, glFormat, glType, mipmap.data);
                        }
                    }
                }
            } else {
                mipmaps = texture.mipmaps;
                if (useTexStorage && allocateMemory) {
                    // TODO: Uniformly handle mipmap definitions
                    // Normal textures and compressed cube textures define base level + mips with their mipmap array
                    // Uncompressed cube textures use their mipmap array only for mips (no base level)
                    if (mipmaps.length > 0) levels++;
                    const dimensions = getDimensions(cubeImage[0]);
                    state.texStorage2D(_gl.TEXTURE_CUBE_MAP, levels, glInternalFormat, dimensions.width, dimensions.height);
                }
                for(let i = 0; i < 6; i++)if (isDataTexture) {
                    if (useTexStorage) {
                        if (dataReady) state.texSubImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, 0, 0, 0, cubeImage[i].width, cubeImage[i].height, glFormat, glType, cubeImage[i].data);
                    } else state.texImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, 0, glInternalFormat, cubeImage[i].width, cubeImage[i].height, 0, glFormat, glType, cubeImage[i].data);
                    for(let j = 0; j < mipmaps.length; j++){
                        const mipmap = mipmaps[j];
                        const mipmapImage = mipmap.image[i].image;
                        if (useTexStorage) {
                            if (dataReady) state.texSubImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j + 1, 0, 0, mipmapImage.width, mipmapImage.height, glFormat, glType, mipmapImage.data);
                        } else state.texImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j + 1, glInternalFormat, mipmapImage.width, mipmapImage.height, 0, glFormat, glType, mipmapImage.data);
                    }
                } else {
                    if (useTexStorage) {
                        if (dataReady) state.texSubImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, 0, 0, 0, glFormat, glType, cubeImage[i]);
                    } else state.texImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, 0, glInternalFormat, glFormat, glType, cubeImage[i]);
                    for(let j = 0; j < mipmaps.length; j++){
                        const mipmap = mipmaps[j];
                        if (useTexStorage) {
                            if (dataReady) state.texSubImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j + 1, 0, 0, glFormat, glType, mipmap.image[i]);
                        } else state.texImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j + 1, glInternalFormat, glFormat, glType, mipmap.image[i]);
                    }
                }
            }
            if (textureNeedsGenerateMipmaps(texture)) // We assume images for cube map have the same size.
            generateMipmap(_gl.TEXTURE_CUBE_MAP);
            sourceProperties.__version = source.version;
            if (texture.onUpdate) texture.onUpdate(texture);
        }
        textureProperties.__version = texture.version;
    }
    // Render targets
    // Setup storage for target texture and bind it to correct framebuffer
    function setupFrameBufferTexture(framebuffer, renderTarget, texture, attachment, textureTarget, level) {
        const glFormat = utils.convert(texture.format, texture.colorSpace);
        const glType = utils.convert(texture.type);
        const glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType, texture.colorSpace);
        const renderTargetProperties = properties.get(renderTarget);
        const textureProperties = properties.get(texture);
        textureProperties.__renderTarget = renderTarget;
        if (!renderTargetProperties.__hasExternalTextures) {
            const width = Math.max(1, renderTarget.width >> level);
            const height = Math.max(1, renderTarget.height >> level);
            if (textureTarget === _gl.TEXTURE_3D || textureTarget === _gl.TEXTURE_2D_ARRAY) state.texImage3D(textureTarget, level, glInternalFormat, width, height, renderTarget.depth, 0, glFormat, glType, null);
            else state.texImage2D(textureTarget, level, glInternalFormat, width, height, 0, glFormat, glType, null);
        }
        state.bindFramebuffer(_gl.FRAMEBUFFER, framebuffer);
        if (useMultisampledRTT(renderTarget)) multisampledRTTExt.framebufferTexture2DMultisampleEXT(_gl.FRAMEBUFFER, attachment, textureTarget, textureProperties.__webglTexture, 0, getRenderTargetSamples(renderTarget));
        else if (textureTarget === _gl.TEXTURE_2D || textureTarget >= _gl.TEXTURE_CUBE_MAP_POSITIVE_X && textureTarget <= _gl.TEXTURE_CUBE_MAP_NEGATIVE_Z) _gl.framebufferTexture2D(_gl.FRAMEBUFFER, attachment, textureTarget, textureProperties.__webglTexture, level);
        state.bindFramebuffer(_gl.FRAMEBUFFER, null);
    }
    // Setup storage for internal depth/stencil buffers and bind to correct framebuffer
    function setupRenderBufferStorage(renderbuffer, renderTarget, isMultisample) {
        _gl.bindRenderbuffer(_gl.RENDERBUFFER, renderbuffer);
        if (renderTarget.depthBuffer) {
            // retrieve the depth attachment types
            const depthTexture = renderTarget.depthTexture;
            const depthType = depthTexture && depthTexture.isDepthTexture ? depthTexture.type : null;
            const glInternalFormat = getInternalDepthFormat(renderTarget.stencilBuffer, depthType);
            const glAttachmentType = renderTarget.stencilBuffer ? _gl.DEPTH_STENCIL_ATTACHMENT : _gl.DEPTH_ATTACHMENT;
            // set up the attachment
            const samples = getRenderTargetSamples(renderTarget);
            const isUseMultisampledRTT = useMultisampledRTT(renderTarget);
            if (isUseMultisampledRTT) multisampledRTTExt.renderbufferStorageMultisampleEXT(_gl.RENDERBUFFER, samples, glInternalFormat, renderTarget.width, renderTarget.height);
            else if (isMultisample) _gl.renderbufferStorageMultisample(_gl.RENDERBUFFER, samples, glInternalFormat, renderTarget.width, renderTarget.height);
            else _gl.renderbufferStorage(_gl.RENDERBUFFER, glInternalFormat, renderTarget.width, renderTarget.height);
            _gl.framebufferRenderbuffer(_gl.FRAMEBUFFER, glAttachmentType, _gl.RENDERBUFFER, renderbuffer);
        } else {
            const textures = renderTarget.textures;
            for(let i = 0; i < textures.length; i++){
                const texture = textures[i];
                const glFormat = utils.convert(texture.format, texture.colorSpace);
                const glType = utils.convert(texture.type);
                const glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType, texture.colorSpace);
                const samples = getRenderTargetSamples(renderTarget);
                if (isMultisample && useMultisampledRTT(renderTarget) === false) _gl.renderbufferStorageMultisample(_gl.RENDERBUFFER, samples, glInternalFormat, renderTarget.width, renderTarget.height);
                else if (useMultisampledRTT(renderTarget)) multisampledRTTExt.renderbufferStorageMultisampleEXT(_gl.RENDERBUFFER, samples, glInternalFormat, renderTarget.width, renderTarget.height);
                else _gl.renderbufferStorage(_gl.RENDERBUFFER, glInternalFormat, renderTarget.width, renderTarget.height);
            }
        }
        _gl.bindRenderbuffer(_gl.RENDERBUFFER, null);
    }
    // Setup resources for a Depth Texture for a FBO (needs an extension)
    function setupDepthTexture(framebuffer, renderTarget) {
        const isCube = renderTarget && renderTarget.isWebGLCubeRenderTarget;
        if (isCube) throw new Error('Depth Texture with cube render targets is not supported');
        state.bindFramebuffer(_gl.FRAMEBUFFER, framebuffer);
        if (!(renderTarget.depthTexture && renderTarget.depthTexture.isDepthTexture)) throw new Error('renderTarget.depthTexture must be an instance of THREE.DepthTexture');
        const textureProperties = properties.get(renderTarget.depthTexture);
        textureProperties.__renderTarget = renderTarget;
        // upload an empty depth texture with framebuffer size
        if (!textureProperties.__webglTexture || renderTarget.depthTexture.image.width !== renderTarget.width || renderTarget.depthTexture.image.height !== renderTarget.height) {
            renderTarget.depthTexture.image.width = renderTarget.width;
            renderTarget.depthTexture.image.height = renderTarget.height;
            renderTarget.depthTexture.needsUpdate = true;
        }
        setTexture2D(renderTarget.depthTexture, 0);
        const webglDepthTexture = textureProperties.__webglTexture;
        const samples = getRenderTargetSamples(renderTarget);
        if (renderTarget.depthTexture.format === $d5b33d7c30034067$export$c1b6b5136be58045) {
            if (useMultisampledRTT(renderTarget)) multisampledRTTExt.framebufferTexture2DMultisampleEXT(_gl.FRAMEBUFFER, _gl.DEPTH_ATTACHMENT, _gl.TEXTURE_2D, webglDepthTexture, 0, samples);
            else _gl.framebufferTexture2D(_gl.FRAMEBUFFER, _gl.DEPTH_ATTACHMENT, _gl.TEXTURE_2D, webglDepthTexture, 0);
        } else if (renderTarget.depthTexture.format === $d5b33d7c30034067$export$1e113ac2d0905829) {
            if (useMultisampledRTT(renderTarget)) multisampledRTTExt.framebufferTexture2DMultisampleEXT(_gl.FRAMEBUFFER, _gl.DEPTH_STENCIL_ATTACHMENT, _gl.TEXTURE_2D, webglDepthTexture, 0, samples);
            else _gl.framebufferTexture2D(_gl.FRAMEBUFFER, _gl.DEPTH_STENCIL_ATTACHMENT, _gl.TEXTURE_2D, webglDepthTexture, 0);
        } else throw new Error('Unknown depthTexture format');
    }
    // Setup GL resources for a non-texture depth buffer
    function setupDepthRenderbuffer(renderTarget) {
        const renderTargetProperties = properties.get(renderTarget);
        const isCube = renderTarget.isWebGLCubeRenderTarget === true;
        // if the bound depth texture has changed
        if (renderTargetProperties.__boundDepthTexture !== renderTarget.depthTexture) {
            // fire the dispose event to get rid of stored state associated with the previously bound depth buffer
            const depthTexture = renderTarget.depthTexture;
            if (renderTargetProperties.__depthDisposeCallback) renderTargetProperties.__depthDisposeCallback();
            // set up dispose listeners to track when the currently attached buffer is implicitly unbound
            if (depthTexture) {
                const disposeEvent = ()=>{
                    delete renderTargetProperties.__boundDepthTexture;
                    delete renderTargetProperties.__depthDisposeCallback;
                    depthTexture.removeEventListener('dispose', disposeEvent);
                };
                depthTexture.addEventListener('dispose', disposeEvent);
                renderTargetProperties.__depthDisposeCallback = disposeEvent;
            }
            renderTargetProperties.__boundDepthTexture = depthTexture;
        }
        if (renderTarget.depthTexture && !renderTargetProperties.__autoAllocateDepthBuffer) {
            if (isCube) throw new Error('target.depthTexture not supported in Cube render targets');
            setupDepthTexture(renderTargetProperties.__webglFramebuffer, renderTarget);
        } else if (isCube) {
            renderTargetProperties.__webglDepthbuffer = [];
            for(let i = 0; i < 6; i++){
                state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglFramebuffer[i]);
                if (renderTargetProperties.__webglDepthbuffer[i] === undefined) {
                    renderTargetProperties.__webglDepthbuffer[i] = _gl.createRenderbuffer();
                    setupRenderBufferStorage(renderTargetProperties.__webglDepthbuffer[i], renderTarget, false);
                } else {
                    // attach buffer if it's been created already
                    const glAttachmentType = renderTarget.stencilBuffer ? _gl.DEPTH_STENCIL_ATTACHMENT : _gl.DEPTH_ATTACHMENT;
                    const renderbuffer = renderTargetProperties.__webglDepthbuffer[i];
                    _gl.bindRenderbuffer(_gl.RENDERBUFFER, renderbuffer);
                    _gl.framebufferRenderbuffer(_gl.FRAMEBUFFER, glAttachmentType, _gl.RENDERBUFFER, renderbuffer);
                }
            }
        } else {
            state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglFramebuffer);
            if (renderTargetProperties.__webglDepthbuffer === undefined) {
                renderTargetProperties.__webglDepthbuffer = _gl.createRenderbuffer();
                setupRenderBufferStorage(renderTargetProperties.__webglDepthbuffer, renderTarget, false);
            } else {
                // attach buffer if it's been created already
                const glAttachmentType = renderTarget.stencilBuffer ? _gl.DEPTH_STENCIL_ATTACHMENT : _gl.DEPTH_ATTACHMENT;
                const renderbuffer = renderTargetProperties.__webglDepthbuffer;
                _gl.bindRenderbuffer(_gl.RENDERBUFFER, renderbuffer);
                _gl.framebufferRenderbuffer(_gl.FRAMEBUFFER, glAttachmentType, _gl.RENDERBUFFER, renderbuffer);
            }
        }
        state.bindFramebuffer(_gl.FRAMEBUFFER, null);
    }
    // rebind framebuffer with external textures
    function rebindTextures(renderTarget, colorTexture, depthTexture) {
        const renderTargetProperties = properties.get(renderTarget);
        if (colorTexture !== undefined) setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer, renderTarget, renderTarget.texture, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_2D, 0);
        if (depthTexture !== undefined) setupDepthRenderbuffer(renderTarget);
    }
    // Set up GL resources for the render target
    function setupRenderTarget(renderTarget) {
        const texture = renderTarget.texture;
        const renderTargetProperties = properties.get(renderTarget);
        const textureProperties = properties.get(texture);
        renderTarget.addEventListener('dispose', onRenderTargetDispose);
        const textures = renderTarget.textures;
        const isCube = renderTarget.isWebGLCubeRenderTarget === true;
        const isMultipleRenderTargets = textures.length > 1;
        if (!isMultipleRenderTargets) {
            if (textureProperties.__webglTexture === undefined) textureProperties.__webglTexture = _gl.createTexture();
            textureProperties.__version = texture.version;
            info.memory.textures++;
        }
        // Setup framebuffer
        if (isCube) {
            renderTargetProperties.__webglFramebuffer = [];
            for(let i = 0; i < 6; i++)if (texture.mipmaps && texture.mipmaps.length > 0) {
                renderTargetProperties.__webglFramebuffer[i] = [];
                for(let level = 0; level < texture.mipmaps.length; level++)renderTargetProperties.__webglFramebuffer[i][level] = _gl.createFramebuffer();
            } else renderTargetProperties.__webglFramebuffer[i] = _gl.createFramebuffer();
        } else {
            if (texture.mipmaps && texture.mipmaps.length > 0) {
                renderTargetProperties.__webglFramebuffer = [];
                for(let level = 0; level < texture.mipmaps.length; level++)renderTargetProperties.__webglFramebuffer[level] = _gl.createFramebuffer();
            } else renderTargetProperties.__webglFramebuffer = _gl.createFramebuffer();
            if (isMultipleRenderTargets) for(let i = 0, il = textures.length; i < il; i++){
                const attachmentProperties = properties.get(textures[i]);
                if (attachmentProperties.__webglTexture === undefined) {
                    attachmentProperties.__webglTexture = _gl.createTexture();
                    info.memory.textures++;
                }
            }
            if (renderTarget.samples > 0 && useMultisampledRTT(renderTarget) === false) {
                renderTargetProperties.__webglMultisampledFramebuffer = _gl.createFramebuffer();
                renderTargetProperties.__webglColorRenderbuffer = [];
                state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglMultisampledFramebuffer);
                for(let i = 0; i < textures.length; i++){
                    const texture = textures[i];
                    renderTargetProperties.__webglColorRenderbuffer[i] = _gl.createRenderbuffer();
                    _gl.bindRenderbuffer(_gl.RENDERBUFFER, renderTargetProperties.__webglColorRenderbuffer[i]);
                    const glFormat = utils.convert(texture.format, texture.colorSpace);
                    const glType = utils.convert(texture.type);
                    const glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType, texture.colorSpace, renderTarget.isXRRenderTarget === true);
                    const samples = getRenderTargetSamples(renderTarget);
                    _gl.renderbufferStorageMultisample(_gl.RENDERBUFFER, samples, glInternalFormat, renderTarget.width, renderTarget.height);
                    _gl.framebufferRenderbuffer(_gl.FRAMEBUFFER, _gl.COLOR_ATTACHMENT0 + i, _gl.RENDERBUFFER, renderTargetProperties.__webglColorRenderbuffer[i]);
                }
                _gl.bindRenderbuffer(_gl.RENDERBUFFER, null);
                if (renderTarget.depthBuffer) {
                    renderTargetProperties.__webglDepthRenderbuffer = _gl.createRenderbuffer();
                    setupRenderBufferStorage(renderTargetProperties.__webglDepthRenderbuffer, renderTarget, true);
                }
                state.bindFramebuffer(_gl.FRAMEBUFFER, null);
            }
        }
        // Setup color buffer
        if (isCube) {
            state.bindTexture(_gl.TEXTURE_CUBE_MAP, textureProperties.__webglTexture);
            setTextureParameters(_gl.TEXTURE_CUBE_MAP, texture);
            for(let i = 0; i < 6; i++){
                if (texture.mipmaps && texture.mipmaps.length > 0) for(let level = 0; level < texture.mipmaps.length; level++)setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer[i][level], renderTarget, texture, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, level);
                else setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer[i], renderTarget, texture, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, 0);
            }
            if (textureNeedsGenerateMipmaps(texture)) generateMipmap(_gl.TEXTURE_CUBE_MAP);
            state.unbindTexture();
        } else if (isMultipleRenderTargets) {
            for(let i = 0, il = textures.length; i < il; i++){
                const attachment = textures[i];
                const attachmentProperties = properties.get(attachment);
                state.bindTexture(_gl.TEXTURE_2D, attachmentProperties.__webglTexture);
                setTextureParameters(_gl.TEXTURE_2D, attachment);
                setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer, renderTarget, attachment, _gl.COLOR_ATTACHMENT0 + i, _gl.TEXTURE_2D, 0);
                if (textureNeedsGenerateMipmaps(attachment)) generateMipmap(_gl.TEXTURE_2D);
            }
            state.unbindTexture();
        } else {
            let glTextureType = _gl.TEXTURE_2D;
            if (renderTarget.isWebGL3DRenderTarget || renderTarget.isWebGLArrayRenderTarget) glTextureType = renderTarget.isWebGL3DRenderTarget ? _gl.TEXTURE_3D : _gl.TEXTURE_2D_ARRAY;
            state.bindTexture(glTextureType, textureProperties.__webglTexture);
            setTextureParameters(glTextureType, texture);
            if (texture.mipmaps && texture.mipmaps.length > 0) for(let level = 0; level < texture.mipmaps.length; level++)setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer[level], renderTarget, texture, _gl.COLOR_ATTACHMENT0, glTextureType, level);
            else setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer, renderTarget, texture, _gl.COLOR_ATTACHMENT0, glTextureType, 0);
            if (textureNeedsGenerateMipmaps(texture)) generateMipmap(glTextureType);
            state.unbindTexture();
        }
        // Setup depth and stencil buffers
        if (renderTarget.depthBuffer) setupDepthRenderbuffer(renderTarget);
    }
    function updateRenderTargetMipmap(renderTarget) {
        const textures = renderTarget.textures;
        for(let i = 0, il = textures.length; i < il; i++){
            const texture = textures[i];
            if (textureNeedsGenerateMipmaps(texture)) {
                const targetType = getTargetType(renderTarget);
                const webglTexture = properties.get(texture).__webglTexture;
                state.bindTexture(targetType, webglTexture);
                generateMipmap(targetType);
                state.unbindTexture();
            }
        }
    }
    const invalidationArrayRead = [];
    const invalidationArrayDraw = [];
    function updateMultisampleRenderTarget(renderTarget) {
        if (renderTarget.samples > 0) {
            if (useMultisampledRTT(renderTarget) === false) {
                const textures = renderTarget.textures;
                const width = renderTarget.width;
                const height = renderTarget.height;
                let mask = _gl.COLOR_BUFFER_BIT;
                const depthStyle = renderTarget.stencilBuffer ? _gl.DEPTH_STENCIL_ATTACHMENT : _gl.DEPTH_ATTACHMENT;
                const renderTargetProperties = properties.get(renderTarget);
                const isMultipleRenderTargets = textures.length > 1;
                // If MRT we need to remove FBO attachments
                if (isMultipleRenderTargets) for(let i = 0; i < textures.length; i++){
                    state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglMultisampledFramebuffer);
                    _gl.framebufferRenderbuffer(_gl.FRAMEBUFFER, _gl.COLOR_ATTACHMENT0 + i, _gl.RENDERBUFFER, null);
                    state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglFramebuffer);
                    _gl.framebufferTexture2D(_gl.DRAW_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0 + i, _gl.TEXTURE_2D, null, 0);
                }
                state.bindFramebuffer(_gl.READ_FRAMEBUFFER, renderTargetProperties.__webglMultisampledFramebuffer);
                state.bindFramebuffer(_gl.DRAW_FRAMEBUFFER, renderTargetProperties.__webglFramebuffer);
                for(let i = 0; i < textures.length; i++){
                    if (renderTarget.resolveDepthBuffer) {
                        if (renderTarget.depthBuffer) mask |= _gl.DEPTH_BUFFER_BIT;
                        // resolving stencil is slow with a D3D backend. disable it for all transmission render targets (see #27799)
                        if (renderTarget.stencilBuffer && renderTarget.resolveStencilBuffer) mask |= _gl.STENCIL_BUFFER_BIT;
                    }
                    if (isMultipleRenderTargets) {
                        _gl.framebufferRenderbuffer(_gl.READ_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, _gl.RENDERBUFFER, renderTargetProperties.__webglColorRenderbuffer[i]);
                        const webglTexture = properties.get(textures[i]).__webglTexture;
                        _gl.framebufferTexture2D(_gl.DRAW_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_2D, webglTexture, 0);
                    }
                    _gl.blitFramebuffer(0, 0, width, height, 0, 0, width, height, mask, _gl.NEAREST);
                    if (supportsInvalidateFramebuffer === true) {
                        invalidationArrayRead.length = 0;
                        invalidationArrayDraw.length = 0;
                        invalidationArrayRead.push(_gl.COLOR_ATTACHMENT0 + i);
                        if (renderTarget.depthBuffer && renderTarget.resolveDepthBuffer === false) {
                            invalidationArrayRead.push(depthStyle);
                            invalidationArrayDraw.push(depthStyle);
                            _gl.invalidateFramebuffer(_gl.DRAW_FRAMEBUFFER, invalidationArrayDraw);
                        }
                        _gl.invalidateFramebuffer(_gl.READ_FRAMEBUFFER, invalidationArrayRead);
                    }
                }
                state.bindFramebuffer(_gl.READ_FRAMEBUFFER, null);
                state.bindFramebuffer(_gl.DRAW_FRAMEBUFFER, null);
                // If MRT since pre-blit we removed the FBO we need to reconstruct the attachments
                if (isMultipleRenderTargets) for(let i = 0; i < textures.length; i++){
                    state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglMultisampledFramebuffer);
                    _gl.framebufferRenderbuffer(_gl.FRAMEBUFFER, _gl.COLOR_ATTACHMENT0 + i, _gl.RENDERBUFFER, renderTargetProperties.__webglColorRenderbuffer[i]);
                    const webglTexture = properties.get(textures[i]).__webglTexture;
                    state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglFramebuffer);
                    _gl.framebufferTexture2D(_gl.DRAW_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0 + i, _gl.TEXTURE_2D, webglTexture, 0);
                }
                state.bindFramebuffer(_gl.DRAW_FRAMEBUFFER, renderTargetProperties.__webglMultisampledFramebuffer);
            } else if (renderTarget.depthBuffer && renderTarget.resolveDepthBuffer === false && supportsInvalidateFramebuffer) {
                const depthStyle = renderTarget.stencilBuffer ? _gl.DEPTH_STENCIL_ATTACHMENT : _gl.DEPTH_ATTACHMENT;
                _gl.invalidateFramebuffer(_gl.DRAW_FRAMEBUFFER, [
                    depthStyle
                ]);
            }
        }
    }
    function getRenderTargetSamples(renderTarget) {
        return Math.min(capabilities.maxSamples, renderTarget.samples);
    }
    function useMultisampledRTT(renderTarget) {
        const renderTargetProperties = properties.get(renderTarget);
        return renderTarget.samples > 0 && extensions.has('WEBGL_multisampled_render_to_texture') === true && renderTargetProperties.__useRenderToTexture !== false;
    }
    function updateVideoTexture(texture) {
        const frame = info.render.frame;
        // Check the last frame we updated the VideoTexture
        if (_videoTextures.get(texture) !== frame) {
            _videoTextures.set(texture, frame);
            texture.update();
        }
    }
    function verifyColorSpace(texture, image) {
        const colorSpace = texture.colorSpace;
        const format = texture.format;
        const type = texture.type;
        if (texture.isCompressedTexture === true || texture.isVideoTexture === true) return image;
        if (colorSpace !== $d5b33d7c30034067$export$42429b3acfb233a4 && colorSpace !== $d5b33d7c30034067$export$bfcb490c2dd3db51) {
            // sRGB
            if ($d5b33d7c30034067$export$5e6fd513f44698c.getTransfer(colorSpace) === $d5b33d7c30034067$export$8d0a61916cc26abb) // in WebGL 2 uncompressed textures can only be sRGB encoded if they have the RGBA8 format
            {
                if (format !== $d5b33d7c30034067$export$3f8bb04b555a363c || type !== $d5b33d7c30034067$export$2e8ce08d3f6f5e10) console.warn('THREE.WebGLTextures: sRGB encoded textures have to use RGBAFormat and UnsignedByteType.');
            } else console.error('THREE.WebGLTextures: Unsupported texture color space:', colorSpace);
        }
        return image;
    }
    function getDimensions(image) {
        if (typeof HTMLImageElement !== 'undefined' && image instanceof HTMLImageElement) {
            // if intrinsic data are not available, fallback to width/height
            _imageDimensions.width = image.naturalWidth || image.width;
            _imageDimensions.height = image.naturalHeight || image.height;
        } else if (typeof VideoFrame !== 'undefined' && image instanceof VideoFrame) {
            _imageDimensions.width = image.displayWidth;
            _imageDimensions.height = image.displayHeight;
        } else {
            _imageDimensions.width = image.width;
            _imageDimensions.height = image.height;
        }
        return _imageDimensions;
    }
    //
    this.allocateTextureUnit = allocateTextureUnit;
    this.resetTextureUnits = resetTextureUnits;
    this.setTexture2D = setTexture2D;
    this.setTexture2DArray = setTexture2DArray;
    this.setTexture3D = setTexture3D;
    this.setTextureCube = setTextureCube;
    this.rebindTextures = rebindTextures;
    this.setupRenderTarget = setupRenderTarget;
    this.updateRenderTargetMipmap = updateRenderTargetMipmap;
    this.updateMultisampleRenderTarget = updateMultisampleRenderTarget;
    this.setupDepthRenderbuffer = setupDepthRenderbuffer;
    this.setupFrameBufferTexture = setupFrameBufferTexture;
    this.useMultisampledRTT = useMultisampledRTT;
}
function $d5b33d7c30034067$export$ddaebcad857649a8(gl, extensions) {
    function convert(p, colorSpace = $d5b33d7c30034067$export$bfcb490c2dd3db51) {
        let extension;
        const transfer = $d5b33d7c30034067$export$5e6fd513f44698c.getTransfer(colorSpace);
        if (p === $d5b33d7c30034067$export$2e8ce08d3f6f5e10) return gl.UNSIGNED_BYTE;
        if (p === $d5b33d7c30034067$export$b3969b01faf587f2) return gl.UNSIGNED_SHORT_4_4_4_4;
        if (p === $d5b33d7c30034067$export$18886f8ae33e90de) return gl.UNSIGNED_SHORT_5_5_5_1;
        if (p === $d5b33d7c30034067$export$5a4c329b7e2092d3) return gl.UNSIGNED_INT_5_9_9_9_REV;
        if (p === $d5b33d7c30034067$export$545fce0311a9796a) return gl.BYTE;
        if (p === $d5b33d7c30034067$export$88572337f312435f) return gl.SHORT;
        if (p === $d5b33d7c30034067$export$c63dc51868b06a9d) return gl.UNSIGNED_SHORT;
        if (p === $d5b33d7c30034067$export$5c612977753abe2) return gl.INT;
        if (p === $d5b33d7c30034067$export$c3c7fc4518ebba96) return gl.UNSIGNED_INT;
        if (p === $d5b33d7c30034067$export$f6d331659b644596) return gl.FLOAT;
        if (p === $d5b33d7c30034067$export$2697304443f382bc) return gl.HALF_FLOAT;
        if (p === $d5b33d7c30034067$export$988473390501ed4b) return gl.ALPHA;
        if (p === $d5b33d7c30034067$export$7c67423a5ee6f5eb) return gl.RGB;
        if (p === $d5b33d7c30034067$export$3f8bb04b555a363c) return gl.RGBA;
        if (p === $d5b33d7c30034067$export$cc09ccbf6d1ed449) return gl.LUMINANCE;
        if (p === $d5b33d7c30034067$export$9053a81c4a69c289) return gl.LUMINANCE_ALPHA;
        if (p === $d5b33d7c30034067$export$c1b6b5136be58045) return gl.DEPTH_COMPONENT;
        if (p === $d5b33d7c30034067$export$1e113ac2d0905829) return gl.DEPTH_STENCIL;
        // WebGL2 formats.
        if (p === $d5b33d7c30034067$export$4e041a7967d15c4b) return gl.RED;
        if (p === $d5b33d7c30034067$export$aa92e870a709d190) return gl.RED_INTEGER;
        if (p === $d5b33d7c30034067$export$6cdf0b461c7ce8a0) return gl.RG;
        if (p === $d5b33d7c30034067$export$1ba1c45f9f77d4d7) return gl.RG_INTEGER;
        if (p === $d5b33d7c30034067$export$c200e7d26f592f21) return gl.RGBA_INTEGER;
        // S3TC
        if (p === $d5b33d7c30034067$export$21d1799c6d552fc0 || p === $d5b33d7c30034067$export$afa304c3e981b668 || p === $d5b33d7c30034067$export$d2a1a68024a3e56c || p === $d5b33d7c30034067$export$9a79c424327dacf9) {
            if (transfer === $d5b33d7c30034067$export$8d0a61916cc26abb) {
                extension = extensions.get('WEBGL_compressed_texture_s3tc_srgb');
                if (extension !== null) {
                    if (p === $d5b33d7c30034067$export$21d1799c6d552fc0) return extension.COMPRESSED_SRGB_S3TC_DXT1_EXT;
                    if (p === $d5b33d7c30034067$export$afa304c3e981b668) return extension.COMPRESSED_SRGB_ALPHA_S3TC_DXT1_EXT;
                    if (p === $d5b33d7c30034067$export$d2a1a68024a3e56c) return extension.COMPRESSED_SRGB_ALPHA_S3TC_DXT3_EXT;
                    if (p === $d5b33d7c30034067$export$9a79c424327dacf9) return extension.COMPRESSED_SRGB_ALPHA_S3TC_DXT5_EXT;
                } else return null;
            } else {
                extension = extensions.get('WEBGL_compressed_texture_s3tc');
                if (extension !== null) {
                    if (p === $d5b33d7c30034067$export$21d1799c6d552fc0) return extension.COMPRESSED_RGB_S3TC_DXT1_EXT;
                    if (p === $d5b33d7c30034067$export$afa304c3e981b668) return extension.COMPRESSED_RGBA_S3TC_DXT1_EXT;
                    if (p === $d5b33d7c30034067$export$d2a1a68024a3e56c) return extension.COMPRESSED_RGBA_S3TC_DXT3_EXT;
                    if (p === $d5b33d7c30034067$export$9a79c424327dacf9) return extension.COMPRESSED_RGBA_S3TC_DXT5_EXT;
                } else return null;
            }
        }
        // PVRTC
        if (p === $d5b33d7c30034067$export$19ada9bbb1af3573 || p === $d5b33d7c30034067$export$d0f0355bb3d948e4 || p === $d5b33d7c30034067$export$b82296714358084c || p === $d5b33d7c30034067$export$b71692456c47b6c3) {
            extension = extensions.get('WEBGL_compressed_texture_pvrtc');
            if (extension !== null) {
                if (p === $d5b33d7c30034067$export$19ada9bbb1af3573) return extension.COMPRESSED_RGB_PVRTC_4BPPV1_IMG;
                if (p === $d5b33d7c30034067$export$d0f0355bb3d948e4) return extension.COMPRESSED_RGB_PVRTC_2BPPV1_IMG;
                if (p === $d5b33d7c30034067$export$b82296714358084c) return extension.COMPRESSED_RGBA_PVRTC_4BPPV1_IMG;
                if (p === $d5b33d7c30034067$export$b71692456c47b6c3) return extension.COMPRESSED_RGBA_PVRTC_2BPPV1_IMG;
            } else return null;
        }
        // ETC
        if (p === $d5b33d7c30034067$export$6ab91af2d757aee7 || p === $d5b33d7c30034067$export$7800993ef8106a6a || p === $d5b33d7c30034067$export$23ed8300a860e7d8) {
            extension = extensions.get('WEBGL_compressed_texture_etc');
            if (extension !== null) {
                if (p === $d5b33d7c30034067$export$6ab91af2d757aee7 || p === $d5b33d7c30034067$export$7800993ef8106a6a) return transfer === $d5b33d7c30034067$export$8d0a61916cc26abb ? extension.COMPRESSED_SRGB8_ETC2 : extension.COMPRESSED_RGB8_ETC2;
                if (p === $d5b33d7c30034067$export$23ed8300a860e7d8) return transfer === $d5b33d7c30034067$export$8d0a61916cc26abb ? extension.COMPRESSED_SRGB8_ALPHA8_ETC2_EAC : extension.COMPRESSED_RGBA8_ETC2_EAC;
            } else return null;
        }
        // ASTC
        if (p === $d5b33d7c30034067$export$dc5570b4a2b92d48 || p === $d5b33d7c30034067$export$68880cd325f8b2fb || p === $d5b33d7c30034067$export$7d2c0be323373d95 || p === $d5b33d7c30034067$export$22b52da301fc3a3e || p === $d5b33d7c30034067$export$c009e2cb4a66485e || p === $d5b33d7c30034067$export$118fff5afa255b63 || p === $d5b33d7c30034067$export$120713c829ae0667 || p === $d5b33d7c30034067$export$c79eeabbf53313e9 || p === $d5b33d7c30034067$export$443cf6567cdd6424 || p === $d5b33d7c30034067$export$6573984fc9840780 || p === $d5b33d7c30034067$export$e7aee563f30091de || p === $d5b33d7c30034067$export$2eb8634622ddeab7 || p === $d5b33d7c30034067$export$202b1ce7b5d25742 || p === $d5b33d7c30034067$export$18ab77abd087e467) {
            extension = extensions.get('WEBGL_compressed_texture_astc');
            if (extension !== null) {
                if (p === $d5b33d7c30034067$export$dc5570b4a2b92d48) return transfer === $d5b33d7c30034067$export$8d0a61916cc26abb ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_4x4_KHR : extension.COMPRESSED_RGBA_ASTC_4x4_KHR;
                if (p === $d5b33d7c30034067$export$68880cd325f8b2fb) return transfer === $d5b33d7c30034067$export$8d0a61916cc26abb ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_5x4_KHR : extension.COMPRESSED_RGBA_ASTC_5x4_KHR;
                if (p === $d5b33d7c30034067$export$7d2c0be323373d95) return transfer === $d5b33d7c30034067$export$8d0a61916cc26abb ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_5x5_KHR : extension.COMPRESSED_RGBA_ASTC_5x5_KHR;
                if (p === $d5b33d7c30034067$export$22b52da301fc3a3e) return transfer === $d5b33d7c30034067$export$8d0a61916cc26abb ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_6x5_KHR : extension.COMPRESSED_RGBA_ASTC_6x5_KHR;
                if (p === $d5b33d7c30034067$export$c009e2cb4a66485e) return transfer === $d5b33d7c30034067$export$8d0a61916cc26abb ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_6x6_KHR : extension.COMPRESSED_RGBA_ASTC_6x6_KHR;
                if (p === $d5b33d7c30034067$export$118fff5afa255b63) return transfer === $d5b33d7c30034067$export$8d0a61916cc26abb ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_8x5_KHR : extension.COMPRESSED_RGBA_ASTC_8x5_KHR;
                if (p === $d5b33d7c30034067$export$120713c829ae0667) return transfer === $d5b33d7c30034067$export$8d0a61916cc26abb ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_8x6_KHR : extension.COMPRESSED_RGBA_ASTC_8x6_KHR;
                if (p === $d5b33d7c30034067$export$c79eeabbf53313e9) return transfer === $d5b33d7c30034067$export$8d0a61916cc26abb ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_8x8_KHR : extension.COMPRESSED_RGBA_ASTC_8x8_KHR;
                if (p === $d5b33d7c30034067$export$443cf6567cdd6424) return transfer === $d5b33d7c30034067$export$8d0a61916cc26abb ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_10x5_KHR : extension.COMPRESSED_RGBA_ASTC_10x5_KHR;
                if (p === $d5b33d7c30034067$export$6573984fc9840780) return transfer === $d5b33d7c30034067$export$8d0a61916cc26abb ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_10x6_KHR : extension.COMPRESSED_RGBA_ASTC_10x6_KHR;
                if (p === $d5b33d7c30034067$export$e7aee563f30091de) return transfer === $d5b33d7c30034067$export$8d0a61916cc26abb ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_10x8_KHR : extension.COMPRESSED_RGBA_ASTC_10x8_KHR;
                if (p === $d5b33d7c30034067$export$2eb8634622ddeab7) return transfer === $d5b33d7c30034067$export$8d0a61916cc26abb ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_10x10_KHR : extension.COMPRESSED_RGBA_ASTC_10x10_KHR;
                if (p === $d5b33d7c30034067$export$202b1ce7b5d25742) return transfer === $d5b33d7c30034067$export$8d0a61916cc26abb ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_12x10_KHR : extension.COMPRESSED_RGBA_ASTC_12x10_KHR;
                if (p === $d5b33d7c30034067$export$18ab77abd087e467) return transfer === $d5b33d7c30034067$export$8d0a61916cc26abb ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_12x12_KHR : extension.COMPRESSED_RGBA_ASTC_12x12_KHR;
            } else return null;
        }
        // BPTC
        if (p === $d5b33d7c30034067$export$ce40b115e188bc81 || p === $d5b33d7c30034067$export$d279c5c4bac5121e || p === $d5b33d7c30034067$export$cde52d17225fdbd3) {
            extension = extensions.get('EXT_texture_compression_bptc');
            if (extension !== null) {
                if (p === $d5b33d7c30034067$export$ce40b115e188bc81) return transfer === $d5b33d7c30034067$export$8d0a61916cc26abb ? extension.COMPRESSED_SRGB_ALPHA_BPTC_UNORM_EXT : extension.COMPRESSED_RGBA_BPTC_UNORM_EXT;
                if (p === $d5b33d7c30034067$export$d279c5c4bac5121e) return extension.COMPRESSED_RGB_BPTC_SIGNED_FLOAT_EXT;
                if (p === $d5b33d7c30034067$export$cde52d17225fdbd3) return extension.COMPRESSED_RGB_BPTC_UNSIGNED_FLOAT_EXT;
            } else return null;
        }
        // RGTC
        if (p === $d5b33d7c30034067$export$b1688df4c4c21670 || p === $d5b33d7c30034067$export$fc15e5d8261eed58 || p === $d5b33d7c30034067$export$d220f6ade8463a0f || p === $d5b33d7c30034067$export$768646d09dc1b6ef) {
            extension = extensions.get('EXT_texture_compression_rgtc');
            if (extension !== null) {
                if (p === $d5b33d7c30034067$export$ce40b115e188bc81) return extension.COMPRESSED_RED_RGTC1_EXT;
                if (p === $d5b33d7c30034067$export$fc15e5d8261eed58) return extension.COMPRESSED_SIGNED_RED_RGTC1_EXT;
                if (p === $d5b33d7c30034067$export$d220f6ade8463a0f) return extension.COMPRESSED_RED_GREEN_RGTC2_EXT;
                if (p === $d5b33d7c30034067$export$768646d09dc1b6ef) return extension.COMPRESSED_SIGNED_RED_GREEN_RGTC2_EXT;
            } else return null;
        }
        //
        if (p === $d5b33d7c30034067$export$6c8ea339bfab1301) return gl.UNSIGNED_INT_24_8;
        // if "p" can't be resolved, assume the user defines a WebGL constant as a string (fallback/workaround for packed RGB formats)
        return gl[p] !== undefined ? gl[p] : null;
    }
    return {
        convert: convert
    };
}
class $d5b33d7c30034067$export$56b937d9e5581166 extends $d5b33d7c30034067$export$74e4ae24825f68d7 {
    constructor(array = []){
        super();
        this.isArrayCamera = true;
        this.cameras = array;
    }
}
class $d5b33d7c30034067$export$eb2fcfdbd7ba97d4 extends $d5b33d7c30034067$export$e4dd07dff30cc924 {
    constructor(){
        super();
        this.isGroup = true;
        this.type = 'Group';
    }
}
const $d5b33d7c30034067$var$_moveEvent = {
    type: 'move'
};
class $d5b33d7c30034067$var$WebXRController {
    constructor(){
        this._targetRay = null;
        this._grip = null;
        this._hand = null;
    }
    getHandSpace() {
        if (this._hand === null) {
            this._hand = new $d5b33d7c30034067$export$eb2fcfdbd7ba97d4();
            this._hand.matrixAutoUpdate = false;
            this._hand.visible = false;
            this._hand.joints = {};
            this._hand.inputState = {
                pinching: false
            };
        }
        return this._hand;
    }
    getTargetRaySpace() {
        if (this._targetRay === null) {
            this._targetRay = new $d5b33d7c30034067$export$eb2fcfdbd7ba97d4();
            this._targetRay.matrixAutoUpdate = false;
            this._targetRay.visible = false;
            this._targetRay.hasLinearVelocity = false;
            this._targetRay.linearVelocity = new $d5b33d7c30034067$export$64b5c384219d3699();
            this._targetRay.hasAngularVelocity = false;
            this._targetRay.angularVelocity = new $d5b33d7c30034067$export$64b5c384219d3699();
        }
        return this._targetRay;
    }
    getGripSpace() {
        if (this._grip === null) {
            this._grip = new $d5b33d7c30034067$export$eb2fcfdbd7ba97d4();
            this._grip.matrixAutoUpdate = false;
            this._grip.visible = false;
            this._grip.hasLinearVelocity = false;
            this._grip.linearVelocity = new $d5b33d7c30034067$export$64b5c384219d3699();
            this._grip.hasAngularVelocity = false;
            this._grip.angularVelocity = new $d5b33d7c30034067$export$64b5c384219d3699();
        }
        return this._grip;
    }
    dispatchEvent(event) {
        if (this._targetRay !== null) this._targetRay.dispatchEvent(event);
        if (this._grip !== null) this._grip.dispatchEvent(event);
        if (this._hand !== null) this._hand.dispatchEvent(event);
        return this;
    }
    connect(inputSource) {
        if (inputSource && inputSource.hand) {
            const hand = this._hand;
            if (hand) for (const inputjoint of inputSource.hand.values())// Initialize hand with joints when connected
            this._getHandJoint(hand, inputjoint);
        }
        this.dispatchEvent({
            type: 'connected',
            data: inputSource
        });
        return this;
    }
    disconnect(inputSource) {
        this.dispatchEvent({
            type: 'disconnected',
            data: inputSource
        });
        if (this._targetRay !== null) this._targetRay.visible = false;
        if (this._grip !== null) this._grip.visible = false;
        if (this._hand !== null) this._hand.visible = false;
        return this;
    }
    update(inputSource, frame, referenceSpace) {
        let inputPose = null;
        let gripPose = null;
        let handPose = null;
        const targetRay = this._targetRay;
        const grip = this._grip;
        const hand = this._hand;
        if (inputSource && frame.session.visibilityState !== 'visible-blurred') {
            if (hand && inputSource.hand) {
                handPose = true;
                for (const inputjoint of inputSource.hand.values()){
                    // Update the joints groups with the XRJoint poses
                    const jointPose = frame.getJointPose(inputjoint, referenceSpace);
                    // The transform of this joint will be updated with the joint pose on each frame
                    const joint = this._getHandJoint(hand, inputjoint);
                    if (jointPose !== null) {
                        joint.matrix.fromArray(jointPose.transform.matrix);
                        joint.matrix.decompose(joint.position, joint.rotation, joint.scale);
                        joint.matrixWorldNeedsUpdate = true;
                        joint.jointRadius = jointPose.radius;
                    }
                    joint.visible = jointPose !== null;
                }
                // Custom events
                // Check pinchz
                const indexTip = hand.joints['index-finger-tip'];
                const thumbTip = hand.joints['thumb-tip'];
                const distance = indexTip.position.distanceTo(thumbTip.position);
                const distanceToPinch = 0.02;
                const threshold = 0.005;
                if (hand.inputState.pinching && distance > distanceToPinch + threshold) {
                    hand.inputState.pinching = false;
                    this.dispatchEvent({
                        type: 'pinchend',
                        handedness: inputSource.handedness,
                        target: this
                    });
                } else if (!hand.inputState.pinching && distance <= distanceToPinch - threshold) {
                    hand.inputState.pinching = true;
                    this.dispatchEvent({
                        type: 'pinchstart',
                        handedness: inputSource.handedness,
                        target: this
                    });
                }
            } else if (grip !== null && inputSource.gripSpace) {
                gripPose = frame.getPose(inputSource.gripSpace, referenceSpace);
                if (gripPose !== null) {
                    grip.matrix.fromArray(gripPose.transform.matrix);
                    grip.matrix.decompose(grip.position, grip.rotation, grip.scale);
                    grip.matrixWorldNeedsUpdate = true;
                    if (gripPose.linearVelocity) {
                        grip.hasLinearVelocity = true;
                        grip.linearVelocity.copy(gripPose.linearVelocity);
                    } else grip.hasLinearVelocity = false;
                    if (gripPose.angularVelocity) {
                        grip.hasAngularVelocity = true;
                        grip.angularVelocity.copy(gripPose.angularVelocity);
                    } else grip.hasAngularVelocity = false;
                }
            }
            if (targetRay !== null) {
                inputPose = frame.getPose(inputSource.targetRaySpace, referenceSpace);
                // Some runtimes (namely Vive Cosmos with Vive OpenXR Runtime) have only grip space and ray space is equal to it
                if (inputPose === null && gripPose !== null) inputPose = gripPose;
                if (inputPose !== null) {
                    targetRay.matrix.fromArray(inputPose.transform.matrix);
                    targetRay.matrix.decompose(targetRay.position, targetRay.rotation, targetRay.scale);
                    targetRay.matrixWorldNeedsUpdate = true;
                    if (inputPose.linearVelocity) {
                        targetRay.hasLinearVelocity = true;
                        targetRay.linearVelocity.copy(inputPose.linearVelocity);
                    } else targetRay.hasLinearVelocity = false;
                    if (inputPose.angularVelocity) {
                        targetRay.hasAngularVelocity = true;
                        targetRay.angularVelocity.copy(inputPose.angularVelocity);
                    } else targetRay.hasAngularVelocity = false;
                    this.dispatchEvent($d5b33d7c30034067$var$_moveEvent);
                }
            }
        }
        if (targetRay !== null) targetRay.visible = inputPose !== null;
        if (grip !== null) grip.visible = gripPose !== null;
        if (hand !== null) hand.visible = handPose !== null;
        return this;
    }
    // private method
    _getHandJoint(hand, inputjoint) {
        if (hand.joints[inputjoint.jointName] === undefined) {
            const joint = new $d5b33d7c30034067$export$eb2fcfdbd7ba97d4();
            joint.matrixAutoUpdate = false;
            joint.visible = false;
            hand.joints[inputjoint.jointName] = joint;
            hand.add(joint);
        }
        return hand.joints[inputjoint.jointName];
    }
}
const $d5b33d7c30034067$var$_occlusion_vertex = `
void main() {

	gl_Position = vec4( position, 1.0 );

}`;
const $d5b33d7c30034067$var$_occlusion_fragment = `
uniform sampler2DArray depthColor;
uniform float depthWidth;
uniform float depthHeight;

void main() {

	vec2 coord = vec2( gl_FragCoord.x / depthWidth, gl_FragCoord.y / depthHeight );

	if ( coord.x >= 1.0 ) {

		gl_FragDepth = texture( depthColor, vec3( coord.x - 1.0, coord.y, 1 ) ).r;

	} else {

		gl_FragDepth = texture( depthColor, vec3( coord.x, coord.y, 0 ) ).r;

	}

}`;
class $d5b33d7c30034067$var$WebXRDepthSensing {
    constructor(){
        this.texture = null;
        this.mesh = null;
        this.depthNear = 0;
        this.depthFar = 0;
    }
    init(renderer, depthData, renderState) {
        if (this.texture === null) {
            const texture = new $d5b33d7c30034067$export$5431306cf43de24a();
            const texProps = renderer.properties.get(texture);
            texProps.__webglTexture = depthData.texture;
            if (depthData.depthNear != renderState.depthNear || depthData.depthFar != renderState.depthFar) {
                this.depthNear = depthData.depthNear;
                this.depthFar = depthData.depthFar;
            }
            this.texture = texture;
        }
    }
    getMesh(cameraXR) {
        if (this.texture !== null) {
            if (this.mesh === null) {
                const viewport = cameraXR.cameras[0].viewport;
                const material = new $d5b33d7c30034067$export$83c7d75d550a8b0d({
                    vertexShader: $d5b33d7c30034067$var$_occlusion_vertex,
                    fragmentShader: $d5b33d7c30034067$var$_occlusion_fragment,
                    uniforms: {
                        depthColor: {
                            value: this.texture
                        },
                        depthWidth: {
                            value: viewport.z
                        },
                        depthHeight: {
                            value: viewport.w
                        }
                    }
                });
                this.mesh = new $d5b33d7c30034067$export$e176487c05830cc5(new $d5b33d7c30034067$export$967d831af31f69ce(20, 20), material);
            }
        }
        return this.mesh;
    }
    reset() {
        this.texture = null;
        this.mesh = null;
    }
    getDepthTexture() {
        return this.texture;
    }
}
class $d5b33d7c30034067$var$WebXRManager extends $d5b33d7c30034067$export$ec8b666c5fe2c75a {
    constructor(renderer, gl){
        super();
        const scope = this;
        let session = null;
        let framebufferScaleFactor = 1.0;
        let referenceSpace = null;
        let referenceSpaceType = 'local-floor';
        // Set default foveation to maximum.
        let foveation = 1.0;
        let customReferenceSpace = null;
        let pose = null;
        let glBinding = null;
        let glProjLayer = null;
        let glBaseLayer = null;
        let xrFrame = null;
        const depthSensing = new $d5b33d7c30034067$var$WebXRDepthSensing();
        const attributes = gl.getContextAttributes();
        let initialRenderTarget = null;
        let newRenderTarget = null;
        const controllers = [];
        const controllerInputSources = [];
        const currentSize = new $d5b33d7c30034067$export$c977b3e384af9ae1();
        let currentPixelRatio = null;
        //
        const cameraL = new $d5b33d7c30034067$export$74e4ae24825f68d7();
        cameraL.viewport = new $d5b33d7c30034067$export$fa7daccca11cdbe3();
        const cameraR = new $d5b33d7c30034067$export$74e4ae24825f68d7();
        cameraR.viewport = new $d5b33d7c30034067$export$fa7daccca11cdbe3();
        const cameras = [
            cameraL,
            cameraR
        ];
        const cameraXR = new $d5b33d7c30034067$export$56b937d9e5581166();
        let _currentDepthNear = null;
        let _currentDepthFar = null;
        //
        this.cameraAutoUpdate = true;
        this.enabled = false;
        this.isPresenting = false;
        this.getController = function(index) {
            let controller = controllers[index];
            if (controller === undefined) {
                controller = new $d5b33d7c30034067$var$WebXRController();
                controllers[index] = controller;
            }
            return controller.getTargetRaySpace();
        };
        this.getControllerGrip = function(index) {
            let controller = controllers[index];
            if (controller === undefined) {
                controller = new $d5b33d7c30034067$var$WebXRController();
                controllers[index] = controller;
            }
            return controller.getGripSpace();
        };
        this.getHand = function(index) {
            let controller = controllers[index];
            if (controller === undefined) {
                controller = new $d5b33d7c30034067$var$WebXRController();
                controllers[index] = controller;
            }
            return controller.getHandSpace();
        };
        //
        function onSessionEvent(event) {
            const controllerIndex = controllerInputSources.indexOf(event.inputSource);
            if (controllerIndex === -1) return;
            const controller = controllers[controllerIndex];
            if (controller !== undefined) {
                controller.update(event.inputSource, event.frame, customReferenceSpace || referenceSpace);
                controller.dispatchEvent({
                    type: event.type,
                    data: event.inputSource
                });
            }
        }
        function onSessionEnd() {
            session.removeEventListener('select', onSessionEvent);
            session.removeEventListener('selectstart', onSessionEvent);
            session.removeEventListener('selectend', onSessionEvent);
            session.removeEventListener('squeeze', onSessionEvent);
            session.removeEventListener('squeezestart', onSessionEvent);
            session.removeEventListener('squeezeend', onSessionEvent);
            session.removeEventListener('end', onSessionEnd);
            session.removeEventListener('inputsourceschange', onInputSourcesChange);
            for(let i = 0; i < controllers.length; i++){
                const inputSource = controllerInputSources[i];
                if (inputSource === null) continue;
                controllerInputSources[i] = null;
                controllers[i].disconnect(inputSource);
            }
            _currentDepthNear = null;
            _currentDepthFar = null;
            depthSensing.reset();
            // restore framebuffer/rendering state
            renderer.setRenderTarget(initialRenderTarget);
            glBaseLayer = null;
            glProjLayer = null;
            glBinding = null;
            session = null;
            newRenderTarget = null;
            //
            animation.stop();
            scope.isPresenting = false;
            renderer.setPixelRatio(currentPixelRatio);
            renderer.setSize(currentSize.width, currentSize.height, false);
            scope.dispatchEvent({
                type: 'sessionend'
            });
        }
        this.setFramebufferScaleFactor = function(value) {
            framebufferScaleFactor = value;
            if (scope.isPresenting === true) console.warn('THREE.WebXRManager: Cannot change framebuffer scale while presenting.');
        };
        this.setReferenceSpaceType = function(value) {
            referenceSpaceType = value;
            if (scope.isPresenting === true) console.warn('THREE.WebXRManager: Cannot change reference space type while presenting.');
        };
        this.getReferenceSpace = function() {
            return customReferenceSpace || referenceSpace;
        };
        this.setReferenceSpace = function(space) {
            customReferenceSpace = space;
        };
        this.getBaseLayer = function() {
            return glProjLayer !== null ? glProjLayer : glBaseLayer;
        };
        this.getBinding = function() {
            return glBinding;
        };
        this.getFrame = function() {
            return xrFrame;
        };
        this.getSession = function() {
            return session;
        };
        this.setSession = async function(value) {
            session = value;
            if (session !== null) {
                initialRenderTarget = renderer.getRenderTarget();
                session.addEventListener('select', onSessionEvent);
                session.addEventListener('selectstart', onSessionEvent);
                session.addEventListener('selectend', onSessionEvent);
                session.addEventListener('squeeze', onSessionEvent);
                session.addEventListener('squeezestart', onSessionEvent);
                session.addEventListener('squeezeend', onSessionEvent);
                session.addEventListener('end', onSessionEnd);
                session.addEventListener('inputsourceschange', onInputSourcesChange);
                if (attributes.xrCompatible !== true) await gl.makeXRCompatible();
                currentPixelRatio = renderer.getPixelRatio();
                renderer.getSize(currentSize);
                if (session.renderState.layers === undefined) {
                    const layerInit = {
                        antialias: attributes.antialias,
                        alpha: true,
                        depth: attributes.depth,
                        stencil: attributes.stencil,
                        framebufferScaleFactor: framebufferScaleFactor
                    };
                    glBaseLayer = new XRWebGLLayer(session, gl, layerInit);
                    session.updateRenderState({
                        baseLayer: glBaseLayer
                    });
                    renderer.setPixelRatio(1);
                    renderer.setSize(glBaseLayer.framebufferWidth, glBaseLayer.framebufferHeight, false);
                    newRenderTarget = new $d5b33d7c30034067$export$3c052beb2e51e23f(glBaseLayer.framebufferWidth, glBaseLayer.framebufferHeight, {
                        format: $d5b33d7c30034067$export$3f8bb04b555a363c,
                        type: $d5b33d7c30034067$export$2e8ce08d3f6f5e10,
                        colorSpace: renderer.outputColorSpace,
                        stencilBuffer: attributes.stencil
                    });
                } else {
                    let depthFormat = null;
                    let depthType = null;
                    let glDepthFormat = null;
                    if (attributes.depth) {
                        glDepthFormat = attributes.stencil ? gl.DEPTH24_STENCIL8 : gl.DEPTH_COMPONENT24;
                        depthFormat = attributes.stencil ? $d5b33d7c30034067$export$1e113ac2d0905829 : $d5b33d7c30034067$export$c1b6b5136be58045;
                        depthType = attributes.stencil ? $d5b33d7c30034067$export$6c8ea339bfab1301 : $d5b33d7c30034067$export$c3c7fc4518ebba96;
                    }
                    const projectionlayerInit = {
                        colorFormat: gl.RGBA8,
                        depthFormat: glDepthFormat,
                        scaleFactor: framebufferScaleFactor
                    };
                    glBinding = new XRWebGLBinding(session, gl);
                    glProjLayer = glBinding.createProjectionLayer(projectionlayerInit);
                    session.updateRenderState({
                        layers: [
                            glProjLayer
                        ]
                    });
                    renderer.setPixelRatio(1);
                    renderer.setSize(glProjLayer.textureWidth, glProjLayer.textureHeight, false);
                    newRenderTarget = new $d5b33d7c30034067$export$3c052beb2e51e23f(glProjLayer.textureWidth, glProjLayer.textureHeight, {
                        format: $d5b33d7c30034067$export$3f8bb04b555a363c,
                        type: $d5b33d7c30034067$export$2e8ce08d3f6f5e10,
                        depthTexture: new $d5b33d7c30034067$export$fc830aa069cc8c2f(glProjLayer.textureWidth, glProjLayer.textureHeight, depthType, undefined, undefined, undefined, undefined, undefined, undefined, depthFormat),
                        stencilBuffer: attributes.stencil,
                        colorSpace: renderer.outputColorSpace,
                        samples: attributes.antialias ? 4 : 0,
                        resolveDepthBuffer: glProjLayer.ignoreDepthValues === false
                    });
                }
                newRenderTarget.isXRRenderTarget = true; // TODO Remove this when possible, see #23278
                this.setFoveation(foveation);
                customReferenceSpace = null;
                referenceSpace = await session.requestReferenceSpace(referenceSpaceType);
                animation.setContext(session);
                animation.start();
                scope.isPresenting = true;
                scope.dispatchEvent({
                    type: 'sessionstart'
                });
            }
        };
        this.getEnvironmentBlendMode = function() {
            if (session !== null) return session.environmentBlendMode;
        };
        this.getDepthTexture = function() {
            return depthSensing.getDepthTexture();
        };
        function onInputSourcesChange(event) {
            // Notify disconnected
            for(let i = 0; i < event.removed.length; i++){
                const inputSource = event.removed[i];
                const index = controllerInputSources.indexOf(inputSource);
                if (index >= 0) {
                    controllerInputSources[index] = null;
                    controllers[index].disconnect(inputSource);
                }
            }
            // Notify connected
            for(let i = 0; i < event.added.length; i++){
                const inputSource = event.added[i];
                let controllerIndex = controllerInputSources.indexOf(inputSource);
                if (controllerIndex === -1) {
                    // Assign input source a controller that currently has no input source
                    for(let i = 0; i < controllers.length; i++){
                        if (i >= controllerInputSources.length) {
                            controllerInputSources.push(inputSource);
                            controllerIndex = i;
                            break;
                        } else if (controllerInputSources[i] === null) {
                            controllerInputSources[i] = inputSource;
                            controllerIndex = i;
                            break;
                        }
                    }
                    // If all controllers do currently receive input we ignore new ones
                    if (controllerIndex === -1) break;
                }
                const controller = controllers[controllerIndex];
                if (controller) controller.connect(inputSource);
            }
        }
        //
        const cameraLPos = new $d5b33d7c30034067$export$64b5c384219d3699();
        const cameraRPos = new $d5b33d7c30034067$export$64b5c384219d3699();
        /**
		 * Assumes 2 cameras that are parallel and share an X-axis, and that
		 * the cameras' projection and world matrices have already been set.
		 * And that near and far planes are identical for both cameras.
		 * Visualization of this technique: https://computergraphics.stackexchange.com/a/4765
		 */ function setProjectionFromUnion(camera, cameraL, cameraR) {
            cameraLPos.setFromMatrixPosition(cameraL.matrixWorld);
            cameraRPos.setFromMatrixPosition(cameraR.matrixWorld);
            const ipd = cameraLPos.distanceTo(cameraRPos);
            const projL = cameraL.projectionMatrix.elements;
            const projR = cameraR.projectionMatrix.elements;
            // VR systems will have identical far and near planes, and
            // most likely identical top and bottom frustum extents.
            // Use the left camera for these values.
            const near = projL[14] / (projL[10] - 1);
            const far = projL[14] / (projL[10] + 1);
            const topFov = (projL[9] + 1) / projL[5];
            const bottomFov = (projL[9] - 1) / projL[5];
            const leftFov = (projL[8] - 1) / projL[0];
            const rightFov = (projR[8] + 1) / projR[0];
            const left = near * leftFov;
            const right = near * rightFov;
            // Calculate the new camera's position offset from the
            // left camera. xOffset should be roughly half `ipd`.
            const zOffset = ipd / (-leftFov + rightFov);
            const xOffset = zOffset * -leftFov;
            // TODO: Better way to apply this offset?
            cameraL.matrixWorld.decompose(camera.position, camera.quaternion, camera.scale);
            camera.translateX(xOffset);
            camera.translateZ(zOffset);
            camera.matrixWorld.compose(camera.position, camera.quaternion, camera.scale);
            camera.matrixWorldInverse.copy(camera.matrixWorld).invert();
            // Check if the projection uses an infinite far plane.
            if (projL[10] === -1) {
                // Use the projection matrix from the left eye.
                // The camera offset is sufficient to include the view volumes
                // of both eyes (assuming symmetric projections).
                camera.projectionMatrix.copy(cameraL.projectionMatrix);
                camera.projectionMatrixInverse.copy(cameraL.projectionMatrixInverse);
            } else {
                // Find the union of the frustum values of the cameras and scale
                // the values so that the near plane's position does not change in world space,
                // although must now be relative to the new union camera.
                const near2 = near + zOffset;
                const far2 = far + zOffset;
                const left2 = left - xOffset;
                const right2 = right + (ipd - xOffset);
                const top2 = topFov * far / far2 * near2;
                const bottom2 = bottomFov * far / far2 * near2;
                camera.projectionMatrix.makePerspective(left2, right2, top2, bottom2, near2, far2);
                camera.projectionMatrixInverse.copy(camera.projectionMatrix).invert();
            }
        }
        function updateCamera(camera, parent) {
            if (parent === null) camera.matrixWorld.copy(camera.matrix);
            else camera.matrixWorld.multiplyMatrices(parent.matrixWorld, camera.matrix);
            camera.matrixWorldInverse.copy(camera.matrixWorld).invert();
        }
        this.updateCamera = function(camera) {
            if (session === null) return;
            let depthNear = camera.near;
            let depthFar = camera.far;
            if (depthSensing.texture !== null) {
                if (depthSensing.depthNear > 0) depthNear = depthSensing.depthNear;
                if (depthSensing.depthFar > 0) depthFar = depthSensing.depthFar;
            }
            cameraXR.near = cameraR.near = cameraL.near = depthNear;
            cameraXR.far = cameraR.far = cameraL.far = depthFar;
            if (_currentDepthNear !== cameraXR.near || _currentDepthFar !== cameraXR.far) {
                // Note that the new renderState won't apply until the next frame. See #18320
                session.updateRenderState({
                    depthNear: cameraXR.near,
                    depthFar: cameraXR.far
                });
                _currentDepthNear = cameraXR.near;
                _currentDepthFar = cameraXR.far;
            }
            cameraL.layers.mask = camera.layers.mask | 2;
            cameraR.layers.mask = camera.layers.mask | 4;
            cameraXR.layers.mask = cameraL.layers.mask | cameraR.layers.mask;
            const parent = camera.parent;
            const cameras = cameraXR.cameras;
            updateCamera(cameraXR, parent);
            for(let i = 0; i < cameras.length; i++)updateCamera(cameras[i], parent);
            // update projection matrix for proper view frustum culling
            if (cameras.length === 2) setProjectionFromUnion(cameraXR, cameraL, cameraR);
            else // assume single camera setup (AR)
            cameraXR.projectionMatrix.copy(cameraL.projectionMatrix);
            // update user camera and its children
            updateUserCamera(camera, cameraXR, parent);
        };
        function updateUserCamera(camera, cameraXR, parent) {
            if (parent === null) camera.matrix.copy(cameraXR.matrixWorld);
            else {
                camera.matrix.copy(parent.matrixWorld);
                camera.matrix.invert();
                camera.matrix.multiply(cameraXR.matrixWorld);
            }
            camera.matrix.decompose(camera.position, camera.quaternion, camera.scale);
            camera.updateMatrixWorld(true);
            camera.projectionMatrix.copy(cameraXR.projectionMatrix);
            camera.projectionMatrixInverse.copy(cameraXR.projectionMatrixInverse);
            if (camera.isPerspectiveCamera) {
                camera.fov = $d5b33d7c30034067$var$RAD2DEG * 2 * Math.atan(1 / camera.projectionMatrix.elements[5]);
                camera.zoom = 1;
            }
        }
        this.getCamera = function() {
            return cameraXR;
        };
        this.getFoveation = function() {
            if (glProjLayer === null && glBaseLayer === null) return undefined;
            return foveation;
        };
        this.setFoveation = function(value) {
            // 0 = no foveation = full resolution
            // 1 = maximum foveation = the edges render at lower resolution
            foveation = value;
            if (glProjLayer !== null) glProjLayer.fixedFoveation = value;
            if (glBaseLayer !== null && glBaseLayer.fixedFoveation !== undefined) glBaseLayer.fixedFoveation = value;
        };
        this.hasDepthSensing = function() {
            return depthSensing.texture !== null;
        };
        this.getDepthSensingMesh = function() {
            return depthSensing.getMesh(cameraXR);
        };
        // Animation Loop
        let onAnimationFrameCallback = null;
        function onAnimationFrame(time, frame) {
            pose = frame.getViewerPose(customReferenceSpace || referenceSpace);
            xrFrame = frame;
            if (pose !== null) {
                const views = pose.views;
                if (glBaseLayer !== null) {
                    renderer.setRenderTargetFramebuffer(newRenderTarget, glBaseLayer.framebuffer);
                    renderer.setRenderTarget(newRenderTarget);
                }
                let cameraXRNeedsUpdate = false;
                // check if it's necessary to rebuild cameraXR's camera list
                if (views.length !== cameraXR.cameras.length) {
                    cameraXR.cameras.length = 0;
                    cameraXRNeedsUpdate = true;
                }
                for(let i = 0; i < views.length; i++){
                    const view = views[i];
                    let viewport = null;
                    if (glBaseLayer !== null) viewport = glBaseLayer.getViewport(view);
                    else {
                        const glSubImage = glBinding.getViewSubImage(glProjLayer, view);
                        viewport = glSubImage.viewport;
                        // For side-by-side projection, we only produce a single texture for both eyes.
                        if (i === 0) {
                            renderer.setRenderTargetTextures(newRenderTarget, glSubImage.colorTexture, glProjLayer.ignoreDepthValues ? undefined : glSubImage.depthStencilTexture);
                            renderer.setRenderTarget(newRenderTarget);
                        }
                    }
                    let camera = cameras[i];
                    if (camera === undefined) {
                        camera = new $d5b33d7c30034067$export$74e4ae24825f68d7();
                        camera.layers.enable(i);
                        camera.viewport = new $d5b33d7c30034067$export$fa7daccca11cdbe3();
                        cameras[i] = camera;
                    }
                    camera.matrix.fromArray(view.transform.matrix);
                    camera.matrix.decompose(camera.position, camera.quaternion, camera.scale);
                    camera.projectionMatrix.fromArray(view.projectionMatrix);
                    camera.projectionMatrixInverse.copy(camera.projectionMatrix).invert();
                    camera.viewport.set(viewport.x, viewport.y, viewport.width, viewport.height);
                    if (i === 0) {
                        cameraXR.matrix.copy(camera.matrix);
                        cameraXR.matrix.decompose(cameraXR.position, cameraXR.quaternion, cameraXR.scale);
                    }
                    if (cameraXRNeedsUpdate === true) cameraXR.cameras.push(camera);
                }
                //
                const enabledFeatures = session.enabledFeatures;
                if (enabledFeatures && enabledFeatures.includes('depth-sensing')) {
                    const depthData = glBinding.getDepthInformation(views[0]);
                    if (depthData && depthData.isValid && depthData.texture) depthSensing.init(renderer, depthData, session.renderState);
                }
            }
            //
            for(let i = 0; i < controllers.length; i++){
                const inputSource = controllerInputSources[i];
                const controller = controllers[i];
                if (inputSource !== null && controller !== undefined) controller.update(inputSource, frame, customReferenceSpace || referenceSpace);
            }
            if (onAnimationFrameCallback) onAnimationFrameCallback(time, frame);
            if (frame.detectedPlanes) scope.dispatchEvent({
                type: 'planesdetected',
                data: frame
            });
            xrFrame = null;
        }
        const animation = new $d5b33d7c30034067$var$WebGLAnimation();
        animation.setAnimationLoop(onAnimationFrame);
        this.setAnimationLoop = function(callback) {
            onAnimationFrameCallback = callback;
        };
        this.dispose = function() {};
    }
}
const $d5b33d7c30034067$var$_e1 = /*@__PURE__*/ new $d5b33d7c30034067$export$d93cc409a0768c5f();
const $d5b33d7c30034067$var$_m1 = /*@__PURE__*/ new $d5b33d7c30034067$export$2ae72fc923e5eb5();
function $d5b33d7c30034067$var$WebGLMaterials(renderer, properties) {
    function refreshTransformUniform(map, uniform) {
        if (map.matrixAutoUpdate === true) map.updateMatrix();
        uniform.value.copy(map.matrix);
    }
    function refreshFogUniforms(uniforms, fog) {
        fog.color.getRGB(uniforms.fogColor.value, $d5b33d7c30034067$var$getUnlitUniformColorSpace(renderer));
        if (fog.isFog) {
            uniforms.fogNear.value = fog.near;
            uniforms.fogFar.value = fog.far;
        } else if (fog.isFogExp2) uniforms.fogDensity.value = fog.density;
    }
    function refreshMaterialUniforms(uniforms, material, pixelRatio, height, transmissionRenderTarget) {
        if (material.isMeshBasicMaterial) refreshUniformsCommon(uniforms, material);
        else if (material.isMeshLambertMaterial) refreshUniformsCommon(uniforms, material);
        else if (material.isMeshToonMaterial) {
            refreshUniformsCommon(uniforms, material);
            refreshUniformsToon(uniforms, material);
        } else if (material.isMeshPhongMaterial) {
            refreshUniformsCommon(uniforms, material);
            refreshUniformsPhong(uniforms, material);
        } else if (material.isMeshStandardMaterial) {
            refreshUniformsCommon(uniforms, material);
            refreshUniformsStandard(uniforms, material);
            if (material.isMeshPhysicalMaterial) refreshUniformsPhysical(uniforms, material, transmissionRenderTarget);
        } else if (material.isMeshMatcapMaterial) {
            refreshUniformsCommon(uniforms, material);
            refreshUniformsMatcap(uniforms, material);
        } else if (material.isMeshDepthMaterial) refreshUniformsCommon(uniforms, material);
        else if (material.isMeshDistanceMaterial) {
            refreshUniformsCommon(uniforms, material);
            refreshUniformsDistance(uniforms, material);
        } else if (material.isMeshNormalMaterial) refreshUniformsCommon(uniforms, material);
        else if (material.isLineBasicMaterial) {
            refreshUniformsLine(uniforms, material);
            if (material.isLineDashedMaterial) refreshUniformsDash(uniforms, material);
        } else if (material.isPointsMaterial) refreshUniformsPoints(uniforms, material, pixelRatio, height);
        else if (material.isSpriteMaterial) refreshUniformsSprites(uniforms, material);
        else if (material.isShadowMaterial) {
            uniforms.color.value.copy(material.color);
            uniforms.opacity.value = material.opacity;
        } else if (material.isShaderMaterial) material.uniformsNeedUpdate = false; // #15581
    }
    function refreshUniformsCommon(uniforms, material) {
        uniforms.opacity.value = material.opacity;
        if (material.color) uniforms.diffuse.value.copy(material.color);
        if (material.emissive) uniforms.emissive.value.copy(material.emissive).multiplyScalar(material.emissiveIntensity);
        if (material.map) {
            uniforms.map.value = material.map;
            refreshTransformUniform(material.map, uniforms.mapTransform);
        }
        if (material.alphaMap) {
            uniforms.alphaMap.value = material.alphaMap;
            refreshTransformUniform(material.alphaMap, uniforms.alphaMapTransform);
        }
        if (material.bumpMap) {
            uniforms.bumpMap.value = material.bumpMap;
            refreshTransformUniform(material.bumpMap, uniforms.bumpMapTransform);
            uniforms.bumpScale.value = material.bumpScale;
            if (material.side === $d5b33d7c30034067$export$d9f0486e75b5ace) uniforms.bumpScale.value *= -1;
        }
        if (material.normalMap) {
            uniforms.normalMap.value = material.normalMap;
            refreshTransformUniform(material.normalMap, uniforms.normalMapTransform);
            uniforms.normalScale.value.copy(material.normalScale);
            if (material.side === $d5b33d7c30034067$export$d9f0486e75b5ace) uniforms.normalScale.value.negate();
        }
        if (material.displacementMap) {
            uniforms.displacementMap.value = material.displacementMap;
            refreshTransformUniform(material.displacementMap, uniforms.displacementMapTransform);
            uniforms.displacementScale.value = material.displacementScale;
            uniforms.displacementBias.value = material.displacementBias;
        }
        if (material.emissiveMap) {
            uniforms.emissiveMap.value = material.emissiveMap;
            refreshTransformUniform(material.emissiveMap, uniforms.emissiveMapTransform);
        }
        if (material.specularMap) {
            uniforms.specularMap.value = material.specularMap;
            refreshTransformUniform(material.specularMap, uniforms.specularMapTransform);
        }
        if (material.alphaTest > 0) uniforms.alphaTest.value = material.alphaTest;
        const materialProperties = properties.get(material);
        const envMap = materialProperties.envMap;
        const envMapRotation = materialProperties.envMapRotation;
        if (envMap) {
            uniforms.envMap.value = envMap;
            $d5b33d7c30034067$var$_e1.copy(envMapRotation);
            // accommodate left-handed frame
            $d5b33d7c30034067$var$_e1.x *= -1;
            $d5b33d7c30034067$var$_e1.y *= -1;
            $d5b33d7c30034067$var$_e1.z *= -1;
            if (envMap.isCubeTexture && envMap.isRenderTargetTexture === false) {
                // environment maps which are not cube render targets or PMREMs follow a different convention
                $d5b33d7c30034067$var$_e1.y *= -1;
                $d5b33d7c30034067$var$_e1.z *= -1;
            }
            uniforms.envMapRotation.value.setFromMatrix4($d5b33d7c30034067$var$_m1.makeRotationFromEuler($d5b33d7c30034067$var$_e1));
            uniforms.flipEnvMap.value = envMap.isCubeTexture && envMap.isRenderTargetTexture === false ? -1 : 1;
            uniforms.reflectivity.value = material.reflectivity;
            uniforms.ior.value = material.ior;
            uniforms.refractionRatio.value = material.refractionRatio;
        }
        if (material.lightMap) {
            uniforms.lightMap.value = material.lightMap;
            uniforms.lightMapIntensity.value = material.lightMapIntensity;
            refreshTransformUniform(material.lightMap, uniforms.lightMapTransform);
        }
        if (material.aoMap) {
            uniforms.aoMap.value = material.aoMap;
            uniforms.aoMapIntensity.value = material.aoMapIntensity;
            refreshTransformUniform(material.aoMap, uniforms.aoMapTransform);
        }
    }
    function refreshUniformsLine(uniforms, material) {
        uniforms.diffuse.value.copy(material.color);
        uniforms.opacity.value = material.opacity;
        if (material.map) {
            uniforms.map.value = material.map;
            refreshTransformUniform(material.map, uniforms.mapTransform);
        }
    }
    function refreshUniformsDash(uniforms, material) {
        uniforms.dashSize.value = material.dashSize;
        uniforms.totalSize.value = material.dashSize + material.gapSize;
        uniforms.scale.value = material.scale;
    }
    function refreshUniformsPoints(uniforms, material, pixelRatio, height) {
        uniforms.diffuse.value.copy(material.color);
        uniforms.opacity.value = material.opacity;
        uniforms.size.value = material.size * pixelRatio;
        uniforms.scale.value = height * 0.5;
        if (material.map) {
            uniforms.map.value = material.map;
            refreshTransformUniform(material.map, uniforms.uvTransform);
        }
        if (material.alphaMap) {
            uniforms.alphaMap.value = material.alphaMap;
            refreshTransformUniform(material.alphaMap, uniforms.alphaMapTransform);
        }
        if (material.alphaTest > 0) uniforms.alphaTest.value = material.alphaTest;
    }
    function refreshUniformsSprites(uniforms, material) {
        uniforms.diffuse.value.copy(material.color);
        uniforms.opacity.value = material.opacity;
        uniforms.rotation.value = material.rotation;
        if (material.map) {
            uniforms.map.value = material.map;
            refreshTransformUniform(material.map, uniforms.mapTransform);
        }
        if (material.alphaMap) {
            uniforms.alphaMap.value = material.alphaMap;
            refreshTransformUniform(material.alphaMap, uniforms.alphaMapTransform);
        }
        if (material.alphaTest > 0) uniforms.alphaTest.value = material.alphaTest;
    }
    function refreshUniformsPhong(uniforms, material) {
        uniforms.specular.value.copy(material.specular);
        uniforms.shininess.value = Math.max(material.shininess, 1e-4); // to prevent pow( 0.0, 0.0 )
    }
    function refreshUniformsToon(uniforms, material) {
        if (material.gradientMap) uniforms.gradientMap.value = material.gradientMap;
    }
    function refreshUniformsStandard(uniforms, material) {
        uniforms.metalness.value = material.metalness;
        if (material.metalnessMap) {
            uniforms.metalnessMap.value = material.metalnessMap;
            refreshTransformUniform(material.metalnessMap, uniforms.metalnessMapTransform);
        }
        uniforms.roughness.value = material.roughness;
        if (material.roughnessMap) {
            uniforms.roughnessMap.value = material.roughnessMap;
            refreshTransformUniform(material.roughnessMap, uniforms.roughnessMapTransform);
        }
        if (material.envMap) //uniforms.envMap.value = material.envMap; // part of uniforms common
        uniforms.envMapIntensity.value = material.envMapIntensity;
    }
    function refreshUniformsPhysical(uniforms, material, transmissionRenderTarget) {
        uniforms.ior.value = material.ior; // also part of uniforms common
        if (material.sheen > 0) {
            uniforms.sheenColor.value.copy(material.sheenColor).multiplyScalar(material.sheen);
            uniforms.sheenRoughness.value = material.sheenRoughness;
            if (material.sheenColorMap) {
                uniforms.sheenColorMap.value = material.sheenColorMap;
                refreshTransformUniform(material.sheenColorMap, uniforms.sheenColorMapTransform);
            }
            if (material.sheenRoughnessMap) {
                uniforms.sheenRoughnessMap.value = material.sheenRoughnessMap;
                refreshTransformUniform(material.sheenRoughnessMap, uniforms.sheenRoughnessMapTransform);
            }
        }
        if (material.clearcoat > 0) {
            uniforms.clearcoat.value = material.clearcoat;
            uniforms.clearcoatRoughness.value = material.clearcoatRoughness;
            if (material.clearcoatMap) {
                uniforms.clearcoatMap.value = material.clearcoatMap;
                refreshTransformUniform(material.clearcoatMap, uniforms.clearcoatMapTransform);
            }
            if (material.clearcoatRoughnessMap) {
                uniforms.clearcoatRoughnessMap.value = material.clearcoatRoughnessMap;
                refreshTransformUniform(material.clearcoatRoughnessMap, uniforms.clearcoatRoughnessMapTransform);
            }
            if (material.clearcoatNormalMap) {
                uniforms.clearcoatNormalMap.value = material.clearcoatNormalMap;
                refreshTransformUniform(material.clearcoatNormalMap, uniforms.clearcoatNormalMapTransform);
                uniforms.clearcoatNormalScale.value.copy(material.clearcoatNormalScale);
                if (material.side === $d5b33d7c30034067$export$d9f0486e75b5ace) uniforms.clearcoatNormalScale.value.negate();
            }
        }
        if (material.dispersion > 0) uniforms.dispersion.value = material.dispersion;
        if (material.iridescence > 0) {
            uniforms.iridescence.value = material.iridescence;
            uniforms.iridescenceIOR.value = material.iridescenceIOR;
            uniforms.iridescenceThicknessMinimum.value = material.iridescenceThicknessRange[0];
            uniforms.iridescenceThicknessMaximum.value = material.iridescenceThicknessRange[1];
            if (material.iridescenceMap) {
                uniforms.iridescenceMap.value = material.iridescenceMap;
                refreshTransformUniform(material.iridescenceMap, uniforms.iridescenceMapTransform);
            }
            if (material.iridescenceThicknessMap) {
                uniforms.iridescenceThicknessMap.value = material.iridescenceThicknessMap;
                refreshTransformUniform(material.iridescenceThicknessMap, uniforms.iridescenceThicknessMapTransform);
            }
        }
        if (material.transmission > 0) {
            uniforms.transmission.value = material.transmission;
            uniforms.transmissionSamplerMap.value = transmissionRenderTarget.texture;
            uniforms.transmissionSamplerSize.value.set(transmissionRenderTarget.width, transmissionRenderTarget.height);
            if (material.transmissionMap) {
                uniforms.transmissionMap.value = material.transmissionMap;
                refreshTransformUniform(material.transmissionMap, uniforms.transmissionMapTransform);
            }
            uniforms.thickness.value = material.thickness;
            if (material.thicknessMap) {
                uniforms.thicknessMap.value = material.thicknessMap;
                refreshTransformUniform(material.thicknessMap, uniforms.thicknessMapTransform);
            }
            uniforms.attenuationDistance.value = material.attenuationDistance;
            uniforms.attenuationColor.value.copy(material.attenuationColor);
        }
        if (material.anisotropy > 0) {
            uniforms.anisotropyVector.value.set(material.anisotropy * Math.cos(material.anisotropyRotation), material.anisotropy * Math.sin(material.anisotropyRotation));
            if (material.anisotropyMap) {
                uniforms.anisotropyMap.value = material.anisotropyMap;
                refreshTransformUniform(material.anisotropyMap, uniforms.anisotropyMapTransform);
            }
        }
        uniforms.specularIntensity.value = material.specularIntensity;
        uniforms.specularColor.value.copy(material.specularColor);
        if (material.specularColorMap) {
            uniforms.specularColorMap.value = material.specularColorMap;
            refreshTransformUniform(material.specularColorMap, uniforms.specularColorMapTransform);
        }
        if (material.specularIntensityMap) {
            uniforms.specularIntensityMap.value = material.specularIntensityMap;
            refreshTransformUniform(material.specularIntensityMap, uniforms.specularIntensityMapTransform);
        }
    }
    function refreshUniformsMatcap(uniforms, material) {
        if (material.matcap) uniforms.matcap.value = material.matcap;
    }
    function refreshUniformsDistance(uniforms, material) {
        const light = properties.get(material).light;
        uniforms.referencePosition.value.setFromMatrixPosition(light.matrixWorld);
        uniforms.nearDistance.value = light.shadow.camera.near;
        uniforms.farDistance.value = light.shadow.camera.far;
    }
    return {
        refreshFogUniforms: refreshFogUniforms,
        refreshMaterialUniforms: refreshMaterialUniforms
    };
}
function $d5b33d7c30034067$var$WebGLUniformsGroups(gl, info, capabilities, state) {
    let buffers = {};
    let updateList = {};
    let allocatedBindingPoints = [];
    const maxBindingPoints = gl.getParameter(gl.MAX_UNIFORM_BUFFER_BINDINGS); // binding points are global whereas block indices are per shader program
    function bind(uniformsGroup, program) {
        const webglProgram = program.program;
        state.uniformBlockBinding(uniformsGroup, webglProgram);
    }
    function update(uniformsGroup, program) {
        let buffer = buffers[uniformsGroup.id];
        if (buffer === undefined) {
            prepareUniformsGroup(uniformsGroup);
            buffer = createBuffer(uniformsGroup);
            buffers[uniformsGroup.id] = buffer;
            uniformsGroup.addEventListener('dispose', onUniformsGroupsDispose);
        }
        // ensure to update the binding points/block indices mapping for this program
        const webglProgram = program.program;
        state.updateUBOMapping(uniformsGroup, webglProgram);
        // update UBO once per frame
        const frame = info.render.frame;
        if (updateList[uniformsGroup.id] !== frame) {
            updateBufferData(uniformsGroup);
            updateList[uniformsGroup.id] = frame;
        }
    }
    function createBuffer(uniformsGroup) {
        // the setup of an UBO is independent of a particular shader program but global
        const bindingPointIndex = allocateBindingPointIndex();
        uniformsGroup.__bindingPointIndex = bindingPointIndex;
        const buffer = gl.createBuffer();
        const size = uniformsGroup.__size;
        const usage = uniformsGroup.usage;
        gl.bindBuffer(gl.UNIFORM_BUFFER, buffer);
        gl.bufferData(gl.UNIFORM_BUFFER, size, usage);
        gl.bindBuffer(gl.UNIFORM_BUFFER, null);
        gl.bindBufferBase(gl.UNIFORM_BUFFER, bindingPointIndex, buffer);
        return buffer;
    }
    function allocateBindingPointIndex() {
        for(let i = 0; i < maxBindingPoints; i++)if (allocatedBindingPoints.indexOf(i) === -1) {
            allocatedBindingPoints.push(i);
            return i;
        }
        console.error('THREE.WebGLRenderer: Maximum number of simultaneously usable uniforms groups reached.');
        return 0;
    }
    function updateBufferData(uniformsGroup) {
        const buffer = buffers[uniformsGroup.id];
        const uniforms = uniformsGroup.uniforms;
        const cache = uniformsGroup.__cache;
        gl.bindBuffer(gl.UNIFORM_BUFFER, buffer);
        for(let i = 0, il = uniforms.length; i < il; i++){
            const uniformArray = Array.isArray(uniforms[i]) ? uniforms[i] : [
                uniforms[i]
            ];
            for(let j = 0, jl = uniformArray.length; j < jl; j++){
                const uniform = uniformArray[j];
                if (hasUniformChanged(uniform, i, j, cache) === true) {
                    const offset = uniform.__offset;
                    const values = Array.isArray(uniform.value) ? uniform.value : [
                        uniform.value
                    ];
                    let arrayOffset = 0;
                    for(let k = 0; k < values.length; k++){
                        const value = values[k];
                        const info = getUniformSize(value);
                        // TODO add integer and struct support
                        if (typeof value === 'number' || typeof value === 'boolean') {
                            uniform.__data[0] = value;
                            gl.bufferSubData(gl.UNIFORM_BUFFER, offset + arrayOffset, uniform.__data);
                        } else if (value.isMatrix3) {
                            // manually converting 3x3 to 3x4
                            uniform.__data[0] = value.elements[0];
                            uniform.__data[1] = value.elements[1];
                            uniform.__data[2] = value.elements[2];
                            uniform.__data[3] = 0;
                            uniform.__data[4] = value.elements[3];
                            uniform.__data[5] = value.elements[4];
                            uniform.__data[6] = value.elements[5];
                            uniform.__data[7] = 0;
                            uniform.__data[8] = value.elements[6];
                            uniform.__data[9] = value.elements[7];
                            uniform.__data[10] = value.elements[8];
                            uniform.__data[11] = 0;
                        } else {
                            value.toArray(uniform.__data, arrayOffset);
                            arrayOffset += info.storage / Float32Array.BYTES_PER_ELEMENT;
                        }
                    }
                    gl.bufferSubData(gl.UNIFORM_BUFFER, offset, uniform.__data);
                }
            }
        }
        gl.bindBuffer(gl.UNIFORM_BUFFER, null);
    }
    function hasUniformChanged(uniform, index, indexArray, cache) {
        const value = uniform.value;
        const indexString = index + '_' + indexArray;
        if (cache[indexString] === undefined) {
            // cache entry does not exist so far
            if (typeof value === 'number' || typeof value === 'boolean') cache[indexString] = value;
            else cache[indexString] = value.clone();
            return true;
        } else {
            const cachedObject = cache[indexString];
            // compare current value with cached entry
            if (typeof value === 'number' || typeof value === 'boolean') {
                if (cachedObject !== value) {
                    cache[indexString] = value;
                    return true;
                }
            } else if (cachedObject.equals(value) === false) {
                cachedObject.copy(value);
                return true;
            }
        }
        return false;
    }
    function prepareUniformsGroup(uniformsGroup) {
        // determine total buffer size according to the STD140 layout
        // Hint: STD140 is the only supported layout in WebGL 2
        const uniforms = uniformsGroup.uniforms;
        let offset = 0; // global buffer offset in bytes
        const chunkSize = 16; // size of a chunk in bytes
        for(let i = 0, l = uniforms.length; i < l; i++){
            const uniformArray = Array.isArray(uniforms[i]) ? uniforms[i] : [
                uniforms[i]
            ];
            for(let j = 0, jl = uniformArray.length; j < jl; j++){
                const uniform = uniformArray[j];
                const values = Array.isArray(uniform.value) ? uniform.value : [
                    uniform.value
                ];
                for(let k = 0, kl = values.length; k < kl; k++){
                    const value = values[k];
                    const info = getUniformSize(value);
                    const chunkOffset = offset % chunkSize; // offset in the current chunk
                    const chunkPadding = chunkOffset % info.boundary; // required padding to match boundary
                    const chunkStart = chunkOffset + chunkPadding; // the start position in the current chunk for the data
                    offset += chunkPadding;
                    // Check for chunk overflow
                    if (chunkStart !== 0 && chunkSize - chunkStart < info.storage) // Add padding and adjust offset
                    offset += chunkSize - chunkStart;
                    // the following two properties will be used for partial buffer updates
                    uniform.__data = new Float32Array(info.storage / Float32Array.BYTES_PER_ELEMENT);
                    uniform.__offset = offset;
                    // Update the global offset
                    offset += info.storage;
                }
            }
        }
        // ensure correct final padding
        const chunkOffset = offset % chunkSize;
        if (chunkOffset > 0) offset += chunkSize - chunkOffset;
        //
        uniformsGroup.__size = offset;
        uniformsGroup.__cache = {};
        return this;
    }
    function getUniformSize(value) {
        const info = {
            boundary: 0,
            storage: 0 // bytes
        };
        // determine sizes according to STD140
        if (typeof value === 'number' || typeof value === 'boolean') {
            // float/int/bool
            info.boundary = 4;
            info.storage = 4;
        } else if (value.isVector2) {
            // vec2
            info.boundary = 8;
            info.storage = 8;
        } else if (value.isVector3 || value.isColor) {
            // vec3
            info.boundary = 16;
            info.storage = 12; // evil: vec3 must start on a 16-byte boundary but it only consumes 12 bytes
        } else if (value.isVector4) {
            // vec4
            info.boundary = 16;
            info.storage = 16;
        } else if (value.isMatrix3) {
            // mat3 (in STD140 a 3x3 matrix is represented as 3x4)
            info.boundary = 48;
            info.storage = 48;
        } else if (value.isMatrix4) {
            // mat4
            info.boundary = 64;
            info.storage = 64;
        } else if (value.isTexture) console.warn('THREE.WebGLRenderer: Texture samplers can not be part of an uniforms group.');
        else console.warn('THREE.WebGLRenderer: Unsupported uniform value type.', value);
        return info;
    }
    function onUniformsGroupsDispose(event) {
        const uniformsGroup = event.target;
        uniformsGroup.removeEventListener('dispose', onUniformsGroupsDispose);
        const index = allocatedBindingPoints.indexOf(uniformsGroup.__bindingPointIndex);
        allocatedBindingPoints.splice(index, 1);
        gl.deleteBuffer(buffers[uniformsGroup.id]);
        delete buffers[uniformsGroup.id];
        delete updateList[uniformsGroup.id];
    }
    function dispose() {
        for(const id in buffers)gl.deleteBuffer(buffers[id]);
        allocatedBindingPoints = [];
        buffers = {};
        updateList = {};
    }
    return {
        bind: bind,
        update: update,
        dispose: dispose
    };
}
class $d5b33d7c30034067$export$f6cc00ef28d7cf97 {
    constructor(parameters = {}){
        const { canvas: canvas = $d5b33d7c30034067$export$1033a2df66368859(), context: context = null, depth: depth = true, stencil: stencil = false, alpha: alpha = false, antialias: antialias = false, premultipliedAlpha: premultipliedAlpha = true, preserveDrawingBuffer: preserveDrawingBuffer = false, powerPreference: powerPreference = 'default', failIfMajorPerformanceCaveat: failIfMajorPerformanceCaveat = false, reverseDepthBuffer: reverseDepthBuffer = false } = parameters;
        this.isWebGLRenderer = true;
        let _alpha;
        if (context !== null) {
            if (typeof WebGLRenderingContext !== 'undefined' && context instanceof WebGLRenderingContext) throw new Error('THREE.WebGLRenderer: WebGL 1 is not supported since r163.');
            _alpha = context.getContextAttributes().alpha;
        } else _alpha = alpha;
        const uintClearColor = new Uint32Array(4);
        const intClearColor = new Int32Array(4);
        let currentRenderList = null;
        let currentRenderState = null;
        // render() can be called from within a callback triggered by another render.
        // We track this so that the nested render call gets its list and state isolated from the parent render call.
        const renderListStack = [];
        const renderStateStack = [];
        // public properties
        this.domElement = canvas;
        // Debug configuration container
        this.debug = {
            /**
			 * Enables error checking and reporting when shader programs are being compiled
			 * @type {boolean}
			 */ checkShaderErrors: true,
            /**
			 * Callback for custom error reporting.
			 * @type {?Function}
			 */ onShaderError: null
        };
        // clearing
        this.autoClear = true;
        this.autoClearColor = true;
        this.autoClearDepth = true;
        this.autoClearStencil = true;
        // scene graph
        this.sortObjects = true;
        // user-defined clipping
        this.clippingPlanes = [];
        this.localClippingEnabled = false;
        // physically based shading
        this._outputColorSpace = $d5b33d7c30034067$export$561f394b24edfcaa;
        // tone mapping
        this.toneMapping = $d5b33d7c30034067$export$9fcb6b4294603b2;
        this.toneMappingExposure = 1.0;
        // internal properties
        const _this = this;
        let _isContextLost = false;
        // internal state cache
        let _currentActiveCubeFace = 0;
        let _currentActiveMipmapLevel = 0;
        let _currentRenderTarget = null;
        let _currentMaterialId = -1;
        let _currentCamera = null;
        const _currentViewport = new $d5b33d7c30034067$export$fa7daccca11cdbe3();
        const _currentScissor = new $d5b33d7c30034067$export$fa7daccca11cdbe3();
        let _currentScissorTest = null;
        const _currentClearColor = new $d5b33d7c30034067$export$892596cec99bc70e(0x000000);
        let _currentClearAlpha = 0;
        //
        let _width = canvas.width;
        let _height = canvas.height;
        let _pixelRatio = 1;
        let _opaqueSort = null;
        let _transparentSort = null;
        const _viewport = new $d5b33d7c30034067$export$fa7daccca11cdbe3(0, 0, _width, _height);
        const _scissor = new $d5b33d7c30034067$export$fa7daccca11cdbe3(0, 0, _width, _height);
        let _scissorTest = false;
        // frustum
        const _frustum = new $d5b33d7c30034067$export$35efe6f4c85463d2();
        // clipping
        let _clippingEnabled = false;
        let _localClippingEnabled = false;
        // camera matrices cache
        const _currentProjectionMatrix = new $d5b33d7c30034067$export$2ae72fc923e5eb5();
        const _projScreenMatrix = new $d5b33d7c30034067$export$2ae72fc923e5eb5();
        const _vector3 = new $d5b33d7c30034067$export$64b5c384219d3699();
        const _vector4 = new $d5b33d7c30034067$export$fa7daccca11cdbe3();
        const _emptyScene = {
            background: null,
            fog: null,
            environment: null,
            overrideMaterial: null,
            isScene: true
        };
        let _renderBackground = false;
        function getTargetPixelRatio() {
            return _currentRenderTarget === null ? _pixelRatio : 1;
        }
        // initialize
        let _gl = context;
        function getContext(contextName, contextAttributes) {
            return canvas.getContext(contextName, contextAttributes);
        }
        try {
            const contextAttributes = {
                alpha: true,
                depth: depth,
                stencil: stencil,
                antialias: antialias,
                premultipliedAlpha: premultipliedAlpha,
                preserveDrawingBuffer: preserveDrawingBuffer,
                powerPreference: powerPreference,
                failIfMajorPerformanceCaveat: failIfMajorPerformanceCaveat
            };
            // OffscreenCanvas does not have setAttribute, see #22811
            if ('setAttribute' in canvas) canvas.setAttribute('data-engine', `three.js r${$d5b33d7c30034067$export$3545e07a80636437}`);
            // event listeners must be registered before WebGL context is created, see #12753
            canvas.addEventListener('webglcontextlost', onContextLost, false);
            canvas.addEventListener('webglcontextrestored', onContextRestore, false);
            canvas.addEventListener('webglcontextcreationerror', onContextCreationError, false);
            if (_gl === null) {
                const contextName = 'webgl2';
                _gl = getContext(contextName, contextAttributes);
                if (_gl === null) {
                    if (getContext(contextName)) throw new Error('Error creating WebGL context with your selected attributes.');
                    else throw new Error('Error creating WebGL context.');
                }
            }
        } catch (error) {
            console.error('THREE.WebGLRenderer: ' + error.message);
            throw error;
        }
        let extensions, capabilities, state, info;
        let properties, textures, cubemaps, cubeuvmaps, attributes, geometries, objects;
        let programCache, materials, renderLists, renderStates, clipping, shadowMap;
        let background, morphtargets, bufferRenderer, indexedBufferRenderer;
        let utils, bindingStates, uniformsGroups;
        function initGLContext() {
            extensions = new $d5b33d7c30034067$var$WebGLExtensions(_gl);
            extensions.init();
            utils = new $d5b33d7c30034067$export$ddaebcad857649a8(_gl, extensions);
            capabilities = new $d5b33d7c30034067$var$WebGLCapabilities(_gl, extensions, parameters, utils);
            state = new $d5b33d7c30034067$var$WebGLState(_gl, extensions);
            if (capabilities.reverseDepthBuffer && reverseDepthBuffer) state.buffers.depth.setReversed(true);
            info = new $d5b33d7c30034067$var$WebGLInfo(_gl);
            properties = new $d5b33d7c30034067$var$WebGLProperties();
            textures = new $d5b33d7c30034067$var$WebGLTextures(_gl, extensions, state, properties, capabilities, utils, info);
            cubemaps = new $d5b33d7c30034067$var$WebGLCubeMaps(_this);
            cubeuvmaps = new $d5b33d7c30034067$var$WebGLCubeUVMaps(_this);
            attributes = new $d5b33d7c30034067$var$WebGLAttributes(_gl);
            bindingStates = new $d5b33d7c30034067$var$WebGLBindingStates(_gl, attributes);
            geometries = new $d5b33d7c30034067$var$WebGLGeometries(_gl, attributes, info, bindingStates);
            objects = new $d5b33d7c30034067$var$WebGLObjects(_gl, geometries, attributes, info);
            morphtargets = new $d5b33d7c30034067$var$WebGLMorphtargets(_gl, capabilities, textures);
            clipping = new $d5b33d7c30034067$var$WebGLClipping(properties);
            programCache = new $d5b33d7c30034067$var$WebGLPrograms(_this, cubemaps, cubeuvmaps, extensions, capabilities, bindingStates, clipping);
            materials = new $d5b33d7c30034067$var$WebGLMaterials(_this, properties);
            renderLists = new $d5b33d7c30034067$var$WebGLRenderLists();
            renderStates = new $d5b33d7c30034067$var$WebGLRenderStates(extensions);
            background = new $d5b33d7c30034067$var$WebGLBackground(_this, cubemaps, cubeuvmaps, state, objects, _alpha, premultipliedAlpha);
            shadowMap = new $d5b33d7c30034067$var$WebGLShadowMap(_this, objects, capabilities);
            uniformsGroups = new $d5b33d7c30034067$var$WebGLUniformsGroups(_gl, info, capabilities, state);
            bufferRenderer = new $d5b33d7c30034067$var$WebGLBufferRenderer(_gl, extensions, info);
            indexedBufferRenderer = new $d5b33d7c30034067$var$WebGLIndexedBufferRenderer(_gl, extensions, info);
            info.programs = programCache.programs;
            _this.capabilities = capabilities;
            _this.extensions = extensions;
            _this.properties = properties;
            _this.renderLists = renderLists;
            _this.shadowMap = shadowMap;
            _this.state = state;
            _this.info = info;
        }
        initGLContext();
        // xr
        const xr = new $d5b33d7c30034067$var$WebXRManager(_this, _gl);
        this.xr = xr;
        // API
        this.getContext = function() {
            return _gl;
        };
        this.getContextAttributes = function() {
            return _gl.getContextAttributes();
        };
        this.forceContextLoss = function() {
            const extension = extensions.get('WEBGL_lose_context');
            if (extension) extension.loseContext();
        };
        this.forceContextRestore = function() {
            const extension = extensions.get('WEBGL_lose_context');
            if (extension) extension.restoreContext();
        };
        this.getPixelRatio = function() {
            return _pixelRatio;
        };
        this.setPixelRatio = function(value) {
            if (value === undefined) return;
            _pixelRatio = value;
            this.setSize(_width, _height, false);
        };
        this.getSize = function(target) {
            return target.set(_width, _height);
        };
        this.setSize = function(width, height, updateStyle = true) {
            if (xr.isPresenting) {
                console.warn('THREE.WebGLRenderer: Can\'t change size while VR device is presenting.');
                return;
            }
            _width = width;
            _height = height;
            canvas.width = Math.floor(width * _pixelRatio);
            canvas.height = Math.floor(height * _pixelRatio);
            if (updateStyle === true) {
                canvas.style.width = width + 'px';
                canvas.style.height = height + 'px';
            }
            this.setViewport(0, 0, width, height);
        };
        this.getDrawingBufferSize = function(target) {
            return target.set(_width * _pixelRatio, _height * _pixelRatio).floor();
        };
        this.setDrawingBufferSize = function(width, height, pixelRatio) {
            _width = width;
            _height = height;
            _pixelRatio = pixelRatio;
            canvas.width = Math.floor(width * pixelRatio);
            canvas.height = Math.floor(height * pixelRatio);
            this.setViewport(0, 0, width, height);
        };
        this.getCurrentViewport = function(target) {
            return target.copy(_currentViewport);
        };
        this.getViewport = function(target) {
            return target.copy(_viewport);
        };
        this.setViewport = function(x, y, width, height) {
            if (x.isVector4) _viewport.set(x.x, x.y, x.z, x.w);
            else _viewport.set(x, y, width, height);
            state.viewport(_currentViewport.copy(_viewport).multiplyScalar(_pixelRatio).round());
        };
        this.getScissor = function(target) {
            return target.copy(_scissor);
        };
        this.setScissor = function(x, y, width, height) {
            if (x.isVector4) _scissor.set(x.x, x.y, x.z, x.w);
            else _scissor.set(x, y, width, height);
            state.scissor(_currentScissor.copy(_scissor).multiplyScalar(_pixelRatio).round());
        };
        this.getScissorTest = function() {
            return _scissorTest;
        };
        this.setScissorTest = function(boolean) {
            state.setScissorTest(_scissorTest = boolean);
        };
        this.setOpaqueSort = function(method) {
            _opaqueSort = method;
        };
        this.setTransparentSort = function(method) {
            _transparentSort = method;
        };
        // Clearing
        this.getClearColor = function(target) {
            return target.copy(background.getClearColor());
        };
        this.setClearColor = function() {
            background.setClearColor.apply(background, arguments);
        };
        this.getClearAlpha = function() {
            return background.getClearAlpha();
        };
        this.setClearAlpha = function() {
            background.setClearAlpha.apply(background, arguments);
        };
        this.clear = function(color = true, depth = true, stencil = true) {
            let bits = 0;
            if (color) {
                // check if we're trying to clear an integer target
                let isIntegerFormat = false;
                if (_currentRenderTarget !== null) {
                    const targetFormat = _currentRenderTarget.texture.format;
                    isIntegerFormat = targetFormat === $d5b33d7c30034067$export$c200e7d26f592f21 || targetFormat === $d5b33d7c30034067$export$1ba1c45f9f77d4d7 || targetFormat === $d5b33d7c30034067$export$aa92e870a709d190;
                }
                // use the appropriate clear functions to clear the target if it's a signed
                // or unsigned integer target
                if (isIntegerFormat) {
                    const targetType = _currentRenderTarget.texture.type;
                    const isUnsignedType = targetType === $d5b33d7c30034067$export$2e8ce08d3f6f5e10 || targetType === $d5b33d7c30034067$export$c3c7fc4518ebba96 || targetType === $d5b33d7c30034067$export$c63dc51868b06a9d || targetType === $d5b33d7c30034067$export$6c8ea339bfab1301 || targetType === $d5b33d7c30034067$export$b3969b01faf587f2 || targetType === $d5b33d7c30034067$export$18886f8ae33e90de;
                    const clearColor = background.getClearColor();
                    const a = background.getClearAlpha();
                    const r = clearColor.r;
                    const g = clearColor.g;
                    const b = clearColor.b;
                    if (isUnsignedType) {
                        uintClearColor[0] = r;
                        uintClearColor[1] = g;
                        uintClearColor[2] = b;
                        uintClearColor[3] = a;
                        _gl.clearBufferuiv(_gl.COLOR, 0, uintClearColor);
                    } else {
                        intClearColor[0] = r;
                        intClearColor[1] = g;
                        intClearColor[2] = b;
                        intClearColor[3] = a;
                        _gl.clearBufferiv(_gl.COLOR, 0, intClearColor);
                    }
                } else bits |= _gl.COLOR_BUFFER_BIT;
            }
            if (depth) bits |= _gl.DEPTH_BUFFER_BIT;
            if (stencil) {
                bits |= _gl.STENCIL_BUFFER_BIT;
                this.state.buffers.stencil.setMask(0xffffffff);
            }
            _gl.clear(bits);
        };
        this.clearColor = function() {
            this.clear(true, false, false);
        };
        this.clearDepth = function() {
            this.clear(false, true, false);
        };
        this.clearStencil = function() {
            this.clear(false, false, true);
        };
        //
        this.dispose = function() {
            canvas.removeEventListener('webglcontextlost', onContextLost, false);
            canvas.removeEventListener('webglcontextrestored', onContextRestore, false);
            canvas.removeEventListener('webglcontextcreationerror', onContextCreationError, false);
            renderLists.dispose();
            renderStates.dispose();
            properties.dispose();
            cubemaps.dispose();
            cubeuvmaps.dispose();
            objects.dispose();
            bindingStates.dispose();
            uniformsGroups.dispose();
            programCache.dispose();
            xr.dispose();
            xr.removeEventListener('sessionstart', onXRSessionStart);
            xr.removeEventListener('sessionend', onXRSessionEnd);
            animation.stop();
        };
        // Events
        function onContextLost(event) {
            event.preventDefault();
            console.log('THREE.WebGLRenderer: Context Lost.');
            _isContextLost = true;
        }
        function onContextRestore() {
            console.log('THREE.WebGLRenderer: Context Restored.');
            _isContextLost = false;
            const infoAutoReset = info.autoReset;
            const shadowMapEnabled = shadowMap.enabled;
            const shadowMapAutoUpdate = shadowMap.autoUpdate;
            const shadowMapNeedsUpdate = shadowMap.needsUpdate;
            const shadowMapType = shadowMap.type;
            initGLContext();
            info.autoReset = infoAutoReset;
            shadowMap.enabled = shadowMapEnabled;
            shadowMap.autoUpdate = shadowMapAutoUpdate;
            shadowMap.needsUpdate = shadowMapNeedsUpdate;
            shadowMap.type = shadowMapType;
        }
        function onContextCreationError(event) {
            console.error('THREE.WebGLRenderer: A WebGL context could not be created. Reason: ', event.statusMessage);
        }
        function onMaterialDispose(event) {
            const material = event.target;
            material.removeEventListener('dispose', onMaterialDispose);
            deallocateMaterial(material);
        }
        // Buffer deallocation
        function deallocateMaterial(material) {
            releaseMaterialProgramReferences(material);
            properties.remove(material);
        }
        function releaseMaterialProgramReferences(material) {
            const programs = properties.get(material).programs;
            if (programs !== undefined) {
                programs.forEach(function(program) {
                    programCache.releaseProgram(program);
                });
                if (material.isShaderMaterial) programCache.releaseShaderCache(material);
            }
        }
        // Buffer rendering
        this.renderBufferDirect = function(camera, scene, geometry, material, object, group) {
            if (scene === null) scene = _emptyScene; // renderBufferDirect second parameter used to be fog (could be null)
            const frontFaceCW = object.isMesh && object.matrixWorld.determinant() < 0;
            const program = setProgram(camera, scene, geometry, material, object);
            state.setMaterial(material, frontFaceCW);
            //
            let index = geometry.index;
            let rangeFactor = 1;
            if (material.wireframe === true) {
                index = geometries.getWireframeAttribute(geometry);
                if (index === undefined) return;
                rangeFactor = 2;
            }
            //
            const drawRange = geometry.drawRange;
            const position = geometry.attributes.position;
            let drawStart = drawRange.start * rangeFactor;
            let drawEnd = (drawRange.start + drawRange.count) * rangeFactor;
            if (group !== null) {
                drawStart = Math.max(drawStart, group.start * rangeFactor);
                drawEnd = Math.min(drawEnd, (group.start + group.count) * rangeFactor);
            }
            if (index !== null) {
                drawStart = Math.max(drawStart, 0);
                drawEnd = Math.min(drawEnd, index.count);
            } else if (position !== undefined && position !== null) {
                drawStart = Math.max(drawStart, 0);
                drawEnd = Math.min(drawEnd, position.count);
            }
            const drawCount = drawEnd - drawStart;
            if (drawCount < 0 || drawCount === Infinity) return;
            //
            bindingStates.setup(object, material, program, geometry, index);
            let attribute;
            let renderer = bufferRenderer;
            if (index !== null) {
                attribute = attributes.get(index);
                renderer = indexedBufferRenderer;
                renderer.setIndex(attribute);
            }
            //
            if (object.isMesh) {
                if (material.wireframe === true) {
                    state.setLineWidth(material.wireframeLinewidth * getTargetPixelRatio());
                    renderer.setMode(_gl.LINES);
                } else renderer.setMode(_gl.TRIANGLES);
            } else if (object.isLine) {
                let lineWidth = material.linewidth;
                if (lineWidth === undefined) lineWidth = 1; // Not using Line*Material
                state.setLineWidth(lineWidth * getTargetPixelRatio());
                if (object.isLineSegments) renderer.setMode(_gl.LINES);
                else if (object.isLineLoop) renderer.setMode(_gl.LINE_LOOP);
                else renderer.setMode(_gl.LINE_STRIP);
            } else if (object.isPoints) renderer.setMode(_gl.POINTS);
            else if (object.isSprite) renderer.setMode(_gl.TRIANGLES);
            if (object.isBatchedMesh) {
                if (object._multiDrawInstances !== null) renderer.renderMultiDrawInstances(object._multiDrawStarts, object._multiDrawCounts, object._multiDrawCount, object._multiDrawInstances);
                else if (!extensions.get('WEBGL_multi_draw')) {
                    const starts = object._multiDrawStarts;
                    const counts = object._multiDrawCounts;
                    const drawCount = object._multiDrawCount;
                    const bytesPerElement = index ? attributes.get(index).bytesPerElement : 1;
                    const uniforms = properties.get(material).currentProgram.getUniforms();
                    for(let i = 0; i < drawCount; i++){
                        uniforms.setValue(_gl, '_gl_DrawID', i);
                        renderer.render(starts[i] / bytesPerElement, counts[i]);
                    }
                } else renderer.renderMultiDraw(object._multiDrawStarts, object._multiDrawCounts, object._multiDrawCount);
            } else if (object.isInstancedMesh) renderer.renderInstances(drawStart, drawCount, object.count);
            else if (geometry.isInstancedBufferGeometry) {
                const maxInstanceCount = geometry._maxInstanceCount !== undefined ? geometry._maxInstanceCount : Infinity;
                const instanceCount = Math.min(geometry.instanceCount, maxInstanceCount);
                renderer.renderInstances(drawStart, drawCount, instanceCount);
            } else renderer.render(drawStart, drawCount);
        };
        // Compile
        function prepareMaterial(material, scene, object) {
            if (material.transparent === true && material.side === $d5b33d7c30034067$export$3b296b6f144d5b03 && material.forceSinglePass === false) {
                material.side = $d5b33d7c30034067$export$d9f0486e75b5ace;
                material.needsUpdate = true;
                getProgram(material, scene, object);
                material.side = $d5b33d7c30034067$export$2ede184fc2998901;
                material.needsUpdate = true;
                getProgram(material, scene, object);
                material.side = $d5b33d7c30034067$export$3b296b6f144d5b03;
            } else getProgram(material, scene, object);
        }
        this.compile = function(scene, camera, targetScene = null) {
            if (targetScene === null) targetScene = scene;
            currentRenderState = renderStates.get(targetScene);
            currentRenderState.init(camera);
            renderStateStack.push(currentRenderState);
            // gather lights from both the target scene and the new object that will be added to the scene.
            targetScene.traverseVisible(function(object) {
                if (object.isLight && object.layers.test(camera.layers)) {
                    currentRenderState.pushLight(object);
                    if (object.castShadow) currentRenderState.pushShadow(object);
                }
            });
            if (scene !== targetScene) scene.traverseVisible(function(object) {
                if (object.isLight && object.layers.test(camera.layers)) {
                    currentRenderState.pushLight(object);
                    if (object.castShadow) currentRenderState.pushShadow(object);
                }
            });
            currentRenderState.setupLights();
            // Only initialize materials in the new scene, not the targetScene.
            const materials = new Set();
            scene.traverse(function(object) {
                if (!(object.isMesh || object.isPoints || object.isLine || object.isSprite)) return;
                const material = object.material;
                if (material) {
                    if (Array.isArray(material)) for(let i = 0; i < material.length; i++){
                        const material2 = material[i];
                        prepareMaterial(material2, targetScene, object);
                        materials.add(material2);
                    }
                    else {
                        prepareMaterial(material, targetScene, object);
                        materials.add(material);
                    }
                }
            });
            renderStateStack.pop();
            currentRenderState = null;
            return materials;
        };
        // compileAsync
        this.compileAsync = function(scene, camera, targetScene = null) {
            const materials = this.compile(scene, camera, targetScene);
            // Wait for all the materials in the new object to indicate that they're
            // ready to be used before resolving the promise.
            return new Promise((resolve)=>{
                function checkMaterialsReady() {
                    materials.forEach(function(material) {
                        const materialProperties = properties.get(material);
                        const program = materialProperties.currentProgram;
                        if (program.isReady()) // remove any programs that report they're ready to use from the list
                        materials.delete(material);
                    });
                    // once the list of compiling materials is empty, call the callback
                    if (materials.size === 0) {
                        resolve(scene);
                        return;
                    }
                    // if some materials are still not ready, wait a bit and check again
                    setTimeout(checkMaterialsReady, 10);
                }
                if (extensions.get('KHR_parallel_shader_compile') !== null) // If we can check the compilation status of the materials without
                // blocking then do so right away.
                checkMaterialsReady();
                else // Otherwise start by waiting a bit to give the materials we just
                // initialized a chance to finish.
                setTimeout(checkMaterialsReady, 10);
            });
        };
        // Animation Loop
        let onAnimationFrameCallback = null;
        function onAnimationFrame(time) {
            if (onAnimationFrameCallback) onAnimationFrameCallback(time);
        }
        function onXRSessionStart() {
            animation.stop();
        }
        function onXRSessionEnd() {
            animation.start();
        }
        const animation = new $d5b33d7c30034067$var$WebGLAnimation();
        animation.setAnimationLoop(onAnimationFrame);
        if (typeof self !== 'undefined') animation.setContext(self);
        this.setAnimationLoop = function(callback) {
            onAnimationFrameCallback = callback;
            xr.setAnimationLoop(callback);
            callback === null ? animation.stop() : animation.start();
        };
        xr.addEventListener('sessionstart', onXRSessionStart);
        xr.addEventListener('sessionend', onXRSessionEnd);
        // Rendering
        this.render = function(scene, camera) {
            if (camera !== undefined && camera.isCamera !== true) {
                console.error('THREE.WebGLRenderer.render: camera is not an instance of THREE.Camera.');
                return;
            }
            if (_isContextLost === true) return;
            // update scene graph
            if (scene.matrixWorldAutoUpdate === true) scene.updateMatrixWorld();
            // update camera matrices and frustum
            if (camera.parent === null && camera.matrixWorldAutoUpdate === true) camera.updateMatrixWorld();
            if (xr.enabled === true && xr.isPresenting === true) {
                if (xr.cameraAutoUpdate === true) xr.updateCamera(camera);
                camera = xr.getCamera(); // use XR camera for rendering
            }
            //
            if (scene.isScene === true) scene.onBeforeRender(_this, scene, camera, _currentRenderTarget);
            currentRenderState = renderStates.get(scene, renderStateStack.length);
            currentRenderState.init(camera);
            renderStateStack.push(currentRenderState);
            _projScreenMatrix.multiplyMatrices(camera.projectionMatrix, camera.matrixWorldInverse);
            _frustum.setFromProjectionMatrix(_projScreenMatrix);
            _localClippingEnabled = this.localClippingEnabled;
            _clippingEnabled = clipping.init(this.clippingPlanes, _localClippingEnabled);
            currentRenderList = renderLists.get(scene, renderListStack.length);
            currentRenderList.init();
            renderListStack.push(currentRenderList);
            if (xr.enabled === true && xr.isPresenting === true) {
                const depthSensingMesh = _this.xr.getDepthSensingMesh();
                if (depthSensingMesh !== null) projectObject(depthSensingMesh, camera, -Infinity, _this.sortObjects);
            }
            projectObject(scene, camera, 0, _this.sortObjects);
            currentRenderList.finish();
            if (_this.sortObjects === true) currentRenderList.sort(_opaqueSort, _transparentSort);
            _renderBackground = xr.enabled === false || xr.isPresenting === false || xr.hasDepthSensing() === false;
            if (_renderBackground) background.addToRenderList(currentRenderList, scene);
            //
            this.info.render.frame++;
            if (_clippingEnabled === true) clipping.beginShadows();
            const shadowsArray = currentRenderState.state.shadowsArray;
            shadowMap.render(shadowsArray, scene, camera);
            if (_clippingEnabled === true) clipping.endShadows();
            //
            if (this.info.autoReset === true) this.info.reset();
            // render scene
            const opaqueObjects = currentRenderList.opaque;
            const transmissiveObjects = currentRenderList.transmissive;
            currentRenderState.setupLights();
            if (camera.isArrayCamera) {
                const cameras = camera.cameras;
                if (transmissiveObjects.length > 0) for(let i = 0, l = cameras.length; i < l; i++){
                    const camera2 = cameras[i];
                    renderTransmissionPass(opaqueObjects, transmissiveObjects, scene, camera2);
                }
                if (_renderBackground) background.render(scene);
                for(let i = 0, l = cameras.length; i < l; i++){
                    const camera2 = cameras[i];
                    renderScene(currentRenderList, scene, camera2, camera2.viewport);
                }
            } else {
                if (transmissiveObjects.length > 0) renderTransmissionPass(opaqueObjects, transmissiveObjects, scene, camera);
                if (_renderBackground) background.render(scene);
                renderScene(currentRenderList, scene, camera);
            }
            //
            if (_currentRenderTarget !== null) {
                // resolve multisample renderbuffers to a single-sample texture if necessary
                textures.updateMultisampleRenderTarget(_currentRenderTarget);
                // Generate mipmap if we're using any kind of mipmap filtering
                textures.updateRenderTargetMipmap(_currentRenderTarget);
            }
            //
            if (scene.isScene === true) scene.onAfterRender(_this, scene, camera);
            // _gl.finish();
            bindingStates.resetDefaultState();
            _currentMaterialId = -1;
            _currentCamera = null;
            renderStateStack.pop();
            if (renderStateStack.length > 0) {
                currentRenderState = renderStateStack[renderStateStack.length - 1];
                if (_clippingEnabled === true) clipping.setGlobalState(_this.clippingPlanes, currentRenderState.state.camera);
            } else currentRenderState = null;
            renderListStack.pop();
            if (renderListStack.length > 0) currentRenderList = renderListStack[renderListStack.length - 1];
            else currentRenderList = null;
        };
        function projectObject(object, camera, groupOrder, sortObjects) {
            if (object.visible === false) return;
            const visible = object.layers.test(camera.layers);
            if (visible) {
                if (object.isGroup) groupOrder = object.renderOrder;
                else if (object.isLOD) {
                    if (object.autoUpdate === true) object.update(camera);
                } else if (object.isLight) {
                    currentRenderState.pushLight(object);
                    if (object.castShadow) currentRenderState.pushShadow(object);
                } else if (object.isSprite) {
                    if (!object.frustumCulled || _frustum.intersectsSprite(object)) {
                        if (sortObjects) _vector4.setFromMatrixPosition(object.matrixWorld).applyMatrix4(_projScreenMatrix);
                        const geometry = objects.update(object);
                        const material = object.material;
                        if (material.visible) currentRenderList.push(object, geometry, material, groupOrder, _vector4.z, null);
                    }
                } else if (object.isMesh || object.isLine || object.isPoints) {
                    if (!object.frustumCulled || _frustum.intersectsObject(object)) {
                        const geometry = objects.update(object);
                        const material = object.material;
                        if (sortObjects) {
                            if (object.boundingSphere !== undefined) {
                                if (object.boundingSphere === null) object.computeBoundingSphere();
                                _vector4.copy(object.boundingSphere.center);
                            } else {
                                if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
                                _vector4.copy(geometry.boundingSphere.center);
                            }
                            _vector4.applyMatrix4(object.matrixWorld).applyMatrix4(_projScreenMatrix);
                        }
                        if (Array.isArray(material)) {
                            const groups = geometry.groups;
                            for(let i = 0, l = groups.length; i < l; i++){
                                const group = groups[i];
                                const groupMaterial = material[group.materialIndex];
                                if (groupMaterial && groupMaterial.visible) currentRenderList.push(object, geometry, groupMaterial, groupOrder, _vector4.z, group);
                            }
                        } else if (material.visible) currentRenderList.push(object, geometry, material, groupOrder, _vector4.z, null);
                    }
                }
            }
            const children = object.children;
            for(let i = 0, l = children.length; i < l; i++)projectObject(children[i], camera, groupOrder, sortObjects);
        }
        function renderScene(currentRenderList, scene, camera, viewport) {
            const opaqueObjects = currentRenderList.opaque;
            const transmissiveObjects = currentRenderList.transmissive;
            const transparentObjects = currentRenderList.transparent;
            currentRenderState.setupLightsView(camera);
            if (_clippingEnabled === true) clipping.setGlobalState(_this.clippingPlanes, camera);
            if (viewport) state.viewport(_currentViewport.copy(viewport));
            if (opaqueObjects.length > 0) renderObjects(opaqueObjects, scene, camera);
            if (transmissiveObjects.length > 0) renderObjects(transmissiveObjects, scene, camera);
            if (transparentObjects.length > 0) renderObjects(transparentObjects, scene, camera);
            // Ensure depth buffer writing is enabled so it can be cleared on next render
            state.buffers.depth.setTest(true);
            state.buffers.depth.setMask(true);
            state.buffers.color.setMask(true);
            state.setPolygonOffset(false);
        }
        function renderTransmissionPass(opaqueObjects, transmissiveObjects, scene, camera) {
            const overrideMaterial = scene.isScene === true ? scene.overrideMaterial : null;
            if (overrideMaterial !== null) return;
            if (currentRenderState.state.transmissionRenderTarget[camera.id] === undefined) currentRenderState.state.transmissionRenderTarget[camera.id] = new $d5b33d7c30034067$export$3c052beb2e51e23f(1, 1, {
                generateMipmaps: true,
                type: extensions.has('EXT_color_buffer_half_float') || extensions.has('EXT_color_buffer_float') ? $d5b33d7c30034067$export$2697304443f382bc : $d5b33d7c30034067$export$2e8ce08d3f6f5e10,
                minFilter: $d5b33d7c30034067$export$5d8599b6a933fb1b,
                samples: 4,
                stencilBuffer: stencil,
                resolveDepthBuffer: false,
                resolveStencilBuffer: false,
                colorSpace: $d5b33d7c30034067$export$5e6fd513f44698c.workingColorSpace
            });
            const transmissionRenderTarget = currentRenderState.state.transmissionRenderTarget[camera.id];
            const activeViewport = camera.viewport || _currentViewport;
            transmissionRenderTarget.setSize(activeViewport.z, activeViewport.w);
            //
            const currentRenderTarget = _this.getRenderTarget();
            _this.setRenderTarget(transmissionRenderTarget);
            _this.getClearColor(_currentClearColor);
            _currentClearAlpha = _this.getClearAlpha();
            if (_currentClearAlpha < 1) _this.setClearColor(0xffffff, 0.5);
            _this.clear();
            if (_renderBackground) background.render(scene);
            // Turn off the features which can affect the frag color for opaque objects pass.
            // Otherwise they are applied twice in opaque objects pass and transmission objects pass.
            const currentToneMapping = _this.toneMapping;
            _this.toneMapping = $d5b33d7c30034067$export$9fcb6b4294603b2;
            // Remove viewport from camera to avoid nested render calls resetting viewport to it (e.g Reflector).
            // Transmission render pass requires viewport to match the transmissionRenderTarget.
            const currentCameraViewport = camera.viewport;
            if (camera.viewport !== undefined) camera.viewport = undefined;
            currentRenderState.setupLightsView(camera);
            if (_clippingEnabled === true) clipping.setGlobalState(_this.clippingPlanes, camera);
            renderObjects(opaqueObjects, scene, camera);
            textures.updateMultisampleRenderTarget(transmissionRenderTarget);
            textures.updateRenderTargetMipmap(transmissionRenderTarget);
            if (extensions.has('WEBGL_multisampled_render_to_texture') === false) {
                let renderTargetNeedsUpdate = false;
                for(let i = 0, l = transmissiveObjects.length; i < l; i++){
                    const renderItem = transmissiveObjects[i];
                    const object = renderItem.object;
                    const geometry = renderItem.geometry;
                    const material = renderItem.material;
                    const group = renderItem.group;
                    if (material.side === $d5b33d7c30034067$export$3b296b6f144d5b03 && object.layers.test(camera.layers)) {
                        const currentSide = material.side;
                        material.side = $d5b33d7c30034067$export$d9f0486e75b5ace;
                        material.needsUpdate = true;
                        renderObject(object, scene, camera, geometry, material, group);
                        material.side = currentSide;
                        material.needsUpdate = true;
                        renderTargetNeedsUpdate = true;
                    }
                }
                if (renderTargetNeedsUpdate === true) {
                    textures.updateMultisampleRenderTarget(transmissionRenderTarget);
                    textures.updateRenderTargetMipmap(transmissionRenderTarget);
                }
            }
            _this.setRenderTarget(currentRenderTarget);
            _this.setClearColor(_currentClearColor, _currentClearAlpha);
            if (currentCameraViewport !== undefined) camera.viewport = currentCameraViewport;
            _this.toneMapping = currentToneMapping;
        }
        function renderObjects(renderList, scene, camera) {
            const overrideMaterial = scene.isScene === true ? scene.overrideMaterial : null;
            for(let i = 0, l = renderList.length; i < l; i++){
                const renderItem = renderList[i];
                const object = renderItem.object;
                const geometry = renderItem.geometry;
                const material = overrideMaterial === null ? renderItem.material : overrideMaterial;
                const group = renderItem.group;
                if (object.layers.test(camera.layers)) renderObject(object, scene, camera, geometry, material, group);
            }
        }
        function renderObject(object, scene, camera, geometry, material, group) {
            object.onBeforeRender(_this, scene, camera, geometry, material, group);
            object.modelViewMatrix.multiplyMatrices(camera.matrixWorldInverse, object.matrixWorld);
            object.normalMatrix.getNormalMatrix(object.modelViewMatrix);
            material.onBeforeRender(_this, scene, camera, geometry, object, group);
            if (material.transparent === true && material.side === $d5b33d7c30034067$export$3b296b6f144d5b03 && material.forceSinglePass === false) {
                material.side = $d5b33d7c30034067$export$d9f0486e75b5ace;
                material.needsUpdate = true;
                _this.renderBufferDirect(camera, scene, geometry, material, object, group);
                material.side = $d5b33d7c30034067$export$2ede184fc2998901;
                material.needsUpdate = true;
                _this.renderBufferDirect(camera, scene, geometry, material, object, group);
                material.side = $d5b33d7c30034067$export$3b296b6f144d5b03;
            } else _this.renderBufferDirect(camera, scene, geometry, material, object, group);
            object.onAfterRender(_this, scene, camera, geometry, material, group);
        }
        function getProgram(material, scene, object) {
            if (scene.isScene !== true) scene = _emptyScene; // scene could be a Mesh, Line, Points, ...
            const materialProperties = properties.get(material);
            const lights = currentRenderState.state.lights;
            const shadowsArray = currentRenderState.state.shadowsArray;
            const lightsStateVersion = lights.state.version;
            const parameters = programCache.getParameters(material, lights.state, shadowsArray, scene, object);
            const programCacheKey = programCache.getProgramCacheKey(parameters);
            let programs = materialProperties.programs;
            // always update environment and fog - changing these trigger an getProgram call, but it's possible that the program doesn't change
            materialProperties.environment = material.isMeshStandardMaterial ? scene.environment : null;
            materialProperties.fog = scene.fog;
            materialProperties.envMap = (material.isMeshStandardMaterial ? cubeuvmaps : cubemaps).get(material.envMap || materialProperties.environment);
            materialProperties.envMapRotation = materialProperties.environment !== null && material.envMap === null ? scene.environmentRotation : material.envMapRotation;
            if (programs === undefined) {
                // new material
                material.addEventListener('dispose', onMaterialDispose);
                programs = new Map();
                materialProperties.programs = programs;
            }
            let program = programs.get(programCacheKey);
            if (program !== undefined) // early out if program and light state is identical
            {
                if (materialProperties.currentProgram === program && materialProperties.lightsStateVersion === lightsStateVersion) {
                    updateCommonMaterialProperties(material, parameters);
                    return program;
                }
            } else {
                parameters.uniforms = programCache.getUniforms(material);
                material.onBeforeCompile(parameters, _this);
                program = programCache.acquireProgram(parameters, programCacheKey);
                programs.set(programCacheKey, program);
                materialProperties.uniforms = parameters.uniforms;
            }
            const uniforms = materialProperties.uniforms;
            if (!material.isShaderMaterial && !material.isRawShaderMaterial || material.clipping === true) uniforms.clippingPlanes = clipping.uniform;
            updateCommonMaterialProperties(material, parameters);
            // store the light setup it was created for
            materialProperties.needsLights = materialNeedsLights(material);
            materialProperties.lightsStateVersion = lightsStateVersion;
            if (materialProperties.needsLights) {
                // wire up the material to this renderer's lighting state
                uniforms.ambientLightColor.value = lights.state.ambient;
                uniforms.lightProbe.value = lights.state.probe;
                uniforms.directionalLights.value = lights.state.directional;
                uniforms.directionalLightShadows.value = lights.state.directionalShadow;
                uniforms.spotLights.value = lights.state.spot;
                uniforms.spotLightShadows.value = lights.state.spotShadow;
                uniforms.rectAreaLights.value = lights.state.rectArea;
                uniforms.ltc_1.value = lights.state.rectAreaLTC1;
                uniforms.ltc_2.value = lights.state.rectAreaLTC2;
                uniforms.pointLights.value = lights.state.point;
                uniforms.pointLightShadows.value = lights.state.pointShadow;
                uniforms.hemisphereLights.value = lights.state.hemi;
                uniforms.directionalShadowMap.value = lights.state.directionalShadowMap;
                uniforms.directionalShadowMatrix.value = lights.state.directionalShadowMatrix;
                uniforms.spotShadowMap.value = lights.state.spotShadowMap;
                uniforms.spotLightMatrix.value = lights.state.spotLightMatrix;
                uniforms.spotLightMap.value = lights.state.spotLightMap;
                uniforms.pointShadowMap.value = lights.state.pointShadowMap;
                uniforms.pointShadowMatrix.value = lights.state.pointShadowMatrix;
            // TODO (abelnation): add area lights shadow info to uniforms
            }
            materialProperties.currentProgram = program;
            materialProperties.uniformsList = null;
            return program;
        }
        function getUniformList(materialProperties) {
            if (materialProperties.uniformsList === null) {
                const progUniforms = materialProperties.currentProgram.getUniforms();
                materialProperties.uniformsList = $d5b33d7c30034067$var$WebGLUniforms.seqWithValue(progUniforms.seq, materialProperties.uniforms);
            }
            return materialProperties.uniformsList;
        }
        function updateCommonMaterialProperties(material, parameters) {
            const materialProperties = properties.get(material);
            materialProperties.outputColorSpace = parameters.outputColorSpace;
            materialProperties.batching = parameters.batching;
            materialProperties.batchingColor = parameters.batchingColor;
            materialProperties.instancing = parameters.instancing;
            materialProperties.instancingColor = parameters.instancingColor;
            materialProperties.instancingMorph = parameters.instancingMorph;
            materialProperties.skinning = parameters.skinning;
            materialProperties.morphTargets = parameters.morphTargets;
            materialProperties.morphNormals = parameters.morphNormals;
            materialProperties.morphColors = parameters.morphColors;
            materialProperties.morphTargetsCount = parameters.morphTargetsCount;
            materialProperties.numClippingPlanes = parameters.numClippingPlanes;
            materialProperties.numIntersection = parameters.numClipIntersection;
            materialProperties.vertexAlphas = parameters.vertexAlphas;
            materialProperties.vertexTangents = parameters.vertexTangents;
            materialProperties.toneMapping = parameters.toneMapping;
        }
        function setProgram(camera, scene, geometry, material, object) {
            if (scene.isScene !== true) scene = _emptyScene; // scene could be a Mesh, Line, Points, ...
            textures.resetTextureUnits();
            const fog = scene.fog;
            const environment = material.isMeshStandardMaterial ? scene.environment : null;
            const colorSpace = _currentRenderTarget === null ? _this.outputColorSpace : _currentRenderTarget.isXRRenderTarget === true ? _currentRenderTarget.texture.colorSpace : $d5b33d7c30034067$export$42429b3acfb233a4;
            const envMap = (material.isMeshStandardMaterial ? cubeuvmaps : cubemaps).get(material.envMap || environment);
            const vertexAlphas = material.vertexColors === true && !!geometry.attributes.color && geometry.attributes.color.itemSize === 4;
            const vertexTangents = !!geometry.attributes.tangent && (!!material.normalMap || material.anisotropy > 0);
            const morphTargets = !!geometry.morphAttributes.position;
            const morphNormals = !!geometry.morphAttributes.normal;
            const morphColors = !!geometry.morphAttributes.color;
            let toneMapping = $d5b33d7c30034067$export$9fcb6b4294603b2;
            if (material.toneMapped) {
                if (_currentRenderTarget === null || _currentRenderTarget.isXRRenderTarget === true) toneMapping = _this.toneMapping;
            }
            const morphAttribute = geometry.morphAttributes.position || geometry.morphAttributes.normal || geometry.morphAttributes.color;
            const morphTargetsCount = morphAttribute !== undefined ? morphAttribute.length : 0;
            const materialProperties = properties.get(material);
            const lights = currentRenderState.state.lights;
            if (_clippingEnabled === true) {
                if (_localClippingEnabled === true || camera !== _currentCamera) {
                    const useCache = camera === _currentCamera && material.id === _currentMaterialId;
                    // we might want to call this function with some ClippingGroup
                    // object instead of the material, once it becomes feasible
                    // (#8465, #8379)
                    clipping.setState(material, camera, useCache);
                }
            }
            //
            let needsProgramChange = false;
            if (material.version === materialProperties.__version) {
                if (materialProperties.needsLights && materialProperties.lightsStateVersion !== lights.state.version) needsProgramChange = true;
                else if (materialProperties.outputColorSpace !== colorSpace) needsProgramChange = true;
                else if (object.isBatchedMesh && materialProperties.batching === false) needsProgramChange = true;
                else if (!object.isBatchedMesh && materialProperties.batching === true) needsProgramChange = true;
                else if (object.isBatchedMesh && materialProperties.batchingColor === true && object.colorTexture === null) needsProgramChange = true;
                else if (object.isBatchedMesh && materialProperties.batchingColor === false && object.colorTexture !== null) needsProgramChange = true;
                else if (object.isInstancedMesh && materialProperties.instancing === false) needsProgramChange = true;
                else if (!object.isInstancedMesh && materialProperties.instancing === true) needsProgramChange = true;
                else if (object.isSkinnedMesh && materialProperties.skinning === false) needsProgramChange = true;
                else if (!object.isSkinnedMesh && materialProperties.skinning === true) needsProgramChange = true;
                else if (object.isInstancedMesh && materialProperties.instancingColor === true && object.instanceColor === null) needsProgramChange = true;
                else if (object.isInstancedMesh && materialProperties.instancingColor === false && object.instanceColor !== null) needsProgramChange = true;
                else if (object.isInstancedMesh && materialProperties.instancingMorph === true && object.morphTexture === null) needsProgramChange = true;
                else if (object.isInstancedMesh && materialProperties.instancingMorph === false && object.morphTexture !== null) needsProgramChange = true;
                else if (materialProperties.envMap !== envMap) needsProgramChange = true;
                else if (material.fog === true && materialProperties.fog !== fog) needsProgramChange = true;
                else if (materialProperties.numClippingPlanes !== undefined && (materialProperties.numClippingPlanes !== clipping.numPlanes || materialProperties.numIntersection !== clipping.numIntersection)) needsProgramChange = true;
                else if (materialProperties.vertexAlphas !== vertexAlphas) needsProgramChange = true;
                else if (materialProperties.vertexTangents !== vertexTangents) needsProgramChange = true;
                else if (materialProperties.morphTargets !== morphTargets) needsProgramChange = true;
                else if (materialProperties.morphNormals !== morphNormals) needsProgramChange = true;
                else if (materialProperties.morphColors !== morphColors) needsProgramChange = true;
                else if (materialProperties.toneMapping !== toneMapping) needsProgramChange = true;
                else if (materialProperties.morphTargetsCount !== morphTargetsCount) needsProgramChange = true;
            } else {
                needsProgramChange = true;
                materialProperties.__version = material.version;
            }
            //
            let program = materialProperties.currentProgram;
            if (needsProgramChange === true) program = getProgram(material, scene, object);
            let refreshProgram = false;
            let refreshMaterial = false;
            let refreshLights = false;
            const p_uniforms = program.getUniforms(), m_uniforms = materialProperties.uniforms;
            if (state.useProgram(program.program)) {
                refreshProgram = true;
                refreshMaterial = true;
                refreshLights = true;
            }
            if (material.id !== _currentMaterialId) {
                _currentMaterialId = material.id;
                refreshMaterial = true;
            }
            if (refreshProgram || _currentCamera !== camera) {
                // common camera uniforms
                const reverseDepthBuffer = state.buffers.depth.getReversed();
                if (reverseDepthBuffer) {
                    _currentProjectionMatrix.copy(camera.projectionMatrix);
                    $d5b33d7c30034067$var$toNormalizedProjectionMatrix(_currentProjectionMatrix);
                    $d5b33d7c30034067$var$toReversedProjectionMatrix(_currentProjectionMatrix);
                    p_uniforms.setValue(_gl, 'projectionMatrix', _currentProjectionMatrix);
                } else p_uniforms.setValue(_gl, 'projectionMatrix', camera.projectionMatrix);
                p_uniforms.setValue(_gl, 'viewMatrix', camera.matrixWorldInverse);
                const uCamPos = p_uniforms.map.cameraPosition;
                if (uCamPos !== undefined) uCamPos.setValue(_gl, _vector3.setFromMatrixPosition(camera.matrixWorld));
                if (capabilities.logarithmicDepthBuffer) p_uniforms.setValue(_gl, 'logDepthBufFC', 2.0 / (Math.log(camera.far + 1.0) / Math.LN2));
                // consider moving isOrthographic to UniformLib and WebGLMaterials, see https://github.com/mrdoob/three.js/pull/26467#issuecomment-1645185067
                if (material.isMeshPhongMaterial || material.isMeshToonMaterial || material.isMeshLambertMaterial || material.isMeshBasicMaterial || material.isMeshStandardMaterial || material.isShaderMaterial) p_uniforms.setValue(_gl, 'isOrthographic', camera.isOrthographicCamera === true);
                if (_currentCamera !== camera) {
                    _currentCamera = camera;
                    // lighting uniforms depend on the camera so enforce an update
                    // now, in case this material supports lights - or later, when
                    // the next material that does gets activated:
                    refreshMaterial = true; // set to true on material change
                    refreshLights = true; // remains set until update done
                }
            }
            // skinning and morph target uniforms must be set even if material didn't change
            // auto-setting of texture unit for bone and morph texture must go before other textures
            // otherwise textures used for skinning and morphing can take over texture units reserved for other material textures
            if (object.isSkinnedMesh) {
                p_uniforms.setOptional(_gl, object, 'bindMatrix');
                p_uniforms.setOptional(_gl, object, 'bindMatrixInverse');
                const skeleton = object.skeleton;
                if (skeleton) {
                    if (skeleton.boneTexture === null) skeleton.computeBoneTexture();
                    p_uniforms.setValue(_gl, 'boneTexture', skeleton.boneTexture, textures);
                }
            }
            if (object.isBatchedMesh) {
                p_uniforms.setOptional(_gl, object, 'batchingTexture');
                p_uniforms.setValue(_gl, 'batchingTexture', object._matricesTexture, textures);
                p_uniforms.setOptional(_gl, object, 'batchingIdTexture');
                p_uniforms.setValue(_gl, 'batchingIdTexture', object._indirectTexture, textures);
                p_uniforms.setOptional(_gl, object, 'batchingColorTexture');
                if (object._colorsTexture !== null) p_uniforms.setValue(_gl, 'batchingColorTexture', object._colorsTexture, textures);
            }
            const morphAttributes = geometry.morphAttributes;
            if (morphAttributes.position !== undefined || morphAttributes.normal !== undefined || morphAttributes.color !== undefined) morphtargets.update(object, geometry, program);
            if (refreshMaterial || materialProperties.receiveShadow !== object.receiveShadow) {
                materialProperties.receiveShadow = object.receiveShadow;
                p_uniforms.setValue(_gl, 'receiveShadow', object.receiveShadow);
            }
            // https://github.com/mrdoob/three.js/pull/24467#issuecomment-1209031512
            if (material.isMeshGouraudMaterial && material.envMap !== null) {
                m_uniforms.envMap.value = envMap;
                m_uniforms.flipEnvMap.value = envMap.isCubeTexture && envMap.isRenderTargetTexture === false ? -1 : 1;
            }
            if (material.isMeshStandardMaterial && material.envMap === null && scene.environment !== null) m_uniforms.envMapIntensity.value = scene.environmentIntensity;
            if (refreshMaterial) {
                p_uniforms.setValue(_gl, 'toneMappingExposure', _this.toneMappingExposure);
                if (materialProperties.needsLights) // the current material requires lighting info
                // note: all lighting uniforms are always set correctly
                // they simply reference the renderer's state for their
                // values
                //
                // use the current material's .needsUpdate flags to set
                // the GL state when required
                markUniformsLightsNeedsUpdate(m_uniforms, refreshLights);
                // refresh uniforms common to several materials
                if (fog && material.fog === true) materials.refreshFogUniforms(m_uniforms, fog);
                materials.refreshMaterialUniforms(m_uniforms, material, _pixelRatio, _height, currentRenderState.state.transmissionRenderTarget[camera.id]);
                $d5b33d7c30034067$var$WebGLUniforms.upload(_gl, getUniformList(materialProperties), m_uniforms, textures);
            }
            if (material.isShaderMaterial && material.uniformsNeedUpdate === true) {
                $d5b33d7c30034067$var$WebGLUniforms.upload(_gl, getUniformList(materialProperties), m_uniforms, textures);
                material.uniformsNeedUpdate = false;
            }
            if (material.isSpriteMaterial) p_uniforms.setValue(_gl, 'center', object.center);
            // common matrices
            p_uniforms.setValue(_gl, 'modelViewMatrix', object.modelViewMatrix);
            p_uniforms.setValue(_gl, 'normalMatrix', object.normalMatrix);
            p_uniforms.setValue(_gl, 'modelMatrix', object.matrixWorld);
            // UBOs
            if (material.isShaderMaterial || material.isRawShaderMaterial) {
                const groups = material.uniformsGroups;
                for(let i = 0, l = groups.length; i < l; i++){
                    const group = groups[i];
                    uniformsGroups.update(group, program);
                    uniformsGroups.bind(group, program);
                }
            }
            return program;
        }
        // If uniforms are marked as clean, they don't need to be loaded to the GPU.
        function markUniformsLightsNeedsUpdate(uniforms, value) {
            uniforms.ambientLightColor.needsUpdate = value;
            uniforms.lightProbe.needsUpdate = value;
            uniforms.directionalLights.needsUpdate = value;
            uniforms.directionalLightShadows.needsUpdate = value;
            uniforms.pointLights.needsUpdate = value;
            uniforms.pointLightShadows.needsUpdate = value;
            uniforms.spotLights.needsUpdate = value;
            uniforms.spotLightShadows.needsUpdate = value;
            uniforms.rectAreaLights.needsUpdate = value;
            uniforms.hemisphereLights.needsUpdate = value;
        }
        function materialNeedsLights(material) {
            return material.isMeshLambertMaterial || material.isMeshToonMaterial || material.isMeshPhongMaterial || material.isMeshStandardMaterial || material.isShadowMaterial || material.isShaderMaterial && material.lights === true;
        }
        this.getActiveCubeFace = function() {
            return _currentActiveCubeFace;
        };
        this.getActiveMipmapLevel = function() {
            return _currentActiveMipmapLevel;
        };
        this.getRenderTarget = function() {
            return _currentRenderTarget;
        };
        this.setRenderTargetTextures = function(renderTarget, colorTexture, depthTexture) {
            properties.get(renderTarget.texture).__webglTexture = colorTexture;
            properties.get(renderTarget.depthTexture).__webglTexture = depthTexture;
            const renderTargetProperties = properties.get(renderTarget);
            renderTargetProperties.__hasExternalTextures = true;
            renderTargetProperties.__autoAllocateDepthBuffer = depthTexture === undefined;
            if (!renderTargetProperties.__autoAllocateDepthBuffer) // The multisample_render_to_texture extension doesn't work properly if there
            // are midframe flushes and an external depth buffer. Disable use of the extension.
            {
                if (extensions.has('WEBGL_multisampled_render_to_texture') === true) {
                    console.warn('THREE.WebGLRenderer: Render-to-texture extension was disabled because an external texture was provided');
                    renderTargetProperties.__useRenderToTexture = false;
                }
            }
        };
        this.setRenderTargetFramebuffer = function(renderTarget, defaultFramebuffer) {
            const renderTargetProperties = properties.get(renderTarget);
            renderTargetProperties.__webglFramebuffer = defaultFramebuffer;
            renderTargetProperties.__useDefaultFramebuffer = defaultFramebuffer === undefined;
        };
        this.setRenderTarget = function(renderTarget, activeCubeFace = 0, activeMipmapLevel = 0) {
            _currentRenderTarget = renderTarget;
            _currentActiveCubeFace = activeCubeFace;
            _currentActiveMipmapLevel = activeMipmapLevel;
            let useDefaultFramebuffer = true;
            let framebuffer = null;
            let isCube = false;
            let isRenderTarget3D = false;
            if (renderTarget) {
                const renderTargetProperties = properties.get(renderTarget);
                if (renderTargetProperties.__useDefaultFramebuffer !== undefined) {
                    // We need to make sure to rebind the framebuffer.
                    state.bindFramebuffer(_gl.FRAMEBUFFER, null);
                    useDefaultFramebuffer = false;
                } else if (renderTargetProperties.__webglFramebuffer === undefined) textures.setupRenderTarget(renderTarget);
                else if (renderTargetProperties.__hasExternalTextures) // Color and depth texture must be rebound in order for the swapchain to update.
                textures.rebindTextures(renderTarget, properties.get(renderTarget.texture).__webglTexture, properties.get(renderTarget.depthTexture).__webglTexture);
                else if (renderTarget.depthBuffer) {
                    // check if the depth texture is already bound to the frame buffer and that it's been initialized
                    const depthTexture = renderTarget.depthTexture;
                    if (renderTargetProperties.__boundDepthTexture !== depthTexture) {
                        // check if the depth texture is compatible
                        if (depthTexture !== null && properties.has(depthTexture) && (renderTarget.width !== depthTexture.image.width || renderTarget.height !== depthTexture.image.height)) throw new Error('WebGLRenderTarget: Attached DepthTexture is initialized to the incorrect size.');
                        // Swap the depth buffer to the currently attached one
                        textures.setupDepthRenderbuffer(renderTarget);
                    }
                }
                const texture = renderTarget.texture;
                if (texture.isData3DTexture || texture.isDataArrayTexture || texture.isCompressedArrayTexture) isRenderTarget3D = true;
                const __webglFramebuffer = properties.get(renderTarget).__webglFramebuffer;
                if (renderTarget.isWebGLCubeRenderTarget) {
                    if (Array.isArray(__webglFramebuffer[activeCubeFace])) framebuffer = __webglFramebuffer[activeCubeFace][activeMipmapLevel];
                    else framebuffer = __webglFramebuffer[activeCubeFace];
                    isCube = true;
                } else if (renderTarget.samples > 0 && textures.useMultisampledRTT(renderTarget) === false) framebuffer = properties.get(renderTarget).__webglMultisampledFramebuffer;
                else if (Array.isArray(__webglFramebuffer)) framebuffer = __webglFramebuffer[activeMipmapLevel];
                else framebuffer = __webglFramebuffer;
                _currentViewport.copy(renderTarget.viewport);
                _currentScissor.copy(renderTarget.scissor);
                _currentScissorTest = renderTarget.scissorTest;
            } else {
                _currentViewport.copy(_viewport).multiplyScalar(_pixelRatio).floor();
                _currentScissor.copy(_scissor).multiplyScalar(_pixelRatio).floor();
                _currentScissorTest = _scissorTest;
            }
            const framebufferBound = state.bindFramebuffer(_gl.FRAMEBUFFER, framebuffer);
            if (framebufferBound && useDefaultFramebuffer) state.drawBuffers(renderTarget, framebuffer);
            state.viewport(_currentViewport);
            state.scissor(_currentScissor);
            state.setScissorTest(_currentScissorTest);
            if (isCube) {
                const textureProperties = properties.get(renderTarget.texture);
                _gl.framebufferTexture2D(_gl.FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_CUBE_MAP_POSITIVE_X + activeCubeFace, textureProperties.__webglTexture, activeMipmapLevel);
            } else if (isRenderTarget3D) {
                const textureProperties = properties.get(renderTarget.texture);
                const layer = activeCubeFace || 0;
                _gl.framebufferTextureLayer(_gl.FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, textureProperties.__webglTexture, activeMipmapLevel || 0, layer);
            }
            _currentMaterialId = -1; // reset current material to ensure correct uniform bindings
        };
        this.readRenderTargetPixels = function(renderTarget, x, y, width, height, buffer, activeCubeFaceIndex) {
            if (!(renderTarget && renderTarget.isWebGLRenderTarget)) {
                console.error('THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not THREE.WebGLRenderTarget.');
                return;
            }
            let framebuffer = properties.get(renderTarget).__webglFramebuffer;
            if (renderTarget.isWebGLCubeRenderTarget && activeCubeFaceIndex !== undefined) framebuffer = framebuffer[activeCubeFaceIndex];
            if (framebuffer) {
                state.bindFramebuffer(_gl.FRAMEBUFFER, framebuffer);
                try {
                    const texture = renderTarget.texture;
                    const textureFormat = texture.format;
                    const textureType = texture.type;
                    if (!capabilities.textureFormatReadable(textureFormat)) {
                        console.error('THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not in RGBA or implementation defined format.');
                        return;
                    }
                    if (!capabilities.textureTypeReadable(textureType)) {
                        console.error('THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not in UnsignedByteType or implementation defined type.');
                        return;
                    }
                    // the following if statement ensures valid read requests (no out-of-bounds pixels, see #8604)
                    if (x >= 0 && x <= renderTarget.width - width && y >= 0 && y <= renderTarget.height - height) _gl.readPixels(x, y, width, height, utils.convert(textureFormat), utils.convert(textureType), buffer);
                } finally{
                    // restore framebuffer of current render target if necessary
                    const framebuffer = _currentRenderTarget !== null ? properties.get(_currentRenderTarget).__webglFramebuffer : null;
                    state.bindFramebuffer(_gl.FRAMEBUFFER, framebuffer);
                }
            }
        };
        this.readRenderTargetPixelsAsync = async function(renderTarget, x, y, width, height, buffer, activeCubeFaceIndex) {
            if (!(renderTarget && renderTarget.isWebGLRenderTarget)) throw new Error('THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not THREE.WebGLRenderTarget.');
            let framebuffer = properties.get(renderTarget).__webglFramebuffer;
            if (renderTarget.isWebGLCubeRenderTarget && activeCubeFaceIndex !== undefined) framebuffer = framebuffer[activeCubeFaceIndex];
            if (framebuffer) {
                const texture = renderTarget.texture;
                const textureFormat = texture.format;
                const textureType = texture.type;
                if (!capabilities.textureFormatReadable(textureFormat)) throw new Error('THREE.WebGLRenderer.readRenderTargetPixelsAsync: renderTarget is not in RGBA or implementation defined format.');
                if (!capabilities.textureTypeReadable(textureType)) throw new Error('THREE.WebGLRenderer.readRenderTargetPixelsAsync: renderTarget is not in UnsignedByteType or implementation defined type.');
                // the following if statement ensures valid read requests (no out-of-bounds pixels, see #8604)
                if (x >= 0 && x <= renderTarget.width - width && y >= 0 && y <= renderTarget.height - height) {
                    // set the active frame buffer to the one we want to read
                    state.bindFramebuffer(_gl.FRAMEBUFFER, framebuffer);
                    const glBuffer = _gl.createBuffer();
                    _gl.bindBuffer(_gl.PIXEL_PACK_BUFFER, glBuffer);
                    _gl.bufferData(_gl.PIXEL_PACK_BUFFER, buffer.byteLength, _gl.STREAM_READ);
                    _gl.readPixels(x, y, width, height, utils.convert(textureFormat), utils.convert(textureType), 0);
                    // reset the frame buffer to the currently set buffer before waiting
                    const currFramebuffer = _currentRenderTarget !== null ? properties.get(_currentRenderTarget).__webglFramebuffer : null;
                    state.bindFramebuffer(_gl.FRAMEBUFFER, currFramebuffer);
                    // check if the commands have finished every 8 ms
                    const sync = _gl.fenceSync(_gl.SYNC_GPU_COMMANDS_COMPLETE, 0);
                    _gl.flush();
                    await $d5b33d7c30034067$var$probeAsync(_gl, sync, 4);
                    // read the data and delete the buffer
                    _gl.bindBuffer(_gl.PIXEL_PACK_BUFFER, glBuffer);
                    _gl.getBufferSubData(_gl.PIXEL_PACK_BUFFER, 0, buffer);
                    _gl.deleteBuffer(glBuffer);
                    _gl.deleteSync(sync);
                    return buffer;
                } else throw new Error('THREE.WebGLRenderer.readRenderTargetPixelsAsync: requested read bounds are out of range.');
            }
        };
        this.copyFramebufferToTexture = function(texture, position = null, level = 0) {
            // support previous signature with position first
            if (texture.isTexture !== true) {
                // @deprecated, r165
                $d5b33d7c30034067$var$warnOnce('WebGLRenderer: copyFramebufferToTexture function signature has changed.');
                position = arguments[0] || null;
                texture = arguments[1];
            }
            const levelScale = Math.pow(2, -level);
            const width = Math.floor(texture.image.width * levelScale);
            const height = Math.floor(texture.image.height * levelScale);
            const x = position !== null ? position.x : 0;
            const y = position !== null ? position.y : 0;
            textures.setTexture2D(texture, 0);
            _gl.copyTexSubImage2D(_gl.TEXTURE_2D, level, 0, 0, x, y, width, height);
            state.unbindTexture();
        };
        this.copyTextureToTexture = function(srcTexture, dstTexture, srcRegion = null, dstPosition = null, level = 0) {
            // support previous signature with dstPosition first
            if (srcTexture.isTexture !== true) {
                // @deprecated, r165
                $d5b33d7c30034067$var$warnOnce('WebGLRenderer: copyTextureToTexture function signature has changed.');
                dstPosition = arguments[0] || null;
                srcTexture = arguments[1];
                dstTexture = arguments[2];
                level = arguments[3] || 0;
                srcRegion = null;
            }
            // gather the necessary dimensions to copy
            let width, height, depth, minX, minY, minZ;
            let dstX, dstY, dstZ;
            const image = srcTexture.isCompressedTexture ? srcTexture.mipmaps[level] : srcTexture.image;
            if (srcRegion !== null) {
                width = srcRegion.max.x - srcRegion.min.x;
                height = srcRegion.max.y - srcRegion.min.y;
                depth = srcRegion.isBox3 ? srcRegion.max.z - srcRegion.min.z : 1;
                minX = srcRegion.min.x;
                minY = srcRegion.min.y;
                minZ = srcRegion.isBox3 ? srcRegion.min.z : 0;
            } else {
                width = image.width;
                height = image.height;
                depth = image.depth || 1;
                minX = 0;
                minY = 0;
                minZ = 0;
            }
            if (dstPosition !== null) {
                dstX = dstPosition.x;
                dstY = dstPosition.y;
                dstZ = dstPosition.z;
            } else {
                dstX = 0;
                dstY = 0;
                dstZ = 0;
            }
            // Set up the destination target
            const glFormat = utils.convert(dstTexture.format);
            const glType = utils.convert(dstTexture.type);
            let glTarget;
            if (dstTexture.isData3DTexture) {
                textures.setTexture3D(dstTexture, 0);
                glTarget = _gl.TEXTURE_3D;
            } else if (dstTexture.isDataArrayTexture || dstTexture.isCompressedArrayTexture) {
                textures.setTexture2DArray(dstTexture, 0);
                glTarget = _gl.TEXTURE_2D_ARRAY;
            } else {
                textures.setTexture2D(dstTexture, 0);
                glTarget = _gl.TEXTURE_2D;
            }
            _gl.pixelStorei(_gl.UNPACK_FLIP_Y_WEBGL, dstTexture.flipY);
            _gl.pixelStorei(_gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, dstTexture.premultiplyAlpha);
            _gl.pixelStorei(_gl.UNPACK_ALIGNMENT, dstTexture.unpackAlignment);
            // used for copying data from cpu
            const currentUnpackRowLen = _gl.getParameter(_gl.UNPACK_ROW_LENGTH);
            const currentUnpackImageHeight = _gl.getParameter(_gl.UNPACK_IMAGE_HEIGHT);
            const currentUnpackSkipPixels = _gl.getParameter(_gl.UNPACK_SKIP_PIXELS);
            const currentUnpackSkipRows = _gl.getParameter(_gl.UNPACK_SKIP_ROWS);
            const currentUnpackSkipImages = _gl.getParameter(_gl.UNPACK_SKIP_IMAGES);
            _gl.pixelStorei(_gl.UNPACK_ROW_LENGTH, image.width);
            _gl.pixelStorei(_gl.UNPACK_IMAGE_HEIGHT, image.height);
            _gl.pixelStorei(_gl.UNPACK_SKIP_PIXELS, minX);
            _gl.pixelStorei(_gl.UNPACK_SKIP_ROWS, minY);
            _gl.pixelStorei(_gl.UNPACK_SKIP_IMAGES, minZ);
            // set up the src texture
            const isSrc3D = srcTexture.isDataArrayTexture || srcTexture.isData3DTexture;
            const isDst3D = dstTexture.isDataArrayTexture || dstTexture.isData3DTexture;
            if (srcTexture.isRenderTargetTexture || srcTexture.isDepthTexture) {
                const srcTextureProperties = properties.get(srcTexture);
                const dstTextureProperties = properties.get(dstTexture);
                const srcRenderTargetProperties = properties.get(srcTextureProperties.__renderTarget);
                const dstRenderTargetProperties = properties.get(dstTextureProperties.__renderTarget);
                state.bindFramebuffer(_gl.READ_FRAMEBUFFER, srcRenderTargetProperties.__webglFramebuffer);
                state.bindFramebuffer(_gl.DRAW_FRAMEBUFFER, dstRenderTargetProperties.__webglFramebuffer);
                for(let i = 0; i < depth; i++){
                    // if the source or destination are a 3d target then a layer needs to be bound
                    if (isSrc3D) _gl.framebufferTextureLayer(_gl.READ_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, properties.get(srcTexture).__webglTexture, level, minZ + i);
                    if (srcTexture.isDepthTexture) {
                        if (isDst3D) _gl.framebufferTextureLayer(_gl.DRAW_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, properties.get(dstTexture).__webglTexture, level, dstZ + i);
                        _gl.blitFramebuffer(minX, minY, width, height, dstX, dstY, width, height, _gl.DEPTH_BUFFER_BIT, _gl.NEAREST);
                    } else if (isDst3D) _gl.copyTexSubImage3D(glTarget, level, dstX, dstY, dstZ + i, minX, minY, width, height);
                    else _gl.copyTexSubImage2D(glTarget, level, dstX, dstY, dstZ + i, minX, minY, width, height);
                }
                state.bindFramebuffer(_gl.READ_FRAMEBUFFER, null);
                state.bindFramebuffer(_gl.DRAW_FRAMEBUFFER, null);
            } else if (isDst3D) {
                // copy data into the 3d texture
                if (srcTexture.isDataTexture || srcTexture.isData3DTexture) _gl.texSubImage3D(glTarget, level, dstX, dstY, dstZ, width, height, depth, glFormat, glType, image.data);
                else if (dstTexture.isCompressedArrayTexture) _gl.compressedTexSubImage3D(glTarget, level, dstX, dstY, dstZ, width, height, depth, glFormat, image.data);
                else _gl.texSubImage3D(glTarget, level, dstX, dstY, dstZ, width, height, depth, glFormat, glType, image);
            } else {
                // copy data into the 2d texture
                if (srcTexture.isDataTexture) _gl.texSubImage2D(_gl.TEXTURE_2D, level, dstX, dstY, width, height, glFormat, glType, image.data);
                else if (srcTexture.isCompressedTexture) _gl.compressedTexSubImage2D(_gl.TEXTURE_2D, level, dstX, dstY, image.width, image.height, glFormat, image.data);
                else _gl.texSubImage2D(_gl.TEXTURE_2D, level, dstX, dstY, width, height, glFormat, glType, image);
            }
            // reset values
            _gl.pixelStorei(_gl.UNPACK_ROW_LENGTH, currentUnpackRowLen);
            _gl.pixelStorei(_gl.UNPACK_IMAGE_HEIGHT, currentUnpackImageHeight);
            _gl.pixelStorei(_gl.UNPACK_SKIP_PIXELS, currentUnpackSkipPixels);
            _gl.pixelStorei(_gl.UNPACK_SKIP_ROWS, currentUnpackSkipRows);
            _gl.pixelStorei(_gl.UNPACK_SKIP_IMAGES, currentUnpackSkipImages);
            // Generate mipmaps only when copying level 0
            if (level === 0 && dstTexture.generateMipmaps) _gl.generateMipmap(glTarget);
            state.unbindTexture();
        };
        this.copyTextureToTexture3D = function(srcTexture, dstTexture, srcRegion = null, dstPosition = null, level = 0) {
            // support previous signature with source box first
            if (srcTexture.isTexture !== true) {
                // @deprecated, r165
                $d5b33d7c30034067$var$warnOnce('WebGLRenderer: copyTextureToTexture3D function signature has changed.');
                srcRegion = arguments[0] || null;
                dstPosition = arguments[1] || null;
                srcTexture = arguments[2];
                dstTexture = arguments[3];
                level = arguments[4] || 0;
            }
            // @deprecated, r170
            $d5b33d7c30034067$var$warnOnce('WebGLRenderer: copyTextureToTexture3D function has been deprecated. Use "copyTextureToTexture" instead.');
            return this.copyTextureToTexture(srcTexture, dstTexture, srcRegion, dstPosition, level);
        };
        this.initRenderTarget = function(target) {
            if (properties.get(target).__webglFramebuffer === undefined) textures.setupRenderTarget(target);
        };
        this.initTexture = function(texture) {
            if (texture.isCubeTexture) textures.setTextureCube(texture, 0);
            else if (texture.isData3DTexture) textures.setTexture3D(texture, 0);
            else if (texture.isDataArrayTexture || texture.isCompressedArrayTexture) textures.setTexture2DArray(texture, 0);
            else textures.setTexture2D(texture, 0);
            state.unbindTexture();
        };
        this.resetState = function() {
            _currentActiveCubeFace = 0;
            _currentActiveMipmapLevel = 0;
            _currentRenderTarget = null;
            state.reset();
            bindingStates.reset();
        };
        if (typeof __THREE_DEVTOOLS__ !== 'undefined') __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent('observe', {
            detail: this
        }));
    }
    get coordinateSystem() {
        return $d5b33d7c30034067$export$5a0e9190d10875d3;
    }
    get outputColorSpace() {
        return this._outputColorSpace;
    }
    set outputColorSpace(colorSpace) {
        this._outputColorSpace = colorSpace;
        const gl = this.getContext();
        gl.drawingBufferColorspace = $d5b33d7c30034067$export$5e6fd513f44698c._getDrawingBufferColorSpace(colorSpace);
        gl.unpackColorSpace = $d5b33d7c30034067$export$5e6fd513f44698c._getUnpackColorSpace();
    }
}
class $d5b33d7c30034067$export$6f1519f023b8d0f6 {
    constructor(color, density = 0.00025){
        this.isFogExp2 = true;
        this.name = '';
        this.color = new $d5b33d7c30034067$export$892596cec99bc70e(color);
        this.density = density;
    }
    clone() {
        return new $d5b33d7c30034067$export$6f1519f023b8d0f6(this.color, this.density);
    }
    toJSON() {
        return {
            type: 'FogExp2',
            name: this.name,
            color: this.color.getHex(),
            density: this.density
        };
    }
}
class $d5b33d7c30034067$export$3c890837b09508d4 {
    constructor(color, near = 1, far = 1000){
        this.isFog = true;
        this.name = '';
        this.color = new $d5b33d7c30034067$export$892596cec99bc70e(color);
        this.near = near;
        this.far = far;
    }
    clone() {
        return new $d5b33d7c30034067$export$3c890837b09508d4(this.color, this.near, this.far);
    }
    toJSON() {
        return {
            type: 'Fog',
            name: this.name,
            color: this.color.getHex(),
            near: this.near,
            far: this.far
        };
    }
}
class $d5b33d7c30034067$export$38af1803e3442a7f extends $d5b33d7c30034067$export$e4dd07dff30cc924 {
    constructor(){
        super();
        this.isScene = true;
        this.type = 'Scene';
        this.background = null;
        this.environment = null;
        this.fog = null;
        this.backgroundBlurriness = 0;
        this.backgroundIntensity = 1;
        this.backgroundRotation = new $d5b33d7c30034067$export$d93cc409a0768c5f();
        this.environmentIntensity = 1;
        this.environmentRotation = new $d5b33d7c30034067$export$d93cc409a0768c5f();
        this.overrideMaterial = null;
        if (typeof __THREE_DEVTOOLS__ !== 'undefined') __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent('observe', {
            detail: this
        }));
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        if (source.background !== null) this.background = source.background.clone();
        if (source.environment !== null) this.environment = source.environment.clone();
        if (source.fog !== null) this.fog = source.fog.clone();
        this.backgroundBlurriness = source.backgroundBlurriness;
        this.backgroundIntensity = source.backgroundIntensity;
        this.backgroundRotation.copy(source.backgroundRotation);
        this.environmentIntensity = source.environmentIntensity;
        this.environmentRotation.copy(source.environmentRotation);
        if (source.overrideMaterial !== null) this.overrideMaterial = source.overrideMaterial.clone();
        this.matrixAutoUpdate = source.matrixAutoUpdate;
        return this;
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        if (this.fog !== null) data.object.fog = this.fog.toJSON();
        if (this.backgroundBlurriness > 0) data.object.backgroundBlurriness = this.backgroundBlurriness;
        if (this.backgroundIntensity !== 1) data.object.backgroundIntensity = this.backgroundIntensity;
        data.object.backgroundRotation = this.backgroundRotation.toArray();
        if (this.environmentIntensity !== 1) data.object.environmentIntensity = this.environmentIntensity;
        data.object.environmentRotation = this.environmentRotation.toArray();
        return data;
    }
}
class $d5b33d7c30034067$export$3d5cd879f108f53f {
    constructor(array, stride){
        this.isInterleavedBuffer = true;
        this.array = array;
        this.stride = stride;
        this.count = array !== undefined ? array.length / stride : 0;
        this.usage = $d5b33d7c30034067$export$763e8360f4d7f77d;
        this.updateRanges = [];
        this.version = 0;
        this.uuid = $d5b33d7c30034067$var$generateUUID();
    }
    onUploadCallback() {}
    set needsUpdate(value) {
        if (value === true) this.version++;
    }
    setUsage(value) {
        this.usage = value;
        return this;
    }
    addUpdateRange(start, count) {
        this.updateRanges.push({
            start: start,
            count: count
        });
    }
    clearUpdateRanges() {
        this.updateRanges.length = 0;
    }
    copy(source) {
        this.array = new source.array.constructor(source.array);
        this.count = source.count;
        this.stride = source.stride;
        this.usage = source.usage;
        return this;
    }
    copyAt(index1, attribute, index2) {
        index1 *= this.stride;
        index2 *= attribute.stride;
        for(let i = 0, l = this.stride; i < l; i++)this.array[index1 + i] = attribute.array[index2 + i];
        return this;
    }
    set(value, offset = 0) {
        this.array.set(value, offset);
        return this;
    }
    clone(data) {
        if (data.arrayBuffers === undefined) data.arrayBuffers = {};
        if (this.array.buffer._uuid === undefined) this.array.buffer._uuid = $d5b33d7c30034067$var$generateUUID();
        if (data.arrayBuffers[this.array.buffer._uuid] === undefined) data.arrayBuffers[this.array.buffer._uuid] = this.array.slice(0).buffer;
        const array = new this.array.constructor(data.arrayBuffers[this.array.buffer._uuid]);
        const ib = new this.constructor(array, this.stride);
        ib.setUsage(this.usage);
        return ib;
    }
    onUpload(callback) {
        this.onUploadCallback = callback;
        return this;
    }
    toJSON(data) {
        if (data.arrayBuffers === undefined) data.arrayBuffers = {};
        // generate UUID for array buffer if necessary
        if (this.array.buffer._uuid === undefined) this.array.buffer._uuid = $d5b33d7c30034067$var$generateUUID();
        if (data.arrayBuffers[this.array.buffer._uuid] === undefined) data.arrayBuffers[this.array.buffer._uuid] = Array.from(new Uint32Array(this.array.buffer));
        //
        return {
            uuid: this.uuid,
            buffer: this.array.buffer._uuid,
            type: this.array.constructor.name,
            stride: this.stride
        };
    }
}
const $d5b33d7c30034067$var$_vector$6 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
class $d5b33d7c30034067$export$920b6d07334599c7 {
    constructor(interleavedBuffer, itemSize, offset, normalized = false){
        this.isInterleavedBufferAttribute = true;
        this.name = '';
        this.data = interleavedBuffer;
        this.itemSize = itemSize;
        this.offset = offset;
        this.normalized = normalized;
    }
    get count() {
        return this.data.count;
    }
    get array() {
        return this.data.array;
    }
    set needsUpdate(value) {
        this.data.needsUpdate = value;
    }
    applyMatrix4(m) {
        for(let i = 0, l = this.data.count; i < l; i++){
            $d5b33d7c30034067$var$_vector$6.fromBufferAttribute(this, i);
            $d5b33d7c30034067$var$_vector$6.applyMatrix4(m);
            this.setXYZ(i, $d5b33d7c30034067$var$_vector$6.x, $d5b33d7c30034067$var$_vector$6.y, $d5b33d7c30034067$var$_vector$6.z);
        }
        return this;
    }
    applyNormalMatrix(m) {
        for(let i = 0, l = this.count; i < l; i++){
            $d5b33d7c30034067$var$_vector$6.fromBufferAttribute(this, i);
            $d5b33d7c30034067$var$_vector$6.applyNormalMatrix(m);
            this.setXYZ(i, $d5b33d7c30034067$var$_vector$6.x, $d5b33d7c30034067$var$_vector$6.y, $d5b33d7c30034067$var$_vector$6.z);
        }
        return this;
    }
    transformDirection(m) {
        for(let i = 0, l = this.count; i < l; i++){
            $d5b33d7c30034067$var$_vector$6.fromBufferAttribute(this, i);
            $d5b33d7c30034067$var$_vector$6.transformDirection(m);
            this.setXYZ(i, $d5b33d7c30034067$var$_vector$6.x, $d5b33d7c30034067$var$_vector$6.y, $d5b33d7c30034067$var$_vector$6.z);
        }
        return this;
    }
    getComponent(index, component) {
        let value = this.array[index * this.data.stride + this.offset + component];
        if (this.normalized) value = $d5b33d7c30034067$var$denormalize(value, this.array);
        return value;
    }
    setComponent(index, component, value) {
        if (this.normalized) value = $d5b33d7c30034067$var$normalize(value, this.array);
        this.data.array[index * this.data.stride + this.offset + component] = value;
        return this;
    }
    setX(index, x) {
        if (this.normalized) x = $d5b33d7c30034067$var$normalize(x, this.array);
        this.data.array[index * this.data.stride + this.offset] = x;
        return this;
    }
    setY(index, y) {
        if (this.normalized) y = $d5b33d7c30034067$var$normalize(y, this.array);
        this.data.array[index * this.data.stride + this.offset + 1] = y;
        return this;
    }
    setZ(index, z) {
        if (this.normalized) z = $d5b33d7c30034067$var$normalize(z, this.array);
        this.data.array[index * this.data.stride + this.offset + 2] = z;
        return this;
    }
    setW(index, w) {
        if (this.normalized) w = $d5b33d7c30034067$var$normalize(w, this.array);
        this.data.array[index * this.data.stride + this.offset + 3] = w;
        return this;
    }
    getX(index) {
        let x = this.data.array[index * this.data.stride + this.offset];
        if (this.normalized) x = $d5b33d7c30034067$var$denormalize(x, this.array);
        return x;
    }
    getY(index) {
        let y = this.data.array[index * this.data.stride + this.offset + 1];
        if (this.normalized) y = $d5b33d7c30034067$var$denormalize(y, this.array);
        return y;
    }
    getZ(index) {
        let z = this.data.array[index * this.data.stride + this.offset + 2];
        if (this.normalized) z = $d5b33d7c30034067$var$denormalize(z, this.array);
        return z;
    }
    getW(index) {
        let w = this.data.array[index * this.data.stride + this.offset + 3];
        if (this.normalized) w = $d5b33d7c30034067$var$denormalize(w, this.array);
        return w;
    }
    setXY(index, x, y) {
        index = index * this.data.stride + this.offset;
        if (this.normalized) {
            x = $d5b33d7c30034067$var$normalize(x, this.array);
            y = $d5b33d7c30034067$var$normalize(y, this.array);
        }
        this.data.array[index + 0] = x;
        this.data.array[index + 1] = y;
        return this;
    }
    setXYZ(index, x, y, z) {
        index = index * this.data.stride + this.offset;
        if (this.normalized) {
            x = $d5b33d7c30034067$var$normalize(x, this.array);
            y = $d5b33d7c30034067$var$normalize(y, this.array);
            z = $d5b33d7c30034067$var$normalize(z, this.array);
        }
        this.data.array[index + 0] = x;
        this.data.array[index + 1] = y;
        this.data.array[index + 2] = z;
        return this;
    }
    setXYZW(index, x, y, z, w) {
        index = index * this.data.stride + this.offset;
        if (this.normalized) {
            x = $d5b33d7c30034067$var$normalize(x, this.array);
            y = $d5b33d7c30034067$var$normalize(y, this.array);
            z = $d5b33d7c30034067$var$normalize(z, this.array);
            w = $d5b33d7c30034067$var$normalize(w, this.array);
        }
        this.data.array[index + 0] = x;
        this.data.array[index + 1] = y;
        this.data.array[index + 2] = z;
        this.data.array[index + 3] = w;
        return this;
    }
    clone(data) {
        if (data === undefined) {
            console.log('THREE.InterleavedBufferAttribute.clone(): Cloning an interleaved buffer attribute will de-interleave buffer data.');
            const array = [];
            for(let i = 0; i < this.count; i++){
                const index = i * this.data.stride + this.offset;
                for(let j = 0; j < this.itemSize; j++)array.push(this.data.array[index + j]);
            }
            return new $d5b33d7c30034067$export$8dea267bd6bde117(new this.array.constructor(array), this.itemSize, this.normalized);
        } else {
            if (data.interleavedBuffers === undefined) data.interleavedBuffers = {};
            if (data.interleavedBuffers[this.data.uuid] === undefined) data.interleavedBuffers[this.data.uuid] = this.data.clone(data);
            return new $d5b33d7c30034067$export$920b6d07334599c7(data.interleavedBuffers[this.data.uuid], this.itemSize, this.offset, this.normalized);
        }
    }
    toJSON(data) {
        if (data === undefined) {
            console.log('THREE.InterleavedBufferAttribute.toJSON(): Serializing an interleaved buffer attribute will de-interleave buffer data.');
            const array = [];
            for(let i = 0; i < this.count; i++){
                const index = i * this.data.stride + this.offset;
                for(let j = 0; j < this.itemSize; j++)array.push(this.data.array[index + j]);
            }
            // de-interleave data and save it as an ordinary buffer attribute for now
            return {
                itemSize: this.itemSize,
                type: this.array.constructor.name,
                array: array,
                normalized: this.normalized
            };
        } else {
            // save as true interleaved attribute
            if (data.interleavedBuffers === undefined) data.interleavedBuffers = {};
            if (data.interleavedBuffers[this.data.uuid] === undefined) data.interleavedBuffers[this.data.uuid] = this.data.toJSON(data);
            return {
                isInterleavedBufferAttribute: true,
                itemSize: this.itemSize,
                data: this.data.uuid,
                offset: this.offset,
                normalized: this.normalized
            };
        }
    }
}
class $d5b33d7c30034067$export$5ec7dd1c6994bf8e extends $d5b33d7c30034067$export$a2d8b23205c25948 {
    static get type() {
        return 'SpriteMaterial';
    }
    constructor(parameters){
        super();
        this.isSpriteMaterial = true;
        this.color = new $d5b33d7c30034067$export$892596cec99bc70e(0xffffff);
        this.map = null;
        this.alphaMap = null;
        this.rotation = 0;
        this.sizeAttenuation = true;
        this.transparent = true;
        this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.map = source.map;
        this.alphaMap = source.alphaMap;
        this.rotation = source.rotation;
        this.sizeAttenuation = source.sizeAttenuation;
        this.fog = source.fog;
        return this;
    }
}
let $d5b33d7c30034067$var$_geometry;
const $d5b33d7c30034067$var$_intersectPoint = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_worldScale = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_mvPosition = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_alignedPosition = /*@__PURE__*/ new $d5b33d7c30034067$export$c977b3e384af9ae1();
const $d5b33d7c30034067$var$_rotatedPosition = /*@__PURE__*/ new $d5b33d7c30034067$export$c977b3e384af9ae1();
const $d5b33d7c30034067$var$_viewWorldMatrix = /*@__PURE__*/ new $d5b33d7c30034067$export$2ae72fc923e5eb5();
const $d5b33d7c30034067$var$_vA = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_vB = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_vC = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_uvA = /*@__PURE__*/ new $d5b33d7c30034067$export$c977b3e384af9ae1();
const $d5b33d7c30034067$var$_uvB = /*@__PURE__*/ new $d5b33d7c30034067$export$c977b3e384af9ae1();
const $d5b33d7c30034067$var$_uvC = /*@__PURE__*/ new $d5b33d7c30034067$export$c977b3e384af9ae1();
class $d5b33d7c30034067$export$3075603db8e6204c extends $d5b33d7c30034067$export$e4dd07dff30cc924 {
    constructor(material = new $d5b33d7c30034067$export$5ec7dd1c6994bf8e()){
        super();
        this.isSprite = true;
        this.type = 'Sprite';
        if ($d5b33d7c30034067$var$_geometry === undefined) {
            $d5b33d7c30034067$var$_geometry = new $d5b33d7c30034067$export$b7be63a67df8959();
            const float32Array = new Float32Array([
                -0.5,
                -0.5,
                0,
                0,
                0,
                0.5,
                -0.5,
                0,
                1,
                0,
                0.5,
                0.5,
                0,
                1,
                1,
                -0.5,
                0.5,
                0,
                0,
                1
            ]);
            const interleavedBuffer = new $d5b33d7c30034067$export$3d5cd879f108f53f(float32Array, 5);
            $d5b33d7c30034067$var$_geometry.setIndex([
                0,
                1,
                2,
                0,
                2,
                3
            ]);
            $d5b33d7c30034067$var$_geometry.setAttribute('position', new $d5b33d7c30034067$export$920b6d07334599c7(interleavedBuffer, 3, 0, false));
            $d5b33d7c30034067$var$_geometry.setAttribute('uv', new $d5b33d7c30034067$export$920b6d07334599c7(interleavedBuffer, 2, 3, false));
        }
        this.geometry = $d5b33d7c30034067$var$_geometry;
        this.material = material;
        this.center = new $d5b33d7c30034067$export$c977b3e384af9ae1(0.5, 0.5);
    }
    raycast(raycaster, intersects) {
        if (raycaster.camera === null) console.error('THREE.Sprite: "Raycaster.camera" needs to be set in order to raycast against sprites.');
        $d5b33d7c30034067$var$_worldScale.setFromMatrixScale(this.matrixWorld);
        $d5b33d7c30034067$var$_viewWorldMatrix.copy(raycaster.camera.matrixWorld);
        this.modelViewMatrix.multiplyMatrices(raycaster.camera.matrixWorldInverse, this.matrixWorld);
        $d5b33d7c30034067$var$_mvPosition.setFromMatrixPosition(this.modelViewMatrix);
        if (raycaster.camera.isPerspectiveCamera && this.material.sizeAttenuation === false) $d5b33d7c30034067$var$_worldScale.multiplyScalar(-$d5b33d7c30034067$var$_mvPosition.z);
        const rotation = this.material.rotation;
        let sin, cos;
        if (rotation !== 0) {
            cos = Math.cos(rotation);
            sin = Math.sin(rotation);
        }
        const center = this.center;
        $d5b33d7c30034067$var$transformVertex($d5b33d7c30034067$var$_vA.set(-0.5, -0.5, 0), $d5b33d7c30034067$var$_mvPosition, center, $d5b33d7c30034067$var$_worldScale, sin, cos);
        $d5b33d7c30034067$var$transformVertex($d5b33d7c30034067$var$_vB.set(0.5, -0.5, 0), $d5b33d7c30034067$var$_mvPosition, center, $d5b33d7c30034067$var$_worldScale, sin, cos);
        $d5b33d7c30034067$var$transformVertex($d5b33d7c30034067$var$_vC.set(0.5, 0.5, 0), $d5b33d7c30034067$var$_mvPosition, center, $d5b33d7c30034067$var$_worldScale, sin, cos);
        $d5b33d7c30034067$var$_uvA.set(0, 0);
        $d5b33d7c30034067$var$_uvB.set(1, 0);
        $d5b33d7c30034067$var$_uvC.set(1, 1);
        // check first triangle
        let intersect = raycaster.ray.intersectTriangle($d5b33d7c30034067$var$_vA, $d5b33d7c30034067$var$_vB, $d5b33d7c30034067$var$_vC, false, $d5b33d7c30034067$var$_intersectPoint);
        if (intersect === null) {
            // check second triangle
            $d5b33d7c30034067$var$transformVertex($d5b33d7c30034067$var$_vB.set(-0.5, 0.5, 0), $d5b33d7c30034067$var$_mvPosition, center, $d5b33d7c30034067$var$_worldScale, sin, cos);
            $d5b33d7c30034067$var$_uvB.set(0, 1);
            intersect = raycaster.ray.intersectTriangle($d5b33d7c30034067$var$_vA, $d5b33d7c30034067$var$_vC, $d5b33d7c30034067$var$_vB, false, $d5b33d7c30034067$var$_intersectPoint);
            if (intersect === null) return;
        }
        const distance = raycaster.ray.origin.distanceTo($d5b33d7c30034067$var$_intersectPoint);
        if (distance < raycaster.near || distance > raycaster.far) return;
        intersects.push({
            distance: distance,
            point: $d5b33d7c30034067$var$_intersectPoint.clone(),
            uv: $d5b33d7c30034067$export$5a465592bfe74b48.getInterpolation($d5b33d7c30034067$var$_intersectPoint, $d5b33d7c30034067$var$_vA, $d5b33d7c30034067$var$_vB, $d5b33d7c30034067$var$_vC, $d5b33d7c30034067$var$_uvA, $d5b33d7c30034067$var$_uvB, $d5b33d7c30034067$var$_uvC, new $d5b33d7c30034067$export$c977b3e384af9ae1()),
            face: null,
            object: this
        });
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        if (source.center !== undefined) this.center.copy(source.center);
        this.material = source.material;
        return this;
    }
}
function $d5b33d7c30034067$var$transformVertex(vertexPosition, mvPosition, center, scale, sin, cos) {
    // compute position in camera space
    $d5b33d7c30034067$var$_alignedPosition.subVectors(vertexPosition, center).addScalar(0.5).multiply(scale);
    // to check if rotation is not zero
    if (sin !== undefined) {
        $d5b33d7c30034067$var$_rotatedPosition.x = cos * $d5b33d7c30034067$var$_alignedPosition.x - sin * $d5b33d7c30034067$var$_alignedPosition.y;
        $d5b33d7c30034067$var$_rotatedPosition.y = sin * $d5b33d7c30034067$var$_alignedPosition.x + cos * $d5b33d7c30034067$var$_alignedPosition.y;
    } else $d5b33d7c30034067$var$_rotatedPosition.copy($d5b33d7c30034067$var$_alignedPosition);
    vertexPosition.copy(mvPosition);
    vertexPosition.x += $d5b33d7c30034067$var$_rotatedPosition.x;
    vertexPosition.y += $d5b33d7c30034067$var$_rotatedPosition.y;
    // transform to world space
    vertexPosition.applyMatrix4($d5b33d7c30034067$var$_viewWorldMatrix);
}
const $d5b33d7c30034067$var$_v1$2 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_v2$1 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
class $d5b33d7c30034067$export$112e7237be0c5f30 extends $d5b33d7c30034067$export$e4dd07dff30cc924 {
    constructor(){
        super();
        this._currentLevel = 0;
        this.type = 'LOD';
        Object.defineProperties(this, {
            levels: {
                enumerable: true,
                value: []
            },
            isLOD: {
                value: true
            }
        });
        this.autoUpdate = true;
    }
    copy(source) {
        super.copy(source, false);
        const levels = source.levels;
        for(let i = 0, l = levels.length; i < l; i++){
            const level = levels[i];
            this.addLevel(level.object.clone(), level.distance, level.hysteresis);
        }
        this.autoUpdate = source.autoUpdate;
        return this;
    }
    addLevel(object, distance = 0, hysteresis = 0) {
        distance = Math.abs(distance);
        const levels = this.levels;
        let l;
        for(l = 0; l < levels.length; l++){
            if (distance < levels[l].distance) break;
        }
        levels.splice(l, 0, {
            distance: distance,
            hysteresis: hysteresis,
            object: object
        });
        this.add(object);
        return this;
    }
    removeLevel(distance) {
        const levels = this.levels;
        for(let i = 0; i < levels.length; i++)if (levels[i].distance === distance) {
            const removedElements = levels.splice(i, 1);
            this.remove(removedElements[0].object);
            return true;
        }
        return false;
    }
    getCurrentLevel() {
        return this._currentLevel;
    }
    getObjectForDistance(distance) {
        const levels = this.levels;
        if (levels.length > 0) {
            let i, l;
            for(i = 1, l = levels.length; i < l; i++){
                let levelDistance = levels[i].distance;
                if (levels[i].object.visible) levelDistance -= levelDistance * levels[i].hysteresis;
                if (distance < levelDistance) break;
            }
            return levels[i - 1].object;
        }
        return null;
    }
    raycast(raycaster, intersects) {
        const levels = this.levels;
        if (levels.length > 0) {
            $d5b33d7c30034067$var$_v1$2.setFromMatrixPosition(this.matrixWorld);
            const distance = raycaster.ray.origin.distanceTo($d5b33d7c30034067$var$_v1$2);
            this.getObjectForDistance(distance).raycast(raycaster, intersects);
        }
    }
    update(camera) {
        const levels = this.levels;
        if (levels.length > 1) {
            $d5b33d7c30034067$var$_v1$2.setFromMatrixPosition(camera.matrixWorld);
            $d5b33d7c30034067$var$_v2$1.setFromMatrixPosition(this.matrixWorld);
            const distance = $d5b33d7c30034067$var$_v1$2.distanceTo($d5b33d7c30034067$var$_v2$1) / camera.zoom;
            levels[0].object.visible = true;
            let i, l;
            for(i = 1, l = levels.length; i < l; i++){
                let levelDistance = levels[i].distance;
                if (levels[i].object.visible) levelDistance -= levelDistance * levels[i].hysteresis;
                if (distance >= levelDistance) {
                    levels[i - 1].object.visible = false;
                    levels[i].object.visible = true;
                } else break;
            }
            this._currentLevel = i - 1;
            for(; i < l; i++)levels[i].object.visible = false;
        }
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        if (this.autoUpdate === false) data.object.autoUpdate = false;
        data.object.levels = [];
        const levels = this.levels;
        for(let i = 0, l = levels.length; i < l; i++){
            const level = levels[i];
            data.object.levels.push({
                object: level.object.uuid,
                distance: level.distance,
                hysteresis: level.hysteresis
            });
        }
        return data;
    }
}
const $d5b33d7c30034067$var$_basePosition = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_skinIndex = /*@__PURE__*/ new $d5b33d7c30034067$export$fa7daccca11cdbe3();
const $d5b33d7c30034067$var$_skinWeight = /*@__PURE__*/ new $d5b33d7c30034067$export$fa7daccca11cdbe3();
const $d5b33d7c30034067$var$_vector3 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_matrix4 = /*@__PURE__*/ new $d5b33d7c30034067$export$2ae72fc923e5eb5();
const $d5b33d7c30034067$var$_vertex = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_sphere$4 = /*@__PURE__*/ new $d5b33d7c30034067$export$805e8b72413ccaba();
const $d5b33d7c30034067$var$_inverseMatrix$2 = /*@__PURE__*/ new $d5b33d7c30034067$export$2ae72fc923e5eb5();
const $d5b33d7c30034067$var$_ray$2 = /*@__PURE__*/ new $d5b33d7c30034067$export$a186db52eed6d40e();
class $d5b33d7c30034067$export$b303577035157ecf extends $d5b33d7c30034067$export$e176487c05830cc5 {
    constructor(geometry, material){
        super(geometry, material);
        this.isSkinnedMesh = true;
        this.type = 'SkinnedMesh';
        this.bindMode = $d5b33d7c30034067$export$2595a3798997538;
        this.bindMatrix = new $d5b33d7c30034067$export$2ae72fc923e5eb5();
        this.bindMatrixInverse = new $d5b33d7c30034067$export$2ae72fc923e5eb5();
        this.boundingBox = null;
        this.boundingSphere = null;
    }
    computeBoundingBox() {
        const geometry = this.geometry;
        if (this.boundingBox === null) this.boundingBox = new $d5b33d7c30034067$export$6f7d5a9418ab2aa3();
        this.boundingBox.makeEmpty();
        const positionAttribute = geometry.getAttribute('position');
        for(let i = 0; i < positionAttribute.count; i++){
            this.getVertexPosition(i, $d5b33d7c30034067$var$_vertex);
            this.boundingBox.expandByPoint($d5b33d7c30034067$var$_vertex);
        }
    }
    computeBoundingSphere() {
        const geometry = this.geometry;
        if (this.boundingSphere === null) this.boundingSphere = new $d5b33d7c30034067$export$805e8b72413ccaba();
        this.boundingSphere.makeEmpty();
        const positionAttribute = geometry.getAttribute('position');
        for(let i = 0; i < positionAttribute.count; i++){
            this.getVertexPosition(i, $d5b33d7c30034067$var$_vertex);
            this.boundingSphere.expandByPoint($d5b33d7c30034067$var$_vertex);
        }
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.bindMode = source.bindMode;
        this.bindMatrix.copy(source.bindMatrix);
        this.bindMatrixInverse.copy(source.bindMatrixInverse);
        this.skeleton = source.skeleton;
        if (source.boundingBox !== null) this.boundingBox = source.boundingBox.clone();
        if (source.boundingSphere !== null) this.boundingSphere = source.boundingSphere.clone();
        return this;
    }
    raycast(raycaster, intersects) {
        const material = this.material;
        const matrixWorld = this.matrixWorld;
        if (material === undefined) return;
        // test with bounding sphere in world space
        if (this.boundingSphere === null) this.computeBoundingSphere();
        $d5b33d7c30034067$var$_sphere$4.copy(this.boundingSphere);
        $d5b33d7c30034067$var$_sphere$4.applyMatrix4(matrixWorld);
        if (raycaster.ray.intersectsSphere($d5b33d7c30034067$var$_sphere$4) === false) return;
        // convert ray to local space of skinned mesh
        $d5b33d7c30034067$var$_inverseMatrix$2.copy(matrixWorld).invert();
        $d5b33d7c30034067$var$_ray$2.copy(raycaster.ray).applyMatrix4($d5b33d7c30034067$var$_inverseMatrix$2);
        // test with bounding box in local space
        if (this.boundingBox !== null) {
            if ($d5b33d7c30034067$var$_ray$2.intersectsBox(this.boundingBox) === false) return;
        }
        // test for intersections with geometry
        this._computeIntersections(raycaster, intersects, $d5b33d7c30034067$var$_ray$2);
    }
    getVertexPosition(index, target) {
        super.getVertexPosition(index, target);
        this.applyBoneTransform(index, target);
        return target;
    }
    bind(skeleton, bindMatrix) {
        this.skeleton = skeleton;
        if (bindMatrix === undefined) {
            this.updateMatrixWorld(true);
            this.skeleton.calculateInverses();
            bindMatrix = this.matrixWorld;
        }
        this.bindMatrix.copy(bindMatrix);
        this.bindMatrixInverse.copy(bindMatrix).invert();
    }
    pose() {
        this.skeleton.pose();
    }
    normalizeSkinWeights() {
        const vector = new $d5b33d7c30034067$export$fa7daccca11cdbe3();
        const skinWeight = this.geometry.attributes.skinWeight;
        for(let i = 0, l = skinWeight.count; i < l; i++){
            vector.fromBufferAttribute(skinWeight, i);
            const scale = 1.0 / vector.manhattanLength();
            if (scale !== Infinity) vector.multiplyScalar(scale);
            else vector.set(1, 0, 0, 0); // do something reasonable
            skinWeight.setXYZW(i, vector.x, vector.y, vector.z, vector.w);
        }
    }
    updateMatrixWorld(force) {
        super.updateMatrixWorld(force);
        if (this.bindMode === $d5b33d7c30034067$export$2595a3798997538) this.bindMatrixInverse.copy(this.matrixWorld).invert();
        else if (this.bindMode === $d5b33d7c30034067$export$d7e7dc2e114517a0) this.bindMatrixInverse.copy(this.bindMatrix).invert();
        else console.warn('THREE.SkinnedMesh: Unrecognized bindMode: ' + this.bindMode);
    }
    applyBoneTransform(index, vector) {
        const skeleton = this.skeleton;
        const geometry = this.geometry;
        $d5b33d7c30034067$var$_skinIndex.fromBufferAttribute(geometry.attributes.skinIndex, index);
        $d5b33d7c30034067$var$_skinWeight.fromBufferAttribute(geometry.attributes.skinWeight, index);
        $d5b33d7c30034067$var$_basePosition.copy(vector).applyMatrix4(this.bindMatrix);
        vector.set(0, 0, 0);
        for(let i = 0; i < 4; i++){
            const weight = $d5b33d7c30034067$var$_skinWeight.getComponent(i);
            if (weight !== 0) {
                const boneIndex = $d5b33d7c30034067$var$_skinIndex.getComponent(i);
                $d5b33d7c30034067$var$_matrix4.multiplyMatrices(skeleton.bones[boneIndex].matrixWorld, skeleton.boneInverses[boneIndex]);
                vector.addScaledVector($d5b33d7c30034067$var$_vector3.copy($d5b33d7c30034067$var$_basePosition).applyMatrix4($d5b33d7c30034067$var$_matrix4), weight);
            }
        }
        return vector.applyMatrix4(this.bindMatrixInverse);
    }
}
class $d5b33d7c30034067$export$b127726e56765aa4 extends $d5b33d7c30034067$export$e4dd07dff30cc924 {
    constructor(){
        super();
        this.isBone = true;
        this.type = 'Bone';
    }
}
class $d5b33d7c30034067$export$b691f601014eabe1 extends $d5b33d7c30034067$export$5431306cf43de24a {
    constructor(data = null, width = 1, height = 1, format, type, mapping, wrapS, wrapT, magFilter = $d5b33d7c30034067$export$727aa5ec3fe39bf0, minFilter = $d5b33d7c30034067$export$727aa5ec3fe39bf0, anisotropy, colorSpace){
        super(null, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, colorSpace);
        this.isDataTexture = true;
        this.image = {
            data: data,
            width: width,
            height: height
        };
        this.generateMipmaps = false;
        this.flipY = false;
        this.unpackAlignment = 1;
    }
}
const $d5b33d7c30034067$var$_offsetMatrix = /*@__PURE__*/ new $d5b33d7c30034067$export$2ae72fc923e5eb5();
const $d5b33d7c30034067$var$_identityMatrix = /*@__PURE__*/ new $d5b33d7c30034067$export$2ae72fc923e5eb5();
class $d5b33d7c30034067$export$8f31e4c4a37b8e9c {
    constructor(bones = [], boneInverses = []){
        this.uuid = $d5b33d7c30034067$var$generateUUID();
        this.bones = bones.slice(0);
        this.boneInverses = boneInverses;
        this.boneMatrices = null;
        this.boneTexture = null;
        this.init();
    }
    init() {
        const bones = this.bones;
        const boneInverses = this.boneInverses;
        this.boneMatrices = new Float32Array(bones.length * 16);
        // calculate inverse bone matrices if necessary
        if (boneInverses.length === 0) this.calculateInverses();
        else // handle special case
        if (bones.length !== boneInverses.length) {
            console.warn('THREE.Skeleton: Number of inverse bone matrices does not match amount of bones.');
            this.boneInverses = [];
            for(let i = 0, il = this.bones.length; i < il; i++)this.boneInverses.push(new $d5b33d7c30034067$export$2ae72fc923e5eb5());
        }
    }
    calculateInverses() {
        this.boneInverses.length = 0;
        for(let i = 0, il = this.bones.length; i < il; i++){
            const inverse = new $d5b33d7c30034067$export$2ae72fc923e5eb5();
            if (this.bones[i]) inverse.copy(this.bones[i].matrixWorld).invert();
            this.boneInverses.push(inverse);
        }
    }
    pose() {
        // recover the bind-time world matrices
        for(let i = 0, il = this.bones.length; i < il; i++){
            const bone = this.bones[i];
            if (bone) bone.matrixWorld.copy(this.boneInverses[i]).invert();
        }
        // compute the local matrices, positions, rotations and scales
        for(let i = 0, il = this.bones.length; i < il; i++){
            const bone = this.bones[i];
            if (bone) {
                if (bone.parent && bone.parent.isBone) {
                    bone.matrix.copy(bone.parent.matrixWorld).invert();
                    bone.matrix.multiply(bone.matrixWorld);
                } else bone.matrix.copy(bone.matrixWorld);
                bone.matrix.decompose(bone.position, bone.quaternion, bone.scale);
            }
        }
    }
    update() {
        const bones = this.bones;
        const boneInverses = this.boneInverses;
        const boneMatrices = this.boneMatrices;
        const boneTexture = this.boneTexture;
        // flatten bone matrices to array
        for(let i = 0, il = bones.length; i < il; i++){
            // compute the offset between the current and the original transform
            const matrix = bones[i] ? bones[i].matrixWorld : $d5b33d7c30034067$var$_identityMatrix;
            $d5b33d7c30034067$var$_offsetMatrix.multiplyMatrices(matrix, boneInverses[i]);
            $d5b33d7c30034067$var$_offsetMatrix.toArray(boneMatrices, i * 16);
        }
        if (boneTexture !== null) boneTexture.needsUpdate = true;
    }
    clone() {
        return new $d5b33d7c30034067$export$8f31e4c4a37b8e9c(this.bones, this.boneInverses);
    }
    computeBoneTexture() {
        // layout (1 matrix = 4 pixels)
        //      RGBA RGBA RGBA RGBA (=> column1, column2, column3, column4)
        //  with  8x8  pixel texture max   16 bones * 4 pixels =  (8 * 8)
        //       16x16 pixel texture max   64 bones * 4 pixels = (16 * 16)
        //       32x32 pixel texture max  256 bones * 4 pixels = (32 * 32)
        //       64x64 pixel texture max 1024 bones * 4 pixels = (64 * 64)
        let size = Math.sqrt(this.bones.length * 4); // 4 pixels needed for 1 matrix
        size = Math.ceil(size / 4) * 4;
        size = Math.max(size, 4);
        const boneMatrices = new Float32Array(size * size * 4); // 4 floats per RGBA pixel
        boneMatrices.set(this.boneMatrices); // copy current values
        const boneTexture = new $d5b33d7c30034067$export$b691f601014eabe1(boneMatrices, size, size, $d5b33d7c30034067$export$3f8bb04b555a363c, $d5b33d7c30034067$export$f6d331659b644596);
        boneTexture.needsUpdate = true;
        this.boneMatrices = boneMatrices;
        this.boneTexture = boneTexture;
        return this;
    }
    getBoneByName(name) {
        for(let i = 0, il = this.bones.length; i < il; i++){
            const bone = this.bones[i];
            if (bone.name === name) return bone;
        }
        return undefined;
    }
    dispose() {
        if (this.boneTexture !== null) {
            this.boneTexture.dispose();
            this.boneTexture = null;
        }
    }
    fromJSON(json, bones) {
        this.uuid = json.uuid;
        for(let i = 0, l = json.bones.length; i < l; i++){
            const uuid = json.bones[i];
            let bone = bones[uuid];
            if (bone === undefined) {
                console.warn('THREE.Skeleton: No bone found with UUID:', uuid);
                bone = new $d5b33d7c30034067$export$b127726e56765aa4();
            }
            this.bones.push(bone);
            this.boneInverses.push(new $d5b33d7c30034067$export$2ae72fc923e5eb5().fromArray(json.boneInverses[i]));
        }
        this.init();
        return this;
    }
    toJSON() {
        const data = {
            metadata: {
                version: 4.6,
                type: 'Skeleton',
                generator: 'Skeleton.toJSON'
            },
            bones: [],
            boneInverses: []
        };
        data.uuid = this.uuid;
        const bones = this.bones;
        const boneInverses = this.boneInverses;
        for(let i = 0, l = bones.length; i < l; i++){
            const bone = bones[i];
            data.bones.push(bone.uuid);
            const boneInverse = boneInverses[i];
            data.boneInverses.push(boneInverse.toArray());
        }
        return data;
    }
}
class $d5b33d7c30034067$export$32ea87a8b54d744a extends $d5b33d7c30034067$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized, meshPerAttribute = 1){
        super(array, itemSize, normalized);
        this.isInstancedBufferAttribute = true;
        this.meshPerAttribute = meshPerAttribute;
    }
    copy(source) {
        super.copy(source);
        this.meshPerAttribute = source.meshPerAttribute;
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.meshPerAttribute = this.meshPerAttribute;
        data.isInstancedBufferAttribute = true;
        return data;
    }
}
const $d5b33d7c30034067$var$_instanceLocalMatrix = /*@__PURE__*/ new $d5b33d7c30034067$export$2ae72fc923e5eb5();
const $d5b33d7c30034067$var$_instanceWorldMatrix = /*@__PURE__*/ new $d5b33d7c30034067$export$2ae72fc923e5eb5();
const $d5b33d7c30034067$var$_instanceIntersects = [];
const $d5b33d7c30034067$var$_box3 = /*@__PURE__*/ new $d5b33d7c30034067$export$6f7d5a9418ab2aa3();
const $d5b33d7c30034067$var$_identity = /*@__PURE__*/ new $d5b33d7c30034067$export$2ae72fc923e5eb5();
const $d5b33d7c30034067$var$_mesh$1 = /*@__PURE__*/ new $d5b33d7c30034067$export$e176487c05830cc5();
const $d5b33d7c30034067$var$_sphere$3 = /*@__PURE__*/ new $d5b33d7c30034067$export$805e8b72413ccaba();
class $d5b33d7c30034067$export$f3c979c331175ad7 extends $d5b33d7c30034067$export$e176487c05830cc5 {
    constructor(geometry, material, count){
        super(geometry, material);
        this.isInstancedMesh = true;
        this.instanceMatrix = new $d5b33d7c30034067$export$32ea87a8b54d744a(new Float32Array(count * 16), 16);
        this.instanceColor = null;
        this.morphTexture = null;
        this.count = count;
        this.boundingBox = null;
        this.boundingSphere = null;
        for(let i = 0; i < count; i++)this.setMatrixAt(i, $d5b33d7c30034067$var$_identity);
    }
    computeBoundingBox() {
        const geometry = this.geometry;
        const count = this.count;
        if (this.boundingBox === null) this.boundingBox = new $d5b33d7c30034067$export$6f7d5a9418ab2aa3();
        if (geometry.boundingBox === null) geometry.computeBoundingBox();
        this.boundingBox.makeEmpty();
        for(let i = 0; i < count; i++){
            this.getMatrixAt(i, $d5b33d7c30034067$var$_instanceLocalMatrix);
            $d5b33d7c30034067$var$_box3.copy(geometry.boundingBox).applyMatrix4($d5b33d7c30034067$var$_instanceLocalMatrix);
            this.boundingBox.union($d5b33d7c30034067$var$_box3);
        }
    }
    computeBoundingSphere() {
        const geometry = this.geometry;
        const count = this.count;
        if (this.boundingSphere === null) this.boundingSphere = new $d5b33d7c30034067$export$805e8b72413ccaba();
        if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
        this.boundingSphere.makeEmpty();
        for(let i = 0; i < count; i++){
            this.getMatrixAt(i, $d5b33d7c30034067$var$_instanceLocalMatrix);
            $d5b33d7c30034067$var$_sphere$3.copy(geometry.boundingSphere).applyMatrix4($d5b33d7c30034067$var$_instanceLocalMatrix);
            this.boundingSphere.union($d5b33d7c30034067$var$_sphere$3);
        }
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.instanceMatrix.copy(source.instanceMatrix);
        if (source.morphTexture !== null) this.morphTexture = source.morphTexture.clone();
        if (source.instanceColor !== null) this.instanceColor = source.instanceColor.clone();
        this.count = source.count;
        if (source.boundingBox !== null) this.boundingBox = source.boundingBox.clone();
        if (source.boundingSphere !== null) this.boundingSphere = source.boundingSphere.clone();
        return this;
    }
    getColorAt(index, color) {
        color.fromArray(this.instanceColor.array, index * 3);
    }
    getMatrixAt(index, matrix) {
        matrix.fromArray(this.instanceMatrix.array, index * 16);
    }
    getMorphAt(index, object) {
        const objectInfluences = object.morphTargetInfluences;
        const array = this.morphTexture.source.data.data;
        const len = objectInfluences.length + 1; // All influences + the baseInfluenceSum
        const dataIndex = index * len + 1; // Skip the baseInfluenceSum at the beginning
        for(let i = 0; i < objectInfluences.length; i++)objectInfluences[i] = array[dataIndex + i];
    }
    raycast(raycaster, intersects) {
        const matrixWorld = this.matrixWorld;
        const raycastTimes = this.count;
        $d5b33d7c30034067$var$_mesh$1.geometry = this.geometry;
        $d5b33d7c30034067$var$_mesh$1.material = this.material;
        if ($d5b33d7c30034067$var$_mesh$1.material === undefined) return;
        // test with bounding sphere first
        if (this.boundingSphere === null) this.computeBoundingSphere();
        $d5b33d7c30034067$var$_sphere$3.copy(this.boundingSphere);
        $d5b33d7c30034067$var$_sphere$3.applyMatrix4(matrixWorld);
        if (raycaster.ray.intersectsSphere($d5b33d7c30034067$var$_sphere$3) === false) return;
        // now test each instance
        for(let instanceId = 0; instanceId < raycastTimes; instanceId++){
            // calculate the world matrix for each instance
            this.getMatrixAt(instanceId, $d5b33d7c30034067$var$_instanceLocalMatrix);
            $d5b33d7c30034067$var$_instanceWorldMatrix.multiplyMatrices(matrixWorld, $d5b33d7c30034067$var$_instanceLocalMatrix);
            // the mesh represents this single instance
            $d5b33d7c30034067$var$_mesh$1.matrixWorld = $d5b33d7c30034067$var$_instanceWorldMatrix;
            $d5b33d7c30034067$var$_mesh$1.raycast(raycaster, $d5b33d7c30034067$var$_instanceIntersects);
            // process the result of raycast
            for(let i = 0, l = $d5b33d7c30034067$var$_instanceIntersects.length; i < l; i++){
                const intersect = $d5b33d7c30034067$var$_instanceIntersects[i];
                intersect.instanceId = instanceId;
                intersect.object = this;
                intersects.push(intersect);
            }
            $d5b33d7c30034067$var$_instanceIntersects.length = 0;
        }
    }
    setColorAt(index, color) {
        if (this.instanceColor === null) this.instanceColor = new $d5b33d7c30034067$export$32ea87a8b54d744a(new Float32Array(this.instanceMatrix.count * 3).fill(1), 3);
        color.toArray(this.instanceColor.array, index * 3);
    }
    setMatrixAt(index, matrix) {
        matrix.toArray(this.instanceMatrix.array, index * 16);
    }
    setMorphAt(index, object) {
        const objectInfluences = object.morphTargetInfluences;
        const len = objectInfluences.length + 1; // morphBaseInfluence + all influences
        if (this.morphTexture === null) this.morphTexture = new $d5b33d7c30034067$export$b691f601014eabe1(new Float32Array(len * this.count), len, this.count, $d5b33d7c30034067$export$4e041a7967d15c4b, $d5b33d7c30034067$export$f6d331659b644596);
        const array = this.morphTexture.source.data.data;
        let morphInfluencesSum = 0;
        for(let i = 0; i < objectInfluences.length; i++)morphInfluencesSum += objectInfluences[i];
        const morphBaseInfluence = this.geometry.morphTargetsRelative ? 1 : 1 - morphInfluencesSum;
        const dataIndex = len * index;
        array[dataIndex] = morphBaseInfluence;
        array.set(objectInfluences, dataIndex + 1);
    }
    updateMorphTargets() {}
    dispose() {
        this.dispatchEvent({
            type: 'dispose'
        });
        if (this.morphTexture !== null) {
            this.morphTexture.dispose();
            this.morphTexture = null;
        }
        return this;
    }
}
function $d5b33d7c30034067$var$ascIdSort(a, b) {
    return a - b;
}
function $d5b33d7c30034067$var$sortOpaque(a, b) {
    return a.z - b.z;
}
function $d5b33d7c30034067$var$sortTransparent(a, b) {
    return b.z - a.z;
}
class $d5b33d7c30034067$var$MultiDrawRenderList {
    constructor(){
        this.index = 0;
        this.pool = [];
        this.list = [];
    }
    push(start, count, z, index) {
        const pool = this.pool;
        const list = this.list;
        if (this.index >= pool.length) pool.push({
            start: -1,
            count: -1,
            z: -1,
            index: -1
        });
        const item = pool[this.index];
        list.push(item);
        this.index++;
        item.start = start;
        item.count = count;
        item.z = z;
        item.index = index;
    }
    reset() {
        this.list.length = 0;
        this.index = 0;
    }
}
const $d5b33d7c30034067$var$_matrix$1 = /*@__PURE__*/ new $d5b33d7c30034067$export$2ae72fc923e5eb5();
const $d5b33d7c30034067$var$_whiteColor = /*@__PURE__*/ new $d5b33d7c30034067$export$892596cec99bc70e(1, 1, 1);
const $d5b33d7c30034067$var$_frustum = /*@__PURE__*/ new $d5b33d7c30034067$export$35efe6f4c85463d2();
const $d5b33d7c30034067$var$_box$1 = /*@__PURE__*/ new $d5b33d7c30034067$export$6f7d5a9418ab2aa3();
const $d5b33d7c30034067$var$_sphere$2 = /*@__PURE__*/ new $d5b33d7c30034067$export$805e8b72413ccaba();
const $d5b33d7c30034067$var$_vector$5 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_forward = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_temp = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_renderList = /*@__PURE__*/ new $d5b33d7c30034067$var$MultiDrawRenderList();
const $d5b33d7c30034067$var$_mesh = /*@__PURE__*/ new $d5b33d7c30034067$export$e176487c05830cc5();
const $d5b33d7c30034067$var$_batchIntersects = [];
// copies data from attribute "src" into "target" starting at "targetOffset"
function $d5b33d7c30034067$var$copyAttributeData(src, target, targetOffset = 0) {
    const itemSize = target.itemSize;
    if (src.isInterleavedBufferAttribute || src.array.constructor !== target.array.constructor) {
        // use the component getters and setters if the array data cannot
        // be copied directly
        const vertexCount = src.count;
        for(let i = 0; i < vertexCount; i++)for(let c = 0; c < itemSize; c++)target.setComponent(i + targetOffset, c, src.getComponent(i, c));
    } else // faster copy approach using typed array set function
    target.array.set(src.array, targetOffset * itemSize);
    target.needsUpdate = true;
}
// safely copies array contents to a potentially smaller array
function $d5b33d7c30034067$var$copyArrayContents(src, target) {
    if (src.constructor !== target.constructor) {
        // if arrays are of a different type (eg due to index size increasing) then data must be per-element copied
        const len = Math.min(src.length, target.length);
        for(let i = 0; i < len; i++)target[i] = src[i];
    } else {
        // if the arrays use the same data layout we can use a fast block copy
        const len = Math.min(src.length, target.length);
        target.set(new src.constructor(src.buffer, 0, len));
    }
}
class $d5b33d7c30034067$export$6e01c5ee52ed8f7b extends $d5b33d7c30034067$export$e176487c05830cc5 {
    get maxInstanceCount() {
        return this._maxInstanceCount;
    }
    get instanceCount() {
        return this._instanceInfo.length - this._availableInstanceIds.length;
    }
    get unusedVertexCount() {
        return this._maxVertexCount - this._nextVertexStart;
    }
    get unusedIndexCount() {
        return this._maxIndexCount - this._nextIndexStart;
    }
    constructor(maxInstanceCount, maxVertexCount, maxIndexCount = maxVertexCount * 2, material){
        super(new $d5b33d7c30034067$export$b7be63a67df8959(), material);
        this.isBatchedMesh = true;
        this.perObjectFrustumCulled = true;
        this.sortObjects = true;
        this.boundingBox = null;
        this.boundingSphere = null;
        this.customSort = null;
        // stores visible, active, and geometry id per instance and reserved buffer ranges for geometries
        this._instanceInfo = [];
        this._geometryInfo = [];
        // instance, geometry ids that have been set as inactive, and are available to be overwritten
        this._availableInstanceIds = [];
        this._availableGeometryIds = [];
        // used to track where the next point is that geometry should be inserted
        this._nextIndexStart = 0;
        this._nextVertexStart = 0;
        this._geometryCount = 0;
        // flags
        this._visibilityChanged = true;
        this._geometryInitialized = false;
        // cached user options
        this._maxInstanceCount = maxInstanceCount;
        this._maxVertexCount = maxVertexCount;
        this._maxIndexCount = maxIndexCount;
        // buffers for multi draw
        this._multiDrawCounts = new Int32Array(maxInstanceCount);
        this._multiDrawStarts = new Int32Array(maxInstanceCount);
        this._multiDrawCount = 0;
        this._multiDrawInstances = null;
        // Local matrix per geometry by using data texture
        this._matricesTexture = null;
        this._indirectTexture = null;
        this._colorsTexture = null;
        this._initMatricesTexture();
        this._initIndirectTexture();
    }
    _initMatricesTexture() {
        // layout (1 matrix = 4 pixels)
        //      RGBA RGBA RGBA RGBA (=> column1, column2, column3, column4)
        //  with  8x8  pixel texture max   16 matrices * 4 pixels =  (8 * 8)
        //       16x16 pixel texture max   64 matrices * 4 pixels = (16 * 16)
        //       32x32 pixel texture max  256 matrices * 4 pixels = (32 * 32)
        //       64x64 pixel texture max 1024 matrices * 4 pixels = (64 * 64)
        let size = Math.sqrt(this._maxInstanceCount * 4); // 4 pixels needed for 1 matrix
        size = Math.ceil(size / 4) * 4;
        size = Math.max(size, 4);
        const matricesArray = new Float32Array(size * size * 4); // 4 floats per RGBA pixel
        const matricesTexture = new $d5b33d7c30034067$export$b691f601014eabe1(matricesArray, size, size, $d5b33d7c30034067$export$3f8bb04b555a363c, $d5b33d7c30034067$export$f6d331659b644596);
        this._matricesTexture = matricesTexture;
    }
    _initIndirectTexture() {
        let size = Math.sqrt(this._maxInstanceCount);
        size = Math.ceil(size);
        const indirectArray = new Uint32Array(size * size);
        const indirectTexture = new $d5b33d7c30034067$export$b691f601014eabe1(indirectArray, size, size, $d5b33d7c30034067$export$aa92e870a709d190, $d5b33d7c30034067$export$c3c7fc4518ebba96);
        this._indirectTexture = indirectTexture;
    }
    _initColorsTexture() {
        let size = Math.sqrt(this._maxInstanceCount);
        size = Math.ceil(size);
        // 4 floats per RGBA pixel initialized to white
        const colorsArray = new Float32Array(size * size * 4).fill(1);
        const colorsTexture = new $d5b33d7c30034067$export$b691f601014eabe1(colorsArray, size, size, $d5b33d7c30034067$export$3f8bb04b555a363c, $d5b33d7c30034067$export$f6d331659b644596);
        colorsTexture.colorSpace = $d5b33d7c30034067$export$5e6fd513f44698c.workingColorSpace;
        this._colorsTexture = colorsTexture;
    }
    _initializeGeometry(reference) {
        const geometry = this.geometry;
        const maxVertexCount = this._maxVertexCount;
        const maxIndexCount = this._maxIndexCount;
        if (this._geometryInitialized === false) {
            for(const attributeName in reference.attributes){
                const srcAttribute = reference.getAttribute(attributeName);
                const { array: array, itemSize: itemSize, normalized: normalized } = srcAttribute;
                const dstArray = new array.constructor(maxVertexCount * itemSize);
                const dstAttribute = new $d5b33d7c30034067$export$8dea267bd6bde117(dstArray, itemSize, normalized);
                geometry.setAttribute(attributeName, dstAttribute);
            }
            if (reference.getIndex() !== null) {
                // Reserve last u16 index for primitive restart.
                const indexArray = maxVertexCount > 65535 ? new Uint32Array(maxIndexCount) : new Uint16Array(maxIndexCount);
                geometry.setIndex(new $d5b33d7c30034067$export$8dea267bd6bde117(indexArray, 1));
            }
            this._geometryInitialized = true;
        }
    }
    // Make sure the geometry is compatible with the existing combined geometry attributes
    _validateGeometry(geometry) {
        // check to ensure the geometries are using consistent attributes and indices
        const batchGeometry = this.geometry;
        if (Boolean(geometry.getIndex()) !== Boolean(batchGeometry.getIndex())) throw new Error('BatchedMesh: All geometries must consistently have "index".');
        for(const attributeName in batchGeometry.attributes){
            if (!geometry.hasAttribute(attributeName)) throw new Error(`BatchedMesh: Added geometry missing "${attributeName}". All geometries must have consistent attributes.`);
            const srcAttribute = geometry.getAttribute(attributeName);
            const dstAttribute = batchGeometry.getAttribute(attributeName);
            if (srcAttribute.itemSize !== dstAttribute.itemSize || srcAttribute.normalized !== dstAttribute.normalized) throw new Error('BatchedMesh: All attributes must have a consistent itemSize and normalized value.');
        }
    }
    setCustomSort(func) {
        this.customSort = func;
        return this;
    }
    computeBoundingBox() {
        if (this.boundingBox === null) this.boundingBox = new $d5b33d7c30034067$export$6f7d5a9418ab2aa3();
        const boundingBox = this.boundingBox;
        const instanceInfo = this._instanceInfo;
        boundingBox.makeEmpty();
        for(let i = 0, l = instanceInfo.length; i < l; i++){
            if (instanceInfo[i].active === false) continue;
            const geometryId = instanceInfo[i].geometryIndex;
            this.getMatrixAt(i, $d5b33d7c30034067$var$_matrix$1);
            this.getBoundingBoxAt(geometryId, $d5b33d7c30034067$var$_box$1).applyMatrix4($d5b33d7c30034067$var$_matrix$1);
            boundingBox.union($d5b33d7c30034067$var$_box$1);
        }
    }
    computeBoundingSphere() {
        if (this.boundingSphere === null) this.boundingSphere = new $d5b33d7c30034067$export$805e8b72413ccaba();
        const boundingSphere = this.boundingSphere;
        const instanceInfo = this._instanceInfo;
        boundingSphere.makeEmpty();
        for(let i = 0, l = instanceInfo.length; i < l; i++){
            if (instanceInfo[i].active === false) continue;
            const geometryId = instanceInfo[i].geometryIndex;
            this.getMatrixAt(i, $d5b33d7c30034067$var$_matrix$1);
            this.getBoundingSphereAt(geometryId, $d5b33d7c30034067$var$_sphere$2).applyMatrix4($d5b33d7c30034067$var$_matrix$1);
            boundingSphere.union($d5b33d7c30034067$var$_sphere$2);
        }
    }
    addInstance(geometryId) {
        const atCapacity = this._instanceInfo.length >= this.maxInstanceCount;
        // ensure we're not over geometry
        if (atCapacity && this._availableInstanceIds.length === 0) throw new Error('BatchedMesh: Maximum item count reached.');
        const instanceInfo = {
            visible: true,
            active: true,
            geometryIndex: geometryId
        };
        let drawId = null;
        // Prioritize using previously freed instance ids
        if (this._availableInstanceIds.length > 0) {
            this._availableInstanceIds.sort($d5b33d7c30034067$var$ascIdSort);
            drawId = this._availableInstanceIds.shift();
            this._instanceInfo[drawId] = instanceInfo;
        } else {
            drawId = this._instanceInfo.length;
            this._instanceInfo.push(instanceInfo);
        }
        const matricesTexture = this._matricesTexture;
        $d5b33d7c30034067$var$_matrix$1.identity().toArray(matricesTexture.image.data, drawId * 16);
        matricesTexture.needsUpdate = true;
        const colorsTexture = this._colorsTexture;
        if (colorsTexture) {
            $d5b33d7c30034067$var$_whiteColor.toArray(colorsTexture.image.data, drawId * 4);
            colorsTexture.needsUpdate = true;
        }
        this._visibilityChanged = true;
        return drawId;
    }
    addGeometry(geometry, reservedVertexCount = -1, reservedIndexCount = -1) {
        this._initializeGeometry(geometry);
        this._validateGeometry(geometry);
        const geometryInfo = {
            // geometry information
            vertexStart: -1,
            vertexCount: -1,
            reservedVertexCount: -1,
            indexStart: -1,
            indexCount: -1,
            reservedIndexCount: -1,
            // draw range information
            start: -1,
            count: -1,
            // state
            boundingBox: null,
            boundingSphere: null,
            active: true
        };
        const geometryInfoList = this._geometryInfo;
        geometryInfo.vertexStart = this._nextVertexStart;
        geometryInfo.reservedVertexCount = reservedVertexCount === -1 ? geometry.getAttribute('position').count : reservedVertexCount;
        const index = geometry.getIndex();
        const hasIndex = index !== null;
        if (hasIndex) {
            geometryInfo.indexStart = this._nextIndexStart;
            geometryInfo.reservedIndexCount = reservedIndexCount === -1 ? index.count : reservedIndexCount;
        }
        if (geometryInfo.indexStart !== -1 && geometryInfo.indexStart + geometryInfo.reservedIndexCount > this._maxIndexCount || geometryInfo.vertexStart + geometryInfo.reservedVertexCount > this._maxVertexCount) throw new Error('BatchedMesh: Reserved space request exceeds the maximum buffer size.');
        // update id
        let geometryId;
        if (this._availableGeometryIds.length > 0) {
            this._availableGeometryIds.sort($d5b33d7c30034067$var$ascIdSort);
            geometryId = this._availableGeometryIds.shift();
            geometryInfoList[geometryId] = geometryInfo;
        } else {
            geometryId = this._geometryCount;
            this._geometryCount++;
            geometryInfoList.push(geometryInfo);
        }
        // update the geometry
        this.setGeometryAt(geometryId, geometry);
        // increment the next geometry position
        this._nextIndexStart = geometryInfo.indexStart + geometryInfo.reservedIndexCount;
        this._nextVertexStart = geometryInfo.vertexStart + geometryInfo.reservedVertexCount;
        return geometryId;
    }
    setGeometryAt(geometryId, geometry) {
        if (geometryId >= this._geometryCount) throw new Error('BatchedMesh: Maximum geometry count reached.');
        this._validateGeometry(geometry);
        const batchGeometry = this.geometry;
        const hasIndex = batchGeometry.getIndex() !== null;
        const dstIndex = batchGeometry.getIndex();
        const srcIndex = geometry.getIndex();
        const geometryInfo = this._geometryInfo[geometryId];
        if (hasIndex && srcIndex.count > geometryInfo.reservedIndexCount || geometry.attributes.position.count > geometryInfo.reservedVertexCount) throw new Error('BatchedMesh: Reserved space not large enough for provided geometry.');
        // copy geometry buffer data over
        const vertexStart = geometryInfo.vertexStart;
        const reservedVertexCount = geometryInfo.reservedVertexCount;
        geometryInfo.vertexCount = geometry.getAttribute('position').count;
        for(const attributeName in batchGeometry.attributes){
            // copy attribute data
            const srcAttribute = geometry.getAttribute(attributeName);
            const dstAttribute = batchGeometry.getAttribute(attributeName);
            $d5b33d7c30034067$var$copyAttributeData(srcAttribute, dstAttribute, vertexStart);
            // fill the rest in with zeroes
            const itemSize = srcAttribute.itemSize;
            for(let i = srcAttribute.count, l = reservedVertexCount; i < l; i++){
                const index = vertexStart + i;
                for(let c = 0; c < itemSize; c++)dstAttribute.setComponent(index, c, 0);
            }
            dstAttribute.needsUpdate = true;
            dstAttribute.addUpdateRange(vertexStart * itemSize, reservedVertexCount * itemSize);
        }
        // copy index
        if (hasIndex) {
            const indexStart = geometryInfo.indexStart;
            const reservedIndexCount = geometryInfo.reservedIndexCount;
            geometryInfo.indexCount = geometry.getIndex().count;
            // copy index data over
            for(let i = 0; i < srcIndex.count; i++)dstIndex.setX(indexStart + i, vertexStart + srcIndex.getX(i));
            // fill the rest in with zeroes
            for(let i = srcIndex.count, l = reservedIndexCount; i < l; i++)dstIndex.setX(indexStart + i, vertexStart);
            dstIndex.needsUpdate = true;
            dstIndex.addUpdateRange(indexStart, geometryInfo.reservedIndexCount);
        }
        // update the draw range
        geometryInfo.start = hasIndex ? geometryInfo.indexStart : geometryInfo.vertexStart;
        geometryInfo.count = hasIndex ? geometryInfo.indexCount : geometryInfo.vertexCount;
        // store the bounding boxes
        geometryInfo.boundingBox = null;
        if (geometry.boundingBox !== null) geometryInfo.boundingBox = geometry.boundingBox.clone();
        geometryInfo.boundingSphere = null;
        if (geometry.boundingSphere !== null) geometryInfo.boundingSphere = geometry.boundingSphere.clone();
        this._visibilityChanged = true;
        return geometryId;
    }
    deleteGeometry(geometryId) {
        const geometryInfoList = this._geometryInfo;
        if (geometryId >= geometryInfoList.length || geometryInfoList[geometryId].active === false) return this;
        // delete any instances associated with this geometry
        const instanceInfo = this._instanceInfo;
        for(let i = 0, l = instanceInfo.length; i < l; i++)if (instanceInfo[i].geometryIndex === geometryId) this.deleteInstance(i);
        geometryInfoList[geometryId].active = false;
        this._availableGeometryIds.push(geometryId);
        this._visibilityChanged = true;
        return this;
    }
    deleteInstance(instanceId) {
        const instanceInfo = this._instanceInfo;
        if (instanceId >= instanceInfo.length || instanceInfo[instanceId].active === false) return this;
        instanceInfo[instanceId].active = false;
        this._availableInstanceIds.push(instanceId);
        this._visibilityChanged = true;
        return this;
    }
    optimize() {
        // track the next indices to copy data to
        let nextVertexStart = 0;
        let nextIndexStart = 0;
        // Iterate over all geometry ranges in order sorted from earliest in the geometry buffer to latest
        // in the geometry buffer. Because draw range objects can be reused there is no guarantee of their order.
        const geometryInfoList = this._geometryInfo;
        const indices = geometryInfoList.map((e, i)=>i).sort((a, b)=>{
            return geometryInfoList[a].vertexStart - geometryInfoList[b].vertexStart;
        });
        const geometry = this.geometry;
        for(let i = 0, l = geometryInfoList.length; i < l; i++){
            // if a geometry range is inactive then don't copy anything
            const index = indices[i];
            const geometryInfo = geometryInfoList[index];
            if (geometryInfo.active === false) continue;
            // if a geometry contains an index buffer then shift it, as well
            if (geometry.index !== null) {
                if (geometryInfo.indexStart !== nextIndexStart) {
                    const { indexStart: indexStart, vertexStart: vertexStart, reservedIndexCount: reservedIndexCount } = geometryInfo;
                    const index = geometry.index;
                    const array = index.array;
                    // shift the index pointers based on how the vertex data will shift
                    // adjusting the index must happen first so the original vertex start value is available
                    const elementDelta = nextVertexStart - vertexStart;
                    for(let j = indexStart; j < indexStart + reservedIndexCount; j++)array[j] = array[j] + elementDelta;
                    index.array.copyWithin(nextIndexStart, indexStart, indexStart + reservedIndexCount);
                    index.addUpdateRange(nextIndexStart, reservedIndexCount);
                    geometryInfo.indexStart = nextIndexStart;
                }
                nextIndexStart += geometryInfo.reservedIndexCount;
            }
            // if a geometry needs to be moved then copy attribute data to overwrite unused space
            if (geometryInfo.vertexStart !== nextVertexStart) {
                const { vertexStart: vertexStart, reservedVertexCount: reservedVertexCount } = geometryInfo;
                const attributes = geometry.attributes;
                for(const key in attributes){
                    const attribute = attributes[key];
                    const { array: array, itemSize: itemSize } = attribute;
                    array.copyWithin(nextVertexStart * itemSize, vertexStart * itemSize, (vertexStart + reservedVertexCount) * itemSize);
                    attribute.addUpdateRange(nextVertexStart * itemSize, reservedVertexCount * itemSize);
                }
                geometryInfo.vertexStart = nextVertexStart;
            }
            nextVertexStart += geometryInfo.reservedVertexCount;
            geometryInfo.start = geometry.index ? geometryInfo.indexStart : geometryInfo.vertexStart;
            // step the next geometry points to the shifted position
            this._nextIndexStart = geometry.index ? geometryInfo.indexStart + geometryInfo.reservedIndexCount : 0;
            this._nextVertexStart = geometryInfo.vertexStart + geometryInfo.reservedVertexCount;
        }
        return this;
    }
    // get bounding box and compute it if it doesn't exist
    getBoundingBoxAt(geometryId, target) {
        if (geometryId >= this._geometryCount) return null;
        // compute bounding box
        const geometry = this.geometry;
        const geometryInfo = this._geometryInfo[geometryId];
        if (geometryInfo.boundingBox === null) {
            const box = new $d5b33d7c30034067$export$6f7d5a9418ab2aa3();
            const index = geometry.index;
            const position = geometry.attributes.position;
            for(let i = geometryInfo.start, l = geometryInfo.start + geometryInfo.count; i < l; i++){
                let iv = i;
                if (index) iv = index.getX(iv);
                box.expandByPoint($d5b33d7c30034067$var$_vector$5.fromBufferAttribute(position, iv));
            }
            geometryInfo.boundingBox = box;
        }
        target.copy(geometryInfo.boundingBox);
        return target;
    }
    // get bounding sphere and compute it if it doesn't exist
    getBoundingSphereAt(geometryId, target) {
        if (geometryId >= this._geometryCount) return null;
        // compute bounding sphere
        const geometry = this.geometry;
        const geometryInfo = this._geometryInfo[geometryId];
        if (geometryInfo.boundingSphere === null) {
            const sphere = new $d5b33d7c30034067$export$805e8b72413ccaba();
            this.getBoundingBoxAt(geometryId, $d5b33d7c30034067$var$_box$1);
            $d5b33d7c30034067$var$_box$1.getCenter(sphere.center);
            const index = geometry.index;
            const position = geometry.attributes.position;
            let maxRadiusSq = 0;
            for(let i = geometryInfo.start, l = geometryInfo.start + geometryInfo.count; i < l; i++){
                let iv = i;
                if (index) iv = index.getX(iv);
                $d5b33d7c30034067$var$_vector$5.fromBufferAttribute(position, iv);
                maxRadiusSq = Math.max(maxRadiusSq, sphere.center.distanceToSquared($d5b33d7c30034067$var$_vector$5));
            }
            sphere.radius = Math.sqrt(maxRadiusSq);
            geometryInfo.boundingSphere = sphere;
        }
        target.copy(geometryInfo.boundingSphere);
        return target;
    }
    setMatrixAt(instanceId, matrix) {
        const instanceInfo = this._instanceInfo;
        const matricesTexture = this._matricesTexture;
        const matricesArray = this._matricesTexture.image.data;
        if (instanceId >= instanceInfo.length || instanceInfo[instanceId].active === false) return this;
        matrix.toArray(matricesArray, instanceId * 16);
        matricesTexture.needsUpdate = true;
        return this;
    }
    getMatrixAt(instanceId, matrix) {
        const instanceInfo = this._instanceInfo;
        const matricesArray = this._matricesTexture.image.data;
        if (instanceId >= instanceInfo.length || instanceInfo[instanceId].active === false) return null;
        return matrix.fromArray(matricesArray, instanceId * 16);
    }
    setColorAt(instanceId, color) {
        if (this._colorsTexture === null) this._initColorsTexture();
        const colorsTexture = this._colorsTexture;
        const colorsArray = this._colorsTexture.image.data;
        const instanceInfo = this._instanceInfo;
        if (instanceId >= instanceInfo.length || instanceInfo[instanceId].active === false) return this;
        color.toArray(colorsArray, instanceId * 4);
        colorsTexture.needsUpdate = true;
        return this;
    }
    getColorAt(instanceId, color) {
        const colorsArray = this._colorsTexture.image.data;
        const instanceInfo = this._instanceInfo;
        if (instanceId >= instanceInfo.length || instanceInfo[instanceId].active === false) return null;
        return color.fromArray(colorsArray, instanceId * 4);
    }
    setVisibleAt(instanceId, value) {
        // if the geometry is out of range, not active, or visibility state
        // does not change then return early
        const instanceInfo = this._instanceInfo;
        if (instanceId >= instanceInfo.length || instanceInfo[instanceId].active === false || instanceInfo[instanceId].visible === value) return this;
        instanceInfo[instanceId].visible = value;
        this._visibilityChanged = true;
        return this;
    }
    getVisibleAt(instanceId) {
        // return early if the geometry is out of range or not active
        const instanceInfo = this._instanceInfo;
        if (instanceId >= instanceInfo.length || instanceInfo[instanceId].active === false) return false;
        return instanceInfo[instanceId].visible;
    }
    setGeometryIdAt(instanceId, geometryId) {
        // return early if the geometry is out of range or not active
        const instanceInfo = this._instanceInfo;
        const geometryInfoList = this._geometryInfo;
        if (instanceId >= instanceInfo.length || instanceInfo[instanceId].active === false) return null;
        // check if the provided geometryId is within the valid range
        if (geometryId >= geometryInfoList.length || geometryInfoList[geometryId].active === false) return null;
        instanceInfo[instanceId].geometryIndex = geometryId;
        return this;
    }
    getGeometryIdAt(instanceId) {
        const instanceInfo = this._instanceInfo;
        if (instanceId >= instanceInfo.length || instanceInfo[instanceId].active === false) return -1;
        return instanceInfo[instanceId].geometryIndex;
    }
    getGeometryRangeAt(geometryId, target = {}) {
        if (geometryId < 0 || geometryId >= this._geometryCount) return null;
        const geometryInfo = this._geometryInfo[geometryId];
        target.vertexStart = geometryInfo.vertexStart;
        target.vertexCount = geometryInfo.vertexCount;
        target.reservedVertexCount = geometryInfo.reservedVertexCount;
        target.indexStart = geometryInfo.indexStart;
        target.indexCount = geometryInfo.indexCount;
        target.reservedIndexCount = geometryInfo.reservedIndexCount;
        target.start = geometryInfo.start;
        target.count = geometryInfo.count;
        return target;
    }
    setInstanceCount(maxInstanceCount) {
        // shrink the available instances as much as possible
        const availableInstanceIds = this._availableInstanceIds;
        const instanceInfo = this._instanceInfo;
        availableInstanceIds.sort($d5b33d7c30034067$var$ascIdSort);
        while(availableInstanceIds[availableInstanceIds.length - 1] === instanceInfo.length){
            instanceInfo.pop();
            availableInstanceIds.pop();
        }
        // throw an error if it can't be shrunk to the desired size
        if (maxInstanceCount < instanceInfo.length) throw new Error(`BatchedMesh: Instance ids outside the range ${maxInstanceCount} are being used. Cannot shrink instance count.`);
        // copy the multi draw counts
        const multiDrawCounts = new Int32Array(maxInstanceCount);
        const multiDrawStarts = new Int32Array(maxInstanceCount);
        $d5b33d7c30034067$var$copyArrayContents(this._multiDrawCounts, multiDrawCounts);
        $d5b33d7c30034067$var$copyArrayContents(this._multiDrawStarts, multiDrawStarts);
        this._multiDrawCounts = multiDrawCounts;
        this._multiDrawStarts = multiDrawStarts;
        this._maxInstanceCount = maxInstanceCount;
        // update texture data for instance sampling
        const indirectTexture = this._indirectTexture;
        const matricesTexture = this._matricesTexture;
        const colorsTexture = this._colorsTexture;
        indirectTexture.dispose();
        this._initIndirectTexture();
        $d5b33d7c30034067$var$copyArrayContents(indirectTexture.image.data, this._indirectTexture.image.data);
        matricesTexture.dispose();
        this._initMatricesTexture();
        $d5b33d7c30034067$var$copyArrayContents(matricesTexture.image.data, this._matricesTexture.image.data);
        if (colorsTexture) {
            colorsTexture.dispose();
            this._initColorsTexture();
            $d5b33d7c30034067$var$copyArrayContents(colorsTexture.image.data, this._colorsTexture.image.data);
        }
    }
    setGeometrySize(maxVertexCount, maxIndexCount) {
        // Check if we can shrink to the requested vertex attribute size
        const validRanges = [
            ...this._geometryInfo
        ].filter((info)=>info.active);
        const requiredVertexLength = Math.max(...validRanges.map((range)=>range.vertexStart + range.reservedVertexCount));
        if (requiredVertexLength > maxVertexCount) throw new Error(`BatchedMesh: Geometry vertex values are being used outside the range ${maxIndexCount}. Cannot shrink further.`);
        // Check if we can shrink to the requested index attribute size
        if (this.geometry.index) {
            const requiredIndexLength = Math.max(...validRanges.map((range)=>range.indexStart + range.reservedIndexCount));
            if (requiredIndexLength > maxIndexCount) throw new Error(`BatchedMesh: Geometry index values are being used outside the range ${maxIndexCount}. Cannot shrink further.`);
        }
        //
        // dispose of the previous geometry
        const oldGeometry = this.geometry;
        oldGeometry.dispose();
        // recreate the geometry needed based on the previous variant
        this._maxVertexCount = maxVertexCount;
        this._maxIndexCount = maxIndexCount;
        if (this._geometryInitialized) {
            this._geometryInitialized = false;
            this.geometry = new $d5b33d7c30034067$export$b7be63a67df8959();
            this._initializeGeometry(oldGeometry);
        }
        // copy data from the previous geometry
        const geometry = this.geometry;
        if (oldGeometry.index) $d5b33d7c30034067$var$copyArrayContents(oldGeometry.index.array, geometry.index.array);
        for(const key in oldGeometry.attributes)$d5b33d7c30034067$var$copyArrayContents(oldGeometry.attributes[key].array, geometry.attributes[key].array);
    }
    raycast(raycaster, intersects) {
        const instanceInfo = this._instanceInfo;
        const geometryInfoList = this._geometryInfo;
        const matrixWorld = this.matrixWorld;
        const batchGeometry = this.geometry;
        // iterate over each geometry
        $d5b33d7c30034067$var$_mesh.material = this.material;
        $d5b33d7c30034067$var$_mesh.geometry.index = batchGeometry.index;
        $d5b33d7c30034067$var$_mesh.geometry.attributes = batchGeometry.attributes;
        if ($d5b33d7c30034067$var$_mesh.geometry.boundingBox === null) $d5b33d7c30034067$var$_mesh.geometry.boundingBox = new $d5b33d7c30034067$export$6f7d5a9418ab2aa3();
        if ($d5b33d7c30034067$var$_mesh.geometry.boundingSphere === null) $d5b33d7c30034067$var$_mesh.geometry.boundingSphere = new $d5b33d7c30034067$export$805e8b72413ccaba();
        for(let i = 0, l = instanceInfo.length; i < l; i++){
            if (!instanceInfo[i].visible || !instanceInfo[i].active) continue;
            const geometryId = instanceInfo[i].geometryIndex;
            const geometryInfo = geometryInfoList[geometryId];
            $d5b33d7c30034067$var$_mesh.geometry.setDrawRange(geometryInfo.start, geometryInfo.count);
            // get the intersects
            this.getMatrixAt(i, $d5b33d7c30034067$var$_mesh.matrixWorld).premultiply(matrixWorld);
            this.getBoundingBoxAt(geometryId, $d5b33d7c30034067$var$_mesh.geometry.boundingBox);
            this.getBoundingSphereAt(geometryId, $d5b33d7c30034067$var$_mesh.geometry.boundingSphere);
            $d5b33d7c30034067$var$_mesh.raycast(raycaster, $d5b33d7c30034067$var$_batchIntersects);
            // add batch id to the intersects
            for(let j = 0, l = $d5b33d7c30034067$var$_batchIntersects.length; j < l; j++){
                const intersect = $d5b33d7c30034067$var$_batchIntersects[j];
                intersect.object = this;
                intersect.batchId = i;
                intersects.push(intersect);
            }
            $d5b33d7c30034067$var$_batchIntersects.length = 0;
        }
        $d5b33d7c30034067$var$_mesh.material = null;
        $d5b33d7c30034067$var$_mesh.geometry.index = null;
        $d5b33d7c30034067$var$_mesh.geometry.attributes = {};
        $d5b33d7c30034067$var$_mesh.geometry.setDrawRange(0, Infinity);
    }
    copy(source) {
        super.copy(source);
        this.geometry = source.geometry.clone();
        this.perObjectFrustumCulled = source.perObjectFrustumCulled;
        this.sortObjects = source.sortObjects;
        this.boundingBox = source.boundingBox !== null ? source.boundingBox.clone() : null;
        this.boundingSphere = source.boundingSphere !== null ? source.boundingSphere.clone() : null;
        this._geometryInfo = source._geometryInfo.map((info)=>({
                ...info,
                boundingBox: info.boundingBox !== null ? info.boundingBox.clone() : null,
                boundingSphere: info.boundingSphere !== null ? info.boundingSphere.clone() : null
            }));
        this._instanceInfo = source._instanceInfo.map((info)=>({
                ...info
            }));
        this._maxInstanceCount = source._maxInstanceCount;
        this._maxVertexCount = source._maxVertexCount;
        this._maxIndexCount = source._maxIndexCount;
        this._geometryInitialized = source._geometryInitialized;
        this._geometryCount = source._geometryCount;
        this._multiDrawCounts = source._multiDrawCounts.slice();
        this._multiDrawStarts = source._multiDrawStarts.slice();
        this._matricesTexture = source._matricesTexture.clone();
        this._matricesTexture.image.data = this._matricesTexture.image.data.slice();
        if (this._colorsTexture !== null) {
            this._colorsTexture = source._colorsTexture.clone();
            this._colorsTexture.image.data = this._colorsTexture.image.data.slice();
        }
        return this;
    }
    dispose() {
        // Assuming the geometry is not shared with other meshes
        this.geometry.dispose();
        this._matricesTexture.dispose();
        this._matricesTexture = null;
        this._indirectTexture.dispose();
        this._indirectTexture = null;
        if (this._colorsTexture !== null) {
            this._colorsTexture.dispose();
            this._colorsTexture = null;
        }
        return this;
    }
    onBeforeRender(renderer, scene, camera, geometry, material /*, _group*/ ) {
        // if visibility has not changed and frustum culling and object sorting is not required
        // then skip iterating over all items
        if (!this._visibilityChanged && !this.perObjectFrustumCulled && !this.sortObjects) return;
        // the indexed version of the multi draw function requires specifying the start
        // offset in bytes.
        const index = geometry.getIndex();
        const bytesPerElement = index === null ? 1 : index.array.BYTES_PER_ELEMENT;
        const instanceInfo = this._instanceInfo;
        const multiDrawStarts = this._multiDrawStarts;
        const multiDrawCounts = this._multiDrawCounts;
        const geometryInfoList = this._geometryInfo;
        const perObjectFrustumCulled = this.perObjectFrustumCulled;
        const indirectTexture = this._indirectTexture;
        const indirectArray = indirectTexture.image.data;
        // prepare the frustum in the local frame
        if (perObjectFrustumCulled) {
            $d5b33d7c30034067$var$_matrix$1.multiplyMatrices(camera.projectionMatrix, camera.matrixWorldInverse).multiply(this.matrixWorld);
            $d5b33d7c30034067$var$_frustum.setFromProjectionMatrix($d5b33d7c30034067$var$_matrix$1, renderer.coordinateSystem);
        }
        let multiDrawCount = 0;
        if (this.sortObjects) {
            // get the camera position in the local frame
            $d5b33d7c30034067$var$_matrix$1.copy(this.matrixWorld).invert();
            $d5b33d7c30034067$var$_vector$5.setFromMatrixPosition(camera.matrixWorld).applyMatrix4($d5b33d7c30034067$var$_matrix$1);
            $d5b33d7c30034067$var$_forward.set(0, 0, -1).transformDirection(camera.matrixWorld).transformDirection($d5b33d7c30034067$var$_matrix$1);
            for(let i = 0, l = instanceInfo.length; i < l; i++)if (instanceInfo[i].visible && instanceInfo[i].active) {
                const geometryId = instanceInfo[i].geometryIndex;
                // get the bounds in world space
                this.getMatrixAt(i, $d5b33d7c30034067$var$_matrix$1);
                this.getBoundingSphereAt(geometryId, $d5b33d7c30034067$var$_sphere$2).applyMatrix4($d5b33d7c30034067$var$_matrix$1);
                // determine whether the batched geometry is within the frustum
                let culled = false;
                if (perObjectFrustumCulled) culled = !$d5b33d7c30034067$var$_frustum.intersectsSphere($d5b33d7c30034067$var$_sphere$2);
                if (!culled) {
                    // get the distance from camera used for sorting
                    const geometryInfo = geometryInfoList[geometryId];
                    const z = $d5b33d7c30034067$var$_temp.subVectors($d5b33d7c30034067$var$_sphere$2.center, $d5b33d7c30034067$var$_vector$5).dot($d5b33d7c30034067$var$_forward);
                    $d5b33d7c30034067$var$_renderList.push(geometryInfo.start, geometryInfo.count, z, i);
                }
            }
            // Sort the draw ranges and prep for rendering
            const list = $d5b33d7c30034067$var$_renderList.list;
            const customSort = this.customSort;
            if (customSort === null) list.sort(material.transparent ? $d5b33d7c30034067$var$sortTransparent : $d5b33d7c30034067$var$sortOpaque);
            else customSort.call(this, list, camera);
            for(let i = 0, l = list.length; i < l; i++){
                const item = list[i];
                multiDrawStarts[multiDrawCount] = item.start * bytesPerElement;
                multiDrawCounts[multiDrawCount] = item.count;
                indirectArray[multiDrawCount] = item.index;
                multiDrawCount++;
            }
            $d5b33d7c30034067$var$_renderList.reset();
        } else {
            for(let i = 0, l = instanceInfo.length; i < l; i++)if (instanceInfo[i].visible && instanceInfo[i].active) {
                const geometryId = instanceInfo[i].geometryIndex;
                // determine whether the batched geometry is within the frustum
                let culled = false;
                if (perObjectFrustumCulled) {
                    // get the bounds in world space
                    this.getMatrixAt(i, $d5b33d7c30034067$var$_matrix$1);
                    this.getBoundingSphereAt(geometryId, $d5b33d7c30034067$var$_sphere$2).applyMatrix4($d5b33d7c30034067$var$_matrix$1);
                    culled = !$d5b33d7c30034067$var$_frustum.intersectsSphere($d5b33d7c30034067$var$_sphere$2);
                }
                if (!culled) {
                    const geometryInfo = geometryInfoList[geometryId];
                    multiDrawStarts[multiDrawCount] = geometryInfo.start * bytesPerElement;
                    multiDrawCounts[multiDrawCount] = geometryInfo.count;
                    indirectArray[multiDrawCount] = i;
                    multiDrawCount++;
                }
            }
        }
        indirectTexture.needsUpdate = true;
        this._multiDrawCount = multiDrawCount;
        this._visibilityChanged = false;
    }
    onBeforeShadow(renderer, object, camera, shadowCamera, geometry, depthMaterial /* , group */ ) {
        this.onBeforeRender(renderer, null, shadowCamera, geometry, depthMaterial);
    }
}
class $d5b33d7c30034067$export$fbaaa33907730a0c extends $d5b33d7c30034067$export$a2d8b23205c25948 {
    static get type() {
        return 'LineBasicMaterial';
    }
    constructor(parameters){
        super();
        this.isLineBasicMaterial = true;
        this.color = new $d5b33d7c30034067$export$892596cec99bc70e(0xffffff);
        this.map = null;
        this.linewidth = 1;
        this.linecap = 'round';
        this.linejoin = 'round';
        this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.map = source.map;
        this.linewidth = source.linewidth;
        this.linecap = source.linecap;
        this.linejoin = source.linejoin;
        this.fog = source.fog;
        return this;
    }
}
const $d5b33d7c30034067$var$_vStart = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_vEnd = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_inverseMatrix$1 = /*@__PURE__*/ new $d5b33d7c30034067$export$2ae72fc923e5eb5();
const $d5b33d7c30034067$var$_ray$1 = /*@__PURE__*/ new $d5b33d7c30034067$export$a186db52eed6d40e();
const $d5b33d7c30034067$var$_sphere$1 = /*@__PURE__*/ new $d5b33d7c30034067$export$805e8b72413ccaba();
const $d5b33d7c30034067$var$_intersectPointOnRay = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_intersectPointOnSegment = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
class $d5b33d7c30034067$export$17d680238e50603e extends $d5b33d7c30034067$export$e4dd07dff30cc924 {
    constructor(geometry = new $d5b33d7c30034067$export$b7be63a67df8959(), material = new $d5b33d7c30034067$export$fbaaa33907730a0c()){
        super();
        this.isLine = true;
        this.type = 'Line';
        this.geometry = geometry;
        this.material = material;
        this.updateMorphTargets();
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.material = Array.isArray(source.material) ? source.material.slice() : source.material;
        this.geometry = source.geometry;
        return this;
    }
    computeLineDistances() {
        const geometry = this.geometry;
        // we assume non-indexed geometry
        if (geometry.index === null) {
            const positionAttribute = geometry.attributes.position;
            const lineDistances = [
                0
            ];
            for(let i = 1, l = positionAttribute.count; i < l; i++){
                $d5b33d7c30034067$var$_vStart.fromBufferAttribute(positionAttribute, i - 1);
                $d5b33d7c30034067$var$_vEnd.fromBufferAttribute(positionAttribute, i);
                lineDistances[i] = lineDistances[i - 1];
                lineDistances[i] += $d5b33d7c30034067$var$_vStart.distanceTo($d5b33d7c30034067$var$_vEnd);
            }
            geometry.setAttribute('lineDistance', new $d5b33d7c30034067$export$cbe7a62641830ebd(lineDistances, 1));
        } else console.warn('THREE.Line.computeLineDistances(): Computation only possible with non-indexed BufferGeometry.');
        return this;
    }
    raycast(raycaster, intersects) {
        const geometry = this.geometry;
        const matrixWorld = this.matrixWorld;
        const threshold = raycaster.params.Line.threshold;
        const drawRange = geometry.drawRange;
        // Checking boundingSphere distance to ray
        if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
        $d5b33d7c30034067$var$_sphere$1.copy(geometry.boundingSphere);
        $d5b33d7c30034067$var$_sphere$1.applyMatrix4(matrixWorld);
        $d5b33d7c30034067$var$_sphere$1.radius += threshold;
        if (raycaster.ray.intersectsSphere($d5b33d7c30034067$var$_sphere$1) === false) return;
        //
        $d5b33d7c30034067$var$_inverseMatrix$1.copy(matrixWorld).invert();
        $d5b33d7c30034067$var$_ray$1.copy(raycaster.ray).applyMatrix4($d5b33d7c30034067$var$_inverseMatrix$1);
        const localThreshold = threshold / ((this.scale.x + this.scale.y + this.scale.z) / 3);
        const localThresholdSq = localThreshold * localThreshold;
        const step = this.isLineSegments ? 2 : 1;
        const index = geometry.index;
        const attributes = geometry.attributes;
        const positionAttribute = attributes.position;
        if (index !== null) {
            const start = Math.max(0, drawRange.start);
            const end = Math.min(index.count, drawRange.start + drawRange.count);
            for(let i = start, l = end - 1; i < l; i += step){
                const a = index.getX(i);
                const b = index.getX(i + 1);
                const intersect = $d5b33d7c30034067$var$checkIntersection(this, raycaster, $d5b33d7c30034067$var$_ray$1, localThresholdSq, a, b);
                if (intersect) intersects.push(intersect);
            }
            if (this.isLineLoop) {
                const a = index.getX(end - 1);
                const b = index.getX(start);
                const intersect = $d5b33d7c30034067$var$checkIntersection(this, raycaster, $d5b33d7c30034067$var$_ray$1, localThresholdSq, a, b);
                if (intersect) intersects.push(intersect);
            }
        } else {
            const start = Math.max(0, drawRange.start);
            const end = Math.min(positionAttribute.count, drawRange.start + drawRange.count);
            for(let i = start, l = end - 1; i < l; i += step){
                const intersect = $d5b33d7c30034067$var$checkIntersection(this, raycaster, $d5b33d7c30034067$var$_ray$1, localThresholdSq, i, i + 1);
                if (intersect) intersects.push(intersect);
            }
            if (this.isLineLoop) {
                const intersect = $d5b33d7c30034067$var$checkIntersection(this, raycaster, $d5b33d7c30034067$var$_ray$1, localThresholdSq, end - 1, start);
                if (intersect) intersects.push(intersect);
            }
        }
    }
    updateMorphTargets() {
        const geometry = this.geometry;
        const morphAttributes = geometry.morphAttributes;
        const keys = Object.keys(morphAttributes);
        if (keys.length > 0) {
            const morphAttribute = morphAttributes[keys[0]];
            if (morphAttribute !== undefined) {
                this.morphTargetInfluences = [];
                this.morphTargetDictionary = {};
                for(let m = 0, ml = morphAttribute.length; m < ml; m++){
                    const name = morphAttribute[m].name || String(m);
                    this.morphTargetInfluences.push(0);
                    this.morphTargetDictionary[name] = m;
                }
            }
        }
    }
}
function $d5b33d7c30034067$var$checkIntersection(object, raycaster, ray, thresholdSq, a, b) {
    const positionAttribute = object.geometry.attributes.position;
    $d5b33d7c30034067$var$_vStart.fromBufferAttribute(positionAttribute, a);
    $d5b33d7c30034067$var$_vEnd.fromBufferAttribute(positionAttribute, b);
    const distSq = ray.distanceSqToSegment($d5b33d7c30034067$var$_vStart, $d5b33d7c30034067$var$_vEnd, $d5b33d7c30034067$var$_intersectPointOnRay, $d5b33d7c30034067$var$_intersectPointOnSegment);
    if (distSq > thresholdSq) return;
    $d5b33d7c30034067$var$_intersectPointOnRay.applyMatrix4(object.matrixWorld); // Move back to world space for distance calculation
    const distance = raycaster.ray.origin.distanceTo($d5b33d7c30034067$var$_intersectPointOnRay);
    if (distance < raycaster.near || distance > raycaster.far) return;
    return {
        distance: distance,
        // What do we want? intersection point on the ray or on the segment??
        // point: raycaster.ray.at( distance ),
        point: $d5b33d7c30034067$var$_intersectPointOnSegment.clone().applyMatrix4(object.matrixWorld),
        index: a,
        face: null,
        faceIndex: null,
        barycoord: null,
        object: object
    };
}
const $d5b33d7c30034067$var$_start = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_end = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
class $d5b33d7c30034067$export$ff1ed10fedfdd604 extends $d5b33d7c30034067$export$17d680238e50603e {
    constructor(geometry, material){
        super(geometry, material);
        this.isLineSegments = true;
        this.type = 'LineSegments';
    }
    computeLineDistances() {
        const geometry = this.geometry;
        // we assume non-indexed geometry
        if (geometry.index === null) {
            const positionAttribute = geometry.attributes.position;
            const lineDistances = [];
            for(let i = 0, l = positionAttribute.count; i < l; i += 2){
                $d5b33d7c30034067$var$_start.fromBufferAttribute(positionAttribute, i);
                $d5b33d7c30034067$var$_end.fromBufferAttribute(positionAttribute, i + 1);
                lineDistances[i] = i === 0 ? 0 : lineDistances[i - 1];
                lineDistances[i + 1] = lineDistances[i] + $d5b33d7c30034067$var$_start.distanceTo($d5b33d7c30034067$var$_end);
            }
            geometry.setAttribute('lineDistance', new $d5b33d7c30034067$export$cbe7a62641830ebd(lineDistances, 1));
        } else console.warn('THREE.LineSegments.computeLineDistances(): Computation only possible with non-indexed BufferGeometry.');
        return this;
    }
}
class $d5b33d7c30034067$export$f85a24d745e4f17d extends $d5b33d7c30034067$export$17d680238e50603e {
    constructor(geometry, material){
        super(geometry, material);
        this.isLineLoop = true;
        this.type = 'LineLoop';
    }
}
class $d5b33d7c30034067$export$a178c45366ce5d6b extends $d5b33d7c30034067$export$a2d8b23205c25948 {
    static get type() {
        return 'PointsMaterial';
    }
    constructor(parameters){
        super();
        this.isPointsMaterial = true;
        this.color = new $d5b33d7c30034067$export$892596cec99bc70e(0xffffff);
        this.map = null;
        this.alphaMap = null;
        this.size = 1;
        this.sizeAttenuation = true;
        this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.map = source.map;
        this.alphaMap = source.alphaMap;
        this.size = source.size;
        this.sizeAttenuation = source.sizeAttenuation;
        this.fog = source.fog;
        return this;
    }
}
const $d5b33d7c30034067$var$_inverseMatrix = /*@__PURE__*/ new $d5b33d7c30034067$export$2ae72fc923e5eb5();
const $d5b33d7c30034067$var$_ray = /*@__PURE__*/ new $d5b33d7c30034067$export$a186db52eed6d40e();
const $d5b33d7c30034067$var$_sphere = /*@__PURE__*/ new $d5b33d7c30034067$export$805e8b72413ccaba();
const $d5b33d7c30034067$var$_position$2 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
class $d5b33d7c30034067$export$1c787534cb11aa3e extends $d5b33d7c30034067$export$e4dd07dff30cc924 {
    constructor(geometry = new $d5b33d7c30034067$export$b7be63a67df8959(), material = new $d5b33d7c30034067$export$a178c45366ce5d6b()){
        super();
        this.isPoints = true;
        this.type = 'Points';
        this.geometry = geometry;
        this.material = material;
        this.updateMorphTargets();
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.material = Array.isArray(source.material) ? source.material.slice() : source.material;
        this.geometry = source.geometry;
        return this;
    }
    raycast(raycaster, intersects) {
        const geometry = this.geometry;
        const matrixWorld = this.matrixWorld;
        const threshold = raycaster.params.Points.threshold;
        const drawRange = geometry.drawRange;
        // Checking boundingSphere distance to ray
        if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
        $d5b33d7c30034067$var$_sphere.copy(geometry.boundingSphere);
        $d5b33d7c30034067$var$_sphere.applyMatrix4(matrixWorld);
        $d5b33d7c30034067$var$_sphere.radius += threshold;
        if (raycaster.ray.intersectsSphere($d5b33d7c30034067$var$_sphere) === false) return;
        //
        $d5b33d7c30034067$var$_inverseMatrix.copy(matrixWorld).invert();
        $d5b33d7c30034067$var$_ray.copy(raycaster.ray).applyMatrix4($d5b33d7c30034067$var$_inverseMatrix);
        const localThreshold = threshold / ((this.scale.x + this.scale.y + this.scale.z) / 3);
        const localThresholdSq = localThreshold * localThreshold;
        const index = geometry.index;
        const attributes = geometry.attributes;
        const positionAttribute = attributes.position;
        if (index !== null) {
            const start = Math.max(0, drawRange.start);
            const end = Math.min(index.count, drawRange.start + drawRange.count);
            for(let i = start, il = end; i < il; i++){
                const a = index.getX(i);
                $d5b33d7c30034067$var$_position$2.fromBufferAttribute(positionAttribute, a);
                $d5b33d7c30034067$var$testPoint($d5b33d7c30034067$var$_position$2, a, localThresholdSq, matrixWorld, raycaster, intersects, this);
            }
        } else {
            const start = Math.max(0, drawRange.start);
            const end = Math.min(positionAttribute.count, drawRange.start + drawRange.count);
            for(let i = start, l = end; i < l; i++){
                $d5b33d7c30034067$var$_position$2.fromBufferAttribute(positionAttribute, i);
                $d5b33d7c30034067$var$testPoint($d5b33d7c30034067$var$_position$2, i, localThresholdSq, matrixWorld, raycaster, intersects, this);
            }
        }
    }
    updateMorphTargets() {
        const geometry = this.geometry;
        const morphAttributes = geometry.morphAttributes;
        const keys = Object.keys(morphAttributes);
        if (keys.length > 0) {
            const morphAttribute = morphAttributes[keys[0]];
            if (morphAttribute !== undefined) {
                this.morphTargetInfluences = [];
                this.morphTargetDictionary = {};
                for(let m = 0, ml = morphAttribute.length; m < ml; m++){
                    const name = morphAttribute[m].name || String(m);
                    this.morphTargetInfluences.push(0);
                    this.morphTargetDictionary[name] = m;
                }
            }
        }
    }
}
function $d5b33d7c30034067$var$testPoint(point, index, localThresholdSq, matrixWorld, raycaster, intersects, object) {
    const rayPointDistanceSq = $d5b33d7c30034067$var$_ray.distanceSqToPoint(point);
    if (rayPointDistanceSq < localThresholdSq) {
        const intersectPoint = new $d5b33d7c30034067$export$64b5c384219d3699();
        $d5b33d7c30034067$var$_ray.closestPointToPoint(point, intersectPoint);
        intersectPoint.applyMatrix4(matrixWorld);
        const distance = raycaster.ray.origin.distanceTo(intersectPoint);
        if (distance < raycaster.near || distance > raycaster.far) return;
        intersects.push({
            distance: distance,
            distanceToRay: Math.sqrt(rayPointDistanceSq),
            point: intersectPoint,
            index: index,
            face: null,
            faceIndex: null,
            barycoord: null,
            object: object
        });
    }
}
class $d5b33d7c30034067$export$6e09d1edf8d5a25c extends $d5b33d7c30034067$export$5431306cf43de24a {
    constructor(video, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy){
        super(video, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy);
        this.isVideoTexture = true;
        this.minFilter = minFilter !== undefined ? minFilter : $d5b33d7c30034067$export$8a72f490b25c56c8;
        this.magFilter = magFilter !== undefined ? magFilter : $d5b33d7c30034067$export$8a72f490b25c56c8;
        this.generateMipmaps = false;
        const scope = this;
        function updateVideo() {
            scope.needsUpdate = true;
            video.requestVideoFrameCallback(updateVideo);
        }
        if ('requestVideoFrameCallback' in video) video.requestVideoFrameCallback(updateVideo);
    }
    clone() {
        return new this.constructor(this.image).copy(this);
    }
    update() {
        const video = this.image;
        const hasVideoFrameCallback = 'requestVideoFrameCallback' in video;
        if (hasVideoFrameCallback === false && video.readyState >= video.HAVE_CURRENT_DATA) this.needsUpdate = true;
    }
}
class $d5b33d7c30034067$export$9270d786f73ce6fe extends $d5b33d7c30034067$export$5431306cf43de24a {
    constructor(width, height){
        super({
            width: width,
            height: height
        });
        this.isFramebufferTexture = true;
        this.magFilter = $d5b33d7c30034067$export$727aa5ec3fe39bf0;
        this.minFilter = $d5b33d7c30034067$export$727aa5ec3fe39bf0;
        this.generateMipmaps = false;
        this.needsUpdate = true;
    }
}
class $d5b33d7c30034067$export$3466bac9141a5cc4 extends $d5b33d7c30034067$export$5431306cf43de24a {
    constructor(mipmaps, width, height, format, type, mapping, wrapS, wrapT, magFilter, minFilter, anisotropy, colorSpace){
        super(null, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, colorSpace);
        this.isCompressedTexture = true;
        this.image = {
            width: width,
            height: height
        };
        this.mipmaps = mipmaps;
        // no flipping for cube textures
        // (also flipping doesn't work for compressed textures )
        this.flipY = false;
        // can't generate mipmaps for compressed textures
        // mips must be embedded in DDS files
        this.generateMipmaps = false;
    }
}
class $d5b33d7c30034067$export$5fe6b8e34b274fcb extends $d5b33d7c30034067$export$3466bac9141a5cc4 {
    constructor(mipmaps, width, height, depth, format, type){
        super(mipmaps, width, height, format, type);
        this.isCompressedArrayTexture = true;
        this.image.depth = depth;
        this.wrapR = $d5b33d7c30034067$export$9d9334239a5a5e06;
        this.layerUpdates = new Set();
    }
    addLayerUpdate(layerIndex) {
        this.layerUpdates.add(layerIndex);
    }
    clearLayerUpdates() {
        this.layerUpdates.clear();
    }
}
class $d5b33d7c30034067$export$d80173634de65bff extends $d5b33d7c30034067$export$3466bac9141a5cc4 {
    constructor(images, format, type){
        super(undefined, images[0].width, images[0].height, format, type, $d5b33d7c30034067$export$8759762a6477f2c4);
        this.isCompressedCubeTexture = true;
        this.isCubeTexture = true;
        this.image = images;
    }
}
class $d5b33d7c30034067$export$f7189e49152d1c13 extends $d5b33d7c30034067$export$5431306cf43de24a {
    constructor(canvas, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy){
        super(canvas, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy);
        this.isCanvasTexture = true;
        this.needsUpdate = true;
    }
}
/**
 * Extensible curve object.
 *
 * Some common of curve methods:
 * .getPoint( t, optionalTarget ), .getTangent( t, optionalTarget )
 * .getPointAt( u, optionalTarget ), .getTangentAt( u, optionalTarget )
 * .getPoints(), .getSpacedPoints()
 * .getLength()
 * .updateArcLengths()
 *
 * This following curves inherit from THREE.Curve:
 *
 * -- 2D curves --
 * THREE.ArcCurve
 * THREE.CubicBezierCurve
 * THREE.EllipseCurve
 * THREE.LineCurve
 * THREE.QuadraticBezierCurve
 * THREE.SplineCurve
 *
 * -- 3D curves --
 * THREE.CatmullRomCurve3
 * THREE.CubicBezierCurve3
 * THREE.LineCurve3
 * THREE.QuadraticBezierCurve3
 *
 * A series of curves can be represented as a THREE.CurvePath.
 *
 **/ class $d5b33d7c30034067$export$b0e83c3ef8d2db1 {
    constructor(){
        this.type = 'Curve';
        this.arcLengthDivisions = 200;
    }
    // Virtual base class method to overwrite and implement in subclasses
    //	- t [0 .. 1]
    getPoint() {
        console.warn('THREE.Curve: .getPoint() not implemented.');
        return null;
    }
    // Get point at relative position in curve according to arc length
    // - u [0 .. 1]
    getPointAt(u, optionalTarget) {
        const t = this.getUtoTmapping(u);
        return this.getPoint(t, optionalTarget);
    }
    // Get sequence of points using getPoint( t )
    getPoints(divisions = 5) {
        const points = [];
        for(let d = 0; d <= divisions; d++)points.push(this.getPoint(d / divisions));
        return points;
    }
    // Get sequence of points using getPointAt( u )
    getSpacedPoints(divisions = 5) {
        const points = [];
        for(let d = 0; d <= divisions; d++)points.push(this.getPointAt(d / divisions));
        return points;
    }
    // Get total curve arc length
    getLength() {
        const lengths = this.getLengths();
        return lengths[lengths.length - 1];
    }
    // Get list of cumulative segment lengths
    getLengths(divisions = this.arcLengthDivisions) {
        if (this.cacheArcLengths && this.cacheArcLengths.length === divisions + 1 && !this.needsUpdate) return this.cacheArcLengths;
        this.needsUpdate = false;
        const cache = [];
        let current, last = this.getPoint(0);
        let sum = 0;
        cache.push(0);
        for(let p = 1; p <= divisions; p++){
            current = this.getPoint(p / divisions);
            sum += current.distanceTo(last);
            cache.push(sum);
            last = current;
        }
        this.cacheArcLengths = cache;
        return cache; // { sums: cache, sum: sum }; Sum is in the last element.
    }
    updateArcLengths() {
        this.needsUpdate = true;
        this.getLengths();
    }
    // Given u ( 0 .. 1 ), get a t to find p. This gives you points which are equidistant
    getUtoTmapping(u, distance) {
        const arcLengths = this.getLengths();
        let i = 0;
        const il = arcLengths.length;
        let targetArcLength; // The targeted u distance value to get
        if (distance) targetArcLength = distance;
        else targetArcLength = u * arcLengths[il - 1];
        // binary search for the index with largest value smaller than target u distance
        let low = 0, high = il - 1, comparison;
        while(low <= high){
            i = Math.floor(low + (high - low) / 2); // less likely to overflow, though probably not issue here, JS doesn't really have integers, all numbers are floats
            comparison = arcLengths[i] - targetArcLength;
            if (comparison < 0) low = i + 1;
            else if (comparison > 0) high = i - 1;
            else {
                high = i;
                break;
            // DONE
            }
        }
        i = high;
        if (arcLengths[i] === targetArcLength) return i / (il - 1);
        // we could get finer grain at lengths, or use simple interpolation between two points
        const lengthBefore = arcLengths[i];
        const lengthAfter = arcLengths[i + 1];
        const segmentLength = lengthAfter - lengthBefore;
        // determine where we are between the 'before' and 'after' points
        const segmentFraction = (targetArcLength - lengthBefore) / segmentLength;
        // add that fractional amount to t
        const t = (i + segmentFraction) / (il - 1);
        return t;
    }
    // Returns a unit vector tangent at t
    // In case any sub curve does not implement its tangent derivation,
    // 2 points a small delta apart will be used to find its gradient
    // which seems to give a reasonable approximation
    getTangent(t, optionalTarget) {
        const delta = 0.0001;
        let t1 = t - delta;
        let t2 = t + delta;
        // Capping in case of danger
        if (t1 < 0) t1 = 0;
        if (t2 > 1) t2 = 1;
        const pt1 = this.getPoint(t1);
        const pt2 = this.getPoint(t2);
        const tangent = optionalTarget || (pt1.isVector2 ? new $d5b33d7c30034067$export$c977b3e384af9ae1() : new $d5b33d7c30034067$export$64b5c384219d3699());
        tangent.copy(pt2).sub(pt1).normalize();
        return tangent;
    }
    getTangentAt(u, optionalTarget) {
        const t = this.getUtoTmapping(u);
        return this.getTangent(t, optionalTarget);
    }
    computeFrenetFrames(segments, closed) {
        // see http://www.cs.indiana.edu/pub/techreports/TR425.pdf
        const normal = new $d5b33d7c30034067$export$64b5c384219d3699();
        const tangents = [];
        const normals = [];
        const binormals = [];
        const vec = new $d5b33d7c30034067$export$64b5c384219d3699();
        const mat = new $d5b33d7c30034067$export$2ae72fc923e5eb5();
        // compute the tangent vectors for each segment on the curve
        for(let i = 0; i <= segments; i++){
            const u = i / segments;
            tangents[i] = this.getTangentAt(u, new $d5b33d7c30034067$export$64b5c384219d3699());
        }
        // select an initial normal vector perpendicular to the first tangent vector,
        // and in the direction of the minimum tangent xyz component
        normals[0] = new $d5b33d7c30034067$export$64b5c384219d3699();
        binormals[0] = new $d5b33d7c30034067$export$64b5c384219d3699();
        let min = Number.MAX_VALUE;
        const tx = Math.abs(tangents[0].x);
        const ty = Math.abs(tangents[0].y);
        const tz = Math.abs(tangents[0].z);
        if (tx <= min) {
            min = tx;
            normal.set(1, 0, 0);
        }
        if (ty <= min) {
            min = ty;
            normal.set(0, 1, 0);
        }
        if (tz <= min) normal.set(0, 0, 1);
        vec.crossVectors(tangents[0], normal).normalize();
        normals[0].crossVectors(tangents[0], vec);
        binormals[0].crossVectors(tangents[0], normals[0]);
        // compute the slowly-varying normal and binormal vectors for each segment on the curve
        for(let i = 1; i <= segments; i++){
            normals[i] = normals[i - 1].clone();
            binormals[i] = binormals[i - 1].clone();
            vec.crossVectors(tangents[i - 1], tangents[i]);
            if (vec.length() > Number.EPSILON) {
                vec.normalize();
                const theta = Math.acos($d5b33d7c30034067$var$clamp(tangents[i - 1].dot(tangents[i]), -1, 1)); // clamp for floating pt errors
                normals[i].applyMatrix4(mat.makeRotationAxis(vec, theta));
            }
            binormals[i].crossVectors(tangents[i], normals[i]);
        }
        // if the curve is closed, postprocess the vectors so the first and last normal vectors are the same
        if (closed === true) {
            let theta = Math.acos($d5b33d7c30034067$var$clamp(normals[0].dot(normals[segments]), -1, 1));
            theta /= segments;
            if (tangents[0].dot(vec.crossVectors(normals[0], normals[segments])) > 0) theta = -theta;
            for(let i = 1; i <= segments; i++){
                // twist a little...
                normals[i].applyMatrix4(mat.makeRotationAxis(tangents[i], theta * i));
                binormals[i].crossVectors(tangents[i], normals[i]);
            }
        }
        return {
            tangents: tangents,
            normals: normals,
            binormals: binormals
        };
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(source) {
        this.arcLengthDivisions = source.arcLengthDivisions;
        return this;
    }
    toJSON() {
        const data = {
            metadata: {
                version: 4.6,
                type: 'Curve',
                generator: 'Curve.toJSON'
            }
        };
        data.arcLengthDivisions = this.arcLengthDivisions;
        data.type = this.type;
        return data;
    }
    fromJSON(json) {
        this.arcLengthDivisions = json.arcLengthDivisions;
        return this;
    }
}
class $d5b33d7c30034067$export$3f87a931616cde04 extends $d5b33d7c30034067$export$b0e83c3ef8d2db1 {
    constructor(aX = 0, aY = 0, xRadius = 1, yRadius = 1, aStartAngle = 0, aEndAngle = Math.PI * 2, aClockwise = false, aRotation = 0){
        super();
        this.isEllipseCurve = true;
        this.type = 'EllipseCurve';
        this.aX = aX;
        this.aY = aY;
        this.xRadius = xRadius;
        this.yRadius = yRadius;
        this.aStartAngle = aStartAngle;
        this.aEndAngle = aEndAngle;
        this.aClockwise = aClockwise;
        this.aRotation = aRotation;
    }
    getPoint(t, optionalTarget = new $d5b33d7c30034067$export$c977b3e384af9ae1()) {
        const point = optionalTarget;
        const twoPi = Math.PI * 2;
        let deltaAngle = this.aEndAngle - this.aStartAngle;
        const samePoints = Math.abs(deltaAngle) < Number.EPSILON;
        // ensures that deltaAngle is 0 .. 2 PI
        while(deltaAngle < 0)deltaAngle += twoPi;
        while(deltaAngle > twoPi)deltaAngle -= twoPi;
        if (deltaAngle < Number.EPSILON) {
            if (samePoints) deltaAngle = 0;
            else deltaAngle = twoPi;
        }
        if (this.aClockwise === true && !samePoints) {
            if (deltaAngle === twoPi) deltaAngle = -twoPi;
            else deltaAngle = deltaAngle - twoPi;
        }
        const angle = this.aStartAngle + t * deltaAngle;
        let x = this.aX + this.xRadius * Math.cos(angle);
        let y = this.aY + this.yRadius * Math.sin(angle);
        if (this.aRotation !== 0) {
            const cos = Math.cos(this.aRotation);
            const sin = Math.sin(this.aRotation);
            const tx = x - this.aX;
            const ty = y - this.aY;
            // Rotate the point about the center of the ellipse.
            x = tx * cos - ty * sin + this.aX;
            y = tx * sin + ty * cos + this.aY;
        }
        return point.set(x, y);
    }
    copy(source) {
        super.copy(source);
        this.aX = source.aX;
        this.aY = source.aY;
        this.xRadius = source.xRadius;
        this.yRadius = source.yRadius;
        this.aStartAngle = source.aStartAngle;
        this.aEndAngle = source.aEndAngle;
        this.aClockwise = source.aClockwise;
        this.aRotation = source.aRotation;
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.aX = this.aX;
        data.aY = this.aY;
        data.xRadius = this.xRadius;
        data.yRadius = this.yRadius;
        data.aStartAngle = this.aStartAngle;
        data.aEndAngle = this.aEndAngle;
        data.aClockwise = this.aClockwise;
        data.aRotation = this.aRotation;
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.aX = json.aX;
        this.aY = json.aY;
        this.xRadius = json.xRadius;
        this.yRadius = json.yRadius;
        this.aStartAngle = json.aStartAngle;
        this.aEndAngle = json.aEndAngle;
        this.aClockwise = json.aClockwise;
        this.aRotation = json.aRotation;
        return this;
    }
}
class $d5b33d7c30034067$export$b1eedc9aab6300e8 extends $d5b33d7c30034067$export$3f87a931616cde04 {
    constructor(aX, aY, aRadius, aStartAngle, aEndAngle, aClockwise){
        super(aX, aY, aRadius, aRadius, aStartAngle, aEndAngle, aClockwise);
        this.isArcCurve = true;
        this.type = 'ArcCurve';
    }
}
/**
 * Centripetal CatmullRom Curve - which is useful for avoiding
 * cusps and self-intersections in non-uniform catmull rom curves.
 * http://www.cemyuksel.com/research/catmullrom_param/catmullrom.pdf
 *
 * curve.type accepts centripetal(default), chordal and catmullrom
 * curve.tension is used for catmullrom which defaults to 0.5
 */ /*
Based on an optimized c++ solution in
 - http://stackoverflow.com/questions/9489736/catmull-rom-curve-with-no-cusps-and-no-self-intersections/
 - http://ideone.com/NoEbVM

This CubicPoly class could be used for reusing some variables and calculations,
but for three.js curve use, it could be possible inlined and flatten into a single function call
which can be placed in CurveUtils.
*/ function $d5b33d7c30034067$var$CubicPoly() {
    let c0 = 0, c1 = 0, c2 = 0, c3 = 0;
    /*
	 * Compute coefficients for a cubic polynomial
	 *   p(s) = c0 + c1*s + c2*s^2 + c3*s^3
	 * such that
	 *   p(0) = x0, p(1) = x1
	 *  and
	 *   p'(0) = t0, p'(1) = t1.
	 */ function init(x0, x1, t0, t1) {
        c0 = x0;
        c1 = t0;
        c2 = -3 * x0 + 3 * x1 - 2 * t0 - t1;
        c3 = 2 * x0 - 2 * x1 + t0 + t1;
    }
    return {
        initCatmullRom: function(x0, x1, x2, x3, tension) {
            init(x1, x2, tension * (x2 - x0), tension * (x3 - x1));
        },
        initNonuniformCatmullRom: function(x0, x1, x2, x3, dt0, dt1, dt2) {
            // compute tangents when parameterized in [t1,t2]
            let t1 = (x1 - x0) / dt0 - (x2 - x0) / (dt0 + dt1) + (x2 - x1) / dt1;
            let t2 = (x2 - x1) / dt1 - (x3 - x1) / (dt1 + dt2) + (x3 - x2) / dt2;
            // rescale tangents for parametrization in [0,1]
            t1 *= dt1;
            t2 *= dt1;
            init(x1, x2, t1, t2);
        },
        calc: function(t) {
            const t2 = t * t;
            const t3 = t2 * t;
            return c0 + c1 * t + c2 * t2 + c3 * t3;
        }
    };
}
//
const $d5b33d7c30034067$var$tmp = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$px = /*@__PURE__*/ new $d5b33d7c30034067$var$CubicPoly();
const $d5b33d7c30034067$var$py = /*@__PURE__*/ new $d5b33d7c30034067$var$CubicPoly();
const $d5b33d7c30034067$var$pz = /*@__PURE__*/ new $d5b33d7c30034067$var$CubicPoly();
class $d5b33d7c30034067$export$b9146b27c24b744c extends $d5b33d7c30034067$export$b0e83c3ef8d2db1 {
    constructor(points = [], closed = false, curveType = 'centripetal', tension = 0.5){
        super();
        this.isCatmullRomCurve3 = true;
        this.type = 'CatmullRomCurve3';
        this.points = points;
        this.closed = closed;
        this.curveType = curveType;
        this.tension = tension;
    }
    getPoint(t, optionalTarget = new $d5b33d7c30034067$export$64b5c384219d3699()) {
        const point = optionalTarget;
        const points = this.points;
        const l = points.length;
        const p = (l - (this.closed ? 0 : 1)) * t;
        let intPoint = Math.floor(p);
        let weight = p - intPoint;
        if (this.closed) intPoint += intPoint > 0 ? 0 : (Math.floor(Math.abs(intPoint) / l) + 1) * l;
        else if (weight === 0 && intPoint === l - 1) {
            intPoint = l - 2;
            weight = 1;
        }
        let p0, p3; // 4 points (p1 & p2 defined below)
        if (this.closed || intPoint > 0) p0 = points[(intPoint - 1) % l];
        else {
            // extrapolate first point
            $d5b33d7c30034067$var$tmp.subVectors(points[0], points[1]).add(points[0]);
            p0 = $d5b33d7c30034067$var$tmp;
        }
        const p1 = points[intPoint % l];
        const p2 = points[(intPoint + 1) % l];
        if (this.closed || intPoint + 2 < l) p3 = points[(intPoint + 2) % l];
        else {
            // extrapolate last point
            $d5b33d7c30034067$var$tmp.subVectors(points[l - 1], points[l - 2]).add(points[l - 1]);
            p3 = $d5b33d7c30034067$var$tmp;
        }
        if (this.curveType === 'centripetal' || this.curveType === 'chordal') {
            // init Centripetal / Chordal Catmull-Rom
            const pow = this.curveType === 'chordal' ? 0.5 : 0.25;
            let dt0 = Math.pow(p0.distanceToSquared(p1), pow);
            let dt1 = Math.pow(p1.distanceToSquared(p2), pow);
            let dt2 = Math.pow(p2.distanceToSquared(p3), pow);
            // safety check for repeated points
            if (dt1 < 1e-4) dt1 = 1.0;
            if (dt0 < 1e-4) dt0 = dt1;
            if (dt2 < 1e-4) dt2 = dt1;
            $d5b33d7c30034067$var$px.initNonuniformCatmullRom(p0.x, p1.x, p2.x, p3.x, dt0, dt1, dt2);
            $d5b33d7c30034067$var$py.initNonuniformCatmullRom(p0.y, p1.y, p2.y, p3.y, dt0, dt1, dt2);
            $d5b33d7c30034067$var$pz.initNonuniformCatmullRom(p0.z, p1.z, p2.z, p3.z, dt0, dt1, dt2);
        } else if (this.curveType === 'catmullrom') {
            $d5b33d7c30034067$var$px.initCatmullRom(p0.x, p1.x, p2.x, p3.x, this.tension);
            $d5b33d7c30034067$var$py.initCatmullRom(p0.y, p1.y, p2.y, p3.y, this.tension);
            $d5b33d7c30034067$var$pz.initCatmullRom(p0.z, p1.z, p2.z, p3.z, this.tension);
        }
        point.set($d5b33d7c30034067$var$px.calc(weight), $d5b33d7c30034067$var$py.calc(weight), $d5b33d7c30034067$var$pz.calc(weight));
        return point;
    }
    copy(source) {
        super.copy(source);
        this.points = [];
        for(let i = 0, l = source.points.length; i < l; i++){
            const point = source.points[i];
            this.points.push(point.clone());
        }
        this.closed = source.closed;
        this.curveType = source.curveType;
        this.tension = source.tension;
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.points = [];
        for(let i = 0, l = this.points.length; i < l; i++){
            const point = this.points[i];
            data.points.push(point.toArray());
        }
        data.closed = this.closed;
        data.curveType = this.curveType;
        data.tension = this.tension;
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.points = [];
        for(let i = 0, l = json.points.length; i < l; i++){
            const point = json.points[i];
            this.points.push(new $d5b33d7c30034067$export$64b5c384219d3699().fromArray(point));
        }
        this.closed = json.closed;
        this.curveType = json.curveType;
        this.tension = json.tension;
        return this;
    }
}
/**
 * Bezier Curves formulas obtained from
 * https://en.wikipedia.org/wiki/B%C3%A9zier_curve
 */ function $d5b33d7c30034067$var$CatmullRom(t, p0, p1, p2, p3) {
    const v0 = (p2 - p0) * 0.5;
    const v1 = (p3 - p1) * 0.5;
    const t2 = t * t;
    const t3 = t * t2;
    return (2 * p1 - 2 * p2 + v0 + v1) * t3 + (-3 * p1 + 3 * p2 - 2 * v0 - v1) * t2 + v0 * t + p1;
}
//
function $d5b33d7c30034067$var$QuadraticBezierP0(t, p) {
    const k = 1 - t;
    return k * k * p;
}
function $d5b33d7c30034067$var$QuadraticBezierP1(t, p) {
    return 2 * (1 - t) * t * p;
}
function $d5b33d7c30034067$var$QuadraticBezierP2(t, p) {
    return t * t * p;
}
function $d5b33d7c30034067$var$QuadraticBezier(t, p0, p1, p2) {
    return $d5b33d7c30034067$var$QuadraticBezierP0(t, p0) + $d5b33d7c30034067$var$QuadraticBezierP1(t, p1) + $d5b33d7c30034067$var$QuadraticBezierP2(t, p2);
}
//
function $d5b33d7c30034067$var$CubicBezierP0(t, p) {
    const k = 1 - t;
    return k * k * k * p;
}
function $d5b33d7c30034067$var$CubicBezierP1(t, p) {
    const k = 1 - t;
    return 3 * k * k * t * p;
}
function $d5b33d7c30034067$var$CubicBezierP2(t, p) {
    return 3 * (1 - t) * t * t * p;
}
function $d5b33d7c30034067$var$CubicBezierP3(t, p) {
    return t * t * t * p;
}
function $d5b33d7c30034067$var$CubicBezier(t, p0, p1, p2, p3) {
    return $d5b33d7c30034067$var$CubicBezierP0(t, p0) + $d5b33d7c30034067$var$CubicBezierP1(t, p1) + $d5b33d7c30034067$var$CubicBezierP2(t, p2) + $d5b33d7c30034067$var$CubicBezierP3(t, p3);
}
class $d5b33d7c30034067$export$e36650d36468bb39 extends $d5b33d7c30034067$export$b0e83c3ef8d2db1 {
    constructor(v0 = new $d5b33d7c30034067$export$c977b3e384af9ae1(), v1 = new $d5b33d7c30034067$export$c977b3e384af9ae1(), v2 = new $d5b33d7c30034067$export$c977b3e384af9ae1(), v3 = new $d5b33d7c30034067$export$c977b3e384af9ae1()){
        super();
        this.isCubicBezierCurve = true;
        this.type = 'CubicBezierCurve';
        this.v0 = v0;
        this.v1 = v1;
        this.v2 = v2;
        this.v3 = v3;
    }
    getPoint(t, optionalTarget = new $d5b33d7c30034067$export$c977b3e384af9ae1()) {
        const point = optionalTarget;
        const v0 = this.v0, v1 = this.v1, v2 = this.v2, v3 = this.v3;
        point.set($d5b33d7c30034067$var$CubicBezier(t, v0.x, v1.x, v2.x, v3.x), $d5b33d7c30034067$var$CubicBezier(t, v0.y, v1.y, v2.y, v3.y));
        return point;
    }
    copy(source) {
        super.copy(source);
        this.v0.copy(source.v0);
        this.v1.copy(source.v1);
        this.v2.copy(source.v2);
        this.v3.copy(source.v3);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.v0 = this.v0.toArray();
        data.v1 = this.v1.toArray();
        data.v2 = this.v2.toArray();
        data.v3 = this.v3.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.v0.fromArray(json.v0);
        this.v1.fromArray(json.v1);
        this.v2.fromArray(json.v2);
        this.v3.fromArray(json.v3);
        return this;
    }
}
class $d5b33d7c30034067$export$13d5f1c9525f246c extends $d5b33d7c30034067$export$b0e83c3ef8d2db1 {
    constructor(v0 = new $d5b33d7c30034067$export$64b5c384219d3699(), v1 = new $d5b33d7c30034067$export$64b5c384219d3699(), v2 = new $d5b33d7c30034067$export$64b5c384219d3699(), v3 = new $d5b33d7c30034067$export$64b5c384219d3699()){
        super();
        this.isCubicBezierCurve3 = true;
        this.type = 'CubicBezierCurve3';
        this.v0 = v0;
        this.v1 = v1;
        this.v2 = v2;
        this.v3 = v3;
    }
    getPoint(t, optionalTarget = new $d5b33d7c30034067$export$64b5c384219d3699()) {
        const point = optionalTarget;
        const v0 = this.v0, v1 = this.v1, v2 = this.v2, v3 = this.v3;
        point.set($d5b33d7c30034067$var$CubicBezier(t, v0.x, v1.x, v2.x, v3.x), $d5b33d7c30034067$var$CubicBezier(t, v0.y, v1.y, v2.y, v3.y), $d5b33d7c30034067$var$CubicBezier(t, v0.z, v1.z, v2.z, v3.z));
        return point;
    }
    copy(source) {
        super.copy(source);
        this.v0.copy(source.v0);
        this.v1.copy(source.v1);
        this.v2.copy(source.v2);
        this.v3.copy(source.v3);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.v0 = this.v0.toArray();
        data.v1 = this.v1.toArray();
        data.v2 = this.v2.toArray();
        data.v3 = this.v3.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.v0.fromArray(json.v0);
        this.v1.fromArray(json.v1);
        this.v2.fromArray(json.v2);
        this.v3.fromArray(json.v3);
        return this;
    }
}
class $d5b33d7c30034067$export$ab2e07e76531a47e extends $d5b33d7c30034067$export$b0e83c3ef8d2db1 {
    constructor(v1 = new $d5b33d7c30034067$export$c977b3e384af9ae1(), v2 = new $d5b33d7c30034067$export$c977b3e384af9ae1()){
        super();
        this.isLineCurve = true;
        this.type = 'LineCurve';
        this.v1 = v1;
        this.v2 = v2;
    }
    getPoint(t, optionalTarget = new $d5b33d7c30034067$export$c977b3e384af9ae1()) {
        const point = optionalTarget;
        if (t === 1) point.copy(this.v2);
        else {
            point.copy(this.v2).sub(this.v1);
            point.multiplyScalar(t).add(this.v1);
        }
        return point;
    }
    // Line curve is linear, so we can overwrite default getPointAt
    getPointAt(u, optionalTarget) {
        return this.getPoint(u, optionalTarget);
    }
    getTangent(t, optionalTarget = new $d5b33d7c30034067$export$c977b3e384af9ae1()) {
        return optionalTarget.subVectors(this.v2, this.v1).normalize();
    }
    getTangentAt(u, optionalTarget) {
        return this.getTangent(u, optionalTarget);
    }
    copy(source) {
        super.copy(source);
        this.v1.copy(source.v1);
        this.v2.copy(source.v2);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.v1 = this.v1.toArray();
        data.v2 = this.v2.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.v1.fromArray(json.v1);
        this.v2.fromArray(json.v2);
        return this;
    }
}
class $d5b33d7c30034067$export$1fdfd9d9cf487600 extends $d5b33d7c30034067$export$b0e83c3ef8d2db1 {
    constructor(v1 = new $d5b33d7c30034067$export$64b5c384219d3699(), v2 = new $d5b33d7c30034067$export$64b5c384219d3699()){
        super();
        this.isLineCurve3 = true;
        this.type = 'LineCurve3';
        this.v1 = v1;
        this.v2 = v2;
    }
    getPoint(t, optionalTarget = new $d5b33d7c30034067$export$64b5c384219d3699()) {
        const point = optionalTarget;
        if (t === 1) point.copy(this.v2);
        else {
            point.copy(this.v2).sub(this.v1);
            point.multiplyScalar(t).add(this.v1);
        }
        return point;
    }
    // Line curve is linear, so we can overwrite default getPointAt
    getPointAt(u, optionalTarget) {
        return this.getPoint(u, optionalTarget);
    }
    getTangent(t, optionalTarget = new $d5b33d7c30034067$export$64b5c384219d3699()) {
        return optionalTarget.subVectors(this.v2, this.v1).normalize();
    }
    getTangentAt(u, optionalTarget) {
        return this.getTangent(u, optionalTarget);
    }
    copy(source) {
        super.copy(source);
        this.v1.copy(source.v1);
        this.v2.copy(source.v2);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.v1 = this.v1.toArray();
        data.v2 = this.v2.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.v1.fromArray(json.v1);
        this.v2.fromArray(json.v2);
        return this;
    }
}
class $d5b33d7c30034067$export$5938c4ee491a43ad extends $d5b33d7c30034067$export$b0e83c3ef8d2db1 {
    constructor(v0 = new $d5b33d7c30034067$export$c977b3e384af9ae1(), v1 = new $d5b33d7c30034067$export$c977b3e384af9ae1(), v2 = new $d5b33d7c30034067$export$c977b3e384af9ae1()){
        super();
        this.isQuadraticBezierCurve = true;
        this.type = 'QuadraticBezierCurve';
        this.v0 = v0;
        this.v1 = v1;
        this.v2 = v2;
    }
    getPoint(t, optionalTarget = new $d5b33d7c30034067$export$c977b3e384af9ae1()) {
        const point = optionalTarget;
        const v0 = this.v0, v1 = this.v1, v2 = this.v2;
        point.set($d5b33d7c30034067$var$QuadraticBezier(t, v0.x, v1.x, v2.x), $d5b33d7c30034067$var$QuadraticBezier(t, v0.y, v1.y, v2.y));
        return point;
    }
    copy(source) {
        super.copy(source);
        this.v0.copy(source.v0);
        this.v1.copy(source.v1);
        this.v2.copy(source.v2);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.v0 = this.v0.toArray();
        data.v1 = this.v1.toArray();
        data.v2 = this.v2.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.v0.fromArray(json.v0);
        this.v1.fromArray(json.v1);
        this.v2.fromArray(json.v2);
        return this;
    }
}
class $d5b33d7c30034067$export$bf3f4c7e459f90fc extends $d5b33d7c30034067$export$b0e83c3ef8d2db1 {
    constructor(v0 = new $d5b33d7c30034067$export$64b5c384219d3699(), v1 = new $d5b33d7c30034067$export$64b5c384219d3699(), v2 = new $d5b33d7c30034067$export$64b5c384219d3699()){
        super();
        this.isQuadraticBezierCurve3 = true;
        this.type = 'QuadraticBezierCurve3';
        this.v0 = v0;
        this.v1 = v1;
        this.v2 = v2;
    }
    getPoint(t, optionalTarget = new $d5b33d7c30034067$export$64b5c384219d3699()) {
        const point = optionalTarget;
        const v0 = this.v0, v1 = this.v1, v2 = this.v2;
        point.set($d5b33d7c30034067$var$QuadraticBezier(t, v0.x, v1.x, v2.x), $d5b33d7c30034067$var$QuadraticBezier(t, v0.y, v1.y, v2.y), $d5b33d7c30034067$var$QuadraticBezier(t, v0.z, v1.z, v2.z));
        return point;
    }
    copy(source) {
        super.copy(source);
        this.v0.copy(source.v0);
        this.v1.copy(source.v1);
        this.v2.copy(source.v2);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.v0 = this.v0.toArray();
        data.v1 = this.v1.toArray();
        data.v2 = this.v2.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.v0.fromArray(json.v0);
        this.v1.fromArray(json.v1);
        this.v2.fromArray(json.v2);
        return this;
    }
}
class $d5b33d7c30034067$export$d3bdd77da77afc1b extends $d5b33d7c30034067$export$b0e83c3ef8d2db1 {
    constructor(points = []){
        super();
        this.isSplineCurve = true;
        this.type = 'SplineCurve';
        this.points = points;
    }
    getPoint(t, optionalTarget = new $d5b33d7c30034067$export$c977b3e384af9ae1()) {
        const point = optionalTarget;
        const points = this.points;
        const p = (points.length - 1) * t;
        const intPoint = Math.floor(p);
        const weight = p - intPoint;
        const p0 = points[intPoint === 0 ? intPoint : intPoint - 1];
        const p1 = points[intPoint];
        const p2 = points[intPoint > points.length - 2 ? points.length - 1 : intPoint + 1];
        const p3 = points[intPoint > points.length - 3 ? points.length - 1 : intPoint + 2];
        point.set($d5b33d7c30034067$var$CatmullRom(weight, p0.x, p1.x, p2.x, p3.x), $d5b33d7c30034067$var$CatmullRom(weight, p0.y, p1.y, p2.y, p3.y));
        return point;
    }
    copy(source) {
        super.copy(source);
        this.points = [];
        for(let i = 0, l = source.points.length; i < l; i++){
            const point = source.points[i];
            this.points.push(point.clone());
        }
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.points = [];
        for(let i = 0, l = this.points.length; i < l; i++){
            const point = this.points[i];
            data.points.push(point.toArray());
        }
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.points = [];
        for(let i = 0, l = json.points.length; i < l; i++){
            const point = json.points[i];
            this.points.push(new $d5b33d7c30034067$export$c977b3e384af9ae1().fromArray(point));
        }
        return this;
    }
}
var $d5b33d7c30034067$var$Curves = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    ArcCurve: $d5b33d7c30034067$export$b1eedc9aab6300e8,
    CatmullRomCurve3: $d5b33d7c30034067$export$b9146b27c24b744c,
    CubicBezierCurve: $d5b33d7c30034067$export$e36650d36468bb39,
    CubicBezierCurve3: $d5b33d7c30034067$export$13d5f1c9525f246c,
    EllipseCurve: $d5b33d7c30034067$export$3f87a931616cde04,
    LineCurve: $d5b33d7c30034067$export$ab2e07e76531a47e,
    LineCurve3: $d5b33d7c30034067$export$1fdfd9d9cf487600,
    QuadraticBezierCurve: $d5b33d7c30034067$export$5938c4ee491a43ad,
    QuadraticBezierCurve3: $d5b33d7c30034067$export$bf3f4c7e459f90fc,
    SplineCurve: $d5b33d7c30034067$export$d3bdd77da77afc1b
});
/**************************************************************
 *	Curved Path - a curve path is simply a array of connected
 *  curves, but retains the api of a curve
 **************************************************************/ class $d5b33d7c30034067$export$4aaf9b66af1bbf2c extends $d5b33d7c30034067$export$b0e83c3ef8d2db1 {
    constructor(){
        super();
        this.type = 'CurvePath';
        this.curves = [];
        this.autoClose = false; // Automatically closes the path
    }
    add(curve) {
        this.curves.push(curve);
    }
    closePath() {
        // Add a line curve if start and end of lines are not connected
        const startPoint = this.curves[0].getPoint(0);
        const endPoint = this.curves[this.curves.length - 1].getPoint(1);
        if (!startPoint.equals(endPoint)) {
            const lineType = startPoint.isVector2 === true ? 'LineCurve' : 'LineCurve3';
            this.curves.push(new $d5b33d7c30034067$var$Curves[lineType](endPoint, startPoint));
        }
        return this;
    }
    // To get accurate point with reference to
    // entire path distance at time t,
    // following has to be done:
    // 1. Length of each sub path have to be known
    // 2. Locate and identify type of curve
    // 3. Get t for the curve
    // 4. Return curve.getPointAt(t')
    getPoint(t, optionalTarget) {
        const d = t * this.getLength();
        const curveLengths = this.getCurveLengths();
        let i = 0;
        // To think about boundaries points.
        while(i < curveLengths.length){
            if (curveLengths[i] >= d) {
                const diff = curveLengths[i] - d;
                const curve = this.curves[i];
                const segmentLength = curve.getLength();
                const u = segmentLength === 0 ? 0 : 1 - diff / segmentLength;
                return curve.getPointAt(u, optionalTarget);
            }
            i++;
        }
        return null;
    // loop where sum != 0, sum > d , sum+1 <d
    }
    // We cannot use the default THREE.Curve getPoint() with getLength() because in
    // THREE.Curve, getLength() depends on getPoint() but in THREE.CurvePath
    // getPoint() depends on getLength
    getLength() {
        const lens = this.getCurveLengths();
        return lens[lens.length - 1];
    }
    // cacheLengths must be recalculated.
    updateArcLengths() {
        this.needsUpdate = true;
        this.cacheLengths = null;
        this.getCurveLengths();
    }
    // Compute lengths and cache them
    // We cannot overwrite getLengths() because UtoT mapping uses it.
    getCurveLengths() {
        // We use cache values if curves and cache array are same length
        if (this.cacheLengths && this.cacheLengths.length === this.curves.length) return this.cacheLengths;
        // Get length of sub-curve
        // Push sums into cached array
        const lengths = [];
        let sums = 0;
        for(let i = 0, l = this.curves.length; i < l; i++){
            sums += this.curves[i].getLength();
            lengths.push(sums);
        }
        this.cacheLengths = lengths;
        return lengths;
    }
    getSpacedPoints(divisions = 40) {
        const points = [];
        for(let i = 0; i <= divisions; i++)points.push(this.getPoint(i / divisions));
        if (this.autoClose) points.push(points[0]);
        return points;
    }
    getPoints(divisions = 12) {
        const points = [];
        let last;
        for(let i = 0, curves = this.curves; i < curves.length; i++){
            const curve = curves[i];
            const resolution = curve.isEllipseCurve ? divisions * 2 : curve.isLineCurve || curve.isLineCurve3 ? 1 : curve.isSplineCurve ? divisions * curve.points.length : divisions;
            const pts = curve.getPoints(resolution);
            for(let j = 0; j < pts.length; j++){
                const point = pts[j];
                if (last && last.equals(point)) continue; // ensures no consecutive points are duplicates
                points.push(point);
                last = point;
            }
        }
        if (this.autoClose && points.length > 1 && !points[points.length - 1].equals(points[0])) points.push(points[0]);
        return points;
    }
    copy(source) {
        super.copy(source);
        this.curves = [];
        for(let i = 0, l = source.curves.length; i < l; i++){
            const curve = source.curves[i];
            this.curves.push(curve.clone());
        }
        this.autoClose = source.autoClose;
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.autoClose = this.autoClose;
        data.curves = [];
        for(let i = 0, l = this.curves.length; i < l; i++){
            const curve = this.curves[i];
            data.curves.push(curve.toJSON());
        }
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.autoClose = json.autoClose;
        this.curves = [];
        for(let i = 0, l = json.curves.length; i < l; i++){
            const curve = json.curves[i];
            this.curves.push(new $d5b33d7c30034067$var$Curves[curve.type]().fromJSON(curve));
        }
        return this;
    }
}
class $d5b33d7c30034067$export$4b2950bdac9b6ee9 extends $d5b33d7c30034067$export$4aaf9b66af1bbf2c {
    constructor(points){
        super();
        this.type = 'Path';
        this.currentPoint = new $d5b33d7c30034067$export$c977b3e384af9ae1();
        if (points) this.setFromPoints(points);
    }
    setFromPoints(points) {
        this.moveTo(points[0].x, points[0].y);
        for(let i = 1, l = points.length; i < l; i++)this.lineTo(points[i].x, points[i].y);
        return this;
    }
    moveTo(x, y) {
        this.currentPoint.set(x, y); // TODO consider referencing vectors instead of copying?
        return this;
    }
    lineTo(x, y) {
        const curve = new $d5b33d7c30034067$export$ab2e07e76531a47e(this.currentPoint.clone(), new $d5b33d7c30034067$export$c977b3e384af9ae1(x, y));
        this.curves.push(curve);
        this.currentPoint.set(x, y);
        return this;
    }
    quadraticCurveTo(aCPx, aCPy, aX, aY) {
        const curve = new $d5b33d7c30034067$export$5938c4ee491a43ad(this.currentPoint.clone(), new $d5b33d7c30034067$export$c977b3e384af9ae1(aCPx, aCPy), new $d5b33d7c30034067$export$c977b3e384af9ae1(aX, aY));
        this.curves.push(curve);
        this.currentPoint.set(aX, aY);
        return this;
    }
    bezierCurveTo(aCP1x, aCP1y, aCP2x, aCP2y, aX, aY) {
        const curve = new $d5b33d7c30034067$export$e36650d36468bb39(this.currentPoint.clone(), new $d5b33d7c30034067$export$c977b3e384af9ae1(aCP1x, aCP1y), new $d5b33d7c30034067$export$c977b3e384af9ae1(aCP2x, aCP2y), new $d5b33d7c30034067$export$c977b3e384af9ae1(aX, aY));
        this.curves.push(curve);
        this.currentPoint.set(aX, aY);
        return this;
    }
    splineThru(pts /*Array of Vector*/ ) {
        const npts = [
            this.currentPoint.clone()
        ].concat(pts);
        const curve = new $d5b33d7c30034067$export$d3bdd77da77afc1b(npts);
        this.curves.push(curve);
        this.currentPoint.copy(pts[pts.length - 1]);
        return this;
    }
    arc(aX, aY, aRadius, aStartAngle, aEndAngle, aClockwise) {
        const x0 = this.currentPoint.x;
        const y0 = this.currentPoint.y;
        this.absarc(aX + x0, aY + y0, aRadius, aStartAngle, aEndAngle, aClockwise);
        return this;
    }
    absarc(aX, aY, aRadius, aStartAngle, aEndAngle, aClockwise) {
        this.absellipse(aX, aY, aRadius, aRadius, aStartAngle, aEndAngle, aClockwise);
        return this;
    }
    ellipse(aX, aY, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation) {
        const x0 = this.currentPoint.x;
        const y0 = this.currentPoint.y;
        this.absellipse(aX + x0, aY + y0, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation);
        return this;
    }
    absellipse(aX, aY, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation) {
        const curve = new $d5b33d7c30034067$export$3f87a931616cde04(aX, aY, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation);
        if (this.curves.length > 0) {
            // if a previous curve is present, attempt to join
            const firstPoint = curve.getPoint(0);
            if (!firstPoint.equals(this.currentPoint)) this.lineTo(firstPoint.x, firstPoint.y);
        }
        this.curves.push(curve);
        const lastPoint = curve.getPoint(1);
        this.currentPoint.copy(lastPoint);
        return this;
    }
    copy(source) {
        super.copy(source);
        this.currentPoint.copy(source.currentPoint);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.currentPoint = this.currentPoint.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.currentPoint.fromArray(json.currentPoint);
        return this;
    }
}
class $d5b33d7c30034067$export$6d839803fcd1882c extends $d5b33d7c30034067$export$b7be63a67df8959 {
    constructor(points = [
        new $d5b33d7c30034067$export$c977b3e384af9ae1(0, -0.5),
        new $d5b33d7c30034067$export$c977b3e384af9ae1(0.5, 0),
        new $d5b33d7c30034067$export$c977b3e384af9ae1(0, 0.5)
    ], segments = 12, phiStart = 0, phiLength = Math.PI * 2){
        super();
        this.type = 'LatheGeometry';
        this.parameters = {
            points: points,
            segments: segments,
            phiStart: phiStart,
            phiLength: phiLength
        };
        segments = Math.floor(segments);
        // clamp phiLength so it's in range of [ 0, 2PI ]
        phiLength = $d5b33d7c30034067$var$clamp(phiLength, 0, Math.PI * 2);
        // buffers
        const indices = [];
        const vertices = [];
        const uvs = [];
        const initNormals = [];
        const normals = [];
        // helper variables
        const inverseSegments = 1.0 / segments;
        const vertex = new $d5b33d7c30034067$export$64b5c384219d3699();
        const uv = new $d5b33d7c30034067$export$c977b3e384af9ae1();
        const normal = new $d5b33d7c30034067$export$64b5c384219d3699();
        const curNormal = new $d5b33d7c30034067$export$64b5c384219d3699();
        const prevNormal = new $d5b33d7c30034067$export$64b5c384219d3699();
        let dx = 0;
        let dy = 0;
        // pre-compute normals for initial "meridian"
        for(let j = 0; j <= points.length - 1; j++)switch(j){
            case 0:
                dx = points[j + 1].x - points[j].x;
                dy = points[j + 1].y - points[j].y;
                normal.x = dy * 1.0;
                normal.y = -dx;
                normal.z = dy * 0.0;
                prevNormal.copy(normal);
                normal.normalize();
                initNormals.push(normal.x, normal.y, normal.z);
                break;
            case points.length - 1:
                initNormals.push(prevNormal.x, prevNormal.y, prevNormal.z);
                break;
            default:
                dx = points[j + 1].x - points[j].x;
                dy = points[j + 1].y - points[j].y;
                normal.x = dy * 1.0;
                normal.y = -dx;
                normal.z = dy * 0.0;
                curNormal.copy(normal);
                normal.x += prevNormal.x;
                normal.y += prevNormal.y;
                normal.z += prevNormal.z;
                normal.normalize();
                initNormals.push(normal.x, normal.y, normal.z);
                prevNormal.copy(curNormal);
        }
        // generate vertices, uvs and normals
        for(let i = 0; i <= segments; i++){
            const phi = phiStart + i * inverseSegments * phiLength;
            const sin = Math.sin(phi);
            const cos = Math.cos(phi);
            for(let j = 0; j <= points.length - 1; j++){
                // vertex
                vertex.x = points[j].x * sin;
                vertex.y = points[j].y;
                vertex.z = points[j].x * cos;
                vertices.push(vertex.x, vertex.y, vertex.z);
                // uv
                uv.x = i / segments;
                uv.y = j / (points.length - 1);
                uvs.push(uv.x, uv.y);
                // normal
                const x = initNormals[3 * j + 0] * sin;
                const y = initNormals[3 * j + 1];
                const z = initNormals[3 * j + 0] * cos;
                normals.push(x, y, z);
            }
        }
        // indices
        for(let i = 0; i < segments; i++)for(let j = 0; j < points.length - 1; j++){
            const base = j + i * points.length;
            const a = base;
            const b = base + points.length;
            const c = base + points.length + 1;
            const d = base + 1;
            // faces
            indices.push(a, b, d);
            indices.push(c, d, b);
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new $d5b33d7c30034067$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute('uv', new $d5b33d7c30034067$export$cbe7a62641830ebd(uvs, 2));
        this.setAttribute('normal', new $d5b33d7c30034067$export$cbe7a62641830ebd(normals, 3));
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    static fromJSON(data) {
        return new $d5b33d7c30034067$export$6d839803fcd1882c(data.points, data.segments, data.phiStart, data.phiLength);
    }
}
class $d5b33d7c30034067$export$41680e8551036033 extends $d5b33d7c30034067$export$6d839803fcd1882c {
    constructor(radius = 1, length = 1, capSegments = 4, radialSegments = 8){
        const path = new $d5b33d7c30034067$export$4b2950bdac9b6ee9();
        path.absarc(0, -length / 2, radius, Math.PI * 1.5, 0);
        path.absarc(0, length / 2, radius, 0, Math.PI * 0.5);
        super(path.getPoints(capSegments), radialSegments);
        this.type = 'CapsuleGeometry';
        this.parameters = {
            radius: radius,
            length: length,
            capSegments: capSegments,
            radialSegments: radialSegments
        };
    }
    static fromJSON(data) {
        return new $d5b33d7c30034067$export$41680e8551036033(data.radius, data.length, data.capSegments, data.radialSegments);
    }
}
class $d5b33d7c30034067$export$d5c0e8d607467193 extends $d5b33d7c30034067$export$b7be63a67df8959 {
    constructor(radius = 1, segments = 32, thetaStart = 0, thetaLength = Math.PI * 2){
        super();
        this.type = 'CircleGeometry';
        this.parameters = {
            radius: radius,
            segments: segments,
            thetaStart: thetaStart,
            thetaLength: thetaLength
        };
        segments = Math.max(3, segments);
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // helper variables
        const vertex = new $d5b33d7c30034067$export$64b5c384219d3699();
        const uv = new $d5b33d7c30034067$export$c977b3e384af9ae1();
        // center point
        vertices.push(0, 0, 0);
        normals.push(0, 0, 1);
        uvs.push(0.5, 0.5);
        for(let s = 0, i = 3; s <= segments; s++, i += 3){
            const segment = thetaStart + s / segments * thetaLength;
            // vertex
            vertex.x = radius * Math.cos(segment);
            vertex.y = radius * Math.sin(segment);
            vertices.push(vertex.x, vertex.y, vertex.z);
            // normal
            normals.push(0, 0, 1);
            // uvs
            uv.x = (vertices[i] / radius + 1) / 2;
            uv.y = (vertices[i + 1] / radius + 1) / 2;
            uvs.push(uv.x, uv.y);
        }
        // indices
        for(let i = 1; i <= segments; i++)indices.push(i, i + 1, 0);
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new $d5b33d7c30034067$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute('normal', new $d5b33d7c30034067$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute('uv', new $d5b33d7c30034067$export$cbe7a62641830ebd(uvs, 2));
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    static fromJSON(data) {
        return new $d5b33d7c30034067$export$d5c0e8d607467193(data.radius, data.segments, data.thetaStart, data.thetaLength);
    }
}
class $d5b33d7c30034067$export$68f745719dbe5198 extends $d5b33d7c30034067$export$b7be63a67df8959 {
    constructor(radiusTop = 1, radiusBottom = 1, height = 1, radialSegments = 32, heightSegments = 1, openEnded = false, thetaStart = 0, thetaLength = Math.PI * 2){
        super();
        this.type = 'CylinderGeometry';
        this.parameters = {
            radiusTop: radiusTop,
            radiusBottom: radiusBottom,
            height: height,
            radialSegments: radialSegments,
            heightSegments: heightSegments,
            openEnded: openEnded,
            thetaStart: thetaStart,
            thetaLength: thetaLength
        };
        const scope = this;
        radialSegments = Math.floor(radialSegments);
        heightSegments = Math.floor(heightSegments);
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // helper variables
        let index = 0;
        const indexArray = [];
        const halfHeight = height / 2;
        let groupStart = 0;
        // generate geometry
        generateTorso();
        if (openEnded === false) {
            if (radiusTop > 0) generateCap(true);
            if (radiusBottom > 0) generateCap(false);
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new $d5b33d7c30034067$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute('normal', new $d5b33d7c30034067$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute('uv', new $d5b33d7c30034067$export$cbe7a62641830ebd(uvs, 2));
        function generateTorso() {
            const normal = new $d5b33d7c30034067$export$64b5c384219d3699();
            const vertex = new $d5b33d7c30034067$export$64b5c384219d3699();
            let groupCount = 0;
            // this will be used to calculate the normal
            const slope = (radiusBottom - radiusTop) / height;
            // generate vertices, normals and uvs
            for(let y = 0; y <= heightSegments; y++){
                const indexRow = [];
                const v = y / heightSegments;
                // calculate the radius of the current row
                const radius = v * (radiusBottom - radiusTop) + radiusTop;
                for(let x = 0; x <= radialSegments; x++){
                    const u = x / radialSegments;
                    const theta = u * thetaLength + thetaStart;
                    const sinTheta = Math.sin(theta);
                    const cosTheta = Math.cos(theta);
                    // vertex
                    vertex.x = radius * sinTheta;
                    vertex.y = -v * height + halfHeight;
                    vertex.z = radius * cosTheta;
                    vertices.push(vertex.x, vertex.y, vertex.z);
                    // normal
                    normal.set(sinTheta, slope, cosTheta).normalize();
                    normals.push(normal.x, normal.y, normal.z);
                    // uv
                    uvs.push(u, 1 - v);
                    // save index of vertex in respective row
                    indexRow.push(index++);
                }
                // now save vertices of the row in our index array
                indexArray.push(indexRow);
            }
            // generate indices
            for(let x = 0; x < radialSegments; x++)for(let y = 0; y < heightSegments; y++){
                // we use the index array to access the correct indices
                const a = indexArray[y][x];
                const b = indexArray[y + 1][x];
                const c = indexArray[y + 1][x + 1];
                const d = indexArray[y][x + 1];
                // faces
                if (radiusTop > 0 || y !== 0) {
                    indices.push(a, b, d);
                    groupCount += 3;
                }
                if (radiusBottom > 0 || y !== heightSegments - 1) {
                    indices.push(b, c, d);
                    groupCount += 3;
                }
            }
            // add a group to the geometry. this will ensure multi material support
            scope.addGroup(groupStart, groupCount, 0);
            // calculate new start value for groups
            groupStart += groupCount;
        }
        function generateCap(top) {
            // save the index of the first center vertex
            const centerIndexStart = index;
            const uv = new $d5b33d7c30034067$export$c977b3e384af9ae1();
            const vertex = new $d5b33d7c30034067$export$64b5c384219d3699();
            let groupCount = 0;
            const radius = top === true ? radiusTop : radiusBottom;
            const sign = top === true ? 1 : -1;
            // first we generate the center vertex data of the cap.
            // because the geometry needs one set of uvs per face,
            // we must generate a center vertex per face/segment
            for(let x = 1; x <= radialSegments; x++){
                // vertex
                vertices.push(0, halfHeight * sign, 0);
                // normal
                normals.push(0, sign, 0);
                // uv
                uvs.push(0.5, 0.5);
                // increase index
                index++;
            }
            // save the index of the last center vertex
            const centerIndexEnd = index;
            // now we generate the surrounding vertices, normals and uvs
            for(let x = 0; x <= radialSegments; x++){
                const u = x / radialSegments;
                const theta = u * thetaLength + thetaStart;
                const cosTheta = Math.cos(theta);
                const sinTheta = Math.sin(theta);
                // vertex
                vertex.x = radius * sinTheta;
                vertex.y = halfHeight * sign;
                vertex.z = radius * cosTheta;
                vertices.push(vertex.x, vertex.y, vertex.z);
                // normal
                normals.push(0, sign, 0);
                // uv
                uv.x = cosTheta * 0.5 + 0.5;
                uv.y = sinTheta * 0.5 * sign + 0.5;
                uvs.push(uv.x, uv.y);
                // increase index
                index++;
            }
            // generate indices
            for(let x = 0; x < radialSegments; x++){
                const c = centerIndexStart + x;
                const i = centerIndexEnd + x;
                if (top === true) // face top
                indices.push(i, i + 1, c);
                else // face bottom
                indices.push(i + 1, i, c);
                groupCount += 3;
            }
            // add a group to the geometry. this will ensure multi material support
            scope.addGroup(groupStart, groupCount, top === true ? 1 : 2);
            // calculate new start value for groups
            groupStart += groupCount;
        }
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    static fromJSON(data) {
        return new $d5b33d7c30034067$export$68f745719dbe5198(data.radiusTop, data.radiusBottom, data.height, data.radialSegments, data.heightSegments, data.openEnded, data.thetaStart, data.thetaLength);
    }
}
class $d5b33d7c30034067$export$a7a48974f285c9b3 extends $d5b33d7c30034067$export$68f745719dbe5198 {
    constructor(radius = 1, height = 1, radialSegments = 32, heightSegments = 1, openEnded = false, thetaStart = 0, thetaLength = Math.PI * 2){
        super(0, radius, height, radialSegments, heightSegments, openEnded, thetaStart, thetaLength);
        this.type = 'ConeGeometry';
        this.parameters = {
            radius: radius,
            height: height,
            radialSegments: radialSegments,
            heightSegments: heightSegments,
            openEnded: openEnded,
            thetaStart: thetaStart,
            thetaLength: thetaLength
        };
    }
    static fromJSON(data) {
        return new $d5b33d7c30034067$export$a7a48974f285c9b3(data.radius, data.height, data.radialSegments, data.heightSegments, data.openEnded, data.thetaStart, data.thetaLength);
    }
}
class $d5b33d7c30034067$export$60e57a7d3f20ff65 extends $d5b33d7c30034067$export$b7be63a67df8959 {
    constructor(vertices = [], indices = [], radius = 1, detail = 0){
        super();
        this.type = 'PolyhedronGeometry';
        this.parameters = {
            vertices: vertices,
            indices: indices,
            radius: radius,
            detail: detail
        };
        // default buffer data
        const vertexBuffer = [];
        const uvBuffer = [];
        // the subdivision creates the vertex buffer data
        subdivide(detail);
        // all vertices should lie on a conceptual sphere with a given radius
        applyRadius(radius);
        // finally, create the uv data
        generateUVs();
        // build non-indexed geometry
        this.setAttribute('position', new $d5b33d7c30034067$export$cbe7a62641830ebd(vertexBuffer, 3));
        this.setAttribute('normal', new $d5b33d7c30034067$export$cbe7a62641830ebd(vertexBuffer.slice(), 3));
        this.setAttribute('uv', new $d5b33d7c30034067$export$cbe7a62641830ebd(uvBuffer, 2));
        if (detail === 0) this.computeVertexNormals(); // flat normals
        else this.normalizeNormals(); // smooth normals
        // helper functions
        function subdivide(detail) {
            const a = new $d5b33d7c30034067$export$64b5c384219d3699();
            const b = new $d5b33d7c30034067$export$64b5c384219d3699();
            const c = new $d5b33d7c30034067$export$64b5c384219d3699();
            // iterate over all faces and apply a subdivision with the given detail value
            for(let i = 0; i < indices.length; i += 3){
                // get the vertices of the face
                getVertexByIndex(indices[i + 0], a);
                getVertexByIndex(indices[i + 1], b);
                getVertexByIndex(indices[i + 2], c);
                // perform subdivision
                subdivideFace(a, b, c, detail);
            }
        }
        function subdivideFace(a, b, c, detail) {
            const cols = detail + 1;
            // we use this multidimensional array as a data structure for creating the subdivision
            const v = [];
            // construct all of the vertices for this subdivision
            for(let i = 0; i <= cols; i++){
                v[i] = [];
                const aj = a.clone().lerp(c, i / cols);
                const bj = b.clone().lerp(c, i / cols);
                const rows = cols - i;
                for(let j = 0; j <= rows; j++)if (j === 0 && i === cols) v[i][j] = aj;
                else v[i][j] = aj.clone().lerp(bj, j / rows);
            }
            // construct all of the faces
            for(let i = 0; i < cols; i++)for(let j = 0; j < 2 * (cols - i) - 1; j++){
                const k = Math.floor(j / 2);
                if (j % 2 === 0) {
                    pushVertex(v[i][k + 1]);
                    pushVertex(v[i + 1][k]);
                    pushVertex(v[i][k]);
                } else {
                    pushVertex(v[i][k + 1]);
                    pushVertex(v[i + 1][k + 1]);
                    pushVertex(v[i + 1][k]);
                }
            }
        }
        function applyRadius(radius) {
            const vertex = new $d5b33d7c30034067$export$64b5c384219d3699();
            // iterate over the entire buffer and apply the radius to each vertex
            for(let i = 0; i < vertexBuffer.length; i += 3){
                vertex.x = vertexBuffer[i + 0];
                vertex.y = vertexBuffer[i + 1];
                vertex.z = vertexBuffer[i + 2];
                vertex.normalize().multiplyScalar(radius);
                vertexBuffer[i + 0] = vertex.x;
                vertexBuffer[i + 1] = vertex.y;
                vertexBuffer[i + 2] = vertex.z;
            }
        }
        function generateUVs() {
            const vertex = new $d5b33d7c30034067$export$64b5c384219d3699();
            for(let i = 0; i < vertexBuffer.length; i += 3){
                vertex.x = vertexBuffer[i + 0];
                vertex.y = vertexBuffer[i + 1];
                vertex.z = vertexBuffer[i + 2];
                const u = azimuth(vertex) / 2 / Math.PI + 0.5;
                const v = inclination(vertex) / Math.PI + 0.5;
                uvBuffer.push(u, 1 - v);
            }
            correctUVs();
            correctSeam();
        }
        function correctSeam() {
            // handle case when face straddles the seam, see #3269
            for(let i = 0; i < uvBuffer.length; i += 6){
                // uv data of a single face
                const x0 = uvBuffer[i + 0];
                const x1 = uvBuffer[i + 2];
                const x2 = uvBuffer[i + 4];
                const max = Math.max(x0, x1, x2);
                const min = Math.min(x0, x1, x2);
                // 0.9 is somewhat arbitrary
                if (max > 0.9 && min < 0.1) {
                    if (x0 < 0.2) uvBuffer[i + 0] += 1;
                    if (x1 < 0.2) uvBuffer[i + 2] += 1;
                    if (x2 < 0.2) uvBuffer[i + 4] += 1;
                }
            }
        }
        function pushVertex(vertex) {
            vertexBuffer.push(vertex.x, vertex.y, vertex.z);
        }
        function getVertexByIndex(index, vertex) {
            const stride = index * 3;
            vertex.x = vertices[stride + 0];
            vertex.y = vertices[stride + 1];
            vertex.z = vertices[stride + 2];
        }
        function correctUVs() {
            const a = new $d5b33d7c30034067$export$64b5c384219d3699();
            const b = new $d5b33d7c30034067$export$64b5c384219d3699();
            const c = new $d5b33d7c30034067$export$64b5c384219d3699();
            const centroid = new $d5b33d7c30034067$export$64b5c384219d3699();
            const uvA = new $d5b33d7c30034067$export$c977b3e384af9ae1();
            const uvB = new $d5b33d7c30034067$export$c977b3e384af9ae1();
            const uvC = new $d5b33d7c30034067$export$c977b3e384af9ae1();
            for(let i = 0, j = 0; i < vertexBuffer.length; i += 9, j += 6){
                a.set(vertexBuffer[i + 0], vertexBuffer[i + 1], vertexBuffer[i + 2]);
                b.set(vertexBuffer[i + 3], vertexBuffer[i + 4], vertexBuffer[i + 5]);
                c.set(vertexBuffer[i + 6], vertexBuffer[i + 7], vertexBuffer[i + 8]);
                uvA.set(uvBuffer[j + 0], uvBuffer[j + 1]);
                uvB.set(uvBuffer[j + 2], uvBuffer[j + 3]);
                uvC.set(uvBuffer[j + 4], uvBuffer[j + 5]);
                centroid.copy(a).add(b).add(c).divideScalar(3);
                const azi = azimuth(centroid);
                correctUV(uvA, j + 0, a, azi);
                correctUV(uvB, j + 2, b, azi);
                correctUV(uvC, j + 4, c, azi);
            }
        }
        function correctUV(uv, stride, vector, azimuth) {
            if (azimuth < 0 && uv.x === 1) uvBuffer[stride] = uv.x - 1;
            if (vector.x === 0 && vector.z === 0) uvBuffer[stride] = azimuth / 2 / Math.PI + 0.5;
        }
        // Angle around the Y axis, counter-clockwise when looking from above.
        function azimuth(vector) {
            return Math.atan2(vector.z, -vector.x);
        }
        // Angle above the XZ plane.
        function inclination(vector) {
            return Math.atan2(-vector.y, Math.sqrt(vector.x * vector.x + vector.z * vector.z));
        }
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    static fromJSON(data) {
        return new $d5b33d7c30034067$export$60e57a7d3f20ff65(data.vertices, data.indices, data.radius, data.details);
    }
}
class $d5b33d7c30034067$export$c0babfeb8708fc9c extends $d5b33d7c30034067$export$60e57a7d3f20ff65 {
    constructor(radius = 1, detail = 0){
        const t = (1 + Math.sqrt(5)) / 2;
        const r = 1 / t;
        const vertices = [
            // (±1, ±1, ±1)
            -1,
            -1,
            -1,
            -1,
            -1,
            1,
            -1,
            1,
            -1,
            -1,
            1,
            1,
            1,
            -1,
            -1,
            1,
            -1,
            1,
            1,
            1,
            -1,
            1,
            1,
            1,
            // (0, ±1/φ, ±φ)
            0,
            -r,
            -t,
            0,
            -r,
            t,
            0,
            r,
            -t,
            0,
            r,
            t,
            // (±1/φ, ±φ, 0)
            -r,
            -t,
            0,
            -r,
            t,
            0,
            r,
            -t,
            0,
            r,
            t,
            0,
            // (±φ, 0, ±1/φ)
            -t,
            0,
            -r,
            t,
            0,
            -r,
            -t,
            0,
            r,
            t,
            0,
            r
        ];
        const indices = [
            3,
            11,
            7,
            3,
            7,
            15,
            3,
            15,
            13,
            7,
            19,
            17,
            7,
            17,
            6,
            7,
            6,
            15,
            17,
            4,
            8,
            17,
            8,
            10,
            17,
            10,
            6,
            8,
            0,
            16,
            8,
            16,
            2,
            8,
            2,
            10,
            0,
            12,
            1,
            0,
            1,
            18,
            0,
            18,
            16,
            6,
            10,
            2,
            6,
            2,
            13,
            6,
            13,
            15,
            2,
            16,
            18,
            2,
            18,
            3,
            2,
            3,
            13,
            18,
            1,
            9,
            18,
            9,
            11,
            18,
            11,
            3,
            4,
            14,
            12,
            4,
            12,
            0,
            4,
            0,
            8,
            11,
            9,
            5,
            11,
            5,
            19,
            11,
            19,
            7,
            19,
            5,
            14,
            19,
            14,
            4,
            19,
            4,
            17,
            1,
            12,
            14,
            1,
            14,
            5,
            1,
            5,
            9
        ];
        super(vertices, indices, radius, detail);
        this.type = 'DodecahedronGeometry';
        this.parameters = {
            radius: radius,
            detail: detail
        };
    }
    static fromJSON(data) {
        return new $d5b33d7c30034067$export$c0babfeb8708fc9c(data.radius, data.detail);
    }
}
const $d5b33d7c30034067$var$_v0 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_v1$1 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_normal = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_triangle = /*@__PURE__*/ new $d5b33d7c30034067$export$5a465592bfe74b48();
class $d5b33d7c30034067$export$4730b1542707547f extends $d5b33d7c30034067$export$b7be63a67df8959 {
    constructor(geometry = null, thresholdAngle = 1){
        super();
        this.type = 'EdgesGeometry';
        this.parameters = {
            geometry: geometry,
            thresholdAngle: thresholdAngle
        };
        if (geometry !== null) {
            const precisionPoints = 4;
            const precision = Math.pow(10, precisionPoints);
            const thresholdDot = Math.cos($d5b33d7c30034067$var$DEG2RAD * thresholdAngle);
            const indexAttr = geometry.getIndex();
            const positionAttr = geometry.getAttribute('position');
            const indexCount = indexAttr ? indexAttr.count : positionAttr.count;
            const indexArr = [
                0,
                0,
                0
            ];
            const vertKeys = [
                'a',
                'b',
                'c'
            ];
            const hashes = new Array(3);
            const edgeData = {};
            const vertices = [];
            for(let i = 0; i < indexCount; i += 3){
                if (indexAttr) {
                    indexArr[0] = indexAttr.getX(i);
                    indexArr[1] = indexAttr.getX(i + 1);
                    indexArr[2] = indexAttr.getX(i + 2);
                } else {
                    indexArr[0] = i;
                    indexArr[1] = i + 1;
                    indexArr[2] = i + 2;
                }
                const { a: a, b: b, c: c } = $d5b33d7c30034067$var$_triangle;
                a.fromBufferAttribute(positionAttr, indexArr[0]);
                b.fromBufferAttribute(positionAttr, indexArr[1]);
                c.fromBufferAttribute(positionAttr, indexArr[2]);
                $d5b33d7c30034067$var$_triangle.getNormal($d5b33d7c30034067$var$_normal);
                // create hashes for the edge from the vertices
                hashes[0] = `${Math.round(a.x * precision)},${Math.round(a.y * precision)},${Math.round(a.z * precision)}`;
                hashes[1] = `${Math.round(b.x * precision)},${Math.round(b.y * precision)},${Math.round(b.z * precision)}`;
                hashes[2] = `${Math.round(c.x * precision)},${Math.round(c.y * precision)},${Math.round(c.z * precision)}`;
                // skip degenerate triangles
                if (hashes[0] === hashes[1] || hashes[1] === hashes[2] || hashes[2] === hashes[0]) continue;
                // iterate over every edge
                for(let j = 0; j < 3; j++){
                    // get the first and next vertex making up the edge
                    const jNext = (j + 1) % 3;
                    const vecHash0 = hashes[j];
                    const vecHash1 = hashes[jNext];
                    const v0 = $d5b33d7c30034067$var$_triangle[vertKeys[j]];
                    const v1 = $d5b33d7c30034067$var$_triangle[vertKeys[jNext]];
                    const hash = `${vecHash0}_${vecHash1}`;
                    const reverseHash = `${vecHash1}_${vecHash0}`;
                    if (reverseHash in edgeData && edgeData[reverseHash]) {
                        // if we found a sibling edge add it into the vertex array if
                        // it meets the angle threshold and delete the edge from the map.
                        if ($d5b33d7c30034067$var$_normal.dot(edgeData[reverseHash].normal) <= thresholdDot) {
                            vertices.push(v0.x, v0.y, v0.z);
                            vertices.push(v1.x, v1.y, v1.z);
                        }
                        edgeData[reverseHash] = null;
                    } else if (!(hash in edgeData)) // if we've already got an edge here then skip adding a new one
                    edgeData[hash] = {
                        index0: indexArr[j],
                        index1: indexArr[jNext],
                        normal: $d5b33d7c30034067$var$_normal.clone()
                    };
                }
            }
            // iterate over all remaining, unmatched edges and add them to the vertex array
            for(const key in edgeData)if (edgeData[key]) {
                const { index0: index0, index1: index1 } = edgeData[key];
                $d5b33d7c30034067$var$_v0.fromBufferAttribute(positionAttr, index0);
                $d5b33d7c30034067$var$_v1$1.fromBufferAttribute(positionAttr, index1);
                vertices.push($d5b33d7c30034067$var$_v0.x, $d5b33d7c30034067$var$_v0.y, $d5b33d7c30034067$var$_v0.z);
                vertices.push($d5b33d7c30034067$var$_v1$1.x, $d5b33d7c30034067$var$_v1$1.y, $d5b33d7c30034067$var$_v1$1.z);
            }
            this.setAttribute('position', new $d5b33d7c30034067$export$cbe7a62641830ebd(vertices, 3));
        }
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
}
class $d5b33d7c30034067$export$6428a7f2611ef1fa extends $d5b33d7c30034067$export$4b2950bdac9b6ee9 {
    constructor(points){
        super(points);
        this.uuid = $d5b33d7c30034067$var$generateUUID();
        this.type = 'Shape';
        this.holes = [];
    }
    getPointsHoles(divisions) {
        const holesPts = [];
        for(let i = 0, l = this.holes.length; i < l; i++)holesPts[i] = this.holes[i].getPoints(divisions);
        return holesPts;
    }
    // get points of shape and holes (keypoints based on segments parameter)
    extractPoints(divisions) {
        return {
            shape: this.getPoints(divisions),
            holes: this.getPointsHoles(divisions)
        };
    }
    copy(source) {
        super.copy(source);
        this.holes = [];
        for(let i = 0, l = source.holes.length; i < l; i++){
            const hole = source.holes[i];
            this.holes.push(hole.clone());
        }
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.uuid = this.uuid;
        data.holes = [];
        for(let i = 0, l = this.holes.length; i < l; i++){
            const hole = this.holes[i];
            data.holes.push(hole.toJSON());
        }
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.uuid = json.uuid;
        this.holes = [];
        for(let i = 0, l = json.holes.length; i < l; i++){
            const hole = json.holes[i];
            this.holes.push(new $d5b33d7c30034067$export$4b2950bdac9b6ee9().fromJSON(hole));
        }
        return this;
    }
}
/**
 * Port from https://github.com/mapbox/earcut (v2.2.4)
 */ const $d5b33d7c30034067$var$Earcut = {
    triangulate: function(data, holeIndices, dim = 2) {
        const hasHoles = holeIndices && holeIndices.length;
        const outerLen = hasHoles ? holeIndices[0] * dim : data.length;
        let outerNode = $d5b33d7c30034067$var$linkedList(data, 0, outerLen, dim, true);
        const triangles = [];
        if (!outerNode || outerNode.next === outerNode.prev) return triangles;
        let minX, minY, maxX, maxY, x, y, invSize;
        if (hasHoles) outerNode = $d5b33d7c30034067$var$eliminateHoles(data, holeIndices, outerNode, dim);
        // if the shape is not too simple, we'll use z-order curve hash later; calculate polygon bbox
        if (data.length > 80 * dim) {
            minX = maxX = data[0];
            minY = maxY = data[1];
            for(let i = dim; i < outerLen; i += dim){
                x = data[i];
                y = data[i + 1];
                if (x < minX) minX = x;
                if (y < minY) minY = y;
                if (x > maxX) maxX = x;
                if (y > maxY) maxY = y;
            }
            // minX, minY and invSize are later used to transform coords into integers for z-order calculation
            invSize = Math.max(maxX - minX, maxY - minY);
            invSize = invSize !== 0 ? 32767 / invSize : 0;
        }
        $d5b33d7c30034067$var$earcutLinked(outerNode, triangles, dim, minX, minY, invSize, 0);
        return triangles;
    }
};
// create a circular doubly linked list from polygon points in the specified winding order
function $d5b33d7c30034067$var$linkedList(data, start, end, dim, clockwise) {
    let i, last;
    if (clockwise === $d5b33d7c30034067$var$signedArea(data, start, end, dim) > 0) for(i = start; i < end; i += dim)last = $d5b33d7c30034067$var$insertNode(i, data[i], data[i + 1], last);
    else for(i = end - dim; i >= start; i -= dim)last = $d5b33d7c30034067$var$insertNode(i, data[i], data[i + 1], last);
    if (last && $d5b33d7c30034067$var$equals(last, last.next)) {
        $d5b33d7c30034067$var$removeNode(last);
        last = last.next;
    }
    return last;
}
// eliminate colinear or duplicate points
function $d5b33d7c30034067$var$filterPoints(start, end) {
    if (!start) return start;
    if (!end) end = start;
    let p = start, again;
    do {
        again = false;
        if (!p.steiner && ($d5b33d7c30034067$var$equals(p, p.next) || $d5b33d7c30034067$var$area(p.prev, p, p.next) === 0)) {
            $d5b33d7c30034067$var$removeNode(p);
            p = end = p.prev;
            if (p === p.next) break;
            again = true;
        } else p = p.next;
    }while (again || p !== end);
    return end;
}
// main ear slicing loop which triangulates a polygon (given as a linked list)
function $d5b33d7c30034067$var$earcutLinked(ear, triangles, dim, minX, minY, invSize, pass) {
    if (!ear) return;
    // interlink polygon nodes in z-order
    if (!pass && invSize) $d5b33d7c30034067$var$indexCurve(ear, minX, minY, invSize);
    let stop = ear, prev, next;
    // iterate through ears, slicing them one by one
    while(ear.prev !== ear.next){
        prev = ear.prev;
        next = ear.next;
        if (invSize ? $d5b33d7c30034067$var$isEarHashed(ear, minX, minY, invSize) : $d5b33d7c30034067$var$isEar(ear)) {
            // cut off the triangle
            triangles.push(prev.i / dim | 0);
            triangles.push(ear.i / dim | 0);
            triangles.push(next.i / dim | 0);
            $d5b33d7c30034067$var$removeNode(ear);
            // skipping the next vertex leads to less sliver triangles
            ear = next.next;
            stop = next.next;
            continue;
        }
        ear = next;
        // if we looped through the whole remaining polygon and can't find any more ears
        if (ear === stop) {
            // try filtering points and slicing again
            if (!pass) $d5b33d7c30034067$var$earcutLinked($d5b33d7c30034067$var$filterPoints(ear), triangles, dim, minX, minY, invSize, 1);
            else if (pass === 1) {
                ear = $d5b33d7c30034067$var$cureLocalIntersections($d5b33d7c30034067$var$filterPoints(ear), triangles, dim);
                $d5b33d7c30034067$var$earcutLinked(ear, triangles, dim, minX, minY, invSize, 2);
            // as a last resort, try splitting the remaining polygon into two
            } else if (pass === 2) $d5b33d7c30034067$var$splitEarcut(ear, triangles, dim, minX, minY, invSize);
            break;
        }
    }
}
// check whether a polygon node forms a valid ear with adjacent nodes
function $d5b33d7c30034067$var$isEar(ear) {
    const a = ear.prev, b = ear, c = ear.next;
    if ($d5b33d7c30034067$var$area(a, b, c) >= 0) return false; // reflex, can't be an ear
    // now make sure we don't have other points inside the potential ear
    const ax = a.x, bx = b.x, cx = c.x, ay = a.y, by = b.y, cy = c.y;
    // triangle bbox; min & max are calculated like this for speed
    const x0 = ax < bx ? ax < cx ? ax : cx : bx < cx ? bx : cx, y0 = ay < by ? ay < cy ? ay : cy : by < cy ? by : cy, x1 = ax > bx ? ax > cx ? ax : cx : bx > cx ? bx : cx, y1 = ay > by ? ay > cy ? ay : cy : by > cy ? by : cy;
    let p = c.next;
    while(p !== a){
        if (p.x >= x0 && p.x <= x1 && p.y >= y0 && p.y <= y1 && $d5b33d7c30034067$var$pointInTriangle(ax, ay, bx, by, cx, cy, p.x, p.y) && $d5b33d7c30034067$var$area(p.prev, p, p.next) >= 0) return false;
        p = p.next;
    }
    return true;
}
function $d5b33d7c30034067$var$isEarHashed(ear, minX, minY, invSize) {
    const a = ear.prev, b = ear, c = ear.next;
    if ($d5b33d7c30034067$var$area(a, b, c) >= 0) return false; // reflex, can't be an ear
    const ax = a.x, bx = b.x, cx = c.x, ay = a.y, by = b.y, cy = c.y;
    // triangle bbox; min & max are calculated like this for speed
    const x0 = ax < bx ? ax < cx ? ax : cx : bx < cx ? bx : cx, y0 = ay < by ? ay < cy ? ay : cy : by < cy ? by : cy, x1 = ax > bx ? ax > cx ? ax : cx : bx > cx ? bx : cx, y1 = ay > by ? ay > cy ? ay : cy : by > cy ? by : cy;
    // z-order range for the current triangle bbox;
    const minZ = $d5b33d7c30034067$var$zOrder(x0, y0, minX, minY, invSize), maxZ = $d5b33d7c30034067$var$zOrder(x1, y1, minX, minY, invSize);
    let p = ear.prevZ, n = ear.nextZ;
    // look for points inside the triangle in both directions
    while(p && p.z >= minZ && n && n.z <= maxZ){
        if (p.x >= x0 && p.x <= x1 && p.y >= y0 && p.y <= y1 && p !== a && p !== c && $d5b33d7c30034067$var$pointInTriangle(ax, ay, bx, by, cx, cy, p.x, p.y) && $d5b33d7c30034067$var$area(p.prev, p, p.next) >= 0) return false;
        p = p.prevZ;
        if (n.x >= x0 && n.x <= x1 && n.y >= y0 && n.y <= y1 && n !== a && n !== c && $d5b33d7c30034067$var$pointInTriangle(ax, ay, bx, by, cx, cy, n.x, n.y) && $d5b33d7c30034067$var$area(n.prev, n, n.next) >= 0) return false;
        n = n.nextZ;
    }
    // look for remaining points in decreasing z-order
    while(p && p.z >= minZ){
        if (p.x >= x0 && p.x <= x1 && p.y >= y0 && p.y <= y1 && p !== a && p !== c && $d5b33d7c30034067$var$pointInTriangle(ax, ay, bx, by, cx, cy, p.x, p.y) && $d5b33d7c30034067$var$area(p.prev, p, p.next) >= 0) return false;
        p = p.prevZ;
    }
    // look for remaining points in increasing z-order
    while(n && n.z <= maxZ){
        if (n.x >= x0 && n.x <= x1 && n.y >= y0 && n.y <= y1 && n !== a && n !== c && $d5b33d7c30034067$var$pointInTriangle(ax, ay, bx, by, cx, cy, n.x, n.y) && $d5b33d7c30034067$var$area(n.prev, n, n.next) >= 0) return false;
        n = n.nextZ;
    }
    return true;
}
// go through all polygon nodes and cure small local self-intersections
function $d5b33d7c30034067$var$cureLocalIntersections(start, triangles, dim) {
    let p = start;
    do {
        const a = p.prev, b = p.next.next;
        if (!$d5b33d7c30034067$var$equals(a, b) && $d5b33d7c30034067$var$intersects(a, p, p.next, b) && $d5b33d7c30034067$var$locallyInside(a, b) && $d5b33d7c30034067$var$locallyInside(b, a)) {
            triangles.push(a.i / dim | 0);
            triangles.push(p.i / dim | 0);
            triangles.push(b.i / dim | 0);
            // remove two nodes involved
            $d5b33d7c30034067$var$removeNode(p);
            $d5b33d7c30034067$var$removeNode(p.next);
            p = start = b;
        }
        p = p.next;
    }while (p !== start);
    return $d5b33d7c30034067$var$filterPoints(p);
}
// try splitting polygon into two and triangulate them independently
function $d5b33d7c30034067$var$splitEarcut(start, triangles, dim, minX, minY, invSize) {
    // look for a valid diagonal that divides the polygon into two
    let a = start;
    do {
        let b = a.next.next;
        while(b !== a.prev){
            if (a.i !== b.i && $d5b33d7c30034067$var$isValidDiagonal(a, b)) {
                // split the polygon in two by the diagonal
                let c = $d5b33d7c30034067$var$splitPolygon(a, b);
                // filter colinear points around the cuts
                a = $d5b33d7c30034067$var$filterPoints(a, a.next);
                c = $d5b33d7c30034067$var$filterPoints(c, c.next);
                // run earcut on each half
                $d5b33d7c30034067$var$earcutLinked(a, triangles, dim, minX, minY, invSize, 0);
                $d5b33d7c30034067$var$earcutLinked(c, triangles, dim, minX, minY, invSize, 0);
                return;
            }
            b = b.next;
        }
        a = a.next;
    }while (a !== start);
}
// link every hole into the outer loop, producing a single-ring polygon without holes
function $d5b33d7c30034067$var$eliminateHoles(data, holeIndices, outerNode, dim) {
    const queue = [];
    let i, len, start, end, list;
    for(i = 0, len = holeIndices.length; i < len; i++){
        start = holeIndices[i] * dim;
        end = i < len - 1 ? holeIndices[i + 1] * dim : data.length;
        list = $d5b33d7c30034067$var$linkedList(data, start, end, dim, false);
        if (list === list.next) list.steiner = true;
        queue.push($d5b33d7c30034067$var$getLeftmost(list));
    }
    queue.sort($d5b33d7c30034067$var$compareX);
    // process holes from left to right
    for(i = 0; i < queue.length; i++)outerNode = $d5b33d7c30034067$var$eliminateHole(queue[i], outerNode);
    return outerNode;
}
function $d5b33d7c30034067$var$compareX(a, b) {
    return a.x - b.x;
}
// find a bridge between vertices that connects hole with an outer ring and link it
function $d5b33d7c30034067$var$eliminateHole(hole, outerNode) {
    const bridge = $d5b33d7c30034067$var$findHoleBridge(hole, outerNode);
    if (!bridge) return outerNode;
    const bridgeReverse = $d5b33d7c30034067$var$splitPolygon(bridge, hole);
    // filter collinear points around the cuts
    $d5b33d7c30034067$var$filterPoints(bridgeReverse, bridgeReverse.next);
    return $d5b33d7c30034067$var$filterPoints(bridge, bridge.next);
}
// David Eberly's algorithm for finding a bridge between hole and outer polygon
function $d5b33d7c30034067$var$findHoleBridge(hole, outerNode) {
    let p = outerNode, qx = -Infinity, m;
    const hx = hole.x, hy = hole.y;
    // find a segment intersected by a ray from the hole's leftmost point to the left;
    // segment's endpoint with lesser x will be potential connection point
    do {
        if (hy <= p.y && hy >= p.next.y && p.next.y !== p.y) {
            const x = p.x + (hy - p.y) * (p.next.x - p.x) / (p.next.y - p.y);
            if (x <= hx && x > qx) {
                qx = x;
                m = p.x < p.next.x ? p : p.next;
                if (x === hx) return m; // hole touches outer segment; pick leftmost endpoint
            }
        }
        p = p.next;
    }while (p !== outerNode);
    if (!m) return null;
    // look for points inside the triangle of hole point, segment intersection and endpoint;
    // if there are no points found, we have a valid connection;
    // otherwise choose the point of the minimum angle with the ray as connection point
    const stop = m, mx = m.x, my = m.y;
    let tanMin = Infinity, tan;
    p = m;
    do {
        if (hx >= p.x && p.x >= mx && hx !== p.x && $d5b33d7c30034067$var$pointInTriangle(hy < my ? hx : qx, hy, mx, my, hy < my ? qx : hx, hy, p.x, p.y)) {
            tan = Math.abs(hy - p.y) / (hx - p.x); // tangential
            if ($d5b33d7c30034067$var$locallyInside(p, hole) && (tan < tanMin || tan === tanMin && (p.x > m.x || p.x === m.x && $d5b33d7c30034067$var$sectorContainsSector(m, p)))) {
                m = p;
                tanMin = tan;
            }
        }
        p = p.next;
    }while (p !== stop);
    return m;
}
// whether sector in vertex m contains sector in vertex p in the same coordinates
function $d5b33d7c30034067$var$sectorContainsSector(m, p) {
    return $d5b33d7c30034067$var$area(m.prev, m, p.prev) < 0 && $d5b33d7c30034067$var$area(p.next, m, m.next) < 0;
}
// interlink polygon nodes in z-order
function $d5b33d7c30034067$var$indexCurve(start, minX, minY, invSize) {
    let p = start;
    do {
        if (p.z === 0) p.z = $d5b33d7c30034067$var$zOrder(p.x, p.y, minX, minY, invSize);
        p.prevZ = p.prev;
        p.nextZ = p.next;
        p = p.next;
    }while (p !== start);
    p.prevZ.nextZ = null;
    p.prevZ = null;
    $d5b33d7c30034067$var$sortLinked(p);
}
// Simon Tatham's linked list merge sort algorithm
// http://www.chiark.greenend.org.uk/~sgtatham/algorithms/listsort.html
function $d5b33d7c30034067$var$sortLinked(list) {
    let i, p, q, e, tail, numMerges, pSize, qSize, inSize = 1;
    do {
        p = list;
        list = null;
        tail = null;
        numMerges = 0;
        while(p){
            numMerges++;
            q = p;
            pSize = 0;
            for(i = 0; i < inSize; i++){
                pSize++;
                q = q.nextZ;
                if (!q) break;
            }
            qSize = inSize;
            while(pSize > 0 || qSize > 0 && q){
                if (pSize !== 0 && (qSize === 0 || !q || p.z <= q.z)) {
                    e = p;
                    p = p.nextZ;
                    pSize--;
                } else {
                    e = q;
                    q = q.nextZ;
                    qSize--;
                }
                if (tail) tail.nextZ = e;
                else list = e;
                e.prevZ = tail;
                tail = e;
            }
            p = q;
        }
        tail.nextZ = null;
        inSize *= 2;
    }while (numMerges > 1);
    return list;
}
// z-order of a point given coords and inverse of the longer side of data bbox
function $d5b33d7c30034067$var$zOrder(x, y, minX, minY, invSize) {
    // coords are transformed into non-negative 15-bit integer range
    x = (x - minX) * invSize | 0;
    y = (y - minY) * invSize | 0;
    x = (x | x << 8) & 0x00FF00FF;
    x = (x | x << 4) & 0x0F0F0F0F;
    x = (x | x << 2) & 0x33333333;
    x = (x | x << 1) & 0x55555555;
    y = (y | y << 8) & 0x00FF00FF;
    y = (y | y << 4) & 0x0F0F0F0F;
    y = (y | y << 2) & 0x33333333;
    y = (y | y << 1) & 0x55555555;
    return x | y << 1;
}
// find the leftmost node of a polygon ring
function $d5b33d7c30034067$var$getLeftmost(start) {
    let p = start, leftmost = start;
    do {
        if (p.x < leftmost.x || p.x === leftmost.x && p.y < leftmost.y) leftmost = p;
        p = p.next;
    }while (p !== start);
    return leftmost;
}
// check if a point lies within a convex triangle
function $d5b33d7c30034067$var$pointInTriangle(ax, ay, bx, by, cx, cy, px, py) {
    return (cx - px) * (ay - py) >= (ax - px) * (cy - py) && (ax - px) * (by - py) >= (bx - px) * (ay - py) && (bx - px) * (cy - py) >= (cx - px) * (by - py);
}
// check if a diagonal between two polygon nodes is valid (lies in polygon interior)
function $d5b33d7c30034067$var$isValidDiagonal(a, b) {
    return a.next.i !== b.i && a.prev.i !== b.i && !$d5b33d7c30034067$var$intersectsPolygon(a, b) && // dones't intersect other edges
    ($d5b33d7c30034067$var$locallyInside(a, b) && $d5b33d7c30034067$var$locallyInside(b, a) && $d5b33d7c30034067$var$middleInside(a, b) && // locally visible
    ($d5b33d7c30034067$var$area(a.prev, a, b.prev) || $d5b33d7c30034067$var$area(a, b.prev, b)) || // does not create opposite-facing sectors
    $d5b33d7c30034067$var$equals(a, b) && $d5b33d7c30034067$var$area(a.prev, a, a.next) > 0 && $d5b33d7c30034067$var$area(b.prev, b, b.next) > 0); // special zero-length case
}
// signed area of a triangle
function $d5b33d7c30034067$var$area(p, q, r) {
    return (q.y - p.y) * (r.x - q.x) - (q.x - p.x) * (r.y - q.y);
}
// check if two points are equal
function $d5b33d7c30034067$var$equals(p1, p2) {
    return p1.x === p2.x && p1.y === p2.y;
}
// check if two segments intersect
function $d5b33d7c30034067$var$intersects(p1, q1, p2, q2) {
    const o1 = $d5b33d7c30034067$var$sign($d5b33d7c30034067$var$area(p1, q1, p2));
    const o2 = $d5b33d7c30034067$var$sign($d5b33d7c30034067$var$area(p1, q1, q2));
    const o3 = $d5b33d7c30034067$var$sign($d5b33d7c30034067$var$area(p2, q2, p1));
    const o4 = $d5b33d7c30034067$var$sign($d5b33d7c30034067$var$area(p2, q2, q1));
    if (o1 !== o2 && o3 !== o4) return true; // general case
    if (o1 === 0 && $d5b33d7c30034067$var$onSegment(p1, p2, q1)) return true; // p1, q1 and p2 are collinear and p2 lies on p1q1
    if (o2 === 0 && $d5b33d7c30034067$var$onSegment(p1, q2, q1)) return true; // p1, q1 and q2 are collinear and q2 lies on p1q1
    if (o3 === 0 && $d5b33d7c30034067$var$onSegment(p2, p1, q2)) return true; // p2, q2 and p1 are collinear and p1 lies on p2q2
    if (o4 === 0 && $d5b33d7c30034067$var$onSegment(p2, q1, q2)) return true; // p2, q2 and q1 are collinear and q1 lies on p2q2
    return false;
}
// for collinear points p, q, r, check if point q lies on segment pr
function $d5b33d7c30034067$var$onSegment(p, q, r) {
    return q.x <= Math.max(p.x, r.x) && q.x >= Math.min(p.x, r.x) && q.y <= Math.max(p.y, r.y) && q.y >= Math.min(p.y, r.y);
}
function $d5b33d7c30034067$var$sign(num) {
    return num > 0 ? 1 : num < 0 ? -1 : 0;
}
// check if a polygon diagonal intersects any polygon segments
function $d5b33d7c30034067$var$intersectsPolygon(a, b) {
    let p = a;
    do {
        if (p.i !== a.i && p.next.i !== a.i && p.i !== b.i && p.next.i !== b.i && $d5b33d7c30034067$var$intersects(p, p.next, a, b)) return true;
        p = p.next;
    }while (p !== a);
    return false;
}
// check if a polygon diagonal is locally inside the polygon
function $d5b33d7c30034067$var$locallyInside(a, b) {
    return $d5b33d7c30034067$var$area(a.prev, a, a.next) < 0 ? $d5b33d7c30034067$var$area(a, b, a.next) >= 0 && $d5b33d7c30034067$var$area(a, a.prev, b) >= 0 : $d5b33d7c30034067$var$area(a, b, a.prev) < 0 || $d5b33d7c30034067$var$area(a, a.next, b) < 0;
}
// check if the middle point of a polygon diagonal is inside the polygon
function $d5b33d7c30034067$var$middleInside(a, b) {
    let p = a, inside = false;
    const px = (a.x + b.x) / 2, py = (a.y + b.y) / 2;
    do {
        if (p.y > py !== p.next.y > py && p.next.y !== p.y && px < (p.next.x - p.x) * (py - p.y) / (p.next.y - p.y) + p.x) inside = !inside;
        p = p.next;
    }while (p !== a);
    return inside;
}
// link two polygon vertices with a bridge; if the vertices belong to the same ring, it splits polygon into two;
// if one belongs to the outer ring and another to a hole, it merges it into a single ring
function $d5b33d7c30034067$var$splitPolygon(a, b) {
    const a2 = new $d5b33d7c30034067$var$Node(a.i, a.x, a.y), b2 = new $d5b33d7c30034067$var$Node(b.i, b.x, b.y), an = a.next, bp = b.prev;
    a.next = b;
    b.prev = a;
    a2.next = an;
    an.prev = a2;
    b2.next = a2;
    a2.prev = b2;
    bp.next = b2;
    b2.prev = bp;
    return b2;
}
// create a node and optionally link it with previous one (in a circular doubly linked list)
function $d5b33d7c30034067$var$insertNode(i, x, y, last) {
    const p = new $d5b33d7c30034067$var$Node(i, x, y);
    if (!last) {
        p.prev = p;
        p.next = p;
    } else {
        p.next = last.next;
        p.prev = last;
        last.next.prev = p;
        last.next = p;
    }
    return p;
}
function $d5b33d7c30034067$var$removeNode(p) {
    p.next.prev = p.prev;
    p.prev.next = p.next;
    if (p.prevZ) p.prevZ.nextZ = p.nextZ;
    if (p.nextZ) p.nextZ.prevZ = p.prevZ;
}
function $d5b33d7c30034067$var$Node(i, x, y) {
    // vertex index in coordinates array
    this.i = i;
    // vertex coordinates
    this.x = x;
    this.y = y;
    // previous and next vertex nodes in a polygon ring
    this.prev = null;
    this.next = null;
    // z-order curve value
    this.z = 0;
    // previous and next nodes in z-order
    this.prevZ = null;
    this.nextZ = null;
    // indicates whether this is a steiner point
    this.steiner = false;
}
function $d5b33d7c30034067$var$signedArea(data, start, end, dim) {
    let sum = 0;
    for(let i = start, j = end - dim; i < end; i += dim){
        sum += (data[j] - data[i]) * (data[i + 1] + data[j + 1]);
        j = i;
    }
    return sum;
}
class $d5b33d7c30034067$export$96bdf6d9c66d7ba8 {
    // calculate area of the contour polygon
    static area(contour) {
        const n = contour.length;
        let a = 0.0;
        for(let p = n - 1, q = 0; q < n; p = q++)a += contour[p].x * contour[q].y - contour[q].x * contour[p].y;
        return a * 0.5;
    }
    static isClockWise(pts) {
        return $d5b33d7c30034067$export$96bdf6d9c66d7ba8.area(pts) < 0;
    }
    static triangulateShape(contour, holes) {
        const vertices = []; // flat array of vertices like [ x0,y0, x1,y1, x2,y2, ... ]
        const holeIndices = []; // array of hole indices
        const faces = []; // final array of vertex indices like [ [ a,b,d ], [ b,c,d ] ]
        $d5b33d7c30034067$var$removeDupEndPts(contour);
        $d5b33d7c30034067$var$addContour(vertices, contour);
        //
        let holeIndex = contour.length;
        holes.forEach($d5b33d7c30034067$var$removeDupEndPts);
        for(let i = 0; i < holes.length; i++){
            holeIndices.push(holeIndex);
            holeIndex += holes[i].length;
            $d5b33d7c30034067$var$addContour(vertices, holes[i]);
        }
        //
        const triangles = $d5b33d7c30034067$var$Earcut.triangulate(vertices, holeIndices);
        //
        for(let i = 0; i < triangles.length; i += 3)faces.push(triangles.slice(i, i + 3));
        return faces;
    }
}
function $d5b33d7c30034067$var$removeDupEndPts(points) {
    const l = points.length;
    if (l > 2 && points[l - 1].equals(points[0])) points.pop();
}
function $d5b33d7c30034067$var$addContour(vertices, contour) {
    for(let i = 0; i < contour.length; i++){
        vertices.push(contour[i].x);
        vertices.push(contour[i].y);
    }
}
/**
 * Creates extruded geometry from a path shape.
 *
 * parameters = {
 *
 *  curveSegments: <int>, // number of points on the curves
 *  steps: <int>, // number of points for z-side extrusions / used for subdividing segments of extrude spline too
 *  depth: <float>, // Depth to extrude the shape
 *
 *  bevelEnabled: <bool>, // turn on bevel
 *  bevelThickness: <float>, // how deep into the original shape bevel goes
 *  bevelSize: <float>, // how far from shape outline (including bevelOffset) is bevel
 *  bevelOffset: <float>, // how far from shape outline does bevel start
 *  bevelSegments: <int>, // number of bevel layers
 *
 *  extrudePath: <THREE.Curve> // curve to extrude shape along
 *
 *  UVGenerator: <Object> // object that provides UV generator functions
 *
 * }
 */ class $d5b33d7c30034067$export$598697a1efa63ca7 extends $d5b33d7c30034067$export$b7be63a67df8959 {
    constructor(shapes = new $d5b33d7c30034067$export$6428a7f2611ef1fa([
        new $d5b33d7c30034067$export$c977b3e384af9ae1(0.5, 0.5),
        new $d5b33d7c30034067$export$c977b3e384af9ae1(-0.5, 0.5),
        new $d5b33d7c30034067$export$c977b3e384af9ae1(-0.5, -0.5),
        new $d5b33d7c30034067$export$c977b3e384af9ae1(0.5, -0.5)
    ]), options = {}){
        super();
        this.type = 'ExtrudeGeometry';
        this.parameters = {
            shapes: shapes,
            options: options
        };
        shapes = Array.isArray(shapes) ? shapes : [
            shapes
        ];
        const scope = this;
        const verticesArray = [];
        const uvArray = [];
        for(let i = 0, l = shapes.length; i < l; i++){
            const shape = shapes[i];
            addShape(shape);
        }
        // build geometry
        this.setAttribute('position', new $d5b33d7c30034067$export$cbe7a62641830ebd(verticesArray, 3));
        this.setAttribute('uv', new $d5b33d7c30034067$export$cbe7a62641830ebd(uvArray, 2));
        this.computeVertexNormals();
        // functions
        function addShape(shape) {
            const placeholder = [];
            // options
            const curveSegments = options.curveSegments !== undefined ? options.curveSegments : 12;
            const steps = options.steps !== undefined ? options.steps : 1;
            const depth = options.depth !== undefined ? options.depth : 1;
            let bevelEnabled = options.bevelEnabled !== undefined ? options.bevelEnabled : true;
            let bevelThickness = options.bevelThickness !== undefined ? options.bevelThickness : 0.2;
            let bevelSize = options.bevelSize !== undefined ? options.bevelSize : bevelThickness - 0.1;
            let bevelOffset = options.bevelOffset !== undefined ? options.bevelOffset : 0;
            let bevelSegments = options.bevelSegments !== undefined ? options.bevelSegments : 3;
            const extrudePath = options.extrudePath;
            const uvgen = options.UVGenerator !== undefined ? options.UVGenerator : $d5b33d7c30034067$var$WorldUVGenerator;
            //
            let extrudePts, extrudeByPath = false;
            let splineTube, binormal, normal, position2;
            if (extrudePath) {
                extrudePts = extrudePath.getSpacedPoints(steps);
                extrudeByPath = true;
                bevelEnabled = false; // bevels not supported for path extrusion
                // SETUP TNB variables
                // TODO1 - have a .isClosed in spline?
                splineTube = extrudePath.computeFrenetFrames(steps, false);
                // console.log(splineTube, 'splineTube', splineTube.normals.length, 'steps', steps, 'extrudePts', extrudePts.length);
                binormal = new $d5b33d7c30034067$export$64b5c384219d3699();
                normal = new $d5b33d7c30034067$export$64b5c384219d3699();
                position2 = new $d5b33d7c30034067$export$64b5c384219d3699();
            }
            // Safeguards if bevels are not enabled
            if (!bevelEnabled) {
                bevelSegments = 0;
                bevelThickness = 0;
                bevelSize = 0;
                bevelOffset = 0;
            }
            // Variables initialization
            const shapePoints = shape.extractPoints(curveSegments);
            let vertices = shapePoints.shape;
            const holes = shapePoints.holes;
            const reverse = !$d5b33d7c30034067$export$96bdf6d9c66d7ba8.isClockWise(vertices);
            if (reverse) {
                vertices = vertices.reverse();
                // Maybe we should also check if holes are in the opposite direction, just to be safe ...
                for(let h = 0, hl = holes.length; h < hl; h++){
                    const ahole = holes[h];
                    if ($d5b33d7c30034067$export$96bdf6d9c66d7ba8.isClockWise(ahole)) holes[h] = ahole.reverse();
                }
            }
            const faces = $d5b33d7c30034067$export$96bdf6d9c66d7ba8.triangulateShape(vertices, holes);
            /* Vertices */ const contour = vertices; // vertices has all points but contour has only points of circumference
            for(let h = 0, hl = holes.length; h < hl; h++){
                const ahole = holes[h];
                vertices = vertices.concat(ahole);
            }
            function scalePt2(pt, vec, size) {
                if (!vec) console.error('THREE.ExtrudeGeometry: vec does not exist');
                return pt.clone().addScaledVector(vec, size);
            }
            const vlen = vertices.length, flen = faces.length;
            // Find directions for point movement
            function getBevelVec(inPt, inPrev, inNext) {
                // computes for inPt the corresponding point inPt' on a new contour
                //   shifted by 1 unit (length of normalized vector) to the left
                // if we walk along contour clockwise, this new contour is outside the old one
                //
                // inPt' is the intersection of the two lines parallel to the two
                //  adjacent edges of inPt at a distance of 1 unit on the left side.
                let v_trans_x, v_trans_y, shrink_by; // resulting translation vector for inPt
                // good reading for geometry algorithms (here: line-line intersection)
                // http://geomalgorithms.com/a05-_intersect-1.html
                const v_prev_x = inPt.x - inPrev.x, v_prev_y = inPt.y - inPrev.y;
                const v_next_x = inNext.x - inPt.x, v_next_y = inNext.y - inPt.y;
                const v_prev_lensq = v_prev_x * v_prev_x + v_prev_y * v_prev_y;
                // check for collinear edges
                const collinear0 = v_prev_x * v_next_y - v_prev_y * v_next_x;
                if (Math.abs(collinear0) > Number.EPSILON) {
                    // not collinear
                    // length of vectors for normalizing
                    const v_prev_len = Math.sqrt(v_prev_lensq);
                    const v_next_len = Math.sqrt(v_next_x * v_next_x + v_next_y * v_next_y);
                    // shift adjacent points by unit vectors to the left
                    const ptPrevShift_x = inPrev.x - v_prev_y / v_prev_len;
                    const ptPrevShift_y = inPrev.y + v_prev_x / v_prev_len;
                    const ptNextShift_x = inNext.x - v_next_y / v_next_len;
                    const ptNextShift_y = inNext.y + v_next_x / v_next_len;
                    // scaling factor for v_prev to intersection point
                    const sf = ((ptNextShift_x - ptPrevShift_x) * v_next_y - (ptNextShift_y - ptPrevShift_y) * v_next_x) / (v_prev_x * v_next_y - v_prev_y * v_next_x);
                    // vector from inPt to intersection point
                    v_trans_x = ptPrevShift_x + v_prev_x * sf - inPt.x;
                    v_trans_y = ptPrevShift_y + v_prev_y * sf - inPt.y;
                    // Don't normalize!, otherwise sharp corners become ugly
                    //  but prevent crazy spikes
                    const v_trans_lensq = v_trans_x * v_trans_x + v_trans_y * v_trans_y;
                    if (v_trans_lensq <= 2) return new $d5b33d7c30034067$export$c977b3e384af9ae1(v_trans_x, v_trans_y);
                    else shrink_by = Math.sqrt(v_trans_lensq / 2);
                } else {
                    // handle special case of collinear edges
                    let direction_eq = false; // assumes: opposite
                    if (v_prev_x > Number.EPSILON) {
                        if (v_next_x > Number.EPSILON) direction_eq = true;
                    } else {
                        if (v_prev_x < -Number.EPSILON) {
                            if (v_next_x < -Number.EPSILON) direction_eq = true;
                        } else if (Math.sign(v_prev_y) === Math.sign(v_next_y)) direction_eq = true;
                    }
                    if (direction_eq) {
                        // console.log("Warning: lines are a straight sequence");
                        v_trans_x = -v_prev_y;
                        v_trans_y = v_prev_x;
                        shrink_by = Math.sqrt(v_prev_lensq);
                    } else {
                        // console.log("Warning: lines are a straight spike");
                        v_trans_x = v_prev_x;
                        v_trans_y = v_prev_y;
                        shrink_by = Math.sqrt(v_prev_lensq / 2);
                    }
                }
                return new $d5b33d7c30034067$export$c977b3e384af9ae1(v_trans_x / shrink_by, v_trans_y / shrink_by);
            }
            const contourMovements = [];
            for(let i = 0, il = contour.length, j = il - 1, k = i + 1; i < il; i++, j++, k++){
                if (j === il) j = 0;
                if (k === il) k = 0;
                //  (j)---(i)---(k)
                // console.log('i,j,k', i, j , k)
                contourMovements[i] = getBevelVec(contour[i], contour[j], contour[k]);
            }
            const holesMovements = [];
            let oneHoleMovements, verticesMovements = contourMovements.concat();
            for(let h = 0, hl = holes.length; h < hl; h++){
                const ahole = holes[h];
                oneHoleMovements = [];
                for(let i = 0, il = ahole.length, j = il - 1, k = i + 1; i < il; i++, j++, k++){
                    if (j === il) j = 0;
                    if (k === il) k = 0;
                    //  (j)---(i)---(k)
                    oneHoleMovements[i] = getBevelVec(ahole[i], ahole[j], ahole[k]);
                }
                holesMovements.push(oneHoleMovements);
                verticesMovements = verticesMovements.concat(oneHoleMovements);
            }
            // Loop bevelSegments, 1 for the front, 1 for the back
            for(let b = 0; b < bevelSegments; b++){
                //for ( b = bevelSegments; b > 0; b -- ) {
                const t = b / bevelSegments;
                const z = bevelThickness * Math.cos(t * Math.PI / 2);
                const bs = bevelSize * Math.sin(t * Math.PI / 2) + bevelOffset;
                // contract shape
                for(let i = 0, il = contour.length; i < il; i++){
                    const vert = scalePt2(contour[i], contourMovements[i], bs);
                    v(vert.x, vert.y, -z);
                }
                // expand holes
                for(let h = 0, hl = holes.length; h < hl; h++){
                    const ahole = holes[h];
                    oneHoleMovements = holesMovements[h];
                    for(let i = 0, il = ahole.length; i < il; i++){
                        const vert = scalePt2(ahole[i], oneHoleMovements[i], bs);
                        v(vert.x, vert.y, -z);
                    }
                }
            }
            const bs = bevelSize + bevelOffset;
            // Back facing vertices
            for(let i = 0; i < vlen; i++){
                const vert = bevelEnabled ? scalePt2(vertices[i], verticesMovements[i], bs) : vertices[i];
                if (!extrudeByPath) v(vert.x, vert.y, 0);
                else {
                    // v( vert.x, vert.y + extrudePts[ 0 ].y, extrudePts[ 0 ].x );
                    normal.copy(splineTube.normals[0]).multiplyScalar(vert.x);
                    binormal.copy(splineTube.binormals[0]).multiplyScalar(vert.y);
                    position2.copy(extrudePts[0]).add(normal).add(binormal);
                    v(position2.x, position2.y, position2.z);
                }
            }
            // Add stepped vertices...
            // Including front facing vertices
            for(let s = 1; s <= steps; s++)for(let i = 0; i < vlen; i++){
                const vert = bevelEnabled ? scalePt2(vertices[i], verticesMovements[i], bs) : vertices[i];
                if (!extrudeByPath) v(vert.x, vert.y, depth / steps * s);
                else {
                    // v( vert.x, vert.y + extrudePts[ s - 1 ].y, extrudePts[ s - 1 ].x );
                    normal.copy(splineTube.normals[s]).multiplyScalar(vert.x);
                    binormal.copy(splineTube.binormals[s]).multiplyScalar(vert.y);
                    position2.copy(extrudePts[s]).add(normal).add(binormal);
                    v(position2.x, position2.y, position2.z);
                }
            }
            // Add bevel segments planes
            //for ( b = 1; b <= bevelSegments; b ++ ) {
            for(let b = bevelSegments - 1; b >= 0; b--){
                const t = b / bevelSegments;
                const z = bevelThickness * Math.cos(t * Math.PI / 2);
                const bs = bevelSize * Math.sin(t * Math.PI / 2) + bevelOffset;
                // contract shape
                for(let i = 0, il = contour.length; i < il; i++){
                    const vert = scalePt2(contour[i], contourMovements[i], bs);
                    v(vert.x, vert.y, depth + z);
                }
                // expand holes
                for(let h = 0, hl = holes.length; h < hl; h++){
                    const ahole = holes[h];
                    oneHoleMovements = holesMovements[h];
                    for(let i = 0, il = ahole.length; i < il; i++){
                        const vert = scalePt2(ahole[i], oneHoleMovements[i], bs);
                        if (!extrudeByPath) v(vert.x, vert.y, depth + z);
                        else v(vert.x, vert.y + extrudePts[steps - 1].y, extrudePts[steps - 1].x + z);
                    }
                }
            }
            /* Faces */ // Top and bottom faces
            buildLidFaces();
            // Sides faces
            buildSideFaces();
            /////  Internal functions
            function buildLidFaces() {
                const start = verticesArray.length / 3;
                if (bevelEnabled) {
                    let layer = 0; // steps + 1
                    let offset = vlen * layer;
                    // Bottom faces
                    for(let i = 0; i < flen; i++){
                        const face = faces[i];
                        f3(face[2] + offset, face[1] + offset, face[0] + offset);
                    }
                    layer = steps + bevelSegments * 2;
                    offset = vlen * layer;
                    // Top faces
                    for(let i = 0; i < flen; i++){
                        const face = faces[i];
                        f3(face[0] + offset, face[1] + offset, face[2] + offset);
                    }
                } else {
                    // Bottom faces
                    for(let i = 0; i < flen; i++){
                        const face = faces[i];
                        f3(face[2], face[1], face[0]);
                    }
                    // Top faces
                    for(let i = 0; i < flen; i++){
                        const face = faces[i];
                        f3(face[0] + vlen * steps, face[1] + vlen * steps, face[2] + vlen * steps);
                    }
                }
                scope.addGroup(start, verticesArray.length / 3 - start, 0);
            }
            // Create faces for the z-sides of the shape
            function buildSideFaces() {
                const start = verticesArray.length / 3;
                let layeroffset = 0;
                sidewalls(contour, layeroffset);
                layeroffset += contour.length;
                for(let h = 0, hl = holes.length; h < hl; h++){
                    const ahole = holes[h];
                    sidewalls(ahole, layeroffset);
                    //, true
                    layeroffset += ahole.length;
                }
                scope.addGroup(start, verticesArray.length / 3 - start, 1);
            }
            function sidewalls(contour, layeroffset) {
                let i = contour.length;
                while(--i >= 0){
                    const j = i;
                    let k = i - 1;
                    if (k < 0) k = contour.length - 1;
                    //console.log('b', i,j, i-1, k,vertices.length);
                    for(let s = 0, sl = steps + bevelSegments * 2; s < sl; s++){
                        const slen1 = vlen * s;
                        const slen2 = vlen * (s + 1);
                        const a = layeroffset + j + slen1, b = layeroffset + k + slen1, c = layeroffset + k + slen2, d = layeroffset + j + slen2;
                        f4(a, b, c, d);
                    }
                }
            }
            function v(x, y, z) {
                placeholder.push(x);
                placeholder.push(y);
                placeholder.push(z);
            }
            function f3(a, b, c) {
                addVertex(a);
                addVertex(b);
                addVertex(c);
                const nextIndex = verticesArray.length / 3;
                const uvs = uvgen.generateTopUV(scope, verticesArray, nextIndex - 3, nextIndex - 2, nextIndex - 1);
                addUV(uvs[0]);
                addUV(uvs[1]);
                addUV(uvs[2]);
            }
            function f4(a, b, c, d) {
                addVertex(a);
                addVertex(b);
                addVertex(d);
                addVertex(b);
                addVertex(c);
                addVertex(d);
                const nextIndex = verticesArray.length / 3;
                const uvs = uvgen.generateSideWallUV(scope, verticesArray, nextIndex - 6, nextIndex - 3, nextIndex - 2, nextIndex - 1);
                addUV(uvs[0]);
                addUV(uvs[1]);
                addUV(uvs[3]);
                addUV(uvs[1]);
                addUV(uvs[2]);
                addUV(uvs[3]);
            }
            function addVertex(index) {
                verticesArray.push(placeholder[index * 3 + 0]);
                verticesArray.push(placeholder[index * 3 + 1]);
                verticesArray.push(placeholder[index * 3 + 2]);
            }
            function addUV(vector2) {
                uvArray.push(vector2.x);
                uvArray.push(vector2.y);
            }
        }
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        const shapes = this.parameters.shapes;
        const options = this.parameters.options;
        return $d5b33d7c30034067$var$toJSON$1(shapes, options, data);
    }
    static fromJSON(data, shapes) {
        const geometryShapes = [];
        for(let j = 0, jl = data.shapes.length; j < jl; j++){
            const shape = shapes[data.shapes[j]];
            geometryShapes.push(shape);
        }
        const extrudePath = data.options.extrudePath;
        if (extrudePath !== undefined) data.options.extrudePath = new $d5b33d7c30034067$var$Curves[extrudePath.type]().fromJSON(extrudePath);
        return new $d5b33d7c30034067$export$598697a1efa63ca7(geometryShapes, data.options);
    }
}
const $d5b33d7c30034067$var$WorldUVGenerator = {
    generateTopUV: function(geometry, vertices, indexA, indexB, indexC) {
        const a_x = vertices[indexA * 3];
        const a_y = vertices[indexA * 3 + 1];
        const b_x = vertices[indexB * 3];
        const b_y = vertices[indexB * 3 + 1];
        const c_x = vertices[indexC * 3];
        const c_y = vertices[indexC * 3 + 1];
        return [
            new $d5b33d7c30034067$export$c977b3e384af9ae1(a_x, a_y),
            new $d5b33d7c30034067$export$c977b3e384af9ae1(b_x, b_y),
            new $d5b33d7c30034067$export$c977b3e384af9ae1(c_x, c_y)
        ];
    },
    generateSideWallUV: function(geometry, vertices, indexA, indexB, indexC, indexD) {
        const a_x = vertices[indexA * 3];
        const a_y = vertices[indexA * 3 + 1];
        const a_z = vertices[indexA * 3 + 2];
        const b_x = vertices[indexB * 3];
        const b_y = vertices[indexB * 3 + 1];
        const b_z = vertices[indexB * 3 + 2];
        const c_x = vertices[indexC * 3];
        const c_y = vertices[indexC * 3 + 1];
        const c_z = vertices[indexC * 3 + 2];
        const d_x = vertices[indexD * 3];
        const d_y = vertices[indexD * 3 + 1];
        const d_z = vertices[indexD * 3 + 2];
        if (Math.abs(a_y - b_y) < Math.abs(a_x - b_x)) return [
            new $d5b33d7c30034067$export$c977b3e384af9ae1(a_x, 1 - a_z),
            new $d5b33d7c30034067$export$c977b3e384af9ae1(b_x, 1 - b_z),
            new $d5b33d7c30034067$export$c977b3e384af9ae1(c_x, 1 - c_z),
            new $d5b33d7c30034067$export$c977b3e384af9ae1(d_x, 1 - d_z)
        ];
        else return [
            new $d5b33d7c30034067$export$c977b3e384af9ae1(a_y, 1 - a_z),
            new $d5b33d7c30034067$export$c977b3e384af9ae1(b_y, 1 - b_z),
            new $d5b33d7c30034067$export$c977b3e384af9ae1(c_y, 1 - c_z),
            new $d5b33d7c30034067$export$c977b3e384af9ae1(d_y, 1 - d_z)
        ];
    }
};
function $d5b33d7c30034067$var$toJSON$1(shapes, options, data) {
    data.shapes = [];
    if (Array.isArray(shapes)) for(let i = 0, l = shapes.length; i < l; i++){
        const shape = shapes[i];
        data.shapes.push(shape.uuid);
    }
    else data.shapes.push(shapes.uuid);
    data.options = Object.assign({}, options);
    if (options.extrudePath !== undefined) data.options.extrudePath = options.extrudePath.toJSON();
    return data;
}
class $d5b33d7c30034067$export$9567cc828c9535da extends $d5b33d7c30034067$export$60e57a7d3f20ff65 {
    constructor(radius = 1, detail = 0){
        const t = (1 + Math.sqrt(5)) / 2;
        const vertices = [
            -1,
            t,
            0,
            1,
            t,
            0,
            -1,
            -t,
            0,
            1,
            -t,
            0,
            0,
            -1,
            t,
            0,
            1,
            t,
            0,
            -1,
            -t,
            0,
            1,
            -t,
            t,
            0,
            -1,
            t,
            0,
            1,
            -t,
            0,
            -1,
            -t,
            0,
            1
        ];
        const indices = [
            0,
            11,
            5,
            0,
            5,
            1,
            0,
            1,
            7,
            0,
            7,
            10,
            0,
            10,
            11,
            1,
            5,
            9,
            5,
            11,
            4,
            11,
            10,
            2,
            10,
            7,
            6,
            7,
            1,
            8,
            3,
            9,
            4,
            3,
            4,
            2,
            3,
            2,
            6,
            3,
            6,
            8,
            3,
            8,
            9,
            4,
            9,
            5,
            2,
            4,
            11,
            6,
            2,
            10,
            8,
            6,
            7,
            9,
            8,
            1
        ];
        super(vertices, indices, radius, detail);
        this.type = 'IcosahedronGeometry';
        this.parameters = {
            radius: radius,
            detail: detail
        };
    }
    static fromJSON(data) {
        return new $d5b33d7c30034067$export$9567cc828c9535da(data.radius, data.detail);
    }
}
class $d5b33d7c30034067$export$1954e2b809fe361e extends $d5b33d7c30034067$export$60e57a7d3f20ff65 {
    constructor(radius = 1, detail = 0){
        const vertices = [
            1,
            0,
            0,
            -1,
            0,
            0,
            0,
            1,
            0,
            0,
            -1,
            0,
            0,
            0,
            1,
            0,
            0,
            -1
        ];
        const indices = [
            0,
            2,
            4,
            0,
            4,
            3,
            0,
            3,
            5,
            0,
            5,
            2,
            1,
            2,
            5,
            1,
            5,
            3,
            1,
            3,
            4,
            1,
            4,
            2
        ];
        super(vertices, indices, radius, detail);
        this.type = 'OctahedronGeometry';
        this.parameters = {
            radius: radius,
            detail: detail
        };
    }
    static fromJSON(data) {
        return new $d5b33d7c30034067$export$1954e2b809fe361e(data.radius, data.detail);
    }
}
class $d5b33d7c30034067$export$68cb731f50f614af extends $d5b33d7c30034067$export$b7be63a67df8959 {
    constructor(innerRadius = 0.5, outerRadius = 1, thetaSegments = 32, phiSegments = 1, thetaStart = 0, thetaLength = Math.PI * 2){
        super();
        this.type = 'RingGeometry';
        this.parameters = {
            innerRadius: innerRadius,
            outerRadius: outerRadius,
            thetaSegments: thetaSegments,
            phiSegments: phiSegments,
            thetaStart: thetaStart,
            thetaLength: thetaLength
        };
        thetaSegments = Math.max(3, thetaSegments);
        phiSegments = Math.max(1, phiSegments);
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // some helper variables
        let radius = innerRadius;
        const radiusStep = (outerRadius - innerRadius) / phiSegments;
        const vertex = new $d5b33d7c30034067$export$64b5c384219d3699();
        const uv = new $d5b33d7c30034067$export$c977b3e384af9ae1();
        // generate vertices, normals and uvs
        for(let j = 0; j <= phiSegments; j++){
            for(let i = 0; i <= thetaSegments; i++){
                // values are generate from the inside of the ring to the outside
                const segment = thetaStart + i / thetaSegments * thetaLength;
                // vertex
                vertex.x = radius * Math.cos(segment);
                vertex.y = radius * Math.sin(segment);
                vertices.push(vertex.x, vertex.y, vertex.z);
                // normal
                normals.push(0, 0, 1);
                // uv
                uv.x = (vertex.x / outerRadius + 1) / 2;
                uv.y = (vertex.y / outerRadius + 1) / 2;
                uvs.push(uv.x, uv.y);
            }
            // increase the radius for next row of vertices
            radius += radiusStep;
        }
        // indices
        for(let j = 0; j < phiSegments; j++){
            const thetaSegmentLevel = j * (thetaSegments + 1);
            for(let i = 0; i < thetaSegments; i++){
                const segment = i + thetaSegmentLevel;
                const a = segment;
                const b = segment + thetaSegments + 1;
                const c = segment + thetaSegments + 2;
                const d = segment + 1;
                // faces
                indices.push(a, b, d);
                indices.push(b, c, d);
            }
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new $d5b33d7c30034067$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute('normal', new $d5b33d7c30034067$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute('uv', new $d5b33d7c30034067$export$cbe7a62641830ebd(uvs, 2));
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    static fromJSON(data) {
        return new $d5b33d7c30034067$export$68cb731f50f614af(data.innerRadius, data.outerRadius, data.thetaSegments, data.phiSegments, data.thetaStart, data.thetaLength);
    }
}
class $d5b33d7c30034067$export$57a29a1c803e9065 extends $d5b33d7c30034067$export$b7be63a67df8959 {
    constructor(shapes = new $d5b33d7c30034067$export$6428a7f2611ef1fa([
        new $d5b33d7c30034067$export$c977b3e384af9ae1(0, 0.5),
        new $d5b33d7c30034067$export$c977b3e384af9ae1(-0.5, -0.5),
        new $d5b33d7c30034067$export$c977b3e384af9ae1(0.5, -0.5)
    ]), curveSegments = 12){
        super();
        this.type = 'ShapeGeometry';
        this.parameters = {
            shapes: shapes,
            curveSegments: curveSegments
        };
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // helper variables
        let groupStart = 0;
        let groupCount = 0;
        // allow single and array values for "shapes" parameter
        if (Array.isArray(shapes) === false) addShape(shapes);
        else for(let i = 0; i < shapes.length; i++){
            addShape(shapes[i]);
            this.addGroup(groupStart, groupCount, i); // enables MultiMaterial support
            groupStart += groupCount;
            groupCount = 0;
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new $d5b33d7c30034067$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute('normal', new $d5b33d7c30034067$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute('uv', new $d5b33d7c30034067$export$cbe7a62641830ebd(uvs, 2));
        // helper functions
        function addShape(shape) {
            const indexOffset = vertices.length / 3;
            const points = shape.extractPoints(curveSegments);
            let shapeVertices = points.shape;
            const shapeHoles = points.holes;
            // check direction of vertices
            if ($d5b33d7c30034067$export$96bdf6d9c66d7ba8.isClockWise(shapeVertices) === false) shapeVertices = shapeVertices.reverse();
            for(let i = 0, l = shapeHoles.length; i < l; i++){
                const shapeHole = shapeHoles[i];
                if ($d5b33d7c30034067$export$96bdf6d9c66d7ba8.isClockWise(shapeHole) === true) shapeHoles[i] = shapeHole.reverse();
            }
            const faces = $d5b33d7c30034067$export$96bdf6d9c66d7ba8.triangulateShape(shapeVertices, shapeHoles);
            // join vertices of inner and outer paths to a single array
            for(let i = 0, l = shapeHoles.length; i < l; i++){
                const shapeHole = shapeHoles[i];
                shapeVertices = shapeVertices.concat(shapeHole);
            }
            // vertices, normals, uvs
            for(let i = 0, l = shapeVertices.length; i < l; i++){
                const vertex = shapeVertices[i];
                vertices.push(vertex.x, vertex.y, 0);
                normals.push(0, 0, 1);
                uvs.push(vertex.x, vertex.y); // world uvs
            }
            // indices
            for(let i = 0, l = faces.length; i < l; i++){
                const face = faces[i];
                const a = face[0] + indexOffset;
                const b = face[1] + indexOffset;
                const c = face[2] + indexOffset;
                indices.push(a, b, c);
                groupCount += 3;
            }
        }
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        const shapes = this.parameters.shapes;
        return $d5b33d7c30034067$var$toJSON(shapes, data);
    }
    static fromJSON(data, shapes) {
        const geometryShapes = [];
        for(let j = 0, jl = data.shapes.length; j < jl; j++){
            const shape = shapes[data.shapes[j]];
            geometryShapes.push(shape);
        }
        return new $d5b33d7c30034067$export$57a29a1c803e9065(geometryShapes, data.curveSegments);
    }
}
function $d5b33d7c30034067$var$toJSON(shapes, data) {
    data.shapes = [];
    if (Array.isArray(shapes)) for(let i = 0, l = shapes.length; i < l; i++){
        const shape = shapes[i];
        data.shapes.push(shape.uuid);
    }
    else data.shapes.push(shapes.uuid);
    return data;
}
class $d5b33d7c30034067$export$1b417fc3b307a251 extends $d5b33d7c30034067$export$b7be63a67df8959 {
    constructor(radius = 1, widthSegments = 32, heightSegments = 16, phiStart = 0, phiLength = Math.PI * 2, thetaStart = 0, thetaLength = Math.PI){
        super();
        this.type = 'SphereGeometry';
        this.parameters = {
            radius: radius,
            widthSegments: widthSegments,
            heightSegments: heightSegments,
            phiStart: phiStart,
            phiLength: phiLength,
            thetaStart: thetaStart,
            thetaLength: thetaLength
        };
        widthSegments = Math.max(3, Math.floor(widthSegments));
        heightSegments = Math.max(2, Math.floor(heightSegments));
        const thetaEnd = Math.min(thetaStart + thetaLength, Math.PI);
        let index = 0;
        const grid = [];
        const vertex = new $d5b33d7c30034067$export$64b5c384219d3699();
        const normal = new $d5b33d7c30034067$export$64b5c384219d3699();
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // generate vertices, normals and uvs
        for(let iy = 0; iy <= heightSegments; iy++){
            const verticesRow = [];
            const v = iy / heightSegments;
            // special case for the poles
            let uOffset = 0;
            if (iy === 0 && thetaStart === 0) uOffset = 0.5 / widthSegments;
            else if (iy === heightSegments && thetaEnd === Math.PI) uOffset = -0.5 / widthSegments;
            for(let ix = 0; ix <= widthSegments; ix++){
                const u = ix / widthSegments;
                // vertex
                vertex.x = -radius * Math.cos(phiStart + u * phiLength) * Math.sin(thetaStart + v * thetaLength);
                vertex.y = radius * Math.cos(thetaStart + v * thetaLength);
                vertex.z = radius * Math.sin(phiStart + u * phiLength) * Math.sin(thetaStart + v * thetaLength);
                vertices.push(vertex.x, vertex.y, vertex.z);
                // normal
                normal.copy(vertex).normalize();
                normals.push(normal.x, normal.y, normal.z);
                // uv
                uvs.push(u + uOffset, 1 - v);
                verticesRow.push(index++);
            }
            grid.push(verticesRow);
        }
        // indices
        for(let iy = 0; iy < heightSegments; iy++)for(let ix = 0; ix < widthSegments; ix++){
            const a = grid[iy][ix + 1];
            const b = grid[iy][ix];
            const c = grid[iy + 1][ix];
            const d = grid[iy + 1][ix + 1];
            if (iy !== 0 || thetaStart > 0) indices.push(a, b, d);
            if (iy !== heightSegments - 1 || thetaEnd < Math.PI) indices.push(b, c, d);
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new $d5b33d7c30034067$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute('normal', new $d5b33d7c30034067$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute('uv', new $d5b33d7c30034067$export$cbe7a62641830ebd(uvs, 2));
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    static fromJSON(data) {
        return new $d5b33d7c30034067$export$1b417fc3b307a251(data.radius, data.widthSegments, data.heightSegments, data.phiStart, data.phiLength, data.thetaStart, data.thetaLength);
    }
}
class $d5b33d7c30034067$export$fb3f7adc68bd6e02 extends $d5b33d7c30034067$export$60e57a7d3f20ff65 {
    constructor(radius = 1, detail = 0){
        const vertices = [
            1,
            1,
            1,
            -1,
            -1,
            1,
            -1,
            1,
            -1,
            1,
            -1,
            -1
        ];
        const indices = [
            2,
            1,
            0,
            0,
            3,
            2,
            1,
            3,
            0,
            2,
            3,
            1
        ];
        super(vertices, indices, radius, detail);
        this.type = 'TetrahedronGeometry';
        this.parameters = {
            radius: radius,
            detail: detail
        };
    }
    static fromJSON(data) {
        return new $d5b33d7c30034067$export$fb3f7adc68bd6e02(data.radius, data.detail);
    }
}
class $d5b33d7c30034067$export$a2312a2a1fa56495 extends $d5b33d7c30034067$export$b7be63a67df8959 {
    constructor(radius = 1, tube = 0.4, radialSegments = 12, tubularSegments = 48, arc = Math.PI * 2){
        super();
        this.type = 'TorusGeometry';
        this.parameters = {
            radius: radius,
            tube: tube,
            radialSegments: radialSegments,
            tubularSegments: tubularSegments,
            arc: arc
        };
        radialSegments = Math.floor(radialSegments);
        tubularSegments = Math.floor(tubularSegments);
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // helper variables
        const center = new $d5b33d7c30034067$export$64b5c384219d3699();
        const vertex = new $d5b33d7c30034067$export$64b5c384219d3699();
        const normal = new $d5b33d7c30034067$export$64b5c384219d3699();
        // generate vertices, normals and uvs
        for(let j = 0; j <= radialSegments; j++)for(let i = 0; i <= tubularSegments; i++){
            const u = i / tubularSegments * arc;
            const v = j / radialSegments * Math.PI * 2;
            // vertex
            vertex.x = (radius + tube * Math.cos(v)) * Math.cos(u);
            vertex.y = (radius + tube * Math.cos(v)) * Math.sin(u);
            vertex.z = tube * Math.sin(v);
            vertices.push(vertex.x, vertex.y, vertex.z);
            // normal
            center.x = radius * Math.cos(u);
            center.y = radius * Math.sin(u);
            normal.subVectors(vertex, center).normalize();
            normals.push(normal.x, normal.y, normal.z);
            // uv
            uvs.push(i / tubularSegments);
            uvs.push(j / radialSegments);
        }
        // generate indices
        for(let j = 1; j <= radialSegments; j++)for(let i = 1; i <= tubularSegments; i++){
            // indices
            const a = (tubularSegments + 1) * j + i - 1;
            const b = (tubularSegments + 1) * (j - 1) + i - 1;
            const c = (tubularSegments + 1) * (j - 1) + i;
            const d = (tubularSegments + 1) * j + i;
            // faces
            indices.push(a, b, d);
            indices.push(b, c, d);
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new $d5b33d7c30034067$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute('normal', new $d5b33d7c30034067$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute('uv', new $d5b33d7c30034067$export$cbe7a62641830ebd(uvs, 2));
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    static fromJSON(data) {
        return new $d5b33d7c30034067$export$a2312a2a1fa56495(data.radius, data.tube, data.radialSegments, data.tubularSegments, data.arc);
    }
}
class $d5b33d7c30034067$export$77e9bfadfb9ab8c8 extends $d5b33d7c30034067$export$b7be63a67df8959 {
    constructor(radius = 1, tube = 0.4, tubularSegments = 64, radialSegments = 8, p = 2, q = 3){
        super();
        this.type = 'TorusKnotGeometry';
        this.parameters = {
            radius: radius,
            tube: tube,
            tubularSegments: tubularSegments,
            radialSegments: radialSegments,
            p: p,
            q: q
        };
        tubularSegments = Math.floor(tubularSegments);
        radialSegments = Math.floor(radialSegments);
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // helper variables
        const vertex = new $d5b33d7c30034067$export$64b5c384219d3699();
        const normal = new $d5b33d7c30034067$export$64b5c384219d3699();
        const P1 = new $d5b33d7c30034067$export$64b5c384219d3699();
        const P2 = new $d5b33d7c30034067$export$64b5c384219d3699();
        const B = new $d5b33d7c30034067$export$64b5c384219d3699();
        const T = new $d5b33d7c30034067$export$64b5c384219d3699();
        const N = new $d5b33d7c30034067$export$64b5c384219d3699();
        // generate vertices, normals and uvs
        for(let i = 0; i <= tubularSegments; ++i){
            // the radian "u" is used to calculate the position on the torus curve of the current tubular segment
            const u = i / tubularSegments * p * Math.PI * 2;
            // now we calculate two points. P1 is our current position on the curve, P2 is a little farther ahead.
            // these points are used to create a special "coordinate space", which is necessary to calculate the correct vertex positions
            calculatePositionOnCurve(u, p, q, radius, P1);
            calculatePositionOnCurve(u + 0.01, p, q, radius, P2);
            // calculate orthonormal basis
            T.subVectors(P2, P1);
            N.addVectors(P2, P1);
            B.crossVectors(T, N);
            N.crossVectors(B, T);
            // normalize B, N. T can be ignored, we don't use it
            B.normalize();
            N.normalize();
            for(let j = 0; j <= radialSegments; ++j){
                // now calculate the vertices. they are nothing more than an extrusion of the torus curve.
                // because we extrude a shape in the xy-plane, there is no need to calculate a z-value.
                const v = j / radialSegments * Math.PI * 2;
                const cx = -tube * Math.cos(v);
                const cy = tube * Math.sin(v);
                // now calculate the final vertex position.
                // first we orient the extrusion with our basis vectors, then we add it to the current position on the curve
                vertex.x = P1.x + (cx * N.x + cy * B.x);
                vertex.y = P1.y + (cx * N.y + cy * B.y);
                vertex.z = P1.z + (cx * N.z + cy * B.z);
                vertices.push(vertex.x, vertex.y, vertex.z);
                // normal (P1 is always the center/origin of the extrusion, thus we can use it to calculate the normal)
                normal.subVectors(vertex, P1).normalize();
                normals.push(normal.x, normal.y, normal.z);
                // uv
                uvs.push(i / tubularSegments);
                uvs.push(j / radialSegments);
            }
        }
        // generate indices
        for(let j = 1; j <= tubularSegments; j++)for(let i = 1; i <= radialSegments; i++){
            // indices
            const a = (radialSegments + 1) * (j - 1) + (i - 1);
            const b = (radialSegments + 1) * j + (i - 1);
            const c = (radialSegments + 1) * j + i;
            const d = (radialSegments + 1) * (j - 1) + i;
            // faces
            indices.push(a, b, d);
            indices.push(b, c, d);
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new $d5b33d7c30034067$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute('normal', new $d5b33d7c30034067$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute('uv', new $d5b33d7c30034067$export$cbe7a62641830ebd(uvs, 2));
        // this function calculates the current position on the torus curve
        function calculatePositionOnCurve(u, p, q, radius, position) {
            const cu = Math.cos(u);
            const su = Math.sin(u);
            const quOverP = q / p * u;
            const cs = Math.cos(quOverP);
            position.x = radius * (2 + cs) * 0.5 * cu;
            position.y = radius * (2 + cs) * su * 0.5;
            position.z = radius * Math.sin(quOverP) * 0.5;
        }
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    static fromJSON(data) {
        return new $d5b33d7c30034067$export$77e9bfadfb9ab8c8(data.radius, data.tube, data.tubularSegments, data.radialSegments, data.p, data.q);
    }
}
class $d5b33d7c30034067$export$7897d9d48904490c extends $d5b33d7c30034067$export$b7be63a67df8959 {
    constructor(path = new $d5b33d7c30034067$export$bf3f4c7e459f90fc(new $d5b33d7c30034067$export$64b5c384219d3699(-1, -1, 0), new $d5b33d7c30034067$export$64b5c384219d3699(-1, 1, 0), new $d5b33d7c30034067$export$64b5c384219d3699(1, 1, 0)), tubularSegments = 64, radius = 1, radialSegments = 8, closed = false){
        super();
        this.type = 'TubeGeometry';
        this.parameters = {
            path: path,
            tubularSegments: tubularSegments,
            radius: radius,
            radialSegments: radialSegments,
            closed: closed
        };
        const frames = path.computeFrenetFrames(tubularSegments, closed);
        // expose internals
        this.tangents = frames.tangents;
        this.normals = frames.normals;
        this.binormals = frames.binormals;
        // helper variables
        const vertex = new $d5b33d7c30034067$export$64b5c384219d3699();
        const normal = new $d5b33d7c30034067$export$64b5c384219d3699();
        const uv = new $d5b33d7c30034067$export$c977b3e384af9ae1();
        let P = new $d5b33d7c30034067$export$64b5c384219d3699();
        // buffer
        const vertices = [];
        const normals = [];
        const uvs = [];
        const indices = [];
        // create buffer data
        generateBufferData();
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new $d5b33d7c30034067$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute('normal', new $d5b33d7c30034067$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute('uv', new $d5b33d7c30034067$export$cbe7a62641830ebd(uvs, 2));
        // functions
        function generateBufferData() {
            for(let i = 0; i < tubularSegments; i++)generateSegment(i);
            // if the geometry is not closed, generate the last row of vertices and normals
            // at the regular position on the given path
            //
            // if the geometry is closed, duplicate the first row of vertices and normals (uvs will differ)
            generateSegment(closed === false ? tubularSegments : 0);
            // uvs are generated in a separate function.
            // this makes it easy compute correct values for closed geometries
            generateUVs();
            // finally create faces
            generateIndices();
        }
        function generateSegment(i) {
            // we use getPointAt to sample evenly distributed points from the given path
            P = path.getPointAt(i / tubularSegments, P);
            // retrieve corresponding normal and binormal
            const N = frames.normals[i];
            const B = frames.binormals[i];
            // generate normals and vertices for the current segment
            for(let j = 0; j <= radialSegments; j++){
                const v = j / radialSegments * Math.PI * 2;
                const sin = Math.sin(v);
                const cos = -Math.cos(v);
                // normal
                normal.x = cos * N.x + sin * B.x;
                normal.y = cos * N.y + sin * B.y;
                normal.z = cos * N.z + sin * B.z;
                normal.normalize();
                normals.push(normal.x, normal.y, normal.z);
                // vertex
                vertex.x = P.x + radius * normal.x;
                vertex.y = P.y + radius * normal.y;
                vertex.z = P.z + radius * normal.z;
                vertices.push(vertex.x, vertex.y, vertex.z);
            }
        }
        function generateIndices() {
            for(let j = 1; j <= tubularSegments; j++)for(let i = 1; i <= radialSegments; i++){
                const a = (radialSegments + 1) * (j - 1) + (i - 1);
                const b = (radialSegments + 1) * j + (i - 1);
                const c = (radialSegments + 1) * j + i;
                const d = (radialSegments + 1) * (j - 1) + i;
                // faces
                indices.push(a, b, d);
                indices.push(b, c, d);
            }
        }
        function generateUVs() {
            for(let i = 0; i <= tubularSegments; i++)for(let j = 0; j <= radialSegments; j++){
                uv.x = i / tubularSegments;
                uv.y = j / radialSegments;
                uvs.push(uv.x, uv.y);
            }
        }
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.path = this.parameters.path.toJSON();
        return data;
    }
    static fromJSON(data) {
        // This only works for built-in curves (e.g. CatmullRomCurve3).
        // User defined curves or instances of CurvePath will not be deserialized.
        return new $d5b33d7c30034067$export$7897d9d48904490c(new $d5b33d7c30034067$var$Curves[data.path.type]().fromJSON(data.path), data.tubularSegments, data.radius, data.radialSegments, data.closed);
    }
}
class $d5b33d7c30034067$export$4b739da06d24892b extends $d5b33d7c30034067$export$b7be63a67df8959 {
    constructor(geometry = null){
        super();
        this.type = 'WireframeGeometry';
        this.parameters = {
            geometry: geometry
        };
        if (geometry !== null) {
            // buffer
            const vertices = [];
            const edges = new Set();
            // helper variables
            const start = new $d5b33d7c30034067$export$64b5c384219d3699();
            const end = new $d5b33d7c30034067$export$64b5c384219d3699();
            if (geometry.index !== null) {
                // indexed BufferGeometry
                const position = geometry.attributes.position;
                const indices = geometry.index;
                let groups = geometry.groups;
                if (groups.length === 0) groups = [
                    {
                        start: 0,
                        count: indices.count,
                        materialIndex: 0
                    }
                ];
                // create a data structure that contains all edges without duplicates
                for(let o = 0, ol = groups.length; o < ol; ++o){
                    const group = groups[o];
                    const groupStart = group.start;
                    const groupCount = group.count;
                    for(let i = groupStart, l = groupStart + groupCount; i < l; i += 3)for(let j = 0; j < 3; j++){
                        const index1 = indices.getX(i + j);
                        const index2 = indices.getX(i + (j + 1) % 3);
                        start.fromBufferAttribute(position, index1);
                        end.fromBufferAttribute(position, index2);
                        if ($d5b33d7c30034067$var$isUniqueEdge(start, end, edges) === true) {
                            vertices.push(start.x, start.y, start.z);
                            vertices.push(end.x, end.y, end.z);
                        }
                    }
                }
            } else {
                // non-indexed BufferGeometry
                const position = geometry.attributes.position;
                for(let i = 0, l = position.count / 3; i < l; i++)for(let j = 0; j < 3; j++){
                    // three edges per triangle, an edge is represented as (index1, index2)
                    // e.g. the first triangle has the following edges: (0,1),(1,2),(2,0)
                    const index1 = 3 * i + j;
                    const index2 = 3 * i + (j + 1) % 3;
                    start.fromBufferAttribute(position, index1);
                    end.fromBufferAttribute(position, index2);
                    if ($d5b33d7c30034067$var$isUniqueEdge(start, end, edges) === true) {
                        vertices.push(start.x, start.y, start.z);
                        vertices.push(end.x, end.y, end.z);
                    }
                }
            }
            // build geometry
            this.setAttribute('position', new $d5b33d7c30034067$export$cbe7a62641830ebd(vertices, 3));
        }
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
}
function $d5b33d7c30034067$var$isUniqueEdge(start, end, edges) {
    const hash1 = `${start.x},${start.y},${start.z}-${end.x},${end.y},${end.z}`;
    const hash2 = `${end.x},${end.y},${end.z}-${start.x},${start.y},${start.z}`; // coincident edge
    if (edges.has(hash1) === true || edges.has(hash2) === true) return false;
    else {
        edges.add(hash1);
        edges.add(hash2);
        return true;
    }
}
var $d5b33d7c30034067$var$Geometries = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    BoxGeometry: $d5b33d7c30034067$export$33e43285f7406bd5,
    CapsuleGeometry: $d5b33d7c30034067$export$41680e8551036033,
    CircleGeometry: $d5b33d7c30034067$export$d5c0e8d607467193,
    ConeGeometry: $d5b33d7c30034067$export$a7a48974f285c9b3,
    CylinderGeometry: $d5b33d7c30034067$export$68f745719dbe5198,
    DodecahedronGeometry: $d5b33d7c30034067$export$c0babfeb8708fc9c,
    EdgesGeometry: $d5b33d7c30034067$export$4730b1542707547f,
    ExtrudeGeometry: $d5b33d7c30034067$export$598697a1efa63ca7,
    IcosahedronGeometry: $d5b33d7c30034067$export$9567cc828c9535da,
    LatheGeometry: $d5b33d7c30034067$export$6d839803fcd1882c,
    OctahedronGeometry: $d5b33d7c30034067$export$1954e2b809fe361e,
    PlaneGeometry: $d5b33d7c30034067$export$967d831af31f69ce,
    PolyhedronGeometry: $d5b33d7c30034067$export$60e57a7d3f20ff65,
    RingGeometry: $d5b33d7c30034067$export$68cb731f50f614af,
    ShapeGeometry: $d5b33d7c30034067$export$57a29a1c803e9065,
    SphereGeometry: $d5b33d7c30034067$export$1b417fc3b307a251,
    TetrahedronGeometry: $d5b33d7c30034067$export$fb3f7adc68bd6e02,
    TorusGeometry: $d5b33d7c30034067$export$a2312a2a1fa56495,
    TorusKnotGeometry: $d5b33d7c30034067$export$77e9bfadfb9ab8c8,
    TubeGeometry: $d5b33d7c30034067$export$7897d9d48904490c,
    WireframeGeometry: $d5b33d7c30034067$export$4b739da06d24892b
});
class $d5b33d7c30034067$export$e8564da406055a3 extends $d5b33d7c30034067$export$a2d8b23205c25948 {
    static get type() {
        return 'ShadowMaterial';
    }
    constructor(parameters){
        super();
        this.isShadowMaterial = true;
        this.color = new $d5b33d7c30034067$export$892596cec99bc70e(0x000000);
        this.transparent = true;
        this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.fog = source.fog;
        return this;
    }
}
class $d5b33d7c30034067$export$21c421a2e1df9d22 extends $d5b33d7c30034067$export$83c7d75d550a8b0d {
    static get type() {
        return 'RawShaderMaterial';
    }
    constructor(parameters){
        super(parameters);
        this.isRawShaderMaterial = true;
    }
}
class $d5b33d7c30034067$export$f2980790215acccd extends $d5b33d7c30034067$export$a2d8b23205c25948 {
    static get type() {
        return 'MeshStandardMaterial';
    }
    constructor(parameters){
        super();
        this.isMeshStandardMaterial = true;
        this.defines = {
            'STANDARD': ''
        };
        this.color = new $d5b33d7c30034067$export$892596cec99bc70e(0xffffff); // diffuse
        this.roughness = 1.0;
        this.metalness = 0.0;
        this.map = null;
        this.lightMap = null;
        this.lightMapIntensity = 1.0;
        this.aoMap = null;
        this.aoMapIntensity = 1.0;
        this.emissive = new $d5b33d7c30034067$export$892596cec99bc70e(0x000000);
        this.emissiveIntensity = 1.0;
        this.emissiveMap = null;
        this.bumpMap = null;
        this.bumpScale = 1;
        this.normalMap = null;
        this.normalMapType = $d5b33d7c30034067$export$2852a58ebdac27b8;
        this.normalScale = new $d5b33d7c30034067$export$c977b3e384af9ae1(1, 1);
        this.displacementMap = null;
        this.displacementScale = 1;
        this.displacementBias = 0;
        this.roughnessMap = null;
        this.metalnessMap = null;
        this.alphaMap = null;
        this.envMap = null;
        this.envMapRotation = new $d5b33d7c30034067$export$d93cc409a0768c5f();
        this.envMapIntensity = 1.0;
        this.wireframe = false;
        this.wireframeLinewidth = 1;
        this.wireframeLinecap = 'round';
        this.wireframeLinejoin = 'round';
        this.flatShading = false;
        this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.defines = {
            'STANDARD': ''
        };
        this.color.copy(source.color);
        this.roughness = source.roughness;
        this.metalness = source.metalness;
        this.map = source.map;
        this.lightMap = source.lightMap;
        this.lightMapIntensity = source.lightMapIntensity;
        this.aoMap = source.aoMap;
        this.aoMapIntensity = source.aoMapIntensity;
        this.emissive.copy(source.emissive);
        this.emissiveMap = source.emissiveMap;
        this.emissiveIntensity = source.emissiveIntensity;
        this.bumpMap = source.bumpMap;
        this.bumpScale = source.bumpScale;
        this.normalMap = source.normalMap;
        this.normalMapType = source.normalMapType;
        this.normalScale.copy(source.normalScale);
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.roughnessMap = source.roughnessMap;
        this.metalnessMap = source.metalnessMap;
        this.alphaMap = source.alphaMap;
        this.envMap = source.envMap;
        this.envMapRotation.copy(source.envMapRotation);
        this.envMapIntensity = source.envMapIntensity;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.wireframeLinecap = source.wireframeLinecap;
        this.wireframeLinejoin = source.wireframeLinejoin;
        this.flatShading = source.flatShading;
        this.fog = source.fog;
        return this;
    }
}
class $d5b33d7c30034067$export$28d04986c4269c9f extends $d5b33d7c30034067$export$f2980790215acccd {
    static get type() {
        return 'MeshPhysicalMaterial';
    }
    constructor(parameters){
        super();
        this.isMeshPhysicalMaterial = true;
        this.defines = {
            'STANDARD': '',
            'PHYSICAL': ''
        };
        this.anisotropyRotation = 0;
        this.anisotropyMap = null;
        this.clearcoatMap = null;
        this.clearcoatRoughness = 0.0;
        this.clearcoatRoughnessMap = null;
        this.clearcoatNormalScale = new $d5b33d7c30034067$export$c977b3e384af9ae1(1, 1);
        this.clearcoatNormalMap = null;
        this.ior = 1.5;
        Object.defineProperty(this, 'reflectivity', {
            get: function() {
                return $d5b33d7c30034067$var$clamp(2.5 * (this.ior - 1) / (this.ior + 1), 0, 1);
            },
            set: function(reflectivity) {
                this.ior = (1 + 0.4 * reflectivity) / (1 - 0.4 * reflectivity);
            }
        });
        this.iridescenceMap = null;
        this.iridescenceIOR = 1.3;
        this.iridescenceThicknessRange = [
            100,
            400
        ];
        this.iridescenceThicknessMap = null;
        this.sheenColor = new $d5b33d7c30034067$export$892596cec99bc70e(0x000000);
        this.sheenColorMap = null;
        this.sheenRoughness = 1.0;
        this.sheenRoughnessMap = null;
        this.transmissionMap = null;
        this.thickness = 0;
        this.thicknessMap = null;
        this.attenuationDistance = Infinity;
        this.attenuationColor = new $d5b33d7c30034067$export$892596cec99bc70e(1, 1, 1);
        this.specularIntensity = 1.0;
        this.specularIntensityMap = null;
        this.specularColor = new $d5b33d7c30034067$export$892596cec99bc70e(1, 1, 1);
        this.specularColorMap = null;
        this._anisotropy = 0;
        this._clearcoat = 0;
        this._dispersion = 0;
        this._iridescence = 0;
        this._sheen = 0.0;
        this._transmission = 0;
        this.setValues(parameters);
    }
    get anisotropy() {
        return this._anisotropy;
    }
    set anisotropy(value) {
        if (this._anisotropy > 0 !== value > 0) this.version++;
        this._anisotropy = value;
    }
    get clearcoat() {
        return this._clearcoat;
    }
    set clearcoat(value) {
        if (this._clearcoat > 0 !== value > 0) this.version++;
        this._clearcoat = value;
    }
    get iridescence() {
        return this._iridescence;
    }
    set iridescence(value) {
        if (this._iridescence > 0 !== value > 0) this.version++;
        this._iridescence = value;
    }
    get dispersion() {
        return this._dispersion;
    }
    set dispersion(value) {
        if (this._dispersion > 0 !== value > 0) this.version++;
        this._dispersion = value;
    }
    get sheen() {
        return this._sheen;
    }
    set sheen(value) {
        if (this._sheen > 0 !== value > 0) this.version++;
        this._sheen = value;
    }
    get transmission() {
        return this._transmission;
    }
    set transmission(value) {
        if (this._transmission > 0 !== value > 0) this.version++;
        this._transmission = value;
    }
    copy(source) {
        super.copy(source);
        this.defines = {
            'STANDARD': '',
            'PHYSICAL': ''
        };
        this.anisotropy = source.anisotropy;
        this.anisotropyRotation = source.anisotropyRotation;
        this.anisotropyMap = source.anisotropyMap;
        this.clearcoat = source.clearcoat;
        this.clearcoatMap = source.clearcoatMap;
        this.clearcoatRoughness = source.clearcoatRoughness;
        this.clearcoatRoughnessMap = source.clearcoatRoughnessMap;
        this.clearcoatNormalMap = source.clearcoatNormalMap;
        this.clearcoatNormalScale.copy(source.clearcoatNormalScale);
        this.dispersion = source.dispersion;
        this.ior = source.ior;
        this.iridescence = source.iridescence;
        this.iridescenceMap = source.iridescenceMap;
        this.iridescenceIOR = source.iridescenceIOR;
        this.iridescenceThicknessRange = [
            ...source.iridescenceThicknessRange
        ];
        this.iridescenceThicknessMap = source.iridescenceThicknessMap;
        this.sheen = source.sheen;
        this.sheenColor.copy(source.sheenColor);
        this.sheenColorMap = source.sheenColorMap;
        this.sheenRoughness = source.sheenRoughness;
        this.sheenRoughnessMap = source.sheenRoughnessMap;
        this.transmission = source.transmission;
        this.transmissionMap = source.transmissionMap;
        this.thickness = source.thickness;
        this.thicknessMap = source.thicknessMap;
        this.attenuationDistance = source.attenuationDistance;
        this.attenuationColor.copy(source.attenuationColor);
        this.specularIntensity = source.specularIntensity;
        this.specularIntensityMap = source.specularIntensityMap;
        this.specularColor.copy(source.specularColor);
        this.specularColorMap = source.specularColorMap;
        return this;
    }
}
class $d5b33d7c30034067$export$24c72f71cbaf0678 extends $d5b33d7c30034067$export$a2d8b23205c25948 {
    static get type() {
        return 'MeshPhongMaterial';
    }
    constructor(parameters){
        super();
        this.isMeshPhongMaterial = true;
        this.color = new $d5b33d7c30034067$export$892596cec99bc70e(0xffffff); // diffuse
        this.specular = new $d5b33d7c30034067$export$892596cec99bc70e(0x111111);
        this.shininess = 30;
        this.map = null;
        this.lightMap = null;
        this.lightMapIntensity = 1.0;
        this.aoMap = null;
        this.aoMapIntensity = 1.0;
        this.emissive = new $d5b33d7c30034067$export$892596cec99bc70e(0x000000);
        this.emissiveIntensity = 1.0;
        this.emissiveMap = null;
        this.bumpMap = null;
        this.bumpScale = 1;
        this.normalMap = null;
        this.normalMapType = $d5b33d7c30034067$export$2852a58ebdac27b8;
        this.normalScale = new $d5b33d7c30034067$export$c977b3e384af9ae1(1, 1);
        this.displacementMap = null;
        this.displacementScale = 1;
        this.displacementBias = 0;
        this.specularMap = null;
        this.alphaMap = null;
        this.envMap = null;
        this.envMapRotation = new $d5b33d7c30034067$export$d93cc409a0768c5f();
        this.combine = $d5b33d7c30034067$export$e50ac29801f1774d;
        this.reflectivity = 1;
        this.refractionRatio = 0.98;
        this.wireframe = false;
        this.wireframeLinewidth = 1;
        this.wireframeLinecap = 'round';
        this.wireframeLinejoin = 'round';
        this.flatShading = false;
        this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.specular.copy(source.specular);
        this.shininess = source.shininess;
        this.map = source.map;
        this.lightMap = source.lightMap;
        this.lightMapIntensity = source.lightMapIntensity;
        this.aoMap = source.aoMap;
        this.aoMapIntensity = source.aoMapIntensity;
        this.emissive.copy(source.emissive);
        this.emissiveMap = source.emissiveMap;
        this.emissiveIntensity = source.emissiveIntensity;
        this.bumpMap = source.bumpMap;
        this.bumpScale = source.bumpScale;
        this.normalMap = source.normalMap;
        this.normalMapType = source.normalMapType;
        this.normalScale.copy(source.normalScale);
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.specularMap = source.specularMap;
        this.alphaMap = source.alphaMap;
        this.envMap = source.envMap;
        this.envMapRotation.copy(source.envMapRotation);
        this.combine = source.combine;
        this.reflectivity = source.reflectivity;
        this.refractionRatio = source.refractionRatio;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.wireframeLinecap = source.wireframeLinecap;
        this.wireframeLinejoin = source.wireframeLinejoin;
        this.flatShading = source.flatShading;
        this.fog = source.fog;
        return this;
    }
}
class $d5b33d7c30034067$export$df893cf97e765622 extends $d5b33d7c30034067$export$a2d8b23205c25948 {
    static get type() {
        return 'MeshToonMaterial';
    }
    constructor(parameters){
        super();
        this.isMeshToonMaterial = true;
        this.defines = {
            'TOON': ''
        };
        this.color = new $d5b33d7c30034067$export$892596cec99bc70e(0xffffff);
        this.map = null;
        this.gradientMap = null;
        this.lightMap = null;
        this.lightMapIntensity = 1.0;
        this.aoMap = null;
        this.aoMapIntensity = 1.0;
        this.emissive = new $d5b33d7c30034067$export$892596cec99bc70e(0x000000);
        this.emissiveIntensity = 1.0;
        this.emissiveMap = null;
        this.bumpMap = null;
        this.bumpScale = 1;
        this.normalMap = null;
        this.normalMapType = $d5b33d7c30034067$export$2852a58ebdac27b8;
        this.normalScale = new $d5b33d7c30034067$export$c977b3e384af9ae1(1, 1);
        this.displacementMap = null;
        this.displacementScale = 1;
        this.displacementBias = 0;
        this.alphaMap = null;
        this.wireframe = false;
        this.wireframeLinewidth = 1;
        this.wireframeLinecap = 'round';
        this.wireframeLinejoin = 'round';
        this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.map = source.map;
        this.gradientMap = source.gradientMap;
        this.lightMap = source.lightMap;
        this.lightMapIntensity = source.lightMapIntensity;
        this.aoMap = source.aoMap;
        this.aoMapIntensity = source.aoMapIntensity;
        this.emissive.copy(source.emissive);
        this.emissiveMap = source.emissiveMap;
        this.emissiveIntensity = source.emissiveIntensity;
        this.bumpMap = source.bumpMap;
        this.bumpScale = source.bumpScale;
        this.normalMap = source.normalMap;
        this.normalMapType = source.normalMapType;
        this.normalScale.copy(source.normalScale);
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.alphaMap = source.alphaMap;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.wireframeLinecap = source.wireframeLinecap;
        this.wireframeLinejoin = source.wireframeLinejoin;
        this.fog = source.fog;
        return this;
    }
}
class $d5b33d7c30034067$export$bfe8c0a091f41ae7 extends $d5b33d7c30034067$export$a2d8b23205c25948 {
    static get type() {
        return 'MeshNormalMaterial';
    }
    constructor(parameters){
        super();
        this.isMeshNormalMaterial = true;
        this.bumpMap = null;
        this.bumpScale = 1;
        this.normalMap = null;
        this.normalMapType = $d5b33d7c30034067$export$2852a58ebdac27b8;
        this.normalScale = new $d5b33d7c30034067$export$c977b3e384af9ae1(1, 1);
        this.displacementMap = null;
        this.displacementScale = 1;
        this.displacementBias = 0;
        this.wireframe = false;
        this.wireframeLinewidth = 1;
        this.flatShading = false;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.bumpMap = source.bumpMap;
        this.bumpScale = source.bumpScale;
        this.normalMap = source.normalMap;
        this.normalMapType = source.normalMapType;
        this.normalScale.copy(source.normalScale);
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.flatShading = source.flatShading;
        return this;
    }
}
class $d5b33d7c30034067$export$5023a9a8114806b8 extends $d5b33d7c30034067$export$a2d8b23205c25948 {
    static get type() {
        return 'MeshLambertMaterial';
    }
    constructor(parameters){
        super();
        this.isMeshLambertMaterial = true;
        this.color = new $d5b33d7c30034067$export$892596cec99bc70e(0xffffff); // diffuse
        this.map = null;
        this.lightMap = null;
        this.lightMapIntensity = 1.0;
        this.aoMap = null;
        this.aoMapIntensity = 1.0;
        this.emissive = new $d5b33d7c30034067$export$892596cec99bc70e(0x000000);
        this.emissiveIntensity = 1.0;
        this.emissiveMap = null;
        this.bumpMap = null;
        this.bumpScale = 1;
        this.normalMap = null;
        this.normalMapType = $d5b33d7c30034067$export$2852a58ebdac27b8;
        this.normalScale = new $d5b33d7c30034067$export$c977b3e384af9ae1(1, 1);
        this.displacementMap = null;
        this.displacementScale = 1;
        this.displacementBias = 0;
        this.specularMap = null;
        this.alphaMap = null;
        this.envMap = null;
        this.envMapRotation = new $d5b33d7c30034067$export$d93cc409a0768c5f();
        this.combine = $d5b33d7c30034067$export$e50ac29801f1774d;
        this.reflectivity = 1;
        this.refractionRatio = 0.98;
        this.wireframe = false;
        this.wireframeLinewidth = 1;
        this.wireframeLinecap = 'round';
        this.wireframeLinejoin = 'round';
        this.flatShading = false;
        this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.map = source.map;
        this.lightMap = source.lightMap;
        this.lightMapIntensity = source.lightMapIntensity;
        this.aoMap = source.aoMap;
        this.aoMapIntensity = source.aoMapIntensity;
        this.emissive.copy(source.emissive);
        this.emissiveMap = source.emissiveMap;
        this.emissiveIntensity = source.emissiveIntensity;
        this.bumpMap = source.bumpMap;
        this.bumpScale = source.bumpScale;
        this.normalMap = source.normalMap;
        this.normalMapType = source.normalMapType;
        this.normalScale.copy(source.normalScale);
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.specularMap = source.specularMap;
        this.alphaMap = source.alphaMap;
        this.envMap = source.envMap;
        this.envMapRotation.copy(source.envMapRotation);
        this.combine = source.combine;
        this.reflectivity = source.reflectivity;
        this.refractionRatio = source.refractionRatio;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.wireframeLinecap = source.wireframeLinecap;
        this.wireframeLinejoin = source.wireframeLinejoin;
        this.flatShading = source.flatShading;
        this.fog = source.fog;
        return this;
    }
}
class $d5b33d7c30034067$export$6f5fef6235ec12ee extends $d5b33d7c30034067$export$a2d8b23205c25948 {
    static get type() {
        return 'MeshMatcapMaterial';
    }
    constructor(parameters){
        super();
        this.isMeshMatcapMaterial = true;
        this.defines = {
            'MATCAP': ''
        };
        this.color = new $d5b33d7c30034067$export$892596cec99bc70e(0xffffff); // diffuse
        this.matcap = null;
        this.map = null;
        this.bumpMap = null;
        this.bumpScale = 1;
        this.normalMap = null;
        this.normalMapType = $d5b33d7c30034067$export$2852a58ebdac27b8;
        this.normalScale = new $d5b33d7c30034067$export$c977b3e384af9ae1(1, 1);
        this.displacementMap = null;
        this.displacementScale = 1;
        this.displacementBias = 0;
        this.alphaMap = null;
        this.flatShading = false;
        this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.defines = {
            'MATCAP': ''
        };
        this.color.copy(source.color);
        this.matcap = source.matcap;
        this.map = source.map;
        this.bumpMap = source.bumpMap;
        this.bumpScale = source.bumpScale;
        this.normalMap = source.normalMap;
        this.normalMapType = source.normalMapType;
        this.normalScale.copy(source.normalScale);
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.alphaMap = source.alphaMap;
        this.flatShading = source.flatShading;
        this.fog = source.fog;
        return this;
    }
}
class $d5b33d7c30034067$export$327886a3efaeaebe extends $d5b33d7c30034067$export$fbaaa33907730a0c {
    static get type() {
        return 'LineDashedMaterial';
    }
    constructor(parameters){
        super();
        this.isLineDashedMaterial = true;
        this.scale = 1;
        this.dashSize = 3;
        this.gapSize = 1;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.scale = source.scale;
        this.dashSize = source.dashSize;
        this.gapSize = source.gapSize;
        return this;
    }
}
// converts an array to a specific type
function $d5b33d7c30034067$var$convertArray(array, type, forceClone) {
    if (!array || // let 'undefined' and 'null' pass
    !forceClone && array.constructor === type) return array;
    if (typeof type.BYTES_PER_ELEMENT === 'number') return new type(array); // create typed array
    return Array.prototype.slice.call(array); // create Array
}
function $d5b33d7c30034067$var$isTypedArray(object) {
    return ArrayBuffer.isView(object) && !(object instanceof DataView);
}
// returns an array by which times and values can be sorted
function $d5b33d7c30034067$var$getKeyframeOrder(times) {
    function compareTime(i, j) {
        return times[i] - times[j];
    }
    const n = times.length;
    const result = new Array(n);
    for(let i = 0; i !== n; ++i)result[i] = i;
    result.sort(compareTime);
    return result;
}
// uses the array previously returned by 'getKeyframeOrder' to sort data
function $d5b33d7c30034067$var$sortedArray(values, stride, order) {
    const nValues = values.length;
    const result = new values.constructor(nValues);
    for(let i = 0, dstOffset = 0; dstOffset !== nValues; ++i){
        const srcOffset = order[i] * stride;
        for(let j = 0; j !== stride; ++j)result[dstOffset++] = values[srcOffset + j];
    }
    return result;
}
// function for parsing AOS keyframe formats
function $d5b33d7c30034067$var$flattenJSON(jsonKeys, times, values, valuePropertyName) {
    let i = 1, key = jsonKeys[0];
    while(key !== undefined && key[valuePropertyName] === undefined)key = jsonKeys[i++];
    if (key === undefined) return; // no data
    let value = key[valuePropertyName];
    if (value === undefined) return; // no data
    if (Array.isArray(value)) do {
        value = key[valuePropertyName];
        if (value !== undefined) {
            times.push(key.time);
            values.push.apply(values, value); // push all elements
        }
        key = jsonKeys[i++];
    }while (key !== undefined);
    else if (value.toArray !== undefined) // ...assume THREE.Math-ish
    do {
        value = key[valuePropertyName];
        if (value !== undefined) {
            times.push(key.time);
            value.toArray(values, values.length);
        }
        key = jsonKeys[i++];
    }while (key !== undefined);
    else // otherwise push as-is
    do {
        value = key[valuePropertyName];
        if (value !== undefined) {
            times.push(key.time);
            values.push(value);
        }
        key = jsonKeys[i++];
    }while (key !== undefined);
}
function $d5b33d7c30034067$var$subclip(sourceClip, name, startFrame, endFrame, fps = 30) {
    const clip = sourceClip.clone();
    clip.name = name;
    const tracks = [];
    for(let i = 0; i < clip.tracks.length; ++i){
        const track = clip.tracks[i];
        const valueSize = track.getValueSize();
        const times = [];
        const values = [];
        for(let j = 0; j < track.times.length; ++j){
            const frame = track.times[j] * fps;
            if (frame < startFrame || frame >= endFrame) continue;
            times.push(track.times[j]);
            for(let k = 0; k < valueSize; ++k)values.push(track.values[j * valueSize + k]);
        }
        if (times.length === 0) continue;
        track.times = $d5b33d7c30034067$var$convertArray(times, track.times.constructor);
        track.values = $d5b33d7c30034067$var$convertArray(values, track.values.constructor);
        tracks.push(track);
    }
    clip.tracks = tracks;
    // find minimum .times value across all tracks in the trimmed clip
    let minStartTime = Infinity;
    for(let i = 0; i < clip.tracks.length; ++i)if (minStartTime > clip.tracks[i].times[0]) minStartTime = clip.tracks[i].times[0];
    // shift all tracks such that clip begins at t=0
    for(let i = 0; i < clip.tracks.length; ++i)clip.tracks[i].shift(-1 * minStartTime);
    clip.resetDuration();
    return clip;
}
function $d5b33d7c30034067$var$makeClipAdditive(targetClip, referenceFrame = 0, referenceClip = targetClip, fps = 30) {
    if (fps <= 0) fps = 30;
    const numTracks = referenceClip.tracks.length;
    const referenceTime = referenceFrame / fps;
    // Make each track's values relative to the values at the reference frame
    for(let i = 0; i < numTracks; ++i){
        const referenceTrack = referenceClip.tracks[i];
        const referenceTrackType = referenceTrack.ValueTypeName;
        // Skip this track if it's non-numeric
        if (referenceTrackType === 'bool' || referenceTrackType === 'string') continue;
        // Find the track in the target clip whose name and type matches the reference track
        const targetTrack = targetClip.tracks.find(function(track) {
            return track.name === referenceTrack.name && track.ValueTypeName === referenceTrackType;
        });
        if (targetTrack === undefined) continue;
        let referenceOffset = 0;
        const referenceValueSize = referenceTrack.getValueSize();
        if (referenceTrack.createInterpolant.isInterpolantFactoryMethodGLTFCubicSpline) referenceOffset = referenceValueSize / 3;
        let targetOffset = 0;
        const targetValueSize = targetTrack.getValueSize();
        if (targetTrack.createInterpolant.isInterpolantFactoryMethodGLTFCubicSpline) targetOffset = targetValueSize / 3;
        const lastIndex = referenceTrack.times.length - 1;
        let referenceValue;
        // Find the value to subtract out of the track
        if (referenceTime <= referenceTrack.times[0]) {
            // Reference frame is earlier than the first keyframe, so just use the first keyframe
            const startIndex = referenceOffset;
            const endIndex = referenceValueSize - referenceOffset;
            referenceValue = referenceTrack.values.slice(startIndex, endIndex);
        } else if (referenceTime >= referenceTrack.times[lastIndex]) {
            // Reference frame is after the last keyframe, so just use the last keyframe
            const startIndex = lastIndex * referenceValueSize + referenceOffset;
            const endIndex = startIndex + referenceValueSize - referenceOffset;
            referenceValue = referenceTrack.values.slice(startIndex, endIndex);
        } else {
            // Interpolate to the reference value
            const interpolant = referenceTrack.createInterpolant();
            const startIndex = referenceOffset;
            const endIndex = referenceValueSize - referenceOffset;
            interpolant.evaluate(referenceTime);
            referenceValue = interpolant.resultBuffer.slice(startIndex, endIndex);
        }
        // Conjugate the quaternion
        if (referenceTrackType === 'quaternion') {
            const referenceQuat = new $d5b33d7c30034067$export$23d6a54f0bbc85a3().fromArray(referenceValue).normalize().conjugate();
            referenceQuat.toArray(referenceValue);
        }
        // Subtract the reference value from all of the track values
        const numTimes = targetTrack.times.length;
        for(let j = 0; j < numTimes; ++j){
            const valueStart = j * targetValueSize + targetOffset;
            if (referenceTrackType === 'quaternion') // Multiply the conjugate for quaternion track types
            $d5b33d7c30034067$export$23d6a54f0bbc85a3.multiplyQuaternionsFlat(targetTrack.values, valueStart, referenceValue, 0, targetTrack.values, valueStart);
            else {
                const valueEnd = targetValueSize - targetOffset * 2;
                // Subtract each value for all other numeric track types
                for(let k = 0; k < valueEnd; ++k)targetTrack.values[valueStart + k] -= referenceValue[k];
            }
        }
    }
    targetClip.blendMode = $d5b33d7c30034067$export$d875e029ef558d3;
    return targetClip;
}
const $d5b33d7c30034067$export$7ee8caa573e71ad1 = {
    convertArray: $d5b33d7c30034067$var$convertArray,
    isTypedArray: $d5b33d7c30034067$var$isTypedArray,
    getKeyframeOrder: $d5b33d7c30034067$var$getKeyframeOrder,
    sortedArray: $d5b33d7c30034067$var$sortedArray,
    flattenJSON: $d5b33d7c30034067$var$flattenJSON,
    subclip: $d5b33d7c30034067$var$subclip,
    makeClipAdditive: $d5b33d7c30034067$var$makeClipAdditive
};
/**
 * Abstract base class of interpolants over parametric samples.
 *
 * The parameter domain is one dimensional, typically the time or a path
 * along a curve defined by the data.
 *
 * The sample values can have any dimensionality and derived classes may
 * apply special interpretations to the data.
 *
 * This class provides the interval seek in a Template Method, deferring
 * the actual interpolation to derived classes.
 *
 * Time complexity is O(1) for linear access crossing at most two points
 * and O(log N) for random access, where N is the number of positions.
 *
 * References:
 *
 * 		http://www.oodesign.com/template-method-pattern.html
 *
 */ class $d5b33d7c30034067$export$b558baee9c0f72d3 {
    constructor(parameterPositions, sampleValues, sampleSize, resultBuffer){
        this.parameterPositions = parameterPositions;
        this._cachedIndex = 0;
        this.resultBuffer = resultBuffer !== undefined ? resultBuffer : new sampleValues.constructor(sampleSize);
        this.sampleValues = sampleValues;
        this.valueSize = sampleSize;
        this.settings = null;
        this.DefaultSettings_ = {};
    }
    evaluate(t) {
        const pp = this.parameterPositions;
        let i1 = this._cachedIndex, t1 = pp[i1], t0 = pp[i1 - 1];
        validate_interval: {
            seek: {
                let right;
                linear_scan: {
                    //- See http://jsperf.com/comparison-to-undefined/3
                    //- slower code:
                    //-
                    //- 				if ( t >= t1 || t1 === undefined ) {
                    forward_scan: if (!(t < t1)) {
                        for(let giveUpAt = i1 + 2;;){
                            if (t1 === undefined) {
                                if (t < t0) break forward_scan;
                                // after end
                                i1 = pp.length;
                                this._cachedIndex = i1;
                                return this.copySampleValue_(i1 - 1);
                            }
                            if (i1 === giveUpAt) break; // this loop
                            t0 = t1;
                            t1 = pp[++i1];
                            if (t < t1) break seek;
                        }
                        // prepare binary search on the right side of the index
                        right = pp.length;
                        break linear_scan;
                    }
                    //- slower code:
                    //-					if ( t < t0 || t0 === undefined ) {
                    if (!(t >= t0)) {
                        // looping?
                        const t1global = pp[1];
                        if (t < t1global) {
                            i1 = 2; // + 1, using the scan for the details
                            t0 = t1global;
                        }
                        // linear reverse scan
                        for(let giveUpAt = i1 - 2;;){
                            if (t0 === undefined) {
                                // before start
                                this._cachedIndex = 0;
                                return this.copySampleValue_(0);
                            }
                            if (i1 === giveUpAt) break; // this loop
                            t1 = t0;
                            t0 = pp[--i1 - 1];
                            if (t >= t0) break seek;
                        }
                        // prepare binary search on the left side of the index
                        right = i1;
                        i1 = 0;
                        break linear_scan;
                    }
                    break validate_interval;
                } // linear scan
                // binary search
                while(i1 < right){
                    const mid = i1 + right >>> 1;
                    if (t < pp[mid]) right = mid;
                    else i1 = mid + 1;
                }
                t1 = pp[i1];
                t0 = pp[i1 - 1];
                // check boundary cases, again
                if (t0 === undefined) {
                    this._cachedIndex = 0;
                    return this.copySampleValue_(0);
                }
                if (t1 === undefined) {
                    i1 = pp.length;
                    this._cachedIndex = i1;
                    return this.copySampleValue_(i1 - 1);
                }
            } // seek
            this._cachedIndex = i1;
            this.intervalChanged_(i1, t0, t1);
        } // validate_interval
        return this.interpolate_(i1, t0, t, t1);
    }
    getSettings_() {
        return this.settings || this.DefaultSettings_;
    }
    copySampleValue_(index) {
        // copies a sample value to the result buffer
        const result = this.resultBuffer, values = this.sampleValues, stride = this.valueSize, offset = index * stride;
        for(let i = 0; i !== stride; ++i)result[i] = values[offset + i];
        return result;
    }
    // Template methods for derived classes:
    interpolate_() {
        throw new Error('call to abstract method');
    // implementations shall return this.resultBuffer
    }
    intervalChanged_() {
    // empty
    }
}
/**
 * Fast and simple cubic spline interpolant.
 *
 * It was derived from a Hermitian construction setting the first derivative
 * at each sample position to the linear slope between neighboring positions
 * over their parameter interval.
 */ class $d5b33d7c30034067$export$3646682e7a3959 extends $d5b33d7c30034067$export$b558baee9c0f72d3 {
    constructor(parameterPositions, sampleValues, sampleSize, resultBuffer){
        super(parameterPositions, sampleValues, sampleSize, resultBuffer);
        this._weightPrev = -0;
        this._offsetPrev = -0;
        this._weightNext = -0;
        this._offsetNext = -0;
        this.DefaultSettings_ = {
            endingStart: $d5b33d7c30034067$export$7f795934b84ab523,
            endingEnd: $d5b33d7c30034067$export$7f795934b84ab523
        };
    }
    intervalChanged_(i1, t0, t1) {
        const pp = this.parameterPositions;
        let iPrev = i1 - 2, iNext = i1 + 1, tPrev = pp[iPrev], tNext = pp[iNext];
        if (tPrev === undefined) switch(this.getSettings_().endingStart){
            case $d5b33d7c30034067$export$24a4ccb5099273b5:
                // f'(t0) = 0
                iPrev = i1;
                tPrev = 2 * t0 - t1;
                break;
            case $d5b33d7c30034067$export$8e8c3ecdcd8e1fee:
                // use the other end of the curve
                iPrev = pp.length - 2;
                tPrev = t0 + pp[iPrev] - pp[iPrev + 1];
                break;
            default:
                // f''(t0) = 0 a.k.a. Natural Spline
                iPrev = i1;
                tPrev = t1;
        }
        if (tNext === undefined) switch(this.getSettings_().endingEnd){
            case $d5b33d7c30034067$export$24a4ccb5099273b5:
                // f'(tN) = 0
                iNext = i1;
                tNext = 2 * t1 - t0;
                break;
            case $d5b33d7c30034067$export$8e8c3ecdcd8e1fee:
                // use the other end of the curve
                iNext = 1;
                tNext = t1 + pp[1] - pp[0];
                break;
            default:
                // f''(tN) = 0, a.k.a. Natural Spline
                iNext = i1 - 1;
                tNext = t0;
        }
        const halfDt = (t1 - t0) * 0.5, stride = this.valueSize;
        this._weightPrev = halfDt / (t0 - tPrev);
        this._weightNext = halfDt / (tNext - t1);
        this._offsetPrev = iPrev * stride;
        this._offsetNext = iNext * stride;
    }
    interpolate_(i1, t0, t, t1) {
        const result = this.resultBuffer, values = this.sampleValues, stride = this.valueSize, o1 = i1 * stride, o0 = o1 - stride, oP = this._offsetPrev, oN = this._offsetNext, wP = this._weightPrev, wN = this._weightNext, p = (t - t0) / (t1 - t0), pp = p * p, ppp = pp * p;
        // evaluate polynomials
        const sP = -wP * ppp + 2 * wP * pp - wP * p;
        const s0 = (1 + wP) * ppp + (-1.5 - 2 * wP) * pp + (-0.5 + wP) * p + 1;
        const s1 = (-1 - wN) * ppp + (1.5 + wN) * pp + 0.5 * p;
        const sN = wN * ppp - wN * pp;
        // combine data linearly
        for(let i = 0; i !== stride; ++i)result[i] = sP * values[oP + i] + s0 * values[o0 + i] + s1 * values[o1 + i] + sN * values[oN + i];
        return result;
    }
}
class $d5b33d7c30034067$export$a8e6009059f51e1a extends $d5b33d7c30034067$export$b558baee9c0f72d3 {
    constructor(parameterPositions, sampleValues, sampleSize, resultBuffer){
        super(parameterPositions, sampleValues, sampleSize, resultBuffer);
    }
    interpolate_(i1, t0, t, t1) {
        const result = this.resultBuffer, values = this.sampleValues, stride = this.valueSize, offset1 = i1 * stride, offset0 = offset1 - stride, weight1 = (t - t0) / (t1 - t0), weight0 = 1 - weight1;
        for(let i = 0; i !== stride; ++i)result[i] = values[offset0 + i] * weight0 + values[offset1 + i] * weight1;
        return result;
    }
}
/**
 *
 * Interpolant that evaluates to the sample value at the position preceding
 * the parameter.
 */ class $d5b33d7c30034067$export$fb9758ef7ef8d5cc extends $d5b33d7c30034067$export$b558baee9c0f72d3 {
    constructor(parameterPositions, sampleValues, sampleSize, resultBuffer){
        super(parameterPositions, sampleValues, sampleSize, resultBuffer);
    }
    interpolate_(i1 /*, t0, t, t1 */ ) {
        return this.copySampleValue_(i1 - 1);
    }
}
class $d5b33d7c30034067$export$b0e479f45b7006d6 {
    constructor(name, times, values, interpolation){
        if (name === undefined) throw new Error('THREE.KeyframeTrack: track name is undefined');
        if (times === undefined || times.length === 0) throw new Error('THREE.KeyframeTrack: no keyframes in track named ' + name);
        this.name = name;
        this.times = $d5b33d7c30034067$var$convertArray(times, this.TimeBufferType);
        this.values = $d5b33d7c30034067$var$convertArray(values, this.ValueBufferType);
        this.setInterpolation(interpolation || this.DefaultInterpolation);
    }
    // Serialization (in static context, because of constructor invocation
    // and automatic invocation of .toJSON):
    static toJSON(track) {
        const trackType = track.constructor;
        let json;
        // derived classes can define a static toJSON method
        if (trackType.toJSON !== this.toJSON) json = trackType.toJSON(track);
        else {
            // by default, we assume the data can be serialized as-is
            json = {
                'name': track.name,
                'times': $d5b33d7c30034067$var$convertArray(track.times, Array),
                'values': $d5b33d7c30034067$var$convertArray(track.values, Array)
            };
            const interpolation = track.getInterpolation();
            if (interpolation !== track.DefaultInterpolation) json.interpolation = interpolation;
        }
        json.type = track.ValueTypeName; // mandatory
        return json;
    }
    InterpolantFactoryMethodDiscrete(result) {
        return new $d5b33d7c30034067$export$fb9758ef7ef8d5cc(this.times, this.values, this.getValueSize(), result);
    }
    InterpolantFactoryMethodLinear(result) {
        return new $d5b33d7c30034067$export$a8e6009059f51e1a(this.times, this.values, this.getValueSize(), result);
    }
    InterpolantFactoryMethodSmooth(result) {
        return new $d5b33d7c30034067$export$3646682e7a3959(this.times, this.values, this.getValueSize(), result);
    }
    setInterpolation(interpolation) {
        let factoryMethod;
        switch(interpolation){
            case $d5b33d7c30034067$export$995b32462a65e855:
                factoryMethod = this.InterpolantFactoryMethodDiscrete;
                break;
            case $d5b33d7c30034067$export$30fac1aace31cf4d:
                factoryMethod = this.InterpolantFactoryMethodLinear;
                break;
            case $d5b33d7c30034067$export$198b11ff4c72bb30:
                factoryMethod = this.InterpolantFactoryMethodSmooth;
                break;
        }
        if (factoryMethod === undefined) {
            const message = 'unsupported interpolation for ' + this.ValueTypeName + ' keyframe track named ' + this.name;
            if (this.createInterpolant === undefined) {
                // fall back to default, unless the default itself is messed up
                if (interpolation !== this.DefaultInterpolation) this.setInterpolation(this.DefaultInterpolation);
                else throw new Error(message); // fatal, in this case
            }
            console.warn('THREE.KeyframeTrack:', message);
            return this;
        }
        this.createInterpolant = factoryMethod;
        return this;
    }
    getInterpolation() {
        switch(this.createInterpolant){
            case this.InterpolantFactoryMethodDiscrete:
                return $d5b33d7c30034067$export$995b32462a65e855;
            case this.InterpolantFactoryMethodLinear:
                return $d5b33d7c30034067$export$30fac1aace31cf4d;
            case this.InterpolantFactoryMethodSmooth:
                return $d5b33d7c30034067$export$198b11ff4c72bb30;
        }
    }
    getValueSize() {
        return this.values.length / this.times.length;
    }
    // move all keyframes either forwards or backwards in time
    shift(timeOffset) {
        if (timeOffset !== 0.0) {
            const times = this.times;
            for(let i = 0, n = times.length; i !== n; ++i)times[i] += timeOffset;
        }
        return this;
    }
    // scale all keyframe times by a factor (useful for frame <-> seconds conversions)
    scale(timeScale) {
        if (timeScale !== 1.0) {
            const times = this.times;
            for(let i = 0, n = times.length; i !== n; ++i)times[i] *= timeScale;
        }
        return this;
    }
    // removes keyframes before and after animation without changing any values within the range [startTime, endTime].
    // IMPORTANT: We do not shift around keys to the start of the track time, because for interpolated keys this will change their values
    trim(startTime, endTime) {
        const times = this.times, nKeys = times.length;
        let from = 0, to = nKeys - 1;
        while(from !== nKeys && times[from] < startTime)++from;
        while(to !== -1 && times[to] > endTime)--to;
        ++to; // inclusive -> exclusive bound
        if (from !== 0 || to !== nKeys) {
            // empty tracks are forbidden, so keep at least one keyframe
            if (from >= to) {
                to = Math.max(to, 1);
                from = to - 1;
            }
            const stride = this.getValueSize();
            this.times = times.slice(from, to);
            this.values = this.values.slice(from * stride, to * stride);
        }
        return this;
    }
    // ensure we do not get a GarbageInGarbageOut situation, make sure tracks are at least minimally viable
    validate() {
        let valid = true;
        const valueSize = this.getValueSize();
        if (valueSize - Math.floor(valueSize) !== 0) {
            console.error('THREE.KeyframeTrack: Invalid value size in track.', this);
            valid = false;
        }
        const times = this.times, values = this.values, nKeys = times.length;
        if (nKeys === 0) {
            console.error('THREE.KeyframeTrack: Track is empty.', this);
            valid = false;
        }
        let prevTime = null;
        for(let i = 0; i !== nKeys; i++){
            const currTime = times[i];
            if (typeof currTime === 'number' && isNaN(currTime)) {
                console.error('THREE.KeyframeTrack: Time is not a valid number.', this, i, currTime);
                valid = false;
                break;
            }
            if (prevTime !== null && prevTime > currTime) {
                console.error('THREE.KeyframeTrack: Out of order keys.', this, i, currTime, prevTime);
                valid = false;
                break;
            }
            prevTime = currTime;
        }
        if (values !== undefined) {
            if ($d5b33d7c30034067$var$isTypedArray(values)) for(let i = 0, n = values.length; i !== n; ++i){
                const value = values[i];
                if (isNaN(value)) {
                    console.error('THREE.KeyframeTrack: Value is not a valid number.', this, i, value);
                    valid = false;
                    break;
                }
            }
        }
        return valid;
    }
    // removes equivalent sequential keys as common in morph target sequences
    // (0,0,0,0,1,1,1,0,0,0,0,0,0,0) --> (0,0,1,1,0,0)
    optimize() {
        // times or values may be shared with other tracks, so overwriting is unsafe
        const times = this.times.slice(), values = this.values.slice(), stride = this.getValueSize(), smoothInterpolation = this.getInterpolation() === $d5b33d7c30034067$export$198b11ff4c72bb30, lastIndex = times.length - 1;
        let writeIndex = 1;
        for(let i = 1; i < lastIndex; ++i){
            let keep = false;
            const time = times[i];
            const timeNext = times[i + 1];
            // remove adjacent keyframes scheduled at the same time
            if (time !== timeNext && (i !== 1 || time !== times[0])) {
                if (!smoothInterpolation) {
                    // remove unnecessary keyframes same as their neighbors
                    const offset = i * stride, offsetP = offset - stride, offsetN = offset + stride;
                    for(let j = 0; j !== stride; ++j){
                        const value = values[offset + j];
                        if (value !== values[offsetP + j] || value !== values[offsetN + j]) {
                            keep = true;
                            break;
                        }
                    }
                } else keep = true;
            }
            // in-place compaction
            if (keep) {
                if (i !== writeIndex) {
                    times[writeIndex] = times[i];
                    const readOffset = i * stride, writeOffset = writeIndex * stride;
                    for(let j = 0; j !== stride; ++j)values[writeOffset + j] = values[readOffset + j];
                }
                ++writeIndex;
            }
        }
        // flush last keyframe (compaction looks ahead)
        if (lastIndex > 0) {
            times[writeIndex] = times[lastIndex];
            for(let readOffset = lastIndex * stride, writeOffset = writeIndex * stride, j = 0; j !== stride; ++j)values[writeOffset + j] = values[readOffset + j];
            ++writeIndex;
        }
        if (writeIndex !== times.length) {
            this.times = times.slice(0, writeIndex);
            this.values = values.slice(0, writeIndex * stride);
        } else {
            this.times = times;
            this.values = values;
        }
        return this;
    }
    clone() {
        const times = this.times.slice();
        const values = this.values.slice();
        const TypedKeyframeTrack = this.constructor;
        const track = new TypedKeyframeTrack(this.name, times, values);
        // Interpolant argument to constructor is not saved, so copy the factory method directly.
        track.createInterpolant = this.createInterpolant;
        return track;
    }
}
$d5b33d7c30034067$export$b0e479f45b7006d6.prototype.TimeBufferType = Float32Array;
$d5b33d7c30034067$export$b0e479f45b7006d6.prototype.ValueBufferType = Float32Array;
$d5b33d7c30034067$export$b0e479f45b7006d6.prototype.DefaultInterpolation = $d5b33d7c30034067$export$30fac1aace31cf4d;
/**
 * A Track of Boolean keyframe values.
 */ class $d5b33d7c30034067$export$d3a344b98cf0b775 extends $d5b33d7c30034067$export$b0e479f45b7006d6 {
    // No interpolation parameter because only InterpolateDiscrete is valid.
    constructor(name, times, values){
        super(name, times, values);
    }
}
$d5b33d7c30034067$export$d3a344b98cf0b775.prototype.ValueTypeName = 'bool';
$d5b33d7c30034067$export$d3a344b98cf0b775.prototype.ValueBufferType = Array;
$d5b33d7c30034067$export$d3a344b98cf0b775.prototype.DefaultInterpolation = $d5b33d7c30034067$export$995b32462a65e855;
$d5b33d7c30034067$export$d3a344b98cf0b775.prototype.InterpolantFactoryMethodLinear = undefined;
$d5b33d7c30034067$export$d3a344b98cf0b775.prototype.InterpolantFactoryMethodSmooth = undefined;
/**
 * A Track of keyframe values that represent color.
 */ class $d5b33d7c30034067$export$83444c5d885347d8 extends $d5b33d7c30034067$export$b0e479f45b7006d6 {
}
$d5b33d7c30034067$export$83444c5d885347d8.prototype.ValueTypeName = 'color';
/**
 * A Track of numeric keyframe values.
 */ class $d5b33d7c30034067$export$d45f0d1a4d9a9314 extends $d5b33d7c30034067$export$b0e479f45b7006d6 {
}
$d5b33d7c30034067$export$d45f0d1a4d9a9314.prototype.ValueTypeName = 'number';
/**
 * Spherical linear unit quaternion interpolant.
 */ class $d5b33d7c30034067$export$2db1cfb7923d931e extends $d5b33d7c30034067$export$b558baee9c0f72d3 {
    constructor(parameterPositions, sampleValues, sampleSize, resultBuffer){
        super(parameterPositions, sampleValues, sampleSize, resultBuffer);
    }
    interpolate_(i1, t0, t, t1) {
        const result = this.resultBuffer, values = this.sampleValues, stride = this.valueSize, alpha = (t - t0) / (t1 - t0);
        let offset = i1 * stride;
        for(let end = offset + stride; offset !== end; offset += 4)$d5b33d7c30034067$export$23d6a54f0bbc85a3.slerpFlat(result, 0, values, offset - stride, values, offset, alpha);
        return result;
    }
}
/**
 * A Track of quaternion keyframe values.
 */ class $d5b33d7c30034067$export$b8043f12b5aafbd7 extends $d5b33d7c30034067$export$b0e479f45b7006d6 {
    InterpolantFactoryMethodLinear(result) {
        return new $d5b33d7c30034067$export$2db1cfb7923d931e(this.times, this.values, this.getValueSize(), result);
    }
}
$d5b33d7c30034067$export$b8043f12b5aafbd7.prototype.ValueTypeName = 'quaternion';
// ValueBufferType is inherited
// DefaultInterpolation is inherited;
$d5b33d7c30034067$export$b8043f12b5aafbd7.prototype.InterpolantFactoryMethodSmooth = undefined;
/**
 * A Track that interpolates Strings
 */ class $d5b33d7c30034067$export$6ce41d4f3a8df9cd extends $d5b33d7c30034067$export$b0e479f45b7006d6 {
    // No interpolation parameter because only InterpolateDiscrete is valid.
    constructor(name, times, values){
        super(name, times, values);
    }
}
$d5b33d7c30034067$export$6ce41d4f3a8df9cd.prototype.ValueTypeName = 'string';
$d5b33d7c30034067$export$6ce41d4f3a8df9cd.prototype.ValueBufferType = Array;
$d5b33d7c30034067$export$6ce41d4f3a8df9cd.prototype.DefaultInterpolation = $d5b33d7c30034067$export$995b32462a65e855;
$d5b33d7c30034067$export$6ce41d4f3a8df9cd.prototype.InterpolantFactoryMethodLinear = undefined;
$d5b33d7c30034067$export$6ce41d4f3a8df9cd.prototype.InterpolantFactoryMethodSmooth = undefined;
/**
 * A Track of vectored keyframe values.
 */ class $d5b33d7c30034067$export$5ce2dcb4cc9f2bff extends $d5b33d7c30034067$export$b0e479f45b7006d6 {
}
$d5b33d7c30034067$export$5ce2dcb4cc9f2bff.prototype.ValueTypeName = 'vector';
class $d5b33d7c30034067$export$d942c706bf23829c {
    constructor(name = '', duration = -1, tracks = [], blendMode = $d5b33d7c30034067$export$bcfbbdcf8de7f8cd){
        this.name = name;
        this.tracks = tracks;
        this.duration = duration;
        this.blendMode = blendMode;
        this.uuid = $d5b33d7c30034067$var$generateUUID();
        // this means it should figure out its duration by scanning the tracks
        if (this.duration < 0) this.resetDuration();
    }
    static parse(json) {
        const tracks = [], jsonTracks = json.tracks, frameTime = 1.0 / (json.fps || 1.0);
        for(let i = 0, n = jsonTracks.length; i !== n; ++i)tracks.push($d5b33d7c30034067$var$parseKeyframeTrack(jsonTracks[i]).scale(frameTime));
        const clip = new this(json.name, json.duration, tracks, json.blendMode);
        clip.uuid = json.uuid;
        return clip;
    }
    static toJSON(clip) {
        const tracks = [], clipTracks = clip.tracks;
        const json = {
            'name': clip.name,
            'duration': clip.duration,
            'tracks': tracks,
            'uuid': clip.uuid,
            'blendMode': clip.blendMode
        };
        for(let i = 0, n = clipTracks.length; i !== n; ++i)tracks.push($d5b33d7c30034067$export$b0e479f45b7006d6.toJSON(clipTracks[i]));
        return json;
    }
    static CreateFromMorphTargetSequence(name, morphTargetSequence, fps, noLoop) {
        const numMorphTargets = morphTargetSequence.length;
        const tracks = [];
        for(let i = 0; i < numMorphTargets; i++){
            let times = [];
            let values = [];
            times.push((i + numMorphTargets - 1) % numMorphTargets, i, (i + 1) % numMorphTargets);
            values.push(0, 1, 0);
            const order = $d5b33d7c30034067$var$getKeyframeOrder(times);
            times = $d5b33d7c30034067$var$sortedArray(times, 1, order);
            values = $d5b33d7c30034067$var$sortedArray(values, 1, order);
            // if there is a key at the first frame, duplicate it as the
            // last frame as well for perfect loop.
            if (!noLoop && times[0] === 0) {
                times.push(numMorphTargets);
                values.push(values[0]);
            }
            tracks.push(new $d5b33d7c30034067$export$d45f0d1a4d9a9314('.morphTargetInfluences[' + morphTargetSequence[i].name + ']', times, values).scale(1.0 / fps));
        }
        return new this(name, -1, tracks);
    }
    static findByName(objectOrClipArray, name) {
        let clipArray = objectOrClipArray;
        if (!Array.isArray(objectOrClipArray)) {
            const o = objectOrClipArray;
            clipArray = o.geometry && o.geometry.animations || o.animations;
        }
        for(let i = 0; i < clipArray.length; i++){
            if (clipArray[i].name === name) return clipArray[i];
        }
        return null;
    }
    static CreateClipsFromMorphTargetSequences(morphTargets, fps, noLoop) {
        const animationToMorphTargets = {};
        // tested with https://regex101.com/ on trick sequences
        // such flamingo_flyA_003, flamingo_run1_003, crdeath0059
        const pattern = /^([\w-]*?)([\d]+)$/;
        // sort morph target names into animation groups based
        // patterns like Walk_001, Walk_002, Run_001, Run_002
        for(let i = 0, il = morphTargets.length; i < il; i++){
            const morphTarget = morphTargets[i];
            const parts = morphTarget.name.match(pattern);
            if (parts && parts.length > 1) {
                const name = parts[1];
                let animationMorphTargets = animationToMorphTargets[name];
                if (!animationMorphTargets) animationToMorphTargets[name] = animationMorphTargets = [];
                animationMorphTargets.push(morphTarget);
            }
        }
        const clips = [];
        for(const name in animationToMorphTargets)clips.push(this.CreateFromMorphTargetSequence(name, animationToMorphTargets[name], fps, noLoop));
        return clips;
    }
    // parse the animation.hierarchy format
    static parseAnimation(animation, bones) {
        if (!animation) {
            console.error('THREE.AnimationClip: No animation in JSONLoader data.');
            return null;
        }
        const addNonemptyTrack = function(trackType, trackName, animationKeys, propertyName, destTracks) {
            // only return track if there are actually keys.
            if (animationKeys.length !== 0) {
                const times = [];
                const values = [];
                $d5b33d7c30034067$var$flattenJSON(animationKeys, times, values, propertyName);
                // empty keys are filtered out, so check again
                if (times.length !== 0) destTracks.push(new trackType(trackName, times, values));
            }
        };
        const tracks = [];
        const clipName = animation.name || 'default';
        const fps = animation.fps || 30;
        const blendMode = animation.blendMode;
        // automatic length determination in AnimationClip.
        let duration = animation.length || -1;
        const hierarchyTracks = animation.hierarchy || [];
        for(let h = 0; h < hierarchyTracks.length; h++){
            const animationKeys = hierarchyTracks[h].keys;
            // skip empty tracks
            if (!animationKeys || animationKeys.length === 0) continue;
            // process morph targets
            if (animationKeys[0].morphTargets) {
                // figure out all morph targets used in this track
                const morphTargetNames = {};
                let k;
                for(k = 0; k < animationKeys.length; k++){
                    if (animationKeys[k].morphTargets) for(let m = 0; m < animationKeys[k].morphTargets.length; m++)morphTargetNames[animationKeys[k].morphTargets[m]] = -1;
                }
                // create a track for each morph target with all zero
                // morphTargetInfluences except for the keys in which
                // the morphTarget is named.
                for(const morphTargetName in morphTargetNames){
                    const times = [];
                    const values = [];
                    for(let m = 0; m !== animationKeys[k].morphTargets.length; ++m){
                        const animationKey = animationKeys[k];
                        times.push(animationKey.time);
                        values.push(animationKey.morphTarget === morphTargetName ? 1 : 0);
                    }
                    tracks.push(new $d5b33d7c30034067$export$d45f0d1a4d9a9314('.morphTargetInfluence[' + morphTargetName + ']', times, values));
                }
                duration = morphTargetNames.length * fps;
            } else {
                // ...assume skeletal animation
                const boneName = '.bones[' + bones[h].name + ']';
                addNonemptyTrack($d5b33d7c30034067$export$5ce2dcb4cc9f2bff, boneName + '.position', animationKeys, 'pos', tracks);
                addNonemptyTrack($d5b33d7c30034067$export$b8043f12b5aafbd7, boneName + '.quaternion', animationKeys, 'rot', tracks);
                addNonemptyTrack($d5b33d7c30034067$export$5ce2dcb4cc9f2bff, boneName + '.scale', animationKeys, 'scl', tracks);
            }
        }
        if (tracks.length === 0) return null;
        const clip = new this(clipName, duration, tracks, blendMode);
        return clip;
    }
    resetDuration() {
        const tracks = this.tracks;
        let duration = 0;
        for(let i = 0, n = tracks.length; i !== n; ++i){
            const track = this.tracks[i];
            duration = Math.max(duration, track.times[track.times.length - 1]);
        }
        this.duration = duration;
        return this;
    }
    trim() {
        for(let i = 0; i < this.tracks.length; i++)this.tracks[i].trim(0, this.duration);
        return this;
    }
    validate() {
        let valid = true;
        for(let i = 0; i < this.tracks.length; i++)valid = valid && this.tracks[i].validate();
        return valid;
    }
    optimize() {
        for(let i = 0; i < this.tracks.length; i++)this.tracks[i].optimize();
        return this;
    }
    clone() {
        const tracks = [];
        for(let i = 0; i < this.tracks.length; i++)tracks.push(this.tracks[i].clone());
        return new this.constructor(this.name, this.duration, tracks, this.blendMode);
    }
    toJSON() {
        return this.constructor.toJSON(this);
    }
}
function $d5b33d7c30034067$var$getTrackTypeForValueTypeName(typeName) {
    switch(typeName.toLowerCase()){
        case 'scalar':
        case 'double':
        case 'float':
        case 'number':
        case 'integer':
            return $d5b33d7c30034067$export$d45f0d1a4d9a9314;
        case 'vector':
        case 'vector2':
        case 'vector3':
        case 'vector4':
            return $d5b33d7c30034067$export$5ce2dcb4cc9f2bff;
        case 'color':
            return $d5b33d7c30034067$export$83444c5d885347d8;
        case 'quaternion':
            return $d5b33d7c30034067$export$b8043f12b5aafbd7;
        case 'bool':
        case 'boolean':
            return $d5b33d7c30034067$export$d3a344b98cf0b775;
        case 'string':
            return $d5b33d7c30034067$export$6ce41d4f3a8df9cd;
    }
    throw new Error('THREE.KeyframeTrack: Unsupported typeName: ' + typeName);
}
function $d5b33d7c30034067$var$parseKeyframeTrack(json) {
    if (json.type === undefined) throw new Error('THREE.KeyframeTrack: track type undefined, can not parse');
    const trackType = $d5b33d7c30034067$var$getTrackTypeForValueTypeName(json.type);
    if (json.times === undefined) {
        const times = [], values = [];
        $d5b33d7c30034067$var$flattenJSON(json.keys, times, values, 'value');
        json.times = times;
        json.values = values;
    }
    // derived classes can define a static parse method
    if (trackType.parse !== undefined) return trackType.parse(json);
    else // by default, we assume a constructor compatible with the base
    return new trackType(json.name, json.times, json.values, json.interpolation);
}
const $d5b33d7c30034067$export$94affb487e701bf2 = {
    enabled: false,
    files: {},
    add: function(key, file) {
        if (this.enabled === false) return;
        // console.log( 'THREE.Cache', 'Adding key:', key );
        this.files[key] = file;
    },
    get: function(key) {
        if (this.enabled === false) return;
        // console.log( 'THREE.Cache', 'Checking key:', key );
        return this.files[key];
    },
    remove: function(key) {
        delete this.files[key];
    },
    clear: function() {
        this.files = {};
    }
};
class $d5b33d7c30034067$export$99cc795e99919eed {
    constructor(onLoad, onProgress, onError){
        const scope = this;
        let isLoading = false;
        let itemsLoaded = 0;
        let itemsTotal = 0;
        let urlModifier = undefined;
        const handlers = [];
        // Refer to #5689 for the reason why we don't set .onStart
        // in the constructor
        this.onStart = undefined;
        this.onLoad = onLoad;
        this.onProgress = onProgress;
        this.onError = onError;
        this.itemStart = function(url) {
            itemsTotal++;
            if (isLoading === false) {
                if (scope.onStart !== undefined) scope.onStart(url, itemsLoaded, itemsTotal);
            }
            isLoading = true;
        };
        this.itemEnd = function(url) {
            itemsLoaded++;
            if (scope.onProgress !== undefined) scope.onProgress(url, itemsLoaded, itemsTotal);
            if (itemsLoaded === itemsTotal) {
                isLoading = false;
                if (scope.onLoad !== undefined) scope.onLoad();
            }
        };
        this.itemError = function(url) {
            if (scope.onError !== undefined) scope.onError(url);
        };
        this.resolveURL = function(url) {
            if (urlModifier) return urlModifier(url);
            return url;
        };
        this.setURLModifier = function(transform) {
            urlModifier = transform;
            return this;
        };
        this.addHandler = function(regex, loader) {
            handlers.push(regex, loader);
            return this;
        };
        this.removeHandler = function(regex) {
            const index = handlers.indexOf(regex);
            if (index !== -1) handlers.splice(index, 2);
            return this;
        };
        this.getHandler = function(file) {
            for(let i = 0, l = handlers.length; i < l; i += 2){
                const regex = handlers[i];
                const loader = handlers[i + 1];
                if (regex.global) regex.lastIndex = 0; // see #17920
                if (regex.test(file)) return loader;
            }
            return null;
        };
    }
}
const $d5b33d7c30034067$export$b033c3f9a95c6a16 = /*@__PURE__*/ new $d5b33d7c30034067$export$99cc795e99919eed();
class $d5b33d7c30034067$export$3b0d6d7590275603 {
    constructor(manager){
        this.manager = manager !== undefined ? manager : $d5b33d7c30034067$export$b033c3f9a95c6a16;
        this.crossOrigin = 'anonymous';
        this.withCredentials = false;
        this.path = '';
        this.resourcePath = '';
        this.requestHeader = {};
    }
    load() {}
    loadAsync(url, onProgress) {
        const scope = this;
        return new Promise(function(resolve, reject) {
            scope.load(url, resolve, onProgress, reject);
        });
    }
    parse() {}
    setCrossOrigin(crossOrigin) {
        this.crossOrigin = crossOrigin;
        return this;
    }
    setWithCredentials(value) {
        this.withCredentials = value;
        return this;
    }
    setPath(path) {
        this.path = path;
        return this;
    }
    setResourcePath(resourcePath) {
        this.resourcePath = resourcePath;
        return this;
    }
    setRequestHeader(requestHeader) {
        this.requestHeader = requestHeader;
        return this;
    }
}
$d5b33d7c30034067$export$3b0d6d7590275603.DEFAULT_MATERIAL_NAME = '__DEFAULT';
const $d5b33d7c30034067$var$loading = {};
class $d5b33d7c30034067$var$HttpError extends Error {
    constructor(message, response){
        super(message);
        this.response = response;
    }
}
class $d5b33d7c30034067$export$98435a25b5cf7b2b extends $d5b33d7c30034067$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(url, onLoad, onProgress, onError) {
        if (url === undefined) url = '';
        if (this.path !== undefined) url = this.path + url;
        url = this.manager.resolveURL(url);
        const cached = $d5b33d7c30034067$export$94affb487e701bf2.get(url);
        if (cached !== undefined) {
            this.manager.itemStart(url);
            setTimeout(()=>{
                if (onLoad) onLoad(cached);
                this.manager.itemEnd(url);
            }, 0);
            return cached;
        }
        // Check if request is duplicate
        if ($d5b33d7c30034067$var$loading[url] !== undefined) {
            $d5b33d7c30034067$var$loading[url].push({
                onLoad: onLoad,
                onProgress: onProgress,
                onError: onError
            });
            return;
        }
        // Initialise array for duplicate requests
        $d5b33d7c30034067$var$loading[url] = [];
        $d5b33d7c30034067$var$loading[url].push({
            onLoad: onLoad,
            onProgress: onProgress,
            onError: onError
        });
        // create request
        const req = new Request(url, {
            headers: new Headers(this.requestHeader),
            credentials: this.withCredentials ? 'include' : 'same-origin'
        });
        // record states ( avoid data race )
        const mimeType = this.mimeType;
        const responseType = this.responseType;
        // start the fetch
        fetch(req).then((response)=>{
            if (response.status === 200 || response.status === 0) {
                // Some browsers return HTTP Status 0 when using non-http protocol
                // e.g. 'file://' or 'data://'. Handle as success.
                if (response.status === 0) console.warn('THREE.FileLoader: HTTP Status 0 received.');
                // Workaround: Checking if response.body === undefined for Alipay browser #23548
                if (typeof ReadableStream === 'undefined' || response.body === undefined || response.body.getReader === undefined) return response;
                const callbacks = $d5b33d7c30034067$var$loading[url];
                const reader = response.body.getReader();
                // Nginx needs X-File-Size check
                // https://serverfault.com/questions/482875/why-does-nginx-remove-content-length-header-for-chunked-content
                const contentLength = response.headers.get('X-File-Size') || response.headers.get('Content-Length');
                const total = contentLength ? parseInt(contentLength) : 0;
                const lengthComputable = total !== 0;
                let loaded = 0;
                // periodically read data into the new stream tracking while download progress
                const stream = new ReadableStream({
                    start (controller) {
                        readData();
                        function readData() {
                            reader.read().then(({ done: done, value: value })=>{
                                if (done) controller.close();
                                else {
                                    loaded += value.byteLength;
                                    const event = new ProgressEvent('progress', {
                                        lengthComputable: lengthComputable,
                                        loaded: loaded,
                                        total: total
                                    });
                                    for(let i = 0, il = callbacks.length; i < il; i++){
                                        const callback = callbacks[i];
                                        if (callback.onProgress) callback.onProgress(event);
                                    }
                                    controller.enqueue(value);
                                    readData();
                                }
                            }, (e)=>{
                                controller.error(e);
                            });
                        }
                    }
                });
                return new Response(stream);
            } else throw new $d5b33d7c30034067$var$HttpError(`fetch for "${response.url}" responded with ${response.status}: ${response.statusText}`, response);
        }).then((response)=>{
            switch(responseType){
                case 'arraybuffer':
                    return response.arrayBuffer();
                case 'blob':
                    return response.blob();
                case 'document':
                    return response.text().then((text)=>{
                        const parser = new DOMParser();
                        return parser.parseFromString(text, mimeType);
                    });
                case 'json':
                    return response.json();
                default:
                    if (mimeType === undefined) return response.text();
                    else {
                        // sniff encoding
                        const re = /charset="?([^;"\s]*)"?/i;
                        const exec = re.exec(mimeType);
                        const label = exec && exec[1] ? exec[1].toLowerCase() : undefined;
                        const decoder = new TextDecoder(label);
                        return response.arrayBuffer().then((ab)=>decoder.decode(ab));
                    }
            }
        }).then((data)=>{
            // Add to cache only on HTTP success, so that we do not cache
            // error response bodies as proper responses to requests.
            $d5b33d7c30034067$export$94affb487e701bf2.add(url, data);
            const callbacks = $d5b33d7c30034067$var$loading[url];
            delete $d5b33d7c30034067$var$loading[url];
            for(let i = 0, il = callbacks.length; i < il; i++){
                const callback = callbacks[i];
                if (callback.onLoad) callback.onLoad(data);
            }
        }).catch((err)=>{
            // Abort errors and other errors are handled the same
            const callbacks = $d5b33d7c30034067$var$loading[url];
            if (callbacks === undefined) {
                // When onLoad was called and url was deleted in `loading`
                this.manager.itemError(url);
                throw err;
            }
            delete $d5b33d7c30034067$var$loading[url];
            for(let i = 0, il = callbacks.length; i < il; i++){
                const callback = callbacks[i];
                if (callback.onError) callback.onError(err);
            }
            this.manager.itemError(url);
        }).finally(()=>{
            this.manager.itemEnd(url);
        });
        this.manager.itemStart(url);
    }
    setResponseType(value) {
        this.responseType = value;
        return this;
    }
    setMimeType(value) {
        this.mimeType = value;
        return this;
    }
}
class $d5b33d7c30034067$export$29711c7e14f61db extends $d5b33d7c30034067$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(url, onLoad, onProgress, onError) {
        const scope = this;
        const loader = new $d5b33d7c30034067$export$98435a25b5cf7b2b(this.manager);
        loader.setPath(this.path);
        loader.setRequestHeader(this.requestHeader);
        loader.setWithCredentials(this.withCredentials);
        loader.load(url, function(text) {
            try {
                onLoad(scope.parse(JSON.parse(text)));
            } catch (e) {
                if (onError) onError(e);
                else console.error(e);
                scope.manager.itemError(url);
            }
        }, onProgress, onError);
    }
    parse(json) {
        const animations = [];
        for(let i = 0; i < json.length; i++){
            const clip = $d5b33d7c30034067$export$d942c706bf23829c.parse(json[i]);
            animations.push(clip);
        }
        return animations;
    }
}
/**
 * Abstract Base class to block based textures loader (dds, pvr, ...)
 *
 * Sub classes have to implement the parse() method which will be used in load().
 */ class $d5b33d7c30034067$export$bd73ce947a280350 extends $d5b33d7c30034067$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(url, onLoad, onProgress, onError) {
        const scope = this;
        const images = [];
        const texture = new $d5b33d7c30034067$export$3466bac9141a5cc4();
        const loader = new $d5b33d7c30034067$export$98435a25b5cf7b2b(this.manager);
        loader.setPath(this.path);
        loader.setResponseType('arraybuffer');
        loader.setRequestHeader(this.requestHeader);
        loader.setWithCredentials(scope.withCredentials);
        let loaded = 0;
        function loadTexture(i) {
            loader.load(url[i], function(buffer) {
                const texDatas = scope.parse(buffer, true);
                images[i] = {
                    width: texDatas.width,
                    height: texDatas.height,
                    format: texDatas.format,
                    mipmaps: texDatas.mipmaps
                };
                loaded += 1;
                if (loaded === 6) {
                    if (texDatas.mipmapCount === 1) texture.minFilter = $d5b33d7c30034067$export$8a72f490b25c56c8;
                    texture.image = images;
                    texture.format = texDatas.format;
                    texture.needsUpdate = true;
                    if (onLoad) onLoad(texture);
                }
            }, onProgress, onError);
        }
        if (Array.isArray(url)) for(let i = 0, il = url.length; i < il; ++i)loadTexture(i);
        else // compressed cubemap texture stored in a single DDS file
        loader.load(url, function(buffer) {
            const texDatas = scope.parse(buffer, true);
            if (texDatas.isCubemap) {
                const faces = texDatas.mipmaps.length / texDatas.mipmapCount;
                for(let f = 0; f < faces; f++){
                    images[f] = {
                        mipmaps: []
                    };
                    for(let i = 0; i < texDatas.mipmapCount; i++){
                        images[f].mipmaps.push(texDatas.mipmaps[f * texDatas.mipmapCount + i]);
                        images[f].format = texDatas.format;
                        images[f].width = texDatas.width;
                        images[f].height = texDatas.height;
                    }
                }
                texture.image = images;
            } else {
                texture.image.width = texDatas.width;
                texture.image.height = texDatas.height;
                texture.mipmaps = texDatas.mipmaps;
            }
            if (texDatas.mipmapCount === 1) texture.minFilter = $d5b33d7c30034067$export$8a72f490b25c56c8;
            texture.format = texDatas.format;
            texture.needsUpdate = true;
            if (onLoad) onLoad(texture);
        }, onProgress, onError);
        return texture;
    }
}
class $d5b33d7c30034067$export$8905ce1c7a2464a1 extends $d5b33d7c30034067$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(url, onLoad, onProgress, onError) {
        if (this.path !== undefined) url = this.path + url;
        url = this.manager.resolveURL(url);
        const scope = this;
        const cached = $d5b33d7c30034067$export$94affb487e701bf2.get(url);
        if (cached !== undefined) {
            scope.manager.itemStart(url);
            setTimeout(function() {
                if (onLoad) onLoad(cached);
                scope.manager.itemEnd(url);
            }, 0);
            return cached;
        }
        const image = $d5b33d7c30034067$var$createElementNS('img');
        function onImageLoad() {
            removeEventListeners();
            $d5b33d7c30034067$export$94affb487e701bf2.add(url, this);
            if (onLoad) onLoad(this);
            scope.manager.itemEnd(url);
        }
        function onImageError(event) {
            removeEventListeners();
            if (onError) onError(event);
            scope.manager.itemError(url);
            scope.manager.itemEnd(url);
        }
        function removeEventListeners() {
            image.removeEventListener('load', onImageLoad, false);
            image.removeEventListener('error', onImageError, false);
        }
        image.addEventListener('load', onImageLoad, false);
        image.addEventListener('error', onImageError, false);
        if (url.slice(0, 5) !== 'data:') {
            if (this.crossOrigin !== undefined) image.crossOrigin = this.crossOrigin;
        }
        scope.manager.itemStart(url);
        image.src = url;
        return image;
    }
}
class $d5b33d7c30034067$export$2ec114afc2cf6308 extends $d5b33d7c30034067$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(urls, onLoad, onProgress, onError) {
        const texture = new $d5b33d7c30034067$export$ee2e5a18258a4049();
        texture.colorSpace = $d5b33d7c30034067$export$561f394b24edfcaa;
        const loader = new $d5b33d7c30034067$export$8905ce1c7a2464a1(this.manager);
        loader.setCrossOrigin(this.crossOrigin);
        loader.setPath(this.path);
        let loaded = 0;
        function loadTexture(i) {
            loader.load(urls[i], function(image) {
                texture.images[i] = image;
                loaded++;
                if (loaded === 6) {
                    texture.needsUpdate = true;
                    if (onLoad) onLoad(texture);
                }
            }, undefined, onError);
        }
        for(let i = 0; i < urls.length; ++i)loadTexture(i);
        return texture;
    }
}
/**
 * Abstract Base class to load generic binary textures formats (rgbe, hdr, ...)
 *
 * Sub classes have to implement the parse() method which will be used in load().
 */ class $d5b33d7c30034067$export$792d8a18f2c55855 extends $d5b33d7c30034067$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(url, onLoad, onProgress, onError) {
        const scope = this;
        const texture = new $d5b33d7c30034067$export$b691f601014eabe1();
        const loader = new $d5b33d7c30034067$export$98435a25b5cf7b2b(this.manager);
        loader.setResponseType('arraybuffer');
        loader.setRequestHeader(this.requestHeader);
        loader.setPath(this.path);
        loader.setWithCredentials(scope.withCredentials);
        loader.load(url, function(buffer) {
            let texData;
            try {
                texData = scope.parse(buffer);
            } catch (error) {
                if (onError !== undefined) onError(error);
                else {
                    console.error(error);
                    return;
                }
            }
            if (texData.image !== undefined) texture.image = texData.image;
            else if (texData.data !== undefined) {
                texture.image.width = texData.width;
                texture.image.height = texData.height;
                texture.image.data = texData.data;
            }
            texture.wrapS = texData.wrapS !== undefined ? texData.wrapS : $d5b33d7c30034067$export$9d9334239a5a5e06;
            texture.wrapT = texData.wrapT !== undefined ? texData.wrapT : $d5b33d7c30034067$export$9d9334239a5a5e06;
            texture.magFilter = texData.magFilter !== undefined ? texData.magFilter : $d5b33d7c30034067$export$8a72f490b25c56c8;
            texture.minFilter = texData.minFilter !== undefined ? texData.minFilter : $d5b33d7c30034067$export$8a72f490b25c56c8;
            texture.anisotropy = texData.anisotropy !== undefined ? texData.anisotropy : 1;
            if (texData.colorSpace !== undefined) texture.colorSpace = texData.colorSpace;
            if (texData.flipY !== undefined) texture.flipY = texData.flipY;
            if (texData.format !== undefined) texture.format = texData.format;
            if (texData.type !== undefined) texture.type = texData.type;
            if (texData.mipmaps !== undefined) {
                texture.mipmaps = texData.mipmaps;
                texture.minFilter = $d5b33d7c30034067$export$5d8599b6a933fb1b; // presumably...
            }
            if (texData.mipmapCount === 1) texture.minFilter = $d5b33d7c30034067$export$8a72f490b25c56c8;
            if (texData.generateMipmaps !== undefined) texture.generateMipmaps = texData.generateMipmaps;
            texture.needsUpdate = true;
            if (onLoad) onLoad(texture, texData);
        }, onProgress, onError);
        return texture;
    }
}
class $d5b33d7c30034067$export$fd1bfc71f64c538c extends $d5b33d7c30034067$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(url, onLoad, onProgress, onError) {
        const texture = new $d5b33d7c30034067$export$5431306cf43de24a();
        const loader = new $d5b33d7c30034067$export$8905ce1c7a2464a1(this.manager);
        loader.setCrossOrigin(this.crossOrigin);
        loader.setPath(this.path);
        loader.load(url, function(image) {
            texture.image = image;
            texture.needsUpdate = true;
            if (onLoad !== undefined) onLoad(texture);
        }, onProgress, onError);
        return texture;
    }
}
class $d5b33d7c30034067$export$6ecadb6ed240d696 extends $d5b33d7c30034067$export$e4dd07dff30cc924 {
    constructor(color, intensity = 1){
        super();
        this.isLight = true;
        this.type = 'Light';
        this.color = new $d5b33d7c30034067$export$892596cec99bc70e(color);
        this.intensity = intensity;
    }
    dispose() {
    // Empty here in base class; some subclasses override.
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.color.copy(source.color);
        this.intensity = source.intensity;
        return this;
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.object.color = this.color.getHex();
        data.object.intensity = this.intensity;
        if (this.groundColor !== undefined) data.object.groundColor = this.groundColor.getHex();
        if (this.distance !== undefined) data.object.distance = this.distance;
        if (this.angle !== undefined) data.object.angle = this.angle;
        if (this.decay !== undefined) data.object.decay = this.decay;
        if (this.penumbra !== undefined) data.object.penumbra = this.penumbra;
        if (this.shadow !== undefined) data.object.shadow = this.shadow.toJSON();
        if (this.target !== undefined) data.object.target = this.target.uuid;
        return data;
    }
}
class $d5b33d7c30034067$export$8d474f55edbb9624 extends $d5b33d7c30034067$export$6ecadb6ed240d696 {
    constructor(skyColor, groundColor, intensity){
        super(skyColor, intensity);
        this.isHemisphereLight = true;
        this.type = 'HemisphereLight';
        this.position.copy($d5b33d7c30034067$export$e4dd07dff30cc924.DEFAULT_UP);
        this.updateMatrix();
        this.groundColor = new $d5b33d7c30034067$export$892596cec99bc70e(groundColor);
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.groundColor.copy(source.groundColor);
        return this;
    }
}
const $d5b33d7c30034067$var$_projScreenMatrix$1 = /*@__PURE__*/ new $d5b33d7c30034067$export$2ae72fc923e5eb5();
const $d5b33d7c30034067$var$_lightPositionWorld$1 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_lookTarget$1 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
class $d5b33d7c30034067$var$LightShadow {
    constructor(camera){
        this.camera = camera;
        this.intensity = 1;
        this.bias = 0;
        this.normalBias = 0;
        this.radius = 1;
        this.blurSamples = 8;
        this.mapSize = new $d5b33d7c30034067$export$c977b3e384af9ae1(512, 512);
        this.map = null;
        this.mapPass = null;
        this.matrix = new $d5b33d7c30034067$export$2ae72fc923e5eb5();
        this.autoUpdate = true;
        this.needsUpdate = false;
        this._frustum = new $d5b33d7c30034067$export$35efe6f4c85463d2();
        this._frameExtents = new $d5b33d7c30034067$export$c977b3e384af9ae1(1, 1);
        this._viewportCount = 1;
        this._viewports = [
            new $d5b33d7c30034067$export$fa7daccca11cdbe3(0, 0, 1, 1)
        ];
    }
    getViewportCount() {
        return this._viewportCount;
    }
    getFrustum() {
        return this._frustum;
    }
    updateMatrices(light) {
        const shadowCamera = this.camera;
        const shadowMatrix = this.matrix;
        $d5b33d7c30034067$var$_lightPositionWorld$1.setFromMatrixPosition(light.matrixWorld);
        shadowCamera.position.copy($d5b33d7c30034067$var$_lightPositionWorld$1);
        $d5b33d7c30034067$var$_lookTarget$1.setFromMatrixPosition(light.target.matrixWorld);
        shadowCamera.lookAt($d5b33d7c30034067$var$_lookTarget$1);
        shadowCamera.updateMatrixWorld();
        $d5b33d7c30034067$var$_projScreenMatrix$1.multiplyMatrices(shadowCamera.projectionMatrix, shadowCamera.matrixWorldInverse);
        this._frustum.setFromProjectionMatrix($d5b33d7c30034067$var$_projScreenMatrix$1);
        shadowMatrix.set(0.5, 0.0, 0.0, 0.5, 0.0, 0.5, 0.0, 0.5, 0.0, 0.0, 0.5, 0.5, 0.0, 0.0, 0.0, 1.0);
        shadowMatrix.multiply($d5b33d7c30034067$var$_projScreenMatrix$1);
    }
    getViewport(viewportIndex) {
        return this._viewports[viewportIndex];
    }
    getFrameExtents() {
        return this._frameExtents;
    }
    dispose() {
        if (this.map) this.map.dispose();
        if (this.mapPass) this.mapPass.dispose();
    }
    copy(source) {
        this.camera = source.camera.clone();
        this.intensity = source.intensity;
        this.bias = source.bias;
        this.radius = source.radius;
        this.mapSize.copy(source.mapSize);
        return this;
    }
    clone() {
        return new this.constructor().copy(this);
    }
    toJSON() {
        const object = {};
        if (this.intensity !== 1) object.intensity = this.intensity;
        if (this.bias !== 0) object.bias = this.bias;
        if (this.normalBias !== 0) object.normalBias = this.normalBias;
        if (this.radius !== 1) object.radius = this.radius;
        if (this.mapSize.x !== 512 || this.mapSize.y !== 512) object.mapSize = this.mapSize.toArray();
        object.camera = this.camera.toJSON(false).object;
        delete object.camera.matrix;
        return object;
    }
}
class $d5b33d7c30034067$var$SpotLightShadow extends $d5b33d7c30034067$var$LightShadow {
    constructor(){
        super(new $d5b33d7c30034067$export$74e4ae24825f68d7(50, 1, 0.5, 500));
        this.isSpotLightShadow = true;
        this.focus = 1;
    }
    updateMatrices(light) {
        const camera = this.camera;
        const fov = $d5b33d7c30034067$var$RAD2DEG * 2 * light.angle * this.focus;
        const aspect = this.mapSize.width / this.mapSize.height;
        const far = light.distance || camera.far;
        if (fov !== camera.fov || aspect !== camera.aspect || far !== camera.far) {
            camera.fov = fov;
            camera.aspect = aspect;
            camera.far = far;
            camera.updateProjectionMatrix();
        }
        super.updateMatrices(light);
    }
    copy(source) {
        super.copy(source);
        this.focus = source.focus;
        return this;
    }
}
class $d5b33d7c30034067$export$81495cbb73897362 extends $d5b33d7c30034067$export$6ecadb6ed240d696 {
    constructor(color, intensity, distance = 0, angle = Math.PI / 3, penumbra = 0, decay = 2){
        super(color, intensity);
        this.isSpotLight = true;
        this.type = 'SpotLight';
        this.position.copy($d5b33d7c30034067$export$e4dd07dff30cc924.DEFAULT_UP);
        this.updateMatrix();
        this.target = new $d5b33d7c30034067$export$e4dd07dff30cc924();
        this.distance = distance;
        this.angle = angle;
        this.penumbra = penumbra;
        this.decay = decay;
        this.map = null;
        this.shadow = new $d5b33d7c30034067$var$SpotLightShadow();
    }
    get power() {
        // compute the light's luminous power (in lumens) from its intensity (in candela)
        // by convention for a spotlight, luminous power (lm) = π * luminous intensity (cd)
        return this.intensity * Math.PI;
    }
    set power(power) {
        // set the light's intensity (in candela) from the desired luminous power (in lumens)
        this.intensity = power / Math.PI;
    }
    dispose() {
        this.shadow.dispose();
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.distance = source.distance;
        this.angle = source.angle;
        this.penumbra = source.penumbra;
        this.decay = source.decay;
        this.target = source.target.clone();
        this.shadow = source.shadow.clone();
        return this;
    }
}
const $d5b33d7c30034067$var$_projScreenMatrix = /*@__PURE__*/ new $d5b33d7c30034067$export$2ae72fc923e5eb5();
const $d5b33d7c30034067$var$_lightPositionWorld = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_lookTarget = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
class $d5b33d7c30034067$var$PointLightShadow extends $d5b33d7c30034067$var$LightShadow {
    constructor(){
        super(new $d5b33d7c30034067$export$74e4ae24825f68d7(90, 1, 0.5, 500));
        this.isPointLightShadow = true;
        this._frameExtents = new $d5b33d7c30034067$export$c977b3e384af9ae1(4, 2);
        this._viewportCount = 6;
        this._viewports = [
            // These viewports map a cube-map onto a 2D texture with the
            // following orientation:
            //
            //  xzXZ
            //   y Y
            //
            // X - Positive x direction
            // x - Negative x direction
            // Y - Positive y direction
            // y - Negative y direction
            // Z - Positive z direction
            // z - Negative z direction
            // positive X
            new $d5b33d7c30034067$export$fa7daccca11cdbe3(2, 1, 1, 1),
            // negative X
            new $d5b33d7c30034067$export$fa7daccca11cdbe3(0, 1, 1, 1),
            // positive Z
            new $d5b33d7c30034067$export$fa7daccca11cdbe3(3, 1, 1, 1),
            // negative Z
            new $d5b33d7c30034067$export$fa7daccca11cdbe3(1, 1, 1, 1),
            // positive Y
            new $d5b33d7c30034067$export$fa7daccca11cdbe3(3, 0, 1, 1),
            // negative Y
            new $d5b33d7c30034067$export$fa7daccca11cdbe3(1, 0, 1, 1)
        ];
        this._cubeDirections = [
            new $d5b33d7c30034067$export$64b5c384219d3699(1, 0, 0),
            new $d5b33d7c30034067$export$64b5c384219d3699(-1, 0, 0),
            new $d5b33d7c30034067$export$64b5c384219d3699(0, 0, 1),
            new $d5b33d7c30034067$export$64b5c384219d3699(0, 0, -1),
            new $d5b33d7c30034067$export$64b5c384219d3699(0, 1, 0),
            new $d5b33d7c30034067$export$64b5c384219d3699(0, -1, 0)
        ];
        this._cubeUps = [
            new $d5b33d7c30034067$export$64b5c384219d3699(0, 1, 0),
            new $d5b33d7c30034067$export$64b5c384219d3699(0, 1, 0),
            new $d5b33d7c30034067$export$64b5c384219d3699(0, 1, 0),
            new $d5b33d7c30034067$export$64b5c384219d3699(0, 1, 0),
            new $d5b33d7c30034067$export$64b5c384219d3699(0, 0, 1),
            new $d5b33d7c30034067$export$64b5c384219d3699(0, 0, -1)
        ];
    }
    updateMatrices(light, viewportIndex = 0) {
        const camera = this.camera;
        const shadowMatrix = this.matrix;
        const far = light.distance || camera.far;
        if (far !== camera.far) {
            camera.far = far;
            camera.updateProjectionMatrix();
        }
        $d5b33d7c30034067$var$_lightPositionWorld.setFromMatrixPosition(light.matrixWorld);
        camera.position.copy($d5b33d7c30034067$var$_lightPositionWorld);
        $d5b33d7c30034067$var$_lookTarget.copy(camera.position);
        $d5b33d7c30034067$var$_lookTarget.add(this._cubeDirections[viewportIndex]);
        camera.up.copy(this._cubeUps[viewportIndex]);
        camera.lookAt($d5b33d7c30034067$var$_lookTarget);
        camera.updateMatrixWorld();
        shadowMatrix.makeTranslation(-$d5b33d7c30034067$var$_lightPositionWorld.x, -$d5b33d7c30034067$var$_lightPositionWorld.y, -$d5b33d7c30034067$var$_lightPositionWorld.z);
        $d5b33d7c30034067$var$_projScreenMatrix.multiplyMatrices(camera.projectionMatrix, camera.matrixWorldInverse);
        this._frustum.setFromProjectionMatrix($d5b33d7c30034067$var$_projScreenMatrix);
    }
}
class $d5b33d7c30034067$export$4c9c1cb3f0b6f455 extends $d5b33d7c30034067$export$6ecadb6ed240d696 {
    constructor(color, intensity, distance = 0, decay = 2){
        super(color, intensity);
        this.isPointLight = true;
        this.type = 'PointLight';
        this.distance = distance;
        this.decay = decay;
        this.shadow = new $d5b33d7c30034067$var$PointLightShadow();
    }
    get power() {
        // compute the light's luminous power (in lumens) from its intensity (in candela)
        // for an isotropic light source, luminous power (lm) = 4 π luminous intensity (cd)
        return this.intensity * 4 * Math.PI;
    }
    set power(power) {
        // set the light's intensity (in candela) from the desired luminous power (in lumens)
        this.intensity = power / (4 * Math.PI);
    }
    dispose() {
        this.shadow.dispose();
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.distance = source.distance;
        this.decay = source.decay;
        this.shadow = source.shadow.clone();
        return this;
    }
}
class $d5b33d7c30034067$var$DirectionalLightShadow extends $d5b33d7c30034067$var$LightShadow {
    constructor(){
        super(new $d5b33d7c30034067$export$9ebf355ee4ed261b(-5, 5, 5, -5, 0.5, 500));
        this.isDirectionalLightShadow = true;
    }
}
class $d5b33d7c30034067$export$3fea33cc9972c868 extends $d5b33d7c30034067$export$6ecadb6ed240d696 {
    constructor(color, intensity){
        super(color, intensity);
        this.isDirectionalLight = true;
        this.type = 'DirectionalLight';
        this.position.copy($d5b33d7c30034067$export$e4dd07dff30cc924.DEFAULT_UP);
        this.updateMatrix();
        this.target = new $d5b33d7c30034067$export$e4dd07dff30cc924();
        this.shadow = new $d5b33d7c30034067$var$DirectionalLightShadow();
    }
    dispose() {
        this.shadow.dispose();
    }
    copy(source) {
        super.copy(source);
        this.target = source.target.clone();
        this.shadow = source.shadow.clone();
        return this;
    }
}
class $d5b33d7c30034067$export$af279bfef9ec2c96 extends $d5b33d7c30034067$export$6ecadb6ed240d696 {
    constructor(color, intensity){
        super(color, intensity);
        this.isAmbientLight = true;
        this.type = 'AmbientLight';
    }
}
class $d5b33d7c30034067$export$61db2d908bbd2429 extends $d5b33d7c30034067$export$6ecadb6ed240d696 {
    constructor(color, intensity, width = 10, height = 10){
        super(color, intensity);
        this.isRectAreaLight = true;
        this.type = 'RectAreaLight';
        this.width = width;
        this.height = height;
    }
    get power() {
        // compute the light's luminous power (in lumens) from its intensity (in nits)
        return this.intensity * this.width * this.height * Math.PI;
    }
    set power(power) {
        // set the light's intensity (in nits) from the desired luminous power (in lumens)
        this.intensity = power / (this.width * this.height * Math.PI);
    }
    copy(source) {
        super.copy(source);
        this.width = source.width;
        this.height = source.height;
        return this;
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.object.width = this.width;
        data.object.height = this.height;
        return data;
    }
}
/**
 * Primary reference:
 *   https://graphics.stanford.edu/papers/envmap/envmap.pdf
 *
 * Secondary reference:
 *   https://www.ppsloan.org/publications/StupidSH36.pdf
 */ // 3-band SH defined by 9 coefficients
class $d5b33d7c30034067$export$ba61ce607e1f405a {
    constructor(){
        this.isSphericalHarmonics3 = true;
        this.coefficients = [];
        for(let i = 0; i < 9; i++)this.coefficients.push(new $d5b33d7c30034067$export$64b5c384219d3699());
    }
    set(coefficients) {
        for(let i = 0; i < 9; i++)this.coefficients[i].copy(coefficients[i]);
        return this;
    }
    zero() {
        for(let i = 0; i < 9; i++)this.coefficients[i].set(0, 0, 0);
        return this;
    }
    // get the radiance in the direction of the normal
    // target is a Vector3
    getAt(normal, target) {
        // normal is assumed to be unit length
        const x = normal.x, y = normal.y, z = normal.z;
        const coeff = this.coefficients;
        // band 0
        target.copy(coeff[0]).multiplyScalar(0.282095);
        // band 1
        target.addScaledVector(coeff[1], 0.488603 * y);
        target.addScaledVector(coeff[2], 0.488603 * z);
        target.addScaledVector(coeff[3], 0.488603 * x);
        // band 2
        target.addScaledVector(coeff[4], 1.092548 * (x * y));
        target.addScaledVector(coeff[5], 1.092548 * (y * z));
        target.addScaledVector(coeff[6], 0.315392 * (3.0 * z * z - 1.0));
        target.addScaledVector(coeff[7], 1.092548 * (x * z));
        target.addScaledVector(coeff[8], 0.546274 * (x * x - y * y));
        return target;
    }
    // get the irradiance (radiance convolved with cosine lobe) in the direction of the normal
    // target is a Vector3
    // https://graphics.stanford.edu/papers/envmap/envmap.pdf
    getIrradianceAt(normal, target) {
        // normal is assumed to be unit length
        const x = normal.x, y = normal.y, z = normal.z;
        const coeff = this.coefficients;
        // band 0
        target.copy(coeff[0]).multiplyScalar(0.886227); // π * 0.282095
        // band 1
        target.addScaledVector(coeff[1], 1.023328 * y); // ( 2 * π / 3 ) * 0.488603
        target.addScaledVector(coeff[2], 1.023328 * z);
        target.addScaledVector(coeff[3], 1.023328 * x);
        // band 2
        target.addScaledVector(coeff[4], 0.858086 * x * y); // ( π / 4 ) * 1.092548
        target.addScaledVector(coeff[5], 0.858086 * y * z);
        target.addScaledVector(coeff[6], 0.743125 * z * z - 0.247708); // ( π / 4 ) * 0.315392 * 3
        target.addScaledVector(coeff[7], 0.858086 * x * z);
        target.addScaledVector(coeff[8], 0.429043 * (x * x - y * y)); // ( π / 4 ) * 0.546274
        return target;
    }
    add(sh) {
        for(let i = 0; i < 9; i++)this.coefficients[i].add(sh.coefficients[i]);
        return this;
    }
    addScaledSH(sh, s) {
        for(let i = 0; i < 9; i++)this.coefficients[i].addScaledVector(sh.coefficients[i], s);
        return this;
    }
    scale(s) {
        for(let i = 0; i < 9; i++)this.coefficients[i].multiplyScalar(s);
        return this;
    }
    lerp(sh, alpha) {
        for(let i = 0; i < 9; i++)this.coefficients[i].lerp(sh.coefficients[i], alpha);
        return this;
    }
    equals(sh) {
        for(let i = 0; i < 9; i++){
            if (!this.coefficients[i].equals(sh.coefficients[i])) return false;
        }
        return true;
    }
    copy(sh) {
        return this.set(sh.coefficients);
    }
    clone() {
        return new this.constructor().copy(this);
    }
    fromArray(array, offset = 0) {
        const coefficients = this.coefficients;
        for(let i = 0; i < 9; i++)coefficients[i].fromArray(array, offset + i * 3);
        return this;
    }
    toArray(array = [], offset = 0) {
        const coefficients = this.coefficients;
        for(let i = 0; i < 9; i++)coefficients[i].toArray(array, offset + i * 3);
        return array;
    }
    // evaluate the basis functions
    // shBasis is an Array[ 9 ]
    static getBasisAt(normal, shBasis) {
        // normal is assumed to be unit length
        const x = normal.x, y = normal.y, z = normal.z;
        // band 0
        shBasis[0] = 0.282095;
        // band 1
        shBasis[1] = 0.488603 * y;
        shBasis[2] = 0.488603 * z;
        shBasis[3] = 0.488603 * x;
        // band 2
        shBasis[4] = 1.092548 * x * y;
        shBasis[5] = 1.092548 * y * z;
        shBasis[6] = 0.315392 * (3 * z * z - 1);
        shBasis[7] = 1.092548 * x * z;
        shBasis[8] = 0.546274 * (x * x - y * y);
    }
}
class $d5b33d7c30034067$export$e7ef036e309b38d2 extends $d5b33d7c30034067$export$6ecadb6ed240d696 {
    constructor(sh = new $d5b33d7c30034067$export$ba61ce607e1f405a(), intensity = 1){
        super(undefined, intensity);
        this.isLightProbe = true;
        this.sh = sh;
    }
    copy(source) {
        super.copy(source);
        this.sh.copy(source.sh);
        return this;
    }
    fromJSON(json) {
        this.intensity = json.intensity; // TODO: Move this bit to Light.fromJSON();
        this.sh.fromArray(json.sh);
        return this;
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.object.sh = this.sh.toArray();
        return data;
    }
}
class $d5b33d7c30034067$export$3bd6d323353dcf96 extends $d5b33d7c30034067$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
        this.textures = {};
    }
    load(url, onLoad, onProgress, onError) {
        const scope = this;
        const loader = new $d5b33d7c30034067$export$98435a25b5cf7b2b(scope.manager);
        loader.setPath(scope.path);
        loader.setRequestHeader(scope.requestHeader);
        loader.setWithCredentials(scope.withCredentials);
        loader.load(url, function(text) {
            try {
                onLoad(scope.parse(JSON.parse(text)));
            } catch (e) {
                if (onError) onError(e);
                else console.error(e);
                scope.manager.itemError(url);
            }
        }, onProgress, onError);
    }
    parse(json) {
        const textures = this.textures;
        function getTexture(name) {
            if (textures[name] === undefined) console.warn('THREE.MaterialLoader: Undefined texture', name);
            return textures[name];
        }
        const material = this.createMaterialFromType(json.type);
        if (json.uuid !== undefined) material.uuid = json.uuid;
        if (json.name !== undefined) material.name = json.name;
        if (json.color !== undefined && material.color !== undefined) material.color.setHex(json.color);
        if (json.roughness !== undefined) material.roughness = json.roughness;
        if (json.metalness !== undefined) material.metalness = json.metalness;
        if (json.sheen !== undefined) material.sheen = json.sheen;
        if (json.sheenColor !== undefined) material.sheenColor = new $d5b33d7c30034067$export$892596cec99bc70e().setHex(json.sheenColor);
        if (json.sheenRoughness !== undefined) material.sheenRoughness = json.sheenRoughness;
        if (json.emissive !== undefined && material.emissive !== undefined) material.emissive.setHex(json.emissive);
        if (json.specular !== undefined && material.specular !== undefined) material.specular.setHex(json.specular);
        if (json.specularIntensity !== undefined) material.specularIntensity = json.specularIntensity;
        if (json.specularColor !== undefined && material.specularColor !== undefined) material.specularColor.setHex(json.specularColor);
        if (json.shininess !== undefined) material.shininess = json.shininess;
        if (json.clearcoat !== undefined) material.clearcoat = json.clearcoat;
        if (json.clearcoatRoughness !== undefined) material.clearcoatRoughness = json.clearcoatRoughness;
        if (json.dispersion !== undefined) material.dispersion = json.dispersion;
        if (json.iridescence !== undefined) material.iridescence = json.iridescence;
        if (json.iridescenceIOR !== undefined) material.iridescenceIOR = json.iridescenceIOR;
        if (json.iridescenceThicknessRange !== undefined) material.iridescenceThicknessRange = json.iridescenceThicknessRange;
        if (json.transmission !== undefined) material.transmission = json.transmission;
        if (json.thickness !== undefined) material.thickness = json.thickness;
        if (json.attenuationDistance !== undefined) material.attenuationDistance = json.attenuationDistance;
        if (json.attenuationColor !== undefined && material.attenuationColor !== undefined) material.attenuationColor.setHex(json.attenuationColor);
        if (json.anisotropy !== undefined) material.anisotropy = json.anisotropy;
        if (json.anisotropyRotation !== undefined) material.anisotropyRotation = json.anisotropyRotation;
        if (json.fog !== undefined) material.fog = json.fog;
        if (json.flatShading !== undefined) material.flatShading = json.flatShading;
        if (json.blending !== undefined) material.blending = json.blending;
        if (json.combine !== undefined) material.combine = json.combine;
        if (json.side !== undefined) material.side = json.side;
        if (json.shadowSide !== undefined) material.shadowSide = json.shadowSide;
        if (json.opacity !== undefined) material.opacity = json.opacity;
        if (json.transparent !== undefined) material.transparent = json.transparent;
        if (json.alphaTest !== undefined) material.alphaTest = json.alphaTest;
        if (json.alphaHash !== undefined) material.alphaHash = json.alphaHash;
        if (json.depthFunc !== undefined) material.depthFunc = json.depthFunc;
        if (json.depthTest !== undefined) material.depthTest = json.depthTest;
        if (json.depthWrite !== undefined) material.depthWrite = json.depthWrite;
        if (json.colorWrite !== undefined) material.colorWrite = json.colorWrite;
        if (json.blendSrc !== undefined) material.blendSrc = json.blendSrc;
        if (json.blendDst !== undefined) material.blendDst = json.blendDst;
        if (json.blendEquation !== undefined) material.blendEquation = json.blendEquation;
        if (json.blendSrcAlpha !== undefined) material.blendSrcAlpha = json.blendSrcAlpha;
        if (json.blendDstAlpha !== undefined) material.blendDstAlpha = json.blendDstAlpha;
        if (json.blendEquationAlpha !== undefined) material.blendEquationAlpha = json.blendEquationAlpha;
        if (json.blendColor !== undefined && material.blendColor !== undefined) material.blendColor.setHex(json.blendColor);
        if (json.blendAlpha !== undefined) material.blendAlpha = json.blendAlpha;
        if (json.stencilWriteMask !== undefined) material.stencilWriteMask = json.stencilWriteMask;
        if (json.stencilFunc !== undefined) material.stencilFunc = json.stencilFunc;
        if (json.stencilRef !== undefined) material.stencilRef = json.stencilRef;
        if (json.stencilFuncMask !== undefined) material.stencilFuncMask = json.stencilFuncMask;
        if (json.stencilFail !== undefined) material.stencilFail = json.stencilFail;
        if (json.stencilZFail !== undefined) material.stencilZFail = json.stencilZFail;
        if (json.stencilZPass !== undefined) material.stencilZPass = json.stencilZPass;
        if (json.stencilWrite !== undefined) material.stencilWrite = json.stencilWrite;
        if (json.wireframe !== undefined) material.wireframe = json.wireframe;
        if (json.wireframeLinewidth !== undefined) material.wireframeLinewidth = json.wireframeLinewidth;
        if (json.wireframeLinecap !== undefined) material.wireframeLinecap = json.wireframeLinecap;
        if (json.wireframeLinejoin !== undefined) material.wireframeLinejoin = json.wireframeLinejoin;
        if (json.rotation !== undefined) material.rotation = json.rotation;
        if (json.linewidth !== undefined) material.linewidth = json.linewidth;
        if (json.dashSize !== undefined) material.dashSize = json.dashSize;
        if (json.gapSize !== undefined) material.gapSize = json.gapSize;
        if (json.scale !== undefined) material.scale = json.scale;
        if (json.polygonOffset !== undefined) material.polygonOffset = json.polygonOffset;
        if (json.polygonOffsetFactor !== undefined) material.polygonOffsetFactor = json.polygonOffsetFactor;
        if (json.polygonOffsetUnits !== undefined) material.polygonOffsetUnits = json.polygonOffsetUnits;
        if (json.dithering !== undefined) material.dithering = json.dithering;
        if (json.alphaToCoverage !== undefined) material.alphaToCoverage = json.alphaToCoverage;
        if (json.premultipliedAlpha !== undefined) material.premultipliedAlpha = json.premultipliedAlpha;
        if (json.forceSinglePass !== undefined) material.forceSinglePass = json.forceSinglePass;
        if (json.visible !== undefined) material.visible = json.visible;
        if (json.toneMapped !== undefined) material.toneMapped = json.toneMapped;
        if (json.userData !== undefined) material.userData = json.userData;
        if (json.vertexColors !== undefined) {
            if (typeof json.vertexColors === 'number') material.vertexColors = json.vertexColors > 0 ? true : false;
            else material.vertexColors = json.vertexColors;
        }
        // Shader Material
        if (json.uniforms !== undefined) for(const name in json.uniforms){
            const uniform = json.uniforms[name];
            material.uniforms[name] = {};
            switch(uniform.type){
                case 't':
                    material.uniforms[name].value = getTexture(uniform.value);
                    break;
                case 'c':
                    material.uniforms[name].value = new $d5b33d7c30034067$export$892596cec99bc70e().setHex(uniform.value);
                    break;
                case 'v2':
                    material.uniforms[name].value = new $d5b33d7c30034067$export$c977b3e384af9ae1().fromArray(uniform.value);
                    break;
                case 'v3':
                    material.uniforms[name].value = new $d5b33d7c30034067$export$64b5c384219d3699().fromArray(uniform.value);
                    break;
                case 'v4':
                    material.uniforms[name].value = new $d5b33d7c30034067$export$fa7daccca11cdbe3().fromArray(uniform.value);
                    break;
                case 'm3':
                    material.uniforms[name].value = new $d5b33d7c30034067$export$8ff26dafa08918().fromArray(uniform.value);
                    break;
                case 'm4':
                    material.uniforms[name].value = new $d5b33d7c30034067$export$2ae72fc923e5eb5().fromArray(uniform.value);
                    break;
                default:
                    material.uniforms[name].value = uniform.value;
            }
        }
        if (json.defines !== undefined) material.defines = json.defines;
        if (json.vertexShader !== undefined) material.vertexShader = json.vertexShader;
        if (json.fragmentShader !== undefined) material.fragmentShader = json.fragmentShader;
        if (json.glslVersion !== undefined) material.glslVersion = json.glslVersion;
        if (json.extensions !== undefined) for(const key in json.extensions)material.extensions[key] = json.extensions[key];
        if (json.lights !== undefined) material.lights = json.lights;
        if (json.clipping !== undefined) material.clipping = json.clipping;
        // for PointsMaterial
        if (json.size !== undefined) material.size = json.size;
        if (json.sizeAttenuation !== undefined) material.sizeAttenuation = json.sizeAttenuation;
        // maps
        if (json.map !== undefined) material.map = getTexture(json.map);
        if (json.matcap !== undefined) material.matcap = getTexture(json.matcap);
        if (json.alphaMap !== undefined) material.alphaMap = getTexture(json.alphaMap);
        if (json.bumpMap !== undefined) material.bumpMap = getTexture(json.bumpMap);
        if (json.bumpScale !== undefined) material.bumpScale = json.bumpScale;
        if (json.normalMap !== undefined) material.normalMap = getTexture(json.normalMap);
        if (json.normalMapType !== undefined) material.normalMapType = json.normalMapType;
        if (json.normalScale !== undefined) {
            let normalScale = json.normalScale;
            if (Array.isArray(normalScale) === false) // Blender exporter used to export a scalar. See #7459
            normalScale = [
                normalScale,
                normalScale
            ];
            material.normalScale = new $d5b33d7c30034067$export$c977b3e384af9ae1().fromArray(normalScale);
        }
        if (json.displacementMap !== undefined) material.displacementMap = getTexture(json.displacementMap);
        if (json.displacementScale !== undefined) material.displacementScale = json.displacementScale;
        if (json.displacementBias !== undefined) material.displacementBias = json.displacementBias;
        if (json.roughnessMap !== undefined) material.roughnessMap = getTexture(json.roughnessMap);
        if (json.metalnessMap !== undefined) material.metalnessMap = getTexture(json.metalnessMap);
        if (json.emissiveMap !== undefined) material.emissiveMap = getTexture(json.emissiveMap);
        if (json.emissiveIntensity !== undefined) material.emissiveIntensity = json.emissiveIntensity;
        if (json.specularMap !== undefined) material.specularMap = getTexture(json.specularMap);
        if (json.specularIntensityMap !== undefined) material.specularIntensityMap = getTexture(json.specularIntensityMap);
        if (json.specularColorMap !== undefined) material.specularColorMap = getTexture(json.specularColorMap);
        if (json.envMap !== undefined) material.envMap = getTexture(json.envMap);
        if (json.envMapRotation !== undefined) material.envMapRotation.fromArray(json.envMapRotation);
        if (json.envMapIntensity !== undefined) material.envMapIntensity = json.envMapIntensity;
        if (json.reflectivity !== undefined) material.reflectivity = json.reflectivity;
        if (json.refractionRatio !== undefined) material.refractionRatio = json.refractionRatio;
        if (json.lightMap !== undefined) material.lightMap = getTexture(json.lightMap);
        if (json.lightMapIntensity !== undefined) material.lightMapIntensity = json.lightMapIntensity;
        if (json.aoMap !== undefined) material.aoMap = getTexture(json.aoMap);
        if (json.aoMapIntensity !== undefined) material.aoMapIntensity = json.aoMapIntensity;
        if (json.gradientMap !== undefined) material.gradientMap = getTexture(json.gradientMap);
        if (json.clearcoatMap !== undefined) material.clearcoatMap = getTexture(json.clearcoatMap);
        if (json.clearcoatRoughnessMap !== undefined) material.clearcoatRoughnessMap = getTexture(json.clearcoatRoughnessMap);
        if (json.clearcoatNormalMap !== undefined) material.clearcoatNormalMap = getTexture(json.clearcoatNormalMap);
        if (json.clearcoatNormalScale !== undefined) material.clearcoatNormalScale = new $d5b33d7c30034067$export$c977b3e384af9ae1().fromArray(json.clearcoatNormalScale);
        if (json.iridescenceMap !== undefined) material.iridescenceMap = getTexture(json.iridescenceMap);
        if (json.iridescenceThicknessMap !== undefined) material.iridescenceThicknessMap = getTexture(json.iridescenceThicknessMap);
        if (json.transmissionMap !== undefined) material.transmissionMap = getTexture(json.transmissionMap);
        if (json.thicknessMap !== undefined) material.thicknessMap = getTexture(json.thicknessMap);
        if (json.anisotropyMap !== undefined) material.anisotropyMap = getTexture(json.anisotropyMap);
        if (json.sheenColorMap !== undefined) material.sheenColorMap = getTexture(json.sheenColorMap);
        if (json.sheenRoughnessMap !== undefined) material.sheenRoughnessMap = getTexture(json.sheenRoughnessMap);
        return material;
    }
    setTextures(value) {
        this.textures = value;
        return this;
    }
    createMaterialFromType(type) {
        return $d5b33d7c30034067$export$3bd6d323353dcf96.createMaterialFromType(type);
    }
    static createMaterialFromType(type) {
        const materialLib = {
            ShadowMaterial: $d5b33d7c30034067$export$e8564da406055a3,
            SpriteMaterial: $d5b33d7c30034067$export$5ec7dd1c6994bf8e,
            RawShaderMaterial: $d5b33d7c30034067$export$21c421a2e1df9d22,
            ShaderMaterial: $d5b33d7c30034067$export$83c7d75d550a8b0d,
            PointsMaterial: $d5b33d7c30034067$export$a178c45366ce5d6b,
            MeshPhysicalMaterial: $d5b33d7c30034067$export$28d04986c4269c9f,
            MeshStandardMaterial: $d5b33d7c30034067$export$f2980790215acccd,
            MeshPhongMaterial: $d5b33d7c30034067$export$24c72f71cbaf0678,
            MeshToonMaterial: $d5b33d7c30034067$export$df893cf97e765622,
            MeshNormalMaterial: $d5b33d7c30034067$export$bfe8c0a091f41ae7,
            MeshLambertMaterial: $d5b33d7c30034067$export$5023a9a8114806b8,
            MeshDepthMaterial: $d5b33d7c30034067$export$2698c22ec13825db,
            MeshDistanceMaterial: $d5b33d7c30034067$export$33e187ed002f2a19,
            MeshBasicMaterial: $d5b33d7c30034067$export$55cbcc9b622fe1f5,
            MeshMatcapMaterial: $d5b33d7c30034067$export$6f5fef6235ec12ee,
            LineDashedMaterial: $d5b33d7c30034067$export$327886a3efaeaebe,
            LineBasicMaterial: $d5b33d7c30034067$export$fbaaa33907730a0c,
            Material: $d5b33d7c30034067$export$a2d8b23205c25948
        };
        return new materialLib[type]();
    }
}
class $d5b33d7c30034067$export$b5d2dc08d867e41a {
    static decodeText(array) {
        console.warn('THREE.LoaderUtils: decodeText() has been deprecated with r165 and will be removed with r175. Use TextDecoder instead.');
        if (typeof TextDecoder !== 'undefined') return new TextDecoder().decode(array);
        // Avoid the String.fromCharCode.apply(null, array) shortcut, which
        // throws a "maximum call stack size exceeded" error for large arrays.
        let s = '';
        for(let i = 0, il = array.length; i < il; i++)// Implicitly assumes little-endian.
        s += String.fromCharCode(array[i]);
        try {
            // merges multi-byte utf-8 characters.
            return decodeURIComponent(escape(s));
        } catch (e) {
            return s;
        }
    }
    static extractUrlBase(url) {
        const index = url.lastIndexOf('/');
        if (index === -1) return './';
        return url.slice(0, index + 1);
    }
    static resolveURL(url, path) {
        // Invalid URL
        if (typeof url !== 'string' || url === '') return '';
        // Host Relative URL
        if (/^https?:\/\//i.test(path) && /^\//.test(url)) path = path.replace(/(^https?:\/\/[^\/]+).*/i, '$1');
        // Absolute URL http://,https://,//
        if (/^(https?:)?\/\//i.test(url)) return url;
        // Data URI
        if (/^data:.*,.*$/i.test(url)) return url;
        // Blob URL
        if (/^blob:.*$/i.test(url)) return url;
        // Relative URL
        return path + url;
    }
}
class $d5b33d7c30034067$export$231f009cbe414146 extends $d5b33d7c30034067$export$b7be63a67df8959 {
    constructor(){
        super();
        this.isInstancedBufferGeometry = true;
        this.type = 'InstancedBufferGeometry';
        this.instanceCount = Infinity;
    }
    copy(source) {
        super.copy(source);
        this.instanceCount = source.instanceCount;
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.instanceCount = this.instanceCount;
        data.isInstancedBufferGeometry = true;
        return data;
    }
}
class $d5b33d7c30034067$export$dc275bb96327833a extends $d5b33d7c30034067$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(url, onLoad, onProgress, onError) {
        const scope = this;
        const loader = new $d5b33d7c30034067$export$98435a25b5cf7b2b(scope.manager);
        loader.setPath(scope.path);
        loader.setRequestHeader(scope.requestHeader);
        loader.setWithCredentials(scope.withCredentials);
        loader.load(url, function(text) {
            try {
                onLoad(scope.parse(JSON.parse(text)));
            } catch (e) {
                if (onError) onError(e);
                else console.error(e);
                scope.manager.itemError(url);
            }
        }, onProgress, onError);
    }
    parse(json) {
        const interleavedBufferMap = {};
        const arrayBufferMap = {};
        function getInterleavedBuffer(json, uuid) {
            if (interleavedBufferMap[uuid] !== undefined) return interleavedBufferMap[uuid];
            const interleavedBuffers = json.interleavedBuffers;
            const interleavedBuffer = interleavedBuffers[uuid];
            const buffer = getArrayBuffer(json, interleavedBuffer.buffer);
            const array = $d5b33d7c30034067$var$getTypedArray(interleavedBuffer.type, buffer);
            const ib = new $d5b33d7c30034067$export$3d5cd879f108f53f(array, interleavedBuffer.stride);
            ib.uuid = interleavedBuffer.uuid;
            interleavedBufferMap[uuid] = ib;
            return ib;
        }
        function getArrayBuffer(json, uuid) {
            if (arrayBufferMap[uuid] !== undefined) return arrayBufferMap[uuid];
            const arrayBuffers = json.arrayBuffers;
            const arrayBuffer = arrayBuffers[uuid];
            const ab = new Uint32Array(arrayBuffer).buffer;
            arrayBufferMap[uuid] = ab;
            return ab;
        }
        const geometry = json.isInstancedBufferGeometry ? new $d5b33d7c30034067$export$231f009cbe414146() : new $d5b33d7c30034067$export$b7be63a67df8959();
        const index = json.data.index;
        if (index !== undefined) {
            const typedArray = $d5b33d7c30034067$var$getTypedArray(index.type, index.array);
            geometry.setIndex(new $d5b33d7c30034067$export$8dea267bd6bde117(typedArray, 1));
        }
        const attributes = json.data.attributes;
        for(const key in attributes){
            const attribute = attributes[key];
            let bufferAttribute;
            if (attribute.isInterleavedBufferAttribute) {
                const interleavedBuffer = getInterleavedBuffer(json.data, attribute.data);
                bufferAttribute = new $d5b33d7c30034067$export$920b6d07334599c7(interleavedBuffer, attribute.itemSize, attribute.offset, attribute.normalized);
            } else {
                const typedArray = $d5b33d7c30034067$var$getTypedArray(attribute.type, attribute.array);
                const bufferAttributeConstr = attribute.isInstancedBufferAttribute ? $d5b33d7c30034067$export$32ea87a8b54d744a : $d5b33d7c30034067$export$8dea267bd6bde117;
                bufferAttribute = new bufferAttributeConstr(typedArray, attribute.itemSize, attribute.normalized);
            }
            if (attribute.name !== undefined) bufferAttribute.name = attribute.name;
            if (attribute.usage !== undefined) bufferAttribute.setUsage(attribute.usage);
            geometry.setAttribute(key, bufferAttribute);
        }
        const morphAttributes = json.data.morphAttributes;
        if (morphAttributes) for(const key in morphAttributes){
            const attributeArray = morphAttributes[key];
            const array = [];
            for(let i = 0, il = attributeArray.length; i < il; i++){
                const attribute = attributeArray[i];
                let bufferAttribute;
                if (attribute.isInterleavedBufferAttribute) {
                    const interleavedBuffer = getInterleavedBuffer(json.data, attribute.data);
                    bufferAttribute = new $d5b33d7c30034067$export$920b6d07334599c7(interleavedBuffer, attribute.itemSize, attribute.offset, attribute.normalized);
                } else {
                    const typedArray = $d5b33d7c30034067$var$getTypedArray(attribute.type, attribute.array);
                    bufferAttribute = new $d5b33d7c30034067$export$8dea267bd6bde117(typedArray, attribute.itemSize, attribute.normalized);
                }
                if (attribute.name !== undefined) bufferAttribute.name = attribute.name;
                array.push(bufferAttribute);
            }
            geometry.morphAttributes[key] = array;
        }
        const morphTargetsRelative = json.data.morphTargetsRelative;
        if (morphTargetsRelative) geometry.morphTargetsRelative = true;
        const groups = json.data.groups || json.data.drawcalls || json.data.offsets;
        if (groups !== undefined) for(let i = 0, n = groups.length; i !== n; ++i){
            const group = groups[i];
            geometry.addGroup(group.start, group.count, group.materialIndex);
        }
        const boundingSphere = json.data.boundingSphere;
        if (boundingSphere !== undefined) {
            const center = new $d5b33d7c30034067$export$64b5c384219d3699();
            if (boundingSphere.center !== undefined) center.fromArray(boundingSphere.center);
            geometry.boundingSphere = new $d5b33d7c30034067$export$805e8b72413ccaba(center, boundingSphere.radius);
        }
        if (json.name) geometry.name = json.name;
        if (json.userData) geometry.userData = json.userData;
        return geometry;
    }
}
class $d5b33d7c30034067$export$40110c8505c5ad19 extends $d5b33d7c30034067$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(url, onLoad, onProgress, onError) {
        const scope = this;
        const path = this.path === '' ? $d5b33d7c30034067$export$b5d2dc08d867e41a.extractUrlBase(url) : this.path;
        this.resourcePath = this.resourcePath || path;
        const loader = new $d5b33d7c30034067$export$98435a25b5cf7b2b(this.manager);
        loader.setPath(this.path);
        loader.setRequestHeader(this.requestHeader);
        loader.setWithCredentials(this.withCredentials);
        loader.load(url, function(text) {
            let json = null;
            try {
                json = JSON.parse(text);
            } catch (error) {
                if (onError !== undefined) onError(error);
                console.error('THREE:ObjectLoader: Can\'t parse ' + url + '.', error.message);
                return;
            }
            const metadata = json.metadata;
            if (metadata === undefined || metadata.type === undefined || metadata.type.toLowerCase() === 'geometry') {
                if (onError !== undefined) onError(new Error('THREE.ObjectLoader: Can\'t load ' + url));
                console.error('THREE.ObjectLoader: Can\'t load ' + url);
                return;
            }
            scope.parse(json, onLoad);
        }, onProgress, onError);
    }
    async loadAsync(url, onProgress) {
        const scope = this;
        const path = this.path === '' ? $d5b33d7c30034067$export$b5d2dc08d867e41a.extractUrlBase(url) : this.path;
        this.resourcePath = this.resourcePath || path;
        const loader = new $d5b33d7c30034067$export$98435a25b5cf7b2b(this.manager);
        loader.setPath(this.path);
        loader.setRequestHeader(this.requestHeader);
        loader.setWithCredentials(this.withCredentials);
        const text = await loader.loadAsync(url, onProgress);
        const json = JSON.parse(text);
        const metadata = json.metadata;
        if (metadata === undefined || metadata.type === undefined || metadata.type.toLowerCase() === 'geometry') throw new Error('THREE.ObjectLoader: Can\'t load ' + url);
        return await scope.parseAsync(json);
    }
    parse(json, onLoad) {
        const animations = this.parseAnimations(json.animations);
        const shapes = this.parseShapes(json.shapes);
        const geometries = this.parseGeometries(json.geometries, shapes);
        const images = this.parseImages(json.images, function() {
            if (onLoad !== undefined) onLoad(object);
        });
        const textures = this.parseTextures(json.textures, images);
        const materials = this.parseMaterials(json.materials, textures);
        const object = this.parseObject(json.object, geometries, materials, textures, animations);
        const skeletons = this.parseSkeletons(json.skeletons, object);
        this.bindSkeletons(object, skeletons);
        this.bindLightTargets(object);
        //
        if (onLoad !== undefined) {
            let hasImages = false;
            for(const uuid in images)if (images[uuid].data instanceof HTMLImageElement) {
                hasImages = true;
                break;
            }
            if (hasImages === false) onLoad(object);
        }
        return object;
    }
    async parseAsync(json) {
        const animations = this.parseAnimations(json.animations);
        const shapes = this.parseShapes(json.shapes);
        const geometries = this.parseGeometries(json.geometries, shapes);
        const images = await this.parseImagesAsync(json.images);
        const textures = this.parseTextures(json.textures, images);
        const materials = this.parseMaterials(json.materials, textures);
        const object = this.parseObject(json.object, geometries, materials, textures, animations);
        const skeletons = this.parseSkeletons(json.skeletons, object);
        this.bindSkeletons(object, skeletons);
        this.bindLightTargets(object);
        return object;
    }
    parseShapes(json) {
        const shapes = {};
        if (json !== undefined) for(let i = 0, l = json.length; i < l; i++){
            const shape = new $d5b33d7c30034067$export$6428a7f2611ef1fa().fromJSON(json[i]);
            shapes[shape.uuid] = shape;
        }
        return shapes;
    }
    parseSkeletons(json, object) {
        const skeletons = {};
        const bones = {};
        // generate bone lookup table
        object.traverse(function(child) {
            if (child.isBone) bones[child.uuid] = child;
        });
        // create skeletons
        if (json !== undefined) for(let i = 0, l = json.length; i < l; i++){
            const skeleton = new $d5b33d7c30034067$export$8f31e4c4a37b8e9c().fromJSON(json[i], bones);
            skeletons[skeleton.uuid] = skeleton;
        }
        return skeletons;
    }
    parseGeometries(json, shapes) {
        const geometries = {};
        if (json !== undefined) {
            const bufferGeometryLoader = new $d5b33d7c30034067$export$dc275bb96327833a();
            for(let i = 0, l = json.length; i < l; i++){
                let geometry;
                const data = json[i];
                switch(data.type){
                    case 'BufferGeometry':
                    case 'InstancedBufferGeometry':
                        geometry = bufferGeometryLoader.parse(data);
                        break;
                    default:
                        if (data.type in $d5b33d7c30034067$var$Geometries) geometry = $d5b33d7c30034067$var$Geometries[data.type].fromJSON(data, shapes);
                        else console.warn(`THREE.ObjectLoader: Unsupported geometry type "${data.type}"`);
                }
                geometry.uuid = data.uuid;
                if (data.name !== undefined) geometry.name = data.name;
                if (data.userData !== undefined) geometry.userData = data.userData;
                geometries[data.uuid] = geometry;
            }
        }
        return geometries;
    }
    parseMaterials(json, textures) {
        const cache = {}; // MultiMaterial
        const materials = {};
        if (json !== undefined) {
            const loader = new $d5b33d7c30034067$export$3bd6d323353dcf96();
            loader.setTextures(textures);
            for(let i = 0, l = json.length; i < l; i++){
                const data = json[i];
                if (cache[data.uuid] === undefined) cache[data.uuid] = loader.parse(data);
                materials[data.uuid] = cache[data.uuid];
            }
        }
        return materials;
    }
    parseAnimations(json) {
        const animations = {};
        if (json !== undefined) for(let i = 0; i < json.length; i++){
            const data = json[i];
            const clip = $d5b33d7c30034067$export$d942c706bf23829c.parse(data);
            animations[clip.uuid] = clip;
        }
        return animations;
    }
    parseImages(json, onLoad) {
        const scope = this;
        const images = {};
        let loader;
        function loadImage(url) {
            scope.manager.itemStart(url);
            return loader.load(url, function() {
                scope.manager.itemEnd(url);
            }, undefined, function() {
                scope.manager.itemError(url);
                scope.manager.itemEnd(url);
            });
        }
        function deserializeImage(image) {
            if (typeof image === 'string') {
                const url = image;
                const path = /^(\/\/)|([a-z]+:(\/\/)?)/i.test(url) ? url : scope.resourcePath + url;
                return loadImage(path);
            } else {
                if (image.data) return {
                    data: $d5b33d7c30034067$var$getTypedArray(image.type, image.data),
                    width: image.width,
                    height: image.height
                };
                else return null;
            }
        }
        if (json !== undefined && json.length > 0) {
            const manager = new $d5b33d7c30034067$export$99cc795e99919eed(onLoad);
            loader = new $d5b33d7c30034067$export$8905ce1c7a2464a1(manager);
            loader.setCrossOrigin(this.crossOrigin);
            for(let i = 0, il = json.length; i < il; i++){
                const image = json[i];
                const url = image.url;
                if (Array.isArray(url)) {
                    // load array of images e.g CubeTexture
                    const imageArray = [];
                    for(let j = 0, jl = url.length; j < jl; j++){
                        const currentUrl = url[j];
                        const deserializedImage = deserializeImage(currentUrl);
                        if (deserializedImage !== null) {
                            if (deserializedImage instanceof HTMLImageElement) imageArray.push(deserializedImage);
                            else // special case: handle array of data textures for cube textures
                            imageArray.push(new $d5b33d7c30034067$export$b691f601014eabe1(deserializedImage.data, deserializedImage.width, deserializedImage.height));
                        }
                    }
                    images[image.uuid] = new $d5b33d7c30034067$export$1d2df86270c81ecb(imageArray);
                } else {
                    // load single image
                    const deserializedImage = deserializeImage(image.url);
                    images[image.uuid] = new $d5b33d7c30034067$export$1d2df86270c81ecb(deserializedImage);
                }
            }
        }
        return images;
    }
    async parseImagesAsync(json) {
        const scope = this;
        const images = {};
        let loader;
        async function deserializeImage(image) {
            if (typeof image === 'string') {
                const url = image;
                const path = /^(\/\/)|([a-z]+:(\/\/)?)/i.test(url) ? url : scope.resourcePath + url;
                return await loader.loadAsync(path);
            } else {
                if (image.data) return {
                    data: $d5b33d7c30034067$var$getTypedArray(image.type, image.data),
                    width: image.width,
                    height: image.height
                };
                else return null;
            }
        }
        if (json !== undefined && json.length > 0) {
            loader = new $d5b33d7c30034067$export$8905ce1c7a2464a1(this.manager);
            loader.setCrossOrigin(this.crossOrigin);
            for(let i = 0, il = json.length; i < il; i++){
                const image = json[i];
                const url = image.url;
                if (Array.isArray(url)) {
                    // load array of images e.g CubeTexture
                    const imageArray = [];
                    for(let j = 0, jl = url.length; j < jl; j++){
                        const currentUrl = url[j];
                        const deserializedImage = await deserializeImage(currentUrl);
                        if (deserializedImage !== null) {
                            if (deserializedImage instanceof HTMLImageElement) imageArray.push(deserializedImage);
                            else // special case: handle array of data textures for cube textures
                            imageArray.push(new $d5b33d7c30034067$export$b691f601014eabe1(deserializedImage.data, deserializedImage.width, deserializedImage.height));
                        }
                    }
                    images[image.uuid] = new $d5b33d7c30034067$export$1d2df86270c81ecb(imageArray);
                } else {
                    // load single image
                    const deserializedImage = await deserializeImage(image.url);
                    images[image.uuid] = new $d5b33d7c30034067$export$1d2df86270c81ecb(deserializedImage);
                }
            }
        }
        return images;
    }
    parseTextures(json, images) {
        function parseConstant(value, type) {
            if (typeof value === 'number') return value;
            console.warn('THREE.ObjectLoader.parseTexture: Constant should be in numeric form.', value);
            return type[value];
        }
        const textures = {};
        if (json !== undefined) for(let i = 0, l = json.length; i < l; i++){
            const data = json[i];
            if (data.image === undefined) console.warn('THREE.ObjectLoader: No "image" specified for', data.uuid);
            if (images[data.image] === undefined) console.warn('THREE.ObjectLoader: Undefined image', data.image);
            const source = images[data.image];
            const image = source.data;
            let texture;
            if (Array.isArray(image)) {
                texture = new $d5b33d7c30034067$export$ee2e5a18258a4049();
                if (image.length === 6) texture.needsUpdate = true;
            } else {
                if (image && image.data) texture = new $d5b33d7c30034067$export$b691f601014eabe1();
                else texture = new $d5b33d7c30034067$export$5431306cf43de24a();
                if (image) texture.needsUpdate = true; // textures can have undefined image data
            }
            texture.source = source;
            texture.uuid = data.uuid;
            if (data.name !== undefined) texture.name = data.name;
            if (data.mapping !== undefined) texture.mapping = parseConstant(data.mapping, $d5b33d7c30034067$var$TEXTURE_MAPPING);
            if (data.channel !== undefined) texture.channel = data.channel;
            if (data.offset !== undefined) texture.offset.fromArray(data.offset);
            if (data.repeat !== undefined) texture.repeat.fromArray(data.repeat);
            if (data.center !== undefined) texture.center.fromArray(data.center);
            if (data.rotation !== undefined) texture.rotation = data.rotation;
            if (data.wrap !== undefined) {
                texture.wrapS = parseConstant(data.wrap[0], $d5b33d7c30034067$var$TEXTURE_WRAPPING);
                texture.wrapT = parseConstant(data.wrap[1], $d5b33d7c30034067$var$TEXTURE_WRAPPING);
            }
            if (data.format !== undefined) texture.format = data.format;
            if (data.internalFormat !== undefined) texture.internalFormat = data.internalFormat;
            if (data.type !== undefined) texture.type = data.type;
            if (data.colorSpace !== undefined) texture.colorSpace = data.colorSpace;
            if (data.minFilter !== undefined) texture.minFilter = parseConstant(data.minFilter, $d5b33d7c30034067$var$TEXTURE_FILTER);
            if (data.magFilter !== undefined) texture.magFilter = parseConstant(data.magFilter, $d5b33d7c30034067$var$TEXTURE_FILTER);
            if (data.anisotropy !== undefined) texture.anisotropy = data.anisotropy;
            if (data.flipY !== undefined) texture.flipY = data.flipY;
            if (data.generateMipmaps !== undefined) texture.generateMipmaps = data.generateMipmaps;
            if (data.premultiplyAlpha !== undefined) texture.premultiplyAlpha = data.premultiplyAlpha;
            if (data.unpackAlignment !== undefined) texture.unpackAlignment = data.unpackAlignment;
            if (data.compareFunction !== undefined) texture.compareFunction = data.compareFunction;
            if (data.userData !== undefined) texture.userData = data.userData;
            textures[data.uuid] = texture;
        }
        return textures;
    }
    parseObject(data, geometries, materials, textures, animations) {
        let object;
        function getGeometry(name) {
            if (geometries[name] === undefined) console.warn('THREE.ObjectLoader: Undefined geometry', name);
            return geometries[name];
        }
        function getMaterial(name) {
            if (name === undefined) return undefined;
            if (Array.isArray(name)) {
                const array = [];
                for(let i = 0, l = name.length; i < l; i++){
                    const uuid = name[i];
                    if (materials[uuid] === undefined) console.warn('THREE.ObjectLoader: Undefined material', uuid);
                    array.push(materials[uuid]);
                }
                return array;
            }
            if (materials[name] === undefined) console.warn('THREE.ObjectLoader: Undefined material', name);
            return materials[name];
        }
        function getTexture(uuid) {
            if (textures[uuid] === undefined) console.warn('THREE.ObjectLoader: Undefined texture', uuid);
            return textures[uuid];
        }
        let geometry, material;
        switch(data.type){
            case 'Scene':
                object = new $d5b33d7c30034067$export$38af1803e3442a7f();
                if (data.background !== undefined) {
                    if (Number.isInteger(data.background)) object.background = new $d5b33d7c30034067$export$892596cec99bc70e(data.background);
                    else object.background = getTexture(data.background);
                }
                if (data.environment !== undefined) object.environment = getTexture(data.environment);
                if (data.fog !== undefined) {
                    if (data.fog.type === 'Fog') object.fog = new $d5b33d7c30034067$export$3c890837b09508d4(data.fog.color, data.fog.near, data.fog.far);
                    else if (data.fog.type === 'FogExp2') object.fog = new $d5b33d7c30034067$export$6f1519f023b8d0f6(data.fog.color, data.fog.density);
                    if (data.fog.name !== '') object.fog.name = data.fog.name;
                }
                if (data.backgroundBlurriness !== undefined) object.backgroundBlurriness = data.backgroundBlurriness;
                if (data.backgroundIntensity !== undefined) object.backgroundIntensity = data.backgroundIntensity;
                if (data.backgroundRotation !== undefined) object.backgroundRotation.fromArray(data.backgroundRotation);
                if (data.environmentIntensity !== undefined) object.environmentIntensity = data.environmentIntensity;
                if (data.environmentRotation !== undefined) object.environmentRotation.fromArray(data.environmentRotation);
                break;
            case 'PerspectiveCamera':
                object = new $d5b33d7c30034067$export$74e4ae24825f68d7(data.fov, data.aspect, data.near, data.far);
                if (data.focus !== undefined) object.focus = data.focus;
                if (data.zoom !== undefined) object.zoom = data.zoom;
                if (data.filmGauge !== undefined) object.filmGauge = data.filmGauge;
                if (data.filmOffset !== undefined) object.filmOffset = data.filmOffset;
                if (data.view !== undefined) object.view = Object.assign({}, data.view);
                break;
            case 'OrthographicCamera':
                object = new $d5b33d7c30034067$export$9ebf355ee4ed261b(data.left, data.right, data.top, data.bottom, data.near, data.far);
                if (data.zoom !== undefined) object.zoom = data.zoom;
                if (data.view !== undefined) object.view = Object.assign({}, data.view);
                break;
            case 'AmbientLight':
                object = new $d5b33d7c30034067$export$af279bfef9ec2c96(data.color, data.intensity);
                break;
            case 'DirectionalLight':
                object = new $d5b33d7c30034067$export$3fea33cc9972c868(data.color, data.intensity);
                object.target = data.target || '';
                break;
            case 'PointLight':
                object = new $d5b33d7c30034067$export$4c9c1cb3f0b6f455(data.color, data.intensity, data.distance, data.decay);
                break;
            case 'RectAreaLight':
                object = new $d5b33d7c30034067$export$61db2d908bbd2429(data.color, data.intensity, data.width, data.height);
                break;
            case 'SpotLight':
                object = new $d5b33d7c30034067$export$81495cbb73897362(data.color, data.intensity, data.distance, data.angle, data.penumbra, data.decay);
                object.target = data.target || '';
                break;
            case 'HemisphereLight':
                object = new $d5b33d7c30034067$export$8d474f55edbb9624(data.color, data.groundColor, data.intensity);
                break;
            case 'LightProbe':
                object = new $d5b33d7c30034067$export$e7ef036e309b38d2().fromJSON(data);
                break;
            case 'SkinnedMesh':
                geometry = getGeometry(data.geometry);
                material = getMaterial(data.material);
                object = new $d5b33d7c30034067$export$b303577035157ecf(geometry, material);
                if (data.bindMode !== undefined) object.bindMode = data.bindMode;
                if (data.bindMatrix !== undefined) object.bindMatrix.fromArray(data.bindMatrix);
                if (data.skeleton !== undefined) object.skeleton = data.skeleton;
                break;
            case 'Mesh':
                geometry = getGeometry(data.geometry);
                material = getMaterial(data.material);
                object = new $d5b33d7c30034067$export$e176487c05830cc5(geometry, material);
                break;
            case 'InstancedMesh':
                geometry = getGeometry(data.geometry);
                material = getMaterial(data.material);
                const count = data.count;
                const instanceMatrix = data.instanceMatrix;
                const instanceColor = data.instanceColor;
                object = new $d5b33d7c30034067$export$f3c979c331175ad7(geometry, material, count);
                object.instanceMatrix = new $d5b33d7c30034067$export$32ea87a8b54d744a(new Float32Array(instanceMatrix.array), 16);
                if (instanceColor !== undefined) object.instanceColor = new $d5b33d7c30034067$export$32ea87a8b54d744a(new Float32Array(instanceColor.array), instanceColor.itemSize);
                break;
            case 'BatchedMesh':
                geometry = getGeometry(data.geometry);
                material = getMaterial(data.material);
                object = new $d5b33d7c30034067$export$6e01c5ee52ed8f7b(data.maxInstanceCount, data.maxVertexCount, data.maxIndexCount, material);
                object.geometry = geometry;
                object.perObjectFrustumCulled = data.perObjectFrustumCulled;
                object.sortObjects = data.sortObjects;
                object._drawRanges = data.drawRanges;
                object._reservedRanges = data.reservedRanges;
                object._visibility = data.visibility;
                object._active = data.active;
                object._bounds = data.bounds.map((bound)=>{
                    const box = new $d5b33d7c30034067$export$6f7d5a9418ab2aa3();
                    box.min.fromArray(bound.boxMin);
                    box.max.fromArray(bound.boxMax);
                    const sphere = new $d5b33d7c30034067$export$805e8b72413ccaba();
                    sphere.radius = bound.sphereRadius;
                    sphere.center.fromArray(bound.sphereCenter);
                    return {
                        boxInitialized: bound.boxInitialized,
                        box: box,
                        sphereInitialized: bound.sphereInitialized,
                        sphere: sphere
                    };
                });
                object._maxInstanceCount = data.maxInstanceCount;
                object._maxVertexCount = data.maxVertexCount;
                object._maxIndexCount = data.maxIndexCount;
                object._geometryInitialized = data.geometryInitialized;
                object._geometryCount = data.geometryCount;
                object._matricesTexture = getTexture(data.matricesTexture.uuid);
                if (data.colorsTexture !== undefined) object._colorsTexture = getTexture(data.colorsTexture.uuid);
                break;
            case 'LOD':
                object = new $d5b33d7c30034067$export$112e7237be0c5f30();
                break;
            case 'Line':
                object = new $d5b33d7c30034067$export$17d680238e50603e(getGeometry(data.geometry), getMaterial(data.material));
                break;
            case 'LineLoop':
                object = new $d5b33d7c30034067$export$f85a24d745e4f17d(getGeometry(data.geometry), getMaterial(data.material));
                break;
            case 'LineSegments':
                object = new $d5b33d7c30034067$export$ff1ed10fedfdd604(getGeometry(data.geometry), getMaterial(data.material));
                break;
            case 'PointCloud':
            case 'Points':
                object = new $d5b33d7c30034067$export$1c787534cb11aa3e(getGeometry(data.geometry), getMaterial(data.material));
                break;
            case 'Sprite':
                object = new $d5b33d7c30034067$export$3075603db8e6204c(getMaterial(data.material));
                break;
            case 'Group':
                object = new $d5b33d7c30034067$export$eb2fcfdbd7ba97d4();
                break;
            case 'Bone':
                object = new $d5b33d7c30034067$export$b127726e56765aa4();
                break;
            default:
                object = new $d5b33d7c30034067$export$e4dd07dff30cc924();
        }
        object.uuid = data.uuid;
        if (data.name !== undefined) object.name = data.name;
        if (data.matrix !== undefined) {
            object.matrix.fromArray(data.matrix);
            if (data.matrixAutoUpdate !== undefined) object.matrixAutoUpdate = data.matrixAutoUpdate;
            if (object.matrixAutoUpdate) object.matrix.decompose(object.position, object.quaternion, object.scale);
        } else {
            if (data.position !== undefined) object.position.fromArray(data.position);
            if (data.rotation !== undefined) object.rotation.fromArray(data.rotation);
            if (data.quaternion !== undefined) object.quaternion.fromArray(data.quaternion);
            if (data.scale !== undefined) object.scale.fromArray(data.scale);
        }
        if (data.up !== undefined) object.up.fromArray(data.up);
        if (data.castShadow !== undefined) object.castShadow = data.castShadow;
        if (data.receiveShadow !== undefined) object.receiveShadow = data.receiveShadow;
        if (data.shadow) {
            if (data.shadow.intensity !== undefined) object.shadow.intensity = data.shadow.intensity;
            if (data.shadow.bias !== undefined) object.shadow.bias = data.shadow.bias;
            if (data.shadow.normalBias !== undefined) object.shadow.normalBias = data.shadow.normalBias;
            if (data.shadow.radius !== undefined) object.shadow.radius = data.shadow.radius;
            if (data.shadow.mapSize !== undefined) object.shadow.mapSize.fromArray(data.shadow.mapSize);
            if (data.shadow.camera !== undefined) object.shadow.camera = this.parseObject(data.shadow.camera);
        }
        if (data.visible !== undefined) object.visible = data.visible;
        if (data.frustumCulled !== undefined) object.frustumCulled = data.frustumCulled;
        if (data.renderOrder !== undefined) object.renderOrder = data.renderOrder;
        if (data.userData !== undefined) object.userData = data.userData;
        if (data.layers !== undefined) object.layers.mask = data.layers;
        if (data.children !== undefined) {
            const children = data.children;
            for(let i = 0; i < children.length; i++)object.add(this.parseObject(children[i], geometries, materials, textures, animations));
        }
        if (data.animations !== undefined) {
            const objectAnimations = data.animations;
            for(let i = 0; i < objectAnimations.length; i++){
                const uuid = objectAnimations[i];
                object.animations.push(animations[uuid]);
            }
        }
        if (data.type === 'LOD') {
            if (data.autoUpdate !== undefined) object.autoUpdate = data.autoUpdate;
            const levels = data.levels;
            for(let l = 0; l < levels.length; l++){
                const level = levels[l];
                const child = object.getObjectByProperty('uuid', level.object);
                if (child !== undefined) object.addLevel(child, level.distance, level.hysteresis);
            }
        }
        return object;
    }
    bindSkeletons(object, skeletons) {
        if (Object.keys(skeletons).length === 0) return;
        object.traverse(function(child) {
            if (child.isSkinnedMesh === true && child.skeleton !== undefined) {
                const skeleton = skeletons[child.skeleton];
                if (skeleton === undefined) console.warn('THREE.ObjectLoader: No skeleton found with UUID:', child.skeleton);
                else child.bind(skeleton, child.bindMatrix);
            }
        });
    }
    bindLightTargets(object) {
        object.traverse(function(child) {
            if (child.isDirectionalLight || child.isSpotLight) {
                const uuid = child.target;
                const target = object.getObjectByProperty('uuid', uuid);
                if (target !== undefined) child.target = target;
                else child.target = new $d5b33d7c30034067$export$e4dd07dff30cc924();
            }
        });
    }
}
const $d5b33d7c30034067$var$TEXTURE_MAPPING = {
    UVMapping: $d5b33d7c30034067$export$1beec6768cbb3d2d,
    CubeReflectionMapping: $d5b33d7c30034067$export$8759762a6477f2c4,
    CubeRefractionMapping: $d5b33d7c30034067$export$dc59f8aed047f61d,
    EquirectangularReflectionMapping: $d5b33d7c30034067$export$d64030b316d3b087,
    EquirectangularRefractionMapping: $d5b33d7c30034067$export$ee99d97d46898098,
    CubeUVReflectionMapping: $d5b33d7c30034067$export$dbf3e70ff37af79
};
const $d5b33d7c30034067$var$TEXTURE_WRAPPING = {
    RepeatWrapping: $d5b33d7c30034067$export$533346c8e8dac0f5,
    ClampToEdgeWrapping: $d5b33d7c30034067$export$9d9334239a5a5e06,
    MirroredRepeatWrapping: $d5b33d7c30034067$export$c7e7c00b14f51a4f
};
const $d5b33d7c30034067$var$TEXTURE_FILTER = {
    NearestFilter: $d5b33d7c30034067$export$727aa5ec3fe39bf0,
    NearestMipmapNearestFilter: $d5b33d7c30034067$export$d129e38cf6feaa8c,
    NearestMipmapLinearFilter: $d5b33d7c30034067$export$d2327c1afe5bfdf2,
    LinearFilter: $d5b33d7c30034067$export$8a72f490b25c56c8,
    LinearMipmapNearestFilter: $d5b33d7c30034067$export$19a719f377145a13,
    LinearMipmapLinearFilter: $d5b33d7c30034067$export$5d8599b6a933fb1b
};
class $d5b33d7c30034067$export$52286b55c4a9b51f extends $d5b33d7c30034067$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
        this.isImageBitmapLoader = true;
        if (typeof createImageBitmap === 'undefined') console.warn('THREE.ImageBitmapLoader: createImageBitmap() not supported.');
        if (typeof fetch === 'undefined') console.warn('THREE.ImageBitmapLoader: fetch() not supported.');
        this.options = {
            premultiplyAlpha: 'none'
        };
    }
    setOptions(options) {
        this.options = options;
        return this;
    }
    load(url, onLoad, onProgress, onError) {
        if (url === undefined) url = '';
        if (this.path !== undefined) url = this.path + url;
        url = this.manager.resolveURL(url);
        const scope = this;
        const cached = $d5b33d7c30034067$export$94affb487e701bf2.get(url);
        if (cached !== undefined) {
            scope.manager.itemStart(url);
            // If cached is a promise, wait for it to resolve
            if (cached.then) {
                cached.then((imageBitmap)=>{
                    if (onLoad) onLoad(imageBitmap);
                    scope.manager.itemEnd(url);
                }).catch((e)=>{
                    if (onError) onError(e);
                });
                return;
            }
            // If cached is not a promise (i.e., it's already an imageBitmap)
            setTimeout(function() {
                if (onLoad) onLoad(cached);
                scope.manager.itemEnd(url);
            }, 0);
            return cached;
        }
        const fetchOptions = {};
        fetchOptions.credentials = this.crossOrigin === 'anonymous' ? 'same-origin' : 'include';
        fetchOptions.headers = this.requestHeader;
        const promise = fetch(url, fetchOptions).then(function(res) {
            return res.blob();
        }).then(function(blob) {
            return createImageBitmap(blob, Object.assign(scope.options, {
                colorSpaceConversion: 'none'
            }));
        }).then(function(imageBitmap) {
            $d5b33d7c30034067$export$94affb487e701bf2.add(url, imageBitmap);
            if (onLoad) onLoad(imageBitmap);
            scope.manager.itemEnd(url);
            return imageBitmap;
        }).catch(function(e) {
            if (onError) onError(e);
            $d5b33d7c30034067$export$94affb487e701bf2.remove(url);
            scope.manager.itemError(url);
            scope.manager.itemEnd(url);
        });
        $d5b33d7c30034067$export$94affb487e701bf2.add(url, promise);
        scope.manager.itemStart(url);
    }
}
let $d5b33d7c30034067$var$_context;
class $d5b33d7c30034067$export$fcbc63750ec2a81f {
    static getContext() {
        if ($d5b33d7c30034067$var$_context === undefined) $d5b33d7c30034067$var$_context = new (window.AudioContext || window.webkitAudioContext)();
        return $d5b33d7c30034067$var$_context;
    }
    static setContext(value) {
        $d5b33d7c30034067$var$_context = value;
    }
}
class $d5b33d7c30034067$export$d8d5fccfbf47714e extends $d5b33d7c30034067$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(url, onLoad, onProgress, onError) {
        const scope = this;
        const loader = new $d5b33d7c30034067$export$98435a25b5cf7b2b(this.manager);
        loader.setResponseType('arraybuffer');
        loader.setPath(this.path);
        loader.setRequestHeader(this.requestHeader);
        loader.setWithCredentials(this.withCredentials);
        loader.load(url, function(buffer) {
            try {
                // Create a copy of the buffer. The `decodeAudioData` method
                // detaches the buffer when complete, preventing reuse.
                const bufferCopy = buffer.slice(0);
                const context = $d5b33d7c30034067$export$fcbc63750ec2a81f.getContext();
                context.decodeAudioData(bufferCopy, function(audioBuffer) {
                    onLoad(audioBuffer);
                }).catch(handleError);
            } catch (e) {
                handleError(e);
            }
        }, onProgress, onError);
        function handleError(e) {
            if (onError) onError(e);
            else console.error(e);
            scope.manager.itemError(url);
        }
    }
}
const $d5b33d7c30034067$var$_eyeRight = /*@__PURE__*/ new $d5b33d7c30034067$export$2ae72fc923e5eb5();
const $d5b33d7c30034067$var$_eyeLeft = /*@__PURE__*/ new $d5b33d7c30034067$export$2ae72fc923e5eb5();
const $d5b33d7c30034067$var$_projectionMatrix = /*@__PURE__*/ new $d5b33d7c30034067$export$2ae72fc923e5eb5();
class $d5b33d7c30034067$export$bc7f73a1065bee0c {
    constructor(){
        this.type = 'StereoCamera';
        this.aspect = 1;
        this.eyeSep = 0.064;
        this.cameraL = new $d5b33d7c30034067$export$74e4ae24825f68d7();
        this.cameraL.layers.enable(1);
        this.cameraL.matrixAutoUpdate = false;
        this.cameraR = new $d5b33d7c30034067$export$74e4ae24825f68d7();
        this.cameraR.layers.enable(2);
        this.cameraR.matrixAutoUpdate = false;
        this._cache = {
            focus: null,
            fov: null,
            aspect: null,
            near: null,
            far: null,
            zoom: null,
            eyeSep: null
        };
    }
    update(camera) {
        const cache = this._cache;
        const needsUpdate = cache.focus !== camera.focus || cache.fov !== camera.fov || cache.aspect !== camera.aspect * this.aspect || cache.near !== camera.near || cache.far !== camera.far || cache.zoom !== camera.zoom || cache.eyeSep !== this.eyeSep;
        if (needsUpdate) {
            cache.focus = camera.focus;
            cache.fov = camera.fov;
            cache.aspect = camera.aspect * this.aspect;
            cache.near = camera.near;
            cache.far = camera.far;
            cache.zoom = camera.zoom;
            cache.eyeSep = this.eyeSep;
            // Off-axis stereoscopic effect based on
            // http://paulbourke.net/stereographics/stereorender/
            $d5b33d7c30034067$var$_projectionMatrix.copy(camera.projectionMatrix);
            const eyeSepHalf = cache.eyeSep / 2;
            const eyeSepOnProjection = eyeSepHalf * cache.near / cache.focus;
            const ymax = cache.near * Math.tan($d5b33d7c30034067$var$DEG2RAD * cache.fov * 0.5) / cache.zoom;
            let xmin, xmax;
            // translate xOffset
            $d5b33d7c30034067$var$_eyeLeft.elements[12] = -eyeSepHalf;
            $d5b33d7c30034067$var$_eyeRight.elements[12] = eyeSepHalf;
            // for left eye
            xmin = -ymax * cache.aspect + eyeSepOnProjection;
            xmax = ymax * cache.aspect + eyeSepOnProjection;
            $d5b33d7c30034067$var$_projectionMatrix.elements[0] = 2 * cache.near / (xmax - xmin);
            $d5b33d7c30034067$var$_projectionMatrix.elements[8] = (xmax + xmin) / (xmax - xmin);
            this.cameraL.projectionMatrix.copy($d5b33d7c30034067$var$_projectionMatrix);
            // for right eye
            xmin = -ymax * cache.aspect - eyeSepOnProjection;
            xmax = ymax * cache.aspect - eyeSepOnProjection;
            $d5b33d7c30034067$var$_projectionMatrix.elements[0] = 2 * cache.near / (xmax - xmin);
            $d5b33d7c30034067$var$_projectionMatrix.elements[8] = (xmax + xmin) / (xmax - xmin);
            this.cameraR.projectionMatrix.copy($d5b33d7c30034067$var$_projectionMatrix);
        }
        this.cameraL.matrixWorld.copy(camera.matrixWorld).multiply($d5b33d7c30034067$var$_eyeLeft);
        this.cameraR.matrixWorld.copy(camera.matrixWorld).multiply($d5b33d7c30034067$var$_eyeRight);
    }
}
class $d5b33d7c30034067$export$9735c82c4bae3302 {
    constructor(autoStart = true){
        this.autoStart = autoStart;
        this.startTime = 0;
        this.oldTime = 0;
        this.elapsedTime = 0;
        this.running = false;
    }
    start() {
        this.startTime = $d5b33d7c30034067$var$now();
        this.oldTime = this.startTime;
        this.elapsedTime = 0;
        this.running = true;
    }
    stop() {
        this.getElapsedTime();
        this.running = false;
        this.autoStart = false;
    }
    getElapsedTime() {
        this.getDelta();
        return this.elapsedTime;
    }
    getDelta() {
        let diff = 0;
        if (this.autoStart && !this.running) {
            this.start();
            return 0;
        }
        if (this.running) {
            const newTime = $d5b33d7c30034067$var$now();
            diff = (newTime - this.oldTime) / 1000;
            this.oldTime = newTime;
            this.elapsedTime += diff;
        }
        return diff;
    }
}
function $d5b33d7c30034067$var$now() {
    return performance.now();
}
const $d5b33d7c30034067$var$_position$1 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_quaternion$1 = /*@__PURE__*/ new $d5b33d7c30034067$export$23d6a54f0bbc85a3();
const $d5b33d7c30034067$var$_scale$1 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_orientation$1 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
class $d5b33d7c30034067$export$8a1b810c6fde8951 extends $d5b33d7c30034067$export$e4dd07dff30cc924 {
    constructor(){
        super();
        this.type = 'AudioListener';
        this.context = $d5b33d7c30034067$export$fcbc63750ec2a81f.getContext();
        this.gain = this.context.createGain();
        this.gain.connect(this.context.destination);
        this.filter = null;
        this.timeDelta = 0;
        // private
        this._clock = new $d5b33d7c30034067$export$9735c82c4bae3302();
    }
    getInput() {
        return this.gain;
    }
    removeFilter() {
        if (this.filter !== null) {
            this.gain.disconnect(this.filter);
            this.filter.disconnect(this.context.destination);
            this.gain.connect(this.context.destination);
            this.filter = null;
        }
        return this;
    }
    getFilter() {
        return this.filter;
    }
    setFilter(value) {
        if (this.filter !== null) {
            this.gain.disconnect(this.filter);
            this.filter.disconnect(this.context.destination);
        } else this.gain.disconnect(this.context.destination);
        this.filter = value;
        this.gain.connect(this.filter);
        this.filter.connect(this.context.destination);
        return this;
    }
    getMasterVolume() {
        return this.gain.gain.value;
    }
    setMasterVolume(value) {
        this.gain.gain.setTargetAtTime(value, this.context.currentTime, 0.01);
        return this;
    }
    updateMatrixWorld(force) {
        super.updateMatrixWorld(force);
        const listener = this.context.listener;
        const up = this.up;
        this.timeDelta = this._clock.getDelta();
        this.matrixWorld.decompose($d5b33d7c30034067$var$_position$1, $d5b33d7c30034067$var$_quaternion$1, $d5b33d7c30034067$var$_scale$1);
        $d5b33d7c30034067$var$_orientation$1.set(0, 0, -1).applyQuaternion($d5b33d7c30034067$var$_quaternion$1);
        if (listener.positionX) {
            // code path for Chrome (see #14393)
            const endTime = this.context.currentTime + this.timeDelta;
            listener.positionX.linearRampToValueAtTime($d5b33d7c30034067$var$_position$1.x, endTime);
            listener.positionY.linearRampToValueAtTime($d5b33d7c30034067$var$_position$1.y, endTime);
            listener.positionZ.linearRampToValueAtTime($d5b33d7c30034067$var$_position$1.z, endTime);
            listener.forwardX.linearRampToValueAtTime($d5b33d7c30034067$var$_orientation$1.x, endTime);
            listener.forwardY.linearRampToValueAtTime($d5b33d7c30034067$var$_orientation$1.y, endTime);
            listener.forwardZ.linearRampToValueAtTime($d5b33d7c30034067$var$_orientation$1.z, endTime);
            listener.upX.linearRampToValueAtTime(up.x, endTime);
            listener.upY.linearRampToValueAtTime(up.y, endTime);
            listener.upZ.linearRampToValueAtTime(up.z, endTime);
        } else {
            listener.setPosition($d5b33d7c30034067$var$_position$1.x, $d5b33d7c30034067$var$_position$1.y, $d5b33d7c30034067$var$_position$1.z);
            listener.setOrientation($d5b33d7c30034067$var$_orientation$1.x, $d5b33d7c30034067$var$_orientation$1.y, $d5b33d7c30034067$var$_orientation$1.z, up.x, up.y, up.z);
        }
    }
}
class $d5b33d7c30034067$export$153755f98d9861de extends $d5b33d7c30034067$export$e4dd07dff30cc924 {
    constructor(listener){
        super();
        this.type = 'Audio';
        this.listener = listener;
        this.context = listener.context;
        this.gain = this.context.createGain();
        this.gain.connect(listener.getInput());
        this.autoplay = false;
        this.buffer = null;
        this.detune = 0;
        this.loop = false;
        this.loopStart = 0;
        this.loopEnd = 0;
        this.offset = 0;
        this.duration = undefined;
        this.playbackRate = 1;
        this.isPlaying = false;
        this.hasPlaybackControl = true;
        this.source = null;
        this.sourceType = 'empty';
        this._startedAt = 0;
        this._progress = 0;
        this._connected = false;
        this.filters = [];
    }
    getOutput() {
        return this.gain;
    }
    setNodeSource(audioNode) {
        this.hasPlaybackControl = false;
        this.sourceType = 'audioNode';
        this.source = audioNode;
        this.connect();
        return this;
    }
    setMediaElementSource(mediaElement) {
        this.hasPlaybackControl = false;
        this.sourceType = 'mediaNode';
        this.source = this.context.createMediaElementSource(mediaElement);
        this.connect();
        return this;
    }
    setMediaStreamSource(mediaStream) {
        this.hasPlaybackControl = false;
        this.sourceType = 'mediaStreamNode';
        this.source = this.context.createMediaStreamSource(mediaStream);
        this.connect();
        return this;
    }
    setBuffer(audioBuffer) {
        this.buffer = audioBuffer;
        this.sourceType = 'buffer';
        if (this.autoplay) this.play();
        return this;
    }
    play(delay = 0) {
        if (this.isPlaying === true) {
            console.warn('THREE.Audio: Audio is already playing.');
            return;
        }
        if (this.hasPlaybackControl === false) {
            console.warn('THREE.Audio: this Audio has no playback control.');
            return;
        }
        this._startedAt = this.context.currentTime + delay;
        const source = this.context.createBufferSource();
        source.buffer = this.buffer;
        source.loop = this.loop;
        source.loopStart = this.loopStart;
        source.loopEnd = this.loopEnd;
        source.onended = this.onEnded.bind(this);
        source.start(this._startedAt, this._progress + this.offset, this.duration);
        this.isPlaying = true;
        this.source = source;
        this.setDetune(this.detune);
        this.setPlaybackRate(this.playbackRate);
        return this.connect();
    }
    pause() {
        if (this.hasPlaybackControl === false) {
            console.warn('THREE.Audio: this Audio has no playback control.');
            return;
        }
        if (this.isPlaying === true) {
            // update current progress
            this._progress += Math.max(this.context.currentTime - this._startedAt, 0) * this.playbackRate;
            if (this.loop === true) // ensure _progress does not exceed duration with looped audios
            this._progress = this._progress % (this.duration || this.buffer.duration);
            this.source.stop();
            this.source.onended = null;
            this.isPlaying = false;
        }
        return this;
    }
    stop(delay = 0) {
        if (this.hasPlaybackControl === false) {
            console.warn('THREE.Audio: this Audio has no playback control.');
            return;
        }
        this._progress = 0;
        if (this.source !== null) {
            this.source.stop(this.context.currentTime + delay);
            this.source.onended = null;
        }
        this.isPlaying = false;
        return this;
    }
    connect() {
        if (this.filters.length > 0) {
            this.source.connect(this.filters[0]);
            for(let i = 1, l = this.filters.length; i < l; i++)this.filters[i - 1].connect(this.filters[i]);
            this.filters[this.filters.length - 1].connect(this.getOutput());
        } else this.source.connect(this.getOutput());
        this._connected = true;
        return this;
    }
    disconnect() {
        if (this._connected === false) return;
        if (this.filters.length > 0) {
            this.source.disconnect(this.filters[0]);
            for(let i = 1, l = this.filters.length; i < l; i++)this.filters[i - 1].disconnect(this.filters[i]);
            this.filters[this.filters.length - 1].disconnect(this.getOutput());
        } else this.source.disconnect(this.getOutput());
        this._connected = false;
        return this;
    }
    getFilters() {
        return this.filters;
    }
    setFilters(value) {
        if (!value) value = [];
        if (this._connected === true) {
            this.disconnect();
            this.filters = value.slice();
            this.connect();
        } else this.filters = value.slice();
        return this;
    }
    setDetune(value) {
        this.detune = value;
        if (this.isPlaying === true && this.source.detune !== undefined) this.source.detune.setTargetAtTime(this.detune, this.context.currentTime, 0.01);
        return this;
    }
    getDetune() {
        return this.detune;
    }
    getFilter() {
        return this.getFilters()[0];
    }
    setFilter(filter) {
        return this.setFilters(filter ? [
            filter
        ] : []);
    }
    setPlaybackRate(value) {
        if (this.hasPlaybackControl === false) {
            console.warn('THREE.Audio: this Audio has no playback control.');
            return;
        }
        this.playbackRate = value;
        if (this.isPlaying === true) this.source.playbackRate.setTargetAtTime(this.playbackRate, this.context.currentTime, 0.01);
        return this;
    }
    getPlaybackRate() {
        return this.playbackRate;
    }
    onEnded() {
        this.isPlaying = false;
    }
    getLoop() {
        if (this.hasPlaybackControl === false) {
            console.warn('THREE.Audio: this Audio has no playback control.');
            return false;
        }
        return this.loop;
    }
    setLoop(value) {
        if (this.hasPlaybackControl === false) {
            console.warn('THREE.Audio: this Audio has no playback control.');
            return;
        }
        this.loop = value;
        if (this.isPlaying === true) this.source.loop = this.loop;
        return this;
    }
    setLoopStart(value) {
        this.loopStart = value;
        return this;
    }
    setLoopEnd(value) {
        this.loopEnd = value;
        return this;
    }
    getVolume() {
        return this.gain.gain.value;
    }
    setVolume(value) {
        this.gain.gain.setTargetAtTime(value, this.context.currentTime, 0.01);
        return this;
    }
}
const $d5b33d7c30034067$var$_position = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_quaternion = /*@__PURE__*/ new $d5b33d7c30034067$export$23d6a54f0bbc85a3();
const $d5b33d7c30034067$var$_scale = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_orientation = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
class $d5b33d7c30034067$export$4b3e397ef1832507 extends $d5b33d7c30034067$export$153755f98d9861de {
    constructor(listener){
        super(listener);
        this.panner = this.context.createPanner();
        this.panner.panningModel = 'HRTF';
        this.panner.connect(this.gain);
    }
    connect() {
        super.connect();
        this.panner.connect(this.gain);
    }
    disconnect() {
        super.disconnect();
        this.panner.disconnect(this.gain);
    }
    getOutput() {
        return this.panner;
    }
    getRefDistance() {
        return this.panner.refDistance;
    }
    setRefDistance(value) {
        this.panner.refDistance = value;
        return this;
    }
    getRolloffFactor() {
        return this.panner.rolloffFactor;
    }
    setRolloffFactor(value) {
        this.panner.rolloffFactor = value;
        return this;
    }
    getDistanceModel() {
        return this.panner.distanceModel;
    }
    setDistanceModel(value) {
        this.panner.distanceModel = value;
        return this;
    }
    getMaxDistance() {
        return this.panner.maxDistance;
    }
    setMaxDistance(value) {
        this.panner.maxDistance = value;
        return this;
    }
    setDirectionalCone(coneInnerAngle, coneOuterAngle, coneOuterGain) {
        this.panner.coneInnerAngle = coneInnerAngle;
        this.panner.coneOuterAngle = coneOuterAngle;
        this.panner.coneOuterGain = coneOuterGain;
        return this;
    }
    updateMatrixWorld(force) {
        super.updateMatrixWorld(force);
        if (this.hasPlaybackControl === true && this.isPlaying === false) return;
        this.matrixWorld.decompose($d5b33d7c30034067$var$_position, $d5b33d7c30034067$var$_quaternion, $d5b33d7c30034067$var$_scale);
        $d5b33d7c30034067$var$_orientation.set(0, 0, 1).applyQuaternion($d5b33d7c30034067$var$_quaternion);
        const panner = this.panner;
        if (panner.positionX) {
            // code path for Chrome and Firefox (see #14393)
            const endTime = this.context.currentTime + this.listener.timeDelta;
            panner.positionX.linearRampToValueAtTime($d5b33d7c30034067$var$_position.x, endTime);
            panner.positionY.linearRampToValueAtTime($d5b33d7c30034067$var$_position.y, endTime);
            panner.positionZ.linearRampToValueAtTime($d5b33d7c30034067$var$_position.z, endTime);
            panner.orientationX.linearRampToValueAtTime($d5b33d7c30034067$var$_orientation.x, endTime);
            panner.orientationY.linearRampToValueAtTime($d5b33d7c30034067$var$_orientation.y, endTime);
            panner.orientationZ.linearRampToValueAtTime($d5b33d7c30034067$var$_orientation.z, endTime);
        } else {
            panner.setPosition($d5b33d7c30034067$var$_position.x, $d5b33d7c30034067$var$_position.y, $d5b33d7c30034067$var$_position.z);
            panner.setOrientation($d5b33d7c30034067$var$_orientation.x, $d5b33d7c30034067$var$_orientation.y, $d5b33d7c30034067$var$_orientation.z);
        }
    }
}
class $d5b33d7c30034067$export$d47da1ef3d382827 {
    constructor(audio, fftSize = 2048){
        this.analyser = audio.context.createAnalyser();
        this.analyser.fftSize = fftSize;
        this.data = new Uint8Array(this.analyser.frequencyBinCount);
        audio.getOutput().connect(this.analyser);
    }
    getFrequencyData() {
        this.analyser.getByteFrequencyData(this.data);
        return this.data;
    }
    getAverageFrequency() {
        let value = 0;
        const data = this.getFrequencyData();
        for(let i = 0; i < data.length; i++)value += data[i];
        return value / data.length;
    }
}
class $d5b33d7c30034067$export$dfe0af1ca1acb78a {
    constructor(binding, typeName, valueSize){
        this.binding = binding;
        this.valueSize = valueSize;
        let mixFunction, mixFunctionAdditive, setIdentity;
        // buffer layout: [ incoming | accu0 | accu1 | orig | addAccu | (optional work) ]
        //
        // interpolators can use .buffer as their .result
        // the data then goes to 'incoming'
        //
        // 'accu0' and 'accu1' are used frame-interleaved for
        // the cumulative result and are compared to detect
        // changes
        //
        // 'orig' stores the original state of the property
        //
        // 'add' is used for additive cumulative results
        //
        // 'work' is optional and is only present for quaternion types. It is used
        // to store intermediate quaternion multiplication results
        switch(typeName){
            case 'quaternion':
                mixFunction = this._slerp;
                mixFunctionAdditive = this._slerpAdditive;
                setIdentity = this._setAdditiveIdentityQuaternion;
                this.buffer = new Float64Array(valueSize * 6);
                this._workIndex = 5;
                break;
            case 'string':
            case 'bool':
                mixFunction = this._select;
                // Use the regular mix function and for additive on these types,
                // additive is not relevant for non-numeric types
                mixFunctionAdditive = this._select;
                setIdentity = this._setAdditiveIdentityOther;
                this.buffer = new Array(valueSize * 5);
                break;
            default:
                mixFunction = this._lerp;
                mixFunctionAdditive = this._lerpAdditive;
                setIdentity = this._setAdditiveIdentityNumeric;
                this.buffer = new Float64Array(valueSize * 5);
        }
        this._mixBufferRegion = mixFunction;
        this._mixBufferRegionAdditive = mixFunctionAdditive;
        this._setIdentity = setIdentity;
        this._origIndex = 3;
        this._addIndex = 4;
        this.cumulativeWeight = 0;
        this.cumulativeWeightAdditive = 0;
        this.useCount = 0;
        this.referenceCount = 0;
    }
    // accumulate data in the 'incoming' region into 'accu<i>'
    accumulate(accuIndex, weight) {
        // note: happily accumulating nothing when weight = 0, the caller knows
        // the weight and shouldn't have made the call in the first place
        const buffer = this.buffer, stride = this.valueSize, offset = accuIndex * stride + stride;
        let currentWeight = this.cumulativeWeight;
        if (currentWeight === 0) {
            // accuN := incoming * weight
            for(let i = 0; i !== stride; ++i)buffer[offset + i] = buffer[i];
            currentWeight = weight;
        } else {
            // accuN := accuN + incoming * weight
            currentWeight += weight;
            const mix = weight / currentWeight;
            this._mixBufferRegion(buffer, offset, 0, mix, stride);
        }
        this.cumulativeWeight = currentWeight;
    }
    // accumulate data in the 'incoming' region into 'add'
    accumulateAdditive(weight) {
        const buffer = this.buffer, stride = this.valueSize, offset = stride * this._addIndex;
        if (this.cumulativeWeightAdditive === 0) // add = identity
        this._setIdentity();
        // add := add + incoming * weight
        this._mixBufferRegionAdditive(buffer, offset, 0, weight, stride);
        this.cumulativeWeightAdditive += weight;
    }
    // apply the state of 'accu<i>' to the binding when accus differ
    apply(accuIndex) {
        const stride = this.valueSize, buffer = this.buffer, offset = accuIndex * stride + stride, weight = this.cumulativeWeight, weightAdditive = this.cumulativeWeightAdditive, binding = this.binding;
        this.cumulativeWeight = 0;
        this.cumulativeWeightAdditive = 0;
        if (weight < 1) {
            // accuN := accuN + original * ( 1 - cumulativeWeight )
            const originalValueOffset = stride * this._origIndex;
            this._mixBufferRegion(buffer, offset, originalValueOffset, 1 - weight, stride);
        }
        if (weightAdditive > 0) // accuN := accuN + additive accuN
        this._mixBufferRegionAdditive(buffer, offset, this._addIndex * stride, 1, stride);
        for(let i = stride, e = stride + stride; i !== e; ++i)if (buffer[i] !== buffer[i + stride]) {
            // value has changed -> update scene graph
            binding.setValue(buffer, offset);
            break;
        }
    }
    // remember the state of the bound property and copy it to both accus
    saveOriginalState() {
        const binding = this.binding;
        const buffer = this.buffer, stride = this.valueSize, originalValueOffset = stride * this._origIndex;
        binding.getValue(buffer, originalValueOffset);
        // accu[0..1] := orig -- initially detect changes against the original
        for(let i = stride, e = originalValueOffset; i !== e; ++i)buffer[i] = buffer[originalValueOffset + i % stride];
        // Add to identity for additive
        this._setIdentity();
        this.cumulativeWeight = 0;
        this.cumulativeWeightAdditive = 0;
    }
    // apply the state previously taken via 'saveOriginalState' to the binding
    restoreOriginalState() {
        const originalValueOffset = this.valueSize * 3;
        this.binding.setValue(this.buffer, originalValueOffset);
    }
    _setAdditiveIdentityNumeric() {
        const startIndex = this._addIndex * this.valueSize;
        const endIndex = startIndex + this.valueSize;
        for(let i = startIndex; i < endIndex; i++)this.buffer[i] = 0;
    }
    _setAdditiveIdentityQuaternion() {
        this._setAdditiveIdentityNumeric();
        this.buffer[this._addIndex * this.valueSize + 3] = 1;
    }
    _setAdditiveIdentityOther() {
        const startIndex = this._origIndex * this.valueSize;
        const targetIndex = this._addIndex * this.valueSize;
        for(let i = 0; i < this.valueSize; i++)this.buffer[targetIndex + i] = this.buffer[startIndex + i];
    }
    // mix functions
    _select(buffer, dstOffset, srcOffset, t, stride) {
        if (t >= 0.5) for(let i = 0; i !== stride; ++i)buffer[dstOffset + i] = buffer[srcOffset + i];
    }
    _slerp(buffer, dstOffset, srcOffset, t) {
        $d5b33d7c30034067$export$23d6a54f0bbc85a3.slerpFlat(buffer, dstOffset, buffer, dstOffset, buffer, srcOffset, t);
    }
    _slerpAdditive(buffer, dstOffset, srcOffset, t, stride) {
        const workOffset = this._workIndex * stride;
        // Store result in intermediate buffer offset
        $d5b33d7c30034067$export$23d6a54f0bbc85a3.multiplyQuaternionsFlat(buffer, workOffset, buffer, dstOffset, buffer, srcOffset);
        // Slerp to the intermediate result
        $d5b33d7c30034067$export$23d6a54f0bbc85a3.slerpFlat(buffer, dstOffset, buffer, dstOffset, buffer, workOffset, t);
    }
    _lerp(buffer, dstOffset, srcOffset, t, stride) {
        const s = 1 - t;
        for(let i = 0; i !== stride; ++i){
            const j = dstOffset + i;
            buffer[j] = buffer[j] * s + buffer[srcOffset + i] * t;
        }
    }
    _lerpAdditive(buffer, dstOffset, srcOffset, t, stride) {
        for(let i = 0; i !== stride; ++i){
            const j = dstOffset + i;
            buffer[j] = buffer[j] + buffer[srcOffset + i] * t;
        }
    }
}
// Characters [].:/ are reserved for track binding syntax.
const $d5b33d7c30034067$var$_RESERVED_CHARS_RE = '\\[\\]\\.:\\/';
const $d5b33d7c30034067$var$_reservedRe = new RegExp('[' + $d5b33d7c30034067$var$_RESERVED_CHARS_RE + ']', 'g');
// Attempts to allow node names from any language. ES5's `\w` regexp matches
// only latin characters, and the unicode \p{L} is not yet supported. So
// instead, we exclude reserved characters and match everything else.
const $d5b33d7c30034067$var$_wordChar = '[^' + $d5b33d7c30034067$var$_RESERVED_CHARS_RE + ']';
const $d5b33d7c30034067$var$_wordCharOrDot = '[^' + $d5b33d7c30034067$var$_RESERVED_CHARS_RE.replace('\\.', '') + ']';
// Parent directories, delimited by '/' or ':'. Currently unused, but must
// be matched to parse the rest of the track name.
const $d5b33d7c30034067$var$_directoryRe = /*@__PURE__*/ /((?:WC+[\/:])*)/.source.replace('WC', $d5b33d7c30034067$var$_wordChar);
// Target node. May contain word characters (a-zA-Z0-9_) and '.' or '-'.
const $d5b33d7c30034067$var$_nodeRe = /*@__PURE__*/ /(WCOD+)?/.source.replace('WCOD', $d5b33d7c30034067$var$_wordCharOrDot);
// Object on target node, and accessor. May not contain reserved
// characters. Accessor may contain any character except closing bracket.
const $d5b33d7c30034067$var$_objectRe = /*@__PURE__*/ /(?:\.(WC+)(?:\[(.+)\])?)?/.source.replace('WC', $d5b33d7c30034067$var$_wordChar);
// Property and accessor. May not contain reserved characters. Accessor may
// contain any non-bracket characters.
const $d5b33d7c30034067$var$_propertyRe = /*@__PURE__*/ /\.(WC+)(?:\[(.+)\])?/.source.replace('WC', $d5b33d7c30034067$var$_wordChar);
const $d5b33d7c30034067$var$_trackRe = new RegExp("^" + $d5b33d7c30034067$var$_directoryRe + $d5b33d7c30034067$var$_nodeRe + $d5b33d7c30034067$var$_objectRe + $d5b33d7c30034067$var$_propertyRe + '$');
const $d5b33d7c30034067$var$_supportedObjectNames = [
    'material',
    'materials',
    'bones',
    'map'
];
class $d5b33d7c30034067$var$Composite {
    constructor(targetGroup, path, optionalParsedPath){
        const parsedPath = optionalParsedPath || $d5b33d7c30034067$export$7bf70fcf9f891893.parseTrackName(path);
        this._targetGroup = targetGroup;
        this._bindings = targetGroup.subscribe_(path, parsedPath);
    }
    getValue(array, offset) {
        this.bind(); // bind all binding
        const firstValidIndex = this._targetGroup.nCachedObjects_, binding = this._bindings[firstValidIndex];
        // and only call .getValue on the first
        if (binding !== undefined) binding.getValue(array, offset);
    }
    setValue(array, offset) {
        const bindings = this._bindings;
        for(let i = this._targetGroup.nCachedObjects_, n = bindings.length; i !== n; ++i)bindings[i].setValue(array, offset);
    }
    bind() {
        const bindings = this._bindings;
        for(let i = this._targetGroup.nCachedObjects_, n = bindings.length; i !== n; ++i)bindings[i].bind();
    }
    unbind() {
        const bindings = this._bindings;
        for(let i = this._targetGroup.nCachedObjects_, n = bindings.length; i !== n; ++i)bindings[i].unbind();
    }
}
// Note: This class uses a State pattern on a per-method basis:
// 'bind' sets 'this.getValue' / 'setValue' and shadows the
// prototype version of these methods with one that represents
// the bound state. When the property is not found, the methods
// become no-ops.
class $d5b33d7c30034067$export$7bf70fcf9f891893 {
    constructor(rootNode, path, parsedPath){
        this.path = path;
        this.parsedPath = parsedPath || $d5b33d7c30034067$export$7bf70fcf9f891893.parseTrackName(path);
        this.node = $d5b33d7c30034067$export$7bf70fcf9f891893.findNode(rootNode, this.parsedPath.nodeName);
        this.rootNode = rootNode;
        // initial state of these methods that calls 'bind'
        this.getValue = this._getValue_unbound;
        this.setValue = this._setValue_unbound;
    }
    static create(root, path, parsedPath) {
        if (!(root && root.isAnimationObjectGroup)) return new $d5b33d7c30034067$export$7bf70fcf9f891893(root, path, parsedPath);
        else return new $d5b33d7c30034067$export$7bf70fcf9f891893.Composite(root, path, parsedPath);
    }
    /**
	 * Replaces spaces with underscores and removes unsupported characters from
	 * node names, to ensure compatibility with parseTrackName().
	 *
	 * @param {string} name Node name to be sanitized.
	 * @return {string}
	 */ static sanitizeNodeName(name) {
        return name.replace(/\s/g, '_').replace($d5b33d7c30034067$var$_reservedRe, '');
    }
    static parseTrackName(trackName) {
        const matches = $d5b33d7c30034067$var$_trackRe.exec(trackName);
        if (matches === null) throw new Error('PropertyBinding: Cannot parse trackName: ' + trackName);
        const results = {
            // directoryName: matches[ 1 ], // (tschw) currently unused
            nodeName: matches[2],
            objectName: matches[3],
            objectIndex: matches[4],
            propertyName: matches[5],
            propertyIndex: matches[6]
        };
        const lastDot = results.nodeName && results.nodeName.lastIndexOf('.');
        if (lastDot !== undefined && lastDot !== -1) {
            const objectName = results.nodeName.substring(lastDot + 1);
            // Object names must be checked against an allowlist. Otherwise, there
            // is no way to parse 'foo.bar.baz': 'baz' must be a property, but
            // 'bar' could be the objectName, or part of a nodeName (which can
            // include '.' characters).
            if ($d5b33d7c30034067$var$_supportedObjectNames.indexOf(objectName) !== -1) {
                results.nodeName = results.nodeName.substring(0, lastDot);
                results.objectName = objectName;
            }
        }
        if (results.propertyName === null || results.propertyName.length === 0) throw new Error('PropertyBinding: can not parse propertyName from trackName: ' + trackName);
        return results;
    }
    static findNode(root, nodeName) {
        if (nodeName === undefined || nodeName === '' || nodeName === '.' || nodeName === -1 || nodeName === root.name || nodeName === root.uuid) return root;
        // search into skeleton bones.
        if (root.skeleton) {
            const bone = root.skeleton.getBoneByName(nodeName);
            if (bone !== undefined) return bone;
        }
        // search into node subtree.
        if (root.children) {
            const searchNodeSubtree = function(children) {
                for(let i = 0; i < children.length; i++){
                    const childNode = children[i];
                    if (childNode.name === nodeName || childNode.uuid === nodeName) return childNode;
                    const result = searchNodeSubtree(childNode.children);
                    if (result) return result;
                }
                return null;
            };
            const subTreeNode = searchNodeSubtree(root.children);
            if (subTreeNode) return subTreeNode;
        }
        return null;
    }
    // these are used to "bind" a nonexistent property
    _getValue_unavailable() {}
    _setValue_unavailable() {}
    // Getters
    _getValue_direct(buffer, offset) {
        buffer[offset] = this.targetObject[this.propertyName];
    }
    _getValue_array(buffer, offset) {
        const source = this.resolvedProperty;
        for(let i = 0, n = source.length; i !== n; ++i)buffer[offset++] = source[i];
    }
    _getValue_arrayElement(buffer, offset) {
        buffer[offset] = this.resolvedProperty[this.propertyIndex];
    }
    _getValue_toArray(buffer, offset) {
        this.resolvedProperty.toArray(buffer, offset);
    }
    // Direct
    _setValue_direct(buffer, offset) {
        this.targetObject[this.propertyName] = buffer[offset];
    }
    _setValue_direct_setNeedsUpdate(buffer, offset) {
        this.targetObject[this.propertyName] = buffer[offset];
        this.targetObject.needsUpdate = true;
    }
    _setValue_direct_setMatrixWorldNeedsUpdate(buffer, offset) {
        this.targetObject[this.propertyName] = buffer[offset];
        this.targetObject.matrixWorldNeedsUpdate = true;
    }
    // EntireArray
    _setValue_array(buffer, offset) {
        const dest = this.resolvedProperty;
        for(let i = 0, n = dest.length; i !== n; ++i)dest[i] = buffer[offset++];
    }
    _setValue_array_setNeedsUpdate(buffer, offset) {
        const dest = this.resolvedProperty;
        for(let i = 0, n = dest.length; i !== n; ++i)dest[i] = buffer[offset++];
        this.targetObject.needsUpdate = true;
    }
    _setValue_array_setMatrixWorldNeedsUpdate(buffer, offset) {
        const dest = this.resolvedProperty;
        for(let i = 0, n = dest.length; i !== n; ++i)dest[i] = buffer[offset++];
        this.targetObject.matrixWorldNeedsUpdate = true;
    }
    // ArrayElement
    _setValue_arrayElement(buffer, offset) {
        this.resolvedProperty[this.propertyIndex] = buffer[offset];
    }
    _setValue_arrayElement_setNeedsUpdate(buffer, offset) {
        this.resolvedProperty[this.propertyIndex] = buffer[offset];
        this.targetObject.needsUpdate = true;
    }
    _setValue_arrayElement_setMatrixWorldNeedsUpdate(buffer, offset) {
        this.resolvedProperty[this.propertyIndex] = buffer[offset];
        this.targetObject.matrixWorldNeedsUpdate = true;
    }
    // HasToFromArray
    _setValue_fromArray(buffer, offset) {
        this.resolvedProperty.fromArray(buffer, offset);
    }
    _setValue_fromArray_setNeedsUpdate(buffer, offset) {
        this.resolvedProperty.fromArray(buffer, offset);
        this.targetObject.needsUpdate = true;
    }
    _setValue_fromArray_setMatrixWorldNeedsUpdate(buffer, offset) {
        this.resolvedProperty.fromArray(buffer, offset);
        this.targetObject.matrixWorldNeedsUpdate = true;
    }
    _getValue_unbound(targetArray, offset) {
        this.bind();
        this.getValue(targetArray, offset);
    }
    _setValue_unbound(sourceArray, offset) {
        this.bind();
        this.setValue(sourceArray, offset);
    }
    // create getter / setter pair for a property in the scene graph
    bind() {
        let targetObject = this.node;
        const parsedPath = this.parsedPath;
        const objectName = parsedPath.objectName;
        const propertyName = parsedPath.propertyName;
        let propertyIndex = parsedPath.propertyIndex;
        if (!targetObject) {
            targetObject = $d5b33d7c30034067$export$7bf70fcf9f891893.findNode(this.rootNode, parsedPath.nodeName);
            this.node = targetObject;
        }
        // set fail state so we can just 'return' on error
        this.getValue = this._getValue_unavailable;
        this.setValue = this._setValue_unavailable;
        // ensure there is a value node
        if (!targetObject) {
            console.warn('THREE.PropertyBinding: No target node found for track: ' + this.path + '.');
            return;
        }
        if (objectName) {
            let objectIndex = parsedPath.objectIndex;
            // special cases were we need to reach deeper into the hierarchy to get the face materials....
            switch(objectName){
                case 'materials':
                    if (!targetObject.material) {
                        console.error('THREE.PropertyBinding: Can not bind to material as node does not have a material.', this);
                        return;
                    }
                    if (!targetObject.material.materials) {
                        console.error('THREE.PropertyBinding: Can not bind to material.materials as node.material does not have a materials array.', this);
                        return;
                    }
                    targetObject = targetObject.material.materials;
                    break;
                case 'bones':
                    if (!targetObject.skeleton) {
                        console.error('THREE.PropertyBinding: Can not bind to bones as node does not have a skeleton.', this);
                        return;
                    }
                    // potential future optimization: skip this if propertyIndex is already an integer
                    // and convert the integer string to a true integer.
                    targetObject = targetObject.skeleton.bones;
                    // support resolving morphTarget names into indices.
                    for(let i = 0; i < targetObject.length; i++)if (targetObject[i].name === objectIndex) {
                        objectIndex = i;
                        break;
                    }
                    break;
                case 'map':
                    if ('map' in targetObject) {
                        targetObject = targetObject.map;
                        break;
                    }
                    if (!targetObject.material) {
                        console.error('THREE.PropertyBinding: Can not bind to material as node does not have a material.', this);
                        return;
                    }
                    if (!targetObject.material.map) {
                        console.error('THREE.PropertyBinding: Can not bind to material.map as node.material does not have a map.', this);
                        return;
                    }
                    targetObject = targetObject.material.map;
                    break;
                default:
                    if (targetObject[objectName] === undefined) {
                        console.error('THREE.PropertyBinding: Can not bind to objectName of node undefined.', this);
                        return;
                    }
                    targetObject = targetObject[objectName];
            }
            if (objectIndex !== undefined) {
                if (targetObject[objectIndex] === undefined) {
                    console.error('THREE.PropertyBinding: Trying to bind to objectIndex of objectName, but is undefined.', this, targetObject);
                    return;
                }
                targetObject = targetObject[objectIndex];
            }
        }
        // resolve property
        const nodeProperty = targetObject[propertyName];
        if (nodeProperty === undefined) {
            const nodeName = parsedPath.nodeName;
            console.error('THREE.PropertyBinding: Trying to update property for track: ' + nodeName + '.' + propertyName + ' but it wasn\'t found.', targetObject);
            return;
        }
        // determine versioning scheme
        let versioning = this.Versioning.None;
        this.targetObject = targetObject;
        if (targetObject.needsUpdate !== undefined) versioning = this.Versioning.NeedsUpdate;
        else if (targetObject.matrixWorldNeedsUpdate !== undefined) versioning = this.Versioning.MatrixWorldNeedsUpdate;
        // determine how the property gets bound
        let bindingType = this.BindingType.Direct;
        if (propertyIndex !== undefined) {
            // access a sub element of the property array (only primitives are supported right now)
            if (propertyName === 'morphTargetInfluences') {
                // potential optimization, skip this if propertyIndex is already an integer, and convert the integer string to a true integer.
                // support resolving morphTarget names into indices.
                if (!targetObject.geometry) {
                    console.error('THREE.PropertyBinding: Can not bind to morphTargetInfluences because node does not have a geometry.', this);
                    return;
                }
                if (!targetObject.geometry.morphAttributes) {
                    console.error('THREE.PropertyBinding: Can not bind to morphTargetInfluences because node does not have a geometry.morphAttributes.', this);
                    return;
                }
                if (targetObject.morphTargetDictionary[propertyIndex] !== undefined) propertyIndex = targetObject.morphTargetDictionary[propertyIndex];
            }
            bindingType = this.BindingType.ArrayElement;
            this.resolvedProperty = nodeProperty;
            this.propertyIndex = propertyIndex;
        } else if (nodeProperty.fromArray !== undefined && nodeProperty.toArray !== undefined) {
            // must use copy for Object3D.Euler/Quaternion
            bindingType = this.BindingType.HasFromToArray;
            this.resolvedProperty = nodeProperty;
        } else if (Array.isArray(nodeProperty)) {
            bindingType = this.BindingType.EntireArray;
            this.resolvedProperty = nodeProperty;
        } else this.propertyName = propertyName;
        // select getter / setter
        this.getValue = this.GetterByBindingType[bindingType];
        this.setValue = this.SetterByBindingTypeAndVersioning[bindingType][versioning];
    }
    unbind() {
        this.node = null;
        // back to the prototype version of getValue / setValue
        // note: avoiding to mutate the shape of 'this' via 'delete'
        this.getValue = this._getValue_unbound;
        this.setValue = this._setValue_unbound;
    }
}
$d5b33d7c30034067$export$7bf70fcf9f891893.Composite = $d5b33d7c30034067$var$Composite;
$d5b33d7c30034067$export$7bf70fcf9f891893.prototype.BindingType = {
    Direct: 0,
    EntireArray: 1,
    ArrayElement: 2,
    HasFromToArray: 3
};
$d5b33d7c30034067$export$7bf70fcf9f891893.prototype.Versioning = {
    None: 0,
    NeedsUpdate: 1,
    MatrixWorldNeedsUpdate: 2
};
$d5b33d7c30034067$export$7bf70fcf9f891893.prototype.GetterByBindingType = [
    $d5b33d7c30034067$export$7bf70fcf9f891893.prototype._getValue_direct,
    $d5b33d7c30034067$export$7bf70fcf9f891893.prototype._getValue_array,
    $d5b33d7c30034067$export$7bf70fcf9f891893.prototype._getValue_arrayElement,
    $d5b33d7c30034067$export$7bf70fcf9f891893.prototype._getValue_toArray
];
$d5b33d7c30034067$export$7bf70fcf9f891893.prototype.SetterByBindingTypeAndVersioning = [
    [
        // Direct
        $d5b33d7c30034067$export$7bf70fcf9f891893.prototype._setValue_direct,
        $d5b33d7c30034067$export$7bf70fcf9f891893.prototype._setValue_direct_setNeedsUpdate,
        $d5b33d7c30034067$export$7bf70fcf9f891893.prototype._setValue_direct_setMatrixWorldNeedsUpdate
    ],
    [
        // EntireArray
        $d5b33d7c30034067$export$7bf70fcf9f891893.prototype._setValue_array,
        $d5b33d7c30034067$export$7bf70fcf9f891893.prototype._setValue_array_setNeedsUpdate,
        $d5b33d7c30034067$export$7bf70fcf9f891893.prototype._setValue_array_setMatrixWorldNeedsUpdate
    ],
    [
        // ArrayElement
        $d5b33d7c30034067$export$7bf70fcf9f891893.prototype._setValue_arrayElement,
        $d5b33d7c30034067$export$7bf70fcf9f891893.prototype._setValue_arrayElement_setNeedsUpdate,
        $d5b33d7c30034067$export$7bf70fcf9f891893.prototype._setValue_arrayElement_setMatrixWorldNeedsUpdate
    ],
    [
        // HasToFromArray
        $d5b33d7c30034067$export$7bf70fcf9f891893.prototype._setValue_fromArray,
        $d5b33d7c30034067$export$7bf70fcf9f891893.prototype._setValue_fromArray_setNeedsUpdate,
        $d5b33d7c30034067$export$7bf70fcf9f891893.prototype._setValue_fromArray_setMatrixWorldNeedsUpdate
    ]
];
/**
 *
 * A group of objects that receives a shared animation state.
 *
 * Usage:
 *
 *  - Add objects you would otherwise pass as 'root' to the
 *    constructor or the .clipAction method of AnimationMixer.
 *
 *  - Instead pass this object as 'root'.
 *
 *  - You can also add and remove objects later when the mixer
 *    is running.
 *
 * Note:
 *
 *    Objects of this class appear as one object to the mixer,
 *    so cache control of the individual objects must be done
 *    on the group.
 *
 * Limitation:
 *
 *  - The animated properties must be compatible among the
 *    all objects in the group.
 *
 *  - A single property can either be controlled through a
 *    target group or directly, but not both.
 */ class $d5b33d7c30034067$export$30619c2afd3f34db {
    constructor(){
        this.isAnimationObjectGroup = true;
        this.uuid = $d5b33d7c30034067$var$generateUUID();
        // cached objects followed by the active ones
        this._objects = Array.prototype.slice.call(arguments);
        this.nCachedObjects_ = 0; // threshold
        // note: read by PropertyBinding.Composite
        const indices = {};
        this._indicesByUUID = indices; // for bookkeeping
        for(let i = 0, n = arguments.length; i !== n; ++i)indices[arguments[i].uuid] = i;
        this._paths = []; // inside: string
        this._parsedPaths = []; // inside: { we don't care, here }
        this._bindings = []; // inside: Array< PropertyBinding >
        this._bindingsIndicesByPath = {}; // inside: indices in these arrays
        const scope = this;
        this.stats = {
            objects: {
                get total () {
                    return scope._objects.length;
                },
                get inUse () {
                    return this.total - scope.nCachedObjects_;
                }
            },
            get bindingsPerObject () {
                return scope._bindings.length;
            }
        };
    }
    add() {
        const objects = this._objects, indicesByUUID = this._indicesByUUID, paths = this._paths, parsedPaths = this._parsedPaths, bindings = this._bindings, nBindings = bindings.length;
        let knownObject = undefined, nObjects = objects.length, nCachedObjects = this.nCachedObjects_;
        for(let i = 0, n = arguments.length; i !== n; ++i){
            const object = arguments[i], uuid = object.uuid;
            let index = indicesByUUID[uuid];
            if (index === undefined) {
                // unknown object -> add it to the ACTIVE region
                index = nObjects++;
                indicesByUUID[uuid] = index;
                objects.push(object);
                // accounting is done, now do the same for all bindings
                for(let j = 0, m = nBindings; j !== m; ++j)bindings[j].push(new $d5b33d7c30034067$export$7bf70fcf9f891893(object, paths[j], parsedPaths[j]));
            } else if (index < nCachedObjects) {
                knownObject = objects[index];
                // move existing object to the ACTIVE region
                const firstActiveIndex = --nCachedObjects, lastCachedObject = objects[firstActiveIndex];
                indicesByUUID[lastCachedObject.uuid] = index;
                objects[index] = lastCachedObject;
                indicesByUUID[uuid] = firstActiveIndex;
                objects[firstActiveIndex] = object;
                // accounting is done, now do the same for all bindings
                for(let j = 0, m = nBindings; j !== m; ++j){
                    const bindingsForPath = bindings[j], lastCached = bindingsForPath[firstActiveIndex];
                    let binding = bindingsForPath[index];
                    bindingsForPath[index] = lastCached;
                    if (binding === undefined) // since we do not bother to create new bindings
                    // for objects that are cached, the binding may
                    // or may not exist
                    binding = new $d5b33d7c30034067$export$7bf70fcf9f891893(object, paths[j], parsedPaths[j]);
                    bindingsForPath[firstActiveIndex] = binding;
                }
            } else if (objects[index] !== knownObject) console.error("THREE.AnimationObjectGroup: Different objects with the same UUID detected. Clean the caches or recreate your infrastructure when reloading scenes.");
             // else the object is already where we want it to be
        } // for arguments
        this.nCachedObjects_ = nCachedObjects;
    }
    remove() {
        const objects = this._objects, indicesByUUID = this._indicesByUUID, bindings = this._bindings, nBindings = bindings.length;
        let nCachedObjects = this.nCachedObjects_;
        for(let i = 0, n = arguments.length; i !== n; ++i){
            const object = arguments[i], uuid = object.uuid, index = indicesByUUID[uuid];
            if (index !== undefined && index >= nCachedObjects) {
                // move existing object into the CACHED region
                const lastCachedIndex = nCachedObjects++, firstActiveObject = objects[lastCachedIndex];
                indicesByUUID[firstActiveObject.uuid] = index;
                objects[index] = firstActiveObject;
                indicesByUUID[uuid] = lastCachedIndex;
                objects[lastCachedIndex] = object;
                // accounting is done, now do the same for all bindings
                for(let j = 0, m = nBindings; j !== m; ++j){
                    const bindingsForPath = bindings[j], firstActive = bindingsForPath[lastCachedIndex], binding = bindingsForPath[index];
                    bindingsForPath[index] = firstActive;
                    bindingsForPath[lastCachedIndex] = binding;
                }
            }
        } // for arguments
        this.nCachedObjects_ = nCachedObjects;
    }
    // remove & forget
    uncache() {
        const objects = this._objects, indicesByUUID = this._indicesByUUID, bindings = this._bindings, nBindings = bindings.length;
        let nCachedObjects = this.nCachedObjects_, nObjects = objects.length;
        for(let i = 0, n = arguments.length; i !== n; ++i){
            const object = arguments[i], uuid = object.uuid, index = indicesByUUID[uuid];
            if (index !== undefined) {
                delete indicesByUUID[uuid];
                if (index < nCachedObjects) {
                    // object is cached, shrink the CACHED region
                    const firstActiveIndex = --nCachedObjects, lastCachedObject = objects[firstActiveIndex], lastIndex = --nObjects, lastObject = objects[lastIndex];
                    // last cached object takes this object's place
                    indicesByUUID[lastCachedObject.uuid] = index;
                    objects[index] = lastCachedObject;
                    // last object goes to the activated slot and pop
                    indicesByUUID[lastObject.uuid] = firstActiveIndex;
                    objects[firstActiveIndex] = lastObject;
                    objects.pop();
                    // accounting is done, now do the same for all bindings
                    for(let j = 0, m = nBindings; j !== m; ++j){
                        const bindingsForPath = bindings[j], lastCached = bindingsForPath[firstActiveIndex], last = bindingsForPath[lastIndex];
                        bindingsForPath[index] = lastCached;
                        bindingsForPath[firstActiveIndex] = last;
                        bindingsForPath.pop();
                    }
                } else {
                    // object is active, just swap with the last and pop
                    const lastIndex = --nObjects, lastObject = objects[lastIndex];
                    if (lastIndex > 0) indicesByUUID[lastObject.uuid] = index;
                    objects[index] = lastObject;
                    objects.pop();
                    // accounting is done, now do the same for all bindings
                    for(let j = 0, m = nBindings; j !== m; ++j){
                        const bindingsForPath = bindings[j];
                        bindingsForPath[index] = bindingsForPath[lastIndex];
                        bindingsForPath.pop();
                    }
                } // cached or active
            } // if object is known
        } // for arguments
        this.nCachedObjects_ = nCachedObjects;
    }
    // Internal interface used by befriended PropertyBinding.Composite:
    subscribe_(path, parsedPath) {
        // returns an array of bindings for the given path that is changed
        // according to the contained objects in the group
        const indicesByPath = this._bindingsIndicesByPath;
        let index = indicesByPath[path];
        const bindings = this._bindings;
        if (index !== undefined) return bindings[index];
        const paths = this._paths, parsedPaths = this._parsedPaths, objects = this._objects, nObjects = objects.length, nCachedObjects = this.nCachedObjects_, bindingsForPath = new Array(nObjects);
        index = bindings.length;
        indicesByPath[path] = index;
        paths.push(path);
        parsedPaths.push(parsedPath);
        bindings.push(bindingsForPath);
        for(let i = nCachedObjects, n = objects.length; i !== n; ++i){
            const object = objects[i];
            bindingsForPath[i] = new $d5b33d7c30034067$export$7bf70fcf9f891893(object, path, parsedPath);
        }
        return bindingsForPath;
    }
    unsubscribe_(path) {
        // tells the group to forget about a property path and no longer
        // update the array previously obtained with 'subscribe_'
        const indicesByPath = this._bindingsIndicesByPath, index = indicesByPath[path];
        if (index !== undefined) {
            const paths = this._paths, parsedPaths = this._parsedPaths, bindings = this._bindings, lastBindingsIndex = bindings.length - 1, lastBindings = bindings[lastBindingsIndex], lastBindingsPath = path[lastBindingsIndex];
            indicesByPath[lastBindingsPath] = index;
            bindings[index] = lastBindings;
            bindings.pop();
            parsedPaths[index] = parsedPaths[lastBindingsIndex];
            parsedPaths.pop();
            paths[index] = paths[lastBindingsIndex];
            paths.pop();
        }
    }
}
class $d5b33d7c30034067$export$6946940a69e799e {
    constructor(mixer, clip, localRoot = null, blendMode = clip.blendMode){
        this._mixer = mixer;
        this._clip = clip;
        this._localRoot = localRoot;
        this.blendMode = blendMode;
        const tracks = clip.tracks, nTracks = tracks.length, interpolants = new Array(nTracks);
        const interpolantSettings = {
            endingStart: $d5b33d7c30034067$export$7f795934b84ab523,
            endingEnd: $d5b33d7c30034067$export$7f795934b84ab523
        };
        for(let i = 0; i !== nTracks; ++i){
            const interpolant = tracks[i].createInterpolant(null);
            interpolants[i] = interpolant;
            interpolant.settings = interpolantSettings;
        }
        this._interpolantSettings = interpolantSettings;
        this._interpolants = interpolants; // bound by the mixer
        // inside: PropertyMixer (managed by the mixer)
        this._propertyBindings = new Array(nTracks);
        this._cacheIndex = null; // for the memory manager
        this._byClipCacheIndex = null; // for the memory manager
        this._timeScaleInterpolant = null;
        this._weightInterpolant = null;
        this.loop = $d5b33d7c30034067$export$dfaf4422ce096e29;
        this._loopCount = -1;
        // global mixer time when the action is to be started
        // it's set back to 'null' upon start of the action
        this._startTime = null;
        // scaled local time of the action
        // gets clamped or wrapped to 0..clip.duration according to loop
        this.time = 0;
        this.timeScale = 1;
        this._effectiveTimeScale = 1;
        this.weight = 1;
        this._effectiveWeight = 1;
        this.repetitions = Infinity; // no. of repetitions when looping
        this.paused = false; // true -> zero effective time scale
        this.enabled = true; // false -> zero effective weight
        this.clampWhenFinished = false; // keep feeding the last frame?
        this.zeroSlopeAtStart = true; // for smooth interpolation w/o separate
        this.zeroSlopeAtEnd = true; // clips for start, loop and end
    }
    // State & Scheduling
    play() {
        this._mixer._activateAction(this);
        return this;
    }
    stop() {
        this._mixer._deactivateAction(this);
        return this.reset();
    }
    reset() {
        this.paused = false;
        this.enabled = true;
        this.time = 0; // restart clip
        this._loopCount = -1; // forget previous loops
        this._startTime = null; // forget scheduling
        return this.stopFading().stopWarping();
    }
    isRunning() {
        return this.enabled && !this.paused && this.timeScale !== 0 && this._startTime === null && this._mixer._isActiveAction(this);
    }
    // return true when play has been called
    isScheduled() {
        return this._mixer._isActiveAction(this);
    }
    startAt(time) {
        this._startTime = time;
        return this;
    }
    setLoop(mode, repetitions) {
        this.loop = mode;
        this.repetitions = repetitions;
        return this;
    }
    // Weight
    // set the weight stopping any scheduled fading
    // although .enabled = false yields an effective weight of zero, this
    // method does *not* change .enabled, because it would be confusing
    setEffectiveWeight(weight) {
        this.weight = weight;
        // note: same logic as when updated at runtime
        this._effectiveWeight = this.enabled ? weight : 0;
        return this.stopFading();
    }
    // return the weight considering fading and .enabled
    getEffectiveWeight() {
        return this._effectiveWeight;
    }
    fadeIn(duration) {
        return this._scheduleFading(duration, 0, 1);
    }
    fadeOut(duration) {
        return this._scheduleFading(duration, 1, 0);
    }
    crossFadeFrom(fadeOutAction, duration, warp) {
        fadeOutAction.fadeOut(duration);
        this.fadeIn(duration);
        if (warp) {
            const fadeInDuration = this._clip.duration, fadeOutDuration = fadeOutAction._clip.duration, startEndRatio = fadeOutDuration / fadeInDuration, endStartRatio = fadeInDuration / fadeOutDuration;
            fadeOutAction.warp(1.0, startEndRatio, duration);
            this.warp(endStartRatio, 1.0, duration);
        }
        return this;
    }
    crossFadeTo(fadeInAction, duration, warp) {
        return fadeInAction.crossFadeFrom(this, duration, warp);
    }
    stopFading() {
        const weightInterpolant = this._weightInterpolant;
        if (weightInterpolant !== null) {
            this._weightInterpolant = null;
            this._mixer._takeBackControlInterpolant(weightInterpolant);
        }
        return this;
    }
    // Time Scale Control
    // set the time scale stopping any scheduled warping
    // although .paused = true yields an effective time scale of zero, this
    // method does *not* change .paused, because it would be confusing
    setEffectiveTimeScale(timeScale) {
        this.timeScale = timeScale;
        this._effectiveTimeScale = this.paused ? 0 : timeScale;
        return this.stopWarping();
    }
    // return the time scale considering warping and .paused
    getEffectiveTimeScale() {
        return this._effectiveTimeScale;
    }
    setDuration(duration) {
        this.timeScale = this._clip.duration / duration;
        return this.stopWarping();
    }
    syncWith(action) {
        this.time = action.time;
        this.timeScale = action.timeScale;
        return this.stopWarping();
    }
    halt(duration) {
        return this.warp(this._effectiveTimeScale, 0, duration);
    }
    warp(startTimeScale, endTimeScale, duration) {
        const mixer = this._mixer, now = mixer.time, timeScale = this.timeScale;
        let interpolant = this._timeScaleInterpolant;
        if (interpolant === null) {
            interpolant = mixer._lendControlInterpolant();
            this._timeScaleInterpolant = interpolant;
        }
        const times = interpolant.parameterPositions, values = interpolant.sampleValues;
        times[0] = now;
        times[1] = now + duration;
        values[0] = startTimeScale / timeScale;
        values[1] = endTimeScale / timeScale;
        return this;
    }
    stopWarping() {
        const timeScaleInterpolant = this._timeScaleInterpolant;
        if (timeScaleInterpolant !== null) {
            this._timeScaleInterpolant = null;
            this._mixer._takeBackControlInterpolant(timeScaleInterpolant);
        }
        return this;
    }
    // Object Accessors
    getMixer() {
        return this._mixer;
    }
    getClip() {
        return this._clip;
    }
    getRoot() {
        return this._localRoot || this._mixer._root;
    }
    // Interna
    _update(time, deltaTime, timeDirection, accuIndex) {
        // called by the mixer
        if (!this.enabled) {
            // call ._updateWeight() to update ._effectiveWeight
            this._updateWeight(time);
            return;
        }
        const startTime = this._startTime;
        if (startTime !== null) {
            // check for scheduled start of action
            const timeRunning = (time - startTime) * timeDirection;
            if (timeRunning < 0 || timeDirection === 0) deltaTime = 0;
            else {
                this._startTime = null; // unschedule
                deltaTime = timeDirection * timeRunning;
            }
        }
        // apply time scale and advance time
        deltaTime *= this._updateTimeScale(time);
        const clipTime = this._updateTime(deltaTime);
        // note: _updateTime may disable the action resulting in
        // an effective weight of 0
        const weight = this._updateWeight(time);
        if (weight > 0) {
            const interpolants = this._interpolants;
            const propertyMixers = this._propertyBindings;
            switch(this.blendMode){
                case $d5b33d7c30034067$export$d875e029ef558d3:
                    for(let j = 0, m = interpolants.length; j !== m; ++j){
                        interpolants[j].evaluate(clipTime);
                        propertyMixers[j].accumulateAdditive(weight);
                    }
                    break;
                case $d5b33d7c30034067$export$bcfbbdcf8de7f8cd:
                default:
                    for(let j = 0, m = interpolants.length; j !== m; ++j){
                        interpolants[j].evaluate(clipTime);
                        propertyMixers[j].accumulate(accuIndex, weight);
                    }
            }
        }
    }
    _updateWeight(time) {
        let weight = 0;
        if (this.enabled) {
            weight = this.weight;
            const interpolant = this._weightInterpolant;
            if (interpolant !== null) {
                const interpolantValue = interpolant.evaluate(time)[0];
                weight *= interpolantValue;
                if (time > interpolant.parameterPositions[1]) {
                    this.stopFading();
                    if (interpolantValue === 0) // faded out, disable
                    this.enabled = false;
                }
            }
        }
        this._effectiveWeight = weight;
        return weight;
    }
    _updateTimeScale(time) {
        let timeScale = 0;
        if (!this.paused) {
            timeScale = this.timeScale;
            const interpolant = this._timeScaleInterpolant;
            if (interpolant !== null) {
                const interpolantValue = interpolant.evaluate(time)[0];
                timeScale *= interpolantValue;
                if (time > interpolant.parameterPositions[1]) {
                    this.stopWarping();
                    if (timeScale === 0) // motion has halted, pause
                    this.paused = true;
                    else // warp done - apply final time scale
                    this.timeScale = timeScale;
                }
            }
        }
        this._effectiveTimeScale = timeScale;
        return timeScale;
    }
    _updateTime(deltaTime) {
        const duration = this._clip.duration;
        const loop = this.loop;
        let time = this.time + deltaTime;
        let loopCount = this._loopCount;
        const pingPong = loop === $d5b33d7c30034067$export$f8f6f2041b78e210;
        if (deltaTime === 0) {
            if (loopCount === -1) return time;
            return pingPong && (loopCount & 1) === 1 ? duration - time : time;
        }
        if (loop === $d5b33d7c30034067$export$d62fdc9d1b1cccad) {
            if (loopCount === -1) {
                // just started
                this._loopCount = 0;
                this._setEndings(true, true, false);
            }
            handle_stop: {
                if (time >= duration) time = duration;
                else if (time < 0) time = 0;
                else {
                    this.time = time;
                    break handle_stop;
                }
                if (this.clampWhenFinished) this.paused = true;
                else this.enabled = false;
                this.time = time;
                this._mixer.dispatchEvent({
                    type: 'finished',
                    action: this,
                    direction: deltaTime < 0 ? -1 : 1
                });
            }
        } else {
            if (loopCount === -1) {
                // just started
                if (deltaTime >= 0) {
                    loopCount = 0;
                    this._setEndings(true, this.repetitions === 0, pingPong);
                } else // when looping in reverse direction, the initial
                // transition through zero counts as a repetition,
                // so leave loopCount at -1
                this._setEndings(this.repetitions === 0, true, pingPong);
            }
            if (time >= duration || time < 0) {
                // wrap around
                const loopDelta = Math.floor(time / duration); // signed
                time -= duration * loopDelta;
                loopCount += Math.abs(loopDelta);
                const pending = this.repetitions - loopCount;
                if (pending <= 0) {
                    // have to stop (switch state, clamp time, fire event)
                    if (this.clampWhenFinished) this.paused = true;
                    else this.enabled = false;
                    time = deltaTime > 0 ? duration : 0;
                    this.time = time;
                    this._mixer.dispatchEvent({
                        type: 'finished',
                        action: this,
                        direction: deltaTime > 0 ? 1 : -1
                    });
                } else {
                    // keep running
                    if (pending === 1) {
                        // entering the last round
                        const atStart = deltaTime < 0;
                        this._setEndings(atStart, !atStart, pingPong);
                    } else this._setEndings(false, false, pingPong);
                    this._loopCount = loopCount;
                    this.time = time;
                    this._mixer.dispatchEvent({
                        type: 'loop',
                        action: this,
                        loopDelta: loopDelta
                    });
                }
            } else this.time = time;
            if (pingPong && (loopCount & 1) === 1) // invert time for the "pong round"
            return duration - time;
        }
        return time;
    }
    _setEndings(atStart, atEnd, pingPong) {
        const settings = this._interpolantSettings;
        if (pingPong) {
            settings.endingStart = $d5b33d7c30034067$export$24a4ccb5099273b5;
            settings.endingEnd = $d5b33d7c30034067$export$24a4ccb5099273b5;
        } else {
            // assuming for LoopOnce atStart == atEnd == true
            if (atStart) settings.endingStart = this.zeroSlopeAtStart ? $d5b33d7c30034067$export$24a4ccb5099273b5 : $d5b33d7c30034067$export$7f795934b84ab523;
            else settings.endingStart = $d5b33d7c30034067$export$8e8c3ecdcd8e1fee;
            if (atEnd) settings.endingEnd = this.zeroSlopeAtEnd ? $d5b33d7c30034067$export$24a4ccb5099273b5 : $d5b33d7c30034067$export$7f795934b84ab523;
            else settings.endingEnd = $d5b33d7c30034067$export$8e8c3ecdcd8e1fee;
        }
    }
    _scheduleFading(duration, weightNow, weightThen) {
        const mixer = this._mixer, now = mixer.time;
        let interpolant = this._weightInterpolant;
        if (interpolant === null) {
            interpolant = mixer._lendControlInterpolant();
            this._weightInterpolant = interpolant;
        }
        const times = interpolant.parameterPositions, values = interpolant.sampleValues;
        times[0] = now;
        values[0] = weightNow;
        times[1] = now + duration;
        values[1] = weightThen;
        return this;
    }
}
const $d5b33d7c30034067$var$_controlInterpolantsResultBuffer = new Float32Array(1);
class $d5b33d7c30034067$export$fbd77e5aefaa0102 extends $d5b33d7c30034067$export$ec8b666c5fe2c75a {
    constructor(root){
        super();
        this._root = root;
        this._initMemoryManager();
        this._accuIndex = 0;
        this.time = 0;
        this.timeScale = 1.0;
    }
    _bindAction(action, prototypeAction) {
        const root = action._localRoot || this._root, tracks = action._clip.tracks, nTracks = tracks.length, bindings = action._propertyBindings, interpolants = action._interpolants, rootUuid = root.uuid, bindingsByRoot = this._bindingsByRootAndName;
        let bindingsByName = bindingsByRoot[rootUuid];
        if (bindingsByName === undefined) {
            bindingsByName = {};
            bindingsByRoot[rootUuid] = bindingsByName;
        }
        for(let i = 0; i !== nTracks; ++i){
            const track = tracks[i], trackName = track.name;
            let binding = bindingsByName[trackName];
            if (binding !== undefined) {
                ++binding.referenceCount;
                bindings[i] = binding;
            } else {
                binding = bindings[i];
                if (binding !== undefined) {
                    // existing binding, make sure the cache knows
                    if (binding._cacheIndex === null) {
                        ++binding.referenceCount;
                        this._addInactiveBinding(binding, rootUuid, trackName);
                    }
                    continue;
                }
                const path = prototypeAction && prototypeAction._propertyBindings[i].binding.parsedPath;
                binding = new $d5b33d7c30034067$export$dfe0af1ca1acb78a($d5b33d7c30034067$export$7bf70fcf9f891893.create(root, trackName, path), track.ValueTypeName, track.getValueSize());
                ++binding.referenceCount;
                this._addInactiveBinding(binding, rootUuid, trackName);
                bindings[i] = binding;
            }
            interpolants[i].resultBuffer = binding.buffer;
        }
    }
    _activateAction(action) {
        if (!this._isActiveAction(action)) {
            if (action._cacheIndex === null) {
                // this action has been forgotten by the cache, but the user
                // appears to be still using it -> rebind
                const rootUuid = (action._localRoot || this._root).uuid, clipUuid = action._clip.uuid, actionsForClip = this._actionsByClip[clipUuid];
                this._bindAction(action, actionsForClip && actionsForClip.knownActions[0]);
                this._addInactiveAction(action, clipUuid, rootUuid);
            }
            const bindings = action._propertyBindings;
            // increment reference counts / sort out state
            for(let i = 0, n = bindings.length; i !== n; ++i){
                const binding = bindings[i];
                if (binding.useCount++ === 0) {
                    this._lendBinding(binding);
                    binding.saveOriginalState();
                }
            }
            this._lendAction(action);
        }
    }
    _deactivateAction(action) {
        if (this._isActiveAction(action)) {
            const bindings = action._propertyBindings;
            // decrement reference counts / sort out state
            for(let i = 0, n = bindings.length; i !== n; ++i){
                const binding = bindings[i];
                if (--binding.useCount === 0) {
                    binding.restoreOriginalState();
                    this._takeBackBinding(binding);
                }
            }
            this._takeBackAction(action);
        }
    }
    // Memory manager
    _initMemoryManager() {
        this._actions = []; // 'nActiveActions' followed by inactive ones
        this._nActiveActions = 0;
        this._actionsByClip = {};
        // inside:
        // {
        // 	knownActions: Array< AnimationAction > - used as prototypes
        // 	actionByRoot: AnimationAction - lookup
        // }
        this._bindings = []; // 'nActiveBindings' followed by inactive ones
        this._nActiveBindings = 0;
        this._bindingsByRootAndName = {}; // inside: Map< name, PropertyMixer >
        this._controlInterpolants = []; // same game as above
        this._nActiveControlInterpolants = 0;
        const scope = this;
        this.stats = {
            actions: {
                get total () {
                    return scope._actions.length;
                },
                get inUse () {
                    return scope._nActiveActions;
                }
            },
            bindings: {
                get total () {
                    return scope._bindings.length;
                },
                get inUse () {
                    return scope._nActiveBindings;
                }
            },
            controlInterpolants: {
                get total () {
                    return scope._controlInterpolants.length;
                },
                get inUse () {
                    return scope._nActiveControlInterpolants;
                }
            }
        };
    }
    // Memory management for AnimationAction objects
    _isActiveAction(action) {
        const index = action._cacheIndex;
        return index !== null && index < this._nActiveActions;
    }
    _addInactiveAction(action, clipUuid, rootUuid) {
        const actions = this._actions, actionsByClip = this._actionsByClip;
        let actionsForClip = actionsByClip[clipUuid];
        if (actionsForClip === undefined) {
            actionsForClip = {
                knownActions: [
                    action
                ],
                actionByRoot: {}
            };
            action._byClipCacheIndex = 0;
            actionsByClip[clipUuid] = actionsForClip;
        } else {
            const knownActions = actionsForClip.knownActions;
            action._byClipCacheIndex = knownActions.length;
            knownActions.push(action);
        }
        action._cacheIndex = actions.length;
        actions.push(action);
        actionsForClip.actionByRoot[rootUuid] = action;
    }
    _removeInactiveAction(action) {
        const actions = this._actions, lastInactiveAction = actions[actions.length - 1], cacheIndex = action._cacheIndex;
        lastInactiveAction._cacheIndex = cacheIndex;
        actions[cacheIndex] = lastInactiveAction;
        actions.pop();
        action._cacheIndex = null;
        const clipUuid = action._clip.uuid, actionsByClip = this._actionsByClip, actionsForClip = actionsByClip[clipUuid], knownActionsForClip = actionsForClip.knownActions, lastKnownAction = knownActionsForClip[knownActionsForClip.length - 1], byClipCacheIndex = action._byClipCacheIndex;
        lastKnownAction._byClipCacheIndex = byClipCacheIndex;
        knownActionsForClip[byClipCacheIndex] = lastKnownAction;
        knownActionsForClip.pop();
        action._byClipCacheIndex = null;
        const actionByRoot = actionsForClip.actionByRoot, rootUuid = (action._localRoot || this._root).uuid;
        delete actionByRoot[rootUuid];
        if (knownActionsForClip.length === 0) delete actionsByClip[clipUuid];
        this._removeInactiveBindingsForAction(action);
    }
    _removeInactiveBindingsForAction(action) {
        const bindings = action._propertyBindings;
        for(let i = 0, n = bindings.length; i !== n; ++i){
            const binding = bindings[i];
            if (--binding.referenceCount === 0) this._removeInactiveBinding(binding);
        }
    }
    _lendAction(action) {
        // [ active actions |  inactive actions  ]
        // [  active actions >| inactive actions ]
        //                 s        a
        //                  <-swap->
        //                 a        s
        const actions = this._actions, prevIndex = action._cacheIndex, lastActiveIndex = this._nActiveActions++, firstInactiveAction = actions[lastActiveIndex];
        action._cacheIndex = lastActiveIndex;
        actions[lastActiveIndex] = action;
        firstInactiveAction._cacheIndex = prevIndex;
        actions[prevIndex] = firstInactiveAction;
    }
    _takeBackAction(action) {
        // [  active actions  | inactive actions ]
        // [ active actions |< inactive actions  ]
        //        a        s
        //         <-swap->
        //        s        a
        const actions = this._actions, prevIndex = action._cacheIndex, firstInactiveIndex = --this._nActiveActions, lastActiveAction = actions[firstInactiveIndex];
        action._cacheIndex = firstInactiveIndex;
        actions[firstInactiveIndex] = action;
        lastActiveAction._cacheIndex = prevIndex;
        actions[prevIndex] = lastActiveAction;
    }
    // Memory management for PropertyMixer objects
    _addInactiveBinding(binding, rootUuid, trackName) {
        const bindingsByRoot = this._bindingsByRootAndName, bindings = this._bindings;
        let bindingByName = bindingsByRoot[rootUuid];
        if (bindingByName === undefined) {
            bindingByName = {};
            bindingsByRoot[rootUuid] = bindingByName;
        }
        bindingByName[trackName] = binding;
        binding._cacheIndex = bindings.length;
        bindings.push(binding);
    }
    _removeInactiveBinding(binding) {
        const bindings = this._bindings, propBinding = binding.binding, rootUuid = propBinding.rootNode.uuid, trackName = propBinding.path, bindingsByRoot = this._bindingsByRootAndName, bindingByName = bindingsByRoot[rootUuid], lastInactiveBinding = bindings[bindings.length - 1], cacheIndex = binding._cacheIndex;
        lastInactiveBinding._cacheIndex = cacheIndex;
        bindings[cacheIndex] = lastInactiveBinding;
        bindings.pop();
        delete bindingByName[trackName];
        if (Object.keys(bindingByName).length === 0) delete bindingsByRoot[rootUuid];
    }
    _lendBinding(binding) {
        const bindings = this._bindings, prevIndex = binding._cacheIndex, lastActiveIndex = this._nActiveBindings++, firstInactiveBinding = bindings[lastActiveIndex];
        binding._cacheIndex = lastActiveIndex;
        bindings[lastActiveIndex] = binding;
        firstInactiveBinding._cacheIndex = prevIndex;
        bindings[prevIndex] = firstInactiveBinding;
    }
    _takeBackBinding(binding) {
        const bindings = this._bindings, prevIndex = binding._cacheIndex, firstInactiveIndex = --this._nActiveBindings, lastActiveBinding = bindings[firstInactiveIndex];
        binding._cacheIndex = firstInactiveIndex;
        bindings[firstInactiveIndex] = binding;
        lastActiveBinding._cacheIndex = prevIndex;
        bindings[prevIndex] = lastActiveBinding;
    }
    // Memory management of Interpolants for weight and time scale
    _lendControlInterpolant() {
        const interpolants = this._controlInterpolants, lastActiveIndex = this._nActiveControlInterpolants++;
        let interpolant = interpolants[lastActiveIndex];
        if (interpolant === undefined) {
            interpolant = new $d5b33d7c30034067$export$a8e6009059f51e1a(new Float32Array(2), new Float32Array(2), 1, $d5b33d7c30034067$var$_controlInterpolantsResultBuffer);
            interpolant.__cacheIndex = lastActiveIndex;
            interpolants[lastActiveIndex] = interpolant;
        }
        return interpolant;
    }
    _takeBackControlInterpolant(interpolant) {
        const interpolants = this._controlInterpolants, prevIndex = interpolant.__cacheIndex, firstInactiveIndex = --this._nActiveControlInterpolants, lastActiveInterpolant = interpolants[firstInactiveIndex];
        interpolant.__cacheIndex = firstInactiveIndex;
        interpolants[firstInactiveIndex] = interpolant;
        lastActiveInterpolant.__cacheIndex = prevIndex;
        interpolants[prevIndex] = lastActiveInterpolant;
    }
    // return an action for a clip optionally using a custom root target
    // object (this method allocates a lot of dynamic memory in case a
    // previously unknown clip/root combination is specified)
    clipAction(clip, optionalRoot, blendMode) {
        const root = optionalRoot || this._root, rootUuid = root.uuid;
        let clipObject = typeof clip === 'string' ? $d5b33d7c30034067$export$d942c706bf23829c.findByName(root, clip) : clip;
        const clipUuid = clipObject !== null ? clipObject.uuid : clip;
        const actionsForClip = this._actionsByClip[clipUuid];
        let prototypeAction = null;
        if (blendMode === undefined) {
            if (clipObject !== null) blendMode = clipObject.blendMode;
            else blendMode = $d5b33d7c30034067$export$bcfbbdcf8de7f8cd;
        }
        if (actionsForClip !== undefined) {
            const existingAction = actionsForClip.actionByRoot[rootUuid];
            if (existingAction !== undefined && existingAction.blendMode === blendMode) return existingAction;
            // we know the clip, so we don't have to parse all
            // the bindings again but can just copy
            prototypeAction = actionsForClip.knownActions[0];
            // also, take the clip from the prototype action
            if (clipObject === null) clipObject = prototypeAction._clip;
        }
        // clip must be known when specified via string
        if (clipObject === null) return null;
        // allocate all resources required to run it
        const newAction = new $d5b33d7c30034067$export$6946940a69e799e(this, clipObject, optionalRoot, blendMode);
        this._bindAction(newAction, prototypeAction);
        // and make the action known to the memory manager
        this._addInactiveAction(newAction, clipUuid, rootUuid);
        return newAction;
    }
    // get an existing action
    existingAction(clip, optionalRoot) {
        const root = optionalRoot || this._root, rootUuid = root.uuid, clipObject = typeof clip === 'string' ? $d5b33d7c30034067$export$d942c706bf23829c.findByName(root, clip) : clip, clipUuid = clipObject ? clipObject.uuid : clip, actionsForClip = this._actionsByClip[clipUuid];
        if (actionsForClip !== undefined) return actionsForClip.actionByRoot[rootUuid] || null;
        return null;
    }
    // deactivates all previously scheduled actions
    stopAllAction() {
        const actions = this._actions, nActions = this._nActiveActions;
        for(let i = nActions - 1; i >= 0; --i)actions[i].stop();
        return this;
    }
    // advance the time and update apply the animation
    update(deltaTime) {
        deltaTime *= this.timeScale;
        const actions = this._actions, nActions = this._nActiveActions, time = this.time += deltaTime, timeDirection = Math.sign(deltaTime), accuIndex = this._accuIndex ^= 1;
        // run active actions
        for(let i = 0; i !== nActions; ++i){
            const action = actions[i];
            action._update(time, deltaTime, timeDirection, accuIndex);
        }
        // update scene graph
        const bindings = this._bindings, nBindings = this._nActiveBindings;
        for(let i = 0; i !== nBindings; ++i)bindings[i].apply(accuIndex);
        return this;
    }
    // Allows you to seek to a specific time in an animation.
    setTime(timeInSeconds) {
        this.time = 0; // Zero out time attribute for AnimationMixer object;
        for(let i = 0; i < this._actions.length; i++)this._actions[i].time = 0; // Zero out time attribute for all associated AnimationAction objects.
        return this.update(timeInSeconds); // Update used to set exact time. Returns "this" AnimationMixer object.
    }
    // return this mixer's root target object
    getRoot() {
        return this._root;
    }
    // free all resources specific to a particular clip
    uncacheClip(clip) {
        const actions = this._actions, clipUuid = clip.uuid, actionsByClip = this._actionsByClip, actionsForClip = actionsByClip[clipUuid];
        if (actionsForClip !== undefined) {
            // note: just calling _removeInactiveAction would mess up the
            // iteration state and also require updating the state we can
            // just throw away
            const actionsToRemove = actionsForClip.knownActions;
            for(let i = 0, n = actionsToRemove.length; i !== n; ++i){
                const action = actionsToRemove[i];
                this._deactivateAction(action);
                const cacheIndex = action._cacheIndex, lastInactiveAction = actions[actions.length - 1];
                action._cacheIndex = null;
                action._byClipCacheIndex = null;
                lastInactiveAction._cacheIndex = cacheIndex;
                actions[cacheIndex] = lastInactiveAction;
                actions.pop();
                this._removeInactiveBindingsForAction(action);
            }
            delete actionsByClip[clipUuid];
        }
    }
    // free all resources specific to a particular root target object
    uncacheRoot(root) {
        const rootUuid = root.uuid, actionsByClip = this._actionsByClip;
        for(const clipUuid in actionsByClip){
            const actionByRoot = actionsByClip[clipUuid].actionByRoot, action = actionByRoot[rootUuid];
            if (action !== undefined) {
                this._deactivateAction(action);
                this._removeInactiveAction(action);
            }
        }
        const bindingsByRoot = this._bindingsByRootAndName, bindingByName = bindingsByRoot[rootUuid];
        if (bindingByName !== undefined) for(const trackName in bindingByName){
            const binding = bindingByName[trackName];
            binding.restoreOriginalState();
            this._removeInactiveBinding(binding);
        }
    }
    // remove a targeted clip from the cache
    uncacheAction(clip, optionalRoot) {
        const action = this.existingAction(clip, optionalRoot);
        if (action !== null) {
            this._deactivateAction(action);
            this._removeInactiveAction(action);
        }
    }
}
class $d5b33d7c30034067$export$2947cebfe91c02f8 {
    constructor(value){
        this.value = value;
    }
    clone() {
        return new $d5b33d7c30034067$export$2947cebfe91c02f8(this.value.clone === undefined ? this.value : this.value.clone());
    }
}
let $d5b33d7c30034067$var$_id = 0;
class $d5b33d7c30034067$export$c412d5ffe1f79209 extends $d5b33d7c30034067$export$ec8b666c5fe2c75a {
    constructor(){
        super();
        this.isUniformsGroup = true;
        Object.defineProperty(this, 'id', {
            value: $d5b33d7c30034067$var$_id++
        });
        this.name = '';
        this.usage = $d5b33d7c30034067$export$763e8360f4d7f77d;
        this.uniforms = [];
    }
    add(uniform) {
        this.uniforms.push(uniform);
        return this;
    }
    remove(uniform) {
        const index = this.uniforms.indexOf(uniform);
        if (index !== -1) this.uniforms.splice(index, 1);
        return this;
    }
    setName(name) {
        this.name = name;
        return this;
    }
    setUsage(value) {
        this.usage = value;
        return this;
    }
    dispose() {
        this.dispatchEvent({
            type: 'dispose'
        });
        return this;
    }
    copy(source) {
        this.name = source.name;
        this.usage = source.usage;
        const uniformsSource = source.uniforms;
        this.uniforms.length = 0;
        for(let i = 0, l = uniformsSource.length; i < l; i++){
            const uniforms = Array.isArray(uniformsSource[i]) ? uniformsSource[i] : [
                uniformsSource[i]
            ];
            for(let j = 0; j < uniforms.length; j++)this.uniforms.push(uniforms[j].clone());
        }
        return this;
    }
    clone() {
        return new this.constructor().copy(this);
    }
}
class $d5b33d7c30034067$export$25ec0e1af1389358 extends $d5b33d7c30034067$export$3d5cd879f108f53f {
    constructor(array, stride, meshPerAttribute = 1){
        super(array, stride);
        this.isInstancedInterleavedBuffer = true;
        this.meshPerAttribute = meshPerAttribute;
    }
    copy(source) {
        super.copy(source);
        this.meshPerAttribute = source.meshPerAttribute;
        return this;
    }
    clone(data) {
        const ib = super.clone(data);
        ib.meshPerAttribute = this.meshPerAttribute;
        return ib;
    }
    toJSON(data) {
        const json = super.toJSON(data);
        json.isInstancedInterleavedBuffer = true;
        json.meshPerAttribute = this.meshPerAttribute;
        return json;
    }
}
class $d5b33d7c30034067$export$6b7339ae8dbddf73 {
    constructor(buffer, type, itemSize, elementSize, count){
        this.isGLBufferAttribute = true;
        this.name = '';
        this.buffer = buffer;
        this.type = type;
        this.itemSize = itemSize;
        this.elementSize = elementSize;
        this.count = count;
        this.version = 0;
    }
    set needsUpdate(value) {
        if (value === true) this.version++;
    }
    setBuffer(buffer) {
        this.buffer = buffer;
        return this;
    }
    setType(type, elementSize) {
        this.type = type;
        this.elementSize = elementSize;
        return this;
    }
    setItemSize(itemSize) {
        this.itemSize = itemSize;
        return this;
    }
    setCount(count) {
        this.count = count;
        return this;
    }
}
const $d5b33d7c30034067$var$_matrix = /*@__PURE__*/ new $d5b33d7c30034067$export$2ae72fc923e5eb5();
class $d5b33d7c30034067$export$8b7aaceff00bd2f {
    constructor(origin, direction, near = 0, far = Infinity){
        this.ray = new $d5b33d7c30034067$export$a186db52eed6d40e(origin, direction);
        // direction is assumed to be normalized (for accurate distance calculations)
        this.near = near;
        this.far = far;
        this.camera = null;
        this.layers = new $d5b33d7c30034067$export$89312ce47c0ca777();
        this.params = {
            Mesh: {},
            Line: {
                threshold: 1
            },
            LOD: {},
            Points: {
                threshold: 1
            },
            Sprite: {}
        };
    }
    set(origin, direction) {
        // direction is assumed to be normalized (for accurate distance calculations)
        this.ray.set(origin, direction);
    }
    setFromCamera(coords, camera) {
        if (camera.isPerspectiveCamera) {
            this.ray.origin.setFromMatrixPosition(camera.matrixWorld);
            this.ray.direction.set(coords.x, coords.y, 0.5).unproject(camera).sub(this.ray.origin).normalize();
            this.camera = camera;
        } else if (camera.isOrthographicCamera) {
            this.ray.origin.set(coords.x, coords.y, (camera.near + camera.far) / (camera.near - camera.far)).unproject(camera); // set origin in plane of camera
            this.ray.direction.set(0, 0, -1).transformDirection(camera.matrixWorld);
            this.camera = camera;
        } else console.error('THREE.Raycaster: Unsupported camera type: ' + camera.type);
    }
    setFromXRController(controller) {
        $d5b33d7c30034067$var$_matrix.identity().extractRotation(controller.matrixWorld);
        this.ray.origin.setFromMatrixPosition(controller.matrixWorld);
        this.ray.direction.set(0, 0, -1).applyMatrix4($d5b33d7c30034067$var$_matrix);
        return this;
    }
    intersectObject(object, recursive = true, intersects = []) {
        $d5b33d7c30034067$var$intersect(object, this, intersects, recursive);
        intersects.sort($d5b33d7c30034067$var$ascSort);
        return intersects;
    }
    intersectObjects(objects, recursive = true, intersects = []) {
        for(let i = 0, l = objects.length; i < l; i++)$d5b33d7c30034067$var$intersect(objects[i], this, intersects, recursive);
        intersects.sort($d5b33d7c30034067$var$ascSort);
        return intersects;
    }
}
function $d5b33d7c30034067$var$ascSort(a, b) {
    return a.distance - b.distance;
}
function $d5b33d7c30034067$var$intersect(object, raycaster, intersects, recursive) {
    let propagate = true;
    if (object.layers.test(raycaster.layers)) {
        const result = object.raycast(raycaster, intersects);
        if (result === false) propagate = false;
    }
    if (propagate === true && recursive === true) {
        const children = object.children;
        for(let i = 0, l = children.length; i < l; i++)$d5b33d7c30034067$var$intersect(children[i], raycaster, intersects, true);
    }
}
/**
 * Ref: https://en.wikipedia.org/wiki/Spherical_coordinate_system
 *
 * phi (the polar angle) is measured from the positive y-axis. The positive y-axis is up.
 * theta (the azimuthal angle) is measured from the positive z-axis.
 */ class $d5b33d7c30034067$export$d712cd887b4a00f7 {
    constructor(radius = 1, phi = 0, theta = 0){
        this.radius = radius;
        this.phi = phi; // polar angle
        this.theta = theta; // azimuthal angle
        return this;
    }
    set(radius, phi, theta) {
        this.radius = radius;
        this.phi = phi;
        this.theta = theta;
        return this;
    }
    copy(other) {
        this.radius = other.radius;
        this.phi = other.phi;
        this.theta = other.theta;
        return this;
    }
    // restrict phi to be between EPS and PI-EPS
    makeSafe() {
        const EPS = 0.000001;
        this.phi = Math.max(EPS, Math.min(Math.PI - EPS, this.phi));
        return this;
    }
    setFromVector3(v) {
        return this.setFromCartesianCoords(v.x, v.y, v.z);
    }
    setFromCartesianCoords(x, y, z) {
        this.radius = Math.sqrt(x * x + y * y + z * z);
        if (this.radius === 0) {
            this.theta = 0;
            this.phi = 0;
        } else {
            this.theta = Math.atan2(x, z);
            this.phi = Math.acos($d5b33d7c30034067$var$clamp(y / this.radius, -1, 1));
        }
        return this;
    }
    clone() {
        return new this.constructor().copy(this);
    }
}
/**
 * Ref: https://en.wikipedia.org/wiki/Cylindrical_coordinate_system
 */ class $d5b33d7c30034067$export$287165bb2177f4fd {
    constructor(radius = 1, theta = 0, y = 0){
        this.radius = radius; // distance from the origin to a point in the x-z plane
        this.theta = theta; // counterclockwise angle in the x-z plane measured in radians from the positive z-axis
        this.y = y; // height above the x-z plane
        return this;
    }
    set(radius, theta, y) {
        this.radius = radius;
        this.theta = theta;
        this.y = y;
        return this;
    }
    copy(other) {
        this.radius = other.radius;
        this.theta = other.theta;
        this.y = other.y;
        return this;
    }
    setFromVector3(v) {
        return this.setFromCartesianCoords(v.x, v.y, v.z);
    }
    setFromCartesianCoords(x, y, z) {
        this.radius = Math.sqrt(x * x + z * z);
        this.theta = Math.atan2(x, z);
        this.y = y;
        return this;
    }
    clone() {
        return new this.constructor().copy(this);
    }
}
class $d5b33d7c30034067$export$cbcc6560bf79fb38 {
    constructor(n11, n12, n21, n22){
        $d5b33d7c30034067$export$cbcc6560bf79fb38.prototype.isMatrix2 = true;
        this.elements = [
            1,
            0,
            0,
            1
        ];
        if (n11 !== undefined) this.set(n11, n12, n21, n22);
    }
    identity() {
        this.set(1, 0, 0, 1);
        return this;
    }
    fromArray(array, offset = 0) {
        for(let i = 0; i < 4; i++)this.elements[i] = array[i + offset];
        return this;
    }
    set(n11, n12, n21, n22) {
        const te = this.elements;
        te[0] = n11;
        te[2] = n12;
        te[1] = n21;
        te[3] = n22;
        return this;
    }
}
const $d5b33d7c30034067$var$_vector$4 = /*@__PURE__*/ new $d5b33d7c30034067$export$c977b3e384af9ae1();
class $d5b33d7c30034067$export$60f553fa130f08b0 {
    constructor(min = new $d5b33d7c30034067$export$c977b3e384af9ae1(Infinity, Infinity), max = new $d5b33d7c30034067$export$c977b3e384af9ae1(-Infinity, -Infinity)){
        this.isBox2 = true;
        this.min = min;
        this.max = max;
    }
    set(min, max) {
        this.min.copy(min);
        this.max.copy(max);
        return this;
    }
    setFromPoints(points) {
        this.makeEmpty();
        for(let i = 0, il = points.length; i < il; i++)this.expandByPoint(points[i]);
        return this;
    }
    setFromCenterAndSize(center, size) {
        const halfSize = $d5b33d7c30034067$var$_vector$4.copy(size).multiplyScalar(0.5);
        this.min.copy(center).sub(halfSize);
        this.max.copy(center).add(halfSize);
        return this;
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(box) {
        this.min.copy(box.min);
        this.max.copy(box.max);
        return this;
    }
    makeEmpty() {
        this.min.x = this.min.y = Infinity;
        this.max.x = this.max.y = -Infinity;
        return this;
    }
    isEmpty() {
        // this is a more robust check for empty than ( volume <= 0 ) because volume can get positive with two negative axes
        return this.max.x < this.min.x || this.max.y < this.min.y;
    }
    getCenter(target) {
        return this.isEmpty() ? target.set(0, 0) : target.addVectors(this.min, this.max).multiplyScalar(0.5);
    }
    getSize(target) {
        return this.isEmpty() ? target.set(0, 0) : target.subVectors(this.max, this.min);
    }
    expandByPoint(point) {
        this.min.min(point);
        this.max.max(point);
        return this;
    }
    expandByVector(vector) {
        this.min.sub(vector);
        this.max.add(vector);
        return this;
    }
    expandByScalar(scalar) {
        this.min.addScalar(-scalar);
        this.max.addScalar(scalar);
        return this;
    }
    containsPoint(point) {
        return point.x >= this.min.x && point.x <= this.max.x && point.y >= this.min.y && point.y <= this.max.y;
    }
    containsBox(box) {
        return this.min.x <= box.min.x && box.max.x <= this.max.x && this.min.y <= box.min.y && box.max.y <= this.max.y;
    }
    getParameter(point, target) {
        // This can potentially have a divide by zero if the box
        // has a size dimension of 0.
        return target.set((point.x - this.min.x) / (this.max.x - this.min.x), (point.y - this.min.y) / (this.max.y - this.min.y));
    }
    intersectsBox(box) {
        // using 4 splitting planes to rule out intersections
        return box.max.x >= this.min.x && box.min.x <= this.max.x && box.max.y >= this.min.y && box.min.y <= this.max.y;
    }
    clampPoint(point, target) {
        return target.copy(point).clamp(this.min, this.max);
    }
    distanceToPoint(point) {
        return this.clampPoint(point, $d5b33d7c30034067$var$_vector$4).distanceTo(point);
    }
    intersect(box) {
        this.min.max(box.min);
        this.max.min(box.max);
        if (this.isEmpty()) this.makeEmpty();
        return this;
    }
    union(box) {
        this.min.min(box.min);
        this.max.max(box.max);
        return this;
    }
    translate(offset) {
        this.min.add(offset);
        this.max.add(offset);
        return this;
    }
    equals(box) {
        return box.min.equals(this.min) && box.max.equals(this.max);
    }
}
const $d5b33d7c30034067$var$_startP = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_startEnd = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
class $d5b33d7c30034067$export$e0ba6359f1954fd3 {
    constructor(start = new $d5b33d7c30034067$export$64b5c384219d3699(), end = new $d5b33d7c30034067$export$64b5c384219d3699()){
        this.start = start;
        this.end = end;
    }
    set(start, end) {
        this.start.copy(start);
        this.end.copy(end);
        return this;
    }
    copy(line) {
        this.start.copy(line.start);
        this.end.copy(line.end);
        return this;
    }
    getCenter(target) {
        return target.addVectors(this.start, this.end).multiplyScalar(0.5);
    }
    delta(target) {
        return target.subVectors(this.end, this.start);
    }
    distanceSq() {
        return this.start.distanceToSquared(this.end);
    }
    distance() {
        return this.start.distanceTo(this.end);
    }
    at(t, target) {
        return this.delta(target).multiplyScalar(t).add(this.start);
    }
    closestPointToPointParameter(point, clampToLine) {
        $d5b33d7c30034067$var$_startP.subVectors(point, this.start);
        $d5b33d7c30034067$var$_startEnd.subVectors(this.end, this.start);
        const startEnd2 = $d5b33d7c30034067$var$_startEnd.dot($d5b33d7c30034067$var$_startEnd);
        const startEnd_startP = $d5b33d7c30034067$var$_startEnd.dot($d5b33d7c30034067$var$_startP);
        let t = startEnd_startP / startEnd2;
        if (clampToLine) t = $d5b33d7c30034067$var$clamp(t, 0, 1);
        return t;
    }
    closestPointToPoint(point, clampToLine, target) {
        const t = this.closestPointToPointParameter(point, clampToLine);
        return this.delta(target).multiplyScalar(t).add(this.start);
    }
    applyMatrix4(matrix) {
        this.start.applyMatrix4(matrix);
        this.end.applyMatrix4(matrix);
        return this;
    }
    equals(line) {
        return line.start.equals(this.start) && line.end.equals(this.end);
    }
    clone() {
        return new this.constructor().copy(this);
    }
}
const $d5b33d7c30034067$var$_vector$3 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
class $d5b33d7c30034067$export$4b14638ffdd81e68 extends $d5b33d7c30034067$export$e4dd07dff30cc924 {
    constructor(light, color){
        super();
        this.light = light;
        this.matrixAutoUpdate = false;
        this.color = color;
        this.type = 'SpotLightHelper';
        const geometry = new $d5b33d7c30034067$export$b7be63a67df8959();
        const positions = [
            0,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            1,
            0,
            1,
            0,
            0,
            0,
            -1,
            0,
            1,
            0,
            0,
            0,
            0,
            1,
            1,
            0,
            0,
            0,
            0,
            -1,
            1
        ];
        for(let i = 0, j = 1, l = 32; i < l; i++, j++){
            const p1 = i / l * Math.PI * 2;
            const p2 = j / l * Math.PI * 2;
            positions.push(Math.cos(p1), Math.sin(p1), 1, Math.cos(p2), Math.sin(p2), 1);
        }
        geometry.setAttribute('position', new $d5b33d7c30034067$export$cbe7a62641830ebd(positions, 3));
        const material = new $d5b33d7c30034067$export$fbaaa33907730a0c({
            fog: false,
            toneMapped: false
        });
        this.cone = new $d5b33d7c30034067$export$ff1ed10fedfdd604(geometry, material);
        this.add(this.cone);
        this.update();
    }
    dispose() {
        this.cone.geometry.dispose();
        this.cone.material.dispose();
    }
    update() {
        this.light.updateWorldMatrix(true, false);
        this.light.target.updateWorldMatrix(true, false);
        // update the local matrix based on the parent and light target transforms
        if (this.parent) {
            this.parent.updateWorldMatrix(true);
            this.matrix.copy(this.parent.matrixWorld).invert().multiply(this.light.matrixWorld);
        } else this.matrix.copy(this.light.matrixWorld);
        this.matrixWorld.copy(this.light.matrixWorld);
        const coneLength = this.light.distance ? this.light.distance : 1000;
        const coneWidth = coneLength * Math.tan(this.light.angle);
        this.cone.scale.set(coneWidth, coneWidth, coneLength);
        $d5b33d7c30034067$var$_vector$3.setFromMatrixPosition(this.light.target.matrixWorld);
        this.cone.lookAt($d5b33d7c30034067$var$_vector$3);
        if (this.color !== undefined) this.cone.material.color.set(this.color);
        else this.cone.material.color.copy(this.light.color);
    }
}
const $d5b33d7c30034067$var$_vector$2 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_boneMatrix = /*@__PURE__*/ new $d5b33d7c30034067$export$2ae72fc923e5eb5();
const $d5b33d7c30034067$var$_matrixWorldInv = /*@__PURE__*/ new $d5b33d7c30034067$export$2ae72fc923e5eb5();
class $d5b33d7c30034067$export$5277df3c9e732259 extends $d5b33d7c30034067$export$ff1ed10fedfdd604 {
    constructor(object){
        const bones = $d5b33d7c30034067$var$getBoneList(object);
        const geometry = new $d5b33d7c30034067$export$b7be63a67df8959();
        const vertices = [];
        const colors = [];
        const color1 = new $d5b33d7c30034067$export$892596cec99bc70e(0, 0, 1);
        const color2 = new $d5b33d7c30034067$export$892596cec99bc70e(0, 1, 0);
        for(let i = 0; i < bones.length; i++){
            const bone = bones[i];
            if (bone.parent && bone.parent.isBone) {
                vertices.push(0, 0, 0);
                vertices.push(0, 0, 0);
                colors.push(color1.r, color1.g, color1.b);
                colors.push(color2.r, color2.g, color2.b);
            }
        }
        geometry.setAttribute('position', new $d5b33d7c30034067$export$cbe7a62641830ebd(vertices, 3));
        geometry.setAttribute('color', new $d5b33d7c30034067$export$cbe7a62641830ebd(colors, 3));
        const material = new $d5b33d7c30034067$export$fbaaa33907730a0c({
            vertexColors: true,
            depthTest: false,
            depthWrite: false,
            toneMapped: false,
            transparent: true
        });
        super(geometry, material);
        this.isSkeletonHelper = true;
        this.type = 'SkeletonHelper';
        this.root = object;
        this.bones = bones;
        this.matrix = object.matrixWorld;
        this.matrixAutoUpdate = false;
    }
    updateMatrixWorld(force) {
        const bones = this.bones;
        const geometry = this.geometry;
        const position = geometry.getAttribute('position');
        $d5b33d7c30034067$var$_matrixWorldInv.copy(this.root.matrixWorld).invert();
        for(let i = 0, j = 0; i < bones.length; i++){
            const bone = bones[i];
            if (bone.parent && bone.parent.isBone) {
                $d5b33d7c30034067$var$_boneMatrix.multiplyMatrices($d5b33d7c30034067$var$_matrixWorldInv, bone.matrixWorld);
                $d5b33d7c30034067$var$_vector$2.setFromMatrixPosition($d5b33d7c30034067$var$_boneMatrix);
                position.setXYZ(j, $d5b33d7c30034067$var$_vector$2.x, $d5b33d7c30034067$var$_vector$2.y, $d5b33d7c30034067$var$_vector$2.z);
                $d5b33d7c30034067$var$_boneMatrix.multiplyMatrices($d5b33d7c30034067$var$_matrixWorldInv, bone.parent.matrixWorld);
                $d5b33d7c30034067$var$_vector$2.setFromMatrixPosition($d5b33d7c30034067$var$_boneMatrix);
                position.setXYZ(j + 1, $d5b33d7c30034067$var$_vector$2.x, $d5b33d7c30034067$var$_vector$2.y, $d5b33d7c30034067$var$_vector$2.z);
                j += 2;
            }
        }
        geometry.getAttribute('position').needsUpdate = true;
        super.updateMatrixWorld(force);
    }
    dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
}
function $d5b33d7c30034067$var$getBoneList(object) {
    const boneList = [];
    if (object.isBone === true) boneList.push(object);
    for(let i = 0; i < object.children.length; i++)boneList.push.apply(boneList, $d5b33d7c30034067$var$getBoneList(object.children[i]));
    return boneList;
}
class $d5b33d7c30034067$export$9a9291685b9e4023 extends $d5b33d7c30034067$export$e176487c05830cc5 {
    constructor(light, sphereSize, color){
        const geometry = new $d5b33d7c30034067$export$1b417fc3b307a251(sphereSize, 4, 2);
        const material = new $d5b33d7c30034067$export$55cbcc9b622fe1f5({
            wireframe: true,
            fog: false,
            toneMapped: false
        });
        super(geometry, material);
        this.light = light;
        this.color = color;
        this.type = 'PointLightHelper';
        this.matrix = this.light.matrixWorld;
        this.matrixAutoUpdate = false;
        this.update();
    /*
	// TODO: delete this comment?
	const distanceGeometry = new THREE.IcosahedronGeometry( 1, 2 );
	const distanceMaterial = new THREE.MeshBasicMaterial( { color: hexColor, fog: false, wireframe: true, opacity: 0.1, transparent: true } );

	this.lightSphere = new THREE.Mesh( bulbGeometry, bulbMaterial );
	this.lightDistance = new THREE.Mesh( distanceGeometry, distanceMaterial );

	const d = light.distance;

	if ( d === 0.0 ) {

		this.lightDistance.visible = false;

	} else {

		this.lightDistance.scale.set( d, d, d );

	}

	this.add( this.lightDistance );
	*/ }
    dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
    update() {
        this.light.updateWorldMatrix(true, false);
        if (this.color !== undefined) this.material.color.set(this.color);
        else this.material.color.copy(this.light.color);
    /*
		const d = this.light.distance;

		if ( d === 0.0 ) {

			this.lightDistance.visible = false;

		} else {

			this.lightDistance.visible = true;
			this.lightDistance.scale.set( d, d, d );

		}
		*/ }
}
const $d5b33d7c30034067$var$_vector$1 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_color1 = /*@__PURE__*/ new $d5b33d7c30034067$export$892596cec99bc70e();
const $d5b33d7c30034067$var$_color2 = /*@__PURE__*/ new $d5b33d7c30034067$export$892596cec99bc70e();
class $d5b33d7c30034067$export$8dca15f13f4f8172 extends $d5b33d7c30034067$export$e4dd07dff30cc924 {
    constructor(light, size, color){
        super();
        this.light = light;
        this.matrix = light.matrixWorld;
        this.matrixAutoUpdate = false;
        this.color = color;
        this.type = 'HemisphereLightHelper';
        const geometry = new $d5b33d7c30034067$export$1954e2b809fe361e(size);
        geometry.rotateY(Math.PI * 0.5);
        this.material = new $d5b33d7c30034067$export$55cbcc9b622fe1f5({
            wireframe: true,
            fog: false,
            toneMapped: false
        });
        if (this.color === undefined) this.material.vertexColors = true;
        const position = geometry.getAttribute('position');
        const colors = new Float32Array(position.count * 3);
        geometry.setAttribute('color', new $d5b33d7c30034067$export$8dea267bd6bde117(colors, 3));
        this.add(new $d5b33d7c30034067$export$e176487c05830cc5(geometry, this.material));
        this.update();
    }
    dispose() {
        this.children[0].geometry.dispose();
        this.children[0].material.dispose();
    }
    update() {
        const mesh = this.children[0];
        if (this.color !== undefined) this.material.color.set(this.color);
        else {
            const colors = mesh.geometry.getAttribute('color');
            $d5b33d7c30034067$var$_color1.copy(this.light.color);
            $d5b33d7c30034067$var$_color2.copy(this.light.groundColor);
            for(let i = 0, l = colors.count; i < l; i++){
                const color = i < l / 2 ? $d5b33d7c30034067$var$_color1 : $d5b33d7c30034067$var$_color2;
                colors.setXYZ(i, color.r, color.g, color.b);
            }
            colors.needsUpdate = true;
        }
        this.light.updateWorldMatrix(true, false);
        mesh.lookAt($d5b33d7c30034067$var$_vector$1.setFromMatrixPosition(this.light.matrixWorld).negate());
    }
}
class $d5b33d7c30034067$export$3875d39926561055 extends $d5b33d7c30034067$export$ff1ed10fedfdd604 {
    constructor(size = 10, divisions = 10, color1 = 0x444444, color2 = 0x888888){
        color1 = new $d5b33d7c30034067$export$892596cec99bc70e(color1);
        color2 = new $d5b33d7c30034067$export$892596cec99bc70e(color2);
        const center = divisions / 2;
        const step = size / divisions;
        const halfSize = size / 2;
        const vertices = [], colors = [];
        for(let i = 0, j = 0, k = -halfSize; i <= divisions; i++, k += step){
            vertices.push(-halfSize, 0, k, halfSize, 0, k);
            vertices.push(k, 0, -halfSize, k, 0, halfSize);
            const color = i === center ? color1 : color2;
            color.toArray(colors, j);
            j += 3;
            color.toArray(colors, j);
            j += 3;
            color.toArray(colors, j);
            j += 3;
            color.toArray(colors, j);
            j += 3;
        }
        const geometry = new $d5b33d7c30034067$export$b7be63a67df8959();
        geometry.setAttribute('position', new $d5b33d7c30034067$export$cbe7a62641830ebd(vertices, 3));
        geometry.setAttribute('color', new $d5b33d7c30034067$export$cbe7a62641830ebd(colors, 3));
        const material = new $d5b33d7c30034067$export$fbaaa33907730a0c({
            vertexColors: true,
            toneMapped: false
        });
        super(geometry, material);
        this.type = 'GridHelper';
    }
    dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
}
class $d5b33d7c30034067$export$361430a10f533cd3 extends $d5b33d7c30034067$export$ff1ed10fedfdd604 {
    constructor(radius = 10, sectors = 16, rings = 8, divisions = 64, color1 = 0x444444, color2 = 0x888888){
        color1 = new $d5b33d7c30034067$export$892596cec99bc70e(color1);
        color2 = new $d5b33d7c30034067$export$892596cec99bc70e(color2);
        const vertices = [];
        const colors = [];
        // create the sectors
        if (sectors > 1) for(let i = 0; i < sectors; i++){
            const v = i / sectors * (Math.PI * 2);
            const x = Math.sin(v) * radius;
            const z = Math.cos(v) * radius;
            vertices.push(0, 0, 0);
            vertices.push(x, 0, z);
            const color = i & 1 ? color1 : color2;
            colors.push(color.r, color.g, color.b);
            colors.push(color.r, color.g, color.b);
        }
        // create the rings
        for(let i = 0; i < rings; i++){
            const color = i & 1 ? color1 : color2;
            const r = radius - radius / rings * i;
            for(let j = 0; j < divisions; j++){
                // first vertex
                let v = j / divisions * (Math.PI * 2);
                let x = Math.sin(v) * r;
                let z = Math.cos(v) * r;
                vertices.push(x, 0, z);
                colors.push(color.r, color.g, color.b);
                // second vertex
                v = (j + 1) / divisions * (Math.PI * 2);
                x = Math.sin(v) * r;
                z = Math.cos(v) * r;
                vertices.push(x, 0, z);
                colors.push(color.r, color.g, color.b);
            }
        }
        const geometry = new $d5b33d7c30034067$export$b7be63a67df8959();
        geometry.setAttribute('position', new $d5b33d7c30034067$export$cbe7a62641830ebd(vertices, 3));
        geometry.setAttribute('color', new $d5b33d7c30034067$export$cbe7a62641830ebd(colors, 3));
        const material = new $d5b33d7c30034067$export$fbaaa33907730a0c({
            vertexColors: true,
            toneMapped: false
        });
        super(geometry, material);
        this.type = 'PolarGridHelper';
    }
    dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
}
const $d5b33d7c30034067$var$_v1 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_v2 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_v3 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
class $d5b33d7c30034067$export$f8e434dc14203e7d extends $d5b33d7c30034067$export$e4dd07dff30cc924 {
    constructor(light, size, color){
        super();
        this.light = light;
        this.matrix = light.matrixWorld;
        this.matrixAutoUpdate = false;
        this.color = color;
        this.type = 'DirectionalLightHelper';
        if (size === undefined) size = 1;
        let geometry = new $d5b33d7c30034067$export$b7be63a67df8959();
        geometry.setAttribute('position', new $d5b33d7c30034067$export$cbe7a62641830ebd([
            -size,
            size,
            0,
            size,
            size,
            0,
            size,
            -size,
            0,
            -size,
            -size,
            0,
            -size,
            size,
            0
        ], 3));
        const material = new $d5b33d7c30034067$export$fbaaa33907730a0c({
            fog: false,
            toneMapped: false
        });
        this.lightPlane = new $d5b33d7c30034067$export$17d680238e50603e(geometry, material);
        this.add(this.lightPlane);
        geometry = new $d5b33d7c30034067$export$b7be63a67df8959();
        geometry.setAttribute('position', new $d5b33d7c30034067$export$cbe7a62641830ebd([
            0,
            0,
            0,
            0,
            0,
            1
        ], 3));
        this.targetLine = new $d5b33d7c30034067$export$17d680238e50603e(geometry, material);
        this.add(this.targetLine);
        this.update();
    }
    dispose() {
        this.lightPlane.geometry.dispose();
        this.lightPlane.material.dispose();
        this.targetLine.geometry.dispose();
        this.targetLine.material.dispose();
    }
    update() {
        this.light.updateWorldMatrix(true, false);
        this.light.target.updateWorldMatrix(true, false);
        $d5b33d7c30034067$var$_v1.setFromMatrixPosition(this.light.matrixWorld);
        $d5b33d7c30034067$var$_v2.setFromMatrixPosition(this.light.target.matrixWorld);
        $d5b33d7c30034067$var$_v3.subVectors($d5b33d7c30034067$var$_v2, $d5b33d7c30034067$var$_v1);
        this.lightPlane.lookAt($d5b33d7c30034067$var$_v2);
        if (this.color !== undefined) {
            this.lightPlane.material.color.set(this.color);
            this.targetLine.material.color.set(this.color);
        } else {
            this.lightPlane.material.color.copy(this.light.color);
            this.targetLine.material.color.copy(this.light.color);
        }
        this.targetLine.lookAt($d5b33d7c30034067$var$_v2);
        this.targetLine.scale.z = $d5b33d7c30034067$var$_v3.length();
    }
}
const $d5b33d7c30034067$var$_vector = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_camera = /*@__PURE__*/ new $d5b33d7c30034067$export$79f141de891a5fed();
/**
 *	- shows frustum, line of sight and up of the camera
 *	- suitable for fast updates
 * 	- based on frustum visualization in lightgl.js shadowmap example
 *		https://github.com/evanw/lightgl.js/blob/master/tests/shadowmap.html
 */ class $d5b33d7c30034067$export$ed8e93f853cd795 extends $d5b33d7c30034067$export$ff1ed10fedfdd604 {
    constructor(camera){
        const geometry = new $d5b33d7c30034067$export$b7be63a67df8959();
        const material = new $d5b33d7c30034067$export$fbaaa33907730a0c({
            color: 0xffffff,
            vertexColors: true,
            toneMapped: false
        });
        const vertices = [];
        const colors = [];
        const pointMap = {};
        // near
        addLine('n1', 'n2');
        addLine('n2', 'n4');
        addLine('n4', 'n3');
        addLine('n3', 'n1');
        // far
        addLine('f1', 'f2');
        addLine('f2', 'f4');
        addLine('f4', 'f3');
        addLine('f3', 'f1');
        // sides
        addLine('n1', 'f1');
        addLine('n2', 'f2');
        addLine('n3', 'f3');
        addLine('n4', 'f4');
        // cone
        addLine('p', 'n1');
        addLine('p', 'n2');
        addLine('p', 'n3');
        addLine('p', 'n4');
        // up
        addLine('u1', 'u2');
        addLine('u2', 'u3');
        addLine('u3', 'u1');
        // target
        addLine('c', 't');
        addLine('p', 'c');
        // cross
        addLine('cn1', 'cn2');
        addLine('cn3', 'cn4');
        addLine('cf1', 'cf2');
        addLine('cf3', 'cf4');
        function addLine(a, b) {
            addPoint(a);
            addPoint(b);
        }
        function addPoint(id) {
            vertices.push(0, 0, 0);
            colors.push(0, 0, 0);
            if (pointMap[id] === undefined) pointMap[id] = [];
            pointMap[id].push(vertices.length / 3 - 1);
        }
        geometry.setAttribute('position', new $d5b33d7c30034067$export$cbe7a62641830ebd(vertices, 3));
        geometry.setAttribute('color', new $d5b33d7c30034067$export$cbe7a62641830ebd(colors, 3));
        super(geometry, material);
        this.type = 'CameraHelper';
        this.camera = camera;
        if (this.camera.updateProjectionMatrix) this.camera.updateProjectionMatrix();
        this.matrix = camera.matrixWorld;
        this.matrixAutoUpdate = false;
        this.pointMap = pointMap;
        this.update();
        // colors
        const colorFrustum = new $d5b33d7c30034067$export$892596cec99bc70e(0xffaa00);
        const colorCone = new $d5b33d7c30034067$export$892596cec99bc70e(0xff0000);
        const colorUp = new $d5b33d7c30034067$export$892596cec99bc70e(0x00aaff);
        const colorTarget = new $d5b33d7c30034067$export$892596cec99bc70e(0xffffff);
        const colorCross = new $d5b33d7c30034067$export$892596cec99bc70e(0x333333);
        this.setColors(colorFrustum, colorCone, colorUp, colorTarget, colorCross);
    }
    setColors(frustum, cone, up, target, cross) {
        const geometry = this.geometry;
        const colorAttribute = geometry.getAttribute('color');
        // near
        colorAttribute.setXYZ(0, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(1, frustum.r, frustum.g, frustum.b); // n1, n2
        colorAttribute.setXYZ(2, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(3, frustum.r, frustum.g, frustum.b); // n2, n4
        colorAttribute.setXYZ(4, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(5, frustum.r, frustum.g, frustum.b); // n4, n3
        colorAttribute.setXYZ(6, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(7, frustum.r, frustum.g, frustum.b); // n3, n1
        // far
        colorAttribute.setXYZ(8, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(9, frustum.r, frustum.g, frustum.b); // f1, f2
        colorAttribute.setXYZ(10, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(11, frustum.r, frustum.g, frustum.b); // f2, f4
        colorAttribute.setXYZ(12, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(13, frustum.r, frustum.g, frustum.b); // f4, f3
        colorAttribute.setXYZ(14, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(15, frustum.r, frustum.g, frustum.b); // f3, f1
        // sides
        colorAttribute.setXYZ(16, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(17, frustum.r, frustum.g, frustum.b); // n1, f1
        colorAttribute.setXYZ(18, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(19, frustum.r, frustum.g, frustum.b); // n2, f2
        colorAttribute.setXYZ(20, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(21, frustum.r, frustum.g, frustum.b); // n3, f3
        colorAttribute.setXYZ(22, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(23, frustum.r, frustum.g, frustum.b); // n4, f4
        // cone
        colorAttribute.setXYZ(24, cone.r, cone.g, cone.b);
        colorAttribute.setXYZ(25, cone.r, cone.g, cone.b); // p, n1
        colorAttribute.setXYZ(26, cone.r, cone.g, cone.b);
        colorAttribute.setXYZ(27, cone.r, cone.g, cone.b); // p, n2
        colorAttribute.setXYZ(28, cone.r, cone.g, cone.b);
        colorAttribute.setXYZ(29, cone.r, cone.g, cone.b); // p, n3
        colorAttribute.setXYZ(30, cone.r, cone.g, cone.b);
        colorAttribute.setXYZ(31, cone.r, cone.g, cone.b); // p, n4
        // up
        colorAttribute.setXYZ(32, up.r, up.g, up.b);
        colorAttribute.setXYZ(33, up.r, up.g, up.b); // u1, u2
        colorAttribute.setXYZ(34, up.r, up.g, up.b);
        colorAttribute.setXYZ(35, up.r, up.g, up.b); // u2, u3
        colorAttribute.setXYZ(36, up.r, up.g, up.b);
        colorAttribute.setXYZ(37, up.r, up.g, up.b); // u3, u1
        // target
        colorAttribute.setXYZ(38, target.r, target.g, target.b);
        colorAttribute.setXYZ(39, target.r, target.g, target.b); // c, t
        colorAttribute.setXYZ(40, cross.r, cross.g, cross.b);
        colorAttribute.setXYZ(41, cross.r, cross.g, cross.b); // p, c
        // cross
        colorAttribute.setXYZ(42, cross.r, cross.g, cross.b);
        colorAttribute.setXYZ(43, cross.r, cross.g, cross.b); // cn1, cn2
        colorAttribute.setXYZ(44, cross.r, cross.g, cross.b);
        colorAttribute.setXYZ(45, cross.r, cross.g, cross.b); // cn3, cn4
        colorAttribute.setXYZ(46, cross.r, cross.g, cross.b);
        colorAttribute.setXYZ(47, cross.r, cross.g, cross.b); // cf1, cf2
        colorAttribute.setXYZ(48, cross.r, cross.g, cross.b);
        colorAttribute.setXYZ(49, cross.r, cross.g, cross.b); // cf3, cf4
        colorAttribute.needsUpdate = true;
    }
    update() {
        const geometry = this.geometry;
        const pointMap = this.pointMap;
        const w = 1, h = 1;
        // we need just camera projection matrix inverse
        // world matrix must be identity
        $d5b33d7c30034067$var$_camera.projectionMatrixInverse.copy(this.camera.projectionMatrixInverse);
        // center / target
        $d5b33d7c30034067$var$setPoint('c', pointMap, geometry, $d5b33d7c30034067$var$_camera, 0, 0, -1);
        $d5b33d7c30034067$var$setPoint('t', pointMap, geometry, $d5b33d7c30034067$var$_camera, 0, 0, 1);
        // near
        $d5b33d7c30034067$var$setPoint('n1', pointMap, geometry, $d5b33d7c30034067$var$_camera, -w, -h, -1);
        $d5b33d7c30034067$var$setPoint('n2', pointMap, geometry, $d5b33d7c30034067$var$_camera, w, -h, -1);
        $d5b33d7c30034067$var$setPoint('n3', pointMap, geometry, $d5b33d7c30034067$var$_camera, -w, h, -1);
        $d5b33d7c30034067$var$setPoint('n4', pointMap, geometry, $d5b33d7c30034067$var$_camera, w, h, -1);
        // far
        $d5b33d7c30034067$var$setPoint('f1', pointMap, geometry, $d5b33d7c30034067$var$_camera, -w, -h, 1);
        $d5b33d7c30034067$var$setPoint('f2', pointMap, geometry, $d5b33d7c30034067$var$_camera, w, -h, 1);
        $d5b33d7c30034067$var$setPoint('f3', pointMap, geometry, $d5b33d7c30034067$var$_camera, -w, h, 1);
        $d5b33d7c30034067$var$setPoint('f4', pointMap, geometry, $d5b33d7c30034067$var$_camera, w, h, 1);
        // up
        $d5b33d7c30034067$var$setPoint('u1', pointMap, geometry, $d5b33d7c30034067$var$_camera, w * 0.7, h * 1.1, -1);
        $d5b33d7c30034067$var$setPoint('u2', pointMap, geometry, $d5b33d7c30034067$var$_camera, -w * 0.7, h * 1.1, -1);
        $d5b33d7c30034067$var$setPoint('u3', pointMap, geometry, $d5b33d7c30034067$var$_camera, 0, h * 2, -1);
        // cross
        $d5b33d7c30034067$var$setPoint('cf1', pointMap, geometry, $d5b33d7c30034067$var$_camera, -w, 0, 1);
        $d5b33d7c30034067$var$setPoint('cf2', pointMap, geometry, $d5b33d7c30034067$var$_camera, w, 0, 1);
        $d5b33d7c30034067$var$setPoint('cf3', pointMap, geometry, $d5b33d7c30034067$var$_camera, 0, -h, 1);
        $d5b33d7c30034067$var$setPoint('cf4', pointMap, geometry, $d5b33d7c30034067$var$_camera, 0, h, 1);
        $d5b33d7c30034067$var$setPoint('cn1', pointMap, geometry, $d5b33d7c30034067$var$_camera, -w, 0, -1);
        $d5b33d7c30034067$var$setPoint('cn2', pointMap, geometry, $d5b33d7c30034067$var$_camera, w, 0, -1);
        $d5b33d7c30034067$var$setPoint('cn3', pointMap, geometry, $d5b33d7c30034067$var$_camera, 0, -h, -1);
        $d5b33d7c30034067$var$setPoint('cn4', pointMap, geometry, $d5b33d7c30034067$var$_camera, 0, h, -1);
        geometry.getAttribute('position').needsUpdate = true;
    }
    dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
}
function $d5b33d7c30034067$var$setPoint(point, pointMap, geometry, camera, x, y, z) {
    $d5b33d7c30034067$var$_vector.set(x, y, z).unproject(camera);
    const points = pointMap[point];
    if (points !== undefined) {
        const position = geometry.getAttribute('position');
        for(let i = 0, l = points.length; i < l; i++)position.setXYZ(points[i], $d5b33d7c30034067$var$_vector.x, $d5b33d7c30034067$var$_vector.y, $d5b33d7c30034067$var$_vector.z);
    }
}
const $d5b33d7c30034067$var$_box = /*@__PURE__*/ new $d5b33d7c30034067$export$6f7d5a9418ab2aa3();
class $d5b33d7c30034067$export$38a664cc862a6a9d extends $d5b33d7c30034067$export$ff1ed10fedfdd604 {
    constructor(object, color = 0xffff00){
        const indices = new Uint16Array([
            0,
            1,
            1,
            2,
            2,
            3,
            3,
            0,
            4,
            5,
            5,
            6,
            6,
            7,
            7,
            4,
            0,
            4,
            1,
            5,
            2,
            6,
            3,
            7
        ]);
        const positions = new Float32Array(24);
        const geometry = new $d5b33d7c30034067$export$b7be63a67df8959();
        geometry.setIndex(new $d5b33d7c30034067$export$8dea267bd6bde117(indices, 1));
        geometry.setAttribute('position', new $d5b33d7c30034067$export$8dea267bd6bde117(positions, 3));
        super(geometry, new $d5b33d7c30034067$export$fbaaa33907730a0c({
            color: color,
            toneMapped: false
        }));
        this.object = object;
        this.type = 'BoxHelper';
        this.matrixAutoUpdate = false;
        this.update();
    }
    update(object) {
        if (object !== undefined) console.warn('THREE.BoxHelper: .update() has no longer arguments.');
        if (this.object !== undefined) $d5b33d7c30034067$var$_box.setFromObject(this.object);
        if ($d5b33d7c30034067$var$_box.isEmpty()) return;
        const min = $d5b33d7c30034067$var$_box.min;
        const max = $d5b33d7c30034067$var$_box.max;
        /*
			5____4
		1/___0/|
		| 6__|_7
		2/___3/

		0: max.x, max.y, max.z
		1: min.x, max.y, max.z
		2: min.x, min.y, max.z
		3: max.x, min.y, max.z
		4: max.x, max.y, min.z
		5: min.x, max.y, min.z
		6: min.x, min.y, min.z
		7: max.x, min.y, min.z
		*/ const position = this.geometry.attributes.position;
        const array = position.array;
        array[0] = max.x;
        array[1] = max.y;
        array[2] = max.z;
        array[3] = min.x;
        array[4] = max.y;
        array[5] = max.z;
        array[6] = min.x;
        array[7] = min.y;
        array[8] = max.z;
        array[9] = max.x;
        array[10] = min.y;
        array[11] = max.z;
        array[12] = max.x;
        array[13] = max.y;
        array[14] = min.z;
        array[15] = min.x;
        array[16] = max.y;
        array[17] = min.z;
        array[18] = min.x;
        array[19] = min.y;
        array[20] = min.z;
        array[21] = max.x;
        array[22] = min.y;
        array[23] = min.z;
        position.needsUpdate = true;
        this.geometry.computeBoundingSphere();
    }
    setFromObject(object) {
        this.object = object;
        this.update();
        return this;
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.object = source.object;
        return this;
    }
    dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
}
class $d5b33d7c30034067$export$ce39f4bb96c9a290 extends $d5b33d7c30034067$export$ff1ed10fedfdd604 {
    constructor(box, color = 0xffff00){
        const indices = new Uint16Array([
            0,
            1,
            1,
            2,
            2,
            3,
            3,
            0,
            4,
            5,
            5,
            6,
            6,
            7,
            7,
            4,
            0,
            4,
            1,
            5,
            2,
            6,
            3,
            7
        ]);
        const positions = [
            1,
            1,
            1,
            -1,
            1,
            1,
            -1,
            -1,
            1,
            1,
            -1,
            1,
            1,
            1,
            -1,
            -1,
            1,
            -1,
            -1,
            -1,
            -1,
            1,
            -1,
            -1
        ];
        const geometry = new $d5b33d7c30034067$export$b7be63a67df8959();
        geometry.setIndex(new $d5b33d7c30034067$export$8dea267bd6bde117(indices, 1));
        geometry.setAttribute('position', new $d5b33d7c30034067$export$cbe7a62641830ebd(positions, 3));
        super(geometry, new $d5b33d7c30034067$export$fbaaa33907730a0c({
            color: color,
            toneMapped: false
        }));
        this.box = box;
        this.type = 'Box3Helper';
        this.geometry.computeBoundingSphere();
    }
    updateMatrixWorld(force) {
        const box = this.box;
        if (box.isEmpty()) return;
        box.getCenter(this.position);
        box.getSize(this.scale);
        this.scale.multiplyScalar(0.5);
        super.updateMatrixWorld(force);
    }
    dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
}
class $d5b33d7c30034067$export$a34fe8156c66e5d7 extends $d5b33d7c30034067$export$17d680238e50603e {
    constructor(plane, size = 1, hex = 0xffff00){
        const color = hex;
        const positions = [
            1,
            -1,
            0,
            -1,
            1,
            0,
            -1,
            -1,
            0,
            1,
            1,
            0,
            -1,
            1,
            0,
            -1,
            -1,
            0,
            1,
            -1,
            0,
            1,
            1,
            0
        ];
        const geometry = new $d5b33d7c30034067$export$b7be63a67df8959();
        geometry.setAttribute('position', new $d5b33d7c30034067$export$cbe7a62641830ebd(positions, 3));
        geometry.computeBoundingSphere();
        super(geometry, new $d5b33d7c30034067$export$fbaaa33907730a0c({
            color: color,
            toneMapped: false
        }));
        this.type = 'PlaneHelper';
        this.plane = plane;
        this.size = size;
        const positions2 = [
            1,
            1,
            0,
            -1,
            1,
            0,
            -1,
            -1,
            0,
            1,
            1,
            0,
            -1,
            -1,
            0,
            1,
            -1,
            0
        ];
        const geometry2 = new $d5b33d7c30034067$export$b7be63a67df8959();
        geometry2.setAttribute('position', new $d5b33d7c30034067$export$cbe7a62641830ebd(positions2, 3));
        geometry2.computeBoundingSphere();
        this.add(new $d5b33d7c30034067$export$e176487c05830cc5(geometry2, new $d5b33d7c30034067$export$55cbcc9b622fe1f5({
            color: color,
            opacity: 0.2,
            transparent: true,
            depthWrite: false,
            toneMapped: false
        })));
    }
    updateMatrixWorld(force) {
        this.position.set(0, 0, 0);
        this.scale.set(0.5 * this.size, 0.5 * this.size, 1);
        this.lookAt(this.plane.normal);
        this.translateZ(-this.plane.constant);
        super.updateMatrixWorld(force);
    }
    dispose() {
        this.geometry.dispose();
        this.material.dispose();
        this.children[0].geometry.dispose();
        this.children[0].material.dispose();
    }
}
const $d5b33d7c30034067$var$_axis = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
let $d5b33d7c30034067$var$_lineGeometry, $d5b33d7c30034067$var$_coneGeometry;
class $d5b33d7c30034067$export$a3008e7bd8d2cbe7 extends $d5b33d7c30034067$export$e4dd07dff30cc924 {
    // dir is assumed to be normalized
    constructor(dir = new $d5b33d7c30034067$export$64b5c384219d3699(0, 0, 1), origin = new $d5b33d7c30034067$export$64b5c384219d3699(0, 0, 0), length = 1, color = 0xffff00, headLength = length * 0.2, headWidth = headLength * 0.2){
        super();
        this.type = 'ArrowHelper';
        if ($d5b33d7c30034067$var$_lineGeometry === undefined) {
            $d5b33d7c30034067$var$_lineGeometry = new $d5b33d7c30034067$export$b7be63a67df8959();
            $d5b33d7c30034067$var$_lineGeometry.setAttribute('position', new $d5b33d7c30034067$export$cbe7a62641830ebd([
                0,
                0,
                0,
                0,
                1,
                0
            ], 3));
            $d5b33d7c30034067$var$_coneGeometry = new $d5b33d7c30034067$export$68f745719dbe5198(0, 0.5, 1, 5, 1);
            $d5b33d7c30034067$var$_coneGeometry.translate(0, -0.5, 0);
        }
        this.position.copy(origin);
        this.line = new $d5b33d7c30034067$export$17d680238e50603e($d5b33d7c30034067$var$_lineGeometry, new $d5b33d7c30034067$export$fbaaa33907730a0c({
            color: color,
            toneMapped: false
        }));
        this.line.matrixAutoUpdate = false;
        this.add(this.line);
        this.cone = new $d5b33d7c30034067$export$e176487c05830cc5($d5b33d7c30034067$var$_coneGeometry, new $d5b33d7c30034067$export$55cbcc9b622fe1f5({
            color: color,
            toneMapped: false
        }));
        this.cone.matrixAutoUpdate = false;
        this.add(this.cone);
        this.setDirection(dir);
        this.setLength(length, headLength, headWidth);
    }
    setDirection(dir) {
        // dir is assumed to be normalized
        if (dir.y > 0.99999) this.quaternion.set(0, 0, 0, 1);
        else if (dir.y < -0.99999) this.quaternion.set(1, 0, 0, 0);
        else {
            $d5b33d7c30034067$var$_axis.set(dir.z, 0, -dir.x).normalize();
            const radians = Math.acos(dir.y);
            this.quaternion.setFromAxisAngle($d5b33d7c30034067$var$_axis, radians);
        }
    }
    setLength(length, headLength = length * 0.2, headWidth = headLength * 0.2) {
        this.line.scale.set(1, Math.max(0.0001, length - headLength), 1); // see #17458
        this.line.updateMatrix();
        this.cone.scale.set(headWidth, headLength, headWidth);
        this.cone.position.y = length;
        this.cone.updateMatrix();
    }
    setColor(color) {
        this.line.material.color.set(color);
        this.cone.material.color.set(color);
    }
    copy(source) {
        super.copy(source, false);
        this.line.copy(source.line);
        this.cone.copy(source.cone);
        return this;
    }
    dispose() {
        this.line.geometry.dispose();
        this.line.material.dispose();
        this.cone.geometry.dispose();
        this.cone.material.dispose();
    }
}
class $d5b33d7c30034067$export$6c8303f35b8578fd extends $d5b33d7c30034067$export$ff1ed10fedfdd604 {
    constructor(size = 1){
        const vertices = [
            0,
            0,
            0,
            size,
            0,
            0,
            0,
            0,
            0,
            0,
            size,
            0,
            0,
            0,
            0,
            0,
            0,
            size
        ];
        const colors = [
            1,
            0,
            0,
            1,
            0.6,
            0,
            0,
            1,
            0,
            0.6,
            1,
            0,
            0,
            0,
            1,
            0,
            0.6,
            1
        ];
        const geometry = new $d5b33d7c30034067$export$b7be63a67df8959();
        geometry.setAttribute('position', new $d5b33d7c30034067$export$cbe7a62641830ebd(vertices, 3));
        geometry.setAttribute('color', new $d5b33d7c30034067$export$cbe7a62641830ebd(colors, 3));
        const material = new $d5b33d7c30034067$export$fbaaa33907730a0c({
            vertexColors: true,
            toneMapped: false
        });
        super(geometry, material);
        this.type = 'AxesHelper';
    }
    setColors(xAxisColor, yAxisColor, zAxisColor) {
        const color = new $d5b33d7c30034067$export$892596cec99bc70e();
        const array = this.geometry.attributes.color.array;
        color.set(xAxisColor);
        color.toArray(array, 0);
        color.toArray(array, 3);
        color.set(yAxisColor);
        color.toArray(array, 6);
        color.toArray(array, 9);
        color.set(zAxisColor);
        color.toArray(array, 12);
        color.toArray(array, 15);
        this.geometry.attributes.color.needsUpdate = true;
        return this;
    }
    dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
}
class $d5b33d7c30034067$export$148534a3c727230b {
    constructor(){
        this.type = 'ShapePath';
        this.color = new $d5b33d7c30034067$export$892596cec99bc70e();
        this.subPaths = [];
        this.currentPath = null;
    }
    moveTo(x, y) {
        this.currentPath = new $d5b33d7c30034067$export$4b2950bdac9b6ee9();
        this.subPaths.push(this.currentPath);
        this.currentPath.moveTo(x, y);
        return this;
    }
    lineTo(x, y) {
        this.currentPath.lineTo(x, y);
        return this;
    }
    quadraticCurveTo(aCPx, aCPy, aX, aY) {
        this.currentPath.quadraticCurveTo(aCPx, aCPy, aX, aY);
        return this;
    }
    bezierCurveTo(aCP1x, aCP1y, aCP2x, aCP2y, aX, aY) {
        this.currentPath.bezierCurveTo(aCP1x, aCP1y, aCP2x, aCP2y, aX, aY);
        return this;
    }
    splineThru(pts) {
        this.currentPath.splineThru(pts);
        return this;
    }
    toShapes(isCCW) {
        function toShapesNoHoles(inSubpaths) {
            const shapes = [];
            for(let i = 0, l = inSubpaths.length; i < l; i++){
                const tmpPath = inSubpaths[i];
                const tmpShape = new $d5b33d7c30034067$export$6428a7f2611ef1fa();
                tmpShape.curves = tmpPath.curves;
                shapes.push(tmpShape);
            }
            return shapes;
        }
        function isPointInsidePolygon(inPt, inPolygon) {
            const polyLen = inPolygon.length;
            // inPt on polygon contour => immediate success    or
            // toggling of inside/outside at every single! intersection point of an edge
            //  with the horizontal line through inPt, left of inPt
            //  not counting lowerY endpoints of edges and whole edges on that line
            let inside = false;
            for(let p = polyLen - 1, q = 0; q < polyLen; p = q++){
                let edgeLowPt = inPolygon[p];
                let edgeHighPt = inPolygon[q];
                let edgeDx = edgeHighPt.x - edgeLowPt.x;
                let edgeDy = edgeHighPt.y - edgeLowPt.y;
                if (Math.abs(edgeDy) > Number.EPSILON) {
                    // not parallel
                    if (edgeDy < 0) {
                        edgeLowPt = inPolygon[q];
                        edgeDx = -edgeDx;
                        edgeHighPt = inPolygon[p];
                        edgeDy = -edgeDy;
                    }
                    if (inPt.y < edgeLowPt.y || inPt.y > edgeHighPt.y) continue;
                    if (inPt.y === edgeLowPt.y) {
                        if (inPt.x === edgeLowPt.x) return true; // inPt is on contour ?
                    // continue;				// no intersection or edgeLowPt => doesn't count !!!
                    } else {
                        const perpEdge = edgeDy * (inPt.x - edgeLowPt.x) - edgeDx * (inPt.y - edgeLowPt.y);
                        if (perpEdge === 0) return true; // inPt is on contour ?
                        if (perpEdge < 0) continue;
                        inside = !inside; // true intersection left of inPt
                    }
                } else {
                    // parallel or collinear
                    if (inPt.y !== edgeLowPt.y) continue; // parallel
                    // edge lies on the same horizontal line as inPt
                    if (edgeHighPt.x <= inPt.x && inPt.x <= edgeLowPt.x || edgeLowPt.x <= inPt.x && inPt.x <= edgeHighPt.x) return true; // inPt: Point on contour !
                // continue;
                }
            }
            return inside;
        }
        const isClockWise = $d5b33d7c30034067$export$96bdf6d9c66d7ba8.isClockWise;
        const subPaths = this.subPaths;
        if (subPaths.length === 0) return [];
        let solid, tmpPath, tmpShape;
        const shapes = [];
        if (subPaths.length === 1) {
            tmpPath = subPaths[0];
            tmpShape = new $d5b33d7c30034067$export$6428a7f2611ef1fa();
            tmpShape.curves = tmpPath.curves;
            shapes.push(tmpShape);
            return shapes;
        }
        let holesFirst = !isClockWise(subPaths[0].getPoints());
        holesFirst = isCCW ? !holesFirst : holesFirst;
        // console.log("Holes first", holesFirst);
        const betterShapeHoles = [];
        const newShapes = [];
        let newShapeHoles = [];
        let mainIdx = 0;
        let tmpPoints;
        newShapes[mainIdx] = undefined;
        newShapeHoles[mainIdx] = [];
        for(let i = 0, l = subPaths.length; i < l; i++){
            tmpPath = subPaths[i];
            tmpPoints = tmpPath.getPoints();
            solid = isClockWise(tmpPoints);
            solid = isCCW ? !solid : solid;
            if (solid) {
                if (!holesFirst && newShapes[mainIdx]) mainIdx++;
                newShapes[mainIdx] = {
                    s: new $d5b33d7c30034067$export$6428a7f2611ef1fa(),
                    p: tmpPoints
                };
                newShapes[mainIdx].s.curves = tmpPath.curves;
                if (holesFirst) mainIdx++;
                newShapeHoles[mainIdx] = [];
            //console.log('cw', i);
            } else newShapeHoles[mainIdx].push({
                h: tmpPath,
                p: tmpPoints[0]
            });
        }
        // only Holes? -> probably all Shapes with wrong orientation
        if (!newShapes[0]) return toShapesNoHoles(subPaths);
        if (newShapes.length > 1) {
            let ambiguous = false;
            let toChange = 0;
            for(let sIdx = 0, sLen = newShapes.length; sIdx < sLen; sIdx++)betterShapeHoles[sIdx] = [];
            for(let sIdx = 0, sLen = newShapes.length; sIdx < sLen; sIdx++){
                const sho = newShapeHoles[sIdx];
                for(let hIdx = 0; hIdx < sho.length; hIdx++){
                    const ho = sho[hIdx];
                    let hole_unassigned = true;
                    for(let s2Idx = 0; s2Idx < newShapes.length; s2Idx++)if (isPointInsidePolygon(ho.p, newShapes[s2Idx].p)) {
                        if (sIdx !== s2Idx) toChange++;
                        if (hole_unassigned) {
                            hole_unassigned = false;
                            betterShapeHoles[s2Idx].push(ho);
                        } else ambiguous = true;
                    }
                    if (hole_unassigned) betterShapeHoles[sIdx].push(ho);
                }
            }
            if (toChange > 0 && ambiguous === false) newShapeHoles = betterShapeHoles;
        }
        let tmpHoles;
        for(let i = 0, il = newShapes.length; i < il; i++){
            tmpShape = newShapes[i].s;
            shapes.push(tmpShape);
            tmpHoles = newShapeHoles[i];
            for(let j = 0, jl = tmpHoles.length; j < jl; j++)tmpShape.holes.push(tmpHoles[j].h);
        }
        //console.log("shape", shapes);
        return shapes;
    }
}
class $d5b33d7c30034067$export$c7c44baae9d9f25f extends $d5b33d7c30034067$export$ec8b666c5fe2c75a {
    constructor(object, domElement = null){
        super();
        this.object = object;
        this.domElement = domElement;
        this.enabled = true;
        this.state = -1;
        this.keys = {};
        this.mouseButtons = {
            LEFT: null,
            MIDDLE: null,
            RIGHT: null
        };
        this.touches = {
            ONE: null,
            TWO: null
        };
    }
    connect() {}
    disconnect() {}
    dispose() {}
    update() {}
}
class $d5b33d7c30034067$export$bd934554fb721730 extends $d5b33d7c30034067$export$3c052beb2e51e23f {
    constructor(width = 1, height = 1, count = 1, options = {}){
        console.warn('THREE.WebGLMultipleRenderTargets has been deprecated and will be removed in r172. Use THREE.WebGLRenderTarget and set the "count" parameter to enable MRT.');
        super(width, height, {
            ...options,
            count: count
        });
        this.isWebGLMultipleRenderTargets = true;
    }
    get texture() {
        return this.textures;
    }
}
if (typeof __THREE_DEVTOOLS__ !== 'undefined') __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent('register', {
    detail: {
        revision: $d5b33d7c30034067$export$3545e07a80636437
    }
}));
if (typeof window !== 'undefined') {
    if (window.__THREE__) console.warn('WARNING: Multiple instances of Three.js being imported.');
    else window.__THREE__ = $d5b33d7c30034067$export$3545e07a80636437;
}



const $40043d5ea0db3d61$var$_plane = new (0, $d5b33d7c30034067$export$7ff5ac152ef991b0)();
const $40043d5ea0db3d61$var$_pointer = new (0, $d5b33d7c30034067$export$c977b3e384af9ae1)();
const $40043d5ea0db3d61$var$_offset = new (0, $d5b33d7c30034067$export$64b5c384219d3699)();
const $40043d5ea0db3d61$var$_diff = new (0, $d5b33d7c30034067$export$c977b3e384af9ae1)();
const $40043d5ea0db3d61$var$_previousPointer = new (0, $d5b33d7c30034067$export$c977b3e384af9ae1)();
const $40043d5ea0db3d61$var$_intersection = new (0, $d5b33d7c30034067$export$64b5c384219d3699)();
const $40043d5ea0db3d61$var$_worldPosition = new (0, $d5b33d7c30034067$export$64b5c384219d3699)();
const $40043d5ea0db3d61$var$_inverseMatrix = new (0, $d5b33d7c30034067$export$2ae72fc923e5eb5)();
const $40043d5ea0db3d61$var$_up = new (0, $d5b33d7c30034067$export$64b5c384219d3699)();
const $40043d5ea0db3d61$var$_right = new (0, $d5b33d7c30034067$export$64b5c384219d3699)();
let $40043d5ea0db3d61$var$_selected = null, $40043d5ea0db3d61$var$_hovered = null;
const $40043d5ea0db3d61$var$_intersections = [];
const $40043d5ea0db3d61$var$STATE = {
    NONE: -1,
    PAN: 0,
    ROTATE: 1
};
class $40043d5ea0db3d61$export$350d0cf1f91b53f4 extends (0, $d5b33d7c30034067$export$c7c44baae9d9f25f) {
    constructor(objects, camera, domElement = null){
        super(camera, domElement);
        this.objects = objects;
        this.recursive = true;
        this.transformGroup = false;
        this.rotateSpeed = 1;
        this.raycaster = new (0, $d5b33d7c30034067$export$8b7aaceff00bd2f)();
        // interaction
        this.mouseButtons = {
            LEFT: (0, $d5b33d7c30034067$export$7177b3e430c2d7ca).PAN,
            MIDDLE: (0, $d5b33d7c30034067$export$7177b3e430c2d7ca).PAN,
            RIGHT: (0, $d5b33d7c30034067$export$7177b3e430c2d7ca).ROTATE
        };
        this.touches = {
            ONE: (0, $d5b33d7c30034067$export$d46bd3ead7cc759b).PAN
        };
        // event listeners
        this._onPointerMove = $40043d5ea0db3d61$var$onPointerMove.bind(this);
        this._onPointerDown = $40043d5ea0db3d61$var$onPointerDown.bind(this);
        this._onPointerCancel = $40043d5ea0db3d61$var$onPointerCancel.bind(this);
        this._onContextMenu = $40043d5ea0db3d61$var$onContextMenu.bind(this);
        //
        if (domElement !== null) this.connect();
    }
    connect() {
        this.domElement.addEventListener('pointermove', this._onPointerMove);
        this.domElement.addEventListener('pointerdown', this._onPointerDown);
        this.domElement.addEventListener('pointerup', this._onPointerCancel);
        this.domElement.addEventListener('pointerleave', this._onPointerCancel);
        this.domElement.addEventListener('contextmenu', this._onContextMenu);
        this.domElement.style.touchAction = 'none'; // disable touch scroll
    }
    disconnect() {
        this.domElement.removeEventListener('pointermove', this._onPointerMove);
        this.domElement.removeEventListener('pointerdown', this._onPointerDown);
        this.domElement.removeEventListener('pointerup', this._onPointerCancel);
        this.domElement.removeEventListener('pointerleave', this._onPointerCancel);
        this.domElement.removeEventListener('contextmenu', this._onContextMenu);
        this.domElement.style.touchAction = 'auto';
        this.domElement.style.cursor = '';
    }
    dispose() {
        this.disconnect();
    }
    _updatePointer(event) {
        const rect = this.domElement.getBoundingClientRect();
        $40043d5ea0db3d61$var$_pointer.x = (event.clientX - rect.left) / rect.width * 2 - 1;
        $40043d5ea0db3d61$var$_pointer.y = -(event.clientY - rect.top) / rect.height * 2 + 1;
    }
    _updateState(event) {
        // determine action
        let action;
        if (event.pointerType === 'touch') action = this.touches.ONE;
        else switch(event.button){
            case 0:
                action = this.mouseButtons.LEFT;
                break;
            case 1:
                action = this.mouseButtons.MIDDLE;
                break;
            case 2:
                action = this.mouseButtons.RIGHT;
                break;
            default:
                action = null;
        }
        // determine state
        switch(action){
            case (0, $d5b33d7c30034067$export$7177b3e430c2d7ca).PAN:
            case (0, $d5b33d7c30034067$export$d46bd3ead7cc759b).PAN:
                this.state = $40043d5ea0db3d61$var$STATE.PAN;
                break;
            case (0, $d5b33d7c30034067$export$7177b3e430c2d7ca).ROTATE:
            case (0, $d5b33d7c30034067$export$d46bd3ead7cc759b).ROTATE:
                this.state = $40043d5ea0db3d61$var$STATE.ROTATE;
                break;
            default:
                this.state = $40043d5ea0db3d61$var$STATE.NONE;
        }
    }
    getRaycaster() {
        console.warn('THREE.DragControls: getRaycaster() has been deprecated. Use controls.raycaster instead.'); // @deprecated r169
        return this.raycaster;
    }
    setObjects(objects) {
        console.warn('THREE.DragControls: setObjects() has been deprecated. Use controls.objects instead.'); // @deprecated r169
        this.objects = objects;
    }
    getObjects() {
        console.warn('THREE.DragControls: getObjects() has been deprecated. Use controls.objects instead.'); // @deprecated r169
        return this.objects;
    }
    activate() {
        console.warn('THREE.DragControls: activate() has been renamed to connect().'); // @deprecated r169
        this.connect();
    }
    deactivate() {
        console.warn('THREE.DragControls: deactivate() has been renamed to disconnect().'); // @deprecated r169
        this.disconnect();
    }
    set mode(value) {
        console.warn('THREE.DragControls: The .mode property has been removed. Define the type of transformation via the .mouseButtons or .touches properties.'); // @deprecated r169
    }
    get mode() {
        console.warn('THREE.DragControls: The .mode property has been removed. Define the type of transformation via the .mouseButtons or .touches properties.'); // @deprecated r169
    }
}
function $40043d5ea0db3d61$var$onPointerMove(event) {
    const camera = this.object;
    const domElement = this.domElement;
    const raycaster = this.raycaster;
    if (this.enabled === false) return;
    this._updatePointer(event);
    raycaster.setFromCamera($40043d5ea0db3d61$var$_pointer, camera);
    if ($40043d5ea0db3d61$var$_selected) {
        if (this.state === $40043d5ea0db3d61$var$STATE.PAN) {
            if (raycaster.ray.intersectPlane($40043d5ea0db3d61$var$_plane, $40043d5ea0db3d61$var$_intersection)) $40043d5ea0db3d61$var$_selected.position.copy($40043d5ea0db3d61$var$_intersection.sub($40043d5ea0db3d61$var$_offset).applyMatrix4($40043d5ea0db3d61$var$_inverseMatrix));
        } else if (this.state === $40043d5ea0db3d61$var$STATE.ROTATE) {
            $40043d5ea0db3d61$var$_diff.subVectors($40043d5ea0db3d61$var$_pointer, $40043d5ea0db3d61$var$_previousPointer).multiplyScalar(this.rotateSpeed);
            $40043d5ea0db3d61$var$_selected.rotateOnWorldAxis($40043d5ea0db3d61$var$_up, $40043d5ea0db3d61$var$_diff.x);
            $40043d5ea0db3d61$var$_selected.rotateOnWorldAxis($40043d5ea0db3d61$var$_right.normalize(), -$40043d5ea0db3d61$var$_diff.y);
        }
        this.dispatchEvent({
            type: 'drag',
            object: $40043d5ea0db3d61$var$_selected
        });
        $40043d5ea0db3d61$var$_previousPointer.copy($40043d5ea0db3d61$var$_pointer);
    } else // hover support
    if (event.pointerType === 'mouse' || event.pointerType === 'pen') {
        $40043d5ea0db3d61$var$_intersections.length = 0;
        raycaster.setFromCamera($40043d5ea0db3d61$var$_pointer, camera);
        raycaster.intersectObjects(this.objects, this.recursive, $40043d5ea0db3d61$var$_intersections);
        if ($40043d5ea0db3d61$var$_intersections.length > 0) {
            const object = $40043d5ea0db3d61$var$_intersections[0].object;
            $40043d5ea0db3d61$var$_plane.setFromNormalAndCoplanarPoint(camera.getWorldDirection($40043d5ea0db3d61$var$_plane.normal), $40043d5ea0db3d61$var$_worldPosition.setFromMatrixPosition(object.matrixWorld));
            if ($40043d5ea0db3d61$var$_hovered !== object && $40043d5ea0db3d61$var$_hovered !== null) {
                this.dispatchEvent({
                    type: 'hoveroff',
                    object: $40043d5ea0db3d61$var$_hovered
                });
                domElement.style.cursor = 'auto';
                $40043d5ea0db3d61$var$_hovered = null;
            }
            if ($40043d5ea0db3d61$var$_hovered !== object) {
                this.dispatchEvent({
                    type: 'hoveron',
                    object: object
                });
                domElement.style.cursor = 'pointer';
                $40043d5ea0db3d61$var$_hovered = object;
            }
        } else if ($40043d5ea0db3d61$var$_hovered !== null) {
            this.dispatchEvent({
                type: 'hoveroff',
                object: $40043d5ea0db3d61$var$_hovered
            });
            domElement.style.cursor = 'auto';
            $40043d5ea0db3d61$var$_hovered = null;
        }
    }
    $40043d5ea0db3d61$var$_previousPointer.copy($40043d5ea0db3d61$var$_pointer);
}
function $40043d5ea0db3d61$var$onPointerDown(event) {
    const camera = this.object;
    const domElement = this.domElement;
    const raycaster = this.raycaster;
    if (this.enabled === false) return;
    this._updatePointer(event);
    this._updateState(event);
    $40043d5ea0db3d61$var$_intersections.length = 0;
    raycaster.setFromCamera($40043d5ea0db3d61$var$_pointer, camera);
    raycaster.intersectObjects(this.objects, this.recursive, $40043d5ea0db3d61$var$_intersections);
    if ($40043d5ea0db3d61$var$_intersections.length > 0) {
        if (this.transformGroup === true) // look for the outermost group in the object's upper hierarchy
        $40043d5ea0db3d61$var$_selected = $40043d5ea0db3d61$var$findGroup($40043d5ea0db3d61$var$_intersections[0].object);
        else $40043d5ea0db3d61$var$_selected = $40043d5ea0db3d61$var$_intersections[0].object;
        $40043d5ea0db3d61$var$_plane.setFromNormalAndCoplanarPoint(camera.getWorldDirection($40043d5ea0db3d61$var$_plane.normal), $40043d5ea0db3d61$var$_worldPosition.setFromMatrixPosition($40043d5ea0db3d61$var$_selected.matrixWorld));
        if (raycaster.ray.intersectPlane($40043d5ea0db3d61$var$_plane, $40043d5ea0db3d61$var$_intersection)) {
            if (this.state === $40043d5ea0db3d61$var$STATE.PAN) {
                $40043d5ea0db3d61$var$_inverseMatrix.copy($40043d5ea0db3d61$var$_selected.parent.matrixWorld).invert();
                $40043d5ea0db3d61$var$_offset.copy($40043d5ea0db3d61$var$_intersection).sub($40043d5ea0db3d61$var$_worldPosition.setFromMatrixPosition($40043d5ea0db3d61$var$_selected.matrixWorld));
            } else if (this.state === $40043d5ea0db3d61$var$STATE.ROTATE) {
                // the controls only support Y+ up
                $40043d5ea0db3d61$var$_up.set(0, 1, 0).applyQuaternion(camera.quaternion).normalize();
                $40043d5ea0db3d61$var$_right.set(1, 0, 0).applyQuaternion(camera.quaternion).normalize();
            }
        }
        domElement.style.cursor = 'move';
        this.dispatchEvent({
            type: 'dragstart',
            object: $40043d5ea0db3d61$var$_selected
        });
    }
    $40043d5ea0db3d61$var$_previousPointer.copy($40043d5ea0db3d61$var$_pointer);
}
function $40043d5ea0db3d61$var$onPointerCancel() {
    if (this.enabled === false) return;
    if ($40043d5ea0db3d61$var$_selected) {
        this.dispatchEvent({
            type: 'dragend',
            object: $40043d5ea0db3d61$var$_selected
        });
        $40043d5ea0db3d61$var$_selected = null;
    }
    this.domElement.style.cursor = $40043d5ea0db3d61$var$_hovered ? 'pointer' : 'auto';
    this.state = $40043d5ea0db3d61$var$STATE.NONE;
}
function $40043d5ea0db3d61$var$onContextMenu(event) {
    if (this.enabled === false) return;
    event.preventDefault();
}
function $40043d5ea0db3d61$var$findGroup(obj, group = null) {
    if (obj.isGroup) group = obj;
    if (obj.parent === null) return group;
    return $40043d5ea0db3d61$var$findGroup(obj.parent, group);
}



function $38b55043e008942d$export$2e2bcd8739ae039(x, y, z) {
    var nodes, strength = 1;
    if (x == null) x = 0;
    if (y == null) y = 0;
    if (z == null) z = 0;
    function force() {
        var i, n = nodes.length, node, sx = 0, sy = 0, sz = 0;
        for(i = 0; i < n; ++i)node = nodes[i], sx += node.x || 0, sy += node.y || 0, sz += node.z || 0;
        for(sx = (sx / n - x) * strength, sy = (sy / n - y) * strength, sz = (sz / n - z) * strength, i = 0; i < n; ++i){
            node = nodes[i];
            if (sx) node.x -= sx;
            if (sy) node.y -= sy;
            if (sz) node.z -= sz;
        }
    }
    force.initialize = function(_) {
        nodes = _;
    };
    force.x = function(_) {
        return arguments.length ? (x = +_, force) : x;
    };
    force.y = function(_) {
        return arguments.length ? (y = +_, force) : y;
    };
    force.z = function(_) {
        return arguments.length ? (z = +_, force) : z;
    };
    force.strength = function(_) {
        return arguments.length ? (strength = +_, force) : strength;
    };
    return force;
}

function $439e574675725ffd$export$2e2bcd8739ae039(x) {
    return function() {
        return x;
    };
}


function $873789d86530d8a0$export$2e2bcd8739ae039(random) {
    return (random() - 0.5) * 1e-6;
}


function $b1bbf836822558b1$var$index(d) {
    return d.index;
}
function $b1bbf836822558b1$var$find(nodeById, nodeId) {
    var node = nodeById.get(nodeId);
    if (!node) throw new Error("node not found: " + nodeId);
    return node;
}
function $b1bbf836822558b1$export$2e2bcd8739ae039(links) {
    var id = $b1bbf836822558b1$var$index, strength = defaultStrength, strengths, distance = (0, $439e574675725ffd$export$2e2bcd8739ae039)(30), distances, nodes, nDim, count, bias, random, iterations = 1;
    if (links == null) links = [];
    function defaultStrength(link) {
        return 1 / Math.min(count[link.source.index], count[link.target.index]);
    }
    function force(alpha) {
        for(var k = 0, n = links.length; k < iterations; ++k)for(var i = 0, link, source, target, x = 0, y = 0, z = 0, l, b; i < n; ++i){
            link = links[i], source = link.source, target = link.target;
            x = target.x + target.vx - source.x - source.vx || (0, $873789d86530d8a0$export$2e2bcd8739ae039)(random);
            if (nDim > 1) y = target.y + target.vy - source.y - source.vy || (0, $873789d86530d8a0$export$2e2bcd8739ae039)(random);
            if (nDim > 2) z = target.z + target.vz - source.z - source.vz || (0, $873789d86530d8a0$export$2e2bcd8739ae039)(random);
            l = Math.sqrt(x * x + y * y + z * z);
            l = (l - distances[i]) / l * alpha * strengths[i];
            x *= l, y *= l, z *= l;
            target.vx -= x * (b = bias[i]);
            if (nDim > 1) target.vy -= y * b;
            if (nDim > 2) target.vz -= z * b;
            source.vx += x * (b = 1 - b);
            if (nDim > 1) source.vy += y * b;
            if (nDim > 2) source.vz += z * b;
        }
    }
    function initialize() {
        if (!nodes) return;
        var i, n = nodes.length, m = links.length, nodeById = new Map(nodes.map((d, i)=>[
                id(d, i, nodes),
                d
            ])), link;
        for(i = 0, count = new Array(n); i < m; ++i){
            link = links[i], link.index = i;
            if (typeof link.source !== "object") link.source = $b1bbf836822558b1$var$find(nodeById, link.source);
            if (typeof link.target !== "object") link.target = $b1bbf836822558b1$var$find(nodeById, link.target);
            count[link.source.index] = (count[link.source.index] || 0) + 1;
            count[link.target.index] = (count[link.target.index] || 0) + 1;
        }
        for(i = 0, bias = new Array(m); i < m; ++i)link = links[i], bias[i] = count[link.source.index] / (count[link.source.index] + count[link.target.index]);
        strengths = new Array(m), initializeStrength();
        distances = new Array(m), initializeDistance();
    }
    function initializeStrength() {
        if (!nodes) return;
        for(var i = 0, n = links.length; i < n; ++i)strengths[i] = +strength(links[i], i, links);
    }
    function initializeDistance() {
        if (!nodes) return;
        for(var i = 0, n = links.length; i < n; ++i)distances[i] = +distance(links[i], i, links);
    }
    force.initialize = function(_nodes, ...args) {
        nodes = _nodes;
        random = args.find((arg)=>typeof arg === 'function') || Math.random;
        nDim = args.find((arg)=>[
                1,
                2,
                3
            ].includes(arg)) || 2;
        initialize();
    };
    force.links = function(_) {
        return arguments.length ? (links = _, initialize(), force) : links;
    };
    force.id = function(_) {
        return arguments.length ? (id = _, force) : id;
    };
    force.iterations = function(_) {
        return arguments.length ? (iterations = +_, force) : iterations;
    };
    force.strength = function(_) {
        return arguments.length ? (strength = typeof _ === "function" ? _ : (0, $439e574675725ffd$export$2e2bcd8739ae039)(+_), initializeStrength(), force) : strength;
    };
    force.distance = function(_) {
        return arguments.length ? (distance = typeof _ === "function" ? _ : (0, $439e574675725ffd$export$2e2bcd8739ae039)(+_), initializeDistance(), force) : distance;
    };
    return force;
}

function $57250c0faa51357c$export$2e2bcd8739ae039(d) {
    const x = +this._x.call(null, d);
    return $57250c0faa51357c$var$add(this.cover(x), x, d);
}
function $57250c0faa51357c$var$add(tree, x, d) {
    if (isNaN(x)) return tree; // ignore invalid points
    var parent, node = tree._root, leaf = {
        data: d
    }, x0 = tree._x0, x1 = tree._x1, xm, xp, right, i, j;
    // If the tree is empty, initialize the root as a leaf.
    if (!node) return tree._root = leaf, tree;
    // Find the existing leaf for the new point, or add it.
    while(node.length){
        if (right = x >= (xm = (x0 + x1) / 2)) x0 = xm;
        else x1 = xm;
        if (parent = node, !(node = node[i = +right])) return parent[i] = leaf, tree;
    }
    // Is the new point is exactly coincident with the existing point?
    xp = +tree._x.call(null, node.data);
    if (x === xp) return leaf.next = node, parent ? parent[i] = leaf : tree._root = leaf, tree;
    // Otherwise, split the leaf node until the old and new point are separated.
    do {
        parent = parent ? parent[i] = new Array(2) : tree._root = new Array(2);
        if (right = x >= (xm = (x0 + x1) / 2)) x0 = xm;
        else x1 = xm;
    }while ((i = +right) === (j = +(xp >= xm)));
    return parent[j] = node, parent[i] = leaf, tree;
}
function $57250c0faa51357c$export$32ed0561867ec8a1(data) {
    if (!Array.isArray(data)) data = Array.from(data);
    const n = data.length;
    const xz = new Float64Array(n);
    let x0 = Infinity, x1 = -Infinity;
    // Compute the points and their extent.
    for(let i = 0, x; i < n; ++i){
        if (isNaN(x = +this._x.call(null, data[i]))) continue;
        xz[i] = x;
        if (x < x0) x0 = x;
        if (x > x1) x1 = x;
    }
    // If there were no (valid) points, abort.
    if (x0 > x1) return this;
    // Expand the tree to cover the new points.
    this.cover(x0).cover(x1);
    // Add the new points.
    for(let i = 0; i < n; ++i)$57250c0faa51357c$var$add(this, xz[i], data[i]);
    return this;
}


function $d14927ef4fd63da1$export$2e2bcd8739ae039(x) {
    if (isNaN(x = +x)) return this; // ignore invalid points
    var x0 = this._x0, x1 = this._x1;
    // If the binarytree has no extent, initialize them.
    // Integer extent are necessary so that if we later double the extent,
    // the existing half boundaries don’t change due to floating point error!
    if (isNaN(x0)) x1 = (x0 = Math.floor(x)) + 1;
    else {
        var z = x1 - x0 || 1, node = this._root, parent, i;
        while(x0 > x || x >= x1){
            i = +(x < x0);
            parent = new Array(2), parent[i] = node, node = parent, z *= 2;
            switch(i){
                case 0:
                    x1 = x0 + z;
                    break;
                case 1:
                    x0 = x1 - z;
                    break;
            }
        }
        if (this._root && this._root.length) this._root = node;
    }
    this._x0 = x0;
    this._x1 = x1;
    return this;
}


function $dda78535ceca5ee1$export$2e2bcd8739ae039() {
    var data = [];
    this.visit(function(node) {
        if (!node.length) do data.push(node.data);
        while (node = node.next);
    });
    return data;
}


function $fa07631210a576ec$export$2e2bcd8739ae039(_) {
    return arguments.length ? this.cover(+_[0][0]).cover(+_[1][0]) : isNaN(this._x0) ? undefined : [
        [
            this._x0
        ],
        [
            this._x1
        ]
    ];
}


function $cf3430a06897f678$export$2e2bcd8739ae039(node, x0, x1) {
    this.node = node;
    this.x0 = x0;
    this.x1 = x1;
}


function $71f8b79478b43ef4$export$2e2bcd8739ae039(x, radius) {
    var data, x0 = this._x0, x1, x2, x3 = this._x1, halves = [], node = this._root, q, i;
    if (node) halves.push(new (0, $cf3430a06897f678$export$2e2bcd8739ae039)(node, x0, x3));
    if (radius == null) radius = Infinity;
    else {
        x0 = x - radius;
        x3 = x + radius;
    }
    while(q = halves.pop()){
        // Stop searching if this half can’t contain a closer node.
        if (!(node = q.node) || (x1 = q.x0) > x3 || (x2 = q.x1) < x0) continue;
        // Bisect the current half.
        if (node.length) {
            var xm = (x1 + x2) / 2;
            halves.push(new (0, $cf3430a06897f678$export$2e2bcd8739ae039)(node[1], xm, x2), new (0, $cf3430a06897f678$export$2e2bcd8739ae039)(node[0], x1, xm));
            // Visit the closest half first.
            if (i = +(x >= xm)) {
                q = halves[halves.length - 1];
                halves[halves.length - 1] = halves[halves.length - 1 - i];
                halves[halves.length - 1 - i] = q;
            }
        } else {
            var d = Math.abs(x - +this._x.call(null, node.data));
            if (d < radius) {
                radius = d;
                x0 = x - d;
                x3 = x + d;
                data = node.data;
            }
        }
    }
    return data;
}


function $a9e86889947ccfe5$export$2e2bcd8739ae039(d) {
    if (isNaN(x = +this._x.call(null, d))) return this; // ignore invalid points
    var parent, node = this._root, retainer, previous, next, x0 = this._x0, x1 = this._x1, x, xm, right, i, j;
    // If the tree is empty, initialize the root as a leaf.
    if (!node) return this;
    // Find the leaf node for the point.
    // While descending, also retain the deepest parent with a non-removed sibling.
    if (node.length) while(true){
        if (right = x >= (xm = (x0 + x1) / 2)) x0 = xm;
        else x1 = xm;
        if (!(parent = node, node = node[i = +right])) return this;
        if (!node.length) break;
        if (parent[i + 1 & 1]) retainer = parent, j = i;
    }
    // Find the point to remove.
    while(node.data !== d)if (!(previous = node, node = node.next)) return this;
    if (next = node.next) delete node.next;
    // If there are multiple coincident points, remove just the point.
    if (previous) return next ? previous.next = next : delete previous.next, this;
    // If this is the root point, remove it.
    if (!parent) return this._root = next, this;
    // Remove this leaf.
    next ? parent[i] = next : delete parent[i];
    // If the parent now contains exactly one leaf, collapse superfluous parents.
    if ((node = parent[0] || parent[1]) && node === (parent[1] || parent[0]) && !node.length) {
        if (retainer) retainer[j] = node;
        else this._root = node;
    }
    return this;
}
function $a9e86889947ccfe5$export$1cfc7aad5cb1833b(data) {
    for(var i = 0, n = data.length; i < n; ++i)this.remove(data[i]);
    return this;
}


function $b2b3c48cf1ed3fdd$export$2e2bcd8739ae039() {
    return this._root;
}


function $1ee1c7685a3de474$export$2e2bcd8739ae039() {
    var size = 0;
    this.visit(function(node) {
        if (!node.length) do ++size;
        while (node = node.next);
    });
    return size;
}



function $024d91f59a2525f1$export$2e2bcd8739ae039(callback) {
    var halves = [], q, node = this._root, child, x0, x1;
    if (node) halves.push(new (0, $cf3430a06897f678$export$2e2bcd8739ae039)(node, this._x0, this._x1));
    while(q = halves.pop())if (!callback(node = q.node, x0 = q.x0, x1 = q.x1) && node.length) {
        var xm = (x0 + x1) / 2;
        if (child = node[1]) halves.push(new (0, $cf3430a06897f678$export$2e2bcd8739ae039)(child, xm, x1));
        if (child = node[0]) halves.push(new (0, $cf3430a06897f678$export$2e2bcd8739ae039)(child, x0, xm));
    }
    return this;
}



function $fc24bef6f3700a02$export$2e2bcd8739ae039(callback) {
    var halves = [], next = [], q;
    if (this._root) halves.push(new (0, $cf3430a06897f678$export$2e2bcd8739ae039)(this._root, this._x0, this._x1));
    while(q = halves.pop()){
        var node = q.node;
        if (node.length) {
            var child, x0 = q.x0, x1 = q.x1, xm = (x0 + x1) / 2;
            if (child = node[0]) halves.push(new (0, $cf3430a06897f678$export$2e2bcd8739ae039)(child, x0, xm));
            if (child = node[1]) halves.push(new (0, $cf3430a06897f678$export$2e2bcd8739ae039)(child, xm, x1));
        }
        next.push(q);
    }
    while(q = next.pop())callback(q.node, q.x0, q.x1);
    return this;
}


function $ed33e6a81b3ddf0d$export$e6fafc98131d2a44(d) {
    return d[0];
}
function $ed33e6a81b3ddf0d$export$2e2bcd8739ae039(_) {
    return arguments.length ? (this._x = _, this) : this._x;
}


function $45b61d86bb7347bf$export$2e2bcd8739ae039(nodes, x) {
    var tree = new $45b61d86bb7347bf$var$Binarytree(x == null ? (0, $ed33e6a81b3ddf0d$export$e6fafc98131d2a44) : x, NaN, NaN);
    return nodes == null ? tree : tree.addAll(nodes);
}
function $45b61d86bb7347bf$var$Binarytree(x, x0, x1) {
    this._x = x;
    this._x0 = x0;
    this._x1 = x1;
    this._root = undefined;
}
function $45b61d86bb7347bf$var$leaf_copy(leaf) {
    var copy = {
        data: leaf.data
    }, next = copy;
    while(leaf = leaf.next)next = next.next = {
        data: leaf.data
    };
    return copy;
}
var $45b61d86bb7347bf$var$treeProto = $45b61d86bb7347bf$export$2e2bcd8739ae039.prototype = $45b61d86bb7347bf$var$Binarytree.prototype;
$45b61d86bb7347bf$var$treeProto.copy = function() {
    var copy = new $45b61d86bb7347bf$var$Binarytree(this._x, this._x0, this._x1), node = this._root, nodes, child;
    if (!node) return copy;
    if (!node.length) return copy._root = $45b61d86bb7347bf$var$leaf_copy(node), copy;
    nodes = [
        {
            source: node,
            target: copy._root = new Array(2)
        }
    ];
    while(node = nodes.pop()){
        for(var i = 0; i < 2; ++i)if (child = node.source[i]) {
            if (child.length) nodes.push({
                source: child,
                target: node.target[i] = new Array(2)
            });
            else node.target[i] = $45b61d86bb7347bf$var$leaf_copy(child);
        }
    }
    return copy;
};
$45b61d86bb7347bf$var$treeProto.add = (0, $57250c0faa51357c$export$2e2bcd8739ae039);
$45b61d86bb7347bf$var$treeProto.addAll = (0, $57250c0faa51357c$export$32ed0561867ec8a1);
$45b61d86bb7347bf$var$treeProto.cover = (0, $d14927ef4fd63da1$export$2e2bcd8739ae039);
$45b61d86bb7347bf$var$treeProto.data = (0, $dda78535ceca5ee1$export$2e2bcd8739ae039);
$45b61d86bb7347bf$var$treeProto.extent = (0, $fa07631210a576ec$export$2e2bcd8739ae039);
$45b61d86bb7347bf$var$treeProto.find = (0, $71f8b79478b43ef4$export$2e2bcd8739ae039);
$45b61d86bb7347bf$var$treeProto.remove = (0, $a9e86889947ccfe5$export$2e2bcd8739ae039);
$45b61d86bb7347bf$var$treeProto.removeAll = (0, $a9e86889947ccfe5$export$1cfc7aad5cb1833b);
$45b61d86bb7347bf$var$treeProto.root = (0, $b2b3c48cf1ed3fdd$export$2e2bcd8739ae039);
$45b61d86bb7347bf$var$treeProto.size = (0, $1ee1c7685a3de474$export$2e2bcd8739ae039);
$45b61d86bb7347bf$var$treeProto.visit = (0, $024d91f59a2525f1$export$2e2bcd8739ae039);
$45b61d86bb7347bf$var$treeProto.visitAfter = (0, $fc24bef6f3700a02$export$2e2bcd8739ae039);
$45b61d86bb7347bf$var$treeProto.x = (0, $ed33e6a81b3ddf0d$export$2e2bcd8739ae039);


function $be1b12895c7da8cf$export$2e2bcd8739ae039(d) {
    const x = +this._x.call(null, d), y = +this._y.call(null, d);
    return $be1b12895c7da8cf$var$add(this.cover(x, y), x, y, d);
}
function $be1b12895c7da8cf$var$add(tree, x, y, d) {
    if (isNaN(x) || isNaN(y)) return tree; // ignore invalid points
    var parent, node = tree._root, leaf = {
        data: d
    }, x0 = tree._x0, y0 = tree._y0, x1 = tree._x1, y1 = tree._y1, xm, ym, xp, yp, right, bottom, i, j;
    // If the tree is empty, initialize the root as a leaf.
    if (!node) return tree._root = leaf, tree;
    // Find the existing leaf for the new point, or add it.
    while(node.length){
        if (right = x >= (xm = (x0 + x1) / 2)) x0 = xm;
        else x1 = xm;
        if (bottom = y >= (ym = (y0 + y1) / 2)) y0 = ym;
        else y1 = ym;
        if (parent = node, !(node = node[i = bottom << 1 | right])) return parent[i] = leaf, tree;
    }
    // Is the new point is exactly coincident with the existing point?
    xp = +tree._x.call(null, node.data);
    yp = +tree._y.call(null, node.data);
    if (x === xp && y === yp) return leaf.next = node, parent ? parent[i] = leaf : tree._root = leaf, tree;
    // Otherwise, split the leaf node until the old and new point are separated.
    do {
        parent = parent ? parent[i] = new Array(4) : tree._root = new Array(4);
        if (right = x >= (xm = (x0 + x1) / 2)) x0 = xm;
        else x1 = xm;
        if (bottom = y >= (ym = (y0 + y1) / 2)) y0 = ym;
        else y1 = ym;
    }while ((i = bottom << 1 | right) === (j = (yp >= ym) << 1 | xp >= xm));
    return parent[j] = node, parent[i] = leaf, tree;
}
function $be1b12895c7da8cf$export$32ed0561867ec8a1(data) {
    var d, i, n = data.length, x, y, xz = new Array(n), yz = new Array(n), x0 = Infinity, y0 = Infinity, x1 = -Infinity, y1 = -Infinity;
    // Compute the points and their extent.
    for(i = 0; i < n; ++i){
        if (isNaN(x = +this._x.call(null, d = data[i])) || isNaN(y = +this._y.call(null, d))) continue;
        xz[i] = x;
        yz[i] = y;
        if (x < x0) x0 = x;
        if (x > x1) x1 = x;
        if (y < y0) y0 = y;
        if (y > y1) y1 = y;
    }
    // If there were no (valid) points, abort.
    if (x0 > x1 || y0 > y1) return this;
    // Expand the tree to cover the new points.
    this.cover(x0, y0).cover(x1, y1);
    // Add the new points.
    for(i = 0; i < n; ++i)$be1b12895c7da8cf$var$add(this, xz[i], yz[i], data[i]);
    return this;
}


function $6063f984171c8523$export$2e2bcd8739ae039(x, y) {
    if (isNaN(x = +x) || isNaN(y = +y)) return this; // ignore invalid points
    var x0 = this._x0, y0 = this._y0, x1 = this._x1, y1 = this._y1;
    // If the quadtree has no extent, initialize them.
    // Integer extent are necessary so that if we later double the extent,
    // the existing quadrant boundaries don’t change due to floating point error!
    if (isNaN(x0)) {
        x1 = (x0 = Math.floor(x)) + 1;
        y1 = (y0 = Math.floor(y)) + 1;
    } else {
        var z = x1 - x0 || 1, node = this._root, parent, i;
        while(x0 > x || x >= x1 || y0 > y || y >= y1){
            i = (y < y0) << 1 | x < x0;
            parent = new Array(4), parent[i] = node, node = parent, z *= 2;
            switch(i){
                case 0:
                    x1 = x0 + z, y1 = y0 + z;
                    break;
                case 1:
                    x0 = x1 - z, y1 = y0 + z;
                    break;
                case 2:
                    x1 = x0 + z, y0 = y1 - z;
                    break;
                case 3:
                    x0 = x1 - z, y0 = y1 - z;
                    break;
            }
        }
        if (this._root && this._root.length) this._root = node;
    }
    this._x0 = x0;
    this._y0 = y0;
    this._x1 = x1;
    this._y1 = y1;
    return this;
}


function $cfd8a0ee53f875c5$export$2e2bcd8739ae039() {
    var data = [];
    this.visit(function(node) {
        if (!node.length) do data.push(node.data);
        while (node = node.next);
    });
    return data;
}


function $feddd81cb3a1a5cd$export$2e2bcd8739ae039(_) {
    return arguments.length ? this.cover(+_[0][0], +_[0][1]).cover(+_[1][0], +_[1][1]) : isNaN(this._x0) ? undefined : [
        [
            this._x0,
            this._y0
        ],
        [
            this._x1,
            this._y1
        ]
    ];
}


function $75f49fd5af8d23e7$export$2e2bcd8739ae039(node, x0, y0, x1, y1) {
    this.node = node;
    this.x0 = x0;
    this.y0 = y0;
    this.x1 = x1;
    this.y1 = y1;
}


function $b7a6a4e6ea4402cb$export$2e2bcd8739ae039(x, y, radius) {
    var data, x0 = this._x0, y0 = this._y0, x1, y1, x2, y2, x3 = this._x1, y3 = this._y1, quads = [], node = this._root, q, i;
    if (node) quads.push(new (0, $75f49fd5af8d23e7$export$2e2bcd8739ae039)(node, x0, y0, x3, y3));
    if (radius == null) radius = Infinity;
    else {
        x0 = x - radius, y0 = y - radius;
        x3 = x + radius, y3 = y + radius;
        radius *= radius;
    }
    while(q = quads.pop()){
        // Stop searching if this quadrant can’t contain a closer node.
        if (!(node = q.node) || (x1 = q.x0) > x3 || (y1 = q.y0) > y3 || (x2 = q.x1) < x0 || (y2 = q.y1) < y0) continue;
        // Bisect the current quadrant.
        if (node.length) {
            var xm = (x1 + x2) / 2, ym = (y1 + y2) / 2;
            quads.push(new (0, $75f49fd5af8d23e7$export$2e2bcd8739ae039)(node[3], xm, ym, x2, y2), new (0, $75f49fd5af8d23e7$export$2e2bcd8739ae039)(node[2], x1, ym, xm, y2), new (0, $75f49fd5af8d23e7$export$2e2bcd8739ae039)(node[1], xm, y1, x2, ym), new (0, $75f49fd5af8d23e7$export$2e2bcd8739ae039)(node[0], x1, y1, xm, ym));
            // Visit the closest quadrant first.
            if (i = (y >= ym) << 1 | x >= xm) {
                q = quads[quads.length - 1];
                quads[quads.length - 1] = quads[quads.length - 1 - i];
                quads[quads.length - 1 - i] = q;
            }
        } else {
            var dx = x - +this._x.call(null, node.data), dy = y - +this._y.call(null, node.data), d2 = dx * dx + dy * dy;
            if (d2 < radius) {
                var d = Math.sqrt(radius = d2);
                x0 = x - d, y0 = y - d;
                x3 = x + d, y3 = y + d;
                data = node.data;
            }
        }
    }
    return data;
}


function $9ea7286cd6ff459a$export$2e2bcd8739ae039(d) {
    if (isNaN(x = +this._x.call(null, d)) || isNaN(y = +this._y.call(null, d))) return this; // ignore invalid points
    var parent, node = this._root, retainer, previous, next, x0 = this._x0, y0 = this._y0, x1 = this._x1, y1 = this._y1, x, y, xm, ym, right, bottom, i, j;
    // If the tree is empty, initialize the root as a leaf.
    if (!node) return this;
    // Find the leaf node for the point.
    // While descending, also retain the deepest parent with a non-removed sibling.
    if (node.length) while(true){
        if (right = x >= (xm = (x0 + x1) / 2)) x0 = xm;
        else x1 = xm;
        if (bottom = y >= (ym = (y0 + y1) / 2)) y0 = ym;
        else y1 = ym;
        if (!(parent = node, node = node[i = bottom << 1 | right])) return this;
        if (!node.length) break;
        if (parent[i + 1 & 3] || parent[i + 2 & 3] || parent[i + 3 & 3]) retainer = parent, j = i;
    }
    // Find the point to remove.
    while(node.data !== d)if (!(previous = node, node = node.next)) return this;
    if (next = node.next) delete node.next;
    // If there are multiple coincident points, remove just the point.
    if (previous) return next ? previous.next = next : delete previous.next, this;
    // If this is the root point, remove it.
    if (!parent) return this._root = next, this;
    // Remove this leaf.
    next ? parent[i] = next : delete parent[i];
    // If the parent now contains exactly one leaf, collapse superfluous parents.
    if ((node = parent[0] || parent[1] || parent[2] || parent[3]) && node === (parent[3] || parent[2] || parent[1] || parent[0]) && !node.length) {
        if (retainer) retainer[j] = node;
        else this._root = node;
    }
    return this;
}
function $9ea7286cd6ff459a$export$1cfc7aad5cb1833b(data) {
    for(var i = 0, n = data.length; i < n; ++i)this.remove(data[i]);
    return this;
}


function $0d9e2b498bba95b5$export$2e2bcd8739ae039() {
    return this._root;
}


function $f92329c600392ac7$export$2e2bcd8739ae039() {
    var size = 0;
    this.visit(function(node) {
        if (!node.length) do ++size;
        while (node = node.next);
    });
    return size;
}



function $15a5c85e382805ba$export$2e2bcd8739ae039(callback) {
    var quads = [], q, node = this._root, child, x0, y0, x1, y1;
    if (node) quads.push(new (0, $75f49fd5af8d23e7$export$2e2bcd8739ae039)(node, this._x0, this._y0, this._x1, this._y1));
    while(q = quads.pop())if (!callback(node = q.node, x0 = q.x0, y0 = q.y0, x1 = q.x1, y1 = q.y1) && node.length) {
        var xm = (x0 + x1) / 2, ym = (y0 + y1) / 2;
        if (child = node[3]) quads.push(new (0, $75f49fd5af8d23e7$export$2e2bcd8739ae039)(child, xm, ym, x1, y1));
        if (child = node[2]) quads.push(new (0, $75f49fd5af8d23e7$export$2e2bcd8739ae039)(child, x0, ym, xm, y1));
        if (child = node[1]) quads.push(new (0, $75f49fd5af8d23e7$export$2e2bcd8739ae039)(child, xm, y0, x1, ym));
        if (child = node[0]) quads.push(new (0, $75f49fd5af8d23e7$export$2e2bcd8739ae039)(child, x0, y0, xm, ym));
    }
    return this;
}



function $9a4dcb6a46603c0e$export$2e2bcd8739ae039(callback) {
    var quads = [], next = [], q;
    if (this._root) quads.push(new (0, $75f49fd5af8d23e7$export$2e2bcd8739ae039)(this._root, this._x0, this._y0, this._x1, this._y1));
    while(q = quads.pop()){
        var node = q.node;
        if (node.length) {
            var child, x0 = q.x0, y0 = q.y0, x1 = q.x1, y1 = q.y1, xm = (x0 + x1) / 2, ym = (y0 + y1) / 2;
            if (child = node[0]) quads.push(new (0, $75f49fd5af8d23e7$export$2e2bcd8739ae039)(child, x0, y0, xm, ym));
            if (child = node[1]) quads.push(new (0, $75f49fd5af8d23e7$export$2e2bcd8739ae039)(child, xm, y0, x1, ym));
            if (child = node[2]) quads.push(new (0, $75f49fd5af8d23e7$export$2e2bcd8739ae039)(child, x0, ym, xm, y1));
            if (child = node[3]) quads.push(new (0, $75f49fd5af8d23e7$export$2e2bcd8739ae039)(child, xm, ym, x1, y1));
        }
        next.push(q);
    }
    while(q = next.pop())callback(q.node, q.x0, q.y0, q.x1, q.y1);
    return this;
}


function $e002de94352e4f40$export$e6fafc98131d2a44(d) {
    return d[0];
}
function $e002de94352e4f40$export$2e2bcd8739ae039(_) {
    return arguments.length ? (this._x = _, this) : this._x;
}


function $6a00482922687876$export$6f0a21aeb844a64c(d) {
    return d[1];
}
function $6a00482922687876$export$2e2bcd8739ae039(_) {
    return arguments.length ? (this._y = _, this) : this._y;
}


function $977cc0295d3f184c$export$2e2bcd8739ae039(nodes, x, y) {
    var tree = new $977cc0295d3f184c$var$Quadtree(x == null ? (0, $e002de94352e4f40$export$e6fafc98131d2a44) : x, y == null ? (0, $6a00482922687876$export$6f0a21aeb844a64c) : y, NaN, NaN, NaN, NaN);
    return nodes == null ? tree : tree.addAll(nodes);
}
function $977cc0295d3f184c$var$Quadtree(x, y, x0, y0, x1, y1) {
    this._x = x;
    this._y = y;
    this._x0 = x0;
    this._y0 = y0;
    this._x1 = x1;
    this._y1 = y1;
    this._root = undefined;
}
function $977cc0295d3f184c$var$leaf_copy(leaf) {
    var copy = {
        data: leaf.data
    }, next = copy;
    while(leaf = leaf.next)next = next.next = {
        data: leaf.data
    };
    return copy;
}
var $977cc0295d3f184c$var$treeProto = $977cc0295d3f184c$export$2e2bcd8739ae039.prototype = $977cc0295d3f184c$var$Quadtree.prototype;
$977cc0295d3f184c$var$treeProto.copy = function() {
    var copy = new $977cc0295d3f184c$var$Quadtree(this._x, this._y, this._x0, this._y0, this._x1, this._y1), node = this._root, nodes, child;
    if (!node) return copy;
    if (!node.length) return copy._root = $977cc0295d3f184c$var$leaf_copy(node), copy;
    nodes = [
        {
            source: node,
            target: copy._root = new Array(4)
        }
    ];
    while(node = nodes.pop()){
        for(var i = 0; i < 4; ++i)if (child = node.source[i]) {
            if (child.length) nodes.push({
                source: child,
                target: node.target[i] = new Array(4)
            });
            else node.target[i] = $977cc0295d3f184c$var$leaf_copy(child);
        }
    }
    return copy;
};
$977cc0295d3f184c$var$treeProto.add = (0, $be1b12895c7da8cf$export$2e2bcd8739ae039);
$977cc0295d3f184c$var$treeProto.addAll = (0, $be1b12895c7da8cf$export$32ed0561867ec8a1);
$977cc0295d3f184c$var$treeProto.cover = (0, $6063f984171c8523$export$2e2bcd8739ae039);
$977cc0295d3f184c$var$treeProto.data = (0, $cfd8a0ee53f875c5$export$2e2bcd8739ae039);
$977cc0295d3f184c$var$treeProto.extent = (0, $feddd81cb3a1a5cd$export$2e2bcd8739ae039);
$977cc0295d3f184c$var$treeProto.find = (0, $b7a6a4e6ea4402cb$export$2e2bcd8739ae039);
$977cc0295d3f184c$var$treeProto.remove = (0, $9ea7286cd6ff459a$export$2e2bcd8739ae039);
$977cc0295d3f184c$var$treeProto.removeAll = (0, $9ea7286cd6ff459a$export$1cfc7aad5cb1833b);
$977cc0295d3f184c$var$treeProto.root = (0, $0d9e2b498bba95b5$export$2e2bcd8739ae039);
$977cc0295d3f184c$var$treeProto.size = (0, $f92329c600392ac7$export$2e2bcd8739ae039);
$977cc0295d3f184c$var$treeProto.visit = (0, $15a5c85e382805ba$export$2e2bcd8739ae039);
$977cc0295d3f184c$var$treeProto.visitAfter = (0, $9a4dcb6a46603c0e$export$2e2bcd8739ae039);
$977cc0295d3f184c$var$treeProto.x = (0, $e002de94352e4f40$export$2e2bcd8739ae039);
$977cc0295d3f184c$var$treeProto.y = (0, $6a00482922687876$export$2e2bcd8739ae039);


function $d21522a7a85a91c2$export$2e2bcd8739ae039(d) {
    const x = +this._x.call(null, d), y = +this._y.call(null, d), z = +this._z.call(null, d);
    return $d21522a7a85a91c2$var$add(this.cover(x, y, z), x, y, z, d);
}
function $d21522a7a85a91c2$var$add(tree, x, y, z, d) {
    if (isNaN(x) || isNaN(y) || isNaN(z)) return tree; // ignore invalid points
    var parent, node = tree._root, leaf = {
        data: d
    }, x0 = tree._x0, y0 = tree._y0, z0 = tree._z0, x1 = tree._x1, y1 = tree._y1, z1 = tree._z1, xm, ym, zm, xp, yp, zp, right, bottom, deep, i, j;
    // If the tree is empty, initialize the root as a leaf.
    if (!node) return tree._root = leaf, tree;
    // Find the existing leaf for the new point, or add it.
    while(node.length){
        if (right = x >= (xm = (x0 + x1) / 2)) x0 = xm;
        else x1 = xm;
        if (bottom = y >= (ym = (y0 + y1) / 2)) y0 = ym;
        else y1 = ym;
        if (deep = z >= (zm = (z0 + z1) / 2)) z0 = zm;
        else z1 = zm;
        if (parent = node, !(node = node[i = deep << 2 | bottom << 1 | right])) return parent[i] = leaf, tree;
    }
    // Is the new point is exactly coincident with the existing point?
    xp = +tree._x.call(null, node.data);
    yp = +tree._y.call(null, node.data);
    zp = +tree._z.call(null, node.data);
    if (x === xp && y === yp && z === zp) return leaf.next = node, parent ? parent[i] = leaf : tree._root = leaf, tree;
    // Otherwise, split the leaf node until the old and new point are separated.
    do {
        parent = parent ? parent[i] = new Array(8) : tree._root = new Array(8);
        if (right = x >= (xm = (x0 + x1) / 2)) x0 = xm;
        else x1 = xm;
        if (bottom = y >= (ym = (y0 + y1) / 2)) y0 = ym;
        else y1 = ym;
        if (deep = z >= (zm = (z0 + z1) / 2)) z0 = zm;
        else z1 = zm;
    }while ((i = deep << 2 | bottom << 1 | right) === (j = (zp >= zm) << 2 | (yp >= ym) << 1 | xp >= xm));
    return parent[j] = node, parent[i] = leaf, tree;
}
function $d21522a7a85a91c2$export$32ed0561867ec8a1(data) {
    if (!Array.isArray(data)) data = Array.from(data);
    const n = data.length;
    const xz = new Float64Array(n);
    const yz = new Float64Array(n);
    const zz = new Float64Array(n);
    let x0 = Infinity, y0 = Infinity, z0 = Infinity, x1 = -Infinity, y1 = -Infinity, z1 = -Infinity;
    // Compute the points and their extent.
    for(let i = 0, d, x, y, z; i < n; ++i){
        if (isNaN(x = +this._x.call(null, d = data[i])) || isNaN(y = +this._y.call(null, d)) || isNaN(z = +this._z.call(null, d))) continue;
        xz[i] = x;
        yz[i] = y;
        zz[i] = z;
        if (x < x0) x0 = x;
        if (x > x1) x1 = x;
        if (y < y0) y0 = y;
        if (y > y1) y1 = y;
        if (z < z0) z0 = z;
        if (z > z1) z1 = z;
    }
    // If there were no (valid) points, abort.
    if (x0 > x1 || y0 > y1 || z0 > z1) return this;
    // Expand the tree to cover the new points.
    this.cover(x0, y0, z0).cover(x1, y1, z1);
    // Add the new points.
    for(let i = 0; i < n; ++i)$d21522a7a85a91c2$var$add(this, xz[i], yz[i], zz[i], data[i]);
    return this;
}


function $e1a8a07399b9cf06$export$2e2bcd8739ae039(x, y, z) {
    if (isNaN(x = +x) || isNaN(y = +y) || isNaN(z = +z)) return this; // ignore invalid points
    var x0 = this._x0, y0 = this._y0, z0 = this._z0, x1 = this._x1, y1 = this._y1, z1 = this._z1;
    // If the octree has no extent, initialize them.
    // Integer extent are necessary so that if we later double the extent,
    // the existing octant boundaries don’t change due to floating point error!
    if (isNaN(x0)) {
        x1 = (x0 = Math.floor(x)) + 1;
        y1 = (y0 = Math.floor(y)) + 1;
        z1 = (z0 = Math.floor(z)) + 1;
    } else {
        var t = x1 - x0 || 1, node = this._root, parent, i;
        while(x0 > x || x >= x1 || y0 > y || y >= y1 || z0 > z || z >= z1){
            i = (z < z0) << 2 | (y < y0) << 1 | x < x0;
            parent = new Array(8), parent[i] = node, node = parent, t *= 2;
            switch(i){
                case 0:
                    x1 = x0 + t, y1 = y0 + t, z1 = z0 + t;
                    break;
                case 1:
                    x0 = x1 - t, y1 = y0 + t, z1 = z0 + t;
                    break;
                case 2:
                    x1 = x0 + t, y0 = y1 - t, z1 = z0 + t;
                    break;
                case 3:
                    x0 = x1 - t, y0 = y1 - t, z1 = z0 + t;
                    break;
                case 4:
                    x1 = x0 + t, y1 = y0 + t, z0 = z1 - t;
                    break;
                case 5:
                    x0 = x1 - t, y1 = y0 + t, z0 = z1 - t;
                    break;
                case 6:
                    x1 = x0 + t, y0 = y1 - t, z0 = z1 - t;
                    break;
                case 7:
                    x0 = x1 - t, y0 = y1 - t, z0 = z1 - t;
                    break;
            }
        }
        if (this._root && this._root.length) this._root = node;
    }
    this._x0 = x0;
    this._y0 = y0;
    this._z0 = z0;
    this._x1 = x1;
    this._y1 = y1;
    this._z1 = z1;
    return this;
}


function $b0faad390127ba70$export$2e2bcd8739ae039() {
    var data = [];
    this.visit(function(node) {
        if (!node.length) do data.push(node.data);
        while (node = node.next);
    });
    return data;
}


function $d98eb8f22d167a52$export$2e2bcd8739ae039(_) {
    return arguments.length ? this.cover(+_[0][0], +_[0][1], +_[0][2]).cover(+_[1][0], +_[1][1], +_[1][2]) : isNaN(this._x0) ? undefined : [
        [
            this._x0,
            this._y0,
            this._z0
        ],
        [
            this._x1,
            this._y1,
            this._z1
        ]
    ];
}


function $812250d8480ea962$export$2e2bcd8739ae039(node, x0, y0, z0, x1, y1, z1) {
    this.node = node;
    this.x0 = x0;
    this.y0 = y0;
    this.z0 = z0;
    this.x1 = x1;
    this.y1 = y1;
    this.z1 = z1;
}


function $9a9011ab754ae1ca$export$2e2bcd8739ae039(x, y, z, radius) {
    var data, x0 = this._x0, y0 = this._y0, z0 = this._z0, x1, y1, z1, x2, y2, z2, x3 = this._x1, y3 = this._y1, z3 = this._z1, octs = [], node = this._root, q, i;
    if (node) octs.push(new (0, $812250d8480ea962$export$2e2bcd8739ae039)(node, x0, y0, z0, x3, y3, z3));
    if (radius == null) radius = Infinity;
    else {
        x0 = x - radius, y0 = y - radius, z0 = z - radius;
        x3 = x + radius, y3 = y + radius, z3 = z + radius;
        radius *= radius;
    }
    while(q = octs.pop()){
        // Stop searching if this octant can’t contain a closer node.
        if (!(node = q.node) || (x1 = q.x0) > x3 || (y1 = q.y0) > y3 || (z1 = q.z0) > z3 || (x2 = q.x1) < x0 || (y2 = q.y1) < y0 || (z2 = q.z1) < z0) continue;
        // Bisect the current octant.
        if (node.length) {
            var xm = (x1 + x2) / 2, ym = (y1 + y2) / 2, zm = (z1 + z2) / 2;
            octs.push(new (0, $812250d8480ea962$export$2e2bcd8739ae039)(node[7], xm, ym, zm, x2, y2, z2), new (0, $812250d8480ea962$export$2e2bcd8739ae039)(node[6], x1, ym, zm, xm, y2, z2), new (0, $812250d8480ea962$export$2e2bcd8739ae039)(node[5], xm, y1, zm, x2, ym, z2), new (0, $812250d8480ea962$export$2e2bcd8739ae039)(node[4], x1, y1, zm, xm, ym, z2), new (0, $812250d8480ea962$export$2e2bcd8739ae039)(node[3], xm, ym, z1, x2, y2, zm), new (0, $812250d8480ea962$export$2e2bcd8739ae039)(node[2], x1, ym, z1, xm, y2, zm), new (0, $812250d8480ea962$export$2e2bcd8739ae039)(node[1], xm, y1, z1, x2, ym, zm), new (0, $812250d8480ea962$export$2e2bcd8739ae039)(node[0], x1, y1, z1, xm, ym, zm));
            // Visit the closest octant first.
            if (i = (z >= zm) << 2 | (y >= ym) << 1 | x >= xm) {
                q = octs[octs.length - 1];
                octs[octs.length - 1] = octs[octs.length - 1 - i];
                octs[octs.length - 1 - i] = q;
            }
        } else {
            var dx = x - +this._x.call(null, node.data), dy = y - +this._y.call(null, node.data), dz = z - +this._z.call(null, node.data), d2 = dx * dx + dy * dy + dz * dz;
            if (d2 < radius) {
                var d = Math.sqrt(radius = d2);
                x0 = x - d, y0 = y - d, z0 = z - d;
                x3 = x + d, y3 = y + d, z3 = z + d;
                data = node.data;
            }
        }
    }
    return data;
}


function $d677fcf60e454087$export$2e2bcd8739ae039(d) {
    if (isNaN(x = +this._x.call(null, d)) || isNaN(y = +this._y.call(null, d)) || isNaN(z = +this._z.call(null, d))) return this; // ignore invalid points
    var parent, node = this._root, retainer, previous, next, x0 = this._x0, y0 = this._y0, z0 = this._z0, x1 = this._x1, y1 = this._y1, z1 = this._z1, x, y, z, xm, ym, zm, right, bottom, deep, i, j;
    // If the tree is empty, initialize the root as a leaf.
    if (!node) return this;
    // Find the leaf node for the point.
    // While descending, also retain the deepest parent with a non-removed sibling.
    if (node.length) while(true){
        if (right = x >= (xm = (x0 + x1) / 2)) x0 = xm;
        else x1 = xm;
        if (bottom = y >= (ym = (y0 + y1) / 2)) y0 = ym;
        else y1 = ym;
        if (deep = z >= (zm = (z0 + z1) / 2)) z0 = zm;
        else z1 = zm;
        if (!(parent = node, node = node[i = deep << 2 | bottom << 1 | right])) return this;
        if (!node.length) break;
        if (parent[i + 1 & 7] || parent[i + 2 & 7] || parent[i + 3 & 7] || parent[i + 4 & 7] || parent[i + 5 & 7] || parent[i + 6 & 7] || parent[i + 7 & 7]) retainer = parent, j = i;
    }
    // Find the point to remove.
    while(node.data !== d)if (!(previous = node, node = node.next)) return this;
    if (next = node.next) delete node.next;
    // If there are multiple coincident points, remove just the point.
    if (previous) return next ? previous.next = next : delete previous.next, this;
    // If this is the root point, remove it.
    if (!parent) return this._root = next, this;
    // Remove this leaf.
    next ? parent[i] = next : delete parent[i];
    // If the parent now contains exactly one leaf, collapse superfluous parents.
    if ((node = parent[0] || parent[1] || parent[2] || parent[3] || parent[4] || parent[5] || parent[6] || parent[7]) && node === (parent[7] || parent[6] || parent[5] || parent[4] || parent[3] || parent[2] || parent[1] || parent[0]) && !node.length) {
        if (retainer) retainer[j] = node;
        else this._root = node;
    }
    return this;
}
function $d677fcf60e454087$export$1cfc7aad5cb1833b(data) {
    for(var i = 0, n = data.length; i < n; ++i)this.remove(data[i]);
    return this;
}


function $4174bfc6ca39974a$export$2e2bcd8739ae039() {
    return this._root;
}


function $b4a20dcf80e902c5$export$2e2bcd8739ae039() {
    var size = 0;
    this.visit(function(node) {
        if (!node.length) do ++size;
        while (node = node.next);
    });
    return size;
}



function $b4996a8350fe675e$export$2e2bcd8739ae039(callback) {
    var octs = [], q, node = this._root, child, x0, y0, z0, x1, y1, z1;
    if (node) octs.push(new (0, $812250d8480ea962$export$2e2bcd8739ae039)(node, this._x0, this._y0, this._z0, this._x1, this._y1, this._z1));
    while(q = octs.pop())if (!callback(node = q.node, x0 = q.x0, y0 = q.y0, z0 = q.z0, x1 = q.x1, y1 = q.y1, z1 = q.z1) && node.length) {
        var xm = (x0 + x1) / 2, ym = (y0 + y1) / 2, zm = (z0 + z1) / 2;
        if (child = node[7]) octs.push(new (0, $812250d8480ea962$export$2e2bcd8739ae039)(child, xm, ym, zm, x1, y1, z1));
        if (child = node[6]) octs.push(new (0, $812250d8480ea962$export$2e2bcd8739ae039)(child, x0, ym, zm, xm, y1, z1));
        if (child = node[5]) octs.push(new (0, $812250d8480ea962$export$2e2bcd8739ae039)(child, xm, y0, zm, x1, ym, z1));
        if (child = node[4]) octs.push(new (0, $812250d8480ea962$export$2e2bcd8739ae039)(child, x0, y0, zm, xm, ym, z1));
        if (child = node[3]) octs.push(new (0, $812250d8480ea962$export$2e2bcd8739ae039)(child, xm, ym, z0, x1, y1, zm));
        if (child = node[2]) octs.push(new (0, $812250d8480ea962$export$2e2bcd8739ae039)(child, x0, ym, z0, xm, y1, zm));
        if (child = node[1]) octs.push(new (0, $812250d8480ea962$export$2e2bcd8739ae039)(child, xm, y0, z0, x1, ym, zm));
        if (child = node[0]) octs.push(new (0, $812250d8480ea962$export$2e2bcd8739ae039)(child, x0, y0, z0, xm, ym, zm));
    }
    return this;
}



function $3b341ea4c5e83f50$export$2e2bcd8739ae039(callback) {
    var octs = [], next = [], q;
    if (this._root) octs.push(new (0, $812250d8480ea962$export$2e2bcd8739ae039)(this._root, this._x0, this._y0, this._z0, this._x1, this._y1, this._z1));
    while(q = octs.pop()){
        var node = q.node;
        if (node.length) {
            var child, x0 = q.x0, y0 = q.y0, z0 = q.z0, x1 = q.x1, y1 = q.y1, z1 = q.z1, xm = (x0 + x1) / 2, ym = (y0 + y1) / 2, zm = (z0 + z1) / 2;
            if (child = node[0]) octs.push(new (0, $812250d8480ea962$export$2e2bcd8739ae039)(child, x0, y0, z0, xm, ym, zm));
            if (child = node[1]) octs.push(new (0, $812250d8480ea962$export$2e2bcd8739ae039)(child, xm, y0, z0, x1, ym, zm));
            if (child = node[2]) octs.push(new (0, $812250d8480ea962$export$2e2bcd8739ae039)(child, x0, ym, z0, xm, y1, zm));
            if (child = node[3]) octs.push(new (0, $812250d8480ea962$export$2e2bcd8739ae039)(child, xm, ym, z0, x1, y1, zm));
            if (child = node[4]) octs.push(new (0, $812250d8480ea962$export$2e2bcd8739ae039)(child, x0, y0, zm, xm, ym, z1));
            if (child = node[5]) octs.push(new (0, $812250d8480ea962$export$2e2bcd8739ae039)(child, xm, y0, zm, x1, ym, z1));
            if (child = node[6]) octs.push(new (0, $812250d8480ea962$export$2e2bcd8739ae039)(child, x0, ym, zm, xm, y1, z1));
            if (child = node[7]) octs.push(new (0, $812250d8480ea962$export$2e2bcd8739ae039)(child, xm, ym, zm, x1, y1, z1));
        }
        next.push(q);
    }
    while(q = next.pop())callback(q.node, q.x0, q.y0, q.z0, q.x1, q.y1, q.z1);
    return this;
}


function $3d754a90c7056106$export$e6fafc98131d2a44(d) {
    return d[0];
}
function $3d754a90c7056106$export$2e2bcd8739ae039(_) {
    return arguments.length ? (this._x = _, this) : this._x;
}


function $a41f3a890178338c$export$6f0a21aeb844a64c(d) {
    return d[1];
}
function $a41f3a890178338c$export$2e2bcd8739ae039(_) {
    return arguments.length ? (this._y = _, this) : this._y;
}


function $73e0140023f54adb$export$f56e419c070182d8(d) {
    return d[2];
}
function $73e0140023f54adb$export$2e2bcd8739ae039(_) {
    return arguments.length ? (this._z = _, this) : this._z;
}


function $c0920825b99e823f$export$2e2bcd8739ae039(nodes, x, y, z) {
    var tree = new $c0920825b99e823f$var$Octree(x == null ? (0, $3d754a90c7056106$export$e6fafc98131d2a44) : x, y == null ? (0, $a41f3a890178338c$export$6f0a21aeb844a64c) : y, z == null ? (0, $73e0140023f54adb$export$f56e419c070182d8) : z, NaN, NaN, NaN, NaN, NaN, NaN);
    return nodes == null ? tree : tree.addAll(nodes);
}
function $c0920825b99e823f$var$Octree(x, y, z, x0, y0, z0, x1, y1, z1) {
    this._x = x;
    this._y = y;
    this._z = z;
    this._x0 = x0;
    this._y0 = y0;
    this._z0 = z0;
    this._x1 = x1;
    this._y1 = y1;
    this._z1 = z1;
    this._root = undefined;
}
function $c0920825b99e823f$var$leaf_copy(leaf) {
    var copy = {
        data: leaf.data
    }, next = copy;
    while(leaf = leaf.next)next = next.next = {
        data: leaf.data
    };
    return copy;
}
var $c0920825b99e823f$var$treeProto = $c0920825b99e823f$export$2e2bcd8739ae039.prototype = $c0920825b99e823f$var$Octree.prototype;
$c0920825b99e823f$var$treeProto.copy = function() {
    var copy = new $c0920825b99e823f$var$Octree(this._x, this._y, this._z, this._x0, this._y0, this._z0, this._x1, this._y1, this._z1), node = this._root, nodes, child;
    if (!node) return copy;
    if (!node.length) return copy._root = $c0920825b99e823f$var$leaf_copy(node), copy;
    nodes = [
        {
            source: node,
            target: copy._root = new Array(8)
        }
    ];
    while(node = nodes.pop()){
        for(var i = 0; i < 8; ++i)if (child = node.source[i]) {
            if (child.length) nodes.push({
                source: child,
                target: node.target[i] = new Array(8)
            });
            else node.target[i] = $c0920825b99e823f$var$leaf_copy(child);
        }
    }
    return copy;
};
$c0920825b99e823f$var$treeProto.add = (0, $d21522a7a85a91c2$export$2e2bcd8739ae039);
$c0920825b99e823f$var$treeProto.addAll = (0, $d21522a7a85a91c2$export$32ed0561867ec8a1);
$c0920825b99e823f$var$treeProto.cover = (0, $e1a8a07399b9cf06$export$2e2bcd8739ae039);
$c0920825b99e823f$var$treeProto.data = (0, $b0faad390127ba70$export$2e2bcd8739ae039);
$c0920825b99e823f$var$treeProto.extent = (0, $d98eb8f22d167a52$export$2e2bcd8739ae039);
$c0920825b99e823f$var$treeProto.find = (0, $9a9011ab754ae1ca$export$2e2bcd8739ae039);
$c0920825b99e823f$var$treeProto.remove = (0, $d677fcf60e454087$export$2e2bcd8739ae039);
$c0920825b99e823f$var$treeProto.removeAll = (0, $d677fcf60e454087$export$1cfc7aad5cb1833b);
$c0920825b99e823f$var$treeProto.root = (0, $4174bfc6ca39974a$export$2e2bcd8739ae039);
$c0920825b99e823f$var$treeProto.size = (0, $b4a20dcf80e902c5$export$2e2bcd8739ae039);
$c0920825b99e823f$var$treeProto.visit = (0, $b4996a8350fe675e$export$2e2bcd8739ae039);
$c0920825b99e823f$var$treeProto.visitAfter = (0, $3b341ea4c5e83f50$export$2e2bcd8739ae039);
$c0920825b99e823f$var$treeProto.x = (0, $3d754a90c7056106$export$2e2bcd8739ae039);
$c0920825b99e823f$var$treeProto.y = (0, $a41f3a890178338c$export$2e2bcd8739ae039);
$c0920825b99e823f$var$treeProto.z = (0, $73e0140023f54adb$export$2e2bcd8739ae039);




var $7c4cf709d1826294$var$noop = {
    value: ()=>{}
};
function $7c4cf709d1826294$var$dispatch() {
    for(var i = 0, n = arguments.length, _ = {}, t; i < n; ++i){
        if (!(t = arguments[i] + "") || t in _ || /[\s.]/.test(t)) throw new Error("illegal type: " + t);
        _[t] = [];
    }
    return new $7c4cf709d1826294$var$Dispatch(_);
}
function $7c4cf709d1826294$var$Dispatch(_) {
    this._ = _;
}
function $7c4cf709d1826294$var$parseTypenames(typenames, types) {
    return typenames.trim().split(/^|\s+/).map(function(t) {
        var name = "", i = t.indexOf(".");
        if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
        if (t && !types.hasOwnProperty(t)) throw new Error("unknown type: " + t);
        return {
            type: t,
            name: name
        };
    });
}
$7c4cf709d1826294$var$Dispatch.prototype = $7c4cf709d1826294$var$dispatch.prototype = {
    constructor: $7c4cf709d1826294$var$Dispatch,
    on: function(typename, callback) {
        var _ = this._, T = $7c4cf709d1826294$var$parseTypenames(typename + "", _), t, i = -1, n = T.length;
        // If no callback was specified, return the callback of the given type and name.
        if (arguments.length < 2) {
            while(++i < n)if ((t = (typename = T[i]).type) && (t = $7c4cf709d1826294$var$get(_[t], typename.name))) return t;
            return;
        }
        // If a type was specified, set the callback for the given type and name.
        // Otherwise, if a null callback was specified, remove callbacks of the given name.
        if (callback != null && typeof callback !== "function") throw new Error("invalid callback: " + callback);
        while(++i < n){
            if (t = (typename = T[i]).type) _[t] = $7c4cf709d1826294$var$set(_[t], typename.name, callback);
            else if (callback == null) for(t in _)_[t] = $7c4cf709d1826294$var$set(_[t], typename.name, null);
        }
        return this;
    },
    copy: function() {
        var copy = {}, _ = this._;
        for(var t in _)copy[t] = _[t].slice();
        return new $7c4cf709d1826294$var$Dispatch(copy);
    },
    call: function(type, that) {
        if ((n = arguments.length - 2) > 0) for(var args = new Array(n), i = 0, n, t; i < n; ++i)args[i] = arguments[i + 2];
        if (!this._.hasOwnProperty(type)) throw new Error("unknown type: " + type);
        for(t = this._[type], i = 0, n = t.length; i < n; ++i)t[i].value.apply(that, args);
    },
    apply: function(type, that, args) {
        if (!this._.hasOwnProperty(type)) throw new Error("unknown type: " + type);
        for(var t = this._[type], i = 0, n = t.length; i < n; ++i)t[i].value.apply(that, args);
    }
};
function $7c4cf709d1826294$var$get(type, name) {
    for(var i = 0, n = type.length, c; i < n; ++i){
        if ((c = type[i]).name === name) return c.value;
    }
}
function $7c4cf709d1826294$var$set(type, name, callback) {
    for(var i = 0, n = type.length; i < n; ++i)if (type[i].name === name) {
        type[i] = $7c4cf709d1826294$var$noop, type = type.slice(0, i).concat(type.slice(i + 1));
        break;
    }
    if (callback != null) type.push({
        name: name,
        value: callback
    });
    return type;
}
var $7c4cf709d1826294$export$2e2bcd8739ae039 = $7c4cf709d1826294$var$dispatch;


var $e782289d8bd71451$var$frame = 0, $e782289d8bd71451$var$timeout = 0, $e782289d8bd71451$var$interval = 0, $e782289d8bd71451$var$pokeDelay = 1000, $e782289d8bd71451$var$taskHead, $e782289d8bd71451$var$taskTail, $e782289d8bd71451$var$clockLast = 0, $e782289d8bd71451$var$clockNow = 0, $e782289d8bd71451$var$clockSkew = 0, $e782289d8bd71451$var$clock = typeof performance === "object" && performance.now ? performance : Date, $e782289d8bd71451$var$setFrame = typeof window === "object" && window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : function(f) {
    setTimeout(f, 17);
};
function $e782289d8bd71451$export$461939dd4422153() {
    return $e782289d8bd71451$var$clockNow || ($e782289d8bd71451$var$setFrame($e782289d8bd71451$var$clearNow), $e782289d8bd71451$var$clockNow = $e782289d8bd71451$var$clock.now() + $e782289d8bd71451$var$clockSkew);
}
function $e782289d8bd71451$var$clearNow() {
    $e782289d8bd71451$var$clockNow = 0;
}
function $e782289d8bd71451$export$c57e9b2d8b9e4de() {
    this._call = this._time = this._next = null;
}
$e782289d8bd71451$export$c57e9b2d8b9e4de.prototype = $e782289d8bd71451$export$9dc4ecf953986f04.prototype = {
    constructor: $e782289d8bd71451$export$c57e9b2d8b9e4de,
    restart: function(callback, delay, time) {
        if (typeof callback !== "function") throw new TypeError("callback is not a function");
        time = (time == null ? $e782289d8bd71451$export$461939dd4422153() : +time) + (delay == null ? 0 : +delay);
        if (!this._next && $e782289d8bd71451$var$taskTail !== this) {
            if ($e782289d8bd71451$var$taskTail) $e782289d8bd71451$var$taskTail._next = this;
            else $e782289d8bd71451$var$taskHead = this;
            $e782289d8bd71451$var$taskTail = this;
        }
        this._call = callback;
        this._time = time;
        $e782289d8bd71451$var$sleep();
    },
    stop: function() {
        if (this._call) {
            this._call = null;
            this._time = Infinity;
            $e782289d8bd71451$var$sleep();
        }
    }
};
function $e782289d8bd71451$export$9dc4ecf953986f04(callback, delay, time) {
    var t = new $e782289d8bd71451$export$c57e9b2d8b9e4de;
    t.restart(callback, delay, time);
    return t;
}
function $e782289d8bd71451$export$d60154c1d7f3990e() {
    $e782289d8bd71451$export$461939dd4422153(); // Get the current time, if not already set.
    ++$e782289d8bd71451$var$frame; // Pretend we’ve set an alarm, if we haven’t already.
    var t = $e782289d8bd71451$var$taskHead, e;
    while(t){
        if ((e = $e782289d8bd71451$var$clockNow - t._time) >= 0) t._call.call(undefined, e);
        t = t._next;
    }
    --$e782289d8bd71451$var$frame;
}
function $e782289d8bd71451$var$wake() {
    $e782289d8bd71451$var$clockNow = ($e782289d8bd71451$var$clockLast = $e782289d8bd71451$var$clock.now()) + $e782289d8bd71451$var$clockSkew;
    $e782289d8bd71451$var$frame = $e782289d8bd71451$var$timeout = 0;
    try {
        $e782289d8bd71451$export$d60154c1d7f3990e();
    } finally{
        $e782289d8bd71451$var$frame = 0;
        $e782289d8bd71451$var$nap();
        $e782289d8bd71451$var$clockNow = 0;
    }
}
function $e782289d8bd71451$var$poke() {
    var now = $e782289d8bd71451$var$clock.now(), delay = now - $e782289d8bd71451$var$clockLast;
    if (delay > $e782289d8bd71451$var$pokeDelay) $e782289d8bd71451$var$clockSkew -= delay, $e782289d8bd71451$var$clockLast = now;
}
function $e782289d8bd71451$var$nap() {
    var t0, t1 = $e782289d8bd71451$var$taskHead, t2, time = Infinity;
    while(t1)if (t1._call) {
        if (time > t1._time) time = t1._time;
        t0 = t1, t1 = t1._next;
    } else {
        t2 = t1._next, t1._next = null;
        t1 = t0 ? t0._next = t2 : $e782289d8bd71451$var$taskHead = t2;
    }
    $e782289d8bd71451$var$taskTail = t0;
    $e782289d8bd71451$var$sleep(time);
}
function $e782289d8bd71451$var$sleep(time) {
    if ($e782289d8bd71451$var$frame) return; // Soonest alarm already set, or will be.
    if ($e782289d8bd71451$var$timeout) $e782289d8bd71451$var$timeout = clearTimeout($e782289d8bd71451$var$timeout);
    var delay = time - $e782289d8bd71451$var$clockNow; // Strictly less than if we recomputed clockNow.
    if (delay > 24) {
        if (time < Infinity) $e782289d8bd71451$var$timeout = setTimeout($e782289d8bd71451$var$wake, time - $e782289d8bd71451$var$clock.now() - $e782289d8bd71451$var$clockSkew);
        if ($e782289d8bd71451$var$interval) $e782289d8bd71451$var$interval = clearInterval($e782289d8bd71451$var$interval);
    } else {
        if (!$e782289d8bd71451$var$interval) $e782289d8bd71451$var$clockLast = $e782289d8bd71451$var$clock.now(), $e782289d8bd71451$var$interval = setInterval($e782289d8bd71451$var$poke, $e782289d8bd71451$var$pokeDelay);
        $e782289d8bd71451$var$frame = 1, $e782289d8bd71451$var$setFrame($e782289d8bd71451$var$wake);
    }
}


// https://en.wikipedia.org/wiki/Linear_congruential_generator#Parameters_in_common_use
const $b6822525b674dc21$var$a = 1664525;
const $b6822525b674dc21$var$c = 1013904223;
const $b6822525b674dc21$var$m = 4294967296; // 2^32
function $b6822525b674dc21$export$2e2bcd8739ae039() {
    let s = 1;
    return ()=>(s = ($b6822525b674dc21$var$a * s + $b6822525b674dc21$var$c) % $b6822525b674dc21$var$m) / $b6822525b674dc21$var$m;
}


var $a61c6b05e92f056e$var$MAX_DIMENSIONS = 3;
function $a61c6b05e92f056e$export$d141bba7fdc215a3(d) {
    return d.x;
}
function $a61c6b05e92f056e$export$4a5767248b18ef41(d) {
    return d.y;
}
function $a61c6b05e92f056e$export$df995fae86a55f06(d) {
    return d.z;
}
var $a61c6b05e92f056e$var$initialRadius = 10, $a61c6b05e92f056e$var$initialAngleRoll = Math.PI * (3 - Math.sqrt(5)), $a61c6b05e92f056e$var$initialAngleYaw = Math.PI * 20 / (9 + Math.sqrt(221)); // Markov irrational number
function $a61c6b05e92f056e$export$2e2bcd8739ae039(nodes, numDimensions) {
    numDimensions = numDimensions || 2;
    var nDim = Math.min($a61c6b05e92f056e$var$MAX_DIMENSIONS, Math.max(1, Math.round(numDimensions))), simulation, alpha = 1, alphaMin = 0.001, alphaDecay = 1 - Math.pow(alphaMin, 1 / 300), alphaTarget = 0, velocityDecay = 0.6, forces = new Map(), stepper = (0, $e782289d8bd71451$export$9dc4ecf953986f04)(step), event = (0, $7c4cf709d1826294$export$2e2bcd8739ae039)("tick", "end"), random = (0, $b6822525b674dc21$export$2e2bcd8739ae039)();
    if (nodes == null) nodes = [];
    function step() {
        tick();
        event.call("tick", simulation);
        if (alpha < alphaMin) {
            stepper.stop();
            event.call("end", simulation);
        }
    }
    function tick(iterations) {
        var i, n = nodes.length, node;
        if (iterations === undefined) iterations = 1;
        for(var k = 0; k < iterations; ++k){
            alpha += (alphaTarget - alpha) * alphaDecay;
            forces.forEach(function(force) {
                force(alpha);
            });
            for(i = 0; i < n; ++i){
                node = nodes[i];
                if (node.fx == null) node.x += node.vx *= velocityDecay;
                else node.x = node.fx, node.vx = 0;
                if (nDim > 1) {
                    if (node.fy == null) node.y += node.vy *= velocityDecay;
                    else node.y = node.fy, node.vy = 0;
                }
                if (nDim > 2) {
                    if (node.fz == null) node.z += node.vz *= velocityDecay;
                    else node.z = node.fz, node.vz = 0;
                }
            }
        }
        return simulation;
    }
    function initializeNodes() {
        for(var i = 0, n = nodes.length, node; i < n; ++i){
            node = nodes[i], node.index = i;
            if (node.fx != null) node.x = node.fx;
            if (node.fy != null) node.y = node.fy;
            if (node.fz != null) node.z = node.fz;
            if (isNaN(node.x) || nDim > 1 && isNaN(node.y) || nDim > 2 && isNaN(node.z)) {
                var radius = $a61c6b05e92f056e$var$initialRadius * (nDim > 2 ? Math.cbrt(0.5 + i) : nDim > 1 ? Math.sqrt(0.5 + i) : i), rollAngle = i * $a61c6b05e92f056e$var$initialAngleRoll, yawAngle = i * $a61c6b05e92f056e$var$initialAngleYaw;
                if (nDim === 1) node.x = radius;
                else if (nDim === 2) {
                    node.x = radius * Math.cos(rollAngle);
                    node.y = radius * Math.sin(rollAngle);
                } else {
                    node.x = radius * Math.sin(rollAngle) * Math.cos(yawAngle);
                    node.y = radius * Math.cos(rollAngle);
                    node.z = radius * Math.sin(rollAngle) * Math.sin(yawAngle);
                }
            }
            if (isNaN(node.vx) || nDim > 1 && isNaN(node.vy) || nDim > 2 && isNaN(node.vz)) {
                node.vx = 0;
                if (nDim > 1) node.vy = 0;
                if (nDim > 2) node.vz = 0;
            }
        }
    }
    function initializeForce(force) {
        if (force.initialize) force.initialize(nodes, random, nDim);
        return force;
    }
    initializeNodes();
    return simulation = {
        tick: tick,
        restart: function() {
            return stepper.restart(step), simulation;
        },
        stop: function() {
            return stepper.stop(), simulation;
        },
        numDimensions: function(_) {
            return arguments.length ? (nDim = Math.min($a61c6b05e92f056e$var$MAX_DIMENSIONS, Math.max(1, Math.round(_))), forces.forEach(initializeForce), simulation) : nDim;
        },
        nodes: function(_) {
            return arguments.length ? (nodes = _, initializeNodes(), forces.forEach(initializeForce), simulation) : nodes;
        },
        alpha: function(_) {
            return arguments.length ? (alpha = +_, simulation) : alpha;
        },
        alphaMin: function(_) {
            return arguments.length ? (alphaMin = +_, simulation) : alphaMin;
        },
        alphaDecay: function(_) {
            return arguments.length ? (alphaDecay = +_, simulation) : +alphaDecay;
        },
        alphaTarget: function(_) {
            return arguments.length ? (alphaTarget = +_, simulation) : alphaTarget;
        },
        velocityDecay: function(_) {
            return arguments.length ? (velocityDecay = 1 - _, simulation) : 1 - velocityDecay;
        },
        randomSource: function(_) {
            return arguments.length ? (random = _, forces.forEach(initializeForce), simulation) : random;
        },
        force: function(name, _) {
            return arguments.length > 1 ? (_ == null ? forces.delete(name) : forces.set(name, initializeForce(_)), simulation) : forces.get(name);
        },
        find: function() {
            var args = Array.prototype.slice.call(arguments);
            var x = args.shift() || 0, y = (nDim > 1 ? args.shift() : null) || 0, z = (nDim > 2 ? args.shift() : null) || 0, radius = args.shift() || Infinity;
            var i = 0, n = nodes.length, dx, dy, dz, d2, node, closest;
            radius *= radius;
            for(i = 0; i < n; ++i){
                node = nodes[i];
                dx = x - node.x;
                dy = y - (node.y || 0);
                dz = z - (node.z || 0);
                d2 = dx * dx + dy * dy + dz * dz;
                if (d2 < radius) closest = node, radius = d2;
            }
            return closest;
        },
        on: function(name, _) {
            return arguments.length > 1 ? (event.on(name, _), simulation) : event.on(name);
        }
    };
}


function $78193c16de4a9cf2$export$2e2bcd8739ae039() {
    var nodes, nDim, node, random, alpha, strength = (0, $439e574675725ffd$export$2e2bcd8739ae039)(-30), strengths, distanceMin2 = 1, distanceMax2 = Infinity, theta2 = 0.81;
    function force(_) {
        var i, n = nodes.length, tree = (nDim === 1 ? (0, $45b61d86bb7347bf$export$2e2bcd8739ae039)(nodes, (0, $a61c6b05e92f056e$export$d141bba7fdc215a3)) : nDim === 2 ? (0, $977cc0295d3f184c$export$2e2bcd8739ae039)(nodes, (0, $a61c6b05e92f056e$export$d141bba7fdc215a3), (0, $a61c6b05e92f056e$export$4a5767248b18ef41)) : nDim === 3 ? (0, $c0920825b99e823f$export$2e2bcd8739ae039)(nodes, (0, $a61c6b05e92f056e$export$d141bba7fdc215a3), (0, $a61c6b05e92f056e$export$4a5767248b18ef41), (0, $a61c6b05e92f056e$export$df995fae86a55f06)) : null).visitAfter(accumulate);
        for(alpha = _, i = 0; i < n; ++i)node = nodes[i], tree.visit(apply);
    }
    function initialize() {
        if (!nodes) return;
        var i, n = nodes.length, node;
        strengths = new Array(n);
        for(i = 0; i < n; ++i)node = nodes[i], strengths[node.index] = +strength(node, i, nodes);
    }
    function accumulate(treeNode) {
        var strength = 0, q, c, weight = 0, x, y, z, i;
        var numChildren = treeNode.length;
        // For internal nodes, accumulate forces from children.
        if (numChildren) {
            for(x = y = z = i = 0; i < numChildren; ++i)if ((q = treeNode[i]) && (c = Math.abs(q.value))) strength += q.value, weight += c, x += c * (q.x || 0), y += c * (q.y || 0), z += c * (q.z || 0);
            strength *= Math.sqrt(4 / numChildren); // scale accumulated strength according to number of dimensions
            treeNode.x = x / weight;
            if (nDim > 1) treeNode.y = y / weight;
            if (nDim > 2) treeNode.z = z / weight;
        } else {
            q = treeNode;
            q.x = q.data.x;
            if (nDim > 1) q.y = q.data.y;
            if (nDim > 2) q.z = q.data.z;
            do strength += strengths[q.data.index];
            while (q = q.next);
        }
        treeNode.value = strength;
    }
    function apply(treeNode, x1, arg1, arg2, arg3) {
        if (!treeNode.value) return true;
        var x2 = [
            arg1,
            arg2,
            arg3
        ][nDim - 1];
        var x = treeNode.x - node.x, y = nDim > 1 ? treeNode.y - node.y : 0, z = nDim > 2 ? treeNode.z - node.z : 0, w = x2 - x1, l = x * x + y * y + z * z;
        // Apply the Barnes-Hut approximation if possible.
        // Limit forces for very close nodes; randomize direction if coincident.
        if (w * w / theta2 < l) {
            if (l < distanceMax2) {
                if (x === 0) x = (0, $873789d86530d8a0$export$2e2bcd8739ae039)(random), l += x * x;
                if (nDim > 1 && y === 0) y = (0, $873789d86530d8a0$export$2e2bcd8739ae039)(random), l += y * y;
                if (nDim > 2 && z === 0) z = (0, $873789d86530d8a0$export$2e2bcd8739ae039)(random), l += z * z;
                if (l < distanceMin2) l = Math.sqrt(distanceMin2 * l);
                node.vx += x * treeNode.value * alpha / l;
                if (nDim > 1) node.vy += y * treeNode.value * alpha / l;
                if (nDim > 2) node.vz += z * treeNode.value * alpha / l;
            }
            return true;
        } else if (treeNode.length || l >= distanceMax2) return;
        // Limit forces for very close nodes; randomize direction if coincident.
        if (treeNode.data !== node || treeNode.next) {
            if (x === 0) x = (0, $873789d86530d8a0$export$2e2bcd8739ae039)(random), l += x * x;
            if (nDim > 1 && y === 0) y = (0, $873789d86530d8a0$export$2e2bcd8739ae039)(random), l += y * y;
            if (nDim > 2 && z === 0) z = (0, $873789d86530d8a0$export$2e2bcd8739ae039)(random), l += z * z;
            if (l < distanceMin2) l = Math.sqrt(distanceMin2 * l);
        }
        do if (treeNode.data !== node) {
            w = strengths[treeNode.data.index] * alpha / l;
            node.vx += x * w;
            if (nDim > 1) node.vy += y * w;
            if (nDim > 2) node.vz += z * w;
        }
        while (treeNode = treeNode.next);
    }
    force.initialize = function(_nodes, ...args) {
        nodes = _nodes;
        random = args.find((arg)=>typeof arg === 'function') || Math.random;
        nDim = args.find((arg)=>[
                1,
                2,
                3
            ].includes(arg)) || 2;
        initialize();
    };
    force.strength = function(_) {
        return arguments.length ? (strength = typeof _ === "function" ? _ : (0, $439e574675725ffd$export$2e2bcd8739ae039)(+_), initialize(), force) : strength;
    };
    force.distanceMin = function(_) {
        return arguments.length ? (distanceMin2 = _ * _, force) : Math.sqrt(distanceMin2);
    };
    force.distanceMax = function(_) {
        return arguments.length ? (distanceMax2 = _ * _, force) : Math.sqrt(distanceMax2);
    };
    force.theta = function(_) {
        return arguments.length ? (theta2 = _ * _, force) : Math.sqrt(theta2);
    };
    return force;
}


function $91cad9d8ddc689ca$export$2e2bcd8739ae039(radius, x, y, z) {
    var nodes, nDim, strength = (0, $439e574675725ffd$export$2e2bcd8739ae039)(0.1), strengths, radiuses;
    if (typeof radius !== "function") radius = (0, $439e574675725ffd$export$2e2bcd8739ae039)(+radius);
    if (x == null) x = 0;
    if (y == null) y = 0;
    if (z == null) z = 0;
    function force(alpha) {
        for(var i = 0, n = nodes.length; i < n; ++i){
            var node = nodes[i], dx = node.x - x || 1e-6, dy = (node.y || 0) - y || 1e-6, dz = (node.z || 0) - z || 1e-6, r = Math.sqrt(dx * dx + dy * dy + dz * dz), k = (radiuses[i] - r) * strengths[i] * alpha / r;
            node.vx += dx * k;
            if (nDim > 1) node.vy += dy * k;
            if (nDim > 2) node.vz += dz * k;
        }
    }
    function initialize() {
        if (!nodes) return;
        var i, n = nodes.length;
        strengths = new Array(n);
        radiuses = new Array(n);
        for(i = 0; i < n; ++i){
            radiuses[i] = +radius(nodes[i], i, nodes);
            strengths[i] = isNaN(radiuses[i]) ? 0 : +strength(nodes[i], i, nodes);
        }
    }
    force.initialize = function(initNodes, ...args) {
        nodes = initNodes;
        nDim = args.find((arg)=>[
                1,
                2,
                3
            ].includes(arg)) || 2;
        initialize();
    };
    force.strength = function(_) {
        return arguments.length ? (strength = typeof _ === "function" ? _ : (0, $439e574675725ffd$export$2e2bcd8739ae039)(+_), initialize(), force) : strength;
    };
    force.radius = function(_) {
        return arguments.length ? (radius = typeof _ === "function" ? _ : (0, $439e574675725ffd$export$2e2bcd8739ae039)(+_), initialize(), force) : radius;
    };
    force.x = function(_) {
        return arguments.length ? (x = +_, force) : x;
    };
    force.y = function(_) {
        return arguments.length ? (y = +_, force) : y;
    };
    force.z = function(_) {
        return arguments.length ? (z = +_, force) : z;
    };
    return force;
}


var $eba878becea76980$exports = {};
/**
 * @fileOverview Contains definition of the core graph object.
 */ // TODO: need to change storage layer:
// 1. Be able to get all nodes O(1)
// 2. Be able to get number of links O(1)
/**
 * @example
 *  var graph = require('ngraph.graph')();
 *  graph.addNode(1);     // graph has one node.
 *  graph.addLink(2, 3);  // now graph contains three nodes and one link.
 *
 */ $eba878becea76980$exports = $eba878becea76980$var$createGraph;

var $5svTu = parcelRequire("5svTu");
/**
 * Creates a new graph
 */ function $eba878becea76980$var$createGraph(options) {
    // Graph structure is maintained as dictionary of nodes
    // and array of links. Each node has 'links' property which
    // hold all links related to that node. And general links
    // array is used to speed up all links enumeration. This is inefficient
    // in terms of memory, but simplifies coding.
    options = options || {};
    if ('uniqueLinkId' in options) {
        console.warn("ngraph.graph: Starting from version 0.14 `uniqueLinkId` is deprecated.\nUse `multigraph` option instead\n", '\n', "Note: there is also change in default behavior: From now on each graph\nis considered to be not a multigraph by default (each edge is unique).");
        options.multigraph = options.uniqueLinkId;
    }
    // Dear reader, the non-multigraphs do not guarantee that there is only
    // one link for a given pair of node. When this option is set to false
    // we can save some memory and CPU (18% faster for non-multigraph);
    if (options.multigraph === undefined) options.multigraph = false;
    if (typeof Map !== 'function') // TODO: Should we polyfill it ourselves? We don't use much operations there..
    throw new Error('ngraph.graph requires `Map` to be defined. Please polyfill it before using ngraph');
    var nodes = new Map(); // nodeId => Node
    var links = new Map(); // linkId => Link
    // Hash of multi-edges. Used to track ids of edges between same nodes
    var multiEdges = {};
    var suspendEvents = 0;
    var createLink = options.multigraph ? createUniqueLink : createSingleLink, // Our graph API provides means to listen to graph changes. Users can subscribe
    // to be notified about changes in the graph by using `on` method. However
    // in some cases they don't use it. To avoid unnecessary memory consumption
    // we will not record graph changes until we have at least one subscriber.
    // Code below supports this optimization.
    //
    // Accumulates all changes made during graph updates.
    // Each change element contains:
    //  changeType - one of the strings: 'add', 'remove' or 'update';
    //  node - if change is related to node this property is set to changed graph's node;
    //  link - if change is related to link this property is set to changed graph's link;
    changes = [], recordLinkChange = noop, recordNodeChange = noop, enterModification = noop, exitModification = noop;
    // this is our public API:
    var graphPart = {
        /**
     * Sometimes duck typing could be slow. Giving clients a hint about data structure
     * via explicit version number here:
     */ version: 20.0,
        /**
     * Adds node to the graph. If node with given id already exists in the graph
     * its data is extended with whatever comes in 'data' argument.
     *
     * @param nodeId the node's identifier. A string or number is preferred.
     * @param [data] additional data for the node being added. If node already
     *   exists its data object is augmented with the new one.
     *
     * @return {node} The newly added node or node with given id if it already exists.
     */ addNode: addNode,
        /**
     * Adds a link to the graph. The function always create a new
     * link between two nodes. If one of the nodes does not exists
     * a new node is created.
     *
     * @param fromId link start node id;
     * @param toId link end node id;
     * @param [data] additional data to be set on the new link;
     *
     * @return {link} The newly created link
     */ addLink: addLink,
        /**
     * Removes link from the graph. If link does not exist does nothing.
     *
     * @param link - object returned by addLink() or getLinks() methods.
     *
     * @returns true if link was removed; false otherwise.
     */ removeLink: removeLink,
        /**
     * Removes node with given id from the graph. If node does not exist in the graph
     * does nothing.
     *
     * @param nodeId node's identifier passed to addNode() function.
     *
     * @returns true if node was removed; false otherwise.
     */ removeNode: removeNode,
        /**
     * Gets node with given identifier. If node does not exist undefined value is returned.
     *
     * @param nodeId requested node identifier;
     *
     * @return {node} in with requested identifier or undefined if no such node exists.
     */ getNode: getNode,
        /**
     * Gets number of nodes in this graph.
     *
     * @return number of nodes in the graph.
     */ getNodeCount: getNodeCount,
        /**
     * Gets total number of links in the graph.
     */ getLinkCount: getLinkCount,
        /**
     * Gets total number of links in the graph.
     */ getEdgeCount: getLinkCount,
        /**
     * Synonym for `getLinkCount()`
     */ getLinksCount: getLinkCount,
        /**
     * Synonym for `getNodeCount()`
     */ getNodesCount: getNodeCount,
        /**
     * Gets all links (inbound and outbound) from the node with given id.
     * If node with given id is not found null is returned.
     *
     * @param nodeId requested node identifier.
     *
     * @return Set of links from and to requested node if such node exists;
     *   otherwise null is returned.
     */ getLinks: getLinks,
        /**
     * Invokes callback on each node of the graph.
     *
     * @param {Function(node)} callback Function to be invoked. The function
     *   is passed one argument: visited node.
     */ forEachNode: forEachNode,
        /**
     * Invokes callback on every linked (adjacent) node to the given one.
     *
     * @param nodeId Identifier of the requested node.
     * @param {Function(node, link)} callback Function to be called on all linked nodes.
     *   The function is passed two parameters: adjacent node and link object itself.
     * @param oriented if true graph treated as oriented.
     */ forEachLinkedNode: forEachLinkedNode,
        /**
     * Enumerates all links in the graph
     *
     * @param {Function(link)} callback Function to be called on all links in the graph.
     *   The function is passed one parameter: graph's link object.
     *
     * Link object contains at least the following fields:
     *  fromId - node id where link starts;
     *  toId - node id where link ends,
     *  data - additional data passed to graph.addLink() method.
     */ forEachLink: forEachLink,
        /**
     * Suspend all notifications about graph changes until
     * endUpdate is called.
     */ beginUpdate: enterModification,
        /**
     * Resumes all notifications about graph changes and fires
     * graph 'changed' event in case there are any pending changes.
     */ endUpdate: exitModification,
        /**
     * Removes all nodes and links from the graph.
     */ clear: clear,
        /**
     * Detects whether there is a link between two nodes.
     * Operation complexity is O(n) where n - number of links of a node.
     * NOTE: this function is synonym for getLink()
     *
     * @returns link if there is one. null otherwise.
     */ hasLink: getLink,
        /**
     * Detects whether there is a node with given id
     * 
     * Operation complexity is O(1)
     * NOTE: this function is synonym for getNode()
     *
     * @returns node if there is one; Falsy value otherwise.
     */ hasNode: getNode,
        /**
     * Gets an edge between two nodes.
     * Operation complexity is O(n) where n - number of links of a node.
     *
     * @param {string} fromId link start identifier
     * @param {string} toId link end identifier
     *
     * @returns link if there is one; undefined otherwise.
     */ getLink: getLink
    };
    // this will add `on()` and `fire()` methods.
    $5svTu(graphPart);
    monitorSubscribers();
    return graphPart;
    function monitorSubscribers() {
        var realOn = graphPart.on;
        // replace real `on` with our temporary on, which will trigger change
        // modification monitoring:
        graphPart.on = on;
        function on() {
            // now it's time to start tracking stuff:
            graphPart.beginUpdate = enterModification = enterModificationReal;
            graphPart.endUpdate = exitModification = exitModificationReal;
            recordLinkChange = recordLinkChangeReal;
            recordNodeChange = recordNodeChangeReal;
            // this will replace current `on` method with real pub/sub from `eventify`.
            graphPart.on = realOn;
            // delegate to real `on` handler:
            return realOn.apply(graphPart, arguments);
        }
    }
    function recordLinkChangeReal(link, changeType) {
        changes.push({
            link: link,
            changeType: changeType
        });
    }
    function recordNodeChangeReal(node, changeType) {
        changes.push({
            node: node,
            changeType: changeType
        });
    }
    function addNode(nodeId, data) {
        if (nodeId === undefined) throw new Error('Invalid node identifier');
        enterModification();
        var node = getNode(nodeId);
        if (!node) {
            node = new $eba878becea76980$var$Node(nodeId, data);
            recordNodeChange(node, 'add');
        } else {
            node.data = data;
            recordNodeChange(node, 'update');
        }
        nodes.set(nodeId, node);
        exitModification();
        return node;
    }
    function getNode(nodeId) {
        return nodes.get(nodeId);
    }
    function removeNode(nodeId) {
        var node = getNode(nodeId);
        if (!node) return false;
        enterModification();
        var prevLinks = node.links;
        if (prevLinks) {
            prevLinks.forEach(removeLinkInstance);
            node.links = null;
        }
        nodes.delete(nodeId);
        recordNodeChange(node, 'remove');
        exitModification();
        return true;
    }
    function addLink(fromId, toId, data) {
        enterModification();
        var fromNode = getNode(fromId) || addNode(fromId);
        var toNode = getNode(toId) || addNode(toId);
        var link = createLink(fromId, toId, data);
        var isUpdate = links.has(link.id);
        links.set(link.id, link);
        // TODO: this is not cool. On large graphs potentially would consume more memory.
        $eba878becea76980$var$addLinkToNode(fromNode, link);
        if (fromId !== toId) // make sure we are not duplicating links for self-loops
        $eba878becea76980$var$addLinkToNode(toNode, link);
        recordLinkChange(link, isUpdate ? 'update' : 'add');
        exitModification();
        return link;
    }
    function createSingleLink(fromId, toId, data) {
        var linkId = $eba878becea76980$var$makeLinkId(fromId, toId);
        var prevLink = links.get(linkId);
        if (prevLink) {
            prevLink.data = data;
            return prevLink;
        }
        return new $eba878becea76980$var$Link(fromId, toId, data, linkId);
    }
    function createUniqueLink(fromId, toId, data) {
        // TODO: Find a better/faster way to store multigraphs
        var linkId = $eba878becea76980$var$makeLinkId(fromId, toId);
        var isMultiEdge = multiEdges.hasOwnProperty(linkId);
        if (isMultiEdge || getLink(fromId, toId)) {
            if (!isMultiEdge) multiEdges[linkId] = 0;
            var suffix = '@' + ++multiEdges[linkId];
            linkId = $eba878becea76980$var$makeLinkId(fromId + suffix, toId + suffix);
        }
        return new $eba878becea76980$var$Link(fromId, toId, data, linkId);
    }
    function getNodeCount() {
        return nodes.size;
    }
    function getLinkCount() {
        return links.size;
    }
    function getLinks(nodeId) {
        var node = getNode(nodeId);
        return node ? node.links : null;
    }
    function removeLink(link, otherId) {
        if (otherId !== undefined) link = getLink(link, otherId);
        return removeLinkInstance(link);
    }
    function removeLinkInstance(link) {
        if (!link) return false;
        if (!links.get(link.id)) return false;
        enterModification();
        links.delete(link.id);
        var fromNode = getNode(link.fromId);
        var toNode = getNode(link.toId);
        if (fromNode) fromNode.links.delete(link);
        if (toNode) toNode.links.delete(link);
        recordLinkChange(link, 'remove');
        exitModification();
        return true;
    }
    function getLink(fromNodeId, toNodeId) {
        if (fromNodeId === undefined || toNodeId === undefined) return undefined;
        return links.get($eba878becea76980$var$makeLinkId(fromNodeId, toNodeId));
    }
    function clear() {
        enterModification();
        forEachNode(function(node) {
            removeNode(node.id);
        });
        exitModification();
    }
    function forEachLink(callback) {
        if (typeof callback === 'function') {
            var valuesIterator = links.values();
            var nextValue = valuesIterator.next();
            while(!nextValue.done){
                if (callback(nextValue.value)) return true; // client doesn't want to proceed. Return.
                nextValue = valuesIterator.next();
            }
        }
    }
    function forEachLinkedNode(nodeId, callback, oriented) {
        var node = getNode(nodeId);
        if (node && node.links && typeof callback === 'function') {
            if (oriented) return forEachOrientedLink(node.links, nodeId, callback);
            else return forEachNonOrientedLink(node.links, nodeId, callback);
        }
    }
    // eslint-disable-next-line no-shadow
    function forEachNonOrientedLink(links, nodeId, callback) {
        var quitFast;
        var valuesIterator = links.values();
        var nextValue = valuesIterator.next();
        while(!nextValue.done){
            var link = nextValue.value;
            var linkedNodeId = link.fromId === nodeId ? link.toId : link.fromId;
            quitFast = callback(nodes.get(linkedNodeId), link);
            if (quitFast) return true; // Client does not need more iterations. Break now.
            nextValue = valuesIterator.next();
        }
    }
    // eslint-disable-next-line no-shadow
    function forEachOrientedLink(links, nodeId, callback) {
        var quitFast;
        var valuesIterator = links.values();
        var nextValue = valuesIterator.next();
        while(!nextValue.done){
            var link = nextValue.value;
            if (link.fromId === nodeId) {
                quitFast = callback(nodes.get(link.toId), link);
                if (quitFast) return true; // Client does not need more iterations. Break now.
            }
            nextValue = valuesIterator.next();
        }
    }
    // we will not fire anything until users of this library explicitly call `on()`
    // method.
    function noop() {}
    // Enter, Exit modification allows bulk graph updates without firing events.
    function enterModificationReal() {
        suspendEvents += 1;
    }
    function exitModificationReal() {
        suspendEvents -= 1;
        if (suspendEvents === 0 && changes.length > 0) {
            graphPart.fire('changed', changes);
            changes.length = 0;
        }
    }
    function forEachNode(callback) {
        if (typeof callback !== 'function') throw new Error('Function is expected to iterate over graph nodes. You passed ' + callback);
        var valuesIterator = nodes.values();
        var nextValue = valuesIterator.next();
        while(!nextValue.done){
            if (callback(nextValue.value)) return true; // client doesn't want to proceed. Return.
            nextValue = valuesIterator.next();
        }
    }
}
/**
 * Internal structure to represent node;
 */ function $eba878becea76980$var$Node(id, data) {
    this.id = id;
    this.links = null;
    this.data = data;
}
function $eba878becea76980$var$addLinkToNode(node, link) {
    if (node.links) node.links.add(link);
    else node.links = new Set([
        link
    ]);
}
/**
 * Internal structure to represent links;
 */ function $eba878becea76980$var$Link(fromId, toId, data, id) {
    this.fromId = fromId;
    this.toId = toId;
    this.data = data;
    this.id = id;
}
function $eba878becea76980$var$makeLinkId(fromId, toId) {
    return fromId.toString() + "\uD83D\uDC49 " + toId.toString();
}


var $6d47bf1a993b0381$exports = {};
$6d47bf1a993b0381$exports = $6d47bf1a993b0381$var$createLayout;

$6d47bf1a993b0381$exports.simulator = (parcelRequire("6y6y7"));

var $5svTu = parcelRequire("5svTu");

/**
 * Creates force based layout for a given graph.
 *
 * @param {ngraph.graph} graph which needs to be laid out
 * @param {object} physicsSettings if you need custom settings
 * for physics simulator you can pass your own settings here. If it's not passed
 * a default one will be created.
 */ function $6d47bf1a993b0381$var$createLayout(graph, physicsSettings) {
    if (!graph) throw new Error('Graph structure cannot be undefined');
    var createSimulator = physicsSettings && physicsSettings.createSimulator || (parcelRequire("6y6y7"));
    var physicsSimulator = createSimulator(physicsSettings);
    if (Array.isArray(physicsSettings)) throw new Error('Physics settings is expected to be an object');
    var nodeMass = graph.version > 19 ? defaultSetNodeMass : defaultArrayNodeMass;
    if (physicsSettings && typeof physicsSettings.nodeMass === 'function') nodeMass = physicsSettings.nodeMass;
    var nodeBodies = new Map();
    var springs = {};
    var bodiesCount = 0;
    var springTransform = physicsSimulator.settings.springTransform || $6d47bf1a993b0381$var$noop;
    // Initialize physics with what we have in the graph:
    initPhysics();
    listenToEvents();
    var wasStable = false;
    var api = {
        /**
     * Performs one step of iterative layout algorithm
     *
     * @returns {boolean} true if the system should be considered stable; False otherwise.
     * The system is stable if no further call to `step()` can improve the layout.
     */ step: function() {
            if (bodiesCount === 0) {
                updateStableStatus(true);
                return true;
            }
            var lastMove = physicsSimulator.step();
            // Save the movement in case if someone wants to query it in the step
            // callback.
            api.lastMove = lastMove;
            // Allow listeners to perform low-level actions after nodes are updated.
            api.fire('step');
            var ratio = lastMove / bodiesCount;
            var isStableNow = ratio <= 0.01; // TODO: The number is somewhat arbitrary...
            updateStableStatus(isStableNow);
            return isStableNow;
        },
        /**
     * For a given `nodeId` returns position
     */ getNodePosition: function(nodeId) {
            return getInitializedBody(nodeId).pos;
        },
        /**
     * Sets position of a node to a given coordinates
     * @param {string} nodeId node identifier
     * @param {number} x position of a node
     * @param {number} y position of a node
     * @param {number=} z position of node (only if applicable to body)
     */ setNodePosition: function(nodeId) {
            var body = getInitializedBody(nodeId);
            body.setPosition.apply(body, Array.prototype.slice.call(arguments, 1));
        },
        /**
     * @returns {Object} Link position by link id
     * @returns {Object.from} {x, y} coordinates of link start
     * @returns {Object.to} {x, y} coordinates of link end
     */ getLinkPosition: function(linkId) {
            var spring = springs[linkId];
            if (spring) return {
                from: spring.from.pos,
                to: spring.to.pos
            };
        },
        /**
     * @returns {Object} area required to fit in the graph. Object contains
     * `x1`, `y1` - top left coordinates
     * `x2`, `y2` - bottom right coordinates
     */ getGraphRect: function() {
            return physicsSimulator.getBBox();
        },
        /**
     * Iterates over each body in the layout simulator and performs a callback(body, nodeId)
     */ forEachBody: forEachBody,
        /*
     * Requests layout algorithm to pin/unpin node to its current position
     * Pinned nodes should not be affected by layout algorithm and always
     * remain at their position
     */ pinNode: function(node, isPinned) {
            var body = getInitializedBody(node.id);
            body.isPinned = !!isPinned;
        },
        /**
     * Checks whether given graph's node is currently pinned
     */ isNodePinned: function(node) {
            return getInitializedBody(node.id).isPinned;
        },
        /**
     * Request to release all resources
     */ dispose: function() {
            graph.off('changed', onGraphChanged);
            api.fire('disposed');
        },
        /**
     * Gets physical body for a given node id. If node is not found undefined
     * value is returned.
     */ getBody: getBody,
        /**
     * Gets spring for a given edge.
     *
     * @param {string} linkId link identifer. If two arguments are passed then
     * this argument is treated as formNodeId
     * @param {string=} toId when defined this parameter denotes head of the link
     * and first argument is treated as tail of the link (fromId)
     */ getSpring: getSpring,
        /**
     * Returns length of cumulative force vector. The closer this to zero - the more stable the system is
     */ getForceVectorLength: getForceVectorLength,
        /**
     * [Read only] Gets current physics simulator
     */ simulator: physicsSimulator,
        /**
     * Gets the graph that was used for layout
     */ graph: graph,
        /**
     * Gets amount of movement performed during last step operation
     */ lastMove: 0
    };
    $5svTu(api);
    return api;
    function updateStableStatus(isStableNow) {
        if (wasStable !== isStableNow) {
            wasStable = isStableNow;
            onStableChanged(isStableNow);
        }
    }
    function forEachBody(cb) {
        nodeBodies.forEach(cb);
    }
    function getForceVectorLength() {
        var fx = 0, fy = 0;
        forEachBody(function(body) {
            fx += Math.abs(body.force.x);
            fy += Math.abs(body.force.y);
        });
        return Math.sqrt(fx * fx + fy * fy);
    }
    function getSpring(fromId, toId) {
        var linkId;
        if (toId === undefined) {
            if (typeof fromId !== 'object') // assume fromId as a linkId:
            linkId = fromId;
            else // assume fromId to be a link object:
            linkId = fromId.id;
        } else {
            // toId is defined, should grab link:
            var link = graph.hasLink(fromId, toId);
            if (!link) return;
            linkId = link.id;
        }
        return springs[linkId];
    }
    function getBody(nodeId) {
        return nodeBodies.get(nodeId);
    }
    function listenToEvents() {
        graph.on('changed', onGraphChanged);
    }
    function onStableChanged(isStable) {
        api.fire('stable', isStable);
    }
    function onGraphChanged(changes) {
        for(var i = 0; i < changes.length; ++i){
            var change = changes[i];
            if (change.changeType === 'add') {
                if (change.node) initBody(change.node.id);
                if (change.link) initLink(change.link);
            } else if (change.changeType === 'remove') {
                if (change.node) releaseNode(change.node);
                if (change.link) releaseLink(change.link);
            }
        }
        bodiesCount = graph.getNodesCount();
    }
    function initPhysics() {
        bodiesCount = 0;
        graph.forEachNode(function(node) {
            initBody(node.id);
            bodiesCount += 1;
        });
        graph.forEachLink(initLink);
    }
    function initBody(nodeId) {
        var body = nodeBodies.get(nodeId);
        if (!body) {
            var node = graph.getNode(nodeId);
            if (!node) throw new Error('initBody() was called with unknown node id');
            var pos = node.position;
            if (!pos) {
                var neighbors = getNeighborBodies(node);
                pos = physicsSimulator.getBestNewBodyPosition(neighbors);
            }
            body = physicsSimulator.addBodyAt(pos);
            body.id = nodeId;
            nodeBodies.set(nodeId, body);
            updateBodyMass(nodeId);
            if (isNodeOriginallyPinned(node)) body.isPinned = true;
        }
    }
    function releaseNode(node) {
        var nodeId = node.id;
        var body = nodeBodies.get(nodeId);
        if (body) {
            nodeBodies.delete(nodeId);
            physicsSimulator.removeBody(body);
        }
    }
    function initLink(link) {
        updateBodyMass(link.fromId);
        updateBodyMass(link.toId);
        var fromBody = nodeBodies.get(link.fromId), toBody = nodeBodies.get(link.toId), spring = physicsSimulator.addSpring(fromBody, toBody, link.length);
        springTransform(link, spring);
        springs[link.id] = spring;
    }
    function releaseLink(link) {
        var spring = springs[link.id];
        if (spring) {
            var from = graph.getNode(link.fromId), to = graph.getNode(link.toId);
            if (from) updateBodyMass(from.id);
            if (to) updateBodyMass(to.id);
            delete springs[link.id];
            physicsSimulator.removeSpring(spring);
        }
    }
    function getNeighborBodies(node) {
        // TODO: Could probably be done better on memory
        var neighbors = [];
        if (!node.links) return neighbors;
        var maxNeighbors = Math.min(node.links.length, 2);
        for(var i = 0; i < maxNeighbors; ++i){
            var link = node.links[i];
            var otherBody = link.fromId !== node.id ? nodeBodies.get(link.fromId) : nodeBodies.get(link.toId);
            if (otherBody && otherBody.pos) neighbors.push(otherBody);
        }
        return neighbors;
    }
    function updateBodyMass(nodeId) {
        var body = nodeBodies.get(nodeId);
        body.mass = nodeMass(nodeId);
        if (Number.isNaN(body.mass)) throw new Error('Node mass should be a number');
    }
    /**
   * Checks whether graph node has in its settings pinned attribute,
   * which means layout algorithm cannot move it. Node can be marked
   * as pinned, if it has "isPinned" attribute, or when node.data has it.
   *
   * @param {Object} node a graph node to check
   * @return {Boolean} true if node should be treated as pinned; false otherwise.
   */ function isNodeOriginallyPinned(node) {
        return node && (node.isPinned || node.data && node.data.isPinned);
    }
    function getInitializedBody(nodeId) {
        var body = nodeBodies.get(nodeId);
        if (!body) {
            initBody(nodeId);
            body = nodeBodies.get(nodeId);
        }
        return body;
    }
    /**
   * Calculates mass of a body, which corresponds to node with given id.
   *
   * @param {String|Number} nodeId identifier of a node, for which body mass needs to be calculated
   * @returns {Number} recommended mass of the body;
   */ function defaultArrayNodeMass(nodeId) {
        // This function is for older versions of ngraph.graph.
        var links = graph.getLinks(nodeId);
        if (!links) return 1;
        return 1 + links.length / 3.0;
    }
    function defaultSetNodeMass(nodeId) {
        var links = graph.getLinks(nodeId);
        if (!links) return 1;
        return 1 + links.size / 3.0;
    }
}
function $6d47bf1a993b0381$var$noop() {}


/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $dd0c70c8150db920$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
}
var $dd0c70c8150db920$export$2e2bcd8739ae039 = $dd0c70c8150db920$var$isObject;


/** Detect free variable `global` from Node.js. */ var $32866938ab70cc57$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
var $32866938ab70cc57$export$2e2bcd8739ae039 = $32866938ab70cc57$var$freeGlobal;


/** Detect free variable `self`. */ var $1b818bf49f333098$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $1b818bf49f333098$var$root = (0, $32866938ab70cc57$export$2e2bcd8739ae039) || $1b818bf49f333098$var$freeSelf || Function('return this')();
var $1b818bf49f333098$export$2e2bcd8739ae039 = $1b818bf49f333098$var$root;


/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $20c74a585cb2c860$var$now = function() {
    return (0, $1b818bf49f333098$export$2e2bcd8739ae039).Date.now();
};
var $20c74a585cb2c860$export$2e2bcd8739ae039 = $20c74a585cb2c860$var$now;


/** Used to match a single whitespace character. */ var $d74bdd257728cf90$var$reWhitespace = /\s/;
/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */ function $d74bdd257728cf90$var$trimmedEndIndex(string) {
    var index = string.length;
    while(index-- && $d74bdd257728cf90$var$reWhitespace.test(string.charAt(index)));
    return index;
}
var $d74bdd257728cf90$export$2e2bcd8739ae039 = $d74bdd257728cf90$var$trimmedEndIndex;


/** Used to match leading whitespace. */ var $66661208b19b5b1b$var$reTrimStart = /^\s+/;
/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */ function $66661208b19b5b1b$var$baseTrim(string) {
    return string ? string.slice(0, (0, $d74bdd257728cf90$export$2e2bcd8739ae039)(string) + 1).replace($66661208b19b5b1b$var$reTrimStart, '') : string;
}
var $66661208b19b5b1b$export$2e2bcd8739ae039 = $66661208b19b5b1b$var$baseTrim;




/** Built-in value references. */ var $f302ffc9a48734c4$var$Symbol = (0, $1b818bf49f333098$export$2e2bcd8739ae039).Symbol;
var $f302ffc9a48734c4$export$2e2bcd8739ae039 = $f302ffc9a48734c4$var$Symbol;



/** Used for built-in method references. */ var $59fc01f5e412f819$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $59fc01f5e412f819$var$hasOwnProperty = $59fc01f5e412f819$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $59fc01f5e412f819$var$nativeObjectToString = $59fc01f5e412f819$var$objectProto.toString;
/** Built-in value references. */ var $59fc01f5e412f819$var$symToStringTag = (0, $f302ffc9a48734c4$export$2e2bcd8739ae039) ? (0, $f302ffc9a48734c4$export$2e2bcd8739ae039).toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $59fc01f5e412f819$var$getRawTag(value) {
    var isOwn = $59fc01f5e412f819$var$hasOwnProperty.call(value, $59fc01f5e412f819$var$symToStringTag), tag = value[$59fc01f5e412f819$var$symToStringTag];
    try {
        value[$59fc01f5e412f819$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $59fc01f5e412f819$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$59fc01f5e412f819$var$symToStringTag] = tag;
        else delete value[$59fc01f5e412f819$var$symToStringTag];
    }
    return result;
}
var $59fc01f5e412f819$export$2e2bcd8739ae039 = $59fc01f5e412f819$var$getRawTag;


/** Used for built-in method references. */ var $94199a1861e07064$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $94199a1861e07064$var$nativeObjectToString = $94199a1861e07064$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $94199a1861e07064$var$objectToString(value) {
    return $94199a1861e07064$var$nativeObjectToString.call(value);
}
var $94199a1861e07064$export$2e2bcd8739ae039 = $94199a1861e07064$var$objectToString;


/** `Object#toString` result references. */ var $ccdb19c7f0a62300$var$nullTag = '[object Null]', $ccdb19c7f0a62300$var$undefinedTag = '[object Undefined]';
/** Built-in value references. */ var $ccdb19c7f0a62300$var$symToStringTag = (0, $f302ffc9a48734c4$export$2e2bcd8739ae039) ? (0, $f302ffc9a48734c4$export$2e2bcd8739ae039).toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $ccdb19c7f0a62300$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $ccdb19c7f0a62300$var$undefinedTag : $ccdb19c7f0a62300$var$nullTag;
    return $ccdb19c7f0a62300$var$symToStringTag && $ccdb19c7f0a62300$var$symToStringTag in Object(value) ? (0, $59fc01f5e412f819$export$2e2bcd8739ae039)(value) : (0, $94199a1861e07064$export$2e2bcd8739ae039)(value);
}
var $ccdb19c7f0a62300$export$2e2bcd8739ae039 = $ccdb19c7f0a62300$var$baseGetTag;


/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $af254ed7460d123e$var$isObjectLike(value) {
    return value != null && typeof value == 'object';
}
var $af254ed7460d123e$export$2e2bcd8739ae039 = $af254ed7460d123e$var$isObjectLike;


/** `Object#toString` result references. */ var $16b138b0231026b6$var$symbolTag = '[object Symbol]';
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $16b138b0231026b6$var$isSymbol(value) {
    return typeof value == 'symbol' || (0, $af254ed7460d123e$export$2e2bcd8739ae039)(value) && (0, $ccdb19c7f0a62300$export$2e2bcd8739ae039)(value) == $16b138b0231026b6$var$symbolTag;
}
var $16b138b0231026b6$export$2e2bcd8739ae039 = $16b138b0231026b6$var$isSymbol;


/** Used as references for various `Number` constants. */ var $0e87326299eb9bb7$var$NAN = 0 / 0;
/** Used to detect bad signed hexadecimal string values. */ var $0e87326299eb9bb7$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $0e87326299eb9bb7$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $0e87326299eb9bb7$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $0e87326299eb9bb7$var$freeParseInt = parseInt;
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $0e87326299eb9bb7$var$toNumber(value) {
    if (typeof value == 'number') return value;
    if ((0, $16b138b0231026b6$export$2e2bcd8739ae039)(value)) return $0e87326299eb9bb7$var$NAN;
    if ((0, $dd0c70c8150db920$export$2e2bcd8739ae039)(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = (0, $dd0c70c8150db920$export$2e2bcd8739ae039)(other) ? other + '' : other;
    }
    if (typeof value != 'string') return value === 0 ? value : +value;
    value = (0, $66661208b19b5b1b$export$2e2bcd8739ae039)(value);
    var isBinary = $0e87326299eb9bb7$var$reIsBinary.test(value);
    return isBinary || $0e87326299eb9bb7$var$reIsOctal.test(value) ? $0e87326299eb9bb7$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $0e87326299eb9bb7$var$reIsBadHex.test(value) ? $0e87326299eb9bb7$var$NAN : +value;
}
var $0e87326299eb9bb7$export$2e2bcd8739ae039 = $0e87326299eb9bb7$var$toNumber;


/** Error message constants. */ var $a122be60491e8d4a$var$FUNC_ERROR_TEXT = 'Expected a function';
/* Built-in method references for those with the same name as other `lodash` methods. */ var $a122be60491e8d4a$var$nativeMax = Math.max, $a122be60491e8d4a$var$nativeMin = Math.min;
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $a122be60491e8d4a$var$debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != 'function') throw new TypeError($a122be60491e8d4a$var$FUNC_ERROR_TEXT);
    wait = (0, $0e87326299eb9bb7$export$2e2bcd8739ae039)(wait) || 0;
    if ((0, $dd0c70c8150db920$export$2e2bcd8739ae039)(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? $a122be60491e8d4a$var$nativeMax((0, $0e87326299eb9bb7$export$2e2bcd8739ae039)(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
        return maxing ? $a122be60491e8d4a$var$nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = (0, $20c74a585cb2c860$export$2e2bcd8739ae039)();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge((0, $20c74a585cb2c860$export$2e2bcd8739ae039)());
    }
    function debounced() {
        var time = (0, $20c74a585cb2c860$export$2e2bcd8739ae039)(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                clearTimeout(timerId);
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
var $a122be60491e8d4a$export$2e2bcd8739ae039 = $a122be60491e8d4a$var$debounce;


function $752852d7be1532d9$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $752852d7be1532d9$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
function $752852d7be1532d9$var$_classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function $752852d7be1532d9$var$_createClass(e, r, t) {
    return Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
function $752852d7be1532d9$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) ;
            else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $752852d7be1532d9$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $752852d7be1532d9$var$_slicedToArray(r, e) {
    return $752852d7be1532d9$var$_arrayWithHoles(r) || $752852d7be1532d9$var$_iterableToArrayLimit(r, e) || $752852d7be1532d9$var$_unsupportedIterableToArray(r, e) || $752852d7be1532d9$var$_nonIterableRest();
}
function $752852d7be1532d9$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $752852d7be1532d9$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $752852d7be1532d9$var$_arrayLikeToArray(r, a) : void 0;
    }
}
var $752852d7be1532d9$var$Prop = /*#__PURE__*/ $752852d7be1532d9$var$_createClass(function Prop(name, _ref) {
    var _ref$default = _ref["default"], defaultVal = _ref$default === void 0 ? null : _ref$default, _ref$triggerUpdate = _ref.triggerUpdate, triggerUpdate = _ref$triggerUpdate === void 0 ? true : _ref$triggerUpdate, _ref$onChange = _ref.onChange, onChange = _ref$onChange === void 0 ? function(newVal, state) {} : _ref$onChange;
    $752852d7be1532d9$var$_classCallCheck(this, Prop);
    this.name = name;
    this.defaultVal = defaultVal;
    this.triggerUpdate = triggerUpdate;
    this.onChange = onChange;
});
function $752852d7be1532d9$export$2e2bcd8739ae039(_ref2) {
    var _ref2$stateInit = _ref2.stateInit, stateInit = _ref2$stateInit === void 0 ? function() {
        return {};
    } : _ref2$stateInit, _ref2$props = _ref2.props, rawProps = _ref2$props === void 0 ? {} : _ref2$props, _ref2$methods = _ref2.methods, methods = _ref2$methods === void 0 ? {} : _ref2$methods, _ref2$aliases = _ref2.aliases, aliases = _ref2$aliases === void 0 ? {} : _ref2$aliases, _ref2$init = _ref2.init, initFn = _ref2$init === void 0 ? function() {} : _ref2$init, _ref2$update = _ref2.update, updateFn = _ref2$update === void 0 ? function() {} : _ref2$update;
    // Parse props into Prop instances
    var props = Object.keys(rawProps).map(function(propName) {
        return new $752852d7be1532d9$var$Prop(propName, rawProps[propName]);
    });
    return function() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        // Holds component state
        var state = Object.assign({}, stateInit instanceof Function ? stateInit(options) : stateInit, // Support plain objects for backwards compatibility
        {
            initialised: false
        });
        // keeps track of which props triggered an update
        var changedProps = {};
        // Component constructor
        function comp(nodeElement) {
            initStatic(nodeElement, options);
            digest();
            return comp;
        }
        var initStatic = function initStatic(nodeElement, options) {
            initFn.call(comp, nodeElement, state, options);
            state.initialised = true;
        };
        var digest = (0, $a122be60491e8d4a$export$2e2bcd8739ae039)(function() {
            if (!state.initialised) return;
            updateFn.call(comp, state, changedProps);
            changedProps = {};
        }, 1);
        // Getter/setter methods
        props.forEach(function(prop) {
            comp[prop.name] = getSetProp(prop);
            function getSetProp(_ref3) {
                var prop = _ref3.name, _ref3$triggerUpdate = _ref3.triggerUpdate, redigest = _ref3$triggerUpdate === void 0 ? false : _ref3$triggerUpdate, _ref3$onChange = _ref3.onChange, onChange = _ref3$onChange === void 0 ? function(newVal, state) {} : _ref3$onChange, _ref3$defaultVal = _ref3.defaultVal, defaultVal = _ref3$defaultVal === void 0 ? null : _ref3$defaultVal;
                return function(_) {
                    var curVal = state[prop];
                    if (!arguments.length) return curVal;
                     // Getter mode
                    var val = _ === undefined ? defaultVal : _; // pick default if value passed is undefined
                    state[prop] = val;
                    onChange.call(comp, val, state, curVal);
                    // track changed props
                    !changedProps.hasOwnProperty(prop) && (changedProps[prop] = curVal);
                    if (redigest) digest();
                    return comp;
                };
            }
        });
        // Other methods
        Object.keys(methods).forEach(function(methodName) {
            comp[methodName] = function() {
                var _methods$methodName;
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                return (_methods$methodName = methods[methodName]).call.apply(_methods$methodName, [
                    comp,
                    state
                ].concat(args));
            };
        });
        // Link aliases
        Object.entries(aliases).forEach(function(_ref4) {
            var _ref5 = $752852d7be1532d9$var$_slicedToArray(_ref4, 2), alias = _ref5[0], target = _ref5[1];
            return comp[alias] = comp[target];
        });
        // Reset all component props to their default value
        comp.resetProps = function() {
            props.forEach(function(prop) {
                comp[prop.name](prop.defaultVal);
            });
            return comp;
        };
        //
        comp.resetProps(); // Apply all prop defaults
        state._rerender = digest; // Expose digest method
        return comp;
    };
}


var $85d8080a057d7be2$export$2e2bcd8739ae039 = function(p) {
    return typeof p === 'function' ? p // fn
     : typeof p === 'string' ? function(obj) {
        return obj[p];
    } // property name
     : function(obj) {
        return p;
    };
}; // constant


function $5a964dca3df4eea7$export$2e2bcd8739ae039(values, valueof) {
    let max;
    if (valueof === undefined) {
        for (const value of values)if (value != null && (max < value || max === undefined && value >= value)) max = value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (max < value || max === undefined && value >= value)) max = value;
    }
    return max;
}

function $02ed355deaa9e190$export$2e2bcd8739ae039(values, valueof) {
    let min;
    if (valueof === undefined) {
        for (const value of values)if (value != null && (min > value || min === undefined && value >= value)) min = value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (min > value || min === undefined && value >= value)) min = value;
    }
    return min;
}


function $831c89c8e21b629b$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $831c89c8e21b629b$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
function $831c89c8e21b629b$var$_arrayWithoutHoles(r) {
    if (Array.isArray(r)) return $831c89c8e21b629b$var$_arrayLikeToArray(r);
}
function $831c89c8e21b629b$var$_iterableToArray(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function $831c89c8e21b629b$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) ;
            else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $831c89c8e21b629b$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $831c89c8e21b629b$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $831c89c8e21b629b$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $831c89c8e21b629b$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var s = Object.getOwnPropertySymbols(e);
        for(r = 0; r < s.length; r++)o = s[r], t.includes(o) || ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $831c89c8e21b629b$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.includes(n)) continue;
        t[n] = r[n];
    }
    return t;
}
function $831c89c8e21b629b$var$_slicedToArray(r, e) {
    return $831c89c8e21b629b$var$_arrayWithHoles(r) || $831c89c8e21b629b$var$_iterableToArrayLimit(r, e) || $831c89c8e21b629b$var$_unsupportedIterableToArray(r, e) || $831c89c8e21b629b$var$_nonIterableRest();
}
function $831c89c8e21b629b$var$_toConsumableArray(r) {
    return $831c89c8e21b629b$var$_arrayWithoutHoles(r) || $831c89c8e21b629b$var$_iterableToArray(r) || $831c89c8e21b629b$var$_unsupportedIterableToArray(r) || $831c89c8e21b629b$var$_nonIterableSpread();
}
function $831c89c8e21b629b$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r);
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return String(t);
}
function $831c89c8e21b629b$var$_toPropertyKey(t) {
    var i = $831c89c8e21b629b$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $831c89c8e21b629b$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $831c89c8e21b629b$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $831c89c8e21b629b$var$_arrayLikeToArray(r, a) : void 0;
    }
}
var $831c89c8e21b629b$export$2e2bcd8739ae039 = function() {
    var list = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var keyAccessors = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var multiItem = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    var flattenKeys = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    var keys = (keyAccessors instanceof Array ? keyAccessors.length ? keyAccessors : [
        undefined
    ] : [
        keyAccessors
    ]).map(function(key) {
        return {
            keyAccessor: key,
            isProp: !(key instanceof Function)
        };
    });
    var indexedResult = list.reduce(function(res, item) {
        var iterObj = res;
        var itemVal = item;
        keys.forEach(function(_ref, idx) {
            var keyAccessor = _ref.keyAccessor, isProp = _ref.isProp;
            var key;
            if (isProp) {
                var _itemVal = itemVal, propVal = _itemVal[keyAccessor], rest = $831c89c8e21b629b$var$_objectWithoutProperties(_itemVal, [
                    keyAccessor
                ].map($831c89c8e21b629b$var$_toPropertyKey));
                key = propVal;
                itemVal = rest;
            } else key = keyAccessor(itemVal, idx);
            if (idx + 1 < keys.length) {
                if (!iterObj.hasOwnProperty(key)) iterObj[key] = {};
                iterObj = iterObj[key];
            } else // Leaf key
            if (multiItem) {
                if (!iterObj.hasOwnProperty(key)) iterObj[key] = [];
                iterObj[key].push(itemVal);
            } else iterObj[key] = itemVal;
        });
        return res;
    }, {});
    if (multiItem instanceof Function) // Reduce leaf multiple values
    (function reduce(node) {
        var level = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
        if (level === keys.length) Object.keys(node).forEach(function(k) {
            return node[k] = multiItem(node[k]);
        });
        else Object.values(node).forEach(function(child) {
            return reduce(child, level + 1);
        });
    })(indexedResult); // IIFE
    var result = indexedResult;
    if (flattenKeys) {
        // flatten into array
        result = [];
        (function flatten(node) {
            var accKeys = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
            if (accKeys.length === keys.length) result.push({
                keys: accKeys,
                vals: node
            });
            else Object.entries(node).forEach(function(_ref2) {
                var _ref3 = $831c89c8e21b629b$var$_slicedToArray(_ref2, 2), key = _ref3[0], val = _ref3[1];
                return flatten(val, [].concat($831c89c8e21b629b$var$_toConsumableArray(accKeys), [
                    key
                ]));
            });
        })(indexedResult); //IIFE
        if (keyAccessors instanceof Array && keyAccessors.length === 0 && result.length === 1) // clear keys if there's no key accessors (single result)
        result[0].keys = [];
    }
    return result;
};


function $0e2a28a99595988d$var$_iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
        var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
        try {
            if (_x = (_i = _i.call(arr)).next, 0 === i) {
                if (Object(_i) !== _i) return;
                _n = !1;
            } else for(; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
        } catch (err) {
            _d = !0, _e = err;
        } finally{
            try {
                if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
}
function $0e2a28a99595988d$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $0e2a28a99595988d$var$_objectSpread2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $0e2a28a99595988d$var$ownKeys(Object(source), !0).forEach(function(key) {
            $0e2a28a99595988d$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $0e2a28a99595988d$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $0e2a28a99595988d$var$_defineProperty(obj, key, value) {
    key = $0e2a28a99595988d$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $0e2a28a99595988d$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $0e2a28a99595988d$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $0e2a28a99595988d$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $0e2a28a99595988d$var$_slicedToArray(arr, i) {
    return $0e2a28a99595988d$var$_arrayWithHoles(arr) || $0e2a28a99595988d$var$_iterableToArrayLimit(arr, i) || $0e2a28a99595988d$var$_unsupportedIterableToArray(arr, i) || $0e2a28a99595988d$var$_nonIterableRest();
}
function $0e2a28a99595988d$var$_toConsumableArray(arr) {
    return $0e2a28a99595988d$var$_arrayWithoutHoles(arr) || $0e2a28a99595988d$var$_iterableToArray(arr) || $0e2a28a99595988d$var$_unsupportedIterableToArray(arr) || $0e2a28a99595988d$var$_nonIterableSpread();
}
function $0e2a28a99595988d$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $0e2a28a99595988d$var$_arrayLikeToArray(arr);
}
function $0e2a28a99595988d$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $0e2a28a99595988d$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $0e2a28a99595988d$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $0e2a28a99595988d$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $0e2a28a99595988d$var$_arrayLikeToArray(o, minLen);
}
function $0e2a28a99595988d$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $0e2a28a99595988d$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $0e2a28a99595988d$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $0e2a28a99595988d$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $0e2a28a99595988d$var$_toPropertyKey(arg) {
    var key = $0e2a28a99595988d$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
var $0e2a28a99595988d$var$_excluded = [
    "createObj",
    "updateObj",
    "exitObj",
    "objBindAttr",
    "dataBindAttr"
];
function $0e2a28a99595988d$var$diffArrays(prev, next, idAccessor) {
    var result = {
        enter: [],
        update: [],
        exit: []
    };
    if (!idAccessor) {
        // use object references for comparison
        var prevSet = new Set(prev);
        var nextSet = new Set(next);
        new Set([].concat($0e2a28a99595988d$var$_toConsumableArray(prevSet), $0e2a28a99595988d$var$_toConsumableArray(nextSet))).forEach(function(item) {
            var type = !prevSet.has(item) ? 'enter' : !nextSet.has(item) ? 'exit' : 'update';
            result[type].push(type === 'update' ? [
                item,
                item
            ] : item);
        });
    } else {
        // compare by id (duplicate keys are ignored)
        var prevById = (0, $831c89c8e21b629b$export$2e2bcd8739ae039)(prev, idAccessor, false);
        var nextById = (0, $831c89c8e21b629b$export$2e2bcd8739ae039)(next, idAccessor, false);
        var byId = Object.assign({}, prevById, nextById);
        Object.entries(byId).forEach(function(_ref) {
            var _ref2 = $0e2a28a99595988d$var$_slicedToArray(_ref, 2), id = _ref2[0], item = _ref2[1];
            var type = !prevById.hasOwnProperty(id) ? 'enter' : !nextById.hasOwnProperty(id) ? 'exit' : 'update';
            result[type].push(type === 'update' ? [
                prevById[id],
                nextById[id]
            ] : item);
        });
    }
    return result;
}
function $0e2a28a99595988d$var$dataBindDiff(data, existingObjs, _ref3) {
    var _ref3$objBindAttr = _ref3.objBindAttr, objBindAttr = _ref3$objBindAttr === void 0 ? '__obj' : _ref3$objBindAttr, _ref3$dataBindAttr = _ref3.dataBindAttr, dataBindAttr = _ref3$dataBindAttr === void 0 ? '__data' : _ref3$dataBindAttr, idAccessor = _ref3.idAccessor, _ref3$purge = _ref3.purge, purge = _ref3$purge === void 0 ? false : _ref3$purge;
    var isObjValid = function isObjValid(obj) {
        return obj.hasOwnProperty(dataBindAttr);
    };
    var removeObjs = existingObjs.filter(function(obj) {
        return !isObjValid(obj);
    });
    var prevD = existingObjs.filter(isObjValid).map(function(obj) {
        return obj[dataBindAttr];
    });
    var nextD = data;
    var diff = purge ? {
        enter: nextD,
        exit: prevD,
        update: []
    } // don't diff data in purge mode
     : $0e2a28a99595988d$var$diffArrays(prevD, nextD, idAccessor);
    diff.update = diff.update.map(function(_ref4) {
        var _ref5 = $0e2a28a99595988d$var$_slicedToArray(_ref4, 2), prevD = _ref5[0], nextD = _ref5[1];
        if (prevD !== nextD) {
            // transfer obj to new data point (if different)
            nextD[objBindAttr] = prevD[objBindAttr];
            nextD[objBindAttr][dataBindAttr] = nextD;
        }
        return nextD;
    });
    diff.exit = diff.exit.concat(removeObjs.map(function(obj) {
        return $0e2a28a99595988d$var$_defineProperty({}, objBindAttr, obj);
    }));
    return diff;
}
function $0e2a28a99595988d$export$2e2bcd8739ae039(data, existingObjs, // list
appendObj, // item => {...} function
removeObj, _ref7) {
    var _ref7$createObj = _ref7.createObj, createObj = _ref7$createObj === void 0 ? function(d) {
        return {};
    } : _ref7$createObj, _ref7$updateObj = _ref7.updateObj, updateObj = _ref7$updateObj === void 0 ? function(obj, d) {} : _ref7$updateObj, _ref7$exitObj = _ref7.exitObj, exitObj = _ref7$exitObj === void 0 ? function(obj) {} : _ref7$exitObj, _ref7$objBindAttr = _ref7.objBindAttr, objBindAttr = _ref7$objBindAttr === void 0 ? '__obj' : _ref7$objBindAttr, _ref7$dataBindAttr = _ref7.dataBindAttr, dataBindAttr = _ref7$dataBindAttr === void 0 ? '__data' : _ref7$dataBindAttr, dataDiffOptions = $0e2a28a99595988d$var$_objectWithoutProperties(_ref7, $0e2a28a99595988d$var$_excluded);
    var _dataBindDiff = $0e2a28a99595988d$var$dataBindDiff(data, existingObjs, $0e2a28a99595988d$var$_objectSpread2({
        objBindAttr: objBindAttr,
        dataBindAttr: dataBindAttr
    }, dataDiffOptions)), enter = _dataBindDiff.enter, update = _dataBindDiff.update, exit = _dataBindDiff.exit;
    // Remove exiting points
    exit.forEach(function(d) {
        var obj = d[objBindAttr];
        delete d[objBindAttr]; // unbind obj
        exitObj(obj);
        removeObj(obj);
    });
    var newObjs = createObjs(enter);
    var pointsData = [].concat($0e2a28a99595988d$var$_toConsumableArray(enter), $0e2a28a99595988d$var$_toConsumableArray(update));
    updateObjs(pointsData);
    // Add new points
    newObjs.forEach(appendObj);
    //
    function createObjs(data) {
        var newObjs = [];
        data.forEach(function(d) {
            var obj = createObj(d);
            if (obj) {
                obj[dataBindAttr] = d;
                d[objBindAttr] = obj;
                newObjs.push(obj);
            }
        });
        return newObjs;
    }
    function updateObjs(data) {
        data.forEach(function(d) {
            var obj = d[objBindAttr];
            if (obj) {
                obj[dataBindAttr] = d;
                updateObj(obj, d);
            }
        });
    }
}


class $3160658555deb5c9$export$dcc6fb7d82b5bc7b extends Map {
    constructor(entries, key = $3160658555deb5c9$var$keyof){
        super();
        Object.defineProperties(this, {
            _intern: {
                value: new Map()
            },
            _key: {
                value: key
            }
        });
        if (entries != null) for (const [key, value] of entries)this.set(key, value);
    }
    get(key) {
        return super.get($3160658555deb5c9$var$intern_get(this, key));
    }
    has(key) {
        return super.has($3160658555deb5c9$var$intern_get(this, key));
    }
    set(key, value) {
        return super.set($3160658555deb5c9$var$intern_set(this, key), value);
    }
    delete(key) {
        return super.delete($3160658555deb5c9$var$intern_delete(this, key));
    }
}
class $3160658555deb5c9$export$55278c3294239828 extends Set {
    constructor(values, key = $3160658555deb5c9$var$keyof){
        super();
        Object.defineProperties(this, {
            _intern: {
                value: new Map()
            },
            _key: {
                value: key
            }
        });
        if (values != null) for (const value of values)this.add(value);
    }
    has(value) {
        return super.has($3160658555deb5c9$var$intern_get(this, value));
    }
    add(value) {
        return super.add($3160658555deb5c9$var$intern_set(this, value));
    }
    delete(value) {
        return super.delete($3160658555deb5c9$var$intern_delete(this, value));
    }
}
function $3160658555deb5c9$var$intern_get({ _intern: _intern, _key: _key }, value) {
    const key = _key(value);
    return _intern.has(key) ? _intern.get(key) : value;
}
function $3160658555deb5c9$var$intern_set({ _intern: _intern, _key: _key }, value) {
    const key = _key(value);
    if (_intern.has(key)) return _intern.get(key);
    _intern.set(key, value);
    return value;
}
function $3160658555deb5c9$var$intern_delete({ _intern: _intern, _key: _key }, value) {
    const key = _key(value);
    if (_intern.has(key)) {
        value = _intern.get(key);
        _intern.delete(key);
    }
    return value;
}
function $3160658555deb5c9$var$keyof(value) {
    return value !== null && typeof value === "object" ? value.valueOf() : value;
}


function $5b694e64f5326630$export$23c7bb9e6558da2a(domain, range) {
    switch(arguments.length){
        case 0:
            break;
        case 1:
            this.range(domain);
            break;
        default:
            this.range(range).domain(domain);
            break;
    }
    return this;
}
function $5b694e64f5326630$export$7d6b419e59e83f3d(domain, interpolator) {
    switch(arguments.length){
        case 0:
            break;
        case 1:
            if (typeof domain === "function") this.interpolator(domain);
            else this.range(domain);
            break;
        default:
            this.domain(domain);
            if (typeof interpolator === "function") this.interpolator(interpolator);
            else this.range(interpolator);
            break;
    }
    return this;
}


const $38404d762c7ac827$export$e4f898ab14d9d460 = Symbol("implicit");
function $38404d762c7ac827$export$2e2bcd8739ae039() {
    var index = new (0, $3160658555deb5c9$export$dcc6fb7d82b5bc7b)(), domain = [], range = [], unknown = $38404d762c7ac827$export$e4f898ab14d9d460;
    function scale(d) {
        let i = index.get(d);
        if (i === undefined) {
            if (unknown !== $38404d762c7ac827$export$e4f898ab14d9d460) return unknown;
            index.set(d, i = domain.push(d) - 1);
        }
        return range[i % range.length];
    }
    scale.domain = function(_) {
        if (!arguments.length) return domain.slice();
        domain = [], index = new (0, $3160658555deb5c9$export$dcc6fb7d82b5bc7b)();
        for (const value of _){
            if (index.has(value)) continue;
            index.set(value, domain.push(value) - 1);
        }
        return scale;
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), scale) : range.slice();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return $38404d762c7ac827$export$2e2bcd8739ae039(domain, range).unknown(unknown);
    };
    (0, $5b694e64f5326630$export$23c7bb9e6558da2a).apply(scale, arguments);
    return scale;
}


function $fe769d98421e6dac$export$2e2bcd8739ae039(specifier) {
    var n = specifier.length / 6 | 0, colors = new Array(n), i = 0;
    while(i < n)colors[i] = "#" + specifier.slice(i * 6, ++i * 6);
    return colors;
}


var $892d66d4b4370fa9$export$2e2bcd8739ae039 = (0, $fe769d98421e6dac$export$2e2bcd8739ae039)("a6cee31f78b4b2df8a33a02cfb9a99e31a1cfdbf6fff7f00cab2d66a3d9affff99b15928");


var $11df18e2f038bad8$exports = {};
// This file is autogenerated. It's used to publish CJS to npm.
(function(global, factory) {
    $11df18e2f038bad8$exports = factory();
})($11df18e2f038bad8$exports, function() {
    'use strict';
    function _typeof(obj) {
        "@babel/helpers - typeof";
        return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
            return typeof obj;
        } : function(obj) {
            return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        }, _typeof(obj);
    }
    // https://github.com/bgrins/TinyColor
    // Brian Grinstead, MIT License
    var trimLeft = /^\s+/;
    var trimRight = /\s+$/;
    function tinycolor(color, opts) {
        color = color ? color : "";
        opts = opts || {};
        // If input is already a tinycolor, return itself
        if (color instanceof tinycolor) return color;
        // If we are called as a function, call using new instead
        if (!(this instanceof tinycolor)) return new tinycolor(color, opts);
        var rgb = inputToRGB(color);
        this._originalInput = color, this._r = rgb.r, this._g = rgb.g, this._b = rgb.b, this._a = rgb.a, this._roundA = Math.round(100 * this._a) / 100, this._format = opts.format || rgb.format;
        this._gradientType = opts.gradientType;
        // Don't let the range of [0,255] come back in [0,1].
        // Potentially lose a little bit of precision here, but will fix issues where
        // .5 gets interpreted as half of the total, instead of half of 1
        // If it was supposed to be 128, this was already taken care of by `inputToRgb`
        if (this._r < 1) this._r = Math.round(this._r);
        if (this._g < 1) this._g = Math.round(this._g);
        if (this._b < 1) this._b = Math.round(this._b);
        this._ok = rgb.ok;
    }
    tinycolor.prototype = {
        isDark: function isDark() {
            return this.getBrightness() < 128;
        },
        isLight: function isLight() {
            return !this.isDark();
        },
        isValid: function isValid() {
            return this._ok;
        },
        getOriginalInput: function getOriginalInput() {
            return this._originalInput;
        },
        getFormat: function getFormat() {
            return this._format;
        },
        getAlpha: function getAlpha() {
            return this._a;
        },
        getBrightness: function getBrightness() {
            //http://www.w3.org/TR/AERT#color-contrast
            var rgb = this.toRgb();
            return (rgb.r * 299 + rgb.g * 587 + rgb.b * 114) / 1000;
        },
        getLuminance: function getLuminance() {
            //http://www.w3.org/TR/2008/REC-WCAG20-20081211/#relativeluminancedef
            var rgb = this.toRgb();
            var RsRGB, GsRGB, BsRGB, R, G, B;
            RsRGB = rgb.r / 255;
            GsRGB = rgb.g / 255;
            BsRGB = rgb.b / 255;
            if (RsRGB <= 0.03928) R = RsRGB / 12.92;
            else R = Math.pow((RsRGB + 0.055) / 1.055, 2.4);
            if (GsRGB <= 0.03928) G = GsRGB / 12.92;
            else G = Math.pow((GsRGB + 0.055) / 1.055, 2.4);
            if (BsRGB <= 0.03928) B = BsRGB / 12.92;
            else B = Math.pow((BsRGB + 0.055) / 1.055, 2.4);
            return 0.2126 * R + 0.7152 * G + 0.0722 * B;
        },
        setAlpha: function setAlpha(value) {
            this._a = boundAlpha(value);
            this._roundA = Math.round(100 * this._a) / 100;
            return this;
        },
        toHsv: function toHsv() {
            var hsv = rgbToHsv(this._r, this._g, this._b);
            return {
                h: hsv.h * 360,
                s: hsv.s,
                v: hsv.v,
                a: this._a
            };
        },
        toHsvString: function toHsvString() {
            var hsv = rgbToHsv(this._r, this._g, this._b);
            var h = Math.round(hsv.h * 360), s = Math.round(hsv.s * 100), v = Math.round(hsv.v * 100);
            return this._a == 1 ? "hsv(" + h + ", " + s + "%, " + v + "%)" : "hsva(" + h + ", " + s + "%, " + v + "%, " + this._roundA + ")";
        },
        toHsl: function toHsl() {
            var hsl = rgbToHsl(this._r, this._g, this._b);
            return {
                h: hsl.h * 360,
                s: hsl.s,
                l: hsl.l,
                a: this._a
            };
        },
        toHslString: function toHslString() {
            var hsl = rgbToHsl(this._r, this._g, this._b);
            var h = Math.round(hsl.h * 360), s = Math.round(hsl.s * 100), l = Math.round(hsl.l * 100);
            return this._a == 1 ? "hsl(" + h + ", " + s + "%, " + l + "%)" : "hsla(" + h + ", " + s + "%, " + l + "%, " + this._roundA + ")";
        },
        toHex: function toHex(allow3Char) {
            return rgbToHex(this._r, this._g, this._b, allow3Char);
        },
        toHexString: function toHexString(allow3Char) {
            return "#" + this.toHex(allow3Char);
        },
        toHex8: function toHex8(allow4Char) {
            return rgbaToHex(this._r, this._g, this._b, this._a, allow4Char);
        },
        toHex8String: function toHex8String(allow4Char) {
            return "#" + this.toHex8(allow4Char);
        },
        toRgb: function toRgb() {
            return {
                r: Math.round(this._r),
                g: Math.round(this._g),
                b: Math.round(this._b),
                a: this._a
            };
        },
        toRgbString: function toRgbString() {
            return this._a == 1 ? "rgb(" + Math.round(this._r) + ", " + Math.round(this._g) + ", " + Math.round(this._b) + ")" : "rgba(" + Math.round(this._r) + ", " + Math.round(this._g) + ", " + Math.round(this._b) + ", " + this._roundA + ")";
        },
        toPercentageRgb: function toPercentageRgb() {
            return {
                r: Math.round(bound01(this._r, 255) * 100) + "%",
                g: Math.round(bound01(this._g, 255) * 100) + "%",
                b: Math.round(bound01(this._b, 255) * 100) + "%",
                a: this._a
            };
        },
        toPercentageRgbString: function toPercentageRgbString() {
            return this._a == 1 ? "rgb(" + Math.round(bound01(this._r, 255) * 100) + "%, " + Math.round(bound01(this._g, 255) * 100) + "%, " + Math.round(bound01(this._b, 255) * 100) + "%)" : "rgba(" + Math.round(bound01(this._r, 255) * 100) + "%, " + Math.round(bound01(this._g, 255) * 100) + "%, " + Math.round(bound01(this._b, 255) * 100) + "%, " + this._roundA + ")";
        },
        toName: function toName() {
            if (this._a === 0) return "transparent";
            if (this._a < 1) return false;
            return hexNames[rgbToHex(this._r, this._g, this._b, true)] || false;
        },
        toFilter: function toFilter(secondColor) {
            var hex8String = "#" + rgbaToArgbHex(this._r, this._g, this._b, this._a);
            var secondHex8String = hex8String;
            var gradientType = this._gradientType ? "GradientType = 1, " : "";
            if (secondColor) {
                var s = tinycolor(secondColor);
                secondHex8String = "#" + rgbaToArgbHex(s._r, s._g, s._b, s._a);
            }
            return "progid:DXImageTransform.Microsoft.gradient(" + gradientType + "startColorstr=" + hex8String + ",endColorstr=" + secondHex8String + ")";
        },
        toString: function toString(format) {
            var formatSet = !!format;
            format = format || this._format;
            var formattedString = false;
            var hasAlpha = this._a < 1 && this._a >= 0;
            var needsAlphaFormat = !formatSet && hasAlpha && (format === "hex" || format === "hex6" || format === "hex3" || format === "hex4" || format === "hex8" || format === "name");
            if (needsAlphaFormat) {
                // Special case for "transparent", all other non-alpha formats
                // will return rgba when there is transparency.
                if (format === "name" && this._a === 0) return this.toName();
                return this.toRgbString();
            }
            if (format === "rgb") formattedString = this.toRgbString();
            if (format === "prgb") formattedString = this.toPercentageRgbString();
            if (format === "hex" || format === "hex6") formattedString = this.toHexString();
            if (format === "hex3") formattedString = this.toHexString(true);
            if (format === "hex4") formattedString = this.toHex8String(true);
            if (format === "hex8") formattedString = this.toHex8String();
            if (format === "name") formattedString = this.toName();
            if (format === "hsl") formattedString = this.toHslString();
            if (format === "hsv") formattedString = this.toHsvString();
            return formattedString || this.toHexString();
        },
        clone: function clone() {
            return tinycolor(this.toString());
        },
        _applyModification: function _applyModification(fn, args) {
            var color = fn.apply(null, [
                this
            ].concat([].slice.call(args)));
            this._r = color._r;
            this._g = color._g;
            this._b = color._b;
            this.setAlpha(color._a);
            return this;
        },
        lighten: function lighten() {
            return this._applyModification(_lighten, arguments);
        },
        brighten: function brighten() {
            return this._applyModification(_brighten, arguments);
        },
        darken: function darken() {
            return this._applyModification(_darken, arguments);
        },
        desaturate: function desaturate() {
            return this._applyModification(_desaturate, arguments);
        },
        saturate: function saturate() {
            return this._applyModification(_saturate, arguments);
        },
        greyscale: function greyscale() {
            return this._applyModification(_greyscale, arguments);
        },
        spin: function spin() {
            return this._applyModification(_spin, arguments);
        },
        _applyCombination: function _applyCombination(fn, args) {
            return fn.apply(null, [
                this
            ].concat([].slice.call(args)));
        },
        analogous: function analogous() {
            return this._applyCombination(_analogous, arguments);
        },
        complement: function complement() {
            return this._applyCombination(_complement, arguments);
        },
        monochromatic: function monochromatic() {
            return this._applyCombination(_monochromatic, arguments);
        },
        splitcomplement: function splitcomplement() {
            return this._applyCombination(_splitcomplement, arguments);
        },
        // Disabled until https://github.com/bgrins/TinyColor/issues/254
        // polyad: function (number) {
        //   return this._applyCombination(polyad, [number]);
        // },
        triad: function triad() {
            return this._applyCombination(polyad, [
                3
            ]);
        },
        tetrad: function tetrad() {
            return this._applyCombination(polyad, [
                4
            ]);
        }
    };
    // If input is an object, force 1 into "1.0" to handle ratios properly
    // String input requires "1.0" as input, so 1 will be treated as 1
    tinycolor.fromRatio = function(color, opts) {
        if (_typeof(color) == "object") {
            var newColor = {};
            for(var i in color)if (color.hasOwnProperty(i)) {
                if (i === "a") newColor[i] = color[i];
                else newColor[i] = convertToPercentage(color[i]);
            }
            color = newColor;
        }
        return tinycolor(color, opts);
    };
    // Given a string or object, convert that input to RGB
    // Possible string inputs:
    //
    //     "red"
    //     "#f00" or "f00"
    //     "#ff0000" or "ff0000"
    //     "#ff000000" or "ff000000"
    //     "rgb 255 0 0" or "rgb (255, 0, 0)"
    //     "rgb 1.0 0 0" or "rgb (1, 0, 0)"
    //     "rgba (255, 0, 0, 1)" or "rgba 255, 0, 0, 1"
    //     "rgba (1.0, 0, 0, 1)" or "rgba 1.0, 0, 0, 1"
    //     "hsl(0, 100%, 50%)" or "hsl 0 100% 50%"
    //     "hsla(0, 100%, 50%, 1)" or "hsla 0 100% 50%, 1"
    //     "hsv(0, 100%, 100%)" or "hsv 0 100% 100%"
    //
    function inputToRGB(color) {
        var rgb = {
            r: 0,
            g: 0,
            b: 0
        };
        var a = 1;
        var s = null;
        var v = null;
        var l = null;
        var ok = false;
        var format = false;
        if (typeof color == "string") color = stringInputToObject(color);
        if (_typeof(color) == "object") {
            if (isValidCSSUnit(color.r) && isValidCSSUnit(color.g) && isValidCSSUnit(color.b)) {
                rgb = rgbToRgb(color.r, color.g, color.b);
                ok = true;
                format = String(color.r).substr(-1) === "%" ? "prgb" : "rgb";
            } else if (isValidCSSUnit(color.h) && isValidCSSUnit(color.s) && isValidCSSUnit(color.v)) {
                s = convertToPercentage(color.s);
                v = convertToPercentage(color.v);
                rgb = hsvToRgb(color.h, s, v);
                ok = true;
                format = "hsv";
            } else if (isValidCSSUnit(color.h) && isValidCSSUnit(color.s) && isValidCSSUnit(color.l)) {
                s = convertToPercentage(color.s);
                l = convertToPercentage(color.l);
                rgb = hslToRgb(color.h, s, l);
                ok = true;
                format = "hsl";
            }
            if (color.hasOwnProperty("a")) a = color.a;
        }
        a = boundAlpha(a);
        return {
            ok: ok,
            format: color.format || format,
            r: Math.min(255, Math.max(rgb.r, 0)),
            g: Math.min(255, Math.max(rgb.g, 0)),
            b: Math.min(255, Math.max(rgb.b, 0)),
            a: a
        };
    }
    // Conversion Functions
    // --------------------
    // `rgbToHsl`, `rgbToHsv`, `hslToRgb`, `hsvToRgb` modified from:
    // <http://mjijackson.com/2008/02/rgb-to-hsl-and-rgb-to-hsv-color-model-conversion-algorithms-in-javascript>
    // `rgbToRgb`
    // Handle bounds / percentage checking to conform to CSS color spec
    // <http://www.w3.org/TR/css3-color/>
    // *Assumes:* r, g, b in [0, 255] or [0, 1]
    // *Returns:* { r, g, b } in [0, 255]
    function rgbToRgb(r, g, b) {
        return {
            r: bound01(r, 255) * 255,
            g: bound01(g, 255) * 255,
            b: bound01(b, 255) * 255
        };
    }
    // `rgbToHsl`
    // Converts an RGB color value to HSL.
    // *Assumes:* r, g, and b are contained in [0, 255] or [0, 1]
    // *Returns:* { h, s, l } in [0,1]
    function rgbToHsl(r, g, b) {
        r = bound01(r, 255);
        g = bound01(g, 255);
        b = bound01(b, 255);
        var max = Math.max(r, g, b), min = Math.min(r, g, b);
        var h, s, l = (max + min) / 2;
        if (max == min) h = s = 0; // achromatic
        else {
            var d = max - min;
            s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
            switch(max){
                case r:
                    h = (g - b) / d + (g < b ? 6 : 0);
                    break;
                case g:
                    h = (b - r) / d + 2;
                    break;
                case b:
                    h = (r - g) / d + 4;
                    break;
            }
            h /= 6;
        }
        return {
            h: h,
            s: s,
            l: l
        };
    }
    // `hslToRgb`
    // Converts an HSL color value to RGB.
    // *Assumes:* h is contained in [0, 1] or [0, 360] and s and l are contained [0, 1] or [0, 100]
    // *Returns:* { r, g, b } in the set [0, 255]
    function hslToRgb(h, s, l) {
        var r, g, b;
        h = bound01(h, 360);
        s = bound01(s, 100);
        l = bound01(l, 100);
        function hue2rgb(p, q, t) {
            if (t < 0) t += 1;
            if (t > 1) t -= 1;
            if (t < 1 / 6) return p + (q - p) * 6 * t;
            if (t < 0.5) return q;
            if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
            return p;
        }
        if (s === 0) r = g = b = l; // achromatic
        else {
            var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
            var p = 2 * l - q;
            r = hue2rgb(p, q, h + 1 / 3);
            g = hue2rgb(p, q, h);
            b = hue2rgb(p, q, h - 1 / 3);
        }
        return {
            r: r * 255,
            g: g * 255,
            b: b * 255
        };
    }
    // `rgbToHsv`
    // Converts an RGB color value to HSV
    // *Assumes:* r, g, and b are contained in the set [0, 255] or [0, 1]
    // *Returns:* { h, s, v } in [0,1]
    function rgbToHsv(r, g, b) {
        r = bound01(r, 255);
        g = bound01(g, 255);
        b = bound01(b, 255);
        var max = Math.max(r, g, b), min = Math.min(r, g, b);
        var h, s, v = max;
        var d = max - min;
        s = max === 0 ? 0 : d / max;
        if (max == min) h = 0; // achromatic
        else {
            switch(max){
                case r:
                    h = (g - b) / d + (g < b ? 6 : 0);
                    break;
                case g:
                    h = (b - r) / d + 2;
                    break;
                case b:
                    h = (r - g) / d + 4;
                    break;
            }
            h /= 6;
        }
        return {
            h: h,
            s: s,
            v: v
        };
    }
    // `hsvToRgb`
    // Converts an HSV color value to RGB.
    // *Assumes:* h is contained in [0, 1] or [0, 360] and s and v are contained in [0, 1] or [0, 100]
    // *Returns:* { r, g, b } in the set [0, 255]
    function hsvToRgb(h, s, v) {
        h = bound01(h, 360) * 6;
        s = bound01(s, 100);
        v = bound01(v, 100);
        var i = Math.floor(h), f = h - i, p = v * (1 - s), q = v * (1 - f * s), t = v * (1 - (1 - f) * s), mod = i % 6, r = [
            v,
            q,
            p,
            p,
            t,
            v
        ][mod], g = [
            t,
            v,
            v,
            q,
            p,
            p
        ][mod], b = [
            p,
            p,
            t,
            v,
            v,
            q
        ][mod];
        return {
            r: r * 255,
            g: g * 255,
            b: b * 255
        };
    }
    // `rgbToHex`
    // Converts an RGB color to hex
    // Assumes r, g, and b are contained in the set [0, 255]
    // Returns a 3 or 6 character hex
    function rgbToHex(r, g, b, allow3Char) {
        var hex = [
            pad2(Math.round(r).toString(16)),
            pad2(Math.round(g).toString(16)),
            pad2(Math.round(b).toString(16))
        ];
        // Return a 3 character hex if possible
        if (allow3Char && hex[0].charAt(0) == hex[0].charAt(1) && hex[1].charAt(0) == hex[1].charAt(1) && hex[2].charAt(0) == hex[2].charAt(1)) return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0);
        return hex.join("");
    }
    // `rgbaToHex`
    // Converts an RGBA color plus alpha transparency to hex
    // Assumes r, g, b are contained in the set [0, 255] and
    // a in [0, 1]. Returns a 4 or 8 character rgba hex
    function rgbaToHex(r, g, b, a, allow4Char) {
        var hex = [
            pad2(Math.round(r).toString(16)),
            pad2(Math.round(g).toString(16)),
            pad2(Math.round(b).toString(16)),
            pad2(convertDecimalToHex(a))
        ];
        // Return a 4 character hex if possible
        if (allow4Char && hex[0].charAt(0) == hex[0].charAt(1) && hex[1].charAt(0) == hex[1].charAt(1) && hex[2].charAt(0) == hex[2].charAt(1) && hex[3].charAt(0) == hex[3].charAt(1)) return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0) + hex[3].charAt(0);
        return hex.join("");
    }
    // `rgbaToArgbHex`
    // Converts an RGBA color to an ARGB Hex8 string
    // Rarely used, but required for "toFilter()"
    function rgbaToArgbHex(r, g, b, a) {
        var hex = [
            pad2(convertDecimalToHex(a)),
            pad2(Math.round(r).toString(16)),
            pad2(Math.round(g).toString(16)),
            pad2(Math.round(b).toString(16))
        ];
        return hex.join("");
    }
    // `equals`
    // Can be called with any tinycolor input
    tinycolor.equals = function(color1, color2) {
        if (!color1 || !color2) return false;
        return tinycolor(color1).toRgbString() == tinycolor(color2).toRgbString();
    };
    tinycolor.random = function() {
        return tinycolor.fromRatio({
            r: Math.random(),
            g: Math.random(),
            b: Math.random()
        });
    };
    // Modification Functions
    // ----------------------
    // Thanks to less.js for some of the basics here
    // <https://github.com/cloudhead/less.js/blob/master/lib/less/functions.js>
    function _desaturate(color, amount) {
        amount = amount === 0 ? 0 : amount || 10;
        var hsl = tinycolor(color).toHsl();
        hsl.s -= amount / 100;
        hsl.s = clamp01(hsl.s);
        return tinycolor(hsl);
    }
    function _saturate(color, amount) {
        amount = amount === 0 ? 0 : amount || 10;
        var hsl = tinycolor(color).toHsl();
        hsl.s += amount / 100;
        hsl.s = clamp01(hsl.s);
        return tinycolor(hsl);
    }
    function _greyscale(color) {
        return tinycolor(color).desaturate(100);
    }
    function _lighten(color, amount) {
        amount = amount === 0 ? 0 : amount || 10;
        var hsl = tinycolor(color).toHsl();
        hsl.l += amount / 100;
        hsl.l = clamp01(hsl.l);
        return tinycolor(hsl);
    }
    function _brighten(color, amount) {
        amount = amount === 0 ? 0 : amount || 10;
        var rgb = tinycolor(color).toRgb();
        rgb.r = Math.max(0, Math.min(255, rgb.r - Math.round(255 * -(amount / 100))));
        rgb.g = Math.max(0, Math.min(255, rgb.g - Math.round(255 * -(amount / 100))));
        rgb.b = Math.max(0, Math.min(255, rgb.b - Math.round(255 * -(amount / 100))));
        return tinycolor(rgb);
    }
    function _darken(color, amount) {
        amount = amount === 0 ? 0 : amount || 10;
        var hsl = tinycolor(color).toHsl();
        hsl.l -= amount / 100;
        hsl.l = clamp01(hsl.l);
        return tinycolor(hsl);
    }
    // Spin takes a positive or negative amount within [-360, 360] indicating the change of hue.
    // Values outside of this range will be wrapped into this range.
    function _spin(color, amount) {
        var hsl = tinycolor(color).toHsl();
        var hue = (hsl.h + amount) % 360;
        hsl.h = hue < 0 ? 360 + hue : hue;
        return tinycolor(hsl);
    }
    // Combination Functions
    // ---------------------
    // Thanks to jQuery xColor for some of the ideas behind these
    // <https://github.com/infusion/jQuery-xcolor/blob/master/jquery.xcolor.js>
    function _complement(color) {
        var hsl = tinycolor(color).toHsl();
        hsl.h = (hsl.h + 180) % 360;
        return tinycolor(hsl);
    }
    function polyad(color, number) {
        if (isNaN(number) || number <= 0) throw new Error("Argument to polyad must be a positive number");
        var hsl = tinycolor(color).toHsl();
        var result = [
            tinycolor(color)
        ];
        var step = 360 / number;
        for(var i = 1; i < number; i++)result.push(tinycolor({
            h: (hsl.h + i * step) % 360,
            s: hsl.s,
            l: hsl.l
        }));
        return result;
    }
    function _splitcomplement(color) {
        var hsl = tinycolor(color).toHsl();
        var h = hsl.h;
        return [
            tinycolor(color),
            tinycolor({
                h: (h + 72) % 360,
                s: hsl.s,
                l: hsl.l
            }),
            tinycolor({
                h: (h + 216) % 360,
                s: hsl.s,
                l: hsl.l
            })
        ];
    }
    function _analogous(color, results, slices) {
        results = results || 6;
        slices = slices || 30;
        var hsl = tinycolor(color).toHsl();
        var part = 360 / slices;
        var ret = [
            tinycolor(color)
        ];
        for(hsl.h = (hsl.h - (part * results >> 1) + 720) % 360; --results;){
            hsl.h = (hsl.h + part) % 360;
            ret.push(tinycolor(hsl));
        }
        return ret;
    }
    function _monochromatic(color, results) {
        results = results || 6;
        var hsv = tinycolor(color).toHsv();
        var h = hsv.h, s = hsv.s, v = hsv.v;
        var ret = [];
        var modification = 1 / results;
        while(results--){
            ret.push(tinycolor({
                h: h,
                s: s,
                v: v
            }));
            v = (v + modification) % 1;
        }
        return ret;
    }
    // Utility Functions
    // ---------------------
    tinycolor.mix = function(color1, color2, amount) {
        amount = amount === 0 ? 0 : amount || 50;
        var rgb1 = tinycolor(color1).toRgb();
        var rgb2 = tinycolor(color2).toRgb();
        var p = amount / 100;
        var rgba = {
            r: (rgb2.r - rgb1.r) * p + rgb1.r,
            g: (rgb2.g - rgb1.g) * p + rgb1.g,
            b: (rgb2.b - rgb1.b) * p + rgb1.b,
            a: (rgb2.a - rgb1.a) * p + rgb1.a
        };
        return tinycolor(rgba);
    };
    // Readability Functions
    // ---------------------
    // <http://www.w3.org/TR/2008/REC-WCAG20-20081211/#contrast-ratiodef (WCAG Version 2)
    // `contrast`
    // Analyze the 2 colors and returns the color contrast defined by (WCAG Version 2)
    tinycolor.readability = function(color1, color2) {
        var c1 = tinycolor(color1);
        var c2 = tinycolor(color2);
        return (Math.max(c1.getLuminance(), c2.getLuminance()) + 0.05) / (Math.min(c1.getLuminance(), c2.getLuminance()) + 0.05);
    };
    // `isReadable`
    // Ensure that foreground and background color combinations meet WCAG2 guidelines.
    // The third argument is an optional Object.
    //      the 'level' property states 'AA' or 'AAA' - if missing or invalid, it defaults to 'AA';
    //      the 'size' property states 'large' or 'small' - if missing or invalid, it defaults to 'small'.
    // If the entire object is absent, isReadable defaults to {level:"AA",size:"small"}.
    // *Example*
    //    tinycolor.isReadable("#000", "#111") => false
    //    tinycolor.isReadable("#000", "#111",{level:"AA",size:"large"}) => false
    tinycolor.isReadable = function(color1, color2, wcag2) {
        var readability = tinycolor.readability(color1, color2);
        var wcag2Parms, out;
        out = false;
        wcag2Parms = validateWCAG2Parms(wcag2);
        switch(wcag2Parms.level + wcag2Parms.size){
            case "AAsmall":
            case "AAAlarge":
                out = readability >= 4.5;
                break;
            case "AAlarge":
                out = readability >= 3;
                break;
            case "AAAsmall":
                out = readability >= 7;
                break;
        }
        return out;
    };
    // `mostReadable`
    // Given a base color and a list of possible foreground or background
    // colors for that base, returns the most readable color.
    // Optionally returns Black or White if the most readable color is unreadable.
    // *Example*
    //    tinycolor.mostReadable(tinycolor.mostReadable("#123", ["#124", "#125"],{includeFallbackColors:false}).toHexString(); // "#112255"
    //    tinycolor.mostReadable(tinycolor.mostReadable("#123", ["#124", "#125"],{includeFallbackColors:true}).toHexString();  // "#ffffff"
    //    tinycolor.mostReadable("#a8015a", ["#faf3f3"],{includeFallbackColors:true,level:"AAA",size:"large"}).toHexString(); // "#faf3f3"
    //    tinycolor.mostReadable("#a8015a", ["#faf3f3"],{includeFallbackColors:true,level:"AAA",size:"small"}).toHexString(); // "#ffffff"
    tinycolor.mostReadable = function(baseColor, colorList, args) {
        var bestColor = null;
        var bestScore = 0;
        var readability;
        var includeFallbackColors, level, size;
        args = args || {};
        includeFallbackColors = args.includeFallbackColors;
        level = args.level;
        size = args.size;
        for(var i = 0; i < colorList.length; i++){
            readability = tinycolor.readability(baseColor, colorList[i]);
            if (readability > bestScore) {
                bestScore = readability;
                bestColor = tinycolor(colorList[i]);
            }
        }
        if (tinycolor.isReadable(baseColor, bestColor, {
            level: level,
            size: size
        }) || !includeFallbackColors) return bestColor;
        else {
            args.includeFallbackColors = false;
            return tinycolor.mostReadable(baseColor, [
                "#fff",
                "#000"
            ], args);
        }
    };
    // Big List of Colors
    // ------------------
    // <https://www.w3.org/TR/css-color-4/#named-colors>
    var names = tinycolor.names = {
        aliceblue: "f0f8ff",
        antiquewhite: "faebd7",
        aqua: "0ff",
        aquamarine: "7fffd4",
        azure: "f0ffff",
        beige: "f5f5dc",
        bisque: "ffe4c4",
        black: "000",
        blanchedalmond: "ffebcd",
        blue: "00f",
        blueviolet: "8a2be2",
        brown: "a52a2a",
        burlywood: "deb887",
        burntsienna: "ea7e5d",
        cadetblue: "5f9ea0",
        chartreuse: "7fff00",
        chocolate: "d2691e",
        coral: "ff7f50",
        cornflowerblue: "6495ed",
        cornsilk: "fff8dc",
        crimson: "dc143c",
        cyan: "0ff",
        darkblue: "00008b",
        darkcyan: "008b8b",
        darkgoldenrod: "b8860b",
        darkgray: "a9a9a9",
        darkgreen: "006400",
        darkgrey: "a9a9a9",
        darkkhaki: "bdb76b",
        darkmagenta: "8b008b",
        darkolivegreen: "556b2f",
        darkorange: "ff8c00",
        darkorchid: "9932cc",
        darkred: "8b0000",
        darksalmon: "e9967a",
        darkseagreen: "8fbc8f",
        darkslateblue: "483d8b",
        darkslategray: "2f4f4f",
        darkslategrey: "2f4f4f",
        darkturquoise: "00ced1",
        darkviolet: "9400d3",
        deeppink: "ff1493",
        deepskyblue: "00bfff",
        dimgray: "696969",
        dimgrey: "696969",
        dodgerblue: "1e90ff",
        firebrick: "b22222",
        floralwhite: "fffaf0",
        forestgreen: "228b22",
        fuchsia: "f0f",
        gainsboro: "dcdcdc",
        ghostwhite: "f8f8ff",
        gold: "ffd700",
        goldenrod: "daa520",
        gray: "808080",
        green: "008000",
        greenyellow: "adff2f",
        grey: "808080",
        honeydew: "f0fff0",
        hotpink: "ff69b4",
        indianred: "cd5c5c",
        indigo: "4b0082",
        ivory: "fffff0",
        khaki: "f0e68c",
        lavender: "e6e6fa",
        lavenderblush: "fff0f5",
        lawngreen: "7cfc00",
        lemonchiffon: "fffacd",
        lightblue: "add8e6",
        lightcoral: "f08080",
        lightcyan: "e0ffff",
        lightgoldenrodyellow: "fafad2",
        lightgray: "d3d3d3",
        lightgreen: "90ee90",
        lightgrey: "d3d3d3",
        lightpink: "ffb6c1",
        lightsalmon: "ffa07a",
        lightseagreen: "20b2aa",
        lightskyblue: "87cefa",
        lightslategray: "789",
        lightslategrey: "789",
        lightsteelblue: "b0c4de",
        lightyellow: "ffffe0",
        lime: "0f0",
        limegreen: "32cd32",
        linen: "faf0e6",
        magenta: "f0f",
        maroon: "800000",
        mediumaquamarine: "66cdaa",
        mediumblue: "0000cd",
        mediumorchid: "ba55d3",
        mediumpurple: "9370db",
        mediumseagreen: "3cb371",
        mediumslateblue: "7b68ee",
        mediumspringgreen: "00fa9a",
        mediumturquoise: "48d1cc",
        mediumvioletred: "c71585",
        midnightblue: "191970",
        mintcream: "f5fffa",
        mistyrose: "ffe4e1",
        moccasin: "ffe4b5",
        navajowhite: "ffdead",
        navy: "000080",
        oldlace: "fdf5e6",
        olive: "808000",
        olivedrab: "6b8e23",
        orange: "ffa500",
        orangered: "ff4500",
        orchid: "da70d6",
        palegoldenrod: "eee8aa",
        palegreen: "98fb98",
        paleturquoise: "afeeee",
        palevioletred: "db7093",
        papayawhip: "ffefd5",
        peachpuff: "ffdab9",
        peru: "cd853f",
        pink: "ffc0cb",
        plum: "dda0dd",
        powderblue: "b0e0e6",
        purple: "800080",
        rebeccapurple: "663399",
        red: "f00",
        rosybrown: "bc8f8f",
        royalblue: "4169e1",
        saddlebrown: "8b4513",
        salmon: "fa8072",
        sandybrown: "f4a460",
        seagreen: "2e8b57",
        seashell: "fff5ee",
        sienna: "a0522d",
        silver: "c0c0c0",
        skyblue: "87ceeb",
        slateblue: "6a5acd",
        slategray: "708090",
        slategrey: "708090",
        snow: "fffafa",
        springgreen: "00ff7f",
        steelblue: "4682b4",
        tan: "d2b48c",
        teal: "008080",
        thistle: "d8bfd8",
        tomato: "ff6347",
        turquoise: "40e0d0",
        violet: "ee82ee",
        wheat: "f5deb3",
        white: "fff",
        whitesmoke: "f5f5f5",
        yellow: "ff0",
        yellowgreen: "9acd32"
    };
    // Make it easy to access colors via `hexNames[hex]`
    var hexNames = tinycolor.hexNames = flip(names);
    // Utilities
    // ---------
    // `{ 'name1': 'val1' }` becomes `{ 'val1': 'name1' }`
    function flip(o) {
        var flipped = {};
        for(var i in o)if (o.hasOwnProperty(i)) flipped[o[i]] = i;
        return flipped;
    }
    // Return a valid alpha value [0,1] with all invalid values being set to 1
    function boundAlpha(a) {
        a = parseFloat(a);
        if (isNaN(a) || a < 0 || a > 1) a = 1;
        return a;
    }
    // Take input from [0, n] and return it as [0, 1]
    function bound01(n, max) {
        if (isOnePointZero(n)) n = "100%";
        var processPercent = isPercentage(n);
        n = Math.min(max, Math.max(0, parseFloat(n)));
        // Automatically convert percentage into number
        if (processPercent) n = parseInt(n * max, 10) / 100;
        // Handle floating point rounding errors
        if (Math.abs(n - max) < 0.000001) return 1;
        // Convert into [0, 1] range if it isn't already
        return n % max / parseFloat(max);
    }
    // Force a number between 0 and 1
    function clamp01(val) {
        return Math.min(1, Math.max(0, val));
    }
    // Parse a base-16 hex value into a base-10 integer
    function parseIntFromHex(val) {
        return parseInt(val, 16);
    }
    // Need to handle 1.0 as 100%, since once it is a number, there is no difference between it and 1
    // <http://stackoverflow.com/questions/7422072/javascript-how-to-detect-number-as-a-decimal-including-1-0>
    function isOnePointZero(n) {
        return typeof n == "string" && n.indexOf(".") != -1 && parseFloat(n) === 1;
    }
    // Check to see if string passed in is a percentage
    function isPercentage(n) {
        return typeof n === "string" && n.indexOf("%") != -1;
    }
    // Force a hex value to have 2 characters
    function pad2(c) {
        return c.length == 1 ? "0" + c : "" + c;
    }
    // Replace a decimal with it's percentage value
    function convertToPercentage(n) {
        if (n <= 1) n = n * 100 + "%";
        return n;
    }
    // Converts a decimal to a hex value
    function convertDecimalToHex(d) {
        return Math.round(parseFloat(d) * 255).toString(16);
    }
    // Converts a hex value to a decimal
    function convertHexToDecimal(h) {
        return parseIntFromHex(h) / 255;
    }
    var matchers = function() {
        // <http://www.w3.org/TR/css3-values/#integers>
        var CSS_INTEGER = "[-\\+]?\\d+%?";
        // <http://www.w3.org/TR/css3-values/#number-value>
        var CSS_NUMBER = "[-\\+]?\\d*\\.\\d+%?";
        // Allow positive/negative integer/number.  Don't capture the either/or, just the entire outcome.
        var CSS_UNIT = "(?:" + CSS_NUMBER + ")|(?:" + CSS_INTEGER + ")";
        // Actual matching.
        // Parentheses and commas are optional, but not required.
        // Whitespace can take the place of commas or opening paren
        var PERMISSIVE_MATCH3 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";
        var PERMISSIVE_MATCH4 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";
        return {
            CSS_UNIT: new RegExp(CSS_UNIT),
            rgb: new RegExp("rgb" + PERMISSIVE_MATCH3),
            rgba: new RegExp("rgba" + PERMISSIVE_MATCH4),
            hsl: new RegExp("hsl" + PERMISSIVE_MATCH3),
            hsla: new RegExp("hsla" + PERMISSIVE_MATCH4),
            hsv: new RegExp("hsv" + PERMISSIVE_MATCH3),
            hsva: new RegExp("hsva" + PERMISSIVE_MATCH4),
            hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
            hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
            hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
            hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
        };
    }();
    // `isValidCSSUnit`
    // Take in a single string / number and check to see if it looks like a CSS unit
    // (see `matchers` above for definition).
    function isValidCSSUnit(color) {
        return !!matchers.CSS_UNIT.exec(color);
    }
    // `stringInputToObject`
    // Permissive string parsing.  Take in a number of formats, and output an object
    // based on detected format.  Returns `{ r, g, b }` or `{ h, s, l }` or `{ h, s, v}`
    function stringInputToObject(color) {
        color = color.replace(trimLeft, "").replace(trimRight, "").toLowerCase();
        var named = false;
        if (names[color]) {
            color = names[color];
            named = true;
        } else if (color == "transparent") return {
            r: 0,
            g: 0,
            b: 0,
            a: 0,
            format: "name"
        };
        // Try to match string input using regular expressions.
        // Keep most of the number bounding out of this function - don't worry about [0,1] or [0,100] or [0,360]
        // Just return an object and let the conversion functions handle that.
        // This way the result will be the same whether the tinycolor is initialized with string or object.
        var match;
        if (match = matchers.rgb.exec(color)) return {
            r: match[1],
            g: match[2],
            b: match[3]
        };
        if (match = matchers.rgba.exec(color)) return {
            r: match[1],
            g: match[2],
            b: match[3],
            a: match[4]
        };
        if (match = matchers.hsl.exec(color)) return {
            h: match[1],
            s: match[2],
            l: match[3]
        };
        if (match = matchers.hsla.exec(color)) return {
            h: match[1],
            s: match[2],
            l: match[3],
            a: match[4]
        };
        if (match = matchers.hsv.exec(color)) return {
            h: match[1],
            s: match[2],
            v: match[3]
        };
        if (match = matchers.hsva.exec(color)) return {
            h: match[1],
            s: match[2],
            v: match[3],
            a: match[4]
        };
        if (match = matchers.hex8.exec(color)) return {
            r: parseIntFromHex(match[1]),
            g: parseIntFromHex(match[2]),
            b: parseIntFromHex(match[3]),
            a: convertHexToDecimal(match[4]),
            format: named ? "name" : "hex8"
        };
        if (match = matchers.hex6.exec(color)) return {
            r: parseIntFromHex(match[1]),
            g: parseIntFromHex(match[2]),
            b: parseIntFromHex(match[3]),
            format: named ? "name" : "hex"
        };
        if (match = matchers.hex4.exec(color)) return {
            r: parseIntFromHex(match[1] + "" + match[1]),
            g: parseIntFromHex(match[2] + "" + match[2]),
            b: parseIntFromHex(match[3] + "" + match[3]),
            a: convertHexToDecimal(match[4] + "" + match[4]),
            format: named ? "name" : "hex8"
        };
        if (match = matchers.hex3.exec(color)) return {
            r: parseIntFromHex(match[1] + "" + match[1]),
            g: parseIntFromHex(match[2] + "" + match[2]),
            b: parseIntFromHex(match[3] + "" + match[3]),
            format: named ? "name" : "hex"
        };
        return false;
    }
    function validateWCAG2Parms(parms) {
        // return valid WCAG2 parms for isReadable.
        // If input parms are invalid, return {"level":"AA", "size":"small"}
        var level, size;
        parms = parms || {
            level: "AA",
            size: "small"
        };
        level = (parms.level || "AA").toUpperCase();
        size = (parms.size || "small").toLowerCase();
        if (level !== "AA" && level !== "AAA") level = "AA";
        if (size !== "small" && size !== "large") size = "small";
        return {
            level: level,
            size: size
        };
    }
    return tinycolor;
});


function $e83b3346bbbc2544$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $e83b3346bbbc2544$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
function $e83b3346bbbc2544$var$_arrayWithoutHoles(r) {
    if (Array.isArray(r)) return $e83b3346bbbc2544$var$_arrayLikeToArray(r);
}
function $e83b3346bbbc2544$var$_assertThisInitialized(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}
function $e83b3346bbbc2544$var$_callSuper(t, o, e) {
    return o = $e83b3346bbbc2544$var$_getPrototypeOf(o), $e83b3346bbbc2544$var$_possibleConstructorReturn(t, $e83b3346bbbc2544$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], $e83b3346bbbc2544$var$_getPrototypeOf(t).constructor) : o.apply(t, e));
}
function $e83b3346bbbc2544$var$_classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function $e83b3346bbbc2544$var$_construct(t, e, r) {
    if ($e83b3346bbbc2544$var$_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments);
    var o = [
        null
    ];
    o.push.apply(o, e);
    var p = new (t.bind.apply(t, o))();
    return p;
}
function $e83b3346bbbc2544$var$_createClass(e, r, t) {
    return Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
function $e83b3346bbbc2544$var$_defineProperty(e, r, t) {
    return (r = $e83b3346bbbc2544$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $e83b3346bbbc2544$var$_getPrototypeOf(t) {
    return $e83b3346bbbc2544$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $e83b3346bbbc2544$var$_getPrototypeOf(t);
}
function $e83b3346bbbc2544$var$_inherits(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && $e83b3346bbbc2544$var$_setPrototypeOf(t, e);
}
function $e83b3346bbbc2544$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($e83b3346bbbc2544$var$_isNativeReflectConstruct = function() {
        return !!t;
    })();
}
function $e83b3346bbbc2544$var$_iterableToArray(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function $e83b3346bbbc2544$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) ;
            else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $e83b3346bbbc2544$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $e83b3346bbbc2544$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $e83b3346bbbc2544$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $e83b3346bbbc2544$var$_objectSpread2(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $e83b3346bbbc2544$var$ownKeys(Object(t), !0).forEach(function(r) {
            $e83b3346bbbc2544$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $e83b3346bbbc2544$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $e83b3346bbbc2544$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $e83b3346bbbc2544$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var s = Object.getOwnPropertySymbols(e);
        for(r = 0; r < s.length; r++)o = s[r], t.includes(o) || ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $e83b3346bbbc2544$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.includes(n)) continue;
        t[n] = r[n];
    }
    return t;
}
function $e83b3346bbbc2544$var$_possibleConstructorReturn(t, e) {
    if (e && ("object" == typeof e || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return $e83b3346bbbc2544$var$_assertThisInitialized(t);
}
function $e83b3346bbbc2544$var$_setPrototypeOf(t, e) {
    return $e83b3346bbbc2544$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $e83b3346bbbc2544$var$_setPrototypeOf(t, e);
}
function $e83b3346bbbc2544$var$_slicedToArray(r, e) {
    return $e83b3346bbbc2544$var$_arrayWithHoles(r) || $e83b3346bbbc2544$var$_iterableToArrayLimit(r, e) || $e83b3346bbbc2544$var$_unsupportedIterableToArray(r, e) || $e83b3346bbbc2544$var$_nonIterableRest();
}
function $e83b3346bbbc2544$var$_toConsumableArray(r) {
    return $e83b3346bbbc2544$var$_arrayWithoutHoles(r) || $e83b3346bbbc2544$var$_iterableToArray(r) || $e83b3346bbbc2544$var$_unsupportedIterableToArray(r) || $e83b3346bbbc2544$var$_nonIterableSpread();
}
function $e83b3346bbbc2544$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $e83b3346bbbc2544$var$_toPropertyKey(t) {
    var i = $e83b3346bbbc2544$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $e83b3346bbbc2544$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $e83b3346bbbc2544$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $e83b3346bbbc2544$var$_typeof(o);
}
function $e83b3346bbbc2544$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $e83b3346bbbc2544$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $e83b3346bbbc2544$var$_arrayLikeToArray(r, a) : void 0;
    }
}
var $e83b3346bbbc2544$var$_materialDispose = function materialDispose(material) {
    if (material instanceof Array) material.forEach($e83b3346bbbc2544$var$_materialDispose);
    else {
        if (material.map) material.map.dispose();
        material.dispose();
    }
};
var $e83b3346bbbc2544$var$_deallocate = function deallocate(obj) {
    if (obj.geometry) obj.geometry.dispose();
    if (obj.material) $e83b3346bbbc2544$var$_materialDispose(obj.material);
    if (obj.texture) obj.texture.dispose();
    if (obj.children) obj.children.forEach($e83b3346bbbc2544$var$_deallocate);
};
var $e83b3346bbbc2544$var$emptyObject = function emptyObject(obj) {
    while(obj.children.length){
        var childObj = obj.children[0];
        obj.remove(childObj);
        $e83b3346bbbc2544$var$_deallocate(childObj);
    }
};
var $e83b3346bbbc2544$var$_excluded = [
    "objFilter"
];
function $e83b3346bbbc2544$var$threeDigest(data, scene) {
    var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {}, _ref$objFilter = _ref.objFilter, objFilter = _ref$objFilter === void 0 ? function() {
        return true;
    } : _ref$objFilter, options = $e83b3346bbbc2544$var$_objectWithoutProperties(_ref, $e83b3346bbbc2544$var$_excluded);
    return (0, $0e2a28a99595988d$export$2e2bcd8739ae039)(data, scene.children.filter(objFilter), function(obj) {
        return scene.add(obj);
    }, function(obj) {
        scene.remove(obj);
        $e83b3346bbbc2544$var$emptyObject(obj);
    }, $e83b3346bbbc2544$var$_objectSpread2({
        objBindAttr: '__threeObj'
    }, options));
}
var $e83b3346bbbc2544$var$colorStr2Hex = function colorStr2Hex(str) {
    return isNaN(str) ? parseInt((0, (/*@__PURE__*/$parcel$interopDefault($11df18e2f038bad8$exports)))(str).toHex(), 16) : str;
};
var $e83b3346bbbc2544$var$colorAlpha = function colorAlpha(str) {
    return isNaN(str) ? (0, (/*@__PURE__*/$parcel$interopDefault($11df18e2f038bad8$exports)))(str).getAlpha() : 1;
};
var $e83b3346bbbc2544$var$autoColorScale = (0, $38404d762c7ac827$export$2e2bcd8739ae039)((0, $892d66d4b4370fa9$export$2e2bcd8739ae039));
// Autoset attribute colorField by colorByAccessor property
// If an object has already a color, don't set it
// Objects can be nodes or links
function $e83b3346bbbc2544$var$autoColorObjects(objects, colorByAccessor, colorField) {
    if (!colorByAccessor || typeof colorField !== 'string') return;
    objects.filter(function(obj) {
        return !obj[colorField];
    }).forEach(function(obj) {
        obj[colorField] = $e83b3346bbbc2544$var$autoColorScale(colorByAccessor(obj));
    });
}
function $e83b3346bbbc2544$var$getDagDepths(_ref, idAccessor) {
    var nodes = _ref.nodes, links = _ref.links;
    var _ref2 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {}, _ref2$nodeFilter = _ref2.nodeFilter, nodeFilter = _ref2$nodeFilter === void 0 ? function() {
        return true;
    } : _ref2$nodeFilter, _ref2$onLoopError = _ref2.onLoopError, onLoopError = _ref2$onLoopError === void 0 ? function(loopIds) {
        throw "Invalid DAG structure! Found cycle in node path: ".concat(loopIds.join(' -> '), ".");
    } : _ref2$onLoopError;
    // linked graph
    var graph = {};
    nodes.forEach(function(node) {
        return graph[idAccessor(node)] = {
            data: node,
            out: [],
            depth: -1,
            skip: !nodeFilter(node)
        };
    });
    links.forEach(function(_ref3) {
        var source = _ref3.source, target = _ref3.target;
        var sourceId = getNodeId(source);
        var targetId = getNodeId(target);
        if (!graph.hasOwnProperty(sourceId)) throw "Missing source node with id: ".concat(sourceId);
        if (!graph.hasOwnProperty(targetId)) throw "Missing target node with id: ".concat(targetId);
        var sourceNode = graph[sourceId];
        var targetNode = graph[targetId];
        sourceNode.out.push(targetNode);
        function getNodeId(node) {
            return $e83b3346bbbc2544$var$_typeof(node) === 'object' ? idAccessor(node) : node;
        }
    });
    var foundLoops = [];
    traverse(Object.values(graph));
    var nodeDepths = Object.assign.apply(Object, [
        {}
    ].concat($e83b3346bbbc2544$var$_toConsumableArray(Object.entries(graph).filter(function(_ref4) {
        var _ref5 = $e83b3346bbbc2544$var$_slicedToArray(_ref4, 2), node = _ref5[1];
        return !node.skip;
    }).map(function(_ref6) {
        var _ref7 = $e83b3346bbbc2544$var$_slicedToArray(_ref6, 2), id = _ref7[0], node = _ref7[1];
        return $e83b3346bbbc2544$var$_defineProperty({}, id, node.depth);
    }))));
    return nodeDepths;
    function traverse(nodes) {
        var nodeStack = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
        var currentDepth = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
        var _loop = function _loop() {
            var node = nodes[i];
            if (nodeStack.indexOf(node) !== -1) {
                var loop = [].concat($e83b3346bbbc2544$var$_toConsumableArray(nodeStack.slice(nodeStack.indexOf(node))), [
                    node
                ]).map(function(d) {
                    return idAccessor(d.data);
                });
                if (!foundLoops.some(function(foundLoop) {
                    return foundLoop.length === loop.length && foundLoop.every(function(id, idx) {
                        return id === loop[idx];
                    });
                })) {
                    foundLoops.push(loop);
                    onLoopError(loop);
                }
                return 1; // continue
            }
            if (currentDepth > node.depth) {
                // Don't unnecessarily revisit chunks of the graph
                node.depth = currentDepth;
                traverse(node.out, [].concat($e83b3346bbbc2544$var$_toConsumableArray(nodeStack), [
                    node
                ]), currentDepth + (node.skip ? 0 : 1));
            }
        };
        for(var i = 0, l = nodes.length; i < l; i++){
            if (_loop()) continue;
        }
    }
}
var $e83b3346bbbc2544$var$three$1 = window.THREE ? window.THREE // Prefer consumption from global THREE, if exists
 : {
    Group: (0, $d5b33d7c30034067$export$eb2fcfdbd7ba97d4),
    Mesh: (0, $d5b33d7c30034067$export$e176487c05830cc5),
    MeshLambertMaterial: (0, $d5b33d7c30034067$export$5023a9a8114806b8),
    Color: (0, $d5b33d7c30034067$export$892596cec99bc70e),
    BufferGeometry: (0, $d5b33d7c30034067$export$b7be63a67df8959),
    BufferAttribute: (0, $d5b33d7c30034067$export$8dea267bd6bde117),
    Matrix4: (0, $d5b33d7c30034067$export$2ae72fc923e5eb5),
    Vector3: (0, $d5b33d7c30034067$export$64b5c384219d3699),
    SphereGeometry: (0, $d5b33d7c30034067$export$1b417fc3b307a251),
    CylinderGeometry: (0, $d5b33d7c30034067$export$68f745719dbe5198),
    TubeGeometry: (0, $d5b33d7c30034067$export$7897d9d48904490c),
    ConeGeometry: (0, $d5b33d7c30034067$export$a7a48974f285c9b3),
    Line: (0, $d5b33d7c30034067$export$17d680238e50603e),
    LineBasicMaterial: (0, $d5b33d7c30034067$export$fbaaa33907730a0c),
    QuadraticBezierCurve3: (0, $d5b33d7c30034067$export$bf3f4c7e459f90fc),
    CubicBezierCurve3: (0, $d5b33d7c30034067$export$13d5f1c9525f246c),
    Box3: (0, $d5b33d7c30034067$export$6f7d5a9418ab2aa3)
};
var $e83b3346bbbc2544$var$ngraph = {
    graph: (0, (/*@__PURE__*/$parcel$interopDefault($eba878becea76980$exports))),
    forcelayout: (0, (/*@__PURE__*/$parcel$interopDefault($6d47bf1a993b0381$exports)))
};
//
var $e83b3346bbbc2544$var$DAG_LEVEL_NODE_RATIO = 2;
// support multiple method names for backwards threejs compatibility
var $e83b3346bbbc2544$var$setAttributeFn = new $e83b3346bbbc2544$var$three$1.BufferGeometry().setAttribute ? 'setAttribute' : 'addAttribute';
var $e83b3346bbbc2544$var$applyMatrix4Fn = new $e83b3346bbbc2544$var$three$1.BufferGeometry().applyMatrix4 ? 'applyMatrix4' : 'applyMatrix';
var $e83b3346bbbc2544$var$ForceGraph = (0, $752852d7be1532d9$export$2e2bcd8739ae039)({
    props: {
        jsonUrl: {
            onChange: function onChange(jsonUrl, state) {
                var _this = this;
                if (jsonUrl && !state.fetchingJson) {
                    // Load data asynchronously
                    state.fetchingJson = true;
                    state.onLoading();
                    fetch(jsonUrl).then(function(r) {
                        return r.json();
                    }).then(function(json) {
                        state.fetchingJson = false;
                        state.onFinishLoading(json);
                        _this.graphData(json);
                    });
                }
            },
            triggerUpdate: false
        },
        graphData: {
            "default": {
                nodes: [],
                links: []
            },
            onChange: function onChange(graphData, state) {
                state.engineRunning = false; // Pause simulation immediately
            }
        },
        numDimensions: {
            "default": 3,
            onChange: function onChange(numDim, state) {
                var chargeForce = state.d3ForceLayout.force('charge');
                // Increase repulsion on 3D mode for improved spatial separation
                if (chargeForce) chargeForce.strength(numDim > 2 ? -60 : -30);
                if (numDim < 3) eraseDimension(state.graphData.nodes, 'z');
                if (numDim < 2) eraseDimension(state.graphData.nodes, 'y');
                function eraseDimension(nodes, dim) {
                    nodes.forEach(function(d) {
                        delete d[dim]; // position
                        delete d["v".concat(dim)]; // velocity
                    });
                }
            }
        },
        dagMode: {
            onChange: function onChange(dagMode, state) {
                // td, bu, lr, rl, zin, zout, radialin, radialout
                !dagMode && state.forceEngine === 'd3' && (state.graphData.nodes || []).forEach(function(n) {
                    return n.fx = n.fy = n.fz = undefined;
                }); // unfix nodes when disabling dag mode
            }
        },
        dagLevelDistance: {},
        dagNodeFilter: {
            "default": function _default(node) {
                return true;
            }
        },
        onDagError: {
            triggerUpdate: false
        },
        nodeRelSize: {
            "default": 4
        },
        // volume per val unit
        nodeId: {
            "default": 'id'
        },
        nodeVal: {
            "default": 'val'
        },
        nodeResolution: {
            "default": 8
        },
        // how many slice segments in the sphere's circumference
        nodeColor: {
            "default": 'color'
        },
        nodeAutoColorBy: {},
        nodeOpacity: {
            "default": 0.75
        },
        nodeVisibility: {
            "default": true
        },
        nodeThreeObject: {},
        nodeThreeObjectExtend: {
            "default": false
        },
        nodePositionUpdate: {
            triggerUpdate: false
        },
        // custom function to call for updating the node's position. Signature: (threeObj, { x, y, z}, node). If the function returns a truthy value, the regular node position update will not run.
        linkSource: {
            "default": 'source'
        },
        linkTarget: {
            "default": 'target'
        },
        linkVisibility: {
            "default": true
        },
        linkColor: {
            "default": 'color'
        },
        linkAutoColorBy: {},
        linkOpacity: {
            "default": 0.2
        },
        linkWidth: {},
        // Rounded to nearest decimal. For falsy values use dimensionless line with 1px regardless of distance.
        linkResolution: {
            "default": 6
        },
        // how many radial segments in each line tube's geometry
        linkCurvature: {
            "default": 0,
            triggerUpdate: false
        },
        // line curvature radius (0: straight, 1: semi-circle)
        linkCurveRotation: {
            "default": 0,
            triggerUpdate: false
        },
        // line curve rotation along the line axis (0: interection with XY plane, PI: upside down)
        linkMaterial: {},
        linkThreeObject: {},
        linkThreeObjectExtend: {
            "default": false
        },
        linkPositionUpdate: {
            triggerUpdate: false
        },
        // custom function to call for updating the link's position. Signature: (threeObj, { start: { x, y, z},  end: { x, y, z }}, link). If the function returns a truthy value, the regular link position update will not run.
        linkDirectionalArrowLength: {
            "default": 0
        },
        linkDirectionalArrowColor: {},
        linkDirectionalArrowRelPos: {
            "default": 0.5,
            triggerUpdate: false
        },
        // value between 0<>1 indicating the relative pos along the (exposed) line
        linkDirectionalArrowResolution: {
            "default": 8
        },
        // how many slice segments in the arrow's conic circumference
        linkDirectionalParticles: {
            "default": 0
        },
        // animate photons travelling in the link direction
        linkDirectionalParticleSpeed: {
            "default": 0.01,
            triggerUpdate: false
        },
        // in link length ratio per frame
        linkDirectionalParticleWidth: {
            "default": 0.5
        },
        linkDirectionalParticleColor: {},
        linkDirectionalParticleResolution: {
            "default": 4
        },
        // how many slice segments in the particle sphere's circumference
        forceEngine: {
            "default": 'd3'
        },
        // d3 or ngraph
        d3AlphaMin: {
            "default": 0
        },
        d3AlphaDecay: {
            "default": 0.0228,
            triggerUpdate: false,
            onChange: function onChange(alphaDecay, state) {
                state.d3ForceLayout.alphaDecay(alphaDecay);
            }
        },
        d3AlphaTarget: {
            "default": 0,
            triggerUpdate: false,
            onChange: function onChange(alphaTarget, state) {
                state.d3ForceLayout.alphaTarget(alphaTarget);
            }
        },
        d3VelocityDecay: {
            "default": 0.4,
            triggerUpdate: false,
            onChange: function onChange(velocityDecay, state) {
                state.d3ForceLayout.velocityDecay(velocityDecay);
            }
        },
        ngraphPhysics: {
            "default": {
                // defaults from https://github.com/anvaka/ngraph.physics.simulator/blob/master/index.js
                timeStep: 20,
                gravity: -1.2,
                theta: 0.8,
                springLength: 30,
                springCoefficient: 0.0008,
                dragCoefficient: 0.02
            }
        },
        warmupTicks: {
            "default": 0,
            triggerUpdate: false
        },
        // how many times to tick the force engine at init before starting to render
        cooldownTicks: {
            "default": Infinity,
            triggerUpdate: false
        },
        cooldownTime: {
            "default": 15000,
            triggerUpdate: false
        },
        // ms
        onLoading: {
            "default": function _default() {},
            triggerUpdate: false
        },
        onFinishLoading: {
            "default": function _default() {},
            triggerUpdate: false
        },
        onUpdate: {
            "default": function _default() {},
            triggerUpdate: false
        },
        onFinishUpdate: {
            "default": function _default() {},
            triggerUpdate: false
        },
        onEngineTick: {
            "default": function _default() {},
            triggerUpdate: false
        },
        onEngineStop: {
            "default": function _default() {},
            triggerUpdate: false
        }
    },
    methods: {
        refresh: function refresh(state) {
            state._flushObjects = true;
            state._rerender();
            return this;
        },
        // Expose d3 forces for external manipulation
        d3Force: function d3Force(state, forceName, forceFn) {
            if (forceFn === undefined) return state.d3ForceLayout.force(forceName); // Force getter
            state.d3ForceLayout.force(forceName, forceFn); // Force setter
            return this;
        },
        d3ReheatSimulation: function d3ReheatSimulation(state) {
            state.d3ForceLayout.alpha(1);
            this.resetCountdown();
            return this;
        },
        // reset cooldown state
        resetCountdown: function resetCountdown(state) {
            state.cntTicks = 0;
            state.startTickTime = new Date();
            state.engineRunning = true;
            return this;
        },
        tickFrame: function tickFrame(state) {
            var isD3Sim = state.forceEngine !== 'ngraph';
            if (state.engineRunning) layoutTick();
            updateArrows();
            updatePhotons();
            return this;
            //
            function layoutTick() {
                if (++state.cntTicks > state.cooldownTicks || new Date() - state.startTickTime > state.cooldownTime || isD3Sim && state.d3AlphaMin > 0 && state.d3ForceLayout.alpha() < state.d3AlphaMin) {
                    state.engineRunning = false; // Stop ticking graph
                    state.onEngineStop();
                } else {
                    state.layout[isD3Sim ? 'tick' : 'step'](); // Tick it
                    state.onEngineTick();
                }
                var nodeThreeObjectExtendAccessor = (0, $85d8080a057d7be2$export$2e2bcd8739ae039)(state.nodeThreeObjectExtend);
                // Update nodes position
                state.graphData.nodes.forEach(function(node) {
                    var obj = node.__threeObj;
                    if (!obj) return;
                    var pos = isD3Sim ? node : state.layout.getNodePosition(node[state.nodeId]);
                    var extendedObj = nodeThreeObjectExtendAccessor(node);
                    if (!state.nodePositionUpdate || !state.nodePositionUpdate(extendedObj ? obj.children[0] : obj, {
                        x: pos.x,
                        y: pos.y,
                        z: pos.z
                    }, node) // pass child custom object if extending the default
                     || extendedObj) {
                        obj.position.x = pos.x;
                        obj.position.y = pos.y || 0;
                        obj.position.z = pos.z || 0;
                    }
                });
                // Update links position
                var linkWidthAccessor = (0, $85d8080a057d7be2$export$2e2bcd8739ae039)(state.linkWidth);
                var linkCurvatureAccessor = (0, $85d8080a057d7be2$export$2e2bcd8739ae039)(state.linkCurvature);
                var linkCurveRotationAccessor = (0, $85d8080a057d7be2$export$2e2bcd8739ae039)(state.linkCurveRotation);
                var linkThreeObjectExtendAccessor = (0, $85d8080a057d7be2$export$2e2bcd8739ae039)(state.linkThreeObjectExtend);
                state.graphData.links.forEach(function(link) {
                    var lineObj = link.__lineObj;
                    if (!lineObj) return;
                    var pos = isD3Sim ? link : state.layout.getLinkPosition(state.layout.graph.getLink(link.source, link.target).id);
                    var start = pos[isD3Sim ? 'source' : 'from'];
                    var end = pos[isD3Sim ? 'target' : 'to'];
                    if (!start || !end || !start.hasOwnProperty('x') || !end.hasOwnProperty('x')) return; // skip invalid link
                    calcLinkCurve(link); // calculate link curve for all links, including custom replaced, so it can be used in directional functionality
                    var extendedObj = linkThreeObjectExtendAccessor(link);
                    if (state.linkPositionUpdate && state.linkPositionUpdate(extendedObj ? lineObj.children[1] : lineObj, // pass child custom object if extending the default
                    {
                        start: {
                            x: start.x,
                            y: start.y,
                            z: start.z
                        },
                        end: {
                            x: end.x,
                            y: end.y,
                            z: end.z
                        }
                    }, link) && !extendedObj) // exit if successfully custom updated position of non-extended obj
                    return;
                    var curveResolution = 30; // # line segments
                    var curve = link.__curve;
                    // select default line obj if it's an extended group
                    var line = lineObj.children.length ? lineObj.children[0] : lineObj;
                    if (line.type === 'Line') {
                        // Update line geometry
                        if (!curve) {
                            // straight line
                            var linePos = line.geometry.getAttribute('position');
                            if (!linePos || !linePos.array || linePos.array.length !== 6) line.geometry[$e83b3346bbbc2544$var$setAttributeFn]('position', linePos = new $e83b3346bbbc2544$var$three$1.BufferAttribute(new Float32Array(6), 3));
                            linePos.array[0] = start.x;
                            linePos.array[1] = start.y || 0;
                            linePos.array[2] = start.z || 0;
                            linePos.array[3] = end.x;
                            linePos.array[4] = end.y || 0;
                            linePos.array[5] = end.z || 0;
                            linePos.needsUpdate = true;
                        } else {
                            // bezier curve line
                            var curvePnts = curve.getPoints(curveResolution);
                            // resize buffer if needed
                            if (line.geometry.getAttribute('position').array.length !== curvePnts.length * 3) line.geometry[$e83b3346bbbc2544$var$setAttributeFn]('position', new $e83b3346bbbc2544$var$three$1.BufferAttribute(new Float32Array(curvePnts.length * 3), 3));
                            line.geometry.setFromPoints(curvePnts);
                        }
                        line.geometry.computeBoundingSphere();
                    } else if (line.type === 'Mesh') {
                        // Update cylinder geometry
                        if (!curve) {
                            // straight tube
                            if (!line.geometry.type.match(/^Cylinder(Buffer)?Geometry$/)) {
                                var linkWidth = Math.ceil(linkWidthAccessor(link) * 10) / 10;
                                var r = linkWidth / 2;
                                var geometry = new $e83b3346bbbc2544$var$three$1.CylinderGeometry(r, r, 1, state.linkResolution, 1, false);
                                geometry[$e83b3346bbbc2544$var$applyMatrix4Fn](new $e83b3346bbbc2544$var$three$1.Matrix4().makeTranslation(0, 0.5, 0));
                                geometry[$e83b3346bbbc2544$var$applyMatrix4Fn](new $e83b3346bbbc2544$var$three$1.Matrix4().makeRotationX(Math.PI / 2));
                                line.geometry.dispose();
                                line.geometry = geometry;
                            }
                            var vStart = new $e83b3346bbbc2544$var$three$1.Vector3(start.x, start.y || 0, start.z || 0);
                            var vEnd = new $e83b3346bbbc2544$var$three$1.Vector3(end.x, end.y || 0, end.z || 0);
                            var distance = vStart.distanceTo(vEnd);
                            line.position.x = vStart.x;
                            line.position.y = vStart.y;
                            line.position.z = vStart.z;
                            line.scale.z = distance;
                            line.parent.localToWorld(vEnd); // lookAt requires world coords
                            line.lookAt(vEnd);
                        } else {
                            // curved tube
                            if (!line.geometry.type.match(/^Tube(Buffer)?Geometry$/)) {
                                // reset object positioning
                                line.position.set(0, 0, 0);
                                line.rotation.set(0, 0, 0);
                                line.scale.set(1, 1, 1);
                            }
                            var _linkWidth = Math.ceil(linkWidthAccessor(link) * 10) / 10;
                            var _r = _linkWidth / 2;
                            var _geometry = new $e83b3346bbbc2544$var$three$1.TubeGeometry(curve, curveResolution, _r, state.linkResolution, false);
                            line.geometry.dispose();
                            line.geometry = _geometry;
                        }
                    }
                });
                //
                function calcLinkCurve(link) {
                    var pos = isD3Sim ? link : state.layout.getLinkPosition(state.layout.graph.getLink(link.source, link.target).id);
                    var start = pos[isD3Sim ? 'source' : 'from'];
                    var end = pos[isD3Sim ? 'target' : 'to'];
                    if (!start || !end || !start.hasOwnProperty('x') || !end.hasOwnProperty('x')) return; // skip invalid link
                    var curvature = linkCurvatureAccessor(link);
                    if (!curvature) link.__curve = null; // Straight line
                    else {
                        // bezier curve line (only for line types)
                        var vStart = new $e83b3346bbbc2544$var$three$1.Vector3(start.x, start.y || 0, start.z || 0);
                        var vEnd = new $e83b3346bbbc2544$var$three$1.Vector3(end.x, end.y || 0, end.z || 0);
                        var l = vStart.distanceTo(vEnd); // line length
                        var curve;
                        var curveRotation = linkCurveRotationAccessor(link);
                        if (l > 0) {
                            var dx = end.x - start.x;
                            var dy = end.y - start.y || 0;
                            var vLine = new $e83b3346bbbc2544$var$three$1.Vector3().subVectors(vEnd, vStart);
                            var cp = vLine.clone().multiplyScalar(curvature).cross(dx !== 0 || dy !== 0 ? new $e83b3346bbbc2544$var$three$1.Vector3(0, 0, 1) : new $e83b3346bbbc2544$var$three$1.Vector3(0, 1, 0)) // avoid cross-product of parallel vectors (prefer Z, fallback to Y)
                            .applyAxisAngle(vLine.normalize(), curveRotation) // rotate along line axis according to linkCurveRotation
                            .add(new $e83b3346bbbc2544$var$three$1.Vector3().addVectors(vStart, vEnd).divideScalar(2));
                            curve = new $e83b3346bbbc2544$var$three$1.QuadraticBezierCurve3(vStart, cp, vEnd);
                        } else {
                            // Same point, draw a loop
                            var d = curvature * 70;
                            var endAngle = -curveRotation; // Rotate clockwise (from Z angle perspective)
                            var startAngle = endAngle + Math.PI / 2;
                            curve = new $e83b3346bbbc2544$var$three$1.CubicBezierCurve3(vStart, new $e83b3346bbbc2544$var$three$1.Vector3(d * Math.cos(startAngle), d * Math.sin(startAngle), 0).add(vStart), new $e83b3346bbbc2544$var$three$1.Vector3(d * Math.cos(endAngle), d * Math.sin(endAngle), 0).add(vStart), vEnd);
                        }
                        link.__curve = curve;
                    }
                }
            }
            function updateArrows() {
                // update link arrow position
                var arrowRelPosAccessor = (0, $85d8080a057d7be2$export$2e2bcd8739ae039)(state.linkDirectionalArrowRelPos);
                var arrowLengthAccessor = (0, $85d8080a057d7be2$export$2e2bcd8739ae039)(state.linkDirectionalArrowLength);
                var nodeValAccessor = (0, $85d8080a057d7be2$export$2e2bcd8739ae039)(state.nodeVal);
                state.graphData.links.forEach(function(link) {
                    var arrowObj = link.__arrowObj;
                    if (!arrowObj) return;
                    var pos = isD3Sim ? link : state.layout.getLinkPosition(state.layout.graph.getLink(link.source, link.target).id);
                    var start = pos[isD3Sim ? 'source' : 'from'];
                    var end = pos[isD3Sim ? 'target' : 'to'];
                    if (!start || !end || !start.hasOwnProperty('x') || !end.hasOwnProperty('x')) return; // skip invalid link
                    var startR = Math.cbrt(Math.max(0, nodeValAccessor(start) || 1)) * state.nodeRelSize;
                    var endR = Math.cbrt(Math.max(0, nodeValAccessor(end) || 1)) * state.nodeRelSize;
                    var arrowLength = arrowLengthAccessor(link);
                    var arrowRelPos = arrowRelPosAccessor(link);
                    var getPosAlongLine = link.__curve ? function(t) {
                        return link.__curve.getPoint(t);
                    } // interpolate along bezier curve
                     : function(t) {
                        // straight line: interpolate linearly
                        var iplt = function iplt(dim, start, end, t) {
                            return start[dim] + (end[dim] - start[dim]) * t || 0;
                        };
                        return {
                            x: iplt('x', start, end, t),
                            y: iplt('y', start, end, t),
                            z: iplt('z', start, end, t)
                        };
                    };
                    var lineLen = link.__curve ? link.__curve.getLength() : Math.sqrt([
                        'x',
                        'y',
                        'z'
                    ].map(function(dim) {
                        return Math.pow((end[dim] || 0) - (start[dim] || 0), 2);
                    }).reduce(function(acc, v) {
                        return acc + v;
                    }, 0));
                    var posAlongLine = startR + arrowLength + (lineLen - startR - endR - arrowLength) * arrowRelPos;
                    var arrowHead = getPosAlongLine(posAlongLine / lineLen);
                    var arrowTail = getPosAlongLine((posAlongLine - arrowLength) / lineLen);
                    [
                        'x',
                        'y',
                        'z'
                    ].forEach(function(dim) {
                        return arrowObj.position[dim] = arrowTail[dim];
                    });
                    var headVec = $e83b3346bbbc2544$var$_construct($e83b3346bbbc2544$var$three$1.Vector3, $e83b3346bbbc2544$var$_toConsumableArray([
                        'x',
                        'y',
                        'z'
                    ].map(function(c) {
                        return arrowHead[c];
                    })));
                    arrowObj.parent.localToWorld(headVec); // lookAt requires world coords
                    arrowObj.lookAt(headVec);
                });
            }
            function updatePhotons() {
                // update link particle positions
                var particleSpeedAccessor = (0, $85d8080a057d7be2$export$2e2bcd8739ae039)(state.linkDirectionalParticleSpeed);
                state.graphData.links.forEach(function(link) {
                    var cyclePhotons = link.__photonsObj && link.__photonsObj.children;
                    var singleHopPhotons = link.__singleHopPhotonsObj && link.__singleHopPhotonsObj.children;
                    if ((!singleHopPhotons || !singleHopPhotons.length) && (!cyclePhotons || !cyclePhotons.length)) return;
                    var pos = isD3Sim ? link : state.layout.getLinkPosition(state.layout.graph.getLink(link.source, link.target).id);
                    var start = pos[isD3Sim ? 'source' : 'from'];
                    var end = pos[isD3Sim ? 'target' : 'to'];
                    if (!start || !end || !start.hasOwnProperty('x') || !end.hasOwnProperty('x')) return; // skip invalid link
                    var particleSpeed = particleSpeedAccessor(link);
                    var getPhotonPos = link.__curve ? function(t) {
                        return link.__curve.getPoint(t);
                    } // interpolate along bezier curve
                     : function(t) {
                        // straight line: interpolate linearly
                        var iplt = function iplt(dim, start, end, t) {
                            return start[dim] + (end[dim] - start[dim]) * t || 0;
                        };
                        return {
                            x: iplt('x', start, end, t),
                            y: iplt('y', start, end, t),
                            z: iplt('z', start, end, t)
                        };
                    };
                    var photons = [].concat($e83b3346bbbc2544$var$_toConsumableArray(cyclePhotons || []), $e83b3346bbbc2544$var$_toConsumableArray(singleHopPhotons || []));
                    photons.forEach(function(photon, idx) {
                        var singleHop = photon.parent.__linkThreeObjType === 'singleHopPhotons';
                        if (!photon.hasOwnProperty('__progressRatio')) photon.__progressRatio = singleHop ? 0 : idx / cyclePhotons.length;
                        photon.__progressRatio += particleSpeed;
                        if (photon.__progressRatio >= 1) {
                            if (!singleHop) photon.__progressRatio = photon.__progressRatio % 1;
                            else {
                                // remove particle
                                photon.parent.remove(photon);
                                $e83b3346bbbc2544$var$emptyObject(photon);
                                return;
                            }
                        }
                        var photonPosRatio = photon.__progressRatio;
                        var pos = getPhotonPos(photonPosRatio);
                        [
                            'x',
                            'y',
                            'z'
                        ].forEach(function(dim) {
                            return photon.position[dim] = pos[dim];
                        });
                    });
                });
            }
        },
        emitParticle: function emitParticle(state, link) {
            if (link && state.graphData.links.includes(link)) {
                if (!link.__singleHopPhotonsObj) {
                    var obj = new $e83b3346bbbc2544$var$three$1.Group();
                    obj.__linkThreeObjType = 'singleHopPhotons';
                    link.__singleHopPhotonsObj = obj;
                    state.graphScene.add(obj);
                }
                var particleWidthAccessor = (0, $85d8080a057d7be2$export$2e2bcd8739ae039)(state.linkDirectionalParticleWidth);
                var photonR = Math.ceil(particleWidthAccessor(link) * 10) / 10 / 2;
                var numSegments = state.linkDirectionalParticleResolution;
                var particleGeometry = new $e83b3346bbbc2544$var$three$1.SphereGeometry(photonR, numSegments, numSegments);
                var linkColorAccessor = (0, $85d8080a057d7be2$export$2e2bcd8739ae039)(state.linkColor);
                var particleColorAccessor = (0, $85d8080a057d7be2$export$2e2bcd8739ae039)(state.linkDirectionalParticleColor);
                var photonColor = particleColorAccessor(link) || linkColorAccessor(link) || '#f0f0f0';
                var materialColor = new $e83b3346bbbc2544$var$three$1.Color($e83b3346bbbc2544$var$colorStr2Hex(photonColor));
                var opacity = state.linkOpacity * 3;
                var particleMaterial = new $e83b3346bbbc2544$var$three$1.MeshLambertMaterial({
                    color: materialColor,
                    transparent: true,
                    opacity: opacity
                });
                // add a single hop particle
                link.__singleHopPhotonsObj.add(new $e83b3346bbbc2544$var$three$1.Mesh(particleGeometry, particleMaterial));
            }
            return this;
        },
        getGraphBbox: function getGraphBbox(state) {
            var nodeFilter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function() {
                return true;
            };
            if (!state.initialised) return null;
            // recursively collect all nested geometries bboxes
            var bboxes = function getBboxes(obj) {
                var bboxes = [];
                if (obj.geometry) {
                    obj.geometry.computeBoundingBox();
                    var box = new $e83b3346bbbc2544$var$three$1.Box3();
                    box.copy(obj.geometry.boundingBox).applyMatrix4(obj.matrixWorld);
                    bboxes.push(box);
                }
                return bboxes.concat.apply(bboxes, $e83b3346bbbc2544$var$_toConsumableArray((obj.children || []).filter(function(obj) {
                    return !obj.hasOwnProperty('__graphObjType') || obj.__graphObjType === 'node' && nodeFilter(obj.__data);
                } // exclude filtered out nodes
                ).map(getBboxes)));
            }(state.graphScene);
            if (!bboxes.length) return null;
            // extract global x,y,z min/max
            return Object.assign.apply(Object, $e83b3346bbbc2544$var$_toConsumableArray([
                'x',
                'y',
                'z'
            ].map(function(c) {
                return $e83b3346bbbc2544$var$_defineProperty({}, c, [
                    (0, $02ed355deaa9e190$export$2e2bcd8739ae039)(bboxes, function(bb) {
                        return bb.min[c];
                    }),
                    (0, $5a964dca3df4eea7$export$2e2bcd8739ae039)(bboxes, function(bb) {
                        return bb.max[c];
                    })
                ]);
            })));
        }
    },
    stateInit: function stateInit() {
        return {
            d3ForceLayout: (0, $a61c6b05e92f056e$export$2e2bcd8739ae039)().force('link', (0, $b1bbf836822558b1$export$2e2bcd8739ae039)()).force('charge', (0, $78193c16de4a9cf2$export$2e2bcd8739ae039)()).force('center', (0, $38b55043e008942d$export$2e2bcd8739ae039)()).force('dagRadial', null).stop(),
            engineRunning: false
        };
    },
    init: function init(threeObj, state) {
        // Main three object to manipulate
        state.graphScene = threeObj;
    },
    update: function update(state, changedProps) {
        var hasAnyPropChanged = function hasAnyPropChanged(propList) {
            return propList.some(function(p) {
                return changedProps.hasOwnProperty(p);
            });
        };
        state.engineRunning = false; // pause simulation
        state.onUpdate();
        if (state.nodeAutoColorBy !== null && hasAnyPropChanged([
            'nodeAutoColorBy',
            'graphData',
            'nodeColor'
        ])) // Auto add color to uncolored nodes
        $e83b3346bbbc2544$var$autoColorObjects(state.graphData.nodes, (0, $85d8080a057d7be2$export$2e2bcd8739ae039)(state.nodeAutoColorBy), state.nodeColor);
        if (state.linkAutoColorBy !== null && hasAnyPropChanged([
            'linkAutoColorBy',
            'graphData',
            'linkColor'
        ])) // Auto add color to uncolored links
        $e83b3346bbbc2544$var$autoColorObjects(state.graphData.links, (0, $85d8080a057d7be2$export$2e2bcd8739ae039)(state.linkAutoColorBy), state.linkColor);
        // Digest nodes WebGL objects
        if (state._flushObjects || hasAnyPropChanged([
            'graphData',
            'nodeThreeObject',
            'nodeThreeObjectExtend',
            'nodeVal',
            'nodeColor',
            'nodeVisibility',
            'nodeRelSize',
            'nodeResolution',
            'nodeOpacity'
        ])) {
            var customObjectAccessor = (0, $85d8080a057d7be2$export$2e2bcd8739ae039)(state.nodeThreeObject);
            var customObjectExtendAccessor = (0, $85d8080a057d7be2$export$2e2bcd8739ae039)(state.nodeThreeObjectExtend);
            var valAccessor = (0, $85d8080a057d7be2$export$2e2bcd8739ae039)(state.nodeVal);
            var colorAccessor = (0, $85d8080a057d7be2$export$2e2bcd8739ae039)(state.nodeColor);
            var visibilityAccessor = (0, $85d8080a057d7be2$export$2e2bcd8739ae039)(state.nodeVisibility);
            var sphereGeometries = {}; // indexed by node value
            var sphereMaterials = {}; // indexed by color
            $e83b3346bbbc2544$var$threeDigest(state.graphData.nodes.filter(visibilityAccessor), state.graphScene, {
                purge: state._flushObjects || hasAnyPropChanged([
                    // recreate objects if any of these props have changed
                    'nodeThreeObject',
                    'nodeThreeObjectExtend'
                ]),
                objFilter: function objFilter(obj) {
                    return obj.__graphObjType === 'node';
                },
                createObj: function createObj(node) {
                    var customObj = customObjectAccessor(node);
                    var extendObj = customObjectExtendAccessor(node);
                    if (customObj && state.nodeThreeObject === customObj) // clone object if it's a shared object among all nodes
                    customObj = customObj.clone();
                    var obj;
                    if (customObj && !extendObj) obj = customObj;
                    else {
                        // Add default object (sphere mesh)
                        obj = new $e83b3346bbbc2544$var$three$1.Mesh();
                        obj.__graphDefaultObj = true;
                        if (customObj && extendObj) obj.add(customObj); // extend default with custom
                    }
                    obj.__graphObjType = 'node'; // Add object type
                    return obj;
                },
                updateObj: function updateObj(obj, node) {
                    if (obj.__graphDefaultObj) {
                        // bypass internal updates for custom node objects
                        var val = valAccessor(node) || 1;
                        var radius = Math.cbrt(val) * state.nodeRelSize;
                        var numSegments = state.nodeResolution;
                        if (!obj.geometry.type.match(/^Sphere(Buffer)?Geometry$/) || obj.geometry.parameters.radius !== radius || obj.geometry.parameters.widthSegments !== numSegments) {
                            if (!sphereGeometries.hasOwnProperty(val)) sphereGeometries[val] = new $e83b3346bbbc2544$var$three$1.SphereGeometry(radius, numSegments, numSegments);
                            obj.geometry.dispose();
                            obj.geometry = sphereGeometries[val];
                        }
                        var color = colorAccessor(node);
                        var materialColor = new $e83b3346bbbc2544$var$three$1.Color($e83b3346bbbc2544$var$colorStr2Hex(color || '#ffffaa'));
                        var opacity = state.nodeOpacity * $e83b3346bbbc2544$var$colorAlpha(color);
                        if (obj.material.type !== 'MeshLambertMaterial' || !obj.material.color.equals(materialColor) || obj.material.opacity !== opacity) {
                            if (!sphereMaterials.hasOwnProperty(color)) sphereMaterials[color] = new $e83b3346bbbc2544$var$three$1.MeshLambertMaterial({
                                color: materialColor,
                                transparent: true,
                                opacity: opacity
                            });
                            obj.material.dispose();
                            obj.material = sphereMaterials[color];
                        }
                    }
                }
            });
        }
        // Digest links WebGL objects
        if (state._flushObjects || hasAnyPropChanged([
            'graphData',
            'linkThreeObject',
            'linkThreeObjectExtend',
            'linkMaterial',
            'linkColor',
            'linkWidth',
            'linkVisibility',
            'linkResolution',
            'linkOpacity',
            'linkDirectionalArrowLength',
            'linkDirectionalArrowColor',
            'linkDirectionalArrowResolution',
            'linkDirectionalParticles',
            'linkDirectionalParticleWidth',
            'linkDirectionalParticleColor',
            'linkDirectionalParticleResolution'
        ])) {
            var _customObjectAccessor = (0, $85d8080a057d7be2$export$2e2bcd8739ae039)(state.linkThreeObject);
            var _customObjectExtendAccessor = (0, $85d8080a057d7be2$export$2e2bcd8739ae039)(state.linkThreeObjectExtend);
            var customMaterialAccessor = (0, $85d8080a057d7be2$export$2e2bcd8739ae039)(state.linkMaterial);
            var _visibilityAccessor = (0, $85d8080a057d7be2$export$2e2bcd8739ae039)(state.linkVisibility);
            var _colorAccessor = (0, $85d8080a057d7be2$export$2e2bcd8739ae039)(state.linkColor);
            var widthAccessor = (0, $85d8080a057d7be2$export$2e2bcd8739ae039)(state.linkWidth);
            var cylinderGeometries = {}; // indexed by link width
            var lambertLineMaterials = {}; // for cylinder objects, indexed by link color
            var basicLineMaterials = {}; // for line objects, indexed by link color
            var visibleLinks = state.graphData.links.filter(_visibilityAccessor);
            // lines digest cycle
            $e83b3346bbbc2544$var$threeDigest(visibleLinks, state.graphScene, {
                objBindAttr: '__lineObj',
                purge: state._flushObjects || hasAnyPropChanged([
                    // recreate objects if any of these props have changed
                    'linkThreeObject',
                    'linkThreeObjectExtend',
                    'linkWidth'
                ]),
                objFilter: function objFilter(obj) {
                    return obj.__graphObjType === 'link';
                },
                exitObj: function exitObj(obj) {
                    // remove trailing single photons
                    var singlePhotonsObj = obj.__data && obj.__data.__singleHopPhotonsObj;
                    if (singlePhotonsObj) {
                        singlePhotonsObj.parent.remove(singlePhotonsObj);
                        $e83b3346bbbc2544$var$emptyObject(singlePhotonsObj);
                        delete obj.__data.__singleHopPhotonsObj;
                    }
                },
                createObj: function createObj(link) {
                    var customObj = _customObjectAccessor(link);
                    var extendObj = _customObjectExtendAccessor(link);
                    if (customObj && state.linkThreeObject === customObj) // clone object if it's a shared object among all links
                    customObj = customObj.clone();
                    var defaultObj;
                    if (!customObj || extendObj) {
                        // construct default line obj
                        var useCylinder = !!widthAccessor(link);
                        if (useCylinder) defaultObj = new $e83b3346bbbc2544$var$three$1.Mesh();
                        else {
                            // Use plain line (constant width)
                            var lineGeometry = new $e83b3346bbbc2544$var$three$1.BufferGeometry();
                            lineGeometry[$e83b3346bbbc2544$var$setAttributeFn]('position', new $e83b3346bbbc2544$var$three$1.BufferAttribute(new Float32Array(6), 3));
                            defaultObj = new $e83b3346bbbc2544$var$three$1.Line(lineGeometry);
                        }
                    }
                    var obj;
                    if (!customObj) {
                        obj = defaultObj;
                        obj.__graphDefaultObj = true;
                    } else if (!extendObj) // use custom object
                    obj = customObj;
                    else {
                        // extend default with custom in a group
                        obj = new $e83b3346bbbc2544$var$three$1.Group();
                        obj.__graphDefaultObj = true;
                        obj.add(defaultObj);
                        obj.add(customObj);
                    }
                    obj.renderOrder = 10; // Prevent visual glitches of dark lines on top of nodes by rendering them last
                    obj.__graphObjType = 'link'; // Add object type
                    return obj;
                },
                updateObj: function updateObj(updObj, link) {
                    if (updObj.__graphDefaultObj) {
                        // bypass internal updates for custom link objects
                        // select default object if it's an extended group
                        var obj = updObj.children.length ? updObj.children[0] : updObj;
                        var linkWidth = Math.ceil(widthAccessor(link) * 10) / 10;
                        var useCylinder = !!linkWidth;
                        if (useCylinder) {
                            var r = linkWidth / 2;
                            var numSegments = state.linkResolution;
                            if (!obj.geometry.type.match(/^Cylinder(Buffer)?Geometry$/) || obj.geometry.parameters.radiusTop !== r || obj.geometry.parameters.radialSegments !== numSegments) {
                                if (!cylinderGeometries.hasOwnProperty(linkWidth)) {
                                    var geometry = new $e83b3346bbbc2544$var$three$1.CylinderGeometry(r, r, 1, numSegments, 1, false);
                                    geometry[$e83b3346bbbc2544$var$applyMatrix4Fn](new $e83b3346bbbc2544$var$three$1.Matrix4().makeTranslation(0, 0.5, 0));
                                    geometry[$e83b3346bbbc2544$var$applyMatrix4Fn](new $e83b3346bbbc2544$var$three$1.Matrix4().makeRotationX(Math.PI / 2));
                                    cylinderGeometries[linkWidth] = geometry;
                                }
                                obj.geometry.dispose();
                                obj.geometry = cylinderGeometries[linkWidth];
                            }
                        }
                        var customMaterial = customMaterialAccessor(link);
                        if (customMaterial) obj.material = customMaterial;
                        else {
                            var color = _colorAccessor(link);
                            var materialColor = new $e83b3346bbbc2544$var$three$1.Color($e83b3346bbbc2544$var$colorStr2Hex(color || '#f0f0f0'));
                            var opacity = state.linkOpacity * $e83b3346bbbc2544$var$colorAlpha(color);
                            var materialType = useCylinder ? 'MeshLambertMaterial' : 'LineBasicMaterial';
                            if (obj.material.type !== materialType || !obj.material.color.equals(materialColor) || obj.material.opacity !== opacity) {
                                var lineMaterials = useCylinder ? lambertLineMaterials : basicLineMaterials;
                                if (!lineMaterials.hasOwnProperty(color)) lineMaterials[color] = new $e83b3346bbbc2544$var$three$1[materialType]({
                                    color: materialColor,
                                    transparent: opacity < 1,
                                    opacity: opacity,
                                    depthWrite: opacity >= 1 // Prevent transparency issues
                                });
                                obj.material.dispose();
                                obj.material = lineMaterials[color];
                            }
                        }
                    }
                }
            });
            // Arrows digest cycle
            if (state.linkDirectionalArrowLength || changedProps.hasOwnProperty('linkDirectionalArrowLength')) {
                var arrowLengthAccessor = (0, $85d8080a057d7be2$export$2e2bcd8739ae039)(state.linkDirectionalArrowLength);
                var arrowColorAccessor = (0, $85d8080a057d7be2$export$2e2bcd8739ae039)(state.linkDirectionalArrowColor);
                $e83b3346bbbc2544$var$threeDigest(visibleLinks.filter(arrowLengthAccessor), state.graphScene, {
                    objBindAttr: '__arrowObj',
                    objFilter: function objFilter(obj) {
                        return obj.__linkThreeObjType === 'arrow';
                    },
                    createObj: function createObj() {
                        var obj = new $e83b3346bbbc2544$var$three$1.Mesh(undefined, new $e83b3346bbbc2544$var$three$1.MeshLambertMaterial({
                            transparent: true
                        }));
                        obj.__linkThreeObjType = 'arrow'; // Add object type
                        return obj;
                    },
                    updateObj: function updateObj(obj, link) {
                        var arrowLength = arrowLengthAccessor(link);
                        var numSegments = state.linkDirectionalArrowResolution;
                        if (!obj.geometry.type.match(/^Cone(Buffer)?Geometry$/) || obj.geometry.parameters.height !== arrowLength || obj.geometry.parameters.radialSegments !== numSegments) {
                            var coneGeometry = new $e83b3346bbbc2544$var$three$1.ConeGeometry(arrowLength * 0.25, arrowLength, numSegments);
                            // Correct orientation
                            coneGeometry.translate(0, arrowLength / 2, 0);
                            coneGeometry.rotateX(Math.PI / 2);
                            obj.geometry.dispose();
                            obj.geometry = coneGeometry;
                        }
                        var arrowColor = arrowColorAccessor(link) || _colorAccessor(link) || '#f0f0f0';
                        obj.material.color = new $e83b3346bbbc2544$var$three$1.Color($e83b3346bbbc2544$var$colorStr2Hex(arrowColor));
                        obj.material.opacity = state.linkOpacity * 3 * $e83b3346bbbc2544$var$colorAlpha(arrowColor);
                    }
                });
            }
            // Photon particles digest cycle
            if (state.linkDirectionalParticles || changedProps.hasOwnProperty('linkDirectionalParticles')) {
                var particlesAccessor = (0, $85d8080a057d7be2$export$2e2bcd8739ae039)(state.linkDirectionalParticles);
                var particleWidthAccessor = (0, $85d8080a057d7be2$export$2e2bcd8739ae039)(state.linkDirectionalParticleWidth);
                var particleColorAccessor = (0, $85d8080a057d7be2$export$2e2bcd8739ae039)(state.linkDirectionalParticleColor);
                var particleMaterials = {}; // indexed by link color
                var particleGeometries = {}; // indexed by particle width
                $e83b3346bbbc2544$var$threeDigest(visibleLinks.filter(particlesAccessor), state.graphScene, {
                    objBindAttr: '__photonsObj',
                    objFilter: function objFilter(obj) {
                        return obj.__linkThreeObjType === 'photons';
                    },
                    createObj: function createObj() {
                        var obj = new $e83b3346bbbc2544$var$three$1.Group();
                        obj.__linkThreeObjType = 'photons'; // Add object type
                        return obj;
                    },
                    updateObj: function updateObj(obj, link) {
                        var numPhotons = Math.round(Math.abs(particlesAccessor(link)));
                        var curPhoton = !!obj.children.length && obj.children[0];
                        var photonR = Math.ceil(particleWidthAccessor(link) * 10) / 10 / 2;
                        var numSegments = state.linkDirectionalParticleResolution;
                        var particleGeometry;
                        if (curPhoton && curPhoton.geometry.parameters.radius === photonR && curPhoton.geometry.parameters.widthSegments === numSegments) particleGeometry = curPhoton.geometry;
                        else {
                            if (!particleGeometries.hasOwnProperty(photonR)) particleGeometries[photonR] = new $e83b3346bbbc2544$var$three$1.SphereGeometry(photonR, numSegments, numSegments);
                            particleGeometry = particleGeometries[photonR];
                            curPhoton && curPhoton.geometry.dispose();
                        }
                        var photonColor = particleColorAccessor(link) || _colorAccessor(link) || '#f0f0f0';
                        var materialColor = new $e83b3346bbbc2544$var$three$1.Color($e83b3346bbbc2544$var$colorStr2Hex(photonColor));
                        var opacity = state.linkOpacity * 3;
                        var particleMaterial;
                        if (curPhoton && curPhoton.material.color.equals(materialColor) && curPhoton.material.opacity === opacity) particleMaterial = curPhoton.material;
                        else {
                            if (!particleMaterials.hasOwnProperty(photonColor)) particleMaterials[photonColor] = new $e83b3346bbbc2544$var$three$1.MeshLambertMaterial({
                                color: materialColor,
                                transparent: true,
                                opacity: opacity
                            });
                            particleMaterial = particleMaterials[photonColor];
                            curPhoton && curPhoton.material.dispose();
                        }
                        // digest cycle for each photon
                        $e83b3346bbbc2544$var$threeDigest($e83b3346bbbc2544$var$_toConsumableArray(new Array(numPhotons)).map(function(_, idx) {
                            return {
                                idx: idx
                            };
                        }), obj, {
                            idAccessor: function idAccessor(d) {
                                return d.idx;
                            },
                            createObj: function createObj() {
                                return new $e83b3346bbbc2544$var$three$1.Mesh(particleGeometry, particleMaterial);
                            },
                            updateObj: function updateObj(obj) {
                                obj.geometry = particleGeometry;
                                obj.material = particleMaterial;
                            }
                        });
                    }
                });
            }
        }
        state._flushObjects = false; // reset objects refresh flag
        // simulation engine
        if (hasAnyPropChanged([
            'graphData',
            'nodeId',
            'linkSource',
            'linkTarget',
            'numDimensions',
            'forceEngine',
            'dagMode',
            'dagNodeFilter',
            'dagLevelDistance'
        ])) {
            state.engineRunning = false; // Pause simulation
            // parse links
            state.graphData.links.forEach(function(link) {
                link.source = link[state.linkSource];
                link.target = link[state.linkTarget];
            });
            // Feed data to force-directed layout
            var isD3Sim = state.forceEngine !== 'ngraph';
            var layout;
            if (isD3Sim) {
                // D3-force
                (layout = state.d3ForceLayout).stop().alpha(1) // re-heat the simulation
                .numDimensions(state.numDimensions).nodes(state.graphData.nodes);
                // add links (if link force is still active)
                var linkForce = state.d3ForceLayout.force('link');
                if (linkForce) linkForce.id(function(d) {
                    return d[state.nodeId];
                }).links(state.graphData.links);
                // setup dag force constraints
                var nodeDepths = state.dagMode && $e83b3346bbbc2544$var$getDagDepths(state.graphData, function(node) {
                    return node[state.nodeId];
                }, {
                    nodeFilter: state.dagNodeFilter,
                    onLoopError: state.onDagError || undefined
                });
                var maxDepth = Math.max.apply(Math, $e83b3346bbbc2544$var$_toConsumableArray(Object.values(nodeDepths || [])));
                var dagLevelDistance = state.dagLevelDistance || state.graphData.nodes.length / (maxDepth || 1) * $e83b3346bbbc2544$var$DAG_LEVEL_NODE_RATIO * ([
                    'radialin',
                    'radialout'
                ].indexOf(state.dagMode) !== -1 ? 0.7 : 1);
                // Reset relevant f* when swapping dag modes
                if ([
                    'lr',
                    'rl',
                    'td',
                    'bu',
                    'zin',
                    'zout'
                ].includes(changedProps.dagMode)) {
                    var resetProp = [
                        'lr',
                        'rl'
                    ].includes(changedProps.dagMode) ? 'fx' : [
                        'td',
                        'bu'
                    ].includes(changedProps.dagMode) ? 'fy' : 'fz';
                    state.graphData.nodes.filter(state.dagNodeFilter).forEach(function(node) {
                        return delete node[resetProp];
                    });
                }
                // Fix nodes to x,y,z for dag mode
                if ([
                    'lr',
                    'rl',
                    'td',
                    'bu',
                    'zin',
                    'zout'
                ].includes(state.dagMode)) {
                    var invert = [
                        'rl',
                        'td',
                        'zout'
                    ].includes(state.dagMode);
                    var fixFn = function fixFn(node) {
                        return (nodeDepths[node[state.nodeId]] - maxDepth / 2) * dagLevelDistance * (invert ? -1 : 1);
                    };
                    var _resetProp = [
                        'lr',
                        'rl'
                    ].includes(state.dagMode) ? 'fx' : [
                        'td',
                        'bu'
                    ].includes(state.dagMode) ? 'fy' : 'fz';
                    state.graphData.nodes.filter(state.dagNodeFilter).forEach(function(node) {
                        return node[_resetProp] = fixFn(node);
                    });
                }
                // Use radial force for radial dags
                state.d3ForceLayout.force('dagRadial', [
                    'radialin',
                    'radialout'
                ].indexOf(state.dagMode) !== -1 ? (0, $91cad9d8ddc689ca$export$2e2bcd8739ae039)(function(node) {
                    var nodeDepth = nodeDepths[node[state.nodeId]] || -1;
                    return (state.dagMode === 'radialin' ? maxDepth - nodeDepth : nodeDepth) * dagLevelDistance;
                }).strength(function(node) {
                    return state.dagNodeFilter(node) ? 1 : 0;
                }) : null);
            } else {
                // ngraph
                var _graph = $e83b3346bbbc2544$var$ngraph.graph();
                state.graphData.nodes.forEach(function(node) {
                    _graph.addNode(node[state.nodeId]);
                });
                state.graphData.links.forEach(function(link) {
                    _graph.addLink(link.source, link.target);
                });
                layout = $e83b3346bbbc2544$var$ngraph.forcelayout(_graph, $e83b3346bbbc2544$var$_objectSpread2({
                    dimensions: state.numDimensions
                }, state.ngraphPhysics));
                layout.graph = _graph; // Attach graph reference to layout
            }
            for(var i = 0; i < state.warmupTicks && !(isD3Sim && state.d3AlphaMin > 0 && state.d3ForceLayout.alpha() < state.d3AlphaMin); i++)layout[isD3Sim ? "tick" : "step"]();
             // Initial ticks before starting to render
            state.layout = layout;
            this.resetCountdown();
        }
        state.engineRunning = true; // resume simulation
        state.onFinishUpdate();
    }
});
function $e83b3346bbbc2544$var$fromKapsule(kapsule) {
    var baseClass = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Object;
    var initKapsuleWithSelf = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var FromKapsule = /*#__PURE__*/ function(_baseClass) {
        function FromKapsule() {
            var _this;
            $e83b3346bbbc2544$var$_classCallCheck(this, FromKapsule);
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            _this = $e83b3346bbbc2544$var$_callSuper(this, FromKapsule, [].concat(args));
            _this.__kapsuleInstance = kapsule().apply(void 0, [].concat($e83b3346bbbc2544$var$_toConsumableArray(initKapsuleWithSelf ? [
                _this
            ] : []), args));
            return _this;
        }
        $e83b3346bbbc2544$var$_inherits(FromKapsule, _baseClass);
        return $e83b3346bbbc2544$var$_createClass(FromKapsule);
    }(baseClass); // attach kapsule props/methods to class prototype
    Object.keys(kapsule()).forEach(function(m) {
        return FromKapsule.prototype[m] = function() {
            var _this$__kapsuleInstan;
            var returnVal = (_this$__kapsuleInstan = this.__kapsuleInstance)[m].apply(_this$__kapsuleInstan, arguments);
            return returnVal === this.__kapsuleInstance ? this // chain based on this class, not the kapsule obj
             : returnVal;
        };
    });
    return FromKapsule;
}
var $e83b3346bbbc2544$var$three = window.THREE ? window.THREE : {
    Group: (0, $d5b33d7c30034067$export$eb2fcfdbd7ba97d4)
}; // Prefer consumption from global THREE, if exists
var $e83b3346bbbc2544$export$2e2bcd8739ae039 = $e83b3346bbbc2544$var$fromKapsule($e83b3346bbbc2544$var$ForceGraph, $e83b3346bbbc2544$var$three.Group, true);



class $a7019598ba21f125$var$Animation {
    constructor(nodes, info){
        this.nodes = nodes;
        this.info = info;
        this.animationLoop = null;
        this.requestId = null;
        this._init();
    }
    _init() {
        const update = (time, frame)=>{
            this.requestId = self.requestAnimationFrame(update);
            if (this.info.autoReset === true) this.info.reset();
            this.nodes.nodeFrame.update();
            this.info.frame = this.nodes.nodeFrame.frameId;
            if (this.animationLoop !== null) this.animationLoop(time, frame);
        };
        update();
    }
    dispose() {
        self.cancelAnimationFrame(this.requestId);
        this.requestId = null;
    }
    setAnimationLoop(callback) {
        this.animationLoop = callback;
    }
}
var $a7019598ba21f125$export$2e2bcd8739ae039 = $a7019598ba21f125$var$Animation;


class $aa043456f1edde49$export$2e2bcd8739ae039 {
    constructor(){
        this.weakMap = new WeakMap();
    }
    get(keys) {
        let map = this.weakMap;
        for(let i = 0; i < keys.length; i++){
            map = map.get(keys[i]);
            if (map === undefined) return undefined;
        }
        return map.get(keys[keys.length - 1]);
    }
    set(keys, value) {
        let map = this.weakMap;
        for(let i = 0; i < keys.length; i++){
            const key = keys[i];
            if (map.has(key) === false) map.set(key, new WeakMap());
            map = map.get(key);
        }
        return map.set(keys[keys.length - 1], value);
    }
    delete(keys) {
        let map = this.weakMap;
        for(let i = 0; i < keys.length; i++){
            map = map.get(keys[i]);
            if (map === undefined) return false;
        }
        return map.delete(keys[keys.length - 1]);
    }
}


const $7f727a3c7059d20d$var$_lut = [
    '00',
    '01',
    '02',
    '03',
    '04',
    '05',
    '06',
    '07',
    '08',
    '09',
    '0a',
    '0b',
    '0c',
    '0d',
    '0e',
    '0f',
    '10',
    '11',
    '12',
    '13',
    '14',
    '15',
    '16',
    '17',
    '18',
    '19',
    '1a',
    '1b',
    '1c',
    '1d',
    '1e',
    '1f',
    '20',
    '21',
    '22',
    '23',
    '24',
    '25',
    '26',
    '27',
    '28',
    '29',
    '2a',
    '2b',
    '2c',
    '2d',
    '2e',
    '2f',
    '30',
    '31',
    '32',
    '33',
    '34',
    '35',
    '36',
    '37',
    '38',
    '39',
    '3a',
    '3b',
    '3c',
    '3d',
    '3e',
    '3f',
    '40',
    '41',
    '42',
    '43',
    '44',
    '45',
    '46',
    '47',
    '48',
    '49',
    '4a',
    '4b',
    '4c',
    '4d',
    '4e',
    '4f',
    '50',
    '51',
    '52',
    '53',
    '54',
    '55',
    '56',
    '57',
    '58',
    '59',
    '5a',
    '5b',
    '5c',
    '5d',
    '5e',
    '5f',
    '60',
    '61',
    '62',
    '63',
    '64',
    '65',
    '66',
    '67',
    '68',
    '69',
    '6a',
    '6b',
    '6c',
    '6d',
    '6e',
    '6f',
    '70',
    '71',
    '72',
    '73',
    '74',
    '75',
    '76',
    '77',
    '78',
    '79',
    '7a',
    '7b',
    '7c',
    '7d',
    '7e',
    '7f',
    '80',
    '81',
    '82',
    '83',
    '84',
    '85',
    '86',
    '87',
    '88',
    '89',
    '8a',
    '8b',
    '8c',
    '8d',
    '8e',
    '8f',
    '90',
    '91',
    '92',
    '93',
    '94',
    '95',
    '96',
    '97',
    '98',
    '99',
    '9a',
    '9b',
    '9c',
    '9d',
    '9e',
    '9f',
    'a0',
    'a1',
    'a2',
    'a3',
    'a4',
    'a5',
    'a6',
    'a7',
    'a8',
    'a9',
    'aa',
    'ab',
    'ac',
    'ad',
    'ae',
    'af',
    'b0',
    'b1',
    'b2',
    'b3',
    'b4',
    'b5',
    'b6',
    'b7',
    'b8',
    'b9',
    'ba',
    'bb',
    'bc',
    'bd',
    'be',
    'bf',
    'c0',
    'c1',
    'c2',
    'c3',
    'c4',
    'c5',
    'c6',
    'c7',
    'c8',
    'c9',
    'ca',
    'cb',
    'cc',
    'cd',
    'ce',
    'cf',
    'd0',
    'd1',
    'd2',
    'd3',
    'd4',
    'd5',
    'd6',
    'd7',
    'd8',
    'd9',
    'da',
    'db',
    'dc',
    'dd',
    'de',
    'df',
    'e0',
    'e1',
    'e2',
    'e3',
    'e4',
    'e5',
    'e6',
    'e7',
    'e8',
    'e9',
    'ea',
    'eb',
    'ec',
    'ed',
    'ee',
    'ef',
    'f0',
    'f1',
    'f2',
    'f3',
    'f4',
    'f5',
    'f6',
    'f7',
    'f8',
    'f9',
    'fa',
    'fb',
    'fc',
    'fd',
    'fe',
    'ff'
];
let $7f727a3c7059d20d$var$_seed = 1234567;
const $7f727a3c7059d20d$export$460c4029b1a54a2e = Math.PI / 180;
const $7f727a3c7059d20d$export$914076c8150813e5 = 180 / Math.PI;
// http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/21963136#21963136
function $7f727a3c7059d20d$export$e73c8bd0f20705a() {
    const d0 = Math.random() * 0xffffffff | 0;
    const d1 = Math.random() * 0xffffffff | 0;
    const d2 = Math.random() * 0xffffffff | 0;
    const d3 = Math.random() * 0xffffffff | 0;
    const uuid = $7f727a3c7059d20d$var$_lut[d0 & 0xff] + $7f727a3c7059d20d$var$_lut[d0 >> 8 & 0xff] + $7f727a3c7059d20d$var$_lut[d0 >> 16 & 0xff] + $7f727a3c7059d20d$var$_lut[d0 >> 24 & 0xff] + '-' + $7f727a3c7059d20d$var$_lut[d1 & 0xff] + $7f727a3c7059d20d$var$_lut[d1 >> 8 & 0xff] + '-' + $7f727a3c7059d20d$var$_lut[d1 >> 16 & 0x0f | 0x40] + $7f727a3c7059d20d$var$_lut[d1 >> 24 & 0xff] + '-' + $7f727a3c7059d20d$var$_lut[d2 & 0x3f | 0x80] + $7f727a3c7059d20d$var$_lut[d2 >> 8 & 0xff] + '-' + $7f727a3c7059d20d$var$_lut[d2 >> 16 & 0xff] + $7f727a3c7059d20d$var$_lut[d2 >> 24 & 0xff] + $7f727a3c7059d20d$var$_lut[d3 & 0xff] + $7f727a3c7059d20d$var$_lut[d3 >> 8 & 0xff] + $7f727a3c7059d20d$var$_lut[d3 >> 16 & 0xff] + $7f727a3c7059d20d$var$_lut[d3 >> 24 & 0xff];
    // .toLowerCase() here flattens concatenated strings to save heap memory space.
    return uuid.toLowerCase();
}
function $7f727a3c7059d20d$export$7d15b64cf5a3a4c4(value, min, max) {
    return Math.max(min, Math.min(max, value));
}
// compute euclidean modulo of m % n
// https://en.wikipedia.org/wiki/Modulo_operation
function $7f727a3c7059d20d$export$3c11354a743b7f4e(n, m) {
    return (n % m + m) % m;
}
// Linear mapping from range <a1, a2> to range <b1, b2>
function $7f727a3c7059d20d$export$61343b3c0ad0a00a(x, a1, a2, b1, b2) {
    return b1 + (x - a1) * (b2 - b1) / (a2 - a1);
}
// https://www.gamedev.net/tutorials/programming/general-and-gameplay-programming/inverse-lerp-a-super-useful-yet-often-overlooked-function-r5230/
function $7f727a3c7059d20d$export$c45b79d581bbb999(x, y, value) {
    if (x !== y) return (value - x) / (y - x);
    else return 0;
}
// https://en.wikipedia.org/wiki/Linear_interpolation
function $7f727a3c7059d20d$export$3a89f8d6f6bf6c9f(x, y, t) {
    return (1 - t) * x + t * y;
}
// http://www.rorydriscoll.com/2016/03/07/frame-rate-independent-damping-using-lerp/
function $7f727a3c7059d20d$export$f81c1cb84e35b185(x, y, lambda, dt) {
    return $7f727a3c7059d20d$export$3a89f8d6f6bf6c9f(x, y, 1 - Math.exp(-lambda * dt));
}
// https://www.desmos.com/calculator/vcsjnyz7x4
function $7f727a3c7059d20d$export$1d919ae830ac5239(x, length = 1) {
    return length - Math.abs($7f727a3c7059d20d$export$3c11354a743b7f4e(x, length * 2) - length);
}
// http://en.wikipedia.org/wiki/Smoothstep
function $7f727a3c7059d20d$export$4053e36566dd3d9a(x, min, max) {
    if (x <= min) return 0;
    if (x >= max) return 1;
    x = (x - min) / (max - min);
    return x * x * (3 - 2 * x);
}
function $7f727a3c7059d20d$export$7509a5c452b9dce8(x, min, max) {
    if (x <= min) return 0;
    if (x >= max) return 1;
    x = (x - min) / (max - min);
    return x * x * x * (x * (x * 6 - 15) + 10);
}
// Random integer from <low, high> interval
function $7f727a3c7059d20d$export$a85cdcada2f6e6d0(low, high) {
    return low + Math.floor(Math.random() * (high - low + 1));
}
// Random float from <low, high> interval
function $7f727a3c7059d20d$export$8dceb61b660164cc(low, high) {
    return low + Math.random() * (high - low);
}
// Random float from <-range/2, range/2> interval
function $7f727a3c7059d20d$export$f093f4e85c7dea5a(range) {
    return range * (0.5 - Math.random());
}
// Deterministic pseudo-random float in the interval [ 0, 1 ]
function $7f727a3c7059d20d$export$d3abb7a3a61fb0cb(s) {
    if (s !== undefined) $7f727a3c7059d20d$var$_seed = s;
    // Mulberry32 generator
    let t = $7f727a3c7059d20d$var$_seed += 0x6D2B79F5;
    t = Math.imul(t ^ t >>> 15, t | 1);
    t ^= t + Math.imul(t ^ t >>> 7, t | 61);
    return ((t ^ t >>> 14) >>> 0) / 4294967296;
}
function $7f727a3c7059d20d$export$e6bfdeff8bfc94f9(degrees) {
    return degrees * $7f727a3c7059d20d$export$460c4029b1a54a2e;
}
function $7f727a3c7059d20d$export$54390e3b44c4a9cb(radians) {
    return radians * $7f727a3c7059d20d$export$914076c8150813e5;
}
function $7f727a3c7059d20d$export$b9e43d1765415474(value) {
    return (value & value - 1) === 0 && value !== 0;
}
function $7f727a3c7059d20d$export$150eaaaf1e7bb6f7(value) {
    return Math.pow(2, Math.ceil(Math.log(value) / Math.LN2));
}
function $7f727a3c7059d20d$export$b500f0356efda8ea(value) {
    return Math.pow(2, Math.floor(Math.log(value) / Math.LN2));
}
function $7f727a3c7059d20d$export$ef2201424fe649f7(q, a, b, c, order) {
    // Intrinsic Proper Euler Angles - see https://en.wikipedia.org/wiki/Euler_angles
    // rotations are applied to the axes in the order specified by 'order'
    // rotation by angle 'a' is applied first, then by angle 'b', then by angle 'c'
    // angles are in radians
    const cos = Math.cos;
    const sin = Math.sin;
    const c2 = cos(b / 2);
    const s2 = sin(b / 2);
    const c13 = cos((a + c) / 2);
    const s13 = sin((a + c) / 2);
    const c1_3 = cos((a - c) / 2);
    const s1_3 = sin((a - c) / 2);
    const c3_1 = cos((c - a) / 2);
    const s3_1 = sin((c - a) / 2);
    switch(order){
        case 'XYX':
            q.set(c2 * s13, s2 * c1_3, s2 * s1_3, c2 * c13);
            break;
        case 'YZY':
            q.set(s2 * s1_3, c2 * s13, s2 * c1_3, c2 * c13);
            break;
        case 'ZXZ':
            q.set(s2 * c1_3, s2 * s1_3, c2 * s13, c2 * c13);
            break;
        case 'XZX':
            q.set(c2 * s13, s2 * s3_1, s2 * c3_1, c2 * c13);
            break;
        case 'YXY':
            q.set(s2 * c3_1, c2 * s13, s2 * s3_1, c2 * c13);
            break;
        case 'ZYZ':
            q.set(s2 * s3_1, s2 * c3_1, c2 * s13, c2 * c13);
            break;
        default:
            console.warn('THREE.MathUtils: .setQuaternionFromProperEuler() encountered an unknown order: ' + order);
    }
}
function $7f727a3c7059d20d$export$be8b9fcbce8e8f70(value, array) {
    switch(array.constructor){
        case Float32Array:
            return value;
        case Uint32Array:
            return value / 4294967295.0;
        case Uint16Array:
            return value / 65535.0;
        case Uint8Array:
            return value / 255.0;
        case Int32Array:
            return Math.max(value / 2147483647.0, -1);
        case Int16Array:
            return Math.max(value / 32767.0, -1);
        case Int8Array:
            return Math.max(value / 127.0, -1);
        default:
            throw new Error('Invalid component type.');
    }
}
function $7f727a3c7059d20d$export$a3295358bff77e(value, array) {
    switch(array.constructor){
        case Float32Array:
            return value;
        case Uint32Array:
            return Math.round(value * 4294967295.0);
        case Uint16Array:
            return Math.round(value * 65535.0);
        case Uint8Array:
            return Math.round(value * 255.0);
        case Int32Array:
            return Math.round(value * 2147483647.0);
        case Int16Array:
            return Math.round(value * 32767.0);
        case Int8Array:
            return Math.round(value * 127.0);
        default:
            throw new Error('Invalid component type.');
    }
}
const $7f727a3c7059d20d$export$6a7ef315a0d1ef07 = {
    DEG2RAD: $7f727a3c7059d20d$export$460c4029b1a54a2e,
    RAD2DEG: $7f727a3c7059d20d$export$914076c8150813e5,
    generateUUID: $7f727a3c7059d20d$export$e73c8bd0f20705a,
    clamp: $7f727a3c7059d20d$export$7d15b64cf5a3a4c4,
    euclideanModulo: $7f727a3c7059d20d$export$3c11354a743b7f4e,
    mapLinear: $7f727a3c7059d20d$export$61343b3c0ad0a00a,
    inverseLerp: $7f727a3c7059d20d$export$c45b79d581bbb999,
    lerp: $7f727a3c7059d20d$export$3a89f8d6f6bf6c9f,
    damp: $7f727a3c7059d20d$export$f81c1cb84e35b185,
    pingpong: $7f727a3c7059d20d$export$1d919ae830ac5239,
    smoothstep: $7f727a3c7059d20d$export$4053e36566dd3d9a,
    smootherstep: $7f727a3c7059d20d$export$7509a5c452b9dce8,
    randInt: $7f727a3c7059d20d$export$a85cdcada2f6e6d0,
    randFloat: $7f727a3c7059d20d$export$8dceb61b660164cc,
    randFloatSpread: $7f727a3c7059d20d$export$f093f4e85c7dea5a,
    seededRandom: $7f727a3c7059d20d$export$d3abb7a3a61fb0cb,
    degToRad: $7f727a3c7059d20d$export$e6bfdeff8bfc94f9,
    radToDeg: $7f727a3c7059d20d$export$54390e3b44c4a9cb,
    isPowerOfTwo: $7f727a3c7059d20d$export$b9e43d1765415474,
    ceilPowerOfTwo: $7f727a3c7059d20d$export$150eaaaf1e7bb6f7,
    floorPowerOfTwo: $7f727a3c7059d20d$export$b500f0356efda8ea,
    setQuaternionFromProperEuler: $7f727a3c7059d20d$export$ef2201424fe649f7,
    normalize: $7f727a3c7059d20d$export$a3295358bff77e,
    denormalize: $7f727a3c7059d20d$export$be8b9fcbce8e8f70
};


const $cb5ee595c0f892af$export$3545e07a80636437 = '170';
const $cb5ee595c0f892af$export$7177b3e430c2d7ca = {
    LEFT: 0,
    MIDDLE: 1,
    RIGHT: 2,
    ROTATE: 0,
    DOLLY: 1,
    PAN: 2
};
const $cb5ee595c0f892af$export$d46bd3ead7cc759b = {
    ROTATE: 0,
    PAN: 1,
    DOLLY_PAN: 2,
    DOLLY_ROTATE: 3
};
const $cb5ee595c0f892af$export$3237e1f2c1ea1f44 = 0;
const $cb5ee595c0f892af$export$b9a7b4fc5cb15f9b = 1;
const $cb5ee595c0f892af$export$b8058bcc7037d3f3 = 2;
const $cb5ee595c0f892af$export$f24be24dcddeac0d = 3;
const $cb5ee595c0f892af$export$346307dbae2b7447 = 0;
const $cb5ee595c0f892af$export$5813f879eee7cd88 = 1;
const $cb5ee595c0f892af$export$a47c4b43a1be34f0 = 2;
const $cb5ee595c0f892af$export$896ae1ade6c829c4 = 3;
const $cb5ee595c0f892af$export$2ede184fc2998901 = 0;
const $cb5ee595c0f892af$export$d9f0486e75b5ace = 1;
const $cb5ee595c0f892af$export$3b296b6f144d5b03 = 2;
const $cb5ee595c0f892af$export$63b8d6b580fc65ba = 0;
const $cb5ee595c0f892af$export$5b29a26d96ee6af0 = 1;
const $cb5ee595c0f892af$export$777d8f9551c2216b = 2;
const $cb5ee595c0f892af$export$cdfa06f868e2e467 = 3;
const $cb5ee595c0f892af$export$4138e1c684b46a20 = 4;
const $cb5ee595c0f892af$export$eda4864c68df1fa2 = 5;
const $cb5ee595c0f892af$export$20183a0484ce21a0 = 100;
const $cb5ee595c0f892af$export$73e0df5177988548 = 101;
const $cb5ee595c0f892af$export$28e582859cbec660 = 102;
const $cb5ee595c0f892af$export$c8c1508da8d0600c = 103;
const $cb5ee595c0f892af$export$99948c02fb51055f = 104;
const $cb5ee595c0f892af$export$2110f05edf778d3d = 200;
const $cb5ee595c0f892af$export$8805bad65e24940e = 201;
const $cb5ee595c0f892af$export$7fbe15b28d28cf52 = 202;
const $cb5ee595c0f892af$export$947829af9f2c17f6 = 203;
const $cb5ee595c0f892af$export$d5773124e86cf28c = 204;
const $cb5ee595c0f892af$export$11d468cc7f19e971 = 205;
const $cb5ee595c0f892af$export$a78aed1ca2a87192 = 206;
const $cb5ee595c0f892af$export$5d0fe17fd8773bac = 207;
const $cb5ee595c0f892af$export$ef5f2dd8ffac5574 = 208;
const $cb5ee595c0f892af$export$56b85b2686ab16 = 209;
const $cb5ee595c0f892af$export$c05e2a1fc8609506 = 210;
const $cb5ee595c0f892af$export$7dd8f434fd59075 = 211;
const $cb5ee595c0f892af$export$99c8d898a9afbcee = 212;
const $cb5ee595c0f892af$export$310cd2be38d13b56 = 213;
const $cb5ee595c0f892af$export$db77b8fbcf45dbf4 = 214;
const $cb5ee595c0f892af$export$69025ce147cee220 = 0;
const $cb5ee595c0f892af$export$7182eb52ea3b3f04 = 1;
const $cb5ee595c0f892af$export$eedccec66ab7ebe = 2;
const $cb5ee595c0f892af$export$296f78a0b892f81a = 3;
const $cb5ee595c0f892af$export$a60d398fc7b7590e = 4;
const $cb5ee595c0f892af$export$7d7234c1240a1fc4 = 5;
const $cb5ee595c0f892af$export$c5e2c52991f30937 = 6;
const $cb5ee595c0f892af$export$2f843afa843d8916 = 7;
const $cb5ee595c0f892af$export$e50ac29801f1774d = 0;
const $cb5ee595c0f892af$export$9f9d94f963c85479 = 1;
const $cb5ee595c0f892af$export$e641dc52bc3494aa = 2;
const $cb5ee595c0f892af$export$9fcb6b4294603b2 = 0;
const $cb5ee595c0f892af$export$98f52c2a46c598ca = 1;
const $cb5ee595c0f892af$export$74b25e54b3bcd548 = 2;
const $cb5ee595c0f892af$export$932b3dd283d4a366 = 3;
const $cb5ee595c0f892af$export$a0d98fe6d7e4af64 = 4;
const $cb5ee595c0f892af$export$2c7b09c1e9abfb5e = 5;
const $cb5ee595c0f892af$export$212d53a513a325b2 = 6;
const $cb5ee595c0f892af$export$f2863e1668a8e317 = 7;
const $cb5ee595c0f892af$export$2595a3798997538 = 'attached';
const $cb5ee595c0f892af$export$d7e7dc2e114517a0 = 'detached';
const $cb5ee595c0f892af$export$1beec6768cbb3d2d = 300;
const $cb5ee595c0f892af$export$8759762a6477f2c4 = 301;
const $cb5ee595c0f892af$export$dc59f8aed047f61d = 302;
const $cb5ee595c0f892af$export$d64030b316d3b087 = 303;
const $cb5ee595c0f892af$export$ee99d97d46898098 = 304;
const $cb5ee595c0f892af$export$dbf3e70ff37af79 = 306;
const $cb5ee595c0f892af$export$533346c8e8dac0f5 = 1000;
const $cb5ee595c0f892af$export$9d9334239a5a5e06 = 1001;
const $cb5ee595c0f892af$export$c7e7c00b14f51a4f = 1002;
const $cb5ee595c0f892af$export$727aa5ec3fe39bf0 = 1003;
const $cb5ee595c0f892af$export$d129e38cf6feaa8c = 1004;
const $cb5ee595c0f892af$export$14a4936464a36496 = 1004;
const $cb5ee595c0f892af$export$d2327c1afe5bfdf2 = 1005;
const $cb5ee595c0f892af$export$cbc5b7f5647595d8 = 1005;
const $cb5ee595c0f892af$export$8a72f490b25c56c8 = 1006;
const $cb5ee595c0f892af$export$19a719f377145a13 = 1007;
const $cb5ee595c0f892af$export$dbe96bee3fe9dbf0 = 1007;
const $cb5ee595c0f892af$export$5d8599b6a933fb1b = 1008;
const $cb5ee595c0f892af$export$90d80f1e3506775f = 1008;
const $cb5ee595c0f892af$export$2e8ce08d3f6f5e10 = 1009;
const $cb5ee595c0f892af$export$545fce0311a9796a = 1010;
const $cb5ee595c0f892af$export$88572337f312435f = 1011;
const $cb5ee595c0f892af$export$c63dc51868b06a9d = 1012;
const $cb5ee595c0f892af$export$5c612977753abe2 = 1013;
const $cb5ee595c0f892af$export$c3c7fc4518ebba96 = 1014;
const $cb5ee595c0f892af$export$f6d331659b644596 = 1015;
const $cb5ee595c0f892af$export$2697304443f382bc = 1016;
const $cb5ee595c0f892af$export$b3969b01faf587f2 = 1017;
const $cb5ee595c0f892af$export$18886f8ae33e90de = 1018;
const $cb5ee595c0f892af$export$6c8ea339bfab1301 = 1020;
const $cb5ee595c0f892af$export$5a4c329b7e2092d3 = 35902;
const $cb5ee595c0f892af$export$988473390501ed4b = 1021;
const $cb5ee595c0f892af$export$7c67423a5ee6f5eb = 1022;
const $cb5ee595c0f892af$export$3f8bb04b555a363c = 1023;
const $cb5ee595c0f892af$export$cc09ccbf6d1ed449 = 1024;
const $cb5ee595c0f892af$export$9053a81c4a69c289 = 1025;
const $cb5ee595c0f892af$export$c1b6b5136be58045 = 1026;
const $cb5ee595c0f892af$export$1e113ac2d0905829 = 1027;
const $cb5ee595c0f892af$export$4e041a7967d15c4b = 1028;
const $cb5ee595c0f892af$export$aa92e870a709d190 = 1029;
const $cb5ee595c0f892af$export$6cdf0b461c7ce8a0 = 1030;
const $cb5ee595c0f892af$export$1ba1c45f9f77d4d7 = 1031;
const $cb5ee595c0f892af$export$d1fd40c11bfa798e = 1032;
const $cb5ee595c0f892af$export$c200e7d26f592f21 = 1033;
const $cb5ee595c0f892af$export$21d1799c6d552fc0 = 33776;
const $cb5ee595c0f892af$export$afa304c3e981b668 = 33777;
const $cb5ee595c0f892af$export$d2a1a68024a3e56c = 33778;
const $cb5ee595c0f892af$export$9a79c424327dacf9 = 33779;
const $cb5ee595c0f892af$export$19ada9bbb1af3573 = 35840;
const $cb5ee595c0f892af$export$d0f0355bb3d948e4 = 35841;
const $cb5ee595c0f892af$export$b82296714358084c = 35842;
const $cb5ee595c0f892af$export$b71692456c47b6c3 = 35843;
const $cb5ee595c0f892af$export$6ab91af2d757aee7 = 36196;
const $cb5ee595c0f892af$export$7800993ef8106a6a = 37492;
const $cb5ee595c0f892af$export$23ed8300a860e7d8 = 37496;
const $cb5ee595c0f892af$export$dc5570b4a2b92d48 = 37808;
const $cb5ee595c0f892af$export$68880cd325f8b2fb = 37809;
const $cb5ee595c0f892af$export$7d2c0be323373d95 = 37810;
const $cb5ee595c0f892af$export$22b52da301fc3a3e = 37811;
const $cb5ee595c0f892af$export$c009e2cb4a66485e = 37812;
const $cb5ee595c0f892af$export$118fff5afa255b63 = 37813;
const $cb5ee595c0f892af$export$120713c829ae0667 = 37814;
const $cb5ee595c0f892af$export$c79eeabbf53313e9 = 37815;
const $cb5ee595c0f892af$export$443cf6567cdd6424 = 37816;
const $cb5ee595c0f892af$export$6573984fc9840780 = 37817;
const $cb5ee595c0f892af$export$e7aee563f30091de = 37818;
const $cb5ee595c0f892af$export$2eb8634622ddeab7 = 37819;
const $cb5ee595c0f892af$export$202b1ce7b5d25742 = 37820;
const $cb5ee595c0f892af$export$18ab77abd087e467 = 37821;
const $cb5ee595c0f892af$export$ce40b115e188bc81 = 36492;
const $cb5ee595c0f892af$export$d279c5c4bac5121e = 36494;
const $cb5ee595c0f892af$export$cde52d17225fdbd3 = 36495;
const $cb5ee595c0f892af$export$b1688df4c4c21670 = 36283;
const $cb5ee595c0f892af$export$fc15e5d8261eed58 = 36284;
const $cb5ee595c0f892af$export$d220f6ade8463a0f = 36285;
const $cb5ee595c0f892af$export$768646d09dc1b6ef = 36286;
const $cb5ee595c0f892af$export$d62fdc9d1b1cccad = 2200;
const $cb5ee595c0f892af$export$dfaf4422ce096e29 = 2201;
const $cb5ee595c0f892af$export$f8f6f2041b78e210 = 2202;
const $cb5ee595c0f892af$export$995b32462a65e855 = 2300;
const $cb5ee595c0f892af$export$30fac1aace31cf4d = 2301;
const $cb5ee595c0f892af$export$198b11ff4c72bb30 = 2302;
const $cb5ee595c0f892af$export$7f795934b84ab523 = 2400;
const $cb5ee595c0f892af$export$24a4ccb5099273b5 = 2401;
const $cb5ee595c0f892af$export$8e8c3ecdcd8e1fee = 2402;
const $cb5ee595c0f892af$export$bcfbbdcf8de7f8cd = 2500;
const $cb5ee595c0f892af$export$d875e029ef558d3 = 2501;
const $cb5ee595c0f892af$export$4c28c87c2dc84758 = 0;
const $cb5ee595c0f892af$export$b23a071aa286eb29 = 1;
const $cb5ee595c0f892af$export$f0d8293634f88842 = 2;
const $cb5ee595c0f892af$export$deeb383078690b50 = 3200;
const $cb5ee595c0f892af$export$8f910f4c4f73df11 = 3201;
const $cb5ee595c0f892af$export$be2e2ddbc3983173 = 3202;
const $cb5ee595c0f892af$export$1a54198784742f80 = 3203;
const $cb5ee595c0f892af$export$2852a58ebdac27b8 = 0;
const $cb5ee595c0f892af$export$9990ad26f9db5b2c = 1;
const $cb5ee595c0f892af$export$bfcb490c2dd3db51 = '';
const $cb5ee595c0f892af$export$561f394b24edfcaa = 'srgb';
const $cb5ee595c0f892af$export$42429b3acfb233a4 = 'srgb-linear';
const $cb5ee595c0f892af$export$f197347d588c1b4a = 'linear';
const $cb5ee595c0f892af$export$8d0a61916cc26abb = 'srgb';
const $cb5ee595c0f892af$export$69433f11f42d5527 = 0;
const $cb5ee595c0f892af$export$9f542ae4b5baca34 = 7680;
const $cb5ee595c0f892af$export$8a4f28336ef203d3 = 7681;
const $cb5ee595c0f892af$export$2928c0231297c036 = 7682;
const $cb5ee595c0f892af$export$c0e9611c8a15f9a8 = 7683;
const $cb5ee595c0f892af$export$9c2c08927385dcc4 = 34055;
const $cb5ee595c0f892af$export$7c74ea00fa1315e6 = 34056;
const $cb5ee595c0f892af$export$22e2e5726612443 = 5386;
const $cb5ee595c0f892af$export$1343870698229224 = 512;
const $cb5ee595c0f892af$export$8e1d8ed281997fa6 = 513;
const $cb5ee595c0f892af$export$55648a1cde8329a7 = 514;
const $cb5ee595c0f892af$export$2dff107857e6aca2 = 515;
const $cb5ee595c0f892af$export$6f93765ab2f451a2 = 516;
const $cb5ee595c0f892af$export$6f3fb2d2440f2b76 = 517;
const $cb5ee595c0f892af$export$4119cf7b4c98fd5a = 518;
const $cb5ee595c0f892af$export$14cf96713ddd97a8 = 519;
const $cb5ee595c0f892af$export$d9e2d19a747baaab = 512;
const $cb5ee595c0f892af$export$36bcf49c713b3eb7 = 513;
const $cb5ee595c0f892af$export$66f28d946fc6a0d5 = 514;
const $cb5ee595c0f892af$export$64eea11eb407ddf1 = 515;
const $cb5ee595c0f892af$export$155af022118f3a38 = 516;
const $cb5ee595c0f892af$export$67ab95dde6bed156 = 517;
const $cb5ee595c0f892af$export$1cdcb70d53d65f61 = 518;
const $cb5ee595c0f892af$export$187b73a3e352c145 = 519;
const $cb5ee595c0f892af$export$763e8360f4d7f77d = 35044;
const $cb5ee595c0f892af$export$8505d14ac8546ca = 35048;
const $cb5ee595c0f892af$export$721e63549e51d81e = 35040;
const $cb5ee595c0f892af$export$415731dc4f48e299 = 35045;
const $cb5ee595c0f892af$export$9e809946455f13bc = 35049;
const $cb5ee595c0f892af$export$2ed9499a35b5f832 = 35041;
const $cb5ee595c0f892af$export$32ab2503ea19469a = 35046;
const $cb5ee595c0f892af$export$ab4022c2c3f86315 = 35050;
const $cb5ee595c0f892af$export$ba7f1db36a76a970 = 35042;
const $cb5ee595c0f892af$export$43600cc67fabd9f = '100';
const $cb5ee595c0f892af$export$f63012db5506e7dd = '300 es';
const $cb5ee595c0f892af$export$5a0e9190d10875d3 = 2000;
const $cb5ee595c0f892af$export$cc83beedcb9be9ac = 2001;


class $800ed18490319df2$export$8ff26dafa08918 {
    constructor(n11, n12, n13, n21, n22, n23, n31, n32, n33){
        $800ed18490319df2$export$8ff26dafa08918.prototype.isMatrix3 = true;
        this.elements = [
            1,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            1
        ];
        if (n11 !== undefined) this.set(n11, n12, n13, n21, n22, n23, n31, n32, n33);
    }
    set(n11, n12, n13, n21, n22, n23, n31, n32, n33) {
        const te = this.elements;
        te[0] = n11;
        te[1] = n21;
        te[2] = n31;
        te[3] = n12;
        te[4] = n22;
        te[5] = n32;
        te[6] = n13;
        te[7] = n23;
        te[8] = n33;
        return this;
    }
    identity() {
        this.set(1, 0, 0, 0, 1, 0, 0, 0, 1);
        return this;
    }
    copy(m) {
        const te = this.elements;
        const me = m.elements;
        te[0] = me[0];
        te[1] = me[1];
        te[2] = me[2];
        te[3] = me[3];
        te[4] = me[4];
        te[5] = me[5];
        te[6] = me[6];
        te[7] = me[7];
        te[8] = me[8];
        return this;
    }
    extractBasis(xAxis, yAxis, zAxis) {
        xAxis.setFromMatrix3Column(this, 0);
        yAxis.setFromMatrix3Column(this, 1);
        zAxis.setFromMatrix3Column(this, 2);
        return this;
    }
    setFromMatrix4(m) {
        const me = m.elements;
        this.set(me[0], me[4], me[8], me[1], me[5], me[9], me[2], me[6], me[10]);
        return this;
    }
    multiply(m) {
        return this.multiplyMatrices(this, m);
    }
    premultiply(m) {
        return this.multiplyMatrices(m, this);
    }
    multiplyMatrices(a, b) {
        const ae = a.elements;
        const be = b.elements;
        const te = this.elements;
        const a11 = ae[0], a12 = ae[3], a13 = ae[6];
        const a21 = ae[1], a22 = ae[4], a23 = ae[7];
        const a31 = ae[2], a32 = ae[5], a33 = ae[8];
        const b11 = be[0], b12 = be[3], b13 = be[6];
        const b21 = be[1], b22 = be[4], b23 = be[7];
        const b31 = be[2], b32 = be[5], b33 = be[8];
        te[0] = a11 * b11 + a12 * b21 + a13 * b31;
        te[3] = a11 * b12 + a12 * b22 + a13 * b32;
        te[6] = a11 * b13 + a12 * b23 + a13 * b33;
        te[1] = a21 * b11 + a22 * b21 + a23 * b31;
        te[4] = a21 * b12 + a22 * b22 + a23 * b32;
        te[7] = a21 * b13 + a22 * b23 + a23 * b33;
        te[2] = a31 * b11 + a32 * b21 + a33 * b31;
        te[5] = a31 * b12 + a32 * b22 + a33 * b32;
        te[8] = a31 * b13 + a32 * b23 + a33 * b33;
        return this;
    }
    multiplyScalar(s) {
        const te = this.elements;
        te[0] *= s;
        te[3] *= s;
        te[6] *= s;
        te[1] *= s;
        te[4] *= s;
        te[7] *= s;
        te[2] *= s;
        te[5] *= s;
        te[8] *= s;
        return this;
    }
    determinant() {
        const te = this.elements;
        const a = te[0], b = te[1], c = te[2], d = te[3], e = te[4], f = te[5], g = te[6], h = te[7], i = te[8];
        return a * e * i - a * f * h - b * d * i + b * f * g + c * d * h - c * e * g;
    }
    invert() {
        const te = this.elements, n11 = te[0], n21 = te[1], n31 = te[2], n12 = te[3], n22 = te[4], n32 = te[5], n13 = te[6], n23 = te[7], n33 = te[8], t11 = n33 * n22 - n32 * n23, t12 = n32 * n13 - n33 * n12, t13 = n23 * n12 - n22 * n13, det = n11 * t11 + n21 * t12 + n31 * t13;
        if (det === 0) return this.set(0, 0, 0, 0, 0, 0, 0, 0, 0);
        const detInv = 1 / det;
        te[0] = t11 * detInv;
        te[1] = (n31 * n23 - n33 * n21) * detInv;
        te[2] = (n32 * n21 - n31 * n22) * detInv;
        te[3] = t12 * detInv;
        te[4] = (n33 * n11 - n31 * n13) * detInv;
        te[5] = (n31 * n12 - n32 * n11) * detInv;
        te[6] = t13 * detInv;
        te[7] = (n21 * n13 - n23 * n11) * detInv;
        te[8] = (n22 * n11 - n21 * n12) * detInv;
        return this;
    }
    transpose() {
        let tmp;
        const m = this.elements;
        tmp = m[1];
        m[1] = m[3];
        m[3] = tmp;
        tmp = m[2];
        m[2] = m[6];
        m[6] = tmp;
        tmp = m[5];
        m[5] = m[7];
        m[7] = tmp;
        return this;
    }
    getNormalMatrix(matrix4) {
        return this.setFromMatrix4(matrix4).invert().transpose();
    }
    transposeIntoArray(r) {
        const m = this.elements;
        r[0] = m[0];
        r[1] = m[3];
        r[2] = m[6];
        r[3] = m[1];
        r[4] = m[4];
        r[5] = m[7];
        r[6] = m[2];
        r[7] = m[5];
        r[8] = m[8];
        return this;
    }
    setUvTransform(tx, ty, sx, sy, rotation, cx, cy) {
        const c = Math.cos(rotation);
        const s = Math.sin(rotation);
        this.set(sx * c, sx * s, -sx * (c * cx + s * cy) + cx + tx, -sy * s, sy * c, -sy * (-s * cx + c * cy) + cy + ty, 0, 0, 1);
        return this;
    }
    //
    scale(sx, sy) {
        this.premultiply($800ed18490319df2$var$_m3.makeScale(sx, sy));
        return this;
    }
    rotate(theta) {
        this.premultiply($800ed18490319df2$var$_m3.makeRotation(-theta));
        return this;
    }
    translate(tx, ty) {
        this.premultiply($800ed18490319df2$var$_m3.makeTranslation(tx, ty));
        return this;
    }
    // for 2D Transforms
    makeTranslation(x, y) {
        if (x.isVector2) this.set(1, 0, x.x, 0, 1, x.y, 0, 0, 1);
        else this.set(1, 0, x, 0, 1, y, 0, 0, 1);
        return this;
    }
    makeRotation(theta) {
        // counterclockwise
        const c = Math.cos(theta);
        const s = Math.sin(theta);
        this.set(c, -s, 0, s, c, 0, 0, 0, 1);
        return this;
    }
    makeScale(x, y) {
        this.set(x, 0, 0, 0, y, 0, 0, 0, 1);
        return this;
    }
    //
    equals(matrix) {
        const te = this.elements;
        const me = matrix.elements;
        for(let i = 0; i < 9; i++){
            if (te[i] !== me[i]) return false;
        }
        return true;
    }
    fromArray(array, offset = 0) {
        for(let i = 0; i < 9; i++)this.elements[i] = array[i + offset];
        return this;
    }
    toArray(array = [], offset = 0) {
        const te = this.elements;
        array[offset] = te[0];
        array[offset + 1] = te[1];
        array[offset + 2] = te[2];
        array[offset + 3] = te[3];
        array[offset + 4] = te[4];
        array[offset + 5] = te[5];
        array[offset + 6] = te[6];
        array[offset + 7] = te[7];
        array[offset + 8] = te[8];
        return array;
    }
    clone() {
        return new this.constructor().fromArray(this.elements);
    }
}
const $800ed18490319df2$var$_m3 = /*@__PURE__*/ new $800ed18490319df2$export$8ff26dafa08918();


const $46d4f6f1be9702a8$export$5e6fd513f44698c = {
    enabled: true,
    workingColorSpace: (0, $cb5ee595c0f892af$export$42429b3acfb233a4),
    /**
	 * Implementations of supported color spaces.
	 *
	 * Required:
	 *	- primaries: chromaticity coordinates [ rx ry gx gy bx by ]
	 *	- whitePoint: reference white [ x y ]
	 *	- transfer: transfer function (pre-defined)
	 *	- toXYZ: Matrix3 RGB to XYZ transform
	 *	- fromXYZ: Matrix3 XYZ to RGB transform
	 *	- luminanceCoefficients: RGB luminance coefficients
	 *
	 * Optional:
	 *  - outputColorSpaceConfig: { drawingBufferColorSpace: ColorSpace }
	 *  - workingColorSpaceConfig: { unpackColorSpace: ColorSpace }
	 *
	 * Reference:
	 * - https://www.russellcottrell.com/photo/matrixCalculator.htm
	 */ spaces: {},
    convert: function(color, sourceColorSpace, targetColorSpace) {
        if (this.enabled === false || sourceColorSpace === targetColorSpace || !sourceColorSpace || !targetColorSpace) return color;
        if (this.spaces[sourceColorSpace].transfer === (0, $cb5ee595c0f892af$export$8d0a61916cc26abb)) {
            color.r = $46d4f6f1be9702a8$export$22855367bc41ba49(color.r);
            color.g = $46d4f6f1be9702a8$export$22855367bc41ba49(color.g);
            color.b = $46d4f6f1be9702a8$export$22855367bc41ba49(color.b);
        }
        if (this.spaces[sourceColorSpace].primaries !== this.spaces[targetColorSpace].primaries) {
            color.applyMatrix3(this.spaces[sourceColorSpace].toXYZ);
            color.applyMatrix3(this.spaces[targetColorSpace].fromXYZ);
        }
        if (this.spaces[targetColorSpace].transfer === (0, $cb5ee595c0f892af$export$8d0a61916cc26abb)) {
            color.r = $46d4f6f1be9702a8$export$cb64753382238f37(color.r);
            color.g = $46d4f6f1be9702a8$export$cb64753382238f37(color.g);
            color.b = $46d4f6f1be9702a8$export$cb64753382238f37(color.b);
        }
        return color;
    },
    fromWorkingColorSpace: function(color, targetColorSpace) {
        return this.convert(color, this.workingColorSpace, targetColorSpace);
    },
    toWorkingColorSpace: function(color, sourceColorSpace) {
        return this.convert(color, sourceColorSpace, this.workingColorSpace);
    },
    getPrimaries: function(colorSpace) {
        return this.spaces[colorSpace].primaries;
    },
    getTransfer: function(colorSpace) {
        if (colorSpace === (0, $cb5ee595c0f892af$export$bfcb490c2dd3db51)) return 0, $cb5ee595c0f892af$export$f197347d588c1b4a;
        return this.spaces[colorSpace].transfer;
    },
    getLuminanceCoefficients: function(target, colorSpace = this.workingColorSpace) {
        return target.fromArray(this.spaces[colorSpace].luminanceCoefficients);
    },
    define: function(colorSpaces) {
        Object.assign(this.spaces, colorSpaces);
    },
    // Internal APIs
    _getMatrix: function(targetMatrix, sourceColorSpace, targetColorSpace) {
        return targetMatrix.copy(this.spaces[sourceColorSpace].toXYZ).multiply(this.spaces[targetColorSpace].fromXYZ);
    },
    _getDrawingBufferColorSpace: function(colorSpace) {
        return this.spaces[colorSpace].outputColorSpaceConfig.drawingBufferColorSpace;
    },
    _getUnpackColorSpace: function(colorSpace = this.workingColorSpace) {
        return this.spaces[colorSpace].workingColorSpaceConfig.unpackColorSpace;
    }
};
function $46d4f6f1be9702a8$export$22855367bc41ba49(c) {
    return c < 0.04045 ? c * 0.0773993808 : Math.pow(c * 0.9478672986 + 0.0521327014, 2.4);
}
function $46d4f6f1be9702a8$export$cb64753382238f37(c) {
    return c < 0.0031308 ? c * 12.92 : 1.055 * Math.pow(c, 0.41666) - 0.055;
}
/******************************************************************************
 * sRGB definitions
 */ const $46d4f6f1be9702a8$var$REC709_PRIMARIES = [
    0.640,
    0.330,
    0.300,
    0.600,
    0.150,
    0.060
];
const $46d4f6f1be9702a8$var$REC709_LUMINANCE_COEFFICIENTS = [
    0.2126,
    0.7152,
    0.0722
];
const $46d4f6f1be9702a8$var$D65 = [
    0.3127,
    0.3290
];
const $46d4f6f1be9702a8$var$LINEAR_REC709_TO_XYZ = /*@__PURE__*/ new (0, $800ed18490319df2$export$8ff26dafa08918)().set(0.4123908, 0.3575843, 0.1804808, 0.2126390, 0.7151687, 0.0721923, 0.0193308, 0.1191948, 0.9505322);
const $46d4f6f1be9702a8$var$XYZ_TO_LINEAR_REC709 = /*@__PURE__*/ new (0, $800ed18490319df2$export$8ff26dafa08918)().set(3.2409699, -1.5373832, -0.4986108, -0.9692436, 1.8759675, 0.0415551, 0.0556301, -0.203977, 1.0569715);
$46d4f6f1be9702a8$export$5e6fd513f44698c.define({
    [(0, $cb5ee595c0f892af$export$42429b3acfb233a4)]: {
        primaries: $46d4f6f1be9702a8$var$REC709_PRIMARIES,
        whitePoint: $46d4f6f1be9702a8$var$D65,
        transfer: (0, $cb5ee595c0f892af$export$f197347d588c1b4a),
        toXYZ: $46d4f6f1be9702a8$var$LINEAR_REC709_TO_XYZ,
        fromXYZ: $46d4f6f1be9702a8$var$XYZ_TO_LINEAR_REC709,
        luminanceCoefficients: $46d4f6f1be9702a8$var$REC709_LUMINANCE_COEFFICIENTS,
        workingColorSpaceConfig: {
            unpackColorSpace: (0, $cb5ee595c0f892af$export$561f394b24edfcaa)
        },
        outputColorSpaceConfig: {
            drawingBufferColorSpace: (0, $cb5ee595c0f892af$export$561f394b24edfcaa)
        }
    },
    [(0, $cb5ee595c0f892af$export$561f394b24edfcaa)]: {
        primaries: $46d4f6f1be9702a8$var$REC709_PRIMARIES,
        whitePoint: $46d4f6f1be9702a8$var$D65,
        transfer: (0, $cb5ee595c0f892af$export$8d0a61916cc26abb),
        toXYZ: $46d4f6f1be9702a8$var$LINEAR_REC709_TO_XYZ,
        fromXYZ: $46d4f6f1be9702a8$var$XYZ_TO_LINEAR_REC709,
        luminanceCoefficients: $46d4f6f1be9702a8$var$REC709_LUMINANCE_COEFFICIENTS,
        outputColorSpaceConfig: {
            drawingBufferColorSpace: (0, $cb5ee595c0f892af$export$561f394b24edfcaa)
        }
    }
});



const $9a23ce591a1b6760$var$_colorKeywords = {
    'aliceblue': 0xF0F8FF,
    'antiquewhite': 0xFAEBD7,
    'aqua': 0x00FFFF,
    'aquamarine': 0x7FFFD4,
    'azure': 0xF0FFFF,
    'beige': 0xF5F5DC,
    'bisque': 0xFFE4C4,
    'black': 0x000000,
    'blanchedalmond': 0xFFEBCD,
    'blue': 0x0000FF,
    'blueviolet': 0x8A2BE2,
    'brown': 0xA52A2A,
    'burlywood': 0xDEB887,
    'cadetblue': 0x5F9EA0,
    'chartreuse': 0x7FFF00,
    'chocolate': 0xD2691E,
    'coral': 0xFF7F50,
    'cornflowerblue': 0x6495ED,
    'cornsilk': 0xFFF8DC,
    'crimson': 0xDC143C,
    'cyan': 0x00FFFF,
    'darkblue': 0x00008B,
    'darkcyan': 0x008B8B,
    'darkgoldenrod': 0xB8860B,
    'darkgray': 0xA9A9A9,
    'darkgreen': 0x006400,
    'darkgrey': 0xA9A9A9,
    'darkkhaki': 0xBDB76B,
    'darkmagenta': 0x8B008B,
    'darkolivegreen': 0x556B2F,
    'darkorange': 0xFF8C00,
    'darkorchid': 0x9932CC,
    'darkred': 0x8B0000,
    'darksalmon': 0xE9967A,
    'darkseagreen': 0x8FBC8F,
    'darkslateblue': 0x483D8B,
    'darkslategray': 0x2F4F4F,
    'darkslategrey': 0x2F4F4F,
    'darkturquoise': 0x00CED1,
    'darkviolet': 0x9400D3,
    'deeppink': 0xFF1493,
    'deepskyblue': 0x00BFFF,
    'dimgray': 0x696969,
    'dimgrey': 0x696969,
    'dodgerblue': 0x1E90FF,
    'firebrick': 0xB22222,
    'floralwhite': 0xFFFAF0,
    'forestgreen': 0x228B22,
    'fuchsia': 0xFF00FF,
    'gainsboro': 0xDCDCDC,
    'ghostwhite': 0xF8F8FF,
    'gold': 0xFFD700,
    'goldenrod': 0xDAA520,
    'gray': 0x808080,
    'green': 0x008000,
    'greenyellow': 0xADFF2F,
    'grey': 0x808080,
    'honeydew': 0xF0FFF0,
    'hotpink': 0xFF69B4,
    'indianred': 0xCD5C5C,
    'indigo': 0x4B0082,
    'ivory': 0xFFFFF0,
    'khaki': 0xF0E68C,
    'lavender': 0xE6E6FA,
    'lavenderblush': 0xFFF0F5,
    'lawngreen': 0x7CFC00,
    'lemonchiffon': 0xFFFACD,
    'lightblue': 0xADD8E6,
    'lightcoral': 0xF08080,
    'lightcyan': 0xE0FFFF,
    'lightgoldenrodyellow': 0xFAFAD2,
    'lightgray': 0xD3D3D3,
    'lightgreen': 0x90EE90,
    'lightgrey': 0xD3D3D3,
    'lightpink': 0xFFB6C1,
    'lightsalmon': 0xFFA07A,
    'lightseagreen': 0x20B2AA,
    'lightskyblue': 0x87CEFA,
    'lightslategray': 0x778899,
    'lightslategrey': 0x778899,
    'lightsteelblue': 0xB0C4DE,
    'lightyellow': 0xFFFFE0,
    'lime': 0x00FF00,
    'limegreen': 0x32CD32,
    'linen': 0xFAF0E6,
    'magenta': 0xFF00FF,
    'maroon': 0x800000,
    'mediumaquamarine': 0x66CDAA,
    'mediumblue': 0x0000CD,
    'mediumorchid': 0xBA55D3,
    'mediumpurple': 0x9370DB,
    'mediumseagreen': 0x3CB371,
    'mediumslateblue': 0x7B68EE,
    'mediumspringgreen': 0x00FA9A,
    'mediumturquoise': 0x48D1CC,
    'mediumvioletred': 0xC71585,
    'midnightblue': 0x191970,
    'mintcream': 0xF5FFFA,
    'mistyrose': 0xFFE4E1,
    'moccasin': 0xFFE4B5,
    'navajowhite': 0xFFDEAD,
    'navy': 0x000080,
    'oldlace': 0xFDF5E6,
    'olive': 0x808000,
    'olivedrab': 0x6B8E23,
    'orange': 0xFFA500,
    'orangered': 0xFF4500,
    'orchid': 0xDA70D6,
    'palegoldenrod': 0xEEE8AA,
    'palegreen': 0x98FB98,
    'paleturquoise': 0xAFEEEE,
    'palevioletred': 0xDB7093,
    'papayawhip': 0xFFEFD5,
    'peachpuff': 0xFFDAB9,
    'peru': 0xCD853F,
    'pink': 0xFFC0CB,
    'plum': 0xDDA0DD,
    'powderblue': 0xB0E0E6,
    'purple': 0x800080,
    'rebeccapurple': 0x663399,
    'red': 0xFF0000,
    'rosybrown': 0xBC8F8F,
    'royalblue': 0x4169E1,
    'saddlebrown': 0x8B4513,
    'salmon': 0xFA8072,
    'sandybrown': 0xF4A460,
    'seagreen': 0x2E8B57,
    'seashell': 0xFFF5EE,
    'sienna': 0xA0522D,
    'silver': 0xC0C0C0,
    'skyblue': 0x87CEEB,
    'slateblue': 0x6A5ACD,
    'slategray': 0x708090,
    'slategrey': 0x708090,
    'snow': 0xFFFAFA,
    'springgreen': 0x00FF7F,
    'steelblue': 0x4682B4,
    'tan': 0xD2B48C,
    'teal': 0x008080,
    'thistle': 0xD8BFD8,
    'tomato': 0xFF6347,
    'turquoise': 0x40E0D0,
    'violet': 0xEE82EE,
    'wheat': 0xF5DEB3,
    'white': 0xFFFFFF,
    'whitesmoke': 0xF5F5F5,
    'yellow': 0xFFFF00,
    'yellowgreen': 0x9ACD32
};
const $9a23ce591a1b6760$var$_hslA = {
    h: 0,
    s: 0,
    l: 0
};
const $9a23ce591a1b6760$var$_hslB = {
    h: 0,
    s: 0,
    l: 0
};
function $9a23ce591a1b6760$var$hue2rgb(p, q, t) {
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1 / 6) return p + (q - p) * 6 * t;
    if (t < 0.5) return q;
    if (t < 2 / 3) return p + (q - p) * 6 * (2 / 3 - t);
    return p;
}
class $9a23ce591a1b6760$export$892596cec99bc70e {
    constructor(r, g, b){
        this.isColor = true;
        this.r = 1;
        this.g = 1;
        this.b = 1;
        return this.set(r, g, b);
    }
    set(r, g, b) {
        if (g === undefined && b === undefined) {
            // r is THREE.Color, hex or string
            const value = r;
            if (value && value.isColor) this.copy(value);
            else if (typeof value === 'number') this.setHex(value);
            else if (typeof value === 'string') this.setStyle(value);
        } else this.setRGB(r, g, b);
        return this;
    }
    setScalar(scalar) {
        this.r = scalar;
        this.g = scalar;
        this.b = scalar;
        return this;
    }
    setHex(hex, colorSpace = (0, $cb5ee595c0f892af$export$561f394b24edfcaa)) {
        hex = Math.floor(hex);
        this.r = (hex >> 16 & 255) / 255;
        this.g = (hex >> 8 & 255) / 255;
        this.b = (hex & 255) / 255;
        (0, $46d4f6f1be9702a8$export$5e6fd513f44698c).toWorkingColorSpace(this, colorSpace);
        return this;
    }
    setRGB(r, g, b, colorSpace = (0, $46d4f6f1be9702a8$export$5e6fd513f44698c).workingColorSpace) {
        this.r = r;
        this.g = g;
        this.b = b;
        (0, $46d4f6f1be9702a8$export$5e6fd513f44698c).toWorkingColorSpace(this, colorSpace);
        return this;
    }
    setHSL(h, s, l, colorSpace = (0, $46d4f6f1be9702a8$export$5e6fd513f44698c).workingColorSpace) {
        // h,s,l ranges are in 0.0 - 1.0
        h = (0, $7f727a3c7059d20d$export$3c11354a743b7f4e)(h, 1);
        s = (0, $7f727a3c7059d20d$export$7d15b64cf5a3a4c4)(s, 0, 1);
        l = (0, $7f727a3c7059d20d$export$7d15b64cf5a3a4c4)(l, 0, 1);
        if (s === 0) this.r = this.g = this.b = l;
        else {
            const p = l <= 0.5 ? l * (1 + s) : l + s - l * s;
            const q = 2 * l - p;
            this.r = $9a23ce591a1b6760$var$hue2rgb(q, p, h + 1 / 3);
            this.g = $9a23ce591a1b6760$var$hue2rgb(q, p, h);
            this.b = $9a23ce591a1b6760$var$hue2rgb(q, p, h - 1 / 3);
        }
        (0, $46d4f6f1be9702a8$export$5e6fd513f44698c).toWorkingColorSpace(this, colorSpace);
        return this;
    }
    setStyle(style, colorSpace = (0, $cb5ee595c0f892af$export$561f394b24edfcaa)) {
        function handleAlpha(string) {
            if (string === undefined) return;
            if (parseFloat(string) < 1) console.warn('THREE.Color: Alpha component of ' + style + ' will be ignored.');
        }
        let m;
        if (m = /^(\w+)\(([^\)]*)\)/.exec(style)) {
            // rgb / hsl
            let color;
            const name = m[1];
            const components = m[2];
            switch(name){
                case 'rgb':
                case 'rgba':
                    if (color = /^\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(components)) {
                        // rgb(255,0,0) rgba(255,0,0,0.5)
                        handleAlpha(color[4]);
                        return this.setRGB(Math.min(255, parseInt(color[1], 10)) / 255, Math.min(255, parseInt(color[2], 10)) / 255, Math.min(255, parseInt(color[3], 10)) / 255, colorSpace);
                    }
                    if (color = /^\s*(\d+)\%\s*,\s*(\d+)\%\s*,\s*(\d+)\%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(components)) {
                        // rgb(100%,0%,0%) rgba(100%,0%,0%,0.5)
                        handleAlpha(color[4]);
                        return this.setRGB(Math.min(100, parseInt(color[1], 10)) / 100, Math.min(100, parseInt(color[2], 10)) / 100, Math.min(100, parseInt(color[3], 10)) / 100, colorSpace);
                    }
                    break;
                case 'hsl':
                case 'hsla':
                    if (color = /^\s*(\d*\.?\d+)\s*,\s*(\d*\.?\d+)\%\s*,\s*(\d*\.?\d+)\%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(components)) {
                        // hsl(120,50%,50%) hsla(120,50%,50%,0.5)
                        handleAlpha(color[4]);
                        return this.setHSL(parseFloat(color[1]) / 360, parseFloat(color[2]) / 100, parseFloat(color[3]) / 100, colorSpace);
                    }
                    break;
                default:
                    console.warn('THREE.Color: Unknown color model ' + style);
            }
        } else if (m = /^\#([A-Fa-f\d]+)$/.exec(style)) {
            // hex color
            const hex = m[1];
            const size = hex.length;
            if (size === 3) // #ff0
            return this.setRGB(parseInt(hex.charAt(0), 16) / 15, parseInt(hex.charAt(1), 16) / 15, parseInt(hex.charAt(2), 16) / 15, colorSpace);
            else if (size === 6) // #ff0000
            return this.setHex(parseInt(hex, 16), colorSpace);
            else console.warn('THREE.Color: Invalid hex color ' + style);
        } else if (style && style.length > 0) return this.setColorName(style, colorSpace);
        return this;
    }
    setColorName(style, colorSpace = (0, $cb5ee595c0f892af$export$561f394b24edfcaa)) {
        // color keywords
        const hex = $9a23ce591a1b6760$var$_colorKeywords[style.toLowerCase()];
        if (hex !== undefined) // red
        this.setHex(hex, colorSpace);
        else // unknown color
        console.warn('THREE.Color: Unknown color ' + style);
        return this;
    }
    clone() {
        return new this.constructor(this.r, this.g, this.b);
    }
    copy(color) {
        this.r = color.r;
        this.g = color.g;
        this.b = color.b;
        return this;
    }
    copySRGBToLinear(color) {
        this.r = (0, $46d4f6f1be9702a8$export$22855367bc41ba49)(color.r);
        this.g = (0, $46d4f6f1be9702a8$export$22855367bc41ba49)(color.g);
        this.b = (0, $46d4f6f1be9702a8$export$22855367bc41ba49)(color.b);
        return this;
    }
    copyLinearToSRGB(color) {
        this.r = (0, $46d4f6f1be9702a8$export$cb64753382238f37)(color.r);
        this.g = (0, $46d4f6f1be9702a8$export$cb64753382238f37)(color.g);
        this.b = (0, $46d4f6f1be9702a8$export$cb64753382238f37)(color.b);
        return this;
    }
    convertSRGBToLinear() {
        this.copySRGBToLinear(this);
        return this;
    }
    convertLinearToSRGB() {
        this.copyLinearToSRGB(this);
        return this;
    }
    getHex(colorSpace = (0, $cb5ee595c0f892af$export$561f394b24edfcaa)) {
        (0, $46d4f6f1be9702a8$export$5e6fd513f44698c).fromWorkingColorSpace($9a23ce591a1b6760$var$_color.copy(this), colorSpace);
        return Math.round((0, $7f727a3c7059d20d$export$7d15b64cf5a3a4c4)($9a23ce591a1b6760$var$_color.r * 255, 0, 255)) * 65536 + Math.round((0, $7f727a3c7059d20d$export$7d15b64cf5a3a4c4)($9a23ce591a1b6760$var$_color.g * 255, 0, 255)) * 256 + Math.round((0, $7f727a3c7059d20d$export$7d15b64cf5a3a4c4)($9a23ce591a1b6760$var$_color.b * 255, 0, 255));
    }
    getHexString(colorSpace = (0, $cb5ee595c0f892af$export$561f394b24edfcaa)) {
        return ('000000' + this.getHex(colorSpace).toString(16)).slice(-6);
    }
    getHSL(target, colorSpace = (0, $46d4f6f1be9702a8$export$5e6fd513f44698c).workingColorSpace) {
        // h,s,l ranges are in 0.0 - 1.0
        (0, $46d4f6f1be9702a8$export$5e6fd513f44698c).fromWorkingColorSpace($9a23ce591a1b6760$var$_color.copy(this), colorSpace);
        const r = $9a23ce591a1b6760$var$_color.r, g = $9a23ce591a1b6760$var$_color.g, b = $9a23ce591a1b6760$var$_color.b;
        const max = Math.max(r, g, b);
        const min = Math.min(r, g, b);
        let hue, saturation;
        const lightness = (min + max) / 2.0;
        if (min === max) {
            hue = 0;
            saturation = 0;
        } else {
            const delta = max - min;
            saturation = lightness <= 0.5 ? delta / (max + min) : delta / (2 - max - min);
            switch(max){
                case r:
                    hue = (g - b) / delta + (g < b ? 6 : 0);
                    break;
                case g:
                    hue = (b - r) / delta + 2;
                    break;
                case b:
                    hue = (r - g) / delta + 4;
                    break;
            }
            hue /= 6;
        }
        target.h = hue;
        target.s = saturation;
        target.l = lightness;
        return target;
    }
    getRGB(target, colorSpace = (0, $46d4f6f1be9702a8$export$5e6fd513f44698c).workingColorSpace) {
        (0, $46d4f6f1be9702a8$export$5e6fd513f44698c).fromWorkingColorSpace($9a23ce591a1b6760$var$_color.copy(this), colorSpace);
        target.r = $9a23ce591a1b6760$var$_color.r;
        target.g = $9a23ce591a1b6760$var$_color.g;
        target.b = $9a23ce591a1b6760$var$_color.b;
        return target;
    }
    getStyle(colorSpace = (0, $cb5ee595c0f892af$export$561f394b24edfcaa)) {
        (0, $46d4f6f1be9702a8$export$5e6fd513f44698c).fromWorkingColorSpace($9a23ce591a1b6760$var$_color.copy(this), colorSpace);
        const r = $9a23ce591a1b6760$var$_color.r, g = $9a23ce591a1b6760$var$_color.g, b = $9a23ce591a1b6760$var$_color.b;
        if (colorSpace !== (0, $cb5ee595c0f892af$export$561f394b24edfcaa)) // Requires CSS Color Module Level 4 (https://www.w3.org/TR/css-color-4/).
        return `color(${colorSpace} ${r.toFixed(3)} ${g.toFixed(3)} ${b.toFixed(3)})`;
        return `rgb(${Math.round(r * 255)},${Math.round(g * 255)},${Math.round(b * 255)})`;
    }
    offsetHSL(h, s, l) {
        this.getHSL($9a23ce591a1b6760$var$_hslA);
        return this.setHSL($9a23ce591a1b6760$var$_hslA.h + h, $9a23ce591a1b6760$var$_hslA.s + s, $9a23ce591a1b6760$var$_hslA.l + l);
    }
    add(color) {
        this.r += color.r;
        this.g += color.g;
        this.b += color.b;
        return this;
    }
    addColors(color1, color2) {
        this.r = color1.r + color2.r;
        this.g = color1.g + color2.g;
        this.b = color1.b + color2.b;
        return this;
    }
    addScalar(s) {
        this.r += s;
        this.g += s;
        this.b += s;
        return this;
    }
    sub(color) {
        this.r = Math.max(0, this.r - color.r);
        this.g = Math.max(0, this.g - color.g);
        this.b = Math.max(0, this.b - color.b);
        return this;
    }
    multiply(color) {
        this.r *= color.r;
        this.g *= color.g;
        this.b *= color.b;
        return this;
    }
    multiplyScalar(s) {
        this.r *= s;
        this.g *= s;
        this.b *= s;
        return this;
    }
    lerp(color, alpha) {
        this.r += (color.r - this.r) * alpha;
        this.g += (color.g - this.g) * alpha;
        this.b += (color.b - this.b) * alpha;
        return this;
    }
    lerpColors(color1, color2, alpha) {
        this.r = color1.r + (color2.r - color1.r) * alpha;
        this.g = color1.g + (color2.g - color1.g) * alpha;
        this.b = color1.b + (color2.b - color1.b) * alpha;
        return this;
    }
    lerpHSL(color, alpha) {
        this.getHSL($9a23ce591a1b6760$var$_hslA);
        color.getHSL($9a23ce591a1b6760$var$_hslB);
        const h = (0, $7f727a3c7059d20d$export$3a89f8d6f6bf6c9f)($9a23ce591a1b6760$var$_hslA.h, $9a23ce591a1b6760$var$_hslB.h, alpha);
        const s = (0, $7f727a3c7059d20d$export$3a89f8d6f6bf6c9f)($9a23ce591a1b6760$var$_hslA.s, $9a23ce591a1b6760$var$_hslB.s, alpha);
        const l = (0, $7f727a3c7059d20d$export$3a89f8d6f6bf6c9f)($9a23ce591a1b6760$var$_hslA.l, $9a23ce591a1b6760$var$_hslB.l, alpha);
        this.setHSL(h, s, l);
        return this;
    }
    setFromVector3(v) {
        this.r = v.x;
        this.g = v.y;
        this.b = v.z;
        return this;
    }
    applyMatrix3(m) {
        const r = this.r, g = this.g, b = this.b;
        const e = m.elements;
        this.r = e[0] * r + e[3] * g + e[6] * b;
        this.g = e[1] * r + e[4] * g + e[7] * b;
        this.b = e[2] * r + e[5] * g + e[8] * b;
        return this;
    }
    equals(c) {
        return c.r === this.r && c.g === this.g && c.b === this.b;
    }
    fromArray(array, offset = 0) {
        this.r = array[offset];
        this.g = array[offset + 1];
        this.b = array[offset + 2];
        return this;
    }
    toArray(array = [], offset = 0) {
        array[offset] = this.r;
        array[offset + 1] = this.g;
        array[offset + 2] = this.b;
        return array;
    }
    fromBufferAttribute(attribute, index) {
        this.r = attribute.getX(index);
        this.g = attribute.getY(index);
        this.b = attribute.getZ(index);
        return this;
    }
    toJSON() {
        return this.getHex();
    }
    *[Symbol.iterator]() {
        yield this.r;
        yield this.g;
        yield this.b;
    }
}
const $9a23ce591a1b6760$var$_color = /*@__PURE__*/ new $9a23ce591a1b6760$export$892596cec99bc70e();
$9a23ce591a1b6760$export$892596cec99bc70e.NAMES = $9a23ce591a1b6760$var$_colorKeywords;






class $cbf6795a106eec59$export$23d6a54f0bbc85a3 {
    constructor(x = 0, y = 0, z = 0, w = 1){
        this.isQuaternion = true;
        this._x = x;
        this._y = y;
        this._z = z;
        this._w = w;
    }
    static slerpFlat(dst, dstOffset, src0, srcOffset0, src1, srcOffset1, t) {
        // fuzz-free, array-based Quaternion SLERP operation
        let x0 = src0[srcOffset0 + 0], y0 = src0[srcOffset0 + 1], z0 = src0[srcOffset0 + 2], w0 = src0[srcOffset0 + 3];
        const x1 = src1[srcOffset1 + 0], y1 = src1[srcOffset1 + 1], z1 = src1[srcOffset1 + 2], w1 = src1[srcOffset1 + 3];
        if (t === 0) {
            dst[dstOffset + 0] = x0;
            dst[dstOffset + 1] = y0;
            dst[dstOffset + 2] = z0;
            dst[dstOffset + 3] = w0;
            return;
        }
        if (t === 1) {
            dst[dstOffset + 0] = x1;
            dst[dstOffset + 1] = y1;
            dst[dstOffset + 2] = z1;
            dst[dstOffset + 3] = w1;
            return;
        }
        if (w0 !== w1 || x0 !== x1 || y0 !== y1 || z0 !== z1) {
            let s = 1 - t;
            const cos = x0 * x1 + y0 * y1 + z0 * z1 + w0 * w1, dir = cos >= 0 ? 1 : -1, sqrSin = 1 - cos * cos;
            // Skip the Slerp for tiny steps to avoid numeric problems:
            if (sqrSin > Number.EPSILON) {
                const sin = Math.sqrt(sqrSin), len = Math.atan2(sin, cos * dir);
                s = Math.sin(s * len) / sin;
                t = Math.sin(t * len) / sin;
            }
            const tDir = t * dir;
            x0 = x0 * s + x1 * tDir;
            y0 = y0 * s + y1 * tDir;
            z0 = z0 * s + z1 * tDir;
            w0 = w0 * s + w1 * tDir;
            // Normalize in case we just did a lerp:
            if (s === 1 - t) {
                const f = 1 / Math.sqrt(x0 * x0 + y0 * y0 + z0 * z0 + w0 * w0);
                x0 *= f;
                y0 *= f;
                z0 *= f;
                w0 *= f;
            }
        }
        dst[dstOffset] = x0;
        dst[dstOffset + 1] = y0;
        dst[dstOffset + 2] = z0;
        dst[dstOffset + 3] = w0;
    }
    static multiplyQuaternionsFlat(dst, dstOffset, src0, srcOffset0, src1, srcOffset1) {
        const x0 = src0[srcOffset0];
        const y0 = src0[srcOffset0 + 1];
        const z0 = src0[srcOffset0 + 2];
        const w0 = src0[srcOffset0 + 3];
        const x1 = src1[srcOffset1];
        const y1 = src1[srcOffset1 + 1];
        const z1 = src1[srcOffset1 + 2];
        const w1 = src1[srcOffset1 + 3];
        dst[dstOffset] = x0 * w1 + w0 * x1 + y0 * z1 - z0 * y1;
        dst[dstOffset + 1] = y0 * w1 + w0 * y1 + z0 * x1 - x0 * z1;
        dst[dstOffset + 2] = z0 * w1 + w0 * z1 + x0 * y1 - y0 * x1;
        dst[dstOffset + 3] = w0 * w1 - x0 * x1 - y0 * y1 - z0 * z1;
        return dst;
    }
    get x() {
        return this._x;
    }
    set x(value) {
        this._x = value;
        this._onChangeCallback();
    }
    get y() {
        return this._y;
    }
    set y(value) {
        this._y = value;
        this._onChangeCallback();
    }
    get z() {
        return this._z;
    }
    set z(value) {
        this._z = value;
        this._onChangeCallback();
    }
    get w() {
        return this._w;
    }
    set w(value) {
        this._w = value;
        this._onChangeCallback();
    }
    set(x, y, z, w) {
        this._x = x;
        this._y = y;
        this._z = z;
        this._w = w;
        this._onChangeCallback();
        return this;
    }
    clone() {
        return new this.constructor(this._x, this._y, this._z, this._w);
    }
    copy(quaternion) {
        this._x = quaternion.x;
        this._y = quaternion.y;
        this._z = quaternion.z;
        this._w = quaternion.w;
        this._onChangeCallback();
        return this;
    }
    setFromEuler(euler, update = true) {
        const x = euler._x, y = euler._y, z = euler._z, order = euler._order;
        // http://www.mathworks.com/matlabcentral/fileexchange/
        // 	20696-function-to-convert-between-dcm-euler-angles-quaternions-and-euler-vectors/
        //	content/SpinCalc.m
        const cos = Math.cos;
        const sin = Math.sin;
        const c1 = cos(x / 2);
        const c2 = cos(y / 2);
        const c3 = cos(z / 2);
        const s1 = sin(x / 2);
        const s2 = sin(y / 2);
        const s3 = sin(z / 2);
        switch(order){
            case 'XYZ':
                this._x = s1 * c2 * c3 + c1 * s2 * s3;
                this._y = c1 * s2 * c3 - s1 * c2 * s3;
                this._z = c1 * c2 * s3 + s1 * s2 * c3;
                this._w = c1 * c2 * c3 - s1 * s2 * s3;
                break;
            case 'YXZ':
                this._x = s1 * c2 * c3 + c1 * s2 * s3;
                this._y = c1 * s2 * c3 - s1 * c2 * s3;
                this._z = c1 * c2 * s3 - s1 * s2 * c3;
                this._w = c1 * c2 * c3 + s1 * s2 * s3;
                break;
            case 'ZXY':
                this._x = s1 * c2 * c3 - c1 * s2 * s3;
                this._y = c1 * s2 * c3 + s1 * c2 * s3;
                this._z = c1 * c2 * s3 + s1 * s2 * c3;
                this._w = c1 * c2 * c3 - s1 * s2 * s3;
                break;
            case 'ZYX':
                this._x = s1 * c2 * c3 - c1 * s2 * s3;
                this._y = c1 * s2 * c3 + s1 * c2 * s3;
                this._z = c1 * c2 * s3 - s1 * s2 * c3;
                this._w = c1 * c2 * c3 + s1 * s2 * s3;
                break;
            case 'YZX':
                this._x = s1 * c2 * c3 + c1 * s2 * s3;
                this._y = c1 * s2 * c3 + s1 * c2 * s3;
                this._z = c1 * c2 * s3 - s1 * s2 * c3;
                this._w = c1 * c2 * c3 - s1 * s2 * s3;
                break;
            case 'XZY':
                this._x = s1 * c2 * c3 - c1 * s2 * s3;
                this._y = c1 * s2 * c3 - s1 * c2 * s3;
                this._z = c1 * c2 * s3 + s1 * s2 * c3;
                this._w = c1 * c2 * c3 + s1 * s2 * s3;
                break;
            default:
                console.warn('THREE.Quaternion: .setFromEuler() encountered an unknown order: ' + order);
        }
        if (update === true) this._onChangeCallback();
        return this;
    }
    setFromAxisAngle(axis, angle) {
        // http://www.euclideanspace.com/maths/geometry/rotations/conversions/angleToQuaternion/index.htm
        // assumes axis is normalized
        const halfAngle = angle / 2, s = Math.sin(halfAngle);
        this._x = axis.x * s;
        this._y = axis.y * s;
        this._z = axis.z * s;
        this._w = Math.cos(halfAngle);
        this._onChangeCallback();
        return this;
    }
    setFromRotationMatrix(m) {
        // http://www.euclideanspace.com/maths/geometry/rotations/conversions/matrixToQuaternion/index.htm
        // assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)
        const te = m.elements, m11 = te[0], m12 = te[4], m13 = te[8], m21 = te[1], m22 = te[5], m23 = te[9], m31 = te[2], m32 = te[6], m33 = te[10], trace = m11 + m22 + m33;
        if (trace > 0) {
            const s = 0.5 / Math.sqrt(trace + 1.0);
            this._w = 0.25 / s;
            this._x = (m32 - m23) * s;
            this._y = (m13 - m31) * s;
            this._z = (m21 - m12) * s;
        } else if (m11 > m22 && m11 > m33) {
            const s = 2.0 * Math.sqrt(1.0 + m11 - m22 - m33);
            this._w = (m32 - m23) / s;
            this._x = 0.25 * s;
            this._y = (m12 + m21) / s;
            this._z = (m13 + m31) / s;
        } else if (m22 > m33) {
            const s = 2.0 * Math.sqrt(1.0 + m22 - m11 - m33);
            this._w = (m13 - m31) / s;
            this._x = (m12 + m21) / s;
            this._y = 0.25 * s;
            this._z = (m23 + m32) / s;
        } else {
            const s = 2.0 * Math.sqrt(1.0 + m33 - m11 - m22);
            this._w = (m21 - m12) / s;
            this._x = (m13 + m31) / s;
            this._y = (m23 + m32) / s;
            this._z = 0.25 * s;
        }
        this._onChangeCallback();
        return this;
    }
    setFromUnitVectors(vFrom, vTo) {
        // assumes direction vectors vFrom and vTo are normalized
        let r = vFrom.dot(vTo) + 1;
        if (r < Number.EPSILON) {
            // vFrom and vTo point in opposite directions
            r = 0;
            if (Math.abs(vFrom.x) > Math.abs(vFrom.z)) {
                this._x = -vFrom.y;
                this._y = vFrom.x;
                this._z = 0;
                this._w = r;
            } else {
                this._x = 0;
                this._y = -vFrom.z;
                this._z = vFrom.y;
                this._w = r;
            }
        } else {
            // crossVectors( vFrom, vTo ); // inlined to avoid cyclic dependency on Vector3
            this._x = vFrom.y * vTo.z - vFrom.z * vTo.y;
            this._y = vFrom.z * vTo.x - vFrom.x * vTo.z;
            this._z = vFrom.x * vTo.y - vFrom.y * vTo.x;
            this._w = r;
        }
        return this.normalize();
    }
    angleTo(q) {
        return 2 * Math.acos(Math.abs($7f727a3c7059d20d$export$7d15b64cf5a3a4c4(this.dot(q), -1, 1)));
    }
    rotateTowards(q, step) {
        const angle = this.angleTo(q);
        if (angle === 0) return this;
        const t = Math.min(1, step / angle);
        this.slerp(q, t);
        return this;
    }
    identity() {
        return this.set(0, 0, 0, 1);
    }
    invert() {
        // quaternion is assumed to have unit length
        return this.conjugate();
    }
    conjugate() {
        this._x *= -1;
        this._y *= -1;
        this._z *= -1;
        this._onChangeCallback();
        return this;
    }
    dot(v) {
        return this._x * v._x + this._y * v._y + this._z * v._z + this._w * v._w;
    }
    lengthSq() {
        return this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w;
    }
    length() {
        return Math.sqrt(this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w);
    }
    normalize() {
        let l = this.length();
        if (l === 0) {
            this._x = 0;
            this._y = 0;
            this._z = 0;
            this._w = 1;
        } else {
            l = 1 / l;
            this._x = this._x * l;
            this._y = this._y * l;
            this._z = this._z * l;
            this._w = this._w * l;
        }
        this._onChangeCallback();
        return this;
    }
    multiply(q) {
        return this.multiplyQuaternions(this, q);
    }
    premultiply(q) {
        return this.multiplyQuaternions(q, this);
    }
    multiplyQuaternions(a, b) {
        // from http://www.euclideanspace.com/maths/algebra/realNormedAlgebra/quaternions/code/index.htm
        const qax = a._x, qay = a._y, qaz = a._z, qaw = a._w;
        const qbx = b._x, qby = b._y, qbz = b._z, qbw = b._w;
        this._x = qax * qbw + qaw * qbx + qay * qbz - qaz * qby;
        this._y = qay * qbw + qaw * qby + qaz * qbx - qax * qbz;
        this._z = qaz * qbw + qaw * qbz + qax * qby - qay * qbx;
        this._w = qaw * qbw - qax * qbx - qay * qby - qaz * qbz;
        this._onChangeCallback();
        return this;
    }
    slerp(qb, t) {
        if (t === 0) return this;
        if (t === 1) return this.copy(qb);
        const x = this._x, y = this._y, z = this._z, w = this._w;
        // http://www.euclideanspace.com/maths/algebra/realNormedAlgebra/quaternions/slerp/
        let cosHalfTheta = w * qb._w + x * qb._x + y * qb._y + z * qb._z;
        if (cosHalfTheta < 0) {
            this._w = -qb._w;
            this._x = -qb._x;
            this._y = -qb._y;
            this._z = -qb._z;
            cosHalfTheta = -cosHalfTheta;
        } else this.copy(qb);
        if (cosHalfTheta >= 1.0) {
            this._w = w;
            this._x = x;
            this._y = y;
            this._z = z;
            return this;
        }
        const sqrSinHalfTheta = 1.0 - cosHalfTheta * cosHalfTheta;
        if (sqrSinHalfTheta <= Number.EPSILON) {
            const s = 1 - t;
            this._w = s * w + t * this._w;
            this._x = s * x + t * this._x;
            this._y = s * y + t * this._y;
            this._z = s * z + t * this._z;
            this.normalize(); // normalize calls _onChangeCallback()
            return this;
        }
        const sinHalfTheta = Math.sqrt(sqrSinHalfTheta);
        const halfTheta = Math.atan2(sinHalfTheta, cosHalfTheta);
        const ratioA = Math.sin((1 - t) * halfTheta) / sinHalfTheta, ratioB = Math.sin(t * halfTheta) / sinHalfTheta;
        this._w = w * ratioA + this._w * ratioB;
        this._x = x * ratioA + this._x * ratioB;
        this._y = y * ratioA + this._y * ratioB;
        this._z = z * ratioA + this._z * ratioB;
        this._onChangeCallback();
        return this;
    }
    slerpQuaternions(qa, qb, t) {
        return this.copy(qa).slerp(qb, t);
    }
    random() {
        // sets this quaternion to a uniform random unit quaternnion
        // Ken Shoemake
        // Uniform random rotations
        // D. Kirk, editor, Graphics Gems III, pages 124-132. Academic Press, New York, 1992.
        const theta1 = 2 * Math.PI * Math.random();
        const theta2 = 2 * Math.PI * Math.random();
        const x0 = Math.random();
        const r1 = Math.sqrt(1 - x0);
        const r2 = Math.sqrt(x0);
        return this.set(r1 * Math.sin(theta1), r1 * Math.cos(theta1), r2 * Math.sin(theta2), r2 * Math.cos(theta2));
    }
    equals(quaternion) {
        return quaternion._x === this._x && quaternion._y === this._y && quaternion._z === this._z && quaternion._w === this._w;
    }
    fromArray(array, offset = 0) {
        this._x = array[offset];
        this._y = array[offset + 1];
        this._z = array[offset + 2];
        this._w = array[offset + 3];
        this._onChangeCallback();
        return this;
    }
    toArray(array = [], offset = 0) {
        array[offset] = this._x;
        array[offset + 1] = this._y;
        array[offset + 2] = this._z;
        array[offset + 3] = this._w;
        return array;
    }
    fromBufferAttribute(attribute, index) {
        this._x = attribute.getX(index);
        this._y = attribute.getY(index);
        this._z = attribute.getZ(index);
        this._w = attribute.getW(index);
        this._onChangeCallback();
        return this;
    }
    toJSON() {
        return this.toArray();
    }
    _onChange(callback) {
        this._onChangeCallback = callback;
        return this;
    }
    _onChangeCallback() {}
    *[Symbol.iterator]() {
        yield this._x;
        yield this._y;
        yield this._z;
        yield this._w;
    }
}


class $d7d0ac0e47013885$export$64b5c384219d3699 {
    constructor(x = 0, y = 0, z = 0){
        $d7d0ac0e47013885$export$64b5c384219d3699.prototype.isVector3 = true;
        this.x = x;
        this.y = y;
        this.z = z;
    }
    set(x, y, z) {
        if (z === undefined) z = this.z; // sprite.scale.set(x,y)
        this.x = x;
        this.y = y;
        this.z = z;
        return this;
    }
    setScalar(scalar) {
        this.x = scalar;
        this.y = scalar;
        this.z = scalar;
        return this;
    }
    setX(x) {
        this.x = x;
        return this;
    }
    setY(y) {
        this.y = y;
        return this;
    }
    setZ(z) {
        this.z = z;
        return this;
    }
    setComponent(index, value) {
        switch(index){
            case 0:
                this.x = value;
                break;
            case 1:
                this.y = value;
                break;
            case 2:
                this.z = value;
                break;
            default:
                throw new Error('index is out of range: ' + index);
        }
        return this;
    }
    getComponent(index) {
        switch(index){
            case 0:
                return this.x;
            case 1:
                return this.y;
            case 2:
                return this.z;
            default:
                throw new Error('index is out of range: ' + index);
        }
    }
    clone() {
        return new this.constructor(this.x, this.y, this.z);
    }
    copy(v) {
        this.x = v.x;
        this.y = v.y;
        this.z = v.z;
        return this;
    }
    add(v) {
        this.x += v.x;
        this.y += v.y;
        this.z += v.z;
        return this;
    }
    addScalar(s) {
        this.x += s;
        this.y += s;
        this.z += s;
        return this;
    }
    addVectors(a, b) {
        this.x = a.x + b.x;
        this.y = a.y + b.y;
        this.z = a.z + b.z;
        return this;
    }
    addScaledVector(v, s) {
        this.x += v.x * s;
        this.y += v.y * s;
        this.z += v.z * s;
        return this;
    }
    sub(v) {
        this.x -= v.x;
        this.y -= v.y;
        this.z -= v.z;
        return this;
    }
    subScalar(s) {
        this.x -= s;
        this.y -= s;
        this.z -= s;
        return this;
    }
    subVectors(a, b) {
        this.x = a.x - b.x;
        this.y = a.y - b.y;
        this.z = a.z - b.z;
        return this;
    }
    multiply(v) {
        this.x *= v.x;
        this.y *= v.y;
        this.z *= v.z;
        return this;
    }
    multiplyScalar(scalar) {
        this.x *= scalar;
        this.y *= scalar;
        this.z *= scalar;
        return this;
    }
    multiplyVectors(a, b) {
        this.x = a.x * b.x;
        this.y = a.y * b.y;
        this.z = a.z * b.z;
        return this;
    }
    applyEuler(euler) {
        return this.applyQuaternion($d7d0ac0e47013885$var$_quaternion.setFromEuler(euler));
    }
    applyAxisAngle(axis, angle) {
        return this.applyQuaternion($d7d0ac0e47013885$var$_quaternion.setFromAxisAngle(axis, angle));
    }
    applyMatrix3(m) {
        const x = this.x, y = this.y, z = this.z;
        const e = m.elements;
        this.x = e[0] * x + e[3] * y + e[6] * z;
        this.y = e[1] * x + e[4] * y + e[7] * z;
        this.z = e[2] * x + e[5] * y + e[8] * z;
        return this;
    }
    applyNormalMatrix(m) {
        return this.applyMatrix3(m).normalize();
    }
    applyMatrix4(m) {
        const x = this.x, y = this.y, z = this.z;
        const e = m.elements;
        const w = 1 / (e[3] * x + e[7] * y + e[11] * z + e[15]);
        this.x = (e[0] * x + e[4] * y + e[8] * z + e[12]) * w;
        this.y = (e[1] * x + e[5] * y + e[9] * z + e[13]) * w;
        this.z = (e[2] * x + e[6] * y + e[10] * z + e[14]) * w;
        return this;
    }
    applyQuaternion(q) {
        // quaternion q is assumed to have unit length
        const vx = this.x, vy = this.y, vz = this.z;
        const qx = q.x, qy = q.y, qz = q.z, qw = q.w;
        // t = 2 * cross( q.xyz, v );
        const tx = 2 * (qy * vz - qz * vy);
        const ty = 2 * (qz * vx - qx * vz);
        const tz = 2 * (qx * vy - qy * vx);
        // v + q.w * t + cross( q.xyz, t );
        this.x = vx + qw * tx + qy * tz - qz * ty;
        this.y = vy + qw * ty + qz * tx - qx * tz;
        this.z = vz + qw * tz + qx * ty - qy * tx;
        return this;
    }
    project(camera) {
        return this.applyMatrix4(camera.matrixWorldInverse).applyMatrix4(camera.projectionMatrix);
    }
    unproject(camera) {
        return this.applyMatrix4(camera.projectionMatrixInverse).applyMatrix4(camera.matrixWorld);
    }
    transformDirection(m) {
        // input: THREE.Matrix4 affine matrix
        // vector interpreted as a direction
        const x = this.x, y = this.y, z = this.z;
        const e = m.elements;
        this.x = e[0] * x + e[4] * y + e[8] * z;
        this.y = e[1] * x + e[5] * y + e[9] * z;
        this.z = e[2] * x + e[6] * y + e[10] * z;
        return this.normalize();
    }
    divide(v) {
        this.x /= v.x;
        this.y /= v.y;
        this.z /= v.z;
        return this;
    }
    divideScalar(scalar) {
        return this.multiplyScalar(1 / scalar);
    }
    min(v) {
        this.x = Math.min(this.x, v.x);
        this.y = Math.min(this.y, v.y);
        this.z = Math.min(this.z, v.z);
        return this;
    }
    max(v) {
        this.x = Math.max(this.x, v.x);
        this.y = Math.max(this.y, v.y);
        this.z = Math.max(this.z, v.z);
        return this;
    }
    clamp(min, max) {
        // assumes min < max, componentwise
        this.x = Math.max(min.x, Math.min(max.x, this.x));
        this.y = Math.max(min.y, Math.min(max.y, this.y));
        this.z = Math.max(min.z, Math.min(max.z, this.z));
        return this;
    }
    clampScalar(minVal, maxVal) {
        this.x = Math.max(minVal, Math.min(maxVal, this.x));
        this.y = Math.max(minVal, Math.min(maxVal, this.y));
        this.z = Math.max(minVal, Math.min(maxVal, this.z));
        return this;
    }
    clampLength(min, max) {
        const length = this.length();
        return this.divideScalar(length || 1).multiplyScalar(Math.max(min, Math.min(max, length)));
    }
    floor() {
        this.x = Math.floor(this.x);
        this.y = Math.floor(this.y);
        this.z = Math.floor(this.z);
        return this;
    }
    ceil() {
        this.x = Math.ceil(this.x);
        this.y = Math.ceil(this.y);
        this.z = Math.ceil(this.z);
        return this;
    }
    round() {
        this.x = Math.round(this.x);
        this.y = Math.round(this.y);
        this.z = Math.round(this.z);
        return this;
    }
    roundToZero() {
        this.x = Math.trunc(this.x);
        this.y = Math.trunc(this.y);
        this.z = Math.trunc(this.z);
        return this;
    }
    negate() {
        this.x = -this.x;
        this.y = -this.y;
        this.z = -this.z;
        return this;
    }
    dot(v) {
        return this.x * v.x + this.y * v.y + this.z * v.z;
    }
    // TODO lengthSquared?
    lengthSq() {
        return this.x * this.x + this.y * this.y + this.z * this.z;
    }
    length() {
        return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z);
    }
    manhattanLength() {
        return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z);
    }
    normalize() {
        return this.divideScalar(this.length() || 1);
    }
    setLength(length) {
        return this.normalize().multiplyScalar(length);
    }
    lerp(v, alpha) {
        this.x += (v.x - this.x) * alpha;
        this.y += (v.y - this.y) * alpha;
        this.z += (v.z - this.z) * alpha;
        return this;
    }
    lerpVectors(v1, v2, alpha) {
        this.x = v1.x + (v2.x - v1.x) * alpha;
        this.y = v1.y + (v2.y - v1.y) * alpha;
        this.z = v1.z + (v2.z - v1.z) * alpha;
        return this;
    }
    cross(v) {
        return this.crossVectors(this, v);
    }
    crossVectors(a, b) {
        const ax = a.x, ay = a.y, az = a.z;
        const bx = b.x, by = b.y, bz = b.z;
        this.x = ay * bz - az * by;
        this.y = az * bx - ax * bz;
        this.z = ax * by - ay * bx;
        return this;
    }
    projectOnVector(v) {
        const denominator = v.lengthSq();
        if (denominator === 0) return this.set(0, 0, 0);
        const scalar = v.dot(this) / denominator;
        return this.copy(v).multiplyScalar(scalar);
    }
    projectOnPlane(planeNormal) {
        $d7d0ac0e47013885$var$_vector.copy(this).projectOnVector(planeNormal);
        return this.sub($d7d0ac0e47013885$var$_vector);
    }
    reflect(normal) {
        // reflect incident vector off plane orthogonal to normal
        // normal is assumed to have unit length
        return this.sub($d7d0ac0e47013885$var$_vector.copy(normal).multiplyScalar(2 * this.dot(normal)));
    }
    angleTo(v) {
        const denominator = Math.sqrt(this.lengthSq() * v.lengthSq());
        if (denominator === 0) return Math.PI / 2;
        const theta = this.dot(v) / denominator;
        // clamp, to handle numerical problems
        return Math.acos($7f727a3c7059d20d$export$7d15b64cf5a3a4c4(theta, -1, 1));
    }
    distanceTo(v) {
        return Math.sqrt(this.distanceToSquared(v));
    }
    distanceToSquared(v) {
        const dx = this.x - v.x, dy = this.y - v.y, dz = this.z - v.z;
        return dx * dx + dy * dy + dz * dz;
    }
    manhattanDistanceTo(v) {
        return Math.abs(this.x - v.x) + Math.abs(this.y - v.y) + Math.abs(this.z - v.z);
    }
    setFromSpherical(s) {
        return this.setFromSphericalCoords(s.radius, s.phi, s.theta);
    }
    setFromSphericalCoords(radius, phi, theta) {
        const sinPhiRadius = Math.sin(phi) * radius;
        this.x = sinPhiRadius * Math.sin(theta);
        this.y = Math.cos(phi) * radius;
        this.z = sinPhiRadius * Math.cos(theta);
        return this;
    }
    setFromCylindrical(c) {
        return this.setFromCylindricalCoords(c.radius, c.theta, c.y);
    }
    setFromCylindricalCoords(radius, theta, y) {
        this.x = radius * Math.sin(theta);
        this.y = y;
        this.z = radius * Math.cos(theta);
        return this;
    }
    setFromMatrixPosition(m) {
        const e = m.elements;
        this.x = e[12];
        this.y = e[13];
        this.z = e[14];
        return this;
    }
    setFromMatrixScale(m) {
        const sx = this.setFromMatrixColumn(m, 0).length();
        const sy = this.setFromMatrixColumn(m, 1).length();
        const sz = this.setFromMatrixColumn(m, 2).length();
        this.x = sx;
        this.y = sy;
        this.z = sz;
        return this;
    }
    setFromMatrixColumn(m, index) {
        return this.fromArray(m.elements, index * 4);
    }
    setFromMatrix3Column(m, index) {
        return this.fromArray(m.elements, index * 3);
    }
    setFromEuler(e) {
        this.x = e._x;
        this.y = e._y;
        this.z = e._z;
        return this;
    }
    setFromColor(c) {
        this.x = c.r;
        this.y = c.g;
        this.z = c.b;
        return this;
    }
    equals(v) {
        return v.x === this.x && v.y === this.y && v.z === this.z;
    }
    fromArray(array, offset = 0) {
        this.x = array[offset];
        this.y = array[offset + 1];
        this.z = array[offset + 2];
        return this;
    }
    toArray(array = [], offset = 0) {
        array[offset] = this.x;
        array[offset + 1] = this.y;
        array[offset + 2] = this.z;
        return array;
    }
    fromBufferAttribute(attribute, index) {
        this.x = attribute.getX(index);
        this.y = attribute.getY(index);
        this.z = attribute.getZ(index);
        return this;
    }
    random() {
        this.x = Math.random();
        this.y = Math.random();
        this.z = Math.random();
        return this;
    }
    randomDirection() {
        // https://mathworld.wolfram.com/SpherePointPicking.html
        const theta = Math.random() * Math.PI * 2;
        const u = Math.random() * 2 - 1;
        const c = Math.sqrt(1 - u * u);
        this.x = c * Math.cos(theta);
        this.y = u;
        this.z = c * Math.sin(theta);
        return this;
    }
    *[Symbol.iterator]() {
        yield this.x;
        yield this.y;
        yield this.z;
    }
}
const $d7d0ac0e47013885$var$_vector = /*@__PURE__*/ new $d7d0ac0e47013885$export$64b5c384219d3699();
const $d7d0ac0e47013885$var$_quaternion = /*@__PURE__*/ new (0, $cbf6795a106eec59$export$23d6a54f0bbc85a3)();


class $0ea09116adcadf95$export$2ae72fc923e5eb5 {
    constructor(n11, n12, n13, n14, n21, n22, n23, n24, n31, n32, n33, n34, n41, n42, n43, n44){
        $0ea09116adcadf95$export$2ae72fc923e5eb5.prototype.isMatrix4 = true;
        this.elements = [
            1,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            0,
            1
        ];
        if (n11 !== undefined) this.set(n11, n12, n13, n14, n21, n22, n23, n24, n31, n32, n33, n34, n41, n42, n43, n44);
    }
    set(n11, n12, n13, n14, n21, n22, n23, n24, n31, n32, n33, n34, n41, n42, n43, n44) {
        const te = this.elements;
        te[0] = n11;
        te[4] = n12;
        te[8] = n13;
        te[12] = n14;
        te[1] = n21;
        te[5] = n22;
        te[9] = n23;
        te[13] = n24;
        te[2] = n31;
        te[6] = n32;
        te[10] = n33;
        te[14] = n34;
        te[3] = n41;
        te[7] = n42;
        te[11] = n43;
        te[15] = n44;
        return this;
    }
    identity() {
        this.set(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
        return this;
    }
    clone() {
        return new $0ea09116adcadf95$export$2ae72fc923e5eb5().fromArray(this.elements);
    }
    copy(m) {
        const te = this.elements;
        const me = m.elements;
        te[0] = me[0];
        te[1] = me[1];
        te[2] = me[2];
        te[3] = me[3];
        te[4] = me[4];
        te[5] = me[5];
        te[6] = me[6];
        te[7] = me[7];
        te[8] = me[8];
        te[9] = me[9];
        te[10] = me[10];
        te[11] = me[11];
        te[12] = me[12];
        te[13] = me[13];
        te[14] = me[14];
        te[15] = me[15];
        return this;
    }
    copyPosition(m) {
        const te = this.elements, me = m.elements;
        te[12] = me[12];
        te[13] = me[13];
        te[14] = me[14];
        return this;
    }
    setFromMatrix3(m) {
        const me = m.elements;
        this.set(me[0], me[3], me[6], 0, me[1], me[4], me[7], 0, me[2], me[5], me[8], 0, 0, 0, 0, 1);
        return this;
    }
    extractBasis(xAxis, yAxis, zAxis) {
        xAxis.setFromMatrixColumn(this, 0);
        yAxis.setFromMatrixColumn(this, 1);
        zAxis.setFromMatrixColumn(this, 2);
        return this;
    }
    makeBasis(xAxis, yAxis, zAxis) {
        this.set(xAxis.x, yAxis.x, zAxis.x, 0, xAxis.y, yAxis.y, zAxis.y, 0, xAxis.z, yAxis.z, zAxis.z, 0, 0, 0, 0, 1);
        return this;
    }
    extractRotation(m) {
        // this method does not support reflection matrices
        const te = this.elements;
        const me = m.elements;
        const scaleX = 1 / $0ea09116adcadf95$var$_v1.setFromMatrixColumn(m, 0).length();
        const scaleY = 1 / $0ea09116adcadf95$var$_v1.setFromMatrixColumn(m, 1).length();
        const scaleZ = 1 / $0ea09116adcadf95$var$_v1.setFromMatrixColumn(m, 2).length();
        te[0] = me[0] * scaleX;
        te[1] = me[1] * scaleX;
        te[2] = me[2] * scaleX;
        te[3] = 0;
        te[4] = me[4] * scaleY;
        te[5] = me[5] * scaleY;
        te[6] = me[6] * scaleY;
        te[7] = 0;
        te[8] = me[8] * scaleZ;
        te[9] = me[9] * scaleZ;
        te[10] = me[10] * scaleZ;
        te[11] = 0;
        te[12] = 0;
        te[13] = 0;
        te[14] = 0;
        te[15] = 1;
        return this;
    }
    makeRotationFromEuler(euler) {
        const te = this.elements;
        const x = euler.x, y = euler.y, z = euler.z;
        const a = Math.cos(x), b = Math.sin(x);
        const c = Math.cos(y), d = Math.sin(y);
        const e = Math.cos(z), f = Math.sin(z);
        if (euler.order === 'XYZ') {
            const ae = a * e, af = a * f, be = b * e, bf = b * f;
            te[0] = c * e;
            te[4] = -c * f;
            te[8] = d;
            te[1] = af + be * d;
            te[5] = ae - bf * d;
            te[9] = -b * c;
            te[2] = bf - ae * d;
            te[6] = be + af * d;
            te[10] = a * c;
        } else if (euler.order === 'YXZ') {
            const ce = c * e, cf = c * f, de = d * e, df = d * f;
            te[0] = ce + df * b;
            te[4] = de * b - cf;
            te[8] = a * d;
            te[1] = a * f;
            te[5] = a * e;
            te[9] = -b;
            te[2] = cf * b - de;
            te[6] = df + ce * b;
            te[10] = a * c;
        } else if (euler.order === 'ZXY') {
            const ce = c * e, cf = c * f, de = d * e, df = d * f;
            te[0] = ce - df * b;
            te[4] = -a * f;
            te[8] = de + cf * b;
            te[1] = cf + de * b;
            te[5] = a * e;
            te[9] = df - ce * b;
            te[2] = -a * d;
            te[6] = b;
            te[10] = a * c;
        } else if (euler.order === 'ZYX') {
            const ae = a * e, af = a * f, be = b * e, bf = b * f;
            te[0] = c * e;
            te[4] = be * d - af;
            te[8] = ae * d + bf;
            te[1] = c * f;
            te[5] = bf * d + ae;
            te[9] = af * d - be;
            te[2] = -d;
            te[6] = b * c;
            te[10] = a * c;
        } else if (euler.order === 'YZX') {
            const ac = a * c, ad = a * d, bc = b * c, bd = b * d;
            te[0] = c * e;
            te[4] = bd - ac * f;
            te[8] = bc * f + ad;
            te[1] = f;
            te[5] = a * e;
            te[9] = -b * e;
            te[2] = -d * e;
            te[6] = ad * f + bc;
            te[10] = ac - bd * f;
        } else if (euler.order === 'XZY') {
            const ac = a * c, ad = a * d, bc = b * c, bd = b * d;
            te[0] = c * e;
            te[4] = -f;
            te[8] = d * e;
            te[1] = ac * f + bd;
            te[5] = a * e;
            te[9] = ad * f - bc;
            te[2] = bc * f - ad;
            te[6] = b * e;
            te[10] = bd * f + ac;
        }
        // bottom row
        te[3] = 0;
        te[7] = 0;
        te[11] = 0;
        // last column
        te[12] = 0;
        te[13] = 0;
        te[14] = 0;
        te[15] = 1;
        return this;
    }
    makeRotationFromQuaternion(q) {
        return this.compose($0ea09116adcadf95$var$_zero, q, $0ea09116adcadf95$var$_one);
    }
    lookAt(eye, target, up) {
        const te = this.elements;
        $0ea09116adcadf95$var$_z.subVectors(eye, target);
        if ($0ea09116adcadf95$var$_z.lengthSq() === 0) // eye and target are in the same position
        $0ea09116adcadf95$var$_z.z = 1;
        $0ea09116adcadf95$var$_z.normalize();
        $0ea09116adcadf95$var$_x.crossVectors(up, $0ea09116adcadf95$var$_z);
        if ($0ea09116adcadf95$var$_x.lengthSq() === 0) {
            // up and z are parallel
            if (Math.abs(up.z) === 1) $0ea09116adcadf95$var$_z.x += 0.0001;
            else $0ea09116adcadf95$var$_z.z += 0.0001;
            $0ea09116adcadf95$var$_z.normalize();
            $0ea09116adcadf95$var$_x.crossVectors(up, $0ea09116adcadf95$var$_z);
        }
        $0ea09116adcadf95$var$_x.normalize();
        $0ea09116adcadf95$var$_y.crossVectors($0ea09116adcadf95$var$_z, $0ea09116adcadf95$var$_x);
        te[0] = $0ea09116adcadf95$var$_x.x;
        te[4] = $0ea09116adcadf95$var$_y.x;
        te[8] = $0ea09116adcadf95$var$_z.x;
        te[1] = $0ea09116adcadf95$var$_x.y;
        te[5] = $0ea09116adcadf95$var$_y.y;
        te[9] = $0ea09116adcadf95$var$_z.y;
        te[2] = $0ea09116adcadf95$var$_x.z;
        te[6] = $0ea09116adcadf95$var$_y.z;
        te[10] = $0ea09116adcadf95$var$_z.z;
        return this;
    }
    multiply(m) {
        return this.multiplyMatrices(this, m);
    }
    premultiply(m) {
        return this.multiplyMatrices(m, this);
    }
    multiplyMatrices(a, b) {
        const ae = a.elements;
        const be = b.elements;
        const te = this.elements;
        const a11 = ae[0], a12 = ae[4], a13 = ae[8], a14 = ae[12];
        const a21 = ae[1], a22 = ae[5], a23 = ae[9], a24 = ae[13];
        const a31 = ae[2], a32 = ae[6], a33 = ae[10], a34 = ae[14];
        const a41 = ae[3], a42 = ae[7], a43 = ae[11], a44 = ae[15];
        const b11 = be[0], b12 = be[4], b13 = be[8], b14 = be[12];
        const b21 = be[1], b22 = be[5], b23 = be[9], b24 = be[13];
        const b31 = be[2], b32 = be[6], b33 = be[10], b34 = be[14];
        const b41 = be[3], b42 = be[7], b43 = be[11], b44 = be[15];
        te[0] = a11 * b11 + a12 * b21 + a13 * b31 + a14 * b41;
        te[4] = a11 * b12 + a12 * b22 + a13 * b32 + a14 * b42;
        te[8] = a11 * b13 + a12 * b23 + a13 * b33 + a14 * b43;
        te[12] = a11 * b14 + a12 * b24 + a13 * b34 + a14 * b44;
        te[1] = a21 * b11 + a22 * b21 + a23 * b31 + a24 * b41;
        te[5] = a21 * b12 + a22 * b22 + a23 * b32 + a24 * b42;
        te[9] = a21 * b13 + a22 * b23 + a23 * b33 + a24 * b43;
        te[13] = a21 * b14 + a22 * b24 + a23 * b34 + a24 * b44;
        te[2] = a31 * b11 + a32 * b21 + a33 * b31 + a34 * b41;
        te[6] = a31 * b12 + a32 * b22 + a33 * b32 + a34 * b42;
        te[10] = a31 * b13 + a32 * b23 + a33 * b33 + a34 * b43;
        te[14] = a31 * b14 + a32 * b24 + a33 * b34 + a34 * b44;
        te[3] = a41 * b11 + a42 * b21 + a43 * b31 + a44 * b41;
        te[7] = a41 * b12 + a42 * b22 + a43 * b32 + a44 * b42;
        te[11] = a41 * b13 + a42 * b23 + a43 * b33 + a44 * b43;
        te[15] = a41 * b14 + a42 * b24 + a43 * b34 + a44 * b44;
        return this;
    }
    multiplyScalar(s) {
        const te = this.elements;
        te[0] *= s;
        te[4] *= s;
        te[8] *= s;
        te[12] *= s;
        te[1] *= s;
        te[5] *= s;
        te[9] *= s;
        te[13] *= s;
        te[2] *= s;
        te[6] *= s;
        te[10] *= s;
        te[14] *= s;
        te[3] *= s;
        te[7] *= s;
        te[11] *= s;
        te[15] *= s;
        return this;
    }
    determinant() {
        const te = this.elements;
        const n11 = te[0], n12 = te[4], n13 = te[8], n14 = te[12];
        const n21 = te[1], n22 = te[5], n23 = te[9], n24 = te[13];
        const n31 = te[2], n32 = te[6], n33 = te[10], n34 = te[14];
        const n41 = te[3], n42 = te[7], n43 = te[11], n44 = te[15];
        //TODO: make this more efficient
        //( based on http://www.euclideanspace.com/maths/algebra/matrix/functions/inverse/fourD/index.htm )
        return n41 * (+n14 * n23 * n32 - n13 * n24 * n32 - n14 * n22 * n33 + n12 * n24 * n33 + n13 * n22 * n34 - n12 * n23 * n34) + n42 * (+n11 * n23 * n34 - n11 * n24 * n33 + n14 * n21 * n33 - n13 * n21 * n34 + n13 * n24 * n31 - n14 * n23 * n31) + n43 * (+n11 * n24 * n32 - n11 * n22 * n34 - n14 * n21 * n32 + n12 * n21 * n34 + n14 * n22 * n31 - n12 * n24 * n31) + n44 * (-n13 * n22 * n31 - n11 * n23 * n32 + n11 * n22 * n33 + n13 * n21 * n32 - n12 * n21 * n33 + n12 * n23 * n31);
    }
    transpose() {
        const te = this.elements;
        let tmp;
        tmp = te[1];
        te[1] = te[4];
        te[4] = tmp;
        tmp = te[2];
        te[2] = te[8];
        te[8] = tmp;
        tmp = te[6];
        te[6] = te[9];
        te[9] = tmp;
        tmp = te[3];
        te[3] = te[12];
        te[12] = tmp;
        tmp = te[7];
        te[7] = te[13];
        te[13] = tmp;
        tmp = te[11];
        te[11] = te[14];
        te[14] = tmp;
        return this;
    }
    setPosition(x, y, z) {
        const te = this.elements;
        if (x.isVector3) {
            te[12] = x.x;
            te[13] = x.y;
            te[14] = x.z;
        } else {
            te[12] = x;
            te[13] = y;
            te[14] = z;
        }
        return this;
    }
    invert() {
        // based on http://www.euclideanspace.com/maths/algebra/matrix/functions/inverse/fourD/index.htm
        const te = this.elements, n11 = te[0], n21 = te[1], n31 = te[2], n41 = te[3], n12 = te[4], n22 = te[5], n32 = te[6], n42 = te[7], n13 = te[8], n23 = te[9], n33 = te[10], n43 = te[11], n14 = te[12], n24 = te[13], n34 = te[14], n44 = te[15], t11 = n23 * n34 * n42 - n24 * n33 * n42 + n24 * n32 * n43 - n22 * n34 * n43 - n23 * n32 * n44 + n22 * n33 * n44, t12 = n14 * n33 * n42 - n13 * n34 * n42 - n14 * n32 * n43 + n12 * n34 * n43 + n13 * n32 * n44 - n12 * n33 * n44, t13 = n13 * n24 * n42 - n14 * n23 * n42 + n14 * n22 * n43 - n12 * n24 * n43 - n13 * n22 * n44 + n12 * n23 * n44, t14 = n14 * n23 * n32 - n13 * n24 * n32 - n14 * n22 * n33 + n12 * n24 * n33 + n13 * n22 * n34 - n12 * n23 * n34;
        const det = n11 * t11 + n21 * t12 + n31 * t13 + n41 * t14;
        if (det === 0) return this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
        const detInv = 1 / det;
        te[0] = t11 * detInv;
        te[1] = (n24 * n33 * n41 - n23 * n34 * n41 - n24 * n31 * n43 + n21 * n34 * n43 + n23 * n31 * n44 - n21 * n33 * n44) * detInv;
        te[2] = (n22 * n34 * n41 - n24 * n32 * n41 + n24 * n31 * n42 - n21 * n34 * n42 - n22 * n31 * n44 + n21 * n32 * n44) * detInv;
        te[3] = (n23 * n32 * n41 - n22 * n33 * n41 - n23 * n31 * n42 + n21 * n33 * n42 + n22 * n31 * n43 - n21 * n32 * n43) * detInv;
        te[4] = t12 * detInv;
        te[5] = (n13 * n34 * n41 - n14 * n33 * n41 + n14 * n31 * n43 - n11 * n34 * n43 - n13 * n31 * n44 + n11 * n33 * n44) * detInv;
        te[6] = (n14 * n32 * n41 - n12 * n34 * n41 - n14 * n31 * n42 + n11 * n34 * n42 + n12 * n31 * n44 - n11 * n32 * n44) * detInv;
        te[7] = (n12 * n33 * n41 - n13 * n32 * n41 + n13 * n31 * n42 - n11 * n33 * n42 - n12 * n31 * n43 + n11 * n32 * n43) * detInv;
        te[8] = t13 * detInv;
        te[9] = (n14 * n23 * n41 - n13 * n24 * n41 - n14 * n21 * n43 + n11 * n24 * n43 + n13 * n21 * n44 - n11 * n23 * n44) * detInv;
        te[10] = (n12 * n24 * n41 - n14 * n22 * n41 + n14 * n21 * n42 - n11 * n24 * n42 - n12 * n21 * n44 + n11 * n22 * n44) * detInv;
        te[11] = (n13 * n22 * n41 - n12 * n23 * n41 - n13 * n21 * n42 + n11 * n23 * n42 + n12 * n21 * n43 - n11 * n22 * n43) * detInv;
        te[12] = t14 * detInv;
        te[13] = (n13 * n24 * n31 - n14 * n23 * n31 + n14 * n21 * n33 - n11 * n24 * n33 - n13 * n21 * n34 + n11 * n23 * n34) * detInv;
        te[14] = (n14 * n22 * n31 - n12 * n24 * n31 - n14 * n21 * n32 + n11 * n24 * n32 + n12 * n21 * n34 - n11 * n22 * n34) * detInv;
        te[15] = (n12 * n23 * n31 - n13 * n22 * n31 + n13 * n21 * n32 - n11 * n23 * n32 - n12 * n21 * n33 + n11 * n22 * n33) * detInv;
        return this;
    }
    scale(v) {
        const te = this.elements;
        const x = v.x, y = v.y, z = v.z;
        te[0] *= x;
        te[4] *= y;
        te[8] *= z;
        te[1] *= x;
        te[5] *= y;
        te[9] *= z;
        te[2] *= x;
        te[6] *= y;
        te[10] *= z;
        te[3] *= x;
        te[7] *= y;
        te[11] *= z;
        return this;
    }
    getMaxScaleOnAxis() {
        const te = this.elements;
        const scaleXSq = te[0] * te[0] + te[1] * te[1] + te[2] * te[2];
        const scaleYSq = te[4] * te[4] + te[5] * te[5] + te[6] * te[6];
        const scaleZSq = te[8] * te[8] + te[9] * te[9] + te[10] * te[10];
        return Math.sqrt(Math.max(scaleXSq, scaleYSq, scaleZSq));
    }
    makeTranslation(x, y, z) {
        if (x.isVector3) this.set(1, 0, 0, x.x, 0, 1, 0, x.y, 0, 0, 1, x.z, 0, 0, 0, 1);
        else this.set(1, 0, 0, x, 0, 1, 0, y, 0, 0, 1, z, 0, 0, 0, 1);
        return this;
    }
    makeRotationX(theta) {
        const c = Math.cos(theta), s = Math.sin(theta);
        this.set(1, 0, 0, 0, 0, c, -s, 0, 0, s, c, 0, 0, 0, 0, 1);
        return this;
    }
    makeRotationY(theta) {
        const c = Math.cos(theta), s = Math.sin(theta);
        this.set(c, 0, s, 0, 0, 1, 0, 0, -s, 0, c, 0, 0, 0, 0, 1);
        return this;
    }
    makeRotationZ(theta) {
        const c = Math.cos(theta), s = Math.sin(theta);
        this.set(c, -s, 0, 0, s, c, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
        return this;
    }
    makeRotationAxis(axis, angle) {
        // Based on http://www.gamedev.net/reference/articles/article1199.asp
        const c = Math.cos(angle);
        const s = Math.sin(angle);
        const t = 1 - c;
        const x = axis.x, y = axis.y, z = axis.z;
        const tx = t * x, ty = t * y;
        this.set(tx * x + c, tx * y - s * z, tx * z + s * y, 0, tx * y + s * z, ty * y + c, ty * z - s * x, 0, tx * z - s * y, ty * z + s * x, t * z * z + c, 0, 0, 0, 0, 1);
        return this;
    }
    makeScale(x, y, z) {
        this.set(x, 0, 0, 0, 0, y, 0, 0, 0, 0, z, 0, 0, 0, 0, 1);
        return this;
    }
    makeShear(xy, xz, yx, yz, zx, zy) {
        this.set(1, yx, zx, 0, xy, 1, zy, 0, xz, yz, 1, 0, 0, 0, 0, 1);
        return this;
    }
    compose(position, quaternion, scale) {
        const te = this.elements;
        const x = quaternion._x, y = quaternion._y, z = quaternion._z, w = quaternion._w;
        const x2 = x + x, y2 = y + y, z2 = z + z;
        const xx = x * x2, xy = x * y2, xz = x * z2;
        const yy = y * y2, yz = y * z2, zz = z * z2;
        const wx = w * x2, wy = w * y2, wz = w * z2;
        const sx = scale.x, sy = scale.y, sz = scale.z;
        te[0] = (1 - (yy + zz)) * sx;
        te[1] = (xy + wz) * sx;
        te[2] = (xz - wy) * sx;
        te[3] = 0;
        te[4] = (xy - wz) * sy;
        te[5] = (1 - (xx + zz)) * sy;
        te[6] = (yz + wx) * sy;
        te[7] = 0;
        te[8] = (xz + wy) * sz;
        te[9] = (yz - wx) * sz;
        te[10] = (1 - (xx + yy)) * sz;
        te[11] = 0;
        te[12] = position.x;
        te[13] = position.y;
        te[14] = position.z;
        te[15] = 1;
        return this;
    }
    decompose(position, quaternion, scale) {
        const te = this.elements;
        let sx = $0ea09116adcadf95$var$_v1.set(te[0], te[1], te[2]).length();
        const sy = $0ea09116adcadf95$var$_v1.set(te[4], te[5], te[6]).length();
        const sz = $0ea09116adcadf95$var$_v1.set(te[8], te[9], te[10]).length();
        // if determine is negative, we need to invert one scale
        const det = this.determinant();
        if (det < 0) sx = -sx;
        position.x = te[12];
        position.y = te[13];
        position.z = te[14];
        // scale the rotation part
        $0ea09116adcadf95$var$_m1.copy(this);
        const invSX = 1 / sx;
        const invSY = 1 / sy;
        const invSZ = 1 / sz;
        $0ea09116adcadf95$var$_m1.elements[0] *= invSX;
        $0ea09116adcadf95$var$_m1.elements[1] *= invSX;
        $0ea09116adcadf95$var$_m1.elements[2] *= invSX;
        $0ea09116adcadf95$var$_m1.elements[4] *= invSY;
        $0ea09116adcadf95$var$_m1.elements[5] *= invSY;
        $0ea09116adcadf95$var$_m1.elements[6] *= invSY;
        $0ea09116adcadf95$var$_m1.elements[8] *= invSZ;
        $0ea09116adcadf95$var$_m1.elements[9] *= invSZ;
        $0ea09116adcadf95$var$_m1.elements[10] *= invSZ;
        quaternion.setFromRotationMatrix($0ea09116adcadf95$var$_m1);
        scale.x = sx;
        scale.y = sy;
        scale.z = sz;
        return this;
    }
    makePerspective(left, right, top, bottom, near, far, coordinateSystem = (0, $cb5ee595c0f892af$export$5a0e9190d10875d3)) {
        const te = this.elements;
        const x = 2 * near / (right - left);
        const y = 2 * near / (top - bottom);
        const a = (right + left) / (right - left);
        const b = (top + bottom) / (top - bottom);
        let c, d;
        if (coordinateSystem === (0, $cb5ee595c0f892af$export$5a0e9190d10875d3)) {
            c = -(far + near) / (far - near);
            d = -2 * far * near / (far - near);
        } else if (coordinateSystem === (0, $cb5ee595c0f892af$export$cc83beedcb9be9ac)) {
            c = -far / (far - near);
            d = -far * near / (far - near);
        } else throw new Error('THREE.Matrix4.makePerspective(): Invalid coordinate system: ' + coordinateSystem);
        te[0] = x;
        te[4] = 0;
        te[8] = a;
        te[12] = 0;
        te[1] = 0;
        te[5] = y;
        te[9] = b;
        te[13] = 0;
        te[2] = 0;
        te[6] = 0;
        te[10] = c;
        te[14] = d;
        te[3] = 0;
        te[7] = 0;
        te[11] = -1;
        te[15] = 0;
        return this;
    }
    makeOrthographic(left, right, top, bottom, near, far, coordinateSystem = (0, $cb5ee595c0f892af$export$5a0e9190d10875d3)) {
        const te = this.elements;
        const w = 1.0 / (right - left);
        const h = 1.0 / (top - bottom);
        const p = 1.0 / (far - near);
        const x = (right + left) * w;
        const y = (top + bottom) * h;
        let z, zInv;
        if (coordinateSystem === (0, $cb5ee595c0f892af$export$5a0e9190d10875d3)) {
            z = (far + near) * p;
            zInv = -2 * p;
        } else if (coordinateSystem === (0, $cb5ee595c0f892af$export$cc83beedcb9be9ac)) {
            z = near * p;
            zInv = -1 * p;
        } else throw new Error('THREE.Matrix4.makeOrthographic(): Invalid coordinate system: ' + coordinateSystem);
        te[0] = 2 * w;
        te[4] = 0;
        te[8] = 0;
        te[12] = -x;
        te[1] = 0;
        te[5] = 2 * h;
        te[9] = 0;
        te[13] = -y;
        te[2] = 0;
        te[6] = 0;
        te[10] = zInv;
        te[14] = -z;
        te[3] = 0;
        te[7] = 0;
        te[11] = 0;
        te[15] = 1;
        return this;
    }
    equals(matrix) {
        const te = this.elements;
        const me = matrix.elements;
        for(let i = 0; i < 16; i++){
            if (te[i] !== me[i]) return false;
        }
        return true;
    }
    fromArray(array, offset = 0) {
        for(let i = 0; i < 16; i++)this.elements[i] = array[i + offset];
        return this;
    }
    toArray(array = [], offset = 0) {
        const te = this.elements;
        array[offset] = te[0];
        array[offset + 1] = te[1];
        array[offset + 2] = te[2];
        array[offset + 3] = te[3];
        array[offset + 4] = te[4];
        array[offset + 5] = te[5];
        array[offset + 6] = te[6];
        array[offset + 7] = te[7];
        array[offset + 8] = te[8];
        array[offset + 9] = te[9];
        array[offset + 10] = te[10];
        array[offset + 11] = te[11];
        array[offset + 12] = te[12];
        array[offset + 13] = te[13];
        array[offset + 14] = te[14];
        array[offset + 15] = te[15];
        return array;
    }
}
const $0ea09116adcadf95$var$_v1 = /*@__PURE__*/ new (0, $d7d0ac0e47013885$export$64b5c384219d3699)();
const $0ea09116adcadf95$var$_m1 = /*@__PURE__*/ new $0ea09116adcadf95$export$2ae72fc923e5eb5();
const $0ea09116adcadf95$var$_zero = /*@__PURE__*/ new (0, $d7d0ac0e47013885$export$64b5c384219d3699)(0, 0, 0);
const $0ea09116adcadf95$var$_one = /*@__PURE__*/ new (0, $d7d0ac0e47013885$export$64b5c384219d3699)(1, 1, 1);
const $0ea09116adcadf95$var$_x = /*@__PURE__*/ new (0, $d7d0ac0e47013885$export$64b5c384219d3699)();
const $0ea09116adcadf95$var$_y = /*@__PURE__*/ new (0, $d7d0ac0e47013885$export$64b5c384219d3699)();
const $0ea09116adcadf95$var$_z = /*@__PURE__*/ new (0, $d7d0ac0e47013885$export$64b5c384219d3699)();



class $3c03061dea0adea3$export$c977b3e384af9ae1 {
    constructor(x = 0, y = 0){
        $3c03061dea0adea3$export$c977b3e384af9ae1.prototype.isVector2 = true;
        this.x = x;
        this.y = y;
    }
    get width() {
        return this.x;
    }
    set width(value) {
        this.x = value;
    }
    get height() {
        return this.y;
    }
    set height(value) {
        this.y = value;
    }
    set(x, y) {
        this.x = x;
        this.y = y;
        return this;
    }
    setScalar(scalar) {
        this.x = scalar;
        this.y = scalar;
        return this;
    }
    setX(x) {
        this.x = x;
        return this;
    }
    setY(y) {
        this.y = y;
        return this;
    }
    setComponent(index, value) {
        switch(index){
            case 0:
                this.x = value;
                break;
            case 1:
                this.y = value;
                break;
            default:
                throw new Error('index is out of range: ' + index);
        }
        return this;
    }
    getComponent(index) {
        switch(index){
            case 0:
                return this.x;
            case 1:
                return this.y;
            default:
                throw new Error('index is out of range: ' + index);
        }
    }
    clone() {
        return new this.constructor(this.x, this.y);
    }
    copy(v) {
        this.x = v.x;
        this.y = v.y;
        return this;
    }
    add(v) {
        this.x += v.x;
        this.y += v.y;
        return this;
    }
    addScalar(s) {
        this.x += s;
        this.y += s;
        return this;
    }
    addVectors(a, b) {
        this.x = a.x + b.x;
        this.y = a.y + b.y;
        return this;
    }
    addScaledVector(v, s) {
        this.x += v.x * s;
        this.y += v.y * s;
        return this;
    }
    sub(v) {
        this.x -= v.x;
        this.y -= v.y;
        return this;
    }
    subScalar(s) {
        this.x -= s;
        this.y -= s;
        return this;
    }
    subVectors(a, b) {
        this.x = a.x - b.x;
        this.y = a.y - b.y;
        return this;
    }
    multiply(v) {
        this.x *= v.x;
        this.y *= v.y;
        return this;
    }
    multiplyScalar(scalar) {
        this.x *= scalar;
        this.y *= scalar;
        return this;
    }
    divide(v) {
        this.x /= v.x;
        this.y /= v.y;
        return this;
    }
    divideScalar(scalar) {
        return this.multiplyScalar(1 / scalar);
    }
    applyMatrix3(m) {
        const x = this.x, y = this.y;
        const e = m.elements;
        this.x = e[0] * x + e[3] * y + e[6];
        this.y = e[1] * x + e[4] * y + e[7];
        return this;
    }
    min(v) {
        this.x = Math.min(this.x, v.x);
        this.y = Math.min(this.y, v.y);
        return this;
    }
    max(v) {
        this.x = Math.max(this.x, v.x);
        this.y = Math.max(this.y, v.y);
        return this;
    }
    clamp(min, max) {
        // assumes min < max, componentwise
        this.x = Math.max(min.x, Math.min(max.x, this.x));
        this.y = Math.max(min.y, Math.min(max.y, this.y));
        return this;
    }
    clampScalar(minVal, maxVal) {
        this.x = Math.max(minVal, Math.min(maxVal, this.x));
        this.y = Math.max(minVal, Math.min(maxVal, this.y));
        return this;
    }
    clampLength(min, max) {
        const length = this.length();
        return this.divideScalar(length || 1).multiplyScalar(Math.max(min, Math.min(max, length)));
    }
    floor() {
        this.x = Math.floor(this.x);
        this.y = Math.floor(this.y);
        return this;
    }
    ceil() {
        this.x = Math.ceil(this.x);
        this.y = Math.ceil(this.y);
        return this;
    }
    round() {
        this.x = Math.round(this.x);
        this.y = Math.round(this.y);
        return this;
    }
    roundToZero() {
        this.x = Math.trunc(this.x);
        this.y = Math.trunc(this.y);
        return this;
    }
    negate() {
        this.x = -this.x;
        this.y = -this.y;
        return this;
    }
    dot(v) {
        return this.x * v.x + this.y * v.y;
    }
    cross(v) {
        return this.x * v.y - this.y * v.x;
    }
    lengthSq() {
        return this.x * this.x + this.y * this.y;
    }
    length() {
        return Math.sqrt(this.x * this.x + this.y * this.y);
    }
    manhattanLength() {
        return Math.abs(this.x) + Math.abs(this.y);
    }
    normalize() {
        return this.divideScalar(this.length() || 1);
    }
    angle() {
        // computes the angle in radians with respect to the positive x-axis
        const angle = Math.atan2(-this.y, -this.x) + Math.PI;
        return angle;
    }
    angleTo(v) {
        const denominator = Math.sqrt(this.lengthSq() * v.lengthSq());
        if (denominator === 0) return Math.PI / 2;
        const theta = this.dot(v) / denominator;
        // clamp, to handle numerical problems
        return Math.acos($7f727a3c7059d20d$export$7d15b64cf5a3a4c4(theta, -1, 1));
    }
    distanceTo(v) {
        return Math.sqrt(this.distanceToSquared(v));
    }
    distanceToSquared(v) {
        const dx = this.x - v.x, dy = this.y - v.y;
        return dx * dx + dy * dy;
    }
    manhattanDistanceTo(v) {
        return Math.abs(this.x - v.x) + Math.abs(this.y - v.y);
    }
    setLength(length) {
        return this.normalize().multiplyScalar(length);
    }
    lerp(v, alpha) {
        this.x += (v.x - this.x) * alpha;
        this.y += (v.y - this.y) * alpha;
        return this;
    }
    lerpVectors(v1, v2, alpha) {
        this.x = v1.x + (v2.x - v1.x) * alpha;
        this.y = v1.y + (v2.y - v1.y) * alpha;
        return this;
    }
    equals(v) {
        return v.x === this.x && v.y === this.y;
    }
    fromArray(array, offset = 0) {
        this.x = array[offset];
        this.y = array[offset + 1];
        return this;
    }
    toArray(array = [], offset = 0) {
        array[offset] = this.x;
        array[offset + 1] = this.y;
        return array;
    }
    fromBufferAttribute(attribute, index) {
        this.x = attribute.getX(index);
        this.y = attribute.getY(index);
        return this;
    }
    rotateAround(center, angle) {
        const c = Math.cos(angle), s = Math.sin(angle);
        const x = this.x - center.x;
        const y = this.y - center.y;
        this.x = x * c - y * s + center.x;
        this.y = x * s + y * c + center.y;
        return this;
    }
    random() {
        this.x = Math.random();
        this.y = Math.random();
        return this;
    }
    *[Symbol.iterator]() {
        yield this.x;
        yield this.y;
    }
}



class $a09a15e9a8421204$export$fa7daccca11cdbe3 {
    constructor(x = 0, y = 0, z = 0, w = 1){
        $a09a15e9a8421204$export$fa7daccca11cdbe3.prototype.isVector4 = true;
        this.x = x;
        this.y = y;
        this.z = z;
        this.w = w;
    }
    get width() {
        return this.z;
    }
    set width(value) {
        this.z = value;
    }
    get height() {
        return this.w;
    }
    set height(value) {
        this.w = value;
    }
    set(x, y, z, w) {
        this.x = x;
        this.y = y;
        this.z = z;
        this.w = w;
        return this;
    }
    setScalar(scalar) {
        this.x = scalar;
        this.y = scalar;
        this.z = scalar;
        this.w = scalar;
        return this;
    }
    setX(x) {
        this.x = x;
        return this;
    }
    setY(y) {
        this.y = y;
        return this;
    }
    setZ(z) {
        this.z = z;
        return this;
    }
    setW(w) {
        this.w = w;
        return this;
    }
    setComponent(index, value) {
        switch(index){
            case 0:
                this.x = value;
                break;
            case 1:
                this.y = value;
                break;
            case 2:
                this.z = value;
                break;
            case 3:
                this.w = value;
                break;
            default:
                throw new Error('index is out of range: ' + index);
        }
        return this;
    }
    getComponent(index) {
        switch(index){
            case 0:
                return this.x;
            case 1:
                return this.y;
            case 2:
                return this.z;
            case 3:
                return this.w;
            default:
                throw new Error('index is out of range: ' + index);
        }
    }
    clone() {
        return new this.constructor(this.x, this.y, this.z, this.w);
    }
    copy(v) {
        this.x = v.x;
        this.y = v.y;
        this.z = v.z;
        this.w = v.w !== undefined ? v.w : 1;
        return this;
    }
    add(v) {
        this.x += v.x;
        this.y += v.y;
        this.z += v.z;
        this.w += v.w;
        return this;
    }
    addScalar(s) {
        this.x += s;
        this.y += s;
        this.z += s;
        this.w += s;
        return this;
    }
    addVectors(a, b) {
        this.x = a.x + b.x;
        this.y = a.y + b.y;
        this.z = a.z + b.z;
        this.w = a.w + b.w;
        return this;
    }
    addScaledVector(v, s) {
        this.x += v.x * s;
        this.y += v.y * s;
        this.z += v.z * s;
        this.w += v.w * s;
        return this;
    }
    sub(v) {
        this.x -= v.x;
        this.y -= v.y;
        this.z -= v.z;
        this.w -= v.w;
        return this;
    }
    subScalar(s) {
        this.x -= s;
        this.y -= s;
        this.z -= s;
        this.w -= s;
        return this;
    }
    subVectors(a, b) {
        this.x = a.x - b.x;
        this.y = a.y - b.y;
        this.z = a.z - b.z;
        this.w = a.w - b.w;
        return this;
    }
    multiply(v) {
        this.x *= v.x;
        this.y *= v.y;
        this.z *= v.z;
        this.w *= v.w;
        return this;
    }
    multiplyScalar(scalar) {
        this.x *= scalar;
        this.y *= scalar;
        this.z *= scalar;
        this.w *= scalar;
        return this;
    }
    applyMatrix4(m) {
        const x = this.x, y = this.y, z = this.z, w = this.w;
        const e = m.elements;
        this.x = e[0] * x + e[4] * y + e[8] * z + e[12] * w;
        this.y = e[1] * x + e[5] * y + e[9] * z + e[13] * w;
        this.z = e[2] * x + e[6] * y + e[10] * z + e[14] * w;
        this.w = e[3] * x + e[7] * y + e[11] * z + e[15] * w;
        return this;
    }
    divide(v) {
        this.x /= v.x;
        this.y /= v.y;
        this.z /= v.z;
        this.w /= v.w;
        return this;
    }
    divideScalar(scalar) {
        return this.multiplyScalar(1 / scalar);
    }
    setAxisAngleFromQuaternion(q) {
        // http://www.euclideanspace.com/maths/geometry/rotations/conversions/quaternionToAngle/index.htm
        // q is assumed to be normalized
        this.w = 2 * Math.acos(q.w);
        const s = Math.sqrt(1 - q.w * q.w);
        if (s < 0.0001) {
            this.x = 1;
            this.y = 0;
            this.z = 0;
        } else {
            this.x = q.x / s;
            this.y = q.y / s;
            this.z = q.z / s;
        }
        return this;
    }
    setAxisAngleFromRotationMatrix(m) {
        // http://www.euclideanspace.com/maths/geometry/rotations/conversions/matrixToAngle/index.htm
        // assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)
        let angle, x, y, z; // variables for result
        const epsilon = 0.01, epsilon2 = 0.1, te = m.elements, m11 = te[0], m12 = te[4], m13 = te[8], m21 = te[1], m22 = te[5], m23 = te[9], m31 = te[2], m32 = te[6], m33 = te[10];
        if (Math.abs(m12 - m21) < epsilon && Math.abs(m13 - m31) < epsilon && Math.abs(m23 - m32) < epsilon) {
            // singularity found
            // first check for identity matrix which must have +1 for all terms
            // in leading diagonal and zero in other terms
            if (Math.abs(m12 + m21) < epsilon2 && Math.abs(m13 + m31) < epsilon2 && Math.abs(m23 + m32) < epsilon2 && Math.abs(m11 + m22 + m33 - 3) < epsilon2) {
                // this singularity is identity matrix so angle = 0
                this.set(1, 0, 0, 0);
                return this; // zero angle, arbitrary axis
            }
            // otherwise this singularity is angle = 180
            angle = Math.PI;
            const xx = (m11 + 1) / 2;
            const yy = (m22 + 1) / 2;
            const zz = (m33 + 1) / 2;
            const xy = (m12 + m21) / 4;
            const xz = (m13 + m31) / 4;
            const yz = (m23 + m32) / 4;
            if (xx > yy && xx > zz) {
                // m11 is the largest diagonal term
                if (xx < epsilon) {
                    x = 0;
                    y = 0.707106781;
                    z = 0.707106781;
                } else {
                    x = Math.sqrt(xx);
                    y = xy / x;
                    z = xz / x;
                }
            } else if (yy > zz) {
                // m22 is the largest diagonal term
                if (yy < epsilon) {
                    x = 0.707106781;
                    y = 0;
                    z = 0.707106781;
                } else {
                    y = Math.sqrt(yy);
                    x = xy / y;
                    z = yz / y;
                }
            } else // m33 is the largest diagonal term so base result on this
            if (zz < epsilon) {
                x = 0.707106781;
                y = 0.707106781;
                z = 0;
            } else {
                z = Math.sqrt(zz);
                x = xz / z;
                y = yz / z;
            }
            this.set(x, y, z, angle);
            return this; // return 180 deg rotation
        }
        // as we have reached here there are no singularities so we can handle normally
        let s = Math.sqrt((m32 - m23) * (m32 - m23) + (m13 - m31) * (m13 - m31) + (m21 - m12) * (m21 - m12)); // used to normalize
        if (Math.abs(s) < 0.001) s = 1;
        // prevent divide by zero, should not happen if matrix is orthogonal and should be
        // caught by singularity test above, but I've left it in just in case
        this.x = (m32 - m23) / s;
        this.y = (m13 - m31) / s;
        this.z = (m21 - m12) / s;
        this.w = Math.acos((m11 + m22 + m33 - 1) / 2);
        return this;
    }
    setFromMatrixPosition(m) {
        const e = m.elements;
        this.x = e[12];
        this.y = e[13];
        this.z = e[14];
        this.w = e[15];
        return this;
    }
    min(v) {
        this.x = Math.min(this.x, v.x);
        this.y = Math.min(this.y, v.y);
        this.z = Math.min(this.z, v.z);
        this.w = Math.min(this.w, v.w);
        return this;
    }
    max(v) {
        this.x = Math.max(this.x, v.x);
        this.y = Math.max(this.y, v.y);
        this.z = Math.max(this.z, v.z);
        this.w = Math.max(this.w, v.w);
        return this;
    }
    clamp(min, max) {
        // assumes min < max, componentwise
        this.x = Math.max(min.x, Math.min(max.x, this.x));
        this.y = Math.max(min.y, Math.min(max.y, this.y));
        this.z = Math.max(min.z, Math.min(max.z, this.z));
        this.w = Math.max(min.w, Math.min(max.w, this.w));
        return this;
    }
    clampScalar(minVal, maxVal) {
        this.x = Math.max(minVal, Math.min(maxVal, this.x));
        this.y = Math.max(minVal, Math.min(maxVal, this.y));
        this.z = Math.max(minVal, Math.min(maxVal, this.z));
        this.w = Math.max(minVal, Math.min(maxVal, this.w));
        return this;
    }
    clampLength(min, max) {
        const length = this.length();
        return this.divideScalar(length || 1).multiplyScalar(Math.max(min, Math.min(max, length)));
    }
    floor() {
        this.x = Math.floor(this.x);
        this.y = Math.floor(this.y);
        this.z = Math.floor(this.z);
        this.w = Math.floor(this.w);
        return this;
    }
    ceil() {
        this.x = Math.ceil(this.x);
        this.y = Math.ceil(this.y);
        this.z = Math.ceil(this.z);
        this.w = Math.ceil(this.w);
        return this;
    }
    round() {
        this.x = Math.round(this.x);
        this.y = Math.round(this.y);
        this.z = Math.round(this.z);
        this.w = Math.round(this.w);
        return this;
    }
    roundToZero() {
        this.x = Math.trunc(this.x);
        this.y = Math.trunc(this.y);
        this.z = Math.trunc(this.z);
        this.w = Math.trunc(this.w);
        return this;
    }
    negate() {
        this.x = -this.x;
        this.y = -this.y;
        this.z = -this.z;
        this.w = -this.w;
        return this;
    }
    dot(v) {
        return this.x * v.x + this.y * v.y + this.z * v.z + this.w * v.w;
    }
    lengthSq() {
        return this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w;
    }
    length() {
        return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w);
    }
    manhattanLength() {
        return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z) + Math.abs(this.w);
    }
    normalize() {
        return this.divideScalar(this.length() || 1);
    }
    setLength(length) {
        return this.normalize().multiplyScalar(length);
    }
    lerp(v, alpha) {
        this.x += (v.x - this.x) * alpha;
        this.y += (v.y - this.y) * alpha;
        this.z += (v.z - this.z) * alpha;
        this.w += (v.w - this.w) * alpha;
        return this;
    }
    lerpVectors(v1, v2, alpha) {
        this.x = v1.x + (v2.x - v1.x) * alpha;
        this.y = v1.y + (v2.y - v1.y) * alpha;
        this.z = v1.z + (v2.z - v1.z) * alpha;
        this.w = v1.w + (v2.w - v1.w) * alpha;
        return this;
    }
    equals(v) {
        return v.x === this.x && v.y === this.y && v.z === this.z && v.w === this.w;
    }
    fromArray(array, offset = 0) {
        this.x = array[offset];
        this.y = array[offset + 1];
        this.z = array[offset + 2];
        this.w = array[offset + 3];
        return this;
    }
    toArray(array = [], offset = 0) {
        array[offset] = this.x;
        array[offset + 1] = this.y;
        array[offset + 2] = this.z;
        array[offset + 3] = this.w;
        return array;
    }
    fromBufferAttribute(attribute, index) {
        this.x = attribute.getX(index);
        this.y = attribute.getY(index);
        this.z = attribute.getZ(index);
        this.w = attribute.getW(index);
        return this;
    }
    random() {
        this.x = Math.random();
        this.y = Math.random();
        this.z = Math.random();
        this.w = Math.random();
        return this;
    }
    *[Symbol.iterator]() {
        yield this.x;
        yield this.y;
        yield this.z;
        yield this.w;
    }
}


// cyrb53 (c) 2018 bryc (github.com/bryc). License: Public domain. Attribution appreciated.
// A fast and simple 64-bit (or 53-bit) string hash function with decent collision resistance.
// Largely inspired by MurmurHash2/3, but with a focus on speed/simplicity.
// See https://stackoverflow.com/questions/7616461/generate-a-hash-from-string-in-javascript/52171480#52171480
// https://github.com/bryc/code/blob/master/jshash/experimental/cyrb53.js
function $97d1d441621670a9$var$cyrb53(value, seed = 0) {
    let h1 = 0xdeadbeef ^ seed, h2 = 0x41c6ce57 ^ seed;
    if (value instanceof Array) for(let i = 0, val; i < value.length; i++){
        val = value[i];
        h1 = Math.imul(h1 ^ val, 2654435761);
        h2 = Math.imul(h2 ^ val, 1597334677);
    }
    else for(let i = 0, ch; i < value.length; i++){
        ch = value.charCodeAt(i);
        h1 = Math.imul(h1 ^ ch, 2654435761);
        h2 = Math.imul(h2 ^ ch, 1597334677);
    }
    h1 = Math.imul(h1 ^ h1 >>> 16, 2246822507);
    h1 ^= Math.imul(h2 ^ h2 >>> 13, 3266489909);
    h2 = Math.imul(h2 ^ h2 >>> 16, 2246822507);
    h2 ^= Math.imul(h1 ^ h1 >>> 13, 3266489909);
    return 4294967296 * (2097151 & h2) + (h1 >>> 0);
}
const $97d1d441621670a9$export$9169be2e06c9c165 = (str)=>$97d1d441621670a9$var$cyrb53(str);
const $97d1d441621670a9$export$cf0fb017e44bd6a4 = (array)=>$97d1d441621670a9$var$cyrb53(array);
const $97d1d441621670a9$export$d6af199866bfb566 = (...params)=>$97d1d441621670a9$var$cyrb53(params);
function $97d1d441621670a9$export$611736262b635f8d(object, force = false) {
    const values = [];
    if (object.isNode === true) {
        values.push(object.id);
        object = object.getSelf();
    }
    for (const { property: property, childNode: childNode } of $97d1d441621670a9$export$1f1998cc3c6b56fb(object))values.push(values, $97d1d441621670a9$var$cyrb53(property.slice(0, -4)), childNode.getCacheKey(force));
    return $97d1d441621670a9$var$cyrb53(values);
}
function* $97d1d441621670a9$export$1f1998cc3c6b56fb(node, toJSON = false) {
    for(const property in node){
        // Ignore private properties.
        if (property.startsWith('_') === true) continue;
        const object = node[property];
        if (Array.isArray(object) === true) for(let i = 0; i < object.length; i++){
            const child = object[i];
            if (child && (child.isNode === true || toJSON && typeof child.toJSON === 'function')) yield {
                property: property,
                index: i,
                childNode: child
            };
        }
        else if (object && object.isNode === true) yield {
            property: property,
            childNode: object
        };
        else if (typeof object === 'object') for(const subProperty in object){
            const child = object[subProperty];
            if (child && (child.isNode === true || toJSON && typeof child.toJSON === 'function')) yield {
                property: property,
                index: subProperty,
                childNode: child
            };
        }
    }
}
function $97d1d441621670a9$export$cc7ab17e03dab419(value) {
    if (value === undefined || value === null) return null;
    const typeOf = typeof value;
    if (value.isNode === true) return 'node';
    else if (typeOf === 'number') return 'float';
    else if (typeOf === 'boolean') return 'bool';
    else if (typeOf === 'string') return 'string';
    else if (typeOf === 'function') return 'shader';
    else if (value.isVector2 === true) return 'vec2';
    else if (value.isVector3 === true) return 'vec3';
    else if (value.isVector4 === true) return 'vec4';
    else if (value.isMatrix3 === true) return 'mat3';
    else if (value.isMatrix4 === true) return 'mat4';
    else if (value.isColor === true) return 'color';
    else if (value instanceof ArrayBuffer) return 'ArrayBuffer';
    return null;
}
function $97d1d441621670a9$export$64e17ccd4a503243(type, ...params) {
    const last4 = type ? type.slice(-4) : undefined;
    if (params.length === 1) {
        if (last4 === 'vec2') params = [
            params[0],
            params[0]
        ];
        else if (last4 === 'vec3') params = [
            params[0],
            params[0],
            params[0]
        ];
        else if (last4 === 'vec4') params = [
            params[0],
            params[0],
            params[0],
            params[0]
        ];
    }
    if (type === 'color') return new (0, $9a23ce591a1b6760$export$892596cec99bc70e)(...params);
    else if (last4 === 'vec2') return new (0, $3c03061dea0adea3$export$c977b3e384af9ae1)(...params);
    else if (last4 === 'vec3') return new (0, $d7d0ac0e47013885$export$64b5c384219d3699)(...params);
    else if (last4 === 'vec4') return new (0, $a09a15e9a8421204$export$fa7daccca11cdbe3)(...params);
    else if (last4 === 'mat3') return new (0, $800ed18490319df2$export$8ff26dafa08918)(...params);
    else if (last4 === 'mat4') return new (0, $0ea09116adcadf95$export$2ae72fc923e5eb5)(...params);
    else if (type === 'bool') return params[0] || false;
    else if (type === 'float' || type === 'int' || type === 'uint') return params[0] || 0;
    else if (type === 'string') return params[0] || '';
    else if (type === 'ArrayBuffer') return $97d1d441621670a9$export$a7a17e76664e3e44(params[0]);
    return null;
}
function $97d1d441621670a9$export$70c4ae293293ca1e(arrayBuffer) {
    let chars = '';
    const array = new Uint8Array(arrayBuffer);
    for(let i = 0; i < array.length; i++)chars += String.fromCharCode(array[i]);
    return btoa(chars);
}
function $97d1d441621670a9$export$a7a17e76664e3e44(base64) {
    return Uint8Array.from(atob(base64), (c)=>c.charCodeAt(0)).buffer;
}





const $741db1fce3b06570$var$_vector1 = /*@__PURE__*/ new (0, $d7d0ac0e47013885$export$64b5c384219d3699)();
const $741db1fce3b06570$var$_vector2 = /*@__PURE__*/ new (0, $d7d0ac0e47013885$export$64b5c384219d3699)();
const $741db1fce3b06570$var$_normalMatrix = /*@__PURE__*/ new (0, $800ed18490319df2$export$8ff26dafa08918)();
class $741db1fce3b06570$export$7ff5ac152ef991b0 {
    constructor(normal = new (0, $d7d0ac0e47013885$export$64b5c384219d3699)(1, 0, 0), constant = 0){
        this.isPlane = true;
        // normal is assumed to be normalized
        this.normal = normal;
        this.constant = constant;
    }
    set(normal, constant) {
        this.normal.copy(normal);
        this.constant = constant;
        return this;
    }
    setComponents(x, y, z, w) {
        this.normal.set(x, y, z);
        this.constant = w;
        return this;
    }
    setFromNormalAndCoplanarPoint(normal, point) {
        this.normal.copy(normal);
        this.constant = -point.dot(this.normal);
        return this;
    }
    setFromCoplanarPoints(a, b, c) {
        const normal = $741db1fce3b06570$var$_vector1.subVectors(c, b).cross($741db1fce3b06570$var$_vector2.subVectors(a, b)).normalize();
        // Q: should an error be thrown if normal is zero (e.g. degenerate plane)?
        this.setFromNormalAndCoplanarPoint(normal, a);
        return this;
    }
    copy(plane) {
        this.normal.copy(plane.normal);
        this.constant = plane.constant;
        return this;
    }
    normalize() {
        // Note: will lead to a divide by zero if the plane is invalid.
        const inverseNormalLength = 1.0 / this.normal.length();
        this.normal.multiplyScalar(inverseNormalLength);
        this.constant *= inverseNormalLength;
        return this;
    }
    negate() {
        this.constant *= -1;
        this.normal.negate();
        return this;
    }
    distanceToPoint(point) {
        return this.normal.dot(point) + this.constant;
    }
    distanceToSphere(sphere) {
        return this.distanceToPoint(sphere.center) - sphere.radius;
    }
    projectPoint(point, target) {
        return target.copy(point).addScaledVector(this.normal, -this.distanceToPoint(point));
    }
    intersectLine(line, target) {
        const direction = line.delta($741db1fce3b06570$var$_vector1);
        const denominator = this.normal.dot(direction);
        if (denominator === 0) {
            // line is coplanar, return origin
            if (this.distanceToPoint(line.start) === 0) return target.copy(line.start);
            // Unsure if this is the correct method to handle this case.
            return null;
        }
        const t = -(line.start.dot(this.normal) + this.constant) / denominator;
        if (t < 0 || t > 1) return null;
        return target.copy(line.start).addScaledVector(direction, t);
    }
    intersectsLine(line) {
        // Note: this tests if a line intersects the plane, not whether it (or its end-points) are coplanar with it.
        const startSign = this.distanceToPoint(line.start);
        const endSign = this.distanceToPoint(line.end);
        return startSign < 0 && endSign > 0 || endSign < 0 && startSign > 0;
    }
    intersectsBox(box) {
        return box.intersectsPlane(this);
    }
    intersectsSphere(sphere) {
        return sphere.intersectsPlane(this);
    }
    coplanarPoint(target) {
        return target.copy(this.normal).multiplyScalar(-this.constant);
    }
    applyMatrix4(matrix, optionalNormalMatrix) {
        const normalMatrix = optionalNormalMatrix || $741db1fce3b06570$var$_normalMatrix.getNormalMatrix(matrix);
        const referencePoint = this.coplanarPoint($741db1fce3b06570$var$_vector1).applyMatrix4(matrix);
        const normal = this.normal.applyMatrix3(normalMatrix).normalize();
        this.constant = -referencePoint.dot(normal);
        return this;
    }
    translate(offset) {
        this.constant -= offset.dot(this.normal);
        return this;
    }
    equals(plane) {
        return plane.normal.equals(this.normal) && plane.constant === this.constant;
    }
    clone() {
        return new this.constructor().copy(this);
    }
}




const $40f294098437e551$var$_plane = /*@__PURE__*/ new (0, $741db1fce3b06570$export$7ff5ac152ef991b0)();
class $40f294098437e551$var$ClippingContext {
    constructor(){
        this.version = 0;
        this.globalClippingCount = 0;
        this.localClippingCount = 0;
        this.localClippingEnabled = false;
        this.localClipIntersection = false;
        this.planes = [];
        this.parentVersion = 0;
        this.viewNormalMatrix = new (0, $800ed18490319df2$export$8ff26dafa08918)();
        this.cacheKey = 0;
    }
    projectPlanes(source, offset) {
        const l = source.length;
        const planes = this.planes;
        for(let i = 0; i < l; i++){
            $40f294098437e551$var$_plane.copy(source[i]).applyMatrix4(this.viewMatrix, this.viewNormalMatrix);
            const v = planes[offset + i];
            const normal = $40f294098437e551$var$_plane.normal;
            v.x = -normal.x;
            v.y = -normal.y;
            v.z = -normal.z;
            v.w = $40f294098437e551$var$_plane.constant;
        }
    }
    updateGlobal(renderer, camera) {
        const rendererClippingPlanes = renderer.clippingPlanes;
        this.viewMatrix = camera.matrixWorldInverse;
        this.viewNormalMatrix.getNormalMatrix(this.viewMatrix);
        let update = false;
        if (Array.isArray(rendererClippingPlanes) && rendererClippingPlanes.length !== 0) {
            const l = rendererClippingPlanes.length;
            if (l !== this.globalClippingCount) {
                const planes = [];
                for(let i = 0; i < l; i++)planes.push(new (0, $a09a15e9a8421204$export$fa7daccca11cdbe3)());
                this.globalClippingCount = l;
                this.planes = planes;
                update = true;
            }
            this.projectPlanes(rendererClippingPlanes, 0);
        } else if (this.globalClippingCount !== 0) {
            this.globalClippingCount = 0;
            this.planes = [];
            update = true;
        }
        if (renderer.localClippingEnabled !== this.localClippingEnabled) {
            this.localClippingEnabled = renderer.localClippingEnabled;
            update = true;
        }
        if (update) {
            this.version++;
            this.cacheKey = (0, $97d1d441621670a9$export$d6af199866bfb566)(this.globalClippingCount, this.localClippingEnabled === true ? 1 : 0);
        }
    }
    update(parent, material) {
        let update = false;
        if (this !== parent && parent.version !== this.parentVersion) {
            this.globalClippingCount = material.isShadowNodeMaterial ? 0 : parent.globalClippingCount;
            this.localClippingEnabled = parent.localClippingEnabled;
            this.planes = Array.from(parent.planes);
            this.parentVersion = parent.version;
            this.viewMatrix = parent.viewMatrix;
            this.viewNormalMatrix = parent.viewNormalMatrix;
            update = true;
        }
        if (this.localClippingEnabled) {
            const localClippingPlanes = material.clippingPlanes;
            if (Array.isArray(localClippingPlanes) && localClippingPlanes.length !== 0) {
                const l = localClippingPlanes.length;
                const planes = this.planes;
                const offset = this.globalClippingCount;
                if (update || l !== this.localClippingCount) {
                    planes.length = offset + l;
                    for(let i = 0; i < l; i++)planes[offset + i] = new (0, $a09a15e9a8421204$export$fa7daccca11cdbe3)();
                    this.localClippingCount = l;
                    update = true;
                }
                this.projectPlanes(localClippingPlanes, offset);
            } else if (this.localClippingCount !== 0) {
                this.localClippingCount = 0;
                update = true;
            }
            if (this.localClipIntersection !== material.clipIntersection) {
                this.localClipIntersection = material.clipIntersection;
                update = true;
            }
        }
        if (update) {
            this.version += parent.version;
            this.cacheKey = (0, $97d1d441621670a9$export$d6af199866bfb566)(parent.cacheKey, this.localClippingCount, this.localClipIntersection === true ? 1 : 0);
        }
    }
}
var $40f294098437e551$export$2e2bcd8739ae039 = $40f294098437e551$var$ClippingContext;


let $0e896fa2347e2bd2$var$_id = 0;
function $0e896fa2347e2bd2$var$getKeys(obj) {
    const keys = Object.keys(obj);
    let proto = Object.getPrototypeOf(obj);
    while(proto){
        const descriptors = Object.getOwnPropertyDescriptors(proto);
        for(const key in descriptors)if (descriptors[key] !== undefined) {
            const descriptor = descriptors[key];
            if (descriptor && typeof descriptor.get === 'function') keys.push(key);
        }
        proto = Object.getPrototypeOf(proto);
    }
    return keys;
}
class $0e896fa2347e2bd2$export$2e2bcd8739ae039 {
    constructor(nodes, geometries, renderer, object, material, scene, camera, lightsNode, renderContext){
        this._nodes = nodes;
        this._geometries = geometries;
        this.id = $0e896fa2347e2bd2$var$_id++;
        this.renderer = renderer;
        this.object = object;
        this.material = material;
        this.scene = scene;
        this.camera = camera;
        this.lightsNode = lightsNode;
        this.context = renderContext;
        this.geometry = object.geometry;
        this.version = material.version;
        this.drawRange = null;
        this.attributes = null;
        this.pipeline = null;
        this.vertexBuffers = null;
        this.drawParams = null;
        this.bundle = null;
        this.updateClipping(renderContext.clippingContext);
        this.clippingContextVersion = this.clippingContext.version;
        this.initialNodesCacheKey = this.getDynamicCacheKey();
        this.initialCacheKey = this.getCacheKey();
        this._nodeBuilderState = null;
        this._bindings = null;
        this._monitor = null;
        this.onDispose = null;
        this.isRenderObject = true;
        this.onMaterialDispose = ()=>{
            this.dispose();
        };
        this.material.addEventListener('dispose', this.onMaterialDispose);
    }
    updateClipping(parent) {
        const material = this.material;
        let clippingContext = this.clippingContext;
        if (Array.isArray(material.clippingPlanes)) {
            if (clippingContext === parent || !clippingContext) {
                clippingContext = new (0, $40f294098437e551$export$2e2bcd8739ae039)();
                this.clippingContext = clippingContext;
            }
            clippingContext.update(parent, material);
        } else if (this.clippingContext !== parent) this.clippingContext = parent;
    }
    get clippingNeedsUpdate() {
        if (this.clippingContext.version === this.clippingContextVersion) return false;
        this.clippingContextVersion = this.clippingContext.version;
        return true;
    }
    getNodeBuilderState() {
        return this._nodeBuilderState || (this._nodeBuilderState = this._nodes.getForRender(this));
    }
    getMonitor() {
        return this._monitor || (this._monitor = this.getNodeBuilderState().monitor);
    }
    getBindings() {
        return this._bindings || (this._bindings = this.getNodeBuilderState().createBindings());
    }
    getIndex() {
        return this._geometries.getIndex(this);
    }
    getIndirect() {
        return this._geometries.getIndirect(this);
    }
    getChainArray() {
        return [
            this.object,
            this.material,
            this.context,
            this.lightsNode
        ];
    }
    getAttributes() {
        if (this.attributes !== null) return this.attributes;
        const nodeAttributes = this.getNodeBuilderState().nodeAttributes;
        const geometry = this.geometry;
        const attributes = [];
        const vertexBuffers = new Set();
        for (const nodeAttribute of nodeAttributes){
            const attribute = nodeAttribute.node && nodeAttribute.node.attribute ? nodeAttribute.node.attribute : geometry.getAttribute(nodeAttribute.name);
            if (attribute === undefined) continue;
            attributes.push(attribute);
            const bufferAttribute = attribute.isInterleavedBufferAttribute ? attribute.data : attribute;
            vertexBuffers.add(bufferAttribute);
        }
        this.attributes = attributes;
        this.vertexBuffers = Array.from(vertexBuffers.values());
        return attributes;
    }
    getVertexBuffers() {
        if (this.vertexBuffers === null) this.getAttributes();
        return this.vertexBuffers;
    }
    getDrawParameters() {
        const { object: object, material: material, geometry: geometry, group: group, drawRange: drawRange } = this;
        const drawParams = this.drawParams || (this.drawParams = {
            vertexCount: 0,
            firstVertex: 0,
            instanceCount: 0,
            firstInstance: 0
        });
        const index = this.getIndex();
        const hasIndex = index !== null;
        const instanceCount = geometry.isInstancedBufferGeometry ? geometry.instanceCount : object.count > 1 ? object.count : 1;
        if (instanceCount === 0) return null;
        drawParams.instanceCount = instanceCount;
        if (object.isBatchedMesh === true) return drawParams;
        let rangeFactor = 1;
        if (material.wireframe === true && !object.isPoints && !object.isLineSegments && !object.isLine && !object.isLineLoop) rangeFactor = 2;
        let firstVertex = drawRange.start * rangeFactor;
        let lastVertex = (drawRange.start + drawRange.count) * rangeFactor;
        if (group !== null) {
            firstVertex = Math.max(firstVertex, group.start * rangeFactor);
            lastVertex = Math.min(lastVertex, (group.start + group.count) * rangeFactor);
        }
        const position = geometry.attributes.position;
        let itemCount = Infinity;
        if (hasIndex) itemCount = index.count;
        else if (position !== undefined && position !== null) itemCount = position.count;
        firstVertex = Math.max(firstVertex, 0);
        lastVertex = Math.min(lastVertex, itemCount);
        const count = lastVertex - firstVertex;
        if (count < 0 || count === Infinity) return null;
        drawParams.vertexCount = count;
        drawParams.firstVertex = firstVertex;
        return drawParams;
    }
    getGeometryCacheKey() {
        const { geometry: geometry } = this;
        let cacheKey = '';
        for (const name of Object.keys(geometry.attributes).sort()){
            const attribute = geometry.attributes[name];
            cacheKey += name + ',';
            if (attribute.data) cacheKey += attribute.data.stride + ',';
            if (attribute.offset) cacheKey += attribute.offset + ',';
            if (attribute.itemSize) cacheKey += attribute.itemSize + ',';
            if (attribute.normalized) cacheKey += 'n,';
        }
        if (geometry.index) cacheKey += 'index,';
        return cacheKey;
    }
    getMaterialCacheKey() {
        const { object: object, material: material } = this;
        let cacheKey = material.customProgramCacheKey();
        for (const property of $0e896fa2347e2bd2$var$getKeys(material)){
            if (/^(is[A-Z]|_)|^(visible|version|uuid|name|opacity|userData)$/.test(property)) continue;
            const value = material[property];
            let valueKey;
            if (value !== null) {
                // some material values require a formatting
                const type = typeof value;
                if (type === 'number') valueKey = value !== 0 ? '1' : '0'; // Convert to on/off, important for clearcoat, transmission, etc
                else if (type === 'object') {
                    valueKey = '{';
                    if (value.isTexture) valueKey += value.mapping;
                    valueKey += '}';
                } else valueKey = String(value);
            } else valueKey = String(value);
            cacheKey += /*property + ':' +*/ valueKey + ',';
        }
        cacheKey += this.clippingContext.cacheKey + ',';
        if (object.geometry) cacheKey += this.getGeometryCacheKey();
        if (object.skeleton) cacheKey += object.skeleton.bones.length + ',';
        if (object.morphTargetInfluences) cacheKey += object.morphTargetInfluences.length + ',';
        if (object.isBatchedMesh) {
            cacheKey += object._matricesTexture.uuid + ',';
            if (object._colorsTexture !== null) cacheKey += object._colorsTexture.uuid + ',';
        }
        if (object.count > 1) // TODO: https://github.com/mrdoob/three.js/pull/29066#issuecomment-2269400850
        cacheKey += object.uuid + ',';
        return (0, $97d1d441621670a9$export$9169be2e06c9c165)(cacheKey);
    }
    get needsUpdate() {
        return /*this.object.static !== true &&*/ this.initialNodesCacheKey !== this.getDynamicCacheKey() || this.clippingNeedsUpdate;
    }
    getDynamicCacheKey() {
        // Environment Nodes Cache Key
        let cacheKey = this._nodes.getCacheKey(this.scene, this.lightsNode);
        if (this.object.receiveShadow) cacheKey += 1;
        return cacheKey;
    }
    getCacheKey() {
        return this.getMaterialCacheKey() + this.getDynamicCacheKey();
    }
    dispose() {
        this.material.removeEventListener('dispose', this.onMaterialDispose);
        this.onDispose();
    }
}


const $b622fa0cbb1f0984$var$chainArray = [];
class $b622fa0cbb1f0984$var$RenderObjects {
    constructor(renderer, nodes, geometries, pipelines, bindings, info){
        this.renderer = renderer;
        this.nodes = nodes;
        this.geometries = geometries;
        this.pipelines = pipelines;
        this.bindings = bindings;
        this.info = info;
        this.chainMaps = {};
    }
    get(object, material, scene, camera, lightsNode, renderContext, passId) {
        const chainMap = this.getChainMap(passId);
        // reuse chainArray
        $b622fa0cbb1f0984$var$chainArray[0] = object;
        $b622fa0cbb1f0984$var$chainArray[1] = material;
        $b622fa0cbb1f0984$var$chainArray[2] = renderContext;
        $b622fa0cbb1f0984$var$chainArray[3] = lightsNode;
        let renderObject = chainMap.get($b622fa0cbb1f0984$var$chainArray);
        if (renderObject === undefined) {
            renderObject = this.createRenderObject(this.nodes, this.geometries, this.renderer, object, material, scene, camera, lightsNode, renderContext, passId);
            chainMap.set($b622fa0cbb1f0984$var$chainArray, renderObject);
        } else {
            renderObject.updateClipping(renderContext.clippingContext);
            if (renderObject.version !== material.version || renderObject.needsUpdate) {
                if (renderObject.initialCacheKey !== renderObject.getCacheKey()) {
                    renderObject.dispose();
                    renderObject = this.get(object, material, scene, camera, lightsNode, renderContext, passId);
                } else renderObject.version = material.version;
            }
        }
        return renderObject;
    }
    getChainMap(passId = 'default') {
        return this.chainMaps[passId] || (this.chainMaps[passId] = new (0, $aa043456f1edde49$export$2e2bcd8739ae039)());
    }
    dispose() {
        this.chainMaps = {};
    }
    createRenderObject(nodes, geometries, renderer, object, material, scene, camera, lightsNode, renderContext, passId) {
        const chainMap = this.getChainMap(passId);
        const renderObject = new (0, $0e896fa2347e2bd2$export$2e2bcd8739ae039)(nodes, geometries, renderer, object, material, scene, camera, lightsNode, renderContext);
        renderObject.onDispose = ()=>{
            this.pipelines.delete(renderObject);
            this.bindings.delete(renderObject);
            this.nodes.delete(renderObject);
            chainMap.delete(renderObject.getChainArray());
        };
        return renderObject;
    }
}
var $b622fa0cbb1f0984$export$2e2bcd8739ae039 = $b622fa0cbb1f0984$var$RenderObjects;


class $0c532ab002169243$var$DataMap {
    constructor(){
        this.data = new WeakMap();
    }
    get(object) {
        let map = this.data.get(object);
        if (map === undefined) {
            map = {};
            this.data.set(object, map);
        }
        return map;
    }
    delete(object) {
        let map;
        if (this.data.has(object)) {
            map = this.data.get(object);
            this.data.delete(object);
        }
        return map;
    }
    has(object) {
        return this.data.has(object);
    }
    dispose() {
        this.data = new WeakMap();
    }
}
var $0c532ab002169243$export$2e2bcd8739ae039 = $0c532ab002169243$var$DataMap;


const $a4815dd317c56025$export$d31c6c64cddbeeac = {
    VERTEX: 1,
    INDEX: 2,
    STORAGE: 3,
    INDIRECT: 4
};
const $a4815dd317c56025$export$a9b1b2f99a40d5cb = 16;
const $a4815dd317c56025$export$b24bddea98f32f06 = 211;
const $a4815dd317c56025$export$25436ebdca80e835 = 212;



class $8afb6b311161e34f$var$Attributes extends (0, $0c532ab002169243$export$2e2bcd8739ae039) {
    constructor(backend){
        super();
        this.backend = backend;
    }
    delete(attribute) {
        const attributeData = super.delete(attribute);
        if (attributeData !== undefined) this.backend.destroyAttribute(attribute);
        return attributeData;
    }
    update(attribute, type) {
        const data = this.get(attribute);
        if (data.version === undefined) {
            if (type === (0, $a4815dd317c56025$export$d31c6c64cddbeeac).VERTEX) this.backend.createAttribute(attribute);
            else if (type === (0, $a4815dd317c56025$export$d31c6c64cddbeeac).INDEX) this.backend.createIndexAttribute(attribute);
            else if (type === (0, $a4815dd317c56025$export$d31c6c64cddbeeac).STORAGE) this.backend.createStorageAttribute(attribute);
            else if (type === (0, $a4815dd317c56025$export$d31c6c64cddbeeac).INDIRECT) this.backend.createIndirectStorageAttribute(attribute);
            data.version = this._getBufferAttribute(attribute).version;
        } else {
            const bufferAttribute = this._getBufferAttribute(attribute);
            if (data.version < bufferAttribute.version || bufferAttribute.usage === (0, $cb5ee595c0f892af$export$8505d14ac8546ca)) {
                this.backend.updateAttribute(attribute);
                data.version = bufferAttribute.version;
            }
        }
    }
    _getBufferAttribute(attribute) {
        if (attribute.isInterleavedBufferAttribute) attribute = attribute.data;
        return attribute;
    }
}
var $8afb6b311161e34f$export$2e2bcd8739ae039 = $8afb6b311161e34f$var$Attributes;









// Fast Half Float Conversions, http://www.fox-toolkit.org/ftp/fasthalffloatconversion.pdf
const $501e9a97687e947e$var$_tables = /*@__PURE__*/ $501e9a97687e947e$var$_generateTables();
function $501e9a97687e947e$var$_generateTables() {
    // float32 to float16 helpers
    const buffer = new ArrayBuffer(4);
    const floatView = new Float32Array(buffer);
    const uint32View = new Uint32Array(buffer);
    const baseTable = new Uint32Array(512);
    const shiftTable = new Uint32Array(512);
    for(let i = 0; i < 256; ++i){
        const e = i - 127;
        // very small number (0, -0)
        if (e < -27) {
            baseTable[i] = 0x0000;
            baseTable[i | 0x100] = 0x8000;
            shiftTable[i] = 24;
            shiftTable[i | 0x100] = 24;
        // small number (denorm)
        } else if (e < -14) {
            baseTable[i] = 0x0400 >> -e - 14;
            baseTable[i | 0x100] = 0x0400 >> -e - 14 | 0x8000;
            shiftTable[i] = -e - 1;
            shiftTable[i | 0x100] = -e - 1;
        // normal number
        } else if (e <= 15) {
            baseTable[i] = e + 15 << 10;
            baseTable[i | 0x100] = e + 15 << 10 | 0x8000;
            shiftTable[i] = 13;
            shiftTable[i | 0x100] = 13;
        // large number (Infinity, -Infinity)
        } else if (e < 128) {
            baseTable[i] = 0x7c00;
            baseTable[i | 0x100] = 0xfc00;
            shiftTable[i] = 24;
            shiftTable[i | 0x100] = 24;
        // stay (NaN, Infinity, -Infinity)
        } else {
            baseTable[i] = 0x7c00;
            baseTable[i | 0x100] = 0xfc00;
            shiftTable[i] = 13;
            shiftTable[i | 0x100] = 13;
        }
    }
    // float16 to float32 helpers
    const mantissaTable = new Uint32Array(2048);
    const exponentTable = new Uint32Array(64);
    const offsetTable = new Uint32Array(64);
    for(let i = 1; i < 1024; ++i){
        let m = i << 13; // zero pad mantissa bits
        let e = 0; // zero exponent
        // normalized
        while((m & 0x00800000) === 0){
            m <<= 1;
            e -= 0x00800000; // decrement exponent
        }
        m &= -8388609; // clear leading 1 bit
        e += 0x38800000; // adjust bias
        mantissaTable[i] = m | e;
    }
    for(let i = 1024; i < 2048; ++i)mantissaTable[i] = 0x38000000 + (i - 1024 << 13);
    for(let i = 1; i < 31; ++i)exponentTable[i] = i << 23;
    exponentTable[31] = 0x47800000;
    exponentTable[32] = 0x80000000;
    for(let i = 33; i < 63; ++i)exponentTable[i] = 0x80000000 + (i - 32 << 23);
    exponentTable[63] = 0xc7800000;
    for(let i = 1; i < 64; ++i)if (i !== 32) offsetTable[i] = 1024;
    return {
        floatView: floatView,
        uint32View: uint32View,
        baseTable: baseTable,
        shiftTable: shiftTable,
        mantissaTable: mantissaTable,
        exponentTable: exponentTable,
        offsetTable: offsetTable
    };
}
// float32 to float16
function $501e9a97687e947e$export$b22a59873b87dca4(val) {
    if (Math.abs(val) > 65504) console.warn('THREE.DataUtils.toHalfFloat(): Value out of range.');
    val = (0, $7f727a3c7059d20d$export$7d15b64cf5a3a4c4)(val, -65504, 65504);
    $501e9a97687e947e$var$_tables.floatView[0] = val;
    const f = $501e9a97687e947e$var$_tables.uint32View[0];
    const e = f >> 23 & 0x1ff;
    return $501e9a97687e947e$var$_tables.baseTable[e] + ((f & 0x007fffff) >> $501e9a97687e947e$var$_tables.shiftTable[e]);
}
// float16 to float32
function $501e9a97687e947e$export$7ad35904d8bf1610(val) {
    const m = val >> 10;
    $501e9a97687e947e$var$_tables.uint32View[0] = $501e9a97687e947e$var$_tables.mantissaTable[$501e9a97687e947e$var$_tables.offsetTable[m] + (val & 0x3ff)] + $501e9a97687e947e$var$_tables.exponentTable[m];
    return $501e9a97687e947e$var$_tables.floatView[0];
}
const $501e9a97687e947e$export$11ce8b759162cc80 = {
    toHalfFloat: $501e9a97687e947e$export$b22a59873b87dca4,
    fromHalfFloat: $501e9a97687e947e$export$7ad35904d8bf1610
};


const $4b03383e684869fb$var$_vector = /*@__PURE__*/ new (0, $d7d0ac0e47013885$export$64b5c384219d3699)();
const $4b03383e684869fb$var$_vector2 = /*@__PURE__*/ new (0, $3c03061dea0adea3$export$c977b3e384af9ae1)();
class $4b03383e684869fb$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized = false){
        if (Array.isArray(array)) throw new TypeError('THREE.BufferAttribute: array should be a Typed Array.');
        this.isBufferAttribute = true;
        this.name = '';
        this.array = array;
        this.itemSize = itemSize;
        this.count = array !== undefined ? array.length / itemSize : 0;
        this.normalized = normalized;
        this.usage = (0, $cb5ee595c0f892af$export$763e8360f4d7f77d);
        this.updateRanges = [];
        this.gpuType = (0, $cb5ee595c0f892af$export$f6d331659b644596);
        this.version = 0;
    }
    onUploadCallback() {}
    set needsUpdate(value) {
        if (value === true) this.version++;
    }
    setUsage(value) {
        this.usage = value;
        return this;
    }
    addUpdateRange(start, count) {
        this.updateRanges.push({
            start: start,
            count: count
        });
    }
    clearUpdateRanges() {
        this.updateRanges.length = 0;
    }
    copy(source) {
        this.name = source.name;
        this.array = new source.array.constructor(source.array);
        this.itemSize = source.itemSize;
        this.count = source.count;
        this.normalized = source.normalized;
        this.usage = source.usage;
        this.gpuType = source.gpuType;
        return this;
    }
    copyAt(index1, attribute, index2) {
        index1 *= this.itemSize;
        index2 *= attribute.itemSize;
        for(let i = 0, l = this.itemSize; i < l; i++)this.array[index1 + i] = attribute.array[index2 + i];
        return this;
    }
    copyArray(array) {
        this.array.set(array);
        return this;
    }
    applyMatrix3(m) {
        if (this.itemSize === 2) for(let i = 0, l = this.count; i < l; i++){
            $4b03383e684869fb$var$_vector2.fromBufferAttribute(this, i);
            $4b03383e684869fb$var$_vector2.applyMatrix3(m);
            this.setXY(i, $4b03383e684869fb$var$_vector2.x, $4b03383e684869fb$var$_vector2.y);
        }
        else if (this.itemSize === 3) for(let i = 0, l = this.count; i < l; i++){
            $4b03383e684869fb$var$_vector.fromBufferAttribute(this, i);
            $4b03383e684869fb$var$_vector.applyMatrix3(m);
            this.setXYZ(i, $4b03383e684869fb$var$_vector.x, $4b03383e684869fb$var$_vector.y, $4b03383e684869fb$var$_vector.z);
        }
        return this;
    }
    applyMatrix4(m) {
        for(let i = 0, l = this.count; i < l; i++){
            $4b03383e684869fb$var$_vector.fromBufferAttribute(this, i);
            $4b03383e684869fb$var$_vector.applyMatrix4(m);
            this.setXYZ(i, $4b03383e684869fb$var$_vector.x, $4b03383e684869fb$var$_vector.y, $4b03383e684869fb$var$_vector.z);
        }
        return this;
    }
    applyNormalMatrix(m) {
        for(let i = 0, l = this.count; i < l; i++){
            $4b03383e684869fb$var$_vector.fromBufferAttribute(this, i);
            $4b03383e684869fb$var$_vector.applyNormalMatrix(m);
            this.setXYZ(i, $4b03383e684869fb$var$_vector.x, $4b03383e684869fb$var$_vector.y, $4b03383e684869fb$var$_vector.z);
        }
        return this;
    }
    transformDirection(m) {
        for(let i = 0, l = this.count; i < l; i++){
            $4b03383e684869fb$var$_vector.fromBufferAttribute(this, i);
            $4b03383e684869fb$var$_vector.transformDirection(m);
            this.setXYZ(i, $4b03383e684869fb$var$_vector.x, $4b03383e684869fb$var$_vector.y, $4b03383e684869fb$var$_vector.z);
        }
        return this;
    }
    set(value, offset = 0) {
        // Matching BufferAttribute constructor, do not normalize the array.
        this.array.set(value, offset);
        return this;
    }
    getComponent(index, component) {
        let value = this.array[index * this.itemSize + component];
        if (this.normalized) value = (0, $7f727a3c7059d20d$export$be8b9fcbce8e8f70)(value, this.array);
        return value;
    }
    setComponent(index, component, value) {
        if (this.normalized) value = (0, $7f727a3c7059d20d$export$a3295358bff77e)(value, this.array);
        this.array[index * this.itemSize + component] = value;
        return this;
    }
    getX(index) {
        let x = this.array[index * this.itemSize];
        if (this.normalized) x = (0, $7f727a3c7059d20d$export$be8b9fcbce8e8f70)(x, this.array);
        return x;
    }
    setX(index, x) {
        if (this.normalized) x = (0, $7f727a3c7059d20d$export$a3295358bff77e)(x, this.array);
        this.array[index * this.itemSize] = x;
        return this;
    }
    getY(index) {
        let y = this.array[index * this.itemSize + 1];
        if (this.normalized) y = (0, $7f727a3c7059d20d$export$be8b9fcbce8e8f70)(y, this.array);
        return y;
    }
    setY(index, y) {
        if (this.normalized) y = (0, $7f727a3c7059d20d$export$a3295358bff77e)(y, this.array);
        this.array[index * this.itemSize + 1] = y;
        return this;
    }
    getZ(index) {
        let z = this.array[index * this.itemSize + 2];
        if (this.normalized) z = (0, $7f727a3c7059d20d$export$be8b9fcbce8e8f70)(z, this.array);
        return z;
    }
    setZ(index, z) {
        if (this.normalized) z = (0, $7f727a3c7059d20d$export$a3295358bff77e)(z, this.array);
        this.array[index * this.itemSize + 2] = z;
        return this;
    }
    getW(index) {
        let w = this.array[index * this.itemSize + 3];
        if (this.normalized) w = (0, $7f727a3c7059d20d$export$be8b9fcbce8e8f70)(w, this.array);
        return w;
    }
    setW(index, w) {
        if (this.normalized) w = (0, $7f727a3c7059d20d$export$a3295358bff77e)(w, this.array);
        this.array[index * this.itemSize + 3] = w;
        return this;
    }
    setXY(index, x, y) {
        index *= this.itemSize;
        if (this.normalized) {
            x = (0, $7f727a3c7059d20d$export$a3295358bff77e)(x, this.array);
            y = (0, $7f727a3c7059d20d$export$a3295358bff77e)(y, this.array);
        }
        this.array[index + 0] = x;
        this.array[index + 1] = y;
        return this;
    }
    setXYZ(index, x, y, z) {
        index *= this.itemSize;
        if (this.normalized) {
            x = (0, $7f727a3c7059d20d$export$a3295358bff77e)(x, this.array);
            y = (0, $7f727a3c7059d20d$export$a3295358bff77e)(y, this.array);
            z = (0, $7f727a3c7059d20d$export$a3295358bff77e)(z, this.array);
        }
        this.array[index + 0] = x;
        this.array[index + 1] = y;
        this.array[index + 2] = z;
        return this;
    }
    setXYZW(index, x, y, z, w) {
        index *= this.itemSize;
        if (this.normalized) {
            x = (0, $7f727a3c7059d20d$export$a3295358bff77e)(x, this.array);
            y = (0, $7f727a3c7059d20d$export$a3295358bff77e)(y, this.array);
            z = (0, $7f727a3c7059d20d$export$a3295358bff77e)(z, this.array);
            w = (0, $7f727a3c7059d20d$export$a3295358bff77e)(w, this.array);
        }
        this.array[index + 0] = x;
        this.array[index + 1] = y;
        this.array[index + 2] = z;
        this.array[index + 3] = w;
        return this;
    }
    onUpload(callback) {
        this.onUploadCallback = callback;
        return this;
    }
    clone() {
        return new this.constructor(this.array, this.itemSize).copy(this);
    }
    toJSON() {
        const data = {
            itemSize: this.itemSize,
            type: this.array.constructor.name,
            array: Array.from(this.array),
            normalized: this.normalized
        };
        if (this.name !== '') data.name = this.name;
        if (this.usage !== (0, $cb5ee595c0f892af$export$763e8360f4d7f77d)) data.usage = this.usage;
        return data;
    }
}
//
class $4b03383e684869fb$export$f9ff2d6a20248cbf extends $4b03383e684869fb$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Int8Array(array), itemSize, normalized);
    }
}
class $4b03383e684869fb$export$cacc90cf35d11cdd extends $4b03383e684869fb$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Uint8Array(array), itemSize, normalized);
    }
}
class $4b03383e684869fb$export$baaa85a1a812c157 extends $4b03383e684869fb$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Uint8ClampedArray(array), itemSize, normalized);
    }
}
class $4b03383e684869fb$export$2b755a102ccdcefe extends $4b03383e684869fb$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Int16Array(array), itemSize, normalized);
    }
}
class $4b03383e684869fb$export$640a853f68025f2e extends $4b03383e684869fb$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Uint16Array(array), itemSize, normalized);
    }
}
class $4b03383e684869fb$export$46b369aed2968a0a extends $4b03383e684869fb$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Int32Array(array), itemSize, normalized);
    }
}
class $4b03383e684869fb$export$7eb8c9fa25cd5bd6 extends $4b03383e684869fb$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Uint32Array(array), itemSize, normalized);
    }
}
class $4b03383e684869fb$export$dbd3698c64958d69 extends $4b03383e684869fb$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Uint16Array(array), itemSize, normalized);
        this.isFloat16BufferAttribute = true;
    }
    getX(index) {
        let x = (0, $501e9a97687e947e$export$7ad35904d8bf1610)(this.array[index * this.itemSize]);
        if (this.normalized) x = (0, $7f727a3c7059d20d$export$be8b9fcbce8e8f70)(x, this.array);
        return x;
    }
    setX(index, x) {
        if (this.normalized) x = (0, $7f727a3c7059d20d$export$a3295358bff77e)(x, this.array);
        this.array[index * this.itemSize] = (0, $501e9a97687e947e$export$b22a59873b87dca4)(x);
        return this;
    }
    getY(index) {
        let y = (0, $501e9a97687e947e$export$7ad35904d8bf1610)(this.array[index * this.itemSize + 1]);
        if (this.normalized) y = (0, $7f727a3c7059d20d$export$be8b9fcbce8e8f70)(y, this.array);
        return y;
    }
    setY(index, y) {
        if (this.normalized) y = (0, $7f727a3c7059d20d$export$a3295358bff77e)(y, this.array);
        this.array[index * this.itemSize + 1] = (0, $501e9a97687e947e$export$b22a59873b87dca4)(y);
        return this;
    }
    getZ(index) {
        let z = (0, $501e9a97687e947e$export$7ad35904d8bf1610)(this.array[index * this.itemSize + 2]);
        if (this.normalized) z = (0, $7f727a3c7059d20d$export$be8b9fcbce8e8f70)(z, this.array);
        return z;
    }
    setZ(index, z) {
        if (this.normalized) z = (0, $7f727a3c7059d20d$export$a3295358bff77e)(z, this.array);
        this.array[index * this.itemSize + 2] = (0, $501e9a97687e947e$export$b22a59873b87dca4)(z);
        return this;
    }
    getW(index) {
        let w = (0, $501e9a97687e947e$export$7ad35904d8bf1610)(this.array[index * this.itemSize + 3]);
        if (this.normalized) w = (0, $7f727a3c7059d20d$export$be8b9fcbce8e8f70)(w, this.array);
        return w;
    }
    setW(index, w) {
        if (this.normalized) w = (0, $7f727a3c7059d20d$export$a3295358bff77e)(w, this.array);
        this.array[index * this.itemSize + 3] = (0, $501e9a97687e947e$export$b22a59873b87dca4)(w);
        return this;
    }
    setXY(index, x, y) {
        index *= this.itemSize;
        if (this.normalized) {
            x = (0, $7f727a3c7059d20d$export$a3295358bff77e)(x, this.array);
            y = (0, $7f727a3c7059d20d$export$a3295358bff77e)(y, this.array);
        }
        this.array[index + 0] = (0, $501e9a97687e947e$export$b22a59873b87dca4)(x);
        this.array[index + 1] = (0, $501e9a97687e947e$export$b22a59873b87dca4)(y);
        return this;
    }
    setXYZ(index, x, y, z) {
        index *= this.itemSize;
        if (this.normalized) {
            x = (0, $7f727a3c7059d20d$export$a3295358bff77e)(x, this.array);
            y = (0, $7f727a3c7059d20d$export$a3295358bff77e)(y, this.array);
            z = (0, $7f727a3c7059d20d$export$a3295358bff77e)(z, this.array);
        }
        this.array[index + 0] = (0, $501e9a97687e947e$export$b22a59873b87dca4)(x);
        this.array[index + 1] = (0, $501e9a97687e947e$export$b22a59873b87dca4)(y);
        this.array[index + 2] = (0, $501e9a97687e947e$export$b22a59873b87dca4)(z);
        return this;
    }
    setXYZW(index, x, y, z, w) {
        index *= this.itemSize;
        if (this.normalized) {
            x = (0, $7f727a3c7059d20d$export$a3295358bff77e)(x, this.array);
            y = (0, $7f727a3c7059d20d$export$a3295358bff77e)(y, this.array);
            z = (0, $7f727a3c7059d20d$export$a3295358bff77e)(z, this.array);
            w = (0, $7f727a3c7059d20d$export$a3295358bff77e)(w, this.array);
        }
        this.array[index + 0] = (0, $501e9a97687e947e$export$b22a59873b87dca4)(x);
        this.array[index + 1] = (0, $501e9a97687e947e$export$b22a59873b87dca4)(y);
        this.array[index + 2] = (0, $501e9a97687e947e$export$b22a59873b87dca4)(z);
        this.array[index + 3] = (0, $501e9a97687e947e$export$b22a59873b87dca4)(w);
        return this;
    }
}
class $4b03383e684869fb$export$cbe7a62641830ebd extends $4b03383e684869fb$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Float32Array(array), itemSize, normalized);
    }
}


function $3f2309e40aadd165$var$arrayNeedsUint32(array) {
    // assumes larger values usually on last
    for(let i = array.length - 1; i >= 0; --i){
        if (array[i] >= 65535) return true; // account for PRIMITIVE_RESTART_FIXED_INDEX, #24565
    }
    return false;
}
function $3f2309e40aadd165$var$getWireframeVersion(geometry) {
    return geometry.index !== null ? geometry.index.version : geometry.attributes.position.version;
}
function $3f2309e40aadd165$var$getWireframeIndex(geometry) {
    const indices = [];
    const geometryIndex = geometry.index;
    const geometryPosition = geometry.attributes.position;
    if (geometryIndex !== null) {
        const array = geometryIndex.array;
        for(let i = 0, l = array.length; i < l; i += 3){
            const a = array[i + 0];
            const b = array[i + 1];
            const c = array[i + 2];
            indices.push(a, b, b, c, c, a);
        }
    } else {
        const array = geometryPosition.array;
        for(let i = 0, l = array.length / 3 - 1; i < l; i += 3){
            const a = i + 0;
            const b = i + 1;
            const c = i + 2;
            indices.push(a, b, b, c, c, a);
        }
    }
    const attribute = new ($3f2309e40aadd165$var$arrayNeedsUint32(indices) ? (0, $4b03383e684869fb$export$7eb8c9fa25cd5bd6) : (0, $4b03383e684869fb$export$640a853f68025f2e))(indices, 1);
    attribute.version = $3f2309e40aadd165$var$getWireframeVersion(geometry);
    return attribute;
}
class $3f2309e40aadd165$var$Geometries extends (0, $0c532ab002169243$export$2e2bcd8739ae039) {
    constructor(attributes, info){
        super();
        this.attributes = attributes;
        this.info = info;
        this.wireframes = new WeakMap();
        this.attributeCall = new WeakMap();
    }
    has(renderObject) {
        const geometry = renderObject.geometry;
        return super.has(geometry) && this.get(geometry).initialized === true;
    }
    updateForRender(renderObject) {
        if (this.has(renderObject) === false) this.initGeometry(renderObject);
        this.updateAttributes(renderObject);
    }
    initGeometry(renderObject) {
        const geometry = renderObject.geometry;
        const geometryData = this.get(geometry);
        geometryData.initialized = true;
        this.info.memory.geometries++;
        const onDispose = ()=>{
            this.info.memory.geometries--;
            const index = geometry.index;
            const geometryAttributes = renderObject.getAttributes();
            if (index !== null) this.attributes.delete(index);
            for (const geometryAttribute of geometryAttributes)this.attributes.delete(geometryAttribute);
            const wireframeAttribute = this.wireframes.get(geometry);
            if (wireframeAttribute !== undefined) this.attributes.delete(wireframeAttribute);
            geometry.removeEventListener('dispose', onDispose);
        };
        geometry.addEventListener('dispose', onDispose);
    }
    updateAttributes(renderObject) {
        // attributes
        const attributes = renderObject.getAttributes();
        for (const attribute of attributes)if (attribute.isStorageBufferAttribute || attribute.isStorageInstancedBufferAttribute) this.updateAttribute(attribute, (0, $a4815dd317c56025$export$d31c6c64cddbeeac).STORAGE);
        else this.updateAttribute(attribute, (0, $a4815dd317c56025$export$d31c6c64cddbeeac).VERTEX);
        // indexes
        const index = this.getIndex(renderObject);
        if (index !== null) this.updateAttribute(index, (0, $a4815dd317c56025$export$d31c6c64cddbeeac).INDEX);
        // indirect
        const indirect = renderObject.geometry.indirect;
        if (indirect !== null) this.updateAttribute(indirect, (0, $a4815dd317c56025$export$d31c6c64cddbeeac).INDIRECT);
    }
    updateAttribute(attribute, type) {
        const callId = this.info.render.calls;
        if (!attribute.isInterleavedBufferAttribute) {
            if (this.attributeCall.get(attribute) !== callId) {
                this.attributes.update(attribute, type);
                this.attributeCall.set(attribute, callId);
            }
        } else {
            if (this.attributeCall.get(attribute) === undefined) {
                this.attributes.update(attribute, type);
                this.attributeCall.set(attribute, callId);
            } else if (this.attributeCall.get(attribute.data) !== callId) {
                this.attributes.update(attribute, type);
                this.attributeCall.set(attribute.data, callId);
                this.attributeCall.set(attribute, callId);
            }
        }
    }
    getIndirect(renderObject) {
        return renderObject.geometry.indirect;
    }
    getIndex(renderObject) {
        const { geometry: geometry, material: material } = renderObject;
        let index = geometry.index;
        if (material.wireframe === true) {
            const wireframes = this.wireframes;
            let wireframeAttribute = wireframes.get(geometry);
            if (wireframeAttribute === undefined) {
                wireframeAttribute = $3f2309e40aadd165$var$getWireframeIndex(geometry);
                wireframes.set(geometry, wireframeAttribute);
            } else if (wireframeAttribute.version !== $3f2309e40aadd165$var$getWireframeVersion(geometry)) {
                this.attributes.delete(wireframeAttribute);
                wireframeAttribute = $3f2309e40aadd165$var$getWireframeIndex(geometry);
                wireframes.set(geometry, wireframeAttribute);
            }
            index = wireframeAttribute;
        }
        return index;
    }
}
var $3f2309e40aadd165$export$2e2bcd8739ae039 = $3f2309e40aadd165$var$Geometries;


class $676315ee04902050$var$Info {
    constructor(){
        this.autoReset = true;
        this.frame = 0;
        this.calls = 0;
        this.render = {
            calls: 0,
            frameCalls: 0,
            drawCalls: 0,
            triangles: 0,
            points: 0,
            lines: 0,
            timestamp: 0,
            previousFrameCalls: 0,
            timestampCalls: 0
        };
        this.compute = {
            calls: 0,
            frameCalls: 0,
            timestamp: 0,
            previousFrameCalls: 0,
            timestampCalls: 0
        };
        this.memory = {
            geometries: 0,
            textures: 0
        };
    }
    update(object, count, instanceCount) {
        this.render.drawCalls++;
        if (object.isMesh || object.isSprite) this.render.triangles += instanceCount * (count / 3);
        else if (object.isPoints) this.render.points += instanceCount * count;
        else if (object.isLineSegments) this.render.lines += instanceCount * (count / 2);
        else if (object.isLine) this.render.lines += instanceCount * (count - 1);
        else console.error('THREE.WebGPUInfo: Unknown object type.');
    }
    updateTimestamp(type, time) {
        if (this[type].timestampCalls === 0) this[type].timestamp = 0;
        this[type].timestamp += time;
        this[type].timestampCalls++;
        if (this[type].timestampCalls >= this[type].previousFrameCalls) this[type].timestampCalls = 0;
    }
    reset() {
        const previousRenderFrameCalls = this.render.frameCalls;
        this.render.previousFrameCalls = previousRenderFrameCalls;
        const previousComputeFrameCalls = this.compute.frameCalls;
        this.compute.previousFrameCalls = previousComputeFrameCalls;
        this.render.drawCalls = 0;
        this.render.frameCalls = 0;
        this.compute.frameCalls = 0;
        this.render.triangles = 0;
        this.render.points = 0;
        this.render.lines = 0;
    }
    dispose() {
        this.reset();
        this.calls = 0;
        this.render.calls = 0;
        this.compute.calls = 0;
        this.render.timestamp = 0;
        this.compute.timestamp = 0;
        this.memory.geometries = 0;
        this.memory.textures = 0;
    }
}
var $676315ee04902050$export$2e2bcd8739ae039 = $676315ee04902050$var$Info;



class $f128096f50a0b2ea$var$Pipeline {
    constructor(cacheKey){
        this.cacheKey = cacheKey;
        this.usedTimes = 0;
    }
}
var $f128096f50a0b2ea$export$2e2bcd8739ae039 = $f128096f50a0b2ea$var$Pipeline;


class $de56e9f44374eadb$var$RenderPipeline extends (0, $f128096f50a0b2ea$export$2e2bcd8739ae039) {
    constructor(cacheKey, vertexProgram, fragmentProgram){
        super(cacheKey);
        this.vertexProgram = vertexProgram;
        this.fragmentProgram = fragmentProgram;
    }
}
var $de56e9f44374eadb$export$2e2bcd8739ae039 = $de56e9f44374eadb$var$RenderPipeline;



class $c979d09ca658bc15$var$ComputePipeline extends (0, $f128096f50a0b2ea$export$2e2bcd8739ae039) {
    constructor(cacheKey, computeProgram){
        super(cacheKey);
        this.computeProgram = computeProgram;
        this.isComputePipeline = true;
    }
}
var $c979d09ca658bc15$export$2e2bcd8739ae039 = $c979d09ca658bc15$var$ComputePipeline;


let $b7e44de1c3f1f6ce$var$_id = 0;
class $b7e44de1c3f1f6ce$var$ProgrammableStage {
    constructor(code, type, transforms = null, attributes = null){
        this.id = $b7e44de1c3f1f6ce$var$_id++;
        this.code = code;
        this.stage = type;
        this.transforms = transforms;
        this.attributes = attributes;
        this.usedTimes = 0;
    }
}
var $b7e44de1c3f1f6ce$export$2e2bcd8739ae039 = $b7e44de1c3f1f6ce$var$ProgrammableStage;


class $1af5968348535fae$var$Pipelines extends (0, $0c532ab002169243$export$2e2bcd8739ae039) {
    constructor(backend, nodes){
        super();
        this.backend = backend;
        this.nodes = nodes;
        this.bindings = null; // set by the bindings
        this.caches = new Map();
        this.programs = {
            vertex: new Map(),
            fragment: new Map(),
            compute: new Map()
        };
    }
    getForCompute(computeNode, bindings) {
        const { backend: backend } = this;
        const data = this.get(computeNode);
        if (this._needsComputeUpdate(computeNode)) {
            const previousPipeline = data.pipeline;
            if (previousPipeline) {
                previousPipeline.usedTimes--;
                previousPipeline.computeProgram.usedTimes--;
            }
            // get shader
            const nodeBuilderState = this.nodes.getForCompute(computeNode);
            // programmable stage
            let stageCompute = this.programs.compute.get(nodeBuilderState.computeShader);
            if (stageCompute === undefined) {
                if (previousPipeline && previousPipeline.computeProgram.usedTimes === 0) this._releaseProgram(previousPipeline.computeProgram);
                stageCompute = new (0, $b7e44de1c3f1f6ce$export$2e2bcd8739ae039)(nodeBuilderState.computeShader, 'compute', nodeBuilderState.transforms, nodeBuilderState.nodeAttributes);
                this.programs.compute.set(nodeBuilderState.computeShader, stageCompute);
                backend.createProgram(stageCompute);
            }
            // determine compute pipeline
            const cacheKey = this._getComputeCacheKey(computeNode, stageCompute);
            let pipeline = this.caches.get(cacheKey);
            if (pipeline === undefined) {
                if (previousPipeline && previousPipeline.usedTimes === 0) this._releasePipeline(previousPipeline);
                pipeline = this._getComputePipeline(computeNode, stageCompute, cacheKey, bindings);
            }
            // keep track of all used times
            pipeline.usedTimes++;
            stageCompute.usedTimes++;
            //
            data.version = computeNode.version;
            data.pipeline = pipeline;
        }
        return data.pipeline;
    }
    getForRender(renderObject, promises = null) {
        const { backend: backend } = this;
        const data = this.get(renderObject);
        if (this._needsRenderUpdate(renderObject)) {
            const previousPipeline = data.pipeline;
            if (previousPipeline) {
                previousPipeline.usedTimes--;
                previousPipeline.vertexProgram.usedTimes--;
                previousPipeline.fragmentProgram.usedTimes--;
            }
            // get shader
            const nodeBuilderState = renderObject.getNodeBuilderState();
            // programmable stages
            let stageVertex = this.programs.vertex.get(nodeBuilderState.vertexShader);
            if (stageVertex === undefined) {
                if (previousPipeline && previousPipeline.vertexProgram.usedTimes === 0) this._releaseProgram(previousPipeline.vertexProgram);
                stageVertex = new (0, $b7e44de1c3f1f6ce$export$2e2bcd8739ae039)(nodeBuilderState.vertexShader, 'vertex');
                this.programs.vertex.set(nodeBuilderState.vertexShader, stageVertex);
                backend.createProgram(stageVertex);
            }
            let stageFragment = this.programs.fragment.get(nodeBuilderState.fragmentShader);
            if (stageFragment === undefined) {
                if (previousPipeline && previousPipeline.fragmentProgram.usedTimes === 0) this._releaseProgram(previousPipeline.fragmentProgram);
                stageFragment = new (0, $b7e44de1c3f1f6ce$export$2e2bcd8739ae039)(nodeBuilderState.fragmentShader, 'fragment');
                this.programs.fragment.set(nodeBuilderState.fragmentShader, stageFragment);
                backend.createProgram(stageFragment);
            }
            // determine render pipeline
            const cacheKey = this._getRenderCacheKey(renderObject, stageVertex, stageFragment);
            let pipeline = this.caches.get(cacheKey);
            if (pipeline === undefined) {
                if (previousPipeline && previousPipeline.usedTimes === 0) this._releasePipeline(previousPipeline);
                pipeline = this._getRenderPipeline(renderObject, stageVertex, stageFragment, cacheKey, promises);
            } else renderObject.pipeline = pipeline;
            // keep track of all used times
            pipeline.usedTimes++;
            stageVertex.usedTimes++;
            stageFragment.usedTimes++;
            //
            data.pipeline = pipeline;
        }
        return data.pipeline;
    }
    delete(object) {
        const pipeline = this.get(object).pipeline;
        if (pipeline) {
            // pipeline
            pipeline.usedTimes--;
            if (pipeline.usedTimes === 0) this._releasePipeline(pipeline);
            // programs
            if (pipeline.isComputePipeline) {
                pipeline.computeProgram.usedTimes--;
                if (pipeline.computeProgram.usedTimes === 0) this._releaseProgram(pipeline.computeProgram);
            } else {
                pipeline.fragmentProgram.usedTimes--;
                pipeline.vertexProgram.usedTimes--;
                if (pipeline.vertexProgram.usedTimes === 0) this._releaseProgram(pipeline.vertexProgram);
                if (pipeline.fragmentProgram.usedTimes === 0) this._releaseProgram(pipeline.fragmentProgram);
            }
        }
        return super.delete(object);
    }
    dispose() {
        super.dispose();
        this.caches = new Map();
        this.programs = {
            vertex: new Map(),
            fragment: new Map(),
            compute: new Map()
        };
    }
    updateForRender(renderObject) {
        this.getForRender(renderObject);
    }
    _getComputePipeline(computeNode, stageCompute, cacheKey, bindings) {
        // check for existing pipeline
        cacheKey = cacheKey || this._getComputeCacheKey(computeNode, stageCompute);
        let pipeline = this.caches.get(cacheKey);
        if (pipeline === undefined) {
            pipeline = new (0, $c979d09ca658bc15$export$2e2bcd8739ae039)(cacheKey, stageCompute);
            this.caches.set(cacheKey, pipeline);
            this.backend.createComputePipeline(pipeline, bindings);
        }
        return pipeline;
    }
    _getRenderPipeline(renderObject, stageVertex, stageFragment, cacheKey, promises) {
        // check for existing pipeline
        cacheKey = cacheKey || this._getRenderCacheKey(renderObject, stageVertex, stageFragment);
        let pipeline = this.caches.get(cacheKey);
        if (pipeline === undefined) {
            pipeline = new (0, $de56e9f44374eadb$export$2e2bcd8739ae039)(cacheKey, stageVertex, stageFragment);
            this.caches.set(cacheKey, pipeline);
            renderObject.pipeline = pipeline;
            this.backend.createRenderPipeline(renderObject, promises);
        }
        return pipeline;
    }
    _getComputeCacheKey(computeNode, stageCompute) {
        return computeNode.id + ',' + stageCompute.id;
    }
    _getRenderCacheKey(renderObject, stageVertex, stageFragment) {
        return stageVertex.id + ',' + stageFragment.id + ',' + this.backend.getRenderCacheKey(renderObject);
    }
    _releasePipeline(pipeline) {
        this.caches.delete(pipeline.cacheKey);
    }
    _releaseProgram(program) {
        const code = program.code;
        const stage = program.stage;
        this.programs[stage].delete(code);
    }
    _needsComputeUpdate(computeNode) {
        const data = this.get(computeNode);
        return data.pipeline === undefined || data.version !== computeNode.version;
    }
    _needsRenderUpdate(renderObject) {
        const data = this.get(renderObject);
        return data.pipeline === undefined || this.backend.needsRenderUpdate(renderObject);
    }
}
var $1af5968348535fae$export$2e2bcd8739ae039 = $1af5968348535fae$var$Pipelines;




class $110c88866fa266a5$var$Bindings extends (0, $0c532ab002169243$export$2e2bcd8739ae039) {
    constructor(backend, nodes, textures, attributes, pipelines, info){
        super();
        this.backend = backend;
        this.textures = textures;
        this.pipelines = pipelines;
        this.attributes = attributes;
        this.nodes = nodes;
        this.info = info;
        this.pipelines.bindings = this; // assign bindings to pipelines
    }
    getForRender(renderObject) {
        const bindings = renderObject.getBindings();
        for (const bindGroup of bindings){
            const groupData = this.get(bindGroup);
            if (groupData.bindGroup === undefined) {
                // each object defines an array of bindings (ubos, textures, samplers etc.)
                this._init(bindGroup);
                this.backend.createBindings(bindGroup, bindings);
                groupData.bindGroup = bindGroup;
            }
        }
        return bindings;
    }
    getForCompute(computeNode) {
        const bindings = this.nodes.getForCompute(computeNode).bindings;
        for (const bindGroup of bindings){
            const groupData = this.get(bindGroup);
            if (groupData.bindGroup === undefined) {
                this._init(bindGroup);
                this.backend.createBindings(bindGroup, bindings);
                groupData.bindGroup = bindGroup;
            }
        }
        return bindings;
    }
    updateForCompute(computeNode) {
        this._updateBindings(this.getForCompute(computeNode));
    }
    updateForRender(renderObject) {
        this._updateBindings(this.getForRender(renderObject));
    }
    _updateBindings(bindings) {
        for (const bindGroup of bindings)this._update(bindGroup, bindings);
    }
    _init(bindGroup) {
        for (const binding of bindGroup.bindings){
            if (binding.isSampledTexture) this.textures.updateTexture(binding.texture);
            else if (binding.isStorageBuffer) {
                const attribute = binding.attribute;
                const attributeType = attribute.isIndirectStorageBufferAttribute ? (0, $a4815dd317c56025$export$d31c6c64cddbeeac).INDIRECT : (0, $a4815dd317c56025$export$d31c6c64cddbeeac).STORAGE;
                this.attributes.update(attribute, attributeType);
            }
        }
    }
    _update(bindGroup, bindings) {
        const { backend: backend } = this;
        let needsBindingsUpdate = false;
        // iterate over all bindings and check if buffer updates or a new binding group is required
        for (const binding of bindGroup.bindings){
            if (binding.isNodeUniformsGroup) {
                const updated = this.nodes.updateGroup(binding);
                if (!updated) continue;
            }
            if (binding.isUniformBuffer) {
                const updated = binding.update();
                if (updated) backend.updateBinding(binding);
            } else if (binding.isSampler) binding.update();
            else if (binding.isSampledTexture) {
                if (binding.needsBindingsUpdate(this.textures.get(binding.texture).generation)) needsBindingsUpdate = true;
                const updated = binding.update();
                const texture = binding.texture;
                if (updated) this.textures.updateTexture(texture);
                const textureData = backend.get(texture);
                if (backend.isWebGPUBackend === true && textureData.texture === undefined && textureData.externalTexture === undefined) {
                    // TODO: Remove this once we found why updated === false isn't bound to a texture in the WebGPU backend
                    console.error('Bindings._update: binding should be available:', binding, updated, texture, binding.textureNode.value, needsBindingsUpdate);
                    this.textures.updateTexture(texture);
                    needsBindingsUpdate = true;
                }
                if (texture.isStorageTexture === true) {
                    const textureData = this.get(texture);
                    if (binding.store === true) textureData.needsMipmap = true;
                    else if (this.textures.needsMipmaps(texture) && textureData.needsMipmap === true) {
                        this.backend.generateMipmaps(texture);
                        textureData.needsMipmap = false;
                    }
                }
            }
        }
        if (needsBindingsUpdate === true) this.backend.updateBindings(bindGroup, bindings);
    }
}
var $110c88866fa266a5$export$2e2bcd8739ae039 = $110c88866fa266a5$var$Bindings;




function $40879037845d8e22$var$painterSortStable(a, b) {
    if (a.groupOrder !== b.groupOrder) return a.groupOrder - b.groupOrder;
    else if (a.renderOrder !== b.renderOrder) return a.renderOrder - b.renderOrder;
    else if (a.material.id !== b.material.id) return a.material.id - b.material.id;
    else if (a.z !== b.z) return a.z - b.z;
    else return a.id - b.id;
}
function $40879037845d8e22$var$reversePainterSortStable(a, b) {
    if (a.groupOrder !== b.groupOrder) return a.groupOrder - b.groupOrder;
    else if (a.renderOrder !== b.renderOrder) return a.renderOrder - b.renderOrder;
    else if (a.z !== b.z) return b.z - a.z;
    else return a.id - b.id;
}
function $40879037845d8e22$var$needsDoublePass(material) {
    const hasTransmission = material.transmission > 0 || material.transmissionNode;
    return hasTransmission && material.side === (0, $cb5ee595c0f892af$export$3b296b6f144d5b03) && material.forceSinglePass === false;
}
class $40879037845d8e22$var$RenderList {
    constructor(lighting, scene, camera){
        this.renderItems = [];
        this.renderItemsIndex = 0;
        this.opaque = [];
        this.transparentDoublePass = [];
        this.transparent = [];
        this.bundles = [];
        this.lightsNode = lighting.getNode(scene, camera);
        this.lightsArray = [];
        this.scene = scene;
        this.camera = camera;
        this.occlusionQueryCount = 0;
    }
    begin() {
        this.renderItemsIndex = 0;
        this.opaque.length = 0;
        this.transparentDoublePass.length = 0;
        this.transparent.length = 0;
        this.bundles.length = 0;
        this.lightsArray.length = 0;
        this.occlusionQueryCount = 0;
        return this;
    }
    getNextRenderItem(object, geometry, material, groupOrder, z, group) {
        let renderItem = this.renderItems[this.renderItemsIndex];
        if (renderItem === undefined) {
            renderItem = {
                id: object.id,
                object: object,
                geometry: geometry,
                material: material,
                groupOrder: groupOrder,
                renderOrder: object.renderOrder,
                z: z,
                group: group
            };
            this.renderItems[this.renderItemsIndex] = renderItem;
        } else {
            renderItem.id = object.id;
            renderItem.object = object;
            renderItem.geometry = geometry;
            renderItem.material = material;
            renderItem.groupOrder = groupOrder;
            renderItem.renderOrder = object.renderOrder;
            renderItem.z = z;
            renderItem.group = group;
        }
        this.renderItemsIndex++;
        return renderItem;
    }
    push(object, geometry, material, groupOrder, z, group) {
        const renderItem = this.getNextRenderItem(object, geometry, material, groupOrder, z, group);
        if (object.occlusionTest === true) this.occlusionQueryCount++;
        if (material.transparent === true || material.transmission > 0) {
            if ($40879037845d8e22$var$needsDoublePass(material)) this.transparentDoublePass.push(renderItem);
            this.transparent.push(renderItem);
        } else this.opaque.push(renderItem);
    }
    unshift(object, geometry, material, groupOrder, z, group) {
        const renderItem = this.getNextRenderItem(object, geometry, material, groupOrder, z, group);
        if (material.transparent === true || material.transmission > 0) {
            if ($40879037845d8e22$var$needsDoublePass(material)) this.transparentDoublePass.unshift(renderItem);
            this.transparent.unshift(renderItem);
        } else this.opaque.unshift(renderItem);
    }
    pushBundle(group) {
        this.bundles.push(group);
    }
    pushLight(light) {
        this.lightsArray.push(light);
    }
    sort(customOpaqueSort, customTransparentSort) {
        if (this.opaque.length > 1) this.opaque.sort(customOpaqueSort || $40879037845d8e22$var$painterSortStable);
        if (this.transparentDoublePass.length > 1) this.transparentDoublePass.sort(customTransparentSort || $40879037845d8e22$var$reversePainterSortStable);
        if (this.transparent.length > 1) this.transparent.sort(customTransparentSort || $40879037845d8e22$var$reversePainterSortStable);
    }
    finish() {
        // update lights
        this.lightsNode.setLights(this.lightsArray);
        // Clear references from inactive renderItems in the list
        for(let i = this.renderItemsIndex, il = this.renderItems.length; i < il; i++){
            const renderItem = this.renderItems[i];
            if (renderItem.id === null) break;
            renderItem.id = null;
            renderItem.object = null;
            renderItem.geometry = null;
            renderItem.material = null;
            renderItem.groupOrder = null;
            renderItem.renderOrder = null;
            renderItem.z = null;
            renderItem.group = null;
        }
    }
}
var $40879037845d8e22$export$2e2bcd8739ae039 = $40879037845d8e22$var$RenderList;


class $a3d774cf6db34685$var$RenderLists {
    constructor(lighting){
        this.lighting = lighting;
        this.lists = new (0, $aa043456f1edde49$export$2e2bcd8739ae039)();
    }
    get(scene, camera) {
        const lists = this.lists;
        const keys = [
            scene,
            camera
        ];
        let list = lists.get(keys);
        if (list === undefined) {
            list = new (0, $40879037845d8e22$export$2e2bcd8739ae039)(this.lighting, scene, camera);
            lists.set(keys, list);
        }
        return list;
    }
    dispose() {
        this.lists = new (0, $aa043456f1edde49$export$2e2bcd8739ae039)();
    }
}
var $a3d774cf6db34685$export$2e2bcd8739ae039 = $a3d774cf6db34685$var$RenderLists;





let $76a9323b86a840ad$var$id = 0;
class $76a9323b86a840ad$var$RenderContext {
    constructor(){
        this.id = $76a9323b86a840ad$var$id++;
        this.color = true;
        this.clearColor = true;
        this.clearColorValue = {
            r: 0,
            g: 0,
            b: 0,
            a: 1
        };
        this.depth = true;
        this.clearDepth = true;
        this.clearDepthValue = 1;
        this.stencil = false;
        this.clearStencil = true;
        this.clearStencilValue = 1;
        this.viewport = false;
        this.viewportValue = new (0, $a09a15e9a8421204$export$fa7daccca11cdbe3)();
        this.scissor = false;
        this.scissorValue = new (0, $a09a15e9a8421204$export$fa7daccca11cdbe3)();
        this.textures = null;
        this.depthTexture = null;
        this.activeCubeFace = 0;
        this.sampleCount = 1;
        this.width = 0;
        this.height = 0;
        this.isRenderContext = true;
    }
    getCacheKey() {
        return $76a9323b86a840ad$export$611736262b635f8d(this);
    }
}
function $76a9323b86a840ad$export$611736262b635f8d(renderContext) {
    const { textures: textures, activeCubeFace: activeCubeFace } = renderContext;
    const values = [
        activeCubeFace
    ];
    for (const texture of textures)values.push(texture.id);
    return (0, $97d1d441621670a9$export$cf0fb017e44bd6a4)(values);
}
var $76a9323b86a840ad$export$2e2bcd8739ae039 = $76a9323b86a840ad$var$RenderContext;


class $db19df1fb4962a35$var$RenderContexts {
    constructor(){
        this.chainMaps = {};
    }
    get(scene, camera, renderTarget = null) {
        const chainKey = [
            scene,
            camera
        ];
        let attachmentState;
        if (renderTarget === null) attachmentState = 'default';
        else {
            const format = renderTarget.texture.format;
            const count = renderTarget.textures.length;
            attachmentState = `${count}:${format}:${renderTarget.samples}:${renderTarget.depthBuffer}:${renderTarget.stencilBuffer}`;
        }
        const chainMap = this.getChainMap(attachmentState);
        let renderState = chainMap.get(chainKey);
        if (renderState === undefined) {
            renderState = new (0, $76a9323b86a840ad$export$2e2bcd8739ae039)();
            chainMap.set(chainKey, renderState);
        }
        if (renderTarget !== null) renderState.sampleCount = renderTarget.samples === 0 ? 1 : renderTarget.samples;
        return renderState;
    }
    getChainMap(attachmentState) {
        return this.chainMaps[attachmentState] || (this.chainMaps[attachmentState] = new (0, $aa043456f1edde49$export$2e2bcd8739ae039)());
    }
    dispose() {
        this.chainMaps = {};
    }
}
var $db19df1fb4962a35$export$2e2bcd8739ae039 = $db19df1fb4962a35$var$RenderContexts;




/**
 * https://github.com/mrdoob/eventdispatcher.js/
 */ class $a35132d5d9375da3$export$ec8b666c5fe2c75a {
    addEventListener(type, listener) {
        if (this._listeners === undefined) this._listeners = {};
        const listeners = this._listeners;
        if (listeners[type] === undefined) listeners[type] = [];
        if (listeners[type].indexOf(listener) === -1) listeners[type].push(listener);
    }
    hasEventListener(type, listener) {
        if (this._listeners === undefined) return false;
        const listeners = this._listeners;
        return listeners[type] !== undefined && listeners[type].indexOf(listener) !== -1;
    }
    removeEventListener(type, listener) {
        if (this._listeners === undefined) return;
        const listeners = this._listeners;
        const listenerArray = listeners[type];
        if (listenerArray !== undefined) {
            const index = listenerArray.indexOf(listener);
            if (index !== -1) listenerArray.splice(index, 1);
        }
    }
    dispatchEvent(event) {
        if (this._listeners === undefined) return;
        const listeners = this._listeners;
        const listenerArray = listeners[event.type];
        if (listenerArray !== undefined) {
            event.target = this;
            // Make a copy, in case listeners are removed while iterating.
            const array = listenerArray.slice(0);
            for(let i = 0, l = array.length; i < l; i++)array[i].call(this, event);
            event.target = null;
        }
    }
}






function $d93c9776005e33ec$export$680abbf67f1133a6(array) {
    if (array.length === 0) return Infinity;
    let min = array[0];
    for(let i = 1, l = array.length; i < l; ++i)if (array[i] < min) min = array[i];
    return min;
}
function $d93c9776005e33ec$export$f8987e074caf578f(array) {
    if (array.length === 0) return -Infinity;
    let max = array[0];
    for(let i = 1, l = array.length; i < l; ++i)if (array[i] > max) max = array[i];
    return max;
}
function $d93c9776005e33ec$export$bc6f937da07eae17(array) {
    // assumes larger values usually on last
    for(let i = array.length - 1; i >= 0; --i){
        if (array[i] >= 65535) return true; // account for PRIMITIVE_RESTART_FIXED_INDEX, #24565
    }
    return false;
}
const $d93c9776005e33ec$var$TYPED_ARRAYS = {
    Int8Array: Int8Array,
    Uint8Array: Uint8Array,
    Uint8ClampedArray: Uint8ClampedArray,
    Int16Array: Int16Array,
    Uint16Array: Uint16Array,
    Int32Array: Int32Array,
    Uint32Array: Uint32Array,
    Float32Array: Float32Array,
    Float64Array: Float64Array
};
function $d93c9776005e33ec$export$78a52b63c014494d(type, buffer) {
    return new $d93c9776005e33ec$var$TYPED_ARRAYS[type](buffer);
}
function $d93c9776005e33ec$export$7094a064528c7fee(name) {
    return document.createElementNS('http://www.w3.org/1999/xhtml', name);
}
function $d93c9776005e33ec$export$1033a2df66368859() {
    const canvas = $d93c9776005e33ec$export$7094a064528c7fee('canvas');
    canvas.style.display = 'block';
    return canvas;
}
const $d93c9776005e33ec$var$_cache = {};
function $d93c9776005e33ec$export$5b28268982f175ba(message) {
    if (message in $d93c9776005e33ec$var$_cache) return;
    $d93c9776005e33ec$var$_cache[message] = true;
    console.warn(message);
}
function $d93c9776005e33ec$export$d43f91ebeafb2c7(gl, sync, interval) {
    return new Promise(function(resolve, reject) {
        function probe() {
            switch(gl.clientWaitSync(sync, gl.SYNC_FLUSH_COMMANDS_BIT, 0)){
                case gl.WAIT_FAILED:
                    reject();
                    break;
                case gl.TIMEOUT_EXPIRED:
                    setTimeout(probe, interval);
                    break;
                default:
                    resolve();
            }
        }
        setTimeout(probe, interval);
    });
}
function $d93c9776005e33ec$export$5238391f68c729b(projectionMatrix) {
    const m = projectionMatrix.elements;
    // Convert [-1, 1] to [0, 1] projection matrix
    m[2] = 0.5 * m[2] + 0.5 * m[3];
    m[6] = 0.5 * m[6] + 0.5 * m[7];
    m[10] = 0.5 * m[10] + 0.5 * m[11];
    m[14] = 0.5 * m[14] + 0.5 * m[15];
}
function $d93c9776005e33ec$export$f8cf97d08da9bc86(projectionMatrix) {
    const m = projectionMatrix.elements;
    const isPerspectiveMatrix = m[11] === -1;
    // Reverse [0, 1] projection matrix
    if (isPerspectiveMatrix) {
        m[10] = -m[10] - 1;
        m[14] = -m[14];
    } else {
        m[10] = -m[10];
        m[14] = -m[14] + 1;
    }
}



let $3255b9f241bec491$var$_canvas;
class $3255b9f241bec491$export$698882cf06df44aa {
    static getDataURL(image) {
        if (/^data:/i.test(image.src)) return image.src;
        if (typeof HTMLCanvasElement === 'undefined') return image.src;
        let canvas;
        if (image instanceof HTMLCanvasElement) canvas = image;
        else {
            if ($3255b9f241bec491$var$_canvas === undefined) $3255b9f241bec491$var$_canvas = (0, $d93c9776005e33ec$export$7094a064528c7fee)('canvas');
            $3255b9f241bec491$var$_canvas.width = image.width;
            $3255b9f241bec491$var$_canvas.height = image.height;
            const context = $3255b9f241bec491$var$_canvas.getContext('2d');
            if (image instanceof ImageData) context.putImageData(image, 0, 0);
            else context.drawImage(image, 0, 0, image.width, image.height);
            canvas = $3255b9f241bec491$var$_canvas;
        }
        if (canvas.width > 2048 || canvas.height > 2048) {
            console.warn('THREE.ImageUtils.getDataURL: Image converted to jpg for performance reasons', image);
            return canvas.toDataURL('image/jpeg', 0.6);
        } else return canvas.toDataURL('image/png');
    }
    static sRGBToLinear(image) {
        if (typeof HTMLImageElement !== 'undefined' && image instanceof HTMLImageElement || typeof HTMLCanvasElement !== 'undefined' && image instanceof HTMLCanvasElement || typeof ImageBitmap !== 'undefined' && image instanceof ImageBitmap) {
            const canvas = (0, $d93c9776005e33ec$export$7094a064528c7fee)('canvas');
            canvas.width = image.width;
            canvas.height = image.height;
            const context = canvas.getContext('2d');
            context.drawImage(image, 0, 0, image.width, image.height);
            const imageData = context.getImageData(0, 0, image.width, image.height);
            const data = imageData.data;
            for(let i = 0; i < data.length; i++)data[i] = (0, $46d4f6f1be9702a8$export$22855367bc41ba49)(data[i] / 255) * 255;
            context.putImageData(imageData, 0, 0);
            return canvas;
        } else if (image.data) {
            const data = image.data.slice(0);
            for(let i = 0; i < data.length; i++)if (data instanceof Uint8Array || data instanceof Uint8ClampedArray) data[i] = Math.floor((0, $46d4f6f1be9702a8$export$22855367bc41ba49)(data[i] / 255) * 255);
            else // assuming float
            data[i] = (0, $46d4f6f1be9702a8$export$22855367bc41ba49)(data[i]);
            return {
                data: data,
                width: image.width,
                height: image.height
            };
        } else {
            console.warn('THREE.ImageUtils.sRGBToLinear(): Unsupported image type. No color space conversion applied.');
            return image;
        }
    }
}



let $56717028e6e96c4f$var$_sourceId = 0;
class $56717028e6e96c4f$export$1d2df86270c81ecb {
    constructor(data = null){
        this.isSource = true;
        Object.defineProperty(this, 'id', {
            value: $56717028e6e96c4f$var$_sourceId++
        });
        this.uuid = $7f727a3c7059d20d$export$e73c8bd0f20705a();
        this.data = data;
        this.dataReady = true;
        this.version = 0;
    }
    set needsUpdate(value) {
        if (value === true) this.version++;
    }
    toJSON(meta) {
        const isRootObject = meta === undefined || typeof meta === 'string';
        if (!isRootObject && meta.images[this.uuid] !== undefined) return meta.images[this.uuid];
        const output = {
            uuid: this.uuid,
            url: ''
        };
        const data = this.data;
        if (data !== null) {
            let url;
            if (Array.isArray(data)) {
                // cube texture
                url = [];
                for(let i = 0, l = data.length; i < l; i++)if (data[i].isDataTexture) url.push($56717028e6e96c4f$var$serializeImage(data[i].image));
                else url.push($56717028e6e96c4f$var$serializeImage(data[i]));
            } else // texture
            url = $56717028e6e96c4f$var$serializeImage(data);
            output.url = url;
        }
        if (!isRootObject) meta.images[this.uuid] = output;
        return output;
    }
}
function $56717028e6e96c4f$var$serializeImage(image) {
    if (typeof HTMLImageElement !== 'undefined' && image instanceof HTMLImageElement || typeof HTMLCanvasElement !== 'undefined' && image instanceof HTMLCanvasElement || typeof ImageBitmap !== 'undefined' && image instanceof ImageBitmap) // default images
    return (0, $3255b9f241bec491$export$698882cf06df44aa).getDataURL(image);
    else {
        if (image.data) // images of DataTexture
        return {
            data: Array.from(image.data),
            width: image.width,
            height: image.height,
            type: image.data.constructor.name
        };
        else {
            console.warn('THREE.Texture: Unable to serialize Texture.');
            return {};
        }
    }
}


let $97033ebbcbadc145$var$_textureId = 0;
class $97033ebbcbadc145$export$5431306cf43de24a extends (0, $a35132d5d9375da3$export$ec8b666c5fe2c75a) {
    constructor(image = $97033ebbcbadc145$export$5431306cf43de24a.DEFAULT_IMAGE, mapping = $97033ebbcbadc145$export$5431306cf43de24a.DEFAULT_MAPPING, wrapS = (0, $cb5ee595c0f892af$export$9d9334239a5a5e06), wrapT = (0, $cb5ee595c0f892af$export$9d9334239a5a5e06), magFilter = (0, $cb5ee595c0f892af$export$8a72f490b25c56c8), minFilter = (0, $cb5ee595c0f892af$export$5d8599b6a933fb1b), format = (0, $cb5ee595c0f892af$export$3f8bb04b555a363c), type = (0, $cb5ee595c0f892af$export$2e8ce08d3f6f5e10), anisotropy = $97033ebbcbadc145$export$5431306cf43de24a.DEFAULT_ANISOTROPY, colorSpace = (0, $cb5ee595c0f892af$export$bfcb490c2dd3db51)){
        super();
        this.isTexture = true;
        Object.defineProperty(this, 'id', {
            value: $97033ebbcbadc145$var$_textureId++
        });
        this.uuid = $7f727a3c7059d20d$export$e73c8bd0f20705a();
        this.name = '';
        this.source = new (0, $56717028e6e96c4f$export$1d2df86270c81ecb)(image);
        this.mipmaps = [];
        this.mapping = mapping;
        this.channel = 0;
        this.wrapS = wrapS;
        this.wrapT = wrapT;
        this.magFilter = magFilter;
        this.minFilter = minFilter;
        this.anisotropy = anisotropy;
        this.format = format;
        this.internalFormat = null;
        this.type = type;
        this.offset = new (0, $3c03061dea0adea3$export$c977b3e384af9ae1)(0, 0);
        this.repeat = new (0, $3c03061dea0adea3$export$c977b3e384af9ae1)(1, 1);
        this.center = new (0, $3c03061dea0adea3$export$c977b3e384af9ae1)(0, 0);
        this.rotation = 0;
        this.matrixAutoUpdate = true;
        this.matrix = new (0, $800ed18490319df2$export$8ff26dafa08918)();
        this.generateMipmaps = true;
        this.premultiplyAlpha = false;
        this.flipY = true;
        this.unpackAlignment = 4; // valid values: 1, 2, 4, 8 (see http://www.khronos.org/opengles/sdk/docs/man/xhtml/glPixelStorei.xml)
        this.colorSpace = colorSpace;
        this.userData = {};
        this.version = 0;
        this.onUpdate = null;
        this.isRenderTargetTexture = false; // indicates whether a texture belongs to a render target or not
        this.pmremVersion = 0; // indicates whether this texture should be processed by PMREMGenerator or not (only relevant for render target textures)
    }
    get image() {
        return this.source.data;
    }
    set image(value = null) {
        this.source.data = value;
    }
    updateMatrix() {
        this.matrix.setUvTransform(this.offset.x, this.offset.y, this.repeat.x, this.repeat.y, this.rotation, this.center.x, this.center.y);
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(source) {
        this.name = source.name;
        this.source = source.source;
        this.mipmaps = source.mipmaps.slice(0);
        this.mapping = source.mapping;
        this.channel = source.channel;
        this.wrapS = source.wrapS;
        this.wrapT = source.wrapT;
        this.magFilter = source.magFilter;
        this.minFilter = source.minFilter;
        this.anisotropy = source.anisotropy;
        this.format = source.format;
        this.internalFormat = source.internalFormat;
        this.type = source.type;
        this.offset.copy(source.offset);
        this.repeat.copy(source.repeat);
        this.center.copy(source.center);
        this.rotation = source.rotation;
        this.matrixAutoUpdate = source.matrixAutoUpdate;
        this.matrix.copy(source.matrix);
        this.generateMipmaps = source.generateMipmaps;
        this.premultiplyAlpha = source.premultiplyAlpha;
        this.flipY = source.flipY;
        this.unpackAlignment = source.unpackAlignment;
        this.colorSpace = source.colorSpace;
        this.userData = JSON.parse(JSON.stringify(source.userData));
        this.needsUpdate = true;
        return this;
    }
    toJSON(meta) {
        const isRootObject = meta === undefined || typeof meta === 'string';
        if (!isRootObject && meta.textures[this.uuid] !== undefined) return meta.textures[this.uuid];
        const output = {
            metadata: {
                version: 4.6,
                type: 'Texture',
                generator: 'Texture.toJSON'
            },
            uuid: this.uuid,
            name: this.name,
            image: this.source.toJSON(meta).uuid,
            mapping: this.mapping,
            channel: this.channel,
            repeat: [
                this.repeat.x,
                this.repeat.y
            ],
            offset: [
                this.offset.x,
                this.offset.y
            ],
            center: [
                this.center.x,
                this.center.y
            ],
            rotation: this.rotation,
            wrap: [
                this.wrapS,
                this.wrapT
            ],
            format: this.format,
            internalFormat: this.internalFormat,
            type: this.type,
            colorSpace: this.colorSpace,
            minFilter: this.minFilter,
            magFilter: this.magFilter,
            anisotropy: this.anisotropy,
            flipY: this.flipY,
            generateMipmaps: this.generateMipmaps,
            premultiplyAlpha: this.premultiplyAlpha,
            unpackAlignment: this.unpackAlignment
        };
        if (Object.keys(this.userData).length > 0) output.userData = this.userData;
        if (!isRootObject) meta.textures[this.uuid] = output;
        return output;
    }
    dispose() {
        this.dispatchEvent({
            type: 'dispose'
        });
    }
    transformUv(uv) {
        if (this.mapping !== (0, $cb5ee595c0f892af$export$1beec6768cbb3d2d)) return uv;
        uv.applyMatrix3(this.matrix);
        if (uv.x < 0 || uv.x > 1) switch(this.wrapS){
            case 0, $cb5ee595c0f892af$export$533346c8e8dac0f5:
                uv.x = uv.x - Math.floor(uv.x);
                break;
            case 0, $cb5ee595c0f892af$export$9d9334239a5a5e06:
                uv.x = uv.x < 0 ? 0 : 1;
                break;
            case 0, $cb5ee595c0f892af$export$c7e7c00b14f51a4f:
                if (Math.abs(Math.floor(uv.x) % 2) === 1) uv.x = Math.ceil(uv.x) - uv.x;
                else uv.x = uv.x - Math.floor(uv.x);
                break;
        }
        if (uv.y < 0 || uv.y > 1) switch(this.wrapT){
            case 0, $cb5ee595c0f892af$export$533346c8e8dac0f5:
                uv.y = uv.y - Math.floor(uv.y);
                break;
            case 0, $cb5ee595c0f892af$export$9d9334239a5a5e06:
                uv.y = uv.y < 0 ? 0 : 1;
                break;
            case 0, $cb5ee595c0f892af$export$c7e7c00b14f51a4f:
                if (Math.abs(Math.floor(uv.y) % 2) === 1) uv.y = Math.ceil(uv.y) - uv.y;
                else uv.y = uv.y - Math.floor(uv.y);
                break;
        }
        if (this.flipY) uv.y = 1 - uv.y;
        return uv;
    }
    set needsUpdate(value) {
        if (value === true) {
            this.version++;
            this.source.needsUpdate = true;
        }
    }
    set needsPMREMUpdate(value) {
        if (value === true) this.pmremVersion++;
    }
}
$97033ebbcbadc145$export$5431306cf43de24a.DEFAULT_IMAGE = null;
$97033ebbcbadc145$export$5431306cf43de24a.DEFAULT_MAPPING = (0, $cb5ee595c0f892af$export$1beec6768cbb3d2d);
$97033ebbcbadc145$export$5431306cf43de24a.DEFAULT_ANISOTROPY = 1;



class $520286b5db9c7cf5$export$fc830aa069cc8c2f extends (0, $97033ebbcbadc145$export$5431306cf43de24a) {
    constructor(width, height, type, mapping, wrapS, wrapT, magFilter, minFilter, anisotropy, format = (0, $cb5ee595c0f892af$export$c1b6b5136be58045)){
        if (format !== (0, $cb5ee595c0f892af$export$c1b6b5136be58045) && format !== (0, $cb5ee595c0f892af$export$1e113ac2d0905829)) throw new Error('DepthTexture format must be either THREE.DepthFormat or THREE.DepthStencilFormat');
        if (type === undefined && format === (0, $cb5ee595c0f892af$export$c1b6b5136be58045)) type = (0, $cb5ee595c0f892af$export$c3c7fc4518ebba96);
        if (type === undefined && format === (0, $cb5ee595c0f892af$export$1e113ac2d0905829)) type = (0, $cb5ee595c0f892af$export$6c8ea339bfab1301);
        super(null, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy);
        this.isDepthTexture = true;
        this.image = {
            width: width,
            height: height
        };
        this.magFilter = magFilter !== undefined ? magFilter : (0, $cb5ee595c0f892af$export$727aa5ec3fe39bf0);
        this.minFilter = minFilter !== undefined ? minFilter : (0, $cb5ee595c0f892af$export$727aa5ec3fe39bf0);
        this.flipY = false;
        this.generateMipmaps = false;
        this.compareFunction = null;
    }
    copy(source) {
        super.copy(source);
        this.compareFunction = source.compareFunction;
        return this;
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        if (this.compareFunction !== null) data.compareFunction = this.compareFunction;
        return data;
    }
}



const $19c1ba17c1582c1b$var$_size = /*@__PURE__*/ new (0, $d7d0ac0e47013885$export$64b5c384219d3699)();
class $19c1ba17c1582c1b$var$Textures extends (0, $0c532ab002169243$export$2e2bcd8739ae039) {
    constructor(renderer, backend, info){
        super();
        this.renderer = renderer;
        this.backend = backend;
        this.info = info;
    }
    updateRenderTarget(renderTarget, activeMipmapLevel = 0) {
        const renderTargetData = this.get(renderTarget);
        const sampleCount = renderTarget.samples === 0 ? 1 : renderTarget.samples;
        const depthTextureMips = renderTargetData.depthTextureMips || (renderTargetData.depthTextureMips = {});
        const textures = renderTarget.textures;
        const size = this.getSize(textures[0]);
        const mipWidth = size.width >> activeMipmapLevel;
        const mipHeight = size.height >> activeMipmapLevel;
        let depthTexture = renderTarget.depthTexture || depthTextureMips[activeMipmapLevel];
        const useDepthTexture = renderTarget.depthBuffer === true || renderTarget.stencilBuffer === true;
        let textureNeedsUpdate = false;
        if (depthTexture === undefined && useDepthTexture) {
            depthTexture = new (0, $520286b5db9c7cf5$export$fc830aa069cc8c2f)();
            depthTexture.format = renderTarget.stencilBuffer ? (0, $cb5ee595c0f892af$export$1e113ac2d0905829) : (0, $cb5ee595c0f892af$export$c1b6b5136be58045);
            depthTexture.type = renderTarget.stencilBuffer ? (0, $cb5ee595c0f892af$export$6c8ea339bfab1301) : (0, $cb5ee595c0f892af$export$c3c7fc4518ebba96); // FloatType
            depthTexture.image.width = mipWidth;
            depthTexture.image.height = mipHeight;
            depthTextureMips[activeMipmapLevel] = depthTexture;
        }
        if (renderTargetData.width !== size.width || size.height !== renderTargetData.height) {
            textureNeedsUpdate = true;
            if (depthTexture) {
                depthTexture.needsUpdate = true;
                depthTexture.image.width = mipWidth;
                depthTexture.image.height = mipHeight;
            }
        }
        renderTargetData.width = size.width;
        renderTargetData.height = size.height;
        renderTargetData.textures = textures;
        renderTargetData.depthTexture = depthTexture || null;
        renderTargetData.depth = renderTarget.depthBuffer;
        renderTargetData.stencil = renderTarget.stencilBuffer;
        renderTargetData.renderTarget = renderTarget;
        if (renderTargetData.sampleCount !== sampleCount) {
            textureNeedsUpdate = true;
            if (depthTexture) depthTexture.needsUpdate = true;
            renderTargetData.sampleCount = sampleCount;
        }
        //
        const options = {
            sampleCount: sampleCount
        };
        for(let i = 0; i < textures.length; i++){
            const texture = textures[i];
            if (textureNeedsUpdate) texture.needsUpdate = true;
            this.updateTexture(texture, options);
        }
        if (depthTexture) this.updateTexture(depthTexture, options);
        // dispose handler
        if (renderTargetData.initialized !== true) {
            renderTargetData.initialized = true;
            // dispose
            const onDispose = ()=>{
                renderTarget.removeEventListener('dispose', onDispose);
                for(let i = 0; i < textures.length; i++)this._destroyTexture(textures[i]);
                if (depthTexture) this._destroyTexture(depthTexture);
                this.delete(renderTarget);
            };
            renderTarget.addEventListener('dispose', onDispose);
        }
    }
    updateTexture(texture, options = {}) {
        const textureData = this.get(texture);
        if (textureData.initialized === true && textureData.version === texture.version) return;
        const isRenderTarget = texture.isRenderTargetTexture || texture.isDepthTexture || texture.isFramebufferTexture;
        const backend = this.backend;
        if (isRenderTarget && textureData.initialized === true) {
            // it's an update
            backend.destroySampler(texture);
            backend.destroyTexture(texture);
        }
        //
        if (texture.isFramebufferTexture) {
            const renderTarget = this.renderer.getRenderTarget();
            if (renderTarget) texture.type = renderTarget.texture.type;
            else texture.type = (0, $cb5ee595c0f892af$export$2e8ce08d3f6f5e10);
        }
        //
        const { width: width, height: height, depth: depth } = this.getSize(texture);
        options.width = width;
        options.height = height;
        options.depth = depth;
        options.needsMipmaps = this.needsMipmaps(texture);
        options.levels = options.needsMipmaps ? this.getMipLevels(texture, width, height) : 1;
        //
        if (isRenderTarget || texture.isStorageTexture === true) {
            backend.createSampler(texture);
            backend.createTexture(texture, options);
            textureData.generation = texture.version;
        } else {
            const needsCreate = textureData.initialized !== true;
            if (needsCreate) backend.createSampler(texture);
            if (texture.version > 0) {
                const image = texture.image;
                if (image === undefined) console.warn('THREE.Renderer: Texture marked for update but image is undefined.');
                else if (image.complete === false) console.warn('THREE.Renderer: Texture marked for update but image is incomplete.');
                else {
                    if (texture.images) {
                        const images = [];
                        for (const image of texture.images)images.push(image);
                        options.images = images;
                    } else options.image = image;
                    if (textureData.isDefaultTexture === undefined || textureData.isDefaultTexture === true) {
                        backend.createTexture(texture, options);
                        textureData.isDefaultTexture = false;
                        textureData.generation = texture.version;
                    }
                    if (texture.source.dataReady === true) backend.updateTexture(texture, options);
                    if (options.needsMipmaps && texture.mipmaps.length === 0) backend.generateMipmaps(texture);
                }
            } else {
                // async update
                backend.createDefaultTexture(texture);
                textureData.isDefaultTexture = true;
                textureData.generation = texture.version;
            }
        }
        // dispose handler
        if (textureData.initialized !== true) {
            textureData.initialized = true;
            textureData.generation = texture.version;
            //
            this.info.memory.textures++;
            // dispose
            const onDispose = ()=>{
                texture.removeEventListener('dispose', onDispose);
                this._destroyTexture(texture);
                this.info.memory.textures--;
            };
            texture.addEventListener('dispose', onDispose);
        }
        //
        textureData.version = texture.version;
    }
    getSize(texture, target = $19c1ba17c1582c1b$var$_size) {
        let image = texture.images ? texture.images[0] : texture.image;
        if (image) {
            if (image.image !== undefined) image = image.image;
            target.width = image.width;
            target.height = image.height;
            target.depth = texture.isCubeTexture ? 6 : image.depth || 1;
        } else target.width = target.height = target.depth = 1;
        return target;
    }
    getMipLevels(texture, width, height) {
        let mipLevelCount;
        if (texture.isCompressedTexture) mipLevelCount = texture.mipmaps.length;
        else mipLevelCount = Math.floor(Math.log2(Math.max(width, height))) + 1;
        return mipLevelCount;
    }
    needsMipmaps(texture) {
        return this.isEnvironmentTexture(texture) || texture.isCompressedTexture === true || texture.generateMipmaps;
    }
    isEnvironmentTexture(texture) {
        const mapping = texture.mapping;
        return mapping === (0, $cb5ee595c0f892af$export$d64030b316d3b087) || mapping === (0, $cb5ee595c0f892af$export$ee99d97d46898098) || mapping === (0, $cb5ee595c0f892af$export$8759762a6477f2c4) || mapping === (0, $cb5ee595c0f892af$export$dc59f8aed047f61d);
    }
    _destroyTexture(texture) {
        this.backend.destroySampler(texture);
        this.backend.destroyTexture(texture);
        this.delete(texture);
    }
}
var $19c1ba17c1582c1b$export$2e2bcd8739ae039 = $19c1ba17c1582c1b$var$Textures;




class $4673b28ced87b0be$var$Color4 extends (0, $9a23ce591a1b6760$export$892596cec99bc70e) {
    constructor(r, g, b, a = 1){
        super(r, g, b);
        this.a = a;
    }
    set(r, g, b, a = 1) {
        this.a = a;
        return super.set(r, g, b);
    }
    copy(color) {
        if (color.a !== undefined) this.a = color.a;
        return super.copy(color);
    }
    clone() {
        return new this.constructor(this.r, this.g, this.b, this.a);
    }
}
var $4673b28ced87b0be$export$2e2bcd8739ae039 = $4673b28ced87b0be$var$Color4;


var $5a29c557262c8ca2$exports = {};
$parcel$export($5a29c557262c8ca2$exports, "context", () => $8e9a9aae457d80ab$export$a078c61943f9dbbe);
$parcel$export($5a29c557262c8ca2$exports, "frameGroup", () => $d2c0f7c752a63c18$export$654c8c9e57a353a5);
$parcel$export($5a29c557262c8ca2$exports, "objectGroup", () => $d2c0f7c752a63c18$export$6a2a415f960d3137);
$parcel$export($5a29c557262c8ca2$exports, "renderGroup", () => $d2c0f7c752a63c18$export$a75a8692b47c7f9e);
$parcel$export($5a29c557262c8ca2$exports, "context", () => $8e9a9aae457d80ab$export$a078c61943f9dbbe);
$parcel$export($5a29c557262c8ca2$exports, "vec4", () => $d5b7ee61758b2e81$export$6dba2a1f0d609415);
$parcel$export($5a29c557262c8ca2$exports, "cubeTexture", () => $48a97961b9b43631$export$f8948c996a1778e8);
$parcel$export($5a29c557262c8ca2$exports, "modelViewProjection", () => $ae567e19e549d56f$export$64e914589db9c49e);
$parcel$export($5a29c557262c8ca2$exports, "normalWorld", () => $0ab44deffc8ae973$export$8cce2f8527757c54);
$parcel$export($5a29c557262c8ca2$exports, "reference", () => $7082d3a91c21cd99$export$ca50aac9f3ba507f);
$parcel$export($5a29c557262c8ca2$exports, "backgroundBlurriness", () => $25d2163f514a019a$export$4e4686c12357d6e1);
$parcel$export($5a29c557262c8ca2$exports, "backgroundIntensity", () => $25d2163f514a019a$export$aefe029977c9e2d3);
$parcel$export($5a29c557262c8ca2$exports, "backgroundRotation", () => $25d2163f514a019a$export$e59ff0f31e16f9ed);
$parcel$export($5a29c557262c8ca2$exports, "texture", () => $f7d68bbf9ea772a7$export$ab69073b3903a075);
$parcel$export($5a29c557262c8ca2$exports, "screenUV", () => $64df2f32a1195518$export$e2a68d187fb2dd60);
$parcel$export($5a29c557262c8ca2$exports, "rangeFog", () => $59c4f43fccb3aac6$export$40551637e51894d4);
$parcel$export($5a29c557262c8ca2$exports, "densityFog", () => $90c80656a1da59cb$export$31ec25b1026406ff);
$parcel$export($5a29c557262c8ca2$exports, "pmremTexture", () => $23ee98d041aa8c55$export$7563f7aed5e67dc);
// constants
const $ddcfecb7fbba5d74$export$9e43649cde3e3072 = {
    VERTEX: 'vertex',
    FRAGMENT: 'fragment'
};
const $ddcfecb7fbba5d74$export$26f7a8bbd9469530 = {
    NONE: 'none',
    FRAME: 'frame',
    RENDER: 'render',
    OBJECT: 'object'
};
const $ddcfecb7fbba5d74$export$f06e977173f1857c = {
    BOOLEAN: 'bool',
    INTEGER: 'int',
    FLOAT: 'float',
    VECTOR2: 'vec2',
    VECTOR3: 'vec3',
    VECTOR4: 'vec4',
    MATRIX2: 'mat2',
    MATRIX3: 'mat3',
    MATRIX4: 'mat4'
};
const $ddcfecb7fbba5d74$export$565139d2263e2965 = [
    'fragment',
    'vertex'
];
const $ddcfecb7fbba5d74$export$f2213ed98eb895d6 = [
    'setup',
    'analyze',
    'generate'
];
const $ddcfecb7fbba5d74$export$48fd793f0255b86a = [
    ...$ddcfecb7fbba5d74$export$565139d2263e2965,
    'compute'
];
const $ddcfecb7fbba5d74$export$1c0adcb9073b646d = [
    'x',
    'y',
    'z',
    'w'
];






let $65e77d5c3a27a66a$var$_nodeId = 0;
class $65e77d5c3a27a66a$var$Node extends (0, $a35132d5d9375da3$export$ec8b666c5fe2c75a) {
    static get type() {
        return 'Node';
    }
    constructor(nodeType = null){
        super();
        this.nodeType = nodeType;
        this.updateType = (0, $ddcfecb7fbba5d74$export$26f7a8bbd9469530).NONE;
        this.updateBeforeType = (0, $ddcfecb7fbba5d74$export$26f7a8bbd9469530).NONE;
        this.updateAfterType = (0, $ddcfecb7fbba5d74$export$26f7a8bbd9469530).NONE;
        this.uuid = (0, $7f727a3c7059d20d$export$6a7ef315a0d1ef07).generateUUID();
        this.version = 0;
        this._cacheKey = null;
        this._cacheKeyVersion = 0;
        this.global = false;
        this.isNode = true;
        Object.defineProperty(this, 'id', {
            value: $65e77d5c3a27a66a$var$_nodeId++
        });
    }
    set needsUpdate(value) {
        if (value === true) this.version++;
    }
    get type() {
        return this.constructor.type;
    }
    onUpdate(callback, updateType) {
        this.updateType = updateType;
        this.update = callback.bind(this.getSelf());
        return this;
    }
    onFrameUpdate(callback) {
        return this.onUpdate(callback, (0, $ddcfecb7fbba5d74$export$26f7a8bbd9469530).FRAME);
    }
    onRenderUpdate(callback) {
        return this.onUpdate(callback, (0, $ddcfecb7fbba5d74$export$26f7a8bbd9469530).RENDER);
    }
    onObjectUpdate(callback) {
        return this.onUpdate(callback, (0, $ddcfecb7fbba5d74$export$26f7a8bbd9469530).OBJECT);
    }
    onReference(callback) {
        this.updateReference = callback.bind(this.getSelf());
        return this;
    }
    getSelf() {
        // Returns non-node object.
        return this.self || this;
    }
    updateReference() {
        return this;
    }
    isGlobal() {
        return this.global;
    }
    *getChildren() {
        for (const { childNode: childNode } of (0, $97d1d441621670a9$export$1f1998cc3c6b56fb)(this))yield childNode;
    }
    dispose() {
        this.dispatchEvent({
            type: 'dispose'
        });
    }
    traverse(callback) {
        callback(this);
        for (const childNode of this.getChildren())childNode.traverse(callback);
    }
    getCacheKey(force = false) {
        force = force || this.version !== this._cacheKeyVersion;
        if (force === true || this._cacheKey === null) {
            this._cacheKey = (0, $97d1d441621670a9$export$611736262b635f8d)(this, force);
            this._cacheKeyVersion = this.version;
        }
        return this._cacheKey;
    }
    getScope() {
        return this;
    }
    getHash() {
        return this.uuid;
    }
    getUpdateType() {
        return this.updateType;
    }
    getUpdateBeforeType() {
        return this.updateBeforeType;
    }
    getUpdateAfterType() {
        return this.updateAfterType;
    }
    getElementType(builder) {
        const type = this.getNodeType(builder);
        const elementType = builder.getElementType(type);
        return elementType;
    }
    getNodeType(builder) {
        const nodeProperties = builder.getNodeProperties(this);
        if (nodeProperties.outputNode) return nodeProperties.outputNode.getNodeType(builder);
        return this.nodeType;
    }
    getShared(builder) {
        const hash = this.getHash(builder);
        const nodeFromHash = builder.getNodeFromHash(hash);
        return nodeFromHash || this;
    }
    setup(builder) {
        const nodeProperties = builder.getNodeProperties(this);
        let index = 0;
        for (const childNode of this.getChildren())nodeProperties['node' + index++] = childNode;
        // return a outputNode if exists
        return null;
    }
    analyze(builder) {
        const usageCount = builder.increaseUsage(this);
        if (usageCount === 1) {
            // node flow children
            const nodeProperties = builder.getNodeProperties(this);
            for (const childNode of Object.values(nodeProperties))if (childNode && childNode.isNode === true) childNode.build(builder);
        }
    }
    generate(builder, output) {
        const { outputNode: outputNode } = builder.getNodeProperties(this);
        if (outputNode && outputNode.isNode === true) return outputNode.build(builder, output);
    }
    updateBefore() {
        console.warn('Abstract function.');
    }
    updateAfter() {
        console.warn('Abstract function.');
    }
    update() {
        console.warn('Abstract function.');
    }
    build(builder, output = null) {
        const refNode = this.getShared(builder);
        if (this !== refNode) return refNode.build(builder, output);
        builder.addNode(this);
        builder.addChain(this);
        /* Build stages expected results:
			- "setup"		-> Node
			- "analyze"		-> null
			- "generate"	-> String
		*/ let result = null;
        const buildStage = builder.getBuildStage();
        if (buildStage === 'setup') {
            this.updateReference(builder);
            const properties = builder.getNodeProperties(this);
            if (properties.initialized !== true) {
                const stackNodesBeforeSetup = builder.stack.nodes.length;
                properties.initialized = true;
                properties.outputNode = this.setup(builder);
                properties.outputNode !== null && builder.stack.nodes.length;
                for (const childNode of Object.values(properties))if (childNode && childNode.isNode === true) childNode.build(builder);
            }
        } else if (buildStage === 'analyze') this.analyze(builder);
        else if (buildStage === 'generate') {
            const isGenerateOnce = this.generate.length === 1;
            if (isGenerateOnce) {
                const type = this.getNodeType(builder);
                const nodeData = builder.getDataFromNode(this);
                result = nodeData.snippet;
                if (result === undefined) {
                    result = this.generate(builder) || '';
                    nodeData.snippet = result;
                } else if (nodeData.flowCodes !== undefined && builder.context.nodeBlock !== undefined) builder.addFlowCodeHierarchy(this, builder.context.nodeBlock);
                result = builder.format(result, type, output);
            } else result = this.generate(builder, output) || '';
        }
        builder.removeChain(this);
        builder.addSequentialNode(this);
        return result;
    }
    getSerializeChildren() {
        return (0, $97d1d441621670a9$export$1f1998cc3c6b56fb)(this);
    }
    serialize(json) {
        const nodeChildren = this.getSerializeChildren();
        const inputNodes = {};
        for (const { property: property, index: index, childNode: childNode } of nodeChildren)if (index !== undefined) {
            if (inputNodes[property] === undefined) inputNodes[property] = Number.isInteger(index) ? [] : {};
            inputNodes[property][index] = childNode.toJSON(json.meta).uuid;
        } else inputNodes[property] = childNode.toJSON(json.meta).uuid;
        if (Object.keys(inputNodes).length > 0) json.inputNodes = inputNodes;
    }
    deserialize(json) {
        if (json.inputNodes !== undefined) {
            const nodes = json.meta.nodes;
            for(const property in json.inputNodes){
                if (Array.isArray(json.inputNodes[property])) {
                    const inputArray = [];
                    for (const uuid of json.inputNodes[property])inputArray.push(nodes[uuid]);
                    this[property] = inputArray;
                } else if (typeof json.inputNodes[property] === 'object') {
                    const inputObject = {};
                    for(const subProperty in json.inputNodes[property]){
                        const uuid = json.inputNodes[property][subProperty];
                        inputObject[subProperty] = nodes[uuid];
                    }
                    this[property] = inputObject;
                } else {
                    const uuid = json.inputNodes[property];
                    this[property] = nodes[uuid];
                }
            }
        }
    }
    toJSON(meta) {
        const { uuid: uuid, type: type } = this;
        const isRoot = meta === undefined || typeof meta === 'string';
        if (isRoot) meta = {
            textures: {},
            images: {},
            nodes: {}
        };
        // serialize
        let data = meta.nodes[uuid];
        if (data === undefined) {
            data = {
                uuid: uuid,
                type: type,
                meta: meta,
                metadata: {
                    version: 4.6,
                    type: 'Node',
                    generator: 'Node.toJSON'
                }
            };
            if (isRoot !== true) meta.nodes[data.uuid] = data;
            this.serialize(data);
            delete data.meta;
        }
        // TODO: Copied from Object3D.toJSON
        function extractFromCache(cache) {
            const values = [];
            for(const key in cache){
                const data = cache[key];
                delete data.metadata;
                values.push(data);
            }
            return values;
        }
        if (isRoot) {
            const textures = extractFromCache(meta.textures);
            const images = extractFromCache(meta.images);
            const nodes = extractFromCache(meta.nodes);
            if (textures.length > 0) data.textures = textures;
            if (images.length > 0) data.images = images;
            if (nodes.length > 0) data.nodes = nodes;
        }
        return data;
    }
}
var $65e77d5c3a27a66a$export$2e2bcd8739ae039 = $65e77d5c3a27a66a$var$Node;


class $75c45ed2361c955f$var$TempNode extends (0, $65e77d5c3a27a66a$export$2e2bcd8739ae039) {
    static get type() {
        return 'TempNode';
    }
    constructor(type){
        super(type);
        this.isTempNode = true;
    }
    hasDependencies(builder) {
        return builder.getDataFromNode(this).usageCount > 1;
    }
    build(builder, output) {
        const buildStage = builder.getBuildStage();
        if (buildStage === 'generate') {
            const type = builder.getVectorType(this.getNodeType(builder, output));
            const nodeData = builder.getDataFromNode(this);
            if (nodeData.propertyName !== undefined) return builder.format(nodeData.propertyName, type, output);
            else if (type !== 'void' && output !== 'void' && this.hasDependencies(builder)) {
                const snippet = super.build(builder, type);
                const nodeVar = builder.getVarFromNode(this, null, type);
                const propertyName = builder.getPropertyName(nodeVar);
                builder.addLineFlowCode(`${propertyName} = ${snippet}`, this);
                nodeData.snippet = snippet;
                nodeData.propertyName = propertyName;
                return builder.format(nodeData.propertyName, type, output);
            }
        }
        return super.build(builder, output);
    }
}
var $75c45ed2361c955f$export$2e2bcd8739ae039 = $75c45ed2361c955f$var$TempNode;




class $e2cc991ce11e1c78$var$ArrayElementNode extends (0, $65e77d5c3a27a66a$export$2e2bcd8739ae039) {
    static get type() {
        return 'ArrayElementNode';
    }
    constructor(node, indexNode){
        super();
        this.node = node;
        this.indexNode = indexNode;
        this.isArrayElementNode = true;
    }
    getNodeType(builder) {
        return this.node.getElementType(builder);
    }
    generate(builder) {
        const nodeSnippet = this.node.build(builder);
        const indexSnippet = this.indexNode.build(builder, 'uint');
        return `${nodeSnippet}[ ${indexSnippet} ]`;
    }
}
var $e2cc991ce11e1c78$export$2e2bcd8739ae039 = $e2cc991ce11e1c78$var$ArrayElementNode;



class $0a2bbf7681f41101$var$ConvertNode extends (0, $65e77d5c3a27a66a$export$2e2bcd8739ae039) {
    static get type() {
        return 'ConvertNode';
    }
    constructor(node, convertTo){
        super();
        this.node = node;
        this.convertTo = convertTo;
    }
    getNodeType(builder) {
        const requestType = this.node.getNodeType(builder);
        let convertTo = null;
        for (const overloadingType of this.convertTo.split('|'))if (convertTo === null || builder.getTypeLength(requestType) === builder.getTypeLength(overloadingType)) convertTo = overloadingType;
        return convertTo;
    }
    serialize(data) {
        super.serialize(data);
        data.convertTo = this.convertTo;
    }
    deserialize(data) {
        super.deserialize(data);
        this.convertTo = data.convertTo;
    }
    generate(builder, output) {
        const node = this.node;
        const type = this.getNodeType(builder);
        const snippet = node.build(builder, type);
        return builder.format(snippet, type, output);
    }
}
var $0a2bbf7681f41101$export$2e2bcd8739ae039 = $0a2bbf7681f41101$var$ConvertNode;



class $35624d68ea2463e8$var$JoinNode extends (0, $75c45ed2361c955f$export$2e2bcd8739ae039) {
    static get type() {
        return 'JoinNode';
    }
    constructor(nodes = [], nodeType = null){
        super(nodeType);
        this.nodes = nodes;
    }
    getNodeType(builder) {
        if (this.nodeType !== null) return builder.getVectorType(this.nodeType);
        return builder.getTypeFromLength(this.nodes.reduce((count, cur)=>count + builder.getTypeLength(cur.getNodeType(builder)), 0));
    }
    generate(builder, output) {
        const type = this.getNodeType(builder);
        const nodes = this.nodes;
        const primitiveType = builder.getComponentType(type);
        const snippetValues = [];
        for (const input of nodes){
            let inputSnippet = input.build(builder);
            const inputPrimitiveType = builder.getComponentType(input.getNodeType(builder));
            if (inputPrimitiveType !== primitiveType) inputSnippet = builder.format(inputSnippet, inputPrimitiveType, primitiveType);
            snippetValues.push(inputSnippet);
        }
        const snippet = `${builder.getType(type)}( ${snippetValues.join(', ')} )`;
        return builder.format(snippet, type, output);
    }
}
var $35624d68ea2463e8$export$2e2bcd8739ae039 = $35624d68ea2463e8$var$JoinNode;




const $070976a081d0afc6$var$stringVectorComponents = (0, $ddcfecb7fbba5d74$export$1c0adcb9073b646d).join('');
class $070976a081d0afc6$var$SplitNode extends (0, $65e77d5c3a27a66a$export$2e2bcd8739ae039) {
    static get type() {
        return 'SplitNode';
    }
    constructor(node, components = 'x'){
        super();
        this.node = node;
        this.components = components;
        this.isSplitNode = true;
    }
    getVectorLength() {
        let vectorLength = this.components.length;
        for (const c of this.components)vectorLength = Math.max((0, $ddcfecb7fbba5d74$export$1c0adcb9073b646d).indexOf(c) + 1, vectorLength);
        return vectorLength;
    }
    getComponentType(builder) {
        return builder.getComponentType(this.node.getNodeType(builder));
    }
    getNodeType(builder) {
        return builder.getTypeFromLength(this.components.length, this.getComponentType(builder));
    }
    generate(builder, output) {
        const node = this.node;
        const nodeTypeLength = builder.getTypeLength(node.getNodeType(builder));
        let snippet = null;
        if (nodeTypeLength > 1) {
            let type = null;
            const componentsLength = this.getVectorLength();
            if (componentsLength >= nodeTypeLength) // needed expand the input node
            type = builder.getTypeFromLength(this.getVectorLength(), this.getComponentType(builder));
            const nodeSnippet = node.build(builder, type);
            if (this.components.length === nodeTypeLength && this.components === $070976a081d0afc6$var$stringVectorComponents.slice(0, this.components.length)) // unnecessary swizzle
            snippet = builder.format(nodeSnippet, type, output);
            else snippet = builder.format(`${nodeSnippet}.${this.components}`, this.getNodeType(builder), output);
        } else // ignore .components if .node returns float/integer
        snippet = node.build(builder, output);
        return snippet;
    }
    serialize(data) {
        super.serialize(data);
        data.components = this.components;
    }
    deserialize(data) {
        super.deserialize(data);
        this.components = data.components;
    }
}
var $070976a081d0afc6$export$2e2bcd8739ae039 = $070976a081d0afc6$var$SplitNode;




class $9dedb40d2bc52c7c$var$SetNode extends (0, $75c45ed2361c955f$export$2e2bcd8739ae039) {
    static get type() {
        return 'SetNode';
    }
    constructor(sourceNode, components, targetNode){
        super();
        this.sourceNode = sourceNode;
        this.components = components;
        this.targetNode = targetNode;
    }
    getNodeType(builder) {
        return this.sourceNode.getNodeType(builder);
    }
    generate(builder) {
        const { sourceNode: sourceNode, components: components, targetNode: targetNode } = this;
        const sourceType = this.getNodeType(builder);
        const targetType = builder.getTypeFromLength(components.length, targetNode.getNodeType(builder));
        const targetSnippet = targetNode.build(builder, targetType);
        const sourceSnippet = sourceNode.build(builder, sourceType);
        const length = builder.getTypeLength(sourceType);
        const snippetValues = [];
        for(let i = 0; i < length; i++){
            const component = (0, $ddcfecb7fbba5d74$export$1c0adcb9073b646d)[i];
            if (component === components[0]) {
                snippetValues.push(targetSnippet);
                i += components.length - 1;
            } else snippetValues.push(sourceSnippet + '.' + component);
        }
        return `${builder.getType(sourceType)}( ${snippetValues.join(', ')} )`;
    }
}
var $9dedb40d2bc52c7c$export$2e2bcd8739ae039 = $9dedb40d2bc52c7c$var$SetNode;




class $8a6f7deed1444fde$var$FlipNode extends (0, $75c45ed2361c955f$export$2e2bcd8739ae039) {
    static get type() {
        return 'FlipNode';
    }
    constructor(sourceNode, components){
        super();
        this.sourceNode = sourceNode;
        this.components = components;
    }
    getNodeType(builder) {
        return this.sourceNode.getNodeType(builder);
    }
    generate(builder) {
        const { components: components, sourceNode: sourceNode } = this;
        const sourceType = this.getNodeType(builder);
        const sourceSnippet = sourceNode.build(builder);
        const sourceCache = builder.getVarFromNode(this);
        const sourceProperty = builder.getPropertyName(sourceCache);
        builder.addLineFlowCode(sourceProperty + ' = ' + sourceSnippet, this);
        const length = builder.getTypeLength(sourceType);
        const snippetValues = [];
        let componentIndex = 0;
        for(let i = 0; i < length; i++){
            const component = (0, $ddcfecb7fbba5d74$export$1c0adcb9073b646d)[i];
            if (component === components[componentIndex]) {
                snippetValues.push('1.0 - ' + (sourceProperty + '.' + component));
                componentIndex++;
            } else snippetValues.push(sourceProperty + '.' + component);
        }
        return `${builder.getType(sourceType)}( ${snippetValues.join(', ')} )`;
    }
}
var $8a6f7deed1444fde$export$2e2bcd8739ae039 = $8a6f7deed1444fde$var$FlipNode;




class $87507ebf571fbdf4$var$InputNode extends (0, $65e77d5c3a27a66a$export$2e2bcd8739ae039) {
    static get type() {
        return 'InputNode';
    }
    constructor(value, nodeType = null){
        super(nodeType);
        this.isInputNode = true;
        this.value = value;
        this.precision = null;
    }
    getNodeType() {
        if (this.nodeType === null) return (0, $97d1d441621670a9$export$cc7ab17e03dab419)(this.value);
        return this.nodeType;
    }
    getInputType(builder) {
        return this.getNodeType(builder);
    }
    setPrecision(precision) {
        this.precision = precision;
        return this;
    }
    serialize(data) {
        super.serialize(data);
        data.value = this.value;
        if (this.value && this.value.toArray) data.value = this.value.toArray();
        data.valueType = (0, $97d1d441621670a9$export$cc7ab17e03dab419)(this.value);
        data.nodeType = this.nodeType;
        if (data.valueType === 'ArrayBuffer') data.value = (0, $97d1d441621670a9$export$70c4ae293293ca1e)(data.value);
        data.precision = this.precision;
    }
    deserialize(data) {
        super.deserialize(data);
        this.nodeType = data.nodeType;
        this.value = Array.isArray(data.value) ? (0, $97d1d441621670a9$export$64e17ccd4a503243)(data.valueType, ...data.value) : data.value;
        this.precision = data.precision || null;
        if (this.value && this.value.fromArray) this.value = this.value.fromArray(data.value);
    }
    generate() {
        console.warn('Abstract function.');
    }
}
var $87507ebf571fbdf4$export$2e2bcd8739ae039 = $87507ebf571fbdf4$var$InputNode;


class $e08750ac28014382$var$ConstNode extends (0, $87507ebf571fbdf4$export$2e2bcd8739ae039) {
    static get type() {
        return 'ConstNode';
    }
    constructor(value, nodeType = null){
        super(value, nodeType);
        this.isConstNode = true;
    }
    generateConst(builder) {
        return builder.generateConst(this.getNodeType(builder), this.value);
    }
    generate(builder, output) {
        const type = this.getNodeType(builder);
        return builder.format(this.generateConst(builder), type, output);
    }
}
var $e08750ac28014382$export$2e2bcd8739ae039 = $e08750ac28014382$var$ConstNode;



//
let $d5b7ee61758b2e81$var$currentStack = null;
const $d5b7ee61758b2e81$var$NodeElements = new Map();
function $d5b7ee61758b2e81$export$5f439e138e9dc985(name, nodeElement) {
    if ($d5b7ee61758b2e81$var$NodeElements.has(name)) {
        console.warn(`Redefinition of method chaining ${name}`);
        return;
    }
    if (typeof nodeElement !== 'function') throw new Error(`Node element ${name} is not a function`);
    $d5b7ee61758b2e81$var$NodeElements.set(name, nodeElement);
}
const $d5b7ee61758b2e81$var$parseSwizzle = (props)=>props.replace(/r|s/g, 'x').replace(/g|t/g, 'y').replace(/b|p/g, 'z').replace(/a|q/g, 'w');
const $d5b7ee61758b2e81$var$parseSwizzleAndSort = (props)=>$d5b7ee61758b2e81$var$parseSwizzle(props).split('').sort().join('');
const $d5b7ee61758b2e81$var$shaderNodeHandler = {
    setup (NodeClosure, params) {
        const inputs = params.shift();
        return NodeClosure($d5b7ee61758b2e81$export$773e99721425b3b3(inputs), ...params);
    },
    get (node, prop, nodeObj) {
        if (typeof prop === 'string' && node[prop] === undefined) {
            if (node.isStackNode !== true && prop === 'assign') return (...params)=>{
                $d5b7ee61758b2e81$var$currentStack.assign(nodeObj, ...params);
                return nodeObj;
            };
            else if ($d5b7ee61758b2e81$var$NodeElements.has(prop)) {
                const nodeElement = $d5b7ee61758b2e81$var$NodeElements.get(prop);
                return node.isStackNode ? (...params)=>nodeObj.add(nodeElement(...params)) : (...params)=>nodeElement(nodeObj, ...params);
            } else if (prop === 'self') return node;
            else if (prop.endsWith('Assign') && $d5b7ee61758b2e81$var$NodeElements.has(prop.slice(0, prop.length - 6))) {
                const nodeElement = $d5b7ee61758b2e81$var$NodeElements.get(prop.slice(0, prop.length - 6));
                return node.isStackNode ? (...params)=>nodeObj.assign(params[0], nodeElement(...params)) : (...params)=>nodeObj.assign(nodeElement(nodeObj, ...params));
            } else if (/^[xyzwrgbastpq]{1,4}$/.test(prop) === true) {
                // accessing properties ( swizzle )
                prop = $d5b7ee61758b2e81$var$parseSwizzle(prop);
                return $d5b7ee61758b2e81$export$e97474e17004dd41(new (0, $070976a081d0afc6$export$2e2bcd8739ae039)(nodeObj, prop));
            } else if (/^set[XYZWRGBASTPQ]{1,4}$/.test(prop) === true) {
                // set properties ( swizzle ) and sort to xyzw sequence
                prop = $d5b7ee61758b2e81$var$parseSwizzleAndSort(prop.slice(3).toLowerCase());
                return (value)=>$d5b7ee61758b2e81$export$e97474e17004dd41(new (0, $9dedb40d2bc52c7c$export$2e2bcd8739ae039)(node, prop, value));
            } else if (/^flip[XYZWRGBASTPQ]{1,4}$/.test(prop) === true) {
                // set properties ( swizzle ) and sort to xyzw sequence
                prop = $d5b7ee61758b2e81$var$parseSwizzleAndSort(prop.slice(4).toLowerCase());
                return ()=>$d5b7ee61758b2e81$export$e97474e17004dd41(new (0, $8a6f7deed1444fde$export$2e2bcd8739ae039)($d5b7ee61758b2e81$export$e97474e17004dd41(node), prop));
            } else if (prop === 'width' || prop === 'height' || prop === 'depth') {
                // accessing property
                if (prop === 'width') prop = 'x';
                else if (prop === 'height') prop = 'y';
                else if (prop === 'depth') prop = 'z';
                return $d5b7ee61758b2e81$export$e97474e17004dd41(new (0, $070976a081d0afc6$export$2e2bcd8739ae039)(node, prop));
            } else if (/^\d+$/.test(prop) === true) // accessing array
            return $d5b7ee61758b2e81$export$e97474e17004dd41(new (0, $e2cc991ce11e1c78$export$2e2bcd8739ae039)(nodeObj, new (0, $e08750ac28014382$export$2e2bcd8739ae039)(Number(prop), 'uint')));
        }
        return Reflect.get(node, prop, nodeObj);
    },
    set (node, prop, value, nodeObj) {
        if (typeof prop === 'string' && node[prop] === undefined) // setting properties
        {
            if (/^[xyzwrgbastpq]{1,4}$/.test(prop) === true || prop === 'width' || prop === 'height' || prop === 'depth' || /^\d+$/.test(prop) === true) {
                nodeObj[prop].assign(value);
                return true;
            }
        }
        return Reflect.set(node, prop, value, nodeObj);
    }
};
const $d5b7ee61758b2e81$var$nodeObjectsCacheMap = new WeakMap();
const $d5b7ee61758b2e81$var$nodeBuilderFunctionsCacheMap = new WeakMap();
const $d5b7ee61758b2e81$var$ShaderNodeObject = function(obj, altType = null) {
    const type = (0, $97d1d441621670a9$export$cc7ab17e03dab419)(obj);
    if (type === 'node') {
        let nodeObject = $d5b7ee61758b2e81$var$nodeObjectsCacheMap.get(obj);
        if (nodeObject === undefined) {
            nodeObject = new Proxy(obj, $d5b7ee61758b2e81$var$shaderNodeHandler);
            $d5b7ee61758b2e81$var$nodeObjectsCacheMap.set(obj, nodeObject);
            $d5b7ee61758b2e81$var$nodeObjectsCacheMap.set(nodeObject, nodeObject);
        }
        return nodeObject;
    } else if (altType === null && (type === 'float' || type === 'boolean') || type && type !== 'shader' && type !== 'string') return $d5b7ee61758b2e81$export$e97474e17004dd41($d5b7ee61758b2e81$var$getConstNode(obj, altType));
    else if (type === 'shader') return $d5b7ee61758b2e81$export$b076717d71a1a47f(obj);
    return obj;
};
const $d5b7ee61758b2e81$var$ShaderNodeObjects = function(objects, altType = null) {
    for(const name in objects)objects[name] = $d5b7ee61758b2e81$export$e97474e17004dd41(objects[name], altType);
    return objects;
};
const $d5b7ee61758b2e81$var$ShaderNodeArray = function(array, altType = null) {
    const len = array.length;
    for(let i = 0; i < len; i++)array[i] = $d5b7ee61758b2e81$export$e97474e17004dd41(array[i], altType);
    return array;
};
const $d5b7ee61758b2e81$var$ShaderNodeProxy = function(NodeClass, scope = null, factor = null, settings = null) {
    const assignNode = (node)=>$d5b7ee61758b2e81$export$e97474e17004dd41(settings !== null ? Object.assign(node, settings) : node);
    if (scope === null) return (...params)=>{
        return assignNode(new NodeClass(...$d5b7ee61758b2e81$export$34baf9226cd3d576(params)));
    };
    else if (factor !== null) {
        factor = $d5b7ee61758b2e81$export$e97474e17004dd41(factor);
        return (...params)=>{
            return assignNode(new NodeClass(scope, ...$d5b7ee61758b2e81$export$34baf9226cd3d576(params), factor));
        };
    } else return (...params)=>{
        return assignNode(new NodeClass(scope, ...$d5b7ee61758b2e81$export$34baf9226cd3d576(params)));
    };
};
const $d5b7ee61758b2e81$var$ShaderNodeImmutable = function(NodeClass, ...params) {
    return $d5b7ee61758b2e81$export$e97474e17004dd41(new NodeClass(...$d5b7ee61758b2e81$export$34baf9226cd3d576(params)));
};
class $d5b7ee61758b2e81$var$ShaderCallNodeInternal extends (0, $65e77d5c3a27a66a$export$2e2bcd8739ae039) {
    constructor(shaderNode, inputNodes){
        super();
        this.shaderNode = shaderNode;
        this.inputNodes = inputNodes;
    }
    getNodeType(builder) {
        return this.shaderNode.nodeType || this.getOutputNode(builder).getNodeType(builder);
    }
    call(builder) {
        const { shaderNode: shaderNode, inputNodes: inputNodes } = this;
        const properties = builder.getNodeProperties(shaderNode);
        if (properties.onceOutput) return properties.onceOutput;
        //
        let result = null;
        if (shaderNode.layout) {
            let functionNodesCacheMap = $d5b7ee61758b2e81$var$nodeBuilderFunctionsCacheMap.get(builder.constructor);
            if (functionNodesCacheMap === undefined) {
                functionNodesCacheMap = new WeakMap();
                $d5b7ee61758b2e81$var$nodeBuilderFunctionsCacheMap.set(builder.constructor, functionNodesCacheMap);
            }
            let functionNode = functionNodesCacheMap.get(shaderNode);
            if (functionNode === undefined) {
                functionNode = $d5b7ee61758b2e81$export$e97474e17004dd41(builder.buildFunctionNode(shaderNode));
                functionNodesCacheMap.set(shaderNode, functionNode);
            }
            if (builder.currentFunctionNode !== null) builder.currentFunctionNode.includes.push(functionNode);
            result = $d5b7ee61758b2e81$export$e97474e17004dd41(functionNode.call(inputNodes));
        } else {
            const jsFunc = shaderNode.jsFunc;
            const outputNode = inputNodes !== null ? jsFunc(inputNodes, builder) : jsFunc(builder);
            result = $d5b7ee61758b2e81$export$e97474e17004dd41(outputNode);
        }
        if (shaderNode.once) properties.onceOutput = result;
        return result;
    }
    getOutputNode(builder) {
        const properties = builder.getNodeProperties(this);
        if (properties.outputNode === null) properties.outputNode = this.setupOutput(builder);
        return properties.outputNode;
    }
    setup(builder) {
        return this.getOutputNode(builder);
    }
    setupOutput(builder) {
        builder.addStack();
        builder.stack.outputNode = this.call(builder);
        return builder.removeStack();
    }
    generate(builder, output) {
        const outputNode = this.getOutputNode(builder);
        return outputNode.build(builder, output);
    }
}
class $d5b7ee61758b2e81$var$ShaderNodeInternal extends (0, $65e77d5c3a27a66a$export$2e2bcd8739ae039) {
    constructor(jsFunc, nodeType){
        super(nodeType);
        this.jsFunc = jsFunc;
        this.layout = null;
        this.global = true;
        this.once = false;
    }
    setLayout(layout) {
        this.layout = layout;
        return this;
    }
    call(inputs = null) {
        $d5b7ee61758b2e81$export$773e99721425b3b3(inputs);
        return $d5b7ee61758b2e81$export$e97474e17004dd41(new $d5b7ee61758b2e81$var$ShaderCallNodeInternal(this, inputs));
    }
    setup() {
        return this.call();
    }
}
const $d5b7ee61758b2e81$var$bools = [
    false,
    true
];
const $d5b7ee61758b2e81$var$uints = [
    0,
    1,
    2,
    3
];
const $d5b7ee61758b2e81$var$ints = [
    -1,
    -2
];
const $d5b7ee61758b2e81$var$floats = [
    0.5,
    1.5,
    1 / 3,
    1e-6,
    1e6,
    Math.PI,
    Math.PI * 2,
    1 / Math.PI,
    2 / Math.PI,
    1 / (Math.PI * 2),
    Math.PI / 2
];
const $d5b7ee61758b2e81$var$boolsCacheMap = new Map();
for (const bool of $d5b7ee61758b2e81$var$bools)$d5b7ee61758b2e81$var$boolsCacheMap.set(bool, new (0, $e08750ac28014382$export$2e2bcd8739ae039)(bool));
const $d5b7ee61758b2e81$var$uintsCacheMap = new Map();
for (const uint of $d5b7ee61758b2e81$var$uints)$d5b7ee61758b2e81$var$uintsCacheMap.set(uint, new (0, $e08750ac28014382$export$2e2bcd8739ae039)(uint, 'uint'));
const $d5b7ee61758b2e81$var$intsCacheMap = new Map([
    ...$d5b7ee61758b2e81$var$uintsCacheMap
].map((el)=>new (0, $e08750ac28014382$export$2e2bcd8739ae039)(el.value, 'int')));
for (const int of $d5b7ee61758b2e81$var$ints)$d5b7ee61758b2e81$var$intsCacheMap.set(int, new (0, $e08750ac28014382$export$2e2bcd8739ae039)(int, 'int'));
const $d5b7ee61758b2e81$var$floatsCacheMap = new Map([
    ...$d5b7ee61758b2e81$var$intsCacheMap
].map((el)=>new (0, $e08750ac28014382$export$2e2bcd8739ae039)(el.value)));
for (const float of $d5b7ee61758b2e81$var$floats)$d5b7ee61758b2e81$var$floatsCacheMap.set(float, new (0, $e08750ac28014382$export$2e2bcd8739ae039)(float));
for (const float of $d5b7ee61758b2e81$var$floats)$d5b7ee61758b2e81$var$floatsCacheMap.set(-float, new (0, $e08750ac28014382$export$2e2bcd8739ae039)(-float));
const $d5b7ee61758b2e81$var$cacheMaps = {
    bool: $d5b7ee61758b2e81$var$boolsCacheMap,
    uint: $d5b7ee61758b2e81$var$uintsCacheMap,
    ints: $d5b7ee61758b2e81$var$intsCacheMap,
    float: $d5b7ee61758b2e81$var$floatsCacheMap
};
const $d5b7ee61758b2e81$var$constNodesCacheMap = new Map([
    ...$d5b7ee61758b2e81$var$boolsCacheMap,
    ...$d5b7ee61758b2e81$var$floatsCacheMap
]);
const $d5b7ee61758b2e81$var$getConstNode = (value, type)=>{
    if ($d5b7ee61758b2e81$var$constNodesCacheMap.has(value)) return $d5b7ee61758b2e81$var$constNodesCacheMap.get(value);
    else if (value.isNode === true) return value;
    else return new (0, $e08750ac28014382$export$2e2bcd8739ae039)(value, type);
};
const $d5b7ee61758b2e81$var$safeGetNodeType = (node)=>{
    try {
        return node.getNodeType();
    } catch (_) {
        return undefined;
    }
};
const $d5b7ee61758b2e81$var$ConvertType = function(type, cacheMap = null) {
    return (...params)=>{
        if (params.length === 0 || ![
            'bool',
            'float',
            'int',
            'uint'
        ].includes(type) && params.every((param)=>typeof param !== 'object')) params = [
            (0, $97d1d441621670a9$export$64e17ccd4a503243)(type, ...params)
        ];
        if (params.length === 1 && cacheMap !== null && cacheMap.has(params[0])) return $d5b7ee61758b2e81$export$e97474e17004dd41(cacheMap.get(params[0]));
        if (params.length === 1) {
            const node = $d5b7ee61758b2e81$var$getConstNode(params[0], type);
            if ($d5b7ee61758b2e81$var$safeGetNodeType(node) === type) return $d5b7ee61758b2e81$export$e97474e17004dd41(node);
            return $d5b7ee61758b2e81$export$e97474e17004dd41(new (0, $0a2bbf7681f41101$export$2e2bcd8739ae039)(node, type));
        }
        const nodes = params.map((param)=>$d5b7ee61758b2e81$var$getConstNode(param));
        return $d5b7ee61758b2e81$export$e97474e17004dd41(new (0, $35624d68ea2463e8$export$2e2bcd8739ae039)(nodes, type));
    };
};
const $d5b7ee61758b2e81$export$43f40ad3fa1d5c97 = (v)=>typeof v === 'object' && v !== null ? v.value : v; // TODO: remove boolean conversion and defined function
const $d5b7ee61758b2e81$export$e11e4dd774259665 = (value)=>value !== undefined && value !== null ? value.nodeType || value.convertTo || (typeof value === 'string' ? value : null) : null;
function $d5b7ee61758b2e81$export$7d95ef31865f68e8(jsFunc, nodeType) {
    return new Proxy(new $d5b7ee61758b2e81$var$ShaderNodeInternal(jsFunc, nodeType), $d5b7ee61758b2e81$var$shaderNodeHandler);
}
const $d5b7ee61758b2e81$export$e97474e17004dd41 = (val, altType = null)=>/* new */ $d5b7ee61758b2e81$var$ShaderNodeObject(val, altType);
const $d5b7ee61758b2e81$export$773e99721425b3b3 = (val, altType = null)=>new $d5b7ee61758b2e81$var$ShaderNodeObjects(val, altType);
const $d5b7ee61758b2e81$export$34baf9226cd3d576 = (val, altType = null)=>new $d5b7ee61758b2e81$var$ShaderNodeArray(val, altType);
const $d5b7ee61758b2e81$export$60d11c6747b7deba = (...params)=>new $d5b7ee61758b2e81$var$ShaderNodeProxy(...params);
const $d5b7ee61758b2e81$export$25c7ddd7ae9b45f3 = (...params)=>new $d5b7ee61758b2e81$var$ShaderNodeImmutable(...params);
const $d5b7ee61758b2e81$export$b076717d71a1a47f = (jsFunc, nodeType)=>{
    const shaderNode = new $d5b7ee61758b2e81$export$7d95ef31865f68e8(jsFunc, nodeType);
    const fn = (...params)=>{
        let inputs;
        $d5b7ee61758b2e81$export$773e99721425b3b3(params);
        if (params[0] && params[0].isNode) inputs = [
            ...params
        ];
        else inputs = params[0];
        return shaderNode.call(inputs);
    };
    fn.shaderNode = shaderNode;
    fn.setLayout = (layout)=>{
        shaderNode.setLayout(layout);
        return fn;
    };
    fn.once = ()=>{
        shaderNode.once = true;
        return fn;
    };
    return fn;
};
const $d5b7ee61758b2e81$export$ab8c2ade1f37d88b = (...params)=>{
    console.warn('TSL.ShaderNode: tslFn() has been renamed to Fn().');
    return $d5b7ee61758b2e81$export$b076717d71a1a47f(...params);
};
//
$d5b7ee61758b2e81$export$5f439e138e9dc985('toGlobal', (node)=>{
    node.global = true;
    return node;
});
const $d5b7ee61758b2e81$export$50a78b1c198bcc62 = (stack)=>{
    $d5b7ee61758b2e81$var$currentStack = stack;
};
const $d5b7ee61758b2e81$export$c3090653b26dfebd = ()=>$d5b7ee61758b2e81$var$currentStack;
const $d5b7ee61758b2e81$export$1f9ff5f4a6c9361a = (...params)=>$d5b7ee61758b2e81$var$currentStack.If(...params);
function $d5b7ee61758b2e81$export$10d8903dec122b9d(node) {
    if ($d5b7ee61758b2e81$var$currentStack) $d5b7ee61758b2e81$var$currentStack.add(node);
    return node;
}
$d5b7ee61758b2e81$export$5f439e138e9dc985('append', $d5b7ee61758b2e81$export$10d8903dec122b9d);
const $d5b7ee61758b2e81$export$35e9368ef982300f = new $d5b7ee61758b2e81$var$ConvertType('color');
const $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab = new $d5b7ee61758b2e81$var$ConvertType('float', $d5b7ee61758b2e81$var$cacheMaps.float);
const $d5b7ee61758b2e81$export$7d260a2a5f8bc19e = new $d5b7ee61758b2e81$var$ConvertType('int', $d5b7ee61758b2e81$var$cacheMaps.ints);
const $d5b7ee61758b2e81$export$877455b195f03b92 = new $d5b7ee61758b2e81$var$ConvertType('uint', $d5b7ee61758b2e81$var$cacheMaps.uint);
const $d5b7ee61758b2e81$export$87b259aa03e3d267 = new $d5b7ee61758b2e81$var$ConvertType('bool', $d5b7ee61758b2e81$var$cacheMaps.bool);
const $d5b7ee61758b2e81$export$e9830bc863290a54 = new $d5b7ee61758b2e81$var$ConvertType('vec2');
const $d5b7ee61758b2e81$export$63e666f6a33be288 = new $d5b7ee61758b2e81$var$ConvertType('ivec2');
const $d5b7ee61758b2e81$export$7adaa2be14210750 = new $d5b7ee61758b2e81$var$ConvertType('uvec2');
const $d5b7ee61758b2e81$export$c94f17737369dd81 = new $d5b7ee61758b2e81$var$ConvertType('bvec2');
const $d5b7ee61758b2e81$export$9100789c9d999364 = new $d5b7ee61758b2e81$var$ConvertType('vec3');
const $d5b7ee61758b2e81$export$6003f6943477580f = new $d5b7ee61758b2e81$var$ConvertType('ivec3');
const $d5b7ee61758b2e81$export$bffc171a9468d831 = new $d5b7ee61758b2e81$var$ConvertType('uvec3');
const $d5b7ee61758b2e81$export$625ee0a1e433837e = new $d5b7ee61758b2e81$var$ConvertType('bvec3');
const $d5b7ee61758b2e81$export$6dba2a1f0d609415 = new $d5b7ee61758b2e81$var$ConvertType('vec4');
const $d5b7ee61758b2e81$export$6b0d90284264dffe = new $d5b7ee61758b2e81$var$ConvertType('ivec4');
const $d5b7ee61758b2e81$export$396e55cb3570606 = new $d5b7ee61758b2e81$var$ConvertType('uvec4');
const $d5b7ee61758b2e81$export$a7659f48478e8245 = new $d5b7ee61758b2e81$var$ConvertType('bvec4');
const $d5b7ee61758b2e81$export$f7543b5409a93c6b = new $d5b7ee61758b2e81$var$ConvertType('mat2');
const $d5b7ee61758b2e81$export$e43bd9f504e4ac00 = new $d5b7ee61758b2e81$var$ConvertType('mat3');
const $d5b7ee61758b2e81$export$d2b4acf069bf09f5 = new $d5b7ee61758b2e81$var$ConvertType('mat4');
const $d5b7ee61758b2e81$export$22b082955e083ec3 = (value = '')=>$d5b7ee61758b2e81$export$e97474e17004dd41(new (0, $e08750ac28014382$export$2e2bcd8739ae039)(value, 'string'));
const $d5b7ee61758b2e81$export$f57200da856d736b = (value)=>$d5b7ee61758b2e81$export$e97474e17004dd41(new (0, $e08750ac28014382$export$2e2bcd8739ae039)(value, 'ArrayBuffer'));
$d5b7ee61758b2e81$export$5f439e138e9dc985('toColor', $d5b7ee61758b2e81$export$35e9368ef982300f);
$d5b7ee61758b2e81$export$5f439e138e9dc985('toFloat', $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab);
$d5b7ee61758b2e81$export$5f439e138e9dc985('toInt', $d5b7ee61758b2e81$export$7d260a2a5f8bc19e);
$d5b7ee61758b2e81$export$5f439e138e9dc985('toUint', $d5b7ee61758b2e81$export$877455b195f03b92);
$d5b7ee61758b2e81$export$5f439e138e9dc985('toBool', $d5b7ee61758b2e81$export$87b259aa03e3d267);
$d5b7ee61758b2e81$export$5f439e138e9dc985('toVec2', $d5b7ee61758b2e81$export$e9830bc863290a54);
$d5b7ee61758b2e81$export$5f439e138e9dc985('toIVec2', $d5b7ee61758b2e81$export$63e666f6a33be288);
$d5b7ee61758b2e81$export$5f439e138e9dc985('toUVec2', $d5b7ee61758b2e81$export$7adaa2be14210750);
$d5b7ee61758b2e81$export$5f439e138e9dc985('toBVec2', $d5b7ee61758b2e81$export$c94f17737369dd81);
$d5b7ee61758b2e81$export$5f439e138e9dc985('toVec3', $d5b7ee61758b2e81$export$9100789c9d999364);
$d5b7ee61758b2e81$export$5f439e138e9dc985('toIVec3', $d5b7ee61758b2e81$export$6003f6943477580f);
$d5b7ee61758b2e81$export$5f439e138e9dc985('toUVec3', $d5b7ee61758b2e81$export$bffc171a9468d831);
$d5b7ee61758b2e81$export$5f439e138e9dc985('toBVec3', $d5b7ee61758b2e81$export$625ee0a1e433837e);
$d5b7ee61758b2e81$export$5f439e138e9dc985('toVec4', $d5b7ee61758b2e81$export$6dba2a1f0d609415);
$d5b7ee61758b2e81$export$5f439e138e9dc985('toIVec4', $d5b7ee61758b2e81$export$6b0d90284264dffe);
$d5b7ee61758b2e81$export$5f439e138e9dc985('toUVec4', $d5b7ee61758b2e81$export$396e55cb3570606);
$d5b7ee61758b2e81$export$5f439e138e9dc985('toBVec4', $d5b7ee61758b2e81$export$a7659f48478e8245);
$d5b7ee61758b2e81$export$5f439e138e9dc985('toMat2', $d5b7ee61758b2e81$export$f7543b5409a93c6b);
$d5b7ee61758b2e81$export$5f439e138e9dc985('toMat3', $d5b7ee61758b2e81$export$e43bd9f504e4ac00);
$d5b7ee61758b2e81$export$5f439e138e9dc985('toMat4', $d5b7ee61758b2e81$export$d2b4acf069bf09f5);
const $d5b7ee61758b2e81$export$8454457683f90105 = /*@__PURE__*/ $d5b7ee61758b2e81$export$60d11c6747b7deba((0, $e2cc991ce11e1c78$export$2e2bcd8739ae039));
const $d5b7ee61758b2e81$export$9c68d69a4c5bbcf9 = (node, types)=>$d5b7ee61758b2e81$export$e97474e17004dd41(new (0, $0a2bbf7681f41101$export$2e2bcd8739ae039)($d5b7ee61758b2e81$export$e97474e17004dd41(node), types));
const $d5b7ee61758b2e81$export$65980d18b75784e2 = (node, channels)=>$d5b7ee61758b2e81$export$e97474e17004dd41(new (0, $070976a081d0afc6$export$2e2bcd8739ae039)($d5b7ee61758b2e81$export$e97474e17004dd41(node), channels));
$d5b7ee61758b2e81$export$5f439e138e9dc985('element', $d5b7ee61758b2e81$export$8454457683f90105);
$d5b7ee61758b2e81$export$5f439e138e9dc985('convert', $d5b7ee61758b2e81$export$9c68d69a4c5bbcf9);



class $cac47bfa39311720$var$AssignNode extends (0, $75c45ed2361c955f$export$2e2bcd8739ae039) {
    static get type() {
        return 'AssignNode';
    }
    constructor(targetNode, sourceNode){
        super();
        this.targetNode = targetNode;
        this.sourceNode = sourceNode;
    }
    hasDependencies() {
        return false;
    }
    getNodeType(builder, output) {
        return output !== 'void' ? this.targetNode.getNodeType(builder) : 'void';
    }
    needsSplitAssign(builder) {
        const { targetNode: targetNode } = this;
        if (builder.isAvailable('swizzleAssign') === false && targetNode.isSplitNode && targetNode.components.length > 1) {
            const targetLength = builder.getTypeLength(targetNode.node.getNodeType(builder));
            const assignDiferentVector = (0, $ddcfecb7fbba5d74$export$1c0adcb9073b646d).join('').slice(0, targetLength) !== targetNode.components;
            return assignDiferentVector;
        }
        return false;
    }
    generate(builder, output) {
        const { targetNode: targetNode, sourceNode: sourceNode } = this;
        const needsSplitAssign = this.needsSplitAssign(builder);
        const targetType = targetNode.getNodeType(builder);
        const target = targetNode.context({
            assign: true
        }).build(builder);
        const source = sourceNode.build(builder, targetType);
        const sourceType = sourceNode.getNodeType(builder);
        const nodeData = builder.getDataFromNode(this);
        //
        let snippet;
        if (nodeData.initialized === true) {
            if (output !== 'void') snippet = target;
        } else if (needsSplitAssign) {
            const sourceVar = builder.getVarFromNode(this, null, targetType);
            const sourceProperty = builder.getPropertyName(sourceVar);
            builder.addLineFlowCode(`${sourceProperty} = ${source}`, this);
            const targetRoot = targetNode.node.context({
                assign: true
            }).build(builder);
            for(let i = 0; i < targetNode.components.length; i++){
                const component = targetNode.components[i];
                builder.addLineFlowCode(`${targetRoot}.${component} = ${sourceProperty}[ ${i} ]`, this);
            }
            if (output !== 'void') snippet = target;
        } else {
            snippet = `${target} = ${source}`;
            if (output === 'void' || sourceType === 'void') {
                builder.addLineFlowCode(snippet, this);
                if (output !== 'void') snippet = target;
            }
        }
        nodeData.initialized = true;
        return builder.format(snippet, targetType, output);
    }
}
var $cac47bfa39311720$export$2e2bcd8739ae039 = $cac47bfa39311720$var$AssignNode;
const $cac47bfa39311720$export$e6e34fd1f2686227 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$60d11c6747b7deba)($cac47bfa39311720$var$AssignNode);
(0, $d5b7ee61758b2e81$export$5f439e138e9dc985)('assign', $cac47bfa39311720$export$e6e34fd1f2686227);



// Non-PURE exports list, side-effects are required here.
// TSL Base Syntax



class $d2c0f7c752a63c18$var$UniformGroupNode extends (0, $65e77d5c3a27a66a$export$2e2bcd8739ae039) {
    static get type() {
        return 'UniformGroupNode';
    }
    constructor(name, shared = false, order = 1){
        super('string');
        this.name = name;
        this.version = 0;
        this.shared = shared;
        this.order = order;
        this.isUniformGroup = true;
    }
    set needsUpdate(value) {
        if (value === true) this.version++;
    }
    serialize(data) {
        super.serialize(data);
        data.name = this.name;
        data.version = this.version;
        data.shared = this.shared;
    }
    deserialize(data) {
        super.deserialize(data);
        this.name = data.name;
        this.version = data.version;
        this.shared = data.shared;
    }
}
var $d2c0f7c752a63c18$export$2e2bcd8739ae039 = $d2c0f7c752a63c18$var$UniformGroupNode;
const $d2c0f7c752a63c18$export$4981c76a74b9d345 = (name)=>new $d2c0f7c752a63c18$var$UniformGroupNode(name);
const $d2c0f7c752a63c18$export$f3cd358870d02e31 = (name, order = 0)=>new $d2c0f7c752a63c18$var$UniformGroupNode(name, true, order);
const $d2c0f7c752a63c18$export$654c8c9e57a353a5 = /*@__PURE__*/ $d2c0f7c752a63c18$export$f3cd358870d02e31('frame');
const $d2c0f7c752a63c18$export$a75a8692b47c7f9e = /*@__PURE__*/ $d2c0f7c752a63c18$export$f3cd358870d02e31('render');
const $d2c0f7c752a63c18$export$6a2a415f960d3137 = /*@__PURE__*/ $d2c0f7c752a63c18$export$4981c76a74b9d345('object');



class $5eb92bf12e57daab$var$UniformNode extends (0, $87507ebf571fbdf4$export$2e2bcd8739ae039) {
    static get type() {
        return 'UniformNode';
    }
    constructor(value, nodeType = null){
        super(value, nodeType);
        this.isUniformNode = true;
        this.name = '';
        this.groupNode = (0, $d2c0f7c752a63c18$export$6a2a415f960d3137);
    }
    label(name) {
        this.name = name;
        return this;
    }
    setGroup(group) {
        this.groupNode = group;
        return this;
    }
    getGroup() {
        return this.groupNode;
    }
    getUniformHash(builder) {
        return this.getHash(builder);
    }
    onUpdate(callback, updateType) {
        const self = this.getSelf();
        callback = callback.bind(self);
        return super.onUpdate((frame)=>{
            const value = callback(frame, self);
            if (value !== undefined) this.value = value;
        }, updateType);
    }
    generate(builder, output) {
        const type = this.getNodeType(builder);
        const hash = this.getUniformHash(builder);
        let sharedNode = builder.getNodeFromHash(hash);
        if (sharedNode === undefined) {
            builder.setHashNode(this, hash);
            sharedNode = this;
        }
        const sharedNodeType = sharedNode.getInputType(builder);
        const nodeUniform = builder.getUniformFromNode(sharedNode, sharedNodeType, builder.shaderStage, this.name || builder.context.label);
        const propertyName = builder.getPropertyName(nodeUniform);
        if (builder.context.label !== undefined) delete builder.context.label;
        return builder.format(propertyName, type, output);
    }
}
var $5eb92bf12e57daab$export$2e2bcd8739ae039 = $5eb92bf12e57daab$var$UniformNode;
const $5eb92bf12e57daab$export$379455b567eff87d = (arg1, arg2)=>{
    const nodeType = (0, $d5b7ee61758b2e81$export$e11e4dd774259665)(arg2 || arg1);
    // @TODO: get ConstNode from .traverse() in the future
    const value = arg1 && arg1.isNode === true ? arg1.node && arg1.node.value || arg1.value : arg1;
    return (0, $d5b7ee61758b2e81$export$e97474e17004dd41)(new $5eb92bf12e57daab$var$UniformNode(value, nodeType));
};




class $dd761eb0c8b88ca7$var$PropertyNode extends (0, $65e77d5c3a27a66a$export$2e2bcd8739ae039) {
    static get type() {
        return 'PropertyNode';
    }
    constructor(nodeType, name = null, varying = false){
        super(nodeType);
        this.name = name;
        this.varying = varying;
        this.isPropertyNode = true;
    }
    getHash(builder) {
        return this.name || super.getHash(builder);
    }
    isGlobal() {
        return true;
    }
    generate(builder) {
        let nodeVar;
        if (this.varying === true) {
            nodeVar = builder.getVaryingFromNode(this, this.name);
            nodeVar.needsInterpolation = true;
        } else nodeVar = builder.getVarFromNode(this, this.name);
        return builder.getPropertyName(nodeVar);
    }
}
var $dd761eb0c8b88ca7$export$2e2bcd8739ae039 = $dd761eb0c8b88ca7$var$PropertyNode;
const $dd761eb0c8b88ca7$export$d541bacb2bda4494 = (type, name)=>(0, $d5b7ee61758b2e81$export$e97474e17004dd41)(new $dd761eb0c8b88ca7$var$PropertyNode(type, name));
const $dd761eb0c8b88ca7$export$cb5f8cbf8b7bd600 = (type, name)=>(0, $d5b7ee61758b2e81$export$e97474e17004dd41)(new $dd761eb0c8b88ca7$var$PropertyNode(type, name, true));
const $dd761eb0c8b88ca7$export$3a790f19f33c5176 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$25c7ddd7ae9b45f3)($dd761eb0c8b88ca7$var$PropertyNode, 'vec4', 'DiffuseColor');
const $dd761eb0c8b88ca7$export$f0b29974073fef6 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$25c7ddd7ae9b45f3)($dd761eb0c8b88ca7$var$PropertyNode, 'vec3', 'EmissiveColor');
const $dd761eb0c8b88ca7$export$df3004878062a594 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$25c7ddd7ae9b45f3)($dd761eb0c8b88ca7$var$PropertyNode, 'float', 'Roughness');
const $dd761eb0c8b88ca7$export$a0ae10b9403517f8 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$25c7ddd7ae9b45f3)($dd761eb0c8b88ca7$var$PropertyNode, 'float', 'Metalness');
const $dd761eb0c8b88ca7$export$9b0829dedd347475 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$25c7ddd7ae9b45f3)($dd761eb0c8b88ca7$var$PropertyNode, 'float', 'Clearcoat');
const $dd761eb0c8b88ca7$export$2747d91296dfac86 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$25c7ddd7ae9b45f3)($dd761eb0c8b88ca7$var$PropertyNode, 'float', 'ClearcoatRoughness');
const $dd761eb0c8b88ca7$export$7cccf56baed94cee = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$25c7ddd7ae9b45f3)($dd761eb0c8b88ca7$var$PropertyNode, 'vec3', 'Sheen');
const $dd761eb0c8b88ca7$export$40c82d21b5c7315b = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$25c7ddd7ae9b45f3)($dd761eb0c8b88ca7$var$PropertyNode, 'float', 'SheenRoughness');
const $dd761eb0c8b88ca7$export$8fa8908d67be43df = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$25c7ddd7ae9b45f3)($dd761eb0c8b88ca7$var$PropertyNode, 'float', 'Iridescence');
const $dd761eb0c8b88ca7$export$e8f290002a000efa = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$25c7ddd7ae9b45f3)($dd761eb0c8b88ca7$var$PropertyNode, 'float', 'IridescenceIOR');
const $dd761eb0c8b88ca7$export$af4f9ca0bc04b1e = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$25c7ddd7ae9b45f3)($dd761eb0c8b88ca7$var$PropertyNode, 'float', 'IridescenceThickness');
const $dd761eb0c8b88ca7$export$6b527ce29f545f8c = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$25c7ddd7ae9b45f3)($dd761eb0c8b88ca7$var$PropertyNode, 'float', 'AlphaT');
const $dd761eb0c8b88ca7$export$13e470198a4f720a = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$25c7ddd7ae9b45f3)($dd761eb0c8b88ca7$var$PropertyNode, 'float', 'Anisotropy');
const $dd761eb0c8b88ca7$export$56937cc288fe4ea7 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$25c7ddd7ae9b45f3)($dd761eb0c8b88ca7$var$PropertyNode, 'vec3', 'AnisotropyT');
const $dd761eb0c8b88ca7$export$5748f3030096f448 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$25c7ddd7ae9b45f3)($dd761eb0c8b88ca7$var$PropertyNode, 'vec3', 'AnisotropyB');
const $dd761eb0c8b88ca7$export$e1aa5ee431e11795 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$25c7ddd7ae9b45f3)($dd761eb0c8b88ca7$var$PropertyNode, 'color', 'SpecularColor');
const $dd761eb0c8b88ca7$export$fa391975b9b85621 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$25c7ddd7ae9b45f3)($dd761eb0c8b88ca7$var$PropertyNode, 'float', 'SpecularF90');
const $dd761eb0c8b88ca7$export$245b4c35387657dc = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$25c7ddd7ae9b45f3)($dd761eb0c8b88ca7$var$PropertyNode, 'float', 'Shininess');
const $dd761eb0c8b88ca7$export$c789db2c85949867 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$25c7ddd7ae9b45f3)($dd761eb0c8b88ca7$var$PropertyNode, 'vec4', 'Output');
const $dd761eb0c8b88ca7$export$c295bac1d6792172 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$25c7ddd7ae9b45f3)($dd761eb0c8b88ca7$var$PropertyNode, 'float', 'dashSize');
const $dd761eb0c8b88ca7$export$146ecbc129c598d1 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$25c7ddd7ae9b45f3)($dd761eb0c8b88ca7$var$PropertyNode, 'float', 'gapSize');
const $dd761eb0c8b88ca7$export$4bc20e29148c4322 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$25c7ddd7ae9b45f3)($dd761eb0c8b88ca7$var$PropertyNode, 'float', 'pointWidth');
const $dd761eb0c8b88ca7$export$9b6d27e550bdd04d = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$25c7ddd7ae9b45f3)($dd761eb0c8b88ca7$var$PropertyNode, 'float', 'IOR');
const $dd761eb0c8b88ca7$export$48b427a8e82dea20 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$25c7ddd7ae9b45f3)($dd761eb0c8b88ca7$var$PropertyNode, 'float', 'Transmission');
const $dd761eb0c8b88ca7$export$70328e7fc5b512a3 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$25c7ddd7ae9b45f3)($dd761eb0c8b88ca7$var$PropertyNode, 'float', 'Thickness');
const $dd761eb0c8b88ca7$export$dfdcdac9ec5733ba = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$25c7ddd7ae9b45f3)($dd761eb0c8b88ca7$var$PropertyNode, 'float', 'AttenuationDistance');
const $dd761eb0c8b88ca7$export$4e929bebb52dac2c = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$25c7ddd7ae9b45f3)($dd761eb0c8b88ca7$var$PropertyNode, 'color', 'AttenuationColor');
const $dd761eb0c8b88ca7$export$6cf2c7e842feef4c = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$25c7ddd7ae9b45f3)($dd761eb0c8b88ca7$var$PropertyNode, 'float', 'Dispersion');





class $c278281764724505$var$FunctionCallNode extends (0, $75c45ed2361c955f$export$2e2bcd8739ae039) {
    static get type() {
        return 'FunctionCallNode';
    }
    constructor(functionNode = null, parameters = {}){
        super();
        this.functionNode = functionNode;
        this.parameters = parameters;
    }
    setParameters(parameters) {
        this.parameters = parameters;
        return this;
    }
    getParameters() {
        return this.parameters;
    }
    getNodeType(builder) {
        return this.functionNode.getNodeType(builder);
    }
    generate(builder) {
        const params = [];
        const functionNode = this.functionNode;
        const inputs = functionNode.getInputs(builder);
        const parameters = this.parameters;
        const generateInput = (node, inputNode)=>{
            const type = inputNode.type;
            const pointer = type === 'pointer';
            let output;
            if (pointer) output = '&' + node.build(builder);
            else output = node.build(builder, type);
            return output;
        };
        if (Array.isArray(parameters)) for(let i = 0; i < parameters.length; i++)params.push(generateInput(parameters[i], inputs[i]));
        else for (const inputNode of inputs){
            const node = parameters[inputNode.name];
            if (node !== undefined) params.push(generateInput(node, inputNode));
            else throw new Error(`FunctionCallNode: Input '${inputNode.name}' not found in FunctionNode.`);
        }
        const functionName = functionNode.build(builder, 'property');
        return `${functionName}( ${params.join(', ')} )`;
    }
}
var $c278281764724505$export$2e2bcd8739ae039 = $c278281764724505$var$FunctionCallNode;
const $c278281764724505$export$848feb93d8f32b9b = (func, ...params)=>{
    params = params.length > 1 || params[0] && params[0].isNode === true ? (0, $d5b7ee61758b2e81$export$34baf9226cd3d576)(params) : (0, $d5b7ee61758b2e81$export$773e99721425b3b3)(params[0]);
    return (0, $d5b7ee61758b2e81$export$e97474e17004dd41)(new $c278281764724505$var$FunctionCallNode((0, $d5b7ee61758b2e81$export$e97474e17004dd41)(func), params));
};
(0, $d5b7ee61758b2e81$export$5f439e138e9dc985)('call', $c278281764724505$export$848feb93d8f32b9b);




class $3f1f23fea79ae256$var$OperatorNode extends (0, $75c45ed2361c955f$export$2e2bcd8739ae039) {
    static get type() {
        return 'OperatorNode';
    }
    constructor(op, aNode, bNode, ...params){
        super();
        if (params.length > 0) {
            let finalOp = new $3f1f23fea79ae256$var$OperatorNode(op, aNode, bNode);
            for(let i = 0; i < params.length - 1; i++)finalOp = new $3f1f23fea79ae256$var$OperatorNode(op, finalOp, params[i]);
            aNode = finalOp;
            bNode = params[params.length - 1];
        }
        this.op = op;
        this.aNode = aNode;
        this.bNode = bNode;
    }
    getNodeType(builder, output) {
        const op = this.op;
        const aNode = this.aNode;
        const bNode = this.bNode;
        const typeA = aNode.getNodeType(builder);
        const typeB = typeof bNode !== 'undefined' ? bNode.getNodeType(builder) : null;
        if (typeA === 'void' || typeB === 'void') return 'void';
        else if (op === '%') return typeA;
        else if (op === '~' || op === '&' || op === '|' || op === '^' || op === '>>' || op === '<<') return builder.getIntegerType(typeA);
        else if (op === '!' || op === '==' || op === '&&' || op === '||' || op === '^^') return 'bool';
        else if (op === '<' || op === '>' || op === '<=' || op === '>=') {
            const typeLength = output ? builder.getTypeLength(output) : Math.max(builder.getTypeLength(typeA), builder.getTypeLength(typeB));
            return typeLength > 1 ? `bvec${typeLength}` : 'bool';
        } else {
            if (typeA === 'float' && builder.isMatrix(typeB)) return typeB;
            else if (builder.isMatrix(typeA) && builder.isVector(typeB)) // matrix x vector
            return builder.getVectorFromMatrix(typeA);
            else if (builder.isVector(typeA) && builder.isMatrix(typeB)) // vector x matrix
            return builder.getVectorFromMatrix(typeB);
            else if (builder.getTypeLength(typeB) > builder.getTypeLength(typeA)) // anytype x anytype: use the greater length vector
            return typeB;
            return typeA;
        }
    }
    generate(builder, output) {
        const op = this.op;
        const aNode = this.aNode;
        const bNode = this.bNode;
        const type = this.getNodeType(builder, output);
        let typeA = null;
        let typeB = null;
        if (type !== 'void') {
            typeA = aNode.getNodeType(builder);
            typeB = typeof bNode !== 'undefined' ? bNode.getNodeType(builder) : null;
            if (op === '<' || op === '>' || op === '<=' || op === '>=' || op === '==') {
                if (builder.isVector(typeA)) typeB = typeA;
                else if (typeA !== typeB) typeA = typeB = 'float';
            } else if (op === '>>' || op === '<<') {
                typeA = type;
                typeB = builder.changeComponentType(typeB, 'uint');
            } else if (builder.isMatrix(typeA) && builder.isVector(typeB)) // matrix x vector
            typeB = builder.getVectorFromMatrix(typeA);
            else if (builder.isVector(typeA) && builder.isMatrix(typeB)) // vector x matrix
            typeA = builder.getVectorFromMatrix(typeB);
            else // anytype x anytype
            typeA = typeB = type;
        } else typeA = typeB = type;
        const a = aNode.build(builder, typeA);
        const b = typeof bNode !== 'undefined' ? bNode.build(builder, typeB) : null;
        const outputLength = builder.getTypeLength(output);
        const fnOpSnippet = builder.getFunctionOperator(op);
        if (output !== 'void') {
            if (op === '<' && outputLength > 1) {
                if (builder.useComparisonMethod) return builder.format(`${builder.getMethod('lessThan', output)}( ${a}, ${b} )`, type, output);
                else return builder.format(`( ${a} < ${b} )`, type, output);
            } else if (op === '<=' && outputLength > 1) {
                if (builder.useComparisonMethod) return builder.format(`${builder.getMethod('lessThanEqual', output)}( ${a}, ${b} )`, type, output);
                else return builder.format(`( ${a} <= ${b} )`, type, output);
            } else if (op === '>' && outputLength > 1) {
                if (builder.useComparisonMethod) return builder.format(`${builder.getMethod('greaterThan', output)}( ${a}, ${b} )`, type, output);
                else return builder.format(`( ${a} > ${b} )`, type, output);
            } else if (op === '>=' && outputLength > 1) {
                if (builder.useComparisonMethod) return builder.format(`${builder.getMethod('greaterThanEqual', output)}( ${a}, ${b} )`, type, output);
                else return builder.format(`( ${a} >= ${b} )`, type, output);
            } else if (op === '!' || op === '~') return builder.format(`(${op}${a})`, typeA, output);
            else if (fnOpSnippet) return builder.format(`${fnOpSnippet}( ${a}, ${b} )`, type, output);
            else return builder.format(`( ${a} ${op} ${b} )`, type, output);
        } else if (typeA !== 'void') {
            if (fnOpSnippet) return builder.format(`${fnOpSnippet}( ${a}, ${b} )`, type, output);
            else return builder.format(`${a} ${op} ${b}`, type, output);
        }
    }
    serialize(data) {
        super.serialize(data);
        data.op = this.op;
    }
    deserialize(data) {
        super.deserialize(data);
        this.op = data.op;
    }
}
var $3f1f23fea79ae256$export$2e2bcd8739ae039 = $3f1f23fea79ae256$var$OperatorNode;
const $3f1f23fea79ae256$export$e16d8520af44a096 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$60d11c6747b7deba)($3f1f23fea79ae256$var$OperatorNode, '+');
const $3f1f23fea79ae256$export$f93b5905241a7cca = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$60d11c6747b7deba)($3f1f23fea79ae256$var$OperatorNode, '-');
const $3f1f23fea79ae256$export$6e3a27864ab166fe = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$60d11c6747b7deba)($3f1f23fea79ae256$var$OperatorNode, '*');
const $3f1f23fea79ae256$export$159d9494db57879b = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$60d11c6747b7deba)($3f1f23fea79ae256$var$OperatorNode, '/');
const $3f1f23fea79ae256$export$bbee620e367ce6fb = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$60d11c6747b7deba)($3f1f23fea79ae256$var$OperatorNode, '%');
const $3f1f23fea79ae256$export$411ce8e5a71e3069 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$60d11c6747b7deba)($3f1f23fea79ae256$var$OperatorNode, '==');
const $3f1f23fea79ae256$export$53a6892c50694894 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$60d11c6747b7deba)($3f1f23fea79ae256$var$OperatorNode, '!=');
const $3f1f23fea79ae256$export$9b050841a3a1b328 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$60d11c6747b7deba)($3f1f23fea79ae256$var$OperatorNode, '<');
const $3f1f23fea79ae256$export$f517ea36c68d4644 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$60d11c6747b7deba)($3f1f23fea79ae256$var$OperatorNode, '>');
const $3f1f23fea79ae256$export$b0b8c4c49050ecd0 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$60d11c6747b7deba)($3f1f23fea79ae256$var$OperatorNode, '<=');
const $3f1f23fea79ae256$export$b5f536bfcbb0f057 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$60d11c6747b7deba)($3f1f23fea79ae256$var$OperatorNode, '>=');
const $3f1f23fea79ae256$export$21c0ac7fe1cef1b8 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$60d11c6747b7deba)($3f1f23fea79ae256$var$OperatorNode, '&&');
const $3f1f23fea79ae256$export$252bb8b3bbdf6749 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$60d11c6747b7deba)($3f1f23fea79ae256$var$OperatorNode, '||');
const $3f1f23fea79ae256$export$6003a5f097c73977 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$60d11c6747b7deba)($3f1f23fea79ae256$var$OperatorNode, '!');
const $3f1f23fea79ae256$export$6444ef5cd411280c = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$60d11c6747b7deba)($3f1f23fea79ae256$var$OperatorNode, '^^');
const $3f1f23fea79ae256$export$a74ff8d3fdef72fc = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$60d11c6747b7deba)($3f1f23fea79ae256$var$OperatorNode, '&');
const $3f1f23fea79ae256$export$aabc449fa5b5f4c0 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$60d11c6747b7deba)($3f1f23fea79ae256$var$OperatorNode, '~');
const $3f1f23fea79ae256$export$361eb278cc70bacf = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$60d11c6747b7deba)($3f1f23fea79ae256$var$OperatorNode, '|');
const $3f1f23fea79ae256$export$bfcff4501301c191 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$60d11c6747b7deba)($3f1f23fea79ae256$var$OperatorNode, '^');
const $3f1f23fea79ae256$export$f613292be21d0bc3 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$60d11c6747b7deba)($3f1f23fea79ae256$var$OperatorNode, '<<');
const $3f1f23fea79ae256$export$86c449e29266e58a = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$60d11c6747b7deba)($3f1f23fea79ae256$var$OperatorNode, '>>');
(0, $d5b7ee61758b2e81$export$5f439e138e9dc985)('add', $3f1f23fea79ae256$export$e16d8520af44a096);
(0, $d5b7ee61758b2e81$export$5f439e138e9dc985)('sub', $3f1f23fea79ae256$export$f93b5905241a7cca);
(0, $d5b7ee61758b2e81$export$5f439e138e9dc985)('mul', $3f1f23fea79ae256$export$6e3a27864ab166fe);
(0, $d5b7ee61758b2e81$export$5f439e138e9dc985)('div', $3f1f23fea79ae256$export$159d9494db57879b);
(0, $d5b7ee61758b2e81$export$5f439e138e9dc985)('modInt', $3f1f23fea79ae256$export$bbee620e367ce6fb);
(0, $d5b7ee61758b2e81$export$5f439e138e9dc985)('equal', $3f1f23fea79ae256$export$411ce8e5a71e3069);
(0, $d5b7ee61758b2e81$export$5f439e138e9dc985)('notEqual', $3f1f23fea79ae256$export$53a6892c50694894);
(0, $d5b7ee61758b2e81$export$5f439e138e9dc985)('lessThan', $3f1f23fea79ae256$export$9b050841a3a1b328);
(0, $d5b7ee61758b2e81$export$5f439e138e9dc985)('greaterThan', $3f1f23fea79ae256$export$f517ea36c68d4644);
(0, $d5b7ee61758b2e81$export$5f439e138e9dc985)('lessThanEqual', $3f1f23fea79ae256$export$b0b8c4c49050ecd0);
(0, $d5b7ee61758b2e81$export$5f439e138e9dc985)('greaterThanEqual', $3f1f23fea79ae256$export$b5f536bfcbb0f057);
(0, $d5b7ee61758b2e81$export$5f439e138e9dc985)('and', $3f1f23fea79ae256$export$21c0ac7fe1cef1b8);
(0, $d5b7ee61758b2e81$export$5f439e138e9dc985)('or', $3f1f23fea79ae256$export$252bb8b3bbdf6749);
(0, $d5b7ee61758b2e81$export$5f439e138e9dc985)('not', $3f1f23fea79ae256$export$6003a5f097c73977);
(0, $d5b7ee61758b2e81$export$5f439e138e9dc985)('xor', $3f1f23fea79ae256$export$6444ef5cd411280c);
(0, $d5b7ee61758b2e81$export$5f439e138e9dc985)('bitAnd', $3f1f23fea79ae256$export$a74ff8d3fdef72fc);
(0, $d5b7ee61758b2e81$export$5f439e138e9dc985)('bitNot', $3f1f23fea79ae256$export$aabc449fa5b5f4c0);
(0, $d5b7ee61758b2e81$export$5f439e138e9dc985)('bitOr', $3f1f23fea79ae256$export$361eb278cc70bacf);
(0, $d5b7ee61758b2e81$export$5f439e138e9dc985)('bitXor', $3f1f23fea79ae256$export$bfcff4501301c191);
(0, $d5b7ee61758b2e81$export$5f439e138e9dc985)('shiftLeft', $3f1f23fea79ae256$export$f613292be21d0bc3);
(0, $d5b7ee61758b2e81$export$5f439e138e9dc985)('shiftRight', $3f1f23fea79ae256$export$86c449e29266e58a);
const $3f1f23fea79ae256$export$159037f780d3415c = (...params)=>{
    console.warn('TSL.OperatorNode: .remainder() has been renamed to .modInt().');
    return $3f1f23fea79ae256$export$bbee620e367ce6fb(...params);
};
(0, $d5b7ee61758b2e81$export$5f439e138e9dc985)('remainder', $3f1f23fea79ae256$export$159037f780d3415c);





class $f37ae0e58866c183$var$MathNode extends (0, $75c45ed2361c955f$export$2e2bcd8739ae039) {
    static get type() {
        return 'MathNode';
    }
    constructor(method, aNode, bNode = null, cNode = null){
        super();
        this.method = method;
        this.aNode = aNode;
        this.bNode = bNode;
        this.cNode = cNode;
    }
    getInputType(builder) {
        const aType = this.aNode.getNodeType(builder);
        const bType = this.bNode ? this.bNode.getNodeType(builder) : null;
        const cType = this.cNode ? this.cNode.getNodeType(builder) : null;
        const aLen = builder.isMatrix(aType) ? 0 : builder.getTypeLength(aType);
        const bLen = builder.isMatrix(bType) ? 0 : builder.getTypeLength(bType);
        const cLen = builder.isMatrix(cType) ? 0 : builder.getTypeLength(cType);
        if (aLen > bLen && aLen > cLen) return aType;
        else if (bLen > cLen) return bType;
        else if (cLen > aLen) return cType;
        return aType;
    }
    getNodeType(builder) {
        const method = this.method;
        if (method === $f37ae0e58866c183$var$MathNode.LENGTH || method === $f37ae0e58866c183$var$MathNode.DISTANCE || method === $f37ae0e58866c183$var$MathNode.DOT) return 'float';
        else if (method === $f37ae0e58866c183$var$MathNode.CROSS) return 'vec3';
        else if (method === $f37ae0e58866c183$var$MathNode.ALL) return 'bool';
        else if (method === $f37ae0e58866c183$var$MathNode.EQUALS) return builder.changeComponentType(this.aNode.getNodeType(builder), 'bool');
        else if (method === $f37ae0e58866c183$var$MathNode.MOD) return this.aNode.getNodeType(builder);
        else return this.getInputType(builder);
    }
    generate(builder, output) {
        const method = this.method;
        const type = this.getNodeType(builder);
        const inputType = this.getInputType(builder);
        const a = this.aNode;
        const b = this.bNode;
        const c = this.cNode;
        const isWebGL = builder.renderer.isWebGLRenderer === true;
        if (method === $f37ae0e58866c183$var$MathNode.TRANSFORM_DIRECTION) {
            // dir can be either a direction vector or a normal vector
            // upper-left 3x3 of matrix is assumed to be orthogonal
            let tA = a;
            let tB = b;
            if (builder.isMatrix(tA.getNodeType(builder))) tB = (0, $d5b7ee61758b2e81$export$6dba2a1f0d609415)((0, $d5b7ee61758b2e81$export$9100789c9d999364)(tB), 0.0);
            else tA = (0, $d5b7ee61758b2e81$export$6dba2a1f0d609415)((0, $d5b7ee61758b2e81$export$9100789c9d999364)(tA), 0.0);
            const mulNode = (0, $3f1f23fea79ae256$export$6e3a27864ab166fe)(tA, tB).xyz;
            return $f37ae0e58866c183$export$a3295358bff77e(mulNode).build(builder, output);
        } else if (method === $f37ae0e58866c183$var$MathNode.NEGATE) return builder.format('( - ' + a.build(builder, inputType) + ' )', type, output);
        else if (method === $f37ae0e58866c183$var$MathNode.ONE_MINUS) return (0, $3f1f23fea79ae256$export$f93b5905241a7cca)(1.0, a).build(builder, output);
        else if (method === $f37ae0e58866c183$var$MathNode.RECIPROCAL) return (0, $3f1f23fea79ae256$export$159d9494db57879b)(1.0, a).build(builder, output);
        else if (method === $f37ae0e58866c183$var$MathNode.DIFFERENCE) return $f37ae0e58866c183$export$2335f513bbd82c6d((0, $3f1f23fea79ae256$export$f93b5905241a7cca)(a, b)).build(builder, output);
        else {
            const params = [];
            if (method === $f37ae0e58866c183$var$MathNode.CROSS || method === $f37ae0e58866c183$var$MathNode.MOD) params.push(a.build(builder, type), b.build(builder, type));
            else if (isWebGL && method === $f37ae0e58866c183$var$MathNode.STEP) params.push(a.build(builder, builder.getTypeLength(a.getNodeType(builder)) === 1 ? 'float' : inputType), b.build(builder, inputType));
            else if (isWebGL && (method === $f37ae0e58866c183$var$MathNode.MIN || method === $f37ae0e58866c183$var$MathNode.MAX) || method === $f37ae0e58866c183$var$MathNode.MOD) params.push(a.build(builder, inputType), b.build(builder, builder.getTypeLength(b.getNodeType(builder)) === 1 ? 'float' : inputType));
            else if (method === $f37ae0e58866c183$var$MathNode.REFRACT) params.push(a.build(builder, inputType), b.build(builder, inputType), c.build(builder, 'float'));
            else if (method === $f37ae0e58866c183$var$MathNode.MIX) params.push(a.build(builder, inputType), b.build(builder, inputType), c.build(builder, builder.getTypeLength(c.getNodeType(builder)) === 1 ? 'float' : inputType));
            else {
                params.push(a.build(builder, inputType));
                if (b !== null) params.push(b.build(builder, inputType));
                if (c !== null) params.push(c.build(builder, inputType));
            }
            return builder.format(`${builder.getMethod(method, type)}( ${params.join(', ')} )`, type, output);
        }
    }
    serialize(data) {
        super.serialize(data);
        data.method = this.method;
    }
    deserialize(data) {
        super.deserialize(data);
        this.method = data.method;
    }
}
// 1 input
$f37ae0e58866c183$var$MathNode.ALL = 'all';
$f37ae0e58866c183$var$MathNode.ANY = 'any';
$f37ae0e58866c183$var$MathNode.EQUALS = 'equals';
$f37ae0e58866c183$var$MathNode.RADIANS = 'radians';
$f37ae0e58866c183$var$MathNode.DEGREES = 'degrees';
$f37ae0e58866c183$var$MathNode.EXP = 'exp';
$f37ae0e58866c183$var$MathNode.EXP2 = 'exp2';
$f37ae0e58866c183$var$MathNode.LOG = 'log';
$f37ae0e58866c183$var$MathNode.LOG2 = 'log2';
$f37ae0e58866c183$var$MathNode.SQRT = 'sqrt';
$f37ae0e58866c183$var$MathNode.INVERSE_SQRT = 'inversesqrt';
$f37ae0e58866c183$var$MathNode.FLOOR = 'floor';
$f37ae0e58866c183$var$MathNode.CEIL = 'ceil';
$f37ae0e58866c183$var$MathNode.NORMALIZE = 'normalize';
$f37ae0e58866c183$var$MathNode.FRACT = 'fract';
$f37ae0e58866c183$var$MathNode.SIN = 'sin';
$f37ae0e58866c183$var$MathNode.COS = 'cos';
$f37ae0e58866c183$var$MathNode.TAN = 'tan';
$f37ae0e58866c183$var$MathNode.ASIN = 'asin';
$f37ae0e58866c183$var$MathNode.ACOS = 'acos';
$f37ae0e58866c183$var$MathNode.ATAN = 'atan';
$f37ae0e58866c183$var$MathNode.ABS = 'abs';
$f37ae0e58866c183$var$MathNode.SIGN = 'sign';
$f37ae0e58866c183$var$MathNode.LENGTH = 'length';
$f37ae0e58866c183$var$MathNode.NEGATE = 'negate';
$f37ae0e58866c183$var$MathNode.ONE_MINUS = 'oneMinus';
$f37ae0e58866c183$var$MathNode.DFDX = 'dFdx';
$f37ae0e58866c183$var$MathNode.DFDY = 'dFdy';
$f37ae0e58866c183$var$MathNode.ROUND = 'round';
$f37ae0e58866c183$var$MathNode.RECIPROCAL = 'reciprocal';
$f37ae0e58866c183$var$MathNode.TRUNC = 'trunc';
$f37ae0e58866c183$var$MathNode.FWIDTH = 'fwidth';
$f37ae0e58866c183$var$MathNode.BITCAST = 'bitcast';
$f37ae0e58866c183$var$MathNode.TRANSPOSE = 'transpose';
// 2 inputs
$f37ae0e58866c183$var$MathNode.ATAN2 = 'atan2';
$f37ae0e58866c183$var$MathNode.MIN = 'min';
$f37ae0e58866c183$var$MathNode.MAX = 'max';
$f37ae0e58866c183$var$MathNode.MOD = 'mod';
$f37ae0e58866c183$var$MathNode.STEP = 'step';
$f37ae0e58866c183$var$MathNode.REFLECT = 'reflect';
$f37ae0e58866c183$var$MathNode.DISTANCE = 'distance';
$f37ae0e58866c183$var$MathNode.DIFFERENCE = 'difference';
$f37ae0e58866c183$var$MathNode.DOT = 'dot';
$f37ae0e58866c183$var$MathNode.CROSS = 'cross';
$f37ae0e58866c183$var$MathNode.POW = 'pow';
$f37ae0e58866c183$var$MathNode.TRANSFORM_DIRECTION = 'transformDirection';
// 3 inputs
$f37ae0e58866c183$var$MathNode.MIX = 'mix';
$f37ae0e58866c183$var$MathNode.CLAMP = 'clamp';
$f37ae0e58866c183$var$MathNode.REFRACT = 'refract';
$f37ae0e58866c183$var$MathNode.SMOOTHSTEP = 'smoothstep';
$f37ae0e58866c183$var$MathNode.FACEFORWARD = 'faceforward';
var $f37ae0e58866c183$export$2e2bcd8739ae039 = $f37ae0e58866c183$var$MathNode;
const $f37ae0e58866c183$export$fd293b15f47e270 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(1e-6);
const $f37ae0e58866c183$export$b4bf424ed968e242 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(1e6);
const $f37ae0e58866c183$export$6b5c1ceb16d01dc3 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(Math.PI);
const $f37ae0e58866c183$export$f4644083ce95e7e3 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(Math.PI * 2);
const $f37ae0e58866c183$export$84bf76cd7afc7469 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$60d11c6747b7deba)($f37ae0e58866c183$var$MathNode, $f37ae0e58866c183$var$MathNode.ALL);
const $f37ae0e58866c183$export$4154a199d7d90455 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$60d11c6747b7deba)($f37ae0e58866c183$var$MathNode, $f37ae0e58866c183$var$MathNode.ANY);
const $f37ae0e58866c183$export$e9bab7fafb253603 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$60d11c6747b7deba)($f37ae0e58866c183$var$MathNode, $f37ae0e58866c183$var$MathNode.EQUALS);
const $f37ae0e58866c183$export$8449e153fbd325fc = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$60d11c6747b7deba)($f37ae0e58866c183$var$MathNode, $f37ae0e58866c183$var$MathNode.RADIANS);
const $f37ae0e58866c183$export$41fc368e1a942b97 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$60d11c6747b7deba)($f37ae0e58866c183$var$MathNode, $f37ae0e58866c183$var$MathNode.DEGREES);
const $f37ae0e58866c183$export$b310ec824aaee37f = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$60d11c6747b7deba)($f37ae0e58866c183$var$MathNode, $f37ae0e58866c183$var$MathNode.EXP);
const $f37ae0e58866c183$export$4edc262d3118e986 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$60d11c6747b7deba)($f37ae0e58866c183$var$MathNode, $f37ae0e58866c183$var$MathNode.EXP2);
const $f37ae0e58866c183$export$bef1f36f5486a6a3 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$60d11c6747b7deba)($f37ae0e58866c183$var$MathNode, $f37ae0e58866c183$var$MathNode.LOG);
const $f37ae0e58866c183$export$b9fae0bba9d9094d = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$60d11c6747b7deba)($f37ae0e58866c183$var$MathNode, $f37ae0e58866c183$var$MathNode.LOG2);
const $f37ae0e58866c183$export$eba8049fb5020b81 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$60d11c6747b7deba)($f37ae0e58866c183$var$MathNode, $f37ae0e58866c183$var$MathNode.SQRT);
const $f37ae0e58866c183$export$e13f9cec9280faf4 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$60d11c6747b7deba)($f37ae0e58866c183$var$MathNode, $f37ae0e58866c183$var$MathNode.INVERSE_SQRT);
const $f37ae0e58866c183$export$a3fe094919f356fd = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$60d11c6747b7deba)($f37ae0e58866c183$var$MathNode, $f37ae0e58866c183$var$MathNode.FLOOR);
const $f37ae0e58866c183$export$803ce6b71a0a94b2 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$60d11c6747b7deba)($f37ae0e58866c183$var$MathNode, $f37ae0e58866c183$var$MathNode.CEIL);
const $f37ae0e58866c183$export$a3295358bff77e = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$60d11c6747b7deba)($f37ae0e58866c183$var$MathNode, $f37ae0e58866c183$var$MathNode.NORMALIZE);
const $f37ae0e58866c183$export$a57bfe0eb79af278 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$60d11c6747b7deba)($f37ae0e58866c183$var$MathNode, $f37ae0e58866c183$var$MathNode.FRACT);
const $f37ae0e58866c183$export$5de3937cb4b592ed = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$60d11c6747b7deba)($f37ae0e58866c183$var$MathNode, $f37ae0e58866c183$var$MathNode.SIN);
const $f37ae0e58866c183$export$50d414a77b60d802 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$60d11c6747b7deba)($f37ae0e58866c183$var$MathNode, $f37ae0e58866c183$var$MathNode.COS);
const $f37ae0e58866c183$export$fcdd3b0b3246a325 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$60d11c6747b7deba)($f37ae0e58866c183$var$MathNode, $f37ae0e58866c183$var$MathNode.TAN);
const $f37ae0e58866c183$export$41726bdb1fc63f = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$60d11c6747b7deba)($f37ae0e58866c183$var$MathNode, $f37ae0e58866c183$var$MathNode.ASIN);
const $f37ae0e58866c183$export$fd6306be3fde5b04 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$60d11c6747b7deba)($f37ae0e58866c183$var$MathNode, $f37ae0e58866c183$var$MathNode.ACOS);
const $f37ae0e58866c183$export$628dc4eed22b0fbd = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$60d11c6747b7deba)($f37ae0e58866c183$var$MathNode, $f37ae0e58866c183$var$MathNode.ATAN);
const $f37ae0e58866c183$export$2335f513bbd82c6d = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$60d11c6747b7deba)($f37ae0e58866c183$var$MathNode, $f37ae0e58866c183$var$MathNode.ABS);
const $f37ae0e58866c183$export$c5552dfdbc7cec71 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$60d11c6747b7deba)($f37ae0e58866c183$var$MathNode, $f37ae0e58866c183$var$MathNode.SIGN);
const $f37ae0e58866c183$export$f24224f1c91d8156 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$60d11c6747b7deba)($f37ae0e58866c183$var$MathNode, $f37ae0e58866c183$var$MathNode.LENGTH);
const $f37ae0e58866c183$export$aef51622e549b8b0 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$60d11c6747b7deba)($f37ae0e58866c183$var$MathNode, $f37ae0e58866c183$var$MathNode.NEGATE);
const $f37ae0e58866c183$export$854ad24922167dc9 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$60d11c6747b7deba)($f37ae0e58866c183$var$MathNode, $f37ae0e58866c183$var$MathNode.ONE_MINUS);
const $f37ae0e58866c183$export$bc6322edd97b7d95 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$60d11c6747b7deba)($f37ae0e58866c183$var$MathNode, $f37ae0e58866c183$var$MathNode.DFDX);
const $f37ae0e58866c183$export$2563647325add98e = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$60d11c6747b7deba)($f37ae0e58866c183$var$MathNode, $f37ae0e58866c183$var$MathNode.DFDY);
const $f37ae0e58866c183$export$2077e0241d6afd3c = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$60d11c6747b7deba)($f37ae0e58866c183$var$MathNode, $f37ae0e58866c183$var$MathNode.ROUND);
const $f37ae0e58866c183$export$163bc8c839a1ac04 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$60d11c6747b7deba)($f37ae0e58866c183$var$MathNode, $f37ae0e58866c183$var$MathNode.RECIPROCAL);
const $f37ae0e58866c183$export$1fe87bd59b089f0 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$60d11c6747b7deba)($f37ae0e58866c183$var$MathNode, $f37ae0e58866c183$var$MathNode.TRUNC);
const $f37ae0e58866c183$export$44e9ddb4871448a2 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$60d11c6747b7deba)($f37ae0e58866c183$var$MathNode, $f37ae0e58866c183$var$MathNode.FWIDTH);
const $f37ae0e58866c183$export$c344030f3a1fe226 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$60d11c6747b7deba)($f37ae0e58866c183$var$MathNode, $f37ae0e58866c183$var$MathNode.BITCAST);
const $f37ae0e58866c183$export$9cb09a71b7d66923 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$60d11c6747b7deba)($f37ae0e58866c183$var$MathNode, $f37ae0e58866c183$var$MathNode.TRANSPOSE);
const $f37ae0e58866c183$export$b8b770ee6a0d9760 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$60d11c6747b7deba)($f37ae0e58866c183$var$MathNode, $f37ae0e58866c183$var$MathNode.ATAN2);
const $f37ae0e58866c183$export$96ec731ed4dcb222 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$60d11c6747b7deba)($f37ae0e58866c183$var$MathNode, $f37ae0e58866c183$var$MathNode.MIN);
const $f37ae0e58866c183$export$8960430cfd85939f = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$60d11c6747b7deba)($f37ae0e58866c183$var$MathNode, $f37ae0e58866c183$var$MathNode.MAX);
const $f37ae0e58866c183$export$842a2cf37af977e1 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$60d11c6747b7deba)($f37ae0e58866c183$var$MathNode, $f37ae0e58866c183$var$MathNode.MOD);
const $f37ae0e58866c183$export$35d34bc0ed591a92 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$60d11c6747b7deba)($f37ae0e58866c183$var$MathNode, $f37ae0e58866c183$var$MathNode.STEP);
const $f37ae0e58866c183$export$9debe8cffacea23 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$60d11c6747b7deba)($f37ae0e58866c183$var$MathNode, $f37ae0e58866c183$var$MathNode.REFLECT);
const $f37ae0e58866c183$export$9f17032d917177de = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$60d11c6747b7deba)($f37ae0e58866c183$var$MathNode, $f37ae0e58866c183$var$MathNode.DISTANCE);
const $f37ae0e58866c183$export$acaf96a27438246b = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$60d11c6747b7deba)($f37ae0e58866c183$var$MathNode, $f37ae0e58866c183$var$MathNode.DIFFERENCE);
const $f37ae0e58866c183$export$94132a0e348806d4 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$60d11c6747b7deba)($f37ae0e58866c183$var$MathNode, $f37ae0e58866c183$var$MathNode.DOT);
const $f37ae0e58866c183$export$bb646b20bb93d339 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$60d11c6747b7deba)($f37ae0e58866c183$var$MathNode, $f37ae0e58866c183$var$MathNode.CROSS);
const $f37ae0e58866c183$export$9c297f60e22e3389 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$60d11c6747b7deba)($f37ae0e58866c183$var$MathNode, $f37ae0e58866c183$var$MathNode.POW);
const $f37ae0e58866c183$export$fa569bd808b67eef = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$60d11c6747b7deba)($f37ae0e58866c183$var$MathNode, $f37ae0e58866c183$var$MathNode.POW, 2);
const $f37ae0e58866c183$export$c460b8d1abb86675 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$60d11c6747b7deba)($f37ae0e58866c183$var$MathNode, $f37ae0e58866c183$var$MathNode.POW, 3);
const $f37ae0e58866c183$export$66864084b1797b69 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$60d11c6747b7deba)($f37ae0e58866c183$var$MathNode, $f37ae0e58866c183$var$MathNode.POW, 4);
const $f37ae0e58866c183$export$fff94e9792354cfa = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$60d11c6747b7deba)($f37ae0e58866c183$var$MathNode, $f37ae0e58866c183$var$MathNode.TRANSFORM_DIRECTION);
const $f37ae0e58866c183$export$841fc4d5a1480b85 = (a)=>(0, $3f1f23fea79ae256$export$6e3a27864ab166fe)($f37ae0e58866c183$export$c5552dfdbc7cec71(a), $f37ae0e58866c183$export$9c297f60e22e3389($f37ae0e58866c183$export$2335f513bbd82c6d(a), 1.0 / 3.0));
const $f37ae0e58866c183$export$2b5af473ed92fb2 = (a)=>$f37ae0e58866c183$export$94132a0e348806d4(a, a);
const $f37ae0e58866c183$export$2c9e8a9632a706b2 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$60d11c6747b7deba)($f37ae0e58866c183$var$MathNode, $f37ae0e58866c183$var$MathNode.MIX);
const $f37ae0e58866c183$export$7d15b64cf5a3a4c4 = (value, low = 0, high = 1)=>(0, $d5b7ee61758b2e81$export$e97474e17004dd41)(new $f37ae0e58866c183$var$MathNode($f37ae0e58866c183$var$MathNode.CLAMP, (0, $d5b7ee61758b2e81$export$e97474e17004dd41)(value), (0, $d5b7ee61758b2e81$export$e97474e17004dd41)(low), (0, $d5b7ee61758b2e81$export$e97474e17004dd41)(high)));
const $f37ae0e58866c183$export$5fcac96f5a87e3db = (value)=>$f37ae0e58866c183$export$7d15b64cf5a3a4c4(value);
const $f37ae0e58866c183$export$f49311db2be090a0 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$60d11c6747b7deba)($f37ae0e58866c183$var$MathNode, $f37ae0e58866c183$var$MathNode.REFRACT);
const $f37ae0e58866c183$export$4053e36566dd3d9a = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$60d11c6747b7deba)($f37ae0e58866c183$var$MathNode, $f37ae0e58866c183$var$MathNode.SMOOTHSTEP);
const $f37ae0e58866c183$export$5d74d69f07f6f54b = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$60d11c6747b7deba)($f37ae0e58866c183$var$MathNode, $f37ae0e58866c183$var$MathNode.FACEFORWARD);
const $f37ae0e58866c183$export$bb0a9c36cf454ea0 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$b076717d71a1a47f)(([uv])=>{
    const a = 12.9898, b = 78.233, c = 43758.5453;
    const dt = $f37ae0e58866c183$export$94132a0e348806d4(uv.xy, (0, $d5b7ee61758b2e81$export$e9830bc863290a54)(a, b)), sn = $f37ae0e58866c183$export$842a2cf37af977e1(dt, $f37ae0e58866c183$export$6b5c1ceb16d01dc3);
    return $f37ae0e58866c183$export$a57bfe0eb79af278($f37ae0e58866c183$export$5de3937cb4b592ed(sn).mul(c));
});
const $f37ae0e58866c183$export$b75075493d44bcd = (t, e1, e2)=>$f37ae0e58866c183$export$2c9e8a9632a706b2(e1, e2, t);
const $f37ae0e58866c183$export$88d04a529a181cca = (x, low, high)=>$f37ae0e58866c183$export$4053e36566dd3d9a(low, high, x);
(0, $d5b7ee61758b2e81$export$5f439e138e9dc985)('all', $f37ae0e58866c183$export$84bf76cd7afc7469);
(0, $d5b7ee61758b2e81$export$5f439e138e9dc985)('any', $f37ae0e58866c183$export$4154a199d7d90455);
(0, $d5b7ee61758b2e81$export$5f439e138e9dc985)('equals', $f37ae0e58866c183$export$e9bab7fafb253603);
(0, $d5b7ee61758b2e81$export$5f439e138e9dc985)('radians', $f37ae0e58866c183$export$8449e153fbd325fc);
(0, $d5b7ee61758b2e81$export$5f439e138e9dc985)('degrees', $f37ae0e58866c183$export$41fc368e1a942b97);
(0, $d5b7ee61758b2e81$export$5f439e138e9dc985)('exp', $f37ae0e58866c183$export$b310ec824aaee37f);
(0, $d5b7ee61758b2e81$export$5f439e138e9dc985)('exp2', $f37ae0e58866c183$export$4edc262d3118e986);
(0, $d5b7ee61758b2e81$export$5f439e138e9dc985)('log', $f37ae0e58866c183$export$bef1f36f5486a6a3);
(0, $d5b7ee61758b2e81$export$5f439e138e9dc985)('log2', $f37ae0e58866c183$export$b9fae0bba9d9094d);
(0, $d5b7ee61758b2e81$export$5f439e138e9dc985)('sqrt', $f37ae0e58866c183$export$eba8049fb5020b81);
(0, $d5b7ee61758b2e81$export$5f439e138e9dc985)('inverseSqrt', $f37ae0e58866c183$export$e13f9cec9280faf4);
(0, $d5b7ee61758b2e81$export$5f439e138e9dc985)('floor', $f37ae0e58866c183$export$a3fe094919f356fd);
(0, $d5b7ee61758b2e81$export$5f439e138e9dc985)('ceil', $f37ae0e58866c183$export$803ce6b71a0a94b2);
(0, $d5b7ee61758b2e81$export$5f439e138e9dc985)('normalize', $f37ae0e58866c183$export$a3295358bff77e);
(0, $d5b7ee61758b2e81$export$5f439e138e9dc985)('fract', $f37ae0e58866c183$export$a57bfe0eb79af278);
(0, $d5b7ee61758b2e81$export$5f439e138e9dc985)('sin', $f37ae0e58866c183$export$5de3937cb4b592ed);
(0, $d5b7ee61758b2e81$export$5f439e138e9dc985)('cos', $f37ae0e58866c183$export$50d414a77b60d802);
(0, $d5b7ee61758b2e81$export$5f439e138e9dc985)('tan', $f37ae0e58866c183$export$fcdd3b0b3246a325);
(0, $d5b7ee61758b2e81$export$5f439e138e9dc985)('asin', $f37ae0e58866c183$export$41726bdb1fc63f);
(0, $d5b7ee61758b2e81$export$5f439e138e9dc985)('acos', $f37ae0e58866c183$export$fd6306be3fde5b04);
(0, $d5b7ee61758b2e81$export$5f439e138e9dc985)('atan', $f37ae0e58866c183$export$628dc4eed22b0fbd);
(0, $d5b7ee61758b2e81$export$5f439e138e9dc985)('abs', $f37ae0e58866c183$export$2335f513bbd82c6d);
(0, $d5b7ee61758b2e81$export$5f439e138e9dc985)('sign', $f37ae0e58866c183$export$c5552dfdbc7cec71);
(0, $d5b7ee61758b2e81$export$5f439e138e9dc985)('length', $f37ae0e58866c183$export$f24224f1c91d8156);
(0, $d5b7ee61758b2e81$export$5f439e138e9dc985)('lengthSq', $f37ae0e58866c183$export$2b5af473ed92fb2);
(0, $d5b7ee61758b2e81$export$5f439e138e9dc985)('negate', $f37ae0e58866c183$export$aef51622e549b8b0);
(0, $d5b7ee61758b2e81$export$5f439e138e9dc985)('oneMinus', $f37ae0e58866c183$export$854ad24922167dc9);
(0, $d5b7ee61758b2e81$export$5f439e138e9dc985)('dFdx', $f37ae0e58866c183$export$bc6322edd97b7d95);
(0, $d5b7ee61758b2e81$export$5f439e138e9dc985)('dFdy', $f37ae0e58866c183$export$2563647325add98e);
(0, $d5b7ee61758b2e81$export$5f439e138e9dc985)('round', $f37ae0e58866c183$export$2077e0241d6afd3c);
(0, $d5b7ee61758b2e81$export$5f439e138e9dc985)('reciprocal', $f37ae0e58866c183$export$163bc8c839a1ac04);
(0, $d5b7ee61758b2e81$export$5f439e138e9dc985)('trunc', $f37ae0e58866c183$export$1fe87bd59b089f0);
(0, $d5b7ee61758b2e81$export$5f439e138e9dc985)('fwidth', $f37ae0e58866c183$export$44e9ddb4871448a2);
(0, $d5b7ee61758b2e81$export$5f439e138e9dc985)('atan2', $f37ae0e58866c183$export$b8b770ee6a0d9760);
(0, $d5b7ee61758b2e81$export$5f439e138e9dc985)('min', $f37ae0e58866c183$export$96ec731ed4dcb222);
(0, $d5b7ee61758b2e81$export$5f439e138e9dc985)('max', $f37ae0e58866c183$export$8960430cfd85939f);
(0, $d5b7ee61758b2e81$export$5f439e138e9dc985)('mod', $f37ae0e58866c183$export$842a2cf37af977e1);
(0, $d5b7ee61758b2e81$export$5f439e138e9dc985)('step', $f37ae0e58866c183$export$35d34bc0ed591a92);
(0, $d5b7ee61758b2e81$export$5f439e138e9dc985)('reflect', $f37ae0e58866c183$export$9debe8cffacea23);
(0, $d5b7ee61758b2e81$export$5f439e138e9dc985)('distance', $f37ae0e58866c183$export$9f17032d917177de);
(0, $d5b7ee61758b2e81$export$5f439e138e9dc985)('dot', $f37ae0e58866c183$export$94132a0e348806d4);
(0, $d5b7ee61758b2e81$export$5f439e138e9dc985)('cross', $f37ae0e58866c183$export$bb646b20bb93d339);
(0, $d5b7ee61758b2e81$export$5f439e138e9dc985)('pow', $f37ae0e58866c183$export$9c297f60e22e3389);
(0, $d5b7ee61758b2e81$export$5f439e138e9dc985)('pow2', $f37ae0e58866c183$export$fa569bd808b67eef);
(0, $d5b7ee61758b2e81$export$5f439e138e9dc985)('pow3', $f37ae0e58866c183$export$c460b8d1abb86675);
(0, $d5b7ee61758b2e81$export$5f439e138e9dc985)('pow4', $f37ae0e58866c183$export$66864084b1797b69);
(0, $d5b7ee61758b2e81$export$5f439e138e9dc985)('transformDirection', $f37ae0e58866c183$export$fff94e9792354cfa);
(0, $d5b7ee61758b2e81$export$5f439e138e9dc985)('mix', $f37ae0e58866c183$export$b75075493d44bcd);
(0, $d5b7ee61758b2e81$export$5f439e138e9dc985)('clamp', $f37ae0e58866c183$export$7d15b64cf5a3a4c4);
(0, $d5b7ee61758b2e81$export$5f439e138e9dc985)('refract', $f37ae0e58866c183$export$f49311db2be090a0);
(0, $d5b7ee61758b2e81$export$5f439e138e9dc985)('smoothstep', $f37ae0e58866c183$export$88d04a529a181cca);
(0, $d5b7ee61758b2e81$export$5f439e138e9dc985)('faceForward', $f37ae0e58866c183$export$5d74d69f07f6f54b);
(0, $d5b7ee61758b2e81$export$5f439e138e9dc985)('difference', $f37ae0e58866c183$export$acaf96a27438246b);
(0, $d5b7ee61758b2e81$export$5f439e138e9dc985)('saturate', $f37ae0e58866c183$export$5fcac96f5a87e3db);
(0, $d5b7ee61758b2e81$export$5f439e138e9dc985)('cbrt', $f37ae0e58866c183$export$841fc4d5a1480b85);
(0, $d5b7ee61758b2e81$export$5f439e138e9dc985)('transpose', $f37ae0e58866c183$export$9cb09a71b7d66923);
(0, $d5b7ee61758b2e81$export$5f439e138e9dc985)('rand', $f37ae0e58866c183$export$bb0a9c36cf454ea0);





class $cb309bf1d9ed8a72$var$ConditionalNode extends (0, $65e77d5c3a27a66a$export$2e2bcd8739ae039) {
    static get type() {
        return 'ConditionalNode';
    }
    constructor(condNode, ifNode, elseNode = null){
        super();
        this.condNode = condNode;
        this.ifNode = ifNode;
        this.elseNode = elseNode;
    }
    getNodeType(builder) {
        const ifType = this.ifNode.getNodeType(builder);
        if (this.elseNode !== null) {
            const elseType = this.elseNode.getNodeType(builder);
            if (builder.getTypeLength(elseType) > builder.getTypeLength(ifType)) return elseType;
        }
        return ifType;
    }
    setup(builder) {
        const condNode = this.condNode.cache();
        const ifNode = this.ifNode.cache();
        const elseNode = this.elseNode ? this.elseNode.cache() : null;
        //
        const currentNodeBlock = builder.context.nodeBlock;
        builder.getDataFromNode(ifNode).parentNodeBlock = currentNodeBlock;
        if (elseNode !== null) builder.getDataFromNode(elseNode).parentNodeBlock = currentNodeBlock;
        //
        const properties = builder.getNodeProperties(this);
        properties.condNode = condNode;
        properties.ifNode = ifNode.context({
            nodeBlock: ifNode
        });
        properties.elseNode = elseNode ? elseNode.context({
            nodeBlock: elseNode
        }) : null;
    }
    generate(builder, output) {
        const type = this.getNodeType(builder);
        const nodeData = builder.getDataFromNode(this);
        if (nodeData.nodeProperty !== undefined) return nodeData.nodeProperty;
        const { condNode: condNode, ifNode: ifNode, elseNode: elseNode } = builder.getNodeProperties(this);
        const needsOutput = output !== 'void';
        const nodeProperty = needsOutput ? (0, $dd761eb0c8b88ca7$export$d541bacb2bda4494)(type).build(builder) : '';
        nodeData.nodeProperty = nodeProperty;
        const nodeSnippet = condNode.build(builder, 'bool');
        builder.addFlowCode(`\n${builder.tab}if ( ${nodeSnippet} ) {\n\n`).addFlowTab();
        let ifSnippet = ifNode.build(builder, type);
        if (ifSnippet) {
            if (needsOutput) ifSnippet = nodeProperty + ' = ' + ifSnippet + ';';
            else ifSnippet = 'return ' + ifSnippet + ';';
        }
        builder.removeFlowTab().addFlowCode(builder.tab + '\t' + ifSnippet + '\n\n' + builder.tab + '}');
        if (elseNode !== null) {
            builder.addFlowCode(' else {\n\n').addFlowTab();
            let elseSnippet = elseNode.build(builder, type);
            if (elseSnippet) {
                if (needsOutput) elseSnippet = nodeProperty + ' = ' + elseSnippet + ';';
                else elseSnippet = 'return ' + elseSnippet + ';';
            }
            builder.removeFlowTab().addFlowCode(builder.tab + '\t' + elseSnippet + '\n\n' + builder.tab + '}\n\n');
        } else builder.addFlowCode('\n\n');
        return builder.format(nodeProperty, type, output);
    }
}
var $cb309bf1d9ed8a72$export$2e2bcd8739ae039 = $cb309bf1d9ed8a72$var$ConditionalNode;
const $cb309bf1d9ed8a72$export$2e6c959c16ff56b8 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$60d11c6747b7deba)($cb309bf1d9ed8a72$var$ConditionalNode);
(0, $d5b7ee61758b2e81$export$5f439e138e9dc985)('select', $cb309bf1d9ed8a72$export$2e6c959c16ff56b8);
const $cb309bf1d9ed8a72$export$7ffafceb12143143 = (...params)=>{
    console.warn('TSL.ConditionalNode: cond() has been renamed to select().');
    return $cb309bf1d9ed8a72$export$2e6c959c16ff56b8(...params);
};
(0, $d5b7ee61758b2e81$export$5f439e138e9dc985)('cond', $cb309bf1d9ed8a72$export$7ffafceb12143143);




class $8e9a9aae457d80ab$var$ContextNode extends (0, $65e77d5c3a27a66a$export$2e2bcd8739ae039) {
    static get type() {
        return 'ContextNode';
    }
    constructor(node, value = {}){
        super();
        this.isContextNode = true;
        this.node = node;
        this.value = value;
    }
    getScope() {
        return this.node.getScope();
    }
    getNodeType(builder) {
        return this.node.getNodeType(builder);
    }
    analyze(builder) {
        this.node.build(builder);
    }
    setup(builder) {
        const previousContext = builder.getContext();
        builder.setContext({
            ...builder.context,
            ...this.value
        });
        const node = this.node.build(builder);
        builder.setContext(previousContext);
        return node;
    }
    generate(builder, output) {
        const previousContext = builder.getContext();
        builder.setContext({
            ...builder.context,
            ...this.value
        });
        const snippet = this.node.build(builder, output);
        builder.setContext(previousContext);
        return snippet;
    }
}
var $8e9a9aae457d80ab$export$2e2bcd8739ae039 = $8e9a9aae457d80ab$var$ContextNode;
const $8e9a9aae457d80ab$export$a078c61943f9dbbe = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$60d11c6747b7deba)($8e9a9aae457d80ab$var$ContextNode);
const $8e9a9aae457d80ab$export$1237798dc640739a = (node, name)=>$8e9a9aae457d80ab$export$a078c61943f9dbbe(node, {
        label: name
    });
(0, $d5b7ee61758b2e81$export$5f439e138e9dc985)('context', $8e9a9aae457d80ab$export$a078c61943f9dbbe);
(0, $d5b7ee61758b2e81$export$5f439e138e9dc985)('label', $8e9a9aae457d80ab$export$1237798dc640739a);




class $546728445a5738ce$var$VarNode extends (0, $65e77d5c3a27a66a$export$2e2bcd8739ae039) {
    static get type() {
        return 'VarNode';
    }
    constructor(node, name = null){
        super();
        this.node = node;
        this.name = name;
        this.global = true;
        this.isVarNode = true;
    }
    getHash(builder) {
        return this.name || super.getHash(builder);
    }
    getNodeType(builder) {
        return this.node.getNodeType(builder);
    }
    generate(builder) {
        const { node: node, name: name } = this;
        const nodeVar = builder.getVarFromNode(this, name, builder.getVectorType(this.getNodeType(builder)));
        const propertyName = builder.getPropertyName(nodeVar);
        const snippet = node.build(builder, nodeVar.type);
        builder.addLineFlowCode(`${propertyName} = ${snippet}`, this);
        return propertyName;
    }
}
var $546728445a5738ce$export$2e2bcd8739ae039 = $546728445a5738ce$var$VarNode;
const $546728445a5738ce$var$createVar = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$60d11c6747b7deba)($546728445a5738ce$var$VarNode);
(0, $d5b7ee61758b2e81$export$5f439e138e9dc985)('toVar', (...params)=>$546728445a5738ce$var$createVar(...params).append());
const $546728445a5738ce$export$8d72b093afd1813e = (node)=>{
    console.warn('TSL: "temp" is deprecated. Use ".toVar()" instead.');
    return $546728445a5738ce$var$createVar(node);
};
(0, $d5b7ee61758b2e81$export$5f439e138e9dc985)('temp', $546728445a5738ce$export$8d72b093afd1813e);





class $c497538e811cb09b$var$VaryingNode extends (0, $65e77d5c3a27a66a$export$2e2bcd8739ae039) {
    static get type() {
        return 'VaryingNode';
    }
    constructor(node, name = null){
        super();
        this.node = node;
        this.name = name;
        this.isVaryingNode = true;
    }
    isGlobal() {
        return true;
    }
    getHash(builder) {
        return this.name || super.getHash(builder);
    }
    getNodeType(builder) {
        // VaryingNode is auto type
        return this.node.getNodeType(builder);
    }
    setupVarying(builder) {
        const properties = builder.getNodeProperties(this);
        let varying = properties.varying;
        if (varying === undefined) {
            const name = this.name;
            const type = this.getNodeType(builder);
            properties.varying = varying = builder.getVaryingFromNode(this, name, type);
            properties.node = this.node;
        }
        // this property can be used to check if the varying can be optimized for a variable
        varying.needsInterpolation || (varying.needsInterpolation = builder.shaderStage === 'fragment');
        return varying;
    }
    setup(builder) {
        this.setupVarying(builder);
    }
    analyze(builder) {
        this.setupVarying(builder);
        return this.node.analyze(builder);
    }
    generate(builder) {
        const properties = builder.getNodeProperties(this);
        const varying = this.setupVarying(builder);
        if (properties.propertyName === undefined) {
            const type = this.getNodeType(builder);
            const propertyName = builder.getPropertyName(varying, (0, $ddcfecb7fbba5d74$export$9e43649cde3e3072).VERTEX);
            // force node run in vertex stage
            builder.flowNodeFromShaderStage((0, $ddcfecb7fbba5d74$export$9e43649cde3e3072).VERTEX, this.node, type, propertyName);
            properties.propertyName = propertyName;
        }
        return builder.getPropertyName(varying);
    }
}
var $c497538e811cb09b$export$2e2bcd8739ae039 = $c497538e811cb09b$var$VaryingNode;
const $c497538e811cb09b$export$3f47f02b8134ef8a = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$60d11c6747b7deba)($c497538e811cb09b$var$VaryingNode);
(0, $d5b7ee61758b2e81$export$5f439e138e9dc985)('varying', $c497538e811cb09b$export$3f47f02b8134ef8a);








const $08cf06b3f432c75e$export$ca33f0de04db7a92 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$b076717d71a1a47f)(([color])=>{
    const a = color.mul(0.9478672986).add(0.0521327014).pow(2.4);
    const b = color.mul(0.0773993808);
    const factor = color.lessThanEqual(0.04045);
    const rgbResult = (0, $f37ae0e58866c183$export$2c9e8a9632a706b2)(a, b, factor);
    return rgbResult;
}).setLayout({
    name: 'sRGBTransferEOTF',
    type: 'vec3',
    inputs: [
        {
            name: 'color',
            type: 'vec3'
        }
    ]
});
const $08cf06b3f432c75e$export$c481893b7b5ec3b2 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$b076717d71a1a47f)(([color])=>{
    const a = color.pow(0.41666).mul(1.055).sub(0.055);
    const b = color.mul(12.92);
    const factor = color.lessThanEqual(0.0031308);
    const rgbResult = (0, $f37ae0e58866c183$export$2c9e8a9632a706b2)(a, b, factor);
    return rgbResult;
}).setLayout({
    name: 'sRGBTransferOETF',
    type: 'vec3',
    inputs: [
        {
            name: 'color',
            type: 'vec3'
        }
    ]
});



const $1b770916e91703b6$var$WORKING_COLOR_SPACE = 'WorkingColorSpace';
const $1b770916e91703b6$var$OUTPUT_COLOR_SPACE = 'OutputColorSpace';
class $1b770916e91703b6$var$ColorSpaceNode extends (0, $75c45ed2361c955f$export$2e2bcd8739ae039) {
    static get type() {
        return 'ColorSpaceNode';
    }
    constructor(colorNode, source, target){
        super('vec4');
        this.colorNode = colorNode;
        this.source = source;
        this.target = target;
    }
    resolveColorSpace(builder, colorSpace) {
        if (colorSpace === $1b770916e91703b6$var$WORKING_COLOR_SPACE) return (0, $46d4f6f1be9702a8$export$5e6fd513f44698c).workingColorSpace;
        else if (colorSpace === $1b770916e91703b6$var$OUTPUT_COLOR_SPACE) return builder.context.outputColorSpace || builder.renderer.outputColorSpace;
        return colorSpace;
    }
    setup(builder) {
        const { colorNode: colorNode } = this;
        const source = this.resolveColorSpace(builder, this.source);
        const target = this.resolveColorSpace(builder, this.target);
        let outputNode = colorNode;
        if ((0, $46d4f6f1be9702a8$export$5e6fd513f44698c).enabled === false || source === target || !source || !target) return outputNode;
        if ((0, $46d4f6f1be9702a8$export$5e6fd513f44698c).getTransfer(source) === (0, $cb5ee595c0f892af$export$8d0a61916cc26abb)) outputNode = (0, $d5b7ee61758b2e81$export$6dba2a1f0d609415)((0, $08cf06b3f432c75e$export$ca33f0de04db7a92)(outputNode.rgb), outputNode.a);
        if ((0, $46d4f6f1be9702a8$export$5e6fd513f44698c).getPrimaries(source) !== (0, $46d4f6f1be9702a8$export$5e6fd513f44698c).getPrimaries(target)) outputNode = (0, $d5b7ee61758b2e81$export$6dba2a1f0d609415)((0, $d5b7ee61758b2e81$export$e43bd9f504e4ac00)((0, $46d4f6f1be9702a8$export$5e6fd513f44698c)._getMatrix(new (0, $800ed18490319df2$export$8ff26dafa08918)(), source, target)).mul(outputNode.rgb), outputNode.a);
        if ((0, $46d4f6f1be9702a8$export$5e6fd513f44698c).getTransfer(target) === (0, $cb5ee595c0f892af$export$8d0a61916cc26abb)) outputNode = (0, $d5b7ee61758b2e81$export$6dba2a1f0d609415)((0, $08cf06b3f432c75e$export$c481893b7b5ec3b2)(outputNode.rgb), outputNode.a);
        return outputNode;
    }
}
var $1b770916e91703b6$export$2e2bcd8739ae039 = $1b770916e91703b6$var$ColorSpaceNode;
const $1b770916e91703b6$export$a2bbf745b3921034 = (node)=>(0, $d5b7ee61758b2e81$export$e97474e17004dd41)(new $1b770916e91703b6$var$ColorSpaceNode((0, $d5b7ee61758b2e81$export$e97474e17004dd41)(node), $1b770916e91703b6$var$WORKING_COLOR_SPACE, $1b770916e91703b6$var$OUTPUT_COLOR_SPACE));
const $1b770916e91703b6$export$df0f08ec14fd1fb5 = (node)=>(0, $d5b7ee61758b2e81$export$e97474e17004dd41)(new $1b770916e91703b6$var$ColorSpaceNode((0, $d5b7ee61758b2e81$export$e97474e17004dd41)(node), $1b770916e91703b6$var$OUTPUT_COLOR_SPACE, $1b770916e91703b6$var$WORKING_COLOR_SPACE));
const $1b770916e91703b6$export$b57e73fd3e5e3c6e = (node, colorSpace)=>(0, $d5b7ee61758b2e81$export$e97474e17004dd41)(new $1b770916e91703b6$var$ColorSpaceNode((0, $d5b7ee61758b2e81$export$e97474e17004dd41)(node), $1b770916e91703b6$var$WORKING_COLOR_SPACE, colorSpace));
const $1b770916e91703b6$export$7444e0682bed4e57 = (node, colorSpace)=>(0, $d5b7ee61758b2e81$export$e97474e17004dd41)(new $1b770916e91703b6$var$ColorSpaceNode((0, $d5b7ee61758b2e81$export$e97474e17004dd41)(node), colorSpace, $1b770916e91703b6$var$WORKING_COLOR_SPACE));
const $1b770916e91703b6$export$156eb9a9cfda9131 = (node, sourceColorSpace, targetColorSpace)=>(0, $d5b7ee61758b2e81$export$e97474e17004dd41)(new $1b770916e91703b6$var$ColorSpaceNode((0, $d5b7ee61758b2e81$export$e97474e17004dd41)(node), sourceColorSpace, targetColorSpace));
(0, $d5b7ee61758b2e81$export$5f439e138e9dc985)('toOutputColorSpace', $1b770916e91703b6$export$a2bbf745b3921034);
(0, $d5b7ee61758b2e81$export$5f439e138e9dc985)('toWorkingColorSpace', $1b770916e91703b6$export$df0f08ec14fd1fb5);
(0, $d5b7ee61758b2e81$export$5f439e138e9dc985)('workingToColorSpace', $1b770916e91703b6$export$b57e73fd3e5e3c6e);
(0, $d5b7ee61758b2e81$export$5f439e138e9dc985)('colorSpaceToWorking', $1b770916e91703b6$export$7444e0682bed4e57);









class $703ae9ffd13a2ae0$var$ReferenceElementNode extends (0, $e2cc991ce11e1c78$export$2e2bcd8739ae039) {
    static get type() {
        return 'ReferenceElementNode';
    }
    constructor(referenceNode, indexNode){
        super(referenceNode, indexNode);
        this.referenceNode = referenceNode;
        this.isReferenceElementNode = true;
    }
    getNodeType() {
        return this.referenceNode.uniformType;
    }
    generate(builder) {
        const snippet = super.generate(builder);
        const arrayType = this.referenceNode.getNodeType();
        const elementType = this.getNodeType();
        return builder.format(snippet, arrayType, elementType);
    }
}
class $703ae9ffd13a2ae0$var$ReferenceBaseNode extends (0, $65e77d5c3a27a66a$export$2e2bcd8739ae039) {
    static get type() {
        return 'ReferenceBaseNode';
    }
    constructor(property, uniformType, object = null, count = null){
        super();
        this.property = property;
        this.uniformType = uniformType;
        this.object = object;
        this.count = count;
        this.properties = property.split('.');
        this.reference = object;
        this.node = null;
        this.group = null;
        this.updateType = (0, $ddcfecb7fbba5d74$export$26f7a8bbd9469530).OBJECT;
    }
    setGroup(group) {
        this.group = group;
        return this;
    }
    element(indexNode) {
        return (0, $d5b7ee61758b2e81$export$e97474e17004dd41)(new $703ae9ffd13a2ae0$var$ReferenceElementNode(this, (0, $d5b7ee61758b2e81$export$e97474e17004dd41)(indexNode)));
    }
    setNodeType(uniformType) {
        const node = (0, $5eb92bf12e57daab$export$379455b567eff87d)(null, uniformType).getSelf();
        if (this.group !== null) node.setGroup(this.group);
        this.node = node;
    }
    getNodeType(builder) {
        if (this.node === null) {
            this.updateReference(builder);
            this.updateValue();
        }
        return this.node.getNodeType(builder);
    }
    getValueFromReference(object = this.reference) {
        const { properties: properties } = this;
        let value = object[properties[0]];
        for(let i = 1; i < properties.length; i++)value = value[properties[i]];
        return value;
    }
    updateReference(state) {
        this.reference = this.object !== null ? this.object : state.object;
        return this.reference;
    }
    setup() {
        this.updateValue();
        return this.node;
    }
    update() {
        this.updateValue();
    }
    updateValue() {
        if (this.node === null) this.setNodeType(this.uniformType);
        const value = this.getValueFromReference();
        if (Array.isArray(value)) this.node.array = value;
        else this.node.value = value;
    }
}
var $703ae9ffd13a2ae0$export$2e2bcd8739ae039 = $703ae9ffd13a2ae0$var$ReferenceBaseNode;
const $703ae9ffd13a2ae0$export$ca50aac9f3ba507f = (name, type, object)=>(0, $d5b7ee61758b2e81$export$e97474e17004dd41)(new $703ae9ffd13a2ae0$var$ReferenceBaseNode(name, type, object));
const $703ae9ffd13a2ae0$export$18088e2a413e76c6 = (name, type, count, object)=>(0, $d5b7ee61758b2e81$export$e97474e17004dd41)(new $703ae9ffd13a2ae0$var$ReferenceBaseNode(name, type, object, count));




class $88378d405d5db1e2$var$RendererReferenceNode extends (0, $703ae9ffd13a2ae0$export$2e2bcd8739ae039) {
    static get type() {
        return 'RendererReferenceNode';
    }
    constructor(property, inputType, renderer = null){
        super(property, inputType, renderer);
        this.renderer = renderer;
        this.setGroup((0, $d2c0f7c752a63c18$export$a75a8692b47c7f9e));
    }
    updateReference(state) {
        this.reference = this.renderer !== null ? this.renderer : state.renderer;
        return this.reference;
    }
}
var $88378d405d5db1e2$export$2e2bcd8739ae039 = $88378d405d5db1e2$var$RendererReferenceNode;
const $88378d405d5db1e2$export$ab54dbb569ffae37 = (name, type, renderer)=>(0, $d5b7ee61758b2e81$export$e97474e17004dd41)(new $88378d405d5db1e2$var$RendererReferenceNode(name, type, renderer));




class $fe26613416b39052$var$ToneMappingNode extends (0, $75c45ed2361c955f$export$2e2bcd8739ae039) {
    static get type() {
        return 'ToneMappingNode';
    }
    constructor(toneMapping, exposureNode = $fe26613416b39052$export$6a4fd05fb7fdb032, colorNode = null){
        super('vec3');
        this.toneMapping = toneMapping;
        this.exposureNode = exposureNode;
        this.colorNode = colorNode;
    }
    getCacheKey() {
        return (0, $97d1d441621670a9$export$d6af199866bfb566)(super.getCacheKey(), this.toneMapping);
    }
    setup(builder) {
        const colorNode = this.colorNode || builder.context.color;
        const toneMapping = this.toneMapping;
        if (toneMapping === (0, $cb5ee595c0f892af$export$9fcb6b4294603b2)) return colorNode;
        let outputNode = null;
        const toneMappingFn = builder.renderer.library.getToneMappingFunction(toneMapping);
        if (toneMappingFn !== null) outputNode = (0, $d5b7ee61758b2e81$export$6dba2a1f0d609415)(toneMappingFn(colorNode.rgb, this.exposureNode), colorNode.a);
        else {
            console.error('ToneMappingNode: Unsupported Tone Mapping configuration.', toneMapping);
            outputNode = colorNode;
        }
        return outputNode;
    }
}
var $fe26613416b39052$export$2e2bcd8739ae039 = $fe26613416b39052$var$ToneMappingNode;
const $fe26613416b39052$export$91d5b91df9dcddb2 = (mapping, exposure, color)=>(0, $d5b7ee61758b2e81$export$e97474e17004dd41)(new $fe26613416b39052$var$ToneMappingNode(mapping, (0, $d5b7ee61758b2e81$export$e97474e17004dd41)(exposure), (0, $d5b7ee61758b2e81$export$e97474e17004dd41)(color)));
const $fe26613416b39052$export$6a4fd05fb7fdb032 = /*@__PURE__*/ (0, $88378d405d5db1e2$export$ab54dbb569ffae37)('toneMappingExposure', 'float');
(0, $d5b7ee61758b2e81$export$5f439e138e9dc985)('toneMapping', (color, mapping, exposure)=>$fe26613416b39052$export$91d5b91df9dcddb2(mapping, exposure, color));








const $b97b29b5fc8305c3$var$_vector = /*@__PURE__*/ new (0, $d7d0ac0e47013885$export$64b5c384219d3699)();
class $b97b29b5fc8305c3$export$920b6d07334599c7 {
    constructor(interleavedBuffer, itemSize, offset, normalized = false){
        this.isInterleavedBufferAttribute = true;
        this.name = '';
        this.data = interleavedBuffer;
        this.itemSize = itemSize;
        this.offset = offset;
        this.normalized = normalized;
    }
    get count() {
        return this.data.count;
    }
    get array() {
        return this.data.array;
    }
    set needsUpdate(value) {
        this.data.needsUpdate = value;
    }
    applyMatrix4(m) {
        for(let i = 0, l = this.data.count; i < l; i++){
            $b97b29b5fc8305c3$var$_vector.fromBufferAttribute(this, i);
            $b97b29b5fc8305c3$var$_vector.applyMatrix4(m);
            this.setXYZ(i, $b97b29b5fc8305c3$var$_vector.x, $b97b29b5fc8305c3$var$_vector.y, $b97b29b5fc8305c3$var$_vector.z);
        }
        return this;
    }
    applyNormalMatrix(m) {
        for(let i = 0, l = this.count; i < l; i++){
            $b97b29b5fc8305c3$var$_vector.fromBufferAttribute(this, i);
            $b97b29b5fc8305c3$var$_vector.applyNormalMatrix(m);
            this.setXYZ(i, $b97b29b5fc8305c3$var$_vector.x, $b97b29b5fc8305c3$var$_vector.y, $b97b29b5fc8305c3$var$_vector.z);
        }
        return this;
    }
    transformDirection(m) {
        for(let i = 0, l = this.count; i < l; i++){
            $b97b29b5fc8305c3$var$_vector.fromBufferAttribute(this, i);
            $b97b29b5fc8305c3$var$_vector.transformDirection(m);
            this.setXYZ(i, $b97b29b5fc8305c3$var$_vector.x, $b97b29b5fc8305c3$var$_vector.y, $b97b29b5fc8305c3$var$_vector.z);
        }
        return this;
    }
    getComponent(index, component) {
        let value = this.array[index * this.data.stride + this.offset + component];
        if (this.normalized) value = (0, $7f727a3c7059d20d$export$be8b9fcbce8e8f70)(value, this.array);
        return value;
    }
    setComponent(index, component, value) {
        if (this.normalized) value = (0, $7f727a3c7059d20d$export$a3295358bff77e)(value, this.array);
        this.data.array[index * this.data.stride + this.offset + component] = value;
        return this;
    }
    setX(index, x) {
        if (this.normalized) x = (0, $7f727a3c7059d20d$export$a3295358bff77e)(x, this.array);
        this.data.array[index * this.data.stride + this.offset] = x;
        return this;
    }
    setY(index, y) {
        if (this.normalized) y = (0, $7f727a3c7059d20d$export$a3295358bff77e)(y, this.array);
        this.data.array[index * this.data.stride + this.offset + 1] = y;
        return this;
    }
    setZ(index, z) {
        if (this.normalized) z = (0, $7f727a3c7059d20d$export$a3295358bff77e)(z, this.array);
        this.data.array[index * this.data.stride + this.offset + 2] = z;
        return this;
    }
    setW(index, w) {
        if (this.normalized) w = (0, $7f727a3c7059d20d$export$a3295358bff77e)(w, this.array);
        this.data.array[index * this.data.stride + this.offset + 3] = w;
        return this;
    }
    getX(index) {
        let x = this.data.array[index * this.data.stride + this.offset];
        if (this.normalized) x = (0, $7f727a3c7059d20d$export$be8b9fcbce8e8f70)(x, this.array);
        return x;
    }
    getY(index) {
        let y = this.data.array[index * this.data.stride + this.offset + 1];
        if (this.normalized) y = (0, $7f727a3c7059d20d$export$be8b9fcbce8e8f70)(y, this.array);
        return y;
    }
    getZ(index) {
        let z = this.data.array[index * this.data.stride + this.offset + 2];
        if (this.normalized) z = (0, $7f727a3c7059d20d$export$be8b9fcbce8e8f70)(z, this.array);
        return z;
    }
    getW(index) {
        let w = this.data.array[index * this.data.stride + this.offset + 3];
        if (this.normalized) w = (0, $7f727a3c7059d20d$export$be8b9fcbce8e8f70)(w, this.array);
        return w;
    }
    setXY(index, x, y) {
        index = index * this.data.stride + this.offset;
        if (this.normalized) {
            x = (0, $7f727a3c7059d20d$export$a3295358bff77e)(x, this.array);
            y = (0, $7f727a3c7059d20d$export$a3295358bff77e)(y, this.array);
        }
        this.data.array[index + 0] = x;
        this.data.array[index + 1] = y;
        return this;
    }
    setXYZ(index, x, y, z) {
        index = index * this.data.stride + this.offset;
        if (this.normalized) {
            x = (0, $7f727a3c7059d20d$export$a3295358bff77e)(x, this.array);
            y = (0, $7f727a3c7059d20d$export$a3295358bff77e)(y, this.array);
            z = (0, $7f727a3c7059d20d$export$a3295358bff77e)(z, this.array);
        }
        this.data.array[index + 0] = x;
        this.data.array[index + 1] = y;
        this.data.array[index + 2] = z;
        return this;
    }
    setXYZW(index, x, y, z, w) {
        index = index * this.data.stride + this.offset;
        if (this.normalized) {
            x = (0, $7f727a3c7059d20d$export$a3295358bff77e)(x, this.array);
            y = (0, $7f727a3c7059d20d$export$a3295358bff77e)(y, this.array);
            z = (0, $7f727a3c7059d20d$export$a3295358bff77e)(z, this.array);
            w = (0, $7f727a3c7059d20d$export$a3295358bff77e)(w, this.array);
        }
        this.data.array[index + 0] = x;
        this.data.array[index + 1] = y;
        this.data.array[index + 2] = z;
        this.data.array[index + 3] = w;
        return this;
    }
    clone(data) {
        if (data === undefined) {
            console.log('THREE.InterleavedBufferAttribute.clone(): Cloning an interleaved buffer attribute will de-interleave buffer data.');
            const array = [];
            for(let i = 0; i < this.count; i++){
                const index = i * this.data.stride + this.offset;
                for(let j = 0; j < this.itemSize; j++)array.push(this.data.array[index + j]);
            }
            return new (0, $4b03383e684869fb$export$8dea267bd6bde117)(new this.array.constructor(array), this.itemSize, this.normalized);
        } else {
            if (data.interleavedBuffers === undefined) data.interleavedBuffers = {};
            if (data.interleavedBuffers[this.data.uuid] === undefined) data.interleavedBuffers[this.data.uuid] = this.data.clone(data);
            return new $b97b29b5fc8305c3$export$920b6d07334599c7(data.interleavedBuffers[this.data.uuid], this.itemSize, this.offset, this.normalized);
        }
    }
    toJSON(data) {
        if (data === undefined) {
            console.log('THREE.InterleavedBufferAttribute.toJSON(): Serializing an interleaved buffer attribute will de-interleave buffer data.');
            const array = [];
            for(let i = 0; i < this.count; i++){
                const index = i * this.data.stride + this.offset;
                for(let j = 0; j < this.itemSize; j++)array.push(this.data.array[index + j]);
            }
            // de-interleave data and save it as an ordinary buffer attribute for now
            return {
                itemSize: this.itemSize,
                type: this.array.constructor.name,
                array: array,
                normalized: this.normalized
            };
        } else {
            // save as true interleaved attribute
            if (data.interleavedBuffers === undefined) data.interleavedBuffers = {};
            if (data.interleavedBuffers[this.data.uuid] === undefined) data.interleavedBuffers[this.data.uuid] = this.data.toJSON(data);
            return {
                isInterleavedBufferAttribute: true,
                itemSize: this.itemSize,
                data: this.data.uuid,
                offset: this.offset,
                normalized: this.normalized
            };
        }
    }
}




class $47ee85f41ba63d35$export$3d5cd879f108f53f {
    constructor(array, stride){
        this.isInterleavedBuffer = true;
        this.array = array;
        this.stride = stride;
        this.count = array !== undefined ? array.length / stride : 0;
        this.usage = (0, $cb5ee595c0f892af$export$763e8360f4d7f77d);
        this.updateRanges = [];
        this.version = 0;
        this.uuid = $7f727a3c7059d20d$export$e73c8bd0f20705a();
    }
    onUploadCallback() {}
    set needsUpdate(value) {
        if (value === true) this.version++;
    }
    setUsage(value) {
        this.usage = value;
        return this;
    }
    addUpdateRange(start, count) {
        this.updateRanges.push({
            start: start,
            count: count
        });
    }
    clearUpdateRanges() {
        this.updateRanges.length = 0;
    }
    copy(source) {
        this.array = new source.array.constructor(source.array);
        this.count = source.count;
        this.stride = source.stride;
        this.usage = source.usage;
        return this;
    }
    copyAt(index1, attribute, index2) {
        index1 *= this.stride;
        index2 *= attribute.stride;
        for(let i = 0, l = this.stride; i < l; i++)this.array[index1 + i] = attribute.array[index2 + i];
        return this;
    }
    set(value, offset = 0) {
        this.array.set(value, offset);
        return this;
    }
    clone(data) {
        if (data.arrayBuffers === undefined) data.arrayBuffers = {};
        if (this.array.buffer._uuid === undefined) this.array.buffer._uuid = $7f727a3c7059d20d$export$e73c8bd0f20705a();
        if (data.arrayBuffers[this.array.buffer._uuid] === undefined) data.arrayBuffers[this.array.buffer._uuid] = this.array.slice(0).buffer;
        const array = new this.array.constructor(data.arrayBuffers[this.array.buffer._uuid]);
        const ib = new this.constructor(array, this.stride);
        ib.setUsage(this.usage);
        return ib;
    }
    onUpload(callback) {
        this.onUploadCallback = callback;
        return this;
    }
    toJSON(data) {
        if (data.arrayBuffers === undefined) data.arrayBuffers = {};
        // generate UUID for array buffer if necessary
        if (this.array.buffer._uuid === undefined) this.array.buffer._uuid = $7f727a3c7059d20d$export$e73c8bd0f20705a();
        if (data.arrayBuffers[this.array.buffer._uuid] === undefined) data.arrayBuffers[this.array.buffer._uuid] = Array.from(new Uint32Array(this.array.buffer));
        //
        return {
            uuid: this.uuid,
            buffer: this.array.buffer._uuid,
            type: this.array.constructor.name,
            stride: this.stride
        };
    }
}



class $48306ea9f4feeeae$var$BufferAttributeNode extends (0, $87507ebf571fbdf4$export$2e2bcd8739ae039) {
    static get type() {
        return 'BufferAttributeNode';
    }
    constructor(value, bufferType = null, bufferStride = 0, bufferOffset = 0){
        super(value, bufferType);
        this.isBufferNode = true;
        this.bufferType = bufferType;
        this.bufferStride = bufferStride;
        this.bufferOffset = bufferOffset;
        this.usage = (0, $cb5ee595c0f892af$export$763e8360f4d7f77d);
        this.instanced = false;
        this.attribute = null;
        this.global = true;
        if (value && value.isBufferAttribute === true) {
            this.attribute = value;
            this.usage = value.usage;
            this.instanced = value.isInstancedBufferAttribute;
        }
    }
    getHash(builder) {
        if (this.bufferStride === 0 && this.bufferOffset === 0) {
            let bufferData = builder.globalCache.getData(this.value);
            if (bufferData === undefined) {
                bufferData = {
                    node: this
                };
                builder.globalCache.setData(this.value, bufferData);
            }
            return bufferData.node.uuid;
        }
        return this.uuid;
    }
    getNodeType(builder) {
        if (this.bufferType === null) this.bufferType = builder.getTypeFromAttribute(this.attribute);
        return this.bufferType;
    }
    setup(builder) {
        if (this.attribute !== null) return;
        const type = this.getNodeType(builder);
        const array = this.value;
        const itemSize = builder.getTypeLength(type);
        const stride = this.bufferStride || itemSize;
        const offset = this.bufferOffset;
        const buffer = array.isInterleavedBuffer === true ? array : new (0, $47ee85f41ba63d35$export$3d5cd879f108f53f)(array, stride);
        const bufferAttribute = new (0, $b97b29b5fc8305c3$export$920b6d07334599c7)(buffer, itemSize, offset);
        buffer.setUsage(this.usage);
        this.attribute = bufferAttribute;
        this.attribute.isInstancedBufferAttribute = this.instanced; // @TODO: Add a possible: InstancedInterleavedBufferAttribute
    }
    generate(builder) {
        const nodeType = this.getNodeType(builder);
        const nodeAttribute = builder.getBufferAttributeFromNode(this, nodeType);
        const propertyName = builder.getPropertyName(nodeAttribute);
        let output = null;
        if (builder.shaderStage === 'vertex' || builder.shaderStage === 'compute') {
            this.name = propertyName;
            output = propertyName;
        } else {
            const nodeVarying = (0, $c497538e811cb09b$export$3f47f02b8134ef8a)(this);
            output = nodeVarying.build(builder, nodeType);
        }
        return output;
    }
    getInputType() {
        return 'bufferAttribute';
    }
    setUsage(value) {
        this.usage = value;
        if (this.attribute && this.attribute.isBufferAttribute === true) this.attribute.usage = value;
        return this;
    }
    setInstanced(value) {
        this.instanced = value;
        return this;
    }
}
var $48306ea9f4feeeae$export$2e2bcd8739ae039 = $48306ea9f4feeeae$var$BufferAttributeNode;
const $48306ea9f4feeeae$export$1a0889be1cc680b2 = (array, type, stride, offset)=>(0, $d5b7ee61758b2e81$export$e97474e17004dd41)(new $48306ea9f4feeeae$var$BufferAttributeNode(array, type, stride, offset));
const $48306ea9f4feeeae$export$41a4a8837b048fd7 = (array, type, stride, offset)=>$48306ea9f4feeeae$export$1a0889be1cc680b2(array, type, stride, offset).setUsage((0, $cb5ee595c0f892af$export$8505d14ac8546ca));
const $48306ea9f4feeeae$export$6776ccefa3811157 = (array, type, stride, offset)=>$48306ea9f4feeeae$export$1a0889be1cc680b2(array, type, stride, offset).setInstanced(true);
const $48306ea9f4feeeae$export$35d450082ae9e736 = (array, type, stride, offset)=>$48306ea9f4feeeae$export$41a4a8837b048fd7(array, type, stride, offset).setInstanced(true);
(0, $d5b7ee61758b2e81$export$5f439e138e9dc985)('toAttribute', (bufferNode)=>$48306ea9f4feeeae$export$1a0889be1cc680b2(bufferNode.value));





class $677fd3c0ed990cf5$var$ComputeNode extends (0, $65e77d5c3a27a66a$export$2e2bcd8739ae039) {
    static get type() {
        return 'ComputeNode';
    }
    constructor(computeNode, count, workgroupSize = [
        64
    ]){
        super('void');
        this.isComputeNode = true;
        this.computeNode = computeNode;
        this.count = count;
        this.workgroupSize = workgroupSize;
        this.dispatchCount = 0;
        this.version = 1;
        this.updateBeforeType = (0, $ddcfecb7fbba5d74$export$26f7a8bbd9469530).OBJECT;
        this.onInitFunction = null;
        this.updateDispatchCount();
    }
    dispose() {
        this.dispatchEvent({
            type: 'dispose'
        });
    }
    set needsUpdate(value) {
        if (value === true) this.version++;
    }
    updateDispatchCount() {
        const { count: count, workgroupSize: workgroupSize } = this;
        let size = workgroupSize[0];
        for(let i = 1; i < workgroupSize.length; i++)size *= workgroupSize[i];
        this.dispatchCount = Math.ceil(count / size);
    }
    onInit(callback) {
        this.onInitFunction = callback;
        return this;
    }
    updateBefore({ renderer: renderer }) {
        renderer.compute(this);
    }
    generate(builder) {
        const { shaderStage: shaderStage } = builder;
        if (shaderStage === 'compute') {
            const snippet = this.computeNode.build(builder, 'void');
            if (snippet !== '') builder.addLineFlowCode(snippet, this);
        }
    }
}
var $677fd3c0ed990cf5$export$2e2bcd8739ae039 = $677fd3c0ed990cf5$var$ComputeNode;
const $677fd3c0ed990cf5$export$3b12cb22b12b954b = (node, count, workgroupSize)=>(0, $d5b7ee61758b2e81$export$e97474e17004dd41)(new $677fd3c0ed990cf5$var$ComputeNode((0, $d5b7ee61758b2e81$export$e97474e17004dd41)(node), count, workgroupSize));
(0, $d5b7ee61758b2e81$export$5f439e138e9dc985)('compute', $677fd3c0ed990cf5$export$3b12cb22b12b954b);




class $c6f397d6620fd99d$var$CacheNode extends (0, $65e77d5c3a27a66a$export$2e2bcd8739ae039) {
    static get type() {
        return 'CacheNode';
    }
    constructor(node, parent = true){
        super();
        this.node = node;
        this.parent = parent;
        this.isCacheNode = true;
    }
    getNodeType(builder) {
        return this.node.getNodeType(builder);
    }
    build(builder, ...params) {
        const previousCache = builder.getCache();
        const cache = builder.getCacheFromNode(this, this.parent);
        builder.setCache(cache);
        const data = this.node.build(builder, ...params);
        builder.setCache(previousCache);
        return data;
    }
}
var $c6f397d6620fd99d$export$2e2bcd8739ae039 = $c6f397d6620fd99d$var$CacheNode;
const $c6f397d6620fd99d$export$69a3209f1a06c04d = (node, ...params)=>(0, $d5b7ee61758b2e81$export$e97474e17004dd41)(new $c6f397d6620fd99d$var$CacheNode((0, $d5b7ee61758b2e81$export$e97474e17004dd41)(node), ...params));
(0, $d5b7ee61758b2e81$export$5f439e138e9dc985)('cache', $c6f397d6620fd99d$export$69a3209f1a06c04d);




class $514f7fc7326d57a6$var$BypassNode extends (0, $65e77d5c3a27a66a$export$2e2bcd8739ae039) {
    static get type() {
        return 'BypassNode';
    }
    constructor(returnNode, callNode){
        super();
        this.isBypassNode = true;
        this.outputNode = returnNode;
        this.callNode = callNode;
    }
    getNodeType(builder) {
        return this.outputNode.getNodeType(builder);
    }
    generate(builder) {
        const snippet = this.callNode.build(builder, 'void');
        if (snippet !== '') builder.addLineFlowCode(snippet, this);
        return this.outputNode.build(builder);
    }
}
var $514f7fc7326d57a6$export$2e2bcd8739ae039 = $514f7fc7326d57a6$var$BypassNode;
const $514f7fc7326d57a6$export$49c50429ca9c5609 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$60d11c6747b7deba)($514f7fc7326d57a6$var$BypassNode);
(0, $d5b7ee61758b2e81$export$5f439e138e9dc985)('bypass', $514f7fc7326d57a6$export$49c50429ca9c5609);




class $14239b34949416cc$var$RemapNode extends (0, $65e77d5c3a27a66a$export$2e2bcd8739ae039) {
    static get type() {
        return 'RemapNode';
    }
    constructor(node, inLowNode, inHighNode, outLowNode = (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(0), outHighNode = (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(1)){
        super();
        this.node = node;
        this.inLowNode = inLowNode;
        this.inHighNode = inHighNode;
        this.outLowNode = outLowNode;
        this.outHighNode = outHighNode;
        this.doClamp = true;
    }
    setup() {
        const { node: node, inLowNode: inLowNode, inHighNode: inHighNode, outLowNode: outLowNode, outHighNode: outHighNode, doClamp: doClamp } = this;
        let t = node.sub(inLowNode).div(inHighNode.sub(inLowNode));
        if (doClamp === true) t = t.clamp();
        return t.mul(outHighNode.sub(outLowNode)).add(outLowNode);
    }
}
var $14239b34949416cc$export$2e2bcd8739ae039 = $14239b34949416cc$var$RemapNode;
const $14239b34949416cc$export$aee1dbae5de2db9d = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$60d11c6747b7deba)($14239b34949416cc$var$RemapNode, null, null, {
    doClamp: false
});
const $14239b34949416cc$export$806e65b7e825a84a = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$60d11c6747b7deba)($14239b34949416cc$var$RemapNode);
(0, $d5b7ee61758b2e81$export$5f439e138e9dc985)('remap', $14239b34949416cc$export$aee1dbae5de2db9d);
(0, $d5b7ee61758b2e81$export$5f439e138e9dc985)('remapClamp', $14239b34949416cc$export$806e65b7e825a84a);




class $687bc12bcf0ed73b$var$ExpressionNode extends (0, $65e77d5c3a27a66a$export$2e2bcd8739ae039) {
    static get type() {
        return 'ExpressionNode';
    }
    constructor(snippet = '', nodeType = 'void'){
        super(nodeType);
        this.snippet = snippet;
    }
    generate(builder, output) {
        const type = this.getNodeType(builder);
        const snippet = this.snippet;
        if (type === 'void') builder.addLineFlowCode(snippet, this);
        else return builder.format(`( ${snippet} )`, type, output);
    }
}
var $687bc12bcf0ed73b$export$2e2bcd8739ae039 = $687bc12bcf0ed73b$var$ExpressionNode;
const $687bc12bcf0ed73b$export$743d82c2fd345b72 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$60d11c6747b7deba)($687bc12bcf0ed73b$var$ExpressionNode);





const $914c0697efacd7d7$export$54c2610bf0c7a9f5 = (conditional)=>(conditional ? (0, $cb309bf1d9ed8a72$export$2e6c959c16ff56b8)(conditional, (0, $687bc12bcf0ed73b$export$743d82c2fd345b72)('discard')) : (0, $687bc12bcf0ed73b$export$743d82c2fd345b72)('discard')).append();
const $914c0697efacd7d7$export$e87088760199ee7a = ()=>(0, $687bc12bcf0ed73b$export$743d82c2fd345b72)('return').append();
(0, $d5b7ee61758b2e81$export$5f439e138e9dc985)('discard', $914c0697efacd7d7$export$54c2610bf0c7a9f5);






class $af4e56b22b7083f1$var$RenderOutputNode extends (0, $75c45ed2361c955f$export$2e2bcd8739ae039) {
    static get type() {
        return 'RenderOutputNode';
    }
    constructor(colorNode, toneMapping, outputColorSpace){
        super('vec4');
        this.colorNode = colorNode;
        this.toneMapping = toneMapping;
        this.outputColorSpace = outputColorSpace;
        this.isRenderOutput = true;
    }
    setup({ context: context }) {
        let outputNode = this.colorNode || context.color;
        // tone mapping
        const toneMapping = (this.toneMapping !== null ? this.toneMapping : context.toneMapping) || (0, $cb5ee595c0f892af$export$9fcb6b4294603b2);
        const outputColorSpace = (this.outputColorSpace !== null ? this.outputColorSpace : context.outputColorSpace) || (0, $cb5ee595c0f892af$export$bfcb490c2dd3db51);
        if (toneMapping !== (0, $cb5ee595c0f892af$export$9fcb6b4294603b2)) outputNode = outputNode.toneMapping(toneMapping);
        // working to output color space
        if (outputColorSpace !== (0, $cb5ee595c0f892af$export$bfcb490c2dd3db51) && outputColorSpace !== (0, $46d4f6f1be9702a8$export$5e6fd513f44698c).workingColorSpace) outputNode = outputNode.workingToColorSpace(outputColorSpace);
        return outputNode;
    }
}
var $af4e56b22b7083f1$export$2e2bcd8739ae039 = $af4e56b22b7083f1$var$RenderOutputNode;
const $af4e56b22b7083f1$export$da8e8db2a2454039 = (color, toneMapping = null, outputColorSpace = null)=>(0, $d5b7ee61758b2e81$export$e97474e17004dd41)(new $af4e56b22b7083f1$var$RenderOutputNode((0, $d5b7ee61758b2e81$export$e97474e17004dd41)(color), toneMapping, outputColorSpace));
(0, $d5b7ee61758b2e81$export$5f439e138e9dc985)('renderOutput', $af4e56b22b7083f1$export$da8e8db2a2454039);


function $ac4c92876d353456$export$9faee53f34e0de2f(name /*, nodeElement*/ ) {
    console.warn('THREE.TSLBase: AddNodeElement has been removed in favor of tree-shaking. Trying add', name);
}


class $700a78a0d988d216$var$AttributeNode extends (0, $65e77d5c3a27a66a$export$2e2bcd8739ae039) {
    static get type() {
        return 'AttributeNode';
    }
    constructor(attributeName, nodeType = null){
        super(nodeType);
        this.global = true;
        this._attributeName = attributeName;
    }
    getHash(builder) {
        return this.getAttributeName(builder);
    }
    getNodeType(builder) {
        let nodeType = this.nodeType;
        if (nodeType === null) {
            const attributeName = this.getAttributeName(builder);
            if (builder.hasGeometryAttribute(attributeName)) {
                const attribute = builder.geometry.getAttribute(attributeName);
                nodeType = builder.getTypeFromAttribute(attribute);
            } else nodeType = 'float';
        }
        return nodeType;
    }
    setAttributeName(attributeName) {
        this._attributeName = attributeName;
        return this;
    }
    getAttributeName() {
        return this._attributeName;
    }
    generate(builder) {
        const attributeName = this.getAttributeName(builder);
        const nodeType = this.getNodeType(builder);
        const geometryAttribute = builder.hasGeometryAttribute(attributeName);
        if (geometryAttribute === true) {
            const attribute = builder.geometry.getAttribute(attributeName);
            const attributeType = builder.getTypeFromAttribute(attribute);
            const nodeAttribute = builder.getAttribute(attributeName, attributeType);
            if (builder.shaderStage === 'vertex') return builder.format(nodeAttribute.name, attributeType, nodeType);
            else {
                const nodeVarying = (0, $c497538e811cb09b$export$3f47f02b8134ef8a)(this);
                return nodeVarying.build(builder, nodeType);
            }
        } else {
            console.warn(`AttributeNode: Vertex attribute "${attributeName}" not found on geometry.`);
            return builder.generateConst(nodeType);
        }
    }
    serialize(data) {
        super.serialize(data);
        data.global = this.global;
        data._attributeName = this._attributeName;
    }
    deserialize(data) {
        super.deserialize(data);
        this.global = data.global;
        this._attributeName = data._attributeName;
    }
}
var $700a78a0d988d216$export$2e2bcd8739ae039 = $700a78a0d988d216$var$AttributeNode;
const $700a78a0d988d216$export$af4b9a83f4b00434 = (name, nodeType)=>(0, $d5b7ee61758b2e81$export$e97474e17004dd41)(new $700a78a0d988d216$var$AttributeNode(name, nodeType));







class $c9c236abfeae4cd5$var$IndexNode extends (0, $65e77d5c3a27a66a$export$2e2bcd8739ae039) {
    static get type() {
        return 'IndexNode';
    }
    constructor(scope){
        super('uint');
        this.scope = scope;
        this.isInstanceIndexNode = true;
    }
    generate(builder) {
        const nodeType = this.getNodeType(builder);
        const scope = this.scope;
        let propertyName;
        if (scope === $c9c236abfeae4cd5$var$IndexNode.VERTEX) // The index of a vertex within a mesh.
        propertyName = builder.getVertexIndex();
        else if (scope === $c9c236abfeae4cd5$var$IndexNode.INSTANCE) // The index of either a mesh instance or an invocation of a compute shader.
        propertyName = builder.getInstanceIndex();
        else if (scope === $c9c236abfeae4cd5$var$IndexNode.DRAW) // The index of a draw call.
        propertyName = builder.getDrawIndex();
        else if (scope === $c9c236abfeae4cd5$var$IndexNode.INVOCATION_LOCAL) // The index of a compute invocation within the scope of a workgroup load.
        propertyName = builder.getInvocationLocalIndex();
        else if (scope === $c9c236abfeae4cd5$var$IndexNode.INVOCATION_SUBGROUP) // The index of a compute invocation within the scope of a subgroup.
        propertyName = builder.getInvocationSubgroupIndex();
        else if (scope === $c9c236abfeae4cd5$var$IndexNode.SUBGROUP) // The index of the subgroup the current compute invocation belongs to.
        propertyName = builder.getSubgroupIndex();
        else throw new Error('THREE.IndexNode: Unknown scope: ' + scope);
        let output;
        if (builder.shaderStage === 'vertex' || builder.shaderStage === 'compute') output = propertyName;
        else {
            const nodeVarying = (0, $c497538e811cb09b$export$3f47f02b8134ef8a)(this);
            output = nodeVarying.build(builder, nodeType);
        }
        return output;
    }
}
$c9c236abfeae4cd5$var$IndexNode.VERTEX = 'vertex';
$c9c236abfeae4cd5$var$IndexNode.INSTANCE = 'instance';
$c9c236abfeae4cd5$var$IndexNode.SUBGROUP = 'subgroup';
$c9c236abfeae4cd5$var$IndexNode.INVOCATION_LOCAL = 'invocationLocal';
$c9c236abfeae4cd5$var$IndexNode.INVOCATION_SUBGROUP = 'invocationSubgroup';
$c9c236abfeae4cd5$var$IndexNode.DRAW = 'draw';
var $c9c236abfeae4cd5$export$2e2bcd8739ae039 = $c9c236abfeae4cd5$var$IndexNode;
const $c9c236abfeae4cd5$export$df3f95685a193815 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$25c7ddd7ae9b45f3)($c9c236abfeae4cd5$var$IndexNode, $c9c236abfeae4cd5$var$IndexNode.VERTEX);
const $c9c236abfeae4cd5$export$3691cd4c77fcb2c4 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$25c7ddd7ae9b45f3)($c9c236abfeae4cd5$var$IndexNode, $c9c236abfeae4cd5$var$IndexNode.INSTANCE);
const $c9c236abfeae4cd5$export$65a5ed6055a6914c = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$25c7ddd7ae9b45f3)($c9c236abfeae4cd5$var$IndexNode, $c9c236abfeae4cd5$var$IndexNode.SUBGROUP);
const $c9c236abfeae4cd5$export$22244425bd2c2c31 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$25c7ddd7ae9b45f3)($c9c236abfeae4cd5$var$IndexNode, $c9c236abfeae4cd5$var$IndexNode.INVOCATION_SUBGROUP);
const $c9c236abfeae4cd5$export$6d54c76ba7596dfd = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$25c7ddd7ae9b45f3)($c9c236abfeae4cd5$var$IndexNode, $c9c236abfeae4cd5$var$IndexNode.INVOCATION_LOCAL);
const $c9c236abfeae4cd5$export$34e05495de4c814 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$25c7ddd7ae9b45f3)($c9c236abfeae4cd5$var$IndexNode, $c9c236abfeae4cd5$var$IndexNode.DRAW);




class $87623609ceb778b2$var$ParameterNode extends (0, $dd761eb0c8b88ca7$export$2e2bcd8739ae039) {
    static get type() {
        return 'ParameterNode';
    }
    constructor(nodeType, name = null){
        super(nodeType, name);
        this.isParameterNode = true;
    }
    getHash() {
        return this.uuid;
    }
    generate() {
        return this.name;
    }
}
var $87623609ceb778b2$export$2e2bcd8739ae039 = $87623609ceb778b2$var$ParameterNode;
const $87623609ceb778b2$export$7eaa70c6742f3c7c = (type, name)=>(0, $d5b7ee61758b2e81$export$e97474e17004dd41)(new $87623609ceb778b2$var$ParameterNode(type, name));






class $e40519046ea5c491$var$StackNode extends (0, $65e77d5c3a27a66a$export$2e2bcd8739ae039) {
    static get type() {
        return 'StackNode';
    }
    constructor(parent = null){
        super();
        this.nodes = [];
        this.outputNode = null;
        this.parent = parent;
        this._currentCond = null;
        this.isStackNode = true;
    }
    getNodeType(builder) {
        return this.outputNode ? this.outputNode.getNodeType(builder) : 'void';
    }
    add(node) {
        this.nodes.push(node);
        return this;
    }
    If(boolNode, method) {
        const methodNode = new (0, $d5b7ee61758b2e81$export$7d95ef31865f68e8)(method);
        this._currentCond = (0, $cb309bf1d9ed8a72$export$2e6c959c16ff56b8)(boolNode, methodNode);
        return this.add(this._currentCond);
    }
    ElseIf(boolNode, method) {
        const methodNode = new (0, $d5b7ee61758b2e81$export$7d95ef31865f68e8)(method);
        const ifNode = (0, $cb309bf1d9ed8a72$export$2e6c959c16ff56b8)(boolNode, methodNode);
        this._currentCond.elseNode = ifNode;
        this._currentCond = ifNode;
        return this;
    }
    Else(method) {
        this._currentCond.elseNode = new (0, $d5b7ee61758b2e81$export$7d95ef31865f68e8)(method);
        return this;
    }
    build(builder, ...params) {
        const previousStack = (0, $d5b7ee61758b2e81$export$c3090653b26dfebd)();
        (0, $d5b7ee61758b2e81$export$50a78b1c198bcc62)(this);
        for (const node of this.nodes)node.build(builder, 'void');
        (0, $d5b7ee61758b2e81$export$50a78b1c198bcc62)(previousStack);
        return this.outputNode ? this.outputNode.build(builder, ...params) : super.build(builder, ...params);
    }
    //
    else(...params) {
        console.warn('TSL.StackNode: .else() has been renamed to .Else().');
        return this.Else(...params);
    }
    elseif(...params) {
        console.warn('TSL.StackNode: .elseif() has been renamed to .ElseIf().');
        return this.ElseIf(...params);
    }
}
var $e40519046ea5c491$export$2e2bcd8739ae039 = $e40519046ea5c491$var$StackNode;
const $e40519046ea5c491$export$a57ab32f40f83ea9 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$60d11c6747b7deba)($e40519046ea5c491$var$StackNode);







class $12ed5964e25eed24$var$StructTypeNode extends (0, $65e77d5c3a27a66a$export$2e2bcd8739ae039) {
    static get type() {
        return 'StructTypeNode';
    }
    constructor(types){
        super();
        this.types = types;
        this.isStructTypeNode = true;
    }
    getMemberTypes() {
        return this.types;
    }
}
var $12ed5964e25eed24$export$2e2bcd8739ae039 = $12ed5964e25eed24$var$StructTypeNode;



class $3df4cdc4230965b1$var$OutputStructNode extends (0, $65e77d5c3a27a66a$export$2e2bcd8739ae039) {
    static get type() {
        return 'OutputStructNode';
    }
    constructor(...members){
        super();
        this.members = members;
        this.isOutputStructNode = true;
    }
    setup(builder) {
        super.setup(builder);
        const members = this.members;
        const types = [];
        for(let i = 0; i < members.length; i++)types.push(members[i].getNodeType(builder));
        this.nodeType = builder.getStructTypeFromNode(new (0, $12ed5964e25eed24$export$2e2bcd8739ae039)(types)).name;
    }
    generate(builder, output) {
        const propertyName = builder.getOutputStructName();
        const members = this.members;
        const structPrefix = propertyName !== '' ? propertyName + '.' : '';
        for(let i = 0; i < members.length; i++){
            const snippet = members[i].build(builder, output);
            builder.addLineFlowCode(`${structPrefix}m${i} = ${snippet}`, this);
        }
        return propertyName;
    }
}
var $3df4cdc4230965b1$export$2e2bcd8739ae039 = $3df4cdc4230965b1$var$OutputStructNode;
const $3df4cdc4230965b1$export$7a34be181e1b3f6e = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$60d11c6747b7deba)($3df4cdc4230965b1$var$OutputStructNode);




function $194f27e0ebfb5456$export$f201bdebfff8792d(textures, name) {
    for(let i = 0; i < textures.length; i++){
        if (textures[i].name === name) return i;
    }
    return -1;
}
class $194f27e0ebfb5456$var$MRTNode extends (0, $3df4cdc4230965b1$export$2e2bcd8739ae039) {
    static get type() {
        return 'MRTNode';
    }
    constructor(outputNodes){
        super();
        this.outputNodes = outputNodes;
        this.isMRTNode = true;
    }
    has(name) {
        return this.outputNodes[name] !== undefined;
    }
    get(name) {
        return this.outputNodes[name];
    }
    merge(mrtNode) {
        const outputs = {
            ...this.outputNodes,
            ...mrtNode.outputNodes
        };
        return $194f27e0ebfb5456$export$aa2401b4f475b182(outputs);
    }
    setup(builder) {
        const outputNodes = this.outputNodes;
        const mrt = builder.renderer.getRenderTarget();
        const members = [];
        const textures = mrt.textures;
        for(const name in outputNodes){
            const index = $194f27e0ebfb5456$export$f201bdebfff8792d(textures, name);
            members[index] = (0, $d5b7ee61758b2e81$export$6dba2a1f0d609415)(outputNodes[name]);
        }
        this.members = members;
        return super.setup(builder);
    }
}
var $194f27e0ebfb5456$export$2e2bcd8739ae039 = $194f27e0ebfb5456$var$MRTNode;
const $194f27e0ebfb5456$export$aa2401b4f475b182 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$60d11c6747b7deba)($194f27e0ebfb5456$var$MRTNode);



const $6197d5f5994486e7$export$d6af199866bfb566 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$b076717d71a1a47f)(([seed])=>{
    // Taken from https://www.shadertoy.com/view/XlGcRh, originally from pcg-random.org
    const state = seed.toUint().mul(747796405).add(2891336453);
    const word = state.shiftRight(state.shiftRight(28).add(4)).bitXor(state).mul(277803737);
    const result = word.shiftRight(22).bitXor(word);
    return result.toFloat().mul(1 / 2 ** 32); // Convert to range [0, 1)
});




const $aad252deba8cb894$export$b465b7f8c1ade29b = (x, k)=>(0, $f37ae0e58866c183$export$9c297f60e22e3389)((0, $3f1f23fea79ae256$export$6e3a27864ab166fe)(4.0, x.mul((0, $3f1f23fea79ae256$export$f93b5905241a7cca)(1.0, x))), k);
const $aad252deba8cb894$export$57790f9172054d97 = (x, k)=>x.lessThan(0.5) ? $aad252deba8cb894$export$b465b7f8c1ade29b(x.mul(2.0), k).div(2.0) : (0, $3f1f23fea79ae256$export$f93b5905241a7cca)(1.0, $aad252deba8cb894$export$b465b7f8c1ade29b((0, $3f1f23fea79ae256$export$6e3a27864ab166fe)((0, $3f1f23fea79ae256$export$f93b5905241a7cca)(1.0, x), 2.0), k).div(2.0));
const $aad252deba8cb894$export$b18e6ccd140f136b = (x, a, b)=>(0, $f37ae0e58866c183$export$9c297f60e22e3389)((0, $3f1f23fea79ae256$export$159d9494db57879b)((0, $f37ae0e58866c183$export$9c297f60e22e3389)(x, a), (0, $3f1f23fea79ae256$export$e16d8520af44a096)((0, $f37ae0e58866c183$export$9c297f60e22e3389)(x, a), (0, $f37ae0e58866c183$export$9c297f60e22e3389)((0, $3f1f23fea79ae256$export$f93b5905241a7cca)(1.0, x), b))), 1.0 / a);
const $aad252deba8cb894$export$494db73f2e58d3b = (x, k)=>(0, $f37ae0e58866c183$export$5de3937cb4b592ed)((0, $f37ae0e58866c183$export$6b5c1ceb16d01dc3).mul(k.mul(x).sub(1.0))).div((0, $f37ae0e58866c183$export$6b5c1ceb16d01dc3).mul(k.mul(x).sub(1.0)));


// https://github.com/cabbibo/glsl-tri-noise-3d



class $2a1578e0d4d8bf63$var$LoopNode extends (0, $65e77d5c3a27a66a$export$2e2bcd8739ae039) {
    static get type() {
        return 'LoopNode';
    }
    constructor(params = []){
        super();
        this.params = params;
    }
    getVarName(index) {
        return String.fromCharCode('i'.charCodeAt() + index);
    }
    getProperties(builder) {
        const properties = builder.getNodeProperties(this);
        if (properties.stackNode !== undefined) return properties;
        //
        const inputs = {};
        for(let i = 0, l = this.params.length - 1; i < l; i++){
            const param = this.params[i];
            const name = param.isNode !== true && param.name || this.getVarName(i);
            const type = param.isNode !== true && param.type || 'int';
            inputs[name] = (0, $687bc12bcf0ed73b$export$743d82c2fd345b72)(name, type);
        }
        const stack = builder.addStack(); // TODO: cache() it
        properties.returnsNode = this.params[this.params.length - 1](inputs, stack, builder);
        properties.stackNode = stack;
        builder.removeStack();
        return properties;
    }
    getNodeType(builder) {
        const { returnsNode: returnsNode } = this.getProperties(builder);
        return returnsNode ? returnsNode.getNodeType(builder) : 'void';
    }
    setup(builder) {
        // setup properties
        this.getProperties(builder);
    }
    generate(builder) {
        const properties = this.getProperties(builder);
        const params = this.params;
        const stackNode = properties.stackNode;
        for(let i = 0, l = params.length - 1; i < l; i++){
            const param = params[i];
            let start = null, end = null, name = null, type = null, condition = null, update = null;
            if (param.isNode) {
                type = 'int';
                name = this.getVarName(i);
                start = '0';
                end = param.build(builder, type);
                condition = '<';
            } else {
                type = param.type || 'int';
                name = param.name || this.getVarName(i);
                start = param.start;
                end = param.end;
                condition = param.condition;
                update = param.update;
                if (typeof start === 'number') start = builder.generateConst(type, start);
                else if (start && start.isNode) start = start.build(builder, type);
                if (typeof end === 'number') end = builder.generateConst(type, end);
                else if (end && end.isNode) end = end.build(builder, type);
                if (start !== undefined && end === undefined) {
                    start = start + ' - 1';
                    end = '0';
                    condition = '>=';
                } else if (end !== undefined && start === undefined) {
                    start = '0';
                    condition = '<';
                }
                if (condition === undefined) {
                    if (Number(start) > Number(end)) condition = '>=';
                    else condition = '<';
                }
            }
            const internalParam = {
                start: start,
                end: end,
                condition: condition
            };
            //
            const startSnippet = internalParam.start;
            const endSnippet = internalParam.end;
            let declarationSnippet = '';
            let conditionalSnippet = '';
            let updateSnippet = '';
            if (!update) {
                if (type === 'int' || type === 'uint') {
                    if (condition.includes('<')) update = '++';
                    else update = '--';
                } else if (condition.includes('<')) update = '+= 1.';
                else update = '-= 1.';
            }
            declarationSnippet += builder.getVar(type, name) + ' = ' + startSnippet;
            conditionalSnippet += name + ' ' + condition + ' ' + endSnippet;
            updateSnippet += name + ' ' + update;
            const forSnippet = `for ( ${declarationSnippet}; ${conditionalSnippet}; ${updateSnippet} )`;
            builder.addFlowCode((i === 0 ? '\n' : '') + builder.tab + forSnippet + ' {\n\n').addFlowTab();
        }
        const stackSnippet = stackNode.build(builder, 'void');
        const returnsSnippet = properties.returnsNode ? properties.returnsNode.build(builder) : '';
        builder.removeFlowTab().addFlowCode('\n' + builder.tab + stackSnippet);
        for(let i = 0, l = this.params.length - 1; i < l; i++)builder.addFlowCode((i === 0 ? '' : builder.tab) + '}\n\n').removeFlowTab();
        builder.addFlowTab();
        return returnsSnippet;
    }
}
var $2a1578e0d4d8bf63$export$2e2bcd8739ae039 = $2a1578e0d4d8bf63$var$LoopNode;
const $2a1578e0d4d8bf63$export$550acbd06a1f5a6a = (...params)=>(0, $d5b7ee61758b2e81$export$e97474e17004dd41)(new $2a1578e0d4d8bf63$var$LoopNode((0, $d5b7ee61758b2e81$export$34baf9226cd3d576)(params, 'int'))).append();
const $2a1578e0d4d8bf63$export$cbb542527a72964 = ()=>(0, $687bc12bcf0ed73b$export$743d82c2fd345b72)('continue').append();
const $2a1578e0d4d8bf63$export$c88190a7f68b38c0 = ()=>(0, $687bc12bcf0ed73b$export$743d82c2fd345b72)('break').append();
const $2a1578e0d4d8bf63$export$f9ef67375ddc185 = (...params)=>{
    console.warn('TSL.LoopNode: loop() has been renamed to Loop().');
    return $2a1578e0d4d8bf63$export$550acbd06a1f5a6a(...params);
};



const $ea77f2c7625e3ef3$export$80f38d456afce276 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$b076717d71a1a47f)(([x])=>{
    return x.fract().sub(.5).abs();
}).setLayout({
    name: 'tri',
    type: 'float',
    inputs: [
        {
            name: 'x',
            type: 'float'
        }
    ]
});
const $ea77f2c7625e3ef3$export$ac732b7bf15e2f51 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$b076717d71a1a47f)(([p])=>{
    return (0, $d5b7ee61758b2e81$export$9100789c9d999364)($ea77f2c7625e3ef3$export$80f38d456afce276(p.z.add($ea77f2c7625e3ef3$export$80f38d456afce276(p.y.mul(1.)))), $ea77f2c7625e3ef3$export$80f38d456afce276(p.z.add($ea77f2c7625e3ef3$export$80f38d456afce276(p.x.mul(1.)))), $ea77f2c7625e3ef3$export$80f38d456afce276(p.y.add($ea77f2c7625e3ef3$export$80f38d456afce276(p.x.mul(1.)))));
}).setLayout({
    name: 'tri3',
    type: 'vec3',
    inputs: [
        {
            name: 'p',
            type: 'vec3'
        }
    ]
});
const $ea77f2c7625e3ef3$export$89102c2848a0961f = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$b076717d71a1a47f)(([p_immutable, spd, time])=>{
    const p = (0, $d5b7ee61758b2e81$export$9100789c9d999364)(p_immutable).toVar();
    const z = (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(1.4).toVar();
    const rz = (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(0.0).toVar();
    const bp = (0, $d5b7ee61758b2e81$export$9100789c9d999364)(p).toVar();
    (0, $2a1578e0d4d8bf63$export$550acbd06a1f5a6a)({
        start: (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(0.0),
        end: (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(3.0),
        type: 'float',
        condition: '<='
    }, ()=>{
        const dg = (0, $d5b7ee61758b2e81$export$9100789c9d999364)($ea77f2c7625e3ef3$export$ac732b7bf15e2f51(bp.mul(2.0))).toVar();
        p.addAssign(dg.add(time.mul((0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(0.1).mul(spd))));
        bp.mulAssign(1.8);
        z.mulAssign(1.5);
        p.mulAssign(1.2);
        const t = (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)($ea77f2c7625e3ef3$export$80f38d456afce276(p.z.add($ea77f2c7625e3ef3$export$80f38d456afce276(p.x.add($ea77f2c7625e3ef3$export$80f38d456afce276(p.y)))))).toVar();
        rz.addAssign(t.div(z));
        bp.addAssign(0.14);
    });
    return rz;
}).setLayout({
    name: 'triNoise3D',
    type: 'float',
    inputs: [
        {
            name: 'p',
            type: 'vec3'
        },
        {
            name: 'spd',
            type: 'float'
        },
        {
            name: 'time',
            type: 'float'
        }
    ]
});









class $3d902719d8405cdf$var$Object3DNode extends (0, $65e77d5c3a27a66a$export$2e2bcd8739ae039) {
    static get type() {
        return 'Object3DNode';
    }
    constructor(scope, object3d = null){
        super();
        this.scope = scope;
        this.object3d = object3d;
        this.updateType = (0, $ddcfecb7fbba5d74$export$26f7a8bbd9469530).OBJECT;
        this._uniformNode = new (0, $5eb92bf12e57daab$export$2e2bcd8739ae039)(null);
    }
    getNodeType() {
        const scope = this.scope;
        if (scope === $3d902719d8405cdf$var$Object3DNode.WORLD_MATRIX) return 'mat4';
        else if (scope === $3d902719d8405cdf$var$Object3DNode.POSITION || scope === $3d902719d8405cdf$var$Object3DNode.VIEW_POSITION || scope === $3d902719d8405cdf$var$Object3DNode.DIRECTION || scope === $3d902719d8405cdf$var$Object3DNode.SCALE) return 'vec3';
    }
    update(frame) {
        const object = this.object3d;
        const uniformNode = this._uniformNode;
        const scope = this.scope;
        if (scope === $3d902719d8405cdf$var$Object3DNode.WORLD_MATRIX) uniformNode.value = object.matrixWorld;
        else if (scope === $3d902719d8405cdf$var$Object3DNode.POSITION) {
            uniformNode.value = uniformNode.value || new (0, $d7d0ac0e47013885$export$64b5c384219d3699)();
            uniformNode.value.setFromMatrixPosition(object.matrixWorld);
        } else if (scope === $3d902719d8405cdf$var$Object3DNode.SCALE) {
            uniformNode.value = uniformNode.value || new (0, $d7d0ac0e47013885$export$64b5c384219d3699)();
            uniformNode.value.setFromMatrixScale(object.matrixWorld);
        } else if (scope === $3d902719d8405cdf$var$Object3DNode.DIRECTION) {
            uniformNode.value = uniformNode.value || new (0, $d7d0ac0e47013885$export$64b5c384219d3699)();
            object.getWorldDirection(uniformNode.value);
        } else if (scope === $3d902719d8405cdf$var$Object3DNode.VIEW_POSITION) {
            const camera = frame.camera;
            uniformNode.value = uniformNode.value || new (0, $d7d0ac0e47013885$export$64b5c384219d3699)();
            uniformNode.value.setFromMatrixPosition(object.matrixWorld);
            uniformNode.value.applyMatrix4(camera.matrixWorldInverse);
        }
    }
    generate(builder) {
        const scope = this.scope;
        if (scope === $3d902719d8405cdf$var$Object3DNode.WORLD_MATRIX) this._uniformNode.nodeType = 'mat4';
        else if (scope === $3d902719d8405cdf$var$Object3DNode.POSITION || scope === $3d902719d8405cdf$var$Object3DNode.VIEW_POSITION || scope === $3d902719d8405cdf$var$Object3DNode.DIRECTION || scope === $3d902719d8405cdf$var$Object3DNode.SCALE) this._uniformNode.nodeType = 'vec3';
        return this._uniformNode.build(builder);
    }
    serialize(data) {
        super.serialize(data);
        data.scope = this.scope;
    }
    deserialize(data) {
        super.deserialize(data);
        this.scope = data.scope;
    }
}
$3d902719d8405cdf$var$Object3DNode.WORLD_MATRIX = 'worldMatrix';
$3d902719d8405cdf$var$Object3DNode.POSITION = 'position';
$3d902719d8405cdf$var$Object3DNode.SCALE = 'scale';
$3d902719d8405cdf$var$Object3DNode.VIEW_POSITION = 'viewPosition';
$3d902719d8405cdf$var$Object3DNode.DIRECTION = 'direction';
var $3d902719d8405cdf$export$2e2bcd8739ae039 = $3d902719d8405cdf$var$Object3DNode;
const $3d902719d8405cdf$export$78c250f1a3539268 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$60d11c6747b7deba)($3d902719d8405cdf$var$Object3DNode, $3d902719d8405cdf$var$Object3DNode.DIRECTION);
const $3d902719d8405cdf$export$a32b324f393b4dd2 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$60d11c6747b7deba)($3d902719d8405cdf$var$Object3DNode, $3d902719d8405cdf$var$Object3DNode.WORLD_MATRIX);
const $3d902719d8405cdf$export$85aefaa6fa23372c = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$60d11c6747b7deba)($3d902719d8405cdf$var$Object3DNode, $3d902719d8405cdf$var$Object3DNode.POSITION);
const $3d902719d8405cdf$export$9dcd283e27416a0c = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$60d11c6747b7deba)($3d902719d8405cdf$var$Object3DNode, $3d902719d8405cdf$var$Object3DNode.SCALE);
const $3d902719d8405cdf$export$a7c813ba72ca1af0 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$60d11c6747b7deba)($3d902719d8405cdf$var$Object3DNode, $3d902719d8405cdf$var$Object3DNode.VIEW_POSITION);








const $aa7db78c76b9331c$export$81bd96ee69286580 = /*@__PURE__*/ (0, $5eb92bf12e57daab$export$379455b567eff87d)('float').label('cameraNear').setGroup((0, $d2c0f7c752a63c18$export$a75a8692b47c7f9e)).onRenderUpdate(({ camera: camera })=>camera.near);
const $aa7db78c76b9331c$export$21e5768aeb8c5c46 = /*@__PURE__*/ (0, $5eb92bf12e57daab$export$379455b567eff87d)('float').label('cameraFar').setGroup((0, $d2c0f7c752a63c18$export$a75a8692b47c7f9e)).onRenderUpdate(({ camera: camera })=>camera.far);
const $aa7db78c76b9331c$export$dc8d743682f60b2d = /*@__PURE__*/ (0, $5eb92bf12e57daab$export$379455b567eff87d)('mat4').label('cameraProjectionMatrix').setGroup((0, $d2c0f7c752a63c18$export$a75a8692b47c7f9e)).onRenderUpdate(({ camera: camera })=>camera.projectionMatrix);
const $aa7db78c76b9331c$export$789ed3dde3cc5499 = /*@__PURE__*/ (0, $5eb92bf12e57daab$export$379455b567eff87d)('mat4').label('cameraProjectionMatrixInverse').setGroup((0, $d2c0f7c752a63c18$export$a75a8692b47c7f9e)).onRenderUpdate(({ camera: camera })=>camera.projectionMatrixInverse);
const $aa7db78c76b9331c$export$6f7d94c027189d78 = /*@__PURE__*/ (0, $5eb92bf12e57daab$export$379455b567eff87d)('mat4').label('cameraViewMatrix').setGroup((0, $d2c0f7c752a63c18$export$a75a8692b47c7f9e)).onRenderUpdate(({ camera: camera })=>camera.matrixWorldInverse);
const $aa7db78c76b9331c$export$4485c5f12754ea55 = /*@__PURE__*/ (0, $5eb92bf12e57daab$export$379455b567eff87d)('mat4').label('cameraWorldMatrix').setGroup((0, $d2c0f7c752a63c18$export$a75a8692b47c7f9e)).onRenderUpdate(({ camera: camera })=>camera.matrixWorld);
const $aa7db78c76b9331c$export$f4988b7d4c52308b = /*@__PURE__*/ (0, $5eb92bf12e57daab$export$379455b567eff87d)('mat3').label('cameraNormalMatrix').setGroup((0, $d2c0f7c752a63c18$export$a75a8692b47c7f9e)).onRenderUpdate(({ camera: camera })=>camera.normalMatrix);
const $aa7db78c76b9331c$export$3d9982e937097c50 = /*@__PURE__*/ (0, $5eb92bf12e57daab$export$379455b567eff87d)(new (0, $d7d0ac0e47013885$export$64b5c384219d3699)()).label('cameraPosition').setGroup((0, $d2c0f7c752a63c18$export$a75a8692b47c7f9e)).onRenderUpdate(({ camera: camera }, self)=>self.value.setFromMatrixPosition(camera.matrixWorld));



class $c03c6edd36966f29$var$ModelNode extends (0, $3d902719d8405cdf$export$2e2bcd8739ae039) {
    static get type() {
        return 'ModelNode';
    }
    constructor(scope){
        super(scope);
    }
    update(frame) {
        this.object3d = frame.object;
        super.update(frame);
    }
}
var $c03c6edd36966f29$export$2e2bcd8739ae039 = $c03c6edd36966f29$var$ModelNode;
const $c03c6edd36966f29$export$d635ba4b1685c241 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$25c7ddd7ae9b45f3)($c03c6edd36966f29$var$ModelNode, $c03c6edd36966f29$var$ModelNode.DIRECTION);
const $c03c6edd36966f29$export$e1011125af6f8b40 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$25c7ddd7ae9b45f3)($c03c6edd36966f29$var$ModelNode, $c03c6edd36966f29$var$ModelNode.WORLD_MATRIX);
const $c03c6edd36966f29$export$daa633a040a2411 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$25c7ddd7ae9b45f3)($c03c6edd36966f29$var$ModelNode, $c03c6edd36966f29$var$ModelNode.POSITION);
const $c03c6edd36966f29$export$7ff78118323277da = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$25c7ddd7ae9b45f3)($c03c6edd36966f29$var$ModelNode, $c03c6edd36966f29$var$ModelNode.SCALE);
const $c03c6edd36966f29$export$2130800e9e71dab = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$25c7ddd7ae9b45f3)($c03c6edd36966f29$var$ModelNode, $c03c6edd36966f29$var$ModelNode.VIEW_POSITION);
const $c03c6edd36966f29$export$7375cd766aaa851d = /*@__PURE__*/ (0, $5eb92bf12e57daab$export$379455b567eff87d)(new (0, $800ed18490319df2$export$8ff26dafa08918)()).onObjectUpdate(({ object: object }, self)=>self.value.getNormalMatrix(object.matrixWorld));
const $c03c6edd36966f29$export$2d730414002b1d6a = /*@__PURE__*/ (0, $5eb92bf12e57daab$export$379455b567eff87d)(new (0, $0ea09116adcadf95$export$2ae72fc923e5eb5)()).onObjectUpdate(({ object: object }, self)=>self.value.copy(object.matrixWorld).invert());
const $c03c6edd36966f29$export$57d0df277658535e = /*@__PURE__*/ (0, $aa7db78c76b9331c$export$6f7d94c027189d78).mul($c03c6edd36966f29$export$e1011125af6f8b40).toVar('modelViewMatrix');
const $c03c6edd36966f29$export$c71b80a661b21bdd = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$b076717d71a1a47f)((builder)=>{
    builder.context.isHighPrecisionModelViewMatrix = true;
    return (0, $5eb92bf12e57daab$export$379455b567eff87d)('mat4').onObjectUpdate(({ object: object, camera: camera })=>{
        return object.modelViewMatrix.multiplyMatrices(camera.matrixWorldInverse, object.matrixWorld);
    });
}).once()().toVar('highPrecisionModelViewMatrix');
const $c03c6edd36966f29$export$52fbd034d582c39f = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$b076717d71a1a47f)((builder)=>{
    const isHighPrecisionModelViewMatrix = builder.context.isHighPrecisionModelViewMatrix;
    return (0, $5eb92bf12e57daab$export$379455b567eff87d)('mat3').onObjectUpdate(({ object: object, camera: camera })=>{
        if (isHighPrecisionModelViewMatrix !== true) object.modelViewMatrix.multiplyMatrices(camera.matrixWorldInverse, object.matrixWorld);
        return object.normalMatrix.getNormalMatrix(object.modelViewMatrix);
    });
}).once()().toVar('highPrecisionModelNormalMatrix');


const $acbec2070ba15851$export$a0f5007edcaeec62 = /*@__PURE__*/ (0, $700a78a0d988d216$export$af4b9a83f4b00434)('position', 'vec3');
const $acbec2070ba15851$export$78cc3a7ea225109f = /*@__PURE__*/ $acbec2070ba15851$export$a0f5007edcaeec62.varying('positionLocal');
const $acbec2070ba15851$export$f69e3bac20b8ae8f = /*@__PURE__*/ $acbec2070ba15851$export$a0f5007edcaeec62.varying('positionPrevious');
const $acbec2070ba15851$export$3e8de2ffef4e6f91 = /*@__PURE__*/ (0, $c03c6edd36966f29$export$e1011125af6f8b40).mul($acbec2070ba15851$export$78cc3a7ea225109f).xyz.varying('v_positionWorld');
const $acbec2070ba15851$export$7a5e5a23009fd1a3 = /*@__PURE__*/ $acbec2070ba15851$export$78cc3a7ea225109f.transformDirection((0, $c03c6edd36966f29$export$e1011125af6f8b40)).varying('v_positionWorldDirection').normalize().toVar('positionWorldDirection');
const $acbec2070ba15851$export$3dfd735ebeac9bfd = /*@__PURE__*/ (0, $c03c6edd36966f29$export$57d0df277658535e).mul($acbec2070ba15851$export$78cc3a7ea225109f).xyz.varying('v_positionView');
const $acbec2070ba15851$export$80de5077965297a8 = /*@__PURE__*/ $acbec2070ba15851$export$3dfd735ebeac9bfd.negate().varying('v_positionViewDirection').normalize().toVar('positionViewDirection');



class $a7ca49051706df79$var$EquirectUVNode extends (0, $75c45ed2361c955f$export$2e2bcd8739ae039) {
    static get type() {
        return 'EquirectUVNode';
    }
    constructor(dirNode = (0, $acbec2070ba15851$export$7a5e5a23009fd1a3)){
        super('vec2');
        this.dirNode = dirNode;
    }
    setup() {
        const dir = this.dirNode;
        const u = dir.z.atan2(dir.x).mul(1 / (Math.PI * 2)).add(0.5);
        const v = dir.y.clamp(-1, 1.0).asin().mul(1 / Math.PI).add(0.5);
        return (0, $d5b7ee61758b2e81$export$e9830bc863290a54)(u, v);
    }
}
var $a7ca49051706df79$export$2e2bcd8739ae039 = $a7ca49051706df79$var$EquirectUVNode;
const $a7ca49051706df79$export$191de21f5bc44b98 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$60d11c6747b7deba)($a7ca49051706df79$var$EquirectUVNode);




class $228cc208600144f8$var$FunctionOverloadingNode extends (0, $65e77d5c3a27a66a$export$2e2bcd8739ae039) {
    static get type() {
        return 'FunctionOverloadingNode';
    }
    constructor(functionNodes = [], ...parametersNodes){
        super();
        this.functionNodes = functionNodes;
        this.parametersNodes = parametersNodes;
        this._candidateFnCall = null;
        this.global = true;
    }
    getNodeType() {
        return this.functionNodes[0].shaderNode.layout.type;
    }
    setup(builder) {
        const params = this.parametersNodes;
        let candidateFnCall = this._candidateFnCall;
        if (candidateFnCall === null) {
            let candidateFn = null;
            let candidateScore = -1;
            for (const functionNode of this.functionNodes){
                const shaderNode = functionNode.shaderNode;
                const layout = shaderNode.layout;
                if (layout === null) throw new Error('FunctionOverloadingNode: FunctionNode must be a layout.');
                const inputs = layout.inputs;
                if (params.length === inputs.length) {
                    let score = 0;
                    for(let i = 0; i < params.length; i++){
                        const param = params[i];
                        const input = inputs[i];
                        if (param.getNodeType(builder) === input.type) score++;
                        else score = 0;
                    }
                    if (score > candidateScore) {
                        candidateFn = functionNode;
                        candidateScore = score;
                    }
                }
            }
            this._candidateFnCall = candidateFnCall = candidateFn(...params);
        }
        return candidateFnCall;
    }
}
var $228cc208600144f8$export$2e2bcd8739ae039 = $228cc208600144f8$var$FunctionOverloadingNode;
const $228cc208600144f8$var$overloadingBaseFn = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$60d11c6747b7deba)($228cc208600144f8$var$FunctionOverloadingNode);
const $228cc208600144f8$export$16973c2f8bfadf46 = (functionNodes)=>(...params)=>$228cc208600144f8$var$overloadingBaseFn(functionNodes, ...params);












class $f8c552c0fa23c18b$var$FrontFacingNode extends (0, $65e77d5c3a27a66a$export$2e2bcd8739ae039) {
    static get type() {
        return 'FrontFacingNode';
    }
    constructor(){
        super('bool');
        this.isFrontFacingNode = true;
    }
    generate(builder) {
        const { renderer: renderer, material: material } = builder;
        if (renderer.coordinateSystem === (0, $cb5ee595c0f892af$export$5a0e9190d10875d3)) {
            if (material.side === (0, $cb5ee595c0f892af$export$d9f0486e75b5ace)) return 'false';
        }
        return builder.getFrontFacing();
    }
}
var $f8c552c0fa23c18b$export$2e2bcd8739ae039 = $f8c552c0fa23c18b$var$FrontFacingNode;
const $f8c552c0fa23c18b$export$89ffc7655cb9d79c = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$25c7ddd7ae9b45f3)($f8c552c0fa23c18b$var$FrontFacingNode);
const $f8c552c0fa23c18b$export$c2922972355d19f8 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)($f8c552c0fa23c18b$export$89ffc7655cb9d79c).mul(2.0).sub(1.0);


const $0ab44deffc8ae973$export$2d025416a9cb464f = /*@__PURE__*/ (0, $700a78a0d988d216$export$af4b9a83f4b00434)('normal', 'vec3');
const $0ab44deffc8ae973$export$c94af1e24aa56d8f = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$b076717d71a1a47f)((builder)=>{
    if (builder.geometry.hasAttribute('normal') === false) {
        console.warn('TSL.NormalNode: Vertex attribute "normal" not found on geometry.');
        return (0, $d5b7ee61758b2e81$export$9100789c9d999364)(0, 1, 0);
    }
    return $0ab44deffc8ae973$export$2d025416a9cb464f;
}, 'vec3').once()().toVar('normalLocal');
const $0ab44deffc8ae973$export$2c639087cd145f23 = /*@__PURE__*/ (0, $acbec2070ba15851$export$3dfd735ebeac9bfd).dFdx().cross((0, $acbec2070ba15851$export$3dfd735ebeac9bfd).dFdy()).normalize().toVar('normalFlat');
const $0ab44deffc8ae973$export$c7d7ec78bf3ab28a = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$b076717d71a1a47f)((builder)=>{
    let node;
    if (builder.material.flatShading === true) node = $0ab44deffc8ae973$export$2c639087cd145f23;
    else node = (0, $c497538e811cb09b$export$3f47f02b8134ef8a)($0ab44deffc8ae973$export$fd2a205e2f09a6e0($0ab44deffc8ae973$export$c94af1e24aa56d8f), 'v_normalView').normalize();
    return node;
}, 'vec3').once()().toVar('normalView');
const $0ab44deffc8ae973$export$8cce2f8527757c54 = /*@__PURE__*/ (0, $c497538e811cb09b$export$3f47f02b8134ef8a)($0ab44deffc8ae973$export$c7d7ec78bf3ab28a.transformDirection((0, $aa7db78c76b9331c$export$6f7d94c027189d78)), 'v_normalWorld').normalize().toVar('normalWorld');
const $0ab44deffc8ae973$export$c58d63d09d102e3c = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$b076717d71a1a47f)((builder)=>{
    return builder.context.setupNormal();
}, 'vec3').once()().mul((0, $f8c552c0fa23c18b$export$c2922972355d19f8)).toVar('transformedNormalView');
const $0ab44deffc8ae973$export$add3225664ac656e = /*@__PURE__*/ $0ab44deffc8ae973$export$c58d63d09d102e3c.transformDirection((0, $aa7db78c76b9331c$export$6f7d94c027189d78)).toVar('transformedNormalWorld');
const $0ab44deffc8ae973$export$71a9f037ea1539e0 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$b076717d71a1a47f)((builder)=>{
    return builder.context.setupClearcoatNormal();
}, 'vec3').once()().mul((0, $f8c552c0fa23c18b$export$c2922972355d19f8)).toVar('transformedClearcoatNormalView');
const $0ab44deffc8ae973$export$1dd08f57bc74994c = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$b076717d71a1a47f)(([normal, matrix = (0, $c03c6edd36966f29$export$e1011125af6f8b40)])=>{
    const m = (0, $d5b7ee61758b2e81$export$e43bd9f504e4ac00)(matrix);
    const transformedNormal = normal.div((0, $d5b7ee61758b2e81$export$9100789c9d999364)(m[0].dot(m[0]), m[1].dot(m[1]), m[2].dot(m[2])));
    return m.mul(transformedNormal).xyz;
});
const $0ab44deffc8ae973$export$fd2a205e2f09a6e0 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$b076717d71a1a47f)(([normal], builder)=>{
    const modelNormalViewMatrix = builder.renderer.nodes.modelNormalViewMatrix;
    if (modelNormalViewMatrix !== null) return modelNormalViewMatrix.transformDirection(normal);
    //
    const transformedNormal = (0, $c03c6edd36966f29$export$7375cd766aaa851d).mul(normal);
    return (0, $aa7db78c76b9331c$export$6f7d94c027189d78).transformDirection(transformedNormal);
});




class $9d71f23e5237e91a$var$MatcapUVNode extends (0, $75c45ed2361c955f$export$2e2bcd8739ae039) {
    static get type() {
        return 'MatcapUVNode';
    }
    constructor(){
        super('vec2');
    }
    setup() {
        const x = (0, $d5b7ee61758b2e81$export$9100789c9d999364)((0, $acbec2070ba15851$export$80de5077965297a8).z, 0, (0, $acbec2070ba15851$export$80de5077965297a8).x.negate()).normalize();
        const y = (0, $acbec2070ba15851$export$80de5077965297a8).cross(x);
        return (0, $d5b7ee61758b2e81$export$e9830bc863290a54)(x.dot((0, $0ab44deffc8ae973$export$c58d63d09d102e3c)), y.dot((0, $0ab44deffc8ae973$export$c58d63d09d102e3c))).mul(0.495).add(0.5); // 0.495 to remove artifacts caused by undersized matcap disks
    }
}
var $9d71f23e5237e91a$export$2e2bcd8739ae039 = $9d71f23e5237e91a$var$MatcapUVNode;
const $9d71f23e5237e91a$export$1144db64d9b88baf = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$25c7ddd7ae9b45f3)($9d71f23e5237e91a$var$MatcapUVNode);





class $da8ad6e2cfb3407e$var$MaxMipLevelNode extends (0, $5eb92bf12e57daab$export$2e2bcd8739ae039) {
    static get type() {
        return 'MaxMipLevelNode';
    }
    constructor(textureNode){
        super(0);
        this._textureNode = textureNode;
        this.updateType = (0, $ddcfecb7fbba5d74$export$26f7a8bbd9469530).FRAME;
    }
    get textureNode() {
        return this._textureNode;
    }
    get texture() {
        return this._textureNode.value;
    }
    update() {
        const texture = this.texture;
        const images = texture.images;
        const image = images && images.length > 0 ? images[0] && images[0].image || images[0] : texture.image;
        if (image && image.width !== undefined) {
            const { width: width, height: height } = image;
            this.value = Math.log2(Math.max(width, height));
        }
    }
}
var $da8ad6e2cfb3407e$export$2e2bcd8739ae039 = $da8ad6e2cfb3407e$var$MaxMipLevelNode;
const $da8ad6e2cfb3407e$export$f004dbb349dcdceb = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$60d11c6747b7deba)($da8ad6e2cfb3407e$var$MaxMipLevelNode);




const $73daa2c4ac78efb6$export$2da9be4cfdb689b1 = /*@__PURE__*/ (0, $5eb92bf12e57daab$export$379455b567eff87d)(0).setGroup((0, $d2c0f7c752a63c18$export$a75a8692b47c7f9e)).onRenderUpdate((frame)=>frame.time);
const $73daa2c4ac78efb6$export$c151f7dbc8280ae = /*@__PURE__*/ (0, $5eb92bf12e57daab$export$379455b567eff87d)(0).setGroup((0, $d2c0f7c752a63c18$export$a75a8692b47c7f9e)).onRenderUpdate((frame)=>frame.deltaTime);
const $73daa2c4ac78efb6$export$d0519621a9bf0b25 = /*@__PURE__*/ (0, $5eb92bf12e57daab$export$379455b567eff87d)(0, 'uint').setGroup((0, $d2c0f7c752a63c18$export$a75a8692b47c7f9e)).onRenderUpdate((frame)=>frame.frameId);
const $73daa2c4ac78efb6$export$f66c752b9fc69480 = (timeScale = 1)=>{
    console.warn('TSL: timerLocal() is deprecated. Use "time" instead.');
    return $73daa2c4ac78efb6$export$2da9be4cfdb689b1.mul(timeScale);
};
const $73daa2c4ac78efb6$export$64181be8d819441c = (timeScale = 1)=>{
    console.warn('TSL: timerGlobal() is deprecated. Use "time" instead.');
    return $73daa2c4ac78efb6$export$2da9be4cfdb689b1.mul(timeScale);
};
const $73daa2c4ac78efb6$export$f39c9dbd50e14b55 = (timeScale = 1)=>{
    console.warn('TSL: timerDelta() is deprecated. Use "deltaTime" instead.');
    return $73daa2c4ac78efb6$export$c151f7dbc8280ae.mul(timeScale);
};


const $26ecca4fe8161adc$export$2729ea64685a2715 = (t = (0, $73daa2c4ac78efb6$export$2da9be4cfdb689b1))=>t.add(0.75).mul(Math.PI * 2).sin().mul(0.5).add(0.5);
const $26ecca4fe8161adc$export$e4c95ccdd8049dee = (t = (0, $73daa2c4ac78efb6$export$2da9be4cfdb689b1))=>t.fract().round();
const $26ecca4fe8161adc$export$21076a275844ac3f = (t = (0, $73daa2c4ac78efb6$export$2da9be4cfdb689b1))=>t.add(0.5).fract().mul(2).sub(1).abs();
const $26ecca4fe8161adc$export$e1eddefd255f1d35 = (t = (0, $73daa2c4ac78efb6$export$2da9be4cfdb689b1))=>t.fract();



const $6886b4ccd5c97d78$export$a0a884e7f644b818 = (node)=>(0, $d5b7ee61758b2e81$export$e97474e17004dd41)(node).mul(0.5).add(0.5);
const $6886b4ccd5c97d78$export$cafa8df232264cc9 = (node)=>(0, $d5b7ee61758b2e81$export$e97474e17004dd41)(node).mul(2.0).sub(1);







class $a6645c4099ad0641$var$RotateNode extends (0, $75c45ed2361c955f$export$2e2bcd8739ae039) {
    static get type() {
        return 'RotateNode';
    }
    constructor(positionNode, rotationNode){
        super();
        this.positionNode = positionNode;
        this.rotationNode = rotationNode;
    }
    getNodeType(builder) {
        return this.positionNode.getNodeType(builder);
    }
    setup(builder) {
        const { rotationNode: rotationNode, positionNode: positionNode } = this;
        const nodeType = this.getNodeType(builder);
        if (nodeType === 'vec2') {
            const cosAngle = rotationNode.cos();
            const sinAngle = rotationNode.sin();
            const rotationMatrix = (0, $d5b7ee61758b2e81$export$f7543b5409a93c6b)(cosAngle, sinAngle, sinAngle.negate(), cosAngle);
            return rotationMatrix.mul(positionNode);
        } else {
            const rotation = rotationNode;
            const rotationXMatrix = (0, $d5b7ee61758b2e81$export$d2b4acf069bf09f5)((0, $d5b7ee61758b2e81$export$6dba2a1f0d609415)(1.0, 0.0, 0.0, 0.0), (0, $d5b7ee61758b2e81$export$6dba2a1f0d609415)(0.0, (0, $f37ae0e58866c183$export$50d414a77b60d802)(rotation.x), (0, $f37ae0e58866c183$export$5de3937cb4b592ed)(rotation.x).negate(), 0.0), (0, $d5b7ee61758b2e81$export$6dba2a1f0d609415)(0.0, (0, $f37ae0e58866c183$export$5de3937cb4b592ed)(rotation.x), (0, $f37ae0e58866c183$export$50d414a77b60d802)(rotation.x), 0.0), (0, $d5b7ee61758b2e81$export$6dba2a1f0d609415)(0.0, 0.0, 0.0, 1.0));
            const rotationYMatrix = (0, $d5b7ee61758b2e81$export$d2b4acf069bf09f5)((0, $d5b7ee61758b2e81$export$6dba2a1f0d609415)((0, $f37ae0e58866c183$export$50d414a77b60d802)(rotation.y), 0.0, (0, $f37ae0e58866c183$export$5de3937cb4b592ed)(rotation.y), 0.0), (0, $d5b7ee61758b2e81$export$6dba2a1f0d609415)(0.0, 1.0, 0.0, 0.0), (0, $d5b7ee61758b2e81$export$6dba2a1f0d609415)((0, $f37ae0e58866c183$export$5de3937cb4b592ed)(rotation.y).negate(), 0.0, (0, $f37ae0e58866c183$export$50d414a77b60d802)(rotation.y), 0.0), (0, $d5b7ee61758b2e81$export$6dba2a1f0d609415)(0.0, 0.0, 0.0, 1.0));
            const rotationZMatrix = (0, $d5b7ee61758b2e81$export$d2b4acf069bf09f5)((0, $d5b7ee61758b2e81$export$6dba2a1f0d609415)((0, $f37ae0e58866c183$export$50d414a77b60d802)(rotation.z), (0, $f37ae0e58866c183$export$5de3937cb4b592ed)(rotation.z).negate(), 0.0, 0.0), (0, $d5b7ee61758b2e81$export$6dba2a1f0d609415)((0, $f37ae0e58866c183$export$5de3937cb4b592ed)(rotation.z), (0, $f37ae0e58866c183$export$50d414a77b60d802)(rotation.z), 0.0, 0.0), (0, $d5b7ee61758b2e81$export$6dba2a1f0d609415)(0.0, 0.0, 1.0, 0.0), (0, $d5b7ee61758b2e81$export$6dba2a1f0d609415)(0.0, 0.0, 0.0, 1.0));
            return rotationXMatrix.mul(rotationYMatrix).mul(rotationZMatrix).mul((0, $d5b7ee61758b2e81$export$6dba2a1f0d609415)(positionNode, 1.0)).xyz;
        }
    }
}
var $a6645c4099ad0641$export$2e2bcd8739ae039 = $a6645c4099ad0641$var$RotateNode;
const $a6645c4099ad0641$export$bb628a54ab399bc9 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$60d11c6747b7deba)($a6645c4099ad0641$var$RotateNode);


const $8c7693ce4974800b$export$acd5aa41c3c41974 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$b076717d71a1a47f)(([uv, rotation, center = (0, $d5b7ee61758b2e81$export$e9830bc863290a54)(0.5)])=>{
    return (0, $a6645c4099ad0641$export$bb628a54ab399bc9)(uv.sub(center), rotation).add(center);
});
const $8c7693ce4974800b$export$a059889a93c31b5e = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$b076717d71a1a47f)(([uv, strength, center = (0, $d5b7ee61758b2e81$export$e9830bc863290a54)(0.5)])=>{
    const delta = uv.sub(center);
    const delta2 = delta.dot(delta);
    const delta4 = delta2.mul(delta2);
    const deltaOffset = delta4.mul(strength);
    return uv.add(delta.mul(deltaOffset));
});






const $165b355984e6aeef$export$b1827dce83cede51 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$b076717d71a1a47f)(({ position: position = null, horizontal: horizontal = true, vertical: vertical = false })=>{
    let worldMatrix;
    if (position !== null) {
        worldMatrix = (0, $c03c6edd36966f29$export$e1011125af6f8b40).toVar();
        worldMatrix[3][0] = position.x;
        worldMatrix[3][1] = position.y;
        worldMatrix[3][2] = position.z;
    } else worldMatrix = (0, $c03c6edd36966f29$export$e1011125af6f8b40);
    const modelViewMatrix = (0, $aa7db78c76b9331c$export$6f7d94c027189d78).mul(worldMatrix);
    if ((0, $d5b7ee61758b2e81$export$43f40ad3fa1d5c97)(horizontal)) {
        modelViewMatrix[0][0] = (0, $c03c6edd36966f29$export$e1011125af6f8b40)[0].length();
        modelViewMatrix[0][1] = 0;
        modelViewMatrix[0][2] = 0;
    }
    if ((0, $d5b7ee61758b2e81$export$43f40ad3fa1d5c97)(vertical)) {
        modelViewMatrix[1][0] = 0;
        modelViewMatrix[1][1] = (0, $c03c6edd36966f29$export$e1011125af6f8b40)[1].length();
        modelViewMatrix[1][2] = 0;
    }
    modelViewMatrix[2][0] = 0;
    modelViewMatrix[2][1] = 0;
    modelViewMatrix[2][2] = 1;
    return (0, $aa7db78c76b9331c$export$dc8d743682f60b2d).mul(modelViewMatrix).mul((0, $acbec2070ba15851$export$78cc3a7ea225109f));
});









let $64df2f32a1195518$var$screenSizeVec, $64df2f32a1195518$var$viewportVec;
class $64df2f32a1195518$var$ScreenNode extends (0, $65e77d5c3a27a66a$export$2e2bcd8739ae039) {
    static get type() {
        return 'ScreenNode';
    }
    constructor(scope){
        super();
        this.scope = scope;
        this.isViewportNode = true;
    }
    getNodeType() {
        if (this.scope === $64df2f32a1195518$var$ScreenNode.VIEWPORT) return 'vec4';
        else return 'vec2';
    }
    getUpdateType() {
        let updateType = (0, $ddcfecb7fbba5d74$export$26f7a8bbd9469530).NONE;
        if (this.scope === $64df2f32a1195518$var$ScreenNode.SIZE || this.scope === $64df2f32a1195518$var$ScreenNode.VIEWPORT) updateType = (0, $ddcfecb7fbba5d74$export$26f7a8bbd9469530).RENDER;
        this.updateType = updateType;
        return updateType;
    }
    update({ renderer: renderer }) {
        const renderTarget = renderer.getRenderTarget();
        if (this.scope === $64df2f32a1195518$var$ScreenNode.VIEWPORT) {
            if (renderTarget !== null) $64df2f32a1195518$var$viewportVec.copy(renderTarget.viewport);
            else {
                renderer.getViewport($64df2f32a1195518$var$viewportVec);
                $64df2f32a1195518$var$viewportVec.multiplyScalar(renderer.getPixelRatio());
            }
        } else if (renderTarget !== null) {
            $64df2f32a1195518$var$screenSizeVec.width = renderTarget.width;
            $64df2f32a1195518$var$screenSizeVec.height = renderTarget.height;
        } else renderer.getDrawingBufferSize($64df2f32a1195518$var$screenSizeVec);
    }
    setup() {
        const scope = this.scope;
        let output = null;
        if (scope === $64df2f32a1195518$var$ScreenNode.SIZE) output = (0, $5eb92bf12e57daab$export$379455b567eff87d)($64df2f32a1195518$var$screenSizeVec || ($64df2f32a1195518$var$screenSizeVec = new (0, $3c03061dea0adea3$export$c977b3e384af9ae1)()));
        else if (scope === $64df2f32a1195518$var$ScreenNode.VIEWPORT) output = (0, $5eb92bf12e57daab$export$379455b567eff87d)($64df2f32a1195518$var$viewportVec || ($64df2f32a1195518$var$viewportVec = new (0, $a09a15e9a8421204$export$fa7daccca11cdbe3)()));
        else output = (0, $d5b7ee61758b2e81$export$e9830bc863290a54)($64df2f32a1195518$export$bf65ab4b6c973b29.div($64df2f32a1195518$export$463d066e8ee12fba));
        return output;
    }
    generate(builder) {
        if (this.scope === $64df2f32a1195518$var$ScreenNode.COORDINATE) {
            let coord = builder.getFragCoord();
            if (builder.isFlipY()) {
                // follow webgpu standards
                const size = builder.getNodeProperties($64df2f32a1195518$export$463d066e8ee12fba).outputNode.build(builder);
                coord = `${builder.getType('vec2')}( ${coord}.x, ${size}.y - ${coord}.y )`;
            }
            return coord;
        }
        return super.generate(builder);
    }
}
$64df2f32a1195518$var$ScreenNode.COORDINATE = 'coordinate';
$64df2f32a1195518$var$ScreenNode.VIEWPORT = 'viewport';
$64df2f32a1195518$var$ScreenNode.SIZE = 'size';
$64df2f32a1195518$var$ScreenNode.UV = 'uv';
var $64df2f32a1195518$export$2e2bcd8739ae039 = $64df2f32a1195518$var$ScreenNode;
const $64df2f32a1195518$export$e2a68d187fb2dd60 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$25c7ddd7ae9b45f3)($64df2f32a1195518$var$ScreenNode, $64df2f32a1195518$var$ScreenNode.UV);
const $64df2f32a1195518$export$463d066e8ee12fba = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$25c7ddd7ae9b45f3)($64df2f32a1195518$var$ScreenNode, $64df2f32a1195518$var$ScreenNode.SIZE);
const $64df2f32a1195518$export$bf65ab4b6c973b29 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$25c7ddd7ae9b45f3)($64df2f32a1195518$var$ScreenNode, $64df2f32a1195518$var$ScreenNode.COORDINATE);
const $64df2f32a1195518$export$d7b7311ec04a3e8f = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$25c7ddd7ae9b45f3)($64df2f32a1195518$var$ScreenNode, $64df2f32a1195518$var$ScreenNode.VIEWPORT);
const $64df2f32a1195518$export$3ad24fad43028167 = $64df2f32a1195518$export$d7b7311ec04a3e8f.zw;
const $64df2f32a1195518$export$fd654ba033f324f0 = /*@__PURE__*/ $64df2f32a1195518$export$bf65ab4b6c973b29.sub($64df2f32a1195518$export$d7b7311ec04a3e8f.xy);
const $64df2f32a1195518$export$546f11640d3a4f87 = /*@__PURE__*/ $64df2f32a1195518$export$fd654ba033f324f0.div($64df2f32a1195518$export$3ad24fad43028167);
const $64df2f32a1195518$export$2f423b0da8fd0d65 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$b076717d71a1a47f)(()=>{
    console.warn('TSL.ViewportNode: "viewportResolution" is deprecated. Use "screenSize" instead.');
    return $64df2f32a1195518$export$463d066e8ee12fba;
}, 'vec2').once()();
const $64df2f32a1195518$export$76b08933cd505895 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$b076717d71a1a47f)(()=>{
    console.warn('TSL.ViewportNode: "viewportTopLeft" is deprecated. Use "screenUV" instead.');
    return $64df2f32a1195518$export$e2a68d187fb2dd60;
}, 'vec2').once()();
const $64df2f32a1195518$export$e2d72b46aee7453c = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$b076717d71a1a47f)(()=>{
    console.warn('TSL.ViewportNode: "viewportBottomLeft" is deprecated. Use "screenUV.flipY()" instead.');
    return $64df2f32a1195518$export$e2a68d187fb2dd60.flipY();
}, 'vec2').once()();




const $382a32bd765f3827$export$c774ebbac59e31d3 = (index)=>(0, $700a78a0d988d216$export$af4b9a83f4b00434)('uv' + (index > 0 ? index : ''), 'vec2');




class $4e1437e3f88f83e2$var$TextureSizeNode extends (0, $65e77d5c3a27a66a$export$2e2bcd8739ae039) {
    static get type() {
        return 'TextureSizeNode';
    }
    constructor(textureNode, levelNode = null){
        super('uvec2');
        this.isTextureSizeNode = true;
        this.textureNode = textureNode;
        this.levelNode = levelNode;
    }
    generate(builder, output) {
        const textureProperty = this.textureNode.build(builder, 'property');
        const level = this.levelNode === null ? '0' : this.levelNode.build(builder, 'int');
        return builder.format(`${builder.getMethod('textureDimensions')}( ${textureProperty}, ${level} )`, this.getNodeType(builder), output);
    }
}
var $4e1437e3f88f83e2$export$2e2bcd8739ae039 = $4e1437e3f88f83e2$var$TextureSizeNode;
const $4e1437e3f88f83e2$export$a8905ccad583a116 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$60d11c6747b7deba)($4e1437e3f88f83e2$var$TextureSizeNode);








class $f7d68bbf9ea772a7$var$TextureNode extends (0, $5eb92bf12e57daab$export$2e2bcd8739ae039) {
    static get type() {
        return 'TextureNode';
    }
    constructor(value, uvNode = null, levelNode = null, biasNode = null){
        super(value);
        this.isTextureNode = true;
        this.uvNode = uvNode;
        this.levelNode = levelNode;
        this.biasNode = biasNode;
        this.compareNode = null;
        this.depthNode = null;
        this.gradNode = null;
        this.sampler = true;
        this.updateMatrix = false;
        this.updateType = (0, $ddcfecb7fbba5d74$export$26f7a8bbd9469530).NONE;
        this.referenceNode = null;
        this._value = value;
        this._matrixUniform = null;
        this.setUpdateMatrix(uvNode === null);
    }
    set value(value) {
        if (this.referenceNode) this.referenceNode.value = value;
        else this._value = value;
    }
    get value() {
        return this.referenceNode ? this.referenceNode.value : this._value;
    }
    getUniformHash() {
        return this.value.uuid;
    }
    getNodeType() {
        if (this.value.isDepthTexture === true) return 'float';
        if (this.value.type === (0, $cb5ee595c0f892af$export$c3c7fc4518ebba96)) return 'uvec4';
        else if (this.value.type === (0, $cb5ee595c0f892af$export$5c612977753abe2)) return 'ivec4';
        return 'vec4';
    }
    getInputType() {
        return 'texture';
    }
    getDefaultUV() {
        return (0, $382a32bd765f3827$export$c774ebbac59e31d3)(this.value.channel);
    }
    updateReference() {
        return this.value;
    }
    getTransformedUV(uvNode) {
        if (this._matrixUniform === null) this._matrixUniform = (0, $5eb92bf12e57daab$export$379455b567eff87d)(this.value.matrix);
        return this._matrixUniform.mul((0, $d5b7ee61758b2e81$export$9100789c9d999364)(uvNode, 1)).xy;
    }
    setUpdateMatrix(value) {
        this.updateMatrix = value;
        this.updateType = value ? (0, $ddcfecb7fbba5d74$export$26f7a8bbd9469530).FRAME : (0, $ddcfecb7fbba5d74$export$26f7a8bbd9469530).NONE;
        return this;
    }
    setupUV(builder, uvNode) {
        const texture = this.value;
        if (builder.isFlipY() && (texture.isRenderTargetTexture === true || texture.isFramebufferTexture === true || texture.isDepthTexture === true)) {
            if (this.sampler) uvNode = uvNode.flipY();
            else uvNode = uvNode.setY((0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)((0, $4e1437e3f88f83e2$export$a8905ccad583a116)(this, this.levelNode).y).sub(uvNode.y).sub(1));
        }
        return uvNode;
    }
    setup(builder) {
        const properties = builder.getNodeProperties(this);
        properties.referenceNode = this.referenceNode;
        //
        let uvNode = this.uvNode;
        if ((uvNode === null || builder.context.forceUVContext === true) && builder.context.getUV) uvNode = builder.context.getUV(this);
        if (!uvNode) uvNode = this.getDefaultUV();
        if (this.updateMatrix === true) uvNode = this.getTransformedUV(uvNode);
        uvNode = this.setupUV(builder, uvNode);
        //
        let levelNode = this.levelNode;
        if (levelNode === null && builder.context.getTextureLevel) levelNode = builder.context.getTextureLevel(this);
        //
        properties.uvNode = uvNode;
        properties.levelNode = levelNode;
        properties.biasNode = this.biasNode;
        properties.compareNode = this.compareNode;
        properties.gradNode = this.gradNode;
        properties.depthNode = this.depthNode;
    }
    generateUV(builder, uvNode) {
        return uvNode.build(builder, this.sampler === true ? 'vec2' : 'ivec2');
    }
    generateSnippet(builder, textureProperty, uvSnippet, levelSnippet, biasSnippet, depthSnippet, compareSnippet, gradSnippet) {
        const texture = this.value;
        let snippet;
        if (levelSnippet) snippet = builder.generateTextureLevel(texture, textureProperty, uvSnippet, levelSnippet, depthSnippet);
        else if (biasSnippet) snippet = builder.generateTextureBias(texture, textureProperty, uvSnippet, biasSnippet, depthSnippet);
        else if (gradSnippet) snippet = builder.generateTextureGrad(texture, textureProperty, uvSnippet, gradSnippet, depthSnippet);
        else if (compareSnippet) snippet = builder.generateTextureCompare(texture, textureProperty, uvSnippet, compareSnippet, depthSnippet);
        else if (this.sampler === false) snippet = builder.generateTextureLoad(texture, textureProperty, uvSnippet, depthSnippet);
        else snippet = builder.generateTexture(texture, textureProperty, uvSnippet, depthSnippet);
        return snippet;
    }
    generate(builder, output) {
        const properties = builder.getNodeProperties(this);
        const texture = this.value;
        if (!texture || texture.isTexture !== true) throw new Error('TextureNode: Need a three.js texture.');
        const textureProperty = super.generate(builder, 'property');
        if (output === 'sampler') return textureProperty + '_sampler';
        else if (builder.isReference(output)) return textureProperty;
        else {
            const nodeData = builder.getDataFromNode(this);
            let propertyName = nodeData.propertyName;
            if (propertyName === undefined) {
                const { uvNode: uvNode, levelNode: levelNode, biasNode: biasNode, compareNode: compareNode, depthNode: depthNode, gradNode: gradNode } = properties;
                const uvSnippet = this.generateUV(builder, uvNode);
                const levelSnippet = levelNode ? levelNode.build(builder, 'float') : null;
                const biasSnippet = biasNode ? biasNode.build(builder, 'float') : null;
                const depthSnippet = depthNode ? depthNode.build(builder, 'int') : null;
                const compareSnippet = compareNode ? compareNode.build(builder, 'float') : null;
                const gradSnippet = gradNode ? [
                    gradNode[0].build(builder, 'vec2'),
                    gradNode[1].build(builder, 'vec2')
                ] : null;
                const nodeVar = builder.getVarFromNode(this);
                propertyName = builder.getPropertyName(nodeVar);
                const snippet = this.generateSnippet(builder, textureProperty, uvSnippet, levelSnippet, biasSnippet, depthSnippet, compareSnippet, gradSnippet);
                builder.addLineFlowCode(`${propertyName} = ${snippet}`, this);
                nodeData.snippet = snippet;
                nodeData.propertyName = propertyName;
            }
            let snippet = propertyName;
            const nodeType = this.getNodeType(builder);
            if (builder.needsToWorkingColorSpace(texture)) snippet = (0, $1b770916e91703b6$export$7444e0682bed4e57)((0, $687bc12bcf0ed73b$export$743d82c2fd345b72)(snippet, nodeType), texture.colorSpace).setup(builder).build(builder, nodeType);
            return builder.format(snippet, nodeType, output);
        }
    }
    setSampler(value) {
        this.sampler = value;
        return this;
    }
    getSampler() {
        return this.sampler;
    }
    // @TODO: Move to TSL
    uv(uvNode) {
        const textureNode = this.clone();
        textureNode.uvNode = (0, $d5b7ee61758b2e81$export$e97474e17004dd41)(uvNode);
        textureNode.referenceNode = this.getSelf();
        return (0, $d5b7ee61758b2e81$export$e97474e17004dd41)(textureNode);
    }
    blur(amountNode) {
        const textureNode = this.clone();
        textureNode.biasNode = (0, $d5b7ee61758b2e81$export$e97474e17004dd41)(amountNode).mul((0, $da8ad6e2cfb3407e$export$f004dbb349dcdceb)(textureNode));
        textureNode.referenceNode = this.getSelf();
        return (0, $d5b7ee61758b2e81$export$e97474e17004dd41)(textureNode);
    }
    level(levelNode) {
        const textureNode = this.clone();
        textureNode.levelNode = (0, $d5b7ee61758b2e81$export$e97474e17004dd41)(levelNode);
        textureNode.referenceNode = this.getSelf();
        return (0, $d5b7ee61758b2e81$export$e97474e17004dd41)(textureNode);
    }
    size(levelNode) {
        return (0, $4e1437e3f88f83e2$export$a8905ccad583a116)(this, levelNode);
    }
    bias(biasNode) {
        const textureNode = this.clone();
        textureNode.biasNode = (0, $d5b7ee61758b2e81$export$e97474e17004dd41)(biasNode);
        textureNode.referenceNode = this.getSelf();
        return (0, $d5b7ee61758b2e81$export$e97474e17004dd41)(textureNode);
    }
    compare(compareNode) {
        const textureNode = this.clone();
        textureNode.compareNode = (0, $d5b7ee61758b2e81$export$e97474e17004dd41)(compareNode);
        textureNode.referenceNode = this.getSelf();
        return (0, $d5b7ee61758b2e81$export$e97474e17004dd41)(textureNode);
    }
    grad(gradNodeX, gradNodeY) {
        const textureNode = this.clone();
        textureNode.gradNode = [
            (0, $d5b7ee61758b2e81$export$e97474e17004dd41)(gradNodeX),
            (0, $d5b7ee61758b2e81$export$e97474e17004dd41)(gradNodeY)
        ];
        textureNode.referenceNode = this.getSelf();
        return (0, $d5b7ee61758b2e81$export$e97474e17004dd41)(textureNode);
    }
    depth(depthNode) {
        const textureNode = this.clone();
        textureNode.depthNode = (0, $d5b7ee61758b2e81$export$e97474e17004dd41)(depthNode);
        textureNode.referenceNode = this.getSelf();
        return (0, $d5b7ee61758b2e81$export$e97474e17004dd41)(textureNode);
    }
    // --
    serialize(data) {
        super.serialize(data);
        data.value = this.value.toJSON(data.meta).uuid;
        data.sampler = this.sampler;
        data.updateMatrix = this.updateMatrix;
        data.updateType = this.updateType;
    }
    deserialize(data) {
        super.deserialize(data);
        this.value = data.meta.textures[data.value];
        this.sampler = data.sampler;
        this.updateMatrix = data.updateMatrix;
        this.updateType = data.updateType;
    }
    update() {
        const texture = this.value;
        const matrixUniform = this._matrixUniform;
        if (matrixUniform !== null) matrixUniform.value = texture.matrix;
        if (texture.matrixAutoUpdate === true) texture.updateMatrix();
    }
    clone() {
        const newNode = new this.constructor(this.value, this.uvNode, this.levelNode, this.biasNode);
        newNode.sampler = this.sampler;
        return newNode;
    }
}
var $f7d68bbf9ea772a7$export$2e2bcd8739ae039 = $f7d68bbf9ea772a7$var$TextureNode;
const $f7d68bbf9ea772a7$export$ab69073b3903a075 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$60d11c6747b7deba)($f7d68bbf9ea772a7$var$TextureNode);
const $f7d68bbf9ea772a7$export$c9a2885c9238610f = (...params)=>$f7d68bbf9ea772a7$export$ab69073b3903a075(...params).setSampler(false);
const $f7d68bbf9ea772a7$export$918ce7b77cc849ea = (aTexture)=>(aTexture.isNode === true ? aTexture : $f7d68bbf9ea772a7$export$ab69073b3903a075(aTexture)).convert('sampler');








class $ab9242dba7b93e7e$export$9270d786f73ce6fe extends (0, $97033ebbcbadc145$export$5431306cf43de24a) {
    constructor(width, height){
        super({
            width: width,
            height: height
        });
        this.isFramebufferTexture = true;
        this.magFilter = (0, $cb5ee595c0f892af$export$727aa5ec3fe39bf0);
        this.minFilter = (0, $cb5ee595c0f892af$export$727aa5ec3fe39bf0);
        this.generateMipmaps = false;
        this.needsUpdate = true;
    }
}



const $3a0ecc63acbbffaf$var$_size = /*@__PURE__*/ new (0, $3c03061dea0adea3$export$c977b3e384af9ae1)();
class $3a0ecc63acbbffaf$var$ViewportTextureNode extends (0, $f7d68bbf9ea772a7$export$2e2bcd8739ae039) {
    static get type() {
        return 'ViewportTextureNode';
    }
    constructor(uvNode = (0, $64df2f32a1195518$export$e2a68d187fb2dd60), levelNode = null, framebufferTexture = null){
        if (framebufferTexture === null) {
            framebufferTexture = new (0, $ab9242dba7b93e7e$export$9270d786f73ce6fe)();
            framebufferTexture.minFilter = (0, $cb5ee595c0f892af$export$5d8599b6a933fb1b);
        }
        super(framebufferTexture, uvNode, levelNode);
        this.generateMipmaps = false;
        this.isOutputTextureNode = true;
        this.updateBeforeType = (0, $ddcfecb7fbba5d74$export$26f7a8bbd9469530).FRAME;
    }
    updateBefore(frame) {
        const renderer = frame.renderer;
        renderer.getDrawingBufferSize($3a0ecc63acbbffaf$var$_size);
        //
        const framebufferTexture = this.value;
        if (framebufferTexture.image.width !== $3a0ecc63acbbffaf$var$_size.width || framebufferTexture.image.height !== $3a0ecc63acbbffaf$var$_size.height) {
            framebufferTexture.image.width = $3a0ecc63acbbffaf$var$_size.width;
            framebufferTexture.image.height = $3a0ecc63acbbffaf$var$_size.height;
            framebufferTexture.needsUpdate = true;
        }
        //
        const currentGenerateMipmaps = framebufferTexture.generateMipmaps;
        framebufferTexture.generateMipmaps = this.generateMipmaps;
        renderer.copyFramebufferToTexture(framebufferTexture);
        framebufferTexture.generateMipmaps = currentGenerateMipmaps;
    }
    clone() {
        const viewportTextureNode = new this.constructor(this.uvNode, this.levelNode, this.value);
        viewportTextureNode.generateMipmaps = this.generateMipmaps;
        return viewportTextureNode;
    }
}
var $3a0ecc63acbbffaf$export$2e2bcd8739ae039 = $3a0ecc63acbbffaf$var$ViewportTextureNode;
const $3a0ecc63acbbffaf$export$e3866d20de3e3579 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$60d11c6747b7deba)($3a0ecc63acbbffaf$var$ViewportTextureNode);
const $3a0ecc63acbbffaf$export$e03dc40ba6105796 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$60d11c6747b7deba)($3a0ecc63acbbffaf$var$ViewportTextureNode, null, null, {
    generateMipmaps: true
});





let $7f9fd3aaf668ceba$var$sharedDepthbuffer = null;
class $7f9fd3aaf668ceba$var$ViewportDepthTextureNode extends (0, $3a0ecc63acbbffaf$export$2e2bcd8739ae039) {
    static get type() {
        return 'ViewportDepthTextureNode';
    }
    constructor(uvNode = (0, $64df2f32a1195518$export$e2a68d187fb2dd60), levelNode = null){
        if ($7f9fd3aaf668ceba$var$sharedDepthbuffer === null) $7f9fd3aaf668ceba$var$sharedDepthbuffer = new (0, $520286b5db9c7cf5$export$fc830aa069cc8c2f)();
        super(uvNode, levelNode, $7f9fd3aaf668ceba$var$sharedDepthbuffer);
    }
}
var $7f9fd3aaf668ceba$export$2e2bcd8739ae039 = $7f9fd3aaf668ceba$var$ViewportDepthTextureNode;
const $7f9fd3aaf668ceba$export$8eb3800fd0750433 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$60d11c6747b7deba)($7f9fd3aaf668ceba$var$ViewportDepthTextureNode);







class $c2ec92bdddb724e3$var$ViewportDepthNode extends (0, $65e77d5c3a27a66a$export$2e2bcd8739ae039) {
    static get type() {
        return 'ViewportDepthNode';
    }
    constructor(scope, valueNode = null){
        super('float');
        this.scope = scope;
        this.valueNode = valueNode;
        this.isViewportDepthNode = true;
    }
    generate(builder) {
        const { scope: scope } = this;
        if (scope === $c2ec92bdddb724e3$var$ViewportDepthNode.DEPTH_BASE) return builder.getFragDepth();
        return super.generate(builder);
    }
    setup({ camera: camera }) {
        const { scope: scope } = this;
        const value = this.valueNode;
        let node = null;
        if (scope === $c2ec92bdddb724e3$var$ViewportDepthNode.DEPTH_BASE) {
            if (value !== null) node = $c2ec92bdddb724e3$var$depthBase().assign(value);
        } else if (scope === $c2ec92bdddb724e3$var$ViewportDepthNode.DEPTH) {
            if (camera.isPerspectiveCamera) node = $c2ec92bdddb724e3$export$afe0ed824ab1a48c((0, $acbec2070ba15851$export$3dfd735ebeac9bfd).z, (0, $aa7db78c76b9331c$export$81bd96ee69286580), (0, $aa7db78c76b9331c$export$21e5768aeb8c5c46));
            else node = $c2ec92bdddb724e3$export$22f8344c678d1434((0, $acbec2070ba15851$export$3dfd735ebeac9bfd).z, (0, $aa7db78c76b9331c$export$81bd96ee69286580), (0, $aa7db78c76b9331c$export$21e5768aeb8c5c46));
        } else if (scope === $c2ec92bdddb724e3$var$ViewportDepthNode.LINEAR_DEPTH) {
            if (value !== null) {
                if (camera.isPerspectiveCamera) {
                    const viewZ = $c2ec92bdddb724e3$export$be58bb2e0c565f9d(value, (0, $aa7db78c76b9331c$export$81bd96ee69286580), (0, $aa7db78c76b9331c$export$21e5768aeb8c5c46));
                    node = $c2ec92bdddb724e3$export$22f8344c678d1434(viewZ, (0, $aa7db78c76b9331c$export$81bd96ee69286580), (0, $aa7db78c76b9331c$export$21e5768aeb8c5c46));
                } else node = value;
            } else node = $c2ec92bdddb724e3$export$22f8344c678d1434((0, $acbec2070ba15851$export$3dfd735ebeac9bfd).z, (0, $aa7db78c76b9331c$export$81bd96ee69286580), (0, $aa7db78c76b9331c$export$21e5768aeb8c5c46));
        }
        return node;
    }
}
$c2ec92bdddb724e3$var$ViewportDepthNode.DEPTH_BASE = 'depthBase';
$c2ec92bdddb724e3$var$ViewportDepthNode.DEPTH = 'depth';
$c2ec92bdddb724e3$var$ViewportDepthNode.LINEAR_DEPTH = 'linearDepth';
var $c2ec92bdddb724e3$export$2e2bcd8739ae039 = $c2ec92bdddb724e3$var$ViewportDepthNode;
const $c2ec92bdddb724e3$export$22f8344c678d1434 = (viewZ, near, far)=>viewZ.add(near).div(near.sub(far));
const $c2ec92bdddb724e3$export$7c25d95f9b37ec81 = (depth, near, far)=>near.sub(far).mul(depth).sub(near);
const $c2ec92bdddb724e3$export$afe0ed824ab1a48c = (viewZ, near, far)=>near.add(viewZ).mul(far).div(far.sub(near).mul(viewZ));
const $c2ec92bdddb724e3$export$be58bb2e0c565f9d = (depth, near, far)=>near.mul(far).div(far.sub(near).mul(depth).sub(far));
const $c2ec92bdddb724e3$export$7e233a63f5c02fa0 = (perspectiveW, near, far)=>{
    // The final logarithmic depth formula used here is adapted from one described in an
    // article by Thatcher Ulrich (see http://tulrich.com/geekstuff/log_depth_buffer.txt),
    // which was an improvement upon an earlier formula one described in an
    // Outerra article (https://outerra.blogspot.com/2009/08/logarithmic-z-buffer.html).
    // Ulrich's formula is the following:
    //     z = K * log( w / cameraNear ) / log( cameraFar / cameraNear )
    //     where K = 2^k - 1, and k is the number of bits in the depth buffer.
    // The Outerra variant ignored the camera near plane (it assumed it was 0) and instead
    // opted for a "C-constant" for resolution adjustment of objects near the camera.
    // Outerra states: "Notice that the 'C' variant doesn’t use a near plane distance, it has it
    // set at 0" (quote from https://outerra.blogspot.com/2012/11/maximizing-depth-buffer-range-and.html).
    // Ulrich's variant has the benefit of constant relative precision over the whole near-far range.
    // It was debated here whether Outerra's "C-constant" or Ulrich's "near plane" variant should
    // be used, and ultimately Ulrich's "near plane" version was chosen.
    // Outerra eventually made another improvement to their original "C-constant" variant,
    // but it still does not incorporate the camera near plane (for this version,
    // see https://outerra.blogspot.com/2013/07/logarithmic-depth-buffer-optimizations.html).
    // Here we make 4 changes to Ulrich's formula:
    // 1. Clamp the camera near plane so we don't divide by 0.
    // 2. Use log2 instead of log to avoid an extra multiply (shaders implement log using log2).
    // 3. Assume K is 1 (K = maximum value in depth buffer; see Ulrich's formula above).
    // 4. Add 1 to each division by cameraNear to ensure the depth curve is shifted to the left as cameraNear increases.
    // For visual representation of this depth curve, see https://www.desmos.com/calculator/lz5rqfysih
    near = near.max(1e-6).toVar();
    const numerator = (0, $f37ae0e58866c183$export$b9fae0bba9d9094d)(perspectiveW.div(near).add(1));
    const denominator = (0, $f37ae0e58866c183$export$b9fae0bba9d9094d)(far.div(near).add(1));
    return numerator.div(denominator);
};
const $c2ec92bdddb724e3$var$depthBase = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$60d11c6747b7deba)($c2ec92bdddb724e3$var$ViewportDepthNode, $c2ec92bdddb724e3$var$ViewportDepthNode.DEPTH_BASE);
const $c2ec92bdddb724e3$export$b202ba015b5882cd = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$25c7ddd7ae9b45f3)($c2ec92bdddb724e3$var$ViewportDepthNode, $c2ec92bdddb724e3$var$ViewportDepthNode.DEPTH);
const $c2ec92bdddb724e3$export$eed228962b165d6f = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$60d11c6747b7deba)($c2ec92bdddb724e3$var$ViewportDepthNode, $c2ec92bdddb724e3$var$ViewportDepthNode.LINEAR_DEPTH);
const $c2ec92bdddb724e3$export$be070795fe97ef92 = /*@__PURE__*/ $c2ec92bdddb724e3$export$eed228962b165d6f((0, $7f9fd3aaf668ceba$export$8eb3800fd0750433)());
$c2ec92bdddb724e3$export$b202ba015b5882cd.assign = (value)=>$c2ec92bdddb724e3$var$depthBase(value);


const $ee61482daf06e140$export$f036aa9cc2605a10 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$b076717d71a1a47f)(([uv = null])=>{
    const depth = (0, $c2ec92bdddb724e3$export$eed228962b165d6f)();
    const depthDiff = (0, $c2ec92bdddb724e3$export$eed228962b165d6f)((0, $7f9fd3aaf668ceba$export$8eb3800fd0750433)(uv)).sub(depth);
    const finalUV = depthDiff.lessThan(0).select((0, $64df2f32a1195518$export$e2a68d187fb2dd60), uv);
    return finalUV;
});






class $e23ced6445243127$var$SpriteSheetUVNode extends (0, $65e77d5c3a27a66a$export$2e2bcd8739ae039) {
    static get type() {
        return 'SpriteSheetUVNode';
    }
    constructor(countNode, uvNode = (0, $382a32bd765f3827$export$c774ebbac59e31d3)(), frameNode = (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(0)){
        super('vec2');
        this.countNode = countNode;
        this.uvNode = uvNode;
        this.frameNode = frameNode;
    }
    setup() {
        const { frameNode: frameNode, uvNode: uvNode, countNode: countNode } = this;
        const { width: width, height: height } = countNode;
        const frameNum = frameNode.mod(width.mul(height)).floor();
        const column = frameNum.mod(width);
        const row = height.sub(frameNum.add(1).div(width).ceil());
        const scale = countNode.reciprocal();
        const uvFrameOffset = (0, $d5b7ee61758b2e81$export$e9830bc863290a54)(column, row);
        return uvNode.add(uvFrameOffset).mul(scale);
    }
}
var $e23ced6445243127$export$2e2bcd8739ae039 = $e23ced6445243127$var$SpriteSheetUVNode;
const $e23ced6445243127$export$f653ad67bdc54b70 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$60d11c6747b7deba)($e23ced6445243127$var$SpriteSheetUVNode);









class $5b9efbb3c86510a2$var$TriplanarTexturesNode extends (0, $65e77d5c3a27a66a$export$2e2bcd8739ae039) {
    static get type() {
        return 'TriplanarTexturesNode';
    }
    constructor(textureXNode, textureYNode = null, textureZNode = null, scaleNode = (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(1), positionNode = (0, $acbec2070ba15851$export$78cc3a7ea225109f), normalNode = (0, $0ab44deffc8ae973$export$c94af1e24aa56d8f)){
        super('vec4');
        this.textureXNode = textureXNode;
        this.textureYNode = textureYNode;
        this.textureZNode = textureZNode;
        this.scaleNode = scaleNode;
        this.positionNode = positionNode;
        this.normalNode = normalNode;
    }
    setup() {
        const { textureXNode: textureXNode, textureYNode: textureYNode, textureZNode: textureZNode, scaleNode: scaleNode, positionNode: positionNode, normalNode: normalNode } = this;
        // Ref: https://github.com/keijiro/StandardTriplanar
        // Blending factor of triplanar mapping
        let bf = normalNode.abs().normalize();
        bf = bf.div(bf.dot((0, $d5b7ee61758b2e81$export$9100789c9d999364)(1.0)));
        // Triplanar mapping
        const tx = positionNode.yz.mul(scaleNode);
        const ty = positionNode.zx.mul(scaleNode);
        const tz = positionNode.xy.mul(scaleNode);
        // Base color
        const textureX = textureXNode.value;
        const textureY = textureYNode !== null ? textureYNode.value : textureX;
        const textureZ = textureZNode !== null ? textureZNode.value : textureX;
        const cx = (0, $f7d68bbf9ea772a7$export$ab69073b3903a075)(textureX, tx).mul(bf.x);
        const cy = (0, $f7d68bbf9ea772a7$export$ab69073b3903a075)(textureY, ty).mul(bf.y);
        const cz = (0, $f7d68bbf9ea772a7$export$ab69073b3903a075)(textureZ, tz).mul(bf.z);
        return (0, $3f1f23fea79ae256$export$e16d8520af44a096)(cx, cy, cz);
    }
}
var $5b9efbb3c86510a2$export$2e2bcd8739ae039 = $5b9efbb3c86510a2$var$TriplanarTexturesNode;
const $5b9efbb3c86510a2$export$98913c3ae6fbe803 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$60d11c6747b7deba)($5b9efbb3c86510a2$var$TriplanarTexturesNode);
const $5b9efbb3c86510a2$export$86ecb77d774ad294 = (...params)=>$5b9efbb3c86510a2$export$98913c3ae6fbe803(...params);
















const $ac384e7663319ba6$var$_matrix = /*@__PURE__*/ new (0, $0ea09116adcadf95$export$2ae72fc923e5eb5)();
const $ac384e7663319ba6$var$_quaternion = /*@__PURE__*/ new (0, $cbf6795a106eec59$export$23d6a54f0bbc85a3)();
class $ac384e7663319ba6$export$d93cc409a0768c5f {
    constructor(x = 0, y = 0, z = 0, order = $ac384e7663319ba6$export$d93cc409a0768c5f.DEFAULT_ORDER){
        this.isEuler = true;
        this._x = x;
        this._y = y;
        this._z = z;
        this._order = order;
    }
    get x() {
        return this._x;
    }
    set x(value) {
        this._x = value;
        this._onChangeCallback();
    }
    get y() {
        return this._y;
    }
    set y(value) {
        this._y = value;
        this._onChangeCallback();
    }
    get z() {
        return this._z;
    }
    set z(value) {
        this._z = value;
        this._onChangeCallback();
    }
    get order() {
        return this._order;
    }
    set order(value) {
        this._order = value;
        this._onChangeCallback();
    }
    set(x, y, z, order = this._order) {
        this._x = x;
        this._y = y;
        this._z = z;
        this._order = order;
        this._onChangeCallback();
        return this;
    }
    clone() {
        return new this.constructor(this._x, this._y, this._z, this._order);
    }
    copy(euler) {
        this._x = euler._x;
        this._y = euler._y;
        this._z = euler._z;
        this._order = euler._order;
        this._onChangeCallback();
        return this;
    }
    setFromRotationMatrix(m, order = this._order, update = true) {
        // assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)
        const te = m.elements;
        const m11 = te[0], m12 = te[4], m13 = te[8];
        const m21 = te[1], m22 = te[5], m23 = te[9];
        const m31 = te[2], m32 = te[6], m33 = te[10];
        switch(order){
            case 'XYZ':
                this._y = Math.asin((0, $7f727a3c7059d20d$export$7d15b64cf5a3a4c4)(m13, -1, 1));
                if (Math.abs(m13) < 0.9999999) {
                    this._x = Math.atan2(-m23, m33);
                    this._z = Math.atan2(-m12, m11);
                } else {
                    this._x = Math.atan2(m32, m22);
                    this._z = 0;
                }
                break;
            case 'YXZ':
                this._x = Math.asin(-(0, $7f727a3c7059d20d$export$7d15b64cf5a3a4c4)(m23, -1, 1));
                if (Math.abs(m23) < 0.9999999) {
                    this._y = Math.atan2(m13, m33);
                    this._z = Math.atan2(m21, m22);
                } else {
                    this._y = Math.atan2(-m31, m11);
                    this._z = 0;
                }
                break;
            case 'ZXY':
                this._x = Math.asin((0, $7f727a3c7059d20d$export$7d15b64cf5a3a4c4)(m32, -1, 1));
                if (Math.abs(m32) < 0.9999999) {
                    this._y = Math.atan2(-m31, m33);
                    this._z = Math.atan2(-m12, m22);
                } else {
                    this._y = 0;
                    this._z = Math.atan2(m21, m11);
                }
                break;
            case 'ZYX':
                this._y = Math.asin(-(0, $7f727a3c7059d20d$export$7d15b64cf5a3a4c4)(m31, -1, 1));
                if (Math.abs(m31) < 0.9999999) {
                    this._x = Math.atan2(m32, m33);
                    this._z = Math.atan2(m21, m11);
                } else {
                    this._x = 0;
                    this._z = Math.atan2(-m12, m22);
                }
                break;
            case 'YZX':
                this._z = Math.asin((0, $7f727a3c7059d20d$export$7d15b64cf5a3a4c4)(m21, -1, 1));
                if (Math.abs(m21) < 0.9999999) {
                    this._x = Math.atan2(-m23, m22);
                    this._y = Math.atan2(-m31, m11);
                } else {
                    this._x = 0;
                    this._y = Math.atan2(m13, m33);
                }
                break;
            case 'XZY':
                this._z = Math.asin(-(0, $7f727a3c7059d20d$export$7d15b64cf5a3a4c4)(m12, -1, 1));
                if (Math.abs(m12) < 0.9999999) {
                    this._x = Math.atan2(m32, m22);
                    this._y = Math.atan2(m13, m11);
                } else {
                    this._x = Math.atan2(-m23, m33);
                    this._y = 0;
                }
                break;
            default:
                console.warn('THREE.Euler: .setFromRotationMatrix() encountered an unknown order: ' + order);
        }
        this._order = order;
        if (update === true) this._onChangeCallback();
        return this;
    }
    setFromQuaternion(q, order, update) {
        $ac384e7663319ba6$var$_matrix.makeRotationFromQuaternion(q);
        return this.setFromRotationMatrix($ac384e7663319ba6$var$_matrix, order, update);
    }
    setFromVector3(v, order = this._order) {
        return this.set(v.x, v.y, v.z, order);
    }
    reorder(newOrder) {
        // WARNING: this discards revolution information -bhouston
        $ac384e7663319ba6$var$_quaternion.setFromEuler(this);
        return this.setFromQuaternion($ac384e7663319ba6$var$_quaternion, newOrder);
    }
    equals(euler) {
        return euler._x === this._x && euler._y === this._y && euler._z === this._z && euler._order === this._order;
    }
    fromArray(array) {
        this._x = array[0];
        this._y = array[1];
        this._z = array[2];
        if (array[3] !== undefined) this._order = array[3];
        this._onChangeCallback();
        return this;
    }
    toArray(array = [], offset = 0) {
        array[offset] = this._x;
        array[offset + 1] = this._y;
        array[offset + 2] = this._z;
        array[offset + 3] = this._order;
        return array;
    }
    _onChange(callback) {
        this._onChangeCallback = callback;
        return this;
    }
    _onChangeCallback() {}
    *[Symbol.iterator]() {
        yield this._x;
        yield this._y;
        yield this._z;
        yield this._order;
    }
}
$ac384e7663319ba6$export$d93cc409a0768c5f.DEFAULT_ORDER = 'XYZ';


class $2c11c955154f4317$export$89312ce47c0ca777 {
    constructor(){
        this.mask = 1;
    }
    set(channel) {
        this.mask = (1 << channel | 0) >>> 0;
    }
    enable(channel) {
        this.mask |= 1 << channel | 0;
    }
    enableAll() {
        this.mask = -1;
    }
    toggle(channel) {
        this.mask ^= 1 << channel | 0;
    }
    disable(channel) {
        this.mask &= ~(1 << channel | 0);
    }
    disableAll() {
        this.mask = 0;
    }
    test(layers) {
        return (this.mask & layers.mask) !== 0;
    }
    isEnabled(channel) {
        return (this.mask & (1 << channel | 0)) !== 0;
    }
}




let $2894733dde59bc41$var$_object3DId = 0;
const $2894733dde59bc41$var$_v1 = /*@__PURE__*/ new (0, $d7d0ac0e47013885$export$64b5c384219d3699)();
const $2894733dde59bc41$var$_q1 = /*@__PURE__*/ new (0, $cbf6795a106eec59$export$23d6a54f0bbc85a3)();
const $2894733dde59bc41$var$_m1 = /*@__PURE__*/ new (0, $0ea09116adcadf95$export$2ae72fc923e5eb5)();
const $2894733dde59bc41$var$_target = /*@__PURE__*/ new (0, $d7d0ac0e47013885$export$64b5c384219d3699)();
const $2894733dde59bc41$var$_position = /*@__PURE__*/ new (0, $d7d0ac0e47013885$export$64b5c384219d3699)();
const $2894733dde59bc41$var$_scale = /*@__PURE__*/ new (0, $d7d0ac0e47013885$export$64b5c384219d3699)();
const $2894733dde59bc41$var$_quaternion = /*@__PURE__*/ new (0, $cbf6795a106eec59$export$23d6a54f0bbc85a3)();
const $2894733dde59bc41$var$_xAxis = /*@__PURE__*/ new (0, $d7d0ac0e47013885$export$64b5c384219d3699)(1, 0, 0);
const $2894733dde59bc41$var$_yAxis = /*@__PURE__*/ new (0, $d7d0ac0e47013885$export$64b5c384219d3699)(0, 1, 0);
const $2894733dde59bc41$var$_zAxis = /*@__PURE__*/ new (0, $d7d0ac0e47013885$export$64b5c384219d3699)(0, 0, 1);
const $2894733dde59bc41$var$_addedEvent = {
    type: 'added'
};
const $2894733dde59bc41$var$_removedEvent = {
    type: 'removed'
};
const $2894733dde59bc41$var$_childaddedEvent = {
    type: 'childadded',
    child: null
};
const $2894733dde59bc41$var$_childremovedEvent = {
    type: 'childremoved',
    child: null
};
class $2894733dde59bc41$export$e4dd07dff30cc924 extends (0, $a35132d5d9375da3$export$ec8b666c5fe2c75a) {
    constructor(){
        super();
        this.isObject3D = true;
        Object.defineProperty(this, 'id', {
            value: $2894733dde59bc41$var$_object3DId++
        });
        this.uuid = $7f727a3c7059d20d$export$e73c8bd0f20705a();
        this.name = '';
        this.type = 'Object3D';
        this.parent = null;
        this.children = [];
        this.up = $2894733dde59bc41$export$e4dd07dff30cc924.DEFAULT_UP.clone();
        const position = new (0, $d7d0ac0e47013885$export$64b5c384219d3699)();
        const rotation = new (0, $ac384e7663319ba6$export$d93cc409a0768c5f)();
        const quaternion = new (0, $cbf6795a106eec59$export$23d6a54f0bbc85a3)();
        const scale = new (0, $d7d0ac0e47013885$export$64b5c384219d3699)(1, 1, 1);
        function onRotationChange() {
            quaternion.setFromEuler(rotation, false);
        }
        function onQuaternionChange() {
            rotation.setFromQuaternion(quaternion, undefined, false);
        }
        rotation._onChange(onRotationChange);
        quaternion._onChange(onQuaternionChange);
        Object.defineProperties(this, {
            position: {
                configurable: true,
                enumerable: true,
                value: position
            },
            rotation: {
                configurable: true,
                enumerable: true,
                value: rotation
            },
            quaternion: {
                configurable: true,
                enumerable: true,
                value: quaternion
            },
            scale: {
                configurable: true,
                enumerable: true,
                value: scale
            },
            modelViewMatrix: {
                value: new (0, $0ea09116adcadf95$export$2ae72fc923e5eb5)()
            },
            normalMatrix: {
                value: new (0, $800ed18490319df2$export$8ff26dafa08918)()
            }
        });
        this.matrix = new (0, $0ea09116adcadf95$export$2ae72fc923e5eb5)();
        this.matrixWorld = new (0, $0ea09116adcadf95$export$2ae72fc923e5eb5)();
        this.matrixAutoUpdate = $2894733dde59bc41$export$e4dd07dff30cc924.DEFAULT_MATRIX_AUTO_UPDATE;
        this.matrixWorldAutoUpdate = $2894733dde59bc41$export$e4dd07dff30cc924.DEFAULT_MATRIX_WORLD_AUTO_UPDATE; // checked by the renderer
        this.matrixWorldNeedsUpdate = false;
        this.layers = new (0, $2c11c955154f4317$export$89312ce47c0ca777)();
        this.visible = true;
        this.castShadow = false;
        this.receiveShadow = false;
        this.frustumCulled = true;
        this.renderOrder = 0;
        this.animations = [];
        this.userData = {};
    }
    onBeforeShadow() {}
    onAfterShadow() {}
    onBeforeRender() {}
    onAfterRender() {}
    applyMatrix4(matrix) {
        if (this.matrixAutoUpdate) this.updateMatrix();
        this.matrix.premultiply(matrix);
        this.matrix.decompose(this.position, this.quaternion, this.scale);
    }
    applyQuaternion(q) {
        this.quaternion.premultiply(q);
        return this;
    }
    setRotationFromAxisAngle(axis, angle) {
        // assumes axis is normalized
        this.quaternion.setFromAxisAngle(axis, angle);
    }
    setRotationFromEuler(euler) {
        this.quaternion.setFromEuler(euler, true);
    }
    setRotationFromMatrix(m) {
        // assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)
        this.quaternion.setFromRotationMatrix(m);
    }
    setRotationFromQuaternion(q) {
        // assumes q is normalized
        this.quaternion.copy(q);
    }
    rotateOnAxis(axis, angle) {
        // rotate object on axis in object space
        // axis is assumed to be normalized
        $2894733dde59bc41$var$_q1.setFromAxisAngle(axis, angle);
        this.quaternion.multiply($2894733dde59bc41$var$_q1);
        return this;
    }
    rotateOnWorldAxis(axis, angle) {
        // rotate object on axis in world space
        // axis is assumed to be normalized
        // method assumes no rotated parent
        $2894733dde59bc41$var$_q1.setFromAxisAngle(axis, angle);
        this.quaternion.premultiply($2894733dde59bc41$var$_q1);
        return this;
    }
    rotateX(angle) {
        return this.rotateOnAxis($2894733dde59bc41$var$_xAxis, angle);
    }
    rotateY(angle) {
        return this.rotateOnAxis($2894733dde59bc41$var$_yAxis, angle);
    }
    rotateZ(angle) {
        return this.rotateOnAxis($2894733dde59bc41$var$_zAxis, angle);
    }
    translateOnAxis(axis, distance) {
        // translate object by distance along axis in object space
        // axis is assumed to be normalized
        $2894733dde59bc41$var$_v1.copy(axis).applyQuaternion(this.quaternion);
        this.position.add($2894733dde59bc41$var$_v1.multiplyScalar(distance));
        return this;
    }
    translateX(distance) {
        return this.translateOnAxis($2894733dde59bc41$var$_xAxis, distance);
    }
    translateY(distance) {
        return this.translateOnAxis($2894733dde59bc41$var$_yAxis, distance);
    }
    translateZ(distance) {
        return this.translateOnAxis($2894733dde59bc41$var$_zAxis, distance);
    }
    localToWorld(vector) {
        this.updateWorldMatrix(true, false);
        return vector.applyMatrix4(this.matrixWorld);
    }
    worldToLocal(vector) {
        this.updateWorldMatrix(true, false);
        return vector.applyMatrix4($2894733dde59bc41$var$_m1.copy(this.matrixWorld).invert());
    }
    lookAt(x, y, z) {
        // This method does not support objects having non-uniformly-scaled parent(s)
        if (x.isVector3) $2894733dde59bc41$var$_target.copy(x);
        else $2894733dde59bc41$var$_target.set(x, y, z);
        const parent = this.parent;
        this.updateWorldMatrix(true, false);
        $2894733dde59bc41$var$_position.setFromMatrixPosition(this.matrixWorld);
        if (this.isCamera || this.isLight) $2894733dde59bc41$var$_m1.lookAt($2894733dde59bc41$var$_position, $2894733dde59bc41$var$_target, this.up);
        else $2894733dde59bc41$var$_m1.lookAt($2894733dde59bc41$var$_target, $2894733dde59bc41$var$_position, this.up);
        this.quaternion.setFromRotationMatrix($2894733dde59bc41$var$_m1);
        if (parent) {
            $2894733dde59bc41$var$_m1.extractRotation(parent.matrixWorld);
            $2894733dde59bc41$var$_q1.setFromRotationMatrix($2894733dde59bc41$var$_m1);
            this.quaternion.premultiply($2894733dde59bc41$var$_q1.invert());
        }
    }
    add(object) {
        if (arguments.length > 1) {
            for(let i = 0; i < arguments.length; i++)this.add(arguments[i]);
            return this;
        }
        if (object === this) {
            console.error('THREE.Object3D.add: object can\'t be added as a child of itself.', object);
            return this;
        }
        if (object && object.isObject3D) {
            object.removeFromParent();
            object.parent = this;
            this.children.push(object);
            object.dispatchEvent($2894733dde59bc41$var$_addedEvent);
            $2894733dde59bc41$var$_childaddedEvent.child = object;
            this.dispatchEvent($2894733dde59bc41$var$_childaddedEvent);
            $2894733dde59bc41$var$_childaddedEvent.child = null;
        } else console.error('THREE.Object3D.add: object not an instance of THREE.Object3D.', object);
        return this;
    }
    remove(object) {
        if (arguments.length > 1) {
            for(let i = 0; i < arguments.length; i++)this.remove(arguments[i]);
            return this;
        }
        const index = this.children.indexOf(object);
        if (index !== -1) {
            object.parent = null;
            this.children.splice(index, 1);
            object.dispatchEvent($2894733dde59bc41$var$_removedEvent);
            $2894733dde59bc41$var$_childremovedEvent.child = object;
            this.dispatchEvent($2894733dde59bc41$var$_childremovedEvent);
            $2894733dde59bc41$var$_childremovedEvent.child = null;
        }
        return this;
    }
    removeFromParent() {
        const parent = this.parent;
        if (parent !== null) parent.remove(this);
        return this;
    }
    clear() {
        return this.remove(...this.children);
    }
    attach(object) {
        // adds object as a child of this, while maintaining the object's world transform
        // Note: This method does not support scene graphs having non-uniformly-scaled nodes(s)
        this.updateWorldMatrix(true, false);
        $2894733dde59bc41$var$_m1.copy(this.matrixWorld).invert();
        if (object.parent !== null) {
            object.parent.updateWorldMatrix(true, false);
            $2894733dde59bc41$var$_m1.multiply(object.parent.matrixWorld);
        }
        object.applyMatrix4($2894733dde59bc41$var$_m1);
        object.removeFromParent();
        object.parent = this;
        this.children.push(object);
        object.updateWorldMatrix(false, true);
        object.dispatchEvent($2894733dde59bc41$var$_addedEvent);
        $2894733dde59bc41$var$_childaddedEvent.child = object;
        this.dispatchEvent($2894733dde59bc41$var$_childaddedEvent);
        $2894733dde59bc41$var$_childaddedEvent.child = null;
        return this;
    }
    getObjectById(id) {
        return this.getObjectByProperty('id', id);
    }
    getObjectByName(name) {
        return this.getObjectByProperty('name', name);
    }
    getObjectByProperty(name, value) {
        if (this[name] === value) return this;
        for(let i = 0, l = this.children.length; i < l; i++){
            const child = this.children[i];
            const object = child.getObjectByProperty(name, value);
            if (object !== undefined) return object;
        }
        return undefined;
    }
    getObjectsByProperty(name, value, result = []) {
        if (this[name] === value) result.push(this);
        const children = this.children;
        for(let i = 0, l = children.length; i < l; i++)children[i].getObjectsByProperty(name, value, result);
        return result;
    }
    getWorldPosition(target) {
        this.updateWorldMatrix(true, false);
        return target.setFromMatrixPosition(this.matrixWorld);
    }
    getWorldQuaternion(target) {
        this.updateWorldMatrix(true, false);
        this.matrixWorld.decompose($2894733dde59bc41$var$_position, target, $2894733dde59bc41$var$_scale);
        return target;
    }
    getWorldScale(target) {
        this.updateWorldMatrix(true, false);
        this.matrixWorld.decompose($2894733dde59bc41$var$_position, $2894733dde59bc41$var$_quaternion, target);
        return target;
    }
    getWorldDirection(target) {
        this.updateWorldMatrix(true, false);
        const e = this.matrixWorld.elements;
        return target.set(e[8], e[9], e[10]).normalize();
    }
    raycast() {}
    traverse(callback) {
        callback(this);
        const children = this.children;
        for(let i = 0, l = children.length; i < l; i++)children[i].traverse(callback);
    }
    traverseVisible(callback) {
        if (this.visible === false) return;
        callback(this);
        const children = this.children;
        for(let i = 0, l = children.length; i < l; i++)children[i].traverseVisible(callback);
    }
    traverseAncestors(callback) {
        const parent = this.parent;
        if (parent !== null) {
            callback(parent);
            parent.traverseAncestors(callback);
        }
    }
    updateMatrix() {
        this.matrix.compose(this.position, this.quaternion, this.scale);
        this.matrixWorldNeedsUpdate = true;
    }
    updateMatrixWorld(force) {
        if (this.matrixAutoUpdate) this.updateMatrix();
        if (this.matrixWorldNeedsUpdate || force) {
            if (this.matrixWorldAutoUpdate === true) {
                if (this.parent === null) this.matrixWorld.copy(this.matrix);
                else this.matrixWorld.multiplyMatrices(this.parent.matrixWorld, this.matrix);
            }
            this.matrixWorldNeedsUpdate = false;
            force = true;
        }
        // make sure descendants are updated if required
        const children = this.children;
        for(let i = 0, l = children.length; i < l; i++){
            const child = children[i];
            child.updateMatrixWorld(force);
        }
    }
    updateWorldMatrix(updateParents, updateChildren) {
        const parent = this.parent;
        if (updateParents === true && parent !== null) parent.updateWorldMatrix(true, false);
        if (this.matrixAutoUpdate) this.updateMatrix();
        if (this.matrixWorldAutoUpdate === true) {
            if (this.parent === null) this.matrixWorld.copy(this.matrix);
            else this.matrixWorld.multiplyMatrices(this.parent.matrixWorld, this.matrix);
        }
        // make sure descendants are updated
        if (updateChildren === true) {
            const children = this.children;
            for(let i = 0, l = children.length; i < l; i++){
                const child = children[i];
                child.updateWorldMatrix(false, true);
            }
        }
    }
    toJSON(meta) {
        // meta is a string when called from JSON.stringify
        const isRootObject = meta === undefined || typeof meta === 'string';
        const output = {};
        // meta is a hash used to collect geometries, materials.
        // not providing it implies that this is the root object
        // being serialized.
        if (isRootObject) {
            // initialize meta obj
            meta = {
                geometries: {},
                materials: {},
                textures: {},
                images: {},
                shapes: {},
                skeletons: {},
                animations: {},
                nodes: {}
            };
            output.metadata = {
                version: 4.6,
                type: 'Object',
                generator: 'Object3D.toJSON'
            };
        }
        // standard Object3D serialization
        const object = {};
        object.uuid = this.uuid;
        object.type = this.type;
        if (this.name !== '') object.name = this.name;
        if (this.castShadow === true) object.castShadow = true;
        if (this.receiveShadow === true) object.receiveShadow = true;
        if (this.visible === false) object.visible = false;
        if (this.frustumCulled === false) object.frustumCulled = false;
        if (this.renderOrder !== 0) object.renderOrder = this.renderOrder;
        if (Object.keys(this.userData).length > 0) object.userData = this.userData;
        object.layers = this.layers.mask;
        object.matrix = this.matrix.toArray();
        object.up = this.up.toArray();
        if (this.matrixAutoUpdate === false) object.matrixAutoUpdate = false;
        // object specific properties
        if (this.isInstancedMesh) {
            object.type = 'InstancedMesh';
            object.count = this.count;
            object.instanceMatrix = this.instanceMatrix.toJSON();
            if (this.instanceColor !== null) object.instanceColor = this.instanceColor.toJSON();
        }
        if (this.isBatchedMesh) {
            object.type = 'BatchedMesh';
            object.perObjectFrustumCulled = this.perObjectFrustumCulled;
            object.sortObjects = this.sortObjects;
            object.drawRanges = this._drawRanges;
            object.reservedRanges = this._reservedRanges;
            object.visibility = this._visibility;
            object.active = this._active;
            object.bounds = this._bounds.map((bound)=>({
                    boxInitialized: bound.boxInitialized,
                    boxMin: bound.box.min.toArray(),
                    boxMax: bound.box.max.toArray(),
                    sphereInitialized: bound.sphereInitialized,
                    sphereRadius: bound.sphere.radius,
                    sphereCenter: bound.sphere.center.toArray()
                }));
            object.maxInstanceCount = this._maxInstanceCount;
            object.maxVertexCount = this._maxVertexCount;
            object.maxIndexCount = this._maxIndexCount;
            object.geometryInitialized = this._geometryInitialized;
            object.geometryCount = this._geometryCount;
            object.matricesTexture = this._matricesTexture.toJSON(meta);
            if (this._colorsTexture !== null) object.colorsTexture = this._colorsTexture.toJSON(meta);
            if (this.boundingSphere !== null) object.boundingSphere = {
                center: object.boundingSphere.center.toArray(),
                radius: object.boundingSphere.radius
            };
            if (this.boundingBox !== null) object.boundingBox = {
                min: object.boundingBox.min.toArray(),
                max: object.boundingBox.max.toArray()
            };
        }
        //
        function serialize(library, element) {
            if (library[element.uuid] === undefined) library[element.uuid] = element.toJSON(meta);
            return element.uuid;
        }
        if (this.isScene) {
            if (this.background) {
                if (this.background.isColor) object.background = this.background.toJSON();
                else if (this.background.isTexture) object.background = this.background.toJSON(meta).uuid;
            }
            if (this.environment && this.environment.isTexture && this.environment.isRenderTargetTexture !== true) object.environment = this.environment.toJSON(meta).uuid;
        } else if (this.isMesh || this.isLine || this.isPoints) {
            object.geometry = serialize(meta.geometries, this.geometry);
            const parameters = this.geometry.parameters;
            if (parameters !== undefined && parameters.shapes !== undefined) {
                const shapes = parameters.shapes;
                if (Array.isArray(shapes)) for(let i = 0, l = shapes.length; i < l; i++){
                    const shape = shapes[i];
                    serialize(meta.shapes, shape);
                }
                else serialize(meta.shapes, shapes);
            }
        }
        if (this.isSkinnedMesh) {
            object.bindMode = this.bindMode;
            object.bindMatrix = this.bindMatrix.toArray();
            if (this.skeleton !== undefined) {
                serialize(meta.skeletons, this.skeleton);
                object.skeleton = this.skeleton.uuid;
            }
        }
        if (this.material !== undefined) {
            if (Array.isArray(this.material)) {
                const uuids = [];
                for(let i = 0, l = this.material.length; i < l; i++)uuids.push(serialize(meta.materials, this.material[i]));
                object.material = uuids;
            } else object.material = serialize(meta.materials, this.material);
        }
        //
        if (this.children.length > 0) {
            object.children = [];
            for(let i = 0; i < this.children.length; i++)object.children.push(this.children[i].toJSON(meta).object);
        }
        //
        if (this.animations.length > 0) {
            object.animations = [];
            for(let i = 0; i < this.animations.length; i++){
                const animation = this.animations[i];
                object.animations.push(serialize(meta.animations, animation));
            }
        }
        if (isRootObject) {
            const geometries = extractFromCache(meta.geometries);
            const materials = extractFromCache(meta.materials);
            const textures = extractFromCache(meta.textures);
            const images = extractFromCache(meta.images);
            const shapes = extractFromCache(meta.shapes);
            const skeletons = extractFromCache(meta.skeletons);
            const animations = extractFromCache(meta.animations);
            const nodes = extractFromCache(meta.nodes);
            if (geometries.length > 0) output.geometries = geometries;
            if (materials.length > 0) output.materials = materials;
            if (textures.length > 0) output.textures = textures;
            if (images.length > 0) output.images = images;
            if (shapes.length > 0) output.shapes = shapes;
            if (skeletons.length > 0) output.skeletons = skeletons;
            if (animations.length > 0) output.animations = animations;
            if (nodes.length > 0) output.nodes = nodes;
        }
        output.object = object;
        return output;
        // extract data from the cache hash
        // remove metadata on each item
        // and return as array
        function extractFromCache(cache) {
            const values = [];
            for(const key in cache){
                const data = cache[key];
                delete data.metadata;
                values.push(data);
            }
            return values;
        }
    }
    clone(recursive) {
        return new this.constructor().copy(this, recursive);
    }
    copy(source, recursive = true) {
        this.name = source.name;
        this.up.copy(source.up);
        this.position.copy(source.position);
        this.rotation.order = source.rotation.order;
        this.quaternion.copy(source.quaternion);
        this.scale.copy(source.scale);
        this.matrix.copy(source.matrix);
        this.matrixWorld.copy(source.matrixWorld);
        this.matrixAutoUpdate = source.matrixAutoUpdate;
        this.matrixWorldAutoUpdate = source.matrixWorldAutoUpdate;
        this.matrixWorldNeedsUpdate = source.matrixWorldNeedsUpdate;
        this.layers.mask = source.layers.mask;
        this.visible = source.visible;
        this.castShadow = source.castShadow;
        this.receiveShadow = source.receiveShadow;
        this.frustumCulled = source.frustumCulled;
        this.renderOrder = source.renderOrder;
        this.animations = source.animations.slice();
        this.userData = JSON.parse(JSON.stringify(source.userData));
        if (recursive === true) for(let i = 0; i < source.children.length; i++){
            const child = source.children[i];
            this.add(child.clone());
        }
        return this;
    }
}
$2894733dde59bc41$export$e4dd07dff30cc924.DEFAULT_UP = /*@__PURE__*/ new (0, $d7d0ac0e47013885$export$64b5c384219d3699)(0, 1, 0);
$2894733dde59bc41$export$e4dd07dff30cc924.DEFAULT_MATRIX_AUTO_UPDATE = true;
$2894733dde59bc41$export$e4dd07dff30cc924.DEFAULT_MATRIX_WORLD_AUTO_UPDATE = true;











/*
 In options, we can specify:
 * Texture parameters for an auto-generated target texture
 * depthBuffer/stencilBuffer: Booleans to indicate if we should generate these buffers
*/ class $2ca03eab531e649d$export$efcb1f8bf367cbfb extends (0, $a35132d5d9375da3$export$ec8b666c5fe2c75a) {
    constructor(width = 1, height = 1, options = {}){
        super();
        this.isRenderTarget = true;
        this.width = width;
        this.height = height;
        this.depth = 1;
        this.scissor = new (0, $a09a15e9a8421204$export$fa7daccca11cdbe3)(0, 0, width, height);
        this.scissorTest = false;
        this.viewport = new (0, $a09a15e9a8421204$export$fa7daccca11cdbe3)(0, 0, width, height);
        const image = {
            width: width,
            height: height,
            depth: 1
        };
        options = Object.assign({
            generateMipmaps: false,
            internalFormat: null,
            minFilter: (0, $cb5ee595c0f892af$export$8a72f490b25c56c8),
            depthBuffer: true,
            stencilBuffer: false,
            resolveDepthBuffer: true,
            resolveStencilBuffer: true,
            depthTexture: null,
            samples: 0,
            count: 1
        }, options);
        const texture = new (0, $97033ebbcbadc145$export$5431306cf43de24a)(image, options.mapping, options.wrapS, options.wrapT, options.magFilter, options.minFilter, options.format, options.type, options.anisotropy, options.colorSpace);
        texture.flipY = false;
        texture.generateMipmaps = options.generateMipmaps;
        texture.internalFormat = options.internalFormat;
        this.textures = [];
        const count = options.count;
        for(let i = 0; i < count; i++){
            this.textures[i] = texture.clone();
            this.textures[i].isRenderTargetTexture = true;
        }
        this.depthBuffer = options.depthBuffer;
        this.stencilBuffer = options.stencilBuffer;
        this.resolveDepthBuffer = options.resolveDepthBuffer;
        this.resolveStencilBuffer = options.resolveStencilBuffer;
        this.depthTexture = options.depthTexture;
        this.samples = options.samples;
    }
    get texture() {
        return this.textures[0];
    }
    set texture(value) {
        this.textures[0] = value;
    }
    setSize(width, height, depth = 1) {
        if (this.width !== width || this.height !== height || this.depth !== depth) {
            this.width = width;
            this.height = height;
            this.depth = depth;
            for(let i = 0, il = this.textures.length; i < il; i++){
                this.textures[i].image.width = width;
                this.textures[i].image.height = height;
                this.textures[i].image.depth = depth;
            }
            this.dispose();
        }
        this.viewport.set(0, 0, width, height);
        this.scissor.set(0, 0, width, height);
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(source) {
        this.width = source.width;
        this.height = source.height;
        this.depth = source.depth;
        this.scissor.copy(source.scissor);
        this.scissorTest = source.scissorTest;
        this.viewport.copy(source.viewport);
        this.textures.length = 0;
        for(let i = 0, il = source.textures.length; i < il; i++){
            this.textures[i] = source.textures[i].clone();
            this.textures[i].isRenderTargetTexture = true;
        }
        // ensure image object is not shared, see #20328
        const image = Object.assign({}, source.texture.image);
        this.texture.source = new (0, $56717028e6e96c4f$export$1d2df86270c81ecb)(image);
        this.depthBuffer = source.depthBuffer;
        this.stencilBuffer = source.stencilBuffer;
        this.resolveDepthBuffer = source.resolveDepthBuffer;
        this.resolveStencilBuffer = source.resolveStencilBuffer;
        if (source.depthTexture !== null) this.depthTexture = source.depthTexture.clone();
        this.samples = source.samples;
        return this;
    }
    dispose() {
        this.dispatchEvent({
            type: 'dispose'
        });
    }
}



const $25ea8d799ddf1f52$var$_reflectorPlane = new (0, $741db1fce3b06570$export$7ff5ac152ef991b0)();
const $25ea8d799ddf1f52$var$_normal = new (0, $d7d0ac0e47013885$export$64b5c384219d3699)();
const $25ea8d799ddf1f52$var$_reflectorWorldPosition = new (0, $d7d0ac0e47013885$export$64b5c384219d3699)();
const $25ea8d799ddf1f52$var$_cameraWorldPosition = new (0, $d7d0ac0e47013885$export$64b5c384219d3699)();
const $25ea8d799ddf1f52$var$_rotationMatrix = new (0, $0ea09116adcadf95$export$2ae72fc923e5eb5)();
const $25ea8d799ddf1f52$var$_lookAtPosition = new (0, $d7d0ac0e47013885$export$64b5c384219d3699)(0, 0, -1);
const $25ea8d799ddf1f52$var$clipPlane = new (0, $a09a15e9a8421204$export$fa7daccca11cdbe3)();
const $25ea8d799ddf1f52$var$_view = new (0, $d7d0ac0e47013885$export$64b5c384219d3699)();
const $25ea8d799ddf1f52$var$_target = new (0, $d7d0ac0e47013885$export$64b5c384219d3699)();
const $25ea8d799ddf1f52$var$_q = new (0, $a09a15e9a8421204$export$fa7daccca11cdbe3)();
const $25ea8d799ddf1f52$var$_size = new (0, $3c03061dea0adea3$export$c977b3e384af9ae1)();
const $25ea8d799ddf1f52$var$_defaultRT = new (0, $2ca03eab531e649d$export$efcb1f8bf367cbfb)();
const $25ea8d799ddf1f52$var$_defaultUV = (0, $64df2f32a1195518$export$e2a68d187fb2dd60).flipX();
$25ea8d799ddf1f52$var$_defaultRT.depthTexture = new (0, $520286b5db9c7cf5$export$fc830aa069cc8c2f)(1, 1);
let $25ea8d799ddf1f52$var$_inReflector = false;
class $25ea8d799ddf1f52$var$ReflectorNode extends (0, $f7d68bbf9ea772a7$export$2e2bcd8739ae039) {
    static get type() {
        return 'ReflectorNode';
    }
    constructor(parameters = {}){
        super(parameters.defaultTexture || $25ea8d799ddf1f52$var$_defaultRT.texture, $25ea8d799ddf1f52$var$_defaultUV);
        this._reflectorBaseNode = parameters.reflector || new $25ea8d799ddf1f52$var$ReflectorBaseNode(this, parameters);
        this._depthNode = null;
        this.setUpdateMatrix(false);
    }
    get reflector() {
        return this._reflectorBaseNode;
    }
    get target() {
        return this._reflectorBaseNode.target;
    }
    getDepthNode() {
        if (this._depthNode === null) {
            if (this._reflectorBaseNode.depth !== true) throw new Error('THREE.ReflectorNode: Depth node can only be requested when the reflector is created with { depth: true }. ');
            this._depthNode = (0, $d5b7ee61758b2e81$export$e97474e17004dd41)(new $25ea8d799ddf1f52$var$ReflectorNode({
                defaultTexture: $25ea8d799ddf1f52$var$_defaultRT.depthTexture,
                reflector: this._reflectorBaseNode
            }));
        }
        return this._depthNode;
    }
    setup(builder) {
        // ignore if used in post-processing
        if (!builder.object.isQuadMesh) this._reflectorBaseNode.build(builder);
        return super.setup(builder);
    }
    clone() {
        const texture = new this.constructor(this.reflectorNode);
        texture._reflectorBaseNode = this._reflectorBaseNode;
        return texture;
    }
}
class $25ea8d799ddf1f52$var$ReflectorBaseNode extends (0, $65e77d5c3a27a66a$export$2e2bcd8739ae039) {
    static get type() {
        return 'ReflectorBaseNode';
    }
    constructor(textureNode, parameters = {}){
        super();
        const { target: target = new (0, $2894733dde59bc41$export$e4dd07dff30cc924)(), resolution: resolution = 1, generateMipmaps: generateMipmaps = false, bounces: bounces = true, depth: depth = false } = parameters;
        //
        this.textureNode = textureNode;
        this.target = target;
        this.resolution = resolution;
        this.generateMipmaps = generateMipmaps;
        this.bounces = bounces;
        this.depth = depth;
        this.updateBeforeType = bounces ? (0, $ddcfecb7fbba5d74$export$26f7a8bbd9469530).RENDER : (0, $ddcfecb7fbba5d74$export$26f7a8bbd9469530).FRAME;
        this.virtualCameras = new WeakMap();
        this.renderTargets = new WeakMap();
    }
    _updateResolution(renderTarget, renderer) {
        const resolution = this.resolution;
        renderer.getDrawingBufferSize($25ea8d799ddf1f52$var$_size);
        renderTarget.setSize(Math.round($25ea8d799ddf1f52$var$_size.width * resolution), Math.round($25ea8d799ddf1f52$var$_size.height * resolution));
    }
    setup(builder) {
        this._updateResolution($25ea8d799ddf1f52$var$_defaultRT, builder.renderer);
        return super.setup(builder);
    }
    getVirtualCamera(camera) {
        let virtualCamera = this.virtualCameras.get(camera);
        if (virtualCamera === undefined) {
            virtualCamera = camera.clone();
            this.virtualCameras.set(camera, virtualCamera);
        }
        return virtualCamera;
    }
    getRenderTarget(camera) {
        let renderTarget = this.renderTargets.get(camera);
        if (renderTarget === undefined) {
            renderTarget = new (0, $2ca03eab531e649d$export$efcb1f8bf367cbfb)(0, 0, {
                type: (0, $cb5ee595c0f892af$export$2697304443f382bc)
            });
            if (this.generateMipmaps === true) {
                renderTarget.texture.minFilter = (0, $cb5ee595c0f892af$export$90d80f1e3506775f);
                renderTarget.texture.generateMipmaps = true;
            }
            if (this.depth === true) renderTarget.depthTexture = new (0, $520286b5db9c7cf5$export$fc830aa069cc8c2f)();
            this.renderTargets.set(camera, renderTarget);
        }
        return renderTarget;
    }
    updateBefore(frame) {
        if (this.bounces === false && $25ea8d799ddf1f52$var$_inReflector) return;
        $25ea8d799ddf1f52$var$_inReflector = true;
        const { scene: scene, camera: camera, renderer: renderer, material: material } = frame;
        const { target: target } = this;
        const virtualCamera = this.getVirtualCamera(camera);
        const renderTarget = this.getRenderTarget(virtualCamera);
        renderer.getDrawingBufferSize($25ea8d799ddf1f52$var$_size);
        this._updateResolution(renderTarget, renderer);
        //
        $25ea8d799ddf1f52$var$_reflectorWorldPosition.setFromMatrixPosition(target.matrixWorld);
        $25ea8d799ddf1f52$var$_cameraWorldPosition.setFromMatrixPosition(camera.matrixWorld);
        $25ea8d799ddf1f52$var$_rotationMatrix.extractRotation(target.matrixWorld);
        $25ea8d799ddf1f52$var$_normal.set(0, 0, 1);
        $25ea8d799ddf1f52$var$_normal.applyMatrix4($25ea8d799ddf1f52$var$_rotationMatrix);
        $25ea8d799ddf1f52$var$_view.subVectors($25ea8d799ddf1f52$var$_reflectorWorldPosition, $25ea8d799ddf1f52$var$_cameraWorldPosition);
        // Avoid rendering when reflector is facing away
        if ($25ea8d799ddf1f52$var$_view.dot($25ea8d799ddf1f52$var$_normal) > 0) return;
        $25ea8d799ddf1f52$var$_view.reflect($25ea8d799ddf1f52$var$_normal).negate();
        $25ea8d799ddf1f52$var$_view.add($25ea8d799ddf1f52$var$_reflectorWorldPosition);
        $25ea8d799ddf1f52$var$_rotationMatrix.extractRotation(camera.matrixWorld);
        $25ea8d799ddf1f52$var$_lookAtPosition.set(0, 0, -1);
        $25ea8d799ddf1f52$var$_lookAtPosition.applyMatrix4($25ea8d799ddf1f52$var$_rotationMatrix);
        $25ea8d799ddf1f52$var$_lookAtPosition.add($25ea8d799ddf1f52$var$_cameraWorldPosition);
        $25ea8d799ddf1f52$var$_target.subVectors($25ea8d799ddf1f52$var$_reflectorWorldPosition, $25ea8d799ddf1f52$var$_lookAtPosition);
        $25ea8d799ddf1f52$var$_target.reflect($25ea8d799ddf1f52$var$_normal).negate();
        $25ea8d799ddf1f52$var$_target.add($25ea8d799ddf1f52$var$_reflectorWorldPosition);
        //
        virtualCamera.coordinateSystem = camera.coordinateSystem;
        virtualCamera.position.copy($25ea8d799ddf1f52$var$_view);
        virtualCamera.up.set(0, 1, 0);
        virtualCamera.up.applyMatrix4($25ea8d799ddf1f52$var$_rotationMatrix);
        virtualCamera.up.reflect($25ea8d799ddf1f52$var$_normal);
        virtualCamera.lookAt($25ea8d799ddf1f52$var$_target);
        virtualCamera.near = camera.near;
        virtualCamera.far = camera.far;
        virtualCamera.updateMatrixWorld();
        virtualCamera.projectionMatrix.copy(camera.projectionMatrix);
        // Now update projection matrix with new clip plane, implementing code from: http://www.terathon.com/code/oblique.html
        // Paper explaining this technique: http://www.terathon.com/lengyel/Lengyel-Oblique.pdf
        $25ea8d799ddf1f52$var$_reflectorPlane.setFromNormalAndCoplanarPoint($25ea8d799ddf1f52$var$_normal, $25ea8d799ddf1f52$var$_reflectorWorldPosition);
        $25ea8d799ddf1f52$var$_reflectorPlane.applyMatrix4(virtualCamera.matrixWorldInverse);
        $25ea8d799ddf1f52$var$clipPlane.set($25ea8d799ddf1f52$var$_reflectorPlane.normal.x, $25ea8d799ddf1f52$var$_reflectorPlane.normal.y, $25ea8d799ddf1f52$var$_reflectorPlane.normal.z, $25ea8d799ddf1f52$var$_reflectorPlane.constant);
        const projectionMatrix = virtualCamera.projectionMatrix;
        $25ea8d799ddf1f52$var$_q.x = (Math.sign($25ea8d799ddf1f52$var$clipPlane.x) + projectionMatrix.elements[8]) / projectionMatrix.elements[0];
        $25ea8d799ddf1f52$var$_q.y = (Math.sign($25ea8d799ddf1f52$var$clipPlane.y) + projectionMatrix.elements[9]) / projectionMatrix.elements[5];
        $25ea8d799ddf1f52$var$_q.z = -1;
        $25ea8d799ddf1f52$var$_q.w = (1.0 + projectionMatrix.elements[10]) / projectionMatrix.elements[14];
        // Calculate the scaled plane vector
        $25ea8d799ddf1f52$var$clipPlane.multiplyScalar(1.0 / $25ea8d799ddf1f52$var$clipPlane.dot($25ea8d799ddf1f52$var$_q));
        const clipBias = 0;
        // Replacing the third row of the projection matrix
        projectionMatrix.elements[2] = $25ea8d799ddf1f52$var$clipPlane.x;
        projectionMatrix.elements[6] = $25ea8d799ddf1f52$var$clipPlane.y;
        projectionMatrix.elements[10] = renderer.coordinateSystem === (0, $cb5ee595c0f892af$export$cc83beedcb9be9ac) ? $25ea8d799ddf1f52$var$clipPlane.z - clipBias : $25ea8d799ddf1f52$var$clipPlane.z + 1.0 - clipBias;
        projectionMatrix.elements[14] = $25ea8d799ddf1f52$var$clipPlane.w;
        //
        this.textureNode.value = renderTarget.texture;
        if (this.depth === true) this.textureNode.getDepthNode().value = renderTarget.depthTexture;
        material.visible = false;
        const currentRenderTarget = renderer.getRenderTarget();
        const currentMRT = renderer.getMRT();
        renderer.setMRT(null);
        renderer.setRenderTarget(renderTarget);
        renderer.render(scene, virtualCamera);
        renderer.setMRT(currentMRT);
        renderer.setRenderTarget(currentRenderTarget);
        material.visible = true;
        $25ea8d799ddf1f52$var$_inReflector = false;
    }
}
const $25ea8d799ddf1f52$export$b5a7f174a914fa82 = (parameters)=>(0, $d5b7ee61758b2e81$export$e97474e17004dd41)(new $25ea8d799ddf1f52$var$ReflectorNode(parameters));
var $25ea8d799ddf1f52$export$2e2bcd8739ae039 = $25ea8d799ddf1f52$var$ReflectorNode;










let $7711e1b3c41f4d78$var$_materialId = 0;
class $7711e1b3c41f4d78$export$a2d8b23205c25948 extends (0, $a35132d5d9375da3$export$ec8b666c5fe2c75a) {
    static get type() {
        return 'Material';
    }
    get type() {
        return this.constructor.type;
    }
    set type(_value) {}
    constructor(){
        super();
        this.isMaterial = true;
        Object.defineProperty(this, 'id', {
            value: $7711e1b3c41f4d78$var$_materialId++
        });
        this.uuid = $7f727a3c7059d20d$export$e73c8bd0f20705a();
        this.name = '';
        this.blending = (0, $cb5ee595c0f892af$export$5b29a26d96ee6af0);
        this.side = (0, $cb5ee595c0f892af$export$2ede184fc2998901);
        this.vertexColors = false;
        this.opacity = 1;
        this.transparent = false;
        this.alphaHash = false;
        this.blendSrc = (0, $cb5ee595c0f892af$export$d5773124e86cf28c);
        this.blendDst = (0, $cb5ee595c0f892af$export$11d468cc7f19e971);
        this.blendEquation = (0, $cb5ee595c0f892af$export$20183a0484ce21a0);
        this.blendSrcAlpha = null;
        this.blendDstAlpha = null;
        this.blendEquationAlpha = null;
        this.blendColor = new (0, $9a23ce591a1b6760$export$892596cec99bc70e)(0, 0, 0);
        this.blendAlpha = 0;
        this.depthFunc = (0, $cb5ee595c0f892af$export$296f78a0b892f81a);
        this.depthTest = true;
        this.depthWrite = true;
        this.stencilWriteMask = 0xff;
        this.stencilFunc = (0, $cb5ee595c0f892af$export$14cf96713ddd97a8);
        this.stencilRef = 0;
        this.stencilFuncMask = 0xff;
        this.stencilFail = (0, $cb5ee595c0f892af$export$9f542ae4b5baca34);
        this.stencilZFail = (0, $cb5ee595c0f892af$export$9f542ae4b5baca34);
        this.stencilZPass = (0, $cb5ee595c0f892af$export$9f542ae4b5baca34);
        this.stencilWrite = false;
        this.clippingPlanes = null;
        this.clipIntersection = false;
        this.clipShadows = false;
        this.shadowSide = null;
        this.colorWrite = true;
        this.precision = null; // override the renderer's default precision for this material
        this.polygonOffset = false;
        this.polygonOffsetFactor = 0;
        this.polygonOffsetUnits = 0;
        this.dithering = false;
        this.alphaToCoverage = false;
        this.premultipliedAlpha = false;
        this.forceSinglePass = false;
        this.visible = true;
        this.toneMapped = true;
        this.userData = {};
        this.version = 0;
        this._alphaTest = 0;
    }
    get alphaTest() {
        return this._alphaTest;
    }
    set alphaTest(value) {
        if (this._alphaTest > 0 !== value > 0) this.version++;
        this._alphaTest = value;
    }
    // onBeforeRender and onBeforeCompile only supported in WebGLRenderer
    onBeforeRender() {}
    onBeforeCompile() {}
    customProgramCacheKey() {
        return this.onBeforeCompile.toString();
    }
    setValues(values) {
        if (values === undefined) return;
        for(const key in values){
            const newValue = values[key];
            if (newValue === undefined) {
                console.warn(`THREE.Material: parameter '${key}' has value of undefined.`);
                continue;
            }
            const currentValue = this[key];
            if (currentValue === undefined) {
                console.warn(`THREE.Material: '${key}' is not a property of THREE.${this.type}.`);
                continue;
            }
            if (currentValue && currentValue.isColor) currentValue.set(newValue);
            else if (currentValue && currentValue.isVector3 && newValue && newValue.isVector3) currentValue.copy(newValue);
            else this[key] = newValue;
        }
    }
    toJSON(meta) {
        const isRootObject = meta === undefined || typeof meta === 'string';
        if (isRootObject) meta = {
            textures: {},
            images: {}
        };
        const data = {
            metadata: {
                version: 4.6,
                type: 'Material',
                generator: 'Material.toJSON'
            }
        };
        // standard Material serialization
        data.uuid = this.uuid;
        data.type = this.type;
        if (this.name !== '') data.name = this.name;
        if (this.color && this.color.isColor) data.color = this.color.getHex();
        if (this.roughness !== undefined) data.roughness = this.roughness;
        if (this.metalness !== undefined) data.metalness = this.metalness;
        if (this.sheen !== undefined) data.sheen = this.sheen;
        if (this.sheenColor && this.sheenColor.isColor) data.sheenColor = this.sheenColor.getHex();
        if (this.sheenRoughness !== undefined) data.sheenRoughness = this.sheenRoughness;
        if (this.emissive && this.emissive.isColor) data.emissive = this.emissive.getHex();
        if (this.emissiveIntensity !== undefined && this.emissiveIntensity !== 1) data.emissiveIntensity = this.emissiveIntensity;
        if (this.specular && this.specular.isColor) data.specular = this.specular.getHex();
        if (this.specularIntensity !== undefined) data.specularIntensity = this.specularIntensity;
        if (this.specularColor && this.specularColor.isColor) data.specularColor = this.specularColor.getHex();
        if (this.shininess !== undefined) data.shininess = this.shininess;
        if (this.clearcoat !== undefined) data.clearcoat = this.clearcoat;
        if (this.clearcoatRoughness !== undefined) data.clearcoatRoughness = this.clearcoatRoughness;
        if (this.clearcoatMap && this.clearcoatMap.isTexture) data.clearcoatMap = this.clearcoatMap.toJSON(meta).uuid;
        if (this.clearcoatRoughnessMap && this.clearcoatRoughnessMap.isTexture) data.clearcoatRoughnessMap = this.clearcoatRoughnessMap.toJSON(meta).uuid;
        if (this.clearcoatNormalMap && this.clearcoatNormalMap.isTexture) {
            data.clearcoatNormalMap = this.clearcoatNormalMap.toJSON(meta).uuid;
            data.clearcoatNormalScale = this.clearcoatNormalScale.toArray();
        }
        if (this.dispersion !== undefined) data.dispersion = this.dispersion;
        if (this.iridescence !== undefined) data.iridescence = this.iridescence;
        if (this.iridescenceIOR !== undefined) data.iridescenceIOR = this.iridescenceIOR;
        if (this.iridescenceThicknessRange !== undefined) data.iridescenceThicknessRange = this.iridescenceThicknessRange;
        if (this.iridescenceMap && this.iridescenceMap.isTexture) data.iridescenceMap = this.iridescenceMap.toJSON(meta).uuid;
        if (this.iridescenceThicknessMap && this.iridescenceThicknessMap.isTexture) data.iridescenceThicknessMap = this.iridescenceThicknessMap.toJSON(meta).uuid;
        if (this.anisotropy !== undefined) data.anisotropy = this.anisotropy;
        if (this.anisotropyRotation !== undefined) data.anisotropyRotation = this.anisotropyRotation;
        if (this.anisotropyMap && this.anisotropyMap.isTexture) data.anisotropyMap = this.anisotropyMap.toJSON(meta).uuid;
        if (this.map && this.map.isTexture) data.map = this.map.toJSON(meta).uuid;
        if (this.matcap && this.matcap.isTexture) data.matcap = this.matcap.toJSON(meta).uuid;
        if (this.alphaMap && this.alphaMap.isTexture) data.alphaMap = this.alphaMap.toJSON(meta).uuid;
        if (this.lightMap && this.lightMap.isTexture) {
            data.lightMap = this.lightMap.toJSON(meta).uuid;
            data.lightMapIntensity = this.lightMapIntensity;
        }
        if (this.aoMap && this.aoMap.isTexture) {
            data.aoMap = this.aoMap.toJSON(meta).uuid;
            data.aoMapIntensity = this.aoMapIntensity;
        }
        if (this.bumpMap && this.bumpMap.isTexture) {
            data.bumpMap = this.bumpMap.toJSON(meta).uuid;
            data.bumpScale = this.bumpScale;
        }
        if (this.normalMap && this.normalMap.isTexture) {
            data.normalMap = this.normalMap.toJSON(meta).uuid;
            data.normalMapType = this.normalMapType;
            data.normalScale = this.normalScale.toArray();
        }
        if (this.displacementMap && this.displacementMap.isTexture) {
            data.displacementMap = this.displacementMap.toJSON(meta).uuid;
            data.displacementScale = this.displacementScale;
            data.displacementBias = this.displacementBias;
        }
        if (this.roughnessMap && this.roughnessMap.isTexture) data.roughnessMap = this.roughnessMap.toJSON(meta).uuid;
        if (this.metalnessMap && this.metalnessMap.isTexture) data.metalnessMap = this.metalnessMap.toJSON(meta).uuid;
        if (this.emissiveMap && this.emissiveMap.isTexture) data.emissiveMap = this.emissiveMap.toJSON(meta).uuid;
        if (this.specularMap && this.specularMap.isTexture) data.specularMap = this.specularMap.toJSON(meta).uuid;
        if (this.specularIntensityMap && this.specularIntensityMap.isTexture) data.specularIntensityMap = this.specularIntensityMap.toJSON(meta).uuid;
        if (this.specularColorMap && this.specularColorMap.isTexture) data.specularColorMap = this.specularColorMap.toJSON(meta).uuid;
        if (this.envMap && this.envMap.isTexture) {
            data.envMap = this.envMap.toJSON(meta).uuid;
            if (this.combine !== undefined) data.combine = this.combine;
        }
        if (this.envMapRotation !== undefined) data.envMapRotation = this.envMapRotation.toArray();
        if (this.envMapIntensity !== undefined) data.envMapIntensity = this.envMapIntensity;
        if (this.reflectivity !== undefined) data.reflectivity = this.reflectivity;
        if (this.refractionRatio !== undefined) data.refractionRatio = this.refractionRatio;
        if (this.gradientMap && this.gradientMap.isTexture) data.gradientMap = this.gradientMap.toJSON(meta).uuid;
        if (this.transmission !== undefined) data.transmission = this.transmission;
        if (this.transmissionMap && this.transmissionMap.isTexture) data.transmissionMap = this.transmissionMap.toJSON(meta).uuid;
        if (this.thickness !== undefined) data.thickness = this.thickness;
        if (this.thicknessMap && this.thicknessMap.isTexture) data.thicknessMap = this.thicknessMap.toJSON(meta).uuid;
        if (this.attenuationDistance !== undefined && this.attenuationDistance !== Infinity) data.attenuationDistance = this.attenuationDistance;
        if (this.attenuationColor !== undefined) data.attenuationColor = this.attenuationColor.getHex();
        if (this.size !== undefined) data.size = this.size;
        if (this.shadowSide !== null) data.shadowSide = this.shadowSide;
        if (this.sizeAttenuation !== undefined) data.sizeAttenuation = this.sizeAttenuation;
        if (this.blending !== (0, $cb5ee595c0f892af$export$5b29a26d96ee6af0)) data.blending = this.blending;
        if (this.side !== (0, $cb5ee595c0f892af$export$2ede184fc2998901)) data.side = this.side;
        if (this.vertexColors === true) data.vertexColors = true;
        if (this.opacity < 1) data.opacity = this.opacity;
        if (this.transparent === true) data.transparent = true;
        if (this.blendSrc !== (0, $cb5ee595c0f892af$export$d5773124e86cf28c)) data.blendSrc = this.blendSrc;
        if (this.blendDst !== (0, $cb5ee595c0f892af$export$11d468cc7f19e971)) data.blendDst = this.blendDst;
        if (this.blendEquation !== (0, $cb5ee595c0f892af$export$20183a0484ce21a0)) data.blendEquation = this.blendEquation;
        if (this.blendSrcAlpha !== null) data.blendSrcAlpha = this.blendSrcAlpha;
        if (this.blendDstAlpha !== null) data.blendDstAlpha = this.blendDstAlpha;
        if (this.blendEquationAlpha !== null) data.blendEquationAlpha = this.blendEquationAlpha;
        if (this.blendColor && this.blendColor.isColor) data.blendColor = this.blendColor.getHex();
        if (this.blendAlpha !== 0) data.blendAlpha = this.blendAlpha;
        if (this.depthFunc !== (0, $cb5ee595c0f892af$export$296f78a0b892f81a)) data.depthFunc = this.depthFunc;
        if (this.depthTest === false) data.depthTest = this.depthTest;
        if (this.depthWrite === false) data.depthWrite = this.depthWrite;
        if (this.colorWrite === false) data.colorWrite = this.colorWrite;
        if (this.stencilWriteMask !== 0xff) data.stencilWriteMask = this.stencilWriteMask;
        if (this.stencilFunc !== (0, $cb5ee595c0f892af$export$14cf96713ddd97a8)) data.stencilFunc = this.stencilFunc;
        if (this.stencilRef !== 0) data.stencilRef = this.stencilRef;
        if (this.stencilFuncMask !== 0xff) data.stencilFuncMask = this.stencilFuncMask;
        if (this.stencilFail !== (0, $cb5ee595c0f892af$export$9f542ae4b5baca34)) data.stencilFail = this.stencilFail;
        if (this.stencilZFail !== (0, $cb5ee595c0f892af$export$9f542ae4b5baca34)) data.stencilZFail = this.stencilZFail;
        if (this.stencilZPass !== (0, $cb5ee595c0f892af$export$9f542ae4b5baca34)) data.stencilZPass = this.stencilZPass;
        if (this.stencilWrite === true) data.stencilWrite = this.stencilWrite;
        // rotation (SpriteMaterial)
        if (this.rotation !== undefined && this.rotation !== 0) data.rotation = this.rotation;
        if (this.polygonOffset === true) data.polygonOffset = true;
        if (this.polygonOffsetFactor !== 0) data.polygonOffsetFactor = this.polygonOffsetFactor;
        if (this.polygonOffsetUnits !== 0) data.polygonOffsetUnits = this.polygonOffsetUnits;
        if (this.linewidth !== undefined && this.linewidth !== 1) data.linewidth = this.linewidth;
        if (this.dashSize !== undefined) data.dashSize = this.dashSize;
        if (this.gapSize !== undefined) data.gapSize = this.gapSize;
        if (this.scale !== undefined) data.scale = this.scale;
        if (this.dithering === true) data.dithering = true;
        if (this.alphaTest > 0) data.alphaTest = this.alphaTest;
        if (this.alphaHash === true) data.alphaHash = true;
        if (this.alphaToCoverage === true) data.alphaToCoverage = true;
        if (this.premultipliedAlpha === true) data.premultipliedAlpha = true;
        if (this.forceSinglePass === true) data.forceSinglePass = true;
        if (this.wireframe === true) data.wireframe = true;
        if (this.wireframeLinewidth > 1) data.wireframeLinewidth = this.wireframeLinewidth;
        if (this.wireframeLinecap !== 'round') data.wireframeLinecap = this.wireframeLinecap;
        if (this.wireframeLinejoin !== 'round') data.wireframeLinejoin = this.wireframeLinejoin;
        if (this.flatShading === true) data.flatShading = true;
        if (this.visible === false) data.visible = false;
        if (this.toneMapped === false) data.toneMapped = false;
        if (this.fog === false) data.fog = false;
        if (Object.keys(this.userData).length > 0) data.userData = this.userData;
        // TODO: Copied from Object3D.toJSON
        function extractFromCache(cache) {
            const values = [];
            for(const key in cache){
                const data = cache[key];
                delete data.metadata;
                values.push(data);
            }
            return values;
        }
        if (isRootObject) {
            const textures = extractFromCache(meta.textures);
            const images = extractFromCache(meta.images);
            if (textures.length > 0) data.textures = textures;
            if (images.length > 0) data.images = images;
        }
        return data;
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(source) {
        this.name = source.name;
        this.blending = source.blending;
        this.side = source.side;
        this.vertexColors = source.vertexColors;
        this.opacity = source.opacity;
        this.transparent = source.transparent;
        this.blendSrc = source.blendSrc;
        this.blendDst = source.blendDst;
        this.blendEquation = source.blendEquation;
        this.blendSrcAlpha = source.blendSrcAlpha;
        this.blendDstAlpha = source.blendDstAlpha;
        this.blendEquationAlpha = source.blendEquationAlpha;
        this.blendColor.copy(source.blendColor);
        this.blendAlpha = source.blendAlpha;
        this.depthFunc = source.depthFunc;
        this.depthTest = source.depthTest;
        this.depthWrite = source.depthWrite;
        this.stencilWriteMask = source.stencilWriteMask;
        this.stencilFunc = source.stencilFunc;
        this.stencilRef = source.stencilRef;
        this.stencilFuncMask = source.stencilFuncMask;
        this.stencilFail = source.stencilFail;
        this.stencilZFail = source.stencilZFail;
        this.stencilZPass = source.stencilZPass;
        this.stencilWrite = source.stencilWrite;
        const srcPlanes = source.clippingPlanes;
        let dstPlanes = null;
        if (srcPlanes !== null) {
            const n = srcPlanes.length;
            dstPlanes = new Array(n);
            for(let i = 0; i !== n; ++i)dstPlanes[i] = srcPlanes[i].clone();
        }
        this.clippingPlanes = dstPlanes;
        this.clipIntersection = source.clipIntersection;
        this.clipShadows = source.clipShadows;
        this.shadowSide = source.shadowSide;
        this.colorWrite = source.colorWrite;
        this.precision = source.precision;
        this.polygonOffset = source.polygonOffset;
        this.polygonOffsetFactor = source.polygonOffsetFactor;
        this.polygonOffsetUnits = source.polygonOffsetUnits;
        this.dithering = source.dithering;
        this.alphaTest = source.alphaTest;
        this.alphaHash = source.alphaHash;
        this.alphaToCoverage = source.alphaToCoverage;
        this.premultipliedAlpha = source.premultipliedAlpha;
        this.forceSinglePass = source.forceSinglePass;
        this.visible = source.visible;
        this.toneMapped = source.toneMapped;
        this.userData = JSON.parse(JSON.stringify(source.userData));
        return this;
    }
    dispose() {
        this.dispatchEvent({
            type: 'dispose'
        });
    }
    set needsUpdate(value) {
        if (value === true) this.version++;
    }
    onBuild() {
        console.warn('Material: onBuild() has been removed.'); // @deprecated, r166
    }
}
















const $7fdcce0b853f9498$export$b2756a5d1c1a6e95 = /*@__PURE__*/ (0, $5eb92bf12e57daab$export$379455b567eff87d)(0).onReference(({ material: material })=>material).onRenderUpdate(({ material: material })=>material.refractionRatio);


const $855c8710a8c2f89f$export$62ed908d69a1edf1 = /*@__PURE__*/ (0, $acbec2070ba15851$export$80de5077965297a8).negate().reflect((0, $0ab44deffc8ae973$export$c58d63d09d102e3c));
const $855c8710a8c2f89f$export$ceb398aa5f585efc = /*@__PURE__*/ (0, $acbec2070ba15851$export$80de5077965297a8).negate().refract((0, $0ab44deffc8ae973$export$c58d63d09d102e3c), (0, $7fdcce0b853f9498$export$b2756a5d1c1a6e95));
const $855c8710a8c2f89f$export$ccfb4f831eb666bc = /*@__PURE__*/ $855c8710a8c2f89f$export$62ed908d69a1edf1.transformDirection((0, $aa7db78c76b9331c$export$6f7d94c027189d78)).toVar('reflectVector');
const $855c8710a8c2f89f$export$b17195e9df7a5b31 = /*@__PURE__*/ $855c8710a8c2f89f$export$ceb398aa5f585efc.transformDirection((0, $aa7db78c76b9331c$export$6f7d94c027189d78)).toVar('reflectVector');




class $48a97961b9b43631$var$CubeTextureNode extends (0, $f7d68bbf9ea772a7$export$2e2bcd8739ae039) {
    static get type() {
        return 'CubeTextureNode';
    }
    constructor(value, uvNode = null, levelNode = null, biasNode = null){
        super(value, uvNode, levelNode, biasNode);
        this.isCubeTextureNode = true;
    }
    getInputType() {
        return 'cubeTexture';
    }
    getDefaultUV() {
        const texture = this.value;
        if (texture.mapping === (0, $cb5ee595c0f892af$export$8759762a6477f2c4)) return 0, $855c8710a8c2f89f$export$ccfb4f831eb666bc;
        else if (texture.mapping === (0, $cb5ee595c0f892af$export$dc59f8aed047f61d)) return 0, $855c8710a8c2f89f$export$b17195e9df7a5b31;
        else {
            console.error('THREE.CubeTextureNode: Mapping "%s" not supported.', texture.mapping);
            return (0, $d5b7ee61758b2e81$export$9100789c9d999364)(0, 0, 0);
        }
    }
    setUpdateMatrix() {}
    setupUV(builder, uvNode) {
        const texture = this.value;
        if (builder.renderer.coordinateSystem === (0, $cb5ee595c0f892af$export$cc83beedcb9be9ac) || !texture.isRenderTargetTexture) return (0, $d5b7ee61758b2e81$export$9100789c9d999364)(uvNode.x.negate(), uvNode.yz);
        else return uvNode;
    }
    generateUV(builder, cubeUV) {
        return cubeUV.build(builder, 'vec3');
    }
}
var $48a97961b9b43631$export$2e2bcd8739ae039 = $48a97961b9b43631$var$CubeTextureNode;
const $48a97961b9b43631$export$f8948c996a1778e8 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$60d11c6747b7deba)($48a97961b9b43631$var$CubeTextureNode);




class $108a458e3a76f5dc$var$BufferNode extends (0, $5eb92bf12e57daab$export$2e2bcd8739ae039) {
    static get type() {
        return 'BufferNode';
    }
    constructor(value, bufferType, bufferCount = 0){
        super(value, bufferType);
        this.isBufferNode = true;
        this.bufferType = bufferType;
        this.bufferCount = bufferCount;
    }
    getElementType(builder) {
        return this.getNodeType(builder);
    }
    getInputType() {
        return 'buffer';
    }
}
var $108a458e3a76f5dc$export$2e2bcd8739ae039 = $108a458e3a76f5dc$var$BufferNode;
const $108a458e3a76f5dc$export$ab1029bcae9ddb4a = (value, type, count)=>(0, $d5b7ee61758b2e81$export$e97474e17004dd41)(new $108a458e3a76f5dc$var$BufferNode(value, type, count));








class $dc98837c0c62767d$var$UniformArrayElementNode extends (0, $e2cc991ce11e1c78$export$2e2bcd8739ae039) {
    static get type() {
        return 'UniformArrayElementNode';
    }
    constructor(arrayBuffer, indexNode){
        super(arrayBuffer, indexNode);
        this.isArrayBufferElementNode = true;
    }
    generate(builder) {
        const snippet = super.generate(builder);
        const type = this.getNodeType();
        return builder.format(snippet, 'vec4', type);
    }
}
class $dc98837c0c62767d$var$UniformArrayNode extends (0, $108a458e3a76f5dc$export$2e2bcd8739ae039) {
    static get type() {
        return 'UniformArrayNode';
    }
    constructor(value, elementType = null){
        super(null, 'vec4');
        this.array = value;
        this.elementType = elementType;
        this._elementType = null;
        this._elementLength = 0;
        this.updateType = (0, $ddcfecb7fbba5d74$export$26f7a8bbd9469530).RENDER;
        this.isArrayBufferNode = true;
    }
    getElementType() {
        return this.elementType || this._elementType;
    }
    getElementLength() {
        return this._elementLength;
    }
    update() {
        const { array: array, value: value } = this;
        const elementLength = this.getElementLength();
        const elementType = this.getElementType();
        if (elementLength === 1) for(let i = 0; i < array.length; i++){
            const index = i * 4;
            value[index] = array[i];
        }
        else if (elementType === 'color') for(let i = 0; i < array.length; i++){
            const index = i * 4;
            const vector = array[i];
            value[index] = vector.r;
            value[index + 1] = vector.g;
            value[index + 2] = vector.b || 0;
        //value[ index + 3 ] = vector.a || 0;
        }
        else for(let i = 0; i < array.length; i++){
            const index = i * 4;
            const vector = array[i];
            value[index] = vector.x;
            value[index + 1] = vector.y;
            value[index + 2] = vector.z || 0;
            value[index + 3] = vector.w || 0;
        }
    }
    setup(builder) {
        const length = this.array.length;
        this._elementType = this.elementType === null ? (0, $97d1d441621670a9$export$cc7ab17e03dab419)(this.array[0]) : this.elementType;
        this._elementLength = builder.getTypeLength(this._elementType);
        let arrayType = Float32Array;
        if (this._elementType.charAt(0) === 'i') arrayType = Int32Array;
        else if (this._elementType.charAt(0) === 'u') arrayType = Uint32Array;
        this.value = new arrayType(length * 4);
        this.bufferCount = length;
        this.bufferType = builder.changeComponentType('vec4', builder.getComponentType(this._elementType));
        return super.setup(builder);
    }
    element(indexNode) {
        return (0, $d5b7ee61758b2e81$export$e97474e17004dd41)(new $dc98837c0c62767d$var$UniformArrayElementNode(this, (0, $d5b7ee61758b2e81$export$e97474e17004dd41)(indexNode)));
    }
}
var $dc98837c0c62767d$export$2e2bcd8739ae039 = $dc98837c0c62767d$var$UniformArrayNode;
const $dc98837c0c62767d$export$9b734ab82c2f4fe3 = (values, nodeType)=>(0, $d5b7ee61758b2e81$export$e97474e17004dd41)(new $dc98837c0c62767d$var$UniformArrayNode(values, nodeType));
const $dc98837c0c62767d$export$dfbf0296e531b4e7 = (values, nodeType)=>{
    console.warn('TSL.UniformArrayNode: uniforms() has been renamed to uniformArray().');
    return (0, $d5b7ee61758b2e81$export$e97474e17004dd41)(new $dc98837c0c62767d$var$UniformArrayNode(values, nodeType));
};



class $7082d3a91c21cd99$var$ReferenceElementNode extends (0, $e2cc991ce11e1c78$export$2e2bcd8739ae039) {
    static get type() {
        return 'ReferenceElementNode';
    }
    constructor(referenceNode, indexNode){
        super(referenceNode, indexNode);
        this.referenceNode = referenceNode;
        this.isReferenceElementNode = true;
    }
    getNodeType() {
        return this.referenceNode.uniformType;
    }
    generate(builder) {
        const snippet = super.generate(builder);
        const arrayType = this.referenceNode.getNodeType();
        const elementType = this.getNodeType();
        return builder.format(snippet, arrayType, elementType);
    }
}
// TODO: Extends this from ReferenceBaseNode
class $7082d3a91c21cd99$var$ReferenceNode extends (0, $65e77d5c3a27a66a$export$2e2bcd8739ae039) {
    static get type() {
        return 'ReferenceNode';
    }
    constructor(property, uniformType, object = null, count = null){
        super();
        this.property = property;
        this.uniformType = uniformType;
        this.object = object;
        this.count = count;
        this.properties = property.split('.');
        this.reference = object;
        this.node = null;
        this.group = null;
        this.name = null;
        this.updateType = (0, $ddcfecb7fbba5d74$export$26f7a8bbd9469530).OBJECT;
    }
    element(indexNode) {
        return (0, $d5b7ee61758b2e81$export$e97474e17004dd41)(new $7082d3a91c21cd99$var$ReferenceElementNode(this, (0, $d5b7ee61758b2e81$export$e97474e17004dd41)(indexNode)));
    }
    setGroup(group) {
        this.group = group;
        return this;
    }
    label(name) {
        this.name = name;
        return this;
    }
    setNodeType(uniformType) {
        let node = null;
        if (this.count !== null) node = (0, $108a458e3a76f5dc$export$ab1029bcae9ddb4a)(null, uniformType, this.count);
        else if (Array.isArray(this.getValueFromReference())) node = (0, $dc98837c0c62767d$export$9b734ab82c2f4fe3)(null, uniformType);
        else if (uniformType === 'texture') node = (0, $f7d68bbf9ea772a7$export$ab69073b3903a075)(null);
        else if (uniformType === 'cubeTexture') node = (0, $48a97961b9b43631$export$f8948c996a1778e8)(null);
        else node = (0, $5eb92bf12e57daab$export$379455b567eff87d)(null, uniformType);
        if (this.group !== null) node.setGroup(this.group);
        if (this.name !== null) node.label(this.name);
        this.node = node.getSelf();
    }
    getNodeType(builder) {
        if (this.node === null) {
            this.updateReference(builder);
            this.updateValue();
        }
        return this.node.getNodeType(builder);
    }
    getValueFromReference(object = this.reference) {
        const { properties: properties } = this;
        let value = object[properties[0]];
        for(let i = 1; i < properties.length; i++)value = value[properties[i]];
        return value;
    }
    updateReference(state) {
        this.reference = this.object !== null ? this.object : state.object;
        return this.reference;
    }
    setup() {
        this.updateValue();
        return this.node;
    }
    update() {
        this.updateValue();
    }
    updateValue() {
        if (this.node === null) this.setNodeType(this.uniformType);
        const value = this.getValueFromReference();
        if (Array.isArray(value)) this.node.array = value;
        else this.node.value = value;
    }
}
var $7082d3a91c21cd99$export$2e2bcd8739ae039 = $7082d3a91c21cd99$var$ReferenceNode;
const $7082d3a91c21cd99$export$ca50aac9f3ba507f = (name, type, object)=>(0, $d5b7ee61758b2e81$export$e97474e17004dd41)(new $7082d3a91c21cd99$var$ReferenceNode(name, type, object));
const $7082d3a91c21cd99$export$18088e2a413e76c6 = (name, type, count, object)=>(0, $d5b7ee61758b2e81$export$e97474e17004dd41)(new $7082d3a91c21cd99$var$ReferenceNode(name, type, object, count));




class $148d94357f05ebae$var$MaterialReferenceNode extends (0, $7082d3a91c21cd99$export$2e2bcd8739ae039) {
    static get type() {
        return 'MaterialReferenceNode';
    }
    constructor(property, inputType, material = null){
        super(property, inputType, material);
        this.material = material;
        //this.updateType = NodeUpdateType.RENDER;
        this.isMaterialReferenceNode = true;
    }
    /*setNodeType( node ) {

		super.setNodeType( node );

		this.node.groupNode = renderGroup;

	}*/ updateReference(state) {
        this.reference = this.material !== null ? this.material : state.material;
        return this.reference;
    }
}
var $148d94357f05ebae$export$2e2bcd8739ae039 = $148d94357f05ebae$var$MaterialReferenceNode;
const $148d94357f05ebae$export$f503be583015cb4f = (name, type, material)=>(0, $d5b7ee61758b2e81$export$e97474e17004dd41)(new $148d94357f05ebae$var$MaterialReferenceNode(name, type, material));
















const $42c3b119e0c3e35a$export$ffefde522c47f278 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$b076717d71a1a47f)((builder)=>{
    if (builder.geometry.hasAttribute('tangent') === false) builder.geometry.computeTangents();
    return (0, $700a78a0d988d216$export$af4b9a83f4b00434)('tangent', 'vec4');
})();
const $42c3b119e0c3e35a$export$f53a7d05db86e284 = /*@__PURE__*/ $42c3b119e0c3e35a$export$ffefde522c47f278.xyz.toVar('tangentLocal');
const $42c3b119e0c3e35a$export$610e156c53541bb9 = /*@__PURE__*/ (0, $c03c6edd36966f29$export$57d0df277658535e).mul((0, $d5b7ee61758b2e81$export$6dba2a1f0d609415)($42c3b119e0c3e35a$export$f53a7d05db86e284, 0)).xyz.varying('v_tangentView').normalize().toVar('tangentView');
const $42c3b119e0c3e35a$export$58a1135040e57d7d = /*@__PURE__*/ $42c3b119e0c3e35a$export$610e156c53541bb9.transformDirection((0, $aa7db78c76b9331c$export$6f7d94c027189d78)).varying('v_tangentWorld').normalize().toVar('tangentWorld');
const $42c3b119e0c3e35a$export$c6b946ad70a6b9af = /*@__PURE__*/ $42c3b119e0c3e35a$export$610e156c53541bb9.toVar('transformedTangentView');
const $42c3b119e0c3e35a$export$6ac2381e11d518d7 = /*@__PURE__*/ $42c3b119e0c3e35a$export$c6b946ad70a6b9af.transformDirection((0, $aa7db78c76b9331c$export$6f7d94c027189d78)).normalize().toVar('transformedTangentWorld');


const $c5cf264c5349f09e$var$getBitangent = (crossNormalTangent)=>crossNormalTangent.mul((0, $42c3b119e0c3e35a$export$ffefde522c47f278).w).xyz;
const $c5cf264c5349f09e$export$11772476513377e9 = /*@__PURE__*/ (0, $c497538e811cb09b$export$3f47f02b8134ef8a)($c5cf264c5349f09e$var$getBitangent((0, $0ab44deffc8ae973$export$2d025416a9cb464f).cross((0, $42c3b119e0c3e35a$export$ffefde522c47f278))), 'v_bitangentGeometry').normalize().toVar('bitangentGeometry');
const $c5cf264c5349f09e$export$851992b7cb630fa = /*@__PURE__*/ (0, $c497538e811cb09b$export$3f47f02b8134ef8a)($c5cf264c5349f09e$var$getBitangent((0, $0ab44deffc8ae973$export$c94af1e24aa56d8f).cross((0, $42c3b119e0c3e35a$export$f53a7d05db86e284))), 'v_bitangentLocal').normalize().toVar('bitangentLocal');
const $c5cf264c5349f09e$export$d7aac59a4a8f24d4 = /*@__PURE__*/ (0, $c497538e811cb09b$export$3f47f02b8134ef8a)($c5cf264c5349f09e$var$getBitangent((0, $0ab44deffc8ae973$export$c7d7ec78bf3ab28a).cross((0, $42c3b119e0c3e35a$export$610e156c53541bb9))), 'v_bitangentView').normalize().toVar('bitangentView');
const $c5cf264c5349f09e$export$dbd309b70bea5ac6 = /*@__PURE__*/ (0, $c497538e811cb09b$export$3f47f02b8134ef8a)($c5cf264c5349f09e$var$getBitangent((0, $0ab44deffc8ae973$export$8cce2f8527757c54).cross((0, $42c3b119e0c3e35a$export$58a1135040e57d7d))), 'v_bitangentWorld').normalize().toVar('bitangentWorld');
const $c5cf264c5349f09e$export$38ca19aed25b489d = /*@__PURE__*/ $c5cf264c5349f09e$var$getBitangent((0, $0ab44deffc8ae973$export$c58d63d09d102e3c).cross((0, $42c3b119e0c3e35a$export$c6b946ad70a6b9af))).normalize().toVar('transformedBitangentView');
const $c5cf264c5349f09e$export$224a749e3d392247 = /*@__PURE__*/ $c5cf264c5349f09e$export$38ca19aed25b489d.transformDirection((0, $aa7db78c76b9331c$export$6f7d94c027189d78)).normalize().toVar('transformedBitangentWorld');








const $d0a60d4044396068$export$6b671943eab6b881 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$e43bd9f504e4ac00)((0, $42c3b119e0c3e35a$export$610e156c53541bb9), (0, $c5cf264c5349f09e$export$d7aac59a4a8f24d4), (0, $0ab44deffc8ae973$export$c7d7ec78bf3ab28a));
const $d0a60d4044396068$export$9512f0b14d82ed8f = /*@__PURE__*/ (0, $acbec2070ba15851$export$80de5077965297a8).mul($d0a60d4044396068$export$6b671943eab6b881) /*.normalize()*/ ;
const $d0a60d4044396068$export$a2debdc580a4d165 = (uv, scale)=>uv.sub($d0a60d4044396068$export$9512f0b14d82ed8f.mul(scale));
const $d0a60d4044396068$export$72a051174b4709cb = /*@__PURE__*/ (()=>{
    // https://google.github.io/filament/Filament.md.html#lighting/imagebasedlights/anisotropy
    let bentNormal = (0, $dd761eb0c8b88ca7$export$5748f3030096f448).cross((0, $acbec2070ba15851$export$80de5077965297a8));
    bentNormal = bentNormal.cross((0, $dd761eb0c8b88ca7$export$5748f3030096f448)).normalize();
    bentNormal = (0, $f37ae0e58866c183$export$2c9e8a9632a706b2)(bentNormal, (0, $0ab44deffc8ae973$export$c58d63d09d102e3c), (0, $dd761eb0c8b88ca7$export$13e470198a4f720a).mul((0, $dd761eb0c8b88ca7$export$df3004878062a594).oneMinus()).oneMinus().pow2().pow2()).normalize();
    return bentNormal;
})();






// Normal Mapping Without Precomputed Tangents
// http://www.thetenthplanet.de/archives/1180
const $807f2e66536cb23b$var$perturbNormal2Arb = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$b076717d71a1a47f)((inputs)=>{
    const { eye_pos: eye_pos, surf_norm: surf_norm, mapN: mapN, uv: uv } = inputs;
    const q0 = eye_pos.dFdx();
    const q1 = eye_pos.dFdy();
    const st0 = uv.dFdx();
    const st1 = uv.dFdy();
    const N = surf_norm; // normalized
    const q1perp = q1.cross(N);
    const q0perp = N.cross(q0);
    const T = q1perp.mul(st0.x).add(q0perp.mul(st1.x));
    const B = q1perp.mul(st0.y).add(q0perp.mul(st1.y));
    const det = T.dot(T).max(B.dot(B));
    const scale = (0, $f8c552c0fa23c18b$export$c2922972355d19f8).mul(det.inverseSqrt());
    return (0, $3f1f23fea79ae256$export$e16d8520af44a096)(T.mul(mapN.x, scale), B.mul(mapN.y, scale), N.mul(mapN.z)).normalize();
});
class $807f2e66536cb23b$var$NormalMapNode extends (0, $75c45ed2361c955f$export$2e2bcd8739ae039) {
    static get type() {
        return 'NormalMapNode';
    }
    constructor(node, scaleNode = null){
        super('vec3');
        this.node = node;
        this.scaleNode = scaleNode;
        this.normalMapType = (0, $cb5ee595c0f892af$export$2852a58ebdac27b8);
    }
    setup(builder) {
        const { normalMapType: normalMapType, scaleNode: scaleNode } = this;
        let normalMap = this.node.mul(2.0).sub(1.0);
        if (scaleNode !== null) normalMap = (0, $d5b7ee61758b2e81$export$9100789c9d999364)(normalMap.xy.mul(scaleNode), normalMap.z);
        let outputNode = null;
        if (normalMapType === (0, $cb5ee595c0f892af$export$9990ad26f9db5b2c)) outputNode = (0, $0ab44deffc8ae973$export$fd2a205e2f09a6e0)(normalMap);
        else if (normalMapType === (0, $cb5ee595c0f892af$export$2852a58ebdac27b8)) {
            const tangent = builder.hasGeometryAttribute('tangent');
            if (tangent === true) outputNode = (0, $d0a60d4044396068$export$6b671943eab6b881).mul(normalMap).normalize();
            else outputNode = $807f2e66536cb23b$var$perturbNormal2Arb({
                eye_pos: (0, $acbec2070ba15851$export$3dfd735ebeac9bfd),
                surf_norm: (0, $0ab44deffc8ae973$export$c7d7ec78bf3ab28a),
                mapN: normalMap,
                uv: (0, $382a32bd765f3827$export$c774ebbac59e31d3)()
            });
        }
        return outputNode;
    }
}
var $807f2e66536cb23b$export$2e2bcd8739ae039 = $807f2e66536cb23b$var$NormalMapNode;
const $807f2e66536cb23b$export$7eb074e5fa623050 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$60d11c6747b7deba)($807f2e66536cb23b$var$NormalMapNode);








// Bump Mapping Unparametrized Surfaces on the GPU by Morten S. Mikkelsen
// https://mmikk.github.io/papers3d/mm_sfgrad_bump.pdf
const $ee8e2ebb59423551$var$dHdxy_fwd = (0, $d5b7ee61758b2e81$export$b076717d71a1a47f)(({ textureNode: textureNode, bumpScale: bumpScale })=>{
    // It's used to preserve the same TextureNode instance
    const sampleTexture = (callback)=>textureNode.cache().context({
            getUV: (texNode)=>callback(texNode.uvNode || (0, $382a32bd765f3827$export$c774ebbac59e31d3)()),
            forceUVContext: true
        });
    const Hll = (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(sampleTexture((uvNode)=>uvNode));
    return (0, $d5b7ee61758b2e81$export$e9830bc863290a54)((0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(sampleTexture((uvNode)=>uvNode.add(uvNode.dFdx()))).sub(Hll), (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(sampleTexture((uvNode)=>uvNode.add(uvNode.dFdy()))).sub(Hll)).mul(bumpScale);
});
// Evaluate the derivative of the height w.r.t. screen-space using forward differencing (listing 2)
const $ee8e2ebb59423551$var$perturbNormalArb = (0, $d5b7ee61758b2e81$export$b076717d71a1a47f)((inputs)=>{
    const { surf_pos: surf_pos, surf_norm: surf_norm, dHdxy: dHdxy } = inputs;
    // normalize is done to ensure that the bump map looks the same regardless of the texture's scale
    const vSigmaX = surf_pos.dFdx().normalize();
    const vSigmaY = surf_pos.dFdy().normalize();
    const vN = surf_norm; // normalized
    const R1 = vSigmaY.cross(vN);
    const R2 = vN.cross(vSigmaX);
    const fDet = vSigmaX.dot(R1).mul((0, $f8c552c0fa23c18b$export$c2922972355d19f8));
    const vGrad = fDet.sign().mul(dHdxy.x.mul(R1).add(dHdxy.y.mul(R2)));
    return fDet.abs().mul(surf_norm).sub(vGrad).normalize();
});
class $ee8e2ebb59423551$var$BumpMapNode extends (0, $75c45ed2361c955f$export$2e2bcd8739ae039) {
    static get type() {
        return 'BumpMapNode';
    }
    constructor(textureNode, scaleNode = null){
        super('vec3');
        this.textureNode = textureNode;
        this.scaleNode = scaleNode;
    }
    setup() {
        const bumpScale = this.scaleNode !== null ? this.scaleNode : 1;
        const dHdxy = $ee8e2ebb59423551$var$dHdxy_fwd({
            textureNode: this.textureNode,
            bumpScale: bumpScale
        });
        return $ee8e2ebb59423551$var$perturbNormalArb({
            surf_pos: (0, $acbec2070ba15851$export$3dfd735ebeac9bfd),
            surf_norm: (0, $0ab44deffc8ae973$export$c7d7ec78bf3ab28a),
            dHdxy: dHdxy
        });
    }
}
var $ee8e2ebb59423551$export$2e2bcd8739ae039 = $ee8e2ebb59423551$var$BumpMapNode;
const $ee8e2ebb59423551$export$f698f3a86d4e368b = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$60d11c6747b7deba)($ee8e2ebb59423551$var$BumpMapNode);



const $8e4701fdb55563f1$var$_propertyCache = new Map();
class $8e4701fdb55563f1$var$MaterialNode extends (0, $65e77d5c3a27a66a$export$2e2bcd8739ae039) {
    static get type() {
        return 'MaterialNode';
    }
    constructor(scope){
        super();
        this.scope = scope;
    }
    getCache(property, type) {
        let node = $8e4701fdb55563f1$var$_propertyCache.get(property);
        if (node === undefined) {
            node = (0, $148d94357f05ebae$export$f503be583015cb4f)(property, type);
            $8e4701fdb55563f1$var$_propertyCache.set(property, node);
        }
        return node;
    }
    getFloat(property) {
        return this.getCache(property, 'float');
    }
    getColor(property) {
        return this.getCache(property, 'color');
    }
    getTexture(property) {
        return this.getCache(property === 'map' ? 'map' : property + 'Map', 'texture');
    }
    setup(builder) {
        const material = builder.context.material;
        const scope = this.scope;
        let node = null;
        if (scope === $8e4701fdb55563f1$var$MaterialNode.COLOR) {
            const colorNode = material.color !== undefined ? this.getColor(scope) : (0, $d5b7ee61758b2e81$export$9100789c9d999364)();
            if (material.map && material.map.isTexture === true) node = colorNode.mul(this.getTexture('map'));
            else node = colorNode;
        } else if (scope === $8e4701fdb55563f1$var$MaterialNode.OPACITY) {
            const opacityNode = this.getFloat(scope);
            if (material.alphaMap && material.alphaMap.isTexture === true) node = opacityNode.mul(this.getTexture('alpha'));
            else node = opacityNode;
        } else if (scope === $8e4701fdb55563f1$var$MaterialNode.SPECULAR_STRENGTH) {
            if (material.specularMap && material.specularMap.isTexture === true) node = this.getTexture('specular').r;
            else node = (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(1);
        } else if (scope === $8e4701fdb55563f1$var$MaterialNode.SPECULAR_INTENSITY) {
            const specularIntensity = this.getFloat(scope);
            if (material.specularMap) node = specularIntensity.mul(this.getTexture(scope).a);
            else node = specularIntensity;
        } else if (scope === $8e4701fdb55563f1$var$MaterialNode.SPECULAR_COLOR) {
            const specularColorNode = this.getColor(scope);
            if (material.specularColorMap && material.specularColorMap.isTexture === true) node = specularColorNode.mul(this.getTexture(scope).rgb);
            else node = specularColorNode;
        } else if (scope === $8e4701fdb55563f1$var$MaterialNode.ROUGHNESS) {
            const roughnessNode = this.getFloat(scope);
            if (material.roughnessMap && material.roughnessMap.isTexture === true) node = roughnessNode.mul(this.getTexture(scope).g);
            else node = roughnessNode;
        } else if (scope === $8e4701fdb55563f1$var$MaterialNode.METALNESS) {
            const metalnessNode = this.getFloat(scope);
            if (material.metalnessMap && material.metalnessMap.isTexture === true) node = metalnessNode.mul(this.getTexture(scope).b);
            else node = metalnessNode;
        } else if (scope === $8e4701fdb55563f1$var$MaterialNode.EMISSIVE) {
            const emissiveIntensityNode = this.getFloat('emissiveIntensity');
            const emissiveNode = this.getColor(scope).mul(emissiveIntensityNode);
            if (material.emissiveMap && material.emissiveMap.isTexture === true) node = emissiveNode.mul(this.getTexture(scope));
            else node = emissiveNode;
        } else if (scope === $8e4701fdb55563f1$var$MaterialNode.NORMAL) {
            if (material.normalMap) {
                node = (0, $807f2e66536cb23b$export$7eb074e5fa623050)(this.getTexture('normal'), this.getCache('normalScale', 'vec2'));
                node.normalMapType = material.normalMapType;
            } else if (material.bumpMap) node = (0, $ee8e2ebb59423551$export$f698f3a86d4e368b)(this.getTexture('bump').r, this.getFloat('bumpScale'));
            else node = (0, $0ab44deffc8ae973$export$c7d7ec78bf3ab28a);
        } else if (scope === $8e4701fdb55563f1$var$MaterialNode.CLEARCOAT) {
            const clearcoatNode = this.getFloat(scope);
            if (material.clearcoatMap && material.clearcoatMap.isTexture === true) node = clearcoatNode.mul(this.getTexture(scope).r);
            else node = clearcoatNode;
        } else if (scope === $8e4701fdb55563f1$var$MaterialNode.CLEARCOAT_ROUGHNESS) {
            const clearcoatRoughnessNode = this.getFloat(scope);
            if (material.clearcoatRoughnessMap && material.clearcoatRoughnessMap.isTexture === true) node = clearcoatRoughnessNode.mul(this.getTexture(scope).r);
            else node = clearcoatRoughnessNode;
        } else if (scope === $8e4701fdb55563f1$var$MaterialNode.CLEARCOAT_NORMAL) {
            if (material.clearcoatNormalMap) node = (0, $807f2e66536cb23b$export$7eb074e5fa623050)(this.getTexture(scope), this.getCache(scope + 'Scale', 'vec2'));
            else node = (0, $0ab44deffc8ae973$export$c7d7ec78bf3ab28a);
        } else if (scope === $8e4701fdb55563f1$var$MaterialNode.SHEEN) {
            const sheenNode = this.getColor('sheenColor').mul(this.getFloat('sheen')); // Move this mul() to CPU
            if (material.sheenColorMap && material.sheenColorMap.isTexture === true) node = sheenNode.mul(this.getTexture('sheenColor').rgb);
            else node = sheenNode;
        } else if (scope === $8e4701fdb55563f1$var$MaterialNode.SHEEN_ROUGHNESS) {
            const sheenRoughnessNode = this.getFloat(scope);
            if (material.sheenRoughnessMap && material.sheenRoughnessMap.isTexture === true) node = sheenRoughnessNode.mul(this.getTexture(scope).a);
            else node = sheenRoughnessNode;
            node = node.clamp(0.07, 1.0);
        } else if (scope === $8e4701fdb55563f1$var$MaterialNode.ANISOTROPY) {
            if (material.anisotropyMap && material.anisotropyMap.isTexture === true) {
                const anisotropyPolar = this.getTexture(scope);
                const anisotropyMat = (0, $d5b7ee61758b2e81$export$f7543b5409a93c6b)($8e4701fdb55563f1$export$d09d625f68baf579.x, $8e4701fdb55563f1$export$d09d625f68baf579.y, $8e4701fdb55563f1$export$d09d625f68baf579.y.negate(), $8e4701fdb55563f1$export$d09d625f68baf579.x);
                node = anisotropyMat.mul(anisotropyPolar.rg.mul(2.0).sub((0, $d5b7ee61758b2e81$export$e9830bc863290a54)(1.0)).normalize().mul(anisotropyPolar.b));
            } else node = $8e4701fdb55563f1$export$d09d625f68baf579;
        } else if (scope === $8e4701fdb55563f1$var$MaterialNode.IRIDESCENCE_THICKNESS) {
            const iridescenceThicknessMaximum = (0, $7082d3a91c21cd99$export$ca50aac9f3ba507f)('1', 'float', material.iridescenceThicknessRange);
            if (material.iridescenceThicknessMap) {
                const iridescenceThicknessMinimum = (0, $7082d3a91c21cd99$export$ca50aac9f3ba507f)('0', 'float', material.iridescenceThicknessRange);
                node = iridescenceThicknessMaximum.sub(iridescenceThicknessMinimum).mul(this.getTexture(scope).g).add(iridescenceThicknessMinimum);
            } else node = iridescenceThicknessMaximum;
        } else if (scope === $8e4701fdb55563f1$var$MaterialNode.TRANSMISSION) {
            const transmissionNode = this.getFloat(scope);
            if (material.transmissionMap) node = transmissionNode.mul(this.getTexture(scope).r);
            else node = transmissionNode;
        } else if (scope === $8e4701fdb55563f1$var$MaterialNode.THICKNESS) {
            const thicknessNode = this.getFloat(scope);
            if (material.thicknessMap) node = thicknessNode.mul(this.getTexture(scope).g);
            else node = thicknessNode;
        } else if (scope === $8e4701fdb55563f1$var$MaterialNode.IOR) node = this.getFloat(scope);
        else if (scope === $8e4701fdb55563f1$var$MaterialNode.LIGHT_MAP) node = this.getTexture(scope).rgb.mul(this.getFloat('lightMapIntensity'));
        else if (scope === $8e4701fdb55563f1$var$MaterialNode.AO_MAP) node = this.getTexture(scope).r.sub(1.0).mul(this.getFloat('aoMapIntensity')).add(1.0);
        else {
            const outputType = this.getNodeType(builder);
            node = this.getCache(scope, outputType);
        }
        return node;
    }
}
$8e4701fdb55563f1$var$MaterialNode.ALPHA_TEST = 'alphaTest';
$8e4701fdb55563f1$var$MaterialNode.COLOR = 'color';
$8e4701fdb55563f1$var$MaterialNode.OPACITY = 'opacity';
$8e4701fdb55563f1$var$MaterialNode.SHININESS = 'shininess';
$8e4701fdb55563f1$var$MaterialNode.SPECULAR = 'specular';
$8e4701fdb55563f1$var$MaterialNode.SPECULAR_STRENGTH = 'specularStrength';
$8e4701fdb55563f1$var$MaterialNode.SPECULAR_INTENSITY = 'specularIntensity';
$8e4701fdb55563f1$var$MaterialNode.SPECULAR_COLOR = 'specularColor';
$8e4701fdb55563f1$var$MaterialNode.REFLECTIVITY = 'reflectivity';
$8e4701fdb55563f1$var$MaterialNode.ROUGHNESS = 'roughness';
$8e4701fdb55563f1$var$MaterialNode.METALNESS = 'metalness';
$8e4701fdb55563f1$var$MaterialNode.NORMAL = 'normal';
$8e4701fdb55563f1$var$MaterialNode.CLEARCOAT = 'clearcoat';
$8e4701fdb55563f1$var$MaterialNode.CLEARCOAT_ROUGHNESS = 'clearcoatRoughness';
$8e4701fdb55563f1$var$MaterialNode.CLEARCOAT_NORMAL = 'clearcoatNormal';
$8e4701fdb55563f1$var$MaterialNode.EMISSIVE = 'emissive';
$8e4701fdb55563f1$var$MaterialNode.ROTATION = 'rotation';
$8e4701fdb55563f1$var$MaterialNode.SHEEN = 'sheen';
$8e4701fdb55563f1$var$MaterialNode.SHEEN_ROUGHNESS = 'sheenRoughness';
$8e4701fdb55563f1$var$MaterialNode.ANISOTROPY = 'anisotropy';
$8e4701fdb55563f1$var$MaterialNode.IRIDESCENCE = 'iridescence';
$8e4701fdb55563f1$var$MaterialNode.IRIDESCENCE_IOR = 'iridescenceIOR';
$8e4701fdb55563f1$var$MaterialNode.IRIDESCENCE_THICKNESS = 'iridescenceThickness';
$8e4701fdb55563f1$var$MaterialNode.IOR = 'ior';
$8e4701fdb55563f1$var$MaterialNode.TRANSMISSION = 'transmission';
$8e4701fdb55563f1$var$MaterialNode.THICKNESS = 'thickness';
$8e4701fdb55563f1$var$MaterialNode.ATTENUATION_DISTANCE = 'attenuationDistance';
$8e4701fdb55563f1$var$MaterialNode.ATTENUATION_COLOR = 'attenuationColor';
$8e4701fdb55563f1$var$MaterialNode.LINE_SCALE = 'scale';
$8e4701fdb55563f1$var$MaterialNode.LINE_DASH_SIZE = 'dashSize';
$8e4701fdb55563f1$var$MaterialNode.LINE_GAP_SIZE = 'gapSize';
$8e4701fdb55563f1$var$MaterialNode.LINE_WIDTH = 'linewidth';
$8e4701fdb55563f1$var$MaterialNode.LINE_DASH_OFFSET = 'dashOffset';
$8e4701fdb55563f1$var$MaterialNode.POINT_WIDTH = 'pointWidth';
$8e4701fdb55563f1$var$MaterialNode.DISPERSION = 'dispersion';
$8e4701fdb55563f1$var$MaterialNode.LIGHT_MAP = 'light';
$8e4701fdb55563f1$var$MaterialNode.AO_MAP = 'ao';
var $8e4701fdb55563f1$export$2e2bcd8739ae039 = $8e4701fdb55563f1$var$MaterialNode;
const $8e4701fdb55563f1$export$3030330267c62589 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$25c7ddd7ae9b45f3)($8e4701fdb55563f1$var$MaterialNode, $8e4701fdb55563f1$var$MaterialNode.ALPHA_TEST);
const $8e4701fdb55563f1$export$852ee2194711a41a = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$25c7ddd7ae9b45f3)($8e4701fdb55563f1$var$MaterialNode, $8e4701fdb55563f1$var$MaterialNode.COLOR);
const $8e4701fdb55563f1$export$e3d16a46fd4e0183 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$25c7ddd7ae9b45f3)($8e4701fdb55563f1$var$MaterialNode, $8e4701fdb55563f1$var$MaterialNode.SHININESS);
const $8e4701fdb55563f1$export$7935949e0cf72a01 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$25c7ddd7ae9b45f3)($8e4701fdb55563f1$var$MaterialNode, $8e4701fdb55563f1$var$MaterialNode.EMISSIVE);
const $8e4701fdb55563f1$export$a61065844a540229 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$25c7ddd7ae9b45f3)($8e4701fdb55563f1$var$MaterialNode, $8e4701fdb55563f1$var$MaterialNode.OPACITY);
const $8e4701fdb55563f1$export$1e2bd0cb74f57b97 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$25c7ddd7ae9b45f3)($8e4701fdb55563f1$var$MaterialNode, $8e4701fdb55563f1$var$MaterialNode.SPECULAR);
const $8e4701fdb55563f1$export$36b44793527d6347 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$25c7ddd7ae9b45f3)($8e4701fdb55563f1$var$MaterialNode, $8e4701fdb55563f1$var$MaterialNode.SPECULAR_INTENSITY);
const $8e4701fdb55563f1$export$5447cf3a560d2eed = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$25c7ddd7ae9b45f3)($8e4701fdb55563f1$var$MaterialNode, $8e4701fdb55563f1$var$MaterialNode.SPECULAR_COLOR);
const $8e4701fdb55563f1$export$aab42c7f7fd50fe = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$25c7ddd7ae9b45f3)($8e4701fdb55563f1$var$MaterialNode, $8e4701fdb55563f1$var$MaterialNode.SPECULAR_STRENGTH);
const $8e4701fdb55563f1$export$9ead911ab638ab9e = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$25c7ddd7ae9b45f3)($8e4701fdb55563f1$var$MaterialNode, $8e4701fdb55563f1$var$MaterialNode.REFLECTIVITY);
const $8e4701fdb55563f1$export$c372ad2642cfd701 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$25c7ddd7ae9b45f3)($8e4701fdb55563f1$var$MaterialNode, $8e4701fdb55563f1$var$MaterialNode.ROUGHNESS);
const $8e4701fdb55563f1$export$ed4ec59eb9c0ad6c = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$25c7ddd7ae9b45f3)($8e4701fdb55563f1$var$MaterialNode, $8e4701fdb55563f1$var$MaterialNode.METALNESS);
const $8e4701fdb55563f1$export$c30da46075fba8bb = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$25c7ddd7ae9b45f3)($8e4701fdb55563f1$var$MaterialNode, $8e4701fdb55563f1$var$MaterialNode.NORMAL).context({
    getUV: null
});
const $8e4701fdb55563f1$export$bcb4b1fc59604158 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$25c7ddd7ae9b45f3)($8e4701fdb55563f1$var$MaterialNode, $8e4701fdb55563f1$var$MaterialNode.CLEARCOAT);
const $8e4701fdb55563f1$export$1deee7039751e39b = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$25c7ddd7ae9b45f3)($8e4701fdb55563f1$var$MaterialNode, $8e4701fdb55563f1$var$MaterialNode.CLEARCOAT_ROUGHNESS);
const $8e4701fdb55563f1$export$1e8c99bce15509ea = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$25c7ddd7ae9b45f3)($8e4701fdb55563f1$var$MaterialNode, $8e4701fdb55563f1$var$MaterialNode.CLEARCOAT_NORMAL).context({
    getUV: null
});
const $8e4701fdb55563f1$export$22a360a238f20723 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$25c7ddd7ae9b45f3)($8e4701fdb55563f1$var$MaterialNode, $8e4701fdb55563f1$var$MaterialNode.ROTATION);
const $8e4701fdb55563f1$export$ca8d8f9bb84c2b06 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$25c7ddd7ae9b45f3)($8e4701fdb55563f1$var$MaterialNode, $8e4701fdb55563f1$var$MaterialNode.SHEEN);
const $8e4701fdb55563f1$export$c53217b49af64201 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$25c7ddd7ae9b45f3)($8e4701fdb55563f1$var$MaterialNode, $8e4701fdb55563f1$var$MaterialNode.SHEEN_ROUGHNESS);
const $8e4701fdb55563f1$export$415abbd8a1393676 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$25c7ddd7ae9b45f3)($8e4701fdb55563f1$var$MaterialNode, $8e4701fdb55563f1$var$MaterialNode.ANISOTROPY);
const $8e4701fdb55563f1$export$2991d95653bddf71 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$25c7ddd7ae9b45f3)($8e4701fdb55563f1$var$MaterialNode, $8e4701fdb55563f1$var$MaterialNode.IRIDESCENCE);
const $8e4701fdb55563f1$export$4d5a92c4b0801e42 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$25c7ddd7ae9b45f3)($8e4701fdb55563f1$var$MaterialNode, $8e4701fdb55563f1$var$MaterialNode.IRIDESCENCE_IOR);
const $8e4701fdb55563f1$export$edac0c112e716da0 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$25c7ddd7ae9b45f3)($8e4701fdb55563f1$var$MaterialNode, $8e4701fdb55563f1$var$MaterialNode.IRIDESCENCE_THICKNESS);
const $8e4701fdb55563f1$export$7a411e4bff144ff0 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$25c7ddd7ae9b45f3)($8e4701fdb55563f1$var$MaterialNode, $8e4701fdb55563f1$var$MaterialNode.TRANSMISSION);
const $8e4701fdb55563f1$export$be136e21cc092e66 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$25c7ddd7ae9b45f3)($8e4701fdb55563f1$var$MaterialNode, $8e4701fdb55563f1$var$MaterialNode.THICKNESS);
const $8e4701fdb55563f1$export$d40ae3ddf6fd407f = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$25c7ddd7ae9b45f3)($8e4701fdb55563f1$var$MaterialNode, $8e4701fdb55563f1$var$MaterialNode.IOR);
const $8e4701fdb55563f1$export$87501a08ff35a5d0 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$25c7ddd7ae9b45f3)($8e4701fdb55563f1$var$MaterialNode, $8e4701fdb55563f1$var$MaterialNode.ATTENUATION_DISTANCE);
const $8e4701fdb55563f1$export$ad54381cfb1f8a9c = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$25c7ddd7ae9b45f3)($8e4701fdb55563f1$var$MaterialNode, $8e4701fdb55563f1$var$MaterialNode.ATTENUATION_COLOR);
const $8e4701fdb55563f1$export$505058bbaa0ad019 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$25c7ddd7ae9b45f3)($8e4701fdb55563f1$var$MaterialNode, $8e4701fdb55563f1$var$MaterialNode.LINE_SCALE);
const $8e4701fdb55563f1$export$200b8bf19a7aecc9 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$25c7ddd7ae9b45f3)($8e4701fdb55563f1$var$MaterialNode, $8e4701fdb55563f1$var$MaterialNode.LINE_DASH_SIZE);
const $8e4701fdb55563f1$export$3154261658c8ee4b = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$25c7ddd7ae9b45f3)($8e4701fdb55563f1$var$MaterialNode, $8e4701fdb55563f1$var$MaterialNode.LINE_GAP_SIZE);
const $8e4701fdb55563f1$export$dc06cf49d582ad47 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$25c7ddd7ae9b45f3)($8e4701fdb55563f1$var$MaterialNode, $8e4701fdb55563f1$var$MaterialNode.LINE_WIDTH);
const $8e4701fdb55563f1$export$194200c8fa44fbfb = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$25c7ddd7ae9b45f3)($8e4701fdb55563f1$var$MaterialNode, $8e4701fdb55563f1$var$MaterialNode.LINE_DASH_OFFSET);
const $8e4701fdb55563f1$export$fadc4e3375c15b33 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$25c7ddd7ae9b45f3)($8e4701fdb55563f1$var$MaterialNode, $8e4701fdb55563f1$var$MaterialNode.POINT_WIDTH);
const $8e4701fdb55563f1$export$e9b48f5b27265c30 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$25c7ddd7ae9b45f3)($8e4701fdb55563f1$var$MaterialNode, $8e4701fdb55563f1$var$MaterialNode.DISPERSION);
const $8e4701fdb55563f1$export$4d5913e0c9a9ccca = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$25c7ddd7ae9b45f3)($8e4701fdb55563f1$var$MaterialNode, $8e4701fdb55563f1$var$MaterialNode.LIGHT_MAP);
const $8e4701fdb55563f1$export$4a45f71f148b256 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$25c7ddd7ae9b45f3)($8e4701fdb55563f1$var$MaterialNode, $8e4701fdb55563f1$var$MaterialNode.AO_MAP);
const $8e4701fdb55563f1$export$d09d625f68baf579 = /*@__PURE__*/ (0, $5eb92bf12e57daab$export$379455b567eff87d)(new (0, $3c03061dea0adea3$export$c977b3e384af9ae1)()).onReference(function(frame) {
    return frame.material;
}).onRenderUpdate(function({ material: material }) {
    this.value.set(material.anisotropy * Math.cos(material.anisotropyRotation), material.anisotropy * Math.sin(material.anisotropyRotation));
});







class $ae567e19e549d56f$var$ModelViewProjectionNode extends (0, $75c45ed2361c955f$export$2e2bcd8739ae039) {
    static get type() {
        return 'ModelViewProjectionNode';
    }
    constructor(positionNode = null){
        super('vec4');
        this.positionNode = positionNode;
    }
    setup(builder) {
        if (builder.shaderStage === 'fragment') return (0, $c497538e811cb09b$export$3f47f02b8134ef8a)(builder.context.mvp);
        const position = this.positionNode || (0, $acbec2070ba15851$export$78cc3a7ea225109f);
        const viewMatrix = builder.renderer.nodes.modelViewMatrix || (0, $c03c6edd36966f29$export$57d0df277658535e);
        return (0, $aa7db78c76b9331c$export$dc8d743682f60b2d).mul(viewMatrix).mul(position);
    }
}
var $ae567e19e549d56f$export$2e2bcd8739ae039 = $ae567e19e549d56f$var$ModelViewProjectionNode;
const $ae567e19e549d56f$export$64e914589db9c49e = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$60d11c6747b7deba)($ae567e19e549d56f$var$ModelViewProjectionNode);













class $70910a96e25c32ff$export$25ec0e1af1389358 extends (0, $47ee85f41ba63d35$export$3d5cd879f108f53f) {
    constructor(array, stride, meshPerAttribute = 1){
        super(array, stride);
        this.isInstancedInterleavedBuffer = true;
        this.meshPerAttribute = meshPerAttribute;
    }
    copy(source) {
        super.copy(source);
        this.meshPerAttribute = source.meshPerAttribute;
        return this;
    }
    clone(data) {
        const ib = super.clone(data);
        ib.meshPerAttribute = this.meshPerAttribute;
        return ib;
    }
    toJSON(data) {
        const json = super.toJSON(data);
        json.isInstancedInterleavedBuffer = true;
        json.meshPerAttribute = this.meshPerAttribute;
        return json;
    }
}



class $3167f16f113afb58$export$32ea87a8b54d744a extends (0, $4b03383e684869fb$export$8dea267bd6bde117) {
    constructor(array, itemSize, normalized, meshPerAttribute = 1){
        super(array, itemSize, normalized);
        this.isInstancedBufferAttribute = true;
        this.meshPerAttribute = meshPerAttribute;
    }
    copy(source) {
        super.copy(source);
        this.meshPerAttribute = source.meshPerAttribute;
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.meshPerAttribute = this.meshPerAttribute;
        data.isInstancedBufferAttribute = true;
        return data;
    }
}



class $7afa8da80fda451d$var$InstanceNode extends (0, $65e77d5c3a27a66a$export$2e2bcd8739ae039) {
    static get type() {
        return 'InstanceNode';
    }
    constructor(instanceMesh){
        super('void');
        this.instanceMesh = instanceMesh;
        this.instanceMatrixNode = null;
        this.instanceColorNode = null;
        this.updateType = (0, $ddcfecb7fbba5d74$export$26f7a8bbd9469530).FRAME;
        this.buffer = null;
        this.bufferColor = null;
    }
    setup(builder) {
        let instanceMatrixNode = this.instanceMatrixNode;
        let instanceColorNode = this.instanceColorNode;
        const instanceMesh = this.instanceMesh;
        if (instanceMatrixNode === null) {
            const instanceAttribute = instanceMesh.instanceMatrix;
            // Both WebGPU and WebGL backends have UBO max limited to 64kb. Matrix count number bigger than 1000 ( 16 * 4 * 1000 = 64kb ) will fallback to attribute.
            if (instanceMesh.count <= 1000) instanceMatrixNode = (0, $108a458e3a76f5dc$export$ab1029bcae9ddb4a)(instanceAttribute.array, 'mat4', Math.max(instanceMesh.count, 1)).element((0, $c9c236abfeae4cd5$export$3691cd4c77fcb2c4));
            else {
                const buffer = new (0, $70910a96e25c32ff$export$25ec0e1af1389358)(instanceAttribute.array, 16, 1);
                this.buffer = buffer;
                const bufferFn = instanceAttribute.usage === (0, $cb5ee595c0f892af$export$8505d14ac8546ca) ? (0, $48306ea9f4feeeae$export$35d450082ae9e736) : (0, $48306ea9f4feeeae$export$6776ccefa3811157);
                const instanceBuffers = [
                    // F.Signature -> bufferAttribute( array, type, stride, offset )
                    bufferFn(buffer, 'vec4', 16, 0),
                    bufferFn(buffer, 'vec4', 16, 4),
                    bufferFn(buffer, 'vec4', 16, 8),
                    bufferFn(buffer, 'vec4', 16, 12)
                ];
                instanceMatrixNode = (0, $d5b7ee61758b2e81$export$d2b4acf069bf09f5)(...instanceBuffers);
            }
            this.instanceMatrixNode = instanceMatrixNode;
        }
        const instanceColorAttribute = instanceMesh.instanceColor;
        if (instanceColorAttribute && instanceColorNode === null) {
            const buffer = new (0, $3167f16f113afb58$export$32ea87a8b54d744a)(instanceColorAttribute.array, 3);
            const bufferFn = instanceColorAttribute.usage === (0, $cb5ee595c0f892af$export$8505d14ac8546ca) ? (0, $48306ea9f4feeeae$export$35d450082ae9e736) : (0, $48306ea9f4feeeae$export$6776ccefa3811157);
            this.bufferColor = buffer;
            instanceColorNode = (0, $d5b7ee61758b2e81$export$9100789c9d999364)(bufferFn(buffer, 'vec3', 3, 0));
            this.instanceColorNode = instanceColorNode;
        }
        // POSITION
        const instancePosition = instanceMatrixNode.mul((0, $acbec2070ba15851$export$78cc3a7ea225109f)).xyz;
        (0, $acbec2070ba15851$export$78cc3a7ea225109f).assign(instancePosition);
        // NORMAL
        if (builder.hasGeometryAttribute('normal')) {
            const instanceNormal = (0, $0ab44deffc8ae973$export$1dd08f57bc74994c)((0, $0ab44deffc8ae973$export$c94af1e24aa56d8f), instanceMatrixNode);
            // ASSIGNS
            (0, $0ab44deffc8ae973$export$c94af1e24aa56d8f).assign(instanceNormal);
        }
        // COLOR
        if (this.instanceColorNode !== null) (0, $dd761eb0c8b88ca7$export$cb5f8cbf8b7bd600)('vec3', 'vInstanceColor').assign(this.instanceColorNode);
    }
    update() {
        if (this.instanceMesh.instanceMatrix.usage !== (0, $cb5ee595c0f892af$export$8505d14ac8546ca) && this.buffer != null && this.instanceMesh.instanceMatrix.version !== this.buffer.version) this.buffer.version = this.instanceMesh.instanceMatrix.version;
        if (this.instanceMesh.instanceColor && this.instanceMesh.instanceColor.usage !== (0, $cb5ee595c0f892af$export$8505d14ac8546ca) && this.bufferColor != null && this.instanceMesh.instanceColor.version !== this.bufferColor.version) this.bufferColor.version = this.instanceMesh.instanceColor.version;
    }
}
var $7afa8da80fda451d$export$2e2bcd8739ae039 = $7afa8da80fda451d$var$InstanceNode;
const $7afa8da80fda451d$export$9544d5bb712b01ea = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$60d11c6747b7deba)($7afa8da80fda451d$var$InstanceNode);











class $62cb007770e0a0cf$var$BatchNode extends (0, $65e77d5c3a27a66a$export$2e2bcd8739ae039) {
    static get type() {
        return 'BatchNode';
    }
    constructor(batchMesh){
        super('void');
        this.batchMesh = batchMesh;
        this.batchingIdNode = null;
    }
    setup(builder) {
        // POSITION
        if (this.batchingIdNode === null) {
            if (builder.getDrawIndex() === null) this.batchingIdNode = (0, $c9c236abfeae4cd5$export$3691cd4c77fcb2c4);
            else this.batchingIdNode = (0, $c9c236abfeae4cd5$export$34e05495de4c814);
        }
        const getIndirectIndex = (0, $d5b7ee61758b2e81$export$b076717d71a1a47f)(([id])=>{
            const size = (0, $4e1437e3f88f83e2$export$a8905ccad583a116)((0, $f7d68bbf9ea772a7$export$c9a2885c9238610f)(this.batchMesh._indirectTexture), 0);
            const x = (0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)(id).modInt((0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)(size));
            const y = (0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)(id).div((0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)(size));
            return (0, $f7d68bbf9ea772a7$export$c9a2885c9238610f)(this.batchMesh._indirectTexture, (0, $d5b7ee61758b2e81$export$63e666f6a33be288)(x, y)).x;
        }).setLayout({
            name: 'getIndirectIndex',
            type: 'uint',
            inputs: [
                {
                    name: 'id',
                    type: 'int'
                }
            ]
        });
        const indirectId = getIndirectIndex((0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)(this.batchingIdNode));
        const matricesTexture = this.batchMesh._matricesTexture;
        const size = (0, $4e1437e3f88f83e2$export$a8905ccad583a116)((0, $f7d68bbf9ea772a7$export$c9a2885c9238610f)(matricesTexture), 0);
        const j = (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(indirectId).mul(4).toInt().toVar();
        const x = j.modInt(size);
        const y = j.div((0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)(size));
        const batchingMatrix = (0, $d5b7ee61758b2e81$export$d2b4acf069bf09f5)((0, $f7d68bbf9ea772a7$export$c9a2885c9238610f)(matricesTexture, (0, $d5b7ee61758b2e81$export$63e666f6a33be288)(x, y)), (0, $f7d68bbf9ea772a7$export$c9a2885c9238610f)(matricesTexture, (0, $d5b7ee61758b2e81$export$63e666f6a33be288)(x.add(1), y)), (0, $f7d68bbf9ea772a7$export$c9a2885c9238610f)(matricesTexture, (0, $d5b7ee61758b2e81$export$63e666f6a33be288)(x.add(2), y)), (0, $f7d68bbf9ea772a7$export$c9a2885c9238610f)(matricesTexture, (0, $d5b7ee61758b2e81$export$63e666f6a33be288)(x.add(3), y)));
        const colorsTexture = this.batchMesh._colorsTexture;
        if (colorsTexture !== null) {
            const getBatchingColor = (0, $d5b7ee61758b2e81$export$b076717d71a1a47f)(([id])=>{
                const size = (0, $4e1437e3f88f83e2$export$a8905ccad583a116)((0, $f7d68bbf9ea772a7$export$c9a2885c9238610f)(colorsTexture), 0).x;
                const j = id;
                const x = j.modInt(size);
                const y = j.div(size);
                return (0, $f7d68bbf9ea772a7$export$c9a2885c9238610f)(colorsTexture, (0, $d5b7ee61758b2e81$export$63e666f6a33be288)(x, y)).rgb;
            }).setLayout({
                name: 'getBatchingColor',
                type: 'vec3',
                inputs: [
                    {
                        name: 'id',
                        type: 'int'
                    }
                ]
            });
            const color = getBatchingColor(indirectId);
            (0, $dd761eb0c8b88ca7$export$cb5f8cbf8b7bd600)('vec3', 'vBatchColor').assign(color);
        }
        const bm = (0, $d5b7ee61758b2e81$export$e43bd9f504e4ac00)(batchingMatrix);
        (0, $acbec2070ba15851$export$78cc3a7ea225109f).assign(batchingMatrix.mul((0, $acbec2070ba15851$export$78cc3a7ea225109f)));
        const transformedNormal = (0, $0ab44deffc8ae973$export$c94af1e24aa56d8f).div((0, $d5b7ee61758b2e81$export$9100789c9d999364)(bm[0].dot(bm[0]), bm[1].dot(bm[1]), bm[2].dot(bm[2])));
        const batchingNormal = bm.mul(transformedNormal).xyz;
        (0, $0ab44deffc8ae973$export$c94af1e24aa56d8f).assign(batchingNormal);
        if (builder.hasGeometryAttribute('tangent')) (0, $42c3b119e0c3e35a$export$f53a7d05db86e284).mulAssign(bm);
    }
}
var $62cb007770e0a0cf$export$2e2bcd8739ae039 = $62cb007770e0a0cf$var$BatchNode;
const $62cb007770e0a0cf$export$712ea50be43a7858 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$60d11c6747b7deba)($62cb007770e0a0cf$var$BatchNode);















const $f17abdcc686228ff$var$_frameId = new WeakMap();
class $f17abdcc686228ff$var$SkinningNode extends (0, $65e77d5c3a27a66a$export$2e2bcd8739ae039) {
    static get type() {
        return 'SkinningNode';
    }
    constructor(skinnedMesh, useReference = false){
        super('void');
        this.skinnedMesh = skinnedMesh;
        this.useReference = useReference;
        this.updateType = (0, $ddcfecb7fbba5d74$export$26f7a8bbd9469530).OBJECT;
        //
        this.skinIndexNode = (0, $700a78a0d988d216$export$af4b9a83f4b00434)('skinIndex', 'uvec4');
        this.skinWeightNode = (0, $700a78a0d988d216$export$af4b9a83f4b00434)('skinWeight', 'vec4');
        let bindMatrixNode, bindMatrixInverseNode, boneMatricesNode;
        if (useReference) {
            bindMatrixNode = (0, $7082d3a91c21cd99$export$ca50aac9f3ba507f)('bindMatrix', 'mat4');
            bindMatrixInverseNode = (0, $7082d3a91c21cd99$export$ca50aac9f3ba507f)('bindMatrixInverse', 'mat4');
            boneMatricesNode = (0, $7082d3a91c21cd99$export$18088e2a413e76c6)('skeleton.boneMatrices', 'mat4', skinnedMesh.skeleton.bones.length);
        } else {
            bindMatrixNode = (0, $5eb92bf12e57daab$export$379455b567eff87d)(skinnedMesh.bindMatrix, 'mat4');
            bindMatrixInverseNode = (0, $5eb92bf12e57daab$export$379455b567eff87d)(skinnedMesh.bindMatrixInverse, 'mat4');
            boneMatricesNode = (0, $108a458e3a76f5dc$export$ab1029bcae9ddb4a)(skinnedMesh.skeleton.boneMatrices, 'mat4', skinnedMesh.skeleton.bones.length);
        }
        this.bindMatrixNode = bindMatrixNode;
        this.bindMatrixInverseNode = bindMatrixInverseNode;
        this.boneMatricesNode = boneMatricesNode;
        this.previousBoneMatricesNode = null;
    }
    getSkinnedPosition(boneMatrices = this.boneMatricesNode, position = (0, $acbec2070ba15851$export$78cc3a7ea225109f)) {
        const { skinIndexNode: skinIndexNode, skinWeightNode: skinWeightNode, bindMatrixNode: bindMatrixNode, bindMatrixInverseNode: bindMatrixInverseNode } = this;
        const boneMatX = boneMatrices.element(skinIndexNode.x);
        const boneMatY = boneMatrices.element(skinIndexNode.y);
        const boneMatZ = boneMatrices.element(skinIndexNode.z);
        const boneMatW = boneMatrices.element(skinIndexNode.w);
        // POSITION
        const skinVertex = bindMatrixNode.mul(position);
        const skinned = (0, $3f1f23fea79ae256$export$e16d8520af44a096)(boneMatX.mul(skinWeightNode.x).mul(skinVertex), boneMatY.mul(skinWeightNode.y).mul(skinVertex), boneMatZ.mul(skinWeightNode.z).mul(skinVertex), boneMatW.mul(skinWeightNode.w).mul(skinVertex));
        return bindMatrixInverseNode.mul(skinned).xyz;
    }
    getSkinnedNormal(boneMatrices = this.boneMatricesNode, normal = (0, $0ab44deffc8ae973$export$c94af1e24aa56d8f)) {
        const { skinIndexNode: skinIndexNode, skinWeightNode: skinWeightNode, bindMatrixNode: bindMatrixNode, bindMatrixInverseNode: bindMatrixInverseNode } = this;
        const boneMatX = boneMatrices.element(skinIndexNode.x);
        const boneMatY = boneMatrices.element(skinIndexNode.y);
        const boneMatZ = boneMatrices.element(skinIndexNode.z);
        const boneMatW = boneMatrices.element(skinIndexNode.w);
        // NORMAL
        let skinMatrix = (0, $3f1f23fea79ae256$export$e16d8520af44a096)(skinWeightNode.x.mul(boneMatX), skinWeightNode.y.mul(boneMatY), skinWeightNode.z.mul(boneMatZ), skinWeightNode.w.mul(boneMatW));
        skinMatrix = bindMatrixInverseNode.mul(skinMatrix).mul(bindMatrixNode);
        return skinMatrix.transformDirection(normal).xyz;
    }
    getPreviousSkinnedPosition(builder) {
        const skinnedMesh = builder.object;
        if (this.previousBoneMatricesNode === null) {
            skinnedMesh.skeleton.previousBoneMatrices = new Float32Array(skinnedMesh.skeleton.boneMatrices);
            this.previousBoneMatricesNode = (0, $7082d3a91c21cd99$export$18088e2a413e76c6)('skeleton.previousBoneMatrices', 'mat4', skinnedMesh.skeleton.bones.length);
        }
        return this.getSkinnedPosition(this.previousBoneMatricesNode, (0, $acbec2070ba15851$export$f69e3bac20b8ae8f));
    }
    needsPreviousBoneMatrices(builder) {
        const mrt = builder.renderer.getMRT();
        return mrt && mrt.has('velocity');
    }
    setup(builder) {
        if (this.needsPreviousBoneMatrices(builder)) (0, $acbec2070ba15851$export$f69e3bac20b8ae8f).assign(this.getPreviousSkinnedPosition(builder));
        const skinPosition = this.getSkinnedPosition();
        (0, $acbec2070ba15851$export$78cc3a7ea225109f).assign(skinPosition);
        if (builder.hasGeometryAttribute('normal')) {
            const skinNormal = this.getSkinnedNormal();
            (0, $0ab44deffc8ae973$export$c94af1e24aa56d8f).assign(skinNormal);
            if (builder.hasGeometryAttribute('tangent')) (0, $42c3b119e0c3e35a$export$f53a7d05db86e284).assign(skinNormal);
        }
    }
    generate(builder, output) {
        if (output !== 'void') return (0, $acbec2070ba15851$export$78cc3a7ea225109f).build(builder, output);
    }
    update(frame) {
        const object = this.useReference ? frame.object : this.skinnedMesh;
        const skeleton = object.skeleton;
        if ($f17abdcc686228ff$var$_frameId.get(skeleton) === frame.frameId) return;
        $f17abdcc686228ff$var$_frameId.set(skeleton, frame.frameId);
        if (this.previousBoneMatricesNode !== null) skeleton.previousBoneMatrices.set(skeleton.boneMatrices);
        skeleton.update();
    }
}
var $f17abdcc686228ff$export$2e2bcd8739ae039 = $f17abdcc686228ff$var$SkinningNode;
const $f17abdcc686228ff$export$8827b75aa6a3dd00 = (skinnedMesh)=>(0, $d5b7ee61758b2e81$export$e97474e17004dd41)(new $f17abdcc686228ff$var$SkinningNode(skinnedMesh));
const $f17abdcc686228ff$export$a1a5c22177b275e2 = (skinnedMesh)=>(0, $d5b7ee61758b2e81$export$e97474e17004dd41)(new $f17abdcc686228ff$var$SkinningNode(skinnedMesh, true));














class $d74aa096db2d1ee7$export$dfac6c8e811406a3 extends (0, $97033ebbcbadc145$export$5431306cf43de24a) {
    constructor(data = null, width = 1, height = 1, depth = 1){
        super(null);
        this.isDataArrayTexture = true;
        this.image = {
            data: data,
            width: width,
            height: height,
            depth: depth
        };
        this.magFilter = (0, $cb5ee595c0f892af$export$727aa5ec3fe39bf0);
        this.minFilter = (0, $cb5ee595c0f892af$export$727aa5ec3fe39bf0);
        this.wrapR = (0, $cb5ee595c0f892af$export$9d9334239a5a5e06);
        this.generateMipmaps = false;
        this.flipY = false;
        this.unpackAlignment = 1;
        this.layerUpdates = new Set();
    }
    addLayerUpdate(layerIndex) {
        this.layerUpdates.add(layerIndex);
    }
    clearLayerUpdates() {
        this.layerUpdates.clear();
    }
}





const $e07a09bc4bca10e7$var$_morphTextures = /*@__PURE__*/ new WeakMap();
const $e07a09bc4bca10e7$var$_morphVec4 = /*@__PURE__*/ new (0, $a09a15e9a8421204$export$fa7daccca11cdbe3)();
const $e07a09bc4bca10e7$var$getMorph = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$b076717d71a1a47f)(({ bufferMap: bufferMap, influence: influence, stride: stride, width: width, depth: depth, offset: offset })=>{
    const texelIndex = (0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)((0, $c9c236abfeae4cd5$export$df3f95685a193815)).mul(stride).add(offset);
    const y = texelIndex.div(width);
    const x = texelIndex.sub(y.mul(width));
    const bufferAttrib = (0, $f7d68bbf9ea772a7$export$c9a2885c9238610f)(bufferMap, (0, $d5b7ee61758b2e81$export$63e666f6a33be288)(x, y)).depth(depth);
    return bufferAttrib.mul(influence);
});
function $e07a09bc4bca10e7$var$getEntry(geometry) {
    const hasMorphPosition = geometry.morphAttributes.position !== undefined;
    const hasMorphNormals = geometry.morphAttributes.normal !== undefined;
    const hasMorphColors = geometry.morphAttributes.color !== undefined;
    // instead of using attributes, the WebGL 2 code path encodes morph targets
    // into an array of data textures. Each layer represents a single morph target.
    const morphAttribute = geometry.morphAttributes.position || geometry.morphAttributes.normal || geometry.morphAttributes.color;
    const morphTargetsCount = morphAttribute !== undefined ? morphAttribute.length : 0;
    let entry = $e07a09bc4bca10e7$var$_morphTextures.get(geometry);
    if (entry === undefined || entry.count !== morphTargetsCount) {
        if (entry !== undefined) entry.texture.dispose();
        const morphTargets = geometry.morphAttributes.position || [];
        const morphNormals = geometry.morphAttributes.normal || [];
        const morphColors = geometry.morphAttributes.color || [];
        let vertexDataCount = 0;
        if (hasMorphPosition === true) vertexDataCount = 1;
        if (hasMorphNormals === true) vertexDataCount = 2;
        if (hasMorphColors === true) vertexDataCount = 3;
        let width = geometry.attributes.position.count * vertexDataCount;
        let height = 1;
        const maxTextureSize = 4096; // @TODO: Use 'capabilities.maxTextureSize'
        if (width > maxTextureSize) {
            height = Math.ceil(width / maxTextureSize);
            width = maxTextureSize;
        }
        const buffer = new Float32Array(width * height * 4 * morphTargetsCount);
        const bufferTexture = new (0, $d74aa096db2d1ee7$export$dfac6c8e811406a3)(buffer, width, height, morphTargetsCount);
        bufferTexture.type = (0, $cb5ee595c0f892af$export$f6d331659b644596);
        bufferTexture.needsUpdate = true;
        // fill buffer
        const vertexDataStride = vertexDataCount * 4;
        for(let i = 0; i < morphTargetsCount; i++){
            const morphTarget = morphTargets[i];
            const morphNormal = morphNormals[i];
            const morphColor = morphColors[i];
            const offset = width * height * 4 * i;
            for(let j = 0; j < morphTarget.count; j++){
                const stride = j * vertexDataStride;
                if (hasMorphPosition === true) {
                    $e07a09bc4bca10e7$var$_morphVec4.fromBufferAttribute(morphTarget, j);
                    buffer[offset + stride + 0] = $e07a09bc4bca10e7$var$_morphVec4.x;
                    buffer[offset + stride + 1] = $e07a09bc4bca10e7$var$_morphVec4.y;
                    buffer[offset + stride + 2] = $e07a09bc4bca10e7$var$_morphVec4.z;
                    buffer[offset + stride + 3] = 0;
                }
                if (hasMorphNormals === true) {
                    $e07a09bc4bca10e7$var$_morphVec4.fromBufferAttribute(morphNormal, j);
                    buffer[offset + stride + 4] = $e07a09bc4bca10e7$var$_morphVec4.x;
                    buffer[offset + stride + 5] = $e07a09bc4bca10e7$var$_morphVec4.y;
                    buffer[offset + stride + 6] = $e07a09bc4bca10e7$var$_morphVec4.z;
                    buffer[offset + stride + 7] = 0;
                }
                if (hasMorphColors === true) {
                    $e07a09bc4bca10e7$var$_morphVec4.fromBufferAttribute(morphColor, j);
                    buffer[offset + stride + 8] = $e07a09bc4bca10e7$var$_morphVec4.x;
                    buffer[offset + stride + 9] = $e07a09bc4bca10e7$var$_morphVec4.y;
                    buffer[offset + stride + 10] = $e07a09bc4bca10e7$var$_morphVec4.z;
                    buffer[offset + stride + 11] = morphColor.itemSize === 4 ? $e07a09bc4bca10e7$var$_morphVec4.w : 1;
                }
            }
        }
        entry = {
            count: morphTargetsCount,
            texture: bufferTexture,
            stride: vertexDataCount,
            size: new (0, $3c03061dea0adea3$export$c977b3e384af9ae1)(width, height)
        };
        $e07a09bc4bca10e7$var$_morphTextures.set(geometry, entry);
        function disposeTexture() {
            bufferTexture.dispose();
            $e07a09bc4bca10e7$var$_morphTextures.delete(geometry);
            geometry.removeEventListener('dispose', disposeTexture);
        }
        geometry.addEventListener('dispose', disposeTexture);
    }
    return entry;
}
class $e07a09bc4bca10e7$var$MorphNode extends (0, $65e77d5c3a27a66a$export$2e2bcd8739ae039) {
    static get type() {
        return 'MorphNode';
    }
    constructor(mesh){
        super('void');
        this.mesh = mesh;
        this.morphBaseInfluence = (0, $5eb92bf12e57daab$export$379455b567eff87d)(1);
        this.updateType = (0, $ddcfecb7fbba5d74$export$26f7a8bbd9469530).OBJECT;
    }
    setup(builder) {
        const { geometry: geometry } = builder;
        const hasMorphPosition = geometry.morphAttributes.position !== undefined;
        const hasMorphNormals = geometry.hasAttribute('normal') && geometry.morphAttributes.normal !== undefined;
        const morphAttribute = geometry.morphAttributes.position || geometry.morphAttributes.normal || geometry.morphAttributes.color;
        const morphTargetsCount = morphAttribute !== undefined ? morphAttribute.length : 0;
        // nodes
        const { texture: bufferMap, stride: stride, size: size } = $e07a09bc4bca10e7$var$getEntry(geometry);
        if (hasMorphPosition === true) (0, $acbec2070ba15851$export$78cc3a7ea225109f).mulAssign(this.morphBaseInfluence);
        if (hasMorphNormals === true) (0, $0ab44deffc8ae973$export$c94af1e24aa56d8f).mulAssign(this.morphBaseInfluence);
        const width = (0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)(size.width);
        (0, $2a1578e0d4d8bf63$export$550acbd06a1f5a6a)(morphTargetsCount, ({ i: i })=>{
            const influence = (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(0).toVar();
            if (this.mesh.count > 1 && this.mesh.morphTexture !== null && this.mesh.morphTexture !== undefined) influence.assign((0, $f7d68bbf9ea772a7$export$c9a2885c9238610f)(this.mesh.morphTexture, (0, $d5b7ee61758b2e81$export$63e666f6a33be288)((0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)(i).add(1), (0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)((0, $c9c236abfeae4cd5$export$3691cd4c77fcb2c4)))).r);
            else influence.assign((0, $7082d3a91c21cd99$export$ca50aac9f3ba507f)('morphTargetInfluences', 'float').element(i).toVar());
            if (hasMorphPosition === true) (0, $acbec2070ba15851$export$78cc3a7ea225109f).addAssign($e07a09bc4bca10e7$var$getMorph({
                bufferMap: bufferMap,
                influence: influence,
                stride: stride,
                width: width,
                depth: i,
                offset: (0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)(0)
            }));
            if (hasMorphNormals === true) (0, $0ab44deffc8ae973$export$c94af1e24aa56d8f).addAssign($e07a09bc4bca10e7$var$getMorph({
                bufferMap: bufferMap,
                influence: influence,
                stride: stride,
                width: width,
                depth: i,
                offset: (0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)(1)
            }));
        });
    }
    update() {
        const morphBaseInfluence = this.morphBaseInfluence;
        if (this.mesh.geometry.morphTargetsRelative) morphBaseInfluence.value = 1;
        else morphBaseInfluence.value = 1 - this.mesh.morphTargetInfluences.reduce((a, b)=>a + b, 0);
    }
}
var $e07a09bc4bca10e7$export$2e2bcd8739ae039 = $e07a09bc4bca10e7$var$MorphNode;
const $e07a09bc4bca10e7$export$1b980db58c123a7f = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$60d11c6747b7deba)($e07a09bc4bca10e7$var$MorphNode);





class $cdb0844205e5f290$var$LightingNode extends (0, $65e77d5c3a27a66a$export$2e2bcd8739ae039) {
    static get type() {
        return 'LightingNode';
    }
    constructor(){
        super('vec3');
        this.isLightingNode = true;
    }
    generate() {
        console.warn('Abstract function.');
    }
}
var $cdb0844205e5f290$export$2e2bcd8739ae039 = $cdb0844205e5f290$var$LightingNode;


class $6f9babd6a71591ef$var$AONode extends (0, $cdb0844205e5f290$export$2e2bcd8739ae039) {
    static get type() {
        return 'AONode';
    }
    constructor(aoNode = null){
        super();
        this.aoNode = aoNode;
    }
    setup(builder) {
        builder.context.ambientOcclusion.mulAssign(this.aoNode);
    }
}
var $6f9babd6a71591ef$export$2e2bcd8739ae039 = $6f9babd6a71591ef$var$AONode;




class $5629b87e8197e71c$var$LightingContextNode extends (0, $8e9a9aae457d80ab$export$2e2bcd8739ae039) {
    static get type() {
        return 'LightingContextNode';
    }
    constructor(node, lightingModel = null, backdropNode = null, backdropAlphaNode = null){
        super(node);
        this.lightingModel = lightingModel;
        this.backdropNode = backdropNode;
        this.backdropAlphaNode = backdropAlphaNode;
        this._value = null;
    }
    getContext() {
        const { backdropNode: backdropNode, backdropAlphaNode: backdropAlphaNode } = this;
        const directDiffuse = (0, $d5b7ee61758b2e81$export$9100789c9d999364)().toVar('directDiffuse'), directSpecular = (0, $d5b7ee61758b2e81$export$9100789c9d999364)().toVar('directSpecular'), indirectDiffuse = (0, $d5b7ee61758b2e81$export$9100789c9d999364)().toVar('indirectDiffuse'), indirectSpecular = (0, $d5b7ee61758b2e81$export$9100789c9d999364)().toVar('indirectSpecular');
        const reflectedLight = {
            directDiffuse: directDiffuse,
            directSpecular: directSpecular,
            indirectDiffuse: indirectDiffuse,
            indirectSpecular: indirectSpecular
        };
        const context = {
            radiance: (0, $d5b7ee61758b2e81$export$9100789c9d999364)().toVar('radiance'),
            irradiance: (0, $d5b7ee61758b2e81$export$9100789c9d999364)().toVar('irradiance'),
            iblIrradiance: (0, $d5b7ee61758b2e81$export$9100789c9d999364)().toVar('iblIrradiance'),
            ambientOcclusion: (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(1).toVar('ambientOcclusion'),
            reflectedLight: reflectedLight,
            backdrop: backdropNode,
            backdropAlpha: backdropAlphaNode
        };
        return context;
    }
    setup(builder) {
        this.value = this._value || (this._value = this.getContext());
        this.value.lightingModel = this.lightingModel || builder.context.lightingModel;
        return super.setup(builder);
    }
}
var $5629b87e8197e71c$export$2e2bcd8739ae039 = $5629b87e8197e71c$var$LightingContextNode;
const $5629b87e8197e71c$export$90120f928c96f1a6 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$60d11c6747b7deba)($5629b87e8197e71c$var$LightingContextNode);



class $ecfa39e03c174b2c$var$IrradianceNode extends (0, $cdb0844205e5f290$export$2e2bcd8739ae039) {
    static get type() {
        return 'IrradianceNode';
    }
    constructor(node){
        super();
        this.node = node;
    }
    setup(builder) {
        builder.context.irradiance.addAssign(this.node);
    }
}
var $ecfa39e03c174b2c$export$2e2bcd8739ae039 = $ecfa39e03c174b2c$var$IrradianceNode;











class $867cabcdf8f7ae03$var$ClippingNode extends (0, $65e77d5c3a27a66a$export$2e2bcd8739ae039) {
    static get type() {
        return 'ClippingNode';
    }
    constructor(scope = $867cabcdf8f7ae03$var$ClippingNode.DEFAULT){
        super();
        this.scope = scope;
    }
    setup(builder) {
        super.setup(builder);
        const clippingContext = builder.clippingContext;
        const { localClipIntersection: localClipIntersection, localClippingCount: localClippingCount, globalClippingCount: globalClippingCount } = clippingContext;
        const numClippingPlanes = globalClippingCount + localClippingCount;
        const numUnionClippingPlanes = localClipIntersection ? numClippingPlanes - localClippingCount : numClippingPlanes;
        if (this.scope === $867cabcdf8f7ae03$var$ClippingNode.ALPHA_TO_COVERAGE) return this.setupAlphaToCoverage(clippingContext.planes, numClippingPlanes, numUnionClippingPlanes);
        else return this.setupDefault(clippingContext.planes, numClippingPlanes, numUnionClippingPlanes);
    }
    setupAlphaToCoverage(planes, numClippingPlanes, numUnionClippingPlanes) {
        return (0, $d5b7ee61758b2e81$export$b076717d71a1a47f)(()=>{
            const clippingPlanes = (0, $dc98837c0c62767d$export$9b734ab82c2f4fe3)(planes);
            const distanceToPlane = (0, $dd761eb0c8b88ca7$export$d541bacb2bda4494)('float', 'distanceToPlane');
            const distanceGradient = (0, $dd761eb0c8b88ca7$export$d541bacb2bda4494)('float', 'distanceToGradient');
            const clipOpacity = (0, $dd761eb0c8b88ca7$export$d541bacb2bda4494)('float', 'clipOpacity');
            clipOpacity.assign(1);
            let plane;
            (0, $2a1578e0d4d8bf63$export$550acbd06a1f5a6a)(numUnionClippingPlanes, ({ i: i })=>{
                plane = clippingPlanes.element(i);
                distanceToPlane.assign((0, $acbec2070ba15851$export$3dfd735ebeac9bfd).dot(plane.xyz).negate().add(plane.w));
                distanceGradient.assign(distanceToPlane.fwidth().div(2.0));
                clipOpacity.mulAssign((0, $f37ae0e58866c183$export$4053e36566dd3d9a)(distanceGradient.negate(), distanceGradient, distanceToPlane));
                clipOpacity.equal(0.0).discard();
            });
            if (numUnionClippingPlanes < numClippingPlanes) {
                const unionClipOpacity = (0, $dd761eb0c8b88ca7$export$d541bacb2bda4494)('float', 'unionclipOpacity');
                unionClipOpacity.assign(1);
                (0, $2a1578e0d4d8bf63$export$550acbd06a1f5a6a)({
                    start: numUnionClippingPlanes,
                    end: numClippingPlanes
                }, ({ i: i })=>{
                    plane = clippingPlanes.element(i);
                    distanceToPlane.assign((0, $acbec2070ba15851$export$3dfd735ebeac9bfd).dot(plane.xyz).negate().add(plane.w));
                    distanceGradient.assign(distanceToPlane.fwidth().div(2.0));
                    unionClipOpacity.mulAssign((0, $f37ae0e58866c183$export$4053e36566dd3d9a)(distanceGradient.negate(), distanceGradient, distanceToPlane).oneMinus());
                });
                clipOpacity.mulAssign(unionClipOpacity.oneMinus());
            }
            (0, $dd761eb0c8b88ca7$export$3a790f19f33c5176).a.mulAssign(clipOpacity);
            (0, $dd761eb0c8b88ca7$export$3a790f19f33c5176).a.equal(0.0).discard();
        })();
    }
    setupDefault(planes, numClippingPlanes, numUnionClippingPlanes) {
        return (0, $d5b7ee61758b2e81$export$b076717d71a1a47f)(()=>{
            const clippingPlanes = (0, $dc98837c0c62767d$export$9b734ab82c2f4fe3)(planes);
            let plane;
            (0, $2a1578e0d4d8bf63$export$550acbd06a1f5a6a)(numUnionClippingPlanes, ({ i: i })=>{
                plane = clippingPlanes.element(i);
                (0, $acbec2070ba15851$export$3dfd735ebeac9bfd).dot(plane.xyz).greaterThan(plane.w).discard();
            });
            if (numUnionClippingPlanes < numClippingPlanes) {
                const clipped = (0, $dd761eb0c8b88ca7$export$d541bacb2bda4494)('bool', 'clipped');
                clipped.assign(true);
                (0, $2a1578e0d4d8bf63$export$550acbd06a1f5a6a)({
                    start: numUnionClippingPlanes,
                    end: numClippingPlanes
                }, ({ i: i })=>{
                    plane = clippingPlanes.element(i);
                    clipped.assign((0, $acbec2070ba15851$export$3dfd735ebeac9bfd).dot(plane.xyz).greaterThan(plane.w).and(clipped));
                });
                clipped.discard();
            }
        })();
    }
}
$867cabcdf8f7ae03$var$ClippingNode.ALPHA_TO_COVERAGE = 'alphaToCoverage';
$867cabcdf8f7ae03$var$ClippingNode.DEFAULT = 'default';
var $867cabcdf8f7ae03$export$2e2bcd8739ae039 = $867cabcdf8f7ae03$var$ClippingNode;
const $867cabcdf8f7ae03$export$f25885999f2292e7 = ()=>(0, $d5b7ee61758b2e81$export$e97474e17004dd41)(new $867cabcdf8f7ae03$var$ClippingNode());
const $867cabcdf8f7ae03$export$f57c0807fb97f806 = ()=>(0, $d5b7ee61758b2e81$export$e97474e17004dd41)(new $867cabcdf8f7ae03$var$ClippingNode($867cabcdf8f7ae03$var$ClippingNode.ALPHA_TO_COVERAGE));


const $4aa49cb7d4db3267$var$refreshUniforms = [
    'alphaMap',
    'alphaTest',
    'anisotropy',
    'anisotropyMap',
    'anisotropyRotation',
    'aoMap',
    'attenuationColor',
    'attenuationDistance',
    'bumpMap',
    'clearcoat',
    'clearcoatMap',
    'clearcoatNormalMap',
    'clearcoatNormalScale',
    'clearcoatRoughness',
    'color',
    'dispersion',
    'displacementMap',
    'emissive',
    'emissiveMap',
    'envMap',
    'gradientMap',
    'ior',
    'iridescence',
    'iridescenceIOR',
    'iridescenceMap',
    'iridescenceThicknessMap',
    'lightMap',
    'map',
    'matcap',
    'metalness',
    'metalnessMap',
    'normalMap',
    'normalScale',
    'opacity',
    'roughness',
    'roughnessMap',
    'sheen',
    'sheenColor',
    'sheenColorMap',
    'sheenRoughnessMap',
    'shininess',
    'specular',
    'specularColor',
    'specularColorMap',
    'specularIntensity',
    'specularIntensityMap',
    'specularMap',
    'thickness',
    'transmission',
    'transmissionMap'
];
class $4aa49cb7d4db3267$var$NodeMaterialObserver {
    constructor(builder){
        this.renderObjects = new WeakMap();
        this.hasNode = this.containsNode(builder);
        this.hasAnimation = builder.object.isSkinnedMesh === true;
        this.refreshUniforms = $4aa49cb7d4db3267$var$refreshUniforms;
        this.renderId = 0;
    }
    firstInitialization(renderObject) {
        const hasInitialized = this.renderObjects.has(renderObject);
        if (hasInitialized === false) {
            this.getRenderObjectData(renderObject);
            return true;
        }
        return false;
    }
    getRenderObjectData(renderObject) {
        let data = this.renderObjects.get(renderObject);
        if (data === undefined) {
            const { geometry: geometry, material: material } = renderObject;
            data = {
                material: this.getMaterialData(material),
                geometry: {
                    attributes: this.getAttributesData(geometry.attributes),
                    indexVersion: geometry.index ? geometry.index.version : null,
                    drawRange: {
                        start: geometry.drawRange.start,
                        count: geometry.drawRange.count
                    }
                },
                worldMatrix: renderObject.object.matrixWorld.clone()
            };
            if (renderObject.object.center) data.center = renderObject.object.center.clone();
            if (renderObject.object.morphTargetInfluences) data.morphTargetInfluences = renderObject.object.morphTargetInfluences.slice();
            if (renderObject.bundle !== null) data.version = renderObject.bundle.version;
            if (data.material.transmission > 0) {
                const { width: width, height: height } = renderObject.context;
                data.bufferWidth = width;
                data.bufferHeight = height;
            }
            this.renderObjects.set(renderObject, data);
        }
        return data;
    }
    getAttributesData(attributes) {
        const attributesData = {};
        for(const name in attributes){
            const attribute = attributes[name];
            attributesData[name] = {
                version: attribute.version
            };
        }
        return attributesData;
    }
    containsNode(builder) {
        const material = builder.material;
        for(const property in material){
            if (material[property] && material[property].isNode) return true;
        }
        if (builder.renderer.nodes.modelViewMatrix !== null || builder.renderer.nodes.modelNormalViewMatrix !== null) return true;
        return false;
    }
    getMaterialData(material) {
        const data = {};
        for (const property of this.refreshUniforms){
            const value = material[property];
            if (value === null || value === undefined) continue;
            if (typeof value === 'object' && value.clone !== undefined) {
                if (value.isTexture === true) data[property] = {
                    id: value.id,
                    version: value.version
                };
                else data[property] = value.clone();
            } else data[property] = value;
        }
        return data;
    }
    equals(renderObject) {
        const { object: object, material: material, geometry: geometry } = renderObject;
        const renderObjectData = this.getRenderObjectData(renderObject);
        // world matrix
        if (renderObjectData.worldMatrix.equals(object.matrixWorld) !== true) {
            renderObjectData.worldMatrix.copy(object.matrixWorld);
            return false;
        }
        // material
        const materialData = renderObjectData.material;
        for(const property in materialData){
            const value = materialData[property];
            const mtlValue = material[property];
            if (value.equals !== undefined) {
                if (value.equals(mtlValue) === false) {
                    value.copy(mtlValue);
                    return false;
                }
            } else if (mtlValue.isTexture === true) {
                if (value.id !== mtlValue.id || value.version !== mtlValue.version) {
                    value.id = mtlValue.id;
                    value.version = mtlValue.version;
                    return false;
                }
            } else if (value !== mtlValue) {
                materialData[property] = mtlValue;
                return false;
            }
        }
        if (materialData.transmission > 0) {
            const { width: width, height: height } = renderObject.context;
            if (renderObjectData.bufferWidth !== width || renderObjectData.bufferHeight !== height) {
                renderObjectData.bufferWidth = width;
                renderObjectData.bufferHeight = height;
                return false;
            }
        }
        // geometry
        const storedGeometryData = renderObjectData.geometry;
        const attributes = geometry.attributes;
        const storedAttributes = storedGeometryData.attributes;
        const storedAttributeNames = Object.keys(storedAttributes);
        const currentAttributeNames = Object.keys(attributes);
        if (storedAttributeNames.length !== currentAttributeNames.length) {
            renderObjectData.geometry.attributes = this.getAttributesData(attributes);
            return false;
        }
        // Compare each attribute
        for (const name of storedAttributeNames){
            const storedAttributeData = storedAttributes[name];
            const attribute = attributes[name];
            if (attribute === undefined) {
                // Attribute was removed
                delete storedAttributes[name];
                return false;
            }
            if (storedAttributeData.version !== attribute.version) {
                storedAttributeData.version = attribute.version;
                return false;
            }
        }
        // Check index
        const index = geometry.index;
        const storedIndexVersion = storedGeometryData.indexVersion;
        const currentIndexVersion = index ? index.version : null;
        if (storedIndexVersion !== currentIndexVersion) {
            storedGeometryData.indexVersion = currentIndexVersion;
            return false;
        }
        // Check drawRange
        if (storedGeometryData.drawRange.start !== geometry.drawRange.start || storedGeometryData.drawRange.count !== geometry.drawRange.count) {
            storedGeometryData.drawRange.start = geometry.drawRange.start;
            storedGeometryData.drawRange.count = geometry.drawRange.count;
            return false;
        }
        // morph targets
        if (renderObjectData.morphTargetInfluences) {
            let morphChanged = false;
            for(let i = 0; i < renderObjectData.morphTargetInfluences.length; i++)if (renderObjectData.morphTargetInfluences[i] !== object.morphTargetInfluences[i]) morphChanged = true;
            if (morphChanged) return true;
        }
        // center
        if (renderObjectData.center) {
            if (renderObjectData.center.equals(object.center) === false) {
                renderObjectData.center.copy(object.center);
                return true;
            }
        }
        // bundle
        if (renderObject.bundle !== null) renderObjectData.version = renderObject.bundle.version;
        return true;
    }
    needsRefresh(renderObject, nodeFrame) {
        if (this.hasNode || this.hasAnimation || this.firstInitialization(renderObject)) return true;
        const { renderId: renderId } = nodeFrame;
        if (this.renderId !== renderId) {
            this.renderId = renderId;
            return true;
        }
        const isStatic = renderObject.object.static === true;
        const isBundle = renderObject.bundle !== null && renderObject.bundle.static === true && this.getRenderObjectData(renderObject).version === renderObject.bundle.version;
        if (isStatic || isBundle) return false;
        const notEqual = this.equals(renderObject) !== true;
        return notEqual;
    }
}
var $4aa49cb7d4db3267$export$2e2bcd8739ae039 = $4aa49cb7d4db3267$var$NodeMaterialObserver;



/**
 * See: https://casual-effects.com/research/Wyman2017Hashed/index.html
 */ const $5c30d76e09eb3868$var$ALPHA_HASH_SCALE = 0.05; // Derived from trials only, and may be changed.
const $5c30d76e09eb3868$var$hash2D = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$b076717d71a1a47f)(([value])=>{
    return (0, $f37ae0e58866c183$export$a57bfe0eb79af278)((0, $3f1f23fea79ae256$export$6e3a27864ab166fe)(1.0e4, (0, $f37ae0e58866c183$export$5de3937cb4b592ed)((0, $3f1f23fea79ae256$export$6e3a27864ab166fe)(17.0, value.x).add((0, $3f1f23fea79ae256$export$6e3a27864ab166fe)(0.1, value.y)))).mul((0, $3f1f23fea79ae256$export$e16d8520af44a096)(0.1, (0, $f37ae0e58866c183$export$2335f513bbd82c6d)((0, $f37ae0e58866c183$export$5de3937cb4b592ed)((0, $3f1f23fea79ae256$export$6e3a27864ab166fe)(13.0, value.y).add(value.x))))));
});
const $5c30d76e09eb3868$var$hash3D = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$b076717d71a1a47f)(([value])=>{
    return $5c30d76e09eb3868$var$hash2D((0, $d5b7ee61758b2e81$export$e9830bc863290a54)($5c30d76e09eb3868$var$hash2D(value.xy), value.z));
});
const $5c30d76e09eb3868$var$getAlphaHashThreshold = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$b076717d71a1a47f)(([position])=>{
    // Find the discretized derivatives of our coordinates
    const maxDeriv = (0, $f37ae0e58866c183$export$8960430cfd85939f)((0, $f37ae0e58866c183$export$f24224f1c91d8156)((0, $f37ae0e58866c183$export$bc6322edd97b7d95)(position.xyz)), (0, $f37ae0e58866c183$export$f24224f1c91d8156)((0, $f37ae0e58866c183$export$2563647325add98e)(position.xyz))).toVar('maxDeriv');
    const pixScale = (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(1).div((0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)($5c30d76e09eb3868$var$ALPHA_HASH_SCALE).mul(maxDeriv)).toVar('pixScale');
    // Find two nearest log-discretized noise scales
    const pixScales = (0, $d5b7ee61758b2e81$export$e9830bc863290a54)((0, $f37ae0e58866c183$export$4edc262d3118e986)((0, $f37ae0e58866c183$export$a3fe094919f356fd)((0, $f37ae0e58866c183$export$b9fae0bba9d9094d)(pixScale))), (0, $f37ae0e58866c183$export$4edc262d3118e986)((0, $f37ae0e58866c183$export$803ce6b71a0a94b2)((0, $f37ae0e58866c183$export$b9fae0bba9d9094d)(pixScale)))).toVar('pixScales');
    // Compute alpha thresholds at our two noise scales
    const alpha = (0, $d5b7ee61758b2e81$export$e9830bc863290a54)($5c30d76e09eb3868$var$hash3D((0, $f37ae0e58866c183$export$a3fe094919f356fd)(pixScales.x.mul(position.xyz))), $5c30d76e09eb3868$var$hash3D((0, $f37ae0e58866c183$export$a3fe094919f356fd)(pixScales.y.mul(position.xyz)))).toVar('alpha');
    // Factor to interpolate lerp with
    const lerpFactor = (0, $f37ae0e58866c183$export$a57bfe0eb79af278)((0, $f37ae0e58866c183$export$b9fae0bba9d9094d)(pixScale)).toVar('lerpFactor');
    // Interpolate alpha threshold from noise at two scales
    const x = (0, $3f1f23fea79ae256$export$e16d8520af44a096)((0, $3f1f23fea79ae256$export$6e3a27864ab166fe)(lerpFactor.oneMinus(), alpha.x), (0, $3f1f23fea79ae256$export$6e3a27864ab166fe)(lerpFactor, alpha.y)).toVar('x');
    // Pass into CDF to compute uniformly distrib threshold
    const a = (0, $f37ae0e58866c183$export$96ec731ed4dcb222)(lerpFactor, lerpFactor.oneMinus()).toVar('a');
    const cases = (0, $d5b7ee61758b2e81$export$9100789c9d999364)(x.mul(x).div((0, $3f1f23fea79ae256$export$6e3a27864ab166fe)(2.0, a).mul((0, $3f1f23fea79ae256$export$f93b5905241a7cca)(1.0, a))), x.sub((0, $3f1f23fea79ae256$export$6e3a27864ab166fe)(0.5, a)).div((0, $3f1f23fea79ae256$export$f93b5905241a7cca)(1.0, a)), (0, $3f1f23fea79ae256$export$f93b5905241a7cca)(1.0, (0, $3f1f23fea79ae256$export$f93b5905241a7cca)(1.0, x).mul((0, $3f1f23fea79ae256$export$f93b5905241a7cca)(1.0, x)).div((0, $3f1f23fea79ae256$export$6e3a27864ab166fe)(2.0, a).mul((0, $3f1f23fea79ae256$export$f93b5905241a7cca)(1.0, a))))).toVar('cases');
    // Find our final, uniformly distributed alpha threshold (ατ)
    const threshold = x.lessThan(a.oneMinus()).select(x.lessThan(a).select(cases.x, cases.y), cases.z);
    // Avoids ατ == 0. Could also do ατ =1-ατ
    return (0, $f37ae0e58866c183$export$7d15b64cf5a3a4c4)(threshold, 1.0e-6, 1.0);
});
var $5c30d76e09eb3868$export$2e2bcd8739ae039 = $5c30d76e09eb3868$var$getAlphaHashThreshold;


class $1a485f4d26090da0$var$NodeMaterial extends (0, $7711e1b3c41f4d78$export$a2d8b23205c25948) {
    static get type() {
        return 'NodeMaterial';
    }
    constructor(){
        super();
        this.isNodeMaterial = true;
        this.type = this.constructor.type;
        this.forceSinglePass = false;
        this.fog = true;
        this.lights = false;
        this.lightsNode = null;
        this.envNode = null;
        this.aoNode = null;
        this.colorNode = null;
        this.normalNode = null;
        this.opacityNode = null;
        this.backdropNode = null;
        this.backdropAlphaNode = null;
        this.alphaTestNode = null;
        this.positionNode = null;
        this.geometryNode = null;
        this.depthNode = null;
        this.shadowNode = null;
        this.shadowPositionNode = null;
        this.outputNode = null;
        this.mrtNode = null;
        this.fragmentNode = null;
        this.vertexNode = null;
    }
    customProgramCacheKey() {
        return this.type + (0, $97d1d441621670a9$export$611736262b635f8d)(this);
    }
    build(builder) {
        this.setup(builder);
    }
    setupObserver(builder) {
        return new (0, $4aa49cb7d4db3267$export$2e2bcd8739ae039)(builder);
    }
    setup(builder) {
        builder.context.setupNormal = ()=>this.setupNormal(builder);
        // < VERTEX STAGE >
        builder.addStack();
        builder.stack.outputNode = this.vertexNode || this.setupPosition(builder);
        if (this.geometryNode !== null) builder.stack.outputNode = builder.stack.outputNode.bypass(this.geometryNode);
        builder.addFlow('vertex', builder.removeStack());
        // < FRAGMENT STAGE >
        builder.addStack();
        let resultNode;
        const clippingNode = this.setupClipping(builder);
        if (this.depthWrite === true) this.setupDepth(builder);
        if (this.fragmentNode === null) {
            this.setupDiffuseColor(builder);
            this.setupVariants(builder);
            const outgoingLightNode = this.setupLighting(builder);
            if (clippingNode !== null) builder.stack.add(clippingNode);
            // force unsigned floats - useful for RenderTargets
            const basicOutput = (0, $d5b7ee61758b2e81$export$6dba2a1f0d609415)(outgoingLightNode, (0, $dd761eb0c8b88ca7$export$3a790f19f33c5176).a).max(0);
            resultNode = this.setupOutput(builder, basicOutput);
            // OUTPUT NODE
            (0, $dd761eb0c8b88ca7$export$c789db2c85949867).assign(resultNode);
            //
            if (this.outputNode !== null) resultNode = this.outputNode;
            // MRT
            const renderTarget = builder.renderer.getRenderTarget();
            if (renderTarget !== null) {
                const mrt = builder.renderer.getMRT();
                const materialMRT = this.mrtNode;
                if (mrt !== null) {
                    resultNode = mrt;
                    if (materialMRT !== null) resultNode = mrt.merge(materialMRT);
                } else if (materialMRT !== null) resultNode = materialMRT;
            }
        } else {
            let fragmentNode = this.fragmentNode;
            if (fragmentNode.isOutputStructNode !== true) fragmentNode = (0, $d5b7ee61758b2e81$export$6dba2a1f0d609415)(fragmentNode);
            resultNode = this.setupOutput(builder, fragmentNode);
        }
        builder.stack.outputNode = resultNode;
        builder.addFlow('fragment', builder.removeStack());
        // < MONITOR >
        builder.monitor = this.setupObserver(builder);
    }
    setupClipping(builder) {
        if (builder.clippingContext === null) return null;
        const { globalClippingCount: globalClippingCount, localClippingCount: localClippingCount } = builder.clippingContext;
        let result = null;
        if (globalClippingCount || localClippingCount) {
            const samples = builder.renderer.samples;
            if (this.alphaToCoverage && samples > 1) // to be added to flow when the color/alpha value has been determined
            result = (0, $867cabcdf8f7ae03$export$f57c0807fb97f806)();
            else builder.stack.add((0, $867cabcdf8f7ae03$export$f25885999f2292e7)());
        }
        return result;
    }
    setupDepth(builder) {
        const { renderer: renderer, camera: camera } = builder;
        // Depth
        let depthNode = this.depthNode;
        if (depthNode === null) {
            const mrt = renderer.getMRT();
            if (mrt && mrt.has('depth')) depthNode = mrt.get('depth');
            else if (renderer.logarithmicDepthBuffer === true) {
                if (camera.isPerspectiveCamera) depthNode = (0, $c2ec92bdddb724e3$export$7e233a63f5c02fa0)((0, $ae567e19e549d56f$export$64e914589db9c49e)().w, (0, $aa7db78c76b9331c$export$81bd96ee69286580), (0, $aa7db78c76b9331c$export$21e5768aeb8c5c46));
                else depthNode = (0, $c2ec92bdddb724e3$export$22f8344c678d1434)((0, $acbec2070ba15851$export$3dfd735ebeac9bfd).z, (0, $aa7db78c76b9331c$export$81bd96ee69286580), (0, $aa7db78c76b9331c$export$21e5768aeb8c5c46));
            }
        }
        if (depthNode !== null) (0, $c2ec92bdddb724e3$export$b202ba015b5882cd).assign(depthNode).append();
    }
    setupPosition(builder) {
        const { object: object } = builder;
        const geometry = object.geometry;
        builder.addStack();
        // Vertex
        if (geometry.morphAttributes.position || geometry.morphAttributes.normal || geometry.morphAttributes.color) (0, $e07a09bc4bca10e7$export$1b980db58c123a7f)(object).append();
        if (object.isSkinnedMesh === true) (0, $f17abdcc686228ff$export$a1a5c22177b275e2)(object).append();
        if (this.displacementMap) {
            const displacementMap = (0, $148d94357f05ebae$export$f503be583015cb4f)('displacementMap', 'texture');
            const displacementScale = (0, $148d94357f05ebae$export$f503be583015cb4f)('displacementScale', 'float');
            const displacementBias = (0, $148d94357f05ebae$export$f503be583015cb4f)('displacementBias', 'float');
            (0, $acbec2070ba15851$export$78cc3a7ea225109f).addAssign((0, $0ab44deffc8ae973$export$c94af1e24aa56d8f).normalize().mul(displacementMap.x.mul(displacementScale).add(displacementBias)));
        }
        if (object.isBatchedMesh) (0, $62cb007770e0a0cf$export$712ea50be43a7858)(object).append();
        if (object.instanceMatrix && object.instanceMatrix.isInstancedBufferAttribute === true) (0, $7afa8da80fda451d$export$9544d5bb712b01ea)(object).append();
        if (this.positionNode !== null) (0, $acbec2070ba15851$export$78cc3a7ea225109f).assign(this.positionNode);
        const mvp = (0, $ae567e19e549d56f$export$64e914589db9c49e)();
        builder.context.vertex = builder.removeStack();
        builder.context.mvp = mvp;
        return mvp;
    }
    setupDiffuseColor({ object: object, geometry: geometry }) {
        let colorNode = this.colorNode ? (0, $d5b7ee61758b2e81$export$6dba2a1f0d609415)(this.colorNode) : (0, $8e4701fdb55563f1$export$852ee2194711a41a);
        // VERTEX COLORS
        if (this.vertexColors === true && geometry.hasAttribute('color')) colorNode = (0, $d5b7ee61758b2e81$export$6dba2a1f0d609415)(colorNode.xyz.mul((0, $700a78a0d988d216$export$af4b9a83f4b00434)('color', 'vec3')), colorNode.a);
        // Instanced colors
        if (object.instanceColor) {
            const instanceColor = (0, $dd761eb0c8b88ca7$export$cb5f8cbf8b7bd600)('vec3', 'vInstanceColor');
            colorNode = instanceColor.mul(colorNode);
        }
        if (object.isBatchedMesh && object._colorsTexture) {
            const batchColor = (0, $dd761eb0c8b88ca7$export$cb5f8cbf8b7bd600)('vec3', 'vBatchColor');
            colorNode = batchColor.mul(colorNode);
        }
        // COLOR
        (0, $dd761eb0c8b88ca7$export$3a790f19f33c5176).assign(colorNode);
        // OPACITY
        const opacityNode = this.opacityNode ? (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(this.opacityNode) : (0, $8e4701fdb55563f1$export$a61065844a540229);
        (0, $dd761eb0c8b88ca7$export$3a790f19f33c5176).a.assign((0, $dd761eb0c8b88ca7$export$3a790f19f33c5176).a.mul(opacityNode));
        // ALPHA TEST
        if (this.alphaTestNode !== null || this.alphaTest > 0) {
            const alphaTestNode = this.alphaTestNode !== null ? (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(this.alphaTestNode) : (0, $8e4701fdb55563f1$export$3030330267c62589);
            (0, $dd761eb0c8b88ca7$export$3a790f19f33c5176).a.lessThanEqual(alphaTestNode).discard();
        }
        // ALPHA HASH
        if (this.alphaHash === true) (0, $dd761eb0c8b88ca7$export$3a790f19f33c5176).a.lessThan((0, $5c30d76e09eb3868$export$2e2bcd8739ae039)((0, $acbec2070ba15851$export$78cc3a7ea225109f))).discard();
        if (this.transparent === false && this.blending === (0, $cb5ee595c0f892af$export$5b29a26d96ee6af0) && this.alphaToCoverage === false) (0, $dd761eb0c8b88ca7$export$3a790f19f33c5176).a.assign(1.0);
    }
    setupVariants() {
    // Interface function.
    }
    setupOutgoingLight() {
        return this.lights === true ? (0, $d5b7ee61758b2e81$export$9100789c9d999364)(0) : (0, $dd761eb0c8b88ca7$export$3a790f19f33c5176).rgb;
    }
    setupNormal() {
        return this.normalNode ? (0, $d5b7ee61758b2e81$export$9100789c9d999364)(this.normalNode) : (0, $8e4701fdb55563f1$export$c30da46075fba8bb);
    }
    setupEnvironment() {
        let node = null;
        if (this.envNode) node = this.envNode;
        else if (this.envMap) node = this.envMap.isCubeTexture ? (0, $148d94357f05ebae$export$f503be583015cb4f)('envMap', 'cubeTexture') : (0, $148d94357f05ebae$export$f503be583015cb4f)('envMap', 'texture');
        return node;
    }
    setupLightMap(builder) {
        let node = null;
        if (builder.material.lightMap) node = new (0, $ecfa39e03c174b2c$export$2e2bcd8739ae039)((0, $8e4701fdb55563f1$export$4d5913e0c9a9ccca));
        return node;
    }
    setupLights(builder) {
        const materialLightsNode = [];
        //
        const envNode = this.setupEnvironment(builder);
        if (envNode && envNode.isLightingNode) materialLightsNode.push(envNode);
        const lightMapNode = this.setupLightMap(builder);
        if (lightMapNode && lightMapNode.isLightingNode) materialLightsNode.push(lightMapNode);
        if (this.aoNode !== null || builder.material.aoMap) {
            const aoNode = this.aoNode !== null ? this.aoNode : (0, $8e4701fdb55563f1$export$4a45f71f148b256);
            materialLightsNode.push(new (0, $6f9babd6a71591ef$export$2e2bcd8739ae039)(aoNode));
        }
        let lightsN = this.lightsNode || builder.lightsNode;
        if (materialLightsNode.length > 0) lightsN = builder.renderer.lighting.createNode([
            ...lightsN.getLights(),
            ...materialLightsNode
        ]);
        return lightsN;
    }
    setupLightingModel() {
    // Interface function.
    }
    setupLighting(builder) {
        const { material: material } = builder;
        const { backdropNode: backdropNode, backdropAlphaNode: backdropAlphaNode, emissiveNode: emissiveNode } = this;
        // OUTGOING LIGHT
        const lights = this.lights === true || this.lightsNode !== null;
        const lightsNode = lights ? this.setupLights(builder) : null;
        let outgoingLightNode = this.setupOutgoingLight(builder);
        if (lightsNode && lightsNode.getScope().hasLights) {
            const lightingModel = this.setupLightingModel(builder);
            outgoingLightNode = (0, $5629b87e8197e71c$export$90120f928c96f1a6)(lightsNode, lightingModel, backdropNode, backdropAlphaNode);
        } else if (backdropNode !== null) outgoingLightNode = (0, $d5b7ee61758b2e81$export$9100789c9d999364)(backdropAlphaNode !== null ? (0, $f37ae0e58866c183$export$2c9e8a9632a706b2)(outgoingLightNode, backdropNode, backdropAlphaNode) : backdropNode);
        // EMISSIVE
        if (emissiveNode && emissiveNode.isNode === true || material.emissive && material.emissive.isColor === true) {
            (0, $dd761eb0c8b88ca7$export$f0b29974073fef6).assign((0, $d5b7ee61758b2e81$export$9100789c9d999364)(emissiveNode ? emissiveNode : (0, $8e4701fdb55563f1$export$7935949e0cf72a01)));
            outgoingLightNode = outgoingLightNode.add((0, $dd761eb0c8b88ca7$export$f0b29974073fef6));
        }
        return outgoingLightNode;
    }
    setupOutput(builder, outputNode) {
        // FOG
        if (this.fog === true) {
            const fogNode = builder.fogNode;
            if (fogNode) outputNode = (0, $d5b7ee61758b2e81$export$6dba2a1f0d609415)(fogNode.mix(outputNode.rgb, fogNode.colorNode), outputNode.a);
        }
        return outputNode;
    }
    setDefaultValues(material) {
        // This approach is to reuse the native refreshUniforms*
        // and turn available the use of features like transmission and environment in core
        for(const property in material){
            const value = material[property];
            if (this[property] === undefined) {
                this[property] = value;
                if (value && value.clone) this[property] = value.clone();
            }
        }
        const descriptors = Object.getOwnPropertyDescriptors(material.constructor.prototype);
        for(const key in descriptors)if (Object.getOwnPropertyDescriptor(this.constructor.prototype, key) === undefined && descriptors[key].get !== undefined) Object.defineProperty(this.constructor.prototype, key, descriptors[key]);
    }
    toJSON(meta) {
        const isRoot = meta === undefined || typeof meta === 'string';
        if (isRoot) meta = {
            textures: {},
            images: {},
            nodes: {}
        };
        const data = (0, $7711e1b3c41f4d78$export$a2d8b23205c25948).prototype.toJSON.call(this, meta);
        const nodeChildren = (0, $97d1d441621670a9$export$1f1998cc3c6b56fb)(this);
        data.inputNodes = {};
        for (const { property: property, childNode: childNode } of nodeChildren)data.inputNodes[property] = childNode.toJSON(meta).uuid;
        // TODO: Copied from Object3D.toJSON
        function extractFromCache(cache) {
            const values = [];
            for(const key in cache){
                const data = cache[key];
                delete data.metadata;
                values.push(data);
            }
            return values;
        }
        if (isRoot) {
            const textures = extractFromCache(meta.textures);
            const images = extractFromCache(meta.images);
            const nodes = extractFromCache(meta.nodes);
            if (textures.length > 0) data.textures = textures;
            if (images.length > 0) data.images = images;
            if (nodes.length > 0) data.nodes = nodes;
        }
        return data;
    }
    copy(source) {
        this.lightsNode = source.lightsNode;
        this.envNode = source.envNode;
        this.colorNode = source.colorNode;
        this.normalNode = source.normalNode;
        this.opacityNode = source.opacityNode;
        this.backdropNode = source.backdropNode;
        this.backdropAlphaNode = source.backdropAlphaNode;
        this.alphaTestNode = source.alphaTestNode;
        this.positionNode = source.positionNode;
        this.geometryNode = source.geometryNode;
        this.depthNode = source.depthNode;
        this.shadowNode = source.shadowNode;
        this.shadowPositionNode = source.shadowPositionNode;
        this.outputNode = source.outputNode;
        this.mrtNode = source.mrtNode;
        this.fragmentNode = source.fragmentNode;
        this.vertexNode = source.vertexNode;
        return super.copy(source);
    }
}
var $1a485f4d26090da0$export$2e2bcd8739ae039 = $1a485f4d26090da0$var$NodeMaterial;





class $e07223619cf61cc6$export$6f7d5a9418ab2aa3 {
    constructor(min = new (0, $d7d0ac0e47013885$export$64b5c384219d3699)(Infinity, Infinity, Infinity), max = new (0, $d7d0ac0e47013885$export$64b5c384219d3699)(-Infinity, -Infinity, -Infinity)){
        this.isBox3 = true;
        this.min = min;
        this.max = max;
    }
    set(min, max) {
        this.min.copy(min);
        this.max.copy(max);
        return this;
    }
    setFromArray(array) {
        this.makeEmpty();
        for(let i = 0, il = array.length; i < il; i += 3)this.expandByPoint($e07223619cf61cc6$var$_vector.fromArray(array, i));
        return this;
    }
    setFromBufferAttribute(attribute) {
        this.makeEmpty();
        for(let i = 0, il = attribute.count; i < il; i++)this.expandByPoint($e07223619cf61cc6$var$_vector.fromBufferAttribute(attribute, i));
        return this;
    }
    setFromPoints(points) {
        this.makeEmpty();
        for(let i = 0, il = points.length; i < il; i++)this.expandByPoint(points[i]);
        return this;
    }
    setFromCenterAndSize(center, size) {
        const halfSize = $e07223619cf61cc6$var$_vector.copy(size).multiplyScalar(0.5);
        this.min.copy(center).sub(halfSize);
        this.max.copy(center).add(halfSize);
        return this;
    }
    setFromObject(object, precise = false) {
        this.makeEmpty();
        return this.expandByObject(object, precise);
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(box) {
        this.min.copy(box.min);
        this.max.copy(box.max);
        return this;
    }
    makeEmpty() {
        this.min.x = this.min.y = this.min.z = Infinity;
        this.max.x = this.max.y = this.max.z = -Infinity;
        return this;
    }
    isEmpty() {
        // this is a more robust check for empty than ( volume <= 0 ) because volume can get positive with two negative axes
        return this.max.x < this.min.x || this.max.y < this.min.y || this.max.z < this.min.z;
    }
    getCenter(target) {
        return this.isEmpty() ? target.set(0, 0, 0) : target.addVectors(this.min, this.max).multiplyScalar(0.5);
    }
    getSize(target) {
        return this.isEmpty() ? target.set(0, 0, 0) : target.subVectors(this.max, this.min);
    }
    expandByPoint(point) {
        this.min.min(point);
        this.max.max(point);
        return this;
    }
    expandByVector(vector) {
        this.min.sub(vector);
        this.max.add(vector);
        return this;
    }
    expandByScalar(scalar) {
        this.min.addScalar(-scalar);
        this.max.addScalar(scalar);
        return this;
    }
    expandByObject(object, precise = false) {
        // Computes the world-axis-aligned bounding box of an object (including its children),
        // accounting for both the object's, and children's, world transforms
        object.updateWorldMatrix(false, false);
        const geometry = object.geometry;
        if (geometry !== undefined) {
            const positionAttribute = geometry.getAttribute('position');
            // precise AABB computation based on vertex data requires at least a position attribute.
            // instancing isn't supported so far and uses the normal (conservative) code path.
            if (precise === true && positionAttribute !== undefined && object.isInstancedMesh !== true) for(let i = 0, l = positionAttribute.count; i < l; i++){
                if (object.isMesh === true) object.getVertexPosition(i, $e07223619cf61cc6$var$_vector);
                else $e07223619cf61cc6$var$_vector.fromBufferAttribute(positionAttribute, i);
                $e07223619cf61cc6$var$_vector.applyMatrix4(object.matrixWorld);
                this.expandByPoint($e07223619cf61cc6$var$_vector);
            }
            else {
                if (object.boundingBox !== undefined) {
                    // object-level bounding box
                    if (object.boundingBox === null) object.computeBoundingBox();
                    $e07223619cf61cc6$var$_box.copy(object.boundingBox);
                } else {
                    // geometry-level bounding box
                    if (geometry.boundingBox === null) geometry.computeBoundingBox();
                    $e07223619cf61cc6$var$_box.copy(geometry.boundingBox);
                }
                $e07223619cf61cc6$var$_box.applyMatrix4(object.matrixWorld);
                this.union($e07223619cf61cc6$var$_box);
            }
        }
        const children = object.children;
        for(let i = 0, l = children.length; i < l; i++)this.expandByObject(children[i], precise);
        return this;
    }
    containsPoint(point) {
        return point.x >= this.min.x && point.x <= this.max.x && point.y >= this.min.y && point.y <= this.max.y && point.z >= this.min.z && point.z <= this.max.z;
    }
    containsBox(box) {
        return this.min.x <= box.min.x && box.max.x <= this.max.x && this.min.y <= box.min.y && box.max.y <= this.max.y && this.min.z <= box.min.z && box.max.z <= this.max.z;
    }
    getParameter(point, target) {
        // This can potentially have a divide by zero if the box
        // has a size dimension of 0.
        return target.set((point.x - this.min.x) / (this.max.x - this.min.x), (point.y - this.min.y) / (this.max.y - this.min.y), (point.z - this.min.z) / (this.max.z - this.min.z));
    }
    intersectsBox(box) {
        // using 6 splitting planes to rule out intersections.
        return box.max.x >= this.min.x && box.min.x <= this.max.x && box.max.y >= this.min.y && box.min.y <= this.max.y && box.max.z >= this.min.z && box.min.z <= this.max.z;
    }
    intersectsSphere(sphere) {
        // Find the point on the AABB closest to the sphere center.
        this.clampPoint(sphere.center, $e07223619cf61cc6$var$_vector);
        // If that point is inside the sphere, the AABB and sphere intersect.
        return $e07223619cf61cc6$var$_vector.distanceToSquared(sphere.center) <= sphere.radius * sphere.radius;
    }
    intersectsPlane(plane) {
        // We compute the minimum and maximum dot product values. If those values
        // are on the same side (back or front) of the plane, then there is no intersection.
        let min, max;
        if (plane.normal.x > 0) {
            min = plane.normal.x * this.min.x;
            max = plane.normal.x * this.max.x;
        } else {
            min = plane.normal.x * this.max.x;
            max = plane.normal.x * this.min.x;
        }
        if (plane.normal.y > 0) {
            min += plane.normal.y * this.min.y;
            max += plane.normal.y * this.max.y;
        } else {
            min += plane.normal.y * this.max.y;
            max += plane.normal.y * this.min.y;
        }
        if (plane.normal.z > 0) {
            min += plane.normal.z * this.min.z;
            max += plane.normal.z * this.max.z;
        } else {
            min += plane.normal.z * this.max.z;
            max += plane.normal.z * this.min.z;
        }
        return min <= -plane.constant && max >= -plane.constant;
    }
    intersectsTriangle(triangle) {
        if (this.isEmpty()) return false;
        // compute box center and extents
        this.getCenter($e07223619cf61cc6$var$_center);
        $e07223619cf61cc6$var$_extents.subVectors(this.max, $e07223619cf61cc6$var$_center);
        // translate triangle to aabb origin
        $e07223619cf61cc6$var$_v0.subVectors(triangle.a, $e07223619cf61cc6$var$_center);
        $e07223619cf61cc6$var$_v1.subVectors(triangle.b, $e07223619cf61cc6$var$_center);
        $e07223619cf61cc6$var$_v2.subVectors(triangle.c, $e07223619cf61cc6$var$_center);
        // compute edge vectors for triangle
        $e07223619cf61cc6$var$_f0.subVectors($e07223619cf61cc6$var$_v1, $e07223619cf61cc6$var$_v0);
        $e07223619cf61cc6$var$_f1.subVectors($e07223619cf61cc6$var$_v2, $e07223619cf61cc6$var$_v1);
        $e07223619cf61cc6$var$_f2.subVectors($e07223619cf61cc6$var$_v0, $e07223619cf61cc6$var$_v2);
        // test against axes that are given by cross product combinations of the edges of the triangle and the edges of the aabb
        // make an axis testing of each of the 3 sides of the aabb against each of the 3 sides of the triangle = 9 axis of separation
        // axis_ij = u_i x f_j (u0, u1, u2 = face normals of aabb = x,y,z axes vectors since aabb is axis aligned)
        let axes = [
            0,
            -$e07223619cf61cc6$var$_f0.z,
            $e07223619cf61cc6$var$_f0.y,
            0,
            -$e07223619cf61cc6$var$_f1.z,
            $e07223619cf61cc6$var$_f1.y,
            0,
            -$e07223619cf61cc6$var$_f2.z,
            $e07223619cf61cc6$var$_f2.y,
            $e07223619cf61cc6$var$_f0.z,
            0,
            -$e07223619cf61cc6$var$_f0.x,
            $e07223619cf61cc6$var$_f1.z,
            0,
            -$e07223619cf61cc6$var$_f1.x,
            $e07223619cf61cc6$var$_f2.z,
            0,
            -$e07223619cf61cc6$var$_f2.x,
            -$e07223619cf61cc6$var$_f0.y,
            $e07223619cf61cc6$var$_f0.x,
            0,
            -$e07223619cf61cc6$var$_f1.y,
            $e07223619cf61cc6$var$_f1.x,
            0,
            -$e07223619cf61cc6$var$_f2.y,
            $e07223619cf61cc6$var$_f2.x,
            0
        ];
        if (!$e07223619cf61cc6$var$satForAxes(axes, $e07223619cf61cc6$var$_v0, $e07223619cf61cc6$var$_v1, $e07223619cf61cc6$var$_v2, $e07223619cf61cc6$var$_extents)) return false;
        // test 3 face normals from the aabb
        axes = [
            1,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            1
        ];
        if (!$e07223619cf61cc6$var$satForAxes(axes, $e07223619cf61cc6$var$_v0, $e07223619cf61cc6$var$_v1, $e07223619cf61cc6$var$_v2, $e07223619cf61cc6$var$_extents)) return false;
        // finally testing the face normal of the triangle
        // use already existing triangle edge vectors here
        $e07223619cf61cc6$var$_triangleNormal.crossVectors($e07223619cf61cc6$var$_f0, $e07223619cf61cc6$var$_f1);
        axes = [
            $e07223619cf61cc6$var$_triangleNormal.x,
            $e07223619cf61cc6$var$_triangleNormal.y,
            $e07223619cf61cc6$var$_triangleNormal.z
        ];
        return $e07223619cf61cc6$var$satForAxes(axes, $e07223619cf61cc6$var$_v0, $e07223619cf61cc6$var$_v1, $e07223619cf61cc6$var$_v2, $e07223619cf61cc6$var$_extents);
    }
    clampPoint(point, target) {
        return target.copy(point).clamp(this.min, this.max);
    }
    distanceToPoint(point) {
        return this.clampPoint(point, $e07223619cf61cc6$var$_vector).distanceTo(point);
    }
    getBoundingSphere(target) {
        if (this.isEmpty()) target.makeEmpty();
        else {
            this.getCenter(target.center);
            target.radius = this.getSize($e07223619cf61cc6$var$_vector).length() * 0.5;
        }
        return target;
    }
    intersect(box) {
        this.min.max(box.min);
        this.max.min(box.max);
        // ensure that if there is no overlap, the result is fully empty, not slightly empty with non-inf/+inf values that will cause subsequence intersects to erroneously return valid values.
        if (this.isEmpty()) this.makeEmpty();
        return this;
    }
    union(box) {
        this.min.min(box.min);
        this.max.max(box.max);
        return this;
    }
    applyMatrix4(matrix) {
        // transform of empty box is an empty box.
        if (this.isEmpty()) return this;
        // NOTE: I am using a binary pattern to specify all 2^3 combinations below
        $e07223619cf61cc6$var$_points[0].set(this.min.x, this.min.y, this.min.z).applyMatrix4(matrix); // 000
        $e07223619cf61cc6$var$_points[1].set(this.min.x, this.min.y, this.max.z).applyMatrix4(matrix); // 001
        $e07223619cf61cc6$var$_points[2].set(this.min.x, this.max.y, this.min.z).applyMatrix4(matrix); // 010
        $e07223619cf61cc6$var$_points[3].set(this.min.x, this.max.y, this.max.z).applyMatrix4(matrix); // 011
        $e07223619cf61cc6$var$_points[4].set(this.max.x, this.min.y, this.min.z).applyMatrix4(matrix); // 100
        $e07223619cf61cc6$var$_points[5].set(this.max.x, this.min.y, this.max.z).applyMatrix4(matrix); // 101
        $e07223619cf61cc6$var$_points[6].set(this.max.x, this.max.y, this.min.z).applyMatrix4(matrix); // 110
        $e07223619cf61cc6$var$_points[7].set(this.max.x, this.max.y, this.max.z).applyMatrix4(matrix); // 111
        this.setFromPoints($e07223619cf61cc6$var$_points);
        return this;
    }
    translate(offset) {
        this.min.add(offset);
        this.max.add(offset);
        return this;
    }
    equals(box) {
        return box.min.equals(this.min) && box.max.equals(this.max);
    }
}
const $e07223619cf61cc6$var$_points = [
    /*@__PURE__*/ new (0, $d7d0ac0e47013885$export$64b5c384219d3699)(),
    /*@__PURE__*/ new (0, $d7d0ac0e47013885$export$64b5c384219d3699)(),
    /*@__PURE__*/ new (0, $d7d0ac0e47013885$export$64b5c384219d3699)(),
    /*@__PURE__*/ new (0, $d7d0ac0e47013885$export$64b5c384219d3699)(),
    /*@__PURE__*/ new (0, $d7d0ac0e47013885$export$64b5c384219d3699)(),
    /*@__PURE__*/ new (0, $d7d0ac0e47013885$export$64b5c384219d3699)(),
    /*@__PURE__*/ new (0, $d7d0ac0e47013885$export$64b5c384219d3699)(),
    /*@__PURE__*/ new (0, $d7d0ac0e47013885$export$64b5c384219d3699)()
];
const $e07223619cf61cc6$var$_vector = /*@__PURE__*/ new (0, $d7d0ac0e47013885$export$64b5c384219d3699)();
const $e07223619cf61cc6$var$_box = /*@__PURE__*/ new $e07223619cf61cc6$export$6f7d5a9418ab2aa3();
// triangle centered vertices
const $e07223619cf61cc6$var$_v0 = /*@__PURE__*/ new (0, $d7d0ac0e47013885$export$64b5c384219d3699)();
const $e07223619cf61cc6$var$_v1 = /*@__PURE__*/ new (0, $d7d0ac0e47013885$export$64b5c384219d3699)();
const $e07223619cf61cc6$var$_v2 = /*@__PURE__*/ new (0, $d7d0ac0e47013885$export$64b5c384219d3699)();
// triangle edge vectors
const $e07223619cf61cc6$var$_f0 = /*@__PURE__*/ new (0, $d7d0ac0e47013885$export$64b5c384219d3699)();
const $e07223619cf61cc6$var$_f1 = /*@__PURE__*/ new (0, $d7d0ac0e47013885$export$64b5c384219d3699)();
const $e07223619cf61cc6$var$_f2 = /*@__PURE__*/ new (0, $d7d0ac0e47013885$export$64b5c384219d3699)();
const $e07223619cf61cc6$var$_center = /*@__PURE__*/ new (0, $d7d0ac0e47013885$export$64b5c384219d3699)();
const $e07223619cf61cc6$var$_extents = /*@__PURE__*/ new (0, $d7d0ac0e47013885$export$64b5c384219d3699)();
const $e07223619cf61cc6$var$_triangleNormal = /*@__PURE__*/ new (0, $d7d0ac0e47013885$export$64b5c384219d3699)();
const $e07223619cf61cc6$var$_testAxis = /*@__PURE__*/ new (0, $d7d0ac0e47013885$export$64b5c384219d3699)();
function $e07223619cf61cc6$var$satForAxes(axes, v0, v1, v2, extents) {
    for(let i = 0, j = axes.length - 3; i <= j; i += 3){
        $e07223619cf61cc6$var$_testAxis.fromArray(axes, i);
        // project the aabb onto the separating axis
        const r = extents.x * Math.abs($e07223619cf61cc6$var$_testAxis.x) + extents.y * Math.abs($e07223619cf61cc6$var$_testAxis.y) + extents.z * Math.abs($e07223619cf61cc6$var$_testAxis.z);
        // project all 3 vertices of the triangle onto the separating axis
        const p0 = v0.dot($e07223619cf61cc6$var$_testAxis);
        const p1 = v1.dot($e07223619cf61cc6$var$_testAxis);
        const p2 = v2.dot($e07223619cf61cc6$var$_testAxis);
        // actual test, basically see if either of the most extreme of the triangle points intersects r
        if (Math.max(-Math.max(p0, p1, p2), Math.min(p0, p1, p2)) > r) // points of the projected triangle are outside the projected half-length of the aabb
        // the axis is separating and we can exit
        return false;
    }
    return true;
}






const $f029c986fd3c8d57$var$_box = /*@__PURE__*/ new (0, $e07223619cf61cc6$export$6f7d5a9418ab2aa3)();
const $f029c986fd3c8d57$var$_v1 = /*@__PURE__*/ new (0, $d7d0ac0e47013885$export$64b5c384219d3699)();
const $f029c986fd3c8d57$var$_v2 = /*@__PURE__*/ new (0, $d7d0ac0e47013885$export$64b5c384219d3699)();
class $f029c986fd3c8d57$export$805e8b72413ccaba {
    constructor(center = new (0, $d7d0ac0e47013885$export$64b5c384219d3699)(), radius = -1){
        this.isSphere = true;
        this.center = center;
        this.radius = radius;
    }
    set(center, radius) {
        this.center.copy(center);
        this.radius = radius;
        return this;
    }
    setFromPoints(points, optionalCenter) {
        const center = this.center;
        if (optionalCenter !== undefined) center.copy(optionalCenter);
        else $f029c986fd3c8d57$var$_box.setFromPoints(points).getCenter(center);
        let maxRadiusSq = 0;
        for(let i = 0, il = points.length; i < il; i++)maxRadiusSq = Math.max(maxRadiusSq, center.distanceToSquared(points[i]));
        this.radius = Math.sqrt(maxRadiusSq);
        return this;
    }
    copy(sphere) {
        this.center.copy(sphere.center);
        this.radius = sphere.radius;
        return this;
    }
    isEmpty() {
        return this.radius < 0;
    }
    makeEmpty() {
        this.center.set(0, 0, 0);
        this.radius = -1;
        return this;
    }
    containsPoint(point) {
        return point.distanceToSquared(this.center) <= this.radius * this.radius;
    }
    distanceToPoint(point) {
        return point.distanceTo(this.center) - this.radius;
    }
    intersectsSphere(sphere) {
        const radiusSum = this.radius + sphere.radius;
        return sphere.center.distanceToSquared(this.center) <= radiusSum * radiusSum;
    }
    intersectsBox(box) {
        return box.intersectsSphere(this);
    }
    intersectsPlane(plane) {
        return Math.abs(plane.distanceToPoint(this.center)) <= this.radius;
    }
    clampPoint(point, target) {
        const deltaLengthSq = this.center.distanceToSquared(point);
        target.copy(point);
        if (deltaLengthSq > this.radius * this.radius) {
            target.sub(this.center).normalize();
            target.multiplyScalar(this.radius).add(this.center);
        }
        return target;
    }
    getBoundingBox(target) {
        if (this.isEmpty()) {
            // Empty sphere produces empty bounding box
            target.makeEmpty();
            return target;
        }
        target.set(this.center, this.center);
        target.expandByScalar(this.radius);
        return target;
    }
    applyMatrix4(matrix) {
        this.center.applyMatrix4(matrix);
        this.radius = this.radius * matrix.getMaxScaleOnAxis();
        return this;
    }
    translate(offset) {
        this.center.add(offset);
        return this;
    }
    expandByPoint(point) {
        if (this.isEmpty()) {
            this.center.copy(point);
            this.radius = 0;
            return this;
        }
        $f029c986fd3c8d57$var$_v1.subVectors(point, this.center);
        const lengthSq = $f029c986fd3c8d57$var$_v1.lengthSq();
        if (lengthSq > this.radius * this.radius) {
            // calculate the minimal sphere
            const length = Math.sqrt(lengthSq);
            const delta = (length - this.radius) * 0.5;
            this.center.addScaledVector($f029c986fd3c8d57$var$_v1, delta / length);
            this.radius += delta;
        }
        return this;
    }
    union(sphere) {
        if (sphere.isEmpty()) return this;
        if (this.isEmpty()) {
            this.copy(sphere);
            return this;
        }
        if (this.center.equals(sphere.center) === true) this.radius = Math.max(this.radius, sphere.radius);
        else {
            $f029c986fd3c8d57$var$_v2.subVectors(sphere.center, this.center).setLength(sphere.radius);
            this.expandByPoint($f029c986fd3c8d57$var$_v1.copy(sphere.center).add($f029c986fd3c8d57$var$_v2));
            this.expandByPoint($f029c986fd3c8d57$var$_v1.copy(sphere.center).sub($f029c986fd3c8d57$var$_v2));
        }
        return this;
    }
    equals(sphere) {
        return sphere.center.equals(this.center) && sphere.radius === this.radius;
    }
    clone() {
        return new this.constructor().copy(this);
    }
}







let $b7aea261c5c9a899$var$_id = 0;
const $b7aea261c5c9a899$var$_m1 = /*@__PURE__*/ new (0, $0ea09116adcadf95$export$2ae72fc923e5eb5)();
const $b7aea261c5c9a899$var$_obj = /*@__PURE__*/ new (0, $2894733dde59bc41$export$e4dd07dff30cc924)();
const $b7aea261c5c9a899$var$_offset = /*@__PURE__*/ new (0, $d7d0ac0e47013885$export$64b5c384219d3699)();
const $b7aea261c5c9a899$var$_box = /*@__PURE__*/ new (0, $e07223619cf61cc6$export$6f7d5a9418ab2aa3)();
const $b7aea261c5c9a899$var$_boxMorphTargets = /*@__PURE__*/ new (0, $e07223619cf61cc6$export$6f7d5a9418ab2aa3)();
const $b7aea261c5c9a899$var$_vector = /*@__PURE__*/ new (0, $d7d0ac0e47013885$export$64b5c384219d3699)();
class $b7aea261c5c9a899$export$b7be63a67df8959 extends (0, $a35132d5d9375da3$export$ec8b666c5fe2c75a) {
    constructor(){
        super();
        this.isBufferGeometry = true;
        Object.defineProperty(this, 'id', {
            value: $b7aea261c5c9a899$var$_id++
        });
        this.uuid = $7f727a3c7059d20d$export$e73c8bd0f20705a();
        this.name = '';
        this.type = 'BufferGeometry';
        this.index = null;
        this.indirect = null;
        this.attributes = {};
        this.morphAttributes = {};
        this.morphTargetsRelative = false;
        this.groups = [];
        this.boundingBox = null;
        this.boundingSphere = null;
        this.drawRange = {
            start: 0,
            count: Infinity
        };
        this.userData = {};
    }
    getIndex() {
        return this.index;
    }
    setIndex(index) {
        if (Array.isArray(index)) this.index = new ((0, $d93c9776005e33ec$export$bc6f937da07eae17)(index) ? (0, $4b03383e684869fb$export$7eb8c9fa25cd5bd6) : (0, $4b03383e684869fb$export$640a853f68025f2e))(index, 1);
        else this.index = index;
        return this;
    }
    setIndirect(indirect) {
        this.indirect = indirect;
        return this;
    }
    getIndirect() {
        return this.indirect;
    }
    getAttribute(name) {
        return this.attributes[name];
    }
    setAttribute(name, attribute) {
        this.attributes[name] = attribute;
        return this;
    }
    deleteAttribute(name) {
        delete this.attributes[name];
        return this;
    }
    hasAttribute(name) {
        return this.attributes[name] !== undefined;
    }
    addGroup(start, count, materialIndex = 0) {
        this.groups.push({
            start: start,
            count: count,
            materialIndex: materialIndex
        });
    }
    clearGroups() {
        this.groups = [];
    }
    setDrawRange(start, count) {
        this.drawRange.start = start;
        this.drawRange.count = count;
    }
    applyMatrix4(matrix) {
        const position = this.attributes.position;
        if (position !== undefined) {
            position.applyMatrix4(matrix);
            position.needsUpdate = true;
        }
        const normal = this.attributes.normal;
        if (normal !== undefined) {
            const normalMatrix = new (0, $800ed18490319df2$export$8ff26dafa08918)().getNormalMatrix(matrix);
            normal.applyNormalMatrix(normalMatrix);
            normal.needsUpdate = true;
        }
        const tangent = this.attributes.tangent;
        if (tangent !== undefined) {
            tangent.transformDirection(matrix);
            tangent.needsUpdate = true;
        }
        if (this.boundingBox !== null) this.computeBoundingBox();
        if (this.boundingSphere !== null) this.computeBoundingSphere();
        return this;
    }
    applyQuaternion(q) {
        $b7aea261c5c9a899$var$_m1.makeRotationFromQuaternion(q);
        this.applyMatrix4($b7aea261c5c9a899$var$_m1);
        return this;
    }
    rotateX(angle) {
        // rotate geometry around world x-axis
        $b7aea261c5c9a899$var$_m1.makeRotationX(angle);
        this.applyMatrix4($b7aea261c5c9a899$var$_m1);
        return this;
    }
    rotateY(angle) {
        // rotate geometry around world y-axis
        $b7aea261c5c9a899$var$_m1.makeRotationY(angle);
        this.applyMatrix4($b7aea261c5c9a899$var$_m1);
        return this;
    }
    rotateZ(angle) {
        // rotate geometry around world z-axis
        $b7aea261c5c9a899$var$_m1.makeRotationZ(angle);
        this.applyMatrix4($b7aea261c5c9a899$var$_m1);
        return this;
    }
    translate(x, y, z) {
        // translate geometry
        $b7aea261c5c9a899$var$_m1.makeTranslation(x, y, z);
        this.applyMatrix4($b7aea261c5c9a899$var$_m1);
        return this;
    }
    scale(x, y, z) {
        // scale geometry
        $b7aea261c5c9a899$var$_m1.makeScale(x, y, z);
        this.applyMatrix4($b7aea261c5c9a899$var$_m1);
        return this;
    }
    lookAt(vector) {
        $b7aea261c5c9a899$var$_obj.lookAt(vector);
        $b7aea261c5c9a899$var$_obj.updateMatrix();
        this.applyMatrix4($b7aea261c5c9a899$var$_obj.matrix);
        return this;
    }
    center() {
        this.computeBoundingBox();
        this.boundingBox.getCenter($b7aea261c5c9a899$var$_offset).negate();
        this.translate($b7aea261c5c9a899$var$_offset.x, $b7aea261c5c9a899$var$_offset.y, $b7aea261c5c9a899$var$_offset.z);
        return this;
    }
    setFromPoints(points) {
        const positionAttribute = this.getAttribute('position');
        if (positionAttribute === undefined) {
            const position = [];
            for(let i = 0, l = points.length; i < l; i++){
                const point = points[i];
                position.push(point.x, point.y, point.z || 0);
            }
            this.setAttribute('position', new (0, $4b03383e684869fb$export$cbe7a62641830ebd)(position, 3));
        } else {
            for(let i = 0, l = positionAttribute.count; i < l; i++){
                const point = points[i];
                positionAttribute.setXYZ(i, point.x, point.y, point.z || 0);
            }
            if (points.length > positionAttribute.count) console.warn('THREE.BufferGeometry: Buffer size too small for points data. Use .dispose() and create a new geometry.');
            positionAttribute.needsUpdate = true;
        }
        return this;
    }
    computeBoundingBox() {
        if (this.boundingBox === null) this.boundingBox = new (0, $e07223619cf61cc6$export$6f7d5a9418ab2aa3)();
        const position = this.attributes.position;
        const morphAttributesPosition = this.morphAttributes.position;
        if (position && position.isGLBufferAttribute) {
            console.error('THREE.BufferGeometry.computeBoundingBox(): GLBufferAttribute requires a manual bounding box.', this);
            this.boundingBox.set(new (0, $d7d0ac0e47013885$export$64b5c384219d3699)(-Infinity, -Infinity, -Infinity), new (0, $d7d0ac0e47013885$export$64b5c384219d3699)(Infinity, Infinity, Infinity));
            return;
        }
        if (position !== undefined) {
            this.boundingBox.setFromBufferAttribute(position);
            // process morph attributes if present
            if (morphAttributesPosition) for(let i = 0, il = morphAttributesPosition.length; i < il; i++){
                const morphAttribute = morphAttributesPosition[i];
                $b7aea261c5c9a899$var$_box.setFromBufferAttribute(morphAttribute);
                if (this.morphTargetsRelative) {
                    $b7aea261c5c9a899$var$_vector.addVectors(this.boundingBox.min, $b7aea261c5c9a899$var$_box.min);
                    this.boundingBox.expandByPoint($b7aea261c5c9a899$var$_vector);
                    $b7aea261c5c9a899$var$_vector.addVectors(this.boundingBox.max, $b7aea261c5c9a899$var$_box.max);
                    this.boundingBox.expandByPoint($b7aea261c5c9a899$var$_vector);
                } else {
                    this.boundingBox.expandByPoint($b7aea261c5c9a899$var$_box.min);
                    this.boundingBox.expandByPoint($b7aea261c5c9a899$var$_box.max);
                }
            }
        } else this.boundingBox.makeEmpty();
        if (isNaN(this.boundingBox.min.x) || isNaN(this.boundingBox.min.y) || isNaN(this.boundingBox.min.z)) console.error('THREE.BufferGeometry.computeBoundingBox(): Computed min/max have NaN values. The "position" attribute is likely to have NaN values.', this);
    }
    computeBoundingSphere() {
        if (this.boundingSphere === null) this.boundingSphere = new (0, $f029c986fd3c8d57$export$805e8b72413ccaba)();
        const position = this.attributes.position;
        const morphAttributesPosition = this.morphAttributes.position;
        if (position && position.isGLBufferAttribute) {
            console.error('THREE.BufferGeometry.computeBoundingSphere(): GLBufferAttribute requires a manual bounding sphere.', this);
            this.boundingSphere.set(new (0, $d7d0ac0e47013885$export$64b5c384219d3699)(), Infinity);
            return;
        }
        if (position) {
            // first, find the center of the bounding sphere
            const center = this.boundingSphere.center;
            $b7aea261c5c9a899$var$_box.setFromBufferAttribute(position);
            // process morph attributes if present
            if (morphAttributesPosition) for(let i = 0, il = morphAttributesPosition.length; i < il; i++){
                const morphAttribute = morphAttributesPosition[i];
                $b7aea261c5c9a899$var$_boxMorphTargets.setFromBufferAttribute(morphAttribute);
                if (this.morphTargetsRelative) {
                    $b7aea261c5c9a899$var$_vector.addVectors($b7aea261c5c9a899$var$_box.min, $b7aea261c5c9a899$var$_boxMorphTargets.min);
                    $b7aea261c5c9a899$var$_box.expandByPoint($b7aea261c5c9a899$var$_vector);
                    $b7aea261c5c9a899$var$_vector.addVectors($b7aea261c5c9a899$var$_box.max, $b7aea261c5c9a899$var$_boxMorphTargets.max);
                    $b7aea261c5c9a899$var$_box.expandByPoint($b7aea261c5c9a899$var$_vector);
                } else {
                    $b7aea261c5c9a899$var$_box.expandByPoint($b7aea261c5c9a899$var$_boxMorphTargets.min);
                    $b7aea261c5c9a899$var$_box.expandByPoint($b7aea261c5c9a899$var$_boxMorphTargets.max);
                }
            }
            $b7aea261c5c9a899$var$_box.getCenter(center);
            // second, try to find a boundingSphere with a radius smaller than the
            // boundingSphere of the boundingBox: sqrt(3) smaller in the best case
            let maxRadiusSq = 0;
            for(let i = 0, il = position.count; i < il; i++){
                $b7aea261c5c9a899$var$_vector.fromBufferAttribute(position, i);
                maxRadiusSq = Math.max(maxRadiusSq, center.distanceToSquared($b7aea261c5c9a899$var$_vector));
            }
            // process morph attributes if present
            if (morphAttributesPosition) for(let i = 0, il = morphAttributesPosition.length; i < il; i++){
                const morphAttribute = morphAttributesPosition[i];
                const morphTargetsRelative = this.morphTargetsRelative;
                for(let j = 0, jl = morphAttribute.count; j < jl; j++){
                    $b7aea261c5c9a899$var$_vector.fromBufferAttribute(morphAttribute, j);
                    if (morphTargetsRelative) {
                        $b7aea261c5c9a899$var$_offset.fromBufferAttribute(position, j);
                        $b7aea261c5c9a899$var$_vector.add($b7aea261c5c9a899$var$_offset);
                    }
                    maxRadiusSq = Math.max(maxRadiusSq, center.distanceToSquared($b7aea261c5c9a899$var$_vector));
                }
            }
            this.boundingSphere.radius = Math.sqrt(maxRadiusSq);
            if (isNaN(this.boundingSphere.radius)) console.error('THREE.BufferGeometry.computeBoundingSphere(): Computed radius is NaN. The "position" attribute is likely to have NaN values.', this);
        }
    }
    computeTangents() {
        const index = this.index;
        const attributes = this.attributes;
        // based on http://www.terathon.com/code/tangent.html
        // (per vertex tangents)
        if (index === null || attributes.position === undefined || attributes.normal === undefined || attributes.uv === undefined) {
            console.error('THREE.BufferGeometry: .computeTangents() failed. Missing required attributes (index, position, normal or uv)');
            return;
        }
        const positionAttribute = attributes.position;
        const normalAttribute = attributes.normal;
        const uvAttribute = attributes.uv;
        if (this.hasAttribute('tangent') === false) this.setAttribute('tangent', new (0, $4b03383e684869fb$export$8dea267bd6bde117)(new Float32Array(4 * positionAttribute.count), 4));
        const tangentAttribute = this.getAttribute('tangent');
        const tan1 = [], tan2 = [];
        for(let i = 0; i < positionAttribute.count; i++){
            tan1[i] = new (0, $d7d0ac0e47013885$export$64b5c384219d3699)();
            tan2[i] = new (0, $d7d0ac0e47013885$export$64b5c384219d3699)();
        }
        const vA = new (0, $d7d0ac0e47013885$export$64b5c384219d3699)(), vB = new (0, $d7d0ac0e47013885$export$64b5c384219d3699)(), vC = new (0, $d7d0ac0e47013885$export$64b5c384219d3699)(), uvA = new (0, $3c03061dea0adea3$export$c977b3e384af9ae1)(), uvB = new (0, $3c03061dea0adea3$export$c977b3e384af9ae1)(), uvC = new (0, $3c03061dea0adea3$export$c977b3e384af9ae1)(), sdir = new (0, $d7d0ac0e47013885$export$64b5c384219d3699)(), tdir = new (0, $d7d0ac0e47013885$export$64b5c384219d3699)();
        function handleTriangle(a, b, c) {
            vA.fromBufferAttribute(positionAttribute, a);
            vB.fromBufferAttribute(positionAttribute, b);
            vC.fromBufferAttribute(positionAttribute, c);
            uvA.fromBufferAttribute(uvAttribute, a);
            uvB.fromBufferAttribute(uvAttribute, b);
            uvC.fromBufferAttribute(uvAttribute, c);
            vB.sub(vA);
            vC.sub(vA);
            uvB.sub(uvA);
            uvC.sub(uvA);
            const r = 1.0 / (uvB.x * uvC.y - uvC.x * uvB.y);
            // silently ignore degenerate uv triangles having coincident or colinear vertices
            if (!isFinite(r)) return;
            sdir.copy(vB).multiplyScalar(uvC.y).addScaledVector(vC, -uvB.y).multiplyScalar(r);
            tdir.copy(vC).multiplyScalar(uvB.x).addScaledVector(vB, -uvC.x).multiplyScalar(r);
            tan1[a].add(sdir);
            tan1[b].add(sdir);
            tan1[c].add(sdir);
            tan2[a].add(tdir);
            tan2[b].add(tdir);
            tan2[c].add(tdir);
        }
        let groups = this.groups;
        if (groups.length === 0) groups = [
            {
                start: 0,
                count: index.count
            }
        ];
        for(let i = 0, il = groups.length; i < il; ++i){
            const group = groups[i];
            const start = group.start;
            const count = group.count;
            for(let j = start, jl = start + count; j < jl; j += 3)handleTriangle(index.getX(j + 0), index.getX(j + 1), index.getX(j + 2));
        }
        const tmp = new (0, $d7d0ac0e47013885$export$64b5c384219d3699)(), tmp2 = new (0, $d7d0ac0e47013885$export$64b5c384219d3699)();
        const n = new (0, $d7d0ac0e47013885$export$64b5c384219d3699)(), n2 = new (0, $d7d0ac0e47013885$export$64b5c384219d3699)();
        function handleVertex(v) {
            n.fromBufferAttribute(normalAttribute, v);
            n2.copy(n);
            const t = tan1[v];
            // Gram-Schmidt orthogonalize
            tmp.copy(t);
            tmp.sub(n.multiplyScalar(n.dot(t))).normalize();
            // Calculate handedness
            tmp2.crossVectors(n2, t);
            const test = tmp2.dot(tan2[v]);
            const w = test < 0.0 ? -1 : 1.0;
            tangentAttribute.setXYZW(v, tmp.x, tmp.y, tmp.z, w);
        }
        for(let i = 0, il = groups.length; i < il; ++i){
            const group = groups[i];
            const start = group.start;
            const count = group.count;
            for(let j = start, jl = start + count; j < jl; j += 3){
                handleVertex(index.getX(j + 0));
                handleVertex(index.getX(j + 1));
                handleVertex(index.getX(j + 2));
            }
        }
    }
    computeVertexNormals() {
        const index = this.index;
        const positionAttribute = this.getAttribute('position');
        if (positionAttribute !== undefined) {
            let normalAttribute = this.getAttribute('normal');
            if (normalAttribute === undefined) {
                normalAttribute = new (0, $4b03383e684869fb$export$8dea267bd6bde117)(new Float32Array(positionAttribute.count * 3), 3);
                this.setAttribute('normal', normalAttribute);
            } else // reset existing normals to zero
            for(let i = 0, il = normalAttribute.count; i < il; i++)normalAttribute.setXYZ(i, 0, 0, 0);
            const pA = new (0, $d7d0ac0e47013885$export$64b5c384219d3699)(), pB = new (0, $d7d0ac0e47013885$export$64b5c384219d3699)(), pC = new (0, $d7d0ac0e47013885$export$64b5c384219d3699)();
            const nA = new (0, $d7d0ac0e47013885$export$64b5c384219d3699)(), nB = new (0, $d7d0ac0e47013885$export$64b5c384219d3699)(), nC = new (0, $d7d0ac0e47013885$export$64b5c384219d3699)();
            const cb = new (0, $d7d0ac0e47013885$export$64b5c384219d3699)(), ab = new (0, $d7d0ac0e47013885$export$64b5c384219d3699)();
            // indexed elements
            if (index) for(let i = 0, il = index.count; i < il; i += 3){
                const vA = index.getX(i + 0);
                const vB = index.getX(i + 1);
                const vC = index.getX(i + 2);
                pA.fromBufferAttribute(positionAttribute, vA);
                pB.fromBufferAttribute(positionAttribute, vB);
                pC.fromBufferAttribute(positionAttribute, vC);
                cb.subVectors(pC, pB);
                ab.subVectors(pA, pB);
                cb.cross(ab);
                nA.fromBufferAttribute(normalAttribute, vA);
                nB.fromBufferAttribute(normalAttribute, vB);
                nC.fromBufferAttribute(normalAttribute, vC);
                nA.add(cb);
                nB.add(cb);
                nC.add(cb);
                normalAttribute.setXYZ(vA, nA.x, nA.y, nA.z);
                normalAttribute.setXYZ(vB, nB.x, nB.y, nB.z);
                normalAttribute.setXYZ(vC, nC.x, nC.y, nC.z);
            }
            else // non-indexed elements (unconnected triangle soup)
            for(let i = 0, il = positionAttribute.count; i < il; i += 3){
                pA.fromBufferAttribute(positionAttribute, i + 0);
                pB.fromBufferAttribute(positionAttribute, i + 1);
                pC.fromBufferAttribute(positionAttribute, i + 2);
                cb.subVectors(pC, pB);
                ab.subVectors(pA, pB);
                cb.cross(ab);
                normalAttribute.setXYZ(i + 0, cb.x, cb.y, cb.z);
                normalAttribute.setXYZ(i + 1, cb.x, cb.y, cb.z);
                normalAttribute.setXYZ(i + 2, cb.x, cb.y, cb.z);
            }
            this.normalizeNormals();
            normalAttribute.needsUpdate = true;
        }
    }
    normalizeNormals() {
        const normals = this.attributes.normal;
        for(let i = 0, il = normals.count; i < il; i++){
            $b7aea261c5c9a899$var$_vector.fromBufferAttribute(normals, i);
            $b7aea261c5c9a899$var$_vector.normalize();
            normals.setXYZ(i, $b7aea261c5c9a899$var$_vector.x, $b7aea261c5c9a899$var$_vector.y, $b7aea261c5c9a899$var$_vector.z);
        }
    }
    toNonIndexed() {
        function convertBufferAttribute(attribute, indices) {
            const array = attribute.array;
            const itemSize = attribute.itemSize;
            const normalized = attribute.normalized;
            const array2 = new array.constructor(indices.length * itemSize);
            let index = 0, index2 = 0;
            for(let i = 0, l = indices.length; i < l; i++){
                if (attribute.isInterleavedBufferAttribute) index = indices[i] * attribute.data.stride + attribute.offset;
                else index = indices[i] * itemSize;
                for(let j = 0; j < itemSize; j++)array2[index2++] = array[index++];
            }
            return new (0, $4b03383e684869fb$export$8dea267bd6bde117)(array2, itemSize, normalized);
        }
        //
        if (this.index === null) {
            console.warn('THREE.BufferGeometry.toNonIndexed(): BufferGeometry is already non-indexed.');
            return this;
        }
        const geometry2 = new $b7aea261c5c9a899$export$b7be63a67df8959();
        const indices = this.index.array;
        const attributes = this.attributes;
        // attributes
        for(const name in attributes){
            const attribute = attributes[name];
            const newAttribute = convertBufferAttribute(attribute, indices);
            geometry2.setAttribute(name, newAttribute);
        }
        // morph attributes
        const morphAttributes = this.morphAttributes;
        for(const name in morphAttributes){
            const morphArray = [];
            const morphAttribute = morphAttributes[name]; // morphAttribute: array of Float32BufferAttributes
            for(let i = 0, il = morphAttribute.length; i < il; i++){
                const attribute = morphAttribute[i];
                const newAttribute = convertBufferAttribute(attribute, indices);
                morphArray.push(newAttribute);
            }
            geometry2.morphAttributes[name] = morphArray;
        }
        geometry2.morphTargetsRelative = this.morphTargetsRelative;
        // groups
        const groups = this.groups;
        for(let i = 0, l = groups.length; i < l; i++){
            const group = groups[i];
            geometry2.addGroup(group.start, group.count, group.materialIndex);
        }
        return geometry2;
    }
    toJSON() {
        const data = {
            metadata: {
                version: 4.6,
                type: 'BufferGeometry',
                generator: 'BufferGeometry.toJSON'
            }
        };
        // standard BufferGeometry serialization
        data.uuid = this.uuid;
        data.type = this.type;
        if (this.name !== '') data.name = this.name;
        if (Object.keys(this.userData).length > 0) data.userData = this.userData;
        if (this.parameters !== undefined) {
            const parameters = this.parameters;
            for(const key in parameters)if (parameters[key] !== undefined) data[key] = parameters[key];
            return data;
        }
        // for simplicity the code assumes attributes are not shared across geometries, see #15811
        data.data = {
            attributes: {}
        };
        const index = this.index;
        if (index !== null) data.data.index = {
            type: index.array.constructor.name,
            array: Array.prototype.slice.call(index.array)
        };
        const attributes = this.attributes;
        for(const key in attributes){
            const attribute = attributes[key];
            data.data.attributes[key] = attribute.toJSON(data.data);
        }
        const morphAttributes = {};
        let hasMorphAttributes = false;
        for(const key in this.morphAttributes){
            const attributeArray = this.morphAttributes[key];
            const array = [];
            for(let i = 0, il = attributeArray.length; i < il; i++){
                const attribute = attributeArray[i];
                array.push(attribute.toJSON(data.data));
            }
            if (array.length > 0) {
                morphAttributes[key] = array;
                hasMorphAttributes = true;
            }
        }
        if (hasMorphAttributes) {
            data.data.morphAttributes = morphAttributes;
            data.data.morphTargetsRelative = this.morphTargetsRelative;
        }
        const groups = this.groups;
        if (groups.length > 0) data.data.groups = JSON.parse(JSON.stringify(groups));
        const boundingSphere = this.boundingSphere;
        if (boundingSphere !== null) data.data.boundingSphere = {
            center: boundingSphere.center.toArray(),
            radius: boundingSphere.radius
        };
        return data;
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(source) {
        // reset
        this.index = null;
        this.attributes = {};
        this.morphAttributes = {};
        this.groups = [];
        this.boundingBox = null;
        this.boundingSphere = null;
        // used for storing cloned, shared data
        const data = {};
        // name
        this.name = source.name;
        // index
        const index = source.index;
        if (index !== null) this.setIndex(index.clone(data));
        // attributes
        const attributes = source.attributes;
        for(const name in attributes){
            const attribute = attributes[name];
            this.setAttribute(name, attribute.clone(data));
        }
        // morph attributes
        const morphAttributes = source.morphAttributes;
        for(const name in morphAttributes){
            const array = [];
            const morphAttribute = morphAttributes[name]; // morphAttribute: array of Float32BufferAttributes
            for(let i = 0, l = morphAttribute.length; i < l; i++)array.push(morphAttribute[i].clone(data));
            this.morphAttributes[name] = array;
        }
        this.morphTargetsRelative = source.morphTargetsRelative;
        // groups
        const groups = source.groups;
        for(let i = 0, l = groups.length; i < l; i++){
            const group = groups[i];
            this.addGroup(group.start, group.count, group.materialIndex);
        }
        // bounding box
        const boundingBox = source.boundingBox;
        if (boundingBox !== null) this.boundingBox = boundingBox.clone();
        // bounding sphere
        const boundingSphere = source.boundingSphere;
        if (boundingSphere !== null) this.boundingSphere = boundingSphere.clone();
        // draw range
        this.drawRange.start = source.drawRange.start;
        this.drawRange.count = source.drawRange.count;
        // user data
        this.userData = source.userData;
        return this;
    }
    dispose() {
        this.dispatchEvent({
            type: 'dispose'
        });
    }
}







const $64db0fa6818d6f42$var$_vector = /*@__PURE__*/ new (0, $d7d0ac0e47013885$export$64b5c384219d3699)();
const $64db0fa6818d6f42$var$_segCenter = /*@__PURE__*/ new (0, $d7d0ac0e47013885$export$64b5c384219d3699)();
const $64db0fa6818d6f42$var$_segDir = /*@__PURE__*/ new (0, $d7d0ac0e47013885$export$64b5c384219d3699)();
const $64db0fa6818d6f42$var$_diff = /*@__PURE__*/ new (0, $d7d0ac0e47013885$export$64b5c384219d3699)();
const $64db0fa6818d6f42$var$_edge1 = /*@__PURE__*/ new (0, $d7d0ac0e47013885$export$64b5c384219d3699)();
const $64db0fa6818d6f42$var$_edge2 = /*@__PURE__*/ new (0, $d7d0ac0e47013885$export$64b5c384219d3699)();
const $64db0fa6818d6f42$var$_normal = /*@__PURE__*/ new (0, $d7d0ac0e47013885$export$64b5c384219d3699)();
class $64db0fa6818d6f42$export$a186db52eed6d40e {
    constructor(origin = new (0, $d7d0ac0e47013885$export$64b5c384219d3699)(), direction = new (0, $d7d0ac0e47013885$export$64b5c384219d3699)(0, 0, -1)){
        this.origin = origin;
        this.direction = direction;
    }
    set(origin, direction) {
        this.origin.copy(origin);
        this.direction.copy(direction);
        return this;
    }
    copy(ray) {
        this.origin.copy(ray.origin);
        this.direction.copy(ray.direction);
        return this;
    }
    at(t, target) {
        return target.copy(this.origin).addScaledVector(this.direction, t);
    }
    lookAt(v) {
        this.direction.copy(v).sub(this.origin).normalize();
        return this;
    }
    recast(t) {
        this.origin.copy(this.at(t, $64db0fa6818d6f42$var$_vector));
        return this;
    }
    closestPointToPoint(point, target) {
        target.subVectors(point, this.origin);
        const directionDistance = target.dot(this.direction);
        if (directionDistance < 0) return target.copy(this.origin);
        return target.copy(this.origin).addScaledVector(this.direction, directionDistance);
    }
    distanceToPoint(point) {
        return Math.sqrt(this.distanceSqToPoint(point));
    }
    distanceSqToPoint(point) {
        const directionDistance = $64db0fa6818d6f42$var$_vector.subVectors(point, this.origin).dot(this.direction);
        // point behind the ray
        if (directionDistance < 0) return this.origin.distanceToSquared(point);
        $64db0fa6818d6f42$var$_vector.copy(this.origin).addScaledVector(this.direction, directionDistance);
        return $64db0fa6818d6f42$var$_vector.distanceToSquared(point);
    }
    distanceSqToSegment(v0, v1, optionalPointOnRay, optionalPointOnSegment) {
        // from https://github.com/pmjoniak/GeometricTools/blob/master/GTEngine/Include/Mathematics/GteDistRaySegment.h
        // It returns the min distance between the ray and the segment
        // defined by v0 and v1
        // It can also set two optional targets :
        // - The closest point on the ray
        // - The closest point on the segment
        $64db0fa6818d6f42$var$_segCenter.copy(v0).add(v1).multiplyScalar(0.5);
        $64db0fa6818d6f42$var$_segDir.copy(v1).sub(v0).normalize();
        $64db0fa6818d6f42$var$_diff.copy(this.origin).sub($64db0fa6818d6f42$var$_segCenter);
        const segExtent = v0.distanceTo(v1) * 0.5;
        const a01 = -this.direction.dot($64db0fa6818d6f42$var$_segDir);
        const b0 = $64db0fa6818d6f42$var$_diff.dot(this.direction);
        const b1 = -$64db0fa6818d6f42$var$_diff.dot($64db0fa6818d6f42$var$_segDir);
        const c = $64db0fa6818d6f42$var$_diff.lengthSq();
        const det = Math.abs(1 - a01 * a01);
        let s0, s1, sqrDist, extDet;
        if (det > 0) {
            // The ray and segment are not parallel.
            s0 = a01 * b1 - b0;
            s1 = a01 * b0 - b1;
            extDet = segExtent * det;
            if (s0 >= 0) {
                if (s1 >= -extDet) {
                    if (s1 <= extDet) {
                        // region 0
                        // Minimum at interior points of ray and segment.
                        const invDet = 1 / det;
                        s0 *= invDet;
                        s1 *= invDet;
                        sqrDist = s0 * (s0 + a01 * s1 + 2 * b0) + s1 * (a01 * s0 + s1 + 2 * b1) + c;
                    } else {
                        // region 1
                        s1 = segExtent;
                        s0 = Math.max(0, -(a01 * s1 + b0));
                        sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
                    }
                } else {
                    // region 5
                    s1 = -segExtent;
                    s0 = Math.max(0, -(a01 * s1 + b0));
                    sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
                }
            } else {
                if (s1 <= -extDet) {
                    // region 4
                    s0 = Math.max(0, -(-a01 * segExtent + b0));
                    s1 = s0 > 0 ? -segExtent : Math.min(Math.max(-segExtent, -b1), segExtent);
                    sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
                } else if (s1 <= extDet) {
                    // region 3
                    s0 = 0;
                    s1 = Math.min(Math.max(-segExtent, -b1), segExtent);
                    sqrDist = s1 * (s1 + 2 * b1) + c;
                } else {
                    // region 2
                    s0 = Math.max(0, -(a01 * segExtent + b0));
                    s1 = s0 > 0 ? segExtent : Math.min(Math.max(-segExtent, -b1), segExtent);
                    sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
                }
            }
        } else {
            // Ray and segment are parallel.
            s1 = a01 > 0 ? -segExtent : segExtent;
            s0 = Math.max(0, -(a01 * s1 + b0));
            sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
        }
        if (optionalPointOnRay) optionalPointOnRay.copy(this.origin).addScaledVector(this.direction, s0);
        if (optionalPointOnSegment) optionalPointOnSegment.copy($64db0fa6818d6f42$var$_segCenter).addScaledVector($64db0fa6818d6f42$var$_segDir, s1);
        return sqrDist;
    }
    intersectSphere(sphere, target) {
        $64db0fa6818d6f42$var$_vector.subVectors(sphere.center, this.origin);
        const tca = $64db0fa6818d6f42$var$_vector.dot(this.direction);
        const d2 = $64db0fa6818d6f42$var$_vector.dot($64db0fa6818d6f42$var$_vector) - tca * tca;
        const radius2 = sphere.radius * sphere.radius;
        if (d2 > radius2) return null;
        const thc = Math.sqrt(radius2 - d2);
        // t0 = first intersect point - entrance on front of sphere
        const t0 = tca - thc;
        // t1 = second intersect point - exit point on back of sphere
        const t1 = tca + thc;
        // test to see if t1 is behind the ray - if so, return null
        if (t1 < 0) return null;
        // test to see if t0 is behind the ray:
        // if it is, the ray is inside the sphere, so return the second exit point scaled by t1,
        // in order to always return an intersect point that is in front of the ray.
        if (t0 < 0) return this.at(t1, target);
        // else t0 is in front of the ray, so return the first collision point scaled by t0
        return this.at(t0, target);
    }
    intersectsSphere(sphere) {
        return this.distanceSqToPoint(sphere.center) <= sphere.radius * sphere.radius;
    }
    distanceToPlane(plane) {
        const denominator = plane.normal.dot(this.direction);
        if (denominator === 0) {
            // line is coplanar, return origin
            if (plane.distanceToPoint(this.origin) === 0) return 0;
            // Null is preferable to undefined since undefined means.... it is undefined
            return null;
        }
        const t = -(this.origin.dot(plane.normal) + plane.constant) / denominator;
        // Return if the ray never intersects the plane
        return t >= 0 ? t : null;
    }
    intersectPlane(plane, target) {
        const t = this.distanceToPlane(plane);
        if (t === null) return null;
        return this.at(t, target);
    }
    intersectsPlane(plane) {
        // check if the ray lies on the plane first
        const distToPoint = plane.distanceToPoint(this.origin);
        if (distToPoint === 0) return true;
        const denominator = plane.normal.dot(this.direction);
        if (denominator * distToPoint < 0) return true;
        // ray origin is behind the plane (and is pointing behind it)
        return false;
    }
    intersectBox(box, target) {
        let tmin, tmax, tymin, tymax, tzmin, tzmax;
        const invdirx = 1 / this.direction.x, invdiry = 1 / this.direction.y, invdirz = 1 / this.direction.z;
        const origin = this.origin;
        if (invdirx >= 0) {
            tmin = (box.min.x - origin.x) * invdirx;
            tmax = (box.max.x - origin.x) * invdirx;
        } else {
            tmin = (box.max.x - origin.x) * invdirx;
            tmax = (box.min.x - origin.x) * invdirx;
        }
        if (invdiry >= 0) {
            tymin = (box.min.y - origin.y) * invdiry;
            tymax = (box.max.y - origin.y) * invdiry;
        } else {
            tymin = (box.max.y - origin.y) * invdiry;
            tymax = (box.min.y - origin.y) * invdiry;
        }
        if (tmin > tymax || tymin > tmax) return null;
        if (tymin > tmin || isNaN(tmin)) tmin = tymin;
        if (tymax < tmax || isNaN(tmax)) tmax = tymax;
        if (invdirz >= 0) {
            tzmin = (box.min.z - origin.z) * invdirz;
            tzmax = (box.max.z - origin.z) * invdirz;
        } else {
            tzmin = (box.max.z - origin.z) * invdirz;
            tzmax = (box.min.z - origin.z) * invdirz;
        }
        if (tmin > tzmax || tzmin > tmax) return null;
        if (tzmin > tmin || tmin !== tmin) tmin = tzmin;
        if (tzmax < tmax || tmax !== tmax) tmax = tzmax;
        //return point closest to the ray (positive side)
        if (tmax < 0) return null;
        return this.at(tmin >= 0 ? tmin : tmax, target);
    }
    intersectsBox(box) {
        return this.intersectBox(box, $64db0fa6818d6f42$var$_vector) !== null;
    }
    intersectTriangle(a, b, c, backfaceCulling, target) {
        // Compute the offset origin, edges, and normal.
        // from https://github.com/pmjoniak/GeometricTools/blob/master/GTEngine/Include/Mathematics/GteIntrRay3Triangle3.h
        $64db0fa6818d6f42$var$_edge1.subVectors(b, a);
        $64db0fa6818d6f42$var$_edge2.subVectors(c, a);
        $64db0fa6818d6f42$var$_normal.crossVectors($64db0fa6818d6f42$var$_edge1, $64db0fa6818d6f42$var$_edge2);
        // Solve Q + t*D = b1*E1 + b2*E2 (Q = kDiff, D = ray direction,
        // E1 = kEdge1, E2 = kEdge2, N = Cross(E1,E2)) by
        //   |Dot(D,N)|*b1 = sign(Dot(D,N))*Dot(D,Cross(Q,E2))
        //   |Dot(D,N)|*b2 = sign(Dot(D,N))*Dot(D,Cross(E1,Q))
        //   |Dot(D,N)|*t = -sign(Dot(D,N))*Dot(Q,N)
        let DdN = this.direction.dot($64db0fa6818d6f42$var$_normal);
        let sign;
        if (DdN > 0) {
            if (backfaceCulling) return null;
            sign = 1;
        } else if (DdN < 0) {
            sign = -1;
            DdN = -DdN;
        } else return null;
        $64db0fa6818d6f42$var$_diff.subVectors(this.origin, a);
        const DdQxE2 = sign * this.direction.dot($64db0fa6818d6f42$var$_edge2.crossVectors($64db0fa6818d6f42$var$_diff, $64db0fa6818d6f42$var$_edge2));
        // b1 < 0, no intersection
        if (DdQxE2 < 0) return null;
        const DdE1xQ = sign * this.direction.dot($64db0fa6818d6f42$var$_edge1.cross($64db0fa6818d6f42$var$_diff));
        // b2 < 0, no intersection
        if (DdE1xQ < 0) return null;
        // b1+b2 > 1, no intersection
        if (DdQxE2 + DdE1xQ > DdN) return null;
        // Line intersects triangle, check if ray does.
        const QdN = -sign * $64db0fa6818d6f42$var$_diff.dot($64db0fa6818d6f42$var$_normal);
        // t < 0, no intersection
        if (QdN < 0) return null;
        // Ray intersects triangle.
        return this.at(QdN / DdN, target);
    }
    applyMatrix4(matrix4) {
        this.origin.applyMatrix4(matrix4);
        this.direction.transformDirection(matrix4);
        return this;
    }
    equals(ray) {
        return ray.origin.equals(this.origin) && ray.direction.equals(this.direction);
    }
    clone() {
        return new this.constructor().copy(this);
    }
}






const $2186453604604e6c$var$_v0 = /*@__PURE__*/ new (0, $d7d0ac0e47013885$export$64b5c384219d3699)();
const $2186453604604e6c$var$_v1 = /*@__PURE__*/ new (0, $d7d0ac0e47013885$export$64b5c384219d3699)();
const $2186453604604e6c$var$_v2 = /*@__PURE__*/ new (0, $d7d0ac0e47013885$export$64b5c384219d3699)();
const $2186453604604e6c$var$_v3 = /*@__PURE__*/ new (0, $d7d0ac0e47013885$export$64b5c384219d3699)();
const $2186453604604e6c$var$_vab = /*@__PURE__*/ new (0, $d7d0ac0e47013885$export$64b5c384219d3699)();
const $2186453604604e6c$var$_vac = /*@__PURE__*/ new (0, $d7d0ac0e47013885$export$64b5c384219d3699)();
const $2186453604604e6c$var$_vbc = /*@__PURE__*/ new (0, $d7d0ac0e47013885$export$64b5c384219d3699)();
const $2186453604604e6c$var$_vap = /*@__PURE__*/ new (0, $d7d0ac0e47013885$export$64b5c384219d3699)();
const $2186453604604e6c$var$_vbp = /*@__PURE__*/ new (0, $d7d0ac0e47013885$export$64b5c384219d3699)();
const $2186453604604e6c$var$_vcp = /*@__PURE__*/ new (0, $d7d0ac0e47013885$export$64b5c384219d3699)();
const $2186453604604e6c$var$_v40 = /*@__PURE__*/ new (0, $a09a15e9a8421204$export$fa7daccca11cdbe3)();
const $2186453604604e6c$var$_v41 = /*@__PURE__*/ new (0, $a09a15e9a8421204$export$fa7daccca11cdbe3)();
const $2186453604604e6c$var$_v42 = /*@__PURE__*/ new (0, $a09a15e9a8421204$export$fa7daccca11cdbe3)();
class $2186453604604e6c$export$5a465592bfe74b48 {
    constructor(a = new (0, $d7d0ac0e47013885$export$64b5c384219d3699)(), b = new (0, $d7d0ac0e47013885$export$64b5c384219d3699)(), c = new (0, $d7d0ac0e47013885$export$64b5c384219d3699)()){
        this.a = a;
        this.b = b;
        this.c = c;
    }
    static getNormal(a, b, c, target) {
        target.subVectors(c, b);
        $2186453604604e6c$var$_v0.subVectors(a, b);
        target.cross($2186453604604e6c$var$_v0);
        const targetLengthSq = target.lengthSq();
        if (targetLengthSq > 0) return target.multiplyScalar(1 / Math.sqrt(targetLengthSq));
        return target.set(0, 0, 0);
    }
    // static/instance method to calculate barycentric coordinates
    // based on: http://www.blackpawn.com/texts/pointinpoly/default.html
    static getBarycoord(point, a, b, c, target) {
        $2186453604604e6c$var$_v0.subVectors(c, a);
        $2186453604604e6c$var$_v1.subVectors(b, a);
        $2186453604604e6c$var$_v2.subVectors(point, a);
        const dot00 = $2186453604604e6c$var$_v0.dot($2186453604604e6c$var$_v0);
        const dot01 = $2186453604604e6c$var$_v0.dot($2186453604604e6c$var$_v1);
        const dot02 = $2186453604604e6c$var$_v0.dot($2186453604604e6c$var$_v2);
        const dot11 = $2186453604604e6c$var$_v1.dot($2186453604604e6c$var$_v1);
        const dot12 = $2186453604604e6c$var$_v1.dot($2186453604604e6c$var$_v2);
        const denom = dot00 * dot11 - dot01 * dot01;
        // collinear or singular triangle
        if (denom === 0) {
            target.set(0, 0, 0);
            return null;
        }
        const invDenom = 1 / denom;
        const u = (dot11 * dot02 - dot01 * dot12) * invDenom;
        const v = (dot00 * dot12 - dot01 * dot02) * invDenom;
        // barycentric coordinates must always sum to 1
        return target.set(1 - u - v, v, u);
    }
    static containsPoint(point, a, b, c) {
        // if the triangle is degenerate then we can't contain a point
        if (this.getBarycoord(point, a, b, c, $2186453604604e6c$var$_v3) === null) return false;
        return $2186453604604e6c$var$_v3.x >= 0 && $2186453604604e6c$var$_v3.y >= 0 && $2186453604604e6c$var$_v3.x + $2186453604604e6c$var$_v3.y <= 1;
    }
    static getInterpolation(point, p1, p2, p3, v1, v2, v3, target) {
        if (this.getBarycoord(point, p1, p2, p3, $2186453604604e6c$var$_v3) === null) {
            target.x = 0;
            target.y = 0;
            if ('z' in target) target.z = 0;
            if ('w' in target) target.w = 0;
            return null;
        }
        target.setScalar(0);
        target.addScaledVector(v1, $2186453604604e6c$var$_v3.x);
        target.addScaledVector(v2, $2186453604604e6c$var$_v3.y);
        target.addScaledVector(v3, $2186453604604e6c$var$_v3.z);
        return target;
    }
    static getInterpolatedAttribute(attr, i1, i2, i3, barycoord, target) {
        $2186453604604e6c$var$_v40.setScalar(0);
        $2186453604604e6c$var$_v41.setScalar(0);
        $2186453604604e6c$var$_v42.setScalar(0);
        $2186453604604e6c$var$_v40.fromBufferAttribute(attr, i1);
        $2186453604604e6c$var$_v41.fromBufferAttribute(attr, i2);
        $2186453604604e6c$var$_v42.fromBufferAttribute(attr, i3);
        target.setScalar(0);
        target.addScaledVector($2186453604604e6c$var$_v40, barycoord.x);
        target.addScaledVector($2186453604604e6c$var$_v41, barycoord.y);
        target.addScaledVector($2186453604604e6c$var$_v42, barycoord.z);
        return target;
    }
    static isFrontFacing(a, b, c, direction) {
        $2186453604604e6c$var$_v0.subVectors(c, b);
        $2186453604604e6c$var$_v1.subVectors(a, b);
        // strictly front facing
        return $2186453604604e6c$var$_v0.cross($2186453604604e6c$var$_v1).dot(direction) < 0 ? true : false;
    }
    set(a, b, c) {
        this.a.copy(a);
        this.b.copy(b);
        this.c.copy(c);
        return this;
    }
    setFromPointsAndIndices(points, i0, i1, i2) {
        this.a.copy(points[i0]);
        this.b.copy(points[i1]);
        this.c.copy(points[i2]);
        return this;
    }
    setFromAttributeAndIndices(attribute, i0, i1, i2) {
        this.a.fromBufferAttribute(attribute, i0);
        this.b.fromBufferAttribute(attribute, i1);
        this.c.fromBufferAttribute(attribute, i2);
        return this;
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(triangle) {
        this.a.copy(triangle.a);
        this.b.copy(triangle.b);
        this.c.copy(triangle.c);
        return this;
    }
    getArea() {
        $2186453604604e6c$var$_v0.subVectors(this.c, this.b);
        $2186453604604e6c$var$_v1.subVectors(this.a, this.b);
        return $2186453604604e6c$var$_v0.cross($2186453604604e6c$var$_v1).length() * 0.5;
    }
    getMidpoint(target) {
        return target.addVectors(this.a, this.b).add(this.c).multiplyScalar(1 / 3);
    }
    getNormal(target) {
        return $2186453604604e6c$export$5a465592bfe74b48.getNormal(this.a, this.b, this.c, target);
    }
    getPlane(target) {
        return target.setFromCoplanarPoints(this.a, this.b, this.c);
    }
    getBarycoord(point, target) {
        return $2186453604604e6c$export$5a465592bfe74b48.getBarycoord(point, this.a, this.b, this.c, target);
    }
    getInterpolation(point, v1, v2, v3, target) {
        return $2186453604604e6c$export$5a465592bfe74b48.getInterpolation(point, this.a, this.b, this.c, v1, v2, v3, target);
    }
    containsPoint(point) {
        return $2186453604604e6c$export$5a465592bfe74b48.containsPoint(point, this.a, this.b, this.c);
    }
    isFrontFacing(direction) {
        return $2186453604604e6c$export$5a465592bfe74b48.isFrontFacing(this.a, this.b, this.c, direction);
    }
    intersectsBox(box) {
        return box.intersectsTriangle(this);
    }
    closestPointToPoint(p, target) {
        const a = this.a, b = this.b, c = this.c;
        let v, w;
        // algorithm thanks to Real-Time Collision Detection by Christer Ericson,
        // published by Morgan Kaufmann Publishers, (c) 2005 Elsevier Inc.,
        // under the accompanying license; see chapter 5.1.5 for detailed explanation.
        // basically, we're distinguishing which of the voronoi regions of the triangle
        // the point lies in with the minimum amount of redundant computation.
        $2186453604604e6c$var$_vab.subVectors(b, a);
        $2186453604604e6c$var$_vac.subVectors(c, a);
        $2186453604604e6c$var$_vap.subVectors(p, a);
        const d1 = $2186453604604e6c$var$_vab.dot($2186453604604e6c$var$_vap);
        const d2 = $2186453604604e6c$var$_vac.dot($2186453604604e6c$var$_vap);
        if (d1 <= 0 && d2 <= 0) // vertex region of A; barycentric coords (1, 0, 0)
        return target.copy(a);
        $2186453604604e6c$var$_vbp.subVectors(p, b);
        const d3 = $2186453604604e6c$var$_vab.dot($2186453604604e6c$var$_vbp);
        const d4 = $2186453604604e6c$var$_vac.dot($2186453604604e6c$var$_vbp);
        if (d3 >= 0 && d4 <= d3) // vertex region of B; barycentric coords (0, 1, 0)
        return target.copy(b);
        const vc = d1 * d4 - d3 * d2;
        if (vc <= 0 && d1 >= 0 && d3 <= 0) {
            v = d1 / (d1 - d3);
            // edge region of AB; barycentric coords (1-v, v, 0)
            return target.copy(a).addScaledVector($2186453604604e6c$var$_vab, v);
        }
        $2186453604604e6c$var$_vcp.subVectors(p, c);
        const d5 = $2186453604604e6c$var$_vab.dot($2186453604604e6c$var$_vcp);
        const d6 = $2186453604604e6c$var$_vac.dot($2186453604604e6c$var$_vcp);
        if (d6 >= 0 && d5 <= d6) // vertex region of C; barycentric coords (0, 0, 1)
        return target.copy(c);
        const vb = d5 * d2 - d1 * d6;
        if (vb <= 0 && d2 >= 0 && d6 <= 0) {
            w = d2 / (d2 - d6);
            // edge region of AC; barycentric coords (1-w, 0, w)
            return target.copy(a).addScaledVector($2186453604604e6c$var$_vac, w);
        }
        const va = d3 * d6 - d5 * d4;
        if (va <= 0 && d4 - d3 >= 0 && d5 - d6 >= 0) {
            $2186453604604e6c$var$_vbc.subVectors(c, b);
            w = (d4 - d3) / (d4 - d3 + (d5 - d6));
            // edge region of BC; barycentric coords (0, 1-w, w)
            return target.copy(b).addScaledVector($2186453604604e6c$var$_vbc, w); // edge region of BC
        }
        // face region
        const denom = 1 / (va + vb + vc);
        // u = va * denom
        v = vb * denom;
        w = vc * denom;
        return target.copy(a).addScaledVector($2186453604604e6c$var$_vab, v).addScaledVector($2186453604604e6c$var$_vac, w);
    }
    equals(triangle) {
        return triangle.a.equals(this.a) && triangle.b.equals(this.b) && triangle.c.equals(this.c);
    }
}







class $30428884caacd4ad$export$55cbcc9b622fe1f5 extends (0, $7711e1b3c41f4d78$export$a2d8b23205c25948) {
    static get type() {
        return 'MeshBasicMaterial';
    }
    constructor(parameters){
        super();
        this.isMeshBasicMaterial = true;
        this.color = new (0, $9a23ce591a1b6760$export$892596cec99bc70e)(0xffffff); // emissive
        this.map = null;
        this.lightMap = null;
        this.lightMapIntensity = 1.0;
        this.aoMap = null;
        this.aoMapIntensity = 1.0;
        this.specularMap = null;
        this.alphaMap = null;
        this.envMap = null;
        this.envMapRotation = new (0, $ac384e7663319ba6$export$d93cc409a0768c5f)();
        this.combine = (0, $cb5ee595c0f892af$export$e50ac29801f1774d);
        this.reflectivity = 1;
        this.refractionRatio = 0.98;
        this.wireframe = false;
        this.wireframeLinewidth = 1;
        this.wireframeLinecap = 'round';
        this.wireframeLinejoin = 'round';
        this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.map = source.map;
        this.lightMap = source.lightMap;
        this.lightMapIntensity = source.lightMapIntensity;
        this.aoMap = source.aoMap;
        this.aoMapIntensity = source.aoMapIntensity;
        this.specularMap = source.specularMap;
        this.alphaMap = source.alphaMap;
        this.envMap = source.envMap;
        this.envMapRotation.copy(source.envMapRotation);
        this.combine = source.combine;
        this.reflectivity = source.reflectivity;
        this.refractionRatio = source.refractionRatio;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.wireframeLinecap = source.wireframeLinecap;
        this.wireframeLinejoin = source.wireframeLinejoin;
        this.fog = source.fog;
        return this;
    }
}



const $4fa83874928b8122$var$_inverseMatrix = /*@__PURE__*/ new (0, $0ea09116adcadf95$export$2ae72fc923e5eb5)();
const $4fa83874928b8122$var$_ray = /*@__PURE__*/ new (0, $64db0fa6818d6f42$export$a186db52eed6d40e)();
const $4fa83874928b8122$var$_sphere = /*@__PURE__*/ new (0, $f029c986fd3c8d57$export$805e8b72413ccaba)();
const $4fa83874928b8122$var$_sphereHitAt = /*@__PURE__*/ new (0, $d7d0ac0e47013885$export$64b5c384219d3699)();
const $4fa83874928b8122$var$_vA = /*@__PURE__*/ new (0, $d7d0ac0e47013885$export$64b5c384219d3699)();
const $4fa83874928b8122$var$_vB = /*@__PURE__*/ new (0, $d7d0ac0e47013885$export$64b5c384219d3699)();
const $4fa83874928b8122$var$_vC = /*@__PURE__*/ new (0, $d7d0ac0e47013885$export$64b5c384219d3699)();
const $4fa83874928b8122$var$_tempA = /*@__PURE__*/ new (0, $d7d0ac0e47013885$export$64b5c384219d3699)();
const $4fa83874928b8122$var$_morphA = /*@__PURE__*/ new (0, $d7d0ac0e47013885$export$64b5c384219d3699)();
const $4fa83874928b8122$var$_intersectionPoint = /*@__PURE__*/ new (0, $d7d0ac0e47013885$export$64b5c384219d3699)();
const $4fa83874928b8122$var$_intersectionPointWorld = /*@__PURE__*/ new (0, $d7d0ac0e47013885$export$64b5c384219d3699)();
class $4fa83874928b8122$export$e176487c05830cc5 extends (0, $2894733dde59bc41$export$e4dd07dff30cc924) {
    constructor(geometry = new (0, $b7aea261c5c9a899$export$b7be63a67df8959)(), material = new (0, $30428884caacd4ad$export$55cbcc9b622fe1f5)()){
        super();
        this.isMesh = true;
        this.type = 'Mesh';
        this.geometry = geometry;
        this.material = material;
        this.updateMorphTargets();
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        if (source.morphTargetInfluences !== undefined) this.morphTargetInfluences = source.morphTargetInfluences.slice();
        if (source.morphTargetDictionary !== undefined) this.morphTargetDictionary = Object.assign({}, source.morphTargetDictionary);
        this.material = Array.isArray(source.material) ? source.material.slice() : source.material;
        this.geometry = source.geometry;
        return this;
    }
    updateMorphTargets() {
        const geometry = this.geometry;
        const morphAttributes = geometry.morphAttributes;
        const keys = Object.keys(morphAttributes);
        if (keys.length > 0) {
            const morphAttribute = morphAttributes[keys[0]];
            if (morphAttribute !== undefined) {
                this.morphTargetInfluences = [];
                this.morphTargetDictionary = {};
                for(let m = 0, ml = morphAttribute.length; m < ml; m++){
                    const name = morphAttribute[m].name || String(m);
                    this.morphTargetInfluences.push(0);
                    this.morphTargetDictionary[name] = m;
                }
            }
        }
    }
    getVertexPosition(index, target) {
        const geometry = this.geometry;
        const position = geometry.attributes.position;
        const morphPosition = geometry.morphAttributes.position;
        const morphTargetsRelative = geometry.morphTargetsRelative;
        target.fromBufferAttribute(position, index);
        const morphInfluences = this.morphTargetInfluences;
        if (morphPosition && morphInfluences) {
            $4fa83874928b8122$var$_morphA.set(0, 0, 0);
            for(let i = 0, il = morphPosition.length; i < il; i++){
                const influence = morphInfluences[i];
                const morphAttribute = morphPosition[i];
                if (influence === 0) continue;
                $4fa83874928b8122$var$_tempA.fromBufferAttribute(morphAttribute, index);
                if (morphTargetsRelative) $4fa83874928b8122$var$_morphA.addScaledVector($4fa83874928b8122$var$_tempA, influence);
                else $4fa83874928b8122$var$_morphA.addScaledVector($4fa83874928b8122$var$_tempA.sub(target), influence);
            }
            target.add($4fa83874928b8122$var$_morphA);
        }
        return target;
    }
    raycast(raycaster, intersects) {
        const geometry = this.geometry;
        const material = this.material;
        const matrixWorld = this.matrixWorld;
        if (material === undefined) return;
        // test with bounding sphere in world space
        if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
        $4fa83874928b8122$var$_sphere.copy(geometry.boundingSphere);
        $4fa83874928b8122$var$_sphere.applyMatrix4(matrixWorld);
        // check distance from ray origin to bounding sphere
        $4fa83874928b8122$var$_ray.copy(raycaster.ray).recast(raycaster.near);
        if ($4fa83874928b8122$var$_sphere.containsPoint($4fa83874928b8122$var$_ray.origin) === false) {
            if ($4fa83874928b8122$var$_ray.intersectSphere($4fa83874928b8122$var$_sphere, $4fa83874928b8122$var$_sphereHitAt) === null) return;
            if ($4fa83874928b8122$var$_ray.origin.distanceToSquared($4fa83874928b8122$var$_sphereHitAt) > (raycaster.far - raycaster.near) ** 2) return;
        }
        // convert ray to local space of mesh
        $4fa83874928b8122$var$_inverseMatrix.copy(matrixWorld).invert();
        $4fa83874928b8122$var$_ray.copy(raycaster.ray).applyMatrix4($4fa83874928b8122$var$_inverseMatrix);
        // test with bounding box in local space
        if (geometry.boundingBox !== null) {
            if ($4fa83874928b8122$var$_ray.intersectsBox(geometry.boundingBox) === false) return;
        }
        // test for intersections with geometry
        this._computeIntersections(raycaster, intersects, $4fa83874928b8122$var$_ray);
    }
    _computeIntersections(raycaster, intersects, rayLocalSpace) {
        let intersection;
        const geometry = this.geometry;
        const material = this.material;
        const index = geometry.index;
        const position = geometry.attributes.position;
        const uv = geometry.attributes.uv;
        const uv1 = geometry.attributes.uv1;
        const normal = geometry.attributes.normal;
        const groups = geometry.groups;
        const drawRange = geometry.drawRange;
        if (index !== null) {
            // indexed buffer geometry
            if (Array.isArray(material)) for(let i = 0, il = groups.length; i < il; i++){
                const group = groups[i];
                const groupMaterial = material[group.materialIndex];
                const start = Math.max(group.start, drawRange.start);
                const end = Math.min(index.count, Math.min(group.start + group.count, drawRange.start + drawRange.count));
                for(let j = start, jl = end; j < jl; j += 3){
                    const a = index.getX(j);
                    const b = index.getX(j + 1);
                    const c = index.getX(j + 2);
                    intersection = $4fa83874928b8122$var$checkGeometryIntersection(this, groupMaterial, raycaster, rayLocalSpace, uv, uv1, normal, a, b, c);
                    if (intersection) {
                        intersection.faceIndex = Math.floor(j / 3); // triangle number in indexed buffer semantics
                        intersection.face.materialIndex = group.materialIndex;
                        intersects.push(intersection);
                    }
                }
            }
            else {
                const start = Math.max(0, drawRange.start);
                const end = Math.min(index.count, drawRange.start + drawRange.count);
                for(let i = start, il = end; i < il; i += 3){
                    const a = index.getX(i);
                    const b = index.getX(i + 1);
                    const c = index.getX(i + 2);
                    intersection = $4fa83874928b8122$var$checkGeometryIntersection(this, material, raycaster, rayLocalSpace, uv, uv1, normal, a, b, c);
                    if (intersection) {
                        intersection.faceIndex = Math.floor(i / 3); // triangle number in indexed buffer semantics
                        intersects.push(intersection);
                    }
                }
            }
        } else if (position !== undefined) {
            // non-indexed buffer geometry
            if (Array.isArray(material)) for(let i = 0, il = groups.length; i < il; i++){
                const group = groups[i];
                const groupMaterial = material[group.materialIndex];
                const start = Math.max(group.start, drawRange.start);
                const end = Math.min(position.count, Math.min(group.start + group.count, drawRange.start + drawRange.count));
                for(let j = start, jl = end; j < jl; j += 3){
                    const a = j;
                    const b = j + 1;
                    const c = j + 2;
                    intersection = $4fa83874928b8122$var$checkGeometryIntersection(this, groupMaterial, raycaster, rayLocalSpace, uv, uv1, normal, a, b, c);
                    if (intersection) {
                        intersection.faceIndex = Math.floor(j / 3); // triangle number in non-indexed buffer semantics
                        intersection.face.materialIndex = group.materialIndex;
                        intersects.push(intersection);
                    }
                }
            }
            else {
                const start = Math.max(0, drawRange.start);
                const end = Math.min(position.count, drawRange.start + drawRange.count);
                for(let i = start, il = end; i < il; i += 3){
                    const a = i;
                    const b = i + 1;
                    const c = i + 2;
                    intersection = $4fa83874928b8122$var$checkGeometryIntersection(this, material, raycaster, rayLocalSpace, uv, uv1, normal, a, b, c);
                    if (intersection) {
                        intersection.faceIndex = Math.floor(i / 3); // triangle number in non-indexed buffer semantics
                        intersects.push(intersection);
                    }
                }
            }
        }
    }
}
function $4fa83874928b8122$var$checkIntersection(object, material, raycaster, ray, pA, pB, pC, point) {
    let intersect;
    if (material.side === (0, $cb5ee595c0f892af$export$d9f0486e75b5ace)) intersect = ray.intersectTriangle(pC, pB, pA, true, point);
    else intersect = ray.intersectTriangle(pA, pB, pC, material.side === (0, $cb5ee595c0f892af$export$2ede184fc2998901), point);
    if (intersect === null) return null;
    $4fa83874928b8122$var$_intersectionPointWorld.copy(point);
    $4fa83874928b8122$var$_intersectionPointWorld.applyMatrix4(object.matrixWorld);
    const distance = raycaster.ray.origin.distanceTo($4fa83874928b8122$var$_intersectionPointWorld);
    if (distance < raycaster.near || distance > raycaster.far) return null;
    return {
        distance: distance,
        point: $4fa83874928b8122$var$_intersectionPointWorld.clone(),
        object: object
    };
}
function $4fa83874928b8122$var$checkGeometryIntersection(object, material, raycaster, ray, uv, uv1, normal, a, b, c) {
    object.getVertexPosition(a, $4fa83874928b8122$var$_vA);
    object.getVertexPosition(b, $4fa83874928b8122$var$_vB);
    object.getVertexPosition(c, $4fa83874928b8122$var$_vC);
    const intersection = $4fa83874928b8122$var$checkIntersection(object, material, raycaster, ray, $4fa83874928b8122$var$_vA, $4fa83874928b8122$var$_vB, $4fa83874928b8122$var$_vC, $4fa83874928b8122$var$_intersectionPoint);
    if (intersection) {
        const barycoord = new (0, $d7d0ac0e47013885$export$64b5c384219d3699)();
        (0, $2186453604604e6c$export$5a465592bfe74b48).getBarycoord($4fa83874928b8122$var$_intersectionPoint, $4fa83874928b8122$var$_vA, $4fa83874928b8122$var$_vB, $4fa83874928b8122$var$_vC, barycoord);
        if (uv) intersection.uv = (0, $2186453604604e6c$export$5a465592bfe74b48).getInterpolatedAttribute(uv, a, b, c, barycoord, new (0, $3c03061dea0adea3$export$c977b3e384af9ae1)());
        if (uv1) intersection.uv1 = (0, $2186453604604e6c$export$5a465592bfe74b48).getInterpolatedAttribute(uv1, a, b, c, barycoord, new (0, $3c03061dea0adea3$export$c977b3e384af9ae1)());
        if (normal) {
            intersection.normal = (0, $2186453604604e6c$export$5a465592bfe74b48).getInterpolatedAttribute(normal, a, b, c, barycoord, new (0, $d7d0ac0e47013885$export$64b5c384219d3699)());
            if (intersection.normal.dot(ray.direction) > 0) intersection.normal.multiplyScalar(-1);
        }
        const face = {
            a: a,
            b: b,
            c: c,
            normal: new (0, $d7d0ac0e47013885$export$64b5c384219d3699)(),
            materialIndex: 0
        };
        (0, $2186453604604e6c$export$5a465592bfe74b48).getNormal($4fa83874928b8122$var$_vA, $4fa83874928b8122$var$_vB, $4fa83874928b8122$var$_vC, face.normal);
        intersection.face = face;
        intersection.barycoord = barycoord;
    }
    return intersection;
}





class $842ad9c500d9d3d8$export$79f141de891a5fed extends (0, $2894733dde59bc41$export$e4dd07dff30cc924) {
    constructor(){
        super();
        this.isCamera = true;
        this.type = 'Camera';
        this.matrixWorldInverse = new (0, $0ea09116adcadf95$export$2ae72fc923e5eb5)();
        this.projectionMatrix = new (0, $0ea09116adcadf95$export$2ae72fc923e5eb5)();
        this.projectionMatrixInverse = new (0, $0ea09116adcadf95$export$2ae72fc923e5eb5)();
        this.coordinateSystem = (0, $cb5ee595c0f892af$export$5a0e9190d10875d3);
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.matrixWorldInverse.copy(source.matrixWorldInverse);
        this.projectionMatrix.copy(source.projectionMatrix);
        this.projectionMatrixInverse.copy(source.projectionMatrixInverse);
        this.coordinateSystem = source.coordinateSystem;
        return this;
    }
    getWorldDirection(target) {
        return super.getWorldDirection(target).negate();
    }
    updateMatrixWorld(force) {
        super.updateMatrixWorld(force);
        this.matrixWorldInverse.copy(this.matrixWorld).invert();
    }
    updateWorldMatrix(updateParents, updateChildren) {
        super.updateWorldMatrix(updateParents, updateChildren);
        this.matrixWorldInverse.copy(this.matrixWorld).invert();
    }
    clone() {
        return new this.constructor().copy(this);
    }
}


class $e37261468d01aaee$export$9ebf355ee4ed261b extends (0, $842ad9c500d9d3d8$export$79f141de891a5fed) {
    constructor(left = -1, right = 1, top = 1, bottom = -1, near = 0.1, far = 2000){
        super();
        this.isOrthographicCamera = true;
        this.type = 'OrthographicCamera';
        this.zoom = 1;
        this.view = null;
        this.left = left;
        this.right = right;
        this.top = top;
        this.bottom = bottom;
        this.near = near;
        this.far = far;
        this.updateProjectionMatrix();
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.left = source.left;
        this.right = source.right;
        this.top = source.top;
        this.bottom = source.bottom;
        this.near = source.near;
        this.far = source.far;
        this.zoom = source.zoom;
        this.view = source.view === null ? null : Object.assign({}, source.view);
        return this;
    }
    setViewOffset(fullWidth, fullHeight, x, y, width, height) {
        if (this.view === null) this.view = {
            enabled: true,
            fullWidth: 1,
            fullHeight: 1,
            offsetX: 0,
            offsetY: 0,
            width: 1,
            height: 1
        };
        this.view.enabled = true;
        this.view.fullWidth = fullWidth;
        this.view.fullHeight = fullHeight;
        this.view.offsetX = x;
        this.view.offsetY = y;
        this.view.width = width;
        this.view.height = height;
        this.updateProjectionMatrix();
    }
    clearViewOffset() {
        if (this.view !== null) this.view.enabled = false;
        this.updateProjectionMatrix();
    }
    updateProjectionMatrix() {
        const dx = (this.right - this.left) / (2 * this.zoom);
        const dy = (this.top - this.bottom) / (2 * this.zoom);
        const cx = (this.right + this.left) / 2;
        const cy = (this.top + this.bottom) / 2;
        let left = cx - dx;
        let right = cx + dx;
        let top = cy + dy;
        let bottom = cy - dy;
        if (this.view !== null && this.view.enabled) {
            const scaleW = (this.right - this.left) / this.view.fullWidth / this.zoom;
            const scaleH = (this.top - this.bottom) / this.view.fullHeight / this.zoom;
            left += scaleW * this.view.offsetX;
            right = left + scaleW * this.view.width;
            top -= scaleH * this.view.offsetY;
            bottom = top - scaleH * this.view.height;
        }
        this.projectionMatrix.makeOrthographic(left, right, top, bottom, this.near, this.far, this.coordinateSystem);
        this.projectionMatrixInverse.copy(this.projectionMatrix).invert();
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.object.zoom = this.zoom;
        data.object.left = this.left;
        data.object.right = this.right;
        data.object.top = this.top;
        data.object.bottom = this.bottom;
        data.object.near = this.near;
        data.object.far = this.far;
        if (this.view !== null) data.object.view = Object.assign({}, this.view);
        return data;
    }
}


// Helper for passes that need to fill the viewport with a single quad.
const $488a8c443ac2097d$var$_camera = /*@__PURE__*/ new (0, $e37261468d01aaee$export$9ebf355ee4ed261b)(-1, 1, 1, -1, 0, 1);
// https://github.com/mrdoob/three.js/pull/21358
class $488a8c443ac2097d$var$QuadGeometry extends (0, $b7aea261c5c9a899$export$b7be63a67df8959) {
    constructor(flipY = false){
        super();
        const uv = flipY === false ? [
            0,
            -1,
            0,
            1,
            2,
            1
        ] : [
            0,
            2,
            0,
            0,
            2,
            0
        ];
        this.setAttribute('position', new (0, $4b03383e684869fb$export$cbe7a62641830ebd)([
            -1,
            3,
            0,
            -1,
            -1,
            0,
            3,
            -1,
            0
        ], 3));
        this.setAttribute('uv', new (0, $4b03383e684869fb$export$cbe7a62641830ebd)(uv, 2));
    }
}
const $488a8c443ac2097d$var$_geometry = /*@__PURE__*/ new $488a8c443ac2097d$var$QuadGeometry();
class $488a8c443ac2097d$var$QuadMesh extends (0, $4fa83874928b8122$export$e176487c05830cc5) {
    constructor(material = null){
        super($488a8c443ac2097d$var$_geometry, material);
        this.camera = $488a8c443ac2097d$var$_camera;
        this.isQuadMesh = true;
    }
    renderAsync(renderer) {
        return renderer.renderAsync(this, $488a8c443ac2097d$var$_camera);
    }
    render(renderer) {
        renderer.render(this, $488a8c443ac2097d$var$_camera);
    }
}
var $488a8c443ac2097d$export$2e2bcd8739ae039 = $488a8c443ac2097d$var$QuadMesh;





const $97f00f21687615f6$var$_size = /*@__PURE__*/ new (0, $3c03061dea0adea3$export$c977b3e384af9ae1)();
class $97f00f21687615f6$var$RTTNode extends (0, $f7d68bbf9ea772a7$export$2e2bcd8739ae039) {
    static get type() {
        return 'RTTNode';
    }
    constructor(node, width = null, height = null, options = {
        type: (0, $cb5ee595c0f892af$export$2697304443f382bc)
    }){
        const renderTarget = new (0, $2ca03eab531e649d$export$efcb1f8bf367cbfb)(width, height, options);
        super(renderTarget.texture, (0, $382a32bd765f3827$export$c774ebbac59e31d3)());
        this.node = node;
        this.width = width;
        this.height = height;
        this.renderTarget = renderTarget;
        this.textureNeedsUpdate = true;
        this.autoUpdate = true;
        this.updateMap = new WeakMap();
        this._rttNode = null;
        this._quadMesh = new (0, $488a8c443ac2097d$export$2e2bcd8739ae039)(new (0, $1a485f4d26090da0$export$2e2bcd8739ae039)());
        this.updateBeforeType = (0, $ddcfecb7fbba5d74$export$26f7a8bbd9469530).RENDER;
    }
    get autoSize() {
        return this.width === null;
    }
    setup(builder) {
        this._rttNode = this.node.context(builder.getSharedContext());
        this._quadMesh.material.name = 'RTT';
        this._quadMesh.material.needsUpdate = true;
        return super.setup(builder);
    }
    setSize(width, height) {
        this.width = width;
        this.height = height;
        const effectiveWidth = width * this.pixelRatio;
        const effectiveHeight = height * this.pixelRatio;
        this.renderTarget.setSize(effectiveWidth, effectiveHeight);
        this.textureNeedsUpdate = true;
    }
    setPixelRatio(pixelRatio) {
        this.pixelRatio = pixelRatio;
        this.setSize(this.width, this.height);
    }
    updateBefore({ renderer: renderer }) {
        if (this.textureNeedsUpdate === false && this.autoUpdate === false) return;
        this.textureNeedsUpdate = false;
        //
        if (this.autoSize === true) {
            this.pixelRatio = renderer.getPixelRatio();
            const size = renderer.getSize($97f00f21687615f6$var$_size);
            this.setSize(size.width, size.height);
        }
        //
        this._quadMesh.material.fragmentNode = this._rttNode;
        //
        const currentRenderTarget = renderer.getRenderTarget();
        renderer.setRenderTarget(this.renderTarget);
        this._quadMesh.render(renderer);
        renderer.setRenderTarget(currentRenderTarget);
    }
    clone() {
        const newNode = new (0, $f7d68bbf9ea772a7$export$2e2bcd8739ae039)(this.value, this.uvNode, this.levelNode);
        newNode.sampler = this.sampler;
        newNode.referenceNode = this;
        return newNode;
    }
}
var $97f00f21687615f6$export$2e2bcd8739ae039 = $97f00f21687615f6$var$RTTNode;
const $97f00f21687615f6$export$37398e9aa0e33ac8 = (node, ...params)=>(0, $d5b7ee61758b2e81$export$e97474e17004dd41)(new $97f00f21687615f6$var$RTTNode((0, $d5b7ee61758b2e81$export$e97474e17004dd41)(node), ...params));
const $97f00f21687615f6$export$1c5d813aa0a49240 = (node, ...params)=>node.isTextureNode ? node : $97f00f21687615f6$export$37398e9aa0e33ac8(node, ...params);






const $48bc91781c0f63d9$export$cd3e68abd0f82656 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$b076717d71a1a47f)(([screenPosition, depth, projectionMatrixInverse], builder)=>{
    let clipSpacePosition;
    if (builder.renderer.coordinateSystem === (0, $cb5ee595c0f892af$export$cc83beedcb9be9ac)) {
        screenPosition = (0, $d5b7ee61758b2e81$export$e9830bc863290a54)(screenPosition.x, screenPosition.y.oneMinus()).mul(2.0).sub(1.0);
        clipSpacePosition = (0, $d5b7ee61758b2e81$export$6dba2a1f0d609415)((0, $d5b7ee61758b2e81$export$9100789c9d999364)(screenPosition, depth), 1.0);
    } else clipSpacePosition = (0, $d5b7ee61758b2e81$export$6dba2a1f0d609415)((0, $d5b7ee61758b2e81$export$9100789c9d999364)(screenPosition.x, screenPosition.y.oneMinus(), depth).mul(2.0).sub(1.0), 1.0);
    const viewSpacePosition = (0, $d5b7ee61758b2e81$export$6dba2a1f0d609415)(projectionMatrixInverse.mul(clipSpacePosition));
    return viewSpacePosition.xyz.div(viewSpacePosition.w);
});
const $48bc91781c0f63d9$export$81f4bef18ad9dba3 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$b076717d71a1a47f)(([viewPosition, projectionMatrix])=>{
    const sampleClipPos = projectionMatrix.mul((0, $d5b7ee61758b2e81$export$6dba2a1f0d609415)(viewPosition, 1.0));
    const sampleUv = sampleClipPos.xy.div(sampleClipPos.w).mul(0.5).add(0.5).toVar();
    return (0, $d5b7ee61758b2e81$export$e9830bc863290a54)(sampleUv.x, sampleUv.y.oneMinus());
});
const $48bc91781c0f63d9$export$b2c1444e1a547184 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$b076717d71a1a47f)(([uv, depthTexture, projectionMatrixInverse])=>{
    const size = (0, $4e1437e3f88f83e2$export$a8905ccad583a116)((0, $f7d68bbf9ea772a7$export$c9a2885c9238610f)(depthTexture));
    const p = (0, $d5b7ee61758b2e81$export$63e666f6a33be288)(uv.mul(size)).toVar();
    const c0 = (0, $f7d68bbf9ea772a7$export$c9a2885c9238610f)(depthTexture, p).toVar();
    const l2 = (0, $f7d68bbf9ea772a7$export$c9a2885c9238610f)(depthTexture, p.sub((0, $d5b7ee61758b2e81$export$63e666f6a33be288)(2, 0))).toVar();
    const l1 = (0, $f7d68bbf9ea772a7$export$c9a2885c9238610f)(depthTexture, p.sub((0, $d5b7ee61758b2e81$export$63e666f6a33be288)(1, 0))).toVar();
    const r1 = (0, $f7d68bbf9ea772a7$export$c9a2885c9238610f)(depthTexture, p.add((0, $d5b7ee61758b2e81$export$63e666f6a33be288)(1, 0))).toVar();
    const r2 = (0, $f7d68bbf9ea772a7$export$c9a2885c9238610f)(depthTexture, p.add((0, $d5b7ee61758b2e81$export$63e666f6a33be288)(2, 0))).toVar();
    const b2 = (0, $f7d68bbf9ea772a7$export$c9a2885c9238610f)(depthTexture, p.add((0, $d5b7ee61758b2e81$export$63e666f6a33be288)(0, 2))).toVar();
    const b1 = (0, $f7d68bbf9ea772a7$export$c9a2885c9238610f)(depthTexture, p.add((0, $d5b7ee61758b2e81$export$63e666f6a33be288)(0, 1))).toVar();
    const t1 = (0, $f7d68bbf9ea772a7$export$c9a2885c9238610f)(depthTexture, p.sub((0, $d5b7ee61758b2e81$export$63e666f6a33be288)(0, 1))).toVar();
    const t2 = (0, $f7d68bbf9ea772a7$export$c9a2885c9238610f)(depthTexture, p.sub((0, $d5b7ee61758b2e81$export$63e666f6a33be288)(0, 2))).toVar();
    const dl = (0, $f37ae0e58866c183$export$2335f513bbd82c6d)((0, $3f1f23fea79ae256$export$f93b5905241a7cca)((0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(2).mul(l1).sub(l2), c0)).toVar();
    const dr = (0, $f37ae0e58866c183$export$2335f513bbd82c6d)((0, $3f1f23fea79ae256$export$f93b5905241a7cca)((0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(2).mul(r1).sub(r2), c0)).toVar();
    const db = (0, $f37ae0e58866c183$export$2335f513bbd82c6d)((0, $3f1f23fea79ae256$export$f93b5905241a7cca)((0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(2).mul(b1).sub(b2), c0)).toVar();
    const dt = (0, $f37ae0e58866c183$export$2335f513bbd82c6d)((0, $3f1f23fea79ae256$export$f93b5905241a7cca)((0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(2).mul(t1).sub(t2), c0)).toVar();
    const ce = $48bc91781c0f63d9$export$cd3e68abd0f82656(uv, c0, projectionMatrixInverse).toVar();
    const dpdx = dl.lessThan(dr).select(ce.sub($48bc91781c0f63d9$export$cd3e68abd0f82656(uv.sub((0, $d5b7ee61758b2e81$export$e9830bc863290a54)((0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(1).div(size.x), 0)), l1, projectionMatrixInverse)), ce.negate().add($48bc91781c0f63d9$export$cd3e68abd0f82656(uv.add((0, $d5b7ee61758b2e81$export$e9830bc863290a54)((0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(1).div(size.x), 0)), r1, projectionMatrixInverse)));
    const dpdy = db.lessThan(dt).select(ce.sub($48bc91781c0f63d9$export$cd3e68abd0f82656(uv.add((0, $d5b7ee61758b2e81$export$e9830bc863290a54)(0, (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(1).div(size.y))), b1, projectionMatrixInverse)), ce.negate().add($48bc91781c0f63d9$export$cd3e68abd0f82656(uv.sub((0, $d5b7ee61758b2e81$export$e9830bc863290a54)(0, (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(1).div(size.y))), t1, projectionMatrixInverse)));
    return (0, $f37ae0e58866c183$export$a3295358bff77e)((0, $f37ae0e58866c183$export$bb646b20bb93d339)(dpdx, dpdy));
});












class $a0b4f983c2ac9937$var$VertexColorNode extends (0, $700a78a0d988d216$export$2e2bcd8739ae039) {
    static get type() {
        return 'VertexColorNode';
    }
    constructor(index = 0){
        super(null, 'vec4');
        this.isVertexColorNode = true;
        this.index = index;
    }
    getAttributeName() {
        const index = this.index;
        return 'color' + (index > 0 ? index : '');
    }
    generate(builder) {
        const attributeName = this.getAttributeName(builder);
        const geometryAttribute = builder.hasGeometryAttribute(attributeName);
        let result;
        if (geometryAttribute === true) result = super.generate(builder);
        else // Vertex color fallback should be white
        result = builder.generateConst(this.nodeType, new (0, $a09a15e9a8421204$export$fa7daccca11cdbe3)(1, 1, 1, 1));
        return result;
    }
    serialize(data) {
        super.serialize(data);
        data.index = this.index;
    }
    deserialize(data) {
        super.deserialize(data);
        this.index = data.index;
    }
}
var $a0b4f983c2ac9937$export$2e2bcd8739ae039 = $a0b4f983c2ac9937$var$VertexColorNode;
const $a0b4f983c2ac9937$export$c8138cad8c736bdb = (...params)=>(0, $d5b7ee61758b2e81$export$e97474e17004dd41)(new $a0b4f983c2ac9937$var$VertexColorNode(...params));













// Mipped Bicubic Texture Filtering by N8
// https://www.shadertoy.com/view/Dl2SDW
const $82ae7c00e8a2de76$var$bC = 1.0 / 6.0;
const $82ae7c00e8a2de76$var$w0 = (a)=>(0, $3f1f23fea79ae256$export$6e3a27864ab166fe)($82ae7c00e8a2de76$var$bC, (0, $3f1f23fea79ae256$export$6e3a27864ab166fe)(a, (0, $3f1f23fea79ae256$export$6e3a27864ab166fe)(a, a.negate().add(3.0)).sub(3.0)).add(1.0));
const $82ae7c00e8a2de76$var$w1 = (a)=>(0, $3f1f23fea79ae256$export$6e3a27864ab166fe)($82ae7c00e8a2de76$var$bC, (0, $3f1f23fea79ae256$export$6e3a27864ab166fe)(a, (0, $3f1f23fea79ae256$export$6e3a27864ab166fe)(a, (0, $3f1f23fea79ae256$export$6e3a27864ab166fe)(3.0, a).sub(6.0))).add(4.0));
const $82ae7c00e8a2de76$var$w2 = (a)=>(0, $3f1f23fea79ae256$export$6e3a27864ab166fe)($82ae7c00e8a2de76$var$bC, (0, $3f1f23fea79ae256$export$6e3a27864ab166fe)(a, (0, $3f1f23fea79ae256$export$6e3a27864ab166fe)(a, (0, $3f1f23fea79ae256$export$6e3a27864ab166fe)(-3, a).add(3.0)).add(3.0)).add(1.0));
const $82ae7c00e8a2de76$var$w3 = (a)=>(0, $3f1f23fea79ae256$export$6e3a27864ab166fe)($82ae7c00e8a2de76$var$bC, (0, $f37ae0e58866c183$export$9c297f60e22e3389)(a, 3));
const $82ae7c00e8a2de76$var$g0 = (a)=>$82ae7c00e8a2de76$var$w0(a).add($82ae7c00e8a2de76$var$w1(a));
const $82ae7c00e8a2de76$var$g1 = (a)=>$82ae7c00e8a2de76$var$w2(a).add($82ae7c00e8a2de76$var$w3(a));
// h0 and h1 are the two offset functions
const $82ae7c00e8a2de76$var$h0 = (a)=>(0, $3f1f23fea79ae256$export$e16d8520af44a096)(-1, $82ae7c00e8a2de76$var$w1(a).div($82ae7c00e8a2de76$var$w0(a).add($82ae7c00e8a2de76$var$w1(a))));
const $82ae7c00e8a2de76$var$h1 = (a)=>(0, $3f1f23fea79ae256$export$e16d8520af44a096)(1.0, $82ae7c00e8a2de76$var$w3(a).div($82ae7c00e8a2de76$var$w2(a).add($82ae7c00e8a2de76$var$w3(a))));
const $82ae7c00e8a2de76$var$bicubic = (textureNode, texelSize, lod)=>{
    const uv = textureNode.uvNode;
    const uvScaled = (0, $3f1f23fea79ae256$export$6e3a27864ab166fe)(uv, texelSize.zw).add(0.5);
    const iuv = (0, $f37ae0e58866c183$export$a3fe094919f356fd)(uvScaled);
    const fuv = (0, $f37ae0e58866c183$export$a57bfe0eb79af278)(uvScaled);
    const g0x = $82ae7c00e8a2de76$var$g0(fuv.x);
    const g1x = $82ae7c00e8a2de76$var$g1(fuv.x);
    const h0x = $82ae7c00e8a2de76$var$h0(fuv.x);
    const h1x = $82ae7c00e8a2de76$var$h1(fuv.x);
    const h0y = $82ae7c00e8a2de76$var$h0(fuv.y);
    const h1y = $82ae7c00e8a2de76$var$h1(fuv.y);
    const p0 = (0, $d5b7ee61758b2e81$export$e9830bc863290a54)(iuv.x.add(h0x), iuv.y.add(h0y)).sub(0.5).mul(texelSize.xy);
    const p1 = (0, $d5b7ee61758b2e81$export$e9830bc863290a54)(iuv.x.add(h1x), iuv.y.add(h0y)).sub(0.5).mul(texelSize.xy);
    const p2 = (0, $d5b7ee61758b2e81$export$e9830bc863290a54)(iuv.x.add(h0x), iuv.y.add(h1y)).sub(0.5).mul(texelSize.xy);
    const p3 = (0, $d5b7ee61758b2e81$export$e9830bc863290a54)(iuv.x.add(h1x), iuv.y.add(h1y)).sub(0.5).mul(texelSize.xy);
    const a = $82ae7c00e8a2de76$var$g0(fuv.y).mul((0, $3f1f23fea79ae256$export$e16d8520af44a096)(g0x.mul(textureNode.uv(p0).level(lod)), g1x.mul(textureNode.uv(p1).level(lod))));
    const b = $82ae7c00e8a2de76$var$g1(fuv.y).mul((0, $3f1f23fea79ae256$export$e16d8520af44a096)(g0x.mul(textureNode.uv(p2).level(lod)), g1x.mul(textureNode.uv(p3).level(lod))));
    return a.add(b);
};
const $82ae7c00e8a2de76$export$c7dcb77ffba0478b = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$b076717d71a1a47f)(([textureNode, lodNode = (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(3)])=>{
    const fLodSize = (0, $d5b7ee61758b2e81$export$e9830bc863290a54)(textureNode.size((0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)(lodNode)));
    const cLodSize = (0, $d5b7ee61758b2e81$export$e9830bc863290a54)(textureNode.size((0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)(lodNode.add(1.0))));
    const fLodSizeInv = (0, $3f1f23fea79ae256$export$159d9494db57879b)(1.0, fLodSize);
    const cLodSizeInv = (0, $3f1f23fea79ae256$export$159d9494db57879b)(1.0, cLodSize);
    const fSample = $82ae7c00e8a2de76$var$bicubic(textureNode, (0, $d5b7ee61758b2e81$export$6dba2a1f0d609415)(fLodSizeInv, fLodSize), (0, $f37ae0e58866c183$export$a3fe094919f356fd)(lodNode));
    const cSample = $82ae7c00e8a2de76$var$bicubic(textureNode, (0, $d5b7ee61758b2e81$export$6dba2a1f0d609415)(cLodSizeInv, cLodSize), (0, $f37ae0e58866c183$export$803ce6b71a0a94b2)(lodNode));
    return (0, $f37ae0e58866c183$export$a57bfe0eb79af278)(lodNode).mix(fSample, cSample);
});








class $9031e3b738d66fad$var$PointUVNode extends (0, $65e77d5c3a27a66a$export$2e2bcd8739ae039) {
    static get type() {
        return 'PointUVNode';
    }
    constructor(){
        super('vec2');
        this.isPointUVNode = true;
    }
    generate() {
        return 'vec2( gl_PointCoord.x, 1.0 - gl_PointCoord.y )';
    }
}
var $9031e3b738d66fad$export$2e2bcd8739ae039 = $9031e3b738d66fad$var$PointUVNode;
const $9031e3b738d66fad$export$50a103c0d3009b9c = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$25c7ddd7ae9b45f3)($9031e3b738d66fad$var$PointUVNode);













const $25d2163f514a019a$var$_e1 = /*@__PURE__*/ new (0, $ac384e7663319ba6$export$d93cc409a0768c5f)();
const $25d2163f514a019a$var$_m1 = /*@__PURE__*/ new (0, $0ea09116adcadf95$export$2ae72fc923e5eb5)();
class $25d2163f514a019a$var$SceneNode extends (0, $65e77d5c3a27a66a$export$2e2bcd8739ae039) {
    static get type() {
        return 'SceneNode';
    }
    constructor(scope = $25d2163f514a019a$var$SceneNode.BACKGROUND_BLURRINESS, scene = null){
        super();
        this.scope = scope;
        this.scene = scene;
    }
    setup(builder) {
        const scope = this.scope;
        const scene = this.scene !== null ? this.scene : builder.scene;
        let output;
        if (scope === $25d2163f514a019a$var$SceneNode.BACKGROUND_BLURRINESS) output = (0, $7082d3a91c21cd99$export$ca50aac9f3ba507f)('backgroundBlurriness', 'float', scene);
        else if (scope === $25d2163f514a019a$var$SceneNode.BACKGROUND_INTENSITY) output = (0, $7082d3a91c21cd99$export$ca50aac9f3ba507f)('backgroundIntensity', 'float', scene);
        else if (scope === $25d2163f514a019a$var$SceneNode.BACKGROUND_ROTATION) output = (0, $5eb92bf12e57daab$export$379455b567eff87d)('mat4').label('backgroundRotation').setGroup((0, $d2c0f7c752a63c18$export$a75a8692b47c7f9e)).onRenderUpdate(()=>{
            const background = scene.background;
            if (background !== null && background.isTexture && background.mapping !== (0, $cb5ee595c0f892af$export$1beec6768cbb3d2d)) {
                $25d2163f514a019a$var$_e1.copy(scene.backgroundRotation);
                // accommodate left-handed frame
                $25d2163f514a019a$var$_e1.x *= -1;
                $25d2163f514a019a$var$_e1.y *= -1;
                $25d2163f514a019a$var$_e1.z *= -1;
                $25d2163f514a019a$var$_m1.makeRotationFromEuler($25d2163f514a019a$var$_e1);
            } else $25d2163f514a019a$var$_m1.identity();
            return $25d2163f514a019a$var$_m1;
        });
        else console.error('THREE.SceneNode: Unknown scope:', scope);
        return output;
    }
}
$25d2163f514a019a$var$SceneNode.BACKGROUND_BLURRINESS = 'backgroundBlurriness';
$25d2163f514a019a$var$SceneNode.BACKGROUND_INTENSITY = 'backgroundIntensity';
$25d2163f514a019a$var$SceneNode.BACKGROUND_ROTATION = 'backgroundRotation';
var $25d2163f514a019a$export$2e2bcd8739ae039 = $25d2163f514a019a$var$SceneNode;
const $25d2163f514a019a$export$4e4686c12357d6e1 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$25c7ddd7ae9b45f3)($25d2163f514a019a$var$SceneNode, $25d2163f514a019a$var$SceneNode.BACKGROUND_BLURRINESS);
const $25d2163f514a019a$export$aefe029977c9e2d3 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$25c7ddd7ae9b45f3)($25d2163f514a019a$var$SceneNode, $25d2163f514a019a$var$SceneNode.BACKGROUND_INTENSITY);
const $25d2163f514a019a$export$e59ff0f31e16f9ed = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$25c7ddd7ae9b45f3)($25d2163f514a019a$var$SceneNode, $25d2163f514a019a$var$SceneNode.BACKGROUND_ROTATION);







class $d95cefd8506acfea$var$StorageArrayElementNode extends (0, $e2cc991ce11e1c78$export$2e2bcd8739ae039) {
    static get type() {
        return 'StorageArrayElementNode';
    }
    constructor(storageBufferNode, indexNode){
        super(storageBufferNode, indexNode);
        this.isStorageArrayElementNode = true;
    }
    set storageBufferNode(value) {
        this.node = value;
    }
    get storageBufferNode() {
        return this.node;
    }
    setup(builder) {
        if (builder.isAvailable('storageBuffer') === false) {
            if (this.node.bufferObject === true) builder.setupPBO(this.node);
        }
        return super.setup(builder);
    }
    generate(builder, output) {
        let snippet;
        const isAssignContext = builder.context.assign;
        //
        if (builder.isAvailable('storageBuffer') === false) {
            if (this.node.bufferObject === true && isAssignContext !== true) snippet = builder.generatePBO(this);
            else snippet = this.node.build(builder);
        } else snippet = super.generate(builder);
        if (isAssignContext !== true) {
            const type = this.getNodeType(builder);
            snippet = builder.format(snippet, type, output);
        }
        return snippet;
    }
}
var $d95cefd8506acfea$export$2e2bcd8739ae039 = $d95cefd8506acfea$var$StorageArrayElementNode;
const $d95cefd8506acfea$export$9c4d65803fb1edd1 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$60d11c6747b7deba)($d95cefd8506acfea$var$StorageArrayElementNode);


const $65e789322b24f25c$export$ee82e1b1a0f4eece = {
    PointList: 'point-list',
    LineList: 'line-list',
    LineStrip: 'line-strip',
    TriangleList: 'triangle-list',
    TriangleStrip: 'triangle-strip'
};
const $65e789322b24f25c$export$d3b4cc57abc1eb2b = {
    Never: 'never',
    Less: 'less',
    Equal: 'equal',
    LessEqual: 'less-equal',
    Greater: 'greater',
    NotEqual: 'not-equal',
    GreaterEqual: 'greater-equal',
    Always: 'always'
};
const $65e789322b24f25c$export$d6b072117316704a = {
    Store: 'store',
    Discard: 'discard'
};
const $65e789322b24f25c$export$e23f171c304e7eb1 = {
    Load: 'load',
    Clear: 'clear'
};
const $65e789322b24f25c$export$8231fbc54c1f8d17 = {
    CCW: 'ccw',
    CW: 'cw'
};
const $65e789322b24f25c$export$e4ecb46d830701d5 = {
    None: 'none',
    Front: 'front',
    Back: 'back'
};
const $65e789322b24f25c$export$6a6945c8ae14b3d0 = {
    Uint16: 'uint16',
    Uint32: 'uint32'
};
const $65e789322b24f25c$export$ddeb401c8e6a90ed = {
    Uint8x2: 'uint8x2',
    Uint8x4: 'uint8x4',
    Sint8x2: 'sint8x2',
    Sint8x4: 'sint8x4',
    Unorm8x2: 'unorm8x2',
    Unorm8x4: 'unorm8x4',
    Snorm8x2: 'snorm8x2',
    Snorm8x4: 'snorm8x4',
    Uint16x2: 'uint16x2',
    Uint16x4: 'uint16x4',
    Sint16x2: 'sint16x2',
    Sint16x4: 'sint16x4',
    Unorm16x2: 'unorm16x2',
    Unorm16x4: 'unorm16x4',
    Snorm16x2: 'snorm16x2',
    Snorm16x4: 'snorm16x4',
    Float16x2: 'float16x2',
    Float16x4: 'float16x4',
    Float32: 'float32',
    Float32x2: 'float32x2',
    Float32x3: 'float32x3',
    Float32x4: 'float32x4',
    Uint32: 'uint32',
    Uint32x2: 'uint32x2',
    Uint32x3: 'uint32x3',
    Uint32x4: 'uint32x4',
    Sint32: 'sint32',
    Sint32x2: 'sint32x2',
    Sint32x3: 'sint32x3',
    Sint32x4: 'sint32x4'
};
const $65e789322b24f25c$export$e19f37cdec813149 = {
    // 8-bit formats
    R8Unorm: 'r8unorm',
    R8Snorm: 'r8snorm',
    R8Uint: 'r8uint',
    R8Sint: 'r8sint',
    // 16-bit formats
    R16Uint: 'r16uint',
    R16Sint: 'r16sint',
    R16Float: 'r16float',
    RG8Unorm: 'rg8unorm',
    RG8Snorm: 'rg8snorm',
    RG8Uint: 'rg8uint',
    RG8Sint: 'rg8sint',
    // 32-bit formats
    R32Uint: 'r32uint',
    R32Sint: 'r32sint',
    R32Float: 'r32float',
    RG16Uint: 'rg16uint',
    RG16Sint: 'rg16sint',
    RG16Float: 'rg16float',
    RGBA8Unorm: 'rgba8unorm',
    RGBA8UnormSRGB: 'rgba8unorm-srgb',
    RGBA8Snorm: 'rgba8snorm',
    RGBA8Uint: 'rgba8uint',
    RGBA8Sint: 'rgba8sint',
    BGRA8Unorm: 'bgra8unorm',
    BGRA8UnormSRGB: 'bgra8unorm-srgb',
    // Packed 32-bit formats
    RGB9E5UFloat: 'rgb9e5ufloat',
    RGB10A2Unorm: 'rgb10a2unorm',
    RG11B10uFloat: 'rgb10a2unorm',
    // 64-bit formats
    RG32Uint: 'rg32uint',
    RG32Sint: 'rg32sint',
    RG32Float: 'rg32float',
    RGBA16Uint: 'rgba16uint',
    RGBA16Sint: 'rgba16sint',
    RGBA16Float: 'rgba16float',
    // 128-bit formats
    RGBA32Uint: 'rgba32uint',
    RGBA32Sint: 'rgba32sint',
    RGBA32Float: 'rgba32float',
    // Depth and stencil formats
    Stencil8: 'stencil8',
    Depth16Unorm: 'depth16unorm',
    Depth24Plus: 'depth24plus',
    Depth24PlusStencil8: 'depth24plus-stencil8',
    Depth32Float: 'depth32float',
    // 'depth32float-stencil8' extension
    Depth32FloatStencil8: 'depth32float-stencil8',
    // BC compressed formats usable if 'texture-compression-bc' is both
    // supported by the device/user agent and enabled in requestDevice.
    BC1RGBAUnorm: 'bc1-rgba-unorm',
    BC1RGBAUnormSRGB: 'bc1-rgba-unorm-srgb',
    BC2RGBAUnorm: 'bc2-rgba-unorm',
    BC2RGBAUnormSRGB: 'bc2-rgba-unorm-srgb',
    BC3RGBAUnorm: 'bc3-rgba-unorm',
    BC3RGBAUnormSRGB: 'bc3-rgba-unorm-srgb',
    BC4RUnorm: 'bc4-r-unorm',
    BC4RSnorm: 'bc4-r-snorm',
    BC5RGUnorm: 'bc5-rg-unorm',
    BC5RGSnorm: 'bc5-rg-snorm',
    BC6HRGBUFloat: 'bc6h-rgb-ufloat',
    BC6HRGBFloat: 'bc6h-rgb-float',
    BC7RGBAUnorm: 'bc7-rgba-unorm',
    BC7RGBAUnormSRGB: 'bc7-rgba-srgb',
    // ETC2 compressed formats usable if 'texture-compression-etc2' is both
    // supported by the device/user agent and enabled in requestDevice.
    ETC2RGB8Unorm: 'etc2-rgb8unorm',
    ETC2RGB8UnormSRGB: 'etc2-rgb8unorm-srgb',
    ETC2RGB8A1Unorm: 'etc2-rgb8a1unorm',
    ETC2RGB8A1UnormSRGB: 'etc2-rgb8a1unorm-srgb',
    ETC2RGBA8Unorm: 'etc2-rgba8unorm',
    ETC2RGBA8UnormSRGB: 'etc2-rgba8unorm-srgb',
    EACR11Unorm: 'eac-r11unorm',
    EACR11Snorm: 'eac-r11snorm',
    EACRG11Unorm: 'eac-rg11unorm',
    EACRG11Snorm: 'eac-rg11snorm',
    // ASTC compressed formats usable if 'texture-compression-astc' is both
    // supported by the device/user agent and enabled in requestDevice.
    ASTC4x4Unorm: 'astc-4x4-unorm',
    ASTC4x4UnormSRGB: 'astc-4x4-unorm-srgb',
    ASTC5x4Unorm: 'astc-5x4-unorm',
    ASTC5x4UnormSRGB: 'astc-5x4-unorm-srgb',
    ASTC5x5Unorm: 'astc-5x5-unorm',
    ASTC5x5UnormSRGB: 'astc-5x5-unorm-srgb',
    ASTC6x5Unorm: 'astc-6x5-unorm',
    ASTC6x5UnormSRGB: 'astc-6x5-unorm-srgb',
    ASTC6x6Unorm: 'astc-6x6-unorm',
    ASTC6x6UnormSRGB: 'astc-6x6-unorm-srgb',
    ASTC8x5Unorm: 'astc-8x5-unorm',
    ASTC8x5UnormSRGB: 'astc-8x5-unorm-srgb',
    ASTC8x6Unorm: 'astc-8x6-unorm',
    ASTC8x6UnormSRGB: 'astc-8x6-unorm-srgb',
    ASTC8x8Unorm: 'astc-8x8-unorm',
    ASTC8x8UnormSRGB: 'astc-8x8-unorm-srgb',
    ASTC10x5Unorm: 'astc-10x5-unorm',
    ASTC10x5UnormSRGB: 'astc-10x5-unorm-srgb',
    ASTC10x6Unorm: 'astc-10x6-unorm',
    ASTC10x6UnormSRGB: 'astc-10x6-unorm-srgb',
    ASTC10x8Unorm: 'astc-10x8-unorm',
    ASTC10x8UnormSRGB: 'astc-10x8-unorm-srgb',
    ASTC10x10Unorm: 'astc-10x10-unorm',
    ASTC10x10UnormSRGB: 'astc-10x10-unorm-srgb',
    ASTC12x10Unorm: 'astc-12x10-unorm',
    ASTC12x10UnormSRGB: 'astc-12x10-unorm-srgb',
    ASTC12x12Unorm: 'astc-12x12-unorm',
    ASTC12x12UnormSRGB: 'astc-12x12-unorm-srgb'
};
const $65e789322b24f25c$export$4c41e9c18981742d = {
    ClampToEdge: 'clamp-to-edge',
    Repeat: 'repeat',
    MirrorRepeat: 'mirror-repeat'
};
const $65e789322b24f25c$export$9948723cf5806885 = {
    Linear: 'linear',
    Nearest: 'nearest'
};
const $65e789322b24f25c$export$cfc4e42b8aca3783 = {
    Zero: 'zero',
    One: 'one',
    Src: 'src',
    OneMinusSrc: 'one-minus-src',
    SrcAlpha: 'src-alpha',
    OneMinusSrcAlpha: 'one-minus-src-alpha',
    Dst: 'dst',
    OneMinusDstColor: 'one-minus-dst',
    DstAlpha: 'dst-alpha',
    OneMinusDstAlpha: 'one-minus-dst-alpha',
    SrcAlphaSaturated: 'src-alpha-saturated',
    Constant: 'constant',
    OneMinusConstant: 'one-minus-constant'
};
const $65e789322b24f25c$export$952412cf8c851ac4 = {
    Add: 'add',
    Subtract: 'subtract',
    ReverseSubtract: 'reverse-subtract',
    Min: 'min',
    Max: 'max'
};
const $65e789322b24f25c$export$98bf55822960ed5f = {
    None: 0,
    Red: 0x1,
    Green: 0x2,
    Blue: 0x4,
    Alpha: 0x8,
    All: 0xF
};
const $65e789322b24f25c$export$378a9c05c4b63f89 = {
    Keep: 'keep',
    Zero: 'zero',
    Replace: 'replace',
    Invert: 'invert',
    IncrementClamp: 'increment-clamp',
    DecrementClamp: 'decrement-clamp',
    IncrementWrap: 'increment-wrap',
    DecrementWrap: 'decrement-wrap'
};
const $65e789322b24f25c$export$1fafb3ddf4a8fbc0 = {
    Uniform: 'uniform',
    Storage: 'storage',
    ReadOnlyStorage: 'read-only-storage'
};
const $65e789322b24f25c$export$1d4987105a935841 = {
    WriteOnly: 'write-only',
    ReadOnly: 'read-only',
    ReadWrite: 'read-write'
};
const $65e789322b24f25c$export$713daf515b4e258e = {
    Filtering: 'filtering',
    NonFiltering: 'non-filtering',
    Comparison: 'comparison'
};
const $65e789322b24f25c$export$b61d1a527b6a55af = {
    Float: 'float',
    UnfilterableFloat: 'unfilterable-float',
    Depth: 'depth',
    SInt: 'sint',
    UInt: 'uint'
};
const $65e789322b24f25c$export$ef10a754a74446cb = {
    OneD: '1d',
    TwoD: '2d',
    ThreeD: '3d'
};
const $65e789322b24f25c$export$e9c73c9e5554baf7 = {
    OneD: '1d',
    TwoD: '2d',
    TwoDArray: '2d-array',
    Cube: 'cube',
    CubeArray: 'cube-array',
    ThreeD: '3d'
};
const $65e789322b24f25c$export$9f7640f14f08c6a8 = {
    All: 'all',
    StencilOnly: 'stencil-only',
    DepthOnly: 'depth-only'
};
const $65e789322b24f25c$export$8d7390ef8d16d49b = {
    Vertex: 'vertex',
    Instance: 'instance'
};
const $65e789322b24f25c$export$97a86f8b50a49c2b = {
    DepthClipControl: 'depth-clip-control',
    Depth32FloatStencil8: 'depth32float-stencil8',
    TextureCompressionBC: 'texture-compression-bc',
    TextureCompressionETC2: 'texture-compression-etc2',
    TextureCompressionASTC: 'texture-compression-astc',
    TimestampQuery: 'timestamp-query',
    IndirectFirstInstance: 'indirect-first-instance',
    ShaderF16: 'shader-f16',
    RG11B10UFloat: 'rg11b10ufloat-renderable',
    BGRA8UNormStorage: 'bgra8unorm-storage',
    Float32Filterable: 'float32-filterable',
    ClipDistances: 'clip-distances',
    DualSourceBlending: 'dual-source-blending',
    Subgroups: 'subgroups'
};


class $df3b974c56c754e9$var$StorageBufferNode extends (0, $108a458e3a76f5dc$export$2e2bcd8739ae039) {
    static get type() {
        return 'StorageBufferNode';
    }
    constructor(value, bufferType, bufferCount = 0){
        super(value, bufferType, bufferCount);
        this.isStorageBufferNode = true;
        this.access = (0, $65e789322b24f25c$export$1fafb3ddf4a8fbc0).Storage;
        this.isAtomic = false;
        this.bufferObject = false;
        this.bufferCount = bufferCount;
        this._attribute = null;
        this._varying = null;
        this.global = true;
        if (value.isStorageBufferAttribute !== true && value.isStorageInstancedBufferAttribute !== true) {
            // TOOD: Improve it, possibly adding a new property to the BufferAttribute to identify it as a storage buffer read-only attribute in Renderer
            if (value.isInstancedBufferAttribute) value.isStorageInstancedBufferAttribute = true;
            else value.isStorageBufferAttribute = true;
        }
    }
    getHash(builder) {
        if (this.bufferCount === 0) {
            let bufferData = builder.globalCache.getData(this.value);
            if (bufferData === undefined) {
                bufferData = {
                    node: this
                };
                builder.globalCache.setData(this.value, bufferData);
            }
            return bufferData.node.uuid;
        }
        return this.uuid;
    }
    getInputType() {
        return this.value.isIndirectStorageBufferAttribute ? 'indirectStorageBuffer' : 'storageBuffer';
    }
    element(indexNode) {
        return (0, $d95cefd8506acfea$export$9c4d65803fb1edd1)(this, indexNode);
    }
    setBufferObject(value) {
        this.bufferObject = value;
        return this;
    }
    setAccess(value) {
        this.access = value;
        return this;
    }
    toReadOnly() {
        return this.setAccess((0, $65e789322b24f25c$export$1fafb3ddf4a8fbc0).ReadOnlyStorage);
    }
    setAtomic(value) {
        this.isAtomic = value;
        return this;
    }
    toAtomic() {
        return this.setAtomic(true);
    }
    getAttributeData() {
        if (this._attribute === null) {
            this._attribute = (0, $48306ea9f4feeeae$export$1a0889be1cc680b2)(this.value);
            this._varying = (0, $c497538e811cb09b$export$3f47f02b8134ef8a)(this._attribute);
        }
        return {
            attribute: this._attribute,
            varying: this._varying
        };
    }
    getNodeType(builder) {
        if (builder.isAvailable('storageBuffer') || builder.isAvailable('indirectStorageBuffer')) return super.getNodeType(builder);
        const { attribute: attribute } = this.getAttributeData();
        return attribute.getNodeType(builder);
    }
    generate(builder) {
        if (builder.isAvailable('storageBuffer') || builder.isAvailable('indirectStorageBuffer')) return super.generate(builder);
        const { attribute: attribute, varying: varying } = this.getAttributeData();
        const output = varying.build(builder);
        builder.registerTransform(output, attribute);
        return output;
    }
}
var $df3b974c56c754e9$export$2e2bcd8739ae039 = $df3b974c56c754e9$var$StorageBufferNode;
const $df3b974c56c754e9$export$ddcffe0146c8f882 = (value, type, count)=>(0, $d5b7ee61758b2e81$export$e97474e17004dd41)(new $df3b974c56c754e9$var$StorageBufferNode(value, type, count));
const $df3b974c56c754e9$export$4c8781371e5dd1de = (value, type, count)=>(0, $d5b7ee61758b2e81$export$e97474e17004dd41)(new $df3b974c56c754e9$var$StorageBufferNode(value, type, count).setBufferObject(true));








class $00e2c9fc9211c1fb$var$StorageTextureNode extends (0, $f7d68bbf9ea772a7$export$2e2bcd8739ae039) {
    static get type() {
        return 'StorageTextureNode';
    }
    constructor(value, uvNode, storeNode = null){
        super(value, uvNode);
        this.storeNode = storeNode;
        this.isStorageTextureNode = true;
        this.access = (0, $65e789322b24f25c$export$1d4987105a935841).WriteOnly;
    }
    getInputType() {
        return 'storageTexture';
    }
    setup(builder) {
        super.setup(builder);
        const properties = builder.getNodeProperties(this);
        properties.storeNode = this.storeNode;
    }
    setAccess(value) {
        this.access = value;
        return this;
    }
    generate(builder, output) {
        let snippet;
        if (this.storeNode !== null) snippet = this.generateStore(builder);
        else snippet = super.generate(builder, output);
        return snippet;
    }
    toReadOnly() {
        return this.setAccess((0, $65e789322b24f25c$export$1d4987105a935841).ReadOnly);
    }
    toWriteOnly() {
        return this.setAccess((0, $65e789322b24f25c$export$1d4987105a935841).WriteOnly);
    }
    generateStore(builder) {
        const properties = builder.getNodeProperties(this);
        const { uvNode: uvNode, storeNode: storeNode } = properties;
        const textureProperty = super.generate(builder, 'property');
        const uvSnippet = uvNode.build(builder, 'uvec2');
        const storeSnippet = storeNode.build(builder, 'vec4');
        const snippet = builder.generateTextureStore(builder, textureProperty, uvSnippet, storeSnippet);
        builder.addLineFlowCode(snippet, this);
    }
}
var $00e2c9fc9211c1fb$export$2e2bcd8739ae039 = $00e2c9fc9211c1fb$var$StorageTextureNode;
const $00e2c9fc9211c1fb$export$9ed08aebb0b17ff6 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$60d11c6747b7deba)($00e2c9fc9211c1fb$var$StorageTextureNode);
const $00e2c9fc9211c1fb$export$487fc156e9e78580 = (value, uvNode, storeNode)=>{
    const node = $00e2c9fc9211c1fb$export$9ed08aebb0b17ff6(value, uvNode, storeNode);
    if (storeNode !== null) node.append();
    return node;
};




const $ceab469c56af6755$var$normal = (0, $d5b7ee61758b2e81$export$b076717d71a1a47f)(({ texture: texture, uv: uv })=>{
    const epsilon = 0.0001;
    const ret = (0, $d5b7ee61758b2e81$export$9100789c9d999364)().toVar();
    (0, $d5b7ee61758b2e81$export$1f9ff5f4a6c9361a)(uv.x.lessThan(epsilon), ()=>{
        ret.assign((0, $d5b7ee61758b2e81$export$9100789c9d999364)(1, 0, 0));
    }).ElseIf(uv.y.lessThan(epsilon), ()=>{
        ret.assign((0, $d5b7ee61758b2e81$export$9100789c9d999364)(0, 1, 0));
    }).ElseIf(uv.z.lessThan(epsilon), ()=>{
        ret.assign((0, $d5b7ee61758b2e81$export$9100789c9d999364)(0, 0, 1));
    }).ElseIf(uv.x.greaterThan(1 - epsilon), ()=>{
        ret.assign((0, $d5b7ee61758b2e81$export$9100789c9d999364)(-1, 0, 0));
    }).ElseIf(uv.y.greaterThan(1 - epsilon), ()=>{
        ret.assign((0, $d5b7ee61758b2e81$export$9100789c9d999364)(0, -1, 0));
    }).ElseIf(uv.z.greaterThan(1 - epsilon), ()=>{
        ret.assign((0, $d5b7ee61758b2e81$export$9100789c9d999364)(0, 0, -1));
    }).Else(()=>{
        const step = 0.01;
        const x = texture.uv(uv.add((0, $d5b7ee61758b2e81$export$9100789c9d999364)(-step, 0.0, 0.0))).r.sub(texture.uv(uv.add((0, $d5b7ee61758b2e81$export$9100789c9d999364)(step, 0.0, 0.0))).r);
        const y = texture.uv(uv.add((0, $d5b7ee61758b2e81$export$9100789c9d999364)(0.0, -step, 0.0))).r.sub(texture.uv(uv.add((0, $d5b7ee61758b2e81$export$9100789c9d999364)(0.0, step, 0.0))).r);
        const z = texture.uv(uv.add((0, $d5b7ee61758b2e81$export$9100789c9d999364)(0.0, 0.0, -step))).r.sub(texture.uv(uv.add((0, $d5b7ee61758b2e81$export$9100789c9d999364)(0.0, 0.0, step))).r);
        ret.assign((0, $d5b7ee61758b2e81$export$9100789c9d999364)(x, y, z));
    });
    return ret.normalize();
});
class $ceab469c56af6755$var$Texture3DNode extends (0, $f7d68bbf9ea772a7$export$2e2bcd8739ae039) {
    static get type() {
        return 'Texture3DNode';
    }
    constructor(value, uvNode = null, levelNode = null){
        super(value, uvNode, levelNode);
        this.isTexture3DNode = true;
    }
    getInputType() {
        return 'texture3D';
    }
    getDefaultUV() {
        return (0, $d5b7ee61758b2e81$export$9100789c9d999364)(0.5, 0.5, 0.5);
    }
    setUpdateMatrix() {}
    setupUV(builder, uvNode) {
        return uvNode;
    }
    generateUV(builder, uvNode) {
        return uvNode.build(builder, 'vec3');
    }
    normal(uvNode) {
        return $ceab469c56af6755$var$normal({
            texture: this,
            uv: uvNode
        });
    }
}
var $ceab469c56af6755$export$2e2bcd8739ae039 = $ceab469c56af6755$var$Texture3DNode;
const $ceab469c56af6755$export$e66778913d66afb2 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$60d11c6747b7deba)($ceab469c56af6755$var$Texture3DNode);





class $13df98add45860f8$var$UserDataNode extends (0, $7082d3a91c21cd99$export$2e2bcd8739ae039) {
    static get type() {
        return 'UserDataNode';
    }
    constructor(property, inputType, userData = null){
        super(property, inputType, userData);
        this.userData = userData;
    }
    updateReference(state) {
        this.reference = this.userData !== null ? this.userData : state.object.userData;
        return this.reference;
    }
}
var $13df98add45860f8$export$2e2bcd8739ae039 = $13df98add45860f8$var$UserDataNode;
const $13df98add45860f8$export$c2507140e5bb8721 = (name, inputType, userData)=>(0, $d5b7ee61758b2e81$export$e97474e17004dd41)(new $13df98add45860f8$var$UserDataNode(name, inputType, userData));












const $f117f4e485ead13a$var$_objectData = new WeakMap();
class $f117f4e485ead13a$var$VelocityNode extends (0, $75c45ed2361c955f$export$2e2bcd8739ae039) {
    static get type() {
        return 'VelocityNode';
    }
    constructor(){
        super('vec2');
        this.projectionMatrix = null;
        this.updateType = (0, $ddcfecb7fbba5d74$export$26f7a8bbd9469530).OBJECT;
        this.updateAfterType = (0, $ddcfecb7fbba5d74$export$26f7a8bbd9469530).OBJECT;
        this.previousModelWorldMatrix = (0, $5eb92bf12e57daab$export$379455b567eff87d)(new (0, $0ea09116adcadf95$export$2ae72fc923e5eb5)());
        this.previousProjectionMatrix = (0, $5eb92bf12e57daab$export$379455b567eff87d)(new (0, $0ea09116adcadf95$export$2ae72fc923e5eb5)()).setGroup((0, $d2c0f7c752a63c18$export$a75a8692b47c7f9e));
        this.previousCameraViewMatrix = (0, $5eb92bf12e57daab$export$379455b567eff87d)(new (0, $0ea09116adcadf95$export$2ae72fc923e5eb5)());
    }
    setProjectionMatrix(projectionMatrix) {
        this.projectionMatrix = projectionMatrix;
    }
    update({ frameId: frameId, camera: camera, object: object }) {
        const previousModelMatrix = $f117f4e485ead13a$var$getPreviousMatrix(object);
        this.previousModelWorldMatrix.value.copy(previousModelMatrix);
        //
        const cameraData = $f117f4e485ead13a$var$getData(camera);
        if (cameraData.frameId !== frameId) {
            cameraData.frameId = frameId;
            if (cameraData.previousProjectionMatrix === undefined) {
                cameraData.previousProjectionMatrix = new (0, $0ea09116adcadf95$export$2ae72fc923e5eb5)();
                cameraData.previousCameraViewMatrix = new (0, $0ea09116adcadf95$export$2ae72fc923e5eb5)();
                cameraData.currentProjectionMatrix = new (0, $0ea09116adcadf95$export$2ae72fc923e5eb5)();
                cameraData.currentCameraViewMatrix = new (0, $0ea09116adcadf95$export$2ae72fc923e5eb5)();
                cameraData.previousProjectionMatrix.copy(this.projectionMatrix || camera.projectionMatrix);
                cameraData.previousCameraViewMatrix.copy(camera.matrixWorldInverse);
            } else {
                cameraData.previousProjectionMatrix.copy(cameraData.currentProjectionMatrix);
                cameraData.previousCameraViewMatrix.copy(cameraData.currentCameraViewMatrix);
            }
            cameraData.currentProjectionMatrix.copy(this.projectionMatrix || camera.projectionMatrix);
            cameraData.currentCameraViewMatrix.copy(camera.matrixWorldInverse);
            this.previousProjectionMatrix.value.copy(cameraData.previousProjectionMatrix);
            this.previousCameraViewMatrix.value.copy(cameraData.previousCameraViewMatrix);
        }
    }
    updateAfter({ object: object }) {
        $f117f4e485ead13a$var$getPreviousMatrix(object).copy(object.matrixWorld);
    }
    setup() {
        const projectionMatrix = this.projectionMatrix === null ? (0, $aa7db78c76b9331c$export$dc8d743682f60b2d) : (0, $5eb92bf12e57daab$export$379455b567eff87d)(this.projectionMatrix);
        const previousModelViewMatrix = this.previousCameraViewMatrix.mul(this.previousModelWorldMatrix);
        const clipPositionCurrent = projectionMatrix.mul((0, $c03c6edd36966f29$export$57d0df277658535e)).mul((0, $acbec2070ba15851$export$78cc3a7ea225109f));
        const clipPositionPrevious = this.previousProjectionMatrix.mul(previousModelViewMatrix).mul((0, $acbec2070ba15851$export$f69e3bac20b8ae8f));
        const ndcPositionCurrent = clipPositionCurrent.xy.div(clipPositionCurrent.w);
        const ndcPositionPrevious = clipPositionPrevious.xy.div(clipPositionPrevious.w);
        const velocity = (0, $3f1f23fea79ae256$export$f93b5905241a7cca)(ndcPositionCurrent, ndcPositionPrevious);
        return velocity;
    }
}
function $f117f4e485ead13a$var$getData(object) {
    let objectData = $f117f4e485ead13a$var$_objectData.get(object);
    if (objectData === undefined) {
        objectData = {};
        $f117f4e485ead13a$var$_objectData.set(object, objectData);
    }
    return objectData;
}
function $f117f4e485ead13a$var$getPreviousMatrix(object, index = 0) {
    const objectData = $f117f4e485ead13a$var$getData(object);
    let matrix = objectData[index];
    if (matrix === undefined) objectData[index] = matrix = new (0, $0ea09116adcadf95$export$2ae72fc923e5eb5)();
    return matrix;
}
var $f117f4e485ead13a$export$2e2bcd8739ae039 = $f117f4e485ead13a$var$VelocityNode;
const $f117f4e485ead13a$export$b9fe5d314b12b4ca = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$25c7ddd7ae9b45f3)($f117f4e485ead13a$var$VelocityNode);




const $d6e4788e061bd183$export$9c0bd85cee0180d7 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$b076717d71a1a47f)(([base, blend])=>{
    return (0, $f37ae0e58866c183$export$96ec731ed4dcb222)(1.0, base.oneMinus().div(blend)).oneMinus();
}).setLayout({
    name: 'burnBlend',
    type: 'vec3',
    inputs: [
        {
            name: 'base',
            type: 'vec3'
        },
        {
            name: 'blend',
            type: 'vec3'
        }
    ]
});
const $d6e4788e061bd183$export$aff2976bcdc2c076 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$b076717d71a1a47f)(([base, blend])=>{
    return (0, $f37ae0e58866c183$export$96ec731ed4dcb222)(base.div(blend.oneMinus()), 1.0);
}).setLayout({
    name: 'dodgeBlend',
    type: 'vec3',
    inputs: [
        {
            name: 'base',
            type: 'vec3'
        },
        {
            name: 'blend',
            type: 'vec3'
        }
    ]
});
const $d6e4788e061bd183$export$be623a1d3e871e62 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$b076717d71a1a47f)(([base, blend])=>{
    return base.oneMinus().mul(blend.oneMinus()).oneMinus();
}).setLayout({
    name: 'screenBlend',
    type: 'vec3',
    inputs: [
        {
            name: 'base',
            type: 'vec3'
        },
        {
            name: 'blend',
            type: 'vec3'
        }
    ]
});
const $d6e4788e061bd183$export$29dd17c7f3c81c36 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$b076717d71a1a47f)(([base, blend])=>{
    return (0, $f37ae0e58866c183$export$2c9e8a9632a706b2)(base.mul(2.0).mul(blend), base.oneMinus().mul(2.0).mul(blend.oneMinus()).oneMinus(), (0, $f37ae0e58866c183$export$35d34bc0ed591a92)(0.5, base));
}).setLayout({
    name: 'overlayBlend',
    type: 'vec3',
    inputs: [
        {
            name: 'base',
            type: 'vec3'
        },
        {
            name: 'blend',
            type: 'vec3'
        }
    ]
});









const $b6068b62b099979c$export$6f416a6db2dfcd5c = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$b076717d71a1a47f)(([color])=>{
    return $b6068b62b099979c$export$5c6e3c2b59b7fbbe(color.rgb);
});
const $b6068b62b099979c$export$c8ee7f6ff22a137e = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$b076717d71a1a47f)(([color, adjustment = (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(1)])=>{
    return adjustment.mix($b6068b62b099979c$export$5c6e3c2b59b7fbbe(color.rgb), color.rgb);
});
const $b6068b62b099979c$export$9d69f5c452819e4 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$b076717d71a1a47f)(([color, adjustment = (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(1)])=>{
    const average = (0, $3f1f23fea79ae256$export$e16d8520af44a096)(color.r, color.g, color.b).div(3.0);
    const mx = color.r.max(color.g.max(color.b));
    const amt = mx.sub(average).mul(adjustment).mul(-3);
    return (0, $f37ae0e58866c183$export$2c9e8a9632a706b2)(color.rgb, mx, amt);
});
const $b6068b62b099979c$export$97d7b0c7ddb78dcf = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$b076717d71a1a47f)(([color, adjustment = (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(1)])=>{
    const k = (0, $d5b7ee61758b2e81$export$9100789c9d999364)(0.57735, 0.57735, 0.57735);
    const cosAngle = adjustment.cos();
    return (0, $d5b7ee61758b2e81$export$9100789c9d999364)(color.rgb.mul(cosAngle).add(k.cross(color.rgb).mul(adjustment.sin()).add(k.mul((0, $f37ae0e58866c183$export$94132a0e348806d4)(k, color.rgb).mul(cosAngle.oneMinus())))));
});
const $b6068b62b099979c$export$5c6e3c2b59b7fbbe = (color, luminanceCoefficients = (0, $d5b7ee61758b2e81$export$9100789c9d999364)((0, $46d4f6f1be9702a8$export$5e6fd513f44698c).getLuminanceCoefficients(new (0, $d7d0ac0e47013885$export$64b5c384219d3699)())))=>(0, $f37ae0e58866c183$export$94132a0e348806d4)(color, luminanceCoefficients);
const $b6068b62b099979c$export$454d09aca5f3ea63 = (color, threshold)=>(0, $f37ae0e58866c183$export$2c9e8a9632a706b2)((0, $d5b7ee61758b2e81$export$9100789c9d999364)(0.0), color, $b6068b62b099979c$export$5c6e3c2b59b7fbbe(color).sub(threshold).max(0));
const $b6068b62b099979c$export$8d0d877e7b15977e = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$b076717d71a1a47f)(([color, slope = (0, $d5b7ee61758b2e81$export$9100789c9d999364)(1), offset = (0, $d5b7ee61758b2e81$export$9100789c9d999364)(0), power = (0, $d5b7ee61758b2e81$export$9100789c9d999364)(1), saturation = (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(1), // ASC CDL v1.2 explicitly requires Rec. 709 luminance coefficients.
luminanceCoefficients = (0, $d5b7ee61758b2e81$export$9100789c9d999364)((0, $46d4f6f1be9702a8$export$5e6fd513f44698c).getLuminanceCoefficients(new (0, $d7d0ac0e47013885$export$64b5c384219d3699)(), (0, $cb5ee595c0f892af$export$42429b3acfb233a4)))])=>{
    // NOTE: The ASC CDL v1.2 defines a [0, 1] clamp on the slope+offset term, and another on the
    // saturation term. Per the ACEScc specification and Filament, limits may be omitted to support
    // values outside [0, 1], requiring a workaround for negative values in the power expression.
    const luma = color.rgb.dot((0, $d5b7ee61758b2e81$export$9100789c9d999364)(luminanceCoefficients));
    const v = (0, $f37ae0e58866c183$export$8960430cfd85939f)(color.rgb.mul(slope).add(offset), 0.0).toVar();
    const pv = v.pow(power).toVar();
    (0, $d5b7ee61758b2e81$export$1f9ff5f4a6c9361a)(v.r.greaterThan(0.0), ()=>{
        v.r.assign(pv.r);
    }); // eslint-disable-line
    (0, $d5b7ee61758b2e81$export$1f9ff5f4a6c9361a)(v.g.greaterThan(0.0), ()=>{
        v.g.assign(pv.g);
    }); // eslint-disable-line
    (0, $d5b7ee61758b2e81$export$1f9ff5f4a6c9361a)(v.b.greaterThan(0.0), ()=>{
        v.b.assign(pv.b);
    }); // eslint-disable-line
    v.assign(luma.add(v.sub(luma).mul(saturation)));
    return (0, $d5b7ee61758b2e81$export$6dba2a1f0d609415)(v.rgb, color.a);
});







class $0b05205064950acc$var$PosterizeNode extends (0, $75c45ed2361c955f$export$2e2bcd8739ae039) {
    static get type() {
        return 'PosterizeNode';
    }
    constructor(sourceNode, stepsNode){
        super();
        this.sourceNode = sourceNode;
        this.stepsNode = stepsNode;
    }
    setup() {
        const { sourceNode: sourceNode, stepsNode: stepsNode } = this;
        return sourceNode.mul(stepsNode).floor().div(stepsNode);
    }
}
var $0b05205064950acc$export$2e2bcd8739ae039 = $0b05205064950acc$var$PosterizeNode;
const $0b05205064950acc$export$59be2f703dc04855 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$60d11c6747b7deba)($0b05205064950acc$var$PosterizeNode);









let $78d7284c9b1d75b6$var$_sharedFramebuffer = null;
class $78d7284c9b1d75b6$var$ViewportSharedTextureNode extends (0, $3a0ecc63acbbffaf$export$2e2bcd8739ae039) {
    static get type() {
        return 'ViewportSharedTextureNode';
    }
    constructor(uvNode = (0, $64df2f32a1195518$export$e2a68d187fb2dd60), levelNode = null){
        if ($78d7284c9b1d75b6$var$_sharedFramebuffer === null) $78d7284c9b1d75b6$var$_sharedFramebuffer = new (0, $ab9242dba7b93e7e$export$9270d786f73ce6fe)();
        super(uvNode, levelNode, $78d7284c9b1d75b6$var$_sharedFramebuffer);
    }
    updateReference() {
        return this;
    }
}
var $78d7284c9b1d75b6$export$2e2bcd8739ae039 = $78d7284c9b1d75b6$var$ViewportSharedTextureNode;
const $78d7284c9b1d75b6$export$53eb1fc033315f55 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$60d11c6747b7deba)($78d7284c9b1d75b6$var$ViewportSharedTextureNode);























const $989854e30c000729$var$_size = /*@__PURE__*/ new (0, $3c03061dea0adea3$export$c977b3e384af9ae1)();
class $989854e30c000729$var$PassTextureNode extends (0, $f7d68bbf9ea772a7$export$2e2bcd8739ae039) {
    static get type() {
        return 'PassTextureNode';
    }
    constructor(passNode, texture){
        super(texture);
        this.passNode = passNode;
        this.setUpdateMatrix(false);
    }
    setup(builder) {
        if (builder.object.isQuadMesh) this.passNode.build(builder);
        return super.setup(builder);
    }
    clone() {
        return new this.constructor(this.passNode, this.value);
    }
}
class $989854e30c000729$var$PassMultipleTextureNode extends $989854e30c000729$var$PassTextureNode {
    static get type() {
        return 'PassMultipleTextureNode';
    }
    constructor(passNode, textureName, previousTexture = false){
        super(passNode, null);
        this.textureName = textureName;
        this.previousTexture = previousTexture;
    }
    updateTexture() {
        this.value = this.previousTexture ? this.passNode.getPreviousTexture(this.textureName) : this.passNode.getTexture(this.textureName);
    }
    setup(builder) {
        this.updateTexture();
        return super.setup(builder);
    }
    clone() {
        return new this.constructor(this.passNode, this.textureName, this.previousTexture);
    }
}
class $989854e30c000729$var$PassNode extends (0, $75c45ed2361c955f$export$2e2bcd8739ae039) {
    static get type() {
        return 'PassNode';
    }
    constructor(scope, scene, camera, options = {}){
        super('vec4');
        this.scope = scope;
        this.scene = scene;
        this.camera = camera;
        this.options = options;
        this._pixelRatio = 1;
        this._width = 1;
        this._height = 1;
        const depthTexture = new (0, $520286b5db9c7cf5$export$fc830aa069cc8c2f)();
        depthTexture.isRenderTargetTexture = true;
        //depthTexture.type = FloatType;
        depthTexture.name = 'depth';
        const renderTarget = new (0, $2ca03eab531e649d$export$efcb1f8bf367cbfb)(this._width * this._pixelRatio, this._height * this._pixelRatio, {
            type: (0, $cb5ee595c0f892af$export$2697304443f382bc),
            ...options
        });
        renderTarget.texture.name = 'output';
        renderTarget.depthTexture = depthTexture;
        this.renderTarget = renderTarget;
        this.updateBeforeType = (0, $ddcfecb7fbba5d74$export$26f7a8bbd9469530).FRAME;
        this._textures = {
            output: renderTarget.texture,
            depth: depthTexture
        };
        this._textureNodes = {};
        this._linearDepthNodes = {};
        this._viewZNodes = {};
        this._previousTextures = {};
        this._previousTextureNodes = {};
        this._cameraNear = (0, $5eb92bf12e57daab$export$379455b567eff87d)(0);
        this._cameraFar = (0, $5eb92bf12e57daab$export$379455b567eff87d)(0);
        this._mrt = null;
        this.isPassNode = true;
    }
    setMRT(mrt) {
        this._mrt = mrt;
        return this;
    }
    getMRT() {
        return this._mrt;
    }
    isGlobal() {
        return true;
    }
    getTexture(name) {
        let texture = this._textures[name];
        if (texture === undefined) {
            const refTexture = this.renderTarget.texture;
            texture = refTexture.clone();
            texture.isRenderTargetTexture = true;
            texture.name = name;
            this._textures[name] = texture;
            this.renderTarget.textures.push(texture);
        }
        return texture;
    }
    getPreviousTexture(name) {
        let texture = this._previousTextures[name];
        if (texture === undefined) {
            texture = this.getTexture(name).clone();
            texture.isRenderTargetTexture = true;
            this._previousTextures[name] = texture;
        }
        return texture;
    }
    toggleTexture(name) {
        const prevTexture = this._previousTextures[name];
        if (prevTexture !== undefined) {
            const texture = this._textures[name];
            const index = this.renderTarget.textures.indexOf(texture);
            this.renderTarget.textures[index] = prevTexture;
            this._textures[name] = prevTexture;
            this._previousTextures[name] = texture;
            this._textureNodes[name].updateTexture();
            this._previousTextureNodes[name].updateTexture();
        }
    }
    getTextureNode(name = 'output') {
        let textureNode = this._textureNodes[name];
        if (textureNode === undefined) {
            textureNode = (0, $d5b7ee61758b2e81$export$e97474e17004dd41)(new $989854e30c000729$var$PassMultipleTextureNode(this, name));
            textureNode.updateTexture();
            this._textureNodes[name] = textureNode;
        }
        return textureNode;
    }
    getPreviousTextureNode(name = 'output') {
        let textureNode = this._previousTextureNodes[name];
        if (textureNode === undefined) {
            if (this._textureNodes[name] === undefined) this.getTextureNode(name);
            textureNode = (0, $d5b7ee61758b2e81$export$e97474e17004dd41)(new $989854e30c000729$var$PassMultipleTextureNode(this, name, true));
            textureNode.updateTexture();
            this._previousTextureNodes[name] = textureNode;
        }
        return textureNode;
    }
    getViewZNode(name = 'depth') {
        let viewZNode = this._viewZNodes[name];
        if (viewZNode === undefined) {
            const cameraNear = this._cameraNear;
            const cameraFar = this._cameraFar;
            this._viewZNodes[name] = viewZNode = (0, $c2ec92bdddb724e3$export$be58bb2e0c565f9d)(this.getTextureNode(name), cameraNear, cameraFar);
        }
        return viewZNode;
    }
    getLinearDepthNode(name = 'depth') {
        let linearDepthNode = this._linearDepthNodes[name];
        if (linearDepthNode === undefined) {
            const cameraNear = this._cameraNear;
            const cameraFar = this._cameraFar;
            const viewZNode = this.getViewZNode(name);
            // TODO: just if ( builder.camera.isPerspectiveCamera )
            this._linearDepthNodes[name] = linearDepthNode = (0, $c2ec92bdddb724e3$export$22f8344c678d1434)(viewZNode, cameraNear, cameraFar);
        }
        return linearDepthNode;
    }
    setup({ renderer: renderer }) {
        this.renderTarget.samples = this.options.samples === undefined ? renderer.samples : this.options.samples;
        // Disable MSAA for WebGL backend for now
        if (renderer.backend.isWebGLBackend === true) this.renderTarget.samples = 0;
        this.renderTarget.depthTexture.isMultisampleRenderTargetTexture = this.renderTarget.samples > 1;
        return this.scope === $989854e30c000729$var$PassNode.COLOR ? this.getTextureNode() : this.getLinearDepthNode();
    }
    updateBefore(frame) {
        const { renderer: renderer } = frame;
        const { scene: scene, camera: camera } = this;
        this._pixelRatio = renderer.getPixelRatio();
        const size = renderer.getSize($989854e30c000729$var$_size);
        this.setSize(size.width, size.height);
        const currentRenderTarget = renderer.getRenderTarget();
        const currentMRT = renderer.getMRT();
        this._cameraNear.value = camera.near;
        this._cameraFar.value = camera.far;
        for(const name in this._previousTextures)this.toggleTexture(name);
        renderer.setRenderTarget(this.renderTarget);
        renderer.setMRT(this._mrt);
        renderer.render(scene, camera);
        renderer.setRenderTarget(currentRenderTarget);
        renderer.setMRT(currentMRT);
    }
    setSize(width, height) {
        this._width = width;
        this._height = height;
        const effectiveWidth = this._width * this._pixelRatio;
        const effectiveHeight = this._height * this._pixelRatio;
        this.renderTarget.setSize(effectiveWidth, effectiveHeight);
    }
    setPixelRatio(pixelRatio) {
        this._pixelRatio = pixelRatio;
        this.setSize(this._width, this._height);
    }
    dispose() {
        this.renderTarget.dispose();
    }
}
$989854e30c000729$var$PassNode.COLOR = 'color';
$989854e30c000729$var$PassNode.DEPTH = 'depth';
var $989854e30c000729$export$2e2bcd8739ae039 = $989854e30c000729$var$PassNode;
const $989854e30c000729$export$167b0ad523238611 = (scene, camera, options)=>(0, $d5b7ee61758b2e81$export$e97474e17004dd41)(new $989854e30c000729$var$PassNode($989854e30c000729$var$PassNode.COLOR, scene, camera, options));
const $989854e30c000729$export$a187b3ab90f602e4 = (pass, texture)=>(0, $d5b7ee61758b2e81$export$e97474e17004dd41)(new $989854e30c000729$var$PassTextureNode(pass, texture));
const $989854e30c000729$export$e1b0df3d1505bf0b = (scene, camera)=>(0, $d5b7ee61758b2e81$export$e97474e17004dd41)(new $989854e30c000729$var$PassNode($989854e30c000729$var$PassNode.DEPTH, scene, camera));


class $f12badc9c16469c3$var$ToonOutlinePassNode extends (0, $989854e30c000729$export$2e2bcd8739ae039) {
    static get type() {
        return 'ToonOutlinePassNode';
    }
    constructor(scene, camera, colorNode, thicknessNode, alphaNode){
        super((0, $989854e30c000729$export$2e2bcd8739ae039).COLOR, scene, camera);
        this.colorNode = colorNode;
        this.thicknessNode = thicknessNode;
        this.alphaNode = alphaNode;
        this._materialCache = new WeakMap();
    }
    updateBefore(frame) {
        const { renderer: renderer } = frame;
        const currentRenderObjectFunction = renderer.getRenderObjectFunction();
        renderer.setRenderObjectFunction((object, scene, camera, geometry, material, group, lightsNode)=>{
            // only render outline for supported materials
            if (material.isMeshToonMaterial || material.isMeshToonNodeMaterial) {
                if (material.wireframe === false) {
                    const outlineMaterial = this._getOutlineMaterial(material);
                    renderer.renderObject(object, scene, camera, geometry, outlineMaterial, group, lightsNode);
                }
            }
            // default
            renderer.renderObject(object, scene, camera, geometry, material, group, lightsNode);
        });
        super.updateBefore(frame);
        renderer.setRenderObjectFunction(currentRenderObjectFunction);
    }
    _createMaterial() {
        const material = new (0, $1a485f4d26090da0$export$2e2bcd8739ae039)();
        material.isMeshToonOutlineMaterial = true;
        material.name = 'Toon_Outline';
        material.side = (0, $cb5ee595c0f892af$export$d9f0486e75b5ace);
        // vertex node
        const outlineNormal = (0, $0ab44deffc8ae973$export$c94af1e24aa56d8f).negate();
        const mvp = (0, $aa7db78c76b9331c$export$dc8d743682f60b2d).mul((0, $c03c6edd36966f29$export$57d0df277658535e));
        const ratio = (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(1.0); // TODO: support outline thickness ratio for each vertex
        const pos = mvp.mul((0, $d5b7ee61758b2e81$export$6dba2a1f0d609415)((0, $acbec2070ba15851$export$78cc3a7ea225109f), 1.0));
        const pos2 = mvp.mul((0, $d5b7ee61758b2e81$export$6dba2a1f0d609415)((0, $acbec2070ba15851$export$78cc3a7ea225109f).add(outlineNormal), 1.0));
        const norm = (0, $f37ae0e58866c183$export$a3295358bff77e)(pos.sub(pos2)); // NOTE: subtract pos2 from pos because BackSide objectNormal is negative
        material.vertexNode = pos.add(norm.mul(this.thicknessNode).mul(pos.w).mul(ratio));
        // color node
        material.colorNode = (0, $d5b7ee61758b2e81$export$6dba2a1f0d609415)(this.colorNode, this.alphaNode);
        return material;
    }
    _getOutlineMaterial(originalMaterial) {
        let outlineMaterial = this._materialCache.get(originalMaterial);
        if (outlineMaterial === undefined) {
            outlineMaterial = this._createMaterial();
            this._materialCache.set(originalMaterial, outlineMaterial);
        }
        return outlineMaterial;
    }
}
var $f12badc9c16469c3$export$2e2bcd8739ae039 = $f12badc9c16469c3$var$ToonOutlinePassNode;
const $f12badc9c16469c3$export$7a8cf1b308819516 = (scene, camera, color = new (0, $9a23ce591a1b6760$export$892596cec99bc70e)(0, 0, 0), thickness = 0.003, alpha = 1)=>(0, $d5b7ee61758b2e81$export$e97474e17004dd41)(new $f12badc9c16469c3$var$ToonOutlinePassNode(scene, camera, (0, $d5b7ee61758b2e81$export$e97474e17004dd41)(color), (0, $d5b7ee61758b2e81$export$e97474e17004dd41)(thickness), (0, $d5b7ee61758b2e81$export$e97474e17004dd41)(alpha)));








const $e93fc3d73612d493$export$9ead2d769de45b3a = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$b076717d71a1a47f)(([color, exposure])=>{
    return color.mul(exposure).clamp();
}).setLayout({
    name: 'linearToneMapping',
    type: 'vec3',
    inputs: [
        {
            name: 'color',
            type: 'vec3'
        },
        {
            name: 'exposure',
            type: 'float'
        }
    ]
});
const $e93fc3d73612d493$export$67ddcedc4b180767 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$b076717d71a1a47f)(([color, exposure])=>{
    color = color.mul(exposure);
    return color.div(color.add(1.0)).clamp();
}).setLayout({
    name: 'reinhardToneMapping',
    type: 'vec3',
    inputs: [
        {
            name: 'color',
            type: 'vec3'
        },
        {
            name: 'exposure',
            type: 'float'
        }
    ]
});
const $e93fc3d73612d493$export$1e6226a4b0daaf11 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$b076717d71a1a47f)(([color, exposure])=>{
    // filmic operator by Jim Hejl and Richard Burgess-Dawson
    color = color.mul(exposure);
    color = color.sub(0.004).max(0.0);
    const a = color.mul(color.mul(6.2).add(0.5));
    const b = color.mul(color.mul(6.2).add(1.7)).add(0.06);
    return a.div(b).pow(2.2);
}).setLayout({
    name: 'cineonToneMapping',
    type: 'vec3',
    inputs: [
        {
            name: 'color',
            type: 'vec3'
        },
        {
            name: 'exposure',
            type: 'float'
        }
    ]
});
// source: https://github.com/selfshadow/ltc_code/blob/master/webgl/shaders/ltc/ltc_blit.fs
const $e93fc3d73612d493$var$RRTAndODTFit = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$b076717d71a1a47f)(([color])=>{
    const a = color.mul(color.add(0.0245786)).sub(0.000090537);
    const b = color.mul(color.add(0.4329510).mul(0.983729)).add(0.238081);
    return a.div(b);
});
const $e93fc3d73612d493$export$2c3e905d79539321 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$b076717d71a1a47f)(([color, exposure])=>{
    // sRGB => XYZ => D65_2_D60 => AP1 => RRT_SAT
    const ACESInputMat = (0, $d5b7ee61758b2e81$export$e43bd9f504e4ac00)(0.59719, 0.35458, 0.04823, 0.07600, 0.90834, 0.01566, 0.02840, 0.13383, 0.83777);
    // ODT_SAT => XYZ => D60_2_D65 => sRGB
    const ACESOutputMat = (0, $d5b7ee61758b2e81$export$e43bd9f504e4ac00)(1.60475, -0.53108, -0.07367, -0.10208, 1.10813, -0.00605, -0.00327, -0.07276, 1.07602);
    color = color.mul(exposure).div(0.6);
    color = ACESInputMat.mul(color);
    // Apply RRT and ODT
    color = $e93fc3d73612d493$var$RRTAndODTFit(color);
    color = ACESOutputMat.mul(color);
    // Clamp to [0, 1]
    return color.clamp();
}).setLayout({
    name: 'acesFilmicToneMapping',
    type: 'vec3',
    inputs: [
        {
            name: 'color',
            type: 'vec3'
        },
        {
            name: 'exposure',
            type: 'float'
        }
    ]
});
const $e93fc3d73612d493$var$LINEAR_REC2020_TO_LINEAR_SRGB = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$e43bd9f504e4ac00)((0, $d5b7ee61758b2e81$export$9100789c9d999364)(1.6605, -0.1246, -0.0182), (0, $d5b7ee61758b2e81$export$9100789c9d999364)(-0.5876, 1.1329, -0.1006), (0, $d5b7ee61758b2e81$export$9100789c9d999364)(-0.0728, -0.0083, 1.1187));
const $e93fc3d73612d493$var$LINEAR_SRGB_TO_LINEAR_REC2020 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$e43bd9f504e4ac00)((0, $d5b7ee61758b2e81$export$9100789c9d999364)(0.6274, 0.0691, 0.0164), (0, $d5b7ee61758b2e81$export$9100789c9d999364)(0.3293, 0.9195, 0.0880), (0, $d5b7ee61758b2e81$export$9100789c9d999364)(0.0433, 0.0113, 0.8956));
const $e93fc3d73612d493$var$agxDefaultContrastApprox = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$b076717d71a1a47f)(([x_immutable])=>{
    const x = (0, $d5b7ee61758b2e81$export$9100789c9d999364)(x_immutable).toVar();
    const x2 = (0, $d5b7ee61758b2e81$export$9100789c9d999364)(x.mul(x)).toVar();
    const x4 = (0, $d5b7ee61758b2e81$export$9100789c9d999364)(x2.mul(x2)).toVar();
    return (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(15.5).mul(x4.mul(x2)).sub((0, $3f1f23fea79ae256$export$6e3a27864ab166fe)(40.14, x4.mul(x))).add((0, $3f1f23fea79ae256$export$6e3a27864ab166fe)(31.96, x4).sub((0, $3f1f23fea79ae256$export$6e3a27864ab166fe)(6.868, x2.mul(x))).add((0, $3f1f23fea79ae256$export$6e3a27864ab166fe)(0.4298, x2).add((0, $3f1f23fea79ae256$export$6e3a27864ab166fe)(0.1191, x).sub(0.00232))));
});
const $e93fc3d73612d493$export$e208838cf33e57e8 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$b076717d71a1a47f)(([color, exposure])=>{
    const colortone = (0, $d5b7ee61758b2e81$export$9100789c9d999364)(color).toVar();
    const AgXInsetMatrix = (0, $d5b7ee61758b2e81$export$e43bd9f504e4ac00)((0, $d5b7ee61758b2e81$export$9100789c9d999364)(0.856627153315983, 0.137318972929847, 0.11189821299995), (0, $d5b7ee61758b2e81$export$9100789c9d999364)(0.0951212405381588, 0.761241990602591, 0.0767994186031903), (0, $d5b7ee61758b2e81$export$9100789c9d999364)(0.0482516061458583, 0.101439036467562, 0.811302368396859));
    const AgXOutsetMatrix = (0, $d5b7ee61758b2e81$export$e43bd9f504e4ac00)((0, $d5b7ee61758b2e81$export$9100789c9d999364)(1.1271005818144368, -0.1413297634984383, -0.14132976349843826), (0, $d5b7ee61758b2e81$export$9100789c9d999364)(-0.11060664309660323, 1.157823702216272, -0.11060664309660294), (0, $d5b7ee61758b2e81$export$9100789c9d999364)(-0.016493938717834573, -0.016493938717834257, 1.2519364065950405));
    const AgxMinEv = (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(-12.47393);
    const AgxMaxEv = (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(4.026069);
    colortone.mulAssign(exposure);
    colortone.assign($e93fc3d73612d493$var$LINEAR_SRGB_TO_LINEAR_REC2020.mul(colortone));
    colortone.assign(AgXInsetMatrix.mul(colortone));
    colortone.assign((0, $f37ae0e58866c183$export$8960430cfd85939f)(colortone, 1e-10));
    colortone.assign((0, $f37ae0e58866c183$export$b9fae0bba9d9094d)(colortone));
    colortone.assign(colortone.sub(AgxMinEv).div(AgxMaxEv.sub(AgxMinEv)));
    colortone.assign((0, $f37ae0e58866c183$export$7d15b64cf5a3a4c4)(colortone, 0.0, 1.0));
    colortone.assign($e93fc3d73612d493$var$agxDefaultContrastApprox(colortone));
    colortone.assign(AgXOutsetMatrix.mul(colortone));
    colortone.assign((0, $f37ae0e58866c183$export$9c297f60e22e3389)((0, $f37ae0e58866c183$export$8960430cfd85939f)((0, $d5b7ee61758b2e81$export$9100789c9d999364)(0.0), colortone), (0, $d5b7ee61758b2e81$export$9100789c9d999364)(2.2)));
    colortone.assign($e93fc3d73612d493$var$LINEAR_REC2020_TO_LINEAR_SRGB.mul(colortone));
    colortone.assign((0, $f37ae0e58866c183$export$7d15b64cf5a3a4c4)(colortone, 0.0, 1.0));
    return colortone;
}).setLayout({
    name: 'agxToneMapping',
    type: 'vec3',
    inputs: [
        {
            name: 'color',
            type: 'vec3'
        },
        {
            name: 'exposure',
            type: 'float'
        }
    ]
});
const $e93fc3d73612d493$export$59c2cf1ae89c695a = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$b076717d71a1a47f)(([color, exposure])=>{
    const StartCompression = (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(0.76);
    const Desaturation = (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(0.15);
    color = color.mul(exposure);
    const x = (0, $f37ae0e58866c183$export$96ec731ed4dcb222)(color.r, (0, $f37ae0e58866c183$export$96ec731ed4dcb222)(color.g, color.b));
    const offset = (0, $cb309bf1d9ed8a72$export$2e6c959c16ff56b8)(x.lessThan(0.08), x.sub((0, $3f1f23fea79ae256$export$6e3a27864ab166fe)(6.25, x.mul(x))), 0.04);
    color.subAssign(offset);
    const peak = (0, $f37ae0e58866c183$export$8960430cfd85939f)(color.r, (0, $f37ae0e58866c183$export$8960430cfd85939f)(color.g, color.b));
    (0, $d5b7ee61758b2e81$export$1f9ff5f4a6c9361a)(peak.lessThan(StartCompression), ()=>{
        return color;
    });
    const d = (0, $3f1f23fea79ae256$export$f93b5905241a7cca)(1, StartCompression);
    const newPeak = (0, $3f1f23fea79ae256$export$f93b5905241a7cca)(1, d.mul(d).div(peak.add(d.sub(StartCompression))));
    color.mulAssign(newPeak.div(peak));
    const g = (0, $3f1f23fea79ae256$export$f93b5905241a7cca)(1, (0, $3f1f23fea79ae256$export$159d9494db57879b)(1, Desaturation.mul(peak.sub(newPeak)).add(1)));
    return (0, $f37ae0e58866c183$export$2c9e8a9632a706b2)(color, (0, $d5b7ee61758b2e81$export$9100789c9d999364)(newPeak), g);
}).setLayout({
    name: 'neutralToneMapping',
    type: 'vec3',
    inputs: [
        {
            name: 'color',
            type: 'vec3'
        },
        {
            name: 'exposure',
            type: 'float'
        }
    ]
});





class $6ab1fbe365a50a7b$var$CodeNode extends (0, $65e77d5c3a27a66a$export$2e2bcd8739ae039) {
    static get type() {
        return 'CodeNode';
    }
    constructor(code = '', includes = [], language = ''){
        super('code');
        this.isCodeNode = true;
        this.code = code;
        this.language = language;
        this.includes = includes;
    }
    isGlobal() {
        return true;
    }
    setIncludes(includes) {
        this.includes = includes;
        return this;
    }
    getIncludes() {
        return this.includes;
    }
    generate(builder) {
        const includes = this.getIncludes(builder);
        for (const include of includes)include.build(builder);
        const nodeCode = builder.getCodeFromNode(this, this.getNodeType(builder));
        nodeCode.code = this.code;
        return nodeCode.code;
    }
    serialize(data) {
        super.serialize(data);
        data.code = this.code;
        data.language = this.language;
    }
    deserialize(data) {
        super.deserialize(data);
        this.code = data.code;
        this.language = data.language;
    }
}
var $6ab1fbe365a50a7b$export$2e2bcd8739ae039 = $6ab1fbe365a50a7b$var$CodeNode;
const $6ab1fbe365a50a7b$export$6565f9f03506010b = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$60d11c6747b7deba)($6ab1fbe365a50a7b$var$CodeNode);
const $6ab1fbe365a50a7b$export$2371fdf5d68c366c = (src, includes)=>$6ab1fbe365a50a7b$export$6565f9f03506010b(src, includes, 'js');
const $6ab1fbe365a50a7b$export$e04176e940221313 = (src, includes)=>$6ab1fbe365a50a7b$export$6565f9f03506010b(src, includes, 'wgsl');
const $6ab1fbe365a50a7b$export$c1b1a45ed915aad9 = (src, includes)=>$6ab1fbe365a50a7b$export$6565f9f03506010b(src, includes, 'glsl');





class $df3d32ffc049420e$var$FunctionNode extends (0, $6ab1fbe365a50a7b$export$2e2bcd8739ae039) {
    static get type() {
        return 'FunctionNode';
    }
    constructor(code = '', includes = [], language = ''){
        super(code, includes, language);
    }
    getNodeType(builder) {
        return this.getNodeFunction(builder).type;
    }
    getInputs(builder) {
        return this.getNodeFunction(builder).inputs;
    }
    getNodeFunction(builder) {
        const nodeData = builder.getDataFromNode(this);
        let nodeFunction = nodeData.nodeFunction;
        if (nodeFunction === undefined) {
            nodeFunction = builder.parser.parseFunction(this.code);
            nodeData.nodeFunction = nodeFunction;
        }
        return nodeFunction;
    }
    generate(builder, output) {
        super.generate(builder);
        const nodeFunction = this.getNodeFunction(builder);
        const name = nodeFunction.name;
        const type = nodeFunction.type;
        const nodeCode = builder.getCodeFromNode(this, type);
        if (name !== '') // use a custom property name
        nodeCode.name = name;
        const propertyName = builder.getPropertyName(nodeCode);
        const code = this.getNodeFunction(builder).getCode(propertyName);
        nodeCode.code = code + '\n';
        if (output === 'property') return propertyName;
        else return builder.format(`${propertyName}()`, type, output);
    }
}
var $df3d32ffc049420e$export$2e2bcd8739ae039 = $df3d32ffc049420e$var$FunctionNode;
const $df3d32ffc049420e$var$nativeFn = (code, includes = [], language = '')=>{
    for(let i = 0; i < includes.length; i++){
        const include = includes[i];
        // TSL Function: glslFn, wgslFn
        if (typeof include === 'function') includes[i] = include.functionNode;
    }
    const functionNode = (0, $d5b7ee61758b2e81$export$e97474e17004dd41)(new $df3d32ffc049420e$var$FunctionNode(code, includes, language));
    const fn = (...params)=>functionNode.call(...params);
    fn.functionNode = functionNode;
    return fn;
};
const $df3d32ffc049420e$export$43d10d3026c18b22 = (code, includes)=>$df3d32ffc049420e$var$nativeFn(code, includes, 'glsl');
const $df3d32ffc049420e$export$621a9f928cb4a662 = (code, includes)=>$df3d32ffc049420e$var$nativeFn(code, includes, 'wgsl');







class $c87702dbf993cba3$var$ScriptableValueNode extends (0, $65e77d5c3a27a66a$export$2e2bcd8739ae039) {
    static get type() {
        return 'ScriptableValueNode';
    }
    constructor(value = null){
        super();
        this._value = value;
        this._cache = null;
        this.inputType = null;
        this.outpuType = null;
        this.events = new (0, $a35132d5d9375da3$export$ec8b666c5fe2c75a)();
        this.isScriptableValueNode = true;
    }
    get isScriptableOutputNode() {
        return this.outputType !== null;
    }
    set value(val) {
        if (this._value === val) return;
        if (this._cache && this.inputType === 'URL' && this.value.value instanceof ArrayBuffer) {
            URL.revokeObjectURL(this._cache);
            this._cache = null;
        }
        this._value = val;
        this.events.dispatchEvent({
            type: 'change'
        });
        this.refresh();
    }
    get value() {
        return this._value;
    }
    refresh() {
        this.events.dispatchEvent({
            type: 'refresh'
        });
    }
    getValue() {
        const value = this.value;
        if (value && this._cache === null && this.inputType === 'URL' && value.value instanceof ArrayBuffer) this._cache = URL.createObjectURL(new Blob([
            value.value
        ]));
        else if (value && value.value !== null && value.value !== undefined && ((this.inputType === 'URL' || this.inputType === 'String') && typeof value.value === 'string' || this.inputType === 'Number' && typeof value.value === 'number' || this.inputType === 'Vector2' && value.value.isVector2 || this.inputType === 'Vector3' && value.value.isVector3 || this.inputType === 'Vector4' && value.value.isVector4 || this.inputType === 'Color' && value.value.isColor || this.inputType === 'Matrix3' && value.value.isMatrix3 || this.inputType === 'Matrix4' && value.value.isMatrix4)) return value.value;
        return this._cache || value;
    }
    getNodeType(builder) {
        return this.value && this.value.isNode ? this.value.getNodeType(builder) : 'float';
    }
    setup() {
        return this.value && this.value.isNode ? this.value : (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)();
    }
    serialize(data) {
        super.serialize(data);
        if (this.value !== null) {
            if (this.inputType === 'ArrayBuffer') data.value = (0, $97d1d441621670a9$export$70c4ae293293ca1e)(this.value);
            else data.value = this.value ? this.value.toJSON(data.meta).uuid : null;
        } else data.value = null;
        data.inputType = this.inputType;
        data.outputType = this.outputType;
    }
    deserialize(data) {
        super.deserialize(data);
        let value = null;
        if (data.value !== null) {
            if (data.inputType === 'ArrayBuffer') value = (0, $97d1d441621670a9$export$a7a17e76664e3e44)(data.value);
            else if (data.inputType === 'Texture') value = data.meta.textures[data.value];
            else value = data.meta.nodes[data.value] || null;
        }
        this.value = value;
        this.inputType = data.inputType;
        this.outputType = data.outputType;
    }
}
var $c87702dbf993cba3$export$2e2bcd8739ae039 = $c87702dbf993cba3$var$ScriptableValueNode;
const $c87702dbf993cba3$export$42b02b32bb931341 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$60d11c6747b7deba)($c87702dbf993cba3$var$ScriptableValueNode);




class $fb2127dab27fdc71$var$Resources extends Map {
    get(key, callback = null, ...params) {
        if (this.has(key)) return super.get(key);
        if (callback !== null) {
            const value = callback(...params);
            this.set(key, value);
            return value;
        }
    }
}
class $fb2127dab27fdc71$var$Parameters {
    constructor(scriptableNode){
        this.scriptableNode = scriptableNode;
    }
    get parameters() {
        return this.scriptableNode.parameters;
    }
    get layout() {
        return this.scriptableNode.getLayout();
    }
    getInputLayout(id) {
        return this.scriptableNode.getInputLayout(id);
    }
    get(name) {
        const param = this.parameters[name];
        const value = param ? param.getValue() : null;
        return value;
    }
}
const $fb2127dab27fdc71$export$dfb38fba8fcf842b = new $fb2127dab27fdc71$var$Resources();
class $fb2127dab27fdc71$var$ScriptableNode extends (0, $65e77d5c3a27a66a$export$2e2bcd8739ae039) {
    static get type() {
        return 'ScriptableNode';
    }
    constructor(codeNode = null, parameters = {}){
        super();
        this.codeNode = codeNode;
        this.parameters = parameters;
        this._local = new $fb2127dab27fdc71$var$Resources();
        this._output = (0, $c87702dbf993cba3$export$42b02b32bb931341)();
        this._outputs = {};
        this._source = this.source;
        this._method = null;
        this._object = null;
        this._value = null;
        this._needsOutputUpdate = true;
        this.onRefresh = this.onRefresh.bind(this);
        this.isScriptableNode = true;
    }
    get source() {
        return this.codeNode ? this.codeNode.code : '';
    }
    setLocal(name, value) {
        return this._local.set(name, value);
    }
    getLocal(name) {
        return this._local.get(name);
    }
    onRefresh() {
        this._refresh();
    }
    getInputLayout(id) {
        for (const element of this.getLayout()){
            if (element.inputType && (element.id === id || element.name === id)) return element;
        }
    }
    getOutputLayout(id) {
        for (const element of this.getLayout()){
            if (element.outputType && (element.id === id || element.name === id)) return element;
        }
    }
    setOutput(name, value) {
        const outputs = this._outputs;
        if (outputs[name] === undefined) outputs[name] = (0, $c87702dbf993cba3$export$42b02b32bb931341)(value);
        else outputs[name].value = value;
        return this;
    }
    getOutput(name) {
        return this._outputs[name];
    }
    getParameter(name) {
        return this.parameters[name];
    }
    setParameter(name, value) {
        const parameters = this.parameters;
        if (value && value.isScriptableNode) {
            this.deleteParameter(name);
            parameters[name] = value;
            parameters[name].getDefaultOutput().events.addEventListener('refresh', this.onRefresh);
        } else if (value && value.isScriptableValueNode) {
            this.deleteParameter(name);
            parameters[name] = value;
            parameters[name].events.addEventListener('refresh', this.onRefresh);
        } else if (parameters[name] === undefined) {
            parameters[name] = (0, $c87702dbf993cba3$export$42b02b32bb931341)(value);
            parameters[name].events.addEventListener('refresh', this.onRefresh);
        } else parameters[name].value = value;
        return this;
    }
    getValue() {
        return this.getDefaultOutput().getValue();
    }
    deleteParameter(name) {
        let valueNode = this.parameters[name];
        if (valueNode) {
            if (valueNode.isScriptableNode) valueNode = valueNode.getDefaultOutput();
            valueNode.events.removeEventListener('refresh', this.onRefresh);
        }
        return this;
    }
    clearParameters() {
        for (const name of Object.keys(this.parameters))this.deleteParameter(name);
        this.needsUpdate = true;
        return this;
    }
    call(name, ...params) {
        const object = this.getObject();
        const method = object[name];
        if (typeof method === 'function') return method(...params);
    }
    async callAsync(name, ...params) {
        const object = this.getObject();
        const method = object[name];
        if (typeof method === 'function') return method.constructor.name === 'AsyncFunction' ? await method(...params) : method(...params);
    }
    getNodeType(builder) {
        return this.getDefaultOutputNode().getNodeType(builder);
    }
    refresh(output = null) {
        if (output !== null) this.getOutput(output).refresh();
        else this._refresh();
    }
    getObject() {
        if (this.needsUpdate) this.dispose();
        if (this._object !== null) return this._object;
        //
        const refresh = ()=>this.refresh();
        const setOutput = (id, value)=>this.setOutput(id, value);
        const parameters = new $fb2127dab27fdc71$var$Parameters(this);
        const THREE = $fb2127dab27fdc71$export$dfb38fba8fcf842b.get('THREE');
        const TSL = $fb2127dab27fdc71$export$dfb38fba8fcf842b.get('TSL');
        const method = this.getMethod(this.codeNode);
        const params = [
            parameters,
            this._local,
            $fb2127dab27fdc71$export$dfb38fba8fcf842b,
            refresh,
            setOutput,
            THREE,
            TSL
        ];
        this._object = method(...params);
        const layout = this._object.layout;
        if (layout) {
            if (layout.cache === false) this._local.clear();
            // default output
            this._output.outputType = layout.outputType || null;
            if (Array.isArray(layout.elements)) for (const element of layout.elements){
                const id = element.id || element.name;
                if (element.inputType) {
                    if (this.getParameter(id) === undefined) this.setParameter(id, null);
                    this.getParameter(id).inputType = element.inputType;
                }
                if (element.outputType) {
                    if (this.getOutput(id) === undefined) this.setOutput(id, null);
                    this.getOutput(id).outputType = element.outputType;
                }
            }
        }
        return this._object;
    }
    deserialize(data) {
        super.deserialize(data);
        for(const name in this.parameters){
            let valueNode = this.parameters[name];
            if (valueNode.isScriptableNode) valueNode = valueNode.getDefaultOutput();
            valueNode.events.addEventListener('refresh', this.onRefresh);
        }
    }
    getLayout() {
        return this.getObject().layout;
    }
    getDefaultOutputNode() {
        const output = this.getDefaultOutput().value;
        if (output && output.isNode) return output;
        return (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)();
    }
    getDefaultOutput() {
        return this._exec()._output;
    }
    getMethod() {
        if (this.needsUpdate) this.dispose();
        if (this._method !== null) return this._method;
        //
        const parametersProps = [
            'parameters',
            'local',
            'global',
            'refresh',
            'setOutput',
            'THREE',
            'TSL'
        ];
        const interfaceProps = [
            'layout',
            'init',
            'main',
            'dispose'
        ];
        const properties = interfaceProps.join(', ');
        const declarations = 'var ' + properties + '; var output = {};\n';
        const returns = '\nreturn { ...output, ' + properties + ' };';
        const code = declarations + this.codeNode.code + returns;
        //
        this._method = new Function(...parametersProps, code);
        return this._method;
    }
    dispose() {
        if (this._method === null) return;
        if (this._object && typeof this._object.dispose === 'function') this._object.dispose();
        this._method = null;
        this._object = null;
        this._source = null;
        this._value = null;
        this._needsOutputUpdate = true;
        this._output.value = null;
        this._outputs = {};
    }
    setup() {
        return this.getDefaultOutputNode();
    }
    getCacheKey(force) {
        const values = [
            (0, $97d1d441621670a9$export$9169be2e06c9c165)(this.source),
            this.getDefaultOutputNode().getCacheKey(force)
        ];
        for(const param in this.parameters)values.push(this.parameters[param].getCacheKey(force));
        return (0, $97d1d441621670a9$export$cf0fb017e44bd6a4)(values);
    }
    set needsUpdate(value) {
        if (value === true) this.dispose();
    }
    get needsUpdate() {
        return this.source !== this._source;
    }
    _exec() {
        if (this.codeNode === null) return this;
        if (this._needsOutputUpdate === true) {
            this._value = this.call('main');
            this._needsOutputUpdate = false;
        }
        this._output.value = this._value;
        return this;
    }
    _refresh() {
        this.needsUpdate = true;
        this._exec();
        this._output.refresh();
    }
}
var $fb2127dab27fdc71$export$2e2bcd8739ae039 = $fb2127dab27fdc71$var$ScriptableNode;
const $fb2127dab27fdc71$export$79490bb4e7cba98b = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$60d11c6747b7deba)($fb2127dab27fdc71$var$ScriptableNode);






class $ea681a48f157ea34$var$FogNode extends (0, $65e77d5c3a27a66a$export$2e2bcd8739ae039) {
    static get type() {
        return 'FogNode';
    }
    constructor(colorNode, factorNode){
        super('float');
        this.isFogNode = true;
        this.colorNode = colorNode;
        this.factorNode = factorNode;
    }
    getViewZNode(builder) {
        let viewZ;
        const getViewZ = builder.context.getViewZ;
        if (getViewZ !== undefined) viewZ = getViewZ(this);
        return (viewZ || (0, $acbec2070ba15851$export$3dfd735ebeac9bfd).z).negate();
    }
    setup() {
        return this.factorNode;
    }
}
var $ea681a48f157ea34$export$2e2bcd8739ae039 = $ea681a48f157ea34$var$FogNode;
const $ea681a48f157ea34$export$fc12593d977205a8 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$60d11c6747b7deba)($ea681a48f157ea34$var$FogNode);





class $59c4f43fccb3aac6$var$FogRangeNode extends (0, $ea681a48f157ea34$export$2e2bcd8739ae039) {
    static get type() {
        return 'FogRangeNode';
    }
    constructor(colorNode, nearNode, farNode){
        super(colorNode);
        this.isFogRangeNode = true;
        this.nearNode = nearNode;
        this.farNode = farNode;
    }
    setup(builder) {
        const viewZ = this.getViewZNode(builder);
        return (0, $f37ae0e58866c183$export$4053e36566dd3d9a)(this.nearNode, this.farNode, viewZ);
    }
}
var $59c4f43fccb3aac6$export$2e2bcd8739ae039 = $59c4f43fccb3aac6$var$FogRangeNode;
const $59c4f43fccb3aac6$export$40551637e51894d4 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$60d11c6747b7deba)($59c4f43fccb3aac6$var$FogRangeNode);




class $90c80656a1da59cb$var$FogExp2Node extends (0, $ea681a48f157ea34$export$2e2bcd8739ae039) {
    static get type() {
        return 'FogExp2Node';
    }
    constructor(colorNode, densityNode){
        super(colorNode);
        this.isFogExp2Node = true;
        this.densityNode = densityNode;
    }
    setup(builder) {
        const viewZ = this.getViewZNode(builder);
        const density = this.densityNode;
        return density.mul(density, viewZ, viewZ).negate().exp().oneMinus();
    }
}
var $90c80656a1da59cb$export$2e2bcd8739ae039 = $90c80656a1da59cb$var$FogExp2Node;
const $90c80656a1da59cb$export$31ec25b1026406ff = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$60d11c6747b7deba)($90c80656a1da59cb$var$FogExp2Node);











let $7d6a7b9b444c1f70$var$min = null;
let $7d6a7b9b444c1f70$var$max = null;
class $7d6a7b9b444c1f70$var$RangeNode extends (0, $65e77d5c3a27a66a$export$2e2bcd8739ae039) {
    static get type() {
        return 'RangeNode';
    }
    constructor(minNode = (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(), maxNode = (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)()){
        super();
        this.minNode = minNode;
        this.maxNode = maxNode;
    }
    getVectorLength(builder) {
        const minLength = builder.getTypeLength((0, $97d1d441621670a9$export$cc7ab17e03dab419)(this.minNode.value));
        const maxLength = builder.getTypeLength((0, $97d1d441621670a9$export$cc7ab17e03dab419)(this.maxNode.value));
        return minLength > maxLength ? minLength : maxLength;
    }
    getNodeType(builder) {
        return builder.object.count > 1 ? builder.getTypeFromLength(this.getVectorLength(builder)) : 'float';
    }
    setup(builder) {
        const object = builder.object;
        let output = null;
        if (object.count > 1) {
            const minValue = this.minNode.value;
            const maxValue = this.maxNode.value;
            const minLength = builder.getTypeLength((0, $97d1d441621670a9$export$cc7ab17e03dab419)(minValue));
            const maxLength = builder.getTypeLength((0, $97d1d441621670a9$export$cc7ab17e03dab419)(maxValue));
            $7d6a7b9b444c1f70$var$min = $7d6a7b9b444c1f70$var$min || new (0, $a09a15e9a8421204$export$fa7daccca11cdbe3)();
            $7d6a7b9b444c1f70$var$max = $7d6a7b9b444c1f70$var$max || new (0, $a09a15e9a8421204$export$fa7daccca11cdbe3)();
            $7d6a7b9b444c1f70$var$min.setScalar(0);
            $7d6a7b9b444c1f70$var$max.setScalar(0);
            if (minLength === 1) $7d6a7b9b444c1f70$var$min.setScalar(minValue);
            else if (minValue.isColor) $7d6a7b9b444c1f70$var$min.set(minValue.r, minValue.g, minValue.b);
            else $7d6a7b9b444c1f70$var$min.set(minValue.x, minValue.y, minValue.z || 0, minValue.w || 0);
            if (maxLength === 1) $7d6a7b9b444c1f70$var$max.setScalar(maxValue);
            else if (maxValue.isColor) $7d6a7b9b444c1f70$var$max.set(maxValue.r, maxValue.g, maxValue.b);
            else $7d6a7b9b444c1f70$var$max.set(maxValue.x, maxValue.y, maxValue.z || 0, maxValue.w || 0);
            const stride = 4;
            const length = stride * object.count;
            const array = new Float32Array(length);
            for(let i = 0; i < length; i++){
                const index = i % stride;
                const minElementValue = $7d6a7b9b444c1f70$var$min.getComponent(index);
                const maxElementValue = $7d6a7b9b444c1f70$var$max.getComponent(index);
                array[i] = (0, $7f727a3c7059d20d$export$6a7ef315a0d1ef07).lerp(minElementValue, maxElementValue, Math.random());
            }
            const nodeType = this.getNodeType(builder);
            if (object.count <= 4096) output = (0, $108a458e3a76f5dc$export$ab1029bcae9ddb4a)(array, 'vec4', object.count).element((0, $c9c236abfeae4cd5$export$3691cd4c77fcb2c4)).convert(nodeType);
            else {
                // TODO: Improve anonymous buffer attribute creation removing this part
                const bufferAttribute = new (0, $3167f16f113afb58$export$32ea87a8b54d744a)(array, 4);
                builder.geometry.setAttribute('__range' + this.id, bufferAttribute);
                output = (0, $48306ea9f4feeeae$export$6776ccefa3811157)(bufferAttribute).convert(nodeType);
            }
        } else output = (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(0);
        return output;
    }
}
var $7d6a7b9b444c1f70$export$2e2bcd8739ae039 = $7d6a7b9b444c1f70$var$RangeNode;
const $7d6a7b9b444c1f70$export$d02631cccf789723 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$60d11c6747b7deba)($7d6a7b9b444c1f70$var$RangeNode);





class $2074ae06a3a4b081$var$ComputeBuiltinNode extends (0, $65e77d5c3a27a66a$export$2e2bcd8739ae039) {
    static get type() {
        return 'ComputeBuiltinNode';
    }
    constructor(builtinName, nodeType){
        super(nodeType);
        this._builtinName = builtinName;
    }
    getHash(builder) {
        return this.getBuiltinName(builder);
    }
    getNodeType() {
        return this.nodeType;
    }
    setBuiltinName(builtinName) {
        this._builtinName = builtinName;
        return this;
    }
    getBuiltinName() {
        return this._builtinName;
    }
    hasBuiltin(builder) {
        builder.hasBuiltin(this._builtinName);
    }
    generate(builder, output) {
        const builtinName = this.getBuiltinName(builder);
        const nodeType = this.getNodeType(builder);
        if (builder.shaderStage === 'compute') return builder.format(builtinName, nodeType, output);
        else {
            console.warn(`ComputeBuiltinNode: Compute built-in value ${builtinName} can not be accessed in the ${builder.shaderStage} stage`);
            return builder.generateConst(nodeType);
        }
    }
    serialize(data) {
        super.serialize(data);
        data.global = this.global;
        data._builtinName = this._builtinName;
    }
    deserialize(data) {
        super.deserialize(data);
        this.global = data.global;
        this._builtinName = data._builtinName;
    }
}
var $2074ae06a3a4b081$export$2e2bcd8739ae039 = $2074ae06a3a4b081$var$ComputeBuiltinNode;
const $2074ae06a3a4b081$var$computeBuiltin = (name, nodeType)=>(0, $d5b7ee61758b2e81$export$e97474e17004dd41)(new $2074ae06a3a4b081$var$ComputeBuiltinNode(name, nodeType));
const $2074ae06a3a4b081$export$16687d5bedf276b3 = /*@__PURE__*/ $2074ae06a3a4b081$var$computeBuiltin('numWorkgroups', 'uvec3');
const $2074ae06a3a4b081$export$1c8819320f2a3a80 = /*@__PURE__*/ $2074ae06a3a4b081$var$computeBuiltin('workgroupId', 'uvec3');
const $2074ae06a3a4b081$export$c757fe2d6706c7cf = /*@__PURE__*/ $2074ae06a3a4b081$var$computeBuiltin('localId', 'uvec3');
const $2074ae06a3a4b081$export$eda5b5be71cde52a = /*@__PURE__*/ $2074ae06a3a4b081$var$computeBuiltin('subgroupSize', 'uint');




class $779ae67e5a7d9e9c$var$BarrierNode extends (0, $65e77d5c3a27a66a$export$2e2bcd8739ae039) {
    constructor(scope){
        super();
        this.scope = scope;
    }
    generate(builder) {
        const { scope: scope } = this;
        const { renderer: renderer } = builder;
        if (renderer.backend.isWebGLBackend === true) builder.addFlowCode(`\t// ${scope}Barrier \n`);
        else builder.addLineFlowCode(`${scope}Barrier()`, this);
    }
}
var $779ae67e5a7d9e9c$export$2e2bcd8739ae039 = $779ae67e5a7d9e9c$var$BarrierNode;
const $779ae67e5a7d9e9c$var$barrier = (0, $d5b7ee61758b2e81$export$60d11c6747b7deba)($779ae67e5a7d9e9c$var$BarrierNode);
const $779ae67e5a7d9e9c$export$edfcfcb6b638dd9a = ()=>$779ae67e5a7d9e9c$var$barrier('workgroup').append();
const $779ae67e5a7d9e9c$export$2277ddfadb2fff06 = ()=>$779ae67e5a7d9e9c$var$barrier('storage').append();
const $779ae67e5a7d9e9c$export$882b2b854b976170 = ()=>$779ae67e5a7d9e9c$var$barrier('texture').append();





class $613680e163e467f6$var$WorkgroupInfoElementNode extends (0, $e2cc991ce11e1c78$export$2e2bcd8739ae039) {
    constructor(workgroupInfoNode, indexNode){
        super(workgroupInfoNode, indexNode);
        this.isWorkgroupInfoElementNode = true;
    }
    generate(builder, output) {
        let snippet;
        const isAssignContext = builder.context.assign;
        snippet = super.generate(builder);
        if (isAssignContext !== true) {
            const type = this.getNodeType(builder);
            snippet = builder.format(snippet, type, output);
        }
        // TODO: Possibly activate clip distance index on index access rather than from clipping context
        return snippet;
    }
}
class $613680e163e467f6$var$WorkgroupInfoNode extends (0, $65e77d5c3a27a66a$export$2e2bcd8739ae039) {
    constructor(scope, bufferType, bufferCount = 0){
        super(bufferType);
        this.bufferType = bufferType;
        this.bufferCount = bufferCount;
        this.isWorkgroupInfoNode = true;
        this.scope = scope;
    }
    label(name) {
        this.name = name;
        return this;
    }
    getHash() {
        return this.uuid;
    }
    setScope(scope) {
        this.scope = scope;
        return this;
    }
    getInputType() {
        return `${this.scope}Array`;
    }
    element(indexNode) {
        return (0, $d5b7ee61758b2e81$export$e97474e17004dd41)(new $613680e163e467f6$var$WorkgroupInfoElementNode(this, indexNode));
    }
    generate(builder) {
        return builder.getScopedArray(this.name || `${this.scope}Array_${this.id}`, this.scope.toLowerCase(), this.bufferType, this.bufferCount);
    }
}
var $613680e163e467f6$export$2e2bcd8739ae039 = $613680e163e467f6$var$WorkgroupInfoNode;
const $613680e163e467f6$export$5846ee5622391292 = (type, count)=>(0, $d5b7ee61758b2e81$export$e97474e17004dd41)(new $613680e163e467f6$var$WorkgroupInfoNode('Workgroup', type, count));




class $9dca5caecdeea059$var$AtomicFunctionNode extends (0, $75c45ed2361c955f$export$2e2bcd8739ae039) {
    static get type() {
        return 'AtomicFunctionNode';
    }
    constructor(method, pointerNode, valueNode, storeNode = null){
        super('uint');
        this.method = method;
        this.pointerNode = pointerNode;
        this.valueNode = valueNode;
        this.storeNode = storeNode;
    }
    getInputType(builder) {
        return this.pointerNode.getNodeType(builder);
    }
    getNodeType(builder) {
        return this.getInputType(builder);
    }
    generate(builder) {
        const method = this.method;
        const type = this.getNodeType(builder);
        const inputType = this.getInputType(builder);
        const a = this.pointerNode;
        const b = this.valueNode;
        const params = [];
        params.push(`&${a.build(builder, inputType)}`);
        params.push(b.build(builder, inputType));
        const methodSnippet = `${builder.getMethod(method, type)}( ${params.join(', ')} )`;
        if (this.storeNode !== null) {
            const varSnippet = this.storeNode.build(builder, inputType);
            builder.addLineFlowCode(`${varSnippet} = ${methodSnippet}`, this);
        } else builder.addLineFlowCode(methodSnippet, this);
    }
}
$9dca5caecdeea059$var$AtomicFunctionNode.ATOMIC_LOAD = 'atomicLoad';
$9dca5caecdeea059$var$AtomicFunctionNode.ATOMIC_STORE = 'atomicStore';
$9dca5caecdeea059$var$AtomicFunctionNode.ATOMIC_ADD = 'atomicAdd';
$9dca5caecdeea059$var$AtomicFunctionNode.ATOMIC_SUB = 'atomicSub';
$9dca5caecdeea059$var$AtomicFunctionNode.ATOMIC_MAX = 'atomicMax';
$9dca5caecdeea059$var$AtomicFunctionNode.ATOMIC_MIN = 'atomicMin';
$9dca5caecdeea059$var$AtomicFunctionNode.ATOMIC_AND = 'atomicAnd';
$9dca5caecdeea059$var$AtomicFunctionNode.ATOMIC_OR = 'atomicOr';
$9dca5caecdeea059$var$AtomicFunctionNode.ATOMIC_XOR = 'atomicXor';
var $9dca5caecdeea059$export$2e2bcd8739ae039 = $9dca5caecdeea059$var$AtomicFunctionNode;
const $9dca5caecdeea059$var$atomicNode = (0, $d5b7ee61758b2e81$export$60d11c6747b7deba)($9dca5caecdeea059$var$AtomicFunctionNode);
const $9dca5caecdeea059$export$be943e5fe13694cf = (method, pointerNode, valueNode, storeNode)=>{
    const node = $9dca5caecdeea059$var$atomicNode(method, pointerNode, valueNode, storeNode);
    node.append();
    return node;
};
const $9dca5caecdeea059$export$57772d3069ab67cf = (pointerNode, valueNode, storeNode = null)=>$9dca5caecdeea059$export$be943e5fe13694cf($9dca5caecdeea059$var$AtomicFunctionNode.ATOMIC_STORE, pointerNode, valueNode, storeNode);
const $9dca5caecdeea059$export$b1b5d592955bd38a = (pointerNode, valueNode, storeNode = null)=>$9dca5caecdeea059$export$be943e5fe13694cf($9dca5caecdeea059$var$AtomicFunctionNode.ATOMIC_ADD, pointerNode, valueNode, storeNode);
const $9dca5caecdeea059$export$7e56c0413dedeb23 = (pointerNode, valueNode, storeNode = null)=>$9dca5caecdeea059$export$be943e5fe13694cf($9dca5caecdeea059$var$AtomicFunctionNode.ATOMIC_SUB, pointerNode, valueNode, storeNode);
const $9dca5caecdeea059$export$a1e9bdab5f06236a = (pointerNode, valueNode, storeNode = null)=>$9dca5caecdeea059$export$be943e5fe13694cf($9dca5caecdeea059$var$AtomicFunctionNode.ATOMIC_MAX, pointerNode, valueNode, storeNode);
const $9dca5caecdeea059$export$d3803e83b90d1215 = (pointerNode, valueNode, storeNode = null)=>$9dca5caecdeea059$export$be943e5fe13694cf($9dca5caecdeea059$var$AtomicFunctionNode.ATOMIC_MIN, pointerNode, valueNode, storeNode);
const $9dca5caecdeea059$export$97164556144bb884 = (pointerNode, valueNode, storeNode = null)=>$9dca5caecdeea059$export$be943e5fe13694cf($9dca5caecdeea059$var$AtomicFunctionNode.ATOMIC_AND, pointerNode, valueNode, storeNode);
const $9dca5caecdeea059$export$90b4fa962675d26a = (pointerNode, valueNode, storeNode = null)=>$9dca5caecdeea059$export$be943e5fe13694cf($9dca5caecdeea059$var$AtomicFunctionNode.ATOMIC_OR, pointerNode, valueNode, storeNode);
const $9dca5caecdeea059$export$5daa6c3ac44b9a37 = (pointerNode, valueNode, storeNode = null)=>$9dca5caecdeea059$export$be943e5fe13694cf($9dca5caecdeea059$var$AtomicFunctionNode.ATOMIC_XOR, pointerNode, valueNode, storeNode);






let $979f6f830d64a743$var$uniformsLib;
function $979f6f830d64a743$var$getLightData(light) {
    $979f6f830d64a743$var$uniformsLib = $979f6f830d64a743$var$uniformsLib || new WeakMap();
    let uniforms = $979f6f830d64a743$var$uniformsLib.get(light);
    if (uniforms === undefined) $979f6f830d64a743$var$uniformsLib.set(light, uniforms = {});
    return uniforms;
}
function $979f6f830d64a743$export$ad1e75955383aee8(light) {
    const data = $979f6f830d64a743$var$getLightData(light);
    return data.position || (data.position = (0, $5eb92bf12e57daab$export$379455b567eff87d)(new (0, $d7d0ac0e47013885$export$64b5c384219d3699)()).setGroup((0, $d2c0f7c752a63c18$export$a75a8692b47c7f9e)).onRenderUpdate((_, self)=>self.value.setFromMatrixPosition(light.matrixWorld)));
}
function $979f6f830d64a743$export$8f6bf61b9cd960e1(light) {
    const data = $979f6f830d64a743$var$getLightData(light);
    return data.targetPosition || (data.targetPosition = (0, $5eb92bf12e57daab$export$379455b567eff87d)(new (0, $d7d0ac0e47013885$export$64b5c384219d3699)()).setGroup((0, $d2c0f7c752a63c18$export$a75a8692b47c7f9e)).onRenderUpdate((_, self)=>self.value.setFromMatrixPosition(light.target.matrixWorld)));
}
function $979f6f830d64a743$export$f9728da392bd8249(light) {
    const data = $979f6f830d64a743$var$getLightData(light);
    return data.viewPosition || (data.viewPosition = (0, $5eb92bf12e57daab$export$379455b567eff87d)(new (0, $d7d0ac0e47013885$export$64b5c384219d3699)()).setGroup((0, $d2c0f7c752a63c18$export$a75a8692b47c7f9e)).onRenderUpdate(({ camera: camera }, self)=>{
        self.value = self.value || new (0, $d7d0ac0e47013885$export$64b5c384219d3699)();
        self.value.setFromMatrixPosition(light.matrixWorld);
        self.value.applyMatrix4(camera.matrixWorldInverse);
    }));
}
const $979f6f830d64a743$export$bee642e950dff992 = (light)=>(0, $aa7db78c76b9331c$export$6f7d94c027189d78).transformDirection($979f6f830d64a743$export$ad1e75955383aee8(light).sub($979f6f830d64a743$export$8f6bf61b9cd960e1(light)));




const $b9902801d7b7fb55$var$sortLights = (lights)=>{
    return lights.sort((a, b)=>a.id - b.id);
};
const $b9902801d7b7fb55$var$getLightNodeById = (id, lightNodes)=>{
    for (const lightNode of lightNodes){
        if (lightNode.isAnalyticLightNode && lightNode.light.id === id) return lightNode;
    }
    return null;
};
const $b9902801d7b7fb55$var$_lightsNodeRef = /*@__PURE__*/ new WeakMap();
class $b9902801d7b7fb55$var$LightsNode extends (0, $65e77d5c3a27a66a$export$2e2bcd8739ae039) {
    static get type() {
        return 'LightsNode';
    }
    constructor(){
        super('vec3');
        this.totalDiffuseNode = (0, $d5b7ee61758b2e81$export$9100789c9d999364)().toVar('totalDiffuse');
        this.totalSpecularNode = (0, $d5b7ee61758b2e81$export$9100789c9d999364)().toVar('totalSpecular');
        this.outgoingLightNode = (0, $d5b7ee61758b2e81$export$9100789c9d999364)().toVar('outgoingLight');
        this._lights = [];
        this._lightNodes = null;
        this._lightNodesHash = null;
        this.global = true;
    }
    getHash(builder) {
        if (this._lightNodesHash === null) {
            if (this._lightNodes === null) this.setupLightsNode(builder);
            const hash = [];
            for (const lightNode of this._lightNodes)hash.push(lightNode.getSelf().getHash());
            this._lightNodesHash = 'lights-' + hash.join(',');
        }
        return this._lightNodesHash;
    }
    analyze(builder) {
        const properties = builder.getDataFromNode(this);
        for (const node of properties.nodes)node.build(builder);
    }
    setupLightsNode(builder) {
        const lightNodes = [];
        const previousLightNodes = this._lightNodes;
        const lights = $b9902801d7b7fb55$var$sortLights(this._lights);
        const nodeLibrary = builder.renderer.library;
        for (const light of lights)if (light.isNode) lightNodes.push((0, $d5b7ee61758b2e81$export$e97474e17004dd41)(light));
        else {
            let lightNode = null;
            if (previousLightNodes !== null) lightNode = $b9902801d7b7fb55$var$getLightNodeById(light.id, previousLightNodes); // resuse existing light node
            if (lightNode === null) {
                const lightNodeClass = nodeLibrary.getLightNodeClass(light.constructor);
                if (lightNodeClass === null) {
                    console.warn(`LightsNode.setupNodeLights: Light node not found for ${light.constructor.name}`);
                    continue;
                }
                let lightNode = null;
                if (!$b9902801d7b7fb55$var$_lightsNodeRef.has(light)) {
                    lightNode = (0, $d5b7ee61758b2e81$export$e97474e17004dd41)(new lightNodeClass(light));
                    $b9902801d7b7fb55$var$_lightsNodeRef.set(light, lightNode);
                } else lightNode = $b9902801d7b7fb55$var$_lightsNodeRef.get(light);
                lightNodes.push(lightNode);
            }
        }
        this._lightNodes = lightNodes;
    }
    setupLights(builder, lightNodes) {
        for (const lightNode of lightNodes)lightNode.build(builder);
    }
    setup(builder) {
        if (this._lightNodes === null) this.setupLightsNode(builder);
        const context = builder.context;
        const lightingModel = context.lightingModel;
        let outgoingLightNode = this.outgoingLightNode;
        if (lightingModel) {
            const { _lightNodes: _lightNodes, totalDiffuseNode: totalDiffuseNode, totalSpecularNode: totalSpecularNode } = this;
            context.outgoingLight = outgoingLightNode;
            const stack = builder.addStack();
            //
            const properties = builder.getDataFromNode(this);
            properties.nodes = stack.nodes;
            //
            lightingModel.start(context, stack, builder);
            // lights
            this.setupLights(builder, _lightNodes);
            //
            lightingModel.indirect(context, stack, builder);
            //
            const { backdrop: backdrop, backdropAlpha: backdropAlpha } = context;
            const { directDiffuse: directDiffuse, directSpecular: directSpecular, indirectDiffuse: indirectDiffuse, indirectSpecular: indirectSpecular } = context.reflectedLight;
            let totalDiffuse = directDiffuse.add(indirectDiffuse);
            if (backdrop !== null) {
                if (backdropAlpha !== null) totalDiffuse = (0, $d5b7ee61758b2e81$export$9100789c9d999364)(backdropAlpha.mix(totalDiffuse, backdrop));
                else totalDiffuse = (0, $d5b7ee61758b2e81$export$9100789c9d999364)(backdrop);
                context.material.transparent = true;
            }
            totalDiffuseNode.assign(totalDiffuse);
            totalSpecularNode.assign(directSpecular.add(indirectSpecular));
            outgoingLightNode.assign(totalDiffuseNode.add(totalSpecularNode));
            //
            lightingModel.finish(context, stack, builder);
            //
            outgoingLightNode = outgoingLightNode.bypass(builder.removeStack());
        }
        return outgoingLightNode;
    }
    setLights(lights) {
        this._lights = lights;
        this._lightNodes = null;
        this._lightNodesHash = null;
        return this;
    }
    getLights() {
        return this._lights;
    }
    get hasLights() {
        return this._lights.length > 0;
    }
}
var $b9902801d7b7fb55$export$2e2bcd8739ae039 = $b9902801d7b7fb55$var$LightsNode;
const $b9902801d7b7fb55$export$7c1fce12d7eeb101 = (lights = [])=>(0, $d5b7ee61758b2e81$export$e97474e17004dd41)(new $b9902801d7b7fb55$var$LightsNode()).setLights(lights);





















const $3959dd1ac84dd306$var$BasicShadowMap = (0, $d5b7ee61758b2e81$export$b076717d71a1a47f)(({ depthTexture: depthTexture, shadowCoord: shadowCoord })=>{
    return (0, $f7d68bbf9ea772a7$export$ab69073b3903a075)(depthTexture, shadowCoord.xy).compare(shadowCoord.z);
});
const $3959dd1ac84dd306$var$PCFShadowMap = (0, $d5b7ee61758b2e81$export$b076717d71a1a47f)(({ depthTexture: depthTexture, shadowCoord: shadowCoord, shadow: shadow })=>{
    const depthCompare = (uv, compare)=>(0, $f7d68bbf9ea772a7$export$ab69073b3903a075)(depthTexture, uv).compare(compare);
    const mapSize = (0, $7082d3a91c21cd99$export$ca50aac9f3ba507f)('mapSize', 'vec2', shadow).setGroup((0, $d2c0f7c752a63c18$export$a75a8692b47c7f9e));
    const radius = (0, $7082d3a91c21cd99$export$ca50aac9f3ba507f)('radius', 'float', shadow).setGroup((0, $d2c0f7c752a63c18$export$a75a8692b47c7f9e));
    const texelSize = (0, $d5b7ee61758b2e81$export$e9830bc863290a54)(1).div(mapSize);
    const dx0 = texelSize.x.negate().mul(radius);
    const dy0 = texelSize.y.negate().mul(radius);
    const dx1 = texelSize.x.mul(radius);
    const dy1 = texelSize.y.mul(radius);
    const dx2 = dx0.div(2);
    const dy2 = dy0.div(2);
    const dx3 = dx1.div(2);
    const dy3 = dy1.div(2);
    return (0, $3f1f23fea79ae256$export$e16d8520af44a096)(depthCompare(shadowCoord.xy.add((0, $d5b7ee61758b2e81$export$e9830bc863290a54)(dx0, dy0)), shadowCoord.z), depthCompare(shadowCoord.xy.add((0, $d5b7ee61758b2e81$export$e9830bc863290a54)(0, dy0)), shadowCoord.z), depthCompare(shadowCoord.xy.add((0, $d5b7ee61758b2e81$export$e9830bc863290a54)(dx1, dy0)), shadowCoord.z), depthCompare(shadowCoord.xy.add((0, $d5b7ee61758b2e81$export$e9830bc863290a54)(dx2, dy2)), shadowCoord.z), depthCompare(shadowCoord.xy.add((0, $d5b7ee61758b2e81$export$e9830bc863290a54)(0, dy2)), shadowCoord.z), depthCompare(shadowCoord.xy.add((0, $d5b7ee61758b2e81$export$e9830bc863290a54)(dx3, dy2)), shadowCoord.z), depthCompare(shadowCoord.xy.add((0, $d5b7ee61758b2e81$export$e9830bc863290a54)(dx0, 0)), shadowCoord.z), depthCompare(shadowCoord.xy.add((0, $d5b7ee61758b2e81$export$e9830bc863290a54)(dx2, 0)), shadowCoord.z), depthCompare(shadowCoord.xy, shadowCoord.z), depthCompare(shadowCoord.xy.add((0, $d5b7ee61758b2e81$export$e9830bc863290a54)(dx3, 0)), shadowCoord.z), depthCompare(shadowCoord.xy.add((0, $d5b7ee61758b2e81$export$e9830bc863290a54)(dx1, 0)), shadowCoord.z), depthCompare(shadowCoord.xy.add((0, $d5b7ee61758b2e81$export$e9830bc863290a54)(dx2, dy3)), shadowCoord.z), depthCompare(shadowCoord.xy.add((0, $d5b7ee61758b2e81$export$e9830bc863290a54)(0, dy3)), shadowCoord.z), depthCompare(shadowCoord.xy.add((0, $d5b7ee61758b2e81$export$e9830bc863290a54)(dx3, dy3)), shadowCoord.z), depthCompare(shadowCoord.xy.add((0, $d5b7ee61758b2e81$export$e9830bc863290a54)(dx0, dy1)), shadowCoord.z), depthCompare(shadowCoord.xy.add((0, $d5b7ee61758b2e81$export$e9830bc863290a54)(0, dy1)), shadowCoord.z), depthCompare(shadowCoord.xy.add((0, $d5b7ee61758b2e81$export$e9830bc863290a54)(dx1, dy1)), shadowCoord.z)).mul(1 / 17);
});
const $3959dd1ac84dd306$var$PCFSoftShadowMap = (0, $d5b7ee61758b2e81$export$b076717d71a1a47f)(({ depthTexture: depthTexture, shadowCoord: shadowCoord, shadow: shadow })=>{
    const depthCompare = (uv, compare)=>(0, $f7d68bbf9ea772a7$export$ab69073b3903a075)(depthTexture, uv).compare(compare);
    const mapSize = (0, $7082d3a91c21cd99$export$ca50aac9f3ba507f)('mapSize', 'vec2', shadow).setGroup((0, $d2c0f7c752a63c18$export$a75a8692b47c7f9e));
    const texelSize = (0, $d5b7ee61758b2e81$export$e9830bc863290a54)(1).div(mapSize);
    const dx = texelSize.x;
    const dy = texelSize.y;
    const uv = shadowCoord.xy;
    const f = (0, $f37ae0e58866c183$export$a57bfe0eb79af278)(uv.mul(mapSize).add(0.5));
    uv.subAssign(f.mul(texelSize));
    return (0, $3f1f23fea79ae256$export$e16d8520af44a096)(depthCompare(uv, shadowCoord.z), depthCompare(uv.add((0, $d5b7ee61758b2e81$export$e9830bc863290a54)(dx, 0)), shadowCoord.z), depthCompare(uv.add((0, $d5b7ee61758b2e81$export$e9830bc863290a54)(0, dy)), shadowCoord.z), depthCompare(uv.add(texelSize), shadowCoord.z), (0, $f37ae0e58866c183$export$2c9e8a9632a706b2)(depthCompare(uv.add((0, $d5b7ee61758b2e81$export$e9830bc863290a54)(dx.negate(), 0)), shadowCoord.z), depthCompare(uv.add((0, $d5b7ee61758b2e81$export$e9830bc863290a54)(dx.mul(2), 0)), shadowCoord.z), f.x), (0, $f37ae0e58866c183$export$2c9e8a9632a706b2)(depthCompare(uv.add((0, $d5b7ee61758b2e81$export$e9830bc863290a54)(dx.negate(), dy)), shadowCoord.z), depthCompare(uv.add((0, $d5b7ee61758b2e81$export$e9830bc863290a54)(dx.mul(2), dy)), shadowCoord.z), f.x), (0, $f37ae0e58866c183$export$2c9e8a9632a706b2)(depthCompare(uv.add((0, $d5b7ee61758b2e81$export$e9830bc863290a54)(0, dy.negate())), shadowCoord.z), depthCompare(uv.add((0, $d5b7ee61758b2e81$export$e9830bc863290a54)(0, dy.mul(2))), shadowCoord.z), f.y), (0, $f37ae0e58866c183$export$2c9e8a9632a706b2)(depthCompare(uv.add((0, $d5b7ee61758b2e81$export$e9830bc863290a54)(dx, dy.negate())), shadowCoord.z), depthCompare(uv.add((0, $d5b7ee61758b2e81$export$e9830bc863290a54)(dx, dy.mul(2))), shadowCoord.z), f.y), (0, $f37ae0e58866c183$export$2c9e8a9632a706b2)((0, $f37ae0e58866c183$export$2c9e8a9632a706b2)(depthCompare(uv.add((0, $d5b7ee61758b2e81$export$e9830bc863290a54)(dx.negate(), dy.negate())), shadowCoord.z), depthCompare(uv.add((0, $d5b7ee61758b2e81$export$e9830bc863290a54)(dx.mul(2), dy.negate())), shadowCoord.z), f.x), (0, $f37ae0e58866c183$export$2c9e8a9632a706b2)(depthCompare(uv.add((0, $d5b7ee61758b2e81$export$e9830bc863290a54)(dx.negate(), dy.mul(2))), shadowCoord.z), depthCompare(uv.add((0, $d5b7ee61758b2e81$export$e9830bc863290a54)(dx.mul(2), dy.mul(2))), shadowCoord.z), f.x), f.y)).mul(1 / 9);
});
// VSM
const $3959dd1ac84dd306$var$VSMShadowMapNode = (0, $d5b7ee61758b2e81$export$b076717d71a1a47f)(({ depthTexture: depthTexture, shadowCoord: shadowCoord })=>{
    const occlusion = (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(1).toVar();
    const distribution = (0, $f7d68bbf9ea772a7$export$ab69073b3903a075)(depthTexture).uv(shadowCoord.xy).rg;
    const hardShadow = (0, $f37ae0e58866c183$export$35d34bc0ed591a92)(shadowCoord.z, distribution.x);
    (0, $d5b7ee61758b2e81$export$1f9ff5f4a6c9361a)(hardShadow.notEqual((0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(1.0)), ()=>{
        const distance = shadowCoord.z.sub(distribution.x);
        const variance = (0, $f37ae0e58866c183$export$8960430cfd85939f)(0, distribution.y.mul(distribution.y));
        let softnessProbability = variance.div(variance.add(distance.mul(distance))); // Chebeyshevs inequality
        softnessProbability = (0, $f37ae0e58866c183$export$7d15b64cf5a3a4c4)((0, $3f1f23fea79ae256$export$f93b5905241a7cca)(softnessProbability, 0.3).div(0.95 - 0.3));
        occlusion.assign((0, $f37ae0e58866c183$export$7d15b64cf5a3a4c4)((0, $f37ae0e58866c183$export$8960430cfd85939f)(hardShadow, softnessProbability)));
    });
    return occlusion;
});
const $3959dd1ac84dd306$var$VSMPassVertical = (0, $d5b7ee61758b2e81$export$b076717d71a1a47f)(({ samples: samples, radius: radius, size: size, shadowPass: shadowPass })=>{
    const mean = (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(0).toVar();
    const squaredMean = (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(0).toVar();
    const uvStride = samples.lessThanEqual((0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(1)).select((0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(0), (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(2).div(samples.sub(1)));
    const uvStart = samples.lessThanEqual((0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(1)).select((0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(0), (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(-1));
    (0, $2a1578e0d4d8bf63$export$550acbd06a1f5a6a)({
        start: (0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)(0),
        end: (0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)(samples),
        type: 'int',
        condition: '<'
    }, ({ i: i })=>{
        const uvOffset = uvStart.add((0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(i).mul(uvStride));
        const depth = shadowPass.uv((0, $3f1f23fea79ae256$export$e16d8520af44a096)((0, $64df2f32a1195518$export$bf65ab4b6c973b29).xy, (0, $d5b7ee61758b2e81$export$e9830bc863290a54)(0, uvOffset).mul(radius)).div(size)).x;
        mean.addAssign(depth);
        squaredMean.addAssign(depth.mul(depth));
    });
    mean.divAssign(samples);
    squaredMean.divAssign(samples);
    const std_dev = (0, $f37ae0e58866c183$export$eba8049fb5020b81)(squaredMean.sub(mean.mul(mean)));
    return (0, $d5b7ee61758b2e81$export$e9830bc863290a54)(mean, std_dev);
});
const $3959dd1ac84dd306$var$VSMPassHorizontal = (0, $d5b7ee61758b2e81$export$b076717d71a1a47f)(({ samples: samples, radius: radius, size: size, shadowPass: shadowPass })=>{
    const mean = (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(0).toVar();
    const squaredMean = (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(0).toVar();
    const uvStride = samples.lessThanEqual((0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(1)).select((0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(0), (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(2).div(samples.sub(1)));
    const uvStart = samples.lessThanEqual((0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(1)).select((0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(0), (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(-1));
    (0, $2a1578e0d4d8bf63$export$550acbd06a1f5a6a)({
        start: (0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)(0),
        end: (0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)(samples),
        type: 'int',
        condition: '<'
    }, ({ i: i })=>{
        const uvOffset = uvStart.add((0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(i).mul(uvStride));
        const distribution = shadowPass.uv((0, $3f1f23fea79ae256$export$e16d8520af44a096)((0, $64df2f32a1195518$export$bf65ab4b6c973b29).xy, (0, $d5b7ee61758b2e81$export$e9830bc863290a54)(uvOffset, 0).mul(radius)).div(size));
        mean.addAssign(distribution.x);
        squaredMean.addAssign((0, $3f1f23fea79ae256$export$e16d8520af44a096)(distribution.y.mul(distribution.y), distribution.x.mul(distribution.x)));
    });
    mean.divAssign(samples);
    squaredMean.divAssign(samples);
    const std_dev = (0, $f37ae0e58866c183$export$eba8049fb5020b81)(squaredMean.sub(mean.mul(mean)));
    return (0, $d5b7ee61758b2e81$export$e9830bc863290a54)(mean, std_dev);
});
const $3959dd1ac84dd306$var$_shadowFilterLib = [
    $3959dd1ac84dd306$var$BasicShadowMap,
    $3959dd1ac84dd306$var$PCFShadowMap,
    $3959dd1ac84dd306$var$PCFSoftShadowMap,
    $3959dd1ac84dd306$var$VSMShadowMapNode
];
//
let $3959dd1ac84dd306$var$_overrideMaterial = null;
const $3959dd1ac84dd306$var$_quadMesh = /*@__PURE__*/ new (0, $488a8c443ac2097d$export$2e2bcd8739ae039)();
class $3959dd1ac84dd306$var$ShadowNode extends (0, $65e77d5c3a27a66a$export$2e2bcd8739ae039) {
    static get type() {
        return 'ShadowNode';
    }
    constructor(light, shadow = null){
        super();
        this.light = light;
        this.shadow = shadow || light.shadow;
        this.shadowMap = null;
        this.vsmShadowMapVertical = null;
        this.vsmShadowMapHorizontal = null;
        this.vsmMaterialVertical = null;
        this.vsmMaterialHorizontal = null;
        this.updateBeforeType = (0, $ddcfecb7fbba5d74$export$26f7a8bbd9469530).RENDER;
        this._node = null;
        this.isShadowNode = true;
    }
    setupShadow(builder) {
        const { object: object, renderer: renderer } = builder;
        if ($3959dd1ac84dd306$var$_overrideMaterial === null) {
            $3959dd1ac84dd306$var$_overrideMaterial = new (0, $1a485f4d26090da0$export$2e2bcd8739ae039)();
            $3959dd1ac84dd306$var$_overrideMaterial.fragmentNode = (0, $d5b7ee61758b2e81$export$6dba2a1f0d609415)(0, 0, 0, 1);
            $3959dd1ac84dd306$var$_overrideMaterial.isShadowNodeMaterial = true; // Use to avoid other overrideMaterial override material.fragmentNode unintentionally when using material.shadowNode
            $3959dd1ac84dd306$var$_overrideMaterial.name = 'ShadowMaterial';
        }
        const shadow = this.shadow;
        const shadowMapType = renderer.shadowMap.type;
        const depthTexture = new (0, $520286b5db9c7cf5$export$fc830aa069cc8c2f)(shadow.mapSize.width, shadow.mapSize.height);
        depthTexture.compareFunction = (0, $cb5ee595c0f892af$export$36bcf49c713b3eb7);
        const shadowMap = builder.createRenderTarget(shadow.mapSize.width, shadow.mapSize.height);
        shadowMap.depthTexture = depthTexture;
        shadow.camera.updateProjectionMatrix();
        // VSM
        if (shadowMapType === (0, $cb5ee595c0f892af$export$896ae1ade6c829c4)) {
            depthTexture.compareFunction = null; // VSM does not use textureSampleCompare()/texture2DCompare()
            this.vsmShadowMapVertical = builder.createRenderTarget(shadow.mapSize.width, shadow.mapSize.height, {
                format: (0, $cb5ee595c0f892af$export$6cdf0b461c7ce8a0),
                type: (0, $cb5ee595c0f892af$export$2697304443f382bc)
            });
            this.vsmShadowMapHorizontal = builder.createRenderTarget(shadow.mapSize.width, shadow.mapSize.height, {
                format: (0, $cb5ee595c0f892af$export$6cdf0b461c7ce8a0),
                type: (0, $cb5ee595c0f892af$export$2697304443f382bc)
            });
            const shadowPassVertical = (0, $f7d68bbf9ea772a7$export$ab69073b3903a075)(depthTexture);
            const shadowPassHorizontal = (0, $f7d68bbf9ea772a7$export$ab69073b3903a075)(this.vsmShadowMapVertical.texture);
            const samples = (0, $7082d3a91c21cd99$export$ca50aac9f3ba507f)('blurSamples', 'float', shadow).setGroup((0, $d2c0f7c752a63c18$export$a75a8692b47c7f9e));
            const radius = (0, $7082d3a91c21cd99$export$ca50aac9f3ba507f)('radius', 'float', shadow).setGroup((0, $d2c0f7c752a63c18$export$a75a8692b47c7f9e));
            const size = (0, $7082d3a91c21cd99$export$ca50aac9f3ba507f)('mapSize', 'vec2', shadow).setGroup((0, $d2c0f7c752a63c18$export$a75a8692b47c7f9e));
            let material = this.vsmMaterialVertical || (this.vsmMaterialVertical = new (0, $1a485f4d26090da0$export$2e2bcd8739ae039)());
            material.fragmentNode = $3959dd1ac84dd306$var$VSMPassVertical({
                samples: samples,
                radius: radius,
                size: size,
                shadowPass: shadowPassVertical
            }).context(builder.getSharedContext());
            material.name = 'VSMVertical';
            material = this.vsmMaterialHorizontal || (this.vsmMaterialHorizontal = new (0, $1a485f4d26090da0$export$2e2bcd8739ae039)());
            material.fragmentNode = $3959dd1ac84dd306$var$VSMPassHorizontal({
                samples: samples,
                radius: radius,
                size: size,
                shadowPass: shadowPassHorizontal
            }).context(builder.getSharedContext());
            material.name = 'VSMHorizontal';
        }
        //
        const shadowIntensity = (0, $7082d3a91c21cd99$export$ca50aac9f3ba507f)('intensity', 'float', shadow).setGroup((0, $d2c0f7c752a63c18$export$a75a8692b47c7f9e));
        const bias = (0, $7082d3a91c21cd99$export$ca50aac9f3ba507f)('bias', 'float', shadow).setGroup((0, $d2c0f7c752a63c18$export$a75a8692b47c7f9e));
        const normalBias = (0, $7082d3a91c21cd99$export$ca50aac9f3ba507f)('normalBias', 'float', shadow).setGroup((0, $d2c0f7c752a63c18$export$a75a8692b47c7f9e));
        const position = object.material.shadowPositionNode || (0, $acbec2070ba15851$export$3e8de2ffef4e6f91);
        let shadowCoord = (0, $5eb92bf12e57daab$export$379455b567eff87d)(shadow.matrix).setGroup((0, $d2c0f7c752a63c18$export$a75a8692b47c7f9e)).mul(position.add((0, $0ab44deffc8ae973$export$add3225664ac656e).mul(normalBias)));
        let coordZ;
        if (shadow.camera.isOrthographicCamera || renderer.logarithmicDepthBuffer !== true) {
            shadowCoord = shadowCoord.xyz.div(shadowCoord.w);
            coordZ = shadowCoord.z;
            if (renderer.coordinateSystem === (0, $cb5ee595c0f892af$export$cc83beedcb9be9ac)) coordZ = coordZ.mul(2).sub(1); // WebGPU: Conversion [ 0, 1 ] to [ - 1, 1 ]
        } else {
            const w = shadowCoord.w;
            shadowCoord = shadowCoord.xy.div(w); // <-- Only divide X/Y coords since we don't need Z
            // The normally available "cameraNear" and "cameraFar" nodes cannot be used here because they do not get
            // updated to use the shadow camera. So, we have to declare our own "local" ones here.
            // TODO: How do we get the cameraNear/cameraFar nodes to use the shadow camera so we don't have to declare local ones here?
            const cameraNearLocal = (0, $5eb92bf12e57daab$export$379455b567eff87d)('float').onRenderUpdate(()=>shadow.camera.near);
            const cameraFarLocal = (0, $5eb92bf12e57daab$export$379455b567eff87d)('float').onRenderUpdate(()=>shadow.camera.far);
            coordZ = (0, $c2ec92bdddb724e3$export$7e233a63f5c02fa0)(w, cameraNearLocal, cameraFarLocal);
        }
        shadowCoord = (0, $d5b7ee61758b2e81$export$9100789c9d999364)(shadowCoord.x, shadowCoord.y.oneMinus(), coordZ.add(bias));
        const frustumTest = shadowCoord.x.greaterThanEqual(0).and(shadowCoord.x.lessThanEqual(1)).and(shadowCoord.y.greaterThanEqual(0)).and(shadowCoord.y.lessThanEqual(1)).and(shadowCoord.z.lessThanEqual(1));
        //
        const filterFn = shadow.filterNode || $3959dd1ac84dd306$var$_shadowFilterLib[renderer.shadowMap.type] || null;
        if (filterFn === null) throw new Error('THREE.WebGPURenderer: Shadow map type not supported yet.');
        const shadowColor = (0, $f7d68bbf9ea772a7$export$ab69073b3903a075)(shadowMap.texture, shadowCoord);
        const shadowNode = frustumTest.select(filterFn({
            depthTexture: shadowMapType === (0, $cb5ee595c0f892af$export$896ae1ade6c829c4) ? this.vsmShadowMapHorizontal.texture : depthTexture,
            shadowCoord: shadowCoord,
            shadow: shadow
        }), (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(1));
        this.shadowMap = shadowMap;
        this.shadow.map = shadowMap;
        return (0, $f37ae0e58866c183$export$2c9e8a9632a706b2)(1, shadowNode.rgb.mix(shadowColor, 1), shadowIntensity.mul(shadowColor.a));
    }
    setup(builder) {
        if (builder.renderer.shadowMap.enabled === false) return;
        return this._node !== null ? this._node : this._node = this.setupShadow(builder);
    }
    updateShadow(frame) {
        const { shadowMap: shadowMap, light: light, shadow: shadow } = this;
        const { renderer: renderer, scene: scene, camera: camera } = frame;
        const shadowType = renderer.shadowMap.type;
        const depthVersion = shadowMap.depthTexture.version;
        this._depthVersionCached = depthVersion;
        const currentOverrideMaterial = scene.overrideMaterial;
        scene.overrideMaterial = $3959dd1ac84dd306$var$_overrideMaterial;
        shadowMap.setSize(shadow.mapSize.width, shadow.mapSize.height);
        shadow.updateMatrices(light);
        shadow.camera.layers.mask = camera.layers.mask;
        const currentRenderTarget = renderer.getRenderTarget();
        const currentRenderObjectFunction = renderer.getRenderObjectFunction();
        renderer.setRenderObjectFunction((object, ...params)=>{
            if (object.castShadow === true || object.receiveShadow && shadowType === (0, $cb5ee595c0f892af$export$896ae1ade6c829c4)) renderer.renderObject(object, ...params);
        });
        renderer.setRenderTarget(shadowMap);
        renderer.render(scene, shadow.camera);
        renderer.setRenderObjectFunction(currentRenderObjectFunction);
        // vsm blur pass
        if (light.isPointLight !== true && shadowType === (0, $cb5ee595c0f892af$export$896ae1ade6c829c4)) this.vsmPass(renderer);
        renderer.setRenderTarget(currentRenderTarget);
        scene.overrideMaterial = currentOverrideMaterial;
    }
    vsmPass(renderer) {
        const { shadow: shadow } = this;
        this.vsmShadowMapVertical.setSize(shadow.mapSize.width, shadow.mapSize.height);
        this.vsmShadowMapHorizontal.setSize(shadow.mapSize.width, shadow.mapSize.height);
        renderer.setRenderTarget(this.vsmShadowMapVertical);
        $3959dd1ac84dd306$var$_quadMesh.material = this.vsmMaterialVertical;
        $3959dd1ac84dd306$var$_quadMesh.render(renderer);
        renderer.setRenderTarget(this.vsmShadowMapHorizontal);
        $3959dd1ac84dd306$var$_quadMesh.material = this.vsmMaterialHorizontal;
        $3959dd1ac84dd306$var$_quadMesh.render(renderer);
    }
    dispose() {
        this.shadowMap.dispose();
        this.shadowMap = null;
        if (this.vsmShadowMapVertical !== null) {
            this.vsmShadowMapVertical.dispose();
            this.vsmShadowMapVertical = null;
            this.vsmMaterialVertical.dispose();
            this.vsmMaterialVertical = null;
        }
        if (this.vsmShadowMapHorizontal !== null) {
            this.vsmShadowMapHorizontal.dispose();
            this.vsmShadowMapHorizontal = null;
            this.vsmMaterialHorizontal.dispose();
            this.vsmMaterialHorizontal = null;
        }
        this.updateBeforeType = (0, $ddcfecb7fbba5d74$export$26f7a8bbd9469530).NONE;
    }
    updateBefore(frame) {
        const { shadow: shadow } = this;
        const needsUpdate = shadow.needsUpdate || shadow.autoUpdate;
        if (needsUpdate) {
            this.updateShadow(frame);
            if (this.shadowMap.depthTexture.version === this._depthVersionCached) shadow.needsUpdate = false;
        }
    }
}
var $3959dd1ac84dd306$export$2e2bcd8739ae039 = $3959dd1ac84dd306$var$ShadowNode;
const $3959dd1ac84dd306$export$b8972b998723d602 = (light, shadow)=>(0, $d5b7ee61758b2e81$export$e97474e17004dd41)(new $3959dd1ac84dd306$var$ShadowNode(light, shadow));










class $c5fe32a85e7ab0bc$var$AnalyticLightNode extends (0, $cdb0844205e5f290$export$2e2bcd8739ae039) {
    static get type() {
        return 'AnalyticLightNode';
    }
    constructor(light = null){
        super();
        this.updateType = (0, $ddcfecb7fbba5d74$export$26f7a8bbd9469530).FRAME;
        this.light = light;
        this.color = new (0, $9a23ce591a1b6760$export$892596cec99bc70e)();
        this.colorNode = (0, $5eb92bf12e57daab$export$379455b567eff87d)(this.color).setGroup((0, $d2c0f7c752a63c18$export$a75a8692b47c7f9e));
        this.baseColorNode = null;
        this.shadowNode = null;
        this.shadowColorNode = null;
        this.isAnalyticLightNode = true;
    }
    getCacheKey() {
        return (0, $97d1d441621670a9$export$d6af199866bfb566)(super.getCacheKey(), this.light.id, this.light.castShadow ? 1 : 0);
    }
    getHash() {
        return this.light.uuid;
    }
    setupShadow(builder) {
        const { renderer: renderer } = builder;
        if (renderer.shadowMap.enabled === false) return;
        let shadowColorNode = this.shadowColorNode;
        if (shadowColorNode === null) {
            const customShadowNode = this.light.shadow.shadowNode;
            let shadowNode;
            if (customShadowNode !== undefined) shadowNode = (0, $d5b7ee61758b2e81$export$e97474e17004dd41)(customShadowNode);
            else shadowNode = (0, $3959dd1ac84dd306$export$b8972b998723d602)(this.light);
            this.shadowNode = shadowNode;
            this.shadowColorNode = shadowColorNode = this.colorNode.mul(shadowNode);
            this.baseColorNode = this.colorNode;
        }
        //
        this.colorNode = shadowColorNode;
    }
    setup(builder) {
        this.colorNode = this.baseColorNode || this.colorNode;
        if (this.light.castShadow) {
            if (builder.object.receiveShadow) this.setupShadow(builder);
        } else if (this.shadowNode !== null) this.shadowNode.dispose();
    }
    update() {
        const { light: light } = this;
        this.color.copy(light.color).multiplyScalar(light.intensity);
    }
}
var $c5fe32a85e7ab0bc$export$2e2bcd8739ae039 = $c5fe32a85e7ab0bc$var$AnalyticLightNode;



const $8dabd82a2fa36007$export$f35276a09da0cd36 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$b076717d71a1a47f)((inputs)=>{
    const { lightDistance: lightDistance, cutoffDistance: cutoffDistance, decayExponent: decayExponent } = inputs;
    // based upon Frostbite 3 Moving to Physically-based Rendering
    // page 32, equation 26: E[window1]
    // https://seblagarde.files.wordpress.com/2015/07/course_notes_moving_frostbite_to_pbr_v32.pdf
    const distanceFalloff = lightDistance.pow(decayExponent).max(0.01).reciprocal();
    return cutoffDistance.greaterThan(0).select(distanceFalloff.mul(lightDistance.div(cutoffDistance).pow4().oneMinus().clamp().pow2()), distanceFalloff);
}); // validated







const $12287d9c9f093f27$export$6e0b9e23d704ce6d = (0, $d5b7ee61758b2e81$export$b076717d71a1a47f)(({ color: color, lightViewPosition: lightViewPosition, cutoffDistance: cutoffDistance, decayExponent: decayExponent }, builder)=>{
    const lightingModel = builder.context.lightingModel;
    const lVector = lightViewPosition.sub((0, $acbec2070ba15851$export$3dfd735ebeac9bfd)); // @TODO: Add it into LightNode
    const lightDirection = lVector.normalize();
    const lightDistance = lVector.length();
    const lightAttenuation = (0, $8dabd82a2fa36007$export$f35276a09da0cd36)({
        lightDistance: lightDistance,
        cutoffDistance: cutoffDistance,
        decayExponent: decayExponent
    });
    const lightColor = color.mul(lightAttenuation);
    const reflectedLight = builder.context.reflectedLight;
    lightingModel.direct({
        lightDirection: lightDirection,
        lightColor: lightColor,
        reflectedLight: reflectedLight
    }, builder.stack, builder);
});
class $12287d9c9f093f27$var$PointLightNode extends (0, $c5fe32a85e7ab0bc$export$2e2bcd8739ae039) {
    static get type() {
        return 'PointLightNode';
    }
    constructor(light = null){
        super(light);
        this.cutoffDistanceNode = (0, $5eb92bf12e57daab$export$379455b567eff87d)(0).setGroup((0, $d2c0f7c752a63c18$export$a75a8692b47c7f9e));
        this.decayExponentNode = (0, $5eb92bf12e57daab$export$379455b567eff87d)(0).setGroup((0, $d2c0f7c752a63c18$export$a75a8692b47c7f9e));
    }
    update(frame) {
        const { light: light } = this;
        super.update(frame);
        this.cutoffDistanceNode.value = light.distance;
        this.decayExponentNode.value = light.decay;
    }
    setup() {
        $12287d9c9f093f27$export$6e0b9e23d704ce6d({
            color: this.colorNode,
            lightViewPosition: (0, $979f6f830d64a743$export$f9728da392bd8249)(this.light),
            cutoffDistance: this.cutoffDistanceNode,
            decayExponent: this.decayExponentNode
        }).append();
    }
}
var $12287d9c9f093f27$export$2e2bcd8739ae039 = $12287d9c9f093f27$var$PointLightNode;









// These defines must match with PMREMGenerator
const $7d521f89dcf0f8b8$var$cubeUV_r0 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(1.0);
const $7d521f89dcf0f8b8$var$cubeUV_m0 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(-2);
const $7d521f89dcf0f8b8$var$cubeUV_r1 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(0.8);
const $7d521f89dcf0f8b8$var$cubeUV_m1 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(-1);
const $7d521f89dcf0f8b8$var$cubeUV_r4 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(0.4);
const $7d521f89dcf0f8b8$var$cubeUV_m4 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(2.0);
const $7d521f89dcf0f8b8$var$cubeUV_r5 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(0.305);
const $7d521f89dcf0f8b8$var$cubeUV_m5 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(3.0);
const $7d521f89dcf0f8b8$var$cubeUV_r6 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(0.21);
const $7d521f89dcf0f8b8$var$cubeUV_m6 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(4.0);
const $7d521f89dcf0f8b8$var$cubeUV_minMipLevel = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(4.0);
const $7d521f89dcf0f8b8$var$cubeUV_minTileSize = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(16.0);
// These shader functions convert between the UV coordinates of a single face of
// a cubemap, the 0-5 integer index of a cube face, and the direction vector for
// sampling a textureCube (not generally normalized ).
const $7d521f89dcf0f8b8$var$getFace = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$b076717d71a1a47f)(([direction])=>{
    const absDirection = (0, $d5b7ee61758b2e81$export$9100789c9d999364)((0, $f37ae0e58866c183$export$2335f513bbd82c6d)(direction)).toVar();
    const face = (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(-1).toVar();
    (0, $d5b7ee61758b2e81$export$1f9ff5f4a6c9361a)(absDirection.x.greaterThan(absDirection.z), ()=>{
        (0, $d5b7ee61758b2e81$export$1f9ff5f4a6c9361a)(absDirection.x.greaterThan(absDirection.y), ()=>{
            face.assign((0, $cb309bf1d9ed8a72$export$2e6c959c16ff56b8)(direction.x.greaterThan(0.0), 0.0, 3.0));
        }).Else(()=>{
            face.assign((0, $cb309bf1d9ed8a72$export$2e6c959c16ff56b8)(direction.y.greaterThan(0.0), 1.0, 4.0));
        });
    }).Else(()=>{
        (0, $d5b7ee61758b2e81$export$1f9ff5f4a6c9361a)(absDirection.z.greaterThan(absDirection.y), ()=>{
            face.assign((0, $cb309bf1d9ed8a72$export$2e6c959c16ff56b8)(direction.z.greaterThan(0.0), 2.0, 5.0));
        }).Else(()=>{
            face.assign((0, $cb309bf1d9ed8a72$export$2e6c959c16ff56b8)(direction.y.greaterThan(0.0), 1.0, 4.0));
        });
    });
    return face;
}).setLayout({
    name: 'getFace',
    type: 'float',
    inputs: [
        {
            name: 'direction',
            type: 'vec3'
        }
    ]
});
// RH coordinate system; PMREM face-indexing convention
const $7d521f89dcf0f8b8$var$getUV = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$b076717d71a1a47f)(([direction, face])=>{
    const uv = (0, $d5b7ee61758b2e81$export$e9830bc863290a54)().toVar();
    (0, $d5b7ee61758b2e81$export$1f9ff5f4a6c9361a)(face.equal(0.0), ()=>{
        uv.assign((0, $d5b7ee61758b2e81$export$e9830bc863290a54)(direction.z, direction.y).div((0, $f37ae0e58866c183$export$2335f513bbd82c6d)(direction.x))); // pos x
    }).ElseIf(face.equal(1.0), ()=>{
        uv.assign((0, $d5b7ee61758b2e81$export$e9830bc863290a54)(direction.x.negate(), direction.z.negate()).div((0, $f37ae0e58866c183$export$2335f513bbd82c6d)(direction.y))); // pos y
    }).ElseIf(face.equal(2.0), ()=>{
        uv.assign((0, $d5b7ee61758b2e81$export$e9830bc863290a54)(direction.x.negate(), direction.y).div((0, $f37ae0e58866c183$export$2335f513bbd82c6d)(direction.z))); // pos z
    }).ElseIf(face.equal(3.0), ()=>{
        uv.assign((0, $d5b7ee61758b2e81$export$e9830bc863290a54)(direction.z.negate(), direction.y).div((0, $f37ae0e58866c183$export$2335f513bbd82c6d)(direction.x))); // neg x
    }).ElseIf(face.equal(4.0), ()=>{
        uv.assign((0, $d5b7ee61758b2e81$export$e9830bc863290a54)(direction.x.negate(), direction.z).div((0, $f37ae0e58866c183$export$2335f513bbd82c6d)(direction.y))); // neg y
    }).Else(()=>{
        uv.assign((0, $d5b7ee61758b2e81$export$e9830bc863290a54)(direction.x, direction.y).div((0, $f37ae0e58866c183$export$2335f513bbd82c6d)(direction.z))); // neg z
    });
    return (0, $3f1f23fea79ae256$export$6e3a27864ab166fe)(0.5, uv.add(1.0));
}).setLayout({
    name: 'getUV',
    type: 'vec2',
    inputs: [
        {
            name: 'direction',
            type: 'vec3'
        },
        {
            name: 'face',
            type: 'float'
        }
    ]
});
const $7d521f89dcf0f8b8$var$roughnessToMip = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$b076717d71a1a47f)(([roughness])=>{
    const mip = (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(0.0).toVar();
    (0, $d5b7ee61758b2e81$export$1f9ff5f4a6c9361a)(roughness.greaterThanEqual($7d521f89dcf0f8b8$var$cubeUV_r1), ()=>{
        mip.assign($7d521f89dcf0f8b8$var$cubeUV_r0.sub(roughness).mul($7d521f89dcf0f8b8$var$cubeUV_m1.sub($7d521f89dcf0f8b8$var$cubeUV_m0)).div($7d521f89dcf0f8b8$var$cubeUV_r0.sub($7d521f89dcf0f8b8$var$cubeUV_r1)).add($7d521f89dcf0f8b8$var$cubeUV_m0));
    }).ElseIf(roughness.greaterThanEqual($7d521f89dcf0f8b8$var$cubeUV_r4), ()=>{
        mip.assign($7d521f89dcf0f8b8$var$cubeUV_r1.sub(roughness).mul($7d521f89dcf0f8b8$var$cubeUV_m4.sub($7d521f89dcf0f8b8$var$cubeUV_m1)).div($7d521f89dcf0f8b8$var$cubeUV_r1.sub($7d521f89dcf0f8b8$var$cubeUV_r4)).add($7d521f89dcf0f8b8$var$cubeUV_m1));
    }).ElseIf(roughness.greaterThanEqual($7d521f89dcf0f8b8$var$cubeUV_r5), ()=>{
        mip.assign($7d521f89dcf0f8b8$var$cubeUV_r4.sub(roughness).mul($7d521f89dcf0f8b8$var$cubeUV_m5.sub($7d521f89dcf0f8b8$var$cubeUV_m4)).div($7d521f89dcf0f8b8$var$cubeUV_r4.sub($7d521f89dcf0f8b8$var$cubeUV_r5)).add($7d521f89dcf0f8b8$var$cubeUV_m4));
    }).ElseIf(roughness.greaterThanEqual($7d521f89dcf0f8b8$var$cubeUV_r6), ()=>{
        mip.assign($7d521f89dcf0f8b8$var$cubeUV_r5.sub(roughness).mul($7d521f89dcf0f8b8$var$cubeUV_m6.sub($7d521f89dcf0f8b8$var$cubeUV_m5)).div($7d521f89dcf0f8b8$var$cubeUV_r5.sub($7d521f89dcf0f8b8$var$cubeUV_r6)).add($7d521f89dcf0f8b8$var$cubeUV_m5));
    }).Else(()=>{
        mip.assign((0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(-2).mul((0, $f37ae0e58866c183$export$b9fae0bba9d9094d)((0, $3f1f23fea79ae256$export$6e3a27864ab166fe)(1.16, roughness)))); // 1.16 = 1.79^0.25
    });
    return mip;
}).setLayout({
    name: 'roughnessToMip',
    type: 'float',
    inputs: [
        {
            name: 'roughness',
            type: 'float'
        }
    ]
});
const $7d521f89dcf0f8b8$export$fcce7887255d1c69 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$b076717d71a1a47f)(([uv_immutable, face])=>{
    const uv = uv_immutable.toVar();
    uv.assign((0, $3f1f23fea79ae256$export$6e3a27864ab166fe)(2.0, uv).sub(1.0));
    const direction = (0, $d5b7ee61758b2e81$export$9100789c9d999364)(uv, 1.0).toVar();
    (0, $d5b7ee61758b2e81$export$1f9ff5f4a6c9361a)(face.equal(0.0), ()=>{
        direction.assign(direction.zyx); // ( 1, v, u ) pos x
    }).ElseIf(face.equal(1.0), ()=>{
        direction.assign(direction.xzy);
        direction.xz.mulAssign(-1); // ( -u, 1, -v ) pos y
    }).ElseIf(face.equal(2.0), ()=>{
        direction.x.mulAssign(-1); // ( -u, v, 1 ) pos z
    }).ElseIf(face.equal(3.0), ()=>{
        direction.assign(direction.zyx);
        direction.xz.mulAssign(-1); // ( -1, v, -u ) neg x
    }).ElseIf(face.equal(4.0), ()=>{
        direction.assign(direction.xzy);
        direction.xy.mulAssign(-1); // ( -u, -1, v ) neg y
    }).ElseIf(face.equal(5.0), ()=>{
        direction.z.mulAssign(-1); // ( u, v, -1 ) neg zS
    });
    return direction;
}).setLayout({
    name: 'getDirection',
    type: 'vec3',
    inputs: [
        {
            name: 'uv',
            type: 'vec2'
        },
        {
            name: 'face',
            type: 'float'
        }
    ]
});
const $7d521f89dcf0f8b8$export$4c2c653e762aa352 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$b076717d71a1a47f)(([envMap, sampleDir_immutable, roughness_immutable, CUBEUV_TEXEL_WIDTH, CUBEUV_TEXEL_HEIGHT, CUBEUV_MAX_MIP])=>{
    const roughness = (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(roughness_immutable);
    const sampleDir = (0, $d5b7ee61758b2e81$export$9100789c9d999364)(sampleDir_immutable);
    const mip = (0, $f37ae0e58866c183$export$7d15b64cf5a3a4c4)($7d521f89dcf0f8b8$var$roughnessToMip(roughness), $7d521f89dcf0f8b8$var$cubeUV_m0, CUBEUV_MAX_MIP);
    const mipF = (0, $f37ae0e58866c183$export$a57bfe0eb79af278)(mip);
    const mipInt = (0, $f37ae0e58866c183$export$a3fe094919f356fd)(mip);
    const color0 = (0, $d5b7ee61758b2e81$export$9100789c9d999364)($7d521f89dcf0f8b8$var$bilinearCubeUV(envMap, sampleDir, mipInt, CUBEUV_TEXEL_WIDTH, CUBEUV_TEXEL_HEIGHT, CUBEUV_MAX_MIP)).toVar();
    (0, $d5b7ee61758b2e81$export$1f9ff5f4a6c9361a)(mipF.notEqual(0.0), ()=>{
        const color1 = (0, $d5b7ee61758b2e81$export$9100789c9d999364)($7d521f89dcf0f8b8$var$bilinearCubeUV(envMap, sampleDir, mipInt.add(1.0), CUBEUV_TEXEL_WIDTH, CUBEUV_TEXEL_HEIGHT, CUBEUV_MAX_MIP)).toVar();
        color0.assign((0, $f37ae0e58866c183$export$2c9e8a9632a706b2)(color0, color1, mipF));
    });
    return color0;
});
const $7d521f89dcf0f8b8$var$bilinearCubeUV = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$b076717d71a1a47f)(([envMap, direction_immutable, mipInt_immutable, CUBEUV_TEXEL_WIDTH, CUBEUV_TEXEL_HEIGHT, CUBEUV_MAX_MIP])=>{
    const mipInt = (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(mipInt_immutable).toVar();
    const direction = (0, $d5b7ee61758b2e81$export$9100789c9d999364)(direction_immutable);
    const face = (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)($7d521f89dcf0f8b8$var$getFace(direction)).toVar();
    const filterInt = (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)((0, $f37ae0e58866c183$export$8960430cfd85939f)($7d521f89dcf0f8b8$var$cubeUV_minMipLevel.sub(mipInt), 0.0)).toVar();
    mipInt.assign((0, $f37ae0e58866c183$export$8960430cfd85939f)(mipInt, $7d521f89dcf0f8b8$var$cubeUV_minMipLevel));
    const faceSize = (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)((0, $f37ae0e58866c183$export$4edc262d3118e986)(mipInt)).toVar();
    const uv = (0, $d5b7ee61758b2e81$export$e9830bc863290a54)($7d521f89dcf0f8b8$var$getUV(direction, face).mul(faceSize.sub(2.0)).add(1.0)).toVar();
    (0, $d5b7ee61758b2e81$export$1f9ff5f4a6c9361a)(face.greaterThan(2.0), ()=>{
        uv.y.addAssign(faceSize);
        face.subAssign(3.0);
    });
    uv.x.addAssign(face.mul(faceSize));
    uv.x.addAssign(filterInt.mul((0, $3f1f23fea79ae256$export$6e3a27864ab166fe)(3.0, $7d521f89dcf0f8b8$var$cubeUV_minTileSize)));
    uv.y.addAssign((0, $3f1f23fea79ae256$export$6e3a27864ab166fe)(4.0, (0, $f37ae0e58866c183$export$4edc262d3118e986)(CUBEUV_MAX_MIP).sub(faceSize)));
    uv.x.mulAssign(CUBEUV_TEXEL_WIDTH);
    uv.y.mulAssign(CUBEUV_TEXEL_HEIGHT);
    return envMap.uv(uv).grad((0, $d5b7ee61758b2e81$export$e9830bc863290a54)(), (0, $d5b7ee61758b2e81$export$e9830bc863290a54)()); // disable anisotropic filtering
});
const $7d521f89dcf0f8b8$var$getSample = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$b076717d71a1a47f)(({ envMap: envMap, mipInt: mipInt, outputDirection: outputDirection, theta: theta, axis: axis, CUBEUV_TEXEL_WIDTH: CUBEUV_TEXEL_WIDTH, CUBEUV_TEXEL_HEIGHT: CUBEUV_TEXEL_HEIGHT, CUBEUV_MAX_MIP: CUBEUV_MAX_MIP })=>{
    const cosTheta = (0, $f37ae0e58866c183$export$50d414a77b60d802)(theta);
    // Rodrigues' axis-angle rotation
    const sampleDirection = outputDirection.mul(cosTheta).add(axis.cross(outputDirection).mul((0, $f37ae0e58866c183$export$5de3937cb4b592ed)(theta))).add(axis.mul(axis.dot(outputDirection).mul(cosTheta.oneMinus())));
    return $7d521f89dcf0f8b8$var$bilinearCubeUV(envMap, sampleDirection, mipInt, CUBEUV_TEXEL_WIDTH, CUBEUV_TEXEL_HEIGHT, CUBEUV_MAX_MIP);
});
const $7d521f89dcf0f8b8$export$2cc7ff91bcacba5e = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$b076717d71a1a47f)(({ n: n, latitudinal: latitudinal, poleAxis: poleAxis, outputDirection: outputDirection, weights: weights, samples: samples, dTheta: dTheta, mipInt: mipInt, envMap: envMap, CUBEUV_TEXEL_WIDTH: CUBEUV_TEXEL_WIDTH, CUBEUV_TEXEL_HEIGHT: CUBEUV_TEXEL_HEIGHT, CUBEUV_MAX_MIP: CUBEUV_MAX_MIP })=>{
    const axis = (0, $d5b7ee61758b2e81$export$9100789c9d999364)((0, $cb309bf1d9ed8a72$export$2e6c959c16ff56b8)(latitudinal, poleAxis, (0, $f37ae0e58866c183$export$bb646b20bb93d339)(poleAxis, outputDirection))).toVar();
    (0, $d5b7ee61758b2e81$export$1f9ff5f4a6c9361a)((0, $f37ae0e58866c183$export$84bf76cd7afc7469)(axis.equals((0, $d5b7ee61758b2e81$export$9100789c9d999364)(0.0))), ()=>{
        axis.assign((0, $d5b7ee61758b2e81$export$9100789c9d999364)(outputDirection.z, 0.0, outputDirection.x.negate()));
    });
    axis.assign((0, $f37ae0e58866c183$export$a3295358bff77e)(axis));
    const gl_FragColor = (0, $d5b7ee61758b2e81$export$9100789c9d999364)().toVar();
    gl_FragColor.addAssign(weights.element((0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)(0)).mul($7d521f89dcf0f8b8$var$getSample({
        theta: 0.0,
        axis: axis,
        outputDirection: outputDirection,
        mipInt: mipInt,
        envMap: envMap,
        CUBEUV_TEXEL_WIDTH: CUBEUV_TEXEL_WIDTH,
        CUBEUV_TEXEL_HEIGHT: CUBEUV_TEXEL_HEIGHT,
        CUBEUV_MAX_MIP: CUBEUV_MAX_MIP
    })));
    (0, $2a1578e0d4d8bf63$export$550acbd06a1f5a6a)({
        start: (0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)(1),
        end: n
    }, ({ i: i })=>{
        (0, $d5b7ee61758b2e81$export$1f9ff5f4a6c9361a)(i.greaterThanEqual(samples), ()=>{
            (0, $2a1578e0d4d8bf63$export$c88190a7f68b38c0)();
        });
        const theta = (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(dTheta.mul((0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(i))).toVar();
        gl_FragColor.addAssign(weights.element(i).mul($7d521f89dcf0f8b8$var$getSample({
            theta: theta.mul(-1),
            axis: axis,
            outputDirection: outputDirection,
            mipInt: mipInt,
            envMap: envMap,
            CUBEUV_TEXEL_WIDTH: CUBEUV_TEXEL_WIDTH,
            CUBEUV_TEXEL_HEIGHT: CUBEUV_TEXEL_HEIGHT,
            CUBEUV_MAX_MIP: CUBEUV_MAX_MIP
        })));
        gl_FragColor.addAssign(weights.element(i).mul($7d521f89dcf0f8b8$var$getSample({
            theta: theta,
            axis: axis,
            outputDirection: outputDirection,
            mipInt: mipInt,
            envMap: envMap,
            CUBEUV_TEXEL_WIDTH: CUBEUV_TEXEL_WIDTH,
            CUBEUV_TEXEL_HEIGHT: CUBEUV_TEXEL_HEIGHT,
            CUBEUV_MAX_MIP: CUBEUV_MAX_MIP
        })));
    });
    return (0, $d5b7ee61758b2e81$export$6dba2a1f0d609415)(gl_FragColor, 1);
});







let $23ee98d041aa8c55$var$_generator = null;
const $23ee98d041aa8c55$var$_cache = new WeakMap();
function $23ee98d041aa8c55$var$_generateCubeUVSize(imageHeight) {
    const maxMip = Math.log2(imageHeight) - 2;
    const texelHeight = 1.0 / imageHeight;
    const texelWidth = 1.0 / (3 * Math.max(Math.pow(2, maxMip), 112));
    return {
        texelWidth: texelWidth,
        texelHeight: texelHeight,
        maxMip: maxMip
    };
}
function $23ee98d041aa8c55$var$_getPMREMFromTexture(texture) {
    let cacheTexture = $23ee98d041aa8c55$var$_cache.get(texture);
    const pmremVersion = cacheTexture !== undefined ? cacheTexture.pmremVersion : -1;
    if (pmremVersion !== texture.pmremVersion) {
        const image = texture.image;
        if (texture.isCubeTexture) {
            if ($23ee98d041aa8c55$var$isCubeMapReady(image)) cacheTexture = $23ee98d041aa8c55$var$_generator.fromCubemap(texture, cacheTexture);
            else return null;
        } else {
            if ($23ee98d041aa8c55$var$isEquirectangularMapReady(image)) cacheTexture = $23ee98d041aa8c55$var$_generator.fromEquirectangular(texture, cacheTexture);
            else return null;
        }
        cacheTexture.pmremVersion = texture.pmremVersion;
        $23ee98d041aa8c55$var$_cache.set(texture, cacheTexture);
    }
    return cacheTexture.texture;
}
class $23ee98d041aa8c55$var$PMREMNode extends (0, $75c45ed2361c955f$export$2e2bcd8739ae039) {
    static get type() {
        return 'PMREMNode';
    }
    constructor(value, uvNode = null, levelNode = null){
        super('vec3');
        this._value = value;
        this._pmrem = null;
        this.uvNode = uvNode;
        this.levelNode = levelNode;
        this._generator = null;
        const defaultTexture = new (0, $97033ebbcbadc145$export$5431306cf43de24a)();
        defaultTexture.isRenderTargetTexture = true;
        this._texture = (0, $f7d68bbf9ea772a7$export$ab69073b3903a075)(defaultTexture);
        this._width = (0, $5eb92bf12e57daab$export$379455b567eff87d)(0);
        this._height = (0, $5eb92bf12e57daab$export$379455b567eff87d)(0);
        this._maxMip = (0, $5eb92bf12e57daab$export$379455b567eff87d)(0);
        this.updateBeforeType = (0, $ddcfecb7fbba5d74$export$26f7a8bbd9469530).RENDER;
    }
    set value(value) {
        this._value = value;
        this._pmrem = null;
    }
    get value() {
        return this._value;
    }
    updateFromTexture(texture) {
        const cubeUVSize = $23ee98d041aa8c55$var$_generateCubeUVSize(texture.image.height);
        this._texture.value = texture;
        this._width.value = cubeUVSize.texelWidth;
        this._height.value = cubeUVSize.texelHeight;
        this._maxMip.value = cubeUVSize.maxMip;
    }
    updateBefore() {
        let pmrem = this._pmrem;
        const pmremVersion = pmrem ? pmrem.pmremVersion : -1;
        const texture = this._value;
        if (pmremVersion !== texture.pmremVersion) {
            if (texture.isPMREMTexture === true) pmrem = texture;
            else pmrem = $23ee98d041aa8c55$var$_getPMREMFromTexture(texture);
            if (pmrem !== null) {
                this._pmrem = pmrem;
                this.updateFromTexture(pmrem);
            }
        }
    }
    setup(builder) {
        if ($23ee98d041aa8c55$var$_generator === null) $23ee98d041aa8c55$var$_generator = builder.createPMREMGenerator();
        //
        this.updateBefore(builder);
        //
        let uvNode = this.uvNode;
        if (uvNode === null && builder.context.getUV) uvNode = builder.context.getUV(this);
        //
        const texture = this.value;
        if (builder.renderer.coordinateSystem === (0, $cb5ee595c0f892af$export$5a0e9190d10875d3) && texture.isPMREMTexture !== true && texture.isRenderTargetTexture === true) uvNode = (0, $d5b7ee61758b2e81$export$9100789c9d999364)(uvNode.x.negate(), uvNode.yz);
        //
        let levelNode = this.levelNode;
        if (levelNode === null && builder.context.getTextureLevel) levelNode = builder.context.getTextureLevel(this);
        //
        return (0, $7d521f89dcf0f8b8$export$4c2c653e762aa352)(this._texture, uvNode, levelNode, this._width, this._height, this._maxMip);
    }
}
var $23ee98d041aa8c55$export$2e2bcd8739ae039 = $23ee98d041aa8c55$var$PMREMNode;
function $23ee98d041aa8c55$var$isCubeMapReady(image) {
    if (image === null || image === undefined) return false;
    let count = 0;
    const length = 6;
    for(let i = 0; i < length; i++)if (image[i] !== undefined) count++;
    return count === length;
}
function $23ee98d041aa8c55$var$isEquirectangularMapReady(image) {
    if (image === null || image === undefined) return false;
    return image.height > 0;
}
const $23ee98d041aa8c55$export$7563f7aed5e67dc = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$60d11c6747b7deba)($23ee98d041aa8c55$var$PMREMNode);





const $e6cb8acb06acd83e$export$86201b36d8e19735 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$b076717d71a1a47f)(([coord = (0, $382a32bd765f3827$export$c774ebbac59e31d3)()])=>{
    const uv1 = coord.mul(2.0);
    const cx = uv1.x.floor();
    const cy = uv1.y.floor();
    const result = cx.add(cy).mod(2.0);
    return result.sign();
});


// Three.js Transpiler
// https://raw.githubusercontent.com/AcademySoftwareFoundation/MaterialX/main/libraries/stdlib/genglsl/lib/mx_noise.glsl






const $5008de97d433d64a$export$fcb3e1b8d74c8b23 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$b076717d71a1a47f)(([b_immutable, t_immutable, f_immutable])=>{
    const f = (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(f_immutable).toVar();
    const t = (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(t_immutable).toVar();
    const b = (0, $d5b7ee61758b2e81$export$87b259aa03e3d267)(b_immutable).toVar();
    return (0, $cb309bf1d9ed8a72$export$2e6c959c16ff56b8)(b, t, f);
}).setLayout({
    name: 'mx_select',
    type: 'float',
    inputs: [
        {
            name: 'b',
            type: 'bool'
        },
        {
            name: 't',
            type: 'float'
        },
        {
            name: 'f',
            type: 'float'
        }
    ]
});
const $5008de97d433d64a$export$806591ac4956b890 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$b076717d71a1a47f)(([val_immutable, b_immutable])=>{
    const b = (0, $d5b7ee61758b2e81$export$87b259aa03e3d267)(b_immutable).toVar();
    const val = (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(val_immutable).toVar();
    return (0, $cb309bf1d9ed8a72$export$2e6c959c16ff56b8)(b, val.negate(), val);
}).setLayout({
    name: 'mx_negate_if',
    type: 'float',
    inputs: [
        {
            name: 'val',
            type: 'float'
        },
        {
            name: 'b',
            type: 'bool'
        }
    ]
});
const $5008de97d433d64a$export$c4655eced0ba6aa5 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$b076717d71a1a47f)(([x_immutable])=>{
    const x = (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(x_immutable).toVar();
    return (0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)((0, $f37ae0e58866c183$export$a3fe094919f356fd)(x));
}).setLayout({
    name: 'mx_floor',
    type: 'int',
    inputs: [
        {
            name: 'x',
            type: 'float'
        }
    ]
});
const $5008de97d433d64a$export$2924b498742ec559 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$b076717d71a1a47f)(([x_immutable, i])=>{
    const x = (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(x_immutable).toVar();
    i.assign($5008de97d433d64a$export$c4655eced0ba6aa5(x));
    return x.sub((0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(i));
});
const $5008de97d433d64a$export$553888c5aac91521 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$b076717d71a1a47f)(([v0_immutable, v1_immutable, v2_immutable, v3_immutable, s_immutable, t_immutable])=>{
    const t = (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(t_immutable).toVar();
    const s = (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(s_immutable).toVar();
    const v3 = (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(v3_immutable).toVar();
    const v2 = (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(v2_immutable).toVar();
    const v1 = (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(v1_immutable).toVar();
    const v0 = (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(v0_immutable).toVar();
    const s1 = (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)((0, $3f1f23fea79ae256$export$f93b5905241a7cca)(1.0, s)).toVar();
    return (0, $3f1f23fea79ae256$export$f93b5905241a7cca)(1.0, t).mul(v0.mul(s1).add(v1.mul(s))).add(t.mul(v2.mul(s1).add(v3.mul(s))));
}).setLayout({
    name: 'mx_bilerp_0',
    type: 'float',
    inputs: [
        {
            name: 'v0',
            type: 'float'
        },
        {
            name: 'v1',
            type: 'float'
        },
        {
            name: 'v2',
            type: 'float'
        },
        {
            name: 'v3',
            type: 'float'
        },
        {
            name: 's',
            type: 'float'
        },
        {
            name: 't',
            type: 'float'
        }
    ]
});
const $5008de97d433d64a$export$e4619c334236d381 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$b076717d71a1a47f)(([v0_immutable, v1_immutable, v2_immutable, v3_immutable, s_immutable, t_immutable])=>{
    const t = (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(t_immutable).toVar();
    const s = (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(s_immutable).toVar();
    const v3 = (0, $d5b7ee61758b2e81$export$9100789c9d999364)(v3_immutable).toVar();
    const v2 = (0, $d5b7ee61758b2e81$export$9100789c9d999364)(v2_immutable).toVar();
    const v1 = (0, $d5b7ee61758b2e81$export$9100789c9d999364)(v1_immutable).toVar();
    const v0 = (0, $d5b7ee61758b2e81$export$9100789c9d999364)(v0_immutable).toVar();
    const s1 = (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)((0, $3f1f23fea79ae256$export$f93b5905241a7cca)(1.0, s)).toVar();
    return (0, $3f1f23fea79ae256$export$f93b5905241a7cca)(1.0, t).mul(v0.mul(s1).add(v1.mul(s))).add(t.mul(v2.mul(s1).add(v3.mul(s))));
}).setLayout({
    name: 'mx_bilerp_1',
    type: 'vec3',
    inputs: [
        {
            name: 'v0',
            type: 'vec3'
        },
        {
            name: 'v1',
            type: 'vec3'
        },
        {
            name: 'v2',
            type: 'vec3'
        },
        {
            name: 'v3',
            type: 'vec3'
        },
        {
            name: 's',
            type: 'float'
        },
        {
            name: 't',
            type: 'float'
        }
    ]
});
const $5008de97d433d64a$export$d7adc3042282e3fa = /*@__PURE__*/ (0, $228cc208600144f8$export$16973c2f8bfadf46)([
    $5008de97d433d64a$export$553888c5aac91521,
    $5008de97d433d64a$export$e4619c334236d381
]);
const $5008de97d433d64a$export$4b040b5432191095 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$b076717d71a1a47f)(([v0_immutable, v1_immutable, v2_immutable, v3_immutable, v4_immutable, v5_immutable, v6_immutable, v7_immutable, s_immutable, t_immutable, r_immutable])=>{
    const r = (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(r_immutable).toVar();
    const t = (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(t_immutable).toVar();
    const s = (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(s_immutable).toVar();
    const v7 = (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(v7_immutable).toVar();
    const v6 = (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(v6_immutable).toVar();
    const v5 = (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(v5_immutable).toVar();
    const v4 = (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(v4_immutable).toVar();
    const v3 = (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(v3_immutable).toVar();
    const v2 = (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(v2_immutable).toVar();
    const v1 = (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(v1_immutable).toVar();
    const v0 = (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(v0_immutable).toVar();
    const s1 = (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)((0, $3f1f23fea79ae256$export$f93b5905241a7cca)(1.0, s)).toVar();
    const t1 = (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)((0, $3f1f23fea79ae256$export$f93b5905241a7cca)(1.0, t)).toVar();
    const r1 = (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)((0, $3f1f23fea79ae256$export$f93b5905241a7cca)(1.0, r)).toVar();
    return r1.mul(t1.mul(v0.mul(s1).add(v1.mul(s))).add(t.mul(v2.mul(s1).add(v3.mul(s))))).add(r.mul(t1.mul(v4.mul(s1).add(v5.mul(s))).add(t.mul(v6.mul(s1).add(v7.mul(s))))));
}).setLayout({
    name: 'mx_trilerp_0',
    type: 'float',
    inputs: [
        {
            name: 'v0',
            type: 'float'
        },
        {
            name: 'v1',
            type: 'float'
        },
        {
            name: 'v2',
            type: 'float'
        },
        {
            name: 'v3',
            type: 'float'
        },
        {
            name: 'v4',
            type: 'float'
        },
        {
            name: 'v5',
            type: 'float'
        },
        {
            name: 'v6',
            type: 'float'
        },
        {
            name: 'v7',
            type: 'float'
        },
        {
            name: 's',
            type: 'float'
        },
        {
            name: 't',
            type: 'float'
        },
        {
            name: 'r',
            type: 'float'
        }
    ]
});
const $5008de97d433d64a$export$7e330de4f4d24f93 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$b076717d71a1a47f)(([v0_immutable, v1_immutable, v2_immutable, v3_immutable, v4_immutable, v5_immutable, v6_immutable, v7_immutable, s_immutable, t_immutable, r_immutable])=>{
    const r = (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(r_immutable).toVar();
    const t = (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(t_immutable).toVar();
    const s = (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(s_immutable).toVar();
    const v7 = (0, $d5b7ee61758b2e81$export$9100789c9d999364)(v7_immutable).toVar();
    const v6 = (0, $d5b7ee61758b2e81$export$9100789c9d999364)(v6_immutable).toVar();
    const v5 = (0, $d5b7ee61758b2e81$export$9100789c9d999364)(v5_immutable).toVar();
    const v4 = (0, $d5b7ee61758b2e81$export$9100789c9d999364)(v4_immutable).toVar();
    const v3 = (0, $d5b7ee61758b2e81$export$9100789c9d999364)(v3_immutable).toVar();
    const v2 = (0, $d5b7ee61758b2e81$export$9100789c9d999364)(v2_immutable).toVar();
    const v1 = (0, $d5b7ee61758b2e81$export$9100789c9d999364)(v1_immutable).toVar();
    const v0 = (0, $d5b7ee61758b2e81$export$9100789c9d999364)(v0_immutable).toVar();
    const s1 = (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)((0, $3f1f23fea79ae256$export$f93b5905241a7cca)(1.0, s)).toVar();
    const t1 = (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)((0, $3f1f23fea79ae256$export$f93b5905241a7cca)(1.0, t)).toVar();
    const r1 = (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)((0, $3f1f23fea79ae256$export$f93b5905241a7cca)(1.0, r)).toVar();
    return r1.mul(t1.mul(v0.mul(s1).add(v1.mul(s))).add(t.mul(v2.mul(s1).add(v3.mul(s))))).add(r.mul(t1.mul(v4.mul(s1).add(v5.mul(s))).add(t.mul(v6.mul(s1).add(v7.mul(s))))));
}).setLayout({
    name: 'mx_trilerp_1',
    type: 'vec3',
    inputs: [
        {
            name: 'v0',
            type: 'vec3'
        },
        {
            name: 'v1',
            type: 'vec3'
        },
        {
            name: 'v2',
            type: 'vec3'
        },
        {
            name: 'v3',
            type: 'vec3'
        },
        {
            name: 'v4',
            type: 'vec3'
        },
        {
            name: 'v5',
            type: 'vec3'
        },
        {
            name: 'v6',
            type: 'vec3'
        },
        {
            name: 'v7',
            type: 'vec3'
        },
        {
            name: 's',
            type: 'float'
        },
        {
            name: 't',
            type: 'float'
        },
        {
            name: 'r',
            type: 'float'
        }
    ]
});
const $5008de97d433d64a$export$83e686cd331bbe85 = /*@__PURE__*/ (0, $228cc208600144f8$export$16973c2f8bfadf46)([
    $5008de97d433d64a$export$4b040b5432191095,
    $5008de97d433d64a$export$7e330de4f4d24f93
]);
const $5008de97d433d64a$export$f655677fe003c96 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$b076717d71a1a47f)(([hash_immutable, x_immutable, y_immutable])=>{
    const y = (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(y_immutable).toVar();
    const x = (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(x_immutable).toVar();
    const hash = (0, $d5b7ee61758b2e81$export$877455b195f03b92)(hash_immutable).toVar();
    const h = (0, $d5b7ee61758b2e81$export$877455b195f03b92)(hash.bitAnd((0, $d5b7ee61758b2e81$export$877455b195f03b92)(7))).toVar();
    const u = (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)($5008de97d433d64a$export$fcb3e1b8d74c8b23(h.lessThan((0, $d5b7ee61758b2e81$export$877455b195f03b92)(4)), x, y)).toVar();
    const v = (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)((0, $3f1f23fea79ae256$export$6e3a27864ab166fe)(2.0, $5008de97d433d64a$export$fcb3e1b8d74c8b23(h.lessThan((0, $d5b7ee61758b2e81$export$877455b195f03b92)(4)), y, x))).toVar();
    return $5008de97d433d64a$export$806591ac4956b890(u, (0, $d5b7ee61758b2e81$export$87b259aa03e3d267)(h.bitAnd((0, $d5b7ee61758b2e81$export$877455b195f03b92)(1)))).add($5008de97d433d64a$export$806591ac4956b890(v, (0, $d5b7ee61758b2e81$export$87b259aa03e3d267)(h.bitAnd((0, $d5b7ee61758b2e81$export$877455b195f03b92)(2)))));
}).setLayout({
    name: 'mx_gradient_float_0',
    type: 'float',
    inputs: [
        {
            name: 'hash',
            type: 'uint'
        },
        {
            name: 'x',
            type: 'float'
        },
        {
            name: 'y',
            type: 'float'
        }
    ]
});
const $5008de97d433d64a$export$2400cb55e3a16d61 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$b076717d71a1a47f)(([hash_immutable, x_immutable, y_immutable, z_immutable])=>{
    const z = (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(z_immutable).toVar();
    const y = (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(y_immutable).toVar();
    const x = (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(x_immutable).toVar();
    const hash = (0, $d5b7ee61758b2e81$export$877455b195f03b92)(hash_immutable).toVar();
    const h = (0, $d5b7ee61758b2e81$export$877455b195f03b92)(hash.bitAnd((0, $d5b7ee61758b2e81$export$877455b195f03b92)(15))).toVar();
    const u = (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)($5008de97d433d64a$export$fcb3e1b8d74c8b23(h.lessThan((0, $d5b7ee61758b2e81$export$877455b195f03b92)(8)), x, y)).toVar();
    const v = (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)($5008de97d433d64a$export$fcb3e1b8d74c8b23(h.lessThan((0, $d5b7ee61758b2e81$export$877455b195f03b92)(4)), y, $5008de97d433d64a$export$fcb3e1b8d74c8b23(h.equal((0, $d5b7ee61758b2e81$export$877455b195f03b92)(12)).or(h.equal((0, $d5b7ee61758b2e81$export$877455b195f03b92)(14))), x, z))).toVar();
    return $5008de97d433d64a$export$806591ac4956b890(u, (0, $d5b7ee61758b2e81$export$87b259aa03e3d267)(h.bitAnd((0, $d5b7ee61758b2e81$export$877455b195f03b92)(1)))).add($5008de97d433d64a$export$806591ac4956b890(v, (0, $d5b7ee61758b2e81$export$87b259aa03e3d267)(h.bitAnd((0, $d5b7ee61758b2e81$export$877455b195f03b92)(2)))));
}).setLayout({
    name: 'mx_gradient_float_1',
    type: 'float',
    inputs: [
        {
            name: 'hash',
            type: 'uint'
        },
        {
            name: 'x',
            type: 'float'
        },
        {
            name: 'y',
            type: 'float'
        },
        {
            name: 'z',
            type: 'float'
        }
    ]
});
const $5008de97d433d64a$export$a7c336d113e7d56e = /*@__PURE__*/ (0, $228cc208600144f8$export$16973c2f8bfadf46)([
    $5008de97d433d64a$export$f655677fe003c96,
    $5008de97d433d64a$export$2400cb55e3a16d61
]);
const $5008de97d433d64a$export$860ed42bee420b82 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$b076717d71a1a47f)(([hash_immutable, x_immutable, y_immutable])=>{
    const y = (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(y_immutable).toVar();
    const x = (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(x_immutable).toVar();
    const hash = (0, $d5b7ee61758b2e81$export$bffc171a9468d831)(hash_immutable).toVar();
    return (0, $d5b7ee61758b2e81$export$9100789c9d999364)($5008de97d433d64a$export$a7c336d113e7d56e(hash.x, x, y), $5008de97d433d64a$export$a7c336d113e7d56e(hash.y, x, y), $5008de97d433d64a$export$a7c336d113e7d56e(hash.z, x, y));
}).setLayout({
    name: 'mx_gradient_vec3_0',
    type: 'vec3',
    inputs: [
        {
            name: 'hash',
            type: 'uvec3'
        },
        {
            name: 'x',
            type: 'float'
        },
        {
            name: 'y',
            type: 'float'
        }
    ]
});
const $5008de97d433d64a$export$e3008137dba801c0 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$b076717d71a1a47f)(([hash_immutable, x_immutable, y_immutable, z_immutable])=>{
    const z = (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(z_immutable).toVar();
    const y = (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(y_immutable).toVar();
    const x = (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(x_immutable).toVar();
    const hash = (0, $d5b7ee61758b2e81$export$bffc171a9468d831)(hash_immutable).toVar();
    return (0, $d5b7ee61758b2e81$export$9100789c9d999364)($5008de97d433d64a$export$a7c336d113e7d56e(hash.x, x, y, z), $5008de97d433d64a$export$a7c336d113e7d56e(hash.y, x, y, z), $5008de97d433d64a$export$a7c336d113e7d56e(hash.z, x, y, z));
}).setLayout({
    name: 'mx_gradient_vec3_1',
    type: 'vec3',
    inputs: [
        {
            name: 'hash',
            type: 'uvec3'
        },
        {
            name: 'x',
            type: 'float'
        },
        {
            name: 'y',
            type: 'float'
        },
        {
            name: 'z',
            type: 'float'
        }
    ]
});
const $5008de97d433d64a$export$5fad2327a2fce05 = /*@__PURE__*/ (0, $228cc208600144f8$export$16973c2f8bfadf46)([
    $5008de97d433d64a$export$860ed42bee420b82,
    $5008de97d433d64a$export$e3008137dba801c0
]);
const $5008de97d433d64a$export$32c0570637012b8a = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$b076717d71a1a47f)(([v_immutable])=>{
    const v = (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(v_immutable).toVar();
    return (0, $3f1f23fea79ae256$export$6e3a27864ab166fe)(0.6616, v);
}).setLayout({
    name: 'mx_gradient_scale2d_0',
    type: 'float',
    inputs: [
        {
            name: 'v',
            type: 'float'
        }
    ]
});
const $5008de97d433d64a$export$6e6d83a63029e36f = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$b076717d71a1a47f)(([v_immutable])=>{
    const v = (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(v_immutable).toVar();
    return (0, $3f1f23fea79ae256$export$6e3a27864ab166fe)(0.9820, v);
}).setLayout({
    name: 'mx_gradient_scale3d_0',
    type: 'float',
    inputs: [
        {
            name: 'v',
            type: 'float'
        }
    ]
});
const $5008de97d433d64a$export$5fb2decff99c0aa7 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$b076717d71a1a47f)(([v_immutable])=>{
    const v = (0, $d5b7ee61758b2e81$export$9100789c9d999364)(v_immutable).toVar();
    return (0, $3f1f23fea79ae256$export$6e3a27864ab166fe)(0.6616, v);
}).setLayout({
    name: 'mx_gradient_scale2d_1',
    type: 'vec3',
    inputs: [
        {
            name: 'v',
            type: 'vec3'
        }
    ]
});
const $5008de97d433d64a$export$9545d7b50b8a37fa = /*@__PURE__*/ (0, $228cc208600144f8$export$16973c2f8bfadf46)([
    $5008de97d433d64a$export$32c0570637012b8a,
    $5008de97d433d64a$export$5fb2decff99c0aa7
]);
const $5008de97d433d64a$export$153df63471a32aa1 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$b076717d71a1a47f)(([v_immutable])=>{
    const v = (0, $d5b7ee61758b2e81$export$9100789c9d999364)(v_immutable).toVar();
    return (0, $3f1f23fea79ae256$export$6e3a27864ab166fe)(0.9820, v);
}).setLayout({
    name: 'mx_gradient_scale3d_1',
    type: 'vec3',
    inputs: [
        {
            name: 'v',
            type: 'vec3'
        }
    ]
});
const $5008de97d433d64a$export$de4bf689fdc55e48 = /*@__PURE__*/ (0, $228cc208600144f8$export$16973c2f8bfadf46)([
    $5008de97d433d64a$export$6e6d83a63029e36f,
    $5008de97d433d64a$export$153df63471a32aa1
]);
const $5008de97d433d64a$export$6d9d66de1ac63983 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$b076717d71a1a47f)(([x_immutable, k_immutable])=>{
    const k = (0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)(k_immutable).toVar();
    const x = (0, $d5b7ee61758b2e81$export$877455b195f03b92)(x_immutable).toVar();
    return x.shiftLeft(k).bitOr(x.shiftRight((0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)(32).sub(k)));
}).setLayout({
    name: 'mx_rotl32',
    type: 'uint',
    inputs: [
        {
            name: 'x',
            type: 'uint'
        },
        {
            name: 'k',
            type: 'int'
        }
    ]
});
const $5008de97d433d64a$export$b37358d1d465116c = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$b076717d71a1a47f)(([a, b, c])=>{
    a.subAssign(c);
    a.bitXorAssign($5008de97d433d64a$export$6d9d66de1ac63983(c, (0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)(4)));
    c.addAssign(b);
    b.subAssign(a);
    b.bitXorAssign($5008de97d433d64a$export$6d9d66de1ac63983(a, (0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)(6)));
    a.addAssign(c);
    c.subAssign(b);
    c.bitXorAssign($5008de97d433d64a$export$6d9d66de1ac63983(b, (0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)(8)));
    b.addAssign(a);
    a.subAssign(c);
    a.bitXorAssign($5008de97d433d64a$export$6d9d66de1ac63983(c, (0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)(16)));
    c.addAssign(b);
    b.subAssign(a);
    b.bitXorAssign($5008de97d433d64a$export$6d9d66de1ac63983(a, (0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)(19)));
    a.addAssign(c);
    c.subAssign(b);
    c.bitXorAssign($5008de97d433d64a$export$6d9d66de1ac63983(b, (0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)(4)));
    b.addAssign(a);
});
const $5008de97d433d64a$export$ec469612ab433c08 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$b076717d71a1a47f)(([a_immutable, b_immutable, c_immutable])=>{
    const c = (0, $d5b7ee61758b2e81$export$877455b195f03b92)(c_immutable).toVar();
    const b = (0, $d5b7ee61758b2e81$export$877455b195f03b92)(b_immutable).toVar();
    const a = (0, $d5b7ee61758b2e81$export$877455b195f03b92)(a_immutable).toVar();
    c.bitXorAssign(b);
    c.subAssign($5008de97d433d64a$export$6d9d66de1ac63983(b, (0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)(14)));
    a.bitXorAssign(c);
    a.subAssign($5008de97d433d64a$export$6d9d66de1ac63983(c, (0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)(11)));
    b.bitXorAssign(a);
    b.subAssign($5008de97d433d64a$export$6d9d66de1ac63983(a, (0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)(25)));
    c.bitXorAssign(b);
    c.subAssign($5008de97d433d64a$export$6d9d66de1ac63983(b, (0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)(16)));
    a.bitXorAssign(c);
    a.subAssign($5008de97d433d64a$export$6d9d66de1ac63983(c, (0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)(4)));
    b.bitXorAssign(a);
    b.subAssign($5008de97d433d64a$export$6d9d66de1ac63983(a, (0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)(14)));
    c.bitXorAssign(b);
    c.subAssign($5008de97d433d64a$export$6d9d66de1ac63983(b, (0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)(24)));
    return c;
}).setLayout({
    name: 'mx_bjfinal',
    type: 'uint',
    inputs: [
        {
            name: 'a',
            type: 'uint'
        },
        {
            name: 'b',
            type: 'uint'
        },
        {
            name: 'c',
            type: 'uint'
        }
    ]
});
const $5008de97d433d64a$export$3af44866218d463 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$b076717d71a1a47f)(([bits_immutable])=>{
    const bits = (0, $d5b7ee61758b2e81$export$877455b195f03b92)(bits_immutable).toVar();
    return (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(bits).div((0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)((0, $d5b7ee61758b2e81$export$877455b195f03b92)((0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)(0xffffffff))));
}).setLayout({
    name: 'mx_bits_to_01',
    type: 'float',
    inputs: [
        {
            name: 'bits',
            type: 'uint'
        }
    ]
});
const $5008de97d433d64a$export$cebcae46bfff0866 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$b076717d71a1a47f)(([t_immutable])=>{
    const t = (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(t_immutable).toVar();
    return t.mul(t).mul(t).mul(t.mul(t.mul(6.0).sub(15.0)).add(10.0));
}).setLayout({
    name: 'mx_fade',
    type: 'float',
    inputs: [
        {
            name: 't',
            type: 'float'
        }
    ]
});
const $5008de97d433d64a$export$b28729497a28c906 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$b076717d71a1a47f)(([x_immutable])=>{
    const x = (0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)(x_immutable).toVar();
    const len = (0, $d5b7ee61758b2e81$export$877455b195f03b92)((0, $d5b7ee61758b2e81$export$877455b195f03b92)(1)).toVar();
    const seed = (0, $d5b7ee61758b2e81$export$877455b195f03b92)((0, $d5b7ee61758b2e81$export$877455b195f03b92)((0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)(0xdeadbeef)).add(len.shiftLeft((0, $d5b7ee61758b2e81$export$877455b195f03b92)(2))).add((0, $d5b7ee61758b2e81$export$877455b195f03b92)(13))).toVar();
    return $5008de97d433d64a$export$ec469612ab433c08(seed.add((0, $d5b7ee61758b2e81$export$877455b195f03b92)(x)), seed, seed);
}).setLayout({
    name: 'mx_hash_int_0',
    type: 'uint',
    inputs: [
        {
            name: 'x',
            type: 'int'
        }
    ]
});
const $5008de97d433d64a$export$61c65c14f4da1eff = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$b076717d71a1a47f)(([x_immutable, y_immutable])=>{
    const y = (0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)(y_immutable).toVar();
    const x = (0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)(x_immutable).toVar();
    const len = (0, $d5b7ee61758b2e81$export$877455b195f03b92)((0, $d5b7ee61758b2e81$export$877455b195f03b92)(2)).toVar();
    const a = (0, $d5b7ee61758b2e81$export$877455b195f03b92)().toVar(), b = (0, $d5b7ee61758b2e81$export$877455b195f03b92)().toVar(), c = (0, $d5b7ee61758b2e81$export$877455b195f03b92)().toVar();
    a.assign(b.assign(c.assign((0, $d5b7ee61758b2e81$export$877455b195f03b92)((0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)(0xdeadbeef)).add(len.shiftLeft((0, $d5b7ee61758b2e81$export$877455b195f03b92)(2))).add((0, $d5b7ee61758b2e81$export$877455b195f03b92)(13)))));
    a.addAssign((0, $d5b7ee61758b2e81$export$877455b195f03b92)(x));
    b.addAssign((0, $d5b7ee61758b2e81$export$877455b195f03b92)(y));
    return $5008de97d433d64a$export$ec469612ab433c08(a, b, c);
}).setLayout({
    name: 'mx_hash_int_1',
    type: 'uint',
    inputs: [
        {
            name: 'x',
            type: 'int'
        },
        {
            name: 'y',
            type: 'int'
        }
    ]
});
const $5008de97d433d64a$export$fa837c13433b294 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$b076717d71a1a47f)(([x_immutable, y_immutable, z_immutable])=>{
    const z = (0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)(z_immutable).toVar();
    const y = (0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)(y_immutable).toVar();
    const x = (0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)(x_immutable).toVar();
    const len = (0, $d5b7ee61758b2e81$export$877455b195f03b92)((0, $d5b7ee61758b2e81$export$877455b195f03b92)(3)).toVar();
    const a = (0, $d5b7ee61758b2e81$export$877455b195f03b92)().toVar(), b = (0, $d5b7ee61758b2e81$export$877455b195f03b92)().toVar(), c = (0, $d5b7ee61758b2e81$export$877455b195f03b92)().toVar();
    a.assign(b.assign(c.assign((0, $d5b7ee61758b2e81$export$877455b195f03b92)((0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)(0xdeadbeef)).add(len.shiftLeft((0, $d5b7ee61758b2e81$export$877455b195f03b92)(2))).add((0, $d5b7ee61758b2e81$export$877455b195f03b92)(13)))));
    a.addAssign((0, $d5b7ee61758b2e81$export$877455b195f03b92)(x));
    b.addAssign((0, $d5b7ee61758b2e81$export$877455b195f03b92)(y));
    c.addAssign((0, $d5b7ee61758b2e81$export$877455b195f03b92)(z));
    return $5008de97d433d64a$export$ec469612ab433c08(a, b, c);
}).setLayout({
    name: 'mx_hash_int_2',
    type: 'uint',
    inputs: [
        {
            name: 'x',
            type: 'int'
        },
        {
            name: 'y',
            type: 'int'
        },
        {
            name: 'z',
            type: 'int'
        }
    ]
});
const $5008de97d433d64a$export$781a91a3c5188c90 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$b076717d71a1a47f)(([x_immutable, y_immutable, z_immutable, xx_immutable])=>{
    const xx = (0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)(xx_immutable).toVar();
    const z = (0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)(z_immutable).toVar();
    const y = (0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)(y_immutable).toVar();
    const x = (0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)(x_immutable).toVar();
    const len = (0, $d5b7ee61758b2e81$export$877455b195f03b92)((0, $d5b7ee61758b2e81$export$877455b195f03b92)(4)).toVar();
    const a = (0, $d5b7ee61758b2e81$export$877455b195f03b92)().toVar(), b = (0, $d5b7ee61758b2e81$export$877455b195f03b92)().toVar(), c = (0, $d5b7ee61758b2e81$export$877455b195f03b92)().toVar();
    a.assign(b.assign(c.assign((0, $d5b7ee61758b2e81$export$877455b195f03b92)((0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)(0xdeadbeef)).add(len.shiftLeft((0, $d5b7ee61758b2e81$export$877455b195f03b92)(2))).add((0, $d5b7ee61758b2e81$export$877455b195f03b92)(13)))));
    a.addAssign((0, $d5b7ee61758b2e81$export$877455b195f03b92)(x));
    b.addAssign((0, $d5b7ee61758b2e81$export$877455b195f03b92)(y));
    c.addAssign((0, $d5b7ee61758b2e81$export$877455b195f03b92)(z));
    $5008de97d433d64a$export$b37358d1d465116c(a, b, c);
    a.addAssign((0, $d5b7ee61758b2e81$export$877455b195f03b92)(xx));
    return $5008de97d433d64a$export$ec469612ab433c08(a, b, c);
}).setLayout({
    name: 'mx_hash_int_3',
    type: 'uint',
    inputs: [
        {
            name: 'x',
            type: 'int'
        },
        {
            name: 'y',
            type: 'int'
        },
        {
            name: 'z',
            type: 'int'
        },
        {
            name: 'xx',
            type: 'int'
        }
    ]
});
const $5008de97d433d64a$export$b49a38064f130e71 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$b076717d71a1a47f)(([x_immutable, y_immutable, z_immutable, xx_immutable, yy_immutable])=>{
    const yy = (0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)(yy_immutable).toVar();
    const xx = (0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)(xx_immutable).toVar();
    const z = (0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)(z_immutable).toVar();
    const y = (0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)(y_immutable).toVar();
    const x = (0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)(x_immutable).toVar();
    const len = (0, $d5b7ee61758b2e81$export$877455b195f03b92)((0, $d5b7ee61758b2e81$export$877455b195f03b92)(5)).toVar();
    const a = (0, $d5b7ee61758b2e81$export$877455b195f03b92)().toVar(), b = (0, $d5b7ee61758b2e81$export$877455b195f03b92)().toVar(), c = (0, $d5b7ee61758b2e81$export$877455b195f03b92)().toVar();
    a.assign(b.assign(c.assign((0, $d5b7ee61758b2e81$export$877455b195f03b92)((0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)(0xdeadbeef)).add(len.shiftLeft((0, $d5b7ee61758b2e81$export$877455b195f03b92)(2))).add((0, $d5b7ee61758b2e81$export$877455b195f03b92)(13)))));
    a.addAssign((0, $d5b7ee61758b2e81$export$877455b195f03b92)(x));
    b.addAssign((0, $d5b7ee61758b2e81$export$877455b195f03b92)(y));
    c.addAssign((0, $d5b7ee61758b2e81$export$877455b195f03b92)(z));
    $5008de97d433d64a$export$b37358d1d465116c(a, b, c);
    a.addAssign((0, $d5b7ee61758b2e81$export$877455b195f03b92)(xx));
    b.addAssign((0, $d5b7ee61758b2e81$export$877455b195f03b92)(yy));
    return $5008de97d433d64a$export$ec469612ab433c08(a, b, c);
}).setLayout({
    name: 'mx_hash_int_4',
    type: 'uint',
    inputs: [
        {
            name: 'x',
            type: 'int'
        },
        {
            name: 'y',
            type: 'int'
        },
        {
            name: 'z',
            type: 'int'
        },
        {
            name: 'xx',
            type: 'int'
        },
        {
            name: 'yy',
            type: 'int'
        }
    ]
});
const $5008de97d433d64a$export$e3e1bc14345163b2 = /*@__PURE__*/ (0, $228cc208600144f8$export$16973c2f8bfadf46)([
    $5008de97d433d64a$export$b28729497a28c906,
    $5008de97d433d64a$export$61c65c14f4da1eff,
    $5008de97d433d64a$export$fa837c13433b294,
    $5008de97d433d64a$export$781a91a3c5188c90,
    $5008de97d433d64a$export$b49a38064f130e71
]);
const $5008de97d433d64a$export$a3a40b24f3ba9d46 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$b076717d71a1a47f)(([x_immutable, y_immutable])=>{
    const y = (0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)(y_immutable).toVar();
    const x = (0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)(x_immutable).toVar();
    const h = (0, $d5b7ee61758b2e81$export$877455b195f03b92)($5008de97d433d64a$export$e3e1bc14345163b2(x, y)).toVar();
    const result = (0, $d5b7ee61758b2e81$export$bffc171a9468d831)().toVar();
    result.x.assign(h.bitAnd((0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)(0xFF)));
    result.y.assign(h.shiftRight((0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)(8)).bitAnd((0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)(0xFF)));
    result.z.assign(h.shiftRight((0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)(16)).bitAnd((0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)(0xFF)));
    return result;
}).setLayout({
    name: 'mx_hash_vec3_0',
    type: 'uvec3',
    inputs: [
        {
            name: 'x',
            type: 'int'
        },
        {
            name: 'y',
            type: 'int'
        }
    ]
});
const $5008de97d433d64a$export$d1d484640b9ee46f = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$b076717d71a1a47f)(([x_immutable, y_immutable, z_immutable])=>{
    const z = (0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)(z_immutable).toVar();
    const y = (0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)(y_immutable).toVar();
    const x = (0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)(x_immutable).toVar();
    const h = (0, $d5b7ee61758b2e81$export$877455b195f03b92)($5008de97d433d64a$export$e3e1bc14345163b2(x, y, z)).toVar();
    const result = (0, $d5b7ee61758b2e81$export$bffc171a9468d831)().toVar();
    result.x.assign(h.bitAnd((0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)(0xFF)));
    result.y.assign(h.shiftRight((0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)(8)).bitAnd((0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)(0xFF)));
    result.z.assign(h.shiftRight((0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)(16)).bitAnd((0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)(0xFF)));
    return result;
}).setLayout({
    name: 'mx_hash_vec3_1',
    type: 'uvec3',
    inputs: [
        {
            name: 'x',
            type: 'int'
        },
        {
            name: 'y',
            type: 'int'
        },
        {
            name: 'z',
            type: 'int'
        }
    ]
});
const $5008de97d433d64a$export$88774482b8eec1ca = /*@__PURE__*/ (0, $228cc208600144f8$export$16973c2f8bfadf46)([
    $5008de97d433d64a$export$a3a40b24f3ba9d46,
    $5008de97d433d64a$export$d1d484640b9ee46f
]);
const $5008de97d433d64a$export$d57b1f3b48f84f66 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$b076717d71a1a47f)(([p_immutable])=>{
    const p = (0, $d5b7ee61758b2e81$export$e9830bc863290a54)(p_immutable).toVar();
    const X = (0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)().toVar(), Y = (0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)().toVar();
    const fx = (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)($5008de97d433d64a$export$2924b498742ec559(p.x, X)).toVar();
    const fy = (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)($5008de97d433d64a$export$2924b498742ec559(p.y, Y)).toVar();
    const u = (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)($5008de97d433d64a$export$cebcae46bfff0866(fx)).toVar();
    const v = (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)($5008de97d433d64a$export$cebcae46bfff0866(fy)).toVar();
    const result = (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)($5008de97d433d64a$export$d7adc3042282e3fa($5008de97d433d64a$export$a7c336d113e7d56e($5008de97d433d64a$export$e3e1bc14345163b2(X, Y), fx, fy), $5008de97d433d64a$export$a7c336d113e7d56e($5008de97d433d64a$export$e3e1bc14345163b2(X.add((0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)(1)), Y), fx.sub(1.0), fy), $5008de97d433d64a$export$a7c336d113e7d56e($5008de97d433d64a$export$e3e1bc14345163b2(X, Y.add((0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)(1))), fx, fy.sub(1.0)), $5008de97d433d64a$export$a7c336d113e7d56e($5008de97d433d64a$export$e3e1bc14345163b2(X.add((0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)(1)), Y.add((0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)(1))), fx.sub(1.0), fy.sub(1.0)), u, v)).toVar();
    return $5008de97d433d64a$export$9545d7b50b8a37fa(result);
}).setLayout({
    name: 'mx_perlin_noise_float_0',
    type: 'float',
    inputs: [
        {
            name: 'p',
            type: 'vec2'
        }
    ]
});
const $5008de97d433d64a$export$269ace448c874879 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$b076717d71a1a47f)(([p_immutable])=>{
    const p = (0, $d5b7ee61758b2e81$export$9100789c9d999364)(p_immutable).toVar();
    const X = (0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)().toVar(), Y = (0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)().toVar(), Z = (0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)().toVar();
    const fx = (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)($5008de97d433d64a$export$2924b498742ec559(p.x, X)).toVar();
    const fy = (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)($5008de97d433d64a$export$2924b498742ec559(p.y, Y)).toVar();
    const fz = (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)($5008de97d433d64a$export$2924b498742ec559(p.z, Z)).toVar();
    const u = (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)($5008de97d433d64a$export$cebcae46bfff0866(fx)).toVar();
    const v = (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)($5008de97d433d64a$export$cebcae46bfff0866(fy)).toVar();
    const w = (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)($5008de97d433d64a$export$cebcae46bfff0866(fz)).toVar();
    const result = (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)($5008de97d433d64a$export$83e686cd331bbe85($5008de97d433d64a$export$a7c336d113e7d56e($5008de97d433d64a$export$e3e1bc14345163b2(X, Y, Z), fx, fy, fz), $5008de97d433d64a$export$a7c336d113e7d56e($5008de97d433d64a$export$e3e1bc14345163b2(X.add((0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)(1)), Y, Z), fx.sub(1.0), fy, fz), $5008de97d433d64a$export$a7c336d113e7d56e($5008de97d433d64a$export$e3e1bc14345163b2(X, Y.add((0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)(1)), Z), fx, fy.sub(1.0), fz), $5008de97d433d64a$export$a7c336d113e7d56e($5008de97d433d64a$export$e3e1bc14345163b2(X.add((0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)(1)), Y.add((0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)(1)), Z), fx.sub(1.0), fy.sub(1.0), fz), $5008de97d433d64a$export$a7c336d113e7d56e($5008de97d433d64a$export$e3e1bc14345163b2(X, Y, Z.add((0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)(1))), fx, fy, fz.sub(1.0)), $5008de97d433d64a$export$a7c336d113e7d56e($5008de97d433d64a$export$e3e1bc14345163b2(X.add((0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)(1)), Y, Z.add((0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)(1))), fx.sub(1.0), fy, fz.sub(1.0)), $5008de97d433d64a$export$a7c336d113e7d56e($5008de97d433d64a$export$e3e1bc14345163b2(X, Y.add((0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)(1)), Z.add((0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)(1))), fx, fy.sub(1.0), fz.sub(1.0)), $5008de97d433d64a$export$a7c336d113e7d56e($5008de97d433d64a$export$e3e1bc14345163b2(X.add((0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)(1)), Y.add((0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)(1)), Z.add((0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)(1))), fx.sub(1.0), fy.sub(1.0), fz.sub(1.0)), u, v, w)).toVar();
    return $5008de97d433d64a$export$de4bf689fdc55e48(result);
}).setLayout({
    name: 'mx_perlin_noise_float_1',
    type: 'float',
    inputs: [
        {
            name: 'p',
            type: 'vec3'
        }
    ]
});
const $5008de97d433d64a$export$8156a390e7b52cb6 = /*@__PURE__*/ (0, $228cc208600144f8$export$16973c2f8bfadf46)([
    $5008de97d433d64a$export$d57b1f3b48f84f66,
    $5008de97d433d64a$export$269ace448c874879
]);
const $5008de97d433d64a$export$fadace5384c694ed = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$b076717d71a1a47f)(([p_immutable])=>{
    const p = (0, $d5b7ee61758b2e81$export$e9830bc863290a54)(p_immutable).toVar();
    const X = (0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)().toVar(), Y = (0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)().toVar();
    const fx = (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)($5008de97d433d64a$export$2924b498742ec559(p.x, X)).toVar();
    const fy = (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)($5008de97d433d64a$export$2924b498742ec559(p.y, Y)).toVar();
    const u = (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)($5008de97d433d64a$export$cebcae46bfff0866(fx)).toVar();
    const v = (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)($5008de97d433d64a$export$cebcae46bfff0866(fy)).toVar();
    const result = (0, $d5b7ee61758b2e81$export$9100789c9d999364)($5008de97d433d64a$export$d7adc3042282e3fa($5008de97d433d64a$export$5fad2327a2fce05($5008de97d433d64a$export$88774482b8eec1ca(X, Y), fx, fy), $5008de97d433d64a$export$5fad2327a2fce05($5008de97d433d64a$export$88774482b8eec1ca(X.add((0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)(1)), Y), fx.sub(1.0), fy), $5008de97d433d64a$export$5fad2327a2fce05($5008de97d433d64a$export$88774482b8eec1ca(X, Y.add((0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)(1))), fx, fy.sub(1.0)), $5008de97d433d64a$export$5fad2327a2fce05($5008de97d433d64a$export$88774482b8eec1ca(X.add((0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)(1)), Y.add((0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)(1))), fx.sub(1.0), fy.sub(1.0)), u, v)).toVar();
    return $5008de97d433d64a$export$9545d7b50b8a37fa(result);
}).setLayout({
    name: 'mx_perlin_noise_vec3_0',
    type: 'vec3',
    inputs: [
        {
            name: 'p',
            type: 'vec2'
        }
    ]
});
const $5008de97d433d64a$export$f4bdc5806f61cb42 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$b076717d71a1a47f)(([p_immutable])=>{
    const p = (0, $d5b7ee61758b2e81$export$9100789c9d999364)(p_immutable).toVar();
    const X = (0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)().toVar(), Y = (0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)().toVar(), Z = (0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)().toVar();
    const fx = (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)($5008de97d433d64a$export$2924b498742ec559(p.x, X)).toVar();
    const fy = (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)($5008de97d433d64a$export$2924b498742ec559(p.y, Y)).toVar();
    const fz = (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)($5008de97d433d64a$export$2924b498742ec559(p.z, Z)).toVar();
    const u = (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)($5008de97d433d64a$export$cebcae46bfff0866(fx)).toVar();
    const v = (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)($5008de97d433d64a$export$cebcae46bfff0866(fy)).toVar();
    const w = (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)($5008de97d433d64a$export$cebcae46bfff0866(fz)).toVar();
    const result = (0, $d5b7ee61758b2e81$export$9100789c9d999364)($5008de97d433d64a$export$83e686cd331bbe85($5008de97d433d64a$export$5fad2327a2fce05($5008de97d433d64a$export$88774482b8eec1ca(X, Y, Z), fx, fy, fz), $5008de97d433d64a$export$5fad2327a2fce05($5008de97d433d64a$export$88774482b8eec1ca(X.add((0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)(1)), Y, Z), fx.sub(1.0), fy, fz), $5008de97d433d64a$export$5fad2327a2fce05($5008de97d433d64a$export$88774482b8eec1ca(X, Y.add((0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)(1)), Z), fx, fy.sub(1.0), fz), $5008de97d433d64a$export$5fad2327a2fce05($5008de97d433d64a$export$88774482b8eec1ca(X.add((0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)(1)), Y.add((0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)(1)), Z), fx.sub(1.0), fy.sub(1.0), fz), $5008de97d433d64a$export$5fad2327a2fce05($5008de97d433d64a$export$88774482b8eec1ca(X, Y, Z.add((0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)(1))), fx, fy, fz.sub(1.0)), $5008de97d433d64a$export$5fad2327a2fce05($5008de97d433d64a$export$88774482b8eec1ca(X.add((0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)(1)), Y, Z.add((0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)(1))), fx.sub(1.0), fy, fz.sub(1.0)), $5008de97d433d64a$export$5fad2327a2fce05($5008de97d433d64a$export$88774482b8eec1ca(X, Y.add((0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)(1)), Z.add((0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)(1))), fx, fy.sub(1.0), fz.sub(1.0)), $5008de97d433d64a$export$5fad2327a2fce05($5008de97d433d64a$export$88774482b8eec1ca(X.add((0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)(1)), Y.add((0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)(1)), Z.add((0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)(1))), fx.sub(1.0), fy.sub(1.0), fz.sub(1.0)), u, v, w)).toVar();
    return $5008de97d433d64a$export$de4bf689fdc55e48(result);
}).setLayout({
    name: 'mx_perlin_noise_vec3_1',
    type: 'vec3',
    inputs: [
        {
            name: 'p',
            type: 'vec3'
        }
    ]
});
const $5008de97d433d64a$export$48933da469822a3e = /*@__PURE__*/ (0, $228cc208600144f8$export$16973c2f8bfadf46)([
    $5008de97d433d64a$export$fadace5384c694ed,
    $5008de97d433d64a$export$f4bdc5806f61cb42
]);
const $5008de97d433d64a$export$7f3f47bd8e740aaa = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$b076717d71a1a47f)(([p_immutable])=>{
    const p = (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(p_immutable).toVar();
    const ix = (0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)($5008de97d433d64a$export$c4655eced0ba6aa5(p)).toVar();
    return $5008de97d433d64a$export$3af44866218d463($5008de97d433d64a$export$e3e1bc14345163b2(ix));
}).setLayout({
    name: 'mx_cell_noise_float_0',
    type: 'float',
    inputs: [
        {
            name: 'p',
            type: 'float'
        }
    ]
});
const $5008de97d433d64a$export$f5523ed1daaa6d7 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$b076717d71a1a47f)(([p_immutable])=>{
    const p = (0, $d5b7ee61758b2e81$export$e9830bc863290a54)(p_immutable).toVar();
    const ix = (0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)($5008de97d433d64a$export$c4655eced0ba6aa5(p.x)).toVar();
    const iy = (0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)($5008de97d433d64a$export$c4655eced0ba6aa5(p.y)).toVar();
    return $5008de97d433d64a$export$3af44866218d463($5008de97d433d64a$export$e3e1bc14345163b2(ix, iy));
}).setLayout({
    name: 'mx_cell_noise_float_1',
    type: 'float',
    inputs: [
        {
            name: 'p',
            type: 'vec2'
        }
    ]
});
const $5008de97d433d64a$export$3cb2539a2164f5ed = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$b076717d71a1a47f)(([p_immutable])=>{
    const p = (0, $d5b7ee61758b2e81$export$9100789c9d999364)(p_immutable).toVar();
    const ix = (0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)($5008de97d433d64a$export$c4655eced0ba6aa5(p.x)).toVar();
    const iy = (0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)($5008de97d433d64a$export$c4655eced0ba6aa5(p.y)).toVar();
    const iz = (0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)($5008de97d433d64a$export$c4655eced0ba6aa5(p.z)).toVar();
    return $5008de97d433d64a$export$3af44866218d463($5008de97d433d64a$export$e3e1bc14345163b2(ix, iy, iz));
}).setLayout({
    name: 'mx_cell_noise_float_2',
    type: 'float',
    inputs: [
        {
            name: 'p',
            type: 'vec3'
        }
    ]
});
const $5008de97d433d64a$export$34a25b0ad6dee2bc = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$b076717d71a1a47f)(([p_immutable])=>{
    const p = (0, $d5b7ee61758b2e81$export$6dba2a1f0d609415)(p_immutable).toVar();
    const ix = (0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)($5008de97d433d64a$export$c4655eced0ba6aa5(p.x)).toVar();
    const iy = (0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)($5008de97d433d64a$export$c4655eced0ba6aa5(p.y)).toVar();
    const iz = (0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)($5008de97d433d64a$export$c4655eced0ba6aa5(p.z)).toVar();
    const iw = (0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)($5008de97d433d64a$export$c4655eced0ba6aa5(p.w)).toVar();
    return $5008de97d433d64a$export$3af44866218d463($5008de97d433d64a$export$e3e1bc14345163b2(ix, iy, iz, iw));
}).setLayout({
    name: 'mx_cell_noise_float_3',
    type: 'float',
    inputs: [
        {
            name: 'p',
            type: 'vec4'
        }
    ]
});
const $5008de97d433d64a$export$5eaa094b2411a56b = /*@__PURE__*/ (0, $228cc208600144f8$export$16973c2f8bfadf46)([
    $5008de97d433d64a$export$7f3f47bd8e740aaa,
    $5008de97d433d64a$export$f5523ed1daaa6d7,
    $5008de97d433d64a$export$3cb2539a2164f5ed,
    $5008de97d433d64a$export$34a25b0ad6dee2bc
]);
const $5008de97d433d64a$export$e9a15bf0278e72dc = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$b076717d71a1a47f)(([p_immutable])=>{
    const p = (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(p_immutable).toVar();
    const ix = (0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)($5008de97d433d64a$export$c4655eced0ba6aa5(p)).toVar();
    return (0, $d5b7ee61758b2e81$export$9100789c9d999364)($5008de97d433d64a$export$3af44866218d463($5008de97d433d64a$export$e3e1bc14345163b2(ix, (0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)(0))), $5008de97d433d64a$export$3af44866218d463($5008de97d433d64a$export$e3e1bc14345163b2(ix, (0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)(1))), $5008de97d433d64a$export$3af44866218d463($5008de97d433d64a$export$e3e1bc14345163b2(ix, (0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)(2))));
}).setLayout({
    name: 'mx_cell_noise_vec3_0',
    type: 'vec3',
    inputs: [
        {
            name: 'p',
            type: 'float'
        }
    ]
});
const $5008de97d433d64a$export$9c767efabd1042a7 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$b076717d71a1a47f)(([p_immutable])=>{
    const p = (0, $d5b7ee61758b2e81$export$e9830bc863290a54)(p_immutable).toVar();
    const ix = (0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)($5008de97d433d64a$export$c4655eced0ba6aa5(p.x)).toVar();
    const iy = (0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)($5008de97d433d64a$export$c4655eced0ba6aa5(p.y)).toVar();
    return (0, $d5b7ee61758b2e81$export$9100789c9d999364)($5008de97d433d64a$export$3af44866218d463($5008de97d433d64a$export$e3e1bc14345163b2(ix, iy, (0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)(0))), $5008de97d433d64a$export$3af44866218d463($5008de97d433d64a$export$e3e1bc14345163b2(ix, iy, (0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)(1))), $5008de97d433d64a$export$3af44866218d463($5008de97d433d64a$export$e3e1bc14345163b2(ix, iy, (0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)(2))));
}).setLayout({
    name: 'mx_cell_noise_vec3_1',
    type: 'vec3',
    inputs: [
        {
            name: 'p',
            type: 'vec2'
        }
    ]
});
const $5008de97d433d64a$export$86373e7c31e4ac7a = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$b076717d71a1a47f)(([p_immutable])=>{
    const p = (0, $d5b7ee61758b2e81$export$9100789c9d999364)(p_immutable).toVar();
    const ix = (0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)($5008de97d433d64a$export$c4655eced0ba6aa5(p.x)).toVar();
    const iy = (0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)($5008de97d433d64a$export$c4655eced0ba6aa5(p.y)).toVar();
    const iz = (0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)($5008de97d433d64a$export$c4655eced0ba6aa5(p.z)).toVar();
    return (0, $d5b7ee61758b2e81$export$9100789c9d999364)($5008de97d433d64a$export$3af44866218d463($5008de97d433d64a$export$e3e1bc14345163b2(ix, iy, iz, (0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)(0))), $5008de97d433d64a$export$3af44866218d463($5008de97d433d64a$export$e3e1bc14345163b2(ix, iy, iz, (0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)(1))), $5008de97d433d64a$export$3af44866218d463($5008de97d433d64a$export$e3e1bc14345163b2(ix, iy, iz, (0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)(2))));
}).setLayout({
    name: 'mx_cell_noise_vec3_2',
    type: 'vec3',
    inputs: [
        {
            name: 'p',
            type: 'vec3'
        }
    ]
});
const $5008de97d433d64a$export$786139cf46cd6d57 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$b076717d71a1a47f)(([p_immutable])=>{
    const p = (0, $d5b7ee61758b2e81$export$6dba2a1f0d609415)(p_immutable).toVar();
    const ix = (0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)($5008de97d433d64a$export$c4655eced0ba6aa5(p.x)).toVar();
    const iy = (0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)($5008de97d433d64a$export$c4655eced0ba6aa5(p.y)).toVar();
    const iz = (0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)($5008de97d433d64a$export$c4655eced0ba6aa5(p.z)).toVar();
    const iw = (0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)($5008de97d433d64a$export$c4655eced0ba6aa5(p.w)).toVar();
    return (0, $d5b7ee61758b2e81$export$9100789c9d999364)($5008de97d433d64a$export$3af44866218d463($5008de97d433d64a$export$e3e1bc14345163b2(ix, iy, iz, iw, (0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)(0))), $5008de97d433d64a$export$3af44866218d463($5008de97d433d64a$export$e3e1bc14345163b2(ix, iy, iz, iw, (0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)(1))), $5008de97d433d64a$export$3af44866218d463($5008de97d433d64a$export$e3e1bc14345163b2(ix, iy, iz, iw, (0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)(2))));
}).setLayout({
    name: 'mx_cell_noise_vec3_3',
    type: 'vec3',
    inputs: [
        {
            name: 'p',
            type: 'vec4'
        }
    ]
});
const $5008de97d433d64a$export$f001280a89d27de0 = /*@__PURE__*/ (0, $228cc208600144f8$export$16973c2f8bfadf46)([
    $5008de97d433d64a$export$e9a15bf0278e72dc,
    $5008de97d433d64a$export$9c767efabd1042a7,
    $5008de97d433d64a$export$86373e7c31e4ac7a,
    $5008de97d433d64a$export$786139cf46cd6d57
]);
const $5008de97d433d64a$export$2a6701b70ee390ec = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$b076717d71a1a47f)(([p_immutable, octaves_immutable, lacunarity_immutable, diminish_immutable])=>{
    const diminish = (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(diminish_immutable).toVar();
    const lacunarity = (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(lacunarity_immutable).toVar();
    const octaves = (0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)(octaves_immutable).toVar();
    const p = (0, $d5b7ee61758b2e81$export$9100789c9d999364)(p_immutable).toVar();
    const result = (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(0.0).toVar();
    const amplitude = (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(1.0).toVar();
    (0, $2a1578e0d4d8bf63$export$550acbd06a1f5a6a)(octaves, ()=>{
        result.addAssign(amplitude.mul($5008de97d433d64a$export$8156a390e7b52cb6(p)));
        amplitude.mulAssign(diminish);
        p.mulAssign(lacunarity);
    });
    return result;
}).setLayout({
    name: 'mx_fractal_noise_float',
    type: 'float',
    inputs: [
        {
            name: 'p',
            type: 'vec3'
        },
        {
            name: 'octaves',
            type: 'int'
        },
        {
            name: 'lacunarity',
            type: 'float'
        },
        {
            name: 'diminish',
            type: 'float'
        }
    ]
});
const $5008de97d433d64a$export$12ba67f6f21a3945 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$b076717d71a1a47f)(([p_immutable, octaves_immutable, lacunarity_immutable, diminish_immutable])=>{
    const diminish = (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(diminish_immutable).toVar();
    const lacunarity = (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(lacunarity_immutable).toVar();
    const octaves = (0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)(octaves_immutable).toVar();
    const p = (0, $d5b7ee61758b2e81$export$9100789c9d999364)(p_immutable).toVar();
    const result = (0, $d5b7ee61758b2e81$export$9100789c9d999364)(0.0).toVar();
    const amplitude = (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(1.0).toVar();
    (0, $2a1578e0d4d8bf63$export$550acbd06a1f5a6a)(octaves, ()=>{
        result.addAssign(amplitude.mul($5008de97d433d64a$export$48933da469822a3e(p)));
        amplitude.mulAssign(diminish);
        p.mulAssign(lacunarity);
    });
    return result;
}).setLayout({
    name: 'mx_fractal_noise_vec3',
    type: 'vec3',
    inputs: [
        {
            name: 'p',
            type: 'vec3'
        },
        {
            name: 'octaves',
            type: 'int'
        },
        {
            name: 'lacunarity',
            type: 'float'
        },
        {
            name: 'diminish',
            type: 'float'
        }
    ]
});
const $5008de97d433d64a$export$dfda353404f4bfd0 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$b076717d71a1a47f)(([p_immutable, octaves_immutable, lacunarity_immutable, diminish_immutable])=>{
    const diminish = (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(diminish_immutable).toVar();
    const lacunarity = (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(lacunarity_immutable).toVar();
    const octaves = (0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)(octaves_immutable).toVar();
    const p = (0, $d5b7ee61758b2e81$export$9100789c9d999364)(p_immutable).toVar();
    return (0, $d5b7ee61758b2e81$export$e9830bc863290a54)($5008de97d433d64a$export$2a6701b70ee390ec(p, octaves, lacunarity, diminish), $5008de97d433d64a$export$2a6701b70ee390ec(p.add((0, $d5b7ee61758b2e81$export$9100789c9d999364)((0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)(19), (0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)(193), (0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)(17))), octaves, lacunarity, diminish));
}).setLayout({
    name: 'mx_fractal_noise_vec2',
    type: 'vec2',
    inputs: [
        {
            name: 'p',
            type: 'vec3'
        },
        {
            name: 'octaves',
            type: 'int'
        },
        {
            name: 'lacunarity',
            type: 'float'
        },
        {
            name: 'diminish',
            type: 'float'
        }
    ]
});
const $5008de97d433d64a$export$970ebd521f5a5812 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$b076717d71a1a47f)(([p_immutable, octaves_immutable, lacunarity_immutable, diminish_immutable])=>{
    const diminish = (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(diminish_immutable).toVar();
    const lacunarity = (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(lacunarity_immutable).toVar();
    const octaves = (0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)(octaves_immutable).toVar();
    const p = (0, $d5b7ee61758b2e81$export$9100789c9d999364)(p_immutable).toVar();
    const c = (0, $d5b7ee61758b2e81$export$9100789c9d999364)($5008de97d433d64a$export$12ba67f6f21a3945(p, octaves, lacunarity, diminish)).toVar();
    const f = (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)($5008de97d433d64a$export$2a6701b70ee390ec(p.add((0, $d5b7ee61758b2e81$export$9100789c9d999364)((0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)(19), (0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)(193), (0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)(17))), octaves, lacunarity, diminish)).toVar();
    return (0, $d5b7ee61758b2e81$export$6dba2a1f0d609415)(c, f);
}).setLayout({
    name: 'mx_fractal_noise_vec4',
    type: 'vec4',
    inputs: [
        {
            name: 'p',
            type: 'vec3'
        },
        {
            name: 'octaves',
            type: 'int'
        },
        {
            name: 'lacunarity',
            type: 'float'
        },
        {
            name: 'diminish',
            type: 'float'
        }
    ]
});
const $5008de97d433d64a$export$e601c0bdbce946b = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$b076717d71a1a47f)(([p_immutable, x_immutable, y_immutable, xoff_immutable, yoff_immutable, jitter_immutable, metric_immutable])=>{
    const metric = (0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)(metric_immutable).toVar();
    const jitter = (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(jitter_immutable).toVar();
    const yoff = (0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)(yoff_immutable).toVar();
    const xoff = (0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)(xoff_immutable).toVar();
    const y = (0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)(y_immutable).toVar();
    const x = (0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)(x_immutable).toVar();
    const p = (0, $d5b7ee61758b2e81$export$e9830bc863290a54)(p_immutable).toVar();
    const tmp = (0, $d5b7ee61758b2e81$export$9100789c9d999364)($5008de97d433d64a$export$f001280a89d27de0((0, $d5b7ee61758b2e81$export$e9830bc863290a54)(x.add(xoff), y.add(yoff)))).toVar();
    const off = (0, $d5b7ee61758b2e81$export$e9830bc863290a54)(tmp.x, tmp.y).toVar();
    off.subAssign(0.5);
    off.mulAssign(jitter);
    off.addAssign(0.5);
    const cellpos = (0, $d5b7ee61758b2e81$export$e9830bc863290a54)((0, $d5b7ee61758b2e81$export$e9830bc863290a54)((0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(x), (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(y)).add(off)).toVar();
    const diff = (0, $d5b7ee61758b2e81$export$e9830bc863290a54)(cellpos.sub(p)).toVar();
    (0, $d5b7ee61758b2e81$export$1f9ff5f4a6c9361a)(metric.equal((0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)(2)), ()=>{
        return (0, $f37ae0e58866c183$export$2335f513bbd82c6d)(diff.x).add((0, $f37ae0e58866c183$export$2335f513bbd82c6d)(diff.y));
    });
    (0, $d5b7ee61758b2e81$export$1f9ff5f4a6c9361a)(metric.equal((0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)(3)), ()=>{
        return (0, $f37ae0e58866c183$export$8960430cfd85939f)((0, $f37ae0e58866c183$export$2335f513bbd82c6d)(diff.x), (0, $f37ae0e58866c183$export$2335f513bbd82c6d)(diff.y));
    });
    return (0, $f37ae0e58866c183$export$94132a0e348806d4)(diff, diff);
}).setLayout({
    name: 'mx_worley_distance_0',
    type: 'float',
    inputs: [
        {
            name: 'p',
            type: 'vec2'
        },
        {
            name: 'x',
            type: 'int'
        },
        {
            name: 'y',
            type: 'int'
        },
        {
            name: 'xoff',
            type: 'int'
        },
        {
            name: 'yoff',
            type: 'int'
        },
        {
            name: 'jitter',
            type: 'float'
        },
        {
            name: 'metric',
            type: 'int'
        }
    ]
});
const $5008de97d433d64a$export$d8cc6bd6a210634a = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$b076717d71a1a47f)(([p_immutable, x_immutable, y_immutable, z_immutable, xoff_immutable, yoff_immutable, zoff_immutable, jitter_immutable, metric_immutable])=>{
    const metric = (0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)(metric_immutable).toVar();
    const jitter = (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(jitter_immutable).toVar();
    const zoff = (0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)(zoff_immutable).toVar();
    const yoff = (0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)(yoff_immutable).toVar();
    const xoff = (0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)(xoff_immutable).toVar();
    const z = (0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)(z_immutable).toVar();
    const y = (0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)(y_immutable).toVar();
    const x = (0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)(x_immutable).toVar();
    const p = (0, $d5b7ee61758b2e81$export$9100789c9d999364)(p_immutable).toVar();
    const off = (0, $d5b7ee61758b2e81$export$9100789c9d999364)($5008de97d433d64a$export$f001280a89d27de0((0, $d5b7ee61758b2e81$export$9100789c9d999364)(x.add(xoff), y.add(yoff), z.add(zoff)))).toVar();
    off.subAssign(0.5);
    off.mulAssign(jitter);
    off.addAssign(0.5);
    const cellpos = (0, $d5b7ee61758b2e81$export$9100789c9d999364)((0, $d5b7ee61758b2e81$export$9100789c9d999364)((0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(x), (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(y), (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(z)).add(off)).toVar();
    const diff = (0, $d5b7ee61758b2e81$export$9100789c9d999364)(cellpos.sub(p)).toVar();
    (0, $d5b7ee61758b2e81$export$1f9ff5f4a6c9361a)(metric.equal((0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)(2)), ()=>{
        return (0, $f37ae0e58866c183$export$2335f513bbd82c6d)(diff.x).add((0, $f37ae0e58866c183$export$2335f513bbd82c6d)(diff.y)).add((0, $f37ae0e58866c183$export$2335f513bbd82c6d)(diff.z));
    });
    (0, $d5b7ee61758b2e81$export$1f9ff5f4a6c9361a)(metric.equal((0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)(3)), ()=>{
        return (0, $f37ae0e58866c183$export$8960430cfd85939f)((0, $f37ae0e58866c183$export$8960430cfd85939f)((0, $f37ae0e58866c183$export$2335f513bbd82c6d)(diff.x), (0, $f37ae0e58866c183$export$2335f513bbd82c6d)(diff.y)), (0, $f37ae0e58866c183$export$2335f513bbd82c6d)(diff.z));
    });
    return (0, $f37ae0e58866c183$export$94132a0e348806d4)(diff, diff);
}).setLayout({
    name: 'mx_worley_distance_1',
    type: 'float',
    inputs: [
        {
            name: 'p',
            type: 'vec3'
        },
        {
            name: 'x',
            type: 'int'
        },
        {
            name: 'y',
            type: 'int'
        },
        {
            name: 'z',
            type: 'int'
        },
        {
            name: 'xoff',
            type: 'int'
        },
        {
            name: 'yoff',
            type: 'int'
        },
        {
            name: 'zoff',
            type: 'int'
        },
        {
            name: 'jitter',
            type: 'float'
        },
        {
            name: 'metric',
            type: 'int'
        }
    ]
});
const $5008de97d433d64a$export$6ac922b7b83e46f7 = /*@__PURE__*/ (0, $228cc208600144f8$export$16973c2f8bfadf46)([
    $5008de97d433d64a$export$e601c0bdbce946b,
    $5008de97d433d64a$export$d8cc6bd6a210634a
]);
const $5008de97d433d64a$export$b8616d1a801842a3 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$b076717d71a1a47f)(([p_immutable, jitter_immutable, metric_immutable])=>{
    const metric = (0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)(metric_immutable).toVar();
    const jitter = (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(jitter_immutable).toVar();
    const p = (0, $d5b7ee61758b2e81$export$e9830bc863290a54)(p_immutable).toVar();
    const X = (0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)().toVar(), Y = (0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)().toVar();
    const localpos = (0, $d5b7ee61758b2e81$export$e9830bc863290a54)($5008de97d433d64a$export$2924b498742ec559(p.x, X), $5008de97d433d64a$export$2924b498742ec559(p.y, Y)).toVar();
    const sqdist = (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(1e6).toVar();
    (0, $2a1578e0d4d8bf63$export$550acbd06a1f5a6a)({
        start: -1,
        end: (0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)(1),
        name: 'x',
        condition: '<='
    }, ({ x: x })=>{
        (0, $2a1578e0d4d8bf63$export$550acbd06a1f5a6a)({
            start: -1,
            end: (0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)(1),
            name: 'y',
            condition: '<='
        }, ({ y: y })=>{
            const dist = (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)($5008de97d433d64a$export$6ac922b7b83e46f7(localpos, x, y, X, Y, jitter, metric)).toVar();
            sqdist.assign((0, $f37ae0e58866c183$export$96ec731ed4dcb222)(sqdist, dist));
        });
    });
    (0, $d5b7ee61758b2e81$export$1f9ff5f4a6c9361a)(metric.equal((0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)(0)), ()=>{
        sqdist.assign((0, $f37ae0e58866c183$export$eba8049fb5020b81)(sqdist));
    });
    return sqdist;
}).setLayout({
    name: 'mx_worley_noise_float_0',
    type: 'float',
    inputs: [
        {
            name: 'p',
            type: 'vec2'
        },
        {
            name: 'jitter',
            type: 'float'
        },
        {
            name: 'metric',
            type: 'int'
        }
    ]
});
const $5008de97d433d64a$export$f23f191e0f46eef3 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$b076717d71a1a47f)(([p_immutable, jitter_immutable, metric_immutable])=>{
    const metric = (0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)(metric_immutable).toVar();
    const jitter = (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(jitter_immutable).toVar();
    const p = (0, $d5b7ee61758b2e81$export$e9830bc863290a54)(p_immutable).toVar();
    const X = (0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)().toVar(), Y = (0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)().toVar();
    const localpos = (0, $d5b7ee61758b2e81$export$e9830bc863290a54)($5008de97d433d64a$export$2924b498742ec559(p.x, X), $5008de97d433d64a$export$2924b498742ec559(p.y, Y)).toVar();
    const sqdist = (0, $d5b7ee61758b2e81$export$e9830bc863290a54)(1e6, 1e6).toVar();
    (0, $2a1578e0d4d8bf63$export$550acbd06a1f5a6a)({
        start: -1,
        end: (0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)(1),
        name: 'x',
        condition: '<='
    }, ({ x: x })=>{
        (0, $2a1578e0d4d8bf63$export$550acbd06a1f5a6a)({
            start: -1,
            end: (0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)(1),
            name: 'y',
            condition: '<='
        }, ({ y: y })=>{
            const dist = (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)($5008de97d433d64a$export$6ac922b7b83e46f7(localpos, x, y, X, Y, jitter, metric)).toVar();
            (0, $d5b7ee61758b2e81$export$1f9ff5f4a6c9361a)(dist.lessThan(sqdist.x), ()=>{
                sqdist.y.assign(sqdist.x);
                sqdist.x.assign(dist);
            }).ElseIf(dist.lessThan(sqdist.y), ()=>{
                sqdist.y.assign(dist);
            });
        });
    });
    (0, $d5b7ee61758b2e81$export$1f9ff5f4a6c9361a)(metric.equal((0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)(0)), ()=>{
        sqdist.assign((0, $f37ae0e58866c183$export$eba8049fb5020b81)(sqdist));
    });
    return sqdist;
}).setLayout({
    name: 'mx_worley_noise_vec2_0',
    type: 'vec2',
    inputs: [
        {
            name: 'p',
            type: 'vec2'
        },
        {
            name: 'jitter',
            type: 'float'
        },
        {
            name: 'metric',
            type: 'int'
        }
    ]
});
const $5008de97d433d64a$export$6de9d2a7fe815d34 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$b076717d71a1a47f)(([p_immutable, jitter_immutable, metric_immutable])=>{
    const metric = (0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)(metric_immutable).toVar();
    const jitter = (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(jitter_immutable).toVar();
    const p = (0, $d5b7ee61758b2e81$export$e9830bc863290a54)(p_immutable).toVar();
    const X = (0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)().toVar(), Y = (0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)().toVar();
    const localpos = (0, $d5b7ee61758b2e81$export$e9830bc863290a54)($5008de97d433d64a$export$2924b498742ec559(p.x, X), $5008de97d433d64a$export$2924b498742ec559(p.y, Y)).toVar();
    const sqdist = (0, $d5b7ee61758b2e81$export$9100789c9d999364)(1e6, 1e6, 1e6).toVar();
    (0, $2a1578e0d4d8bf63$export$550acbd06a1f5a6a)({
        start: -1,
        end: (0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)(1),
        name: 'x',
        condition: '<='
    }, ({ x: x })=>{
        (0, $2a1578e0d4d8bf63$export$550acbd06a1f5a6a)({
            start: -1,
            end: (0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)(1),
            name: 'y',
            condition: '<='
        }, ({ y: y })=>{
            const dist = (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)($5008de97d433d64a$export$6ac922b7b83e46f7(localpos, x, y, X, Y, jitter, metric)).toVar();
            (0, $d5b7ee61758b2e81$export$1f9ff5f4a6c9361a)(dist.lessThan(sqdist.x), ()=>{
                sqdist.z.assign(sqdist.y);
                sqdist.y.assign(sqdist.x);
                sqdist.x.assign(dist);
            }).ElseIf(dist.lessThan(sqdist.y), ()=>{
                sqdist.z.assign(sqdist.y);
                sqdist.y.assign(dist);
            }).ElseIf(dist.lessThan(sqdist.z), ()=>{
                sqdist.z.assign(dist);
            });
        });
    });
    (0, $d5b7ee61758b2e81$export$1f9ff5f4a6c9361a)(metric.equal((0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)(0)), ()=>{
        sqdist.assign((0, $f37ae0e58866c183$export$eba8049fb5020b81)(sqdist));
    });
    return sqdist;
}).setLayout({
    name: 'mx_worley_noise_vec3_0',
    type: 'vec3',
    inputs: [
        {
            name: 'p',
            type: 'vec2'
        },
        {
            name: 'jitter',
            type: 'float'
        },
        {
            name: 'metric',
            type: 'int'
        }
    ]
});
const $5008de97d433d64a$export$d482729f70b35bee = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$b076717d71a1a47f)(([p_immutable, jitter_immutable, metric_immutable])=>{
    const metric = (0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)(metric_immutable).toVar();
    const jitter = (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(jitter_immutable).toVar();
    const p = (0, $d5b7ee61758b2e81$export$9100789c9d999364)(p_immutable).toVar();
    const X = (0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)().toVar(), Y = (0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)().toVar(), Z = (0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)().toVar();
    const localpos = (0, $d5b7ee61758b2e81$export$9100789c9d999364)($5008de97d433d64a$export$2924b498742ec559(p.x, X), $5008de97d433d64a$export$2924b498742ec559(p.y, Y), $5008de97d433d64a$export$2924b498742ec559(p.z, Z)).toVar();
    const sqdist = (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(1e6).toVar();
    (0, $2a1578e0d4d8bf63$export$550acbd06a1f5a6a)({
        start: -1,
        end: (0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)(1),
        name: 'x',
        condition: '<='
    }, ({ x: x })=>{
        (0, $2a1578e0d4d8bf63$export$550acbd06a1f5a6a)({
            start: -1,
            end: (0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)(1),
            name: 'y',
            condition: '<='
        }, ({ y: y })=>{
            (0, $2a1578e0d4d8bf63$export$550acbd06a1f5a6a)({
                start: -1,
                end: (0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)(1),
                name: 'z',
                condition: '<='
            }, ({ z: z })=>{
                const dist = (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)($5008de97d433d64a$export$6ac922b7b83e46f7(localpos, x, y, z, X, Y, Z, jitter, metric)).toVar();
                sqdist.assign((0, $f37ae0e58866c183$export$96ec731ed4dcb222)(sqdist, dist));
            });
        });
    });
    (0, $d5b7ee61758b2e81$export$1f9ff5f4a6c9361a)(metric.equal((0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)(0)), ()=>{
        sqdist.assign((0, $f37ae0e58866c183$export$eba8049fb5020b81)(sqdist));
    });
    return sqdist;
}).setLayout({
    name: 'mx_worley_noise_float_1',
    type: 'float',
    inputs: [
        {
            name: 'p',
            type: 'vec3'
        },
        {
            name: 'jitter',
            type: 'float'
        },
        {
            name: 'metric',
            type: 'int'
        }
    ]
});
const $5008de97d433d64a$export$ee237dfb83b6bbea = /*@__PURE__*/ (0, $228cc208600144f8$export$16973c2f8bfadf46)([
    $5008de97d433d64a$export$b8616d1a801842a3,
    $5008de97d433d64a$export$d482729f70b35bee
]);
const $5008de97d433d64a$export$957705b4df05fe40 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$b076717d71a1a47f)(([p_immutable, jitter_immutable, metric_immutable])=>{
    const metric = (0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)(metric_immutable).toVar();
    const jitter = (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(jitter_immutable).toVar();
    const p = (0, $d5b7ee61758b2e81$export$9100789c9d999364)(p_immutable).toVar();
    const X = (0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)().toVar(), Y = (0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)().toVar(), Z = (0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)().toVar();
    const localpos = (0, $d5b7ee61758b2e81$export$9100789c9d999364)($5008de97d433d64a$export$2924b498742ec559(p.x, X), $5008de97d433d64a$export$2924b498742ec559(p.y, Y), $5008de97d433d64a$export$2924b498742ec559(p.z, Z)).toVar();
    const sqdist = (0, $d5b7ee61758b2e81$export$e9830bc863290a54)(1e6, 1e6).toVar();
    (0, $2a1578e0d4d8bf63$export$550acbd06a1f5a6a)({
        start: -1,
        end: (0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)(1),
        name: 'x',
        condition: '<='
    }, ({ x: x })=>{
        (0, $2a1578e0d4d8bf63$export$550acbd06a1f5a6a)({
            start: -1,
            end: (0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)(1),
            name: 'y',
            condition: '<='
        }, ({ y: y })=>{
            (0, $2a1578e0d4d8bf63$export$550acbd06a1f5a6a)({
                start: -1,
                end: (0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)(1),
                name: 'z',
                condition: '<='
            }, ({ z: z })=>{
                const dist = (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)($5008de97d433d64a$export$6ac922b7b83e46f7(localpos, x, y, z, X, Y, Z, jitter, metric)).toVar();
                (0, $d5b7ee61758b2e81$export$1f9ff5f4a6c9361a)(dist.lessThan(sqdist.x), ()=>{
                    sqdist.y.assign(sqdist.x);
                    sqdist.x.assign(dist);
                }).ElseIf(dist.lessThan(sqdist.y), ()=>{
                    sqdist.y.assign(dist);
                });
            });
        });
    });
    (0, $d5b7ee61758b2e81$export$1f9ff5f4a6c9361a)(metric.equal((0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)(0)), ()=>{
        sqdist.assign((0, $f37ae0e58866c183$export$eba8049fb5020b81)(sqdist));
    });
    return sqdist;
}).setLayout({
    name: 'mx_worley_noise_vec2_1',
    type: 'vec2',
    inputs: [
        {
            name: 'p',
            type: 'vec3'
        },
        {
            name: 'jitter',
            type: 'float'
        },
        {
            name: 'metric',
            type: 'int'
        }
    ]
});
const $5008de97d433d64a$export$f83e54c8c80af323 = /*@__PURE__*/ (0, $228cc208600144f8$export$16973c2f8bfadf46)([
    $5008de97d433d64a$export$f23f191e0f46eef3,
    $5008de97d433d64a$export$957705b4df05fe40
]);
const $5008de97d433d64a$export$7a05953f29b1763a = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$b076717d71a1a47f)(([p_immutable, jitter_immutable, metric_immutable])=>{
    const metric = (0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)(metric_immutable).toVar();
    const jitter = (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(jitter_immutable).toVar();
    const p = (0, $d5b7ee61758b2e81$export$9100789c9d999364)(p_immutable).toVar();
    const X = (0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)().toVar(), Y = (0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)().toVar(), Z = (0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)().toVar();
    const localpos = (0, $d5b7ee61758b2e81$export$9100789c9d999364)($5008de97d433d64a$export$2924b498742ec559(p.x, X), $5008de97d433d64a$export$2924b498742ec559(p.y, Y), $5008de97d433d64a$export$2924b498742ec559(p.z, Z)).toVar();
    const sqdist = (0, $d5b7ee61758b2e81$export$9100789c9d999364)(1e6, 1e6, 1e6).toVar();
    (0, $2a1578e0d4d8bf63$export$550acbd06a1f5a6a)({
        start: -1,
        end: (0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)(1),
        name: 'x',
        condition: '<='
    }, ({ x: x })=>{
        (0, $2a1578e0d4d8bf63$export$550acbd06a1f5a6a)({
            start: -1,
            end: (0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)(1),
            name: 'y',
            condition: '<='
        }, ({ y: y })=>{
            (0, $2a1578e0d4d8bf63$export$550acbd06a1f5a6a)({
                start: -1,
                end: (0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)(1),
                name: 'z',
                condition: '<='
            }, ({ z: z })=>{
                const dist = (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)($5008de97d433d64a$export$6ac922b7b83e46f7(localpos, x, y, z, X, Y, Z, jitter, metric)).toVar();
                (0, $d5b7ee61758b2e81$export$1f9ff5f4a6c9361a)(dist.lessThan(sqdist.x), ()=>{
                    sqdist.z.assign(sqdist.y);
                    sqdist.y.assign(sqdist.x);
                    sqdist.x.assign(dist);
                }).ElseIf(dist.lessThan(sqdist.y), ()=>{
                    sqdist.z.assign(sqdist.y);
                    sqdist.y.assign(dist);
                }).ElseIf(dist.lessThan(sqdist.z), ()=>{
                    sqdist.z.assign(dist);
                });
            });
        });
    });
    (0, $d5b7ee61758b2e81$export$1f9ff5f4a6c9361a)(metric.equal((0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)(0)), ()=>{
        sqdist.assign((0, $f37ae0e58866c183$export$eba8049fb5020b81)(sqdist));
    });
    return sqdist;
}).setLayout({
    name: 'mx_worley_noise_vec3_1',
    type: 'vec3',
    inputs: [
        {
            name: 'p',
            type: 'vec3'
        },
        {
            name: 'jitter',
            type: 'float'
        },
        {
            name: 'metric',
            type: 'int'
        }
    ]
});
const $5008de97d433d64a$export$b7934e3309df8a41 = /*@__PURE__*/ (0, $228cc208600144f8$export$16973c2f8bfadf46)([
    $5008de97d433d64a$export$6de9d2a7fe815d34,
    $5008de97d433d64a$export$7a05953f29b1763a
]);


// Three.js Transpiler
// https://github.com/AcademySoftwareFoundation/MaterialX/blob/main/libraries/stdlib/genglsl/lib/mx_hsv.glsl



const $3425088cec8d87de$export$1c73a657835dd60c = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$b076717d71a1a47f)(([hsv])=>{
    const s = hsv.y;
    const v = hsv.z;
    const result = (0, $d5b7ee61758b2e81$export$9100789c9d999364)().toVar();
    (0, $d5b7ee61758b2e81$export$1f9ff5f4a6c9361a)(s.lessThan(0.0001), ()=>{
        result.assign((0, $d5b7ee61758b2e81$export$9100789c9d999364)(v, v, v));
    }).Else(()=>{
        let h = hsv.x;
        h = h.sub((0, $f37ae0e58866c183$export$a3fe094919f356fd)(h)).mul(6.0).toVar(); // TODO: check what .toVar() is needed in node system cache
        const hi = (0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)((0, $f37ae0e58866c183$export$1fe87bd59b089f0)(h));
        const f = h.sub((0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(hi));
        const p = v.mul(s.oneMinus());
        const q = v.mul(s.mul(f).oneMinus());
        const t = v.mul(s.mul(f.oneMinus()).oneMinus());
        (0, $d5b7ee61758b2e81$export$1f9ff5f4a6c9361a)(hi.equal((0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)(0)), ()=>{
            result.assign((0, $d5b7ee61758b2e81$export$9100789c9d999364)(v, t, p));
        }).ElseIf(hi.equal((0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)(1)), ()=>{
            result.assign((0, $d5b7ee61758b2e81$export$9100789c9d999364)(q, v, p));
        }).ElseIf(hi.equal((0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)(2)), ()=>{
            result.assign((0, $d5b7ee61758b2e81$export$9100789c9d999364)(p, v, t));
        }).ElseIf(hi.equal((0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)(3)), ()=>{
            result.assign((0, $d5b7ee61758b2e81$export$9100789c9d999364)(p, q, v));
        }).ElseIf(hi.equal((0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)(4)), ()=>{
            result.assign((0, $d5b7ee61758b2e81$export$9100789c9d999364)(t, p, v));
        }).Else(()=>{
            result.assign((0, $d5b7ee61758b2e81$export$9100789c9d999364)(v, p, q));
        });
    });
    return result;
}).setLayout({
    name: 'mx_hsvtorgb',
    type: 'vec3',
    inputs: [
        {
            name: 'hsv',
            type: 'vec3'
        }
    ]
});
const $3425088cec8d87de$export$477554281ec906c0 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$b076717d71a1a47f)(([c_immutable])=>{
    const c = (0, $d5b7ee61758b2e81$export$9100789c9d999364)(c_immutable).toVar();
    const r = (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(c.x).toVar();
    const g = (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(c.y).toVar();
    const b = (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(c.z).toVar();
    const mincomp = (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)((0, $f37ae0e58866c183$export$96ec731ed4dcb222)(r, (0, $f37ae0e58866c183$export$96ec731ed4dcb222)(g, b))).toVar();
    const maxcomp = (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)((0, $f37ae0e58866c183$export$8960430cfd85939f)(r, (0, $f37ae0e58866c183$export$8960430cfd85939f)(g, b))).toVar();
    const delta = (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(maxcomp.sub(mincomp)).toVar();
    const h = (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)().toVar(), s = (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)().toVar(), v = (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)().toVar();
    v.assign(maxcomp);
    (0, $d5b7ee61758b2e81$export$1f9ff5f4a6c9361a)(maxcomp.greaterThan(0.0), ()=>{
        s.assign(delta.div(maxcomp));
    }).Else(()=>{
        s.assign(0.0);
    });
    (0, $d5b7ee61758b2e81$export$1f9ff5f4a6c9361a)(s.lessThanEqual(0.0), ()=>{
        h.assign(0.0);
    }).Else(()=>{
        (0, $d5b7ee61758b2e81$export$1f9ff5f4a6c9361a)(r.greaterThanEqual(maxcomp), ()=>{
            h.assign(g.sub(b).div(delta));
        }).ElseIf(g.greaterThanEqual(maxcomp), ()=>{
            h.assign((0, $3f1f23fea79ae256$export$e16d8520af44a096)(2.0, b.sub(r).div(delta)));
        }).Else(()=>{
            h.assign((0, $3f1f23fea79ae256$export$e16d8520af44a096)(4.0, r.sub(g).div(delta)));
        });
        h.mulAssign(1.0 / 6.0);
        (0, $d5b7ee61758b2e81$export$1f9ff5f4a6c9361a)(h.lessThan(0.0), ()=>{
            h.addAssign(1.0);
        });
    });
    return (0, $d5b7ee61758b2e81$export$9100789c9d999364)(h, s, v);
}).setLayout({
    name: 'mx_rgbtohsv',
    type: 'vec3',
    inputs: [
        {
            name: 'c',
            type: 'vec3'
        }
    ]
});


// Three.js Transpiler
// https://github.com/AcademySoftwareFoundation/MaterialX/blob/main/libraries/stdlib/genglsl/lib/mx_transform_color.glsl



const $2b62333094871cb7$export$988eb684c3dd11f6 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$b076717d71a1a47f)(([color_immutable])=>{
    const color = (0, $d5b7ee61758b2e81$export$9100789c9d999364)(color_immutable).toVar();
    const isAbove = (0, $d5b7ee61758b2e81$export$625ee0a1e433837e)((0, $3f1f23fea79ae256$export$f517ea36c68d4644)(color, (0, $d5b7ee61758b2e81$export$9100789c9d999364)(0.04045))).toVar();
    const linSeg = (0, $d5b7ee61758b2e81$export$9100789c9d999364)(color.div(12.92)).toVar();
    const powSeg = (0, $d5b7ee61758b2e81$export$9100789c9d999364)((0, $f37ae0e58866c183$export$9c297f60e22e3389)((0, $f37ae0e58866c183$export$8960430cfd85939f)(color.add((0, $d5b7ee61758b2e81$export$9100789c9d999364)(0.055)), (0, $d5b7ee61758b2e81$export$9100789c9d999364)(0.0)).div(1.055), (0, $d5b7ee61758b2e81$export$9100789c9d999364)(2.4))).toVar();
    return (0, $f37ae0e58866c183$export$2c9e8a9632a706b2)(linSeg, powSeg, isAbove);
}).setLayout({
    name: 'mx_srgb_texture_to_lin_rec709',
    type: 'vec3',
    inputs: [
        {
            name: 'color',
            type: 'vec3'
        }
    ]
});





const $6767002b56deac97$export$3abc4ab271c90c12 = (threshold, value)=>{
    threshold = (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(threshold);
    value = (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(value);
    const afwidth = (0, $d5b7ee61758b2e81$export$e9830bc863290a54)(value.dFdx(), value.dFdy()).length().mul(0.70710678118654757);
    return (0, $f37ae0e58866c183$export$4053e36566dd3d9a)(threshold.sub(afwidth), threshold.add(afwidth), value);
};
const $6767002b56deac97$var$_ramp = (a, b, uv, p)=>(0, $f37ae0e58866c183$export$2c9e8a9632a706b2)(a, b, uv[p].clamp());
const $6767002b56deac97$export$b8397ca5ab92c8eb = (valuel, valuer, texcoord = (0, $382a32bd765f3827$export$c774ebbac59e31d3)())=>$6767002b56deac97$var$_ramp(valuel, valuer, texcoord, 'x');
const $6767002b56deac97$export$8f10382b4ad0dbdf = (valuet, valueb, texcoord = (0, $382a32bd765f3827$export$c774ebbac59e31d3)())=>$6767002b56deac97$var$_ramp(valuet, valueb, texcoord, 'y');
const $6767002b56deac97$var$_split = (a, b, center, uv, p)=>(0, $f37ae0e58866c183$export$2c9e8a9632a706b2)(a, b, $6767002b56deac97$export$3abc4ab271c90c12(center, uv[p]));
const $6767002b56deac97$export$c99c1f94d5fd9c82 = (valuel, valuer, center, texcoord = (0, $382a32bd765f3827$export$c774ebbac59e31d3)())=>$6767002b56deac97$var$_split(valuel, valuer, center, texcoord, 'x');
const $6767002b56deac97$export$b2177b377f6c02c7 = (valuet, valueb, center, texcoord = (0, $382a32bd765f3827$export$c774ebbac59e31d3)())=>$6767002b56deac97$var$_split(valuet, valueb, center, texcoord, 'y');
const $6767002b56deac97$export$a85ea9382bad03f4 = (uv_scale = 1, uv_offset = 0, uv_geo = (0, $382a32bd765f3827$export$c774ebbac59e31d3)())=>uv_geo.mul(uv_scale).add(uv_offset);
const $6767002b56deac97$export$3af405f73b3ef1a4 = (in1, in2 = 1)=>{
    in1 = (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(in1);
    return in1.abs().pow(in2).mul(in1.sign());
};
const $6767002b56deac97$export$a5846f4df8e00325 = (input, amount = 1, pivot = .5)=>(0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(input).sub(pivot).mul(amount).add(pivot);
const $6767002b56deac97$export$28ad0acc0579e60b = (texcoord = (0, $382a32bd765f3827$export$c774ebbac59e31d3)(), amplitude = 1, pivot = 0)=>(0, $5008de97d433d64a$export$8156a390e7b52cb6)(texcoord.convert('vec2|vec3')).mul(amplitude).add(pivot);
const $6767002b56deac97$export$e5fcad86905f3008 = (texcoord = (0, $382a32bd765f3827$export$c774ebbac59e31d3)(), amplitude = 1, pivot = 0)=>(0, $5008de97d433d64a$export$48933da469822a3e)(texcoord.convert('vec2|vec3')).mul(amplitude).add(pivot);
const $6767002b56deac97$export$d9085b548a873a4f = (texcoord = (0, $382a32bd765f3827$export$c774ebbac59e31d3)(), amplitude = 1, pivot = 0)=>{
    texcoord = texcoord.convert('vec2|vec3'); // overloading type
    const noise_vec4 = (0, $d5b7ee61758b2e81$export$6dba2a1f0d609415)((0, $5008de97d433d64a$export$48933da469822a3e)(texcoord), (0, $5008de97d433d64a$export$8156a390e7b52cb6)(texcoord.add((0, $d5b7ee61758b2e81$export$e9830bc863290a54)(19, 73))));
    return noise_vec4.mul(amplitude).add(pivot);
};
const $6767002b56deac97$export$ee237dfb83b6bbea = (texcoord = (0, $382a32bd765f3827$export$c774ebbac59e31d3)(), jitter = 1)=>(0, $5008de97d433d64a$export$ee237dfb83b6bbea)(texcoord.convert('vec2|vec3'), jitter, (0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)(1));
const $6767002b56deac97$export$f83e54c8c80af323 = (texcoord = (0, $382a32bd765f3827$export$c774ebbac59e31d3)(), jitter = 1)=>(0, $5008de97d433d64a$export$f83e54c8c80af323)(texcoord.convert('vec2|vec3'), jitter, (0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)(1));
const $6767002b56deac97$export$b7934e3309df8a41 = (texcoord = (0, $382a32bd765f3827$export$c774ebbac59e31d3)(), jitter = 1)=>(0, $5008de97d433d64a$export$b7934e3309df8a41)(texcoord.convert('vec2|vec3'), jitter, (0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)(1));
const $6767002b56deac97$export$5eaa094b2411a56b = (texcoord = (0, $382a32bd765f3827$export$c774ebbac59e31d3)())=>(0, $5008de97d433d64a$export$5eaa094b2411a56b)(texcoord.convert('vec2|vec3'));
const $6767002b56deac97$export$2a6701b70ee390ec = (position = (0, $382a32bd765f3827$export$c774ebbac59e31d3)(), octaves = 3, lacunarity = 2, diminish = .5, amplitude = 1)=>(0, $5008de97d433d64a$export$2a6701b70ee390ec)(position, (0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)(octaves), lacunarity, diminish).mul(amplitude);
const $6767002b56deac97$export$dfda353404f4bfd0 = (position = (0, $382a32bd765f3827$export$c774ebbac59e31d3)(), octaves = 3, lacunarity = 2, diminish = .5, amplitude = 1)=>(0, $5008de97d433d64a$export$dfda353404f4bfd0)(position, (0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)(octaves), lacunarity, diminish).mul(amplitude);
const $6767002b56deac97$export$12ba67f6f21a3945 = (position = (0, $382a32bd765f3827$export$c774ebbac59e31d3)(), octaves = 3, lacunarity = 2, diminish = .5, amplitude = 1)=>(0, $5008de97d433d64a$export$12ba67f6f21a3945)(position, (0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)(octaves), lacunarity, diminish).mul(amplitude);
const $6767002b56deac97$export$970ebd521f5a5812 = (position = (0, $382a32bd765f3827$export$c774ebbac59e31d3)(), octaves = 3, lacunarity = 2, diminish = .5, amplitude = 1)=>(0, $5008de97d433d64a$export$970ebd521f5a5812)(position, (0, $d5b7ee61758b2e81$export$7d260a2a5f8bc19e)(octaves), lacunarity, diminish).mul(amplitude);



const $2b8bcb75dcac1789$var$F_Schlick = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$b076717d71a1a47f)(({ f0: f0, f90: f90, dotVH: dotVH })=>{
    // Original approximation by Christophe Schlick '94
    // float fresnel = pow( 1.0 - dotVH, 5.0 );
    // Optimized variant (presented by Epic at SIGGRAPH '13)
    // https://cdn2.unrealengine.com/Resources/files/2013SiggraphPresentationsNotes-26915738.pdf
    const fresnel = dotVH.mul(-5.55473).sub(6.98316).mul(dotVH).exp2();
    return f0.mul(fresnel.oneMinus()).add(f90.mul(fresnel));
}); // validated
var $2b8bcb75dcac1789$export$2e2bcd8739ae039 = $2b8bcb75dcac1789$var$F_Schlick;





// Moving Frostbite to Physically Based Rendering 3.0 - page 12, listing 2
// https://seblagarde.files.wordpress.com/2015/07/course_notes_moving_frostbite_to_pbr_v32.pdf
const $583024b2709d6d25$var$V_GGX_SmithCorrelated = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$b076717d71a1a47f)(({ alpha: alpha, dotNL: dotNL, dotNV: dotNV })=>{
    const a2 = alpha.pow2();
    const gv = dotNL.mul(a2.add(a2.oneMinus().mul(dotNV.pow2())).sqrt());
    const gl = dotNV.mul(a2.add(a2.oneMinus().mul(dotNL.pow2())).sqrt());
    return (0, $3f1f23fea79ae256$export$159d9494db57879b)(0.5, gv.add(gl).max((0, $f37ae0e58866c183$export$fd293b15f47e270)));
}).setLayout({
    name: 'V_GGX_SmithCorrelated',
    type: 'float',
    inputs: [
        {
            name: 'alpha',
            type: 'float'
        },
        {
            name: 'dotNL',
            type: 'float'
        },
        {
            name: 'dotNV',
            type: 'float'
        }
    ]
}); // validated
var $583024b2709d6d25$export$2e2bcd8739ae039 = $583024b2709d6d25$var$V_GGX_SmithCorrelated;




// https://google.github.io/filament/Filament.md.html#materialsystem/anisotropicmodel/anisotropicspecularbrdf
const $c25e61b937f19633$var$V_GGX_SmithCorrelated_Anisotropic = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$b076717d71a1a47f)(({ alphaT: alphaT, alphaB: alphaB, dotTV: dotTV, dotBV: dotBV, dotTL: dotTL, dotBL: dotBL, dotNV: dotNV, dotNL: dotNL })=>{
    const gv = dotNL.mul((0, $d5b7ee61758b2e81$export$9100789c9d999364)(alphaT.mul(dotTV), alphaB.mul(dotBV), dotNV).length());
    const gl = dotNV.mul((0, $d5b7ee61758b2e81$export$9100789c9d999364)(alphaT.mul(dotTL), alphaB.mul(dotBL), dotNL).length());
    const v = (0, $3f1f23fea79ae256$export$159d9494db57879b)(0.5, gv.add(gl));
    return v.saturate();
}).setLayout({
    name: 'V_GGX_SmithCorrelated_Anisotropic',
    type: 'float',
    inputs: [
        {
            name: 'alphaT',
            type: 'float',
            qualifier: 'in'
        },
        {
            name: 'alphaB',
            type: 'float',
            qualifier: 'in'
        },
        {
            name: 'dotTV',
            type: 'float',
            qualifier: 'in'
        },
        {
            name: 'dotBV',
            type: 'float',
            qualifier: 'in'
        },
        {
            name: 'dotTL',
            type: 'float',
            qualifier: 'in'
        },
        {
            name: 'dotBL',
            type: 'float',
            qualifier: 'in'
        },
        {
            name: 'dotNV',
            type: 'float',
            qualifier: 'in'
        },
        {
            name: 'dotNL',
            type: 'float',
            qualifier: 'in'
        }
    ]
});
var $c25e61b937f19633$export$2e2bcd8739ae039 = $c25e61b937f19633$var$V_GGX_SmithCorrelated_Anisotropic;



// Microfacet Models for Refraction through Rough Surfaces - equation (33)
// http://graphicrants.blogspot.com/2013/08/specular-brdf-reference.html
// alpha is "roughness squared" in Disney’s reparameterization
const $acd1b56cb4259f4b$var$D_GGX = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$b076717d71a1a47f)(({ alpha: alpha, dotNH: dotNH })=>{
    const a2 = alpha.pow2();
    const denom = dotNH.pow2().mul(a2.oneMinus()).oneMinus(); // avoid alpha = 0 with dotNH = 1
    return a2.div(denom.pow2()).mul(1 / Math.PI);
}).setLayout({
    name: 'D_GGX',
    type: 'float',
    inputs: [
        {
            name: 'alpha',
            type: 'float'
        },
        {
            name: 'dotNH',
            type: 'float'
        }
    ]
}); // validated
var $acd1b56cb4259f4b$export$2e2bcd8739ae039 = $acd1b56cb4259f4b$var$D_GGX;



const $14a12bbc840484b0$var$RECIPROCAL_PI = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(1 / Math.PI);
// https://google.github.io/filament/Filament.md.html#materialsystem/anisotropicmodel/anisotropicspecularbrdf
const $14a12bbc840484b0$var$D_GGX_Anisotropic = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$b076717d71a1a47f)(({ alphaT: alphaT, alphaB: alphaB, dotNH: dotNH, dotTH: dotTH, dotBH: dotBH })=>{
    const a2 = alphaT.mul(alphaB);
    const v = (0, $d5b7ee61758b2e81$export$9100789c9d999364)(alphaB.mul(dotTH), alphaT.mul(dotBH), a2.mul(dotNH));
    const v2 = v.dot(v);
    const w2 = a2.div(v2);
    return $14a12bbc840484b0$var$RECIPROCAL_PI.mul(a2.mul(w2.pow2()));
}).setLayout({
    name: 'D_GGX_Anisotropic',
    type: 'float',
    inputs: [
        {
            name: 'alphaT',
            type: 'float',
            qualifier: 'in'
        },
        {
            name: 'alphaB',
            type: 'float',
            qualifier: 'in'
        },
        {
            name: 'dotNH',
            type: 'float',
            qualifier: 'in'
        },
        {
            name: 'dotTH',
            type: 'float',
            qualifier: 'in'
        },
        {
            name: 'dotBH',
            type: 'float',
            qualifier: 'in'
        }
    ]
});
var $14a12bbc840484b0$export$2e2bcd8739ae039 = $14a12bbc840484b0$var$D_GGX_Anisotropic;






// GGX Distribution, Schlick Fresnel, GGX_SmithCorrelated Visibility
const $173677068bff6758$var$BRDF_GGX = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$b076717d71a1a47f)((inputs)=>{
    const { lightDirection: lightDirection, f0: f0, f90: f90, roughness: roughness, f: f, USE_IRIDESCENCE: USE_IRIDESCENCE, USE_ANISOTROPY: USE_ANISOTROPY } = inputs;
    const normalView = inputs.normalView || (0, $0ab44deffc8ae973$export$c58d63d09d102e3c);
    const alpha = roughness.pow2(); // UE4's roughness
    const halfDir = lightDirection.add((0, $acbec2070ba15851$export$80de5077965297a8)).normalize();
    const dotNL = normalView.dot(lightDirection).clamp();
    const dotNV = normalView.dot((0, $acbec2070ba15851$export$80de5077965297a8)).clamp(); // @ TODO: Move to core dotNV
    const dotNH = normalView.dot(halfDir).clamp();
    const dotVH = (0, $acbec2070ba15851$export$80de5077965297a8).dot(halfDir).clamp();
    let F = (0, $2b8bcb75dcac1789$export$2e2bcd8739ae039)({
        f0: f0,
        f90: f90,
        dotVH: dotVH
    });
    let V, D;
    if ((0, $d5b7ee61758b2e81$export$43f40ad3fa1d5c97)(USE_IRIDESCENCE)) F = (0, $dd761eb0c8b88ca7$export$8fa8908d67be43df).mix(F, f);
    if ((0, $d5b7ee61758b2e81$export$43f40ad3fa1d5c97)(USE_ANISOTROPY)) {
        const dotTL = (0, $dd761eb0c8b88ca7$export$56937cc288fe4ea7).dot(lightDirection);
        const dotTV = (0, $dd761eb0c8b88ca7$export$56937cc288fe4ea7).dot((0, $acbec2070ba15851$export$80de5077965297a8));
        const dotTH = (0, $dd761eb0c8b88ca7$export$56937cc288fe4ea7).dot(halfDir);
        const dotBL = (0, $dd761eb0c8b88ca7$export$5748f3030096f448).dot(lightDirection);
        const dotBV = (0, $dd761eb0c8b88ca7$export$5748f3030096f448).dot((0, $acbec2070ba15851$export$80de5077965297a8));
        const dotBH = (0, $dd761eb0c8b88ca7$export$5748f3030096f448).dot(halfDir);
        V = (0, $c25e61b937f19633$export$2e2bcd8739ae039)({
            alphaT: $dd761eb0c8b88ca7$export$6b527ce29f545f8c,
            alphaB: alpha,
            dotTV: dotTV,
            dotBV: dotBV,
            dotTL: dotTL,
            dotBL: dotBL,
            dotNV: dotNV,
            dotNL: dotNL
        });
        D = (0, $14a12bbc840484b0$export$2e2bcd8739ae039)({
            alphaT: $dd761eb0c8b88ca7$export$6b527ce29f545f8c,
            alphaB: alpha,
            dotNH: dotNH,
            dotTH: dotTH,
            dotBH: dotBH
        });
    } else {
        V = (0, $583024b2709d6d25$export$2e2bcd8739ae039)({
            alpha: alpha,
            dotNL: dotNL,
            dotNV: dotNV
        });
        D = (0, $acd1b56cb4259f4b$export$2e2bcd8739ae039)({
            alpha: alpha,
            dotNH: dotNH
        });
    }
    return F.mul(V).mul(D);
}); // validated
var $173677068bff6758$export$2e2bcd8739ae039 = $173677068bff6758$var$BRDF_GGX;



const $f21c2fe74f9eb092$var$BRDF_Lambert = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$b076717d71a1a47f)((inputs)=>{
    return inputs.diffuseColor.mul(1 / Math.PI); // punctual light
}); // validated
var $f21c2fe74f9eb092$export$2e2bcd8739ae039 = $f21c2fe74f9eb092$var$BRDF_Lambert;




// Analytical approximation of the DFG LUT, one half of the
// split-sum approximation used in indirect specular lighting.
// via 'environmentBRDF' from "Physically Based Shading on Mobile"
// https://www.unrealengine.com/blog/physically-based-shading-on-mobile
const $032552e6d393c061$var$DFGApprox = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$b076717d71a1a47f)(({ roughness: roughness, dotNV: dotNV })=>{
    const c0 = (0, $d5b7ee61758b2e81$export$6dba2a1f0d609415)(-1, -0.0275, -0.572, 0.022);
    const c1 = (0, $d5b7ee61758b2e81$export$6dba2a1f0d609415)(1, 0.0425, 1.04, -0.04);
    const r = roughness.mul(c0).add(c1);
    const a004 = r.x.mul(r.x).min(dotNV.mul(-9.28).exp2()).mul(r.x).add(r.y);
    const fab = (0, $d5b7ee61758b2e81$export$e9830bc863290a54)(-1.04, 1.04).mul(a004).add(r.zw);
    return fab;
}).setLayout({
    name: 'DFGApprox',
    type: 'vec2',
    inputs: [
        {
            name: 'roughness',
            type: 'float'
        },
        {
            name: 'dotNV',
            type: 'vec3'
        }
    ]
});
var $032552e6d393c061$export$2e2bcd8739ae039 = $032552e6d393c061$var$DFGApprox;




const $37c11dc2ed7b9a24$var$Schlick_to_F0 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$b076717d71a1a47f)(({ f: f, f90: f90, dotVH: dotVH })=>{
    const x = dotVH.oneMinus().saturate();
    const x2 = x.mul(x);
    const x5 = x.mul(x2, x2).clamp(0, .9999);
    return f.sub((0, $d5b7ee61758b2e81$export$9100789c9d999364)(f90).mul(x5)).div(x5.oneMinus());
}).setLayout({
    name: 'Schlick_to_F0',
    type: 'vec3',
    inputs: [
        {
            name: 'f',
            type: 'vec3'
        },
        {
            name: 'f90',
            type: 'float'
        },
        {
            name: 'dotVH',
            type: 'float'
        }
    ]
});
var $37c11dc2ed7b9a24$export$2e2bcd8739ae039 = $37c11dc2ed7b9a24$var$Schlick_to_F0;






const $a7ec6303e75a94b2$var$getGeometryRoughness = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$b076717d71a1a47f)((builder)=>{
    if (builder.geometry.hasAttribute('normal') === false) return (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(0);
    const dxy = (0, $0ab44deffc8ae973$export$c7d7ec78bf3ab28a).dFdx().abs().max((0, $0ab44deffc8ae973$export$c7d7ec78bf3ab28a).dFdy().abs());
    const geometryRoughness = dxy.x.max(dxy.y).max(dxy.z);
    return geometryRoughness;
});
var $a7ec6303e75a94b2$export$2e2bcd8739ae039 = $a7ec6303e75a94b2$var$getGeometryRoughness;




// https://devlog-martinsh.blogspot.com/2011/09/box-projected-cube-environment-mapping.html
const $ee89f77bb6596b2e$var$getParallaxCorrectNormal = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$b076717d71a1a47f)(([normal, cubeSize, cubePos])=>{
    const nDir = (0, $f37ae0e58866c183$export$a3295358bff77e)(normal).toVar('nDir');
    const rbmax = (0, $3f1f23fea79ae256$export$f93b5905241a7cca)((0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(0.5).mul(cubeSize.sub(cubePos)), (0, $acbec2070ba15851$export$3e8de2ffef4e6f91)).div(nDir).toVar('rbmax');
    const rbmin = (0, $3f1f23fea79ae256$export$f93b5905241a7cca)((0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(-0.5).mul(cubeSize.sub(cubePos)), (0, $acbec2070ba15851$export$3e8de2ffef4e6f91)).div(nDir).toVar('rbmin');
    const rbminmax = (0, $d5b7ee61758b2e81$export$9100789c9d999364)().toVar('rbminmax');
    rbminmax.x = nDir.x.greaterThan((0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(0)).select(rbmax.x, rbmin.x);
    rbminmax.y = nDir.y.greaterThan((0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(0)).select(rbmax.y, rbmin.y);
    rbminmax.z = nDir.z.greaterThan((0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(0)).select(rbmax.z, rbmin.z);
    const correction = (0, $f37ae0e58866c183$export$96ec731ed4dcb222)((0, $f37ae0e58866c183$export$96ec731ed4dcb222)(rbminmax.x, rbminmax.y), rbminmax.z).toVar('correction');
    const boxIntersection = (0, $acbec2070ba15851$export$3e8de2ffef4e6f91).add(nDir.mul(correction)).toVar('boxIntersection');
    return boxIntersection.sub(cubePos);
});
var $ee89f77bb6596b2e$export$2e2bcd8739ae039 = $ee89f77bb6596b2e$var$getParallaxCorrectNormal;




const $92d764f415b878f6$var$getRoughness = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$b076717d71a1a47f)((inputs)=>{
    const { roughness: roughness } = inputs;
    const geometryRoughness = (0, $a7ec6303e75a94b2$export$2e2bcd8739ae039)();
    let roughnessFactor = roughness.max(0.0525); // 0.0525 corresponds to the base mip of a 256 cubemap.
    roughnessFactor = roughnessFactor.add(geometryRoughness);
    roughnessFactor = roughnessFactor.min(1.0);
    return roughnessFactor;
});
var $92d764f415b878f6$export$2e2bcd8739ae039 = $92d764f415b878f6$var$getRoughness;



const $c1938fd2d8038641$var$getShIrradianceAt = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$b076717d71a1a47f)(([normal, shCoefficients])=>{
    // normal is assumed to have unit length
    const x = normal.x, y = normal.y, z = normal.z;
    // band 0
    let result = shCoefficients.element(0).mul(0.886227);
    // band 1
    result = result.add(shCoefficients.element(1).mul(1.023328).mul(y));
    result = result.add(shCoefficients.element(2).mul(1.023328).mul(z));
    result = result.add(shCoefficients.element(3).mul(1.023328).mul(x));
    // band 2
    result = result.add(shCoefficients.element(4).mul(0.858086).mul(x).mul(y));
    result = result.add(shCoefficients.element(5).mul(0.858086).mul(y).mul(z));
    result = result.add(shCoefficients.element(6).mul(z.mul(z).mul(0.743125).sub(0.247708)));
    result = result.add(shCoefficients.element(7).mul(0.858086).mul(x).mul(z));
    result = result.add(shCoefficients.element(8).mul(0.429043).mul((0, $3f1f23fea79ae256$export$6e3a27864ab166fe)(x, x).sub((0, $3f1f23fea79ae256$export$6e3a27864ab166fe)(y, y))));
    return result;
});
var $c1938fd2d8038641$export$2e2bcd8739ae039 = $c1938fd2d8038641$var$getShIrradianceAt;









class $3dd25c609bc8a72a$export$1b417fc3b307a251 extends (0, $b7aea261c5c9a899$export$b7be63a67df8959) {
    constructor(radius = 1, widthSegments = 32, heightSegments = 16, phiStart = 0, phiLength = Math.PI * 2, thetaStart = 0, thetaLength = Math.PI){
        super();
        this.type = 'SphereGeometry';
        this.parameters = {
            radius: radius,
            widthSegments: widthSegments,
            heightSegments: heightSegments,
            phiStart: phiStart,
            phiLength: phiLength,
            thetaStart: thetaStart,
            thetaLength: thetaLength
        };
        widthSegments = Math.max(3, Math.floor(widthSegments));
        heightSegments = Math.max(2, Math.floor(heightSegments));
        const thetaEnd = Math.min(thetaStart + thetaLength, Math.PI);
        let index = 0;
        const grid = [];
        const vertex = new (0, $d7d0ac0e47013885$export$64b5c384219d3699)();
        const normal = new (0, $d7d0ac0e47013885$export$64b5c384219d3699)();
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // generate vertices, normals and uvs
        for(let iy = 0; iy <= heightSegments; iy++){
            const verticesRow = [];
            const v = iy / heightSegments;
            // special case for the poles
            let uOffset = 0;
            if (iy === 0 && thetaStart === 0) uOffset = 0.5 / widthSegments;
            else if (iy === heightSegments && thetaEnd === Math.PI) uOffset = -0.5 / widthSegments;
            for(let ix = 0; ix <= widthSegments; ix++){
                const u = ix / widthSegments;
                // vertex
                vertex.x = -radius * Math.cos(phiStart + u * phiLength) * Math.sin(thetaStart + v * thetaLength);
                vertex.y = radius * Math.cos(thetaStart + v * thetaLength);
                vertex.z = radius * Math.sin(phiStart + u * phiLength) * Math.sin(thetaStart + v * thetaLength);
                vertices.push(vertex.x, vertex.y, vertex.z);
                // normal
                normal.copy(vertex).normalize();
                normals.push(normal.x, normal.y, normal.z);
                // uv
                uvs.push(u + uOffset, 1 - v);
                verticesRow.push(index++);
            }
            grid.push(verticesRow);
        }
        // indices
        for(let iy = 0; iy < heightSegments; iy++)for(let ix = 0; ix < widthSegments; ix++){
            const a = grid[iy][ix + 1];
            const b = grid[iy][ix];
            const c = grid[iy + 1][ix];
            const d = grid[iy + 1][ix + 1];
            if (iy !== 0 || thetaStart > 0) indices.push(a, b, d);
            if (iy !== heightSegments - 1 || thetaEnd < Math.PI) indices.push(b, c, d);
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new (0, $4b03383e684869fb$export$cbe7a62641830ebd)(vertices, 3));
        this.setAttribute('normal', new (0, $4b03383e684869fb$export$cbe7a62641830ebd)(normals, 3));
        this.setAttribute('uv', new (0, $4b03383e684869fb$export$cbe7a62641830ebd)(uvs, 2));
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    static fromJSON(data) {
        return new $3dd25c609bc8a72a$export$1b417fc3b307a251(data.radius, data.widthSegments, data.heightSegments, data.phiStart, data.phiLength, data.thetaStart, data.thetaLength);
    }
}



const $1aa79941180be295$var$_clearColor = /*@__PURE__*/ new (0, $4673b28ced87b0be$export$2e2bcd8739ae039)();
class $1aa79941180be295$var$Background extends (0, $0c532ab002169243$export$2e2bcd8739ae039) {
    constructor(renderer, nodes){
        super();
        this.renderer = renderer;
        this.nodes = nodes;
    }
    update(scene, renderList, renderContext) {
        const renderer = this.renderer;
        const background = this.nodes.getBackgroundNode(scene) || scene.background;
        let forceClear = false;
        if (background === null) {
            // no background settings, use clear color configuration from the renderer
            renderer._clearColor.getRGB($1aa79941180be295$var$_clearColor, (0, $cb5ee595c0f892af$export$42429b3acfb233a4));
            $1aa79941180be295$var$_clearColor.a = renderer._clearColor.a;
        } else if (background.isColor === true) {
            // background is an opaque color
            background.getRGB($1aa79941180be295$var$_clearColor, (0, $cb5ee595c0f892af$export$42429b3acfb233a4));
            $1aa79941180be295$var$_clearColor.a = 1;
            forceClear = true;
        } else if (background.isNode === true) {
            const sceneData = this.get(scene);
            const backgroundNode = background;
            $1aa79941180be295$var$_clearColor.copy(renderer._clearColor);
            let backgroundMesh = sceneData.backgroundMesh;
            if (backgroundMesh === undefined) {
                const backgroundMeshNode = (0, $8e9a9aae457d80ab$export$a078c61943f9dbbe)((0, $d5b7ee61758b2e81$export$6dba2a1f0d609415)(backgroundNode).mul((0, $25d2163f514a019a$export$aefe029977c9e2d3)), {
                    // @TODO: Add Texture2D support using node context
                    getUV: ()=>(0, $25d2163f514a019a$export$e59ff0f31e16f9ed).mul((0, $0ab44deffc8ae973$export$8cce2f8527757c54)),
                    getTextureLevel: ()=>(0, $25d2163f514a019a$export$4e4686c12357d6e1)
                });
                let viewProj = (0, $ae567e19e549d56f$export$64e914589db9c49e)();
                viewProj = viewProj.setZ(viewProj.w);
                const nodeMaterial = new (0, $1a485f4d26090da0$export$2e2bcd8739ae039)();
                nodeMaterial.name = 'Background.material';
                nodeMaterial.side = (0, $cb5ee595c0f892af$export$d9f0486e75b5ace);
                nodeMaterial.depthTest = false;
                nodeMaterial.depthWrite = false;
                nodeMaterial.fog = false;
                nodeMaterial.lights = false;
                nodeMaterial.vertexNode = viewProj;
                nodeMaterial.colorNode = backgroundMeshNode;
                sceneData.backgroundMeshNode = backgroundMeshNode;
                sceneData.backgroundMesh = backgroundMesh = new (0, $4fa83874928b8122$export$e176487c05830cc5)(new (0, $3dd25c609bc8a72a$export$1b417fc3b307a251)(1, 32, 32), nodeMaterial);
                backgroundMesh.frustumCulled = false;
                backgroundMesh.name = 'Background.mesh';
                backgroundMesh.onBeforeRender = function(renderer, scene, camera) {
                    this.matrixWorld.copyPosition(camera.matrixWorld);
                };
            }
            const backgroundCacheKey = backgroundNode.getCacheKey();
            if (sceneData.backgroundCacheKey !== backgroundCacheKey) {
                sceneData.backgroundMeshNode.node = (0, $d5b7ee61758b2e81$export$6dba2a1f0d609415)(backgroundNode).mul((0, $25d2163f514a019a$export$aefe029977c9e2d3));
                sceneData.backgroundMeshNode.needsUpdate = true;
                backgroundMesh.material.needsUpdate = true;
                sceneData.backgroundCacheKey = backgroundCacheKey;
            }
            renderList.unshift(backgroundMesh, backgroundMesh.geometry, backgroundMesh.material, 0, 0, null);
        } else console.error('THREE.Renderer: Unsupported background configuration.', background);
        //
        if (renderer.autoClear === true || forceClear === true) {
            const clearColorValue = renderContext.clearColorValue;
            clearColorValue.r = $1aa79941180be295$var$_clearColor.r;
            clearColorValue.g = $1aa79941180be295$var$_clearColor.g;
            clearColorValue.b = $1aa79941180be295$var$_clearColor.b;
            clearColorValue.a = $1aa79941180be295$var$_clearColor.a;
            // premultiply alpha
            if (renderer.backend.isWebGLBackend === true || renderer.alpha === true) {
                clearColorValue.r *= clearColorValue.a;
                clearColorValue.g *= clearColorValue.a;
                clearColorValue.b *= clearColorValue.a;
            }
            //
            renderContext.depthClearValue = renderer._clearDepth;
            renderContext.stencilClearValue = renderer._clearStencil;
            renderContext.clearColor = renderer.autoClearColor === true;
            renderContext.clearDepth = renderer.autoClearDepth === true;
            renderContext.clearStencil = renderer.autoClearStencil === true;
        } else {
            renderContext.clearColor = false;
            renderContext.clearDepth = false;
            renderContext.clearStencil = false;
        }
    }
}
var $1aa79941180be295$export$2e2bcd8739ae039 = $1aa79941180be295$var$Background;




let $3779080013be9f66$var$_id = 0;
class $3779080013be9f66$var$BindGroup {
    constructor(name = '', bindings = [], index = 0, bindingsReference = []){
        this.name = name;
        this.bindings = bindings;
        this.index = index;
        this.bindingsReference = bindingsReference;
        this.id = $3779080013be9f66$var$_id++;
    }
}
var $3779080013be9f66$export$2e2bcd8739ae039 = $3779080013be9f66$var$BindGroup;


class $52805df7fe067754$var$NodeBuilderState {
    constructor(vertexShader, fragmentShader, computeShader, nodeAttributes, bindings, updateNodes, updateBeforeNodes, updateAfterNodes, monitor, transforms = []){
        this.vertexShader = vertexShader;
        this.fragmentShader = fragmentShader;
        this.computeShader = computeShader;
        this.transforms = transforms;
        this.nodeAttributes = nodeAttributes;
        this.bindings = bindings;
        this.updateNodes = updateNodes;
        this.updateBeforeNodes = updateBeforeNodes;
        this.updateAfterNodes = updateAfterNodes;
        this.monitor = monitor;
        this.usedTimes = 0;
    }
    createBindings() {
        const bindings = [];
        for (const instanceGroup of this.bindings){
            const shared = instanceGroup.bindings[0].groupNode.shared;
            if (shared !== true) {
                const bindingsGroup = new (0, $3779080013be9f66$export$2e2bcd8739ae039)(instanceGroup.name, [], instanceGroup.index, instanceGroup);
                bindings.push(bindingsGroup);
                for (const instanceBinding of instanceGroup.bindings)bindingsGroup.bindings.push(instanceBinding.clone());
            } else bindings.push(instanceGroup);
        }
        return bindings;
    }
}
var $52805df7fe067754$export$2e2bcd8739ae039 = $52805df7fe067754$var$NodeBuilderState;







class $0b071408edafdf32$export$ee2e5a18258a4049 extends (0, $97033ebbcbadc145$export$5431306cf43de24a) {
    constructor(images, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, colorSpace){
        images = images !== undefined ? images : [];
        mapping = mapping !== undefined ? mapping : (0, $cb5ee595c0f892af$export$8759762a6477f2c4);
        super(images, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, colorSpace);
        this.isCubeTexture = true;
        this.flipY = false;
    }
    get images() {
        return this.image;
    }
    set images(value) {
        this.image = value;
    }
}












class $24282652b400341e$export$33e43285f7406bd5 extends (0, $b7aea261c5c9a899$export$b7be63a67df8959) {
    constructor(width = 1, height = 1, depth = 1, widthSegments = 1, heightSegments = 1, depthSegments = 1){
        super();
        this.type = 'BoxGeometry';
        this.parameters = {
            width: width,
            height: height,
            depth: depth,
            widthSegments: widthSegments,
            heightSegments: heightSegments,
            depthSegments: depthSegments
        };
        const scope = this;
        // segments
        widthSegments = Math.floor(widthSegments);
        heightSegments = Math.floor(heightSegments);
        depthSegments = Math.floor(depthSegments);
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // helper variables
        let numberOfVertices = 0;
        let groupStart = 0;
        // build each side of the box geometry
        buildPlane('z', 'y', 'x', -1, -1, depth, height, width, depthSegments, heightSegments, 0); // px
        buildPlane('z', 'y', 'x', 1, -1, depth, height, -width, depthSegments, heightSegments, 1); // nx
        buildPlane('x', 'z', 'y', 1, 1, width, depth, height, widthSegments, depthSegments, 2); // py
        buildPlane('x', 'z', 'y', 1, -1, width, depth, -height, widthSegments, depthSegments, 3); // ny
        buildPlane('x', 'y', 'z', 1, -1, width, height, depth, widthSegments, heightSegments, 4); // pz
        buildPlane('x', 'y', 'z', -1, -1, width, height, -depth, widthSegments, heightSegments, 5); // nz
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new (0, $4b03383e684869fb$export$cbe7a62641830ebd)(vertices, 3));
        this.setAttribute('normal', new (0, $4b03383e684869fb$export$cbe7a62641830ebd)(normals, 3));
        this.setAttribute('uv', new (0, $4b03383e684869fb$export$cbe7a62641830ebd)(uvs, 2));
        function buildPlane(u, v, w, udir, vdir, width, height, depth, gridX, gridY, materialIndex) {
            const segmentWidth = width / gridX;
            const segmentHeight = height / gridY;
            const widthHalf = width / 2;
            const heightHalf = height / 2;
            const depthHalf = depth / 2;
            const gridX1 = gridX + 1;
            const gridY1 = gridY + 1;
            let vertexCounter = 0;
            let groupCount = 0;
            const vector = new (0, $d7d0ac0e47013885$export$64b5c384219d3699)();
            // generate vertices, normals and uvs
            for(let iy = 0; iy < gridY1; iy++){
                const y = iy * segmentHeight - heightHalf;
                for(let ix = 0; ix < gridX1; ix++){
                    const x = ix * segmentWidth - widthHalf;
                    // set values to correct vector component
                    vector[u] = x * udir;
                    vector[v] = y * vdir;
                    vector[w] = depthHalf;
                    // now apply vector to vertex buffer
                    vertices.push(vector.x, vector.y, vector.z);
                    // set values to correct vector component
                    vector[u] = 0;
                    vector[v] = 0;
                    vector[w] = depth > 0 ? 1 : -1;
                    // now apply vector to normal buffer
                    normals.push(vector.x, vector.y, vector.z);
                    // uvs
                    uvs.push(ix / gridX);
                    uvs.push(1 - iy / gridY);
                    // counters
                    vertexCounter += 1;
                }
            }
            // indices
            // 1. you need three indices to draw a single face
            // 2. a single segment consists of two faces
            // 3. so we need to generate six (2*3) indices per segment
            for(let iy = 0; iy < gridY; iy++)for(let ix = 0; ix < gridX; ix++){
                const a = numberOfVertices + ix + gridX1 * iy;
                const b = numberOfVertices + ix + gridX1 * (iy + 1);
                const c = numberOfVertices + (ix + 1) + gridX1 * (iy + 1);
                const d = numberOfVertices + (ix + 1) + gridX1 * iy;
                // faces
                indices.push(a, b, d);
                indices.push(b, c, d);
                // increase counter
                groupCount += 6;
            }
            // add a group to the geometry. this will ensure multi material support
            scope.addGroup(groupStart, groupCount, materialIndex);
            // calculate new start value for groups
            groupStart += groupCount;
            // update total number of vertices
            numberOfVertices += vertexCounter;
        }
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    static fromJSON(data) {
        return new $24282652b400341e$export$33e43285f7406bd5(data.width, data.height, data.depth, data.widthSegments, data.heightSegments, data.depthSegments);
    }
}




function $11e070c4b510306e$export$acda854380553452(src) {
    const dst = {};
    for(const u in src){
        dst[u] = {};
        for(const p in src[u]){
            const property = src[u][p];
            if (property && (property.isColor || property.isMatrix3 || property.isMatrix4 || property.isVector2 || property.isVector3 || property.isVector4 || property.isTexture || property.isQuaternion)) {
                if (property.isRenderTargetTexture) {
                    console.warn('UniformsUtils: Textures of render targets cannot be cloned via cloneUniforms() or mergeUniforms().');
                    dst[u][p] = null;
                } else dst[u][p] = property.clone();
            } else if (Array.isArray(property)) dst[u][p] = property.slice();
            else dst[u][p] = property;
        }
    }
    return dst;
}
function $11e070c4b510306e$export$8916ce6879271f43(uniforms) {
    const merged = {};
    for(let u = 0; u < uniforms.length; u++){
        const tmp = $11e070c4b510306e$export$acda854380553452(uniforms[u]);
        for(const p in tmp)merged[p] = tmp[p];
    }
    return merged;
}
function $11e070c4b510306e$export$296d019b3eb19704(src) {
    const dst = [];
    for(let u = 0; u < src.length; u++)dst.push(src[u].clone());
    return dst;
}
function $11e070c4b510306e$export$a630742c640528c1(renderer) {
    const currentRenderTarget = renderer.getRenderTarget();
    if (currentRenderTarget === null) // https://github.com/mrdoob/three.js/pull/23937#issuecomment-1111067398
    return renderer.outputColorSpace;
    // https://github.com/mrdoob/three.js/issues/27868
    if (currentRenderTarget.isXRRenderTarget === true) return currentRenderTarget.texture.colorSpace;
    return (0, $46d4f6f1be9702a8$export$5e6fd513f44698c).workingColorSpace;
}
// Legacy
const $11e070c4b510306e$export$d8ecdf8615bfea69 = {
    clone: $11e070c4b510306e$export$acda854380553452,
    merge: $11e070c4b510306e$export$8916ce6879271f43
};


var $de2a22170d32ae98$export$2e2bcd8739ae039 = /* glsl */ `
void main() {
	gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );
}
`;


var $02426923c76aa43b$export$2e2bcd8739ae039 = /* glsl */ `
void main() {
	gl_FragColor = vec4( 1.0, 0.0, 0.0, 1.0 );
}
`;


class $a2aba2f2e3806f54$export$83c7d75d550a8b0d extends (0, $7711e1b3c41f4d78$export$a2d8b23205c25948) {
    static get type() {
        return 'ShaderMaterial';
    }
    constructor(parameters){
        super();
        this.isShaderMaterial = true;
        this.defines = {};
        this.uniforms = {};
        this.uniformsGroups = [];
        this.vertexShader = (0, $de2a22170d32ae98$export$2e2bcd8739ae039);
        this.fragmentShader = (0, $02426923c76aa43b$export$2e2bcd8739ae039);
        this.linewidth = 1;
        this.wireframe = false;
        this.wireframeLinewidth = 1;
        this.fog = false; // set to use scene fog
        this.lights = false; // set to use scene lights
        this.clipping = false; // set to use user-defined clipping planes
        this.forceSinglePass = true;
        this.extensions = {
            clipCullDistance: false,
            multiDraw: false // set to use vertex shader multi_draw / enable gl_DrawID
        };
        // When rendered geometry doesn't include these attributes but the material does,
        // use these default values in WebGL. This avoids errors when buffer data is missing.
        this.defaultAttributeValues = {
            'color': [
                1,
                1,
                1
            ],
            'uv': [
                0,
                0
            ],
            'uv1': [
                0,
                0
            ]
        };
        this.index0AttributeName = undefined;
        this.uniformsNeedUpdate = false;
        this.glslVersion = null;
        if (parameters !== undefined) this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.fragmentShader = source.fragmentShader;
        this.vertexShader = source.vertexShader;
        this.uniforms = (0, $11e070c4b510306e$export$acda854380553452)(source.uniforms);
        this.uniformsGroups = (0, $11e070c4b510306e$export$296d019b3eb19704)(source.uniformsGroups);
        this.defines = Object.assign({}, source.defines);
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.fog = source.fog;
        this.lights = source.lights;
        this.clipping = source.clipping;
        this.extensions = Object.assign({}, source.extensions);
        this.glslVersion = source.glslVersion;
        return this;
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.glslVersion = this.glslVersion;
        data.uniforms = {};
        for(const name in this.uniforms){
            const uniform = this.uniforms[name];
            const value = uniform.value;
            if (value && value.isTexture) data.uniforms[name] = {
                type: 't',
                value: value.toJSON(meta).uuid
            };
            else if (value && value.isColor) data.uniforms[name] = {
                type: 'c',
                value: value.getHex()
            };
            else if (value && value.isVector2) data.uniforms[name] = {
                type: 'v2',
                value: value.toArray()
            };
            else if (value && value.isVector3) data.uniforms[name] = {
                type: 'v3',
                value: value.toArray()
            };
            else if (value && value.isVector4) data.uniforms[name] = {
                type: 'v4',
                value: value.toArray()
            };
            else if (value && value.isMatrix3) data.uniforms[name] = {
                type: 'm3',
                value: value.toArray()
            };
            else if (value && value.isMatrix4) data.uniforms[name] = {
                type: 'm4',
                value: value.toArray()
            };
            else data.uniforms[name] = {
                value: value
            };
        }
        if (Object.keys(this.defines).length > 0) data.defines = this.defines;
        data.vertexShader = this.vertexShader;
        data.fragmentShader = this.fragmentShader;
        data.lights = this.lights;
        data.clipping = this.clipping;
        const extensions = {};
        for(const key in this.extensions)if (this.extensions[key] === true) extensions[key] = true;
        if (Object.keys(extensions).length > 0) data.extensions = extensions;
        return data;
    }
}




class $984bc729b8d1028c$export$3c052beb2e51e23f extends (0, $2ca03eab531e649d$export$efcb1f8bf367cbfb) {
    constructor(width = 1, height = 1, options = {}){
        super(width, height, options);
        this.isWebGLRenderTarget = true;
    }
}








const $2791465b256430b4$var$_v3 = /*@__PURE__*/ new (0, $d7d0ac0e47013885$export$64b5c384219d3699)();
const $2791465b256430b4$var$_minTarget = /*@__PURE__*/ new (0, $3c03061dea0adea3$export$c977b3e384af9ae1)();
const $2791465b256430b4$var$_maxTarget = /*@__PURE__*/ new (0, $3c03061dea0adea3$export$c977b3e384af9ae1)();
class $2791465b256430b4$export$74e4ae24825f68d7 extends (0, $842ad9c500d9d3d8$export$79f141de891a5fed) {
    constructor(fov = 50, aspect = 1, near = 0.1, far = 2000){
        super();
        this.isPerspectiveCamera = true;
        this.type = 'PerspectiveCamera';
        this.fov = fov;
        this.zoom = 1;
        this.near = near;
        this.far = far;
        this.focus = 10;
        this.aspect = aspect;
        this.view = null;
        this.filmGauge = 35; // width of the film (default in millimeters)
        this.filmOffset = 0; // horizontal film offset (same unit as gauge)
        this.updateProjectionMatrix();
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.fov = source.fov;
        this.zoom = source.zoom;
        this.near = source.near;
        this.far = source.far;
        this.focus = source.focus;
        this.aspect = source.aspect;
        this.view = source.view === null ? null : Object.assign({}, source.view);
        this.filmGauge = source.filmGauge;
        this.filmOffset = source.filmOffset;
        return this;
    }
    /**
	 * Sets the FOV by focal length in respect to the current .filmGauge.
	 *
	 * The default film gauge is 35, so that the focal length can be specified for
	 * a 35mm (full frame) camera.
	 *
	 * Values for focal length and film gauge must have the same unit.
	 */ setFocalLength(focalLength) {
        /** see {@link http://www.bobatkins.com/photography/technical/field_of_view.html} */ const vExtentSlope = 0.5 * this.getFilmHeight() / focalLength;
        this.fov = $7f727a3c7059d20d$export$914076c8150813e5 * 2 * Math.atan(vExtentSlope);
        this.updateProjectionMatrix();
    }
    /**
	 * Calculates the focal length from the current .fov and .filmGauge.
	 */ getFocalLength() {
        const vExtentSlope = Math.tan($7f727a3c7059d20d$export$460c4029b1a54a2e * 0.5 * this.fov);
        return 0.5 * this.getFilmHeight() / vExtentSlope;
    }
    getEffectiveFOV() {
        return $7f727a3c7059d20d$export$914076c8150813e5 * 2 * Math.atan(Math.tan($7f727a3c7059d20d$export$460c4029b1a54a2e * 0.5 * this.fov) / this.zoom);
    }
    getFilmWidth() {
        // film not completely covered in portrait format (aspect < 1)
        return this.filmGauge * Math.min(this.aspect, 1);
    }
    getFilmHeight() {
        // film not completely covered in landscape format (aspect > 1)
        return this.filmGauge / Math.max(this.aspect, 1);
    }
    /**
	 * Computes the 2D bounds of the camera's viewable rectangle at a given distance along the viewing direction.
	 * Sets minTarget and maxTarget to the coordinates of the lower-left and upper-right corners of the view rectangle.
	 */ getViewBounds(distance, minTarget, maxTarget) {
        $2791465b256430b4$var$_v3.set(-1, -1, 0.5).applyMatrix4(this.projectionMatrixInverse);
        minTarget.set($2791465b256430b4$var$_v3.x, $2791465b256430b4$var$_v3.y).multiplyScalar(-distance / $2791465b256430b4$var$_v3.z);
        $2791465b256430b4$var$_v3.set(1, 1, 0.5).applyMatrix4(this.projectionMatrixInverse);
        maxTarget.set($2791465b256430b4$var$_v3.x, $2791465b256430b4$var$_v3.y).multiplyScalar(-distance / $2791465b256430b4$var$_v3.z);
    }
    /**
	 * Computes the width and height of the camera's viewable rectangle at a given distance along the viewing direction.
	 * Copies the result into the target Vector2, where x is width and y is height.
	 */ getViewSize(distance, target) {
        this.getViewBounds(distance, $2791465b256430b4$var$_minTarget, $2791465b256430b4$var$_maxTarget);
        return target.subVectors($2791465b256430b4$var$_maxTarget, $2791465b256430b4$var$_minTarget);
    }
    /**
	 * Sets an offset in a larger frustum. This is useful for multi-window or
	 * multi-monitor/multi-machine setups.
	 *
	 * For example, if you have 3x2 monitors and each monitor is 1920x1080 and
	 * the monitors are in grid like this
	 *
	 *   +---+---+---+
	 *   | A | B | C |
	 *   +---+---+---+
	 *   | D | E | F |
	 *   +---+---+---+
	 *
	 * then for each monitor you would call it like this
	 *
	 *   const w = 1920;
	 *   const h = 1080;
	 *   const fullWidth = w * 3;
	 *   const fullHeight = h * 2;
	 *
	 *   --A--
	 *   camera.setViewOffset( fullWidth, fullHeight, w * 0, h * 0, w, h );
	 *   --B--
	 *   camera.setViewOffset( fullWidth, fullHeight, w * 1, h * 0, w, h );
	 *   --C--
	 *   camera.setViewOffset( fullWidth, fullHeight, w * 2, h * 0, w, h );
	 *   --D--
	 *   camera.setViewOffset( fullWidth, fullHeight, w * 0, h * 1, w, h );
	 *   --E--
	 *   camera.setViewOffset( fullWidth, fullHeight, w * 1, h * 1, w, h );
	 *   --F--
	 *   camera.setViewOffset( fullWidth, fullHeight, w * 2, h * 1, w, h );
	 *
	 *   Note there is no reason monitors have to be the same size or in a grid.
	 */ setViewOffset(fullWidth, fullHeight, x, y, width, height) {
        this.aspect = fullWidth / fullHeight;
        if (this.view === null) this.view = {
            enabled: true,
            fullWidth: 1,
            fullHeight: 1,
            offsetX: 0,
            offsetY: 0,
            width: 1,
            height: 1
        };
        this.view.enabled = true;
        this.view.fullWidth = fullWidth;
        this.view.fullHeight = fullHeight;
        this.view.offsetX = x;
        this.view.offsetY = y;
        this.view.width = width;
        this.view.height = height;
        this.updateProjectionMatrix();
    }
    clearViewOffset() {
        if (this.view !== null) this.view.enabled = false;
        this.updateProjectionMatrix();
    }
    updateProjectionMatrix() {
        const near = this.near;
        let top = near * Math.tan($7f727a3c7059d20d$export$460c4029b1a54a2e * 0.5 * this.fov) / this.zoom;
        let height = 2 * top;
        let width = this.aspect * height;
        let left = -0.5 * width;
        const view = this.view;
        if (this.view !== null && this.view.enabled) {
            const fullWidth = view.fullWidth, fullHeight = view.fullHeight;
            left += view.offsetX * width / fullWidth;
            top -= view.offsetY * height / fullHeight;
            width *= view.width / fullWidth;
            height *= view.height / fullHeight;
        }
        const skew = this.filmOffset;
        if (skew !== 0) left += near * skew / this.getFilmWidth();
        this.projectionMatrix.makePerspective(left, left + width, top, top - height, near, this.far, this.coordinateSystem);
        this.projectionMatrixInverse.copy(this.projectionMatrix).invert();
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.object.fov = this.fov;
        data.object.zoom = this.zoom;
        data.object.near = this.near;
        data.object.far = this.far;
        data.object.focus = this.focus;
        data.object.aspect = this.aspect;
        if (this.view !== null) data.object.view = Object.assign({}, this.view);
        data.object.filmGauge = this.filmGauge;
        data.object.filmOffset = this.filmOffset;
        return data;
    }
}


const $5d1fd5ec9d555336$var$fov = -90; // negative fov is not an error
const $5d1fd5ec9d555336$var$aspect = 1;
class $5d1fd5ec9d555336$export$d0cdd0bd804995de extends (0, $2894733dde59bc41$export$e4dd07dff30cc924) {
    constructor(near, far, renderTarget){
        super();
        this.type = 'CubeCamera';
        this.renderTarget = renderTarget;
        this.coordinateSystem = null;
        this.activeMipmapLevel = 0;
        const cameraPX = new (0, $2791465b256430b4$export$74e4ae24825f68d7)($5d1fd5ec9d555336$var$fov, $5d1fd5ec9d555336$var$aspect, near, far);
        cameraPX.layers = this.layers;
        this.add(cameraPX);
        const cameraNX = new (0, $2791465b256430b4$export$74e4ae24825f68d7)($5d1fd5ec9d555336$var$fov, $5d1fd5ec9d555336$var$aspect, near, far);
        cameraNX.layers = this.layers;
        this.add(cameraNX);
        const cameraPY = new (0, $2791465b256430b4$export$74e4ae24825f68d7)($5d1fd5ec9d555336$var$fov, $5d1fd5ec9d555336$var$aspect, near, far);
        cameraPY.layers = this.layers;
        this.add(cameraPY);
        const cameraNY = new (0, $2791465b256430b4$export$74e4ae24825f68d7)($5d1fd5ec9d555336$var$fov, $5d1fd5ec9d555336$var$aspect, near, far);
        cameraNY.layers = this.layers;
        this.add(cameraNY);
        const cameraPZ = new (0, $2791465b256430b4$export$74e4ae24825f68d7)($5d1fd5ec9d555336$var$fov, $5d1fd5ec9d555336$var$aspect, near, far);
        cameraPZ.layers = this.layers;
        this.add(cameraPZ);
        const cameraNZ = new (0, $2791465b256430b4$export$74e4ae24825f68d7)($5d1fd5ec9d555336$var$fov, $5d1fd5ec9d555336$var$aspect, near, far);
        cameraNZ.layers = this.layers;
        this.add(cameraNZ);
    }
    updateCoordinateSystem() {
        const coordinateSystem = this.coordinateSystem;
        const cameras = this.children.concat();
        const [cameraPX, cameraNX, cameraPY, cameraNY, cameraPZ, cameraNZ] = cameras;
        for (const camera of cameras)this.remove(camera);
        if (coordinateSystem === (0, $cb5ee595c0f892af$export$5a0e9190d10875d3)) {
            cameraPX.up.set(0, 1, 0);
            cameraPX.lookAt(1, 0, 0);
            cameraNX.up.set(0, 1, 0);
            cameraNX.lookAt(-1, 0, 0);
            cameraPY.up.set(0, 0, -1);
            cameraPY.lookAt(0, 1, 0);
            cameraNY.up.set(0, 0, 1);
            cameraNY.lookAt(0, -1, 0);
            cameraPZ.up.set(0, 1, 0);
            cameraPZ.lookAt(0, 0, 1);
            cameraNZ.up.set(0, 1, 0);
            cameraNZ.lookAt(0, 0, -1);
        } else if (coordinateSystem === (0, $cb5ee595c0f892af$export$cc83beedcb9be9ac)) {
            cameraPX.up.set(0, -1, 0);
            cameraPX.lookAt(-1, 0, 0);
            cameraNX.up.set(0, -1, 0);
            cameraNX.lookAt(1, 0, 0);
            cameraPY.up.set(0, 0, 1);
            cameraPY.lookAt(0, 1, 0);
            cameraNY.up.set(0, 0, -1);
            cameraNY.lookAt(0, -1, 0);
            cameraPZ.up.set(0, -1, 0);
            cameraPZ.lookAt(0, 0, 1);
            cameraNZ.up.set(0, -1, 0);
            cameraNZ.lookAt(0, 0, -1);
        } else throw new Error('THREE.CubeCamera.updateCoordinateSystem(): Invalid coordinate system: ' + coordinateSystem);
        for (const camera of cameras){
            this.add(camera);
            camera.updateMatrixWorld();
        }
    }
    update(renderer, scene) {
        if (this.parent === null) this.updateMatrixWorld();
        const { renderTarget: renderTarget, activeMipmapLevel: activeMipmapLevel } = this;
        if (this.coordinateSystem !== renderer.coordinateSystem) {
            this.coordinateSystem = renderer.coordinateSystem;
            this.updateCoordinateSystem();
        }
        const [cameraPX, cameraNX, cameraPY, cameraNY, cameraPZ, cameraNZ] = this.children;
        const currentRenderTarget = renderer.getRenderTarget();
        const currentActiveCubeFace = renderer.getActiveCubeFace();
        const currentActiveMipmapLevel = renderer.getActiveMipmapLevel();
        const currentXrEnabled = renderer.xr.enabled;
        renderer.xr.enabled = false;
        const generateMipmaps = renderTarget.texture.generateMipmaps;
        renderTarget.texture.generateMipmaps = false;
        renderer.setRenderTarget(renderTarget, 0, activeMipmapLevel);
        renderer.render(scene, cameraPX);
        renderer.setRenderTarget(renderTarget, 1, activeMipmapLevel);
        renderer.render(scene, cameraNX);
        renderer.setRenderTarget(renderTarget, 2, activeMipmapLevel);
        renderer.render(scene, cameraPY);
        renderer.setRenderTarget(renderTarget, 3, activeMipmapLevel);
        renderer.render(scene, cameraNY);
        renderer.setRenderTarget(renderTarget, 4, activeMipmapLevel);
        renderer.render(scene, cameraPZ);
        // mipmaps are generated during the last call of render()
        // at this point, all sides of the cube render target are defined
        renderTarget.texture.generateMipmaps = generateMipmaps;
        renderer.setRenderTarget(renderTarget, 5, activeMipmapLevel);
        renderer.render(scene, cameraNZ);
        renderer.setRenderTarget(currentRenderTarget, currentActiveCubeFace, currentActiveMipmapLevel);
        renderer.xr.enabled = currentXrEnabled;
        renderTarget.texture.needsPMREMUpdate = true;
    }
}



class $5bcb18f62a281581$export$ac386671d651941e extends (0, $984bc729b8d1028c$export$3c052beb2e51e23f) {
    constructor(size = 1, options = {}){
        super(size, size, options);
        this.isWebGLCubeRenderTarget = true;
        const image = {
            width: size,
            height: size,
            depth: 1
        };
        const images = [
            image,
            image,
            image,
            image,
            image,
            image
        ];
        this.texture = new (0, $0b071408edafdf32$export$ee2e5a18258a4049)(images, options.mapping, options.wrapS, options.wrapT, options.magFilter, options.minFilter, options.format, options.type, options.anisotropy, options.colorSpace);
        // By convention -- likely based on the RenderMan spec from the 1990's -- cube maps are specified by WebGL (and three.js)
        // in a coordinate system in which positive-x is to the right when looking up the positive-z axis -- in other words,
        // in a left-handed coordinate system. By continuing this convention, preexisting cube maps continued to render correctly.
        // three.js uses a right-handed coordinate system. So environment maps used in three.js appear to have px and nx swapped
        // and the flag isRenderTargetTexture controls this conversion. The flip is not required when using WebGLCubeRenderTarget.texture
        // as a cube texture (this is detected when isRenderTargetTexture is set to true for cube textures).
        this.texture.isRenderTargetTexture = true;
        this.texture.generateMipmaps = options.generateMipmaps !== undefined ? options.generateMipmaps : false;
        this.texture.minFilter = options.minFilter !== undefined ? options.minFilter : (0, $cb5ee595c0f892af$export$8a72f490b25c56c8);
    }
    fromEquirectangularTexture(renderer, texture) {
        this.texture.type = texture.type;
        this.texture.colorSpace = texture.colorSpace;
        this.texture.generateMipmaps = texture.generateMipmaps;
        this.texture.minFilter = texture.minFilter;
        this.texture.magFilter = texture.magFilter;
        const shader = {
            uniforms: {
                tEquirect: {
                    value: null
                }
            },
            vertexShader: /* glsl */ `

				varying vec3 vWorldDirection;

				vec3 transformDirection( in vec3 dir, in mat4 matrix ) {

					return normalize( ( matrix * vec4( dir, 0.0 ) ).xyz );

				}

				void main() {

					vWorldDirection = transformDirection( position, modelMatrix );

					#include <begin_vertex>
					#include <project_vertex>

				}
			`,
            fragmentShader: /* glsl */ `

				uniform sampler2D tEquirect;

				varying vec3 vWorldDirection;

				#include <common>

				void main() {

					vec3 direction = normalize( vWorldDirection );

					vec2 sampleUV = equirectUv( direction );

					gl_FragColor = texture2D( tEquirect, sampleUV );

				}
			`
        };
        const geometry = new (0, $24282652b400341e$export$33e43285f7406bd5)(5, 5, 5);
        const material = new (0, $a2aba2f2e3806f54$export$83c7d75d550a8b0d)({
            name: 'CubemapFromEquirect',
            uniforms: (0, $11e070c4b510306e$export$acda854380553452)(shader.uniforms),
            vertexShader: shader.vertexShader,
            fragmentShader: shader.fragmentShader,
            side: (0, $cb5ee595c0f892af$export$d9f0486e75b5ace),
            blending: (0, $cb5ee595c0f892af$export$63b8d6b580fc65ba)
        });
        material.uniforms.tEquirect.value = texture;
        const mesh = new (0, $4fa83874928b8122$export$e176487c05830cc5)(geometry, material);
        const currentMinFilter = texture.minFilter;
        // Avoid blurred poles
        if (texture.minFilter === (0, $cb5ee595c0f892af$export$5d8599b6a933fb1b)) texture.minFilter = (0, $cb5ee595c0f892af$export$8a72f490b25c56c8);
        const camera = new (0, $5d1fd5ec9d555336$export$d0cdd0bd804995de)(1, 10, this);
        camera.update(renderer, mesh);
        texture.minFilter = currentMinFilter;
        mesh.geometry.dispose();
        mesh.material.dispose();
        return this;
    }
    clear(renderer, color, depth, stencil) {
        const currentRenderTarget = renderer.getRenderTarget();
        for(let i = 0; i < 6; i++){
            renderer.setRenderTarget(this, i);
            renderer.clear(color, depth, stencil);
        }
        renderer.setRenderTarget(currentRenderTarget);
    }
}




class $cdfde66d154b1e5c$export$38af1803e3442a7f extends (0, $2894733dde59bc41$export$e4dd07dff30cc924) {
    constructor(){
        super();
        this.isScene = true;
        this.type = 'Scene';
        this.background = null;
        this.environment = null;
        this.fog = null;
        this.backgroundBlurriness = 0;
        this.backgroundIntensity = 1;
        this.backgroundRotation = new (0, $ac384e7663319ba6$export$d93cc409a0768c5f)();
        this.environmentIntensity = 1;
        this.environmentRotation = new (0, $ac384e7663319ba6$export$d93cc409a0768c5f)();
        this.overrideMaterial = null;
        if (typeof __THREE_DEVTOOLS__ !== 'undefined') __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent('observe', {
            detail: this
        }));
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        if (source.background !== null) this.background = source.background.clone();
        if (source.environment !== null) this.environment = source.environment.clone();
        if (source.fog !== null) this.fog = source.fog.clone();
        this.backgroundBlurriness = source.backgroundBlurriness;
        this.backgroundIntensity = source.backgroundIntensity;
        this.backgroundRotation.copy(source.backgroundRotation);
        this.environmentIntensity = source.environmentIntensity;
        this.environmentRotation.copy(source.environmentRotation);
        if (source.overrideMaterial !== null) this.overrideMaterial = source.overrideMaterial.clone();
        this.matrixAutoUpdate = source.matrixAutoUpdate;
        return this;
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        if (this.fog !== null) data.object.fog = this.fog.toJSON();
        if (this.backgroundBlurriness > 0) data.object.backgroundBlurriness = this.backgroundBlurriness;
        if (this.backgroundIntensity !== 1) data.object.backgroundIntensity = this.backgroundIntensity;
        data.object.backgroundRotation = this.backgroundRotation.toArray();
        if (this.environmentIntensity !== 1) data.object.environmentIntensity = this.environmentIntensity;
        data.object.environmentRotation = this.environmentRotation.toArray();
        return data;
    }
}






// @TODO: Consider rename WebGLCubeRenderTarget to just CubeRenderTarget
class $4ca216577e55c34a$var$CubeRenderTarget extends (0, $5bcb18f62a281581$export$ac386671d651941e) {
    constructor(size = 1, options = {}){
        super(size, options);
        this.isCubeRenderTarget = true;
    }
    fromEquirectangularTexture(renderer, texture) {
        const currentMinFilter = texture.minFilter;
        const currentGenerateMipmaps = texture.generateMipmaps;
        texture.generateMipmaps = true;
        this.texture.type = texture.type;
        this.texture.colorSpace = texture.colorSpace;
        this.texture.generateMipmaps = texture.generateMipmaps;
        this.texture.minFilter = texture.minFilter;
        this.texture.magFilter = texture.magFilter;
        const geometry = new (0, $24282652b400341e$export$33e43285f7406bd5)(5, 5, 5);
        const uvNode = (0, $a7ca49051706df79$export$191de21f5bc44b98)((0, $acbec2070ba15851$export$7a5e5a23009fd1a3));
        const material = new (0, $1a485f4d26090da0$export$2e2bcd8739ae039)();
        material.colorNode = (0, $f7d68bbf9ea772a7$export$ab69073b3903a075)(texture, uvNode, 0);
        material.side = (0, $cb5ee595c0f892af$export$d9f0486e75b5ace);
        material.blending = (0, $cb5ee595c0f892af$export$63b8d6b580fc65ba);
        const mesh = new (0, $4fa83874928b8122$export$e176487c05830cc5)(geometry, material);
        const scene = new (0, $cdfde66d154b1e5c$export$38af1803e3442a7f)();
        scene.add(mesh);
        // Avoid blurred poles
        if (texture.minFilter === (0, $cb5ee595c0f892af$export$5d8599b6a933fb1b)) texture.minFilter = (0, $cb5ee595c0f892af$export$8a72f490b25c56c8);
        const camera = new (0, $5d1fd5ec9d555336$export$d0cdd0bd804995de)(1, 10, this);
        const currentMRT = renderer.getMRT();
        renderer.setMRT(null);
        camera.update(renderer, scene);
        renderer.setMRT(currentMRT);
        texture.minFilter = currentMinFilter;
        texture.currentGenerateMipmaps = currentGenerateMipmaps;
        mesh.geometry.dispose();
        mesh.material.dispose();
        return this;
    }
}
var $4ca216577e55c34a$export$2e2bcd8739ae039 = $4ca216577e55c34a$var$CubeRenderTarget;



const $5e9eb535dcfc47a7$var$_cache = new WeakMap();
class $5e9eb535dcfc47a7$var$CubeMapNode extends (0, $75c45ed2361c955f$export$2e2bcd8739ae039) {
    static get type() {
        return 'CubeMapNode';
    }
    constructor(envNode){
        super('vec3');
        this.envNode = envNode;
        this._cubeTexture = null;
        this._cubeTextureNode = (0, $48a97961b9b43631$export$f8948c996a1778e8)();
        const defaultTexture = new (0, $0b071408edafdf32$export$ee2e5a18258a4049)();
        defaultTexture.isRenderTargetTexture = true;
        this._defaultTexture = defaultTexture;
        this.updateBeforeType = (0, $ddcfecb7fbba5d74$export$26f7a8bbd9469530).RENDER;
    }
    updateBefore(frame) {
        const { renderer: renderer, material: material } = frame;
        const envNode = this.envNode;
        if (envNode.isTextureNode || envNode.isMaterialReferenceNode) {
            const texture = envNode.isTextureNode ? envNode.value : material[envNode.property];
            if (texture && texture.isTexture) {
                const mapping = texture.mapping;
                if (mapping === (0, $cb5ee595c0f892af$export$d64030b316d3b087) || mapping === (0, $cb5ee595c0f892af$export$ee99d97d46898098)) {
                    // check for converted cubemap map
                    if ($5e9eb535dcfc47a7$var$_cache.has(texture)) {
                        const cubeMap = $5e9eb535dcfc47a7$var$_cache.get(texture);
                        $5e9eb535dcfc47a7$var$mapTextureMapping(cubeMap, texture.mapping);
                        this._cubeTexture = cubeMap;
                    } else {
                        // create cube map from equirectangular map
                        const image = texture.image;
                        if ($5e9eb535dcfc47a7$var$isEquirectangularMapReady(image)) {
                            const renderTarget = new (0, $4ca216577e55c34a$export$2e2bcd8739ae039)(image.height);
                            renderTarget.fromEquirectangularTexture(renderer, texture);
                            $5e9eb535dcfc47a7$var$mapTextureMapping(renderTarget.texture, texture.mapping);
                            this._cubeTexture = renderTarget.texture;
                            $5e9eb535dcfc47a7$var$_cache.set(texture, renderTarget.texture);
                            texture.addEventListener('dispose', $5e9eb535dcfc47a7$var$onTextureDispose);
                        } else // default cube texture as fallback when equirectangular texture is not yet loaded
                        this._cubeTexture = this._defaultTexture;
                    }
                    //
                    this._cubeTextureNode.value = this._cubeTexture;
                } else // envNode already refers to a cube map
                this._cubeTextureNode = this.envNode;
            }
        }
    }
    setup(builder) {
        this.updateBefore(builder);
        return this._cubeTextureNode;
    }
}
var $5e9eb535dcfc47a7$export$2e2bcd8739ae039 = $5e9eb535dcfc47a7$var$CubeMapNode;
function $5e9eb535dcfc47a7$var$isEquirectangularMapReady(image) {
    if (image === null || image === undefined) return false;
    return image.height > 0;
}
function $5e9eb535dcfc47a7$var$onTextureDispose(event) {
    const texture = event.target;
    texture.removeEventListener('dispose', $5e9eb535dcfc47a7$var$onTextureDispose);
    const renderTarget = $5e9eb535dcfc47a7$var$_cache.get(texture);
    if (renderTarget !== undefined) {
        $5e9eb535dcfc47a7$var$_cache.delete(texture);
        renderTarget.dispose();
    }
}
function $5e9eb535dcfc47a7$var$mapTextureMapping(texture, mapping) {
    if (mapping === (0, $cb5ee595c0f892af$export$d64030b316d3b087)) texture.mapping = (0, $cb5ee595c0f892af$export$8759762a6477f2c4);
    else if (mapping === (0, $cb5ee595c0f892af$export$ee99d97d46898098)) texture.mapping = (0, $cb5ee595c0f892af$export$dc59f8aed047f61d);
}
const $5e9eb535dcfc47a7$export$41fca45bb73dbdd9 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$60d11c6747b7deba)($5e9eb535dcfc47a7$var$CubeMapNode);


// constants








class $e15d7fb89e2d8a53$var$LightingModel {
    start() {}
    finish() {}
    direct() {}
    directRectArea() {}
    indirect() {}
    ambientOcclusion() {}
}
var $e15d7fb89e2d8a53$export$2e2bcd8739ae039 = $e15d7fb89e2d8a53$var$LightingModel;




class $f8605aaa2b9dceda$var$NodeAttribute {
    constructor(name, type, node = null){
        this.isNodeAttribute = true;
        this.name = name;
        this.type = type;
        this.node = node;
    }
}
var $f8605aaa2b9dceda$export$2e2bcd8739ae039 = $f8605aaa2b9dceda$var$NodeAttribute;


class $e7ea5cee0b2b009b$var$NodeUniform {
    constructor(name, type, node){
        this.isNodeUniform = true;
        this.name = name;
        this.type = type;
        this.node = node.getSelf();
    }
    get value() {
        return this.node.value;
    }
    set value(val) {
        this.node.value = val;
    }
    get id() {
        return this.node.id;
    }
    get groupNode() {
        return this.node.groupNode;
    }
}
var $e7ea5cee0b2b009b$export$2e2bcd8739ae039 = $e7ea5cee0b2b009b$var$NodeUniform;



class $9a791041809c4946$var$NodeVar {
    constructor(name, type){
        this.isNodeVar = true;
        this.name = name;
        this.type = type;
    }
}
var $9a791041809c4946$export$2e2bcd8739ae039 = $9a791041809c4946$var$NodeVar;


class $b78e3970291f645b$var$NodeVarying extends (0, $9a791041809c4946$export$2e2bcd8739ae039) {
    constructor(name, type){
        super(name, type);
        this.needsInterpolation = false;
        this.isNodeVarying = true;
    }
}
var $b78e3970291f645b$export$2e2bcd8739ae039 = $b78e3970291f645b$var$NodeVarying;



class $c902812dce9b4122$var$NodeCode {
    constructor(name, type, code = ''){
        this.name = name;
        this.type = type;
        this.code = code;
        Object.defineProperty(this, 'isNodeCode', {
            value: true
        });
    }
}
var $c902812dce9b4122$export$2e2bcd8739ae039 = $c902812dce9b4122$var$NodeCode;


let $d0bbde41f323eaae$var$id = 0;
class $d0bbde41f323eaae$var$NodeCache {
    constructor(parent = null){
        this.id = $d0bbde41f323eaae$var$id++;
        this.nodesData = new WeakMap();
        this.parent = parent;
    }
    getData(node) {
        let data = this.nodesData.get(node);
        if (data === undefined && this.parent !== null) data = this.parent.getData(node);
        return data;
    }
    setData(node, data) {
        this.nodesData.set(node, data);
    }
}
var $d0bbde41f323eaae$export$2e2bcd8739ae039 = $d0bbde41f323eaae$var$NodeCache;












class $3f2962f81e8e5f3b$var$Uniform {
    constructor(name, value){
        this.name = name;
        this.value = value;
        this.boundary = 0; // used to build the uniform buffer according to the STD140 layout
        this.itemSize = 0;
        this.offset = 0; // this property is set by WebGPUUniformsGroup and marks the start position in the uniform buffer
    }
    setValue(value) {
        this.value = value;
    }
    getValue() {
        return this.value;
    }
}
class $3f2962f81e8e5f3b$export$d35bb6c86abac575 extends $3f2962f81e8e5f3b$var$Uniform {
    constructor(name, value = 0){
        super(name, value);
        this.isNumberUniform = true;
        this.boundary = 4;
        this.itemSize = 1;
    }
}
class $3f2962f81e8e5f3b$export$cfbfbe105938fa14 extends $3f2962f81e8e5f3b$var$Uniform {
    constructor(name, value = new (0, $3c03061dea0adea3$export$c977b3e384af9ae1)()){
        super(name, value);
        this.isVector2Uniform = true;
        this.boundary = 8;
        this.itemSize = 2;
    }
}
class $3f2962f81e8e5f3b$export$52c20e8dbc369cad extends $3f2962f81e8e5f3b$var$Uniform {
    constructor(name, value = new (0, $d7d0ac0e47013885$export$64b5c384219d3699)()){
        super(name, value);
        this.isVector3Uniform = true;
        this.boundary = 16;
        this.itemSize = 3;
    }
}
class $3f2962f81e8e5f3b$export$3b613782c258f364 extends $3f2962f81e8e5f3b$var$Uniform {
    constructor(name, value = new (0, $a09a15e9a8421204$export$fa7daccca11cdbe3)()){
        super(name, value);
        this.isVector4Uniform = true;
        this.boundary = 16;
        this.itemSize = 4;
    }
}
class $3f2962f81e8e5f3b$export$ac67f5f3f575305e extends $3f2962f81e8e5f3b$var$Uniform {
    constructor(name, value = new (0, $9a23ce591a1b6760$export$892596cec99bc70e)()){
        super(name, value);
        this.isColorUniform = true;
        this.boundary = 16;
        this.itemSize = 3;
    }
}
class $3f2962f81e8e5f3b$export$771c521f0145cfab extends $3f2962f81e8e5f3b$var$Uniform {
    constructor(name, value = new (0, $800ed18490319df2$export$8ff26dafa08918)()){
        super(name, value);
        this.isMatrix3Uniform = true;
        this.boundary = 48;
        this.itemSize = 12;
    }
}
class $3f2962f81e8e5f3b$export$a952a98a0882ab53 extends $3f2962f81e8e5f3b$var$Uniform {
    constructor(name, value = new (0, $0ea09116adcadf95$export$2ae72fc923e5eb5)()){
        super(name, value);
        this.isMatrix4Uniform = true;
        this.boundary = 64;
        this.itemSize = 16;
    }
}


class $9548c5be945d6e52$export$bd5178af19f9d1e9 extends (0, $3f2962f81e8e5f3b$export$d35bb6c86abac575) {
    constructor(nodeUniform){
        super(nodeUniform.name, nodeUniform.value);
        this.nodeUniform = nodeUniform;
    }
    getValue() {
        return this.nodeUniform.value;
    }
}
class $9548c5be945d6e52$export$3e6626ee055e11ec extends (0, $3f2962f81e8e5f3b$export$cfbfbe105938fa14) {
    constructor(nodeUniform){
        super(nodeUniform.name, nodeUniform.value);
        this.nodeUniform = nodeUniform;
    }
    getValue() {
        return this.nodeUniform.value;
    }
}
class $9548c5be945d6e52$export$222550f4ad161b66 extends (0, $3f2962f81e8e5f3b$export$52c20e8dbc369cad) {
    constructor(nodeUniform){
        super(nodeUniform.name, nodeUniform.value);
        this.nodeUniform = nodeUniform;
    }
    getValue() {
        return this.nodeUniform.value;
    }
}
class $9548c5be945d6e52$export$2f5c35776b379101 extends (0, $3f2962f81e8e5f3b$export$3b613782c258f364) {
    constructor(nodeUniform){
        super(nodeUniform.name, nodeUniform.value);
        this.nodeUniform = nodeUniform;
    }
    getValue() {
        return this.nodeUniform.value;
    }
}
class $9548c5be945d6e52$export$d65b35d185d16645 extends (0, $3f2962f81e8e5f3b$export$ac67f5f3f575305e) {
    constructor(nodeUniform){
        super(nodeUniform.name, nodeUniform.value);
        this.nodeUniform = nodeUniform;
    }
    getValue() {
        return this.nodeUniform.value;
    }
}
class $9548c5be945d6e52$export$e04f01f73e1507d4 extends (0, $3f2962f81e8e5f3b$export$771c521f0145cfab) {
    constructor(nodeUniform){
        super(nodeUniform.name, nodeUniform.value);
        this.nodeUniform = nodeUniform;
    }
    getValue() {
        return this.nodeUniform.value;
    }
}
class $9548c5be945d6e52$export$9df310e837bed706 extends (0, $3f2962f81e8e5f3b$export$a952a98a0882ab53) {
    constructor(nodeUniform){
        super(nodeUniform.name, nodeUniform.value);
        this.nodeUniform = nodeUniform;
    }
    getValue() {
        return this.nodeUniform.value;
    }
}



























const $d83e6ef4006f75c9$var$LOD_MIN = 4;
// The standard deviations (radians) associated with the extra mips. These are
// chosen to approximate a Trowbridge-Reitz distribution function times the
// geometric shadowing function. These sigma values squared must match the
// variance #defines in cube_uv_reflection_fragment.glsl.js.
const $d83e6ef4006f75c9$var$EXTRA_LOD_SIGMA = [
    0.125,
    0.215,
    0.35,
    0.446,
    0.526,
    0.582
];
// The maximum length of the blur for loop. Smaller sigmas will use fewer
// samples and exit early, but not recompile the shader.
const $d83e6ef4006f75c9$var$MAX_SAMPLES = 20;
const $d83e6ef4006f75c9$var$_flatCamera = /*@__PURE__*/ new (0, $e37261468d01aaee$export$9ebf355ee4ed261b)(-1, 1, 1, -1, 0, 1);
const $d83e6ef4006f75c9$var$_cubeCamera = /*@__PURE__*/ new (0, $2791465b256430b4$export$74e4ae24825f68d7)(90, 1);
const $d83e6ef4006f75c9$var$_clearColor = /*@__PURE__*/ new (0, $9a23ce591a1b6760$export$892596cec99bc70e)();
let $d83e6ef4006f75c9$var$_oldTarget = null;
let $d83e6ef4006f75c9$var$_oldActiveCubeFace = 0;
let $d83e6ef4006f75c9$var$_oldActiveMipmapLevel = 0;
// Golden Ratio
const $d83e6ef4006f75c9$var$PHI = (1 + Math.sqrt(5)) / 2;
const $d83e6ef4006f75c9$var$INV_PHI = 1 / $d83e6ef4006f75c9$var$PHI;
// Vertices of a dodecahedron (except the opposites, which represent the
// same axis), used as axis directions evenly spread on a sphere.
const $d83e6ef4006f75c9$var$_axisDirections = [
    /*@__PURE__*/ new (0, $d7d0ac0e47013885$export$64b5c384219d3699)(-$d83e6ef4006f75c9$var$PHI, $d83e6ef4006f75c9$var$INV_PHI, 0),
    /*@__PURE__*/ new (0, $d7d0ac0e47013885$export$64b5c384219d3699)($d83e6ef4006f75c9$var$PHI, $d83e6ef4006f75c9$var$INV_PHI, 0),
    /*@__PURE__*/ new (0, $d7d0ac0e47013885$export$64b5c384219d3699)(-$d83e6ef4006f75c9$var$INV_PHI, 0, $d83e6ef4006f75c9$var$PHI),
    /*@__PURE__*/ new (0, $d7d0ac0e47013885$export$64b5c384219d3699)($d83e6ef4006f75c9$var$INV_PHI, 0, $d83e6ef4006f75c9$var$PHI),
    /*@__PURE__*/ new (0, $d7d0ac0e47013885$export$64b5c384219d3699)(0, $d83e6ef4006f75c9$var$PHI, -$d83e6ef4006f75c9$var$INV_PHI),
    /*@__PURE__*/ new (0, $d7d0ac0e47013885$export$64b5c384219d3699)(0, $d83e6ef4006f75c9$var$PHI, $d83e6ef4006f75c9$var$INV_PHI),
    /*@__PURE__*/ new (0, $d7d0ac0e47013885$export$64b5c384219d3699)(-1, 1, -1),
    /*@__PURE__*/ new (0, $d7d0ac0e47013885$export$64b5c384219d3699)(1, 1, -1),
    /*@__PURE__*/ new (0, $d7d0ac0e47013885$export$64b5c384219d3699)(-1, 1, 1),
    /*@__PURE__*/ new (0, $d7d0ac0e47013885$export$64b5c384219d3699)(1, 1, 1)
];
//
// WebGPU Face indices
const $d83e6ef4006f75c9$var$_faceLib = [
    3,
    1,
    5,
    0,
    4,
    2
];
const $d83e6ef4006f75c9$var$direction = (0, $7d521f89dcf0f8b8$export$fcce7887255d1c69)((0, $382a32bd765f3827$export$c774ebbac59e31d3)(), (0, $700a78a0d988d216$export$af4b9a83f4b00434)('faceIndex')).normalize();
const $d83e6ef4006f75c9$var$outputDirection = (0, $d5b7ee61758b2e81$export$9100789c9d999364)($d83e6ef4006f75c9$var$direction.x, $d83e6ef4006f75c9$var$direction.y.negate(), $d83e6ef4006f75c9$var$direction.z);
/**
 * This class generates a Prefiltered, Mipmapped Radiance Environment Map
 * (PMREM) from a cubeMap environment texture. This allows different levels of
 * blur to be quickly accessed based on material roughness. It is packed into a
 * special CubeUV format that allows us to perform custom interpolation so that
 * we can support nonlinear formats such as RGBE. Unlike a traditional mipmap
 * chain, it only goes down to the LOD_MIN level (above), and then creates extra
 * even more filtered 'mips' at the same LOD_MIN resolution, associated with
 * higher roughness levels. In this way we maintain resolution to smoothly
 * interpolate diffuse lighting while limiting sampling computation.
 *
 * Paper: Fast, Accurate Image-Based Lighting
 * https://drive.google.com/file/d/15y8r_UpKlU9SvV4ILb0C3qCPecS8pvLz/view
*/ class $d83e6ef4006f75c9$var$PMREMGenerator {
    constructor(renderer){
        this._renderer = renderer;
        this._pingPongRenderTarget = null;
        this._lodMax = 0;
        this._cubeSize = 0;
        this._lodPlanes = [];
        this._sizeLods = [];
        this._sigmas = [];
        this._lodMeshes = [];
        this._blurMaterial = null;
        this._cubemapMaterial = null;
        this._equirectMaterial = null;
        this._backgroundBox = null;
    }
    /**
	 * Generates a PMREM from a supplied Scene, which can be faster than using an
	 * image if networking bandwidth is low. Optional sigma specifies a blur radius
	 * in radians to be applied to the scene before PMREM generation. Optional near
	 * and far planes ensure the scene is rendered in its entirety (the cubeCamera
	 * is placed at the origin).
	 */ fromScene(scene, sigma = 0, near = 0.1, far = 100) {
        $d83e6ef4006f75c9$var$_oldTarget = this._renderer.getRenderTarget();
        $d83e6ef4006f75c9$var$_oldActiveCubeFace = this._renderer.getActiveCubeFace();
        $d83e6ef4006f75c9$var$_oldActiveMipmapLevel = this._renderer.getActiveMipmapLevel();
        this._setSize(256);
        const cubeUVRenderTarget = this._allocateTargets();
        cubeUVRenderTarget.depthBuffer = true;
        this._sceneToCubeUV(scene, near, far, cubeUVRenderTarget);
        if (sigma > 0) this._blur(cubeUVRenderTarget, 0, 0, sigma);
        this._applyPMREM(cubeUVRenderTarget);
        this._cleanup(cubeUVRenderTarget);
        return cubeUVRenderTarget;
    }
    /**
	 * Generates a PMREM from an equirectangular texture, which can be either LDR
	 * or HDR. The ideal input image size is 1k (1024 x 512),
	 * as this matches best with the 256 x 256 cubemap output.
	 */ fromEquirectangular(equirectangular, renderTarget = null) {
        return this._fromTexture(equirectangular, renderTarget);
    }
    /**
	 * Generates a PMREM from an cubemap texture, which can be either LDR
	 * or HDR. The ideal input cube size is 256 x 256,
	 * as this matches best with the 256 x 256 cubemap output.
	 */ fromCubemap(cubemap, renderTarget = null) {
        return this._fromTexture(cubemap, renderTarget);
    }
    /**
	 * Pre-compiles the cubemap shader. You can get faster start-up by invoking this method during
	 * your texture's network fetch for increased concurrency.
	 */ async compileCubemapShader() {
        if (this._cubemapMaterial === null) {
            this._cubemapMaterial = $d83e6ef4006f75c9$var$_getCubemapMaterial();
            await this._compileMaterial(this._cubemapMaterial);
        }
    }
    /**
	 * Pre-compiles the equirectangular shader. You can get faster start-up by invoking this method during
	 * your texture's network fetch for increased concurrency.
	 */ async compileEquirectangularShader() {
        if (this._equirectMaterial === null) {
            this._equirectMaterial = $d83e6ef4006f75c9$var$_getEquirectMaterial();
            await this._compileMaterial(this._equirectMaterial);
        }
    }
    /**
	 * Disposes of the PMREMGenerator's internal memory. Note that PMREMGenerator is a static class,
	 * so you should not need more than one PMREMGenerator object. If you do, calling dispose() on
	 * one of them will cause any others to also become unusable.
	 */ dispose() {
        this._dispose();
        if (this._cubemapMaterial !== null) this._cubemapMaterial.dispose();
        if (this._equirectMaterial !== null) this._equirectMaterial.dispose();
        if (this._backgroundBox !== null) {
            this._backgroundBox.geometry.dispose();
            this._backgroundBox.material.dispose();
        }
    }
    // private interface
    _setSize(cubeSize) {
        this._lodMax = Math.floor(Math.log2(cubeSize));
        this._cubeSize = Math.pow(2, this._lodMax);
    }
    _dispose() {
        if (this._blurMaterial !== null) this._blurMaterial.dispose();
        if (this._pingPongRenderTarget !== null) this._pingPongRenderTarget.dispose();
        for(let i = 0; i < this._lodPlanes.length; i++)this._lodPlanes[i].dispose();
    }
    _cleanup(outputTarget) {
        this._renderer.setRenderTarget($d83e6ef4006f75c9$var$_oldTarget, $d83e6ef4006f75c9$var$_oldActiveCubeFace, $d83e6ef4006f75c9$var$_oldActiveMipmapLevel);
        outputTarget.scissorTest = false;
        $d83e6ef4006f75c9$var$_setViewport(outputTarget, 0, 0, outputTarget.width, outputTarget.height);
    }
    _fromTexture(texture, renderTarget) {
        if (texture.mapping === (0, $cb5ee595c0f892af$export$8759762a6477f2c4) || texture.mapping === (0, $cb5ee595c0f892af$export$dc59f8aed047f61d)) this._setSize(texture.image.length === 0 ? 16 : texture.image[0].width || texture.image[0].image.width);
        else this._setSize(texture.image.width / 4);
        $d83e6ef4006f75c9$var$_oldTarget = this._renderer.getRenderTarget();
        $d83e6ef4006f75c9$var$_oldActiveCubeFace = this._renderer.getActiveCubeFace();
        $d83e6ef4006f75c9$var$_oldActiveMipmapLevel = this._renderer.getActiveMipmapLevel();
        const cubeUVRenderTarget = renderTarget || this._allocateTargets();
        this._textureToCubeUV(texture, cubeUVRenderTarget);
        this._applyPMREM(cubeUVRenderTarget);
        this._cleanup(cubeUVRenderTarget);
        return cubeUVRenderTarget;
    }
    _allocateTargets() {
        const width = 3 * Math.max(this._cubeSize, 112);
        const height = 4 * this._cubeSize;
        const params = {
            magFilter: (0, $cb5ee595c0f892af$export$8a72f490b25c56c8),
            minFilter: (0, $cb5ee595c0f892af$export$8a72f490b25c56c8),
            generateMipmaps: false,
            type: (0, $cb5ee595c0f892af$export$2697304443f382bc),
            format: (0, $cb5ee595c0f892af$export$3f8bb04b555a363c),
            colorSpace: (0, $cb5ee595c0f892af$export$42429b3acfb233a4)
        };
        const cubeUVRenderTarget = $d83e6ef4006f75c9$var$_createRenderTarget(width, height, params);
        if (this._pingPongRenderTarget === null || this._pingPongRenderTarget.width !== width || this._pingPongRenderTarget.height !== height) {
            if (this._pingPongRenderTarget !== null) this._dispose();
            this._pingPongRenderTarget = $d83e6ef4006f75c9$var$_createRenderTarget(width, height, params);
            const { _lodMax: _lodMax } = this;
            ({ sizeLods: this._sizeLods, lodPlanes: this._lodPlanes, sigmas: this._sigmas, lodMeshes: this._lodMeshes } = $d83e6ef4006f75c9$var$_createPlanes(_lodMax));
            this._blurMaterial = $d83e6ef4006f75c9$var$_getBlurShader(_lodMax, width, height);
        }
        return cubeUVRenderTarget;
    }
    async _compileMaterial(material) {
        const tmpMesh = new (0, $4fa83874928b8122$export$e176487c05830cc5)(this._lodPlanes[0], material);
        await this._renderer.compile(tmpMesh, $d83e6ef4006f75c9$var$_flatCamera);
    }
    _sceneToCubeUV(scene, near, far, cubeUVRenderTarget) {
        const cubeCamera = $d83e6ef4006f75c9$var$_cubeCamera;
        cubeCamera.near = near;
        cubeCamera.far = far;
        // px, py, pz, nx, ny, nz
        const upSign = [
            -1,
            1,
            -1,
            -1,
            -1,
            -1
        ];
        const forwardSign = [
            1,
            1,
            1,
            -1,
            -1,
            -1
        ];
        const renderer = this._renderer;
        const originalAutoClear = renderer.autoClear;
        renderer.getClearColor($d83e6ef4006f75c9$var$_clearColor);
        renderer.autoClear = false;
        let backgroundBox = this._backgroundBox;
        if (backgroundBox === null) {
            const backgroundMaterial = new (0, $30428884caacd4ad$export$55cbcc9b622fe1f5)({
                name: 'PMREM.Background',
                side: (0, $cb5ee595c0f892af$export$d9f0486e75b5ace),
                depthWrite: false,
                depthTest: false
            });
            backgroundBox = new (0, $4fa83874928b8122$export$e176487c05830cc5)(new (0, $24282652b400341e$export$33e43285f7406bd5)(), backgroundMaterial);
        }
        let useSolidColor = false;
        const background = scene.background;
        if (background) {
            if (background.isColor) {
                backgroundBox.material.color.copy(background);
                scene.background = null;
                useSolidColor = true;
            }
        } else {
            backgroundBox.material.color.copy($d83e6ef4006f75c9$var$_clearColor);
            useSolidColor = true;
        }
        renderer.setRenderTarget(cubeUVRenderTarget);
        renderer.clear();
        if (useSolidColor) renderer.render(backgroundBox, cubeCamera);
        for(let i = 0; i < 6; i++){
            const col = i % 3;
            if (col === 0) {
                cubeCamera.up.set(0, upSign[i], 0);
                cubeCamera.lookAt(forwardSign[i], 0, 0);
            } else if (col === 1) {
                cubeCamera.up.set(0, 0, upSign[i]);
                cubeCamera.lookAt(0, forwardSign[i], 0);
            } else {
                cubeCamera.up.set(0, upSign[i], 0);
                cubeCamera.lookAt(0, 0, forwardSign[i]);
            }
            const size = this._cubeSize;
            $d83e6ef4006f75c9$var$_setViewport(cubeUVRenderTarget, col * size, i > 2 ? size : 0, size, size);
            renderer.render(scene, cubeCamera);
        }
        renderer.autoClear = originalAutoClear;
        scene.background = background;
    }
    _textureToCubeUV(texture, cubeUVRenderTarget) {
        const renderer = this._renderer;
        const isCubeTexture = texture.mapping === (0, $cb5ee595c0f892af$export$8759762a6477f2c4) || texture.mapping === (0, $cb5ee595c0f892af$export$dc59f8aed047f61d);
        if (isCubeTexture) {
            if (this._cubemapMaterial === null) this._cubemapMaterial = $d83e6ef4006f75c9$var$_getCubemapMaterial(texture);
        } else if (this._equirectMaterial === null) this._equirectMaterial = $d83e6ef4006f75c9$var$_getEquirectMaterial(texture);
        const material = isCubeTexture ? this._cubemapMaterial : this._equirectMaterial;
        material.fragmentNode.value = texture;
        const mesh = this._lodMeshes[0];
        mesh.material = material;
        const size = this._cubeSize;
        $d83e6ef4006f75c9$var$_setViewport(cubeUVRenderTarget, 0, 0, 3 * size, 2 * size);
        renderer.setRenderTarget(cubeUVRenderTarget);
        renderer.render(mesh, $d83e6ef4006f75c9$var$_flatCamera);
    }
    _applyPMREM(cubeUVRenderTarget) {
        const renderer = this._renderer;
        const autoClear = renderer.autoClear;
        renderer.autoClear = false;
        const n = this._lodPlanes.length;
        for(let i = 1; i < n; i++){
            const sigma = Math.sqrt(this._sigmas[i] * this._sigmas[i] - this._sigmas[i - 1] * this._sigmas[i - 1]);
            const poleAxis = $d83e6ef4006f75c9$var$_axisDirections[(n - i - 1) % $d83e6ef4006f75c9$var$_axisDirections.length];
            this._blur(cubeUVRenderTarget, i - 1, i, sigma, poleAxis);
        }
        renderer.autoClear = autoClear;
    }
    /**
	 * This is a two-pass Gaussian blur for a cubemap. Normally this is done
	 * vertically and horizontally, but this breaks down on a cube. Here we apply
	 * the blur latitudinally (around the poles), and then longitudinally (towards
	 * the poles) to approximate the orthogonally-separable blur. It is least
	 * accurate at the poles, but still does a decent job.
	 */ _blur(cubeUVRenderTarget, lodIn, lodOut, sigma, poleAxis) {
        const pingPongRenderTarget = this._pingPongRenderTarget;
        this._halfBlur(cubeUVRenderTarget, pingPongRenderTarget, lodIn, lodOut, sigma, 'latitudinal', poleAxis);
        this._halfBlur(pingPongRenderTarget, cubeUVRenderTarget, lodOut, lodOut, sigma, 'longitudinal', poleAxis);
    }
    _halfBlur(targetIn, targetOut, lodIn, lodOut, sigmaRadians, direction, poleAxis) {
        const renderer = this._renderer;
        const blurMaterial = this._blurMaterial;
        if (direction !== 'latitudinal' && direction !== 'longitudinal') console.error('blur direction must be either latitudinal or longitudinal!');
        // Number of standard deviations at which to cut off the discrete approximation.
        const STANDARD_DEVIATIONS = 3;
        const blurMesh = this._lodMeshes[lodOut];
        blurMesh.material = blurMaterial;
        const blurUniforms = blurMaterial.uniforms;
        const pixels = this._sizeLods[lodIn] - 1;
        const radiansPerPixel = isFinite(sigmaRadians) ? Math.PI / (2 * pixels) : 2 * Math.PI / (2 * $d83e6ef4006f75c9$var$MAX_SAMPLES - 1);
        const sigmaPixels = sigmaRadians / radiansPerPixel;
        const samples = isFinite(sigmaRadians) ? 1 + Math.floor(STANDARD_DEVIATIONS * sigmaPixels) : $d83e6ef4006f75c9$var$MAX_SAMPLES;
        if (samples > $d83e6ef4006f75c9$var$MAX_SAMPLES) console.warn(`sigmaRadians, ${sigmaRadians}, is too large and will clip, as it requested ${samples} samples when the maximum is set to ${$d83e6ef4006f75c9$var$MAX_SAMPLES}`);
        const weights = [];
        let sum = 0;
        for(let i = 0; i < $d83e6ef4006f75c9$var$MAX_SAMPLES; ++i){
            const x = i / sigmaPixels;
            const weight = Math.exp(-x * x / 2);
            weights.push(weight);
            if (i === 0) sum += weight;
            else if (i < samples) sum += 2 * weight;
        }
        for(let i = 0; i < weights.length; i++)weights[i] = weights[i] / sum;
        targetIn.texture.frame = (targetIn.texture.frame || 0) + 1;
        blurUniforms.envMap.value = targetIn.texture;
        blurUniforms.samples.value = samples;
        blurUniforms.weights.array = weights;
        blurUniforms.latitudinal.value = direction === 'latitudinal' ? 1 : 0;
        if (poleAxis) blurUniforms.poleAxis.value = poleAxis;
        const { _lodMax: _lodMax } = this;
        blurUniforms.dTheta.value = radiansPerPixel;
        blurUniforms.mipInt.value = _lodMax - lodIn;
        const outputSize = this._sizeLods[lodOut];
        const x = 3 * outputSize * (lodOut > _lodMax - $d83e6ef4006f75c9$var$LOD_MIN ? lodOut - _lodMax + $d83e6ef4006f75c9$var$LOD_MIN : 0);
        const y = 4 * (this._cubeSize - outputSize);
        $d83e6ef4006f75c9$var$_setViewport(targetOut, x, y, 3 * outputSize, 2 * outputSize);
        renderer.setRenderTarget(targetOut);
        renderer.render(blurMesh, $d83e6ef4006f75c9$var$_flatCamera);
    }
}
function $d83e6ef4006f75c9$var$_createPlanes(lodMax) {
    const lodPlanes = [];
    const sizeLods = [];
    const sigmas = [];
    const lodMeshes = [];
    let lod = lodMax;
    const totalLods = lodMax - $d83e6ef4006f75c9$var$LOD_MIN + 1 + $d83e6ef4006f75c9$var$EXTRA_LOD_SIGMA.length;
    for(let i = 0; i < totalLods; i++){
        const sizeLod = Math.pow(2, lod);
        sizeLods.push(sizeLod);
        let sigma = 1.0 / sizeLod;
        if (i > lodMax - $d83e6ef4006f75c9$var$LOD_MIN) sigma = $d83e6ef4006f75c9$var$EXTRA_LOD_SIGMA[i - lodMax + $d83e6ef4006f75c9$var$LOD_MIN - 1];
        else if (i === 0) sigma = 0;
        sigmas.push(sigma);
        const texelSize = 1.0 / (sizeLod - 2);
        const min = -texelSize;
        const max = 1 + texelSize;
        const uv1 = [
            min,
            min,
            max,
            min,
            max,
            max,
            min,
            min,
            max,
            max,
            min,
            max
        ];
        const cubeFaces = 6;
        const vertices = 6;
        const positionSize = 3;
        const uvSize = 2;
        const faceIndexSize = 1;
        const position = new Float32Array(positionSize * vertices * cubeFaces);
        const uv = new Float32Array(uvSize * vertices * cubeFaces);
        const faceIndex = new Float32Array(faceIndexSize * vertices * cubeFaces);
        for(let face = 0; face < cubeFaces; face++){
            const x = face % 3 * 2 / 3 - 1;
            const y = face > 2 ? 0 : -1;
            const coordinates = [
                x,
                y,
                0,
                x + 2 / 3,
                y,
                0,
                x + 2 / 3,
                y + 1,
                0,
                x,
                y,
                0,
                x + 2 / 3,
                y + 1,
                0,
                x,
                y + 1,
                0
            ];
            const faceIdx = $d83e6ef4006f75c9$var$_faceLib[face];
            position.set(coordinates, positionSize * vertices * faceIdx);
            uv.set(uv1, uvSize * vertices * faceIdx);
            const fill = [
                faceIdx,
                faceIdx,
                faceIdx,
                faceIdx,
                faceIdx,
                faceIdx
            ];
            faceIndex.set(fill, faceIndexSize * vertices * faceIdx);
        }
        const planes = new (0, $b7aea261c5c9a899$export$b7be63a67df8959)();
        planes.setAttribute('position', new (0, $4b03383e684869fb$export$8dea267bd6bde117)(position, positionSize));
        planes.setAttribute('uv', new (0, $4b03383e684869fb$export$8dea267bd6bde117)(uv, uvSize));
        planes.setAttribute('faceIndex', new (0, $4b03383e684869fb$export$8dea267bd6bde117)(faceIndex, faceIndexSize));
        lodPlanes.push(planes);
        lodMeshes.push(new (0, $4fa83874928b8122$export$e176487c05830cc5)(planes, null));
        if (lod > $d83e6ef4006f75c9$var$LOD_MIN) lod--;
    }
    return {
        lodPlanes: lodPlanes,
        sizeLods: sizeLods,
        sigmas: sigmas,
        lodMeshes: lodMeshes
    };
}
function $d83e6ef4006f75c9$var$_createRenderTarget(width, height, params) {
    const cubeUVRenderTarget = new (0, $2ca03eab531e649d$export$efcb1f8bf367cbfb)(width, height, params);
    cubeUVRenderTarget.texture.mapping = (0, $cb5ee595c0f892af$export$dbf3e70ff37af79);
    cubeUVRenderTarget.texture.name = 'PMREM.cubeUv';
    cubeUVRenderTarget.texture.isPMREMTexture = true;
    cubeUVRenderTarget.scissorTest = true;
    return cubeUVRenderTarget;
}
function $d83e6ef4006f75c9$var$_setViewport(target, x, y, width, height) {
    target.viewport.set(x, y, width, height);
    target.scissor.set(x, y, width, height);
}
function $d83e6ef4006f75c9$var$_getMaterial(type) {
    const material = new (0, $1a485f4d26090da0$export$2e2bcd8739ae039)();
    material.depthTest = false;
    material.depthWrite = false;
    material.blending = (0, $cb5ee595c0f892af$export$63b8d6b580fc65ba);
    material.name = `PMREM_${type}`;
    return material;
}
function $d83e6ef4006f75c9$var$_getBlurShader(lodMax, width, height) {
    const weights = (0, $dc98837c0c62767d$export$9b734ab82c2f4fe3)(new Array($d83e6ef4006f75c9$var$MAX_SAMPLES).fill(0));
    const poleAxis = (0, $5eb92bf12e57daab$export$379455b567eff87d)(new (0, $d7d0ac0e47013885$export$64b5c384219d3699)(0, 1, 0));
    const dTheta = (0, $5eb92bf12e57daab$export$379455b567eff87d)(0);
    const n = (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)($d83e6ef4006f75c9$var$MAX_SAMPLES);
    const latitudinal = (0, $5eb92bf12e57daab$export$379455b567eff87d)(0); // false, bool
    const samples = (0, $5eb92bf12e57daab$export$379455b567eff87d)(1); // int
    const envMap = (0, $f7d68bbf9ea772a7$export$ab69073b3903a075)(null);
    const mipInt = (0, $5eb92bf12e57daab$export$379455b567eff87d)(0); // int
    const CUBEUV_TEXEL_WIDTH = (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(1 / width);
    const CUBEUV_TEXEL_HEIGHT = (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(1 / height);
    const CUBEUV_MAX_MIP = (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(lodMax);
    const materialUniforms = {
        n: n,
        latitudinal: latitudinal,
        weights: weights,
        poleAxis: poleAxis,
        outputDirection: $d83e6ef4006f75c9$var$outputDirection,
        dTheta: dTheta,
        samples: samples,
        envMap: envMap,
        mipInt: mipInt,
        CUBEUV_TEXEL_WIDTH: CUBEUV_TEXEL_WIDTH,
        CUBEUV_TEXEL_HEIGHT: CUBEUV_TEXEL_HEIGHT,
        CUBEUV_MAX_MIP: CUBEUV_MAX_MIP
    };
    const material = $d83e6ef4006f75c9$var$_getMaterial('blur');
    material.uniforms = materialUniforms; // TODO: Move to outside of the material
    material.fragmentNode = (0, $7d521f89dcf0f8b8$export$2cc7ff91bcacba5e)({
        ...materialUniforms,
        latitudinal: latitudinal.equal(1)
    });
    return material;
}
function $d83e6ef4006f75c9$var$_getCubemapMaterial(envTexture) {
    const material = $d83e6ef4006f75c9$var$_getMaterial('cubemap');
    material.fragmentNode = (0, $48a97961b9b43631$export$f8948c996a1778e8)(envTexture, $d83e6ef4006f75c9$var$outputDirection);
    return material;
}
function $d83e6ef4006f75c9$var$_getEquirectMaterial(envTexture) {
    const material = $d83e6ef4006f75c9$var$_getMaterial('equirect');
    material.fragmentNode = (0, $f7d68bbf9ea772a7$export$ab69073b3903a075)(envTexture, (0, $a7ca49051706df79$export$191de21f5bc44b98)($d83e6ef4006f75c9$var$outputDirection), 0);
    return material;
}
var $d83e6ef4006f75c9$export$2e2bcd8739ae039 = $d83e6ef4006f75c9$var$PMREMGenerator;










const $3ac2b0a498e221c7$var$rendererCache = new WeakMap();
const $3ac2b0a498e221c7$var$typeFromLength = new Map([
    [
        2,
        'vec2'
    ],
    [
        3,
        'vec3'
    ],
    [
        4,
        'vec4'
    ],
    [
        9,
        'mat3'
    ],
    [
        16,
        'mat4'
    ]
]);
const $3ac2b0a498e221c7$var$typeFromArray = new Map([
    [
        Int8Array,
        'int'
    ],
    [
        Int16Array,
        'int'
    ],
    [
        Int32Array,
        'int'
    ],
    [
        Uint8Array,
        'uint'
    ],
    [
        Uint16Array,
        'uint'
    ],
    [
        Uint32Array,
        'uint'
    ],
    [
        Float32Array,
        'float'
    ]
]);
const $3ac2b0a498e221c7$var$toFloat = (value)=>{
    if (/e/g.test(value)) return String(value).replace(/\+/g, '');
    else {
        value = Number(value);
        return value + (value % 1 ? '' : '.0');
    }
};
class $3ac2b0a498e221c7$var$NodeBuilder {
    constructor(object, renderer, parser){
        this.object = object;
        this.material = object && object.material || null;
        this.geometry = object && object.geometry || null;
        this.renderer = renderer;
        this.parser = parser;
        this.scene = null;
        this.camera = null;
        this.nodes = [];
        this.sequentialNodes = [];
        this.updateNodes = [];
        this.updateBeforeNodes = [];
        this.updateAfterNodes = [];
        this.hashNodes = {};
        this.monitor = null;
        this.lightsNode = null;
        this.environmentNode = null;
        this.fogNode = null;
        this.clippingContext = null;
        this.vertexShader = null;
        this.fragmentShader = null;
        this.computeShader = null;
        this.flowNodes = {
            vertex: [],
            fragment: [],
            compute: []
        };
        this.flowCode = {
            vertex: '',
            fragment: '',
            compute: ''
        };
        this.uniforms = {
            vertex: [],
            fragment: [],
            compute: [],
            index: 0
        };
        this.structs = {
            vertex: [],
            fragment: [],
            compute: [],
            index: 0
        };
        this.bindings = {
            vertex: {},
            fragment: {},
            compute: {}
        };
        this.bindingsIndexes = {};
        this.bindGroups = null;
        this.attributes = [];
        this.bufferAttributes = [];
        this.varyings = [];
        this.codes = {};
        this.vars = {};
        this.flow = {
            code: ''
        };
        this.chaining = [];
        this.stack = (0, $e40519046ea5c491$export$a57ab32f40f83ea9)();
        this.stacks = [];
        this.tab = '\t';
        this.currentFunctionNode = null;
        this.context = {
            material: this.material
        };
        this.cache = new (0, $d0bbde41f323eaae$export$2e2bcd8739ae039)();
        this.globalCache = this.cache;
        this.flowsData = new WeakMap();
        this.shaderStage = null;
        this.buildStage = null;
        this.useComparisonMethod = false;
    }
    getBindGroupsCache() {
        let bindGroupsCache = $3ac2b0a498e221c7$var$rendererCache.get(this.renderer);
        if (bindGroupsCache === undefined) {
            bindGroupsCache = new (0, $aa043456f1edde49$export$2e2bcd8739ae039)();
            $3ac2b0a498e221c7$var$rendererCache.set(this.renderer, bindGroupsCache);
        }
        return bindGroupsCache;
    }
    createRenderTarget(width, height, options) {
        return new (0, $2ca03eab531e649d$export$efcb1f8bf367cbfb)(width, height, options);
    }
    createCubeRenderTarget(size, options) {
        return new (0, $4ca216577e55c34a$export$2e2bcd8739ae039)(size, options);
    }
    createPMREMGenerator() {
        // TODO: Move Materials.js to outside of the Nodes.js in order to remove this function and improve tree-shaking support
        return new (0, $d83e6ef4006f75c9$export$2e2bcd8739ae039)(this.renderer);
    }
    includes(node) {
        return this.nodes.includes(node);
    }
    _getBindGroup(groupName, bindings) {
        const bindGroupsCache = this.getBindGroupsCache();
        //
        const bindingsArray = [];
        let sharedGroup = true;
        for (const binding of bindings){
            bindingsArray.push(binding);
            sharedGroup = sharedGroup && binding.groupNode.shared !== true;
        }
        //
        let bindGroup;
        if (sharedGroup) {
            bindGroup = bindGroupsCache.get(bindingsArray);
            if (bindGroup === undefined) {
                bindGroup = new (0, $3779080013be9f66$export$2e2bcd8739ae039)(groupName, bindingsArray, this.bindingsIndexes[groupName].group, bindingsArray);
                bindGroupsCache.set(bindingsArray, bindGroup);
            }
        } else bindGroup = new (0, $3779080013be9f66$export$2e2bcd8739ae039)(groupName, bindingsArray, this.bindingsIndexes[groupName].group, bindingsArray);
        return bindGroup;
    }
    getBindGroupArray(groupName, shaderStage) {
        const bindings = this.bindings[shaderStage];
        let bindGroup = bindings[groupName];
        if (bindGroup === undefined) {
            if (this.bindingsIndexes[groupName] === undefined) this.bindingsIndexes[groupName] = {
                binding: 0,
                group: Object.keys(this.bindingsIndexes).length
            };
            bindings[groupName] = bindGroup = [];
        }
        return bindGroup;
    }
    getBindings() {
        let bindingsGroups = this.bindGroups;
        if (bindingsGroups === null) {
            const groups = {};
            const bindings = this.bindings;
            for (const shaderStage of (0, $ddcfecb7fbba5d74$export$48fd793f0255b86a))for(const groupName in bindings[shaderStage]){
                const uniforms = bindings[shaderStage][groupName];
                const groupUniforms = groups[groupName] || (groups[groupName] = []);
                groupUniforms.push(...uniforms);
            }
            bindingsGroups = [];
            for(const groupName in groups){
                const group = groups[groupName];
                const bindingsGroup = this._getBindGroup(groupName, group);
                bindingsGroups.push(bindingsGroup);
            }
            this.bindGroups = bindingsGroups;
        }
        return bindingsGroups;
    }
    sortBindingGroups() {
        const bindingsGroups = this.getBindings();
        bindingsGroups.sort((a, b)=>a.bindings[0].groupNode.order - b.bindings[0].groupNode.order);
        for(let i = 0; i < bindingsGroups.length; i++){
            const bindingGroup = bindingsGroups[i];
            this.bindingsIndexes[bindingGroup.name].group = i;
            bindingGroup.index = i;
        }
    }
    setHashNode(node, hash) {
        this.hashNodes[hash] = node;
    }
    addNode(node) {
        if (this.nodes.includes(node) === false) {
            this.nodes.push(node);
            this.setHashNode(node, node.getHash(this));
        }
    }
    addSequentialNode(node) {
        if (this.sequentialNodes.includes(node) === false) this.sequentialNodes.push(node);
    }
    buildUpdateNodes() {
        for (const node of this.nodes){
            const updateType = node.getUpdateType();
            if (updateType !== (0, $ddcfecb7fbba5d74$export$26f7a8bbd9469530).NONE) this.updateNodes.push(node.getSelf());
        }
        for (const node of this.sequentialNodes){
            const updateBeforeType = node.getUpdateBeforeType();
            const updateAfterType = node.getUpdateAfterType();
            if (updateBeforeType !== (0, $ddcfecb7fbba5d74$export$26f7a8bbd9469530).NONE) this.updateBeforeNodes.push(node.getSelf());
            if (updateAfterType !== (0, $ddcfecb7fbba5d74$export$26f7a8bbd9469530).NONE) this.updateAfterNodes.push(node.getSelf());
        }
    }
    get currentNode() {
        return this.chaining[this.chaining.length - 1];
    }
    isFilteredTexture(texture) {
        return texture.magFilter === (0, $cb5ee595c0f892af$export$8a72f490b25c56c8) || texture.magFilter === (0, $cb5ee595c0f892af$export$19a719f377145a13) || texture.magFilter === (0, $cb5ee595c0f892af$export$d2327c1afe5bfdf2) || texture.magFilter === (0, $cb5ee595c0f892af$export$5d8599b6a933fb1b) || texture.minFilter === (0, $cb5ee595c0f892af$export$8a72f490b25c56c8) || texture.minFilter === (0, $cb5ee595c0f892af$export$19a719f377145a13) || texture.minFilter === (0, $cb5ee595c0f892af$export$d2327c1afe5bfdf2) || texture.minFilter === (0, $cb5ee595c0f892af$export$5d8599b6a933fb1b);
    }
    addChain(node) {
        /*
		if ( this.chaining.indexOf( node ) !== - 1 ) {

			console.warn( 'Recursive node: ', node );

		}
		*/ this.chaining.push(node);
    }
    removeChain(node) {
        const lastChain = this.chaining.pop();
        if (lastChain !== node) throw new Error('NodeBuilder: Invalid node chaining!');
    }
    getMethod(method) {
        return method;
    }
    getNodeFromHash(hash) {
        return this.hashNodes[hash];
    }
    addFlow(shaderStage, node) {
        this.flowNodes[shaderStage].push(node);
        return node;
    }
    setContext(context) {
        this.context = context;
    }
    getContext() {
        return this.context;
    }
    getSharedContext() {
        const context = {
            ...this.context
        };
        delete context.material;
        return this.context;
    }
    setCache(cache) {
        this.cache = cache;
    }
    getCache() {
        return this.cache;
    }
    getCacheFromNode(node, parent = true) {
        const data = this.getDataFromNode(node);
        if (data.cache === undefined) data.cache = new (0, $d0bbde41f323eaae$export$2e2bcd8739ae039)(parent ? this.getCache() : null);
        return data.cache;
    }
    isAvailable() {
        return false;
    }
    getVertexIndex() {
        console.warn('Abstract function.');
    }
    getInstanceIndex() {
        console.warn('Abstract function.');
    }
    getDrawIndex() {
        console.warn('Abstract function.');
    }
    getFrontFacing() {
        console.warn('Abstract function.');
    }
    getFragCoord() {
        console.warn('Abstract function.');
    }
    isFlipY() {
        return false;
    }
    increaseUsage(node) {
        const nodeData = this.getDataFromNode(node);
        nodeData.usageCount = nodeData.usageCount === undefined ? 1 : nodeData.usageCount + 1;
        return nodeData.usageCount;
    }
    generateTexture() {
        console.warn('Abstract function.');
    }
    generateTextureLod() {
        console.warn('Abstract function.');
    }
    generateConst(type, value = null) {
        if (value === null) {
            if (type === 'float' || type === 'int' || type === 'uint') value = 0;
            else if (type === 'bool') value = false;
            else if (type === 'color') value = new (0, $9a23ce591a1b6760$export$892596cec99bc70e)();
            else if (type === 'vec2') value = new (0, $3c03061dea0adea3$export$c977b3e384af9ae1)();
            else if (type === 'vec3') value = new (0, $d7d0ac0e47013885$export$64b5c384219d3699)();
            else if (type === 'vec4') value = new (0, $a09a15e9a8421204$export$fa7daccca11cdbe3)();
        }
        if (type === 'float') return $3ac2b0a498e221c7$var$toFloat(value);
        if (type === 'int') return `${Math.round(value)}`;
        if (type === 'uint') return value >= 0 ? `${Math.round(value)}u` : '0u';
        if (type === 'bool') return value ? 'true' : 'false';
        if (type === 'color') return `${this.getType('vec3')}( ${$3ac2b0a498e221c7$var$toFloat(value.r)}, ${$3ac2b0a498e221c7$var$toFloat(value.g)}, ${$3ac2b0a498e221c7$var$toFloat(value.b)} )`;
        const typeLength = this.getTypeLength(type);
        const componentType = this.getComponentType(type);
        const generateConst = (value)=>this.generateConst(componentType, value);
        if (typeLength === 2) return `${this.getType(type)}( ${generateConst(value.x)}, ${generateConst(value.y)} )`;
        else if (typeLength === 3) return `${this.getType(type)}( ${generateConst(value.x)}, ${generateConst(value.y)}, ${generateConst(value.z)} )`;
        else if (typeLength === 4) return `${this.getType(type)}( ${generateConst(value.x)}, ${generateConst(value.y)}, ${generateConst(value.z)}, ${generateConst(value.w)} )`;
        else if (typeLength > 4 && value && (value.isMatrix3 || value.isMatrix4)) return `${this.getType(type)}( ${value.elements.map(generateConst).join(', ')} )`;
        else if (typeLength > 4) return `${this.getType(type)}()`;
        throw new Error(`NodeBuilder: Type '${type}' not found in generate constant attempt.`);
    }
    getType(type) {
        if (type === 'color') return 'vec3';
        return type;
    }
    hasGeometryAttribute(name) {
        return this.geometry && this.geometry.getAttribute(name) !== undefined;
    }
    getAttribute(name, type) {
        const attributes = this.attributes;
        // find attribute
        for (const attribute of attributes){
            if (attribute.name === name) return attribute;
        }
        // create a new if no exist
        const attribute = new (0, $f8605aaa2b9dceda$export$2e2bcd8739ae039)(name, type);
        attributes.push(attribute);
        return attribute;
    }
    getPropertyName(node /*, shaderStage*/ ) {
        return node.name;
    }
    isVector(type) {
        return /vec\d/.test(type);
    }
    isMatrix(type) {
        return /mat\d/.test(type);
    }
    isReference(type) {
        return type === 'void' || type === 'property' || type === 'sampler' || type === 'texture' || type === 'cubeTexture' || type === 'storageTexture' || type === 'depthTexture' || type === 'texture3D';
    }
    needsToWorkingColorSpace() {
        return false;
    }
    getComponentTypeFromTexture(texture) {
        const type = texture.type;
        if (texture.isDataTexture) {
            if (type === (0, $cb5ee595c0f892af$export$5c612977753abe2)) return 'int';
            if (type === (0, $cb5ee595c0f892af$export$c3c7fc4518ebba96)) return 'uint';
        }
        return 'float';
    }
    getElementType(type) {
        if (type === 'mat2') return 'vec2';
        if (type === 'mat3') return 'vec3';
        if (type === 'mat4') return 'vec4';
        return this.getComponentType(type);
    }
    getComponentType(type) {
        type = this.getVectorType(type);
        if (type === 'float' || type === 'bool' || type === 'int' || type === 'uint') return type;
        const componentType = /(b|i|u|)(vec|mat)([2-4])/.exec(type);
        if (componentType === null) return null;
        if (componentType[1] === 'b') return 'bool';
        if (componentType[1] === 'i') return 'int';
        if (componentType[1] === 'u') return 'uint';
        return 'float';
    }
    getVectorType(type) {
        if (type === 'color') return 'vec3';
        if (type === 'texture' || type === 'cubeTexture' || type === 'storageTexture' || type === 'texture3D') return 'vec4';
        return type;
    }
    getTypeFromLength(length, componentType = 'float') {
        if (length === 1) return componentType;
        const baseType = $3ac2b0a498e221c7$var$typeFromLength.get(length);
        const prefix = componentType === 'float' ? '' : componentType[0];
        return prefix + baseType;
    }
    getTypeFromArray(array) {
        return $3ac2b0a498e221c7$var$typeFromArray.get(array.constructor);
    }
    getTypeFromAttribute(attribute) {
        let dataAttribute = attribute;
        if (attribute.isInterleavedBufferAttribute) dataAttribute = attribute.data;
        const array = dataAttribute.array;
        const itemSize = attribute.itemSize;
        const normalized = attribute.normalized;
        let arrayType;
        if (!(attribute instanceof (0, $4b03383e684869fb$export$dbd3698c64958d69)) && normalized !== true) arrayType = this.getTypeFromArray(array);
        return this.getTypeFromLength(itemSize, arrayType);
    }
    getTypeLength(type) {
        const vecType = this.getVectorType(type);
        const vecNum = /vec([2-4])/.exec(vecType);
        if (vecNum !== null) return Number(vecNum[1]);
        if (vecType === 'float' || vecType === 'bool' || vecType === 'int' || vecType === 'uint') return 1;
        if (/mat2/.test(type) === true) return 4;
        if (/mat3/.test(type) === true) return 9;
        if (/mat4/.test(type) === true) return 16;
        return 0;
    }
    getVectorFromMatrix(type) {
        return type.replace('mat', 'vec');
    }
    changeComponentType(type, newComponentType) {
        return this.getTypeFromLength(this.getTypeLength(type), newComponentType);
    }
    getIntegerType(type) {
        const componentType = this.getComponentType(type);
        if (componentType === 'int' || componentType === 'uint') return type;
        return this.changeComponentType(type, 'int');
    }
    addStack() {
        this.stack = (0, $e40519046ea5c491$export$a57ab32f40f83ea9)(this.stack);
        this.stacks.push((0, $d5b7ee61758b2e81$export$c3090653b26dfebd)() || this.stack);
        (0, $d5b7ee61758b2e81$export$50a78b1c198bcc62)(this.stack);
        return this.stack;
    }
    removeStack() {
        const lastStack = this.stack;
        this.stack = lastStack.parent;
        (0, $d5b7ee61758b2e81$export$50a78b1c198bcc62)(this.stacks.pop());
        return lastStack;
    }
    getDataFromNode(node, shaderStage = this.shaderStage, cache = null) {
        cache = cache === null ? node.isGlobal(this) ? this.globalCache : this.cache : cache;
        let nodeData = cache.getData(node);
        if (nodeData === undefined) {
            nodeData = {};
            cache.setData(node, nodeData);
        }
        if (nodeData[shaderStage] === undefined) nodeData[shaderStage] = {};
        return nodeData[shaderStage];
    }
    getNodeProperties(node, shaderStage = 'any') {
        const nodeData = this.getDataFromNode(node, shaderStage);
        return nodeData.properties || (nodeData.properties = {
            outputNode: null
        });
    }
    getBufferAttributeFromNode(node, type) {
        const nodeData = this.getDataFromNode(node);
        let bufferAttribute = nodeData.bufferAttribute;
        if (bufferAttribute === undefined) {
            const index = this.uniforms.index++;
            bufferAttribute = new (0, $f8605aaa2b9dceda$export$2e2bcd8739ae039)('nodeAttribute' + index, type, node);
            this.bufferAttributes.push(bufferAttribute);
            nodeData.bufferAttribute = bufferAttribute;
        }
        return bufferAttribute;
    }
    getStructTypeFromNode(node, shaderStage = this.shaderStage) {
        const nodeData = this.getDataFromNode(node, shaderStage);
        if (nodeData.structType === undefined) {
            const index = this.structs.index++;
            node.name = `StructType${index}`;
            this.structs[shaderStage].push(node);
            nodeData.structType = node;
        }
        return node;
    }
    getUniformFromNode(node, type, shaderStage = this.shaderStage, name = null) {
        const nodeData = this.getDataFromNode(node, shaderStage, this.globalCache);
        let nodeUniform = nodeData.uniform;
        if (nodeUniform === undefined) {
            const index = this.uniforms.index++;
            nodeUniform = new (0, $e7ea5cee0b2b009b$export$2e2bcd8739ae039)(name || 'nodeUniform' + index, type, node);
            this.uniforms[shaderStage].push(nodeUniform);
            nodeData.uniform = nodeUniform;
        }
        return nodeUniform;
    }
    getVarFromNode(node, name = null, type = node.getNodeType(this), shaderStage = this.shaderStage) {
        const nodeData = this.getDataFromNode(node, shaderStage);
        let nodeVar = nodeData.variable;
        if (nodeVar === undefined) {
            const vars = this.vars[shaderStage] || (this.vars[shaderStage] = []);
            if (name === null) name = 'nodeVar' + vars.length;
            nodeVar = new (0, $9a791041809c4946$export$2e2bcd8739ae039)(name, type);
            vars.push(nodeVar);
            nodeData.variable = nodeVar;
        }
        return nodeVar;
    }
    getVaryingFromNode(node, name = null, type = node.getNodeType(this)) {
        const nodeData = this.getDataFromNode(node, 'any');
        let nodeVarying = nodeData.varying;
        if (nodeVarying === undefined) {
            const varyings = this.varyings;
            const index = varyings.length;
            if (name === null) name = 'nodeVarying' + index;
            nodeVarying = new (0, $b78e3970291f645b$export$2e2bcd8739ae039)(name, type);
            varyings.push(nodeVarying);
            nodeData.varying = nodeVarying;
        }
        return nodeVarying;
    }
    getCodeFromNode(node, type, shaderStage = this.shaderStage) {
        const nodeData = this.getDataFromNode(node);
        let nodeCode = nodeData.code;
        if (nodeCode === undefined) {
            const codes = this.codes[shaderStage] || (this.codes[shaderStage] = []);
            const index = codes.length;
            nodeCode = new (0, $c902812dce9b4122$export$2e2bcd8739ae039)('nodeCode' + index, type);
            codes.push(nodeCode);
            nodeData.code = nodeCode;
        }
        return nodeCode;
    }
    addFlowCodeHierarchy(node, nodeBlock) {
        const { flowCodes: flowCodes, flowCodeBlock: flowCodeBlock } = this.getDataFromNode(node);
        let needsFlowCode = true;
        let nodeBlockHierarchy = nodeBlock;
        while(nodeBlockHierarchy){
            if (flowCodeBlock.get(nodeBlockHierarchy) === true) {
                needsFlowCode = false;
                break;
            }
            nodeBlockHierarchy = this.getDataFromNode(nodeBlockHierarchy).parentNodeBlock;
        }
        if (needsFlowCode) for (const flowCode of flowCodes)this.addLineFlowCode(flowCode);
    }
    addLineFlowCodeBlock(node, code, nodeBlock) {
        const nodeData = this.getDataFromNode(node);
        const flowCodes = nodeData.flowCodes || (nodeData.flowCodes = []);
        const codeBlock = nodeData.flowCodeBlock || (nodeData.flowCodeBlock = new WeakMap());
        flowCodes.push(code);
        codeBlock.set(nodeBlock, true);
    }
    addLineFlowCode(code, node = null) {
        if (code === '') return this;
        if (node !== null && this.context.nodeBlock) this.addLineFlowCodeBlock(node, code, this.context.nodeBlock);
        code = this.tab + code;
        if (!/;\s*$/.test(code)) code = code + ';\n';
        this.flow.code += code;
        return this;
    }
    addFlowCode(code) {
        this.flow.code += code;
        return this;
    }
    addFlowTab() {
        this.tab += '\t';
        return this;
    }
    removeFlowTab() {
        this.tab = this.tab.slice(0, -1);
        return this;
    }
    getFlowData(node /*, shaderStage*/ ) {
        return this.flowsData.get(node);
    }
    flowNode(node) {
        const output = node.getNodeType(this);
        const flowData = this.flowChildNode(node, output);
        this.flowsData.set(node, flowData);
        return flowData;
    }
    buildFunctionNode(shaderNode) {
        const fn = new (0, $df3d32ffc049420e$export$2e2bcd8739ae039)();
        const previous = this.currentFunctionNode;
        this.currentFunctionNode = fn;
        fn.code = this.buildFunctionCode(shaderNode);
        this.currentFunctionNode = previous;
        return fn;
    }
    flowShaderNode(shaderNode) {
        const layout = shaderNode.layout;
        const inputs = {
            [Symbol.iterator] () {
                let index = 0;
                const values = Object.values(this);
                return {
                    next: ()=>({
                            value: values[index],
                            done: index++ >= values.length
                        })
                };
            }
        };
        for (const input of layout.inputs)inputs[input.name] = new (0, $87623609ceb778b2$export$2e2bcd8739ae039)(input.type, input.name);
        //
        shaderNode.layout = null;
        const callNode = shaderNode.call(inputs);
        const flowData = this.flowStagesNode(callNode, layout.type);
        shaderNode.layout = layout;
        return flowData;
    }
    flowStagesNode(node, output = null) {
        const previousFlow = this.flow;
        const previousVars = this.vars;
        const previousCache = this.cache;
        const previousBuildStage = this.buildStage;
        const previousStack = this.stack;
        const flow = {
            code: ''
        };
        this.flow = flow;
        this.vars = {};
        this.cache = new (0, $d0bbde41f323eaae$export$2e2bcd8739ae039)();
        this.stack = (0, $e40519046ea5c491$export$a57ab32f40f83ea9)();
        for (const buildStage of (0, $ddcfecb7fbba5d74$export$f2213ed98eb895d6)){
            this.setBuildStage(buildStage);
            flow.result = node.build(this, output);
        }
        flow.vars = this.getVars(this.shaderStage);
        this.flow = previousFlow;
        this.vars = previousVars;
        this.cache = previousCache;
        this.stack = previousStack;
        this.setBuildStage(previousBuildStage);
        return flow;
    }
    getFunctionOperator() {
        return null;
    }
    flowChildNode(node, output = null) {
        const previousFlow = this.flow;
        const flow = {
            code: ''
        };
        this.flow = flow;
        flow.result = node.build(this, output);
        this.flow = previousFlow;
        return flow;
    }
    flowNodeFromShaderStage(shaderStage, node, output = null, propertyName = null) {
        const previousShaderStage = this.shaderStage;
        this.setShaderStage(shaderStage);
        const flowData = this.flowChildNode(node, output);
        if (propertyName !== null) flowData.code += `${this.tab + propertyName} = ${flowData.result};\n`;
        this.flowCode[shaderStage] = this.flowCode[shaderStage] + flowData.code;
        this.setShaderStage(previousShaderStage);
        return flowData;
    }
    getAttributesArray() {
        return this.attributes.concat(this.bufferAttributes);
    }
    getAttributes() {
        console.warn('Abstract function.');
    }
    getVaryings() {
        console.warn('Abstract function.');
    }
    getVar(type, name) {
        return `${this.getType(type)} ${name}`;
    }
    getVars(shaderStage) {
        let snippet = '';
        const vars = this.vars[shaderStage];
        if (vars !== undefined) for (const variable of vars)snippet += `${this.getVar(variable.type, variable.name)}; `;
        return snippet;
    }
    getUniforms() {
        console.warn('Abstract function.');
    }
    getCodes(shaderStage) {
        const codes = this.codes[shaderStage];
        let code = '';
        if (codes !== undefined) for (const nodeCode of codes)code += nodeCode.code + '\n';
        return code;
    }
    getHash() {
        return this.vertexShader + this.fragmentShader + this.computeShader;
    }
    setShaderStage(shaderStage) {
        this.shaderStage = shaderStage;
    }
    getShaderStage() {
        return this.shaderStage;
    }
    setBuildStage(buildStage) {
        this.buildStage = buildStage;
    }
    getBuildStage() {
        return this.buildStage;
    }
    buildCode() {
        console.warn('Abstract function.');
    }
    build() {
        const { object: object, material: material, renderer: renderer } = this;
        if (material !== null) {
            let nodeMaterial = renderer.library.fromMaterial(material);
            if (nodeMaterial === null) {
                console.error(`NodeMaterial: Material "${material.type}" is not compatible.`);
                nodeMaterial = new (0, $1a485f4d26090da0$export$2e2bcd8739ae039)();
            }
            nodeMaterial.build(this);
        } else this.addFlow('compute', object);
        // setup() -> stage 1: create possible new nodes and returns an output reference node
        // analyze()   -> stage 2: analyze nodes to possible optimization and validation
        // generate()  -> stage 3: generate shader
        for (const buildStage of (0, $ddcfecb7fbba5d74$export$f2213ed98eb895d6)){
            this.setBuildStage(buildStage);
            if (this.context.vertex && this.context.vertex.isNode) this.flowNodeFromShaderStage('vertex', this.context.vertex);
            for (const shaderStage of (0, $ddcfecb7fbba5d74$export$48fd793f0255b86a)){
                this.setShaderStage(shaderStage);
                const flowNodes = this.flowNodes[shaderStage];
                for (const node of flowNodes)if (buildStage === 'generate') this.flowNode(node);
                else node.build(this);
            }
        }
        this.setBuildStage(null);
        this.setShaderStage(null);
        // stage 4: build code for a specific output
        this.buildCode();
        this.buildUpdateNodes();
        return this;
    }
    getNodeUniform(uniformNode, type) {
        if (type === 'float' || type === 'int' || type === 'uint') return new (0, $9548c5be945d6e52$export$bd5178af19f9d1e9)(uniformNode);
        if (type === 'vec2' || type === 'ivec2' || type === 'uvec2') return new (0, $9548c5be945d6e52$export$3e6626ee055e11ec)(uniformNode);
        if (type === 'vec3' || type === 'ivec3' || type === 'uvec3') return new (0, $9548c5be945d6e52$export$222550f4ad161b66)(uniformNode);
        if (type === 'vec4' || type === 'ivec4' || type === 'uvec4') return new (0, $9548c5be945d6e52$export$2f5c35776b379101)(uniformNode);
        if (type === 'color') return new (0, $9548c5be945d6e52$export$d65b35d185d16645)(uniformNode);
        if (type === 'mat3') return new (0, $9548c5be945d6e52$export$e04f01f73e1507d4)(uniformNode);
        if (type === 'mat4') return new (0, $9548c5be945d6e52$export$9df310e837bed706)(uniformNode);
        throw new Error(`Uniform "${type}" not declared.`);
    }
    createNodeMaterial(type = 'NodeMaterial') {
        throw new Error(`THREE.NodeBuilder: createNodeMaterial() was deprecated. Use new ${type}() instead.`);
    }
    format(snippet, fromType, toType) {
        fromType = this.getVectorType(fromType);
        toType = this.getVectorType(toType);
        if (fromType === toType || toType === null || this.isReference(toType)) return snippet;
        const fromTypeLength = this.getTypeLength(fromType);
        const toTypeLength = this.getTypeLength(toType);
        if (fromTypeLength === 16 && toTypeLength === 9) return `${this.getType(toType)}(${snippet}[0].xyz, ${snippet}[1].xyz, ${snippet}[2].xyz)`;
        if (fromTypeLength === 9 && toTypeLength === 4) return `${this.getType(toType)}(${snippet}[0].xy, ${snippet}[1].xy)`;
        if (fromTypeLength > 4) // @TODO: ignore for now
        return snippet;
        if (toTypeLength > 4 || toTypeLength === 0) // @TODO: ignore for now
        return snippet;
        if (fromTypeLength === toTypeLength) return `${this.getType(toType)}( ${snippet} )`;
        if (fromTypeLength > toTypeLength) return this.format(`${snippet}.${'xyz'.slice(0, toTypeLength)}`, this.getTypeFromLength(toTypeLength, this.getComponentType(fromType)), toType);
        if (toTypeLength === 4 && fromTypeLength > 1) return `${this.getType(toType)}( ${this.format(snippet, fromType, 'vec3')}, 1.0 )`;
        if (fromTypeLength === 2) return `${this.getType(toType)}( ${this.format(snippet, fromType, 'vec2')}, 0.0 )`;
        if (fromTypeLength === 1 && toTypeLength > 1 && fromType !== this.getComponentType(toType)) // convert a number value to vector type, e.g:
        // vec3( 1u ) -> vec3( float( 1u ) )
        snippet = `${this.getType(this.getComponentType(toType))}( ${snippet} )`;
        return `${this.getType(toType)}( ${snippet} )`; // fromType is float-like
    }
    getSignature() {
        return `// Three.js r${0, $cb5ee595c0f892af$export$3545e07a80636437} - Node System\n`;
    }
}
var $3ac2b0a498e221c7$export$2e2bcd8739ae039 = $3ac2b0a498e221c7$var$NodeBuilder;





class $9e468f77ddf08edf$var$NodeFrame {
    constructor(){
        this.time = 0;
        this.deltaTime = 0;
        this.frameId = 0;
        this.renderId = 0;
        this.startTime = null;
        this.updateMap = new WeakMap();
        this.updateBeforeMap = new WeakMap();
        this.updateAfterMap = new WeakMap();
        this.renderer = null;
        this.material = null;
        this.camera = null;
        this.object = null;
        this.scene = null;
    }
    _getMaps(referenceMap, nodeRef) {
        let maps = referenceMap.get(nodeRef);
        if (maps === undefined) {
            maps = {
                renderMap: new WeakMap(),
                frameMap: new WeakMap()
            };
            referenceMap.set(nodeRef, maps);
        }
        return maps;
    }
    updateBeforeNode(node) {
        const updateType = node.getUpdateBeforeType();
        const reference = node.updateReference(this);
        if (updateType === (0, $ddcfecb7fbba5d74$export$26f7a8bbd9469530).FRAME) {
            const { frameMap: frameMap } = this._getMaps(this.updateBeforeMap, reference);
            if (frameMap.get(reference) !== this.frameId) {
                if (node.updateBefore(this) !== false) frameMap.set(reference, this.frameId);
            }
        } else if (updateType === (0, $ddcfecb7fbba5d74$export$26f7a8bbd9469530).RENDER) {
            const { renderMap: renderMap } = this._getMaps(this.updateBeforeMap, reference);
            if (renderMap.get(reference) !== this.renderId) {
                if (node.updateBefore(this) !== false) renderMap.set(reference, this.renderId);
            }
        } else if (updateType === (0, $ddcfecb7fbba5d74$export$26f7a8bbd9469530).OBJECT) node.updateBefore(this);
    }
    updateAfterNode(node) {
        const updateType = node.getUpdateAfterType();
        const reference = node.updateReference(this);
        if (updateType === (0, $ddcfecb7fbba5d74$export$26f7a8bbd9469530).FRAME) {
            const { frameMap: frameMap } = this._getMaps(this.updateAfterMap, reference);
            if (frameMap.get(reference) !== this.frameId) {
                if (node.updateAfter(this) !== false) frameMap.set(reference, this.frameId);
            }
        } else if (updateType === (0, $ddcfecb7fbba5d74$export$26f7a8bbd9469530).RENDER) {
            const { renderMap: renderMap } = this._getMaps(this.updateAfterMap, reference);
            if (renderMap.get(reference) !== this.renderId) {
                if (node.updateAfter(this) !== false) renderMap.set(reference, this.renderId);
            }
        } else if (updateType === (0, $ddcfecb7fbba5d74$export$26f7a8bbd9469530).OBJECT) node.updateAfter(this);
    }
    updateNode(node) {
        const updateType = node.getUpdateType();
        const reference = node.updateReference(this);
        if (updateType === (0, $ddcfecb7fbba5d74$export$26f7a8bbd9469530).FRAME) {
            const { frameMap: frameMap } = this._getMaps(this.updateMap, reference);
            if (frameMap.get(reference) !== this.frameId) {
                if (node.update(this) !== false) frameMap.set(reference, this.frameId);
            }
        } else if (updateType === (0, $ddcfecb7fbba5d74$export$26f7a8bbd9469530).RENDER) {
            const { renderMap: renderMap } = this._getMaps(this.updateMap, reference);
            if (renderMap.get(reference) !== this.renderId) {
                if (node.update(this) !== false) renderMap.set(reference, this.renderId);
            }
        } else if (updateType === (0, $ddcfecb7fbba5d74$export$26f7a8bbd9469530).OBJECT) node.update(this);
    }
    update() {
        this.frameId++;
        if (this.lastTime === undefined) this.lastTime = performance.now();
        this.deltaTime = (performance.now() - this.lastTime) / 1000;
        this.lastTime = performance.now();
        this.time += this.deltaTime;
    }
}
var $9e468f77ddf08edf$export$2e2bcd8739ae039 = $9e468f77ddf08edf$var$NodeFrame;


class $e7717ae23c68650f$var$NodeFunctionInput {
    constructor(type, name, count = null, qualifier = '', isConst = false){
        this.type = type;
        this.name = name;
        this.count = count;
        this.qualifier = qualifier;
        this.isConst = isConst;
    }
}
$e7717ae23c68650f$var$NodeFunctionInput.isNodeFunctionInput = true;
var $e7717ae23c68650f$export$2e2bcd8739ae039 = $e7717ae23c68650f$var$NodeFunctionInput;




















































































class $e01c01fe8e4607c2$var$DirectionalLightNode extends (0, $c5fe32a85e7ab0bc$export$2e2bcd8739ae039) {
    static get type() {
        return 'DirectionalLightNode';
    }
    constructor(light = null){
        super(light);
    }
    setup(builder) {
        super.setup(builder);
        const lightingModel = builder.context.lightingModel;
        const lightColor = this.colorNode;
        const lightDirection = (0, $979f6f830d64a743$export$bee642e950dff992)(this.light);
        const reflectedLight = builder.context.reflectedLight;
        lightingModel.direct({
            lightDirection: lightDirection,
            lightColor: lightColor,
            reflectedLight: reflectedLight
        }, builder.stack, builder);
    }
}
var $e01c01fe8e4607c2$export$2e2bcd8739ae039 = $e01c01fe8e4607c2$var$DirectionalLightNode;










const $f6bd949db7c614c5$var$_matrix41 = /*@__PURE__*/ new (0, $0ea09116adcadf95$export$2ae72fc923e5eb5)();
const $f6bd949db7c614c5$var$_matrix42 = /*@__PURE__*/ new (0, $0ea09116adcadf95$export$2ae72fc923e5eb5)();
let $f6bd949db7c614c5$var$ltcLib = null;
class $f6bd949db7c614c5$var$RectAreaLightNode extends (0, $c5fe32a85e7ab0bc$export$2e2bcd8739ae039) {
    static get type() {
        return 'RectAreaLightNode';
    }
    constructor(light = null){
        super(light);
        this.halfHeight = (0, $5eb92bf12e57daab$export$379455b567eff87d)(new (0, $d7d0ac0e47013885$export$64b5c384219d3699)()).setGroup((0, $d2c0f7c752a63c18$export$a75a8692b47c7f9e));
        this.halfWidth = (0, $5eb92bf12e57daab$export$379455b567eff87d)(new (0, $d7d0ac0e47013885$export$64b5c384219d3699)()).setGroup((0, $d2c0f7c752a63c18$export$a75a8692b47c7f9e));
        this.updateType = (0, $ddcfecb7fbba5d74$export$26f7a8bbd9469530).RENDER;
    }
    update(frame) {
        super.update(frame);
        const { light: light } = this;
        const viewMatrix = frame.camera.matrixWorldInverse;
        $f6bd949db7c614c5$var$_matrix42.identity();
        $f6bd949db7c614c5$var$_matrix41.copy(light.matrixWorld);
        $f6bd949db7c614c5$var$_matrix41.premultiply(viewMatrix);
        $f6bd949db7c614c5$var$_matrix42.extractRotation($f6bd949db7c614c5$var$_matrix41);
        this.halfWidth.value.set(light.width * 0.5, 0.0, 0.0);
        this.halfHeight.value.set(0.0, light.height * 0.5, 0.0);
        this.halfWidth.value.applyMatrix4($f6bd949db7c614c5$var$_matrix42);
        this.halfHeight.value.applyMatrix4($f6bd949db7c614c5$var$_matrix42);
    }
    setup(builder) {
        super.setup(builder);
        let ltc_1, ltc_2;
        if (builder.isAvailable('float32Filterable')) {
            ltc_1 = (0, $f7d68bbf9ea772a7$export$ab69073b3903a075)($f6bd949db7c614c5$var$ltcLib.LTC_FLOAT_1);
            ltc_2 = (0, $f7d68bbf9ea772a7$export$ab69073b3903a075)($f6bd949db7c614c5$var$ltcLib.LTC_FLOAT_2);
        } else {
            ltc_1 = (0, $f7d68bbf9ea772a7$export$ab69073b3903a075)($f6bd949db7c614c5$var$ltcLib.LTC_HALF_1);
            ltc_2 = (0, $f7d68bbf9ea772a7$export$ab69073b3903a075)($f6bd949db7c614c5$var$ltcLib.LTC_HALF_2);
        }
        const { colorNode: colorNode, light: light } = this;
        const lightingModel = builder.context.lightingModel;
        const lightPosition = (0, $979f6f830d64a743$export$f9728da392bd8249)(light);
        const reflectedLight = builder.context.reflectedLight;
        lightingModel.directRectArea({
            lightColor: colorNode,
            lightPosition: lightPosition,
            halfWidth: this.halfWidth,
            halfHeight: this.halfHeight,
            reflectedLight: reflectedLight,
            ltc_1: ltc_1,
            ltc_2: ltc_2
        }, builder.stack, builder);
    }
    static setLTC(ltc) {
        $f6bd949db7c614c5$var$ltcLib = ltc;
    }
}
var $f6bd949db7c614c5$export$2e2bcd8739ae039 = $f6bd949db7c614c5$var$RectAreaLightNode;









class $b516406311089938$var$SpotLightNode extends (0, $c5fe32a85e7ab0bc$export$2e2bcd8739ae039) {
    static get type() {
        return 'SpotLightNode';
    }
    constructor(light = null){
        super(light);
        this.coneCosNode = (0, $5eb92bf12e57daab$export$379455b567eff87d)(0).setGroup((0, $d2c0f7c752a63c18$export$a75a8692b47c7f9e));
        this.penumbraCosNode = (0, $5eb92bf12e57daab$export$379455b567eff87d)(0).setGroup((0, $d2c0f7c752a63c18$export$a75a8692b47c7f9e));
        this.cutoffDistanceNode = (0, $5eb92bf12e57daab$export$379455b567eff87d)(0).setGroup((0, $d2c0f7c752a63c18$export$a75a8692b47c7f9e));
        this.decayExponentNode = (0, $5eb92bf12e57daab$export$379455b567eff87d)(0).setGroup((0, $d2c0f7c752a63c18$export$a75a8692b47c7f9e));
    }
    update(frame) {
        super.update(frame);
        const { light: light } = this;
        this.coneCosNode.value = Math.cos(light.angle);
        this.penumbraCosNode.value = Math.cos(light.angle * (1 - light.penumbra));
        this.cutoffDistanceNode.value = light.distance;
        this.decayExponentNode.value = light.decay;
    }
    getSpotAttenuation(angleCosine) {
        const { coneCosNode: coneCosNode, penumbraCosNode: penumbraCosNode } = this;
        return (0, $f37ae0e58866c183$export$4053e36566dd3d9a)(coneCosNode, penumbraCosNode, angleCosine);
    }
    setup(builder) {
        super.setup(builder);
        const lightingModel = builder.context.lightingModel;
        const { colorNode: colorNode, cutoffDistanceNode: cutoffDistanceNode, decayExponentNode: decayExponentNode, light: light } = this;
        const lVector = (0, $979f6f830d64a743$export$f9728da392bd8249)(light).sub((0, $acbec2070ba15851$export$3dfd735ebeac9bfd)); // @TODO: Add it into LightNode
        const lightDirection = lVector.normalize();
        const angleCos = lightDirection.dot((0, $979f6f830d64a743$export$bee642e950dff992)(light));
        const spotAttenuation = this.getSpotAttenuation(angleCos);
        const lightDistance = lVector.length();
        const lightAttenuation = (0, $8dabd82a2fa36007$export$f35276a09da0cd36)({
            lightDistance: lightDistance,
            cutoffDistance: cutoffDistanceNode,
            decayExponent: decayExponentNode
        });
        const lightColor = colorNode.mul(spotAttenuation).mul(lightAttenuation);
        const reflectedLight = builder.context.reflectedLight;
        lightingModel.direct({
            lightDirection: lightDirection,
            lightColor: lightColor,
            reflectedLight: reflectedLight
        }, builder.stack, builder);
    }
}
var $b516406311089938$export$2e2bcd8739ae039 = $b516406311089938$var$SpotLightNode;





class $439b02a79c98e55f$var$IESSpotLightNode extends (0, $b516406311089938$export$2e2bcd8739ae039) {
    static get type() {
        return 'IESSpotLightNode';
    }
    getSpotAttenuation(angleCosine) {
        const iesMap = this.light.iesMap;
        let spotAttenuation = null;
        if (iesMap && iesMap.isTexture === true) {
            const angle = angleCosine.acos().mul(1.0 / Math.PI);
            spotAttenuation = (0, $f7d68bbf9ea772a7$export$ab69073b3903a075)(iesMap, (0, $d5b7ee61758b2e81$export$e9830bc863290a54)(angle, 0), 0).r;
        } else spotAttenuation = super.getSpotAttenuation(angleCosine);
        return spotAttenuation;
    }
}
var $439b02a79c98e55f$export$2e2bcd8739ae039 = $439b02a79c98e55f$var$IESSpotLightNode;



class $c64ec0a0d80aa4e1$var$AmbientLightNode extends (0, $c5fe32a85e7ab0bc$export$2e2bcd8739ae039) {
    static get type() {
        return 'AmbientLightNode';
    }
    constructor(light = null){
        super(light);
    }
    setup({ context: context }) {
        context.irradiance.addAssign(this.colorNode);
    }
}
var $c64ec0a0d80aa4e1$export$2e2bcd8739ae039 = $c64ec0a0d80aa4e1$var$AmbientLightNode;












class $9a2a2c30c39605df$var$HemisphereLightNode extends (0, $c5fe32a85e7ab0bc$export$2e2bcd8739ae039) {
    static get type() {
        return 'HemisphereLightNode';
    }
    constructor(light = null){
        super(light);
        this.lightPositionNode = (0, $979f6f830d64a743$export$ad1e75955383aee8)(light);
        this.lightDirectionNode = this.lightPositionNode.normalize();
        this.groundColorNode = (0, $5eb92bf12e57daab$export$379455b567eff87d)(new (0, $9a23ce591a1b6760$export$892596cec99bc70e)()).setGroup((0, $d2c0f7c752a63c18$export$a75a8692b47c7f9e));
    }
    update(frame) {
        const { light: light } = this;
        super.update(frame);
        this.lightPositionNode.object3d = light;
        this.groundColorNode.value.copy(light.groundColor).multiplyScalar(light.intensity);
    }
    setup(builder) {
        const { colorNode: colorNode, groundColorNode: groundColorNode, lightDirectionNode: lightDirectionNode } = this;
        const dotNL = (0, $0ab44deffc8ae973$export$c7d7ec78bf3ab28a).dot(lightDirectionNode);
        const hemiDiffuseWeight = dotNL.mul(0.5).add(0.5);
        const irradiance = (0, $f37ae0e58866c183$export$2c9e8a9632a706b2)(groundColorNode, colorNode, hemiDiffuseWeight);
        builder.context.irradiance.addAssign(irradiance);
    }
}
var $9a2a2c30c39605df$export$2e2bcd8739ae039 = $9a2a2c30c39605df$var$HemisphereLightNode;







class $8c978f5120ff4d68$var$LightProbeNode extends (0, $c5fe32a85e7ab0bc$export$2e2bcd8739ae039) {
    static get type() {
        return 'LightProbeNode';
    }
    constructor(light = null){
        super(light);
        const array = [];
        for(let i = 0; i < 9; i++)array.push(new (0, $d7d0ac0e47013885$export$64b5c384219d3699)());
        this.lightProbe = (0, $dc98837c0c62767d$export$9b734ab82c2f4fe3)(array);
    }
    update(frame) {
        const { light: light } = this;
        super.update(frame);
        //
        for(let i = 0; i < 9; i++)this.lightProbe.array[i].copy(light.sh.coefficients[i]).multiplyScalar(light.intensity);
    }
    setup(builder) {
        const irradiance = (0, $c1938fd2d8038641$export$2e2bcd8739ae039)((0, $0ab44deffc8ae973$export$8cce2f8527757c54), this.lightProbe);
        builder.context.irradiance.addAssign(irradiance);
    }
}
var $8c978f5120ff4d68$export$2e2bcd8739ae039 = $8c978f5120ff4d68$var$LightProbeNode;












const $7f10f4fffce72c39$var$_envNodeCache = new WeakMap();
class $7f10f4fffce72c39$var$EnvironmentNode extends (0, $cdb0844205e5f290$export$2e2bcd8739ae039) {
    static get type() {
        return 'EnvironmentNode';
    }
    constructor(envNode = null){
        super();
        this.envNode = envNode;
    }
    setup(builder) {
        const { material: material } = builder;
        let envNode = this.envNode;
        if (envNode.isTextureNode || envNode.isMaterialReferenceNode) {
            const value = envNode.isTextureNode ? envNode.value : material[envNode.property];
            let cacheEnvNode = $7f10f4fffce72c39$var$_envNodeCache.get(value);
            if (cacheEnvNode === undefined) {
                cacheEnvNode = (0, $23ee98d041aa8c55$export$7563f7aed5e67dc)(value);
                $7f10f4fffce72c39$var$_envNodeCache.set(value, cacheEnvNode);
            }
            envNode = cacheEnvNode;
        }
        //
        const envMap = material.envMap;
        const intensity = envMap ? (0, $7082d3a91c21cd99$export$ca50aac9f3ba507f)('envMapIntensity', 'float', builder.material) : (0, $7082d3a91c21cd99$export$ca50aac9f3ba507f)('environmentIntensity', 'float', builder.scene); // @TODO: Add materialEnvIntensity in MaterialNode
        const useAnisotropy = material.useAnisotropy === true || material.anisotropy > 0;
        const radianceNormalView = useAnisotropy ? (0, $d0a60d4044396068$export$72a051174b4709cb) : (0, $0ab44deffc8ae973$export$c58d63d09d102e3c);
        const radiance = envNode.context($7f10f4fffce72c39$var$createRadianceContext((0, $dd761eb0c8b88ca7$export$df3004878062a594), radianceNormalView)).mul(intensity);
        const irradiance = envNode.context($7f10f4fffce72c39$var$createIrradianceContext((0, $0ab44deffc8ae973$export$add3225664ac656e))).mul(Math.PI).mul(intensity);
        const isolateRadiance = (0, $c6f397d6620fd99d$export$69a3209f1a06c04d)(radiance);
        const isolateIrradiance = (0, $c6f397d6620fd99d$export$69a3209f1a06c04d)(irradiance);
        //
        builder.context.radiance.addAssign(isolateRadiance);
        builder.context.iblIrradiance.addAssign(isolateIrradiance);
        //
        const clearcoatRadiance = builder.context.lightingModel.clearcoatRadiance;
        if (clearcoatRadiance) {
            const clearcoatRadianceContext = envNode.context($7f10f4fffce72c39$var$createRadianceContext((0, $dd761eb0c8b88ca7$export$2747d91296dfac86), (0, $0ab44deffc8ae973$export$71a9f037ea1539e0))).mul(intensity);
            const isolateClearcoatRadiance = (0, $c6f397d6620fd99d$export$69a3209f1a06c04d)(clearcoatRadianceContext);
            clearcoatRadiance.addAssign(isolateClearcoatRadiance);
        }
    }
}
var $7f10f4fffce72c39$export$2e2bcd8739ae039 = $7f10f4fffce72c39$var$EnvironmentNode;
const $7f10f4fffce72c39$var$createRadianceContext = (roughnessNode, normalViewNode)=>{
    let reflectVec = null;
    return {
        getUV: ()=>{
            if (reflectVec === null) {
                reflectVec = (0, $acbec2070ba15851$export$80de5077965297a8).negate().reflect(normalViewNode);
                // Mixing the reflection with the normal is more accurate and keeps rough objects from gathering light from behind their tangent plane.
                reflectVec = roughnessNode.mul(roughnessNode).mix(reflectVec, normalViewNode).normalize();
                reflectVec = reflectVec.transformDirection((0, $aa7db78c76b9331c$export$6f7d94c027189d78));
            }
            return reflectVec;
        },
        getTextureLevel: ()=>{
            return roughnessNode;
        }
    };
};
const $7f10f4fffce72c39$var$createIrradianceContext = (normalWorldNode)=>{
    return {
        getUV: ()=>{
            return normalWorldNode;
        },
        getTextureLevel: ()=>{
            return (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(1.0);
        }
    };
};




class $eb1fde74125000ac$var$BasicEnvironmentNode extends (0, $cdb0844205e5f290$export$2e2bcd8739ae039) {
    static get type() {
        return 'BasicEnvironmentNode';
    }
    constructor(envNode = null){
        super();
        this.envNode = envNode;
    }
    setup(builder) {
        // environment property is used in the finish() method of BasicLightingModel
        builder.context.environment = (0, $5e9eb535dcfc47a7$export$41fca45bb73dbdd9)(this.envNode);
    }
}
var $eb1fde74125000ac$export$2e2bcd8739ae039 = $eb1fde74125000ac$var$BasicEnvironmentNode;







class $a47b493dd7f0b4c2$var$NodeParser {
    parseFunction() {
        console.warn('Abstract function.');
    }
}
var $a47b493dd7f0b4c2$export$2e2bcd8739ae039 = $a47b493dd7f0b4c2$var$NodeParser;


class $5bbb3bf76cd481f8$var$NodeFunction {
    constructor(type, inputs, name = '', precision = ''){
        this.type = type;
        this.inputs = inputs;
        this.name = name;
        this.precision = precision;
    }
    getCode() {
        console.warn('Abstract function.');
    }
}
$5bbb3bf76cd481f8$var$NodeFunction.isNodeFunction = true;
var $5bbb3bf76cd481f8$export$2e2bcd8739ae039 = $5bbb3bf76cd481f8$var$NodeFunction;



const $965ba58e64829fc4$var$declarationRegexp = /^\s*(highp|mediump|lowp)?\s*([a-z_0-9]+)\s*([a-z_0-9]+)?\s*\(([\s\S]*?)\)/i;
const $965ba58e64829fc4$var$propertiesRegexp = /[a-z_0-9]+/ig;
const $965ba58e64829fc4$var$pragmaMain = '#pragma main';
const $965ba58e64829fc4$var$parse = (source)=>{
    source = source.trim();
    const pragmaMainIndex = source.indexOf($965ba58e64829fc4$var$pragmaMain);
    const mainCode = pragmaMainIndex !== -1 ? source.slice(pragmaMainIndex + $965ba58e64829fc4$var$pragmaMain.length) : source;
    const declaration = mainCode.match($965ba58e64829fc4$var$declarationRegexp);
    if (declaration !== null && declaration.length === 5) {
        // tokenizer
        const inputsCode = declaration[4];
        const propsMatches = [];
        let nameMatch = null;
        while((nameMatch = $965ba58e64829fc4$var$propertiesRegexp.exec(inputsCode)) !== null)propsMatches.push(nameMatch);
        // parser
        const inputs = [];
        let i = 0;
        while(i < propsMatches.length){
            const isConst = propsMatches[i][0] === 'const';
            if (isConst === true) i++;
            let qualifier = propsMatches[i][0];
            if (qualifier === 'in' || qualifier === 'out' || qualifier === 'inout') i++;
            else qualifier = '';
            const type = propsMatches[i++][0];
            let count = Number.parseInt(propsMatches[i][0]);
            if (Number.isNaN(count) === false) i++;
            else count = null;
            const name = propsMatches[i++][0];
            inputs.push(new (0, $e7717ae23c68650f$export$2e2bcd8739ae039)(type, name, count, qualifier, isConst));
        }
        //
        const blockCode = mainCode.substring(declaration[0].length);
        const name = declaration[3] !== undefined ? declaration[3] : '';
        const type = declaration[2];
        const precision = declaration[1] !== undefined ? declaration[1] : '';
        const headerCode = pragmaMainIndex !== -1 ? source.slice(0, pragmaMainIndex) : '';
        return {
            type: type,
            inputs: inputs,
            name: name,
            precision: precision,
            inputsCode: inputsCode,
            blockCode: blockCode,
            headerCode: headerCode
        };
    } else throw new Error('FunctionNode: Function is not a GLSL code.');
};
class $965ba58e64829fc4$var$GLSLNodeFunction extends (0, $5bbb3bf76cd481f8$export$2e2bcd8739ae039) {
    constructor(source){
        const { type: type, inputs: inputs, name: name, precision: precision, inputsCode: inputsCode, blockCode: blockCode, headerCode: headerCode } = $965ba58e64829fc4$var$parse(source);
        super(type, inputs, name, precision);
        this.inputsCode = inputsCode;
        this.blockCode = blockCode;
        this.headerCode = headerCode;
    }
    getCode(name = this.name) {
        let code;
        const blockCode = this.blockCode;
        if (blockCode !== '') {
            const { type: type, inputsCode: inputsCode, headerCode: headerCode, precision: precision } = this;
            let declarationCode = `${type} ${name} ( ${inputsCode.trim()} )`;
            if (precision !== '') declarationCode = `${precision} ${declarationCode}`;
            code = headerCode + declarationCode + blockCode;
        } else // interface function
        code = '';
        return code;
    }
}
var $965ba58e64829fc4$export$2e2bcd8739ae039 = $965ba58e64829fc4$var$GLSLNodeFunction;


class $83a516d552911e58$var$GLSLNodeParser extends (0, $a47b493dd7f0b4c2$export$2e2bcd8739ae039) {
    parseFunction(source) {
        return new (0, $965ba58e64829fc4$export$2e2bcd8739ae039)(source);
    }
}
var $83a516d552911e58$export$2e2bcd8739ae039 = $83a516d552911e58$var$GLSLNodeParser;








class $87063ef446f2f682$var$BasicLightingModel extends (0, $e15d7fb89e2d8a53$export$2e2bcd8739ae039) {
    constructor(){
        super();
    }
    indirect(context, stack, builder) {
        const ambientOcclusion = context.ambientOcclusion;
        const reflectedLight = context.reflectedLight;
        const irradianceLightMap = builder.context.irradianceLightMap;
        reflectedLight.indirectDiffuse.assign((0, $d5b7ee61758b2e81$export$6dba2a1f0d609415)(0.0));
        // accumulation (baked indirect lighting only)
        if (irradianceLightMap) reflectedLight.indirectDiffuse.addAssign(irradianceLightMap);
        else reflectedLight.indirectDiffuse.addAssign((0, $d5b7ee61758b2e81$export$6dba2a1f0d609415)(1.0, 1.0, 1.0, 0.0));
        // modulation
        reflectedLight.indirectDiffuse.mulAssign(ambientOcclusion);
        reflectedLight.indirectDiffuse.mulAssign((0, $dd761eb0c8b88ca7$export$3a790f19f33c5176).rgb);
    }
    finish(context, stack, builder) {
        const material = builder.material;
        const outgoingLight = context.outgoingLight;
        const envNode = builder.context.environment;
        if (envNode) switch(material.combine){
            case 0, $cb5ee595c0f892af$export$e50ac29801f1774d:
                outgoingLight.rgb.assign((0, $f37ae0e58866c183$export$2c9e8a9632a706b2)(outgoingLight.rgb, outgoingLight.rgb.mul(envNode.rgb), (0, $8e4701fdb55563f1$export$aab42c7f7fd50fe).mul((0, $8e4701fdb55563f1$export$9ead911ab638ab9e))));
                break;
            case 0, $cb5ee595c0f892af$export$9f9d94f963c85479:
                outgoingLight.rgb.assign((0, $f37ae0e58866c183$export$2c9e8a9632a706b2)(outgoingLight.rgb, envNode.rgb, (0, $8e4701fdb55563f1$export$aab42c7f7fd50fe).mul((0, $8e4701fdb55563f1$export$9ead911ab638ab9e))));
                break;
            case 0, $cb5ee595c0f892af$export$e641dc52bc3494aa:
                outgoingLight.rgb.addAssign(envNode.rgb.mul((0, $8e4701fdb55563f1$export$aab42c7f7fd50fe).mul((0, $8e4701fdb55563f1$export$9ead911ab638ab9e))));
                break;
            default:
                console.warn('THREE.BasicLightingModel: Unsupported .combine value:', material.combine);
                break;
        }
    }
}
var $87063ef446f2f682$export$2e2bcd8739ae039 = $87063ef446f2f682$var$BasicLightingModel;









const $4771908cdc45bf93$var$G_BlinnPhong_Implicit = ()=>(0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(0.25);
const $4771908cdc45bf93$var$D_BlinnPhong = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$b076717d71a1a47f)(({ dotNH: dotNH })=>{
    return (0, $dd761eb0c8b88ca7$export$245b4c35387657dc).mul((0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(0.5)).add(1.0).mul((0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(1 / Math.PI)).mul(dotNH.pow((0, $dd761eb0c8b88ca7$export$245b4c35387657dc)));
});
const $4771908cdc45bf93$var$BRDF_BlinnPhong = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$b076717d71a1a47f)(({ lightDirection: lightDirection })=>{
    const halfDir = lightDirection.add((0, $acbec2070ba15851$export$80de5077965297a8)).normalize();
    const dotNH = (0, $0ab44deffc8ae973$export$c58d63d09d102e3c).dot(halfDir).clamp();
    const dotVH = (0, $acbec2070ba15851$export$80de5077965297a8).dot(halfDir).clamp();
    const F = (0, $2b8bcb75dcac1789$export$2e2bcd8739ae039)({
        f0: (0, $dd761eb0c8b88ca7$export$e1aa5ee431e11795),
        f90: 1.0,
        dotVH: dotVH
    });
    const G = $4771908cdc45bf93$var$G_BlinnPhong_Implicit();
    const D = $4771908cdc45bf93$var$D_BlinnPhong({
        dotNH: dotNH
    });
    return F.mul(G).mul(D);
});
class $4771908cdc45bf93$var$PhongLightingModel extends (0, $87063ef446f2f682$export$2e2bcd8739ae039) {
    constructor(specular = true){
        super();
        this.specular = specular;
    }
    direct({ lightDirection: lightDirection, lightColor: lightColor, reflectedLight: reflectedLight }) {
        const dotNL = (0, $0ab44deffc8ae973$export$c58d63d09d102e3c).dot(lightDirection).clamp();
        const irradiance = dotNL.mul(lightColor);
        reflectedLight.directDiffuse.addAssign(irradiance.mul((0, $f21c2fe74f9eb092$export$2e2bcd8739ae039)({
            diffuseColor: (0, $dd761eb0c8b88ca7$export$3a790f19f33c5176).rgb
        })));
        if (this.specular === true) reflectedLight.directSpecular.addAssign(irradiance.mul($4771908cdc45bf93$var$BRDF_BlinnPhong({
            lightDirection: lightDirection
        })).mul((0, $8e4701fdb55563f1$export$aab42c7f7fd50fe)));
    }
    indirect({ ambientOcclusion: ambientOcclusion, irradiance: irradiance, reflectedLight: reflectedLight }) {
        reflectedLight.indirectDiffuse.addAssign(irradiance.mul((0, $f21c2fe74f9eb092$export$2e2bcd8739ae039)({
            diffuseColor: $dd761eb0c8b88ca7$export$3a790f19f33c5176
        })));
        reflectedLight.indirectDiffuse.mulAssign(ambientOcclusion);
    }
}
var $4771908cdc45bf93$export$2e2bcd8739ae039 = $4771908cdc45bf93$var$PhongLightingModel;







const $900d8c67f34282bc$var$EnvironmentBRDF = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$b076717d71a1a47f)((inputs)=>{
    const { dotNV: dotNV, specularColor: specularColor, specularF90: specularF90, roughness: roughness } = inputs;
    const fab = (0, $032552e6d393c061$export$2e2bcd8739ae039)({
        dotNV: dotNV,
        roughness: roughness
    });
    return specularColor.mul(fab.x).add(specularF90.mul(fab.y));
});
var $900d8c67f34282bc$export$2e2bcd8739ae039 = $900d8c67f34282bc$var$EnvironmentBRDF;








// https://github.com/google/filament/blob/master/shaders/src/brdf.fs
const $3ebb7ab18b0e71a0$var$D_Charlie = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$b076717d71a1a47f)(({ roughness: roughness, dotNH: dotNH })=>{
    const alpha = roughness.pow2();
    // Estevez and Kulla 2017, "Production Friendly Microfacet Sheen BRDF"
    const invAlpha = (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(1.0).div(alpha);
    const cos2h = dotNH.pow2();
    const sin2h = cos2h.oneMinus().max(0.0078125); // 2^(-14/2), so sin2h^2 > 0 in fp16
    return (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(2.0).add(invAlpha).mul(sin2h.pow(invAlpha.mul(0.5))).div(2.0 * Math.PI);
}).setLayout({
    name: 'D_Charlie',
    type: 'float',
    inputs: [
        {
            name: 'roughness',
            type: 'float'
        },
        {
            name: 'dotNH',
            type: 'float'
        }
    ]
});
// https://github.com/google/filament/blob/master/shaders/src/brdf.fs
const $3ebb7ab18b0e71a0$var$V_Neubelt = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$b076717d71a1a47f)(({ dotNV: dotNV, dotNL: dotNL })=>{
    // Neubelt and Pettineo 2013, "Crafting a Next-gen Material Pipeline for The Order: 1886"
    return (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(1.0).div((0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(4.0).mul(dotNL.add(dotNV).sub(dotNL.mul(dotNV))));
}).setLayout({
    name: 'V_Neubelt',
    type: 'float',
    inputs: [
        {
            name: 'dotNV',
            type: 'float'
        },
        {
            name: 'dotNL',
            type: 'float'
        }
    ]
});
const $3ebb7ab18b0e71a0$var$BRDF_Sheen = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$b076717d71a1a47f)(({ lightDirection: lightDirection })=>{
    const halfDir = lightDirection.add((0, $acbec2070ba15851$export$80de5077965297a8)).normalize();
    const dotNL = (0, $0ab44deffc8ae973$export$c58d63d09d102e3c).dot(lightDirection).clamp();
    const dotNV = (0, $0ab44deffc8ae973$export$c58d63d09d102e3c).dot((0, $acbec2070ba15851$export$80de5077965297a8)).clamp();
    const dotNH = (0, $0ab44deffc8ae973$export$c58d63d09d102e3c).dot(halfDir).clamp();
    const D = $3ebb7ab18b0e71a0$var$D_Charlie({
        roughness: (0, $dd761eb0c8b88ca7$export$40c82d21b5c7315b),
        dotNH: dotNH
    });
    const V = $3ebb7ab18b0e71a0$var$V_Neubelt({
        dotNV: dotNV,
        dotNL: dotNL
    });
    return (0, $dd761eb0c8b88ca7$export$7cccf56baed94cee).mul(D).mul(V);
});
var $3ebb7ab18b0e71a0$export$2e2bcd8739ae039 = $3ebb7ab18b0e71a0$var$BRDF_Sheen;




// Rect Area Light
// Real-Time Polygonal-Light Shading with Linearly Transformed Cosines
// by Eric Heitz, Jonathan Dupuy, Stephen Hill and David Neubelt
// code: https://github.com/selfshadow/ltc_code/
const $8b153fe954991afa$export$e89b03059fe3831e = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$b076717d71a1a47f)(({ N: N, V: V, roughness: roughness })=>{
    const LUT_SIZE = 64.0;
    const LUT_SCALE = (LUT_SIZE - 1.0) / LUT_SIZE;
    const LUT_BIAS = 0.5 / LUT_SIZE;
    const dotNV = N.dot(V).saturate();
    // texture parameterized by sqrt( GGX alpha ) and sqrt( 1 - cos( theta ) )
    const uv = (0, $d5b7ee61758b2e81$export$e9830bc863290a54)(roughness, dotNV.oneMinus().sqrt());
    uv.assign(uv.mul(LUT_SCALE).add(LUT_BIAS));
    return uv;
}).setLayout({
    name: 'LTC_Uv',
    type: 'vec2',
    inputs: [
        {
            name: 'N',
            type: 'vec3'
        },
        {
            name: 'V',
            type: 'vec3'
        },
        {
            name: 'roughness',
            type: 'float'
        }
    ]
});
const $8b153fe954991afa$var$LTC_ClippedSphereFormFactor = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$b076717d71a1a47f)(({ f: f })=>{
    // Real-Time Area Lighting: a Journey from Research to Production (p.102)
    // An approximation of the form factor of a horizon-clipped rectangle.
    const l = f.length();
    return (0, $f37ae0e58866c183$export$8960430cfd85939f)(l.mul(l).add(f.z).div(l.add(1.0)), 0);
}).setLayout({
    name: 'LTC_ClippedSphereFormFactor',
    type: 'float',
    inputs: [
        {
            name: 'f',
            type: 'vec3'
        }
    ]
});
const $8b153fe954991afa$var$LTC_EdgeVectorFormFactor = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$b076717d71a1a47f)(({ v1: v1, v2: v2 })=>{
    const x = v1.dot(v2);
    const y = x.abs().toVar();
    // rational polynomial approximation to theta / sin( theta ) / 2PI
    const a = y.mul(0.0145206).add(0.4965155).mul(y).add(0.8543985).toVar();
    const b = y.add(4.1616724).mul(y).add(3.4175940).toVar();
    const v = a.div(b);
    const theta_sintheta = x.greaterThan(0.0).select(v, (0, $f37ae0e58866c183$export$8960430cfd85939f)(x.mul(x).oneMinus(), 1e-7).inverseSqrt().mul(0.5).sub(v));
    return v1.cross(v2).mul(theta_sintheta);
}).setLayout({
    name: 'LTC_EdgeVectorFormFactor',
    type: 'vec3',
    inputs: [
        {
            name: 'v1',
            type: 'vec3'
        },
        {
            name: 'v2',
            type: 'vec3'
        }
    ]
});
const $8b153fe954991afa$export$9d3f62728c5672dd = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$b076717d71a1a47f)(({ N: N, V: V, P: P, mInv: mInv, p0: p0, p1: p1, p2: p2, p3: p3 })=>{
    // bail if point is on back side of plane of light
    // assumes ccw winding order of light vertices
    const v1 = p1.sub(p0).toVar();
    const v2 = p3.sub(p0).toVar();
    const lightNormal = v1.cross(v2);
    const result = (0, $d5b7ee61758b2e81$export$9100789c9d999364)().toVar();
    (0, $d5b7ee61758b2e81$export$1f9ff5f4a6c9361a)(lightNormal.dot(P.sub(p0)).greaterThanEqual(0.0), ()=>{
        // construct orthonormal basis around N
        const T1 = V.sub(N.mul(V.dot(N))).normalize();
        const T2 = N.cross(T1).negate(); // negated from paper; possibly due to a different handedness of world coordinate system
        // compute transform
        const mat = mInv.mul((0, $d5b7ee61758b2e81$export$e43bd9f504e4ac00)(T1, T2, N).transpose()).toVar();
        // transform rect
        // & project rect onto sphere
        const coords0 = mat.mul(p0.sub(P)).normalize().toVar();
        const coords1 = mat.mul(p1.sub(P)).normalize().toVar();
        const coords2 = mat.mul(p2.sub(P)).normalize().toVar();
        const coords3 = mat.mul(p3.sub(P)).normalize().toVar();
        // calculate vector form factor
        const vectorFormFactor = (0, $d5b7ee61758b2e81$export$9100789c9d999364)(0).toVar();
        vectorFormFactor.addAssign($8b153fe954991afa$var$LTC_EdgeVectorFormFactor({
            v1: coords0,
            v2: coords1
        }));
        vectorFormFactor.addAssign($8b153fe954991afa$var$LTC_EdgeVectorFormFactor({
            v1: coords1,
            v2: coords2
        }));
        vectorFormFactor.addAssign($8b153fe954991afa$var$LTC_EdgeVectorFormFactor({
            v1: coords2,
            v2: coords3
        }));
        vectorFormFactor.addAssign($8b153fe954991afa$var$LTC_EdgeVectorFormFactor({
            v1: coords3,
            v2: coords0
        }));
        // adjust for horizon clipping
        result.assign((0, $d5b7ee61758b2e81$export$9100789c9d999364)($8b153fe954991afa$var$LTC_ClippedSphereFormFactor({
            f: vectorFormFactor
        })));
    });
    return result;
}).setLayout({
    name: 'LTC_Evaluate',
    type: 'vec3',
    inputs: [
        {
            name: 'N',
            type: 'vec3'
        },
        {
            name: 'V',
            type: 'vec3'
        },
        {
            name: 'P',
            type: 'vec3'
        },
        {
            name: 'mInv',
            type: 'mat3'
        },
        {
            name: 'p0',
            type: 'vec3'
        },
        {
            name: 'p1',
            type: 'vec3'
        },
        {
            name: 'p2',
            type: 'vec3'
        },
        {
            name: 'p3',
            type: 'vec3'
        }
    ]
});

















//
// Transmission
//
const $e78cda5c083cf9f1$var$getVolumeTransmissionRay = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$b076717d71a1a47f)(([n, v, thickness, ior, modelMatrix])=>{
    // Direction of refracted light.
    const refractionVector = (0, $d5b7ee61758b2e81$export$9100789c9d999364)((0, $f37ae0e58866c183$export$f49311db2be090a0)(v.negate(), (0, $f37ae0e58866c183$export$a3295358bff77e)(n), (0, $3f1f23fea79ae256$export$159d9494db57879b)(1.0, ior)));
    // Compute rotation-independant scaling of the model matrix.
    const modelScale = (0, $d5b7ee61758b2e81$export$9100789c9d999364)((0, $f37ae0e58866c183$export$f24224f1c91d8156)(modelMatrix[0].xyz), (0, $f37ae0e58866c183$export$f24224f1c91d8156)(modelMatrix[1].xyz), (0, $f37ae0e58866c183$export$f24224f1c91d8156)(modelMatrix[2].xyz));
    // The thickness is specified in local space.
    return (0, $f37ae0e58866c183$export$a3295358bff77e)(refractionVector).mul(thickness.mul(modelScale));
}).setLayout({
    name: 'getVolumeTransmissionRay',
    type: 'vec3',
    inputs: [
        {
            name: 'n',
            type: 'vec3'
        },
        {
            name: 'v',
            type: 'vec3'
        },
        {
            name: 'thickness',
            type: 'float'
        },
        {
            name: 'ior',
            type: 'float'
        },
        {
            name: 'modelMatrix',
            type: 'mat4'
        }
    ]
});
const $e78cda5c083cf9f1$var$applyIorToRoughness = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$b076717d71a1a47f)(([roughness, ior])=>{
    // Scale roughness with IOR so that an IOR of 1.0 results in no microfacet refraction and
    // an IOR of 1.5 results in the default amount of microfacet refraction.
    return roughness.mul((0, $f37ae0e58866c183$export$7d15b64cf5a3a4c4)(ior.mul(2.0).sub(2.0), 0.0, 1.0));
}).setLayout({
    name: 'applyIorToRoughness',
    type: 'float',
    inputs: [
        {
            name: 'roughness',
            type: 'float'
        },
        {
            name: 'ior',
            type: 'float'
        }
    ]
});
const $e78cda5c083cf9f1$var$viewportBackSideTexture = /*@__PURE__*/ (0, $3a0ecc63acbbffaf$export$e03dc40ba6105796)();
const $e78cda5c083cf9f1$var$viewportFrontSideTexture = /*@__PURE__*/ (0, $3a0ecc63acbbffaf$export$e03dc40ba6105796)();
const $e78cda5c083cf9f1$var$getTransmissionSample = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$b076717d71a1a47f)(([fragCoord, roughness, ior], { material: material })=>{
    const vTexture = material.side == (0, $cb5ee595c0f892af$export$d9f0486e75b5ace) ? $e78cda5c083cf9f1$var$viewportBackSideTexture : $e78cda5c083cf9f1$var$viewportFrontSideTexture;
    const transmissionSample = vTexture.uv(fragCoord);
    //const transmissionSample = viewportMipTexture( fragCoord );
    const lod = (0, $f37ae0e58866c183$export$b9fae0bba9d9094d)((0, $64df2f32a1195518$export$463d066e8ee12fba).x).mul($e78cda5c083cf9f1$var$applyIorToRoughness(roughness, ior));
    return (0, $82ae7c00e8a2de76$export$c7dcb77ffba0478b)(transmissionSample, lod);
});
const $e78cda5c083cf9f1$var$volumeAttenuation = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$b076717d71a1a47f)(([transmissionDistance, attenuationColor, attenuationDistance])=>{
    (0, $d5b7ee61758b2e81$export$1f9ff5f4a6c9361a)(attenuationDistance.notEqual(0), ()=>{
        // Compute light attenuation using Beer's law.
        const attenuationCoefficient = (0, $f37ae0e58866c183$export$bef1f36f5486a6a3)(attenuationColor).negate().div(attenuationDistance);
        const transmittance = (0, $f37ae0e58866c183$export$b310ec824aaee37f)(attenuationCoefficient.negate().mul(transmissionDistance));
        return transmittance;
    });
    // Attenuation distance is +∞, i.e. the transmitted color is not attenuated at all.
    return (0, $d5b7ee61758b2e81$export$9100789c9d999364)(1.0);
}).setLayout({
    name: 'volumeAttenuation',
    type: 'vec3',
    inputs: [
        {
            name: 'transmissionDistance',
            type: 'float'
        },
        {
            name: 'attenuationColor',
            type: 'vec3'
        },
        {
            name: 'attenuationDistance',
            type: 'float'
        }
    ]
});
const $e78cda5c083cf9f1$var$getIBLVolumeRefraction = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$b076717d71a1a47f)(([n, v, roughness, diffuseColor, specularColor, specularF90, position, modelMatrix, viewMatrix, projMatrix, ior, thickness, attenuationColor, attenuationDistance, dispersion])=>{
    let transmittedLight, transmittance;
    if (dispersion) {
        transmittedLight = (0, $d5b7ee61758b2e81$export$6dba2a1f0d609415)().toVar();
        transmittance = (0, $d5b7ee61758b2e81$export$9100789c9d999364)().toVar();
        const halfSpread = ior.sub(1.0).mul(dispersion.mul(0.025));
        const iors = (0, $d5b7ee61758b2e81$export$9100789c9d999364)(ior.sub(halfSpread), ior, ior.add(halfSpread));
        (0, $2a1578e0d4d8bf63$export$550acbd06a1f5a6a)({
            start: 0,
            end: 3
        }, ({ i: i })=>{
            const ior = iors.element(i);
            const transmissionRay = $e78cda5c083cf9f1$var$getVolumeTransmissionRay(n, v, thickness, ior, modelMatrix);
            const refractedRayExit = position.add(transmissionRay);
            // Project refracted vector on the framebuffer, while mapping to normalized device coordinates.
            const ndcPos = projMatrix.mul(viewMatrix.mul((0, $d5b7ee61758b2e81$export$6dba2a1f0d609415)(refractedRayExit, 1.0)));
            const refractionCoords = (0, $d5b7ee61758b2e81$export$e9830bc863290a54)(ndcPos.xy.div(ndcPos.w)).toVar();
            refractionCoords.addAssign(1.0);
            refractionCoords.divAssign(2.0);
            refractionCoords.assign((0, $d5b7ee61758b2e81$export$e9830bc863290a54)(refractionCoords.x, refractionCoords.y.oneMinus())); // webgpu
            // Sample framebuffer to get pixel the refracted ray hits.
            const transmissionSample = $e78cda5c083cf9f1$var$getTransmissionSample(refractionCoords, roughness, ior);
            transmittedLight.element(i).assign(transmissionSample.element(i));
            transmittedLight.a.addAssign(transmissionSample.a);
            transmittance.element(i).assign(diffuseColor.element(i).mul($e78cda5c083cf9f1$var$volumeAttenuation((0, $f37ae0e58866c183$export$f24224f1c91d8156)(transmissionRay), attenuationColor, attenuationDistance).element(i)));
        });
        transmittedLight.a.divAssign(3.0);
    } else {
        const transmissionRay = $e78cda5c083cf9f1$var$getVolumeTransmissionRay(n, v, thickness, ior, modelMatrix);
        const refractedRayExit = position.add(transmissionRay);
        // Project refracted vector on the framebuffer, while mapping to normalized device coordinates.
        const ndcPos = projMatrix.mul(viewMatrix.mul((0, $d5b7ee61758b2e81$export$6dba2a1f0d609415)(refractedRayExit, 1.0)));
        const refractionCoords = (0, $d5b7ee61758b2e81$export$e9830bc863290a54)(ndcPos.xy.div(ndcPos.w)).toVar();
        refractionCoords.addAssign(1.0);
        refractionCoords.divAssign(2.0);
        refractionCoords.assign((0, $d5b7ee61758b2e81$export$e9830bc863290a54)(refractionCoords.x, refractionCoords.y.oneMinus())); // webgpu
        // Sample framebuffer to get pixel the refracted ray hits.
        transmittedLight = $e78cda5c083cf9f1$var$getTransmissionSample(refractionCoords, roughness, ior);
        transmittance = diffuseColor.mul($e78cda5c083cf9f1$var$volumeAttenuation((0, $f37ae0e58866c183$export$f24224f1c91d8156)(transmissionRay), attenuationColor, attenuationDistance));
    }
    const attenuatedColor = transmittance.rgb.mul(transmittedLight.rgb);
    const dotNV = n.dot(v).clamp();
    // Get the specular component.
    const F = (0, $d5b7ee61758b2e81$export$9100789c9d999364)((0, $900d8c67f34282bc$export$2e2bcd8739ae039)({
        dotNV: dotNV,
        specularColor: specularColor,
        specularF90: specularF90,
        roughness: roughness
    }));
    // As less light is transmitted, the opacity should be increased. This simple approximation does a decent job
    // of modulating a CSS background, and has no effect when the buffer is opaque, due to a solid object or clear color.
    const transmittanceFactor = transmittance.r.add(transmittance.g, transmittance.b).div(3.0);
    return (0, $d5b7ee61758b2e81$export$6dba2a1f0d609415)(F.oneMinus().mul(attenuatedColor), transmittedLight.a.oneMinus().mul(transmittanceFactor).oneMinus());
});
//
// Iridescence
//
// XYZ to linear-sRGB color space
const $e78cda5c083cf9f1$var$XYZ_TO_REC709 = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$e43bd9f504e4ac00)(3.2404542, -0.969266, 0.0556434, -1.5371385, 1.8760108, -0.2040259, -0.4985314, 0.0415560, 1.0572252);
// Assume air interface for top
// Note: We don't handle the case fresnel0 == 1
const $e78cda5c083cf9f1$var$Fresnel0ToIor = (fresnel0)=>{
    const sqrtF0 = fresnel0.sqrt();
    return (0, $d5b7ee61758b2e81$export$9100789c9d999364)(1.0).add(sqrtF0).div((0, $d5b7ee61758b2e81$export$9100789c9d999364)(1.0).sub(sqrtF0));
};
// ior is a value between 1.0 and 3.0. 1.0 is air interface
const $e78cda5c083cf9f1$var$IorToFresnel0 = (transmittedIor, incidentIor)=>{
    return transmittedIor.sub(incidentIor).div(transmittedIor.add(incidentIor)).pow2();
};
// Fresnel equations for dielectric/dielectric interfaces.
// Ref: https://belcour.github.io/blog/research/2017/05/01/brdf-thin-film.html
// Evaluation XYZ sensitivity curves in Fourier space
const $e78cda5c083cf9f1$var$evalSensitivity = (OPD, shift)=>{
    const phase = OPD.mul(2.0 * Math.PI * 1.0e-9);
    const val = (0, $d5b7ee61758b2e81$export$9100789c9d999364)(5.4856e-13, 4.4201e-13, 5.2481e-13);
    const pos = (0, $d5b7ee61758b2e81$export$9100789c9d999364)(1.6810e+06, 1.7953e+06, 2.2084e+06);
    const VAR = (0, $d5b7ee61758b2e81$export$9100789c9d999364)(4.3278e+09, 9.3046e+09, 6.6121e+09);
    const x = (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(9.7470e-14 * Math.sqrt(2.0 * Math.PI * 4.5282e+09)).mul(phase.mul(2.2399e+06).add(shift.x).cos()).mul(phase.pow2().mul(-4528200000).exp());
    let xyz = val.mul(VAR.mul(2.0 * Math.PI).sqrt()).mul(pos.mul(phase).add(shift).cos()).mul(phase.pow2().negate().mul(VAR).exp());
    xyz = (0, $d5b7ee61758b2e81$export$9100789c9d999364)(xyz.x.add(x), xyz.y, xyz.z).div(1.0685e-7);
    const rgb = $e78cda5c083cf9f1$var$XYZ_TO_REC709.mul(xyz);
    return rgb;
};
const $e78cda5c083cf9f1$var$evalIridescence = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$b076717d71a1a47f)(({ outsideIOR: outsideIOR, eta2: eta2, cosTheta1: cosTheta1, thinFilmThickness: thinFilmThickness, baseF0: baseF0 })=>{
    // Force iridescenceIOR -> outsideIOR when thinFilmThickness -> 0.0
    const iridescenceIOR = (0, $f37ae0e58866c183$export$2c9e8a9632a706b2)(outsideIOR, eta2, (0, $f37ae0e58866c183$export$4053e36566dd3d9a)(0.0, 0.03, thinFilmThickness));
    // Evaluate the cosTheta on the base layer (Snell law)
    const sinTheta2Sq = outsideIOR.div(iridescenceIOR).pow2().mul(cosTheta1.pow2().oneMinus());
    // Handle TIR:
    const cosTheta2Sq = sinTheta2Sq.oneMinus();
    (0, $d5b7ee61758b2e81$export$1f9ff5f4a6c9361a)(cosTheta2Sq.lessThan(0), ()=>{
        return (0, $d5b7ee61758b2e81$export$9100789c9d999364)(1.0);
    });
    const cosTheta2 = cosTheta2Sq.sqrt();
    // First interface
    const R0 = $e78cda5c083cf9f1$var$IorToFresnel0(iridescenceIOR, outsideIOR);
    const R12 = (0, $2b8bcb75dcac1789$export$2e2bcd8739ae039)({
        f0: R0,
        f90: 1.0,
        dotVH: cosTheta1
    });
    //const R21 = R12;
    const T121 = R12.oneMinus();
    const phi12 = iridescenceIOR.lessThan(outsideIOR).select(Math.PI, 0.0);
    const phi21 = (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(Math.PI).sub(phi12);
    // Second interface
    const baseIOR = $e78cda5c083cf9f1$var$Fresnel0ToIor(baseF0.clamp(0.0, 0.9999)); // guard against 1.0
    const R1 = $e78cda5c083cf9f1$var$IorToFresnel0(baseIOR, iridescenceIOR.toVec3());
    const R23 = (0, $2b8bcb75dcac1789$export$2e2bcd8739ae039)({
        f0: R1,
        f90: 1.0,
        dotVH: cosTheta2
    });
    const phi23 = (0, $d5b7ee61758b2e81$export$9100789c9d999364)(baseIOR.x.lessThan(iridescenceIOR).select(Math.PI, 0.0), baseIOR.y.lessThan(iridescenceIOR).select(Math.PI, 0.0), baseIOR.z.lessThan(iridescenceIOR).select(Math.PI, 0.0));
    // Phase shift
    const OPD = iridescenceIOR.mul(thinFilmThickness, cosTheta2, 2.0);
    const phi = (0, $d5b7ee61758b2e81$export$9100789c9d999364)(phi21).add(phi23);
    // Compound terms
    const R123 = R12.mul(R23).clamp(1e-5, 0.9999);
    const r123 = R123.sqrt();
    const Rs = T121.pow2().mul(R23).div((0, $d5b7ee61758b2e81$export$9100789c9d999364)(1.0).sub(R123));
    // Reflectance term for m = 0 (DC term amplitude)
    const C0 = R12.add(Rs);
    const I = C0.toVar();
    // Reflectance term for m > 0 (pairs of diracs)
    const Cm = Rs.sub(T121).toVar();
    (0, $2a1578e0d4d8bf63$export$550acbd06a1f5a6a)({
        start: 1,
        end: 2,
        condition: '<=',
        name: 'm'
    }, ({ m: m })=>{
        Cm.mulAssign(r123);
        const Sm = $e78cda5c083cf9f1$var$evalSensitivity((0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(m).mul(OPD), (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(m).mul(phi)).mul(2.0);
        I.addAssign(Cm.mul(Sm));
    });
    // Since out of gamut colors might be produced, negative color values are clamped to 0.
    return I.max((0, $d5b7ee61758b2e81$export$9100789c9d999364)(0.0));
}).setLayout({
    name: 'evalIridescence',
    type: 'vec3',
    inputs: [
        {
            name: 'outsideIOR',
            type: 'float'
        },
        {
            name: 'eta2',
            type: 'float'
        },
        {
            name: 'cosTheta1',
            type: 'float'
        },
        {
            name: 'thinFilmThickness',
            type: 'float'
        },
        {
            name: 'baseF0',
            type: 'vec3'
        }
    ]
});
//
//	Sheen
//
// This is a curve-fit approxmation to the "Charlie sheen" BRDF integrated over the hemisphere from
// Estevez and Kulla 2017, "Production Friendly Microfacet Sheen BRDF". The analysis can be found
// in the Sheen section of https://drive.google.com/file/d/1T0D1VSyR4AllqIJTQAraEIzjlb5h4FKH/view?usp=sharing
const $e78cda5c083cf9f1$var$IBLSheenBRDF = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$b076717d71a1a47f)(({ normal: normal, viewDir: viewDir, roughness: roughness })=>{
    const dotNV = normal.dot(viewDir).saturate();
    const r2 = roughness.pow2();
    const a = (0, $cb309bf1d9ed8a72$export$2e6c959c16ff56b8)(roughness.lessThan(0.25), (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(-339.2).mul(r2).add((0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(161.4).mul(roughness)).sub(25.9), (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(-8.48).mul(r2).add((0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(14.3).mul(roughness)).sub(9.95));
    const b = (0, $cb309bf1d9ed8a72$export$2e6c959c16ff56b8)(roughness.lessThan(0.25), (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(44.0).mul(r2).sub((0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(23.7).mul(roughness)).add(3.26), (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(1.97).mul(r2).sub((0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(3.27).mul(roughness)).add(0.72));
    const DG = (0, $cb309bf1d9ed8a72$export$2e6c959c16ff56b8)(roughness.lessThan(0.25), 0.0, (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(0.1).mul(roughness).sub(0.025)).add(a.mul(dotNV).add(b).exp());
    return DG.mul(1.0 / Math.PI).saturate();
});
const $e78cda5c083cf9f1$var$clearcoatF0 = (0, $d5b7ee61758b2e81$export$9100789c9d999364)(0.04);
const $e78cda5c083cf9f1$var$clearcoatF90 = (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(1);
//
class $e78cda5c083cf9f1$var$PhysicalLightingModel extends (0, $e15d7fb89e2d8a53$export$2e2bcd8739ae039) {
    constructor(clearcoat = false, sheen = false, iridescence = false, anisotropy = false, transmission = false, dispersion = false){
        super();
        this.clearcoat = clearcoat;
        this.sheen = sheen;
        this.iridescence = iridescence;
        this.anisotropy = anisotropy;
        this.transmission = transmission;
        this.dispersion = dispersion;
        this.clearcoatRadiance = null;
        this.clearcoatSpecularDirect = null;
        this.clearcoatSpecularIndirect = null;
        this.sheenSpecularDirect = null;
        this.sheenSpecularIndirect = null;
        this.iridescenceFresnel = null;
        this.iridescenceF0 = null;
    }
    start(context) {
        if (this.clearcoat === true) {
            this.clearcoatRadiance = (0, $d5b7ee61758b2e81$export$9100789c9d999364)().toVar('clearcoatRadiance');
            this.clearcoatSpecularDirect = (0, $d5b7ee61758b2e81$export$9100789c9d999364)().toVar('clearcoatSpecularDirect');
            this.clearcoatSpecularIndirect = (0, $d5b7ee61758b2e81$export$9100789c9d999364)().toVar('clearcoatSpecularIndirect');
        }
        if (this.sheen === true) {
            this.sheenSpecularDirect = (0, $d5b7ee61758b2e81$export$9100789c9d999364)().toVar('sheenSpecularDirect');
            this.sheenSpecularIndirect = (0, $d5b7ee61758b2e81$export$9100789c9d999364)().toVar('sheenSpecularIndirect');
        }
        if (this.iridescence === true) {
            const dotNVi = (0, $0ab44deffc8ae973$export$c58d63d09d102e3c).dot((0, $acbec2070ba15851$export$80de5077965297a8)).clamp();
            this.iridescenceFresnel = $e78cda5c083cf9f1$var$evalIridescence({
                outsideIOR: (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(1.0),
                eta2: (0, $dd761eb0c8b88ca7$export$e8f290002a000efa),
                cosTheta1: dotNVi,
                thinFilmThickness: (0, $dd761eb0c8b88ca7$export$af4f9ca0bc04b1e),
                baseF0: (0, $dd761eb0c8b88ca7$export$e1aa5ee431e11795)
            });
            this.iridescenceF0 = (0, $37c11dc2ed7b9a24$export$2e2bcd8739ae039)({
                f: this.iridescenceFresnel,
                f90: 1.0,
                dotVH: dotNVi
            });
        }
        if (this.transmission === true) {
            const position = (0, $acbec2070ba15851$export$3e8de2ffef4e6f91);
            const v = (0, $aa7db78c76b9331c$export$3d9982e937097c50).sub((0, $acbec2070ba15851$export$3e8de2ffef4e6f91)).normalize(); // TODO: Create Node for this, same issue in MaterialX
            const n = (0, $0ab44deffc8ae973$export$add3225664ac656e);
            context.backdrop = $e78cda5c083cf9f1$var$getIBLVolumeRefraction(n, v, (0, $dd761eb0c8b88ca7$export$df3004878062a594), (0, $dd761eb0c8b88ca7$export$3a790f19f33c5176), (0, $dd761eb0c8b88ca7$export$e1aa5ee431e11795), (0, $dd761eb0c8b88ca7$export$fa391975b9b85621), position, (0, $c03c6edd36966f29$export$e1011125af6f8b40), (0, $aa7db78c76b9331c$export$6f7d94c027189d78), (0, $aa7db78c76b9331c$export$dc8d743682f60b2d), (0, $dd761eb0c8b88ca7$export$9b6d27e550bdd04d), (0, $dd761eb0c8b88ca7$export$70328e7fc5b512a3), (0, $dd761eb0c8b88ca7$export$4e929bebb52dac2c), (0, $dd761eb0c8b88ca7$export$dfdcdac9ec5733ba), this.dispersion ? (0, $dd761eb0c8b88ca7$export$6cf2c7e842feef4c) : null);
            context.backdropAlpha = (0, $dd761eb0c8b88ca7$export$48b427a8e82dea20);
            (0, $dd761eb0c8b88ca7$export$3a790f19f33c5176).a.mulAssign((0, $f37ae0e58866c183$export$2c9e8a9632a706b2)(1, context.backdrop.a, (0, $dd761eb0c8b88ca7$export$48b427a8e82dea20)));
        }
    }
    // Fdez-Agüera's "Multiple-Scattering Microfacet Model for Real-Time Image Based Lighting"
    // Approximates multiscattering in order to preserve energy.
    // http://www.jcgt.org/published/0008/01/03/
    computeMultiscattering(singleScatter, multiScatter, specularF90) {
        const dotNV = (0, $0ab44deffc8ae973$export$c58d63d09d102e3c).dot((0, $acbec2070ba15851$export$80de5077965297a8)).clamp(); // @ TODO: Move to core dotNV
        const fab = (0, $032552e6d393c061$export$2e2bcd8739ae039)({
            roughness: $dd761eb0c8b88ca7$export$df3004878062a594,
            dotNV: dotNV
        });
        const Fr = this.iridescenceF0 ? (0, $dd761eb0c8b88ca7$export$8fa8908d67be43df).mix((0, $dd761eb0c8b88ca7$export$e1aa5ee431e11795), this.iridescenceF0) : (0, $dd761eb0c8b88ca7$export$e1aa5ee431e11795);
        const FssEss = Fr.mul(fab.x).add(specularF90.mul(fab.y));
        const Ess = fab.x.add(fab.y);
        const Ems = Ess.oneMinus();
        const Favg = (0, $dd761eb0c8b88ca7$export$e1aa5ee431e11795).add((0, $dd761eb0c8b88ca7$export$e1aa5ee431e11795).oneMinus().mul(0.047619)); // 1/21
        const Fms = FssEss.mul(Favg).div(Ems.mul(Favg).oneMinus());
        singleScatter.addAssign(FssEss);
        multiScatter.addAssign(Fms.mul(Ems));
    }
    direct({ lightDirection: lightDirection, lightColor: lightColor, reflectedLight: reflectedLight }) {
        const dotNL = (0, $0ab44deffc8ae973$export$c58d63d09d102e3c).dot(lightDirection).clamp();
        const irradiance = dotNL.mul(lightColor);
        if (this.sheen === true) this.sheenSpecularDirect.addAssign(irradiance.mul((0, $3ebb7ab18b0e71a0$export$2e2bcd8739ae039)({
            lightDirection: lightDirection
        })));
        if (this.clearcoat === true) {
            const dotNLcc = (0, $0ab44deffc8ae973$export$71a9f037ea1539e0).dot(lightDirection).clamp();
            const ccIrradiance = dotNLcc.mul(lightColor);
            this.clearcoatSpecularDirect.addAssign(ccIrradiance.mul((0, $173677068bff6758$export$2e2bcd8739ae039)({
                lightDirection: lightDirection,
                f0: $e78cda5c083cf9f1$var$clearcoatF0,
                f90: $e78cda5c083cf9f1$var$clearcoatF90,
                roughness: (0, $dd761eb0c8b88ca7$export$2747d91296dfac86),
                normalView: (0, $0ab44deffc8ae973$export$71a9f037ea1539e0)
            })));
        }
        reflectedLight.directDiffuse.addAssign(irradiance.mul((0, $f21c2fe74f9eb092$export$2e2bcd8739ae039)({
            diffuseColor: (0, $dd761eb0c8b88ca7$export$3a790f19f33c5176).rgb
        })));
        reflectedLight.directSpecular.addAssign(irradiance.mul((0, $173677068bff6758$export$2e2bcd8739ae039)({
            lightDirection: lightDirection,
            f0: (0, $dd761eb0c8b88ca7$export$e1aa5ee431e11795),
            f90: 1,
            roughness: $dd761eb0c8b88ca7$export$df3004878062a594,
            iridescence: this.iridescence,
            f: this.iridescenceFresnel,
            USE_IRIDESCENCE: this.iridescence,
            USE_ANISOTROPY: this.anisotropy
        })));
    }
    directRectArea({ lightColor: lightColor, lightPosition: lightPosition, halfWidth: halfWidth, halfHeight: halfHeight, reflectedLight: reflectedLight, ltc_1: ltc_1, ltc_2: ltc_2 }) {
        const p0 = lightPosition.add(halfWidth).sub(halfHeight); // counterclockwise; light shines in local neg z direction
        const p1 = lightPosition.sub(halfWidth).sub(halfHeight);
        const p2 = lightPosition.sub(halfWidth).add(halfHeight);
        const p3 = lightPosition.add(halfWidth).add(halfHeight);
        const N = (0, $0ab44deffc8ae973$export$c58d63d09d102e3c);
        const V = (0, $acbec2070ba15851$export$80de5077965297a8);
        const P = (0, $acbec2070ba15851$export$3dfd735ebeac9bfd).toVar();
        const uv = (0, $8b153fe954991afa$export$e89b03059fe3831e)({
            N: N,
            V: V,
            roughness: $dd761eb0c8b88ca7$export$df3004878062a594
        });
        const t1 = ltc_1.uv(uv).toVar();
        const t2 = ltc_2.uv(uv).toVar();
        const mInv = (0, $d5b7ee61758b2e81$export$e43bd9f504e4ac00)((0, $d5b7ee61758b2e81$export$9100789c9d999364)(t1.x, 0, t1.y), (0, $d5b7ee61758b2e81$export$9100789c9d999364)(0, 1, 0), (0, $d5b7ee61758b2e81$export$9100789c9d999364)(t1.z, 0, t1.w)).toVar();
        // LTC Fresnel Approximation by Stephen Hill
        // http://blog.selfshadow.com/publications/s2016-advances/s2016_ltc_fresnel.pdf
        const fresnel = (0, $dd761eb0c8b88ca7$export$e1aa5ee431e11795).mul(t2.x).add((0, $dd761eb0c8b88ca7$export$e1aa5ee431e11795).oneMinus().mul(t2.y)).toVar();
        reflectedLight.directSpecular.addAssign(lightColor.mul(fresnel).mul((0, $8b153fe954991afa$export$9d3f62728c5672dd)({
            N: N,
            V: V,
            P: P,
            mInv: mInv,
            p0: p0,
            p1: p1,
            p2: p2,
            p3: p3
        })));
        reflectedLight.directDiffuse.addAssign(lightColor.mul((0, $dd761eb0c8b88ca7$export$3a790f19f33c5176)).mul((0, $8b153fe954991afa$export$9d3f62728c5672dd)({
            N: N,
            V: V,
            P: P,
            mInv: (0, $d5b7ee61758b2e81$export$e43bd9f504e4ac00)(1, 0, 0, 0, 1, 0, 0, 0, 1),
            p0: p0,
            p1: p1,
            p2: p2,
            p3: p3
        })));
    }
    indirect(context, stack, builder) {
        this.indirectDiffuse(context, stack, builder);
        this.indirectSpecular(context, stack, builder);
        this.ambientOcclusion(context, stack, builder);
    }
    indirectDiffuse({ irradiance: irradiance, reflectedLight: reflectedLight }) {
        reflectedLight.indirectDiffuse.addAssign(irradiance.mul((0, $f21c2fe74f9eb092$export$2e2bcd8739ae039)({
            diffuseColor: $dd761eb0c8b88ca7$export$3a790f19f33c5176
        })));
    }
    indirectSpecular({ radiance: radiance, iblIrradiance: iblIrradiance, reflectedLight: reflectedLight }) {
        if (this.sheen === true) this.sheenSpecularIndirect.addAssign(iblIrradiance.mul((0, $dd761eb0c8b88ca7$export$7cccf56baed94cee), $e78cda5c083cf9f1$var$IBLSheenBRDF({
            normal: (0, $0ab44deffc8ae973$export$c58d63d09d102e3c),
            viewDir: (0, $acbec2070ba15851$export$80de5077965297a8),
            roughness: (0, $dd761eb0c8b88ca7$export$40c82d21b5c7315b)
        })));
        if (this.clearcoat === true) {
            const dotNVcc = (0, $0ab44deffc8ae973$export$71a9f037ea1539e0).dot((0, $acbec2070ba15851$export$80de5077965297a8)).clamp();
            const clearcoatEnv = (0, $900d8c67f34282bc$export$2e2bcd8739ae039)({
                dotNV: dotNVcc,
                specularColor: $e78cda5c083cf9f1$var$clearcoatF0,
                specularF90: $e78cda5c083cf9f1$var$clearcoatF90,
                roughness: (0, $dd761eb0c8b88ca7$export$2747d91296dfac86)
            });
            this.clearcoatSpecularIndirect.addAssign(this.clearcoatRadiance.mul(clearcoatEnv));
        }
        // Both indirect specular and indirect diffuse light accumulate here
        const singleScattering = (0, $d5b7ee61758b2e81$export$9100789c9d999364)().toVar('singleScattering');
        const multiScattering = (0, $d5b7ee61758b2e81$export$9100789c9d999364)().toVar('multiScattering');
        const cosineWeightedIrradiance = iblIrradiance.mul(1 / Math.PI);
        this.computeMultiscattering(singleScattering, multiScattering, (0, $dd761eb0c8b88ca7$export$fa391975b9b85621));
        const totalScattering = singleScattering.add(multiScattering);
        const diffuse = (0, $dd761eb0c8b88ca7$export$3a790f19f33c5176).mul(totalScattering.r.max(totalScattering.g).max(totalScattering.b).oneMinus());
        reflectedLight.indirectSpecular.addAssign(radiance.mul(singleScattering));
        reflectedLight.indirectSpecular.addAssign(multiScattering.mul(cosineWeightedIrradiance));
        reflectedLight.indirectDiffuse.addAssign(diffuse.mul(cosineWeightedIrradiance));
    }
    ambientOcclusion({ ambientOcclusion: ambientOcclusion, reflectedLight: reflectedLight }) {
        const dotNV = (0, $0ab44deffc8ae973$export$c58d63d09d102e3c).dot((0, $acbec2070ba15851$export$80de5077965297a8)).clamp(); // @ TODO: Move to core dotNV
        const aoNV = dotNV.add(ambientOcclusion);
        const aoExp = (0, $dd761eb0c8b88ca7$export$df3004878062a594).mul(-16).oneMinus().negate().exp2();
        const aoNode = ambientOcclusion.sub(aoNV.pow(aoExp).oneMinus()).clamp();
        if (this.clearcoat === true) this.clearcoatSpecularIndirect.mulAssign(ambientOcclusion);
        if (this.sheen === true) this.sheenSpecularIndirect.mulAssign(ambientOcclusion);
        reflectedLight.indirectDiffuse.mulAssign(ambientOcclusion);
        reflectedLight.indirectSpecular.mulAssign(aoNode);
    }
    finish(context) {
        const { outgoingLight: outgoingLight } = context;
        if (this.clearcoat === true) {
            const dotNVcc = (0, $0ab44deffc8ae973$export$71a9f037ea1539e0).dot((0, $acbec2070ba15851$export$80de5077965297a8)).clamp();
            const Fcc = (0, $2b8bcb75dcac1789$export$2e2bcd8739ae039)({
                dotVH: dotNVcc,
                f0: $e78cda5c083cf9f1$var$clearcoatF0,
                f90: $e78cda5c083cf9f1$var$clearcoatF90
            });
            const clearcoatLight = outgoingLight.mul((0, $dd761eb0c8b88ca7$export$9b0829dedd347475).mul(Fcc).oneMinus()).add(this.clearcoatSpecularDirect.add(this.clearcoatSpecularIndirect).mul((0, $dd761eb0c8b88ca7$export$9b0829dedd347475)));
            outgoingLight.assign(clearcoatLight);
        }
        if (this.sheen === true) {
            const sheenEnergyComp = (0, $dd761eb0c8b88ca7$export$7cccf56baed94cee).r.max((0, $dd761eb0c8b88ca7$export$7cccf56baed94cee).g).max((0, $dd761eb0c8b88ca7$export$7cccf56baed94cee).b).mul(0.157).oneMinus();
            const sheenLight = outgoingLight.mul(sheenEnergyComp).add(this.sheenSpecularDirect, this.sheenSpecularIndirect);
            outgoingLight.assign(sheenLight);
        }
    }
}
var $e78cda5c083cf9f1$export$2e2bcd8739ae039 = $e78cda5c083cf9f1$var$PhysicalLightingModel;







const $084cacc9178ba669$var$outputNodeMap = new WeakMap();
class $084cacc9178ba669$var$Nodes extends (0, $0c532ab002169243$export$2e2bcd8739ae039) {
    constructor(renderer, backend){
        super();
        this.renderer = renderer;
        this.backend = backend;
        this.nodeFrame = new (0, $9e468f77ddf08edf$export$2e2bcd8739ae039)();
        this.nodeBuilderCache = new Map();
        this.callHashCache = new (0, $aa043456f1edde49$export$2e2bcd8739ae039)();
        this.groupsData = new (0, $aa043456f1edde49$export$2e2bcd8739ae039)();
    }
    updateGroup(nodeUniformsGroup) {
        const groupNode = nodeUniformsGroup.groupNode;
        const name = groupNode.name;
        // objectGroup is every updated
        if (name === (0, $d2c0f7c752a63c18$export$6a2a415f960d3137).name) return true;
        // renderGroup is updated once per render/compute call
        if (name === (0, $d2c0f7c752a63c18$export$a75a8692b47c7f9e).name) {
            const uniformsGroupData = this.get(nodeUniformsGroup);
            const renderId = this.nodeFrame.renderId;
            if (uniformsGroupData.renderId !== renderId) {
                uniformsGroupData.renderId = renderId;
                return true;
            }
            return false;
        }
        // frameGroup is updated once per frame
        if (name === (0, $d2c0f7c752a63c18$export$654c8c9e57a353a5).name) {
            const uniformsGroupData = this.get(nodeUniformsGroup);
            const frameId = this.nodeFrame.frameId;
            if (uniformsGroupData.frameId !== frameId) {
                uniformsGroupData.frameId = frameId;
                return true;
            }
            return false;
        }
        // other groups are updated just when groupNode.needsUpdate is true
        const groupChain = [
            groupNode,
            nodeUniformsGroup
        ];
        let groupData = this.groupsData.get(groupChain);
        if (groupData === undefined) this.groupsData.set(groupChain, groupData = {});
        if (groupData.version !== groupNode.version) {
            groupData.version = groupNode.version;
            return true;
        }
        return false;
    }
    getForRenderCacheKey(renderObject) {
        return renderObject.initialCacheKey;
    }
    getForRender(renderObject) {
        const renderObjectData = this.get(renderObject);
        let nodeBuilderState = renderObjectData.nodeBuilderState;
        if (nodeBuilderState === undefined) {
            const { nodeBuilderCache: nodeBuilderCache } = this;
            const cacheKey = this.getForRenderCacheKey(renderObject);
            nodeBuilderState = nodeBuilderCache.get(cacheKey);
            if (nodeBuilderState === undefined) {
                const nodeBuilder = this.backend.createNodeBuilder(renderObject.object, this.renderer);
                nodeBuilder.scene = renderObject.scene;
                nodeBuilder.material = renderObject.material;
                nodeBuilder.camera = renderObject.camera;
                nodeBuilder.context.material = renderObject.material;
                nodeBuilder.lightsNode = renderObject.lightsNode;
                nodeBuilder.environmentNode = this.getEnvironmentNode(renderObject.scene);
                nodeBuilder.fogNode = this.getFogNode(renderObject.scene);
                nodeBuilder.clippingContext = renderObject.clippingContext;
                nodeBuilder.build();
                nodeBuilderState = this._createNodeBuilderState(nodeBuilder);
                nodeBuilderCache.set(cacheKey, nodeBuilderState);
            }
            nodeBuilderState.usedTimes++;
            renderObjectData.nodeBuilderState = nodeBuilderState;
        }
        return nodeBuilderState;
    }
    delete(object) {
        if (object.isRenderObject) {
            const nodeBuilderState = this.get(object).nodeBuilderState;
            nodeBuilderState.usedTimes--;
            if (nodeBuilderState.usedTimes === 0) this.nodeBuilderCache.delete(this.getForRenderCacheKey(object));
        }
        return super.delete(object);
    }
    getForCompute(computeNode) {
        const computeData = this.get(computeNode);
        let nodeBuilderState = computeData.nodeBuilderState;
        if (nodeBuilderState === undefined) {
            const nodeBuilder = this.backend.createNodeBuilder(computeNode, this.renderer);
            nodeBuilder.build();
            nodeBuilderState = this._createNodeBuilderState(nodeBuilder);
            computeData.nodeBuilderState = nodeBuilderState;
        }
        return nodeBuilderState;
    }
    _createNodeBuilderState(nodeBuilder) {
        return new (0, $52805df7fe067754$export$2e2bcd8739ae039)(nodeBuilder.vertexShader, nodeBuilder.fragmentShader, nodeBuilder.computeShader, nodeBuilder.getAttributesArray(), nodeBuilder.getBindings(), nodeBuilder.updateNodes, nodeBuilder.updateBeforeNodes, nodeBuilder.updateAfterNodes, nodeBuilder.monitor, nodeBuilder.transforms);
    }
    getEnvironmentNode(scene) {
        return scene.environmentNode || this.get(scene).environmentNode || null;
    }
    getBackgroundNode(scene) {
        return scene.backgroundNode || this.get(scene).backgroundNode || null;
    }
    getFogNode(scene) {
        return scene.fogNode || this.get(scene).fogNode || null;
    }
    getCacheKey(scene, lightsNode) {
        const chain = [
            scene,
            lightsNode
        ];
        const callId = this.renderer.info.calls;
        let cacheKeyData = this.callHashCache.get(chain);
        if (cacheKeyData === undefined || cacheKeyData.callId !== callId) {
            const environmentNode = this.getEnvironmentNode(scene);
            const fogNode = this.getFogNode(scene);
            const values = [];
            if (lightsNode) values.push(lightsNode.getCacheKey(true));
            if (environmentNode) values.push(environmentNode.getCacheKey());
            if (fogNode) values.push(fogNode.getCacheKey());
            values.push(this.renderer.shadowMap.enabled ? 1 : 0);
            cacheKeyData = {
                callId: callId,
                cacheKey: (0, $97d1d441621670a9$export$cf0fb017e44bd6a4)(values)
            };
            this.callHashCache.set(chain, cacheKeyData);
        }
        return cacheKeyData.cacheKey;
    }
    updateScene(scene) {
        this.updateEnvironment(scene);
        this.updateFog(scene);
        this.updateBackground(scene);
    }
    get isToneMappingState() {
        return this.renderer.getRenderTarget() ? false : true;
    }
    updateBackground(scene) {
        const sceneData = this.get(scene);
        const background = scene.background;
        if (background) {
            const forceUpdate = scene.backgroundBlurriness === 0 && sceneData.backgroundBlurriness > 0 || scene.backgroundBlurriness > 0 && sceneData.backgroundBlurriness === 0;
            if (sceneData.background !== background || forceUpdate) {
                let backgroundNode = null;
                if (background.isCubeTexture === true || background.mapping === (0, $cb5ee595c0f892af$export$d64030b316d3b087) || background.mapping === (0, $cb5ee595c0f892af$export$ee99d97d46898098) || background.mapping === (0, $cb5ee595c0f892af$export$dbf3e70ff37af79)) {
                    if (scene.backgroundBlurriness > 0 || background.mapping === (0, $cb5ee595c0f892af$export$dbf3e70ff37af79)) backgroundNode = (0, $23ee98d041aa8c55$export$7563f7aed5e67dc)(background);
                    else {
                        let envMap;
                        if (background.isCubeTexture === true) envMap = (0, $48a97961b9b43631$export$f8948c996a1778e8)(background);
                        else envMap = (0, $f7d68bbf9ea772a7$export$ab69073b3903a075)(background);
                        backgroundNode = (0, $5e9eb535dcfc47a7$export$41fca45bb73dbdd9)(envMap);
                    }
                } else if (background.isTexture === true) backgroundNode = (0, $f7d68bbf9ea772a7$export$ab69073b3903a075)(background, (0, $64df2f32a1195518$export$e2a68d187fb2dd60).flipY()).setUpdateMatrix(true);
                else if (background.isColor !== true) console.error('WebGPUNodes: Unsupported background configuration.', background);
                sceneData.backgroundNode = backgroundNode;
                sceneData.background = background;
                sceneData.backgroundBlurriness = scene.backgroundBlurriness;
            }
        } else if (sceneData.backgroundNode) {
            delete sceneData.backgroundNode;
            delete sceneData.background;
        }
    }
    updateFog(scene) {
        const sceneData = this.get(scene);
        const fog = scene.fog;
        if (fog) {
            if (sceneData.fog !== fog) {
                let fogNode = null;
                if (fog.isFogExp2) {
                    const color = (0, $7082d3a91c21cd99$export$ca50aac9f3ba507f)('color', 'color', fog).setGroup((0, $d2c0f7c752a63c18$export$a75a8692b47c7f9e));
                    const density = (0, $7082d3a91c21cd99$export$ca50aac9f3ba507f)('density', 'float', fog).setGroup((0, $d2c0f7c752a63c18$export$a75a8692b47c7f9e));
                    fogNode = (0, $90c80656a1da59cb$export$31ec25b1026406ff)(color, density);
                } else if (fog.isFog) {
                    const color = (0, $7082d3a91c21cd99$export$ca50aac9f3ba507f)('color', 'color', fog).setGroup((0, $d2c0f7c752a63c18$export$a75a8692b47c7f9e));
                    const near = (0, $7082d3a91c21cd99$export$ca50aac9f3ba507f)('near', 'float', fog).setGroup((0, $d2c0f7c752a63c18$export$a75a8692b47c7f9e));
                    const far = (0, $7082d3a91c21cd99$export$ca50aac9f3ba507f)('far', 'float', fog).setGroup((0, $d2c0f7c752a63c18$export$a75a8692b47c7f9e));
                    fogNode = (0, $59c4f43fccb3aac6$export$40551637e51894d4)(color, near, far);
                } else console.error('WebGPUNodes: Unsupported fog configuration.', fog);
                sceneData.fogNode = fogNode;
                sceneData.fog = fog;
            }
        } else {
            delete sceneData.fogNode;
            delete sceneData.fog;
        }
    }
    updateEnvironment(scene) {
        const sceneData = this.get(scene);
        const environment = scene.environment;
        if (environment) {
            if (sceneData.environment !== environment) {
                let environmentNode = null;
                if (environment.isCubeTexture === true) environmentNode = (0, $48a97961b9b43631$export$f8948c996a1778e8)(environment);
                else if (environment.isTexture === true) environmentNode = (0, $f7d68bbf9ea772a7$export$ab69073b3903a075)(environment);
                else console.error('Nodes: Unsupported environment configuration.', environment);
                sceneData.environmentNode = environmentNode;
                sceneData.environment = environment;
            }
        } else if (sceneData.environmentNode) {
            delete sceneData.environmentNode;
            delete sceneData.environment;
        }
    }
    getNodeFrame(renderer = this.renderer, scene = null, object = null, camera = null, material = null) {
        const nodeFrame = this.nodeFrame;
        nodeFrame.renderer = renderer;
        nodeFrame.scene = scene;
        nodeFrame.object = object;
        nodeFrame.camera = camera;
        nodeFrame.material = material;
        return nodeFrame;
    }
    getNodeFrameForRender(renderObject) {
        return this.getNodeFrame(renderObject.renderer, renderObject.scene, renderObject.object, renderObject.camera, renderObject.material);
    }
    getOutputCacheKey() {
        const renderer = this.renderer;
        return renderer.toneMapping + ',' + renderer.currentColorSpace;
    }
    hasOutputChange(outputTarget) {
        const cacheKey = $084cacc9178ba669$var$outputNodeMap.get(outputTarget);
        return cacheKey !== this.getOutputCacheKey();
    }
    getOutputNode(outputTexture) {
        const renderer = this.renderer;
        const cacheKey = this.getOutputCacheKey();
        const output = (0, $f7d68bbf9ea772a7$export$ab69073b3903a075)(outputTexture, (0, $64df2f32a1195518$export$e2a68d187fb2dd60)).renderOutput(renderer.toneMapping, renderer.currentColorSpace);
        $084cacc9178ba669$var$outputNodeMap.set(outputTexture, cacheKey);
        return output;
    }
    updateBefore(renderObject) {
        const nodeBuilder = renderObject.getNodeBuilderState();
        for (const node of nodeBuilder.updateBeforeNodes)// update frame state for each node
        this.getNodeFrameForRender(renderObject).updateBeforeNode(node);
    }
    updateAfter(renderObject) {
        const nodeBuilder = renderObject.getNodeBuilderState();
        for (const node of nodeBuilder.updateAfterNodes)// update frame state for each node
        this.getNodeFrameForRender(renderObject).updateAfterNode(node);
    }
    updateForCompute(computeNode) {
        const nodeFrame = this.getNodeFrame();
        const nodeBuilder = this.getForCompute(computeNode);
        for (const node of nodeBuilder.updateNodes)nodeFrame.updateNode(node);
    }
    updateForRender(renderObject) {
        const nodeFrame = this.getNodeFrameForRender(renderObject);
        const nodeBuilder = renderObject.getNodeBuilderState();
        for (const node of nodeBuilder.updateNodes)nodeFrame.updateNode(node);
    }
    needsRefresh(renderObject) {
        const nodeFrame = this.getNodeFrameForRender(renderObject);
        const monitor = renderObject.getMonitor();
        return monitor.needsRefresh(renderObject, nodeFrame);
    }
    dispose() {
        super.dispose();
        this.nodeFrame = new (0, $9e468f77ddf08edf$export$2e2bcd8739ae039)();
        this.nodeBuilderCache = new Map();
    }
}
var $084cacc9178ba669$export$2e2bcd8739ae039 = $084cacc9178ba669$var$Nodes;






class $65ad2433e62d947b$var$RenderBundle {
    constructor(scene, camera){
        this.scene = scene;
        this.camera = camera;
    }
    clone() {
        return Object.assign(new this.constructor(), this);
    }
}
var $65ad2433e62d947b$export$2e2bcd8739ae039 = $65ad2433e62d947b$var$RenderBundle;


class $9e5d205325eef336$var$RenderBundles {
    constructor(){
        this.lists = new (0, $aa043456f1edde49$export$2e2bcd8739ae039)();
    }
    get(scene, camera) {
        const lists = this.lists;
        const keys = [
            scene,
            camera
        ];
        let list = lists.get(keys);
        if (list === undefined) {
            list = new (0, $65ad2433e62d947b$export$2e2bcd8739ae039)(scene, camera);
            lists.set(keys, list);
        }
        return list;
    }
    dispose() {
        this.lists = new (0, $aa043456f1edde49$export$2e2bcd8739ae039)();
    }
}
var $9e5d205325eef336$export$2e2bcd8739ae039 = $9e5d205325eef336$var$RenderBundles;


class $cf59a4ca80db2ff6$var$NodeLibrary {
    constructor(){
        this.lightNodes = new WeakMap();
        this.materialNodes = new Map();
        this.toneMappingNodes = new Map();
    }
    fromMaterial(material) {
        if (material.isNodeMaterial) return material;
        let nodeMaterial = null;
        const nodeMaterialClass = this.getMaterialNodeClass(material.type);
        if (nodeMaterialClass !== null) {
            nodeMaterial = new nodeMaterialClass();
            for(const key in material)nodeMaterial[key] = material[key];
        }
        return nodeMaterial;
    }
    addToneMapping(toneMappingNode, toneMapping) {
        this.addType(toneMappingNode, toneMapping, this.toneMappingNodes);
    }
    getToneMappingFunction(toneMapping) {
        return this.toneMappingNodes.get(toneMapping) || null;
    }
    getMaterialNodeClass(materialType) {
        return this.materialNodes.get(materialType) || null;
    }
    addMaterial(materialNodeClass, materialClass) {
        this.addType(materialNodeClass, materialClass.type, this.materialNodes);
    }
    getLightNodeClass(light) {
        return this.lightNodes.get(light) || null;
    }
    addLight(lightNodeClass, lightClass) {
        this.addClass(lightNodeClass, lightClass, this.lightNodes);
    }
    addType(nodeClass, type, library) {
        if (library.has(type)) {
            console.warn(`Redefinition of node ${type}`);
            return;
        }
        if (typeof nodeClass !== 'function') throw new Error(`Node class ${nodeClass.name} is not a class.`);
        if (typeof type === 'function' || typeof type === 'object') throw new Error(`Base class ${type} is not a class.`);
        library.set(type, nodeClass);
    }
    addClass(nodeClass, baseClass, library) {
        if (library.has(baseClass)) {
            console.warn(`Redefinition of node ${baseClass.name}`);
            return;
        }
        if (typeof nodeClass !== 'function') throw new Error(`Node class ${nodeClass.name} is not a class.`);
        if (typeof baseClass !== 'function') throw new Error(`Base class ${baseClass.name} is not a class.`);
        library.set(baseClass, nodeClass);
    }
}
var $cf59a4ca80db2ff6$export$2e2bcd8739ae039 = $cf59a4ca80db2ff6$var$NodeLibrary;




const $69342219418d13eb$var$_defaultLights = /*@__PURE__*/ new (0, $b9902801d7b7fb55$export$2e2bcd8739ae039)();
class $69342219418d13eb$var$Lighting extends (0, $aa043456f1edde49$export$2e2bcd8739ae039) {
    constructor(){
        super();
    }
    createNode(lights = []) {
        return new (0, $b9902801d7b7fb55$export$2e2bcd8739ae039)().setLights(lights);
    }
    getNode(scene, camera) {
        // ignore post-processing
        if (scene.isQuadMesh) return $69342219418d13eb$var$_defaultLights;
        // tiled lighting
        const keys = [
            scene,
            camera
        ];
        let node = this.get(keys);
        if (node === undefined) {
            node = this.createNode();
            this.set(keys, node);
        }
        return node;
    }
}
var $69342219418d13eb$export$2e2bcd8739ae039 = $69342219418d13eb$var$Lighting;








const $ada82301cc8d88e9$var$_sphere = /*@__PURE__*/ new (0, $f029c986fd3c8d57$export$805e8b72413ccaba)();
const $ada82301cc8d88e9$var$_vector = /*@__PURE__*/ new (0, $d7d0ac0e47013885$export$64b5c384219d3699)();
class $ada82301cc8d88e9$export$35efe6f4c85463d2 {
    constructor(p0 = new (0, $741db1fce3b06570$export$7ff5ac152ef991b0)(), p1 = new (0, $741db1fce3b06570$export$7ff5ac152ef991b0)(), p2 = new (0, $741db1fce3b06570$export$7ff5ac152ef991b0)(), p3 = new (0, $741db1fce3b06570$export$7ff5ac152ef991b0)(), p4 = new (0, $741db1fce3b06570$export$7ff5ac152ef991b0)(), p5 = new (0, $741db1fce3b06570$export$7ff5ac152ef991b0)()){
        this.planes = [
            p0,
            p1,
            p2,
            p3,
            p4,
            p5
        ];
    }
    set(p0, p1, p2, p3, p4, p5) {
        const planes = this.planes;
        planes[0].copy(p0);
        planes[1].copy(p1);
        planes[2].copy(p2);
        planes[3].copy(p3);
        planes[4].copy(p4);
        planes[5].copy(p5);
        return this;
    }
    copy(frustum) {
        const planes = this.planes;
        for(let i = 0; i < 6; i++)planes[i].copy(frustum.planes[i]);
        return this;
    }
    setFromProjectionMatrix(m, coordinateSystem = (0, $cb5ee595c0f892af$export$5a0e9190d10875d3)) {
        const planes = this.planes;
        const me = m.elements;
        const me0 = me[0], me1 = me[1], me2 = me[2], me3 = me[3];
        const me4 = me[4], me5 = me[5], me6 = me[6], me7 = me[7];
        const me8 = me[8], me9 = me[9], me10 = me[10], me11 = me[11];
        const me12 = me[12], me13 = me[13], me14 = me[14], me15 = me[15];
        planes[0].setComponents(me3 - me0, me7 - me4, me11 - me8, me15 - me12).normalize();
        planes[1].setComponents(me3 + me0, me7 + me4, me11 + me8, me15 + me12).normalize();
        planes[2].setComponents(me3 + me1, me7 + me5, me11 + me9, me15 + me13).normalize();
        planes[3].setComponents(me3 - me1, me7 - me5, me11 - me9, me15 - me13).normalize();
        planes[4].setComponents(me3 - me2, me7 - me6, me11 - me10, me15 - me14).normalize();
        if (coordinateSystem === (0, $cb5ee595c0f892af$export$5a0e9190d10875d3)) planes[5].setComponents(me3 + me2, me7 + me6, me11 + me10, me15 + me14).normalize();
        else if (coordinateSystem === (0, $cb5ee595c0f892af$export$cc83beedcb9be9ac)) planes[5].setComponents(me2, me6, me10, me14).normalize();
        else throw new Error('THREE.Frustum.setFromProjectionMatrix(): Invalid coordinate system: ' + coordinateSystem);
        return this;
    }
    intersectsObject(object) {
        if (object.boundingSphere !== undefined) {
            if (object.boundingSphere === null) object.computeBoundingSphere();
            $ada82301cc8d88e9$var$_sphere.copy(object.boundingSphere).applyMatrix4(object.matrixWorld);
        } else {
            const geometry = object.geometry;
            if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
            $ada82301cc8d88e9$var$_sphere.copy(geometry.boundingSphere).applyMatrix4(object.matrixWorld);
        }
        return this.intersectsSphere($ada82301cc8d88e9$var$_sphere);
    }
    intersectsSprite(sprite) {
        $ada82301cc8d88e9$var$_sphere.center.set(0, 0, 0);
        $ada82301cc8d88e9$var$_sphere.radius = 0.7071067811865476;
        $ada82301cc8d88e9$var$_sphere.applyMatrix4(sprite.matrixWorld);
        return this.intersectsSphere($ada82301cc8d88e9$var$_sphere);
    }
    intersectsSphere(sphere) {
        const planes = this.planes;
        const center = sphere.center;
        const negRadius = -sphere.radius;
        for(let i = 0; i < 6; i++){
            const distance = planes[i].distanceToPoint(center);
            if (distance < negRadius) return false;
        }
        return true;
    }
    intersectsBox(box) {
        const planes = this.planes;
        for(let i = 0; i < 6; i++){
            const plane = planes[i];
            // corner at max distance
            $ada82301cc8d88e9$var$_vector.x = plane.normal.x > 0 ? box.max.x : box.min.x;
            $ada82301cc8d88e9$var$_vector.y = plane.normal.y > 0 ? box.max.y : box.min.y;
            $ada82301cc8d88e9$var$_vector.z = plane.normal.z > 0 ? box.max.z : box.min.z;
            if (plane.distanceToPoint($ada82301cc8d88e9$var$_vector) < 0) return false;
        }
        return true;
    }
    containsPoint(point) {
        const planes = this.planes;
        for(let i = 0; i < 6; i++){
            if (planes[i].distanceToPoint(point) < 0) return false;
        }
        return true;
    }
    clone() {
        return new this.constructor().copy(this);
    }
}







const $1010750c439bdb5c$var$_scene = /*@__PURE__*/ new (0, $cdfde66d154b1e5c$export$38af1803e3442a7f)();
const $1010750c439bdb5c$var$_drawingBufferSize = /*@__PURE__*/ new (0, $3c03061dea0adea3$export$c977b3e384af9ae1)();
const $1010750c439bdb5c$var$_screen = /*@__PURE__*/ new (0, $a09a15e9a8421204$export$fa7daccca11cdbe3)();
const $1010750c439bdb5c$var$_frustum = /*@__PURE__*/ new (0, $ada82301cc8d88e9$export$35efe6f4c85463d2)();
const $1010750c439bdb5c$var$_projScreenMatrix = /*@__PURE__*/ new (0, $0ea09116adcadf95$export$2ae72fc923e5eb5)();
const $1010750c439bdb5c$var$_vector4 = /*@__PURE__*/ new (0, $a09a15e9a8421204$export$fa7daccca11cdbe3)();
class $1010750c439bdb5c$var$Renderer {
    constructor(backend, parameters = {}){
        this.isRenderer = true;
        //
        const { logarithmicDepthBuffer: logarithmicDepthBuffer = false, alpha: alpha = true, depth: depth = true, stencil: stencil = false, antialias: antialias = false, samples: samples = 0, getFallback: getFallback = null } = parameters;
        // public
        this.domElement = backend.getDomElement();
        this.backend = backend;
        this.samples = samples || antialias === true ? 4 : 0;
        this.autoClear = true;
        this.autoClearColor = true;
        this.autoClearDepth = true;
        this.autoClearStencil = true;
        this.alpha = alpha;
        this.logarithmicDepthBuffer = logarithmicDepthBuffer;
        this.outputColorSpace = (0, $cb5ee595c0f892af$export$561f394b24edfcaa);
        this.toneMapping = (0, $cb5ee595c0f892af$export$9fcb6b4294603b2);
        this.toneMappingExposure = 1.0;
        this.sortObjects = true;
        this.depth = depth;
        this.stencil = stencil;
        this.clippingPlanes = [];
        this.info = new (0, $676315ee04902050$export$2e2bcd8739ae039)();
        this.nodes = {
            modelViewMatrix: null,
            modelNormalViewMatrix: null
        };
        this.library = new (0, $cf59a4ca80db2ff6$export$2e2bcd8739ae039)();
        this.lighting = new (0, $69342219418d13eb$export$2e2bcd8739ae039)();
        // internals
        this._getFallback = getFallback;
        this._pixelRatio = 1;
        this._width = this.domElement.width;
        this._height = this.domElement.height;
        this._viewport = new (0, $a09a15e9a8421204$export$fa7daccca11cdbe3)(0, 0, this._width, this._height);
        this._scissor = new (0, $a09a15e9a8421204$export$fa7daccca11cdbe3)(0, 0, this._width, this._height);
        this._scissorTest = false;
        this._attributes = null;
        this._geometries = null;
        this._nodes = null;
        this._animation = null;
        this._bindings = null;
        this._objects = null;
        this._pipelines = null;
        this._bundles = null;
        this._renderLists = null;
        this._renderContexts = null;
        this._textures = null;
        this._background = null;
        this._quad = new (0, $488a8c443ac2097d$export$2e2bcd8739ae039)(new (0, $1a485f4d26090da0$export$2e2bcd8739ae039)());
        this._quad.material.type = 'Renderer_output';
        this._currentRenderContext = null;
        this._opaqueSort = null;
        this._transparentSort = null;
        this._frameBufferTarget = null;
        const alphaClear = this.alpha === true ? 0 : 1;
        this._clearColor = new (0, $4673b28ced87b0be$export$2e2bcd8739ae039)(0, 0, 0, alphaClear);
        this._clearDepth = 1;
        this._clearStencil = 0;
        this._renderTarget = null;
        this._activeCubeFace = 0;
        this._activeMipmapLevel = 0;
        this._mrt = null;
        this._renderObjectFunction = null;
        this._currentRenderObjectFunction = null;
        this._currentRenderBundle = null;
        this._handleObjectFunction = this._renderObjectDirect;
        this._isDeviceLost = false;
        this.onDeviceLost = this._onDeviceLost;
        this._initialized = false;
        this._initPromise = null;
        this._compilationPromises = null;
        this.transparent = true;
        this.opaque = true;
        this.shadowMap = {
            enabled: false,
            type: (0, $cb5ee595c0f892af$export$5813f879eee7cd88)
        };
        this.xr = {
            enabled: false
        };
        this.debug = {
            checkShaderErrors: true,
            onShaderError: null,
            getShaderAsync: async (scene, camera, object)=>{
                await this.compileAsync(scene, camera);
                const renderList = this._renderLists.get(scene, camera);
                const renderContext = this._renderContexts.get(scene, camera, this._renderTarget);
                const material = scene.overrideMaterial || object.material;
                const renderObject = this._objects.get(object, material, scene, camera, renderList.lightsNode, renderContext);
                const { fragmentShader: fragmentShader, vertexShader: vertexShader } = renderObject.getNodeBuilderState();
                return {
                    fragmentShader: fragmentShader,
                    vertexShader: vertexShader
                };
            }
        };
    }
    async init() {
        if (this._initialized) throw new Error('Renderer: Backend has already been initialized.');
        if (this._initPromise !== null) return this._initPromise;
        this._initPromise = new Promise(async (resolve, reject)=>{
            let backend = this.backend;
            try {
                await backend.init(this);
            } catch (error) {
                if (this._getFallback !== null) // try the fallback
                try {
                    this.backend = backend = this._getFallback(error);
                    await backend.init(this);
                } catch (error) {
                    reject(error);
                    return;
                }
                else {
                    reject(error);
                    return;
                }
            }
            this._nodes = new (0, $084cacc9178ba669$export$2e2bcd8739ae039)(this, backend);
            this._animation = new (0, $a7019598ba21f125$export$2e2bcd8739ae039)(this._nodes, this.info);
            this._attributes = new (0, $8afb6b311161e34f$export$2e2bcd8739ae039)(backend);
            this._background = new (0, $1aa79941180be295$export$2e2bcd8739ae039)(this, this._nodes);
            this._geometries = new (0, $3f2309e40aadd165$export$2e2bcd8739ae039)(this._attributes, this.info);
            this._textures = new (0, $19c1ba17c1582c1b$export$2e2bcd8739ae039)(this, backend, this.info);
            this._pipelines = new (0, $1af5968348535fae$export$2e2bcd8739ae039)(backend, this._nodes);
            this._bindings = new (0, $110c88866fa266a5$export$2e2bcd8739ae039)(backend, this._nodes, this._textures, this._attributes, this._pipelines, this.info);
            this._objects = new (0, $b622fa0cbb1f0984$export$2e2bcd8739ae039)(this, this._nodes, this._geometries, this._pipelines, this._bindings, this.info);
            this._renderLists = new (0, $a3d774cf6db34685$export$2e2bcd8739ae039)(this.lighting);
            this._bundles = new (0, $9e5d205325eef336$export$2e2bcd8739ae039)();
            this._renderContexts = new (0, $db19df1fb4962a35$export$2e2bcd8739ae039)();
            //
            this._initialized = true;
            resolve();
        });
        return this._initPromise;
    }
    get coordinateSystem() {
        return this.backend.coordinateSystem;
    }
    async compileAsync(scene, camera, targetScene = null) {
        if (this._isDeviceLost === true) return;
        if (this._initialized === false) await this.init();
        // preserve render tree
        const nodeFrame = this._nodes.nodeFrame;
        const previousRenderId = nodeFrame.renderId;
        const previousRenderContext = this._currentRenderContext;
        const previousRenderObjectFunction = this._currentRenderObjectFunction;
        const previousCompilationPromises = this._compilationPromises;
        //
        const sceneRef = scene.isScene === true ? scene : $1010750c439bdb5c$var$_scene;
        if (targetScene === null) targetScene = scene;
        const renderTarget = this._renderTarget;
        const renderContext = this._renderContexts.get(targetScene, camera, renderTarget);
        const activeMipmapLevel = this._activeMipmapLevel;
        const compilationPromises = [];
        this._currentRenderContext = renderContext;
        this._currentRenderObjectFunction = this.renderObject;
        this._handleObjectFunction = this._createObjectPipeline;
        this._compilationPromises = compilationPromises;
        nodeFrame.renderId++;
        //
        nodeFrame.update();
        //
        renderContext.depth = this.depth;
        renderContext.stencil = this.stencil;
        if (!renderContext.clippingContext) renderContext.clippingContext = new (0, $40f294098437e551$export$2e2bcd8739ae039)();
        renderContext.clippingContext.updateGlobal(this, camera);
        //
        sceneRef.onBeforeRender(this, scene, camera, renderTarget);
        //
        const renderList = this._renderLists.get(scene, camera);
        renderList.begin();
        this._projectObject(scene, camera, 0, renderList);
        // include lights from target scene
        if (targetScene !== scene) targetScene.traverseVisible(function(object) {
            if (object.isLight && object.layers.test(camera.layers)) renderList.pushLight(object);
        });
        renderList.finish();
        //
        if (renderTarget !== null) {
            this._textures.updateRenderTarget(renderTarget, activeMipmapLevel);
            const renderTargetData = this._textures.get(renderTarget);
            renderContext.textures = renderTargetData.textures;
            renderContext.depthTexture = renderTargetData.depthTexture;
        } else {
            renderContext.textures = null;
            renderContext.depthTexture = null;
        }
        //
        this._nodes.updateScene(sceneRef);
        //
        this._background.update(sceneRef, renderList, renderContext);
        // process render lists
        const opaqueObjects = renderList.opaque;
        const transparentObjects = renderList.transparent;
        const lightsNode = renderList.lightsNode;
        if (this.opaque === true && opaqueObjects.length > 0) this._renderObjects(opaqueObjects, camera, sceneRef, lightsNode);
        if (this.transparent === true && transparentObjects.length > 0) this._renderTransparents(transparentObjects, camera, sceneRef, lightsNode);
        // restore render tree
        nodeFrame.renderId = previousRenderId;
        this._currentRenderContext = previousRenderContext;
        this._currentRenderObjectFunction = previousRenderObjectFunction;
        this._compilationPromises = previousCompilationPromises;
        this._handleObjectFunction = this._renderObjectDirect;
        // wait for all promises setup by backends awaiting compilation/linking/pipeline creation to complete
        await Promise.all(compilationPromises);
    }
    async renderAsync(scene, camera) {
        if (this._initialized === false) await this.init();
        const renderContext = this._renderScene(scene, camera);
        await this.backend.resolveTimestampAsync(renderContext, 'render');
    }
    async waitForGPU() {
        await this.backend.waitForGPU();
    }
    setMRT(mrt) {
        this._mrt = mrt;
        return this;
    }
    getMRT() {
        return this._mrt;
    }
    _onDeviceLost(info) {
        let errorMessage = `THREE.WebGPURenderer: ${info.api} Device Lost:\n\nMessage: ${info.message}`;
        if (info.reason) errorMessage += `\nReason: ${info.reason}`;
        console.error(errorMessage);
        this._isDeviceLost = true;
    }
    _renderBundle(bundle, sceneRef, lightsNode) {
        const { bundleGroup: bundleGroup, camera: camera, renderList: renderList } = bundle;
        const renderContext = this._currentRenderContext;
        //
        const renderBundle = this._bundles.get(bundleGroup, camera);
        const renderBundleData = this.backend.get(renderBundle);
        if (renderBundleData.renderContexts === undefined) renderBundleData.renderContexts = new Set();
        //
        const needsUpdate = bundleGroup.version !== renderBundleData.version;
        const renderBundleNeedsUpdate = renderBundleData.renderContexts.has(renderContext) === false || needsUpdate;
        renderBundleData.renderContexts.add(renderContext);
        if (renderBundleNeedsUpdate) {
            this.backend.beginBundle(renderContext);
            if (renderBundleData.renderObjects === undefined || needsUpdate) renderBundleData.renderObjects = [];
            this._currentRenderBundle = renderBundle;
            const opaqueObjects = renderList.opaque;
            if (this.opaque === true && opaqueObjects.length > 0) this._renderObjects(opaqueObjects, camera, sceneRef, lightsNode);
            this._currentRenderBundle = null;
            //
            this.backend.finishBundle(renderContext, renderBundle);
            renderBundleData.version = bundleGroup.version;
        } else {
            const { renderObjects: renderObjects } = renderBundleData;
            for(let i = 0, l = renderObjects.length; i < l; i++){
                const renderObject = renderObjects[i];
                if (this._nodes.needsRefresh(renderObject)) {
                    this._nodes.updateBefore(renderObject);
                    this._nodes.updateForRender(renderObject);
                    this._bindings.updateForRender(renderObject);
                    this._nodes.updateAfter(renderObject);
                }
            }
        }
        this.backend.addBundle(renderContext, renderBundle);
    }
    render(scene, camera) {
        if (this._initialized === false) {
            console.warn('THREE.Renderer: .render() called before the backend is initialized. Try using .renderAsync() instead.');
            return this.renderAsync(scene, camera);
        }
        this._renderScene(scene, camera);
    }
    _getFrameBufferTarget() {
        const { currentToneMapping: currentToneMapping, currentColorSpace: currentColorSpace } = this;
        const useToneMapping = currentToneMapping !== (0, $cb5ee595c0f892af$export$9fcb6b4294603b2);
        const useColorSpace = currentColorSpace !== (0, $cb5ee595c0f892af$export$42429b3acfb233a4);
        if (useToneMapping === false && useColorSpace === false) return null;
        const { width: width, height: height } = this.getDrawingBufferSize($1010750c439bdb5c$var$_drawingBufferSize);
        const { depth: depth, stencil: stencil } = this;
        let frameBufferTarget = this._frameBufferTarget;
        if (frameBufferTarget === null) {
            frameBufferTarget = new (0, $2ca03eab531e649d$export$efcb1f8bf367cbfb)(width, height, {
                depthBuffer: depth,
                stencilBuffer: stencil,
                type: (0, $cb5ee595c0f892af$export$2697304443f382bc),
                format: (0, $cb5ee595c0f892af$export$3f8bb04b555a363c),
                colorSpace: (0, $cb5ee595c0f892af$export$42429b3acfb233a4),
                generateMipmaps: false,
                minFilter: (0, $cb5ee595c0f892af$export$8a72f490b25c56c8),
                magFilter: (0, $cb5ee595c0f892af$export$8a72f490b25c56c8),
                samples: this.samples
            });
            frameBufferTarget.isPostProcessingRenderTarget = true;
            this._frameBufferTarget = frameBufferTarget;
        }
        frameBufferTarget.depthBuffer = depth;
        frameBufferTarget.stencilBuffer = stencil;
        frameBufferTarget.setSize(width, height);
        frameBufferTarget.viewport.copy(this._viewport);
        frameBufferTarget.scissor.copy(this._scissor);
        frameBufferTarget.viewport.multiplyScalar(this._pixelRatio);
        frameBufferTarget.scissor.multiplyScalar(this._pixelRatio);
        frameBufferTarget.scissorTest = this._scissorTest;
        return frameBufferTarget;
    }
    _renderScene(scene, camera, useFrameBufferTarget = true) {
        if (this._isDeviceLost === true) return;
        const frameBufferTarget = useFrameBufferTarget ? this._getFrameBufferTarget() : null;
        // preserve render tree
        const nodeFrame = this._nodes.nodeFrame;
        const previousRenderId = nodeFrame.renderId;
        const previousRenderContext = this._currentRenderContext;
        const previousRenderObjectFunction = this._currentRenderObjectFunction;
        //
        const sceneRef = scene.isScene === true ? scene : $1010750c439bdb5c$var$_scene;
        const outputRenderTarget = this._renderTarget;
        const activeCubeFace = this._activeCubeFace;
        const activeMipmapLevel = this._activeMipmapLevel;
        //
        let renderTarget;
        if (frameBufferTarget !== null) {
            renderTarget = frameBufferTarget;
            this.setRenderTarget(renderTarget);
        } else renderTarget = outputRenderTarget;
        //
        const renderContext = this._renderContexts.get(scene, camera, renderTarget);
        this._currentRenderContext = renderContext;
        this._currentRenderObjectFunction = this._renderObjectFunction || this.renderObject;
        //
        this.info.calls++;
        this.info.render.calls++;
        this.info.render.frameCalls++;
        nodeFrame.renderId = this.info.calls;
        //
        const coordinateSystem = this.coordinateSystem;
        if (camera.coordinateSystem !== coordinateSystem) {
            camera.coordinateSystem = coordinateSystem;
            camera.updateProjectionMatrix();
        }
        //
        if (scene.matrixWorldAutoUpdate === true) scene.updateMatrixWorld();
        if (camera.parent === null && camera.matrixWorldAutoUpdate === true) camera.updateMatrixWorld();
        //
        let viewport = this._viewport;
        let scissor = this._scissor;
        let pixelRatio = this._pixelRatio;
        if (renderTarget !== null) {
            viewport = renderTarget.viewport;
            scissor = renderTarget.scissor;
            pixelRatio = 1;
        }
        this.getDrawingBufferSize($1010750c439bdb5c$var$_drawingBufferSize);
        $1010750c439bdb5c$var$_screen.set(0, 0, $1010750c439bdb5c$var$_drawingBufferSize.width, $1010750c439bdb5c$var$_drawingBufferSize.height);
        const minDepth = viewport.minDepth === undefined ? 0 : viewport.minDepth;
        const maxDepth = viewport.maxDepth === undefined ? 1 : viewport.maxDepth;
        renderContext.viewportValue.copy(viewport).multiplyScalar(pixelRatio).floor();
        renderContext.viewportValue.width >>= activeMipmapLevel;
        renderContext.viewportValue.height >>= activeMipmapLevel;
        renderContext.viewportValue.minDepth = minDepth;
        renderContext.viewportValue.maxDepth = maxDepth;
        renderContext.viewport = renderContext.viewportValue.equals($1010750c439bdb5c$var$_screen) === false;
        renderContext.scissorValue.copy(scissor).multiplyScalar(pixelRatio).floor();
        renderContext.scissor = this._scissorTest && renderContext.scissorValue.equals($1010750c439bdb5c$var$_screen) === false;
        renderContext.scissorValue.width >>= activeMipmapLevel;
        renderContext.scissorValue.height >>= activeMipmapLevel;
        if (!renderContext.clippingContext) renderContext.clippingContext = new (0, $40f294098437e551$export$2e2bcd8739ae039)();
        renderContext.clippingContext.updateGlobal(this, camera);
        //
        sceneRef.onBeforeRender(this, scene, camera, renderTarget);
        //
        $1010750c439bdb5c$var$_projScreenMatrix.multiplyMatrices(camera.projectionMatrix, camera.matrixWorldInverse);
        $1010750c439bdb5c$var$_frustum.setFromProjectionMatrix($1010750c439bdb5c$var$_projScreenMatrix, coordinateSystem);
        const renderList = this._renderLists.get(scene, camera);
        renderList.begin();
        this._projectObject(scene, camera, 0, renderList);
        renderList.finish();
        if (this.sortObjects === true) renderList.sort(this._opaqueSort, this._transparentSort);
        //
        if (renderTarget !== null) {
            this._textures.updateRenderTarget(renderTarget, activeMipmapLevel);
            const renderTargetData = this._textures.get(renderTarget);
            renderContext.textures = renderTargetData.textures;
            renderContext.depthTexture = renderTargetData.depthTexture;
            renderContext.width = renderTargetData.width;
            renderContext.height = renderTargetData.height;
            renderContext.renderTarget = renderTarget;
            renderContext.depth = renderTarget.depthBuffer;
            renderContext.stencil = renderTarget.stencilBuffer;
        } else {
            renderContext.textures = null;
            renderContext.depthTexture = null;
            renderContext.width = this.domElement.width;
            renderContext.height = this.domElement.height;
            renderContext.depth = this.depth;
            renderContext.stencil = this.stencil;
        }
        renderContext.width >>= activeMipmapLevel;
        renderContext.height >>= activeMipmapLevel;
        renderContext.activeCubeFace = activeCubeFace;
        renderContext.activeMipmapLevel = activeMipmapLevel;
        renderContext.occlusionQueryCount = renderList.occlusionQueryCount;
        //
        this._nodes.updateScene(sceneRef);
        //
        this._background.update(sceneRef, renderList, renderContext);
        //
        this.backend.beginRender(renderContext);
        // process render lists
        const { bundles: bundles, lightsNode: lightsNode, transparentDoublePass: transparentDoublePassObjects, transparent: transparentObjects, opaque: opaqueObjects } = renderList;
        if (bundles.length > 0) this._renderBundles(bundles, sceneRef, lightsNode);
        if (this.opaque === true && opaqueObjects.length > 0) this._renderObjects(opaqueObjects, camera, sceneRef, lightsNode);
        if (this.transparent === true && transparentObjects.length > 0) this._renderTransparents(transparentObjects, transparentDoublePassObjects, camera, sceneRef, lightsNode);
        // finish render pass
        this.backend.finishRender(renderContext);
        // restore render tree
        nodeFrame.renderId = previousRenderId;
        this._currentRenderContext = previousRenderContext;
        this._currentRenderObjectFunction = previousRenderObjectFunction;
        //
        if (frameBufferTarget !== null) {
            this.setRenderTarget(outputRenderTarget, activeCubeFace, activeMipmapLevel);
            const quad = this._quad;
            if (this._nodes.hasOutputChange(renderTarget.texture)) {
                quad.material.fragmentNode = this._nodes.getOutputNode(renderTarget.texture);
                quad.material.needsUpdate = true;
            }
            this._renderScene(quad, quad.camera, false);
        }
        //
        sceneRef.onAfterRender(this, scene, camera, renderTarget);
        //
        return renderContext;
    }
    getMaxAnisotropy() {
        return this.backend.getMaxAnisotropy();
    }
    getActiveCubeFace() {
        return this._activeCubeFace;
    }
    getActiveMipmapLevel() {
        return this._activeMipmapLevel;
    }
    async setAnimationLoop(callback) {
        if (this._initialized === false) await this.init();
        this._animation.setAnimationLoop(callback);
    }
    async getArrayBufferAsync(attribute) {
        return await this.backend.getArrayBufferAsync(attribute);
    }
    getContext() {
        return this.backend.getContext();
    }
    getPixelRatio() {
        return this._pixelRatio;
    }
    getDrawingBufferSize(target) {
        return target.set(this._width * this._pixelRatio, this._height * this._pixelRatio).floor();
    }
    getSize(target) {
        return target.set(this._width, this._height);
    }
    setPixelRatio(value = 1) {
        if (this._pixelRatio === value) return;
        this._pixelRatio = value;
        this.setSize(this._width, this._height, false);
    }
    setDrawingBufferSize(width, height, pixelRatio) {
        this._width = width;
        this._height = height;
        this._pixelRatio = pixelRatio;
        this.domElement.width = Math.floor(width * pixelRatio);
        this.domElement.height = Math.floor(height * pixelRatio);
        this.setViewport(0, 0, width, height);
        if (this._initialized) this.backend.updateSize();
    }
    setSize(width, height, updateStyle = true) {
        this._width = width;
        this._height = height;
        this.domElement.width = Math.floor(width * this._pixelRatio);
        this.domElement.height = Math.floor(height * this._pixelRatio);
        if (updateStyle === true) {
            this.domElement.style.width = width + 'px';
            this.domElement.style.height = height + 'px';
        }
        this.setViewport(0, 0, width, height);
        if (this._initialized) this.backend.updateSize();
    }
    setOpaqueSort(method) {
        this._opaqueSort = method;
    }
    setTransparentSort(method) {
        this._transparentSort = method;
    }
    getScissor(target) {
        const scissor = this._scissor;
        target.x = scissor.x;
        target.y = scissor.y;
        target.width = scissor.width;
        target.height = scissor.height;
        return target;
    }
    setScissor(x, y, width, height) {
        const scissor = this._scissor;
        if (x.isVector4) scissor.copy(x);
        else scissor.set(x, y, width, height);
    }
    getScissorTest() {
        return this._scissorTest;
    }
    setScissorTest(boolean) {
        this._scissorTest = boolean;
        this.backend.setScissorTest(boolean);
    }
    getViewport(target) {
        return target.copy(this._viewport);
    }
    setViewport(x, y, width, height, minDepth = 0, maxDepth = 1) {
        const viewport = this._viewport;
        if (x.isVector4) viewport.copy(x);
        else viewport.set(x, y, width, height);
        viewport.minDepth = minDepth;
        viewport.maxDepth = maxDepth;
    }
    getClearColor(target) {
        return target.copy(this._clearColor);
    }
    setClearColor(color, alpha = 1) {
        this._clearColor.set(color);
        this._clearColor.a = alpha;
    }
    getClearAlpha() {
        return this._clearColor.a;
    }
    setClearAlpha(alpha) {
        this._clearColor.a = alpha;
    }
    getClearDepth() {
        return this._clearDepth;
    }
    setClearDepth(depth) {
        this._clearDepth = depth;
    }
    getClearStencil() {
        return this._clearStencil;
    }
    setClearStencil(stencil) {
        this._clearStencil = stencil;
    }
    isOccluded(object) {
        const renderContext = this._currentRenderContext;
        return renderContext && this.backend.isOccluded(renderContext, object);
    }
    clear(color = true, depth = true, stencil = true) {
        if (this._initialized === false) {
            console.warn('THREE.Renderer: .clear() called before the backend is initialized. Try using .clearAsync() instead.');
            return this.clearAsync(color, depth, stencil);
        }
        const renderTarget = this._renderTarget || this._getFrameBufferTarget();
        let renderTargetData = null;
        if (renderTarget !== null) {
            this._textures.updateRenderTarget(renderTarget);
            renderTargetData = this._textures.get(renderTarget);
        }
        this.backend.clear(color, depth, stencil, renderTargetData);
        if (renderTarget !== null && this._renderTarget === null) {
            // If a color space transform or tone mapping is required,
            // the clear operation clears the intermediate renderTarget texture, but does not update the screen canvas.
            const quad = this._quad;
            if (this._nodes.hasOutputChange(renderTarget.texture)) {
                quad.material.fragmentNode = this._nodes.getOutputNode(renderTarget.texture);
                quad.material.needsUpdate = true;
            }
            this._renderScene(quad, quad.camera, false);
        }
    }
    clearColor() {
        return this.clear(true, false, false);
    }
    clearDepth() {
        return this.clear(false, true, false);
    }
    clearStencil() {
        return this.clear(false, false, true);
    }
    async clearAsync(color = true, depth = true, stencil = true) {
        if (this._initialized === false) await this.init();
        this.clear(color, depth, stencil);
    }
    clearColorAsync() {
        return this.clearAsync(true, false, false);
    }
    clearDepthAsync() {
        return this.clearAsync(false, true, false);
    }
    clearStencilAsync() {
        return this.clearAsync(false, false, true);
    }
    get currentToneMapping() {
        return this._renderTarget !== null ? (0, $cb5ee595c0f892af$export$9fcb6b4294603b2) : this.toneMapping;
    }
    get currentColorSpace() {
        return this._renderTarget !== null ? (0, $cb5ee595c0f892af$export$42429b3acfb233a4) : this.outputColorSpace;
    }
    dispose() {
        this.info.dispose();
        this.backend.dispose();
        this._animation.dispose();
        this._objects.dispose();
        this._pipelines.dispose();
        this._nodes.dispose();
        this._bindings.dispose();
        this._renderLists.dispose();
        this._renderContexts.dispose();
        this._textures.dispose();
        this.setRenderTarget(null);
        this.setAnimationLoop(null);
    }
    setRenderTarget(renderTarget, activeCubeFace = 0, activeMipmapLevel = 0) {
        this._renderTarget = renderTarget;
        this._activeCubeFace = activeCubeFace;
        this._activeMipmapLevel = activeMipmapLevel;
    }
    getRenderTarget() {
        return this._renderTarget;
    }
    setRenderObjectFunction(renderObjectFunction) {
        this._renderObjectFunction = renderObjectFunction;
    }
    getRenderObjectFunction() {
        return this._renderObjectFunction;
    }
    compute(computeNodes) {
        if (this.isDeviceLost === true) return;
        if (this._initialized === false) {
            console.warn('THREE.Renderer: .compute() called before the backend is initialized. Try using .computeAsync() instead.');
            return this.computeAsync(computeNodes);
        }
        //
        const nodeFrame = this._nodes.nodeFrame;
        const previousRenderId = nodeFrame.renderId;
        //
        this.info.calls++;
        this.info.compute.calls++;
        this.info.compute.frameCalls++;
        nodeFrame.renderId = this.info.calls;
        //
        const backend = this.backend;
        const pipelines = this._pipelines;
        const bindings = this._bindings;
        const nodes = this._nodes;
        const computeList = Array.isArray(computeNodes) ? computeNodes : [
            computeNodes
        ];
        if (computeList[0] === undefined || computeList[0].isComputeNode !== true) throw new Error('THREE.Renderer: .compute() expects a ComputeNode.');
        backend.beginCompute(computeNodes);
        for (const computeNode of computeList){
            // onInit
            if (pipelines.has(computeNode) === false) {
                const dispose = ()=>{
                    computeNode.removeEventListener('dispose', dispose);
                    pipelines.delete(computeNode);
                    bindings.delete(computeNode);
                    nodes.delete(computeNode);
                };
                computeNode.addEventListener('dispose', dispose);
                //
                const onInitFn = computeNode.onInitFunction;
                if (onInitFn !== null) onInitFn.call(computeNode, {
                    renderer: this
                });
            }
            nodes.updateForCompute(computeNode);
            bindings.updateForCompute(computeNode);
            const computeBindings = bindings.getForCompute(computeNode);
            const computePipeline = pipelines.getForCompute(computeNode, computeBindings);
            backend.compute(computeNodes, computeNode, computeBindings, computePipeline);
        }
        backend.finishCompute(computeNodes);
        //
        nodeFrame.renderId = previousRenderId;
    }
    async computeAsync(computeNodes) {
        if (this._initialized === false) await this.init();
        this.compute(computeNodes);
        await this.backend.resolveTimestampAsync(computeNodes, 'compute');
    }
    async hasFeatureAsync(name) {
        if (this._initialized === false) await this.init();
        return this.backend.hasFeature(name);
    }
    hasFeature(name) {
        if (this._initialized === false) {
            console.warn('THREE.Renderer: .hasFeature() called before the backend is initialized. Try using .hasFeatureAsync() instead.');
            return false;
        }
        return this.backend.hasFeature(name);
    }
    copyFramebufferToTexture(framebufferTexture, rectangle = null) {
        if (rectangle !== null) {
            if (rectangle.isVector2) rectangle = $1010750c439bdb5c$var$_vector4.set(rectangle.x, rectangle.y, framebufferTexture.image.width, framebufferTexture.image.height).floor();
            else if (rectangle.isVector4) rectangle = $1010750c439bdb5c$var$_vector4.copy(rectangle).floor();
            else {
                console.error('THREE.Renderer.copyFramebufferToTexture: Invalid rectangle.');
                return;
            }
        } else rectangle = $1010750c439bdb5c$var$_vector4.set(0, 0, framebufferTexture.image.width, framebufferTexture.image.height);
        //
        let renderContext = this._currentRenderContext;
        let renderTarget;
        if (renderContext !== null) renderTarget = renderContext.renderTarget;
        else {
            renderTarget = this._renderTarget || this._getFrameBufferTarget();
            if (renderTarget !== null) {
                this._textures.updateRenderTarget(renderTarget);
                renderContext = this._textures.get(renderTarget);
            }
        }
        //
        this._textures.updateTexture(framebufferTexture, {
            renderTarget: renderTarget
        });
        this.backend.copyFramebufferToTexture(framebufferTexture, renderContext, rectangle);
    }
    copyTextureToTexture(srcTexture, dstTexture, srcRegion = null, dstPosition = null, level = 0) {
        this._textures.updateTexture(srcTexture);
        this._textures.updateTexture(dstTexture);
        this.backend.copyTextureToTexture(srcTexture, dstTexture, srcRegion, dstPosition, level);
    }
    readRenderTargetPixelsAsync(renderTarget, x, y, width, height, index = 0, faceIndex = 0) {
        return this.backend.copyTextureToBuffer(renderTarget.textures[index], x, y, width, height, faceIndex);
    }
    _projectObject(object, camera, groupOrder, renderList) {
        if (object.visible === false) return;
        const visible = object.layers.test(camera.layers);
        if (visible) {
            if (object.isGroup) groupOrder = object.renderOrder;
            else if (object.isLOD) {
                if (object.autoUpdate === true) object.update(camera);
            } else if (object.isLight) renderList.pushLight(object);
            else if (object.isSprite) {
                if (!object.frustumCulled || $1010750c439bdb5c$var$_frustum.intersectsSprite(object)) {
                    if (this.sortObjects === true) $1010750c439bdb5c$var$_vector4.setFromMatrixPosition(object.matrixWorld).applyMatrix4($1010750c439bdb5c$var$_projScreenMatrix);
                    const { geometry: geometry, material: material } = object;
                    if (material.visible) renderList.push(object, geometry, material, groupOrder, $1010750c439bdb5c$var$_vector4.z, null);
                }
            } else if (object.isLineLoop) console.error('THREE.Renderer: Objects of type THREE.LineLoop are not supported. Please use THREE.Line or THREE.LineSegments.');
            else if (object.isMesh || object.isLine || object.isPoints) {
                if (!object.frustumCulled || $1010750c439bdb5c$var$_frustum.intersectsObject(object)) {
                    const { geometry: geometry, material: material } = object;
                    if (this.sortObjects === true) {
                        if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
                        $1010750c439bdb5c$var$_vector4.copy(geometry.boundingSphere.center).applyMatrix4(object.matrixWorld).applyMatrix4($1010750c439bdb5c$var$_projScreenMatrix);
                    }
                    if (Array.isArray(material)) {
                        const groups = geometry.groups;
                        for(let i = 0, l = groups.length; i < l; i++){
                            const group = groups[i];
                            const groupMaterial = material[group.materialIndex];
                            if (groupMaterial && groupMaterial.visible) renderList.push(object, geometry, groupMaterial, groupOrder, $1010750c439bdb5c$var$_vector4.z, group);
                        }
                    } else if (material.visible) renderList.push(object, geometry, material, groupOrder, $1010750c439bdb5c$var$_vector4.z, null);
                }
            }
        }
        if (object.isBundleGroup === true && this.backend.beginBundle !== undefined) {
            const baseRenderList = renderList;
            // replace render list
            renderList = this._renderLists.get(object, camera);
            renderList.begin();
            baseRenderList.pushBundle({
                bundleGroup: object,
                camera: camera,
                renderList: renderList
            });
            renderList.finish();
        }
        const children = object.children;
        for(let i = 0, l = children.length; i < l; i++)this._projectObject(children[i], camera, groupOrder, renderList);
    }
    _renderBundles(bundles, sceneRef, lightsNode) {
        for (const bundle of bundles)this._renderBundle(bundle, sceneRef, lightsNode);
    }
    _renderTransparents(renderList, doublePassList, camera, scene, lightsNode) {
        if (doublePassList.length > 0) {
            // render back side
            for (const { material: material } of doublePassList)material.side = (0, $cb5ee595c0f892af$export$d9f0486e75b5ace);
            this._renderObjects(doublePassList, camera, scene, lightsNode, 'backSide');
            // render front side
            for (const { material: material } of doublePassList)material.side = (0, $cb5ee595c0f892af$export$2ede184fc2998901);
            this._renderObjects(renderList, camera, scene, lightsNode);
            // restore
            for (const { material: material } of doublePassList)material.side = (0, $cb5ee595c0f892af$export$3b296b6f144d5b03);
        } else this._renderObjects(renderList, camera, scene, lightsNode);
    }
    _renderObjects(renderList, camera, scene, lightsNode, passId = null) {
        // process renderable objects
        for(let i = 0, il = renderList.length; i < il; i++){
            const renderItem = renderList[i];
            // @TODO: Add support for multiple materials per object. This will require to extract
            // the material from the renderItem object and pass it with its group data to renderObject().
            const { object: object, geometry: geometry, material: material, group: group } = renderItem;
            if (camera.isArrayCamera) {
                const cameras = camera.cameras;
                for(let j = 0, jl = cameras.length; j < jl; j++){
                    const camera2 = cameras[j];
                    if (object.layers.test(camera2.layers)) {
                        const vp = camera2.viewport;
                        const minDepth = vp.minDepth === undefined ? 0 : vp.minDepth;
                        const maxDepth = vp.maxDepth === undefined ? 1 : vp.maxDepth;
                        const viewportValue = this._currentRenderContext.viewportValue;
                        viewportValue.copy(vp).multiplyScalar(this._pixelRatio).floor();
                        viewportValue.minDepth = minDepth;
                        viewportValue.maxDepth = maxDepth;
                        this.backend.updateViewport(this._currentRenderContext);
                        this._currentRenderObjectFunction(object, scene, camera2, geometry, material, group, lightsNode, passId);
                    }
                }
            } else this._currentRenderObjectFunction(object, scene, camera, geometry, material, group, lightsNode, passId);
        }
    }
    renderObject(object, scene, camera, geometry, material, group, lightsNode, passId = null) {
        let overridePositionNode;
        let overrideFragmentNode;
        let overrideDepthNode;
        //
        object.onBeforeRender(this, scene, camera, geometry, material, group);
        //
        if (scene.overrideMaterial !== null) {
            const overrideMaterial = scene.overrideMaterial;
            if (material.positionNode && material.positionNode.isNode) {
                overridePositionNode = overrideMaterial.positionNode;
                overrideMaterial.positionNode = material.positionNode;
            }
            if (overrideMaterial.isShadowNodeMaterial) {
                overrideMaterial.side = material.shadowSide === null ? material.side : material.shadowSide;
                if (material.depthNode && material.depthNode.isNode) {
                    overrideDepthNode = overrideMaterial.depthNode;
                    overrideMaterial.depthNode = material.depthNode;
                }
                if (material.shadowNode && material.shadowNode.isNode) {
                    overrideFragmentNode = overrideMaterial.fragmentNode;
                    overrideMaterial.fragmentNode = material.shadowNode;
                }
                if (this.localClippingEnabled) {
                    if (material.clipShadows) {
                        if (overrideMaterial.clippingPlanes !== material.clippingPlanes) {
                            overrideMaterial.clippingPlanes = material.clippingPlanes;
                            overrideMaterial.needsUpdate = true;
                        }
                        if (overrideMaterial.clipIntersection !== material.clipIntersection) overrideMaterial.clipIntersection = material.clipIntersection;
                    } else if (Array.isArray(overrideMaterial.clippingPlanes)) {
                        overrideMaterial.clippingPlanes = null;
                        overrideMaterial.needsUpdate = true;
                    }
                }
            }
            material = overrideMaterial;
        }
        //
        if (material.transparent === true && material.side === (0, $cb5ee595c0f892af$export$3b296b6f144d5b03) && material.forceSinglePass === false) {
            material.side = (0, $cb5ee595c0f892af$export$d9f0486e75b5ace);
            this._handleObjectFunction(object, material, scene, camera, lightsNode, group, 'backSide'); // create backSide pass id
            material.side = (0, $cb5ee595c0f892af$export$2ede184fc2998901);
            this._handleObjectFunction(object, material, scene, camera, lightsNode, group, passId); // use default pass id
            material.side = (0, $cb5ee595c0f892af$export$3b296b6f144d5b03);
        } else this._handleObjectFunction(object, material, scene, camera, lightsNode, group, passId);
        //
        if (overridePositionNode !== undefined) scene.overrideMaterial.positionNode = overridePositionNode;
        if (overrideDepthNode !== undefined) scene.overrideMaterial.depthNode = overrideDepthNode;
        if (overrideFragmentNode !== undefined) scene.overrideMaterial.fragmentNode = overrideFragmentNode;
        //
        object.onAfterRender(this, scene, camera, geometry, material, group);
    }
    _renderObjectDirect(object, material, scene, camera, lightsNode, group, passId) {
        const renderObject = this._objects.get(object, material, scene, camera, lightsNode, this._currentRenderContext, passId);
        renderObject.drawRange = object.geometry.drawRange;
        renderObject.group = group;
        //
        const needsRefresh = this._nodes.needsRefresh(renderObject);
        if (needsRefresh) {
            this._nodes.updateBefore(renderObject);
            this._geometries.updateForRender(renderObject);
            this._nodes.updateForRender(renderObject);
            this._bindings.updateForRender(renderObject);
        }
        this._pipelines.updateForRender(renderObject);
        //
        if (this._currentRenderBundle !== null) {
            const renderBundleData = this.backend.get(this._currentRenderBundle);
            renderBundleData.renderObjects.push(renderObject);
            renderObject.bundle = this._currentRenderBundle.scene;
        }
        this.backend.draw(renderObject, this.info);
        if (needsRefresh) this._nodes.updateAfter(renderObject);
    }
    _createObjectPipeline(object, material, scene, camera, lightsNode, passId) {
        const renderObject = this._objects.get(object, material, scene, camera, lightsNode, this._currentRenderContext, passId);
        //
        this._nodes.updateBefore(renderObject);
        this._geometries.updateForRender(renderObject);
        this._nodes.updateForRender(renderObject);
        this._bindings.updateForRender(renderObject);
        this._pipelines.getForRender(renderObject, this._compilationPromises);
        this._nodes.updateAfter(renderObject);
    }
    get compile() {
        return this.compileAsync;
    }
}
var $1010750c439bdb5c$export$2e2bcd8739ae039 = $1010750c439bdb5c$var$Renderer;



class $3d47fc7f553021d2$var$Binding {
    constructor(name = ''){
        this.name = name;
        this.visibility = 0;
    }
    setVisibility(visibility) {
        this.visibility |= visibility;
    }
    clone() {
        return Object.assign(new this.constructor(), this);
    }
}
var $3d47fc7f553021d2$export$2e2bcd8739ae039 = $3d47fc7f553021d2$var$Binding;



function $1d9dc17ff4d49dc7$export$c81ed6e730b66b07(floatLength) {
    // ensure chunk size alignment (STD140 layout)
    return floatLength + ((0, $a4815dd317c56025$export$a9b1b2f99a40d5cb) - floatLength % (0, $a4815dd317c56025$export$a9b1b2f99a40d5cb)) % (0, $a4815dd317c56025$export$a9b1b2f99a40d5cb);
}
function $1d9dc17ff4d49dc7$export$9c9d159a07ebea2f(count, vectorLength = 4) {
    const strideLength = $1d9dc17ff4d49dc7$export$e35627f2faa4b15(vectorLength);
    const floatLength = strideLength * count;
    return $1d9dc17ff4d49dc7$export$c81ed6e730b66b07(floatLength);
}
function $1d9dc17ff4d49dc7$export$e35627f2faa4b15(vectorLength) {
    const strideLength = 4;
    return vectorLength + (strideLength - vectorLength % strideLength) % strideLength;
}


class $d67513964dae471e$var$Buffer extends (0, $3d47fc7f553021d2$export$2e2bcd8739ae039) {
    constructor(name, buffer = null){
        super(name);
        this.isBuffer = true;
        this.bytesPerElement = Float32Array.BYTES_PER_ELEMENT;
        this._buffer = buffer;
    }
    get byteLength() {
        return (0, $1d9dc17ff4d49dc7$export$c81ed6e730b66b07)(this._buffer.byteLength);
    }
    get buffer() {
        return this._buffer;
    }
    update() {
        return true;
    }
}
var $d67513964dae471e$export$2e2bcd8739ae039 = $d67513964dae471e$var$Buffer;


class $07c0605ee21c34a6$var$UniformBuffer extends (0, $d67513964dae471e$export$2e2bcd8739ae039) {
    constructor(name, buffer = null){
        super(name, buffer);
        this.isUniformBuffer = true;
    }
}
var $07c0605ee21c34a6$export$2e2bcd8739ae039 = $07c0605ee21c34a6$var$UniformBuffer;


let $acea95d61477db49$var$_id = 0;
class $acea95d61477db49$var$NodeUniformBuffer extends (0, $07c0605ee21c34a6$export$2e2bcd8739ae039) {
    constructor(nodeUniform, groupNode){
        super('UniformBuffer_' + $acea95d61477db49$var$_id++, nodeUniform ? nodeUniform.value : null);
        this.nodeUniform = nodeUniform;
        this.groupNode = groupNode;
    }
    get buffer() {
        return this.nodeUniform.value;
    }
}
var $acea95d61477db49$export$2e2bcd8739ae039 = $acea95d61477db49$var$NodeUniformBuffer;




class $e6942d11cf9f6924$var$UniformsGroup extends (0, $07c0605ee21c34a6$export$2e2bcd8739ae039) {
    constructor(name){
        super(name);
        this.isUniformsGroup = true;
        this._values = null;
        // the order of uniforms in this array must match the order of uniforms in the shader
        this.uniforms = [];
    }
    addUniform(uniform) {
        this.uniforms.push(uniform);
        return this;
    }
    removeUniform(uniform) {
        const index = this.uniforms.indexOf(uniform);
        if (index !== -1) this.uniforms.splice(index, 1);
        return this;
    }
    get values() {
        if (this._values === null) this._values = Array.from(this.buffer);
        return this._values;
    }
    get buffer() {
        let buffer = this._buffer;
        if (buffer === null) {
            const byteLength = this.byteLength;
            buffer = new Float32Array(new ArrayBuffer(byteLength));
            this._buffer = buffer;
        }
        return buffer;
    }
    get byteLength() {
        let offset = 0; // global buffer offset in bytes
        for(let i = 0, l = this.uniforms.length; i < l; i++){
            const uniform = this.uniforms[i];
            const { boundary: boundary, itemSize: itemSize } = uniform;
            // offset within a single chunk in bytes
            const chunkOffset = offset % (0, $a4815dd317c56025$export$a9b1b2f99a40d5cb);
            const remainingSizeInChunk = (0, $a4815dd317c56025$export$a9b1b2f99a40d5cb) - chunkOffset;
            // conformance tests
            if (chunkOffset !== 0 && remainingSizeInChunk - boundary < 0) // check for chunk overflow
            offset += (0, $a4815dd317c56025$export$a9b1b2f99a40d5cb) - chunkOffset;
            else if (chunkOffset % boundary !== 0) // check for correct alignment
            offset += chunkOffset % boundary;
            uniform.offset = offset / this.bytesPerElement;
            offset += itemSize * this.bytesPerElement;
        }
        return Math.ceil(offset / (0, $a4815dd317c56025$export$a9b1b2f99a40d5cb)) * (0, $a4815dd317c56025$export$a9b1b2f99a40d5cb);
    }
    update() {
        let updated = false;
        for (const uniform of this.uniforms)if (this.updateByType(uniform) === true) updated = true;
        return updated;
    }
    updateByType(uniform) {
        if (uniform.isNumberUniform) return this.updateNumber(uniform);
        if (uniform.isVector2Uniform) return this.updateVector2(uniform);
        if (uniform.isVector3Uniform) return this.updateVector3(uniform);
        if (uniform.isVector4Uniform) return this.updateVector4(uniform);
        if (uniform.isColorUniform) return this.updateColor(uniform);
        if (uniform.isMatrix3Uniform) return this.updateMatrix3(uniform);
        if (uniform.isMatrix4Uniform) return this.updateMatrix4(uniform);
        console.error('THREE.WebGPUUniformsGroup: Unsupported uniform type.', uniform);
    }
    updateNumber(uniform) {
        let updated = false;
        const a = this.values;
        const v = uniform.getValue();
        const offset = uniform.offset;
        if (a[offset] !== v) {
            const b = this.buffer;
            b[offset] = a[offset] = v;
            updated = true;
        }
        return updated;
    }
    updateVector2(uniform) {
        let updated = false;
        const a = this.values;
        const v = uniform.getValue();
        const offset = uniform.offset;
        if (a[offset + 0] !== v.x || a[offset + 1] !== v.y) {
            const b = this.buffer;
            b[offset + 0] = a[offset + 0] = v.x;
            b[offset + 1] = a[offset + 1] = v.y;
            updated = true;
        }
        return updated;
    }
    updateVector3(uniform) {
        let updated = false;
        const a = this.values;
        const v = uniform.getValue();
        const offset = uniform.offset;
        if (a[offset + 0] !== v.x || a[offset + 1] !== v.y || a[offset + 2] !== v.z) {
            const b = this.buffer;
            b[offset + 0] = a[offset + 0] = v.x;
            b[offset + 1] = a[offset + 1] = v.y;
            b[offset + 2] = a[offset + 2] = v.z;
            updated = true;
        }
        return updated;
    }
    updateVector4(uniform) {
        let updated = false;
        const a = this.values;
        const v = uniform.getValue();
        const offset = uniform.offset;
        if (a[offset + 0] !== v.x || a[offset + 1] !== v.y || a[offset + 2] !== v.z || a[offset + 4] !== v.w) {
            const b = this.buffer;
            b[offset + 0] = a[offset + 0] = v.x;
            b[offset + 1] = a[offset + 1] = v.y;
            b[offset + 2] = a[offset + 2] = v.z;
            b[offset + 3] = a[offset + 3] = v.w;
            updated = true;
        }
        return updated;
    }
    updateColor(uniform) {
        let updated = false;
        const a = this.values;
        const c = uniform.getValue();
        const offset = uniform.offset;
        if (a[offset + 0] !== c.r || a[offset + 1] !== c.g || a[offset + 2] !== c.b) {
            const b = this.buffer;
            b[offset + 0] = a[offset + 0] = c.r;
            b[offset + 1] = a[offset + 1] = c.g;
            b[offset + 2] = a[offset + 2] = c.b;
            updated = true;
        }
        return updated;
    }
    updateMatrix3(uniform) {
        let updated = false;
        const a = this.values;
        const e = uniform.getValue().elements;
        const offset = uniform.offset;
        if (a[offset + 0] !== e[0] || a[offset + 1] !== e[1] || a[offset + 2] !== e[2] || a[offset + 4] !== e[3] || a[offset + 5] !== e[4] || a[offset + 6] !== e[5] || a[offset + 8] !== e[6] || a[offset + 9] !== e[7] || a[offset + 10] !== e[8]) {
            const b = this.buffer;
            b[offset + 0] = a[offset + 0] = e[0];
            b[offset + 1] = a[offset + 1] = e[1];
            b[offset + 2] = a[offset + 2] = e[2];
            b[offset + 4] = a[offset + 4] = e[3];
            b[offset + 5] = a[offset + 5] = e[4];
            b[offset + 6] = a[offset + 6] = e[5];
            b[offset + 8] = a[offset + 8] = e[6];
            b[offset + 9] = a[offset + 9] = e[7];
            b[offset + 10] = a[offset + 10] = e[8];
            updated = true;
        }
        return updated;
    }
    updateMatrix4(uniform) {
        let updated = false;
        const a = this.values;
        const e = uniform.getValue().elements;
        const offset = uniform.offset;
        if ($e6942d11cf9f6924$var$arraysEqual(a, e, offset) === false) {
            const b = this.buffer;
            b.set(e, offset);
            $e6942d11cf9f6924$var$setArray(a, e, offset);
            updated = true;
        }
        return updated;
    }
}
function $e6942d11cf9f6924$var$setArray(a, b, offset) {
    for(let i = 0, l = b.length; i < l; i++)a[offset + i] = b[i];
}
function $e6942d11cf9f6924$var$arraysEqual(a, b, offset) {
    for(let i = 0, l = b.length; i < l; i++){
        if (a[offset + i] !== b[i]) return false;
    }
    return true;
}
var $e6942d11cf9f6924$export$2e2bcd8739ae039 = $e6942d11cf9f6924$var$UniformsGroup;


let $859d0a2a1eca4de4$var$_id = 0;
class $859d0a2a1eca4de4$var$NodeUniformsGroup extends (0, $e6942d11cf9f6924$export$2e2bcd8739ae039) {
    constructor(name, groupNode){
        super(name);
        this.id = $859d0a2a1eca4de4$var$_id++;
        this.groupNode = groupNode;
        this.isNodeUniformsGroup = true;
    }
    getNodes() {
        const nodes = [];
        for (const uniform of this.uniforms){
            const node = uniform.nodeUniform.node;
            if (!node) throw new Error('NodeUniformsGroup: Uniform has no node.');
            nodes.push(node);
        }
        return nodes;
    }
}
var $859d0a2a1eca4de4$export$2e2bcd8739ae039 = $859d0a2a1eca4de4$var$NodeUniformsGroup;



let $c68a085200d1cf22$var$_id = 0;
class $c68a085200d1cf22$export$a00253022a5caa63 extends (0, $3d47fc7f553021d2$export$2e2bcd8739ae039) {
    constructor(name, texture){
        super(name);
        this.id = $c68a085200d1cf22$var$_id++;
        this.texture = texture;
        this.version = texture ? texture.version : 0;
        this.store = false;
        this.generation = null;
        this.isSampledTexture = true;
    }
    needsBindingsUpdate(generation) {
        const { texture: texture } = this;
        if (generation !== this.generation) {
            this.generation = generation;
            return true;
        }
        return texture.isVideoTexture;
    }
    update() {
        const { texture: texture, version: version } = this;
        if (version !== texture.version) {
            this.version = texture.version;
            return true;
        }
        return false;
    }
}
class $c68a085200d1cf22$export$a75a5b98849ce3e3 extends $c68a085200d1cf22$export$a00253022a5caa63 {
    constructor(name, texture){
        super(name, texture);
        this.isSampledArrayTexture = true;
    }
}
class $c68a085200d1cf22$export$71371e97f70d26b7 extends $c68a085200d1cf22$export$a00253022a5caa63 {
    constructor(name, texture){
        super(name, texture);
        this.isSampled3DTexture = true;
    }
}
class $c68a085200d1cf22$export$5a6c138a0d216f65 extends $c68a085200d1cf22$export$a00253022a5caa63 {
    constructor(name, texture){
        super(name, texture);
        this.isSampledCubeTexture = true;
    }
}


class $10c17ea0e2041e51$export$aa8de3dc7ba6e062 extends (0, $c68a085200d1cf22$export$a00253022a5caa63) {
    constructor(name, textureNode, groupNode, access = null){
        super(name, textureNode ? textureNode.value : null);
        this.textureNode = textureNode;
        this.groupNode = groupNode;
        this.access = access;
    }
    needsBindingsUpdate(generation) {
        return this.textureNode.value !== this.texture || super.needsBindingsUpdate(generation);
    }
    update() {
        const { textureNode: textureNode } = this;
        if (this.texture !== textureNode.value) {
            this.texture = textureNode.value;
            return true;
        }
        return super.update();
    }
}
class $10c17ea0e2041e51$export$43e0cf75b8e20ded extends $10c17ea0e2041e51$export$aa8de3dc7ba6e062 {
    constructor(name, textureNode, groupNode, access){
        super(name, textureNode, groupNode, access);
        this.isSampledCubeTexture = true;
    }
}
class $10c17ea0e2041e51$export$646279b2b7dbb3b7 extends $10c17ea0e2041e51$export$aa8de3dc7ba6e062 {
    constructor(name, textureNode, groupNode, access){
        super(name, textureNode, groupNode, access);
        this.isSampledTexture3D = true;
    }
}





class $4ee4cebfa25bf758$export$b691f601014eabe1 extends (0, $97033ebbcbadc145$export$5431306cf43de24a) {
    constructor(data = null, width = 1, height = 1, format, type, mapping, wrapS, wrapT, magFilter = (0, $cb5ee595c0f892af$export$727aa5ec3fe39bf0), minFilter = (0, $cb5ee595c0f892af$export$727aa5ec3fe39bf0), anisotropy, colorSpace){
        super(null, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, colorSpace);
        this.isDataTexture = true;
        this.image = {
            data: data,
            width: width,
            height: height
        };
        this.generateMipmaps = false;
        this.flipY = false;
        this.unpackAlignment = 1;
    }
}


const $6d6e1ec7a4b7e7e9$var$glslMethods = {
    atan2: 'atan',
    textureDimensions: 'textureSize',
    equals: 'equal'
};
const $6d6e1ec7a4b7e7e9$var$precisionLib = {
    low: 'lowp',
    medium: 'mediump',
    high: 'highp'
};
const $6d6e1ec7a4b7e7e9$var$supports = {
    swizzleAssign: true,
    storageBuffer: false
};
const $6d6e1ec7a4b7e7e9$var$defaultPrecisions = `
precision highp float;
precision highp int;
precision highp sampler2D;
precision highp sampler3D;
precision highp samplerCube;
precision highp sampler2DArray;

precision highp usampler2D;
precision highp usampler3D;
precision highp usamplerCube;
precision highp usampler2DArray;

precision highp isampler2D;
precision highp isampler3D;
precision highp isamplerCube;
precision highp isampler2DArray;

precision lowp sampler2DShadow;
`;
class $6d6e1ec7a4b7e7e9$var$GLSLNodeBuilder extends (0, $3ac2b0a498e221c7$export$2e2bcd8739ae039) {
    constructor(object, renderer){
        super(object, renderer, new (0, $83a516d552911e58$export$2e2bcd8739ae039)());
        this.uniformGroups = {};
        this.transforms = [];
        this.extensions = {};
        this.useComparisonMethod = true;
    }
    needsColorSpaceToLinearSRGB(texture) {
        return texture.isVideoTexture === true && texture.colorSpace !== (0, $cb5ee595c0f892af$export$bfcb490c2dd3db51);
    }
    getMethod(method) {
        return $6d6e1ec7a4b7e7e9$var$glslMethods[method] || method;
    }
    getOutputStructName() {
        return '';
    }
    buildFunctionCode(shaderNode) {
        const layout = shaderNode.layout;
        const flowData = this.flowShaderNode(shaderNode);
        const parameters = [];
        for (const input of layout.inputs)parameters.push(this.getType(input.type) + ' ' + input.name);
        //
        const code = `${this.getType(layout.type)} ${layout.name}( ${parameters.join(', ')} ) {

	${flowData.vars}

${flowData.code}
	return ${flowData.result};

}`;
        //
        return code;
    }
    setupPBO(storageBufferNode) {
        const attribute = storageBufferNode.value;
        if (attribute.pbo === undefined) {
            const originalArray = attribute.array;
            const numElements = attribute.count * attribute.itemSize;
            const { itemSize: itemSize } = attribute;
            const isInteger = attribute.array.constructor.name.toLowerCase().includes('int');
            let format = isInteger ? (0, $cb5ee595c0f892af$export$aa92e870a709d190) : (0, $cb5ee595c0f892af$export$4e041a7967d15c4b);
            if (itemSize === 2) format = isInteger ? (0, $cb5ee595c0f892af$export$1ba1c45f9f77d4d7) : (0, $cb5ee595c0f892af$export$6cdf0b461c7ce8a0);
            else if (itemSize === 3) format = isInteger ? (0, $cb5ee595c0f892af$export$d1fd40c11bfa798e) : (0, $cb5ee595c0f892af$export$7c67423a5ee6f5eb);
            else if (itemSize === 4) format = isInteger ? (0, $cb5ee595c0f892af$export$c200e7d26f592f21) : (0, $cb5ee595c0f892af$export$3f8bb04b555a363c);
            const typeMap = {
                Float32Array: (0, $cb5ee595c0f892af$export$f6d331659b644596),
                Uint8Array: (0, $cb5ee595c0f892af$export$2e8ce08d3f6f5e10),
                Uint16Array: (0, $cb5ee595c0f892af$export$c63dc51868b06a9d),
                Uint32Array: (0, $cb5ee595c0f892af$export$c3c7fc4518ebba96),
                Int8Array: (0, $cb5ee595c0f892af$export$545fce0311a9796a),
                Int16Array: (0, $cb5ee595c0f892af$export$88572337f312435f),
                Int32Array: (0, $cb5ee595c0f892af$export$5c612977753abe2),
                Uint8ClampedArray: (0, $cb5ee595c0f892af$export$2e8ce08d3f6f5e10)
            };
            const width = Math.pow(2, Math.ceil(Math.log2(Math.sqrt(numElements / itemSize))));
            let height = Math.ceil(numElements / itemSize / width);
            if (width * height * itemSize < numElements) height++; // Ensure enough space
            const newSize = width * height * itemSize;
            const newArray = new originalArray.constructor(newSize);
            newArray.set(originalArray, 0);
            attribute.array = newArray;
            const pboTexture = new (0, $4ee4cebfa25bf758$export$b691f601014eabe1)(attribute.array, width, height, format, typeMap[attribute.array.constructor.name] || (0, $cb5ee595c0f892af$export$f6d331659b644596));
            pboTexture.needsUpdate = true;
            pboTexture.isPBOTexture = true;
            const pbo = new (0, $f7d68bbf9ea772a7$export$2e2bcd8739ae039)(pboTexture, null, null);
            pbo.setPrecision('high');
            attribute.pboNode = pbo;
            attribute.pbo = pbo.value;
            this.getUniformFromNode(attribute.pboNode, 'texture', this.shaderStage, this.context.label);
        }
    }
    getPropertyName(node, shaderStage = this.shaderStage) {
        if (node.isNodeUniform && node.node.isTextureNode !== true && node.node.isBufferNode !== true) return shaderStage.charAt(0) + '_' + node.name;
        return super.getPropertyName(node, shaderStage);
    }
    generatePBO(storageArrayElementNode) {
        const { node: node, indexNode: indexNode } = storageArrayElementNode;
        const attribute = node.value;
        if (this.renderer.backend.has(attribute)) {
            const attributeData = this.renderer.backend.get(attribute);
            attributeData.pbo = attribute.pbo;
        }
        const nodeUniform = this.getUniformFromNode(attribute.pboNode, 'texture', this.shaderStage, this.context.label);
        const textureName = this.getPropertyName(nodeUniform);
        this.increaseUsage(indexNode); // force cache generate to be used as index in x,y
        const indexSnippet = indexNode.build(this, 'uint');
        const elementNodeData = this.getDataFromNode(storageArrayElementNode);
        let propertyName = elementNodeData.propertyName;
        if (propertyName === undefined) {
            // property element
            const nodeVar = this.getVarFromNode(storageArrayElementNode);
            propertyName = this.getPropertyName(nodeVar);
            // property size
            const bufferNodeData = this.getDataFromNode(node);
            let propertySizeName = bufferNodeData.propertySizeName;
            if (propertySizeName === undefined) {
                propertySizeName = propertyName + 'Size';
                this.getVarFromNode(node, propertySizeName, 'uint');
                this.addLineFlowCode(`${propertySizeName} = uint( textureSize( ${textureName}, 0 ).x )`, storageArrayElementNode);
                bufferNodeData.propertySizeName = propertySizeName;
            }
            //
            const { itemSize: itemSize } = attribute;
            const channel = '.' + (0, $ddcfecb7fbba5d74$export$1c0adcb9073b646d).join('').slice(0, itemSize);
            const uvSnippet = `ivec2(${indexSnippet} % ${propertySizeName}, ${indexSnippet} / ${propertySizeName})`;
            const snippet = this.generateTextureLoad(null, textureName, uvSnippet, null, '0');
            //
            let prefix = 'vec4';
            if (attribute.pbo.type === (0, $cb5ee595c0f892af$export$c3c7fc4518ebba96)) prefix = 'uvec4';
            else if (attribute.pbo.type === (0, $cb5ee595c0f892af$export$5c612977753abe2)) prefix = 'ivec4';
            this.addLineFlowCode(`${propertyName} = ${prefix}(${snippet})${channel}`, storageArrayElementNode);
            elementNodeData.propertyName = propertyName;
        }
        return propertyName;
    }
    generateTextureLoad(texture, textureProperty, uvIndexSnippet, depthSnippet, levelSnippet = '0') {
        if (depthSnippet) return `texelFetch( ${textureProperty}, ivec3( ${uvIndexSnippet}, ${depthSnippet} ), ${levelSnippet} )`;
        else return `texelFetch( ${textureProperty}, ${uvIndexSnippet}, ${levelSnippet} )`;
    }
    generateTexture(texture, textureProperty, uvSnippet, depthSnippet) {
        if (texture.isDepthTexture) return `texture( ${textureProperty}, ${uvSnippet} ).x`;
        else {
            if (depthSnippet) uvSnippet = `vec3( ${uvSnippet}, ${depthSnippet} )`;
            return `texture( ${textureProperty}, ${uvSnippet} )`;
        }
    }
    generateTextureLevel(texture, textureProperty, uvSnippet, levelSnippet) {
        return `textureLod( ${textureProperty}, ${uvSnippet}, ${levelSnippet} )`;
    }
    generateTextureBias(texture, textureProperty, uvSnippet, biasSnippet) {
        return `texture( ${textureProperty}, ${uvSnippet}, ${biasSnippet} )`;
    }
    generateTextureGrad(texture, textureProperty, uvSnippet, gradSnippet) {
        return `textureGrad( ${textureProperty}, ${uvSnippet}, ${gradSnippet[0]}, ${gradSnippet[1]} )`;
    }
    generateTextureCompare(texture, textureProperty, uvSnippet, compareSnippet, depthSnippet, shaderStage = this.shaderStage) {
        if (shaderStage === 'fragment') return `texture( ${textureProperty}, vec3( ${uvSnippet}, ${compareSnippet} ) )`;
        else console.error(`WebGPURenderer: THREE.DepthTexture.compareFunction() does not support ${shaderStage} shader.`);
    }
    getVars(shaderStage) {
        const snippets = [];
        const vars = this.vars[shaderStage];
        if (vars !== undefined) for (const variable of vars)snippets.push(`${this.getVar(variable.type, variable.name)};`);
        return snippets.join('\n\t');
    }
    getUniforms(shaderStage) {
        const uniforms = this.uniforms[shaderStage];
        const bindingSnippets = [];
        const uniformGroups = {};
        for (const uniform of uniforms){
            let snippet = null;
            let group = false;
            if (uniform.type === 'texture') {
                const texture = uniform.node.value;
                let typePrefix = '';
                if (texture.isDataTexture === true) {
                    if (texture.type === (0, $cb5ee595c0f892af$export$c3c7fc4518ebba96)) typePrefix = 'u';
                    else if (texture.type === (0, $cb5ee595c0f892af$export$5c612977753abe2)) typePrefix = 'i';
                }
                if (texture.compareFunction) snippet = `sampler2DShadow ${uniform.name};`;
                else if (texture.isDataArrayTexture === true || texture.isCompressedArrayTexture === true) snippet = `${typePrefix}sampler2DArray ${uniform.name};`;
                else snippet = `${typePrefix}sampler2D ${uniform.name};`;
            } else if (uniform.type === 'cubeTexture') snippet = `samplerCube ${uniform.name};`;
            else if (uniform.type === 'texture3D') snippet = `sampler3D ${uniform.name};`;
            else if (uniform.type === 'buffer') {
                const bufferNode = uniform.node;
                const bufferType = this.getType(bufferNode.bufferType);
                const bufferCount = bufferNode.bufferCount;
                const bufferCountSnippet = bufferCount > 0 ? bufferCount : '';
                snippet = `${bufferNode.name} {\n\t${bufferType} ${uniform.name}[${bufferCountSnippet}];\n};\n`;
            } else {
                const vectorType = this.getVectorType(uniform.type);
                snippet = `${vectorType} ${this.getPropertyName(uniform, shaderStage)};`;
                group = true;
            }
            const precision = uniform.node.precision;
            if (precision !== null) snippet = $6d6e1ec7a4b7e7e9$var$precisionLib[precision] + ' ' + snippet;
            if (group) {
                snippet = '\t' + snippet;
                const groupName = uniform.groupNode.name;
                const groupSnippets = uniformGroups[groupName] || (uniformGroups[groupName] = []);
                groupSnippets.push(snippet);
            } else {
                snippet = 'uniform ' + snippet;
                bindingSnippets.push(snippet);
            }
        }
        let output = '';
        for(const name in uniformGroups){
            const groupSnippets = uniformGroups[name];
            output += this._getGLSLUniformStruct(shaderStage + '_' + name, groupSnippets.join('\n')) + '\n';
        }
        output += bindingSnippets.join('\n');
        return output;
    }
    getTypeFromAttribute(attribute) {
        let nodeType = super.getTypeFromAttribute(attribute);
        if (/^[iu]/.test(nodeType) && attribute.gpuType !== (0, $cb5ee595c0f892af$export$5c612977753abe2)) {
            let dataAttribute = attribute;
            if (attribute.isInterleavedBufferAttribute) dataAttribute = attribute.data;
            const array = dataAttribute.array;
            if ((array instanceof Uint32Array || array instanceof Int32Array) === false) nodeType = nodeType.slice(1);
        }
        return nodeType;
    }
    getAttributes(shaderStage) {
        let snippet = '';
        if (shaderStage === 'vertex' || shaderStage === 'compute') {
            const attributes = this.getAttributesArray();
            let location = 0;
            for (const attribute of attributes)snippet += `layout( location = ${location++} ) in ${attribute.type} ${attribute.name};\n`;
        }
        return snippet;
    }
    getStructMembers(struct) {
        const snippets = [];
        const members = struct.getMemberTypes();
        for(let i = 0; i < members.length; i++){
            const member = members[i];
            snippets.push(`layout( location = ${i} ) out ${member} m${i};`);
        }
        return snippets.join('\n');
    }
    getStructs(shaderStage) {
        const snippets = [];
        const structs = this.structs[shaderStage];
        if (structs.length === 0) return 'layout( location = 0 ) out vec4 fragColor;\n';
        for(let index = 0, length = structs.length; index < length; index++){
            const struct = structs[index];
            let snippet = '\n';
            snippet += this.getStructMembers(struct);
            snippet += '\n';
            snippets.push(snippet);
        }
        return snippets.join('\n\n');
    }
    getVaryings(shaderStage) {
        let snippet = '';
        const varyings = this.varyings;
        if (shaderStage === 'vertex' || shaderStage === 'compute') for (const varying of varyings){
            if (shaderStage === 'compute') varying.needsInterpolation = true;
            const type = varying.type;
            const flat = type.includes('int') || type.includes('uv') || type.includes('iv') ? 'flat ' : '';
            snippet += `${flat}${varying.needsInterpolation ? 'out' : '/*out*/'} ${type} ${varying.name};\n`;
        }
        else if (shaderStage === 'fragment') {
            for (const varying of varyings)if (varying.needsInterpolation) {
                const type = varying.type;
                const flat = type.includes('int') || type.includes('uv') || type.includes('iv') ? 'flat ' : '';
                snippet += `${flat}in ${type} ${varying.name};\n`;
            }
        }
        return snippet;
    }
    getVertexIndex() {
        return 'uint( gl_VertexID )';
    }
    getInstanceIndex() {
        return 'uint( gl_InstanceID )';
    }
    getInvocationLocalIndex() {
        const workgroupSize = this.object.workgroupSize;
        const size = workgroupSize.reduce((acc, curr)=>acc * curr, 1);
        return `uint( gl_InstanceID ) % ${size}u`;
    }
    getDrawIndex() {
        const extensions = this.renderer.backend.extensions;
        if (extensions.has('WEBGL_multi_draw')) return 'uint( gl_DrawID )';
        return null;
    }
    getFrontFacing() {
        return 'gl_FrontFacing';
    }
    getFragCoord() {
        return 'gl_FragCoord.xy';
    }
    getFragDepth() {
        return 'gl_FragDepth';
    }
    enableExtension(name, behavior, shaderStage = this.shaderStage) {
        const map = this.extensions[shaderStage] || (this.extensions[shaderStage] = new Map());
        if (map.has(name) === false) map.set(name, {
            name: name,
            behavior: behavior
        });
    }
    getExtensions(shaderStage) {
        const snippets = [];
        if (shaderStage === 'vertex') {
            const ext = this.renderer.backend.extensions;
            const isBatchedMesh = this.object.isBatchedMesh;
            if (isBatchedMesh && ext.has('WEBGL_multi_draw')) this.enableExtension('GL_ANGLE_multi_draw', 'require', shaderStage);
        }
        const extensions = this.extensions[shaderStage];
        if (extensions !== undefined) for (const { name: name, behavior: behavior } of extensions.values())snippets.push(`#extension ${name} : ${behavior}`);
        return snippets.join('\n');
    }
    isAvailable(name) {
        let result = $6d6e1ec7a4b7e7e9$var$supports[name];
        if (result === undefined) {
            if (name === 'float32Filterable') {
                const extensions = this.renderer.backend.extensions;
                if (extensions.has('OES_texture_float_linear')) {
                    extensions.get('OES_texture_float_linear');
                    result = true;
                } else result = false;
            }
            $6d6e1ec7a4b7e7e9$var$supports[name] = result;
        }
        return result;
    }
    isFlipY() {
        return true;
    }
    registerTransform(varyingName, attributeNode) {
        this.transforms.push({
            varyingName: varyingName,
            attributeNode: attributeNode
        });
    }
    getTransforms() {
        const transforms = this.transforms;
        let snippet = '';
        for(let i = 0; i < transforms.length; i++){
            const transform = transforms[i];
            const attributeName = this.getPropertyName(transform.attributeNode);
            snippet += `${transform.varyingName} = ${attributeName};\n\t`;
        }
        return snippet;
    }
    _getGLSLUniformStruct(name, vars) {
        return `
layout( std140 ) uniform ${name} {
${vars}
};`;
    }
    _getGLSLVertexCode(shaderData) {
        return `#version 300 es

${this.getSignature()}

// extensions 
${shaderData.extensions}

// precision
${$6d6e1ec7a4b7e7e9$var$defaultPrecisions}

// uniforms
${shaderData.uniforms}

// varyings
${shaderData.varyings}

// attributes
${shaderData.attributes}

// codes
${shaderData.codes}

void main() {

	// vars
	${shaderData.vars}

	// transforms
	${shaderData.transforms}

	// flow
	${shaderData.flow}

	gl_PointSize = 1.0;

}
`;
    }
    _getGLSLFragmentCode(shaderData) {
        return `#version 300 es

${this.getSignature()}

// precision
${$6d6e1ec7a4b7e7e9$var$defaultPrecisions}

// uniforms
${shaderData.uniforms}

// varyings
${shaderData.varyings}

// codes
${shaderData.codes}

${shaderData.structs}

void main() {

	// vars
	${shaderData.vars}

	// flow
	${shaderData.flow}

}
`;
    }
    buildCode() {
        const shadersData = this.material !== null ? {
            fragment: {},
            vertex: {}
        } : {
            compute: {}
        };
        this.sortBindingGroups();
        for(const shaderStage in shadersData){
            let flow = '// code\n\n';
            flow += this.flowCode[shaderStage];
            const flowNodes = this.flowNodes[shaderStage];
            const mainNode = flowNodes[flowNodes.length - 1];
            for (const node of flowNodes){
                const flowSlotData = this.getFlowData(node /*, shaderStage*/ );
                const slotName = node.name;
                if (slotName) {
                    if (flow.length > 0) flow += '\n';
                    flow += `\t// flow -> ${slotName}\n\t`;
                }
                flow += `${flowSlotData.code}\n\t`;
                if (node === mainNode && shaderStage !== 'compute') {
                    flow += '// result\n\t';
                    if (shaderStage === 'vertex') {
                        flow += 'gl_Position = ';
                        flow += `${flowSlotData.result};`;
                    } else if (shaderStage === 'fragment') {
                        if (!node.outputNode.isOutputStructNode) {
                            flow += 'fragColor = ';
                            flow += `${flowSlotData.result};`;
                        }
                    }
                }
            }
            const stageData = shadersData[shaderStage];
            stageData.extensions = this.getExtensions(shaderStage);
            stageData.uniforms = this.getUniforms(shaderStage);
            stageData.attributes = this.getAttributes(shaderStage);
            stageData.varyings = this.getVaryings(shaderStage);
            stageData.vars = this.getVars(shaderStage);
            stageData.structs = this.getStructs(shaderStage);
            stageData.codes = this.getCodes(shaderStage);
            stageData.transforms = this.getTransforms(shaderStage);
            stageData.flow = flow;
        }
        if (this.material !== null) {
            this.vertexShader = this._getGLSLVertexCode(shadersData.vertex);
            this.fragmentShader = this._getGLSLFragmentCode(shadersData.fragment);
        } else this.computeShader = this._getGLSLVertexCode(shadersData.compute);
    }
    getUniformFromNode(node, type, shaderStage, name = null) {
        const uniformNode = super.getUniformFromNode(node, type, shaderStage, name);
        const nodeData = this.getDataFromNode(node, shaderStage, this.globalCache);
        let uniformGPU = nodeData.uniformGPU;
        if (uniformGPU === undefined) {
            const group = node.groupNode;
            const groupName = group.name;
            const bindings = this.getBindGroupArray(groupName, shaderStage);
            if (type === 'texture') {
                uniformGPU = new (0, $10c17ea0e2041e51$export$aa8de3dc7ba6e062)(uniformNode.name, uniformNode.node, group);
                bindings.push(uniformGPU);
            } else if (type === 'cubeTexture') {
                uniformGPU = new (0, $10c17ea0e2041e51$export$43e0cf75b8e20ded)(uniformNode.name, uniformNode.node, group);
                bindings.push(uniformGPU);
            } else if (type === 'texture3D') {
                uniformGPU = new (0, $10c17ea0e2041e51$export$646279b2b7dbb3b7)(uniformNode.name, uniformNode.node, group);
                bindings.push(uniformGPU);
            } else if (type === 'buffer') {
                node.name = `NodeBuffer_${node.id}`;
                uniformNode.name = `buffer${node.id}`;
                const buffer = new (0, $acea95d61477db49$export$2e2bcd8739ae039)(node, group);
                buffer.name = node.name;
                bindings.push(buffer);
                uniformGPU = buffer;
            } else {
                const uniformsStage = this.uniformGroups[shaderStage] || (this.uniformGroups[shaderStage] = {});
                let uniformsGroup = uniformsStage[groupName];
                if (uniformsGroup === undefined) {
                    uniformsGroup = new (0, $859d0a2a1eca4de4$export$2e2bcd8739ae039)(shaderStage + '_' + groupName, group);
                    //uniformsGroup.setVisibility( gpuShaderStageLib[ shaderStage ] );
                    uniformsStage[groupName] = uniformsGroup;
                    bindings.push(uniformsGroup);
                }
                uniformGPU = this.getNodeUniform(uniformNode, type);
                uniformsGroup.addUniform(uniformGPU);
            }
            nodeData.uniformGPU = uniformGPU;
        }
        return uniformNode;
    }
}
var $6d6e1ec7a4b7e7e9$export$2e2bcd8739ae039 = $6d6e1ec7a4b7e7e9$var$GLSLNodeBuilder;







let $191c5c4fa47571a5$var$vector2 = null;
let $191c5c4fa47571a5$var$vector4 = null;
let $191c5c4fa47571a5$var$color4 = null;
class $191c5c4fa47571a5$var$Backend {
    constructor(parameters = {}){
        this.parameters = Object.assign({}, parameters);
        this.data = new WeakMap();
        this.renderer = null;
        this.domElement = null;
    }
    async init(renderer) {
        this.renderer = renderer;
    }
    // render context
    begin() {}
    finish() {}
    // render object
    draw() {}
    // program
    createProgram() {}
    destroyProgram() {}
    // bindings
    createBindings() {}
    updateBindings() {}
    // pipeline
    createRenderPipeline() {}
    createComputePipeline() {}
    destroyPipeline() {}
    // cache key
    needsRenderUpdate() {}
    getRenderCacheKey() {}
    // node builder
    createNodeBuilder() {}
    // textures
    createSampler() {}
    createDefaultTexture() {}
    createTexture() {}
    copyTextureToBuffer() {}
    // attributes
    createAttribute() {}
    createIndexAttribute() {}
    updateAttribute() {}
    destroyAttribute() {}
    // canvas
    getContext() {}
    updateSize() {}
    // utils
    resolveTimestampAsync() {}
    hasFeatureAsync() {}
    hasFeature() {}
    getInstanceCount(renderObject) {
        const { object: object, geometry: geometry } = renderObject;
        return geometry.isInstancedBufferGeometry ? geometry.instanceCount : object.count > 1 ? object.count : 1;
    }
    getDrawingBufferSize() {
        $191c5c4fa47571a5$var$vector2 = $191c5c4fa47571a5$var$vector2 || new (0, $3c03061dea0adea3$export$c977b3e384af9ae1)();
        return this.renderer.getDrawingBufferSize($191c5c4fa47571a5$var$vector2);
    }
    getScissor() {
        $191c5c4fa47571a5$var$vector4 = $191c5c4fa47571a5$var$vector4 || new (0, $a09a15e9a8421204$export$fa7daccca11cdbe3)();
        return this.renderer.getScissor($191c5c4fa47571a5$var$vector4);
    }
    setScissorTest() {}
    getClearColor() {
        const renderer = this.renderer;
        $191c5c4fa47571a5$var$color4 = $191c5c4fa47571a5$var$color4 || new (0, $4673b28ced87b0be$export$2e2bcd8739ae039)();
        renderer.getClearColor($191c5c4fa47571a5$var$color4);
        $191c5c4fa47571a5$var$color4.getRGB($191c5c4fa47571a5$var$color4, this.renderer.currentColorSpace);
        return $191c5c4fa47571a5$var$color4;
    }
    getDomElement() {
        let domElement = this.domElement;
        if (domElement === null) {
            domElement = this.parameters.canvas !== undefined ? this.parameters.canvas : (0, $d93c9776005e33ec$export$1033a2df66368859)();
            // OffscreenCanvas does not have setAttribute, see #22811
            if ('setAttribute' in domElement) domElement.setAttribute('data-engine', `three.js r${(0, $cb5ee595c0f892af$export$3545e07a80636437)} webgpu`);
            this.domElement = domElement;
        }
        return domElement;
    }
    // resource properties
    set(object, value) {
        this.data.set(object, value);
    }
    get(object) {
        let map = this.data.get(object);
        if (map === undefined) {
            map = {};
            this.data.set(object, map);
        }
        return map;
    }
    has(object) {
        return this.data.has(object);
    }
    delete(object) {
        this.data.delete(object);
    }
    dispose() {}
}
var $191c5c4fa47571a5$export$2e2bcd8739ae039 = $191c5c4fa47571a5$var$Backend;




let $c2b2d84faa09d1ea$var$_id = 0;
class $c2b2d84faa09d1ea$var$DualAttributeData {
    constructor(attributeData, dualBuffer){
        this.buffers = [
            attributeData.bufferGPU,
            dualBuffer
        ];
        this.type = attributeData.type;
        this.bufferType = attributeData.bufferType;
        this.pbo = attributeData.pbo;
        this.byteLength = attributeData.byteLength;
        this.bytesPerElement = attributeData.BYTES_PER_ELEMENT;
        this.version = attributeData.version;
        this.isInteger = attributeData.isInteger;
        this.activeBufferIndex = 0;
        this.baseId = attributeData.id;
    }
    get id() {
        return `${this.baseId}|${this.activeBufferIndex}`;
    }
    get bufferGPU() {
        return this.buffers[this.activeBufferIndex];
    }
    get transformBuffer() {
        return this.buffers[this.activeBufferIndex ^ 1];
    }
    switchBuffers() {
        this.activeBufferIndex ^= 1;
    }
}
class $c2b2d84faa09d1ea$var$WebGLAttributeUtils {
    constructor(backend){
        this.backend = backend;
    }
    createAttribute(attribute, bufferType) {
        const backend = this.backend;
        const { gl: gl } = backend;
        const array = attribute.array;
        const usage = attribute.usage || gl.STATIC_DRAW;
        const bufferAttribute = attribute.isInterleavedBufferAttribute ? attribute.data : attribute;
        const bufferData = backend.get(bufferAttribute);
        let bufferGPU = bufferData.bufferGPU;
        if (bufferGPU === undefined) {
            bufferGPU = this._createBuffer(gl, bufferType, array, usage);
            bufferData.bufferGPU = bufferGPU;
            bufferData.bufferType = bufferType;
            bufferData.version = bufferAttribute.version;
        }
        //attribute.onUploadCallback();
        let type;
        if (array instanceof Float32Array) type = gl.FLOAT;
        else if (array instanceof Uint16Array) {
            if (attribute.isFloat16BufferAttribute) type = gl.HALF_FLOAT;
            else type = gl.UNSIGNED_SHORT;
        } else if (array instanceof Int16Array) type = gl.SHORT;
        else if (array instanceof Uint32Array) type = gl.UNSIGNED_INT;
        else if (array instanceof Int32Array) type = gl.INT;
        else if (array instanceof Int8Array) type = gl.BYTE;
        else if (array instanceof Uint8Array) type = gl.UNSIGNED_BYTE;
        else if (array instanceof Uint8ClampedArray) type = gl.UNSIGNED_BYTE;
        else throw new Error('THREE.WebGLBackend: Unsupported buffer data format: ' + array);
        let attributeData = {
            bufferGPU: bufferGPU,
            bufferType: bufferType,
            type: type,
            byteLength: array.byteLength,
            bytesPerElement: array.BYTES_PER_ELEMENT,
            version: attribute.version,
            pbo: attribute.pbo,
            isInteger: type === gl.INT || type === gl.UNSIGNED_INT || attribute.gpuType === (0, $cb5ee595c0f892af$export$5c612977753abe2),
            id: $c2b2d84faa09d1ea$var$_id++
        };
        if (attribute.isStorageBufferAttribute || attribute.isStorageInstancedBufferAttribute) {
            // create buffer for tranform feedback use
            const bufferGPUDual = this._createBuffer(gl, bufferType, array, usage);
            attributeData = new $c2b2d84faa09d1ea$var$DualAttributeData(attributeData, bufferGPUDual);
        }
        backend.set(attribute, attributeData);
    }
    updateAttribute(attribute) {
        const backend = this.backend;
        const { gl: gl } = backend;
        const array = attribute.array;
        const bufferAttribute = attribute.isInterleavedBufferAttribute ? attribute.data : attribute;
        const bufferData = backend.get(bufferAttribute);
        const bufferType = bufferData.bufferType;
        const updateRanges = attribute.isInterleavedBufferAttribute ? attribute.data.updateRanges : attribute.updateRanges;
        gl.bindBuffer(bufferType, bufferData.bufferGPU);
        if (updateRanges.length === 0) // Not using update ranges
        gl.bufferSubData(bufferType, 0, array);
        else {
            for(let i = 0, l = updateRanges.length; i < l; i++){
                const range = updateRanges[i];
                gl.bufferSubData(bufferType, range.start * array.BYTES_PER_ELEMENT, array, range.start, range.count);
            }
            bufferAttribute.clearUpdateRanges();
        }
        gl.bindBuffer(bufferType, null);
        bufferData.version = bufferAttribute.version;
    }
    destroyAttribute(attribute) {
        const backend = this.backend;
        const { gl: gl } = backend;
        if (attribute.isInterleavedBufferAttribute) backend.delete(attribute.data);
        const attributeData = backend.get(attribute);
        gl.deleteBuffer(attributeData.bufferGPU);
        backend.delete(attribute);
    }
    async getArrayBufferAsync(attribute) {
        const backend = this.backend;
        const { gl: gl } = backend;
        const bufferAttribute = attribute.isInterleavedBufferAttribute ? attribute.data : attribute;
        const { bufferGPU: bufferGPU } = backend.get(bufferAttribute);
        const array = attribute.array;
        const byteLength = array.byteLength;
        gl.bindBuffer(gl.COPY_READ_BUFFER, bufferGPU);
        const writeBuffer = gl.createBuffer();
        gl.bindBuffer(gl.COPY_WRITE_BUFFER, writeBuffer);
        gl.bufferData(gl.COPY_WRITE_BUFFER, byteLength, gl.STREAM_READ);
        gl.copyBufferSubData(gl.COPY_READ_BUFFER, gl.COPY_WRITE_BUFFER, 0, 0, byteLength);
        await backend.utils._clientWaitAsync();
        const dstBuffer = new attribute.array.constructor(array.length);
        // Ensure the buffer is bound before reading
        gl.bindBuffer(gl.COPY_WRITE_BUFFER, writeBuffer);
        gl.getBufferSubData(gl.COPY_WRITE_BUFFER, 0, dstBuffer);
        gl.deleteBuffer(writeBuffer);
        gl.bindBuffer(gl.COPY_READ_BUFFER, null);
        gl.bindBuffer(gl.COPY_WRITE_BUFFER, null);
        return dstBuffer.buffer;
    }
    _createBuffer(gl, bufferType, array, usage) {
        const bufferGPU = gl.createBuffer();
        gl.bindBuffer(bufferType, bufferGPU);
        gl.bufferData(bufferType, array, usage);
        gl.bindBuffer(bufferType, null);
        return bufferGPU;
    }
}
var $c2b2d84faa09d1ea$export$2e2bcd8739ae039 = $c2b2d84faa09d1ea$var$WebGLAttributeUtils;



let $88572ab434b6ea49$var$initialized = false, $88572ab434b6ea49$var$equationToGL, $88572ab434b6ea49$var$factorToGL;
class $88572ab434b6ea49$var$WebGLState {
    constructor(backend){
        this.backend = backend;
        this.gl = this.backend.gl;
        this.enabled = {};
        this.currentFlipSided = null;
        this.currentCullFace = null;
        this.currentProgram = null;
        this.currentBlendingEnabled = false;
        this.currentBlending = null;
        this.currentBlendSrc = null;
        this.currentBlendDst = null;
        this.currentBlendSrcAlpha = null;
        this.currentBlendDstAlpha = null;
        this.currentPremultipledAlpha = null;
        this.currentPolygonOffsetFactor = null;
        this.currentPolygonOffsetUnits = null;
        this.currentColorMask = null;
        this.currentDepthFunc = null;
        this.currentDepthMask = null;
        this.currentStencilFunc = null;
        this.currentStencilRef = null;
        this.currentStencilFuncMask = null;
        this.currentStencilFail = null;
        this.currentStencilZFail = null;
        this.currentStencilZPass = null;
        this.currentStencilMask = null;
        this.currentLineWidth = null;
        this.currentBoundFramebuffers = {};
        this.currentDrawbuffers = new WeakMap();
        this.maxTextures = this.gl.getParameter(this.gl.MAX_TEXTURE_IMAGE_UNITS);
        this.currentTextureSlot = null;
        this.currentBoundTextures = {};
        this.currentBoundBufferBases = {};
        if ($88572ab434b6ea49$var$initialized === false) {
            this._init(this.gl);
            $88572ab434b6ea49$var$initialized = true;
        }
    }
    _init(gl) {
        // Store only WebGL constants here.
        $88572ab434b6ea49$var$equationToGL = {
            [(0, $cb5ee595c0f892af$export$20183a0484ce21a0)]: gl.FUNC_ADD,
            [(0, $cb5ee595c0f892af$export$73e0df5177988548)]: gl.FUNC_SUBTRACT,
            [(0, $cb5ee595c0f892af$export$28e582859cbec660)]: gl.FUNC_REVERSE_SUBTRACT
        };
        $88572ab434b6ea49$var$factorToGL = {
            [(0, $cb5ee595c0f892af$export$2110f05edf778d3d)]: gl.ZERO,
            [(0, $cb5ee595c0f892af$export$8805bad65e24940e)]: gl.ONE,
            [(0, $cb5ee595c0f892af$export$7fbe15b28d28cf52)]: gl.SRC_COLOR,
            [(0, $cb5ee595c0f892af$export$d5773124e86cf28c)]: gl.SRC_ALPHA,
            [(0, $cb5ee595c0f892af$export$c05e2a1fc8609506)]: gl.SRC_ALPHA_SATURATE,
            [(0, $cb5ee595c0f892af$export$ef5f2dd8ffac5574)]: gl.DST_COLOR,
            [(0, $cb5ee595c0f892af$export$a78aed1ca2a87192)]: gl.DST_ALPHA,
            [(0, $cb5ee595c0f892af$export$947829af9f2c17f6)]: gl.ONE_MINUS_SRC_COLOR,
            [(0, $cb5ee595c0f892af$export$11d468cc7f19e971)]: gl.ONE_MINUS_SRC_ALPHA,
            [(0, $cb5ee595c0f892af$export$56b85b2686ab16)]: gl.ONE_MINUS_DST_COLOR,
            [(0, $cb5ee595c0f892af$export$5d0fe17fd8773bac)]: gl.ONE_MINUS_DST_ALPHA
        };
    }
    enable(id) {
        const { enabled: enabled } = this;
        if (enabled[id] !== true) {
            this.gl.enable(id);
            enabled[id] = true;
        }
    }
    disable(id) {
        const { enabled: enabled } = this;
        if (enabled[id] !== false) {
            this.gl.disable(id);
            enabled[id] = false;
        }
    }
    setFlipSided(flipSided) {
        if (this.currentFlipSided !== flipSided) {
            const { gl: gl } = this;
            if (flipSided) gl.frontFace(gl.CW);
            else gl.frontFace(gl.CCW);
            this.currentFlipSided = flipSided;
        }
    }
    setCullFace(cullFace) {
        const { gl: gl } = this;
        if (cullFace !== (0, $cb5ee595c0f892af$export$3237e1f2c1ea1f44)) {
            this.enable(gl.CULL_FACE);
            if (cullFace !== this.currentCullFace) {
                if (cullFace === (0, $cb5ee595c0f892af$export$b9a7b4fc5cb15f9b)) gl.cullFace(gl.BACK);
                else if (cullFace === (0, $cb5ee595c0f892af$export$b8058bcc7037d3f3)) gl.cullFace(gl.FRONT);
                else gl.cullFace(gl.FRONT_AND_BACK);
            }
        } else this.disable(gl.CULL_FACE);
        this.currentCullFace = cullFace;
    }
    setLineWidth(width) {
        const { currentLineWidth: currentLineWidth, gl: gl } = this;
        if (width !== currentLineWidth) {
            gl.lineWidth(width);
            this.currentLineWidth = width;
        }
    }
    setBlending(blending, blendEquation, blendSrc, blendDst, blendEquationAlpha, blendSrcAlpha, blendDstAlpha, premultipliedAlpha) {
        const { gl: gl } = this;
        if (blending === (0, $cb5ee595c0f892af$export$63b8d6b580fc65ba)) {
            if (this.currentBlendingEnabled === true) {
                this.disable(gl.BLEND);
                this.currentBlendingEnabled = false;
            }
            return;
        }
        if (this.currentBlendingEnabled === false) {
            this.enable(gl.BLEND);
            this.currentBlendingEnabled = true;
        }
        if (blending !== (0, $cb5ee595c0f892af$export$eda4864c68df1fa2)) {
            if (blending !== this.currentBlending || premultipliedAlpha !== this.currentPremultipledAlpha) {
                if (this.currentBlendEquation !== (0, $cb5ee595c0f892af$export$20183a0484ce21a0) || this.currentBlendEquationAlpha !== (0, $cb5ee595c0f892af$export$20183a0484ce21a0)) {
                    gl.blendEquation(gl.FUNC_ADD);
                    this.currentBlendEquation = (0, $cb5ee595c0f892af$export$20183a0484ce21a0);
                    this.currentBlendEquationAlpha = (0, $cb5ee595c0f892af$export$20183a0484ce21a0);
                }
                if (premultipliedAlpha) switch(blending){
                    case 0, $cb5ee595c0f892af$export$5b29a26d96ee6af0:
                        gl.blendFuncSeparate(gl.ONE, gl.ONE_MINUS_SRC_ALPHA, gl.ONE, gl.ONE_MINUS_SRC_ALPHA);
                        break;
                    case 0, $cb5ee595c0f892af$export$777d8f9551c2216b:
                        gl.blendFunc(gl.ONE, gl.ONE);
                        break;
                    case 0, $cb5ee595c0f892af$export$cdfa06f868e2e467:
                        gl.blendFuncSeparate(gl.ZERO, gl.ONE_MINUS_SRC_COLOR, gl.ZERO, gl.ONE);
                        break;
                    case 0, $cb5ee595c0f892af$export$4138e1c684b46a20:
                        gl.blendFuncSeparate(gl.ZERO, gl.SRC_COLOR, gl.ZERO, gl.SRC_ALPHA);
                        break;
                    default:
                        console.error('THREE.WebGLState: Invalid blending: ', blending);
                        break;
                }
                else switch(blending){
                    case 0, $cb5ee595c0f892af$export$5b29a26d96ee6af0:
                        gl.blendFuncSeparate(gl.SRC_ALPHA, gl.ONE_MINUS_SRC_ALPHA, gl.ONE, gl.ONE_MINUS_SRC_ALPHA);
                        break;
                    case 0, $cb5ee595c0f892af$export$777d8f9551c2216b:
                        gl.blendFunc(gl.SRC_ALPHA, gl.ONE);
                        break;
                    case 0, $cb5ee595c0f892af$export$cdfa06f868e2e467:
                        gl.blendFuncSeparate(gl.ZERO, gl.ONE_MINUS_SRC_COLOR, gl.ZERO, gl.ONE);
                        break;
                    case 0, $cb5ee595c0f892af$export$4138e1c684b46a20:
                        gl.blendFunc(gl.ZERO, gl.SRC_COLOR);
                        break;
                    default:
                        console.error('THREE.WebGLState: Invalid blending: ', blending);
                        break;
                }
                this.currentBlendSrc = null;
                this.currentBlendDst = null;
                this.currentBlendSrcAlpha = null;
                this.currentBlendDstAlpha = null;
                this.currentBlending = blending;
                this.currentPremultipledAlpha = premultipliedAlpha;
            }
            return;
        }
        // custom blending
        blendEquationAlpha = blendEquationAlpha || blendEquation;
        blendSrcAlpha = blendSrcAlpha || blendSrc;
        blendDstAlpha = blendDstAlpha || blendDst;
        if (blendEquation !== this.currentBlendEquation || blendEquationAlpha !== this.currentBlendEquationAlpha) {
            gl.blendEquationSeparate($88572ab434b6ea49$var$equationToGL[blendEquation], $88572ab434b6ea49$var$equationToGL[blendEquationAlpha]);
            this.currentBlendEquation = blendEquation;
            this.currentBlendEquationAlpha = blendEquationAlpha;
        }
        if (blendSrc !== this.currentBlendSrc || blendDst !== this.currentBlendDst || blendSrcAlpha !== this.currentBlendSrcAlpha || blendDstAlpha !== this.currentBlendDstAlpha) {
            gl.blendFuncSeparate($88572ab434b6ea49$var$factorToGL[blendSrc], $88572ab434b6ea49$var$factorToGL[blendDst], $88572ab434b6ea49$var$factorToGL[blendSrcAlpha], $88572ab434b6ea49$var$factorToGL[blendDstAlpha]);
            this.currentBlendSrc = blendSrc;
            this.currentBlendDst = blendDst;
            this.currentBlendSrcAlpha = blendSrcAlpha;
            this.currentBlendDstAlpha = blendDstAlpha;
        }
        this.currentBlending = blending;
        this.currentPremultipledAlpha = false;
    }
    setColorMask(colorMask) {
        if (this.currentColorMask !== colorMask) {
            this.gl.colorMask(colorMask, colorMask, colorMask, colorMask);
            this.currentColorMask = colorMask;
        }
    }
    setDepthTest(depthTest) {
        const { gl: gl } = this;
        if (depthTest) this.enable(gl.DEPTH_TEST);
        else this.disable(gl.DEPTH_TEST);
    }
    setDepthMask(depthMask) {
        if (this.currentDepthMask !== depthMask) {
            this.gl.depthMask(depthMask);
            this.currentDepthMask = depthMask;
        }
    }
    setDepthFunc(depthFunc) {
        if (this.currentDepthFunc !== depthFunc) {
            const { gl: gl } = this;
            switch(depthFunc){
                case 0, $cb5ee595c0f892af$export$69025ce147cee220:
                    gl.depthFunc(gl.NEVER);
                    break;
                case 0, $cb5ee595c0f892af$export$7182eb52ea3b3f04:
                    gl.depthFunc(gl.ALWAYS);
                    break;
                case 0, $cb5ee595c0f892af$export$eedccec66ab7ebe:
                    gl.depthFunc(gl.LESS);
                    break;
                case 0, $cb5ee595c0f892af$export$296f78a0b892f81a:
                    gl.depthFunc(gl.LEQUAL);
                    break;
                case 0, $cb5ee595c0f892af$export$a60d398fc7b7590e:
                    gl.depthFunc(gl.EQUAL);
                    break;
                case 0, $cb5ee595c0f892af$export$7d7234c1240a1fc4:
                    gl.depthFunc(gl.GEQUAL);
                    break;
                case 0, $cb5ee595c0f892af$export$c5e2c52991f30937:
                    gl.depthFunc(gl.GREATER);
                    break;
                case 0, $cb5ee595c0f892af$export$2f843afa843d8916:
                    gl.depthFunc(gl.NOTEQUAL);
                    break;
                default:
                    gl.depthFunc(gl.LEQUAL);
            }
            this.currentDepthFunc = depthFunc;
        }
    }
    setStencilTest(stencilTest) {
        const { gl: gl } = this;
        if (stencilTest) this.enable(gl.STENCIL_TEST);
        else this.disable(gl.STENCIL_TEST);
    }
    setStencilMask(stencilMask) {
        if (this.currentStencilMask !== stencilMask) {
            this.gl.stencilMask(stencilMask);
            this.currentStencilMask = stencilMask;
        }
    }
    setStencilFunc(stencilFunc, stencilRef, stencilMask) {
        if (this.currentStencilFunc !== stencilFunc || this.currentStencilRef !== stencilRef || this.currentStencilFuncMask !== stencilMask) {
            this.gl.stencilFunc(stencilFunc, stencilRef, stencilMask);
            this.currentStencilFunc = stencilFunc;
            this.currentStencilRef = stencilRef;
            this.currentStencilFuncMask = stencilMask;
        }
    }
    setStencilOp(stencilFail, stencilZFail, stencilZPass) {
        if (this.currentStencilFail !== stencilFail || this.currentStencilZFail !== stencilZFail || this.currentStencilZPass !== stencilZPass) {
            this.gl.stencilOp(stencilFail, stencilZFail, stencilZPass);
            this.currentStencilFail = stencilFail;
            this.currentStencilZFail = stencilZFail;
            this.currentStencilZPass = stencilZPass;
        }
    }
    setMaterial(material, frontFaceCW) {
        const { gl: gl } = this;
        material.side === (0, $cb5ee595c0f892af$export$3b296b6f144d5b03) ? this.disable(gl.CULL_FACE) : this.enable(gl.CULL_FACE);
        let flipSided = material.side === (0, $cb5ee595c0f892af$export$d9f0486e75b5ace);
        if (frontFaceCW) flipSided = !flipSided;
        this.setFlipSided(flipSided);
        material.blending === (0, $cb5ee595c0f892af$export$5b29a26d96ee6af0) && material.transparent === false ? this.setBlending((0, $cb5ee595c0f892af$export$63b8d6b580fc65ba)) : this.setBlending(material.blending, material.blendEquation, material.blendSrc, material.blendDst, material.blendEquationAlpha, material.blendSrcAlpha, material.blendDstAlpha, material.premultipliedAlpha);
        this.setDepthFunc(material.depthFunc);
        this.setDepthTest(material.depthTest);
        this.setDepthMask(material.depthWrite);
        this.setColorMask(material.colorWrite);
        const stencilWrite = material.stencilWrite;
        this.setStencilTest(stencilWrite);
        if (stencilWrite) {
            this.setStencilMask(material.stencilWriteMask);
            this.setStencilFunc(material.stencilFunc, material.stencilRef, material.stencilFuncMask);
            this.setStencilOp(material.stencilFail, material.stencilZFail, material.stencilZPass);
        }
        this.setPolygonOffset(material.polygonOffset, material.polygonOffsetFactor, material.polygonOffsetUnits);
        material.alphaToCoverage === true && this.backend.renderer.samples > 1 ? this.enable(gl.SAMPLE_ALPHA_TO_COVERAGE) : this.disable(gl.SAMPLE_ALPHA_TO_COVERAGE);
    }
    setPolygonOffset(polygonOffset, factor, units) {
        const { gl: gl } = this;
        if (polygonOffset) {
            this.enable(gl.POLYGON_OFFSET_FILL);
            if (this.currentPolygonOffsetFactor !== factor || this.currentPolygonOffsetUnits !== units) {
                gl.polygonOffset(factor, units);
                this.currentPolygonOffsetFactor = factor;
                this.currentPolygonOffsetUnits = units;
            }
        } else this.disable(gl.POLYGON_OFFSET_FILL);
    }
    useProgram(program) {
        if (this.currentProgram !== program) {
            this.gl.useProgram(program);
            this.currentProgram = program;
            return true;
        }
        return false;
    }
    // framebuffer
    bindFramebuffer(target, framebuffer) {
        const { gl: gl, currentBoundFramebuffers: currentBoundFramebuffers } = this;
        if (currentBoundFramebuffers[target] !== framebuffer) {
            gl.bindFramebuffer(target, framebuffer);
            currentBoundFramebuffers[target] = framebuffer;
            // gl.DRAW_FRAMEBUFFER is equivalent to gl.FRAMEBUFFER
            if (target === gl.DRAW_FRAMEBUFFER) currentBoundFramebuffers[gl.FRAMEBUFFER] = framebuffer;
            if (target === gl.FRAMEBUFFER) currentBoundFramebuffers[gl.DRAW_FRAMEBUFFER] = framebuffer;
            return true;
        }
        return false;
    }
    drawBuffers(renderContext, framebuffer) {
        const { gl: gl } = this;
        let drawBuffers = [];
        let needsUpdate = false;
        if (renderContext.textures !== null) {
            drawBuffers = this.currentDrawbuffers.get(framebuffer);
            if (drawBuffers === undefined) {
                drawBuffers = [];
                this.currentDrawbuffers.set(framebuffer, drawBuffers);
            }
            const textures = renderContext.textures;
            if (drawBuffers.length !== textures.length || drawBuffers[0] !== gl.COLOR_ATTACHMENT0) {
                for(let i = 0, il = textures.length; i < il; i++)drawBuffers[i] = gl.COLOR_ATTACHMENT0 + i;
                drawBuffers.length = textures.length;
                needsUpdate = true;
            }
        } else if (drawBuffers[0] !== gl.BACK) {
            drawBuffers[0] = gl.BACK;
            needsUpdate = true;
        }
        if (needsUpdate) gl.drawBuffers(drawBuffers);
    }
    // texture
    activeTexture(webglSlot) {
        const { gl: gl, currentTextureSlot: currentTextureSlot, maxTextures: maxTextures } = this;
        if (webglSlot === undefined) webglSlot = gl.TEXTURE0 + maxTextures - 1;
        if (currentTextureSlot !== webglSlot) {
            gl.activeTexture(webglSlot);
            this.currentTextureSlot = webglSlot;
        }
    }
    bindTexture(webglType, webglTexture, webglSlot) {
        const { gl: gl, currentTextureSlot: currentTextureSlot, currentBoundTextures: currentBoundTextures, maxTextures: maxTextures } = this;
        if (webglSlot === undefined) {
            if (currentTextureSlot === null) webglSlot = gl.TEXTURE0 + maxTextures - 1;
            else webglSlot = currentTextureSlot;
        }
        let boundTexture = currentBoundTextures[webglSlot];
        if (boundTexture === undefined) {
            boundTexture = {
                type: undefined,
                texture: undefined
            };
            currentBoundTextures[webglSlot] = boundTexture;
        }
        if (boundTexture.type !== webglType || boundTexture.texture !== webglTexture) {
            if (currentTextureSlot !== webglSlot) {
                gl.activeTexture(webglSlot);
                this.currentTextureSlot = webglSlot;
            }
            gl.bindTexture(webglType, webglTexture);
            boundTexture.type = webglType;
            boundTexture.texture = webglTexture;
        }
    }
    bindBufferBase(target, index, buffer) {
        const { gl: gl } = this;
        const key = `${target}-${index}`;
        if (this.currentBoundBufferBases[key] !== buffer) {
            gl.bindBufferBase(target, index, buffer);
            this.currentBoundBufferBases[key] = buffer;
            return true;
        }
        return false;
    }
    unbindTexture() {
        const { gl: gl, currentTextureSlot: currentTextureSlot, currentBoundTextures: currentBoundTextures } = this;
        const boundTexture = currentBoundTextures[currentTextureSlot];
        if (boundTexture !== undefined && boundTexture.type !== undefined) {
            gl.bindTexture(boundTexture.type, null);
            boundTexture.type = undefined;
            boundTexture.texture = undefined;
        }
    }
}
var $88572ab434b6ea49$export$2e2bcd8739ae039 = $88572ab434b6ea49$var$WebGLState;



class $c064792306d08bad$var$WebGLUtils {
    constructor(backend){
        this.backend = backend;
        this.gl = this.backend.gl;
        this.extensions = backend.extensions;
    }
    convert(p, colorSpace = (0, $cb5ee595c0f892af$export$bfcb490c2dd3db51)) {
        const { gl: gl, extensions: extensions } = this;
        let extension;
        if (p === (0, $cb5ee595c0f892af$export$2e8ce08d3f6f5e10)) return gl.UNSIGNED_BYTE;
        if (p === (0, $cb5ee595c0f892af$export$b3969b01faf587f2)) return gl.UNSIGNED_SHORT_4_4_4_4;
        if (p === (0, $cb5ee595c0f892af$export$18886f8ae33e90de)) return gl.UNSIGNED_SHORT_5_5_5_1;
        if (p === (0, $cb5ee595c0f892af$export$5a4c329b7e2092d3)) return gl.UNSIGNED_INT_5_9_9_9_REV;
        if (p === (0, $cb5ee595c0f892af$export$545fce0311a9796a)) return gl.BYTE;
        if (p === (0, $cb5ee595c0f892af$export$88572337f312435f)) return gl.SHORT;
        if (p === (0, $cb5ee595c0f892af$export$c63dc51868b06a9d)) return gl.UNSIGNED_SHORT;
        if (p === (0, $cb5ee595c0f892af$export$5c612977753abe2)) return gl.INT;
        if (p === (0, $cb5ee595c0f892af$export$c3c7fc4518ebba96)) return gl.UNSIGNED_INT;
        if (p === (0, $cb5ee595c0f892af$export$f6d331659b644596)) return gl.FLOAT;
        if (p === (0, $cb5ee595c0f892af$export$2697304443f382bc)) return gl.HALF_FLOAT;
        if (p === (0, $cb5ee595c0f892af$export$988473390501ed4b)) return gl.ALPHA;
        if (p === (0, $cb5ee595c0f892af$export$7c67423a5ee6f5eb)) return gl.RGB;
        if (p === (0, $cb5ee595c0f892af$export$3f8bb04b555a363c)) return gl.RGBA;
        if (p === (0, $cb5ee595c0f892af$export$cc09ccbf6d1ed449)) return gl.LUMINANCE;
        if (p === (0, $cb5ee595c0f892af$export$9053a81c4a69c289)) return gl.LUMINANCE_ALPHA;
        if (p === (0, $cb5ee595c0f892af$export$c1b6b5136be58045)) return gl.DEPTH_COMPONENT;
        if (p === (0, $cb5ee595c0f892af$export$1e113ac2d0905829)) return gl.DEPTH_STENCIL;
        // WebGL2 formats.
        if (p === (0, $cb5ee595c0f892af$export$4e041a7967d15c4b)) return gl.RED;
        if (p === (0, $cb5ee595c0f892af$export$aa92e870a709d190)) return gl.RED_INTEGER;
        if (p === (0, $cb5ee595c0f892af$export$6cdf0b461c7ce8a0)) return gl.RG;
        if (p === (0, $cb5ee595c0f892af$export$1ba1c45f9f77d4d7)) return gl.RG_INTEGER;
        if (p === (0, $cb5ee595c0f892af$export$c200e7d26f592f21)) return gl.RGBA_INTEGER;
        // S3TC
        if (p === (0, $cb5ee595c0f892af$export$21d1799c6d552fc0) || p === (0, $cb5ee595c0f892af$export$afa304c3e981b668) || p === (0, $cb5ee595c0f892af$export$d2a1a68024a3e56c) || p === (0, $cb5ee595c0f892af$export$9a79c424327dacf9)) {
            if (colorSpace === (0, $cb5ee595c0f892af$export$561f394b24edfcaa)) {
                extension = extensions.get('WEBGL_compressed_texture_s3tc_srgb');
                if (extension !== null) {
                    if (p === (0, $cb5ee595c0f892af$export$21d1799c6d552fc0)) return extension.COMPRESSED_SRGB_S3TC_DXT1_EXT;
                    if (p === (0, $cb5ee595c0f892af$export$afa304c3e981b668)) return extension.COMPRESSED_SRGB_ALPHA_S3TC_DXT1_EXT;
                    if (p === (0, $cb5ee595c0f892af$export$d2a1a68024a3e56c)) return extension.COMPRESSED_SRGB_ALPHA_S3TC_DXT3_EXT;
                    if (p === (0, $cb5ee595c0f892af$export$9a79c424327dacf9)) return extension.COMPRESSED_SRGB_ALPHA_S3TC_DXT5_EXT;
                } else return null;
            } else {
                extension = extensions.get('WEBGL_compressed_texture_s3tc');
                if (extension !== null) {
                    if (p === (0, $cb5ee595c0f892af$export$21d1799c6d552fc0)) return extension.COMPRESSED_RGB_S3TC_DXT1_EXT;
                    if (p === (0, $cb5ee595c0f892af$export$afa304c3e981b668)) return extension.COMPRESSED_RGBA_S3TC_DXT1_EXT;
                    if (p === (0, $cb5ee595c0f892af$export$d2a1a68024a3e56c)) return extension.COMPRESSED_RGBA_S3TC_DXT3_EXT;
                    if (p === (0, $cb5ee595c0f892af$export$9a79c424327dacf9)) return extension.COMPRESSED_RGBA_S3TC_DXT5_EXT;
                } else return null;
            }
        }
        // PVRTC
        if (p === (0, $cb5ee595c0f892af$export$19ada9bbb1af3573) || p === (0, $cb5ee595c0f892af$export$d0f0355bb3d948e4) || p === (0, $cb5ee595c0f892af$export$b82296714358084c) || p === (0, $cb5ee595c0f892af$export$b71692456c47b6c3)) {
            extension = extensions.get('WEBGL_compressed_texture_pvrtc');
            if (extension !== null) {
                if (p === (0, $cb5ee595c0f892af$export$19ada9bbb1af3573)) return extension.COMPRESSED_RGB_PVRTC_4BPPV1_IMG;
                if (p === (0, $cb5ee595c0f892af$export$d0f0355bb3d948e4)) return extension.COMPRESSED_RGB_PVRTC_2BPPV1_IMG;
                if (p === (0, $cb5ee595c0f892af$export$b82296714358084c)) return extension.COMPRESSED_RGBA_PVRTC_4BPPV1_IMG;
                if (p === (0, $cb5ee595c0f892af$export$b71692456c47b6c3)) return extension.COMPRESSED_RGBA_PVRTC_2BPPV1_IMG;
            } else return null;
        }
        // ETC
        if (p === (0, $cb5ee595c0f892af$export$6ab91af2d757aee7) || p === (0, $cb5ee595c0f892af$export$7800993ef8106a6a) || p === (0, $cb5ee595c0f892af$export$23ed8300a860e7d8)) {
            extension = extensions.get('WEBGL_compressed_texture_etc');
            if (extension !== null) {
                if (p === (0, $cb5ee595c0f892af$export$6ab91af2d757aee7) || p === (0, $cb5ee595c0f892af$export$7800993ef8106a6a)) return colorSpace === (0, $cb5ee595c0f892af$export$561f394b24edfcaa) ? extension.COMPRESSED_SRGB8_ETC2 : extension.COMPRESSED_RGB8_ETC2;
                if (p === (0, $cb5ee595c0f892af$export$23ed8300a860e7d8)) return colorSpace === (0, $cb5ee595c0f892af$export$561f394b24edfcaa) ? extension.COMPRESSED_SRGB8_ALPHA8_ETC2_EAC : extension.COMPRESSED_RGBA8_ETC2_EAC;
            } else return null;
        }
        // ASTC
        if (p === (0, $cb5ee595c0f892af$export$dc5570b4a2b92d48) || p === (0, $cb5ee595c0f892af$export$68880cd325f8b2fb) || p === (0, $cb5ee595c0f892af$export$7d2c0be323373d95) || p === (0, $cb5ee595c0f892af$export$22b52da301fc3a3e) || p === (0, $cb5ee595c0f892af$export$c009e2cb4a66485e) || p === (0, $cb5ee595c0f892af$export$118fff5afa255b63) || p === (0, $cb5ee595c0f892af$export$120713c829ae0667) || p === (0, $cb5ee595c0f892af$export$c79eeabbf53313e9) || p === (0, $cb5ee595c0f892af$export$443cf6567cdd6424) || p === (0, $cb5ee595c0f892af$export$6573984fc9840780) || p === (0, $cb5ee595c0f892af$export$e7aee563f30091de) || p === (0, $cb5ee595c0f892af$export$2eb8634622ddeab7) || p === (0, $cb5ee595c0f892af$export$202b1ce7b5d25742) || p === (0, $cb5ee595c0f892af$export$18ab77abd087e467)) {
            extension = extensions.get('WEBGL_compressed_texture_astc');
            if (extension !== null) {
                if (p === (0, $cb5ee595c0f892af$export$dc5570b4a2b92d48)) return colorSpace === (0, $cb5ee595c0f892af$export$561f394b24edfcaa) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_4x4_KHR : extension.COMPRESSED_RGBA_ASTC_4x4_KHR;
                if (p === (0, $cb5ee595c0f892af$export$68880cd325f8b2fb)) return colorSpace === (0, $cb5ee595c0f892af$export$561f394b24edfcaa) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_5x4_KHR : extension.COMPRESSED_RGBA_ASTC_5x4_KHR;
                if (p === (0, $cb5ee595c0f892af$export$7d2c0be323373d95)) return colorSpace === (0, $cb5ee595c0f892af$export$561f394b24edfcaa) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_5x5_KHR : extension.COMPRESSED_RGBA_ASTC_5x5_KHR;
                if (p === (0, $cb5ee595c0f892af$export$22b52da301fc3a3e)) return colorSpace === (0, $cb5ee595c0f892af$export$561f394b24edfcaa) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_6x5_KHR : extension.COMPRESSED_RGBA_ASTC_6x5_KHR;
                if (p === (0, $cb5ee595c0f892af$export$c009e2cb4a66485e)) return colorSpace === (0, $cb5ee595c0f892af$export$561f394b24edfcaa) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_6x6_KHR : extension.COMPRESSED_RGBA_ASTC_6x6_KHR;
                if (p === (0, $cb5ee595c0f892af$export$118fff5afa255b63)) return colorSpace === (0, $cb5ee595c0f892af$export$561f394b24edfcaa) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_8x5_KHR : extension.COMPRESSED_RGBA_ASTC_8x5_KHR;
                if (p === (0, $cb5ee595c0f892af$export$120713c829ae0667)) return colorSpace === (0, $cb5ee595c0f892af$export$561f394b24edfcaa) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_8x6_KHR : extension.COMPRESSED_RGBA_ASTC_8x6_KHR;
                if (p === (0, $cb5ee595c0f892af$export$c79eeabbf53313e9)) return colorSpace === (0, $cb5ee595c0f892af$export$561f394b24edfcaa) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_8x8_KHR : extension.COMPRESSED_RGBA_ASTC_8x8_KHR;
                if (p === (0, $cb5ee595c0f892af$export$443cf6567cdd6424)) return colorSpace === (0, $cb5ee595c0f892af$export$561f394b24edfcaa) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_10x5_KHR : extension.COMPRESSED_RGBA_ASTC_10x5_KHR;
                if (p === (0, $cb5ee595c0f892af$export$6573984fc9840780)) return colorSpace === (0, $cb5ee595c0f892af$export$561f394b24edfcaa) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_10x6_KHR : extension.COMPRESSED_RGBA_ASTC_10x6_KHR;
                if (p === (0, $cb5ee595c0f892af$export$e7aee563f30091de)) return colorSpace === (0, $cb5ee595c0f892af$export$561f394b24edfcaa) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_10x8_KHR : extension.COMPRESSED_RGBA_ASTC_10x8_KHR;
                if (p === (0, $cb5ee595c0f892af$export$2eb8634622ddeab7)) return colorSpace === (0, $cb5ee595c0f892af$export$561f394b24edfcaa) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_10x10_KHR : extension.COMPRESSED_RGBA_ASTC_10x10_KHR;
                if (p === (0, $cb5ee595c0f892af$export$202b1ce7b5d25742)) return colorSpace === (0, $cb5ee595c0f892af$export$561f394b24edfcaa) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_12x10_KHR : extension.COMPRESSED_RGBA_ASTC_12x10_KHR;
                if (p === (0, $cb5ee595c0f892af$export$18ab77abd087e467)) return colorSpace === (0, $cb5ee595c0f892af$export$561f394b24edfcaa) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_12x12_KHR : extension.COMPRESSED_RGBA_ASTC_12x12_KHR;
            } else return null;
        }
        // BPTC
        if (p === (0, $cb5ee595c0f892af$export$ce40b115e188bc81)) {
            extension = extensions.get('EXT_texture_compression_bptc');
            if (extension !== null) {
                if (p === (0, $cb5ee595c0f892af$export$ce40b115e188bc81)) return colorSpace === (0, $cb5ee595c0f892af$export$561f394b24edfcaa) ? extension.COMPRESSED_SRGB_ALPHA_BPTC_UNORM_EXT : extension.COMPRESSED_RGBA_BPTC_UNORM_EXT;
            } else return null;
        }
        // RGTC
        if (p === (0, $cb5ee595c0f892af$export$b1688df4c4c21670) || p === (0, $cb5ee595c0f892af$export$fc15e5d8261eed58) || p === (0, $cb5ee595c0f892af$export$d220f6ade8463a0f) || p === (0, $cb5ee595c0f892af$export$768646d09dc1b6ef)) {
            extension = extensions.get('EXT_texture_compression_rgtc');
            if (extension !== null) {
                if (p === (0, $cb5ee595c0f892af$export$ce40b115e188bc81)) return extension.COMPRESSED_RED_RGTC1_EXT;
                if (p === (0, $cb5ee595c0f892af$export$fc15e5d8261eed58)) return extension.COMPRESSED_SIGNED_RED_RGTC1_EXT;
                if (p === (0, $cb5ee595c0f892af$export$d220f6ade8463a0f)) return extension.COMPRESSED_RED_GREEN_RGTC2_EXT;
                if (p === (0, $cb5ee595c0f892af$export$768646d09dc1b6ef)) return extension.COMPRESSED_SIGNED_RED_GREEN_RGTC2_EXT;
            } else return null;
        }
        //
        if (p === (0, $cb5ee595c0f892af$export$6c8ea339bfab1301)) return gl.UNSIGNED_INT_24_8;
        // if "p" can't be resolved, assume the user defines a WebGL constant as a string (fallback/workaround for packed RGB formats)
        return gl[p] !== undefined ? gl[p] : null;
    }
    _clientWaitAsync() {
        const { gl: gl } = this;
        const sync = gl.fenceSync(gl.SYNC_GPU_COMMANDS_COMPLETE, 0);
        gl.flush();
        return new Promise((resolve, reject)=>{
            function test() {
                const res = gl.clientWaitSync(sync, gl.SYNC_FLUSH_COMMANDS_BIT, 0);
                if (res === gl.WAIT_FAILED) {
                    gl.deleteSync(sync);
                    reject();
                    return;
                }
                if (res === gl.TIMEOUT_EXPIRED) {
                    requestAnimationFrame(test);
                    return;
                }
                gl.deleteSync(sync);
                resolve();
            }
            test();
        });
    }
}
var $c064792306d08bad$export$2e2bcd8739ae039 = $c064792306d08bad$var$WebGLUtils;



let $e2aa71f43acb41f6$var$initialized = false, $e2aa71f43acb41f6$var$wrappingToGL, $e2aa71f43acb41f6$var$filterToGL, $e2aa71f43acb41f6$var$compareToGL;
class $e2aa71f43acb41f6$var$WebGLTextureUtils {
    constructor(backend){
        this.backend = backend;
        this.gl = backend.gl;
        this.extensions = backend.extensions;
        this.defaultTextures = {};
        if ($e2aa71f43acb41f6$var$initialized === false) {
            this._init(this.gl);
            $e2aa71f43acb41f6$var$initialized = true;
        }
    }
    _init(gl) {
        // Store only WebGL constants here.
        $e2aa71f43acb41f6$var$wrappingToGL = {
            [(0, $cb5ee595c0f892af$export$533346c8e8dac0f5)]: gl.REPEAT,
            [(0, $cb5ee595c0f892af$export$9d9334239a5a5e06)]: gl.CLAMP_TO_EDGE,
            [(0, $cb5ee595c0f892af$export$c7e7c00b14f51a4f)]: gl.MIRRORED_REPEAT
        };
        $e2aa71f43acb41f6$var$filterToGL = {
            [(0, $cb5ee595c0f892af$export$727aa5ec3fe39bf0)]: gl.NEAREST,
            [(0, $cb5ee595c0f892af$export$d129e38cf6feaa8c)]: gl.NEAREST_MIPMAP_NEAREST,
            [(0, $cb5ee595c0f892af$export$d2327c1afe5bfdf2)]: gl.NEAREST_MIPMAP_LINEAR,
            [(0, $cb5ee595c0f892af$export$8a72f490b25c56c8)]: gl.LINEAR,
            [(0, $cb5ee595c0f892af$export$19a719f377145a13)]: gl.LINEAR_MIPMAP_NEAREST,
            [(0, $cb5ee595c0f892af$export$5d8599b6a933fb1b)]: gl.LINEAR_MIPMAP_LINEAR
        };
        $e2aa71f43acb41f6$var$compareToGL = {
            [(0, $cb5ee595c0f892af$export$d9e2d19a747baaab)]: gl.NEVER,
            [(0, $cb5ee595c0f892af$export$187b73a3e352c145)]: gl.ALWAYS,
            [(0, $cb5ee595c0f892af$export$36bcf49c713b3eb7)]: gl.LESS,
            [(0, $cb5ee595c0f892af$export$64eea11eb407ddf1)]: gl.LEQUAL,
            [(0, $cb5ee595c0f892af$export$66f28d946fc6a0d5)]: gl.EQUAL,
            [(0, $cb5ee595c0f892af$export$1cdcb70d53d65f61)]: gl.GEQUAL,
            [(0, $cb5ee595c0f892af$export$155af022118f3a38)]: gl.GREATER,
            [(0, $cb5ee595c0f892af$export$67ab95dde6bed156)]: gl.NOTEQUAL
        };
    }
    filterFallback(f) {
        const { gl: gl } = this;
        if (f === (0, $cb5ee595c0f892af$export$727aa5ec3fe39bf0) || f === (0, $cb5ee595c0f892af$export$d129e38cf6feaa8c) || f === (0, $cb5ee595c0f892af$export$d2327c1afe5bfdf2)) return gl.NEAREST;
        return gl.LINEAR;
    }
    getGLTextureType(texture) {
        const { gl: gl } = this;
        let glTextureType;
        if (texture.isCubeTexture === true) glTextureType = gl.TEXTURE_CUBE_MAP;
        else if (texture.isDataArrayTexture === true || texture.isCompressedArrayTexture === true) glTextureType = gl.TEXTURE_2D_ARRAY;
        else if (texture.isData3DTexture === true) glTextureType = gl.TEXTURE_3D;
        else glTextureType = gl.TEXTURE_2D;
        return glTextureType;
    }
    getInternalFormat(internalFormatName, glFormat, glType, colorSpace, forceLinearTransfer = false) {
        const { gl: gl, extensions: extensions } = this;
        if (internalFormatName !== null) {
            if (gl[internalFormatName] !== undefined) return gl[internalFormatName];
            console.warn('THREE.WebGLRenderer: Attempt to use non-existing WebGL internal format \'' + internalFormatName + '\'');
        }
        let internalFormat = glFormat;
        if (glFormat === gl.RED) {
            if (glType === gl.FLOAT) internalFormat = gl.R32F;
            if (glType === gl.HALF_FLOAT) internalFormat = gl.R16F;
            if (glType === gl.UNSIGNED_BYTE) internalFormat = gl.R8;
            if (glType === gl.UNSIGNED_SHORT) internalFormat = gl.R16;
            if (glType === gl.UNSIGNED_INT) internalFormat = gl.R32UI;
            if (glType === gl.BYTE) internalFormat = gl.R8I;
            if (glType === gl.SHORT) internalFormat = gl.R16I;
            if (glType === gl.INT) internalFormat = gl.R32I;
        }
        if (glFormat === gl.RED_INTEGER) {
            if (glType === gl.UNSIGNED_BYTE) internalFormat = gl.R8UI;
            if (glType === gl.UNSIGNED_SHORT) internalFormat = gl.R16UI;
            if (glType === gl.UNSIGNED_INT) internalFormat = gl.R32UI;
            if (glType === gl.BYTE) internalFormat = gl.R8I;
            if (glType === gl.SHORT) internalFormat = gl.R16I;
            if (glType === gl.INT) internalFormat = gl.R32I;
        }
        if (glFormat === gl.RG) {
            if (glType === gl.FLOAT) internalFormat = gl.RG32F;
            if (glType === gl.HALF_FLOAT) internalFormat = gl.RG16F;
            if (glType === gl.UNSIGNED_BYTE) internalFormat = gl.RG8;
            if (glType === gl.UNSIGNED_SHORT) internalFormat = gl.RG16;
            if (glType === gl.UNSIGNED_INT) internalFormat = gl.RG32UI;
            if (glType === gl.BYTE) internalFormat = gl.RG8I;
            if (glType === gl.SHORT) internalFormat = gl.RG16I;
            if (glType === gl.INT) internalFormat = gl.RG32I;
        }
        if (glFormat === gl.RG_INTEGER) {
            if (glType === gl.UNSIGNED_BYTE) internalFormat = gl.RG8UI;
            if (glType === gl.UNSIGNED_SHORT) internalFormat = gl.RG16UI;
            if (glType === gl.UNSIGNED_INT) internalFormat = gl.RG32UI;
            if (glType === gl.BYTE) internalFormat = gl.RG8I;
            if (glType === gl.SHORT) internalFormat = gl.RG16I;
            if (glType === gl.INT) internalFormat = gl.RG32I;
        }
        if (glFormat === gl.RGB) {
            if (glType === gl.FLOAT) internalFormat = gl.RGB32F;
            if (glType === gl.HALF_FLOAT) internalFormat = gl.RGB16F;
            if (glType === gl.UNSIGNED_BYTE) internalFormat = gl.RGB8;
            if (glType === gl.UNSIGNED_SHORT) internalFormat = gl.RGB16;
            if (glType === gl.UNSIGNED_INT) internalFormat = gl.RGB32UI;
            if (glType === gl.BYTE) internalFormat = gl.RGB8I;
            if (glType === gl.SHORT) internalFormat = gl.RGB16I;
            if (glType === gl.INT) internalFormat = gl.RGB32I;
            if (glType === gl.UNSIGNED_BYTE) internalFormat = colorSpace === (0, $cb5ee595c0f892af$export$561f394b24edfcaa) && forceLinearTransfer === false ? gl.SRGB8 : gl.RGB8;
            if (glType === gl.UNSIGNED_SHORT_5_6_5) internalFormat = gl.RGB565;
            if (glType === gl.UNSIGNED_SHORT_5_5_5_1) internalFormat = gl.RGB5_A1;
            if (glType === gl.UNSIGNED_SHORT_4_4_4_4) internalFormat = gl.RGB4;
            if (glType === gl.UNSIGNED_INT_5_9_9_9_REV) internalFormat = gl.RGB9_E5;
        }
        if (glFormat === gl.RGB_INTEGER) {
            if (glType === gl.UNSIGNED_BYTE) internalFormat = gl.RGB8UI;
            if (glType === gl.UNSIGNED_SHORT) internalFormat = gl.RGB16UI;
            if (glType === gl.UNSIGNED_INT) internalFormat = gl.RGB32UI;
            if (glType === gl.BYTE) internalFormat = gl.RGB8I;
            if (glType === gl.SHORT) internalFormat = gl.RGB16I;
            if (glType === gl.INT) internalFormat = gl.RGB32I;
        }
        if (glFormat === gl.RGBA) {
            if (glType === gl.FLOAT) internalFormat = gl.RGBA32F;
            if (glType === gl.HALF_FLOAT) internalFormat = gl.RGBA16F;
            if (glType === gl.UNSIGNED_BYTE) internalFormat = gl.RGBA8;
            if (glType === gl.UNSIGNED_SHORT) internalFormat = gl.RGBA16;
            if (glType === gl.UNSIGNED_INT) internalFormat = gl.RGBA32UI;
            if (glType === gl.BYTE) internalFormat = gl.RGBA8I;
            if (glType === gl.SHORT) internalFormat = gl.RGBA16I;
            if (glType === gl.INT) internalFormat = gl.RGBA32I;
            if (glType === gl.UNSIGNED_BYTE) internalFormat = colorSpace === (0, $cb5ee595c0f892af$export$561f394b24edfcaa) && forceLinearTransfer === false ? gl.SRGB8_ALPHA8 : gl.RGBA8;
            if (glType === gl.UNSIGNED_SHORT_4_4_4_4) internalFormat = gl.RGBA4;
            if (glType === gl.UNSIGNED_SHORT_5_5_5_1) internalFormat = gl.RGB5_A1;
        }
        if (glFormat === gl.RGBA_INTEGER) {
            if (glType === gl.UNSIGNED_BYTE) internalFormat = gl.RGBA8UI;
            if (glType === gl.UNSIGNED_SHORT) internalFormat = gl.RGBA16UI;
            if (glType === gl.UNSIGNED_INT) internalFormat = gl.RGBA32UI;
            if (glType === gl.BYTE) internalFormat = gl.RGBA8I;
            if (glType === gl.SHORT) internalFormat = gl.RGBA16I;
            if (glType === gl.INT) internalFormat = gl.RGBA32I;
        }
        if (glFormat === gl.DEPTH_COMPONENT) {
            if (glType === gl.UNSIGNED_INT) internalFormat = gl.DEPTH24_STENCIL8;
            if (glType === gl.FLOAT) internalFormat = gl.DEPTH_COMPONENT32F;
        }
        if (glFormat === gl.DEPTH_STENCIL) {
            if (glType === gl.UNSIGNED_INT_24_8) internalFormat = gl.DEPTH24_STENCIL8;
        }
        if (internalFormat === gl.R16F || internalFormat === gl.R32F || internalFormat === gl.RG16F || internalFormat === gl.RG32F || internalFormat === gl.RGBA16F || internalFormat === gl.RGBA32F) extensions.get('EXT_color_buffer_float');
        return internalFormat;
    }
    setTextureParameters(textureType, texture) {
        const { gl: gl, extensions: extensions, backend: backend } = this;
        gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL, texture.flipY);
        gl.pixelStorei(gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, texture.premultiplyAlpha);
        gl.pixelStorei(gl.UNPACK_ALIGNMENT, texture.unpackAlignment);
        gl.pixelStorei(gl.UNPACK_COLORSPACE_CONVERSION_WEBGL, gl.NONE);
        gl.texParameteri(textureType, gl.TEXTURE_WRAP_S, $e2aa71f43acb41f6$var$wrappingToGL[texture.wrapS]);
        gl.texParameteri(textureType, gl.TEXTURE_WRAP_T, $e2aa71f43acb41f6$var$wrappingToGL[texture.wrapT]);
        if (textureType === gl.TEXTURE_3D || textureType === gl.TEXTURE_2D_ARRAY) gl.texParameteri(textureType, gl.TEXTURE_WRAP_R, $e2aa71f43acb41f6$var$wrappingToGL[texture.wrapR]);
        gl.texParameteri(textureType, gl.TEXTURE_MAG_FILTER, $e2aa71f43acb41f6$var$filterToGL[texture.magFilter]);
        const hasMipmaps = texture.mipmaps !== undefined && texture.mipmaps.length > 0;
        // follow WebGPU backend mapping for texture filtering
        const minFilter = texture.minFilter === (0, $cb5ee595c0f892af$export$8a72f490b25c56c8) && hasMipmaps ? (0, $cb5ee595c0f892af$export$5d8599b6a933fb1b) : texture.minFilter;
        gl.texParameteri(textureType, gl.TEXTURE_MIN_FILTER, $e2aa71f43acb41f6$var$filterToGL[minFilter]);
        if (texture.compareFunction) {
            gl.texParameteri(textureType, gl.TEXTURE_COMPARE_MODE, gl.COMPARE_REF_TO_TEXTURE);
            gl.texParameteri(textureType, gl.TEXTURE_COMPARE_FUNC, $e2aa71f43acb41f6$var$compareToGL[texture.compareFunction]);
        }
        if (extensions.has('EXT_texture_filter_anisotropic') === true) {
            if (texture.magFilter === (0, $cb5ee595c0f892af$export$727aa5ec3fe39bf0)) return;
            if (texture.minFilter !== (0, $cb5ee595c0f892af$export$d2327c1afe5bfdf2) && texture.minFilter !== (0, $cb5ee595c0f892af$export$5d8599b6a933fb1b)) return;
            if (texture.type === (0, $cb5ee595c0f892af$export$f6d331659b644596) && extensions.has('OES_texture_float_linear') === false) return; // verify extension for WebGL 1 and WebGL 2
            if (texture.anisotropy > 1) {
                const extension = extensions.get('EXT_texture_filter_anisotropic');
                gl.texParameterf(textureType, extension.TEXTURE_MAX_ANISOTROPY_EXT, Math.min(texture.anisotropy, backend.getMaxAnisotropy()));
            }
        }
    }
    createDefaultTexture(texture) {
        const { gl: gl, backend: backend, defaultTextures: defaultTextures } = this;
        const glTextureType = this.getGLTextureType(texture);
        let textureGPU = defaultTextures[glTextureType];
        if (textureGPU === undefined) {
            textureGPU = gl.createTexture();
            backend.state.bindTexture(glTextureType, textureGPU);
            gl.texParameteri(glTextureType, gl.TEXTURE_MIN_FILTER, gl.NEAREST);
            gl.texParameteri(glTextureType, gl.TEXTURE_MAG_FILTER, gl.NEAREST);
            // gl.texImage2D( glTextureType, 0, gl.RGBA, 1, 1, 0, gl.RGBA, gl.UNSIGNED_BYTE, data );
            defaultTextures[glTextureType] = textureGPU;
        }
        backend.set(texture, {
            textureGPU: textureGPU,
            glTextureType: glTextureType,
            isDefault: true
        });
    }
    createTexture(texture, options) {
        const { gl: gl, backend: backend } = this;
        const { levels: levels, width: width, height: height, depth: depth } = options;
        const glFormat = backend.utils.convert(texture.format, texture.colorSpace);
        const glType = backend.utils.convert(texture.type);
        const glInternalFormat = this.getInternalFormat(texture.internalFormat, glFormat, glType, texture.colorSpace, texture.isVideoTexture);
        const textureGPU = gl.createTexture();
        const glTextureType = this.getGLTextureType(texture);
        backend.state.bindTexture(glTextureType, textureGPU);
        this.setTextureParameters(glTextureType, texture);
        if (texture.isDataArrayTexture || texture.isCompressedArrayTexture) gl.texStorage3D(gl.TEXTURE_2D_ARRAY, levels, glInternalFormat, width, height, depth);
        else if (texture.isData3DTexture) gl.texStorage3D(gl.TEXTURE_3D, levels, glInternalFormat, width, height, depth);
        else if (!texture.isVideoTexture) gl.texStorage2D(glTextureType, levels, glInternalFormat, width, height);
        backend.set(texture, {
            textureGPU: textureGPU,
            glTextureType: glTextureType,
            glFormat: glFormat,
            glType: glType,
            glInternalFormat: glInternalFormat
        });
    }
    copyBufferToTexture(buffer, texture) {
        const { gl: gl, backend: backend } = this;
        const { textureGPU: textureGPU, glTextureType: glTextureType, glFormat: glFormat, glType: glType } = backend.get(texture);
        const { width: width, height: height } = texture.source.data;
        gl.bindBuffer(gl.PIXEL_UNPACK_BUFFER, buffer);
        backend.state.bindTexture(glTextureType, textureGPU);
        gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL, false);
        gl.pixelStorei(gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, false);
        gl.texSubImage2D(glTextureType, 0, 0, 0, width, height, glFormat, glType, 0);
        gl.bindBuffer(gl.PIXEL_UNPACK_BUFFER, null);
        backend.state.unbindTexture();
    // debug
    // const framebuffer = gl.createFramebuffer();
    // gl.bindFramebuffer( gl.FRAMEBUFFER, framebuffer );
    // gl.framebufferTexture2D( gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, glTextureType, textureGPU, 0 );
    // const readout = new Float32Array( width * height * 4 );
    // const altFormat = gl.getParameter( gl.IMPLEMENTATION_COLOR_READ_FORMAT );
    // const altType = gl.getParameter( gl.IMPLEMENTATION_COLOR_READ_TYPE );
    // gl.readPixels( 0, 0, width, height, altFormat, altType, readout );
    // gl.bindFramebuffer( gl.FRAMEBUFFER, null );
    // console.log( readout );
    }
    updateTexture(texture, options) {
        const { gl: gl } = this;
        const { width: width, height: height } = options;
        const { textureGPU: textureGPU, glTextureType: glTextureType, glFormat: glFormat, glType: glType, glInternalFormat: glInternalFormat } = this.backend.get(texture);
        if (texture.isRenderTargetTexture || textureGPU === undefined /* unsupported texture format */ ) return;
        const getImage = (source)=>{
            if (source.isDataTexture) return source.image.data;
            else if (source instanceof ImageBitmap || source instanceof OffscreenCanvas || source instanceof HTMLImageElement || source instanceof HTMLCanvasElement) return source;
            return source.data;
        };
        this.backend.state.bindTexture(glTextureType, textureGPU);
        this.setTextureParameters(glTextureType, texture);
        if (texture.isCompressedTexture) {
            const mipmaps = texture.mipmaps;
            const image = options.image;
            for(let i = 0; i < mipmaps.length; i++){
                const mipmap = mipmaps[i];
                if (texture.isCompressedArrayTexture) {
                    if (texture.format !== gl.RGBA) {
                        if (glFormat !== null) gl.compressedTexSubImage3D(gl.TEXTURE_2D_ARRAY, i, 0, 0, 0, mipmap.width, mipmap.height, image.depth, glFormat, mipmap.data);
                        else console.warn('THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .uploadTexture()');
                    } else gl.texSubImage3D(gl.TEXTURE_2D_ARRAY, i, 0, 0, 0, mipmap.width, mipmap.height, image.depth, glFormat, glType, mipmap.data);
                } else if (glFormat !== null) gl.compressedTexSubImage2D(gl.TEXTURE_2D, i, 0, 0, mipmap.width, mipmap.height, glFormat, mipmap.data);
                else console.warn('Unsupported compressed texture format');
            }
        } else if (texture.isCubeTexture) {
            const images = options.images;
            for(let i = 0; i < 6; i++){
                const image = getImage(images[i]);
                gl.texSubImage2D(gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, 0, 0, 0, width, height, glFormat, glType, image);
            }
        } else if (texture.isDataArrayTexture) {
            const image = options.image;
            gl.texSubImage3D(gl.TEXTURE_2D_ARRAY, 0, 0, 0, 0, image.width, image.height, image.depth, glFormat, glType, image.data);
        } else if (texture.isData3DTexture) {
            const image = options.image;
            gl.texSubImage3D(gl.TEXTURE_3D, 0, 0, 0, 0, image.width, image.height, image.depth, glFormat, glType, image.data);
        } else if (texture.isVideoTexture) {
            texture.update();
            gl.texImage2D(glTextureType, 0, glInternalFormat, glFormat, glType, options.image);
        } else {
            const image = getImage(options.image);
            gl.texSubImage2D(glTextureType, 0, 0, 0, width, height, glFormat, glType, image);
        }
    }
    generateMipmaps(texture) {
        const { gl: gl, backend: backend } = this;
        const { textureGPU: textureGPU, glTextureType: glTextureType } = backend.get(texture);
        backend.state.bindTexture(glTextureType, textureGPU);
        gl.generateMipmap(glTextureType);
    }
    deallocateRenderBuffers(renderTarget) {
        const { gl: gl, backend: backend } = this;
        // remove framebuffer reference
        if (renderTarget) {
            const renderContextData = backend.get(renderTarget);
            renderContextData.renderBufferStorageSetup = undefined;
            if (renderContextData.framebuffers) {
                for(const cacheKey in renderContextData.framebuffers)gl.deleteFramebuffer(renderContextData.framebuffers[cacheKey]);
                delete renderContextData.framebuffers;
            }
            if (renderContextData.depthRenderbuffer) {
                gl.deleteRenderbuffer(renderContextData.depthRenderbuffer);
                delete renderContextData.depthRenderbuffer;
            }
            if (renderContextData.stencilRenderbuffer) {
                gl.deleteRenderbuffer(renderContextData.stencilRenderbuffer);
                delete renderContextData.stencilRenderbuffer;
            }
            if (renderContextData.msaaFrameBuffer) {
                gl.deleteFramebuffer(renderContextData.msaaFrameBuffer);
                delete renderContextData.msaaFrameBuffer;
            }
            if (renderContextData.msaaRenderbuffers) {
                for(let i = 0; i < renderContextData.msaaRenderbuffers.length; i++)gl.deleteRenderbuffer(renderContextData.msaaRenderbuffers[i]);
                delete renderContextData.msaaRenderbuffers;
            }
        }
    }
    destroyTexture(texture) {
        const { gl: gl, backend: backend } = this;
        const { textureGPU: textureGPU, renderTarget: renderTarget } = backend.get(texture);
        this.deallocateRenderBuffers(renderTarget);
        gl.deleteTexture(textureGPU);
        backend.delete(texture);
    }
    copyTextureToTexture(srcTexture, dstTexture, srcRegion = null, dstPosition = null, level = 0) {
        const { gl: gl, backend: backend } = this;
        const { state: state } = this.backend;
        const { textureGPU: dstTextureGPU, glTextureType: glTextureType, glType: glType, glFormat: glFormat } = backend.get(dstTexture);
        let width, height, minX, minY;
        let dstX, dstY;
        if (srcRegion !== null) {
            width = srcRegion.max.x - srcRegion.min.x;
            height = srcRegion.max.y - srcRegion.min.y;
            minX = srcRegion.min.x;
            minY = srcRegion.min.y;
        } else {
            width = srcTexture.image.width;
            height = srcTexture.image.height;
            minX = 0;
            minY = 0;
        }
        if (dstPosition !== null) {
            dstX = dstPosition.x;
            dstY = dstPosition.y;
        } else {
            dstX = 0;
            dstY = 0;
        }
        state.bindTexture(glTextureType, dstTextureGPU);
        // As another texture upload may have changed pixelStorei
        // parameters, make sure they are correct for the dstTexture
        gl.pixelStorei(gl.UNPACK_ALIGNMENT, dstTexture.unpackAlignment);
        gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL, dstTexture.flipY);
        gl.pixelStorei(gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, dstTexture.premultiplyAlpha);
        gl.pixelStorei(gl.UNPACK_ALIGNMENT, dstTexture.unpackAlignment);
        const currentUnpackRowLen = gl.getParameter(gl.UNPACK_ROW_LENGTH);
        const currentUnpackImageHeight = gl.getParameter(gl.UNPACK_IMAGE_HEIGHT);
        const currentUnpackSkipPixels = gl.getParameter(gl.UNPACK_SKIP_PIXELS);
        const currentUnpackSkipRows = gl.getParameter(gl.UNPACK_SKIP_ROWS);
        const currentUnpackSkipImages = gl.getParameter(gl.UNPACK_SKIP_IMAGES);
        const image = srcTexture.isCompressedTexture ? srcTexture.mipmaps[level] : srcTexture.image;
        gl.pixelStorei(gl.UNPACK_ROW_LENGTH, image.width);
        gl.pixelStorei(gl.UNPACK_IMAGE_HEIGHT, image.height);
        gl.pixelStorei(gl.UNPACK_SKIP_PIXELS, minX);
        gl.pixelStorei(gl.UNPACK_SKIP_ROWS, minY);
        if (srcTexture.isRenderTargetTexture || srcTexture.isDepthTexture) {
            const srcTextureData = backend.get(srcTexture);
            const dstTextureData = backend.get(dstTexture);
            const srcRenderContextData = backend.get(srcTextureData.renderTarget);
            const dstRenderContextData = backend.get(dstTextureData.renderTarget);
            const srcFramebuffer = srcRenderContextData.framebuffers[srcTextureData.cacheKey];
            const dstFramebuffer = dstRenderContextData.framebuffers[dstTextureData.cacheKey];
            state.bindFramebuffer(gl.READ_FRAMEBUFFER, srcFramebuffer);
            state.bindFramebuffer(gl.DRAW_FRAMEBUFFER, dstFramebuffer);
            let mask = gl.COLOR_BUFFER_BIT;
            if (srcTexture.isDepthTexture) mask = gl.DEPTH_BUFFER_BIT;
            gl.blitFramebuffer(minX, minY, width, height, dstX, dstY, width, height, mask, gl.NEAREST);
            state.bindFramebuffer(gl.READ_FRAMEBUFFER, null);
            state.bindFramebuffer(gl.DRAW_FRAMEBUFFER, null);
        } else {
            if (srcTexture.isDataTexture) gl.texSubImage2D(gl.TEXTURE_2D, level, dstX, dstY, width, height, glFormat, glType, image.data);
            else if (srcTexture.isCompressedTexture) gl.compressedTexSubImage2D(gl.TEXTURE_2D, level, dstX, dstY, image.width, image.height, glFormat, image.data);
            else gl.texSubImage2D(gl.TEXTURE_2D, level, dstX, dstY, width, height, glFormat, glType, image);
        }
        gl.pixelStorei(gl.UNPACK_ROW_LENGTH, currentUnpackRowLen);
        gl.pixelStorei(gl.UNPACK_IMAGE_HEIGHT, currentUnpackImageHeight);
        gl.pixelStorei(gl.UNPACK_SKIP_PIXELS, currentUnpackSkipPixels);
        gl.pixelStorei(gl.UNPACK_SKIP_ROWS, currentUnpackSkipRows);
        gl.pixelStorei(gl.UNPACK_SKIP_IMAGES, currentUnpackSkipImages);
        // Generate mipmaps only when copying level 0
        if (level === 0 && dstTexture.generateMipmaps) gl.generateMipmap(gl.TEXTURE_2D);
        state.unbindTexture();
    }
    copyFramebufferToTexture(texture, renderContext, rectangle) {
        const { gl: gl } = this;
        const { state: state } = this.backend;
        const { textureGPU: textureGPU } = this.backend.get(texture);
        const { x: x, y: y, z: width, w: height } = rectangle;
        const requireDrawFrameBuffer = texture.isDepthTexture === true || renderContext.renderTarget && renderContext.renderTarget.samples > 0;
        const srcHeight = renderContext.renderTarget ? renderContext.renderTarget.height : this.backend.gerDrawingBufferSize().y;
        if (requireDrawFrameBuffer) {
            const partial = x !== 0 || y !== 0;
            let mask;
            let attachment;
            if (texture.isDepthTexture === true) {
                mask = gl.DEPTH_BUFFER_BIT;
                attachment = gl.DEPTH_ATTACHMENT;
                if (renderContext.stencil) mask |= gl.STENCIL_BUFFER_BIT;
            } else {
                mask = gl.COLOR_BUFFER_BIT;
                attachment = gl.COLOR_ATTACHMENT0;
            }
            if (partial) {
                const renderTargetContextData = this.backend.get(renderContext.renderTarget);
                const fb = renderTargetContextData.framebuffers[renderContext.getCacheKey()];
                const msaaFrameBuffer = renderTargetContextData.msaaFrameBuffer;
                state.bindFramebuffer(gl.DRAW_FRAMEBUFFER, fb);
                state.bindFramebuffer(gl.READ_FRAMEBUFFER, msaaFrameBuffer);
                const flippedY = srcHeight - y - height;
                gl.blitFramebuffer(x, flippedY, x + width, flippedY + height, x, flippedY, x + width, flippedY + height, mask, gl.NEAREST);
                state.bindFramebuffer(gl.READ_FRAMEBUFFER, fb);
                state.bindTexture(gl.TEXTURE_2D, textureGPU);
                gl.copyTexSubImage2D(gl.TEXTURE_2D, 0, 0, 0, x, flippedY, width, height);
                state.unbindTexture();
            } else {
                const fb = gl.createFramebuffer();
                state.bindFramebuffer(gl.DRAW_FRAMEBUFFER, fb);
                gl.framebufferTexture2D(gl.DRAW_FRAMEBUFFER, attachment, gl.TEXTURE_2D, textureGPU, 0);
                gl.blitFramebuffer(0, 0, width, height, 0, 0, width, height, mask, gl.NEAREST);
                gl.deleteFramebuffer(fb);
            }
        } else {
            state.bindTexture(gl.TEXTURE_2D, textureGPU);
            gl.copyTexSubImage2D(gl.TEXTURE_2D, 0, 0, 0, x, srcHeight - height - y, width, height);
            state.unbindTexture();
        }
        if (texture.generateMipmaps) this.generateMipmaps(texture);
        this.backend._setFramebuffer(renderContext);
    }
    // Setup storage for internal depth/stencil buffers and bind to correct framebuffer
    setupRenderBufferStorage(renderbuffer, renderContext) {
        const { gl: gl } = this;
        const renderTarget = renderContext.renderTarget;
        const { samples: samples, depthTexture: depthTexture, depthBuffer: depthBuffer, stencilBuffer: stencilBuffer, width: width, height: height } = renderTarget;
        gl.bindRenderbuffer(gl.RENDERBUFFER, renderbuffer);
        if (depthBuffer && !stencilBuffer) {
            let glInternalFormat = gl.DEPTH_COMPONENT24;
            if (samples > 0) {
                if (depthTexture && depthTexture.isDepthTexture) {
                    if (depthTexture.type === gl.FLOAT) glInternalFormat = gl.DEPTH_COMPONENT32F;
                }
                gl.renderbufferStorageMultisample(gl.RENDERBUFFER, samples, glInternalFormat, width, height);
            } else gl.renderbufferStorage(gl.RENDERBUFFER, glInternalFormat, width, height);
            gl.framebufferRenderbuffer(gl.FRAMEBUFFER, gl.DEPTH_ATTACHMENT, gl.RENDERBUFFER, renderbuffer);
        } else if (depthBuffer && stencilBuffer) {
            if (samples > 0) gl.renderbufferStorageMultisample(gl.RENDERBUFFER, samples, gl.DEPTH24_STENCIL8, width, height);
            else gl.renderbufferStorage(gl.RENDERBUFFER, gl.DEPTH_STENCIL, width, height);
            gl.framebufferRenderbuffer(gl.FRAMEBUFFER, gl.DEPTH_STENCIL_ATTACHMENT, gl.RENDERBUFFER, renderbuffer);
        }
    }
    async copyTextureToBuffer(texture, x, y, width, height, faceIndex) {
        const { backend: backend, gl: gl } = this;
        const { textureGPU: textureGPU, glFormat: glFormat, glType: glType } = this.backend.get(texture);
        const fb = gl.createFramebuffer();
        gl.bindFramebuffer(gl.READ_FRAMEBUFFER, fb);
        const target = texture.isCubeTexture ? gl.TEXTURE_CUBE_MAP_POSITIVE_X + faceIndex : gl.TEXTURE_2D;
        gl.framebufferTexture2D(gl.READ_FRAMEBUFFER, gl.COLOR_ATTACHMENT0, target, textureGPU, 0);
        const typedArrayType = this._getTypedArrayType(glType);
        const bytesPerTexel = this._getBytesPerTexel(glType, glFormat);
        const elementCount = width * height;
        const byteLength = elementCount * bytesPerTexel;
        const buffer = gl.createBuffer();
        gl.bindBuffer(gl.PIXEL_PACK_BUFFER, buffer);
        gl.bufferData(gl.PIXEL_PACK_BUFFER, byteLength, gl.STREAM_READ);
        gl.readPixels(x, y, width, height, glFormat, glType, 0);
        gl.bindBuffer(gl.PIXEL_PACK_BUFFER, null);
        await backend.utils._clientWaitAsync();
        const dstBuffer = new typedArrayType(byteLength / typedArrayType.BYTES_PER_ELEMENT);
        gl.bindBuffer(gl.PIXEL_PACK_BUFFER, buffer);
        gl.getBufferSubData(gl.PIXEL_PACK_BUFFER, 0, dstBuffer);
        gl.bindBuffer(gl.PIXEL_PACK_BUFFER, null);
        gl.deleteFramebuffer(fb);
        return dstBuffer;
    }
    _getTypedArrayType(glType) {
        const { gl: gl } = this;
        if (glType === gl.UNSIGNED_BYTE) return Uint8Array;
        if (glType === gl.UNSIGNED_SHORT_4_4_4_4) return Uint16Array;
        if (glType === gl.UNSIGNED_SHORT_5_5_5_1) return Uint16Array;
        if (glType === gl.UNSIGNED_SHORT_5_6_5) return Uint16Array;
        if (glType === gl.UNSIGNED_SHORT) return Uint16Array;
        if (glType === gl.UNSIGNED_INT) return Uint32Array;
        if (glType === gl.HALF_FLOAT) return Uint16Array;
        if (glType === gl.FLOAT) return Float32Array;
        throw new Error(`Unsupported WebGL type: ${glType}`);
    }
    _getBytesPerTexel(glType, glFormat) {
        const { gl: gl } = this;
        let bytesPerComponent = 0;
        if (glType === gl.UNSIGNED_BYTE) bytesPerComponent = 1;
        if (glType === gl.UNSIGNED_SHORT_4_4_4_4 || glType === gl.UNSIGNED_SHORT_5_5_5_1 || glType === gl.UNSIGNED_SHORT_5_6_5 || glType === gl.UNSIGNED_SHORT || glType === gl.HALF_FLOAT) bytesPerComponent = 2;
        if (glType === gl.UNSIGNED_INT || glType === gl.FLOAT) bytesPerComponent = 4;
        if (glFormat === gl.RGBA) return bytesPerComponent * 4;
        if (glFormat === gl.RGB) return bytesPerComponent * 3;
        if (glFormat === gl.ALPHA) return bytesPerComponent;
    }
}
var $e2aa71f43acb41f6$export$2e2bcd8739ae039 = $e2aa71f43acb41f6$var$WebGLTextureUtils;


class $28f965668da4f063$var$WebGLExtensions {
    constructor(backend){
        this.backend = backend;
        this.gl = this.backend.gl;
        this.availableExtensions = this.gl.getSupportedExtensions();
        this.extensions = {};
    }
    get(name) {
        let extension = this.extensions[name];
        if (extension === undefined) {
            extension = this.gl.getExtension(name);
            this.extensions[name] = extension;
        }
        return extension;
    }
    has(name) {
        return this.availableExtensions.includes(name);
    }
}
var $28f965668da4f063$export$2e2bcd8739ae039 = $28f965668da4f063$var$WebGLExtensions;


class $3efb9c563ce54796$var$WebGLCapabilities {
    constructor(backend){
        this.backend = backend;
        this.maxAnisotropy = null;
    }
    getMaxAnisotropy() {
        if (this.maxAnisotropy !== null) return this.maxAnisotropy;
        const gl = this.backend.gl;
        const extensions = this.backend.extensions;
        if (extensions.has('EXT_texture_filter_anisotropic') === true) {
            const extension = extensions.get('EXT_texture_filter_anisotropic');
            this.maxAnisotropy = gl.getParameter(extension.MAX_TEXTURE_MAX_ANISOTROPY_EXT);
        } else this.maxAnisotropy = 0;
        return this.maxAnisotropy;
    }
}
var $3efb9c563ce54796$export$2e2bcd8739ae039 = $3efb9c563ce54796$var$WebGLCapabilities;


const $4f5dd92ce4e46454$export$708d550b3ebdaac = {
    'WEBGL_multi_draw': 'WEBGL_multi_draw',
    'WEBGL_compressed_texture_astc': 'texture-compression-astc',
    'WEBGL_compressed_texture_etc': 'texture-compression-etc2',
    'WEBGL_compressed_texture_etc1': 'texture-compression-etc1',
    'WEBGL_compressed_texture_pvrtc': 'texture-compression-pvrtc',
    'WEBKIT_WEBGL_compressed_texture_pvrtc': 'texture-compression-pvrtc',
    'WEBGL_compressed_texture_s3tc': 'texture-compression-bc',
    'EXT_texture_compression_bptc': 'texture-compression-bptc',
    'EXT_disjoint_timer_query_webgl2': 'timestamp-query'
};


class $a5a5243224d0d363$export$5b54a9e56c76ae71 {
    constructor(backend){
        this.gl = backend.gl;
        this.extensions = backend.extensions;
        this.info = backend.renderer.info;
        this.mode = null;
        this.index = 0;
        this.type = null;
        this.object = null;
    }
    render(start, count) {
        const { gl: gl, mode: mode, object: object, type: type, info: info, index: index } = this;
        if (index !== 0) gl.drawElements(mode, count, type, start);
        else gl.drawArrays(mode, start, count);
        info.update(object, count, mode, 1);
    }
    renderInstances(start, count, primcount) {
        const { gl: gl, mode: mode, type: type, index: index, object: object, info: info } = this;
        if (primcount === 0) return;
        if (index !== 0) gl.drawElementsInstanced(mode, count, type, start, primcount);
        else gl.drawArraysInstanced(mode, start, count, primcount);
        info.update(object, count, mode, primcount);
    }
    renderMultiDraw(starts, counts, drawCount) {
        const { extensions: extensions, mode: mode, object: object, info: info } = this;
        if (drawCount === 0) return;
        const extension = extensions.get('WEBGL_multi_draw');
        if (extension === null) for(let i = 0; i < drawCount; i++)this.render(starts[i], counts[i]);
        else {
            if (this.index !== 0) extension.multiDrawElementsWEBGL(mode, counts, 0, this.type, starts, 0, drawCount);
            else extension.multiDrawArraysWEBGL(mode, starts, 0, counts, 0, drawCount);
            let elementCount = 0;
            for(let i = 0; i < drawCount; i++)elementCount += counts[i];
            info.update(object, elementCount, mode, 1);
        }
    }
    renderMultiDrawInstances(starts, counts, drawCount, primcount) {
        const { extensions: extensions, mode: mode, object: object, info: info } = this;
        if (drawCount === 0) return;
        const extension = extensions.get('WEBGL_multi_draw');
        if (extension === null) for(let i = 0; i < drawCount; i++)this.renderInstances(starts[i], counts[i], primcount[i]);
        else {
            if (this.index !== 0) extension.multiDrawElementsInstancedWEBGL(mode, counts, 0, this.type, starts, 0, primcount, 0, drawCount);
            else extension.multiDrawArraysInstancedWEBGL(mode, starts, 0, counts, 0, primcount, 0, drawCount);
            let elementCount = 0;
            for(let i = 0; i < drawCount; i++)elementCount += counts[i] * primcount[i];
            info.update(object, elementCount, mode, 1);
        }
    }
}




//
class $53e987b995691f55$var$WebGLBackend extends (0, $191c5c4fa47571a5$export$2e2bcd8739ae039) {
    constructor(parameters = {}){
        super(parameters);
        this.isWebGLBackend = true;
    }
    init(renderer) {
        super.init(renderer);
        //
        const parameters = this.parameters;
        const glContext = parameters.context !== undefined ? parameters.context : renderer.domElement.getContext('webgl2');
        function onContextLost(event) {
            event.preventDefault();
            const contextLossInfo = {
                api: 'WebGL',
                message: event.statusMessage || 'Unknown reason',
                reason: null,
                originalEvent: event
            };
            renderer.onDeviceLost(contextLossInfo);
        }
        this._onContextLost = onContextLost;
        renderer.domElement.addEventListener('webglcontextlost', onContextLost, false);
        this.gl = glContext;
        this.extensions = new (0, $28f965668da4f063$export$2e2bcd8739ae039)(this);
        this.capabilities = new (0, $3efb9c563ce54796$export$2e2bcd8739ae039)(this);
        this.attributeUtils = new (0, $c2b2d84faa09d1ea$export$2e2bcd8739ae039)(this);
        this.textureUtils = new (0, $e2aa71f43acb41f6$export$2e2bcd8739ae039)(this);
        this.bufferRenderer = new (0, $a5a5243224d0d363$export$5b54a9e56c76ae71)(this);
        this.state = new (0, $88572ab434b6ea49$export$2e2bcd8739ae039)(this);
        this.utils = new (0, $c064792306d08bad$export$2e2bcd8739ae039)(this);
        this.vaoCache = {};
        this.transformFeedbackCache = {};
        this.discard = false;
        this.trackTimestamp = parameters.trackTimestamp === true;
        this.extensions.get('EXT_color_buffer_float');
        this.extensions.get('WEBGL_clip_cull_distance');
        this.extensions.get('OES_texture_float_linear');
        this.extensions.get('EXT_color_buffer_half_float');
        this.extensions.get('WEBGL_multisampled_render_to_texture');
        this.extensions.get('WEBGL_render_shared_exponent');
        this.extensions.get('WEBGL_multi_draw');
        this.disjoint = this.extensions.get('EXT_disjoint_timer_query_webgl2');
        this.parallel = this.extensions.get('KHR_parallel_shader_compile');
        this._knownBindings = new WeakSet();
        this._currentContext = null;
    }
    get coordinateSystem() {
        return 0, $cb5ee595c0f892af$export$5a0e9190d10875d3;
    }
    async getArrayBufferAsync(attribute) {
        return await this.attributeUtils.getArrayBufferAsync(attribute);
    }
    async waitForGPU() {
        await this.utils._clientWaitAsync();
    }
    initTimestampQuery(renderContext) {
        if (!this.disjoint || !this.trackTimestamp) return;
        const renderContextData = this.get(renderContext);
        if (this.queryRunning) {
            if (!renderContextData.queryQueue) renderContextData.queryQueue = [];
            renderContextData.queryQueue.push(renderContext);
            return;
        }
        if (renderContextData.activeQuery) {
            this.gl.endQuery(this.disjoint.TIME_ELAPSED_EXT);
            renderContextData.activeQuery = null;
        }
        renderContextData.activeQuery = this.gl.createQuery();
        if (renderContextData.activeQuery !== null) {
            this.gl.beginQuery(this.disjoint.TIME_ELAPSED_EXT, renderContextData.activeQuery);
            this.queryRunning = true;
        }
    }
    // timestamp utils
    prepareTimestampBuffer(renderContext) {
        if (!this.disjoint || !this.trackTimestamp) return;
        const renderContextData = this.get(renderContext);
        if (renderContextData.activeQuery) {
            this.gl.endQuery(this.disjoint.TIME_ELAPSED_EXT);
            if (!renderContextData.gpuQueries) renderContextData.gpuQueries = [];
            renderContextData.gpuQueries.push({
                query: renderContextData.activeQuery
            });
            renderContextData.activeQuery = null;
            this.queryRunning = false;
            if (renderContextData.queryQueue && renderContextData.queryQueue.length > 0) {
                const nextRenderContext = renderContextData.queryQueue.shift();
                this.initTimestampQuery(nextRenderContext);
            }
        }
    }
    async resolveTimestampAsync(renderContext, type = 'render') {
        if (!this.disjoint || !this.trackTimestamp) return;
        const renderContextData = this.get(renderContext);
        if (!renderContextData.gpuQueries) renderContextData.gpuQueries = [];
        for(let i = 0; i < renderContextData.gpuQueries.length; i++){
            const queryInfo = renderContextData.gpuQueries[i];
            const available = this.gl.getQueryParameter(queryInfo.query, this.gl.QUERY_RESULT_AVAILABLE);
            const disjoint = this.gl.getParameter(this.disjoint.GPU_DISJOINT_EXT);
            if (available && !disjoint) {
                const elapsed = this.gl.getQueryParameter(queryInfo.query, this.gl.QUERY_RESULT);
                const duration = Number(elapsed) / 1000000; // Convert nanoseconds to milliseconds
                this.gl.deleteQuery(queryInfo.query);
                renderContextData.gpuQueries.splice(i, 1); // Remove the processed query
                i--;
                this.renderer.info.updateTimestamp(type, duration);
            }
        }
    }
    getContext() {
        return this.gl;
    }
    beginRender(renderContext) {
        const { gl: gl } = this;
        const renderContextData = this.get(renderContext);
        //
        //
        this.initTimestampQuery(renderContext);
        renderContextData.previousContext = this._currentContext;
        this._currentContext = renderContext;
        this._setFramebuffer(renderContext);
        this.clear(renderContext.clearColor, renderContext.clearDepth, renderContext.clearStencil, renderContext, false);
        //
        if (renderContext.viewport) this.updateViewport(renderContext);
        else gl.viewport(0, 0, gl.drawingBufferWidth, gl.drawingBufferHeight);
        if (renderContext.scissor) {
            const { x: x, y: y, width: width, height: height } = renderContext.scissorValue;
            gl.scissor(x, renderContext.height - height - y, width, height);
        }
        const occlusionQueryCount = renderContext.occlusionQueryCount;
        if (occlusionQueryCount > 0) {
            // Get a reference to the array of objects with queries. The renderContextData property
            // can be changed by another render pass before the async reading of all previous queries complete
            renderContextData.currentOcclusionQueries = renderContextData.occlusionQueries;
            renderContextData.currentOcclusionQueryObjects = renderContextData.occlusionQueryObjects;
            renderContextData.lastOcclusionObject = null;
            renderContextData.occlusionQueries = new Array(occlusionQueryCount);
            renderContextData.occlusionQueryObjects = new Array(occlusionQueryCount);
            renderContextData.occlusionQueryIndex = 0;
        }
    }
    finishRender(renderContext) {
        const { gl: gl, state: state } = this;
        const renderContextData = this.get(renderContext);
        const previousContext = renderContextData.previousContext;
        const occlusionQueryCount = renderContext.occlusionQueryCount;
        if (occlusionQueryCount > 0) {
            if (occlusionQueryCount > renderContextData.occlusionQueryIndex) gl.endQuery(gl.ANY_SAMPLES_PASSED);
            this.resolveOccludedAsync(renderContext);
        }
        const textures = renderContext.textures;
        if (textures !== null) for(let i = 0; i < textures.length; i++){
            const texture = textures[i];
            if (texture.generateMipmaps) this.generateMipmaps(texture);
        }
        this._currentContext = previousContext;
        if (renderContext.textures !== null && renderContext.renderTarget) {
            const renderTargetContextData = this.get(renderContext.renderTarget);
            const { samples: samples } = renderContext.renderTarget;
            if (samples > 0) {
                const fb = renderTargetContextData.framebuffers[renderContext.getCacheKey()];
                const mask = gl.COLOR_BUFFER_BIT;
                const msaaFrameBuffer = renderTargetContextData.msaaFrameBuffer;
                const textures = renderContext.textures;
                state.bindFramebuffer(gl.READ_FRAMEBUFFER, msaaFrameBuffer);
                state.bindFramebuffer(gl.DRAW_FRAMEBUFFER, fb);
                for(let i = 0; i < textures.length; i++)// TODO Add support for MRT
                if (renderContext.scissor) {
                    const { x: x, y: y, width: width, height: height } = renderContext.scissorValue;
                    const viewY = renderContext.height - height - y;
                    gl.blitFramebuffer(x, viewY, x + width, viewY + height, x, viewY, x + width, viewY + height, mask, gl.NEAREST);
                    gl.invalidateSubFramebuffer(gl.READ_FRAMEBUFFER, renderTargetContextData.invalidationArray, x, viewY, width, height);
                } else {
                    gl.blitFramebuffer(0, 0, renderContext.width, renderContext.height, 0, 0, renderContext.width, renderContext.height, mask, gl.NEAREST);
                    gl.invalidateFramebuffer(gl.READ_FRAMEBUFFER, renderTargetContextData.invalidationArray);
                }
            }
        }
        if (previousContext !== null) {
            this._setFramebuffer(previousContext);
            if (previousContext.viewport) this.updateViewport(previousContext);
            else gl.viewport(0, 0, gl.drawingBufferWidth, gl.drawingBufferHeight);
        }
        this.prepareTimestampBuffer(renderContext);
    }
    resolveOccludedAsync(renderContext) {
        const renderContextData = this.get(renderContext);
        // handle occlusion query results
        const { currentOcclusionQueries: currentOcclusionQueries, currentOcclusionQueryObjects: currentOcclusionQueryObjects } = renderContextData;
        if (currentOcclusionQueries && currentOcclusionQueryObjects) {
            const occluded = new WeakSet();
            const { gl: gl } = this;
            renderContextData.currentOcclusionQueryObjects = null;
            renderContextData.currentOcclusionQueries = null;
            const check = ()=>{
                let completed = 0;
                // check all queries and requeue as appropriate
                for(let i = 0; i < currentOcclusionQueries.length; i++){
                    const query = currentOcclusionQueries[i];
                    if (query === null) continue;
                    if (gl.getQueryParameter(query, gl.QUERY_RESULT_AVAILABLE)) {
                        if (gl.getQueryParameter(query, gl.QUERY_RESULT) > 0) occluded.add(currentOcclusionQueryObjects[i]);
                        currentOcclusionQueries[i] = null;
                        gl.deleteQuery(query);
                        completed++;
                    }
                }
                if (completed < currentOcclusionQueries.length) requestAnimationFrame(check);
                else renderContextData.occluded = occluded;
            };
            check();
        }
    }
    isOccluded(renderContext, object) {
        const renderContextData = this.get(renderContext);
        return renderContextData.occluded && renderContextData.occluded.has(object);
    }
    updateViewport(renderContext) {
        const gl = this.gl;
        const { x: x, y: y, width: width, height: height } = renderContext.viewportValue;
        gl.viewport(x, renderContext.height - height - y, width, height);
    }
    setScissorTest(boolean) {
        const gl = this.gl;
        if (boolean) gl.enable(gl.SCISSOR_TEST);
        else gl.disable(gl.SCISSOR_TEST);
    }
    clear(color, depth, stencil, descriptor = null, setFrameBuffer = true) {
        const { gl: gl } = this;
        if (descriptor === null) {
            const clearColor = this.getClearColor();
            // premultiply alpha
            clearColor.r *= clearColor.a;
            clearColor.g *= clearColor.a;
            clearColor.b *= clearColor.a;
            descriptor = {
                textures: null,
                clearColorValue: clearColor
            };
        }
        //
        let clear = 0;
        if (color) clear |= gl.COLOR_BUFFER_BIT;
        if (depth) clear |= gl.DEPTH_BUFFER_BIT;
        if (stencil) clear |= gl.STENCIL_BUFFER_BIT;
        if (clear !== 0) {
            let clearColor;
            if (descriptor.clearColorValue) clearColor = descriptor.clearColorValue;
            else {
                clearColor = this.getClearColor();
                // premultiply alpha
                clearColor.r *= clearColor.a;
                clearColor.g *= clearColor.a;
                clearColor.b *= clearColor.a;
            }
            if (depth) this.state.setDepthMask(true);
            if (descriptor.textures === null) {
                gl.clearColor(clearColor.r, clearColor.g, clearColor.b, clearColor.a);
                gl.clear(clear);
            } else {
                if (setFrameBuffer) this._setFramebuffer(descriptor);
                if (color) for(let i = 0; i < descriptor.textures.length; i++)gl.clearBufferfv(gl.COLOR, i, [
                    clearColor.r,
                    clearColor.g,
                    clearColor.b,
                    clearColor.a
                ]);
                if (depth && stencil) gl.clearBufferfi(gl.DEPTH_STENCIL, 0, 1, 0);
                else if (depth) gl.clearBufferfv(gl.DEPTH, 0, [
                    1.0
                ]);
                else if (stencil) gl.clearBufferiv(gl.STENCIL, 0, [
                    0
                ]);
            }
        }
    }
    beginCompute(computeGroup) {
        const { state: state, gl: gl } = this;
        state.bindFramebuffer(gl.FRAMEBUFFER, null);
        this.initTimestampQuery(computeGroup);
    }
    compute(computeGroup, computeNode, bindings, pipeline) {
        const { state: state, gl: gl } = this;
        if (!this.discard) {
            // required here to handle async behaviour of render.compute()
            gl.enable(gl.RASTERIZER_DISCARD);
            this.discard = true;
        }
        const { programGPU: programGPU, transformBuffers: transformBuffers, attributes: attributes } = this.get(pipeline);
        const vaoKey = this._getVaoKey(null, attributes);
        const vaoGPU = this.vaoCache[vaoKey];
        if (vaoGPU === undefined) this._createVao(null, attributes);
        else gl.bindVertexArray(vaoGPU);
        state.useProgram(programGPU);
        this._bindUniforms(bindings);
        const transformFeedbackGPU = this._getTransformFeedback(transformBuffers);
        gl.bindTransformFeedback(gl.TRANSFORM_FEEDBACK, transformFeedbackGPU);
        gl.beginTransformFeedback(gl.POINTS);
        if (attributes[0].isStorageInstancedBufferAttribute) gl.drawArraysInstanced(gl.POINTS, 0, 1, computeNode.count);
        else gl.drawArrays(gl.POINTS, 0, computeNode.count);
        gl.endTransformFeedback();
        gl.bindTransformFeedback(gl.TRANSFORM_FEEDBACK, null);
        // switch active buffers
        for(let i = 0; i < transformBuffers.length; i++){
            const dualAttributeData = transformBuffers[i];
            if (dualAttributeData.pbo) this.textureUtils.copyBufferToTexture(dualAttributeData.transformBuffer, dualAttributeData.pbo);
            dualAttributeData.switchBuffers();
        }
    }
    finishCompute(computeGroup) {
        const gl = this.gl;
        this.discard = false;
        gl.disable(gl.RASTERIZER_DISCARD);
        this.prepareTimestampBuffer(computeGroup);
        if (this._currentContext) this._setFramebuffer(this._currentContext);
    }
    draw(renderObject /*, info*/ ) {
        const { object: object, pipeline: pipeline, material: material, context: context } = renderObject;
        const { programGPU: programGPU } = this.get(pipeline);
        const { gl: gl, state: state } = this;
        const contextData = this.get(context);
        const drawParams = renderObject.getDrawParameters();
        if (drawParams === null) return;
        //
        this._bindUniforms(renderObject.getBindings());
        const frontFaceCW = object.isMesh && object.matrixWorld.determinant() < 0;
        state.setMaterial(material, frontFaceCW);
        state.useProgram(programGPU);
        //
        let vaoGPU = renderObject.staticVao;
        if (vaoGPU === undefined) {
            const vaoKey = this._getVaoKey(renderObject.getIndex(), renderObject.getAttributes());
            vaoGPU = this.vaoCache[vaoKey];
            if (vaoGPU === undefined) {
                let staticVao;
                ({ vaoGPU: vaoGPU, staticVao: staticVao } = this._createVao(renderObject.getIndex(), renderObject.getAttributes()));
                if (staticVao) renderObject.staticVao = vaoGPU;
            }
        }
        gl.bindVertexArray(vaoGPU);
        //
        const index = renderObject.getIndex();
        //
        const lastObject = contextData.lastOcclusionObject;
        if (lastObject !== object && lastObject !== undefined) {
            if (lastObject !== null && lastObject.occlusionTest === true) {
                gl.endQuery(gl.ANY_SAMPLES_PASSED);
                contextData.occlusionQueryIndex++;
            }
            if (object.occlusionTest === true) {
                const query = gl.createQuery();
                gl.beginQuery(gl.ANY_SAMPLES_PASSED, query);
                contextData.occlusionQueries[contextData.occlusionQueryIndex] = query;
                contextData.occlusionQueryObjects[contextData.occlusionQueryIndex] = object;
            }
            contextData.lastOcclusionObject = object;
        }
        //
        const renderer = this.bufferRenderer;
        if (object.isPoints) renderer.mode = gl.POINTS;
        else if (object.isLineSegments) renderer.mode = gl.LINES;
        else if (object.isLine) renderer.mode = gl.LINE_STRIP;
        else if (object.isLineLoop) renderer.mode = gl.LINE_LOOP;
        else if (material.wireframe === true) {
            state.setLineWidth(material.wireframeLinewidth * this.renderer.getPixelRatio());
            renderer.mode = gl.LINES;
        } else renderer.mode = gl.TRIANGLES;
        //
        const { vertexCount: vertexCount, instanceCount: instanceCount } = drawParams;
        let { firstVertex: firstVertex } = drawParams;
        renderer.object = object;
        if (index !== null) {
            firstVertex *= index.array.BYTES_PER_ELEMENT;
            const indexData = this.get(index);
            renderer.index = index.count;
            renderer.type = indexData.type;
        } else renderer.index = 0;
        if (object.isBatchedMesh) {
            if (object._multiDrawInstances !== null) renderer.renderMultiDrawInstances(object._multiDrawStarts, object._multiDrawCounts, object._multiDrawCount, object._multiDrawInstances);
            else if (!this.hasFeature('WEBGL_multi_draw')) (0, $d93c9776005e33ec$export$5b28268982f175ba)('THREE.WebGLRenderer: WEBGL_multi_draw not supported.');
            else renderer.renderMultiDraw(object._multiDrawStarts, object._multiDrawCounts, object._multiDrawCount);
        } else if (instanceCount > 1) renderer.renderInstances(firstVertex, vertexCount, instanceCount);
        else renderer.render(firstVertex, vertexCount);
        //
        gl.bindVertexArray(null);
    }
    needsRenderUpdate() {
        return false;
    }
    getRenderCacheKey() {
        return '';
    }
    // textures
    createDefaultTexture(texture) {
        this.textureUtils.createDefaultTexture(texture);
    }
    createTexture(texture, options) {
        this.textureUtils.createTexture(texture, options);
    }
    updateTexture(texture, options) {
        this.textureUtils.updateTexture(texture, options);
    }
    generateMipmaps(texture) {
        this.textureUtils.generateMipmaps(texture);
    }
    destroyTexture(texture) {
        this.textureUtils.destroyTexture(texture);
    }
    copyTextureToBuffer(texture, x, y, width, height, faceIndex) {
        return this.textureUtils.copyTextureToBuffer(texture, x, y, width, height, faceIndex);
    }
    createSampler() {
    //console.warn( 'Abstract class.' );
    }
    destroySampler() {}
    // node builder
    createNodeBuilder(object, renderer) {
        return new (0, $6d6e1ec7a4b7e7e9$export$2e2bcd8739ae039)(object, renderer);
    }
    // program
    createProgram(program) {
        const gl = this.gl;
        const { stage: stage, code: code } = program;
        const shader = stage === 'fragment' ? gl.createShader(gl.FRAGMENT_SHADER) : gl.createShader(gl.VERTEX_SHADER);
        gl.shaderSource(shader, code);
        gl.compileShader(shader);
        this.set(program, {
            shaderGPU: shader
        });
    }
    destroyProgram() {
        console.warn('Abstract class.');
    }
    createRenderPipeline(renderObject, promises) {
        const gl = this.gl;
        const pipeline = renderObject.pipeline;
        // Program
        const { fragmentProgram: fragmentProgram, vertexProgram: vertexProgram } = pipeline;
        const programGPU = gl.createProgram();
        const fragmentShader = this.get(fragmentProgram).shaderGPU;
        const vertexShader = this.get(vertexProgram).shaderGPU;
        gl.attachShader(programGPU, fragmentShader);
        gl.attachShader(programGPU, vertexShader);
        gl.linkProgram(programGPU);
        this.set(pipeline, {
            programGPU: programGPU,
            fragmentShader: fragmentShader,
            vertexShader: vertexShader
        });
        if (promises !== null && this.parallel) {
            const p = new Promise((resolve /*, reject*/ )=>{
                const parallel = this.parallel;
                const checkStatus = ()=>{
                    if (gl.getProgramParameter(programGPU, parallel.COMPLETION_STATUS_KHR)) {
                        this._completeCompile(renderObject, pipeline);
                        resolve();
                    } else requestAnimationFrame(checkStatus);
                };
                checkStatus();
            });
            promises.push(p);
            return;
        }
        this._completeCompile(renderObject, pipeline);
    }
    _handleSource(string, errorLine) {
        const lines = string.split('\n');
        const lines2 = [];
        const from = Math.max(errorLine - 6, 0);
        const to = Math.min(errorLine + 6, lines.length);
        for(let i = from; i < to; i++){
            const line = i + 1;
            lines2.push(`${line === errorLine ? '>' : ' '} ${line}: ${lines[i]}`);
        }
        return lines2.join('\n');
    }
    _getShaderErrors(gl, shader, type) {
        const status = gl.getShaderParameter(shader, gl.COMPILE_STATUS);
        const errors = gl.getShaderInfoLog(shader).trim();
        if (status && errors === '') return '';
        const errorMatches = /ERROR: 0:(\d+)/.exec(errors);
        if (errorMatches) {
            const errorLine = parseInt(errorMatches[1]);
            return type.toUpperCase() + '\n\n' + errors + '\n\n' + this._handleSource(gl.getShaderSource(shader), errorLine);
        } else return errors;
    }
    _logProgramError(programGPU, glFragmentShader, glVertexShader) {
        if (this.renderer.debug.checkShaderErrors) {
            const gl = this.gl;
            const programLog = gl.getProgramInfoLog(programGPU).trim();
            if (gl.getProgramParameter(programGPU, gl.LINK_STATUS) === false) {
                if (typeof this.renderer.debug.onShaderError === 'function') this.renderer.debug.onShaderError(gl, programGPU, glVertexShader, glFragmentShader);
                else {
                    // default error reporting
                    const vertexErrors = this._getShaderErrors(gl, glVertexShader, 'vertex');
                    const fragmentErrors = this._getShaderErrors(gl, glFragmentShader, 'fragment');
                    console.error('THREE.WebGLProgram: Shader Error ' + gl.getError() + ' - ' + 'VALIDATE_STATUS ' + gl.getProgramParameter(programGPU, gl.VALIDATE_STATUS) + '\n\n' + 'Program Info Log: ' + programLog + '\n' + vertexErrors + '\n' + fragmentErrors);
                }
            } else if (programLog !== '') console.warn('THREE.WebGLProgram: Program Info Log:', programLog);
        }
    }
    _completeCompile(renderObject, pipeline) {
        const { state: state, gl: gl } = this;
        const pipelineData = this.get(pipeline);
        const { programGPU: programGPU, fragmentShader: fragmentShader, vertexShader: vertexShader } = pipelineData;
        if (gl.getProgramParameter(programGPU, gl.LINK_STATUS) === false) this._logProgramError(programGPU, fragmentShader, vertexShader);
        state.useProgram(programGPU);
        // Bindings
        const bindings = renderObject.getBindings();
        this._setupBindings(bindings, programGPU);
        //
        this.set(pipeline, {
            programGPU: programGPU
        });
    }
    createComputePipeline(computePipeline, bindings) {
        const { state: state, gl: gl } = this;
        // Program
        const fragmentProgram = {
            stage: 'fragment',
            code: '#version 300 es\nprecision highp float;\nvoid main() {}'
        };
        this.createProgram(fragmentProgram);
        const { computeProgram: computeProgram } = computePipeline;
        const programGPU = gl.createProgram();
        const fragmentShader = this.get(fragmentProgram).shaderGPU;
        const vertexShader = this.get(computeProgram).shaderGPU;
        const transforms = computeProgram.transforms;
        const transformVaryingNames = [];
        const transformAttributeNodes = [];
        for(let i = 0; i < transforms.length; i++){
            const transform = transforms[i];
            transformVaryingNames.push(transform.varyingName);
            transformAttributeNodes.push(transform.attributeNode);
        }
        gl.attachShader(programGPU, fragmentShader);
        gl.attachShader(programGPU, vertexShader);
        gl.transformFeedbackVaryings(programGPU, transformVaryingNames, gl.SEPARATE_ATTRIBS);
        gl.linkProgram(programGPU);
        if (gl.getProgramParameter(programGPU, gl.LINK_STATUS) === false) this._logProgramError(programGPU, fragmentShader, vertexShader);
        state.useProgram(programGPU);
        // Bindings
        this._setupBindings(bindings, programGPU);
        const attributeNodes = computeProgram.attributes;
        const attributes = [];
        const transformBuffers = [];
        for(let i = 0; i < attributeNodes.length; i++){
            const attribute = attributeNodes[i].node.attribute;
            attributes.push(attribute);
            if (!this.has(attribute)) this.attributeUtils.createAttribute(attribute, gl.ARRAY_BUFFER);
        }
        for(let i = 0; i < transformAttributeNodes.length; i++){
            const attribute = transformAttributeNodes[i].attribute;
            if (!this.has(attribute)) this.attributeUtils.createAttribute(attribute, gl.ARRAY_BUFFER);
            const attributeData = this.get(attribute);
            transformBuffers.push(attributeData);
        }
        //
        this.set(computePipeline, {
            programGPU: programGPU,
            transformBuffers: transformBuffers,
            attributes: attributes
        });
    }
    createBindings(bindGroup, bindings) {
        if (this._knownBindings.has(bindings) === false) {
            this._knownBindings.add(bindings);
            let uniformBuffers = 0;
            let textures = 0;
            for (const bindGroup of bindings){
                this.set(bindGroup, {
                    textures: textures,
                    uniformBuffers: uniformBuffers
                });
                for (const binding of bindGroup.bindings){
                    if (binding.isUniformBuffer) uniformBuffers++;
                    if (binding.isSampledTexture) textures++;
                }
            }
        }
        this.updateBindings(bindGroup, bindings);
    }
    updateBindings(bindGroup /*, bindings*/ ) {
        const { gl: gl } = this;
        const bindGroupData = this.get(bindGroup);
        let i = bindGroupData.uniformBuffers;
        let t = bindGroupData.textures;
        for (const binding of bindGroup.bindings){
            if (binding.isUniformsGroup || binding.isUniformBuffer) {
                const data = binding.buffer;
                const bufferGPU = gl.createBuffer();
                gl.bindBuffer(gl.UNIFORM_BUFFER, bufferGPU);
                gl.bufferData(gl.UNIFORM_BUFFER, data, gl.DYNAMIC_DRAW);
                this.set(binding, {
                    index: i++,
                    bufferGPU: bufferGPU
                });
            } else if (binding.isSampledTexture) {
                const { textureGPU: textureGPU, glTextureType: glTextureType } = this.get(binding.texture);
                this.set(binding, {
                    index: t++,
                    textureGPU: textureGPU,
                    glTextureType: glTextureType
                });
            }
        }
    }
    updateBinding(binding) {
        const gl = this.gl;
        if (binding.isUniformsGroup || binding.isUniformBuffer) {
            const bindingData = this.get(binding);
            const bufferGPU = bindingData.bufferGPU;
            const data = binding.buffer;
            gl.bindBuffer(gl.UNIFORM_BUFFER, bufferGPU);
            gl.bufferData(gl.UNIFORM_BUFFER, data, gl.DYNAMIC_DRAW);
        }
    }
    // attributes
    createIndexAttribute(attribute) {
        const gl = this.gl;
        this.attributeUtils.createAttribute(attribute, gl.ELEMENT_ARRAY_BUFFER);
    }
    createAttribute(attribute) {
        if (this.has(attribute)) return;
        const gl = this.gl;
        this.attributeUtils.createAttribute(attribute, gl.ARRAY_BUFFER);
    }
    createStorageAttribute(attribute) {
        if (this.has(attribute)) return;
        const gl = this.gl;
        this.attributeUtils.createAttribute(attribute, gl.ARRAY_BUFFER);
    }
    updateAttribute(attribute) {
        this.attributeUtils.updateAttribute(attribute);
    }
    destroyAttribute(attribute) {
        this.attributeUtils.destroyAttribute(attribute);
    }
    updateSize() {
    //console.warn( 'Abstract class.' );
    }
    hasFeature(name) {
        const keysMatching = Object.keys((0, $4f5dd92ce4e46454$export$708d550b3ebdaac)).filter((key)=>(0, $4f5dd92ce4e46454$export$708d550b3ebdaac)[key] === name);
        const extensions = this.extensions;
        for(let i = 0; i < keysMatching.length; i++){
            if (extensions.has(keysMatching[i])) return true;
        }
        return false;
    }
    getMaxAnisotropy() {
        return this.capabilities.getMaxAnisotropy();
    }
    copyTextureToTexture(srcTexture, dstTexture, srcRegion, dstPosition, level) {
        this.textureUtils.copyTextureToTexture(srcTexture, dstTexture, srcRegion, dstPosition, level);
    }
    copyFramebufferToTexture(texture, renderContext, rectangle) {
        this.textureUtils.copyFramebufferToTexture(texture, renderContext, rectangle);
    }
    _setFramebuffer(descriptor) {
        const { gl: gl, state: state } = this;
        let currentFrameBuffer = null;
        if (descriptor.textures !== null) {
            const renderTarget = descriptor.renderTarget;
            const renderTargetContextData = this.get(renderTarget);
            const { samples: samples, depthBuffer: depthBuffer, stencilBuffer: stencilBuffer } = renderTarget;
            const isCube = renderTarget.isWebGLCubeRenderTarget === true;
            let msaaFb = renderTargetContextData.msaaFrameBuffer;
            let depthRenderbuffer = renderTargetContextData.depthRenderbuffer;
            const cacheKey = (0, $76a9323b86a840ad$export$611736262b635f8d)(descriptor);
            let fb;
            if (isCube) {
                renderTargetContextData.cubeFramebuffers || (renderTargetContextData.cubeFramebuffers = {});
                fb = renderTargetContextData.cubeFramebuffers[cacheKey];
            } else {
                renderTargetContextData.framebuffers || (renderTargetContextData.framebuffers = {});
                fb = renderTargetContextData.framebuffers[cacheKey];
            }
            if (fb === undefined) {
                fb = gl.createFramebuffer();
                state.bindFramebuffer(gl.FRAMEBUFFER, fb);
                const textures = descriptor.textures;
                if (isCube) {
                    renderTargetContextData.cubeFramebuffers[cacheKey] = fb;
                    const { textureGPU: textureGPU } = this.get(textures[0]);
                    const cubeFace = this.renderer._activeCubeFace;
                    gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_CUBE_MAP_POSITIVE_X + cubeFace, textureGPU, 0);
                } else {
                    renderTargetContextData.framebuffers[cacheKey] = fb;
                    for(let i = 0; i < textures.length; i++){
                        const texture = textures[i];
                        const textureData = this.get(texture);
                        textureData.renderTarget = descriptor.renderTarget;
                        textureData.cacheKey = cacheKey; // required for copyTextureToTexture()
                        const attachment = gl.COLOR_ATTACHMENT0 + i;
                        gl.framebufferTexture2D(gl.FRAMEBUFFER, attachment, gl.TEXTURE_2D, textureData.textureGPU, 0);
                    }
                    state.drawBuffers(descriptor, fb);
                }
                if (descriptor.depthTexture !== null) {
                    const textureData = this.get(descriptor.depthTexture);
                    const depthStyle = stencilBuffer ? gl.DEPTH_STENCIL_ATTACHMENT : gl.DEPTH_ATTACHMENT;
                    textureData.renderTarget = descriptor.renderTarget;
                    textureData.cacheKey = cacheKey; // required for copyTextureToTexture()
                    gl.framebufferTexture2D(gl.FRAMEBUFFER, depthStyle, gl.TEXTURE_2D, textureData.textureGPU, 0);
                }
            }
            if (samples > 0) {
                if (msaaFb === undefined) {
                    const invalidationArray = [];
                    msaaFb = gl.createFramebuffer();
                    state.bindFramebuffer(gl.FRAMEBUFFER, msaaFb);
                    const msaaRenderbuffers = [];
                    const textures = descriptor.textures;
                    for(let i = 0; i < textures.length; i++){
                        msaaRenderbuffers[i] = gl.createRenderbuffer();
                        gl.bindRenderbuffer(gl.RENDERBUFFER, msaaRenderbuffers[i]);
                        invalidationArray.push(gl.COLOR_ATTACHMENT0 + i);
                        if (depthBuffer) {
                            const depthStyle = stencilBuffer ? gl.DEPTH_STENCIL_ATTACHMENT : gl.DEPTH_ATTACHMENT;
                            invalidationArray.push(depthStyle);
                        }
                        const texture = descriptor.textures[i];
                        const textureData = this.get(texture);
                        gl.renderbufferStorageMultisample(gl.RENDERBUFFER, samples, textureData.glInternalFormat, descriptor.width, descriptor.height);
                        gl.framebufferRenderbuffer(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0 + i, gl.RENDERBUFFER, msaaRenderbuffers[i]);
                    }
                    renderTargetContextData.msaaFrameBuffer = msaaFb;
                    renderTargetContextData.msaaRenderbuffers = msaaRenderbuffers;
                    if (depthRenderbuffer === undefined) {
                        depthRenderbuffer = gl.createRenderbuffer();
                        this.textureUtils.setupRenderBufferStorage(depthRenderbuffer, descriptor);
                        renderTargetContextData.depthRenderbuffer = depthRenderbuffer;
                        const depthStyle = stencilBuffer ? gl.DEPTH_STENCIL_ATTACHMENT : gl.DEPTH_ATTACHMENT;
                        invalidationArray.push(depthStyle);
                    }
                    renderTargetContextData.invalidationArray = invalidationArray;
                }
                currentFrameBuffer = renderTargetContextData.msaaFrameBuffer;
            } else currentFrameBuffer = fb;
        }
        state.bindFramebuffer(gl.FRAMEBUFFER, currentFrameBuffer);
    }
    _getVaoKey(index, attributes) {
        let key = [];
        if (index !== null) {
            const indexData = this.get(index);
            key += ':' + indexData.id;
        }
        for(let i = 0; i < attributes.length; i++){
            const attributeData = this.get(attributes[i]);
            key += ':' + attributeData.id;
        }
        return key;
    }
    _createVao(index, attributes) {
        const { gl: gl } = this;
        const vaoGPU = gl.createVertexArray();
        let key = '';
        let staticVao = true;
        gl.bindVertexArray(vaoGPU);
        if (index !== null) {
            const indexData = this.get(index);
            gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, indexData.bufferGPU);
            key += ':' + indexData.id;
        }
        for(let i = 0; i < attributes.length; i++){
            const attribute = attributes[i];
            const attributeData = this.get(attribute);
            key += ':' + attributeData.id;
            gl.bindBuffer(gl.ARRAY_BUFFER, attributeData.bufferGPU);
            gl.enableVertexAttribArray(i);
            if (attribute.isStorageBufferAttribute || attribute.isStorageInstancedBufferAttribute) staticVao = false;
            let stride, offset;
            if (attribute.isInterleavedBufferAttribute === true) {
                stride = attribute.data.stride * attributeData.bytesPerElement;
                offset = attribute.offset * attributeData.bytesPerElement;
            } else {
                stride = 0;
                offset = 0;
            }
            if (attributeData.isInteger) gl.vertexAttribIPointer(i, attribute.itemSize, attributeData.type, stride, offset);
            else gl.vertexAttribPointer(i, attribute.itemSize, attributeData.type, attribute.normalized, stride, offset);
            if (attribute.isInstancedBufferAttribute && !attribute.isInterleavedBufferAttribute) gl.vertexAttribDivisor(i, attribute.meshPerAttribute);
            else if (attribute.isInterleavedBufferAttribute && attribute.data.isInstancedInterleavedBuffer) gl.vertexAttribDivisor(i, attribute.data.meshPerAttribute);
        }
        gl.bindBuffer(gl.ARRAY_BUFFER, null);
        this.vaoCache[key] = vaoGPU;
        return {
            vaoGPU: vaoGPU,
            staticVao: staticVao
        };
    }
    _getTransformFeedback(transformBuffers) {
        let key = '';
        for(let i = 0; i < transformBuffers.length; i++)key += ':' + transformBuffers[i].id;
        let transformFeedbackGPU = this.transformFeedbackCache[key];
        if (transformFeedbackGPU !== undefined) return transformFeedbackGPU;
        const { gl: gl } = this;
        transformFeedbackGPU = gl.createTransformFeedback();
        gl.bindTransformFeedback(gl.TRANSFORM_FEEDBACK, transformFeedbackGPU);
        for(let i = 0; i < transformBuffers.length; i++){
            const attributeData = transformBuffers[i];
            gl.bindBufferBase(gl.TRANSFORM_FEEDBACK_BUFFER, i, attributeData.transformBuffer);
        }
        gl.bindTransformFeedback(gl.TRANSFORM_FEEDBACK, null);
        this.transformFeedbackCache[key] = transformFeedbackGPU;
        return transformFeedbackGPU;
    }
    _setupBindings(bindings, programGPU) {
        const gl = this.gl;
        for (const bindGroup of bindings)for (const binding of bindGroup.bindings){
            const bindingData = this.get(binding);
            const index = bindingData.index;
            if (binding.isUniformsGroup || binding.isUniformBuffer) {
                const location = gl.getUniformBlockIndex(programGPU, binding.name);
                gl.uniformBlockBinding(programGPU, location, index);
            } else if (binding.isSampledTexture) {
                const location = gl.getUniformLocation(programGPU, binding.name);
                gl.uniform1i(location, index);
            }
        }
    }
    _bindUniforms(bindings) {
        const { gl: gl, state: state } = this;
        for (const bindGroup of bindings)for (const binding of bindGroup.bindings){
            const bindingData = this.get(binding);
            const index = bindingData.index;
            if (binding.isUniformsGroup || binding.isUniformBuffer) // TODO USE bindBufferRange to group multiple uniform buffers
            state.bindBufferBase(gl.UNIFORM_BUFFER, index, bindingData.bufferGPU);
            else if (binding.isSampledTexture) state.bindTexture(bindingData.glTextureType, bindingData.textureGPU, gl.TEXTURE0 + index);
        }
    }
    dispose() {
        this.renderer.domElement.removeEventListener('webglcontextlost', this._onContextLost);
    }
}
var $53e987b995691f55$export$2e2bcd8739ae039 = $53e987b995691f55$var$WebGLBackend;


/*// debugger tools
import 'https://greggman.github.io/webgpu-avoid-redundant-state-setting/webgpu-check-redundant-state-setting.js';
//*/ 


class $46a30e7313bb3166$var$Sampler extends (0, $3d47fc7f553021d2$export$2e2bcd8739ae039) {
    constructor(name, texture){
        super(name);
        this.texture = texture;
        this.version = texture ? texture.version : 0;
        this.isSampler = true;
    }
}
var $46a30e7313bb3166$export$2e2bcd8739ae039 = $46a30e7313bb3166$var$Sampler;


class $b1ef4ffdc54c3c25$var$NodeSampler extends (0, $46a30e7313bb3166$export$2e2bcd8739ae039) {
    constructor(name, textureNode, groupNode){
        super(name, textureNode ? textureNode.value : null);
        this.textureNode = textureNode;
        this.groupNode = groupNode;
    }
    update() {
        this.texture = this.textureNode.value;
    }
}
var $b1ef4ffdc54c3c25$export$2e2bcd8739ae039 = $b1ef4ffdc54c3c25$var$NodeSampler;





class $a246bd29fbf820f9$var$StorageBuffer extends (0, $d67513964dae471e$export$2e2bcd8739ae039) {
    constructor(name, attribute){
        super(name, attribute ? attribute.array : null);
        this.attribute = attribute;
        this.isStorageBuffer = true;
    }
}
var $a246bd29fbf820f9$export$2e2bcd8739ae039 = $a246bd29fbf820f9$var$StorageBuffer;



let $f41997a49c56b6ed$var$_id = 0;
class $f41997a49c56b6ed$var$NodeStorageBuffer extends (0, $a246bd29fbf820f9$export$2e2bcd8739ae039) {
    constructor(nodeUniform, groupNode){
        super('StorageBuffer_' + $f41997a49c56b6ed$var$_id++, nodeUniform ? nodeUniform.value : null);
        this.nodeUniform = nodeUniform;
        this.access = nodeUniform ? nodeUniform.access : (0, $65e789322b24f25c$export$1fafb3ddf4a8fbc0).Storage;
        this.groupNode = groupNode;
    }
    get buffer() {
        return this.nodeUniform.value;
    }
}
var $f41997a49c56b6ed$export$2e2bcd8739ae039 = $f41997a49c56b6ed$var$NodeStorageBuffer;






class $faf1374890c7020f$var$WebGPUTexturePassUtils extends (0, $0c532ab002169243$export$2e2bcd8739ae039) {
    constructor(device){
        super();
        this.device = device;
        const mipmapVertexSource = `
struct VarysStruct {
	@builtin( position ) Position: vec4<f32>,
	@location( 0 ) vTex : vec2<f32>
};

@vertex
fn main( @builtin( vertex_index ) vertexIndex : u32 ) -> VarysStruct {

	var Varys : VarysStruct;

	var pos = array< vec2<f32>, 4 >(
		vec2<f32>( -1.0,  1.0 ),
		vec2<f32>(  1.0,  1.0 ),
		vec2<f32>( -1.0, -1.0 ),
		vec2<f32>(  1.0, -1.0 )
	);

	var tex = array< vec2<f32>, 4 >(
		vec2<f32>( 0.0, 0.0 ),
		vec2<f32>( 1.0, 0.0 ),
		vec2<f32>( 0.0, 1.0 ),
		vec2<f32>( 1.0, 1.0 )
	);

	Varys.vTex = tex[ vertexIndex ];
	Varys.Position = vec4<f32>( pos[ vertexIndex ], 0.0, 1.0 );

	return Varys;

}
`;
        const mipmapFragmentSource = `
@group( 0 ) @binding( 0 )
var imgSampler : sampler;

@group( 0 ) @binding( 1 )
var img : texture_2d<f32>;

@fragment
fn main( @location( 0 ) vTex : vec2<f32> ) -> @location( 0 ) vec4<f32> {

	return textureSample( img, imgSampler, vTex );

}
`;
        const flipYFragmentSource = `
@group( 0 ) @binding( 0 )
var imgSampler : sampler;

@group( 0 ) @binding( 1 )
var img : texture_2d<f32>;

@fragment
fn main( @location( 0 ) vTex : vec2<f32> ) -> @location( 0 ) vec4<f32> {

	return textureSample( img, imgSampler, vec2( vTex.x, 1.0 - vTex.y ) );

}
`;
        this.mipmapSampler = device.createSampler({
            minFilter: (0, $65e789322b24f25c$export$9948723cf5806885).Linear
        });
        this.flipYSampler = device.createSampler({
            minFilter: (0, $65e789322b24f25c$export$9948723cf5806885).Nearest
        }); //@TODO?: Consider using textureLoad()
        // We'll need a new pipeline for every texture format used.
        this.transferPipelines = {};
        this.flipYPipelines = {};
        this.mipmapVertexShaderModule = device.createShaderModule({
            label: 'mipmapVertex',
            code: mipmapVertexSource
        });
        this.mipmapFragmentShaderModule = device.createShaderModule({
            label: 'mipmapFragment',
            code: mipmapFragmentSource
        });
        this.flipYFragmentShaderModule = device.createShaderModule({
            label: 'flipYFragment',
            code: flipYFragmentSource
        });
    }
    getTransferPipeline(format) {
        let pipeline = this.transferPipelines[format];
        if (pipeline === undefined) {
            pipeline = this.device.createRenderPipeline({
                label: `mipmap-${format}`,
                vertex: {
                    module: this.mipmapVertexShaderModule,
                    entryPoint: 'main'
                },
                fragment: {
                    module: this.mipmapFragmentShaderModule,
                    entryPoint: 'main',
                    targets: [
                        {
                            format: format
                        }
                    ]
                },
                primitive: {
                    topology: (0, $65e789322b24f25c$export$ee82e1b1a0f4eece).TriangleStrip,
                    stripIndexFormat: (0, $65e789322b24f25c$export$6a6945c8ae14b3d0).Uint32
                },
                layout: 'auto'
            });
            this.transferPipelines[format] = pipeline;
        }
        return pipeline;
    }
    getFlipYPipeline(format) {
        let pipeline = this.flipYPipelines[format];
        if (pipeline === undefined) {
            pipeline = this.device.createRenderPipeline({
                label: `flipY-${format}`,
                vertex: {
                    module: this.mipmapVertexShaderModule,
                    entryPoint: 'main'
                },
                fragment: {
                    module: this.flipYFragmentShaderModule,
                    entryPoint: 'main',
                    targets: [
                        {
                            format: format
                        }
                    ]
                },
                primitive: {
                    topology: (0, $65e789322b24f25c$export$ee82e1b1a0f4eece).TriangleStrip,
                    stripIndexFormat: (0, $65e789322b24f25c$export$6a6945c8ae14b3d0).Uint32
                },
                layout: 'auto'
            });
            this.flipYPipelines[format] = pipeline;
        }
        return pipeline;
    }
    flipY(textureGPU, textureGPUDescriptor, baseArrayLayer = 0) {
        const format = textureGPUDescriptor.format;
        const { width: width, height: height } = textureGPUDescriptor.size;
        const transferPipeline = this.getTransferPipeline(format);
        const flipYPipeline = this.getFlipYPipeline(format);
        const tempTexture = this.device.createTexture({
            size: {
                width: width,
                height: height,
                depthOrArrayLayers: 1
            },
            format: format,
            usage: GPUTextureUsage.RENDER_ATTACHMENT | GPUTextureUsage.TEXTURE_BINDING
        });
        const srcView = textureGPU.createView({
            baseMipLevel: 0,
            mipLevelCount: 1,
            dimension: (0, $65e789322b24f25c$export$e9c73c9e5554baf7).TwoD,
            baseArrayLayer: baseArrayLayer
        });
        const dstView = tempTexture.createView({
            baseMipLevel: 0,
            mipLevelCount: 1,
            dimension: (0, $65e789322b24f25c$export$e9c73c9e5554baf7).TwoD,
            baseArrayLayer: 0
        });
        const commandEncoder = this.device.createCommandEncoder({});
        const pass = (pipeline, sourceView, destinationView)=>{
            const bindGroupLayout = pipeline.getBindGroupLayout(0); // @TODO: Consider making this static.
            const bindGroup = this.device.createBindGroup({
                layout: bindGroupLayout,
                entries: [
                    {
                        binding: 0,
                        resource: this.flipYSampler
                    },
                    {
                        binding: 1,
                        resource: sourceView
                    }
                ]
            });
            const passEncoder = commandEncoder.beginRenderPass({
                colorAttachments: [
                    {
                        view: destinationView,
                        loadOp: (0, $65e789322b24f25c$export$e23f171c304e7eb1).Clear,
                        storeOp: (0, $65e789322b24f25c$export$d6b072117316704a).Store,
                        clearValue: [
                            0,
                            0,
                            0,
                            0
                        ]
                    }
                ]
            });
            passEncoder.setPipeline(pipeline);
            passEncoder.setBindGroup(0, bindGroup);
            passEncoder.draw(4, 1, 0, 0);
            passEncoder.end();
        };
        pass(transferPipeline, srcView, dstView);
        pass(flipYPipeline, dstView, srcView);
        this.device.queue.submit([
            commandEncoder.finish()
        ]);
        tempTexture.destroy();
    }
    generateMipmaps(textureGPU, textureGPUDescriptor, baseArrayLayer = 0) {
        const textureData = this.get(textureGPU);
        if (textureData.useCount === undefined) {
            textureData.useCount = 0;
            textureData.layers = [];
        }
        const passes = textureData.layers[baseArrayLayer] || this._mipmapCreateBundles(textureGPU, textureGPUDescriptor, baseArrayLayer);
        const commandEncoder = this.device.createCommandEncoder({});
        this._mipmapRunBundles(commandEncoder, passes);
        this.device.queue.submit([
            commandEncoder.finish()
        ]);
        if (textureData.useCount !== 0) textureData.layers[baseArrayLayer] = passes;
        textureData.useCount++;
    }
    _mipmapCreateBundles(textureGPU, textureGPUDescriptor, baseArrayLayer) {
        const pipeline = this.getTransferPipeline(textureGPUDescriptor.format);
        const bindGroupLayout = pipeline.getBindGroupLayout(0); // @TODO: Consider making this static.
        let srcView = textureGPU.createView({
            baseMipLevel: 0,
            mipLevelCount: 1,
            dimension: (0, $65e789322b24f25c$export$e9c73c9e5554baf7).TwoD,
            baseArrayLayer: baseArrayLayer
        });
        const passes = [];
        for(let i = 1; i < textureGPUDescriptor.mipLevelCount; i++){
            const bindGroup = this.device.createBindGroup({
                layout: bindGroupLayout,
                entries: [
                    {
                        binding: 0,
                        resource: this.mipmapSampler
                    },
                    {
                        binding: 1,
                        resource: srcView
                    }
                ]
            });
            const dstView = textureGPU.createView({
                baseMipLevel: i,
                mipLevelCount: 1,
                dimension: (0, $65e789322b24f25c$export$e9c73c9e5554baf7).TwoD,
                baseArrayLayer: baseArrayLayer
            });
            const passDescriptor = {
                colorAttachments: [
                    {
                        view: dstView,
                        loadOp: (0, $65e789322b24f25c$export$e23f171c304e7eb1).Clear,
                        storeOp: (0, $65e789322b24f25c$export$d6b072117316704a).Store,
                        clearValue: [
                            0,
                            0,
                            0,
                            0
                        ]
                    }
                ]
            };
            const passEncoder = this.device.createRenderBundleEncoder({
                colorFormats: [
                    textureGPUDescriptor.format
                ]
            });
            passEncoder.setPipeline(pipeline);
            passEncoder.setBindGroup(0, bindGroup);
            passEncoder.draw(4, 1, 0, 0);
            passes.push({
                renderBundles: [
                    passEncoder.finish()
                ],
                passDescriptor: passDescriptor
            });
            srcView = dstView;
        }
        return passes;
    }
    _mipmapRunBundles(commandEncoder, passes) {
        const levels = passes.length;
        for(let i = 0; i < levels; i++){
            const pass = passes[i];
            const passEncoder = commandEncoder.beginRenderPass(pass.passDescriptor);
            passEncoder.executeBundles(pass.renderBundles);
            passEncoder.end();
        }
    }
}
var $faf1374890c7020f$export$2e2bcd8739ae039 = $faf1374890c7020f$var$WebGPUTexturePassUtils;






const $39e424db81bbb213$var$_compareToWebGPU = {
    [(0, $cb5ee595c0f892af$export$d9e2d19a747baaab)]: 'never',
    [(0, $cb5ee595c0f892af$export$36bcf49c713b3eb7)]: 'less',
    [(0, $cb5ee595c0f892af$export$66f28d946fc6a0d5)]: 'equal',
    [(0, $cb5ee595c0f892af$export$64eea11eb407ddf1)]: 'less-equal',
    [(0, $cb5ee595c0f892af$export$155af022118f3a38)]: 'greater',
    [(0, $cb5ee595c0f892af$export$1cdcb70d53d65f61)]: 'greater-equal',
    [(0, $cb5ee595c0f892af$export$187b73a3e352c145)]: 'always',
    [(0, $cb5ee595c0f892af$export$67ab95dde6bed156)]: 'not-equal'
};
const $39e424db81bbb213$var$_flipMap = [
    0,
    1,
    3,
    2,
    4,
    5
];
class $39e424db81bbb213$var$WebGPUTextureUtils {
    constructor(backend){
        this.backend = backend;
        this._passUtils = null;
        this.defaultTexture = {};
        this.defaultCubeTexture = {};
        this.defaultVideoFrame = null;
        this.colorBuffer = null;
        this.depthTexture = new (0, $520286b5db9c7cf5$export$fc830aa069cc8c2f)();
        this.depthTexture.name = 'depthBuffer';
    }
    createSampler(texture) {
        const backend = this.backend;
        const device = backend.device;
        const textureGPU = backend.get(texture);
        const samplerDescriptorGPU = {
            addressModeU: this._convertAddressMode(texture.wrapS),
            addressModeV: this._convertAddressMode(texture.wrapT),
            addressModeW: this._convertAddressMode(texture.wrapR),
            magFilter: this._convertFilterMode(texture.magFilter),
            minFilter: this._convertFilterMode(texture.minFilter),
            mipmapFilter: this._convertFilterMode(texture.minFilter),
            maxAnisotropy: 1
        };
        // anisotropy can only be used when all filter modes are set to linear.
        if (samplerDescriptorGPU.magFilter === (0, $65e789322b24f25c$export$9948723cf5806885).Linear && samplerDescriptorGPU.minFilter === (0, $65e789322b24f25c$export$9948723cf5806885).Linear && samplerDescriptorGPU.mipmapFilter === (0, $65e789322b24f25c$export$9948723cf5806885).Linear) samplerDescriptorGPU.maxAnisotropy = texture.anisotropy;
        if (texture.isDepthTexture && texture.compareFunction !== null) samplerDescriptorGPU.compare = $39e424db81bbb213$var$_compareToWebGPU[texture.compareFunction];
        textureGPU.sampler = device.createSampler(samplerDescriptorGPU);
    }
    createDefaultTexture(texture) {
        let textureGPU;
        const format = $39e424db81bbb213$export$f61ac8b6f1f46202(texture);
        if (texture.isCubeTexture) textureGPU = this._getDefaultCubeTextureGPU(format);
        else if (texture.isVideoTexture) this.backend.get(texture).externalTexture = this._getDefaultVideoFrame();
        else textureGPU = this._getDefaultTextureGPU(format);
        this.backend.get(texture).texture = textureGPU;
    }
    createTexture(texture, options = {}) {
        const backend = this.backend;
        const textureData = backend.get(texture);
        if (textureData.initialized) throw new Error('WebGPUTextureUtils: Texture already initialized.');
        if (options.needsMipmaps === undefined) options.needsMipmaps = false;
        if (options.levels === undefined) options.levels = 1;
        if (options.depth === undefined) options.depth = 1;
        const { width: width, height: height, depth: depth, levels: levels } = options;
        if (texture.isFramebufferTexture) {
            if (options.renderTarget) options.format = this.backend.utils.getCurrentColorFormat(options.renderTarget);
            else options.format = this.backend.utils.getPreferredCanvasFormat();
        }
        const dimension = this._getDimension(texture);
        const format = texture.internalFormat || options.format || $39e424db81bbb213$export$f61ac8b6f1f46202(texture, backend.device);
        textureData.format = format;
        let sampleCount = options.sampleCount !== undefined ? options.sampleCount : 1;
        sampleCount = backend.utils.getSampleCount(sampleCount);
        const primarySampleCount = texture.isRenderTargetTexture && !texture.isMultisampleRenderTargetTexture ? 1 : sampleCount;
        let usage = GPUTextureUsage.TEXTURE_BINDING | GPUTextureUsage.COPY_DST | GPUTextureUsage.COPY_SRC;
        if (texture.isStorageTexture === true) usage |= GPUTextureUsage.STORAGE_BINDING;
        if (texture.isCompressedTexture !== true && texture.isCompressedArrayTexture !== true) usage |= GPUTextureUsage.RENDER_ATTACHMENT;
        const textureDescriptorGPU = {
            label: texture.name,
            size: {
                width: width,
                height: height,
                depthOrArrayLayers: depth
            },
            mipLevelCount: levels,
            sampleCount: primarySampleCount,
            dimension: dimension,
            format: format,
            usage: usage
        };
        // texture creation
        if (texture.isVideoTexture) {
            const video = texture.source.data;
            const videoFrame = new VideoFrame(video);
            textureDescriptorGPU.size.width = videoFrame.displayWidth;
            textureDescriptorGPU.size.height = videoFrame.displayHeight;
            videoFrame.close();
            textureData.externalTexture = video;
        } else {
            if (format === undefined) {
                console.warn('WebGPURenderer: Texture format not supported.');
                return this.createDefaultTexture(texture);
            }
            textureData.texture = backend.device.createTexture(textureDescriptorGPU);
        }
        if (texture.isRenderTargetTexture && sampleCount > 1 && !texture.isMultisampleRenderTargetTexture) {
            const msaaTextureDescriptorGPU = Object.assign({}, textureDescriptorGPU);
            msaaTextureDescriptorGPU.label = msaaTextureDescriptorGPU.label + '-msaa';
            msaaTextureDescriptorGPU.sampleCount = sampleCount;
            textureData.msaaTexture = backend.device.createTexture(msaaTextureDescriptorGPU);
        }
        textureData.initialized = true;
        textureData.textureDescriptorGPU = textureDescriptorGPU;
    }
    destroyTexture(texture) {
        const backend = this.backend;
        const textureData = backend.get(texture);
        textureData.texture.destroy();
        if (textureData.msaaTexture !== undefined) textureData.msaaTexture.destroy();
        backend.delete(texture);
    }
    destroySampler(texture) {
        const backend = this.backend;
        const textureData = backend.get(texture);
        delete textureData.sampler;
    }
    generateMipmaps(texture) {
        const textureData = this.backend.get(texture);
        if (texture.isCubeTexture) for(let i = 0; i < 6; i++)this._generateMipmaps(textureData.texture, textureData.textureDescriptorGPU, i);
        else {
            const depth = texture.image.depth || 1;
            for(let i = 0; i < depth; i++)this._generateMipmaps(textureData.texture, textureData.textureDescriptorGPU, i);
        }
    }
    getColorBuffer() {
        if (this.colorBuffer) this.colorBuffer.destroy();
        const backend = this.backend;
        const { width: width, height: height } = backend.getDrawingBufferSize();
        this.colorBuffer = backend.device.createTexture({
            label: 'colorBuffer',
            size: {
                width: width,
                height: height,
                depthOrArrayLayers: 1
            },
            sampleCount: backend.utils.getSampleCount(backend.renderer.samples),
            format: backend.utils.getPreferredCanvasFormat(),
            usage: GPUTextureUsage.RENDER_ATTACHMENT | GPUTextureUsage.COPY_SRC
        });
        return this.colorBuffer;
    }
    getDepthBuffer(depth = true, stencil = false) {
        const backend = this.backend;
        const { width: width, height: height } = backend.getDrawingBufferSize();
        const depthTexture = this.depthTexture;
        const depthTextureGPU = backend.get(depthTexture).texture;
        let format, type;
        if (stencil) {
            format = (0, $cb5ee595c0f892af$export$1e113ac2d0905829);
            type = (0, $cb5ee595c0f892af$export$6c8ea339bfab1301);
        } else if (depth) {
            format = (0, $cb5ee595c0f892af$export$c1b6b5136be58045);
            type = (0, $cb5ee595c0f892af$export$c3c7fc4518ebba96);
        }
        if (depthTextureGPU !== undefined) {
            if (depthTexture.image.width === width && depthTexture.image.height === height && depthTexture.format === format && depthTexture.type === type) return depthTextureGPU;
            this.destroyTexture(depthTexture);
        }
        depthTexture.name = 'depthBuffer';
        depthTexture.format = format;
        depthTexture.type = type;
        depthTexture.image.width = width;
        depthTexture.image.height = height;
        this.createTexture(depthTexture, {
            sampleCount: backend.utils.getSampleCount(backend.renderer.samples),
            width: width,
            height: height
        });
        return backend.get(depthTexture).texture;
    }
    updateTexture(texture, options) {
        const textureData = this.backend.get(texture);
        const { textureDescriptorGPU: textureDescriptorGPU } = textureData;
        if (texture.isRenderTargetTexture || textureDescriptorGPU === undefined /* unsupported texture format */ ) return;
        // transfer texture data
        if (texture.isDataTexture) this._copyBufferToTexture(options.image, textureData.texture, textureDescriptorGPU, 0, texture.flipY);
        else if (texture.isDataArrayTexture || texture.isData3DTexture) for(let i = 0; i < options.image.depth; i++)this._copyBufferToTexture(options.image, textureData.texture, textureDescriptorGPU, i, texture.flipY, i);
        else if (texture.isCompressedTexture || texture.isCompressedArrayTexture) this._copyCompressedBufferToTexture(texture.mipmaps, textureData.texture, textureDescriptorGPU);
        else if (texture.isCubeTexture) this._copyCubeMapToTexture(options.images, textureData.texture, textureDescriptorGPU, texture.flipY);
        else if (texture.isVideoTexture) {
            const video = texture.source.data;
            textureData.externalTexture = video;
        } else this._copyImageToTexture(options.image, textureData.texture, textureDescriptorGPU, 0, texture.flipY);
        //
        textureData.version = texture.version;
        if (texture.onUpdate) texture.onUpdate(texture);
    }
    async copyTextureToBuffer(texture, x, y, width, height, faceIndex) {
        const device = this.backend.device;
        const textureData = this.backend.get(texture);
        const textureGPU = textureData.texture;
        const format = textureData.textureDescriptorGPU.format;
        const bytesPerTexel = this._getBytesPerTexel(format);
        let bytesPerRow = width * bytesPerTexel;
        bytesPerRow = Math.ceil(bytesPerRow / 256) * 256; // Align to 256 bytes
        const readBuffer = device.createBuffer({
            size: width * height * bytesPerTexel,
            usage: GPUBufferUsage.COPY_DST | GPUBufferUsage.MAP_READ
        });
        const encoder = device.createCommandEncoder();
        encoder.copyTextureToBuffer({
            texture: textureGPU,
            origin: {
                x: x,
                y: y,
                z: faceIndex
            }
        }, {
            buffer: readBuffer,
            bytesPerRow: bytesPerRow
        }, {
            width: width,
            height: height
        });
        const typedArrayType = this._getTypedArrayType(format);
        device.queue.submit([
            encoder.finish()
        ]);
        await readBuffer.mapAsync(GPUMapMode.READ);
        const buffer = readBuffer.getMappedRange();
        return new typedArrayType(buffer);
    }
    _isEnvironmentTexture(texture) {
        const mapping = texture.mapping;
        return mapping === (0, $cb5ee595c0f892af$export$d64030b316d3b087) || mapping === (0, $cb5ee595c0f892af$export$ee99d97d46898098) || mapping === (0, $cb5ee595c0f892af$export$8759762a6477f2c4) || mapping === (0, $cb5ee595c0f892af$export$dc59f8aed047f61d);
    }
    _getDefaultTextureGPU(format) {
        let defaultTexture = this.defaultTexture[format];
        if (defaultTexture === undefined) {
            const texture = new (0, $97033ebbcbadc145$export$5431306cf43de24a)();
            texture.minFilter = (0, $cb5ee595c0f892af$export$727aa5ec3fe39bf0);
            texture.magFilter = (0, $cb5ee595c0f892af$export$727aa5ec3fe39bf0);
            this.createTexture(texture, {
                width: 1,
                height: 1,
                format: format
            });
            this.defaultTexture[format] = defaultTexture = texture;
        }
        return this.backend.get(defaultTexture).texture;
    }
    _getDefaultCubeTextureGPU(format) {
        let defaultCubeTexture = this.defaultTexture[format];
        if (defaultCubeTexture === undefined) {
            const texture = new (0, $0b071408edafdf32$export$ee2e5a18258a4049)();
            texture.minFilter = (0, $cb5ee595c0f892af$export$727aa5ec3fe39bf0);
            texture.magFilter = (0, $cb5ee595c0f892af$export$727aa5ec3fe39bf0);
            this.createTexture(texture, {
                width: 1,
                height: 1,
                depth: 6
            });
            this.defaultCubeTexture[format] = defaultCubeTexture = texture;
        }
        return this.backend.get(defaultCubeTexture).texture;
    }
    _getDefaultVideoFrame() {
        let defaultVideoFrame = this.defaultVideoFrame;
        if (defaultVideoFrame === null) {
            const init = {
                timestamp: 0,
                codedWidth: 1,
                codedHeight: 1,
                format: 'RGBA'
            };
            this.defaultVideoFrame = defaultVideoFrame = new VideoFrame(new Uint8Array([
                0,
                0,
                0,
                0xff
            ]), init);
        }
        return defaultVideoFrame;
    }
    _copyCubeMapToTexture(images, textureGPU, textureDescriptorGPU, flipY) {
        for(let i = 0; i < 6; i++){
            const image = images[i];
            const flipIndex = flipY === true ? $39e424db81bbb213$var$_flipMap[i] : i;
            if (image.isDataTexture) this._copyBufferToTexture(image.image, textureGPU, textureDescriptorGPU, flipIndex, flipY);
            else this._copyImageToTexture(image, textureGPU, textureDescriptorGPU, flipIndex, flipY);
        }
    }
    _copyImageToTexture(image, textureGPU, textureDescriptorGPU, originDepth, flipY) {
        const device = this.backend.device;
        device.queue.copyExternalImageToTexture({
            source: image
        }, {
            texture: textureGPU,
            mipLevel: 0,
            origin: {
                x: 0,
                y: 0,
                z: originDepth
            }
        }, {
            width: image.width,
            height: image.height,
            depthOrArrayLayers: 1
        });
        if (flipY === true) this._flipY(textureGPU, textureDescriptorGPU, originDepth);
    }
    _getPassUtils() {
        let passUtils = this._passUtils;
        if (passUtils === null) this._passUtils = passUtils = new (0, $faf1374890c7020f$export$2e2bcd8739ae039)(this.backend.device);
        return passUtils;
    }
    _generateMipmaps(textureGPU, textureDescriptorGPU, baseArrayLayer = 0) {
        this._getPassUtils().generateMipmaps(textureGPU, textureDescriptorGPU, baseArrayLayer);
    }
    _flipY(textureGPU, textureDescriptorGPU, originDepth = 0) {
        this._getPassUtils().flipY(textureGPU, textureDescriptorGPU, originDepth);
    }
    _copyBufferToTexture(image, textureGPU, textureDescriptorGPU, originDepth, flipY, depth = 0) {
        // @TODO: Consider to use GPUCommandEncoder.copyBufferToTexture()
        // @TODO: Consider to support valid buffer layouts with other formats like RGB
        const device = this.backend.device;
        const data = image.data;
        const bytesPerTexel = this._getBytesPerTexel(textureDescriptorGPU.format);
        const bytesPerRow = image.width * bytesPerTexel;
        device.queue.writeTexture({
            texture: textureGPU,
            mipLevel: 0,
            origin: {
                x: 0,
                y: 0,
                z: originDepth
            }
        }, data, {
            offset: image.width * image.height * bytesPerTexel * depth,
            bytesPerRow: bytesPerRow
        }, {
            width: image.width,
            height: image.height,
            depthOrArrayLayers: 1
        });
        if (flipY === true) this._flipY(textureGPU, textureDescriptorGPU, originDepth);
    }
    _copyCompressedBufferToTexture(mipmaps, textureGPU, textureDescriptorGPU) {
        // @TODO: Consider to use GPUCommandEncoder.copyBufferToTexture()
        const device = this.backend.device;
        const blockData = this._getBlockData(textureDescriptorGPU.format);
        const isTextureArray = textureDescriptorGPU.size.depthOrArrayLayers > 1;
        for(let i = 0; i < mipmaps.length; i++){
            const mipmap = mipmaps[i];
            const width = mipmap.width;
            const height = mipmap.height;
            const depth = isTextureArray ? textureDescriptorGPU.size.depthOrArrayLayers : 1;
            const bytesPerRow = Math.ceil(width / blockData.width) * blockData.byteLength;
            const bytesPerImage = bytesPerRow * Math.ceil(height / blockData.height);
            for(let j = 0; j < depth; j++)device.queue.writeTexture({
                texture: textureGPU,
                mipLevel: i,
                origin: {
                    x: 0,
                    y: 0,
                    z: j
                }
            }, mipmap.data, {
                offset: j * bytesPerImage,
                bytesPerRow: bytesPerRow,
                rowsPerImage: Math.ceil(height / blockData.height)
            }, {
                width: Math.ceil(width / blockData.width) * blockData.width,
                height: Math.ceil(height / blockData.height) * blockData.height,
                depthOrArrayLayers: 1
            });
        }
    }
    _getBlockData(format) {
        // this method is only relevant for compressed texture formats
        if (format === (0, $65e789322b24f25c$export$e19f37cdec813149).BC1RGBAUnorm || format === (0, $65e789322b24f25c$export$e19f37cdec813149).BC1RGBAUnormSRGB) return {
            byteLength: 8,
            width: 4,
            height: 4
        }; // DXT1
        if (format === (0, $65e789322b24f25c$export$e19f37cdec813149).BC2RGBAUnorm || format === (0, $65e789322b24f25c$export$e19f37cdec813149).BC2RGBAUnormSRGB) return {
            byteLength: 16,
            width: 4,
            height: 4
        }; // DXT3
        if (format === (0, $65e789322b24f25c$export$e19f37cdec813149).BC3RGBAUnorm || format === (0, $65e789322b24f25c$export$e19f37cdec813149).BC3RGBAUnormSRGB) return {
            byteLength: 16,
            width: 4,
            height: 4
        }; // DXT5
        if (format === (0, $65e789322b24f25c$export$e19f37cdec813149).BC4RUnorm || format === (0, $65e789322b24f25c$export$e19f37cdec813149).BC4RSNorm) return {
            byteLength: 8,
            width: 4,
            height: 4
        }; // RGTC1
        if (format === (0, $65e789322b24f25c$export$e19f37cdec813149).BC5RGUnorm || format === (0, $65e789322b24f25c$export$e19f37cdec813149).BC5RGSnorm) return {
            byteLength: 16,
            width: 4,
            height: 4
        }; // RGTC2
        if (format === (0, $65e789322b24f25c$export$e19f37cdec813149).BC6HRGBUFloat || format === (0, $65e789322b24f25c$export$e19f37cdec813149).BC6HRGBFloat) return {
            byteLength: 16,
            width: 4,
            height: 4
        }; // BPTC (float)
        if (format === (0, $65e789322b24f25c$export$e19f37cdec813149).BC7RGBAUnorm || format === (0, $65e789322b24f25c$export$e19f37cdec813149).BC7RGBAUnormSRGB) return {
            byteLength: 16,
            width: 4,
            height: 4
        }; // BPTC (unorm)
        if (format === (0, $65e789322b24f25c$export$e19f37cdec813149).ETC2RGB8Unorm || format === (0, $65e789322b24f25c$export$e19f37cdec813149).ETC2RGB8UnormSRGB) return {
            byteLength: 8,
            width: 4,
            height: 4
        };
        if (format === (0, $65e789322b24f25c$export$e19f37cdec813149).ETC2RGB8A1Unorm || format === (0, $65e789322b24f25c$export$e19f37cdec813149).ETC2RGB8A1UnormSRGB) return {
            byteLength: 8,
            width: 4,
            height: 4
        };
        if (format === (0, $65e789322b24f25c$export$e19f37cdec813149).ETC2RGBA8Unorm || format === (0, $65e789322b24f25c$export$e19f37cdec813149).ETC2RGBA8UnormSRGB) return {
            byteLength: 16,
            width: 4,
            height: 4
        };
        if (format === (0, $65e789322b24f25c$export$e19f37cdec813149).EACR11Unorm) return {
            byteLength: 8,
            width: 4,
            height: 4
        };
        if (format === (0, $65e789322b24f25c$export$e19f37cdec813149).EACR11Snorm) return {
            byteLength: 8,
            width: 4,
            height: 4
        };
        if (format === (0, $65e789322b24f25c$export$e19f37cdec813149).EACRG11Unorm) return {
            byteLength: 16,
            width: 4,
            height: 4
        };
        if (format === (0, $65e789322b24f25c$export$e19f37cdec813149).EACRG11Snorm) return {
            byteLength: 16,
            width: 4,
            height: 4
        };
        if (format === (0, $65e789322b24f25c$export$e19f37cdec813149).ASTC4x4Unorm || format === (0, $65e789322b24f25c$export$e19f37cdec813149).ASTC4x4UnormSRGB) return {
            byteLength: 16,
            width: 4,
            height: 4
        };
        if (format === (0, $65e789322b24f25c$export$e19f37cdec813149).ASTC5x4Unorm || format === (0, $65e789322b24f25c$export$e19f37cdec813149).ASTC5x4UnormSRGB) return {
            byteLength: 16,
            width: 5,
            height: 4
        };
        if (format === (0, $65e789322b24f25c$export$e19f37cdec813149).ASTC5x5Unorm || format === (0, $65e789322b24f25c$export$e19f37cdec813149).ASTC5x5UnormSRGB) return {
            byteLength: 16,
            width: 5,
            height: 5
        };
        if (format === (0, $65e789322b24f25c$export$e19f37cdec813149).ASTC6x5Unorm || format === (0, $65e789322b24f25c$export$e19f37cdec813149).ASTC6x5UnormSRGB) return {
            byteLength: 16,
            width: 6,
            height: 5
        };
        if (format === (0, $65e789322b24f25c$export$e19f37cdec813149).ASTC6x6Unorm || format === (0, $65e789322b24f25c$export$e19f37cdec813149).ASTC6x6UnormSRGB) return {
            byteLength: 16,
            width: 6,
            height: 6
        };
        if (format === (0, $65e789322b24f25c$export$e19f37cdec813149).ASTC8x5Unorm || format === (0, $65e789322b24f25c$export$e19f37cdec813149).ASTC8x5UnormSRGB) return {
            byteLength: 16,
            width: 8,
            height: 5
        };
        if (format === (0, $65e789322b24f25c$export$e19f37cdec813149).ASTC8x6Unorm || format === (0, $65e789322b24f25c$export$e19f37cdec813149).ASTC8x6UnormSRGB) return {
            byteLength: 16,
            width: 8,
            height: 6
        };
        if (format === (0, $65e789322b24f25c$export$e19f37cdec813149).ASTC8x8Unorm || format === (0, $65e789322b24f25c$export$e19f37cdec813149).ASTC8x8UnormSRGB) return {
            byteLength: 16,
            width: 8,
            height: 8
        };
        if (format === (0, $65e789322b24f25c$export$e19f37cdec813149).ASTC10x5Unorm || format === (0, $65e789322b24f25c$export$e19f37cdec813149).ASTC10x5UnormSRGB) return {
            byteLength: 16,
            width: 10,
            height: 5
        };
        if (format === (0, $65e789322b24f25c$export$e19f37cdec813149).ASTC10x6Unorm || format === (0, $65e789322b24f25c$export$e19f37cdec813149).ASTC10x6UnormSRGB) return {
            byteLength: 16,
            width: 10,
            height: 6
        };
        if (format === (0, $65e789322b24f25c$export$e19f37cdec813149).ASTC10x8Unorm || format === (0, $65e789322b24f25c$export$e19f37cdec813149).ASTC10x8UnormSRGB) return {
            byteLength: 16,
            width: 10,
            height: 8
        };
        if (format === (0, $65e789322b24f25c$export$e19f37cdec813149).ASTC10x10Unorm || format === (0, $65e789322b24f25c$export$e19f37cdec813149).ASTC10x10UnormSRGB) return {
            byteLength: 16,
            width: 10,
            height: 10
        };
        if (format === (0, $65e789322b24f25c$export$e19f37cdec813149).ASTC12x10Unorm || format === (0, $65e789322b24f25c$export$e19f37cdec813149).ASTC12x10UnormSRGB) return {
            byteLength: 16,
            width: 12,
            height: 10
        };
        if (format === (0, $65e789322b24f25c$export$e19f37cdec813149).ASTC12x12Unorm || format === (0, $65e789322b24f25c$export$e19f37cdec813149).ASTC12x12UnormSRGB) return {
            byteLength: 16,
            width: 12,
            height: 12
        };
    }
    _convertAddressMode(value) {
        let addressMode = (0, $65e789322b24f25c$export$4c41e9c18981742d).ClampToEdge;
        if (value === (0, $cb5ee595c0f892af$export$533346c8e8dac0f5)) addressMode = (0, $65e789322b24f25c$export$4c41e9c18981742d).Repeat;
        else if (value === (0, $cb5ee595c0f892af$export$c7e7c00b14f51a4f)) addressMode = (0, $65e789322b24f25c$export$4c41e9c18981742d).MirrorRepeat;
        return addressMode;
    }
    _convertFilterMode(value) {
        let filterMode = (0, $65e789322b24f25c$export$9948723cf5806885).Linear;
        if (value === (0, $cb5ee595c0f892af$export$727aa5ec3fe39bf0) || value === (0, $cb5ee595c0f892af$export$d129e38cf6feaa8c) || value === (0, $cb5ee595c0f892af$export$d2327c1afe5bfdf2)) filterMode = (0, $65e789322b24f25c$export$9948723cf5806885).Nearest;
        return filterMode;
    }
    _getBytesPerTexel(format) {
        // 8-bit formats
        if (format === (0, $65e789322b24f25c$export$e19f37cdec813149).R8Unorm || format === (0, $65e789322b24f25c$export$e19f37cdec813149).R8Snorm || format === (0, $65e789322b24f25c$export$e19f37cdec813149).R8Uint || format === (0, $65e789322b24f25c$export$e19f37cdec813149).R8Sint) return 1;
        // 16-bit formats
        if (format === (0, $65e789322b24f25c$export$e19f37cdec813149).R16Uint || format === (0, $65e789322b24f25c$export$e19f37cdec813149).R16Sint || format === (0, $65e789322b24f25c$export$e19f37cdec813149).R16Float || format === (0, $65e789322b24f25c$export$e19f37cdec813149).RG8Unorm || format === (0, $65e789322b24f25c$export$e19f37cdec813149).RG8Snorm || format === (0, $65e789322b24f25c$export$e19f37cdec813149).RG8Uint || format === (0, $65e789322b24f25c$export$e19f37cdec813149).RG8Sint) return 2;
        // 32-bit formats
        if (format === (0, $65e789322b24f25c$export$e19f37cdec813149).R32Uint || format === (0, $65e789322b24f25c$export$e19f37cdec813149).R32Sint || format === (0, $65e789322b24f25c$export$e19f37cdec813149).R32Float || format === (0, $65e789322b24f25c$export$e19f37cdec813149).RG16Uint || format === (0, $65e789322b24f25c$export$e19f37cdec813149).RG16Sint || format === (0, $65e789322b24f25c$export$e19f37cdec813149).RG16Float || format === (0, $65e789322b24f25c$export$e19f37cdec813149).RGBA8Unorm || format === (0, $65e789322b24f25c$export$e19f37cdec813149).RGBA8UnormSRGB || format === (0, $65e789322b24f25c$export$e19f37cdec813149).RGBA8Snorm || format === (0, $65e789322b24f25c$export$e19f37cdec813149).RGBA8Uint || format === (0, $65e789322b24f25c$export$e19f37cdec813149).RGBA8Sint || format === (0, $65e789322b24f25c$export$e19f37cdec813149).BGRA8Unorm || format === (0, $65e789322b24f25c$export$e19f37cdec813149).BGRA8UnormSRGB || // Packed 32-bit formats
        format === (0, $65e789322b24f25c$export$e19f37cdec813149).RGB9E5UFloat || format === (0, $65e789322b24f25c$export$e19f37cdec813149).RGB10A2Unorm || format === (0, $65e789322b24f25c$export$e19f37cdec813149).RG11B10UFloat || format === (0, $65e789322b24f25c$export$e19f37cdec813149).Depth32Float || format === (0, $65e789322b24f25c$export$e19f37cdec813149).Depth24Plus || format === (0, $65e789322b24f25c$export$e19f37cdec813149).Depth24PlusStencil8 || format === (0, $65e789322b24f25c$export$e19f37cdec813149).Depth32FloatStencil8) return 4;
        // 64-bit formats
        if (format === (0, $65e789322b24f25c$export$e19f37cdec813149).RG32Uint || format === (0, $65e789322b24f25c$export$e19f37cdec813149).RG32Sint || format === (0, $65e789322b24f25c$export$e19f37cdec813149).RG32Float || format === (0, $65e789322b24f25c$export$e19f37cdec813149).RGBA16Uint || format === (0, $65e789322b24f25c$export$e19f37cdec813149).RGBA16Sint || format === (0, $65e789322b24f25c$export$e19f37cdec813149).RGBA16Float) return 8;
        // 128-bit formats
        if (format === (0, $65e789322b24f25c$export$e19f37cdec813149).RGBA32Uint || format === (0, $65e789322b24f25c$export$e19f37cdec813149).RGBA32Sint || format === (0, $65e789322b24f25c$export$e19f37cdec813149).RGBA32Float) return 16;
    }
    _getTypedArrayType(format) {
        if (format === (0, $65e789322b24f25c$export$e19f37cdec813149).R8Uint) return Uint8Array;
        if (format === (0, $65e789322b24f25c$export$e19f37cdec813149).R8Sint) return Int8Array;
        if (format === (0, $65e789322b24f25c$export$e19f37cdec813149).R8Unorm) return Uint8Array;
        if (format === (0, $65e789322b24f25c$export$e19f37cdec813149).R8Snorm) return Int8Array;
        if (format === (0, $65e789322b24f25c$export$e19f37cdec813149).RG8Uint) return Uint8Array;
        if (format === (0, $65e789322b24f25c$export$e19f37cdec813149).RG8Sint) return Int8Array;
        if (format === (0, $65e789322b24f25c$export$e19f37cdec813149).RG8Unorm) return Uint8Array;
        if (format === (0, $65e789322b24f25c$export$e19f37cdec813149).RG8Snorm) return Int8Array;
        if (format === (0, $65e789322b24f25c$export$e19f37cdec813149).RGBA8Uint) return Uint8Array;
        if (format === (0, $65e789322b24f25c$export$e19f37cdec813149).RGBA8Sint) return Int8Array;
        if (format === (0, $65e789322b24f25c$export$e19f37cdec813149).RGBA8Unorm) return Uint8Array;
        if (format === (0, $65e789322b24f25c$export$e19f37cdec813149).RGBA8Snorm) return Int8Array;
        if (format === (0, $65e789322b24f25c$export$e19f37cdec813149).R16Uint) return Uint16Array;
        if (format === (0, $65e789322b24f25c$export$e19f37cdec813149).R16Sint) return Int16Array;
        if (format === (0, $65e789322b24f25c$export$e19f37cdec813149).RG16Uint) return Uint16Array;
        if (format === (0, $65e789322b24f25c$export$e19f37cdec813149).RG16Sint) return Int16Array;
        if (format === (0, $65e789322b24f25c$export$e19f37cdec813149).RGBA16Uint) return Uint16Array;
        if (format === (0, $65e789322b24f25c$export$e19f37cdec813149).RGBA16Sint) return Int16Array;
        if (format === (0, $65e789322b24f25c$export$e19f37cdec813149).R16Float) return Uint16Array;
        if (format === (0, $65e789322b24f25c$export$e19f37cdec813149).RG16Float) return Uint16Array;
        if (format === (0, $65e789322b24f25c$export$e19f37cdec813149).RGBA16Float) return Uint16Array;
        if (format === (0, $65e789322b24f25c$export$e19f37cdec813149).R32Uint) return Uint32Array;
        if (format === (0, $65e789322b24f25c$export$e19f37cdec813149).R32Sint) return Int32Array;
        if (format === (0, $65e789322b24f25c$export$e19f37cdec813149).R32Float) return Float32Array;
        if (format === (0, $65e789322b24f25c$export$e19f37cdec813149).RG32Uint) return Uint32Array;
        if (format === (0, $65e789322b24f25c$export$e19f37cdec813149).RG32Sint) return Int32Array;
        if (format === (0, $65e789322b24f25c$export$e19f37cdec813149).RG32Float) return Float32Array;
        if (format === (0, $65e789322b24f25c$export$e19f37cdec813149).RGBA32Uint) return Uint32Array;
        if (format === (0, $65e789322b24f25c$export$e19f37cdec813149).RGBA32Sint) return Int32Array;
        if (format === (0, $65e789322b24f25c$export$e19f37cdec813149).RGBA32Float) return Float32Array;
        if (format === (0, $65e789322b24f25c$export$e19f37cdec813149).BGRA8Unorm) return Uint8Array;
        if (format === (0, $65e789322b24f25c$export$e19f37cdec813149).BGRA8UnormSRGB) return Uint8Array;
        if (format === (0, $65e789322b24f25c$export$e19f37cdec813149).RGB10A2Unorm) return Uint32Array;
        if (format === (0, $65e789322b24f25c$export$e19f37cdec813149).RGB9E5UFloat) return Uint32Array;
        if (format === (0, $65e789322b24f25c$export$e19f37cdec813149).RG11B10UFloat) return Uint32Array;
        if (format === (0, $65e789322b24f25c$export$e19f37cdec813149).Depth32Float) return Float32Array;
        if (format === (0, $65e789322b24f25c$export$e19f37cdec813149).Depth24Plus) return Uint32Array;
        if (format === (0, $65e789322b24f25c$export$e19f37cdec813149).Depth24PlusStencil8) return Uint32Array;
        if (format === (0, $65e789322b24f25c$export$e19f37cdec813149).Depth32FloatStencil8) return Float32Array;
    }
    _getDimension(texture) {
        let dimension;
        if (texture.isData3DTexture) dimension = (0, $65e789322b24f25c$export$ef10a754a74446cb).ThreeD;
        else dimension = (0, $65e789322b24f25c$export$ef10a754a74446cb).TwoD;
        return dimension;
    }
}
function $39e424db81bbb213$export$f61ac8b6f1f46202(texture, device = null) {
    const format = texture.format;
    const type = texture.type;
    const colorSpace = texture.colorSpace;
    let formatGPU;
    if (texture.isCompressedTexture === true || texture.isCompressedArrayTexture === true) switch(format){
        case 0, $cb5ee595c0f892af$export$afa304c3e981b668:
            formatGPU = colorSpace === (0, $cb5ee595c0f892af$export$561f394b24edfcaa) ? (0, $65e789322b24f25c$export$e19f37cdec813149).BC1RGBAUnormSRGB : (0, $65e789322b24f25c$export$e19f37cdec813149).BC1RGBAUnorm;
            break;
        case 0, $cb5ee595c0f892af$export$d2a1a68024a3e56c:
            formatGPU = colorSpace === (0, $cb5ee595c0f892af$export$561f394b24edfcaa) ? (0, $65e789322b24f25c$export$e19f37cdec813149).BC2RGBAUnormSRGB : (0, $65e789322b24f25c$export$e19f37cdec813149).BC2RGBAUnorm;
            break;
        case 0, $cb5ee595c0f892af$export$9a79c424327dacf9:
            formatGPU = colorSpace === (0, $cb5ee595c0f892af$export$561f394b24edfcaa) ? (0, $65e789322b24f25c$export$e19f37cdec813149).BC3RGBAUnormSRGB : (0, $65e789322b24f25c$export$e19f37cdec813149).BC3RGBAUnorm;
            break;
        case 0, $cb5ee595c0f892af$export$7800993ef8106a6a:
            formatGPU = colorSpace === (0, $cb5ee595c0f892af$export$561f394b24edfcaa) ? (0, $65e789322b24f25c$export$e19f37cdec813149).ETC2RGB8UnormSRGB : (0, $65e789322b24f25c$export$e19f37cdec813149).ETC2RGB8Unorm;
            break;
        case 0, $cb5ee595c0f892af$export$23ed8300a860e7d8:
            formatGPU = colorSpace === (0, $cb5ee595c0f892af$export$561f394b24edfcaa) ? (0, $65e789322b24f25c$export$e19f37cdec813149).ETC2RGBA8UnormSRGB : (0, $65e789322b24f25c$export$e19f37cdec813149).ETC2RGBA8Unorm;
            break;
        case 0, $cb5ee595c0f892af$export$dc5570b4a2b92d48:
            formatGPU = colorSpace === (0, $cb5ee595c0f892af$export$561f394b24edfcaa) ? (0, $65e789322b24f25c$export$e19f37cdec813149).ASTC4x4UnormSRGB : (0, $65e789322b24f25c$export$e19f37cdec813149).ASTC4x4Unorm;
            break;
        case 0, $cb5ee595c0f892af$export$68880cd325f8b2fb:
            formatGPU = colorSpace === (0, $cb5ee595c0f892af$export$561f394b24edfcaa) ? (0, $65e789322b24f25c$export$e19f37cdec813149).ASTC5x4UnormSRGB : (0, $65e789322b24f25c$export$e19f37cdec813149).ASTC5x4Unorm;
            break;
        case 0, $cb5ee595c0f892af$export$7d2c0be323373d95:
            formatGPU = colorSpace === (0, $cb5ee595c0f892af$export$561f394b24edfcaa) ? (0, $65e789322b24f25c$export$e19f37cdec813149).ASTC5x5UnormSRGB : (0, $65e789322b24f25c$export$e19f37cdec813149).ASTC5x5Unorm;
            break;
        case 0, $cb5ee595c0f892af$export$22b52da301fc3a3e:
            formatGPU = colorSpace === (0, $cb5ee595c0f892af$export$561f394b24edfcaa) ? (0, $65e789322b24f25c$export$e19f37cdec813149).ASTC6x5UnormSRGB : (0, $65e789322b24f25c$export$e19f37cdec813149).ASTC6x5Unorm;
            break;
        case 0, $cb5ee595c0f892af$export$c009e2cb4a66485e:
            formatGPU = colorSpace === (0, $cb5ee595c0f892af$export$561f394b24edfcaa) ? (0, $65e789322b24f25c$export$e19f37cdec813149).ASTC6x6UnormSRGB : (0, $65e789322b24f25c$export$e19f37cdec813149).ASTC6x6Unorm;
            break;
        case 0, $cb5ee595c0f892af$export$118fff5afa255b63:
            formatGPU = colorSpace === (0, $cb5ee595c0f892af$export$561f394b24edfcaa) ? (0, $65e789322b24f25c$export$e19f37cdec813149).ASTC8x5UnormSRGB : (0, $65e789322b24f25c$export$e19f37cdec813149).ASTC8x5Unorm;
            break;
        case 0, $cb5ee595c0f892af$export$120713c829ae0667:
            formatGPU = colorSpace === (0, $cb5ee595c0f892af$export$561f394b24edfcaa) ? (0, $65e789322b24f25c$export$e19f37cdec813149).ASTC8x6UnormSRGB : (0, $65e789322b24f25c$export$e19f37cdec813149).ASTC8x6Unorm;
            break;
        case 0, $cb5ee595c0f892af$export$c79eeabbf53313e9:
            formatGPU = colorSpace === (0, $cb5ee595c0f892af$export$561f394b24edfcaa) ? (0, $65e789322b24f25c$export$e19f37cdec813149).ASTC8x8UnormSRGB : (0, $65e789322b24f25c$export$e19f37cdec813149).ASTC8x8Unorm;
            break;
        case 0, $cb5ee595c0f892af$export$443cf6567cdd6424:
            formatGPU = colorSpace === (0, $cb5ee595c0f892af$export$561f394b24edfcaa) ? (0, $65e789322b24f25c$export$e19f37cdec813149).ASTC10x5UnormSRGB : (0, $65e789322b24f25c$export$e19f37cdec813149).ASTC10x5Unorm;
            break;
        case 0, $cb5ee595c0f892af$export$6573984fc9840780:
            formatGPU = colorSpace === (0, $cb5ee595c0f892af$export$561f394b24edfcaa) ? (0, $65e789322b24f25c$export$e19f37cdec813149).ASTC10x6UnormSRGB : (0, $65e789322b24f25c$export$e19f37cdec813149).ASTC10x6Unorm;
            break;
        case 0, $cb5ee595c0f892af$export$e7aee563f30091de:
            formatGPU = colorSpace === (0, $cb5ee595c0f892af$export$561f394b24edfcaa) ? (0, $65e789322b24f25c$export$e19f37cdec813149).ASTC10x8UnormSRGB : (0, $65e789322b24f25c$export$e19f37cdec813149).ASTC10x8Unorm;
            break;
        case 0, $cb5ee595c0f892af$export$2eb8634622ddeab7:
            formatGPU = colorSpace === (0, $cb5ee595c0f892af$export$561f394b24edfcaa) ? (0, $65e789322b24f25c$export$e19f37cdec813149).ASTC10x10UnormSRGB : (0, $65e789322b24f25c$export$e19f37cdec813149).ASTC10x10Unorm;
            break;
        case 0, $cb5ee595c0f892af$export$202b1ce7b5d25742:
            formatGPU = colorSpace === (0, $cb5ee595c0f892af$export$561f394b24edfcaa) ? (0, $65e789322b24f25c$export$e19f37cdec813149).ASTC12x10UnormSRGB : (0, $65e789322b24f25c$export$e19f37cdec813149).ASTC12x10Unorm;
            break;
        case 0, $cb5ee595c0f892af$export$18ab77abd087e467:
            formatGPU = colorSpace === (0, $cb5ee595c0f892af$export$561f394b24edfcaa) ? (0, $65e789322b24f25c$export$e19f37cdec813149).ASTC12x12UnormSRGB : (0, $65e789322b24f25c$export$e19f37cdec813149).ASTC12x12Unorm;
            break;
        default:
            console.error('WebGPURenderer: Unsupported texture format.', format);
    }
    else switch(format){
        case 0, $cb5ee595c0f892af$export$3f8bb04b555a363c:
            switch(type){
                case 0, $cb5ee595c0f892af$export$545fce0311a9796a:
                    formatGPU = (0, $65e789322b24f25c$export$e19f37cdec813149).RGBA8Snorm;
                    break;
                case 0, $cb5ee595c0f892af$export$88572337f312435f:
                    formatGPU = (0, $65e789322b24f25c$export$e19f37cdec813149).RGBA16Sint;
                    break;
                case 0, $cb5ee595c0f892af$export$c63dc51868b06a9d:
                    formatGPU = (0, $65e789322b24f25c$export$e19f37cdec813149).RGBA16Uint;
                    break;
                case 0, $cb5ee595c0f892af$export$c3c7fc4518ebba96:
                    formatGPU = (0, $65e789322b24f25c$export$e19f37cdec813149).RGBA32Uint;
                    break;
                case 0, $cb5ee595c0f892af$export$5c612977753abe2:
                    formatGPU = (0, $65e789322b24f25c$export$e19f37cdec813149).RGBA32Sint;
                    break;
                case 0, $cb5ee595c0f892af$export$2e8ce08d3f6f5e10:
                    formatGPU = colorSpace === (0, $cb5ee595c0f892af$export$561f394b24edfcaa) ? (0, $65e789322b24f25c$export$e19f37cdec813149).RGBA8UnormSRGB : (0, $65e789322b24f25c$export$e19f37cdec813149).RGBA8Unorm;
                    break;
                case 0, $cb5ee595c0f892af$export$2697304443f382bc:
                    formatGPU = (0, $65e789322b24f25c$export$e19f37cdec813149).RGBA16Float;
                    break;
                case 0, $cb5ee595c0f892af$export$f6d331659b644596:
                    formatGPU = (0, $65e789322b24f25c$export$e19f37cdec813149).RGBA32Float;
                    break;
                default:
                    console.error('WebGPURenderer: Unsupported texture type with RGBAFormat.', type);
            }
            break;
        case 0, $cb5ee595c0f892af$export$7c67423a5ee6f5eb:
            switch(type){
                case 0, $cb5ee595c0f892af$export$5a4c329b7e2092d3:
                    formatGPU = (0, $65e789322b24f25c$export$e19f37cdec813149).RGB9E5UFloat;
                    break;
                default:
                    console.error('WebGPURenderer: Unsupported texture type with RGBFormat.', type);
            }
            break;
        case 0, $cb5ee595c0f892af$export$4e041a7967d15c4b:
            switch(type){
                case 0, $cb5ee595c0f892af$export$545fce0311a9796a:
                    formatGPU = (0, $65e789322b24f25c$export$e19f37cdec813149).R8Snorm;
                    break;
                case 0, $cb5ee595c0f892af$export$88572337f312435f:
                    formatGPU = (0, $65e789322b24f25c$export$e19f37cdec813149).R16Sint;
                    break;
                case 0, $cb5ee595c0f892af$export$c63dc51868b06a9d:
                    formatGPU = (0, $65e789322b24f25c$export$e19f37cdec813149).R16Uint;
                    break;
                case 0, $cb5ee595c0f892af$export$c3c7fc4518ebba96:
                    formatGPU = (0, $65e789322b24f25c$export$e19f37cdec813149).R32Uint;
                    break;
                case 0, $cb5ee595c0f892af$export$5c612977753abe2:
                    formatGPU = (0, $65e789322b24f25c$export$e19f37cdec813149).R32Sint;
                    break;
                case 0, $cb5ee595c0f892af$export$2e8ce08d3f6f5e10:
                    formatGPU = (0, $65e789322b24f25c$export$e19f37cdec813149).R8Unorm;
                    break;
                case 0, $cb5ee595c0f892af$export$2697304443f382bc:
                    formatGPU = (0, $65e789322b24f25c$export$e19f37cdec813149).R16Float;
                    break;
                case 0, $cb5ee595c0f892af$export$f6d331659b644596:
                    formatGPU = (0, $65e789322b24f25c$export$e19f37cdec813149).R32Float;
                    break;
                default:
                    console.error('WebGPURenderer: Unsupported texture type with RedFormat.', type);
            }
            break;
        case 0, $cb5ee595c0f892af$export$6cdf0b461c7ce8a0:
            switch(type){
                case 0, $cb5ee595c0f892af$export$545fce0311a9796a:
                    formatGPU = (0, $65e789322b24f25c$export$e19f37cdec813149).RG8Snorm;
                    break;
                case 0, $cb5ee595c0f892af$export$88572337f312435f:
                    formatGPU = (0, $65e789322b24f25c$export$e19f37cdec813149).RG16Sint;
                    break;
                case 0, $cb5ee595c0f892af$export$c63dc51868b06a9d:
                    formatGPU = (0, $65e789322b24f25c$export$e19f37cdec813149).RG16Uint;
                    break;
                case 0, $cb5ee595c0f892af$export$c3c7fc4518ebba96:
                    formatGPU = (0, $65e789322b24f25c$export$e19f37cdec813149).RG32Uint;
                    break;
                case 0, $cb5ee595c0f892af$export$5c612977753abe2:
                    formatGPU = (0, $65e789322b24f25c$export$e19f37cdec813149).RG32Sint;
                    break;
                case 0, $cb5ee595c0f892af$export$2e8ce08d3f6f5e10:
                    formatGPU = (0, $65e789322b24f25c$export$e19f37cdec813149).RG8Unorm;
                    break;
                case 0, $cb5ee595c0f892af$export$2697304443f382bc:
                    formatGPU = (0, $65e789322b24f25c$export$e19f37cdec813149).RG16Float;
                    break;
                case 0, $cb5ee595c0f892af$export$f6d331659b644596:
                    formatGPU = (0, $65e789322b24f25c$export$e19f37cdec813149).RG32Float;
                    break;
                default:
                    console.error('WebGPURenderer: Unsupported texture type with RGFormat.', type);
            }
            break;
        case 0, $cb5ee595c0f892af$export$c1b6b5136be58045:
            switch(type){
                case 0, $cb5ee595c0f892af$export$c63dc51868b06a9d:
                    formatGPU = (0, $65e789322b24f25c$export$e19f37cdec813149).Depth16Unorm;
                    break;
                case 0, $cb5ee595c0f892af$export$c3c7fc4518ebba96:
                    formatGPU = (0, $65e789322b24f25c$export$e19f37cdec813149).Depth24Plus;
                    break;
                case 0, $cb5ee595c0f892af$export$f6d331659b644596:
                    formatGPU = (0, $65e789322b24f25c$export$e19f37cdec813149).Depth32Float;
                    break;
                default:
                    console.error('WebGPURenderer: Unsupported texture type with DepthFormat.', type);
            }
            break;
        case 0, $cb5ee595c0f892af$export$1e113ac2d0905829:
            switch(type){
                case 0, $cb5ee595c0f892af$export$6c8ea339bfab1301:
                    formatGPU = (0, $65e789322b24f25c$export$e19f37cdec813149).Depth24PlusStencil8;
                    break;
                case 0, $cb5ee595c0f892af$export$f6d331659b644596:
                    if (device && device.features.has((0, $65e789322b24f25c$export$97a86f8b50a49c2b).Depth32FloatStencil8) === false) console.error('WebGPURenderer: Depth textures with DepthStencilFormat + FloatType can only be used with the "depth32float-stencil8" GPU feature.');
                    formatGPU = (0, $65e789322b24f25c$export$e19f37cdec813149).Depth32FloatStencil8;
                    break;
                default:
                    console.error('WebGPURenderer: Unsupported texture type with DepthStencilFormat.', type);
            }
            break;
        case 0, $cb5ee595c0f892af$export$aa92e870a709d190:
            switch(type){
                case 0, $cb5ee595c0f892af$export$5c612977753abe2:
                    formatGPU = (0, $65e789322b24f25c$export$e19f37cdec813149).R32Sint;
                    break;
                case 0, $cb5ee595c0f892af$export$c3c7fc4518ebba96:
                    formatGPU = (0, $65e789322b24f25c$export$e19f37cdec813149).R32Uint;
                    break;
                default:
                    console.error('WebGPURenderer: Unsupported texture type with RedIntegerFormat.', type);
            }
            break;
        case 0, $cb5ee595c0f892af$export$1ba1c45f9f77d4d7:
            switch(type){
                case 0, $cb5ee595c0f892af$export$5c612977753abe2:
                    formatGPU = (0, $65e789322b24f25c$export$e19f37cdec813149).RG32Sint;
                    break;
                case 0, $cb5ee595c0f892af$export$c3c7fc4518ebba96:
                    formatGPU = (0, $65e789322b24f25c$export$e19f37cdec813149).RG32Uint;
                    break;
                default:
                    console.error('WebGPURenderer: Unsupported texture type with RGIntegerFormat.', type);
            }
            break;
        case 0, $cb5ee595c0f892af$export$c200e7d26f592f21:
            switch(type){
                case 0, $cb5ee595c0f892af$export$5c612977753abe2:
                    formatGPU = (0, $65e789322b24f25c$export$e19f37cdec813149).RGBA32Sint;
                    break;
                case 0, $cb5ee595c0f892af$export$c3c7fc4518ebba96:
                    formatGPU = (0, $65e789322b24f25c$export$e19f37cdec813149).RGBA32Uint;
                    break;
                default:
                    console.error('WebGPURenderer: Unsupported texture type with RGBAIntegerFormat.', type);
            }
            break;
        default:
            console.error('WebGPURenderer: Unsupported texture format.', format);
    }
    return formatGPU;
}
var $39e424db81bbb213$export$2e2bcd8739ae039 = $39e424db81bbb213$var$WebGPUTextureUtils;





const $535bb279056f5458$var$declarationRegexp = /^[fn]*\s*([a-z_0-9]+)?\s*\(([\s\S]*?)\)\s*[\-\>]*\s*([a-z_0-9]+(?:<[\s\S]+?>)?)/i;
const $535bb279056f5458$var$propertiesRegexp = /([a-z_0-9]+)\s*:\s*([a-z_0-9]+(?:<[\s\S]+?>)?)/ig;
const $535bb279056f5458$var$wgslTypeLib = {
    'f32': 'float',
    'i32': 'int',
    'u32': 'uint',
    'bool': 'bool',
    'vec2<f32>': 'vec2',
    'vec2<i32>': 'ivec2',
    'vec2<u32>': 'uvec2',
    'vec2<bool>': 'bvec2',
    'vec2f': 'vec2',
    'vec2i': 'ivec2',
    'vec2u': 'uvec2',
    'vec2b': 'bvec2',
    'vec3<f32>': 'vec3',
    'vec3<i32>': 'ivec3',
    'vec3<u32>': 'uvec3',
    'vec3<bool>': 'bvec3',
    'vec3f': 'vec3',
    'vec3i': 'ivec3',
    'vec3u': 'uvec3',
    'vec3b': 'bvec3',
    'vec4<f32>': 'vec4',
    'vec4<i32>': 'ivec4',
    'vec4<u32>': 'uvec4',
    'vec4<bool>': 'bvec4',
    'vec4f': 'vec4',
    'vec4i': 'ivec4',
    'vec4u': 'uvec4',
    'vec4b': 'bvec4',
    'mat2x2<f32>': 'mat2',
    'mat2x2f': 'mat2',
    'mat3x3<f32>': 'mat3',
    'mat3x3f': 'mat3',
    'mat4x4<f32>': 'mat4',
    'mat4x4f': 'mat4',
    'sampler': 'sampler',
    'texture_1d': 'texture',
    'texture_2d': 'texture',
    'texture_2d_array': 'texture',
    'texture_multisampled_2d': 'cubeTexture',
    'texture_depth_2d': 'depthTexture',
    'texture_3d': 'texture3D',
    'texture_cube': 'cubeTexture',
    'texture_cube_array': 'cubeTexture',
    'texture_storage_1d': 'storageTexture',
    'texture_storage_2d': 'storageTexture',
    'texture_storage_2d_array': 'storageTexture',
    'texture_storage_3d': 'storageTexture'
};
const $535bb279056f5458$var$parse = (source)=>{
    source = source.trim();
    const declaration = source.match($535bb279056f5458$var$declarationRegexp);
    if (declaration !== null && declaration.length === 4) {
        const inputsCode = declaration[2];
        const propsMatches = [];
        let match = null;
        while((match = $535bb279056f5458$var$propertiesRegexp.exec(inputsCode)) !== null)propsMatches.push({
            name: match[1],
            type: match[2]
        });
        // Process matches to correctly pair names and types
        const inputs = [];
        for(let i = 0; i < propsMatches.length; i++){
            const { name: name, type: type } = propsMatches[i];
            let resolvedType = type;
            if (resolvedType.startsWith('ptr')) resolvedType = 'pointer';
            else {
                if (resolvedType.startsWith('texture')) resolvedType = type.split('<')[0];
                resolvedType = $535bb279056f5458$var$wgslTypeLib[resolvedType];
            }
            inputs.push(new (0, $e7717ae23c68650f$export$2e2bcd8739ae039)(resolvedType, name));
        }
        const blockCode = source.substring(declaration[0].length);
        const outputType = declaration[3] || 'void';
        const name = declaration[1] !== undefined ? declaration[1] : '';
        const type = $535bb279056f5458$var$wgslTypeLib[outputType] || outputType;
        return {
            type: type,
            inputs: inputs,
            name: name,
            inputsCode: inputsCode,
            blockCode: blockCode,
            outputType: outputType
        };
    } else throw new Error('FunctionNode: Function is not a WGSL code.');
};
class $535bb279056f5458$var$WGSLNodeFunction extends (0, $5bbb3bf76cd481f8$export$2e2bcd8739ae039) {
    constructor(source){
        const { type: type, inputs: inputs, name: name, inputsCode: inputsCode, blockCode: blockCode, outputType: outputType } = $535bb279056f5458$var$parse(source);
        super(type, inputs, name);
        this.inputsCode = inputsCode;
        this.blockCode = blockCode;
        this.outputType = outputType;
    }
    getCode(name = this.name) {
        const outputType = this.outputType !== 'void' ? '-> ' + this.outputType : '';
        return `fn ${name} ( ${this.inputsCode.trim()} ) ${outputType}` + this.blockCode;
    }
}
var $535bb279056f5458$export$2e2bcd8739ae039 = $535bb279056f5458$var$WGSLNodeFunction;


class $e0ef8ba37de78d9e$var$WGSLNodeParser extends (0, $a47b493dd7f0b4c2$export$2e2bcd8739ae039) {
    parseFunction(source) {
        return new (0, $535bb279056f5458$export$2e2bcd8739ae039)(source);
    }
}
var $e0ef8ba37de78d9e$export$2e2bcd8739ae039 = $e0ef8ba37de78d9e$var$WGSLNodeParser;




// GPUShaderStage is not defined in browsers not supporting WebGPU
const $59f98e181a42e0a2$var$GPUShaderStage = self.GPUShaderStage;
const $59f98e181a42e0a2$var$gpuShaderStageLib = {
    'vertex': $59f98e181a42e0a2$var$GPUShaderStage ? $59f98e181a42e0a2$var$GPUShaderStage.VERTEX : 1,
    'fragment': $59f98e181a42e0a2$var$GPUShaderStage ? $59f98e181a42e0a2$var$GPUShaderStage.FRAGMENT : 2,
    'compute': $59f98e181a42e0a2$var$GPUShaderStage ? $59f98e181a42e0a2$var$GPUShaderStage.COMPUTE : 4
};
const $59f98e181a42e0a2$var$supports = {
    instance: true,
    swizzleAssign: false,
    storageBuffer: true
};
const $59f98e181a42e0a2$var$wgslFnOpLib = {
    '^^': 'tsl_xor'
};
const $59f98e181a42e0a2$var$wgslTypeLib = {
    float: 'f32',
    int: 'i32',
    uint: 'u32',
    bool: 'bool',
    color: 'vec3<f32>',
    vec2: 'vec2<f32>',
    ivec2: 'vec2<i32>',
    uvec2: 'vec2<u32>',
    bvec2: 'vec2<bool>',
    vec3: 'vec3<f32>',
    ivec3: 'vec3<i32>',
    uvec3: 'vec3<u32>',
    bvec3: 'vec3<bool>',
    vec4: 'vec4<f32>',
    ivec4: 'vec4<i32>',
    uvec4: 'vec4<u32>',
    bvec4: 'vec4<bool>',
    mat2: 'mat2x2<f32>',
    mat3: 'mat3x3<f32>',
    mat4: 'mat4x4<f32>'
};
const $59f98e181a42e0a2$var$wgslPolyfill = {
    tsl_xor: new (0, $6ab1fbe365a50a7b$export$2e2bcd8739ae039)('fn tsl_xor( a : bool, b : bool ) -> bool { return ( a || b ) && !( a && b ); }'),
    mod_float: new (0, $6ab1fbe365a50a7b$export$2e2bcd8739ae039)('fn tsl_mod_float( x : f32, y : f32 ) -> f32 { return x - y * floor( x / y ); }'),
    mod_vec2: new (0, $6ab1fbe365a50a7b$export$2e2bcd8739ae039)('fn tsl_mod_vec2( x : vec2f, y : vec2f ) -> vec2f { return x - y * floor( x / y ); }'),
    mod_vec3: new (0, $6ab1fbe365a50a7b$export$2e2bcd8739ae039)('fn tsl_mod_vec3( x : vec3f, y : vec3f ) -> vec3f { return x - y * floor( x / y ); }'),
    mod_vec4: new (0, $6ab1fbe365a50a7b$export$2e2bcd8739ae039)('fn tsl_mod_vec4( x : vec4f, y : vec4f ) -> vec4f { return x - y * floor( x / y ); }'),
    equals_bool: new (0, $6ab1fbe365a50a7b$export$2e2bcd8739ae039)('fn tsl_equals_bool( a : bool, b : bool ) -> bool { return a == b; }'),
    equals_bvec2: new (0, $6ab1fbe365a50a7b$export$2e2bcd8739ae039)('fn tsl_equals_bvec2( a : vec2f, b : vec2f ) -> vec2<bool> { return vec2<bool>( a.x == b.x, a.y == b.y ); }'),
    equals_bvec3: new (0, $6ab1fbe365a50a7b$export$2e2bcd8739ae039)('fn tsl_equals_bvec3( a : vec3f, b : vec3f ) -> vec3<bool> { return vec3<bool>( a.x == b.x, a.y == b.y, a.z == b.z ); }'),
    equals_bvec4: new (0, $6ab1fbe365a50a7b$export$2e2bcd8739ae039)('fn tsl_equals_bvec4( a : vec4f, b : vec4f ) -> vec4<bool> { return vec4<bool>( a.x == b.x, a.y == b.y, a.z == b.z, a.w == b.w ); }'),
    repeatWrapping: new (0, $6ab1fbe365a50a7b$export$2e2bcd8739ae039)(/* wgsl */ `
fn tsl_repeatWrapping( uv : vec2<f32>, dimension : vec2<u32> ) -> vec2<u32> {

	let uvScaled = vec2<u32>( uv * vec2<f32>( dimension ) );

	return ( ( uvScaled % dimension ) + dimension ) % dimension;

}
`),
    biquadraticTexture: new (0, $6ab1fbe365a50a7b$export$2e2bcd8739ae039)(/* wgsl */ `
fn tsl_biquadraticTexture( map : texture_2d<f32>, coord : vec2f, level : i32 ) -> vec4f {

	let iRes = vec2i( textureDimensions( map, level ) );
	let res = vec2f( iRes );

	let uvScaled = coord * res;
	let uvWrapping = ( ( uvScaled % res ) + res ) % res;

	// https://www.shadertoy.com/view/WtyXRy

	let uv = uvWrapping - 0.5;
	let iuv = floor( uv );
	let f = fract( uv );

	let rg1 = textureLoad( map, vec2i( iuv + vec2( 0.5, 0.5 ) ) % iRes, level );
	let rg2 = textureLoad( map, vec2i( iuv + vec2( 1.5, 0.5 ) ) % iRes, level );
	let rg3 = textureLoad( map, vec2i( iuv + vec2( 0.5, 1.5 ) ) % iRes, level );
	let rg4 = textureLoad( map, vec2i( iuv + vec2( 1.5, 1.5 ) ) % iRes, level );

	return mix( mix( rg1, rg2, f.x ), mix( rg3, rg4, f.x ), f.y );

}
`)
};
const $59f98e181a42e0a2$var$wgslMethods = {
    dFdx: 'dpdx',
    dFdy: '- dpdy',
    mod_float: 'tsl_mod_float',
    mod_vec2: 'tsl_mod_vec2',
    mod_vec3: 'tsl_mod_vec3',
    mod_vec4: 'tsl_mod_vec4',
    equals_bool: 'tsl_equals_bool',
    equals_bvec2: 'tsl_equals_bvec2',
    equals_bvec3: 'tsl_equals_bvec3',
    equals_bvec4: 'tsl_equals_bvec4',
    inversesqrt: 'inverseSqrt',
    bitcast: 'bitcast<f32>'
};
// WebGPU issue: does not support pow() with negative base on Windows
if (/Windows/g.test(navigator.userAgent)) {
    $59f98e181a42e0a2$var$wgslPolyfill.pow_float = new (0, $6ab1fbe365a50a7b$export$2e2bcd8739ae039)('fn tsl_pow_float( a : f32, b : f32 ) -> f32 { return select( -pow( -a, b ), pow( a, b ), a > 0.0 ); }');
    $59f98e181a42e0a2$var$wgslPolyfill.pow_vec2 = new (0, $6ab1fbe365a50a7b$export$2e2bcd8739ae039)('fn tsl_pow_vec2( a : vec2f, b : vec2f ) -> vec2f { return vec2f( tsl_pow_float( a.x, b.x ), tsl_pow_float( a.y, b.y ) ); }', [
        $59f98e181a42e0a2$var$wgslPolyfill.pow_float
    ]);
    $59f98e181a42e0a2$var$wgslPolyfill.pow_vec3 = new (0, $6ab1fbe365a50a7b$export$2e2bcd8739ae039)('fn tsl_pow_vec3( a : vec3f, b : vec3f ) -> vec3f { return vec3f( tsl_pow_float( a.x, b.x ), tsl_pow_float( a.y, b.y ), tsl_pow_float( a.z, b.z ) ); }', [
        $59f98e181a42e0a2$var$wgslPolyfill.pow_float
    ]);
    $59f98e181a42e0a2$var$wgslPolyfill.pow_vec4 = new (0, $6ab1fbe365a50a7b$export$2e2bcd8739ae039)('fn tsl_pow_vec4( a : vec4f, b : vec4f ) -> vec4f { return vec4f( tsl_pow_float( a.x, b.x ), tsl_pow_float( a.y, b.y ), tsl_pow_float( a.z, b.z ), tsl_pow_float( a.w, b.w ) ); }', [
        $59f98e181a42e0a2$var$wgslPolyfill.pow_float
    ]);
    $59f98e181a42e0a2$var$wgslMethods.pow_float = 'tsl_pow_float';
    $59f98e181a42e0a2$var$wgslMethods.pow_vec2 = 'tsl_pow_vec2';
    $59f98e181a42e0a2$var$wgslMethods.pow_vec3 = 'tsl_pow_vec3';
    $59f98e181a42e0a2$var$wgslMethods.pow_vec4 = 'tsl_pow_vec4';
}
//
let $59f98e181a42e0a2$var$diagnostics = '';
if (/Firefox|Deno/g.test(navigator.userAgent) !== true) $59f98e181a42e0a2$var$diagnostics += 'diagnostic( off, derivative_uniformity );\n';
//
class $59f98e181a42e0a2$var$WGSLNodeBuilder extends (0, $3ac2b0a498e221c7$export$2e2bcd8739ae039) {
    constructor(object, renderer){
        super(object, renderer, new (0, $e0ef8ba37de78d9e$export$2e2bcd8739ae039)());
        this.uniformGroups = {};
        this.builtins = {};
        this.directives = {};
        this.scopedArrays = new Map();
    }
    needsToWorkingColorSpace(texture) {
        return texture.isVideoTexture === true && texture.colorSpace !== (0, $cb5ee595c0f892af$export$bfcb490c2dd3db51);
    }
    _generateTextureSample(texture, textureProperty, uvSnippet, depthSnippet, shaderStage = this.shaderStage) {
        if (shaderStage === 'fragment') {
            if (depthSnippet) return `textureSample( ${textureProperty}, ${textureProperty}_sampler, ${uvSnippet}, ${depthSnippet} )`;
            else return `textureSample( ${textureProperty}, ${textureProperty}_sampler, ${uvSnippet} )`;
        } else if (this.isFilteredTexture(texture)) return this.generateFilteredTexture(texture, textureProperty, uvSnippet);
        else return this.generateTextureLod(texture, textureProperty, uvSnippet, '0');
    }
    _generateVideoSample(textureProperty, uvSnippet, shaderStage = this.shaderStage) {
        if (shaderStage === 'fragment') return `textureSampleBaseClampToEdge( ${textureProperty}, ${textureProperty}_sampler, vec2<f32>( ${uvSnippet}.x, 1.0 - ${uvSnippet}.y ) )`;
        else console.error(`WebGPURenderer: THREE.VideoTexture does not support ${shaderStage} shader.`);
    }
    _generateTextureSampleLevel(texture, textureProperty, uvSnippet, levelSnippet, depthSnippet, shaderStage = this.shaderStage) {
        if (shaderStage === 'fragment' && this.isUnfilterable(texture) === false) return `textureSampleLevel( ${textureProperty}, ${textureProperty}_sampler, ${uvSnippet}, ${levelSnippet} )`;
        else if (this.isFilteredTexture(texture)) return this.generateFilteredTexture(texture, textureProperty, uvSnippet, levelSnippet);
        else return this.generateTextureLod(texture, textureProperty, uvSnippet, levelSnippet);
    }
    generateFilteredTexture(texture, textureProperty, uvSnippet, levelSnippet = '0') {
        this._include('biquadraticTexture');
        return `tsl_biquadraticTexture( ${textureProperty}, ${uvSnippet}, i32( ${levelSnippet} ) )`;
    }
    generateTextureLod(texture, textureProperty, uvSnippet, levelSnippet = '0') {
        this._include('repeatWrapping');
        const dimension = texture.isMultisampleRenderTargetTexture === true ? `textureDimensions( ${textureProperty} )` : `textureDimensions( ${textureProperty}, 0 )`;
        return `textureLoad( ${textureProperty}, tsl_repeatWrapping( ${uvSnippet}, ${dimension} ), i32( ${levelSnippet} ) )`;
    }
    generateTextureLoad(texture, textureProperty, uvIndexSnippet, depthSnippet, levelSnippet = '0u') {
        if (depthSnippet) return `textureLoad( ${textureProperty}, ${uvIndexSnippet}, ${depthSnippet}, ${levelSnippet} )`;
        else return `textureLoad( ${textureProperty}, ${uvIndexSnippet}, ${levelSnippet} )`;
    }
    generateTextureStore(texture, textureProperty, uvIndexSnippet, valueSnippet) {
        return `textureStore( ${textureProperty}, ${uvIndexSnippet}, ${valueSnippet} )`;
    }
    isUnfilterable(texture) {
        return this.getComponentTypeFromTexture(texture) !== 'float' || !this.isAvailable('float32Filterable') && texture.isDataTexture === true && texture.type === (0, $cb5ee595c0f892af$export$f6d331659b644596) || texture.isMultisampleRenderTargetTexture === true;
    }
    generateTexture(texture, textureProperty, uvSnippet, depthSnippet, shaderStage = this.shaderStage) {
        let snippet = null;
        if (texture.isVideoTexture === true) snippet = this._generateVideoSample(textureProperty, uvSnippet, shaderStage);
        else if (this.isUnfilterable(texture)) snippet = this.generateTextureLod(texture, textureProperty, uvSnippet, '0', depthSnippet, shaderStage);
        else snippet = this._generateTextureSample(texture, textureProperty, uvSnippet, depthSnippet, shaderStage);
        return snippet;
    }
    generateTextureGrad(texture, textureProperty, uvSnippet, gradSnippet, depthSnippet, shaderStage = this.shaderStage) {
        if (shaderStage === 'fragment') // TODO handle i32 or u32 --> uvSnippet, array_index: A, ddx, ddy
        return `textureSampleGrad( ${textureProperty}, ${textureProperty}_sampler, ${uvSnippet},  ${gradSnippet[0]}, ${gradSnippet[1]} )`;
        else console.error(`WebGPURenderer: THREE.TextureNode.gradient() does not support ${shaderStage} shader.`);
    }
    generateTextureCompare(texture, textureProperty, uvSnippet, compareSnippet, depthSnippet, shaderStage = this.shaderStage) {
        if (shaderStage === 'fragment') return `textureSampleCompare( ${textureProperty}, ${textureProperty}_sampler, ${uvSnippet}, ${compareSnippet} )`;
        else console.error(`WebGPURenderer: THREE.DepthTexture.compareFunction() does not support ${shaderStage} shader.`);
    }
    generateTextureLevel(texture, textureProperty, uvSnippet, levelSnippet, depthSnippet, shaderStage = this.shaderStage) {
        let snippet = null;
        if (texture.isVideoTexture === true) snippet = this._generateVideoSample(textureProperty, uvSnippet, shaderStage);
        else snippet = this._generateTextureSampleLevel(texture, textureProperty, uvSnippet, levelSnippet, depthSnippet, shaderStage);
        return snippet;
    }
    generateTextureBias(texture, textureProperty, uvSnippet, biasSnippet, depthSnippet, shaderStage = this.shaderStage) {
        if (shaderStage === 'fragment') return `textureSampleBias( ${textureProperty}, ${textureProperty}_sampler, ${uvSnippet}, ${biasSnippet} )`;
        else console.error(`WebGPURenderer: THREE.TextureNode.biasNode does not support ${shaderStage} shader.`);
    }
    getPropertyName(node, shaderStage = this.shaderStage) {
        if (node.isNodeVarying === true && node.needsInterpolation === true) {
            if (shaderStage === 'vertex') return `varyings.${node.name}`;
        } else if (node.isNodeUniform === true) {
            const name = node.name;
            const type = node.type;
            if (type === 'texture' || type === 'cubeTexture' || type === 'storageTexture' || type === 'texture3D') return name;
            else if (type === 'buffer' || type === 'storageBuffer' || type === 'indirectStorageBuffer') return `NodeBuffer_${node.id}.${name}`;
            else return node.groupNode.name + '.' + name;
        }
        return super.getPropertyName(node);
    }
    getOutputStructName() {
        return 'output';
    }
    _getUniformGroupCount(shaderStage) {
        return Object.keys(this.uniforms[shaderStage]).length;
    }
    getFunctionOperator(op) {
        const fnOp = $59f98e181a42e0a2$var$wgslFnOpLib[op];
        if (fnOp !== undefined) {
            this._include(fnOp);
            return fnOp;
        }
        return null;
    }
    getStorageAccess(node) {
        if (node.isStorageTextureNode) switch(node.access){
            case (0, $65e789322b24f25c$export$1d4987105a935841).ReadOnly:
                return 'read';
            case (0, $65e789322b24f25c$export$1d4987105a935841).WriteOnly:
                return 'write';
            default:
                return 'read_write';
        }
        else switch(node.access){
            case (0, $65e789322b24f25c$export$1fafb3ddf4a8fbc0).Storage:
                return 'read_write';
            case (0, $65e789322b24f25c$export$1fafb3ddf4a8fbc0).ReadOnlyStorage:
                return 'read';
            default:
                return 'write';
        }
    }
    getUniformFromNode(node, type, shaderStage, name = null) {
        const uniformNode = super.getUniformFromNode(node, type, shaderStage, name);
        const nodeData = this.getDataFromNode(node, shaderStage, this.globalCache);
        if (nodeData.uniformGPU === undefined) {
            let uniformGPU;
            const group = node.groupNode;
            const groupName = group.name;
            const bindings = this.getBindGroupArray(groupName, shaderStage);
            if (type === 'texture' || type === 'cubeTexture' || type === 'storageTexture' || type === 'texture3D') {
                let texture = null;
                if (type === 'texture' || type === 'storageTexture') texture = new (0, $10c17ea0e2041e51$export$aa8de3dc7ba6e062)(uniformNode.name, uniformNode.node, group, node.access ? node.access : null);
                else if (type === 'cubeTexture') texture = new (0, $10c17ea0e2041e51$export$43e0cf75b8e20ded)(uniformNode.name, uniformNode.node, group, node.access ? node.access : null);
                else if (type === 'texture3D') texture = new (0, $10c17ea0e2041e51$export$646279b2b7dbb3b7)(uniformNode.name, uniformNode.node, group, node.access ? node.access : null);
                texture.store = node.isStorageTextureNode === true;
                texture.setVisibility($59f98e181a42e0a2$var$gpuShaderStageLib[shaderStage]);
                if (shaderStage === 'fragment' && this.isUnfilterable(node.value) === false && texture.store === false) {
                    const sampler = new (0, $b1ef4ffdc54c3c25$export$2e2bcd8739ae039)(`${uniformNode.name}_sampler`, uniformNode.node, group);
                    sampler.setVisibility($59f98e181a42e0a2$var$gpuShaderStageLib[shaderStage]);
                    bindings.push(sampler, texture);
                    uniformGPU = [
                        sampler,
                        texture
                    ];
                } else {
                    bindings.push(texture);
                    uniformGPU = [
                        texture
                    ];
                }
            } else if (type === 'buffer' || type === 'storageBuffer' || type === 'indirectStorageBuffer') {
                const bufferClass = type === 'buffer' ? (0, $acea95d61477db49$export$2e2bcd8739ae039) : (0, $f41997a49c56b6ed$export$2e2bcd8739ae039);
                const buffer = new bufferClass(node, group);
                buffer.setVisibility($59f98e181a42e0a2$var$gpuShaderStageLib[shaderStage]);
                bindings.push(buffer);
                uniformGPU = buffer;
            } else {
                const uniformsStage = this.uniformGroups[shaderStage] || (this.uniformGroups[shaderStage] = {});
                let uniformsGroup = uniformsStage[groupName];
                if (uniformsGroup === undefined) {
                    uniformsGroup = new (0, $859d0a2a1eca4de4$export$2e2bcd8739ae039)(groupName, group);
                    uniformsGroup.setVisibility($59f98e181a42e0a2$var$gpuShaderStageLib[shaderStage]);
                    uniformsStage[groupName] = uniformsGroup;
                    bindings.push(uniformsGroup);
                }
                uniformGPU = this.getNodeUniform(uniformNode, type);
                uniformsGroup.addUniform(uniformGPU);
            }
            nodeData.uniformGPU = uniformGPU;
        }
        return uniformNode;
    }
    getBuiltin(name, property, type, shaderStage = this.shaderStage) {
        const map = this.builtins[shaderStage] || (this.builtins[shaderStage] = new Map());
        if (map.has(name) === false) map.set(name, {
            name: name,
            property: property,
            type: type
        });
        return property;
    }
    hasBuiltin(name, shaderStage = this.shaderStage) {
        return this.builtins[shaderStage] !== undefined && this.builtins[shaderStage].has(name);
    }
    getVertexIndex() {
        if (this.shaderStage === 'vertex') return this.getBuiltin('vertex_index', 'vertexIndex', 'u32', 'attribute');
        return 'vertexIndex';
    }
    buildFunctionCode(shaderNode) {
        const layout = shaderNode.layout;
        const flowData = this.flowShaderNode(shaderNode);
        const parameters = [];
        for (const input of layout.inputs)parameters.push(input.name + ' : ' + this.getType(input.type));
        //
        let code = `fn ${layout.name}( ${parameters.join(', ')} ) -> ${this.getType(layout.type)} {
${flowData.vars}
${flowData.code}
`;
        if (flowData.result) code += `\treturn ${flowData.result};\n`;
        code += '\n}\n';
        //
        return code;
    }
    getInstanceIndex() {
        if (this.shaderStage === 'vertex') return this.getBuiltin('instance_index', 'instanceIndex', 'u32', 'attribute');
        return 'instanceIndex';
    }
    getInvocationLocalIndex() {
        return this.getBuiltin('local_invocation_index', 'invocationLocalIndex', 'u32', 'attribute');
    }
    getSubgroupSize() {
        this.enableSubGroups();
        return this.getBuiltin('subgroup_size', 'subgroupSize', 'u32', 'attribute');
    }
    getInvocationSubgroupIndex() {
        this.enableSubGroups();
        return this.getBuiltin('subgroup_invocation_id', 'invocationSubgroupIndex', 'u32', 'attribute');
    }
    getSubgroupIndex() {
        this.enableSubGroups();
        return this.getBuiltin('subgroup_id', 'subgroupIndex', 'u32', 'attribute');
    }
    getDrawIndex() {
        return null;
    }
    getFrontFacing() {
        return this.getBuiltin('front_facing', 'isFront', 'bool');
    }
    getFragCoord() {
        return this.getBuiltin('position', 'fragCoord', 'vec4<f32>') + '.xy';
    }
    getFragDepth() {
        return 'output.' + this.getBuiltin('frag_depth', 'depth', 'f32', 'output');
    }
    isFlipY() {
        return false;
    }
    enableDirective(name, shaderStage = this.shaderStage) {
        const stage = this.directives[shaderStage] || (this.directives[shaderStage] = new Set());
        stage.add(name);
    }
    getDirectives(shaderStage) {
        const snippets = [];
        const directives = this.directives[shaderStage];
        if (directives !== undefined) for (const directive of directives)snippets.push(`enable ${directive};`);
        return snippets.join('\n');
    }
    enableSubGroups() {
        this.enableDirective('subgroups');
    }
    enableSubgroupsF16() {
        this.enableDirective('subgroups-f16');
    }
    enableClipDistances() {
        this.enableDirective('clip_distances');
    }
    enableShaderF16() {
        this.enableDirective('f16');
    }
    enableDualSourceBlending() {
        this.enableDirective('dual_source_blending');
    }
    getBuiltins(shaderStage) {
        const snippets = [];
        const builtins = this.builtins[shaderStage];
        if (builtins !== undefined) for (const { name: name, property: property, type: type } of builtins.values())snippets.push(`@builtin( ${name} ) ${property} : ${type}`);
        return snippets.join(',\n\t');
    }
    getScopedArray(name, scope, bufferType, bufferCount) {
        if (this.scopedArrays.has(name) === false) this.scopedArrays.set(name, {
            name: name,
            scope: scope,
            bufferType: bufferType,
            bufferCount: bufferCount
        });
        return name;
    }
    getScopedArrays(shaderStage) {
        if (shaderStage !== 'compute') return;
        const snippets = [];
        for (const { name: name, scope: scope, bufferType: bufferType, bufferCount: bufferCount } of this.scopedArrays.values()){
            const type = this.getType(bufferType);
            snippets.push(`var<${scope}> ${name}: array< ${type}, ${bufferCount} >;`);
        }
        return snippets.join('\n');
    }
    getAttributes(shaderStage) {
        const snippets = [];
        if (shaderStage === 'compute') {
            this.getBuiltin('global_invocation_id', 'id', 'vec3<u32>', 'attribute');
            this.getBuiltin('workgroup_id', 'workgroupId', 'vec3<u32>', 'attribute');
            this.getBuiltin('local_invocation_id', 'localId', 'vec3<u32>', 'attribute');
            this.getBuiltin('num_workgroups', 'numWorkgroups', 'vec3<u32>', 'attribute');
            if (this.renderer.hasFeature('subgroups')) {
                this.enableDirective('subgroups', shaderStage);
                this.getBuiltin('subgroup_size', 'subgroupSize', 'u32', 'attribute');
            }
        }
        if (shaderStage === 'vertex' || shaderStage === 'compute') {
            const builtins = this.getBuiltins('attribute');
            if (builtins) snippets.push(builtins);
            const attributes = this.getAttributesArray();
            for(let index = 0, length = attributes.length; index < length; index++){
                const attribute = attributes[index];
                const name = attribute.name;
                const type = this.getType(attribute.type);
                snippets.push(`@location( ${index} ) ${name} : ${type}`);
            }
        }
        return snippets.join(',\n\t');
    }
    getStructMembers(struct) {
        const snippets = [];
        const members = struct.getMemberTypes();
        for(let i = 0; i < members.length; i++){
            const member = members[i];
            snippets.push(`\t@location( ${i} ) m${i} : ${member}<f32>`);
        }
        const builtins = this.getBuiltins('output');
        if (builtins) snippets.push('\t' + builtins);
        return snippets.join(',\n');
    }
    getStructs(shaderStage) {
        const snippets = [];
        const structs = this.structs[shaderStage];
        for(let index = 0, length = structs.length; index < length; index++){
            const struct = structs[index];
            const name = struct.name;
            let snippet = `\struct ${name} {\n`;
            snippet += this.getStructMembers(struct);
            snippet += '\n}';
            snippets.push(snippet);
            snippets.push(`\nvar<private> output : ${name};\n\n`);
        }
        return snippets.join('\n\n');
    }
    getVar(type, name) {
        return `var ${name} : ${this.getType(type)}`;
    }
    getVars(shaderStage) {
        const snippets = [];
        const vars = this.vars[shaderStage];
        if (vars !== undefined) for (const variable of vars)snippets.push(`\t${this.getVar(variable.type, variable.name)};`);
        return `\n${snippets.join('\n')}\n`;
    }
    getVaryings(shaderStage) {
        const snippets = [];
        if (shaderStage === 'vertex') this.getBuiltin('position', 'Vertex', 'vec4<f32>', 'vertex');
        if (shaderStage === 'vertex' || shaderStage === 'fragment') {
            const varyings = this.varyings;
            const vars = this.vars[shaderStage];
            for(let index = 0; index < varyings.length; index++){
                const varying = varyings[index];
                if (varying.needsInterpolation) {
                    let attributesSnippet = `@location( ${index} )`;
                    if (/^(int|uint|ivec|uvec)/.test(varying.type)) attributesSnippet += ' @interpolate( flat )';
                    snippets.push(`${attributesSnippet} ${varying.name} : ${this.getType(varying.type)}`);
                } else if (shaderStage === 'vertex' && vars.includes(varying) === false) vars.push(varying);
            }
        }
        const builtins = this.getBuiltins(shaderStage);
        if (builtins) snippets.push(builtins);
        const code = snippets.join(',\n\t');
        return shaderStage === 'vertex' ? this._getWGSLStruct('VaryingsStruct', '\t' + code) : code;
    }
    getUniforms(shaderStage) {
        const uniforms = this.uniforms[shaderStage];
        const bindingSnippets = [];
        const bufferSnippets = [];
        const structSnippets = [];
        const uniformGroups = {};
        for (const uniform of uniforms){
            const groupName = uniform.groupNode.name;
            const uniformIndexes = this.bindingsIndexes[groupName];
            if (uniform.type === 'texture' || uniform.type === 'cubeTexture' || uniform.type === 'storageTexture' || uniform.type === 'texture3D') {
                const texture = uniform.node.value;
                if (shaderStage === 'fragment' && this.isUnfilterable(texture) === false && uniform.node.isStorageTextureNode !== true) {
                    if (texture.isDepthTexture === true && texture.compareFunction !== null) bindingSnippets.push(`@binding( ${uniformIndexes.binding++} ) @group( ${uniformIndexes.group} ) var ${uniform.name}_sampler : sampler_comparison;`);
                    else bindingSnippets.push(`@binding( ${uniformIndexes.binding++} ) @group( ${uniformIndexes.group} ) var ${uniform.name}_sampler : sampler;`);
                }
                let textureType;
                let multisampled = '';
                if (texture.isMultisampleRenderTargetTexture === true) multisampled = '_multisampled';
                if (texture.isCubeTexture === true) textureType = 'texture_cube<f32>';
                else if (texture.isDataArrayTexture === true || texture.isCompressedArrayTexture === true) textureType = 'texture_2d_array<f32>';
                else if (texture.isDepthTexture === true) textureType = `texture_depth${multisampled}_2d`;
                else if (texture.isVideoTexture === true) textureType = 'texture_external';
                else if (texture.isData3DTexture === true) textureType = 'texture_3d<f32>';
                else if (uniform.node.isStorageTextureNode === true) {
                    const format = (0, $39e424db81bbb213$export$f61ac8b6f1f46202)(texture);
                    const access = this.getStorageAccess(uniform.node);
                    textureType = `texture_storage_2d<${format}, ${access}>`;
                } else {
                    const componentPrefix = this.getComponentTypeFromTexture(texture).charAt(0);
                    textureType = `texture${multisampled}_2d<${componentPrefix}32>`;
                }
                bindingSnippets.push(`@binding( ${uniformIndexes.binding++} ) @group( ${uniformIndexes.group} ) var ${uniform.name} : ${textureType};`);
            } else if (uniform.type === 'buffer' || uniform.type === 'storageBuffer' || uniform.type === 'indirectStorageBuffer') {
                const bufferNode = uniform.node;
                const bufferType = this.getType(bufferNode.bufferType);
                const bufferCount = bufferNode.bufferCount;
                const bufferCountSnippet = bufferCount > 0 && uniform.type === 'buffer' ? ', ' + bufferCount : '';
                const bufferTypeSnippet = bufferNode.isAtomic ? `atomic<${bufferType}>` : `${bufferType}`;
                const bufferSnippet = `\t${uniform.name} : array< ${bufferTypeSnippet}${bufferCountSnippet} >\n`;
                const bufferAccessMode = bufferNode.isStorageBufferNode ? `storage, ${this.getStorageAccess(bufferNode)}` : 'uniform';
                bufferSnippets.push(this._getWGSLStructBinding('NodeBuffer_' + bufferNode.id, bufferSnippet, bufferAccessMode, uniformIndexes.binding++, uniformIndexes.group));
            } else {
                const vectorType = this.getType(this.getVectorType(uniform.type));
                const groupName = uniform.groupNode.name;
                const group = uniformGroups[groupName] || (uniformGroups[groupName] = {
                    index: uniformIndexes.binding++,
                    id: uniformIndexes.group,
                    snippets: []
                });
                group.snippets.push(`\t${uniform.name} : ${vectorType}`);
            }
        }
        for(const name in uniformGroups){
            const group = uniformGroups[name];
            structSnippets.push(this._getWGSLStructBinding(name, group.snippets.join(',\n'), 'uniform', group.index, group.id));
        }
        let code = bindingSnippets.join('\n');
        code += bufferSnippets.join('\n');
        code += structSnippets.join('\n');
        return code;
    }
    buildCode() {
        const shadersData = this.material !== null ? {
            fragment: {},
            vertex: {}
        } : {
            compute: {}
        };
        this.sortBindingGroups();
        for(const shaderStage in shadersData){
            const stageData = shadersData[shaderStage];
            stageData.uniforms = this.getUniforms(shaderStage);
            stageData.attributes = this.getAttributes(shaderStage);
            stageData.varyings = this.getVaryings(shaderStage);
            stageData.structs = this.getStructs(shaderStage);
            stageData.vars = this.getVars(shaderStage);
            stageData.codes = this.getCodes(shaderStage);
            stageData.directives = this.getDirectives(shaderStage);
            stageData.scopedArrays = this.getScopedArrays(shaderStage);
            //
            let flow = '// code\n\n';
            flow += this.flowCode[shaderStage];
            const flowNodes = this.flowNodes[shaderStage];
            const mainNode = flowNodes[flowNodes.length - 1];
            const outputNode = mainNode.outputNode;
            const isOutputStruct = outputNode !== undefined && outputNode.isOutputStructNode === true;
            for (const node of flowNodes){
                const flowSlotData = this.getFlowData(node /*, shaderStage*/ );
                const slotName = node.name;
                if (slotName) {
                    if (flow.length > 0) flow += '\n';
                    flow += `\t// flow -> ${slotName}\n\t`;
                }
                flow += `${flowSlotData.code}\n\t`;
                if (node === mainNode && shaderStage !== 'compute') {
                    flow += '// result\n\n\t';
                    if (shaderStage === 'vertex') flow += `varyings.Vertex = ${flowSlotData.result};`;
                    else if (shaderStage === 'fragment') {
                        if (isOutputStruct) {
                            stageData.returnType = outputNode.nodeType;
                            flow += `return ${flowSlotData.result};`;
                        } else {
                            let structSnippet = '\t@location(0) color: vec4<f32>';
                            const builtins = this.getBuiltins('output');
                            if (builtins) structSnippet += ',\n\t' + builtins;
                            stageData.returnType = 'OutputStruct';
                            stageData.structs += this._getWGSLStruct('OutputStruct', structSnippet);
                            stageData.structs += '\nvar<private> output : OutputStruct;\n\n';
                            flow += `output.color = ${flowSlotData.result};\n\n\treturn output;`;
                        }
                    }
                }
            }
            stageData.flow = flow;
        }
        if (this.material !== null) {
            this.vertexShader = this._getWGSLVertexCode(shadersData.vertex);
            this.fragmentShader = this._getWGSLFragmentCode(shadersData.fragment);
        } else this.computeShader = this._getWGSLComputeCode(shadersData.compute, (this.object.workgroupSize || [
            64
        ]).join(', '));
    }
    getMethod(method, output = null) {
        let wgslMethod;
        if (output !== null) wgslMethod = this._getWGSLMethod(method + '_' + output);
        if (wgslMethod === undefined) wgslMethod = this._getWGSLMethod(method);
        return wgslMethod || method;
    }
    getType(type) {
        return $59f98e181a42e0a2$var$wgslTypeLib[type] || type;
    }
    isAvailable(name) {
        let result = $59f98e181a42e0a2$var$supports[name];
        if (result === undefined) {
            if (name === 'float32Filterable') result = this.renderer.hasFeature('float32-filterable');
            $59f98e181a42e0a2$var$supports[name] = result;
        }
        return result;
    }
    _getWGSLMethod(method) {
        if ($59f98e181a42e0a2$var$wgslPolyfill[method] !== undefined) this._include(method);
        return $59f98e181a42e0a2$var$wgslMethods[method];
    }
    _include(name) {
        const codeNode = $59f98e181a42e0a2$var$wgslPolyfill[name];
        codeNode.build(this);
        if (this.currentFunctionNode !== null) this.currentFunctionNode.includes.push(codeNode);
        return codeNode;
    }
    _getWGSLVertexCode(shaderData) {
        return `${this.getSignature()}
// directives
${shaderData.directives}

// uniforms
${shaderData.uniforms}

// varyings
${shaderData.varyings}
var<private> varyings : VaryingsStruct;

// codes
${shaderData.codes}

@vertex
fn main( ${shaderData.attributes} ) -> VaryingsStruct {

	// vars
	${shaderData.vars}

	// flow
	${shaderData.flow}

	return varyings;

}
`;
    }
    _getWGSLFragmentCode(shaderData) {
        return `${this.getSignature()}
// global
${$59f98e181a42e0a2$var$diagnostics}

// uniforms
${shaderData.uniforms}

// structs
${shaderData.structs}

// codes
${shaderData.codes}

@fragment
fn main( ${shaderData.varyings} ) -> ${shaderData.returnType} {

	// vars
	${shaderData.vars}

	// flow
	${shaderData.flow}

}
`;
    }
    _getWGSLComputeCode(shaderData, workgroupSize) {
        return `${this.getSignature()}
// directives
${shaderData.directives}

// system
var<private> instanceIndex : u32;

// locals
${shaderData.scopedArrays}

// uniforms
${shaderData.uniforms}

// codes
${shaderData.codes}

@compute @workgroup_size( ${workgroupSize} )
fn main( ${shaderData.attributes} ) {

	// system
	instanceIndex = id.x + id.y * numWorkgroups.x * u32(${workgroupSize}) + id.z * numWorkgroups.x * numWorkgroups.y * u32(${workgroupSize});

	// vars
	${shaderData.vars}

	// flow
	${shaderData.flow}

}
`;
    }
    _getWGSLStruct(name, vars) {
        return `
struct ${name} {
${vars}
};`;
    }
    _getWGSLStructBinding(name, vars, access, binding = 0, group = 0) {
        const structName = name + 'Struct';
        const structSnippet = this._getWGSLStruct(structName, vars);
        return `${structSnippet}
@binding( ${binding} ) @group( ${group} )
var<${access}> ${name} : ${structName};`;
    }
}
var $59f98e181a42e0a2$export$2e2bcd8739ae039 = $59f98e181a42e0a2$var$WGSLNodeBuilder;




class $b6e5dc74d3252c2b$var$WebGPUUtils {
    constructor(backend){
        this.backend = backend;
    }
    getCurrentDepthStencilFormat(renderContext) {
        let format;
        if (renderContext.depthTexture !== null) format = this.getTextureFormatGPU(renderContext.depthTexture);
        else if (renderContext.depth && renderContext.stencil) format = (0, $65e789322b24f25c$export$e19f37cdec813149).Depth24PlusStencil8;
        else if (renderContext.depth) format = (0, $65e789322b24f25c$export$e19f37cdec813149).Depth24Plus;
        return format;
    }
    getTextureFormatGPU(texture) {
        return this.backend.get(texture).format;
    }
    getCurrentColorFormat(renderContext) {
        let format;
        if (renderContext.textures !== null) format = this.getTextureFormatGPU(renderContext.textures[0]);
        else format = this.getPreferredCanvasFormat(); // default context format
        return format;
    }
    getCurrentColorSpace(renderContext) {
        if (renderContext.textures !== null) return renderContext.textures[0].colorSpace;
        return this.backend.renderer.outputColorSpace;
    }
    getPrimitiveTopology(object, material) {
        if (object.isPoints) return (0, $65e789322b24f25c$export$ee82e1b1a0f4eece).PointList;
        else if (object.isLineSegments || object.isMesh && material.wireframe === true) return (0, $65e789322b24f25c$export$ee82e1b1a0f4eece).LineList;
        else if (object.isLine) return (0, $65e789322b24f25c$export$ee82e1b1a0f4eece).LineStrip;
        else if (object.isMesh) return (0, $65e789322b24f25c$export$ee82e1b1a0f4eece).TriangleList;
    }
    getSampleCount(sampleCount) {
        let count = 1;
        if (sampleCount > 1) {
            // WebGPU only supports power-of-two sample counts and 2 is not a valid value
            count = Math.pow(2, Math.floor(Math.log2(sampleCount)));
            if (count === 2) count = 4;
        }
        return count;
    }
    getSampleCountRenderContext(renderContext) {
        if (renderContext.textures !== null) return this.getSampleCount(renderContext.sampleCount);
        return this.getSampleCount(this.backend.renderer.samples);
    }
    getPreferredCanvasFormat() {
        // TODO: Remove this check when Quest 34.5 is out
        // https://github.com/mrdoob/three.js/pull/29221/files#r1731833949
        if (navigator.userAgent.includes('Quest')) return (0, $65e789322b24f25c$export$e19f37cdec813149).BGRA8Unorm;
        else return navigator.gpu.getPreferredCanvasFormat();
    }
}
var $b6e5dc74d3252c2b$export$2e2bcd8739ae039 = $b6e5dc74d3252c2b$var$WebGPUUtils;




const $ca9a29fd6a396b36$var$typedArraysToVertexFormatPrefix = new Map([
    [
        Int8Array,
        [
            'sint8',
            'snorm8'
        ]
    ],
    [
        Uint8Array,
        [
            'uint8',
            'unorm8'
        ]
    ],
    [
        Int16Array,
        [
            'sint16',
            'snorm16'
        ]
    ],
    [
        Uint16Array,
        [
            'uint16',
            'unorm16'
        ]
    ],
    [
        Int32Array,
        [
            'sint32',
            'snorm32'
        ]
    ],
    [
        Uint32Array,
        [
            'uint32',
            'unorm32'
        ]
    ],
    [
        Float32Array,
        [
            'float32'
        ]
    ]
]);
const $ca9a29fd6a396b36$var$typedAttributeToVertexFormatPrefix = new Map([
    [
        (0, $4b03383e684869fb$export$dbd3698c64958d69),
        [
            'float16'
        ]
    ]
]);
const $ca9a29fd6a396b36$var$typeArraysToVertexFormatPrefixForItemSize1 = new Map([
    [
        Int32Array,
        'sint32'
    ],
    [
        Int16Array,
        'sint32'
    ],
    [
        Uint32Array,
        'uint32'
    ],
    [
        Uint16Array,
        'uint32'
    ],
    [
        Float32Array,
        'float32'
    ]
]);
class $ca9a29fd6a396b36$var$WebGPUAttributeUtils {
    constructor(backend){
        this.backend = backend;
    }
    createAttribute(attribute, usage) {
        const bufferAttribute = this._getBufferAttribute(attribute);
        const backend = this.backend;
        const bufferData = backend.get(bufferAttribute);
        let buffer = bufferData.buffer;
        if (buffer === undefined) {
            const device = backend.device;
            let array = bufferAttribute.array;
            // patch for INT16 and UINT16
            if (attribute.normalized === false && (array.constructor === Int16Array || array.constructor === Uint16Array)) {
                const tempArray = new Uint32Array(array.length);
                for(let i = 0; i < array.length; i++)tempArray[i] = array[i];
                array = tempArray;
            }
            bufferAttribute.array = array;
            if ((bufferAttribute.isStorageBufferAttribute || bufferAttribute.isStorageInstancedBufferAttribute) && bufferAttribute.itemSize === 3) {
                array = new array.constructor(bufferAttribute.count * 4);
                for(let i = 0; i < bufferAttribute.count; i++)array.set(bufferAttribute.array.subarray(i * 3, i * 3 + 3), i * 4);
                // Update BufferAttribute
                bufferAttribute.itemSize = 4;
                bufferAttribute.array = array;
            }
            const size = array.byteLength + (4 - array.byteLength % 4) % 4; // ensure 4 byte alignment, see #20441
            buffer = device.createBuffer({
                label: bufferAttribute.name,
                size: size,
                usage: usage,
                mappedAtCreation: true
            });
            new array.constructor(buffer.getMappedRange()).set(array);
            buffer.unmap();
            bufferData.buffer = buffer;
        }
    }
    updateAttribute(attribute) {
        const bufferAttribute = this._getBufferAttribute(attribute);
        const backend = this.backend;
        const device = backend.device;
        const buffer = backend.get(bufferAttribute).buffer;
        const array = bufferAttribute.array;
        const updateRanges = bufferAttribute.updateRanges;
        if (updateRanges.length === 0) // Not using update ranges
        device.queue.writeBuffer(buffer, 0, array, 0);
        else {
            for(let i = 0, l = updateRanges.length; i < l; i++){
                const range = updateRanges[i];
                device.queue.writeBuffer(buffer, 0, array, range.start * array.BYTES_PER_ELEMENT, range.count * array.BYTES_PER_ELEMENT);
            }
            bufferAttribute.clearUpdateRanges();
        }
    }
    createShaderVertexBuffers(renderObject) {
        const attributes = renderObject.getAttributes();
        const vertexBuffers = new Map();
        for(let slot = 0; slot < attributes.length; slot++){
            const geometryAttribute = attributes[slot];
            const bytesPerElement = geometryAttribute.array.BYTES_PER_ELEMENT;
            const bufferAttribute = this._getBufferAttribute(geometryAttribute);
            let vertexBufferLayout = vertexBuffers.get(bufferAttribute);
            if (vertexBufferLayout === undefined) {
                let arrayStride, stepMode;
                if (geometryAttribute.isInterleavedBufferAttribute === true) {
                    arrayStride = geometryAttribute.data.stride * bytesPerElement;
                    stepMode = geometryAttribute.data.isInstancedInterleavedBuffer ? (0, $65e789322b24f25c$export$8d7390ef8d16d49b).Instance : (0, $65e789322b24f25c$export$8d7390ef8d16d49b).Vertex;
                } else {
                    arrayStride = geometryAttribute.itemSize * bytesPerElement;
                    stepMode = geometryAttribute.isInstancedBufferAttribute ? (0, $65e789322b24f25c$export$8d7390ef8d16d49b).Instance : (0, $65e789322b24f25c$export$8d7390ef8d16d49b).Vertex;
                }
                // patch for INT16 and UINT16
                if (geometryAttribute.normalized === false && (geometryAttribute.array.constructor === Int16Array || geometryAttribute.array.constructor === Uint16Array)) arrayStride = 4;
                vertexBufferLayout = {
                    arrayStride: arrayStride,
                    attributes: [],
                    stepMode: stepMode
                };
                vertexBuffers.set(bufferAttribute, vertexBufferLayout);
            }
            const format = this._getVertexFormat(geometryAttribute);
            const offset = geometryAttribute.isInterleavedBufferAttribute === true ? geometryAttribute.offset * bytesPerElement : 0;
            vertexBufferLayout.attributes.push({
                shaderLocation: slot,
                offset: offset,
                format: format
            });
        }
        return Array.from(vertexBuffers.values());
    }
    destroyAttribute(attribute) {
        const backend = this.backend;
        const data = backend.get(this._getBufferAttribute(attribute));
        data.buffer.destroy();
        backend.delete(attribute);
    }
    async getArrayBufferAsync(attribute) {
        const backend = this.backend;
        const device = backend.device;
        const data = backend.get(this._getBufferAttribute(attribute));
        const bufferGPU = data.buffer;
        const size = bufferGPU.size;
        const readBufferGPU = device.createBuffer({
            label: attribute.name,
            size: size,
            usage: GPUBufferUsage.COPY_DST | GPUBufferUsage.MAP_READ
        });
        const cmdEncoder = device.createCommandEncoder({});
        cmdEncoder.copyBufferToBuffer(bufferGPU, 0, readBufferGPU, 0, size);
        readBufferGPU.unmap();
        const gpuCommands = cmdEncoder.finish();
        device.queue.submit([
            gpuCommands
        ]);
        await readBufferGPU.mapAsync(GPUMapMode.READ);
        const arrayBuffer = readBufferGPU.getMappedRange();
        return arrayBuffer;
    }
    _getVertexFormat(geometryAttribute) {
        const { itemSize: itemSize, normalized: normalized } = geometryAttribute;
        const ArrayType = geometryAttribute.array.constructor;
        const AttributeType = geometryAttribute.constructor;
        let format;
        if (itemSize == 1) format = $ca9a29fd6a396b36$var$typeArraysToVertexFormatPrefixForItemSize1.get(ArrayType);
        else {
            const prefixOptions = $ca9a29fd6a396b36$var$typedAttributeToVertexFormatPrefix.get(AttributeType) || $ca9a29fd6a396b36$var$typedArraysToVertexFormatPrefix.get(ArrayType);
            const prefix = prefixOptions[normalized ? 1 : 0];
            if (prefix) {
                const bytesPerUnit = ArrayType.BYTES_PER_ELEMENT * itemSize;
                const paddedBytesPerUnit = Math.floor((bytesPerUnit + 3) / 4) * 4;
                const paddedItemSize = paddedBytesPerUnit / ArrayType.BYTES_PER_ELEMENT;
                if (paddedItemSize % 1) throw new Error('THREE.WebGPUAttributeUtils: Bad vertex format item size.');
                format = `${prefix}x${paddedItemSize}`;
            }
        }
        if (!format) console.error('THREE.WebGPUAttributeUtils: Vertex format not supported yet.');
        return format;
    }
    _getBufferAttribute(attribute) {
        if (attribute.isInterleavedBufferAttribute) attribute = attribute.data;
        return attribute;
    }
}
var $ca9a29fd6a396b36$export$2e2bcd8739ae039 = $ca9a29fd6a396b36$var$WebGPUAttributeUtils;




class $966d6a864eea4f3e$var$WebGPUBindingUtils {
    constructor(backend){
        this.backend = backend;
        this.bindGroupLayoutCache = new WeakMap();
    }
    createBindingsLayout(bindGroup) {
        const backend = this.backend;
        const device = backend.device;
        const entries = [];
        let index = 0;
        for (const binding of bindGroup.bindings){
            const bindingGPU = {
                binding: index++,
                visibility: binding.visibility
            };
            if (binding.isUniformBuffer || binding.isStorageBuffer) {
                const buffer = {}; // GPUBufferBindingLayout
                if (binding.isStorageBuffer) buffer.type = binding.access;
                bindingGPU.buffer = buffer;
            } else if (binding.isSampler) {
                const sampler = {}; // GPUSamplerBindingLayout
                if (binding.texture.isDepthTexture) {
                    if (binding.texture.compareFunction !== null) sampler.type = 'comparison';
                }
                bindingGPU.sampler = sampler;
            } else if (binding.isSampledTexture && binding.texture.isVideoTexture) bindingGPU.externalTexture = {}; // GPUExternalTextureBindingLayout
            else if (binding.isSampledTexture && binding.store) {
                const format = this.backend.get(binding.texture).texture.format;
                const access = binding.access;
                bindingGPU.storageTexture = {
                    format: format,
                    access: access
                }; // GPUStorageTextureBindingLayout
            } else if (binding.isSampledTexture) {
                const texture = {}; // GPUTextureBindingLayout
                if (binding.texture.isMultisampleRenderTargetTexture === true) texture.multisampled = true;
                if (binding.texture.isDepthTexture) texture.sampleType = (0, $65e789322b24f25c$export$b61d1a527b6a55af).Depth;
                else if (binding.texture.isDataTexture || binding.texture.isDataArrayTexture || binding.texture.isData3DTexture) {
                    const type = binding.texture.type;
                    if (type === (0, $cb5ee595c0f892af$export$5c612977753abe2)) texture.sampleType = (0, $65e789322b24f25c$export$b61d1a527b6a55af).SInt;
                    else if (type === (0, $cb5ee595c0f892af$export$c3c7fc4518ebba96)) texture.sampleType = (0, $65e789322b24f25c$export$b61d1a527b6a55af).UInt;
                    else if (type === (0, $cb5ee595c0f892af$export$f6d331659b644596)) {
                        if (this.backend.hasFeature('float32-filterable')) texture.sampleType = (0, $65e789322b24f25c$export$b61d1a527b6a55af).Float;
                        else texture.sampleType = (0, $65e789322b24f25c$export$b61d1a527b6a55af).UnfilterableFloat;
                    }
                }
                if (binding.isSampledCubeTexture) texture.viewDimension = (0, $65e789322b24f25c$export$e9c73c9e5554baf7).Cube;
                else if (binding.texture.isDataArrayTexture || binding.texture.isCompressedArrayTexture) texture.viewDimension = (0, $65e789322b24f25c$export$e9c73c9e5554baf7).TwoDArray;
                else if (binding.isSampledTexture3D) texture.viewDimension = (0, $65e789322b24f25c$export$e9c73c9e5554baf7).ThreeD;
                bindingGPU.texture = texture;
            } else console.error(`WebGPUBindingUtils: Unsupported binding "${binding}".`);
            entries.push(bindingGPU);
        }
        return device.createBindGroupLayout({
            entries: entries
        });
    }
    createBindings(bindGroup) {
        const { backend: backend, bindGroupLayoutCache: bindGroupLayoutCache } = this;
        const bindingsData = backend.get(bindGroup);
        // setup (static) binding layout and (dynamic) binding group
        let bindLayoutGPU = bindGroupLayoutCache.get(bindGroup.bindingsReference);
        if (bindLayoutGPU === undefined) {
            bindLayoutGPU = this.createBindingsLayout(bindGroup);
            bindGroupLayoutCache.set(bindGroup.bindingsReference, bindLayoutGPU);
        }
        const bindGroupGPU = this.createBindGroup(bindGroup, bindLayoutGPU);
        bindingsData.layout = bindLayoutGPU;
        bindingsData.group = bindGroupGPU;
    }
    updateBinding(binding) {
        const backend = this.backend;
        const device = backend.device;
        const buffer = binding.buffer;
        const bufferGPU = backend.get(binding).buffer;
        device.queue.writeBuffer(bufferGPU, 0, buffer, 0);
    }
    createBindGroup(bindGroup, layoutGPU) {
        const backend = this.backend;
        const device = backend.device;
        let bindingPoint = 0;
        const entriesGPU = [];
        for (const binding of bindGroup.bindings){
            if (binding.isUniformBuffer) {
                const bindingData = backend.get(binding);
                if (bindingData.buffer === undefined) {
                    const byteLength = binding.byteLength;
                    const usage = GPUBufferUsage.UNIFORM | GPUBufferUsage.COPY_DST;
                    const bufferGPU = device.createBuffer({
                        label: 'bindingBuffer_' + binding.name,
                        size: byteLength,
                        usage: usage
                    });
                    bindingData.buffer = bufferGPU;
                }
                entriesGPU.push({
                    binding: bindingPoint,
                    resource: {
                        buffer: bindingData.buffer
                    }
                });
            } else if (binding.isStorageBuffer) {
                const bindingData = backend.get(binding);
                if (bindingData.buffer === undefined) {
                    const attribute = binding.attribute;
                    //const usage = GPUBufferUsage.STORAGE | GPUBufferUsage.VERTEX | /*GPUBufferUsage.COPY_SRC |*/ GPUBufferUsage.COPY_DST;
                    //backend.attributeUtils.createAttribute( attribute, usage ); // @TODO: Move it to universal renderer
                    bindingData.buffer = backend.get(attribute).buffer;
                }
                entriesGPU.push({
                    binding: bindingPoint,
                    resource: {
                        buffer: bindingData.buffer
                    }
                });
            } else if (binding.isSampler) {
                const textureGPU = backend.get(binding.texture);
                entriesGPU.push({
                    binding: bindingPoint,
                    resource: textureGPU.sampler
                });
            } else if (binding.isSampledTexture) {
                const textureData = backend.get(binding.texture);
                let resourceGPU;
                if (textureData.externalTexture !== undefined) resourceGPU = device.importExternalTexture({
                    source: textureData.externalTexture
                });
                else {
                    const mipLevelCount = binding.store ? 1 : textureData.texture.mipLevelCount;
                    const propertyName = `view-${textureData.texture.width}-${textureData.texture.height}-${mipLevelCount}`;
                    resourceGPU = textureData[propertyName];
                    if (resourceGPU === undefined) {
                        const aspectGPU = (0, $65e789322b24f25c$export$9f7640f14f08c6a8).All;
                        let dimensionViewGPU;
                        if (binding.isSampledCubeTexture) dimensionViewGPU = (0, $65e789322b24f25c$export$e9c73c9e5554baf7).Cube;
                        else if (binding.isSampledTexture3D) dimensionViewGPU = (0, $65e789322b24f25c$export$e9c73c9e5554baf7).ThreeD;
                        else if (binding.texture.isDataArrayTexture || binding.texture.isCompressedArrayTexture) dimensionViewGPU = (0, $65e789322b24f25c$export$e9c73c9e5554baf7).TwoDArray;
                        else dimensionViewGPU = (0, $65e789322b24f25c$export$e9c73c9e5554baf7).TwoD;
                        resourceGPU = textureData[propertyName] = textureData.texture.createView({
                            aspect: aspectGPU,
                            dimension: dimensionViewGPU,
                            mipLevelCount: mipLevelCount
                        });
                    }
                }
                entriesGPU.push({
                    binding: bindingPoint,
                    resource: resourceGPU
                });
            }
            bindingPoint++;
        }
        return device.createBindGroup({
            label: 'bindGroup_' + bindGroup.name,
            layout: layoutGPU,
            entries: entriesGPU
        });
    }
}
var $966d6a864eea4f3e$export$2e2bcd8739ae039 = $966d6a864eea4f3e$var$WebGPUBindingUtils;





class $a50211bd8f67adbd$var$WebGPUPipelineUtils {
    constructor(backend){
        this.backend = backend;
    }
    _getSampleCount(renderObjectContext) {
        return this.backend.utils.getSampleCountRenderContext(renderObjectContext);
    }
    createRenderPipeline(renderObject, promises) {
        const { object: object, material: material, geometry: geometry, pipeline: pipeline } = renderObject;
        const { vertexProgram: vertexProgram, fragmentProgram: fragmentProgram } = pipeline;
        const backend = this.backend;
        const device = backend.device;
        const utils = backend.utils;
        const pipelineData = backend.get(pipeline);
        // bind group layouts
        const bindGroupLayouts = [];
        for (const bindGroup of renderObject.getBindings()){
            const bindingsData = backend.get(bindGroup);
            bindGroupLayouts.push(bindingsData.layout);
        }
        // vertex buffers
        const vertexBuffers = backend.attributeUtils.createShaderVertexBuffers(renderObject);
        // blending
        let blending;
        if (material.transparent === true && material.blending !== (0, $cb5ee595c0f892af$export$63b8d6b580fc65ba)) blending = this._getBlending(material);
        // stencil
        let stencilFront = {};
        if (material.stencilWrite === true) stencilFront = {
            compare: this._getStencilCompare(material),
            failOp: this._getStencilOperation(material.stencilFail),
            depthFailOp: this._getStencilOperation(material.stencilZFail),
            passOp: this._getStencilOperation(material.stencilZPass)
        };
        const colorWriteMask = this._getColorWriteMask(material);
        const targets = [];
        if (renderObject.context.textures !== null) {
            const textures = renderObject.context.textures;
            for(let i = 0; i < textures.length; i++){
                const colorFormat = utils.getTextureFormatGPU(textures[i]);
                targets.push({
                    format: colorFormat,
                    blend: blending,
                    writeMask: colorWriteMask
                });
            }
        } else {
            const colorFormat = utils.getCurrentColorFormat(renderObject.context);
            targets.push({
                format: colorFormat,
                blend: blending,
                writeMask: colorWriteMask
            });
        }
        const vertexModule = backend.get(vertexProgram).module;
        const fragmentModule = backend.get(fragmentProgram).module;
        const primitiveState = this._getPrimitiveState(object, geometry, material);
        const depthCompare = this._getDepthCompare(material);
        const depthStencilFormat = utils.getCurrentDepthStencilFormat(renderObject.context);
        const sampleCount = this._getSampleCount(renderObject.context);
        const pipelineDescriptor = {
            label: `renderPipeline_${material.name || material.type}_${material.id}`,
            vertex: Object.assign({}, vertexModule, {
                buffers: vertexBuffers
            }),
            fragment: Object.assign({}, fragmentModule, {
                targets: targets
            }),
            primitive: primitiveState,
            multisample: {
                count: sampleCount,
                alphaToCoverageEnabled: material.alphaToCoverage && sampleCount > 1
            },
            layout: device.createPipelineLayout({
                bindGroupLayouts: bindGroupLayouts
            })
        };
        const depthStencil = {};
        const renderDepth = renderObject.context.depth;
        const renderStencil = renderObject.context.stencil;
        if (renderDepth === true || renderStencil === true) {
            if (renderDepth === true) {
                depthStencil.format = depthStencilFormat;
                depthStencil.depthWriteEnabled = material.depthWrite;
                depthStencil.depthCompare = depthCompare;
            }
            if (renderStencil === true) {
                depthStencil.stencilFront = stencilFront;
                depthStencil.stencilBack = {}; // three.js does not provide an API to configure the back function (gl.stencilFuncSeparate() was never used)
                depthStencil.stencilReadMask = material.stencilFuncMask;
                depthStencil.stencilWriteMask = material.stencilWriteMask;
            }
            pipelineDescriptor.depthStencil = depthStencil;
        }
        if (promises === null) pipelineData.pipeline = device.createRenderPipeline(pipelineDescriptor);
        else {
            const p = new Promise((resolve /*, reject*/ )=>{
                device.createRenderPipelineAsync(pipelineDescriptor).then((pipeline)=>{
                    pipelineData.pipeline = pipeline;
                    resolve();
                });
            });
            promises.push(p);
        }
    }
    createBundleEncoder(renderContext) {
        const backend = this.backend;
        const { utils: utils, device: device } = backend;
        const depthStencilFormat = utils.getCurrentDepthStencilFormat(renderContext);
        const colorFormat = utils.getCurrentColorFormat(renderContext);
        const sampleCount = this._getSampleCount(renderContext);
        const descriptor = {
            label: 'renderBundleEncoder',
            colorFormats: [
                colorFormat
            ],
            depthStencilFormat: depthStencilFormat,
            sampleCount: sampleCount
        };
        return device.createRenderBundleEncoder(descriptor);
    }
    createComputePipeline(pipeline, bindings) {
        const backend = this.backend;
        const device = backend.device;
        const computeProgram = backend.get(pipeline.computeProgram).module;
        const pipelineGPU = backend.get(pipeline);
        // bind group layouts
        const bindGroupLayouts = [];
        for (const bindingsGroup of bindings){
            const bindingsData = backend.get(bindingsGroup);
            bindGroupLayouts.push(bindingsData.layout);
        }
        pipelineGPU.pipeline = device.createComputePipeline({
            compute: computeProgram,
            layout: device.createPipelineLayout({
                bindGroupLayouts: bindGroupLayouts
            })
        });
    }
    _getBlending(material) {
        let color, alpha;
        const blending = material.blending;
        const blendSrc = material.blendSrc;
        const blendDst = material.blendDst;
        const blendEquation = material.blendEquation;
        if (blending === (0, $cb5ee595c0f892af$export$eda4864c68df1fa2)) {
            const blendSrcAlpha = material.blendSrcAlpha !== null ? material.blendSrcAlpha : blendSrc;
            const blendDstAlpha = material.blendDstAlpha !== null ? material.blendDstAlpha : blendDst;
            const blendEquationAlpha = material.blendEquationAlpha !== null ? material.blendEquationAlpha : blendEquation;
            color = {
                srcFactor: this._getBlendFactor(blendSrc),
                dstFactor: this._getBlendFactor(blendDst),
                operation: this._getBlendOperation(blendEquation)
            };
            alpha = {
                srcFactor: this._getBlendFactor(blendSrcAlpha),
                dstFactor: this._getBlendFactor(blendDstAlpha),
                operation: this._getBlendOperation(blendEquationAlpha)
            };
        } else {
            const premultipliedAlpha = material.premultipliedAlpha;
            const setBlend = (srcRGB, dstRGB, srcAlpha, dstAlpha)=>{
                color = {
                    srcFactor: srcRGB,
                    dstFactor: dstRGB,
                    operation: (0, $65e789322b24f25c$export$952412cf8c851ac4).Add
                };
                alpha = {
                    srcFactor: srcAlpha,
                    dstFactor: dstAlpha,
                    operation: (0, $65e789322b24f25c$export$952412cf8c851ac4).Add
                };
            };
            if (premultipliedAlpha) switch(blending){
                case 0, $cb5ee595c0f892af$export$5b29a26d96ee6af0:
                    setBlend((0, $65e789322b24f25c$export$cfc4e42b8aca3783).One, (0, $65e789322b24f25c$export$cfc4e42b8aca3783).OneMinusSrcAlpha, (0, $65e789322b24f25c$export$cfc4e42b8aca3783).One, (0, $65e789322b24f25c$export$cfc4e42b8aca3783).OneMinusSrcAlpha);
                    break;
                case 0, $cb5ee595c0f892af$export$777d8f9551c2216b:
                    setBlend((0, $65e789322b24f25c$export$cfc4e42b8aca3783).One, (0, $65e789322b24f25c$export$cfc4e42b8aca3783).One, (0, $65e789322b24f25c$export$cfc4e42b8aca3783).One, (0, $65e789322b24f25c$export$cfc4e42b8aca3783).One);
                    break;
                case 0, $cb5ee595c0f892af$export$cdfa06f868e2e467:
                    setBlend((0, $65e789322b24f25c$export$cfc4e42b8aca3783).Zero, (0, $65e789322b24f25c$export$cfc4e42b8aca3783).OneMinusSrc, (0, $65e789322b24f25c$export$cfc4e42b8aca3783).Zero, (0, $65e789322b24f25c$export$cfc4e42b8aca3783).One);
                    break;
                case 0, $cb5ee595c0f892af$export$4138e1c684b46a20:
                    setBlend((0, $65e789322b24f25c$export$cfc4e42b8aca3783).Zero, (0, $65e789322b24f25c$export$cfc4e42b8aca3783).Src, (0, $65e789322b24f25c$export$cfc4e42b8aca3783).Zero, (0, $65e789322b24f25c$export$cfc4e42b8aca3783).SrcAlpha);
                    break;
            }
            else switch(blending){
                case 0, $cb5ee595c0f892af$export$5b29a26d96ee6af0:
                    setBlend((0, $65e789322b24f25c$export$cfc4e42b8aca3783).SrcAlpha, (0, $65e789322b24f25c$export$cfc4e42b8aca3783).OneMinusSrcAlpha, (0, $65e789322b24f25c$export$cfc4e42b8aca3783).One, (0, $65e789322b24f25c$export$cfc4e42b8aca3783).OneMinusSrcAlpha);
                    break;
                case 0, $cb5ee595c0f892af$export$777d8f9551c2216b:
                    setBlend((0, $65e789322b24f25c$export$cfc4e42b8aca3783).SrcAlpha, (0, $65e789322b24f25c$export$cfc4e42b8aca3783).One, (0, $65e789322b24f25c$export$cfc4e42b8aca3783).SrcAlpha, (0, $65e789322b24f25c$export$cfc4e42b8aca3783).One);
                    break;
                case 0, $cb5ee595c0f892af$export$cdfa06f868e2e467:
                    setBlend((0, $65e789322b24f25c$export$cfc4e42b8aca3783).Zero, (0, $65e789322b24f25c$export$cfc4e42b8aca3783).OneMinusSrc, (0, $65e789322b24f25c$export$cfc4e42b8aca3783).Zero, (0, $65e789322b24f25c$export$cfc4e42b8aca3783).One);
                    break;
                case 0, $cb5ee595c0f892af$export$4138e1c684b46a20:
                    setBlend((0, $65e789322b24f25c$export$cfc4e42b8aca3783).Zero, (0, $65e789322b24f25c$export$cfc4e42b8aca3783).Src, (0, $65e789322b24f25c$export$cfc4e42b8aca3783).Zero, (0, $65e789322b24f25c$export$cfc4e42b8aca3783).Src);
                    break;
            }
        }
        if (color !== undefined && alpha !== undefined) return {
            color: color,
            alpha: alpha
        };
        else console.error('THREE.WebGPURenderer: Invalid blending: ', blending);
    }
    _getBlendFactor(blend) {
        let blendFactor;
        switch(blend){
            case 0, $cb5ee595c0f892af$export$2110f05edf778d3d:
                blendFactor = (0, $65e789322b24f25c$export$cfc4e42b8aca3783).Zero;
                break;
            case 0, $cb5ee595c0f892af$export$8805bad65e24940e:
                blendFactor = (0, $65e789322b24f25c$export$cfc4e42b8aca3783).One;
                break;
            case 0, $cb5ee595c0f892af$export$7fbe15b28d28cf52:
                blendFactor = (0, $65e789322b24f25c$export$cfc4e42b8aca3783).Src;
                break;
            case 0, $cb5ee595c0f892af$export$947829af9f2c17f6:
                blendFactor = (0, $65e789322b24f25c$export$cfc4e42b8aca3783).OneMinusSrc;
                break;
            case 0, $cb5ee595c0f892af$export$d5773124e86cf28c:
                blendFactor = (0, $65e789322b24f25c$export$cfc4e42b8aca3783).SrcAlpha;
                break;
            case 0, $cb5ee595c0f892af$export$11d468cc7f19e971:
                blendFactor = (0, $65e789322b24f25c$export$cfc4e42b8aca3783).OneMinusSrcAlpha;
                break;
            case 0, $cb5ee595c0f892af$export$ef5f2dd8ffac5574:
                blendFactor = (0, $65e789322b24f25c$export$cfc4e42b8aca3783).Dst;
                break;
            case 0, $cb5ee595c0f892af$export$56b85b2686ab16:
                blendFactor = (0, $65e789322b24f25c$export$cfc4e42b8aca3783).OneMinusDstColor;
                break;
            case 0, $cb5ee595c0f892af$export$a78aed1ca2a87192:
                blendFactor = (0, $65e789322b24f25c$export$cfc4e42b8aca3783).DstAlpha;
                break;
            case 0, $cb5ee595c0f892af$export$5d0fe17fd8773bac:
                blendFactor = (0, $65e789322b24f25c$export$cfc4e42b8aca3783).OneMinusDstAlpha;
                break;
            case 0, $cb5ee595c0f892af$export$c05e2a1fc8609506:
                blendFactor = (0, $65e789322b24f25c$export$cfc4e42b8aca3783).SrcAlphaSaturated;
                break;
            case 0, $a4815dd317c56025$export$b24bddea98f32f06:
                blendFactor = (0, $65e789322b24f25c$export$cfc4e42b8aca3783).Constant;
                break;
            case 0, $a4815dd317c56025$export$25436ebdca80e835:
                blendFactor = (0, $65e789322b24f25c$export$cfc4e42b8aca3783).OneMinusConstant;
                break;
            default:
                console.error('THREE.WebGPURenderer: Blend factor not supported.', blend);
        }
        return blendFactor;
    }
    _getStencilCompare(material) {
        let stencilCompare;
        const stencilFunc = material.stencilFunc;
        switch(stencilFunc){
            case 0, $cb5ee595c0f892af$export$1343870698229224:
                stencilCompare = (0, $65e789322b24f25c$export$d3b4cc57abc1eb2b).Never;
                break;
            case 0, $cb5ee595c0f892af$export$14cf96713ddd97a8:
                stencilCompare = (0, $65e789322b24f25c$export$d3b4cc57abc1eb2b).Always;
                break;
            case 0, $cb5ee595c0f892af$export$8e1d8ed281997fa6:
                stencilCompare = (0, $65e789322b24f25c$export$d3b4cc57abc1eb2b).Less;
                break;
            case 0, $cb5ee595c0f892af$export$2dff107857e6aca2:
                stencilCompare = (0, $65e789322b24f25c$export$d3b4cc57abc1eb2b).LessEqual;
                break;
            case 0, $cb5ee595c0f892af$export$55648a1cde8329a7:
                stencilCompare = (0, $65e789322b24f25c$export$d3b4cc57abc1eb2b).Equal;
                break;
            case 0, $cb5ee595c0f892af$export$4119cf7b4c98fd5a:
                stencilCompare = (0, $65e789322b24f25c$export$d3b4cc57abc1eb2b).GreaterEqual;
                break;
            case 0, $cb5ee595c0f892af$export$6f93765ab2f451a2:
                stencilCompare = (0, $65e789322b24f25c$export$d3b4cc57abc1eb2b).Greater;
                break;
            case 0, $cb5ee595c0f892af$export$6f3fb2d2440f2b76:
                stencilCompare = (0, $65e789322b24f25c$export$d3b4cc57abc1eb2b).NotEqual;
                break;
            default:
                console.error('THREE.WebGPURenderer: Invalid stencil function.', stencilFunc);
        }
        return stencilCompare;
    }
    _getStencilOperation(op) {
        let stencilOperation;
        switch(op){
            case 0, $cb5ee595c0f892af$export$9f542ae4b5baca34:
                stencilOperation = (0, $65e789322b24f25c$export$378a9c05c4b63f89).Keep;
                break;
            case 0, $cb5ee595c0f892af$export$69433f11f42d5527:
                stencilOperation = (0, $65e789322b24f25c$export$378a9c05c4b63f89).Zero;
                break;
            case 0, $cb5ee595c0f892af$export$8a4f28336ef203d3:
                stencilOperation = (0, $65e789322b24f25c$export$378a9c05c4b63f89).Replace;
                break;
            case 0, $cb5ee595c0f892af$export$22e2e5726612443:
                stencilOperation = (0, $65e789322b24f25c$export$378a9c05c4b63f89).Invert;
                break;
            case 0, $cb5ee595c0f892af$export$2928c0231297c036:
                stencilOperation = (0, $65e789322b24f25c$export$378a9c05c4b63f89).IncrementClamp;
                break;
            case 0, $cb5ee595c0f892af$export$c0e9611c8a15f9a8:
                stencilOperation = (0, $65e789322b24f25c$export$378a9c05c4b63f89).DecrementClamp;
                break;
            case 0, $cb5ee595c0f892af$export$9c2c08927385dcc4:
                stencilOperation = (0, $65e789322b24f25c$export$378a9c05c4b63f89).IncrementWrap;
                break;
            case 0, $cb5ee595c0f892af$export$7c74ea00fa1315e6:
                stencilOperation = (0, $65e789322b24f25c$export$378a9c05c4b63f89).DecrementWrap;
                break;
            default:
                console.error('THREE.WebGPURenderer: Invalid stencil operation.', stencilOperation);
        }
        return stencilOperation;
    }
    _getBlendOperation(blendEquation) {
        let blendOperation;
        switch(blendEquation){
            case 0, $cb5ee595c0f892af$export$20183a0484ce21a0:
                blendOperation = (0, $65e789322b24f25c$export$952412cf8c851ac4).Add;
                break;
            case 0, $cb5ee595c0f892af$export$73e0df5177988548:
                blendOperation = (0, $65e789322b24f25c$export$952412cf8c851ac4).Subtract;
                break;
            case 0, $cb5ee595c0f892af$export$28e582859cbec660:
                blendOperation = (0, $65e789322b24f25c$export$952412cf8c851ac4).ReverseSubtract;
                break;
            case 0, $cb5ee595c0f892af$export$c8c1508da8d0600c:
                blendOperation = (0, $65e789322b24f25c$export$952412cf8c851ac4).Min;
                break;
            case 0, $cb5ee595c0f892af$export$99948c02fb51055f:
                blendOperation = (0, $65e789322b24f25c$export$952412cf8c851ac4).Max;
                break;
            default:
                console.error('THREE.WebGPUPipelineUtils: Blend equation not supported.', blendEquation);
        }
        return blendOperation;
    }
    _getPrimitiveState(object, geometry, material) {
        const descriptor = {};
        const utils = this.backend.utils;
        descriptor.topology = utils.getPrimitiveTopology(object, material);
        if (geometry.index !== null && object.isLine === true && object.isLineSegments !== true) descriptor.stripIndexFormat = geometry.index.array instanceof Uint16Array ? (0, $65e789322b24f25c$export$6a6945c8ae14b3d0).Uint16 : (0, $65e789322b24f25c$export$6a6945c8ae14b3d0).Uint32;
        switch(material.side){
            case 0, $cb5ee595c0f892af$export$2ede184fc2998901:
                descriptor.frontFace = (0, $65e789322b24f25c$export$8231fbc54c1f8d17).CCW;
                descriptor.cullMode = (0, $65e789322b24f25c$export$e4ecb46d830701d5).Back;
                break;
            case 0, $cb5ee595c0f892af$export$d9f0486e75b5ace:
                descriptor.frontFace = (0, $65e789322b24f25c$export$8231fbc54c1f8d17).CCW;
                descriptor.cullMode = (0, $65e789322b24f25c$export$e4ecb46d830701d5).Front;
                break;
            case 0, $cb5ee595c0f892af$export$3b296b6f144d5b03:
                descriptor.frontFace = (0, $65e789322b24f25c$export$8231fbc54c1f8d17).CCW;
                descriptor.cullMode = (0, $65e789322b24f25c$export$e4ecb46d830701d5).None;
                break;
            default:
                console.error('THREE.WebGPUPipelineUtils: Unknown material.side value.', material.side);
                break;
        }
        return descriptor;
    }
    _getColorWriteMask(material) {
        return material.colorWrite === true ? (0, $65e789322b24f25c$export$98bf55822960ed5f).All : (0, $65e789322b24f25c$export$98bf55822960ed5f).None;
    }
    _getDepthCompare(material) {
        let depthCompare;
        if (material.depthTest === false) depthCompare = (0, $65e789322b24f25c$export$d3b4cc57abc1eb2b).Always;
        else {
            const depthFunc = material.depthFunc;
            switch(depthFunc){
                case 0, $cb5ee595c0f892af$export$69025ce147cee220:
                    depthCompare = (0, $65e789322b24f25c$export$d3b4cc57abc1eb2b).Never;
                    break;
                case 0, $cb5ee595c0f892af$export$7182eb52ea3b3f04:
                    depthCompare = (0, $65e789322b24f25c$export$d3b4cc57abc1eb2b).Always;
                    break;
                case 0, $cb5ee595c0f892af$export$eedccec66ab7ebe:
                    depthCompare = (0, $65e789322b24f25c$export$d3b4cc57abc1eb2b).Less;
                    break;
                case 0, $cb5ee595c0f892af$export$296f78a0b892f81a:
                    depthCompare = (0, $65e789322b24f25c$export$d3b4cc57abc1eb2b).LessEqual;
                    break;
                case 0, $cb5ee595c0f892af$export$a60d398fc7b7590e:
                    depthCompare = (0, $65e789322b24f25c$export$d3b4cc57abc1eb2b).Equal;
                    break;
                case 0, $cb5ee595c0f892af$export$7d7234c1240a1fc4:
                    depthCompare = (0, $65e789322b24f25c$export$d3b4cc57abc1eb2b).GreaterEqual;
                    break;
                case 0, $cb5ee595c0f892af$export$c5e2c52991f30937:
                    depthCompare = (0, $65e789322b24f25c$export$d3b4cc57abc1eb2b).Greater;
                    break;
                case 0, $cb5ee595c0f892af$export$2f843afa843d8916:
                    depthCompare = (0, $65e789322b24f25c$export$d3b4cc57abc1eb2b).NotEqual;
                    break;
                default:
                    console.error('THREE.WebGPUPipelineUtils: Invalid depth function.', depthFunc);
            }
        }
        return depthCompare;
    }
}
var $a50211bd8f67adbd$export$2e2bcd8739ae039 = $a50211bd8f67adbd$var$WebGPUPipelineUtils;




//
class $00002c23d5ded4a6$var$WebGPUBackend extends (0, $191c5c4fa47571a5$export$2e2bcd8739ae039) {
    constructor(parameters = {}){
        super(parameters);
        this.isWebGPUBackend = true;
        // some parameters require default values other than "undefined"
        this.parameters.alpha = parameters.alpha === undefined ? true : parameters.alpha;
        this.parameters.requiredLimits = parameters.requiredLimits === undefined ? {} : parameters.requiredLimits;
        this.trackTimestamp = parameters.trackTimestamp === true;
        this.device = null;
        this.context = null;
        this.colorBuffer = null;
        this.defaultRenderPassdescriptor = null;
        this.utils = new (0, $b6e5dc74d3252c2b$export$2e2bcd8739ae039)(this);
        this.attributeUtils = new (0, $ca9a29fd6a396b36$export$2e2bcd8739ae039)(this);
        this.bindingUtils = new (0, $966d6a864eea4f3e$export$2e2bcd8739ae039)(this);
        this.pipelineUtils = new (0, $a50211bd8f67adbd$export$2e2bcd8739ae039)(this);
        this.textureUtils = new (0, $39e424db81bbb213$export$2e2bcd8739ae039)(this);
        this.occludedResolveCache = new Map();
    }
    async init(renderer) {
        await super.init(renderer);
        //
        const parameters = this.parameters;
        // create the device if it is not passed with parameters
        let device;
        if (parameters.device === undefined) {
            const adapterOptions = {
                powerPreference: parameters.powerPreference
            };
            const adapter = await navigator.gpu.requestAdapter(adapterOptions);
            if (adapter === null) throw new Error('WebGPUBackend: Unable to create WebGPU adapter.');
            // feature support
            const features = Object.values((0, $65e789322b24f25c$export$97a86f8b50a49c2b));
            const supportedFeatures = [];
            for (const name of features)if (adapter.features.has(name)) supportedFeatures.push(name);
            const deviceDescriptor = {
                requiredFeatures: supportedFeatures,
                requiredLimits: parameters.requiredLimits
            };
            device = await adapter.requestDevice(deviceDescriptor);
        } else device = parameters.device;
        device.lost.then((info)=>{
            const deviceLossInfo = {
                api: 'WebGPU',
                message: info.message || 'Unknown reason',
                reason: info.reason || null,
                originalEvent: info
            };
            renderer.onDeviceLost(deviceLossInfo);
        });
        const context = parameters.context !== undefined ? parameters.context : renderer.domElement.getContext('webgpu');
        this.device = device;
        this.context = context;
        const alphaMode = parameters.alpha ? 'premultiplied' : 'opaque';
        this.trackTimestamp = this.trackTimestamp && this.hasFeature((0, $65e789322b24f25c$export$97a86f8b50a49c2b).TimestampQuery);
        this.context.configure({
            device: this.device,
            format: this.utils.getPreferredCanvasFormat(),
            usage: GPUTextureUsage.RENDER_ATTACHMENT | GPUTextureUsage.COPY_SRC,
            alphaMode: alphaMode
        });
        this.updateSize();
    }
    get coordinateSystem() {
        return 0, $cb5ee595c0f892af$export$cc83beedcb9be9ac;
    }
    async getArrayBufferAsync(attribute) {
        return await this.attributeUtils.getArrayBufferAsync(attribute);
    }
    getContext() {
        return this.context;
    }
    _getDefaultRenderPassDescriptor() {
        let descriptor = this.defaultRenderPassdescriptor;
        if (descriptor === null) {
            const renderer = this.renderer;
            descriptor = {
                colorAttachments: [
                    {
                        view: null
                    }
                ]
            };
            if (this.renderer.depth === true || this.renderer.stencil === true) descriptor.depthStencilAttachment = {
                view: this.textureUtils.getDepthBuffer(renderer.depth, renderer.stencil).createView()
            };
            const colorAttachment = descriptor.colorAttachments[0];
            if (this.renderer.samples > 0) colorAttachment.view = this.colorBuffer.createView();
            else colorAttachment.resolveTarget = undefined;
            this.defaultRenderPassdescriptor = descriptor;
        }
        const colorAttachment = descriptor.colorAttachments[0];
        if (this.renderer.samples > 0) colorAttachment.resolveTarget = this.context.getCurrentTexture().createView();
        else colorAttachment.view = this.context.getCurrentTexture().createView();
        return descriptor;
    }
    _getRenderPassDescriptor(renderContext) {
        const renderTarget = renderContext.renderTarget;
        const renderTargetData = this.get(renderTarget);
        let descriptors = renderTargetData.descriptors;
        if (descriptors === undefined || renderTargetData.width !== renderTarget.width || renderTargetData.height !== renderTarget.height || renderTargetData.activeMipmapLevel !== renderTarget.activeMipmapLevel || renderTargetData.samples !== renderTarget.samples) {
            descriptors = {};
            renderTargetData.descriptors = descriptors;
            // dispose
            const onDispose = ()=>{
                renderTarget.removeEventListener('dispose', onDispose);
                this.delete(renderTarget);
            };
            renderTarget.addEventListener('dispose', onDispose);
        }
        const cacheKey = renderContext.getCacheKey();
        let descriptor = descriptors[cacheKey];
        if (descriptor === undefined) {
            const textures = renderContext.textures;
            const colorAttachments = [];
            for(let i = 0; i < textures.length; i++){
                const textureData = this.get(textures[i]);
                const textureView = textureData.texture.createView({
                    baseMipLevel: renderContext.activeMipmapLevel,
                    mipLevelCount: 1,
                    baseArrayLayer: renderContext.activeCubeFace,
                    dimension: (0, $65e789322b24f25c$export$e9c73c9e5554baf7).TwoD
                });
                let view, resolveTarget;
                if (textureData.msaaTexture !== undefined) {
                    view = textureData.msaaTexture.createView();
                    resolveTarget = textureView;
                } else {
                    view = textureView;
                    resolveTarget = undefined;
                }
                colorAttachments.push({
                    view: view,
                    resolveTarget: resolveTarget,
                    loadOp: (0, $65e789322b24f25c$export$e23f171c304e7eb1).Load,
                    storeOp: (0, $65e789322b24f25c$export$d6b072117316704a).Store
                });
            }
            descriptor = {
                colorAttachments: colorAttachments
            };
            if (renderContext.depth) {
                const depthTextureData = this.get(renderContext.depthTexture);
                const depthStencilAttachment = {
                    view: depthTextureData.texture.createView()
                };
                descriptor.depthStencilAttachment = depthStencilAttachment;
            }
            descriptors[cacheKey] = descriptor;
            renderTargetData.width = renderTarget.width;
            renderTargetData.height = renderTarget.height;
            renderTargetData.samples = renderTarget.samples;
            renderTargetData.activeMipmapLevel = renderTarget.activeMipmapLevel;
        }
        return descriptor;
    }
    beginRender(renderContext) {
        const renderContextData = this.get(renderContext);
        const device = this.device;
        const occlusionQueryCount = renderContext.occlusionQueryCount;
        let occlusionQuerySet;
        if (occlusionQueryCount > 0) {
            if (renderContextData.currentOcclusionQuerySet) renderContextData.currentOcclusionQuerySet.destroy();
            if (renderContextData.currentOcclusionQueryBuffer) renderContextData.currentOcclusionQueryBuffer.destroy();
            // Get a reference to the array of objects with queries. The renderContextData property
            // can be changed by another render pass before the buffer.mapAsyc() completes.
            renderContextData.currentOcclusionQuerySet = renderContextData.occlusionQuerySet;
            renderContextData.currentOcclusionQueryBuffer = renderContextData.occlusionQueryBuffer;
            renderContextData.currentOcclusionQueryObjects = renderContextData.occlusionQueryObjects;
            //
            occlusionQuerySet = device.createQuerySet({
                type: 'occlusion',
                count: occlusionQueryCount
            });
            renderContextData.occlusionQuerySet = occlusionQuerySet;
            renderContextData.occlusionQueryIndex = 0;
            renderContextData.occlusionQueryObjects = new Array(occlusionQueryCount);
            renderContextData.lastOcclusionObject = null;
        }
        let descriptor;
        if (renderContext.textures === null) descriptor = this._getDefaultRenderPassDescriptor();
        else descriptor = this._getRenderPassDescriptor(renderContext);
        this.initTimestampQuery(renderContext, descriptor);
        descriptor.occlusionQuerySet = occlusionQuerySet;
        const depthStencilAttachment = descriptor.depthStencilAttachment;
        if (renderContext.textures !== null) {
            const colorAttachments = descriptor.colorAttachments;
            for(let i = 0; i < colorAttachments.length; i++){
                const colorAttachment = colorAttachments[i];
                if (renderContext.clearColor) {
                    colorAttachment.clearValue = i === 0 ? renderContext.clearColorValue : {
                        r: 0,
                        g: 0,
                        b: 0,
                        a: 1
                    };
                    colorAttachment.loadOp = (0, $65e789322b24f25c$export$e23f171c304e7eb1).Clear;
                    colorAttachment.storeOp = (0, $65e789322b24f25c$export$d6b072117316704a).Store;
                } else {
                    colorAttachment.loadOp = (0, $65e789322b24f25c$export$e23f171c304e7eb1).Load;
                    colorAttachment.storeOp = (0, $65e789322b24f25c$export$d6b072117316704a).Store;
                }
            }
        } else {
            const colorAttachment = descriptor.colorAttachments[0];
            if (renderContext.clearColor) {
                colorAttachment.clearValue = renderContext.clearColorValue;
                colorAttachment.loadOp = (0, $65e789322b24f25c$export$e23f171c304e7eb1).Clear;
                colorAttachment.storeOp = (0, $65e789322b24f25c$export$d6b072117316704a).Store;
            } else {
                colorAttachment.loadOp = (0, $65e789322b24f25c$export$e23f171c304e7eb1).Load;
                colorAttachment.storeOp = (0, $65e789322b24f25c$export$d6b072117316704a).Store;
            }
        }
        //
        if (renderContext.depth) {
            if (renderContext.clearDepth) {
                depthStencilAttachment.depthClearValue = renderContext.clearDepthValue;
                depthStencilAttachment.depthLoadOp = (0, $65e789322b24f25c$export$e23f171c304e7eb1).Clear;
                depthStencilAttachment.depthStoreOp = (0, $65e789322b24f25c$export$d6b072117316704a).Store;
            } else {
                depthStencilAttachment.depthLoadOp = (0, $65e789322b24f25c$export$e23f171c304e7eb1).Load;
                depthStencilAttachment.depthStoreOp = (0, $65e789322b24f25c$export$d6b072117316704a).Store;
            }
        }
        if (renderContext.stencil) {
            if (renderContext.clearStencil) {
                depthStencilAttachment.stencilClearValue = renderContext.clearStencilValue;
                depthStencilAttachment.stencilLoadOp = (0, $65e789322b24f25c$export$e23f171c304e7eb1).Clear;
                depthStencilAttachment.stencilStoreOp = (0, $65e789322b24f25c$export$d6b072117316704a).Store;
            } else {
                depthStencilAttachment.stencilLoadOp = (0, $65e789322b24f25c$export$e23f171c304e7eb1).Load;
                depthStencilAttachment.stencilStoreOp = (0, $65e789322b24f25c$export$d6b072117316704a).Store;
            }
        }
        //
        const encoder = device.createCommandEncoder({
            label: 'renderContext_' + renderContext.id
        });
        const currentPass = encoder.beginRenderPass(descriptor);
        //
        renderContextData.descriptor = descriptor;
        renderContextData.encoder = encoder;
        renderContextData.currentPass = currentPass;
        renderContextData.currentSets = {
            attributes: {},
            bindingGroups: [],
            pipeline: null,
            index: null
        };
        renderContextData.renderBundles = [];
        //
        if (renderContext.viewport) this.updateViewport(renderContext);
        if (renderContext.scissor) {
            const { x: x, y: y, width: width, height: height } = renderContext.scissorValue;
            currentPass.setScissorRect(x, y, width, height);
        }
    }
    finishRender(renderContext) {
        const renderContextData = this.get(renderContext);
        const occlusionQueryCount = renderContext.occlusionQueryCount;
        if (renderContextData.renderBundles.length > 0) renderContextData.currentPass.executeBundles(renderContextData.renderBundles);
        if (occlusionQueryCount > renderContextData.occlusionQueryIndex) renderContextData.currentPass.endOcclusionQuery();
        renderContextData.currentPass.end();
        if (occlusionQueryCount > 0) {
            const bufferSize = occlusionQueryCount * 8; // 8 byte entries for query results
            //
            let queryResolveBuffer = this.occludedResolveCache.get(bufferSize);
            if (queryResolveBuffer === undefined) {
                queryResolveBuffer = this.device.createBuffer({
                    size: bufferSize,
                    usage: GPUBufferUsage.QUERY_RESOLVE | GPUBufferUsage.COPY_SRC
                });
                this.occludedResolveCache.set(bufferSize, queryResolveBuffer);
            }
            //
            const readBuffer = this.device.createBuffer({
                size: bufferSize,
                usage: GPUBufferUsage.COPY_DST | GPUBufferUsage.MAP_READ
            });
            // two buffers required here - WebGPU doesn't allow usage of QUERY_RESOLVE & MAP_READ to be combined
            renderContextData.encoder.resolveQuerySet(renderContextData.occlusionQuerySet, 0, occlusionQueryCount, queryResolveBuffer, 0);
            renderContextData.encoder.copyBufferToBuffer(queryResolveBuffer, 0, readBuffer, 0, bufferSize);
            renderContextData.occlusionQueryBuffer = readBuffer;
            //
            this.resolveOccludedAsync(renderContext);
        }
        this.prepareTimestampBuffer(renderContext, renderContextData.encoder);
        this.device.queue.submit([
            renderContextData.encoder.finish()
        ]);
        //
        if (renderContext.textures !== null) {
            const textures = renderContext.textures;
            for(let i = 0; i < textures.length; i++){
                const texture = textures[i];
                if (texture.generateMipmaps === true) this.textureUtils.generateMipmaps(texture);
            }
        }
    }
    isOccluded(renderContext, object) {
        const renderContextData = this.get(renderContext);
        return renderContextData.occluded && renderContextData.occluded.has(object);
    }
    async resolveOccludedAsync(renderContext) {
        const renderContextData = this.get(renderContext);
        // handle occlusion query results
        const { currentOcclusionQueryBuffer: currentOcclusionQueryBuffer, currentOcclusionQueryObjects: currentOcclusionQueryObjects } = renderContextData;
        if (currentOcclusionQueryBuffer && currentOcclusionQueryObjects) {
            const occluded = new WeakSet();
            renderContextData.currentOcclusionQueryObjects = null;
            renderContextData.currentOcclusionQueryBuffer = null;
            await currentOcclusionQueryBuffer.mapAsync(GPUMapMode.READ);
            const buffer = currentOcclusionQueryBuffer.getMappedRange();
            const results = new BigUint64Array(buffer);
            for(let i = 0; i < currentOcclusionQueryObjects.length; i++)if (results[i] !== BigInt(0)) occluded.add(currentOcclusionQueryObjects[i]);
            currentOcclusionQueryBuffer.destroy();
            renderContextData.occluded = occluded;
        }
    }
    updateViewport(renderContext) {
        const { currentPass: currentPass } = this.get(renderContext);
        const { x: x, y: y, width: width, height: height, minDepth: minDepth, maxDepth: maxDepth } = renderContext.viewportValue;
        currentPass.setViewport(x, y, width, height, minDepth, maxDepth);
    }
    clear(color, depth, stencil, renderTargetData = null) {
        const device = this.device;
        const renderer = this.renderer;
        let colorAttachments = [];
        let depthStencilAttachment;
        let clearValue;
        let supportsDepth;
        let supportsStencil;
        if (color) {
            const clearColor = this.getClearColor();
            if (this.renderer.alpha === true) {
                // premultiply alpha
                const a = clearColor.a;
                clearValue = {
                    r: clearColor.r * a,
                    g: clearColor.g * a,
                    b: clearColor.b * a,
                    a: a
                };
            } else clearValue = {
                r: clearColor.r,
                g: clearColor.g,
                b: clearColor.b,
                a: clearColor.a
            };
        }
        if (renderTargetData === null) {
            supportsDepth = renderer.depth;
            supportsStencil = renderer.stencil;
            const descriptor = this._getDefaultRenderPassDescriptor();
            if (color) {
                colorAttachments = descriptor.colorAttachments;
                const colorAttachment = colorAttachments[0];
                colorAttachment.clearValue = clearValue;
                colorAttachment.loadOp = (0, $65e789322b24f25c$export$e23f171c304e7eb1).Clear;
                colorAttachment.storeOp = (0, $65e789322b24f25c$export$d6b072117316704a).Store;
            }
            if (supportsDepth || supportsStencil) depthStencilAttachment = descriptor.depthStencilAttachment;
        } else {
            supportsDepth = renderTargetData.depth;
            supportsStencil = renderTargetData.stencil;
            if (color) for (const texture of renderTargetData.textures){
                const textureData = this.get(texture);
                const textureView = textureData.texture.createView();
                let view, resolveTarget;
                if (textureData.msaaTexture !== undefined) {
                    view = textureData.msaaTexture.createView();
                    resolveTarget = textureView;
                } else {
                    view = textureView;
                    resolveTarget = undefined;
                }
                colorAttachments.push({
                    view: view,
                    resolveTarget: resolveTarget,
                    clearValue: clearValue,
                    loadOp: (0, $65e789322b24f25c$export$e23f171c304e7eb1).Clear,
                    storeOp: (0, $65e789322b24f25c$export$d6b072117316704a).Store
                });
            }
            if (supportsDepth || supportsStencil) {
                const depthTextureData = this.get(renderTargetData.depthTexture);
                depthStencilAttachment = {
                    view: depthTextureData.texture.createView()
                };
            }
        }
        //
        if (supportsDepth) {
            if (depth) {
                depthStencilAttachment.depthLoadOp = (0, $65e789322b24f25c$export$e23f171c304e7eb1).Clear;
                depthStencilAttachment.depthClearValue = renderer.getClearDepth();
                depthStencilAttachment.depthStoreOp = (0, $65e789322b24f25c$export$d6b072117316704a).Store;
            } else {
                depthStencilAttachment.depthLoadOp = (0, $65e789322b24f25c$export$e23f171c304e7eb1).Load;
                depthStencilAttachment.depthStoreOp = (0, $65e789322b24f25c$export$d6b072117316704a).Store;
            }
        }
        //
        if (supportsStencil) {
            if (stencil) {
                depthStencilAttachment.stencilLoadOp = (0, $65e789322b24f25c$export$e23f171c304e7eb1).Clear;
                depthStencilAttachment.stencilClearValue = renderer.getClearStencil();
                depthStencilAttachment.stencilStoreOp = (0, $65e789322b24f25c$export$d6b072117316704a).Store;
            } else {
                depthStencilAttachment.stencilLoadOp = (0, $65e789322b24f25c$export$e23f171c304e7eb1).Load;
                depthStencilAttachment.stencilStoreOp = (0, $65e789322b24f25c$export$d6b072117316704a).Store;
            }
        }
        //
        const encoder = device.createCommandEncoder({});
        const currentPass = encoder.beginRenderPass({
            colorAttachments: colorAttachments,
            depthStencilAttachment: depthStencilAttachment
        });
        currentPass.end();
        device.queue.submit([
            encoder.finish()
        ]);
    }
    // compute
    beginCompute(computeGroup) {
        const groupGPU = this.get(computeGroup);
        const descriptor = {};
        this.initTimestampQuery(computeGroup, descriptor);
        groupGPU.cmdEncoderGPU = this.device.createCommandEncoder();
        groupGPU.passEncoderGPU = groupGPU.cmdEncoderGPU.beginComputePass(descriptor);
    }
    compute(computeGroup, computeNode, bindings, pipeline) {
        const { passEncoderGPU: passEncoderGPU } = this.get(computeGroup);
        // pipeline
        const pipelineGPU = this.get(pipeline).pipeline;
        passEncoderGPU.setPipeline(pipelineGPU);
        // bind groups
        for(let i = 0, l = bindings.length; i < l; i++){
            const bindGroup = bindings[i];
            const bindingsData = this.get(bindGroup);
            passEncoderGPU.setBindGroup(i, bindingsData.group);
        }
        const maxComputeWorkgroupsPerDimension = this.device.limits.maxComputeWorkgroupsPerDimension;
        const computeNodeData = this.get(computeNode);
        if (computeNodeData.dispatchSize === undefined) computeNodeData.dispatchSize = {
            x: 0,
            y: 1,
            z: 1
        };
        const { dispatchSize: dispatchSize } = computeNodeData;
        if (computeNode.dispatchCount > maxComputeWorkgroupsPerDimension) {
            dispatchSize.x = Math.min(computeNode.dispatchCount, maxComputeWorkgroupsPerDimension);
            dispatchSize.y = Math.ceil(computeNode.dispatchCount / maxComputeWorkgroupsPerDimension);
        } else dispatchSize.x = computeNode.dispatchCount;
        passEncoderGPU.dispatchWorkgroups(dispatchSize.x, dispatchSize.y, dispatchSize.z);
    }
    finishCompute(computeGroup) {
        const groupData = this.get(computeGroup);
        groupData.passEncoderGPU.end();
        this.prepareTimestampBuffer(computeGroup, groupData.cmdEncoderGPU);
        this.device.queue.submit([
            groupData.cmdEncoderGPU.finish()
        ]);
    }
    async waitForGPU() {
        await this.device.queue.onSubmittedWorkDone();
    }
    // render object
    draw(renderObject, info) {
        const { object: object, context: context, pipeline: pipeline } = renderObject;
        const bindings = renderObject.getBindings();
        const renderContextData = this.get(context);
        const pipelineGPU = this.get(pipeline).pipeline;
        const currentSets = renderContextData.currentSets;
        const passEncoderGPU = renderContextData.currentPass;
        const drawParams = renderObject.getDrawParameters();
        if (drawParams === null) return;
        // pipeline
        if (currentSets.pipeline !== pipelineGPU) {
            passEncoderGPU.setPipeline(pipelineGPU);
            currentSets.pipeline = pipelineGPU;
        }
        // bind groups
        const currentBindingGroups = currentSets.bindingGroups;
        for(let i = 0, l = bindings.length; i < l; i++){
            const bindGroup = bindings[i];
            const bindingsData = this.get(bindGroup);
            if (currentBindingGroups[bindGroup.index] !== bindGroup.id) {
                passEncoderGPU.setBindGroup(bindGroup.index, bindingsData.group);
                currentBindingGroups[bindGroup.index] = bindGroup.id;
            }
        }
        // attributes
        const index = renderObject.getIndex();
        const hasIndex = index !== null;
        // index
        if (hasIndex === true) {
            if (currentSets.index !== index) {
                const buffer = this.get(index).buffer;
                const indexFormat = index.array instanceof Uint16Array ? (0, $65e789322b24f25c$export$6a6945c8ae14b3d0).Uint16 : (0, $65e789322b24f25c$export$6a6945c8ae14b3d0).Uint32;
                passEncoderGPU.setIndexBuffer(buffer, indexFormat);
                currentSets.index = index;
            }
        }
        // vertex buffers
        const vertexBuffers = renderObject.getVertexBuffers();
        for(let i = 0, l = vertexBuffers.length; i < l; i++){
            const vertexBuffer = vertexBuffers[i];
            if (currentSets.attributes[i] !== vertexBuffer) {
                const buffer = this.get(vertexBuffer).buffer;
                passEncoderGPU.setVertexBuffer(i, buffer);
                currentSets.attributes[i] = vertexBuffer;
            }
        }
        // occlusion queries - handle multiple consecutive draw calls for an object
        if (renderContextData.occlusionQuerySet !== undefined) {
            const lastObject = renderContextData.lastOcclusionObject;
            if (lastObject !== object) {
                if (lastObject !== null && lastObject.occlusionTest === true) {
                    passEncoderGPU.endOcclusionQuery();
                    renderContextData.occlusionQueryIndex++;
                }
                if (object.occlusionTest === true) {
                    passEncoderGPU.beginOcclusionQuery(renderContextData.occlusionQueryIndex);
                    renderContextData.occlusionQueryObjects[renderContextData.occlusionQueryIndex] = object;
                }
                renderContextData.lastOcclusionObject = object;
            }
        }
        // draw
        if (object.isBatchedMesh === true) {
            const starts = object._multiDrawStarts;
            const counts = object._multiDrawCounts;
            const drawCount = object._multiDrawCount;
            const drawInstances = object._multiDrawInstances;
            const bytesPerElement = hasIndex ? index.array.BYTES_PER_ELEMENT : 1;
            for(let i = 0; i < drawCount; i++){
                const count = drawInstances ? drawInstances[i] : 1;
                const firstInstance = count > 1 ? 0 : i;
                passEncoderGPU.drawIndexed(counts[i], count, starts[i] / bytesPerElement, 0, firstInstance);
            }
        } else if (hasIndex === true) {
            const { vertexCount: indexCount, instanceCount: instanceCount, firstVertex: firstIndex } = drawParams;
            const indirect = renderObject.getIndirect();
            if (indirect !== null) {
                const buffer = this.get(indirect).buffer;
                passEncoderGPU.drawIndexedIndirect(buffer, 0);
            } else passEncoderGPU.drawIndexed(indexCount, instanceCount, firstIndex, 0, 0);
            info.update(object, indexCount, instanceCount);
        } else {
            const { vertexCount: vertexCount, instanceCount: instanceCount, firstVertex: firstVertex } = drawParams;
            const indirect = renderObject.getIndirect();
            if (indirect !== null) {
                const buffer = this.get(indirect).buffer;
                passEncoderGPU.drawIndirect(buffer, 0);
            } else passEncoderGPU.draw(vertexCount, instanceCount, firstVertex, 0);
            info.update(object, vertexCount, instanceCount);
        }
    }
    // cache key
    needsRenderUpdate(renderObject) {
        const data = this.get(renderObject);
        const { object: object, material: material } = renderObject;
        const utils = this.utils;
        const sampleCount = utils.getSampleCountRenderContext(renderObject.context);
        const colorSpace = utils.getCurrentColorSpace(renderObject.context);
        const colorFormat = utils.getCurrentColorFormat(renderObject.context);
        const depthStencilFormat = utils.getCurrentDepthStencilFormat(renderObject.context);
        const primitiveTopology = utils.getPrimitiveTopology(object, material);
        let needsUpdate = false;
        if (data.material !== material || data.materialVersion !== material.version || data.transparent !== material.transparent || data.blending !== material.blending || data.premultipliedAlpha !== material.premultipliedAlpha || data.blendSrc !== material.blendSrc || data.blendDst !== material.blendDst || data.blendEquation !== material.blendEquation || data.blendSrcAlpha !== material.blendSrcAlpha || data.blendDstAlpha !== material.blendDstAlpha || data.blendEquationAlpha !== material.blendEquationAlpha || data.colorWrite !== material.colorWrite || data.depthWrite !== material.depthWrite || data.depthTest !== material.depthTest || data.depthFunc !== material.depthFunc || data.stencilWrite !== material.stencilWrite || data.stencilFunc !== material.stencilFunc || data.stencilFail !== material.stencilFail || data.stencilZFail !== material.stencilZFail || data.stencilZPass !== material.stencilZPass || data.stencilFuncMask !== material.stencilFuncMask || data.stencilWriteMask !== material.stencilWriteMask || data.side !== material.side || data.alphaToCoverage !== material.alphaToCoverage || data.sampleCount !== sampleCount || data.colorSpace !== colorSpace || data.colorFormat !== colorFormat || data.depthStencilFormat !== depthStencilFormat || data.primitiveTopology !== primitiveTopology || data.clippingContextCacheKey !== renderObject.clippingContext.cacheKey) {
            data.material = material;
            data.materialVersion = material.version;
            data.transparent = material.transparent;
            data.blending = material.blending;
            data.premultipliedAlpha = material.premultipliedAlpha;
            data.blendSrc = material.blendSrc;
            data.blendDst = material.blendDst;
            data.blendEquation = material.blendEquation;
            data.blendSrcAlpha = material.blendSrcAlpha;
            data.blendDstAlpha = material.blendDstAlpha;
            data.blendEquationAlpha = material.blendEquationAlpha;
            data.colorWrite = material.colorWrite;
            data.depthWrite = material.depthWrite;
            data.depthTest = material.depthTest;
            data.depthFunc = material.depthFunc;
            data.stencilWrite = material.stencilWrite;
            data.stencilFunc = material.stencilFunc;
            data.stencilFail = material.stencilFail;
            data.stencilZFail = material.stencilZFail;
            data.stencilZPass = material.stencilZPass;
            data.stencilFuncMask = material.stencilFuncMask;
            data.stencilWriteMask = material.stencilWriteMask;
            data.side = material.side;
            data.alphaToCoverage = material.alphaToCoverage;
            data.sampleCount = sampleCount;
            data.colorSpace = colorSpace;
            data.colorFormat = colorFormat;
            data.depthStencilFormat = depthStencilFormat;
            data.primitiveTopology = primitiveTopology;
            data.clippingContextCacheKey = renderObject.clippingContext.cacheKey;
            needsUpdate = true;
        }
        return needsUpdate;
    }
    getRenderCacheKey(renderObject) {
        const { object: object, material: material } = renderObject;
        const utils = this.utils;
        const renderContext = renderObject.context;
        return [
            material.transparent,
            material.blending,
            material.premultipliedAlpha,
            material.blendSrc,
            material.blendDst,
            material.blendEquation,
            material.blendSrcAlpha,
            material.blendDstAlpha,
            material.blendEquationAlpha,
            material.colorWrite,
            material.depthWrite,
            material.depthTest,
            material.depthFunc,
            material.stencilWrite,
            material.stencilFunc,
            material.stencilFail,
            material.stencilZFail,
            material.stencilZPass,
            material.stencilFuncMask,
            material.stencilWriteMask,
            material.side,
            utils.getSampleCountRenderContext(renderContext),
            utils.getCurrentColorSpace(renderContext),
            utils.getCurrentColorFormat(renderContext),
            utils.getCurrentDepthStencilFormat(renderContext),
            utils.getPrimitiveTopology(object, material),
            renderObject.getGeometryCacheKey(),
            renderObject.clippingContext.cacheKey
        ].join();
    }
    // textures
    createSampler(texture) {
        this.textureUtils.createSampler(texture);
    }
    destroySampler(texture) {
        this.textureUtils.destroySampler(texture);
    }
    createDefaultTexture(texture) {
        this.textureUtils.createDefaultTexture(texture);
    }
    createTexture(texture, options) {
        this.textureUtils.createTexture(texture, options);
    }
    updateTexture(texture, options) {
        this.textureUtils.updateTexture(texture, options);
    }
    generateMipmaps(texture) {
        this.textureUtils.generateMipmaps(texture);
    }
    destroyTexture(texture) {
        this.textureUtils.destroyTexture(texture);
    }
    copyTextureToBuffer(texture, x, y, width, height, faceIndex) {
        return this.textureUtils.copyTextureToBuffer(texture, x, y, width, height, faceIndex);
    }
    initTimestampQuery(renderContext, descriptor) {
        if (!this.trackTimestamp) return;
        const renderContextData = this.get(renderContext);
        if (!renderContextData.timeStampQuerySet) {
            // Create a GPUQuerySet which holds 2 timestamp query results: one for the
            // beginning and one for the end of compute pass execution.
            const timeStampQuerySet = this.device.createQuerySet({
                type: 'timestamp',
                count: 2
            });
            const timestampWrites = {
                querySet: timeStampQuerySet,
                beginningOfPassWriteIndex: 0,
                endOfPassWriteIndex: 1
            };
            Object.assign(descriptor, {
                timestampWrites: timestampWrites
            });
            renderContextData.timeStampQuerySet = timeStampQuerySet;
        }
    }
    // timestamp utils
    prepareTimestampBuffer(renderContext, encoder) {
        if (!this.trackTimestamp) return;
        const renderContextData = this.get(renderContext);
        const size = 2 * BigInt64Array.BYTES_PER_ELEMENT;
        if (renderContextData.currentTimestampQueryBuffers === undefined) renderContextData.currentTimestampQueryBuffers = {
            resolveBuffer: this.device.createBuffer({
                label: 'timestamp resolve buffer',
                size: size,
                usage: GPUBufferUsage.QUERY_RESOLVE | GPUBufferUsage.COPY_SRC
            }),
            resultBuffer: this.device.createBuffer({
                label: 'timestamp result buffer',
                size: size,
                usage: GPUBufferUsage.COPY_DST | GPUBufferUsage.MAP_READ
            }),
            isMappingPending: false
        };
        const { resolveBuffer: resolveBuffer, resultBuffer: resultBuffer, isMappingPending: isMappingPending } = renderContextData.currentTimestampQueryBuffers;
        if (isMappingPending === true) return;
        encoder.resolveQuerySet(renderContextData.timeStampQuerySet, 0, 2, resolveBuffer, 0);
        encoder.copyBufferToBuffer(resolveBuffer, 0, resultBuffer, 0, size);
    }
    async resolveTimestampAsync(renderContext, type = 'render') {
        if (!this.trackTimestamp) return;
        const renderContextData = this.get(renderContext);
        if (renderContextData.currentTimestampQueryBuffers === undefined) return;
        const { resultBuffer: resultBuffer, isMappingPending: isMappingPending } = renderContextData.currentTimestampQueryBuffers;
        if (isMappingPending === true) return;
        renderContextData.currentTimestampQueryBuffers.isMappingPending = true;
        resultBuffer.mapAsync(GPUMapMode.READ).then(()=>{
            const times = new BigUint64Array(resultBuffer.getMappedRange());
            const duration = Number(times[1] - times[0]) / 1000000;
            this.renderer.info.updateTimestamp(type, duration);
            resultBuffer.unmap();
            renderContextData.currentTimestampQueryBuffers.isMappingPending = false;
        });
    }
    // node builder
    createNodeBuilder(object, renderer) {
        return new (0, $59f98e181a42e0a2$export$2e2bcd8739ae039)(object, renderer);
    }
    // program
    createProgram(program) {
        const programGPU = this.get(program);
        programGPU.module = {
            module: this.device.createShaderModule({
                code: program.code,
                label: program.stage
            }),
            entryPoint: 'main'
        };
    }
    destroyProgram(program) {
        this.delete(program);
    }
    // pipelines
    createRenderPipeline(renderObject, promises) {
        this.pipelineUtils.createRenderPipeline(renderObject, promises);
    }
    createComputePipeline(computePipeline, bindings) {
        this.pipelineUtils.createComputePipeline(computePipeline, bindings);
    }
    beginBundle(renderContext) {
        const renderContextData = this.get(renderContext);
        renderContextData._currentPass = renderContextData.currentPass;
        renderContextData._currentSets = renderContextData.currentSets;
        renderContextData.currentSets = {
            attributes: {},
            bindingGroups: [],
            pipeline: null,
            index: null
        };
        renderContextData.currentPass = this.pipelineUtils.createBundleEncoder(renderContext);
    }
    finishBundle(renderContext, bundle) {
        const renderContextData = this.get(renderContext);
        const bundleEncoder = renderContextData.currentPass;
        const bundleGPU = bundleEncoder.finish();
        this.get(bundle).bundleGPU = bundleGPU;
        // restore render pass state
        renderContextData.currentSets = renderContextData._currentSets;
        renderContextData.currentPass = renderContextData._currentPass;
    }
    addBundle(renderContext, bundle) {
        const renderContextData = this.get(renderContext);
        renderContextData.renderBundles.push(this.get(bundle).bundleGPU);
    }
    // bindings
    createBindings(bindGroup) {
        this.bindingUtils.createBindings(bindGroup);
    }
    updateBindings(bindGroup) {
        this.bindingUtils.createBindings(bindGroup);
    }
    updateBinding(binding) {
        this.bindingUtils.updateBinding(binding);
    }
    // attributes
    createIndexAttribute(attribute) {
        this.attributeUtils.createAttribute(attribute, GPUBufferUsage.INDEX | GPUBufferUsage.COPY_SRC | GPUBufferUsage.COPY_DST);
    }
    createAttribute(attribute) {
        this.attributeUtils.createAttribute(attribute, GPUBufferUsage.VERTEX | GPUBufferUsage.COPY_SRC | GPUBufferUsage.COPY_DST);
    }
    createStorageAttribute(attribute) {
        this.attributeUtils.createAttribute(attribute, GPUBufferUsage.STORAGE | GPUBufferUsage.VERTEX | GPUBufferUsage.COPY_SRC | GPUBufferUsage.COPY_DST);
    }
    createIndirectStorageAttribute(attribute) {
        this.attributeUtils.createAttribute(attribute, GPUBufferUsage.STORAGE | GPUBufferUsage.INDIRECT | GPUBufferUsage.COPY_SRC | GPUBufferUsage.COPY_DST);
    }
    updateAttribute(attribute) {
        this.attributeUtils.updateAttribute(attribute);
    }
    destroyAttribute(attribute) {
        this.attributeUtils.destroyAttribute(attribute);
    }
    // canvas
    updateSize() {
        this.colorBuffer = this.textureUtils.getColorBuffer();
        this.defaultRenderPassdescriptor = null;
    }
    // utils public
    getMaxAnisotropy() {
        return 16;
    }
    hasFeature(name) {
        return this.device.features.has(name);
    }
    copyTextureToTexture(srcTexture, dstTexture, srcRegion = null, dstPosition = null, level = 0) {
        let dstX = 0;
        let dstY = 0;
        let dstLayer = 0;
        let srcX = 0;
        let srcY = 0;
        let srcLayer = 0;
        let srcWidth = srcTexture.image.width;
        let srcHeight = srcTexture.image.height;
        if (srcRegion !== null) {
            srcX = srcRegion.x;
            srcY = srcRegion.y;
            srcLayer = srcRegion.z || 0;
            srcWidth = srcRegion.width;
            srcHeight = srcRegion.height;
        }
        if (dstPosition !== null) {
            dstX = dstPosition.x;
            dstY = dstPosition.y;
            dstLayer = dstPosition.z || 0;
        }
        const encoder = this.device.createCommandEncoder({
            label: 'copyTextureToTexture_' + srcTexture.id + '_' + dstTexture.id
        });
        const sourceGPU = this.get(srcTexture).texture;
        const destinationGPU = this.get(dstTexture).texture;
        encoder.copyTextureToTexture({
            texture: sourceGPU,
            mipLevel: level,
            origin: {
                x: srcX,
                y: srcY,
                z: srcLayer
            }
        }, {
            texture: destinationGPU,
            mipLevel: level,
            origin: {
                x: dstX,
                y: dstY,
                z: dstLayer
            }
        }, [
            srcWidth,
            srcHeight,
            1
        ]);
        this.device.queue.submit([
            encoder.finish()
        ]);
    }
    copyFramebufferToTexture(texture, renderContext, rectangle) {
        const renderContextData = this.get(renderContext);
        let sourceGPU = null;
        if (renderContext.renderTarget) {
            if (texture.isDepthTexture) sourceGPU = this.get(renderContext.depthTexture).texture;
            else sourceGPU = this.get(renderContext.textures[0]).texture;
        } else if (texture.isDepthTexture) sourceGPU = this.textureUtils.getDepthBuffer(renderContext.depth, renderContext.stencil);
        else sourceGPU = this.context.getCurrentTexture();
        const destinationGPU = this.get(texture).texture;
        if (sourceGPU.format !== destinationGPU.format) {
            console.error('WebGPUBackend: copyFramebufferToTexture: Source and destination formats do not match.', sourceGPU.format, destinationGPU.format);
            return;
        }
        let encoder;
        if (renderContextData.currentPass) {
            renderContextData.currentPass.end();
            encoder = renderContextData.encoder;
        } else encoder = this.device.createCommandEncoder({
            label: 'copyFramebufferToTexture_' + texture.id
        });
        encoder.copyTextureToTexture({
            texture: sourceGPU,
            origin: {
                x: rectangle.x,
                y: rectangle.y,
                z: 0
            }
        }, {
            texture: destinationGPU
        }, [
            rectangle.z,
            rectangle.w
        ]);
        if (texture.generateMipmaps) this.textureUtils.generateMipmaps(texture);
        if (renderContextData.currentPass) {
            const { descriptor: descriptor } = renderContextData;
            for(let i = 0; i < descriptor.colorAttachments.length; i++)descriptor.colorAttachments[i].loadOp = (0, $65e789322b24f25c$export$e23f171c304e7eb1).Load;
            if (renderContext.depth) descriptor.depthStencilAttachment.depthLoadOp = (0, $65e789322b24f25c$export$e23f171c304e7eb1).Load;
            if (renderContext.stencil) descriptor.depthStencilAttachment.stencilLoadOp = (0, $65e789322b24f25c$export$e23f171c304e7eb1).Load;
            renderContextData.currentPass = encoder.beginRenderPass(descriptor);
            renderContextData.currentSets = {
                attributes: {},
                bindingGroups: [],
                pipeline: null,
                index: null
            };
        } else this.device.queue.submit([
            encoder.finish()
        ]);
    }
}
var $00002c23d5ded4a6$export$2e2bcd8739ae039 = $00002c23d5ded4a6$var$WebGPUBackend;








class $f2c168c1ef3d4267$export$24c72f71cbaf0678 extends (0, $7711e1b3c41f4d78$export$a2d8b23205c25948) {
    static get type() {
        return 'MeshPhongMaterial';
    }
    constructor(parameters){
        super();
        this.isMeshPhongMaterial = true;
        this.color = new (0, $9a23ce591a1b6760$export$892596cec99bc70e)(0xffffff); // diffuse
        this.specular = new (0, $9a23ce591a1b6760$export$892596cec99bc70e)(0x111111);
        this.shininess = 30;
        this.map = null;
        this.lightMap = null;
        this.lightMapIntensity = 1.0;
        this.aoMap = null;
        this.aoMapIntensity = 1.0;
        this.emissive = new (0, $9a23ce591a1b6760$export$892596cec99bc70e)(0x000000);
        this.emissiveIntensity = 1.0;
        this.emissiveMap = null;
        this.bumpMap = null;
        this.bumpScale = 1;
        this.normalMap = null;
        this.normalMapType = (0, $cb5ee595c0f892af$export$2852a58ebdac27b8);
        this.normalScale = new (0, $3c03061dea0adea3$export$c977b3e384af9ae1)(1, 1);
        this.displacementMap = null;
        this.displacementScale = 1;
        this.displacementBias = 0;
        this.specularMap = null;
        this.alphaMap = null;
        this.envMap = null;
        this.envMapRotation = new (0, $ac384e7663319ba6$export$d93cc409a0768c5f)();
        this.combine = (0, $cb5ee595c0f892af$export$e50ac29801f1774d);
        this.reflectivity = 1;
        this.refractionRatio = 0.98;
        this.wireframe = false;
        this.wireframeLinewidth = 1;
        this.wireframeLinecap = 'round';
        this.wireframeLinejoin = 'round';
        this.flatShading = false;
        this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.specular.copy(source.specular);
        this.shininess = source.shininess;
        this.map = source.map;
        this.lightMap = source.lightMap;
        this.lightMapIntensity = source.lightMapIntensity;
        this.aoMap = source.aoMap;
        this.aoMapIntensity = source.aoMapIntensity;
        this.emissive.copy(source.emissive);
        this.emissiveMap = source.emissiveMap;
        this.emissiveIntensity = source.emissiveIntensity;
        this.bumpMap = source.bumpMap;
        this.bumpScale = source.bumpScale;
        this.normalMap = source.normalMap;
        this.normalMapType = source.normalMapType;
        this.normalScale.copy(source.normalScale);
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.specularMap = source.specularMap;
        this.alphaMap = source.alphaMap;
        this.envMap = source.envMap;
        this.envMapRotation.copy(source.envMapRotation);
        this.combine = source.combine;
        this.reflectivity = source.reflectivity;
        this.refractionRatio = source.refractionRatio;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.wireframeLinecap = source.wireframeLinecap;
        this.wireframeLinejoin = source.wireframeLinejoin;
        this.flatShading = source.flatShading;
        this.fog = source.fog;
        return this;
    }
}









const $30b28559a96c3ca3$var$_defaultValues = /*@__PURE__*/ new (0, $f2c168c1ef3d4267$export$24c72f71cbaf0678)();
class $30b28559a96c3ca3$var$MeshPhongNodeMaterial extends (0, $1a485f4d26090da0$export$2e2bcd8739ae039) {
    static get type() {
        return 'MeshPhongNodeMaterial';
    }
    constructor(parameters){
        super();
        this.isMeshPhongNodeMaterial = true;
        this.lights = true;
        this.shininessNode = null;
        this.specularNode = null;
        this.setDefaultValues($30b28559a96c3ca3$var$_defaultValues);
        this.setValues(parameters);
    }
    setupEnvironment(builder) {
        const envNode = super.setupEnvironment(builder);
        return envNode ? new (0, $eb1fde74125000ac$export$2e2bcd8739ae039)(envNode) : null;
    }
    setupLightingModel() {
        return new (0, $4771908cdc45bf93$export$2e2bcd8739ae039)();
    }
    setupVariants() {
        // SHININESS
        const shininessNode = (this.shininessNode ? (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(this.shininessNode) : (0, $8e4701fdb55563f1$export$e3d16a46fd4e0183)).max(1e-4); // to prevent pow( 0.0, 0.0 )
        (0, $dd761eb0c8b88ca7$export$245b4c35387657dc).assign(shininessNode);
        // SPECULAR COLOR
        const specularNode = this.specularNode || (0, $8e4701fdb55563f1$export$1e2bd0cb74f57b97);
        (0, $dd761eb0c8b88ca7$export$e1aa5ee431e11795).assign(specularNode);
    }
    copy(source) {
        this.shininessNode = source.shininessNode;
        this.specularNode = source.specularNode;
        return super.copy(source);
    }
}
var $30b28559a96c3ca3$export$2e2bcd8739ae039 = $30b28559a96c3ca3$var$MeshPhongNodeMaterial;







class $248228003d1ce111$export$f2980790215acccd extends (0, $7711e1b3c41f4d78$export$a2d8b23205c25948) {
    static get type() {
        return 'MeshStandardMaterial';
    }
    constructor(parameters){
        super();
        this.isMeshStandardMaterial = true;
        this.defines = {
            'STANDARD': ''
        };
        this.color = new (0, $9a23ce591a1b6760$export$892596cec99bc70e)(0xffffff); // diffuse
        this.roughness = 1.0;
        this.metalness = 0.0;
        this.map = null;
        this.lightMap = null;
        this.lightMapIntensity = 1.0;
        this.aoMap = null;
        this.aoMapIntensity = 1.0;
        this.emissive = new (0, $9a23ce591a1b6760$export$892596cec99bc70e)(0x000000);
        this.emissiveIntensity = 1.0;
        this.emissiveMap = null;
        this.bumpMap = null;
        this.bumpScale = 1;
        this.normalMap = null;
        this.normalMapType = (0, $cb5ee595c0f892af$export$2852a58ebdac27b8);
        this.normalScale = new (0, $3c03061dea0adea3$export$c977b3e384af9ae1)(1, 1);
        this.displacementMap = null;
        this.displacementScale = 1;
        this.displacementBias = 0;
        this.roughnessMap = null;
        this.metalnessMap = null;
        this.alphaMap = null;
        this.envMap = null;
        this.envMapRotation = new (0, $ac384e7663319ba6$export$d93cc409a0768c5f)();
        this.envMapIntensity = 1.0;
        this.wireframe = false;
        this.wireframeLinewidth = 1;
        this.wireframeLinecap = 'round';
        this.wireframeLinejoin = 'round';
        this.flatShading = false;
        this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.defines = {
            'STANDARD': ''
        };
        this.color.copy(source.color);
        this.roughness = source.roughness;
        this.metalness = source.metalness;
        this.map = source.map;
        this.lightMap = source.lightMap;
        this.lightMapIntensity = source.lightMapIntensity;
        this.aoMap = source.aoMap;
        this.aoMapIntensity = source.aoMapIntensity;
        this.emissive.copy(source.emissive);
        this.emissiveMap = source.emissiveMap;
        this.emissiveIntensity = source.emissiveIntensity;
        this.bumpMap = source.bumpMap;
        this.bumpScale = source.bumpScale;
        this.normalMap = source.normalMap;
        this.normalMapType = source.normalMapType;
        this.normalScale.copy(source.normalScale);
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.roughnessMap = source.roughnessMap;
        this.metalnessMap = source.metalnessMap;
        this.alphaMap = source.alphaMap;
        this.envMap = source.envMap;
        this.envMapRotation.copy(source.envMapRotation);
        this.envMapIntensity = source.envMapIntensity;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.wireframeLinecap = source.wireframeLinecap;
        this.wireframeLinejoin = source.wireframeLinejoin;
        this.flatShading = source.flatShading;
        this.fog = source.fog;
        return this;
    }
}











const $c6c766f08d29b743$var$_defaultValues = /*@__PURE__*/ new (0, $248228003d1ce111$export$f2980790215acccd)();
class $c6c766f08d29b743$var$MeshStandardNodeMaterial extends (0, $1a485f4d26090da0$export$2e2bcd8739ae039) {
    static get type() {
        return 'MeshStandardNodeMaterial';
    }
    constructor(parameters){
        super();
        this.isMeshStandardNodeMaterial = true;
        this.lights = true;
        this.emissiveNode = null;
        this.metalnessNode = null;
        this.roughnessNode = null;
        this.setDefaultValues($c6c766f08d29b743$var$_defaultValues);
        this.setValues(parameters);
    }
    setupEnvironment(builder) {
        let envNode = super.setupEnvironment(builder);
        if (envNode === null && builder.environmentNode) envNode = builder.environmentNode;
        return envNode ? new (0, $7f10f4fffce72c39$export$2e2bcd8739ae039)(envNode) : null;
    }
    setupLightingModel() {
        return new (0, $e78cda5c083cf9f1$export$2e2bcd8739ae039)();
    }
    setupSpecular() {
        const specularColorNode = (0, $f37ae0e58866c183$export$2c9e8a9632a706b2)((0, $d5b7ee61758b2e81$export$9100789c9d999364)(0.04), (0, $dd761eb0c8b88ca7$export$3a790f19f33c5176).rgb, (0, $dd761eb0c8b88ca7$export$a0ae10b9403517f8));
        (0, $dd761eb0c8b88ca7$export$e1aa5ee431e11795).assign(specularColorNode);
        (0, $dd761eb0c8b88ca7$export$fa391975b9b85621).assign(1.0);
    }
    setupVariants() {
        // METALNESS
        const metalnessNode = this.metalnessNode ? (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(this.metalnessNode) : (0, $8e4701fdb55563f1$export$ed4ec59eb9c0ad6c);
        (0, $dd761eb0c8b88ca7$export$a0ae10b9403517f8).assign(metalnessNode);
        // ROUGHNESS
        let roughnessNode = this.roughnessNode ? (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(this.roughnessNode) : (0, $8e4701fdb55563f1$export$c372ad2642cfd701);
        roughnessNode = (0, $92d764f415b878f6$export$2e2bcd8739ae039)({
            roughness: roughnessNode
        });
        (0, $dd761eb0c8b88ca7$export$df3004878062a594).assign(roughnessNode);
        // SPECULAR COLOR
        this.setupSpecular();
        // DIFFUSE COLOR
        (0, $dd761eb0c8b88ca7$export$3a790f19f33c5176).assign((0, $d5b7ee61758b2e81$export$6dba2a1f0d609415)((0, $dd761eb0c8b88ca7$export$3a790f19f33c5176).rgb.mul(metalnessNode.oneMinus()), (0, $dd761eb0c8b88ca7$export$3a790f19f33c5176).a));
    }
    copy(source) {
        this.emissiveNode = source.emissiveNode;
        this.metalnessNode = source.metalnessNode;
        this.roughnessNode = source.roughnessNode;
        return super.copy(source);
    }
}
var $c6c766f08d29b743$export$2e2bcd8739ae039 = $c6c766f08d29b743$var$MeshStandardNodeMaterial;






class $3916ce630a03508a$export$28d04986c4269c9f extends (0, $248228003d1ce111$export$f2980790215acccd) {
    static get type() {
        return 'MeshPhysicalMaterial';
    }
    constructor(parameters){
        super();
        this.isMeshPhysicalMaterial = true;
        this.defines = {
            'STANDARD': '',
            'PHYSICAL': ''
        };
        this.anisotropyRotation = 0;
        this.anisotropyMap = null;
        this.clearcoatMap = null;
        this.clearcoatRoughness = 0.0;
        this.clearcoatRoughnessMap = null;
        this.clearcoatNormalScale = new (0, $3c03061dea0adea3$export$c977b3e384af9ae1)(1, 1);
        this.clearcoatNormalMap = null;
        this.ior = 1.5;
        Object.defineProperty(this, 'reflectivity', {
            get: function() {
                return $7f727a3c7059d20d$export$7d15b64cf5a3a4c4(2.5 * (this.ior - 1) / (this.ior + 1), 0, 1);
            },
            set: function(reflectivity) {
                this.ior = (1 + 0.4 * reflectivity) / (1 - 0.4 * reflectivity);
            }
        });
        this.iridescenceMap = null;
        this.iridescenceIOR = 1.3;
        this.iridescenceThicknessRange = [
            100,
            400
        ];
        this.iridescenceThicknessMap = null;
        this.sheenColor = new (0, $9a23ce591a1b6760$export$892596cec99bc70e)(0x000000);
        this.sheenColorMap = null;
        this.sheenRoughness = 1.0;
        this.sheenRoughnessMap = null;
        this.transmissionMap = null;
        this.thickness = 0;
        this.thicknessMap = null;
        this.attenuationDistance = Infinity;
        this.attenuationColor = new (0, $9a23ce591a1b6760$export$892596cec99bc70e)(1, 1, 1);
        this.specularIntensity = 1.0;
        this.specularIntensityMap = null;
        this.specularColor = new (0, $9a23ce591a1b6760$export$892596cec99bc70e)(1, 1, 1);
        this.specularColorMap = null;
        this._anisotropy = 0;
        this._clearcoat = 0;
        this._dispersion = 0;
        this._iridescence = 0;
        this._sheen = 0.0;
        this._transmission = 0;
        this.setValues(parameters);
    }
    get anisotropy() {
        return this._anisotropy;
    }
    set anisotropy(value) {
        if (this._anisotropy > 0 !== value > 0) this.version++;
        this._anisotropy = value;
    }
    get clearcoat() {
        return this._clearcoat;
    }
    set clearcoat(value) {
        if (this._clearcoat > 0 !== value > 0) this.version++;
        this._clearcoat = value;
    }
    get iridescence() {
        return this._iridescence;
    }
    set iridescence(value) {
        if (this._iridescence > 0 !== value > 0) this.version++;
        this._iridescence = value;
    }
    get dispersion() {
        return this._dispersion;
    }
    set dispersion(value) {
        if (this._dispersion > 0 !== value > 0) this.version++;
        this._dispersion = value;
    }
    get sheen() {
        return this._sheen;
    }
    set sheen(value) {
        if (this._sheen > 0 !== value > 0) this.version++;
        this._sheen = value;
    }
    get transmission() {
        return this._transmission;
    }
    set transmission(value) {
        if (this._transmission > 0 !== value > 0) this.version++;
        this._transmission = value;
    }
    copy(source) {
        super.copy(source);
        this.defines = {
            'STANDARD': '',
            'PHYSICAL': ''
        };
        this.anisotropy = source.anisotropy;
        this.anisotropyRotation = source.anisotropyRotation;
        this.anisotropyMap = source.anisotropyMap;
        this.clearcoat = source.clearcoat;
        this.clearcoatMap = source.clearcoatMap;
        this.clearcoatRoughness = source.clearcoatRoughness;
        this.clearcoatRoughnessMap = source.clearcoatRoughnessMap;
        this.clearcoatNormalMap = source.clearcoatNormalMap;
        this.clearcoatNormalScale.copy(source.clearcoatNormalScale);
        this.dispersion = source.dispersion;
        this.ior = source.ior;
        this.iridescence = source.iridescence;
        this.iridescenceMap = source.iridescenceMap;
        this.iridescenceIOR = source.iridescenceIOR;
        this.iridescenceThicknessRange = [
            ...source.iridescenceThicknessRange
        ];
        this.iridescenceThicknessMap = source.iridescenceThicknessMap;
        this.sheen = source.sheen;
        this.sheenColor.copy(source.sheenColor);
        this.sheenColorMap = source.sheenColorMap;
        this.sheenRoughness = source.sheenRoughness;
        this.sheenRoughnessMap = source.sheenRoughnessMap;
        this.transmission = source.transmission;
        this.transmissionMap = source.transmissionMap;
        this.thickness = source.thickness;
        this.thicknessMap = source.thicknessMap;
        this.attenuationDistance = source.attenuationDistance;
        this.attenuationColor.copy(source.attenuationColor);
        this.specularIntensity = source.specularIntensity;
        this.specularIntensityMap = source.specularIntensityMap;
        this.specularColor.copy(source.specularColor);
        this.specularColorMap = source.specularColorMap;
        return this;
    }
}











const $3433103932e4dc09$var$_defaultValues = /*@__PURE__*/ new (0, $3916ce630a03508a$export$28d04986c4269c9f)();
class $3433103932e4dc09$var$MeshPhysicalNodeMaterial extends (0, $c6c766f08d29b743$export$2e2bcd8739ae039) {
    static get type() {
        return 'MeshPhysicalNodeMaterial';
    }
    constructor(parameters){
        super();
        this.isMeshPhysicalNodeMaterial = true;
        this.clearcoatNode = null;
        this.clearcoatRoughnessNode = null;
        this.clearcoatNormalNode = null;
        this.sheenNode = null;
        this.sheenRoughnessNode = null;
        this.iridescenceNode = null;
        this.iridescenceIORNode = null;
        this.iridescenceThicknessNode = null;
        this.specularIntensityNode = null;
        this.specularColorNode = null;
        this.iorNode = null;
        this.transmissionNode = null;
        this.thicknessNode = null;
        this.attenuationDistanceNode = null;
        this.attenuationColorNode = null;
        this.dispersionNode = null;
        this.anisotropyNode = null;
        this.setDefaultValues($3433103932e4dc09$var$_defaultValues);
        this.setValues(parameters);
    }
    get useClearcoat() {
        return this.clearcoat > 0 || this.clearcoatNode !== null;
    }
    get useIridescence() {
        return this.iridescence > 0 || this.iridescenceNode !== null;
    }
    get useSheen() {
        return this.sheen > 0 || this.sheenNode !== null;
    }
    get useAnisotropy() {
        return this.anisotropy > 0 || this.anisotropyNode !== null;
    }
    get useTransmission() {
        return this.transmission > 0 || this.transmissionNode !== null;
    }
    get useDispersion() {
        return this.dispersion > 0 || this.dispersionNode !== null;
    }
    setupSpecular() {
        const iorNode = this.iorNode ? (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(this.iorNode) : (0, $8e4701fdb55563f1$export$d40ae3ddf6fd407f);
        (0, $dd761eb0c8b88ca7$export$9b6d27e550bdd04d).assign(iorNode);
        (0, $dd761eb0c8b88ca7$export$e1aa5ee431e11795).assign((0, $f37ae0e58866c183$export$2c9e8a9632a706b2)((0, $f37ae0e58866c183$export$96ec731ed4dcb222)((0, $f37ae0e58866c183$export$fa569bd808b67eef)((0, $dd761eb0c8b88ca7$export$9b6d27e550bdd04d).sub(1.0).div((0, $dd761eb0c8b88ca7$export$9b6d27e550bdd04d).add(1.0))).mul((0, $8e4701fdb55563f1$export$5447cf3a560d2eed)), (0, $d5b7ee61758b2e81$export$9100789c9d999364)(1.0)).mul((0, $8e4701fdb55563f1$export$36b44793527d6347)), (0, $dd761eb0c8b88ca7$export$3a790f19f33c5176).rgb, (0, $dd761eb0c8b88ca7$export$a0ae10b9403517f8)));
        (0, $dd761eb0c8b88ca7$export$fa391975b9b85621).assign((0, $f37ae0e58866c183$export$2c9e8a9632a706b2)((0, $8e4701fdb55563f1$export$36b44793527d6347), 1.0, (0, $dd761eb0c8b88ca7$export$a0ae10b9403517f8)));
    }
    setupLightingModel() {
        return new (0, $e78cda5c083cf9f1$export$2e2bcd8739ae039)(this.useClearcoat, this.useSheen, this.useIridescence, this.useAnisotropy, this.useTransmission, this.useDispersion);
    }
    setupVariants(builder) {
        super.setupVariants(builder);
        // CLEARCOAT
        if (this.useClearcoat) {
            const clearcoatNode = this.clearcoatNode ? (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(this.clearcoatNode) : (0, $8e4701fdb55563f1$export$bcb4b1fc59604158);
            const clearcoatRoughnessNode = this.clearcoatRoughnessNode ? (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(this.clearcoatRoughnessNode) : (0, $8e4701fdb55563f1$export$1deee7039751e39b);
            (0, $dd761eb0c8b88ca7$export$9b0829dedd347475).assign(clearcoatNode);
            (0, $dd761eb0c8b88ca7$export$2747d91296dfac86).assign((0, $92d764f415b878f6$export$2e2bcd8739ae039)({
                roughness: clearcoatRoughnessNode
            }));
        }
        // SHEEN
        if (this.useSheen) {
            const sheenNode = this.sheenNode ? (0, $d5b7ee61758b2e81$export$9100789c9d999364)(this.sheenNode) : (0, $8e4701fdb55563f1$export$ca8d8f9bb84c2b06);
            const sheenRoughnessNode = this.sheenRoughnessNode ? (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(this.sheenRoughnessNode) : (0, $8e4701fdb55563f1$export$c53217b49af64201);
            (0, $dd761eb0c8b88ca7$export$7cccf56baed94cee).assign(sheenNode);
            (0, $dd761eb0c8b88ca7$export$40c82d21b5c7315b).assign(sheenRoughnessNode);
        }
        // IRIDESCENCE
        if (this.useIridescence) {
            const iridescenceNode = this.iridescenceNode ? (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(this.iridescenceNode) : (0, $8e4701fdb55563f1$export$2991d95653bddf71);
            const iridescenceIORNode = this.iridescenceIORNode ? (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(this.iridescenceIORNode) : (0, $8e4701fdb55563f1$export$4d5a92c4b0801e42);
            const iridescenceThicknessNode = this.iridescenceThicknessNode ? (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(this.iridescenceThicknessNode) : (0, $8e4701fdb55563f1$export$edac0c112e716da0);
            (0, $dd761eb0c8b88ca7$export$8fa8908d67be43df).assign(iridescenceNode);
            (0, $dd761eb0c8b88ca7$export$e8f290002a000efa).assign(iridescenceIORNode);
            (0, $dd761eb0c8b88ca7$export$af4f9ca0bc04b1e).assign(iridescenceThicknessNode);
        }
        // ANISOTROPY
        if (this.useAnisotropy) {
            const anisotropyV = (this.anisotropyNode ? (0, $d5b7ee61758b2e81$export$e9830bc863290a54)(this.anisotropyNode) : (0, $8e4701fdb55563f1$export$415abbd8a1393676)).toVar();
            (0, $dd761eb0c8b88ca7$export$13e470198a4f720a).assign(anisotropyV.length());
            (0, $d5b7ee61758b2e81$export$1f9ff5f4a6c9361a)((0, $dd761eb0c8b88ca7$export$13e470198a4f720a).equal(0.0), ()=>{
                anisotropyV.assign((0, $d5b7ee61758b2e81$export$e9830bc863290a54)(1.0, 0.0));
            }).Else(()=>{
                anisotropyV.divAssign((0, $d5b7ee61758b2e81$export$e9830bc863290a54)((0, $dd761eb0c8b88ca7$export$13e470198a4f720a)));
                (0, $dd761eb0c8b88ca7$export$13e470198a4f720a).assign((0, $dd761eb0c8b88ca7$export$13e470198a4f720a).saturate());
            });
            // Roughness along the anisotropy bitangent is the material roughness, while the tangent roughness increases with anisotropy.
            (0, $dd761eb0c8b88ca7$export$6b527ce29f545f8c).assign((0, $dd761eb0c8b88ca7$export$13e470198a4f720a).pow2().mix((0, $dd761eb0c8b88ca7$export$df3004878062a594).pow2(), 1.0));
            (0, $dd761eb0c8b88ca7$export$56937cc288fe4ea7).assign((0, $d0a60d4044396068$export$6b671943eab6b881)[0].mul(anisotropyV.x).add((0, $d0a60d4044396068$export$6b671943eab6b881)[1].mul(anisotropyV.y)));
            (0, $dd761eb0c8b88ca7$export$5748f3030096f448).assign((0, $d0a60d4044396068$export$6b671943eab6b881)[1].mul(anisotropyV.x).sub((0, $d0a60d4044396068$export$6b671943eab6b881)[0].mul(anisotropyV.y)));
        }
        // TRANSMISSION
        if (this.useTransmission) {
            const transmissionNode = this.transmissionNode ? (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(this.transmissionNode) : (0, $8e4701fdb55563f1$export$7a411e4bff144ff0);
            const thicknessNode = this.thicknessNode ? (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(this.thicknessNode) : (0, $8e4701fdb55563f1$export$be136e21cc092e66);
            const attenuationDistanceNode = this.attenuationDistanceNode ? (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(this.attenuationDistanceNode) : (0, $8e4701fdb55563f1$export$87501a08ff35a5d0);
            const attenuationColorNode = this.attenuationColorNode ? (0, $d5b7ee61758b2e81$export$9100789c9d999364)(this.attenuationColorNode) : (0, $8e4701fdb55563f1$export$ad54381cfb1f8a9c);
            (0, $dd761eb0c8b88ca7$export$48b427a8e82dea20).assign(transmissionNode);
            (0, $dd761eb0c8b88ca7$export$70328e7fc5b512a3).assign(thicknessNode);
            (0, $dd761eb0c8b88ca7$export$dfdcdac9ec5733ba).assign(attenuationDistanceNode);
            (0, $dd761eb0c8b88ca7$export$4e929bebb52dac2c).assign(attenuationColorNode);
            if (this.useDispersion) {
                const dispersionNode = this.dispersionNode ? (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(this.dispersionNode) : (0, $8e4701fdb55563f1$export$e9b48f5b27265c30);
                (0, $dd761eb0c8b88ca7$export$6cf2c7e842feef4c).assign(dispersionNode);
            }
        }
    }
    setupClearcoatNormal() {
        return this.clearcoatNormalNode ? (0, $d5b7ee61758b2e81$export$9100789c9d999364)(this.clearcoatNormalNode) : (0, $8e4701fdb55563f1$export$1e8c99bce15509ea);
    }
    setup(builder) {
        builder.context.setupClearcoatNormal = ()=>this.setupClearcoatNormal(builder);
        super.setup(builder);
    }
    copy(source) {
        this.clearcoatNode = source.clearcoatNode;
        this.clearcoatRoughnessNode = source.clearcoatRoughnessNode;
        this.clearcoatNormalNode = source.clearcoatNormalNode;
        this.sheenNode = source.sheenNode;
        this.sheenRoughnessNode = source.sheenRoughnessNode;
        this.iridescenceNode = source.iridescenceNode;
        this.iridescenceIORNode = source.iridescenceIORNode;
        this.iridescenceThicknessNode = source.iridescenceThicknessNode;
        this.specularIntensityNode = source.specularIntensityNode;
        this.specularColorNode = source.specularColorNode;
        this.transmissionNode = source.transmissionNode;
        this.thicknessNode = source.thicknessNode;
        this.attenuationDistanceNode = source.attenuationDistanceNode;
        this.attenuationColorNode = source.attenuationColorNode;
        this.dispersionNode = source.dispersionNode;
        this.anisotropyNode = source.anisotropyNode;
        return super.copy(source);
    }
}
var $3433103932e4dc09$export$2e2bcd8739ae039 = $3433103932e4dc09$var$MeshPhysicalNodeMaterial;






class $df676fc8522e06be$export$df893cf97e765622 extends (0, $7711e1b3c41f4d78$export$a2d8b23205c25948) {
    static get type() {
        return 'MeshToonMaterial';
    }
    constructor(parameters){
        super();
        this.isMeshToonMaterial = true;
        this.defines = {
            'TOON': ''
        };
        this.color = new (0, $9a23ce591a1b6760$export$892596cec99bc70e)(0xffffff);
        this.map = null;
        this.gradientMap = null;
        this.lightMap = null;
        this.lightMapIntensity = 1.0;
        this.aoMap = null;
        this.aoMapIntensity = 1.0;
        this.emissive = new (0, $9a23ce591a1b6760$export$892596cec99bc70e)(0x000000);
        this.emissiveIntensity = 1.0;
        this.emissiveMap = null;
        this.bumpMap = null;
        this.bumpScale = 1;
        this.normalMap = null;
        this.normalMapType = (0, $cb5ee595c0f892af$export$2852a58ebdac27b8);
        this.normalScale = new (0, $3c03061dea0adea3$export$c977b3e384af9ae1)(1, 1);
        this.displacementMap = null;
        this.displacementScale = 1;
        this.displacementBias = 0;
        this.alphaMap = null;
        this.wireframe = false;
        this.wireframeLinewidth = 1;
        this.wireframeLinecap = 'round';
        this.wireframeLinejoin = 'round';
        this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.map = source.map;
        this.gradientMap = source.gradientMap;
        this.lightMap = source.lightMap;
        this.lightMapIntensity = source.lightMapIntensity;
        this.aoMap = source.aoMap;
        this.aoMapIntensity = source.aoMapIntensity;
        this.emissive.copy(source.emissive);
        this.emissiveMap = source.emissiveMap;
        this.emissiveIntensity = source.emissiveIntensity;
        this.bumpMap = source.bumpMap;
        this.bumpScale = source.bumpScale;
        this.normalMap = source.normalMap;
        this.normalMapType = source.normalMapType;
        this.normalScale.copy(source.normalScale);
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.alphaMap = source.alphaMap;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.wireframeLinecap = source.wireframeLinecap;
        this.wireframeLinejoin = source.wireframeLinejoin;
        this.fog = source.fog;
        return this;
    }
}










const $3ac130ef03749e03$var$getGradientIrradiance = /*@__PURE__*/ (0, $d5b7ee61758b2e81$export$b076717d71a1a47f)(({ normal: normal, lightDirection: lightDirection, builder: builder })=>{
    // dotNL will be from -1.0 to 1.0
    const dotNL = normal.dot(lightDirection);
    const coord = (0, $d5b7ee61758b2e81$export$e9830bc863290a54)(dotNL.mul(0.5).add(0.5), 0.0);
    if (builder.material.gradientMap) {
        const gradientMap = (0, $148d94357f05ebae$export$f503be583015cb4f)('gradientMap', 'texture').context({
            getUV: ()=>coord
        });
        return (0, $d5b7ee61758b2e81$export$9100789c9d999364)(gradientMap.r);
    } else {
        const fw = coord.fwidth().mul(0.5);
        return (0, $f37ae0e58866c183$export$2c9e8a9632a706b2)((0, $d5b7ee61758b2e81$export$9100789c9d999364)(0.7), (0, $d5b7ee61758b2e81$export$9100789c9d999364)(1.0), (0, $f37ae0e58866c183$export$4053e36566dd3d9a)((0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(0.7).sub(fw.x), (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(0.7).add(fw.x), coord.x));
    }
});
class $3ac130ef03749e03$var$ToonLightingModel extends (0, $e15d7fb89e2d8a53$export$2e2bcd8739ae039) {
    direct({ lightDirection: lightDirection, lightColor: lightColor, reflectedLight: reflectedLight }, stack, builder) {
        const irradiance = $3ac130ef03749e03$var$getGradientIrradiance({
            normal: (0, $0ab44deffc8ae973$export$2d025416a9cb464f),
            lightDirection: lightDirection,
            builder: builder
        }).mul(lightColor);
        reflectedLight.directDiffuse.addAssign(irradiance.mul((0, $f21c2fe74f9eb092$export$2e2bcd8739ae039)({
            diffuseColor: (0, $dd761eb0c8b88ca7$export$3a790f19f33c5176).rgb
        })));
    }
    indirect({ ambientOcclusion: ambientOcclusion, irradiance: irradiance, reflectedLight: reflectedLight }) {
        reflectedLight.indirectDiffuse.addAssign(irradiance.mul((0, $f21c2fe74f9eb092$export$2e2bcd8739ae039)({
            diffuseColor: $dd761eb0c8b88ca7$export$3a790f19f33c5176
        })));
        reflectedLight.indirectDiffuse.mulAssign(ambientOcclusion);
    }
}
var $3ac130ef03749e03$export$2e2bcd8739ae039 = $3ac130ef03749e03$var$ToonLightingModel;



const $166fc548c8edaf45$var$_defaultValues = /*@__PURE__*/ new (0, $df676fc8522e06be$export$df893cf97e765622)();
class $166fc548c8edaf45$var$MeshToonNodeMaterial extends (0, $1a485f4d26090da0$export$2e2bcd8739ae039) {
    static get type() {
        return 'MeshToonNodeMaterial';
    }
    constructor(parameters){
        super();
        this.isMeshToonNodeMaterial = true;
        this.lights = true;
        this.setDefaultValues($166fc548c8edaf45$var$_defaultValues);
        this.setValues(parameters);
    }
    setupLightingModel() {
        return new (0, $3ac130ef03749e03$export$2e2bcd8739ae039)();
    }
}
var $166fc548c8edaf45$export$2e2bcd8739ae039 = $166fc548c8edaf45$var$MeshToonNodeMaterial;








class $75fbe5b95d2d1e0e$var$BasicLightMapNode extends (0, $cdb0844205e5f290$export$2e2bcd8739ae039) {
    static get type() {
        return 'BasicLightMapNode';
    }
    constructor(lightMapNode = null){
        super();
        this.lightMapNode = lightMapNode;
    }
    setup(builder) {
        // irradianceLightMap property is used in the indirectDiffuse() method of BasicLightingModel
        const RECIPROCAL_PI = (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(1 / Math.PI);
        builder.context.irradianceLightMap = this.lightMapNode.mul(RECIPROCAL_PI);
    }
}
var $75fbe5b95d2d1e0e$export$2e2bcd8739ae039 = $75fbe5b95d2d1e0e$var$BasicLightMapNode;






const $4b8c69dc5d4bb347$var$_defaultValues = /*@__PURE__*/ new (0, $30428884caacd4ad$export$55cbcc9b622fe1f5)();
class $4b8c69dc5d4bb347$var$MeshBasicNodeMaterial extends (0, $1a485f4d26090da0$export$2e2bcd8739ae039) {
    static get type() {
        return 'MeshBasicNodeMaterial';
    }
    constructor(parameters){
        super();
        this.isMeshBasicNodeMaterial = true;
        this.lights = true;
        this.setDefaultValues($4b8c69dc5d4bb347$var$_defaultValues);
        this.setValues(parameters);
    }
    setupNormal() {
        return 0, $0ab44deffc8ae973$export$c7d7ec78bf3ab28a; // see #28839
    }
    setupEnvironment(builder) {
        const envNode = super.setupEnvironment(builder);
        return envNode ? new (0, $eb1fde74125000ac$export$2e2bcd8739ae039)(envNode) : null;
    }
    setupLightMap(builder) {
        let node = null;
        if (builder.material.lightMap) node = new (0, $75fbe5b95d2d1e0e$export$2e2bcd8739ae039)((0, $8e4701fdb55563f1$export$4d5913e0c9a9ccca));
        return node;
    }
    setupOutgoingLight() {
        return (0, $dd761eb0c8b88ca7$export$3a790f19f33c5176).rgb;
    }
    setupLightingModel() {
        return new (0, $87063ef446f2f682$export$2e2bcd8739ae039)();
    }
}
var $4b8c69dc5d4bb347$export$2e2bcd8739ae039 = $4b8c69dc5d4bb347$var$MeshBasicNodeMaterial;







class $da18a46d400c99e2$export$5023a9a8114806b8 extends (0, $7711e1b3c41f4d78$export$a2d8b23205c25948) {
    static get type() {
        return 'MeshLambertMaterial';
    }
    constructor(parameters){
        super();
        this.isMeshLambertMaterial = true;
        this.color = new (0, $9a23ce591a1b6760$export$892596cec99bc70e)(0xffffff); // diffuse
        this.map = null;
        this.lightMap = null;
        this.lightMapIntensity = 1.0;
        this.aoMap = null;
        this.aoMapIntensity = 1.0;
        this.emissive = new (0, $9a23ce591a1b6760$export$892596cec99bc70e)(0x000000);
        this.emissiveIntensity = 1.0;
        this.emissiveMap = null;
        this.bumpMap = null;
        this.bumpScale = 1;
        this.normalMap = null;
        this.normalMapType = (0, $cb5ee595c0f892af$export$2852a58ebdac27b8);
        this.normalScale = new (0, $3c03061dea0adea3$export$c977b3e384af9ae1)(1, 1);
        this.displacementMap = null;
        this.displacementScale = 1;
        this.displacementBias = 0;
        this.specularMap = null;
        this.alphaMap = null;
        this.envMap = null;
        this.envMapRotation = new (0, $ac384e7663319ba6$export$d93cc409a0768c5f)();
        this.combine = (0, $cb5ee595c0f892af$export$e50ac29801f1774d);
        this.reflectivity = 1;
        this.refractionRatio = 0.98;
        this.wireframe = false;
        this.wireframeLinewidth = 1;
        this.wireframeLinecap = 'round';
        this.wireframeLinejoin = 'round';
        this.flatShading = false;
        this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.map = source.map;
        this.lightMap = source.lightMap;
        this.lightMapIntensity = source.lightMapIntensity;
        this.aoMap = source.aoMap;
        this.aoMapIntensity = source.aoMapIntensity;
        this.emissive.copy(source.emissive);
        this.emissiveMap = source.emissiveMap;
        this.emissiveIntensity = source.emissiveIntensity;
        this.bumpMap = source.bumpMap;
        this.bumpScale = source.bumpScale;
        this.normalMap = source.normalMap;
        this.normalMapType = source.normalMapType;
        this.normalScale.copy(source.normalScale);
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.specularMap = source.specularMap;
        this.alphaMap = source.alphaMap;
        this.envMap = source.envMap;
        this.envMapRotation.copy(source.envMapRotation);
        this.combine = source.combine;
        this.reflectivity = source.reflectivity;
        this.refractionRatio = source.refractionRatio;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.wireframeLinecap = source.wireframeLinecap;
        this.wireframeLinejoin = source.wireframeLinejoin;
        this.flatShading = source.flatShading;
        this.fog = source.fog;
        return this;
    }
}






const $6b671cb45a65c32b$var$_defaultValues = /*@__PURE__*/ new (0, $da18a46d400c99e2$export$5023a9a8114806b8)();
class $6b671cb45a65c32b$var$MeshLambertNodeMaterial extends (0, $1a485f4d26090da0$export$2e2bcd8739ae039) {
    static get type() {
        return 'MeshLambertNodeMaterial';
    }
    constructor(parameters){
        super();
        this.isMeshLambertNodeMaterial = true;
        this.lights = true;
        this.setDefaultValues($6b671cb45a65c32b$var$_defaultValues);
        this.setValues(parameters);
    }
    setupEnvironment(builder) {
        const envNode = super.setupEnvironment(builder);
        return envNode ? new (0, $eb1fde74125000ac$export$2e2bcd8739ae039)(envNode) : null;
    }
    setupLightingModel() {
        return new (0, $4771908cdc45bf93$export$2e2bcd8739ae039)(false); // ( specular ) -> force lambert
    }
}
var $6b671cb45a65c32b$export$2e2bcd8739ae039 = $6b671cb45a65c32b$var$MeshLambertNodeMaterial;





class $0aa3bcd9d9d49c80$export$bfe8c0a091f41ae7 extends (0, $7711e1b3c41f4d78$export$a2d8b23205c25948) {
    static get type() {
        return 'MeshNormalMaterial';
    }
    constructor(parameters){
        super();
        this.isMeshNormalMaterial = true;
        this.bumpMap = null;
        this.bumpScale = 1;
        this.normalMap = null;
        this.normalMapType = (0, $cb5ee595c0f892af$export$2852a58ebdac27b8);
        this.normalScale = new (0, $3c03061dea0adea3$export$c977b3e384af9ae1)(1, 1);
        this.displacementMap = null;
        this.displacementScale = 1;
        this.displacementBias = 0;
        this.wireframe = false;
        this.wireframeLinewidth = 1;
        this.flatShading = false;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.bumpMap = source.bumpMap;
        this.bumpScale = source.bumpScale;
        this.normalMap = source.normalMap;
        this.normalMapType = source.normalMapType;
        this.normalScale.copy(source.normalScale);
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.flatShading = source.flatShading;
        return this;
    }
}









const $70a25e8ef83ba872$var$_defaultValues = /*@__PURE__*/ new (0, $0aa3bcd9d9d49c80$export$bfe8c0a091f41ae7)();
class $70a25e8ef83ba872$var$MeshNormalNodeMaterial extends (0, $1a485f4d26090da0$export$2e2bcd8739ae039) {
    static get type() {
        return 'MeshNormalNodeMaterial';
    }
    constructor(parameters){
        super();
        this.lights = false;
        this.isMeshNormalNodeMaterial = true;
        this.setDefaultValues($70a25e8ef83ba872$var$_defaultValues);
        this.setValues(parameters);
    }
    setupDiffuseColor() {
        const opacityNode = this.opacityNode ? (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(this.opacityNode) : (0, $8e4701fdb55563f1$export$a61065844a540229);
        (0, $dd761eb0c8b88ca7$export$3a790f19f33c5176).assign((0, $d5b7ee61758b2e81$export$6dba2a1f0d609415)((0, $6886b4ccd5c97d78$export$a0a884e7f644b818)((0, $0ab44deffc8ae973$export$c58d63d09d102e3c)), opacityNode));
    }
}
var $70a25e8ef83ba872$export$2e2bcd8739ae039 = $70a25e8ef83ba872$var$MeshNormalNodeMaterial;






class $3eb5ad37383cae4e$export$6f5fef6235ec12ee extends (0, $7711e1b3c41f4d78$export$a2d8b23205c25948) {
    static get type() {
        return 'MeshMatcapMaterial';
    }
    constructor(parameters){
        super();
        this.isMeshMatcapMaterial = true;
        this.defines = {
            'MATCAP': ''
        };
        this.color = new (0, $9a23ce591a1b6760$export$892596cec99bc70e)(0xffffff); // diffuse
        this.matcap = null;
        this.map = null;
        this.bumpMap = null;
        this.bumpScale = 1;
        this.normalMap = null;
        this.normalMapType = (0, $cb5ee595c0f892af$export$2852a58ebdac27b8);
        this.normalScale = new (0, $3c03061dea0adea3$export$c977b3e384af9ae1)(1, 1);
        this.displacementMap = null;
        this.displacementScale = 1;
        this.displacementBias = 0;
        this.alphaMap = null;
        this.flatShading = false;
        this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.defines = {
            'MATCAP': ''
        };
        this.color.copy(source.color);
        this.matcap = source.matcap;
        this.map = source.map;
        this.bumpMap = source.bumpMap;
        this.bumpScale = source.bumpScale;
        this.normalMap = source.normalMap;
        this.normalMapType = source.normalMapType;
        this.normalScale.copy(source.normalScale);
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.alphaMap = source.alphaMap;
        this.flatShading = source.flatShading;
        this.fog = source.fog;
        return this;
    }
}









const $4380fa8df6ac48cc$var$_defaultValues = /*@__PURE__*/ new (0, $3eb5ad37383cae4e$export$6f5fef6235ec12ee)();
class $4380fa8df6ac48cc$var$MeshMatcapNodeMaterial extends (0, $1a485f4d26090da0$export$2e2bcd8739ae039) {
    static get type() {
        return 'MeshMatcapNodeMaterial';
    }
    constructor(parameters){
        super();
        this.lights = false;
        this.isMeshMatcapNodeMaterial = true;
        this.setDefaultValues($4380fa8df6ac48cc$var$_defaultValues);
        this.setValues(parameters);
    }
    setupVariants(builder) {
        const uv = (0, $9d71f23e5237e91a$export$1144db64d9b88baf);
        let matcapColor;
        if (builder.material.matcap) matcapColor = (0, $148d94357f05ebae$export$f503be583015cb4f)('matcap', 'texture').context({
            getUV: ()=>uv
        });
        else matcapColor = (0, $d5b7ee61758b2e81$export$9100789c9d999364)((0, $f37ae0e58866c183$export$2c9e8a9632a706b2)(0.2, 0.8, uv.y)); // default if matcap is missing
        (0, $dd761eb0c8b88ca7$export$3a790f19f33c5176).rgb.mulAssign(matcapColor.rgb);
    }
}
var $4380fa8df6ac48cc$export$2e2bcd8739ae039 = $4380fa8df6ac48cc$var$MeshMatcapNodeMaterial;




class $b8a84d020f0a5c06$export$fbaaa33907730a0c extends (0, $7711e1b3c41f4d78$export$a2d8b23205c25948) {
    static get type() {
        return 'LineBasicMaterial';
    }
    constructor(parameters){
        super();
        this.isLineBasicMaterial = true;
        this.color = new (0, $9a23ce591a1b6760$export$892596cec99bc70e)(0xffffff);
        this.map = null;
        this.linewidth = 1;
        this.linecap = 'round';
        this.linejoin = 'round';
        this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.map = source.map;
        this.linewidth = source.linewidth;
        this.linecap = source.linecap;
        this.linejoin = source.linejoin;
        this.fog = source.fog;
        return this;
    }
}




const $9ec81905dd2bf03e$var$_defaultValues = /*@__PURE__*/ new (0, $b8a84d020f0a5c06$export$fbaaa33907730a0c)();
class $9ec81905dd2bf03e$var$LineBasicNodeMaterial extends (0, $1a485f4d26090da0$export$2e2bcd8739ae039) {
    static get type() {
        return 'LineBasicNodeMaterial';
    }
    constructor(parameters){
        super();
        this.isLineBasicNodeMaterial = true;
        this.lights = false;
        this.setDefaultValues($9ec81905dd2bf03e$var$_defaultValues);
        this.setValues(parameters);
    }
}
var $9ec81905dd2bf03e$export$2e2bcd8739ae039 = $9ec81905dd2bf03e$var$LineBasicNodeMaterial;



class $8127f0c132963ff4$export$327886a3efaeaebe extends (0, $b8a84d020f0a5c06$export$fbaaa33907730a0c) {
    static get type() {
        return 'LineDashedMaterial';
    }
    constructor(parameters){
        super();
        this.isLineDashedMaterial = true;
        this.scale = 1;
        this.dashSize = 3;
        this.gapSize = 1;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.scale = source.scale;
        this.dashSize = source.dashSize;
        this.gapSize = source.gapSize;
        return this;
    }
}








const $b4139533113f621f$var$_defaultValues = /*@__PURE__*/ new (0, $8127f0c132963ff4$export$327886a3efaeaebe)();
class $b4139533113f621f$var$LineDashedNodeMaterial extends (0, $1a485f4d26090da0$export$2e2bcd8739ae039) {
    static get type() {
        return 'LineDashedNodeMaterial';
    }
    constructor(parameters){
        super();
        this.isLineDashedNodeMaterial = true;
        this.lights = false;
        this.setDefaultValues($b4139533113f621f$var$_defaultValues);
        this.offsetNode = null;
        this.dashScaleNode = null;
        this.dashSizeNode = null;
        this.gapSizeNode = null;
        this.setValues(parameters);
    }
    setupVariants() {
        const offsetNode = this.offsetNode;
        const dashScaleNode = this.dashScaleNode ? (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(this.dashScaleNode) : (0, $8e4701fdb55563f1$export$505058bbaa0ad019);
        const dashSizeNode = this.dashSizeNode ? (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(this.dashSizeNode) : (0, $8e4701fdb55563f1$export$200b8bf19a7aecc9);
        const gapSizeNode = this.dashSizeNode ? (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(this.dashGapNode) : (0, $8e4701fdb55563f1$export$3154261658c8ee4b);
        (0, $dd761eb0c8b88ca7$export$c295bac1d6792172).assign(dashSizeNode);
        (0, $dd761eb0c8b88ca7$export$146ecbc129c598d1).assign(gapSizeNode);
        const vLineDistance = (0, $c497538e811cb09b$export$3f47f02b8134ef8a)((0, $700a78a0d988d216$export$af4b9a83f4b00434)('lineDistance').mul(dashScaleNode));
        const vLineDistanceOffset = offsetNode ? vLineDistance.add(offsetNode) : vLineDistance;
        vLineDistanceOffset.mod((0, $dd761eb0c8b88ca7$export$c295bac1d6792172).add((0, $dd761eb0c8b88ca7$export$146ecbc129c598d1))).greaterThan((0, $dd761eb0c8b88ca7$export$c295bac1d6792172)).discard();
    }
}
var $b4139533113f621f$export$2e2bcd8739ae039 = $b4139533113f621f$var$LineDashedNodeMaterial;




class $f95b6247fc2c68d0$export$a178c45366ce5d6b extends (0, $7711e1b3c41f4d78$export$a2d8b23205c25948) {
    static get type() {
        return 'PointsMaterial';
    }
    constructor(parameters){
        super();
        this.isPointsMaterial = true;
        this.color = new (0, $9a23ce591a1b6760$export$892596cec99bc70e)(0xffffff);
        this.map = null;
        this.alphaMap = null;
        this.size = 1;
        this.sizeAttenuation = true;
        this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.map = source.map;
        this.alphaMap = source.alphaMap;
        this.size = source.size;
        this.sizeAttenuation = source.sizeAttenuation;
        this.fog = source.fog;
        return this;
    }
}




const $30151d68d7d8bc1d$var$_defaultValues = /*@__PURE__*/ new (0, $f95b6247fc2c68d0$export$a178c45366ce5d6b)();
class $30151d68d7d8bc1d$var$PointsNodeMaterial extends (0, $1a485f4d26090da0$export$2e2bcd8739ae039) {
    static get type() {
        return 'PointsNodeMaterial';
    }
    constructor(parameters){
        super();
        this.isPointsNodeMaterial = true;
        this.lights = false;
        this.transparent = true;
        this.sizeNode = null;
        this.setDefaultValues($30151d68d7d8bc1d$var$_defaultValues);
        this.setValues(parameters);
    }
    copy(source) {
        this.sizeNode = source.sizeNode;
        return super.copy(source);
    }
}
var $30151d68d7d8bc1d$export$2e2bcd8739ae039 = $30151d68d7d8bc1d$var$PointsNodeMaterial;




class $12f9355badc11ad4$export$5ec7dd1c6994bf8e extends (0, $7711e1b3c41f4d78$export$a2d8b23205c25948) {
    static get type() {
        return 'SpriteMaterial';
    }
    constructor(parameters){
        super();
        this.isSpriteMaterial = true;
        this.color = new (0, $9a23ce591a1b6760$export$892596cec99bc70e)(0xffffff);
        this.map = null;
        this.alphaMap = null;
        this.rotation = 0;
        this.sizeAttenuation = true;
        this.transparent = true;
        this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.map = source.map;
        this.alphaMap = source.alphaMap;
        this.rotation = source.rotation;
        this.sizeAttenuation = source.sizeAttenuation;
        this.fog = source.fog;
        return this;
    }
}











const $eaa0a64a25291444$var$_defaultValues = /*@__PURE__*/ new (0, $12f9355badc11ad4$export$5ec7dd1c6994bf8e)();
class $eaa0a64a25291444$var$SpriteNodeMaterial extends (0, $1a485f4d26090da0$export$2e2bcd8739ae039) {
    static get type() {
        return 'SpriteNodeMaterial';
    }
    constructor(parameters){
        super();
        this.isSpriteNodeMaterial = true;
        this.lights = false;
        this._useSizeAttenuation = true;
        this.positionNode = null;
        this.rotationNode = null;
        this.scaleNode = null;
        this.setDefaultValues($eaa0a64a25291444$var$_defaultValues);
        this.setValues(parameters);
    }
    setupPosition({ object: object, camera: camera, context: context }) {
        const sizeAttenuation = this.sizeAttenuation;
        // < VERTEX STAGE >
        const { positionNode: positionNode, rotationNode: rotationNode, scaleNode: scaleNode } = this;
        const vertex = (0, $acbec2070ba15851$export$78cc3a7ea225109f);
        let mvPosition = (0, $c03c6edd36966f29$export$57d0df277658535e).mul((0, $d5b7ee61758b2e81$export$9100789c9d999364)(positionNode || 0));
        let scale = (0, $d5b7ee61758b2e81$export$e9830bc863290a54)((0, $c03c6edd36966f29$export$e1011125af6f8b40)[0].xyz.length(), (0, $c03c6edd36966f29$export$e1011125af6f8b40)[1].xyz.length());
        if (scaleNode !== null) scale = scale.mul(scaleNode);
        if (!sizeAttenuation) {
            if (camera.isPerspectiveCamera) scale = scale.mul(mvPosition.z.negate());
            else {
                const orthoScale = (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(2.0).div((0, $aa7db78c76b9331c$export$dc8d743682f60b2d).element(1).element(1));
                scale = scale.mul(orthoScale.mul(2));
            }
        }
        let alignedPosition = vertex.xy;
        if (object.center && object.center.isVector2 === true) {
            const center = (0, $703ae9ffd13a2ae0$export$ca50aac9f3ba507f)('center', 'vec2');
            alignedPosition = alignedPosition.sub(center.sub(0.5));
        }
        alignedPosition = alignedPosition.mul(scale);
        const rotation = (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(rotationNode || (0, $8e4701fdb55563f1$export$22a360a238f20723));
        const rotatedPosition = (0, $a6645c4099ad0641$export$bb628a54ab399bc9)(alignedPosition, rotation);
        mvPosition = (0, $d5b7ee61758b2e81$export$6dba2a1f0d609415)(mvPosition.xy.add(rotatedPosition), mvPosition.zw);
        const modelViewProjection = (0, $aa7db78c76b9331c$export$dc8d743682f60b2d).mul(mvPosition);
        context.vertex = vertex;
        return modelViewProjection;
    }
    copy(source) {
        this.positionNode = source.positionNode;
        this.rotationNode = source.rotationNode;
        this.scaleNode = source.scaleNode;
        return super.copy(source);
    }
    get sizeAttenuation() {
        return this._useSizeAttenuation;
    }
    set sizeAttenuation(value) {
        if (this._useSizeAttenuation !== value) {
            this._useSizeAttenuation = value;
            this.needsUpdate = true;
        }
    }
}
var $eaa0a64a25291444$export$2e2bcd8739ae039 = $eaa0a64a25291444$var$SpriteNodeMaterial;




class $b0c2e16c30bc2127$export$e8564da406055a3 extends (0, $7711e1b3c41f4d78$export$a2d8b23205c25948) {
    static get type() {
        return 'ShadowMaterial';
    }
    constructor(parameters){
        super();
        this.isShadowMaterial = true;
        this.color = new (0, $9a23ce591a1b6760$export$892596cec99bc70e)(0x000000);
        this.transparent = true;
        this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.fog = source.fog;
        return this;
    }
}






class $701f5e6b7f306f49$var$ShadowMaskModel extends (0, $e15d7fb89e2d8a53$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.shadowNode = (0, $d5b7ee61758b2e81$export$6b5cd3983e3ee5ab)(1).toVar('shadowMask');
    }
    direct({ shadowMask: shadowMask }) {
        this.shadowNode.mulAssign(shadowMask);
    }
    finish(context) {
        (0, $dd761eb0c8b88ca7$export$3a790f19f33c5176).a.mulAssign(this.shadowNode.oneMinus());
        context.outgoingLight.rgb.assign((0, $dd761eb0c8b88ca7$export$3a790f19f33c5176).rgb); // TODO: Optimize LightsNode to avoid this assignment
    }
}
var $701f5e6b7f306f49$export$2e2bcd8739ae039 = $701f5e6b7f306f49$var$ShadowMaskModel;



const $5df5329447b15778$var$_defaultValues = /*@__PURE__*/ new (0, $b0c2e16c30bc2127$export$e8564da406055a3)();
class $5df5329447b15778$var$ShadowNodeMaterial extends (0, $1a485f4d26090da0$export$2e2bcd8739ae039) {
    static get type() {
        return 'ShadowNodeMaterial';
    }
    constructor(parameters){
        super();
        this.isShadowNodeMaterial = true;
        this.lights = true;
        this.setDefaultValues($5df5329447b15778$var$_defaultValues);
        this.setValues(parameters);
    }
    setupLightingModel() {
        return new (0, $701f5e6b7f306f49$export$2e2bcd8739ae039)();
    }
}
var $5df5329447b15778$export$2e2bcd8739ae039 = $5df5329447b15778$var$ShadowNodeMaterial;




class $a3eeb8c49a38c4a5$export$6ecadb6ed240d696 extends (0, $2894733dde59bc41$export$e4dd07dff30cc924) {
    constructor(color, intensity = 1){
        super();
        this.isLight = true;
        this.type = 'Light';
        this.color = new (0, $9a23ce591a1b6760$export$892596cec99bc70e)(color);
        this.intensity = intensity;
    }
    dispose() {
    // Empty here in base class; some subclasses override.
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.color.copy(source.color);
        this.intensity = source.intensity;
        return this;
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.object.color = this.color.getHex();
        data.object.intensity = this.intensity;
        if (this.groundColor !== undefined) data.object.groundColor = this.groundColor.getHex();
        if (this.distance !== undefined) data.object.distance = this.distance;
        if (this.angle !== undefined) data.object.angle = this.angle;
        if (this.decay !== undefined) data.object.decay = this.decay;
        if (this.penumbra !== undefined) data.object.penumbra = this.penumbra;
        if (this.shadow !== undefined) data.object.shadow = this.shadow.toJSON();
        if (this.target !== undefined) data.object.target = this.target.uuid;
        return data;
    }
}







const $b5898499b84653ed$var$_projScreenMatrix = /*@__PURE__*/ new (0, $0ea09116adcadf95$export$2ae72fc923e5eb5)();
const $b5898499b84653ed$var$_lightPositionWorld = /*@__PURE__*/ new (0, $d7d0ac0e47013885$export$64b5c384219d3699)();
const $b5898499b84653ed$var$_lookTarget = /*@__PURE__*/ new (0, $d7d0ac0e47013885$export$64b5c384219d3699)();
class $b5898499b84653ed$export$62dfae6aea7122f9 {
    constructor(camera){
        this.camera = camera;
        this.intensity = 1;
        this.bias = 0;
        this.normalBias = 0;
        this.radius = 1;
        this.blurSamples = 8;
        this.mapSize = new (0, $3c03061dea0adea3$export$c977b3e384af9ae1)(512, 512);
        this.map = null;
        this.mapPass = null;
        this.matrix = new (0, $0ea09116adcadf95$export$2ae72fc923e5eb5)();
        this.autoUpdate = true;
        this.needsUpdate = false;
        this._frustum = new (0, $ada82301cc8d88e9$export$35efe6f4c85463d2)();
        this._frameExtents = new (0, $3c03061dea0adea3$export$c977b3e384af9ae1)(1, 1);
        this._viewportCount = 1;
        this._viewports = [
            new (0, $a09a15e9a8421204$export$fa7daccca11cdbe3)(0, 0, 1, 1)
        ];
    }
    getViewportCount() {
        return this._viewportCount;
    }
    getFrustum() {
        return this._frustum;
    }
    updateMatrices(light) {
        const shadowCamera = this.camera;
        const shadowMatrix = this.matrix;
        $b5898499b84653ed$var$_lightPositionWorld.setFromMatrixPosition(light.matrixWorld);
        shadowCamera.position.copy($b5898499b84653ed$var$_lightPositionWorld);
        $b5898499b84653ed$var$_lookTarget.setFromMatrixPosition(light.target.matrixWorld);
        shadowCamera.lookAt($b5898499b84653ed$var$_lookTarget);
        shadowCamera.updateMatrixWorld();
        $b5898499b84653ed$var$_projScreenMatrix.multiplyMatrices(shadowCamera.projectionMatrix, shadowCamera.matrixWorldInverse);
        this._frustum.setFromProjectionMatrix($b5898499b84653ed$var$_projScreenMatrix);
        shadowMatrix.set(0.5, 0.0, 0.0, 0.5, 0.0, 0.5, 0.0, 0.5, 0.0, 0.0, 0.5, 0.5, 0.0, 0.0, 0.0, 1.0);
        shadowMatrix.multiply($b5898499b84653ed$var$_projScreenMatrix);
    }
    getViewport(viewportIndex) {
        return this._viewports[viewportIndex];
    }
    getFrameExtents() {
        return this._frameExtents;
    }
    dispose() {
        if (this.map) this.map.dispose();
        if (this.mapPass) this.mapPass.dispose();
    }
    copy(source) {
        this.camera = source.camera.clone();
        this.intensity = source.intensity;
        this.bias = source.bias;
        this.radius = source.radius;
        this.mapSize.copy(source.mapSize);
        return this;
    }
    clone() {
        return new this.constructor().copy(this);
    }
    toJSON() {
        const object = {};
        if (this.intensity !== 1) object.intensity = this.intensity;
        if (this.bias !== 0) object.bias = this.bias;
        if (this.normalBias !== 0) object.normalBias = this.normalBias;
        if (this.radius !== 1) object.radius = this.radius;
        if (this.mapSize.x !== 512 || this.mapSize.y !== 512) object.mapSize = this.mapSize.toArray();
        object.camera = this.camera.toJSON(false).object;
        delete object.camera.matrix;
        return object;
    }
}







const $82eab54f717b329e$var$_projScreenMatrix = /*@__PURE__*/ new (0, $0ea09116adcadf95$export$2ae72fc923e5eb5)();
const $82eab54f717b329e$var$_lightPositionWorld = /*@__PURE__*/ new (0, $d7d0ac0e47013885$export$64b5c384219d3699)();
const $82eab54f717b329e$var$_lookTarget = /*@__PURE__*/ new (0, $d7d0ac0e47013885$export$64b5c384219d3699)();
class $82eab54f717b329e$export$61bfe09e4aee08ea extends (0, $b5898499b84653ed$export$62dfae6aea7122f9) {
    constructor(){
        super(new (0, $2791465b256430b4$export$74e4ae24825f68d7)(90, 1, 0.5, 500));
        this.isPointLightShadow = true;
        this._frameExtents = new (0, $3c03061dea0adea3$export$c977b3e384af9ae1)(4, 2);
        this._viewportCount = 6;
        this._viewports = [
            // These viewports map a cube-map onto a 2D texture with the
            // following orientation:
            //
            //  xzXZ
            //   y Y
            //
            // X - Positive x direction
            // x - Negative x direction
            // Y - Positive y direction
            // y - Negative y direction
            // Z - Positive z direction
            // z - Negative z direction
            // positive X
            new (0, $a09a15e9a8421204$export$fa7daccca11cdbe3)(2, 1, 1, 1),
            // negative X
            new (0, $a09a15e9a8421204$export$fa7daccca11cdbe3)(0, 1, 1, 1),
            // positive Z
            new (0, $a09a15e9a8421204$export$fa7daccca11cdbe3)(3, 1, 1, 1),
            // negative Z
            new (0, $a09a15e9a8421204$export$fa7daccca11cdbe3)(1, 1, 1, 1),
            // positive Y
            new (0, $a09a15e9a8421204$export$fa7daccca11cdbe3)(3, 0, 1, 1),
            // negative Y
            new (0, $a09a15e9a8421204$export$fa7daccca11cdbe3)(1, 0, 1, 1)
        ];
        this._cubeDirections = [
            new (0, $d7d0ac0e47013885$export$64b5c384219d3699)(1, 0, 0),
            new (0, $d7d0ac0e47013885$export$64b5c384219d3699)(-1, 0, 0),
            new (0, $d7d0ac0e47013885$export$64b5c384219d3699)(0, 0, 1),
            new (0, $d7d0ac0e47013885$export$64b5c384219d3699)(0, 0, -1),
            new (0, $d7d0ac0e47013885$export$64b5c384219d3699)(0, 1, 0),
            new (0, $d7d0ac0e47013885$export$64b5c384219d3699)(0, -1, 0)
        ];
        this._cubeUps = [
            new (0, $d7d0ac0e47013885$export$64b5c384219d3699)(0, 1, 0),
            new (0, $d7d0ac0e47013885$export$64b5c384219d3699)(0, 1, 0),
            new (0, $d7d0ac0e47013885$export$64b5c384219d3699)(0, 1, 0),
            new (0, $d7d0ac0e47013885$export$64b5c384219d3699)(0, 1, 0),
            new (0, $d7d0ac0e47013885$export$64b5c384219d3699)(0, 0, 1),
            new (0, $d7d0ac0e47013885$export$64b5c384219d3699)(0, 0, -1)
        ];
    }
    updateMatrices(light, viewportIndex = 0) {
        const camera = this.camera;
        const shadowMatrix = this.matrix;
        const far = light.distance || camera.far;
        if (far !== camera.far) {
            camera.far = far;
            camera.updateProjectionMatrix();
        }
        $82eab54f717b329e$var$_lightPositionWorld.setFromMatrixPosition(light.matrixWorld);
        camera.position.copy($82eab54f717b329e$var$_lightPositionWorld);
        $82eab54f717b329e$var$_lookTarget.copy(camera.position);
        $82eab54f717b329e$var$_lookTarget.add(this._cubeDirections[viewportIndex]);
        camera.up.copy(this._cubeUps[viewportIndex]);
        camera.lookAt($82eab54f717b329e$var$_lookTarget);
        camera.updateMatrixWorld();
        shadowMatrix.makeTranslation(-$82eab54f717b329e$var$_lightPositionWorld.x, -$82eab54f717b329e$var$_lightPositionWorld.y, -$82eab54f717b329e$var$_lightPositionWorld.z);
        $82eab54f717b329e$var$_projScreenMatrix.multiplyMatrices(camera.projectionMatrix, camera.matrixWorldInverse);
        this._frustum.setFromProjectionMatrix($82eab54f717b329e$var$_projScreenMatrix);
    }
}


class $8dfc6db086f992d7$export$4c9c1cb3f0b6f455 extends (0, $a3eeb8c49a38c4a5$export$6ecadb6ed240d696) {
    constructor(color, intensity, distance = 0, decay = 2){
        super(color, intensity);
        this.isPointLight = true;
        this.type = 'PointLight';
        this.distance = distance;
        this.decay = decay;
        this.shadow = new (0, $82eab54f717b329e$export$61bfe09e4aee08ea)();
    }
    get power() {
        // compute the light's luminous power (in lumens) from its intensity (in candela)
        // for an isotropic light source, luminous power (lm) = 4 π luminous intensity (cd)
        return this.intensity * 4 * Math.PI;
    }
    set power(power) {
        // set the light's intensity (in candela) from the desired luminous power (in lumens)
        this.intensity = power / (4 * Math.PI);
    }
    dispose() {
        this.shadow.dispose();
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.distance = source.distance;
        this.decay = source.decay;
        this.shadow = source.shadow.clone();
        return this;
    }
}






class $70a15ea33c0a0e4d$export$dff95a04f9366e71 extends (0, $b5898499b84653ed$export$62dfae6aea7122f9) {
    constructor(){
        super(new (0, $e37261468d01aaee$export$9ebf355ee4ed261b)(-5, 5, 5, -5, 0.5, 500));
        this.isDirectionalLightShadow = true;
    }
}



class $4dd8c0896bc492d4$export$3fea33cc9972c868 extends (0, $a3eeb8c49a38c4a5$export$6ecadb6ed240d696) {
    constructor(color, intensity){
        super(color, intensity);
        this.isDirectionalLight = true;
        this.type = 'DirectionalLight';
        this.position.copy((0, $2894733dde59bc41$export$e4dd07dff30cc924).DEFAULT_UP);
        this.updateMatrix();
        this.target = new (0, $2894733dde59bc41$export$e4dd07dff30cc924)();
        this.shadow = new (0, $70a15ea33c0a0e4d$export$dff95a04f9366e71)();
    }
    dispose() {
        this.shadow.dispose();
    }
    copy(source) {
        super.copy(source);
        this.target = source.target.clone();
        this.shadow = source.shadow.clone();
        return this;
    }
}



class $74f31cca411e80bd$export$61db2d908bbd2429 extends (0, $a3eeb8c49a38c4a5$export$6ecadb6ed240d696) {
    constructor(color, intensity, width = 10, height = 10){
        super(color, intensity);
        this.isRectAreaLight = true;
        this.type = 'RectAreaLight';
        this.width = width;
        this.height = height;
    }
    get power() {
        // compute the light's luminous power (in lumens) from its intensity (in nits)
        return this.intensity * this.width * this.height * Math.PI;
    }
    set power(power) {
        // set the light's intensity (in nits) from the desired luminous power (in lumens)
        this.intensity = power / (this.width * this.height * Math.PI);
    }
    copy(source) {
        super.copy(source);
        this.width = source.width;
        this.height = source.height;
        return this;
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.object.width = this.width;
        data.object.height = this.height;
        return data;
    }
}






class $5ef5cee6ce01058e$export$ce3cca1bb81001ce extends (0, $b5898499b84653ed$export$62dfae6aea7122f9) {
    constructor(){
        super(new (0, $2791465b256430b4$export$74e4ae24825f68d7)(50, 1, 0.5, 500));
        this.isSpotLightShadow = true;
        this.focus = 1;
    }
    updateMatrices(light) {
        const camera = this.camera;
        const fov = $7f727a3c7059d20d$export$914076c8150813e5 * 2 * light.angle * this.focus;
        const aspect = this.mapSize.width / this.mapSize.height;
        const far = light.distance || camera.far;
        if (fov !== camera.fov || aspect !== camera.aspect || far !== camera.far) {
            camera.fov = fov;
            camera.aspect = aspect;
            camera.far = far;
            camera.updateProjectionMatrix();
        }
        super.updateMatrices(light);
    }
    copy(source) {
        super.copy(source);
        this.focus = source.focus;
        return this;
    }
}



class $05e7dfb34dcf7ac5$export$81495cbb73897362 extends (0, $a3eeb8c49a38c4a5$export$6ecadb6ed240d696) {
    constructor(color, intensity, distance = 0, angle = Math.PI / 3, penumbra = 0, decay = 2){
        super(color, intensity);
        this.isSpotLight = true;
        this.type = 'SpotLight';
        this.position.copy((0, $2894733dde59bc41$export$e4dd07dff30cc924).DEFAULT_UP);
        this.updateMatrix();
        this.target = new (0, $2894733dde59bc41$export$e4dd07dff30cc924)();
        this.distance = distance;
        this.angle = angle;
        this.penumbra = penumbra;
        this.decay = decay;
        this.map = null;
        this.shadow = new (0, $5ef5cee6ce01058e$export$ce3cca1bb81001ce)();
    }
    get power() {
        // compute the light's luminous power (in lumens) from its intensity (in candela)
        // by convention for a spotlight, luminous power (lm) = π * luminous intensity (cd)
        return this.intensity * Math.PI;
    }
    set power(power) {
        // set the light's intensity (in candela) from the desired luminous power (in lumens)
        this.intensity = power / Math.PI;
    }
    dispose() {
        this.shadow.dispose();
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.distance = source.distance;
        this.angle = source.angle;
        this.penumbra = source.penumbra;
        this.decay = source.decay;
        this.target = source.target.clone();
        this.shadow = source.shadow.clone();
        return this;
    }
}



class $6e4aa1d95d746120$export$af279bfef9ec2c96 extends (0, $a3eeb8c49a38c4a5$export$6ecadb6ed240d696) {
    constructor(color, intensity){
        super(color, intensity);
        this.isAmbientLight = true;
        this.type = 'AmbientLight';
    }
}





class $97e01d90f172ad62$export$8d474f55edbb9624 extends (0, $a3eeb8c49a38c4a5$export$6ecadb6ed240d696) {
    constructor(skyColor, groundColor, intensity){
        super(skyColor, intensity);
        this.isHemisphereLight = true;
        this.type = 'HemisphereLight';
        this.position.copy((0, $2894733dde59bc41$export$e4dd07dff30cc924).DEFAULT_UP);
        this.updateMatrix();
        this.groundColor = new (0, $9a23ce591a1b6760$export$892596cec99bc70e)(groundColor);
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.groundColor.copy(source.groundColor);
        return this;
    }
}



/**
 * Primary reference:
 *   https://graphics.stanford.edu/papers/envmap/envmap.pdf
 *
 * Secondary reference:
 *   https://www.ppsloan.org/publications/StupidSH36.pdf
 */ // 3-band SH defined by 9 coefficients
class $39051cadd4748d5b$export$ba61ce607e1f405a {
    constructor(){
        this.isSphericalHarmonics3 = true;
        this.coefficients = [];
        for(let i = 0; i < 9; i++)this.coefficients.push(new (0, $d7d0ac0e47013885$export$64b5c384219d3699)());
    }
    set(coefficients) {
        for(let i = 0; i < 9; i++)this.coefficients[i].copy(coefficients[i]);
        return this;
    }
    zero() {
        for(let i = 0; i < 9; i++)this.coefficients[i].set(0, 0, 0);
        return this;
    }
    // get the radiance in the direction of the normal
    // target is a Vector3
    getAt(normal, target) {
        // normal is assumed to be unit length
        const x = normal.x, y = normal.y, z = normal.z;
        const coeff = this.coefficients;
        // band 0
        target.copy(coeff[0]).multiplyScalar(0.282095);
        // band 1
        target.addScaledVector(coeff[1], 0.488603 * y);
        target.addScaledVector(coeff[2], 0.488603 * z);
        target.addScaledVector(coeff[3], 0.488603 * x);
        // band 2
        target.addScaledVector(coeff[4], 1.092548 * (x * y));
        target.addScaledVector(coeff[5], 1.092548 * (y * z));
        target.addScaledVector(coeff[6], 0.315392 * (3.0 * z * z - 1.0));
        target.addScaledVector(coeff[7], 1.092548 * (x * z));
        target.addScaledVector(coeff[8], 0.546274 * (x * x - y * y));
        return target;
    }
    // get the irradiance (radiance convolved with cosine lobe) in the direction of the normal
    // target is a Vector3
    // https://graphics.stanford.edu/papers/envmap/envmap.pdf
    getIrradianceAt(normal, target) {
        // normal is assumed to be unit length
        const x = normal.x, y = normal.y, z = normal.z;
        const coeff = this.coefficients;
        // band 0
        target.copy(coeff[0]).multiplyScalar(0.886227); // π * 0.282095
        // band 1
        target.addScaledVector(coeff[1], 1.023328 * y); // ( 2 * π / 3 ) * 0.488603
        target.addScaledVector(coeff[2], 1.023328 * z);
        target.addScaledVector(coeff[3], 1.023328 * x);
        // band 2
        target.addScaledVector(coeff[4], 0.858086 * x * y); // ( π / 4 ) * 1.092548
        target.addScaledVector(coeff[5], 0.858086 * y * z);
        target.addScaledVector(coeff[6], 0.743125 * z * z - 0.247708); // ( π / 4 ) * 0.315392 * 3
        target.addScaledVector(coeff[7], 0.858086 * x * z);
        target.addScaledVector(coeff[8], 0.429043 * (x * x - y * y)); // ( π / 4 ) * 0.546274
        return target;
    }
    add(sh) {
        for(let i = 0; i < 9; i++)this.coefficients[i].add(sh.coefficients[i]);
        return this;
    }
    addScaledSH(sh, s) {
        for(let i = 0; i < 9; i++)this.coefficients[i].addScaledVector(sh.coefficients[i], s);
        return this;
    }
    scale(s) {
        for(let i = 0; i < 9; i++)this.coefficients[i].multiplyScalar(s);
        return this;
    }
    lerp(sh, alpha) {
        for(let i = 0; i < 9; i++)this.coefficients[i].lerp(sh.coefficients[i], alpha);
        return this;
    }
    equals(sh) {
        for(let i = 0; i < 9; i++){
            if (!this.coefficients[i].equals(sh.coefficients[i])) return false;
        }
        return true;
    }
    copy(sh) {
        return this.set(sh.coefficients);
    }
    clone() {
        return new this.constructor().copy(this);
    }
    fromArray(array, offset = 0) {
        const coefficients = this.coefficients;
        for(let i = 0; i < 9; i++)coefficients[i].fromArray(array, offset + i * 3);
        return this;
    }
    toArray(array = [], offset = 0) {
        const coefficients = this.coefficients;
        for(let i = 0; i < 9; i++)coefficients[i].toArray(array, offset + i * 3);
        return array;
    }
    // evaluate the basis functions
    // shBasis is an Array[ 9 ]
    static getBasisAt(normal, shBasis) {
        // normal is assumed to be unit length
        const x = normal.x, y = normal.y, z = normal.z;
        // band 0
        shBasis[0] = 0.282095;
        // band 1
        shBasis[1] = 0.488603 * y;
        shBasis[2] = 0.488603 * z;
        shBasis[3] = 0.488603 * x;
        // band 2
        shBasis[4] = 1.092548 * x * y;
        shBasis[5] = 1.092548 * y * z;
        shBasis[6] = 0.315392 * (3 * z * z - 1);
        shBasis[7] = 1.092548 * x * z;
        shBasis[8] = 0.546274 * (x * x - y * y);
    }
}



class $9599db51c4c04820$export$e7ef036e309b38d2 extends (0, $a3eeb8c49a38c4a5$export$6ecadb6ed240d696) {
    constructor(sh = new (0, $39051cadd4748d5b$export$ba61ce607e1f405a)(), intensity = 1){
        super(undefined, intensity);
        this.isLightProbe = true;
        this.sh = sh;
    }
    copy(source) {
        super.copy(source);
        this.sh.copy(source.sh);
        return this;
    }
    fromJSON(json) {
        this.intensity = json.intensity; // TODO: Move this bit to Light.fromJSON();
        this.sh.fromArray(json.sh);
        return this;
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.object.sh = this.sh.toArray();
        return data;
    }
}



class $a77586efc35efd12$var$IESSpotLight extends (0, $05e7dfb34dcf7ac5$export$81495cbb73897362) {
    constructor(color, intensity, distance, angle, penumbra, decay){
        super(color, intensity, distance, angle, penumbra, decay);
        this.iesMap = null;
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.iesMap = source.iesMap;
        return this;
    }
}
var $a77586efc35efd12$export$2e2bcd8739ae039 = $a77586efc35efd12$var$IESSpotLight;




class $15dd6c1a8024d78e$var$StandardNodeLibrary extends (0, $cf59a4ca80db2ff6$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.addMaterial((0, $30b28559a96c3ca3$export$2e2bcd8739ae039), (0, $f2c168c1ef3d4267$export$24c72f71cbaf0678));
        this.addMaterial((0, $c6c766f08d29b743$export$2e2bcd8739ae039), (0, $248228003d1ce111$export$f2980790215acccd));
        this.addMaterial((0, $3433103932e4dc09$export$2e2bcd8739ae039), (0, $3916ce630a03508a$export$28d04986c4269c9f));
        this.addMaterial((0, $166fc548c8edaf45$export$2e2bcd8739ae039), (0, $df676fc8522e06be$export$df893cf97e765622));
        this.addMaterial((0, $4b8c69dc5d4bb347$export$2e2bcd8739ae039), (0, $30428884caacd4ad$export$55cbcc9b622fe1f5));
        this.addMaterial((0, $6b671cb45a65c32b$export$2e2bcd8739ae039), (0, $da18a46d400c99e2$export$5023a9a8114806b8));
        this.addMaterial((0, $70a25e8ef83ba872$export$2e2bcd8739ae039), (0, $0aa3bcd9d9d49c80$export$bfe8c0a091f41ae7));
        this.addMaterial((0, $4380fa8df6ac48cc$export$2e2bcd8739ae039), (0, $3eb5ad37383cae4e$export$6f5fef6235ec12ee));
        this.addMaterial((0, $9ec81905dd2bf03e$export$2e2bcd8739ae039), (0, $b8a84d020f0a5c06$export$fbaaa33907730a0c));
        this.addMaterial((0, $b4139533113f621f$export$2e2bcd8739ae039), (0, $8127f0c132963ff4$export$327886a3efaeaebe));
        this.addMaterial((0, $30151d68d7d8bc1d$export$2e2bcd8739ae039), (0, $f95b6247fc2c68d0$export$a178c45366ce5d6b));
        this.addMaterial((0, $eaa0a64a25291444$export$2e2bcd8739ae039), (0, $12f9355badc11ad4$export$5ec7dd1c6994bf8e));
        this.addMaterial((0, $5df5329447b15778$export$2e2bcd8739ae039), (0, $b0c2e16c30bc2127$export$e8564da406055a3));
        this.addLight((0, $12287d9c9f093f27$export$2e2bcd8739ae039), (0, $8dfc6db086f992d7$export$4c9c1cb3f0b6f455));
        this.addLight((0, $e01c01fe8e4607c2$export$2e2bcd8739ae039), (0, $4dd8c0896bc492d4$export$3fea33cc9972c868));
        this.addLight((0, $f6bd949db7c614c5$export$2e2bcd8739ae039), (0, $74f31cca411e80bd$export$61db2d908bbd2429));
        this.addLight((0, $b516406311089938$export$2e2bcd8739ae039), (0, $05e7dfb34dcf7ac5$export$81495cbb73897362));
        this.addLight((0, $c64ec0a0d80aa4e1$export$2e2bcd8739ae039), (0, $6e4aa1d95d746120$export$af279bfef9ec2c96));
        this.addLight((0, $9a2a2c30c39605df$export$2e2bcd8739ae039), (0, $97e01d90f172ad62$export$8d474f55edbb9624));
        this.addLight((0, $8c978f5120ff4d68$export$2e2bcd8739ae039), (0, $9599db51c4c04820$export$e7ef036e309b38d2));
        this.addLight((0, $439b02a79c98e55f$export$2e2bcd8739ae039), (0, $a77586efc35efd12$export$2e2bcd8739ae039));
        this.addToneMapping((0, $e93fc3d73612d493$export$9ead2d769de45b3a), (0, $cb5ee595c0f892af$export$98f52c2a46c598ca));
        this.addToneMapping((0, $e93fc3d73612d493$export$67ddcedc4b180767), (0, $cb5ee595c0f892af$export$74b25e54b3bcd548));
        this.addToneMapping((0, $e93fc3d73612d493$export$1e6226a4b0daaf11), (0, $cb5ee595c0f892af$export$932b3dd283d4a366));
        this.addToneMapping((0, $e93fc3d73612d493$export$2c3e905d79539321), (0, $cb5ee595c0f892af$export$a0d98fe6d7e4af64));
        this.addToneMapping((0, $e93fc3d73612d493$export$e208838cf33e57e8), (0, $cb5ee595c0f892af$export$212d53a513a325b2));
        this.addToneMapping((0, $e93fc3d73612d493$export$59c2cf1ae89c695a), (0, $cb5ee595c0f892af$export$f2863e1668a8e317));
    }
}
var $15dd6c1a8024d78e$export$2e2bcd8739ae039 = $15dd6c1a8024d78e$var$StandardNodeLibrary;


/*
const debugHandler = {

	get: function ( target, name ) {

		// Add |update
		if ( /^(create|destroy)/.test( name ) ) console.log( 'WebGPUBackend.' + name );

		return target[ name ];

	}

};
*/ class $8574d94dd9555abd$var$WebGPURenderer extends (0, $1010750c439bdb5c$export$2e2bcd8739ae039) {
    constructor(parameters = {}){
        let BackendClass;
        if (parameters.forceWebGL) BackendClass = (0, $53e987b995691f55$export$2e2bcd8739ae039);
        else {
            BackendClass = (0, $00002c23d5ded4a6$export$2e2bcd8739ae039);
            parameters.getFallback = ()=>{
                console.warn('THREE.WebGPURenderer: WebGPU is not available, running under WebGL2 backend.');
                return new (0, $53e987b995691f55$export$2e2bcd8739ae039)(parameters);
            };
        }
        const backend = new BackendClass(parameters);
        //super( new Proxy( backend, debugHandler ) );
        super(backend, parameters);
        this.library = new (0, $15dd6c1a8024d78e$export$2e2bcd8739ae039)();
        this.isWebGPURenderer = true;
    }
}
var $8574d94dd9555abd$export$2e2bcd8739ae039 = $8574d94dd9555abd$var$WebGPURenderer;



const $164afa34e4b04624$var$_changeEvent = {
    type: 'change'
};
const $164afa34e4b04624$var$_startEvent = {
    type: 'start'
};
const $164afa34e4b04624$var$_endEvent = {
    type: 'end'
};
const $164afa34e4b04624$var$_EPS = 0.000001;
const $164afa34e4b04624$var$_STATE = {
    NONE: -1,
    ROTATE: 0,
    ZOOM: 1,
    PAN: 2,
    TOUCH_ROTATE: 3,
    TOUCH_ZOOM_PAN: 4
};
const $164afa34e4b04624$var$_v2 = new (0, $d5b33d7c30034067$export$c977b3e384af9ae1)();
const $164afa34e4b04624$var$_mouseChange = new (0, $d5b33d7c30034067$export$c977b3e384af9ae1)();
const $164afa34e4b04624$var$_objectUp = new (0, $d5b33d7c30034067$export$64b5c384219d3699)();
const $164afa34e4b04624$var$_pan = new (0, $d5b33d7c30034067$export$64b5c384219d3699)();
const $164afa34e4b04624$var$_axis = new (0, $d5b33d7c30034067$export$64b5c384219d3699)();
const $164afa34e4b04624$var$_quaternion = new (0, $d5b33d7c30034067$export$23d6a54f0bbc85a3)();
const $164afa34e4b04624$var$_eyeDirection = new (0, $d5b33d7c30034067$export$64b5c384219d3699)();
const $164afa34e4b04624$var$_objectUpDirection = new (0, $d5b33d7c30034067$export$64b5c384219d3699)();
const $164afa34e4b04624$var$_objectSidewaysDirection = new (0, $d5b33d7c30034067$export$64b5c384219d3699)();
const $164afa34e4b04624$var$_moveDirection = new (0, $d5b33d7c30034067$export$64b5c384219d3699)();
class $164afa34e4b04624$export$18b7f869be764a91 extends (0, $d5b33d7c30034067$export$c7c44baae9d9f25f) {
    constructor(object, domElement = null){
        super(object, domElement);
        // API
        this.enabled = true;
        this.screen = {
            left: 0,
            top: 0,
            width: 0,
            height: 0
        };
        this.rotateSpeed = 1.0;
        this.zoomSpeed = 1.2;
        this.panSpeed = 0.3;
        this.noRotate = false;
        this.noZoom = false;
        this.noPan = false;
        this.staticMoving = false;
        this.dynamicDampingFactor = 0.2;
        this.minDistance = 0;
        this.maxDistance = Infinity;
        this.minZoom = 0;
        this.maxZoom = Infinity;
        this.keys = [
            'KeyA' /*A*/ ,
            'KeyS' /*S*/ ,
            'KeyD' /*D*/ 
        ];
        this.mouseButtons = {
            LEFT: (0, $d5b33d7c30034067$export$7177b3e430c2d7ca).ROTATE,
            MIDDLE: (0, $d5b33d7c30034067$export$7177b3e430c2d7ca).DOLLY,
            RIGHT: (0, $d5b33d7c30034067$export$7177b3e430c2d7ca).PAN
        };
        this.state = $164afa34e4b04624$var$_STATE.NONE;
        this.keyState = $164afa34e4b04624$var$_STATE.NONE;
        this.target = new (0, $d5b33d7c30034067$export$64b5c384219d3699)();
        // internals
        this._lastPosition = new (0, $d5b33d7c30034067$export$64b5c384219d3699)();
        this._lastZoom = 1;
        this._touchZoomDistanceStart = 0;
        this._touchZoomDistanceEnd = 0;
        this._lastAngle = 0;
        this._eye = new (0, $d5b33d7c30034067$export$64b5c384219d3699)();
        this._movePrev = new (0, $d5b33d7c30034067$export$c977b3e384af9ae1)();
        this._moveCurr = new (0, $d5b33d7c30034067$export$c977b3e384af9ae1)();
        this._lastAxis = new (0, $d5b33d7c30034067$export$64b5c384219d3699)();
        this._zoomStart = new (0, $d5b33d7c30034067$export$c977b3e384af9ae1)();
        this._zoomEnd = new (0, $d5b33d7c30034067$export$c977b3e384af9ae1)();
        this._panStart = new (0, $d5b33d7c30034067$export$c977b3e384af9ae1)();
        this._panEnd = new (0, $d5b33d7c30034067$export$c977b3e384af9ae1)();
        this._pointers = [];
        this._pointerPositions = {};
        // event listeners
        this._onPointerMove = $164afa34e4b04624$var$onPointerMove.bind(this);
        this._onPointerDown = $164afa34e4b04624$var$onPointerDown.bind(this);
        this._onPointerUp = $164afa34e4b04624$var$onPointerUp.bind(this);
        this._onPointerCancel = $164afa34e4b04624$var$onPointerCancel.bind(this);
        this._onContextMenu = $164afa34e4b04624$var$onContextMenu.bind(this);
        this._onMouseWheel = $164afa34e4b04624$var$onMouseWheel.bind(this);
        this._onKeyDown = $164afa34e4b04624$var$onKeyDown.bind(this);
        this._onKeyUp = $164afa34e4b04624$var$onKeyUp.bind(this);
        this._onTouchStart = $164afa34e4b04624$var$onTouchStart.bind(this);
        this._onTouchMove = $164afa34e4b04624$var$onTouchMove.bind(this);
        this._onTouchEnd = $164afa34e4b04624$var$onTouchEnd.bind(this);
        this._onMouseDown = $164afa34e4b04624$var$onMouseDown.bind(this);
        this._onMouseMove = $164afa34e4b04624$var$onMouseMove.bind(this);
        this._onMouseUp = $164afa34e4b04624$var$onMouseUp.bind(this);
        // for reset
        this._target0 = this.target.clone();
        this._position0 = this.object.position.clone();
        this._up0 = this.object.up.clone();
        this._zoom0 = this.object.zoom;
        if (domElement !== null) {
            this.connect();
            this.handleResize();
        }
        // force an update at start
        this.update();
    }
    connect() {
        window.addEventListener('keydown', this._onKeyDown);
        window.addEventListener('keyup', this._onKeyUp);
        this.domElement.addEventListener('pointerdown', this._onPointerDown);
        this.domElement.addEventListener('pointercancel', this._onPointerCancel);
        this.domElement.addEventListener('wheel', this._onMouseWheel, {
            passive: false
        });
        this.domElement.addEventListener('contextmenu', this._onContextMenu);
        this.domElement.style.touchAction = 'none'; // disable touch scroll
    }
    disconnect() {
        window.removeEventListener('keydown', this._onKeyDown);
        window.removeEventListener('keyup', this._onKeyUp);
        this.domElement.removeEventListener('pointerdown', this._onPointerDown);
        this.domElement.removeEventListener('pointermove', this._onPointerMove);
        this.domElement.removeEventListener('pointerup', this._onPointerUp);
        this.domElement.removeEventListener('pointercancel', this._onPointerCancel);
        this.domElement.removeEventListener('wheel', this._onMouseWheel);
        this.domElement.removeEventListener('contextmenu', this._onContextMenu);
        this.domElement.style.touchAction = 'auto'; // disable touch scroll
    }
    dispose() {
        this.disconnect();
    }
    handleResize() {
        const box = this.domElement.getBoundingClientRect();
        // adjustments come from similar code in the jquery offset() function
        const d = this.domElement.ownerDocument.documentElement;
        this.screen.left = box.left + window.pageXOffset - d.clientLeft;
        this.screen.top = box.top + window.pageYOffset - d.clientTop;
        this.screen.width = box.width;
        this.screen.height = box.height;
    }
    update() {
        this._eye.subVectors(this.object.position, this.target);
        if (!this.noRotate) this._rotateCamera();
        if (!this.noZoom) this._zoomCamera();
        if (!this.noPan) this._panCamera();
        this.object.position.addVectors(this.target, this._eye);
        if (this.object.isPerspectiveCamera) {
            this._checkDistances();
            this.object.lookAt(this.target);
            if (this._lastPosition.distanceToSquared(this.object.position) > $164afa34e4b04624$var$_EPS) {
                this.dispatchEvent($164afa34e4b04624$var$_changeEvent);
                this._lastPosition.copy(this.object.position);
            }
        } else if (this.object.isOrthographicCamera) {
            this.object.lookAt(this.target);
            if (this._lastPosition.distanceToSquared(this.object.position) > $164afa34e4b04624$var$_EPS || this._lastZoom !== this.object.zoom) {
                this.dispatchEvent($164afa34e4b04624$var$_changeEvent);
                this._lastPosition.copy(this.object.position);
                this._lastZoom = this.object.zoom;
            }
        } else console.warn('THREE.TrackballControls: Unsupported camera type.');
    }
    reset() {
        this.state = $164afa34e4b04624$var$_STATE.NONE;
        this.keyState = $164afa34e4b04624$var$_STATE.NONE;
        this.target.copy(this._target0);
        this.object.position.copy(this._position0);
        this.object.up.copy(this._up0);
        this.object.zoom = this._zoom0;
        this.object.updateProjectionMatrix();
        this._eye.subVectors(this.object.position, this.target);
        this.object.lookAt(this.target);
        this.dispatchEvent($164afa34e4b04624$var$_changeEvent);
        this._lastPosition.copy(this.object.position);
        this._lastZoom = this.object.zoom;
    }
    _panCamera() {
        $164afa34e4b04624$var$_mouseChange.copy(this._panEnd).sub(this._panStart);
        if ($164afa34e4b04624$var$_mouseChange.lengthSq()) {
            if (this.object.isOrthographicCamera) {
                const scale_x = (this.object.right - this.object.left) / this.object.zoom / this.domElement.clientWidth;
                const scale_y = (this.object.top - this.object.bottom) / this.object.zoom / this.domElement.clientWidth;
                $164afa34e4b04624$var$_mouseChange.x *= scale_x;
                $164afa34e4b04624$var$_mouseChange.y *= scale_y;
            }
            $164afa34e4b04624$var$_mouseChange.multiplyScalar(this._eye.length() * this.panSpeed);
            $164afa34e4b04624$var$_pan.copy(this._eye).cross(this.object.up).setLength($164afa34e4b04624$var$_mouseChange.x);
            $164afa34e4b04624$var$_pan.add($164afa34e4b04624$var$_objectUp.copy(this.object.up).setLength($164afa34e4b04624$var$_mouseChange.y));
            this.object.position.add($164afa34e4b04624$var$_pan);
            this.target.add($164afa34e4b04624$var$_pan);
            if (this.staticMoving) this._panStart.copy(this._panEnd);
            else this._panStart.add($164afa34e4b04624$var$_mouseChange.subVectors(this._panEnd, this._panStart).multiplyScalar(this.dynamicDampingFactor));
        }
    }
    _rotateCamera() {
        $164afa34e4b04624$var$_moveDirection.set(this._moveCurr.x - this._movePrev.x, this._moveCurr.y - this._movePrev.y, 0);
        let angle = $164afa34e4b04624$var$_moveDirection.length();
        if (angle) {
            this._eye.copy(this.object.position).sub(this.target);
            $164afa34e4b04624$var$_eyeDirection.copy(this._eye).normalize();
            $164afa34e4b04624$var$_objectUpDirection.copy(this.object.up).normalize();
            $164afa34e4b04624$var$_objectSidewaysDirection.crossVectors($164afa34e4b04624$var$_objectUpDirection, $164afa34e4b04624$var$_eyeDirection).normalize();
            $164afa34e4b04624$var$_objectUpDirection.setLength(this._moveCurr.y - this._movePrev.y);
            $164afa34e4b04624$var$_objectSidewaysDirection.setLength(this._moveCurr.x - this._movePrev.x);
            $164afa34e4b04624$var$_moveDirection.copy($164afa34e4b04624$var$_objectUpDirection.add($164afa34e4b04624$var$_objectSidewaysDirection));
            $164afa34e4b04624$var$_axis.crossVectors($164afa34e4b04624$var$_moveDirection, this._eye).normalize();
            angle *= this.rotateSpeed;
            $164afa34e4b04624$var$_quaternion.setFromAxisAngle($164afa34e4b04624$var$_axis, angle);
            this._eye.applyQuaternion($164afa34e4b04624$var$_quaternion);
            this.object.up.applyQuaternion($164afa34e4b04624$var$_quaternion);
            this._lastAxis.copy($164afa34e4b04624$var$_axis);
            this._lastAngle = angle;
        } else if (!this.staticMoving && this._lastAngle) {
            this._lastAngle *= Math.sqrt(1.0 - this.dynamicDampingFactor);
            this._eye.copy(this.object.position).sub(this.target);
            $164afa34e4b04624$var$_quaternion.setFromAxisAngle(this._lastAxis, this._lastAngle);
            this._eye.applyQuaternion($164afa34e4b04624$var$_quaternion);
            this.object.up.applyQuaternion($164afa34e4b04624$var$_quaternion);
        }
        this._movePrev.copy(this._moveCurr);
    }
    _zoomCamera() {
        let factor;
        if (this.state === $164afa34e4b04624$var$_STATE.TOUCH_ZOOM_PAN) {
            factor = this._touchZoomDistanceStart / this._touchZoomDistanceEnd;
            this._touchZoomDistanceStart = this._touchZoomDistanceEnd;
            if (this.object.isPerspectiveCamera) this._eye.multiplyScalar(factor);
            else if (this.object.isOrthographicCamera) {
                this.object.zoom = (0, $d5b33d7c30034067$export$6a7ef315a0d1ef07).clamp(this.object.zoom / factor, this.minZoom, this.maxZoom);
                if (this._lastZoom !== this.object.zoom) this.object.updateProjectionMatrix();
            } else console.warn('THREE.TrackballControls: Unsupported camera type');
        } else {
            factor = 1.0 + (this._zoomEnd.y - this._zoomStart.y) * this.zoomSpeed;
            if (factor !== 1.0 && factor > 0.0) {
                if (this.object.isPerspectiveCamera) this._eye.multiplyScalar(factor);
                else if (this.object.isOrthographicCamera) {
                    this.object.zoom = (0, $d5b33d7c30034067$export$6a7ef315a0d1ef07).clamp(this.object.zoom / factor, this.minZoom, this.maxZoom);
                    if (this._lastZoom !== this.object.zoom) this.object.updateProjectionMatrix();
                } else console.warn('THREE.TrackballControls: Unsupported camera type');
            }
            if (this.staticMoving) this._zoomStart.copy(this._zoomEnd);
            else this._zoomStart.y += (this._zoomEnd.y - this._zoomStart.y) * this.dynamicDampingFactor;
        }
    }
    _getMouseOnScreen(pageX, pageY) {
        $164afa34e4b04624$var$_v2.set((pageX - this.screen.left) / this.screen.width, (pageY - this.screen.top) / this.screen.height);
        return $164afa34e4b04624$var$_v2;
    }
    _getMouseOnCircle(pageX, pageY) {
        $164afa34e4b04624$var$_v2.set((pageX - this.screen.width * 0.5 - this.screen.left) / (this.screen.width * 0.5), (this.screen.height + 2 * (this.screen.top - pageY)) / this.screen.width // screen.width intentional
        );
        return $164afa34e4b04624$var$_v2;
    }
    _addPointer(event) {
        this._pointers.push(event);
    }
    _removePointer(event) {
        delete this._pointerPositions[event.pointerId];
        for(let i = 0; i < this._pointers.length; i++)if (this._pointers[i].pointerId == event.pointerId) {
            this._pointers.splice(i, 1);
            return;
        }
    }
    _trackPointer(event) {
        let position = this._pointerPositions[event.pointerId];
        if (position === undefined) {
            position = new (0, $d5b33d7c30034067$export$c977b3e384af9ae1)();
            this._pointerPositions[event.pointerId] = position;
        }
        position.set(event.pageX, event.pageY);
    }
    _getSecondPointerPosition(event) {
        const pointer = event.pointerId === this._pointers[0].pointerId ? this._pointers[1] : this._pointers[0];
        return this._pointerPositions[pointer.pointerId];
    }
    _checkDistances() {
        if (!this.noZoom || !this.noPan) {
            if (this._eye.lengthSq() > this.maxDistance * this.maxDistance) {
                this.object.position.addVectors(this.target, this._eye.setLength(this.maxDistance));
                this._zoomStart.copy(this._zoomEnd);
            }
            if (this._eye.lengthSq() < this.minDistance * this.minDistance) {
                this.object.position.addVectors(this.target, this._eye.setLength(this.minDistance));
                this._zoomStart.copy(this._zoomEnd);
            }
        }
    }
}
function $164afa34e4b04624$var$onPointerDown(event) {
    if (this.enabled === false) return;
    if (this._pointers.length === 0) {
        this.domElement.setPointerCapture(event.pointerId);
        this.domElement.addEventListener('pointermove', this._onPointerMove);
        this.domElement.addEventListener('pointerup', this._onPointerUp);
    }
    //
    this._addPointer(event);
    if (event.pointerType === 'touch') this._onTouchStart(event);
    else this._onMouseDown(event);
}
function $164afa34e4b04624$var$onPointerMove(event) {
    if (this.enabled === false) return;
    if (event.pointerType === 'touch') this._onTouchMove(event);
    else this._onMouseMove(event);
}
function $164afa34e4b04624$var$onPointerUp(event) {
    if (this.enabled === false) return;
    if (event.pointerType === 'touch') this._onTouchEnd(event);
    else this._onMouseUp();
    //
    this._removePointer(event);
    if (this._pointers.length === 0) {
        this.domElement.releasePointerCapture(event.pointerId);
        this.domElement.removeEventListener('pointermove', this._onPointerMove);
        this.domElement.removeEventListener('pointerup', this._onPointerUp);
    }
}
function $164afa34e4b04624$var$onPointerCancel(event) {
    this._removePointer(event);
}
function $164afa34e4b04624$var$onKeyUp() {
    if (this.enabled === false) return;
    this.keyState = $164afa34e4b04624$var$_STATE.NONE;
    window.addEventListener('keydown', this._onKeyDown);
}
function $164afa34e4b04624$var$onKeyDown(event) {
    if (this.enabled === false) return;
    window.removeEventListener('keydown', this._onKeyDown);
    if (this.keyState !== $164afa34e4b04624$var$_STATE.NONE) return;
    else if (event.code === this.keys[$164afa34e4b04624$var$_STATE.ROTATE] && !this.noRotate) this.keyState = $164afa34e4b04624$var$_STATE.ROTATE;
    else if (event.code === this.keys[$164afa34e4b04624$var$_STATE.ZOOM] && !this.noZoom) this.keyState = $164afa34e4b04624$var$_STATE.ZOOM;
    else if (event.code === this.keys[$164afa34e4b04624$var$_STATE.PAN] && !this.noPan) this.keyState = $164afa34e4b04624$var$_STATE.PAN;
}
function $164afa34e4b04624$var$onMouseDown(event) {
    let mouseAction;
    switch(event.button){
        case 0:
            mouseAction = this.mouseButtons.LEFT;
            break;
        case 1:
            mouseAction = this.mouseButtons.MIDDLE;
            break;
        case 2:
            mouseAction = this.mouseButtons.RIGHT;
            break;
        default:
            mouseAction = -1;
    }
    switch(mouseAction){
        case (0, $d5b33d7c30034067$export$7177b3e430c2d7ca).DOLLY:
            this.state = $164afa34e4b04624$var$_STATE.ZOOM;
            break;
        case (0, $d5b33d7c30034067$export$7177b3e430c2d7ca).ROTATE:
            this.state = $164afa34e4b04624$var$_STATE.ROTATE;
            break;
        case (0, $d5b33d7c30034067$export$7177b3e430c2d7ca).PAN:
            this.state = $164afa34e4b04624$var$_STATE.PAN;
            break;
        default:
            this.state = $164afa34e4b04624$var$_STATE.NONE;
    }
    const state = this.keyState !== $164afa34e4b04624$var$_STATE.NONE ? this.keyState : this.state;
    if (state === $164afa34e4b04624$var$_STATE.ROTATE && !this.noRotate) {
        this._moveCurr.copy(this._getMouseOnCircle(event.pageX, event.pageY));
        this._movePrev.copy(this._moveCurr);
    } else if (state === $164afa34e4b04624$var$_STATE.ZOOM && !this.noZoom) {
        this._zoomStart.copy(this._getMouseOnScreen(event.pageX, event.pageY));
        this._zoomEnd.copy(this._zoomStart);
    } else if (state === $164afa34e4b04624$var$_STATE.PAN && !this.noPan) {
        this._panStart.copy(this._getMouseOnScreen(event.pageX, event.pageY));
        this._panEnd.copy(this._panStart);
    }
    this.dispatchEvent($164afa34e4b04624$var$_startEvent);
}
function $164afa34e4b04624$var$onMouseMove(event) {
    const state = this.keyState !== $164afa34e4b04624$var$_STATE.NONE ? this.keyState : this.state;
    if (state === $164afa34e4b04624$var$_STATE.ROTATE && !this.noRotate) {
        this._movePrev.copy(this._moveCurr);
        this._moveCurr.copy(this._getMouseOnCircle(event.pageX, event.pageY));
    } else if (state === $164afa34e4b04624$var$_STATE.ZOOM && !this.noZoom) this._zoomEnd.copy(this._getMouseOnScreen(event.pageX, event.pageY));
    else if (state === $164afa34e4b04624$var$_STATE.PAN && !this.noPan) this._panEnd.copy(this._getMouseOnScreen(event.pageX, event.pageY));
}
function $164afa34e4b04624$var$onMouseUp() {
    this.state = $164afa34e4b04624$var$_STATE.NONE;
    this.dispatchEvent($164afa34e4b04624$var$_endEvent);
}
function $164afa34e4b04624$var$onMouseWheel(event) {
    if (this.enabled === false) return;
    if (this.noZoom === true) return;
    event.preventDefault();
    switch(event.deltaMode){
        case 2:
            // Zoom in pages
            this._zoomStart.y -= event.deltaY * 0.025;
            break;
        case 1:
            // Zoom in lines
            this._zoomStart.y -= event.deltaY * 0.01;
            break;
        default:
            // undefined, 0, assume pixels
            this._zoomStart.y -= event.deltaY * 0.00025;
            break;
    }
    this.dispatchEvent($164afa34e4b04624$var$_startEvent);
    this.dispatchEvent($164afa34e4b04624$var$_endEvent);
}
function $164afa34e4b04624$var$onContextMenu(event) {
    if (this.enabled === false) return;
    event.preventDefault();
}
function $164afa34e4b04624$var$onTouchStart(event) {
    this._trackPointer(event);
    switch(this._pointers.length){
        case 1:
            this.state = $164afa34e4b04624$var$_STATE.TOUCH_ROTATE;
            this._moveCurr.copy(this._getMouseOnCircle(this._pointers[0].pageX, this._pointers[0].pageY));
            this._movePrev.copy(this._moveCurr);
            break;
        default:
            this.state = $164afa34e4b04624$var$_STATE.TOUCH_ZOOM_PAN;
            const dx = this._pointers[0].pageX - this._pointers[1].pageX;
            const dy = this._pointers[0].pageY - this._pointers[1].pageY;
            this._touchZoomDistanceEnd = this._touchZoomDistanceStart = Math.sqrt(dx * dx + dy * dy);
            const x = (this._pointers[0].pageX + this._pointers[1].pageX) / 2;
            const y = (this._pointers[0].pageY + this._pointers[1].pageY) / 2;
            this._panStart.copy(this._getMouseOnScreen(x, y));
            this._panEnd.copy(this._panStart);
            break;
    }
    this.dispatchEvent($164afa34e4b04624$var$_startEvent);
}
function $164afa34e4b04624$var$onTouchMove(event) {
    this._trackPointer(event);
    switch(this._pointers.length){
        case 1:
            this._movePrev.copy(this._moveCurr);
            this._moveCurr.copy(this._getMouseOnCircle(event.pageX, event.pageY));
            break;
        default:
            const position = this._getSecondPointerPosition(event);
            const dx = event.pageX - position.x;
            const dy = event.pageY - position.y;
            this._touchZoomDistanceEnd = Math.sqrt(dx * dx + dy * dy);
            const x = (event.pageX + position.x) / 2;
            const y = (event.pageY + position.y) / 2;
            this._panEnd.copy(this._getMouseOnScreen(x, y));
            break;
    }
}
function $164afa34e4b04624$var$onTouchEnd(event) {
    switch(this._pointers.length){
        case 0:
            this.state = $164afa34e4b04624$var$_STATE.NONE;
            break;
        case 1:
            this.state = $164afa34e4b04624$var$_STATE.TOUCH_ROTATE;
            this._moveCurr.copy(this._getMouseOnCircle(event.pageX, event.pageY));
            this._movePrev.copy(this._moveCurr);
            break;
        case 2:
            this.state = $164afa34e4b04624$var$_STATE.TOUCH_ZOOM_PAN;
            for(let i = 0; i < this._pointers.length; i++)if (this._pointers[i].pointerId !== event.pointerId) {
                const position = this._pointerPositions[this._pointers[i].pointerId];
                this._moveCurr.copy(this._getMouseOnCircle(position.x, position.y));
                this._movePrev.copy(this._moveCurr);
                break;
            }
            break;
    }
    this.dispatchEvent($164afa34e4b04624$var$_endEvent);
}



// OrbitControls performs orbiting, dollying (zooming), and panning.
// Unlike TrackballControls, it maintains the "up" direction object.up (+Y by default).
//
//    Orbit - left mouse / touch: one-finger move
//    Zoom - middle mouse, or mousewheel / touch: two-finger spread or squish
//    Pan - right mouse, or left mouse + ctrl/meta/shiftKey, or arrow keys / touch: two-finger move
const $443c013b983d0324$var$_changeEvent = {
    type: 'change'
};
const $443c013b983d0324$var$_startEvent = {
    type: 'start'
};
const $443c013b983d0324$var$_endEvent = {
    type: 'end'
};
const $443c013b983d0324$var$_ray = new (0, $d5b33d7c30034067$export$a186db52eed6d40e)();
const $443c013b983d0324$var$_plane = new (0, $d5b33d7c30034067$export$7ff5ac152ef991b0)();
const $443c013b983d0324$var$_TILT_LIMIT = Math.cos(70 * (0, $d5b33d7c30034067$export$6a7ef315a0d1ef07).DEG2RAD);
const $443c013b983d0324$var$_v = new (0, $d5b33d7c30034067$export$64b5c384219d3699)();
const $443c013b983d0324$var$_twoPI = 2 * Math.PI;
const $443c013b983d0324$var$_STATE = {
    NONE: -1,
    ROTATE: 0,
    DOLLY: 1,
    PAN: 2,
    TOUCH_ROTATE: 3,
    TOUCH_PAN: 4,
    TOUCH_DOLLY_PAN: 5,
    TOUCH_DOLLY_ROTATE: 6
};
const $443c013b983d0324$var$_EPS = 0.000001;
class $443c013b983d0324$export$8ff7788029dfdf52 extends (0, $d5b33d7c30034067$export$c7c44baae9d9f25f) {
    constructor(object, domElement = null){
        super(object, domElement);
        this.state = $443c013b983d0324$var$_STATE.NONE;
        // Set to false to disable this control
        this.enabled = true;
        // "target" sets the location of focus, where the object orbits around
        this.target = new (0, $d5b33d7c30034067$export$64b5c384219d3699)();
        // Sets the 3D cursor (similar to Blender), from which the maxTargetRadius takes effect
        this.cursor = new (0, $d5b33d7c30034067$export$64b5c384219d3699)();
        // How far you can dolly in and out ( PerspectiveCamera only )
        this.minDistance = 0;
        this.maxDistance = Infinity;
        // How far you can zoom in and out ( OrthographicCamera only )
        this.minZoom = 0;
        this.maxZoom = Infinity;
        // Limit camera target within a spherical area around the cursor
        this.minTargetRadius = 0;
        this.maxTargetRadius = Infinity;
        // How far you can orbit vertically, upper and lower limits.
        // Range is 0 to Math.PI radians.
        this.minPolarAngle = 0; // radians
        this.maxPolarAngle = Math.PI; // radians
        // How far you can orbit horizontally, upper and lower limits.
        // If set, the interval [ min, max ] must be a sub-interval of [ - 2 PI, 2 PI ], with ( max - min < 2 PI )
        this.minAzimuthAngle = -Infinity; // radians
        this.maxAzimuthAngle = Infinity; // radians
        // Set to true to enable damping (inertia)
        // If damping is enabled, you must call controls.update() in your animation loop
        this.enableDamping = false;
        this.dampingFactor = 0.05;
        // This option actually enables dollying in and out; left as "zoom" for backwards compatibility.
        // Set to false to disable zooming
        this.enableZoom = true;
        this.zoomSpeed = 1.0;
        // Set to false to disable rotating
        this.enableRotate = true;
        this.rotateSpeed = 1.0;
        // Set to false to disable panning
        this.enablePan = true;
        this.panSpeed = 1.0;
        this.screenSpacePanning = true; // if false, pan orthogonal to world-space direction camera.up
        this.keyPanSpeed = 7.0; // pixels moved per arrow key push
        this.zoomToCursor = false;
        // Set to true to automatically rotate around the target
        // If auto-rotate is enabled, you must call controls.update() in your animation loop
        this.autoRotate = false;
        this.autoRotateSpeed = 2.0; // 30 seconds per orbit when fps is 60
        // The four arrow keys
        this.keys = {
            LEFT: 'ArrowLeft',
            UP: 'ArrowUp',
            RIGHT: 'ArrowRight',
            BOTTOM: 'ArrowDown'
        };
        // Mouse buttons
        this.mouseButtons = {
            LEFT: (0, $d5b33d7c30034067$export$7177b3e430c2d7ca).ROTATE,
            MIDDLE: (0, $d5b33d7c30034067$export$7177b3e430c2d7ca).DOLLY,
            RIGHT: (0, $d5b33d7c30034067$export$7177b3e430c2d7ca).PAN
        };
        // Touch fingers
        this.touches = {
            ONE: (0, $d5b33d7c30034067$export$d46bd3ead7cc759b).ROTATE,
            TWO: (0, $d5b33d7c30034067$export$d46bd3ead7cc759b).DOLLY_PAN
        };
        // for reset
        this.target0 = this.target.clone();
        this.position0 = this.object.position.clone();
        this.zoom0 = this.object.zoom;
        // the target DOM element for key events
        this._domElementKeyEvents = null;
        // internals
        this._lastPosition = new (0, $d5b33d7c30034067$export$64b5c384219d3699)();
        this._lastQuaternion = new (0, $d5b33d7c30034067$export$23d6a54f0bbc85a3)();
        this._lastTargetPosition = new (0, $d5b33d7c30034067$export$64b5c384219d3699)();
        // so camera.up is the orbit axis
        this._quat = new (0, $d5b33d7c30034067$export$23d6a54f0bbc85a3)().setFromUnitVectors(object.up, new (0, $d5b33d7c30034067$export$64b5c384219d3699)(0, 1, 0));
        this._quatInverse = this._quat.clone().invert();
        // current position in spherical coordinates
        this._spherical = new (0, $d5b33d7c30034067$export$d712cd887b4a00f7)();
        this._sphericalDelta = new (0, $d5b33d7c30034067$export$d712cd887b4a00f7)();
        this._scale = 1;
        this._panOffset = new (0, $d5b33d7c30034067$export$64b5c384219d3699)();
        this._rotateStart = new (0, $d5b33d7c30034067$export$c977b3e384af9ae1)();
        this._rotateEnd = new (0, $d5b33d7c30034067$export$c977b3e384af9ae1)();
        this._rotateDelta = new (0, $d5b33d7c30034067$export$c977b3e384af9ae1)();
        this._panStart = new (0, $d5b33d7c30034067$export$c977b3e384af9ae1)();
        this._panEnd = new (0, $d5b33d7c30034067$export$c977b3e384af9ae1)();
        this._panDelta = new (0, $d5b33d7c30034067$export$c977b3e384af9ae1)();
        this._dollyStart = new (0, $d5b33d7c30034067$export$c977b3e384af9ae1)();
        this._dollyEnd = new (0, $d5b33d7c30034067$export$c977b3e384af9ae1)();
        this._dollyDelta = new (0, $d5b33d7c30034067$export$c977b3e384af9ae1)();
        this._dollyDirection = new (0, $d5b33d7c30034067$export$64b5c384219d3699)();
        this._mouse = new (0, $d5b33d7c30034067$export$c977b3e384af9ae1)();
        this._performCursorZoom = false;
        this._pointers = [];
        this._pointerPositions = {};
        this._controlActive = false;
        // event listeners
        this._onPointerMove = $443c013b983d0324$var$onPointerMove.bind(this);
        this._onPointerDown = $443c013b983d0324$var$onPointerDown.bind(this);
        this._onPointerUp = $443c013b983d0324$var$onPointerUp.bind(this);
        this._onContextMenu = $443c013b983d0324$var$onContextMenu.bind(this);
        this._onMouseWheel = $443c013b983d0324$var$onMouseWheel.bind(this);
        this._onKeyDown = $443c013b983d0324$var$onKeyDown.bind(this);
        this._onTouchStart = $443c013b983d0324$var$onTouchStart.bind(this);
        this._onTouchMove = $443c013b983d0324$var$onTouchMove.bind(this);
        this._onMouseDown = $443c013b983d0324$var$onMouseDown.bind(this);
        this._onMouseMove = $443c013b983d0324$var$onMouseMove.bind(this);
        this._interceptControlDown = $443c013b983d0324$var$interceptControlDown.bind(this);
        this._interceptControlUp = $443c013b983d0324$var$interceptControlUp.bind(this);
        //
        if (this.domElement !== null) this.connect();
        this.update();
    }
    connect() {
        this.domElement.addEventListener('pointerdown', this._onPointerDown);
        this.domElement.addEventListener('pointercancel', this._onPointerUp);
        this.domElement.addEventListener('contextmenu', this._onContextMenu);
        this.domElement.addEventListener('wheel', this._onMouseWheel, {
            passive: false
        });
        const document = this.domElement.getRootNode(); // offscreen canvas compatibility
        document.addEventListener('keydown', this._interceptControlDown, {
            passive: true,
            capture: true
        });
        this.domElement.style.touchAction = 'none'; // disable touch scroll
    }
    disconnect() {
        this.domElement.removeEventListener('pointerdown', this._onPointerDown);
        this.domElement.removeEventListener('pointermove', this._onPointerMove);
        this.domElement.removeEventListener('pointerup', this._onPointerUp);
        this.domElement.removeEventListener('pointercancel', this._onPointerUp);
        this.domElement.removeEventListener('wheel', this._onMouseWheel);
        this.domElement.removeEventListener('contextmenu', this._onContextMenu);
        this.stopListenToKeyEvents();
        const document = this.domElement.getRootNode(); // offscreen canvas compatibility
        document.removeEventListener('keydown', this._interceptControlDown, {
            capture: true
        });
        this.domElement.style.touchAction = 'auto';
    }
    dispose() {
        this.disconnect();
    }
    getPolarAngle() {
        return this._spherical.phi;
    }
    getAzimuthalAngle() {
        return this._spherical.theta;
    }
    getDistance() {
        return this.object.position.distanceTo(this.target);
    }
    listenToKeyEvents(domElement) {
        domElement.addEventListener('keydown', this._onKeyDown);
        this._domElementKeyEvents = domElement;
    }
    stopListenToKeyEvents() {
        if (this._domElementKeyEvents !== null) {
            this._domElementKeyEvents.removeEventListener('keydown', this._onKeyDown);
            this._domElementKeyEvents = null;
        }
    }
    saveState() {
        this.target0.copy(this.target);
        this.position0.copy(this.object.position);
        this.zoom0 = this.object.zoom;
    }
    reset() {
        this.target.copy(this.target0);
        this.object.position.copy(this.position0);
        this.object.zoom = this.zoom0;
        this.object.updateProjectionMatrix();
        this.dispatchEvent($443c013b983d0324$var$_changeEvent);
        this.update();
        this.state = $443c013b983d0324$var$_STATE.NONE;
    }
    update(deltaTime = null) {
        const position = this.object.position;
        $443c013b983d0324$var$_v.copy(position).sub(this.target);
        // rotate offset to "y-axis-is-up" space
        $443c013b983d0324$var$_v.applyQuaternion(this._quat);
        // angle from z-axis around y-axis
        this._spherical.setFromVector3($443c013b983d0324$var$_v);
        if (this.autoRotate && this.state === $443c013b983d0324$var$_STATE.NONE) this._rotateLeft(this._getAutoRotationAngle(deltaTime));
        if (this.enableDamping) {
            this._spherical.theta += this._sphericalDelta.theta * this.dampingFactor;
            this._spherical.phi += this._sphericalDelta.phi * this.dampingFactor;
        } else {
            this._spherical.theta += this._sphericalDelta.theta;
            this._spherical.phi += this._sphericalDelta.phi;
        }
        // restrict theta to be between desired limits
        let min = this.minAzimuthAngle;
        let max = this.maxAzimuthAngle;
        if (isFinite(min) && isFinite(max)) {
            if (min < -Math.PI) min += $443c013b983d0324$var$_twoPI;
            else if (min > Math.PI) min -= $443c013b983d0324$var$_twoPI;
            if (max < -Math.PI) max += $443c013b983d0324$var$_twoPI;
            else if (max > Math.PI) max -= $443c013b983d0324$var$_twoPI;
            if (min <= max) this._spherical.theta = Math.max(min, Math.min(max, this._spherical.theta));
            else this._spherical.theta = this._spherical.theta > (min + max) / 2 ? Math.max(min, this._spherical.theta) : Math.min(max, this._spherical.theta);
        }
        // restrict phi to be between desired limits
        this._spherical.phi = Math.max(this.minPolarAngle, Math.min(this.maxPolarAngle, this._spherical.phi));
        this._spherical.makeSafe();
        // move target to panned location
        if (this.enableDamping === true) this.target.addScaledVector(this._panOffset, this.dampingFactor);
        else this.target.add(this._panOffset);
        // Limit the target distance from the cursor to create a sphere around the center of interest
        this.target.sub(this.cursor);
        this.target.clampLength(this.minTargetRadius, this.maxTargetRadius);
        this.target.add(this.cursor);
        let zoomChanged = false;
        // adjust the camera position based on zoom only if we're not zooming to the cursor or if it's an ortho camera
        // we adjust zoom later in these cases
        if (this.zoomToCursor && this._performCursorZoom || this.object.isOrthographicCamera) this._spherical.radius = this._clampDistance(this._spherical.radius);
        else {
            const prevRadius = this._spherical.radius;
            this._spherical.radius = this._clampDistance(this._spherical.radius * this._scale);
            zoomChanged = prevRadius != this._spherical.radius;
        }
        $443c013b983d0324$var$_v.setFromSpherical(this._spherical);
        // rotate offset back to "camera-up-vector-is-up" space
        $443c013b983d0324$var$_v.applyQuaternion(this._quatInverse);
        position.copy(this.target).add($443c013b983d0324$var$_v);
        this.object.lookAt(this.target);
        if (this.enableDamping === true) {
            this._sphericalDelta.theta *= 1 - this.dampingFactor;
            this._sphericalDelta.phi *= 1 - this.dampingFactor;
            this._panOffset.multiplyScalar(1 - this.dampingFactor);
        } else {
            this._sphericalDelta.set(0, 0, 0);
            this._panOffset.set(0, 0, 0);
        }
        // adjust camera position
        if (this.zoomToCursor && this._performCursorZoom) {
            let newRadius = null;
            if (this.object.isPerspectiveCamera) {
                // move the camera down the pointer ray
                // this method avoids floating point error
                const prevRadius = $443c013b983d0324$var$_v.length();
                newRadius = this._clampDistance(prevRadius * this._scale);
                const radiusDelta = prevRadius - newRadius;
                this.object.position.addScaledVector(this._dollyDirection, radiusDelta);
                this.object.updateMatrixWorld();
                zoomChanged = !!radiusDelta;
            } else if (this.object.isOrthographicCamera) {
                // adjust the ortho camera position based on zoom changes
                const mouseBefore = new (0, $d5b33d7c30034067$export$64b5c384219d3699)(this._mouse.x, this._mouse.y, 0);
                mouseBefore.unproject(this.object);
                const prevZoom = this.object.zoom;
                this.object.zoom = Math.max(this.minZoom, Math.min(this.maxZoom, this.object.zoom / this._scale));
                this.object.updateProjectionMatrix();
                zoomChanged = prevZoom !== this.object.zoom;
                const mouseAfter = new (0, $d5b33d7c30034067$export$64b5c384219d3699)(this._mouse.x, this._mouse.y, 0);
                mouseAfter.unproject(this.object);
                this.object.position.sub(mouseAfter).add(mouseBefore);
                this.object.updateMatrixWorld();
                newRadius = $443c013b983d0324$var$_v.length();
            } else {
                console.warn('WARNING: OrbitControls.js encountered an unknown camera type - zoom to cursor disabled.');
                this.zoomToCursor = false;
            }
            // handle the placement of the target
            if (newRadius !== null) {
                if (this.screenSpacePanning) // position the orbit target in front of the new camera position
                this.target.set(0, 0, -1).transformDirection(this.object.matrix).multiplyScalar(newRadius).add(this.object.position);
                else {
                    // get the ray and translation plane to compute target
                    $443c013b983d0324$var$_ray.origin.copy(this.object.position);
                    $443c013b983d0324$var$_ray.direction.set(0, 0, -1).transformDirection(this.object.matrix);
                    // if the camera is 20 degrees above the horizon then don't adjust the focus target to avoid
                    // extremely large values
                    if (Math.abs(this.object.up.dot($443c013b983d0324$var$_ray.direction)) < $443c013b983d0324$var$_TILT_LIMIT) this.object.lookAt(this.target);
                    else {
                        $443c013b983d0324$var$_plane.setFromNormalAndCoplanarPoint(this.object.up, this.target);
                        $443c013b983d0324$var$_ray.intersectPlane($443c013b983d0324$var$_plane, this.target);
                    }
                }
            }
        } else if (this.object.isOrthographicCamera) {
            const prevZoom = this.object.zoom;
            this.object.zoom = Math.max(this.minZoom, Math.min(this.maxZoom, this.object.zoom / this._scale));
            if (prevZoom !== this.object.zoom) {
                this.object.updateProjectionMatrix();
                zoomChanged = true;
            }
        }
        this._scale = 1;
        this._performCursorZoom = false;
        // update condition is:
        // min(camera displacement, camera rotation in radians)^2 > EPS
        // using small-angle approximation cos(x/2) = 1 - x^2 / 8
        if (zoomChanged || this._lastPosition.distanceToSquared(this.object.position) > $443c013b983d0324$var$_EPS || 8 * (1 - this._lastQuaternion.dot(this.object.quaternion)) > $443c013b983d0324$var$_EPS || this._lastTargetPosition.distanceToSquared(this.target) > $443c013b983d0324$var$_EPS) {
            this.dispatchEvent($443c013b983d0324$var$_changeEvent);
            this._lastPosition.copy(this.object.position);
            this._lastQuaternion.copy(this.object.quaternion);
            this._lastTargetPosition.copy(this.target);
            return true;
        }
        return false;
    }
    _getAutoRotationAngle(deltaTime) {
        if (deltaTime !== null) return $443c013b983d0324$var$_twoPI / 60 * this.autoRotateSpeed * deltaTime;
        else return $443c013b983d0324$var$_twoPI / 60 / 60 * this.autoRotateSpeed;
    }
    _getZoomScale(delta) {
        const normalizedDelta = Math.abs(delta * 0.01);
        return Math.pow(0.95, this.zoomSpeed * normalizedDelta);
    }
    _rotateLeft(angle) {
        this._sphericalDelta.theta -= angle;
    }
    _rotateUp(angle) {
        this._sphericalDelta.phi -= angle;
    }
    _panLeft(distance, objectMatrix) {
        $443c013b983d0324$var$_v.setFromMatrixColumn(objectMatrix, 0); // get X column of objectMatrix
        $443c013b983d0324$var$_v.multiplyScalar(-distance);
        this._panOffset.add($443c013b983d0324$var$_v);
    }
    _panUp(distance, objectMatrix) {
        if (this.screenSpacePanning === true) $443c013b983d0324$var$_v.setFromMatrixColumn(objectMatrix, 1);
        else {
            $443c013b983d0324$var$_v.setFromMatrixColumn(objectMatrix, 0);
            $443c013b983d0324$var$_v.crossVectors(this.object.up, $443c013b983d0324$var$_v);
        }
        $443c013b983d0324$var$_v.multiplyScalar(distance);
        this._panOffset.add($443c013b983d0324$var$_v);
    }
    // deltaX and deltaY are in pixels; right and down are positive
    _pan(deltaX, deltaY) {
        const element = this.domElement;
        if (this.object.isPerspectiveCamera) {
            // perspective
            const position = this.object.position;
            $443c013b983d0324$var$_v.copy(position).sub(this.target);
            let targetDistance = $443c013b983d0324$var$_v.length();
            // half of the fov is center to top of screen
            targetDistance *= Math.tan(this.object.fov / 2 * Math.PI / 180.0);
            // we use only clientHeight here so aspect ratio does not distort speed
            this._panLeft(2 * deltaX * targetDistance / element.clientHeight, this.object.matrix);
            this._panUp(2 * deltaY * targetDistance / element.clientHeight, this.object.matrix);
        } else if (this.object.isOrthographicCamera) {
            // orthographic
            this._panLeft(deltaX * (this.object.right - this.object.left) / this.object.zoom / element.clientWidth, this.object.matrix);
            this._panUp(deltaY * (this.object.top - this.object.bottom) / this.object.zoom / element.clientHeight, this.object.matrix);
        } else {
            // camera neither orthographic nor perspective
            console.warn('WARNING: OrbitControls.js encountered an unknown camera type - pan disabled.');
            this.enablePan = false;
        }
    }
    _dollyOut(dollyScale) {
        if (this.object.isPerspectiveCamera || this.object.isOrthographicCamera) this._scale /= dollyScale;
        else {
            console.warn('WARNING: OrbitControls.js encountered an unknown camera type - dolly/zoom disabled.');
            this.enableZoom = false;
        }
    }
    _dollyIn(dollyScale) {
        if (this.object.isPerspectiveCamera || this.object.isOrthographicCamera) this._scale *= dollyScale;
        else {
            console.warn('WARNING: OrbitControls.js encountered an unknown camera type - dolly/zoom disabled.');
            this.enableZoom = false;
        }
    }
    _updateZoomParameters(x, y) {
        if (!this.zoomToCursor) return;
        this._performCursorZoom = true;
        const rect = this.domElement.getBoundingClientRect();
        const dx = x - rect.left;
        const dy = y - rect.top;
        const w = rect.width;
        const h = rect.height;
        this._mouse.x = dx / w * 2 - 1;
        this._mouse.y = -(dy / h) * 2 + 1;
        this._dollyDirection.set(this._mouse.x, this._mouse.y, 1).unproject(this.object).sub(this.object.position).normalize();
    }
    _clampDistance(dist) {
        return Math.max(this.minDistance, Math.min(this.maxDistance, dist));
    }
    //
    // event callbacks - update the object state
    //
    _handleMouseDownRotate(event) {
        this._rotateStart.set(event.clientX, event.clientY);
    }
    _handleMouseDownDolly(event) {
        this._updateZoomParameters(event.clientX, event.clientX);
        this._dollyStart.set(event.clientX, event.clientY);
    }
    _handleMouseDownPan(event) {
        this._panStart.set(event.clientX, event.clientY);
    }
    _handleMouseMoveRotate(event) {
        this._rotateEnd.set(event.clientX, event.clientY);
        this._rotateDelta.subVectors(this._rotateEnd, this._rotateStart).multiplyScalar(this.rotateSpeed);
        const element = this.domElement;
        this._rotateLeft($443c013b983d0324$var$_twoPI * this._rotateDelta.x / element.clientHeight); // yes, height
        this._rotateUp($443c013b983d0324$var$_twoPI * this._rotateDelta.y / element.clientHeight);
        this._rotateStart.copy(this._rotateEnd);
        this.update();
    }
    _handleMouseMoveDolly(event) {
        this._dollyEnd.set(event.clientX, event.clientY);
        this._dollyDelta.subVectors(this._dollyEnd, this._dollyStart);
        if (this._dollyDelta.y > 0) this._dollyOut(this._getZoomScale(this._dollyDelta.y));
        else if (this._dollyDelta.y < 0) this._dollyIn(this._getZoomScale(this._dollyDelta.y));
        this._dollyStart.copy(this._dollyEnd);
        this.update();
    }
    _handleMouseMovePan(event) {
        this._panEnd.set(event.clientX, event.clientY);
        this._panDelta.subVectors(this._panEnd, this._panStart).multiplyScalar(this.panSpeed);
        this._pan(this._panDelta.x, this._panDelta.y);
        this._panStart.copy(this._panEnd);
        this.update();
    }
    _handleMouseWheel(event) {
        this._updateZoomParameters(event.clientX, event.clientY);
        if (event.deltaY < 0) this._dollyIn(this._getZoomScale(event.deltaY));
        else if (event.deltaY > 0) this._dollyOut(this._getZoomScale(event.deltaY));
        this.update();
    }
    _handleKeyDown(event) {
        let needsUpdate = false;
        switch(event.code){
            case this.keys.UP:
                if (event.ctrlKey || event.metaKey || event.shiftKey) this._rotateUp($443c013b983d0324$var$_twoPI * this.rotateSpeed / this.domElement.clientHeight);
                else this._pan(0, this.keyPanSpeed);
                needsUpdate = true;
                break;
            case this.keys.BOTTOM:
                if (event.ctrlKey || event.metaKey || event.shiftKey) this._rotateUp(-$443c013b983d0324$var$_twoPI * this.rotateSpeed / this.domElement.clientHeight);
                else this._pan(0, -this.keyPanSpeed);
                needsUpdate = true;
                break;
            case this.keys.LEFT:
                if (event.ctrlKey || event.metaKey || event.shiftKey) this._rotateLeft($443c013b983d0324$var$_twoPI * this.rotateSpeed / this.domElement.clientHeight);
                else this._pan(this.keyPanSpeed, 0);
                needsUpdate = true;
                break;
            case this.keys.RIGHT:
                if (event.ctrlKey || event.metaKey || event.shiftKey) this._rotateLeft(-$443c013b983d0324$var$_twoPI * this.rotateSpeed / this.domElement.clientHeight);
                else this._pan(-this.keyPanSpeed, 0);
                needsUpdate = true;
                break;
        }
        if (needsUpdate) {
            // prevent the browser from scrolling on cursor keys
            event.preventDefault();
            this.update();
        }
    }
    _handleTouchStartRotate(event) {
        if (this._pointers.length === 1) this._rotateStart.set(event.pageX, event.pageY);
        else {
            const position = this._getSecondPointerPosition(event);
            const x = 0.5 * (event.pageX + position.x);
            const y = 0.5 * (event.pageY + position.y);
            this._rotateStart.set(x, y);
        }
    }
    _handleTouchStartPan(event) {
        if (this._pointers.length === 1) this._panStart.set(event.pageX, event.pageY);
        else {
            const position = this._getSecondPointerPosition(event);
            const x = 0.5 * (event.pageX + position.x);
            const y = 0.5 * (event.pageY + position.y);
            this._panStart.set(x, y);
        }
    }
    _handleTouchStartDolly(event) {
        const position = this._getSecondPointerPosition(event);
        const dx = event.pageX - position.x;
        const dy = event.pageY - position.y;
        const distance = Math.sqrt(dx * dx + dy * dy);
        this._dollyStart.set(0, distance);
    }
    _handleTouchStartDollyPan(event) {
        if (this.enableZoom) this._handleTouchStartDolly(event);
        if (this.enablePan) this._handleTouchStartPan(event);
    }
    _handleTouchStartDollyRotate(event) {
        if (this.enableZoom) this._handleTouchStartDolly(event);
        if (this.enableRotate) this._handleTouchStartRotate(event);
    }
    _handleTouchMoveRotate(event) {
        if (this._pointers.length == 1) this._rotateEnd.set(event.pageX, event.pageY);
        else {
            const position = this._getSecondPointerPosition(event);
            const x = 0.5 * (event.pageX + position.x);
            const y = 0.5 * (event.pageY + position.y);
            this._rotateEnd.set(x, y);
        }
        this._rotateDelta.subVectors(this._rotateEnd, this._rotateStart).multiplyScalar(this.rotateSpeed);
        const element = this.domElement;
        this._rotateLeft($443c013b983d0324$var$_twoPI * this._rotateDelta.x / element.clientHeight); // yes, height
        this._rotateUp($443c013b983d0324$var$_twoPI * this._rotateDelta.y / element.clientHeight);
        this._rotateStart.copy(this._rotateEnd);
    }
    _handleTouchMovePan(event) {
        if (this._pointers.length === 1) this._panEnd.set(event.pageX, event.pageY);
        else {
            const position = this._getSecondPointerPosition(event);
            const x = 0.5 * (event.pageX + position.x);
            const y = 0.5 * (event.pageY + position.y);
            this._panEnd.set(x, y);
        }
        this._panDelta.subVectors(this._panEnd, this._panStart).multiplyScalar(this.panSpeed);
        this._pan(this._panDelta.x, this._panDelta.y);
        this._panStart.copy(this._panEnd);
    }
    _handleTouchMoveDolly(event) {
        const position = this._getSecondPointerPosition(event);
        const dx = event.pageX - position.x;
        const dy = event.pageY - position.y;
        const distance = Math.sqrt(dx * dx + dy * dy);
        this._dollyEnd.set(0, distance);
        this._dollyDelta.set(0, Math.pow(this._dollyEnd.y / this._dollyStart.y, this.zoomSpeed));
        this._dollyOut(this._dollyDelta.y);
        this._dollyStart.copy(this._dollyEnd);
        const centerX = (event.pageX + position.x) * 0.5;
        const centerY = (event.pageY + position.y) * 0.5;
        this._updateZoomParameters(centerX, centerY);
    }
    _handleTouchMoveDollyPan(event) {
        if (this.enableZoom) this._handleTouchMoveDolly(event);
        if (this.enablePan) this._handleTouchMovePan(event);
    }
    _handleTouchMoveDollyRotate(event) {
        if (this.enableZoom) this._handleTouchMoveDolly(event);
        if (this.enableRotate) this._handleTouchMoveRotate(event);
    }
    // pointers
    _addPointer(event) {
        this._pointers.push(event.pointerId);
    }
    _removePointer(event) {
        delete this._pointerPositions[event.pointerId];
        for(let i = 0; i < this._pointers.length; i++)if (this._pointers[i] == event.pointerId) {
            this._pointers.splice(i, 1);
            return;
        }
    }
    _isTrackingPointer(event) {
        for(let i = 0; i < this._pointers.length; i++){
            if (this._pointers[i] == event.pointerId) return true;
        }
        return false;
    }
    _trackPointer(event) {
        let position = this._pointerPositions[event.pointerId];
        if (position === undefined) {
            position = new (0, $d5b33d7c30034067$export$c977b3e384af9ae1)();
            this._pointerPositions[event.pointerId] = position;
        }
        position.set(event.pageX, event.pageY);
    }
    _getSecondPointerPosition(event) {
        const pointerId = event.pointerId === this._pointers[0] ? this._pointers[1] : this._pointers[0];
        return this._pointerPositions[pointerId];
    }
    //
    _customWheelEvent(event) {
        const mode = event.deltaMode;
        // minimal wheel event altered to meet delta-zoom demand
        const newEvent = {
            clientX: event.clientX,
            clientY: event.clientY,
            deltaY: event.deltaY
        };
        switch(mode){
            case 1:
                newEvent.deltaY *= 16;
                break;
            case 2:
                newEvent.deltaY *= 100;
                break;
        }
        // detect if event was triggered by pinching
        if (event.ctrlKey && !this._controlActive) newEvent.deltaY *= 10;
        return newEvent;
    }
}
function $443c013b983d0324$var$onPointerDown(event) {
    if (this.enabled === false) return;
    if (this._pointers.length === 0) {
        this.domElement.setPointerCapture(event.pointerId);
        this.domElement.addEventListener('pointermove', this._onPointerMove);
        this.domElement.addEventListener('pointerup', this._onPointerUp);
    }
    //
    if (this._isTrackingPointer(event)) return;
    //
    this._addPointer(event);
    if (event.pointerType === 'touch') this._onTouchStart(event);
    else this._onMouseDown(event);
}
function $443c013b983d0324$var$onPointerMove(event) {
    if (this.enabled === false) return;
    if (event.pointerType === 'touch') this._onTouchMove(event);
    else this._onMouseMove(event);
}
function $443c013b983d0324$var$onPointerUp(event) {
    this._removePointer(event);
    switch(this._pointers.length){
        case 0:
            this.domElement.releasePointerCapture(event.pointerId);
            this.domElement.removeEventListener('pointermove', this._onPointerMove);
            this.domElement.removeEventListener('pointerup', this._onPointerUp);
            this.dispatchEvent($443c013b983d0324$var$_endEvent);
            this.state = $443c013b983d0324$var$_STATE.NONE;
            break;
        case 1:
            const pointerId = this._pointers[0];
            const position = this._pointerPositions[pointerId];
            // minimal placeholder event - allows state correction on pointer-up
            this._onTouchStart({
                pointerId: pointerId,
                pageX: position.x,
                pageY: position.y
            });
            break;
    }
}
function $443c013b983d0324$var$onMouseDown(event) {
    let mouseAction;
    switch(event.button){
        case 0:
            mouseAction = this.mouseButtons.LEFT;
            break;
        case 1:
            mouseAction = this.mouseButtons.MIDDLE;
            break;
        case 2:
            mouseAction = this.mouseButtons.RIGHT;
            break;
        default:
            mouseAction = -1;
    }
    switch(mouseAction){
        case (0, $d5b33d7c30034067$export$7177b3e430c2d7ca).DOLLY:
            if (this.enableZoom === false) return;
            this._handleMouseDownDolly(event);
            this.state = $443c013b983d0324$var$_STATE.DOLLY;
            break;
        case (0, $d5b33d7c30034067$export$7177b3e430c2d7ca).ROTATE:
            if (event.ctrlKey || event.metaKey || event.shiftKey) {
                if (this.enablePan === false) return;
                this._handleMouseDownPan(event);
                this.state = $443c013b983d0324$var$_STATE.PAN;
            } else {
                if (this.enableRotate === false) return;
                this._handleMouseDownRotate(event);
                this.state = $443c013b983d0324$var$_STATE.ROTATE;
            }
            break;
        case (0, $d5b33d7c30034067$export$7177b3e430c2d7ca).PAN:
            if (event.ctrlKey || event.metaKey || event.shiftKey) {
                if (this.enableRotate === false) return;
                this._handleMouseDownRotate(event);
                this.state = $443c013b983d0324$var$_STATE.ROTATE;
            } else {
                if (this.enablePan === false) return;
                this._handleMouseDownPan(event);
                this.state = $443c013b983d0324$var$_STATE.PAN;
            }
            break;
        default:
            this.state = $443c013b983d0324$var$_STATE.NONE;
    }
    if (this.state !== $443c013b983d0324$var$_STATE.NONE) this.dispatchEvent($443c013b983d0324$var$_startEvent);
}
function $443c013b983d0324$var$onMouseMove(event) {
    switch(this.state){
        case $443c013b983d0324$var$_STATE.ROTATE:
            if (this.enableRotate === false) return;
            this._handleMouseMoveRotate(event);
            break;
        case $443c013b983d0324$var$_STATE.DOLLY:
            if (this.enableZoom === false) return;
            this._handleMouseMoveDolly(event);
            break;
        case $443c013b983d0324$var$_STATE.PAN:
            if (this.enablePan === false) return;
            this._handleMouseMovePan(event);
            break;
    }
}
function $443c013b983d0324$var$onMouseWheel(event) {
    if (this.enabled === false || this.enableZoom === false || this.state !== $443c013b983d0324$var$_STATE.NONE) return;
    event.preventDefault();
    this.dispatchEvent($443c013b983d0324$var$_startEvent);
    this._handleMouseWheel(this._customWheelEvent(event));
    this.dispatchEvent($443c013b983d0324$var$_endEvent);
}
function $443c013b983d0324$var$onKeyDown(event) {
    if (this.enabled === false || this.enablePan === false) return;
    this._handleKeyDown(event);
}
function $443c013b983d0324$var$onTouchStart(event) {
    this._trackPointer(event);
    switch(this._pointers.length){
        case 1:
            switch(this.touches.ONE){
                case (0, $d5b33d7c30034067$export$d46bd3ead7cc759b).ROTATE:
                    if (this.enableRotate === false) return;
                    this._handleTouchStartRotate(event);
                    this.state = $443c013b983d0324$var$_STATE.TOUCH_ROTATE;
                    break;
                case (0, $d5b33d7c30034067$export$d46bd3ead7cc759b).PAN:
                    if (this.enablePan === false) return;
                    this._handleTouchStartPan(event);
                    this.state = $443c013b983d0324$var$_STATE.TOUCH_PAN;
                    break;
                default:
                    this.state = $443c013b983d0324$var$_STATE.NONE;
            }
            break;
        case 2:
            switch(this.touches.TWO){
                case (0, $d5b33d7c30034067$export$d46bd3ead7cc759b).DOLLY_PAN:
                    if (this.enableZoom === false && this.enablePan === false) return;
                    this._handleTouchStartDollyPan(event);
                    this.state = $443c013b983d0324$var$_STATE.TOUCH_DOLLY_PAN;
                    break;
                case (0, $d5b33d7c30034067$export$d46bd3ead7cc759b).DOLLY_ROTATE:
                    if (this.enableZoom === false && this.enableRotate === false) return;
                    this._handleTouchStartDollyRotate(event);
                    this.state = $443c013b983d0324$var$_STATE.TOUCH_DOLLY_ROTATE;
                    break;
                default:
                    this.state = $443c013b983d0324$var$_STATE.NONE;
            }
            break;
        default:
            this.state = $443c013b983d0324$var$_STATE.NONE;
    }
    if (this.state !== $443c013b983d0324$var$_STATE.NONE) this.dispatchEvent($443c013b983d0324$var$_startEvent);
}
function $443c013b983d0324$var$onTouchMove(event) {
    this._trackPointer(event);
    switch(this.state){
        case $443c013b983d0324$var$_STATE.TOUCH_ROTATE:
            if (this.enableRotate === false) return;
            this._handleTouchMoveRotate(event);
            this.update();
            break;
        case $443c013b983d0324$var$_STATE.TOUCH_PAN:
            if (this.enablePan === false) return;
            this._handleTouchMovePan(event);
            this.update();
            break;
        case $443c013b983d0324$var$_STATE.TOUCH_DOLLY_PAN:
            if (this.enableZoom === false && this.enablePan === false) return;
            this._handleTouchMoveDollyPan(event);
            this.update();
            break;
        case $443c013b983d0324$var$_STATE.TOUCH_DOLLY_ROTATE:
            if (this.enableZoom === false && this.enableRotate === false) return;
            this._handleTouchMoveDollyRotate(event);
            this.update();
            break;
        default:
            this.state = $443c013b983d0324$var$_STATE.NONE;
    }
}
function $443c013b983d0324$var$onContextMenu(event) {
    if (this.enabled === false) return;
    event.preventDefault();
}
function $443c013b983d0324$var$interceptControlDown(event) {
    if (event.key === 'Control') {
        this._controlActive = true;
        const document = this.domElement.getRootNode(); // offscreen canvas compatibility
        document.addEventListener('keyup', this._interceptControlUp, {
            passive: true,
            capture: true
        });
    }
}
function $443c013b983d0324$var$interceptControlUp(event) {
    if (event.key === 'Control') {
        this._controlActive = false;
        const document = this.domElement.getRootNode(); // offscreen canvas compatibility
        document.removeEventListener('keyup', this._interceptControlUp, {
            passive: true,
            capture: true
        });
    }
}



const $37d4d287f7c195e5$var$_changeEvent = {
    type: 'change'
};
const $37d4d287f7c195e5$var$_EPS = 0.000001;
const $37d4d287f7c195e5$var$_tmpQuaternion = new (0, $d5b33d7c30034067$export$23d6a54f0bbc85a3)();
class $37d4d287f7c195e5$export$4cec72bd81e75195 extends (0, $d5b33d7c30034067$export$c7c44baae9d9f25f) {
    constructor(object, domElement = null){
        super(object, domElement);
        this.movementSpeed = 1.0;
        this.rollSpeed = 0.005;
        this.dragToLook = false;
        this.autoForward = false;
        // internals
        this._moveState = {
            up: 0,
            down: 0,
            left: 0,
            right: 0,
            forward: 0,
            back: 0,
            pitchUp: 0,
            pitchDown: 0,
            yawLeft: 0,
            yawRight: 0,
            rollLeft: 0,
            rollRight: 0
        };
        this._moveVector = new (0, $d5b33d7c30034067$export$64b5c384219d3699)(0, 0, 0);
        this._rotationVector = new (0, $d5b33d7c30034067$export$64b5c384219d3699)(0, 0, 0);
        this._lastQuaternion = new (0, $d5b33d7c30034067$export$23d6a54f0bbc85a3)();
        this._lastPosition = new (0, $d5b33d7c30034067$export$64b5c384219d3699)();
        this._status = 0;
        // event listeners
        this._onKeyDown = $37d4d287f7c195e5$var$onKeyDown.bind(this);
        this._onKeyUp = $37d4d287f7c195e5$var$onKeyUp.bind(this);
        this._onPointerMove = $37d4d287f7c195e5$var$onPointerMove.bind(this);
        this._onPointerDown = $37d4d287f7c195e5$var$onPointerDown.bind(this);
        this._onPointerUp = $37d4d287f7c195e5$var$onPointerUp.bind(this);
        this._onPointerCancel = $37d4d287f7c195e5$var$onPointerCancel.bind(this);
        this._onContextMenu = $37d4d287f7c195e5$var$onContextMenu.bind(this);
        //
        if (domElement !== null) this.connect();
    }
    connect() {
        window.addEventListener('keydown', this._onKeyDown);
        window.addEventListener('keyup', this._onKeyUp);
        this.domElement.addEventListener('pointermove', this._onPointerMove);
        this.domElement.addEventListener('pointerdown', this._onPointerDown);
        this.domElement.addEventListener('pointerup', this._onPointerUp);
        this.domElement.addEventListener('pointercancel', this._onPointerCancel);
        this.domElement.addEventListener('contextmenu', this._onContextMenu);
    }
    disconnect() {
        window.removeEventListener('keydown', this._onKeyDown);
        window.removeEventListener('keyup', this._onKeyUp);
        this.domElement.removeEventListener('pointermove', this._onPointerMove);
        this.domElement.removeEventListener('pointerdown', this._onPointerDown);
        this.domElement.removeEventListener('pointerup', this._onPointerUp);
        this.domElement.removeEventListener('pointercancel', this._onPointerCancel);
        this.domElement.removeEventListener('contextmenu', this._onContextMenu);
    }
    dispose() {
        this.disconnect();
    }
    update(delta) {
        if (this.enabled === false) return;
        const object = this.object;
        const moveMult = delta * this.movementSpeed;
        const rotMult = delta * this.rollSpeed;
        object.translateX(this._moveVector.x * moveMult);
        object.translateY(this._moveVector.y * moveMult);
        object.translateZ(this._moveVector.z * moveMult);
        $37d4d287f7c195e5$var$_tmpQuaternion.set(this._rotationVector.x * rotMult, this._rotationVector.y * rotMult, this._rotationVector.z * rotMult, 1).normalize();
        object.quaternion.multiply($37d4d287f7c195e5$var$_tmpQuaternion);
        if (this._lastPosition.distanceToSquared(object.position) > $37d4d287f7c195e5$var$_EPS || 8 * (1 - this._lastQuaternion.dot(object.quaternion)) > $37d4d287f7c195e5$var$_EPS) {
            this.dispatchEvent($37d4d287f7c195e5$var$_changeEvent);
            this._lastQuaternion.copy(object.quaternion);
            this._lastPosition.copy(object.position);
        }
    }
    // private
    _updateMovementVector() {
        const forward = this._moveState.forward || this.autoForward && !this._moveState.back ? 1 : 0;
        this._moveVector.x = -this._moveState.left + this._moveState.right;
        this._moveVector.y = -this._moveState.down + this._moveState.up;
        this._moveVector.z = -forward + this._moveState.back;
    //console.log( 'move:', [ this._moveVector.x, this._moveVector.y, this._moveVector.z ] );
    }
    _updateRotationVector() {
        this._rotationVector.x = -this._moveState.pitchDown + this._moveState.pitchUp;
        this._rotationVector.y = -this._moveState.yawRight + this._moveState.yawLeft;
        this._rotationVector.z = -this._moveState.rollRight + this._moveState.rollLeft;
    //console.log( 'rotate:', [ this._rotationVector.x, this._rotationVector.y, this._rotationVector.z ] );
    }
    _getContainerDimensions() {
        if (this.domElement != document) return {
            size: [
                this.domElement.offsetWidth,
                this.domElement.offsetHeight
            ],
            offset: [
                this.domElement.offsetLeft,
                this.domElement.offsetTop
            ]
        };
        else return {
            size: [
                window.innerWidth,
                window.innerHeight
            ],
            offset: [
                0,
                0
            ]
        };
    }
}
function $37d4d287f7c195e5$var$onKeyDown(event) {
    if (event.altKey || this.enabled === false) return;
    switch(event.code){
        case 'ShiftLeft':
        case 'ShiftRight':
            this.movementSpeedMultiplier = .1;
            break;
        case 'KeyW':
            this._moveState.forward = 1;
            break;
        case 'KeyS':
            this._moveState.back = 1;
            break;
        case 'KeyA':
            this._moveState.left = 1;
            break;
        case 'KeyD':
            this._moveState.right = 1;
            break;
        case 'KeyR':
            this._moveState.up = 1;
            break;
        case 'KeyF':
            this._moveState.down = 1;
            break;
        case 'ArrowUp':
            this._moveState.pitchUp = 1;
            break;
        case 'ArrowDown':
            this._moveState.pitchDown = 1;
            break;
        case 'ArrowLeft':
            this._moveState.yawLeft = 1;
            break;
        case 'ArrowRight':
            this._moveState.yawRight = 1;
            break;
        case 'KeyQ':
            this._moveState.rollLeft = 1;
            break;
        case 'KeyE':
            this._moveState.rollRight = 1;
            break;
    }
    this._updateMovementVector();
    this._updateRotationVector();
}
function $37d4d287f7c195e5$var$onKeyUp(event) {
    if (this.enabled === false) return;
    switch(event.code){
        case 'ShiftLeft':
        case 'ShiftRight':
            this.movementSpeedMultiplier = 1;
            break;
        case 'KeyW':
            this._moveState.forward = 0;
            break;
        case 'KeyS':
            this._moveState.back = 0;
            break;
        case 'KeyA':
            this._moveState.left = 0;
            break;
        case 'KeyD':
            this._moveState.right = 0;
            break;
        case 'KeyR':
            this._moveState.up = 0;
            break;
        case 'KeyF':
            this._moveState.down = 0;
            break;
        case 'ArrowUp':
            this._moveState.pitchUp = 0;
            break;
        case 'ArrowDown':
            this._moveState.pitchDown = 0;
            break;
        case 'ArrowLeft':
            this._moveState.yawLeft = 0;
            break;
        case 'ArrowRight':
            this._moveState.yawRight = 0;
            break;
        case 'KeyQ':
            this._moveState.rollLeft = 0;
            break;
        case 'KeyE':
            this._moveState.rollRight = 0;
            break;
    }
    this._updateMovementVector();
    this._updateRotationVector();
}
function $37d4d287f7c195e5$var$onPointerDown(event) {
    if (this.enabled === false) return;
    if (this.dragToLook) this._status++;
    else {
        switch(event.button){
            case 0:
                this._moveState.forward = 1;
                break;
            case 2:
                this._moveState.back = 1;
                break;
        }
        this._updateMovementVector();
    }
}
function $37d4d287f7c195e5$var$onPointerMove(event) {
    if (this.enabled === false) return;
    if (!this.dragToLook || this._status > 0) {
        const container = this._getContainerDimensions();
        const halfWidth = container.size[0] / 2;
        const halfHeight = container.size[1] / 2;
        this._moveState.yawLeft = -(event.pageX - container.offset[0] - halfWidth) / halfWidth;
        this._moveState.pitchDown = (event.pageY - container.offset[1] - halfHeight) / halfHeight;
        this._updateRotationVector();
    }
}
function $37d4d287f7c195e5$var$onPointerUp(event) {
    if (this.enabled === false) return;
    if (this.dragToLook) {
        this._status--;
        this._moveState.yawLeft = this._moveState.pitchDown = 0;
    } else {
        switch(event.button){
            case 0:
                this._moveState.forward = 0;
                break;
            case 2:
                this._moveState.back = 0;
                break;
        }
        this._updateMovementVector();
    }
    this._updateRotationVector();
}
function $37d4d287f7c195e5$var$onPointerCancel() {
    if (this.enabled === false) return;
    if (this.dragToLook) {
        this._status = 0;
        this._moveState.yawLeft = this._moveState.pitchDown = 0;
    } else {
        this._moveState.forward = 0;
        this._moveState.back = 0;
        this._updateMovementVector();
    }
    this._updateRotationVector();
}
function $37d4d287f7c195e5$var$onContextMenu(event) {
    if (this.enabled === false) return;
    event.preventDefault();
}



/**
 * Full-screen textured quad shader
 */ const $2f93ac2d46312da9$export$57f84a24a9a6130d = {
    name: 'CopyShader',
    uniforms: {
        'tDiffuse': {
            value: null
        },
        'opacity': {
            value: 1.0
        }
    },
    vertexShader: /* glsl */ `

		varying vec2 vUv;

		void main() {

			vUv = uv;
			gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );

		}`,
    fragmentShader: /* glsl */ `

		uniform float opacity;

		uniform sampler2D tDiffuse;

		varying vec2 vUv;

		void main() {

			vec4 texel = texture2D( tDiffuse, vUv );
			gl_FragColor = opacity * texel;


		}`
};




class $0a1d3a5a6a49de03$export$802bc10488da99c7 {
    constructor(){
        this.isPass = true;
        // if set to true, the pass is processed by the composer
        this.enabled = true;
        // if set to true, the pass indicates to swap read and write buffer after rendering
        this.needsSwap = true;
        // if set to true, the pass clears its buffer before rendering
        this.clear = false;
        // if set to true, the result of the pass is rendered to screen. This is set automatically by EffectComposer.
        this.renderToScreen = false;
    }
    setSize() {}
    render() {
        console.error('THREE.Pass: .render() must be implemented in derived pass.');
    }
    dispose() {}
}
// Helper for passes that need to fill the viewport with a single quad.
const $0a1d3a5a6a49de03$var$_camera = new (0, $d5b33d7c30034067$export$9ebf355ee4ed261b)(-1, 1, 1, -1, 0, 1);
// https://github.com/mrdoob/three.js/pull/21358
class $0a1d3a5a6a49de03$var$FullscreenTriangleGeometry extends (0, $d5b33d7c30034067$export$b7be63a67df8959) {
    constructor(){
        super();
        this.setAttribute('position', new (0, $d5b33d7c30034067$export$cbe7a62641830ebd)([
            -1,
            3,
            0,
            -1,
            -1,
            0,
            3,
            -1,
            0
        ], 3));
        this.setAttribute('uv', new (0, $d5b33d7c30034067$export$cbe7a62641830ebd)([
            0,
            2,
            0,
            0,
            2,
            0
        ], 2));
    }
}
const $0a1d3a5a6a49de03$var$_geometry = new $0a1d3a5a6a49de03$var$FullscreenTriangleGeometry();
class $0a1d3a5a6a49de03$export$3983474c8e6e978b {
    constructor(material){
        this._mesh = new (0, $d5b33d7c30034067$export$e176487c05830cc5)($0a1d3a5a6a49de03$var$_geometry, material);
    }
    dispose() {
        this._mesh.geometry.dispose();
    }
    render(renderer) {
        renderer.render(this._mesh, $0a1d3a5a6a49de03$var$_camera);
    }
    get material() {
        return this._mesh.material;
    }
    set material(value) {
        this._mesh.material = value;
    }
}


class $6ac47a3de6300e1f$export$c55093fd4f9e42f0 extends (0, $0a1d3a5a6a49de03$export$802bc10488da99c7) {
    constructor(shader, textureID){
        super();
        this.textureID = textureID !== undefined ? textureID : 'tDiffuse';
        if (shader instanceof (0, $d5b33d7c30034067$export$83c7d75d550a8b0d)) {
            this.uniforms = shader.uniforms;
            this.material = shader;
        } else if (shader) {
            this.uniforms = (0, $d5b33d7c30034067$export$d8ecdf8615bfea69).clone(shader.uniforms);
            this.material = new (0, $d5b33d7c30034067$export$83c7d75d550a8b0d)({
                name: shader.name !== undefined ? shader.name : 'unspecified',
                defines: Object.assign({}, shader.defines),
                uniforms: this.uniforms,
                vertexShader: shader.vertexShader,
                fragmentShader: shader.fragmentShader
            });
        }
        this.fsQuad = new (0, $0a1d3a5a6a49de03$export$3983474c8e6e978b)(this.material);
    }
    render(renderer, writeBuffer, readBuffer /*, deltaTime, maskActive */ ) {
        if (this.uniforms[this.textureID]) this.uniforms[this.textureID].value = readBuffer.texture;
        this.fsQuad.material = this.material;
        if (this.renderToScreen) {
            renderer.setRenderTarget(null);
            this.fsQuad.render(renderer);
        } else {
            renderer.setRenderTarget(writeBuffer);
            // TODO: Avoid using autoClear properties, see https://github.com/mrdoob/three.js/pull/15571#issuecomment-465669600
            if (this.clear) renderer.clear(renderer.autoClearColor, renderer.autoClearDepth, renderer.autoClearStencil);
            this.fsQuad.render(renderer);
        }
    }
    dispose() {
        this.material.dispose();
        this.fsQuad.dispose();
    }
}



class $0f4907a355572481$export$bb424a4005d6dde0 extends (0, $0a1d3a5a6a49de03$export$802bc10488da99c7) {
    constructor(scene, camera){
        super();
        this.scene = scene;
        this.camera = camera;
        this.clear = true;
        this.needsSwap = false;
        this.inverse = false;
    }
    render(renderer, writeBuffer, readBuffer /*, deltaTime, maskActive */ ) {
        const context = renderer.getContext();
        const state = renderer.state;
        // don't update color or depth
        state.buffers.color.setMask(false);
        state.buffers.depth.setMask(false);
        // lock buffers
        state.buffers.color.setLocked(true);
        state.buffers.depth.setLocked(true);
        // set up stencil
        let writeValue, clearValue;
        if (this.inverse) {
            writeValue = 0;
            clearValue = 1;
        } else {
            writeValue = 1;
            clearValue = 0;
        }
        state.buffers.stencil.setTest(true);
        state.buffers.stencil.setOp(context.REPLACE, context.REPLACE, context.REPLACE);
        state.buffers.stencil.setFunc(context.ALWAYS, writeValue, 0xffffffff);
        state.buffers.stencil.setClear(clearValue);
        state.buffers.stencil.setLocked(true);
        // draw into the stencil buffer
        renderer.setRenderTarget(readBuffer);
        if (this.clear) renderer.clear();
        renderer.render(this.scene, this.camera);
        renderer.setRenderTarget(writeBuffer);
        if (this.clear) renderer.clear();
        renderer.render(this.scene, this.camera);
        // unlock color and depth buffer and make them writable for subsequent rendering/clearing
        state.buffers.color.setLocked(false);
        state.buffers.depth.setLocked(false);
        state.buffers.color.setMask(true);
        state.buffers.depth.setMask(true);
        // only render where stencil is set to 1
        state.buffers.stencil.setLocked(false);
        state.buffers.stencil.setFunc(context.EQUAL, 1, 0xffffffff); // draw if == 1
        state.buffers.stencil.setOp(context.KEEP, context.KEEP, context.KEEP);
        state.buffers.stencil.setLocked(true);
    }
}
class $0f4907a355572481$export$8d8650aed29c6251 extends (0, $0a1d3a5a6a49de03$export$802bc10488da99c7) {
    constructor(){
        super();
        this.needsSwap = false;
    }
    render(renderer /*, writeBuffer, readBuffer, deltaTime, maskActive */ ) {
        renderer.state.buffers.stencil.setLocked(false);
        renderer.state.buffers.stencil.setTest(false);
    }
}


class $1f89f80dfbd5e815$export$7fe01e6ab8aa748c {
    constructor(renderer, renderTarget){
        this.renderer = renderer;
        this._pixelRatio = renderer.getPixelRatio();
        if (renderTarget === undefined) {
            const size = renderer.getSize(new (0, $d5b33d7c30034067$export$c977b3e384af9ae1)());
            this._width = size.width;
            this._height = size.height;
            renderTarget = new (0, $d5b33d7c30034067$export$3c052beb2e51e23f)(this._width * this._pixelRatio, this._height * this._pixelRatio, {
                type: (0, $d5b33d7c30034067$export$2697304443f382bc)
            });
            renderTarget.texture.name = 'EffectComposer.rt1';
        } else {
            this._width = renderTarget.width;
            this._height = renderTarget.height;
        }
        this.renderTarget1 = renderTarget;
        this.renderTarget2 = renderTarget.clone();
        this.renderTarget2.texture.name = 'EffectComposer.rt2';
        this.writeBuffer = this.renderTarget1;
        this.readBuffer = this.renderTarget2;
        this.renderToScreen = true;
        this.passes = [];
        this.copyPass = new (0, $6ac47a3de6300e1f$export$c55093fd4f9e42f0)((0, $2f93ac2d46312da9$export$57f84a24a9a6130d));
        this.copyPass.material.blending = (0, $d5b33d7c30034067$export$63b8d6b580fc65ba);
        this.clock = new (0, $d5b33d7c30034067$export$9735c82c4bae3302)();
    }
    swapBuffers() {
        const tmp = this.readBuffer;
        this.readBuffer = this.writeBuffer;
        this.writeBuffer = tmp;
    }
    addPass(pass) {
        this.passes.push(pass);
        pass.setSize(this._width * this._pixelRatio, this._height * this._pixelRatio);
    }
    insertPass(pass, index) {
        this.passes.splice(index, 0, pass);
        pass.setSize(this._width * this._pixelRatio, this._height * this._pixelRatio);
    }
    removePass(pass) {
        const index = this.passes.indexOf(pass);
        if (index !== -1) this.passes.splice(index, 1);
    }
    isLastEnabledPass(passIndex) {
        for(let i = passIndex + 1; i < this.passes.length; i++){
            if (this.passes[i].enabled) return false;
        }
        return true;
    }
    render(deltaTime) {
        // deltaTime value is in seconds
        if (deltaTime === undefined) deltaTime = this.clock.getDelta();
        const currentRenderTarget = this.renderer.getRenderTarget();
        let maskActive = false;
        for(let i = 0, il = this.passes.length; i < il; i++){
            const pass = this.passes[i];
            if (pass.enabled === false) continue;
            pass.renderToScreen = this.renderToScreen && this.isLastEnabledPass(i);
            pass.render(this.renderer, this.writeBuffer, this.readBuffer, deltaTime, maskActive);
            if (pass.needsSwap) {
                if (maskActive) {
                    const context = this.renderer.getContext();
                    const stencil = this.renderer.state.buffers.stencil;
                    //context.stencilFunc( context.NOTEQUAL, 1, 0xffffffff );
                    stencil.setFunc(context.NOTEQUAL, 1, 0xffffffff);
                    this.copyPass.render(this.renderer, this.writeBuffer, this.readBuffer, deltaTime);
                    //context.stencilFunc( context.EQUAL, 1, 0xffffffff );
                    stencil.setFunc(context.EQUAL, 1, 0xffffffff);
                }
                this.swapBuffers();
            }
            if ((0, $0f4907a355572481$export$bb424a4005d6dde0) !== undefined) {
                if (pass instanceof (0, $0f4907a355572481$export$bb424a4005d6dde0)) maskActive = true;
                else if (pass instanceof (0, $0f4907a355572481$export$8d8650aed29c6251)) maskActive = false;
            }
        }
        this.renderer.setRenderTarget(currentRenderTarget);
    }
    reset(renderTarget) {
        if (renderTarget === undefined) {
            const size = this.renderer.getSize(new (0, $d5b33d7c30034067$export$c977b3e384af9ae1)());
            this._pixelRatio = this.renderer.getPixelRatio();
            this._width = size.width;
            this._height = size.height;
            renderTarget = this.renderTarget1.clone();
            renderTarget.setSize(this._width * this._pixelRatio, this._height * this._pixelRatio);
        }
        this.renderTarget1.dispose();
        this.renderTarget2.dispose();
        this.renderTarget1 = renderTarget;
        this.renderTarget2 = renderTarget.clone();
        this.writeBuffer = this.renderTarget1;
        this.readBuffer = this.renderTarget2;
    }
    setSize(width, height) {
        this._width = width;
        this._height = height;
        const effectiveWidth = this._width * this._pixelRatio;
        const effectiveHeight = this._height * this._pixelRatio;
        this.renderTarget1.setSize(effectiveWidth, effectiveHeight);
        this.renderTarget2.setSize(effectiveWidth, effectiveHeight);
        for(let i = 0; i < this.passes.length; i++)this.passes[i].setSize(effectiveWidth, effectiveHeight);
    }
    setPixelRatio(pixelRatio) {
        this._pixelRatio = pixelRatio;
        this.setSize(this._width, this._height);
    }
    dispose() {
        this.renderTarget1.dispose();
        this.renderTarget2.dispose();
        this.copyPass.dispose();
    }
}




class $f4d3a60efece63cd$export$f63ea822f020b5b0 extends (0, $0a1d3a5a6a49de03$export$802bc10488da99c7) {
    constructor(scene, camera, overrideMaterial = null, clearColor = null, clearAlpha = null){
        super();
        this.scene = scene;
        this.camera = camera;
        this.overrideMaterial = overrideMaterial;
        this.clearColor = clearColor;
        this.clearAlpha = clearAlpha;
        this.clear = true;
        this.clearDepth = false;
        this.needsSwap = false;
        this._oldClearColor = new (0, $d5b33d7c30034067$export$892596cec99bc70e)();
    }
    render(renderer, writeBuffer, readBuffer /*, deltaTime, maskActive */ ) {
        const oldAutoClear = renderer.autoClear;
        renderer.autoClear = false;
        let oldClearAlpha, oldOverrideMaterial;
        if (this.overrideMaterial !== null) {
            oldOverrideMaterial = this.scene.overrideMaterial;
            this.scene.overrideMaterial = this.overrideMaterial;
        }
        if (this.clearColor !== null) {
            renderer.getClearColor(this._oldClearColor);
            renderer.setClearColor(this.clearColor, renderer.getClearAlpha());
        }
        if (this.clearAlpha !== null) {
            oldClearAlpha = renderer.getClearAlpha();
            renderer.setClearAlpha(this.clearAlpha);
        }
        if (this.clearDepth == true) renderer.clearDepth();
        renderer.setRenderTarget(this.renderToScreen ? null : readBuffer);
        if (this.clear === true) // TODO: Avoid using autoClear properties, see https://github.com/mrdoob/three.js/pull/15571#issuecomment-465669600
        renderer.clear(renderer.autoClearColor, renderer.autoClearDepth, renderer.autoClearStencil);
        renderer.render(this.scene, this.camera);
        // restore
        if (this.clearColor !== null) renderer.setClearColor(this._oldClearColor);
        if (this.clearAlpha !== null) renderer.setClearAlpha(oldClearAlpha);
        if (this.overrideMaterial !== null) this.scene.overrideMaterial = oldOverrideMaterial;
        renderer.autoClear = oldAutoClear;
    }
}


function $618a8e53233cd9fa$export$2e2bcd8739ae039() {
    return $618a8e53233cd9fa$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $618a8e53233cd9fa$export$2e2bcd8739ae039.apply(null, arguments);
}


function $cd69a1d4c6210e44$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}


function $0ad5d8b55fe970db$export$2e2bcd8739ae039(t, e) {
    return $0ad5d8b55fe970db$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $0ad5d8b55fe970db$export$2e2bcd8739ae039(t, e);
}


function $bbb54ce93eb94a95$export$2e2bcd8739ae039(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, (0, $0ad5d8b55fe970db$export$2e2bcd8739ae039)(t, o);
}


function $e4c5ebe502337db0$export$2e2bcd8739ae039(t) {
    return $e4c5ebe502337db0$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $e4c5ebe502337db0$export$2e2bcd8739ae039(t);
}



function $7fc69e80a314c4c3$export$2e2bcd8739ae039(t) {
    try {
        return -1 !== Function.toString.call(t).indexOf("[native code]");
    } catch (n) {
        return "function" == typeof t;
    }
}


function $b2099f49db83e2df$export$2e2bcd8739ae039() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($b2099f49db83e2df$export$2e2bcd8739ae039 = function _isNativeReflectConstruct() {
        return !!t;
    })();
}



function $a01f1d6c8bd49d36$export$2e2bcd8739ae039(t, e, r) {
    if ((0, $b2099f49db83e2df$export$2e2bcd8739ae039)()) return Reflect.construct.apply(null, arguments);
    var o = [
        null
    ];
    o.push.apply(o, e);
    var p = new (t.bind.apply(t, o))();
    return r && (0, $0ad5d8b55fe970db$export$2e2bcd8739ae039)(p, r.prototype), p;
}


function $b6acf1c5cac9dbb2$export$2e2bcd8739ae039(t) {
    var r = "function" == typeof Map ? new Map() : void 0;
    return $b6acf1c5cac9dbb2$export$2e2bcd8739ae039 = function _wrapNativeSuper(t) {
        if (null === t || !(0, $7fc69e80a314c4c3$export$2e2bcd8739ae039)(t)) return t;
        if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
        if (void 0 !== r) {
            if (r.has(t)) return r.get(t);
            r.set(t, Wrapper);
        }
        function Wrapper() {
            return (0, $a01f1d6c8bd49d36$export$2e2bcd8739ae039)(t, arguments, (0, $e4c5ebe502337db0$export$2e2bcd8739ae039)(this).constructor);
        }
        return Wrapper.prototype = Object.create(t.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: !1,
                writable: !0,
                configurable: !0
            }
        }), (0, $0ad5d8b55fe970db$export$2e2bcd8739ae039)(Wrapper, t);
    }, $b6acf1c5cac9dbb2$export$2e2bcd8739ae039(t);
}


function $c5db23e5823ab236$export$2e2bcd8739ae039(e, t) {
    return t || (t = e.slice(0)), e.raw = t, e;
}


function $c4f699b4a01e0372$var$last() {
    var _ref;
    return _ref = arguments.length - 1, _ref < 0 || arguments.length <= _ref ? undefined : arguments[_ref];
}
function $c4f699b4a01e0372$var$negation(a) {
    return -a;
}
function $c4f699b4a01e0372$var$addition(a, b) {
    return a + b;
}
function $c4f699b4a01e0372$var$subtraction(a, b) {
    return a - b;
}
function $c4f699b4a01e0372$var$multiplication(a, b) {
    return a * b;
}
function $c4f699b4a01e0372$var$division(a, b) {
    return a / b;
}
function $c4f699b4a01e0372$var$max() {
    return Math.max.apply(Math, arguments);
}
function $c4f699b4a01e0372$var$min() {
    return Math.min.apply(Math, arguments);
}
function $c4f699b4a01e0372$var$comma() {
    return Array.of.apply(Array, arguments);
}
var $c4f699b4a01e0372$var$defaultSymbols = {
    symbols: {
        '*': {
            infix: {
                symbol: '*',
                f: $c4f699b4a01e0372$var$multiplication,
                notation: 'infix',
                precedence: 4,
                rightToLeft: 0,
                argCount: 2
            },
            symbol: '*',
            regSymbol: '\\*'
        },
        '/': {
            infix: {
                symbol: '/',
                f: $c4f699b4a01e0372$var$division,
                notation: 'infix',
                precedence: 4,
                rightToLeft: 0,
                argCount: 2
            },
            symbol: '/',
            regSymbol: '/'
        },
        '+': {
            infix: {
                symbol: '+',
                f: $c4f699b4a01e0372$var$addition,
                notation: 'infix',
                precedence: 2,
                rightToLeft: 0,
                argCount: 2
            },
            prefix: {
                symbol: '+',
                f: $c4f699b4a01e0372$var$last,
                notation: 'prefix',
                precedence: 3,
                rightToLeft: 0,
                argCount: 1
            },
            symbol: '+',
            regSymbol: '\\+'
        },
        '-': {
            infix: {
                symbol: '-',
                f: $c4f699b4a01e0372$var$subtraction,
                notation: 'infix',
                precedence: 2,
                rightToLeft: 0,
                argCount: 2
            },
            prefix: {
                symbol: '-',
                f: $c4f699b4a01e0372$var$negation,
                notation: 'prefix',
                precedence: 3,
                rightToLeft: 0,
                argCount: 1
            },
            symbol: '-',
            regSymbol: '-'
        },
        ',': {
            infix: {
                symbol: ',',
                f: $c4f699b4a01e0372$var$comma,
                notation: 'infix',
                precedence: 1,
                rightToLeft: 0,
                argCount: 2
            },
            symbol: ',',
            regSymbol: ','
        },
        '(': {
            prefix: {
                symbol: '(',
                f: $c4f699b4a01e0372$var$last,
                notation: 'prefix',
                precedence: 0,
                rightToLeft: 0,
                argCount: 1
            },
            symbol: '(',
            regSymbol: '\\('
        },
        ')': {
            postfix: {
                symbol: ')',
                f: undefined,
                notation: 'postfix',
                precedence: 0,
                rightToLeft: 0,
                argCount: 1
            },
            symbol: ')',
            regSymbol: '\\)'
        },
        min: {
            func: {
                symbol: 'min',
                f: $c4f699b4a01e0372$var$min,
                notation: 'func',
                precedence: 0,
                rightToLeft: 0,
                argCount: 1
            },
            symbol: 'min',
            regSymbol: 'min\\b'
        },
        max: {
            func: {
                symbol: 'max',
                f: $c4f699b4a01e0372$var$max,
                notation: 'func',
                precedence: 0,
                rightToLeft: 0,
                argCount: 1
            },
            symbol: 'max',
            regSymbol: 'max\\b'
        }
    }
};
var $c4f699b4a01e0372$var$defaultSymbolMap = $c4f699b4a01e0372$var$defaultSymbols;
// based on https://github.com/styled-components/styled-components/blob/fcf6f3804c57a14dd7984dfab7bc06ee2edca044/src/utils/error.js
/**
 * Parse errors.md and turn it into a simple hash of code: message
 * @private
 */ var $c4f699b4a01e0372$var$ERRORS = {
    "1": "Passed invalid arguments to hsl, please pass multiple numbers e.g. hsl(360, 0.75, 0.4) or an object e.g. rgb({ hue: 255, saturation: 0.4, lightness: 0.75 }).\n\n",
    "2": "Passed invalid arguments to hsla, please pass multiple numbers e.g. hsla(360, 0.75, 0.4, 0.7) or an object e.g. rgb({ hue: 255, saturation: 0.4, lightness: 0.75, alpha: 0.7 }).\n\n",
    "3": "Passed an incorrect argument to a color function, please pass a string representation of a color.\n\n",
    "4": "Couldn't generate valid rgb string from %s, it returned %s.\n\n",
    "5": "Couldn't parse the color string. Please provide the color as a string in hex, rgb, rgba, hsl or hsla notation.\n\n",
    "6": "Passed invalid arguments to rgb, please pass multiple numbers e.g. rgb(255, 205, 100) or an object e.g. rgb({ red: 255, green: 205, blue: 100 }).\n\n",
    "7": "Passed invalid arguments to rgba, please pass multiple numbers e.g. rgb(255, 205, 100, 0.75) or an object e.g. rgb({ red: 255, green: 205, blue: 100, alpha: 0.75 }).\n\n",
    "8": "Passed invalid argument to toColorString, please pass a RgbColor, RgbaColor, HslColor or HslaColor object.\n\n",
    "9": "Please provide a number of steps to the modularScale helper.\n\n",
    "10": "Please pass a number or one of the predefined scales to the modularScale helper as the ratio.\n\n",
    "11": "Invalid value passed as base to modularScale, expected number or em string but got \"%s\"\n\n",
    "12": "Expected a string ending in \"px\" or a number passed as the first argument to %s(), got \"%s\" instead.\n\n",
    "13": "Expected a string ending in \"px\" or a number passed as the second argument to %s(), got \"%s\" instead.\n\n",
    "14": "Passed invalid pixel value (\"%s\") to %s(), please pass a value like \"12px\" or 12.\n\n",
    "15": "Passed invalid base value (\"%s\") to %s(), please pass a value like \"12px\" or 12.\n\n",
    "16": "You must provide a template to this method.\n\n",
    "17": "You passed an unsupported selector state to this method.\n\n",
    "18": "minScreen and maxScreen must be provided as stringified numbers with the same units.\n\n",
    "19": "fromSize and toSize must be provided as stringified numbers with the same units.\n\n",
    "20": "expects either an array of objects or a single object with the properties prop, fromSize, and toSize.\n\n",
    "21": "expects the objects in the first argument array to have the properties `prop`, `fromSize`, and `toSize`.\n\n",
    "22": "expects the first argument object to have the properties `prop`, `fromSize`, and `toSize`.\n\n",
    "23": "fontFace expects a name of a font-family.\n\n",
    "24": "fontFace expects either the path to the font file(s) or a name of a local copy.\n\n",
    "25": "fontFace expects localFonts to be an array.\n\n",
    "26": "fontFace expects fileFormats to be an array.\n\n",
    "27": "radialGradient requries at least 2 color-stops to properly render.\n\n",
    "28": "Please supply a filename to retinaImage() as the first argument.\n\n",
    "29": "Passed invalid argument to triangle, please pass correct pointingDirection e.g. 'right'.\n\n",
    "30": "Passed an invalid value to `height` or `width`. Please provide a pixel based unit.\n\n",
    "31": "The animation shorthand only takes 8 arguments. See the specification for more information: http://mdn.io/animation\n\n",
    "32": "To pass multiple animations please supply them in arrays, e.g. animation(['rotate', '2s'], ['move', '1s'])\nTo pass a single animation please supply them in simple values, e.g. animation('rotate', '2s')\n\n",
    "33": "The animation shorthand arrays can only have 8 elements. See the specification for more information: http://mdn.io/animation\n\n",
    "34": "borderRadius expects a radius value as a string or number as the second argument.\n\n",
    "35": "borderRadius expects one of \"top\", \"bottom\", \"left\" or \"right\" as the first argument.\n\n",
    "36": "Property must be a string value.\n\n",
    "37": "Syntax Error at %s.\n\n",
    "38": "Formula contains a function that needs parentheses at %s.\n\n",
    "39": "Formula is missing closing parenthesis at %s.\n\n",
    "40": "Formula has too many closing parentheses at %s.\n\n",
    "41": "All values in a formula must have the same unit or be unitless.\n\n",
    "42": "Please provide a number of steps to the modularScale helper.\n\n",
    "43": "Please pass a number or one of the predefined scales to the modularScale helper as the ratio.\n\n",
    "44": "Invalid value passed as base to modularScale, expected number or em/rem string but got %s.\n\n",
    "45": "Passed invalid argument to hslToColorString, please pass a HslColor or HslaColor object.\n\n",
    "46": "Passed invalid argument to rgbToColorString, please pass a RgbColor or RgbaColor object.\n\n",
    "47": "minScreen and maxScreen must be provided as stringified numbers with the same units.\n\n",
    "48": "fromSize and toSize must be provided as stringified numbers with the same units.\n\n",
    "49": "Expects either an array of objects or a single object with the properties prop, fromSize, and toSize.\n\n",
    "50": "Expects the objects in the first argument array to have the properties prop, fromSize, and toSize.\n\n",
    "51": "Expects the first argument object to have the properties prop, fromSize, and toSize.\n\n",
    "52": "fontFace expects either the path to the font file(s) or a name of a local copy.\n\n",
    "53": "fontFace expects localFonts to be an array.\n\n",
    "54": "fontFace expects fileFormats to be an array.\n\n",
    "55": "fontFace expects a name of a font-family.\n\n",
    "56": "linearGradient requries at least 2 color-stops to properly render.\n\n",
    "57": "radialGradient requries at least 2 color-stops to properly render.\n\n",
    "58": "Please supply a filename to retinaImage() as the first argument.\n\n",
    "59": "Passed invalid argument to triangle, please pass correct pointingDirection e.g. 'right'.\n\n",
    "60": "Passed an invalid value to `height` or `width`. Please provide a pixel based unit.\n\n",
    "61": "Property must be a string value.\n\n",
    "62": "borderRadius expects a radius value as a string or number as the second argument.\n\n",
    "63": "borderRadius expects one of \"top\", \"bottom\", \"left\" or \"right\" as the first argument.\n\n",
    "64": "The animation shorthand only takes 8 arguments. See the specification for more information: http://mdn.io/animation.\n\n",
    "65": "To pass multiple animations please supply them in arrays, e.g. animation(['rotate', '2s'], ['move', '1s'])\\nTo pass a single animation please supply them in simple values, e.g. animation('rotate', '2s').\n\n",
    "66": "The animation shorthand arrays can only have 8 elements. See the specification for more information: http://mdn.io/animation.\n\n",
    "67": "You must provide a template to this method.\n\n",
    "68": "You passed an unsupported selector state to this method.\n\n",
    "69": "Expected a string ending in \"px\" or a number passed as the first argument to %s(), got %s instead.\n\n",
    "70": "Expected a string ending in \"px\" or a number passed as the second argument to %s(), got %s instead.\n\n",
    "71": "Passed invalid pixel value %s to %s(), please pass a value like \"12px\" or 12.\n\n",
    "72": "Passed invalid base value %s to %s(), please pass a value like \"12px\" or 12.\n\n",
    "73": "Please provide a valid CSS variable.\n\n",
    "74": "CSS variable not found and no default was provided.\n\n",
    "75": "important requires a valid style object, got a %s instead.\n\n",
    "76": "fromSize and toSize must be provided as stringified numbers with the same units as minScreen and maxScreen.\n\n",
    "77": "remToPx expects a value in \"rem\" but you provided it in \"%s\".\n\n",
    "78": "base must be set in \"px\" or \"%\" but you set it in \"%s\".\n"
};
/**
 * super basic version of sprintf
 * @private
 */ function $c4f699b4a01e0372$var$format() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    var a = args[0];
    var b = [];
    var c;
    for(c = 1; c < args.length; c += 1)b.push(args[c]);
    b.forEach(function(d) {
        a = a.replace(/%[a-z]/, d);
    });
    return a;
}
/**
 * Create an error file out of errors.md for development and a simple web link to the full errors
 * in production mode.
 * @private
 */ var $c4f699b4a01e0372$var$PolishedError = /*#__PURE__*/ function(_Error) {
    (0, $bbb54ce93eb94a95$export$2e2bcd8739ae039)(PolishedError, _Error);
    function PolishedError(code) {
        var _this;
        var _len2, args, _key2;
        _this = _Error.call(this, "An error occurred. See https://github.com/styled-components/polished/blob/main/src/internalHelpers/errors.md#" + code + " for more information.") || this;
        return (0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this);
    }
    return PolishedError;
}(/*#__PURE__*/ (0, $b6acf1c5cac9dbb2$export$2e2bcd8739ae039)(Error));
var $c4f699b4a01e0372$var$unitRegExp = /((?!\w)a|na|hc|mc|dg|me[r]?|xe|ni(?![a-zA-Z])|mm|cp|tp|xp|q(?!s)|hv|xamv|nimv|wv|sm|s(?!\D|$)|ged|darg?|nrut)/g;
// Merges additional math functionality into the defaults.
function $c4f699b4a01e0372$var$mergeSymbolMaps(additionalSymbols) {
    var symbolMap = {};
    symbolMap.symbols = additionalSymbols ? (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, $c4f699b4a01e0372$var$defaultSymbolMap.symbols, additionalSymbols.symbols) : (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, $c4f699b4a01e0372$var$defaultSymbolMap.symbols);
    return symbolMap;
}
function $c4f699b4a01e0372$var$exec(operators, values) {
    var _ref;
    var op = operators.pop();
    values.push(op.f.apply(op, (_ref = []).concat.apply(_ref, values.splice(-op.argCount))));
    return op.precedence;
}
function $c4f699b4a01e0372$var$calculate(expression, additionalSymbols) {
    var symbolMap = $c4f699b4a01e0372$var$mergeSymbolMaps(additionalSymbols);
    var match;
    var operators = [
        symbolMap.symbols['('].prefix
    ];
    var values = [];
    var pattern = new RegExp("\\d+(?:\\.\\d+)?|" + // ...and patterns for individual operators/function names
    Object.keys(symbolMap.symbols).map(function(key) {
        return symbolMap.symbols[key];
    })// longer symbols should be listed first
    // $FlowFixMe
    .sort(function(a, b) {
        return b.symbol.length - a.symbol.length;
    })// $FlowFixMe
    .map(function(val) {
        return val.regSymbol;
    }).join('|') + "|(\\S)", 'g');
    pattern.lastIndex = 0; // Reset regular expression object
    var afterValue = false;
    do {
        match = pattern.exec(expression);
        var _ref2 = match || [
            ')',
            undefined
        ], token = _ref2[0], bad = _ref2[1];
        var notNumber = symbolMap.symbols[token];
        var notNewValue = notNumber && !notNumber.prefix && !notNumber.func;
        var notAfterValue = !notNumber || !notNumber.postfix && !notNumber.infix;
        // Check for syntax errors:
        if (bad || (afterValue ? notAfterValue : notNewValue)) throw new $c4f699b4a01e0372$var$PolishedError(37, match ? match.index : expression.length, expression);
        if (afterValue) {
            // We either have an infix or postfix operator (they should be mutually exclusive)
            var curr = notNumber.postfix || notNumber.infix;
            do {
                var prev = operators[operators.length - 1];
                if ((curr.precedence - prev.precedence || prev.rightToLeft) > 0) break;
            // Apply previous operator, since it has precedence over current one
            }while ($c4f699b4a01e0372$var$exec(operators, values)); // Exit loop after executing an opening parenthesis or function
            afterValue = curr.notation === 'postfix';
            if (curr.symbol !== ')') {
                operators.push(curr);
                // Postfix always has precedence over any operator that follows after it
                if (afterValue) $c4f699b4a01e0372$var$exec(operators, values);
            }
        } else if (notNumber) {
            // prefix operator or function
            operators.push(notNumber.prefix || notNumber.func);
            if (notNumber.func) {
                // Require an opening parenthesis
                match = pattern.exec(expression);
                if (!match || match[0] !== '(') throw new $c4f699b4a01e0372$var$PolishedError(38, match ? match.index : expression.length, expression);
            }
        } else {
            // number
            values.push(+token);
            afterValue = true;
        }
    }while (match && operators.length);
    if (operators.length) throw new $c4f699b4a01e0372$var$PolishedError(39, match ? match.index : expression.length, expression);
    else if (match) throw new $c4f699b4a01e0372$var$PolishedError(40, match ? match.index : expression.length, expression);
    else return values.pop();
}
function $c4f699b4a01e0372$var$reverseString(str) {
    return str.split('').reverse().join('');
}
/**
 * Helper for doing math with CSS Units. Accepts a formula as a string. All values in the formula must have the same unit (or be unitless). Supports complex formulas utliziing addition, subtraction, multiplication, division, square root, powers, factorial, min, max, as well as parentheses for order of operation.
 *
 *In cases where you need to do calculations with mixed units where one unit is a [relative length unit](https://developer.mozilla.org/en-US/docs/Web/CSS/length#Relative_length_units), you will want to use [CSS Calc](https://developer.mozilla.org/en-US/docs/Web/CSS/calc).
 *
 * *warning* While we've done everything possible to ensure math safely evalutes formulas expressed as strings, you should always use extreme caution when passing `math` user provided values.
 * @example
 * // Styles as object usage
 * const styles = {
 *   fontSize: math('12rem + 8rem'),
 *   fontSize: math('(12px + 2px) * 3'),
 *   fontSize: math('3px^2 + sqrt(4)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   fontSize: ${math('12rem + 8rem')};
 *   fontSize: ${math('(12px + 2px) * 3')};
 *   fontSize: ${math('3px^2 + sqrt(4)')};
 * `
 *
 * // CSS as JS Output
 *
 * div: {
 *   fontSize: '20rem',
 *   fontSize: '42px',
 *   fontSize: '11px',
 * }
 */ function $c4f699b4a01e0372$export$1c891a3202c0ba6a(formula, additionalSymbols) {
    var reversedFormula = $c4f699b4a01e0372$var$reverseString(formula);
    var formulaMatch = reversedFormula.match($c4f699b4a01e0372$var$unitRegExp);
    // Check that all units are the same
    if (formulaMatch && !formulaMatch.every(function(unit) {
        return unit === formulaMatch[0];
    })) throw new $c4f699b4a01e0372$var$PolishedError(41);
    var cleanFormula = $c4f699b4a01e0372$var$reverseString(reversedFormula.replace($c4f699b4a01e0372$var$unitRegExp, ''));
    return "" + $c4f699b4a01e0372$var$calculate(cleanFormula, additionalSymbols) + (formulaMatch ? $c4f699b4a01e0372$var$reverseString(formulaMatch[0]) : '');
}
var $c4f699b4a01e0372$var$cssVariableRegex = /--[\S]*/g;
/**
 * Fetches the value of a passed CSS Variable in the :root scope, or otherwise returns a defaultValue if provided.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   'background': cssVar('--background-color'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${cssVar('--background-color')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   'background': 'red'
 * }
 */ function $c4f699b4a01e0372$export$8b4981022bd80a4e(cssVariable, defaultValue) {
    if (!cssVariable || !cssVariable.match($c4f699b4a01e0372$var$cssVariableRegex)) throw new $c4f699b4a01e0372$var$PolishedError(73);
    var variableValue;
    /* eslint-disable */ /* istanbul ignore next */ if (typeof document !== 'undefined' && document.documentElement !== null) variableValue = getComputedStyle(document.documentElement).getPropertyValue(cssVariable);
    /* eslint-enable */ if (variableValue) return variableValue.trim();
    else if (defaultValue) return defaultValue;
    throw new $c4f699b4a01e0372$var$PolishedError(74);
}
// @private
function $c4f699b4a01e0372$var$capitalizeString(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}
var $c4f699b4a01e0372$var$positionMap$1 = [
    'Top',
    'Right',
    'Bottom',
    'Left'
];
function $c4f699b4a01e0372$var$generateProperty(property, position) {
    if (!property) return position.toLowerCase();
    var splitProperty = property.split('-');
    if (splitProperty.length > 1) {
        splitProperty.splice(1, 0, position);
        return splitProperty.reduce(function(acc, val) {
            return "" + acc + $c4f699b4a01e0372$var$capitalizeString(val);
        });
    }
    var joinedProperty = property.replace(/([a-z])([A-Z])/g, "$1" + position + "$2");
    return property === joinedProperty ? "" + property + position : joinedProperty;
}
function $c4f699b4a01e0372$var$generateStyles(property, valuesWithDefaults) {
    var styles = {};
    for(var i = 0; i < valuesWithDefaults.length; i += 1)if (valuesWithDefaults[i] || valuesWithDefaults[i] === 0) styles[$c4f699b4a01e0372$var$generateProperty(property, $c4f699b4a01e0372$var$positionMap$1[i])] = valuesWithDefaults[i];
    return styles;
}
/**
 * Enables shorthand for direction-based properties. It accepts a property (hyphenated or camelCased) and up to four values that map to top, right, bottom, and left, respectively. You can optionally pass an empty string to get only the directional values as properties. You can also optionally pass a null argument for a directional value to ignore it.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...directionalProperty('padding', '12px', '24px', '36px', '48px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${directionalProperty('padding', '12px', '24px', '36px', '48px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'paddingTop': '12px',
 *   'paddingRight': '24px',
 *   'paddingBottom': '36px',
 *   'paddingLeft': '48px'
 * }
 */ function $c4f699b4a01e0372$export$4fc00c04dd60af95(property) {
    for(var _len = arguments.length, values = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)values[_key - 1] = arguments[_key];
    //  prettier-ignore
    var firstValue = values[0], _values$ = values[1], secondValue = _values$ === void 0 ? firstValue : _values$, _values$2 = values[2], thirdValue = _values$2 === void 0 ? firstValue : _values$2, _values$3 = values[3], fourthValue = _values$3 === void 0 ? secondValue : _values$3;
    var valuesWithDefaults = [
        firstValue,
        secondValue,
        thirdValue,
        fourthValue
    ];
    return $c4f699b4a01e0372$var$generateStyles(property, valuesWithDefaults);
}
/**
 * Check if a string ends with something
 * @private
 */ function $c4f699b4a01e0372$var$endsWith(string, suffix) {
    return string.substr(-suffix.length) === suffix;
}
var $c4f699b4a01e0372$var$cssRegex$1 = /^([+-]?(?:\d+|\d*\.\d+))([a-z]*|%)$/;
/**
 * Returns a given CSS value minus its unit of measure.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   '--dimension': stripUnit('100px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   --dimension: ${stripUnit('100px')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   '--dimension': 100
 * }
 */ function $c4f699b4a01e0372$export$ef04e38dc423904(value) {
    if (typeof value !== 'string') return value;
    var matchedValue = value.match($c4f699b4a01e0372$var$cssRegex$1);
    return matchedValue ? parseFloat(value) : value;
}
/**
 * Factory function that creates pixel-to-x converters
 * @private
 */ var $c4f699b4a01e0372$var$pxtoFactory = function pxtoFactory(to) {
    return function(pxval, base) {
        if (base === void 0) base = '16px';
        var newPxval = pxval;
        var newBase = base;
        if (typeof pxval === 'string') {
            if (!$c4f699b4a01e0372$var$endsWith(pxval, 'px')) throw new $c4f699b4a01e0372$var$PolishedError(69, to, pxval);
            newPxval = $c4f699b4a01e0372$export$ef04e38dc423904(pxval);
        }
        if (typeof base === 'string') {
            if (!$c4f699b4a01e0372$var$endsWith(base, 'px')) throw new $c4f699b4a01e0372$var$PolishedError(70, to, base);
            newBase = $c4f699b4a01e0372$export$ef04e38dc423904(base);
        }
        if (typeof newPxval === 'string') throw new $c4f699b4a01e0372$var$PolishedError(71, pxval, to);
        if (typeof newBase === 'string') throw new $c4f699b4a01e0372$var$PolishedError(72, base, to);
        return "" + newPxval / newBase + to;
    };
};
var $c4f699b4a01e0372$var$pixelsto = $c4f699b4a01e0372$var$pxtoFactory;
/**
 * Convert pixel value to ems. The default base value is 16px, but can be changed by passing a
 * second argument to the function.
 * @function
 * @param {string|number} pxval
 * @param {string|number} [base='16px']
 * @example
 * // Styles as object usage
 * const styles = {
 *   'height': em('16px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   height: ${em('16px')}
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   'height': '1em'
 * }
 */ var $c4f699b4a01e0372$var$em = $c4f699b4a01e0372$var$pixelsto('em');
var $c4f699b4a01e0372$export$c63c6f932822f543 = $c4f699b4a01e0372$var$em;
var $c4f699b4a01e0372$var$cssRegex = /^([+-]?(?:\d+|\d*\.\d+))([a-z]*|%)$/;
/**
 * Returns a given CSS value and its unit as elements of an array.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   '--dimension': getValueAndUnit('100px')[0],
 *   '--unit': getValueAndUnit('100px')[1],
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   --dimension: ${getValueAndUnit('100px')[0]};
 *   --unit: ${getValueAndUnit('100px')[1]};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   '--dimension': 100,
 *   '--unit': 'px',
 * }
 */ function $c4f699b4a01e0372$export$feec6b849ef388ab(value) {
    if (typeof value !== 'string') return [
        value,
        ''
    ];
    var matchedValue = value.match($c4f699b4a01e0372$var$cssRegex);
    if (matchedValue) return [
        parseFloat(value),
        matchedValue[2]
    ];
    return [
        value,
        undefined
    ];
}
/**
 * Helper for targeting rules in a style block generated by polished modules that need !important-level specificity. Can optionally specify a rule (or rules) to target specific rules.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...important(cover())
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${important(cover())}
 * `
 *
 * // CSS as JS Output
 *
 * div: {
 *   'position': 'absolute !important',
 *   'top': '0 !important',
 *   'right: '0 !important',
 *   'bottom': '0 !important',
 *   'left: '0 !important'
 * }
 */ function $c4f699b4a01e0372$export$929888ab0c9f043c(styleBlock, rules) {
    if (typeof styleBlock !== 'object' || styleBlock === null) throw new $c4f699b4a01e0372$var$PolishedError(75, typeof styleBlock);
    var newStyleBlock = {};
    Object.keys(styleBlock).forEach(function(key) {
        if (typeof styleBlock[key] === 'object' && styleBlock[key] !== null) newStyleBlock[key] = $c4f699b4a01e0372$export$929888ab0c9f043c(styleBlock[key], rules);
        else if (!rules || rules && (rules === key || rules.indexOf(key) >= 0)) newStyleBlock[key] = styleBlock[key] + " !important";
        else newStyleBlock[key] = styleBlock[key];
    });
    return newStyleBlock;
}
var $c4f699b4a01e0372$var$ratioNames = {
    minorSecond: 1.067,
    majorSecond: 1.125,
    minorThird: 1.2,
    majorThird: 1.25,
    perfectFourth: 1.333,
    augFourth: 1.414,
    perfectFifth: 1.5,
    minorSixth: 1.6,
    goldenSection: 1.618,
    majorSixth: 1.667,
    minorSeventh: 1.778,
    majorSeventh: 1.875,
    octave: 2,
    majorTenth: 2.5,
    majorEleventh: 2.667,
    majorTwelfth: 3,
    doubleOctave: 4
};
function $c4f699b4a01e0372$var$getRatio(ratioName) {
    return $c4f699b4a01e0372$var$ratioNames[ratioName];
}
/**
 * Establish consistent measurements and spacial relationships throughout your projects by incrementing an em or rem value up or down a defined scale. We provide a list of commonly used scales as pre-defined variables.
 * @example
 * // Styles as object usage
 * const styles = {
 *    // Increment two steps up the default scale
 *   'fontSize': modularScale(2)
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *    // Increment two steps up the default scale
 *   fontSize: ${modularScale(2)}
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   'fontSize': '1.77689em'
 * }
 */ function $c4f699b4a01e0372$export$c82a8a23c9e8bdb6(steps, base, ratio) {
    if (base === void 0) base = '1em';
    if (ratio === void 0) ratio = 1.333;
    if (typeof steps !== 'number') throw new $c4f699b4a01e0372$var$PolishedError(42);
    if (typeof ratio === 'string' && !$c4f699b4a01e0372$var$ratioNames[ratio]) throw new $c4f699b4a01e0372$var$PolishedError(43);
    var _ref = typeof base === 'string' ? $c4f699b4a01e0372$export$feec6b849ef388ab(base) : [
        base,
        ''
    ], realBase = _ref[0], unit = _ref[1];
    var realRatio = typeof ratio === 'string' ? $c4f699b4a01e0372$var$getRatio(ratio) : ratio;
    if (typeof realBase === 'string') throw new $c4f699b4a01e0372$var$PolishedError(44, base);
    return "" + realBase * Math.pow(realRatio, steps) + (unit || '');
}
/**
 * Convert pixel value to rems. The default base value is 16px, but can be changed by passing a
 * second argument to the function.
 * @function
 * @param {string|number} pxval
 * @param {string|number} [base='16px']
 * @example
 * // Styles as object usage
 * const styles = {
 *   'height': rem('16px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   height: ${rem('16px')}
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   'height': '1rem'
 * }
 */ var $c4f699b4a01e0372$var$rem = $c4f699b4a01e0372$var$pixelsto('rem');
var $c4f699b4a01e0372$export$fb1897a40d146f7f = $c4f699b4a01e0372$var$rem;
var $c4f699b4a01e0372$var$defaultFontSize = 16;
function $c4f699b4a01e0372$var$convertBase(base) {
    var deconstructedValue = $c4f699b4a01e0372$export$feec6b849ef388ab(base);
    if (deconstructedValue[1] === 'px') return parseFloat(base);
    if (deconstructedValue[1] === '%') return parseFloat(base) / 100 * $c4f699b4a01e0372$var$defaultFontSize;
    throw new $c4f699b4a01e0372$var$PolishedError(78, deconstructedValue[1]);
}
function $c4f699b4a01e0372$var$getBaseFromDoc() {
    /* eslint-disable */ /* istanbul ignore next */ if (typeof document !== 'undefined' && document.documentElement !== null) {
        var rootFontSize = getComputedStyle(document.documentElement).fontSize;
        return rootFontSize ? $c4f699b4a01e0372$var$convertBase(rootFontSize) : $c4f699b4a01e0372$var$defaultFontSize;
    }
    /* eslint-enable */ /* istanbul ignore next */ return $c4f699b4a01e0372$var$defaultFontSize;
}
/**
 * Convert rem values to px. By default, the base value is pulled from the font-size property on the root element (if it is set in % or px). It defaults to 16px if not found on the root. You can also override the base value by providing your own base in % or px.
 * @example
 * // Styles as object usage
 * const styles = {
 *   'height': remToPx('1.6rem')
 *   'height': remToPx('1.6rem', '10px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   height: ${remToPx('1.6rem')}
 *   height: ${remToPx('1.6rem', '10px')}
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   'height': '25.6px',
 *   'height': '16px',
 * }
 */ function $c4f699b4a01e0372$export$7e5d3caf0359a67a(value, base) {
    var deconstructedValue = $c4f699b4a01e0372$export$feec6b849ef388ab(value);
    if (deconstructedValue[1] !== 'rem' && deconstructedValue[1] !== '') throw new $c4f699b4a01e0372$var$PolishedError(77, deconstructedValue[1]);
    var newBase = base ? $c4f699b4a01e0372$var$convertBase(base) : $c4f699b4a01e0372$var$getBaseFromDoc();
    return deconstructedValue[0] * newBase + "px";
}
var $c4f699b4a01e0372$var$functionsMap$3 = {
    back: 'cubic-bezier(0.600, -0.280, 0.735, 0.045)',
    circ: 'cubic-bezier(0.600,  0.040, 0.980, 0.335)',
    cubic: 'cubic-bezier(0.550,  0.055, 0.675, 0.190)',
    expo: 'cubic-bezier(0.950,  0.050, 0.795, 0.035)',
    quad: 'cubic-bezier(0.550,  0.085, 0.680, 0.530)',
    quart: 'cubic-bezier(0.895,  0.030, 0.685, 0.220)',
    quint: 'cubic-bezier(0.755,  0.050, 0.855, 0.060)',
    sine: 'cubic-bezier(0.470,  0.000, 0.745, 0.715)'
};
/**
 * String to represent common easing functions as demonstrated here: (github.com/jaukia/easie).
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   'transitionTimingFunction': easeIn('quad')
 * }
 *
 * // styled-components usage
 *  const div = styled.div`
 *   transitionTimingFunction: ${easeIn('quad')};
 * `
 *
 * // CSS as JS Output
 *
 * 'div': {
 *   'transitionTimingFunction': 'cubic-bezier(0.550,  0.085, 0.680, 0.530)',
 * }
 */ function $c4f699b4a01e0372$export$929e5a82286172a6(functionName) {
    return $c4f699b4a01e0372$var$functionsMap$3[functionName.toLowerCase().trim()];
}
var $c4f699b4a01e0372$var$functionsMap$2 = {
    back: 'cubic-bezier(0.680, -0.550, 0.265, 1.550)',
    circ: 'cubic-bezier(0.785,  0.135, 0.150, 0.860)',
    cubic: 'cubic-bezier(0.645,  0.045, 0.355, 1.000)',
    expo: 'cubic-bezier(1.000,  0.000, 0.000, 1.000)',
    quad: 'cubic-bezier(0.455,  0.030, 0.515, 0.955)',
    quart: 'cubic-bezier(0.770,  0.000, 0.175, 1.000)',
    quint: 'cubic-bezier(0.860,  0.000, 0.070, 1.000)',
    sine: 'cubic-bezier(0.445,  0.050, 0.550, 0.950)'
};
/**
 * String to represent common easing functions as demonstrated here: (github.com/jaukia/easie).
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   'transitionTimingFunction': easeInOut('quad')
 * }
 *
 * // styled-components usage
 *  const div = styled.div`
 *   transitionTimingFunction: ${easeInOut('quad')};
 * `
 *
 * // CSS as JS Output
 *
 * 'div': {
 *   'transitionTimingFunction': 'cubic-bezier(0.455,  0.030, 0.515, 0.955)',
 * }
 */ function $c4f699b4a01e0372$export$c07234257a03d5e9(functionName) {
    return $c4f699b4a01e0372$var$functionsMap$2[functionName.toLowerCase().trim()];
}
var $c4f699b4a01e0372$var$functionsMap$1 = {
    back: 'cubic-bezier(0.175,  0.885, 0.320, 1.275)',
    cubic: 'cubic-bezier(0.215,  0.610, 0.355, 1.000)',
    circ: 'cubic-bezier(0.075,  0.820, 0.165, 1.000)',
    expo: 'cubic-bezier(0.190,  1.000, 0.220, 1.000)',
    quad: 'cubic-bezier(0.250,  0.460, 0.450, 0.940)',
    quart: 'cubic-bezier(0.165,  0.840, 0.440, 1.000)',
    quint: 'cubic-bezier(0.230,  1.000, 0.320, 1.000)',
    sine: 'cubic-bezier(0.390,  0.575, 0.565, 1.000)'
};
/**
 * String to represent common easing functions as demonstrated here: (github.com/jaukia/easie).
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   'transitionTimingFunction': easeOut('quad')
 * }
 *
 * // styled-components usage
 *  const div = styled.div`
 *   transitionTimingFunction: ${easeOut('quad')};
 * `
 *
 * // CSS as JS Output
 *
 * 'div': {
 *   'transitionTimingFunction': 'cubic-bezier(0.250,  0.460, 0.450, 0.940)',
 * }
 */ function $c4f699b4a01e0372$export$57636bb43b1ccbb0(functionName) {
    return $c4f699b4a01e0372$var$functionsMap$1[functionName.toLowerCase().trim()];
}
/**
 * Returns a CSS calc formula for linear interpolation of a property between two values. Accepts optional minScreen (defaults to '320px') and maxScreen (defaults to '1200px').
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   fontSize: between('20px', '100px', '400px', '1000px'),
 *   fontSize: between('20px', '100px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   fontSize: ${between('20px', '100px', '400px', '1000px')};
 *   fontSize: ${between('20px', '100px')}
 * `
 *
 * // CSS as JS Output
 *
 * h1: {
 *   'fontSize': 'calc(-33.33333333333334px + 13.333333333333334vw)',
 *   'fontSize': 'calc(-9.090909090909093px + 9.090909090909092vw)'
 * }
 */ function $c4f699b4a01e0372$export$cf95c51b03f10bae(fromSize, toSize, minScreen, maxScreen) {
    if (minScreen === void 0) minScreen = '320px';
    if (maxScreen === void 0) maxScreen = '1200px';
    var _getValueAndUnit = $c4f699b4a01e0372$export$feec6b849ef388ab(fromSize), unitlessFromSize = _getValueAndUnit[0], fromSizeUnit = _getValueAndUnit[1];
    var _getValueAndUnit2 = $c4f699b4a01e0372$export$feec6b849ef388ab(toSize), unitlessToSize = _getValueAndUnit2[0], toSizeUnit = _getValueAndUnit2[1];
    var _getValueAndUnit3 = $c4f699b4a01e0372$export$feec6b849ef388ab(minScreen), unitlessMinScreen = _getValueAndUnit3[0], minScreenUnit = _getValueAndUnit3[1];
    var _getValueAndUnit4 = $c4f699b4a01e0372$export$feec6b849ef388ab(maxScreen), unitlessMaxScreen = _getValueAndUnit4[0], maxScreenUnit = _getValueAndUnit4[1];
    if (typeof unitlessMinScreen !== 'number' || typeof unitlessMaxScreen !== 'number' || !minScreenUnit || !maxScreenUnit || minScreenUnit !== maxScreenUnit) throw new $c4f699b4a01e0372$var$PolishedError(47);
    if (typeof unitlessFromSize !== 'number' || typeof unitlessToSize !== 'number' || fromSizeUnit !== toSizeUnit) throw new $c4f699b4a01e0372$var$PolishedError(48);
    if (fromSizeUnit !== minScreenUnit || toSizeUnit !== maxScreenUnit) throw new $c4f699b4a01e0372$var$PolishedError(76);
    var slope = (unitlessFromSize - unitlessToSize) / (unitlessMinScreen - unitlessMaxScreen);
    var base = unitlessToSize - slope * unitlessMaxScreen;
    return "calc(" + base.toFixed(2) + (fromSizeUnit || '') + " + " + (100 * slope).toFixed(2) + "vw)";
}
/**
 * CSS to contain a float (credit to CSSMojo).
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *    ...clearFix(),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${clearFix()}
 * `
 *
 * // CSS as JS Output
 *
 * '&::after': {
 *   'clear': 'both',
 *   'content': '""',
 *   'display': 'table'
 * }
 */ function $c4f699b4a01e0372$export$8c467e8859fdef13(parent) {
    var _ref;
    if (parent === void 0) parent = '&';
    var pseudoSelector = parent + "::after";
    return _ref = {}, _ref[pseudoSelector] = {
        clear: 'both',
        content: '""',
        display: 'table'
    }, _ref;
}
/**
 * CSS to fully cover an area. Can optionally be passed an offset to act as a "padding".
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...cover()
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${cover()}
 * `
 *
 * // CSS as JS Output
 *
 * div: {
 *   'position': 'absolute',
 *   'top': '0',
 *   'right: '0',
 *   'bottom': '0',
 *   'left: '0'
 * }
 */ function $c4f699b4a01e0372$export$4bdbf921f0c0fd8c(offset) {
    if (offset === void 0) offset = 0;
    return {
        position: 'absolute',
        top: offset,
        right: offset,
        bottom: offset,
        left: offset
    };
}
/**
 * CSS to represent truncated text with an ellipsis. You can optionally pass a max-width and number of lines before truncating.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...ellipsis('250px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${ellipsis('250px')}
 * `
 *
 * // CSS as JS Output
 *
 * div: {
 *   'display': 'inline-block',
 *   'maxWidth': '250px',
 *   'overflow': 'hidden',
 *   'textOverflow': 'ellipsis',
 *   'whiteSpace': 'nowrap',
 *   'wordWrap': 'normal'
 * }
 */ function $c4f699b4a01e0372$export$a5b94313d6908893(width, lines) {
    if (lines === void 0) lines = 1;
    var styles = {
        display: 'inline-block',
        maxWidth: width || '100%',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        wordWrap: 'normal'
    };
    return lines > 1 ? (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, styles, {
        WebkitBoxOrient: 'vertical',
        WebkitLineClamp: lines,
        display: '-webkit-box',
        whiteSpace: 'normal'
    }) : styles;
}
function $c4f699b4a01e0372$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $c4f699b4a01e0372$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $c4f699b4a01e0372$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $c4f699b4a01e0372$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $c4f699b4a01e0372$var$_arrayLikeToArray(o, minLen);
}
function $c4f699b4a01e0372$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
/**
 * Returns a set of media queries that resizes a property (or set of properties) between a provided fromSize and toSize. Accepts optional minScreen (defaults to '320px') and maxScreen (defaults to '1200px') to constrain the interpolation.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...fluidRange(
 *    {
 *        prop: 'padding',
 *        fromSize: '20px',
 *        toSize: '100px',
 *      },
 *      '400px',
 *      '1000px',
 *    )
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${fluidRange(
 *      {
 *        prop: 'padding',
 *        fromSize: '20px',
 *        toSize: '100px',
 *      },
 *      '400px',
 *      '1000px',
 *    )}
 * `
 *
 * // CSS as JS Output
 *
 * div: {
 *   "@media (min-width: 1000px)": Object {
 *     "padding": "100px",
 *   },
 *   "@media (min-width: 400px)": Object {
 *     "padding": "calc(-33.33333333333334px + 13.333333333333334vw)",
 *   },
 *   "padding": "20px",
 * }
 */ function $c4f699b4a01e0372$export$de4c2ac00f6121cf(cssProp, minScreen, maxScreen) {
    if (minScreen === void 0) minScreen = '320px';
    if (maxScreen === void 0) maxScreen = '1200px';
    if (!Array.isArray(cssProp) && typeof cssProp !== 'object' || cssProp === null) throw new $c4f699b4a01e0372$var$PolishedError(49);
    if (Array.isArray(cssProp)) {
        var mediaQueries = {};
        var fallbacks = {};
        for(var _iterator = $c4f699b4a01e0372$var$_createForOfIteratorHelperLoose(cssProp), _step; !(_step = _iterator()).done;){
            var _extends2, _extends3;
            var obj = _step.value;
            if (!obj.prop || !obj.fromSize || !obj.toSize) throw new $c4f699b4a01e0372$var$PolishedError(50);
            fallbacks[obj.prop] = obj.fromSize;
            mediaQueries["@media (min-width: " + minScreen + ")"] = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, mediaQueries["@media (min-width: " + minScreen + ")"], (_extends2 = {}, _extends2[obj.prop] = $c4f699b4a01e0372$export$cf95c51b03f10bae(obj.fromSize, obj.toSize, minScreen, maxScreen), _extends2));
            mediaQueries["@media (min-width: " + maxScreen + ")"] = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, mediaQueries["@media (min-width: " + maxScreen + ")"], (_extends3 = {}, _extends3[obj.prop] = obj.toSize, _extends3));
        }
        return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, fallbacks, mediaQueries);
    } else {
        var _ref, _ref2, _ref3;
        if (!cssProp.prop || !cssProp.fromSize || !cssProp.toSize) throw new $c4f699b4a01e0372$var$PolishedError(51);
        return _ref3 = {}, _ref3[cssProp.prop] = cssProp.fromSize, _ref3["@media (min-width: " + minScreen + ")"] = (_ref = {}, _ref[cssProp.prop] = $c4f699b4a01e0372$export$cf95c51b03f10bae(cssProp.fromSize, cssProp.toSize, minScreen, maxScreen), _ref), _ref3["@media (min-width: " + maxScreen + ")"] = (_ref2 = {}, _ref2[cssProp.prop] = cssProp.toSize, _ref2), _ref3;
    }
}
var $c4f699b4a01e0372$var$dataURIRegex = /^\s*data:([a-z]+\/[a-z-]+(;[a-z-]+=[a-z-]+)?)?(;charset=[a-z0-9-]+)?(;base64)?,[a-z0-9!$&',()*+,;=\-._~:@/?%\s]*\s*$/i;
var $c4f699b4a01e0372$var$formatHintMap = {
    woff: 'woff',
    woff2: 'woff2',
    ttf: 'truetype',
    otf: 'opentype',
    eot: 'embedded-opentype',
    svg: 'svg',
    svgz: 'svg'
};
function $c4f699b4a01e0372$var$generateFormatHint(format, formatHint) {
    if (!formatHint) return '';
    return " format(\"" + $c4f699b4a01e0372$var$formatHintMap[format] + "\")";
}
function $c4f699b4a01e0372$var$isDataURI(fontFilePath) {
    return !!fontFilePath.replace(/\s+/g, ' ').match($c4f699b4a01e0372$var$dataURIRegex);
}
function $c4f699b4a01e0372$var$generateFileReferences(fontFilePath, fileFormats, formatHint) {
    if ($c4f699b4a01e0372$var$isDataURI(fontFilePath)) return "url(\"" + fontFilePath + "\")" + $c4f699b4a01e0372$var$generateFormatHint(fileFormats[0], formatHint);
    var fileFontReferences = fileFormats.map(function(format) {
        return "url(\"" + fontFilePath + "." + format + "\")" + $c4f699b4a01e0372$var$generateFormatHint(format, formatHint);
    });
    return fileFontReferences.join(', ');
}
function $c4f699b4a01e0372$var$generateLocalReferences(localFonts) {
    var localFontReferences = localFonts.map(function(font) {
        return "local(\"" + font + "\")";
    });
    return localFontReferences.join(', ');
}
function $c4f699b4a01e0372$var$generateSources(fontFilePath, localFonts, fileFormats, formatHint) {
    var fontReferences = [];
    if (localFonts) fontReferences.push($c4f699b4a01e0372$var$generateLocalReferences(localFonts));
    if (fontFilePath) fontReferences.push($c4f699b4a01e0372$var$generateFileReferences(fontFilePath, fileFormats, formatHint));
    return fontReferences.join(', ');
}
/**
 * CSS for a @font-face declaration. Defaults to check for local copies of the font on the user's machine. You can disable this by passing `null` to localFonts.
 *
 * @example
 * // Styles as object basic usage
 * const styles = {
 *    ...fontFace({
 *      'fontFamily': 'Sans-Pro',
 *      'fontFilePath': 'path/to/file'
 *    })
 * }
 *
 * // styled-components basic usage
 * const GlobalStyle = createGlobalStyle`${
 *   fontFace({
 *     'fontFamily': 'Sans-Pro',
 *     'fontFilePath': 'path/to/file'
 *   }
 * )}`
 *
 * // CSS as JS Output
 *
 * '@font-face': {
 *   'fontFamily': 'Sans-Pro',
 *   'src': 'url("path/to/file.eot"), url("path/to/file.woff2"), url("path/to/file.woff"), url("path/to/file.ttf"), url("path/to/file.svg")',
 * }
 */ function $c4f699b4a01e0372$export$566c6c2ff0443c7(_ref) {
    var fontFamily = _ref.fontFamily, fontFilePath = _ref.fontFilePath, fontStretch = _ref.fontStretch, fontStyle = _ref.fontStyle, fontVariant = _ref.fontVariant, fontWeight = _ref.fontWeight, _ref$fileFormats = _ref.fileFormats, fileFormats = _ref$fileFormats === void 0 ? [
        'eot',
        'woff2',
        'woff',
        'ttf',
        'svg'
    ] : _ref$fileFormats, _ref$formatHint = _ref.formatHint, formatHint = _ref$formatHint === void 0 ? false : _ref$formatHint, _ref$localFonts = _ref.localFonts, localFonts = _ref$localFonts === void 0 ? [
        fontFamily
    ] : _ref$localFonts, unicodeRange = _ref.unicodeRange, fontDisplay = _ref.fontDisplay, fontVariationSettings = _ref.fontVariationSettings, fontFeatureSettings = _ref.fontFeatureSettings;
    // Error Handling
    if (!fontFamily) throw new $c4f699b4a01e0372$var$PolishedError(55);
    if (!fontFilePath && !localFonts) throw new $c4f699b4a01e0372$var$PolishedError(52);
    if (localFonts && !Array.isArray(localFonts)) throw new $c4f699b4a01e0372$var$PolishedError(53);
    if (!Array.isArray(fileFormats)) throw new $c4f699b4a01e0372$var$PolishedError(54);
    var fontFaceDeclaration = {
        '@font-face': {
            fontFamily: fontFamily,
            src: $c4f699b4a01e0372$var$generateSources(fontFilePath, localFonts, fileFormats, formatHint),
            unicodeRange: unicodeRange,
            fontStretch: fontStretch,
            fontStyle: fontStyle,
            fontVariant: fontVariant,
            fontWeight: fontWeight,
            fontDisplay: fontDisplay,
            fontVariationSettings: fontVariationSettings,
            fontFeatureSettings: fontFeatureSettings
        }
    };
    // Removes undefined fields for cleaner css object.
    return JSON.parse(JSON.stringify(fontFaceDeclaration));
}
/**
 * CSS to hide text to show a background image in a SEO-friendly way.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   'backgroundImage': 'url(logo.png)',
 *   ...hideText(),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   backgroundImage: url(logo.png);
 *   ${hideText()};
 * `
 *
 * // CSS as JS Output
 *
 * 'div': {
 *   'backgroundImage': 'url(logo.png)',
 *   'textIndent': '101%',
 *   'overflow': 'hidden',
 *   'whiteSpace': 'nowrap',
 * }
 */ function $c4f699b4a01e0372$export$27bef6389954e24d() {
    return {
        textIndent: '101%',
        overflow: 'hidden',
        whiteSpace: 'nowrap'
    };
}
/**
 * CSS to hide content visually but remain accessible to screen readers.
 * from [HTML5 Boilerplate](https://github.com/h5bp/html5-boilerplate/blob/9a176f57af1cfe8ec70300da4621fb9b07e5fa31/src/css/main.css#L121)
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...hideVisually(),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${hideVisually()};
 * `
 *
 * // CSS as JS Output
 *
 * 'div': {
 *   'border': '0',
 *   'clip': 'rect(0 0 0 0)',
 *   'height': '1px',
 *   'margin': '-1px',
 *   'overflow': 'hidden',
 *   'padding': '0',
 *   'position': 'absolute',
 *   'whiteSpace': 'nowrap',
 *   'width': '1px',
 * }
 */ function $c4f699b4a01e0372$export$36e2157ae4e3cbdd() {
    return {
        border: '0',
        clip: 'rect(0 0 0 0)',
        height: '1px',
        margin: '-1px',
        overflow: 'hidden',
        padding: '0',
        position: 'absolute',
        whiteSpace: 'nowrap',
        width: '1px'
    };
}
/**
 * Generates a media query to target HiDPI devices.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *  [hiDPI(1.5)]: {
 *    width: 200px;
 *  }
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${hiDPI(1.5)} {
 *     width: 200px;
 *   }
 * `
 *
 * // CSS as JS Output
 *
 * '@media only screen and (-webkit-min-device-pixel-ratio: 1.5),
 *  only screen and (min--moz-device-pixel-ratio: 1.5),
 *  only screen and (-o-min-device-pixel-ratio: 1.5/1),
 *  only screen and (min-resolution: 144dpi),
 *  only screen and (min-resolution: 1.5dppx)': {
 *   'width': '200px',
 * }
 */ function $c4f699b4a01e0372$export$e79006618d7c6cc3(ratio) {
    if (ratio === void 0) ratio = 1.3;
    return "\n    @media only screen and (-webkit-min-device-pixel-ratio: " + ratio + "),\n    only screen and (min--moz-device-pixel-ratio: " + ratio + "),\n    only screen and (-o-min-device-pixel-ratio: " + ratio + "/1),\n    only screen and (min-resolution: " + Math.round(ratio * 96) + "dpi),\n    only screen and (min-resolution: " + ratio + "dppx)\n  ";
}
function $c4f699b4a01e0372$var$constructGradientValue(literals) {
    var template = '';
    for(var _len = arguments.length, substitutions = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)substitutions[_key - 1] = arguments[_key];
    for(var i = 0; i < literals.length; i += 1){
        template += literals[i];
        if (i === substitutions.length - 1 && substitutions[i]) {
            var definedValues = substitutions.filter(function(substitute) {
                return !!substitute;
            });
            // Adds leading coma if properties preceed color-stops
            if (definedValues.length > 1) {
                template = template.slice(0, -1);
                template += ", " + substitutions[i];
            // No trailing space if color-stops is the only param provided
            } else if (definedValues.length === 1) template += "" + substitutions[i];
        } else if (substitutions[i]) template += substitutions[i] + " ";
    }
    return template.trim();
}
var $c4f699b4a01e0372$var$_templateObject$1;
/**
 * CSS for declaring a linear gradient, including a fallback background-color. The fallback is either the first color-stop or an explicitly passed fallback color.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...linearGradient({
        colorStops: ['#00FFFF 0%', 'rgba(0, 0, 255, 0) 50%', '#0000FF 95%'],
        toDirection: 'to top right',
        fallback: '#FFF',
      })
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${linearGradient({
        colorStops: ['#00FFFF 0%', 'rgba(0, 0, 255, 0) 50%', '#0000FF 95%'],
        toDirection: 'to top right',
        fallback: '#FFF',
      })}
 *`
 *
 * // CSS as JS Output
 *
 * div: {
 *   'backgroundColor': '#FFF',
 *   'backgroundImage': 'linear-gradient(to top right, #00FFFF 0%, rgba(0, 0, 255, 0) 50%, #0000FF 95%)',
 * }
 */ function $c4f699b4a01e0372$export$46def8197cf4dd4c(_ref) {
    var colorStops = _ref.colorStops, fallback = _ref.fallback, _ref$toDirection = _ref.toDirection, toDirection = _ref$toDirection === void 0 ? '' : _ref$toDirection;
    if (!colorStops || colorStops.length < 2) throw new $c4f699b4a01e0372$var$PolishedError(56);
    return {
        backgroundColor: fallback || colorStops[0].replace(/,\s+/g, ',').split(' ')[0].replace(/,(?=\S)/g, ', '),
        backgroundImage: $c4f699b4a01e0372$var$constructGradientValue($c4f699b4a01e0372$var$_templateObject$1 || ($c4f699b4a01e0372$var$_templateObject$1 = (0, $c5db23e5823ab236$export$2e2bcd8739ae039)([
            "linear-gradient(",
            "",
            ")"
        ])), toDirection, colorStops.join(', ').replace(/,(?=\S)/g, ', '))
    };
}
/**
 * CSS to normalize abnormalities across browsers (normalize.css v8.0.1 | MIT License | github.com/necolas/normalize.css)
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *    ...normalize(),
 * }
 *
 * // styled-components usage
 * const GlobalStyle = createGlobalStyle`${normalize()}`
 *
 * // CSS as JS Output
 *
 * html {
 *   lineHeight: 1.15,
 *   textSizeAdjust: 100%,
 * } ...
 */ function $c4f699b4a01e0372$export$a3295358bff77e() {
    var _ref;
    return [
        (_ref = {
            html: {
                lineHeight: '1.15',
                textSizeAdjust: '100%'
            },
            body: {
                margin: '0'
            },
            main: {
                display: 'block'
            },
            h1: {
                fontSize: '2em',
                margin: '0.67em 0'
            },
            hr: {
                boxSizing: 'content-box',
                height: '0',
                overflow: 'visible'
            },
            pre: {
                fontFamily: 'monospace, monospace',
                fontSize: '1em'
            },
            a: {
                backgroundColor: 'transparent'
            },
            'abbr[title]': {
                borderBottom: 'none',
                textDecoration: 'underline'
            }
        }, _ref["b,\n    strong"] = {
            fontWeight: 'bolder'
        }, _ref["code,\n    kbd,\n    samp"] = {
            fontFamily: 'monospace, monospace',
            fontSize: '1em'
        }, _ref.small = {
            fontSize: '80%'
        }, _ref["sub,\n    sup"] = {
            fontSize: '75%',
            lineHeight: '0',
            position: 'relative',
            verticalAlign: 'baseline'
        }, _ref.sub = {
            bottom: '-0.25em'
        }, _ref.sup = {
            top: '-0.5em'
        }, _ref.img = {
            borderStyle: 'none'
        }, _ref["button,\n    input,\n    optgroup,\n    select,\n    textarea"] = {
            fontFamily: 'inherit',
            fontSize: '100%',
            lineHeight: '1.15',
            margin: '0'
        }, _ref["button,\n    input"] = {
            overflow: 'visible'
        }, _ref["button,\n    select"] = {
            textTransform: 'none'
        }, _ref["button,\n    html [type=\"button\"],\n    [type=\"reset\"],\n    [type=\"submit\"]"] = {
            WebkitAppearance: 'button'
        }, _ref["button::-moz-focus-inner,\n    [type=\"button\"]::-moz-focus-inner,\n    [type=\"reset\"]::-moz-focus-inner,\n    [type=\"submit\"]::-moz-focus-inner"] = {
            borderStyle: 'none',
            padding: '0'
        }, _ref["button:-moz-focusring,\n    [type=\"button\"]:-moz-focusring,\n    [type=\"reset\"]:-moz-focusring,\n    [type=\"submit\"]:-moz-focusring"] = {
            outline: '1px dotted ButtonText'
        }, _ref.fieldset = {
            padding: '0.35em 0.625em 0.75em'
        }, _ref.legend = {
            boxSizing: 'border-box',
            color: 'inherit',
            display: 'table',
            maxWidth: '100%',
            padding: '0',
            whiteSpace: 'normal'
        }, _ref.progress = {
            verticalAlign: 'baseline'
        }, _ref.textarea = {
            overflow: 'auto'
        }, _ref["[type=\"checkbox\"],\n    [type=\"radio\"]"] = {
            boxSizing: 'border-box',
            padding: '0'
        }, _ref["[type=\"number\"]::-webkit-inner-spin-button,\n    [type=\"number\"]::-webkit-outer-spin-button"] = {
            height: 'auto'
        }, _ref['[type="search"]'] = {
            WebkitAppearance: 'textfield',
            outlineOffset: '-2px'
        }, _ref['[type="search"]::-webkit-search-decoration'] = {
            WebkitAppearance: 'none'
        }, _ref['::-webkit-file-upload-button'] = {
            WebkitAppearance: 'button',
            font: 'inherit'
        }, _ref.details = {
            display: 'block'
        }, _ref.summary = {
            display: 'list-item'
        }, _ref.template = {
            display: 'none'
        }, _ref['[hidden]'] = {
            display: 'none'
        }, _ref),
        {
            'abbr[title]': {
                textDecoration: 'underline dotted'
            }
        }
    ];
}
var $c4f699b4a01e0372$var$_templateObject;
/**
 * CSS for declaring a radial gradient, including a fallback background-color. The fallback is either the first color-stop or an explicitly passed fallback color.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...radialGradient({
 *     colorStops: ['#00FFFF 0%', 'rgba(0, 0, 255, 0) 50%', '#0000FF 95%'],
 *     extent: 'farthest-corner at 45px 45px',
 *     position: 'center',
 *     shape: 'ellipse',
 *   })
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${radialGradient({
 *     colorStops: ['#00FFFF 0%', 'rgba(0, 0, 255, 0) 50%', '#0000FF 95%'],
 *     extent: 'farthest-corner at 45px 45px',
 *     position: 'center',
 *     shape: 'ellipse',
 *   })}
 *`
 *
 * // CSS as JS Output
 *
 * div: {
 *   'backgroundColor': '#00FFFF',
 *   'backgroundImage': 'radial-gradient(center ellipse farthest-corner at 45px 45px, #00FFFF 0%, rgba(0, 0, 255, 0) 50%, #0000FF 95%)',
 * }
 */ function $c4f699b4a01e0372$export$3922d1ccb8631cd8(_ref) {
    var colorStops = _ref.colorStops, _ref$extent = _ref.extent, extent = _ref$extent === void 0 ? '' : _ref$extent, fallback = _ref.fallback, _ref$position = _ref.position, position = _ref$position === void 0 ? '' : _ref$position, _ref$shape = _ref.shape, shape = _ref$shape === void 0 ? '' : _ref$shape;
    if (!colorStops || colorStops.length < 2) throw new $c4f699b4a01e0372$var$PolishedError(57);
    return {
        backgroundColor: fallback || colorStops[0].split(' ')[0],
        backgroundImage: $c4f699b4a01e0372$var$constructGradientValue($c4f699b4a01e0372$var$_templateObject || ($c4f699b4a01e0372$var$_templateObject = (0, $c5db23e5823ab236$export$2e2bcd8739ae039)([
            "radial-gradient(",
            "",
            "",
            "",
            ")"
        ])), position, shape, extent, colorStops.join(', '))
    };
}
/**
 * A helper to generate a retina background image and non-retina
 * background image. The retina background image will output to a HiDPI media query. The mixin uses
 * a _2x.png filename suffix by default.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *  ...retinaImage('my-img')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${retinaImage('my-img')}
 * `
 *
 * // CSS as JS Output
 * div {
 *   backgroundImage: 'url(my-img.png)',
 *   '@media only screen and (-webkit-min-device-pixel-ratio: 1.3),
 *    only screen and (min--moz-device-pixel-ratio: 1.3),
 *    only screen and (-o-min-device-pixel-ratio: 1.3/1),
 *    only screen and (min-resolution: 144dpi),
 *    only screen and (min-resolution: 1.5dppx)': {
 *     backgroundImage: 'url(my-img_2x.png)',
 *   }
 * }
 */ function $c4f699b4a01e0372$export$19389033401d366a(filename, backgroundSize, extension, retinaFilename, retinaSuffix) {
    var _ref;
    if (extension === void 0) extension = 'png';
    if (retinaSuffix === void 0) retinaSuffix = '_2x';
    if (!filename) throw new $c4f699b4a01e0372$var$PolishedError(58);
    // Replace the dot at the beginning of the passed extension if one exists
    var ext = extension.replace(/^\./, '');
    var rFilename = retinaFilename ? retinaFilename + "." + ext : "" + filename + retinaSuffix + "." + ext;
    return _ref = {
        backgroundImage: "url(" + filename + "." + ext + ")"
    }, _ref[$c4f699b4a01e0372$export$e79006618d7c6cc3()] = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        backgroundImage: "url(" + rFilename + ")"
    }, backgroundSize ? {
        backgroundSize: backgroundSize
    } : {}), _ref;
}
/* eslint-disable key-spacing */ var $c4f699b4a01e0372$var$functionsMap = {
    easeInBack: 'cubic-bezier(0.600, -0.280, 0.735, 0.045)',
    easeInCirc: 'cubic-bezier(0.600,  0.040, 0.980, 0.335)',
    easeInCubic: 'cubic-bezier(0.550,  0.055, 0.675, 0.190)',
    easeInExpo: 'cubic-bezier(0.950,  0.050, 0.795, 0.035)',
    easeInQuad: 'cubic-bezier(0.550,  0.085, 0.680, 0.530)',
    easeInQuart: 'cubic-bezier(0.895,  0.030, 0.685, 0.220)',
    easeInQuint: 'cubic-bezier(0.755,  0.050, 0.855, 0.060)',
    easeInSine: 'cubic-bezier(0.470,  0.000, 0.745, 0.715)',
    easeOutBack: 'cubic-bezier(0.175,  0.885, 0.320, 1.275)',
    easeOutCubic: 'cubic-bezier(0.215,  0.610, 0.355, 1.000)',
    easeOutCirc: 'cubic-bezier(0.075,  0.820, 0.165, 1.000)',
    easeOutExpo: 'cubic-bezier(0.190,  1.000, 0.220, 1.000)',
    easeOutQuad: 'cubic-bezier(0.250,  0.460, 0.450, 0.940)',
    easeOutQuart: 'cubic-bezier(0.165,  0.840, 0.440, 1.000)',
    easeOutQuint: 'cubic-bezier(0.230,  1.000, 0.320, 1.000)',
    easeOutSine: 'cubic-bezier(0.390,  0.575, 0.565, 1.000)',
    easeInOutBack: 'cubic-bezier(0.680, -0.550, 0.265, 1.550)',
    easeInOutCirc: 'cubic-bezier(0.785,  0.135, 0.150, 0.860)',
    easeInOutCubic: 'cubic-bezier(0.645,  0.045, 0.355, 1.000)',
    easeInOutExpo: 'cubic-bezier(1.000,  0.000, 0.000, 1.000)',
    easeInOutQuad: 'cubic-bezier(0.455,  0.030, 0.515, 0.955)',
    easeInOutQuart: 'cubic-bezier(0.770,  0.000, 0.175, 1.000)',
    easeInOutQuint: 'cubic-bezier(0.860,  0.000, 0.070, 1.000)',
    easeInOutSine: 'cubic-bezier(0.445,  0.050, 0.550, 0.950)'
};
/* eslint-enable key-spacing */ function $c4f699b4a01e0372$var$getTimingFunction(functionName) {
    return $c4f699b4a01e0372$var$functionsMap[functionName];
}
/**
 * String to represent common easing functions as demonstrated here: (github.com/jaukia/easie).
 *
 * @deprecated - This will be deprecated in v5 in favor of `easeIn`, `easeOut`, `easeInOut`.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   'transitionTimingFunction': timingFunctions('easeInQuad')
 * }
 *
 * // styled-components usage
 *  const div = styled.div`
 *   transitionTimingFunction: ${timingFunctions('easeInQuad')};
 * `
 *
 * // CSS as JS Output
 *
 * 'div': {
 *   'transitionTimingFunction': 'cubic-bezier(0.550,  0.085, 0.680, 0.530)',
 * }
 */ function $c4f699b4a01e0372$export$61210fa83792a81(timingFunction) {
    return $c4f699b4a01e0372$var$getTimingFunction(timingFunction);
}
var $c4f699b4a01e0372$var$getBorderWidth = function getBorderWidth(pointingDirection, height, width) {
    var fullWidth = "" + width[0] + (width[1] || '');
    var halfWidth = "" + width[0] / 2 + (width[1] || '');
    var fullHeight = "" + height[0] + (height[1] || '');
    var halfHeight = "" + height[0] / 2 + (height[1] || '');
    switch(pointingDirection){
        case 'top':
            return "0 " + halfWidth + " " + fullHeight + " " + halfWidth;
        case 'topLeft':
            return fullWidth + " " + fullHeight + " 0 0";
        case 'left':
            return halfHeight + " " + fullWidth + " " + halfHeight + " 0";
        case 'bottomLeft':
            return fullWidth + " 0 0 " + fullHeight;
        case 'bottom':
            return fullHeight + " " + halfWidth + " 0 " + halfWidth;
        case 'bottomRight':
            return "0 0 " + fullWidth + " " + fullHeight;
        case 'right':
            return halfHeight + " 0 " + halfHeight + " " + fullWidth;
        case 'topRight':
        default:
            return "0 " + fullWidth + " " + fullHeight + " 0";
    }
};
var $c4f699b4a01e0372$var$getBorderColor = function getBorderColor(pointingDirection, foregroundColor) {
    switch(pointingDirection){
        case 'top':
        case 'bottomRight':
            return {
                borderBottomColor: foregroundColor
            };
        case 'right':
        case 'bottomLeft':
            return {
                borderLeftColor: foregroundColor
            };
        case 'bottom':
        case 'topLeft':
            return {
                borderTopColor: foregroundColor
            };
        case 'left':
        case 'topRight':
            return {
                borderRightColor: foregroundColor
            };
        default:
            throw new $c4f699b4a01e0372$var$PolishedError(59);
    }
};
/**
 * CSS to represent triangle with any pointing direction with an optional background color.
 *
 * @example
 * // Styles as object usage
 *
 * const styles = {
 *   ...triangle({ pointingDirection: 'right', width: '100px', height: '100px', foregroundColor: 'red' })
 * }
 *
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${triangle({ pointingDirection: 'right', width: '100px', height: '100px', foregroundColor: 'red' })}
 *
 *
 * // CSS as JS Output
 *
 * div: {
 *  'borderColor': 'transparent transparent transparent red',
 *  'borderStyle': 'solid',
 *  'borderWidth': '50px 0 50px 100px',
 *  'height': '0',
 *  'width': '0',
 * }
 */ function $c4f699b4a01e0372$export$9eed783d03e0135c(_ref) {
    var pointingDirection = _ref.pointingDirection, height = _ref.height, width = _ref.width, foregroundColor = _ref.foregroundColor, _ref$backgroundColor = _ref.backgroundColor, backgroundColor = _ref$backgroundColor === void 0 ? 'transparent' : _ref$backgroundColor;
    var widthAndUnit = $c4f699b4a01e0372$export$feec6b849ef388ab(width);
    var heightAndUnit = $c4f699b4a01e0372$export$feec6b849ef388ab(height);
    if (isNaN(heightAndUnit[0]) || isNaN(widthAndUnit[0])) throw new $c4f699b4a01e0372$var$PolishedError(60);
    return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        width: '0',
        height: '0',
        borderColor: backgroundColor
    }, $c4f699b4a01e0372$var$getBorderColor(pointingDirection, foregroundColor), {
        borderStyle: 'solid',
        borderWidth: $c4f699b4a01e0372$var$getBorderWidth(pointingDirection, heightAndUnit, widthAndUnit)
    });
}
/**
 * Provides an easy way to change the `wordWrap` property.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...wordWrap('break-word')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${wordWrap('break-word')}
 * `
 *
 * // CSS as JS Output
 *
 * const styles = {
 *   overflowWrap: 'break-word',
 *   wordWrap: 'break-word',
 *   wordBreak: 'break-all',
 * }
 */ function $c4f699b4a01e0372$export$dca3d8ad656c34d2(wrap) {
    if (wrap === void 0) wrap = 'break-word';
    var wordBreak = wrap === 'break-word' ? 'break-all' : wrap;
    return {
        overflowWrap: wrap,
        wordWrap: wrap,
        wordBreak: wordBreak
    };
}
function $c4f699b4a01e0372$var$colorToInt(color) {
    return Math.round(color * 255);
}
function $c4f699b4a01e0372$var$convertToInt(red, green, blue) {
    return $c4f699b4a01e0372$var$colorToInt(red) + "," + $c4f699b4a01e0372$var$colorToInt(green) + "," + $c4f699b4a01e0372$var$colorToInt(blue);
}
function $c4f699b4a01e0372$var$hslToRgb(hue, saturation, lightness, convert) {
    if (convert === void 0) convert = $c4f699b4a01e0372$var$convertToInt;
    if (saturation === 0) // achromatic
    return convert(lightness, lightness, lightness);
    // formulae from https://en.wikipedia.org/wiki/HSL_and_HSV
    var huePrime = (hue % 360 + 360) % 360 / 60;
    var chroma = (1 - Math.abs(2 * lightness - 1)) * saturation;
    var secondComponent = chroma * (1 - Math.abs(huePrime % 2 - 1));
    var red = 0;
    var green = 0;
    var blue = 0;
    if (huePrime >= 0 && huePrime < 1) {
        red = chroma;
        green = secondComponent;
    } else if (huePrime >= 1 && huePrime < 2) {
        red = secondComponent;
        green = chroma;
    } else if (huePrime >= 2 && huePrime < 3) {
        green = chroma;
        blue = secondComponent;
    } else if (huePrime >= 3 && huePrime < 4) {
        green = secondComponent;
        blue = chroma;
    } else if (huePrime >= 4 && huePrime < 5) {
        red = secondComponent;
        blue = chroma;
    } else if (huePrime >= 5 && huePrime < 6) {
        red = chroma;
        blue = secondComponent;
    }
    var lightnessModification = lightness - chroma / 2;
    var finalRed = red + lightnessModification;
    var finalGreen = green + lightnessModification;
    var finalBlue = blue + lightnessModification;
    return convert(finalRed, finalGreen, finalBlue);
}
var $c4f699b4a01e0372$var$namedColorMap = {
    aliceblue: 'f0f8ff',
    antiquewhite: 'faebd7',
    aqua: '00ffff',
    aquamarine: '7fffd4',
    azure: 'f0ffff',
    beige: 'f5f5dc',
    bisque: 'ffe4c4',
    black: '000',
    blanchedalmond: 'ffebcd',
    blue: '0000ff',
    blueviolet: '8a2be2',
    brown: 'a52a2a',
    burlywood: 'deb887',
    cadetblue: '5f9ea0',
    chartreuse: '7fff00',
    chocolate: 'd2691e',
    coral: 'ff7f50',
    cornflowerblue: '6495ed',
    cornsilk: 'fff8dc',
    crimson: 'dc143c',
    cyan: '00ffff',
    darkblue: '00008b',
    darkcyan: '008b8b',
    darkgoldenrod: 'b8860b',
    darkgray: 'a9a9a9',
    darkgreen: '006400',
    darkgrey: 'a9a9a9',
    darkkhaki: 'bdb76b',
    darkmagenta: '8b008b',
    darkolivegreen: '556b2f',
    darkorange: 'ff8c00',
    darkorchid: '9932cc',
    darkred: '8b0000',
    darksalmon: 'e9967a',
    darkseagreen: '8fbc8f',
    darkslateblue: '483d8b',
    darkslategray: '2f4f4f',
    darkslategrey: '2f4f4f',
    darkturquoise: '00ced1',
    darkviolet: '9400d3',
    deeppink: 'ff1493',
    deepskyblue: '00bfff',
    dimgray: '696969',
    dimgrey: '696969',
    dodgerblue: '1e90ff',
    firebrick: 'b22222',
    floralwhite: 'fffaf0',
    forestgreen: '228b22',
    fuchsia: 'ff00ff',
    gainsboro: 'dcdcdc',
    ghostwhite: 'f8f8ff',
    gold: 'ffd700',
    goldenrod: 'daa520',
    gray: '808080',
    green: '008000',
    greenyellow: 'adff2f',
    grey: '808080',
    honeydew: 'f0fff0',
    hotpink: 'ff69b4',
    indianred: 'cd5c5c',
    indigo: '4b0082',
    ivory: 'fffff0',
    khaki: 'f0e68c',
    lavender: 'e6e6fa',
    lavenderblush: 'fff0f5',
    lawngreen: '7cfc00',
    lemonchiffon: 'fffacd',
    lightblue: 'add8e6',
    lightcoral: 'f08080',
    lightcyan: 'e0ffff',
    lightgoldenrodyellow: 'fafad2',
    lightgray: 'd3d3d3',
    lightgreen: '90ee90',
    lightgrey: 'd3d3d3',
    lightpink: 'ffb6c1',
    lightsalmon: 'ffa07a',
    lightseagreen: '20b2aa',
    lightskyblue: '87cefa',
    lightslategray: '789',
    lightslategrey: '789',
    lightsteelblue: 'b0c4de',
    lightyellow: 'ffffe0',
    lime: '0f0',
    limegreen: '32cd32',
    linen: 'faf0e6',
    magenta: 'f0f',
    maroon: '800000',
    mediumaquamarine: '66cdaa',
    mediumblue: '0000cd',
    mediumorchid: 'ba55d3',
    mediumpurple: '9370db',
    mediumseagreen: '3cb371',
    mediumslateblue: '7b68ee',
    mediumspringgreen: '00fa9a',
    mediumturquoise: '48d1cc',
    mediumvioletred: 'c71585',
    midnightblue: '191970',
    mintcream: 'f5fffa',
    mistyrose: 'ffe4e1',
    moccasin: 'ffe4b5',
    navajowhite: 'ffdead',
    navy: '000080',
    oldlace: 'fdf5e6',
    olive: '808000',
    olivedrab: '6b8e23',
    orange: 'ffa500',
    orangered: 'ff4500',
    orchid: 'da70d6',
    palegoldenrod: 'eee8aa',
    palegreen: '98fb98',
    paleturquoise: 'afeeee',
    palevioletred: 'db7093',
    papayawhip: 'ffefd5',
    peachpuff: 'ffdab9',
    peru: 'cd853f',
    pink: 'ffc0cb',
    plum: 'dda0dd',
    powderblue: 'b0e0e6',
    purple: '800080',
    rebeccapurple: '639',
    red: 'f00',
    rosybrown: 'bc8f8f',
    royalblue: '4169e1',
    saddlebrown: '8b4513',
    salmon: 'fa8072',
    sandybrown: 'f4a460',
    seagreen: '2e8b57',
    seashell: 'fff5ee',
    sienna: 'a0522d',
    silver: 'c0c0c0',
    skyblue: '87ceeb',
    slateblue: '6a5acd',
    slategray: '708090',
    slategrey: '708090',
    snow: 'fffafa',
    springgreen: '00ff7f',
    steelblue: '4682b4',
    tan: 'd2b48c',
    teal: '008080',
    thistle: 'd8bfd8',
    tomato: 'ff6347',
    turquoise: '40e0d0',
    violet: 'ee82ee',
    wheat: 'f5deb3',
    white: 'fff',
    whitesmoke: 'f5f5f5',
    yellow: 'ff0',
    yellowgreen: '9acd32'
};
/**
 * Checks if a string is a CSS named color and returns its equivalent hex value, otherwise returns the original color.
 * @private
 */ function $c4f699b4a01e0372$var$nameToHex(color) {
    if (typeof color !== 'string') return color;
    var normalizedColorName = color.toLowerCase();
    return $c4f699b4a01e0372$var$namedColorMap[normalizedColorName] ? "#" + $c4f699b4a01e0372$var$namedColorMap[normalizedColorName] : color;
}
var $c4f699b4a01e0372$var$hexRegex = /^#[a-fA-F0-9]{6}$/;
var $c4f699b4a01e0372$var$hexRgbaRegex = /^#[a-fA-F0-9]{8}$/;
var $c4f699b4a01e0372$var$reducedHexRegex = /^#[a-fA-F0-9]{3}$/;
var $c4f699b4a01e0372$var$reducedRgbaHexRegex = /^#[a-fA-F0-9]{4}$/;
var $c4f699b4a01e0372$var$rgbRegex = /^rgb\(\s*(\d{1,3})\s*(?:,)?\s*(\d{1,3})\s*(?:,)?\s*(\d{1,3})\s*\)$/i;
var $c4f699b4a01e0372$var$rgbaRegex = /^rgb(?:a)?\(\s*(\d{1,3})\s*(?:,)?\s*(\d{1,3})\s*(?:,)?\s*(\d{1,3})\s*(?:,|\/)\s*([-+]?\d*[.]?\d+[%]?)\s*\)$/i;
var $c4f699b4a01e0372$var$hslRegex = /^hsl\(\s*(\d{0,3}[.]?[0-9]+(?:deg)?)\s*(?:,)?\s*(\d{1,3}[.]?[0-9]?)%\s*(?:,)?\s*(\d{1,3}[.]?[0-9]?)%\s*\)$/i;
var $c4f699b4a01e0372$var$hslaRegex = /^hsl(?:a)?\(\s*(\d{0,3}[.]?[0-9]+(?:deg)?)\s*(?:,)?\s*(\d{1,3}[.]?[0-9]?)%\s*(?:,)?\s*(\d{1,3}[.]?[0-9]?)%\s*(?:,|\/)\s*([-+]?\d*[.]?\d+[%]?)\s*\)$/i;
/**
 * Returns an RgbColor or RgbaColor object. This utility function is only useful
 * if want to extract a color component. With the color util `toColorString` you
 * can convert a RgbColor or RgbaColor object back to a string.
 *
 * @example
 * // Assigns `{ red: 255, green: 0, blue: 0 }` to color1
 * const color1 = parseToRgb('rgb(255, 0, 0)');
 * // Assigns `{ red: 92, green: 102, blue: 112, alpha: 0.75 }` to color2
 * const color2 = parseToRgb('hsla(210, 10%, 40%, 0.75)');
 */ function $c4f699b4a01e0372$export$2f48baff6995707a(color) {
    if (typeof color !== 'string') throw new $c4f699b4a01e0372$var$PolishedError(3);
    var normalizedColor = $c4f699b4a01e0372$var$nameToHex(color);
    if (normalizedColor.match($c4f699b4a01e0372$var$hexRegex)) return {
        red: parseInt("" + normalizedColor[1] + normalizedColor[2], 16),
        green: parseInt("" + normalizedColor[3] + normalizedColor[4], 16),
        blue: parseInt("" + normalizedColor[5] + normalizedColor[6], 16)
    };
    if (normalizedColor.match($c4f699b4a01e0372$var$hexRgbaRegex)) {
        var alpha = parseFloat((parseInt("" + normalizedColor[7] + normalizedColor[8], 16) / 255).toFixed(2));
        return {
            red: parseInt("" + normalizedColor[1] + normalizedColor[2], 16),
            green: parseInt("" + normalizedColor[3] + normalizedColor[4], 16),
            blue: parseInt("" + normalizedColor[5] + normalizedColor[6], 16),
            alpha: alpha
        };
    }
    if (normalizedColor.match($c4f699b4a01e0372$var$reducedHexRegex)) return {
        red: parseInt("" + normalizedColor[1] + normalizedColor[1], 16),
        green: parseInt("" + normalizedColor[2] + normalizedColor[2], 16),
        blue: parseInt("" + normalizedColor[3] + normalizedColor[3], 16)
    };
    if (normalizedColor.match($c4f699b4a01e0372$var$reducedRgbaHexRegex)) {
        var _alpha = parseFloat((parseInt("" + normalizedColor[4] + normalizedColor[4], 16) / 255).toFixed(2));
        return {
            red: parseInt("" + normalizedColor[1] + normalizedColor[1], 16),
            green: parseInt("" + normalizedColor[2] + normalizedColor[2], 16),
            blue: parseInt("" + normalizedColor[3] + normalizedColor[3], 16),
            alpha: _alpha
        };
    }
    var rgbMatched = $c4f699b4a01e0372$var$rgbRegex.exec(normalizedColor);
    if (rgbMatched) return {
        red: parseInt("" + rgbMatched[1], 10),
        green: parseInt("" + rgbMatched[2], 10),
        blue: parseInt("" + rgbMatched[3], 10)
    };
    var rgbaMatched = $c4f699b4a01e0372$var$rgbaRegex.exec(normalizedColor.substring(0, 50));
    if (rgbaMatched) return {
        red: parseInt("" + rgbaMatched[1], 10),
        green: parseInt("" + rgbaMatched[2], 10),
        blue: parseInt("" + rgbaMatched[3], 10),
        alpha: parseFloat("" + rgbaMatched[4]) > 1 ? parseFloat("" + rgbaMatched[4]) / 100 : parseFloat("" + rgbaMatched[4])
    };
    var hslMatched = $c4f699b4a01e0372$var$hslRegex.exec(normalizedColor);
    if (hslMatched) {
        var hue = parseInt("" + hslMatched[1], 10);
        var saturation = parseInt("" + hslMatched[2], 10) / 100;
        var lightness = parseInt("" + hslMatched[3], 10) / 100;
        var rgbColorString = "rgb(" + $c4f699b4a01e0372$var$hslToRgb(hue, saturation, lightness) + ")";
        var hslRgbMatched = $c4f699b4a01e0372$var$rgbRegex.exec(rgbColorString);
        if (!hslRgbMatched) throw new $c4f699b4a01e0372$var$PolishedError(4, normalizedColor, rgbColorString);
        return {
            red: parseInt("" + hslRgbMatched[1], 10),
            green: parseInt("" + hslRgbMatched[2], 10),
            blue: parseInt("" + hslRgbMatched[3], 10)
        };
    }
    var hslaMatched = $c4f699b4a01e0372$var$hslaRegex.exec(normalizedColor.substring(0, 50));
    if (hslaMatched) {
        var _hue = parseInt("" + hslaMatched[1], 10);
        var _saturation = parseInt("" + hslaMatched[2], 10) / 100;
        var _lightness = parseInt("" + hslaMatched[3], 10) / 100;
        var _rgbColorString = "rgb(" + $c4f699b4a01e0372$var$hslToRgb(_hue, _saturation, _lightness) + ")";
        var _hslRgbMatched = $c4f699b4a01e0372$var$rgbRegex.exec(_rgbColorString);
        if (!_hslRgbMatched) throw new $c4f699b4a01e0372$var$PolishedError(4, normalizedColor, _rgbColorString);
        return {
            red: parseInt("" + _hslRgbMatched[1], 10),
            green: parseInt("" + _hslRgbMatched[2], 10),
            blue: parseInt("" + _hslRgbMatched[3], 10),
            alpha: parseFloat("" + hslaMatched[4]) > 1 ? parseFloat("" + hslaMatched[4]) / 100 : parseFloat("" + hslaMatched[4])
        };
    }
    throw new $c4f699b4a01e0372$var$PolishedError(5);
}
function $c4f699b4a01e0372$var$rgbToHsl(color) {
    // make sure rgb are contained in a set of [0, 255]
    var red = color.red / 255;
    var green = color.green / 255;
    var blue = color.blue / 255;
    var max = Math.max(red, green, blue);
    var min = Math.min(red, green, blue);
    var lightness = (max + min) / 2;
    if (max === min) {
        // achromatic
        if (color.alpha !== undefined) return {
            hue: 0,
            saturation: 0,
            lightness: lightness,
            alpha: color.alpha
        };
        else return {
            hue: 0,
            saturation: 0,
            lightness: lightness
        };
    }
    var hue;
    var delta = max - min;
    var saturation = lightness > 0.5 ? delta / (2 - max - min) : delta / (max + min);
    switch(max){
        case red:
            hue = (green - blue) / delta + (green < blue ? 6 : 0);
            break;
        case green:
            hue = (blue - red) / delta + 2;
            break;
        default:
            // blue case
            hue = (red - green) / delta + 4;
            break;
    }
    hue *= 60;
    if (color.alpha !== undefined) return {
        hue: hue,
        saturation: saturation,
        lightness: lightness,
        alpha: color.alpha
    };
    return {
        hue: hue,
        saturation: saturation,
        lightness: lightness
    };
}
/**
 * Returns an HslColor or HslaColor object. This utility function is only useful
 * if want to extract a color component. With the color util `toColorString` you
 * can convert a HslColor or HslaColor object back to a string.
 *
 * @example
 * // Assigns `{ hue: 0, saturation: 1, lightness: 0.5 }` to color1
 * const color1 = parseToHsl('rgb(255, 0, 0)');
 * // Assigns `{ hue: 128, saturation: 1, lightness: 0.5, alpha: 0.75 }` to color2
 * const color2 = parseToHsl('hsla(128, 100%, 50%, 0.75)');
 */ function $c4f699b4a01e0372$export$1286688e1b3fde9c(color) {
    // Note: At a later stage we can optimize this function as right now a hsl
    // color would be parsed converted to rgb values and converted back to hsl.
    return $c4f699b4a01e0372$var$rgbToHsl($c4f699b4a01e0372$export$2f48baff6995707a(color));
}
/**
 * Reduces hex values if possible e.g. #ff8866 to #f86
 * @private
 */ var $c4f699b4a01e0372$var$reduceHexValue = function reduceHexValue(value) {
    if (value.length === 7 && value[1] === value[2] && value[3] === value[4] && value[5] === value[6]) return "#" + value[1] + value[3] + value[5];
    return value;
};
var $c4f699b4a01e0372$var$reduceHexValue$1 = $c4f699b4a01e0372$var$reduceHexValue;
function $c4f699b4a01e0372$var$numberToHex(value) {
    var hex = value.toString(16);
    return hex.length === 1 ? "0" + hex : hex;
}
function $c4f699b4a01e0372$var$colorToHex(color) {
    return $c4f699b4a01e0372$var$numberToHex(Math.round(color * 255));
}
function $c4f699b4a01e0372$var$convertToHex(red, green, blue) {
    return $c4f699b4a01e0372$var$reduceHexValue$1("#" + $c4f699b4a01e0372$var$colorToHex(red) + $c4f699b4a01e0372$var$colorToHex(green) + $c4f699b4a01e0372$var$colorToHex(blue));
}
function $c4f699b4a01e0372$var$hslToHex(hue, saturation, lightness) {
    return $c4f699b4a01e0372$var$hslToRgb(hue, saturation, lightness, $c4f699b4a01e0372$var$convertToHex);
}
/**
 * Returns a string value for the color. The returned result is the smallest possible hex notation.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: hsl(359, 0.75, 0.4),
 *   background: hsl({ hue: 360, saturation: 0.75, lightness: 0.4 }),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${hsl(359, 0.75, 0.4)};
 *   background: ${hsl({ hue: 360, saturation: 0.75, lightness: 0.4 })};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#b3191c";
 *   background: "#b3191c";
 * }
 */ function $c4f699b4a01e0372$export$8f4a7c0bb78e6ea8(value, saturation, lightness) {
    if (typeof value === 'number' && typeof saturation === 'number' && typeof lightness === 'number') return $c4f699b4a01e0372$var$hslToHex(value, saturation, lightness);
    else if (typeof value === 'object' && saturation === undefined && lightness === undefined) return $c4f699b4a01e0372$var$hslToHex(value.hue, value.saturation, value.lightness);
    throw new $c4f699b4a01e0372$var$PolishedError(1);
}
/**
 * Returns a string value for the color. The returned result is the smallest possible rgba or hex notation.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: hsla(359, 0.75, 0.4, 0.7),
 *   background: hsla({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0,7 }),
 *   background: hsla(359, 0.75, 0.4, 1),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${hsla(359, 0.75, 0.4, 0.7)};
 *   background: ${hsla({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0,7 })};
 *   background: ${hsla(359, 0.75, 0.4, 1)};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "rgba(179,25,28,0.7)";
 *   background: "rgba(179,25,28,0.7)";
 *   background: "#b3191c";
 * }
 */ function $c4f699b4a01e0372$export$810b04175080204c(value, saturation, lightness, alpha) {
    if (typeof value === 'number' && typeof saturation === 'number' && typeof lightness === 'number' && typeof alpha === 'number') return alpha >= 1 ? $c4f699b4a01e0372$var$hslToHex(value, saturation, lightness) : "rgba(" + $c4f699b4a01e0372$var$hslToRgb(value, saturation, lightness) + "," + alpha + ")";
    else if (typeof value === 'object' && saturation === undefined && lightness === undefined && alpha === undefined) return value.alpha >= 1 ? $c4f699b4a01e0372$var$hslToHex(value.hue, value.saturation, value.lightness) : "rgba(" + $c4f699b4a01e0372$var$hslToRgb(value.hue, value.saturation, value.lightness) + "," + value.alpha + ")";
    throw new $c4f699b4a01e0372$var$PolishedError(2);
}
/**
 * Returns a string value for the color. The returned result is the smallest possible hex notation.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: rgb(255, 205, 100),
 *   background: rgb({ red: 255, green: 205, blue: 100 }),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${rgb(255, 205, 100)};
 *   background: ${rgb({ red: 255, green: 205, blue: 100 })};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#ffcd64";
 *   background: "#ffcd64";
 * }
 */ function $c4f699b4a01e0372$export$8972dc0e6ad9238f(value, green, blue) {
    if (typeof value === 'number' && typeof green === 'number' && typeof blue === 'number') return $c4f699b4a01e0372$var$reduceHexValue$1("#" + $c4f699b4a01e0372$var$numberToHex(value) + $c4f699b4a01e0372$var$numberToHex(green) + $c4f699b4a01e0372$var$numberToHex(blue));
    else if (typeof value === 'object' && green === undefined && blue === undefined) return $c4f699b4a01e0372$var$reduceHexValue$1("#" + $c4f699b4a01e0372$var$numberToHex(value.red) + $c4f699b4a01e0372$var$numberToHex(value.green) + $c4f699b4a01e0372$var$numberToHex(value.blue));
    throw new $c4f699b4a01e0372$var$PolishedError(6);
}
/**
 * Returns a string value for the color. The returned result is the smallest possible rgba or hex notation.
 *
 * Can also be used to fade a color by passing a hex value or named CSS color along with an alpha value.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: rgba(255, 205, 100, 0.7),
 *   background: rgba({ red: 255, green: 205, blue: 100, alpha: 0.7 }),
 *   background: rgba(255, 205, 100, 1),
 *   background: rgba('#ffffff', 0.4),
 *   background: rgba('black', 0.7),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${rgba(255, 205, 100, 0.7)};
 *   background: ${rgba({ red: 255, green: 205, blue: 100, alpha: 0.7 })};
 *   background: ${rgba(255, 205, 100, 1)};
 *   background: ${rgba('#ffffff', 0.4)};
 *   background: ${rgba('black', 0.7)};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "rgba(255,205,100,0.7)";
 *   background: "rgba(255,205,100,0.7)";
 *   background: "#ffcd64";
 *   background: "rgba(255,255,255,0.4)";
 *   background: "rgba(0,0,0,0.7)";
 * }
 */ function $c4f699b4a01e0372$export$4e46ac54fc82cf3b(firstValue, secondValue, thirdValue, fourthValue) {
    if (typeof firstValue === 'string' && typeof secondValue === 'number') {
        var rgbValue = $c4f699b4a01e0372$export$2f48baff6995707a(firstValue);
        return "rgba(" + rgbValue.red + "," + rgbValue.green + "," + rgbValue.blue + "," + secondValue + ")";
    } else if (typeof firstValue === 'number' && typeof secondValue === 'number' && typeof thirdValue === 'number' && typeof fourthValue === 'number') return fourthValue >= 1 ? $c4f699b4a01e0372$export$8972dc0e6ad9238f(firstValue, secondValue, thirdValue) : "rgba(" + firstValue + "," + secondValue + "," + thirdValue + "," + fourthValue + ")";
    else if (typeof firstValue === 'object' && secondValue === undefined && thirdValue === undefined && fourthValue === undefined) return firstValue.alpha >= 1 ? $c4f699b4a01e0372$export$8972dc0e6ad9238f(firstValue.red, firstValue.green, firstValue.blue) : "rgba(" + firstValue.red + "," + firstValue.green + "," + firstValue.blue + "," + firstValue.alpha + ")";
    throw new $c4f699b4a01e0372$var$PolishedError(7);
}
var $c4f699b4a01e0372$var$isRgb = function isRgb(color) {
    return typeof color.red === 'number' && typeof color.green === 'number' && typeof color.blue === 'number' && (typeof color.alpha !== 'number' || typeof color.alpha === 'undefined');
};
var $c4f699b4a01e0372$var$isRgba = function isRgba(color) {
    return typeof color.red === 'number' && typeof color.green === 'number' && typeof color.blue === 'number' && typeof color.alpha === 'number';
};
var $c4f699b4a01e0372$var$isHsl = function isHsl(color) {
    return typeof color.hue === 'number' && typeof color.saturation === 'number' && typeof color.lightness === 'number' && (typeof color.alpha !== 'number' || typeof color.alpha === 'undefined');
};
var $c4f699b4a01e0372$var$isHsla = function isHsla(color) {
    return typeof color.hue === 'number' && typeof color.saturation === 'number' && typeof color.lightness === 'number' && typeof color.alpha === 'number';
};
/**
 * Converts a RgbColor, RgbaColor, HslColor or HslaColor object to a color string.
 * This util is useful in case you only know on runtime which color object is
 * used. Otherwise we recommend to rely on `rgb`, `rgba`, `hsl` or `hsla`.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: toColorString({ red: 255, green: 205, blue: 100 }),
 *   background: toColorString({ red: 255, green: 205, blue: 100, alpha: 0.72 }),
 *   background: toColorString({ hue: 240, saturation: 1, lightness: 0.5 }),
 *   background: toColorString({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0.72 }),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${toColorString({ red: 255, green: 205, blue: 100 })};
 *   background: ${toColorString({ red: 255, green: 205, blue: 100, alpha: 0.72 })};
 *   background: ${toColorString({ hue: 240, saturation: 1, lightness: 0.5 })};
 *   background: ${toColorString({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0.72 })};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#ffcd64";
 *   background: "rgba(255,205,100,0.72)";
 *   background: "#00f";
 *   background: "rgba(179,25,25,0.72)";
 * }
 */ function $c4f699b4a01e0372$export$42fe740cdf79b2df(color) {
    if (typeof color !== 'object') throw new $c4f699b4a01e0372$var$PolishedError(8);
    if ($c4f699b4a01e0372$var$isRgba(color)) return $c4f699b4a01e0372$export$4e46ac54fc82cf3b(color);
    if ($c4f699b4a01e0372$var$isRgb(color)) return $c4f699b4a01e0372$export$8972dc0e6ad9238f(color);
    if ($c4f699b4a01e0372$var$isHsla(color)) return $c4f699b4a01e0372$export$810b04175080204c(color);
    if ($c4f699b4a01e0372$var$isHsl(color)) return $c4f699b4a01e0372$export$8f4a7c0bb78e6ea8(color);
    throw new $c4f699b4a01e0372$var$PolishedError(8);
}
// Type definitions taken from https://github.com/gcanti/flow-static-land/blob/master/src/Fun.js
// eslint-disable-next-line no-unused-vars
// eslint-disable-next-line no-unused-vars
// eslint-disable-next-line no-redeclare
function $c4f699b4a01e0372$var$curried(f, length, acc) {
    return function fn() {
        // eslint-disable-next-line prefer-rest-params
        var combined = acc.concat(Array.prototype.slice.call(arguments));
        return combined.length >= length ? f.apply(this, combined) : $c4f699b4a01e0372$var$curried(f, length, combined);
    };
}
// eslint-disable-next-line no-redeclare
function $c4f699b4a01e0372$var$curry(f) {
    // eslint-disable-line no-redeclare
    return $c4f699b4a01e0372$var$curried(f, f.length, []);
}
/**
 * Changes the hue of the color. Hue is a number between 0 to 360. The first
 * argument for adjustHue is the amount of degrees the color is rotated around
 * the color wheel, always producing a positive hue value.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: adjustHue(180, '#448'),
 *   background: adjustHue('180', 'rgba(101,100,205,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${adjustHue(180, '#448')};
 *   background: ${adjustHue('180', 'rgba(101,100,205,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#888844";
 *   background: "rgba(136,136,68,0.7)";
 * }
 */ function $c4f699b4a01e0372$var$adjustHue(degree, color) {
    if (color === 'transparent') return color;
    var hslColor = $c4f699b4a01e0372$export$1286688e1b3fde9c(color);
    return $c4f699b4a01e0372$export$42fe740cdf79b2df((0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, hslColor, {
        hue: hslColor.hue + parseFloat(degree)
    }));
}
// prettier-ignore
var $c4f699b4a01e0372$var$curriedAdjustHue = $c4f699b4a01e0372$var$curry /* ::<number | string, string, string> */ ($c4f699b4a01e0372$var$adjustHue);
var $c4f699b4a01e0372$export$2b372a09365374d6 = $c4f699b4a01e0372$var$curriedAdjustHue;
/**
 * Returns the complement of the provided color. This is identical to adjustHue(180, <color>).
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: complement('#448'),
 *   background: complement('rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${complement('#448')};
 *   background: ${complement('rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#884";
 *   background: "rgba(153,153,153,0.7)";
 * }
 */ function $c4f699b4a01e0372$export$bd4f6f7e1823bc9e(color) {
    if (color === 'transparent') return color;
    var hslColor = $c4f699b4a01e0372$export$1286688e1b3fde9c(color);
    return $c4f699b4a01e0372$export$42fe740cdf79b2df((0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, hslColor, {
        hue: (hslColor.hue + 180) % 360
    }));
}
function $c4f699b4a01e0372$var$guard(lowerBoundary, upperBoundary, value) {
    return Math.max(lowerBoundary, Math.min(upperBoundary, value));
}
/**
 * Returns a string value for the darkened color.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: darken(0.2, '#FFCD64'),
 *   background: darken('0.2', 'rgba(255,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${darken(0.2, '#FFCD64')};
 *   background: ${darken('0.2', 'rgba(255,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#ffbd31";
 *   background: "rgba(255,189,49,0.7)";
 * }
 */ function $c4f699b4a01e0372$var$darken(amount, color) {
    if (color === 'transparent') return color;
    var hslColor = $c4f699b4a01e0372$export$1286688e1b3fde9c(color);
    return $c4f699b4a01e0372$export$42fe740cdf79b2df((0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, hslColor, {
        lightness: $c4f699b4a01e0372$var$guard(0, 1, hslColor.lightness - parseFloat(amount))
    }));
}
// prettier-ignore
var $c4f699b4a01e0372$var$curriedDarken = $c4f699b4a01e0372$var$curry /* ::<number | string, string, string> */ ($c4f699b4a01e0372$var$darken);
var $c4f699b4a01e0372$export$4b073707ff63303 = $c4f699b4a01e0372$var$curriedDarken;
/**
 * Decreases the intensity of a color. Its range is between 0 to 1. The first
 * argument of the desaturate function is the amount by how much the color
 * intensity should be decreased.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: desaturate(0.2, '#CCCD64'),
 *   background: desaturate('0.2', 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${desaturate(0.2, '#CCCD64')};
 *   background: ${desaturate('0.2', 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#b8b979";
 *   background: "rgba(184,185,121,0.7)";
 * }
 */ function $c4f699b4a01e0372$var$desaturate(amount, color) {
    if (color === 'transparent') return color;
    var hslColor = $c4f699b4a01e0372$export$1286688e1b3fde9c(color);
    return $c4f699b4a01e0372$export$42fe740cdf79b2df((0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, hslColor, {
        saturation: $c4f699b4a01e0372$var$guard(0, 1, hslColor.saturation - parseFloat(amount))
    }));
}
// prettier-ignore
var $c4f699b4a01e0372$var$curriedDesaturate = $c4f699b4a01e0372$var$curry /* ::<number | string, string, string> */ ($c4f699b4a01e0372$var$desaturate);
var $c4f699b4a01e0372$export$fb75607d98509d9 = $c4f699b4a01e0372$var$curriedDesaturate;
/**
 * Returns a number (float) representing the luminance of a color.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: getLuminance('#CCCD64') >= getLuminance('#0000ff') ? '#CCCD64' : '#0000ff',
 *   background: getLuminance('rgba(58, 133, 255, 1)') >= getLuminance('rgba(255, 57, 149, 1)') ?
 *                             'rgba(58, 133, 255, 1)' :
 *                             'rgba(255, 57, 149, 1)',
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${getLuminance('#CCCD64') >= getLuminance('#0000ff') ? '#CCCD64' : '#0000ff'};
 *   background: ${getLuminance('rgba(58, 133, 255, 1)') >= getLuminance('rgba(255, 57, 149, 1)') ?
 *                             'rgba(58, 133, 255, 1)' :
 *                             'rgba(255, 57, 149, 1)'};
 *
 * // CSS in JS Output
 *
 * div {
 *   background: "#CCCD64";
 *   background: "rgba(58, 133, 255, 1)";
 * }
 */ function $c4f699b4a01e0372$export$c852d90bf7403b62(color) {
    if (color === 'transparent') return 0;
    var rgbColor = $c4f699b4a01e0372$export$2f48baff6995707a(color);
    var _Object$keys$map = Object.keys(rgbColor).map(function(key) {
        var channel = rgbColor[key] / 255;
        return channel <= 0.03928 ? channel / 12.92 : Math.pow((channel + 0.055) / 1.055, 2.4);
    }), r = _Object$keys$map[0], g = _Object$keys$map[1], b = _Object$keys$map[2];
    return parseFloat((0.2126 * r + 0.7152 * g + 0.0722 * b).toFixed(3));
}
/**
 * Returns the contrast ratio between two colors based on
 * [W3's recommended equation for calculating contrast](http://www.w3.org/TR/WCAG20/#contrast-ratiodef).
 *
 * @example
 * const contrastRatio = getContrast('#444', '#fff');
 */ function $c4f699b4a01e0372$export$850ce485a60d103b(color1, color2) {
    var luminance1 = $c4f699b4a01e0372$export$c852d90bf7403b62(color1);
    var luminance2 = $c4f699b4a01e0372$export$c852d90bf7403b62(color2);
    return parseFloat((luminance1 > luminance2 ? (luminance1 + 0.05) / (luminance2 + 0.05) : (luminance2 + 0.05) / (luminance1 + 0.05)).toFixed(2));
}
/**
 * Converts the color to a grayscale, by reducing its saturation to 0.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: grayscale('#CCCD64'),
 *   background: grayscale('rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${grayscale('#CCCD64')};
 *   background: ${grayscale('rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#999";
 *   background: "rgba(153,153,153,0.7)";
 * }
 */ function $c4f699b4a01e0372$export$6f416a6db2dfcd5c(color) {
    if (color === 'transparent') return color;
    return $c4f699b4a01e0372$export$42fe740cdf79b2df((0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, $c4f699b4a01e0372$export$1286688e1b3fde9c(color), {
        saturation: 0
    }));
}
/**
 * Converts a HslColor or HslaColor object to a color string.
 * This util is useful in case you only know on runtime which color object is
 * used. Otherwise we recommend to rely on `hsl` or `hsla`.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: hslToColorString({ hue: 240, saturation: 1, lightness: 0.5 }),
 *   background: hslToColorString({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0.72 }),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${hslToColorString({ hue: 240, saturation: 1, lightness: 0.5 })};
 *   background: ${hslToColorString({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0.72 })};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#00f";
 *   background: "rgba(179,25,25,0.72)";
 * }
 */ function $c4f699b4a01e0372$export$97fc773b219a4ae(color) {
    if (typeof color === 'object' && typeof color.hue === 'number' && typeof color.saturation === 'number' && typeof color.lightness === 'number') {
        if (color.alpha && typeof color.alpha === 'number') return $c4f699b4a01e0372$export$810b04175080204c({
            hue: color.hue,
            saturation: color.saturation,
            lightness: color.lightness,
            alpha: color.alpha
        });
        return $c4f699b4a01e0372$export$8f4a7c0bb78e6ea8({
            hue: color.hue,
            saturation: color.saturation,
            lightness: color.lightness
        });
    }
    throw new $c4f699b4a01e0372$var$PolishedError(45);
}
/**
 * Inverts the red, green and blue values of a color.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: invert('#CCCD64'),
 *   background: invert('rgba(101,100,205,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${invert('#CCCD64')};
 *   background: ${invert('rgba(101,100,205,0.7)')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#33329b";
 *   background: "rgba(154,155,50,0.7)";
 * }
 */ function $c4f699b4a01e0372$export$6897c284b6f9f4dc(color) {
    if (color === 'transparent') return color;
    // parse color string to rgb
    var value = $c4f699b4a01e0372$export$2f48baff6995707a(color);
    return $c4f699b4a01e0372$export$42fe740cdf79b2df((0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, value, {
        red: 255 - value.red,
        green: 255 - value.green,
        blue: 255 - value.blue
    }));
}
/**
 * Returns a string value for the lightened color.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: lighten(0.2, '#CCCD64'),
 *   background: lighten('0.2', 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${lighten(0.2, '#FFCD64')};
 *   background: ${lighten('0.2', 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#e5e6b1";
 *   background: "rgba(229,230,177,0.7)";
 * }
 */ function $c4f699b4a01e0372$var$lighten(amount, color) {
    if (color === 'transparent') return color;
    var hslColor = $c4f699b4a01e0372$export$1286688e1b3fde9c(color);
    return $c4f699b4a01e0372$export$42fe740cdf79b2df((0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, hslColor, {
        lightness: $c4f699b4a01e0372$var$guard(0, 1, hslColor.lightness + parseFloat(amount))
    }));
}
// prettier-ignore
var $c4f699b4a01e0372$var$curriedLighten = $c4f699b4a01e0372$var$curry /* ::<number | string, string, string> */ ($c4f699b4a01e0372$var$lighten);
var $c4f699b4a01e0372$export$c0816ed86df316af = $c4f699b4a01e0372$var$curriedLighten;
/**
 * Determines which contrast guidelines have been met for two colors.
 * Based on the [contrast calculations recommended by W3](https://www.w3.org/WAI/WCAG21/Understanding/contrast-enhanced.html).
 *
 * @example
 * const scores = meetsContrastGuidelines('#444', '#fff');
 */ function $c4f699b4a01e0372$export$bc0d548020bc5a2(color1, color2) {
    var contrastRatio = $c4f699b4a01e0372$export$850ce485a60d103b(color1, color2);
    return {
        AA: contrastRatio >= 4.5,
        AALarge: contrastRatio >= 3,
        AAA: contrastRatio >= 7,
        AAALarge: contrastRatio >= 4.5
    };
}
/**
 * Mixes the two provided colors together by calculating the average of each of the RGB components weighted to the first color by the provided weight.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: mix(0.5, '#f00', '#00f')
 *   background: mix(0.25, '#f00', '#00f')
 *   background: mix('0.5', 'rgba(255, 0, 0, 0.5)', '#00f')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${mix(0.5, '#f00', '#00f')};
 *   background: ${mix(0.25, '#f00', '#00f')};
 *   background: ${mix('0.5', 'rgba(255, 0, 0, 0.5)', '#00f')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#7f007f";
 *   background: "#3f00bf";
 *   background: "rgba(63, 0, 191, 0.75)";
 * }
 */ function $c4f699b4a01e0372$var$mix(weight, color, otherColor) {
    if (color === 'transparent') return otherColor;
    if (otherColor === 'transparent') return color;
    if (weight === 0) return otherColor;
    var parsedColor1 = $c4f699b4a01e0372$export$2f48baff6995707a(color);
    var color1 = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, parsedColor1, {
        alpha: typeof parsedColor1.alpha === 'number' ? parsedColor1.alpha : 1
    });
    var parsedColor2 = $c4f699b4a01e0372$export$2f48baff6995707a(otherColor);
    var color2 = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, parsedColor2, {
        alpha: typeof parsedColor2.alpha === 'number' ? parsedColor2.alpha : 1
    });
    // The formula is copied from the original Sass implementation:
    // http://sass-lang.com/documentation/Sass/Script/Functions.html#mix-instance_method
    var alphaDelta = color1.alpha - color2.alpha;
    var x = parseFloat(weight) * 2 - 1;
    var y = x * alphaDelta === -1 ? x : x + alphaDelta;
    var z = 1 + x * alphaDelta;
    var weight1 = (y / z + 1) / 2.0;
    var weight2 = 1 - weight1;
    var mixedColor = {
        red: Math.floor(color1.red * weight1 + color2.red * weight2),
        green: Math.floor(color1.green * weight1 + color2.green * weight2),
        blue: Math.floor(color1.blue * weight1 + color2.blue * weight2),
        alpha: color1.alpha * parseFloat(weight) + color2.alpha * (1 - parseFloat(weight))
    };
    return $c4f699b4a01e0372$export$4e46ac54fc82cf3b(mixedColor);
}
// prettier-ignore
var $c4f699b4a01e0372$var$curriedMix = $c4f699b4a01e0372$var$curry /* ::<number | string, string, string, string> */ ($c4f699b4a01e0372$var$mix);
var $c4f699b4a01e0372$export$2c9e8a9632a706b2 = $c4f699b4a01e0372$var$curriedMix;
/**
 * Increases the opacity of a color. Its range for the amount is between 0 to 1.
 *
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: opacify(0.1, 'rgba(255, 255, 255, 0.9)');
 *   background: opacify(0.2, 'hsla(0, 0%, 100%, 0.5)'),
 *   background: opacify('0.5', 'rgba(255, 0, 0, 0.2)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${opacify(0.1, 'rgba(255, 255, 255, 0.9)')};
 *   background: ${opacify(0.2, 'hsla(0, 0%, 100%, 0.5)')},
 *   background: ${opacify('0.5', 'rgba(255, 0, 0, 0.2)')},
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#fff";
 *   background: "rgba(255,255,255,0.7)";
 *   background: "rgba(255,0,0,0.7)";
 * }
 */ function $c4f699b4a01e0372$var$opacify(amount, color) {
    if (color === 'transparent') return color;
    var parsedColor = $c4f699b4a01e0372$export$2f48baff6995707a(color);
    var alpha = typeof parsedColor.alpha === 'number' ? parsedColor.alpha : 1;
    var colorWithAlpha = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, parsedColor, {
        alpha: $c4f699b4a01e0372$var$guard(0, 1, (alpha * 100 + parseFloat(amount) * 100) / 100)
    });
    return $c4f699b4a01e0372$export$4e46ac54fc82cf3b(colorWithAlpha);
}
// prettier-ignore
var $c4f699b4a01e0372$var$curriedOpacify = $c4f699b4a01e0372$var$curry /* ::<number | string, string, string> */ ($c4f699b4a01e0372$var$opacify);
var $c4f699b4a01e0372$export$f4f50e3877dd0530 = $c4f699b4a01e0372$var$curriedOpacify;
var $c4f699b4a01e0372$var$defaultReturnIfLightColor = '#000';
var $c4f699b4a01e0372$var$defaultReturnIfDarkColor = '#fff';
/**
 * Returns black or white (or optional passed colors) for best
 * contrast depending on the luminosity of the given color.
 * When passing custom return colors, strict mode ensures that the
 * return color always meets or exceeds WCAG level AA or greater. If this test
 * fails, the default return color (black or white) is returned in place of the
 * custom return color. You can optionally turn off strict mode.
 *
 * Follows [W3C specs for readability](https://www.w3.org/TR/WCAG20-TECHS/G18.html).
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   color: readableColor('#000'),
 *   color: readableColor('black', '#001', '#ff8'),
 *   color: readableColor('white', '#001', '#ff8'),
 *   color: readableColor('red', '#333', '#ddd', true)
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   color: ${readableColor('#000')};
 *   color: ${readableColor('black', '#001', '#ff8')};
 *   color: ${readableColor('white', '#001', '#ff8')};
 *   color: ${readableColor('red', '#333', '#ddd', true)};
 * `
 *
 * // CSS in JS Output
 * element {
 *   color: "#fff";
 *   color: "#ff8";
 *   color: "#001";
 *   color: "#000";
 * }
 */ function $c4f699b4a01e0372$export$61654c1796c44811(color, returnIfLightColor, returnIfDarkColor, strict) {
    if (returnIfLightColor === void 0) returnIfLightColor = $c4f699b4a01e0372$var$defaultReturnIfLightColor;
    if (returnIfDarkColor === void 0) returnIfDarkColor = $c4f699b4a01e0372$var$defaultReturnIfDarkColor;
    if (strict === void 0) strict = true;
    var isColorLight = $c4f699b4a01e0372$export$c852d90bf7403b62(color) > 0.179;
    var preferredReturnColor = isColorLight ? returnIfLightColor : returnIfDarkColor;
    if (!strict || $c4f699b4a01e0372$export$850ce485a60d103b(color, preferredReturnColor) >= 4.5) return preferredReturnColor;
    return isColorLight ? $c4f699b4a01e0372$var$defaultReturnIfLightColor : $c4f699b4a01e0372$var$defaultReturnIfDarkColor;
}
/**
 * Converts a RgbColor or RgbaColor object to a color string.
 * This util is useful in case you only know on runtime which color object is
 * used. Otherwise we recommend to rely on `rgb` or `rgba`.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: rgbToColorString({ red: 255, green: 205, blue: 100 }),
 *   background: rgbToColorString({ red: 255, green: 205, blue: 100, alpha: 0.72 }),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${rgbToColorString({ red: 255, green: 205, blue: 100 })};
 *   background: ${rgbToColorString({ red: 255, green: 205, blue: 100, alpha: 0.72 })};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#ffcd64";
 *   background: "rgba(255,205,100,0.72)";
 * }
 */ function $c4f699b4a01e0372$export$34b0917fcca19deb(color) {
    if (typeof color === 'object' && typeof color.red === 'number' && typeof color.green === 'number' && typeof color.blue === 'number') {
        if (typeof color.alpha === 'number') return $c4f699b4a01e0372$export$4e46ac54fc82cf3b({
            red: color.red,
            green: color.green,
            blue: color.blue,
            alpha: color.alpha
        });
        return $c4f699b4a01e0372$export$8972dc0e6ad9238f({
            red: color.red,
            green: color.green,
            blue: color.blue
        });
    }
    throw new $c4f699b4a01e0372$var$PolishedError(46);
}
/**
 * Increases the intensity of a color. Its range is between 0 to 1. The first
 * argument of the saturate function is the amount by how much the color
 * intensity should be increased.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: saturate(0.2, '#CCCD64'),
 *   background: saturate('0.2', 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${saturate(0.2, '#FFCD64')};
 *   background: ${saturate('0.2', 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#e0e250";
 *   background: "rgba(224,226,80,0.7)";
 * }
 */ function $c4f699b4a01e0372$var$saturate(amount, color) {
    if (color === 'transparent') return color;
    var hslColor = $c4f699b4a01e0372$export$1286688e1b3fde9c(color);
    return $c4f699b4a01e0372$export$42fe740cdf79b2df((0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, hslColor, {
        saturation: $c4f699b4a01e0372$var$guard(0, 1, hslColor.saturation + parseFloat(amount))
    }));
}
// prettier-ignore
var $c4f699b4a01e0372$var$curriedSaturate = $c4f699b4a01e0372$var$curry /* ::<number | string, string, string> */ ($c4f699b4a01e0372$var$saturate);
var $c4f699b4a01e0372$export$5fcac96f5a87e3db = $c4f699b4a01e0372$var$curriedSaturate;
/**
 * Sets the hue of a color to the provided value. The hue range can be
 * from 0 and 359.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: setHue(42, '#CCCD64'),
 *   background: setHue('244', 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${setHue(42, '#CCCD64')};
 *   background: ${setHue('244', 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#cdae64";
 *   background: "rgba(107,100,205,0.7)";
 * }
 */ function $c4f699b4a01e0372$var$setHue(hue, color) {
    if (color === 'transparent') return color;
    return $c4f699b4a01e0372$export$42fe740cdf79b2df((0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, $c4f699b4a01e0372$export$1286688e1b3fde9c(color), {
        hue: parseFloat(hue)
    }));
}
// prettier-ignore
var $c4f699b4a01e0372$var$curriedSetHue = $c4f699b4a01e0372$var$curry /* ::<number | string, string, string> */ ($c4f699b4a01e0372$var$setHue);
var $c4f699b4a01e0372$export$3bf58ce3e497a846 = $c4f699b4a01e0372$var$curriedSetHue;
/**
 * Sets the lightness of a color to the provided value. The lightness range can be
 * from 0 and 1.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: setLightness(0.2, '#CCCD64'),
 *   background: setLightness('0.75', 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${setLightness(0.2, '#CCCD64')};
 *   background: ${setLightness('0.75', 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#4d4d19";
 *   background: "rgba(223,224,159,0.7)";
 * }
 */ function $c4f699b4a01e0372$var$setLightness(lightness, color) {
    if (color === 'transparent') return color;
    return $c4f699b4a01e0372$export$42fe740cdf79b2df((0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, $c4f699b4a01e0372$export$1286688e1b3fde9c(color), {
        lightness: parseFloat(lightness)
    }));
}
// prettier-ignore
var $c4f699b4a01e0372$var$curriedSetLightness = $c4f699b4a01e0372$var$curry /* ::<number | string, string, string> */ ($c4f699b4a01e0372$var$setLightness);
var $c4f699b4a01e0372$export$7ef5d725337b805d = $c4f699b4a01e0372$var$curriedSetLightness;
/**
 * Sets the saturation of a color to the provided value. The saturation range can be
 * from 0 and 1.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: setSaturation(0.2, '#CCCD64'),
 *   background: setSaturation('0.75', 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${setSaturation(0.2, '#CCCD64')};
 *   background: ${setSaturation('0.75', 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#adad84";
 *   background: "rgba(228,229,76,0.7)";
 * }
 */ function $c4f699b4a01e0372$var$setSaturation(saturation, color) {
    if (color === 'transparent') return color;
    return $c4f699b4a01e0372$export$42fe740cdf79b2df((0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, $c4f699b4a01e0372$export$1286688e1b3fde9c(color), {
        saturation: parseFloat(saturation)
    }));
}
// prettier-ignore
var $c4f699b4a01e0372$var$curriedSetSaturation = $c4f699b4a01e0372$var$curry /* ::<number | string, string, string> */ ($c4f699b4a01e0372$var$setSaturation);
var $c4f699b4a01e0372$export$b40fe421ea7a4f7e = $c4f699b4a01e0372$var$curriedSetSaturation;
/**
 * Shades a color by mixing it with black. `shade` can produce
 * hue shifts, where as `darken` manipulates the luminance channel and therefore
 * doesn't produce hue shifts.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: shade(0.25, '#00f')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${shade(0.25, '#00f')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#00003f";
 * }
 */ function $c4f699b4a01e0372$var$shade(percentage, color) {
    if (color === 'transparent') return color;
    return $c4f699b4a01e0372$export$2c9e8a9632a706b2(parseFloat(percentage), 'rgb(0, 0, 0)', color);
}
// prettier-ignore
var $c4f699b4a01e0372$var$curriedShade = $c4f699b4a01e0372$var$curry /* ::<number | string, string, string> */ ($c4f699b4a01e0372$var$shade);
var $c4f699b4a01e0372$export$3e32adda0df4ef5d = $c4f699b4a01e0372$var$curriedShade;
/**
 * Tints a color by mixing it with white. `tint` can produce
 * hue shifts, where as `lighten` manipulates the luminance channel and therefore
 * doesn't produce hue shifts.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: tint(0.25, '#00f')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${tint(0.25, '#00f')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#bfbfff";
 * }
 */ function $c4f699b4a01e0372$var$tint(percentage, color) {
    if (color === 'transparent') return color;
    return $c4f699b4a01e0372$export$2c9e8a9632a706b2(parseFloat(percentage), 'rgb(255, 255, 255)', color);
}
// prettier-ignore
var $c4f699b4a01e0372$var$curriedTint = $c4f699b4a01e0372$var$curry /* ::<number | string, string, string> */ ($c4f699b4a01e0372$var$tint);
var $c4f699b4a01e0372$export$fc176dd65a27d98b = $c4f699b4a01e0372$var$curriedTint;
/**
 * Decreases the opacity of a color. Its range for the amount is between 0 to 1.
 *
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: transparentize(0.1, '#fff'),
 *   background: transparentize(0.2, 'hsl(0, 0%, 100%)'),
 *   background: transparentize('0.5', 'rgba(255, 0, 0, 0.8)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${transparentize(0.1, '#fff')};
 *   background: ${transparentize(0.2, 'hsl(0, 0%, 100%)')};
 *   background: ${transparentize('0.5', 'rgba(255, 0, 0, 0.8)')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "rgba(255,255,255,0.9)";
 *   background: "rgba(255,255,255,0.8)";
 *   background: "rgba(255,0,0,0.3)";
 * }
 */ function $c4f699b4a01e0372$var$transparentize(amount, color) {
    if (color === 'transparent') return color;
    var parsedColor = $c4f699b4a01e0372$export$2f48baff6995707a(color);
    var alpha = typeof parsedColor.alpha === 'number' ? parsedColor.alpha : 1;
    var colorWithAlpha = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, parsedColor, {
        alpha: $c4f699b4a01e0372$var$guard(0, 1, +(alpha * 100 - parseFloat(amount) * 100).toFixed(2) / 100)
    });
    return $c4f699b4a01e0372$export$4e46ac54fc82cf3b(colorWithAlpha);
}
// prettier-ignore
var $c4f699b4a01e0372$var$curriedTransparentize = $c4f699b4a01e0372$var$curry /* ::<number | string, string, string> */ ($c4f699b4a01e0372$var$transparentize);
var $c4f699b4a01e0372$export$d11da87e55cc498f = $c4f699b4a01e0372$var$curriedTransparentize;
/**
 * Shorthand for easily setting the animation property. Allows either multiple arrays with animations
 * or a single animation spread over the arguments.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...animation(['rotate', '1s', 'ease-in-out'], ['colorchange', '2s'])
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${animation(['rotate', '1s', 'ease-in-out'], ['colorchange', '2s'])}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'animation': 'rotate 1s ease-in-out, colorchange 2s'
 * }
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...animation('rotate', '1s', 'ease-in-out')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${animation('rotate', '1s', 'ease-in-out')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'animation': 'rotate 1s ease-in-out'
 * }
 */ function $c4f699b4a01e0372$export$ecad260a8a5fef4f() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    // Allow single or multiple animations passed
    var multiMode = Array.isArray(args[0]);
    if (!multiMode && args.length > 8) throw new $c4f699b4a01e0372$var$PolishedError(64);
    var code = args.map(function(arg) {
        if (multiMode && !Array.isArray(arg) || !multiMode && Array.isArray(arg)) throw new $c4f699b4a01e0372$var$PolishedError(65);
        if (Array.isArray(arg) && arg.length > 8) throw new $c4f699b4a01e0372$var$PolishedError(66);
        return Array.isArray(arg) ? arg.join(' ') : arg;
    }).join(', ');
    return {
        animation: code
    };
}
/**
 * Shorthand that accepts any number of backgroundImage values as parameters for creating a single background statement.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...backgroundImages('url("/image/background.jpg")', 'linear-gradient(red, green)')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${backgroundImages('url("/image/background.jpg")', 'linear-gradient(red, green)')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'backgroundImage': 'url("/image/background.jpg"), linear-gradient(red, green)'
 * }
 */ function $c4f699b4a01e0372$export$c7de706fee81cfb4() {
    for(var _len = arguments.length, properties = new Array(_len), _key = 0; _key < _len; _key++)properties[_key] = arguments[_key];
    return {
        backgroundImage: properties.join(', ')
    };
}
/**
 * Shorthand that accepts any number of background values as parameters for creating a single background statement.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...backgrounds('url("/image/background.jpg")', 'linear-gradient(red, green)', 'center no-repeat')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${backgrounds('url("/image/background.jpg")', 'linear-gradient(red, green)', 'center no-repeat')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'background': 'url("/image/background.jpg"), linear-gradient(red, green), center no-repeat'
 * }
 */ function $c4f699b4a01e0372$export$d041fef2b78b7906() {
    for(var _len = arguments.length, properties = new Array(_len), _key = 0; _key < _len; _key++)properties[_key] = arguments[_key];
    return {
        background: properties.join(', ')
    };
}
var $c4f699b4a01e0372$var$sideMap = [
    'top',
    'right',
    'bottom',
    'left'
];
/**
 * Shorthand for the border property that splits out individual properties for use with tools like Fela and Styletron. A side keyword can optionally be passed to target only one side's border properties.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...border('1px', 'solid', 'red')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${border('1px', 'solid', 'red')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'borderColor': 'red',
 *   'borderStyle': 'solid',
 *   'borderWidth': `1px`,
 * }
 *
 * // Styles as object usage
 * const styles = {
 *   ...border('top', '1px', 'solid', 'red')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${border('top', '1px', 'solid', 'red')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'borderTopColor': 'red',
 *   'borderTopStyle': 'solid',
 *   'borderTopWidth': `1px`,
 * }
 */ function $c4f699b4a01e0372$export$1edee58a52776cd9(sideKeyword) {
    for(var _len = arguments.length, values = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)values[_key - 1] = arguments[_key];
    if (typeof sideKeyword === 'string' && $c4f699b4a01e0372$var$sideMap.indexOf(sideKeyword) >= 0) {
        var _ref;
        return _ref = {}, _ref["border" + $c4f699b4a01e0372$var$capitalizeString(sideKeyword) + "Width"] = values[0], _ref["border" + $c4f699b4a01e0372$var$capitalizeString(sideKeyword) + "Style"] = values[1], _ref["border" + $c4f699b4a01e0372$var$capitalizeString(sideKeyword) + "Color"] = values[2], _ref;
    } else {
        values.unshift(sideKeyword);
        return {
            borderWidth: values[0],
            borderStyle: values[1],
            borderColor: values[2]
        };
    }
}
/**
 * Shorthand that accepts up to four values, including null to skip a value, and maps them to their respective directions.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...borderColor('red', 'green', 'blue', 'yellow')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${borderColor('red', 'green', 'blue', 'yellow')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'borderTopColor': 'red',
 *   'borderRightColor': 'green',
 *   'borderBottomColor': 'blue',
 *   'borderLeftColor': 'yellow'
 * }
 */ function $c4f699b4a01e0372$export$e7fb0694ba2404fc() {
    for(var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++)values[_key] = arguments[_key];
    return $c4f699b4a01e0372$export$4fc00c04dd60af95.apply(void 0, [
        'borderColor'
    ].concat(values));
}
/**
 * Shorthand that accepts a value for side and a value for radius and applies the radius value to both corners of the side.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...borderRadius('top', '5px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${borderRadius('top', '5px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'borderTopRightRadius': '5px',
 *   'borderTopLeftRadius': '5px',
 * }
 */ function $c4f699b4a01e0372$export$7a57f79000377ca2(side, radius) {
    var uppercaseSide = $c4f699b4a01e0372$var$capitalizeString(side);
    if (!radius && radius !== 0) throw new $c4f699b4a01e0372$var$PolishedError(62);
    if (uppercaseSide === 'Top' || uppercaseSide === 'Bottom') {
        var _ref;
        return _ref = {}, _ref["border" + uppercaseSide + "RightRadius"] = radius, _ref["border" + uppercaseSide + "LeftRadius"] = radius, _ref;
    }
    if (uppercaseSide === 'Left' || uppercaseSide === 'Right') {
        var _ref2;
        return _ref2 = {}, _ref2["borderTop" + uppercaseSide + "Radius"] = radius, _ref2["borderBottom" + uppercaseSide + "Radius"] = radius, _ref2;
    }
    throw new $c4f699b4a01e0372$var$PolishedError(63);
}
/**
 * Shorthand that accepts up to four values, including null to skip a value, and maps them to their respective directions.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...borderStyle('solid', 'dashed', 'dotted', 'double')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${borderStyle('solid', 'dashed', 'dotted', 'double')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'borderTopStyle': 'solid',
 *   'borderRightStyle': 'dashed',
 *   'borderBottomStyle': 'dotted',
 *   'borderLeftStyle': 'double'
 * }
 */ function $c4f699b4a01e0372$export$4d0a7f76ad443516() {
    for(var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++)values[_key] = arguments[_key];
    return $c4f699b4a01e0372$export$4fc00c04dd60af95.apply(void 0, [
        'borderStyle'
    ].concat(values));
}
/**
 * Shorthand that accepts up to four values, including null to skip a value, and maps them to their respective directions.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...borderWidth('12px', '24px', '36px', '48px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${borderWidth('12px', '24px', '36px', '48px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'borderTopWidth': '12px',
 *   'borderRightWidth': '24px',
 *   'borderBottomWidth': '36px',
 *   'borderLeftWidth': '48px'
 * }
 */ function $c4f699b4a01e0372$export$12879c7697ed953d() {
    for(var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++)values[_key] = arguments[_key];
    return $c4f699b4a01e0372$export$4fc00c04dd60af95.apply(void 0, [
        'borderWidth'
    ].concat(values));
}
function $c4f699b4a01e0372$var$generateSelectors(template, state) {
    var stateSuffix = state ? ":" + state : '';
    return template(stateSuffix);
}
/**
 * Function helper that adds an array of states to a template of selectors. Used in textInputs and buttons.
 * @private
 */ function $c4f699b4a01e0372$var$statefulSelectors(states, template, stateMap) {
    if (!template) throw new $c4f699b4a01e0372$var$PolishedError(67);
    if (states.length === 0) return $c4f699b4a01e0372$var$generateSelectors(template, null);
    var selectors = [];
    for(var i = 0; i < states.length; i += 1){
        if (stateMap && stateMap.indexOf(states[i]) < 0) throw new $c4f699b4a01e0372$var$PolishedError(68);
        selectors.push($c4f699b4a01e0372$var$generateSelectors(template, states[i]));
    }
    selectors = selectors.join(',');
    return selectors;
}
var $c4f699b4a01e0372$var$stateMap$1 = [
    undefined,
    null,
    'active',
    'focus',
    'hover'
];
function $c4f699b4a01e0372$var$template$1(state) {
    return "button" + state + ",\n  input[type=\"button\"]" + state + ",\n  input[type=\"reset\"]" + state + ",\n  input[type=\"submit\"]" + state;
}
/**
 * Populates selectors that target all buttons. You can pass optional states to append to the selectors.
 * @example
 * // Styles as object usage
 * const styles = {
 *   [buttons('active')]: {
 *     'border': 'none'
 *   }
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   > ${buttons('active')} {
 *     border: none;
 *   }
 * `
 *
 * // CSS in JS Output
 *
 *  'button:active,
 *  'input[type="button"]:active,
 *  'input[type=\"reset\"]:active,
 *  'input[type=\"submit\"]:active: {
 *   'border': 'none'
 * }
 */ function $c4f699b4a01e0372$export$bbea856fdb3e3c5f() {
    for(var _len = arguments.length, states = new Array(_len), _key = 0; _key < _len; _key++)states[_key] = arguments[_key];
    return $c4f699b4a01e0372$var$statefulSelectors(states, $c4f699b4a01e0372$var$template$1, $c4f699b4a01e0372$var$stateMap$1);
}
/**
 * Shorthand that accepts up to four values, including null to skip a value, and maps them to their respective directions.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...margin('12px', '24px', '36px', '48px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${margin('12px', '24px', '36px', '48px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'marginTop': '12px',
 *   'marginRight': '24px',
 *   'marginBottom': '36px',
 *   'marginLeft': '48px'
 * }
 */ function $c4f699b4a01e0372$export$7ede87f9b603dd3c() {
    for(var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++)values[_key] = arguments[_key];
    return $c4f699b4a01e0372$export$4fc00c04dd60af95.apply(void 0, [
        'margin'
    ].concat(values));
}
/**
 * Shorthand that accepts up to four values, including null to skip a value, and maps them to their respective directions.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...padding('12px', '24px', '36px', '48px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${padding('12px', '24px', '36px', '48px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'paddingTop': '12px',
 *   'paddingRight': '24px',
 *   'paddingBottom': '36px',
 *   'paddingLeft': '48px'
 * }
 */ function $c4f699b4a01e0372$export$6f98e8eaf0be1996() {
    for(var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++)values[_key] = arguments[_key];
    return $c4f699b4a01e0372$export$4fc00c04dd60af95.apply(void 0, [
        'padding'
    ].concat(values));
}
var $c4f699b4a01e0372$var$positionMap = [
    'absolute',
    'fixed',
    'relative',
    'static',
    'sticky'
];
/**
 * Shorthand accepts up to five values, including null to skip a value, and maps them to their respective directions. The first value can optionally be a position keyword.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...position('12px', '24px', '36px', '48px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${position('12px', '24px', '36px', '48px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'top': '12px',
 *   'right': '24px',
 *   'bottom': '36px',
 *   'left': '48px'
 * }
 *
 * // Styles as object usage
 * const styles = {
 *   ...position('absolute', '12px', '24px', '36px', '48px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${position('absolute', '12px', '24px', '36px', '48px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'position': 'absolute',
 *   'top': '12px',
 *   'right': '24px',
 *   'bottom': '36px',
 *   'left': '48px'
 * }
 */ function $c4f699b4a01e0372$export$5880b8b5730aff45(firstValue) {
    for(var _len = arguments.length, values = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)values[_key - 1] = arguments[_key];
    if ($c4f699b4a01e0372$var$positionMap.indexOf(firstValue) >= 0 && firstValue) return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, $c4f699b4a01e0372$export$4fc00c04dd60af95.apply(void 0, [
        ''
    ].concat(values)), {
        position: firstValue
    });
    else return $c4f699b4a01e0372$export$4fc00c04dd60af95.apply(void 0, [
        '',
        firstValue
    ].concat(values));
}
/**
 * Shorthand to set the height and width properties in a single statement.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...size('300px', '250px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${size('300px', '250px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'height': '300px',
 *   'width': '250px',
 * }
 */ function $c4f699b4a01e0372$export$346677f925de839c(height, width) {
    if (width === void 0) width = height;
    return {
        height: height,
        width: width
    };
}
var $c4f699b4a01e0372$var$stateMap = [
    undefined,
    null,
    'active',
    'focus',
    'hover'
];
function $c4f699b4a01e0372$var$template(state) {
    return "input[type=\"color\"]" + state + ",\n    input[type=\"date\"]" + state + ",\n    input[type=\"datetime\"]" + state + ",\n    input[type=\"datetime-local\"]" + state + ",\n    input[type=\"email\"]" + state + ",\n    input[type=\"month\"]" + state + ",\n    input[type=\"number\"]" + state + ",\n    input[type=\"password\"]" + state + ",\n    input[type=\"search\"]" + state + ",\n    input[type=\"tel\"]" + state + ",\n    input[type=\"text\"]" + state + ",\n    input[type=\"time\"]" + state + ",\n    input[type=\"url\"]" + state + ",\n    input[type=\"week\"]" + state + ",\n    input:not([type])" + state + ",\n    textarea" + state;
}
/**
 * Populates selectors that target all text inputs. You can pass optional states to append to the selectors.
 * @example
 * // Styles as object usage
 * const styles = {
 *   [textInputs('active')]: {
 *     'border': 'none'
 *   }
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   > ${textInputs('active')} {
 *     border: none;
 *   }
 * `
 *
 * // CSS in JS Output
 *
 *  'input[type="color"]:active,
 *  input[type="date"]:active,
 *  input[type="datetime"]:active,
 *  input[type="datetime-local"]:active,
 *  input[type="email"]:active,
 *  input[type="month"]:active,
 *  input[type="number"]:active,
 *  input[type="password"]:active,
 *  input[type="search"]:active,
 *  input[type="tel"]:active,
 *  input[type="text"]:active,
 *  input[type="time"]:active,
 *  input[type="url"]:active,
 *  input[type="week"]:active,
 *  input:not([type]):active,
 *  textarea:active': {
 *   'border': 'none'
 * }
 */ function $c4f699b4a01e0372$export$baad927ee93ccf9c() {
    for(var _len = arguments.length, states = new Array(_len), _key = 0; _key < _len; _key++)states[_key] = arguments[_key];
    return $c4f699b4a01e0372$var$statefulSelectors(states, $c4f699b4a01e0372$var$template, $c4f699b4a01e0372$var$stateMap);
}
/**
 * Accepts any number of transition values as parameters for creating a single transition statement. You may also pass an array of properties as the first parameter that you would like to apply the same transition values to (second parameter).
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...transitions('opacity 1.0s ease-in 0s', 'width 2.0s ease-in 2s'),
 *   ...transitions(['color', 'background-color'], '2.0s ease-in 2s')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${transitions('opacity 1.0s ease-in 0s', 'width 2.0s ease-in 2s')};
 *   ${transitions(['color', 'background-color'], '2.0s ease-in 2s'),};
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'transition': 'opacity 1.0s ease-in 0s, width 2.0s ease-in 2s'
 *   'transition': 'color 2.0s ease-in 2s, background-color 2.0s ease-in 2s',
 * }
 */ function $c4f699b4a01e0372$export$622eca585e740ed5() {
    for(var _len = arguments.length, properties = new Array(_len), _key = 0; _key < _len; _key++)properties[_key] = arguments[_key];
    if (Array.isArray(properties[0]) && properties.length === 2) {
        var value = properties[1];
        if (typeof value !== 'string') throw new $c4f699b4a01e0372$var$PolishedError(61);
        var transitionsString = properties[0].map(function(property) {
            return property + " " + value;
        }).join(', ');
        return {
            transition: transitionsString
        };
    } else return {
        transition: properties.join(', ')
    };
}



var $8PNKb = parcelRequire("8PNKb");


function $69c9538f9a62b4e8$var$styleInject(css, ref) {
    if (ref === void 0) ref = {};
    var insertAt = ref.insertAt;
    if (typeof document === 'undefined') return;
    var head = document.head || document.getElementsByTagName('head')[0];
    var style = document.createElement('style');
    style.type = 'text/css';
    if (insertAt === 'top') {
        if (head.firstChild) head.insertBefore(style, head.firstChild);
        else head.appendChild(style);
    } else head.appendChild(style);
    if (style.styleSheet) style.styleSheet.cssText = css;
    else style.appendChild(document.createTextNode(css));
}
var $69c9538f9a62b4e8$var$css_248z = ".scene-nav-info {\n  bottom: 5px;\n  width: 100%;\n  text-align: center;\n  color: slategrey;\n  opacity: 0.7;\n  font-size: 10px;\n}\n\n.scene-tooltip {\n  top: 0;\n  color: lavender;\n  font-size: 15px;\n}\n\n.scene-nav-info, .scene-tooltip {\n  position: absolute;\n  font-family: sans-serif;\n  pointer-events: none;\n  user-select: none;\n}\n\n.scene-container canvas:focus {\n  outline: none;\n}";
$69c9538f9a62b4e8$var$styleInject($69c9538f9a62b4e8$var$css_248z);
function $69c9538f9a62b4e8$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $69c9538f9a62b4e8$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
function $69c9538f9a62b4e8$var$_arrayWithoutHoles(r) {
    if (Array.isArray(r)) return $69c9538f9a62b4e8$var$_arrayLikeToArray(r);
}
function $69c9538f9a62b4e8$var$_defineProperty(e, r, t) {
    return (r = $69c9538f9a62b4e8$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $69c9538f9a62b4e8$var$_iterableToArray(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function $69c9538f9a62b4e8$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) ;
            else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $69c9538f9a62b4e8$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $69c9538f9a62b4e8$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $69c9538f9a62b4e8$var$_slicedToArray(r, e) {
    return $69c9538f9a62b4e8$var$_arrayWithHoles(r) || $69c9538f9a62b4e8$var$_iterableToArrayLimit(r, e) || $69c9538f9a62b4e8$var$_unsupportedIterableToArray(r, e) || $69c9538f9a62b4e8$var$_nonIterableRest();
}
function $69c9538f9a62b4e8$var$_toConsumableArray(r) {
    return $69c9538f9a62b4e8$var$_arrayWithoutHoles(r) || $69c9538f9a62b4e8$var$_iterableToArray(r) || $69c9538f9a62b4e8$var$_unsupportedIterableToArray(r) || $69c9538f9a62b4e8$var$_nonIterableSpread();
}
function $69c9538f9a62b4e8$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $69c9538f9a62b4e8$var$_toPropertyKey(t) {
    var i = $69c9538f9a62b4e8$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $69c9538f9a62b4e8$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $69c9538f9a62b4e8$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $69c9538f9a62b4e8$var$_arrayLikeToArray(r, a) : void 0;
    }
}
var $69c9538f9a62b4e8$var$three = window.THREE ? window.THREE // Prefer consumption from global THREE, if exists
 : {
    WebGLRenderer: (0, $d5b33d7c30034067$export$f6cc00ef28d7cf97),
    Scene: (0, $d5b33d7c30034067$export$38af1803e3442a7f),
    PerspectiveCamera: (0, $d5b33d7c30034067$export$74e4ae24825f68d7),
    Raycaster: (0, $d5b33d7c30034067$export$8b7aaceff00bd2f),
    SRGBColorSpace: (0, $d5b33d7c30034067$export$561f394b24edfcaa),
    TextureLoader: (0, $d5b33d7c30034067$export$fd1bfc71f64c538c),
    Vector2: (0, $d5b33d7c30034067$export$c977b3e384af9ae1),
    Vector3: (0, $d5b33d7c30034067$export$64b5c384219d3699),
    Box3: (0, $d5b33d7c30034067$export$6f7d5a9418ab2aa3),
    Color: (0, $d5b33d7c30034067$export$892596cec99bc70e),
    Mesh: (0, $d5b33d7c30034067$export$e176487c05830cc5),
    SphereGeometry: (0, $d5b33d7c30034067$export$1b417fc3b307a251),
    MeshBasicMaterial: (0, $d5b33d7c30034067$export$55cbcc9b622fe1f5),
    BackSide: (0, $d5b33d7c30034067$export$d9f0486e75b5ace),
    EventDispatcher: (0, $d5b33d7c30034067$export$ec8b666c5fe2c75a),
    MOUSE: (0, $d5b33d7c30034067$export$7177b3e430c2d7ca),
    Quaternion: (0, $d5b33d7c30034067$export$23d6a54f0bbc85a3),
    Spherical: (0, $d5b33d7c30034067$export$d712cd887b4a00f7),
    Clock: (0, $d5b33d7c30034067$export$9735c82c4bae3302)
};
var $69c9538f9a62b4e8$export$2e2bcd8739ae039 = (0, $752852d7be1532d9$export$2e2bcd8739ae039)({
    props: {
        width: {
            "default": window.innerWidth,
            onChange: function onChange(width, state, prevWidth) {
                isNaN(width) && (state.width = prevWidth);
            }
        },
        height: {
            "default": window.innerHeight,
            onChange: function onChange(height, state, prevHeight) {
                isNaN(height) && (state.height = prevHeight);
            }
        },
        backgroundColor: {
            "default": '#000011'
        },
        backgroundImageUrl: {},
        onBackgroundImageLoaded: {},
        showNavInfo: {
            "default": true
        },
        skyRadius: {
            "default": 50000
        },
        objects: {
            "default": []
        },
        lights: {
            "default": []
        },
        enablePointerInteraction: {
            "default": true,
            onChange: function onChange(_, state) {
                // Reset hover state
                state.hoverObj = null;
                if (state.toolTipElem) state.toolTipElem.innerHTML = '';
            },
            triggerUpdate: false
        },
        lineHoverPrecision: {
            "default": 1,
            triggerUpdate: false
        },
        hoverOrderComparator: {
            "default": function _default() {
                return -1;
            },
            triggerUpdate: false
        },
        // keep existing order by default
        hoverFilter: {
            "default": function _default() {
                return true;
            },
            triggerUpdate: false
        },
        // exclude objects from interaction
        tooltipContent: {
            triggerUpdate: false
        },
        hoverDuringDrag: {
            "default": false,
            triggerUpdate: false
        },
        clickAfterDrag: {
            "default": false,
            triggerUpdate: false
        },
        onHover: {
            "default": function _default() {},
            triggerUpdate: false
        },
        onClick: {
            "default": function _default() {},
            triggerUpdate: false
        },
        onRightClick: {
            triggerUpdate: false
        }
    },
    methods: {
        tick: function tick(state) {
            if (state.initialised) {
                state.controls.update && state.controls.update(Math.min(1, state.clock.getDelta())); // timedelta is required for fly controls
                state.postProcessingComposer ? state.postProcessingComposer.render() // if using postprocessing, switch the output to it
                 : state.renderer.render(state.scene, state.camera);
                state.extraRenderers.forEach(function(r) {
                    return r.render(state.scene, state.camera);
                });
                if (state.enablePointerInteraction) {
                    // Update tooltip and trigger onHover events
                    var topObject = null;
                    if (state.hoverDuringDrag || !state.isPointerDragging) {
                        var intersects = this.intersectingObjects(state.pointerPos.x, state.pointerPos.y).filter(function(d) {
                            return state.hoverFilter(d.object);
                        }).sort(function(a, b) {
                            return state.hoverOrderComparator(a.object, b.object);
                        });
                        var topIntersect = intersects.length ? intersects[0] : null;
                        topObject = topIntersect ? topIntersect.object : null;
                        state.intersectionPoint = topIntersect ? topIntersect.point : null;
                    }
                    if (topObject !== state.hoverObj) {
                        state.onHover(topObject, state.hoverObj);
                        state.toolTipElem.innerHTML = topObject ? (0, $85d8080a057d7be2$export$2e2bcd8739ae039)(state.tooltipContent)(topObject) || '' : '';
                        state.hoverObj = topObject;
                    }
                }
                state.tweenGroup.update(); // update camera animation tweens
            }
            return this;
        },
        getPointerPos: function getPointerPos(state) {
            var _state$pointerPos = state.pointerPos, x = _state$pointerPos.x, y = _state$pointerPos.y;
            return {
                x: x,
                y: y
            };
        },
        cameraPosition: function cameraPosition(state, position, lookAt, transitionDuration) {
            var camera = state.camera;
            // Setter
            if (position && state.initialised) {
                var finalPos = position;
                var finalLookAt = lookAt || {
                    x: 0,
                    y: 0,
                    z: 0
                };
                if (!transitionDuration) {
                    // no animation
                    setCameraPos(finalPos);
                    setLookAt(finalLookAt);
                } else {
                    var camPos = Object.assign({}, camera.position);
                    var camLookAt = getLookAt();
                    state.tweenGroup.add(new (0, $8PNKb.Tween)(camPos).to(finalPos, transitionDuration).easing((0, $8PNKb.Easing).Quadratic.Out).onUpdate(setCameraPos).start());
                    // Face direction in 1/3rd of time
                    state.tweenGroup.add(new (0, $8PNKb.Tween)(camLookAt).to(finalLookAt, transitionDuration / 3).easing((0, $8PNKb.Easing).Quadratic.Out).onUpdate(setLookAt).start());
                }
                return this;
            }
            // Getter
            return Object.assign({}, camera.position, {
                lookAt: getLookAt()
            });
            //
            function setCameraPos(pos) {
                var x = pos.x, y = pos.y, z = pos.z;
                if (x !== undefined) camera.position.x = x;
                if (y !== undefined) camera.position.y = y;
                if (z !== undefined) camera.position.z = z;
            }
            function setLookAt(lookAt) {
                var lookAtVect = new $69c9538f9a62b4e8$var$three.Vector3(lookAt.x, lookAt.y, lookAt.z);
                if (state.controls.target) state.controls.target = lookAtVect;
                else // Fly controls doesn't have target attribute
                camera.lookAt(lookAtVect); // note: lookAt may be overridden by other controls in some cases
            }
            function getLookAt() {
                return Object.assign(new $69c9538f9a62b4e8$var$three.Vector3(0, 0, -1000).applyQuaternion(camera.quaternion).add(camera.position));
            }
        },
        zoomToFit: function zoomToFit(state) {
            var transitionDuration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
            var padding = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 10;
            for(var _len = arguments.length, bboxArgs = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++)bboxArgs[_key - 3] = arguments[_key];
            return this.fitToBbox(this.getBbox.apply(this, bboxArgs), transitionDuration, padding);
        },
        fitToBbox: function fitToBbox(state, bbox) {
            var transitionDuration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
            var padding = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 10;
            // based on https://discourse.threejs.org/t/camera-zoom-to-fit-object/936/24
            var camera = state.camera;
            if (bbox) {
                var center = new $69c9538f9a62b4e8$var$three.Vector3(0, 0, 0); // reset camera aim to center
                var maxBoxSide = Math.max.apply(Math, $69c9538f9a62b4e8$var$_toConsumableArray(Object.entries(bbox).map(function(_ref) {
                    var _ref2 = $69c9538f9a62b4e8$var$_slicedToArray(_ref, 2), coordType = _ref2[0], coords = _ref2[1];
                    return Math.max.apply(Math, $69c9538f9a62b4e8$var$_toConsumableArray(coords.map(function(c) {
                        return Math.abs(center[coordType] - c);
                    })));
                }))) * 2;
                // find distance that fits whole bbox within padded fov
                var paddedFov = (1 - padding * 2 / state.height) * camera.fov;
                var fitHeightDistance = maxBoxSide / Math.atan(paddedFov * Math.PI / 180);
                var fitWidthDistance = fitHeightDistance / camera.aspect;
                var distance = Math.max(fitHeightDistance, fitWidthDistance);
                if (distance > 0) {
                    var newCameraPosition = center.clone().sub(camera.position).normalize().multiplyScalar(-distance);
                    this.cameraPosition(newCameraPosition, center, transitionDuration);
                }
            }
            return this;
        },
        getBbox: function getBbox(state) {
            var objFilter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function() {
                return true;
            };
            var box = new $69c9538f9a62b4e8$var$three.Box3(new $69c9538f9a62b4e8$var$three.Vector3(0, 0, 0), new $69c9538f9a62b4e8$var$three.Vector3(0, 0, 0));
            var objs = state.objects.filter(objFilter);
            if (!objs.length) return null;
            objs.forEach(function(obj) {
                return box.expandByObject(obj);
            });
            // extract global x,y,z min/max
            return Object.assign.apply(Object, $69c9538f9a62b4e8$var$_toConsumableArray([
                'x',
                'y',
                'z'
            ].map(function(c) {
                return $69c9538f9a62b4e8$var$_defineProperty({}, c, [
                    box.min[c],
                    box.max[c]
                ]);
            })));
        },
        getScreenCoords: function getScreenCoords(state, x, y, z) {
            var vec = new $69c9538f9a62b4e8$var$three.Vector3(x, y, z);
            vec.project(this.camera()); // project to the camera plane
            return {
                // align relative pos to canvas dimensions
                x: (vec.x + 1) * state.width / 2,
                y: -(vec.y - 1) * state.height / 2
            };
        },
        getSceneCoords: function getSceneCoords(state, screenX, screenY) {
            var distance = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
            var relCoords = new $69c9538f9a62b4e8$var$three.Vector2(screenX / state.width * 2 - 1, -(screenY / state.height) * 2 + 1);
            var raycaster = new $69c9538f9a62b4e8$var$three.Raycaster();
            raycaster.setFromCamera(relCoords, state.camera);
            return Object.assign({}, raycaster.ray.at(distance, new $69c9538f9a62b4e8$var$three.Vector3()));
        },
        intersectingObjects: function intersectingObjects(state, x, y) {
            var relCoords = new $69c9538f9a62b4e8$var$three.Vector2(x / state.width * 2 - 1, -(y / state.height) * 2 + 1);
            var raycaster = new $69c9538f9a62b4e8$var$three.Raycaster();
            raycaster.params.Line.threshold = state.lineHoverPrecision; // set linePrecision
            raycaster.setFromCamera(relCoords, state.camera);
            return raycaster.intersectObjects(state.objects, true);
        },
        renderer: function renderer(state) {
            return state.renderer;
        },
        scene: function scene(state) {
            return state.scene;
        },
        camera: function camera(state) {
            return state.camera;
        },
        postProcessingComposer: function postProcessingComposer(state) {
            return state.postProcessingComposer;
        },
        controls: function controls(state) {
            return state.controls;
        },
        tbControls: function tbControls(state) {
            return state.controls;
        } // to be deprecated
    },
    stateInit: function stateInit() {
        return {
            scene: new $69c9538f9a62b4e8$var$three.Scene(),
            camera: new $69c9538f9a62b4e8$var$three.PerspectiveCamera(),
            clock: new $69c9538f9a62b4e8$var$three.Clock(),
            tweenGroup: new (0, $8PNKb.Group)()
        };
    },
    init: function init(domNode, state) {
        var _ref4 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {}, _ref4$controlType = _ref4.controlType, controlType = _ref4$controlType === void 0 ? 'trackball' : _ref4$controlType, _ref4$useWebGPU = _ref4.useWebGPU, useWebGPU = _ref4$useWebGPU === void 0 ? false : _ref4$useWebGPU, _ref4$rendererConfig = _ref4.rendererConfig, rendererConfig = _ref4$rendererConfig === void 0 ? {} : _ref4$rendererConfig, _ref4$extraRenderers = _ref4.extraRenderers, extraRenderers = _ref4$extraRenderers === void 0 ? [] : _ref4$extraRenderers, _ref4$waitForLoadComp = _ref4.waitForLoadComplete, waitForLoadComplete = _ref4$waitForLoadComp === void 0 ? true : _ref4$waitForLoadComp;
        // Wipe DOM
        domNode.innerHTML = '';
        // Add relative container
        domNode.appendChild(state.container = document.createElement('div'));
        state.container.className = 'scene-container';
        state.container.style.position = 'relative';
        // Add nav info section
        state.container.appendChild(state.navInfo = document.createElement('div'));
        state.navInfo.className = 'scene-nav-info';
        state.navInfo.textContent = ({
            orbit: 'Left-click: rotate, Mouse-wheel/middle-click: zoom, Right-click: pan',
            trackball: 'Left-click: rotate, Mouse-wheel/middle-click: zoom, Right-click: pan',
            fly: 'WASD: move, R|F: up | down, Q|E: roll, up|down: pitch, left|right: yaw'
        })[controlType] || '';
        state.navInfo.style.display = state.showNavInfo ? null : 'none';
        // Setup tooltip
        state.toolTipElem = document.createElement('div');
        state.toolTipElem.classList.add('scene-tooltip');
        state.container.appendChild(state.toolTipElem);
        // Capture pointer coords on move or touchstart
        state.pointerPos = new $69c9538f9a62b4e8$var$three.Vector2();
        state.pointerPos.x = -2; // Initialize off canvas
        state.pointerPos.y = -2;
        [
            'pointermove',
            'pointerdown'
        ].forEach(function(evType) {
            return state.container.addEventListener(evType, function(ev) {
                // track click state
                evType === 'pointerdown' && (state.isPointerPressed = true);
                // detect point drag
                !state.isPointerDragging && ev.type === 'pointermove' && (ev.pressure > 0 || state.isPointerPressed // ev.pressure always 0 on Safari, so we used the isPointerPressed tracker
                ) && (ev.pointerType !== 'touch' || ev.movementX === undefined || [
                    ev.movementX,
                    ev.movementY
                ].some(function(m) {
                    return Math.abs(m) > 1;
                }) // relax drag trigger sensitivity on touch events
                ) && (state.isPointerDragging = true);
                if (state.enablePointerInteraction) {
                    // update the pointer pos
                    var offset = getOffset(state.container);
                    state.pointerPos.x = ev.pageX - offset.left;
                    state.pointerPos.y = ev.pageY - offset.top;
                    // Move tooltip
                    state.toolTipElem.style.top = "".concat(state.pointerPos.y, "px");
                    state.toolTipElem.style.left = "".concat(state.pointerPos.x, "px");
                    // adjust horizontal position to not exceed canvas boundaries
                    state.toolTipElem.style.transform = "translate(-".concat(state.pointerPos.x / state.width * 100, "%, ").concat(// flip to above if near bottom
                    state.height - state.pointerPos.y < 100 ? 'calc(-100% - 8px)' : '21px', ")");
                }
                function getOffset(el) {
                    var rect = el.getBoundingClientRect(), scrollLeft = window.pageXOffset || document.documentElement.scrollLeft, scrollTop = window.pageYOffset || document.documentElement.scrollTop;
                    return {
                        top: rect.top + scrollTop,
                        left: rect.left + scrollLeft
                    };
                }
            }, {
                passive: true
            });
        });
        // Handle click events on objs
        state.container.addEventListener('pointerup', function(ev) {
            state.isPointerPressed = false;
            if (state.isPointerDragging) {
                state.isPointerDragging = false;
                if (!state.clickAfterDrag) return; // don't trigger onClick after pointer drag (camera motion via controls)
            }
            requestAnimationFrame(function() {
                // trigger click events asynchronously, to allow hoverObj to be set (on frame)
                if (ev.button === 0) // left-click
                state.onClick(state.hoverObj || null, ev, state.intersectionPoint); // trigger background clicks with null
                if (ev.button === 2 && state.onRightClick) // right-click
                state.onRightClick(state.hoverObj || null, ev, state.intersectionPoint);
            });
        }, {
            passive: true,
            capture: true
        }); // use capture phase to prevent propagation blocking from controls (specifically for fly)
        state.container.addEventListener('contextmenu', function(ev) {
            if (state.onRightClick) ev.preventDefault(); // prevent default contextmenu behavior and allow pointerup to fire instead
        });
        // Setup renderer, camera and controls
        state.renderer = new (useWebGPU ? (0, $8574d94dd9555abd$export$2e2bcd8739ae039) : $69c9538f9a62b4e8$var$three.WebGLRenderer)(Object.assign({
            antialias: true,
            alpha: true
        }, rendererConfig));
        state.renderer.setPixelRatio(Math.min(2, window.devicePixelRatio)); // clamp device pixel ratio
        state.container.appendChild(state.renderer.domElement);
        // Setup extra renderers
        state.extraRenderers = extraRenderers;
        state.extraRenderers.forEach(function(r) {
            // overlay them on top of main renderer
            r.domElement.style.position = 'absolute';
            r.domElement.style.top = '0px';
            r.domElement.style.pointerEvents = 'none';
            state.container.appendChild(r.domElement);
        });
        // configure post-processing composer
        state.postProcessingComposer = new (0, $1f89f80dfbd5e815$export$7fe01e6ab8aa748c)(state.renderer);
        state.postProcessingComposer.addPass(new (0, $f4d3a60efece63cd$export$f63ea822f020b5b0)(state.scene, state.camera)); // render scene as first pass
        // configure controls
        state.controls = new ({
            trackball: (0, $164afa34e4b04624$export$18b7f869be764a91),
            orbit: (0, $443c013b983d0324$export$8ff7788029dfdf52),
            fly: (0, $37d4d287f7c195e5$export$4cec72bd81e75195)
        })[controlType](state.camera, state.renderer.domElement);
        if (controlType === 'fly') {
            state.controls.movementSpeed = 300;
            state.controls.rollSpeed = Math.PI / 6;
            state.controls.dragToLook = true;
        }
        if (controlType === 'trackball' || controlType === 'orbit') {
            state.controls.minDistance = 0.1;
            state.controls.maxDistance = state.skyRadius;
            state.controls.addEventListener('start', function() {
                state.controlsEngaged = true;
            });
            state.controls.addEventListener('change', function() {
                if (state.controlsEngaged) state.controlsDragging = true;
            });
            state.controls.addEventListener('end', function() {
                state.controlsEngaged = false;
                state.controlsDragging = false;
            });
        }
        [
            state.renderer,
            state.postProcessingComposer
        ].concat($69c9538f9a62b4e8$var$_toConsumableArray(state.extraRenderers)).forEach(function(r) {
            return r.setSize(state.width, state.height);
        });
        state.camera.aspect = state.width / state.height;
        state.camera.updateProjectionMatrix();
        state.camera.position.z = 1000;
        // add sky
        state.scene.add(state.skysphere = new $69c9538f9a62b4e8$var$three.Mesh());
        state.skysphere.visible = false;
        state.loadComplete = state.scene.visible = !waitForLoadComplete;
        window.scene = state.scene;
    },
    update: function update(state, changedProps) {
        // resize canvas
        if (state.width && state.height && (changedProps.hasOwnProperty('width') || changedProps.hasOwnProperty('height'))) {
            state.container.style.width = "".concat(state.width, "px");
            state.container.style.height = "".concat(state.height, "px");
            [
                state.renderer,
                state.postProcessingComposer
            ].concat($69c9538f9a62b4e8$var$_toConsumableArray(state.extraRenderers)).forEach(function(r) {
                return r.setSize(state.width, state.height);
            });
            state.camera.aspect = state.width / state.height;
            state.camera.updateProjectionMatrix();
        }
        if (changedProps.hasOwnProperty('skyRadius') && state.skyRadius) {
            state.controls.hasOwnProperty('maxDistance') && changedProps.skyRadius && (state.controls.maxDistance = Math.min(state.controls.maxDistance, state.skyRadius));
            state.camera.far = state.skyRadius * 2.5;
            state.camera.updateProjectionMatrix();
            state.skysphere.geometry = new $69c9538f9a62b4e8$var$three.SphereGeometry(state.skyRadius);
        }
        if (changedProps.hasOwnProperty('backgroundColor')) {
            var alpha = (0, $c4f699b4a01e0372$export$2f48baff6995707a)(state.backgroundColor).alpha;
            if (alpha === undefined) alpha = 1;
            state.renderer.setClearColor(new $69c9538f9a62b4e8$var$three.Color((0, $c4f699b4a01e0372$export$f4f50e3877dd0530)(1, state.backgroundColor)), alpha);
        }
        if (changedProps.hasOwnProperty('backgroundImageUrl')) {
            if (!state.backgroundImageUrl) {
                state.skysphere.visible = false;
                state.skysphere.material.map = null;
                !state.loadComplete && finishLoad();
            } else new $69c9538f9a62b4e8$var$three.TextureLoader().load(state.backgroundImageUrl, function(texture) {
                texture.colorSpace = $69c9538f9a62b4e8$var$three.SRGBColorSpace;
                state.skysphere.material = new $69c9538f9a62b4e8$var$three.MeshBasicMaterial({
                    map: texture,
                    side: $69c9538f9a62b4e8$var$three.BackSide
                });
                state.skysphere.visible = true;
                // triggered when background image finishes loading (asynchronously to allow 1 frame to load texture)
                state.onBackgroundImageLoaded && setTimeout(state.onBackgroundImageLoaded);
                !state.loadComplete && finishLoad();
            });
        }
        changedProps.hasOwnProperty('showNavInfo') && (state.navInfo.style.display = state.showNavInfo ? null : 'none');
        if (changedProps.hasOwnProperty('lights')) {
            (changedProps.lights || []).forEach(function(light) {
                return state.scene.remove(light);
            }); // Clear the place
            state.lights.forEach(function(light) {
                return state.scene.add(light);
            }); // Add to scene
        }
        if (changedProps.hasOwnProperty('objects')) {
            (changedProps.objects || []).forEach(function(obj) {
                return state.scene.remove(obj);
            }); // Clear the place
            state.objects.forEach(function(obj) {
                return state.scene.add(obj);
            }); // Add to scene
        }
        //
        function finishLoad() {
            state.loadComplete = state.scene.visible = true;
        }
    }
});




function $66a418df8d4b954b$var$styleInject(css, ref) {
    if (ref === void 0) ref = {};
    var insertAt = ref.insertAt;
    if (typeof document === 'undefined') return;
    var head = document.head || document.getElementsByTagName('head')[0];
    var style = document.createElement('style');
    style.type = 'text/css';
    if (insertAt === 'top') {
        if (head.firstChild) head.insertBefore(style, head.firstChild);
        else head.appendChild(style);
    } else head.appendChild(style);
    if (style.styleSheet) style.styleSheet.cssText = css;
    else style.appendChild(document.createTextNode(css));
}
var $66a418df8d4b954b$var$css_248z = ".graph-info-msg {\n  top: 50%;\n  width: 100%;\n  text-align: center;\n  color: lavender;\n  opacity: 0.7;\n  font-size: 22px;\n  position: absolute;\n  font-family: Sans-serif;\n}\n\n.scene-container .clickable {\n  cursor: pointer;\n}\n\n.scene-container .grabbable {\n  cursor: move;\n  cursor: grab;\n  cursor: -moz-grab;\n  cursor: -webkit-grab;\n}\n\n.scene-container .grabbable:active {\n  cursor: grabbing;\n  cursor: -moz-grabbing;\n  cursor: -webkit-grabbing;\n}";
$66a418df8d4b954b$var$styleInject($66a418df8d4b954b$var$css_248z);
function $66a418df8d4b954b$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $66a418df8d4b954b$var$_arrayWithoutHoles(r) {
    if (Array.isArray(r)) return $66a418df8d4b954b$var$_arrayLikeToArray(r);
}
function $66a418df8d4b954b$var$_defineProperty(e, r, t) {
    return (r = $66a418df8d4b954b$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $66a418df8d4b954b$var$_iterableToArray(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function $66a418df8d4b954b$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $66a418df8d4b954b$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $66a418df8d4b954b$var$_objectSpread2(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $66a418df8d4b954b$var$ownKeys(Object(t), !0).forEach(function(r) {
            $66a418df8d4b954b$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $66a418df8d4b954b$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $66a418df8d4b954b$var$_toConsumableArray(r) {
    return $66a418df8d4b954b$var$_arrayWithoutHoles(r) || $66a418df8d4b954b$var$_iterableToArray(r) || $66a418df8d4b954b$var$_unsupportedIterableToArray(r) || $66a418df8d4b954b$var$_nonIterableSpread();
}
function $66a418df8d4b954b$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $66a418df8d4b954b$var$_toPropertyKey(t) {
    var i = $66a418df8d4b954b$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $66a418df8d4b954b$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $66a418df8d4b954b$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $66a418df8d4b954b$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $66a418df8d4b954b$var$linkKapsule(kapsulePropName, kapsuleType) {
    var dummyK = new kapsuleType(); // To extract defaults
    dummyK._destructor && dummyK._destructor();
    return {
        linkProp: function linkProp(prop) {
            // link property config
            return {
                "default": dummyK[prop](),
                onChange: function onChange(v, state) {
                    state[kapsulePropName][prop](v);
                },
                triggerUpdate: false
            };
        },
        linkMethod: function linkMethod(method) {
            // link method pass-through
            return function(state) {
                var kapsuleInstance = state[kapsulePropName];
                for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
                var returnVal = kapsuleInstance[method].apply(kapsuleInstance, args);
                return returnVal === kapsuleInstance ? this // chain based on the parent object, not the inner kapsule
                 : returnVal;
            };
        }
    };
}
var $66a418df8d4b954b$var$three = window.THREE ? window.THREE // Prefer consumption from global THREE, if exists
 : {
    AmbientLight: (0, $d5b33d7c30034067$export$af279bfef9ec2c96),
    DirectionalLight: (0, $d5b33d7c30034067$export$3fea33cc9972c868),
    Vector3: (0, $d5b33d7c30034067$export$64b5c384219d3699),
    REVISION: (0, $d5b33d7c30034067$export$3545e07a80636437)
};
//
var $66a418df8d4b954b$var$CAMERA_DISTANCE2NODES_FACTOR = 170;
//
// Expose config from forceGraph
var $66a418df8d4b954b$var$bindFG = $66a418df8d4b954b$var$linkKapsule('forceGraph', (0, $e83b3346bbbc2544$export$2e2bcd8739ae039));
var $66a418df8d4b954b$var$linkedFGProps = Object.assign.apply(Object, $66a418df8d4b954b$var$_toConsumableArray([
    'jsonUrl',
    'graphData',
    'numDimensions',
    'dagMode',
    'dagLevelDistance',
    'dagNodeFilter',
    'onDagError',
    'nodeRelSize',
    'nodeId',
    'nodeVal',
    'nodeResolution',
    'nodeColor',
    'nodeAutoColorBy',
    'nodeOpacity',
    'nodeVisibility',
    'nodeThreeObject',
    'nodeThreeObjectExtend',
    'linkSource',
    'linkTarget',
    'linkVisibility',
    'linkColor',
    'linkAutoColorBy',
    'linkOpacity',
    'linkWidth',
    'linkResolution',
    'linkCurvature',
    'linkCurveRotation',
    'linkMaterial',
    'linkThreeObject',
    'linkThreeObjectExtend',
    'linkPositionUpdate',
    'linkDirectionalArrowLength',
    'linkDirectionalArrowColor',
    'linkDirectionalArrowRelPos',
    'linkDirectionalArrowResolution',
    'linkDirectionalParticles',
    'linkDirectionalParticleSpeed',
    'linkDirectionalParticleWidth',
    'linkDirectionalParticleColor',
    'linkDirectionalParticleResolution',
    'forceEngine',
    'd3AlphaDecay',
    'd3VelocityDecay',
    'd3AlphaMin',
    'ngraphPhysics',
    'warmupTicks',
    'cooldownTicks',
    'cooldownTime',
    'onEngineTick',
    'onEngineStop'
].map(function(p) {
    return $66a418df8d4b954b$var$_defineProperty({}, p, $66a418df8d4b954b$var$bindFG.linkProp(p));
})));
var $66a418df8d4b954b$var$linkedFGMethods = Object.assign.apply(Object, $66a418df8d4b954b$var$_toConsumableArray([
    'refresh',
    'getGraphBbox',
    'd3Force',
    'd3ReheatSimulation',
    'emitParticle'
].map(function(p) {
    return $66a418df8d4b954b$var$_defineProperty({}, p, $66a418df8d4b954b$var$bindFG.linkMethod(p));
})));
// Expose config from renderObjs
var $66a418df8d4b954b$var$bindRenderObjs = $66a418df8d4b954b$var$linkKapsule('renderObjs', (0, $69c9538f9a62b4e8$export$2e2bcd8739ae039));
var $66a418df8d4b954b$var$linkedRenderObjsProps = Object.assign.apply(Object, $66a418df8d4b954b$var$_toConsumableArray([
    'width',
    'height',
    'backgroundColor',
    'showNavInfo',
    'enablePointerInteraction'
].map(function(p) {
    return $66a418df8d4b954b$var$_defineProperty({}, p, $66a418df8d4b954b$var$bindRenderObjs.linkProp(p));
})));
var $66a418df8d4b954b$var$linkedRenderObjsMethods = Object.assign.apply(Object, $66a418df8d4b954b$var$_toConsumableArray([
    'lights',
    'cameraPosition',
    'postProcessingComposer'
].map(function(p) {
    return $66a418df8d4b954b$var$_defineProperty({}, p, $66a418df8d4b954b$var$bindRenderObjs.linkMethod(p));
})).concat([
    {
        graph2ScreenCoords: $66a418df8d4b954b$var$bindRenderObjs.linkMethod('getScreenCoords'),
        screen2GraphCoords: $66a418df8d4b954b$var$bindRenderObjs.linkMethod('getSceneCoords')
    }
]));
//
var $66a418df8d4b954b$export$2e2bcd8739ae039 = (0, $752852d7be1532d9$export$2e2bcd8739ae039)({
    props: $66a418df8d4b954b$var$_objectSpread2($66a418df8d4b954b$var$_objectSpread2({
        nodeLabel: {
            "default": 'name',
            triggerUpdate: false
        },
        linkLabel: {
            "default": 'name',
            triggerUpdate: false
        },
        linkHoverPrecision: {
            "default": 1,
            onChange: function onChange(p, state) {
                return state.renderObjs.lineHoverPrecision(p);
            },
            triggerUpdate: false
        },
        enableNavigationControls: {
            "default": true,
            onChange: function onChange(enable, state) {
                var controls = state.renderObjs.controls();
                if (controls) {
                    controls.enabled = enable;
                    // trigger mouseup on re-enable to prevent sticky controls
                    enable && controls.domElement && controls.domElement.dispatchEvent(new PointerEvent('pointerup'));
                }
            },
            triggerUpdate: false
        },
        enableNodeDrag: {
            "default": true,
            triggerUpdate: false
        },
        onNodeDrag: {
            "default": function _default() {},
            triggerUpdate: false
        },
        onNodeDragEnd: {
            "default": function _default() {},
            triggerUpdate: false
        },
        onNodeClick: {
            triggerUpdate: false
        },
        onNodeRightClick: {
            triggerUpdate: false
        },
        onNodeHover: {
            triggerUpdate: false
        },
        onLinkClick: {
            triggerUpdate: false
        },
        onLinkRightClick: {
            triggerUpdate: false
        },
        onLinkHover: {
            triggerUpdate: false
        },
        onBackgroundClick: {
            triggerUpdate: false
        },
        onBackgroundRightClick: {
            triggerUpdate: false
        }
    }, $66a418df8d4b954b$var$linkedFGProps), $66a418df8d4b954b$var$linkedRenderObjsProps),
    methods: $66a418df8d4b954b$var$_objectSpread2($66a418df8d4b954b$var$_objectSpread2({
        zoomToFit: function zoomToFit(state, transitionDuration, padding) {
            var _state$forceGraph;
            for(var _len = arguments.length, bboxArgs = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++)bboxArgs[_key - 3] = arguments[_key];
            state.renderObjs.fitToBbox((_state$forceGraph = state.forceGraph).getGraphBbox.apply(_state$forceGraph, bboxArgs), transitionDuration, padding);
            return this;
        },
        pauseAnimation: function pauseAnimation(state) {
            if (state.animationFrameRequestId !== null) {
                cancelAnimationFrame(state.animationFrameRequestId);
                state.animationFrameRequestId = null;
            }
            return this;
        },
        resumeAnimation: function resumeAnimation(state) {
            if (state.animationFrameRequestId === null) this._animationCycle();
            return this;
        },
        _animationCycle: function _animationCycle(state) {
            if (state.enablePointerInteraction) // reset canvas cursor (override dragControls cursor)
            this.renderer().domElement.style.cursor = null;
            // Frame cycle
            state.forceGraph.tickFrame();
            state.renderObjs.tick();
            state.animationFrameRequestId = requestAnimationFrame(this._animationCycle);
        },
        scene: function scene(state) {
            return state.renderObjs.scene();
        },
        // Expose scene
        camera: function camera(state) {
            return state.renderObjs.camera();
        },
        // Expose camera
        renderer: function renderer(state) {
            return state.renderObjs.renderer();
        },
        // Expose renderer
        controls: function controls(state) {
            return state.renderObjs.controls();
        },
        // Expose controls
        tbControls: function tbControls(state) {
            return state.renderObjs.tbControls();
        },
        // To be deprecated
        _destructor: function _destructor() {
            this.pauseAnimation();
            this.graphData({
                nodes: [],
                links: []
            });
        }
    }, $66a418df8d4b954b$var$linkedFGMethods), $66a418df8d4b954b$var$linkedRenderObjsMethods),
    stateInit: function stateInit(_ref5) {
        var controlType = _ref5.controlType, rendererConfig = _ref5.rendererConfig, extraRenderers = _ref5.extraRenderers;
        var forceGraph = new (0, $e83b3346bbbc2544$export$2e2bcd8739ae039)();
        return {
            forceGraph: forceGraph,
            renderObjs: (0, $69c9538f9a62b4e8$export$2e2bcd8739ae039)({
                controlType: controlType,
                rendererConfig: rendererConfig,
                extraRenderers: extraRenderers
            }).objects([
                forceGraph
            ]) // Populate scene
            .lights([
                new $66a418df8d4b954b$var$three.AmbientLight(0xcccccc, Math.PI),
                new $66a418df8d4b954b$var$three.DirectionalLight(0xffffff, 0.6 * Math.PI)
            ])
        };
    },
    init: function init(domNode, state) {
        // Wipe DOM
        domNode.innerHTML = '';
        // Add relative container
        domNode.appendChild(state.container = document.createElement('div'));
        state.container.style.position = 'relative';
        // Add renderObjs
        var roDomNode = document.createElement('div');
        state.container.appendChild(roDomNode);
        state.renderObjs(roDomNode);
        var camera = state.renderObjs.camera();
        var renderer = state.renderObjs.renderer();
        var controls = state.renderObjs.controls();
        controls.enabled = !!state.enableNavigationControls;
        state.lastSetCameraZ = camera.position.z;
        // Add info space
        var infoElem;
        state.container.appendChild(infoElem = document.createElement('div'));
        infoElem.className = 'graph-info-msg';
        infoElem.textContent = '';
        // config forcegraph
        state.forceGraph.onLoading(function() {
            infoElem.textContent = 'Loading...';
        }).onFinishLoading(function() {
            infoElem.textContent = '';
        }).onUpdate(function() {
            // sync graph data structures
            state.graphData = state.forceGraph.graphData();
            // re-aim camera, if still in default position (not user modified)
            if (camera.position.x === 0 && camera.position.y === 0 && camera.position.z === state.lastSetCameraZ && state.graphData.nodes.length) {
                camera.lookAt(state.forceGraph.position);
                state.lastSetCameraZ = camera.position.z = Math.cbrt(state.graphData.nodes.length) * $66a418df8d4b954b$var$CAMERA_DISTANCE2NODES_FACTOR;
            }
        }).onFinishUpdate(function() {
            // Setup node drag interaction
            if (state._dragControls) {
                var curNodeDrag = state.graphData.nodes.find(function(node) {
                    return node.__initialFixedPos && !node.__disposeControlsAfterDrag;
                }); // detect if there's a node being dragged using the existing drag controls
                if (curNodeDrag) curNodeDrag.__disposeControlsAfterDrag = true; // postpone previous controls disposal until drag ends
                else state._dragControls.dispose(); // cancel previous drag controls
                state._dragControls = undefined;
            }
            if (state.enableNodeDrag && state.enablePointerInteraction && state.forceEngine === 'd3') {
                // Can't access node positions programmatically in ngraph
                var dragControls = state._dragControls = new (0, $40043d5ea0db3d61$export$350d0cf1f91b53f4)(state.graphData.nodes.map(function(node) {
                    return node.__threeObj;
                }).filter(function(obj) {
                    return obj;
                }), camera, renderer.domElement);
                dragControls.addEventListener('dragstart', function(event) {
                    controls.enabled = false; // Disable controls while dragging
                    // track drag object movement
                    event.object.__initialPos = event.object.position.clone();
                    event.object.__prevPos = event.object.position.clone();
                    var node = $66a418df8d4b954b$var$getGraphObj(event.object).__data;
                    !node.__initialFixedPos && (node.__initialFixedPos = {
                        fx: node.fx,
                        fy: node.fy,
                        fz: node.fz
                    });
                    !node.__initialPos && (node.__initialPos = {
                        x: node.x,
                        y: node.y,
                        z: node.z
                    });
                    // lock node
                    [
                        'x',
                        'y',
                        'z'
                    ].forEach(function(c) {
                        return node["f".concat(c)] = node[c];
                    });
                    // drag cursor
                    renderer.domElement.classList.add('grabbable');
                });
                dragControls.addEventListener('drag', function(event) {
                    var nodeObj = $66a418df8d4b954b$var$getGraphObj(event.object);
                    if (!event.object.hasOwnProperty('__graphObjType')) {
                        // If dragging a child of the node, update the node object instead
                        var initPos = event.object.__initialPos;
                        var prevPos = event.object.__prevPos;
                        var _newPos = event.object.position;
                        nodeObj.position.add(_newPos.clone().sub(prevPos)); // translate node object by the motion delta
                        prevPos.copy(_newPos);
                        _newPos.copy(initPos); // reset child back to its initial position
                    }
                    var node = nodeObj.__data;
                    var newPos = nodeObj.position;
                    var translate = {
                        x: newPos.x - node.x,
                        y: newPos.y - node.y,
                        z: newPos.z - node.z
                    };
                    // Move fx/fy/fz (and x/y/z) of nodes based on object new position
                    [
                        'x',
                        'y',
                        'z'
                    ].forEach(function(c) {
                        return node["f".concat(c)] = node[c] = newPos[c];
                    });
                    state.forceGraph.d3AlphaTarget(0.3) // keep engine running at low intensity throughout drag
                    .resetCountdown(); // prevent freeze while dragging
                    node.__dragged = true;
                    state.onNodeDrag(node, translate);
                });
                dragControls.addEventListener('dragend', function(event) {
                    delete event.object.__initialPos; // remove tracking attributes
                    delete event.object.__prevPos;
                    var node = $66a418df8d4b954b$var$getGraphObj(event.object).__data;
                    // dispose previous controls if needed
                    if (node.__disposeControlsAfterDrag) {
                        dragControls.dispose();
                        delete node.__disposeControlsAfterDrag;
                    }
                    var initFixedPos = node.__initialFixedPos;
                    var initPos = node.__initialPos;
                    var translate = {
                        x: initPos.x - node.x,
                        y: initPos.y - node.y,
                        z: initPos.z - node.z
                    };
                    if (initFixedPos) {
                        [
                            'x',
                            'y',
                            'z'
                        ].forEach(function(c) {
                            var fc = "f".concat(c);
                            if (initFixedPos[fc] === undefined) delete node[fc];
                        });
                        delete node.__initialFixedPos;
                        delete node.__initialPos;
                        if (node.__dragged) {
                            delete node.__dragged;
                            state.onNodeDragEnd(node, translate);
                        }
                    }
                    state.forceGraph.d3AlphaTarget(0) // release engine low intensity
                    .resetCountdown(); // let the engine readjust after releasing fixed nodes
                    if (state.enableNavigationControls) {
                        controls.enabled = true; // Re-enable controls
                        controls.domElement && controls.domElement.ownerDocument && controls.domElement.ownerDocument.dispatchEvent(// simulate mouseup to ensure the controls don't take over after dragend
                        new PointerEvent('pointerup', {
                            pointerType: 'touch'
                        }));
                    }
                    // clear cursor
                    renderer.domElement.classList.remove('grabbable');
                });
            }
        });
        // config renderObjs
        $66a418df8d4b954b$var$three.REVISION < 155 && (state.renderObjs.renderer().useLegacyLights = false); // force behavior for three < 155
        state.renderObjs.hoverOrderComparator(function(a, b) {
            // Prioritize graph objects
            var aObj = $66a418df8d4b954b$var$getGraphObj(a);
            if (!aObj) return 1;
            var bObj = $66a418df8d4b954b$var$getGraphObj(b);
            if (!bObj) return -1;
            // Prioritize nodes over links
            var isNode = function isNode(o) {
                return o.__graphObjType === 'node';
            };
            return isNode(bObj) - isNode(aObj);
        }).tooltipContent(function(obj) {
            var graphObj = $66a418df8d4b954b$var$getGraphObj(obj);
            return graphObj ? (0, $85d8080a057d7be2$export$2e2bcd8739ae039)(state["".concat(graphObj.__graphObjType, "Label")])(graphObj.__data) || '' : '';
        }).hoverDuringDrag(false).onHover(function(obj) {
            // Update tooltip and trigger onHover events
            var hoverObj = $66a418df8d4b954b$var$getGraphObj(obj);
            if (hoverObj !== state.hoverObj) {
                var prevObjType = state.hoverObj ? state.hoverObj.__graphObjType : null;
                var prevObjData = state.hoverObj ? state.hoverObj.__data : null;
                var objType = hoverObj ? hoverObj.__graphObjType : null;
                var objData = hoverObj ? hoverObj.__data : null;
                if (prevObjType && prevObjType !== objType) {
                    // Hover out
                    var fn = state["on".concat(prevObjType === 'node' ? 'Node' : 'Link', "Hover")];
                    fn && fn(null, prevObjData);
                }
                if (objType) {
                    // Hover in
                    var _fn = state["on".concat(objType === 'node' ? 'Node' : 'Link', "Hover")];
                    _fn && _fn(objData, prevObjType === objType ? prevObjData : null);
                }
                // set pointer if hovered object is clickable
                renderer.domElement.classList[hoverObj && state["on".concat(objType === 'node' ? 'Node' : 'Link', "Click")] || !hoverObj && state.onBackgroundClick ? 'add' : 'remove']('clickable');
                state.hoverObj = hoverObj;
            }
        }).clickAfterDrag(false).onClick(function(obj, ev) {
            var graphObj = $66a418df8d4b954b$var$getGraphObj(obj);
            if (graphObj) {
                var fn = state["on".concat(graphObj.__graphObjType === 'node' ? 'Node' : 'Link', "Click")];
                fn && fn(graphObj.__data, ev);
            } else state.onBackgroundClick && state.onBackgroundClick(ev);
        }).onRightClick(function(obj, ev) {
            // Handle right-click events
            var graphObj = $66a418df8d4b954b$var$getGraphObj(obj);
            if (graphObj) {
                var fn = state["on".concat(graphObj.__graphObjType === 'node' ? 'Node' : 'Link', "RightClick")];
                fn && fn(graphObj.__data, ev);
            } else state.onBackgroundRightClick && state.onBackgroundRightClick(ev);
        });
        //
        // Kick-off renderer
        this._animationCycle();
    }
});
//
function $66a418df8d4b954b$var$getGraphObj(object) {
    var obj = object;
    // recurse up object chain until finding the graph object
    while(obj && !obj.hasOwnProperty('__graphObjType'))obj = obj.parent;
    return obj;
}


var $8da5bfbbed271cd7$exports = {};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $8da5bfbbed271cd7$var$ReactIs, $8da5bfbbed271cd7$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
$8da5bfbbed271cd7$exports = (parcelRequire("hOzOt"))();


const $fb74db41c312cc9d$var$commonPropTypes = {
    width: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
    height: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
    graphData: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).shape({
        nodes: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).object).isRequired,
        links: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).object).isRequired
    }),
    backgroundColor: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
    nodeRelSize: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
    nodeId: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
    nodeLabel: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func
    ]),
    nodeVal: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func
    ]),
    nodeVisibility: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func
    ]),
    nodeColor: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func
    ]),
    nodeAutoColorBy: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func
    ]),
    onNodeHover: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    onNodeClick: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    linkSource: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
    linkTarget: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
    linkLabel: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func
    ]),
    linkVisibility: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func
    ]),
    linkColor: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func
    ]),
    linkAutoColorBy: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func
    ]),
    linkWidth: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func
    ]),
    linkCurvature: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func
    ]),
    linkDirectionalArrowLength: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func
    ]),
    linkDirectionalArrowColor: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func
    ]),
    linkDirectionalArrowRelPos: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func
    ]),
    linkDirectionalParticles: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func
    ]),
    linkDirectionalParticleSpeed: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func
    ]),
    linkDirectionalParticleWidth: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func
    ]),
    linkDirectionalParticleColor: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func
    ]),
    onLinkHover: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    onLinkClick: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    dagMode: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOf([
        'td',
        'bu',
        'lr',
        'rl',
        'zin',
        'zout',
        'radialin',
        'radialout'
    ]),
    dagLevelDistance: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
    dagNodeFilter: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    onDagError: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    d3AlphaMin: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
    d3AlphaDecay: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
    d3VelocityDecay: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
    warmupTicks: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
    cooldownTicks: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
    cooldownTime: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
    onEngineTick: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    onEngineStop: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    getGraphBbox: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func
};
const $fb74db41c312cc9d$var$pointerBasedPropTypes = {
    zoomToFit: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    onNodeRightClick: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    onNodeDrag: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    onNodeDragEnd: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    onLinkRightClick: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    linkHoverPrecision: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
    onBackgroundClick: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    onBackgroundRightClick: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    enablePointerInteraction: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    enableNodeDrag: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool
};
const $fb74db41c312cc9d$var$threeBasedPropTypes = {
    showNavInfo: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    nodeOpacity: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
    nodeResolution: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
    nodeThreeObject: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func
    ]),
    nodeThreeObjectExtend: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func
    ]),
    linkOpacity: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
    linkResolution: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
    linkCurveRotation: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func
    ]),
    linkMaterial: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func
    ]),
    linkThreeObject: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func
    ]),
    linkThreeObjectExtend: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func
    ]),
    linkPositionUpdate: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    linkDirectionalArrowResolution: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
    linkDirectionalParticleResolution: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
    forceEngine: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOf([
        'd3',
        'ngraph'
    ]),
    ngraphPhysics: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).object,
    numDimensions: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOf([
        1,
        2,
        3
    ])
};
Object.assign({}, $fb74db41c312cc9d$var$commonPropTypes, $fb74db41c312cc9d$var$pointerBasedPropTypes, {
    linkLineDash: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number),
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func
    ]),
    nodeCanvasObjectMode: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func
    ]),
    nodeCanvasObject: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    nodePointerAreaPaint: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    linkCanvasObjectMode: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func
    ]),
    linkCanvasObject: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    linkPointerAreaPaint: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    autoPauseRedraw: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    minZoom: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
    maxZoom: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
    enableZoomInteraction: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func
    ]),
    enablePanInteraction: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func
    ]),
    onZoom: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    onZoomEnd: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    onRenderFramePre: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    onRenderFramePost: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func
});
const $fb74db41c312cc9d$var$ForceGraph3DPropTypes = Object.assign({}, $fb74db41c312cc9d$var$commonPropTypes, $fb74db41c312cc9d$var$pointerBasedPropTypes, $fb74db41c312cc9d$var$threeBasedPropTypes, {
    enableNavigationControls: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    controlType: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOf([
        'trackball',
        'orbit',
        'fly'
    ]),
    rendererConfig: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).object,
    extraRenderers: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).shape({
        render: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func.isRequired
    }))
});
Object.assign({}, $fb74db41c312cc9d$var$commonPropTypes, $fb74db41c312cc9d$var$threeBasedPropTypes, {
    nodeDesc: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func
    ]),
    linkDesc: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func
    ])
});
Object.assign({}, $fb74db41c312cc9d$var$commonPropTypes, $fb74db41c312cc9d$var$threeBasedPropTypes, {
    markerAttrs: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).object,
    yOffset: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
    glScale: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number
});
const $fb74db41c312cc9d$export$2e2bcd8739ae039 = (0, $5d3aea6df4994d8c$export$2e2bcd8739ae039)((0, $66a418df8d4b954b$export$2e2bcd8739ae039), {
    methodNames: [
        // bind methods
        'emitParticle',
        'd3Force',
        'd3ReheatSimulation',
        'stopAnimation',
        'pauseAnimation',
        'resumeAnimation',
        'cameraPosition',
        'zoomToFit',
        'getGraphBbox',
        'screen2GraphCoords',
        'graph2ScreenCoords',
        'postProcessingComposer',
        'lights',
        'scene',
        'camera',
        'renderer',
        'controls',
        'refresh'
    ],
    initPropNames: [
        'controlType',
        'rendererConfig',
        'extraRenderers'
    ]
});
$fb74db41c312cc9d$export$2e2bcd8739ae039.displayName = 'ForceGraph3D';
$fb74db41c312cc9d$export$2e2bcd8739ae039.propTypes = $fb74db41c312cc9d$var$ForceGraph3DPropTypes;


/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var $5c96a02c592fcff1$var$extendStatics = function(d, b) {
    $5c96a02c592fcff1$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $5c96a02c592fcff1$var$extendStatics(d, b);
};
function $5c96a02c592fcff1$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $5c96a02c592fcff1$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $5c96a02c592fcff1$export$18ce0697a983be9b = function() {
    $5c96a02c592fcff1$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $5c96a02c592fcff1$export$18ce0697a983be9b.apply(this, arguments);
};
function $5c96a02c592fcff1$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $5c96a02c592fcff1$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $5c96a02c592fcff1$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $5c96a02c592fcff1$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $5c96a02c592fcff1$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $5c96a02c592fcff1$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $5c96a02c592fcff1$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $5c96a02c592fcff1$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $5c96a02c592fcff1$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $5c96a02c592fcff1$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $5c96a02c592fcff1$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $5c96a02c592fcff1$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $5c96a02c592fcff1$export$45d3717a4c69092e(o, m, p);
}
function $5c96a02c592fcff1$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $5c96a02c592fcff1$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $5c96a02c592fcff1$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($5c96a02c592fcff1$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $5c96a02c592fcff1$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $5c96a02c592fcff1$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $5c96a02c592fcff1$export$10c90e4f7922046c(v) {
    return this instanceof $5c96a02c592fcff1$export$10c90e4f7922046c ? (this.v = v, this) : new $5c96a02c592fcff1$export$10c90e4f7922046c(v);
}
function $5c96a02c592fcff1$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $5c96a02c592fcff1$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $5c96a02c592fcff1$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $5c96a02c592fcff1$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $5c96a02c592fcff1$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $5c96a02c592fcff1$export$19a8beecd37a4c45 === "function" ? $5c96a02c592fcff1$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $5c96a02c592fcff1$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $5c96a02c592fcff1$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $5c96a02c592fcff1$var$ownKeys = function(o) {
    $5c96a02c592fcff1$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $5c96a02c592fcff1$var$ownKeys(o);
};
function $5c96a02c592fcff1$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $5c96a02c592fcff1$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $5c96a02c592fcff1$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $5c96a02c592fcff1$var$__setModuleDefault(result, mod);
    return result;
}
function $5c96a02c592fcff1$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $5c96a02c592fcff1$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $5c96a02c592fcff1$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $5c96a02c592fcff1$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $5c96a02c592fcff1$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $5c96a02c592fcff1$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $5c96a02c592fcff1$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $5c96a02c592fcff1$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $5c96a02c592fcff1$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $5c96a02c592fcff1$export$2e2bcd8739ae039 = {
    __extends: $5c96a02c592fcff1$export$a8ba968b8961cb8a,
    __assign: $5c96a02c592fcff1$export$18ce0697a983be9b,
    __rest: $5c96a02c592fcff1$export$3c9a16f847548506,
    __decorate: $5c96a02c592fcff1$export$29e00dfd3077644b,
    __param: $5c96a02c592fcff1$export$d5ad3fd78186038f,
    __esDecorate: $5c96a02c592fcff1$export$3a84e1ae4e97e9b0,
    __runInitializers: $5c96a02c592fcff1$export$d831c04e792af3d,
    __propKey: $5c96a02c592fcff1$export$6a2a36740a146cb8,
    __setFunctionName: $5c96a02c592fcff1$export$d1a06452d3489bc7,
    __metadata: $5c96a02c592fcff1$export$f1db080c865becb9,
    __awaiter: $5c96a02c592fcff1$export$1050f835b63b671e,
    __generator: $5c96a02c592fcff1$export$67ebef60e6f28a6,
    __createBinding: $5c96a02c592fcff1$export$45d3717a4c69092e,
    __exportStar: $5c96a02c592fcff1$export$f33643c0debef087,
    __values: $5c96a02c592fcff1$export$19a8beecd37a4c45,
    __read: $5c96a02c592fcff1$export$8d051b38c9118094,
    __spread: $5c96a02c592fcff1$export$afc72e2116322959,
    __spreadArrays: $5c96a02c592fcff1$export$6388937ca91ccae8,
    __spreadArray: $5c96a02c592fcff1$export$1216008129fb82ed,
    __await: $5c96a02c592fcff1$export$10c90e4f7922046c,
    __asyncGenerator: $5c96a02c592fcff1$export$e427f37a30a4de9b,
    __asyncDelegator: $5c96a02c592fcff1$export$bbd80228419bb833,
    __asyncValues: $5c96a02c592fcff1$export$e3b29a3d6162315f,
    __makeTemplateObject: $5c96a02c592fcff1$export$4fb47efe1390b86f,
    __importStar: $5c96a02c592fcff1$export$c21735bcef00d192,
    __importDefault: $5c96a02c592fcff1$export$da59b14a69baef04,
    __classPrivateFieldGet: $5c96a02c592fcff1$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $5c96a02c592fcff1$export$d40a35129aaff81f,
    __classPrivateFieldIn: $5c96a02c592fcff1$export$81fdc39f203e4e04,
    __addDisposableResource: $5c96a02c592fcff1$export$88ac25d8e944e405,
    __disposeResources: $5c96a02c592fcff1$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $5c96a02c592fcff1$export$889dfb5d17574b0b
};



var $7c30baa29d2eb832$var$genericMessage = "Invariant Violation";
var $7c30baa29d2eb832$var$_a = Object.setPrototypeOf, $7c30baa29d2eb832$var$setPrototypeOf = $7c30baa29d2eb832$var$_a === void 0 ? function(obj, proto) {
    obj.__proto__ = proto;
    return obj;
} : $7c30baa29d2eb832$var$_a;
var $7c30baa29d2eb832$export$cea12affaee22fe8 = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(InvariantError, _super);
    function InvariantError(message) {
        if (message === void 0) message = $7c30baa29d2eb832$var$genericMessage;
        var _this = _super.call(this, typeof message === "number" ? $7c30baa29d2eb832$var$genericMessage + ": " + message + " (see https://github.com/apollographql/invariant-packages)" : message) || this;
        _this.framesToPop = 1;
        _this.name = $7c30baa29d2eb832$var$genericMessage;
        $7c30baa29d2eb832$var$setPrototypeOf(_this, InvariantError.prototype);
        return _this;
    }
    return InvariantError;
}(Error);
function $7c30baa29d2eb832$export$f5708dca728d7177(condition, message) {
    if (!condition) throw new $7c30baa29d2eb832$export$cea12affaee22fe8(message);
}
var $7c30baa29d2eb832$var$verbosityLevels = [
    "debug",
    "log",
    "warn",
    "error",
    "silent"
];
var $7c30baa29d2eb832$var$verbosityLevel = $7c30baa29d2eb832$var$verbosityLevels.indexOf("log");
function $7c30baa29d2eb832$var$wrapConsoleMethod(name) {
    return function() {
        if ($7c30baa29d2eb832$var$verbosityLevels.indexOf(name) >= $7c30baa29d2eb832$var$verbosityLevel) {
            // Default to console.log if this host environment happens not to provide
            // all the console.* methods we need.
            var method = console[name] || console.log;
            return method.apply(console, arguments);
        }
    };
}
(function(invariant) {
    invariant.debug = $7c30baa29d2eb832$var$wrapConsoleMethod("debug");
    invariant.log = $7c30baa29d2eb832$var$wrapConsoleMethod("log");
    invariant.warn = $7c30baa29d2eb832$var$wrapConsoleMethod("warn");
    invariant.error = $7c30baa29d2eb832$var$wrapConsoleMethod("error");
})($7c30baa29d2eb832$export$f5708dca728d7177 || ($7c30baa29d2eb832$export$f5708dca728d7177 = {}));
function $7c30baa29d2eb832$export$a80e09f2cd325fb8(level) {
    var old = $7c30baa29d2eb832$var$verbosityLevels[$7c30baa29d2eb832$var$verbosityLevel];
    $7c30baa29d2eb832$var$verbosityLevel = Math.max(0, $7c30baa29d2eb832$var$verbosityLevels.indexOf(level));
    return old;
}
var $7c30baa29d2eb832$export$2e2bcd8739ae039 = $7c30baa29d2eb832$export$f5708dca728d7177;


var $fb2c94d2c044c7c5$export$83d89fbfd8236492 = "3.11.10";


function $3ac3e23fcbe2d68c$export$f8b8b9ce72e9ccbf(thunk) {
    try {
        return thunk();
    } catch (_a) {}
}


var $d461b0c33b06d27f$export$2e2bcd8739ae039 = (0, $3ac3e23fcbe2d68c$export$f8b8b9ce72e9ccbf)(function() {
    return globalThis;
}) || (0, $3ac3e23fcbe2d68c$export$f8b8b9ce72e9ccbf)(function() {
    return window;
}) || (0, $3ac3e23fcbe2d68c$export$f8b8b9ce72e9ccbf)(function() {
    return self;
}) || (0, $3ac3e23fcbe2d68c$export$f8b8b9ce72e9ccbf)(function() {
    return $parcel$global;
}) || // We don't expect the Function constructor ever to be invoked at runtime, as
// long as at least one of globalThis, window, self, or global is defined, so
// we are under no obligation to make it easy for static analysis tools to
// detect syntactic usage of the Function constructor. If you think you can
// improve your static analysis to detect this obfuscation, think again. This
// is an arms race you cannot win, at least not in JavaScript.
(0, $3ac3e23fcbe2d68c$export$f8b8b9ce72e9ccbf)(function() {
    return (0, $3ac3e23fcbe2d68c$export$f8b8b9ce72e9ccbf).constructor("return this")();
});


var $14071c0503b706b7$var$prefixCounts = new Map();
function $14071c0503b706b7$export$d0c8ec0fe1b18b70(prefix) {
    var count = $14071c0503b706b7$var$prefixCounts.get(prefix) || 1;
    $14071c0503b706b7$var$prefixCounts.set(prefix, count + 1);
    return "".concat(prefix, ":").concat(count, ":").concat(Math.random().toString(36).slice(2));
}


function $29a424226342d3ac$export$f341b4883239463f(value, space) {
    if (space === void 0) space = 0;
    var undefId = (0, $14071c0503b706b7$export$d0c8ec0fe1b18b70)("stringifyForDisplay");
    return JSON.stringify(value, function(key, value) {
        return value === void 0 ? undefId : value;
    }, space).split(JSON.stringify(undefId)).join("<undefined>");
}


function $28d90d877eb1e517$var$wrap(fn) {
    return function(message) {
        var args = [];
        for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
        if (typeof message === "number") {
            var arg0 = message;
            message = $28d90d877eb1e517$var$getHandledErrorMsg(arg0);
            if (!message) {
                message = $28d90d877eb1e517$var$getFallbackErrorMsg(arg0, args);
                args = [];
            }
        }
        fn.apply(void 0, [
            message
        ].concat(args));
    };
}
var $28d90d877eb1e517$export$f5708dca728d7177 = Object.assign(function invariant(condition, message) {
    var args = [];
    for(var _i = 2; _i < arguments.length; _i++)args[_i - 2] = arguments[_i];
    if (!condition) (0, $7c30baa29d2eb832$export$f5708dca728d7177)(condition, $28d90d877eb1e517$var$getHandledErrorMsg(message, args) || $28d90d877eb1e517$var$getFallbackErrorMsg(message, args));
}, {
    debug: $28d90d877eb1e517$var$wrap((0, $7c30baa29d2eb832$export$f5708dca728d7177).debug),
    log: $28d90d877eb1e517$var$wrap((0, $7c30baa29d2eb832$export$f5708dca728d7177).log),
    warn: $28d90d877eb1e517$var$wrap((0, $7c30baa29d2eb832$export$f5708dca728d7177).warn),
    error: $28d90d877eb1e517$var$wrap((0, $7c30baa29d2eb832$export$f5708dca728d7177).error)
});
/**
 * Returns an InvariantError.
 *
 * `message` can only be a string, a concatenation of strings, or a ternary statement
 * that results in a string. This will be enforced on build, where the message will
 * be replaced with a message number.
 * String substitutions with %s are supported and will also return
 * pretty-stringified objects.
 * Excess `optionalParams` will be swallowed.
 */ function $28d90d877eb1e517$export$3991762405098ea(message) {
    var optionalParams = [];
    for(var _i = 1; _i < arguments.length; _i++)optionalParams[_i - 1] = arguments[_i];
    return new (0, $7c30baa29d2eb832$export$cea12affaee22fe8)($28d90d877eb1e517$var$getHandledErrorMsg(message, optionalParams) || $28d90d877eb1e517$var$getFallbackErrorMsg(message, optionalParams));
}
var $28d90d877eb1e517$export$b8ca975fa04efdf3 = Symbol.for("ApolloErrorMessageHandler_" + (0, $fb2c94d2c044c7c5$export$83d89fbfd8236492));
function $28d90d877eb1e517$var$stringify(arg) {
    if (typeof arg == "string") return arg;
    try {
        return (0, $29a424226342d3ac$export$f341b4883239463f)(arg, 2).slice(0, 1000);
    } catch (_a) {
        return "<non-serializable>";
    }
}
function $28d90d877eb1e517$var$getHandledErrorMsg(message, messageArgs) {
    if (messageArgs === void 0) messageArgs = [];
    if (!message) return;
    return (0, $d461b0c33b06d27f$export$2e2bcd8739ae039)[$28d90d877eb1e517$export$b8ca975fa04efdf3] && (0, $d461b0c33b06d27f$export$2e2bcd8739ae039)[$28d90d877eb1e517$export$b8ca975fa04efdf3](message, messageArgs.map($28d90d877eb1e517$var$stringify));
}
function $28d90d877eb1e517$var$getFallbackErrorMsg(message, messageArgs) {
    if (messageArgs === void 0) messageArgs = [];
    if (!message) return;
    return "An error occurred! For more details, see the full error text at https://go.apollo.dev/c/err#".concat(encodeURIComponent(JSON.stringify({
        version: (0, $fb2c94d2c044c7c5$export$83d89fbfd8236492),
        message: message,
        args: messageArgs.map($28d90d877eb1e517$var$stringify)
    })));
}




var $bd560f7419fc8fee$export$404582bc18fe4d9e = globalThis.__DEV__ !== false;



function $6d99a9de69717ea6$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $6d99a9de69717ea6$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $6d99a9de69717ea6$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $6d99a9de69717ea6$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $6d99a9de69717ea6$var$_arrayLikeToArray(o, minLen);
}
function $6d99a9de69717ea6$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $6d99a9de69717ea6$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $6d99a9de69717ea6$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $6d99a9de69717ea6$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $6d99a9de69717ea6$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
// === Symbol Support ===
var $6d99a9de69717ea6$var$hasSymbols = function() {
    return typeof Symbol === 'function';
};
var $6d99a9de69717ea6$var$hasSymbol = function(name) {
    return $6d99a9de69717ea6$var$hasSymbols() && Boolean(Symbol[name]);
};
var $6d99a9de69717ea6$var$getSymbol = function(name) {
    return $6d99a9de69717ea6$var$hasSymbol(name) ? Symbol[name] : '@@' + name;
};
if ($6d99a9de69717ea6$var$hasSymbols() && !$6d99a9de69717ea6$var$hasSymbol('observable')) Symbol.observable = Symbol('observable');
var $6d99a9de69717ea6$var$SymbolIterator = $6d99a9de69717ea6$var$getSymbol('iterator');
var $6d99a9de69717ea6$var$SymbolObservable = $6d99a9de69717ea6$var$getSymbol('observable');
var $6d99a9de69717ea6$var$SymbolSpecies = $6d99a9de69717ea6$var$getSymbol('species'); // === Abstract Operations ===
function $6d99a9de69717ea6$var$getMethod(obj, key) {
    var value = obj[key];
    if (value == null) return undefined;
    if (typeof value !== 'function') throw new TypeError(value + ' is not a function');
    return value;
}
function $6d99a9de69717ea6$var$getSpecies(obj) {
    var ctor = obj.constructor;
    if (ctor !== undefined) {
        ctor = ctor[$6d99a9de69717ea6$var$SymbolSpecies];
        if (ctor === null) ctor = undefined;
    }
    return ctor !== undefined ? ctor : $6d99a9de69717ea6$export$77cea355fa80b5f4;
}
function $6d99a9de69717ea6$var$isObservable(x) {
    return x instanceof $6d99a9de69717ea6$export$77cea355fa80b5f4; // SPEC: Brand check
}
function $6d99a9de69717ea6$var$hostReportError(e) {
    if ($6d99a9de69717ea6$var$hostReportError.log) $6d99a9de69717ea6$var$hostReportError.log(e);
    else setTimeout(function() {
        throw e;
    });
}
function $6d99a9de69717ea6$var$enqueue(fn) {
    Promise.resolve().then(function() {
        try {
            fn();
        } catch (e) {
            $6d99a9de69717ea6$var$hostReportError(e);
        }
    });
}
function $6d99a9de69717ea6$var$cleanupSubscription(subscription) {
    var cleanup = subscription._cleanup;
    if (cleanup === undefined) return;
    subscription._cleanup = undefined;
    if (!cleanup) return;
    try {
        if (typeof cleanup === 'function') cleanup();
        else {
            var unsubscribe = $6d99a9de69717ea6$var$getMethod(cleanup, 'unsubscribe');
            if (unsubscribe) unsubscribe.call(cleanup);
        }
    } catch (e) {
        $6d99a9de69717ea6$var$hostReportError(e);
    }
}
function $6d99a9de69717ea6$var$closeSubscription(subscription) {
    subscription._observer = undefined;
    subscription._queue = undefined;
    subscription._state = 'closed';
}
function $6d99a9de69717ea6$var$flushSubscription(subscription) {
    var queue = subscription._queue;
    if (!queue) return;
    subscription._queue = undefined;
    subscription._state = 'ready';
    for(var i = 0; i < queue.length; ++i){
        $6d99a9de69717ea6$var$notifySubscription(subscription, queue[i].type, queue[i].value);
        if (subscription._state === 'closed') break;
    }
}
function $6d99a9de69717ea6$var$notifySubscription(subscription, type, value) {
    subscription._state = 'running';
    var observer = subscription._observer;
    try {
        var m = $6d99a9de69717ea6$var$getMethod(observer, type);
        switch(type){
            case 'next':
                if (m) m.call(observer, value);
                break;
            case 'error':
                $6d99a9de69717ea6$var$closeSubscription(subscription);
                if (m) m.call(observer, value);
                else throw value;
                break;
            case 'complete':
                $6d99a9de69717ea6$var$closeSubscription(subscription);
                if (m) m.call(observer);
                break;
        }
    } catch (e) {
        $6d99a9de69717ea6$var$hostReportError(e);
    }
    if (subscription._state === 'closed') $6d99a9de69717ea6$var$cleanupSubscription(subscription);
    else if (subscription._state === 'running') subscription._state = 'ready';
}
function $6d99a9de69717ea6$var$onNotify(subscription, type, value) {
    if (subscription._state === 'closed') return;
    if (subscription._state === 'buffering') {
        subscription._queue.push({
            type: type,
            value: value
        });
        return;
    }
    if (subscription._state !== 'ready') {
        subscription._state = 'buffering';
        subscription._queue = [
            {
                type: type,
                value: value
            }
        ];
        $6d99a9de69717ea6$var$enqueue(function() {
            return $6d99a9de69717ea6$var$flushSubscription(subscription);
        });
        return;
    }
    $6d99a9de69717ea6$var$notifySubscription(subscription, type, value);
}
var $6d99a9de69717ea6$var$Subscription = /*#__PURE__*/ function() {
    function Subscription(observer, subscriber) {
        // ASSERT: observer is an object
        // ASSERT: subscriber is callable
        this._cleanup = undefined;
        this._observer = observer;
        this._queue = undefined;
        this._state = 'initializing';
        var subscriptionObserver = new $6d99a9de69717ea6$var$SubscriptionObserver(this);
        try {
            this._cleanup = subscriber.call(undefined, subscriptionObserver);
        } catch (e) {
            subscriptionObserver.error(e);
        }
        if (this._state === 'initializing') this._state = 'ready';
    }
    var _proto = Subscription.prototype;
    _proto.unsubscribe = function unsubscribe() {
        if (this._state !== 'closed') {
            $6d99a9de69717ea6$var$closeSubscription(this);
            $6d99a9de69717ea6$var$cleanupSubscription(this);
        }
    };
    $6d99a9de69717ea6$var$_createClass(Subscription, [
        {
            key: "closed",
            get: function() {
                return this._state === 'closed';
            }
        }
    ]);
    return Subscription;
}();
var $6d99a9de69717ea6$var$SubscriptionObserver = /*#__PURE__*/ function() {
    function SubscriptionObserver(subscription) {
        this._subscription = subscription;
    }
    var _proto2 = SubscriptionObserver.prototype;
    _proto2.next = function next(value) {
        $6d99a9de69717ea6$var$onNotify(this._subscription, 'next', value);
    };
    _proto2.error = function error(value) {
        $6d99a9de69717ea6$var$onNotify(this._subscription, 'error', value);
    };
    _proto2.complete = function complete() {
        $6d99a9de69717ea6$var$onNotify(this._subscription, 'complete');
    };
    $6d99a9de69717ea6$var$_createClass(SubscriptionObserver, [
        {
            key: "closed",
            get: function() {
                return this._subscription._state === 'closed';
            }
        }
    ]);
    return SubscriptionObserver;
}();
var $6d99a9de69717ea6$export$77cea355fa80b5f4 = /*#__PURE__*/ function() {
    function Observable(subscriber) {
        if (!(this instanceof Observable)) throw new TypeError('Observable cannot be called as a function');
        if (typeof subscriber !== 'function') throw new TypeError('Observable initializer must be a function');
        this._subscriber = subscriber;
    }
    var _proto3 = Observable.prototype;
    _proto3.subscribe = function subscribe(observer) {
        if (typeof observer !== 'object' || observer === null) observer = {
            next: observer,
            error: arguments[1],
            complete: arguments[2]
        };
        return new $6d99a9de69717ea6$var$Subscription(observer, this._subscriber);
    };
    _proto3.forEach = function forEach(fn) {
        var _this = this;
        return new Promise(function(resolve, reject) {
            if (typeof fn !== 'function') {
                reject(new TypeError(fn + ' is not a function'));
                return;
            }
            function done() {
                subscription.unsubscribe();
                resolve();
            }
            var subscription = _this.subscribe({
                next: function(value) {
                    try {
                        fn(value, done);
                    } catch (e) {
                        reject(e);
                        subscription.unsubscribe();
                    }
                },
                error: reject,
                complete: resolve
            });
        });
    };
    _proto3.map = function map(fn) {
        var _this2 = this;
        if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
        var C = $6d99a9de69717ea6$var$getSpecies(this);
        return new C(function(observer) {
            return _this2.subscribe({
                next: function(value) {
                    try {
                        value = fn(value);
                    } catch (e) {
                        return observer.error(e);
                    }
                    observer.next(value);
                },
                error: function(e) {
                    observer.error(e);
                },
                complete: function() {
                    observer.complete();
                }
            });
        });
    };
    _proto3.filter = function filter(fn) {
        var _this3 = this;
        if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
        var C = $6d99a9de69717ea6$var$getSpecies(this);
        return new C(function(observer) {
            return _this3.subscribe({
                next: function(value) {
                    try {
                        if (!fn(value)) return;
                    } catch (e) {
                        return observer.error(e);
                    }
                    observer.next(value);
                },
                error: function(e) {
                    observer.error(e);
                },
                complete: function() {
                    observer.complete();
                }
            });
        });
    };
    _proto3.reduce = function reduce(fn) {
        var _this4 = this;
        if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
        var C = $6d99a9de69717ea6$var$getSpecies(this);
        var hasSeed = arguments.length > 1;
        var hasValue = false;
        var seed = arguments[1];
        var acc = seed;
        return new C(function(observer) {
            return _this4.subscribe({
                next: function(value) {
                    var first = !hasValue;
                    hasValue = true;
                    if (!first || hasSeed) try {
                        acc = fn(acc, value);
                    } catch (e) {
                        return observer.error(e);
                    }
                    else acc = value;
                },
                error: function(e) {
                    observer.error(e);
                },
                complete: function() {
                    if (!hasValue && !hasSeed) return observer.error(new TypeError('Cannot reduce an empty sequence'));
                    observer.next(acc);
                    observer.complete();
                }
            });
        });
    };
    _proto3.concat = function concat() {
        var _this5 = this;
        for(var _len = arguments.length, sources = new Array(_len), _key = 0; _key < _len; _key++)sources[_key] = arguments[_key];
        var C = $6d99a9de69717ea6$var$getSpecies(this);
        return new C(function(observer) {
            var subscription;
            var index = 0;
            function startNext(next) {
                subscription = next.subscribe({
                    next: function(v) {
                        observer.next(v);
                    },
                    error: function(e) {
                        observer.error(e);
                    },
                    complete: function() {
                        if (index === sources.length) {
                            subscription = undefined;
                            observer.complete();
                        } else startNext(C.from(sources[index++]));
                    }
                });
            }
            startNext(_this5);
            return function() {
                if (subscription) {
                    subscription.unsubscribe();
                    subscription = undefined;
                }
            };
        });
    };
    _proto3.flatMap = function flatMap(fn) {
        var _this6 = this;
        if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
        var C = $6d99a9de69717ea6$var$getSpecies(this);
        return new C(function(observer) {
            var subscriptions = [];
            var outer = _this6.subscribe({
                next: function(value) {
                    if (fn) try {
                        value = fn(value);
                    } catch (e) {
                        return observer.error(e);
                    }
                    var inner = C.from(value).subscribe({
                        next: function(value) {
                            observer.next(value);
                        },
                        error: function(e) {
                            observer.error(e);
                        },
                        complete: function() {
                            var i = subscriptions.indexOf(inner);
                            if (i >= 0) subscriptions.splice(i, 1);
                            completeIfDone();
                        }
                    });
                    subscriptions.push(inner);
                },
                error: function(e) {
                    observer.error(e);
                },
                complete: function() {
                    completeIfDone();
                }
            });
            function completeIfDone() {
                if (outer.closed && subscriptions.length === 0) observer.complete();
            }
            return function() {
                subscriptions.forEach(function(s) {
                    return s.unsubscribe();
                });
                outer.unsubscribe();
            };
        });
    };
    _proto3[$6d99a9de69717ea6$var$SymbolObservable] = function() {
        return this;
    };
    Observable.from = function from(x) {
        var C = typeof this === 'function' ? this : Observable;
        if (x == null) throw new TypeError(x + ' is not an object');
        var method = $6d99a9de69717ea6$var$getMethod(x, $6d99a9de69717ea6$var$SymbolObservable);
        if (method) {
            var observable = method.call(x);
            if (Object(observable) !== observable) throw new TypeError(observable + ' is not an object');
            if ($6d99a9de69717ea6$var$isObservable(observable) && observable.constructor === C) return observable;
            return new C(function(observer) {
                return observable.subscribe(observer);
            });
        }
        if ($6d99a9de69717ea6$var$hasSymbol('iterator')) {
            method = $6d99a9de69717ea6$var$getMethod(x, $6d99a9de69717ea6$var$SymbolIterator);
            if (method) return new C(function(observer) {
                $6d99a9de69717ea6$var$enqueue(function() {
                    if (observer.closed) return;
                    for(var _iterator = $6d99a9de69717ea6$var$_createForOfIteratorHelperLoose(method.call(x)), _step; !(_step = _iterator()).done;){
                        var item = _step.value;
                        observer.next(item);
                        if (observer.closed) return;
                    }
                    observer.complete();
                });
            });
        }
        if (Array.isArray(x)) return new C(function(observer) {
            $6d99a9de69717ea6$var$enqueue(function() {
                if (observer.closed) return;
                for(var i = 0; i < x.length; ++i){
                    observer.next(x[i]);
                    if (observer.closed) return;
                }
                observer.complete();
            });
        });
        throw new TypeError(x + ' is not observable');
    };
    Observable.of = function of() {
        for(var _len2 = arguments.length, items = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)items[_key2] = arguments[_key2];
        var C = typeof this === 'function' ? this : Observable;
        return new C(function(observer) {
            $6d99a9de69717ea6$var$enqueue(function() {
                if (observer.closed) return;
                for(var i = 0; i < items.length; ++i){
                    observer.next(items[i]);
                    if (observer.closed) return;
                }
                observer.complete();
            });
        });
    };
    $6d99a9de69717ea6$var$_createClass(Observable, null, [
        {
            key: $6d99a9de69717ea6$var$SymbolSpecies,
            get: function() {
                return this;
            }
        }
    ]);
    return Observable;
}();
if ($6d99a9de69717ea6$var$hasSymbols()) Object.defineProperty($6d99a9de69717ea6$export$77cea355fa80b5f4, Symbol('extensions'), {
    value: {
        symbol: $6d99a9de69717ea6$var$SymbolObservable,
        hostReportError: $6d99a9de69717ea6$var$hostReportError
    },
    configurable: true
});


parcelRequire("6Z7su");
// The zen-observable package defines Observable.prototype[Symbol.observable]
// when Symbol is supported, but RxJS interop depends on also setting this fake
// '@@observable' string as a polyfill for Symbol.observable.
var $58650dd67955ab9d$var$prototype = (0, $6d99a9de69717ea6$export$77cea355fa80b5f4).prototype;
var $58650dd67955ab9d$var$fakeObsSymbol = "@@observable";
if (!$58650dd67955ab9d$var$prototype[$58650dd67955ab9d$var$fakeObsSymbol]) // @ts-expect-error
$58650dd67955ab9d$var$prototype[$58650dd67955ab9d$var$fakeObsSymbol] = function() {
    return this;
};



function $159d5dc79a8added$export$f29bedd62f56fcb2(starting, operation) {
    var context = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, starting);
    var setContext = function(next) {
        if (typeof next === "function") context = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, context), next(context));
        else context = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, context), next);
    };
    var getContext = function() {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, context);
    };
    Object.defineProperty(operation, "setContext", {
        enumerable: false,
        value: setContext
    });
    Object.defineProperty(operation, "getContext", {
        enumerable: false,
        value: getContext
    });
    return operation;
}



function $3a16601e2096f4cd$export$417207af72fad9c9(obj) {
    return obj !== null && typeof obj === "object";
}
function $3a16601e2096f4cd$export$53b83ca8eaab0383(obj) {
    return obj !== null && typeof obj === "object" && (Object.getPrototypeOf(obj) === Object.prototype || Object.getPrototypeOf(obj) === null);
}




function $7f688c9754699513$export$abbf37c7cf644e41(document, fragmentName) {
    var actualFragmentName = fragmentName;
    // Build an array of all our fragment definitions that will be used for
    // validations. We also do some validations on the other definitions in the
    // document while building this list.
    var fragments = [];
    document.definitions.forEach(function(definition) {
        // Throw an error if we encounter an operation definition because we will
        // define our own operation definition later on.
        if (definition.kind === "OperationDefinition") throw (0, $28d90d877eb1e517$export$3991762405098ea)(74, definition.operation, definition.name ? " named '".concat(definition.name.value, "'") : "");
        // Add our definition to the fragments array if it is a fragment
        // definition.
        if (definition.kind === "FragmentDefinition") fragments.push(definition);
    });
    // If the user did not give us a fragment name then let us try to get a
    // name from a single fragment in the definition.
    if (typeof actualFragmentName === "undefined") {
        (0, $28d90d877eb1e517$export$f5708dca728d7177)(fragments.length === 1, 75, fragments.length);
        actualFragmentName = fragments[0].name.value;
    }
    // Generate a query document with an operation that simply spreads the
    // fragment inside of it.
    var query = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, document), {
        definitions: (0, $5c96a02c592fcff1$export$1216008129fb82ed)([
            {
                kind: "OperationDefinition",
                // OperationTypeNode is an enum
                operation: "query",
                selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                        {
                            kind: "FragmentSpread",
                            name: {
                                kind: "Name",
                                value: actualFragmentName
                            }
                        }
                    ]
                }
            }
        ], document.definitions, true)
    });
    return query;
}
function $7f688c9754699513$export$193789b4c8246dd4(fragments) {
    if (fragments === void 0) fragments = [];
    var symTable = {};
    fragments.forEach(function(fragment) {
        symTable[fragment.name.value] = fragment;
    });
    return symTable;
}
function $7f688c9754699513$export$f80bdb85f299186(selection, fragmentMap) {
    switch(selection.kind){
        case "InlineFragment":
            return selection;
        case "FragmentSpread":
            var fragmentName = selection.name.value;
            if (typeof fragmentMap === "function") return fragmentMap(fragmentName);
            var fragment = fragmentMap && fragmentMap[fragmentName];
            (0, $28d90d877eb1e517$export$f5708dca728d7177)(fragment, 76, fragmentName);
            return fragment || null;
        default:
            return null;
    }
}


function $557c26506c40b8f1$var$defaultDispose() {}
class $557c26506c40b8f1$export$d3a0331d2c286dc8 {
    constructor(max = Infinity, dispose = $557c26506c40b8f1$var$defaultDispose){
        this.max = max;
        this.dispose = dispose;
        this.map = new Map();
        this.newest = null;
        this.oldest = null;
    }
    has(key) {
        return this.map.has(key);
    }
    get(key) {
        const node = this.getNode(key);
        return node && node.value;
    }
    get size() {
        return this.map.size;
    }
    getNode(key) {
        const node = this.map.get(key);
        if (node && node !== this.newest) {
            const { older: older, newer: newer } = node;
            if (newer) newer.older = older;
            if (older) older.newer = newer;
            node.older = this.newest;
            node.older.newer = node;
            node.newer = null;
            this.newest = node;
            if (node === this.oldest) this.oldest = newer;
        }
        return node;
    }
    set(key, value) {
        let node = this.getNode(key);
        if (node) return node.value = value;
        node = {
            key: key,
            value: value,
            newer: null,
            older: this.newest
        };
        if (this.newest) this.newest.newer = node;
        this.newest = node;
        this.oldest = this.oldest || node;
        this.map.set(key, node);
        return node.value;
    }
    clean() {
        while(this.oldest && this.map.size > this.max)this.delete(this.oldest.key);
    }
    delete(key) {
        const node = this.map.get(key);
        if (node) {
            if (node === this.newest) this.newest = node.older;
            if (node === this.oldest) this.oldest = node.newer;
            if (node.newer) node.newer.older = node.older;
            if (node.older) node.older.newer = node.newer;
            this.map.delete(key);
            this.dispose(node.value, key);
            return true;
        }
        return false;
    }
}

function $947797cdb9e55a2d$var$noop() {}
const $947797cdb9e55a2d$var$defaultDispose = $947797cdb9e55a2d$var$noop;
const $947797cdb9e55a2d$var$_WeakRef = typeof WeakRef !== "undefined" ? WeakRef : function(value) {
    return {
        deref: ()=>value
    };
};
const $947797cdb9e55a2d$var$_WeakMap = typeof WeakMap !== "undefined" ? WeakMap : Map;
const $947797cdb9e55a2d$var$_FinalizationRegistry = typeof FinalizationRegistry !== "undefined" ? FinalizationRegistry : function() {
    return {
        register: $947797cdb9e55a2d$var$noop,
        unregister: $947797cdb9e55a2d$var$noop
    };
};
const $947797cdb9e55a2d$var$finalizationBatchSize = 10024;
class $947797cdb9e55a2d$export$87b462129af3b7d4 {
    constructor(max = Infinity, dispose = $947797cdb9e55a2d$var$defaultDispose){
        this.max = max;
        this.dispose = dispose;
        this.map = new $947797cdb9e55a2d$var$_WeakMap();
        this.newest = null;
        this.oldest = null;
        this.unfinalizedNodes = new Set();
        this.finalizationScheduled = false;
        this.size = 0;
        this.finalize = ()=>{
            const iterator = this.unfinalizedNodes.values();
            for(let i = 0; i < $947797cdb9e55a2d$var$finalizationBatchSize; i++){
                const node = iterator.next().value;
                if (!node) break;
                this.unfinalizedNodes.delete(node);
                const key = node.key;
                delete node.key;
                node.keyRef = new $947797cdb9e55a2d$var$_WeakRef(key);
                this.registry.register(key, node, node);
            }
            if (this.unfinalizedNodes.size > 0) queueMicrotask(this.finalize);
            else this.finalizationScheduled = false;
        };
        this.registry = new $947797cdb9e55a2d$var$_FinalizationRegistry(this.deleteNode.bind(this));
    }
    has(key) {
        return this.map.has(key);
    }
    get(key) {
        const node = this.getNode(key);
        return node && node.value;
    }
    getNode(key) {
        const node = this.map.get(key);
        if (node && node !== this.newest) {
            const { older: older, newer: newer } = node;
            if (newer) newer.older = older;
            if (older) older.newer = newer;
            node.older = this.newest;
            node.older.newer = node;
            node.newer = null;
            this.newest = node;
            if (node === this.oldest) this.oldest = newer;
        }
        return node;
    }
    set(key, value) {
        let node = this.getNode(key);
        if (node) return node.value = value;
        node = {
            key: key,
            value: value,
            newer: null,
            older: this.newest
        };
        if (this.newest) this.newest.newer = node;
        this.newest = node;
        this.oldest = this.oldest || node;
        this.scheduleFinalization(node);
        this.map.set(key, node);
        this.size++;
        return node.value;
    }
    clean() {
        while(this.oldest && this.size > this.max)this.deleteNode(this.oldest);
    }
    deleteNode(node) {
        if (node === this.newest) this.newest = node.older;
        if (node === this.oldest) this.oldest = node.newer;
        if (node.newer) node.newer.older = node.older;
        if (node.older) node.older.newer = node.newer;
        this.size--;
        const key = node.key || node.keyRef && node.keyRef.deref();
        this.dispose(node.value, key);
        if (!node.keyRef) this.unfinalizedNodes.delete(node);
        else this.registry.unregister(node);
        if (key) this.map.delete(key);
    }
    delete(key) {
        const node = this.map.get(key);
        if (node) {
            this.deleteNode(node);
            return true;
        }
        return false;
    }
    scheduleFinalization(node) {
        this.unfinalizedNodes.add(node);
        if (!this.finalizationScheduled) {
            this.finalizationScheduled = true;
            queueMicrotask(this.finalize);
        }
    }
}


var $b3ac5bdec858bda0$var$scheduledCleanup = new WeakSet();
function $b3ac5bdec858bda0$var$schedule(cache) {
    if (cache.size <= (cache.max || -1)) return;
    if (!$b3ac5bdec858bda0$var$scheduledCleanup.has(cache)) {
        $b3ac5bdec858bda0$var$scheduledCleanup.add(cache);
        setTimeout(function() {
            cache.clean();
            $b3ac5bdec858bda0$var$scheduledCleanup.delete(cache);
        }, 100);
    }
}
var $b3ac5bdec858bda0$export$8dbad6f439bb2331 = function(max, dispose) {
    /*
    Some builds of `WeakCache` are function prototypes, some are classes.
    This library still builds with an ES5 target, so we can't extend the
    real classes.
    Instead, we have to use this workaround until we switch to a newer build
    target.
    */ var cache = new (0, $947797cdb9e55a2d$export$87b462129af3b7d4)(max, dispose);
    cache.set = function(key, value) {
        var ret = (0, $947797cdb9e55a2d$export$87b462129af3b7d4).prototype.set.call(this, key, value);
        $b3ac5bdec858bda0$var$schedule(this);
        return ret;
    };
    return cache;
};
var $b3ac5bdec858bda0$export$5b4f745137d91413 = function(max, dispose) {
    /*
    Some builds of `StrongCache` are function prototypes, some are classes.
    This library still builds with an ES5 target, so we can't extend the
    real classes.
    Instead, we have to use this workaround until we switch to a newer build
    target.
    */ var cache = new (0, $557c26506c40b8f1$export$d3a0331d2c286dc8)(max, dispose);
    cache.set = function(key, value) {
        var ret = (0, $557c26506c40b8f1$export$d3a0331d2c286dc8).prototype.set.call(this, key, value);
        $b3ac5bdec858bda0$var$schedule(this);
        return ret;
    };
    return cache;
};



var $c506be9be1a65610$var$cacheSizeSymbol = Symbol.for("apollo.cacheSize");
var $c506be9be1a65610$export$f29926b23b28936b = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, (0, $d461b0c33b06d27f$export$2e2bcd8739ae039)[$c506be9be1a65610$var$cacheSizeSymbol]);




var $1da01699264b6e1e$var$globalCaches = {};
function $1da01699264b6e1e$export$a8fcd406d9e37621(name, getSize) {
    $1da01699264b6e1e$var$globalCaches[name] = getSize;
}
var $1da01699264b6e1e$export$dfdba94ce46d2ea5 = globalThis.__DEV__ !== false ? $1da01699264b6e1e$var$_getApolloClientMemoryInternals : undefined;
var $1da01699264b6e1e$export$e95a5a2210e62466 = globalThis.__DEV__ !== false ? $1da01699264b6e1e$var$_getInMemoryCacheMemoryInternals : undefined;
var $1da01699264b6e1e$export$e7ed438e82606689 = globalThis.__DEV__ !== false ? $1da01699264b6e1e$var$_getApolloCacheMemoryInternals : undefined;
function $1da01699264b6e1e$var$getCurrentCacheSizes() {
    // `defaultCacheSizes` is a `const enum` that will be inlined during build, so we have to reconstruct it's shape here
    var defaults = {
        parser: 1000 /* defaultCacheSizes["parser"] */ ,
        canonicalStringify: 1000 /* defaultCacheSizes["canonicalStringify"] */ ,
        print: 2000 /* defaultCacheSizes["print"] */ ,
        "documentTransform.cache": 2000 /* defaultCacheSizes["documentTransform.cache"] */ ,
        "queryManager.getDocumentInfo": 2000 /* defaultCacheSizes["queryManager.getDocumentInfo"] */ ,
        "PersistedQueryLink.persistedQueryHashes": 2000 /* defaultCacheSizes["PersistedQueryLink.persistedQueryHashes"] */ ,
        "fragmentRegistry.transform": 2000 /* defaultCacheSizes["fragmentRegistry.transform"] */ ,
        "fragmentRegistry.lookup": 1000 /* defaultCacheSizes["fragmentRegistry.lookup"] */ ,
        "fragmentRegistry.findFragmentSpreads": 4000 /* defaultCacheSizes["fragmentRegistry.findFragmentSpreads"] */ ,
        "cache.fragmentQueryDocuments": 1000 /* defaultCacheSizes["cache.fragmentQueryDocuments"] */ ,
        "removeTypenameFromVariables.getVariableDefinitions": 2000 /* defaultCacheSizes["removeTypenameFromVariables.getVariableDefinitions"] */ ,
        "inMemoryCache.maybeBroadcastWatch": 5000 /* defaultCacheSizes["inMemoryCache.maybeBroadcastWatch"] */ ,
        "inMemoryCache.executeSelectionSet": 50000 /* defaultCacheSizes["inMemoryCache.executeSelectionSet"] */ ,
        "inMemoryCache.executeSubSelectedArray": 10000 /* defaultCacheSizes["inMemoryCache.executeSubSelectedArray"] */ 
    };
    return Object.fromEntries(Object.entries(defaults).map(function(_a) {
        var k = _a[0], v = _a[1];
        return [
            k,
            (0, $c506be9be1a65610$export$f29926b23b28936b)[k] || v
        ];
    }));
}
function $1da01699264b6e1e$var$_getApolloClientMemoryInternals() {
    var _a, _b, _c, _d, _e;
    if (!(globalThis.__DEV__ !== false)) throw new Error("only supported in development mode");
    return {
        limits: $1da01699264b6e1e$var$getCurrentCacheSizes(),
        sizes: (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
            print: (_a = $1da01699264b6e1e$var$globalCaches.print) === null || _a === void 0 ? void 0 : _a.call($1da01699264b6e1e$var$globalCaches),
            parser: (_b = $1da01699264b6e1e$var$globalCaches.parser) === null || _b === void 0 ? void 0 : _b.call($1da01699264b6e1e$var$globalCaches),
            canonicalStringify: (_c = $1da01699264b6e1e$var$globalCaches.canonicalStringify) === null || _c === void 0 ? void 0 : _c.call($1da01699264b6e1e$var$globalCaches),
            links: $1da01699264b6e1e$var$linkInfo(this.link),
            queryManager: {
                getDocumentInfo: this["queryManager"]["transformCache"].size,
                documentTransforms: $1da01699264b6e1e$var$transformInfo(this["queryManager"].documentTransform)
            }
        }, (_e = (_d = this.cache).getMemoryInternals) === null || _e === void 0 ? void 0 : _e.call(_d))
    };
}
function $1da01699264b6e1e$var$_getApolloCacheMemoryInternals() {
    return {
        cache: {
            fragmentQueryDocuments: $1da01699264b6e1e$var$getWrapperInformation(this["getFragmentDoc"])
        }
    };
}
function $1da01699264b6e1e$var$_getInMemoryCacheMemoryInternals() {
    var fragments = this.config.fragments;
    return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, $1da01699264b6e1e$var$_getApolloCacheMemoryInternals.apply(this)), {
        addTypenameDocumentTransform: $1da01699264b6e1e$var$transformInfo(this["addTypenameTransform"]),
        inMemoryCache: {
            executeSelectionSet: $1da01699264b6e1e$var$getWrapperInformation(this["storeReader"]["executeSelectionSet"]),
            executeSubSelectedArray: $1da01699264b6e1e$var$getWrapperInformation(this["storeReader"]["executeSubSelectedArray"]),
            maybeBroadcastWatch: $1da01699264b6e1e$var$getWrapperInformation(this["maybeBroadcastWatch"])
        },
        fragmentRegistry: {
            findFragmentSpreads: $1da01699264b6e1e$var$getWrapperInformation(fragments === null || fragments === void 0 ? void 0 : fragments.findFragmentSpreads),
            lookup: $1da01699264b6e1e$var$getWrapperInformation(fragments === null || fragments === void 0 ? void 0 : fragments.lookup),
            transform: $1da01699264b6e1e$var$getWrapperInformation(fragments === null || fragments === void 0 ? void 0 : fragments.transform)
        }
    });
}
function $1da01699264b6e1e$var$isWrapper(f) {
    return !!f && "dirtyKey" in f;
}
function $1da01699264b6e1e$var$getWrapperInformation(f) {
    return $1da01699264b6e1e$var$isWrapper(f) ? f.size : undefined;
}
function $1da01699264b6e1e$var$isDefined(value) {
    return value != null;
}
function $1da01699264b6e1e$var$transformInfo(transform) {
    return $1da01699264b6e1e$var$recurseTransformInfo(transform).map(function(cache) {
        return {
            cache: cache
        };
    });
}
function $1da01699264b6e1e$var$recurseTransformInfo(transform) {
    return transform ? (0, $5c96a02c592fcff1$export$1216008129fb82ed)((0, $5c96a02c592fcff1$export$1216008129fb82ed)([
        $1da01699264b6e1e$var$getWrapperInformation(transform === null || transform === void 0 ? void 0 : transform["performWork"])
    ], $1da01699264b6e1e$var$recurseTransformInfo(transform === null || transform === void 0 ? void 0 : transform["left"]), true), $1da01699264b6e1e$var$recurseTransformInfo(transform === null || transform === void 0 ? void 0 : transform["right"]), true).filter($1da01699264b6e1e$var$isDefined) : [];
}
function $1da01699264b6e1e$var$linkInfo(link) {
    var _a;
    return link ? (0, $5c96a02c592fcff1$export$1216008129fb82ed)((0, $5c96a02c592fcff1$export$1216008129fb82ed)([
        (_a = link === null || link === void 0 ? void 0 : link.getMemoryInternals) === null || _a === void 0 ? void 0 : _a.call(link)
    ], $1da01699264b6e1e$var$linkInfo(link === null || link === void 0 ? void 0 : link.left), true), $1da01699264b6e1e$var$linkInfo(link === null || link === void 0 ? void 0 : link.right), true).filter($1da01699264b6e1e$var$isDefined) : [];
}


var $0bef48da5254bd54$export$88a0ad9b6f961b51 = Object.assign(function canonicalStringify(value) {
    return JSON.stringify(value, $0bef48da5254bd54$var$stableObjectReplacer);
}, {
    reset: function() {
        // Clearing the sortingMap will reclaim all cached memory, without
        // affecting the logical results of canonicalStringify, but potentially
        // sacrificing performance until the cache is refilled.
        $0bef48da5254bd54$var$sortingMap = new (0, $b3ac5bdec858bda0$export$5b4f745137d91413)((0, $c506be9be1a65610$export$f29926b23b28936b).canonicalStringify || 1000 /* defaultCacheSizes.canonicalStringify */ );
    }
});
if (globalThis.__DEV__ !== false) (0, $1da01699264b6e1e$export$a8fcd406d9e37621)("canonicalStringify", function() {
    return $0bef48da5254bd54$var$sortingMap.size;
});
// Values are JSON-serialized arrays of object keys (in any order), and values
// are sorted arrays of the same keys.
var $0bef48da5254bd54$var$sortingMap;
$0bef48da5254bd54$export$88a0ad9b6f961b51.reset();
// The JSON.stringify function takes an optional second argument called a
// replacer function. This function is called for each key-value pair in the
// object being stringified, and its return value is used instead of the
// original value. If the replacer function returns a new value, that value is
// stringified as JSON instead of the original value of the property.
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/JSON/stringify#the_replacer_parameter
function $0bef48da5254bd54$var$stableObjectReplacer(key, value) {
    if (value && typeof value === "object") {
        var proto = Object.getPrototypeOf(value);
        // We don't want to mess with objects that are not "plain" objects, which
        // means their prototype is either Object.prototype or null. This check also
        // prevents needlessly rearranging the indices of arrays.
        if (proto === Object.prototype || proto === null) {
            var keys = Object.keys(value);
            // If keys is already sorted, let JSON.stringify serialize the original
            // value instead of creating a new object with keys in the same order.
            if (keys.every($0bef48da5254bd54$var$everyKeyInOrder)) return value;
            var unsortedKey = JSON.stringify(keys);
            var sortedKeys = $0bef48da5254bd54$var$sortingMap.get(unsortedKey);
            if (!sortedKeys) {
                keys.sort();
                var sortedKey = JSON.stringify(keys);
                // Checking for sortedKey in the sortingMap allows us to share the same
                // sorted array reference for all permutations of the same set of keys.
                sortedKeys = $0bef48da5254bd54$var$sortingMap.get(sortedKey) || keys;
                $0bef48da5254bd54$var$sortingMap.set(unsortedKey, sortedKeys);
                $0bef48da5254bd54$var$sortingMap.set(sortedKey, sortedKeys);
            }
            var sortedObject_1 = Object.create(proto);
            // Reassigning the keys in sorted order will cause JSON.stringify to
            // serialize them in sorted order.
            sortedKeys.forEach(function(key) {
                sortedObject_1[key] = value[key];
            });
            return sortedObject_1;
        }
    }
    return value;
}
// Since everything that happens in stableObjectReplacer benefits from being as
// efficient as possible, we use a static function as the callback for
// keys.every in order to test if the provided keys are already sorted without
// allocating extra memory for a callback.
function $0bef48da5254bd54$var$everyKeyInOrder(key, i, keys) {
    return i === 0 || keys[i - 1] <= key;
}


function $9d830e5028848843$export$634ae0e932e9be99(id) {
    return {
        __ref: String(id)
    };
}
function $9d830e5028848843$export$fa99cac1c0883c47(obj) {
    return Boolean(obj && typeof obj === "object" && typeof obj.__ref === "string");
}
function $9d830e5028848843$export$540432d49fcec6c9(value) {
    return (0, $3a16601e2096f4cd$export$417207af72fad9c9)(value) && value.kind === "Document" && Array.isArray(value.definitions);
}
function $9d830e5028848843$var$isStringValue(value) {
    return value.kind === "StringValue";
}
function $9d830e5028848843$var$isBooleanValue(value) {
    return value.kind === "BooleanValue";
}
function $9d830e5028848843$var$isIntValue(value) {
    return value.kind === "IntValue";
}
function $9d830e5028848843$var$isFloatValue(value) {
    return value.kind === "FloatValue";
}
function $9d830e5028848843$var$isVariable(value) {
    return value.kind === "Variable";
}
function $9d830e5028848843$var$isObjectValue(value) {
    return value.kind === "ObjectValue";
}
function $9d830e5028848843$var$isListValue(value) {
    return value.kind === "ListValue";
}
function $9d830e5028848843$var$isEnumValue(value) {
    return value.kind === "EnumValue";
}
function $9d830e5028848843$var$isNullValue(value) {
    return value.kind === "NullValue";
}
function $9d830e5028848843$export$a1dab82d368d6525(argObj, name, value, variables) {
    if ($9d830e5028848843$var$isIntValue(value) || $9d830e5028848843$var$isFloatValue(value)) argObj[name.value] = Number(value.value);
    else if ($9d830e5028848843$var$isBooleanValue(value) || $9d830e5028848843$var$isStringValue(value)) argObj[name.value] = value.value;
    else if ($9d830e5028848843$var$isObjectValue(value)) {
        var nestedArgObj_1 = {};
        value.fields.map(function(obj) {
            return $9d830e5028848843$export$a1dab82d368d6525(nestedArgObj_1, obj.name, obj.value, variables);
        });
        argObj[name.value] = nestedArgObj_1;
    } else if ($9d830e5028848843$var$isVariable(value)) {
        var variableValue = (variables || {})[value.name.value];
        argObj[name.value] = variableValue;
    } else if ($9d830e5028848843$var$isListValue(value)) argObj[name.value] = value.values.map(function(listValue) {
        var nestedArgArrayObj = {};
        $9d830e5028848843$export$a1dab82d368d6525(nestedArgArrayObj, name, listValue, variables);
        return nestedArgArrayObj[name.value];
    });
    else if ($9d830e5028848843$var$isEnumValue(value)) argObj[name.value] = value.value;
    else if ($9d830e5028848843$var$isNullValue(value)) argObj[name.value] = null;
    else throw (0, $28d90d877eb1e517$export$3991762405098ea)(85, name.value, value.kind);
}
function $9d830e5028848843$export$54be8689c65f3b56(field, variables) {
    var directivesObj = null;
    if (field.directives) {
        directivesObj = {};
        field.directives.forEach(function(directive) {
            directivesObj[directive.name.value] = {};
            if (directive.arguments) directive.arguments.forEach(function(_a) {
                var name = _a.name, value = _a.value;
                return $9d830e5028848843$export$a1dab82d368d6525(directivesObj[directive.name.value], name, value, variables);
            });
        });
    }
    var argObj = null;
    if (field.arguments && field.arguments.length) {
        argObj = {};
        field.arguments.forEach(function(_a) {
            var name = _a.name, value = _a.value;
            return $9d830e5028848843$export$a1dab82d368d6525(argObj, name, value, variables);
        });
    }
    return $9d830e5028848843$export$3cdb6c178b88cabe(field.name.value, argObj, directivesObj);
}
var $9d830e5028848843$var$KNOWN_DIRECTIVES = [
    "connection",
    "include",
    "skip",
    "client",
    "rest",
    "export",
    "nonreactive"
];
// Default stable JSON.stringify implementation used by getStoreKeyName. Can be
// updated/replaced with something better by calling
// getStoreKeyName.setStringify(newStringifyFunction).
var $9d830e5028848843$var$storeKeyNameStringify = (0, $0bef48da5254bd54$export$88a0ad9b6f961b51);
var $9d830e5028848843$export$3cdb6c178b88cabe = Object.assign(function(fieldName, args, directives) {
    if (args && directives && directives["connection"] && directives["connection"]["key"]) {
        if (directives["connection"]["filter"] && directives["connection"]["filter"].length > 0) {
            var filterKeys = directives["connection"]["filter"] ? directives["connection"]["filter"] : [];
            filterKeys.sort();
            var filteredArgs_1 = {};
            filterKeys.forEach(function(key) {
                filteredArgs_1[key] = args[key];
            });
            return "".concat(directives["connection"]["key"], "(").concat($9d830e5028848843$var$storeKeyNameStringify(filteredArgs_1), ")");
        } else return directives["connection"]["key"];
    }
    var completeFieldName = fieldName;
    if (args) {
        // We can't use `JSON.stringify` here since it's non-deterministic,
        // and can lead to different store key names being created even though
        // the `args` object used during creation has the same properties/values.
        var stringifiedArgs = $9d830e5028848843$var$storeKeyNameStringify(args);
        completeFieldName += "(".concat(stringifiedArgs, ")");
    }
    if (directives) Object.keys(directives).forEach(function(key) {
        if ($9d830e5028848843$var$KNOWN_DIRECTIVES.indexOf(key) !== -1) return;
        if (directives[key] && Object.keys(directives[key]).length) completeFieldName += "@".concat(key, "(").concat($9d830e5028848843$var$storeKeyNameStringify(directives[key]), ")");
        else completeFieldName += "@".concat(key);
    });
    return completeFieldName;
}, {
    setStringify: function(s) {
        var previous = $9d830e5028848843$var$storeKeyNameStringify;
        $9d830e5028848843$var$storeKeyNameStringify = s;
        return previous;
    }
});
function $9d830e5028848843$export$3f5a60fb6a781b4f(field, variables) {
    if (field.arguments && field.arguments.length) {
        var argObj_1 = {};
        field.arguments.forEach(function(_a) {
            var name = _a.name, value = _a.value;
            return $9d830e5028848843$export$a1dab82d368d6525(argObj_1, name, value, variables);
        });
        return argObj_1;
    }
    return null;
}
function $9d830e5028848843$export$7d1ad22471852218(field) {
    return field.alias ? field.alias.value : field.name.value;
}
function $9d830e5028848843$export$cf7bf7e4f289cc26(result, selectionSet, fragmentMap) {
    var fragments;
    for(var _i = 0, _a = selectionSet.selections; _i < _a.length; _i++){
        var selection = _a[_i];
        if ($9d830e5028848843$export$fb56ad75dd311c12(selection)) {
            if (selection.name.value === "__typename") return result[$9d830e5028848843$export$7d1ad22471852218(selection)];
        } else if (fragments) fragments.push(selection);
        else fragments = [
            selection
        ];
    }
    if (typeof result.__typename === "string") return result.__typename;
    if (fragments) for(var _b = 0, fragments_1 = fragments; _b < fragments_1.length; _b++){
        var selection = fragments_1[_b];
        var typename = $9d830e5028848843$export$cf7bf7e4f289cc26(result, (0, $7f688c9754699513$export$f80bdb85f299186)(selection, fragmentMap).selectionSet, fragmentMap);
        if (typeof typename === "string") return typename;
    }
}
function $9d830e5028848843$export$fb56ad75dd311c12(selection) {
    return selection.kind === "Field";
}
function $9d830e5028848843$export$22a1cdafaf27bcff(selection) {
    return selection.kind === "InlineFragment";
}


function $818d93327cb72c29$export$a7d0d8111d2386df(doc) {
    (0, $28d90d877eb1e517$export$f5708dca728d7177)(doc && doc.kind === "Document", 77);
    var operations = doc.definitions.filter(function(d) {
        return d.kind !== "FragmentDefinition";
    }).map(function(definition) {
        if (definition.kind !== "OperationDefinition") throw (0, $28d90d877eb1e517$export$3991762405098ea)(78, definition.kind);
        return definition;
    });
    (0, $28d90d877eb1e517$export$f5708dca728d7177)(operations.length <= 1, 79, operations.length);
    return doc;
}
function $818d93327cb72c29$export$7a5b1fa979d2c158(doc) {
    $818d93327cb72c29$export$a7d0d8111d2386df(doc);
    return doc.definitions.filter(function(definition) {
        return definition.kind === "OperationDefinition";
    })[0];
}
function $818d93327cb72c29$export$41bca9dc6871dd4e(doc) {
    return doc.definitions.filter(function(definition) {
        return definition.kind === "OperationDefinition" && !!definition.name;
    }).map(function(x) {
        return x.name.value;
    })[0] || null;
}
function $818d93327cb72c29$export$5320a7ba9466a3df(doc) {
    return doc.definitions.filter(function(definition) {
        return definition.kind === "FragmentDefinition";
    });
}
function $818d93327cb72c29$export$d96b2213c1b9d3a9(doc) {
    var queryDef = $818d93327cb72c29$export$7a5b1fa979d2c158(doc);
    (0, $28d90d877eb1e517$export$f5708dca728d7177)(queryDef && queryDef.operation === "query", 80);
    return queryDef;
}
function $818d93327cb72c29$export$772111caef41b3f5(doc) {
    (0, $28d90d877eb1e517$export$f5708dca728d7177)(doc.kind === "Document", 81);
    (0, $28d90d877eb1e517$export$f5708dca728d7177)(doc.definitions.length <= 1, 82);
    var fragmentDef = doc.definitions[0];
    (0, $28d90d877eb1e517$export$f5708dca728d7177)(fragmentDef.kind === "FragmentDefinition", 83);
    return fragmentDef;
}
function $818d93327cb72c29$export$f431198736b7f96d(queryDoc) {
    $818d93327cb72c29$export$a7d0d8111d2386df(queryDoc);
    var fragmentDefinition;
    for(var _i = 0, _a = queryDoc.definitions; _i < _a.length; _i++){
        var definition = _a[_i];
        if (definition.kind === "OperationDefinition") {
            var operation = definition.operation;
            if (operation === "query" || operation === "mutation" || operation === "subscription") return definition;
        }
        if (definition.kind === "FragmentDefinition" && !fragmentDefinition) // we do this because we want to allow multiple fragment definitions
        // to precede an operation definition.
        fragmentDefinition = definition;
    }
    if (fragmentDefinition) return fragmentDefinition;
    throw (0, $28d90d877eb1e517$export$3991762405098ea)(84);
}
function $818d93327cb72c29$export$84c19026e616569e(definition) {
    var defaultValues = Object.create(null);
    var defs = definition && definition.variableDefinitions;
    if (defs && defs.length) defs.forEach(function(def) {
        if (def.defaultValue) (0, $9d830e5028848843$export$a1dab82d368d6525)(defaultValues, def.variable.name, def.defaultValue);
    });
    return defaultValues;
}


function $6a49a3d7d64e95e4$export$4f3f7df1b558c729(operation) {
    var transformedOperation = {
        variables: operation.variables || {},
        extensions: operation.extensions || {},
        operationName: operation.operationName,
        query: operation.query
    };
    // Best guess at an operation name
    if (!transformedOperation.operationName) transformedOperation.operationName = typeof transformedOperation.query !== "string" ? (0, $818d93327cb72c29$export$41bca9dc6871dd4e)(transformedOperation.query) || undefined : "";
    return transformedOperation;
}


function $f3beb697e0729913$export$a92a48117d546c9(operation) {
    var OPERATION_FIELDS = [
        "query",
        "operationName",
        "variables",
        "extensions",
        "context"
    ];
    for(var _i = 0, _a = Object.keys(operation); _i < _a.length; _i++){
        var key = _a[_i];
        if (OPERATION_FIELDS.indexOf(key) < 0) throw (0, $28d90d877eb1e517$export$3991762405098ea)(44, key);
    }
    return operation;
}


function $60c07ffd02e3617d$var$passthrough(op, forward) {
    return forward ? forward(op) : (0, $6d99a9de69717ea6$export$77cea355fa80b5f4).of();
}
function $60c07ffd02e3617d$var$toLink(handler) {
    return typeof handler === "function" ? new $60c07ffd02e3617d$export$2fed3d61f740bc7f(handler) : handler;
}
function $60c07ffd02e3617d$var$isTerminating(link) {
    return link.request.length <= 1;
}
var $60c07ffd02e3617d$export$2fed3d61f740bc7f = /** @class */ function() {
    function ApolloLink(request) {
        if (request) this.request = request;
    }
    ApolloLink.empty = function() {
        return new ApolloLink(function() {
            return (0, $6d99a9de69717ea6$export$77cea355fa80b5f4).of();
        });
    };
    ApolloLink.from = function(links) {
        if (links.length === 0) return ApolloLink.empty();
        return links.map($60c07ffd02e3617d$var$toLink).reduce(function(x, y) {
            return x.concat(y);
        });
    };
    ApolloLink.split = function(test, left, right) {
        var leftLink = $60c07ffd02e3617d$var$toLink(left);
        var rightLink = $60c07ffd02e3617d$var$toLink(right || new ApolloLink($60c07ffd02e3617d$var$passthrough));
        var ret;
        if ($60c07ffd02e3617d$var$isTerminating(leftLink) && $60c07ffd02e3617d$var$isTerminating(rightLink)) ret = new ApolloLink(function(operation) {
            return test(operation) ? leftLink.request(operation) || (0, $6d99a9de69717ea6$export$77cea355fa80b5f4).of() : rightLink.request(operation) || (0, $6d99a9de69717ea6$export$77cea355fa80b5f4).of();
        });
        else ret = new ApolloLink(function(operation, forward) {
            return test(operation) ? leftLink.request(operation, forward) || (0, $6d99a9de69717ea6$export$77cea355fa80b5f4).of() : rightLink.request(operation, forward) || (0, $6d99a9de69717ea6$export$77cea355fa80b5f4).of();
        });
        return Object.assign(ret, {
            left: leftLink,
            right: rightLink
        });
    };
    ApolloLink.execute = function(link, operation) {
        return link.request((0, $159d5dc79a8added$export$f29bedd62f56fcb2)(operation.context, (0, $6a49a3d7d64e95e4$export$4f3f7df1b558c729)((0, $f3beb697e0729913$export$a92a48117d546c9)(operation)))) || (0, $6d99a9de69717ea6$export$77cea355fa80b5f4).of();
    };
    ApolloLink.concat = function(first, second) {
        var firstLink = $60c07ffd02e3617d$var$toLink(first);
        if ($60c07ffd02e3617d$var$isTerminating(firstLink)) {
            globalThis.__DEV__ !== false && (0, $28d90d877eb1e517$export$f5708dca728d7177).warn(36, firstLink);
            return firstLink;
        }
        var nextLink = $60c07ffd02e3617d$var$toLink(second);
        var ret;
        if ($60c07ffd02e3617d$var$isTerminating(nextLink)) ret = new ApolloLink(function(operation) {
            return firstLink.request(operation, function(op) {
                return nextLink.request(op) || (0, $6d99a9de69717ea6$export$77cea355fa80b5f4).of();
            }) || (0, $6d99a9de69717ea6$export$77cea355fa80b5f4).of();
        });
        else ret = new ApolloLink(function(operation, forward) {
            return firstLink.request(operation, function(op) {
                return nextLink.request(op, forward) || (0, $6d99a9de69717ea6$export$77cea355fa80b5f4).of();
            }) || (0, $6d99a9de69717ea6$export$77cea355fa80b5f4).of();
        });
        return Object.assign(ret, {
            left: firstLink,
            right: nextLink
        });
    };
    ApolloLink.prototype.split = function(test, left, right) {
        return this.concat(ApolloLink.split(test, left, right || new ApolloLink($60c07ffd02e3617d$var$passthrough)));
    };
    ApolloLink.prototype.concat = function(next) {
        return ApolloLink.concat(this, next);
    };
    ApolloLink.prototype.request = function(operation, forward) {
        throw (0, $28d90d877eb1e517$export$3991762405098ea)(37);
    };
    ApolloLink.prototype.onError = function(error, observer) {
        if (observer && observer.error) {
            observer.error(error);
            // Returning false indicates that observer.error does not need to be
            // called again, since it was already called (on the previous line).
            // Calling observer.error again would not cause any real problems,
            // since only the first call matters, but custom onError functions
            // might have other reasons for wanting to prevent the default
            // behavior by returning false.
            return false;
        }
        // Throw errors will be passed to observer.error.
        throw error;
    };
    ApolloLink.prototype.setOnError = function(fn) {
        this.onError = fn;
        return this;
    };
    return ApolloLink;
}();


var $88c17748fb93d3ed$export$51396ec711da548b = (0, $60c07ffd02e3617d$export$2fed3d61f740bc7f).execute;









function $8beb5260c793fc92$export$b6cb5906f04696c8(condition, message) {
    const booleanCondition = Boolean(condition);
    if (!booleanCondition) throw new Error(message);
}


const $9541a54af6a37409$var$MAX_ARRAY_LENGTH = 10;
const $9541a54af6a37409$var$MAX_RECURSIVE_DEPTH = 2;
function $9541a54af6a37409$export$9dec5d1b3b6a130d(value) {
    return $9541a54af6a37409$var$formatValue(value, []);
}
function $9541a54af6a37409$var$formatValue(value, seenValues) {
    switch(typeof value){
        case 'string':
            return JSON.stringify(value);
        case 'function':
            return value.name ? `[function ${value.name}]` : '[function]';
        case 'object':
            return $9541a54af6a37409$var$formatObjectValue(value, seenValues);
        default:
            return String(value);
    }
}
function $9541a54af6a37409$var$formatObjectValue(value, previouslySeenValues) {
    if (value === null) return 'null';
    if (previouslySeenValues.includes(value)) return '[Circular]';
    const seenValues = [
        ...previouslySeenValues,
        value
    ];
    if ($9541a54af6a37409$var$isJSONable(value)) {
        const jsonValue = value.toJSON(); // check for infinite recursion
        if (jsonValue !== value) return typeof jsonValue === 'string' ? jsonValue : $9541a54af6a37409$var$formatValue(jsonValue, seenValues);
    } else if (Array.isArray(value)) return $9541a54af6a37409$var$formatArray(value, seenValues);
    return $9541a54af6a37409$var$formatObject(value, seenValues);
}
function $9541a54af6a37409$var$isJSONable(value) {
    return typeof value.toJSON === 'function';
}
function $9541a54af6a37409$var$formatObject(object, seenValues) {
    const entries = Object.entries(object);
    if (entries.length === 0) return '{}';
    if (seenValues.length > $9541a54af6a37409$var$MAX_RECURSIVE_DEPTH) return '[' + $9541a54af6a37409$var$getObjectTag(object) + ']';
    const properties = entries.map(([key, value])=>key + ': ' + $9541a54af6a37409$var$formatValue(value, seenValues));
    return '{ ' + properties.join(', ') + ' }';
}
function $9541a54af6a37409$var$formatArray(array, seenValues) {
    if (array.length === 0) return '[]';
    if (seenValues.length > $9541a54af6a37409$var$MAX_RECURSIVE_DEPTH) return '[Array]';
    const len = Math.min($9541a54af6a37409$var$MAX_ARRAY_LENGTH, array.length);
    const remaining = array.length - len;
    const items = [];
    for(let i = 0; i < len; ++i)items.push($9541a54af6a37409$var$formatValue(array[i], seenValues));
    if (remaining === 1) items.push('... 1 more item');
    else if (remaining > 1) items.push(`... ${remaining} more items`);
    return '[' + items.join(', ') + ']';
}
function $9541a54af6a37409$var$getObjectTag(object) {
    const tag = Object.prototype.toString.call(object).replace(/^\[object /, '').replace(/]$/, '');
    if (tag === 'Object' && typeof object.constructor === 'function') {
        const name = object.constructor.name;
        if (typeof name === 'string' && name !== '') return name;
    }
    return tag;
}


/**
 * Contains a range of UTF-8 character offsets and token references that
 * identify the region of the source from which the AST derived.
 */ class $11b06753ce50693f$export$18a2be9195644f38 {
    /**
   * The character offset at which this Node begins.
   */ /**
   * The character offset at which this Node ends.
   */ /**
   * The Token at which this Node begins.
   */ /**
   * The Token at which this Node ends.
   */ /**
   * The Source document the AST represents.
   */ constructor(startToken, endToken, source){
        this.start = startToken.start;
        this.end = endToken.end;
        this.startToken = startToken;
        this.endToken = endToken;
        this.source = source;
    }
    get [Symbol.toStringTag]() {
        return 'Location';
    }
    toJSON() {
        return {
            start: this.start,
            end: this.end
        };
    }
}
class $11b06753ce50693f$export$50792b0e93539fde {
    /**
   * The kind of Token.
   */ /**
   * The character offset at which this Node begins.
   */ /**
   * The character offset at which this Node ends.
   */ /**
   * The 1-indexed line number on which this Token appears.
   */ /**
   * The 1-indexed column number at which this Token begins.
   */ /**
   * For non-punctuation tokens, represents the interpreted value of the token.
   *
   * Note: is undefined for punctuation tokens, but typed as string for
   * convenience in the parser.
   */ /**
   * Tokens exist as nodes in a double-linked-list amongst all tokens
   * including ignored tokens. <SOF> is always the first node and <EOF>
   * the last.
   */ constructor(kind, start, end, line, column, value){
        this.kind = kind;
        this.start = start;
        this.end = end;
        this.line = line;
        this.column = column; // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        this.value = value;
        this.prev = null;
        this.next = null;
    }
    get [Symbol.toStringTag]() {
        return 'Token';
    }
    toJSON() {
        return {
            kind: this.kind,
            value: this.value,
            line: this.line,
            column: this.column
        };
    }
}
const $11b06753ce50693f$export$4fcd777a40ccf407 = {
    Name: [],
    Document: [
        'definitions'
    ],
    OperationDefinition: [
        'name',
        'variableDefinitions',
        'directives',
        'selectionSet'
    ],
    VariableDefinition: [
        'variable',
        'type',
        'defaultValue',
        'directives'
    ],
    Variable: [
        'name'
    ],
    SelectionSet: [
        'selections'
    ],
    Field: [
        'alias',
        'name',
        'arguments',
        'directives',
        'selectionSet'
    ],
    Argument: [
        'name',
        'value'
    ],
    FragmentSpread: [
        'name',
        'directives'
    ],
    InlineFragment: [
        'typeCondition',
        'directives',
        'selectionSet'
    ],
    FragmentDefinition: [
        'name',
        'variableDefinitions',
        'typeCondition',
        'directives',
        'selectionSet'
    ],
    IntValue: [],
    FloatValue: [],
    StringValue: [],
    BooleanValue: [],
    NullValue: [],
    EnumValue: [],
    ListValue: [
        'values'
    ],
    ObjectValue: [
        'fields'
    ],
    ObjectField: [
        'name',
        'value'
    ],
    Directive: [
        'name',
        'arguments'
    ],
    NamedType: [
        'name'
    ],
    ListType: [
        'type'
    ],
    NonNullType: [
        'type'
    ],
    SchemaDefinition: [
        'description',
        'directives',
        'operationTypes'
    ],
    OperationTypeDefinition: [
        'type'
    ],
    ScalarTypeDefinition: [
        'description',
        'name',
        'directives'
    ],
    ObjectTypeDefinition: [
        'description',
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    FieldDefinition: [
        'description',
        'name',
        'arguments',
        'type',
        'directives'
    ],
    InputValueDefinition: [
        'description',
        'name',
        'type',
        'defaultValue',
        'directives'
    ],
    InterfaceTypeDefinition: [
        'description',
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    UnionTypeDefinition: [
        'description',
        'name',
        'directives',
        'types'
    ],
    EnumTypeDefinition: [
        'description',
        'name',
        'directives',
        'values'
    ],
    EnumValueDefinition: [
        'description',
        'name',
        'directives'
    ],
    InputObjectTypeDefinition: [
        'description',
        'name',
        'directives',
        'fields'
    ],
    DirectiveDefinition: [
        'description',
        'name',
        'arguments',
        'locations'
    ],
    SchemaExtension: [
        'directives',
        'operationTypes'
    ],
    ScalarTypeExtension: [
        'name',
        'directives'
    ],
    ObjectTypeExtension: [
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    InterfaceTypeExtension: [
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    UnionTypeExtension: [
        'name',
        'directives',
        'types'
    ],
    EnumTypeExtension: [
        'name',
        'directives',
        'values'
    ],
    InputObjectTypeExtension: [
        'name',
        'directives',
        'fields'
    ]
};
const $11b06753ce50693f$var$kindValues = new Set(Object.keys($11b06753ce50693f$export$4fcd777a40ccf407));
function $11b06753ce50693f$export$8ee0fc9ee280b4ee(maybeNode) {
    const maybeKind = maybeNode === null || maybeNode === void 0 ? void 0 : maybeNode.kind;
    return typeof maybeKind === 'string' && $11b06753ce50693f$var$kindValues.has(maybeKind);
}
/** Name */ var $11b06753ce50693f$export$f58c50edb4aef9d4;
(function(OperationTypeNode) {
    OperationTypeNode['QUERY'] = 'query';
    OperationTypeNode['MUTATION'] = 'mutation';
    OperationTypeNode['SUBSCRIPTION'] = 'subscription';
})($11b06753ce50693f$export$f58c50edb4aef9d4 || ($11b06753ce50693f$export$f58c50edb4aef9d4 = {}));


/**
 * The set of allowed kind values for AST nodes.
 */ var $b7b8db97a7d116fe$export$a84bdc57c5122798;
(function(Kind) {
    Kind['NAME'] = 'Name';
    Kind['DOCUMENT'] = 'Document';
    Kind['OPERATION_DEFINITION'] = 'OperationDefinition';
    Kind['VARIABLE_DEFINITION'] = 'VariableDefinition';
    Kind['SELECTION_SET'] = 'SelectionSet';
    Kind['FIELD'] = 'Field';
    Kind['ARGUMENT'] = 'Argument';
    Kind['FRAGMENT_SPREAD'] = 'FragmentSpread';
    Kind['INLINE_FRAGMENT'] = 'InlineFragment';
    Kind['FRAGMENT_DEFINITION'] = 'FragmentDefinition';
    Kind['VARIABLE'] = 'Variable';
    Kind['INT'] = 'IntValue';
    Kind['FLOAT'] = 'FloatValue';
    Kind['STRING'] = 'StringValue';
    Kind['BOOLEAN'] = 'BooleanValue';
    Kind['NULL'] = 'NullValue';
    Kind['ENUM'] = 'EnumValue';
    Kind['LIST'] = 'ListValue';
    Kind['OBJECT'] = 'ObjectValue';
    Kind['OBJECT_FIELD'] = 'ObjectField';
    Kind['DIRECTIVE'] = 'Directive';
    Kind['NAMED_TYPE'] = 'NamedType';
    Kind['LIST_TYPE'] = 'ListType';
    Kind['NON_NULL_TYPE'] = 'NonNullType';
    Kind['SCHEMA_DEFINITION'] = 'SchemaDefinition';
    Kind['OPERATION_TYPE_DEFINITION'] = 'OperationTypeDefinition';
    Kind['SCALAR_TYPE_DEFINITION'] = 'ScalarTypeDefinition';
    Kind['OBJECT_TYPE_DEFINITION'] = 'ObjectTypeDefinition';
    Kind['FIELD_DEFINITION'] = 'FieldDefinition';
    Kind['INPUT_VALUE_DEFINITION'] = 'InputValueDefinition';
    Kind['INTERFACE_TYPE_DEFINITION'] = 'InterfaceTypeDefinition';
    Kind['UNION_TYPE_DEFINITION'] = 'UnionTypeDefinition';
    Kind['ENUM_TYPE_DEFINITION'] = 'EnumTypeDefinition';
    Kind['ENUM_VALUE_DEFINITION'] = 'EnumValueDefinition';
    Kind['INPUT_OBJECT_TYPE_DEFINITION'] = 'InputObjectTypeDefinition';
    Kind['DIRECTIVE_DEFINITION'] = 'DirectiveDefinition';
    Kind['SCHEMA_EXTENSION'] = 'SchemaExtension';
    Kind['SCALAR_TYPE_EXTENSION'] = 'ScalarTypeExtension';
    Kind['OBJECT_TYPE_EXTENSION'] = 'ObjectTypeExtension';
    Kind['INTERFACE_TYPE_EXTENSION'] = 'InterfaceTypeExtension';
    Kind['UNION_TYPE_EXTENSION'] = 'UnionTypeExtension';
    Kind['ENUM_TYPE_EXTENSION'] = 'EnumTypeExtension';
    Kind['INPUT_OBJECT_TYPE_EXTENSION'] = 'InputObjectTypeExtension';
})($b7b8db97a7d116fe$export$a84bdc57c5122798 || ($b7b8db97a7d116fe$export$a84bdc57c5122798 = {}));
 /**
 * The enum type representing the possible kind values of AST nodes.
 *
 * @deprecated Please use `Kind`. Will be remove in v17.
 */ 

const $78b48476e314521e$export$a89c95c098ac2a58 = Object.freeze({});
function $78b48476e314521e$export$bf638b60ea8b89b7(root, visitor, visitorKeys = (0, $11b06753ce50693f$export$4fcd777a40ccf407)) {
    const enterLeaveMap = new Map();
    for (const kind of Object.values((0, $b7b8db97a7d116fe$export$a84bdc57c5122798)))enterLeaveMap.set(kind, $78b48476e314521e$export$736de8489257458(visitor, kind));
    /* eslint-disable no-undef-init */ let stack = undefined;
    let inArray = Array.isArray(root);
    let keys = [
        root
    ];
    let index = -1;
    let edits = [];
    let node = root;
    let key = undefined;
    let parent = undefined;
    const path = [];
    const ancestors = [];
    /* eslint-enable no-undef-init */ do {
        index++;
        const isLeaving = index === keys.length;
        const isEdited = isLeaving && edits.length !== 0;
        if (isLeaving) {
            key = ancestors.length === 0 ? undefined : path[path.length - 1];
            node = parent;
            parent = ancestors.pop();
            if (isEdited) {
                if (inArray) {
                    node = node.slice();
                    let editOffset = 0;
                    for (const [editKey, editValue] of edits){
                        const arrayKey = editKey - editOffset;
                        if (editValue === null) {
                            node.splice(arrayKey, 1);
                            editOffset++;
                        } else node[arrayKey] = editValue;
                    }
                } else {
                    node = Object.defineProperties({}, Object.getOwnPropertyDescriptors(node));
                    for (const [editKey, editValue] of edits)node[editKey] = editValue;
                }
            }
            index = stack.index;
            keys = stack.keys;
            edits = stack.edits;
            inArray = stack.inArray;
            stack = stack.prev;
        } else if (parent) {
            key = inArray ? index : keys[index];
            node = parent[key];
            if (node === null || node === undefined) continue;
            path.push(key);
        }
        let result;
        if (!Array.isArray(node)) {
            var _enterLeaveMap$get, _enterLeaveMap$get2;
            (0, $11b06753ce50693f$export$8ee0fc9ee280b4ee)(node) || (0, $8beb5260c793fc92$export$b6cb5906f04696c8)(false, `Invalid AST Node: ${(0, $9541a54af6a37409$export$9dec5d1b3b6a130d)(node)}.`);
            const visitFn = isLeaving ? (_enterLeaveMap$get = enterLeaveMap.get(node.kind)) === null || _enterLeaveMap$get === void 0 ? void 0 : _enterLeaveMap$get.leave : (_enterLeaveMap$get2 = enterLeaveMap.get(node.kind)) === null || _enterLeaveMap$get2 === void 0 ? void 0 : _enterLeaveMap$get2.enter;
            result = visitFn === null || visitFn === void 0 ? void 0 : visitFn.call(visitor, node, key, parent, path, ancestors);
            if (result === $78b48476e314521e$export$a89c95c098ac2a58) break;
            if (result === false) {
                if (!isLeaving) {
                    path.pop();
                    continue;
                }
            } else if (result !== undefined) {
                edits.push([
                    key,
                    result
                ]);
                if (!isLeaving) {
                    if ((0, $11b06753ce50693f$export$8ee0fc9ee280b4ee)(result)) node = result;
                    else {
                        path.pop();
                        continue;
                    }
                }
            }
        }
        if (result === undefined && isEdited) edits.push([
            key,
            node
        ]);
        if (isLeaving) path.pop();
        else {
            var _node$kind;
            stack = {
                inArray: inArray,
                index: index,
                keys: keys,
                edits: edits,
                prev: stack
            };
            inArray = Array.isArray(node);
            keys = inArray ? node : (_node$kind = visitorKeys[node.kind]) !== null && _node$kind !== void 0 ? _node$kind : [];
            index = -1;
            edits = [];
            if (parent) ancestors.push(parent);
            parent = node;
        }
    }while (stack !== undefined);
    if (edits.length !== 0) // New root
    return edits[edits.length - 1][1];
    return root;
}
function $78b48476e314521e$export$728beebeea393478(visitors) {
    const skipping = new Array(visitors.length).fill(null);
    const mergedVisitor = Object.create(null);
    for (const kind of Object.values((0, $b7b8db97a7d116fe$export$a84bdc57c5122798))){
        let hasVisitor = false;
        const enterList = new Array(visitors.length).fill(undefined);
        const leaveList = new Array(visitors.length).fill(undefined);
        for(let i = 0; i < visitors.length; ++i){
            const { enter: enter, leave: leave } = $78b48476e314521e$export$736de8489257458(visitors[i], kind);
            hasVisitor || (hasVisitor = enter != null || leave != null);
            enterList[i] = enter;
            leaveList[i] = leave;
        }
        if (!hasVisitor) continue;
        const mergedEnterLeave = {
            enter (...args) {
                const node = args[0];
                for(let i = 0; i < visitors.length; i++)if (skipping[i] === null) {
                    var _enterList$i;
                    const result = (_enterList$i = enterList[i]) === null || _enterList$i === void 0 ? void 0 : _enterList$i.apply(visitors[i], args);
                    if (result === false) skipping[i] = node;
                    else if (result === $78b48476e314521e$export$a89c95c098ac2a58) skipping[i] = $78b48476e314521e$export$a89c95c098ac2a58;
                    else if (result !== undefined) return result;
                }
            },
            leave (...args) {
                const node = args[0];
                for(let i = 0; i < visitors.length; i++){
                    if (skipping[i] === null) {
                        var _leaveList$i;
                        const result = (_leaveList$i = leaveList[i]) === null || _leaveList$i === void 0 ? void 0 : _leaveList$i.apply(visitors[i], args);
                        if (result === $78b48476e314521e$export$a89c95c098ac2a58) skipping[i] = $78b48476e314521e$export$a89c95c098ac2a58;
                        else if (result !== undefined && result !== false) return result;
                    } else if (skipping[i] === node) skipping[i] = null;
                }
            }
        };
        mergedVisitor[kind] = mergedEnterLeave;
    }
    return mergedVisitor;
}
function $78b48476e314521e$export$736de8489257458(visitor, kind) {
    const kindVisitor = visitor[kind];
    if (typeof kindVisitor === 'object') // { Kind: { enter() {}, leave() {} } }
    return kindVisitor;
    else if (typeof kindVisitor === 'function') // { Kind() {} }
    return {
        enter: kindVisitor,
        leave: undefined
    };
     // { enter() {}, leave() {} }
    return {
        enter: visitor.enter,
        leave: visitor.leave
    };
}
function $78b48476e314521e$export$c9c25cca74db6e70(visitor, kind, isLeaving) {
    const { enter: enter, leave: leave } = $78b48476e314521e$export$736de8489257458(visitor, kind);
    return isLeaving ? leave : enter;
}


function $89c1eec09879e1ca$export$3dc388a5f013b4a5(_a, variables) {
    var directives = _a.directives;
    if (!directives || !directives.length) return true;
    return $89c1eec09879e1ca$export$b7bdffb7e6f1ef53(directives).every(function(_a) {
        var directive = _a.directive, ifArgument = _a.ifArgument;
        var evaledValue = false;
        if (ifArgument.value.kind === "Variable") {
            evaledValue = variables && variables[ifArgument.value.name.value];
            (0, $28d90d877eb1e517$export$f5708dca728d7177)(evaledValue !== void 0, 70, directive.name.value);
        } else evaledValue = ifArgument.value.value;
        return directive.name.value === "skip" ? !evaledValue : evaledValue;
    });
}
function $89c1eec09879e1ca$export$1b217de6ce18b9a(root) {
    var names = [];
    (0, $78b48476e314521e$export$bf638b60ea8b89b7)(root, {
        Directive: function(node) {
            names.push(node.name.value);
        }
    });
    return names;
}
var $89c1eec09879e1ca$export$528b5e7d8ba07fbf = function(names, root) {
    return $89c1eec09879e1ca$export$2dafb573e282fe8d(names, root, false);
};
var $89c1eec09879e1ca$export$ad1b63b26c1a9b76 = function(names, root) {
    return $89c1eec09879e1ca$export$2dafb573e282fe8d(names, root, true);
};
function $89c1eec09879e1ca$export$2dafb573e282fe8d(names, root, all) {
    var nameSet = new Set(names);
    var uniqueCount = nameSet.size;
    (0, $78b48476e314521e$export$bf638b60ea8b89b7)(root, {
        Directive: function(node) {
            if (nameSet.delete(node.name.value) && (!all || !nameSet.size)) return 0, $78b48476e314521e$export$a89c95c098ac2a58;
        }
    });
    // If we found all the names, nameSet will be empty. If we only care about
    // finding some of them, the < condition is sufficient.
    return all ? !nameSet.size : nameSet.size < uniqueCount;
}
function $89c1eec09879e1ca$export$8d1e9e5bbfa5d09a(document) {
    return document && $89c1eec09879e1ca$export$2dafb573e282fe8d([
        "client",
        "export"
    ], document, true);
}
function $89c1eec09879e1ca$var$isInclusionDirective(_a) {
    var value = _a.name.value;
    return value === "skip" || value === "include";
}
function $89c1eec09879e1ca$export$b7bdffb7e6f1ef53(directives) {
    var result = [];
    if (directives && directives.length) directives.forEach(function(directive) {
        if (!$89c1eec09879e1ca$var$isInclusionDirective(directive)) return;
        var directiveArguments = directive.arguments;
        var directiveName = directive.name.value;
        (0, $28d90d877eb1e517$export$f5708dca728d7177)(directiveArguments && directiveArguments.length === 1, 71, directiveName);
        var ifArgument = directiveArguments[0];
        (0, $28d90d877eb1e517$export$f5708dca728d7177)(ifArgument.name && ifArgument.name.value === "if", 72, directiveName);
        var ifValue = ifArgument.value;
        // means it has to be a variable value if this is a valid @skip or @include directive
        (0, $28d90d877eb1e517$export$f5708dca728d7177)(ifValue && (ifValue.kind === "Variable" || ifValue.kind === "BooleanValue"), 73, directiveName);
        result.push({
            directive: directive,
            ifArgument: ifArgument
        });
    });
    return result;
}







// A version of Array.isArray that works better with readonly arrays.
var $e6aaa0e65613edd7$export$43bee75e5e14138e = Array.isArray;
function $e6aaa0e65613edd7$export$d307f5934e447d0e(value) {
    return Array.isArray(value) && value.length > 0;
}


var $202b8a19e6086c64$var$TYPENAME_FIELD = {
    kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).FIELD,
    name: {
        kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).NAME,
        value: "__typename"
    }
};
function $202b8a19e6086c64$var$isEmpty(op, fragmentMap) {
    return !op || op.selectionSet.selections.every(function(selection) {
        return selection.kind === (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).FRAGMENT_SPREAD && $202b8a19e6086c64$var$isEmpty(fragmentMap[selection.name.value], fragmentMap);
    });
}
function $202b8a19e6086c64$var$nullIfDocIsEmpty(doc) {
    return $202b8a19e6086c64$var$isEmpty((0, $818d93327cb72c29$export$7a5b1fa979d2c158)(doc) || (0, $818d93327cb72c29$export$772111caef41b3f5)(doc), (0, $7f688c9754699513$export$193789b4c8246dd4)((0, $818d93327cb72c29$export$5320a7ba9466a3df)(doc))) ? null : doc;
}
function $202b8a19e6086c64$var$getDirectiveMatcher(configs) {
    var names = new Map();
    var tests = new Map();
    configs.forEach(function(directive) {
        if (directive) {
            if (directive.name) names.set(directive.name, directive);
            else if (directive.test) tests.set(directive.test, directive);
        }
    });
    return function(directive) {
        var config = names.get(directive.name.value);
        if (!config && tests.size) tests.forEach(function(testConfig, test) {
            if (test(directive)) config = testConfig;
        });
        return config;
    };
}
function $202b8a19e6086c64$var$makeInUseGetterFunction(defaultKey) {
    var map = new Map();
    return function inUseGetterFunction(key) {
        if (key === void 0) key = defaultKey;
        var inUse = map.get(key);
        if (!inUse) map.set(key, inUse = {
            // Variable and fragment spread names used directly within this
            // operation or fragment definition, as identified by key. These sets
            // will be populated during the first traversal of the document in
            // removeDirectivesFromDocument below.
            variables: new Set(),
            fragmentSpreads: new Set()
        });
        return inUse;
    };
}
function $202b8a19e6086c64$export$e5ae0530da5fe96c(directives, doc) {
    (0, $818d93327cb72c29$export$a7d0d8111d2386df)(doc);
    // Passing empty strings to makeInUseGetterFunction means we handle anonymous
    // operations as if their names were "". Anonymous fragment definitions are
    // not supposed to be possible, but the same default naming strategy seems
    // appropriate for that case as well.
    var getInUseByOperationName = $202b8a19e6086c64$var$makeInUseGetterFunction("");
    var getInUseByFragmentName = $202b8a19e6086c64$var$makeInUseGetterFunction("");
    var getInUse = function(ancestors) {
        for(var p = 0, ancestor = void 0; p < ancestors.length && (ancestor = ancestors[p]); ++p){
            if ((0, $e6aaa0e65613edd7$export$43bee75e5e14138e)(ancestor)) continue;
            if (ancestor.kind === (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).OPERATION_DEFINITION) // If an operation is anonymous, we use the empty string as its key.
            return getInUseByOperationName(ancestor.name && ancestor.name.value);
            if (ancestor.kind === (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).FRAGMENT_DEFINITION) return getInUseByFragmentName(ancestor.name.value);
        }
        globalThis.__DEV__ !== false && (0, $28d90d877eb1e517$export$f5708dca728d7177).error(86);
        return null;
    };
    var operationCount = 0;
    for(var i = doc.definitions.length - 1; i >= 0; --i)if (doc.definitions[i].kind === (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).OPERATION_DEFINITION) ++operationCount;
    var directiveMatcher = $202b8a19e6086c64$var$getDirectiveMatcher(directives);
    var shouldRemoveField = function(nodeDirectives) {
        return (0, $e6aaa0e65613edd7$export$d307f5934e447d0e)(nodeDirectives) && nodeDirectives.map(directiveMatcher).some(function(config) {
            return config && config.remove;
        });
    };
    var originalFragmentDefsByPath = new Map();
    // Any time the first traversal of the document below makes a change like
    // removing a fragment (by returning null), this variable should be set to
    // true. Once it becomes true, it should never be set to false again. If this
    // variable remains false throughout the traversal, then we can return the
    // original doc immediately without any modifications.
    var firstVisitMadeChanges = false;
    var fieldOrInlineFragmentVisitor = {
        enter: function(node) {
            if (shouldRemoveField(node.directives)) {
                firstVisitMadeChanges = true;
                return null;
            }
        }
    };
    var docWithoutDirectiveSubtrees = (0, $78b48476e314521e$export$bf638b60ea8b89b7)(doc, {
        // These two AST node types share the same implementation, defined above.
        Field: fieldOrInlineFragmentVisitor,
        InlineFragment: fieldOrInlineFragmentVisitor,
        VariableDefinition: {
            enter: function() {
                // VariableDefinition nodes do not count as variables in use, though
                // they do contain Variable nodes that might be visited below. To avoid
                // counting variable declarations as usages, we skip visiting the
                // contents of this VariableDefinition node by returning false.
                return false;
            }
        },
        Variable: {
            enter: function(node, _key, _parent, _path, ancestors) {
                var inUse = getInUse(ancestors);
                if (inUse) inUse.variables.add(node.name.value);
            }
        },
        FragmentSpread: {
            enter: function(node, _key, _parent, _path, ancestors) {
                if (shouldRemoveField(node.directives)) {
                    firstVisitMadeChanges = true;
                    return null;
                }
                var inUse = getInUse(ancestors);
                if (inUse) inUse.fragmentSpreads.add(node.name.value);
            // We might like to remove this FragmentSpread by returning null here if
            // the corresponding FragmentDefinition node is also going to be removed
            // by the logic below, but we can't control the relative order of those
            // events, so we have to postpone the removal of dangling FragmentSpread
            // nodes until after the current visit of the document has finished.
            }
        },
        FragmentDefinition: {
            enter: function(node, _key, _parent, path) {
                originalFragmentDefsByPath.set(JSON.stringify(path), node);
            },
            leave: function(node, _key, _parent, path) {
                var originalNode = originalFragmentDefsByPath.get(JSON.stringify(path));
                if (node === originalNode) // If the FragmentNode received by this leave function is identical to
                // the one received by the corresponding enter function (above), then
                // the visitor must not have made any changes within this
                // FragmentDefinition node. This fragment definition may still be
                // removed if there are no ...spread references to it, but it won't be
                // removed just because it has only a __typename field.
                return node;
                if (// This logic applies only if the document contains one or more
                // operations, since removing all fragments from a document containing
                // only fragments makes the document useless.
                operationCount > 0 && node.selectionSet.selections.every(function(selection) {
                    return selection.kind === (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).FIELD && selection.name.value === "__typename";
                })) {
                    // This is a somewhat opinionated choice: if a FragmentDefinition ends
                    // up having no fields other than __typename, we remove the whole
                    // fragment definition, and later prune ...spread references to it.
                    getInUseByFragmentName(node.name.value).removed = true;
                    firstVisitMadeChanges = true;
                    return null;
                }
            }
        },
        Directive: {
            leave: function(node) {
                // If a matching directive is found, remove the directive itself. Note
                // that this does not remove the target (field, argument, etc) of the
                // directive, but only the directive itself.
                if (directiveMatcher(node)) {
                    firstVisitMadeChanges = true;
                    return null;
                }
            }
        }
    });
    if (!firstVisitMadeChanges) // If our first pass did not change anything about the document, then there
    // is no cleanup we need to do, and we can return the original doc.
    return doc;
    // Utility for making sure inUse.transitiveVars is recursively populated.
    // Because this logic assumes inUse.fragmentSpreads has been completely
    // populated and inUse.removed has been set if appropriate,
    // populateTransitiveVars must be called after that information has been
    // collected by the first traversal of the document.
    var populateTransitiveVars = function(inUse) {
        if (!inUse.transitiveVars) {
            inUse.transitiveVars = new Set(inUse.variables);
            if (!inUse.removed) inUse.fragmentSpreads.forEach(function(childFragmentName) {
                populateTransitiveVars(getInUseByFragmentName(childFragmentName)).transitiveVars.forEach(function(varName) {
                    inUse.transitiveVars.add(varName);
                });
            });
        }
        return inUse;
    };
    // Since we've been keeping track of fragment spreads used by particular
    // operations and fragment definitions, we now need to compute the set of all
    // spreads used (transitively) by any operations in the document.
    var allFragmentNamesUsed = new Set();
    docWithoutDirectiveSubtrees.definitions.forEach(function(def) {
        if (def.kind === (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).OPERATION_DEFINITION) populateTransitiveVars(getInUseByOperationName(def.name && def.name.value)).fragmentSpreads.forEach(function(childFragmentName) {
            allFragmentNamesUsed.add(childFragmentName);
        });
        else if (def.kind === (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).FRAGMENT_DEFINITION && // If there are no operations in the document, then all fragment
        // definitions count as usages of their own fragment names. This heuristic
        // prevents accidentally removing all fragment definitions from the
        // document just because it contains no operations that use the fragments.
        operationCount === 0 && !getInUseByFragmentName(def.name.value).removed) allFragmentNamesUsed.add(def.name.value);
    });
    // Now that we have added all fragment spreads used by operations to the
    // allFragmentNamesUsed set, we can complete the set by transitively adding
    // all fragment spreads used by those fragments, and so on.
    allFragmentNamesUsed.forEach(function(fragmentName) {
        // Once all the childFragmentName strings added here have been seen already,
        // the top-level allFragmentNamesUsed.forEach loop will terminate.
        populateTransitiveVars(getInUseByFragmentName(fragmentName)).fragmentSpreads.forEach(function(childFragmentName) {
            allFragmentNamesUsed.add(childFragmentName);
        });
    });
    var fragmentWillBeRemoved = function(fragmentName) {
        return !!// A fragment definition will be removed if there are no spreads that refer
        // to it, or the fragment was explicitly removed because it had no fields
        // other than __typename.
        (!allFragmentNamesUsed.has(fragmentName) || getInUseByFragmentName(fragmentName).removed);
    };
    var enterVisitor = {
        enter: function(node) {
            if (fragmentWillBeRemoved(node.name.value)) return null;
        }
    };
    return $202b8a19e6086c64$var$nullIfDocIsEmpty((0, $78b48476e314521e$export$bf638b60ea8b89b7)(docWithoutDirectiveSubtrees, {
        // If the fragment is going to be removed, then leaving any dangling
        // FragmentSpread nodes with the same name would be a mistake.
        FragmentSpread: enterVisitor,
        // This is where the fragment definition is actually removed.
        FragmentDefinition: enterVisitor,
        OperationDefinition: {
            leave: function(node) {
                // Upon leaving each operation in the depth-first AST traversal, prune
                // any variables that are declared by the operation but unused within.
                if (node.variableDefinitions) {
                    var usedVariableNames_1 = populateTransitiveVars(// If an operation is anonymous, we use the empty string as its key.
                    getInUseByOperationName(node.name && node.name.value)).transitiveVars;
                    // According to the GraphQL spec, all variables declared by an
                    // operation must either be used by that operation or used by some
                    // fragment included transitively into that operation:
                    // https://spec.graphql.org/draft/#sec-All-Variables-Used
                    //
                    // To stay on the right side of this validation rule, if/when we
                    // remove the last $var references from an operation or its fragments,
                    // we must also remove the corresponding $var declaration from the
                    // enclosing operation. This pruning applies only to operations and
                    // not fragment definitions, at the moment. Fragments may be able to
                    // declare variables eventually, but today they can only consume them.
                    if (usedVariableNames_1.size < node.variableDefinitions.length) return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, node), {
                        variableDefinitions: node.variableDefinitions.filter(function(varDef) {
                            return usedVariableNames_1.has(varDef.variable.name.value);
                        })
                    });
                }
            }
        }
    }));
}
var $202b8a19e6086c64$export$43b332f87950a467 = Object.assign(function(doc) {
    return (0, $78b48476e314521e$export$bf638b60ea8b89b7)(doc, {
        SelectionSet: {
            enter: function(node, _key, parent) {
                // Don't add __typename to OperationDefinitions.
                if (parent && parent.kind === (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).OPERATION_DEFINITION) return;
                // No changes if no selections.
                var selections = node.selections;
                if (!selections) return;
                // If selections already have a __typename, or are part of an
                // introspection query, do nothing.
                var skip = selections.some(function(selection) {
                    return (0, $9d830e5028848843$export$fb56ad75dd311c12)(selection) && (selection.name.value === "__typename" || selection.name.value.lastIndexOf("__", 0) === 0);
                });
                if (skip) return;
                // If this SelectionSet is @export-ed as an input variable, it should
                // not have a __typename field (see issue #4691).
                var field = parent;
                if ((0, $9d830e5028848843$export$fb56ad75dd311c12)(field) && field.directives && field.directives.some(function(d) {
                    return d.name.value === "export";
                })) return;
                // Create and return a new SelectionSet with a __typename Field.
                return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, node), {
                    selections: (0, $5c96a02c592fcff1$export$1216008129fb82ed)((0, $5c96a02c592fcff1$export$1216008129fb82ed)([], selections, true), [
                        $202b8a19e6086c64$var$TYPENAME_FIELD
                    ], false)
                });
            }
        }
    });
}, {
    added: function(field) {
        return field === $202b8a19e6086c64$var$TYPENAME_FIELD;
    }
});
var $202b8a19e6086c64$var$connectionRemoveConfig = {
    test: function(directive) {
        var willRemove = directive.name.value === "connection";
        if (willRemove) {
            if (!directive.arguments || !directive.arguments.some(function(arg) {
                return arg.name.value === "key";
            })) globalThis.__DEV__ !== false && (0, $28d90d877eb1e517$export$f5708dca728d7177).warn(87);
        }
        return willRemove;
    }
};
function $202b8a19e6086c64$export$74985f3324559867(doc) {
    return $202b8a19e6086c64$export$e5ae0530da5fe96c([
        $202b8a19e6086c64$var$connectionRemoveConfig
    ], (0, $818d93327cb72c29$export$a7d0d8111d2386df)(doc));
}
function $202b8a19e6086c64$var$hasDirectivesInSelectionSet(directives, selectionSet, nestedCheck) {
    if (nestedCheck === void 0) nestedCheck = true;
    return !!selectionSet && selectionSet.selections && selectionSet.selections.some(function(selection) {
        return $202b8a19e6086c64$var$hasDirectivesInSelection(directives, selection, nestedCheck);
    });
}
function $202b8a19e6086c64$var$hasDirectivesInSelection(directives, selection, nestedCheck) {
    if (nestedCheck === void 0) nestedCheck = true;
    if (!(0, $9d830e5028848843$export$fb56ad75dd311c12)(selection)) return true;
    if (!selection.directives) return false;
    return selection.directives.some($202b8a19e6086c64$var$getDirectiveMatcher(directives)) || nestedCheck && $202b8a19e6086c64$var$hasDirectivesInSelectionSet(directives, selection.selectionSet, nestedCheck);
}
function $202b8a19e6086c64$var$getArgumentMatcher(config) {
    return function argumentMatcher(argument) {
        return config.some(function(aConfig) {
            return argument.value && argument.value.kind === (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).VARIABLE && argument.value.name && (aConfig.name === argument.value.name.value || aConfig.test && aConfig.test(argument));
        });
    };
}
function $202b8a19e6086c64$export$ecd5bb739c4a8b38(config, doc) {
    var argMatcher = $202b8a19e6086c64$var$getArgumentMatcher(config);
    return $202b8a19e6086c64$var$nullIfDocIsEmpty((0, $78b48476e314521e$export$bf638b60ea8b89b7)(doc, {
        OperationDefinition: {
            enter: function(node) {
                return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, node), {
                    // Remove matching top level variables definitions.
                    variableDefinitions: node.variableDefinitions ? node.variableDefinitions.filter(function(varDef) {
                        return !config.some(function(arg) {
                            return arg.name === varDef.variable.name.value;
                        });
                    }) : []
                });
            }
        },
        Field: {
            enter: function(node) {
                // If `remove` is set to true for an argument, and an argument match
                // is found for a field, remove the field as well.
                var shouldRemoveField = config.some(function(argConfig) {
                    return argConfig.remove;
                });
                if (shouldRemoveField) {
                    var argMatchCount_1 = 0;
                    if (node.arguments) node.arguments.forEach(function(arg) {
                        if (argMatcher(arg)) argMatchCount_1 += 1;
                    });
                    if (argMatchCount_1 === 1) return null;
                }
            }
        },
        Argument: {
            enter: function(node) {
                // Remove all matching arguments.
                if (argMatcher(node)) return null;
            }
        }
    }));
}
function $202b8a19e6086c64$export$7c9d17c333033c13(config, doc) {
    function enter(node) {
        if (config.some(function(def) {
            return def.name === node.name.value;
        })) return null;
    }
    return $202b8a19e6086c64$var$nullIfDocIsEmpty((0, $78b48476e314521e$export$bf638b60ea8b89b7)(doc, {
        FragmentSpread: {
            enter: enter
        },
        FragmentDefinition: {
            enter: enter
        }
    }));
}
function $202b8a19e6086c64$export$57c368c23873f32b(document) {
    var definition = (0, $818d93327cb72c29$export$f431198736b7f96d)(document);
    var definitionOperation = definition.operation;
    if (definitionOperation === "query") // Already a query, so return the existing document.
    return document;
    // Build a new query using the selection set of the main operation.
    var modifiedDoc = (0, $78b48476e314521e$export$bf638b60ea8b89b7)(document, {
        OperationDefinition: {
            enter: function(node) {
                return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, node), {
                    operation: "query"
                });
            }
        }
    });
    return modifiedDoc;
}
function $202b8a19e6086c64$export$8eae69e876ee321e(document) {
    (0, $818d93327cb72c29$export$a7d0d8111d2386df)(document);
    var modifiedDoc = $202b8a19e6086c64$export$e5ae0530da5fe96c([
        {
            test: function(directive) {
                return directive.name.value === "client";
            },
            remove: true
        }
    ], document);
    return modifiedDoc;
}



var $c32b8dc3cfa701c7$export$5f8e80ac52052e28 = function(p, label) {
    var serialized;
    try {
        serialized = JSON.stringify(p);
    } catch (e) {
        var parseError = (0, $28d90d877eb1e517$export$3991762405098ea)(40, label, e.message);
        parseError.parseError = e;
        throw parseError;
    }
    return serialized;
};


var $5a02450356081318$export$63ccc2571850f81a = function(operation, fallbackURI) {
    var context = operation.getContext();
    var contextURI = context.uri;
    if (contextURI) return contextURI;
    else if (typeof fallbackURI === "function") return fallbackURI(operation);
    else return fallbackURI || "/graphql";
};



/**
 * Original source:
 * https://github.com/kmalakoff/response-iterator/blob/master/src/index.ts
 */ 
var $5d0a073f980bb2a3$var$isReactNative = (0, $3ac3e23fcbe2d68c$export$f8b8b9ce72e9ccbf)(function() {
    return navigator.product;
}) == "ReactNative";
var $5d0a073f980bb2a3$export$772fbc04a0ad4ce9 = typeof WeakMap === "function" && !($5d0a073f980bb2a3$var$isReactNative && !$parcel$global.HermesInternal);
var $5d0a073f980bb2a3$export$7293b8a0b474028d = typeof WeakSet === "function";
var $5d0a073f980bb2a3$export$23ba675b4b838b92 = typeof Symbol === "function" && typeof Symbol.for === "function";
var $5d0a073f980bb2a3$export$c34f882e9f1c1637 = $5d0a073f980bb2a3$export$23ba675b4b838b92 && Symbol.asyncIterator;
var $5d0a073f980bb2a3$export$71594e8a50f746f4 = typeof (0, $3ac3e23fcbe2d68c$export$f8b8b9ce72e9ccbf)(function() {
    return window.document.createElement;
}) === "function";
var $5d0a073f980bb2a3$var$usingJSDOM = // Following advice found in this comment from @domenic (maintainer of jsdom):
// https://github.com/jsdom/jsdom/issues/1537#issuecomment-229405327
//
// Since we control the version of Jest and jsdom used when running Apollo
// Client tests, and that version is recent enought to include " jsdom/x.y.z"
// at the end of the user agent string, I believe this case is all we need to
// check. Testing for "Node.js" was recommended for backwards compatibility
// with older version of jsdom, but we don't have that problem.
(0, $3ac3e23fcbe2d68c$export$f8b8b9ce72e9ccbf)(function() {
    return navigator.userAgent.indexOf("jsdom") >= 0;
}) || false;
var $5d0a073f980bb2a3$export$4001f6cd4a62405b = ($5d0a073f980bb2a3$export$71594e8a50f746f4 || $5d0a073f980bb2a3$var$isReactNative) && !$5d0a073f980bb2a3$var$usingJSDOM;


/**
 * Original source:
 * https://github.com/kmalakoff/response-iterator/blob/master/src/iterators/async.ts
 */ function $1601b71e849a21db$export$2e2bcd8739ae039(source) {
    var _a;
    var iterator = source[Symbol.asyncIterator]();
    return _a = {
        next: function() {
            return iterator.next();
        }
    }, _a[Symbol.asyncIterator] = function() {
        return this;
    }, _a;
}


/**
 * Original source:
 * https://github.com/kmalakoff/response-iterator/blob/master/src/iterators/nodeStream.ts
 */ 
function $7a3bb2c4baa2eb3c$export$2e2bcd8739ae039(stream) {
    var cleanup = null;
    var error = null;
    var done = false;
    var data = [];
    var waiting = [];
    function onData(chunk) {
        if (error) return;
        if (waiting.length) {
            var shiftedArr = waiting.shift();
            if (Array.isArray(shiftedArr) && shiftedArr[0]) return shiftedArr[0]({
                value: chunk,
                done: false
            });
        }
        data.push(chunk);
    }
    function onError(err) {
        error = err;
        var all = waiting.slice();
        all.forEach(function(pair) {
            pair[1](err);
        });
        !cleanup || cleanup();
    }
    function onEnd() {
        done = true;
        var all = waiting.slice();
        all.forEach(function(pair) {
            pair[0]({
                value: undefined,
                done: true
            });
        });
        !cleanup || cleanup();
    }
    cleanup = function() {
        cleanup = null;
        stream.removeListener("data", onData);
        stream.removeListener("error", onError);
        stream.removeListener("end", onEnd);
        stream.removeListener("finish", onEnd);
        stream.removeListener("close", onEnd);
    };
    stream.on("data", onData);
    stream.on("error", onError);
    stream.on("end", onEnd);
    stream.on("finish", onEnd);
    stream.on("close", onEnd);
    function getNext() {
        return new Promise(function(resolve, reject) {
            if (error) return reject(error);
            if (data.length) return resolve({
                value: data.shift(),
                done: false
            });
            if (done) return resolve({
                value: undefined,
                done: true
            });
            waiting.push([
                resolve,
                reject
            ]);
        });
    }
    var iterator = {
        next: function() {
            return getNext();
        }
    };
    if (0, $5d0a073f980bb2a3$export$c34f882e9f1c1637) iterator[Symbol.asyncIterator] = function() {
        return this;
    };
    return iterator;
}


/**
 * Original source:
 * https://github.com/kmalakoff/response-iterator/blob/master/src/iterators/promise.ts
 */ 
function $4a4ee00566e93faf$export$2e2bcd8739ae039(promise) {
    var resolved = false;
    var iterator = {
        next: function() {
            if (resolved) return Promise.resolve({
                value: undefined,
                done: true
            });
            resolved = true;
            return new Promise(function(resolve, reject) {
                promise.then(function(value) {
                    resolve({
                        value: value,
                        done: false
                    });
                }).catch(reject);
            });
        }
    };
    if (0, $5d0a073f980bb2a3$export$c34f882e9f1c1637) iterator[Symbol.asyncIterator] = function() {
        return this;
    };
    return iterator;
}


/**
 * Original source:
 * https://github.com/kmalakoff/response-iterator/blob/master/src/iterators/reader.ts
 */ 
function $5fd38885ae4d12e0$export$2e2bcd8739ae039(reader) {
    var iterator = {
        next: function() {
            return reader.read();
        }
    };
    if (0, $5d0a073f980bb2a3$export$c34f882e9f1c1637) iterator[Symbol.asyncIterator] = function() {
        return this;
    };
    return iterator;
}


function $fd4188fd4ad08084$var$isNodeResponse(value) {
    return !!value.body;
}
function $fd4188fd4ad08084$var$isReadableStream(value) {
    return !!value.getReader;
}
function $fd4188fd4ad08084$var$isAsyncIterableIterator(value) {
    return !!((0, $5d0a073f980bb2a3$export$c34f882e9f1c1637) && value[Symbol.asyncIterator]);
}
function $fd4188fd4ad08084$var$isStreamableBlob(value) {
    return !!value.stream;
}
function $fd4188fd4ad08084$var$isBlob(value) {
    return !!value.arrayBuffer;
}
function $fd4188fd4ad08084$var$isNodeReadableStream(value) {
    return !!value.pipe;
}
function $fd4188fd4ad08084$export$7e4ac9ed9577f145(response) {
    var body = response;
    if ($fd4188fd4ad08084$var$isNodeResponse(response)) body = response.body;
    if ($fd4188fd4ad08084$var$isAsyncIterableIterator(body)) return (0, $1601b71e849a21db$export$2e2bcd8739ae039)(body);
    if ($fd4188fd4ad08084$var$isReadableStream(body)) return (0, $5fd38885ae4d12e0$export$2e2bcd8739ae039)(body.getReader());
    // this errors without casting to ReadableStream<T>
    // because Blob.stream() returns a NodeJS ReadableStream
    if ($fd4188fd4ad08084$var$isStreamableBlob(body)) return (0, $5fd38885ae4d12e0$export$2e2bcd8739ae039)(body.stream().getReader());
    if ($fd4188fd4ad08084$var$isBlob(body)) return (0, $4a4ee00566e93faf$export$2e2bcd8739ae039)(body.arrayBuffer());
    if ($fd4188fd4ad08084$var$isNodeReadableStream(body)) return (0, $7a3bb2c4baa2eb3c$export$2e2bcd8739ae039)(body);
    throw new Error("Unknown body type for responseIterator. Please pass a streamable response.");
}


var $844103e0eea42137$export$c33ef9219f27efd7 = function(response, result, message) {
    var error = new Error(message);
    error.name = "ServerError";
    error.response = response;
    error.statusCode = response.status;
    error.result = result;
    throw error;
};





var $456cf4c370166a0f$export$4995664c1b49842e = Symbol();
function $456cf4c370166a0f$export$345f95cc6b6b9b0b(result) {
    if (result.extensions) return Array.isArray(result.extensions[$456cf4c370166a0f$export$4995664c1b49842e]);
    return false;
}
function $456cf4c370166a0f$export$17f5e6bd290bb15d(err) {
    return err.hasOwnProperty("graphQLErrors");
}
// Sets the error message on this error according to the
// the GraphQL and network errors that are present.
// If the error message has already been set through the
// constructor or otherwise, this function is a nop.
var $456cf4c370166a0f$var$generateErrorMessage = function(err) {
    var errors = (0, $5c96a02c592fcff1$export$1216008129fb82ed)((0, $5c96a02c592fcff1$export$1216008129fb82ed)((0, $5c96a02c592fcff1$export$1216008129fb82ed)([], err.graphQLErrors, true), err.clientErrors, true), err.protocolErrors, true);
    if (err.networkError) errors.push(err.networkError);
    return errors// The rest of the code sometimes unsafely types non-Error objects as GraphQLErrors
    .map(function(err) {
        return (0, $3a16601e2096f4cd$export$417207af72fad9c9)(err) && err.message || "Error message not found.";
    }).join("\n");
};
var $456cf4c370166a0f$export$26a337512320b8c6 = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(ApolloError, _super);
    // Constructs an instance of ApolloError given serialized GraphQL errors,
    // client errors, protocol errors or network errors.
    // Note that one of these has to be a valid
    // value or the constructed error will be meaningless.
    function ApolloError(_a) {
        var graphQLErrors = _a.graphQLErrors, protocolErrors = _a.protocolErrors, clientErrors = _a.clientErrors, networkError = _a.networkError, errorMessage = _a.errorMessage, extraInfo = _a.extraInfo;
        var _this = _super.call(this, errorMessage) || this;
        _this.name = "ApolloError";
        _this.graphQLErrors = graphQLErrors || [];
        _this.protocolErrors = protocolErrors || [];
        _this.clientErrors = clientErrors || [];
        _this.networkError = networkError || null;
        _this.message = errorMessage || $456cf4c370166a0f$var$generateErrorMessage(_this);
        _this.extraInfo = extraInfo;
        _this.cause = (0, $5c96a02c592fcff1$export$1216008129fb82ed)((0, $5c96a02c592fcff1$export$1216008129fb82ed)((0, $5c96a02c592fcff1$export$1216008129fb82ed)([
            networkError
        ], graphQLErrors || [], true), protocolErrors || [], true), clientErrors || [], true).find(function(e) {
            return !!e;
        }) || null;
        // We're not using `Object.setPrototypeOf` here as it isn't fully
        // supported on Android (see issue #3236).
        _this.__proto__ = ApolloError.prototype;
        return _this;
    }
    return ApolloError;
}(Error);






var $0217b27a7999d1ae$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $0217b27a7999d1ae$export$dd702b3c8240390c() {
    var sources = [];
    for(var _i = 0; _i < arguments.length; _i++)sources[_i] = arguments[_i];
    return $0217b27a7999d1ae$export$160070228be94b08(sources);
}
function $0217b27a7999d1ae$export$160070228be94b08(sources) {
    var target = sources[0] || {};
    var count = sources.length;
    if (count > 1) {
        var merger = new $0217b27a7999d1ae$export$509e11c221f576c0();
        for(var i = 1; i < count; ++i)target = merger.merge(target, sources[i]);
    }
    return target;
}
var $0217b27a7999d1ae$var$defaultReconciler = function(target, source, property) {
    return this.merge(target[property], source[property]);
};
var $0217b27a7999d1ae$export$509e11c221f576c0 = /** @class */ function() {
    function DeepMerger(reconciler) {
        if (reconciler === void 0) reconciler = $0217b27a7999d1ae$var$defaultReconciler;
        this.reconciler = reconciler;
        this.isObject = (0, $3a16601e2096f4cd$export$417207af72fad9c9);
        this.pastCopies = new Set();
    }
    DeepMerger.prototype.merge = function(target, source) {
        var _this = this;
        var context = [];
        for(var _i = 2; _i < arguments.length; _i++)context[_i - 2] = arguments[_i];
        if ((0, $3a16601e2096f4cd$export$417207af72fad9c9)(source) && (0, $3a16601e2096f4cd$export$417207af72fad9c9)(target)) {
            Object.keys(source).forEach(function(sourceKey) {
                if ($0217b27a7999d1ae$var$hasOwnProperty.call(target, sourceKey)) {
                    var targetValue = target[sourceKey];
                    if (source[sourceKey] !== targetValue) {
                        var result = _this.reconciler.apply(_this, (0, $5c96a02c592fcff1$export$1216008129fb82ed)([
                            target,
                            source,
                            sourceKey
                        ], context, false));
                        // A well-implemented reconciler may return targetValue to indicate
                        // the merge changed nothing about the structure of the target.
                        if (result !== targetValue) {
                            target = _this.shallowCopyForMerge(target);
                            target[sourceKey] = result;
                        }
                    }
                } else {
                    // If there is no collision, the target can safely share memory with
                    // the source, and the recursion can terminate here.
                    target = _this.shallowCopyForMerge(target);
                    target[sourceKey] = source[sourceKey];
                }
            });
            return target;
        }
        // If source (or target) is not an object, let source replace target.
        return source;
    };
    DeepMerger.prototype.shallowCopyForMerge = function(value) {
        if ((0, $3a16601e2096f4cd$export$417207af72fad9c9)(value)) {
            if (!this.pastCopies.has(value)) {
                if (Array.isArray(value)) value = value.slice(0);
                else value = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                    __proto__: Object.getPrototypeOf(value)
                }, value);
                this.pastCopies.add(value);
            }
        }
        return value;
    };
    return DeepMerger;
}();


function $4753a78f97af1d82$export$879767c5cdf33cb3(value) {
    return "incremental" in value;
}
function $4753a78f97af1d82$export$6c17a45d8c64ff02(value) {
    return "hasNext" in value && "data" in value;
}
function $4753a78f97af1d82$export$f90dc0a3531b8b83(value) {
    return $4753a78f97af1d82$export$879767c5cdf33cb3(value) || $4753a78f97af1d82$export$6c17a45d8c64ff02(value);
}
function $4753a78f97af1d82$export$3f32b6369f408f33(value) {
    return (0, $3a16601e2096f4cd$export$417207af72fad9c9)(value) && "payload" in value;
}
function $4753a78f97af1d82$export$9a905f57d6393874(prevResult, result) {
    var mergedData = prevResult;
    var merger = new (0, $0217b27a7999d1ae$export$509e11c221f576c0)();
    if ($4753a78f97af1d82$export$879767c5cdf33cb3(result) && (0, $e6aaa0e65613edd7$export$d307f5934e447d0e)(result.incremental)) result.incremental.forEach(function(_a) {
        var data = _a.data, path = _a.path;
        for(var i = path.length - 1; i >= 0; --i){
            var key = path[i];
            var isNumericKey = !isNaN(+key);
            var parent_1 = isNumericKey ? [] : {};
            parent_1[key] = data;
            data = parent_1;
        }
        mergedData = merger.merge(mergedData, data);
    });
    return mergedData;
}


var $6ba89ebc2766b493$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $6ba89ebc2766b493$export$ccb60864026baf09(response, nextValue) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(this, void 0, void 0, function() {
        var decoder, contentType, delimiter, boundaryVal, boundary, buffer, iterator, running, _a, value, done, chunk, searchFrom, bi, message, i, headers, contentType_1, body, result, next;
        var _b, _c;
        var _d;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_e) {
            switch(_e.label){
                case 0:
                    if (TextDecoder === undefined) throw new Error("TextDecoder must be defined in the environment: please import a polyfill.");
                    decoder = new TextDecoder("utf-8");
                    contentType = (_d = response.headers) === null || _d === void 0 ? void 0 : _d.get("content-type");
                    delimiter = "boundary=";
                    boundaryVal = (contentType === null || contentType === void 0 ? void 0 : contentType.includes(delimiter)) ? contentType === null || contentType === void 0 ? void 0 : contentType.substring((contentType === null || contentType === void 0 ? void 0 : contentType.indexOf(delimiter)) + delimiter.length).replace(/['"]/g, "").replace(/\;(.*)/gm, "").trim() : "-";
                    boundary = "\r\n--".concat(boundaryVal);
                    buffer = "";
                    iterator = (0, $fd4188fd4ad08084$export$7e4ac9ed9577f145)(response);
                    running = true;
                    _e.label = 1;
                case 1:
                    if (!running) return [
                        3 /*break*/ ,
                        3
                    ];
                    return [
                        4 /*yield*/ ,
                        iterator.next()
                    ];
                case 2:
                    _a = _e.sent(), value = _a.value, done = _a.done;
                    chunk = typeof value === "string" ? value : decoder.decode(value);
                    searchFrom = buffer.length - boundary.length + 1;
                    running = !done;
                    buffer += chunk;
                    bi = buffer.indexOf(boundary, searchFrom);
                    while(bi > -1){
                        message = void 0;
                        _b = [
                            buffer.slice(0, bi),
                            buffer.slice(bi + boundary.length)
                        ], message = _b[0], buffer = _b[1];
                        i = message.indexOf("\r\n\r\n");
                        headers = $6ba89ebc2766b493$export$eea2c1c5e1a37e50(message.slice(0, i));
                        contentType_1 = headers["content-type"];
                        if (contentType_1 && contentType_1.toLowerCase().indexOf("application/json") === -1) throw new Error("Unsupported patch content type: application/json is required.");
                        body = message.slice(i);
                        if (body) {
                            result = $6ba89ebc2766b493$export$759bcb35b0d1bf81(response, body);
                            if (Object.keys(result).length > 1 || "data" in result || "incremental" in result || "errors" in result || "payload" in result) {
                                if ((0, $4753a78f97af1d82$export$3f32b6369f408f33)(result)) {
                                    next = {};
                                    if ("payload" in result) {
                                        if (Object.keys(result).length === 1 && result.payload === null) return [
                                            2 /*return*/ 
                                        ];
                                        next = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, result.payload);
                                    }
                                    if ("errors" in result) next = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, next), {
                                        extensions: (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, "extensions" in next ? next.extensions : null), (_c = {}, _c[0, $456cf4c370166a0f$export$4995664c1b49842e] = result.errors, _c))
                                    });
                                    nextValue(next);
                                } else // for the last chunk with only `hasNext: false`
                                // we don't need to call observer.next as there is no data/errors
                                nextValue(result);
                            } else if (// If the chunk contains only a "hasNext: false", we can call
                            // observer.complete() immediately.
                            Object.keys(result).length === 1 && "hasNext" in result && !result.hasNext) return [
                                2 /*return*/ 
                            ];
                        }
                        bi = buffer.indexOf(boundary);
                    }
                    return [
                        3 /*break*/ ,
                        1
                    ];
                case 3:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
}
function $6ba89ebc2766b493$export$eea2c1c5e1a37e50(headerText) {
    var headersInit = {};
    headerText.split("\n").forEach(function(line) {
        var i = line.indexOf(":");
        if (i > -1) {
            // normalize headers to lowercase
            var name_1 = line.slice(0, i).trim().toLowerCase();
            var value = line.slice(i + 1).trim();
            headersInit[name_1] = value;
        }
    });
    return headersInit;
}
function $6ba89ebc2766b493$export$759bcb35b0d1bf81(response, bodyText) {
    if (response.status >= 300) {
        // Network error
        var getResult = function() {
            try {
                return JSON.parse(bodyText);
            } catch (err) {
                return bodyText;
            }
        };
        (0, $844103e0eea42137$export$c33ef9219f27efd7)(response, getResult(), "Response not successful: Received status code ".concat(response.status));
    }
    try {
        return JSON.parse(bodyText);
    } catch (err) {
        var parseError = err;
        parseError.name = "ServerParseError";
        parseError.response = response;
        parseError.statusCode = response.status;
        parseError.bodyText = bodyText;
        throw parseError;
    }
}
function $6ba89ebc2766b493$export$d3da1ecaf1206c58(err, observer) {
    // if it is a network error, BUT there is graphql result info fire
    // the next observer before calling error this gives apollo-client
    // (and react-apollo) the `graphqlErrors` and `networkErrors` to
    // pass to UI this should only happen if we *also* have data as
    // part of the response key per the spec
    if (err.result && err.result.errors && err.result.data) // if we don't call next, the UI can only show networkError
    // because AC didn't get any graphqlErrors this is graphql
    // execution result info (i.e errors and possibly data) this is
    // because there is no formal spec how errors should translate to
    // http status codes. So an auth error (401) could have both data
    // from a public field, errors from a private field, and a status
    // of 401
    // {
    //  user { // this will have errors
    //    firstName
    //  }
    //  products { // this is public so will have data
    //    cost
    //  }
    // }
    //
    // the result of above *could* look like this:
    // {
    //   data: { products: [{ cost: "$10" }] },
    //   errors: [{
    //      message: 'your session has timed out',
    //      path: []
    //   }]
    // }
    // status code of above would be a 401
    // in the UI you want to show data where you can, errors as data where you can
    // and use correct http status codes
    observer.next(err.result);
    observer.error(err);
}
function $6ba89ebc2766b493$export$d4051215bea0639f(operations) {
    return function(response) {
        return response.text().then(function(bodyText) {
            return $6ba89ebc2766b493$export$759bcb35b0d1bf81(response, bodyText);
        }).then(function(result) {
            if (!Array.isArray(result) && !$6ba89ebc2766b493$var$hasOwnProperty.call(result, "data") && !$6ba89ebc2766b493$var$hasOwnProperty.call(result, "errors")) // Data error
            (0, $844103e0eea42137$export$c33ef9219f27efd7)(response, result, "Server response was missing for query '".concat(Array.isArray(operations) ? operations.map(function(op) {
                return op.operationName;
            }) : operations.operationName, "'."));
            return result;
        });
    };
}



var $fc846bb2ae15ec15$export$8423f0cd3773115e = function(fetcher) {
    if (!fetcher && typeof fetch === "undefined") throw (0, $28d90d877eb1e517$export$3991762405098ea)(38);
};



/**
 * ```
 * WhiteSpace ::
 *   - "Horizontal Tab (U+0009)"
 *   - "Space (U+0020)"
 * ```
 * @internal
 */ function $876b79dde797933a$export$3c52dd84024ae72c(code) {
    return code === 0x0009 || code === 0x0020;
}
function $876b79dde797933a$export$727d9dbc4fbb948f(code) {
    return code >= 0x0030 && code <= 0x0039;
}
function $876b79dde797933a$export$79c5d5217943d6a7(code) {
    return code >= 0x0061 && code <= 0x007a || // A-Z
    code >= 0x0041 && code <= 0x005a // a-z
    ;
}
function $876b79dde797933a$export$45a677ea7cb6d5c8(code) {
    return $876b79dde797933a$export$79c5d5217943d6a7(code) || code === 0x005f;
}
function $876b79dde797933a$export$d3f406ff46035894(code) {
    return $876b79dde797933a$export$79c5d5217943d6a7(code) || $876b79dde797933a$export$727d9dbc4fbb948f(code) || code === 0x005f;
}


function $a51b3e37e1f6e888$export$d5ee19b441e8d2ae(lines) {
    var _firstNonEmptyLine2;
    let commonIndent = Number.MAX_SAFE_INTEGER;
    let firstNonEmptyLine = null;
    let lastNonEmptyLine = -1;
    for(let i = 0; i < lines.length; ++i){
        var _firstNonEmptyLine;
        const line = lines[i];
        const indent = $a51b3e37e1f6e888$var$leadingWhitespace(line);
        if (indent === line.length) continue; // skip empty lines
        firstNonEmptyLine = (_firstNonEmptyLine = firstNonEmptyLine) !== null && _firstNonEmptyLine !== void 0 ? _firstNonEmptyLine : i;
        lastNonEmptyLine = i;
        if (i !== 0 && indent < commonIndent) commonIndent = indent;
    }
    return lines // Remove common indentation from all lines but first.
    .map((line, i)=>i === 0 ? line : line.slice(commonIndent)) // Remove leading and trailing blank lines.
    .slice((_firstNonEmptyLine2 = firstNonEmptyLine) !== null && _firstNonEmptyLine2 !== void 0 ? _firstNonEmptyLine2 : 0, lastNonEmptyLine + 1);
}
function $a51b3e37e1f6e888$var$leadingWhitespace(str) {
    let i = 0;
    while(i < str.length && (0, $876b79dde797933a$export$3c52dd84024ae72c)(str.charCodeAt(i)))++i;
    return i;
}
function $a51b3e37e1f6e888$export$40862a63ef85e395(value) {
    if (value === '') return true; // empty string is printable
    let isEmptyLine = true;
    let hasIndent = false;
    let hasCommonIndent = true;
    let seenNonEmptyLine = false;
    for(let i = 0; i < value.length; ++i)switch(value.codePointAt(i)){
        case 0x0000:
        case 0x0001:
        case 0x0002:
        case 0x0003:
        case 0x0004:
        case 0x0005:
        case 0x0006:
        case 0x0007:
        case 0x0008:
        case 0x000b:
        case 0x000c:
        case 0x000e:
        case 0x000f:
            return false;
        // Has non-printable characters
        case 0x000d:
            //  \r
            return false;
        // Has \r or \r\n which will be replaced as \n
        case 10:
            //  \n
            if (isEmptyLine && !seenNonEmptyLine) return false; // Has leading new line
            seenNonEmptyLine = true;
            isEmptyLine = true;
            hasIndent = false;
            break;
        case 9:
        case 32:
            //  <space>
            hasIndent || (hasIndent = isEmptyLine);
            break;
        default:
            hasCommonIndent && (hasCommonIndent = hasIndent);
            isEmptyLine = false;
    }
    if (isEmptyLine) return false; // Has trailing empty lines
    if (hasCommonIndent && seenNonEmptyLine) return false; // Has internal indent
    return true;
}
function $a51b3e37e1f6e888$export$adb6ca997eeb1f45(value, options) {
    const escapedValue = value.replace(/"""/g, '\\"""'); // Expand a block string's raw value into independent lines.
    const lines = escapedValue.split(/\r\n|[\n\r]/g);
    const isSingleLine = lines.length === 1; // If common indentation is found we can fix some of those cases by adding leading new line
    const forceLeadingNewLine = lines.length > 1 && lines.slice(1).every((line)=>line.length === 0 || (0, $876b79dde797933a$export$3c52dd84024ae72c)(line.charCodeAt(0))); // Trailing triple quotes just looks confusing but doesn't force trailing new line
    const hasTrailingTripleQuotes = escapedValue.endsWith('\\"""'); // Trailing quote (single or double) or slash forces trailing new line
    const hasTrailingQuote = value.endsWith('"') && !hasTrailingTripleQuotes;
    const hasTrailingSlash = value.endsWith('\\');
    const forceTrailingNewline = hasTrailingQuote || hasTrailingSlash;
    const printAsMultipleLines = !(options !== null && options !== void 0 && options.minimize) && // add leading and trailing new lines only if it improves readability
    (!isSingleLine || value.length > 70 || forceTrailingNewline || forceLeadingNewLine || hasTrailingTripleQuotes);
    let result = ''; // Format a multi-line block quote to account for leading space.
    const skipLeadingNewLine = isSingleLine && (0, $876b79dde797933a$export$3c52dd84024ae72c)(value.charCodeAt(0));
    if (printAsMultipleLines && !skipLeadingNewLine || forceLeadingNewLine) result += '\n';
    result += escapedValue;
    if (printAsMultipleLines || forceTrailingNewline) result += '\n';
    return '"""' + result + '"""';
}


/**
 * Prints a string as a GraphQL StringValue literal. Replaces control characters
 * and excluded characters (" U+0022 and \\ U+005C) with escape sequences.
 */ function $670ab209adef6fbd$export$3cdec7cf614a0ecc(str) {
    return `"${str.replace($670ab209adef6fbd$var$escapedRegExp, $670ab209adef6fbd$var$escapedReplacer)}"`;
} // eslint-disable-next-line no-control-regex
const $670ab209adef6fbd$var$escapedRegExp = /[\x00-\x1f\x22\x5c\x7f-\x9f]/g;
function $670ab209adef6fbd$var$escapedReplacer(str) {
    return $670ab209adef6fbd$var$escapeSequences[str.charCodeAt(0)];
} // prettier-ignore
const $670ab209adef6fbd$var$escapeSequences = [
    '\\u0000',
    '\\u0001',
    '\\u0002',
    '\\u0003',
    '\\u0004',
    '\\u0005',
    '\\u0006',
    '\\u0007',
    '\\b',
    '\\t',
    '\\n',
    '\\u000B',
    '\\f',
    '\\r',
    '\\u000E',
    '\\u000F',
    '\\u0010',
    '\\u0011',
    '\\u0012',
    '\\u0013',
    '\\u0014',
    '\\u0015',
    '\\u0016',
    '\\u0017',
    '\\u0018',
    '\\u0019',
    '\\u001A',
    '\\u001B',
    '\\u001C',
    '\\u001D',
    '\\u001E',
    '\\u001F',
    '',
    '',
    '\\"',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '\\\\',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '\\u007F',
    '\\u0080',
    '\\u0081',
    '\\u0082',
    '\\u0083',
    '\\u0084',
    '\\u0085',
    '\\u0086',
    '\\u0087',
    '\\u0088',
    '\\u0089',
    '\\u008A',
    '\\u008B',
    '\\u008C',
    '\\u008D',
    '\\u008E',
    '\\u008F',
    '\\u0090',
    '\\u0091',
    '\\u0092',
    '\\u0093',
    '\\u0094',
    '\\u0095',
    '\\u0096',
    '\\u0097',
    '\\u0098',
    '\\u0099',
    '\\u009A',
    '\\u009B',
    '\\u009C',
    '\\u009D',
    '\\u009E',
    '\\u009F'
];



function $e6602c9cee6df4a2$export$c2d084dc44961371(ast) {
    return (0, $78b48476e314521e$export$bf638b60ea8b89b7)(ast, $e6602c9cee6df4a2$var$printDocASTReducer);
}
const $e6602c9cee6df4a2$var$MAX_LINE_LENGTH = 80;
const $e6602c9cee6df4a2$var$printDocASTReducer = {
    Name: {
        leave: (node)=>node.value
    },
    Variable: {
        leave: (node)=>'$' + node.name
    },
    // Document
    Document: {
        leave: (node)=>$e6602c9cee6df4a2$var$join(node.definitions, '\n\n')
    },
    OperationDefinition: {
        leave (node) {
            const varDefs = $e6602c9cee6df4a2$var$wrap('(', $e6602c9cee6df4a2$var$join(node.variableDefinitions, ', '), ')');
            const prefix = $e6602c9cee6df4a2$var$join([
                node.operation,
                $e6602c9cee6df4a2$var$join([
                    node.name,
                    varDefs
                ]),
                $e6602c9cee6df4a2$var$join(node.directives, ' ')
            ], ' '); // Anonymous queries with no directives or variable definitions can use
            // the query short form.
            return (prefix === 'query' ? '' : prefix + ' ') + node.selectionSet;
        }
    },
    VariableDefinition: {
        leave: ({ variable: variable, type: type, defaultValue: defaultValue, directives: directives })=>variable + ': ' + type + $e6602c9cee6df4a2$var$wrap(' = ', defaultValue) + $e6602c9cee6df4a2$var$wrap(' ', $e6602c9cee6df4a2$var$join(directives, ' '))
    },
    SelectionSet: {
        leave: ({ selections: selections })=>$e6602c9cee6df4a2$var$block(selections)
    },
    Field: {
        leave ({ alias: alias, name: name, arguments: args, directives: directives, selectionSet: selectionSet }) {
            const prefix = $e6602c9cee6df4a2$var$wrap('', alias, ': ') + name;
            let argsLine = prefix + $e6602c9cee6df4a2$var$wrap('(', $e6602c9cee6df4a2$var$join(args, ', '), ')');
            if (argsLine.length > $e6602c9cee6df4a2$var$MAX_LINE_LENGTH) argsLine = prefix + $e6602c9cee6df4a2$var$wrap('(\n', $e6602c9cee6df4a2$var$indent($e6602c9cee6df4a2$var$join(args, '\n')), '\n)');
            return $e6602c9cee6df4a2$var$join([
                argsLine,
                $e6602c9cee6df4a2$var$join(directives, ' '),
                selectionSet
            ], ' ');
        }
    },
    Argument: {
        leave: ({ name: name, value: value })=>name + ': ' + value
    },
    // Fragments
    FragmentSpread: {
        leave: ({ name: name, directives: directives })=>'...' + name + $e6602c9cee6df4a2$var$wrap(' ', $e6602c9cee6df4a2$var$join(directives, ' '))
    },
    InlineFragment: {
        leave: ({ typeCondition: typeCondition, directives: directives, selectionSet: selectionSet })=>$e6602c9cee6df4a2$var$join([
                '...',
                $e6602c9cee6df4a2$var$wrap('on ', typeCondition),
                $e6602c9cee6df4a2$var$join(directives, ' '),
                selectionSet
            ], ' ')
    },
    FragmentDefinition: {
        leave: ({ name: name, typeCondition: typeCondition, variableDefinitions: variableDefinitions, directives: directives, selectionSet: selectionSet })=>// or removed in the future.
            `fragment ${name}${$e6602c9cee6df4a2$var$wrap('(', $e6602c9cee6df4a2$var$join(variableDefinitions, ', '), ')')} ` + `on ${typeCondition} ${$e6602c9cee6df4a2$var$wrap('', $e6602c9cee6df4a2$var$join(directives, ' '), ' ')}` + selectionSet
    },
    // Value
    IntValue: {
        leave: ({ value: value })=>value
    },
    FloatValue: {
        leave: ({ value: value })=>value
    },
    StringValue: {
        leave: ({ value: value, block: isBlockString })=>isBlockString ? (0, $a51b3e37e1f6e888$export$adb6ca997eeb1f45)(value) : (0, $670ab209adef6fbd$export$3cdec7cf614a0ecc)(value)
    },
    BooleanValue: {
        leave: ({ value: value })=>value ? 'true' : 'false'
    },
    NullValue: {
        leave: ()=>'null'
    },
    EnumValue: {
        leave: ({ value: value })=>value
    },
    ListValue: {
        leave: ({ values: values })=>'[' + $e6602c9cee6df4a2$var$join(values, ', ') + ']'
    },
    ObjectValue: {
        leave: ({ fields: fields })=>'{' + $e6602c9cee6df4a2$var$join(fields, ', ') + '}'
    },
    ObjectField: {
        leave: ({ name: name, value: value })=>name + ': ' + value
    },
    // Directive
    Directive: {
        leave: ({ name: name, arguments: args })=>'@' + name + $e6602c9cee6df4a2$var$wrap('(', $e6602c9cee6df4a2$var$join(args, ', '), ')')
    },
    // Type
    NamedType: {
        leave: ({ name: name })=>name
    },
    ListType: {
        leave: ({ type: type })=>'[' + type + ']'
    },
    NonNullType: {
        leave: ({ type: type })=>type + '!'
    },
    // Type System Definitions
    SchemaDefinition: {
        leave: ({ description: description, directives: directives, operationTypes: operationTypes })=>$e6602c9cee6df4a2$var$wrap('', description, '\n') + $e6602c9cee6df4a2$var$join([
                'schema',
                $e6602c9cee6df4a2$var$join(directives, ' '),
                $e6602c9cee6df4a2$var$block(operationTypes)
            ], ' ')
    },
    OperationTypeDefinition: {
        leave: ({ operation: operation, type: type })=>operation + ': ' + type
    },
    ScalarTypeDefinition: {
        leave: ({ description: description, name: name, directives: directives })=>$e6602c9cee6df4a2$var$wrap('', description, '\n') + $e6602c9cee6df4a2$var$join([
                'scalar',
                name,
                $e6602c9cee6df4a2$var$join(directives, ' ')
            ], ' ')
    },
    ObjectTypeDefinition: {
        leave: ({ description: description, name: name, interfaces: interfaces, directives: directives, fields: fields })=>$e6602c9cee6df4a2$var$wrap('', description, '\n') + $e6602c9cee6df4a2$var$join([
                'type',
                name,
                $e6602c9cee6df4a2$var$wrap('implements ', $e6602c9cee6df4a2$var$join(interfaces, ' & ')),
                $e6602c9cee6df4a2$var$join(directives, ' '),
                $e6602c9cee6df4a2$var$block(fields)
            ], ' ')
    },
    FieldDefinition: {
        leave: ({ description: description, name: name, arguments: args, type: type, directives: directives })=>$e6602c9cee6df4a2$var$wrap('', description, '\n') + name + ($e6602c9cee6df4a2$var$hasMultilineItems(args) ? $e6602c9cee6df4a2$var$wrap('(\n', $e6602c9cee6df4a2$var$indent($e6602c9cee6df4a2$var$join(args, '\n')), '\n)') : $e6602c9cee6df4a2$var$wrap('(', $e6602c9cee6df4a2$var$join(args, ', '), ')')) + ': ' + type + $e6602c9cee6df4a2$var$wrap(' ', $e6602c9cee6df4a2$var$join(directives, ' '))
    },
    InputValueDefinition: {
        leave: ({ description: description, name: name, type: type, defaultValue: defaultValue, directives: directives })=>$e6602c9cee6df4a2$var$wrap('', description, '\n') + $e6602c9cee6df4a2$var$join([
                name + ': ' + type,
                $e6602c9cee6df4a2$var$wrap('= ', defaultValue),
                $e6602c9cee6df4a2$var$join(directives, ' ')
            ], ' ')
    },
    InterfaceTypeDefinition: {
        leave: ({ description: description, name: name, interfaces: interfaces, directives: directives, fields: fields })=>$e6602c9cee6df4a2$var$wrap('', description, '\n') + $e6602c9cee6df4a2$var$join([
                'interface',
                name,
                $e6602c9cee6df4a2$var$wrap('implements ', $e6602c9cee6df4a2$var$join(interfaces, ' & ')),
                $e6602c9cee6df4a2$var$join(directives, ' '),
                $e6602c9cee6df4a2$var$block(fields)
            ], ' ')
    },
    UnionTypeDefinition: {
        leave: ({ description: description, name: name, directives: directives, types: types })=>$e6602c9cee6df4a2$var$wrap('', description, '\n') + $e6602c9cee6df4a2$var$join([
                'union',
                name,
                $e6602c9cee6df4a2$var$join(directives, ' '),
                $e6602c9cee6df4a2$var$wrap('= ', $e6602c9cee6df4a2$var$join(types, ' | '))
            ], ' ')
    },
    EnumTypeDefinition: {
        leave: ({ description: description, name: name, directives: directives, values: values })=>$e6602c9cee6df4a2$var$wrap('', description, '\n') + $e6602c9cee6df4a2$var$join([
                'enum',
                name,
                $e6602c9cee6df4a2$var$join(directives, ' '),
                $e6602c9cee6df4a2$var$block(values)
            ], ' ')
    },
    EnumValueDefinition: {
        leave: ({ description: description, name: name, directives: directives })=>$e6602c9cee6df4a2$var$wrap('', description, '\n') + $e6602c9cee6df4a2$var$join([
                name,
                $e6602c9cee6df4a2$var$join(directives, ' ')
            ], ' ')
    },
    InputObjectTypeDefinition: {
        leave: ({ description: description, name: name, directives: directives, fields: fields })=>$e6602c9cee6df4a2$var$wrap('', description, '\n') + $e6602c9cee6df4a2$var$join([
                'input',
                name,
                $e6602c9cee6df4a2$var$join(directives, ' '),
                $e6602c9cee6df4a2$var$block(fields)
            ], ' ')
    },
    DirectiveDefinition: {
        leave: ({ description: description, name: name, arguments: args, repeatable: repeatable, locations: locations })=>$e6602c9cee6df4a2$var$wrap('', description, '\n') + 'directive @' + name + ($e6602c9cee6df4a2$var$hasMultilineItems(args) ? $e6602c9cee6df4a2$var$wrap('(\n', $e6602c9cee6df4a2$var$indent($e6602c9cee6df4a2$var$join(args, '\n')), '\n)') : $e6602c9cee6df4a2$var$wrap('(', $e6602c9cee6df4a2$var$join(args, ', '), ')')) + (repeatable ? ' repeatable' : '') + ' on ' + $e6602c9cee6df4a2$var$join(locations, ' | ')
    },
    SchemaExtension: {
        leave: ({ directives: directives, operationTypes: operationTypes })=>$e6602c9cee6df4a2$var$join([
                'extend schema',
                $e6602c9cee6df4a2$var$join(directives, ' '),
                $e6602c9cee6df4a2$var$block(operationTypes)
            ], ' ')
    },
    ScalarTypeExtension: {
        leave: ({ name: name, directives: directives })=>$e6602c9cee6df4a2$var$join([
                'extend scalar',
                name,
                $e6602c9cee6df4a2$var$join(directives, ' ')
            ], ' ')
    },
    ObjectTypeExtension: {
        leave: ({ name: name, interfaces: interfaces, directives: directives, fields: fields })=>$e6602c9cee6df4a2$var$join([
                'extend type',
                name,
                $e6602c9cee6df4a2$var$wrap('implements ', $e6602c9cee6df4a2$var$join(interfaces, ' & ')),
                $e6602c9cee6df4a2$var$join(directives, ' '),
                $e6602c9cee6df4a2$var$block(fields)
            ], ' ')
    },
    InterfaceTypeExtension: {
        leave: ({ name: name, interfaces: interfaces, directives: directives, fields: fields })=>$e6602c9cee6df4a2$var$join([
                'extend interface',
                name,
                $e6602c9cee6df4a2$var$wrap('implements ', $e6602c9cee6df4a2$var$join(interfaces, ' & ')),
                $e6602c9cee6df4a2$var$join(directives, ' '),
                $e6602c9cee6df4a2$var$block(fields)
            ], ' ')
    },
    UnionTypeExtension: {
        leave: ({ name: name, directives: directives, types: types })=>$e6602c9cee6df4a2$var$join([
                'extend union',
                name,
                $e6602c9cee6df4a2$var$join(directives, ' '),
                $e6602c9cee6df4a2$var$wrap('= ', $e6602c9cee6df4a2$var$join(types, ' | '))
            ], ' ')
    },
    EnumTypeExtension: {
        leave: ({ name: name, directives: directives, values: values })=>$e6602c9cee6df4a2$var$join([
                'extend enum',
                name,
                $e6602c9cee6df4a2$var$join(directives, ' '),
                $e6602c9cee6df4a2$var$block(values)
            ], ' ')
    },
    InputObjectTypeExtension: {
        leave: ({ name: name, directives: directives, fields: fields })=>$e6602c9cee6df4a2$var$join([
                'extend input',
                name,
                $e6602c9cee6df4a2$var$join(directives, ' '),
                $e6602c9cee6df4a2$var$block(fields)
            ], ' ')
    }
};
/**
 * Given maybeArray, print an empty string if it is null or empty, otherwise
 * print all items together separated by separator if provided
 */ function $e6602c9cee6df4a2$var$join(maybeArray, separator = '') {
    var _maybeArray$filter$jo;
    return (_maybeArray$filter$jo = maybeArray === null || maybeArray === void 0 ? void 0 : maybeArray.filter((x)=>x).join(separator)) !== null && _maybeArray$filter$jo !== void 0 ? _maybeArray$filter$jo : '';
}
/**
 * Given array, print each item on its own line, wrapped in an indented `{ }` block.
 */ function $e6602c9cee6df4a2$var$block(array) {
    return $e6602c9cee6df4a2$var$wrap('{\n', $e6602c9cee6df4a2$var$indent($e6602c9cee6df4a2$var$join(array, '\n')), '\n}');
}
/**
 * If maybeString is not null or empty, then wrap with start and end, otherwise print an empty string.
 */ function $e6602c9cee6df4a2$var$wrap(start, maybeString, end = '') {
    return maybeString != null && maybeString !== '' ? start + maybeString + end : '';
}
function $e6602c9cee6df4a2$var$indent(str) {
    return $e6602c9cee6df4a2$var$wrap('  ', str.replace(/\n/g, '\n  '));
}
function $e6602c9cee6df4a2$var$hasMultilineItems(maybeArray) {
    var _maybeArray$some;
    // FIXME: https://github.com/graphql/graphql-js/issues/2203
    /* c8 ignore next */ return (_maybeArray$some = maybeArray === null || maybeArray === void 0 ? void 0 : maybeArray.some((str)=>str.includes('\n'))) !== null && _maybeArray$some !== void 0 ? _maybeArray$some : false;
}




var $722312be2835bfdf$var$printCache;
var $722312be2835bfdf$export$c2d084dc44961371 = Object.assign(function(ast) {
    var result = $722312be2835bfdf$var$printCache.get(ast);
    if (!result) {
        result = (0, $e6602c9cee6df4a2$export$c2d084dc44961371)(ast);
        $722312be2835bfdf$var$printCache.set(ast, result);
    }
    return result;
}, {
    reset: function() {
        $722312be2835bfdf$var$printCache = new (0, $b3ac5bdec858bda0$export$8dbad6f439bb2331)((0, $c506be9be1a65610$export$f29926b23b28936b).print || 2000 /* defaultCacheSizes.print */ );
    }
});
$722312be2835bfdf$export$c2d084dc44961371.reset();
if (globalThis.__DEV__ !== false) (0, $1da01699264b6e1e$export$a8fcd406d9e37621)("print", function() {
    return $722312be2835bfdf$var$printCache ? $722312be2835bfdf$var$printCache.size : 0;
});


var $9778f37d6aa7b324$var$defaultHttpOptions = {
    includeQuery: true,
    includeExtensions: false,
    preserveHeaderCase: false
};
var $9778f37d6aa7b324$var$defaultHeaders = {
    // headers are case insensitive (https://stackoverflow.com/a/5259004)
    accept: "*/*",
    // The content-type header describes the type of the body of the request, and
    // so it typically only is sent with requests that actually have bodies. One
    // could imagine that Apollo Client would remove this header when constructing
    // a GET request (which has no body), but we historically have not done that.
    // This means that browsers will preflight all Apollo Client requests (even
    // GET requests). Apollo Server's CSRF prevention feature (introduced in
    // AS3.7) takes advantage of this fact and does not block requests with this
    // header. If you want to drop this header from GET requests, then you should
    // probably replace it with a `apollo-require-preflight` header, or servers
    // with CSRF prevention enabled might block your GET request. See
    // https://www.apollographql.com/docs/apollo-server/security/cors/#preventing-cross-site-request-forgery-csrf
    // for more details.
    "content-type": "application/json"
};
var $9778f37d6aa7b324$var$defaultOptions = {
    method: "POST"
};
var $9778f37d6aa7b324$export$dd86f00dc866e75d = {
    http: $9778f37d6aa7b324$var$defaultHttpOptions,
    headers: $9778f37d6aa7b324$var$defaultHeaders,
    options: $9778f37d6aa7b324$var$defaultOptions
};
var $9778f37d6aa7b324$export$e88934976ca4fd65 = function(ast, printer) {
    return printer(ast);
};
function $9778f37d6aa7b324$export$a00ebfd5f1eebfb1(operation, fallbackConfig) {
    var configs = [];
    for(var _i = 2; _i < arguments.length; _i++)configs[_i - 2] = arguments[_i];
    configs.unshift(fallbackConfig);
    return $9778f37d6aa7b324$export$12d90ccf75844275.apply(void 0, (0, $5c96a02c592fcff1$export$1216008129fb82ed)([
        operation,
        $9778f37d6aa7b324$export$e88934976ca4fd65
    ], configs, false));
}
function $9778f37d6aa7b324$export$12d90ccf75844275(operation, printer) {
    var configs = [];
    for(var _i = 2; _i < arguments.length; _i++)configs[_i - 2] = arguments[_i];
    var options = {};
    var http = {};
    configs.forEach(function(config) {
        options = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, options), config.options), {
            headers: (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, options.headers), config.headers)
        });
        if (config.credentials) options.credentials = config.credentials;
        http = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, http), config.http);
    });
    if (options.headers) options.headers = $9778f37d6aa7b324$var$removeDuplicateHeaders(options.headers, http.preserveHeaderCase);
    //The body depends on the http options
    var operationName = operation.operationName, extensions = operation.extensions, variables = operation.variables, query = operation.query;
    var body = {
        operationName: operationName,
        variables: variables
    };
    if (http.includeExtensions) body.extensions = extensions;
    // not sending the query (i.e persisted queries)
    if (http.includeQuery) body.query = printer(query, (0, $722312be2835bfdf$export$c2d084dc44961371));
    return {
        options: options,
        body: body
    };
}
// Remove potential duplicate header names, preserving last (by insertion order).
// This is done to prevent unintentionally duplicating a header instead of
// overwriting it (See #8447 and #8449).
function $9778f37d6aa7b324$var$removeDuplicateHeaders(headers, preserveHeaderCase) {
    // If we're not preserving the case, just remove duplicates w/ normalization.
    if (!preserveHeaderCase) {
        var normalizedHeaders_1 = {};
        Object.keys(Object(headers)).forEach(function(name) {
            normalizedHeaders_1[name.toLowerCase()] = headers[name];
        });
        return normalizedHeaders_1;
    }
    // If we are preserving the case, remove duplicates w/ normalization,
    // preserving the original name.
    // This allows for non-http-spec-compliant servers that expect intentionally
    // capitalized header names (See #6741).
    var headerData = {};
    Object.keys(Object(headers)).forEach(function(name) {
        headerData[name.toLowerCase()] = {
            originalName: name,
            value: headers[name]
        };
    });
    var normalizedHeaders = {};
    Object.keys(headerData).forEach(function(name) {
        normalizedHeaders[headerData[name].originalName] = headerData[name].value;
    });
    return normalizedHeaders;
}



function $d07bf4cf2912bc0e$export$fb82bb094b6f76b5(chosenURI, body) {
    // Implement the standard HTTP GET serialization, plus 'extensions'. Note
    // the extra level of JSON serialization!
    var queryParams = [];
    var addQueryParam = function(key, value) {
        queryParams.push("".concat(key, "=").concat(encodeURIComponent(value)));
    };
    if ("query" in body) addQueryParam("query", body.query);
    if (body.operationName) addQueryParam("operationName", body.operationName);
    if (body.variables) {
        var serializedVariables = void 0;
        try {
            serializedVariables = (0, $c32b8dc3cfa701c7$export$5f8e80ac52052e28)(body.variables, "Variables map");
        } catch (parseError) {
            return {
                parseError: parseError
            };
        }
        addQueryParam("variables", serializedVariables);
    }
    if (body.extensions) {
        var serializedExtensions = void 0;
        try {
            serializedExtensions = (0, $c32b8dc3cfa701c7$export$5f8e80ac52052e28)(body.extensions, "Extensions map");
        } catch (parseError) {
            return {
                parseError: parseError
            };
        }
        addQueryParam("extensions", serializedExtensions);
    }
    // Reconstruct the URI with added query params.
    // XXX This assumes that the URI is well-formed and that it doesn't
    //     already contain any of these query params. We could instead use the
    //     URL API and take a polyfill (whatwg-url@6) for older browsers that
    //     don't support URLSearchParams. Note that some browsers (and
    //     versions of whatwg-url) support URL but not URLSearchParams!
    var fragment = "", preFragment = chosenURI;
    var fragmentStart = chosenURI.indexOf("#");
    if (fragmentStart !== -1) {
        fragment = chosenURI.substr(fragmentStart);
        preFragment = chosenURI.substr(0, fragmentStart);
    }
    var queryParamsPrefix = preFragment.indexOf("?") === -1 ? "?" : "&";
    var newURI = preFragment + queryParamsPrefix + queryParams.join("&") + fragment;
    return {
        newURI: newURI
    };
}




function $c8ea6bc4a603e6d1$export$de246493ae27fe3f(variables, query) {
    var result = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, variables);
    var unusedNames = new Set(Object.keys(variables));
    (0, $78b48476e314521e$export$bf638b60ea8b89b7)(query, {
        Variable: function(node, _key, parent) {
            // A variable type definition at the top level of a query is not
            // enough to silence server-side errors about the variable being
            // unused, so variable definitions do not count as usage.
            // https://spec.graphql.org/draft/#sec-All-Variables-Used
            if (parent && parent.kind !== "VariableDefinition") unusedNames.delete(node.name.value);
        }
    });
    unusedNames.forEach(function(name) {
        delete result[name];
    });
    return result;
}


function $045bb098515a5bfc$export$4fd972edbe7450d3(errorValue) {
    return new (0, $6d99a9de69717ea6$export$77cea355fa80b5f4)(function(observer) {
        observer.error(errorValue);
    });
}


var $0c8dd0eb947866f7$var$backupFetch = (0, $3ac3e23fcbe2d68c$export$f8b8b9ce72e9ccbf)(function() {
    return fetch;
});
var $0c8dd0eb947866f7$export$95180a16573d6675 = function(linkOptions) {
    if (linkOptions === void 0) linkOptions = {};
    var _a = linkOptions.uri, uri = _a === void 0 ? "/graphql" : _a, // use default global fetch if nothing passed in
    preferredFetch = linkOptions.fetch, _b = linkOptions.print, print = _b === void 0 ? (0, $9778f37d6aa7b324$export$e88934976ca4fd65) : _b, includeExtensions = linkOptions.includeExtensions, preserveHeaderCase = linkOptions.preserveHeaderCase, useGETForQueries = linkOptions.useGETForQueries, _c = linkOptions.includeUnusedVariables, includeUnusedVariables = _c === void 0 ? false : _c, requestOptions = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(linkOptions, [
        "uri",
        "fetch",
        "print",
        "includeExtensions",
        "preserveHeaderCase",
        "useGETForQueries",
        "includeUnusedVariables"
    ]);
    if (globalThis.__DEV__ !== false) // Make sure at least one of preferredFetch, window.fetch, or backupFetch is
    // defined, so requests won't fail at runtime.
    (0, $fc846bb2ae15ec15$export$8423f0cd3773115e)(preferredFetch || $0c8dd0eb947866f7$var$backupFetch);
    var linkConfig = {
        http: {
            includeExtensions: includeExtensions,
            preserveHeaderCase: preserveHeaderCase
        },
        options: requestOptions.fetchOptions,
        credentials: requestOptions.credentials,
        headers: requestOptions.headers
    };
    return new (0, $60c07ffd02e3617d$export$2fed3d61f740bc7f)(function(operation) {
        var chosenURI = (0, $5a02450356081318$export$63ccc2571850f81a)(operation, uri);
        var context = operation.getContext();
        // `apollographql-client-*` headers are automatically set if a
        // `clientAwareness` object is found in the context. These headers are
        // set first, followed by the rest of the headers pulled from
        // `context.headers`. If desired, `apollographql-client-*` headers set by
        // the `clientAwareness` object can be overridden by
        // `apollographql-client-*` headers set in `context.headers`.
        var clientAwarenessHeaders = {};
        if (context.clientAwareness) {
            var _a = context.clientAwareness, name_1 = _a.name, version = _a.version;
            if (name_1) clientAwarenessHeaders["apollographql-client-name"] = name_1;
            if (version) clientAwarenessHeaders["apollographql-client-version"] = version;
        }
        var contextHeaders = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, clientAwarenessHeaders), context.headers);
        var contextConfig = {
            http: context.http,
            options: context.fetchOptions,
            credentials: context.credentials,
            headers: contextHeaders
        };
        if ((0, $89c1eec09879e1ca$export$2dafb573e282fe8d)([
            "client"
        ], operation.query)) {
            var transformedQuery = (0, $202b8a19e6086c64$export$8eae69e876ee321e)(operation.query);
            if (!transformedQuery) return (0, $045bb098515a5bfc$export$4fd972edbe7450d3)(new Error("HttpLink: Trying to send a client-only query to the server. To send to the server, ensure a non-client field is added to the query or set the `transformOptions.removeClientFields` option to `true`."));
            operation.query = transformedQuery;
        }
        //uses fallback, link, and then context to build options
        var _b = (0, $9778f37d6aa7b324$export$12d90ccf75844275)(operation, print, (0, $9778f37d6aa7b324$export$dd86f00dc866e75d), linkConfig, contextConfig), options = _b.options, body = _b.body;
        if (body.variables && !includeUnusedVariables) body.variables = (0, $c8ea6bc4a603e6d1$export$de246493ae27fe3f)(body.variables, operation.query);
        var controller;
        if (!options.signal && typeof AbortController !== "undefined") {
            controller = new AbortController();
            options.signal = controller.signal;
        }
        // If requested, set method to GET if there are no mutations.
        var definitionIsMutation = function(d) {
            return d.kind === "OperationDefinition" && d.operation === "mutation";
        };
        var definitionIsSubscription = function(d) {
            return d.kind === "OperationDefinition" && d.operation === "subscription";
        };
        var isSubscription = definitionIsSubscription((0, $818d93327cb72c29$export$f431198736b7f96d)(operation.query));
        // does not match custom directives beginning with @defer
        var hasDefer = (0, $89c1eec09879e1ca$export$2dafb573e282fe8d)([
            "defer"
        ], operation.query);
        if (useGETForQueries && !operation.query.definitions.some(definitionIsMutation)) options.method = "GET";
        if (hasDefer || isSubscription) {
            options.headers = options.headers || {};
            var acceptHeader = "multipart/mixed;";
            // Omit defer-specific headers if the user attempts to defer a selection
            // set on a subscription and log a warning.
            if (isSubscription && hasDefer) globalThis.__DEV__ !== false && (0, $28d90d877eb1e517$export$f5708dca728d7177).warn(39);
            if (isSubscription) acceptHeader += "boundary=graphql;subscriptionSpec=1.0,application/json";
            else if (hasDefer) acceptHeader += "deferSpec=20220824,application/json";
            options.headers.accept = acceptHeader;
        }
        if (options.method === "GET") {
            var _c = (0, $d07bf4cf2912bc0e$export$fb82bb094b6f76b5)(chosenURI, body), newURI = _c.newURI, parseError = _c.parseError;
            if (parseError) return (0, $045bb098515a5bfc$export$4fd972edbe7450d3)(parseError);
            chosenURI = newURI;
        } else try {
            options.body = (0, $c32b8dc3cfa701c7$export$5f8e80ac52052e28)(body, "Payload");
        } catch (parseError) {
            return (0, $045bb098515a5bfc$export$4fd972edbe7450d3)(parseError);
        }
        return new (0, $6d99a9de69717ea6$export$77cea355fa80b5f4)(function(observer) {
            // Prefer linkOptions.fetch (preferredFetch) if provided, and otherwise
            // fall back to the *current* global window.fetch function (see issue
            // #7832), or (if all else fails) the backupFetch function we saved when
            // this module was first evaluated. This last option protects against the
            // removal of window.fetch, which is unlikely but not impossible.
            var currentFetch = preferredFetch || (0, $3ac3e23fcbe2d68c$export$f8b8b9ce72e9ccbf)(function() {
                return fetch;
            }) || $0c8dd0eb947866f7$var$backupFetch;
            var observerNext = observer.next.bind(observer);
            currentFetch(chosenURI, options).then(function(response) {
                var _a;
                operation.setContext({
                    response: response
                });
                var ctype = (_a = response.headers) === null || _a === void 0 ? void 0 : _a.get("content-type");
                if (ctype !== null && /^multipart\/mixed/i.test(ctype)) return (0, $6ba89ebc2766b493$export$ccb60864026baf09)(response, observerNext);
                else return (0, $6ba89ebc2766b493$export$d4051215bea0639f)(operation)(response).then(observerNext);
            }).then(function() {
                controller = undefined;
                observer.complete();
            }).catch(function(err) {
                controller = undefined;
                (0, $6ba89ebc2766b493$export$d3da1ecaf1206c58)(err, observer);
            });
            return function() {
                // XXX support canceling this request
                // https://developers.google.com/web/updates/2017/09/abortable-fetch
                if (controller) controller.abort();
            };
        });
    });
};


var $4c2d109245a5920b$export$f4bbf1aec241cc1 = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(HttpLink, _super);
    function HttpLink(options) {
        if (options === void 0) options = {};
        var _this = _super.call(this, (0, $0c8dd0eb947866f7$export$95180a16573d6675)(options).request) || this;
        _this.options = options;
        return _this;
    }
    return HttpLink;
}((0, $60c07ffd02e3617d$export$2fed3d61f740bc7f));




const { toString: $a2b6f433e732b502$var$toString, hasOwnProperty: $a2b6f433e732b502$var$hasOwnProperty } = Object.prototype;
const $a2b6f433e732b502$var$fnToStr = Function.prototype.toString;
const $a2b6f433e732b502$var$previousComparisons = new Map();
function $a2b6f433e732b502$export$411ce8e5a71e3069(a, b) {
    try {
        return $a2b6f433e732b502$var$check(a, b);
    } finally{
        $a2b6f433e732b502$var$previousComparisons.clear();
    }
}
var // Allow default imports as well.
$a2b6f433e732b502$export$2e2bcd8739ae039 = $a2b6f433e732b502$export$411ce8e5a71e3069;
function $a2b6f433e732b502$var$check(a, b) {
    // If the two values are strictly equal, our job is easy.
    if (a === b) return true;
    // Object.prototype.toString returns a representation of the runtime type of
    // the given value that is considerably more precise than typeof.
    const aTag = $a2b6f433e732b502$var$toString.call(a);
    const bTag = $a2b6f433e732b502$var$toString.call(b);
    // If the runtime types of a and b are different, they could maybe be equal
    // under some interpretation of equality, but for simplicity and performance
    // we just return false instead.
    if (aTag !== bTag) return false;
    switch(aTag){
        case '[object Array]':
            // Arrays are a lot like other objects, but we can cheaply compare their
            // lengths as a short-cut before comparing their elements.
            if (a.length !== b.length) return false;
        // Fall through to object case...
        case '[object Object]':
            {
                if ($a2b6f433e732b502$var$previouslyCompared(a, b)) return true;
                const aKeys = $a2b6f433e732b502$var$definedKeys(a);
                const bKeys = $a2b6f433e732b502$var$definedKeys(b);
                // If `a` and `b` have a different number of enumerable keys, they
                // must be different.
                const keyCount = aKeys.length;
                if (keyCount !== bKeys.length) return false;
                // Now make sure they have the same keys.
                for(let k = 0; k < keyCount; ++k){
                    if (!$a2b6f433e732b502$var$hasOwnProperty.call(b, aKeys[k])) return false;
                }
                // Finally, check deep equality of all child properties.
                for(let k = 0; k < keyCount; ++k){
                    const key = aKeys[k];
                    if (!$a2b6f433e732b502$var$check(a[key], b[key])) return false;
                }
                return true;
            }
        case '[object Error]':
            return a.name === b.name && a.message === b.message;
        case '[object Number]':
            // Handle NaN, which is !== itself.
            if (a !== a) return b !== b;
        // Fall through to shared +a === +b case...
        case '[object Boolean]':
        case '[object Date]':
            return +a === +b;
        case '[object RegExp]':
        case '[object String]':
            return a == `${b}`;
        case '[object Map]':
        case '[object Set]':
            {
                if (a.size !== b.size) return false;
                if ($a2b6f433e732b502$var$previouslyCompared(a, b)) return true;
                const aIterator = a.entries();
                const isMap = aTag === '[object Map]';
                while(true){
                    const info = aIterator.next();
                    if (info.done) break;
                    // If a instanceof Set, aValue === aKey.
                    const [aKey, aValue] = info.value;
                    // So this works the same way for both Set and Map.
                    if (!b.has(aKey)) return false;
                    // However, we care about deep equality of values only when dealing
                    // with Map structures.
                    if (isMap && !$a2b6f433e732b502$var$check(aValue, b.get(aKey))) return false;
                }
                return true;
            }
        case '[object Uint16Array]':
        case '[object Uint8Array]':
        case '[object Uint32Array]':
        case '[object Int32Array]':
        case '[object Int8Array]':
        case '[object Int16Array]':
        case '[object ArrayBuffer]':
            // DataView doesn't need these conversions, but the equality check is
            // otherwise the same.
            a = new Uint8Array(a);
            b = new Uint8Array(b);
        // Fall through...
        case '[object DataView]':
            {
                let len = a.byteLength;
                if (len === b.byteLength) {
                    while(len-- && a[len] === b[len]);
                }
                return len === -1;
            }
        case '[object AsyncFunction]':
        case '[object GeneratorFunction]':
        case '[object AsyncGeneratorFunction]':
        case '[object Function]':
            {
                const aCode = $a2b6f433e732b502$var$fnToStr.call(a);
                if (aCode !== $a2b6f433e732b502$var$fnToStr.call(b)) return false;
                // We consider non-native functions equal if they have the same code
                // (native functions require === because their code is censored).
                // Note that this behavior is not entirely sound, since !== function
                // objects with the same code can behave differently depending on
                // their closure scope. However, any function can behave differently
                // depending on the values of its input arguments (including this)
                // and its calling context (including its closure scope), even
                // though the function object is === to itself; and it is entirely
                // possible for functions that are not === to behave exactly the
                // same under all conceivable circumstances. Because none of these
                // factors are statically decidable in JavaScript, JS function
                // equality is not well-defined. This ambiguity allows us to
                // consider the best possible heuristic among various imperfect
                // options, and equating non-native functions that have the same
                // code has enormous practical benefits, such as when comparing
                // functions that are repeatedly passed as fresh function
                // expressions within objects that are otherwise deeply equal. Since
                // any function created from the same syntactic expression (in the
                // same code location) will always stringify to the same code
                // according to fnToStr.call, we can reasonably expect these
                // repeatedly passed function expressions to have the same code, and
                // thus behave "the same" (with all the caveats mentioned above),
                // even though the runtime function objects are !== to one another.
                return !$a2b6f433e732b502$var$endsWith(aCode, $a2b6f433e732b502$var$nativeCodeSuffix);
            }
    }
    // Otherwise the values are not equal.
    return false;
}
function $a2b6f433e732b502$var$definedKeys(obj) {
    // Remember that the second argument to Array.prototype.filter will be
    // used as `this` within the callback function.
    return Object.keys(obj).filter($a2b6f433e732b502$var$isDefinedKey, obj);
}
function $a2b6f433e732b502$var$isDefinedKey(key) {
    return this[key] !== void 0;
}
const $a2b6f433e732b502$var$nativeCodeSuffix = "{ [native code] }";
function $a2b6f433e732b502$var$endsWith(full, suffix) {
    const fromIndex = full.length - suffix.length;
    return fromIndex >= 0 && full.indexOf(suffix, fromIndex) === fromIndex;
}
function $a2b6f433e732b502$var$previouslyCompared(a, b) {
    // Though cyclic references can make an object graph appear infinite from the
    // perspective of a depth-first traversal, the graph still contains a finite
    // number of distinct object references. We use the previousComparisons cache
    // to avoid comparing the same pair of object references more than once, which
    // guarantees termination (even if we end up comparing every object in one
    // graph to every object in the other graph, which is extremely unlikely),
    // while still allowing weird isomorphic structures (like rings with different
    // lengths) a chance to pass the equality test.
    let bSet = $a2b6f433e732b502$var$previousComparisons.get(a);
    if (bSet) {
        // Return true here because we can be sure false will be returned somewhere
        // else if the objects are not equivalent.
        if (bSet.has(b)) return true;
    } else $a2b6f433e732b502$var$previousComparisons.set(a, bSet = new Set);
    bSet.add(b);
    return false;
}




function $558b9f91eb7bf726$export$707ee4c4c95d39e3(observable, mapFn, catchFn) {
    return new (0, $6d99a9de69717ea6$export$77cea355fa80b5f4)(function(observer) {
        var promiseQueue = {
            // Normally we would initialize promiseQueue to Promise.resolve(), but
            // in this case, for backwards compatibility, we need to be careful to
            // invoke the first callback synchronously.
            then: function(callback) {
                return new Promise(function(resolve) {
                    return resolve(callback());
                });
            }
        };
        function makeCallback(examiner, key) {
            return function(arg) {
                if (examiner) {
                    var both = function() {
                        // If the observer is closed, we don't want to continue calling the
                        // mapping function - it's result will be swallowed anyways.
                        return observer.closed ? /* will be swallowed */ 0 : examiner(arg);
                    };
                    promiseQueue = promiseQueue.then(both, both).then(function(result) {
                        return observer.next(result);
                    }, function(error) {
                        return observer.error(error);
                    });
                } else observer[key](arg);
            };
        }
        var handler = {
            next: makeCallback(mapFn, "next"),
            error: makeCallback(catchFn, "error"),
            complete: function() {
                // no need to reassign `promiseQueue`, after `observer.complete`,
                // the observer will be closed and short-circuit everything anyways
                /*promiseQueue = */ promiseQueue.then(function() {
                    return observer.complete();
                });
            }
        };
        var sub = observable.subscribe(handler);
        return function() {
            return sub.unsubscribe();
        };
    });
}



function $de072e4be1d4d57a$export$9f6c99ae166dbeca(observers, method, argument) {
    // In case observers is modified during iteration, we need to commit to the
    // original elements, which also provides an opportunity to filter them down
    // to just the observers with the given method.
    var observersWithMethod = [];
    observers.forEach(function(obs) {
        return obs[method] && observersWithMethod.push(obs);
    });
    observersWithMethod.forEach(function(obs) {
        return obs[method](argument);
    });
}




function $af26a5afbde47a9e$export$33c8bd820eece9b2(subclass) {
    function set(key) {
        // Object.defineProperty is necessary because the Symbol.species
        // property is a getter by default in modern JS environments, so we
        // can't assign to it with a normal assignment expression.
        Object.defineProperty(subclass, key, {
            value: (0, $6d99a9de69717ea6$export$77cea355fa80b5f4)
        });
    }
    if ((0, $5d0a073f980bb2a3$export$23ba675b4b838b92) && Symbol.species) set(Symbol.species);
    // The "@@species" string is used as a fake Symbol.species value in some
    // polyfill systems (including the SymbolSpecies variable used by
    // zen-observable), so we should set it as well, to be safe.
    set("@@species");
    return subclass;
}


function $5bb23690c12ed9a4$var$isPromiseLike(value) {
    return value && typeof value.then === "function";
}
// A Concast<T> observable concatenates the given sources into a single
// non-overlapping sequence of Ts, automatically unwrapping any promises,
// and broadcasts the T elements of that sequence to any number of
// subscribers, all without creating a bunch of intermediary Observable
// wrapper objects.
//
// Even though any number of observers can subscribe to the Concast, each
// source observable is guaranteed to receive at most one subscribe call,
// and the results are multicast to all observers.
//
// In addition to broadcasting every next/error message to this.observers,
// the Concast stores the most recent message using this.latest, so any
// new observers can immediately receive the latest message, even if it
// was originally delivered in the past. This behavior means we can assume
// every active observer in this.observers has received the same most
// recent message.
//
// With the exception of this.latest replay, a Concast is a "hot"
// observable in the sense that it does not replay past results from the
// beginning of time for each new observer.
//
// Could we have used some existing RxJS class instead? Concast<T> is
// similar to a BehaviorSubject<T>, because it is multicast and redelivers
// the latest next/error message to new subscribers. Unlike Subject<T>,
// Concast<T> does not expose an Observer<T> interface (this.handlers is
// intentionally private), since Concast<T> gets its inputs from the
// concatenated sources. If we ever switch to RxJS, there may be some
// value in reusing their code, but for now we use zen-observable, which
// does not contain any Subject implementations.
var $5bb23690c12ed9a4$export$ae0cf2ec7a6fa78e = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(Concast, _super);
    // Not only can the individual elements of the iterable be promises, but
    // also the iterable itself can be wrapped in a promise.
    function Concast(sources) {
        var _this = _super.call(this, function(observer) {
            _this.addObserver(observer);
            return function() {
                return _this.removeObserver(observer);
            };
        }) || this;
        // Active observers receiving broadcast messages. Thanks to this.latest,
        // we can assume all observers in this Set have received the same most
        // recent message, though possibly at different times in the past.
        _this.observers = new Set();
        _this.promise = new Promise(function(resolve, reject) {
            _this.resolve = resolve;
            _this.reject = reject;
        });
        // Bound handler functions that can be reused for every internal
        // subscription.
        _this.handlers = {
            next: function(result) {
                if (_this.sub !== null) {
                    _this.latest = [
                        "next",
                        result
                    ];
                    _this.notify("next", result);
                    (0, $de072e4be1d4d57a$export$9f6c99ae166dbeca)(_this.observers, "next", result);
                }
            },
            error: function(error) {
                var sub = _this.sub;
                if (sub !== null) {
                    // Delay unsubscribing from the underlying subscription slightly,
                    // so that immediately subscribing another observer can keep the
                    // subscription active.
                    if (sub) setTimeout(function() {
                        return sub.unsubscribe();
                    });
                    _this.sub = null;
                    _this.latest = [
                        "error",
                        error
                    ];
                    _this.reject(error);
                    _this.notify("error", error);
                    (0, $de072e4be1d4d57a$export$9f6c99ae166dbeca)(_this.observers, "error", error);
                }
            },
            complete: function() {
                var _a = _this, sub = _a.sub, _b = _a.sources, sources = _b === void 0 ? [] : _b;
                if (sub !== null) {
                    // If complete is called before concast.start, this.sources may be
                    // undefined, so we use a default value of [] for sources. That works
                    // here because it falls into the if (!value) {...} block, which
                    // appropriately terminates the Concast, even if this.sources might
                    // eventually have been initialized to a non-empty array.
                    var value = sources.shift();
                    if (!value) {
                        if (sub) setTimeout(function() {
                            return sub.unsubscribe();
                        });
                        _this.sub = null;
                        if (_this.latest && _this.latest[0] === "next") _this.resolve(_this.latest[1]);
                        else _this.resolve();
                        _this.notify("complete");
                        // We do not store this.latest = ["complete"], because doing so
                        // discards useful information about the previous next (or
                        // error) message. Instead, if new observers subscribe after
                        // this Concast has completed, they will receive the final
                        // 'next' message (unless there was an error) immediately
                        // followed by a 'complete' message (see addObserver).
                        (0, $de072e4be1d4d57a$export$9f6c99ae166dbeca)(_this.observers, "complete");
                    } else if ($5bb23690c12ed9a4$var$isPromiseLike(value)) value.then(function(obs) {
                        return _this.sub = obs.subscribe(_this.handlers);
                    }, _this.handlers.error);
                    else _this.sub = value.subscribe(_this.handlers);
                }
            }
        };
        _this.nextResultListeners = new Set();
        // A public way to abort observation and broadcast.
        _this.cancel = function(reason) {
            _this.reject(reason);
            _this.sources = [];
            _this.handlers.error(reason);
        };
        // Suppress rejection warnings for this.promise, since it's perfectly
        // acceptable to pay no attention to this.promise if you're consuming
        // the results through the normal observable API.
        _this.promise.catch(function(_) {});
        // If someone accidentally tries to create a Concast using a subscriber
        // function, recover by creating an Observable from that subscriber and
        // using it as the source.
        if (typeof sources === "function") sources = [
            new (0, $6d99a9de69717ea6$export$77cea355fa80b5f4)(sources)
        ];
        if ($5bb23690c12ed9a4$var$isPromiseLike(sources)) sources.then(function(iterable) {
            return _this.start(iterable);
        }, _this.handlers.error);
        else _this.start(sources);
        return _this;
    }
    Concast.prototype.start = function(sources) {
        if (this.sub !== void 0) return;
        // In practice, sources is most often simply an Array of observables.
        // TODO Consider using sources[Symbol.iterator]() to take advantage
        // of the laziness of non-Array iterables.
        this.sources = Array.from(sources);
        // Calling this.handlers.complete() kicks off consumption of the first
        // source observable. It's tempting to do this step lazily in
        // addObserver, but this.promise can be accessed without calling
        // addObserver, so consumption needs to begin eagerly.
        this.handlers.complete();
    };
    Concast.prototype.deliverLastMessage = function(observer) {
        if (this.latest) {
            var nextOrError = this.latest[0];
            var method = observer[nextOrError];
            if (method) method.call(observer, this.latest[1]);
            // If the subscription is already closed, and the last message was
            // a 'next' message, simulate delivery of the final 'complete'
            // message again.
            if (this.sub === null && nextOrError === "next" && observer.complete) observer.complete();
        }
    };
    Concast.prototype.addObserver = function(observer) {
        if (!this.observers.has(observer)) {
            // Immediately deliver the most recent message, so we can always
            // be sure all observers have the latest information.
            this.deliverLastMessage(observer);
            this.observers.add(observer);
        }
    };
    Concast.prototype.removeObserver = function(observer) {
        if (this.observers.delete(observer) && this.observers.size < 1) // In case there are still any listeners in this.nextResultListeners, and
        // no error or completion has been broadcast yet, make sure those
        // observers have a chance to run and then remove themselves from
        // this.observers.
        this.handlers.complete();
    };
    Concast.prototype.notify = function(method, arg) {
        var nextResultListeners = this.nextResultListeners;
        if (nextResultListeners.size) {
            // Replacing this.nextResultListeners first ensures it does not grow while
            // we are iterating over it, potentially leading to infinite loops.
            this.nextResultListeners = new Set();
            nextResultListeners.forEach(function(listener) {
                return listener(method, arg);
            });
        }
    };
    // We need a way to run callbacks just *before* the next result (or error or
    // completion) is delivered by this Concast, so we can be sure any code that
    // runs as a result of delivering that result/error observes the effects of
    // running the callback(s). It was tempting to reuse the Observer type instead
    // of introducing NextResultListener, but that messes with the sizing and
    // maintenance of this.observers, and ends up being more code overall.
    Concast.prototype.beforeNext = function(callback) {
        var called = false;
        this.nextResultListeners.add(function(method, arg) {
            if (!called) {
                called = true;
                callback(method, arg);
            }
        });
    };
    return Concast;
}((0, $6d99a9de69717ea6$export$77cea355fa80b5f4));
// Necessary because the Concast constructor has a different signature
// than the Observable constructor.
(0, $af26a5afbde47a9e$export$33c8bd820eece9b2)($5bb23690c12ed9a4$export$ae0cf2ec7a6fa78e);

// A [trie](https://en.wikipedia.org/wiki/Trie) data structure that holds
// object keys weakly, yet can also hold non-object keys, unlike the
// native `WeakMap`.
// If no makeData function is supplied, the looked-up data will be an empty,
// null-prototype Object.
const $02443dfd16cf74b4$var$defaultMakeData = ()=>Object.create(null);
// Useful for processing arguments objects as well as arrays.
const { forEach: $02443dfd16cf74b4$var$forEach, slice: $02443dfd16cf74b4$var$slice } = Array.prototype;
const { hasOwnProperty: $02443dfd16cf74b4$var$hasOwnProperty } = Object.prototype;
class $02443dfd16cf74b4$export$73571c50d0f2507e {
    constructor(weakness = true, makeData = $02443dfd16cf74b4$var$defaultMakeData){
        this.weakness = weakness;
        this.makeData = makeData;
    }
    lookup() {
        return this.lookupArray(arguments);
    }
    lookupArray(array) {
        let node = this;
        $02443dfd16cf74b4$var$forEach.call(array, (key)=>node = node.getChildTrie(key));
        return $02443dfd16cf74b4$var$hasOwnProperty.call(node, "data") ? node.data : node.data = this.makeData($02443dfd16cf74b4$var$slice.call(array));
    }
    peek() {
        return this.peekArray(arguments);
    }
    peekArray(array) {
        let node = this;
        for(let i = 0, len = array.length; node && i < len; ++i){
            const map = node.mapFor(array[i], false);
            node = map && map.get(array[i]);
        }
        return node && node.data;
    }
    remove() {
        return this.removeArray(arguments);
    }
    removeArray(array) {
        let data;
        if (array.length) {
            const head = array[0];
            const map = this.mapFor(head, false);
            const child = map && map.get(head);
            if (child) {
                data = child.removeArray($02443dfd16cf74b4$var$slice.call(array, 1));
                if (!child.data && !child.weak && !(child.strong && child.strong.size)) map.delete(head);
            }
        } else {
            data = this.data;
            delete this.data;
        }
        return data;
    }
    getChildTrie(key) {
        const map = this.mapFor(key, true);
        let child = map.get(key);
        if (!child) map.set(key, child = new $02443dfd16cf74b4$export$73571c50d0f2507e(this.weakness, this.makeData));
        return child;
    }
    mapFor(key, create) {
        return this.weakness && $02443dfd16cf74b4$var$isObjRef(key) ? this.weak || (create ? this.weak = new WeakMap : void 0) : this.strong || (create ? this.strong = new Map : void 0);
    }
}
function $02443dfd16cf74b4$var$isObjRef(value) {
    switch(typeof value){
        case "object":
            if (value === null) break;
        // Fall through to return true...
        case "function":
            return true;
    }
    return false;
}








// This currentContext variable will only be used if the makeSlotClass
// function is called, which happens only if this is the first copy of the
// @wry/context package to be imported.
let $1b7dab7b0d0a41be$var$currentContext = null;
// This unique internal object is used to denote the absence of a value
// for a given Slot, and is never exposed to outside code.
const $1b7dab7b0d0a41be$var$MISSING_VALUE = {};
let $1b7dab7b0d0a41be$var$idCounter = 1;
// Although we can't do anything about the cost of duplicated code from
// accidentally bundling multiple copies of the @wry/context package, we can
// avoid creating the Slot class more than once using makeSlotClass.
const $1b7dab7b0d0a41be$var$makeSlotClass = ()=>class Slot {
        constructor(){
            // If you have a Slot object, you can find out its slot.id, but you cannot
            // guess the slot.id of a Slot you don't have access to, thanks to the
            // randomized suffix.
            this.id = [
                "slot",
                $1b7dab7b0d0a41be$var$idCounter++,
                Date.now(),
                Math.random().toString(36).slice(2)
            ].join(":");
        }
        hasValue() {
            for(let context = $1b7dab7b0d0a41be$var$currentContext; context; context = context.parent)// We use the Slot object iself as a key to its value, which means the
            // value cannot be obtained without a reference to the Slot object.
            if (this.id in context.slots) {
                const value = context.slots[this.id];
                if (value === $1b7dab7b0d0a41be$var$MISSING_VALUE) break;
                if (context !== $1b7dab7b0d0a41be$var$currentContext) // Cache the value in currentContext.slots so the next lookup will
                // be faster. This caching is safe because the tree of contexts and
                // the values of the slots are logically immutable.
                $1b7dab7b0d0a41be$var$currentContext.slots[this.id] = value;
                return true;
            }
            if ($1b7dab7b0d0a41be$var$currentContext) // If a value was not found for this Slot, it's never going to be found
            // no matter how many times we look it up, so we might as well cache
            // the absence of the value, too.
            $1b7dab7b0d0a41be$var$currentContext.slots[this.id] = $1b7dab7b0d0a41be$var$MISSING_VALUE;
            return false;
        }
        getValue() {
            if (this.hasValue()) return $1b7dab7b0d0a41be$var$currentContext.slots[this.id];
        }
        withValue(value, callback, // Given the prevalence of arrow functions, specifying arguments is likely
        // to be much more common than specifying `this`, hence this ordering:
        args, thisArg) {
            const slots = {
                __proto__: null,
                [this.id]: value
            };
            const parent = $1b7dab7b0d0a41be$var$currentContext;
            $1b7dab7b0d0a41be$var$currentContext = {
                parent: parent,
                slots: slots
            };
            try {
                // Function.prototype.apply allows the arguments array argument to be
                // omitted or undefined, so args! is fine here.
                return callback.apply(thisArg, args);
            } finally{
                $1b7dab7b0d0a41be$var$currentContext = parent;
            }
        }
        // Capture the current context and wrap a callback function so that it
        // reestablishes the captured context when called.
        static bind(callback) {
            const context = $1b7dab7b0d0a41be$var$currentContext;
            return function() {
                const saved = $1b7dab7b0d0a41be$var$currentContext;
                try {
                    $1b7dab7b0d0a41be$var$currentContext = context;
                    return callback.apply(this, arguments);
                } finally{
                    $1b7dab7b0d0a41be$var$currentContext = saved;
                }
            };
        }
        // Immediately run a callback function without any captured context.
        static noContext(callback, // Given the prevalence of arrow functions, specifying arguments is likely
        // to be much more common than specifying `this`, hence this ordering:
        args, thisArg) {
            if ($1b7dab7b0d0a41be$var$currentContext) {
                const saved = $1b7dab7b0d0a41be$var$currentContext;
                try {
                    $1b7dab7b0d0a41be$var$currentContext = null;
                    // Function.prototype.apply allows the arguments array argument to be
                    // omitted or undefined, so args! is fine here.
                    return callback.apply(thisArg, args);
                } finally{
                    $1b7dab7b0d0a41be$var$currentContext = saved;
                }
            } else return callback.apply(thisArg, args);
        }
    };
function $1b7dab7b0d0a41be$var$maybe(fn) {
    try {
        return fn();
    } catch (ignored) {}
}
// We store a single global implementation of the Slot class as a permanent
// non-enumerable property of the globalThis object. This obfuscation does
// nothing to prevent access to the Slot class, but at least it ensures the
// implementation (i.e. currentContext) cannot be tampered with, and all copies
// of the @wry/context package (hopefully just one) will share the same Slot
// implementation. Since the first copy of the @wry/context package to be
// imported wins, this technique imposes a steep cost for any future breaking
// changes to the Slot class.
const $1b7dab7b0d0a41be$var$globalKey = "@wry/context:Slot";
const $1b7dab7b0d0a41be$var$host = // Prefer globalThis when available.
// https://github.com/benjamn/wryware/issues/347
$1b7dab7b0d0a41be$var$maybe(()=>globalThis) || // Fall back to global, which works in Node.js and may be converted by some
// bundlers to the appropriate identifier (window, self, ...) depending on the
// bundling target. https://github.com/endojs/endo/issues/576#issuecomment-1178515224
$1b7dab7b0d0a41be$var$maybe(()=>$parcel$global) || // Otherwise, use a dummy host that's local to this module. We used to fall
// back to using the Array constructor as a namespace, but that was flagged in
// https://github.com/benjamn/wryware/issues/347, and can be avoided.
Object.create(null);
// Whichever globalHost we're using, make TypeScript happy about the additional
// globalKey property.
const $1b7dab7b0d0a41be$var$globalHost = $1b7dab7b0d0a41be$var$host;
const $1b7dab7b0d0a41be$export$8c6ed5c666ac1360 = $1b7dab7b0d0a41be$var$globalHost[$1b7dab7b0d0a41be$var$globalKey] || // Earlier versions of this package stored the globalKey property on the Array
// constructor, so we check there as well, to prevent Slot class duplication.
Array[$1b7dab7b0d0a41be$var$globalKey] || function(Slot) {
    try {
        Object.defineProperty($1b7dab7b0d0a41be$var$globalHost, $1b7dab7b0d0a41be$var$globalKey, {
            value: Slot,
            enumerable: false,
            writable: false,
            // When it was possible for globalHost to be the Array constructor (a
            // legacy Slot dedup strategy), it was important for the property to be
            // configurable:true so it could be deleted. That does not seem to be as
            // important when globalHost is the global object, but I don't want to
            // cause similar problems again, and configurable:true seems safest.
            // https://github.com/endojs/endo/issues/576#issuecomment-1178274008
            configurable: true
        });
    } finally{
        return Slot;
    }
}($1b7dab7b0d0a41be$var$makeSlotClass());


const { bind: $1f2d3d2c6c19c650$export$2385a24977818dd0, noContext: $1f2d3d2c6c19c650$export$9fa6f2e300a97f8 } = (0, $1b7dab7b0d0a41be$export$8c6ed5c666ac1360);
function $1f2d3d2c6c19c650$export$831dc9f2ab0a617b(callback, delay) {
    return setTimeout($1f2d3d2c6c19c650$export$2385a24977818dd0(callback), delay);
}
function $1f2d3d2c6c19c650$export$d5d7536e965c82da(genFn) {
    return function() {
        const gen = genFn.apply(this, arguments);
        const boundNext = $1f2d3d2c6c19c650$export$2385a24977818dd0(gen.next);
        const boundThrow = $1f2d3d2c6c19c650$export$2385a24977818dd0(gen.throw);
        return new Promise((resolve, reject)=>{
            function invoke(method, argument) {
                try {
                    var result = method.call(gen, argument);
                } catch (error) {
                    return reject(error);
                }
                const next = result.done ? resolve : invokeNext;
                if ($1f2d3d2c6c19c650$var$isPromiseLike(result.value)) result.value.then(next, result.done ? reject : invokeThrow);
                else next(result.value);
            }
            const invokeNext = (value)=>invoke(boundNext, value);
            const invokeThrow = (error)=>invoke(boundThrow, error);
            invokeNext();
        });
    };
}
function $1f2d3d2c6c19c650$var$isPromiseLike(value) {
    return value && typeof value.then === "function";
}
// If you use the fibers npm package to implement coroutines in Node.js,
// you should call this function at least once to ensure context management
// remains coherent across any yields.
const $1f2d3d2c6c19c650$var$wrappedFibers = [];
function $1f2d3d2c6c19c650$export$14794f6e0a4dc6a0(Fiber) {
    // There can be only one implementation of Fiber per process, so this array
    // should never grow longer than one element.
    if ($1f2d3d2c6c19c650$var$wrappedFibers.indexOf(Fiber) < 0) {
        const wrap = (obj, method)=>{
            const fn = obj[method];
            obj[method] = function() {
                return $1f2d3d2c6c19c650$export$9fa6f2e300a97f8(fn, arguments, this);
            };
        };
        // These methods can yield, according to
        // https://github.com/laverdet/node-fibers/blob/ddebed9b8ae3883e57f822e2108e6943e5c8d2a8/fibers.js#L97-L100
        wrap(Fiber, "yield");
        wrap(Fiber.prototype, "run");
        wrap(Fiber.prototype, "throwInto");
        $1f2d3d2c6c19c650$var$wrappedFibers.push(Fiber);
    }
    return Fiber;
}


const $ef3c9a5ce6618ec2$export$11fa9682b6ba79b1 = new (0, $1b7dab7b0d0a41be$export$8c6ed5c666ac1360)();
function $ef3c9a5ce6618ec2$export$d906efd39458576(fn) {
    return $ef3c9a5ce6618ec2$export$11fa9682b6ba79b1.withValue(void 0, fn);
}


const { hasOwnProperty: $ad641868d96e626a$export$5a15a386532a5ea4 } = Object.prototype;
const $ad641868d96e626a$export$1eb72f2488cedd93 = Array.from || function(set) {
    const array = [];
    set.forEach((item)=>array.push(item));
    return array;
};
function $ad641868d96e626a$export$50527b97338c0f71(entryOrDep) {
    const { unsubscribe: unsubscribe } = entryOrDep;
    if (typeof unsubscribe === "function") {
        entryOrDep.unsubscribe = void 0;
        unsubscribe();
    }
}


const $2a376116df8c597f$var$emptySetPool = [];
const $2a376116df8c597f$var$POOL_TARGET_SIZE = 100;
// Since this package might be used browsers, we should avoid using the
// Node built-in assert module.
function $2a376116df8c597f$var$assert(condition, optionalMessage) {
    if (!condition) throw new Error(optionalMessage || "assertion failure");
}
function $2a376116df8c597f$var$valueIs(a, b) {
    const len = a.length;
    return(// Unknown values are not equal to each other.
    len > 0 && // Both values must be ordinary (or both exceptional) to be equal.
    len === b.length && // The underlying value or exception must be the same.
    a[len - 1] === b[len - 1]);
}
function $2a376116df8c597f$var$valueGet(value) {
    switch(value.length){
        case 0:
            throw new Error("unknown value");
        case 1:
            return value[0];
        case 2:
            throw value[1];
    }
}
function $2a376116df8c597f$var$valueCopy(value) {
    return value.slice(0);
}
class $2a376116df8c597f$export$3bb977b3ba9d3b59 {
    constructor(fn){
        this.fn = fn;
        this.parents = new Set();
        this.childValues = new Map();
        // When this Entry has children that are dirty, this property becomes
        // a Set containing other Entry objects, borrowed from emptySetPool.
        // When the set becomes empty, it gets recycled back to emptySetPool.
        this.dirtyChildren = null;
        this.dirty = true;
        this.recomputing = false;
        this.value = [];
        this.deps = null;
        ++$2a376116df8c597f$export$3bb977b3ba9d3b59.count;
    }
    peek() {
        if (this.value.length === 1 && !$2a376116df8c597f$var$mightBeDirty(this)) {
            $2a376116df8c597f$var$rememberParent(this);
            return this.value[0];
        }
    }
    // This is the most important method of the Entry API, because it
    // determines whether the cached this.value can be returned immediately,
    // or must be recomputed. The overall performance of the caching system
    // depends on the truth of the following observations: (1) this.dirty is
    // usually false, (2) this.dirtyChildren is usually null/empty, and thus
    // (3) valueGet(this.value) is usually returned without recomputation.
    recompute(args) {
        $2a376116df8c597f$var$assert(!this.recomputing, "already recomputing");
        $2a376116df8c597f$var$rememberParent(this);
        return $2a376116df8c597f$var$mightBeDirty(this) ? $2a376116df8c597f$var$reallyRecompute(this, args) : $2a376116df8c597f$var$valueGet(this.value);
    }
    setDirty() {
        if (this.dirty) return;
        this.dirty = true;
        $2a376116df8c597f$var$reportDirty(this);
        // We can go ahead and unsubscribe here, since any further dirty
        // notifications we receive will be redundant, and unsubscribing may
        // free up some resources, e.g. file watchers.
        (0, $ad641868d96e626a$export$50527b97338c0f71)(this);
    }
    dispose() {
        this.setDirty();
        // Sever any dependency relationships with our own children, so those
        // children don't retain this parent Entry in their child.parents sets,
        // thereby preventing it from being fully garbage collected.
        $2a376116df8c597f$var$forgetChildren(this);
        // Because this entry has been kicked out of the cache (in index.js),
        // we've lost the ability to find out if/when this entry becomes dirty,
        // whether that happens through a subscription, because of a direct call
        // to entry.setDirty(), or because one of its children becomes dirty.
        // Because of this loss of future information, we have to assume the
        // worst (that this entry might have become dirty very soon), so we must
        // immediately mark this entry's parents as dirty. Normally we could
        // just call entry.setDirty() rather than calling parent.setDirty() for
        // each parent, but that would leave this entry in parent.childValues
        // and parent.dirtyChildren, which would prevent the child from being
        // truly forgotten.
        $2a376116df8c597f$var$eachParent(this, (parent, child)=>{
            parent.setDirty();
            $2a376116df8c597f$var$forgetChild(parent, this);
        });
    }
    forget() {
        // The code that creates Entry objects in index.ts will replace this method
        // with one that actually removes the Entry from the cache, which will also
        // trigger the entry.dispose method.
        this.dispose();
    }
    dependOn(dep) {
        dep.add(this);
        if (!this.deps) this.deps = $2a376116df8c597f$var$emptySetPool.pop() || new Set();
        this.deps.add(dep);
    }
    forgetDeps() {
        if (this.deps) {
            (0, $ad641868d96e626a$export$1eb72f2488cedd93)(this.deps).forEach((dep)=>dep.delete(this));
            this.deps.clear();
            $2a376116df8c597f$var$emptySetPool.push(this.deps);
            this.deps = null;
        }
    }
}
$2a376116df8c597f$export$3bb977b3ba9d3b59.count = 0;
function $2a376116df8c597f$var$rememberParent(child) {
    const parent = (0, $ef3c9a5ce6618ec2$export$11fa9682b6ba79b1).getValue();
    if (parent) {
        child.parents.add(parent);
        if (!parent.childValues.has(child)) parent.childValues.set(child, []);
        if ($2a376116df8c597f$var$mightBeDirty(child)) $2a376116df8c597f$var$reportDirtyChild(parent, child);
        else $2a376116df8c597f$var$reportCleanChild(parent, child);
        return parent;
    }
}
function $2a376116df8c597f$var$reallyRecompute(entry, args) {
    $2a376116df8c597f$var$forgetChildren(entry);
    // Set entry as the parent entry while calling recomputeNewValue(entry).
    (0, $ef3c9a5ce6618ec2$export$11fa9682b6ba79b1).withValue(entry, $2a376116df8c597f$var$recomputeNewValue, [
        entry,
        args
    ]);
    if ($2a376116df8c597f$var$maybeSubscribe(entry, args)) // If we successfully recomputed entry.value and did not fail to
    // (re)subscribe, then this Entry is no longer explicitly dirty.
    $2a376116df8c597f$var$setClean(entry);
    return $2a376116df8c597f$var$valueGet(entry.value);
}
function $2a376116df8c597f$var$recomputeNewValue(entry, args) {
    entry.recomputing = true;
    const { normalizeResult: normalizeResult } = entry;
    let oldValueCopy;
    if (normalizeResult && entry.value.length === 1) oldValueCopy = $2a376116df8c597f$var$valueCopy(entry.value);
    // Make entry.value an empty array, representing an unknown value.
    entry.value.length = 0;
    try {
        // If entry.fn succeeds, entry.value will become a normal Value.
        entry.value[0] = entry.fn.apply(null, args);
        // If we have a viable oldValueCopy to compare with the (successfully
        // recomputed) new entry.value, and they are not already === identical, give
        // normalizeResult a chance to pick/choose/reuse parts of oldValueCopy[0]
        // and/or entry.value[0] to determine the final cached entry.value.
        if (normalizeResult && oldValueCopy && !$2a376116df8c597f$var$valueIs(oldValueCopy, entry.value)) try {
            entry.value[0] = normalizeResult(entry.value[0], oldValueCopy[0]);
        } catch (_a) {
        // If normalizeResult throws, just use the newer value, rather than
        // saving the exception as entry.value[1].
        }
    } catch (e) {
        // If entry.fn throws, entry.value will hold that exception.
        entry.value[1] = e;
    }
    // Either way, this line is always reached.
    entry.recomputing = false;
}
function $2a376116df8c597f$var$mightBeDirty(entry) {
    return entry.dirty || !!(entry.dirtyChildren && entry.dirtyChildren.size);
}
function $2a376116df8c597f$var$setClean(entry) {
    entry.dirty = false;
    if ($2a376116df8c597f$var$mightBeDirty(entry)) // This Entry may still have dirty children, in which case we can't
    // let our parents know we're clean just yet.
    return;
    $2a376116df8c597f$var$reportClean(entry);
}
function $2a376116df8c597f$var$reportDirty(child) {
    $2a376116df8c597f$var$eachParent(child, $2a376116df8c597f$var$reportDirtyChild);
}
function $2a376116df8c597f$var$reportClean(child) {
    $2a376116df8c597f$var$eachParent(child, $2a376116df8c597f$var$reportCleanChild);
}
function $2a376116df8c597f$var$eachParent(child, callback) {
    const parentCount = child.parents.size;
    if (parentCount) {
        const parents = (0, $ad641868d96e626a$export$1eb72f2488cedd93)(child.parents);
        for(let i = 0; i < parentCount; ++i)callback(parents[i], child);
    }
}
// Let a parent Entry know that one of its children may be dirty.
function $2a376116df8c597f$var$reportDirtyChild(parent, child) {
    // Must have called rememberParent(child) before calling
    // reportDirtyChild(parent, child).
    $2a376116df8c597f$var$assert(parent.childValues.has(child));
    $2a376116df8c597f$var$assert($2a376116df8c597f$var$mightBeDirty(child));
    const parentWasClean = !$2a376116df8c597f$var$mightBeDirty(parent);
    if (!parent.dirtyChildren) parent.dirtyChildren = $2a376116df8c597f$var$emptySetPool.pop() || new Set;
    else if (parent.dirtyChildren.has(child)) // If we already know this child is dirty, then we must have already
    // informed our own parents that we are dirty, so we can terminate
    // the recursion early.
    return;
    parent.dirtyChildren.add(child);
    // If parent was clean before, it just became (possibly) dirty (according to
    // mightBeDirty), since we just added child to parent.dirtyChildren.
    if (parentWasClean) $2a376116df8c597f$var$reportDirty(parent);
}
// Let a parent Entry know that one of its children is no longer dirty.
function $2a376116df8c597f$var$reportCleanChild(parent, child) {
    // Must have called rememberChild(child) before calling
    // reportCleanChild(parent, child).
    $2a376116df8c597f$var$assert(parent.childValues.has(child));
    $2a376116df8c597f$var$assert(!$2a376116df8c597f$var$mightBeDirty(child));
    const childValue = parent.childValues.get(child);
    if (childValue.length === 0) parent.childValues.set(child, $2a376116df8c597f$var$valueCopy(child.value));
    else if (!$2a376116df8c597f$var$valueIs(childValue, child.value)) parent.setDirty();
    $2a376116df8c597f$var$removeDirtyChild(parent, child);
    if ($2a376116df8c597f$var$mightBeDirty(parent)) return;
    $2a376116df8c597f$var$reportClean(parent);
}
function $2a376116df8c597f$var$removeDirtyChild(parent, child) {
    const dc = parent.dirtyChildren;
    if (dc) {
        dc.delete(child);
        if (dc.size === 0) {
            if ($2a376116df8c597f$var$emptySetPool.length < $2a376116df8c597f$var$POOL_TARGET_SIZE) $2a376116df8c597f$var$emptySetPool.push(dc);
            parent.dirtyChildren = null;
        }
    }
}
// Removes all children from this entry and returns an array of the
// removed children.
function $2a376116df8c597f$var$forgetChildren(parent) {
    if (parent.childValues.size > 0) parent.childValues.forEach((_value, child)=>{
        $2a376116df8c597f$var$forgetChild(parent, child);
    });
    // Remove this parent Entry from any sets to which it was added by the
    // addToSet method.
    parent.forgetDeps();
    // After we forget all our children, this.dirtyChildren must be empty
    // and therefore must have been reset to null.
    $2a376116df8c597f$var$assert(parent.dirtyChildren === null);
}
function $2a376116df8c597f$var$forgetChild(parent, child) {
    child.parents.delete(parent);
    parent.childValues.delete(child);
    $2a376116df8c597f$var$removeDirtyChild(parent, child);
}
function $2a376116df8c597f$var$maybeSubscribe(entry, args) {
    if (typeof entry.subscribe === "function") try {
        (0, $ad641868d96e626a$export$50527b97338c0f71)(entry); // Prevent double subscriptions.
        entry.unsubscribe = entry.subscribe.apply(null, args);
    } catch (e) {
        // If this Entry has a subscribe function and it threw an exception
        // (or an unsubscribe function it previously returned now throws),
        // return false to indicate that we were not able to subscribe (or
        // unsubscribe), and this Entry should remain dirty.
        entry.setDirty();
        return false;
    }
    // Returning true indicates either that there was no entry.subscribe
    // function or that it succeeded.
    return true;
}





const $f96bffcf733fdbbf$var$EntryMethods = {
    setDirty: true,
    dispose: true,
    forget: true
};
function $f96bffcf733fdbbf$export$c723b7eff9d8f870(options) {
    const depsByKey = new Map();
    const subscribe = options && options.subscribe;
    function depend(key) {
        const parent = (0, $ef3c9a5ce6618ec2$export$11fa9682b6ba79b1).getValue();
        if (parent) {
            let dep = depsByKey.get(key);
            if (!dep) depsByKey.set(key, dep = new Set);
            parent.dependOn(dep);
            if (typeof subscribe === "function") {
                (0, $ad641868d96e626a$export$50527b97338c0f71)(dep);
                dep.unsubscribe = subscribe(key);
            }
        }
    }
    depend.dirty = function dirty(key, entryMethodName) {
        const dep = depsByKey.get(key);
        if (dep) {
            const m = entryMethodName && (0, $ad641868d96e626a$export$5a15a386532a5ea4).call($f96bffcf733fdbbf$var$EntryMethods, entryMethodName) ? entryMethodName : "setDirty";
            // We have to use arrayFromSet(dep).forEach instead of dep.forEach,
            // because modifying a Set while iterating over it can cause elements in
            // the Set to be removed from the Set before they've been iterated over.
            (0, $ad641868d96e626a$export$1eb72f2488cedd93)(dep).forEach((entry)=>entry[m]());
            depsByKey.delete(key);
            (0, $ad641868d96e626a$export$50527b97338c0f71)(dep);
        }
    };
    return depend;
}


// The defaultMakeCacheKey function is remarkably powerful, because it gives
// a unique object for any shallow-identical list of arguments. If you need
// to implement a custom makeCacheKey function, you may find it helpful to
// delegate the final work to defaultMakeCacheKey, which is why we export it
// here. However, you may want to avoid defaultMakeCacheKey if your runtime
// does not support WeakMap, or you have the ability to return a string key.
// In those cases, just write your own custom makeCacheKey functions.
let $0fc5e093b69637b4$var$defaultKeyTrie;
function $0fc5e093b69637b4$export$cd3144f8dd136006(...args) {
    const trie = $0fc5e093b69637b4$var$defaultKeyTrie || ($0fc5e093b69637b4$var$defaultKeyTrie = new (0, $02443dfd16cf74b4$export$73571c50d0f2507e)(typeof WeakMap === "function"));
    return trie.lookupArray(args);
}
const $0fc5e093b69637b4$var$caches = new Set();
function $0fc5e093b69637b4$export$4997ffc0176396a6(originalFunction, { max: max = Math.pow(2, 16), keyArgs: keyArgs, makeCacheKey: makeCacheKey = $0fc5e093b69637b4$export$cd3144f8dd136006, normalizeResult: normalizeResult, subscribe: subscribe, cache: cacheOption = (0, $557c26506c40b8f1$export$d3a0331d2c286dc8) } = Object.create(null)) {
    const cache = typeof cacheOption === "function" ? new cacheOption(max, (entry)=>entry.dispose()) : cacheOption;
    const optimistic = function() {
        const key = makeCacheKey.apply(null, keyArgs ? keyArgs.apply(null, arguments) : arguments);
        if (key === void 0) return originalFunction.apply(null, arguments);
        let entry = cache.get(key);
        if (!entry) {
            cache.set(key, entry = new (0, $2a376116df8c597f$export$3bb977b3ba9d3b59)(originalFunction));
            entry.normalizeResult = normalizeResult;
            entry.subscribe = subscribe;
            // Give the Entry the ability to trigger cache.delete(key), even though
            // the Entry itself does not know about key or cache.
            entry.forget = ()=>cache.delete(key);
        }
        const value = entry.recompute(Array.prototype.slice.call(arguments));
        // Move this entry to the front of the least-recently used queue,
        // since we just finished computing its value.
        cache.set(key, entry);
        $0fc5e093b69637b4$var$caches.add(cache);
        // Clean up any excess entries in the cache, but only if there is no
        // active parent entry, meaning we're not in the middle of a larger
        // computation that might be flummoxed by the cleaning.
        if (!(0, $ef3c9a5ce6618ec2$export$11fa9682b6ba79b1).hasValue()) {
            $0fc5e093b69637b4$var$caches.forEach((cache)=>cache.clean());
            $0fc5e093b69637b4$var$caches.clear();
        }
        return value;
    };
    Object.defineProperty(optimistic, "size", {
        get: ()=>cache.size,
        configurable: false,
        enumerable: false
    });
    Object.freeze(optimistic.options = {
        max: max,
        keyArgs: keyArgs,
        makeCacheKey: makeCacheKey,
        normalizeResult: normalizeResult,
        subscribe: subscribe,
        cache: cache
    });
    function dirtyKey(key) {
        const entry = key && cache.get(key);
        if (entry) entry.setDirty();
    }
    optimistic.dirtyKey = dirtyKey;
    optimistic.dirty = function dirty() {
        dirtyKey(makeCacheKey.apply(null, arguments));
    };
    function peekKey(key) {
        const entry = key && cache.get(key);
        if (entry) return entry.peek();
    }
    optimistic.peekKey = peekKey;
    optimistic.peek = function peek() {
        return peekKey(makeCacheKey.apply(null, arguments));
    };
    function forgetKey(key) {
        return key ? cache.delete(key) : false;
    }
    optimistic.forgetKey = forgetKey;
    optimistic.forget = function forget() {
        return forgetKey(makeCacheKey.apply(null, arguments));
    };
    optimistic.makeCacheKey = makeCacheKey;
    optimistic.getKey = keyArgs ? function getKey() {
        return makeCacheKey.apply(null, keyArgs.apply(null, arguments));
    } : makeCacheKey;
    return Object.freeze(optimistic);
}



function $2e04132f91cc06f1$var$identity(document) {
    return document;
}
var $2e04132f91cc06f1$export$f887060e48e5dc1b = /** @class */ function() {
    function DocumentTransform(transform, options) {
        if (options === void 0) options = Object.create(null);
        this.resultCache = (0, $5d0a073f980bb2a3$export$7293b8a0b474028d) ? new WeakSet() : new Set();
        this.transform = transform;
        if (options.getCacheKey) // Override default `getCacheKey` function, which returns [document].
        this.getCacheKey = options.getCacheKey;
        this.cached = options.cache !== false;
        this.resetCache();
    }
    // This default implementation of getCacheKey can be overridden by providing
    // options.getCacheKey to the DocumentTransform constructor. In general, a
    // getCacheKey function may either return an array of keys (often including
    // the document) to be used as a cache key, or undefined to indicate the
    // transform for this document should not be cached.
    DocumentTransform.prototype.getCacheKey = function(document) {
        return [
            document
        ];
    };
    DocumentTransform.identity = function() {
        // No need to cache this transform since it just returns the document
        // unchanged. This should save a bit of memory that would otherwise be
        // needed to populate the `documentCache` of this transform.
        return new DocumentTransform($2e04132f91cc06f1$var$identity, {
            cache: false
        });
    };
    DocumentTransform.split = function(predicate, left, right) {
        if (right === void 0) right = DocumentTransform.identity();
        return Object.assign(new DocumentTransform(function(document) {
            var documentTransform = predicate(document) ? left : right;
            return documentTransform.transformDocument(document);
        }, // Reasonably assume both `left` and `right` transforms handle their own caching
        {
            cache: false
        }), {
            left: left,
            right: right
        });
    };
    /**
     * Resets the internal cache of this transform, if it has one.
     */ DocumentTransform.prototype.resetCache = function() {
        var _this = this;
        if (this.cached) {
            var stableCacheKeys_1 = new (0, $02443dfd16cf74b4$export$73571c50d0f2507e)((0, $5d0a073f980bb2a3$export$772fbc04a0ad4ce9));
            this.performWork = (0, $0fc5e093b69637b4$export$4997ffc0176396a6)(DocumentTransform.prototype.performWork.bind(this), {
                makeCacheKey: function(document) {
                    var cacheKeys = _this.getCacheKey(document);
                    if (cacheKeys) {
                        (0, $28d90d877eb1e517$export$f5708dca728d7177)(Array.isArray(cacheKeys), 69);
                        return stableCacheKeys_1.lookupArray(cacheKeys);
                    }
                },
                max: (0, $c506be9be1a65610$export$f29926b23b28936b)["documentTransform.cache"],
                cache: (0, $947797cdb9e55a2d$export$87b462129af3b7d4)
            });
        }
    };
    DocumentTransform.prototype.performWork = function(document) {
        (0, $818d93327cb72c29$export$a7d0d8111d2386df)(document);
        return this.transform(document);
    };
    DocumentTransform.prototype.transformDocument = function(document) {
        // If a user passes an already transformed result back to this function,
        // immediately return it.
        if (this.resultCache.has(document)) return document;
        var transformedDocument = this.performWork(document);
        this.resultCache.add(transformedDocument);
        return transformedDocument;
    };
    DocumentTransform.prototype.concat = function(otherTransform) {
        var _this = this;
        return Object.assign(new DocumentTransform(function(document) {
            return otherTransform.transformDocument(_this.transformDocument(document));
        }, // Reasonably assume both transforms handle their own caching
        {
            cache: false
        }), {
            left: this,
            right: otherTransform
        });
    };
    return DocumentTransform;
}();



function $5333c7f04e9cca43$export$b4df399e879e53ab(result) {
    var errors = $5333c7f04e9cca43$export$a163557155188b6e(result);
    return (0, $e6aaa0e65613edd7$export$d307f5934e447d0e)(errors);
}
function $5333c7f04e9cca43$export$a163557155188b6e(result) {
    var graphQLErrors = (0, $e6aaa0e65613edd7$export$d307f5934e447d0e)(result.errors) ? result.errors.slice(0) : [];
    if ((0, $4753a78f97af1d82$export$879767c5cdf33cb3)(result) && (0, $e6aaa0e65613edd7$export$d307f5934e447d0e)(result.incremental)) result.incremental.forEach(function(incrementalResult) {
        if (incrementalResult.errors) graphQLErrors.push.apply(graphQLErrors, incrementalResult.errors);
    });
    return graphQLErrors;
}








/**
 * The current status of a query’s execution in our system.
 */ var $72c5140a632c7fa1$export$bd096ddbd246c79c;
(function(NetworkStatus) {
    /**
     * The query has never been run before and the query is now currently running. A query will still
     * have this network status even if a partial data result was returned from the cache, but a
     * query was dispatched anyway.
     */ NetworkStatus[NetworkStatus["loading"] = 1] = "loading";
    /**
     * If `setVariables` was called and a query was fired because of that then the network status
     * will be `setVariables` until the result of that query comes back.
     */ NetworkStatus[NetworkStatus["setVariables"] = 2] = "setVariables";
    /**
     * Indicates that `fetchMore` was called on this query and that the query created is currently in
     * flight.
     */ NetworkStatus[NetworkStatus["fetchMore"] = 3] = "fetchMore";
    /**
     * Similar to the `setVariables` network status. It means that `refetch` was called on a query
     * and the refetch request is currently in flight.
     */ NetworkStatus[NetworkStatus["refetch"] = 4] = "refetch";
    /**
     * Indicates that a polling query is currently in flight. So for example if you are polling a
     * query every 10 seconds then the network status will switch to `poll` every 10 seconds whenever
     * a poll request has been sent but not resolved.
     */ NetworkStatus[NetworkStatus["poll"] = 6] = "poll";
    /**
     * No request is in flight for this query, and no errors happened. Everything is OK.
     */ NetworkStatus[NetworkStatus["ready"] = 7] = "ready";
    /**
     * No request is in flight for this query, but one or more errors were detected.
     */ NetworkStatus[NetworkStatus["error"] = 8] = "error";
})($72c5140a632c7fa1$export$bd096ddbd246c79c || ($72c5140a632c7fa1$export$bd096ddbd246c79c = {}));
function $72c5140a632c7fa1$export$37509604341a3464(networkStatus) {
    return networkStatus ? networkStatus < 7 : false;
}
function $72c5140a632c7fa1$export$427e8a52ef0f96e2(networkStatus) {
    return networkStatus === 7 || networkStatus === 8;
}


var $e398dba65b0b4cec$var$toString = Object.prototype.toString;
function $e398dba65b0b4cec$export$629a2bd3f5a49ecc(value) {
    return $e398dba65b0b4cec$var$cloneDeepHelper(value);
}
function $e398dba65b0b4cec$var$cloneDeepHelper(val, seen) {
    switch($e398dba65b0b4cec$var$toString.call(val)){
        case "[object Array]":
            seen = seen || new Map();
            if (seen.has(val)) return seen.get(val);
            var copy_1 = val.slice(0);
            seen.set(val, copy_1);
            copy_1.forEach(function(child, i) {
                copy_1[i] = $e398dba65b0b4cec$var$cloneDeepHelper(child, seen);
            });
            return copy_1;
        case "[object Object]":
            seen = seen || new Map();
            if (seen.has(val)) return seen.get(val);
            // High fidelity polyfills of Object.create and Object.getPrototypeOf are
            // possible in all JS environments, so we will assume they exist/work.
            var copy_2 = Object.create(Object.getPrototypeOf(val));
            seen.set(val, copy_2);
            Object.keys(val).forEach(function(key) {
                copy_2[key] = $e398dba65b0b4cec$var$cloneDeepHelper(val[key], seen);
            });
            return copy_2;
        default:
            return val;
    }
}

/**
 * Merges the provided objects shallowly and removes
 * all properties with an `undefined` value
 */ function $2f3cebf1a05c1b38$export$8e16b83750b44988() {
    var objects = [];
    for(var _i = 0; _i < arguments.length; _i++)objects[_i] = arguments[_i];
    var result = Object.create(null);
    objects.forEach(function(obj) {
        if (!obj) return;
        Object.keys(obj).forEach(function(key) {
            var value = obj[key];
            if (value !== void 0) result[key] = value;
        });
    });
    return result;
}






function $3703278c0cb633ee$export$5e40714c5ad44445(query, _a, _b, variables) {
    var aData = _a.data, aRest = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(_a, [
        "data"
    ]);
    var bData = _b.data, bRest = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(_b, [
        "data"
    ]);
    return (0, $a2b6f433e732b502$export$2e2bcd8739ae039)(aRest, bRest) && $3703278c0cb633ee$var$equalBySelectionSet((0, $818d93327cb72c29$export$f431198736b7f96d)(query).selectionSet, aData, bData, {
        fragmentMap: (0, $7f688c9754699513$export$193789b4c8246dd4)((0, $818d93327cb72c29$export$5320a7ba9466a3df)(query)),
        variables: variables
    });
}
function $3703278c0cb633ee$var$equalBySelectionSet(selectionSet, aResult, bResult, context) {
    if (aResult === bResult) return true;
    var seenSelections = new Set();
    // Returning true from this Array.prototype.every callback function skips the
    // current field/subtree. Returning false aborts the entire traversal
    // immediately, causing equalBySelectionSet to return false.
    return selectionSet.selections.every(function(selection) {
        // Avoid re-processing the same selection at the same level of recursion, in
        // case the same field gets included via multiple indirect fragment spreads.
        if (seenSelections.has(selection)) return true;
        seenSelections.add(selection);
        // Ignore @skip(if: true) and @include(if: false) fields.
        if (!(0, $89c1eec09879e1ca$export$3dc388a5f013b4a5)(selection, context.variables)) return true;
        // If the field or (named) fragment spread has a @nonreactive directive on
        // it, we don't care if it's different, so we pretend it's the same.
        if ($3703278c0cb633ee$var$selectionHasNonreactiveDirective(selection)) return true;
        if ((0, $9d830e5028848843$export$fb56ad75dd311c12)(selection)) {
            var resultKey = (0, $9d830e5028848843$export$7d1ad22471852218)(selection);
            var aResultChild = aResult && aResult[resultKey];
            var bResultChild = bResult && bResult[resultKey];
            var childSelectionSet = selection.selectionSet;
            if (!childSelectionSet) // These are scalar values, so we can compare them with deep equal
            // without redoing the main recursive work.
            return (0, $a2b6f433e732b502$export$2e2bcd8739ae039)(aResultChild, bResultChild);
            var aChildIsArray = Array.isArray(aResultChild);
            var bChildIsArray = Array.isArray(bResultChild);
            if (aChildIsArray !== bChildIsArray) return false;
            if (aChildIsArray && bChildIsArray) {
                var length_1 = aResultChild.length;
                if (bResultChild.length !== length_1) return false;
                for(var i = 0; i < length_1; ++i){
                    if (!$3703278c0cb633ee$var$equalBySelectionSet(childSelectionSet, aResultChild[i], bResultChild[i], context)) return false;
                }
                return true;
            }
            return $3703278c0cb633ee$var$equalBySelectionSet(childSelectionSet, aResultChild, bResultChild, context);
        } else {
            var fragment = (0, $7f688c9754699513$export$f80bdb85f299186)(selection, context.fragmentMap);
            if (fragment) {
                // The fragment might === selection if it's an inline fragment, but
                // could be !== if it's a named fragment ...spread.
                if ($3703278c0cb633ee$var$selectionHasNonreactiveDirective(fragment)) return true;
                return $3703278c0cb633ee$var$equalBySelectionSet(fragment.selectionSet, // Notice that we reuse the same aResult and bResult values here,
                // since the fragment ...spread does not specify a field name, but
                // consists of multiple fields (within the fragment's selection set)
                // that should be applied to the current result value(s).
                aResult, bResult, context);
            }
        }
    });
}
function $3703278c0cb633ee$var$selectionHasNonreactiveDirective(selection) {
    return !!selection.directives && selection.directives.some($3703278c0cb633ee$var$directiveIsNonreactive);
}
function $3703278c0cb633ee$var$directiveIsNonreactive(dir) {
    return dir.name.value === "nonreactive";
}


var $3118fa29bcf9f4b2$var$assign = Object.assign, $3118fa29bcf9f4b2$var$hasOwnProperty = Object.hasOwnProperty;
var $3118fa29bcf9f4b2$export$6c1b56eac59c9584 = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(ObservableQuery, _super);
    function ObservableQuery(_a) {
        var queryManager = _a.queryManager, queryInfo = _a.queryInfo, options = _a.options;
        var _this = _super.call(this, function(observer) {
            // Zen Observable has its own error function, so in order to log correctly
            // we need to provide a custom error callback.
            try {
                var subObserver = observer._subscription._observer;
                if (subObserver && !subObserver.error) subObserver.error = $3118fa29bcf9f4b2$var$defaultSubscriptionObserverErrorCallback;
            } catch (_a) {}
            var first = !_this.observers.size;
            _this.observers.add(observer);
            // Deliver most recent error or result.
            var last = _this.last;
            if (last && last.error) observer.error && observer.error(last.error);
            else if (last && last.result) observer.next && observer.next(last.result);
            // Initiate observation of this query if it hasn't been reported to
            // the QueryManager yet.
            if (first) // Blindly catching here prevents unhandled promise rejections,
            // and is safe because the ObservableQuery handles this error with
            // this.observer.error, so we're not just swallowing the error by
            // ignoring it here.
            _this.reobserve().catch(function() {});
            return function() {
                if (_this.observers.delete(observer) && !_this.observers.size) _this.tearDownQuery();
            };
        }) || this;
        _this.observers = new Set();
        _this.subscriptions = new Set();
        // related classes
        _this.queryInfo = queryInfo;
        _this.queryManager = queryManager;
        // active state
        _this.waitForOwnResult = $3118fa29bcf9f4b2$var$skipCacheDataFor(options.fetchPolicy);
        _this.isTornDown = false;
        _this.subscribeToMore = _this.subscribeToMore.bind(_this);
        var _b = queryManager.defaultOptions.watchQuery, _c = _b === void 0 ? {} : _b, _d = _c.fetchPolicy, defaultFetchPolicy = _d === void 0 ? "cache-first" : _d;
        var _e = options.fetchPolicy, fetchPolicy = _e === void 0 ? defaultFetchPolicy : _e, // Make sure we don't store "standby" as the initialFetchPolicy.
        _f = options.initialFetchPolicy, // Make sure we don't store "standby" as the initialFetchPolicy.
        initialFetchPolicy = _f === void 0 ? fetchPolicy === "standby" ? defaultFetchPolicy : fetchPolicy : _f;
        _this.options = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, options), {
            // Remember the initial options.fetchPolicy so we can revert back to this
            // policy when variables change. This information can also be specified
            // (or overridden) by providing options.initialFetchPolicy explicitly.
            initialFetchPolicy: initialFetchPolicy,
            // This ensures this.options.fetchPolicy always has a string value, in
            // case options.fetchPolicy was not provided.
            fetchPolicy: fetchPolicy
        });
        _this.queryId = queryInfo.queryId || queryManager.generateQueryId();
        var opDef = (0, $818d93327cb72c29$export$7a5b1fa979d2c158)(_this.query);
        _this.queryName = opDef && opDef.name && opDef.name.value;
        return _this;
    }
    Object.defineProperty(ObservableQuery.prototype, "query", {
        // The `query` computed property will always reflect the document transformed
        // by the last run query. `this.options.query` will always reflect the raw
        // untransformed query to ensure document transforms with runtime conditionals
        // are run on the original document.
        get: function() {
            return this.lastQuery || this.options.query;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ObservableQuery.prototype, "variables", {
        // Computed shorthand for this.options.variables, preserved for
        // backwards compatibility.
        /**
         * An object containing the variables that were provided for the query.
         */ get: function() {
            return this.options.variables;
        },
        enumerable: false,
        configurable: true
    });
    ObservableQuery.prototype.result = function() {
        var _this = this;
        return new Promise(function(resolve, reject) {
            // TODO: this code doesn’t actually make sense insofar as the observer
            // will never exist in this.observers due how zen-observable wraps observables.
            // https://github.com/zenparsing/zen-observable/blob/master/src/Observable.js#L169
            var observer = {
                next: function(result) {
                    resolve(result);
                    // Stop the query within the QueryManager if we can before
                    // this function returns.
                    //
                    // We do this in order to prevent observers piling up within
                    // the QueryManager. Notice that we only fully unsubscribe
                    // from the subscription in a setTimeout(..., 0)  call. This call can
                    // actually be handled by the browser at a much later time. If queries
                    // are fired in the meantime, observers that should have been removed
                    // from the QueryManager will continue to fire, causing an unnecessary
                    // performance hit.
                    _this.observers.delete(observer);
                    if (!_this.observers.size) _this.queryManager.removeQuery(_this.queryId);
                    setTimeout(function() {
                        subscription.unsubscribe();
                    }, 0);
                },
                error: reject
            };
            var subscription = _this.subscribe(observer);
        });
    };
    /** @internal */ ObservableQuery.prototype.resetDiff = function() {
        this.queryInfo.resetDiff();
    };
    ObservableQuery.prototype.getCurrentResult = function(saveAsLastResult) {
        if (saveAsLastResult === void 0) saveAsLastResult = true;
        // Use the last result as long as the variables match this.variables.
        var lastResult = this.getLastResult(true);
        var networkStatus = this.queryInfo.networkStatus || lastResult && lastResult.networkStatus || (0, $72c5140a632c7fa1$export$bd096ddbd246c79c).ready;
        var result = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, lastResult), {
            loading: (0, $72c5140a632c7fa1$export$37509604341a3464)(networkStatus),
            networkStatus: networkStatus
        });
        var _a = this.options.fetchPolicy, fetchPolicy = _a === void 0 ? "cache-first" : _a;
        if (// These fetch policies should never deliver data from the cache, unless
        // redelivering a previously delivered result.
        $3118fa29bcf9f4b2$var$skipCacheDataFor(fetchPolicy) || // If this.options.query has @client(always: true) fields, we cannot
        // trust diff.result, since it was read from the cache without running
        // local resolvers (and it's too late to run resolvers now, since we must
        // return a result synchronously).
        this.queryManager.getDocumentInfo(this.query).hasForcedResolvers) ;
        else if (this.waitForOwnResult) // This would usually be a part of `QueryInfo.getDiff()`.
        // which we skip in the waitForOwnResult case since we are not
        // interested in the diff.
        this.queryInfo["updateWatch"]();
        else {
            var diff = this.queryInfo.getDiff();
            if (diff.complete || this.options.returnPartialData) result.data = diff.result;
            if ((0, $a2b6f433e732b502$export$411ce8e5a71e3069)(result.data, {})) result.data = void 0;
            if (diff.complete) {
                // Similar to setting result.partial to false, but taking advantage of the
                // falsiness of missing fields.
                delete result.partial;
                // If the diff is complete, and we're using a FetchPolicy that
                // terminates after a complete cache read, we can assume the next result
                // we receive will have NetworkStatus.ready and !loading.
                if (diff.complete && result.networkStatus === (0, $72c5140a632c7fa1$export$bd096ddbd246c79c).loading && (fetchPolicy === "cache-first" || fetchPolicy === "cache-only")) {
                    result.networkStatus = (0, $72c5140a632c7fa1$export$bd096ddbd246c79c).ready;
                    result.loading = false;
                }
            } else result.partial = true;
            if (globalThis.__DEV__ !== false && !diff.complete && !this.options.partialRefetch && !result.loading && !result.data && !result.error) $3118fa29bcf9f4b2$export$b7e1973aacac3ae7(diff.missing);
        }
        if (saveAsLastResult) this.updateLastResult(result);
        return result;
    };
    // Compares newResult to the snapshot we took of this.lastResult when it was
    // first received.
    ObservableQuery.prototype.isDifferentFromLastResult = function(newResult, variables) {
        if (!this.last) return true;
        var resultIsDifferent = this.queryManager.getDocumentInfo(this.query).hasNonreactiveDirective ? !(0, $3703278c0cb633ee$export$5e40714c5ad44445)(this.query, this.last.result, newResult, this.variables) : !(0, $a2b6f433e732b502$export$411ce8e5a71e3069)(this.last.result, newResult);
        return resultIsDifferent || variables && !(0, $a2b6f433e732b502$export$411ce8e5a71e3069)(this.last.variables, variables);
    };
    ObservableQuery.prototype.getLast = function(key, variablesMustMatch) {
        var last = this.last;
        if (last && last[key] && (!variablesMustMatch || (0, $a2b6f433e732b502$export$411ce8e5a71e3069)(last.variables, this.variables))) return last[key];
    };
    ObservableQuery.prototype.getLastResult = function(variablesMustMatch) {
        return this.getLast("result", variablesMustMatch);
    };
    ObservableQuery.prototype.getLastError = function(variablesMustMatch) {
        return this.getLast("error", variablesMustMatch);
    };
    ObservableQuery.prototype.resetLastResults = function() {
        delete this.last;
        this.isTornDown = false;
    };
    ObservableQuery.prototype.resetQueryStoreErrors = function() {
        this.queryManager.resetErrors(this.queryId);
    };
    /**
     * Update the variables of this observable query, and fetch the new results.
     * This method should be preferred over `setVariables` in most use cases.
     *
     * @param variables - The new set of variables. If there are missing variables,
     * the previous values of those variables will be used.
     */ ObservableQuery.prototype.refetch = function(variables) {
        var _a;
        var reobserveOptions = {
            // Always disable polling for refetches.
            pollInterval: 0
        };
        // Unless the provided fetchPolicy always consults the network
        // (no-cache, network-only, or cache-and-network), override it with
        // network-only to force the refetch for this fetchQuery call.
        var fetchPolicy = this.options.fetchPolicy;
        if (fetchPolicy === "cache-and-network") reobserveOptions.fetchPolicy = fetchPolicy;
        else if (fetchPolicy === "no-cache") reobserveOptions.fetchPolicy = "no-cache";
        else reobserveOptions.fetchPolicy = "network-only";
        if (globalThis.__DEV__ !== false && variables && $3118fa29bcf9f4b2$var$hasOwnProperty.call(variables, "variables")) {
            var queryDef = (0, $818d93327cb72c29$export$d96b2213c1b9d3a9)(this.query);
            var vars = queryDef.variableDefinitions;
            if (!vars || !vars.some(function(v) {
                return v.variable.name.value === "variables";
            })) globalThis.__DEV__ !== false && (0, $28d90d877eb1e517$export$f5708dca728d7177).warn(20, variables, ((_a = queryDef.name) === null || _a === void 0 ? void 0 : _a.value) || queryDef);
        }
        if (variables && !(0, $a2b6f433e732b502$export$411ce8e5a71e3069)(this.options.variables, variables)) // Update the existing options with new variables
        reobserveOptions.variables = this.options.variables = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, this.options.variables), variables);
        this.queryInfo.resetLastWrite();
        return this.reobserve(reobserveOptions, (0, $72c5140a632c7fa1$export$bd096ddbd246c79c).refetch);
    };
    /**
     * A function that helps you fetch the next set of results for a [paginated list field](https://www.apollographql.com/docs/react/pagination/core-api/).
     */ ObservableQuery.prototype.fetchMore = function(fetchMoreOptions) {
        var _this = this;
        var combinedOptions = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, fetchMoreOptions.query ? fetchMoreOptions : (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, this.options), {
            query: this.options.query
        }), fetchMoreOptions), {
            variables: (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, this.options.variables), fetchMoreOptions.variables)
        })), {
            // The fetchMore request goes immediately to the network and does
            // not automatically write its result to the cache (hence no-cache
            // instead of network-only), because we allow the caller of
            // fetchMore to provide an updateQuery callback that determines how
            // the data gets written to the cache.
            fetchPolicy: "no-cache"
        });
        combinedOptions.query = this.transformDocument(combinedOptions.query);
        var qid = this.queryManager.generateQueryId();
        // If a temporary query is passed to `fetchMore`, we don't want to store
        // it as the last query result since it may be an optimized query for
        // pagination. We will however run the transforms on the original document
        // as well as the document passed in `fetchMoreOptions` to ensure the cache
        // uses the most up-to-date document which may rely on runtime conditionals.
        this.lastQuery = fetchMoreOptions.query ? this.transformDocument(this.options.query) : combinedOptions.query;
        // Simulate a loading result for the original query with
        // result.networkStatus === NetworkStatus.fetchMore.
        var queryInfo = this.queryInfo;
        var originalNetworkStatus = queryInfo.networkStatus;
        queryInfo.networkStatus = (0, $72c5140a632c7fa1$export$bd096ddbd246c79c).fetchMore;
        if (combinedOptions.notifyOnNetworkStatusChange) this.observe();
        var updatedQuerySet = new Set();
        var updateQuery = fetchMoreOptions === null || fetchMoreOptions === void 0 ? void 0 : fetchMoreOptions.updateQuery;
        var isCached = this.options.fetchPolicy !== "no-cache";
        if (!isCached) (0, $28d90d877eb1e517$export$f5708dca728d7177)(updateQuery, 21);
        return this.queryManager.fetchQuery(qid, combinedOptions, (0, $72c5140a632c7fa1$export$bd096ddbd246c79c).fetchMore).then(function(fetchMoreResult) {
            _this.queryManager.removeQuery(qid);
            if (queryInfo.networkStatus === (0, $72c5140a632c7fa1$export$bd096ddbd246c79c).fetchMore) queryInfo.networkStatus = originalNetworkStatus;
            if (isCached) // Performing this cache update inside a cache.batch transaction ensures
            // any affected cache.watch watchers are notified at most once about any
            // updates. Most watchers will be using the QueryInfo class, which
            // responds to notifications by calling reobserveCacheFirst to deliver
            // fetchMore cache results back to this ObservableQuery.
            _this.queryManager.cache.batch({
                update: function(cache) {
                    var updateQuery = fetchMoreOptions.updateQuery;
                    if (updateQuery) cache.updateQuery({
                        query: _this.query,
                        variables: _this.variables,
                        returnPartialData: true,
                        optimistic: false
                    }, function(previous) {
                        return updateQuery(previous, {
                            fetchMoreResult: fetchMoreResult.data,
                            variables: combinedOptions.variables
                        });
                    });
                    else // If we're using a field policy instead of updateQuery, the only
                    // thing we need to do is write the new data to the cache using
                    // combinedOptions.variables (instead of this.variables, which is
                    // what this.updateQuery uses, because it works by abusing the
                    // original field value, keyed by the original variables).
                    cache.writeQuery({
                        query: combinedOptions.query,
                        variables: combinedOptions.variables,
                        data: fetchMoreResult.data
                    });
                },
                onWatchUpdated: function(watch) {
                    // Record the DocumentNode associated with any watched query whose
                    // data were updated by the cache writes above.
                    updatedQuerySet.add(watch.query);
                }
            });
            else {
                // There is a possibility `lastResult` may not be set when
                // `fetchMore` is called which would cause this to crash. This should
                // only happen if we haven't previously reported a result. We don't
                // quite know what the right behavior should be here since this block
                // of code runs after the fetch result has executed on the network.
                // We plan to let it crash in the meantime.
                //
                // If we get bug reports due to the `data` property access on
                // undefined, this should give us a real-world scenario that we can
                // use to test against and determine the right behavior. If we do end
                // up changing this behavior, this may require, for example, an
                // adjustment to the types on `updateQuery` since that function
                // expects that the first argument always contains previous result
                // data, but not `undefined`.
                var lastResult = _this.getLast("result");
                var data = updateQuery(lastResult.data, {
                    fetchMoreResult: fetchMoreResult.data,
                    variables: combinedOptions.variables
                });
                _this.reportResult((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, lastResult), {
                    data: data
                }), _this.variables);
            }
            return fetchMoreResult;
        }).finally(function() {
            // In case the cache writes above did not generate a broadcast
            // notification (which would have been intercepted by onWatchUpdated),
            // likely because the written data were the same as what was already in
            // the cache, we still want fetchMore to deliver its final loading:false
            // result with the unchanged data.
            if (isCached && !updatedQuerySet.has(_this.query)) $3118fa29bcf9f4b2$export$419171d60552792a(_this);
        });
    };
    // XXX the subscription variables are separate from the query variables.
    // if you want to update subscription variables, right now you have to do that separately,
    // and you can only do it by stopping the subscription and then subscribing again with new variables.
    /**
     * A function that enables you to execute a [subscription](https://www.apollographql.com/docs/react/data/subscriptions/), usually to subscribe to specific fields that were included in the query.
     *
     * This function returns _another_ function that you can call to terminate the subscription.
     */ ObservableQuery.prototype.subscribeToMore = function(options) {
        var _this = this;
        var subscription = this.queryManager.startGraphQLSubscription({
            query: options.document,
            variables: options.variables,
            context: options.context
        }).subscribe({
            next: function(subscriptionData) {
                var updateQuery = options.updateQuery;
                if (updateQuery) _this.updateQuery(function(previous, _a) {
                    var variables = _a.variables;
                    return updateQuery(previous, {
                        subscriptionData: subscriptionData,
                        variables: variables
                    });
                });
            },
            error: function(err) {
                if (options.onError) {
                    options.onError(err);
                    return;
                }
                globalThis.__DEV__ !== false && (0, $28d90d877eb1e517$export$f5708dca728d7177).error(22, err);
            }
        });
        this.subscriptions.add(subscription);
        return function() {
            if (_this.subscriptions.delete(subscription)) subscription.unsubscribe();
        };
    };
    ObservableQuery.prototype.setOptions = function(newOptions) {
        return this.reobserve(newOptions);
    };
    ObservableQuery.prototype.silentSetOptions = function(newOptions) {
        var mergedOptions = (0, $2f3cebf1a05c1b38$export$8e16b83750b44988)(this.options, newOptions || {});
        $3118fa29bcf9f4b2$var$assign(this.options, mergedOptions);
    };
    /**
     * Update the variables of this observable query, and fetch the new results
     * if they've changed. Most users should prefer `refetch` instead of
     * `setVariables` in order to to be properly notified of results even when
     * they come from the cache.
     *
     * Note: the `next` callback will *not* fire if the variables have not changed
     * or if the result is coming from cache.
     *
     * Note: the promise will return the old results immediately if the variables
     * have not changed.
     *
     * Note: the promise will return null immediately if the query is not active
     * (there are no subscribers).
     *
     * @param variables - The new set of variables. If there are missing variables,
     * the previous values of those variables will be used.
     */ ObservableQuery.prototype.setVariables = function(variables) {
        if ((0, $a2b6f433e732b502$export$411ce8e5a71e3069)(this.variables, variables)) // If we have no observers, then we don't actually want to make a network
        // request. As soon as someone observes the query, the request will kick
        // off. For now, we just store any changes. (See #1077)
        return this.observers.size ? this.result() : Promise.resolve();
        this.options.variables = variables;
        // See comment above
        if (!this.observers.size) return Promise.resolve();
        return this.reobserve({
            // Reset options.fetchPolicy to its original value.
            fetchPolicy: this.options.initialFetchPolicy,
            variables: variables
        }, (0, $72c5140a632c7fa1$export$bd096ddbd246c79c).setVariables);
    };
    /**
     * A function that enables you to update the query's cached result without executing a followup GraphQL operation.
     *
     * See [using updateQuery and updateFragment](https://www.apollographql.com/docs/react/caching/cache-interaction/#using-updatequery-and-updatefragment) for additional information.
     */ ObservableQuery.prototype.updateQuery = function(mapFn) {
        var queryManager = this.queryManager;
        var result = queryManager.cache.diff({
            query: this.options.query,
            variables: this.variables,
            returnPartialData: true,
            optimistic: false
        }).result;
        var newResult = mapFn(result, {
            variables: this.variables
        });
        if (newResult) {
            queryManager.cache.writeQuery({
                query: this.options.query,
                data: newResult,
                variables: this.variables
            });
            queryManager.broadcastQueries();
        }
    };
    /**
     * A function that instructs the query to begin re-executing at a specified interval (in milliseconds).
     */ ObservableQuery.prototype.startPolling = function(pollInterval) {
        this.options.pollInterval = pollInterval;
        this.updatePolling();
    };
    /**
     * A function that instructs the query to stop polling after a previous call to `startPolling`.
     */ ObservableQuery.prototype.stopPolling = function() {
        this.options.pollInterval = 0;
        this.updatePolling();
    };
    // Update options.fetchPolicy according to options.nextFetchPolicy.
    ObservableQuery.prototype.applyNextFetchPolicy = function(reason, // It's possible to use this method to apply options.nextFetchPolicy to
    // options.fetchPolicy even if options !== this.options, though that happens
    // most often when the options are temporary, used for only one request and
    // then thrown away, so nextFetchPolicy may not end up mattering.
    options) {
        if (options.nextFetchPolicy) {
            var _a = options.fetchPolicy, fetchPolicy = _a === void 0 ? "cache-first" : _a, _b = options.initialFetchPolicy, initialFetchPolicy = _b === void 0 ? fetchPolicy : _b;
            if (fetchPolicy === "standby") ;
            else if (typeof options.nextFetchPolicy === "function") // When someone chooses "cache-and-network" or "network-only" as their
            // initial FetchPolicy, they often do not want future cache updates to
            // trigger unconditional network requests, which is what repeatedly
            // applying the "cache-and-network" or "network-only" policies would
            // seem to imply. Instead, when the cache reports an update after the
            // initial network request, it may be desirable for subsequent network
            // requests to be triggered only if the cache result is incomplete. To
            // that end, the options.nextFetchPolicy option provides an easy way to
            // update options.fetchPolicy after the initial network request, without
            // having to call observableQuery.setOptions.
            options.fetchPolicy = options.nextFetchPolicy(fetchPolicy, {
                reason: reason,
                options: options,
                observable: this,
                initialFetchPolicy: initialFetchPolicy
            });
            else if (reason === "variables-changed") options.fetchPolicy = initialFetchPolicy;
            else options.fetchPolicy = options.nextFetchPolicy;
        }
        return options.fetchPolicy;
    };
    ObservableQuery.prototype.fetch = function(options, newNetworkStatus, query) {
        // TODO Make sure we update the networkStatus (and infer fetchVariables)
        // before actually committing to the fetch.
        this.queryManager.setObservableQuery(this);
        return this.queryManager["fetchConcastWithInfo"](this.queryId, options, newNetworkStatus, query);
    };
    // Turns polling on or off based on this.options.pollInterval.
    ObservableQuery.prototype.updatePolling = function() {
        var _this = this;
        // Avoid polling in SSR mode
        if (this.queryManager.ssrMode) return;
        var _a = this, pollingInfo = _a.pollingInfo, pollInterval = _a.options.pollInterval;
        if (!pollInterval || !this.hasObservers()) {
            if (pollingInfo) {
                clearTimeout(pollingInfo.timeout);
                delete this.pollingInfo;
            }
            return;
        }
        if (pollingInfo && pollingInfo.interval === pollInterval) return;
        (0, $28d90d877eb1e517$export$f5708dca728d7177)(pollInterval, 23);
        var info = pollingInfo || (this.pollingInfo = {});
        info.interval = pollInterval;
        var maybeFetch = function() {
            var _a, _b;
            if (_this.pollingInfo) {
                if (!(0, $72c5140a632c7fa1$export$37509604341a3464)(_this.queryInfo.networkStatus) && !((_b = (_a = _this.options).skipPollAttempt) === null || _b === void 0 ? void 0 : _b.call(_a))) _this.reobserve({
                    // Most fetchPolicy options don't make sense to use in a polling context, as
                    // users wouldn't want to be polling the cache directly. However, network-only and
                    // no-cache are both useful for when the user wants to control whether or not the
                    // polled results are written to the cache.
                    fetchPolicy: _this.options.initialFetchPolicy === "no-cache" ? "no-cache" : "network-only"
                }, (0, $72c5140a632c7fa1$export$bd096ddbd246c79c).poll).then(poll, poll);
                else poll();
            }
        };
        var poll = function() {
            var info = _this.pollingInfo;
            if (info) {
                clearTimeout(info.timeout);
                info.timeout = setTimeout(maybeFetch, info.interval);
            }
        };
        poll();
    };
    ObservableQuery.prototype.updateLastResult = function(newResult, variables) {
        if (variables === void 0) variables = this.variables;
        var error = this.getLastError();
        // Preserve this.last.error unless the variables have changed.
        if (error && this.last && !(0, $a2b6f433e732b502$export$411ce8e5a71e3069)(variables, this.last.variables)) error = void 0;
        return this.last = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
            result: this.queryManager.assumeImmutableResults ? newResult : (0, $e398dba65b0b4cec$export$629a2bd3f5a49ecc)(newResult),
            variables: variables
        }, error ? {
            error: error
        } : null);
    };
    ObservableQuery.prototype.reobserveAsConcast = function(newOptions, newNetworkStatus) {
        var _this = this;
        this.isTornDown = false;
        var useDisposableConcast = // Refetching uses a disposable Concast to allow refetches using different
        // options/variables, without permanently altering the options of the
        // original ObservableQuery.
        newNetworkStatus === (0, $72c5140a632c7fa1$export$bd096ddbd246c79c).refetch || // The fetchMore method does not actually call the reobserve method, but,
        // if it did, it would definitely use a disposable Concast.
        newNetworkStatus === (0, $72c5140a632c7fa1$export$bd096ddbd246c79c).fetchMore || // Polling uses a disposable Concast so the polling options (which force
        // fetchPolicy to be "network-only" or "no-cache") won't override the original options.
        newNetworkStatus === (0, $72c5140a632c7fa1$export$bd096ddbd246c79c).poll;
        // Save the old variables, since Object.assign may modify them below.
        var oldVariables = this.options.variables;
        var oldFetchPolicy = this.options.fetchPolicy;
        var mergedOptions = (0, $2f3cebf1a05c1b38$export$8e16b83750b44988)(this.options, newOptions || {});
        var options = useDisposableConcast ? // Disposable Concast fetches receive a shallow copy of this.options
        // (merged with newOptions), leaving this.options unmodified.
        mergedOptions : $3118fa29bcf9f4b2$var$assign(this.options, mergedOptions);
        // Don't update options.query with the transformed query to avoid
        // overwriting this.options.query when we aren't using a disposable concast.
        // We want to ensure we can re-run the custom document transforms the next
        // time a request is made against the original query.
        var query = this.transformDocument(options.query);
        this.lastQuery = query;
        if (!useDisposableConcast) {
            // We can skip calling updatePolling if we're not changing this.options.
            this.updatePolling();
            // Reset options.fetchPolicy to its original value when variables change,
            // unless a new fetchPolicy was provided by newOptions.
            if (newOptions && newOptions.variables && !(0, $a2b6f433e732b502$export$411ce8e5a71e3069)(newOptions.variables, oldVariables) && // Don't mess with the fetchPolicy if it's currently "standby".
            options.fetchPolicy !== "standby" && // If we're changing the fetchPolicy anyway, don't try to change it here
            // using applyNextFetchPolicy. The explicit options.fetchPolicy wins.
            (options.fetchPolicy === oldFetchPolicy || // A `nextFetchPolicy` function has even higher priority, though,
            // so in that case `applyNextFetchPolicy` must be called.
            typeof options.nextFetchPolicy === "function")) {
                this.applyNextFetchPolicy("variables-changed", options);
                if (newNetworkStatus === void 0) newNetworkStatus = (0, $72c5140a632c7fa1$export$bd096ddbd246c79c).setVariables;
            }
        }
        this.waitForOwnResult && (this.waitForOwnResult = $3118fa29bcf9f4b2$var$skipCacheDataFor(options.fetchPolicy));
        var finishWaitingForOwnResult = function() {
            if (_this.concast === concast) _this.waitForOwnResult = false;
        };
        var variables = options.variables && (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, options.variables);
        var _a = this.fetch(options, newNetworkStatus, query), concast = _a.concast, fromLink = _a.fromLink;
        var observer = {
            next: function(result) {
                if ((0, $a2b6f433e732b502$export$411ce8e5a71e3069)(_this.variables, variables)) {
                    finishWaitingForOwnResult();
                    _this.reportResult(result, variables);
                }
            },
            error: function(error) {
                if ((0, $a2b6f433e732b502$export$411ce8e5a71e3069)(_this.variables, variables)) {
                    // Coming from `getResultsFromLink`, `error` here should always be an `ApolloError`.
                    // However, calling `concast.cancel` can inject another type of error, so we have to
                    // wrap it again here.
                    if (!(0, $456cf4c370166a0f$export$17f5e6bd290bb15d)(error)) error = new (0, $456cf4c370166a0f$export$26a337512320b8c6)({
                        networkError: error
                    });
                    finishWaitingForOwnResult();
                    _this.reportError(error, variables);
                }
            }
        };
        if (!useDisposableConcast && (fromLink || !this.concast)) {
            // We use the {add,remove}Observer methods directly to avoid wrapping
            // observer with an unnecessary SubscriptionObserver object.
            if (this.concast && this.observer) this.concast.removeObserver(this.observer);
            this.concast = concast;
            this.observer = observer;
        }
        concast.addObserver(observer);
        return concast;
    };
    ObservableQuery.prototype.reobserve = function(newOptions, newNetworkStatus) {
        return this.reobserveAsConcast(newOptions, newNetworkStatus).promise;
    };
    ObservableQuery.prototype.resubscribeAfterError = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        // If `lastError` is set in the current when the subscription is re-created,
        // the subscription will immediately receive the error, which will
        // cause it to terminate again. To avoid this, we first clear
        // the last error/result from the `observableQuery` before re-starting
        // the subscription, and restore the last value afterwards so that the
        // subscription has a chance to stay open.
        var last = this.last;
        this.resetLastResults();
        var subscription = this.subscribe.apply(this, args);
        this.last = last;
        return subscription;
    };
    // (Re)deliver the current result to this.observers without applying fetch
    // policies or making network requests.
    ObservableQuery.prototype.observe = function() {
        this.reportResult(// Passing false is important so that this.getCurrentResult doesn't
        // save the fetchMore result as this.lastResult, causing it to be
        // ignored due to the this.isDifferentFromLastResult check in
        // this.reportResult.
        this.getCurrentResult(false), this.variables);
    };
    ObservableQuery.prototype.reportResult = function(result, variables) {
        var lastError = this.getLastError();
        var isDifferent = this.isDifferentFromLastResult(result, variables);
        // Update the last result even when isDifferentFromLastResult returns false,
        // because the query may be using the @nonreactive directive, and we want to
        // save the the latest version of any nonreactive subtrees (in case
        // getCurrentResult is called), even though we skip broadcasting changes.
        if (lastError || !result.partial || this.options.returnPartialData) this.updateLastResult(result, variables);
        if (lastError || isDifferent) (0, $de072e4be1d4d57a$export$9f6c99ae166dbeca)(this.observers, "next", result);
    };
    ObservableQuery.prototype.reportError = function(error, variables) {
        // Since we don't get the current result on errors, only the error, we
        // must mirror the updates that occur in QueryStore.markQueryError here
        var errorResult = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, this.getLastResult()), {
            error: error,
            errors: error.graphQLErrors,
            networkStatus: (0, $72c5140a632c7fa1$export$bd096ddbd246c79c).error,
            loading: false
        });
        this.updateLastResult(errorResult, variables);
        (0, $de072e4be1d4d57a$export$9f6c99ae166dbeca)(this.observers, "error", this.last.error = error);
    };
    ObservableQuery.prototype.hasObservers = function() {
        return this.observers.size > 0;
    };
    ObservableQuery.prototype.tearDownQuery = function() {
        if (this.isTornDown) return;
        if (this.concast && this.observer) {
            this.concast.removeObserver(this.observer);
            delete this.concast;
            delete this.observer;
        }
        this.stopPolling();
        // stop all active GraphQL subscriptions
        this.subscriptions.forEach(function(sub) {
            return sub.unsubscribe();
        });
        this.subscriptions.clear();
        this.queryManager.stopQuery(this.queryId);
        this.observers.clear();
        this.isTornDown = true;
    };
    ObservableQuery.prototype.transformDocument = function(document) {
        return this.queryManager.transform(document);
    };
    return ObservableQuery;
}((0, $6d99a9de69717ea6$export$77cea355fa80b5f4));
// Necessary because the ObservableQuery constructor has a different
// signature than the Observable constructor.
(0, $af26a5afbde47a9e$export$33c8bd820eece9b2)($3118fa29bcf9f4b2$export$6c1b56eac59c9584);
function $3118fa29bcf9f4b2$export$419171d60552792a(obsQuery) {
    var _a = obsQuery.options, fetchPolicy = _a.fetchPolicy, nextFetchPolicy = _a.nextFetchPolicy;
    if (fetchPolicy === "cache-and-network" || fetchPolicy === "network-only") return obsQuery.reobserve({
        fetchPolicy: "cache-first",
        // Use a temporary nextFetchPolicy function that replaces itself with the
        // previous nextFetchPolicy value and returns the original fetchPolicy.
        nextFetchPolicy: function(currentFetchPolicy, context) {
            // Replace this nextFetchPolicy function in the options object with the
            // original this.options.nextFetchPolicy value.
            this.nextFetchPolicy = nextFetchPolicy;
            // If the original nextFetchPolicy value was a function, give it a
            // chance to decide what happens here.
            if (typeof this.nextFetchPolicy === "function") return this.nextFetchPolicy(currentFetchPolicy, context);
            // Otherwise go back to the original this.options.fetchPolicy.
            return fetchPolicy;
        }
    });
    return obsQuery.reobserve();
}
function $3118fa29bcf9f4b2$var$defaultSubscriptionObserverErrorCallback(error) {
    globalThis.__DEV__ !== false && (0, $28d90d877eb1e517$export$f5708dca728d7177).error(24, error.message, error.stack);
}
function $3118fa29bcf9f4b2$export$b7e1973aacac3ae7(missing) {
    if (globalThis.__DEV__ !== false && missing) globalThis.__DEV__ !== false && (0, $28d90d877eb1e517$export$f5708dca728d7177).debug(25, missing);
}
function $3118fa29bcf9f4b2$var$skipCacheDataFor(fetchPolicy /* `undefined` would mean `"cache-first"` */ ) {
    return fetchPolicy === "network-only" || fetchPolicy === "no-cache" || fetchPolicy === "standby";
}








var $f8e7d4b4bf21978e$var$destructiveMethodCounts = new ((0, $5d0a073f980bb2a3$export$772fbc04a0ad4ce9) ? WeakMap : Map)();
function $f8e7d4b4bf21978e$var$wrapDestructiveCacheMethod(cache, methodName) {
    var original = cache[methodName];
    if (typeof original === "function") // @ts-expect-error this is just too generic to be typed correctly
    cache[methodName] = function() {
        $f8e7d4b4bf21978e$var$destructiveMethodCounts.set(cache, // The %1e15 allows the count to wrap around to 0 safely every
        // quadrillion evictions, so there's no risk of overflow. To be
        // clear, this is more of a pedantic principle than something
        // that matters in any conceivable practical scenario.
        ($f8e7d4b4bf21978e$var$destructiveMethodCounts.get(cache) + 1) % 1e15);
        // @ts-expect-error this is just too generic to be typed correctly
        return original.apply(this, arguments);
    };
}
function $f8e7d4b4bf21978e$var$cancelNotifyTimeout(info) {
    if (info["notifyTimeout"]) {
        clearTimeout(info["notifyTimeout"]);
        info["notifyTimeout"] = void 0;
    }
}
// A QueryInfo object represents a single query managed by the
// QueryManager, which tracks all QueryInfo objects by queryId in its
// this.queries Map. QueryInfo objects store the latest results and errors
// for the given query, and are responsible for reporting those results to
// the corresponding ObservableQuery, via the QueryInfo.notify method.
// Results are reported asynchronously whenever setDiff marks the
// QueryInfo object as dirty, though a call to the QueryManager's
// broadcastQueries method may trigger the notification before it happens
// automatically. This class used to be a simple interface type without
// any field privacy or meaningful methods, which is why it still has so
// many public fields. The effort to lock down and simplify the QueryInfo
// interface is ongoing, and further improvements are welcome.
var $f8e7d4b4bf21978e$export$79a6120a39c90b6a = /** @class */ function() {
    function QueryInfo(queryManager, queryId) {
        if (queryId === void 0) queryId = queryManager.generateQueryId();
        this.queryId = queryId;
        this.listeners = new Set();
        this.document = null;
        this.lastRequestId = 1;
        this.stopped = false;
        this.dirty = false;
        this.observableQuery = null;
        var cache = this.cache = queryManager.cache;
        // Track how often cache.evict is called, since we want eviction to
        // override the feud-stopping logic in the markResult method, by
        // causing shouldWrite to return true. Wrapping the cache.evict method
        // is a bit of a hack, but it saves us from having to make eviction
        // counting an official part of the ApolloCache API.
        if (!$f8e7d4b4bf21978e$var$destructiveMethodCounts.has(cache)) {
            $f8e7d4b4bf21978e$var$destructiveMethodCounts.set(cache, 0);
            $f8e7d4b4bf21978e$var$wrapDestructiveCacheMethod(cache, "evict");
            $f8e7d4b4bf21978e$var$wrapDestructiveCacheMethod(cache, "modify");
            $f8e7d4b4bf21978e$var$wrapDestructiveCacheMethod(cache, "reset");
        }
    }
    QueryInfo.prototype.init = function(query) {
        var networkStatus = query.networkStatus || (0, $72c5140a632c7fa1$export$bd096ddbd246c79c).loading;
        if (this.variables && this.networkStatus !== (0, $72c5140a632c7fa1$export$bd096ddbd246c79c).loading && !(0, $a2b6f433e732b502$export$411ce8e5a71e3069)(this.variables, query.variables)) networkStatus = (0, $72c5140a632c7fa1$export$bd096ddbd246c79c).setVariables;
        if (!(0, $a2b6f433e732b502$export$411ce8e5a71e3069)(query.variables, this.variables)) this.lastDiff = void 0;
        Object.assign(this, {
            document: query.document,
            variables: query.variables,
            networkError: null,
            graphQLErrors: this.graphQLErrors || [],
            networkStatus: networkStatus
        });
        if (query.observableQuery) this.setObservableQuery(query.observableQuery);
        if (query.lastRequestId) this.lastRequestId = query.lastRequestId;
        return this;
    };
    QueryInfo.prototype.reset = function() {
        $f8e7d4b4bf21978e$var$cancelNotifyTimeout(this);
        this.dirty = false;
    };
    QueryInfo.prototype.resetDiff = function() {
        this.lastDiff = void 0;
    };
    QueryInfo.prototype.getDiff = function() {
        var options = this.getDiffOptions();
        if (this.lastDiff && (0, $a2b6f433e732b502$export$411ce8e5a71e3069)(options, this.lastDiff.options)) return this.lastDiff.diff;
        this.updateWatch(this.variables);
        var oq = this.observableQuery;
        if (oq && oq.options.fetchPolicy === "no-cache") return {
            complete: false
        };
        var diff = this.cache.diff(options);
        this.updateLastDiff(diff, options);
        return diff;
    };
    QueryInfo.prototype.updateLastDiff = function(diff, options) {
        this.lastDiff = diff ? {
            diff: diff,
            options: options || this.getDiffOptions()
        } : void 0;
    };
    QueryInfo.prototype.getDiffOptions = function(variables) {
        var _a;
        if (variables === void 0) variables = this.variables;
        return {
            query: this.document,
            variables: variables,
            returnPartialData: true,
            optimistic: true,
            canonizeResults: (_a = this.observableQuery) === null || _a === void 0 ? void 0 : _a.options.canonizeResults
        };
    };
    QueryInfo.prototype.setDiff = function(diff) {
        var _this = this;
        var _a;
        var oldDiff = this.lastDiff && this.lastDiff.diff;
        // If we are trying to deliver an incomplete cache result, we avoid
        // reporting it if the query has errored, otherwise we let the broadcast try
        // and repair the partial result by refetching the query. This check avoids
        // a situation where a query that errors and another succeeds with
        // overlapping data does not report the partial data result to the errored
        // query.
        //
        // See https://github.com/apollographql/apollo-client/issues/11400 for more
        // information on this issue.
        if (diff && !diff.complete && ((_a = this.observableQuery) === null || _a === void 0 ? void 0 : _a.getLastError())) return;
        this.updateLastDiff(diff);
        if (!this.dirty && !(0, $a2b6f433e732b502$export$411ce8e5a71e3069)(oldDiff && oldDiff.result, diff && diff.result)) {
            this.dirty = true;
            if (!this.notifyTimeout) this.notifyTimeout = setTimeout(function() {
                return _this.notify();
            }, 0);
        }
    };
    QueryInfo.prototype.setObservableQuery = function(oq) {
        var _this = this;
        if (oq === this.observableQuery) return;
        if (this.oqListener) this.listeners.delete(this.oqListener);
        this.observableQuery = oq;
        if (oq) {
            oq["queryInfo"] = this;
            this.listeners.add(this.oqListener = function() {
                var diff = _this.getDiff();
                if (diff.fromOptimisticTransaction) // If this diff came from an optimistic transaction, deliver the
                // current cache data to the ObservableQuery, but don't perform a
                // reobservation, since oq.reobserveCacheFirst might make a network
                // request, and we never want to trigger network requests in the
                // middle of optimistic updates.
                oq["observe"]();
                else // Otherwise, make the ObservableQuery "reobserve" the latest data
                // using a temporary fetch policy of "cache-first", so complete cache
                // results have a chance to be delivered without triggering additional
                // network requests, even when options.fetchPolicy is "network-only"
                // or "cache-and-network". All other fetch policies are preserved by
                // this method, and are handled by calling oq.reobserve(). If this
                // reobservation is spurious, isDifferentFromLastResult still has a
                // chance to catch it before delivery to ObservableQuery subscribers.
                (0, $3118fa29bcf9f4b2$export$419171d60552792a)(oq);
            });
        } else delete this.oqListener;
    };
    QueryInfo.prototype.notify = function() {
        var _this = this;
        $f8e7d4b4bf21978e$var$cancelNotifyTimeout(this);
        if (this.shouldNotify()) this.listeners.forEach(function(listener) {
            return listener(_this);
        });
        this.dirty = false;
    };
    QueryInfo.prototype.shouldNotify = function() {
        if (!this.dirty || !this.listeners.size) return false;
        if ((0, $72c5140a632c7fa1$export$37509604341a3464)(this.networkStatus) && this.observableQuery) {
            var fetchPolicy = this.observableQuery.options.fetchPolicy;
            if (fetchPolicy !== "cache-only" && fetchPolicy !== "cache-and-network") return false;
        }
        return true;
    };
    QueryInfo.prototype.stop = function() {
        if (!this.stopped) {
            this.stopped = true;
            // Cancel the pending notify timeout
            this.reset();
            this.cancel();
            // Revert back to the no-op version of cancel inherited from
            // QueryInfo.prototype.
            this.cancel = QueryInfo.prototype.cancel;
            var oq = this.observableQuery;
            if (oq) oq.stopPolling();
        }
    };
    // This method is a no-op by default, until/unless overridden by the
    // updateWatch method.
    QueryInfo.prototype.cancel = function() {};
    QueryInfo.prototype.updateWatch = function(variables) {
        var _this = this;
        if (variables === void 0) variables = this.variables;
        var oq = this.observableQuery;
        if (oq && oq.options.fetchPolicy === "no-cache") return;
        var watchOptions = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, this.getDiffOptions(variables)), {
            watcher: this,
            callback: function(diff) {
                return _this.setDiff(diff);
            }
        });
        if (!this.lastWatch || !(0, $a2b6f433e732b502$export$411ce8e5a71e3069)(watchOptions, this.lastWatch)) {
            this.cancel();
            this.cancel = this.cache.watch(this.lastWatch = watchOptions);
        }
    };
    QueryInfo.prototype.resetLastWrite = function() {
        this.lastWrite = void 0;
    };
    QueryInfo.prototype.shouldWrite = function(result, variables) {
        var lastWrite = this.lastWrite;
        return !(lastWrite && // If cache.evict has been called since the last time we wrote this
        // data into the cache, there's a chance writing this result into
        // the cache will repair what was evicted.
        lastWrite.dmCount === $f8e7d4b4bf21978e$var$destructiveMethodCounts.get(this.cache) && (0, $a2b6f433e732b502$export$411ce8e5a71e3069)(variables, lastWrite.variables) && (0, $a2b6f433e732b502$export$411ce8e5a71e3069)(result.data, lastWrite.result.data));
    };
    QueryInfo.prototype.markResult = function(result, document, options, cacheWriteBehavior) {
        var _this = this;
        var merger = new (0, $0217b27a7999d1ae$export$509e11c221f576c0)();
        var graphQLErrors = (0, $e6aaa0e65613edd7$export$d307f5934e447d0e)(result.errors) ? result.errors.slice(0) : [];
        // Cancel the pending notify timeout (if it exists) to prevent extraneous network
        // requests. To allow future notify timeouts, diff and dirty are reset as well.
        this.reset();
        if ("incremental" in result && (0, $e6aaa0e65613edd7$export$d307f5934e447d0e)(result.incremental)) {
            var mergedData = (0, $4753a78f97af1d82$export$9a905f57d6393874)(this.getDiff().result, result);
            result.data = mergedData;
        // Detect the first chunk of a deferred query and merge it with existing
        // cache data. This ensures a `cache-first` fetch policy that returns
        // partial cache data or a `cache-and-network` fetch policy that already
        // has full data in the cache does not complain when trying to merge the
        // initial deferred server data with existing cache data.
        } else if ("hasNext" in result && result.hasNext) {
            var diff = this.getDiff();
            result.data = merger.merge(diff.result, result.data);
        }
        this.graphQLErrors = graphQLErrors;
        if (options.fetchPolicy === "no-cache") this.updateLastDiff({
            result: result.data,
            complete: true
        }, this.getDiffOptions(options.variables));
        else if (cacheWriteBehavior !== 0 /* CacheWriteBehavior.FORBID */ ) {
            if ($f8e7d4b4bf21978e$export$5f47a9fb9a521654(result, options.errorPolicy)) // Using a transaction here so we have a chance to read the result
            // back from the cache before the watch callback fires as a result
            // of writeQuery, so we can store the new diff quietly and ignore
            // it when we receive it redundantly from the watch callback.
            this.cache.performTransaction(function(cache) {
                if (_this.shouldWrite(result, options.variables)) {
                    cache.writeQuery({
                        query: document,
                        data: result.data,
                        variables: options.variables,
                        overwrite: cacheWriteBehavior === 1 /* CacheWriteBehavior.OVERWRITE */ 
                    });
                    _this.lastWrite = {
                        result: result,
                        variables: options.variables,
                        dmCount: $f8e7d4b4bf21978e$var$destructiveMethodCounts.get(_this.cache)
                    };
                } else // If result is the same as the last result we received from
                // the network (and the variables match too), avoid writing
                // result into the cache again. The wisdom of skipping this
                // cache write is far from obvious, since any cache write
                // could be the one that puts the cache back into a desired
                // state, fixing corruption or missing data. However, if we
                // always write every network result into the cache, we enable
                // feuds between queries competing to update the same data in
                // incompatible ways, which can lead to an endless cycle of
                // cache broadcasts and useless network requests. As with any
                // feud, eventually one side must step back from the brink,
                // letting the other side(s) have the last word(s). There may
                // be other points where we could break this cycle, such as
                // silencing the broadcast for cache.writeQuery (not a good
                // idea, since it just delays the feud a bit) or somehow
                // avoiding the network request that just happened (also bad,
                // because the server could return useful new data). All
                // options considered, skipping this cache write seems to be
                // the least damaging place to break the cycle, because it
                // reflects the intuition that we recently wrote this exact
                // result into the cache, so the cache *should* already/still
                // contain this data. If some other query has clobbered that
                // data in the meantime, that's too bad, but there will be no
                // winners if every query blindly reverts to its own version
                // of the data. This approach also gives the network a chance
                // to return new data, which will be written into the cache as
                // usual, notifying only those queries that are directly
                // affected by the cache updates, as usual. In the future, an
                // even more sophisticated cache could perhaps prevent or
                // mitigate the clobbering somehow, but that would make this
                // particular cache write even less important, and thus
                // skipping it would be even safer than it is today.
                if (_this.lastDiff && _this.lastDiff.diff.complete) {
                    // Reuse data from the last good (complete) diff that we
                    // received, when possible.
                    result.data = _this.lastDiff.diff.result;
                    return;
                }
                var diffOptions = _this.getDiffOptions(options.variables);
                var diff = cache.diff(diffOptions);
                // In case the QueryManager stops this QueryInfo before its
                // results are delivered, it's important to avoid restarting the
                // cache watch when markResult is called. We also avoid updating
                // the watch if we are writing a result that doesn't match the current
                // variables to avoid race conditions from broadcasting the wrong
                // result.
                if (!_this.stopped && (0, $a2b6f433e732b502$export$411ce8e5a71e3069)(_this.variables, options.variables)) // Any time we're about to update this.diff, we need to make
                // sure we've started watching the cache.
                _this.updateWatch(options.variables);
                // If we're allowed to write to the cache, and we can read a
                // complete result from the cache, update result.data to be the
                // result from the cache, rather than the raw network result.
                // Set without setDiff to avoid triggering a notify call, since
                // we have other ways of notifying for this result.
                _this.updateLastDiff(diff, diffOptions);
                if (diff.complete) result.data = diff.result;
            });
            else this.lastWrite = void 0;
        }
    };
    QueryInfo.prototype.markReady = function() {
        this.networkError = null;
        return this.networkStatus = (0, $72c5140a632c7fa1$export$bd096ddbd246c79c).ready;
    };
    QueryInfo.prototype.markError = function(error) {
        this.networkStatus = (0, $72c5140a632c7fa1$export$bd096ddbd246c79c).error;
        this.lastWrite = void 0;
        this.reset();
        if (error.graphQLErrors) this.graphQLErrors = error.graphQLErrors;
        if (error.networkError) this.networkError = error.networkError;
        return error;
    };
    return QueryInfo;
}();
function $f8e7d4b4bf21978e$export$5f47a9fb9a521654(result, errorPolicy) {
    if (errorPolicy === void 0) errorPolicy = "none";
    var ignoreErrors = errorPolicy === "ignore" || errorPolicy === "all";
    var writeWithErrors = !(0, $5333c7f04e9cca43$export$b4df399e879e53ab)(result);
    if (!writeWithErrors && ignoreErrors && result.data) writeWithErrors = true;
    return writeWithErrors;
}



var $957978b378afd274$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $957978b378afd274$var$IGNORE = Object.create(null);
var $957978b378afd274$export$b986383a50b53ea4 = /** @class */ function() {
    function QueryManager(options) {
        var _this = this;
        this.clientAwareness = {};
        // All the queries that the QueryManager is currently managing (not
        // including mutations and subscriptions).
        this.queries = new Map();
        // Maps from queryId strings to Promise rejection functions for
        // currently active queries and fetches.
        // Use protected instead of private field so
        // @apollo/experimental-nextjs-app-support can access type info.
        this.fetchCancelFns = new Map();
        this.transformCache = new (0, $b3ac5bdec858bda0$export$8dbad6f439bb2331)((0, $c506be9be1a65610$export$f29926b23b28936b)["queryManager.getDocumentInfo"] || 2000 /* defaultCacheSizes["queryManager.getDocumentInfo"] */ );
        this.queryIdCounter = 1;
        this.requestIdCounter = 1;
        this.mutationIdCounter = 1;
        // Use protected instead of private field so
        // @apollo/experimental-nextjs-app-support can access type info.
        this.inFlightLinkObservables = new (0, $02443dfd16cf74b4$export$73571c50d0f2507e)(false);
        var defaultDocumentTransform = new (0, $2e04132f91cc06f1$export$f887060e48e5dc1b)(function(document) {
            return _this.cache.transformDocument(document);
        }, // Allow the apollo cache to manage its own transform caches
        {
            cache: false
        });
        this.cache = options.cache;
        this.link = options.link;
        this.defaultOptions = options.defaultOptions;
        this.queryDeduplication = options.queryDeduplication;
        this.clientAwareness = options.clientAwareness;
        this.localState = options.localState;
        this.ssrMode = options.ssrMode;
        this.assumeImmutableResults = options.assumeImmutableResults;
        var documentTransform = options.documentTransform;
        this.documentTransform = documentTransform ? defaultDocumentTransform.concat(documentTransform)// The custom document transform may add new fragment spreads or new
        // field selections, so we want to give the cache a chance to run
        // again. For example, the InMemoryCache adds __typename to field
        // selections and fragments from the fragment registry.
        .concat(defaultDocumentTransform) : defaultDocumentTransform;
        this.defaultContext = options.defaultContext || Object.create(null);
        if (this.onBroadcast = options.onBroadcast) this.mutationStore = Object.create(null);
    }
    /**
     * Call this method to terminate any active query processes, making it safe
     * to dispose of this QueryManager instance.
     */ QueryManager.prototype.stop = function() {
        var _this = this;
        this.queries.forEach(function(_info, queryId) {
            _this.stopQueryNoBroadcast(queryId);
        });
        this.cancelPendingFetches((0, $28d90d877eb1e517$export$3991762405098ea)(26));
    };
    QueryManager.prototype.cancelPendingFetches = function(error) {
        this.fetchCancelFns.forEach(function(cancel) {
            return cancel(error);
        });
        this.fetchCancelFns.clear();
    };
    QueryManager.prototype.mutate = function(_a) {
        return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(this, arguments, void 0, function(_b) {
            var mutationId, hasClientExports, mutationStoreValue, isOptimistic, self;
            var _c, _d;
            var mutation = _b.mutation, variables = _b.variables, optimisticResponse = _b.optimisticResponse, updateQueries = _b.updateQueries, _e = _b.refetchQueries, refetchQueries = _e === void 0 ? [] : _e, _f = _b.awaitRefetchQueries, awaitRefetchQueries = _f === void 0 ? false : _f, updateWithProxyFn = _b.update, onQueryUpdated = _b.onQueryUpdated, _g = _b.fetchPolicy, fetchPolicy = _g === void 0 ? ((_c = this.defaultOptions.mutate) === null || _c === void 0 ? void 0 : _c.fetchPolicy) || "network-only" : _g, _h = _b.errorPolicy, errorPolicy = _h === void 0 ? ((_d = this.defaultOptions.mutate) === null || _d === void 0 ? void 0 : _d.errorPolicy) || "none" : _h, keepRootFields = _b.keepRootFields, context = _b.context;
            return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_j) {
                switch(_j.label){
                    case 0:
                        (0, $28d90d877eb1e517$export$f5708dca728d7177)(mutation, 27);
                        (0, $28d90d877eb1e517$export$f5708dca728d7177)(fetchPolicy === "network-only" || fetchPolicy === "no-cache", 28);
                        mutationId = this.generateMutationId();
                        mutation = this.cache.transformForLink(this.transform(mutation));
                        hasClientExports = this.getDocumentInfo(mutation).hasClientExports;
                        variables = this.getVariables(mutation, variables);
                        if (!hasClientExports) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            this.localState.addExportedVariables(mutation, variables, context)
                        ];
                    case 1:
                        variables = _j.sent();
                        _j.label = 2;
                    case 2:
                        mutationStoreValue = this.mutationStore && (this.mutationStore[mutationId] = {
                            mutation: mutation,
                            variables: variables,
                            loading: true,
                            error: null
                        });
                        isOptimistic = optimisticResponse && this.markMutationOptimistic(optimisticResponse, {
                            mutationId: mutationId,
                            document: mutation,
                            variables: variables,
                            fetchPolicy: fetchPolicy,
                            errorPolicy: errorPolicy,
                            context: context,
                            updateQueries: updateQueries,
                            update: updateWithProxyFn,
                            keepRootFields: keepRootFields
                        });
                        this.broadcastQueries();
                        self = this;
                        return [
                            2 /*return*/ ,
                            new Promise(function(resolve, reject) {
                                return (0, $558b9f91eb7bf726$export$707ee4c4c95d39e3)(self.getObservableFromLink(mutation, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, context), {
                                    optimisticResponse: isOptimistic ? optimisticResponse : void 0
                                }), variables, {}, false), function(result) {
                                    if ((0, $5333c7f04e9cca43$export$b4df399e879e53ab)(result) && errorPolicy === "none") throw new (0, $456cf4c370166a0f$export$26a337512320b8c6)({
                                        graphQLErrors: (0, $5333c7f04e9cca43$export$a163557155188b6e)(result)
                                    });
                                    if (mutationStoreValue) {
                                        mutationStoreValue.loading = false;
                                        mutationStoreValue.error = null;
                                    }
                                    var storeResult = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, result);
                                    if (typeof refetchQueries === "function") refetchQueries = refetchQueries(storeResult);
                                    if (errorPolicy === "ignore" && (0, $5333c7f04e9cca43$export$b4df399e879e53ab)(storeResult)) delete storeResult.errors;
                                    return self.markMutationResult({
                                        mutationId: mutationId,
                                        result: storeResult,
                                        document: mutation,
                                        variables: variables,
                                        fetchPolicy: fetchPolicy,
                                        errorPolicy: errorPolicy,
                                        context: context,
                                        update: updateWithProxyFn,
                                        updateQueries: updateQueries,
                                        awaitRefetchQueries: awaitRefetchQueries,
                                        refetchQueries: refetchQueries,
                                        removeOptimistic: isOptimistic ? mutationId : void 0,
                                        onQueryUpdated: onQueryUpdated,
                                        keepRootFields: keepRootFields
                                    });
                                }).subscribe({
                                    next: function(storeResult) {
                                        self.broadcastQueries();
                                        // Since mutations might receive multiple payloads from the
                                        // ApolloLink chain (e.g. when used with @defer),
                                        // we resolve with a SingleExecutionResult or after the final
                                        // ExecutionPatchResult has arrived and we have assembled the
                                        // multipart response into a single result.
                                        if (!("hasNext" in storeResult) || storeResult.hasNext === false) resolve(storeResult);
                                    },
                                    error: function(err) {
                                        if (mutationStoreValue) {
                                            mutationStoreValue.loading = false;
                                            mutationStoreValue.error = err;
                                        }
                                        if (isOptimistic) self.cache.removeOptimistic(mutationId);
                                        self.broadcastQueries();
                                        reject(err instanceof (0, $456cf4c370166a0f$export$26a337512320b8c6) ? err : new (0, $456cf4c370166a0f$export$26a337512320b8c6)({
                                            networkError: err
                                        }));
                                    }
                                });
                            })
                        ];
                }
            });
        });
    };
    QueryManager.prototype.markMutationResult = function(mutation, cache) {
        var _this = this;
        if (cache === void 0) cache = this.cache;
        var result = mutation.result;
        var cacheWrites = [];
        var skipCache = mutation.fetchPolicy === "no-cache";
        if (!skipCache && (0, $f8e7d4b4bf21978e$export$5f47a9fb9a521654)(result, mutation.errorPolicy)) {
            if (!(0, $4753a78f97af1d82$export$879767c5cdf33cb3)(result)) cacheWrites.push({
                result: result.data,
                dataId: "ROOT_MUTATION",
                query: mutation.document,
                variables: mutation.variables
            });
            if ((0, $4753a78f97af1d82$export$879767c5cdf33cb3)(result) && (0, $e6aaa0e65613edd7$export$d307f5934e447d0e)(result.incremental)) {
                var diff = cache.diff({
                    id: "ROOT_MUTATION",
                    // The cache complains if passed a mutation where it expects a
                    // query, so we transform mutations and subscriptions to queries
                    // (only once, thanks to this.transformCache).
                    query: this.getDocumentInfo(mutation.document).asQuery,
                    variables: mutation.variables,
                    optimistic: false,
                    returnPartialData: true
                });
                var mergedData = void 0;
                if (diff.result) mergedData = (0, $4753a78f97af1d82$export$9a905f57d6393874)(diff.result, result);
                if (typeof mergedData !== "undefined") {
                    // cast the ExecutionPatchResult to FetchResult here since
                    // ExecutionPatchResult never has `data` when returned from the server
                    result.data = mergedData;
                    cacheWrites.push({
                        result: mergedData,
                        dataId: "ROOT_MUTATION",
                        query: mutation.document,
                        variables: mutation.variables
                    });
                }
            }
            var updateQueries_1 = mutation.updateQueries;
            if (updateQueries_1) this.queries.forEach(function(_a, queryId) {
                var observableQuery = _a.observableQuery;
                var queryName = observableQuery && observableQuery.queryName;
                if (!queryName || !$957978b378afd274$var$hasOwnProperty.call(updateQueries_1, queryName)) return;
                var updater = updateQueries_1[queryName];
                var _b = _this.queries.get(queryId), document = _b.document, variables = _b.variables;
                // Read the current query result from the store.
                var _c = cache.diff({
                    query: document,
                    variables: variables,
                    returnPartialData: true,
                    optimistic: false
                }), currentQueryResult = _c.result, complete = _c.complete;
                if (complete && currentQueryResult) {
                    // Run our reducer using the current query result and the mutation result.
                    var nextQueryResult = updater(currentQueryResult, {
                        mutationResult: result,
                        queryName: document && (0, $818d93327cb72c29$export$41bca9dc6871dd4e)(document) || void 0,
                        queryVariables: variables
                    });
                    // Write the modified result back into the store if we got a new result.
                    if (nextQueryResult) cacheWrites.push({
                        result: nextQueryResult,
                        dataId: "ROOT_QUERY",
                        query: document,
                        variables: variables
                    });
                }
            });
        }
        if (cacheWrites.length > 0 || (mutation.refetchQueries || "").length > 0 || mutation.update || mutation.onQueryUpdated || mutation.removeOptimistic) {
            var results_1 = [];
            this.refetchQueries({
                updateCache: function(cache) {
                    if (!skipCache) cacheWrites.forEach(function(write) {
                        return cache.write(write);
                    });
                    // If the mutation has some writes associated with it then we need to
                    // apply those writes to the store by running this reducer again with
                    // a write action.
                    var update = mutation.update;
                    // Determine whether result is a SingleExecutionResult,
                    // or the final ExecutionPatchResult.
                    var isFinalResult = !(0, $4753a78f97af1d82$export$f90dc0a3531b8b83)(result) || (0, $4753a78f97af1d82$export$879767c5cdf33cb3)(result) && !result.hasNext;
                    if (update) {
                        if (!skipCache) {
                            // Re-read the ROOT_MUTATION data we just wrote into the cache
                            // (the first cache.write call in the cacheWrites.forEach loop
                            // above), so field read functions have a chance to run for
                            // fields within mutation result objects.
                            var diff = cache.diff({
                                id: "ROOT_MUTATION",
                                // The cache complains if passed a mutation where it expects a
                                // query, so we transform mutations and subscriptions to queries
                                // (only once, thanks to this.transformCache).
                                query: _this.getDocumentInfo(mutation.document).asQuery,
                                variables: mutation.variables,
                                optimistic: false,
                                returnPartialData: true
                            });
                            if (diff.complete) {
                                result = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, result), {
                                    data: diff.result
                                });
                                if ("incremental" in result) delete result.incremental;
                                if ("hasNext" in result) delete result.hasNext;
                            }
                        }
                        // If we've received the whole response,
                        // either a SingleExecutionResult or the final ExecutionPatchResult,
                        // call the update function.
                        if (isFinalResult) update(cache, result, {
                            context: mutation.context,
                            variables: mutation.variables
                        });
                    }
                    // TODO Do this with cache.evict({ id: 'ROOT_MUTATION' }) but make it
                    // shallow to allow rolling back optimistic evictions.
                    if (!skipCache && !mutation.keepRootFields && isFinalResult) cache.modify({
                        id: "ROOT_MUTATION",
                        fields: function(value, _a) {
                            var fieldName = _a.fieldName, DELETE = _a.DELETE;
                            return fieldName === "__typename" ? value : DELETE;
                        }
                    });
                },
                include: mutation.refetchQueries,
                // Write the final mutation.result to the root layer of the cache.
                optimistic: false,
                // Remove the corresponding optimistic layer at the same time as we
                // write the final non-optimistic result.
                removeOptimistic: mutation.removeOptimistic,
                // Let the caller of client.mutate optionally determine the refetching
                // behavior for watched queries after the mutation.update function runs.
                // If no onQueryUpdated function was provided for this mutation, pass
                // null instead of undefined to disable the default refetching behavior.
                onQueryUpdated: mutation.onQueryUpdated || null
            }).forEach(function(result) {
                return results_1.push(result);
            });
            if (mutation.awaitRefetchQueries || mutation.onQueryUpdated) // Returning a promise here makes the mutation await that promise, so we
            // include results in that promise's work if awaitRefetchQueries or an
            // onQueryUpdated function was specified.
            return Promise.all(results_1).then(function() {
                return result;
            });
        }
        return Promise.resolve(result);
    };
    QueryManager.prototype.markMutationOptimistic = function(optimisticResponse, mutation) {
        var _this = this;
        var data = typeof optimisticResponse === "function" ? optimisticResponse(mutation.variables, {
            IGNORE: $957978b378afd274$var$IGNORE
        }) : optimisticResponse;
        if (data === $957978b378afd274$var$IGNORE) return false;
        this.cache.recordOptimisticTransaction(function(cache) {
            try {
                _this.markMutationResult((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, mutation), {
                    result: {
                        data: data
                    }
                }), cache);
            } catch (error) {
                globalThis.__DEV__ !== false && (0, $28d90d877eb1e517$export$f5708dca728d7177).error(error);
            }
        }, mutation.mutationId);
        return true;
    };
    QueryManager.prototype.fetchQuery = function(queryId, options, networkStatus) {
        return this.fetchConcastWithInfo(queryId, options, networkStatus).concast.promise;
    };
    QueryManager.prototype.getQueryStore = function() {
        var store = Object.create(null);
        this.queries.forEach(function(info, queryId) {
            store[queryId] = {
                variables: info.variables,
                networkStatus: info.networkStatus,
                networkError: info.networkError,
                graphQLErrors: info.graphQLErrors
            };
        });
        return store;
    };
    QueryManager.prototype.resetErrors = function(queryId) {
        var queryInfo = this.queries.get(queryId);
        if (queryInfo) {
            queryInfo.networkError = undefined;
            queryInfo.graphQLErrors = [];
        }
    };
    QueryManager.prototype.transform = function(document) {
        return this.documentTransform.transformDocument(document);
    };
    QueryManager.prototype.getDocumentInfo = function(document) {
        var transformCache = this.transformCache;
        if (!transformCache.has(document)) {
            var cacheEntry = {
                // TODO These three calls (hasClientExports, shouldForceResolvers, and
                // usesNonreactiveDirective) are performing independent full traversals
                // of the transformed document. We should consider merging these
                // traversals into a single pass in the future, though the work is
                // cached after the first time.
                hasClientExports: (0, $89c1eec09879e1ca$export$8d1e9e5bbfa5d09a)(document),
                hasForcedResolvers: this.localState.shouldForceResolvers(document),
                hasNonreactiveDirective: (0, $89c1eec09879e1ca$export$2dafb573e282fe8d)([
                    "nonreactive"
                ], document),
                clientQuery: this.localState.clientQuery(document),
                serverQuery: (0, $202b8a19e6086c64$export$e5ae0530da5fe96c)([
                    {
                        name: "client",
                        remove: true
                    },
                    {
                        name: "connection"
                    },
                    {
                        name: "nonreactive"
                    }
                ], document),
                defaultVars: (0, $818d93327cb72c29$export$84c19026e616569e)((0, $818d93327cb72c29$export$7a5b1fa979d2c158)(document)),
                // Transform any mutation or subscription operations to query operations
                // so we can read/write them from/to the cache.
                asQuery: (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, document), {
                    definitions: document.definitions.map(function(def) {
                        if (def.kind === "OperationDefinition" && def.operation !== "query") return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, def), {
                            operation: "query"
                        });
                        return def;
                    })
                })
            };
            transformCache.set(document, cacheEntry);
        }
        return transformCache.get(document);
    };
    QueryManager.prototype.getVariables = function(document, variables) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, this.getDocumentInfo(document).defaultVars), variables);
    };
    QueryManager.prototype.watchQuery = function(options) {
        var query = this.transform(options.query);
        // assign variable default values if supplied
        // NOTE: We don't modify options.query here with the transformed query to
        // ensure observable.options.query is set to the raw untransformed query.
        options = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, options), {
            variables: this.getVariables(query, options.variables)
        });
        if (typeof options.notifyOnNetworkStatusChange === "undefined") options.notifyOnNetworkStatusChange = false;
        var queryInfo = new (0, $f8e7d4b4bf21978e$export$79a6120a39c90b6a)(this);
        var observable = new (0, $3118fa29bcf9f4b2$export$6c1b56eac59c9584)({
            queryManager: this,
            queryInfo: queryInfo,
            options: options
        });
        observable["lastQuery"] = query;
        this.queries.set(observable.queryId, queryInfo);
        // We give queryInfo the transformed query to ensure the first cache diff
        // uses the transformed query instead of the raw query
        queryInfo.init({
            document: query,
            observableQuery: observable,
            variables: observable.variables
        });
        return observable;
    };
    QueryManager.prototype.query = function(options, queryId) {
        var _this = this;
        if (queryId === void 0) queryId = this.generateQueryId();
        (0, $28d90d877eb1e517$export$f5708dca728d7177)(options.query, 29);
        (0, $28d90d877eb1e517$export$f5708dca728d7177)(options.query.kind === "Document", 30);
        (0, $28d90d877eb1e517$export$f5708dca728d7177)(!options.returnPartialData, 31);
        (0, $28d90d877eb1e517$export$f5708dca728d7177)(!options.pollInterval, 32);
        return this.fetchQuery(queryId, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, options), {
            query: this.transform(options.query)
        })).finally(function() {
            return _this.stopQuery(queryId);
        });
    };
    QueryManager.prototype.generateQueryId = function() {
        return String(this.queryIdCounter++);
    };
    QueryManager.prototype.generateRequestId = function() {
        return this.requestIdCounter++;
    };
    QueryManager.prototype.generateMutationId = function() {
        return String(this.mutationIdCounter++);
    };
    QueryManager.prototype.stopQueryInStore = function(queryId) {
        this.stopQueryInStoreNoBroadcast(queryId);
        this.broadcastQueries();
    };
    QueryManager.prototype.stopQueryInStoreNoBroadcast = function(queryId) {
        var queryInfo = this.queries.get(queryId);
        if (queryInfo) queryInfo.stop();
    };
    QueryManager.prototype.clearStore = function(options) {
        if (options === void 0) options = {
            discardWatches: true
        };
        // Before we have sent the reset action to the store, we can no longer
        // rely on the results returned by in-flight requests since these may
        // depend on values that previously existed in the data portion of the
        // store. So, we cancel the promises and observers that we have issued
        // so far and not yet resolved (in the case of queries).
        this.cancelPendingFetches((0, $28d90d877eb1e517$export$3991762405098ea)(33));
        this.queries.forEach(function(queryInfo) {
            if (queryInfo.observableQuery) // Set loading to true so listeners don't trigger unless they want
            // results with partial data.
            queryInfo.networkStatus = (0, $72c5140a632c7fa1$export$bd096ddbd246c79c).loading;
            else queryInfo.stop();
        });
        if (this.mutationStore) this.mutationStore = Object.create(null);
        // begin removing data from the store
        return this.cache.reset(options);
    };
    QueryManager.prototype.getObservableQueries = function(include) {
        var _this = this;
        if (include === void 0) include = "active";
        var queries = new Map();
        var queryNamesAndDocs = new Map();
        var legacyQueryOptions = new Set();
        if (Array.isArray(include)) include.forEach(function(desc) {
            if (typeof desc === "string") queryNamesAndDocs.set(desc, false);
            else if ((0, $9d830e5028848843$export$540432d49fcec6c9)(desc)) queryNamesAndDocs.set(_this.transform(desc), false);
            else if ((0, $3a16601e2096f4cd$export$417207af72fad9c9)(desc) && desc.query) legacyQueryOptions.add(desc);
        });
        this.queries.forEach(function(_a, queryId) {
            var oq = _a.observableQuery, document = _a.document;
            if (oq) {
                if (include === "all") {
                    queries.set(queryId, oq);
                    return;
                }
                var queryName = oq.queryName, fetchPolicy = oq.options.fetchPolicy;
                if (fetchPolicy === "standby" || include === "active" && !oq.hasObservers()) return;
                if (include === "active" || queryName && queryNamesAndDocs.has(queryName) || document && queryNamesAndDocs.has(document)) {
                    queries.set(queryId, oq);
                    if (queryName) queryNamesAndDocs.set(queryName, true);
                    if (document) queryNamesAndDocs.set(document, true);
                }
            }
        });
        if (legacyQueryOptions.size) legacyQueryOptions.forEach(function(options) {
            // We will be issuing a fresh network request for this query, so we
            // pre-allocate a new query ID here, using a special prefix to enable
            // cleaning up these temporary queries later, after fetching.
            var queryId = (0, $14071c0503b706b7$export$d0c8ec0fe1b18b70)("legacyOneTimeQuery");
            var queryInfo = _this.getQuery(queryId).init({
                document: options.query,
                variables: options.variables
            });
            var oq = new (0, $3118fa29bcf9f4b2$export$6c1b56eac59c9584)({
                queryManager: _this,
                queryInfo: queryInfo,
                options: (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, options), {
                    fetchPolicy: "network-only"
                })
            });
            (0, $28d90d877eb1e517$export$f5708dca728d7177)(oq.queryId === queryId);
            queryInfo.setObservableQuery(oq);
            queries.set(queryId, oq);
        });
        if (globalThis.__DEV__ !== false && queryNamesAndDocs.size) queryNamesAndDocs.forEach(function(included, nameOrDoc) {
            if (!included) globalThis.__DEV__ !== false && (0, $28d90d877eb1e517$export$f5708dca728d7177).warn(typeof nameOrDoc === "string" ? 34 : 35, nameOrDoc);
        });
        return queries;
    };
    QueryManager.prototype.reFetchObservableQueries = function(includeStandby) {
        var _this = this;
        if (includeStandby === void 0) includeStandby = false;
        var observableQueryPromises = [];
        this.getObservableQueries(includeStandby ? "all" : "active").forEach(function(observableQuery, queryId) {
            var fetchPolicy = observableQuery.options.fetchPolicy;
            observableQuery.resetLastResults();
            if (includeStandby || fetchPolicy !== "standby" && fetchPolicy !== "cache-only") observableQueryPromises.push(observableQuery.refetch());
            _this.getQuery(queryId).setDiff(null);
        });
        this.broadcastQueries();
        return Promise.all(observableQueryPromises);
    };
    QueryManager.prototype.setObservableQuery = function(observableQuery) {
        this.getQuery(observableQuery.queryId).setObservableQuery(observableQuery);
    };
    QueryManager.prototype.startGraphQLSubscription = function(_a) {
        var _this = this;
        var query = _a.query, fetchPolicy = _a.fetchPolicy, _b = _a.errorPolicy, errorPolicy = _b === void 0 ? "none" : _b, variables = _a.variables, _c = _a.context, context = _c === void 0 ? {} : _c, _d = _a.extensions, extensions = _d === void 0 ? {} : _d;
        query = this.transform(query);
        variables = this.getVariables(query, variables);
        var makeObservable = function(variables) {
            return _this.getObservableFromLink(query, context, variables, extensions).map(function(result) {
                if (fetchPolicy !== "no-cache") {
                    // the subscription interface should handle not sending us results we no longer subscribe to.
                    // XXX I don't think we ever send in an object with errors, but we might in the future...
                    if ((0, $f8e7d4b4bf21978e$export$5f47a9fb9a521654)(result, errorPolicy)) _this.cache.write({
                        query: query,
                        result: result.data,
                        dataId: "ROOT_SUBSCRIPTION",
                        variables: variables
                    });
                    _this.broadcastQueries();
                }
                var hasErrors = (0, $5333c7f04e9cca43$export$b4df399e879e53ab)(result);
                var hasProtocolErrors = (0, $456cf4c370166a0f$export$345f95cc6b6b9b0b)(result);
                if (hasErrors || hasProtocolErrors) {
                    var errors = {};
                    if (hasErrors) errors.graphQLErrors = result.errors;
                    if (hasProtocolErrors) errors.protocolErrors = result.extensions[0, $456cf4c370166a0f$export$4995664c1b49842e];
                    // `errorPolicy` is a mechanism for handling GraphQL errors, according
                    // to our documentation, so we throw protocol errors regardless of the
                    // set error policy.
                    if (errorPolicy === "none" || hasProtocolErrors) throw new (0, $456cf4c370166a0f$export$26a337512320b8c6)(errors);
                }
                if (errorPolicy === "ignore") delete result.errors;
                return result;
            });
        };
        if (this.getDocumentInfo(query).hasClientExports) {
            var observablePromise_1 = this.localState.addExportedVariables(query, variables, context).then(makeObservable);
            return new (0, $6d99a9de69717ea6$export$77cea355fa80b5f4)(function(observer) {
                var sub = null;
                observablePromise_1.then(function(observable) {
                    return sub = observable.subscribe(observer);
                }, observer.error);
                return function() {
                    return sub && sub.unsubscribe();
                };
            });
        }
        return makeObservable(variables);
    };
    QueryManager.prototype.stopQuery = function(queryId) {
        this.stopQueryNoBroadcast(queryId);
        this.broadcastQueries();
    };
    QueryManager.prototype.stopQueryNoBroadcast = function(queryId) {
        this.stopQueryInStoreNoBroadcast(queryId);
        this.removeQuery(queryId);
    };
    QueryManager.prototype.removeQuery = function(queryId) {
        // teardown all links
        // Both `QueryManager.fetchRequest` and `QueryManager.query` create separate promises
        // that each add their reject functions to fetchCancelFns.
        // A query created with `QueryManager.query()` could trigger a `QueryManager.fetchRequest`.
        // The same queryId could have two rejection fns for two promises
        this.fetchCancelFns.delete(queryId);
        if (this.queries.has(queryId)) {
            this.getQuery(queryId).stop();
            this.queries.delete(queryId);
        }
    };
    QueryManager.prototype.broadcastQueries = function() {
        if (this.onBroadcast) this.onBroadcast();
        this.queries.forEach(function(info) {
            return info.notify();
        });
    };
    QueryManager.prototype.getLocalState = function() {
        return this.localState;
    };
    QueryManager.prototype.getObservableFromLink = function(query, context, variables, extensions, // Prefer context.queryDeduplication if specified.
    deduplication) {
        var _this = this;
        var _a;
        if (deduplication === void 0) deduplication = (_a = context === null || context === void 0 ? void 0 : context.queryDeduplication) !== null && _a !== void 0 ? _a : this.queryDeduplication;
        var observable;
        var _b = this.getDocumentInfo(query), serverQuery = _b.serverQuery, clientQuery = _b.clientQuery;
        if (serverQuery) {
            var _c = this, inFlightLinkObservables_1 = _c.inFlightLinkObservables, link = _c.link;
            var operation = {
                query: serverQuery,
                variables: variables,
                operationName: (0, $818d93327cb72c29$export$41bca9dc6871dd4e)(serverQuery) || void 0,
                context: this.prepareContext((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, context), {
                    forceFetch: !deduplication
                })),
                extensions: extensions
            };
            context = operation.context;
            if (deduplication) {
                var printedServerQuery_1 = (0, $722312be2835bfdf$export$c2d084dc44961371)(serverQuery);
                var varJson_1 = (0, $0bef48da5254bd54$export$88a0ad9b6f961b51)(variables);
                var entry = inFlightLinkObservables_1.lookup(printedServerQuery_1, varJson_1);
                observable = entry.observable;
                if (!observable) {
                    var concast = new (0, $5bb23690c12ed9a4$export$ae0cf2ec7a6fa78e)([
                        (0, $88c17748fb93d3ed$export$51396ec711da548b)(link, operation)
                    ]);
                    observable = entry.observable = concast;
                    concast.beforeNext(function() {
                        inFlightLinkObservables_1.remove(printedServerQuery_1, varJson_1);
                    });
                }
            } else observable = new (0, $5bb23690c12ed9a4$export$ae0cf2ec7a6fa78e)([
                (0, $88c17748fb93d3ed$export$51396ec711da548b)(link, operation)
            ]);
        } else {
            observable = new (0, $5bb23690c12ed9a4$export$ae0cf2ec7a6fa78e)([
                (0, $6d99a9de69717ea6$export$77cea355fa80b5f4).of({
                    data: {}
                })
            ]);
            context = this.prepareContext(context);
        }
        if (clientQuery) observable = (0, $558b9f91eb7bf726$export$707ee4c4c95d39e3)(observable, function(result) {
            return _this.localState.runResolvers({
                document: clientQuery,
                remoteResult: result,
                context: context,
                variables: variables
            });
        });
        return observable;
    };
    QueryManager.prototype.getResultsFromLink = function(queryInfo, cacheWriteBehavior, options) {
        var requestId = queryInfo.lastRequestId = this.generateRequestId();
        // Performing transformForLink here gives this.cache a chance to fill in
        // missing fragment definitions (for example) before sending this document
        // through the link chain.
        var linkDocument = this.cache.transformForLink(options.query);
        return (0, $558b9f91eb7bf726$export$707ee4c4c95d39e3)(this.getObservableFromLink(linkDocument, options.context, options.variables), function(result) {
            var graphQLErrors = (0, $5333c7f04e9cca43$export$a163557155188b6e)(result);
            var hasErrors = graphQLErrors.length > 0;
            var errorPolicy = options.errorPolicy;
            // If we interrupted this request by calling getResultsFromLink again
            // with the same QueryInfo object, we ignore the old results.
            if (requestId >= queryInfo.lastRequestId) {
                if (hasErrors && errorPolicy === "none") // Throwing here effectively calls observer.error.
                throw queryInfo.markError(new (0, $456cf4c370166a0f$export$26a337512320b8c6)({
                    graphQLErrors: graphQLErrors
                }));
                // Use linkDocument rather than queryInfo.document so the
                // operation/fragments used to write the result are the same as the
                // ones used to obtain it from the link.
                queryInfo.markResult(result, linkDocument, options, cacheWriteBehavior);
                queryInfo.markReady();
            }
            var aqr = {
                data: result.data,
                loading: false,
                networkStatus: (0, $72c5140a632c7fa1$export$bd096ddbd246c79c).ready
            };
            // In the case we start multiple network requests simulatenously, we
            // want to ensure we properly set `data` if we're reporting on an old
            // result which will not be caught by the conditional above that ends up
            // throwing the markError result.
            if (hasErrors && errorPolicy === "none") aqr.data = void 0;
            if (hasErrors && errorPolicy !== "ignore") {
                aqr.errors = graphQLErrors;
                aqr.networkStatus = (0, $72c5140a632c7fa1$export$bd096ddbd246c79c).error;
            }
            return aqr;
        }, function(networkError) {
            var error = (0, $456cf4c370166a0f$export$17f5e6bd290bb15d)(networkError) ? networkError : new (0, $456cf4c370166a0f$export$26a337512320b8c6)({
                networkError: networkError
            });
            // Avoid storing errors from older interrupted queries.
            if (requestId >= queryInfo.lastRequestId) queryInfo.markError(error);
            throw error;
        });
    };
    QueryManager.prototype.fetchConcastWithInfo = function(queryId, options, // The initial networkStatus for this fetch, most often
    // NetworkStatus.loading, but also possibly fetchMore, poll, refetch,
    // or setVariables.
    networkStatus, query) {
        var _this = this;
        if (networkStatus === void 0) networkStatus = (0, $72c5140a632c7fa1$export$bd096ddbd246c79c).loading;
        if (query === void 0) query = options.query;
        var variables = this.getVariables(query, options.variables);
        var queryInfo = this.getQuery(queryId);
        var defaults = this.defaultOptions.watchQuery;
        var _a = options.fetchPolicy, fetchPolicy = _a === void 0 ? defaults && defaults.fetchPolicy || "cache-first" : _a, _b = options.errorPolicy, errorPolicy = _b === void 0 ? defaults && defaults.errorPolicy || "none" : _b, _c = options.returnPartialData, returnPartialData = _c === void 0 ? false : _c, _d = options.notifyOnNetworkStatusChange, notifyOnNetworkStatusChange = _d === void 0 ? false : _d, _e = options.context, context = _e === void 0 ? {} : _e;
        var normalized = Object.assign({}, options, {
            query: query,
            variables: variables,
            fetchPolicy: fetchPolicy,
            errorPolicy: errorPolicy,
            returnPartialData: returnPartialData,
            notifyOnNetworkStatusChange: notifyOnNetworkStatusChange,
            context: context
        });
        var fromVariables = function(variables) {
            // Since normalized is always a fresh copy of options, it's safe to
            // modify its properties here, rather than creating yet another new
            // WatchQueryOptions object.
            normalized.variables = variables;
            var sourcesWithInfo = _this.fetchQueryByPolicy(queryInfo, normalized, networkStatus);
            if (// If we're in standby, postpone advancing options.fetchPolicy using
            // applyNextFetchPolicy.
            normalized.fetchPolicy !== "standby" && // The "standby" policy currently returns [] from fetchQueryByPolicy, so
            // this is another way to detect when nothing was done/fetched.
            sourcesWithInfo.sources.length > 0 && queryInfo.observableQuery) queryInfo.observableQuery["applyNextFetchPolicy"]("after-fetch", options);
            return sourcesWithInfo;
        };
        // This cancel function needs to be set before the concast is created,
        // in case concast creation synchronously cancels the request.
        var cleanupCancelFn = function() {
            return _this.fetchCancelFns.delete(queryId);
        };
        this.fetchCancelFns.set(queryId, function(reason) {
            cleanupCancelFn();
            // This delay ensures the concast variable has been initialized.
            setTimeout(function() {
                return concast.cancel(reason);
            });
        });
        var concast, containsDataFromLink;
        // If the query has @export(as: ...) directives, then we need to
        // process those directives asynchronously. When there are no
        // @export directives (the common case), we deliberately avoid
        // wrapping the result of this.fetchQueryByPolicy in a Promise,
        // since the timing of result delivery is (unfortunately) important
        // for backwards compatibility. TODO This code could be simpler if
        // we deprecated and removed LocalState.
        if (this.getDocumentInfo(normalized.query).hasClientExports) {
            concast = new (0, $5bb23690c12ed9a4$export$ae0cf2ec7a6fa78e)(this.localState.addExportedVariables(normalized.query, normalized.variables, normalized.context).then(fromVariables).then(function(sourcesWithInfo) {
                return sourcesWithInfo.sources;
            }));
            // there is just no way we can synchronously get the *right* value here,
            // so we will assume `true`, which is the behaviour before the bug fix in
            // #10597. This means that bug is not fixed in that case, and is probably
            // un-fixable with reasonable effort for the edge case of @export as
            // directives.
            containsDataFromLink = true;
        } else {
            var sourcesWithInfo = fromVariables(normalized.variables);
            containsDataFromLink = sourcesWithInfo.fromLink;
            concast = new (0, $5bb23690c12ed9a4$export$ae0cf2ec7a6fa78e)(sourcesWithInfo.sources);
        }
        concast.promise.then(cleanupCancelFn, cleanupCancelFn);
        return {
            concast: concast,
            fromLink: containsDataFromLink
        };
    };
    QueryManager.prototype.refetchQueries = function(_a) {
        var _this = this;
        var updateCache = _a.updateCache, include = _a.include, _b = _a.optimistic, optimistic = _b === void 0 ? false : _b, _c = _a.removeOptimistic, removeOptimistic = _c === void 0 ? optimistic ? (0, $14071c0503b706b7$export$d0c8ec0fe1b18b70)("refetchQueries") : void 0 : _c, onQueryUpdated = _a.onQueryUpdated;
        var includedQueriesById = new Map();
        if (include) this.getObservableQueries(include).forEach(function(oq, queryId) {
            includedQueriesById.set(queryId, {
                oq: oq,
                lastDiff: _this.getQuery(queryId).getDiff()
            });
        });
        var results = new Map();
        if (updateCache) this.cache.batch({
            update: updateCache,
            // Since you can perform any combination of cache reads and/or writes in
            // the cache.batch update function, its optimistic option can be either
            // a boolean or a string, representing three distinct modes of
            // operation:
            //
            // * false: read/write only the root layer
            // * true: read/write the topmost layer
            // * string: read/write a fresh optimistic layer with that ID string
            //
            // When typeof optimistic === "string", a new optimistic layer will be
            // temporarily created within cache.batch with that string as its ID. If
            // we then pass that same string as the removeOptimistic option, we can
            // make cache.batch immediately remove the optimistic layer after
            // running the updateCache function, triggering only one broadcast.
            //
            // However, the refetchQueries method accepts only true or false for its
            // optimistic option (not string). We interpret true to mean a temporary
            // optimistic layer should be created, to allow efficiently rolling back
            // the effect of the updateCache function, which involves passing a
            // string instead of true as the optimistic option to cache.batch, when
            // refetchQueries receives optimistic: true.
            //
            // In other words, we are deliberately not supporting the use case of
            // writing to an *existing* optimistic layer (using the refetchQueries
            // updateCache function), since that would potentially interfere with
            // other optimistic updates in progress. Instead, you can read/write
            // only the root layer by passing optimistic: false to refetchQueries,
            // or you can read/write a brand new optimistic layer that will be
            // automatically removed by passing optimistic: true.
            optimistic: optimistic && removeOptimistic || false,
            // The removeOptimistic option can also be provided by itself, even if
            // optimistic === false, to remove some previously-added optimistic
            // layer safely and efficiently, like we do in markMutationResult.
            //
            // If an explicit removeOptimistic string is provided with optimistic:
            // true, the removeOptimistic string will determine the ID of the
            // temporary optimistic layer, in case that ever matters.
            removeOptimistic: removeOptimistic,
            onWatchUpdated: function(watch, diff, lastDiff) {
                var oq = watch.watcher instanceof (0, $f8e7d4b4bf21978e$export$79a6120a39c90b6a) && watch.watcher.observableQuery;
                if (oq) {
                    if (onQueryUpdated) {
                        // Since we're about to handle this query now, remove it from
                        // includedQueriesById, in case it was added earlier because of
                        // options.include.
                        includedQueriesById.delete(oq.queryId);
                        var result = onQueryUpdated(oq, diff, lastDiff);
                        if (result === true) // The onQueryUpdated function requested the default refetching
                        // behavior by returning true.
                        result = oq.refetch();
                        // Record the result in the results Map, as long as onQueryUpdated
                        // did not return false to skip/ignore this result.
                        if (result !== false) results.set(oq, result);
                        // Allow the default cache broadcast to happen, except when
                        // onQueryUpdated returns false.
                        return result;
                    }
                    if (onQueryUpdated !== null) // If we don't have an onQueryUpdated function, and onQueryUpdated
                    // was not disabled by passing null, make sure this query is
                    // "included" like any other options.include-specified query.
                    includedQueriesById.set(oq.queryId, {
                        oq: oq,
                        lastDiff: lastDiff,
                        diff: diff
                    });
                }
            }
        });
        if (includedQueriesById.size) includedQueriesById.forEach(function(_a, queryId) {
            var oq = _a.oq, lastDiff = _a.lastDiff, diff = _a.diff;
            var result;
            // If onQueryUpdated is provided, we want to use it for all included
            // queries, even the QueryOptions ones.
            if (onQueryUpdated) {
                if (!diff) {
                    var info = oq["queryInfo"];
                    info.reset(); // Force info.getDiff() to read from cache.
                    diff = info.getDiff();
                }
                result = onQueryUpdated(oq, diff, lastDiff);
            }
            // Otherwise, we fall back to refetching.
            if (!onQueryUpdated || result === true) result = oq.refetch();
            if (result !== false) results.set(oq, result);
            if (queryId.indexOf("legacyOneTimeQuery") >= 0) _this.stopQueryNoBroadcast(queryId);
        });
        if (removeOptimistic) // In case no updateCache callback was provided (so cache.batch was not
        // called above, and thus did not already remove the optimistic layer),
        // remove it here. Since this is a no-op when the layer has already been
        // removed, we do it even if we called cache.batch above, since it's
        // possible this.cache is an instance of some ApolloCache subclass other
        // than InMemoryCache, and does not fully support the removeOptimistic
        // option for cache.batch.
        this.cache.removeOptimistic(removeOptimistic);
        return results;
    };
    QueryManager.prototype.fetchQueryByPolicy = function(queryInfo, _a, // The initial networkStatus for this fetch, most often
    // NetworkStatus.loading, but also possibly fetchMore, poll, refetch,
    // or setVariables.
    networkStatus) {
        var _this = this;
        var query = _a.query, variables = _a.variables, fetchPolicy = _a.fetchPolicy, refetchWritePolicy = _a.refetchWritePolicy, errorPolicy = _a.errorPolicy, returnPartialData = _a.returnPartialData, context = _a.context, notifyOnNetworkStatusChange = _a.notifyOnNetworkStatusChange;
        var oldNetworkStatus = queryInfo.networkStatus;
        queryInfo.init({
            document: query,
            variables: variables,
            networkStatus: networkStatus
        });
        var readCache = function() {
            return queryInfo.getDiff();
        };
        var resultsFromCache = function(diff, networkStatus) {
            if (networkStatus === void 0) networkStatus = queryInfo.networkStatus || (0, $72c5140a632c7fa1$export$bd096ddbd246c79c).loading;
            var data = diff.result;
            if (globalThis.__DEV__ !== false && !returnPartialData && !(0, $a2b6f433e732b502$export$411ce8e5a71e3069)(data, {})) (0, $3118fa29bcf9f4b2$export$b7e1973aacac3ae7)(diff.missing);
            var fromData = function(data) {
                return (0, $6d99a9de69717ea6$export$77cea355fa80b5f4).of((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                    data: data,
                    loading: (0, $72c5140a632c7fa1$export$37509604341a3464)(networkStatus),
                    networkStatus: networkStatus
                }, diff.complete ? null : {
                    partial: true
                }));
            };
            if (data && _this.getDocumentInfo(query).hasForcedResolvers) return _this.localState.runResolvers({
                document: query,
                remoteResult: {
                    data: data
                },
                context: context,
                variables: variables,
                onlyRunForcedResolvers: true
            }).then(function(resolved) {
                return fromData(resolved.data || void 0);
            });
            // Resolves https://github.com/apollographql/apollo-client/issues/10317.
            // If errorPolicy is 'none' and notifyOnNetworkStatusChange is true,
            // data was incorrectly returned from the cache on refetch:
            // if diff.missing exists, we should not return cache data.
            if (errorPolicy === "none" && networkStatus === (0, $72c5140a632c7fa1$export$bd096ddbd246c79c).refetch && Array.isArray(diff.missing)) return fromData(void 0);
            return fromData(data);
        };
        var cacheWriteBehavior = fetchPolicy === "no-cache" ? 0 /* CacheWriteBehavior.FORBID */  : networkStatus === (0, $72c5140a632c7fa1$export$bd096ddbd246c79c).refetch && refetchWritePolicy !== "merge" ? 1 /* CacheWriteBehavior.OVERWRITE */  : 2 /* CacheWriteBehavior.MERGE */ ;
        var resultsFromLink = function() {
            return _this.getResultsFromLink(queryInfo, cacheWriteBehavior, {
                query: query,
                variables: variables,
                context: context,
                fetchPolicy: fetchPolicy,
                errorPolicy: errorPolicy
            });
        };
        var shouldNotify = notifyOnNetworkStatusChange && typeof oldNetworkStatus === "number" && oldNetworkStatus !== networkStatus && (0, $72c5140a632c7fa1$export$37509604341a3464)(networkStatus);
        switch(fetchPolicy){
            default:
            case "cache-first":
                var diff = readCache();
                if (diff.complete) return {
                    fromLink: false,
                    sources: [
                        resultsFromCache(diff, queryInfo.markReady())
                    ]
                };
                if (returnPartialData || shouldNotify) return {
                    fromLink: true,
                    sources: [
                        resultsFromCache(diff),
                        resultsFromLink()
                    ]
                };
                return {
                    fromLink: true,
                    sources: [
                        resultsFromLink()
                    ]
                };
            case "cache-and-network":
                var diff = readCache();
                if (diff.complete || returnPartialData || shouldNotify) return {
                    fromLink: true,
                    sources: [
                        resultsFromCache(diff),
                        resultsFromLink()
                    ]
                };
                return {
                    fromLink: true,
                    sources: [
                        resultsFromLink()
                    ]
                };
            case "cache-only":
                return {
                    fromLink: false,
                    sources: [
                        resultsFromCache(readCache(), queryInfo.markReady())
                    ]
                };
            case "network-only":
                if (shouldNotify) return {
                    fromLink: true,
                    sources: [
                        resultsFromCache(readCache()),
                        resultsFromLink()
                    ]
                };
                return {
                    fromLink: true,
                    sources: [
                        resultsFromLink()
                    ]
                };
            case "no-cache":
                if (shouldNotify) return {
                    fromLink: true,
                    // Note that queryInfo.getDiff() for no-cache queries does not call
                    // cache.diff, but instead returns a { complete: false } stub result
                    // when there is no queryInfo.diff already defined.
                    sources: [
                        resultsFromCache(queryInfo.getDiff()),
                        resultsFromLink()
                    ]
                };
                return {
                    fromLink: true,
                    sources: [
                        resultsFromLink()
                    ]
                };
            case "standby":
                return {
                    fromLink: false,
                    sources: []
                };
        }
    };
    QueryManager.prototype.getQuery = function(queryId) {
        if (queryId && !this.queries.has(queryId)) this.queries.set(queryId, new (0, $f8e7d4b4bf21978e$export$79a6120a39c90b6a)(this, queryId));
        return this.queries.get(queryId);
    };
    QueryManager.prototype.prepareContext = function(context) {
        if (context === void 0) context = {};
        var newContext = this.localState.prepareContext(context);
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, this.defaultContext), newContext), {
            clientAwareness: this.clientAwareness
        });
    };
    return QueryManager;
}();





function $6320ab015e2889cc$export$e7ecd7c16613ccfd(node) {
    return $6320ab015e2889cc$export$4cedd8740794bd78(node) || $6320ab015e2889cc$export$b05c7141ec7770ba(node) || $6320ab015e2889cc$export$fbc18e88163d676d(node);
}
function $6320ab015e2889cc$export$4cedd8740794bd78(node) {
    return node.kind === (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).OPERATION_DEFINITION || node.kind === (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).FRAGMENT_DEFINITION;
}
function $6320ab015e2889cc$export$65772b71e1d017ba(node) {
    return node.kind === (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).FIELD || node.kind === (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).FRAGMENT_SPREAD || node.kind === (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).INLINE_FRAGMENT;
}
function $6320ab015e2889cc$export$ab65b54ec7cbe9e4(node) {
    return node.kind === (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).VARIABLE || node.kind === (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).INT || node.kind === (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).FLOAT || node.kind === (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).STRING || node.kind === (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).BOOLEAN || node.kind === (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).NULL || node.kind === (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).ENUM || node.kind === (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).LIST || node.kind === (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).OBJECT;
}
function $6320ab015e2889cc$export$f95bfad9e6aea45f(node) {
    return $6320ab015e2889cc$export$ab65b54ec7cbe9e4(node) && (node.kind === (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).LIST ? node.values.some($6320ab015e2889cc$export$f95bfad9e6aea45f) : node.kind === (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).OBJECT ? node.fields.some((field)=>$6320ab015e2889cc$export$f95bfad9e6aea45f(field.value)) : node.kind !== (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).VARIABLE);
}
function $6320ab015e2889cc$export$26e8a4730f4310f4(node) {
    return node.kind === (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).NAMED_TYPE || node.kind === (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).LIST_TYPE || node.kind === (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).NON_NULL_TYPE;
}
function $6320ab015e2889cc$export$b05c7141ec7770ba(node) {
    return node.kind === (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).SCHEMA_DEFINITION || $6320ab015e2889cc$export$a3584bba04f5bfe0(node) || node.kind === (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).DIRECTIVE_DEFINITION;
}
function $6320ab015e2889cc$export$a3584bba04f5bfe0(node) {
    return node.kind === (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).SCALAR_TYPE_DEFINITION || node.kind === (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).OBJECT_TYPE_DEFINITION || node.kind === (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).INTERFACE_TYPE_DEFINITION || node.kind === (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).UNION_TYPE_DEFINITION || node.kind === (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).ENUM_TYPE_DEFINITION || node.kind === (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).INPUT_OBJECT_TYPE_DEFINITION;
}
function $6320ab015e2889cc$export$fbc18e88163d676d(node) {
    return node.kind === (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).SCHEMA_EXTENSION || $6320ab015e2889cc$export$d7907721b241e11f(node);
}
function $6320ab015e2889cc$export$d7907721b241e11f(node) {
    return node.kind === (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).SCALAR_TYPE_EXTENSION || node.kind === (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).OBJECT_TYPE_EXTENSION || node.kind === (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).INTERFACE_TYPE_EXTENSION || node.kind === (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).UNION_TYPE_EXTENSION || node.kind === (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).ENUM_TYPE_EXTENSION || node.kind === (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).INPUT_OBJECT_TYPE_EXTENSION;
}




var $0b37964519c908de$export$ac9723609f5c76c2 = new (0, $1b7dab7b0d0a41be$export$8c6ed5c666ac1360)();
var $0b37964519c908de$var$cacheInfoMap = new WeakMap();
function $0b37964519c908de$var$getCacheInfo(cache) {
    var info = $0b37964519c908de$var$cacheInfoMap.get(cache);
    if (!info) $0b37964519c908de$var$cacheInfoMap.set(cache, info = {
        vars: new Set(),
        dep: (0, $f96bffcf733fdbbf$export$c723b7eff9d8f870)()
    });
    return info;
}
function $0b37964519c908de$export$cbe12faed7725318(cache) {
    $0b37964519c908de$var$getCacheInfo(cache).vars.forEach(function(rv) {
        return rv.forgetCache(cache);
    });
}
function $0b37964519c908de$export$f342bdd61b3e9412(cache) {
    $0b37964519c908de$var$getCacheInfo(cache).vars.forEach(function(rv) {
        return rv.attachCache(cache);
    });
}
function $0b37964519c908de$export$5345c8ac69b4a9db(value) {
    var caches = new Set();
    var listeners = new Set();
    var rv = function(newValue) {
        if (arguments.length > 0) {
            if (value !== newValue) {
                value = newValue;
                caches.forEach(function(cache) {
                    // Invalidate any fields with custom read functions that
                    // consumed this variable, so query results involving those
                    // fields will be recomputed the next time we read them.
                    $0b37964519c908de$var$getCacheInfo(cache).dep.dirty(rv);
                    // Broadcast changes to any caches that have previously read
                    // from this variable.
                    $0b37964519c908de$var$broadcast(cache);
                });
                // Finally, notify any listeners added via rv.onNextChange.
                var oldListeners = Array.from(listeners);
                listeners.clear();
                oldListeners.forEach(function(listener) {
                    return listener(value);
                });
            }
        } else {
            // When reading from the variable, obtain the current cache from
            // context via cacheSlot. This isn't entirely foolproof, but it's
            // the same system that powers varDep.
            var cache = $0b37964519c908de$export$ac9723609f5c76c2.getValue();
            if (cache) {
                attach(cache);
                $0b37964519c908de$var$getCacheInfo(cache).dep(rv);
            }
        }
        return value;
    };
    rv.onNextChange = function(listener) {
        listeners.add(listener);
        return function() {
            listeners.delete(listener);
        };
    };
    var attach = rv.attachCache = function(cache) {
        caches.add(cache);
        $0b37964519c908de$var$getCacheInfo(cache).vars.add(rv);
        return rv;
    };
    rv.forgetCache = function(cache) {
        return caches.delete(cache);
    };
    return rv;
}
function $0b37964519c908de$var$broadcast(cache) {
    if (cache.broadcastWatches) cache.broadcastWatches();
}


var $99c0c2fd8aedf706$export$19901bcd339c3ded = /** @class */ function() {
    function LocalState(_a) {
        var cache = _a.cache, client = _a.client, resolvers = _a.resolvers, fragmentMatcher = _a.fragmentMatcher;
        this.selectionsToResolveCache = new WeakMap();
        this.cache = cache;
        if (client) this.client = client;
        if (resolvers) this.addResolvers(resolvers);
        if (fragmentMatcher) this.setFragmentMatcher(fragmentMatcher);
    }
    LocalState.prototype.addResolvers = function(resolvers) {
        var _this = this;
        this.resolvers = this.resolvers || {};
        if (Array.isArray(resolvers)) resolvers.forEach(function(resolverGroup) {
            _this.resolvers = (0, $0217b27a7999d1ae$export$dd702b3c8240390c)(_this.resolvers, resolverGroup);
        });
        else this.resolvers = (0, $0217b27a7999d1ae$export$dd702b3c8240390c)(this.resolvers, resolvers);
    };
    LocalState.prototype.setResolvers = function(resolvers) {
        this.resolvers = {};
        this.addResolvers(resolvers);
    };
    LocalState.prototype.getResolvers = function() {
        return this.resolvers || {};
    };
    // Run local client resolvers against the incoming query and remote data.
    // Locally resolved field values are merged with the incoming remote data,
    // and returned. Note that locally resolved fields will overwrite
    // remote data using the same field name.
    LocalState.prototype.runResolvers = function(_a) {
        return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(this, arguments, void 0, function(_b) {
            var document = _b.document, remoteResult = _b.remoteResult, context = _b.context, variables = _b.variables, _c = _b.onlyRunForcedResolvers, onlyRunForcedResolvers = _c === void 0 ? false : _c;
            return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_d) {
                if (document) return [
                    2 /*return*/ ,
                    this.resolveDocument(document, remoteResult.data, context, variables, this.fragmentMatcher, onlyRunForcedResolvers).then(function(localResult) {
                        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, remoteResult), {
                            data: localResult.result
                        });
                    })
                ];
                return [
                    2 /*return*/ ,
                    remoteResult
                ];
            });
        });
    };
    LocalState.prototype.setFragmentMatcher = function(fragmentMatcher) {
        this.fragmentMatcher = fragmentMatcher;
    };
    LocalState.prototype.getFragmentMatcher = function() {
        return this.fragmentMatcher;
    };
    // Client queries contain everything in the incoming document (if a @client
    // directive is found).
    LocalState.prototype.clientQuery = function(document) {
        if ((0, $89c1eec09879e1ca$export$2dafb573e282fe8d)([
            "client"
        ], document)) {
            if (this.resolvers) return document;
        }
        return null;
    };
    // Server queries are stripped of all @client based selection sets.
    LocalState.prototype.serverQuery = function(document) {
        return (0, $202b8a19e6086c64$export$8eae69e876ee321e)(document);
    };
    LocalState.prototype.prepareContext = function(context) {
        var cache = this.cache;
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, context), {
            cache: cache,
            // Getting an entry's cache key is useful for local state resolvers.
            getCacheKey: function(obj) {
                return cache.identify(obj);
            }
        });
    };
    // To support `@client @export(as: "someVar")` syntax, we'll first resolve
    // @client @export fields locally, then pass the resolved values back to be
    // used alongside the original operation variables.
    LocalState.prototype.addExportedVariables = function(document_1) {
        return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(this, arguments, void 0, function(document, variables, context) {
            if (variables === void 0) variables = {};
            if (context === void 0) context = {};
            return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
                if (document) return [
                    2 /*return*/ ,
                    this.resolveDocument(document, this.buildRootValueFromCache(document, variables) || {}, this.prepareContext(context), variables).then(function(data) {
                        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, variables), data.exportedVariables);
                    })
                ];
                return [
                    2 /*return*/ ,
                    (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, variables)
                ];
            });
        });
    };
    LocalState.prototype.shouldForceResolvers = function(document) {
        var forceResolvers = false;
        (0, $78b48476e314521e$export$bf638b60ea8b89b7)(document, {
            Directive: {
                enter: function(node) {
                    if (node.name.value === "client" && node.arguments) {
                        forceResolvers = node.arguments.some(function(arg) {
                            return arg.name.value === "always" && arg.value.kind === "BooleanValue" && arg.value.value === true;
                        });
                        if (forceResolvers) return 0, $78b48476e314521e$export$a89c95c098ac2a58;
                    }
                }
            }
        });
        return forceResolvers;
    };
    // Query the cache and return matching data.
    LocalState.prototype.buildRootValueFromCache = function(document, variables) {
        return this.cache.diff({
            query: (0, $202b8a19e6086c64$export$57c368c23873f32b)(document),
            variables: variables,
            returnPartialData: true,
            optimistic: false
        }).result;
    };
    LocalState.prototype.resolveDocument = function(document_1, rootValue_1) {
        return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(this, arguments, void 0, function(document, rootValue, context, variables, fragmentMatcher, onlyRunForcedResolvers) {
            var mainDefinition, fragments, fragmentMap, selectionsToResolve, definitionOperation, defaultOperationType, _a, cache, client, execContext, isClientFieldDescendant;
            if (context === void 0) context = {};
            if (variables === void 0) variables = {};
            if (fragmentMatcher === void 0) fragmentMatcher = function() {
                return true;
            };
            if (onlyRunForcedResolvers === void 0) onlyRunForcedResolvers = false;
            return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_b) {
                mainDefinition = (0, $818d93327cb72c29$export$f431198736b7f96d)(document);
                fragments = (0, $818d93327cb72c29$export$5320a7ba9466a3df)(document);
                fragmentMap = (0, $7f688c9754699513$export$193789b4c8246dd4)(fragments);
                selectionsToResolve = this.collectSelectionsToResolve(mainDefinition, fragmentMap);
                definitionOperation = mainDefinition.operation;
                defaultOperationType = definitionOperation ? definitionOperation.charAt(0).toUpperCase() + definitionOperation.slice(1) : "Query";
                _a = this, cache = _a.cache, client = _a.client;
                execContext = {
                    fragmentMap: fragmentMap,
                    context: (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, context), {
                        cache: cache,
                        client: client
                    }),
                    variables: variables,
                    fragmentMatcher: fragmentMatcher,
                    defaultOperationType: defaultOperationType,
                    exportedVariables: {},
                    selectionsToResolve: selectionsToResolve,
                    onlyRunForcedResolvers: onlyRunForcedResolvers
                };
                isClientFieldDescendant = false;
                return [
                    2 /*return*/ ,
                    this.resolveSelectionSet(mainDefinition.selectionSet, isClientFieldDescendant, rootValue, execContext).then(function(result) {
                        return {
                            result: result,
                            exportedVariables: execContext.exportedVariables
                        };
                    })
                ];
            });
        });
    };
    LocalState.prototype.resolveSelectionSet = function(selectionSet, isClientFieldDescendant, rootValue, execContext) {
        return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var fragmentMap, context, variables, resultsToMerge, execute;
            var _this = this;
            return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
                fragmentMap = execContext.fragmentMap, context = execContext.context, variables = execContext.variables;
                resultsToMerge = [
                    rootValue
                ];
                execute = function(selection) {
                    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(_this, void 0, void 0, function() {
                        var fragment, typeCondition;
                        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
                            if (!isClientFieldDescendant && !execContext.selectionsToResolve.has(selection)) // Skip selections without @client directives
                            // (still processing if one of the ancestors or one of the child fields has @client directive)
                            return [
                                2 /*return*/ 
                            ];
                            if (!(0, $89c1eec09879e1ca$export$3dc388a5f013b4a5)(selection, variables)) // Skip this entirely.
                            return [
                                2 /*return*/ 
                            ];
                            if ((0, $9d830e5028848843$export$fb56ad75dd311c12)(selection)) return [
                                2 /*return*/ ,
                                this.resolveField(selection, isClientFieldDescendant, rootValue, execContext).then(function(fieldResult) {
                                    var _a;
                                    if (typeof fieldResult !== "undefined") resultsToMerge.push((_a = {}, _a[(0, $9d830e5028848843$export$7d1ad22471852218)(selection)] = fieldResult, _a));
                                })
                            ];
                            if ((0, $9d830e5028848843$export$22a1cdafaf27bcff)(selection)) fragment = selection;
                            else {
                                // This is a named fragment.
                                fragment = fragmentMap[selection.name.value];
                                (0, $28d90d877eb1e517$export$f5708dca728d7177)(fragment, 18, selection.name.value);
                            }
                            if (fragment && fragment.typeCondition) {
                                typeCondition = fragment.typeCondition.name.value;
                                if (execContext.fragmentMatcher(rootValue, typeCondition, context)) return [
                                    2 /*return*/ ,
                                    this.resolveSelectionSet(fragment.selectionSet, isClientFieldDescendant, rootValue, execContext).then(function(fragmentResult) {
                                        resultsToMerge.push(fragmentResult);
                                    })
                                ];
                            }
                            return [
                                2 /*return*/ 
                            ];
                        });
                    });
                };
                return [
                    2 /*return*/ ,
                    Promise.all(selectionSet.selections.map(execute)).then(function() {
                        return (0, $0217b27a7999d1ae$export$160070228be94b08)(resultsToMerge);
                    })
                ];
            });
        });
    };
    LocalState.prototype.resolveField = function(field, isClientFieldDescendant, rootValue, execContext) {
        return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var variables, fieldName, aliasedFieldName, aliasUsed, defaultResult, resultPromise, resolverType, resolverMap, resolve;
            var _this = this;
            return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_a) {
                if (!rootValue) return [
                    2 /*return*/ ,
                    null
                ];
                variables = execContext.variables;
                fieldName = field.name.value;
                aliasedFieldName = (0, $9d830e5028848843$export$7d1ad22471852218)(field);
                aliasUsed = fieldName !== aliasedFieldName;
                defaultResult = rootValue[aliasedFieldName] || rootValue[fieldName];
                resultPromise = Promise.resolve(defaultResult);
                // Usually all local resolvers are run when passing through here, but
                // if we've specifically identified that we only want to run forced
                // resolvers (that is, resolvers for fields marked with
                // `@client(always: true)`), then we'll skip running non-forced resolvers.
                if (!execContext.onlyRunForcedResolvers || this.shouldForceResolvers(field)) {
                    resolverType = rootValue.__typename || execContext.defaultOperationType;
                    resolverMap = this.resolvers && this.resolvers[resolverType];
                    if (resolverMap) {
                        resolve = resolverMap[aliasUsed ? fieldName : aliasedFieldName];
                        if (resolve) resultPromise = Promise.resolve(// In case the resolve function accesses reactive variables,
                        // set cacheSlot to the current cache instance.
                        (0, $0b37964519c908de$export$ac9723609f5c76c2).withValue(this.cache, resolve, [
                            rootValue,
                            (0, $9d830e5028848843$export$3f5a60fb6a781b4f)(field, variables),
                            execContext.context,
                            {
                                field: field,
                                fragmentMap: execContext.fragmentMap
                            }
                        ]));
                    }
                }
                return [
                    2 /*return*/ ,
                    resultPromise.then(function(result) {
                        var _a, _b;
                        if (result === void 0) result = defaultResult;
                        // If an @export directive is associated with the current field, store
                        // the `as` export variable name and current result for later use.
                        if (field.directives) field.directives.forEach(function(directive) {
                            if (directive.name.value === "export" && directive.arguments) directive.arguments.forEach(function(arg) {
                                if (arg.name.value === "as" && arg.value.kind === "StringValue") execContext.exportedVariables[arg.value.value] = result;
                            });
                        });
                        // Handle all scalar types here.
                        if (!field.selectionSet) return result;
                        // From here down, the field has a selection set, which means it's trying
                        // to query a GraphQLObjectType.
                        if (result == null) // Basically any field in a GraphQL response can be null, or missing
                        return result;
                        var isClientField = (_b = (_a = field.directives) === null || _a === void 0 ? void 0 : _a.some(function(d) {
                            return d.name.value === "client";
                        })) !== null && _b !== void 0 ? _b : false;
                        if (Array.isArray(result)) return _this.resolveSubSelectedArray(field, isClientFieldDescendant || isClientField, result, execContext);
                        // Returned value is an object, and the query has a sub-selection. Recurse.
                        if (field.selectionSet) return _this.resolveSelectionSet(field.selectionSet, isClientFieldDescendant || isClientField, result, execContext);
                    })
                ];
            });
        });
    };
    LocalState.prototype.resolveSubSelectedArray = function(field, isClientFieldDescendant, result, execContext) {
        var _this = this;
        return Promise.all(result.map(function(item) {
            if (item === null) return null;
            // This is a nested array, recurse.
            if (Array.isArray(item)) return _this.resolveSubSelectedArray(field, isClientFieldDescendant, item, execContext);
            // This is an object, run the selection set on it.
            if (field.selectionSet) return _this.resolveSelectionSet(field.selectionSet, isClientFieldDescendant, item, execContext);
        }));
    };
    // Collect selection nodes on paths from document root down to all @client directives.
    // This function takes into account transitive fragment spreads.
    // Complexity equals to a single `visit` over the full document.
    LocalState.prototype.collectSelectionsToResolve = function(mainDefinition, fragmentMap) {
        var isSingleASTNode = function(node) {
            return !Array.isArray(node);
        };
        var selectionsToResolveCache = this.selectionsToResolveCache;
        function collectByDefinition(definitionNode) {
            if (!selectionsToResolveCache.has(definitionNode)) {
                var matches_1 = new Set();
                selectionsToResolveCache.set(definitionNode, matches_1);
                (0, $78b48476e314521e$export$bf638b60ea8b89b7)(definitionNode, {
                    Directive: function(node, _, __, ___, ancestors) {
                        if (node.name.value === "client") ancestors.forEach(function(node) {
                            if (isSingleASTNode(node) && (0, $6320ab015e2889cc$export$65772b71e1d017ba)(node)) matches_1.add(node);
                        });
                    },
                    FragmentSpread: function(spread, _, __, ___, ancestors) {
                        var fragment = fragmentMap[spread.name.value];
                        (0, $28d90d877eb1e517$export$f5708dca728d7177)(fragment, 19, spread.name.value);
                        var fragmentSelections = collectByDefinition(fragment);
                        if (fragmentSelections.size > 0) {
                            // Fragment for this spread contains @client directive (either directly or transitively)
                            // Collect selection nodes on paths from the root down to fields with the @client directive
                            ancestors.forEach(function(node) {
                                if (isSingleASTNode(node) && (0, $6320ab015e2889cc$export$65772b71e1d017ba)(node)) matches_1.add(node);
                            });
                            matches_1.add(spread);
                            fragmentSelections.forEach(function(selection) {
                                matches_1.add(selection);
                            });
                        }
                    }
                });
            }
            return selectionsToResolveCache.get(definitionNode);
        }
        return collectByDefinition(mainDefinition);
    };
    return LocalState;
}();




function $1a9f9b47c9ebef70$export$235b7fc70b9fc359(defaults, options) {
    return (0, $2f3cebf1a05c1b38$export$8e16b83750b44988)(defaults, options, options.variables && {
        variables: (0, $2f3cebf1a05c1b38$export$8e16b83750b44988)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, defaults && defaults.variables), options.variables))
    });
}



var $9cf0de8518e6cdc4$var$hasSuggestedDevtools = false;
/**
 * This is the primary Apollo Client class. It is used to send GraphQL documents (i.e. queries
 * and mutations) to a GraphQL spec-compliant server over an `ApolloLink` instance,
 * receive results from the server and cache the results in a store. It also delivers updates
 * to GraphQL queries through `Observable` instances.
 */ var $9cf0de8518e6cdc4$export$13f5a5f0f1dbab88 = /** @class */ function() {
    /**
     * Constructs an instance of `ApolloClient`.
     *
     * @example
     * ```js
     * import { ApolloClient, InMemoryCache } from '@apollo/client';
     *
     * const cache = new InMemoryCache();
     *
     * const client = new ApolloClient({
     *   // Provide required constructor fields
     *   cache: cache,
     *   uri: 'http://localhost:4000/',
     *
     *   // Provide some optional constructor fields
     *   name: 'react-web-client',
     *   version: '1.3',
     *   queryDeduplication: false,
     *   defaultOptions: {
     *     watchQuery: {
     *       fetchPolicy: 'cache-and-network',
     *     },
     *   },
     * });
     * ```
     */ function ApolloClient(options) {
        var _this = this;
        var _a;
        this.resetStoreCallbacks = [];
        this.clearStoreCallbacks = [];
        if (!options.cache) throw (0, $28d90d877eb1e517$export$3991762405098ea)(15);
        var uri = options.uri, credentials = options.credentials, headers = options.headers, cache = options.cache, documentTransform = options.documentTransform, _b = options.ssrMode, ssrMode = _b === void 0 ? false : _b, _c = options.ssrForceFetchDelay, ssrForceFetchDelay = _c === void 0 ? 0 : _c, // Expose the client instance as window.__APOLLO_CLIENT__ and call
        // onBroadcast in queryManager.broadcastQueries to enable browser
        // devtools, but disable them by default in production.
        connectToDevTools = options.connectToDevTools, _d = options.queryDeduplication, queryDeduplication = _d === void 0 ? true : _d, defaultOptions = options.defaultOptions, defaultContext = options.defaultContext, _e = options.assumeImmutableResults, assumeImmutableResults = _e === void 0 ? cache.assumeImmutableResults : _e, resolvers = options.resolvers, typeDefs = options.typeDefs, fragmentMatcher = options.fragmentMatcher, clientAwarenessName = options.name, clientAwarenessVersion = options.version, devtools = options.devtools;
        var link = options.link;
        if (!link) link = uri ? new (0, $4c2d109245a5920b$export$f4bbf1aec241cc1)({
            uri: uri,
            credentials: credentials,
            headers: headers
        }) : (0, $60c07ffd02e3617d$export$2fed3d61f740bc7f).empty();
        this.link = link;
        this.cache = cache;
        this.disableNetworkFetches = ssrMode || ssrForceFetchDelay > 0;
        this.queryDeduplication = queryDeduplication;
        this.defaultOptions = defaultOptions || Object.create(null);
        this.typeDefs = typeDefs;
        this.devtoolsConfig = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, devtools), {
            enabled: (_a = devtools === null || devtools === void 0 ? void 0 : devtools.enabled) !== null && _a !== void 0 ? _a : connectToDevTools
        });
        if (this.devtoolsConfig.enabled === undefined) this.devtoolsConfig.enabled = globalThis.__DEV__ !== false;
        if (ssrForceFetchDelay) setTimeout(function() {
            return _this.disableNetworkFetches = false;
        }, ssrForceFetchDelay);
        this.watchQuery = this.watchQuery.bind(this);
        this.query = this.query.bind(this);
        this.mutate = this.mutate.bind(this);
        this.watchFragment = this.watchFragment.bind(this);
        this.resetStore = this.resetStore.bind(this);
        this.reFetchObservableQueries = this.reFetchObservableQueries.bind(this);
        this.version = (0, $fb2c94d2c044c7c5$export$83d89fbfd8236492);
        this.localState = new (0, $99c0c2fd8aedf706$export$19901bcd339c3ded)({
            cache: cache,
            client: this,
            resolvers: resolvers,
            fragmentMatcher: fragmentMatcher
        });
        this.queryManager = new (0, $957978b378afd274$export$b986383a50b53ea4)({
            cache: this.cache,
            link: this.link,
            defaultOptions: this.defaultOptions,
            defaultContext: defaultContext,
            documentTransform: documentTransform,
            queryDeduplication: queryDeduplication,
            ssrMode: ssrMode,
            clientAwareness: {
                name: clientAwarenessName,
                version: clientAwarenessVersion
            },
            localState: this.localState,
            assumeImmutableResults: assumeImmutableResults,
            onBroadcast: this.devtoolsConfig.enabled ? function() {
                if (_this.devToolsHookCb) _this.devToolsHookCb({
                    action: {},
                    state: {
                        queries: _this.queryManager.getQueryStore(),
                        mutations: _this.queryManager.mutationStore || {}
                    },
                    dataWithOptimisticResults: _this.cache.extract(true)
                });
            } : void 0
        });
        if (this.devtoolsConfig.enabled) this.connectToDevTools();
    }
    ApolloClient.prototype.connectToDevTools = function() {
        if (typeof window === "undefined") return;
        var windowWithDevTools = window;
        var devtoolsSymbol = Symbol.for("apollo.devtools");
        (windowWithDevTools[devtoolsSymbol] = windowWithDevTools[devtoolsSymbol] || []).push(this);
        windowWithDevTools.__APOLLO_CLIENT__ = this;
        /**
         * Suggest installing the devtools for developers who don't have them
         */ if (!$9cf0de8518e6cdc4$var$hasSuggestedDevtools && globalThis.__DEV__ !== false) {
            $9cf0de8518e6cdc4$var$hasSuggestedDevtools = true;
            if (window.document && window.top === window.self && /^(https?|file):$/.test(window.location.protocol)) setTimeout(function() {
                if (!window.__APOLLO_DEVTOOLS_GLOBAL_HOOK__) {
                    var nav = window.navigator;
                    var ua = nav && nav.userAgent;
                    var url = void 0;
                    if (typeof ua === "string") {
                        if (ua.indexOf("Chrome/") > -1) url = "https://chrome.google.com/webstore/detail/apollo-client-developer-t/jdkknkkbebbapilgoeccciglkfbmbnfm";
                        else if (ua.indexOf("Firefox/") > -1) url = "https://addons.mozilla.org/en-US/firefox/addon/apollo-developer-tools/";
                    }
                    if (url) globalThis.__DEV__ !== false && (0, $28d90d877eb1e517$export$f5708dca728d7177).log("Download the Apollo DevTools for a better development experience: %s", url);
                }
            }, 10000);
        }
    };
    Object.defineProperty(ApolloClient.prototype, "documentTransform", {
        /**
         * The `DocumentTransform` used to modify GraphQL documents before a request
         * is made. If a custom `DocumentTransform` is not provided, this will be the
         * default document transform.
         */ get: function() {
            return this.queryManager.documentTransform;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Call this method to terminate any active client processes, making it safe
     * to dispose of this `ApolloClient` instance.
     */ ApolloClient.prototype.stop = function() {
        this.queryManager.stop();
    };
    /**
     * This watches the cache store of the query according to the options specified and
     * returns an `ObservableQuery`. We can subscribe to this `ObservableQuery` and
     * receive updated results through an observer when the cache store changes.
     *
     * Note that this method is not an implementation of GraphQL subscriptions. Rather,
     * it uses Apollo's store in order to reactively deliver updates to your query results.
     *
     * For example, suppose you call watchQuery on a GraphQL query that fetches a person's
     * first and last name and this person has a particular object identifier, provided by
     * dataIdFromObject. Later, a different query fetches that same person's
     * first and last name and the first name has now changed. Then, any observers associated
     * with the results of the first query will be updated with a new result object.
     *
     * Note that if the cache does not change, the subscriber will *not* be notified.
     *
     * See [here](https://medium.com/apollo-stack/the-concepts-of-graphql-bc68bd819be3#.3mb0cbcmc) for
     * a description of store reactivity.
     */ ApolloClient.prototype.watchQuery = function(options) {
        if (this.defaultOptions.watchQuery) options = (0, $1a9f9b47c9ebef70$export$235b7fc70b9fc359)(this.defaultOptions.watchQuery, options);
        // XXX Overwriting options is probably not the best way to do this long term...
        if (this.disableNetworkFetches && (options.fetchPolicy === "network-only" || options.fetchPolicy === "cache-and-network")) options = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, options), {
            fetchPolicy: "cache-first"
        });
        return this.queryManager.watchQuery(options);
    };
    /**
     * This resolves a single query according to the options specified and
     * returns a `Promise` which is either resolved with the resulting data
     * or rejected with an error.
     *
     * @param options - An object of type `QueryOptions` that allows us to
     * describe how this query should be treated e.g. whether it should hit the
     * server at all or just resolve from the cache, etc.
     */ ApolloClient.prototype.query = function(options) {
        if (this.defaultOptions.query) options = (0, $1a9f9b47c9ebef70$export$235b7fc70b9fc359)(this.defaultOptions.query, options);
        (0, $28d90d877eb1e517$export$f5708dca728d7177)(options.fetchPolicy !== "cache-and-network", 16);
        if (this.disableNetworkFetches && options.fetchPolicy === "network-only") options = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, options), {
            fetchPolicy: "cache-first"
        });
        return this.queryManager.query(options);
    };
    /**
     * This resolves a single mutation according to the options specified and returns a
     * Promise which is either resolved with the resulting data or rejected with an
     * error. In some cases both `data` and `errors` might be undefined, for example
     * when `errorPolicy` is set to `'ignore'`.
     *
     * It takes options as an object with the following keys and values:
     */ ApolloClient.prototype.mutate = function(options) {
        if (this.defaultOptions.mutate) options = (0, $1a9f9b47c9ebef70$export$235b7fc70b9fc359)(this.defaultOptions.mutate, options);
        return this.queryManager.mutate(options);
    };
    /**
     * This subscribes to a graphql subscription according to the options specified and returns an
     * `Observable` which either emits received data or an error.
     */ ApolloClient.prototype.subscribe = function(options) {
        return this.queryManager.startGraphQLSubscription(options);
    };
    /**
     * Tries to read some data from the store in the shape of the provided
     * GraphQL query without making a network request. This method will start at
     * the root query. To start at a specific id returned by `dataIdFromObject`
     * use `readFragment`.
     *
     * @param optimistic - Set to `true` to allow `readQuery` to return
     * optimistic results. Is `false` by default.
     */ ApolloClient.prototype.readQuery = function(options, optimistic) {
        if (optimistic === void 0) optimistic = false;
        return this.cache.readQuery(options, optimistic);
    };
    /**
     * Watches the cache store of the fragment according to the options specified
     * and returns an `Observable`. We can subscribe to this
     * `Observable` and receive updated results through an
     * observer when the cache store changes.
     *
     * You must pass in a GraphQL document with a single fragment or a document
     * with multiple fragments that represent what you are reading. If you pass
     * in a document with multiple fragments then you must also specify a
     * `fragmentName`.
     *
     * @since 3.10.0
     * @param options - An object of type `WatchFragmentOptions` that allows
     * the cache to identify the fragment and optionally specify whether to react
     * to optimistic updates.
     */ ApolloClient.prototype.watchFragment = function(options) {
        return this.cache.watchFragment(options);
    };
    /**
     * Tries to read some data from the store in the shape of the provided
     * GraphQL fragment without making a network request. This method will read a
     * GraphQL fragment from any arbitrary id that is currently cached, unlike
     * `readQuery` which will only read from the root query.
     *
     * You must pass in a GraphQL document with a single fragment or a document
     * with multiple fragments that represent what you are reading. If you pass
     * in a document with multiple fragments then you must also specify a
     * `fragmentName`.
     *
     * @param optimistic - Set to `true` to allow `readFragment` to return
     * optimistic results. Is `false` by default.
     */ ApolloClient.prototype.readFragment = function(options, optimistic) {
        if (optimistic === void 0) optimistic = false;
        return this.cache.readFragment(options, optimistic);
    };
    /**
     * Writes some data in the shape of the provided GraphQL query directly to
     * the store. This method will start at the root query. To start at a
     * specific id returned by `dataIdFromObject` then use `writeFragment`.
     */ ApolloClient.prototype.writeQuery = function(options) {
        var ref = this.cache.writeQuery(options);
        if (options.broadcast !== false) this.queryManager.broadcastQueries();
        return ref;
    };
    /**
     * Writes some data in the shape of the provided GraphQL fragment directly to
     * the store. This method will write to a GraphQL fragment from any arbitrary
     * id that is currently cached, unlike `writeQuery` which will only write
     * from the root query.
     *
     * You must pass in a GraphQL document with a single fragment or a document
     * with multiple fragments that represent what you are writing. If you pass
     * in a document with multiple fragments then you must also specify a
     * `fragmentName`.
     */ ApolloClient.prototype.writeFragment = function(options) {
        var ref = this.cache.writeFragment(options);
        if (options.broadcast !== false) this.queryManager.broadcastQueries();
        return ref;
    };
    ApolloClient.prototype.__actionHookForDevTools = function(cb) {
        this.devToolsHookCb = cb;
    };
    ApolloClient.prototype.__requestRaw = function(payload) {
        return (0, $88c17748fb93d3ed$export$51396ec711da548b)(this.link, payload);
    };
    /**
     * Resets your entire store by clearing out your cache and then re-executing
     * all of your active queries. This makes it so that you may guarantee that
     * there is no data left in your store from a time before you called this
     * method.
     *
     * `resetStore()` is useful when your user just logged out. You’ve removed the
     * user session, and you now want to make sure that any references to data you
     * might have fetched while the user session was active is gone.
     *
     * It is important to remember that `resetStore()` *will* refetch any active
     * queries. This means that any components that might be mounted will execute
     * their queries again using your network interface. If you do not want to
     * re-execute any queries then you should make sure to stop watching any
     * active queries.
     */ ApolloClient.prototype.resetStore = function() {
        var _this = this;
        return Promise.resolve().then(function() {
            return _this.queryManager.clearStore({
                discardWatches: false
            });
        }).then(function() {
            return Promise.all(_this.resetStoreCallbacks.map(function(fn) {
                return fn();
            }));
        }).then(function() {
            return _this.reFetchObservableQueries();
        });
    };
    /**
     * Remove all data from the store. Unlike `resetStore`, `clearStore` will
     * not refetch any active queries.
     */ ApolloClient.prototype.clearStore = function() {
        var _this = this;
        return Promise.resolve().then(function() {
            return _this.queryManager.clearStore({
                discardWatches: true
            });
        }).then(function() {
            return Promise.all(_this.clearStoreCallbacks.map(function(fn) {
                return fn();
            }));
        });
    };
    /**
     * Allows callbacks to be registered that are executed when the store is
     * reset. `onResetStore` returns an unsubscribe function that can be used
     * to remove registered callbacks.
     */ ApolloClient.prototype.onResetStore = function(cb) {
        var _this = this;
        this.resetStoreCallbacks.push(cb);
        return function() {
            _this.resetStoreCallbacks = _this.resetStoreCallbacks.filter(function(c) {
                return c !== cb;
            });
        };
    };
    /**
     * Allows callbacks to be registered that are executed when the store is
     * cleared. `onClearStore` returns an unsubscribe function that can be used
     * to remove registered callbacks.
     */ ApolloClient.prototype.onClearStore = function(cb) {
        var _this = this;
        this.clearStoreCallbacks.push(cb);
        return function() {
            _this.clearStoreCallbacks = _this.clearStoreCallbacks.filter(function(c) {
                return c !== cb;
            });
        };
    };
    /**
     * Refetches all of your active queries.
     *
     * `reFetchObservableQueries()` is useful if you want to bring the client back to proper state in case of a network outage
     *
     * It is important to remember that `reFetchObservableQueries()` *will* refetch any active
     * queries. This means that any components that might be mounted will execute
     * their queries again using your network interface. If you do not want to
     * re-execute any queries then you should make sure to stop watching any
     * active queries.
     * Takes optional parameter `includeStandby` which will include queries in standby-mode when refetching.
     */ ApolloClient.prototype.reFetchObservableQueries = function(includeStandby) {
        return this.queryManager.reFetchObservableQueries(includeStandby);
    };
    /**
     * Refetches specified active queries. Similar to "reFetchObservableQueries()" but with a specific list of queries.
     *
     * `refetchQueries()` is useful for use cases to imperatively refresh a selection of queries.
     *
     * It is important to remember that `refetchQueries()` *will* refetch specified active
     * queries. This means that any components that might be mounted will execute
     * their queries again using your network interface. If you do not want to
     * re-execute any queries then you should make sure to stop watching any
     * active queries.
     */ ApolloClient.prototype.refetchQueries = function(options) {
        var map = this.queryManager.refetchQueries(options);
        var queries = [];
        var results = [];
        map.forEach(function(result, obsQuery) {
            queries.push(obsQuery);
            results.push(result);
        });
        var result = Promise.all(results);
        // In case you need the raw results immediately, without awaiting
        // Promise.all(results):
        result.queries = queries;
        result.results = results;
        // If you decide to ignore the result Promise because you're using
        // result.queries and result.results instead, you shouldn't have to worry
        // about preventing uncaught rejections for the Promise.all result.
        result.catch(function(error) {
            globalThis.__DEV__ !== false && (0, $28d90d877eb1e517$export$f5708dca728d7177).debug(17, error);
        });
        return result;
    };
    /**
     * Get all currently active `ObservableQuery` objects, in a `Map` keyed by
     * query ID strings.
     *
     * An "active" query is one that has observers and a `fetchPolicy` other than
     * "standby" or "cache-only".
     *
     * You can include all `ObservableQuery` objects (including the inactive ones)
     * by passing "all" instead of "active", or you can include just a subset of
     * active queries by passing an array of query names or DocumentNode objects.
     */ ApolloClient.prototype.getObservableQueries = function(include) {
        if (include === void 0) include = "active";
        return this.queryManager.getObservableQueries(include);
    };
    /**
     * Exposes the cache's complete state, in a serializable format for later restoration.
     */ ApolloClient.prototype.extract = function(optimistic) {
        return this.cache.extract(optimistic);
    };
    /**
     * Replaces existing state in the cache (if any) with the values expressed by
     * `serializedState`.
     *
     * Called when hydrating a cache (server side rendering, or offline storage),
     * and also (potentially) during hot reloads.
     */ ApolloClient.prototype.restore = function(serializedState) {
        return this.cache.restore(serializedState);
    };
    /**
     * Add additional local resolvers.
     */ ApolloClient.prototype.addResolvers = function(resolvers) {
        this.localState.addResolvers(resolvers);
    };
    /**
     * Set (override existing) local resolvers.
     */ ApolloClient.prototype.setResolvers = function(resolvers) {
        this.localState.setResolvers(resolvers);
    };
    /**
     * Get all registered local resolvers.
     */ ApolloClient.prototype.getResolvers = function() {
        return this.localState.getResolvers();
    };
    /**
     * Set a custom local state fragment matcher.
     */ ApolloClient.prototype.setLocalStateFragmentMatcher = function(fragmentMatcher) {
        this.localState.setFragmentMatcher(fragmentMatcher);
    };
    /**
     * Define a new ApolloLink (or link chain) that Apollo Client will use.
     */ ApolloClient.prototype.setLink = function(newLink) {
        this.link = this.queryManager.link = newLink;
    };
    Object.defineProperty(ApolloClient.prototype, "defaultContext", {
        get: function() {
            return this.queryManager.defaultContext;
        },
        enumerable: false,
        configurable: true
    });
    return ApolloClient;
}();
if (globalThis.__DEV__ !== false) $9cf0de8518e6cdc4$export$13f5a5f0f1dbab88.prototype.getMemoryInternals = (0, $1da01699264b6e1e$export$dfdba94ce46d2ea5);



var $69607e38bd2400f2$exports = {};
"use strict";
// We don't want bundlers to error when they encounter usage of any of these exports.
// It's up to the package author to ensure that if they access React internals,
// they do so in a safe way that won't break if React changes how they use these internals.
// (e.g. only access them in development, and only in an optional way that won't
// break if internals are not there or do not have the expected structure)
// @ts-ignore
$69607e38bd2400f2$exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = undefined;
// @ts-ignore
$69607e38bd2400f2$exports.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE = undefined;
// @ts-ignore
$69607e38bd2400f2$exports.__SERVER_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE = undefined;

// Here we actually pull in the React library and add everything
// it exports to our own `module.exports`.
// If React suddenly were to add one of the above "polyfilled" exports,
// the React version would overwrite our version, so this should be
// future-proof.
Object.assign($69607e38bd2400f2$exports, (parcelRequire("acw62")));





// To make sure Apollo Client doesn't create more than one React context
// (which can lead to problems like having an Apollo Client instance added
// in one context, then attempting to retrieve it from another different
// context), a single Apollo context is created and tracked in global state.
var $14505e8b7f660318$var$contextKey = (0, $5d0a073f980bb2a3$export$23ba675b4b838b92) ? Symbol.for("__APOLLO_CONTEXT__") : "__APOLLO_CONTEXT__";
function $14505e8b7f660318$export$a47505d961ee3a1() {
    (0, $28d90d877eb1e517$export$f5708dca728d7177)("createContext" in $69607e38bd2400f2$exports, 46);
    var context = $69607e38bd2400f2$exports.createContext[$14505e8b7f660318$var$contextKey];
    if (!context) {
        Object.defineProperty($69607e38bd2400f2$exports.createContext, $14505e8b7f660318$var$contextKey, {
            value: context = $69607e38bd2400f2$exports.createContext({}),
            enumerable: false,
            writable: false,
            configurable: true
        });
        context.displayName = "ApolloContext";
    }
    return context;
}
var $14505e8b7f660318$export$c2ee824bcc89ca6a = $14505e8b7f660318$export$a47505d961ee3a1;


var $93ef3346b14b7851$export$c16b04c8a9956446 = function(_a) {
    var client = _a.client, children = _a.children;
    var ApolloContext = (0, $14505e8b7f660318$export$a47505d961ee3a1)();
    var parentContext = $69607e38bd2400f2$exports.useContext(ApolloContext);
    var context = $69607e38bd2400f2$exports.useMemo(function() {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, parentContext), {
            client: client || parentContext.client
        });
    }, [
        parentContext,
        client
    ]);
    (0, $28d90d877eb1e517$export$f5708dca728d7177)(context.client, 47);
    return $69607e38bd2400f2$exports.createElement(ApolloContext.Provider, {
        value: context
    }, children);
};


/**
 * Return true if `value` is object-like. A value is object-like if it's not
 * `null` and has a `typeof` result of "object".
 */ function $f419306d4be7fb23$export$c10d0b04eaa80a43(value) {
    return typeof value == 'object' && value !== null;
}


function $0989dd6156f69013$export$f5708dca728d7177(condition, message) {
    const booleanCondition = Boolean(condition);
    if (!booleanCondition) throw new Error(message != null ? message : 'Unexpected invariant triggered.');
}


const $151337c9f32f7005$var$LineRegExp = /\r\n|[\n\r]/g;
function $151337c9f32f7005$export$e7fd20fad3cf4b5f(source, position) {
    let lastLineStart = 0;
    let line = 1;
    for (const match of source.body.matchAll($151337c9f32f7005$var$LineRegExp)){
        typeof match.index === 'number' || (0, $0989dd6156f69013$export$f5708dca728d7177)(false);
        if (match.index >= position) break;
        lastLineStart = match.index + match[0].length;
        line += 1;
    }
    return {
        line: line,
        column: position + 1 - lastLineStart
    };
}



function $a45c53fbf464b798$export$96a9681e539deed(location) {
    return $a45c53fbf464b798$export$867940333fd9f869(location.source, (0, $151337c9f32f7005$export$e7fd20fad3cf4b5f)(location.source, location.start));
}
function $a45c53fbf464b798$export$867940333fd9f869(source, sourceLocation) {
    const firstLineColumnOffset = source.locationOffset.column - 1;
    const body = ''.padStart(firstLineColumnOffset) + source.body;
    const lineIndex = sourceLocation.line - 1;
    const lineOffset = source.locationOffset.line - 1;
    const lineNum = sourceLocation.line + lineOffset;
    const columnOffset = sourceLocation.line === 1 ? firstLineColumnOffset : 0;
    const columnNum = sourceLocation.column + columnOffset;
    const locationStr = `${source.name}:${lineNum}:${columnNum}\n`;
    const lines = body.split(/\r\n|[\n\r]/g);
    const locationLine = lines[lineIndex]; // Special case for minified documents
    if (locationLine.length > 120) {
        const subLineIndex = Math.floor(columnNum / 80);
        const subLineColumnNum = columnNum % 80;
        const subLines = [];
        for(let i = 0; i < locationLine.length; i += 80)subLines.push(locationLine.slice(i, i + 80));
        return locationStr + $a45c53fbf464b798$var$printPrefixedLines([
            [
                `${lineNum} |`,
                subLines[0]
            ],
            ...subLines.slice(1, subLineIndex + 1).map((subLine)=>[
                    '|',
                    subLine
                ]),
            [
                '|',
                '^'.padStart(subLineColumnNum)
            ],
            [
                '|',
                subLines[subLineIndex + 1]
            ]
        ]);
    }
    return locationStr + $a45c53fbf464b798$var$printPrefixedLines([
        // Lines specified like this: ["prefix", "string"],
        [
            `${lineNum - 1} |`,
            lines[lineIndex - 1]
        ],
        [
            `${lineNum} |`,
            locationLine
        ],
        [
            '|',
            '^'.padStart(columnNum)
        ],
        [
            `${lineNum + 1} |`,
            lines[lineIndex + 1]
        ]
    ]);
}
function $a45c53fbf464b798$var$printPrefixedLines(lines) {
    const existingLines = lines.filter(([_, line])=>line !== undefined);
    const padLen = Math.max(...existingLines.map(([prefix])=>prefix.length));
    return existingLines.map(([prefix, line])=>prefix.padStart(padLen) + (line ? ' ' + line : '')).join('\n');
}


function $52f13d37c0305dc6$var$toNormalizedOptions(args) {
    const firstArg = args[0];
    if (firstArg == null || 'kind' in firstArg || 'length' in firstArg) return {
        nodes: firstArg,
        source: args[1],
        positions: args[2],
        path: args[3],
        originalError: args[4],
        extensions: args[5]
    };
    return firstArg;
}
class $52f13d37c0305dc6$export$92d6ed0888e7cb7f extends Error {
    /**
   * An array of `{ line, column }` locations within the source GraphQL document
   * which correspond to this error.
   *
   * Errors during validation often contain multiple locations, for example to
   * point out two things with the same name. Errors during execution include a
   * single location, the field which produced the error.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */ /**
   * An array describing the JSON-path into the execution response which
   * corresponds to this error. Only included for errors during execution.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */ /**
   * An array of GraphQL AST Nodes corresponding to this error.
   */ /**
   * The source GraphQL document for the first location of this error.
   *
   * Note that if this Error represents more than one node, the source may not
   * represent nodes after the first node.
   */ /**
   * An array of character offsets within the source GraphQL document
   * which correspond to this error.
   */ /**
   * The original error thrown from a field resolver during execution.
   */ /**
   * Extension fields to add to the formatted error.
   */ /**
   * @deprecated Please use the `GraphQLErrorOptions` constructor overload instead.
   */ constructor(message, ...rawArgs){
        var _this$nodes, _nodeLocations$, _ref;
        const { nodes: nodes, source: source, positions: positions, path: path, originalError: originalError, extensions: extensions } = $52f13d37c0305dc6$var$toNormalizedOptions(rawArgs);
        super(message);
        this.name = 'GraphQLError';
        this.path = path !== null && path !== void 0 ? path : undefined;
        this.originalError = originalError !== null && originalError !== void 0 ? originalError : undefined; // Compute list of blame nodes.
        this.nodes = $52f13d37c0305dc6$var$undefinedIfEmpty(Array.isArray(nodes) ? nodes : nodes ? [
            nodes
        ] : undefined);
        const nodeLocations = $52f13d37c0305dc6$var$undefinedIfEmpty((_this$nodes = this.nodes) === null || _this$nodes === void 0 ? void 0 : _this$nodes.map((node)=>node.loc).filter((loc)=>loc != null)); // Compute locations in the source for the given nodes/positions.
        this.source = source !== null && source !== void 0 ? source : nodeLocations === null || nodeLocations === void 0 ? void 0 : (_nodeLocations$ = nodeLocations[0]) === null || _nodeLocations$ === void 0 ? void 0 : _nodeLocations$.source;
        this.positions = positions !== null && positions !== void 0 ? positions : nodeLocations === null || nodeLocations === void 0 ? void 0 : nodeLocations.map((loc)=>loc.start);
        this.locations = positions && source ? positions.map((pos)=>(0, $151337c9f32f7005$export$e7fd20fad3cf4b5f)(source, pos)) : nodeLocations === null || nodeLocations === void 0 ? void 0 : nodeLocations.map((loc)=>(0, $151337c9f32f7005$export$e7fd20fad3cf4b5f)(loc.source, loc.start));
        const originalExtensions = (0, $f419306d4be7fb23$export$c10d0b04eaa80a43)(originalError === null || originalError === void 0 ? void 0 : originalError.extensions) ? originalError === null || originalError === void 0 ? void 0 : originalError.extensions : undefined;
        this.extensions = (_ref = extensions !== null && extensions !== void 0 ? extensions : originalExtensions) !== null && _ref !== void 0 ? _ref : Object.create(null); // Only properties prescribed by the spec should be enumerable.
        // Keep the rest as non-enumerable.
        Object.defineProperties(this, {
            message: {
                writable: true,
                enumerable: true
            },
            name: {
                enumerable: false
            },
            nodes: {
                enumerable: false
            },
            source: {
                enumerable: false
            },
            positions: {
                enumerable: false
            },
            originalError: {
                enumerable: false
            }
        }); // Include (non-enumerable) stack trace.
        /* c8 ignore start */ // FIXME: https://github.com/graphql/graphql-js/issues/2317
        if (originalError !== null && originalError !== void 0 && originalError.stack) Object.defineProperty(this, 'stack', {
            value: originalError.stack,
            writable: true,
            configurable: true
        });
        else if (Error.captureStackTrace) Error.captureStackTrace(this, $52f13d37c0305dc6$export$92d6ed0888e7cb7f);
        else Object.defineProperty(this, 'stack', {
            value: Error().stack,
            writable: true,
            configurable: true
        });
    /* c8 ignore stop */ }
    get [Symbol.toStringTag]() {
        return 'GraphQLError';
    }
    toString() {
        let output = this.message;
        if (this.nodes) {
            for (const node of this.nodes)if (node.loc) output += '\n\n' + (0, $a45c53fbf464b798$export$96a9681e539deed)(node.loc);
        } else if (this.source && this.locations) for (const location of this.locations)output += '\n\n' + (0, $a45c53fbf464b798$export$867940333fd9f869)(this.source, location);
        return output;
    }
    toJSON() {
        const formattedError = {
            message: this.message
        };
        if (this.locations != null) formattedError.locations = this.locations;
        if (this.path != null) formattedError.path = this.path;
        if (this.extensions != null && Object.keys(this.extensions).length > 0) formattedError.extensions = this.extensions;
        return formattedError;
    }
}
function $52f13d37c0305dc6$var$undefinedIfEmpty(array) {
    return array === undefined || array.length === 0 ? undefined : array;
}
function $52f13d37c0305dc6$export$55ee1551a3f962e6(error) {
    return error.toString();
}
function $52f13d37c0305dc6$export$7b5b869ee98c16ab(error) {
    return error.toJSON();
}


function $ddf6b9f696b0d6b2$export$bbee0c6176c019d4(source, position, description) {
    return new (0, $52f13d37c0305dc6$export$92d6ed0888e7cb7f)(`Syntax Error: ${description}`, {
        source: source,
        positions: [
            position
        ]
    });
}



/**
 * The set of allowed directive location values.
 */ var $289bf729a82494c6$export$b45ffd2948484c41;
(function(DirectiveLocation) {
    DirectiveLocation['QUERY'] = 'QUERY';
    DirectiveLocation['MUTATION'] = 'MUTATION';
    DirectiveLocation['SUBSCRIPTION'] = 'SUBSCRIPTION';
    DirectiveLocation['FIELD'] = 'FIELD';
    DirectiveLocation['FRAGMENT_DEFINITION'] = 'FRAGMENT_DEFINITION';
    DirectiveLocation['FRAGMENT_SPREAD'] = 'FRAGMENT_SPREAD';
    DirectiveLocation['INLINE_FRAGMENT'] = 'INLINE_FRAGMENT';
    DirectiveLocation['VARIABLE_DEFINITION'] = 'VARIABLE_DEFINITION';
    DirectiveLocation['SCHEMA'] = 'SCHEMA';
    DirectiveLocation['SCALAR'] = 'SCALAR';
    DirectiveLocation['OBJECT'] = 'OBJECT';
    DirectiveLocation['FIELD_DEFINITION'] = 'FIELD_DEFINITION';
    DirectiveLocation['ARGUMENT_DEFINITION'] = 'ARGUMENT_DEFINITION';
    DirectiveLocation['INTERFACE'] = 'INTERFACE';
    DirectiveLocation['UNION'] = 'UNION';
    DirectiveLocation['ENUM'] = 'ENUM';
    DirectiveLocation['ENUM_VALUE'] = 'ENUM_VALUE';
    DirectiveLocation['INPUT_OBJECT'] = 'INPUT_OBJECT';
    DirectiveLocation['INPUT_FIELD_DEFINITION'] = 'INPUT_FIELD_DEFINITION';
})($289bf729a82494c6$export$b45ffd2948484c41 || ($289bf729a82494c6$export$b45ffd2948484c41 = {}));
 /**
 * The enum type representing the directive location values.
 *
 * @deprecated Please use `DirectiveLocation`. Will be remove in v17.
 */ 






/**
 * An exported enum describing the different kinds of tokens that the
 * lexer emits.
 */ var $ac240aaa94caf15d$export$8b9d26ab11394711;
(function(TokenKind) {
    TokenKind['SOF'] = '<SOF>';
    TokenKind['EOF'] = '<EOF>';
    TokenKind['BANG'] = '!';
    TokenKind['DOLLAR'] = '$';
    TokenKind['AMP'] = '&';
    TokenKind['PAREN_L'] = '(';
    TokenKind['PAREN_R'] = ')';
    TokenKind['SPREAD'] = '...';
    TokenKind['COLON'] = ':';
    TokenKind['EQUALS'] = '=';
    TokenKind['AT'] = '@';
    TokenKind['BRACKET_L'] = '[';
    TokenKind['BRACKET_R'] = ']';
    TokenKind['BRACE_L'] = '{';
    TokenKind['PIPE'] = '|';
    TokenKind['BRACE_R'] = '}';
    TokenKind['NAME'] = 'Name';
    TokenKind['INT'] = 'Int';
    TokenKind['FLOAT'] = 'Float';
    TokenKind['STRING'] = 'String';
    TokenKind['BLOCK_STRING'] = 'BlockString';
    TokenKind['COMMENT'] = 'Comment';
})($ac240aaa94caf15d$export$8b9d26ab11394711 || ($ac240aaa94caf15d$export$8b9d26ab11394711 = {}));
 /**
 * The enum type representing the token kinds values.
 *
 * @deprecated Please use `TokenKind`. Will be remove in v17.
 */ 

class $971bc50063303b32$export$6168dc8908a6c652 {
    /**
   * The previously focused non-ignored token.
   */ /**
   * The currently focused non-ignored token.
   */ /**
   * The (1-indexed) line containing the current token.
   */ /**
   * The character offset at which the current line begins.
   */ constructor(source){
        const startOfFileToken = new (0, $11b06753ce50693f$export$50792b0e93539fde)((0, $ac240aaa94caf15d$export$8b9d26ab11394711).SOF, 0, 0, 0, 0);
        this.source = source;
        this.lastToken = startOfFileToken;
        this.token = startOfFileToken;
        this.line = 1;
        this.lineStart = 0;
    }
    get [Symbol.toStringTag]() {
        return 'Lexer';
    }
    /**
   * Advances the token stream to the next non-ignored token.
   */ advance() {
        this.lastToken = this.token;
        const token = this.token = this.lookahead();
        return token;
    }
    /**
   * Looks ahead and returns the next non-ignored token, but does not change
   * the state of Lexer.
   */ lookahead() {
        let token = this.token;
        if (token.kind !== (0, $ac240aaa94caf15d$export$8b9d26ab11394711).EOF) {
            do if (token.next) token = token.next;
            else {
                // Read the next token and form a link in the token linked-list.
                const nextToken = $971bc50063303b32$var$readNextToken(this, token.end); // @ts-expect-error next is only mutable during parsing.
                token.next = nextToken; // @ts-expect-error prev is only mutable during parsing.
                nextToken.prev = token;
                token = nextToken;
            }
            while (token.kind === (0, $ac240aaa94caf15d$export$8b9d26ab11394711).COMMENT);
        }
        return token;
    }
}
function $971bc50063303b32$export$59ac0f4da287406a(kind) {
    return kind === (0, $ac240aaa94caf15d$export$8b9d26ab11394711).BANG || kind === (0, $ac240aaa94caf15d$export$8b9d26ab11394711).DOLLAR || kind === (0, $ac240aaa94caf15d$export$8b9d26ab11394711).AMP || kind === (0, $ac240aaa94caf15d$export$8b9d26ab11394711).PAREN_L || kind === (0, $ac240aaa94caf15d$export$8b9d26ab11394711).PAREN_R || kind === (0, $ac240aaa94caf15d$export$8b9d26ab11394711).SPREAD || kind === (0, $ac240aaa94caf15d$export$8b9d26ab11394711).COLON || kind === (0, $ac240aaa94caf15d$export$8b9d26ab11394711).EQUALS || kind === (0, $ac240aaa94caf15d$export$8b9d26ab11394711).AT || kind === (0, $ac240aaa94caf15d$export$8b9d26ab11394711).BRACKET_L || kind === (0, $ac240aaa94caf15d$export$8b9d26ab11394711).BRACKET_R || kind === (0, $ac240aaa94caf15d$export$8b9d26ab11394711).BRACE_L || kind === (0, $ac240aaa94caf15d$export$8b9d26ab11394711).PIPE || kind === (0, $ac240aaa94caf15d$export$8b9d26ab11394711).BRACE_R;
}
/**
 * A Unicode scalar value is any Unicode code point except surrogate code
 * points. In other words, the inclusive ranges of values 0x0000 to 0xD7FF and
 * 0xE000 to 0x10FFFF.
 *
 * SourceCharacter ::
 *   - "Any Unicode scalar value"
 */ function $971bc50063303b32$var$isUnicodeScalarValue(code) {
    return code >= 0x0000 && code <= 0xd7ff || code >= 0xe000 && code <= 0x10ffff;
}
/**
 * The GraphQL specification defines source text as a sequence of unicode scalar
 * values (which Unicode defines to exclude surrogate code points). However
 * JavaScript defines strings as a sequence of UTF-16 code units which may
 * include surrogates. A surrogate pair is a valid source character as it
 * encodes a supplementary code point (above U+FFFF), but unpaired surrogate
 * code points are not valid source characters.
 */ function $971bc50063303b32$var$isSupplementaryCodePoint(body, location) {
    return $971bc50063303b32$var$isLeadingSurrogate(body.charCodeAt(location)) && $971bc50063303b32$var$isTrailingSurrogate(body.charCodeAt(location + 1));
}
function $971bc50063303b32$var$isLeadingSurrogate(code) {
    return code >= 0xd800 && code <= 0xdbff;
}
function $971bc50063303b32$var$isTrailingSurrogate(code) {
    return code >= 0xdc00 && code <= 0xdfff;
}
/**
 * Prints the code point (or end of file reference) at a given location in a
 * source for use in error messages.
 *
 * Printable ASCII is printed quoted, while other points are printed in Unicode
 * code point form (ie. U+1234).
 */ function $971bc50063303b32$var$printCodePointAt(lexer, location) {
    const code = lexer.source.body.codePointAt(location);
    if (code === undefined) return (0, $ac240aaa94caf15d$export$8b9d26ab11394711).EOF;
    else if (code >= 0x0020 && code <= 0x007e) {
        // Printable ASCII
        const char = String.fromCodePoint(code);
        return char === '"' ? "'\"'" : `"${char}"`;
    } // Unicode code point
    return 'U+' + code.toString(16).toUpperCase().padStart(4, '0');
}
/**
 * Create a token with line and column location information.
 */ function $971bc50063303b32$var$createToken(lexer, kind, start, end, value) {
    const line = lexer.line;
    const col = 1 + start - lexer.lineStart;
    return new (0, $11b06753ce50693f$export$50792b0e93539fde)(kind, start, end, line, col, value);
}
/**
 * Gets the next token from the source starting at the given position.
 *
 * This skips over whitespace until it finds the next lexable token, then lexes
 * punctuators immediately or calls the appropriate helper function for more
 * complicated tokens.
 */ function $971bc50063303b32$var$readNextToken(lexer, start) {
    const body = lexer.source.body;
    const bodyLength = body.length;
    let position = start;
    while(position < bodyLength){
        const code = body.charCodeAt(position); // SourceCharacter
        switch(code){
            // Ignored ::
            //   - UnicodeBOM
            //   - WhiteSpace
            //   - LineTerminator
            //   - Comment
            //   - Comma
            //
            // UnicodeBOM :: "Byte Order Mark (U+FEFF)"
            //
            // WhiteSpace ::
            //   - "Horizontal Tab (U+0009)"
            //   - "Space (U+0020)"
            //
            // Comma :: ,
            case 0xfeff:
            case 0x0009:
            case 0x0020:
            case 0x002c:
                // ,
                ++position;
                continue;
            // LineTerminator ::
            //   - "New Line (U+000A)"
            //   - "Carriage Return (U+000D)" [lookahead != "New Line (U+000A)"]
            //   - "Carriage Return (U+000D)" "New Line (U+000A)"
            case 0x000a:
                // \n
                ++position;
                ++lexer.line;
                lexer.lineStart = position;
                continue;
            case 0x000d:
                // \r
                if (body.charCodeAt(position + 1) === 0x000a) position += 2;
                else ++position;
                ++lexer.line;
                lexer.lineStart = position;
                continue;
            // Comment
            case 0x0023:
                // #
                return $971bc50063303b32$var$readComment(lexer, position);
            // Token ::
            //   - Punctuator
            //   - Name
            //   - IntValue
            //   - FloatValue
            //   - StringValue
            //
            // Punctuator :: one of ! $ & ( ) ... : = @ [ ] { | }
            case 0x0021:
                // !
                return $971bc50063303b32$var$createToken(lexer, (0, $ac240aaa94caf15d$export$8b9d26ab11394711).BANG, position, position + 1);
            case 0x0024:
                // $
                return $971bc50063303b32$var$createToken(lexer, (0, $ac240aaa94caf15d$export$8b9d26ab11394711).DOLLAR, position, position + 1);
            case 0x0026:
                // &
                return $971bc50063303b32$var$createToken(lexer, (0, $ac240aaa94caf15d$export$8b9d26ab11394711).AMP, position, position + 1);
            case 0x0028:
                // (
                return $971bc50063303b32$var$createToken(lexer, (0, $ac240aaa94caf15d$export$8b9d26ab11394711).PAREN_L, position, position + 1);
            case 0x0029:
                // )
                return $971bc50063303b32$var$createToken(lexer, (0, $ac240aaa94caf15d$export$8b9d26ab11394711).PAREN_R, position, position + 1);
            case 0x002e:
                // .
                if (body.charCodeAt(position + 1) === 0x002e && body.charCodeAt(position + 2) === 0x002e) return $971bc50063303b32$var$createToken(lexer, (0, $ac240aaa94caf15d$export$8b9d26ab11394711).SPREAD, position, position + 3);
                break;
            case 0x003a:
                // :
                return $971bc50063303b32$var$createToken(lexer, (0, $ac240aaa94caf15d$export$8b9d26ab11394711).COLON, position, position + 1);
            case 0x003d:
                // =
                return $971bc50063303b32$var$createToken(lexer, (0, $ac240aaa94caf15d$export$8b9d26ab11394711).EQUALS, position, position + 1);
            case 0x0040:
                // @
                return $971bc50063303b32$var$createToken(lexer, (0, $ac240aaa94caf15d$export$8b9d26ab11394711).AT, position, position + 1);
            case 0x005b:
                // [
                return $971bc50063303b32$var$createToken(lexer, (0, $ac240aaa94caf15d$export$8b9d26ab11394711).BRACKET_L, position, position + 1);
            case 0x005d:
                // ]
                return $971bc50063303b32$var$createToken(lexer, (0, $ac240aaa94caf15d$export$8b9d26ab11394711).BRACKET_R, position, position + 1);
            case 0x007b:
                // {
                return $971bc50063303b32$var$createToken(lexer, (0, $ac240aaa94caf15d$export$8b9d26ab11394711).BRACE_L, position, position + 1);
            case 0x007c:
                // |
                return $971bc50063303b32$var$createToken(lexer, (0, $ac240aaa94caf15d$export$8b9d26ab11394711).PIPE, position, position + 1);
            case 0x007d:
                // }
                return $971bc50063303b32$var$createToken(lexer, (0, $ac240aaa94caf15d$export$8b9d26ab11394711).BRACE_R, position, position + 1);
            // StringValue
            case 0x0022:
                // "
                if (body.charCodeAt(position + 1) === 0x0022 && body.charCodeAt(position + 2) === 0x0022) return $971bc50063303b32$var$readBlockString(lexer, position);
                return $971bc50063303b32$var$readString(lexer, position);
        } // IntValue | FloatValue (Digit | -)
        if ((0, $876b79dde797933a$export$727d9dbc4fbb948f)(code) || code === 0x002d) return $971bc50063303b32$var$readNumber(lexer, position, code);
         // Name
        if ((0, $876b79dde797933a$export$45a677ea7cb6d5c8)(code)) return $971bc50063303b32$var$readName(lexer, position);
        throw (0, $ddf6b9f696b0d6b2$export$bbee0c6176c019d4)(lexer.source, position, code === 0x0027 ? 'Unexpected single quote character (\'), did you mean to use a double quote (")?' : $971bc50063303b32$var$isUnicodeScalarValue(code) || $971bc50063303b32$var$isSupplementaryCodePoint(body, position) ? `Unexpected character: ${$971bc50063303b32$var$printCodePointAt(lexer, position)}.` : `Invalid character: ${$971bc50063303b32$var$printCodePointAt(lexer, position)}.`);
    }
    return $971bc50063303b32$var$createToken(lexer, (0, $ac240aaa94caf15d$export$8b9d26ab11394711).EOF, bodyLength, bodyLength);
}
/**
 * Reads a comment token from the source file.
 *
 * ```
 * Comment :: # CommentChar* [lookahead != CommentChar]
 *
 * CommentChar :: SourceCharacter but not LineTerminator
 * ```
 */ function $971bc50063303b32$var$readComment(lexer, start) {
    const body = lexer.source.body;
    const bodyLength = body.length;
    let position = start + 1;
    while(position < bodyLength){
        const code = body.charCodeAt(position); // LineTerminator (\n | \r)
        if (code === 0x000a || code === 0x000d) break;
         // SourceCharacter
        if ($971bc50063303b32$var$isUnicodeScalarValue(code)) ++position;
        else if ($971bc50063303b32$var$isSupplementaryCodePoint(body, position)) position += 2;
        else break;
    }
    return $971bc50063303b32$var$createToken(lexer, (0, $ac240aaa94caf15d$export$8b9d26ab11394711).COMMENT, start, position, body.slice(start + 1, position));
}
/**
 * Reads a number token from the source file, either a FloatValue or an IntValue
 * depending on whether a FractionalPart or ExponentPart is encountered.
 *
 * ```
 * IntValue :: IntegerPart [lookahead != {Digit, `.`, NameStart}]
 *
 * IntegerPart ::
 *   - NegativeSign? 0
 *   - NegativeSign? NonZeroDigit Digit*
 *
 * NegativeSign :: -
 *
 * NonZeroDigit :: Digit but not `0`
 *
 * FloatValue ::
 *   - IntegerPart FractionalPart ExponentPart [lookahead != {Digit, `.`, NameStart}]
 *   - IntegerPart FractionalPart [lookahead != {Digit, `.`, NameStart}]
 *   - IntegerPart ExponentPart [lookahead != {Digit, `.`, NameStart}]
 *
 * FractionalPart :: . Digit+
 *
 * ExponentPart :: ExponentIndicator Sign? Digit+
 *
 * ExponentIndicator :: one of `e` `E`
 *
 * Sign :: one of + -
 * ```
 */ function $971bc50063303b32$var$readNumber(lexer, start, firstCode) {
    const body = lexer.source.body;
    let position = start;
    let code = firstCode;
    let isFloat = false; // NegativeSign (-)
    if (code === 0x002d) code = body.charCodeAt(++position);
     // Zero (0)
    if (code === 0x0030) {
        code = body.charCodeAt(++position);
        if ((0, $876b79dde797933a$export$727d9dbc4fbb948f)(code)) throw (0, $ddf6b9f696b0d6b2$export$bbee0c6176c019d4)(lexer.source, position, `Invalid number, unexpected digit after 0: ${$971bc50063303b32$var$printCodePointAt(lexer, position)}.`);
    } else {
        position = $971bc50063303b32$var$readDigits(lexer, position, code);
        code = body.charCodeAt(position);
    } // Full stop (.)
    if (code === 0x002e) {
        isFloat = true;
        code = body.charCodeAt(++position);
        position = $971bc50063303b32$var$readDigits(lexer, position, code);
        code = body.charCodeAt(position);
    } // E e
    if (code === 0x0045 || code === 0x0065) {
        isFloat = true;
        code = body.charCodeAt(++position); // + -
        if (code === 0x002b || code === 0x002d) code = body.charCodeAt(++position);
        position = $971bc50063303b32$var$readDigits(lexer, position, code);
        code = body.charCodeAt(position);
    } // Numbers cannot be followed by . or NameStart
    if (code === 0x002e || (0, $876b79dde797933a$export$45a677ea7cb6d5c8)(code)) throw (0, $ddf6b9f696b0d6b2$export$bbee0c6176c019d4)(lexer.source, position, `Invalid number, expected digit but got: ${$971bc50063303b32$var$printCodePointAt(lexer, position)}.`);
    return $971bc50063303b32$var$createToken(lexer, isFloat ? (0, $ac240aaa94caf15d$export$8b9d26ab11394711).FLOAT : (0, $ac240aaa94caf15d$export$8b9d26ab11394711).INT, start, position, body.slice(start, position));
}
/**
 * Returns the new position in the source after reading one or more digits.
 */ function $971bc50063303b32$var$readDigits(lexer, start, firstCode) {
    if (!(0, $876b79dde797933a$export$727d9dbc4fbb948f)(firstCode)) throw (0, $ddf6b9f696b0d6b2$export$bbee0c6176c019d4)(lexer.source, start, `Invalid number, expected digit but got: ${$971bc50063303b32$var$printCodePointAt(lexer, start)}.`);
    const body = lexer.source.body;
    let position = start + 1; // +1 to skip first firstCode
    while((0, $876b79dde797933a$export$727d9dbc4fbb948f)(body.charCodeAt(position)))++position;
    return position;
}
/**
 * Reads a single-quote string token from the source file.
 *
 * ```
 * StringValue ::
 *   - `""` [lookahead != `"`]
 *   - `"` StringCharacter+ `"`
 *
 * StringCharacter ::
 *   - SourceCharacter but not `"` or `\` or LineTerminator
 *   - `\u` EscapedUnicode
 *   - `\` EscapedCharacter
 *
 * EscapedUnicode ::
 *   - `{` HexDigit+ `}`
 *   - HexDigit HexDigit HexDigit HexDigit
 *
 * EscapedCharacter :: one of `"` `\` `/` `b` `f` `n` `r` `t`
 * ```
 */ function $971bc50063303b32$var$readString(lexer, start) {
    const body = lexer.source.body;
    const bodyLength = body.length;
    let position = start + 1;
    let chunkStart = position;
    let value = '';
    while(position < bodyLength){
        const code = body.charCodeAt(position); // Closing Quote (")
        if (code === 0x0022) {
            value += body.slice(chunkStart, position);
            return $971bc50063303b32$var$createToken(lexer, (0, $ac240aaa94caf15d$export$8b9d26ab11394711).STRING, start, position + 1, value);
        } // Escape Sequence (\)
        if (code === 0x005c) {
            value += body.slice(chunkStart, position);
            const escape = body.charCodeAt(position + 1) === 0x0075 // u
             ? body.charCodeAt(position + 2) === 0x007b // {
             ? $971bc50063303b32$var$readEscapedUnicodeVariableWidth(lexer, position) : $971bc50063303b32$var$readEscapedUnicodeFixedWidth(lexer, position) : $971bc50063303b32$var$readEscapedCharacter(lexer, position);
            value += escape.value;
            position += escape.size;
            chunkStart = position;
            continue;
        } // LineTerminator (\n | \r)
        if (code === 0x000a || code === 0x000d) break;
         // SourceCharacter
        if ($971bc50063303b32$var$isUnicodeScalarValue(code)) ++position;
        else if ($971bc50063303b32$var$isSupplementaryCodePoint(body, position)) position += 2;
        else throw (0, $ddf6b9f696b0d6b2$export$bbee0c6176c019d4)(lexer.source, position, `Invalid character within String: ${$971bc50063303b32$var$printCodePointAt(lexer, position)}.`);
    }
    throw (0, $ddf6b9f696b0d6b2$export$bbee0c6176c019d4)(lexer.source, position, 'Unterminated string.');
} // The string value and lexed size of an escape sequence.
function $971bc50063303b32$var$readEscapedUnicodeVariableWidth(lexer, position) {
    const body = lexer.source.body;
    let point = 0;
    let size = 3; // Cannot be larger than 12 chars (\u{00000000}).
    while(size < 12){
        const code = body.charCodeAt(position + size++); // Closing Brace (})
        if (code === 0x007d) {
            // Must be at least 5 chars (\u{0}) and encode a Unicode scalar value.
            if (size < 5 || !$971bc50063303b32$var$isUnicodeScalarValue(point)) break;
            return {
                value: String.fromCodePoint(point),
                size: size
            };
        } // Append this hex digit to the code point.
        point = point << 4 | $971bc50063303b32$var$readHexDigit(code);
        if (point < 0) break;
    }
    throw (0, $ddf6b9f696b0d6b2$export$bbee0c6176c019d4)(lexer.source, position, `Invalid Unicode escape sequence: "${body.slice(position, position + size)}".`);
}
function $971bc50063303b32$var$readEscapedUnicodeFixedWidth(lexer, position) {
    const body = lexer.source.body;
    const code = $971bc50063303b32$var$read16BitHexCode(body, position + 2);
    if ($971bc50063303b32$var$isUnicodeScalarValue(code)) return {
        value: String.fromCodePoint(code),
        size: 6
    };
     // GraphQL allows JSON-style surrogate pair escape sequences, but only when
    // a valid pair is formed.
    if ($971bc50063303b32$var$isLeadingSurrogate(code)) // \u
    {
        if (body.charCodeAt(position + 6) === 0x005c && body.charCodeAt(position + 7) === 0x0075) {
            const trailingCode = $971bc50063303b32$var$read16BitHexCode(body, position + 8);
            if ($971bc50063303b32$var$isTrailingSurrogate(trailingCode)) // JavaScript defines strings as a sequence of UTF-16 code units and
            // encodes Unicode code points above U+FFFF using a surrogate pair of
            // code units. Since this is a surrogate pair escape sequence, just
            // include both codes into the JavaScript string value. Had JavaScript
            // not been internally based on UTF-16, then this surrogate pair would
            // be decoded to retrieve the supplementary code point.
            return {
                value: String.fromCodePoint(code, trailingCode),
                size: 12
            };
        }
    }
    throw (0, $ddf6b9f696b0d6b2$export$bbee0c6176c019d4)(lexer.source, position, `Invalid Unicode escape sequence: "${body.slice(position, position + 6)}".`);
}
/**
 * Reads four hexadecimal characters and returns the positive integer that 16bit
 * hexadecimal string represents. For example, "000f" will return 15, and "dead"
 * will return 57005.
 *
 * Returns a negative number if any char was not a valid hexadecimal digit.
 */ function $971bc50063303b32$var$read16BitHexCode(body, position) {
    // readHexDigit() returns -1 on error. ORing a negative value with any other
    // value always produces a negative value.
    return $971bc50063303b32$var$readHexDigit(body.charCodeAt(position)) << 12 | $971bc50063303b32$var$readHexDigit(body.charCodeAt(position + 1)) << 8 | $971bc50063303b32$var$readHexDigit(body.charCodeAt(position + 2)) << 4 | $971bc50063303b32$var$readHexDigit(body.charCodeAt(position + 3));
}
/**
 * Reads a hexadecimal character and returns its positive integer value (0-15).
 *
 * '0' becomes 0, '9' becomes 9
 * 'A' becomes 10, 'F' becomes 15
 * 'a' becomes 10, 'f' becomes 15
 *
 * Returns -1 if the provided character code was not a valid hexadecimal digit.
 *
 * HexDigit :: one of
 *   - `0` `1` `2` `3` `4` `5` `6` `7` `8` `9`
 *   - `A` `B` `C` `D` `E` `F`
 *   - `a` `b` `c` `d` `e` `f`
 */ function $971bc50063303b32$var$readHexDigit(code) {
    return code >= 0x0030 && code <= 0x0039 // 0-9
     ? code - 0x0030 : code >= 0x0041 && code <= 0x0046 // A-F
     ? code - 0x0037 : code >= 0x0061 && code <= 0x0066 // a-f
     ? code - 0x0057 : -1;
}
/**
 * | Escaped Character | Code Point | Character Name               |
 * | ----------------- | ---------- | ---------------------------- |
 * | `"`               | U+0022     | double quote                 |
 * | `\`               | U+005C     | reverse solidus (back slash) |
 * | `/`               | U+002F     | solidus (forward slash)      |
 * | `b`               | U+0008     | backspace                    |
 * | `f`               | U+000C     | form feed                    |
 * | `n`               | U+000A     | line feed (new line)         |
 * | `r`               | U+000D     | carriage return              |
 * | `t`               | U+0009     | horizontal tab               |
 */ function $971bc50063303b32$var$readEscapedCharacter(lexer, position) {
    const body = lexer.source.body;
    const code = body.charCodeAt(position + 1);
    switch(code){
        case 0x0022:
            // "
            return {
                value: '\u0022',
                size: 2
            };
        case 0x005c:
            // \
            return {
                value: '\u005c',
                size: 2
            };
        case 0x002f:
            // /
            return {
                value: '\u002f',
                size: 2
            };
        case 0x0062:
            // b
            return {
                value: '\u0008',
                size: 2
            };
        case 0x0066:
            // f
            return {
                value: '\u000c',
                size: 2
            };
        case 0x006e:
            // n
            return {
                value: '\u000a',
                size: 2
            };
        case 0x0072:
            // r
            return {
                value: '\u000d',
                size: 2
            };
        case 0x0074:
            // t
            return {
                value: '\u0009',
                size: 2
            };
    }
    throw (0, $ddf6b9f696b0d6b2$export$bbee0c6176c019d4)(lexer.source, position, `Invalid character escape sequence: "${body.slice(position, position + 2)}".`);
}
/**
 * Reads a block string token from the source file.
 *
 * ```
 * StringValue ::
 *   - `"""` BlockStringCharacter* `"""`
 *
 * BlockStringCharacter ::
 *   - SourceCharacter but not `"""` or `\"""`
 *   - `\"""`
 * ```
 */ function $971bc50063303b32$var$readBlockString(lexer, start) {
    const body = lexer.source.body;
    const bodyLength = body.length;
    let lineStart = lexer.lineStart;
    let position = start + 3;
    let chunkStart = position;
    let currentLine = '';
    const blockLines = [];
    while(position < bodyLength){
        const code = body.charCodeAt(position); // Closing Triple-Quote (""")
        if (code === 0x0022 && body.charCodeAt(position + 1) === 0x0022 && body.charCodeAt(position + 2) === 0x0022) {
            currentLine += body.slice(chunkStart, position);
            blockLines.push(currentLine);
            const token = $971bc50063303b32$var$createToken(lexer, (0, $ac240aaa94caf15d$export$8b9d26ab11394711).BLOCK_STRING, start, position + 3, (0, $a51b3e37e1f6e888$export$d5ee19b441e8d2ae)(blockLines).join('\n'));
            lexer.line += blockLines.length - 1;
            lexer.lineStart = lineStart;
            return token;
        } // Escaped Triple-Quote (\""")
        if (code === 0x005c && body.charCodeAt(position + 1) === 0x0022 && body.charCodeAt(position + 2) === 0x0022 && body.charCodeAt(position + 3) === 0x0022) {
            currentLine += body.slice(chunkStart, position);
            chunkStart = position + 1; // skip only slash
            position += 4;
            continue;
        } // LineTerminator
        if (code === 0x000a || code === 0x000d) {
            currentLine += body.slice(chunkStart, position);
            blockLines.push(currentLine);
            if (code === 0x000d && body.charCodeAt(position + 1) === 0x000a) position += 2;
            else ++position;
            currentLine = '';
            chunkStart = position;
            lineStart = position;
            continue;
        } // SourceCharacter
        if ($971bc50063303b32$var$isUnicodeScalarValue(code)) ++position;
        else if ($971bc50063303b32$var$isSupplementaryCodePoint(body, position)) position += 2;
        else throw (0, $ddf6b9f696b0d6b2$export$bbee0c6176c019d4)(lexer.source, position, `Invalid character within String: ${$971bc50063303b32$var$printCodePointAt(lexer, position)}.`);
    }
    throw (0, $ddf6b9f696b0d6b2$export$bbee0c6176c019d4)(lexer.source, position, 'Unterminated string.');
}
/**
 * Reads an alphanumeric + underscore name from the source.
 *
 * ```
 * Name ::
 *   - NameStart NameContinue* [lookahead != NameContinue]
 * ```
 */ function $971bc50063303b32$var$readName(lexer, start) {
    const body = lexer.source.body;
    const bodyLength = body.length;
    let position = start + 1;
    while(position < bodyLength){
        const code = body.charCodeAt(position);
        if ((0, $876b79dde797933a$export$d3f406ff46035894)(code)) ++position;
        else break;
    }
    return $971bc50063303b32$var$createToken(lexer, (0, $ac240aaa94caf15d$export$8b9d26ab11394711).NAME, start, position, body.slice(start, position));
}





/* c8 ignore next 3 */ const $c44107310810d751$var$isProduction = globalThis.process && // eslint-disable-next-line no-undef
true;
const $c44107310810d751$export$ca03416d6c9e029e = /* c8 ignore next 6 */ // FIXME: https://github.com/graphql/graphql-js/issues/2317
$c44107310810d751$var$isProduction ? function instanceOf(value, constructor) {
    return value instanceof constructor;
} : function instanceOf(value, constructor) {
    if (value instanceof constructor) return true;
    if (typeof value === 'object' && value !== null) {
        var _value$constructor;
        // Prefer Symbol.toStringTag since it is immune to minification.
        const className = constructor.prototype[Symbol.toStringTag];
        const valueClassName = Symbol.toStringTag in value // @ts-expect-error TS bug see, https://github.com/microsoft/TypeScript/issues/38009
         ? value[Symbol.toStringTag] : (_value$constructor = value.constructor) === null || _value$constructor === void 0 ? void 0 : _value$constructor.name;
        if (className === valueClassName) {
            const stringifiedValue = (0, $9541a54af6a37409$export$9dec5d1b3b6a130d)(value);
            throw new Error(`Cannot use ${className} "${stringifiedValue}" from another module or realm.

Ensure that there is only one instance of "graphql" in the node_modules
directory. If different versions of "graphql" are the dependencies of other
relied on modules, use "resolutions" to ensure only one version is installed.

https://yarnpkg.com/en/docs/selective-version-resolutions

Duplicate "graphql" modules cannot be used at the same time since different
versions may have different capabilities and behavior. The data from one
version used in the function from another could produce confusing and
spurious results.`);
        }
    }
    return false;
};


class $1ff584847d3a412c$export$1d2df86270c81ecb {
    constructor(body, name = 'GraphQL request', locationOffset = {
        line: 1,
        column: 1
    }){
        typeof body === 'string' || (0, $8beb5260c793fc92$export$b6cb5906f04696c8)(false, `Body must be a string. Received: ${(0, $9541a54af6a37409$export$9dec5d1b3b6a130d)(body)}.`);
        this.body = body;
        this.name = name;
        this.locationOffset = locationOffset;
        this.locationOffset.line > 0 || (0, $8beb5260c793fc92$export$b6cb5906f04696c8)(false, 'line in locationOffset is 1-indexed and must be positive.');
        this.locationOffset.column > 0 || (0, $8beb5260c793fc92$export$b6cb5906f04696c8)(false, 'column in locationOffset is 1-indexed and must be positive.');
    }
    get [Symbol.toStringTag]() {
        return 'Source';
    }
}
function $1ff584847d3a412c$export$75135ee9ed6e435b(source) {
    return (0, $c44107310810d751$export$ca03416d6c9e029e)(source, $1ff584847d3a412c$export$1d2df86270c81ecb);
}



function $0013c7ab45cf197d$export$98e6a39c04603d36(source, options) {
    const parser = new $0013c7ab45cf197d$export$7acfa6ed01010e37(source, options);
    return parser.parseDocument();
}
function $0013c7ab45cf197d$export$5303528d1070ff6f(source, options) {
    const parser = new $0013c7ab45cf197d$export$7acfa6ed01010e37(source, options);
    parser.expectToken((0, $ac240aaa94caf15d$export$8b9d26ab11394711).SOF);
    const value = parser.parseValueLiteral(false);
    parser.expectToken((0, $ac240aaa94caf15d$export$8b9d26ab11394711).EOF);
    return value;
}
function $0013c7ab45cf197d$export$e14c466bd0916f7a(source, options) {
    const parser = new $0013c7ab45cf197d$export$7acfa6ed01010e37(source, options);
    parser.expectToken((0, $ac240aaa94caf15d$export$8b9d26ab11394711).SOF);
    const value = parser.parseConstValueLiteral();
    parser.expectToken((0, $ac240aaa94caf15d$export$8b9d26ab11394711).EOF);
    return value;
}
function $0013c7ab45cf197d$export$28b8f402ccc88182(source, options) {
    const parser = new $0013c7ab45cf197d$export$7acfa6ed01010e37(source, options);
    parser.expectToken((0, $ac240aaa94caf15d$export$8b9d26ab11394711).SOF);
    const type = parser.parseTypeReference();
    parser.expectToken((0, $ac240aaa94caf15d$export$8b9d26ab11394711).EOF);
    return type;
}
class $0013c7ab45cf197d$export$7acfa6ed01010e37 {
    constructor(source, options = {}){
        const sourceObj = (0, $1ff584847d3a412c$export$75135ee9ed6e435b)(source) ? source : new (0, $1ff584847d3a412c$export$1d2df86270c81ecb)(source);
        this._lexer = new (0, $971bc50063303b32$export$6168dc8908a6c652)(sourceObj);
        this._options = options;
        this._tokenCounter = 0;
    }
    /**
   * Converts a name lex token into a name parse node.
   */ parseName() {
        const token = this.expectToken((0, $ac240aaa94caf15d$export$8b9d26ab11394711).NAME);
        return this.node(token, {
            kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).NAME,
            value: token.value
        });
    }
    /**
   * Document : Definition+
   */ parseDocument() {
        return this.node(this._lexer.token, {
            kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).DOCUMENT,
            definitions: this.many((0, $ac240aaa94caf15d$export$8b9d26ab11394711).SOF, this.parseDefinition, (0, $ac240aaa94caf15d$export$8b9d26ab11394711).EOF)
        });
    }
    /**
   * Definition :
   *   - ExecutableDefinition
   *   - TypeSystemDefinition
   *   - TypeSystemExtension
   *
   * ExecutableDefinition :
   *   - OperationDefinition
   *   - FragmentDefinition
   *
   * TypeSystemDefinition :
   *   - SchemaDefinition
   *   - TypeDefinition
   *   - DirectiveDefinition
   *
   * TypeDefinition :
   *   - ScalarTypeDefinition
   *   - ObjectTypeDefinition
   *   - InterfaceTypeDefinition
   *   - UnionTypeDefinition
   *   - EnumTypeDefinition
   *   - InputObjectTypeDefinition
   */ parseDefinition() {
        if (this.peek((0, $ac240aaa94caf15d$export$8b9d26ab11394711).BRACE_L)) return this.parseOperationDefinition();
         // Many definitions begin with a description and require a lookahead.
        const hasDescription = this.peekDescription();
        const keywordToken = hasDescription ? this._lexer.lookahead() : this._lexer.token;
        if (keywordToken.kind === (0, $ac240aaa94caf15d$export$8b9d26ab11394711).NAME) {
            switch(keywordToken.value){
                case 'schema':
                    return this.parseSchemaDefinition();
                case 'scalar':
                    return this.parseScalarTypeDefinition();
                case 'type':
                    return this.parseObjectTypeDefinition();
                case 'interface':
                    return this.parseInterfaceTypeDefinition();
                case 'union':
                    return this.parseUnionTypeDefinition();
                case 'enum':
                    return this.parseEnumTypeDefinition();
                case 'input':
                    return this.parseInputObjectTypeDefinition();
                case 'directive':
                    return this.parseDirectiveDefinition();
            }
            if (hasDescription) throw (0, $ddf6b9f696b0d6b2$export$bbee0c6176c019d4)(this._lexer.source, this._lexer.token.start, 'Unexpected description, descriptions are supported only on type definitions.');
            switch(keywordToken.value){
                case 'query':
                case 'mutation':
                case 'subscription':
                    return this.parseOperationDefinition();
                case 'fragment':
                    return this.parseFragmentDefinition();
                case 'extend':
                    return this.parseTypeSystemExtension();
            }
        }
        throw this.unexpected(keywordToken);
    }
    /**
   * OperationDefinition :
   *  - SelectionSet
   *  - OperationType Name? VariableDefinitions? Directives? SelectionSet
   */ parseOperationDefinition() {
        const start = this._lexer.token;
        if (this.peek((0, $ac240aaa94caf15d$export$8b9d26ab11394711).BRACE_L)) return this.node(start, {
            kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).OPERATION_DEFINITION,
            operation: (0, $11b06753ce50693f$export$f58c50edb4aef9d4).QUERY,
            name: undefined,
            variableDefinitions: [],
            directives: [],
            selectionSet: this.parseSelectionSet()
        });
        const operation = this.parseOperationType();
        let name;
        if (this.peek((0, $ac240aaa94caf15d$export$8b9d26ab11394711).NAME)) name = this.parseName();
        return this.node(start, {
            kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).OPERATION_DEFINITION,
            operation: operation,
            name: name,
            variableDefinitions: this.parseVariableDefinitions(),
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet()
        });
    }
    /**
   * OperationType : one of query mutation subscription
   */ parseOperationType() {
        const operationToken = this.expectToken((0, $ac240aaa94caf15d$export$8b9d26ab11394711).NAME);
        switch(operationToken.value){
            case 'query':
                return (0, $11b06753ce50693f$export$f58c50edb4aef9d4).QUERY;
            case 'mutation':
                return (0, $11b06753ce50693f$export$f58c50edb4aef9d4).MUTATION;
            case 'subscription':
                return (0, $11b06753ce50693f$export$f58c50edb4aef9d4).SUBSCRIPTION;
        }
        throw this.unexpected(operationToken);
    }
    /**
   * VariableDefinitions : ( VariableDefinition+ )
   */ parseVariableDefinitions() {
        return this.optionalMany((0, $ac240aaa94caf15d$export$8b9d26ab11394711).PAREN_L, this.parseVariableDefinition, (0, $ac240aaa94caf15d$export$8b9d26ab11394711).PAREN_R);
    }
    /**
   * VariableDefinition : Variable : Type DefaultValue? Directives[Const]?
   */ parseVariableDefinition() {
        return this.node(this._lexer.token, {
            kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).VARIABLE_DEFINITION,
            variable: this.parseVariable(),
            type: (this.expectToken((0, $ac240aaa94caf15d$export$8b9d26ab11394711).COLON), this.parseTypeReference()),
            defaultValue: this.expectOptionalToken((0, $ac240aaa94caf15d$export$8b9d26ab11394711).EQUALS) ? this.parseConstValueLiteral() : undefined,
            directives: this.parseConstDirectives()
        });
    }
    /**
   * Variable : $ Name
   */ parseVariable() {
        const start = this._lexer.token;
        this.expectToken((0, $ac240aaa94caf15d$export$8b9d26ab11394711).DOLLAR);
        return this.node(start, {
            kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).VARIABLE,
            name: this.parseName()
        });
    }
    /**
   * ```
   * SelectionSet : { Selection+ }
   * ```
   */ parseSelectionSet() {
        return this.node(this._lexer.token, {
            kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).SELECTION_SET,
            selections: this.many((0, $ac240aaa94caf15d$export$8b9d26ab11394711).BRACE_L, this.parseSelection, (0, $ac240aaa94caf15d$export$8b9d26ab11394711).BRACE_R)
        });
    }
    /**
   * Selection :
   *   - Field
   *   - FragmentSpread
   *   - InlineFragment
   */ parseSelection() {
        return this.peek((0, $ac240aaa94caf15d$export$8b9d26ab11394711).SPREAD) ? this.parseFragment() : this.parseField();
    }
    /**
   * Field : Alias? Name Arguments? Directives? SelectionSet?
   *
   * Alias : Name :
   */ parseField() {
        const start = this._lexer.token;
        const nameOrAlias = this.parseName();
        let alias;
        let name;
        if (this.expectOptionalToken((0, $ac240aaa94caf15d$export$8b9d26ab11394711).COLON)) {
            alias = nameOrAlias;
            name = this.parseName();
        } else name = nameOrAlias;
        return this.node(start, {
            kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).FIELD,
            alias: alias,
            name: name,
            arguments: this.parseArguments(false),
            directives: this.parseDirectives(false),
            selectionSet: this.peek((0, $ac240aaa94caf15d$export$8b9d26ab11394711).BRACE_L) ? this.parseSelectionSet() : undefined
        });
    }
    /**
   * Arguments[Const] : ( Argument[?Const]+ )
   */ parseArguments(isConst) {
        const item = isConst ? this.parseConstArgument : this.parseArgument;
        return this.optionalMany((0, $ac240aaa94caf15d$export$8b9d26ab11394711).PAREN_L, item, (0, $ac240aaa94caf15d$export$8b9d26ab11394711).PAREN_R);
    }
    /**
   * Argument[Const] : Name : Value[?Const]
   */ parseArgument(isConst = false) {
        const start = this._lexer.token;
        const name = this.parseName();
        this.expectToken((0, $ac240aaa94caf15d$export$8b9d26ab11394711).COLON);
        return this.node(start, {
            kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).ARGUMENT,
            name: name,
            value: this.parseValueLiteral(isConst)
        });
    }
    parseConstArgument() {
        return this.parseArgument(true);
    }
    /**
   * Corresponds to both FragmentSpread and InlineFragment in the spec.
   *
   * FragmentSpread : ... FragmentName Directives?
   *
   * InlineFragment : ... TypeCondition? Directives? SelectionSet
   */ parseFragment() {
        const start = this._lexer.token;
        this.expectToken((0, $ac240aaa94caf15d$export$8b9d26ab11394711).SPREAD);
        const hasTypeCondition = this.expectOptionalKeyword('on');
        if (!hasTypeCondition && this.peek((0, $ac240aaa94caf15d$export$8b9d26ab11394711).NAME)) return this.node(start, {
            kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).FRAGMENT_SPREAD,
            name: this.parseFragmentName(),
            directives: this.parseDirectives(false)
        });
        return this.node(start, {
            kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).INLINE_FRAGMENT,
            typeCondition: hasTypeCondition ? this.parseNamedType() : undefined,
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet()
        });
    }
    /**
   * FragmentDefinition :
   *   - fragment FragmentName on TypeCondition Directives? SelectionSet
   *
   * TypeCondition : NamedType
   */ parseFragmentDefinition() {
        const start = this._lexer.token;
        this.expectKeyword('fragment'); // Legacy support for defining variables within fragments changes
        // the grammar of FragmentDefinition:
        //   - fragment FragmentName VariableDefinitions? on TypeCondition Directives? SelectionSet
        if (this._options.allowLegacyFragmentVariables === true) return this.node(start, {
            kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).FRAGMENT_DEFINITION,
            name: this.parseFragmentName(),
            variableDefinitions: this.parseVariableDefinitions(),
            typeCondition: (this.expectKeyword('on'), this.parseNamedType()),
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet()
        });
        return this.node(start, {
            kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).FRAGMENT_DEFINITION,
            name: this.parseFragmentName(),
            typeCondition: (this.expectKeyword('on'), this.parseNamedType()),
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet()
        });
    }
    /**
   * FragmentName : Name but not `on`
   */ parseFragmentName() {
        if (this._lexer.token.value === 'on') throw this.unexpected();
        return this.parseName();
    }
    /**
   * Value[Const] :
   *   - [~Const] Variable
   *   - IntValue
   *   - FloatValue
   *   - StringValue
   *   - BooleanValue
   *   - NullValue
   *   - EnumValue
   *   - ListValue[?Const]
   *   - ObjectValue[?Const]
   *
   * BooleanValue : one of `true` `false`
   *
   * NullValue : `null`
   *
   * EnumValue : Name but not `true`, `false` or `null`
   */ parseValueLiteral(isConst) {
        const token = this._lexer.token;
        switch(token.kind){
            case (0, $ac240aaa94caf15d$export$8b9d26ab11394711).BRACKET_L:
                return this.parseList(isConst);
            case (0, $ac240aaa94caf15d$export$8b9d26ab11394711).BRACE_L:
                return this.parseObject(isConst);
            case (0, $ac240aaa94caf15d$export$8b9d26ab11394711).INT:
                this.advanceLexer();
                return this.node(token, {
                    kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).INT,
                    value: token.value
                });
            case (0, $ac240aaa94caf15d$export$8b9d26ab11394711).FLOAT:
                this.advanceLexer();
                return this.node(token, {
                    kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).FLOAT,
                    value: token.value
                });
            case (0, $ac240aaa94caf15d$export$8b9d26ab11394711).STRING:
            case (0, $ac240aaa94caf15d$export$8b9d26ab11394711).BLOCK_STRING:
                return this.parseStringLiteral();
            case (0, $ac240aaa94caf15d$export$8b9d26ab11394711).NAME:
                this.advanceLexer();
                switch(token.value){
                    case 'true':
                        return this.node(token, {
                            kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).BOOLEAN,
                            value: true
                        });
                    case 'false':
                        return this.node(token, {
                            kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).BOOLEAN,
                            value: false
                        });
                    case 'null':
                        return this.node(token, {
                            kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).NULL
                        });
                    default:
                        return this.node(token, {
                            kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).ENUM,
                            value: token.value
                        });
                }
            case (0, $ac240aaa94caf15d$export$8b9d26ab11394711).DOLLAR:
                if (isConst) {
                    this.expectToken((0, $ac240aaa94caf15d$export$8b9d26ab11394711).DOLLAR);
                    if (this._lexer.token.kind === (0, $ac240aaa94caf15d$export$8b9d26ab11394711).NAME) {
                        const varName = this._lexer.token.value;
                        throw (0, $ddf6b9f696b0d6b2$export$bbee0c6176c019d4)(this._lexer.source, token.start, `Unexpected variable "$${varName}" in constant value.`);
                    } else throw this.unexpected(token);
                }
                return this.parseVariable();
            default:
                throw this.unexpected();
        }
    }
    parseConstValueLiteral() {
        return this.parseValueLiteral(true);
    }
    parseStringLiteral() {
        const token = this._lexer.token;
        this.advanceLexer();
        return this.node(token, {
            kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).STRING,
            value: token.value,
            block: token.kind === (0, $ac240aaa94caf15d$export$8b9d26ab11394711).BLOCK_STRING
        });
    }
    /**
   * ListValue[Const] :
   *   - [ ]
   *   - [ Value[?Const]+ ]
   */ parseList(isConst) {
        const item = ()=>this.parseValueLiteral(isConst);
        return this.node(this._lexer.token, {
            kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).LIST,
            values: this.any((0, $ac240aaa94caf15d$export$8b9d26ab11394711).BRACKET_L, item, (0, $ac240aaa94caf15d$export$8b9d26ab11394711).BRACKET_R)
        });
    }
    /**
   * ```
   * ObjectValue[Const] :
   *   - { }
   *   - { ObjectField[?Const]+ }
   * ```
   */ parseObject(isConst) {
        const item = ()=>this.parseObjectField(isConst);
        return this.node(this._lexer.token, {
            kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).OBJECT,
            fields: this.any((0, $ac240aaa94caf15d$export$8b9d26ab11394711).BRACE_L, item, (0, $ac240aaa94caf15d$export$8b9d26ab11394711).BRACE_R)
        });
    }
    /**
   * ObjectField[Const] : Name : Value[?Const]
   */ parseObjectField(isConst) {
        const start = this._lexer.token;
        const name = this.parseName();
        this.expectToken((0, $ac240aaa94caf15d$export$8b9d26ab11394711).COLON);
        return this.node(start, {
            kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).OBJECT_FIELD,
            name: name,
            value: this.parseValueLiteral(isConst)
        });
    }
    /**
   * Directives[Const] : Directive[?Const]+
   */ parseDirectives(isConst) {
        const directives = [];
        while(this.peek((0, $ac240aaa94caf15d$export$8b9d26ab11394711).AT))directives.push(this.parseDirective(isConst));
        return directives;
    }
    parseConstDirectives() {
        return this.parseDirectives(true);
    }
    /**
   * ```
   * Directive[Const] : @ Name Arguments[?Const]?
   * ```
   */ parseDirective(isConst) {
        const start = this._lexer.token;
        this.expectToken((0, $ac240aaa94caf15d$export$8b9d26ab11394711).AT);
        return this.node(start, {
            kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).DIRECTIVE,
            name: this.parseName(),
            arguments: this.parseArguments(isConst)
        });
    }
    /**
   * Type :
   *   - NamedType
   *   - ListType
   *   - NonNullType
   */ parseTypeReference() {
        const start = this._lexer.token;
        let type;
        if (this.expectOptionalToken((0, $ac240aaa94caf15d$export$8b9d26ab11394711).BRACKET_L)) {
            const innerType = this.parseTypeReference();
            this.expectToken((0, $ac240aaa94caf15d$export$8b9d26ab11394711).BRACKET_R);
            type = this.node(start, {
                kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).LIST_TYPE,
                type: innerType
            });
        } else type = this.parseNamedType();
        if (this.expectOptionalToken((0, $ac240aaa94caf15d$export$8b9d26ab11394711).BANG)) return this.node(start, {
            kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).NON_NULL_TYPE,
            type: type
        });
        return type;
    }
    /**
   * NamedType : Name
   */ parseNamedType() {
        return this.node(this._lexer.token, {
            kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).NAMED_TYPE,
            name: this.parseName()
        });
    }
    peekDescription() {
        return this.peek((0, $ac240aaa94caf15d$export$8b9d26ab11394711).STRING) || this.peek((0, $ac240aaa94caf15d$export$8b9d26ab11394711).BLOCK_STRING);
    }
    /**
   * Description : StringValue
   */ parseDescription() {
        if (this.peekDescription()) return this.parseStringLiteral();
    }
    /**
   * ```
   * SchemaDefinition : Description? schema Directives[Const]? { OperationTypeDefinition+ }
   * ```
   */ parseSchemaDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        this.expectKeyword('schema');
        const directives = this.parseConstDirectives();
        const operationTypes = this.many((0, $ac240aaa94caf15d$export$8b9d26ab11394711).BRACE_L, this.parseOperationTypeDefinition, (0, $ac240aaa94caf15d$export$8b9d26ab11394711).BRACE_R);
        return this.node(start, {
            kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).SCHEMA_DEFINITION,
            description: description,
            directives: directives,
            operationTypes: operationTypes
        });
    }
    /**
   * OperationTypeDefinition : OperationType : NamedType
   */ parseOperationTypeDefinition() {
        const start = this._lexer.token;
        const operation = this.parseOperationType();
        this.expectToken((0, $ac240aaa94caf15d$export$8b9d26ab11394711).COLON);
        const type = this.parseNamedType();
        return this.node(start, {
            kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).OPERATION_TYPE_DEFINITION,
            operation: operation,
            type: type
        });
    }
    /**
   * ScalarTypeDefinition : Description? scalar Name Directives[Const]?
   */ parseScalarTypeDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        this.expectKeyword('scalar');
        const name = this.parseName();
        const directives = this.parseConstDirectives();
        return this.node(start, {
            kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).SCALAR_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives
        });
    }
    /**
   * ObjectTypeDefinition :
   *   Description?
   *   type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition?
   */ parseObjectTypeDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        this.expectKeyword('type');
        const name = this.parseName();
        const interfaces = this.parseImplementsInterfaces();
        const directives = this.parseConstDirectives();
        const fields = this.parseFieldsDefinition();
        return this.node(start, {
            kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).OBJECT_TYPE_DEFINITION,
            description: description,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields
        });
    }
    /**
   * ImplementsInterfaces :
   *   - implements `&`? NamedType
   *   - ImplementsInterfaces & NamedType
   */ parseImplementsInterfaces() {
        return this.expectOptionalKeyword('implements') ? this.delimitedMany((0, $ac240aaa94caf15d$export$8b9d26ab11394711).AMP, this.parseNamedType) : [];
    }
    /**
   * ```
   * FieldsDefinition : { FieldDefinition+ }
   * ```
   */ parseFieldsDefinition() {
        return this.optionalMany((0, $ac240aaa94caf15d$export$8b9d26ab11394711).BRACE_L, this.parseFieldDefinition, (0, $ac240aaa94caf15d$export$8b9d26ab11394711).BRACE_R);
    }
    /**
   * FieldDefinition :
   *   - Description? Name ArgumentsDefinition? : Type Directives[Const]?
   */ parseFieldDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        const name = this.parseName();
        const args = this.parseArgumentDefs();
        this.expectToken((0, $ac240aaa94caf15d$export$8b9d26ab11394711).COLON);
        const type = this.parseTypeReference();
        const directives = this.parseConstDirectives();
        return this.node(start, {
            kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).FIELD_DEFINITION,
            description: description,
            name: name,
            arguments: args,
            type: type,
            directives: directives
        });
    }
    /**
   * ArgumentsDefinition : ( InputValueDefinition+ )
   */ parseArgumentDefs() {
        return this.optionalMany((0, $ac240aaa94caf15d$export$8b9d26ab11394711).PAREN_L, this.parseInputValueDef, (0, $ac240aaa94caf15d$export$8b9d26ab11394711).PAREN_R);
    }
    /**
   * InputValueDefinition :
   *   - Description? Name : Type DefaultValue? Directives[Const]?
   */ parseInputValueDef() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        const name = this.parseName();
        this.expectToken((0, $ac240aaa94caf15d$export$8b9d26ab11394711).COLON);
        const type = this.parseTypeReference();
        let defaultValue;
        if (this.expectOptionalToken((0, $ac240aaa94caf15d$export$8b9d26ab11394711).EQUALS)) defaultValue = this.parseConstValueLiteral();
        const directives = this.parseConstDirectives();
        return this.node(start, {
            kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).INPUT_VALUE_DEFINITION,
            description: description,
            name: name,
            type: type,
            defaultValue: defaultValue,
            directives: directives
        });
    }
    /**
   * InterfaceTypeDefinition :
   *   - Description? interface Name Directives[Const]? FieldsDefinition?
   */ parseInterfaceTypeDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        this.expectKeyword('interface');
        const name = this.parseName();
        const interfaces = this.parseImplementsInterfaces();
        const directives = this.parseConstDirectives();
        const fields = this.parseFieldsDefinition();
        return this.node(start, {
            kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).INTERFACE_TYPE_DEFINITION,
            description: description,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields
        });
    }
    /**
   * UnionTypeDefinition :
   *   - Description? union Name Directives[Const]? UnionMemberTypes?
   */ parseUnionTypeDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        this.expectKeyword('union');
        const name = this.parseName();
        const directives = this.parseConstDirectives();
        const types = this.parseUnionMemberTypes();
        return this.node(start, {
            kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).UNION_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            types: types
        });
    }
    /**
   * UnionMemberTypes :
   *   - = `|`? NamedType
   *   - UnionMemberTypes | NamedType
   */ parseUnionMemberTypes() {
        return this.expectOptionalToken((0, $ac240aaa94caf15d$export$8b9d26ab11394711).EQUALS) ? this.delimitedMany((0, $ac240aaa94caf15d$export$8b9d26ab11394711).PIPE, this.parseNamedType) : [];
    }
    /**
   * EnumTypeDefinition :
   *   - Description? enum Name Directives[Const]? EnumValuesDefinition?
   */ parseEnumTypeDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        this.expectKeyword('enum');
        const name = this.parseName();
        const directives = this.parseConstDirectives();
        const values = this.parseEnumValuesDefinition();
        return this.node(start, {
            kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).ENUM_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            values: values
        });
    }
    /**
   * ```
   * EnumValuesDefinition : { EnumValueDefinition+ }
   * ```
   */ parseEnumValuesDefinition() {
        return this.optionalMany((0, $ac240aaa94caf15d$export$8b9d26ab11394711).BRACE_L, this.parseEnumValueDefinition, (0, $ac240aaa94caf15d$export$8b9d26ab11394711).BRACE_R);
    }
    /**
   * EnumValueDefinition : Description? EnumValue Directives[Const]?
   */ parseEnumValueDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        const name = this.parseEnumValueName();
        const directives = this.parseConstDirectives();
        return this.node(start, {
            kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).ENUM_VALUE_DEFINITION,
            description: description,
            name: name,
            directives: directives
        });
    }
    /**
   * EnumValue : Name but not `true`, `false` or `null`
   */ parseEnumValueName() {
        if (this._lexer.token.value === 'true' || this._lexer.token.value === 'false' || this._lexer.token.value === 'null') throw (0, $ddf6b9f696b0d6b2$export$bbee0c6176c019d4)(this._lexer.source, this._lexer.token.start, `${$0013c7ab45cf197d$var$getTokenDesc(this._lexer.token)} is reserved and cannot be used for an enum value.`);
        return this.parseName();
    }
    /**
   * InputObjectTypeDefinition :
   *   - Description? input Name Directives[Const]? InputFieldsDefinition?
   */ parseInputObjectTypeDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        this.expectKeyword('input');
        const name = this.parseName();
        const directives = this.parseConstDirectives();
        const fields = this.parseInputFieldsDefinition();
        return this.node(start, {
            kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).INPUT_OBJECT_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            fields: fields
        });
    }
    /**
   * ```
   * InputFieldsDefinition : { InputValueDefinition+ }
   * ```
   */ parseInputFieldsDefinition() {
        return this.optionalMany((0, $ac240aaa94caf15d$export$8b9d26ab11394711).BRACE_L, this.parseInputValueDef, (0, $ac240aaa94caf15d$export$8b9d26ab11394711).BRACE_R);
    }
    /**
   * TypeSystemExtension :
   *   - SchemaExtension
   *   - TypeExtension
   *
   * TypeExtension :
   *   - ScalarTypeExtension
   *   - ObjectTypeExtension
   *   - InterfaceTypeExtension
   *   - UnionTypeExtension
   *   - EnumTypeExtension
   *   - InputObjectTypeDefinition
   */ parseTypeSystemExtension() {
        const keywordToken = this._lexer.lookahead();
        if (keywordToken.kind === (0, $ac240aaa94caf15d$export$8b9d26ab11394711).NAME) switch(keywordToken.value){
            case 'schema':
                return this.parseSchemaExtension();
            case 'scalar':
                return this.parseScalarTypeExtension();
            case 'type':
                return this.parseObjectTypeExtension();
            case 'interface':
                return this.parseInterfaceTypeExtension();
            case 'union':
                return this.parseUnionTypeExtension();
            case 'enum':
                return this.parseEnumTypeExtension();
            case 'input':
                return this.parseInputObjectTypeExtension();
        }
        throw this.unexpected(keywordToken);
    }
    /**
   * ```
   * SchemaExtension :
   *  - extend schema Directives[Const]? { OperationTypeDefinition+ }
   *  - extend schema Directives[Const]
   * ```
   */ parseSchemaExtension() {
        const start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('schema');
        const directives = this.parseConstDirectives();
        const operationTypes = this.optionalMany((0, $ac240aaa94caf15d$export$8b9d26ab11394711).BRACE_L, this.parseOperationTypeDefinition, (0, $ac240aaa94caf15d$export$8b9d26ab11394711).BRACE_R);
        if (directives.length === 0 && operationTypes.length === 0) throw this.unexpected();
        return this.node(start, {
            kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).SCHEMA_EXTENSION,
            directives: directives,
            operationTypes: operationTypes
        });
    }
    /**
   * ScalarTypeExtension :
   *   - extend scalar Name Directives[Const]
   */ parseScalarTypeExtension() {
        const start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('scalar');
        const name = this.parseName();
        const directives = this.parseConstDirectives();
        if (directives.length === 0) throw this.unexpected();
        return this.node(start, {
            kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).SCALAR_TYPE_EXTENSION,
            name: name,
            directives: directives
        });
    }
    /**
   * ObjectTypeExtension :
   *  - extend type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend type Name ImplementsInterfaces? Directives[Const]
   *  - extend type Name ImplementsInterfaces
   */ parseObjectTypeExtension() {
        const start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('type');
        const name = this.parseName();
        const interfaces = this.parseImplementsInterfaces();
        const directives = this.parseConstDirectives();
        const fields = this.parseFieldsDefinition();
        if (interfaces.length === 0 && directives.length === 0 && fields.length === 0) throw this.unexpected();
        return this.node(start, {
            kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).OBJECT_TYPE_EXTENSION,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields
        });
    }
    /**
   * InterfaceTypeExtension :
   *  - extend interface Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend interface Name ImplementsInterfaces? Directives[Const]
   *  - extend interface Name ImplementsInterfaces
   */ parseInterfaceTypeExtension() {
        const start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('interface');
        const name = this.parseName();
        const interfaces = this.parseImplementsInterfaces();
        const directives = this.parseConstDirectives();
        const fields = this.parseFieldsDefinition();
        if (interfaces.length === 0 && directives.length === 0 && fields.length === 0) throw this.unexpected();
        return this.node(start, {
            kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).INTERFACE_TYPE_EXTENSION,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields
        });
    }
    /**
   * UnionTypeExtension :
   *   - extend union Name Directives[Const]? UnionMemberTypes
   *   - extend union Name Directives[Const]
   */ parseUnionTypeExtension() {
        const start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('union');
        const name = this.parseName();
        const directives = this.parseConstDirectives();
        const types = this.parseUnionMemberTypes();
        if (directives.length === 0 && types.length === 0) throw this.unexpected();
        return this.node(start, {
            kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).UNION_TYPE_EXTENSION,
            name: name,
            directives: directives,
            types: types
        });
    }
    /**
   * EnumTypeExtension :
   *   - extend enum Name Directives[Const]? EnumValuesDefinition
   *   - extend enum Name Directives[Const]
   */ parseEnumTypeExtension() {
        const start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('enum');
        const name = this.parseName();
        const directives = this.parseConstDirectives();
        const values = this.parseEnumValuesDefinition();
        if (directives.length === 0 && values.length === 0) throw this.unexpected();
        return this.node(start, {
            kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).ENUM_TYPE_EXTENSION,
            name: name,
            directives: directives,
            values: values
        });
    }
    /**
   * InputObjectTypeExtension :
   *   - extend input Name Directives[Const]? InputFieldsDefinition
   *   - extend input Name Directives[Const]
   */ parseInputObjectTypeExtension() {
        const start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('input');
        const name = this.parseName();
        const directives = this.parseConstDirectives();
        const fields = this.parseInputFieldsDefinition();
        if (directives.length === 0 && fields.length === 0) throw this.unexpected();
        return this.node(start, {
            kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).INPUT_OBJECT_TYPE_EXTENSION,
            name: name,
            directives: directives,
            fields: fields
        });
    }
    /**
   * ```
   * DirectiveDefinition :
   *   - Description? directive @ Name ArgumentsDefinition? `repeatable`? on DirectiveLocations
   * ```
   */ parseDirectiveDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        this.expectKeyword('directive');
        this.expectToken((0, $ac240aaa94caf15d$export$8b9d26ab11394711).AT);
        const name = this.parseName();
        const args = this.parseArgumentDefs();
        const repeatable = this.expectOptionalKeyword('repeatable');
        this.expectKeyword('on');
        const locations = this.parseDirectiveLocations();
        return this.node(start, {
            kind: (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).DIRECTIVE_DEFINITION,
            description: description,
            name: name,
            arguments: args,
            repeatable: repeatable,
            locations: locations
        });
    }
    /**
   * DirectiveLocations :
   *   - `|`? DirectiveLocation
   *   - DirectiveLocations | DirectiveLocation
   */ parseDirectiveLocations() {
        return this.delimitedMany((0, $ac240aaa94caf15d$export$8b9d26ab11394711).PIPE, this.parseDirectiveLocation);
    }
    /*
   * DirectiveLocation :
   *   - ExecutableDirectiveLocation
   *   - TypeSystemDirectiveLocation
   *
   * ExecutableDirectiveLocation : one of
   *   `QUERY`
   *   `MUTATION`
   *   `SUBSCRIPTION`
   *   `FIELD`
   *   `FRAGMENT_DEFINITION`
   *   `FRAGMENT_SPREAD`
   *   `INLINE_FRAGMENT`
   *
   * TypeSystemDirectiveLocation : one of
   *   `SCHEMA`
   *   `SCALAR`
   *   `OBJECT`
   *   `FIELD_DEFINITION`
   *   `ARGUMENT_DEFINITION`
   *   `INTERFACE`
   *   `UNION`
   *   `ENUM`
   *   `ENUM_VALUE`
   *   `INPUT_OBJECT`
   *   `INPUT_FIELD_DEFINITION`
   */ parseDirectiveLocation() {
        const start = this._lexer.token;
        const name = this.parseName();
        if (Object.prototype.hasOwnProperty.call((0, $289bf729a82494c6$export$b45ffd2948484c41), name.value)) return name;
        throw this.unexpected(start);
    }
    /**
   * Returns a node that, if configured to do so, sets a "loc" field as a
   * location object, used to identify the place in the source that created a
   * given parsed object.
   */ node(startToken, node) {
        if (this._options.noLocation !== true) node.loc = new (0, $11b06753ce50693f$export$18a2be9195644f38)(startToken, this._lexer.lastToken, this._lexer.source);
        return node;
    }
    /**
   * Determines if the next token is of a given kind
   */ peek(kind) {
        return this._lexer.token.kind === kind;
    }
    /**
   * If the next token is of the given kind, return that token after advancing the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */ expectToken(kind) {
        const token = this._lexer.token;
        if (token.kind === kind) {
            this.advanceLexer();
            return token;
        }
        throw (0, $ddf6b9f696b0d6b2$export$bbee0c6176c019d4)(this._lexer.source, token.start, `Expected ${$0013c7ab45cf197d$var$getTokenKindDesc(kind)}, found ${$0013c7ab45cf197d$var$getTokenDesc(token)}.`);
    }
    /**
   * If the next token is of the given kind, return "true" after advancing the lexer.
   * Otherwise, do not change the parser state and return "false".
   */ expectOptionalToken(kind) {
        const token = this._lexer.token;
        if (token.kind === kind) {
            this.advanceLexer();
            return true;
        }
        return false;
    }
    /**
   * If the next token is a given keyword, advance the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */ expectKeyword(value) {
        const token = this._lexer.token;
        if (token.kind === (0, $ac240aaa94caf15d$export$8b9d26ab11394711).NAME && token.value === value) this.advanceLexer();
        else throw (0, $ddf6b9f696b0d6b2$export$bbee0c6176c019d4)(this._lexer.source, token.start, `Expected "${value}", found ${$0013c7ab45cf197d$var$getTokenDesc(token)}.`);
    }
    /**
   * If the next token is a given keyword, return "true" after advancing the lexer.
   * Otherwise, do not change the parser state and return "false".
   */ expectOptionalKeyword(value) {
        const token = this._lexer.token;
        if (token.kind === (0, $ac240aaa94caf15d$export$8b9d26ab11394711).NAME && token.value === value) {
            this.advanceLexer();
            return true;
        }
        return false;
    }
    /**
   * Helper function for creating an error when an unexpected lexed token is encountered.
   */ unexpected(atToken) {
        const token = atToken !== null && atToken !== void 0 ? atToken : this._lexer.token;
        return (0, $ddf6b9f696b0d6b2$export$bbee0c6176c019d4)(this._lexer.source, token.start, `Unexpected ${$0013c7ab45cf197d$var$getTokenDesc(token)}.`);
    }
    /**
   * Returns a possibly empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */ any(openKind, parseFn, closeKind) {
        this.expectToken(openKind);
        const nodes = [];
        while(!this.expectOptionalToken(closeKind))nodes.push(parseFn.call(this));
        return nodes;
    }
    /**
   * Returns a list of parse nodes, determined by the parseFn.
   * It can be empty only if open token is missing otherwise it will always return non-empty list
   * that begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */ optionalMany(openKind, parseFn, closeKind) {
        if (this.expectOptionalToken(openKind)) {
            const nodes = [];
            do nodes.push(parseFn.call(this));
            while (!this.expectOptionalToken(closeKind));
            return nodes;
        }
        return [];
    }
    /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */ many(openKind, parseFn, closeKind) {
        this.expectToken(openKind);
        const nodes = [];
        do nodes.push(parseFn.call(this));
        while (!this.expectOptionalToken(closeKind));
        return nodes;
    }
    /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list may begin with a lex token of delimiterKind followed by items separated by lex tokens of tokenKind.
   * Advances the parser to the next lex token after last item in the list.
   */ delimitedMany(delimiterKind, parseFn) {
        this.expectOptionalToken(delimiterKind);
        const nodes = [];
        do nodes.push(parseFn.call(this));
        while (this.expectOptionalToken(delimiterKind));
        return nodes;
    }
    advanceLexer() {
        const { maxTokens: maxTokens } = this._options;
        const token = this._lexer.advance();
        if (maxTokens !== undefined && token.kind !== (0, $ac240aaa94caf15d$export$8b9d26ab11394711).EOF) {
            ++this._tokenCounter;
            if (this._tokenCounter > maxTokens) throw (0, $ddf6b9f696b0d6b2$export$bbee0c6176c019d4)(this._lexer.source, token.start, `Document contains more that ${maxTokens} tokens. Parsing aborted.`);
        }
    }
}
/**
 * A helper function to describe a token as a string for debugging.
 */ function $0013c7ab45cf197d$var$getTokenDesc(token) {
    const value = token.value;
    return $0013c7ab45cf197d$var$getTokenKindDesc(token.kind) + (value != null ? ` "${value}"` : '');
}
/**
 * A helper function to describe a token kind as a string for debugging.
 */ function $0013c7ab45cf197d$var$getTokenKindDesc(kind) {
    return (0, $971bc50063303b32$export$59ac0f4da287406a)(kind) ? `"${kind}"` : kind;
}


var $4f5dcc0184f23a66$var$docCache = new Map();
var $4f5dcc0184f23a66$var$fragmentSourceMap = new Map();
var $4f5dcc0184f23a66$var$printFragmentWarnings = true;
var $4f5dcc0184f23a66$var$experimentalFragmentVariables = false;
function $4f5dcc0184f23a66$var$normalize(string) {
    return string.replace(/[\s,]+/g, ' ').trim();
}
function $4f5dcc0184f23a66$var$cacheKeyFromLoc(loc) {
    return $4f5dcc0184f23a66$var$normalize(loc.source.body.substring(loc.start, loc.end));
}
function $4f5dcc0184f23a66$var$processFragments(ast) {
    var seenKeys = new Set();
    var definitions = [];
    ast.definitions.forEach(function(fragmentDefinition) {
        if (fragmentDefinition.kind === 'FragmentDefinition') {
            var fragmentName = fragmentDefinition.name.value;
            var sourceKey = $4f5dcc0184f23a66$var$cacheKeyFromLoc(fragmentDefinition.loc);
            var sourceKeySet = $4f5dcc0184f23a66$var$fragmentSourceMap.get(fragmentName);
            if (sourceKeySet && !sourceKeySet.has(sourceKey)) {
                if ($4f5dcc0184f23a66$var$printFragmentWarnings) console.warn("Warning: fragment with name " + fragmentName + " already exists.\n" + "graphql-tag enforces all fragment names across your application to be unique; read more about\n" + "this in the docs: http://dev.apollodata.com/core/fragments.html#unique-names");
            } else if (!sourceKeySet) $4f5dcc0184f23a66$var$fragmentSourceMap.set(fragmentName, sourceKeySet = new Set);
            sourceKeySet.add(sourceKey);
            if (!seenKeys.has(sourceKey)) {
                seenKeys.add(sourceKey);
                definitions.push(fragmentDefinition);
            }
        } else definitions.push(fragmentDefinition);
    });
    return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, ast), {
        definitions: definitions
    });
}
function $4f5dcc0184f23a66$var$stripLoc(doc) {
    var workSet = new Set(doc.definitions);
    workSet.forEach(function(node) {
        if (node.loc) delete node.loc;
        Object.keys(node).forEach(function(key) {
            var value = node[key];
            if (value && typeof value === 'object') workSet.add(value);
        });
    });
    var loc = doc.loc;
    if (loc) {
        delete loc.startToken;
        delete loc.endToken;
    }
    return doc;
}
function $4f5dcc0184f23a66$var$parseDocument(source) {
    var cacheKey = $4f5dcc0184f23a66$var$normalize(source);
    if (!$4f5dcc0184f23a66$var$docCache.has(cacheKey)) {
        var parsed = (0, $0013c7ab45cf197d$export$98e6a39c04603d36)(source, {
            experimentalFragmentVariables: $4f5dcc0184f23a66$var$experimentalFragmentVariables,
            allowLegacyFragmentVariables: $4f5dcc0184f23a66$var$experimentalFragmentVariables
        });
        if (!parsed || parsed.kind !== 'Document') throw new Error('Not a valid GraphQL document.');
        $4f5dcc0184f23a66$var$docCache.set(cacheKey, $4f5dcc0184f23a66$var$stripLoc($4f5dcc0184f23a66$var$processFragments(parsed)));
    }
    return $4f5dcc0184f23a66$var$docCache.get(cacheKey);
}
function $4f5dcc0184f23a66$export$72e4926bf8358653(literals) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    if (typeof literals === 'string') literals = [
        literals
    ];
    var result = literals[0];
    args.forEach(function(arg, i) {
        if (arg && arg.kind === 'Document') result += arg.loc.source.body;
        else result += arg;
        result += literals[i + 1];
    });
    return $4f5dcc0184f23a66$var$parseDocument(result);
}
function $4f5dcc0184f23a66$export$657554ef4dc7ac2d() {
    $4f5dcc0184f23a66$var$docCache.clear();
    $4f5dcc0184f23a66$var$fragmentSourceMap.clear();
}
function $4f5dcc0184f23a66$export$e4294e638636c6ab() {
    $4f5dcc0184f23a66$var$printFragmentWarnings = false;
}
function $4f5dcc0184f23a66$export$78cf889af350c840() {
    $4f5dcc0184f23a66$var$experimentalFragmentVariables = true;
}
function $4f5dcc0184f23a66$export$5290df9bbbd3cfa() {
    $4f5dcc0184f23a66$var$experimentalFragmentVariables = false;
}
var $4f5dcc0184f23a66$var$extras = {
    gql: $4f5dcc0184f23a66$export$72e4926bf8358653,
    resetCaches: $4f5dcc0184f23a66$export$657554ef4dc7ac2d,
    disableFragmentWarnings: $4f5dcc0184f23a66$export$e4294e638636c6ab,
    enableExperimentalFragmentVariables: $4f5dcc0184f23a66$export$78cf889af350c840,
    disableExperimentalFragmentVariables: $4f5dcc0184f23a66$export$5290df9bbbd3cfa
};
(function(gql_1) {
    gql_1.gql = $4f5dcc0184f23a66$var$extras.gql, gql_1.resetCaches = $4f5dcc0184f23a66$var$extras.resetCaches, gql_1.disableFragmentWarnings = $4f5dcc0184f23a66$var$extras.disableFragmentWarnings, gql_1.enableExperimentalFragmentVariables = $4f5dcc0184f23a66$var$extras.enableExperimentalFragmentVariables, gql_1.disableExperimentalFragmentVariables = $4f5dcc0184f23a66$var$extras.disableExperimentalFragmentVariables;
})($4f5dcc0184f23a66$export$72e4926bf8358653 || ($4f5dcc0184f23a66$export$72e4926bf8358653 = {}));
$4f5dcc0184f23a66$export$72e4926bf8358653["default"] = $4f5dcc0184f23a66$export$72e4926bf8358653;
var $4f5dcc0184f23a66$export$2e2bcd8739ae039 = $4f5dcc0184f23a66$export$72e4926bf8358653;












var $3b55b3aff583fbaf$export$5fc74f25506aa9c = /** @class */ function() {
    function ApolloCache() {
        this.assumeImmutableResults = false;
        // Make sure we compute the same (===) fragment query document every
        // time we receive the same fragment in readFragment.
        this.getFragmentDoc = (0, $0fc5e093b69637b4$export$4997ffc0176396a6)((0, $7f688c9754699513$export$abbf37c7cf644e41), {
            max: (0, $c506be9be1a65610$export$f29926b23b28936b)["cache.fragmentQueryDocuments"] || 1000 /* defaultCacheSizes["cache.fragmentQueryDocuments"] */ ,
            cache: (0, $947797cdb9e55a2d$export$87b462129af3b7d4)
        });
    }
    // Transactional API
    // The batch method is intended to replace/subsume both performTransaction
    // and recordOptimisticTransaction, but performTransaction came first, so we
    // provide a default batch implementation that's just another way of calling
    // performTransaction. Subclasses of ApolloCache (such as InMemoryCache) can
    // override the batch method to do more interesting things with its options.
    ApolloCache.prototype.batch = function(options) {
        var _this = this;
        var optimisticId = typeof options.optimistic === "string" ? options.optimistic : options.optimistic === false ? null : void 0;
        var updateResult;
        this.performTransaction(function() {
            return updateResult = options.update(_this);
        }, optimisticId);
        return updateResult;
    };
    ApolloCache.prototype.recordOptimisticTransaction = function(transaction, optimisticId) {
        this.performTransaction(transaction, optimisticId);
    };
    // Optional API
    // Called once per input document, allowing the cache to make static changes
    // to the query, such as adding __typename fields.
    ApolloCache.prototype.transformDocument = function(document) {
        return document;
    };
    // Called before each ApolloLink request, allowing the cache to make dynamic
    // changes to the query, such as filling in missing fragment definitions.
    ApolloCache.prototype.transformForLink = function(document) {
        return document;
    };
    ApolloCache.prototype.identify = function(object) {
        return;
    };
    ApolloCache.prototype.gc = function() {
        return [];
    };
    ApolloCache.prototype.modify = function(options) {
        return false;
    };
    // DataProxy API
    ApolloCache.prototype.readQuery = function(options, optimistic) {
        if (optimistic === void 0) optimistic = !!options.optimistic;
        return this.read((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, options), {
            rootId: options.id || "ROOT_QUERY",
            optimistic: optimistic
        }));
    };
    /** {@inheritDoc @apollo/client!ApolloClient#watchFragment:member(1)} */ ApolloCache.prototype.watchFragment = function(options) {
        var _this = this;
        var fragment = options.fragment, fragmentName = options.fragmentName, from = options.from, _a = options.optimistic, optimistic = _a === void 0 ? true : _a, otherOptions = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(options, [
            "fragment",
            "fragmentName",
            "from",
            "optimistic"
        ]);
        var query = this.getFragmentDoc(fragment, fragmentName);
        var diffOptions = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, otherOptions), {
            returnPartialData: true,
            id: // While our TypeScript types do not allow for `undefined` as a valid
            // `from`, its possible `useFragment` gives us an `undefined` since it
            // calls` cache.identify` and provides that value to `from`. We are
            // adding this fix here however to ensure those using plain JavaScript
            // and using `cache.identify` themselves will avoid seeing the obscure
            // warning.
            typeof from === "undefined" || typeof from === "string" ? from : this.identify(from),
            query: query,
            optimistic: optimistic
        });
        var latestDiff;
        return new (0, $6d99a9de69717ea6$export$77cea355fa80b5f4)(function(observer) {
            return _this.watch((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, diffOptions), {
                immediate: true,
                callback: function(diff) {
                    if (// Always ensure we deliver the first result
                    latestDiff && (0, $3703278c0cb633ee$export$5e40714c5ad44445)(query, {
                        data: latestDiff === null || latestDiff === void 0 ? void 0 : latestDiff.result
                    }, {
                        data: diff.result
                    })) return;
                    var result = {
                        data: diff.result,
                        complete: !!diff.complete
                    };
                    if (diff.missing) result.missing = (0, $0217b27a7999d1ae$export$160070228be94b08)(diff.missing.map(function(error) {
                        return error.missing;
                    }));
                    latestDiff = diff;
                    observer.next(result);
                }
            }));
        });
    };
    ApolloCache.prototype.readFragment = function(options, optimistic) {
        if (optimistic === void 0) optimistic = !!options.optimistic;
        return this.read((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, options), {
            query: this.getFragmentDoc(options.fragment, options.fragmentName),
            rootId: options.id,
            optimistic: optimistic
        }));
    };
    ApolloCache.prototype.writeQuery = function(_a) {
        var id = _a.id, data = _a.data, options = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(_a, [
            "id",
            "data"
        ]);
        return this.write(Object.assign(options, {
            dataId: id || "ROOT_QUERY",
            result: data
        }));
    };
    ApolloCache.prototype.writeFragment = function(_a) {
        var id = _a.id, data = _a.data, fragment = _a.fragment, fragmentName = _a.fragmentName, options = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(_a, [
            "id",
            "data",
            "fragment",
            "fragmentName"
        ]);
        return this.write(Object.assign(options, {
            query: this.getFragmentDoc(fragment, fragmentName),
            dataId: id,
            result: data
        }));
    };
    ApolloCache.prototype.updateQuery = function(options, update) {
        return this.batch({
            update: function(cache) {
                var value = cache.readQuery(options);
                var data = update(value);
                if (data === void 0 || data === null) return value;
                cache.writeQuery((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, options), {
                    data: data
                }));
                return data;
            }
        });
    };
    ApolloCache.prototype.updateFragment = function(options, update) {
        return this.batch({
            update: function(cache) {
                var value = cache.readFragment(options);
                var data = update(value);
                if (data === void 0 || data === null) return value;
                cache.writeFragment((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, options), {
                    data: data
                }));
                return data;
            }
        });
    };
    return ApolloCache;
}();
if (globalThis.__DEV__ !== false) $3b55b3aff583fbaf$export$5fc74f25506aa9c.prototype.getMemoryInternals = (0, $1da01699264b6e1e$export$e7ed438e82606689);



var $5b6ca74647771eb2$export$257c68286583b0f9 = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(MissingFieldError, _super);
    function MissingFieldError(message, path, query, variables) {
        var _a;
        // 'Error' breaks prototype chain here
        var _this = _super.call(this, message) || this;
        _this.message = message;
        _this.path = path;
        _this.query = query;
        _this.variables = variables;
        if (Array.isArray(_this.path)) {
            _this.missing = _this.message;
            for(var i = _this.path.length - 1; i >= 0; --i)_this.missing = (_a = {}, _a[_this.path[i]] = _this.missing, _a);
        } else _this.missing = _this.path;
        // We're not using `Object.setPrototypeOf` here as it isn't fully supported
        // on Android (see issue #3236).
        _this.__proto__ = MissingFieldError.prototype;
        return _this;
    }
    return MissingFieldError;
}(Error);








function $310a6ebe531ba02b$var$deepFreeze(value) {
    var workSet = new Set([
        value
    ]);
    workSet.forEach(function(obj) {
        if ((0, $3a16601e2096f4cd$export$417207af72fad9c9)(obj) && $310a6ebe531ba02b$var$shallowFreeze(obj) === obj) Object.getOwnPropertyNames(obj).forEach(function(name) {
            if ((0, $3a16601e2096f4cd$export$417207af72fad9c9)(obj[name])) workSet.add(obj[name]);
        });
    });
    return value;
}
function $310a6ebe531ba02b$var$shallowFreeze(obj) {
    if (globalThis.__DEV__ !== false && !Object.isFrozen(obj)) try {
        Object.freeze(obj);
    } catch (e) {
        // Some types like Uint8Array and Node.js's Buffer cannot be frozen, but
        // they all throw a TypeError when you try, so we re-throw any exceptions
        // that are not TypeErrors, since that would be unexpected.
        if (e instanceof TypeError) return null;
        throw e;
    }
    return obj;
}
function $310a6ebe531ba02b$export$7f9c177735b71f18(obj) {
    if (globalThis.__DEV__ !== false) $310a6ebe531ba02b$var$deepFreeze(obj);
    return obj;
}









var $3f1d3403edb822de$export$b5a638e9b3fff9f3 = Object.prototype.hasOwnProperty;
function $3f1d3403edb822de$export$b931b78cbb3caf86(value) {
    return value === null || value === void 0;
}
function $3f1d3403edb822de$export$bd03c5a9c99d6bce(_a, context) {
    var __typename = _a.__typename, id = _a.id, _id = _a._id;
    if (typeof __typename === "string") {
        if (context) context.keyObject = !$3f1d3403edb822de$export$b931b78cbb3caf86(id) ? {
            id: id
        } : !$3f1d3403edb822de$export$b931b78cbb3caf86(_id) ? {
            _id: _id
        } : void 0;
        // If there is no object.id, fall back to object._id.
        if ($3f1d3403edb822de$export$b931b78cbb3caf86(id) && !$3f1d3403edb822de$export$b931b78cbb3caf86(_id)) id = _id;
        if (!$3f1d3403edb822de$export$b931b78cbb3caf86(id)) return "".concat(__typename, ":").concat(typeof id === "number" || typeof id === "string" ? id : JSON.stringify(id));
    }
}
var $3f1d3403edb822de$var$defaultConfig = {
    dataIdFromObject: $3f1d3403edb822de$export$bd03c5a9c99d6bce,
    addTypename: true,
    resultCaching: true,
    // Thanks to the shouldCanonizeResults helper, this should be the only line
    // you have to change to reenable canonization by default in the future.
    canonizeResults: false
};
function $3f1d3403edb822de$export$fa542f9ee3f7f4e2(config) {
    return (0, $2f3cebf1a05c1b38$export$8e16b83750b44988)($3f1d3403edb822de$var$defaultConfig, config);
}
function $3f1d3403edb822de$export$3ac2a95fbd99c479(config) {
    var value = config.canonizeResults;
    return value === void 0 ? $3f1d3403edb822de$var$defaultConfig.canonizeResults : value;
}
function $3f1d3403edb822de$export$fdef206c83ff2c09(store, objectOrReference) {
    return (0, $9d830e5028848843$export$fa99cac1c0883c47)(objectOrReference) ? store.get(objectOrReference.__ref, "__typename") : objectOrReference && objectOrReference.__typename;
}
var $3f1d3403edb822de$export$6ed54d4784f1ce28 = /^[_a-z][_0-9a-z]*/i;
function $3f1d3403edb822de$export$37874422037b6029(storeFieldName) {
    var match = storeFieldName.match($3f1d3403edb822de$export$6ed54d4784f1ce28);
    return match ? match[0] : storeFieldName;
}
function $3f1d3403edb822de$export$60bd1cbb09c1a4a2(selectionSet, result, variables) {
    if ((0, $3a16601e2096f4cd$export$417207af72fad9c9)(result)) return (0, $e6aaa0e65613edd7$export$43bee75e5e14138e)(result) ? result.every(function(item) {
        return $3f1d3403edb822de$export$60bd1cbb09c1a4a2(selectionSet, item, variables);
    }) : selectionSet.selections.every(function(field) {
        if ((0, $9d830e5028848843$export$fb56ad75dd311c12)(field) && (0, $89c1eec09879e1ca$export$3dc388a5f013b4a5)(field, variables)) {
            var key = (0, $9d830e5028848843$export$7d1ad22471852218)(field);
            return $3f1d3403edb822de$export$b5a638e9b3fff9f3.call(result, key) && (!field.selectionSet || $3f1d3403edb822de$export$60bd1cbb09c1a4a2(field.selectionSet, result[key], variables));
        }
        // If the selection has been skipped with @skip(true) or
        // @include(false), it should not count against the matching. If
        // the selection is not a field, it must be a fragment (inline or
        // named). We will determine if selectionSetMatchesResult for that
        // fragment when we get to it, so for now we return true.
        return true;
    });
    return false;
}
function $3f1d3403edb822de$export$4f39afca21bd938e(value) {
    return (0, $3a16601e2096f4cd$export$417207af72fad9c9)(value) && !(0, $9d830e5028848843$export$fa99cac1c0883c47)(value) && !(0, $e6aaa0e65613edd7$export$43bee75e5e14138e)(value);
}
function $3f1d3403edb822de$export$b874a818f7a2fa6d() {
    return new (0, $0217b27a7999d1ae$export$509e11c221f576c0)();
}
function $3f1d3403edb822de$export$3a33c00f0ae4a480(document, fragments) {
    // FragmentMap consisting only of fragments defined directly in document, not
    // including other fragments registered in the FragmentRegistry.
    var fragmentMap = (0, $7f688c9754699513$export$193789b4c8246dd4)((0, $818d93327cb72c29$export$5320a7ba9466a3df)(document));
    return {
        fragmentMap: fragmentMap,
        lookupFragment: function(name) {
            var def = fragmentMap[name];
            if (!def && fragments) def = fragments.lookup(name);
            return def || null;
        }
    };
}


var $0268d457c22a2684$var$DELETE = Object.create(null);
var $0268d457c22a2684$var$delModifier = function() {
    return $0268d457c22a2684$var$DELETE;
};
var $0268d457c22a2684$var$INVALIDATE = Object.create(null);
var $0268d457c22a2684$export$cb507f57054c7321 = /** @class */ function() {
    function EntityStore(policies, group) {
        var _this = this;
        this.policies = policies;
        this.group = group;
        this.data = Object.create(null);
        // Maps root entity IDs to the number of times they have been retained, minus
        // the number of times they have been released. Retained entities keep other
        // entities they reference (even indirectly) from being garbage collected.
        this.rootIds = Object.create(null);
        // Lazily tracks { __ref: <dataId> } strings contained by this.data[dataId].
        this.refs = Object.create(null);
        // Bound function that can be passed around to provide easy access to fields
        // of Reference objects as well as ordinary objects.
        this.getFieldValue = function(objectOrReference, storeFieldName) {
            return (0, $310a6ebe531ba02b$export$7f9c177735b71f18)((0, $9d830e5028848843$export$fa99cac1c0883c47)(objectOrReference) ? _this.get(objectOrReference.__ref, storeFieldName) : objectOrReference && objectOrReference[storeFieldName]);
        };
        // Returns true for non-normalized StoreObjects and non-dangling
        // References, indicating that readField(name, objOrRef) has a chance of
        // working. Useful for filtering out dangling references from lists.
        this.canRead = function(objOrRef) {
            return (0, $9d830e5028848843$export$fa99cac1c0883c47)(objOrRef) ? _this.has(objOrRef.__ref) : typeof objOrRef === "object";
        };
        // Bound function that converts an id or an object with a __typename and
        // primary key fields to a Reference object. If called with a Reference object,
        // that same Reference object is returned. Pass true for mergeIntoStore to persist
        // an object into the store.
        this.toReference = function(objOrIdOrRef, mergeIntoStore) {
            if (typeof objOrIdOrRef === "string") return (0, $9d830e5028848843$export$634ae0e932e9be99)(objOrIdOrRef);
            if ((0, $9d830e5028848843$export$fa99cac1c0883c47)(objOrIdOrRef)) return objOrIdOrRef;
            var id = _this.policies.identify(objOrIdOrRef)[0];
            if (id) {
                var ref = (0, $9d830e5028848843$export$634ae0e932e9be99)(id);
                if (mergeIntoStore) _this.merge(id, objOrIdOrRef);
                return ref;
            }
        };
    }
    // Although the EntityStore class is abstract, it contains concrete
    // implementations of the various NormalizedCache interface methods that
    // are inherited by the Root and Layer subclasses.
    EntityStore.prototype.toObject = function() {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, this.data);
    };
    EntityStore.prototype.has = function(dataId) {
        return this.lookup(dataId, true) !== void 0;
    };
    EntityStore.prototype.get = function(dataId, fieldName) {
        this.group.depend(dataId, fieldName);
        if ((0, $3f1d3403edb822de$export$b5a638e9b3fff9f3).call(this.data, dataId)) {
            var storeObject = this.data[dataId];
            if (storeObject && (0, $3f1d3403edb822de$export$b5a638e9b3fff9f3).call(storeObject, fieldName)) return storeObject[fieldName];
        }
        if (fieldName === "__typename" && (0, $3f1d3403edb822de$export$b5a638e9b3fff9f3).call(this.policies.rootTypenamesById, dataId)) return this.policies.rootTypenamesById[dataId];
        if (this instanceof $0268d457c22a2684$var$Layer) return this.parent.get(dataId, fieldName);
    };
    EntityStore.prototype.lookup = function(dataId, dependOnExistence) {
        // The has method (above) calls lookup with dependOnExistence = true, so
        // that it can later be invalidated when we add or remove a StoreObject for
        // this dataId. Any consumer who cares about the contents of the StoreObject
        // should not rely on this dependency, since the contents could change
        // without the object being added or removed.
        if (dependOnExistence) this.group.depend(dataId, "__exists");
        if ((0, $3f1d3403edb822de$export$b5a638e9b3fff9f3).call(this.data, dataId)) return this.data[dataId];
        if (this instanceof $0268d457c22a2684$var$Layer) return this.parent.lookup(dataId, dependOnExistence);
        if (this.policies.rootTypenamesById[dataId]) return Object.create(null);
    };
    EntityStore.prototype.merge = function(older, newer) {
        var _this = this;
        var dataId;
        // Convert unexpected references to ID strings.
        if ((0, $9d830e5028848843$export$fa99cac1c0883c47)(older)) older = older.__ref;
        if ((0, $9d830e5028848843$export$fa99cac1c0883c47)(newer)) newer = newer.__ref;
        var existing = typeof older === "string" ? this.lookup(dataId = older) : older;
        var incoming = typeof newer === "string" ? this.lookup(dataId = newer) : newer;
        // If newer was a string ID, but that ID was not defined in this store,
        // then there are no fields to be merged, so we're done.
        if (!incoming) return;
        (0, $28d90d877eb1e517$export$f5708dca728d7177)(typeof dataId === "string", 1);
        var merged = new (0, $0217b27a7999d1ae$export$509e11c221f576c0)($0268d457c22a2684$var$storeObjectReconciler).merge(existing, incoming);
        // Even if merged === existing, existing may have come from a lower
        // layer, so we always need to set this.data[dataId] on this level.
        this.data[dataId] = merged;
        if (merged !== existing) {
            delete this.refs[dataId];
            if (this.group.caching) {
                var fieldsToDirty_1 = Object.create(null);
                // If we added a new StoreObject where there was previously none, dirty
                // anything that depended on the existence of this dataId, such as the
                // EntityStore#has method.
                if (!existing) fieldsToDirty_1.__exists = 1;
                // Now invalidate dependents who called getFieldValue for any fields
                // that are changing as a result of this merge.
                Object.keys(incoming).forEach(function(storeFieldName) {
                    if (!existing || existing[storeFieldName] !== merged[storeFieldName]) {
                        // Always dirty the full storeFieldName, which may include
                        // serialized arguments following the fieldName prefix.
                        fieldsToDirty_1[storeFieldName] = 1;
                        // Also dirty fieldNameFromStoreName(storeFieldName) if it's
                        // different from storeFieldName and this field does not have
                        // keyArgs configured, because that means the cache can't make
                        // any assumptions about how field values with the same field
                        // name but different arguments might be interrelated, so it
                        // must err on the side of invalidating all field values that
                        // share the same short fieldName, regardless of arguments.
                        var fieldName = (0, $3f1d3403edb822de$export$37874422037b6029)(storeFieldName);
                        if (fieldName !== storeFieldName && !_this.policies.hasKeyArgs(merged.__typename, fieldName)) fieldsToDirty_1[fieldName] = 1;
                        // If merged[storeFieldName] has become undefined, and this is the
                        // Root layer, actually delete the property from the merged object,
                        // which is guaranteed to have been created fresh in this method.
                        if (merged[storeFieldName] === void 0 && !(_this instanceof $0268d457c22a2684$var$Layer)) delete merged[storeFieldName];
                    }
                });
                if (fieldsToDirty_1.__typename && !(existing && existing.__typename) && // Since we return default root __typename strings
                // automatically from store.get, we don't need to dirty the
                // ROOT_QUERY.__typename field if merged.__typename is equal
                // to the default string (usually "Query").
                this.policies.rootTypenamesById[dataId] === merged.__typename) delete fieldsToDirty_1.__typename;
                Object.keys(fieldsToDirty_1).forEach(function(fieldName) {
                    return _this.group.dirty(dataId, fieldName);
                });
            }
        }
    };
    EntityStore.prototype.modify = function(dataId, fields) {
        var _this = this;
        var storeObject = this.lookup(dataId);
        if (storeObject) {
            var changedFields_1 = Object.create(null);
            var needToMerge_1 = false;
            var allDeleted_1 = true;
            var sharedDetails_1 = {
                DELETE: $0268d457c22a2684$var$DELETE,
                INVALIDATE: $0268d457c22a2684$var$INVALIDATE,
                isReference: (0, $9d830e5028848843$export$fa99cac1c0883c47),
                toReference: this.toReference,
                canRead: this.canRead,
                readField: function(fieldNameOrOptions, from) {
                    return _this.policies.readField(typeof fieldNameOrOptions === "string" ? {
                        fieldName: fieldNameOrOptions,
                        from: from || (0, $9d830e5028848843$export$634ae0e932e9be99)(dataId)
                    } : fieldNameOrOptions, {
                        store: _this
                    });
                }
            };
            Object.keys(storeObject).forEach(function(storeFieldName) {
                var fieldName = (0, $3f1d3403edb822de$export$37874422037b6029)(storeFieldName);
                var fieldValue = storeObject[storeFieldName];
                if (fieldValue === void 0) return;
                var modify = typeof fields === "function" ? fields : fields[storeFieldName] || fields[fieldName];
                if (modify) {
                    var newValue = modify === $0268d457c22a2684$var$delModifier ? $0268d457c22a2684$var$DELETE : modify((0, $310a6ebe531ba02b$export$7f9c177735b71f18)(fieldValue), (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, sharedDetails_1), {
                        fieldName: fieldName,
                        storeFieldName: storeFieldName,
                        storage: _this.getStorage(dataId, storeFieldName)
                    }));
                    if (newValue === $0268d457c22a2684$var$INVALIDATE) _this.group.dirty(dataId, storeFieldName);
                    else {
                        if (newValue === $0268d457c22a2684$var$DELETE) newValue = void 0;
                        if (newValue !== fieldValue) {
                            changedFields_1[storeFieldName] = newValue;
                            needToMerge_1 = true;
                            fieldValue = newValue;
                            if (globalThis.__DEV__ !== false) {
                                var checkReference = function(ref) {
                                    if (_this.lookup(ref.__ref) === undefined) {
                                        globalThis.__DEV__ !== false && (0, $28d90d877eb1e517$export$f5708dca728d7177).warn(2, ref);
                                        return true;
                                    }
                                };
                                if ((0, $9d830e5028848843$export$fa99cac1c0883c47)(newValue)) checkReference(newValue);
                                else if (Array.isArray(newValue)) {
                                    // Warn about writing "mixed" arrays of Reference and non-Reference objects
                                    var seenReference = false;
                                    var someNonReference = void 0;
                                    for(var _i = 0, newValue_1 = newValue; _i < newValue_1.length; _i++){
                                        var value = newValue_1[_i];
                                        if ((0, $9d830e5028848843$export$fa99cac1c0883c47)(value)) {
                                            seenReference = true;
                                            if (checkReference(value)) break;
                                        } else // Do not warn on primitive values, since those could never be represented
                                        // by a reference. This is a valid (albeit uncommon) use case.
                                        if (typeof value === "object" && !!value) {
                                            var id = _this.policies.identify(value)[0];
                                            // check if object could even be referenced, otherwise we are not interested in it for this warning
                                            if (id) someNonReference = value;
                                        }
                                        if (seenReference && someNonReference !== undefined) {
                                            globalThis.__DEV__ !== false && (0, $28d90d877eb1e517$export$f5708dca728d7177).warn(3, someNonReference);
                                            break;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                if (fieldValue !== void 0) allDeleted_1 = false;
            });
            if (needToMerge_1) {
                this.merge(dataId, changedFields_1);
                if (allDeleted_1) {
                    if (this instanceof $0268d457c22a2684$var$Layer) this.data[dataId] = void 0;
                    else delete this.data[dataId];
                    this.group.dirty(dataId, "__exists");
                }
                return true;
            }
        }
        return false;
    };
    // If called with only one argument, removes the entire entity
    // identified by dataId. If called with a fieldName as well, removes all
    // fields of that entity whose names match fieldName according to the
    // fieldNameFromStoreName helper function. If called with a fieldName
    // and variables, removes all fields of that entity whose names match fieldName
    // and whose arguments when cached exactly match the variables passed.
    EntityStore.prototype.delete = function(dataId, fieldName, args) {
        var _a;
        var storeObject = this.lookup(dataId);
        if (storeObject) {
            var typename = this.getFieldValue(storeObject, "__typename");
            var storeFieldName = fieldName && args ? this.policies.getStoreFieldName({
                typename: typename,
                fieldName: fieldName,
                args: args
            }) : fieldName;
            return this.modify(dataId, storeFieldName ? (_a = {}, _a[storeFieldName] = $0268d457c22a2684$var$delModifier, _a) : $0268d457c22a2684$var$delModifier);
        }
        return false;
    };
    EntityStore.prototype.evict = function(options, limit) {
        var evicted = false;
        if (options.id) {
            if ((0, $3f1d3403edb822de$export$b5a638e9b3fff9f3).call(this.data, options.id)) evicted = this.delete(options.id, options.fieldName, options.args);
            if (this instanceof $0268d457c22a2684$var$Layer && this !== limit) evicted = this.parent.evict(options, limit) || evicted;
            // Always invalidate the field to trigger rereading of watched
            // queries, even if no cache data was modified by the eviction,
            // because queries may depend on computed fields with custom read
            // functions, whose values are not stored in the EntityStore.
            if (options.fieldName || evicted) this.group.dirty(options.id, options.fieldName || "__exists");
        }
        return evicted;
    };
    EntityStore.prototype.clear = function() {
        this.replace(null);
    };
    EntityStore.prototype.extract = function() {
        var _this = this;
        var obj = this.toObject();
        var extraRootIds = [];
        this.getRootIdSet().forEach(function(id) {
            if (!(0, $3f1d3403edb822de$export$b5a638e9b3fff9f3).call(_this.policies.rootTypenamesById, id)) extraRootIds.push(id);
        });
        if (extraRootIds.length) obj.__META = {
            extraRootIds: extraRootIds.sort()
        };
        return obj;
    };
    EntityStore.prototype.replace = function(newData) {
        var _this = this;
        Object.keys(this.data).forEach(function(dataId) {
            if (!(newData && (0, $3f1d3403edb822de$export$b5a638e9b3fff9f3).call(newData, dataId))) _this.delete(dataId);
        });
        if (newData) {
            var __META = newData.__META, rest_1 = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(newData, [
                "__META"
            ]);
            Object.keys(rest_1).forEach(function(dataId) {
                _this.merge(dataId, rest_1[dataId]);
            });
            if (__META) __META.extraRootIds.forEach(this.retain, this);
        }
    };
    EntityStore.prototype.retain = function(rootId) {
        return this.rootIds[rootId] = (this.rootIds[rootId] || 0) + 1;
    };
    EntityStore.prototype.release = function(rootId) {
        if (this.rootIds[rootId] > 0) {
            var count = --this.rootIds[rootId];
            if (!count) delete this.rootIds[rootId];
            return count;
        }
        return 0;
    };
    // Return a Set<string> of all the ID strings that have been retained by
    // this layer/root *and* any layers/roots beneath it.
    EntityStore.prototype.getRootIdSet = function(ids) {
        if (ids === void 0) ids = new Set();
        Object.keys(this.rootIds).forEach(ids.add, ids);
        if (this instanceof $0268d457c22a2684$var$Layer) this.parent.getRootIdSet(ids);
        else // Official singleton IDs like ROOT_QUERY and ROOT_MUTATION are
        // always considered roots for garbage collection, regardless of
        // their retainment counts in this.rootIds.
        Object.keys(this.policies.rootTypenamesById).forEach(ids.add, ids);
        return ids;
    };
    // The goal of garbage collection is to remove IDs from the Root layer of the
    // store that are no longer reachable starting from any IDs that have been
    // explicitly retained (see retain and release, above). Returns an array of
    // dataId strings that were removed from the store.
    EntityStore.prototype.gc = function() {
        var _this = this;
        var ids = this.getRootIdSet();
        var snapshot = this.toObject();
        ids.forEach(function(id) {
            if ((0, $3f1d3403edb822de$export$b5a638e9b3fff9f3).call(snapshot, id)) {
                // Because we are iterating over an ECMAScript Set, the IDs we add here
                // will be visited in later iterations of the forEach loop only if they
                // were not previously contained by the Set.
                Object.keys(_this.findChildRefIds(id)).forEach(ids.add, ids);
                // By removing IDs from the snapshot object here, we protect them from
                // getting removed from the root store layer below.
                delete snapshot[id];
            }
        });
        var idsToRemove = Object.keys(snapshot);
        if (idsToRemove.length) {
            var root_1 = this;
            while(root_1 instanceof $0268d457c22a2684$var$Layer)root_1 = root_1.parent;
            idsToRemove.forEach(function(id) {
                return root_1.delete(id);
            });
        }
        return idsToRemove;
    };
    EntityStore.prototype.findChildRefIds = function(dataId) {
        if (!(0, $3f1d3403edb822de$export$b5a638e9b3fff9f3).call(this.refs, dataId)) {
            var found_1 = this.refs[dataId] = Object.create(null);
            var root = this.data[dataId];
            if (!root) return found_1;
            var workSet_1 = new Set([
                root
            ]);
            // Within the store, only arrays and objects can contain child entity
            // references, so we can prune the traversal using this predicate:
            workSet_1.forEach(function(obj) {
                if ((0, $9d830e5028848843$export$fa99cac1c0883c47)(obj)) found_1[obj.__ref] = true;
                if ((0, $3a16601e2096f4cd$export$417207af72fad9c9)(obj)) Object.keys(obj).forEach(function(key) {
                    var child = obj[key];
                    // No need to add primitive values to the workSet, since they cannot
                    // contain reference objects.
                    if ((0, $3a16601e2096f4cd$export$417207af72fad9c9)(child)) workSet_1.add(child);
                });
            });
        }
        return this.refs[dataId];
    };
    EntityStore.prototype.makeCacheKey = function() {
        return this.group.keyMaker.lookupArray(arguments);
    };
    return EntityStore;
}();
// A single CacheGroup represents a set of one or more EntityStore objects,
// typically the Root store in a CacheGroup by itself, and all active Layer
// stores in a group together. A single EntityStore object belongs to only
// one CacheGroup, store.group. The CacheGroup is responsible for tracking
// dependencies, so store.group is helpful for generating unique keys for
// cached results that need to be invalidated when/if those dependencies
// change. If we used the EntityStore objects themselves as cache keys (that
// is, store rather than store.group), the cache would become unnecessarily
// fragmented by all the different Layer objects. Instead, the CacheGroup
// approach allows all optimistic Layer objects in the same linked list to
// belong to one CacheGroup, with the non-optimistic Root object belonging
// to another CacheGroup, allowing resultCaching dependencies to be tracked
// separately for optimistic and non-optimistic entity data.
var $0268d457c22a2684$var$CacheGroup = /** @class */ function() {
    function CacheGroup(caching, parent) {
        if (parent === void 0) parent = null;
        this.caching = caching;
        this.parent = parent;
        this.d = null;
        this.resetCaching();
    }
    CacheGroup.prototype.resetCaching = function() {
        this.d = this.caching ? (0, $f96bffcf733fdbbf$export$c723b7eff9d8f870)() : null;
        this.keyMaker = new (0, $02443dfd16cf74b4$export$73571c50d0f2507e)((0, $5d0a073f980bb2a3$export$772fbc04a0ad4ce9));
    };
    CacheGroup.prototype.depend = function(dataId, storeFieldName) {
        if (this.d) {
            this.d($0268d457c22a2684$var$makeDepKey(dataId, storeFieldName));
            var fieldName = (0, $3f1d3403edb822de$export$37874422037b6029)(storeFieldName);
            if (fieldName !== storeFieldName) // Fields with arguments that contribute extra identifying
            // information to the fieldName (thus forming the storeFieldName)
            // depend not only on the full storeFieldName but also on the
            // short fieldName, so the field can be invalidated using either
            // level of specificity.
            this.d($0268d457c22a2684$var$makeDepKey(dataId, fieldName));
            if (this.parent) this.parent.depend(dataId, storeFieldName);
        }
    };
    CacheGroup.prototype.dirty = function(dataId, storeFieldName) {
        if (this.d) this.d.dirty($0268d457c22a2684$var$makeDepKey(dataId, storeFieldName), // When storeFieldName === "__exists", that means the entity identified
        // by dataId has either disappeared from the cache or was newly added,
        // so the result caching system would do well to "forget everything it
        // knows" about that object. To achieve that kind of invalidation, we
        // not only dirty the associated result cache entry, but also remove it
        // completely from the dependency graph. For the optimism implementation
        // details, see https://github.com/benjamn/optimism/pull/195.
        storeFieldName === "__exists" ? "forget" : "setDirty");
    };
    return CacheGroup;
}();
function $0268d457c22a2684$var$makeDepKey(dataId, storeFieldName) {
    // Since field names cannot have '#' characters in them, this method
    // of joining the field name and the ID should be unambiguous, and much
    // cheaper than JSON.stringify([dataId, fieldName]).
    return storeFieldName + "#" + dataId;
}
function $0268d457c22a2684$export$f8068a30967ddc18(store, entityId) {
    if ($0268d457c22a2684$export$488c0743feab3d61(store)) // We use this pseudo-field __exists elsewhere in the EntityStore code to
    // represent changes in the existence of the entity object identified by
    // entityId. This dependency gets reliably dirtied whenever an object with
    // this ID is deleted (or newly created) within this group, so any result
    // cache entries (for example, StoreReader#executeSelectionSet results) that
    // depend on __exists for this entityId will get dirtied as well, leading to
    // the eventual recomputation (instead of reuse) of those result objects the
    // next time someone reads them from the cache.
    store.group.depend(entityId, "__exists");
}
(function(EntityStore) {
    // Refer to this class as EntityStore.Root outside this namespace.
    var Root = /** @class */ function(_super) {
        (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(Root, _super);
        function Root(_a) {
            var policies = _a.policies, _b = _a.resultCaching, resultCaching = _b === void 0 ? true : _b, seed = _a.seed;
            var _this = _super.call(this, policies, new $0268d457c22a2684$var$CacheGroup(resultCaching)) || this;
            _this.stump = new $0268d457c22a2684$var$Stump(_this);
            _this.storageTrie = new (0, $02443dfd16cf74b4$export$73571c50d0f2507e)((0, $5d0a073f980bb2a3$export$772fbc04a0ad4ce9));
            if (seed) _this.replace(seed);
            return _this;
        }
        Root.prototype.addLayer = function(layerId, replay) {
            // Adding an optimistic Layer on top of the Root actually adds the Layer
            // on top of the Stump, so the Stump always comes between the Root and
            // any Layer objects that we've added.
            return this.stump.addLayer(layerId, replay);
        };
        Root.prototype.removeLayer = function() {
            // Never remove the root layer.
            return this;
        };
        Root.prototype.getStorage = function() {
            return this.storageTrie.lookupArray(arguments);
        };
        return Root;
    }(EntityStore);
    EntityStore.Root = Root;
})($0268d457c22a2684$export$cb507f57054c7321 || ($0268d457c22a2684$export$cb507f57054c7321 = {}));
// Not exported, since all Layer instances are created by the addLayer method
// of the EntityStore.Root class.
var $0268d457c22a2684$var$Layer = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(Layer, _super);
    function Layer(id, parent, replay, group) {
        var _this = _super.call(this, parent.policies, group) || this;
        _this.id = id;
        _this.parent = parent;
        _this.replay = replay;
        _this.group = group;
        replay(_this);
        return _this;
    }
    Layer.prototype.addLayer = function(layerId, replay) {
        return new Layer(layerId, this, replay, this.group);
    };
    Layer.prototype.removeLayer = function(layerId) {
        var _this = this;
        // Remove all instances of the given id, not just the first one.
        var parent = this.parent.removeLayer(layerId);
        if (layerId === this.id) {
            if (this.group.caching) // Dirty every ID we're removing. Technically we might be able to avoid
            // dirtying fields that have values in higher layers, but we don't have
            // easy access to higher layers here, and we're about to recreate those
            // layers anyway (see parent.addLayer below).
            Object.keys(this.data).forEach(function(dataId) {
                var ownStoreObject = _this.data[dataId];
                var parentStoreObject = parent["lookup"](dataId);
                if (!parentStoreObject) // The StoreObject identified by dataId was defined in this layer
                // but will be undefined in the parent layer, so we can delete the
                // whole entity using this.delete(dataId). Since we're about to
                // throw this layer away, the only goal of this deletion is to dirty
                // the removed fields.
                _this.delete(dataId);
                else if (!ownStoreObject) {
                    // This layer had an entry for dataId but it was undefined, which
                    // means the entity was deleted in this layer, and it's about to
                    // become undeleted when we remove this layer, so we need to dirty
                    // all fields that are about to be reexposed.
                    _this.group.dirty(dataId, "__exists");
                    Object.keys(parentStoreObject).forEach(function(storeFieldName) {
                        _this.group.dirty(dataId, storeFieldName);
                    });
                } else if (ownStoreObject !== parentStoreObject) // If ownStoreObject is not exactly the same as parentStoreObject,
                // dirty any fields whose values will change as a result of this
                // removal.
                Object.keys(ownStoreObject).forEach(function(storeFieldName) {
                    if (!(0, $a2b6f433e732b502$export$411ce8e5a71e3069)(ownStoreObject[storeFieldName], parentStoreObject[storeFieldName])) _this.group.dirty(dataId, storeFieldName);
                });
            });
            return parent;
        }
        // No changes are necessary if the parent chain remains identical.
        if (parent === this.parent) return this;
        // Recreate this layer on top of the new parent.
        return parent.addLayer(this.id, this.replay);
    };
    Layer.prototype.toObject = function() {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, this.parent.toObject()), this.data);
    };
    Layer.prototype.findChildRefIds = function(dataId) {
        var fromParent = this.parent.findChildRefIds(dataId);
        return (0, $3f1d3403edb822de$export$b5a638e9b3fff9f3).call(this.data, dataId) ? (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, fromParent), _super.prototype.findChildRefIds.call(this, dataId)) : fromParent;
    };
    Layer.prototype.getStorage = function() {
        var p = this.parent;
        while(p.parent)p = p.parent;
        return p.getStorage.apply(p, // @ts-expect-error
        arguments);
    };
    return Layer;
}($0268d457c22a2684$export$cb507f57054c7321);
// Represents a Layer permanently installed just above the Root, which allows
// reading optimistically (and registering optimistic dependencies) even when
// no optimistic layers are currently active. The stump.group CacheGroup object
// is shared by any/all Layer objects added on top of the Stump.
var $0268d457c22a2684$var$Stump = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(Stump, _super);
    function Stump(root) {
        return _super.call(this, "EntityStore.Stump", root, function() {}, new $0268d457c22a2684$var$CacheGroup(root.group.caching, root.group)) || this;
    }
    Stump.prototype.removeLayer = function() {
        // Never remove the Stump layer.
        return this;
    };
    Stump.prototype.merge = function(older, newer) {
        // We never want to write any data into the Stump, so we forward any merge
        // calls to the Root instead. Another option here would be to throw an
        // exception, but the toReference(object, true) function can sometimes
        // trigger Stump writes (which used to be Root writes, before the Stump
        // concept was introduced).
        return this.parent.merge(older, newer);
    };
    return Stump;
}($0268d457c22a2684$var$Layer);
function $0268d457c22a2684$var$storeObjectReconciler(existingObject, incomingObject, property) {
    var existingValue = existingObject[property];
    var incomingValue = incomingObject[property];
    // Wherever there is a key collision, prefer the incoming value, unless
    // it is deeply equal to the existing value. It's worth checking deep
    // equality here (even though blindly returning incoming would be
    // logically correct) because preserving the referential identity of
    // existing data can prevent needless rereading and rerendering.
    return (0, $a2b6f433e732b502$export$411ce8e5a71e3069)(existingValue, incomingValue) ? existingValue : incomingValue;
}
function $0268d457c22a2684$export$488c0743feab3d61(store) {
    // When result caching is disabled, store.depend will be null.
    return !!(store instanceof $0268d457c22a2684$export$cb507f57054c7321 && store.group.caching);
}








function $4a344505b0ae796e$var$shallowCopy(value) {
    if ((0, $3a16601e2096f4cd$export$417207af72fad9c9)(value)) return (0, $e6aaa0e65613edd7$export$43bee75e5e14138e)(value) ? value.slice(0) : (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
        __proto__: Object.getPrototypeOf(value)
    }, value);
    return value;
}
// When programmers talk about the "canonical form" of an object, they
// usually have the following meaning in mind, which I've copied from
// https://en.wiktionary.org/wiki/canonical_form:
//
// 1. A standard or normal presentation of a mathematical entity [or
//    object]. A canonical form is an element of a set of representatives
//    of equivalence classes of forms such that there is a function or
//    procedure which projects every element of each equivalence class
//    onto that one element, the canonical form of that equivalence
//    class. The canonical form is expected to be simpler than the rest of
//    the forms in some way.
//
// That's a long-winded way of saying any two objects that have the same
// canonical form may be considered equivalent, even if they are !==,
// which usually means the objects are structurally equivalent (deeply
// equal), but don't necessarily use the same memory.
//
// Like a literary or musical canon, this ObjectCanon class represents a
// collection of unique canonical items (JavaScript objects), with the
// important property that canon.admit(a) === canon.admit(b) if a and b
// are deeply equal to each other. In terms of the definition above, the
// canon.admit method is the "function or procedure which projects every"
// object "onto that one element, the canonical form."
//
// In the worst case, the canonicalization process may involve looking at
// every property in the provided object tree, so it takes the same order
// of time as deep equality checking. Fortunately, already-canonicalized
// objects are returned immediately from canon.admit, so the presence of
// canonical subtrees tends to speed up canonicalization.
//
// Since consumers of canonical objects can check for deep equality in
// constant time, canonicalizing cache results can massively improve the
// performance of application code that skips re-rendering unchanged
// results, such as "pure" UI components in a framework like React.
//
// Of course, since canonical objects may be shared widely between
// unrelated consumers, it's important to think of them as immutable, even
// though they are not actually frozen with Object.freeze in production,
// due to the extra performance overhead that comes with frozen objects.
//
// Custom scalar objects whose internal class name is neither Array nor
// Object can be included safely in the admitted tree, but they will not
// be replaced with a canonical version (to put it another way, they are
// assumed to be canonical already).
//
// If we ignore custom objects, no detection of cycles or repeated object
// references is currently required by the StoreReader class, since
// GraphQL result objects are JSON-serializable trees (and thus contain
// neither cycles nor repeated subtrees), so we can avoid the complexity
// of keeping track of objects we've already seen during the recursion of
// the admit method.
//
// In the future, we may consider adding additional cases to the switch
// statement to handle other common object types, such as "[object Date]"
// objects, as needed.
var $4a344505b0ae796e$export$c2e7fdd82233f4a4 = /** @class */ function() {
    function ObjectCanon() {
        // Set of all canonical objects this ObjectCanon has admitted, allowing
        // canon.admit to return previously-canonicalized objects immediately.
        this.known = new ((0, $5d0a073f980bb2a3$export$7293b8a0b474028d) ? WeakSet : Set)();
        // Efficient storage/lookup structure for canonical objects.
        this.pool = new (0, $02443dfd16cf74b4$export$73571c50d0f2507e)((0, $5d0a073f980bb2a3$export$772fbc04a0ad4ce9));
        // Make the ObjectCanon assume this value has already been
        // canonicalized.
        this.passes = new WeakMap();
        // Arrays that contain the same elements in a different order can share
        // the same SortedKeysInfo object, to save memory.
        this.keysByJSON = new Map();
        // This has to come last because it depends on keysByJSON.
        this.empty = this.admit({});
    }
    ObjectCanon.prototype.isKnown = function(value) {
        return (0, $3a16601e2096f4cd$export$417207af72fad9c9)(value) && this.known.has(value);
    };
    ObjectCanon.prototype.pass = function(value) {
        if ((0, $3a16601e2096f4cd$export$417207af72fad9c9)(value)) {
            var copy = $4a344505b0ae796e$var$shallowCopy(value);
            this.passes.set(copy, value);
            return copy;
        }
        return value;
    };
    ObjectCanon.prototype.admit = function(value) {
        var _this = this;
        if ((0, $3a16601e2096f4cd$export$417207af72fad9c9)(value)) {
            var original = this.passes.get(value);
            if (original) return original;
            var proto = Object.getPrototypeOf(value);
            switch(proto){
                case Array.prototype:
                    if (this.known.has(value)) return value;
                    var array = value.map(this.admit, this);
                    // Arrays are looked up in the Trie using their recursively
                    // canonicalized elements, and the known version of the array is
                    // preserved as node.array.
                    var node = this.pool.lookupArray(array);
                    if (!node.array) {
                        this.known.add(node.array = array);
                        // Since canonical arrays may be shared widely between
                        // unrelated consumers, it's important to regard them as
                        // immutable, even if they are not frozen in production.
                        if (globalThis.__DEV__ !== false) Object.freeze(array);
                    }
                    return node.array;
                case null:
                case Object.prototype:
                    if (this.known.has(value)) return value;
                    var proto_1 = Object.getPrototypeOf(value);
                    var array_1 = [
                        proto_1
                    ];
                    var keys = this.sortedKeys(value);
                    array_1.push(keys.json);
                    var firstValueIndex_1 = array_1.length;
                    keys.sorted.forEach(function(key) {
                        array_1.push(_this.admit(value[key]));
                    });
                    // Objects are looked up in the Trie by their prototype (which
                    // is *not* recursively canonicalized), followed by a JSON
                    // representation of their (sorted) keys, followed by the
                    // sequence of recursively canonicalized values corresponding to
                    // those keys. To keep the final results unambiguous with other
                    // sequences (such as arrays that just happen to contain [proto,
                    // keys.json, value1, value2, ...]), the known version of the
                    // object is stored as node.object.
                    var node = this.pool.lookupArray(array_1);
                    if (!node.object) {
                        var obj_1 = node.object = Object.create(proto_1);
                        this.known.add(obj_1);
                        keys.sorted.forEach(function(key, i) {
                            obj_1[key] = array_1[firstValueIndex_1 + i];
                        });
                        // Since canonical objects may be shared widely between
                        // unrelated consumers, it's important to regard them as
                        // immutable, even if they are not frozen in production.
                        if (globalThis.__DEV__ !== false) Object.freeze(obj_1);
                    }
                    return node.object;
            }
        }
        return value;
    };
    // It's worthwhile to cache the sorting of arrays of strings, since the
    // same initial unsorted arrays tend to be encountered many times.
    // Fortunately, we can reuse the Trie machinery to look up the sorted
    // arrays in linear time (which is faster than sorting large arrays).
    ObjectCanon.prototype.sortedKeys = function(obj) {
        var keys = Object.keys(obj);
        var node = this.pool.lookupArray(keys);
        if (!node.keys) {
            keys.sort();
            var json = JSON.stringify(keys);
            if (!(node.keys = this.keysByJSON.get(json))) this.keysByJSON.set(json, node.keys = {
                sorted: keys,
                json: json
            });
        }
        return node.keys;
    };
    return ObjectCanon;
}();


function $145a33e3a7865af6$var$execSelectionSetKeyArgs(options) {
    return [
        options.selectionSet,
        options.objectOrReference,
        options.context,
        // We split out this property so we can pass different values
        // independently without modifying options.context itself.
        options.context.canonizeResults
    ];
}
var $145a33e3a7865af6$export$628ef07ba8965f12 = /** @class */ function() {
    function StoreReader(config) {
        var _this = this;
        this.knownResults = new ((0, $5d0a073f980bb2a3$export$772fbc04a0ad4ce9) ? WeakMap : Map)();
        this.config = (0, $2f3cebf1a05c1b38$export$8e16b83750b44988)(config, {
            addTypename: config.addTypename !== false,
            canonizeResults: (0, $3f1d3403edb822de$export$3ac2a95fbd99c479)(config)
        });
        this.canon = config.canon || new (0, $4a344505b0ae796e$export$c2e7fdd82233f4a4)();
        // memoized functions in this class will be "garbage-collected"
        // by recreating the whole `StoreReader` in
        // `InMemoryCache.resetResultsCache`
        // (triggered from `InMemoryCache.gc` with `resetResultCache: true`)
        this.executeSelectionSet = (0, $0fc5e093b69637b4$export$4997ffc0176396a6)(function(options) {
            var _a;
            var canonizeResults = options.context.canonizeResults;
            var peekArgs = $145a33e3a7865af6$var$execSelectionSetKeyArgs(options);
            // Negate this boolean option so we can find out if we've already read
            // this result using the other boolean value.
            peekArgs[3] = !canonizeResults;
            var other = (_a = _this.executeSelectionSet).peek.apply(_a, peekArgs);
            if (other) {
                if (canonizeResults) return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, other), {
                    // If we previously read this result without canonizing it, we can
                    // reuse that result simply by canonizing it now.
                    result: _this.canon.admit(other.result)
                });
                // If we previously read this result with canonization enabled, we can
                // return that canonized result as-is.
                return other;
            }
            (0, $0268d457c22a2684$export$f8068a30967ddc18)(options.context.store, options.enclosingRef.__ref);
            // Finally, if we didn't find any useful previous results, run the real
            // execSelectionSetImpl method with the given options.
            return _this.execSelectionSetImpl(options);
        }, {
            max: this.config.resultCacheMaxSize || (0, $c506be9be1a65610$export$f29926b23b28936b)["inMemoryCache.executeSelectionSet"] || 50000 /* defaultCacheSizes["inMemoryCache.executeSelectionSet"] */ ,
            keyArgs: $145a33e3a7865af6$var$execSelectionSetKeyArgs,
            // Note that the parameters of makeCacheKey are determined by the
            // array returned by keyArgs.
            makeCacheKey: function(selectionSet, parent, context, canonizeResults) {
                if ((0, $0268d457c22a2684$export$488c0743feab3d61)(context.store)) return context.store.makeCacheKey(selectionSet, (0, $9d830e5028848843$export$fa99cac1c0883c47)(parent) ? parent.__ref : parent, context.varString, canonizeResults);
            }
        });
        this.executeSubSelectedArray = (0, $0fc5e093b69637b4$export$4997ffc0176396a6)(function(options) {
            (0, $0268d457c22a2684$export$f8068a30967ddc18)(options.context.store, options.enclosingRef.__ref);
            return _this.execSubSelectedArrayImpl(options);
        }, {
            max: this.config.resultCacheMaxSize || (0, $c506be9be1a65610$export$f29926b23b28936b)["inMemoryCache.executeSubSelectedArray"] || 10000 /* defaultCacheSizes["inMemoryCache.executeSubSelectedArray"] */ ,
            makeCacheKey: function(_a) {
                var field = _a.field, array = _a.array, context = _a.context;
                if ((0, $0268d457c22a2684$export$488c0743feab3d61)(context.store)) return context.store.makeCacheKey(field, array, context.varString);
            }
        });
    }
    StoreReader.prototype.resetCanon = function() {
        this.canon = new (0, $4a344505b0ae796e$export$c2e7fdd82233f4a4)();
    };
    /**
     * Given a store and a query, return as much of the result as possible and
     * identify if any data was missing from the store.
     */ StoreReader.prototype.diffQueryAgainstStore = function(_a) {
        var store = _a.store, query = _a.query, _b = _a.rootId, rootId = _b === void 0 ? "ROOT_QUERY" : _b, variables = _a.variables, _c = _a.returnPartialData, returnPartialData = _c === void 0 ? true : _c, _d = _a.canonizeResults, canonizeResults = _d === void 0 ? this.config.canonizeResults : _d;
        var policies = this.config.cache.policies;
        variables = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, (0, $818d93327cb72c29$export$84c19026e616569e)((0, $818d93327cb72c29$export$d96b2213c1b9d3a9)(query))), variables);
        var rootRef = (0, $9d830e5028848843$export$634ae0e932e9be99)(rootId);
        var execResult = this.executeSelectionSet({
            selectionSet: (0, $818d93327cb72c29$export$f431198736b7f96d)(query).selectionSet,
            objectOrReference: rootRef,
            enclosingRef: rootRef,
            context: (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                store: store,
                query: query,
                policies: policies,
                variables: variables,
                varString: (0, $0bef48da5254bd54$export$88a0ad9b6f961b51)(variables),
                canonizeResults: canonizeResults
            }, (0, $3f1d3403edb822de$export$3a33c00f0ae4a480)(query, this.config.fragments))
        });
        var missing;
        if (execResult.missing) {
            // For backwards compatibility we still report an array of
            // MissingFieldError objects, even though there will only ever be at most
            // one of them, now that all missing field error messages are grouped
            // together in the execResult.missing tree.
            missing = [
                new (0, $5b6ca74647771eb2$export$257c68286583b0f9)($145a33e3a7865af6$var$firstMissing(execResult.missing), execResult.missing, query, variables)
            ];
            if (!returnPartialData) throw missing[0];
        }
        return {
            result: execResult.result,
            complete: !missing,
            missing: missing
        };
    };
    StoreReader.prototype.isFresh = function(result, parent, selectionSet, context) {
        if ((0, $0268d457c22a2684$export$488c0743feab3d61)(context.store) && this.knownResults.get(result) === selectionSet) {
            var latest = this.executeSelectionSet.peek(selectionSet, parent, context, // If result is canonical, then it could only have been previously
            // cached by the canonizing version of executeSelectionSet, so we can
            // avoid checking both possibilities here.
            this.canon.isKnown(result));
            if (latest && result === latest.result) return true;
        }
        return false;
    };
    // Uncached version of executeSelectionSet.
    StoreReader.prototype.execSelectionSetImpl = function(_a) {
        var _this = this;
        var selectionSet = _a.selectionSet, objectOrReference = _a.objectOrReference, enclosingRef = _a.enclosingRef, context = _a.context;
        if ((0, $9d830e5028848843$export$fa99cac1c0883c47)(objectOrReference) && !context.policies.rootTypenamesById[objectOrReference.__ref] && !context.store.has(objectOrReference.__ref)) return {
            result: this.canon.empty,
            missing: "Dangling reference to missing ".concat(objectOrReference.__ref, " object")
        };
        var variables = context.variables, policies = context.policies, store = context.store;
        var typename = store.getFieldValue(objectOrReference, "__typename");
        var objectsToMerge = [];
        var missing;
        var missingMerger = new (0, $0217b27a7999d1ae$export$509e11c221f576c0)();
        if (this.config.addTypename && typeof typename === "string" && !policies.rootIdsByTypename[typename]) // Ensure we always include a default value for the __typename
        // field, if we have one, and this.config.addTypename is true. Note
        // that this field can be overridden by other merged objects.
        objectsToMerge.push({
            __typename: typename
        });
        function handleMissing(result, resultName) {
            var _a;
            if (result.missing) missing = missingMerger.merge(missing, (_a = {}, _a[resultName] = result.missing, _a));
            return result.result;
        }
        var workSet = new Set(selectionSet.selections);
        workSet.forEach(function(selection) {
            var _a, _b;
            // Omit fields with directives @skip(if: <truthy value>) or
            // @include(if: <falsy value>).
            if (!(0, $89c1eec09879e1ca$export$3dc388a5f013b4a5)(selection, variables)) return;
            if ((0, $9d830e5028848843$export$fb56ad75dd311c12)(selection)) {
                var fieldValue = policies.readField({
                    fieldName: selection.name.value,
                    field: selection,
                    variables: context.variables,
                    from: objectOrReference
                }, context);
                var resultName = (0, $9d830e5028848843$export$7d1ad22471852218)(selection);
                if (fieldValue === void 0) {
                    if (!(0, $202b8a19e6086c64$export$43b332f87950a467).added(selection)) missing = missingMerger.merge(missing, (_a = {}, _a[resultName] = "Can't find field '".concat(selection.name.value, "' on ").concat((0, $9d830e5028848843$export$fa99cac1c0883c47)(objectOrReference) ? objectOrReference.__ref + " object" : "object " + JSON.stringify(objectOrReference, null, 2)), _a));
                } else if ((0, $e6aaa0e65613edd7$export$43bee75e5e14138e)(fieldValue)) {
                    if (fieldValue.length > 0) fieldValue = handleMissing(_this.executeSubSelectedArray({
                        field: selection,
                        array: fieldValue,
                        enclosingRef: enclosingRef,
                        context: context
                    }), resultName);
                } else if (!selection.selectionSet) // If the field does not have a selection set, then we handle it
                // as a scalar value. To keep this.canon from canonicalizing
                // this value, we use this.canon.pass to wrap fieldValue in a
                // Pass object that this.canon.admit will later unwrap as-is.
                {
                    if (context.canonizeResults) fieldValue = _this.canon.pass(fieldValue);
                } else if (fieldValue != null) // In this case, because we know the field has a selection set,
                // it must be trying to query a GraphQLObjectType, which is why
                // fieldValue must be != null.
                fieldValue = handleMissing(_this.executeSelectionSet({
                    selectionSet: selection.selectionSet,
                    objectOrReference: fieldValue,
                    enclosingRef: (0, $9d830e5028848843$export$fa99cac1c0883c47)(fieldValue) ? fieldValue : enclosingRef,
                    context: context
                }), resultName);
                if (fieldValue !== void 0) objectsToMerge.push((_b = {}, _b[resultName] = fieldValue, _b));
            } else {
                var fragment = (0, $7f688c9754699513$export$f80bdb85f299186)(selection, context.lookupFragment);
                if (!fragment && selection.kind === (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).FRAGMENT_SPREAD) throw (0, $28d90d877eb1e517$export$3991762405098ea)(9, selection.name.value);
                if (fragment && policies.fragmentMatches(fragment, typename)) fragment.selectionSet.selections.forEach(workSet.add, workSet);
            }
        });
        var result = (0, $0217b27a7999d1ae$export$160070228be94b08)(objectsToMerge);
        var finalResult = {
            result: result,
            missing: missing
        };
        var frozen = context.canonizeResults ? this.canon.admit(finalResult) : (0, $310a6ebe531ba02b$export$7f9c177735b71f18)(finalResult);
        // Store this result with its selection set so that we can quickly
        // recognize it again in the StoreReader#isFresh method.
        if (frozen.result) this.knownResults.set(frozen.result, selectionSet);
        return frozen;
    };
    // Uncached version of executeSubSelectedArray.
    StoreReader.prototype.execSubSelectedArrayImpl = function(_a) {
        var _this = this;
        var field = _a.field, array = _a.array, enclosingRef = _a.enclosingRef, context = _a.context;
        var missing;
        var missingMerger = new (0, $0217b27a7999d1ae$export$509e11c221f576c0)();
        function handleMissing(childResult, i) {
            var _a;
            if (childResult.missing) missing = missingMerger.merge(missing, (_a = {}, _a[i] = childResult.missing, _a));
            return childResult.result;
        }
        if (field.selectionSet) array = array.filter(context.store.canRead);
        array = array.map(function(item, i) {
            // null value in array
            if (item === null) return null;
            // This is a nested array, recurse
            if ((0, $e6aaa0e65613edd7$export$43bee75e5e14138e)(item)) return handleMissing(_this.executeSubSelectedArray({
                field: field,
                array: item,
                enclosingRef: enclosingRef,
                context: context
            }), i);
            // This is an object, run the selection set on it
            if (field.selectionSet) return handleMissing(_this.executeSelectionSet({
                selectionSet: field.selectionSet,
                objectOrReference: item,
                enclosingRef: (0, $9d830e5028848843$export$fa99cac1c0883c47)(item) ? item : enclosingRef,
                context: context
            }), i);
            if (globalThis.__DEV__ !== false) $145a33e3a7865af6$var$assertSelectionSetForIdValue(context.store, field, item);
            return item;
        });
        return {
            result: context.canonizeResults ? this.canon.admit(array) : array,
            missing: missing
        };
    };
    return StoreReader;
}();
function $145a33e3a7865af6$var$firstMissing(tree) {
    try {
        JSON.stringify(tree, function(_, value) {
            if (typeof value === "string") throw value;
            return value;
        });
    } catch (result) {
        return result;
    }
}
function $145a33e3a7865af6$var$assertSelectionSetForIdValue(store, field, fieldValue) {
    if (!field.selectionSet) {
        var workSet_1 = new Set([
            fieldValue
        ]);
        workSet_1.forEach(function(value) {
            if ((0, $3a16601e2096f4cd$export$417207af72fad9c9)(value)) {
                (0, $28d90d877eb1e517$export$f5708dca728d7177)(!(0, $9d830e5028848843$export$fa99cac1c0883c47)(value), 10, (0, $3f1d3403edb822de$export$fdef206c83ff2c09)(store, value), field.name.value);
                Object.values(value).forEach(workSet_1.add, workSet_1);
            }
        });
    }
}

















// Mapping from JSON-encoded KeySpecifier strings to associated information.
var $113f43d0843b9450$var$specifierInfoCache = Object.create(null);
function $113f43d0843b9450$var$lookupSpecifierInfo(spec) {
    // It's safe to encode KeySpecifier arrays with JSON.stringify, since they're
    // just arrays of strings or nested KeySpecifier arrays, and the order of the
    // array elements is important (and suitably preserved by JSON.stringify).
    var cacheKey = JSON.stringify(spec);
    return $113f43d0843b9450$var$specifierInfoCache[cacheKey] || ($113f43d0843b9450$var$specifierInfoCache[cacheKey] = Object.create(null));
}
function $113f43d0843b9450$export$f1953a0407594d2c(specifier) {
    var info = $113f43d0843b9450$var$lookupSpecifierInfo(specifier);
    return info.keyFieldsFn || (info.keyFieldsFn = function(object, context) {
        var extract = function(from, key) {
            return context.readField(key, from);
        };
        var keyObject = context.keyObject = $113f43d0843b9450$export$2db31da99613c21f(specifier, function(schemaKeyPath) {
            var extracted = $113f43d0843b9450$export$e8f64f7a025887d3(context.storeObject, schemaKeyPath, // Using context.readField to extract paths from context.storeObject
            // allows the extraction to see through Reference objects and respect
            // custom read functions.
            extract);
            if (extracted === void 0 && object !== context.storeObject && (0, $3f1d3403edb822de$export$b5a638e9b3fff9f3).call(object, schemaKeyPath[0])) // If context.storeObject fails to provide a value for the requested
            // path, fall back to the raw result object, if it has a top-level key
            // matching the first key in the path (schemaKeyPath[0]). This allows
            // key fields included in the written data to be saved in the cache
            // even if they are not selected explicitly in context.selectionSet.
            // Not being mentioned by context.selectionSet is convenient here,
            // since it means these extra fields cannot be affected by field
            // aliasing, which is why we can use extractKey instead of
            // context.readField for this extraction.
            extracted = $113f43d0843b9450$export$e8f64f7a025887d3(object, schemaKeyPath, $113f43d0843b9450$var$extractKey);
            (0, $28d90d877eb1e517$export$f5708dca728d7177)(extracted !== void 0, 4, schemaKeyPath.join("."), object);
            return extracted;
        });
        return "".concat(context.typename, ":").concat(JSON.stringify(keyObject));
    });
}
function $113f43d0843b9450$export$550737ee0cc371ac(specifier) {
    var info = $113f43d0843b9450$var$lookupSpecifierInfo(specifier);
    return info.keyArgsFn || (info.keyArgsFn = function(args, _a) {
        var field = _a.field, variables = _a.variables, fieldName = _a.fieldName;
        var collected = $113f43d0843b9450$export$2db31da99613c21f(specifier, function(keyPath) {
            var firstKey = keyPath[0];
            var firstChar = firstKey.charAt(0);
            if (firstChar === "@") {
                if (field && (0, $e6aaa0e65613edd7$export$d307f5934e447d0e)(field.directives)) {
                    var directiveName_1 = firstKey.slice(1);
                    // If the directive appears multiple times, only the first
                    // occurrence's arguments will be used. TODO Allow repetition?
                    // TODO Cache this work somehow, a la aliasMap?
                    var d = field.directives.find(function(d) {
                        return d.name.value === directiveName_1;
                    });
                    // Fortunately argumentsObjectFromField works for DirectiveNode!
                    var directiveArgs = d && (0, $9d830e5028848843$export$3f5a60fb6a781b4f)(d, variables);
                    // For directives without arguments (d defined, but directiveArgs ===
                    // null), the presence or absence of the directive still counts as
                    // part of the field key, so we return null in those cases. If no
                    // directive with this name was found for this field (d undefined and
                    // thus directiveArgs undefined), we return undefined, which causes
                    // this value to be omitted from the key object returned by
                    // collectSpecifierPaths.
                    return directiveArgs && $113f43d0843b9450$export$e8f64f7a025887d3(directiveArgs, // If keyPath.length === 1, this code calls extractKeyPath with an
                    // empty path, which works because it uses directiveArgs as the
                    // extracted value.
                    keyPath.slice(1));
                }
                // If the key started with @ but there was no corresponding directive,
                // we want to omit this value from the key object, not fall through to
                // treating @whatever as a normal argument name.
                return;
            }
            if (firstChar === "$") {
                var variableName = firstKey.slice(1);
                if (variables && (0, $3f1d3403edb822de$export$b5a638e9b3fff9f3).call(variables, variableName)) {
                    var varKeyPath = keyPath.slice(0);
                    varKeyPath[0] = variableName;
                    return $113f43d0843b9450$export$e8f64f7a025887d3(variables, varKeyPath);
                }
                // If the key started with $ but there was no corresponding variable, we
                // want to omit this value from the key object, not fall through to
                // treating $whatever as a normal argument name.
                return;
            }
            if (args) return $113f43d0843b9450$export$e8f64f7a025887d3(args, keyPath);
        });
        var suffix = JSON.stringify(collected);
        // If no arguments were passed to this field, and it didn't have any other
        // field key contributions from directives or variables, hide the empty
        // :{} suffix from the field key. However, a field passed no arguments can
        // still end up with a non-empty :{...} suffix if its key configuration
        // refers to directives or variables.
        if (args || suffix !== "{}") fieldName += ":" + suffix;
        return fieldName;
    });
}
function $113f43d0843b9450$export$2db31da99613c21f(specifier, extractor) {
    // For each path specified by specifier, invoke the extractor, and repeatedly
    // merge the results together, with appropriate ancestor context.
    var merger = new (0, $0217b27a7999d1ae$export$509e11c221f576c0)();
    return $113f43d0843b9450$export$eca459f173e85801(specifier).reduce(function(collected, path) {
        var _a;
        var toMerge = extractor(path);
        if (toMerge !== void 0) {
            // This path is not expected to contain array indexes, so the toMerge
            // reconstruction will not contain arrays. TODO Fix this?
            for(var i = path.length - 1; i >= 0; --i)toMerge = (_a = {}, _a[path[i]] = toMerge, _a);
            collected = merger.merge(collected, toMerge);
        }
        return collected;
    }, Object.create(null));
}
function $113f43d0843b9450$export$eca459f173e85801(spec) {
    var info = $113f43d0843b9450$var$lookupSpecifierInfo(spec);
    if (!info.paths) {
        var paths_1 = info.paths = [];
        var currentPath_1 = [];
        spec.forEach(function(s, i) {
            if ((0, $e6aaa0e65613edd7$export$43bee75e5e14138e)(s)) {
                $113f43d0843b9450$export$eca459f173e85801(s).forEach(function(p) {
                    return paths_1.push(currentPath_1.concat(p));
                });
                currentPath_1.length = 0;
            } else {
                currentPath_1.push(s);
                if (!(0, $e6aaa0e65613edd7$export$43bee75e5e14138e)(spec[i + 1])) {
                    paths_1.push(currentPath_1.slice(0));
                    currentPath_1.length = 0;
                }
            }
        });
    }
    return info.paths;
}
function $113f43d0843b9450$var$extractKey(object, key) {
    return object[key];
}
function $113f43d0843b9450$export$e8f64f7a025887d3(object, path, extract) {
    // For each key in path, extract the corresponding child property from obj,
    // flattening arrays if encountered (uncommon for keyFields and keyArgs, but
    // possible). The final result of path.reduce is normalized so unexpected leaf
    // objects have their keys safely sorted. That final result is difficult to
    // type as anything other than any. You're welcome to try to improve the
    // return type, but keep in mind extractKeyPath is not a public function
    // (exported only for testing), so the effort may not be worthwhile unless the
    // limited set of actual callers (see above) pass arguments that TypeScript
    // can statically type. If we know only that path is some array of strings
    // (and not, say, a specific tuple of statically known strings), any (or
    // possibly unknown) is the honest answer.
    extract = extract || $113f43d0843b9450$var$extractKey;
    return $113f43d0843b9450$var$normalize(path.reduce(function reducer(obj, key) {
        return (0, $e6aaa0e65613edd7$export$43bee75e5e14138e)(obj) ? obj.map(function(child) {
            return reducer(child, key);
        }) : obj && extract(obj, key);
    }, object));
}
function $113f43d0843b9450$var$normalize(value) {
    // Usually the extracted value will be a scalar value, since most primary
    // key fields are scalar, but just in case we get an object or an array, we
    // need to do some normalization of the order of (nested) keys.
    if ((0, $3a16601e2096f4cd$export$417207af72fad9c9)(value)) {
        if ((0, $e6aaa0e65613edd7$export$43bee75e5e14138e)(value)) return value.map($113f43d0843b9450$var$normalize);
        return $113f43d0843b9450$export$2db31da99613c21f(Object.keys(value).sort(), function(path) {
            return $113f43d0843b9450$export$e8f64f7a025887d3(value, path);
        });
    }
    return value;
}


function $8557ced3c8197c32$var$argsFromFieldSpecifier(spec) {
    return spec.args !== void 0 ? spec.args : spec.field ? (0, $9d830e5028848843$export$3f5a60fb6a781b4f)(spec.field, spec.variables) : null;
}
var $8557ced3c8197c32$var$nullKeyFieldsFn = function() {
    return void 0;
};
var $8557ced3c8197c32$var$simpleKeyArgsFn = function(_args, context) {
    return context.fieldName;
};
// These merge functions can be selected by specifying merge:true or
// merge:false in a field policy.
var $8557ced3c8197c32$var$mergeTrueFn = function(existing, incoming, _a) {
    var mergeObjects = _a.mergeObjects;
    return mergeObjects(existing, incoming);
};
var $8557ced3c8197c32$var$mergeFalseFn = function(_, incoming) {
    return incoming;
};
var $8557ced3c8197c32$export$e9859ad90648930b = /** @class */ function() {
    function Policies(config) {
        this.config = config;
        this.typePolicies = Object.create(null);
        this.toBeAdded = Object.create(null);
        // Map from subtype names to sets of supertype names. Note that this
        // representation inverts the structure of possibleTypes (whose keys are
        // supertypes and whose values are arrays of subtypes) because it tends
        // to be much more efficient to search upwards than downwards.
        this.supertypeMap = new Map();
        // Any fuzzy subtypes specified by possibleTypes will be converted to
        // RegExp objects and recorded here. Every key of this map can also be
        // found in supertypeMap. In many cases this Map will be empty, which
        // means no fuzzy subtype checking will happen in fragmentMatches.
        this.fuzzySubtypes = new Map();
        this.rootIdsByTypename = Object.create(null);
        this.rootTypenamesById = Object.create(null);
        this.usingPossibleTypes = false;
        this.config = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
            dataIdFromObject: (0, $3f1d3403edb822de$export$bd03c5a9c99d6bce)
        }, config);
        this.cache = this.config.cache;
        this.setRootTypename("Query");
        this.setRootTypename("Mutation");
        this.setRootTypename("Subscription");
        if (config.possibleTypes) this.addPossibleTypes(config.possibleTypes);
        if (config.typePolicies) this.addTypePolicies(config.typePolicies);
    }
    Policies.prototype.identify = function(object, partialContext) {
        var _a;
        var policies = this;
        var typename = partialContext && (partialContext.typename || ((_a = partialContext.storeObject) === null || _a === void 0 ? void 0 : _a.__typename)) || object.__typename;
        // It should be possible to write root Query fields with writeFragment,
        // using { __typename: "Query", ... } as the data, but it does not make
        // sense to allow the same identification behavior for the Mutation and
        // Subscription types, since application code should never be writing
        // directly to (or reading directly from) those root objects.
        if (typename === this.rootTypenamesById.ROOT_QUERY) return [
            "ROOT_QUERY"
        ];
        // Default context.storeObject to object if not otherwise provided.
        var storeObject = partialContext && partialContext.storeObject || object;
        var context = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, partialContext), {
            typename: typename,
            storeObject: storeObject,
            readField: partialContext && partialContext.readField || function() {
                var options = $8557ced3c8197c32$export$1ad7a877581bdf2e(arguments, storeObject);
                return policies.readField(options, {
                    store: policies.cache["data"],
                    variables: options.variables
                });
            }
        });
        var id;
        var policy = typename && this.getTypePolicy(typename);
        var keyFn = policy && policy.keyFn || this.config.dataIdFromObject;
        while(keyFn){
            var specifierOrId = keyFn((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, object), storeObject), context);
            if ((0, $e6aaa0e65613edd7$export$43bee75e5e14138e)(specifierOrId)) keyFn = (0, $113f43d0843b9450$export$f1953a0407594d2c)(specifierOrId);
            else {
                id = specifierOrId;
                break;
            }
        }
        id = id ? String(id) : void 0;
        return context.keyObject ? [
            id,
            context.keyObject
        ] : [
            id
        ];
    };
    Policies.prototype.addTypePolicies = function(typePolicies) {
        var _this = this;
        Object.keys(typePolicies).forEach(function(typename) {
            var _a = typePolicies[typename], queryType = _a.queryType, mutationType = _a.mutationType, subscriptionType = _a.subscriptionType, incoming = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(_a, [
                "queryType",
                "mutationType",
                "subscriptionType"
            ]);
            // Though {query,mutation,subscription}Type configurations are rare,
            // it's important to call setRootTypename as early as possible,
            // since these configurations should apply consistently for the
            // entire lifetime of the cache. Also, since only one __typename can
            // qualify as one of these root types, these three properties cannot
            // be inherited, unlike the rest of the incoming properties. That
            // restriction is convenient, because the purpose of this.toBeAdded
            // is to delay the processing of type/field policies until the first
            // time they're used, allowing policies to be added in any order as
            // long as all relevant policies (including policies for supertypes)
            // have been added by the time a given policy is used for the first
            // time. In other words, since inheritance doesn't matter for these
            // properties, there's also no need to delay their processing using
            // the this.toBeAdded queue.
            if (queryType) _this.setRootTypename("Query", typename);
            if (mutationType) _this.setRootTypename("Mutation", typename);
            if (subscriptionType) _this.setRootTypename("Subscription", typename);
            if ((0, $3f1d3403edb822de$export$b5a638e9b3fff9f3).call(_this.toBeAdded, typename)) _this.toBeAdded[typename].push(incoming);
            else _this.toBeAdded[typename] = [
                incoming
            ];
        });
    };
    Policies.prototype.updateTypePolicy = function(typename, incoming) {
        var _this = this;
        var existing = this.getTypePolicy(typename);
        var keyFields = incoming.keyFields, fields = incoming.fields;
        function setMerge(existing, merge) {
            existing.merge = typeof merge === "function" ? merge : merge === true ? $8557ced3c8197c32$var$mergeTrueFn : merge === false ? $8557ced3c8197c32$var$mergeFalseFn : existing.merge;
        }
        // Type policies can define merge functions, as an alternative to
        // using field policies to merge child objects.
        setMerge(existing, incoming.merge);
        existing.keyFn = // Pass false to disable normalization for this typename.
        keyFields === false ? $8557ced3c8197c32$var$nullKeyFieldsFn : (0, $e6aaa0e65613edd7$export$43bee75e5e14138e)(keyFields) ? (0, $113f43d0843b9450$export$f1953a0407594d2c)(keyFields) : typeof keyFields === "function" ? keyFields : existing.keyFn;
        if (fields) Object.keys(fields).forEach(function(fieldName) {
            var existing = _this.getFieldPolicy(typename, fieldName, true);
            var incoming = fields[fieldName];
            if (typeof incoming === "function") existing.read = incoming;
            else {
                var keyArgs = incoming.keyArgs, read = incoming.read, merge = incoming.merge;
                existing.keyFn = // Pass false to disable argument-based differentiation of
                // field identities.
                keyArgs === false ? $8557ced3c8197c32$var$simpleKeyArgsFn : (0, $e6aaa0e65613edd7$export$43bee75e5e14138e)(keyArgs) ? (0, $113f43d0843b9450$export$550737ee0cc371ac)(keyArgs) : typeof keyArgs === "function" ? keyArgs : existing.keyFn;
                if (typeof read === "function") existing.read = read;
                setMerge(existing, merge);
            }
            if (existing.read && existing.merge) // If we have both a read and a merge function, assume
            // keyArgs:false, because read and merge together can take
            // responsibility for interpreting arguments in and out. This
            // default assumption can always be overridden by specifying
            // keyArgs explicitly in the FieldPolicy.
            existing.keyFn = existing.keyFn || $8557ced3c8197c32$var$simpleKeyArgsFn;
        });
    };
    Policies.prototype.setRootTypename = function(which, typename) {
        if (typename === void 0) typename = which;
        var rootId = "ROOT_" + which.toUpperCase();
        var old = this.rootTypenamesById[rootId];
        if (typename !== old) {
            (0, $28d90d877eb1e517$export$f5708dca728d7177)(!old || old === which, 5, which);
            // First, delete any old __typename associated with this rootId from
            // rootIdsByTypename.
            if (old) delete this.rootIdsByTypename[old];
            // Now make this the only __typename that maps to this rootId.
            this.rootIdsByTypename[typename] = rootId;
            // Finally, update the __typename associated with this rootId.
            this.rootTypenamesById[rootId] = typename;
        }
    };
    Policies.prototype.addPossibleTypes = function(possibleTypes) {
        var _this = this;
        this.usingPossibleTypes = true;
        Object.keys(possibleTypes).forEach(function(supertype) {
            // Make sure all types have an entry in this.supertypeMap, even if
            // their supertype set is empty, so we can return false immediately
            // from policies.fragmentMatches for unknown supertypes.
            _this.getSupertypeSet(supertype, true);
            possibleTypes[supertype].forEach(function(subtype) {
                _this.getSupertypeSet(subtype, true).add(supertype);
                var match = subtype.match((0, $3f1d3403edb822de$export$6ed54d4784f1ce28));
                if (!match || match[0] !== subtype) // TODO Don't interpret just any invalid typename as a RegExp.
                _this.fuzzySubtypes.set(subtype, new RegExp(subtype));
            });
        });
    };
    Policies.prototype.getTypePolicy = function(typename) {
        var _this = this;
        if (!(0, $3f1d3403edb822de$export$b5a638e9b3fff9f3).call(this.typePolicies, typename)) {
            var policy_1 = this.typePolicies[typename] = Object.create(null);
            policy_1.fields = Object.create(null);
            // When the TypePolicy for typename is first accessed, instead of
            // starting with an empty policy object, inherit any properties or
            // fields from the type policies of the supertypes of typename.
            //
            // Any properties or fields defined explicitly within the TypePolicy
            // for typename will take precedence, and if there are multiple
            // supertypes, the properties of policies whose types were added
            // later via addPossibleTypes will take precedence over those of
            // earlier supertypes. TODO Perhaps we should warn about these
            // conflicts in development, and recommend defining the property
            // explicitly in the subtype policy?
            //
            // Field policy inheritance is atomic/shallow: you can't inherit a
            // field policy and then override just its read function, since read
            // and merge functions often need to cooperate, so changing only one
            // of them would be a recipe for inconsistency.
            //
            // Once the TypePolicy for typename has been accessed, its properties can
            // still be updated directly using addTypePolicies, but future changes to
            // inherited supertype policies will not be reflected in this subtype
            // policy, because this code runs at most once per typename.
            var supertypes_1 = this.supertypeMap.get(typename);
            if (!supertypes_1 && this.fuzzySubtypes.size) {
                // To make the inheritance logic work for unknown typename strings that
                // may have fuzzy supertypes, we give this typename an empty supertype
                // set and then populate it with any fuzzy supertypes that match.
                supertypes_1 = this.getSupertypeSet(typename, true);
                // This only works for typenames that are directly matched by a fuzzy
                // supertype. What if there is an intermediate chain of supertypes?
                // While possible, that situation can only be solved effectively by
                // specifying the intermediate relationships via possibleTypes, manually
                // and in a non-fuzzy way.
                this.fuzzySubtypes.forEach(function(regExp, fuzzy) {
                    if (regExp.test(typename)) {
                        // The fuzzy parameter is just the original string version of regExp
                        // (not a valid __typename string), but we can look up the
                        // associated supertype(s) in this.supertypeMap.
                        var fuzzySupertypes = _this.supertypeMap.get(fuzzy);
                        if (fuzzySupertypes) fuzzySupertypes.forEach(function(supertype) {
                            return supertypes_1.add(supertype);
                        });
                    }
                });
            }
            if (supertypes_1 && supertypes_1.size) supertypes_1.forEach(function(supertype) {
                var _a = _this.getTypePolicy(supertype), fields = _a.fields, rest = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(_a, [
                    "fields"
                ]);
                Object.assign(policy_1, rest);
                Object.assign(policy_1.fields, fields);
            });
        }
        var inbox = this.toBeAdded[typename];
        if (inbox && inbox.length) // Merge the pending policies into this.typePolicies, in the order they
        // were originally passed to addTypePolicy.
        inbox.splice(0).forEach(function(policy) {
            _this.updateTypePolicy(typename, policy);
        });
        return this.typePolicies[typename];
    };
    Policies.prototype.getFieldPolicy = function(typename, fieldName, createIfMissing) {
        if (typename) {
            var fieldPolicies = this.getTypePolicy(typename).fields;
            return fieldPolicies[fieldName] || createIfMissing && (fieldPolicies[fieldName] = Object.create(null));
        }
    };
    Policies.prototype.getSupertypeSet = function(subtype, createIfMissing) {
        var supertypeSet = this.supertypeMap.get(subtype);
        if (!supertypeSet && createIfMissing) this.supertypeMap.set(subtype, supertypeSet = new Set());
        return supertypeSet;
    };
    Policies.prototype.fragmentMatches = function(fragment, typename, result, variables) {
        var _this = this;
        if (!fragment.typeCondition) return true;
        // If the fragment has a type condition but the object we're matching
        // against does not have a __typename, the fragment cannot match.
        if (!typename) return false;
        var supertype = fragment.typeCondition.name.value;
        // Common case: fragment type condition and __typename are the same.
        if (typename === supertype) return true;
        if (this.usingPossibleTypes && this.supertypeMap.has(supertype)) {
            var typenameSupertypeSet = this.getSupertypeSet(typename, true);
            var workQueue_1 = [
                typenameSupertypeSet
            ];
            var maybeEnqueue_1 = function(subtype) {
                var supertypeSet = _this.getSupertypeSet(subtype, false);
                if (supertypeSet && supertypeSet.size && workQueue_1.indexOf(supertypeSet) < 0) workQueue_1.push(supertypeSet);
            };
            // We need to check fuzzy subtypes only if we encountered fuzzy
            // subtype strings in addPossibleTypes, and only while writing to
            // the cache, since that's when selectionSetMatchesResult gives a
            // strong signal of fragment matching. The StoreReader class calls
            // policies.fragmentMatches without passing a result object, so
            // needToCheckFuzzySubtypes is always false while reading.
            var needToCheckFuzzySubtypes = !!(result && this.fuzzySubtypes.size);
            var checkingFuzzySubtypes = false;
            // It's important to keep evaluating workQueue.length each time through
            // the loop, because the queue can grow while we're iterating over it.
            for(var i = 0; i < workQueue_1.length; ++i){
                var supertypeSet = workQueue_1[i];
                if (supertypeSet.has(supertype)) {
                    if (!typenameSupertypeSet.has(supertype)) {
                        if (checkingFuzzySubtypes) globalThis.__DEV__ !== false && (0, $28d90d877eb1e517$export$f5708dca728d7177).warn(6, typename, supertype);
                        // Record positive results for faster future lookup.
                        // Unfortunately, we cannot safely cache negative results,
                        // because new possibleTypes data could always be added to the
                        // Policies class.
                        typenameSupertypeSet.add(supertype);
                    }
                    return true;
                }
                supertypeSet.forEach(maybeEnqueue_1);
                if (needToCheckFuzzySubtypes && // Start checking fuzzy subtypes only after exhausting all
                // non-fuzzy subtypes (after the final iteration of the loop).
                i === workQueue_1.length - 1 && // We could wait to compare fragment.selectionSet to result
                // after we verify the supertype, but this check is often less
                // expensive than that search, and we will have to do the
                // comparison anyway whenever we find a potential match.
                (0, $3f1d3403edb822de$export$60bd1cbb09c1a4a2)(fragment.selectionSet, result, variables)) {
                    // We don't always need to check fuzzy subtypes (if no result
                    // was provided, or !this.fuzzySubtypes.size), but, when we do,
                    // we only want to check them once.
                    needToCheckFuzzySubtypes = false;
                    checkingFuzzySubtypes = true;
                    // If we find any fuzzy subtypes that match typename, extend the
                    // workQueue to search through the supertypes of those fuzzy
                    // subtypes. Otherwise the for-loop will terminate and we'll
                    // return false below.
                    this.fuzzySubtypes.forEach(function(regExp, fuzzyString) {
                        var match = typename.match(regExp);
                        if (match && match[0] === typename) maybeEnqueue_1(fuzzyString);
                    });
                }
            }
        }
        return false;
    };
    Policies.prototype.hasKeyArgs = function(typename, fieldName) {
        var policy = this.getFieldPolicy(typename, fieldName, false);
        return !!(policy && policy.keyFn);
    };
    Policies.prototype.getStoreFieldName = function(fieldSpec) {
        var typename = fieldSpec.typename, fieldName = fieldSpec.fieldName;
        var policy = this.getFieldPolicy(typename, fieldName, false);
        var storeFieldName;
        var keyFn = policy && policy.keyFn;
        if (keyFn && typename) {
            var context = {
                typename: typename,
                fieldName: fieldName,
                field: fieldSpec.field || null,
                variables: fieldSpec.variables
            };
            var args = $8557ced3c8197c32$var$argsFromFieldSpecifier(fieldSpec);
            while(keyFn){
                var specifierOrString = keyFn(args, context);
                if ((0, $e6aaa0e65613edd7$export$43bee75e5e14138e)(specifierOrString)) keyFn = (0, $113f43d0843b9450$export$550737ee0cc371ac)(specifierOrString);
                else {
                    // If the custom keyFn returns a falsy value, fall back to
                    // fieldName instead.
                    storeFieldName = specifierOrString || fieldName;
                    break;
                }
            }
        }
        if (storeFieldName === void 0) storeFieldName = fieldSpec.field ? (0, $9d830e5028848843$export$54be8689c65f3b56)(fieldSpec.field, fieldSpec.variables) : (0, $9d830e5028848843$export$3cdb6c178b88cabe)(fieldName, $8557ced3c8197c32$var$argsFromFieldSpecifier(fieldSpec));
        // Returning false from a keyArgs function is like configuring
        // keyArgs: false, but more dynamic.
        if (storeFieldName === false) return fieldName;
        // Make sure custom field names start with the actual field.name.value
        // of the field, so we can always figure out which properties of a
        // StoreObject correspond to which original field names.
        return fieldName === (0, $3f1d3403edb822de$export$37874422037b6029)(storeFieldName) ? storeFieldName : fieldName + ":" + storeFieldName;
    };
    Policies.prototype.readField = function(options, context) {
        var objectOrReference = options.from;
        if (!objectOrReference) return;
        var nameOrField = options.field || options.fieldName;
        if (!nameOrField) return;
        if (options.typename === void 0) {
            var typename = context.store.getFieldValue(objectOrReference, "__typename");
            if (typename) options.typename = typename;
        }
        var storeFieldName = this.getStoreFieldName(options);
        var fieldName = (0, $3f1d3403edb822de$export$37874422037b6029)(storeFieldName);
        var existing = context.store.getFieldValue(objectOrReference, storeFieldName);
        var policy = this.getFieldPolicy(options.typename, fieldName, false);
        var read = policy && policy.read;
        if (read) {
            var readOptions = $8557ced3c8197c32$var$makeFieldFunctionOptions(this, objectOrReference, options, context, context.store.getStorage((0, $9d830e5028848843$export$fa99cac1c0883c47)(objectOrReference) ? objectOrReference.__ref : objectOrReference, storeFieldName));
            // Call read(existing, readOptions) with cacheSlot holding this.cache.
            return (0, $0b37964519c908de$export$ac9723609f5c76c2).withValue(this.cache, read, [
                existing,
                readOptions
            ]);
        }
        return existing;
    };
    Policies.prototype.getReadFunction = function(typename, fieldName) {
        var policy = this.getFieldPolicy(typename, fieldName, false);
        return policy && policy.read;
    };
    Policies.prototype.getMergeFunction = function(parentTypename, fieldName, childTypename) {
        var policy = this.getFieldPolicy(parentTypename, fieldName, false);
        var merge = policy && policy.merge;
        if (!merge && childTypename) {
            policy = this.getTypePolicy(childTypename);
            merge = policy && policy.merge;
        }
        return merge;
    };
    Policies.prototype.runMergeFunction = function(existing, incoming, _a, context, storage) {
        var field = _a.field, typename = _a.typename, merge = _a.merge;
        if (merge === $8557ced3c8197c32$var$mergeTrueFn) // Instead of going to the trouble of creating a full
        // FieldFunctionOptions object and calling mergeTrueFn, we can
        // simply call mergeObjects, as mergeTrueFn would.
        return $8557ced3c8197c32$var$makeMergeObjectsFunction(context.store)(existing, incoming);
        if (merge === $8557ced3c8197c32$var$mergeFalseFn) // Likewise for mergeFalseFn, whose implementation is even simpler.
        return incoming;
        // If cache.writeQuery or cache.writeFragment was called with
        // options.overwrite set to true, we still call merge functions, but
        // the existing data is always undefined, so the merge function will
        // not attempt to combine the incoming data with the existing data.
        if (context.overwrite) existing = void 0;
        return merge(existing, incoming, $8557ced3c8197c32$var$makeFieldFunctionOptions(this, // Unlike options.readField for read functions, we do not fall
        // back to the current object if no foreignObjOrRef is provided,
        // because it's not clear what the current object should be for
        // merge functions: the (possibly undefined) existing object, or
        // the incoming object? If you think your merge function needs
        // to read sibling fields in order to produce a new value for
        // the current field, you might want to rethink your strategy,
        // because that's a recipe for making merge behavior sensitive
        // to the order in which fields are written into the cache.
        // However, readField(name, ref) is useful for merge functions
        // that need to deduplicate child objects and references.
        void 0, {
            typename: typename,
            fieldName: field.name.value,
            field: field,
            variables: context.variables
        }, context, storage || Object.create(null)));
    };
    return Policies;
}();
function $8557ced3c8197c32$var$makeFieldFunctionOptions(policies, objectOrReference, fieldSpec, context, storage) {
    var storeFieldName = policies.getStoreFieldName(fieldSpec);
    var fieldName = (0, $3f1d3403edb822de$export$37874422037b6029)(storeFieldName);
    var variables = fieldSpec.variables || context.variables;
    var _a = context.store, toReference = _a.toReference, canRead = _a.canRead;
    return {
        args: $8557ced3c8197c32$var$argsFromFieldSpecifier(fieldSpec),
        field: fieldSpec.field || null,
        fieldName: fieldName,
        storeFieldName: storeFieldName,
        variables: variables,
        isReference: (0, $9d830e5028848843$export$fa99cac1c0883c47),
        toReference: toReference,
        storage: storage,
        cache: policies.cache,
        canRead: canRead,
        readField: function() {
            return policies.readField($8557ced3c8197c32$export$1ad7a877581bdf2e(arguments, objectOrReference, variables), context);
        },
        mergeObjects: $8557ced3c8197c32$var$makeMergeObjectsFunction(context.store)
    };
}
function $8557ced3c8197c32$export$1ad7a877581bdf2e(readFieldArgs, objectOrReference, variables) {
    var fieldNameOrOptions = readFieldArgs[0], from = readFieldArgs[1], argc = readFieldArgs.length;
    var options;
    if (typeof fieldNameOrOptions === "string") options = {
        fieldName: fieldNameOrOptions,
        // Default to objectOrReference only when no second argument was
        // passed for the from parameter, not when undefined is explicitly
        // passed as the second argument.
        from: argc > 1 ? from : objectOrReference
    };
    else {
        options = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, fieldNameOrOptions);
        // Default to objectOrReference only when fieldNameOrOptions.from is
        // actually omitted, rather than just undefined.
        if (!(0, $3f1d3403edb822de$export$b5a638e9b3fff9f3).call(options, "from")) options.from = objectOrReference;
    }
    if (globalThis.__DEV__ !== false && options.from === void 0) globalThis.__DEV__ !== false && (0, $28d90d877eb1e517$export$f5708dca728d7177).warn(7, (0, $29a424226342d3ac$export$f341b4883239463f)(Array.from(readFieldArgs)));
    if (void 0 === options.variables) options.variables = variables;
    return options;
}
function $8557ced3c8197c32$var$makeMergeObjectsFunction(store) {
    return function mergeObjects(existing, incoming) {
        if ((0, $e6aaa0e65613edd7$export$43bee75e5e14138e)(existing) || (0, $e6aaa0e65613edd7$export$43bee75e5e14138e)(incoming)) throw (0, $28d90d877eb1e517$export$3991762405098ea)(8);
        // These dynamic checks are necessary because the parameters of a
        // custom merge function can easily have the any type, so the type
        // system cannot always enforce the StoreObject | Reference parameter
        // types of options.mergeObjects.
        if ((0, $3a16601e2096f4cd$export$417207af72fad9c9)(existing) && (0, $3a16601e2096f4cd$export$417207af72fad9c9)(incoming)) {
            var eType = store.getFieldValue(existing, "__typename");
            var iType = store.getFieldValue(incoming, "__typename");
            var typesDiffer = eType && iType && eType !== iType;
            if (typesDiffer) return incoming;
            if ((0, $9d830e5028848843$export$fa99cac1c0883c47)(existing) && (0, $3f1d3403edb822de$export$4f39afca21bd938e)(incoming)) {
                // Update the normalized EntityStore for the entity identified by
                // existing.__ref, preferring/overwriting any fields contributed by the
                // newer incoming StoreObject.
                store.merge(existing.__ref, incoming);
                return existing;
            }
            if ((0, $3f1d3403edb822de$export$4f39afca21bd938e)(existing) && (0, $9d830e5028848843$export$fa99cac1c0883c47)(incoming)) {
                // Update the normalized EntityStore for the entity identified by
                // incoming.__ref, taking fields from the older existing object only if
                // those fields are not already present in the newer StoreObject
                // identified by incoming.__ref.
                store.merge(existing, incoming.__ref);
                return incoming;
            }
            if ((0, $3f1d3403edb822de$export$4f39afca21bd938e)(existing) && (0, $3f1d3403edb822de$export$4f39afca21bd938e)(incoming)) return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, existing), incoming);
        }
        return incoming;
    };
}


// Since there are only four possible combinations of context.clientOnly and
// context.deferred values, we should need at most four "flavors" of any given
// WriteContext. To avoid creating multiple copies of the same context, we cache
// the contexts in the context.flavors Map (shared by all flavors) according to
// their clientOnly and deferred values (always in that order).
function $e28f51741d388e97$var$getContextFlavor(context, clientOnly, deferred) {
    var key = "".concat(clientOnly).concat(deferred);
    var flavored = context.flavors.get(key);
    if (!flavored) context.flavors.set(key, flavored = context.clientOnly === clientOnly && context.deferred === deferred ? context : (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, context), {
        clientOnly: clientOnly,
        deferred: deferred
    }));
    return flavored;
}
var $e28f51741d388e97$export$eb8361c5d132fb8f = /** @class */ function() {
    function StoreWriter(cache, reader, fragments) {
        this.cache = cache;
        this.reader = reader;
        this.fragments = fragments;
    }
    StoreWriter.prototype.writeToStore = function(store, _a) {
        var _this = this;
        var query = _a.query, result = _a.result, dataId = _a.dataId, variables = _a.variables, overwrite = _a.overwrite;
        var operationDefinition = (0, $818d93327cb72c29$export$7a5b1fa979d2c158)(query);
        var merger = (0, $3f1d3403edb822de$export$b874a818f7a2fa6d)();
        variables = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, (0, $818d93327cb72c29$export$84c19026e616569e)(operationDefinition)), variables);
        var context = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
            store: store,
            written: Object.create(null),
            merge: function(existing, incoming) {
                return merger.merge(existing, incoming);
            },
            variables: variables,
            varString: (0, $0bef48da5254bd54$export$88a0ad9b6f961b51)(variables)
        }, (0, $3f1d3403edb822de$export$3a33c00f0ae4a480)(query, this.fragments)), {
            overwrite: !!overwrite,
            incomingById: new Map(),
            clientOnly: false,
            deferred: false,
            flavors: new Map()
        });
        var ref = this.processSelectionSet({
            result: result || Object.create(null),
            dataId: dataId,
            selectionSet: operationDefinition.selectionSet,
            mergeTree: {
                map: new Map()
            },
            context: context
        });
        if (!(0, $9d830e5028848843$export$fa99cac1c0883c47)(ref)) throw (0, $28d90d877eb1e517$export$3991762405098ea)(11, result);
        // So far, the store has not been modified, so now it's time to process
        // context.incomingById and merge those incoming fields into context.store.
        context.incomingById.forEach(function(_a, dataId) {
            var storeObject = _a.storeObject, mergeTree = _a.mergeTree, fieldNodeSet = _a.fieldNodeSet;
            var entityRef = (0, $9d830e5028848843$export$634ae0e932e9be99)(dataId);
            if (mergeTree && mergeTree.map.size) {
                var applied = _this.applyMerges(mergeTree, entityRef, storeObject, context);
                if ((0, $9d830e5028848843$export$fa99cac1c0883c47)(applied)) // Assume References returned by applyMerges have already been merged
                // into the store. See makeMergeObjectsFunction in policies.ts for an
                // example of how this can happen.
                return;
                // Otherwise, applyMerges returned a StoreObject, whose fields we should
                // merge into the store (see store.merge statement below).
                storeObject = applied;
            }
            if (globalThis.__DEV__ !== false && !context.overwrite) {
                var fieldsWithSelectionSets_1 = Object.create(null);
                fieldNodeSet.forEach(function(field) {
                    if (field.selectionSet) fieldsWithSelectionSets_1[field.name.value] = true;
                });
                var hasSelectionSet_1 = function(storeFieldName) {
                    return fieldsWithSelectionSets_1[(0, $3f1d3403edb822de$export$37874422037b6029)(storeFieldName)] === true;
                };
                var hasMergeFunction_1 = function(storeFieldName) {
                    var childTree = mergeTree && mergeTree.map.get(storeFieldName);
                    return Boolean(childTree && childTree.info && childTree.info.merge);
                };
                Object.keys(storeObject).forEach(function(storeFieldName) {
                    // If a merge function was defined for this field, trust that it
                    // did the right thing about (not) clobbering data. If the field
                    // has no selection set, it's a scalar field, so it doesn't need
                    // a merge function (even if it's an object, like JSON data).
                    if (hasSelectionSet_1(storeFieldName) && !hasMergeFunction_1(storeFieldName)) $e28f51741d388e97$var$warnAboutDataLoss(entityRef, storeObject, storeFieldName, context.store);
                });
            }
            store.merge(dataId, storeObject);
        });
        // Any IDs written explicitly to the cache will be retained as
        // reachable root IDs for garbage collection purposes. Although this
        // logic includes root IDs like ROOT_QUERY and ROOT_MUTATION, their
        // retainment counts are effectively ignored because cache.gc() always
        // includes them in its root ID set.
        store.retain(ref.__ref);
        return ref;
    };
    StoreWriter.prototype.processSelectionSet = function(_a) {
        var _this = this;
        var dataId = _a.dataId, result = _a.result, selectionSet = _a.selectionSet, context = _a.context, // This object allows processSelectionSet to report useful information
        // to its callers without explicitly returning that information.
        mergeTree = _a.mergeTree;
        var policies = this.cache.policies;
        // This variable will be repeatedly updated using context.merge to
        // accumulate all fields that need to be written into the store.
        var incoming = Object.create(null);
        // If typename was not passed in, infer it. Note that typename is
        // always passed in for tricky-to-infer cases such as "Query" for
        // ROOT_QUERY.
        var typename = dataId && policies.rootTypenamesById[dataId] || (0, $9d830e5028848843$export$cf7bf7e4f289cc26)(result, selectionSet, context.fragmentMap) || dataId && context.store.get(dataId, "__typename");
        if ("string" === typeof typename) incoming.__typename = typename;
        // This readField function will be passed as context.readField in the
        // KeyFieldsContext object created within policies.identify (called below).
        // In addition to reading from the existing context.store (thanks to the
        // policies.readField(options, context) line at the very bottom), this
        // version of readField can read from Reference objects that are currently
        // pending in context.incomingById, which is important whenever keyFields
        // need to be extracted from a child object that processSelectionSet has
        // turned into a Reference.
        var readField = function() {
            var options = (0, $8557ced3c8197c32$export$1ad7a877581bdf2e)(arguments, incoming, context.variables);
            if ((0, $9d830e5028848843$export$fa99cac1c0883c47)(options.from)) {
                var info = context.incomingById.get(options.from.__ref);
                if (info) {
                    var result_1 = policies.readField((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, options), {
                        from: info.storeObject
                    }), context);
                    if (result_1 !== void 0) return result_1;
                }
            }
            return policies.readField(options, context);
        };
        var fieldNodeSet = new Set();
        this.flattenFields(selectionSet, result, // This WriteContext will be the default context value for fields returned
        // by the flattenFields method, but some fields may be assigned a modified
        // context, depending on the presence of @client and other directives.
        context, typename).forEach(function(context, field) {
            var _a;
            var resultFieldKey = (0, $9d830e5028848843$export$7d1ad22471852218)(field);
            var value = result[resultFieldKey];
            fieldNodeSet.add(field);
            if (value !== void 0) {
                var storeFieldName = policies.getStoreFieldName({
                    typename: typename,
                    fieldName: field.name.value,
                    field: field,
                    variables: context.variables
                });
                var childTree = $e28f51741d388e97$var$getChildMergeTree(mergeTree, storeFieldName);
                var incomingValue = _this.processFieldValue(value, field, // Reset context.clientOnly and context.deferred to their default
                // values before processing nested selection sets.
                field.selectionSet ? $e28f51741d388e97$var$getContextFlavor(context, false, false) : context, childTree);
                // To determine if this field holds a child object with a merge function
                // defined in its type policy (see PR #7070), we need to figure out the
                // child object's __typename.
                var childTypename = void 0;
                // The field's value can be an object that has a __typename only if the
                // field has a selection set. Otherwise incomingValue is scalar.
                if (field.selectionSet && ((0, $9d830e5028848843$export$fa99cac1c0883c47)(incomingValue) || (0, $3f1d3403edb822de$export$4f39afca21bd938e)(incomingValue))) childTypename = readField("__typename", incomingValue);
                var merge = policies.getMergeFunction(typename, field.name.value, childTypename);
                if (merge) childTree.info = {
                    // TODO Check compatibility against any existing childTree.field?
                    field: field,
                    typename: typename,
                    merge: merge
                };
                else $e28f51741d388e97$var$maybeRecycleChildMergeTree(mergeTree, storeFieldName);
                incoming = context.merge(incoming, (_a = {}, _a[storeFieldName] = incomingValue, _a));
            } else if (globalThis.__DEV__ !== false && !context.clientOnly && !context.deferred && !(0, $202b8a19e6086c64$export$43b332f87950a467).added(field) && // If the field has a read function, it may be a synthetic field or
            // provide a default value, so its absence from the written data should
            // not be cause for alarm.
            !policies.getReadFunction(typename, field.name.value)) globalThis.__DEV__ !== false && (0, $28d90d877eb1e517$export$f5708dca728d7177).error(12, (0, $9d830e5028848843$export$7d1ad22471852218)(field), result);
        });
        // Identify the result object, even if dataId was already provided,
        // since we always need keyObject below.
        try {
            var _b = policies.identify(result, {
                typename: typename,
                selectionSet: selectionSet,
                fragmentMap: context.fragmentMap,
                storeObject: incoming,
                readField: readField
            }), id = _b[0], keyObject = _b[1];
            // If dataId was not provided, fall back to the id just generated by
            // policies.identify.
            dataId = dataId || id;
            // Write any key fields that were used during identification, even if
            // they were not mentioned in the original query.
            if (keyObject) // TODO Reverse the order of the arguments?
            incoming = context.merge(incoming, keyObject);
        } catch (e) {
            // If dataId was provided, tolerate failure of policies.identify.
            if (!dataId) throw e;
        }
        if ("string" === typeof dataId) {
            var dataRef = (0, $9d830e5028848843$export$634ae0e932e9be99)(dataId);
            // Avoid processing the same entity object using the same selection
            // set more than once. We use an array instead of a Set since most
            // entity IDs will be written using only one selection set, so the
            // size of this array is likely to be very small, meaning indexOf is
            // likely to be faster than Set.prototype.has.
            var sets = context.written[dataId] || (context.written[dataId] = []);
            if (sets.indexOf(selectionSet) >= 0) return dataRef;
            sets.push(selectionSet);
            // If we're about to write a result object into the store, but we
            // happen to know that the exact same (===) result object would be
            // returned if we were to reread the result with the same inputs,
            // then we can skip the rest of the processSelectionSet work for
            // this object, and immediately return a Reference to it.
            if (this.reader && this.reader.isFresh(result, dataRef, selectionSet, context)) return dataRef;
            var previous_1 = context.incomingById.get(dataId);
            if (previous_1) {
                previous_1.storeObject = context.merge(previous_1.storeObject, incoming);
                previous_1.mergeTree = $e28f51741d388e97$var$mergeMergeTrees(previous_1.mergeTree, mergeTree);
                fieldNodeSet.forEach(function(field) {
                    return previous_1.fieldNodeSet.add(field);
                });
            } else context.incomingById.set(dataId, {
                storeObject: incoming,
                // Save a reference to mergeTree only if it is not empty, because
                // empty MergeTrees may be recycled by maybeRecycleChildMergeTree and
                // reused for entirely different parts of the result tree.
                mergeTree: $e28f51741d388e97$var$mergeTreeIsEmpty(mergeTree) ? void 0 : mergeTree,
                fieldNodeSet: fieldNodeSet
            });
            return dataRef;
        }
        return incoming;
    };
    StoreWriter.prototype.processFieldValue = function(value, field, context, mergeTree) {
        var _this = this;
        if (!field.selectionSet || value === null) // In development, we need to clone scalar values so that they can be
        // safely frozen with maybeDeepFreeze in readFromStore.ts. In production,
        // it's cheaper to store the scalar values directly in the cache.
        return globalThis.__DEV__ !== false ? (0, $e398dba65b0b4cec$export$629a2bd3f5a49ecc)(value) : value;
        if ((0, $e6aaa0e65613edd7$export$43bee75e5e14138e)(value)) return value.map(function(item, i) {
            var value = _this.processFieldValue(item, field, context, $e28f51741d388e97$var$getChildMergeTree(mergeTree, i));
            $e28f51741d388e97$var$maybeRecycleChildMergeTree(mergeTree, i);
            return value;
        });
        return this.processSelectionSet({
            result: value,
            selectionSet: field.selectionSet,
            context: context,
            mergeTree: mergeTree
        });
    };
    // Implements https://spec.graphql.org/draft/#sec-Field-Collection, but with
    // some additions for tracking @client and @defer directives.
    StoreWriter.prototype.flattenFields = function(selectionSet, result, context, typename) {
        if (typename === void 0) typename = (0, $9d830e5028848843$export$cf7bf7e4f289cc26)(result, selectionSet, context.fragmentMap);
        var fieldMap = new Map();
        var policies = this.cache.policies;
        var limitingTrie = new (0, $02443dfd16cf74b4$export$73571c50d0f2507e)(false); // No need for WeakMap, since limitingTrie does not escape.
        (function flatten(selectionSet, inheritedContext) {
            var visitedNode = limitingTrie.lookup(selectionSet, // Because we take inheritedClientOnly and inheritedDeferred into
            // consideration here (in addition to selectionSet), it's possible for
            // the same selection set to be flattened more than once, if it appears
            // in the query with different @client and/or @directive configurations.
            inheritedContext.clientOnly, inheritedContext.deferred);
            if (visitedNode.visited) return;
            visitedNode.visited = true;
            selectionSet.selections.forEach(function(selection) {
                if (!(0, $89c1eec09879e1ca$export$3dc388a5f013b4a5)(selection, context.variables)) return;
                var clientOnly = inheritedContext.clientOnly, deferred = inheritedContext.deferred;
                if (// Since the presence of @client or @defer on this field can only
                // cause clientOnly or deferred to become true, we can skip the
                // forEach loop if both clientOnly and deferred are already true.
                !(clientOnly && deferred) && (0, $e6aaa0e65613edd7$export$d307f5934e447d0e)(selection.directives)) selection.directives.forEach(function(dir) {
                    var name = dir.name.value;
                    if (name === "client") clientOnly = true;
                    if (name === "defer") {
                        var args = (0, $9d830e5028848843$export$3f5a60fb6a781b4f)(dir, context.variables);
                        // The @defer directive takes an optional args.if boolean
                        // argument, similar to @include(if: boolean). Note that
                        // @defer(if: false) does not make context.deferred false, but
                        // instead behaves as if there was no @defer directive.
                        if (!args || args.if !== false) deferred = true;
                    // TODO In the future, we may want to record args.label using
                    // context.deferred, if a label is specified.
                    }
                });
                if ((0, $9d830e5028848843$export$fb56ad75dd311c12)(selection)) {
                    var existing = fieldMap.get(selection);
                    if (existing) {
                        // If this field has been visited along another recursive path
                        // before, the final context should have clientOnly or deferred set
                        // to true only if *all* paths have the directive (hence the &&).
                        clientOnly = clientOnly && existing.clientOnly;
                        deferred = deferred && existing.deferred;
                    }
                    fieldMap.set(selection, $e28f51741d388e97$var$getContextFlavor(context, clientOnly, deferred));
                } else {
                    var fragment = (0, $7f688c9754699513$export$f80bdb85f299186)(selection, context.lookupFragment);
                    if (!fragment && selection.kind === (0, $b7b8db97a7d116fe$export$a84bdc57c5122798).FRAGMENT_SPREAD) throw (0, $28d90d877eb1e517$export$3991762405098ea)(13, selection.name.value);
                    if (fragment && policies.fragmentMatches(fragment, typename, result, context.variables)) flatten(fragment.selectionSet, $e28f51741d388e97$var$getContextFlavor(context, clientOnly, deferred));
                }
            });
        })(selectionSet, context);
        return fieldMap;
    };
    StoreWriter.prototype.applyMerges = function(mergeTree, existing, incoming, context, getStorageArgs) {
        var _a;
        var _this = this;
        if (mergeTree.map.size && !(0, $9d830e5028848843$export$fa99cac1c0883c47)(incoming)) {
            var e_1 = // Items in the same position in different arrays are not
            // necessarily related to each other, so when incoming is an array
            // we process its elements as if there was no existing data.
            !(0, $e6aaa0e65613edd7$export$43bee75e5e14138e)(incoming) && // Likewise, existing must be either a Reference or a StoreObject
            // in order for its fields to be safe to merge with the fields of
            // the incoming object.
            ((0, $9d830e5028848843$export$fa99cac1c0883c47)(existing) || (0, $3f1d3403edb822de$export$4f39afca21bd938e)(existing)) ? existing : void 0;
            // This narrowing is implied by mergeTree.map.size > 0 and
            // !isReference(incoming), though TypeScript understandably cannot
            // hope to infer this type.
            var i_1 = incoming;
            // The options.storage objects provided to read and merge functions
            // are derived from the identity of the parent object plus a
            // sequence of storeFieldName strings/numbers identifying the nested
            // field name path of each field value to be merged.
            if (e_1 && !getStorageArgs) getStorageArgs = [
                (0, $9d830e5028848843$export$fa99cac1c0883c47)(e_1) ? e_1.__ref : e_1
            ];
            // It's possible that applying merge functions to this subtree will
            // not change the incoming data, so this variable tracks the fields
            // that did change, so we can create a new incoming object when (and
            // only when) at least one incoming field has changed. We use a Map
            // to preserve the type of numeric keys.
            var changedFields_1;
            var getValue_1 = function(from, name) {
                return (0, $e6aaa0e65613edd7$export$43bee75e5e14138e)(from) ? typeof name === "number" ? from[name] : void 0 : context.store.getFieldValue(from, String(name));
            };
            mergeTree.map.forEach(function(childTree, storeFieldName) {
                var eVal = getValue_1(e_1, storeFieldName);
                var iVal = getValue_1(i_1, storeFieldName);
                // If we have no incoming data, leave any existing data untouched.
                if (void 0 === iVal) return;
                if (getStorageArgs) getStorageArgs.push(storeFieldName);
                var aVal = _this.applyMerges(childTree, eVal, iVal, context, getStorageArgs);
                if (aVal !== iVal) {
                    changedFields_1 = changedFields_1 || new Map();
                    changedFields_1.set(storeFieldName, aVal);
                }
                if (getStorageArgs) (0, $28d90d877eb1e517$export$f5708dca728d7177)(getStorageArgs.pop() === storeFieldName);
            });
            if (changedFields_1) {
                // Shallow clone i so we can add changed fields to it.
                incoming = (0, $e6aaa0e65613edd7$export$43bee75e5e14138e)(i_1) ? i_1.slice(0) : (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, i_1);
                changedFields_1.forEach(function(value, name) {
                    incoming[name] = value;
                });
            }
        }
        if (mergeTree.info) return this.cache.policies.runMergeFunction(existing, incoming, mergeTree.info, context, getStorageArgs && (_a = context.store).getStorage.apply(_a, getStorageArgs));
        return incoming;
    };
    return StoreWriter;
}();
var $e28f51741d388e97$var$emptyMergeTreePool = [];
function $e28f51741d388e97$var$getChildMergeTree(_a, name) {
    var map = _a.map;
    if (!map.has(name)) map.set(name, $e28f51741d388e97$var$emptyMergeTreePool.pop() || {
        map: new Map()
    });
    return map.get(name);
}
function $e28f51741d388e97$var$mergeMergeTrees(left, right) {
    if (left === right || !right || $e28f51741d388e97$var$mergeTreeIsEmpty(right)) return left;
    if (!left || $e28f51741d388e97$var$mergeTreeIsEmpty(left)) return right;
    var info = left.info && right.info ? (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, left.info), right.info) : left.info || right.info;
    var needToMergeMaps = left.map.size && right.map.size;
    var map = needToMergeMaps ? new Map() : left.map.size ? left.map : right.map;
    var merged = {
        info: info,
        map: map
    };
    if (needToMergeMaps) {
        var remainingRightKeys_1 = new Set(right.map.keys());
        left.map.forEach(function(leftTree, key) {
            merged.map.set(key, $e28f51741d388e97$var$mergeMergeTrees(leftTree, right.map.get(key)));
            remainingRightKeys_1.delete(key);
        });
        remainingRightKeys_1.forEach(function(key) {
            merged.map.set(key, $e28f51741d388e97$var$mergeMergeTrees(right.map.get(key), left.map.get(key)));
        });
    }
    return merged;
}
function $e28f51741d388e97$var$mergeTreeIsEmpty(tree) {
    return !tree || !(tree.info || tree.map.size);
}
function $e28f51741d388e97$var$maybeRecycleChildMergeTree(_a, name) {
    var map = _a.map;
    var childTree = map.get(name);
    if (childTree && $e28f51741d388e97$var$mergeTreeIsEmpty(childTree)) {
        $e28f51741d388e97$var$emptyMergeTreePool.push(childTree);
        map.delete(name);
    }
}
var $e28f51741d388e97$var$warnings = new Set();
// Note that this function is unused in production, and thus should be
// pruned by any well-configured minifier.
function $e28f51741d388e97$var$warnAboutDataLoss(existingRef, incomingObj, storeFieldName, store) {
    var getChild = function(objOrRef) {
        var child = store.getFieldValue(objOrRef, storeFieldName);
        return typeof child === "object" && child;
    };
    var existing = getChild(existingRef);
    if (!existing) return;
    var incoming = getChild(incomingObj);
    if (!incoming) return;
    // It's always safe to replace a reference, since it refers to data
    // safely stored elsewhere.
    if ((0, $9d830e5028848843$export$fa99cac1c0883c47)(existing)) return;
    // If the values are structurally equivalent, we do not need to worry
    // about incoming replacing existing.
    if ((0, $a2b6f433e732b502$export$411ce8e5a71e3069)(existing, incoming)) return;
    // If we're replacing every key of the existing object, then the
    // existing data would be overwritten even if the objects were
    // normalized, so warning would not be helpful here.
    if (Object.keys(existing).every(function(key) {
        return store.getFieldValue(incoming, key) !== void 0;
    })) return;
    var parentType = store.getFieldValue(existingRef, "__typename") || store.getFieldValue(incomingObj, "__typename");
    var fieldName = (0, $3f1d3403edb822de$export$37874422037b6029)(storeFieldName);
    var typeDotName = "".concat(parentType, ".").concat(fieldName);
    // Avoid warning more than once for the same type and field name.
    if ($e28f51741d388e97$var$warnings.has(typeDotName)) return;
    $e28f51741d388e97$var$warnings.add(typeDotName);
    var childTypenames = [];
    // Arrays do not have __typename fields, and always need a custom merge
    // function, even if their elements are normalized entities.
    if (!(0, $e6aaa0e65613edd7$export$43bee75e5e14138e)(existing) && !(0, $e6aaa0e65613edd7$export$43bee75e5e14138e)(incoming)) [
        existing,
        incoming
    ].forEach(function(child) {
        var typename = store.getFieldValue(child, "__typename");
        if (typeof typename === "string" && !childTypenames.includes(typename)) childTypenames.push(typename);
    });
    globalThis.__DEV__ !== false && (0, $28d90d877eb1e517$export$f5708dca728d7177).warn(14, fieldName, parentType, childTypenames.length ? "either ensure all objects of type " + childTypenames.join(" and ") + " have an ID or a custom merge function, or " : "", typeDotName, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, existing), (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, incoming));
}







var $49c8996098641f51$export$467265324939f47f = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(InMemoryCache, _super);
    function InMemoryCache(config) {
        if (config === void 0) config = {};
        var _this = _super.call(this) || this;
        _this.watches = new Set();
        _this.addTypenameTransform = new (0, $2e04132f91cc06f1$export$f887060e48e5dc1b)((0, $202b8a19e6086c64$export$43b332f87950a467));
        // Override the default value, since InMemoryCache result objects are frozen
        // in development and expected to remain logically immutable in production.
        _this.assumeImmutableResults = true;
        _this.makeVar = (0, $0b37964519c908de$export$5345c8ac69b4a9db);
        _this.txCount = 0;
        _this.config = (0, $3f1d3403edb822de$export$fa542f9ee3f7f4e2)(config);
        _this.addTypename = !!_this.config.addTypename;
        _this.policies = new (0, $8557ced3c8197c32$export$e9859ad90648930b)({
            cache: _this,
            dataIdFromObject: _this.config.dataIdFromObject,
            possibleTypes: _this.config.possibleTypes,
            typePolicies: _this.config.typePolicies
        });
        _this.init();
        return _this;
    }
    InMemoryCache.prototype.init = function() {
        // Passing { resultCaching: false } in the InMemoryCache constructor options
        // will completely disable dependency tracking, which will improve memory
        // usage but worsen the performance of repeated reads.
        var rootStore = this.data = new (0, $0268d457c22a2684$export$cb507f57054c7321).Root({
            policies: this.policies,
            resultCaching: this.config.resultCaching
        });
        // When no optimistic writes are currently active, cache.optimisticData ===
        // cache.data, so there are no additional layers on top of the actual data.
        // When an optimistic update happens, this.optimisticData will become a
        // linked list of EntityStore Layer objects that terminates with the
        // original this.data cache object.
        this.optimisticData = rootStore.stump;
        this.resetResultCache();
    };
    InMemoryCache.prototype.resetResultCache = function(resetResultIdentities) {
        var _this = this;
        var previousReader = this.storeReader;
        var fragments = this.config.fragments;
        // The StoreWriter is mostly stateless and so doesn't really need to be
        // reset, but it does need to have its writer.storeReader reference updated,
        // so it's simpler to update this.storeWriter as well.
        this.storeWriter = new (0, $e28f51741d388e97$export$eb8361c5d132fb8f)(this, this.storeReader = new (0, $145a33e3a7865af6$export$628ef07ba8965f12)({
            cache: this,
            addTypename: this.addTypename,
            resultCacheMaxSize: this.config.resultCacheMaxSize,
            canonizeResults: (0, $3f1d3403edb822de$export$3ac2a95fbd99c479)(this.config),
            canon: resetResultIdentities ? void 0 : previousReader && previousReader.canon,
            fragments: fragments
        }), fragments);
        this.maybeBroadcastWatch = (0, $0fc5e093b69637b4$export$4997ffc0176396a6)(function(c, options) {
            return _this.broadcastWatch(c, options);
        }, {
            max: this.config.resultCacheMaxSize || (0, $c506be9be1a65610$export$f29926b23b28936b)["inMemoryCache.maybeBroadcastWatch"] || 5000 /* defaultCacheSizes["inMemoryCache.maybeBroadcastWatch"] */ ,
            makeCacheKey: function(c) {
                // Return a cache key (thus enabling result caching) only if we're
                // currently using a data store that can track cache dependencies.
                var store = c.optimistic ? _this.optimisticData : _this.data;
                if ((0, $0268d457c22a2684$export$488c0743feab3d61)(store)) {
                    var optimistic = c.optimistic, id = c.id, variables = c.variables;
                    return store.makeCacheKey(c.query, // Different watches can have the same query, optimistic
                    // status, rootId, and variables, but if their callbacks are
                    // different, the (identical) result needs to be delivered to
                    // each distinct callback. The easiest way to achieve that
                    // separation is to include c.callback in the cache key for
                    // maybeBroadcastWatch calls. See issue #5733.
                    c.callback, (0, $0bef48da5254bd54$export$88a0ad9b6f961b51)({
                        optimistic: optimistic,
                        id: id,
                        variables: variables
                    }));
                }
            }
        });
        // Since we have thrown away all the cached functions that depend on the
        // CacheGroup dependencies maintained by EntityStore, we should also reset
        // all CacheGroup dependency information.
        new Set([
            this.data.group,
            this.optimisticData.group
        ]).forEach(function(group) {
            return group.resetCaching();
        });
    };
    InMemoryCache.prototype.restore = function(data) {
        this.init();
        // Since calling this.init() discards/replaces the entire StoreReader, along
        // with the result caches it maintains, this.data.replace(data) won't have
        // to bother deleting the old data.
        if (data) this.data.replace(data);
        return this;
    };
    InMemoryCache.prototype.extract = function(optimistic) {
        if (optimistic === void 0) optimistic = false;
        return (optimistic ? this.optimisticData : this.data).extract();
    };
    InMemoryCache.prototype.read = function(options) {
        var // Since read returns data or null, without any additional metadata
        // about whether/where there might have been missing fields, the
        // default behavior cannot be returnPartialData = true (like it is
        // for the diff method), since defaulting to true would violate the
        // integrity of the T in the return type. However, partial data may
        // be useful in some cases, so returnPartialData:true may be
        // specified explicitly.
        _a = options.returnPartialData, // Since read returns data or null, without any additional metadata
        // about whether/where there might have been missing fields, the
        // default behavior cannot be returnPartialData = true (like it is
        // for the diff method), since defaulting to true would violate the
        // integrity of the T in the return type. However, partial data may
        // be useful in some cases, so returnPartialData:true may be
        // specified explicitly.
        returnPartialData = _a === void 0 ? false : _a;
        try {
            return this.storeReader.diffQueryAgainstStore((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, options), {
                store: options.optimistic ? this.optimisticData : this.data,
                config: this.config,
                returnPartialData: returnPartialData
            })).result || null;
        } catch (e) {
            if (e instanceof (0, $5b6ca74647771eb2$export$257c68286583b0f9)) // Swallow MissingFieldError and return null, so callers do not need to
            // worry about catching "normal" exceptions resulting from incomplete
            // cache data. Unexpected errors will be re-thrown. If you need more
            // information about which fields were missing, use cache.diff instead,
            // and examine diffResult.missing.
            return null;
            throw e;
        }
    };
    InMemoryCache.prototype.write = function(options) {
        try {
            ++this.txCount;
            return this.storeWriter.writeToStore(this.data, options);
        } finally{
            if (!--this.txCount && options.broadcast !== false) this.broadcastWatches();
        }
    };
    InMemoryCache.prototype.modify = function(options) {
        if ((0, $3f1d3403edb822de$export$b5a638e9b3fff9f3).call(options, "id") && !options.id) // To my knowledge, TypeScript does not currently provide a way to
        // enforce that an optional property?:type must *not* be undefined
        // when present. That ability would be useful here, because we want
        // options.id to default to ROOT_QUERY only when no options.id was
        // provided. If the caller attempts to pass options.id with a
        // falsy/undefined value (perhaps because cache.identify failed), we
        // should not assume the goal was to modify the ROOT_QUERY object.
        // We could throw, but it seems natural to return false to indicate
        // that nothing was modified.
        return false;
        var store = options.optimistic // Defaults to false.
         ? this.optimisticData : this.data;
        try {
            ++this.txCount;
            return store.modify(options.id || "ROOT_QUERY", options.fields);
        } finally{
            if (!--this.txCount && options.broadcast !== false) this.broadcastWatches();
        }
    };
    InMemoryCache.prototype.diff = function(options) {
        return this.storeReader.diffQueryAgainstStore((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, options), {
            store: options.optimistic ? this.optimisticData : this.data,
            rootId: options.id || "ROOT_QUERY",
            config: this.config
        }));
    };
    InMemoryCache.prototype.watch = function(watch) {
        var _this = this;
        if (!this.watches.size) // In case we previously called forgetCache(this) because
        // this.watches became empty (see below), reattach this cache to any
        // reactive variables on which it previously depended. It might seem
        // paradoxical that we're able to recall something we supposedly
        // forgot, but the point of calling forgetCache(this) is to silence
        // useless broadcasts while this.watches is empty, and to allow the
        // cache to be garbage collected. If, however, we manage to call
        // recallCache(this) here, this cache object must not have been
        // garbage collected yet, and should resume receiving updates from
        // reactive variables, now that it has a watcher to notify.
        (0, $0b37964519c908de$export$f342bdd61b3e9412)(this);
        this.watches.add(watch);
        if (watch.immediate) this.maybeBroadcastWatch(watch);
        return function() {
            // Once we remove the last watch from this.watches, cache.broadcastWatches
            // no longer does anything, so we preemptively tell the reactive variable
            // system to exclude this cache from future broadcasts.
            if (_this.watches.delete(watch) && !_this.watches.size) (0, $0b37964519c908de$export$cbe12faed7725318)(_this);
            // Remove this watch from the LRU cache managed by the
            // maybeBroadcastWatch OptimisticWrapperFunction, to prevent memory
            // leaks involving the closure of watch.callback.
            _this.maybeBroadcastWatch.forget(watch);
        };
    };
    InMemoryCache.prototype.gc = function(options) {
        var _a;
        (0, $0bef48da5254bd54$export$88a0ad9b6f961b51).reset();
        (0, $722312be2835bfdf$export$c2d084dc44961371).reset();
        this.addTypenameTransform.resetCache();
        (_a = this.config.fragments) === null || _a === void 0 || _a.resetCaches();
        var ids = this.optimisticData.gc();
        if (options && !this.txCount) {
            if (options.resetResultCache) this.resetResultCache(options.resetResultIdentities);
            else if (options.resetResultIdentities) this.storeReader.resetCanon();
        }
        return ids;
    };
    // Call this method to ensure the given root ID remains in the cache after
    // garbage collection, along with its transitive child entities. Note that
    // the cache automatically retains all directly written entities. By default,
    // the retainment persists after optimistic updates are removed. Pass true
    // for the optimistic argument if you would prefer for the retainment to be
    // discarded when the top-most optimistic layer is removed. Returns the
    // resulting (non-negative) retainment count.
    InMemoryCache.prototype.retain = function(rootId, optimistic) {
        return (optimistic ? this.optimisticData : this.data).retain(rootId);
    };
    // Call this method to undo the effect of the retain method, above. Once the
    // retainment count falls to zero, the given ID will no longer be preserved
    // during garbage collection, though it may still be preserved by other safe
    // entities that refer to it. Returns the resulting (non-negative) retainment
    // count, in case that's useful.
    InMemoryCache.prototype.release = function(rootId, optimistic) {
        return (optimistic ? this.optimisticData : this.data).release(rootId);
    };
    // Returns the canonical ID for a given StoreObject, obeying typePolicies
    // and keyFields (and dataIdFromObject, if you still use that). At minimum,
    // the object must contain a __typename and any primary key fields required
    // to identify entities of that type. If you pass a query result object, be
    // sure that none of the primary key fields have been renamed by aliasing.
    // If you pass a Reference object, its __ref ID string will be returned.
    InMemoryCache.prototype.identify = function(object) {
        if ((0, $9d830e5028848843$export$fa99cac1c0883c47)(object)) return object.__ref;
        try {
            return this.policies.identify(object)[0];
        } catch (e) {
            globalThis.__DEV__ !== false && (0, $28d90d877eb1e517$export$f5708dca728d7177).warn(e);
        }
    };
    InMemoryCache.prototype.evict = function(options) {
        if (!options.id) {
            if ((0, $3f1d3403edb822de$export$b5a638e9b3fff9f3).call(options, "id")) // See comment in modify method about why we return false when
            // options.id exists but is falsy/undefined.
            return false;
            options = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, options), {
                id: "ROOT_QUERY"
            });
        }
        try {
            // It's unlikely that the eviction will end up invoking any other
            // cache update operations while it's running, but {in,de}crementing
            // this.txCount still seems like a good idea, for uniformity with
            // the other update methods.
            ++this.txCount;
            // Pass this.data as a limit on the depth of the eviction, so evictions
            // during optimistic updates (when this.data is temporarily set equal to
            // this.optimisticData) do not escape their optimistic Layer.
            return this.optimisticData.evict(options, this.data);
        } finally{
            if (!--this.txCount && options.broadcast !== false) this.broadcastWatches();
        }
    };
    InMemoryCache.prototype.reset = function(options) {
        var _this = this;
        this.init();
        (0, $0bef48da5254bd54$export$88a0ad9b6f961b51).reset();
        if (options && options.discardWatches) {
            // Similar to what happens in the unsubscribe function returned by
            // cache.watch, applied to all current watches.
            this.watches.forEach(function(watch) {
                return _this.maybeBroadcastWatch.forget(watch);
            });
            this.watches.clear();
            (0, $0b37964519c908de$export$cbe12faed7725318)(this);
        } else // Calling this.init() above unblocks all maybeBroadcastWatch caching, so
        // this.broadcastWatches() triggers a broadcast to every current watcher
        // (letting them know their data is now missing). This default behavior is
        // convenient because it means the watches do not have to be manually
        // reestablished after resetting the cache. To prevent this broadcast and
        // cancel all watches, pass true for options.discardWatches.
        this.broadcastWatches();
        return Promise.resolve();
    };
    InMemoryCache.prototype.removeOptimistic = function(idToRemove) {
        var newOptimisticData = this.optimisticData.removeLayer(idToRemove);
        if (newOptimisticData !== this.optimisticData) {
            this.optimisticData = newOptimisticData;
            this.broadcastWatches();
        }
    };
    InMemoryCache.prototype.batch = function(options) {
        var _this = this;
        var update = options.update, _a = options.optimistic, optimistic = _a === void 0 ? true : _a, removeOptimistic = options.removeOptimistic, onWatchUpdated = options.onWatchUpdated;
        var updateResult;
        var perform = function(layer) {
            var _a = _this, data = _a.data, optimisticData = _a.optimisticData;
            ++_this.txCount;
            if (layer) _this.data = _this.optimisticData = layer;
            try {
                return updateResult = update(_this);
            } finally{
                --_this.txCount;
                _this.data = data;
                _this.optimisticData = optimisticData;
            }
        };
        var alreadyDirty = new Set();
        if (onWatchUpdated && !this.txCount) // If an options.onWatchUpdated callback is provided, we want to call it
        // with only the Cache.WatchOptions objects affected by options.update,
        // but there might be dirty watchers already waiting to be broadcast that
        // have nothing to do with the update. To prevent including those watchers
        // in the post-update broadcast, we perform this initial broadcast to
        // collect the dirty watchers, so we can re-dirty them later, after the
        // post-update broadcast, allowing them to receive their pending
        // broadcasts the next time broadcastWatches is called, just as they would
        // if we never called cache.batch.
        this.broadcastWatches((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, options), {
            onWatchUpdated: function(watch) {
                alreadyDirty.add(watch);
                return false;
            }
        }));
        if (typeof optimistic === "string") // Note that there can be multiple layers with the same optimistic ID.
        // When removeOptimistic(id) is called for that id, all matching layers
        // will be removed, and the remaining layers will be reapplied.
        this.optimisticData = this.optimisticData.addLayer(optimistic, perform);
        else if (optimistic === false) // Ensure both this.data and this.optimisticData refer to the root
        // (non-optimistic) layer of the cache during the update. Note that
        // this.data could be a Layer if we are currently executing an optimistic
        // update function, but otherwise will always be an EntityStore.Root
        // instance.
        perform(this.data);
        else // Otherwise, leave this.data and this.optimisticData unchanged and run
        // the update with broadcast batching.
        perform();
        if (typeof removeOptimistic === "string") this.optimisticData = this.optimisticData.removeLayer(removeOptimistic);
        // Note: if this.txCount > 0, then alreadyDirty.size === 0, so this code
        // takes the else branch and calls this.broadcastWatches(options), which
        // does nothing when this.txCount > 0.
        if (onWatchUpdated && alreadyDirty.size) {
            this.broadcastWatches((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, options), {
                onWatchUpdated: function(watch, diff) {
                    var result = onWatchUpdated.call(this, watch, diff);
                    if (result !== false) // Since onWatchUpdated did not return false, this diff is
                    // about to be broadcast to watch.callback, so we don't need
                    // to re-dirty it with the other alreadyDirty watches below.
                    alreadyDirty.delete(watch);
                    return result;
                }
            }));
            // Silently re-dirty any watches that were already dirty before the update
            // was performed, and were not broadcast just now.
            if (alreadyDirty.size) alreadyDirty.forEach(function(watch) {
                return _this.maybeBroadcastWatch.dirty(watch);
            });
        } else // If alreadyDirty is empty or we don't have an onWatchUpdated
        // function, we don't need to go to the trouble of wrapping
        // options.onWatchUpdated.
        this.broadcastWatches(options);
        return updateResult;
    };
    InMemoryCache.prototype.performTransaction = function(update, optimisticId) {
        return this.batch({
            update: update,
            optimistic: optimisticId || optimisticId !== null
        });
    };
    InMemoryCache.prototype.transformDocument = function(document) {
        return this.addTypenameToDocument(this.addFragmentsToDocument(document));
    };
    InMemoryCache.prototype.broadcastWatches = function(options) {
        var _this = this;
        if (!this.txCount) this.watches.forEach(function(c) {
            return _this.maybeBroadcastWatch(c, options);
        });
    };
    InMemoryCache.prototype.addFragmentsToDocument = function(document) {
        var fragments = this.config.fragments;
        return fragments ? fragments.transform(document) : document;
    };
    InMemoryCache.prototype.addTypenameToDocument = function(document) {
        if (this.addTypename) return this.addTypenameTransform.transformDocument(document);
        return document;
    };
    // This method is wrapped by maybeBroadcastWatch, which is called by
    // broadcastWatches, so that we compute and broadcast results only when
    // the data that would be broadcast might have changed. It would be
    // simpler to check for changes after recomputing a result but before
    // broadcasting it, but this wrapping approach allows us to skip both
    // the recomputation and the broadcast, in most cases.
    InMemoryCache.prototype.broadcastWatch = function(c, options) {
        var lastDiff = c.lastDiff;
        // Both WatchOptions and DiffOptions extend ReadOptions, and DiffOptions
        // currently requires no additional properties, so we can use c (a
        // WatchOptions object) as DiffOptions, without having to allocate a new
        // object, and without having to enumerate the relevant properties (query,
        // variables, etc.) explicitly. There will be some additional properties
        // (lastDiff, callback, etc.), but cache.diff ignores them.
        var diff = this.diff(c);
        if (options) {
            if (c.optimistic && typeof options.optimistic === "string") diff.fromOptimisticTransaction = true;
            if (options.onWatchUpdated && options.onWatchUpdated.call(this, c, diff, lastDiff) === false) // Returning false from the onWatchUpdated callback will prevent
            // calling c.callback(diff) for this watcher.
            return;
        }
        if (!lastDiff || !(0, $a2b6f433e732b502$export$411ce8e5a71e3069)(lastDiff.result, diff.result)) c.callback(c.lastDiff = diff, lastDiff);
    };
    return InMemoryCache;
}((0, $3b55b3aff583fbaf$export$5fc74f25506aa9c));
if (globalThis.__DEV__ !== false) $49c8996098641f51$export$467265324939f47f.prototype.getMemoryInternals = (0, $1da01699264b6e1e$export$e95a5a2210e62466);







var $4653928bf51922ba$var$didWarnUncachedGetSnapshot = false;
// Prevent webpack from complaining about our feature detection of the
// useSyncExternalStore property of the React namespace, which is expected not
// to exist when using React 17 and earlier, and that's fine.
var $4653928bf51922ba$var$uSESKey = "useSyncExternalStore";
var $4653928bf51922ba$var$realHook = $69607e38bd2400f2$exports[$4653928bf51922ba$var$uSESKey];
var $4653928bf51922ba$export$306c0aa65ff9ec16 = $4653928bf51922ba$var$realHook || function(subscribe, getSnapshot, getServerSnapshot) {
    // Read the current snapshot from the store on every render. Again, this
    // breaks the rules of React, and only works here because of specific
    // implementation details, most importantly that updates are
    // always synchronous.
    var value = getSnapshot();
    if (// DEVIATION: Using __DEV__
    globalThis.__DEV__ !== false && !$4653928bf51922ba$var$didWarnUncachedGetSnapshot && // DEVIATION: Not using Object.is because we know our snapshots will never
    // be exotic primitive values like NaN, which is !== itself.
    value !== getSnapshot()) {
        $4653928bf51922ba$var$didWarnUncachedGetSnapshot = true;
        // DEVIATION: Using invariant.error instead of console.error directly.
        globalThis.__DEV__ !== false && (0, $28d90d877eb1e517$export$f5708dca728d7177).error(60);
    }
    // Because updates are synchronous, we don't queue them. Instead we force a
    // re-render whenever the subscribed state changes by updating an some
    // arbitrary useState hook. Then, during render, we call getSnapshot to read
    // the current value.
    //
    // Because we don't actually use the state returned by the useState hook, we
    // can save a bit of memory by storing other stuff in that slot.
    //
    // To implement the early bailout, we need to track some things on a mutable
    // object. Usually, we would put that in a useRef hook, but we can stash it in
    // our useState hook instead.
    //
    // To force a re-render, we call forceUpdate({inst}). That works because the
    // new object always fails an equality check.
    var _a = $69607e38bd2400f2$exports.useState({
        inst: {
            value: value,
            getSnapshot: getSnapshot
        }
    }), inst = _a[0].inst, forceUpdate = _a[1];
    // Track the latest getSnapshot function with a ref. This needs to be updated
    // in the layout phase so we can access it during the tearing check that
    // happens on subscribe.
    if (0, $5d0a073f980bb2a3$export$4001f6cd4a62405b) // DEVIATION: We avoid calling useLayoutEffect when !canUseLayoutEffect,
    // which may seem like a conditional hook, but this code ends up behaving
    // unconditionally (one way or the other) because canUseLayoutEffect is
    // constant.
    $69607e38bd2400f2$exports.useLayoutEffect(function() {
        Object.assign(inst, {
            value: value,
            getSnapshot: getSnapshot
        });
        // Whenever getSnapshot or subscribe changes, we need to check in the
        // commit phase if there was an interleaved mutation. In concurrent mode
        // this can happen all the time, but even in synchronous mode, an earlier
        // effect may have mutated the store.
        if ($4653928bf51922ba$var$checkIfSnapshotChanged(inst)) // Force a re-render.
        forceUpdate({
            inst: inst
        });
    // React Hook React.useLayoutEffect has a missing dependency: 'inst'. Either include it or remove the dependency array.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        subscribe,
        value,
        getSnapshot
    ]);
    else Object.assign(inst, {
        value: value,
        getSnapshot: getSnapshot
    });
    $69607e38bd2400f2$exports.useEffect(function() {
        // Check for changes right before subscribing. Subsequent changes will be
        // detected in the subscription handler.
        if ($4653928bf51922ba$var$checkIfSnapshotChanged(inst)) // Force a re-render.
        forceUpdate({
            inst: inst
        });
        // Subscribe to the store and return a clean-up function.
        return subscribe(function handleStoreChange() {
            // TODO: Because there is no cross-renderer API for batching updates, it's
            // up to the consumer of this library to wrap their subscription event
            // with unstable_batchedUpdates. Should we try to detect when this isn't
            // the case and print a warning in development?
            // The store changed. Check if the snapshot changed since the last time we
            // read from the store.
            if ($4653928bf51922ba$var$checkIfSnapshotChanged(inst)) // Force a re-render.
            forceUpdate({
                inst: inst
            });
        });
    // React Hook React.useEffect has a missing dependency: 'inst'. Either include it or remove the dependency array.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        subscribe
    ]);
    return value;
};
function $4653928bf51922ba$var$checkIfSnapshotChanged(_a) {
    var value = _a.value, getSnapshot = _a.getSnapshot;
    try {
        return value !== getSnapshot();
    } catch (_b) {
        return true;
    }
}










var $0feb9bd81dd1c3b8$export$d1d99cf900472499;
(function(DocumentType) {
    DocumentType[DocumentType["Query"] = 0] = "Query";
    DocumentType[DocumentType["Mutation"] = 1] = "Mutation";
    DocumentType[DocumentType["Subscription"] = 2] = "Subscription";
})($0feb9bd81dd1c3b8$export$d1d99cf900472499 || ($0feb9bd81dd1c3b8$export$d1d99cf900472499 = {}));
var $0feb9bd81dd1c3b8$var$cache;
function $0feb9bd81dd1c3b8$export$5db520940cf00715(type) {
    var name;
    switch(type){
        case $0feb9bd81dd1c3b8$export$d1d99cf900472499.Query:
            name = "Query";
            break;
        case $0feb9bd81dd1c3b8$export$d1d99cf900472499.Mutation:
            name = "Mutation";
            break;
        case $0feb9bd81dd1c3b8$export$d1d99cf900472499.Subscription:
            name = "Subscription";
            break;
    }
    return name;
}
function $0feb9bd81dd1c3b8$export$8f49e4af10703ce3(document) {
    if (!$0feb9bd81dd1c3b8$var$cache) $0feb9bd81dd1c3b8$var$cache = new (0, $b3ac5bdec858bda0$export$8dbad6f439bb2331)((0, $c506be9be1a65610$export$f29926b23b28936b).parser || 1000 /* defaultCacheSizes.parser */ );
    var cached = $0feb9bd81dd1c3b8$var$cache.get(document);
    if (cached) return cached;
    var variables, type, name;
    (0, $28d90d877eb1e517$export$f5708dca728d7177)(!!document && !!document.kind, 62, document);
    var fragments = [];
    var queries = [];
    var mutations = [];
    var subscriptions = [];
    for(var _i = 0, _a = document.definitions; _i < _a.length; _i++){
        var x = _a[_i];
        if (x.kind === "FragmentDefinition") {
            fragments.push(x);
            continue;
        }
        if (x.kind === "OperationDefinition") switch(x.operation){
            case "query":
                queries.push(x);
                break;
            case "mutation":
                mutations.push(x);
                break;
            case "subscription":
                subscriptions.push(x);
                break;
        }
    }
    (0, $28d90d877eb1e517$export$f5708dca728d7177)(!fragments.length || queries.length || mutations.length || subscriptions.length, 63);
    (0, $28d90d877eb1e517$export$f5708dca728d7177)(queries.length + mutations.length + subscriptions.length <= 1, 64, document, queries.length, subscriptions.length, mutations.length);
    type = queries.length ? $0feb9bd81dd1c3b8$export$d1d99cf900472499.Query : $0feb9bd81dd1c3b8$export$d1d99cf900472499.Mutation;
    if (!queries.length && !mutations.length) type = $0feb9bd81dd1c3b8$export$d1d99cf900472499.Subscription;
    var definitions = queries.length ? queries : mutations.length ? mutations : subscriptions;
    (0, $28d90d877eb1e517$export$f5708dca728d7177)(definitions.length === 1, 65, document, definitions.length);
    var definition = definitions[0];
    variables = definition.variableDefinitions || [];
    if (definition.name && definition.name.kind === "Name") name = definition.name.value;
    else name = "data"; // fallback to using data if no name
    var payload = {
        name: name,
        type: type,
        variables: variables
    };
    $0feb9bd81dd1c3b8$var$cache.set(document, payload);
    return payload;
}
$0feb9bd81dd1c3b8$export$8f49e4af10703ce3.resetCache = function() {
    $0feb9bd81dd1c3b8$var$cache = undefined;
};
if (globalThis.__DEV__ !== false) (0, $1da01699264b6e1e$export$a8fcd406d9e37621)("parser", function() {
    return $0feb9bd81dd1c3b8$var$cache ? $0feb9bd81dd1c3b8$var$cache.size : 0;
});
function $0feb9bd81dd1c3b8$export$6dfb8732f737404c(document, type) {
    var operation = $0feb9bd81dd1c3b8$export$8f49e4af10703ce3(document);
    var requiredOperationName = $0feb9bd81dd1c3b8$export$5db520940cf00715(type);
    var usedOperationName = $0feb9bd81dd1c3b8$export$5db520940cf00715(operation.type);
    (0, $28d90d877eb1e517$export$f5708dca728d7177)(operation.type === type, 66, requiredOperationName, requiredOperationName, usedOperationName);
}





function $0868e36814f766fc$export$eb9a56e7a29e494(override) {
    var context = $69607e38bd2400f2$exports.useContext((0, $14505e8b7f660318$export$a47505d961ee3a1)());
    var client = override || context.client;
    (0, $28d90d877eb1e517$export$f5708dca728d7177)(!!client, 50);
    return client;
}


var $966349df9047bbed$var$wrapperSymbol = Symbol.for("apollo.hook.wrappers");
function $966349df9047bbed$export$7f12579c79e39619(hookName, useHook, clientOrObsQuery) {
    var queryManager = clientOrObsQuery["queryManager"];
    var wrappers = queryManager && queryManager[$966349df9047bbed$var$wrapperSymbol];
    var wrapper = wrappers && wrappers[hookName];
    return wrapper ? wrapper(useHook) : useHook;
}


var $0ad8e3d9f4959055$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $0ad8e3d9f4959055$var$noop() {}
var $0ad8e3d9f4959055$export$163a98bed2d8d099 = Symbol();
function $0ad8e3d9f4959055$export$dd0a697e1782aedd(query, options) {
    if (options === void 0) options = Object.create(null);
    return (0, $966349df9047bbed$export$7f12579c79e39619)("useQuery", $0ad8e3d9f4959055$var$_useQuery, (0, $0868e36814f766fc$export$eb9a56e7a29e494)(options && options.client))(query, options);
}
function $0ad8e3d9f4959055$var$_useQuery(query, options) {
    var _a = $0ad8e3d9f4959055$export$5c23c59ff7f655a8(query, options), result = _a.result, obsQueryFields = _a.obsQueryFields;
    return $69607e38bd2400f2$exports.useMemo(function() {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, result), obsQueryFields);
    }, [
        result,
        obsQueryFields
    ]);
}
function $0ad8e3d9f4959055$var$useInternalState(client, query, options, renderPromises, makeWatchQueryOptions) {
    function createInternalState(previous) {
        var _a;
        (0, $0feb9bd81dd1c3b8$export$6dfb8732f737404c)(query, (0, $0feb9bd81dd1c3b8$export$d1d99cf900472499).Query);
        var internalState = {
            client: client,
            query: query,
            observable: // See if there is an existing observable that was used to fetch the same
            // data and if so, use it instead since it will contain the proper queryId
            // to fetch the result set. This is used during SSR.
            renderPromises && renderPromises.getSSRObservable(makeWatchQueryOptions()) || client.watchQuery($0ad8e3d9f4959055$export$2167b7db3cd527f2(void 0, client, options, makeWatchQueryOptions())),
            resultData: {
                // Reuse previousData from previous InternalState (if any) to provide
                // continuity of previousData even if/when the query or client changes.
                previousData: (_a = previous === null || previous === void 0 ? void 0 : previous.resultData.current) === null || _a === void 0 ? void 0 : _a.data
            }
        };
        return internalState;
    }
    var _a = $69607e38bd2400f2$exports.useState(createInternalState), internalState = _a[0], updateInternalState = _a[1];
    /**
     * Used by `useLazyQuery` when a new query is executed.
     * We keep this logic here since it needs to update things in unsafe
     * ways and here we at least can keep track of that in a single place.
     */ function onQueryExecuted(watchQueryOptions) {
        var _a;
        var _b;
        // this needs to be set to prevent an immediate `resubscribe` in the
        // next rerender of the `useQuery` internals
        Object.assign(internalState.observable, (_a = {}, _a[$0ad8e3d9f4959055$export$163a98bed2d8d099] = watchQueryOptions, _a));
        var resultData = internalState.resultData;
        updateInternalState((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, internalState), {
            // might be a different query
            query: watchQueryOptions.query,
            resultData: Object.assign(resultData, {
                // We need to modify the previous `resultData` object as we rely on the
                // object reference in other places
                previousData: ((_b = resultData.current) === null || _b === void 0 ? void 0 : _b.data) || resultData.previousData,
                current: undefined
            })
        }));
    }
    if (client !== internalState.client || query !== internalState.query) {
        // If the client or query have changed, we need to create a new InternalState.
        // This will trigger a re-render with the new state, but it will also continue
        // to run the current render function to completion.
        // Since we sometimes trigger some side-effects in the render function, we
        // re-assign `state` to the new state to ensure that those side-effects are
        // triggered with the new state.
        var newInternalState = createInternalState(internalState);
        updateInternalState(newInternalState);
        return [
            newInternalState,
            onQueryExecuted
        ];
    }
    return [
        internalState,
        onQueryExecuted
    ];
}
function $0ad8e3d9f4959055$export$5c23c59ff7f655a8(query, options) {
    var client = (0, $0868e36814f766fc$export$eb9a56e7a29e494)(options.client);
    var renderPromises = $69607e38bd2400f2$exports.useContext((0, $14505e8b7f660318$export$a47505d961ee3a1)()).renderPromises;
    var isSyncSSR = !!renderPromises;
    var disableNetworkFetches = client.disableNetworkFetches;
    var ssrAllowed = options.ssr !== false && !options.skip;
    var partialRefetch = options.partialRefetch;
    var makeWatchQueryOptions = $0ad8e3d9f4959055$export$63539d93836ebf9c(client, query, options, isSyncSSR);
    var _a = $0ad8e3d9f4959055$var$useInternalState(client, query, options, renderPromises, makeWatchQueryOptions), _b = _a[0], observable = _b.observable, resultData = _b.resultData, onQueryExecuted = _a[1];
    var watchQueryOptions = makeWatchQueryOptions(observable);
    $0ad8e3d9f4959055$var$useResubscribeIfNecessary(resultData, observable, client, options, watchQueryOptions);
    var obsQueryFields = $69607e38bd2400f2$exports.useMemo(function() {
        return $0ad8e3d9f4959055$var$bindObservableMethods(observable);
    }, [
        observable
    ]);
    $0ad8e3d9f4959055$var$useRegisterSSRObservable(observable, renderPromises, ssrAllowed);
    var result = $0ad8e3d9f4959055$var$useObservableSubscriptionResult(resultData, observable, client, options, watchQueryOptions, disableNetworkFetches, partialRefetch, isSyncSSR, {
        onCompleted: options.onCompleted || $0ad8e3d9f4959055$var$noop,
        onError: options.onError || $0ad8e3d9f4959055$var$noop
    });
    return {
        result: result,
        obsQueryFields: obsQueryFields,
        observable: observable,
        resultData: resultData,
        client: client,
        onQueryExecuted: onQueryExecuted
    };
}
function $0ad8e3d9f4959055$var$useObservableSubscriptionResult(resultData, observable, client, options, watchQueryOptions, disableNetworkFetches, partialRefetch, isSyncSSR, callbacks) {
    var callbackRef = $69607e38bd2400f2$exports.useRef(callbacks);
    $69607e38bd2400f2$exports.useEffect(function() {
        // Make sure state.onCompleted and state.onError always reflect the latest
        // options.onCompleted and options.onError callbacks provided to useQuery,
        // since those functions are often recreated every time useQuery is called.
        // Like the forceUpdate method, the versions of these methods inherited from
        // InternalState.prototype are empty no-ops, but we can override them on the
        // base state object (without modifying the prototype).
        callbackRef.current = callbacks;
    });
    var resultOverride = (isSyncSSR || disableNetworkFetches) && options.ssr === false && !options.skip ? // If SSR has been explicitly disabled, and this function has been called
    // on the server side, return the default loading state.
    $0ad8e3d9f4959055$var$ssrDisabledResult : options.skip || watchQueryOptions.fetchPolicy === "standby" ? // When skipping a query (ie. we're not querying for data but still want to
    // render children), make sure the `data` is cleared out and `loading` is
    // set to `false` (since we aren't loading anything).
    //
    // NOTE: We no longer think this is the correct behavior. Skipping should
    // not automatically set `data` to `undefined`, but instead leave the
    // previous data in place. In other words, skipping should not mandate that
    // previously received data is all of a sudden removed. Unfortunately,
    // changing this is breaking, so we'll have to wait until Apollo Client 4.0
    // to address this.
    $0ad8e3d9f4959055$var$skipStandbyResult : void 0;
    var previousData = resultData.previousData;
    var currentResultOverride = $69607e38bd2400f2$exports.useMemo(function() {
        return resultOverride && $0ad8e3d9f4959055$export$de3acc9431f1695e(resultOverride, previousData, observable, client);
    }, [
        client,
        observable,
        resultOverride,
        previousData
    ]);
    return (0, $4653928bf51922ba$export$306c0aa65ff9ec16)($69607e38bd2400f2$exports.useCallback(function(handleStoreChange) {
        // reference `disableNetworkFetches` here to ensure that the rules of hooks
        // keep it as a dependency of this effect, even though it's not used
        disableNetworkFetches;
        if (isSyncSSR) return function() {};
        var onNext = function() {
            var previousResult = resultData.current;
            // We use `getCurrentResult()` instead of the onNext argument because
            // the values differ slightly. Specifically, loading results will have
            // an empty object for data instead of `undefined` for some reason.
            var result = observable.getCurrentResult();
            // Make sure we're not attempting to re-render similar results
            if (previousResult && previousResult.loading === result.loading && previousResult.networkStatus === result.networkStatus && (0, $a2b6f433e732b502$export$411ce8e5a71e3069)(previousResult.data, result.data)) return;
            $0ad8e3d9f4959055$var$setResult(result, resultData, observable, client, partialRefetch, handleStoreChange, callbackRef.current);
        };
        var onError = function(error) {
            subscription.current.unsubscribe();
            subscription.current = observable.resubscribeAfterError(onNext, onError);
            if (!$0ad8e3d9f4959055$var$hasOwnProperty.call(error, "graphQLErrors")) // The error is not a GraphQL error
            throw error;
            var previousResult = resultData.current;
            if (!previousResult || previousResult && previousResult.loading || !(0, $a2b6f433e732b502$export$411ce8e5a71e3069)(error, previousResult.error)) $0ad8e3d9f4959055$var$setResult({
                data: previousResult && previousResult.data,
                error: error,
                loading: false,
                networkStatus: (0, $72c5140a632c7fa1$export$bd096ddbd246c79c).error
            }, resultData, observable, client, partialRefetch, handleStoreChange, callbackRef.current);
        };
        // TODO evaluate if we keep this in
        // React Compiler cannot handle scoped `let` access, but a mutable object
        // like this is fine.
        // was:
        // let subscription = observable.subscribe(onNext, onError);
        var subscription = {
            current: observable.subscribe(onNext, onError)
        };
        // Do the "unsubscribe" with a short delay.
        // This way, an existing subscription can be reused without an additional
        // request if "unsubscribe"  and "resubscribe" to the same ObservableQuery
        // happen in very fast succession.
        return function() {
            setTimeout(function() {
                return subscription.current.unsubscribe();
            });
        };
    }, [
        disableNetworkFetches,
        isSyncSSR,
        observable,
        resultData,
        partialRefetch,
        client
    ]), function() {
        return currentResultOverride || $0ad8e3d9f4959055$var$getCurrentResult(resultData, observable, callbackRef.current, partialRefetch, client);
    }, function() {
        return currentResultOverride || $0ad8e3d9f4959055$var$getCurrentResult(resultData, observable, callbackRef.current, partialRefetch, client);
    });
}
function $0ad8e3d9f4959055$var$useRegisterSSRObservable(observable, renderPromises, ssrAllowed) {
    if (renderPromises && ssrAllowed) {
        renderPromises.registerSSRObservable(observable);
        if (observable.getCurrentResult().loading) // TODO: This is a legacy API which could probably be cleaned up
        renderPromises.addObservableQueryPromise(observable);
    }
}
// this hook is not compatible with any rules of React, and there's no good way to rewrite it.
// it should stay a separate hook that will not be optimized by the compiler
function $0ad8e3d9f4959055$var$useResubscribeIfNecessary(/** this hook will mutate properties on `resultData` */ resultData, /** this hook will mutate properties on `observable` */ observable, client, options, watchQueryOptions) {
    var _a;
    if (observable[$0ad8e3d9f4959055$export$163a98bed2d8d099] && !(0, $a2b6f433e732b502$export$411ce8e5a71e3069)(observable[$0ad8e3d9f4959055$export$163a98bed2d8d099], watchQueryOptions)) {
        // Though it might be tempting to postpone this reobserve call to the
        // useEffect block, we need getCurrentResult to return an appropriate
        // loading:true result synchronously (later within the same call to
        // useQuery). Since we already have this.observable here (not true for
        // the very first call to useQuery), we are not initiating any new
        // subscriptions, though it does feel less than ideal that reobserve
        // (potentially) kicks off a network request (for example, when the
        // variables have changed), which is technically a side-effect.
        observable.reobserve($0ad8e3d9f4959055$export$2167b7db3cd527f2(observable, client, options, watchQueryOptions));
        // Make sure getCurrentResult returns a fresh ApolloQueryResult<TData>,
        // but save the current data as this.previousData, just like setResult
        // usually does.
        resultData.previousData = ((_a = resultData.current) === null || _a === void 0 ? void 0 : _a.data) || resultData.previousData;
        resultData.current = void 0;
    }
    observable[$0ad8e3d9f4959055$export$163a98bed2d8d099] = watchQueryOptions;
}
function $0ad8e3d9f4959055$export$63539d93836ebf9c(client, query, _a, isSyncSSR) {
    if (_a === void 0) _a = {};
    var skip = _a.skip, ssr = _a.ssr, onCompleted = _a.onCompleted, onError = _a.onError, defaultOptions = _a.defaultOptions, // The above options are useQuery-specific, so this ...otherOptions spread
    // makes otherOptions almost a WatchQueryOptions object, except for the
    // query property that we add below.
    otherOptions = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(_a, [
        "skip",
        "ssr",
        "onCompleted",
        "onError",
        "defaultOptions"
    ]);
    return function(observable) {
        // This Object.assign is safe because otherOptions is a fresh ...rest object
        // that did not exist until just now, so modifications are still allowed.
        var watchQueryOptions = Object.assign(otherOptions, {
            query: query
        });
        if (isSyncSSR && (watchQueryOptions.fetchPolicy === "network-only" || watchQueryOptions.fetchPolicy === "cache-and-network")) // this behavior was added to react-apollo without explanation in this PR
        // https://github.com/apollographql/react-apollo/pull/1579
        watchQueryOptions.fetchPolicy = "cache-first";
        if (!watchQueryOptions.variables) watchQueryOptions.variables = {};
        if (skip) {
            // When skipping, we set watchQueryOptions.fetchPolicy initially to
            // "standby", but we also need/want to preserve the initial non-standby
            // fetchPolicy that would have been used if not skipping.
            watchQueryOptions.initialFetchPolicy = watchQueryOptions.initialFetchPolicy || watchQueryOptions.fetchPolicy || $0ad8e3d9f4959055$export$e700754533d2c94f(defaultOptions, client.defaultOptions);
            watchQueryOptions.fetchPolicy = "standby";
        } else if (!watchQueryOptions.fetchPolicy) watchQueryOptions.fetchPolicy = (observable === null || observable === void 0 ? void 0 : observable.options.initialFetchPolicy) || $0ad8e3d9f4959055$export$e700754533d2c94f(defaultOptions, client.defaultOptions);
        return watchQueryOptions;
    };
}
function $0ad8e3d9f4959055$export$2167b7db3cd527f2(observable, client, queryHookOptions, watchQueryOptions) {
    var toMerge = [];
    var globalDefaults = client.defaultOptions.watchQuery;
    if (globalDefaults) toMerge.push(globalDefaults);
    if (queryHookOptions.defaultOptions) toMerge.push(queryHookOptions.defaultOptions);
    // We use compact rather than mergeOptions for this part of the merge,
    // because we want watchQueryOptions.variables (if defined) to replace
    // this.observable.options.variables whole. This replacement allows
    // removing variables by removing them from the variables input to
    // useQuery. If the variables were always merged together (rather than
    // replaced), there would be no way to remove existing variables.
    // However, the variables from options.defaultOptions and globalDefaults
    // (if provided) should be merged, to ensure individual defaulted
    // variables always have values, if not otherwise defined in
    // observable.options or watchQueryOptions.
    toMerge.push((0, $2f3cebf1a05c1b38$export$8e16b83750b44988)(observable && observable.options, watchQueryOptions));
    return toMerge.reduce((0, $1a9f9b47c9ebef70$export$235b7fc70b9fc359));
}
function $0ad8e3d9f4959055$var$setResult(nextResult, resultData, observable, client, partialRefetch, forceUpdate, callbacks) {
    var previousResult = resultData.current;
    if (previousResult && previousResult.data) resultData.previousData = previousResult.data;
    if (!nextResult.error && (0, $e6aaa0e65613edd7$export$d307f5934e447d0e)(nextResult.errors)) // Until a set naming convention for networkError and graphQLErrors is
    // decided upon, we map errors (graphQLErrors) to the error options.
    // TODO: Is it possible for both result.error and result.errors to be
    // defined here?
    nextResult.error = new (0, $456cf4c370166a0f$export$26a337512320b8c6)({
        graphQLErrors: nextResult.errors
    });
    resultData.current = $0ad8e3d9f4959055$export$de3acc9431f1695e($0ad8e3d9f4959055$var$unsafeHandlePartialRefetch(nextResult, observable, partialRefetch), resultData.previousData, observable, client);
    // Calling state.setResult always triggers an update, though some call sites
    // perform additional equality checks before committing to an update.
    forceUpdate();
    $0ad8e3d9f4959055$var$handleErrorOrCompleted(nextResult, previousResult === null || previousResult === void 0 ? void 0 : previousResult.networkStatus, callbacks);
}
function $0ad8e3d9f4959055$var$handleErrorOrCompleted(result, previousNetworkStatus, callbacks) {
    if (!result.loading) {
        var error_1 = $0ad8e3d9f4959055$export$b2c90f1874ba96bf(result);
        // wait a tick in case we are in the middle of rendering a component
        Promise.resolve().then(function() {
            if (error_1) callbacks.onError(error_1);
            else if (result.data && previousNetworkStatus !== result.networkStatus && result.networkStatus === (0, $72c5140a632c7fa1$export$bd096ddbd246c79c).ready) callbacks.onCompleted(result.data);
        }).catch(function(error) {
            globalThis.__DEV__ !== false && (0, $28d90d877eb1e517$export$f5708dca728d7177).warn(error);
        });
    }
}
function $0ad8e3d9f4959055$var$getCurrentResult(resultData, observable, callbacks, partialRefetch, client) {
    // Using this.result as a cache ensures getCurrentResult continues returning
    // the same (===) result object, unless state.setResult has been called, or
    // we're doing server rendering and therefore override the result below.
    if (!resultData.current) // WARNING: SIDE-EFFECTS IN THE RENDER FUNCTION
    // this could call unsafeHandlePartialRefetch
    $0ad8e3d9f4959055$var$setResult(observable.getCurrentResult(), resultData, observable, client, partialRefetch, function() {}, callbacks);
    return resultData.current;
}
function $0ad8e3d9f4959055$export$e700754533d2c94f(queryHookDefaultOptions, clientDefaultOptions) {
    var _a;
    return (queryHookDefaultOptions === null || queryHookDefaultOptions === void 0 ? void 0 : queryHookDefaultOptions.fetchPolicy) || ((_a = clientDefaultOptions === null || clientDefaultOptions === void 0 ? void 0 : clientDefaultOptions.watchQuery) === null || _a === void 0 ? void 0 : _a.fetchPolicy) || "cache-first";
}
function $0ad8e3d9f4959055$export$b2c90f1874ba96bf(result) {
    return (0, $e6aaa0e65613edd7$export$d307f5934e447d0e)(result.errors) ? new (0, $456cf4c370166a0f$export$26a337512320b8c6)({
        graphQLErrors: result.errors
    }) : result.error;
}
function $0ad8e3d9f4959055$export$de3acc9431f1695e(result, previousData, observable, client) {
    var data = result.data, partial = result.partial, resultWithoutPartial = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(result, [
        "data",
        "partial"
    ]);
    var queryResult = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
        data: data
    }, resultWithoutPartial), {
        client: client,
        observable: observable,
        variables: observable.variables,
        called: result !== $0ad8e3d9f4959055$var$ssrDisabledResult && result !== $0ad8e3d9f4959055$var$skipStandbyResult,
        previousData: previousData
    });
    return queryResult;
}
function $0ad8e3d9f4959055$var$unsafeHandlePartialRefetch(result, observable, partialRefetch) {
    // TODO: This code should be removed when the partialRefetch option is
    // removed. I was unable to get this hook to behave reasonably in certain
    // edge cases when this block was put in an effect.
    if (result.partial && partialRefetch && !result.loading && (!result.data || Object.keys(result.data).length === 0) && observable.options.fetchPolicy !== "cache-only") {
        observable.refetch();
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, result), {
            loading: true,
            networkStatus: (0, $72c5140a632c7fa1$export$bd096ddbd246c79c).refetch
        });
    }
    return result;
}
var $0ad8e3d9f4959055$var$ssrDisabledResult = (0, $310a6ebe531ba02b$export$7f9c177735b71f18)({
    loading: true,
    data: void 0,
    error: void 0,
    networkStatus: (0, $72c5140a632c7fa1$export$bd096ddbd246c79c).loading
});
var $0ad8e3d9f4959055$var$skipStandbyResult = (0, $310a6ebe531ba02b$export$7f9c177735b71f18)({
    loading: false,
    data: void 0,
    error: void 0,
    networkStatus: (0, $72c5140a632c7fa1$export$bd096ddbd246c79c).ready
});
function $0ad8e3d9f4959055$var$bindObservableMethods(observable) {
    return {
        refetch: observable.refetch.bind(observable),
        reobserve: observable.reobserve.bind(observable),
        fetchMore: observable.fetchMore.bind(observable),
        updateQuery: observable.updateQuery.bind(observable),
        startPolling: observable.startPolling.bind(observable),
        stopPolling: observable.stopPolling.bind(observable),
        subscribeToMore: observable.subscribeToMore.bind(observable)
    };
}




function $e971b40c07629a0e$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $e971b40c07629a0e$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
function $e971b40c07629a0e$var$_arrayWithoutHoles(r) {
    if (Array.isArray(r)) return $e971b40c07629a0e$var$_arrayLikeToArray(r);
}
function $e971b40c07629a0e$var$_assertThisInitialized(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}
function $e971b40c07629a0e$var$_callSuper(t, o, e) {
    return o = $e971b40c07629a0e$var$_getPrototypeOf(o), $e971b40c07629a0e$var$_possibleConstructorReturn(t, $e971b40c07629a0e$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], $e971b40c07629a0e$var$_getPrototypeOf(t).constructor) : o.apply(t, e));
}
function $e971b40c07629a0e$var$_classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function $e971b40c07629a0e$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, $e971b40c07629a0e$var$_toPropertyKey(o.key), o);
    }
}
function $e971b40c07629a0e$var$_createClass(e, r, t) {
    return r && $e971b40c07629a0e$var$_defineProperties(e.prototype, r), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
function $e971b40c07629a0e$var$_getPrototypeOf(t) {
    return $e971b40c07629a0e$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $e971b40c07629a0e$var$_getPrototypeOf(t);
}
function $e971b40c07629a0e$var$_inherits(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && $e971b40c07629a0e$var$_setPrototypeOf(t, e);
}
function $e971b40c07629a0e$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($e971b40c07629a0e$var$_isNativeReflectConstruct = function() {
        return !!t;
    })();
}
function $e971b40c07629a0e$var$_iterableToArray(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function $e971b40c07629a0e$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $e971b40c07629a0e$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $e971b40c07629a0e$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $e971b40c07629a0e$var$_possibleConstructorReturn(t, e) {
    if (e && ("object" == typeof e || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return $e971b40c07629a0e$var$_assertThisInitialized(t);
}
function $e971b40c07629a0e$var$_setPrototypeOf(t, e) {
    return $e971b40c07629a0e$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $e971b40c07629a0e$var$_setPrototypeOf(t, e);
}
function $e971b40c07629a0e$var$_slicedToArray(r, e) {
    return $e971b40c07629a0e$var$_arrayWithHoles(r) || $e971b40c07629a0e$var$_iterableToArrayLimit(r, e) || $e971b40c07629a0e$var$_unsupportedIterableToArray(r, e) || $e971b40c07629a0e$var$_nonIterableRest();
}
function $e971b40c07629a0e$var$_toConsumableArray(r) {
    return $e971b40c07629a0e$var$_arrayWithoutHoles(r) || $e971b40c07629a0e$var$_iterableToArray(r) || $e971b40c07629a0e$var$_unsupportedIterableToArray(r) || $e971b40c07629a0e$var$_nonIterableSpread();
}
function $e971b40c07629a0e$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r);
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return String(t);
}
function $e971b40c07629a0e$var$_toPropertyKey(t) {
    var i = $e971b40c07629a0e$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $e971b40c07629a0e$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $e971b40c07629a0e$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $e971b40c07629a0e$var$_arrayLikeToArray(r, a) : void 0;
    }
}
var $e971b40c07629a0e$var$three = typeof window !== 'undefined' && window.THREE ? window.THREE // Prefer consumption from global THREE, if exists
 : {
    CanvasTexture: (0, $d5b33d7c30034067$export$f7189e49152d1c13),
    Sprite: (0, $d5b33d7c30034067$export$3075603db8e6204c),
    SpriteMaterial: (0, $d5b33d7c30034067$export$5ec7dd1c6994bf8e),
    SRGBColorSpace: (0, $d5b33d7c30034067$export$561f394b24edfcaa)
};
var $e971b40c07629a0e$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_three$Sprite) {
    function _default() {
        var _this;
        var text = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
        var textHeight = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;
        var color = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'rgba(255, 255, 255, 1)';
        $e971b40c07629a0e$var$_classCallCheck(this, _default);
        _this = $e971b40c07629a0e$var$_callSuper(this, _default, [
            new $e971b40c07629a0e$var$three.SpriteMaterial()
        ]);
        _this._text = "".concat(text);
        _this._textHeight = textHeight;
        _this._color = color;
        _this._backgroundColor = false; // no background color
        _this._padding = 0;
        _this._borderWidth = 0;
        _this._borderRadius = 0;
        _this._borderColor = 'white';
        _this._strokeWidth = 0;
        _this._strokeColor = 'white';
        _this._fontFace = 'system-ui';
        _this._fontSize = 90; // defines text resolution
        _this._fontWeight = 'normal';
        _this._canvas = document.createElement('canvas');
        _this._genCanvas();
        return _this;
    }
    $e971b40c07629a0e$var$_inherits(_default, _three$Sprite);
    return $e971b40c07629a0e$var$_createClass(_default, [
        {
            key: "text",
            get: function get() {
                return this._text;
            },
            set: function set(text) {
                this._text = text;
                this._genCanvas();
            }
        },
        {
            key: "textHeight",
            get: function get() {
                return this._textHeight;
            },
            set: function set(textHeight) {
                this._textHeight = textHeight;
                this._genCanvas();
            }
        },
        {
            key: "color",
            get: function get() {
                return this._color;
            },
            set: function set(color) {
                this._color = color;
                this._genCanvas();
            }
        },
        {
            key: "backgroundColor",
            get: function get() {
                return this._backgroundColor;
            },
            set: function set(color) {
                this._backgroundColor = color;
                this._genCanvas();
            }
        },
        {
            key: "padding",
            get: function get() {
                return this._padding;
            },
            set: function set(padding) {
                this._padding = padding;
                this._genCanvas();
            }
        },
        {
            key: "borderWidth",
            get: function get() {
                return this._borderWidth;
            },
            set: function set(borderWidth) {
                this._borderWidth = borderWidth;
                this._genCanvas();
            }
        },
        {
            key: "borderRadius",
            get: function get() {
                return this._borderRadius;
            },
            set: function set(borderRadius) {
                this._borderRadius = borderRadius;
                this._genCanvas();
            }
        },
        {
            key: "borderColor",
            get: function get() {
                return this._borderColor;
            },
            set: function set(borderColor) {
                this._borderColor = borderColor;
                this._genCanvas();
            }
        },
        {
            key: "fontFace",
            get: function get() {
                return this._fontFace;
            },
            set: function set(fontFace) {
                this._fontFace = fontFace;
                this._genCanvas();
            }
        },
        {
            key: "fontSize",
            get: function get() {
                return this._fontSize;
            },
            set: function set(fontSize) {
                this._fontSize = fontSize;
                this._genCanvas();
            }
        },
        {
            key: "fontWeight",
            get: function get() {
                return this._fontWeight;
            },
            set: function set(fontWeight) {
                this._fontWeight = fontWeight;
                this._genCanvas();
            }
        },
        {
            key: "strokeWidth",
            get: function get() {
                return this._strokeWidth;
            },
            set: function set(strokeWidth) {
                this._strokeWidth = strokeWidth;
                this._genCanvas();
            }
        },
        {
            key: "strokeColor",
            get: function get() {
                return this._strokeColor;
            },
            set: function set(strokeColor) {
                this._strokeColor = strokeColor;
                this._genCanvas();
            }
        },
        {
            key: "_genCanvas",
            value: function _genCanvas() {
                var _this2 = this;
                var canvas = this._canvas;
                var ctx = canvas.getContext('2d');
                var border = Array.isArray(this.borderWidth) ? this.borderWidth : [
                    this.borderWidth,
                    this.borderWidth
                ]; // x,y border
                var relBorder = border.map(function(b) {
                    return b * _this2.fontSize * 0.1;
                }); // border in canvas units
                var borderRadius = Array.isArray(this.borderRadius) ? this.borderRadius : [
                    this.borderRadius,
                    this.borderRadius,
                    this.borderRadius,
                    this.borderRadius
                ]; // tl tr br bl corners
                var relBorderRadius = borderRadius.map(function(b) {
                    return b * _this2.fontSize * 0.1;
                }); // border radius in canvas units
                var padding = Array.isArray(this.padding) ? this.padding : [
                    this.padding,
                    this.padding
                ]; // x,y padding
                var relPadding = padding.map(function(p) {
                    return p * _this2.fontSize * 0.1;
                }); // padding in canvas units
                var lines = this.text.split('\n');
                var font = "".concat(this.fontWeight, " ").concat(this.fontSize, "px ").concat(this.fontFace);
                ctx.font = font; // measure canvas with appropriate font
                var innerWidth = Math.max.apply(Math, $e971b40c07629a0e$var$_toConsumableArray(lines.map(function(line) {
                    return ctx.measureText(line).width;
                })));
                var innerHeight = this.fontSize * lines.length;
                canvas.width = innerWidth + relBorder[0] * 2 + relPadding[0] * 2;
                canvas.height = innerHeight + relBorder[1] * 2 + relPadding[1] * 2;
                // paint border
                if (this.borderWidth) {
                    ctx.strokeStyle = this.borderColor;
                    if (relBorder[0]) {
                        // left + right borders
                        var hb = relBorder[0] / 2;
                        ctx.lineWidth = relBorder[0];
                        ctx.beginPath();
                        ctx.moveTo(hb, relBorderRadius[0]);
                        ctx.lineTo(hb, canvas.height - relBorderRadius[3]);
                        ctx.moveTo(canvas.width - hb, relBorderRadius[1]);
                        ctx.lineTo(canvas.width - hb, canvas.height - relBorderRadius[2]);
                        ctx.stroke();
                    }
                    if (relBorder[1]) {
                        // top + bottom borders
                        var _hb = relBorder[1] / 2;
                        ctx.lineWidth = relBorder[1];
                        ctx.beginPath();
                        ctx.moveTo(Math.max(relBorder[0], relBorderRadius[0]), _hb);
                        ctx.lineTo(canvas.width - Math.max(relBorder[0], relBorderRadius[1]), _hb);
                        ctx.moveTo(Math.max(relBorder[0], relBorderRadius[3]), canvas.height - _hb);
                        ctx.lineTo(canvas.width - Math.max(relBorder[0], relBorderRadius[2]), canvas.height - _hb);
                        ctx.stroke();
                    }
                    if (this.borderRadius) {
                        // strike rounded corners
                        var cornerWidth = Math.max.apply(Math, $e971b40c07629a0e$var$_toConsumableArray(relBorder));
                        var _hb2 = cornerWidth / 2;
                        ctx.lineWidth = cornerWidth;
                        ctx.beginPath();
                        [
                            !!relBorderRadius[0] && [
                                relBorderRadius[0],
                                _hb2,
                                _hb2,
                                relBorderRadius[0]
                            ],
                            !!relBorderRadius[1] && [
                                canvas.width - relBorderRadius[1],
                                canvas.width - _hb2,
                                _hb2,
                                relBorderRadius[1]
                            ],
                            !!relBorderRadius[2] && [
                                canvas.width - relBorderRadius[2],
                                canvas.width - _hb2,
                                canvas.height - _hb2,
                                canvas.height - relBorderRadius[2]
                            ],
                            !!relBorderRadius[3] && [
                                relBorderRadius[3],
                                _hb2,
                                canvas.height - _hb2,
                                canvas.height - relBorderRadius[3]
                            ]
                        ].filter(function(d) {
                            return d;
                        }).forEach(function(_ref) {
                            var _ref2 = $e971b40c07629a0e$var$_slicedToArray(_ref, 4), x0 = _ref2[0], x1 = _ref2[1], y0 = _ref2[2], y1 = _ref2[3];
                            ctx.moveTo(x0, y0);
                            ctx.quadraticCurveTo(x1, y0, x1, y1);
                        });
                        ctx.stroke();
                    }
                }
                // paint background
                if (this.backgroundColor) {
                    ctx.fillStyle = this.backgroundColor;
                    if (!this.borderRadius) ctx.fillRect(relBorder[0], relBorder[1], canvas.width - relBorder[0] * 2, canvas.height - relBorder[1] * 2);
                    else {
                        // fill with rounded corners
                        ctx.beginPath();
                        ctx.moveTo(relBorder[0], relBorderRadius[0]);
                        [
                            [
                                relBorder[0],
                                relBorderRadius[0],
                                canvas.width - relBorderRadius[1],
                                relBorder[1],
                                relBorder[1],
                                relBorder[1]
                            ],
                            // t
                            [
                                canvas.width - relBorder[0],
                                canvas.width - relBorder[0],
                                canvas.width - relBorder[0],
                                relBorder[1],
                                relBorderRadius[1],
                                canvas.height - relBorderRadius[2]
                            ],
                            // r
                            [
                                canvas.width - relBorder[0],
                                canvas.width - relBorderRadius[2],
                                relBorderRadius[3],
                                canvas.height - relBorder[1],
                                canvas.height - relBorder[1],
                                canvas.height - relBorder[1]
                            ],
                            // b
                            [
                                relBorder[0],
                                relBorder[0],
                                relBorder[0],
                                canvas.height - relBorder[1],
                                canvas.height - relBorderRadius[3],
                                relBorderRadius[0]
                            ] // t
                        ].forEach(function(_ref3) {
                            var _ref4 = $e971b40c07629a0e$var$_slicedToArray(_ref3, 6), x0 = _ref4[0], x1 = _ref4[1], x2 = _ref4[2], y0 = _ref4[3], y1 = _ref4[4], y2 = _ref4[5];
                            ctx.quadraticCurveTo(x0, y0, x1, y1);
                            ctx.lineTo(x2, y2);
                        });
                        ctx.closePath();
                        ctx.fill();
                    }
                }
                ctx.translate.apply(ctx, $e971b40c07629a0e$var$_toConsumableArray(relBorder));
                ctx.translate.apply(ctx, $e971b40c07629a0e$var$_toConsumableArray(relPadding));
                // paint text
                ctx.font = font; // Set font again after canvas is resized, as context properties are reset
                ctx.fillStyle = this.color;
                ctx.textBaseline = 'bottom';
                var drawTextStroke = this.strokeWidth > 0;
                if (drawTextStroke) {
                    ctx.lineWidth = this.strokeWidth * this.fontSize / 10;
                    ctx.strokeStyle = this.strokeColor;
                }
                lines.forEach(function(line, index) {
                    var lineX = (innerWidth - ctx.measureText(line).width) / 2;
                    var lineY = (index + 1) * _this2.fontSize;
                    drawTextStroke && ctx.strokeText(line, lineX, lineY);
                    ctx.fillText(line, lineX, lineY);
                });
                // Inject canvas into sprite
                if (this.material.map) this.material.map.dispose(); // gc previous texture
                var texture = this.material.map = new $e971b40c07629a0e$var$three.CanvasTexture(canvas);
                texture.colorSpace = $e971b40c07629a0e$var$three.SRGBColorSpace;
                var yScale = this.textHeight * lines.length + border[1] * 2 + padding[1] * 2;
                this.scale.set(yScale * canvas.width / canvas.height, yScale, 0);
            }
        },
        {
            key: "clone",
            value: function clone() {
                return new this.constructor(this.text, this.textHeight, this.color).copy(this);
            }
        },
        {
            key: "copy",
            value: function copy(source) {
                $e971b40c07629a0e$var$three.Sprite.prototype.copy.call(this, source);
                this.color = source.color;
                this.backgroundColor = source.backgroundColor;
                this.padding = source.padding;
                this.borderWidth = source.borderWidth;
                this.borderColor = source.borderColor;
                this.fontFace = source.fontFace;
                this.fontSize = source.fontSize;
                this.fontWeight = source.fontWeight;
                this.strokeWidth = source.strokeWidth;
                this.strokeColor = source.strokeColor;
                return this;
            }
        }
    ]);
}($e971b40c07629a0e$var$three.Sprite);


var $a4c0e40a0bc029a4$exports = {};
$a4c0e40a0bc029a4$exports = JSON.parse("{\"0x0990dead50d6a9e13a7cf44d00a6020ea725e7c8\":{\"website\":\"https://mdai.meth.house\",\"image\":\"https://dd.dexscreener.com/ds-data/tokens/pulsechain/0x0990dead50d6a9e13a7cf44d00a6020ea725e7c8.png?size=lg\",\"description\":\"Rewards Ethereum Dai - 1% tax.\"},\"0x1ce10867a7d779cc4e1b82a5a6a9d2e3768ad0c3\":{\"website\":\"https://centr.rewardr.cash\",\"image\":\"https://dd.dexscreener.com/ds-data/tokens/pulsechain/0x1ce10867a7d779cc4e1b82a5a6a9d2e3768ad0c3.png?size=lg\",\"description\":\"Rewards (eDAI/pDAI)/(eWBTC/pWBTC) LP - 1% tax.\"},\"0x26d979a0c0830e02eb3b4ca6b1d1d0b6263c188f\":{\"website\":\"https://mfrax.meth.house\",\"image\":\"mfrax.png\",\"description\":\"Rewards Ethereum Frax - 1% tax.\"},\"0x282cecf3fef68cf38ee3e3880f69572c376b9cc1\":{\"website\":\"https://usdcr.rewardr.cash\",\"image\":\"usdcr.png\",\"description\":\"Rewards PulseChain USDC - 1% tax.\"},\"0x286063c4ad66adf0643d5567dc31cc1bb514bbb7\":{\"website\":\"https://dysnomia.atropa.community\",\"image\":\"chata1a.png\",\"description\":\"Rewards A1A_Eco LAU - 3% tax.\"},\"0x299b107b8945cf3ac8ecd1f69dbb9204bf27fa20\":{\"website\":\"https://414r.rewardr.cash\",\"image\":\"414r.png\",\"description\":\"Rewards Bff/2cc/Crows/monat/Atropa/teddy/nukes/tsfi LP - 1% tax.\"},\"0x2cda6c4d9c0f27d2565d688d292d3b0568dd613b\":{\"website\":\"https://BEAr.rewardr.cash\",\"image\":\"BEAr.png\",\"description\":\"Rewards Teddy Bear - 2% tax.\"},\"0x365f3dab5b2249576a81a84e159bdd8d2b9ad8eb\":{\"website\":\"https://lusdlp.rewardr.cash\",\"image\":\"lusdlpx.png\",\"description\":\"Rewards eLUSD/pLUSD LP - 3% tax.\"},\"0x47273ee3360b936e1c9f2bc808da76e1df4b43c4\":{\"website\":\"https://dair.rewardr.cash\",\"image\":\"dair.png\",\"description\":\"Rewards PulseChain DAI - 1% tax.\"},\"0x4e6a5bf1a97912269d5af5da4861088507e16fa8\":{\"website\":\"https://lendr.rewardr.cash\",\"image\":\"lendr.png\",\"description\":\"Rewards PulseChain AAVE - 3% tax.\"},\"0x5b17a3d673c47c30a1e87e238dd31ad437158141\":{\"website\":\"https://rwdr.rewardr.cash\",\"image\":\"rwdr.png\",\"description\":\"Rewards Pulse - 1% tax.\"}}");


// Token IDs (Ecosystem tokens)
const $879a74e0f856fe0e$var$tokenIds = [
    "0x0990dead50d6a9e13a7cf44d00a6020ea725e7c8",
    "0x1ce10867a7d779cc4e1b82a5a6a9d2e3768ad0c3",
    "0x26d979a0c0830e02eb3b4ca6b1d1d0b6263c188f",
    "0x282cecf3fef68cf38ee3e3880f69572c376b9cc1",
    "0x286063c4ad66adf0643d5567dc31cc1bb514bbb7",
    "0x299b107b8945cf3ac8ecd1f69dbb9204bf27fa20",
    "0x2cda6c4d9c0f27d2565d688d292d3b0568dd613b",
    "0x365f3dab5b2249576a81a84e159bdd8d2b9ad8eb",
    "0x47273ee3360b936e1c9f2bc808da76e1df4b43c4",
    "0x4b0cc8809d9ec2ea72f3b1bccb8d0b7597320683",
    "0x4e6a5bf1a97912269d5af5da4861088507e16fa8",
    "0x5b17a3d673c47c30a1e87e238dd31ad437158141",
    "0x61496615a3cc5f3bed6dad8cf3945cb6d7765f02",
    "0x6198d4e91e66508b887980a0665d49facd3cb89c",
    "0x697fc467720b2a8e1b2f7f665d0e3f28793e65e8",
    "0x6e22dcfdf550f35b68276216bd46f51d99b77263",
    "0x6d2dc71afa00484c48bff8160dbddb7973c37a5e",
    "0x6f8cbfa5072462282f331967730edce532a73b69",
    "0x708130c48511942b1488118bbdf5ca68f0b5c6fe",
    "0x737fd5b88524d0b90b984ba4f64a6b81b1a1dbc0",
    "0x75da7f3e6811e56b6f8e0a21ea79cffaef0fc2b8",
    "0x868c653acd878dafa2a4aa70421f40c0fec614a8",
    "0x89e30dfc4a68355c1e9cd173c1632835fe4807e3",
    "0x99d6c086bf13f8dc7858629ca637fb900bb58925",
    "0xa3e20671eb098321305c925d16e0d38b443ebd55",
    "0xa9208eed6251e5ccd4d495d8c1c63f78588453d7",
    "0xaba034923f29bd8e7c09afe7f2e5b255b18bfd48",
    "0xad704adf05edb9187cdcde5d29556aadaf92e2aa",
    "0xafcaef62344c5242c20158eb7530ba4ce78de18c",
    "0xb6bad00525221eb28eb911a0b1162a0709b4ce57",
    "0xbe85caacdf811649c7d30598b2bc5674549c5bd5",
    "0xcd80146285ce56def3cf647e79cc3690df139cea",
    "0xd49688bdd162feac18026cea6c7546b4ead67089",
    "0xd5e6e4e24cb3cee9277c7a957d39bfe83c8ffaa2",
    "0xf49c5dd8f51f36f609e4c87e20bcc7aadc51aefb",
    "0xf4a0c336256155726d5aad620a241bd0edb2d681",
    "0xf924da4b2ddf0e8474c65ee046fbd07abc6c8e48",
    "0xfa9ff85e0df45752df23d65d3b91e2b788c197bf",
    "0xa1aed13d95c1eaf0c69a77bb339b07f382fcd7dd",
    "0xc3ea115f6af00e5f5e64044cc0f19b1a97335da8",
    "0xd5968f289ffb6eafec7c9108846e4b03a166ae80",
    "0xf36a961c05bcc239e2ebcdce94c975b4e354d94a",
    "0xf3f7301adee9d32486e86b6992d04e0e8ba7d139",
    "0x7164033ec242d3d868fe3b2f7b00a85c229b28c8",
    "0x9247376301e55e887319bca1cb096a8249b32270"
];
// Blacklist (addresses to always exclude)
const $879a74e0f856fe0e$var$blackList = [
    // Add blacklisted addresses here
    "0xbbea78397d4d4590882efcc4820f03074ab2ab29",
    "0x382973e90c96b0723d13dab79286be6032a204b3"
];
// Whitelist
const $879a74e0f856fe0e$var$whiteList = [];
// Greenlist
const $879a74e0f856fe0e$var$greenList = [];
// Goldlist
const $879a74e0f856fe0e$var$goldList = [];
const $879a74e0f856fe0e$var$PAGE_SIZE = 1000; // Adjust as needed
const $879a74e0f856fe0e$var$QUERY = (0, $4f5dcc0184f23a66$export$72e4926bf8358653)`
  query GetPairs($where: Pair_filter, $first: Int, $skip: Int) {
    pairs(
      orderBy: reserveUSD
      where: $where
      orderDirection: desc
      first: $first
      skip: $skip
      subgraphError: allow
    ) {
      id
      reserveUSD
      token0 {
        id
        name
      }
      token1 {
        id
        name
      }
    }
  }
`;
function $879a74e0f856fe0e$var$buildGraph(pairsData) {
    const nodesMap = {};
    const links = [];
    pairsData.forEach((pair)=>{
        const token0 = pair.token0;
        const token1 = pair.token1;
        if (!nodesMap[token0.id]) nodesMap[token0.id] = {
            id: token0.id,
            name: token0.name
        };
        if (!nodesMap[token1.id]) nodesMap[token1.id] = {
            id: token1.id,
            name: token1.name
        };
        links.push({
            source: token0.id,
            target: token1.id,
            value: parseFloat(pair.reserveUSD),
            id: pair.id,
            token0: pair.token0,
            token1: pair.token1,
            reserveUSD: parseFloat(pair.reserveUSD)
        });
    });
    return {
        nodes: Object.values(nodesMap),
        links: links
    };
}
function $879a74e0f856fe0e$var$Graph() {
    const [graphData, setGraphData] = (0, $acw62.useState)({
        nodes: [],
        links: []
    });
    const [linkHover, setLinkHover] = (0, $acw62.useState)(null);
    const [selectedNode, setSelectedNode] = (0, $acw62.useState)(null);
    const fgRef = (0, $acw62.useRef)();
    const [skip, setSkip] = (0, $acw62.useState)(0);
    const [hasMore, setHasMore] = (0, $acw62.useState)(true);
    // State variables for toggles
    const [showNonEcosystemNodes, setShowNonEcosystemNodes] = (0, $acw62.useState)(false);
    const [showWhiteList, setShowWhiteList] = (0, $acw62.useState)(true);
    const [showGreenList, setShowGreenList] = (0, $acw62.useState)(true);
    const [showGoldList, setShowGoldList] = (0, $acw62.useState)(true);
    const where = {
        or: [
            {
                token0_in: $879a74e0f856fe0e$var$tokenIds
            },
            {
                token1_in: $879a74e0f856fe0e$var$tokenIds
            }
        ]
    };
    const { loading: loading, error: error, data: data1, fetchMore: fetchMore } = (0, $0ad8e3d9f4959055$export$dd0a697e1782aedd)($879a74e0f856fe0e$var$QUERY, {
        variables: {
            where: where,
            first: $879a74e0f856fe0e$var$PAGE_SIZE,
            skip: 0
        },
        notifyOnNetworkStatusChange: true
    });
    // Load initial data and handle pagination
    (0, $acw62.useEffect)(()=>{
        if (data1 && data1.pairs.length > 0) {
            const newGraph = $879a74e0f856fe0e$var$buildGraph(data1.pairs);
            setGraphData((prevGraphData)=>{
                const combinedNodesMap = {
                    ...prevGraphData.nodes.reduce((acc, node)=>({
                            ...acc,
                            [node.id]: node
                        }), {})
                };
                newGraph.nodes.forEach((node)=>{
                    combinedNodesMap[node.id] = node;
                });
                const combinedLinksMap = {
                    ...prevGraphData.links.reduce((acc, link)=>({
                            ...acc,
                            [link.id]: link
                        }), {})
                };
                newGraph.links.forEach((link)=>{
                    combinedLinksMap[link.id] = link;
                });
                return {
                    nodes: Object.values(combinedNodesMap),
                    links: Object.values(combinedLinksMap)
                };
            });
            // Prepare for next fetch
            if (data1.pairs.length < $879a74e0f856fe0e$var$PAGE_SIZE) setHasMore(false);
            else setSkip((prevSkip)=>prevSkip + $879a74e0f856fe0e$var$PAGE_SIZE);
        } else setHasMore(false);
    }, [
        data1
    ]);
    // Fetch more data when available
    (0, $acw62.useEffect)(()=>{
        if (hasMore && !loading) fetchMore({
            variables: {
                skip: skip
            },
            updateQuery: (prevResult, { fetchMoreResult: fetchMoreResult })=>{
                if (!fetchMoreResult || fetchMoreResult.pairs.length === 0) {
                    setHasMore(false);
                    return prevResult;
                }
                return {
                    pairs: [
                        ...prevResult.pairs,
                        ...fetchMoreResult.pairs
                    ]
                };
            }
        });
    }, [
        hasMore,
        loading,
        skip
    ]);
    // Adjust force strength based on reserveUSD
    (0, $acw62.useEffect)(()=>{
        if (fgRef.current) {
            fgRef.current.cameraPosition({
                x: 0,
                y: 0,
                z: 5000
            }, {
                x: 0,
                y: 0,
                z: 0
            }, 0 // No animation
            );
            // Set link strength dynamically based on reserveUSD
            fgRef.current.d3Force('link').strength((link)=>Math.log(link.reserveUSD + 1) / 10).distance((link)=>Math.log(link.reserveUSD + 1) * 300);
            // Increase node repulsion for more spread
            fgRef.current.d3Force('charge').strength(-750);
            // Reheat simulation
            fgRef.current.d3ReheatSimulation();
        }
    }, [
        graphData
    ]);
    const filteredGraphData = (0, $acw62.useMemo)(()=>{
        // Convert lists to lowercase for case-insensitive comparison
        const blackListSet = new Set($879a74e0f856fe0e$var$blackList.map((id)=>id.toLowerCase()));
        const whiteListSet = new Set($879a74e0f856fe0e$var$whiteList.map((id)=>id.toLowerCase()));
        const greenListSet = new Set($879a74e0f856fe0e$var$greenList.map((id)=>id.toLowerCase()));
        const goldListSet = new Set($879a74e0f856fe0e$var$goldList.map((id)=>id.toLowerCase()));
        const tokenIdsSet = new Set($879a74e0f856fe0e$var$tokenIds.map((id)=>id.toLowerCase()));
        const filteredNodes = graphData.nodes.filter((node)=>{
            const nodeId = node.id.toLowerCase();
            // Exclude blacklisted nodes
            if (blackListSet.has(nodeId)) return false;
            // Always include ecosystem nodes
            if (tokenIdsSet.has(nodeId)) return true;
            // Include based on lists and toggles
            if (whiteListSet.has(nodeId) && showWhiteList) return true;
            if (greenListSet.has(nodeId) && showGreenList) return true;
            if (goldListSet.has(nodeId) && showGoldList) return true;
            // Include non-ecosystem nodes if toggle is on
            if (showNonEcosystemNodes) return true;
            // Exclude by default
            return false;
        });
        // Create a set of node IDs for easy lookup
        const nodeIdsSet = new Set(filteredNodes.map((node)=>node.id.toLowerCase()));
        // Filter links where both source and target nodes are included
        const filteredLinks = graphData.links.filter((link)=>{
            const sourceId = typeof link.source === 'object' ? link.source.id.toLowerCase() : link.source.toLowerCase();
            const targetId = typeof link.target === 'object' ? link.target.id.toLowerCase() : link.target.toLowerCase();
            return nodeIdsSet.has(sourceId) && nodeIdsSet.has(targetId);
        });
        return {
            nodes: filteredNodes,
            links: filteredLinks
        };
    }, [
        graphData,
        showNonEcosystemNodes,
        showWhiteList,
        showGreenList,
        showGoldList
    ]);
    if (loading && graphData.nodes.length === 0) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
        children: "Loading..."
    });
    if (error) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
        children: [
            "Error: ",
            error.message
        ]
    });
    // Function to create a neon glow material
    function createNeonMaterial(color) {
        return new $d5b33d7c30034067$export$5023a9a8114806b8({
            color: color,
            emissive: color,
            emissiveIntensity: 1.5,
            transparent: false,
            opacity: 0.9
        });
    }
    // Handle node click
    const handleNodeClick = (node)=>{
        setSelectedNode(selectedNode && selectedNode.id === node.id ? null : node);
    };
    // Adjust link width and color
    const getLinkWidth = (link)=>{
        if (selectedNode && (link.source.id === selectedNode.id || link.target.id === selectedNode.id)) return Math.log(link.reserveUSD + 1) * 2.5;
        return 3.7;
    };
    // Handle link hover
    const handleLinkHover = (link)=>{
        if (selectedNode && link && (link.source.id === selectedNode.id || link.target.id === selectedNode.id)) setLinkHover(link);
        else setLinkHover(null);
    };
    // Handle link click
    const handleLinkClick = (link, event)=>{
        if (selectedNode && link && (link.source.id === selectedNode.id || link.target.id === selectedNode.id)) // Open submenu or perform desired action
        $879a74e0f856fe0e$var$openSubmenu(link, event.clientX, event.clientY);
    };
    // Handle background click to clear selection
    const handleBackgroundClick = ()=>{
        setSelectedNode(null);
        setLinkHover(null);
    };
    const getLinkColor = (link)=>{
        if (selectedNode && (link.source.id === selectedNode.id || link.target.id === selectedNode.id)) return 'cyan';
        return 'magenta'; // Use magenta instead of green
    };
    // Node object with neon material
    const nodeThreeObject = (node)=>{
        const radius = 60;
        const nodeId = node.id.toLowerCase();
        let nodeColor;
        if (selectedNode && nodeId === selectedNode.id.toLowerCase()) nodeColor = 'cyan'; // Highlighted node
        else if ($879a74e0f856fe0e$var$tokenIds.includes(nodeId)) nodeColor = 'purple'; // Ecosystem nodes
        else if ($879a74e0f856fe0e$var$whiteList.includes(nodeId)) nodeColor = 'yellow';
        else if ($879a74e0f856fe0e$var$goldList.includes(nodeId)) nodeColor = 'orange';
        else nodeColor = 'grey'; // Default color for other nodes
        // Create neon material
        const material = createNeonMaterial(nodeColor);
        const geometry = new $d5b33d7c30034067$export$1b417fc3b307a251(radius, 32, 32);
        const sphere = new $d5b33d7c30034067$export$e176487c05830cc5(geometry, material);
        // Add neon text label
        const sprite = new (0, $e971b40c07629a0e$export$2e2bcd8739ae039)(node.name, radius * 0.5, 'white');
        sprite.color = 'white';
        sprite.textHeight = radius * 1.5;
        sprite.material.depthTest = false;
        sprite.renderOrder = 1;
        sprite.position.set(0, radius + 5, 0);
        sphere.add(sprite);
        return sphere;
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fb74db41c312cc9d$export$2e2bcd8739ae039), {
                ref: fgRef,
                graphData: filteredGraphData,
                backgroundColor: "#000000",
                linkWidth: getLinkWidth,
                linkColor: getLinkColor,
                onLinkHover: handleLinkHover,
                onLinkClick: handleLinkClick,
                onNodeClick: handleNodeClick,
                nodeThreeObject: nodeThreeObject,
                enableNodeDrag: false,
                enableLinkDrag: false,
                enableNavigationControls: true,
                rendererConfig: {
                    antialias: true,
                    alpha: true
                }
            }),
            selectedNode && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($879a74e0f856fe0e$var$TokenStatsSubmenu, {
                node: selectedNode
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($879a74e0f856fe0e$var$FilterToggles, {
                showNonEcosystemNodes: showNonEcosystemNodes,
                setShowNonEcosystemNodes: setShowNonEcosystemNodes,
                showWhiteList: showWhiteList,
                setShowWhiteList: setShowWhiteList,
                showGreenList: showGreenList,
                setShowGreenList: setShowGreenList,
                showGoldList: showGoldList,
                setShowGoldList: setShowGoldList
            })
        ]
    });
}
// TokenStatsSubmenu component
function $879a74e0f856fe0e$var$TokenStatsSubmenu({ node: node }) {
    if (!node) return null;
    const submenuStyle = {
        position: 'absolute',
        bottom: '3px',
        right: '3px',
        width: '300px',
        background: 'black',
        border: '1px solid #ccc',
        borderRadius: '10px',
        padding: '3px',
        zIndex: 5000,
        fontFamily: '"Undertale", sans-serif',
        color: 'white'
    };
    const titleStyle = {
        color: 'white',
        fontWeight: 'bold',
        fontSize: '24px',
        marginBottom: '2px'
    };
    const addressContainerStyle = {
        display: 'flex',
        alignItems: 'center',
        marginTop: '2px'
    };
    const imageStyle = {
        width: '100px',
        height: '100px'
    };
    const addressStyle = {
        color: 'white',
        marginLeft: '5px',
        flexGrow: 1,
        wordBreak: 'break-all'
    };
    const websiteStyle = {
        marginBottom: '10px',
        display: 'flex'
    };
    const websiteLinkStyle = {
        fontWeight: 'bold',
        marginRight: '15px',
        textDecoration: 'none',
        color: 'white'
    };
    const descriptionStyle = {
        color: 'white',
        marginRight: '15px'
    };
    const buttonStyle = {
        width: '18%',
        padding: '3px',
        fontFamily: '"Undertale", sans-serif'
    };
    const buttonContainerStyle = {
        display: 'flex',
        justifyContent: 'space-between'
    };
    const copyButtonStyle = {
        marginTop: '1px',
        fontFamily: '"Undertale", sans-serif'
    };
    const tokenAddress = node.id;
    const tokenName = node.name;
    const tokenSymbol = data.symbol || "\uD83D\uDC40";
    const tokenWebsite = 'https://t.me/sunnyspubv2'; // Add website if available
    const tokenDescription = "Suck up all tha liquitties! \uD83D\uDC9C";
    // URLs
    const pulsexTradeUrl = `https://pulsex.mypinata.cloud/ipfs/bafy.../#/?outputCurrency=${tokenAddress}`;
    const pulsexStatsUrl = `https://pulsex.mypinata.cloud/ipfs/bafy.../#/info/v2/token/${tokenAddress}`;
    const addLiquidityUrl = `https://pulsex.mypinata.cloud/ipfs/bafy.../#/add/v2/pls/${tokenAddress}`;
    const chartUrl = `https://dexscreener.com/pulsechain/${tokenAddress}?embed=1&theme=dark&trades=0`;
    const scannerUrl = `https://scan.mypinata.cloud/ipfs/bafy.../#/address/${tokenAddress}`;
    const copyToClipboard = ()=>{
        navigator.clipboard.writeText(tokenAddress);
        alert("Token address copied to clipboard! \uD83D\uDC9C");
    };
    const openIframe = (url, title)=>{
        $879a74e0f856fe0e$var$openIframeWindow(url, title);
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        style: submenuStyle,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: titleStyle,
                children: [
                    node.name,
                    " ",
                    tokenSymbol && `(${tokenSymbol})`
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: addressContainerStyle,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                        src: `images/${tokenAddress}.webp`,
                        alt: tokenName,
                        style: imageStyle
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: addressStyle,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                children: tokenAddress
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                onClick: copyToClipboard,
                                style: copyButtonStyle,
                                children: "Copy"
                            })
                        ]
                    })
                ]
            }),
            tokenWebsite && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: websiteStyle,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                    href: tokenWebsite,
                    target: "_blank",
                    rel: "noopener noreferrer",
                    className: "rgb-link",
                    style: websiteLinkStyle,
                    children: tokenWebsite
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: descriptionStyle,
                children: tokenDescription
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: buttonContainerStyle,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        onClick: ()=>openIframe(pulsexTradeUrl, 'Trade'),
                        style: buttonStyle,
                        children: "Trade"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        onClick: ()=>openIframe(addLiquidityUrl, 'Add Liquidity'),
                        style: buttonStyle,
                        children: "Add Liq"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        onClick: ()=>openIframe(pulsexStatsUrl, 'PulseX Stats'),
                        style: buttonStyle,
                        children: "Stats"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        onClick: ()=>openIframe(chartUrl, 'Chart'),
                        style: buttonStyle,
                        children: "Chart"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        onClick: ()=>openIframe(scannerUrl, 'Scanner'),
                        style: buttonStyle,
                        children: "Scanner"
                    })
                ]
            })
        ]
    });
}
function $879a74e0f856fe0e$var$FilterToggles({ showNonEcosystemNodes: showNonEcosystemNodes, setShowNonEcosystemNodes: setShowNonEcosystemNodes, showWhiteList: showWhiteList, setShowWhiteList: setShowWhiteList, showGreenList: showGreenList, setShowGreenList: setShowGreenList, showGoldList: showGoldList, setShowGoldList: setShowGoldList }) {
    const toggleContainerStyle = {
        position: 'absolute',
        bottom: '10px',
        left: '10px',
        background: 'rgba(0, 0, 0, 0.8)',
        padding: '10px',
        borderRadius: '5px',
        color: 'white',
        zIndex: 1000
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        style: toggleContainerStyle,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                            type: "checkbox",
                            checked: showNonEcosystemNodes,
                            onChange: (e)=>setShowNonEcosystemNodes(e.target.checked)
                        }),
                        "Show Non-Ecosystem Tokens"
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                            type: "checkbox",
                            checked: showWhiteList,
                            onChange: (e)=>setShowWhiteList(e.target.checked)
                        }),
                        "Toggle PRC20s"
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                            type: "checkbox",
                            checked: showGreenList,
                            onChange: (e)=>setShowGreenList(e.target.checked)
                        }),
                        "Display ??? PROFIT"
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                            type: "checkbox",
                            checked: showGoldList,
                            onChange: (e)=>setShowGoldList(e.target.checked)
                        }),
                        "Do not touch under any circumstances"
                    ]
                })
            })
        ]
    });
}
// TokenStatsSubmenu component 
function $879a74e0f856fe0e$var$TokenStatsSubmenu({ node: node }) {
    if (!node) return null;
    const submenuStyle = {
        position: 'absolute',
        bottom: '3px',
        right: '3px',
        width: '300px',
        background: 'black',
        border: '1px solid #ccc',
        borderRadius: '10px',
        padding: '3px',
        zIndex: 5000,
        fontFamily: '"Undertale", sans-serif'
    };
    const titleStyle = {
        color: 'white',
        fontWeight: 'bold',
        fontSize: '24px',
        marginBottom: '2px'
    };
    const addressContainerStyle = {
        display: 'flex',
        alignItems: 'center',
        marginTop: '2px'
    };
    const imageStyle = {
        width: '100px',
        height: '100px'
    };
    const addressStyle = {
        color: 'white',
        marginLeft: '5px',
        flexGrow: 1,
        wordBreak: 'break-all'
    };
    const websiteStyle = {
        marginBottom: '10px',
        display: 'flex'
    };
    const websiteLinkStyle = {
        fontWeight: 'bold',
        marginRight: '15px',
        textDecoration: 'none'
    };
    const descriptionStyle = {
        color: 'white',
        marginRight: '15px'
    };
    const buttonStyle = {
        width: '18%',
        padding: '3px',
        fontFamily: '"Undertale", sans-serif'
    };
    const buttonContainerStyle = {
        display: 'flex',
        justifyContent: 'space-between'
    };
    const copyButtonStyle = {
        marginTop: '1px',
        fontFamily: '"Undertale", sans-serif'
    };
    const tokenAddress = node.id.toLowerCase();
    // Get the token data from the JSON file
    const data1 = (0, (/*@__PURE__*/$parcel$interopDefault($a4c0e40a0bc029a4$exports)))[tokenAddress] || {};
    const tokenWebsite = data1.website || 'https://t.me/sunnyspubv2';
    const tokenImage = data1.image || `images/${tokenAddress}.webp`;
    const tokenDescription = data1.description || "Token description here! \uD83D\uDC9C";
    const tokenName = node.name;
    const tokenSymbol = ''; // Add symbol if available
    // URLs
    const pulsexTradeUrl = `https://pulsex.mypinata.cloud/ipfs/bafybeift2yakeymqmjmonkzlx2zyc4tty7clkwvg37suffn5bncjx4e6xq/#/?outputCurrency=${tokenAddress}`;
    const pulsexStatsUrl = `https://pulsex.mypinata.cloud/ipfs/bafybeift2yakeymqmjmonkzlx2zyc4tty7clkwvg37suffn5bncjx4e6xq/#/info/v2/token/${tokenAddress}`;
    const addLiquidityUrl = `https://pulsex.mypinata.cloud/ipfs/bafybeift2yakeymqmjmonkzlx2zyc4tty7clkwvg37suffn5bncjx4e6xq/#/add/v2/pls/${tokenAddress}`;
    const chartUrl = `https://dexscreener.com/pulsechain/${tokenAddress}?embed=1&theme=dark&trades=0`;
    const scannerUrl = `https://scan.mypinata.cloud/ipfs/bafybeih3olry3is4e4lzm7rus5l3h6zrphcal5a7ayfkhzm5oivjro2cp4/#/address/${tokenAddress}`;
    const copyToClipboard = ()=>{
        navigator.clipboard.writeText(tokenAddress);
        alert("Token address copied to clipboard! \uD83D\uDC9C");
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        style: submenuStyle,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: titleStyle,
                children: [
                    tokenName,
                    " ",
                    tokenSymbol
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: addressContainerStyle,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                        src: `images/${tokenAddress}.webp`,
                        alt: tokenName,
                        style: imageStyle
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: addressStyle,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                children: tokenAddress
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                onClick: copyToClipboard,
                                style: copyButtonStyle,
                                children: "Copy"
                            })
                        ]
                    })
                ]
            }),
            tokenWebsite && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: websiteStyle,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                    href: tokenWebsite,
                    target: "_blank",
                    rel: "noopener noreferrer",
                    className: "rgb-link",
                    style: websiteLinkStyle,
                    children: tokenWebsite
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: descriptionStyle,
                children: tokenDescription
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: buttonContainerStyle,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        onClick: ()=>$879a74e0f856fe0e$var$openIframeWindow(pulsexTradeUrl, `\u{2B91} APEING LIFE SAVINGS INTO ${tokenName}! tru degen xD lmao`),
                        style: buttonStyle,
                        children: "Trade"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        onClick: ()=>$879a74e0f856fe0e$var$openIframeWindow(addLiquidityUrl, `\u{2B91} Add liquititties 2 ${tokenName}`),
                        style: buttonStyle,
                        children: "Add Liq"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        onClick: ()=>$879a74e0f856fe0e$var$openIframeWindow(pulsexStatsUrl, `\u{2B91} PulseX Statz 4 ${tokenName}`),
                        style: buttonStyle,
                        children: "Stats"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        onClick: ()=>$879a74e0f856fe0e$var$openIframeWindow(chartUrl, `\u{2B91} Tha UP ONLY chart of ${tokenName}`),
                        style: buttonStyle,
                        children: "Chart"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        onClick: ()=>$879a74e0f856fe0e$var$openIframeWindow(scannerUrl, `\u{2B91} ${tokenName}?!?! THATS A SCAN!!!!!`),
                        style: buttonStyle,
                        children: "Scanner"
                    })
                ]
            })
        ]
    });
}
// Implement openSubmenu and openIframeWindow functions
function $879a74e0f856fe0e$var$openSubmenu(link, x, y) {
    const existingMenu = document.getElementById('submenu');
    if (existingMenu) existingMenu.parentNode.removeChild(existingMenu);
    const menu = document.createElement('div');
    menu.id = 'submenu';
    menu.className = 'submenu';
    menu.style.position = 'absolute';
    menu.style.left = `${x}px`;
    menu.style.top = `${y}px`;
    menu.style.background = 'white';
    menu.style.padding = '10px';
    menu.style.border = '1px solid #ccc';
    menu.style.borderRadius = '5px';
    menu.style.zIndex = '1000';
    const title = document.createElement('div');
    title.textContent = `\u{2B91}${link.token0.name} / ${link.token1.name} \u{214A}\u{214C}`;
    title.style.fontWeight = 'bold';
    title.style.marginBottom = '8px';
    title.style.color = 'black';
    menu.appendChild(title);
    const options = [
        {
            name: 'Pulsex Pool Info',
            url: `https://pulsex.mypinata.cloud/ipfs/bafybeift2yakeymqmjmonkzlx2zyc4tty7clkwvg37suffn5bncjx4e6xq/#/info/v2/pool/${link.id}`
        },
        {
            name: 'Pulsex Trading Pair',
            url: `https://pulsex.mypinata.cloud/ipfs/bafybeift2yakeymqmjmonkzlx2zyc4tty7clkwvg37suffn5bncjx4e6xq/#/?inputCurrency=${link.token0.id}&outputCurrency=${link.token1.id}`
        },
        {
            name: 'Pulsex Add LP',
            url: `https://pulsex.mypinata.cloud/ipfs/bafybeift2yakeymqmjmonkzlx2zyc4tty7clkwvg37suffn5bncjx4e6xq/#/add/v2/${link.token0.id}/${link.token1.id}`
        },
        {
            name: 'Dexscreener Pair Chart',
            url: `https://dexscreener.com/pulsechain/${link.id}?embed=1&theme=dark&trades=0`
        },
        {
            name: 'Scanner LP Page',
            url: `https://scan.mypinata.cloud/ipfs/bafybeih3olry3is4e4lzm7rus5l3h6zrphcal5a7ayfkhzm5oivjro2cp4/#/address/${link.id}`
        }
    ];
    options.forEach((opt)=>{
        const btn = document.createElement('button');
        btn.textContent = opt.name;
        btn.style.display = 'block';
        btn.style.width = '100%';
        btn.style.margin = '5px 0';
        btn.onclick = ()=>{
            $879a74e0f856fe0e$var$openIframeWindow(opt.url, `${link.token0.name} / ${link.token1.name}`);
            closeSubmenu();
        };
        menu.appendChild(btn);
    });
    document.body.appendChild(menu);
    // Close submenu if clicking outside
    const closeOnOutsideClick = (event)=>{
        if (!menu.contains(event.target)) closeSubmenu();
    };
    const closeSubmenu = ()=>{
        document.body.removeChild(menu);
        document.removeEventListener('mousedown', closeOnOutsideClick);
    };
    document.addEventListener('mousedown', closeOnOutsideClick);
}
function $879a74e0f856fe0e$var$openIframeWindow(url, title) {
    const iframeWrapper = document.createElement('div');
    iframeWrapper.className = 'iframe-wrapper';
    iframeWrapper.style.position = 'absolute';
    iframeWrapper.style.width = '600px';
    iframeWrapper.style.height = '400px';
    iframeWrapper.style.left = '100px';
    iframeWrapper.style.top = '100px';
    iframeWrapper.style.border = '2px solid #ccc';
    iframeWrapper.style.zIndex = '1000';
    iframeWrapper.style.background = 'white';
    iframeWrapper.style.resize = 'both'; // Enables resizing
    iframeWrapper.style.overflow = 'hidden';
    let isMinimized = false;
    const header = document.createElement('div');
    header.style.display = 'flex';
    header.style.justifyContent = 'space-between';
    header.style.alignItems = 'center';
    header.style.padding = '5px';
    header.style.background = '#f0f0f0';
    header.style.borderBottom = '1px solid #ccc';
    header.style.cursor = 'move'; // For dragging the iframe
    const titleEl = document.createElement('span');
    titleEl.textContent = `\u{2B91} ${title}`;
    header.appendChild(titleEl);
    const controls = document.createElement('div');
    const minimizeBtn = document.createElement('button');
    minimizeBtn.textContent = "\u2581";
    minimizeBtn.onclick = ()=>{
        if (isMinimized) {
            iframeWrapper.style.height = iframeWrapper.dataset.originalHeight || '400px';
            iframeWrapper.style.width = iframeWrapper.dataset.originalWidth || '600px';
            iframeWrapper.style.overflow = 'hidden';
            isMinimized = false;
        } else {
            iframeWrapper.dataset.originalHeight = iframeWrapper.style.height;
            iframeWrapper.dataset.originalWidth = iframeWrapper.style.width;
            iframeWrapper.style.height = '30px'; // Only the header remains visible
            iframeWrapper.style.overflow = 'hidden';
            isMinimized = true;
        }
    };
    const maximizeBtn = document.createElement('button');
    maximizeBtn.textContent = "\u29C9";
    maximizeBtn.onclick = ()=>{
        if (iframeWrapper.style.width === '100%') {
            iframeWrapper.style.width = iframeWrapper.dataset.originalWidth || '600px';
            iframeWrapper.style.height = iframeWrapper.dataset.originalHeight || '400px';
            iframeWrapper.style.left = '100px';
            iframeWrapper.style.top = '100px';
        } else {
            iframeWrapper.dataset.originalWidth = iframeWrapper.style.width;
            iframeWrapper.dataset.originalHeight = iframeWrapper.style.height;
            iframeWrapper.style.width = '100%';
            iframeWrapper.style.height = '100%';
            iframeWrapper.style.left = '0';
            iframeWrapper.style.top = '0';
        }
    };
    const closeBtn = document.createElement('button');
    closeBtn.textContent = "\u2612";
    closeBtn.onclick = ()=>{
        document.body.removeChild(iframeWrapper);
    };
    controls.appendChild(minimizeBtn);
    controls.appendChild(maximizeBtn);
    controls.appendChild(closeBtn);
    header.appendChild(controls);
    const iframe = document.createElement('iframe');
    iframe.src = url;
    iframe.style.width = '100%';
    iframe.style.height = 'calc(100% - 30px)';
    iframe.style.border = 'none';
    iframeWrapper.appendChild(header);
    iframeWrapper.appendChild(iframe);
    document.body.appendChild(iframeWrapper);
    // Make the iframe draggable
    let isDragging = false;
    let startX, startY, startLeft, startTop;
    header.addEventListener('mousedown', (e)=>{
        isDragging = true;
        startX = e.clientX;
        startY = e.clientY;
        startLeft = parseInt(iframeWrapper.style.left);
        startTop = parseInt(iframeWrapper.style.top);
        e.preventDefault();
    });
    document.addEventListener('mousemove', (e)=>{
        if (isDragging) {
            const dx = e.clientX - startX;
            const dy = e.clientY - startY;
            iframeWrapper.style.left = `${startLeft + dx}px`;
            iframeWrapper.style.top = `${startTop + dy}px`;
        }
    });
    document.addEventListener('mouseup', ()=>{
        isDragging = false;
    });
}
function $879a74e0f856fe0e$var$GraphWrapper() {
    const client = new (0, $9cf0de8518e6cdc4$export$13f5a5f0f1dbab88)({
        uri: 'https://psycho.sunnys.pub/atropa/graphql-proxy.php',
        cache: new (0, $49c8996098641f51$export$467265324939f47f)()
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $93ef3346b14b7851$export$c16b04c8a9956446), {
        client: client,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($879a74e0f856fe0e$var$Graph, {})
    });
}
var $879a74e0f856fe0e$export$2e2bcd8739ae039 = $879a74e0f856fe0e$var$GraphWrapper;


const $35da740d59af89ba$var$root = (0, $7e96a608cb33bf79$export$882461b6382ed46c)(document.getElementById('root'));
$35da740d59af89ba$var$root.render(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $879a74e0f856fe0e$export$2e2bcd8739ae039), {}));


//# sourceMappingURL=index.3448de48.js.map
